/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(7);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _common = __webpack_require__(218);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(406);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(214);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(215);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Importando componentes base
	var root = _angular2.default.module('app', [_app4.default, _common2.default, _components2.default]).component('app', _app2.default).constant().name;
	
	// Bootstrap the app.
	document.addEventListener('DOMContentLoaded', function () {
	    return _angular2.default.bootstrap(document, ['app']);
	});
	
	exports.default = root;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.silentRejection = exports.silenceUncaughtInPromise = exports._extend = exports.copy = exports.tail = exports.applyPairs = exports.arrayTuples = exports.pairs = exports.assertFn = exports.assertMap = exports.assertPredicate = exports.flatten = exports.unnest = exports.uniqR = exports.pushR = exports.flattenR = exports.unnestR = exports.anyTrueR = exports.allTrueR = exports.values = exports.map = exports.mapObj = exports.find = exports.filter = exports.pluck = exports.omit = exports.pick = exports.ancestors = exports.mergeR = exports.defaults = exports.deregAll = exports._pushTo = exports.pushTo = exports._removeFrom = exports.removeFrom = exports._inArray = exports.inArray = exports.inherit = exports.createProxyFunctions = exports.noop = exports.identity = exports.equals = exports.extend = exports.forEach = exports.toJson = exports.fromJson = exports.root = void 0;
	/**
	 * Random utility functions used in the UI-Router code
	 *
	 * These functions are exported, but are subject to change without notice.
	 *
	 * @packageDocumentation
	 * @preferred
	 */
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var coreservices_1 = __webpack_require__(5);
	exports.root = (typeof self === 'object' && self.self === self && self) ||
	    (typeof global === 'object' && global.global === global && global) ||
	    this;
	var angular = exports.root.angular || {};
	exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
	exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
	exports.forEach = angular.forEach || _forEach;
	exports.extend = Object.assign || _extend;
	exports.equals = angular.equals || _equals;
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	function noop() { }
	exports.noop = noop;
	/**
	 * Builds proxy functions on the `to` object which pass through to the `from` object.
	 *
	 * For each key in `fnNames`, creates a proxy function on the `to` object.
	 * The proxy function calls the real function on the `from` object.
	 *
	 *
	 * #### Example:
	 * This example creates an new class instance whose functions are prebound to the new'd object.
	 * ```js
	 * class Foo {
	 *   constructor(data) {
	 *     // Binds all functions from Foo.prototype to 'this',
	 *     // then copies them to 'this'
	 *     bindFunctions(Foo.prototype, this, this);
	 *     this.data = data;
	 *   }
	 *
	 *   log() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * let myFoo = new Foo([1,2,3]);
	 * var logit = myFoo.log;
	 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
	 * ```
	 *
	 * #### Example:
	 * This example creates a bound version of a service function, and copies it to another object
	 * ```
	 *
	 * var SomeService = {
	 *   this.data = [3, 4, 5];
	 *   this.log = function() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * // Constructor fn
	 * function OtherThing() {
	 *   // Binds all functions from SomeService to SomeService,
	 *   // then copies them to 'this'
	 *   bindFunctions(SomeService, this, SomeService);
	 * }
	 *
	 * let myOtherThing = new OtherThing();
	 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
	 * ```
	 *
	 * @param source A function that returns the source object which contains the original functions to be bound
	 * @param target A function that returns the target object which will receive the bound functions
	 * @param bind A function that returns the object which the functions will be bound to
	 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
	 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
	 */
	function createProxyFunctions(source, target, bind, fnNames, latebind) {
	    if (latebind === void 0) { latebind = false; }
	    var bindFunction = function (fnName) { return source()[fnName].bind(bind()); };
	    var makeLateRebindFn = function (fnName) {
	        return function lateRebindFunction() {
	            target[fnName] = bindFunction(fnName);
	            return target[fnName].apply(null, arguments);
	        };
	    };
	    fnNames = fnNames || Object.keys(source());
	    return fnNames.reduce(function (acc, name) {
	        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
	        return acc;
	    }, target);
	}
	exports.createProxyFunctions = createProxyFunctions;
	/**
	 * prototypal inheritance helper.
	 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
	 */
	exports.inherit = function (parent, extra) { return exports.extend(Object.create(parent), extra); };
	/** Given an array, returns true if the object is found in the array, (using indexOf) */
	exports.inArray = hof_1.curry(_inArray);
	function _inArray(array, obj) {
	    return array.indexOf(obj) !== -1;
	}
	exports._inArray = _inArray;
	/**
	 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
	 * The same array is returned
	 */
	exports.removeFrom = hof_1.curry(_removeFrom);
	function _removeFrom(array, obj) {
	    var idx = array.indexOf(obj);
	    if (idx >= 0)
	        array.splice(idx, 1);
	    return array;
	}
	exports._removeFrom = _removeFrom;
	/** pushes a values to an array and returns the value */
	exports.pushTo = hof_1.curry(_pushTo);
	function _pushTo(arr, val) {
	    return arr.push(val), val;
	}
	exports._pushTo = _pushTo;
	/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
	exports.deregAll = function (functions) {
	    return functions.slice().forEach(function (fn) {
	        typeof fn === 'function' && fn();
	        exports.removeFrom(functions, fn);
	    });
	};
	/**
	 * Applies a set of defaults to an options object.  The options object is filtered
	 * to only those properties of the objects in the defaultsList.
	 * Earlier objects in the defaultsList take precedence when applying defaults.
	 */
	function defaults(opts) {
	    var defaultsList = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        defaultsList[_i - 1] = arguments[_i];
	    }
	    var defaultVals = exports.extend.apply(void 0, __spreadArrays([{}], defaultsList.reverse()));
	    return exports.extend(defaultVals, pick(opts || {}, Object.keys(defaultVals)));
	}
	exports.defaults = defaults;
	/** Reduce function that merges each element of the list into a single object, using extend */
	exports.mergeR = function (memo, item) { return exports.extend(memo, item); };
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	    var path = [];
	    // tslint:disable-next-line:forin
	    for (var n in first.path) {
	        if (first.path[n] !== second.path[n])
	            break;
	        path.push(first.path[n]);
	    }
	    return path;
	}
	exports.ancestors = ancestors;
	/**
	 * Return a copy of the object only containing the whitelisted properties.
	 *
	 * #### Example:
	 * ```
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = pick(foo, ['a', 'b']); // { a: 1, b: 2 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the whitelisted property names
	 */
	function pick(obj, propNames) {
	    var objCopy = {};
	    for (var _prop in obj) {
	        if (propNames.indexOf(_prop) !== -1) {
	            objCopy[_prop] = obj[_prop];
	        }
	    }
	    return objCopy;
	}
	exports.pick = pick;
	/**
	 * Return a copy of the object omitting the blacklisted properties.
	 *
	 * @example
	 * ```
	 *
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = omit(foo, ['a', 'b']); // { c: 3 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the blacklisted property names
	 */
	function omit(obj, propNames) {
	    return Object.keys(obj)
	        .filter(hof_1.not(exports.inArray(propNames)))
	        .reduce(function (acc, key) { return ((acc[key] = obj[key]), acc); }, {});
	}
	exports.omit = omit;
	/**
	 * Maps an array, or object to a property (by name)
	 */
	function pluck(collection, propName) {
	    return map(collection, hof_1.prop(propName));
	}
	exports.pluck = pluck;
	/** Filters an Array or an Object's properties based on a predicate */
	function filter(collection, callback) {
	    var arr = predicates_1.isArray(collection), result = arr ? [] : {};
	    var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return (result[key] = x); };
	    exports.forEach(collection, function (item, i) {
	        if (callback(item, i))
	            accept(item, i);
	    });
	    return result;
	}
	exports.filter = filter;
	/** Finds an object from an array, or a property of an object, that matches a predicate */
	function find(collection, callback) {
	    var result;
	    exports.forEach(collection, function (item, i) {
	        if (result)
	            return;
	        if (callback(item, i))
	            result = item;
	    });
	    return result;
	}
	exports.find = find;
	/** Given an object, returns a new object, where each property is transformed by the callback function */
	exports.mapObj = map;
	/** Maps an array or object properties using a callback function */
	function map(collection, callback, target) {
	    target = target || (predicates_1.isArray(collection) ? [] : {});
	    exports.forEach(collection, function (item, i) { return (target[i] = callback(item, i)); });
	    return target;
	}
	exports.map = map;
	/**
	 * Given an object, return its enumerable property values
	 *
	 * @example
	 * ```
	 *
	 * let foo = { a: 1, b: 2, c: 3 }
	 * let vals = values(foo); // [ 1, 2, 3 ]
	 * ```
	 */
	exports.values = function (obj) { return Object.keys(obj).map(function (key) { return obj[key]; }); };
	/**
	 * Reduce function that returns true if all of the values are truthy.
	 *
	 * @example
	 * ```
	 *
	 * let vals = [ 1, true, {}, "hello world"];
	 * vals.reduce(allTrueR, true); // true
	 *
	 * vals.push(0);
	 * vals.reduce(allTrueR, true); // false
	 * ```
	 */
	exports.allTrueR = function (memo, elem) { return memo && elem; };
	/**
	 * Reduce function that returns true if any of the values are truthy.
	 *
	 *  * @example
	 * ```
	 *
	 * let vals = [ 0, null, undefined ];
	 * vals.reduce(anyTrueR, true); // false
	 *
	 * vals.push("hello world");
	 * vals.reduce(anyTrueR, true); // true
	 * ```
	 */
	exports.anyTrueR = function (memo, elem) { return memo || elem; };
	/**
	 * Reduce function which un-nests a single level of arrays
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnestR = function (memo, elem) { return memo.concat(elem); };
	/**
	 * Reduce function which recursively un-nests all arrays
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flattenR = function (memo, elem) {
	    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
	};
	/**
	 * Reduce function that pushes an object to an array, then returns the array.
	 * Mostly just for [[flattenR]] and [[uniqR]]
	 */
	function pushR(arr, obj) {
	    arr.push(obj);
	    return arr;
	}
	exports.pushR = pushR;
	/** Reduce function that filters out duplicates */
	exports.uniqR = function (acc, token) { return (exports.inArray(acc, token) ? acc : pushR(acc, token)); };
	/**
	 * Return a new array with a single level of arrays unnested.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnest = function (arr) { return arr.reduce(exports.unnestR, []); };
	/**
	 * Return a completely flattened version of an array.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flatten = function (arr) { return arr.reduce(exports.flattenR, []); };
	/**
	 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
	 * @example
	 * ```
	 *
	 * let isNumber = (obj) => typeof(obj) === 'number';
	 * let allNumbers = [ 1, 2, 3, 4, 5 ];
	 * allNumbers.filter(assertPredicate(isNumber)); //OK
	 *
	 * let oneString = [ 1, 2, 3, 4, "5" ];
	 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
	 * ```
	 */
	exports.assertPredicate = assertFn;
	/**
	 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
	 * @example
	 * ```
	 *
	 * var data = { foo: 1, bar: 2 };
	 *
	 * let keys = [ 'foo', 'bar' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // values is [1, 2]
	 *
	 * let keys = [ 'foo', 'bar', 'baz' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // throws Error("Key not found")
	 * ```
	 */
	exports.assertMap = assertFn;
	function assertFn(predicateOrMap, errMsg) {
	    if (errMsg === void 0) { errMsg = 'assert failure'; }
	    return function (obj) {
	        var result = predicateOrMap(obj);
	        if (!result) {
	            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
	        }
	        return result;
	    };
	}
	exports.assertFn = assertFn;
	/**
	 * Like _.pairs: Given an object, returns an array of key/value pairs
	 *
	 * @example
	 * ```
	 *
	 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
	 * ```
	 */
	exports.pairs = function (obj) { return Object.keys(obj).map(function (key) { return [key, obj[key]]; }); };
	/**
	 * Given two or more parallel arrays, returns an array of tuples where
	 * each tuple is composed of [ a[i], b[i], ... z[i] ]
	 *
	 * @example
	 * ```
	 *
	 * let foo = [ 0, 2, 4, 6 ];
	 * let bar = [ 1, 3, 5, 7 ];
	 * let baz = [ 10, 30, 50, 70 ];
	 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
	 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
	 * ```
	 */
	function arrayTuples() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    if (args.length === 0)
	        return [];
	    var maxArrayLen = args.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
	    var result = [];
	    var _loop_1 = function (i) {
	        // This is a hot function
	        // Unroll when there are 1-4 arguments
	        switch (args.length) {
	            case 1:
	                result.push([args[0][i]]);
	                break;
	            case 2:
	                result.push([args[0][i], args[1][i]]);
	                break;
	            case 3:
	                result.push([args[0][i], args[1][i], args[2][i]]);
	                break;
	            case 4:
	                result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
	                break;
	            default:
	                result.push(args.map(function (array) { return array[i]; }));
	                break;
	        }
	    };
	    for (var i = 0; i < maxArrayLen; i++) {
	        _loop_1(i);
	    }
	    return result;
	}
	exports.arrayTuples = arrayTuples;
	/**
	 * Reduce function which builds an object from an array of [key, value] pairs.
	 *
	 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
	 *
	 * Each keyValueTuple should be an array with values [ key: string, value: any ]
	 *
	 * @example
	 * ```
	 *
	 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
	 *
	 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 *
	 * // Or, more simply:
	 * var pairsToObj = pairs.reduce(applyPairs, {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 * ```
	 */
	function applyPairs(memo, keyValTuple) {
	    var key, value;
	    if (predicates_1.isArray(keyValTuple))
	        key = keyValTuple[0], value = keyValTuple[1];
	    if (!predicates_1.isString(key))
	        throw new Error('invalid parameters to applyPairs');
	    memo[key] = value;
	    return memo;
	}
	exports.applyPairs = applyPairs;
	/** Get the last element of an array */
	function tail(arr) {
	    return (arr.length && arr[arr.length - 1]) || undefined;
	}
	exports.tail = tail;
	/**
	 * shallow copy from src to dest
	 */
	function copy(src, dest) {
	    if (dest)
	        Object.keys(dest).forEach(function (key) { return delete dest[key]; });
	    if (!dest)
	        dest = {};
	    return exports.extend(dest, src);
	}
	exports.copy = copy;
	/** Naive forEach implementation works with Objects or Arrays */
	function _forEach(obj, cb, _this) {
	    if (predicates_1.isArray(obj))
	        return obj.forEach(cb, _this);
	    Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
	}
	function _extend(toObj) {
	    for (var i = 1; i < arguments.length; i++) {
	        var obj = arguments[i];
	        if (!obj)
	            continue;
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; j++) {
	            toObj[keys[j]] = obj[keys[j]];
	        }
	    }
	    return toObj;
	}
	exports._extend = _extend;
	function _equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2;
	    if (t1 !== t2 || t1 !== 'object')
	        return false;
	    var tup = [o1, o2];
	    if (hof_1.all(predicates_1.isArray)(tup))
	        return _arraysEq(o1, o2);
	    if (hof_1.all(predicates_1.isDate)(tup))
	        return o1.getTime() === o2.getTime();
	    if (hof_1.all(predicates_1.isRegExp)(tup))
	        return o1.toString() === o2.toString();
	    if (hof_1.all(predicates_1.isFunction)(tup))
	        return true; // meh
	    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
	    if (predicates.map(hof_1.any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
	        return false;
	    var keys = {};
	    // tslint:disable-next-line:forin
	    for (var key in o1) {
	        if (!_equals(o1[key], o2[key]))
	            return false;
	        keys[key] = true;
	    }
	    for (var key in o2) {
	        if (!keys[key])
	            return false;
	    }
	    return true;
	}
	function _arraysEq(a1, a2) {
	    if (a1.length !== a2.length)
	        return false;
	    return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
	}
	// issue #2676
	exports.silenceUncaughtInPromise = function (promise) { return promise.catch(function (e) { return 0; }) && promise; };
	exports.silentRejection = function (error) { return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error)); };
	//# sourceMappingURL=common.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isPromise = exports.isInjectable = exports.isRegExp = exports.isDate = exports.isArray = exports.isObject = exports.isString = exports.isNumber = exports.isFunction = exports.isNullOrUndefined = exports.isNull = exports.isDefined = exports.isUndefined = void 0;
	/**
	 * Predicates
	 *
	 * These predicates return true/false based on the input.
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	var hof_1 = __webpack_require__(3);
	var toStr = Object.prototype.toString;
	var tis = function (t) { return function (x) { return typeof x === t; }; };
	exports.isUndefined = tis('undefined');
	exports.isDefined = hof_1.not(exports.isUndefined);
	exports.isNull = function (o) { return o === null; };
	exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
	exports.isFunction = tis('function');
	exports.isNumber = tis('number');
	exports.isString = tis('string');
	exports.isObject = function (x) { return x !== null && typeof x === 'object'; };
	exports.isArray = Array.isArray;
	exports.isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
	exports.isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
	/**
	 * Predicate which checks if a value is injectable
	 *
	 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
	 * where all the elements in the array are Strings, except the last one, which is a Function
	 */
	function isInjectable(val) {
	    if (exports.isArray(val) && val.length) {
	        var head = val.slice(0, -1), tail = val.slice(-1);
	        return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
	    }
	    return exports.isFunction(val);
	}
	exports.isInjectable = isInjectable;
	/**
	 * Predicate which checks if a value looks like a Promise
	 *
	 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
	 */
	exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
	//# sourceMappingURL=predicates.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Higher order functions
	 *
	 * These utility functions are exported, but are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pattern = exports.invoke = exports.val = exports.eq = exports.is = exports.any = exports.all = exports.or = exports.and = exports.not = exports.parse = exports.propEq = exports.prop = exports.pipe = exports.compose = exports.curry = void 0;
	/**
	 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
	 *
	 * Given a function with N parameters, returns a new function that supports partial application.
	 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
	 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
	 * accept more parameters until all N parameters have been supplied.
	 *
	 *
	 * This contrived example uses a partially applied function as an predicate, which returns true
	 * if an object is found in both arrays.
	 * @example
	 * ```
	 * // returns true if an object is in both of the two arrays
	 * function inBoth(array1, array2, object) {
	 *   return array1.indexOf(object) !== -1 &&
	 *          array2.indexOf(object) !== 1;
	 * }
	 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
	 * let foos = [obj1, obj3]
	 * let bars = [obj3, obj4, obj5]
	 *
	 * // A curried "copy" of inBoth
	 * let curriedInBoth = curry(inBoth);
	 * // Partially apply both the array1 and array2
	 * let inFoosAndBars = curriedInBoth(foos, bars);
	 *
	 * // Supply the final argument; since all arguments are
	 * // supplied, the original inBoth function is then called.
	 * let obj1InBoth = inFoosAndBars(obj1); // false
	 *
	 * // Use the inFoosAndBars as a predicate.
	 * // Filter, on each iteration, supplies the final argument
	 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
	 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
	 *
	 * ```
	 *
	 * @param fn
	 * @returns {*|function(): (*|any)}
	 */
	function curry(fn) {
	    return function curried() {
	        if (arguments.length >= fn.length) {
	            return fn.apply(this, arguments);
	        }
	        var args = Array.prototype.slice.call(arguments);
	        return curried.bind.apply(curried, __spreadArrays([this], args));
	    };
	}
	exports.curry = curry;
	/**
	 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
	 * given: f(x), g(x), h(x)
	 * let composed = compose(f,g,h)
	 * then, composed is: f(g(h(x)))
	 */
	function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	        var i = start, result = args[start].apply(this, arguments);
	        while (i--)
	            result = args[i].call(this, result);
	        return result;
	    };
	}
	exports.compose = compose;
	/**
	 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
	 * given: f(x), g(x), h(x)
	 * let piped = pipe(f,g,h);
	 * then, piped is: h(g(f(x)))
	 */
	function pipe() {
	    var funcs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        funcs[_i] = arguments[_i];
	    }
	    return compose.apply(null, [].slice.call(arguments).reverse());
	}
	exports.pipe = pipe;
	/**
	 * Given a property name, returns a function that returns that property from an object
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = prop("name");
	 * getName(obj) === "blarg"
	 */
	exports.prop = function (name) { return function (obj) { return obj && obj[name]; }; };
	/**
	 * Given a property name and a value, returns a function that returns a boolean based on whether
	 * the passed object has a property that matches the value
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = propEq("name", "blarg");
	 * getName(obj) === true
	 */
	exports.propEq = curry(function (name, _val, obj) { return obj && obj[name] === _val; });
	/**
	 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
	 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
	 * let getName = prop("nestedObj.name");
	 * getName(obj) === "blarg"
	 * let propNotFound = prop("this.property.doesnt.exist");
	 * propNotFound(obj) === undefined
	 */
	exports.parse = function (name) { return pipe.apply(null, name.split('.').map(exports.prop)); };
	/**
	 * Given a function that returns a truthy or falsey value, returns a
	 * function that returns the opposite (falsey or truthy) value given the same inputs
	 */
	exports.not = function (fn) { return function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return !fn.apply(null, args);
	}; };
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if both functions return truthy for the given arguments
	 */
	function and(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) && fn2.apply(null, args);
	    };
	}
	exports.and = and;
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if at least one of the functions returns truthy for the given arguments
	 */
	function or(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) || fn2.apply(null, args);
	    };
	}
	exports.or = or;
	/**
	 * Check if all the elements of an array match a predicate function
	 *
	 * @param fn1 a predicate function `fn1`
	 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
	 */
	exports.all = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); }; };
	// tslint:disable-next-line:variable-name
	exports.any = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); }; };
	/** Given a class, returns a Predicate function that returns true if the object is of that class */
	exports.is = function (ctor) { return function (obj) {
	    return (obj != null && obj.constructor === ctor) || obj instanceof ctor;
	}; };
	/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
	exports.eq = function (value) { return function (other) { return value === other; }; };
	/** Given a value, returns a function which returns the value */
	exports.val = function (v) { return function () { return v; }; };
	function invoke(fnName, args) {
	    return function (obj) { return obj[fnName].apply(obj, args); };
	}
	exports.invoke = invoke;
	/**
	 * Sorta like Pattern Matching (a functional programming conditional construct)
	 *
	 * See http://c2.com/cgi/wiki?PatternMatching
	 *
	 * This is a conditional construct which allows a series of predicates and output functions
	 * to be checked and then applied.  Each predicate receives the input.  If the predicate
	 * returns truthy, then its matching output function (mapping function) is provided with
	 * the input and, then the result is returned.
	 *
	 * Each combination (2-tuple) of predicate + output function should be placed in an array
	 * of size 2: [ predicate, mapFn ]
	 *
	 * These 2-tuples should be put in an outer array.
	 *
	 * @example
	 * ```
	 *
	 * // Here's a 2-tuple where the first element is the isString predicate
	 * // and the second element is a function that returns a description of the input
	 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
	 *
	 * // Second tuple: predicate "isNumber", mapfn returns a description
	 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
	 *
	 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
	 *
	 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
	 *
	 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
	 *
	 * console.log(descriptionOf(undefined)); // 'notdefined'
	 * console.log(descriptionOf(55)); // '(55) That's a number!'
	 * console.log(descriptionOf("foo")); // 'Here's your string foo'
	 * ```
	 *
	 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
	 * with a Predicate and a mapping/output function
	 * @returns {function(any): *}
	 */
	function pattern(struct) {
	    return function (x) {
	        for (var i = 0; i < struct.length; i++) {
	            if (struct[i][0](x))
	                return struct[i][1](x);
	        }
	    };
	}
	exports.pattern = pattern;
	//# sourceMappingURL=hof.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(1), exports);
	__exportStar(__webpack_require__(5), exports);
	__exportStar(__webpack_require__(35), exports);
	__exportStar(__webpack_require__(3), exports);
	__exportStar(__webpack_require__(2), exports);
	__exportStar(__webpack_require__(36), exports);
	__exportStar(__webpack_require__(6), exports);
	__exportStar(__webpack_require__(9), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.services = exports.makeStub = void 0;
	var noImpl = function (fnname) { return function () {
	    throw new Error("No implementation for " + fnname + ". The framework specific code did not implement this method.");
	}; };
	exports.makeStub = function (service, methods) {
	    return methods.reduce(function (acc, key) { return ((acc[key] = noImpl(service + "." + key + "()")), acc); }, {});
	};
	var services = {
	    $q: undefined,
	    $injector: undefined,
	};
	exports.services = services;
	//# sourceMappingURL=coreservices.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Functions that manipulate strings
	 *
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.joinNeighborsR = exports.splitOnDelim = exports.trimHashVal = exports.splitEqual = exports.splitQuery = exports.splitHash = exports.stripLastPathElement = exports.hostRegex = exports.beforeAfterSubstr = exports.stringify = exports.fnToString = exports.functionToString = exports.kebobString = exports.padString = exports.maxLength = void 0;
	var predicates_1 = __webpack_require__(2);
	var rejectFactory_1 = __webpack_require__(12);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	/**
	 * Returns a string shortened to a maximum length
	 *
	 * If the string is already less than the `max` length, return the string.
	 * Else return the string, shortened to `max - 3` and append three dots ("...").
	 *
	 * @param max the maximum length of the string to return
	 * @param str the input string
	 */
	function maxLength(max, str) {
	    if (str.length <= max)
	        return str;
	    return str.substr(0, max - 3) + '...';
	}
	exports.maxLength = maxLength;
	/**
	 * Returns a string, with spaces added to the end, up to a desired str length
	 *
	 * If the string is already longer than the desired length, return the string.
	 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
	 *
	 * @param length the desired length of the string to return
	 * @param str the input string
	 */
	function padString(length, str) {
	    while (str.length < length)
	        str += ' ';
	    return str;
	}
	exports.padString = padString;
	function kebobString(camelCase) {
	    return camelCase
	        .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
	        .replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); }); // replace rest
	}
	exports.kebobString = kebobString;
	function functionToString(fn) {
	    var fnStr = fnToString(fn);
	    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
	    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
	    var fnName = fn['name'] || '';
	    if (fnName && toStr.match(/function \(/)) {
	        return 'function ' + fnName + toStr.substr(9);
	    }
	    return toStr;
	}
	exports.functionToString = functionToString;
	function fnToString(fn) {
	    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
	    return (_fn && _fn.toString()) || 'undefined';
	}
	exports.fnToString = fnToString;
	var isRejection = rejectFactory_1.Rejection.isRejectionPromise;
	var hasToString = function (obj) {
	    return predicates_1.isObject(obj) && !predicates_1.isArray(obj) && obj.constructor !== Object && predicates_1.isFunction(obj.toString);
	};
	var stringifyPattern = hof_1.pattern([
	    [predicates_1.isUndefined, hof_1.val('undefined')],
	    [predicates_1.isNull, hof_1.val('null')],
	    [predicates_1.isPromise, hof_1.val('[Promise]')],
	    [isRejection, function (x) { return x._transitionRejection.toString(); }],
	    [hasToString, function (x) { return x.toString(); }],
	    [predicates_1.isInjectable, functionToString],
	    [hof_1.val(true), common_1.identity],
	]);
	function stringify(o) {
	    var seen = [];
	    function format(value) {
	        if (predicates_1.isObject(value)) {
	            if (seen.indexOf(value) !== -1)
	                return '[circular ref]';
	            seen.push(value);
	        }
	        return stringifyPattern(value);
	    }
	    if (predicates_1.isUndefined(o)) {
	        // Workaround for IE & Edge Spec incompatibility where replacer function would not be called when JSON.stringify
	        // is given `undefined` as value. To work around that, we simply detect `undefined` and bail out early by
	        // manually stringifying it.
	        return format(o);
	    }
	    return JSON.stringify(o, function (key, value) { return format(value); }).replace(/\\"/g, '"');
	}
	exports.stringify = stringify;
	/** Returns a function that splits a string on a character or substring */
	exports.beforeAfterSubstr = function (char) { return function (str) {
	    if (!str)
	        return ['', ''];
	    var idx = str.indexOf(char);
	    if (idx === -1)
	        return [str, ''];
	    return [str.substr(0, idx), str.substr(idx + 1)];
	}; };
	exports.hostRegex = new RegExp('^(?:[a-z]+:)?//[^/]+/');
	exports.stripLastPathElement = function (str) { return str.replace(/\/[^/]*$/, ''); };
	exports.splitHash = exports.beforeAfterSubstr('#');
	exports.splitQuery = exports.beforeAfterSubstr('?');
	exports.splitEqual = exports.beforeAfterSubstr('=');
	exports.trimHashVal = function (str) { return (str ? str.replace(/^#/, '') : ''); };
	/**
	 * Splits on a delimiter, but returns the delimiters in the array
	 *
	 * #### Example:
	 * ```js
	 * var splitOnSlashes = splitOnDelim('/');
	 * splitOnSlashes("/foo"); // ["/", "foo"]
	 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
	 * ```
	 */
	function splitOnDelim(delim) {
	    var re = new RegExp('(' + delim + ')', 'g');
	    return function (str) { return str.split(re).filter(common_1.identity); };
	}
	exports.splitOnDelim = splitOnDelim;
	/**
	 * Reduce fn that joins neighboring strings
	 *
	 * Given an array of strings, returns a new array
	 * where all neighboring strings have been joined.
	 *
	 * #### Example:
	 * ```js
	 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
	 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
	 * ```
	 */
	function joinNeighborsR(acc, x) {
	    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x))
	        return acc.slice(0, -1).concat(common_1.tail(acc) + x);
	    return common_1.pushR(acc, x);
	}
	exports.joinNeighborsR = joinNeighborsR;
	//# sourceMappingURL=strings.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(150);
	module.exports = angular;


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.trace = exports.Trace = exports.Category = void 0;
	/**
	 * # Transition tracing (debug)
	 *
	 * Enable transition tracing to print transition information to the console,
	 * in order to help debug your application.
	 * Tracing logs detailed information about each Transition to your console.
	 *
	 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
	 *
	 * ### ES6
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
	 * ```
	 *
	 * ### CJS
	 * ```js
	 * let trace = require("@uirouter/core").trace;
	 * trace.enable("TRANSITION", "VIEWCONFIG");
	 * ```
	 *
	 * ### Globals
	 * ```js
	 * let trace = window["@uirouter/core"].trace;
	 * trace.enable(); // Trace everything (very verbose)
	 * ```
	 *
	 * ### Angular 1:
	 * ```js
	 * app.run($trace => $trace.enable());
	 * ```
	 *
	 * @packageDocumentation
	 */
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var strings_1 = __webpack_require__(6);
	var safeConsole_1 = __webpack_require__(49);
	function uiViewString(uiview) {
	    if (!uiview)
	        return 'ui-view (defunct)';
	    var state = uiview.creationContext ? uiview.creationContext.name || '(root)' : '(none)';
	    return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
	}
	var viewConfigString = function (viewConfig) {
	    var view = viewConfig.viewDecl;
	    var state = view.$context.name || '(root)';
	    return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
	};
	function normalizedCat(input) {
	    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
	}
	/**
	 * Trace categories Enum
	 *
	 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
	 *
	 * `trace.enable(Category.TRANSITION)`
	 *
	 * These can also be provided using a matching string, or position ordinal
	 *
	 * `trace.enable("TRANSITION")`
	 *
	 * `trace.enable(1)`
	 */
	var Category;
	(function (Category) {
	    Category[Category["RESOLVE"] = 0] = "RESOLVE";
	    Category[Category["TRANSITION"] = 1] = "TRANSITION";
	    Category[Category["HOOK"] = 2] = "HOOK";
	    Category[Category["UIVIEW"] = 3] = "UIVIEW";
	    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
	})(Category || (Category = {}));
	exports.Category = Category;
	var _tid = hof_1.parse('$id');
	var _rid = hof_1.parse('router.$id');
	var transLbl = function (trans) { return "Transition #" + _tid(trans) + "-" + _rid(trans); };
	/**
	 * Prints UI-Router Transition trace information to the console.
	 */
	var Trace = /** @class */ (function () {
	    /** @internal */
	    function Trace() {
	        /** @internal */
	        this._enabled = {};
	        this.approximateDigests = 0;
	    }
	    /** @internal */
	    Trace.prototype._set = function (enabled, categories) {
	        var _this = this;
	        if (!categories.length) {
	            categories = Object.keys(Category)
	                .map(function (k) { return parseInt(k, 10); })
	                .filter(function (k) { return !isNaN(k); })
	                .map(function (key) { return Category[key]; });
	        }
	        categories.map(normalizedCat).forEach(function (category) { return (_this._enabled[category] = enabled); });
	    };
	    Trace.prototype.enable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(true, categories);
	    };
	    Trace.prototype.disable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(false, categories);
	    };
	    /**
	     * Retrieves the enabled stateus of a [[Category]]
	     *
	     * ```js
	     * trace.enabled("VIEWCONFIG"); // true or false
	     * ```
	     *
	     * @returns boolean true if the category is enabled
	     */
	    Trace.prototype.enabled = function (category) {
	        return !!this._enabled[normalizedCat(category)];
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceTransitionStart = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": Started  -> " + strings_1.stringify(trans));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceTransitionIgnored = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": Ignored  <> " + strings_1.stringify(trans));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceHookInvocation = function (step, trans, options) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.functionToString(step.registeredHook.callback);
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":   <- Hook returned: " + strings_1.maxLength(200, strings_1.stringify(hookResult)));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceResolvePath = function (path, when, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + strings_1.maxLength(200, strings_1.stringify(resolvable.data)));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceError = function (reason, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": <- Rejected " + strings_1.stringify(trans) + ", reason: " + reason);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceSuccess = function (finalState, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": <- Success  " + strings_1.stringify(trans) + ", final state: " + finalState.name);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
	        if (extra === void 0) { extra = ''; }
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        safeConsole_1.safeConsole.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Updating', viewData, " with ViewConfig from context='" + context + "'");
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewFill = function (viewData, html) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Fill', viewData, " with: " + strings_1.maxLength(200, html));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewSync = function (pairs) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        var uivheader = 'uiview component fqn';
	        var cfgheader = 'view config state (view name)';
	        var mapping = pairs
	            .map(function (_a) {
	            var _b;
	            var uiView = _a.uiView, viewConfig = _a.viewConfig;
	            var uiv = uiView && uiView.fqn;
	            var cfg = viewConfig && viewConfig.viewDecl.$context.name + ": (" + viewConfig.viewDecl.$name + ")";
	            return _b = {}, _b[uivheader] = uiv, _b[cfgheader] = cfg, _b;
	        })
	            .sort(function (a, b) { return (a[uivheader] || '').localeCompare(b[uivheader] || ''); });
	        safeConsole_1.safeConsole.table(mapping);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        safeConsole_1.safeConsole.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        safeConsole_1.safeConsole.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
	    };
	    return Trace;
	}());
	exports.Trace = Trace;
	/**
	 * The [[Trace]] singleton
	 *
	 * #### Example:
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5);
	 * ```
	 */
	var trace = new Trace();
	exports.trace = trace;
	//# sourceMappingURL=trace.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(47)
	var ieee754 = __webpack_require__(48)
	var isArray = __webpack_require__(27)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionHookScope = exports.TransitionHookPhase = void 0;
	var TransitionHookPhase;
	(function (TransitionHookPhase) {
	    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
	    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
	    TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
	    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
	    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
	})(TransitionHookPhase || (TransitionHookPhase = {}));
	exports.TransitionHookPhase = TransitionHookPhase;
	var TransitionHookScope;
	(function (TransitionHookScope) {
	    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
	    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
	})(TransitionHookScope || (TransitionHookScope = {}));
	exports.TransitionHookScope = TransitionHookScope;
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Rejection = exports.RejectType = void 0;
	var common_1 = __webpack_require__(1);
	var strings_1 = __webpack_require__(6);
	var hof_1 = __webpack_require__(3);
	/** An enum for Transition Rejection reasons */
	var RejectType;
	(function (RejectType) {
	    /**
	     * A new transition superseded this one.
	     *
	     * While this transition was running, a new transition started.
	     * This transition is cancelled because it was superseded by new transition.
	     */
	    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
	    /**
	     * The transition was aborted
	     *
	     * The transition was aborted by a hook which returned `false`
	     */
	    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
	    /**
	     * The transition was invalid
	     *
	     * The transition was never started because it was invalid
	     */
	    RejectType[RejectType["INVALID"] = 4] = "INVALID";
	    /**
	     * The transition was ignored
	     *
	     * The transition was ignored because it would have no effect.
	     *
	     * Either:
	     *
	     * - The transition is targeting the current state and parameter values
	     * - The transition is targeting the same state and parameter values as the currently running transition.
	     */
	    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
	    /**
	     * The transition errored.
	     *
	     * This generally means a hook threw an error or returned a rejected promise
	     */
	    RejectType[RejectType["ERROR"] = 6] = "ERROR";
	})(RejectType || (RejectType = {}));
	exports.RejectType = RejectType;
	/** @internal */
	var id = 0;
	var Rejection = /** @class */ (function () {
	    function Rejection(type, message, detail) {
	        /** @internal */
	        this.$id = id++;
	        this.type = type;
	        this.message = message;
	        this.detail = detail;
	    }
	    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
	    Rejection.isRejectionPromise = function (obj) {
	        return obj && typeof obj.then === 'function' && hof_1.is(Rejection)(obj._transitionRejection);
	    };
	    /** Returns a Rejection due to transition superseded */
	    Rejection.superseded = function (detail, options) {
	        var message = 'The transition has been superseded by a different transition';
	        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
	        if (options && options.redirected) {
	            rejection.redirected = true;
	        }
	        return rejection;
	    };
	    /** Returns a Rejection due to redirected transition */
	    Rejection.redirected = function (detail) {
	        return Rejection.superseded(detail, { redirected: true });
	    };
	    /** Returns a Rejection due to invalid transition */
	    Rejection.invalid = function (detail) {
	        var message = 'This transition is invalid';
	        return new Rejection(RejectType.INVALID, message, detail);
	    };
	    /** Returns a Rejection due to ignored transition */
	    Rejection.ignored = function (detail) {
	        var message = 'The transition was ignored';
	        return new Rejection(RejectType.IGNORED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.aborted = function (detail) {
	        var message = 'The transition has been aborted';
	        return new Rejection(RejectType.ABORTED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.errored = function (detail) {
	        var message = 'The transition errored';
	        return new Rejection(RejectType.ERROR, message, detail);
	    };
	    /**
	     * Returns a Rejection
	     *
	     * Normalizes a value as a Rejection.
	     * If the value is already a Rejection, returns it.
	     * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
	     *
	     * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
	     */
	    Rejection.normalize = function (detail) {
	        return hof_1.is(Rejection)(detail) ? detail : Rejection.errored(detail);
	    };
	    Rejection.prototype.toString = function () {
	        var detailString = function (d) { return (d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d)); };
	        var detail = detailString(this.detail);
	        var _a = this, $id = _a.$id, type = _a.type, message = _a.message;
	        return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
	    };
	    Rejection.prototype.toPromise = function () {
	        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
	    };
	    return Rejection;
	}());
	exports.Rejection = Rejection;
	//# sourceMappingURL=rejectFactory.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NuevaModificacionModalController = function () {
	  NuevaModificacionModalController.$inject = ["$uibModalInstance", "$state", "data", "Modal", "DataService", "Storage", "_", "Usuarios"];
	  function NuevaModificacionModalController($uibModalInstance, $state, data, Modal, DataService, Storage, _, Usuarios) {
	    'ngInject';
	
	    _classCallCheck(this, NuevaModificacionModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$state = $state;
	    this.proyecto = data;
	    this.Modal = Modal;
	    this.DataService = DataService;
	    this._ = _;
	    this.modificando = true;
	    this.user = Storage.getUser();
	    this.Usuarios = Usuarios;
	  }
	
	  _createClass(NuevaModificacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/modificaciones/' + this.proyecto.adjudicacion.id_adjudicacion + '/historial').then(function (result) {
	        if (result && result.finalizado) {
	          _this.modificaciones = result.datos;
	          _this.existeSupervisionesEnCurso = _this.tieneSupervisionesEnCurso();
	          _this.puedeModificar = !(_this.proyecto.estado_proyecto != 'EN_EJECUCION_FDI' && _this.proyecto.estado_proyecto != 'EN_CIERRE_FDI') && _this.Usuarios.esSupervisor() && !_this.existeSupervisionesEnCurso && _this.proyecto.estado_proyecto !== 'CERRADO_FDI' && !result.en_modificacion;
	          _this.modificando = ['SUPERVISOR_FDI', 'FISCAL_FDI', 'TECNICO_FDI', 'JEFE_REVISION_FDI', 'RESP_GAM_GAIOC', 'VISOR_REPORTES', 'TECNICO_CIERRE'].indexOf(_this.user.rol.nombre) >= 0 ? true : false;
	          var cant = _this.modificaciones.length - 1;
	          if (cant >= 0 && _this.modificaciones[cant] && !_this.modificaciones[cant].nombre) {
	            _this.modificaciones[cant].nombre = 'Contrato Original';
	          }
	        }
	      });
	    }
	  }, {
	    key: 'tieneSupervisionesEnCurso',
	    value: function tieneSupervisionesEnCurso() {
	      var _this2 = this;
	
	      return this._.some(this.proyecto.supervisiones, function (supervision) {
	        return supervision.estado_supervision !== 'EN_ARCHIVO_FDI' && supervision.estado_supervision !== 'REGISTRO_PLANILLA_FDI' && supervision.fid_adjudicacion === _this2.proyecto.adjudicacion.id_adjudicacion;
	      });
	    }
	  }, {
	    key: 'abrirModificacion',
	    value: function abrirModificacion(tipoModificacion) {
	      var _this3 = this;
	
	      var html = '\n      1. Para realizar una modificaci\xF3n deber\xE1 contar con el respectivo documento de respaldo debidamente aprobado por las instancias pertinentes (Libro de Ordenes e Informes T\xE9cnicos para la Orden de Trabajo y Orden de Cambio y el respectivo contrato para el Contrato Modificatorio).\n      <br/><br/>\n      2. Una vez que este registrando modificaciones la empresa no podr\xE1 procesar una planilla de avance hasta que se finalice y apruebe la solicitud de modificaci\xF3n.\n    ';
	      this.Modal.confirm(html, function () {
	        _this3.$uibModalInstance.close(false);
	        /*const data = {
	          id_adjudicacion: this.proyecto.adjudicacion.id_adjudicacion,
	          fid_proyecto: this.proyecto.id_proyecto,
	          tipo_modificacion: tipoModificacion
	        };*/
	        /*this.DataService.post(`proyectos/adjudicaciones/modificacion/${this.proyecto.adjudicacion.id_adjudicacion}`, data).then(response => {
	          if (response) {
	            //this.irAModificacion(response.datos.id_adjudicacion);
	          }
	        });*/
	        _this3.$state.go('modificacion', {
	          proyecto: _this3.proyecto.id_proyecto,
	          componente: 'test',
	          adjudicacion: _this3.proyecto.adjudicacion.id_adjudicacion,
	          tipoModificacion: tipoModificacion,
	          edicion: true,
	          crear: true
	        });
	      }, null, 'Confirmar inicio de modificación', 'Confirmar');
	    }
	  }, {
	    key: 'irAModificacion',
	    value: function irAModificacion(modificacion, edicion) {
	      if (this.Usuarios.esFiscal() || this.Usuarios.esTecnicoResponsable() || this.Usuarios.esTecnicoCierre()) edicion = false;
	      var tipoModificacion = 0;
	      switch (modificacion.tipo_modificacion) {
	        case 'TM_ORDEN_TRABAJO':
	          tipoModificacion = 1;
	          break;
	        case 'TM_ORDEN_CAMBIO':
	          tipoModificacion = 2;
	          break;
	        case 'TM_CONTRATO_MODIFICATORIO':
	          tipoModificacion = 3;
	          break;
	        default:
	          tipoModificacion = 0;
	          break;
	      }
	      // let tipoModificacion = modificacion.tipo_modificacion === 'TM_ORDEN_TRABAJO' ? 1 : modificacion.tipo_modificacion === 'TM_ORDEN_CAMBIO' ? 2 : modificacion.tipo_modificacion === 'TM_CONTRATO_MODIFICATORIO' ? 3 : 0;
	      this.$uibModalInstance.close(false);
	
	      this.$state.go('modificacion', {
	        proyecto: this.proyecto.id_proyecto,
	        adjudicacion: this.proyecto.adjudicacion.id_adjudicacion,
	        version: modificacion.version,
	        tipoModificacion: tipoModificacion,
	        edicion: edicion,
	        crear: false
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'verModificar',
	    value: function verModificar(modificacion) {
	      return modificacion.estado_adjudicacion == 'MODIFICADO_FDI' && this.Usuarios.esSupervisor() || modificacion.estado_adjudicacion == 'REVISION_MODIFICADO_FDI' && this.Usuarios.esFiscal() || modificacion.estado_adjudicacion == 'NO_OBJECION_FDI' && this.Usuarios.esTecnicoResponsable();
	    }
	  }, {
	    key: 'verUltimaModificacion',
	    value: function verUltimaModificacion(modificacion) {
	      return ['NO_OBJECION_FDI', 'REVISION_MODIFICADO_FDI', 'MODIFICADO_FDI', 'CERRADO_FDI'].indexOf(modificacion.estado_adjudicacion) >= 0 && ['SUPERVISOR_FDI', 'TECNICO_FDI', 'JEFE_REVISION_FDI', 'RESP_GAM_GAIOC', 'FISCAL_FDI', 'VISOR_REPORTES', 'TECNICO_CIERRE'].indexOf(this.user.rol.nombre) >= 0 && !this.verModificar(modificacion);
	    }
	  }]);
	
	  return NuevaModificacionModalController;
	}();
	
	exports.default = NuevaModificacionModalController;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-list\"></i> {{$ctrl.proyecto.nombre}}</h5>  \n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n\n<div class=\"modal-body\">\n  <strong>Componente: {{$ctrl.proyecto.adjudicacion.referencia}} ({{$ctrl.proyecto.adjudicacion.id_adjudicacion}})</strong>\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.existeSupervisionesEnCurso\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>No se pueden realizar modificaciones mientras existan supervisiones en curso de aprobación.</span>\n  </div>\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.proyecto.estado_proyecto === 'CERRADO_FDI'\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>No se pueden realizar modificaciones a un proyecto concluído.</span>\n  </div>\n  <section ng-if=\"$ctrl.puedeModificar\">\n    <div class=\"alert alert-secondary\">\n      <i class=\"fa fa-info-circle\"></i>\n      <span>Seleccione el tipo de modificación que desea realizar al proyecto.</span>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-sm-4\">\n        <div class=\"card card-modificacion\" ng-mouseover=\"$ctrl.tipo=1\">\n          <div class=\"card-header text-center\">\n            <h6><strong>ORDEN<br>DE TRABAJO</strong></h6>\n          </div>\n          <div class=\"card-body text-center\">\n            <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.abrirModificacion(1)\">\n              <i class=\"fa fa-check\"></i> Seleccionar\n            </button>\n          </div>\n          <div class=\"card-footer\">\n          </div>\n        </div>\n      </div>\n      <div class=\"col-sm-4\">\n        <div class=\"card card-modificacion\" ng-mouseover=\"$ctrl.tipo=2\">\n          <div class=\"card-header text-center\">\n            <h6><strong>ORDEN<br>DE CAMBIO</strong></h6>\n          </div>\n          <div class=\"card-body text-center\">\n            <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.abrirModificacion(2)\">\n              <i class=\"fa fa-check\"></i> Seleccionar\n            </button>\n          </div>\n          <div class=\"card-footer\">\n          </div>\n        </div>\n      </div>\n      <div class=\"col-sm-4\">\n        <div class=\"card card-modificacion\" ng-mouseover=\"$ctrl.tipo=3\">\n          <div class=\"card-header text-center\">\n            <h6><strong>CONTRATO<br>MODIFICATORIO</strong></h6>\n          </div>\n          <div class=\"card-body text-center\">\n            <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.abrirModificacion(3)\">\n              <i class=\"fa fa-check\"></i> Seleccionar\n            </button>\n          </div>\n          <div class=\"card-footer\">\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"alert alert-primary\">\n      <div ng-click=\"$ctrl.tipo=1\">\n        <i class=\"fa fa-info-circle\"></i>\n        <strong>Orden de trabajo</strong>\n        <ul ng-if=\"$ctrl.tipo==1\">\n          <li>Modificación de cantidades (volúmenes) de los ítems.</li>\n          <li>Las modificaciones realizadas no deberán incrementar o disminuir el monto contractual del proyecto.</li>\n          <li>No afectará a los plazos de ejecución.</li>\n        </ul>\n      </div>\n      <div ng-click=\"$ctrl.tipo=2\">\n        <i class=\"fa fa-info-circle\"></i>\n        <strong>Orden de cambio</strong>\n        <ul ng-if=\"$ctrl.tipo==2\">\n          <li>Modificación de cantidades (volúmenes) de los ítems, misma que podrá incrementar o disminuir el monto contractual del proyecto hasta un 5%.</li>\n          <li>Modificación del plazo de ejecución del proyecto (por volumen o compensación).</li>\n          <li>El total de las modificaciones no deberá superar el 15% del monto contractual del proyecto.</li>\n        </ul>\n      </div>\n      <div ng-click=\"$ctrl.tipo=3\">\n        <i class=\"fa fa-info-circle\"></i>\n        <strong>Contrato modificatorio</strong>\n        <ul ng-if=\"$ctrl.tipo==3\">\n          <li>Modificación de cantidades (volúmenes) de los ítems, misma que podrá incrementar o disminuir el monto contractual del proyecto hasta un 10%.</li>\n          <li>Modificación del plazo de ejecución del proyecto (por volumen o compensación).</li>\n          <li>Adición de ítems.</li>\n          <li>El total de las modificaciones no deberá superar el 15% del monto contractual del proyecto.</li>\n        </ul>\n      </div>\n    </div>\n\n    <div class=\"alert alert-success\">\n      <i class=\"fa fa-info-circle\"></i>\n      <span>* Las modificaciones solo se las podrá realizar sobre las cantidades no ejecutadas de los ítems, y no así sobre ítems cerrados físicamente.</span>\n    </div>\n  </section>\n\n  <hr>\n  <section ng-if=\"$ctrl.modificando\">\n    <p class=\"text-center\"><strong>Modificaciones</strong></p>\n    <div class=\"crud-table mt-3 table-responsive\">\n      <table class=\"table table-striped table-hover ng-table\">\n        <thead>\n          <tr>\n            <td><strong></strong></td>\n            <td><strong>Tipo</strong></td>\n            <td><strong>Estado</strong></td>\n            <td><strong>Fecha</strong></td>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"modificacion in $ctrl.modificaciones\">\n            <td data-title=\"'Acción'\">\n              <button md-effect type=\"button\" class=\"btn btn-primary btn-noborder btn-sm mb-1\" ng-if=\"$ctrl.verUltimaModificacion(modificacion)\"\n                uib-tooltip=\"Ver Modificacion {{modificacion.version}}\" ng-click=\"$ctrl.irAModificacion(modificacion)\">\n                <i class=\"fa fa-eye\"></i>\n              </button>\n              <button md-effect type=\"button\" class=\"btn btn-success btn-noborder btn-sm mb-1\" ng-if=\"modificacion.estado_adjudicacion == 'ADJUDICADO_FDI' && modificacion.version > 1\"\n                uib-tooltip=\"Ver Modificacion {{modificacion.version}}\" ng-click=\"$ctrl.irAModificacion(modificacion)\">\n                <i class=\"fa fa-eye\"></i>\n              </button>\n              <button md-effect type=\"button\" class=\"btn btn-primary btn-noborder btn-sm mb-1\" ng-if=\"$ctrl.verModificar(modificacion)\"\n                uib-tooltip=\"Ver Modificacion {{modificacion.version}}\" ng-click=\"$ctrl.irAModificacion(modificacion,true)\">\n                <i class=\"fa fa-edit\"></i>\n              </button>\n            </td>\n            <td>{{modificacion.nombre}}</td>\n            <td>\n              {{modificacion.estado_actual.nombre}}<br>\n              <span ng-if=\"modificacion.observacion.mensaje\" class=\"text-danger\"> {{ modificacion.observacion.mensaje }} </span>\n            </td>\n            <td>{{modificacion.fecha_modificacion | date : 'dd/MM/yyyy'}}</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </section>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Cerrar\n  </button>\n</div>\n"

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Param = exports.DefType = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var coreservices_1 = __webpack_require__(5);
	var paramType_1 = __webpack_require__(38);
	var hasOwn = Object.prototype.hasOwnProperty;
	var isShorthand = function (cfg) {
	    return ['value', 'type', 'squash', 'array', 'dynamic'].filter(hasOwn.bind(cfg || {})).length === 0;
	};
	var DefType;
	(function (DefType) {
	    DefType[DefType["PATH"] = 0] = "PATH";
	    DefType[DefType["SEARCH"] = 1] = "SEARCH";
	    DefType[DefType["CONFIG"] = 2] = "CONFIG";
	})(DefType || (DefType = {}));
	exports.DefType = DefType;
	function getParamDeclaration(paramName, location, state) {
	    var noReloadOnSearch = (state.reloadOnSearch === false && location === DefType.SEARCH) || undefined;
	    var dynamic = common_1.find([state.dynamic, noReloadOnSearch], predicates_1.isDefined);
	    var defaultConfig = predicates_1.isDefined(dynamic) ? { dynamic: dynamic } : {};
	    var paramConfig = unwrapShorthand(state && state.params && state.params[paramName]);
	    return common_1.extend(defaultConfig, paramConfig);
	}
	function unwrapShorthand(cfg) {
	    cfg = isShorthand(cfg) ? { value: cfg } : cfg;
	    getStaticDefaultValue['__cacheable'] = true;
	    function getStaticDefaultValue() {
	        return cfg.value;
	    }
	    var $$fn = predicates_1.isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue;
	    return common_1.extend(cfg, { $$fn: $$fn });
	}
	function getType(cfg, urlType, location, id, paramTypes) {
	    if (cfg.type && urlType && urlType.name !== 'string')
	        throw new Error("Param '" + id + "' has two type configurations.");
	    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
	        return paramTypes.type(cfg.type);
	    if (urlType)
	        return urlType;
	    if (!cfg.type) {
	        var type = location === DefType.CONFIG
	            ? 'any'
	            : location === DefType.PATH
	                ? 'path'
	                : location === DefType.SEARCH
	                    ? 'query'
	                    : 'string';
	        return paramTypes.type(type);
	    }
	    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
	}
	/** returns false, true, or the squash value to indicate the "default parameter url squash policy". */
	function getSquashPolicy(config, isOptional, defaultPolicy) {
	    var squash = config.squash;
	    if (!isOptional || squash === false)
	        return false;
	    if (!predicates_1.isDefined(squash) || squash == null)
	        return defaultPolicy;
	    if (squash === true || predicates_1.isString(squash))
	        return squash;
	    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	}
	function getReplace(config, arrayMode, isOptional, squash) {
	    var defaultPolicy = [
	        { from: '', to: isOptional || arrayMode ? undefined : '' },
	        { from: null, to: isOptional || arrayMode ? undefined : '' },
	    ];
	    var replace = predicates_1.isArray(config.replace) ? config.replace : [];
	    if (predicates_1.isString(squash))
	        replace.push({ from: squash, to: undefined });
	    var configuredKeys = common_1.map(replace, hof_1.prop('from'));
	    return common_1.filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
	}
	var Param = /** @class */ (function () {
	    function Param(id, type, location, urlConfig, state) {
	        var config = getParamDeclaration(id, location, state);
	        type = getType(config, type, location, id, urlConfig.paramTypes);
	        var arrayMode = getArrayMode();
	        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
	        var isOptional = config.value !== undefined || location === DefType.SEARCH;
	        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
	        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
	        var squash = getSquashPolicy(config, isOptional, urlConfig.defaultSquashPolicy());
	        var replace = getReplace(config, arrayMode, isOptional, squash);
	        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
	        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	        function getArrayMode() {
	            var arrayDefaults = { array: location === DefType.SEARCH ? 'auto' : false };
	            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
	        }
	        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config });
	    }
	    Param.values = function (params, values) {
	        if (values === void 0) { values = {}; }
	        var paramValues = {};
	        for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
	            var param = params_1[_i];
	            paramValues[param.id] = param.value(values[param.id]);
	        }
	        return paramValues;
	    };
	    /**
	     * Finds [[Param]] objects which have different param values
	     *
	     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
	     *
	     * @param params: The list of Param objects to filter
	     * @param values1: The first set of parameter values
	     * @param values2: the second set of parameter values
	     *
	     * @returns any Param objects whose values were different between values1 and values2
	     */
	    Param.changed = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
	    };
	    /**
	     * Checks if two param value objects are equal (for a set of [[Param]] objects)
	     *
	     * @param params The list of [[Param]] objects to check
	     * @param values1 The first set of param values
	     * @param values2 The second set of param values
	     *
	     * @returns true if the param values in values1 and values2 are equal
	     */
	    Param.equals = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return Param.changed(params, values1, values2).length === 0;
	    };
	    /** Returns true if a the parameter values are valid, according to the Param definitions */
	    Param.validates = function (params, values) {
	        if (values === void 0) { values = {}; }
	        return params.map(function (param) { return param.validates(values[param.id]); }).reduce(common_1.allTrueR, true);
	    };
	    Param.prototype.isDefaultValue = function (value) {
	        return this.isOptional && this.type.equals(this.value(), value);
	    };
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    Param.prototype.value = function (value) {
	        var _this = this;
	        /**
	         * [Internal] Get the default value of a parameter, which may be an injectable function.
	         */
	        var getDefaultValue = function () {
	            if (_this._defaultValueCache)
	                return _this._defaultValueCache.defaultValue;
	            if (!coreservices_1.services.$injector)
	                throw new Error('Injectable functions cannot be called at configuration time');
	            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
	            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
	                throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
	            if (_this.config.$$fn['__cacheable']) {
	                _this._defaultValueCache = { defaultValue: defaultValue };
	            }
	            return defaultValue;
	        };
	        var replaceSpecialValues = function (val) {
	            for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
	                var tuple = _a[_i];
	                if (tuple.from === val)
	                    return tuple.to;
	            }
	            return val;
	        };
	        value = replaceSpecialValues(value);
	        return predicates_1.isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
	    };
	    Param.prototype.isSearch = function () {
	        return this.location === DefType.SEARCH;
	    };
	    Param.prototype.validates = function (value) {
	        // There was no parameter value, but the param is optional
	        if ((predicates_1.isUndefined(value) || value === null) && this.isOptional)
	            return true;
	        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
	        var normalized = this.type.$normalize(value);
	        if (!this.type.is(normalized))
	            return false;
	        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
	        var encoded = this.type.encode(normalized);
	        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
	    };
	    Param.prototype.toString = function () {
	        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
	    };
	    return Param;
	}());
	exports.Param = Param;
	//# sourceMappingURL=param.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TargetState = void 0;
	var predicates_1 = __webpack_require__(2);
	var strings_1 = __webpack_require__(6);
	var common_1 = __webpack_require__(4);
	/**
	 * Encapsulate the target (destination) state/params/options of a [[Transition]].
	 *
	 * This class is frequently used to redirect a transition to a new destination.
	 *
	 * See:
	 *
	 * - [[HookResult]]
	 * - [[TransitionHookFn]]
	 * - [[TransitionService.onStart]]
	 *
	 * To create a `TargetState`, use [[StateService.target]].
	 *
	 * ---
	 *
	 * This class wraps:
	 *
	 * 1) an identifier for a state
	 * 2) a set of parameters
	 * 3) and transition options
	 * 4) the registered state object (the [[StateDeclaration]])
	 *
	 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
	 * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
	 * The `TargetState` class normalizes those options.
	 *
	 * A `TargetState` may be valid (the state being targeted exists in the registry)
	 * or invalid (the state being targeted is not registered).
	 */
	var TargetState = /** @class */ (function () {
	    /**
	     * The TargetState constructor
	     *
	     * Note: Do not construct a `TargetState` manually.
	     * To create a `TargetState`, use the [[StateService.target]] factory method.
	     *
	     * @param _stateRegistry The StateRegistry to use to look up the _definition
	     * @param _identifier An identifier for a state.
	     *    Either a fully-qualified state name, or the object used to define the state.
	     * @param _params Parameters for the target state
	     * @param _options Transition options.
	     *
	     * @internal
	     */
	    function TargetState(_stateRegistry, _identifier, _params, _options) {
	        this._stateRegistry = _stateRegistry;
	        this._identifier = _identifier;
	        this._identifier = _identifier;
	        this._params = common_1.extend({}, _params || {});
	        this._options = common_1.extend({}, _options || {});
	        this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
	    }
	    /** The name of the state this object targets */
	    TargetState.prototype.name = function () {
	        return (this._definition && this._definition.name) || this._identifier;
	    };
	    /** The identifier used when creating this TargetState */
	    TargetState.prototype.identifier = function () {
	        return this._identifier;
	    };
	    /** The target parameter values */
	    TargetState.prototype.params = function () {
	        return this._params;
	    };
	    /** The internal state object (if it was found) */
	    TargetState.prototype.$state = function () {
	        return this._definition;
	    };
	    /** The internal state declaration (if it was found) */
	    TargetState.prototype.state = function () {
	        return this._definition && this._definition.self;
	    };
	    /** The target options */
	    TargetState.prototype.options = function () {
	        return this._options;
	    };
	    /** True if the target state was found */
	    TargetState.prototype.exists = function () {
	        return !!(this._definition && this._definition.self);
	    };
	    /** True if the object is valid */
	    TargetState.prototype.valid = function () {
	        return !this.error();
	    };
	    /** If the object is invalid, returns the reason why */
	    TargetState.prototype.error = function () {
	        var base = this.options().relative;
	        if (!this._definition && !!base) {
	            var stateName = base.name ? base.name : base;
	            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
	        }
	        if (!this._definition)
	            return "No such state '" + this.name() + "'";
	        if (!this._definition.self)
	            return "State '" + this.name() + "' has an invalid definition";
	    };
	    TargetState.prototype.toString = function () {
	        return "'" + this.name() + "'" + strings_1.stringify(this.params());
	    };
	    /**
	     * Returns a copy of this TargetState which targets a different state.
	     * The new TargetState has the same parameter values and transition options.
	     *
	     * @param state The new state that should be targeted
	     */
	    TargetState.prototype.withState = function (state) {
	        return new TargetState(this._stateRegistry, state, this._params, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified parameter values.
	     *
	     * @param params the new parameter values to use
	     * @param replace When false (default) the new parameter values will be merged with the current values.
	     *                When true the parameter values will be used instead of the current values.
	     */
	    TargetState.prototype.withParams = function (params, replace) {
	        if (replace === void 0) { replace = false; }
	        var newParams = replace ? params : common_1.extend({}, this._params, params);
	        return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified Transition Options.
	     *
	     * @param options the new options to use
	     * @param replace When false (default) the new options will be merged with the current options.
	     *                When true the options will be used instead of the current options.
	     */
	    TargetState.prototype.withOptions = function (options, replace) {
	        if (replace === void 0) { replace = false; }
	        var newOpts = replace ? options : common_1.extend({}, this._options, options);
	        return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
	    };
	    /** Returns true if the object has a state property that might be a state or state name */
	    TargetState.isDef = function (obj) {
	        return obj && obj.state && (predicates_1.isString(obj.state) || (predicates_1.isObject(obj.state) && predicates_1.isString(obj.state.name)));
	    };
	    return TargetState;
	}());
	exports.TargetState = TargetState;
	//# sourceMappingURL=targetState.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionHook = void 0;
	var interface_1 = __webpack_require__(11);
	var common_1 = __webpack_require__(1);
	var strings_1 = __webpack_require__(6);
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var trace_1 = __webpack_require__(9);
	var coreservices_1 = __webpack_require__(5);
	var rejectFactory_1 = __webpack_require__(12);
	var targetState_1 = __webpack_require__(17);
	var defaultOptions = {
	    current: common_1.noop,
	    transition: null,
	    traceData: {},
	    bind: null,
	};
	var TransitionHook = /** @class */ (function () {
	    function TransitionHook(transition, stateContext, registeredHook, options) {
	        var _this = this;
	        this.transition = transition;
	        this.stateContext = stateContext;
	        this.registeredHook = registeredHook;
	        this.options = options;
	        this.isSuperseded = function () { return _this.type.hookPhase === interface_1.TransitionHookPhase.RUN && !_this.options.transition.isActive(); };
	        this.options = common_1.defaults(options, defaultOptions);
	        this.type = registeredHook.eventType;
	    }
	    /**
	     * Chains together an array of TransitionHooks.
	     *
	     * Given a list of [[TransitionHook]] objects, chains them together.
	     * Each hook is invoked after the previous one completes.
	     *
	     * #### Example:
	     * ```js
	     * var hooks: TransitionHook[] = getHooks();
	     * let promise: Promise<any> = TransitionHook.chain(hooks);
	     *
	     * promise.then(handleSuccess, handleError);
	     * ```
	     *
	     * @param hooks the list of hooks to chain together
	     * @param waitFor if provided, the chain is `.then()`'ed off this promise
	     * @returns a `Promise` for sequentially invoking the hooks (in order)
	     */
	    TransitionHook.chain = function (hooks, waitFor) {
	        // Chain the next hook off the previous
	        var createHookChainR = function (prev, nextHook) { return prev.then(function () { return nextHook.invokeHook(); }); };
	        return hooks.reduce(createHookChainR, waitFor || coreservices_1.services.$q.when());
	    };
	    /**
	     * Invokes all the provided TransitionHooks, in order.
	     * Each hook's return value is checked.
	     * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
	     * If no hook returns a promise, then all hooks are processed synchronously.
	     *
	     * @param hooks the list of TransitionHooks to invoke
	     * @param doneCallback a callback that is invoked after all the hooks have successfully completed
	     *
	     * @returns a promise for the async result, or the result of the callback
	     */
	    TransitionHook.invokeHooks = function (hooks, doneCallback) {
	        for (var idx = 0; idx < hooks.length; idx++) {
	            var hookResult = hooks[idx].invokeHook();
	            if (predicates_1.isPromise(hookResult)) {
	                var remainingHooks = hooks.slice(idx + 1);
	                return TransitionHook.chain(remainingHooks, hookResult).then(doneCallback);
	            }
	        }
	        return doneCallback();
	    };
	    /**
	     * Run all TransitionHooks, ignoring their return value.
	     */
	    TransitionHook.runAllHooks = function (hooks) {
	        hooks.forEach(function (hook) { return hook.invokeHook(); });
	    };
	    TransitionHook.prototype.logError = function (err) {
	        this.transition.router.stateService.defaultErrorHandler()(err);
	    };
	    TransitionHook.prototype.invokeHook = function () {
	        var _this = this;
	        var hook = this.registeredHook;
	        if (hook._deregistered)
	            return;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        var options = this.options;
	        trace_1.trace.traceHookInvocation(this, this.transition, options);
	        var invokeCallback = function () { return hook.callback.call(options.bind, _this.transition, _this.stateContext); };
	        var normalizeErr = function (err) { return rejectFactory_1.Rejection.normalize(err).toPromise(); };
	        var handleError = function (err) { return hook.eventType.getErrorHandler(_this)(err); };
	        var handleResult = function (result) { return hook.eventType.getResultHandler(_this)(result); };
	        try {
	            var result = invokeCallback();
	            if (!this.type.synchronous && predicates_1.isPromise(result)) {
	                return result.catch(normalizeErr).then(handleResult, handleError);
	            }
	            else {
	                return handleResult(result);
	            }
	        }
	        catch (err) {
	            // If callback throws (synchronously)
	            return handleError(rejectFactory_1.Rejection.normalize(err));
	        }
	        finally {
	            if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) {
	                hook.deregister();
	            }
	        }
	    };
	    /**
	     * This method handles the return value of a Transition Hook.
	     *
	     * A hook can return false (cancel), a TargetState (redirect),
	     * or a promise (which may later resolve to false or a redirect)
	     *
	     * This also handles "transition superseded" -- when a new transition
	     * was started while the hook was still running
	     */
	    TransitionHook.prototype.handleHookResult = function (result) {
	        var _this = this;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        // Hook returned a promise
	        if (predicates_1.isPromise(result)) {
	            // Wait for the promise, then reprocess with the resulting value
	            return result.then(function (val) { return _this.handleHookResult(val); });
	        }
	        trace_1.trace.traceHookResult(result, this.transition, this.options);
	        // Hook returned false
	        if (result === false) {
	            // Abort this Transition
	            return rejectFactory_1.Rejection.aborted('Hook aborted transition').toPromise();
	        }
	        var isTargetState = hof_1.is(targetState_1.TargetState);
	        // hook returned a TargetState
	        if (isTargetState(result)) {
	            // Halt the current Transition and redirect (a new Transition) to the TargetState.
	            return rejectFactory_1.Rejection.redirected(result).toPromise();
	        }
	    };
	    /**
	     * Return a Rejection promise if the transition is no longer current due
	     * to a stopped router (disposed), or a new transition has started and superseded this one.
	     */
	    TransitionHook.prototype.getNotCurrentRejection = function () {
	        var router = this.transition.router;
	        // The router is stopped
	        if (router._disposed) {
	            return rejectFactory_1.Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
	        }
	        if (this.transition._aborted) {
	            return rejectFactory_1.Rejection.aborted().toPromise();
	        }
	        // This transition is no longer current.
	        // Another transition started while this hook was still running.
	        if (this.isSuperseded()) {
	            // Abort this transition
	            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
	        }
	    };
	    TransitionHook.prototype.toString = function () {
	        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.fnToString(registeredHook.callback);
	        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
	    };
	    /**
	     * These GetResultHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.HANDLE_RESULT = function (hook) { return function (result) {
	        return hook.handleHookResult(result);
	    }; };
	    /**
	     * If the result is a promise rejection, log it.
	     * Otherwise, ignore the result.
	     */
	    TransitionHook.LOG_REJECTED_RESULT = function (hook) { return function (result) {
	        predicates_1.isPromise(result) && result.catch(function (err) { return hook.logError(rejectFactory_1.Rejection.normalize(err)); });
	        return undefined;
	    }; };
	    /**
	     * These GetErrorHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.LOG_ERROR = function (hook) { return function (error) { return hook.logError(error); }; };
	    TransitionHook.REJECT_ERROR = function (hook) { return function (error) { return common_1.silentRejection(error); }; };
	    TransitionHook.THROW_ERROR = function (hook) { return function (error) {
	        throw error;
	    }; };
	    return TransitionHook;
	}());
	exports.TransitionHook = TransitionHook;
	//# sourceMappingURL=transitionHook.js.map

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PathUtils = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var targetState_1 = __webpack_require__(17);
	var pathNode_1 = __webpack_require__(39);
	/**
	 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
	 */
	var PathUtils = /** @class */ (function () {
	    function PathUtils() {
	    }
	    /** Given a PathNode[], create an TargetState */
	    PathUtils.makeTargetState = function (registry, path) {
	        var state = common_1.tail(path).state;
	        return new targetState_1.TargetState(registry, state, path.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}), {});
	    };
	    PathUtils.buildPath = function (targetState) {
	        var toParams = targetState.params();
	        return targetState.$state().path.map(function (state) { return new pathNode_1.PathNode(state).applyRawParams(toParams); });
	    };
	    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
	    PathUtils.buildToPath = function (fromPath, targetState) {
	        var toPath = PathUtils.buildPath(targetState);
	        if (targetState.options().inherit) {
	            return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
	        }
	        return toPath;
	    };
	    /**
	     * Creates ViewConfig objects and adds to nodes.
	     *
	     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
	     */
	    PathUtils.applyViewConfigs = function ($view, path, states) {
	        // Only apply the viewConfigs to the nodes for the given states
	        path
	            .filter(function (node) { return common_1.inArray(states, node.state); })
	            .forEach(function (node) {
	            var viewDecls = common_1.values(node.state.views || {});
	            var subPath = PathUtils.subPath(path, function (n) { return n === node; });
	            var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
	            node.views = viewConfigs.reduce(common_1.unnestR, []);
	        });
	    };
	    /**
	     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
	     *
	     * For a parameter in a node to be inherited from the from path:
	     * - The toPath's node must have a matching node in the fromPath (by state).
	     * - The parameter name must not be found in the toKeys parameter array.
	     *
	     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
	     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
	     * it is not inherited from the fromPath.
	     */
	    PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
	        if (toKeys === void 0) { toKeys = []; }
	        function nodeParamVals(path, state) {
	            var node = common_1.find(path, hof_1.propEq('state', state));
	            return common_1.extend({}, node && node.paramValues);
	        }
	        var noInherit = fromPath
	            .map(function (node) { return node.paramSchema; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (param) { return !param.inherit; })
	            .map(hof_1.prop('id'));
	        /**
	         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
	         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
	         */
	        function makeInheritedParamsNode(toNode) {
	            // All param values for the node (may include default key/vals, when key was not found in toParams)
	            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
	            // limited to only those keys found in toParams
	            var incomingParamVals = common_1.pick(toParamVals, toKeys);
	            toParamVals = common_1.omit(toParamVals, toKeys);
	            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
	            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
	            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
	            return new pathNode_1.PathNode(toNode.state).applyRawParams(ownParamVals);
	        }
	        // The param keys specified by the incoming toParams
	        return toPath.map(makeInheritedParamsNode);
	    };
	    /**
	     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
	     */
	    PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
	        var max = Math.min(fromPath.length, toPath.length);
	        var keep = 0;
	        var nodesMatch = function (node1, node2) { return node1.equals(node2, PathUtils.nonDynamicParams); };
	        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
	            keep++;
	        }
	        /** Given a retained node, return a new node which uses the to node's param values */
	        function applyToParams(retainedNode, idx) {
	            var cloned = retainedNode.clone();
	            cloned.paramValues = toPath[idx].paramValues;
	            return cloned;
	        }
	        var from, retained, exiting, entering, to;
	        from = fromPath;
	        retained = from.slice(0, keep);
	        exiting = from.slice(keep);
	        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
	        var retainedWithToParams = retained.map(applyToParams);
	        entering = toPath.slice(keep);
	        to = retainedWithToParams.concat(entering);
	        return { from: from, to: to, retained: retained, retainedWithToParams: retainedWithToParams, exiting: exiting, entering: entering };
	    };
	    /**
	     * Returns a new path which is: the subpath of the first path which matches the second path.
	     *
	     * The new path starts from root and contains any nodes that match the nodes in the second path.
	     * It stops before the first non-matching node.
	     *
	     * Nodes are compared using their state property and their parameter values.
	     * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
	     *
	     * @param pathA the first path
	     * @param pathB the second path
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     *
	     * @returns an array of PathNodes from the first path which match the nodes in the second path
	     */
	    PathUtils.matching = function (pathA, pathB, paramsFn) {
	        var done = false;
	        var tuples = common_1.arrayTuples(pathA, pathB);
	        return tuples.reduce(function (matching, _a) {
	            var nodeA = _a[0], nodeB = _a[1];
	            done = done || !nodeA.equals(nodeB, paramsFn);
	            return done ? matching : matching.concat(nodeA);
	        }, []);
	    };
	    /**
	     * Returns true if two paths are identical.
	     *
	     * @param pathA
	     * @param pathB
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     * @returns true if the the states and parameter values for both paths are identical
	     */
	    PathUtils.equals = function (pathA, pathB, paramsFn) {
	        return pathA.length === pathB.length && PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
	    };
	    /**
	     * Return a subpath of a path, which stops at the first matching node
	     *
	     * Given an array of nodes, returns a subset of the array starting from the first node,
	     * stopping when the first node matches the predicate.
	     *
	     * @param path a path of [[PathNode]]s
	     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
	     * @returns a subpath up to the matching node, or undefined if no match is found
	     */
	    PathUtils.subPath = function (path, predicate) {
	        var node = common_1.find(path, predicate);
	        var elementIdx = path.indexOf(node);
	        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
	    };
	    PathUtils.nonDynamicParams = function (node) {
	        return node.state.parameters({ inherit: false }).filter(function (param) { return !param.dynamic; });
	    };
	    /** Gets the raw parameter values from a path */
	    PathUtils.paramValues = function (path) { return path.reduce(function (acc, node) { return common_1.extend(acc, node.paramValues); }, {}); };
	    return PathUtils;
	}());
	exports.PathUtils = PathUtils;
	//# sourceMappingURL=pathUtils.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Resolvable = exports.defaultResolvePolicy = void 0;
	var common_1 = __webpack_require__(1);
	var coreservices_1 = __webpack_require__(5);
	var trace_1 = __webpack_require__(9);
	var strings_1 = __webpack_require__(6);
	var predicates_1 = __webpack_require__(2);
	var predicates_2 = __webpack_require__(2);
	// TODO: explicitly make this user configurable
	exports.defaultResolvePolicy = {
	    when: 'LAZY',
	    async: 'WAIT',
	};
	/**
	 * The basic building block for the resolve system.
	 *
	 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
	 * and the unwrapped-when-complete (.data) result of the resolveFn.
	 *
	 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
	 * resolveFn) and returns the resulting promise.
	 *
	 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
	 * parameter to those fns.
	 */
	var Resolvable = /** @class */ (function () {
	    function Resolvable(arg1, resolveFn, deps, policy, data) {
	        this.resolved = false;
	        this.promise = undefined;
	        if (arg1 instanceof Resolvable) {
	            common_1.extend(this, arg1);
	        }
	        else if (predicates_1.isFunction(resolveFn)) {
	            if (predicates_2.isNullOrUndefined(arg1))
	                throw new Error('new Resolvable(): token argument is required');
	            if (!predicates_1.isFunction(resolveFn))
	                throw new Error('new Resolvable(): resolveFn argument must be a function');
	            this.token = arg1;
	            this.policy = policy;
	            this.resolveFn = resolveFn;
	            this.deps = deps || [];
	            this.data = data;
	            this.resolved = data !== undefined;
	            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
	        }
	        else if (predicates_1.isObject(arg1) && arg1.token && (arg1.hasOwnProperty('resolveFn') || arg1.hasOwnProperty('data'))) {
	            var literal = arg1;
	            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
	        }
	    }
	    Resolvable.prototype.getPolicy = function (state) {
	        var thisPolicy = this.policy || {};
	        var statePolicy = (state && state.resolvePolicy) || {};
	        return {
	            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
	            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async,
	        };
	    };
	    /**
	     * Asynchronously resolve this Resolvable's data
	     *
	     * Given a ResolveContext that this Resolvable is found in:
	     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
	     * and update the Resolvable's state
	     */
	    Resolvable.prototype.resolve = function (resolveContext, trans) {
	        var _this = this;
	        var $q = coreservices_1.services.$q;
	        // Gets all dependencies from ResolveContext and wait for them to be resolved
	        var getResolvableDependencies = function () {
	            return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) { return resolvable.get(resolveContext, trans); }));
	        };
	        // Invokes the resolve function passing the resolved dependencies as arguments
	        var invokeResolveFn = function (resolvedDeps) { return _this.resolveFn.apply(null, resolvedDeps); };
	        var node = resolveContext.findNode(this);
	        var state = node && node.state;
	        var asyncPolicy = this.getPolicy(state).async;
	        var customAsyncPolicy = predicates_1.isFunction(asyncPolicy) ? asyncPolicy : common_1.identity;
	        // After the final value has been resolved, update the state of the Resolvable
	        var applyResolvedValue = function (resolvedValue) {
	            _this.data = resolvedValue;
	            _this.resolved = true;
	            _this.resolveFn = null;
	            trace_1.trace.traceResolvableResolved(_this, trans);
	            return _this.data;
	        };
	        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
	        return (this.promise = $q
	            .when()
	            .then(getResolvableDependencies)
	            .then(invokeResolveFn)
	            .then(customAsyncPolicy)
	            .then(applyResolvedValue));
	    };
	    /**
	     * Gets a promise for this Resolvable's data.
	     *
	     * Fetches the data and returns a promise.
	     * Returns the existing promise if it has already been fetched once.
	     */
	    Resolvable.prototype.get = function (resolveContext, trans) {
	        return this.promise || this.resolve(resolveContext, trans);
	    };
	    Resolvable.prototype.toString = function () {
	        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
	    };
	    Resolvable.prototype.clone = function () {
	        return new Resolvable(this);
	    };
	    Resolvable.fromData = function (token, data) { return new Resolvable(token, function () { return data; }, null, null, data); };
	    return Resolvable;
	}());
	exports.Resolvable = Resolvable;
	//# sourceMappingURL=resolvable.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ResolveContext = exports.NATIVE_INJECTOR_TOKEN = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var trace_1 = __webpack_require__(9);
	var coreservices_1 = __webpack_require__(5);
	var interface_1 = __webpack_require__(54);
	var resolvable_1 = __webpack_require__(22);
	var pathUtils_1 = __webpack_require__(21);
	var strings_1 = __webpack_require__(6);
	var common_2 = __webpack_require__(4);
	var whens = interface_1.resolvePolicies.when;
	var ALL_WHENS = [whens.EAGER, whens.LAZY];
	var EAGER_WHENS = [whens.EAGER];
	// tslint:disable-next-line:no-inferrable-types
	exports.NATIVE_INJECTOR_TOKEN = 'Native Injector';
	/**
	 * Encapsulates Dependency Injection for a path of nodes
	 *
	 * UI-Router states are organized as a tree.
	 * A nested state has a path of ancestors to the root of the tree.
	 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
	 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
	 *
	 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
	 */
	var ResolveContext = /** @class */ (function () {
	    function ResolveContext(_path) {
	        this._path = _path;
	    }
	    /** Gets all the tokens found in the resolve context, de-duplicated */
	    ResolveContext.prototype.getTokens = function () {
	        return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(common_1.uniqR, []);
	    };
	    /**
	     * Gets the Resolvable that matches the token
	     *
	     * Gets the last Resolvable that matches the token in this context, or undefined.
	     * Throws an error if it doesn't exist in the ResolveContext
	     */
	    ResolveContext.prototype.getResolvable = function (token) {
	        var matching = this._path
	            .map(function (node) { return node.resolvables; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (r) { return r.token === token; });
	        return common_1.tail(matching);
	    };
	    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
	    ResolveContext.prototype.getPolicy = function (resolvable) {
	        var node = this.findNode(resolvable);
	        return resolvable.getPolicy(node.state);
	    };
	    /**
	     * Returns a ResolveContext that includes a portion of this one
	     *
	     * Given a state, this method creates a new ResolveContext from this one.
	     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
	     *
	     * #### Why
	     *
	     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
	     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
	     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
	     * This method is used to create a narrower context when injecting ancestor nodes.
	     *
	     * @example
	     * `let ABCD = new ResolveContext([A, B, C, D]);`
	     *
	     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
	     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
	     * However, `B` should only be able to access resolvables from `A`, `B`.
	     *
	     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
	     * `let AB = ABCD.subcontext(a)`
	     */
	    ResolveContext.prototype.subContext = function (state) {
	        return new ResolveContext(pathUtils_1.PathUtils.subPath(this._path, function (node) { return node.state === state; }));
	    };
	    /**
	     * Adds Resolvables to the node that matches the state
	     *
	     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
	     * The resolvable is added to the node matching the `state` parameter.
	     *
	     * These new resolvables are not automatically fetched.
	     * The calling code should either fetch them, fetch something that depends on them,
	     * or rely on [[resolvePath]] being called when some state is being entered.
	     *
	     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
	     *
	     * @param newResolvables the new Resolvables
	     * @param state Used to find the node to put the resolvable on
	     */
	    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
	        var node = common_1.find(this._path, hof_1.propEq('state', state));
	        var keys = newResolvables.map(function (r) { return r.token; });
	        node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
	    };
	    /**
	     * Returns a promise for an array of resolved path Element promises
	     *
	     * @param when
	     * @param trans
	     * @returns {Promise<any>|any}
	     */
	    ResolveContext.prototype.resolvePath = function (when, trans) {
	        var _this = this;
	        if (when === void 0) { when = 'LAZY'; }
	        // This option determines which 'when' policy Resolvables we are about to fetch.
	        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : 'LAZY';
	        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
	        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
	        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
	        // get the subpath to the state argument, if provided
	        trace_1.trace.traceResolvePath(this._path, when, trans);
	        var matchesPolicy = function (acceptedVals, whenOrAsync) { return function (resolvable) {
	            return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
	        }; };
	        // Trigger all the (matching) Resolvables in the path
	        // Reduce all the "WAIT" Resolvables into an array
	        var promises = this._path.reduce(function (acc, node) {
	            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
	            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
	            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
	            // For the matching Resolvables, start their async fetch process.
	            var subContext = _this.subContext(node.state);
	            var getResult = function (r) {
	                return r
	                    .get(subContext, trans)
	                    // Return a tuple that includes the Resolvable's token
	                    .then(function (value) { return ({ token: r.token, value: value }); });
	            };
	            nowait.forEach(getResult);
	            return acc.concat(wait.map(getResult));
	        }, []);
	        // Wait for all the "WAIT" resolvables
	        return coreservices_1.services.$q.all(promises);
	    };
	    ResolveContext.prototype.injector = function () {
	        return this._injector || (this._injector = new UIInjectorImpl(this));
	    };
	    ResolveContext.prototype.findNode = function (resolvable) {
	        return common_1.find(this._path, function (node) { return common_1.inArray(node.resolvables, resolvable); });
	    };
	    /**
	     * Gets the async dependencies of a Resolvable
	     *
	     * Given a Resolvable, returns its dependencies as a Resolvable[]
	     */
	    ResolveContext.prototype.getDependencies = function (resolvable) {
	        var _this = this;
	        var node = this.findNode(resolvable);
	        // Find which other resolvables are "visible" to the `resolvable` argument
	        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
	        var subPath = pathUtils_1.PathUtils.subPath(this._path, function (x) { return x === node; }) || this._path;
	        var availableResolvables = subPath
	            .reduce(function (acc, _node) { return acc.concat(_node.resolvables); }, []) // all of subpath's resolvables
	            .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
	        var getDependency = function (token) {
	            var matching = availableResolvables.filter(function (r) { return r.token === token; });
	            if (matching.length)
	                return common_1.tail(matching);
	            var fromInjector = _this.injector().getNative(token);
	            if (common_2.isUndefined(fromInjector)) {
	                throw new Error('Could not find Dependency Injection token: ' + strings_1.stringify(token));
	            }
	            return new resolvable_1.Resolvable(token, function () { return fromInjector; }, [], fromInjector);
	        };
	        return resolvable.deps.map(getDependency);
	    };
	    return ResolveContext;
	}());
	exports.ResolveContext = ResolveContext;
	/** @internal */
	var UIInjectorImpl = /** @class */ (function () {
	    function UIInjectorImpl(context) {
	        this.context = context;
	        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
	    }
	    UIInjectorImpl.prototype.get = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable) {
	            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
	                return resolvable.get(this.context);
	            }
	            if (!resolvable.resolved) {
	                throw new Error('Resolvable async .get() not complete:' + strings_1.stringify(resolvable.token));
	            }
	            return resolvable.data;
	        }
	        return this.getNative(token);
	    };
	    UIInjectorImpl.prototype.getAsync = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable)
	            return resolvable.get(this.context);
	        return coreservices_1.services.$q.when(this.native.get(token));
	    };
	    UIInjectorImpl.prototype.getNative = function (token) {
	        return this.native && this.native.get(token);
	    };
	    return UIInjectorImpl;
	}());
	//# sourceMappingURL=resolveContext.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcher = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var param_1 = __webpack_require__(16);
	var strings_1 = __webpack_require__(6);
	var common_2 = __webpack_require__(4);
	function quoteRegExp(str, param) {
	    var surroundPattern = ['', ''], result = str.replace(/[\\\[\]\^$*+?.()|{}]/g, '\\$&');
	    if (!param)
	        return result;
	    switch (param.squash) {
	        case false:
	            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
	            break;
	        case true:
	            result = result.replace(/\/$/, '');
	            surroundPattern = ['(?:/(', ')|/)?'];
	            break;
	        default:
	            surroundPattern = ["(" + param.squash + "|", ')?'];
	            break;
	    }
	    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
	}
	var memoizeTo = function (obj, _prop, fn) { return (obj[_prop] = obj[_prop] || fn()); };
	var splitOnSlash = strings_1.splitOnDelim('/');
	var defaultConfig = {
	    state: { params: {} },
	    strict: true,
	    caseInsensitive: true,
	    decodeParams: true,
	};
	/**
	 * Matches URLs against patterns.
	 *
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL.
	 *
	 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
	 * parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by [[UrlMatcher.exec]].
	 *
	 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
	 * or colon placeholders (`/somePath/:param`).
	 *
	 * - *A parameter RegExp* may be defined for a param after a colon
	 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
	 * The regexp must match for the url to be matched.
	 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
	 *
	 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
	 *   See [[UrlMatcherFactory.type]] for more information.
	 *
	 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
	 *   A catch-all * parameter value will contain the remainder of the URL.
	 *
	 * ---
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters).
	 * A path parameter matches any number of characters other than '/'. For catch-all
	 * placeholders the path parameter matches any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 */
	var UrlMatcher = /** @class */ (function () {
	    /**
	     * @param pattern The pattern to compile into a matcher.
	     * @param paramTypes The [[ParamTypes]] registry
	     * @param paramFactory A [[ParamFactory]] object
	     * @param config  A [[UrlMatcherCompileConfig]] configuration object
	     */
	    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
	        var _this = this;
	        /** @internal */
	        this._cache = { path: [this] };
	        /** @internal */
	        this._children = [];
	        /** @internal */
	        this._params = [];
	        /** @internal */
	        this._segments = [];
	        /** @internal */
	        this._compiled = [];
	        this.config = config = common_2.defaults(config, defaultConfig);
	        this.pattern = pattern;
	        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	        //   '*' name
	        //   ':' name
	        //   '{' name '}'
	        //   '{' name ':' regexp '}'
	        // The regular expression is somewhat complicated due to the need to allow curly braces
	        // inside the regular expression. The placeholder regexp breaks down as follows:
	        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	        //    [^{}\\]+                       - anything other than curly braces or backslash
	        //    \\.                            - a backslash escape
	        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var patterns = [];
	        var last = 0;
	        var matchArray;
	        var checkParamErrors = function (id) {
	            if (!UrlMatcher.nameValidator.test(id))
	                throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	            if (common_1.find(_this._params, hof_1.propEq('id', id)))
	                throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	        };
	        // Split into static segments separated by path parameter placeholders.
	        // The number of segments is always 1 more than the number of parameters.
	        var matchDetails = function (m, isSearch) {
	            // IE[78] returns '' for unmatched groups instead of null
	            var id = m[2] || m[3];
	            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '[\\s\\S]*' : null);
	            var makeRegexpType = function (str) {
	                return common_1.inherit(paramTypes.type(isSearch ? 'query' : 'path'), {
	                    pattern: new RegExp(str, _this.config.caseInsensitive ? 'i' : undefined),
	                });
	            };
	            return {
	                id: id,
	                regexp: regexp,
	                segment: pattern.substring(last, m.index),
	                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp),
	            };
	        };
	        var details;
	        var segment;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((matchArray = placeholder.exec(pattern))) {
	            details = matchDetails(matchArray, false);
	            if (details.segment.indexOf('?') >= 0)
	                break; // we're into the search part
	            checkParamErrors(details.id);
	            this._params.push(paramFactory.fromPath(details.id, details.type, config.state));
	            this._segments.push(details.segment);
	            patterns.push([details.segment, common_1.tail(this._params)]);
	            last = placeholder.lastIndex;
	        }
	        segment = pattern.substring(last);
	        // Find any search parameter names and remove them from the last segment
	        var i = segment.indexOf('?');
	        if (i >= 0) {
	            var search = segment.substring(i);
	            segment = segment.substring(0, i);
	            if (search.length > 0) {
	                last = 0;
	                // tslint:disable-next-line:no-conditional-assignment
	                while ((matchArray = searchPlaceholder.exec(search))) {
	                    details = matchDetails(matchArray, true);
	                    checkParamErrors(details.id);
	                    this._params.push(paramFactory.fromSearch(details.id, details.type, config.state));
	                    last = placeholder.lastIndex;
	                    // check if ?&
	                }
	            }
	        }
	        this._segments.push(segment);
	        this._compiled = patterns.map(function (_pattern) { return quoteRegExp.apply(null, _pattern); }).concat(quoteRegExp(segment));
	    }
	    /** @internal */
	    UrlMatcher.encodeDashes = function (str) {
	        // Replace dashes with encoded "\-"
	        return encodeURIComponent(str).replace(/-/g, function (c) { return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase(); });
	    };
	    /** @internal Given a matcher, return an array with the matcher's path segments and path params, in order */
	    UrlMatcher.pathSegmentsAndParams = function (matcher) {
	        var staticSegments = matcher._segments;
	        var pathParams = matcher._params.filter(function (p) { return p.location === param_1.DefType.PATH; });
	        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined))
	            .reduce(common_1.unnestR, [])
	            .filter(function (x) { return x !== '' && predicates_1.isDefined(x); });
	    };
	    /** @internal Given a matcher, return an array with the matcher's query params */
	    UrlMatcher.queryParams = function (matcher) {
	        return matcher._params.filter(function (p) { return p.location === param_1.DefType.SEARCH; });
	    };
	    /**
	     * Compare two UrlMatchers
	     *
	     * This comparison function converts a UrlMatcher into static and dynamic path segments.
	     * Each static path segment is a static string between a path separator (slash character).
	     * Each dynamic segment is a path parameter.
	     *
	     * The comparison function sorts static segments before dynamic ones.
	     */
	    UrlMatcher.compare = function (a, b) {
	        /**
	         * Turn a UrlMatcher and all its parent matchers into an array
	         * of slash literals '/', string literals, and Param objects
	         *
	         * This example matcher matches strings like "/foo/:param/tail":
	         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
	         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
	         *
	         * Caches the result as `matcher._cache.segments`
	         */
	        var segments = function (matcher) {
	            return (matcher._cache.segments =
	                matcher._cache.segments ||
	                    matcher._cache.path
	                        .map(UrlMatcher.pathSegmentsAndParams)
	                        .reduce(common_1.unnestR, [])
	                        .reduce(strings_1.joinNeighborsR, [])
	                        .map(function (x) { return (predicates_1.isString(x) ? splitOnSlash(x) : x); })
	                        .reduce(common_1.unnestR, []));
	        };
	        /**
	         * Gets the sort weight for each segment of a UrlMatcher
	         *
	         * Caches the result as `matcher._cache.weights`
	         */
	        var weights = function (matcher) {
	            return (matcher._cache.weights =
	                matcher._cache.weights ||
	                    segments(matcher).map(function (segment) {
	                        // Sort slashes first, then static strings, the Params
	                        if (segment === '/')
	                            return 1;
	                        if (predicates_1.isString(segment))
	                            return 2;
	                        if (segment instanceof param_1.Param)
	                            return 3;
	                    }));
	        };
	        /**
	         * Pads shorter array in-place (mutates)
	         */
	        var padArrays = function (l, r, padVal) {
	            var len = Math.max(l.length, r.length);
	            while (l.length < len)
	                l.push(padVal);
	            while (r.length < len)
	                r.push(padVal);
	        };
	        var weightsA = weights(a), weightsB = weights(b);
	        padArrays(weightsA, weightsB, 0);
	        var _pairs = common_1.arrayTuples(weightsA, weightsB);
	        var cmp, i;
	        for (i = 0; i < _pairs.length; i++) {
	            cmp = _pairs[i][0] - _pairs[i][1];
	            if (cmp !== 0)
	                return cmp;
	        }
	        return 0;
	    };
	    /**
	     * Creates a new concatenated UrlMatcher
	     *
	     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
	     *
	     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
	     */
	    UrlMatcher.prototype.append = function (url) {
	        this._children.push(url);
	        url._cache = {
	            path: this._cache.path.concat(url),
	            parent: this,
	            pattern: null,
	        };
	        return url;
	    };
	    /** @internal */
	    UrlMatcher.prototype.isRoot = function () {
	        return this._cache.path[0] === this;
	    };
	    /** Returns the input pattern string */
	    UrlMatcher.prototype.toString = function () {
	        return this.pattern;
	    };
	    UrlMatcher.prototype._getDecodedParamValue = function (value, param) {
	        if (predicates_1.isDefined(value)) {
	            if (this.config.decodeParams && !param.type.raw) {
	                if (predicates_1.isArray(value)) {
	                    value = value.map(function (paramValue) { return decodeURIComponent(paramValue); });
	                }
	                else {
	                    value = decodeURIComponent(value);
	                }
	            }
	            value = param.type.decode(value);
	        }
	        return param.value(value);
	    };
	    /**
	     * Tests the specified url/path against this matcher.
	     *
	     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
	     * parameter values.  Returns null if the path does not match.
	     *
	     * The returned object contains the values
	     * of any search parameters that are mentioned in the pattern, but their value may be null if
	     * they are not present in `search`. This means that search parameters are always treated
	     * as optional.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	     *   x: '1', q: 'hello'
	     * });
	     * // returns { id: 'bob', q: 'hello', r: null }
	     * ```
	     *
	     * @param path    The URL path to match, e.g. `$location.path()`.
	     * @param search  URL search parameters, e.g. `$location.search()`.
	     * @param hash    URL hash e.g. `$location.hash()`.
	     * @param options
	     *
	     * @returns The captured parameter values.
	     */
	    UrlMatcher.prototype.exec = function (path, search, hash, options) {
	        var _this = this;
	        if (search === void 0) { search = {}; }
	        if (options === void 0) { options = {}; }
	        var match = memoizeTo(this._cache, 'pattern', function () {
	            return new RegExp([
	                '^',
	                common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''),
	                _this.config.strict === false ? '/?' : '',
	                '$',
	            ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
	        }).exec(path);
	        if (!match)
	            return null;
	        // options = defaults(options, { isolate: false });
	        var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
	        if (nPathSegments !== match.length - 1)
	            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
	        function decodePathArray(paramVal) {
	            var reverseString = function (str) { return str.split('').reverse().join(''); };
	            var unquoteDashes = function (str) { return str.replace(/\\-/g, '-'); };
	            var split = reverseString(paramVal).split(/-(?!\\)/);
	            var allReversed = common_1.map(split, reverseString);
	            return common_1.map(allReversed, unquoteDashes).reverse();
	        }
	        for (var i = 0; i < nPathSegments; i++) {
	            var param = pathParams[i];
	            var value = match[i + 1];
	            // if the param value matches a pre-replace pair, replace the value before decoding.
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            if (value && param.array === true)
	                value = decodePathArray(value);
	            values[param.id] = this._getDecodedParamValue(value, param);
	        }
	        searchParams.forEach(function (param) {
	            var value = search[param.id];
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            values[param.id] = _this._getDecodedParamValue(value, param);
	        });
	        if (hash)
	            values['#'] = hash;
	        return values;
	    };
	    /**
	     * @internal
	     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
	     *
	     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
	     *    pattern has no parameters, an empty array is returned.
	     */
	    UrlMatcher.prototype.parameters = function (opts) {
	        if (opts === void 0) { opts = {}; }
	        if (opts.inherit === false)
	            return this._params;
	        return common_1.unnest(this._cache.path.map(function (matcher) { return matcher._params; }));
	    };
	    /**
	     * @internal
	     * Returns a single parameter from this UrlMatcher by id
	     *
	     * @param id
	     * @param opts
	     * @returns {T|Param|any|boolean|UrlMatcher|null}
	     */
	    UrlMatcher.prototype.parameter = function (id, opts) {
	        var _this = this;
	        if (opts === void 0) { opts = {}; }
	        var findParam = function () {
	            for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
	                var param = _a[_i];
	                if (param.id === id)
	                    return param;
	            }
	        };
	        var parent = this._cache.parent;
	        return findParam() || (opts.inherit !== false && parent && parent.parameter(id, opts)) || null;
	    };
	    /**
	     * Validates the input parameter values against this UrlMatcher
	     *
	     * Checks an object hash of parameters to validate their correctness according to the parameter
	     * types of this `UrlMatcher`.
	     *
	     * @param params The object hash of parameters to validate.
	     * @returns Returns `true` if `params` validates, otherwise `false`.
	     */
	    UrlMatcher.prototype.validates = function (params) {
	        var validParamVal = function (param, val) { return !param || param.validates(val); };
	        params = params || {};
	        // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
	        var paramSchema = this.parameters().filter(function (paramDef) { return params.hasOwnProperty(paramDef.id); });
	        return paramSchema.map(function (paramDef) { return validParamVal(paramDef, params[paramDef.id]); }).reduce(common_1.allTrueR, true);
	    };
	    /**
	     * Given a set of parameter values, creates a URL from this UrlMatcher.
	     *
	     * Creates a URL that matches this pattern by substituting the specified values
	     * for the path and search parameters.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	     * // returns '/user/bob?q=yes'
	     * ```
	     *
	     * @param values  the values to substitute for the parameters in this pattern.
	     * @returns the formatted URL (path and optionally search part).
	     */
	    UrlMatcher.prototype.format = function (values) {
	        if (values === void 0) { values = {}; }
	        // Build the full path of UrlMatchers (including all parent UrlMatchers)
	        var urlMatchers = this._cache.path;
	        // Extract all the static segments and Params (processed as ParamDetails)
	        // into an ordered array
	        var pathSegmentsAndParams = urlMatchers
	            .map(UrlMatcher.pathSegmentsAndParams)
	            .reduce(common_1.unnestR, [])
	            .map(function (x) { return (predicates_1.isString(x) ? x : getDetails(x)); });
	        // Extract the query params into a separate array
	        var queryParams = urlMatchers
	            .map(UrlMatcher.queryParams)
	            .reduce(common_1.unnestR, [])
	            .map(getDetails);
	        var isInvalid = function (param) { return param.isValid === false; };
	        if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
	            return null;
	        }
	        /**
	         * Given a Param, applies the parameter value, then returns detailed information about it
	         */
	        function getDetails(param) {
	            // Normalize to typed value
	            var value = param.value(values[param.id]);
	            var isValid = param.validates(value);
	            var isDefaultValue = param.isDefaultValue(value);
	            // Check if we're in squash mode for the parameter
	            var squash = isDefaultValue ? param.squash : false;
	            // Allow the Parameter's Type to encode the value
	            var encoded = param.type.encode(value);
	            return { param: param, value: value, isValid: isValid, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
	        }
	        // Build up the path-portion from the list of static segments and parameters
	        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
	            // The element is a static segment (a raw string); just append it
	            if (predicates_1.isString(x))
	                return acc + x;
	            // Otherwise, it's a ParamDetails.
	            var squash = x.squash, encoded = x.encoded, param = x.param;
	            // If squash is === true, try to remove a slash from the path
	            if (squash === true)
	                return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
	            // If squash is a string, use the string for the param value
	            if (predicates_1.isString(squash))
	                return acc + squash;
	            if (squash !== false)
	                return acc; // ?
	            if (encoded == null)
	                return acc;
	            // If this parameter value is an array, encode the value using encodeDashes
	            if (predicates_1.isArray(encoded))
	                return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join('-');
	            // If the parameter type is "raw", then do not encodeURIComponent
	            if (param.raw)
	                return acc + encoded;
	            // Encode the value
	            return acc + encodeURIComponent(encoded);
	        }, '');
	        // Build the query string by applying parameter values (array or regular)
	        // then mapping to key=value, then flattening and joining using "&"
	        var queryString = queryParams
	            .map(function (paramDetails) {
	            var param = paramDetails.param, squash = paramDetails.squash, encoded = paramDetails.encoded, isDefaultValue = paramDetails.isDefaultValue;
	            if (encoded == null || (isDefaultValue && squash !== false))
	                return;
	            if (!predicates_1.isArray(encoded))
	                encoded = [encoded];
	            if (encoded.length === 0)
	                return;
	            if (!param.raw)
	                encoded = common_1.map(encoded, encodeURIComponent);
	            return encoded.map(function (val) { return param.id + "=" + val; });
	        })
	            .filter(common_1.identity)
	            .reduce(common_1.unnestR, [])
	            .join('&');
	        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
	        return pathString + (queryString ? "?" + queryString : '') + (values['#'] ? '#' + values['#'] : '');
	    };
	    /** @internal */
	    UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
	    return UrlMatcher;
	}());
	exports.UrlMatcher = UrlMatcher;
	//# sourceMappingURL=urlMatcher.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseLocationServices = void 0;
	var common_1 = __webpack_require__(4);
	var utils_1 = __webpack_require__(46);
	/** A base `LocationServices` */
	var BaseLocationServices = /** @class */ (function () {
	    function BaseLocationServices(router, fireAfterUpdate) {
	        var _this = this;
	        this.fireAfterUpdate = fireAfterUpdate;
	        this._listeners = [];
	        this._listener = function (evt) { return _this._listeners.forEach(function (cb) { return cb(evt); }); };
	        this.hash = function () { return utils_1.parseUrl(_this._get()).hash; };
	        this.path = function () { return utils_1.parseUrl(_this._get()).path; };
	        this.search = function () { return utils_1.getParams(utils_1.parseUrl(_this._get()).search); };
	        this._location = common_1.root.location;
	        this._history = common_1.root.history;
	    }
	    BaseLocationServices.prototype.url = function (url, replace) {
	        if (replace === void 0) { replace = true; }
	        if (common_1.isDefined(url) && url !== this._get()) {
	            this._set(null, null, url, replace);
	            if (this.fireAfterUpdate) {
	                this._listeners.forEach(function (cb) { return cb({ url: url }); });
	            }
	        }
	        return utils_1.buildUrl(this);
	    };
	    BaseLocationServices.prototype.onChange = function (cb) {
	        var _this = this;
	        this._listeners.push(cb);
	        return function () { return common_1.removeFrom(_this._listeners, cb); };
	    };
	    BaseLocationServices.prototype.dispose = function (router) {
	        common_1.deregAll(this._listeners);
	    };
	    return BaseLocationServices;
	}());
	exports.BaseLocationServices = BaseLocationServices;
	//# sourceMappingURL=baseLocationService.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(13);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(14);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NuevaModificacionModalController = function () {
	  NuevaModificacionModalController.$inject = ["$uibModalInstance", "DataService", "Storage", "data", "apiUrl", "$state", "Usuarios", "Modal"];
	  function NuevaModificacionModalController($uibModalInstance, DataService, Storage, data, apiUrl, $state, Usuarios, Modal) {
	    'ngInject';
	
	    _classCallCheck(this, NuevaModificacionModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.Storage = Storage;
	    this.apiUrl = apiUrl;
	    this.$state = $state;
	    this.proyecto = data;
	    this.Usuarios = Usuarios;
	    this.DataService = DataService;
	    this.Modal = Modal;
	  }
	
	  _createClass(NuevaModificacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.usuario = this.Storage.getUser();
	    }
	  }, {
	    key: 'puedeVerModificaciones',
	    value: function puedeVerModificaciones(adjudicacion) {
	      if ((this.Usuarios.esFiscal() || this.Usuarios.esSupervisor() || this.Usuarios.esResponsableProyecto() || this.Usuarios.esTecnicoCierre()) && adjudicacion.version > 1) {
	        return true;
	      }
	      return this.Usuarios.esSupervisor() && adjudicacion;
	    }
	  }, {
	    key: 'nuevaModificacion',
	    value: function nuevaModificacion(proyecto, adjudicacion) {
	      this.$uibModalInstance.close(false);
	      this.proyecto.adjudicacion = adjudicacion;
	      this.Modal.show({
	        template: _modal4.default,
	        controller: _modal2.default,
	        data: this.proyecto,
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'irPlanilla',
	    value: function irPlanilla(idSupervision) {
	      this.$state.go('planilla-proyecto', { idSupervision: idSupervision });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return NuevaModificacionModalController;
	}();
	
	exports.default = NuevaModificacionModalController;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(629);
	
	var MODULE_NAME = 'ui.bootstrap.module.position';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.position']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-list\"></i> {{$ctrl.proyecto.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\"><strong>COMPONENTES</strong></p>\n  <div class=\"crud-table mt-3\">\n    <table class=\"table table-striped table-hover ng-table\">\n      <tbody>\n        <tr ng-repeat=\"adjudicacion in $ctrl.proyecto.adjudicaciones\">\n          <td data-title=\"'Acción'\">\n            <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\"\n                ng-click=\"$ctrl.nuevaModificacion($ctrl.proyecto,adjudicacion)\" uib-tooltip=\"Modificaciones\"\n                ng-if=\"($ctrl.proyecto.estado_proyecto === 'APROBADO_FDI' || $ctrl.proyecto.estado_proyecto === 'EN_EJECUCION_FDI' || $ctrl.proyecto.estado_proyecto === 'REVISION_SEGUIMIENTO_FDI' || $ctrl.proyecto.estado_proyecto === 'ASIGNACION_TECNICO_CIERRE_FDI'  || $ctrl.proyecto.estado_proyecto === 'EN_CIERRE_FDI') && $ctrl.puedeVerModificaciones(adjudicacion)\">\n                <i class=\"fa fa-medium\"></i>\n              </button>\n          </td>          \n          <td>{{adjudicacion.referencia}}</td>\n          <td>\n            <div ng-if=\"adjudicacion.supervision.length>0\">\n              <strong class=\"resaltado\">PLANILLA: {{adjudicacion.supervision[0].nro_supervision}}</strong><br>\n              {{adjudicacion.supervision[0].estado_actual.nombre}} <br>\n              <span ng-if=\"supervision.observacion_proceso.mensaje\" class=\"text-danger\"> {{ adjudicacion.supervision[0].observacion_proceso.mensaje }} </span>\n            </div>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Glob = void 0;
	/**
	 * Matches state names using glob-like pattern strings.
	 *
	 * Globs can be used in specific APIs including:
	 *
	 * - [[StateService.is]]
	 * - [[StateService.includes]]
	 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
	 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
	 *
	 * A `Glob` string is a pattern which matches state names.
	 * Nested state names are split into segments (separated by a dot) when processing.
	 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
	 *
	 * Globs work according to the following rules:
	 *
	 * ### Exact match:
	 *
	 * The glob `'A.B'` matches the state named exactly `'A.B'`.
	 *
	 * | Glob        |Matches states named|Does not match state named|
	 * |:------------|:--------------------|:---------------------|
	 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
	 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
	 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
	 *
	 * ### Single star (`*`)
	 *
	 * A single star (`*`) is a wildcard that matches exactly one segment.
	 *
	 * | Glob        |Matches states named  |Does not match state named |
	 * |:------------|:---------------------|:--------------------------|
	 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
	 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
	 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
	 *
	 * ### Double star (`**`)
	 *
	 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
	 *
	 * | Glob        |Matches states named                           |Does not match state named         |
	 * |:------------|:----------------------------------------------|:----------------------------------|
	 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
	 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
	 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
	 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
	 *
	 * @packageDocumentation
	 */
	var Glob = /** @class */ (function () {
	    function Glob(text) {
	        this.text = text;
	        this.glob = text.split('.');
	        var regexpString = this.text
	            .split('.')
	            .map(function (seg) {
	            if (seg === '**')
	                return '(?:|(?:\\.[^.]*)*)';
	            if (seg === '*')
	                return '\\.[^.]*';
	            return '\\.' + seg;
	        })
	            .join('');
	        this.regexp = new RegExp('^' + regexpString + '$');
	    }
	    /** Returns true if the string has glob-like characters in it */
	    Glob.is = function (text) {
	        return !!/[!,*]+/.exec(text);
	    };
	    /** Returns a glob from the string, or null if the string isn't Glob-like */
	    Glob.fromString = function (text) {
	        return Glob.is(text) ? new Glob(text) : null;
	    };
	    Glob.prototype.matches = function (name) {
	        return this.regexp.test('.' + name);
	    };
	    return Glob;
	}());
	exports.Glob = Glob;
	//# sourceMappingURL=glob.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Queue = void 0;
	var common_1 = __webpack_require__(1);
	var Queue = /** @class */ (function () {
	    function Queue(_items, _limit) {
	        if (_items === void 0) { _items = []; }
	        if (_limit === void 0) { _limit = null; }
	        this._items = _items;
	        this._limit = _limit;
	        this._evictListeners = [];
	        this.onEvict = common_1.pushTo(this._evictListeners);
	    }
	    Queue.prototype.enqueue = function (item) {
	        var items = this._items;
	        items.push(item);
	        if (this._limit && items.length > this._limit)
	            this.evict();
	        return item;
	    };
	    Queue.prototype.evict = function () {
	        var item = this._items.shift();
	        this._evictListeners.forEach(function (fn) { return fn(item); });
	        return item;
	    };
	    Queue.prototype.dequeue = function () {
	        if (this.size())
	            return this._items.splice(0, 1)[0];
	    };
	    Queue.prototype.clear = function () {
	        var current = this._items;
	        this._items = [];
	        return current;
	    };
	    Queue.prototype.size = function () {
	        return this._items.length;
	    };
	    Queue.prototype.remove = function (item) {
	        var idx = this._items.indexOf(item);
	        return idx > -1 && this._items.splice(idx, 1)[0];
	    };
	    Queue.prototype.peekTail = function () {
	        return this._items[this._items.length - 1];
	    };
	    Queue.prototype.peekHead = function () {
	        if (this.size())
	            return this._items[0];
	    };
	    return Queue;
	}());
	exports.Queue = Queue;
	//# sourceMappingURL=queue.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This module contains code for State Parameters.
	 *
	 * See [[ParamDeclaration]]
	 *
	 * @packageDocumentation @preferred
	 */
	__exportStar(__webpack_require__(118), exports);
	__exportStar(__webpack_require__(16), exports);
	__exportStar(__webpack_require__(119), exports);
	__exportStar(__webpack_require__(52), exports);
	__exportStar(__webpack_require__(38), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamType = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	/**
	 * An internal class which implements [[ParamTypeDefinition]].
	 *
	 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
	 * When a param type definition is registered, an instance of this class is created internally.
	 *
	 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
	 *
	 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
	 *
	 * #### Example:
	 * ```js
	 * var paramTypeDef = {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 *
	 * var paramType = new ParamType(paramTypeDef);
	 * ```
	 */
	var ParamType = /** @class */ (function () {
	    /**
	     * @param def  A configuration object which contains the custom type definition.  The object's
	     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
	     * @returns a new ParamType object
	     */
	    function ParamType(def) {
	        /** @inheritdoc */
	        this.pattern = /.*/;
	        /** @inheritdoc */
	        this.inherit = true;
	        common_1.extend(this, def);
	    }
	    // consider these four methods to be "abstract methods" that should be overridden
	    /** @inheritdoc */
	    ParamType.prototype.is = function (val, key) {
	        return true;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.encode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.decode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.equals = function (a, b) {
	        // tslint:disable-next-line:triple-equals
	        return a == b;
	    };
	    ParamType.prototype.$subPattern = function () {
	        var sub = this.pattern.toString();
	        return sub.substr(1, sub.length - 2);
	    };
	    ParamType.prototype.toString = function () {
	        return "{ParamType:" + this.name + "}";
	    };
	    /** Given an encoded string, or a decoded object, returns a decoded object */
	    ParamType.prototype.$normalize = function (val) {
	        return this.is(val) ? val : this.decode(val);
	    };
	    /**
	     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
	     * e.g.:
	     * - urlmatcher pattern "/path?{queryParam[]:int}"
	     * - url: "/path?queryParam=1&queryParam=2
	     * - $stateParams.queryParam will be [1, 2]
	     * if `mode` is "auto", then
	     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	     */
	    ParamType.prototype.$asArray = function (mode, isSearch) {
	        if (!mode)
	            return this;
	        if (mode === 'auto' && !isSearch)
	            throw new Error("'auto' array mode is for query parameters only");
	        return new ArrayType(this, mode);
	    };
	    return ParamType;
	}());
	exports.ParamType = ParamType;
	/** Wraps up a `ParamType` object to handle array values. */
	function ArrayType(type, mode) {
	    var _this = this;
	    // Wrap non-array value as array
	    function arrayWrap(val) {
	        return predicates_1.isArray(val) ? val : predicates_1.isDefined(val) ? [val] : [];
	    }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	        switch (val.length) {
	            case 0:
	                return undefined;
	            case 1:
	                return mode === 'auto' ? val[0] : val;
	            default:
	                return val;
	        }
	    }
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	        return function handleArray(val) {
	            if (predicates_1.isArray(val) && val.length === 0)
	                return val;
	            var arr = arrayWrap(val);
	            var result = common_1.map(arr, callback);
	            return allTruthyMode === true ? common_1.filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
	        };
	    }
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	        return function handleArray(val1, val2) {
	            var left = arrayWrap(val1), right = arrayWrap(val2);
	            if (left.length !== right.length)
	                return false;
	            for (var i = 0; i < left.length; i++) {
	                if (!callback(left[i], right[i]))
	                    return false;
	            }
	            return true;
	        };
	    }
	    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
	        var paramTypeFn = type[name].bind(type);
	        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
	        _this[name] = wrapperFn(paramTypeFn);
	    });
	    common_1.extend(this, {
	        dynamic: type.dynamic,
	        name: type.name,
	        pattern: type.pattern,
	        inherit: type.inherit,
	        raw: type.raw,
	        is: arrayHandler(type.is.bind(type), true),
	        $arrayMode: mode,
	    });
	}
	//# sourceMappingURL=paramType.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PathNode = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var param_1 = __webpack_require__(16);
	/**
	 * A node in a [[TreeChanges]] path
	 *
	 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
	 * Each PathNode corresponds to a state being entered, exited, or retained.
	 * The stateful information includes parameter values and resolve data.
	 */
	var PathNode = /** @class */ (function () {
	    function PathNode(stateOrNode) {
	        if (stateOrNode instanceof PathNode) {
	            var node = stateOrNode;
	            this.state = node.state;
	            this.paramSchema = node.paramSchema.slice();
	            this.paramValues = common_1.extend({}, node.paramValues);
	            this.resolvables = node.resolvables.slice();
	            this.views = node.views && node.views.slice();
	        }
	        else {
	            var state = stateOrNode;
	            this.state = state;
	            this.paramSchema = state.parameters({ inherit: false });
	            this.paramValues = {};
	            this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
	        }
	    }
	    PathNode.prototype.clone = function () {
	        return new PathNode(this);
	    };
	    /** Sets [[paramValues]] for the node, from the values of an object hash */
	    PathNode.prototype.applyRawParams = function (params) {
	        var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
	        this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return common_1.applyPairs(memo, getParamVal(pDef)); }, {});
	        return this;
	    };
	    /** Gets a specific [[Param]] metadata that belongs to the node */
	    PathNode.prototype.parameter = function (name) {
	        return common_1.find(this.paramSchema, hof_1.propEq('id', name));
	    };
	    /**
	     * @returns true if the state and parameter values for another PathNode are
	     * equal to the state and param values for this PathNode
	     */
	    PathNode.prototype.equals = function (node, paramsFn) {
	        var diff = this.diff(node, paramsFn);
	        return diff && diff.length === 0;
	    };
	    /**
	     * Finds Params with different parameter values on another PathNode.
	     *
	     * Given another node (of the same state), finds the parameter values which differ.
	     * Returns the [[Param]] (schema objects) whose parameter values differ.
	     *
	     * Given another node for a different state, returns `false`
	     *
	     * @param node The node to compare to
	     * @param paramsFn A function that returns which parameters should be compared.
	     * @returns The [[Param]]s which differ, or null if the two nodes are for different states
	     */
	    PathNode.prototype.diff = function (node, paramsFn) {
	        if (this.state !== node.state)
	            return false;
	        var params = paramsFn ? paramsFn(this) : this.paramSchema;
	        return param_1.Param.changed(params, this.paramValues, node.paramValues);
	    };
	    /**
	     * Returns a clone of the PathNode
	     * @deprecated use instance method `node.clone()`
	     */
	    PathNode.clone = function (node) { return node.clone(); };
	    return PathNode;
	}());
	exports.PathNode = PathNode;
	//# sourceMappingURL=pathNode.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # The state subsystem
	 *
	 * This subsystem implements the ui-router state tree
	 *
	 * - The [[StateService]] has state-related service methods such as:
	 *   - [[StateService.get]]: Get a registered [[StateDeclaration]] object
	 *   - [[StateService.go]]: Transition from the current state to a new state
	 *   - [[StateService.reload]]: Reload the current state
	 *   - [[StateService.target]]: Get a [[TargetState]] (useful when redirecting from a Transition Hook)
	 *   - [[StateService.onInvalid]]: Register a callback for when a transition to an invalid state is started
	 *   - [[StateService.defaultErrorHandler]]: Register a global callback for when a transition errors
	 * - The [[StateDeclaration]] interface defines the shape of a state declaration
	 * - The [[StateRegistry]] contains all the registered states
	 *   - States can be added/removed using the [[StateRegistry.register]] and [[StateRegistry.deregister]]
	 *     - Note: Bootstrap state registration differs by front-end framework.
	 *   - Get notified of state registration/deregistration using [[StateRegistry.onStatesChanged]].
	 *
	 * @packageDocumentation
	 */
	__exportStar(__webpack_require__(121), exports);
	__exportStar(__webpack_require__(56), exports);
	__exportStar(__webpack_require__(41), exports);
	__exportStar(__webpack_require__(57), exports);
	__exportStar(__webpack_require__(58), exports);
	__exportStar(__webpack_require__(59), exports);
	__exportStar(__webpack_require__(60), exports);
	__exportStar(__webpack_require__(17), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateObject = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var glob_1 = __webpack_require__(35);
	var predicates_1 = __webpack_require__(2);
	/**
	 * Internal representation of a UI-Router state.
	 *
	 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
	 *
	 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
	 *
	 * This class prototypally inherits from the corresponding [[StateDeclaration]].
	 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
	 */
	var StateObject = /** @class */ (function () {
	    /** @deprecated use State.create() */
	    function StateObject(config) {
	        return StateObject.create(config || {});
	    }
	    /**
	     * Create a state object to put the private/internal implementation details onto.
	     * The object's prototype chain looks like:
	     * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
	     *
	     * @param stateDecl the user-supplied State Declaration
	     * @returns {StateObject} an internal State object
	     */
	    StateObject.create = function (stateDecl) {
	        stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
	        var state = common_1.inherit(common_1.inherit(stateDecl, StateObject.prototype));
	        stateDecl.$$state = function () { return state; };
	        state.self = stateDecl;
	        state.__stateObjectCache = {
	            nameGlob: glob_1.Glob.fromString(state.name),
	        };
	        return state;
	    };
	    /**
	     * Returns true if the provided parameter is the same state.
	     *
	     * Compares the identity of the state against the passed value, which is either an object
	     * reference to the actual `State` instance, the original definition object passed to
	     * `$stateProvider.state()`, or the fully-qualified name.
	     *
	     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
	     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
	     * @returns Returns `true` if `ref` matches the current `State` instance.
	     */
	    StateObject.prototype.is = function (ref) {
	        return this === ref || this.self === ref || this.fqn() === ref;
	    };
	    /**
	     * @deprecated this does not properly handle dot notation
	     * @returns Returns a dot-separated name of the state.
	     */
	    StateObject.prototype.fqn = function () {
	        if (!this.parent || !(this.parent instanceof this.constructor))
	            return this.name;
	        var name = this.parent.fqn();
	        return name ? name + '.' + this.name : this.name;
	    };
	    /**
	     * Returns the root node of this state's tree.
	     *
	     * @returns The root of this state's tree.
	     */
	    StateObject.prototype.root = function () {
	        return (this.parent && this.parent.root()) || this;
	    };
	    /**
	     * Gets the state's `Param` objects
	     *
	     * Gets the list of [[Param]] objects owned by the state.
	     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
	     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
	     *
	     * @param opts options
	     */
	    StateObject.prototype.parameters = function (opts) {
	        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
	        var inherited = (opts.inherit && this.parent && this.parent.parameters()) || [];
	        return inherited
	            .concat(common_1.values(this.params))
	            .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
	    };
	    /**
	     * Returns a single [[Param]] that is owned by the state
	     *
	     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
	     * @param id the name of the [[Param]] to return
	     * @param opts options
	     */
	    StateObject.prototype.parameter = function (id, opts) {
	        if (opts === void 0) { opts = {}; }
	        return ((this.url && this.url.parameter(id, opts)) ||
	            common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) ||
	            (opts.inherit && this.parent && this.parent.parameter(id)));
	    };
	    StateObject.prototype.toString = function () {
	        return this.fqn();
	    };
	    /** Predicate which returns true if the object is an class with @State() decorator */
	    StateObject.isStateClass = function (stateDecl) {
	        return predicates_1.isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
	    };
	    /** Predicate which returns true if the object is a [[StateDeclaration]] object */
	    StateObject.isStateDeclaration = function (obj) { return predicates_1.isFunction(obj['$$state']); };
	    /** Predicate which returns true if the object is an internal [[StateObject]] object */
	    StateObject.isState = function (obj) { return predicates_1.isObject(obj['__stateObjectCache']); };
	    return StateObject;
	}());
	exports.StateObject = StateObject;
	//# sourceMappingURL=stateObject.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.makeEvent = exports.RegisteredHook = exports.matchState = void 0;
	var common_1 = __webpack_require__(4);
	var interface_1 = __webpack_require__(11);
	/**
	 * Determines if the given state matches the matchCriteria
	 *
	 * @internal
	 *
	 * @param state a State Object to test against
	 * @param criterion
	 * - If a string, matchState uses the string as a glob-matcher against the state name
	 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
	 *   and returns a positive match if any of the globs match.
	 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
	 * @returns {boolean}
	 */
	function matchState(state, criterion, transition) {
	    var toMatch = common_1.isString(criterion) ? [criterion] : criterion;
	    function matchGlobs(_state) {
	        var globStrings = toMatch;
	        for (var i = 0; i < globStrings.length; i++) {
	            var glob = new common_1.Glob(globStrings[i]);
	            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    var matchFn = (common_1.isFunction(toMatch) ? toMatch : matchGlobs);
	    return !!matchFn(state, transition);
	}
	exports.matchState = matchState;
	/**
	 * The registration data for a registered transition hook
	 */
	var RegisteredHook = /** @class */ (function () {
	    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
	        if (options === void 0) { options = {}; }
	        this.tranSvc = tranSvc;
	        this.eventType = eventType;
	        this.callback = callback;
	        this.matchCriteria = matchCriteria;
	        this.removeHookFromRegistry = removeHookFromRegistry;
	        this.invokeCount = 0;
	        this._deregistered = false;
	        this.priority = options.priority || 0;
	        this.bind = options.bind || null;
	        this.invokeLimit = options.invokeLimit;
	    }
	    /**
	     * Gets the matching [[PathNode]]s
	     *
	     * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
	     * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
	     *
	     * Returning `null` is significant to distinguish between the default
	     * "match-all criterion value" of `true` compared to a `() => true` function,
	     * when the nodes is an empty array.
	     *
	     * This is useful to allow a transition match criteria of `entering: true`
	     * to still match a transition, even when `entering === []`.  Contrast that
	     * with `entering: (state) => true` which only matches when a state is actually
	     * being entered.
	     */
	    RegisteredHook.prototype._matchingNodes = function (nodes, criterion, transition) {
	        if (criterion === true)
	            return nodes;
	        var matching = nodes.filter(function (node) { return matchState(node.state, criterion, transition); });
	        return matching.length ? matching : null;
	    };
	    /**
	     * Gets the default match criteria (all `true`)
	     *
	     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
	     *
	     * ```js
	     * {
	     *   to: true,
	     *   from: true,
	     *   entering: true,
	     *   exiting: true,
	     *   retained: true,
	     * }
	     */
	    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
	        return common_1.mapObj(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
	    };
	    /**
	     * Gets matching nodes as [[IMatchingNodes]]
	     *
	     * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
	     *
	     * ```js
	     * let matches: IMatchingNodes = {
	     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
	     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
	     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
	     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
	     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
	     * };
	     * ```
	     */
	    RegisteredHook.prototype._getMatchingNodes = function (treeChanges, transition) {
	        var _this = this;
	        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
	        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
	        return paths.reduce(function (mn, pathtype) {
	            // STATE scope criteria matches against every node in the path.
	            // TRANSITION scope criteria matches against only the last node in the path
	            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
	            var path = treeChanges[pathtype.name] || [];
	            var nodes = isStateHook ? path : [common_1.tail(path)];
	            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name], transition);
	            return mn;
	        }, {});
	    };
	    /**
	     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
	     *
	     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
	     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
	     */
	    RegisteredHook.prototype.matches = function (treeChanges, transition) {
	        var matches = this._getMatchingNodes(treeChanges, transition);
	        // Check if all the criteria matched the TreeChanges object
	        var allMatched = common_1.values(matches).every(common_1.identity);
	        return allMatched ? matches : null;
	    };
	    RegisteredHook.prototype.deregister = function () {
	        this.removeHookFromRegistry(this);
	        this._deregistered = true;
	    };
	    return RegisteredHook;
	}());
	exports.RegisteredHook = RegisteredHook;
	/** Return a registration function of the requested type. */
	function makeEvent(registry, transitionService, eventType) {
	    // Create the object which holds the registered transition hooks.
	    var _registeredHooks = (registry._registeredHooks = registry._registeredHooks || {});
	    var hooks = (_registeredHooks[eventType.name] = []);
	    var removeHookFn = common_1.removeFrom(hooks);
	    // Create hook registration function on the IHookRegistry for the event
	    registry[eventType.name] = hookRegistrationFn;
	    function hookRegistrationFn(matchObject, callback, options) {
	        if (options === void 0) { options = {}; }
	        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, removeHookFn, options);
	        hooks.push(registeredHook);
	        return registeredHook.deregister.bind(registeredHook);
	    }
	    return hookRegistrationFn;
	}
	exports.makeEvent = makeEvent;
	//# sourceMappingURL=hookRegistry.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Transition = void 0;
	var trace_1 = __webpack_require__(9);
	var coreservices_1 = __webpack_require__(5);
	var strings_1 = __webpack_require__(6);
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var interface_1 = __webpack_require__(11); // has or is using
	var transitionHook_1 = __webpack_require__(18);
	var hookRegistry_1 = __webpack_require__(42);
	var hookBuilder_1 = __webpack_require__(61);
	var pathUtils_1 = __webpack_require__(21);
	var param_1 = __webpack_require__(16);
	var resolvable_1 = __webpack_require__(22);
	var resolveContext_1 = __webpack_require__(23);
	var rejectFactory_1 = __webpack_require__(12);
	var common_2 = __webpack_require__(4);
	/** @internal */
	var stateSelf = hof_1.prop('self');
	/**
	 * Represents a transition between two states.
	 *
	 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
	 *
	 * This object contains all contextual information about the to/from states, parameters, resolves.
	 * It has information about all states being entered and exited as a result of the transition.
	 */
	var Transition = /** @class */ (function () {
	    /**
	     * Creates a new Transition object.
	     *
	     * If the target state is not valid, an error is thrown.
	     *
	     * @internal
	     *
	     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
	     *        encapsulates the "from state".
	     * @param targetState The target state and parameters being transitioned to (also, the transition options)
	     * @param router The [[UIRouter]] instance
	     * @internal
	     */
	    function Transition(fromPath, targetState, router) {
	        var _this = this;
	        /** @internal */
	        this._deferred = coreservices_1.services.$q.defer();
	        /**
	         * This promise is resolved or rejected based on the outcome of the Transition.
	         *
	         * When the transition is successful, the promise is resolved
	         * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
	         */
	        this.promise = this._deferred.promise;
	        /** @internal Holds the hook registration functions such as those passed to Transition.onStart() */
	        this._registeredHooks = {};
	        /** @internal */
	        this._hookBuilder = new hookBuilder_1.HookBuilder(this);
	        /** Checks if this transition is currently active/running. */
	        this.isActive = function () { return _this.router.globals.transition === _this; };
	        this.router = router;
	        this._targetState = targetState;
	        if (!targetState.valid()) {
	            throw new Error(targetState.error());
	        }
	        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
	        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
	        this.$id = router.transitionService._transitionCount++;
	        var toPath = pathUtils_1.PathUtils.buildToPath(fromPath, targetState);
	        this._treeChanges = pathUtils_1.PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
	        this.createTransitionHookRegFns();
	        var onCreateHooks = this._hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
	        transitionHook_1.TransitionHook.invokeHooks(onCreateHooks, function () { return null; });
	        this.applyViewConfigs(router);
	    }
	    /** @internal */
	    Transition.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /** @internal
	     * Creates the transition-level hook registration functions
	     * (which can then be used to register hooks)
	     */
	    Transition.prototype.createTransitionHookRegFns = function () {
	        var _this = this;
	        this.router.transitionService._pluginapi
	            ._getEvents()
	            .filter(function (type) { return type.hookPhase !== interface_1.TransitionHookPhase.CREATE; })
	            .forEach(function (type) { return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type); });
	    };
	    /** @internal */
	    Transition.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    Transition.prototype.applyViewConfigs = function (router) {
	        var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
	        pathUtils_1.PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
	    };
	    /**
	     * @internal
	     * @returns the internal from [State] object
	     */
	    Transition.prototype.$from = function () {
	        return common_1.tail(this._treeChanges.from).state;
	    };
	    /**
	     * @internal
	     * @returns the internal to [State] object
	     */
	    Transition.prototype.$to = function () {
	        return common_1.tail(this._treeChanges.to).state;
	    };
	    /**
	     * Returns the "from state"
	     *
	     * Returns the state that the transition is coming *from*.
	     *
	     * @returns The state declaration object for the Transition's ("from state").
	     */
	    Transition.prototype.from = function () {
	        return this.$from().self;
	    };
	    /**
	     * Returns the "to state"
	     *
	     * Returns the state that the transition is going *to*.
	     *
	     * @returns The state declaration object for the Transition's target state ("to state").
	     */
	    Transition.prototype.to = function () {
	        return this.$to().self;
	    };
	    /**
	     * Gets the Target State
	     *
	     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
	     *
	     * @returns the [[TargetState]] of this Transition
	     */
	    Transition.prototype.targetState = function () {
	        return this._targetState;
	    };
	    /**
	     * Determines whether two transitions are equivalent.
	     * @deprecated
	     */
	    Transition.prototype.is = function (compare) {
	        if (compare instanceof Transition) {
	            // TODO: Also compare parameters
	            return this.is({ to: compare.$to().name, from: compare.$from().name });
	        }
	        return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to, this)) ||
	            (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from, this)));
	    };
	    Transition.prototype.params = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}));
	    };
	    Transition.prototype.paramsChanged = function () {
	        var fromParams = this.params('from');
	        var toParams = this.params('to');
	        // All the parameters declared on both the "to" and "from" paths
	        var allParamDescriptors = []
	            .concat(this._treeChanges.to)
	            .concat(this._treeChanges.from)
	            .map(function (pathNode) { return pathNode.paramSchema; })
	            .reduce(common_2.flattenR, [])
	            .reduce(common_2.uniqR, []);
	        var changedParamDescriptors = param_1.Param.changed(allParamDescriptors, fromParams, toParams);
	        return changedParamDescriptors.reduce(function (changedValues, descriptor) {
	            changedValues[descriptor.id] = toParams[descriptor.id];
	            return changedValues;
	        }, {});
	    };
	    /**
	     * Creates a [[UIInjector]] Dependency Injector
	     *
	     * Returns a Dependency Injector for the Transition's target state (to state).
	     * The injector provides resolve values which the target state has access to.
	     *
	     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
	     *
	     * #### Example:
	     * ```js
	     * .onEnter({ entering: 'myState' }, trans => {
	     *   var myResolveValue = trans.injector().get('myResolve');
	     *   // Inject a global service from the global/native injector (if it exists)
	     *   var MyService = trans.injector().get('MyService');
	     * })
	     * ```
	     *
	     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
	     * You can use [[UIInjector.getAsync]] to get a promise for the data.
	     * #### Example:
	     * ```js
	     * .onBefore({}, trans => {
	     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
	     *     return myResolveValue !== 'ABORT';
	     *   });
	     * });
	     * ```
	     *
	     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
	     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
	     * #### Example:
	     * ```js
	     * .onEnter({ to: 'foo.bar' }, trans => {
	     *   // returns result of `foo` state's `myResolve` resolve
	     *   // even though `foo.bar` also has a `myResolve` resolve
	     *   var fooData = trans.injector('foo').get('myResolve');
	     * });
	     * ```
	     *
	     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
	     * The resolve data from the `from` path will be returned.
	     * #### Example:
	     * ```js
	     * .onExit({ exiting: 'foo.bar' }, trans => {
	     *   // Gets the resolve value of `myResolve` from the state being exited
	     *   var fooData = trans.injector(null, 'from').get('myResolve');
	     * });
	     * ```
	     *
	     *
	     * @param state Limits the resolves provided to only the resolves the provided state has access to.
	     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
	     *
	     * @returns a [[UIInjector]]
	     */
	    Transition.prototype.injector = function (state, pathName) {
	        if (pathName === void 0) { pathName = 'to'; }
	        var path = this._treeChanges[pathName];
	        if (state)
	            path = pathUtils_1.PathUtils.subPath(path, function (node) { return node.state === state || node.state.name === state; });
	        return new resolveContext_1.ResolveContext(path).injector();
	    };
	    /**
	     * Gets all available resolve tokens (keys)
	     *
	     * This method can be used in conjunction with [[injector]] to inspect the resolve values
	     * available to the Transition.
	     *
	     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
	     * in the Transition's [[TreeChanges.to]] path.
	     *
	     * #### Example:
	     * This example logs all resolve values
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
	     * ```
	     *
	     * #### Example:
	     * This example creates promises for each resolve value.
	     * This triggers fetches of resolves (if any have not yet been fetched).
	     * When all promises have all settled, it logs the resolve values.
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * let promise = tokens.map(token => trans.injector().getAsync(token));
	     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
	     * ```
	     *
	     * Note: Angular 1 users whould use `$q.all()`
	     *
	     * @param pathname resolve context's path name (e.g., `to` or `from`)
	     *
	     * @returns an array of resolve tokens (keys)
	     */
	    Transition.prototype.getResolveTokens = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
	    };
	    /**
	     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
	     *
	     * Allows a transition hook to dynamically add a Resolvable to this Transition.
	     *
	     * Use the [[Transition.injector]] to retrieve the resolved data in subsequent hooks ([[UIInjector.get]]).
	     *
	     * If a `state` argument is provided, the Resolvable is processed when that state is being entered.
	     * If no `state` is provided then the root state is used.
	     * If the given `state` has already been entered, the Resolvable is processed when any child state is entered.
	     * If no child states will be entered, the Resolvable is processed during the `onFinish` phase of the Transition.
	     *
	     * The `state` argument also scopes the resolved data.
	     * The resolved data is available from the injector for that `state` and any children states.
	     *
	     * #### Example:
	     * ```js
	     * transitionService.onBefore({}, transition => {
	     *   transition.addResolvable({
	     *     token: 'myResolve',
	     *     deps: ['MyService'],
	     *     resolveFn: myService => myService.getData()
	     *   });
	     * });
	     * ```
	     *
	     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
	     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
	     */
	    Transition.prototype.addResolvable = function (resolvable, state) {
	        if (state === void 0) { state = ''; }
	        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
	        var stateName = typeof state === 'string' ? state : state.name;
	        var topath = this._treeChanges.to;
	        var targetNode = common_1.find(topath, function (node) { return node.state.name === stateName; });
	        var resolveContext = new resolveContext_1.ResolveContext(topath);
	        resolveContext.addResolvables([resolvable], targetNode.state);
	    };
	    /**
	     * Gets the transition from which this transition was redirected.
	     *
	     * If the current transition is a redirect, this method returns the transition that was redirected.
	     *
	     * #### Example:
	     * ```js
	     * let transitionA = $state.go('A').transition
	     * transitionA.onStart({}, () => $state.target('B'));
	     * $transitions.onSuccess({ to: 'B' }, (trans) => {
	     *   trans.to().name === 'B'; // true
	     *   trans.redirectedFrom() === transitionA; // true
	     * });
	     * ```
	     *
	     * @returns The previous Transition, or null if this Transition is not the result of a redirection
	     */
	    Transition.prototype.redirectedFrom = function () {
	        return this._options.redirectedFrom || null;
	    };
	    /**
	     * Gets the original transition in a redirect chain
	     *
	     * A transition might belong to a long chain of multiple redirects.
	     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
	     *
	     * #### Example:
	     * ```js
	     * // states
	     * registry.register({ name: 'A', redirectTo: 'B' });
	     * registry.register({ name: 'B', redirectTo: 'C' });
	     * registry.register({ name: 'C', redirectTo: 'D' });
	     * registry.register({ name: 'D' });
	     *
	     * let transitionA = $state.go('A').transition
	     *
	     * $transitions.onSuccess({ to: 'D' }, (trans) => {
	     *   trans.to().name === 'D'; // true
	     *   trans.redirectedFrom().to().name === 'C'; // true
	     *   trans.originalTransition() === transitionA; // true
	     *   trans.originalTransition().to().name === 'A'; // true
	     * });
	     * ```
	     *
	     * @returns The original Transition that started a redirect chain
	     */
	    Transition.prototype.originalTransition = function () {
	        var rf = this.redirectedFrom();
	        return (rf && rf.originalTransition()) || this;
	    };
	    /**
	     * Get the transition options
	     *
	     * @returns the options for this Transition.
	     */
	    Transition.prototype.options = function () {
	        return this._options;
	    };
	    /**
	     * Gets the states being entered.
	     *
	     * @returns an array of states that will be entered during this transition.
	     */
	    Transition.prototype.entering = function () {
	        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Gets the states being exited.
	     *
	     * @returns an array of states that will be exited during this transition.
	     */
	    Transition.prototype.exiting = function () {
	        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
	    };
	    /**
	     * Gets the states being retained.
	     *
	     * @returns an array of states that are already entered from a previous Transition, that will not be
	     *    exited during this Transition
	     */
	    Transition.prototype.retained = function () {
	        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Get the [[ViewConfig]]s associated with this Transition
	     *
	     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
	     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
	     *
	     * @param pathname the name of the path to fetch views for:
	     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
	     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
	     *
	     * @returns a list of ViewConfig objects for the given path.
	     */
	    Transition.prototype.views = function (pathname, state) {
	        if (pathname === void 0) { pathname = 'entering'; }
	        var path = this._treeChanges[pathname];
	        path = !state ? path : path.filter(hof_1.propEq('state', state));
	        return path.map(hof_1.prop('views')).filter(common_1.identity).reduce(common_1.unnestR, []);
	    };
	    Transition.prototype.treeChanges = function (pathname) {
	        return pathname ? this._treeChanges[pathname] : this._treeChanges;
	    };
	    /**
	     * Creates a new transition that is a redirection of the current one.
	     *
	     * This transition can be returned from a [[TransitionService]] hook to
	     * redirect a transition to a new state and/or set of parameters.
	     *
	     * @internal
	     *
	     * @returns Returns a new [[Transition]] instance.
	     */
	    Transition.prototype.redirect = function (targetState) {
	        var redirects = 1, trans = this;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((trans = trans.redirectedFrom()) != null) {
	            if (++redirects > 20)
	                throw new Error("Too many consecutive Transition redirects (20+)");
	        }
	        var redirectOpts = { redirectedFrom: this, source: 'redirect' };
	        // If the original transition was caused by URL sync, then use { location: 'replace' }
	        // on the new transition (unless the target state explicitly specifies location: false).
	        // This causes the original url to be replaced with the url for the redirect target
	        // so the original url disappears from the browser history.
	        if (this.options().source === 'url' && targetState.options().location !== false) {
	            redirectOpts.location = 'replace';
	        }
	        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
	        targetState = targetState.withOptions(newOptions, true);
	        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
	        var originalEnteringNodes = this._treeChanges.entering;
	        var redirectEnteringNodes = newTransition._treeChanges.entering;
	        // --- Re-use resolve data from original transition ---
	        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
	        // (because of the redirect), the resolves fetched by the original transition are still valid in the
	        // redirected transition.
	        //
	        // This allows you to define a redirect on a parent state which depends on an async resolve value.
	        // You can wait for the resolve, then redirect to a child state based on the result.
	        // The redirected transition does not have to re-fetch the resolve.
	        // ---------------------------------------------------------
	        var nodeIsReloading = function (reloadState) { return function (node) {
	            return reloadState && node.state.includes[reloadState.name];
	        }; };
	        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
	        var matchingEnteringNodes = pathUtils_1.PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, pathUtils_1.PathUtils.nonDynamicParams).filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
	        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
	        matchingEnteringNodes.forEach(function (node, idx) {
	            node.resolvables = originalEnteringNodes[idx].resolvables;
	        });
	        return newTransition;
	    };
	    /** @internal If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
	    Transition.prototype._changedParams = function () {
	        var tc = this._treeChanges;
	        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
	        // If user explicitly wants a reload
	        if (this._options.reload)
	            return undefined;
	        // If any states are exiting or entering
	        if (tc.exiting.length || tc.entering.length)
	            return undefined;
	        // If to/from path lengths differ
	        if (tc.to.length !== tc.from.length)
	            return undefined;
	        // If the to/from paths are different
	        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from)
	            .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
	            .reduce(common_1.anyTrueR, false);
	        if (pathsDiffer)
	            return undefined;
	        // Find any parameter values that differ
	        var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
	        var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
	        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
	        return tuples.map(function (_a) {
	            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
	            return param_1.Param.changed(schema, toVals, fromVals);
	        }).reduce(common_1.unnestR, []);
	    };
	    /**
	     * Returns true if the transition is dynamic.
	     *
	     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
	     *
	     * @returns true if the Transition is dynamic
	     */
	    Transition.prototype.dynamic = function () {
	        var changes = this._changedParams();
	        return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(common_1.anyTrueR, false);
	    };
	    /**
	     * Returns true if the transition is ignored.
	     *
	     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
	     *
	     * @returns true if the Transition is ignored.
	     */
	    Transition.prototype.ignored = function () {
	        return !!this._ignoredReason();
	    };
	    /** @internal */
	    Transition.prototype._ignoredReason = function () {
	        var pending = this.router.globals.transition;
	        var reloadState = this._options.reloadState;
	        var same = function (pathA, pathB) {
	            if (pathA.length !== pathB.length)
	                return false;
	            var matching = pathUtils_1.PathUtils.matching(pathA, pathB);
	            return pathA.length === matching.filter(function (node) { return !reloadState || !node.state.includes[reloadState.name]; }).length;
	        };
	        var newTC = this.treeChanges();
	        var pendTC = pending && pending.treeChanges();
	        if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting))
	            return 'SameAsPending';
	        if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to))
	            return 'SameAsCurrent';
	    };
	    /**
	     * Runs the transition
	     *
	     * This method is generally called from the [[StateService.transitionTo]]
	     *
	     * @internal
	     *
	     * @returns a promise for a successful transition.
	     */
	    Transition.prototype.run = function () {
	        var _this = this;
	        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
	        // Gets transition hooks array for the given phase
	        var getHooksFor = function (phase) { return _this._hookBuilder.buildHooksForPhase(phase); };
	        // When the chain is complete, then resolve or reject the deferred
	        var transitionSuccess = function () {
	            trace_1.trace.traceSuccess(_this.$to(), _this);
	            _this.success = true;
	            _this._deferred.resolve(_this.to());
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.SUCCESS));
	        };
	        var transitionError = function (reason) {
	            trace_1.trace.traceError(reason, _this);
	            _this.success = false;
	            _this._deferred.reject(reason);
	            _this._error = reason;
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.ERROR));
	        };
	        var runTransition = function () {
	            // Wait to build the RUN hook chain until the BEFORE hooks are done
	            // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
	            var allRunHooks = getHooksFor(interface_1.TransitionHookPhase.RUN);
	            var done = function () { return coreservices_1.services.$q.when(undefined); };
	            return transitionHook_1.TransitionHook.invokeHooks(allRunHooks, done);
	        };
	        var startTransition = function () {
	            var globals = _this.router.globals;
	            globals.lastStartedTransitionId = _this.$id;
	            globals.transition = _this;
	            globals.transitionHistory.enqueue(_this);
	            trace_1.trace.traceTransitionStart(_this);
	            return coreservices_1.services.$q.when(undefined);
	        };
	        var allBeforeHooks = getHooksFor(interface_1.TransitionHookPhase.BEFORE);
	        transitionHook_1.TransitionHook.invokeHooks(allBeforeHooks, startTransition)
	            .then(runTransition)
	            .then(transitionSuccess, transitionError);
	        return this.promise;
	    };
	    /**
	     * Checks if the Transition is valid
	     *
	     * @returns true if the Transition is valid
	     */
	    Transition.prototype.valid = function () {
	        return !this.error() || this.success !== undefined;
	    };
	    /**
	     * Aborts this transition
	     *
	     * Imperative API to abort a Transition.
	     * This only applies to Transitions that are not yet complete.
	     */
	    Transition.prototype.abort = function () {
	        // Do not set flag if the transition is already complete
	        if (predicates_1.isUndefined(this.success)) {
	            this._aborted = true;
	        }
	    };
	    /**
	     * The Transition error reason.
	     *
	     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
	     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
	     *
	     * @returns a transition rejection explaining why the transition is invalid, or the reason the transition failed.
	     */
	    Transition.prototype.error = function () {
	        var state = this.$to();
	        if (state.self.abstract) {
	            return rejectFactory_1.Rejection.invalid("Cannot transition to abstract state '" + state.name + "'");
	        }
	        var paramDefs = state.parameters();
	        var values = this.params();
	        var invalidParams = paramDefs.filter(function (param) { return !param.validates(values[param.id]); });
	        if (invalidParams.length) {
	            var invalidValues = invalidParams.map(function (param) { return "[" + param.id + ":" + strings_1.stringify(values[param.id]) + "]"; }).join(', ');
	            var detail = "The following parameter values are not valid for state '" + state.name + "': " + invalidValues;
	            return rejectFactory_1.Rejection.invalid(detail);
	        }
	        if (this.success === false)
	            return this._error;
	    };
	    /**
	     * A string representation of the Transition
	     *
	     * @returns A string representation of the Transition
	     */
	    Transition.prototype.toString = function () {
	        var fromStateOrName = this.from();
	        var toStateOrName = this.to();
	        var avoidEmptyHash = function (params) {
	            return params['#'] !== null && params['#'] !== undefined ? params : common_1.omit(params, ['#']);
	        };
	        // (X) means the to state is invalid.
	        var id = this.$id, from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = strings_1.stringify(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))), toValid = this.valid() ? '' : '(X) ', to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = strings_1.stringify(avoidEmptyHash(this.params()));
	        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
	    };
	    /** @internal */
	    Transition.diToken = Transition;
	    return Transition;
	}());
	exports.Transition = Transition;
	//# sourceMappingURL=transition.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionService = exports.defaultTransOpts = void 0;
	var interface_1 = __webpack_require__(11);
	var transition_1 = __webpack_require__(43);
	var hookRegistry_1 = __webpack_require__(42);
	var coreResolvables_1 = __webpack_require__(107);
	var redirectTo_1 = __webpack_require__(111);
	var onEnterExitRetain_1 = __webpack_require__(110);
	var resolve_1 = __webpack_require__(112);
	var views_1 = __webpack_require__(115);
	var updateGlobals_1 = __webpack_require__(113);
	var url_1 = __webpack_require__(114);
	var lazyLoad_1 = __webpack_require__(51);
	var transitionEventType_1 = __webpack_require__(62);
	var transitionHook_1 = __webpack_require__(18);
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var ignoredTransition_1 = __webpack_require__(108);
	var invalidTransition_1 = __webpack_require__(109);
	/**
	 * The default [[Transition]] options.
	 *
	 * Include this object when applying custom defaults:
	 * let reloadOpts = { reload: true, notify: true }
	 * let options = defaults(theirOpts, customDefaults, defaultOptions);
	 */
	exports.defaultTransOpts = {
	    location: true,
	    relative: null,
	    inherit: false,
	    notify: true,
	    reload: false,
	    supercede: true,
	    custom: {},
	    current: function () { return null; },
	    source: 'unknown',
	};
	/**
	 * This class provides services related to Transitions.
	 *
	 * - Most importantly, it allows global Transition Hooks to be registered.
	 * - It allows the default transition error handler to be set.
	 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
	 *
	 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
	 *
	 * This API is located at `router.transitionService` ([[UIRouter.transitionService]])
	 */
	var TransitionService = /** @class */ (function () {
	    /** @internal */
	    function TransitionService(_router) {
	        /** @internal */
	        this._transitionCount = 0;
	        /** The transition hook types, such as `onEnter`, `onStart`, etc */
	        this._eventTypes = [];
	        /** @internal The registered transition hooks */
	        this._registeredHooks = {};
	        /** The  paths on a criteria object */
	        this._criteriaPaths = {};
	        this._router = _router;
	        this.$view = _router.viewService;
	        this._deregisterHookFns = {};
	        this._pluginapi = (common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), [
	            '_definePathType',
	            '_defineEvent',
	            '_getPathTypes',
	            '_getEvents',
	            'getHooks',
	        ]));
	        this._defineCorePaths();
	        this._defineCoreEvents();
	        this._registerCoreTransitionHooks();
	        _router.globals.successfulTransitions.onEvict(coreResolvables_1.treeChangesCleanup);
	    }
	    /**
	     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
	     *
	     * Registers a transition lifecycle hook, which is invoked during transition construction.
	     *
	     * This low level hook should only be used by plugins.
	     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
	     * The Sticky States plugin uses this hook to modify the treechanges.
	     *
	     * ### Lifecycle
	     *
	     * `onCreate` hooks are invoked *while a transition is being constructed*.
	     *
	     * ### Return value
	     *
	     * The hook's return value is ignored
	     *
	     * @internal
	     * @param criteria defines which Transitions the Hook should be invoked for.
	     * @param callback the hook function which will be invoked.
	     * @param options the registration options
	     * @returns a function which deregisters the hook.
	     */
	    TransitionService.prototype.onCreate = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /**
	     * dispose
	     * @internal
	     */
	    TransitionService.prototype.dispose = function (router) {
	        common_1.values(this._registeredHooks).forEach(function (hooksArray) {
	            return hooksArray.forEach(function (hook) {
	                hook._deregistered = true;
	                common_1.removeFrom(hooksArray, hook);
	            });
	        });
	    };
	    /**
	     * Creates a new [[Transition]] object
	     *
	     * This is a factory function for creating new Transition objects.
	     * It is used internally by the [[StateService]] and should generally not be called by application code.
	     *
	     * @internal
	     * @param fromPath the path to the current state (the from state)
	     * @param targetState the target state (destination)
	     * @returns a Transition
	     */
	    TransitionService.prototype.create = function (fromPath, targetState) {
	        return new transition_1.Transition(fromPath, targetState, this._router);
	    };
	    /** @internal */
	    TransitionService.prototype._defineCoreEvents = function () {
	        var Phase = interface_1.TransitionHookPhase;
	        var TH = transitionHook_1.TransitionHook;
	        var paths = this._criteriaPaths;
	        var NORMAL_SORT = false, REVERSE_SORT = true;
	        var SYNCHRONOUS = true;
	        this._defineEvent('onCreate', Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
	        this._defineEvent('onBefore', Phase.BEFORE, 0, paths.to);
	        this._defineEvent('onStart', Phase.RUN, 0, paths.to);
	        this._defineEvent('onExit', Phase.RUN, 100, paths.exiting, REVERSE_SORT);
	        this._defineEvent('onRetain', Phase.RUN, 200, paths.retained);
	        this._defineEvent('onEnter', Phase.RUN, 300, paths.entering);
	        this._defineEvent('onFinish', Phase.RUN, 400, paths.to);
	        this._defineEvent('onSuccess', Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	        this._defineEvent('onError', Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	    };
	    /** @internal */
	    TransitionService.prototype._defineCorePaths = function () {
	        var STATE = interface_1.TransitionHookScope.STATE, TRANSITION = interface_1.TransitionHookScope.TRANSITION;
	        this._definePathType('to', TRANSITION);
	        this._definePathType('from', TRANSITION);
	        this._definePathType('exiting', STATE);
	        this._definePathType('retained', STATE);
	        this._definePathType('entering', STATE);
	    };
	    /** @internal */
	    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
	        this._eventTypes.push(eventType);
	        hookRegistry_1.makeEvent(this, this, eventType);
	    };
	    /** @internal */
	    TransitionService.prototype._getEvents = function (phase) {
	        var transitionHookTypes = predicates_1.isDefined(phase)
	            ? this._eventTypes.filter(function (type) { return type.hookPhase === phase; })
	            : this._eventTypes.slice();
	        return transitionHookTypes.sort(function (l, r) {
	            var cmpByPhase = l.hookPhase - r.hookPhase;
	            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
	        });
	    };
	    /**
	     * Adds a Path to be used as a criterion against a TreeChanges path
	     *
	     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
	     * Each state in the exiting path is checked against the criteria and returned as part of the match.
	     *
	     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
	     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
	     *
	     * @internal
	     */
	    TransitionService.prototype._definePathType = function (name, hookScope) {
	        this._criteriaPaths[name] = { name: name, scope: hookScope };
	    };
	    /** @internal */
	    // tslint:disable-next-line
	    TransitionService.prototype._getPathTypes = function () {
	        return this._criteriaPaths;
	    };
	    /** @internal */
	    TransitionService.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    /** @internal */
	    TransitionService.prototype._registerCoreTransitionHooks = function () {
	        var fns = this._deregisterHookFns;
	        fns.addCoreResolves = coreResolvables_1.registerAddCoreResolvables(this);
	        fns.ignored = ignoredTransition_1.registerIgnoredTransitionHook(this);
	        fns.invalid = invalidTransition_1.registerInvalidTransitionHook(this);
	        // Wire up redirectTo hook
	        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
	        // Wire up onExit/Retain/Enter state hooks
	        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
	        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
	        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
	        // Wire up Resolve hooks
	        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
	        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
	        fns.resolveAll = resolve_1.registerResolveRemaining(this);
	        // Wire up the View management hooks
	        fns.loadViews = views_1.registerLoadEnteringViews(this);
	        fns.activateViews = views_1.registerActivateViews(this);
	        // Updates global state after a transition
	        fns.updateGlobals = updateGlobals_1.registerUpdateGlobalState(this);
	        // After globals.current is updated at priority: 10000
	        fns.updateUrl = url_1.registerUpdateUrl(this);
	        // Lazy load state trees
	        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
	    };
	    return TransitionService;
	}());
	exports.TransitionService = TransitionService;
	//# sourceMappingURL=transitionService.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseUrlRule = exports.UrlRuleFactory = void 0;
	var urlMatcher_1 = __webpack_require__(24);
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var stateObject_1 = __webpack_require__(41);
	/**
	 * Creates a [[UrlRule]]
	 *
	 * Creates a [[UrlRule]] from a:
	 *
	 * - `string`
	 * - [[UrlMatcher]]
	 * - `RegExp`
	 * - [[StateObject]]
	 */
	var UrlRuleFactory = /** @class */ (function () {
	    function UrlRuleFactory(router) {
	        this.router = router;
	    }
	    UrlRuleFactory.prototype.compile = function (str) {
	        return this.router.urlMatcherFactory.compile(str);
	    };
	    UrlRuleFactory.prototype.create = function (what, handler) {
	        var _this = this;
	        var isState = stateObject_1.StateObject.isState, isStateDeclaration = stateObject_1.StateObject.isStateDeclaration;
	        var makeRule = hof_1.pattern([
	            [predicates_1.isString, function (_what) { return makeRule(_this.compile(_what)); }],
	            [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
	            [hof_1.or(isState, isStateDeclaration), function (_what) { return _this.fromState(_what, _this.router); }],
	            [hof_1.is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
	            [predicates_1.isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
	        ]);
	        var rule = makeRule(what);
	        if (!rule)
	            throw new Error("invalid 'what' in when()");
	        return rule;
	    };
	    /**
	     * A UrlRule which matches based on a UrlMatcher
	     *
	     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     *
	     * ## Handler as UrlMatcher
	     *
	     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
	     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
	     * The url is replaced with the result.
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var handler = $umf.compile("/home/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
	        var _handler = handler;
	        if (predicates_1.isString(handler))
	            handler = this.router.urlMatcherFactory.compile(handler);
	        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler))
	            _handler = function (match) { return handler.format(match); };
	        function matchUrlParamters(url) {
	            var params = urlMatcher.exec(url.path, url.search, url.hash);
	            return urlMatcher.validates(params) && params;
	        }
	        // Prioritize URLs, lowest to highest:
	        // - Some optional URL parameters, but none matched
	        // - No optional parameters in URL
	        // - Some optional parameters, some matched
	        // - Some optional parameters, all matched
	        function matchPriority(params) {
	            var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
	            if (!optional.length)
	                return 0.000001;
	            var matched = optional.filter(function (param) { return params[param.id]; });
	            return matched.length / optional.length;
	        }
	        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: 'URLMATCHER' };
	        return common_1.extend(new BaseUrlRule(matchUrlParamters, _handler), details);
	    };
	    /**
	     * A UrlRule which matches a state by its url
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromState($state.get('foo'), router);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match);
	     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
	     * ```
	     */
	    UrlRuleFactory.prototype.fromState = function (stateOrDecl, router) {
	        var state = stateObject_1.StateObject.isStateDeclaration(stateOrDecl) ? stateOrDecl.$$state() : stateOrDecl;
	        /**
	         * Handles match by transitioning to matched state
	         *
	         * First checks if the router should start a new transition.
	         * A new transition is not required if the current state's URL
	         * and the new URL are already identical
	         */
	        var handler = function (match) {
	            var $state = router.stateService;
	            var globals = router.globals;
	            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
	                $state.transitionTo(state, match, { inherit: true, source: 'url' });
	            }
	        };
	        var details = { state: state, type: 'STATE' };
	        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
	    };
	    /**
	     * A UrlRule which matches based on a regular expression
	     *
	     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - regexp match array (from `regexp`)
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     *
	     * ## Handler as string
	     *
	     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
	     * The string is first interpolated using `string.replace()` style pattern.
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
	        if (regexp.global || regexp.sticky)
	            throw new Error('Rule RegExp must not be global or sticky');
	        /**
	         * If handler is a string, the url will be replaced by the string.
	         * If the string has any String.replace() style variables in it (like `$2`),
	         * they will be replaced by the captures from [[match]]
	         */
	        var redirectUrlTo = function (match) {
	            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
	            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) { return match[what === '$' ? 0 : Number(what)]; });
	        };
	        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
	        var matchParamsFromRegexp = function (url) { return regexp.exec(url.path); };
	        var details = { regexp: regexp, type: 'REGEXP' };
	        return common_1.extend(new BaseUrlRule(matchParamsFromRegexp, _handler), details);
	    };
	    UrlRuleFactory.isUrlRule = function (obj) { return obj && ['type', 'match', 'handler'].every(function (key) { return predicates_1.isDefined(obj[key]); }); };
	    return UrlRuleFactory;
	}());
	exports.UrlRuleFactory = UrlRuleFactory;
	/**
	 * A base rule which calls `match`
	 *
	 * The value from the `match` function is passed through to the `handler`.
	 * @internal
	 */
	var BaseUrlRule = /** @class */ (function () {
	    function BaseUrlRule(match, handler) {
	        var _this = this;
	        this.match = match;
	        this.type = 'RAW';
	        this.matchPriority = function (match) { return 0 - _this.$id; };
	        this.handler = handler || common_1.identity;
	    }
	    return BaseUrlRule;
	}());
	exports.BaseUrlRule = BaseUrlRule;
	//# sourceMappingURL=urlRule.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.locationPluginFactory = exports.buildUrl = exports.parseUrl = exports.getParams = exports.keyValsToObjectR = void 0;
	var common_1 = __webpack_require__(4);
	exports.keyValsToObjectR = function (accum, _a) {
	    var key = _a[0], val = _a[1];
	    if (!accum.hasOwnProperty(key)) {
	        accum[key] = val;
	    }
	    else if (common_1.isArray(accum[key])) {
	        accum[key].push(val);
	    }
	    else {
	        accum[key] = [accum[key], val];
	    }
	    return accum;
	};
	exports.getParams = function (queryString) {
	    return queryString.split('&').filter(common_1.identity).map(common_1.splitEqual).reduce(exports.keyValsToObjectR, {});
	};
	function parseUrl(url) {
	    var orEmptyString = function (x) { return x || ''; };
	    var _a = common_1.splitHash(url).map(orEmptyString), beforehash = _a[0], hash = _a[1];
	    var _b = common_1.splitQuery(beforehash).map(orEmptyString), path = _b[0], search = _b[1];
	    return { path: path, search: search, hash: hash, url: url };
	}
	exports.parseUrl = parseUrl;
	exports.buildUrl = function (loc) {
	    var path = loc.path();
	    var searchObject = loc.search();
	    var hash = loc.hash();
	    var search = Object.keys(searchObject)
	        .map(function (key) {
	        var param = searchObject[key];
	        var vals = common_1.isArray(param) ? param : [param];
	        return vals.map(function (val) { return key + '=' + val; });
	    })
	        .reduce(common_1.unnestR, [])
	        .join('&');
	    return path + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	};
	function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
	    return function (uiRouter) {
	        var service = (uiRouter.locationService = new serviceClass(uiRouter));
	        var configuration = (uiRouter.locationConfig = new configurationClass(uiRouter, isHtml5));
	        function dispose(router) {
	            router.dispose(service);
	            router.dispose(configuration);
	        }
	        return { name: name, service: service, configuration: configuration, dispose: dispose };
	    };
	}
	exports.locationPluginFactory = locationPluginFactory;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.safeConsole = void 0;
	/**
	 * workaround for missing console object in IE9 when dev tools haven't been opened o_O
	 * @packageDocumentation
	 */
	/* tslint:disable:no-console */
	var common_1 = __webpack_require__(1);
	var noopConsoleStub = { log: common_1.noop, error: common_1.noop, table: common_1.noop };
	function ie9Console(console) {
	    var bound = function (fn) { return Function.prototype.bind.call(fn, console); };
	    return {
	        log: bound(console.log),
	        error: bound(console.log),
	        table: bound(console.log),
	    };
	}
	function fallbackConsole(console) {
	    var log = console.log.bind(console);
	    var error = console.error ? console.error.bind(console) : log;
	    var table = console.table ? console.table.bind(console) : log;
	    return { log: log, error: error, table: table };
	}
	function getSafeConsole() {
	    // @ts-ignore
	    var isIE9 = typeof document !== 'undefined' && document.documentMode && document.documentMode === 9;
	    if (isIE9) {
	        return window && window.console ? ie9Console(window.console) : noopConsoleStub;
	    }
	    else if (!console.table || !console.error) {
	        return fallbackConsole(console);
	    }
	    else {
	        return console;
	    }
	}
	exports.safeConsole = getSafeConsole();
	//# sourceMappingURL=safeConsole.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouterGlobals = void 0;
	var stateParams_1 = __webpack_require__(52);
	var queue_1 = __webpack_require__(36);
	/**
	 * Global router state
	 *
	 * This is where we hold the global mutable state such as current state, current
	 * params, current transition, etc.
	 */
	var UIRouterGlobals = /** @class */ (function () {
	    function UIRouterGlobals() {
	        /**
	         * Current parameter values
	         *
	         * The parameter values from the latest successful transition
	         */
	        this.params = new stateParams_1.StateParams();
	        /** @internal */
	        this.lastStartedTransitionId = -1;
	        /** @internal */
	        this.transitionHistory = new queue_1.Queue([], 1);
	        /** @internal */
	        this.successfulTransitions = new queue_1.Queue([], 1);
	    }
	    UIRouterGlobals.prototype.dispose = function () {
	        this.transitionHistory.clear();
	        this.successfulTransitions.clear();
	        this.transition = null;
	    };
	    return UIRouterGlobals;
	}());
	exports.UIRouterGlobals = UIRouterGlobals;
	//# sourceMappingURL=globals.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.lazyLoadState = exports.registerLazyLoadHook = void 0;
	var coreservices_1 = __webpack_require__(5);
	/**
	 * A [[TransitionHookFn]] that performs lazy loading
	 *
	 * When entering a state "abc" which has a `lazyLoad` function defined:
	 * - Invoke the `lazyLoad` function (unless it is already in process)
	 *   - Flag the hook function as "in process"
	 *   - The function should return a promise (that resolves when lazy loading is complete)
	 * - Wait for the promise to settle
	 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
	 *   - Flag the hook function as "not in process"
	 * - If the hook was successful
	 *   - Remove the `lazyLoad` function from the state declaration
	 * - If all the hooks were successful
	 *   - Retry the transition (by returning a TargetState)
	 *
	 * ```
	 * .state('abc', {
	 *   component: 'fooComponent',
	 *   lazyLoad: () => import('./fooComponent')
	 *   });
	 * ```
	 *
	 * See [[StateDeclaration.lazyLoad]]
	 */
	var lazyLoadHook = function (transition) {
	    var router = transition.router;
	    function retryTransition() {
	        if (transition.originalTransition().options().source !== 'url') {
	            // The original transition was not triggered via url sync
	            // The lazy state should be loaded now, so re-try the original transition
	            var orig = transition.targetState();
	            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
	        }
	        // The original transition was triggered via url sync
	        // Run the URL rules and find the best match
	        var $url = router.urlService;
	        var result = $url.match($url.parts());
	        var rule = result && result.rule;
	        // If the best match is a state, redirect the transition (instead
	        // of calling sync() which supersedes the current transition)
	        if (rule && rule.type === 'STATE') {
	            var state = rule.state;
	            var params = result.match;
	            return router.stateService.target(state, params, transition.options());
	        }
	        // No matching state found, so let .sync() choose the best non-state match/otherwise
	        router.urlService.sync();
	    }
	    var promises = transition
	        .entering()
	        .filter(function (state) { return !!state.$$state().lazyLoad; })
	        .map(function (state) { return lazyLoadState(transition, state); });
	    return coreservices_1.services.$q.all(promises).then(retryTransition);
	};
	exports.registerLazyLoadHook = function (transitionService) {
	    return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
	};
	/**
	 * Invokes a state's lazy load function
	 *
	 * @param transition a Transition context
	 * @param state the state to lazy load
	 * @returns A promise for the lazy load result
	 */
	function lazyLoadState(transition, state) {
	    var lazyLoadFn = state.$$state().lazyLoad;
	    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
	    var promise = lazyLoadFn['_promise'];
	    if (!promise) {
	        var success = function (result) {
	            delete state.lazyLoad;
	            delete state.$$state().lazyLoad;
	            delete lazyLoadFn['_promise'];
	            return result;
	        };
	        var error = function (err) {
	            delete lazyLoadFn['_promise'];
	            return coreservices_1.services.$q.reject(err);
	        };
	        promise = lazyLoadFn['_promise'] = coreservices_1.services.$q
	            .when(lazyLoadFn(transition, state))
	            .then(updateStateRegistry)
	            .then(success, error);
	    }
	    /** Register any lazy loaded state definitions */
	    function updateStateRegistry(result) {
	        if (result && Array.isArray(result.states)) {
	            result.states.forEach(function (_state) { return transition.router.stateRegistry.register(_state); });
	        }
	        return result;
	    }
	    return promise;
	}
	exports.lazyLoadState = lazyLoadState;
	//# sourceMappingURL=lazyLoad.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateParams = void 0;
	var common_1 = __webpack_require__(1);
	var StateParams = /** @class */ (function () {
	    function StateParams(params) {
	        if (params === void 0) { params = {}; }
	        common_1.extend(this, params);
	    }
	    /**
	     * Merges a set of parameters with all parameters inherited between the common parents of the
	     * current state and a given destination state.
	     *
	     * @param {Object} newParams The set of parameters which will be composited with inherited params.
	     * @param {Object} $current Internal definition of object representing the current state.
	     * @param {Object} $to Internal definition of object representing state to transition to.
	     */
	    StateParams.prototype.$inherit = function (newParams, $current, $to) {
	        var parentParams;
	        var parents = common_1.ancestors($current, $to), inherited = {}, inheritList = [];
	        for (var i in parents) {
	            if (!parents[i] || !parents[i].params)
	                continue;
	            parentParams = Object.keys(parents[i].params);
	            if (!parentParams.length)
	                continue;
	            for (var j in parentParams) {
	                if (inheritList.indexOf(parentParams[j]) >= 0)
	                    continue;
	                inheritList.push(parentParams[j]);
	                inherited[parentParams[j]] = this[parentParams[j]];
	            }
	        }
	        return common_1.extend({}, inherited, newParams);
	    };
	    return StateParams;
	}());
	exports.StateParams = StateParams;
	//# sourceMappingURL=stateParams.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(54), exports);
	__exportStar(__webpack_require__(22), exports);
	__exportStar(__webpack_require__(23), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.resolvePolicies = void 0;
	exports.resolvePolicies = {
	    when: {
	        LAZY: 'LAZY',
	        EAGER: 'EAGER',
	    },
	    async: {
	        WAIT: 'WAIT',
	        NOWAIT: 'NOWAIT',
	    },
	};
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouter = void 0;
	var urlMatcherFactory_1 = __webpack_require__(64);
	var urlRouter_1 = __webpack_require__(65);
	var transitionService_1 = __webpack_require__(44);
	var view_1 = __webpack_require__(75);
	var stateRegistry_1 = __webpack_require__(59);
	var stateService_1 = __webpack_require__(60);
	var globals_1 = __webpack_require__(50);
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var urlService_1 = __webpack_require__(67);
	var trace_1 = __webpack_require__(9);
	var common_2 = __webpack_require__(4);
	/** @internal */
	var _routerInstance = 0;
	/** @internal */
	var locSvcFns = ['url', 'path', 'search', 'hash', 'onChange'];
	/** @internal */
	var locCfgFns = ['port', 'protocol', 'host', 'baseHref', 'html5Mode', 'hashPrefix'];
	/** @internal */
	var locationServiceStub = common_2.makeStub('LocationServices', locSvcFns);
	/** @internal */
	var locationConfigStub = common_2.makeStub('LocationConfig', locCfgFns);
	/**
	 * An instance of UI-Router.
	 *
	 * This object contains references to service APIs which define your application's routing behavior.
	 */
	var UIRouter = /** @class */ (function () {
	    /**
	     * Creates a new `UIRouter` object
	     *
	     * @param locationService a [[LocationServices]] implementation
	     * @param locationConfig a [[LocationConfig]] implementation
	     * @internal
	     */
	    function UIRouter(locationService, locationConfig) {
	        if (locationService === void 0) { locationService = locationServiceStub; }
	        if (locationConfig === void 0) { locationConfig = locationConfigStub; }
	        this.locationService = locationService;
	        this.locationConfig = locationConfig;
	        /** @internal */ this.$id = _routerInstance++;
	        /** @internal */ this._disposed = false;
	        /** @internal */ this._disposables = [];
	        /** Enable/disable tracing to the javascript console */
	        this.trace = trace_1.trace;
	        /** Provides services related to ui-view synchronization */
	        this.viewService = new view_1.ViewService(this);
	        /** An object that contains global router state, such as the current state and params */
	        this.globals = new globals_1.UIRouterGlobals();
	        /** A service that exposes global Transition Hooks */
	        this.transitionService = new transitionService_1.TransitionService(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlRouter = new urlRouter_1.UrlRouter(this);
	        /** Provides services related to the URL */
	        this.urlService = new urlService_1.UrlService(this);
	        /** Provides a registry for states, and related registration services */
	        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
	        /** Provides services related to states */
	        this.stateService = new stateService_1.StateService(this);
	        /** @internal plugin instances are registered here */
	        this._plugins = {};
	        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
	        this.globals.$current = this.stateRegistry.root();
	        this.globals.current = this.globals.$current.self;
	        this.disposable(this.globals);
	        this.disposable(this.stateService);
	        this.disposable(this.stateRegistry);
	        this.disposable(this.transitionService);
	        this.disposable(this.urlService);
	        this.disposable(locationService);
	        this.disposable(locationConfig);
	    }
	    /** Registers an object to be notified when the router is disposed */
	    UIRouter.prototype.disposable = function (disposable) {
	        this._disposables.push(disposable);
	    };
	    /**
	     * Disposes this router instance
	     *
	     * When called, clears resources retained by the router by calling `dispose(this)` on all
	     * registered [[disposable]] objects.
	     *
	     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
	     *
	     * @internal
	     * @param disposable (optional) the disposable to dispose
	     */
	    UIRouter.prototype.dispose = function (disposable) {
	        var _this = this;
	        if (disposable && predicates_1.isFunction(disposable.dispose)) {
	            disposable.dispose(this);
	            return undefined;
	        }
	        this._disposed = true;
	        this._disposables.slice().forEach(function (d) {
	            try {
	                typeof d.dispose === 'function' && d.dispose(_this);
	                common_1.removeFrom(_this._disposables, d);
	            }
	            catch (ignored) { }
	        });
	    };
	    /**
	     * Adds a plugin to UI-Router
	     *
	     * This method adds a UI-Router Plugin.
	     * A plugin can enhance or change UI-Router behavior using any public API.
	     *
	     * #### Example:
	     * ```js
	     * import { MyCoolPlugin } from "ui-router-cool-plugin";
	     *
	     * var plugin = router.addPlugin(MyCoolPlugin);
	     * ```
	     *
	     * ### Plugin authoring
	     *
	     * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
	     *
	     * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
	     * For example, it may configure router options or add a Transition Hook.
	     *
	     * The plugin can then be published as a separate module.
	     *
	     * #### Example:
	     * ```js
	     * export class MyAuthPlugin implements UIRouterPlugin {
	     *   constructor(router: UIRouter, options: any) {
	     *     this.name = "MyAuthPlugin";
	     *     let $transitions = router.transitionService;
	     *     let $state = router.stateService;
	     *
	     *     let authCriteria = {
	     *       to: (state) => state.data && state.data.requiresAuth
	     *     };
	     *
	     *     function authHook(transition: Transition) {
	     *       let authService = transition.injector().get('AuthService');
	     *       if (!authService.isAuthenticated()) {
	     *         return $state.target('login');
	     *       }
	     *     }
	     *
	     *     $transitions.onStart(authCriteria, authHook);
	     *   }
	     * }
	     * ```
	     *
	     * @param plugin one of:
	     *        - a plugin class which implements [[UIRouterPlugin]]
	     *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
	     *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
	     * @param options options to pass to the plugin class/factory
	     * @returns the registered plugin instance
	     */
	    UIRouter.prototype.plugin = function (plugin, options) {
	        if (options === void 0) { options = {}; }
	        var pluginInstance = new plugin(this, options);
	        if (!pluginInstance.name)
	            throw new Error('Required property `name` missing on plugin: ' + pluginInstance);
	        this._disposables.push(pluginInstance);
	        return (this._plugins[pluginInstance.name] = pluginInstance);
	    };
	    UIRouter.prototype.getPlugin = function (pluginName) {
	        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
	    };
	    return UIRouter;
	}());
	exports.UIRouter = UIRouter;
	//# sourceMappingURL=router.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateBuilder = exports.resolvablesBuilder = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var strings_1 = __webpack_require__(6);
	var hof_1 = __webpack_require__(3);
	var resolvable_1 = __webpack_require__(22);
	var coreservices_1 = __webpack_require__(5);
	var parseUrl = function (url) {
	    if (!predicates_1.isString(url))
	        return false;
	    var root = url.charAt(0) === '^';
	    return { val: root ? url.substring(1) : url, root: root };
	};
	function nameBuilder(state) {
	    return state.name;
	}
	function selfBuilder(state) {
	    state.self.$$state = function () { return state; };
	    return state.self;
	}
	function dataBuilder(state) {
	    if (state.parent && state.parent.data) {
	        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
	    }
	    return state.data;
	}
	var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
	    return function urlBuilder(stateObject) {
	        var stateDec = stateObject.self;
	        // For future states, i.e., states whose name ends with `.**`,
	        // match anything that starts with the url prefix
	        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
	            var newStateDec = {};
	            common_1.copy(stateDec, newStateDec);
	            newStateDec.url += '{remainder:any}'; // match any path (.*)
	            stateDec = newStateDec;
	        }
	        var parent = stateObject.parent;
	        var parsed = parseUrl(stateDec.url);
	        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, { state: stateDec });
	        if (!url)
	            return null;
	        if (!$urlMatcherFactoryProvider.isMatcher(url))
	            throw new Error("Invalid url '" + url + "' in state '" + stateObject + "'");
	        return parsed && parsed.root ? url : ((parent && parent.navigable) || root()).url.append(url);
	    };
	};
	var getNavigableBuilder = function (isRoot) {
	    return function navigableBuilder(state) {
	        return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
	    };
	};
	var getParamsBuilder = function (paramFactory) {
	    return function paramsBuilder(state) {
	        var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, state.self); };
	        var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
	        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
	        return urlParams
	            .concat(nonUrlParams)
	            .map(function (p) { return [p.id, p]; })
	            .reduce(common_1.applyPairs, {});
	    };
	};
	function pathBuilder(state) {
	    return state.parent ? state.parent.path.concat(state) : /*root*/ [state];
	}
	function includesBuilder(state) {
	    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
	    includes[state.name] = true;
	    return includes;
	}
	/**
	 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
	 *
	 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	 * validates the `resolve` property and converts it to a [[Resolvable]] array.
	 *
	 * resolve: input value can be:
	 *
	 * {
	 *   // analyzed but not injected
	 *   myFooResolve: function() { return "myFooData"; },
	 *
	 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
	 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
	 *
	 *   // Array split; "DependencyName" dep as string
	 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
	 *
	 *   // Array split; DependencyType dep as token (compared using ===)
	 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
	 *
	 *   // val.$inject used as deps
	 *   // where:
	 *   //     corgeResolve.$inject = ["DependencyName"];
	 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
	 *   // then "DependencyName" dep as string
	 *   myCorgeResolve: corgeResolve,
	 *
	 *  // inject service by name
	 *  // When a string is found, desugar creating a resolve that injects the named service
	 *   myGraultResolve: "SomeService"
	 * }
	 *
	 * or:
	 *
	 * [
	 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
	 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
	 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
	 * ]
	 */
	function resolvablesBuilder(state) {
	    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
	    var objects2Tuples = function (resolveObj, resolvePolicies) {
	        return Object.keys(resolveObj || {}).map(function (token) { return ({
	            token: token,
	            val: resolveObj[token],
	            deps: undefined,
	            policy: resolvePolicies[token],
	        }); });
	    };
	    /** fetch DI annotations from a function or ng1-style array */
	    var annotate = function (fn) {
	        var $injector = coreservices_1.services.$injector;
	        // ng1 doesn't have an $injector until runtime.
	        // If the $injector doesn't exist, use "deferred" literal as a
	        // marker indicating they should be annotated when runtime starts
	        return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || 'deferred';
	    };
	    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
	    var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
	    /** true if the object looks like a provide literal, or a ng2 Provider */
	    var isLikeNg2Provider = function (obj) {
	        return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
	    };
	    /** true if the object looks like a tuple from obj2Tuples */
	    var isTupleFromObj = function (obj) {
	        return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val)));
	    };
	    /** extracts the token from a Provider or provide literal */
	    var getToken = function (p) { return p.provide || p.token; };
	    // prettier-ignore: Given a literal resolve or provider object, returns a Resolvable
	    var literal2Resolvable = hof_1.pattern([
	        [hof_1.prop('resolveFn'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.resolveFn, p.deps, p.policy); }],
	        [hof_1.prop('useFactory'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.useFactory, p.deps || p.dependencies, p.policy); }],
	        [hof_1.prop('useClass'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return new p.useClass(); }, [], p.policy); }],
	        [hof_1.prop('useValue'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
	        [hof_1.prop('useExisting'), function (p) { return new resolvable_1.Resolvable(getToken(p), common_1.identity, [p.useExisting], p.policy); }],
	    ]);
	    // prettier-ignore
	    var tuple2Resolvable = hof_1.pattern([
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isString), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isArray), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isFunction), function (tuple) { return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
	    ]);
	    // prettier-ignore
	    var item2Resolvable = hof_1.pattern([
	        [hof_1.is(resolvable_1.Resolvable), function (r) { return r; }],
	        [isResolveLiteral, literal2Resolvable],
	        [isLikeNg2Provider, literal2Resolvable],
	        [isTupleFromObj, tuple2Resolvable],
	        [hof_1.val(true), function (obj) { throw new Error('Invalid resolve value: ' + strings_1.stringify(obj)); },],
	    ]);
	    // If resolveBlock is already an array, use it as-is.
	    // Otherwise, assume it's an object and convert to an Array of tuples
	    var decl = state.resolve;
	    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
	    return items.map(item2Resolvable);
	}
	exports.resolvablesBuilder = resolvablesBuilder;
	/**
	 * A internal global service
	 *
	 * StateBuilder is a factory for the internal [[StateObject]] objects.
	 *
	 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
	 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
	 * [[StateObject]] object, which has an API and is used internally.
	 *
	 * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
	 * using the [[builder]] method.
	 */
	var StateBuilder = /** @class */ (function () {
	    function StateBuilder(matcher, urlMatcherFactory) {
	        this.matcher = matcher;
	        var self = this;
	        var root = function () { return matcher.find(''); };
	        var isRoot = function (state) { return state.name === ''; };
	        function parentBuilder(state) {
	            if (isRoot(state))
	                return null;
	            return matcher.find(self.parentName(state)) || root();
	        }
	        this.builders = {
	            name: [nameBuilder],
	            self: [selfBuilder],
	            parent: [parentBuilder],
	            data: [dataBuilder],
	            // Build a URLMatcher if necessary, either via a relative or absolute URL
	            url: [getUrlBuilder(urlMatcherFactory, root)],
	            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	            navigable: [getNavigableBuilder(isRoot)],
	            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
	            // Each framework-specific ui-router implementation should define its own `views` builder
	            // e.g., src/ng1/statebuilders/views.ts
	            views: [],
	            // Keep a full path from the root down to this state as this is needed for state activation.
	            path: [pathBuilder],
	            // Speed up $state.includes() as it's used a lot
	            includes: [includesBuilder],
	            resolvables: [resolvablesBuilder],
	        };
	    }
	    StateBuilder.prototype.builder = function (name, fn) {
	        var builders = this.builders;
	        var array = builders[name] || [];
	        // Backwards compat: if only one builder exists, return it, else return whole arary.
	        if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
	            return array.length > 1 ? array : array[0];
	        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
	            return;
	        builders[name] = array;
	        builders[name].push(fn);
	        return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
	    };
	    /**
	     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
	     * properties and API built.
	     *
	     * @param state an uninitialized State object
	     * @returns the built State object
	     */
	    StateBuilder.prototype.build = function (state) {
	        var _a = this, matcher = _a.matcher, builders = _a.builders;
	        var parent = this.parentName(state);
	        if (parent && !matcher.find(parent, undefined, false)) {
	            return null;
	        }
	        for (var key in builders) {
	            if (!builders.hasOwnProperty(key))
	                continue;
	            var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, common_1.noop);
	            state[key] = chain(state);
	        }
	        return state;
	    };
	    StateBuilder.prototype.parentName = function (state) {
	        // name = 'foo.bar.baz.**'
	        var name = state.name || '';
	        // segments = ['foo', 'bar', 'baz', '.**']
	        var segments = name.split('.');
	        // segments = ['foo', 'bar', 'baz']
	        var lastSegment = segments.pop();
	        // segments = ['foo', 'bar'] (ignore .** segment for future states)
	        if (lastSegment === '**')
	            segments.pop();
	        if (segments.length) {
	            if (state.parent) {
	                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
	            }
	            // 'foo.bar'
	            return segments.join('.');
	        }
	        if (!state.parent)
	            return '';
	        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	    };
	    StateBuilder.prototype.name = function (state) {
	        var name = state.name;
	        if (name.indexOf('.') !== -1 || !state.parent)
	            return name;
	        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	        return parentName ? parentName + '.' + name : name;
	    };
	    return StateBuilder;
	}());
	exports.StateBuilder = StateBuilder;
	//# sourceMappingURL=stateBuilder.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateMatcher = void 0;
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	var safeConsole_1 = __webpack_require__(49);
	var StateMatcher = /** @class */ (function () {
	    function StateMatcher(_states) {
	        this._states = _states;
	    }
	    StateMatcher.prototype.isRelative = function (stateName) {
	        stateName = stateName || '';
	        return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
	    };
	    StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
	        if (matchGlob === void 0) { matchGlob = true; }
	        if (!stateOrName && stateOrName !== '')
	            return undefined;
	        var isStr = predicates_1.isString(stateOrName);
	        var name = isStr ? stateOrName : stateOrName.name;
	        if (this.isRelative(name))
	            name = this.resolvePath(name, base);
	        var state = this._states[name];
	        if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	            return state;
	        }
	        else if (isStr && matchGlob) {
	            var _states = common_1.values(this._states);
	            var matches = _states.filter(function (_state) { return _state.__stateObjectCache.nameGlob && _state.__stateObjectCache.nameGlob.matches(name); });
	            if (matches.length > 1) {
	                safeConsole_1.safeConsole.error("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
	            }
	            return matches[0];
	        }
	        return undefined;
	    };
	    StateMatcher.prototype.resolvePath = function (name, base) {
	        if (!base)
	            throw new Error("No reference point given for path '" + name + "'");
	        var baseState = this.find(base);
	        var splitName = name.split('.');
	        var pathLength = splitName.length;
	        var i = 0, current = baseState;
	        for (; i < pathLength; i++) {
	            if (splitName[i] === '' && i === 0) {
	                current = baseState;
	                continue;
	            }
	            if (splitName[i] === '^') {
	                if (!current.parent)
	                    throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
	                current = current.parent;
	                continue;
	            }
	            break;
	        }
	        var relName = splitName.slice(i).join('.');
	        return current.name + (current.name && relName ? '.' : '') + relName;
	    };
	    return StateMatcher;
	}());
	exports.StateMatcher = StateMatcher;
	//# sourceMappingURL=stateMatcher.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateQueueManager = void 0;
	var common_1 = __webpack_require__(4);
	var stateObject_1 = __webpack_require__(41);
	var StateQueueManager = /** @class */ (function () {
	    function StateQueueManager(router, states, builder, listeners) {
	        this.router = router;
	        this.states = states;
	        this.builder = builder;
	        this.listeners = listeners;
	        this.queue = [];
	    }
	    StateQueueManager.prototype.dispose = function () {
	        this.queue = [];
	    };
	    StateQueueManager.prototype.register = function (stateDecl) {
	        var queue = this.queue;
	        var state = stateObject_1.StateObject.create(stateDecl);
	        var name = state.name;
	        if (!common_1.isString(name))
	            throw new Error('State must have a valid name');
	        if (this.states.hasOwnProperty(name) || common_1.inArray(queue.map(common_1.prop('name')), name))
	            throw new Error("State '" + name + "' is already defined");
	        queue.push(state);
	        this.flush();
	        return state;
	    };
	    StateQueueManager.prototype.flush = function () {
	        var _this = this;
	        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
	        var registered = [], // states that got registered
	        orphans = [], // states that don't yet have a parent registered
	        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
	        var getState = function (name) { return _this.states.hasOwnProperty(name) && _this.states[name]; };
	        var notifyListeners = function () {
	            if (registered.length) {
	                _this.listeners.forEach(function (listener) {
	                    return listener('registered', registered.map(function (s) { return s.self; }));
	                });
	            }
	        };
	        while (queue.length > 0) {
	            var state = queue.shift();
	            var name_1 = state.name;
	            var result = builder.build(state);
	            var orphanIdx = orphans.indexOf(state);
	            if (result) {
	                var existingState = getState(name_1);
	                if (existingState && existingState.name === name_1) {
	                    throw new Error("State '" + name_1 + "' is already defined");
	                }
	                var existingFutureState = getState(name_1 + '.**');
	                if (existingFutureState) {
	                    // Remove future state of the same name
	                    this.router.stateRegistry.deregister(existingFutureState);
	                }
	                states[name_1] = state;
	                this.attachRoute(state);
	                if (orphanIdx >= 0)
	                    orphans.splice(orphanIdx, 1);
	                registered.push(state);
	                continue;
	            }
	            var prev = previousQueueLength[name_1];
	            previousQueueLength[name_1] = queue.length;
	            if (orphanIdx >= 0 && prev === queue.length) {
	                // Wait until two consecutive iterations where no additional states were dequeued successfully.
	                // throw new Error(`Cannot register orphaned state '${name}'`);
	                queue.push(state);
	                notifyListeners();
	                return states;
	            }
	            else if (orphanIdx < 0) {
	                orphans.push(state);
	            }
	            queue.push(state);
	        }
	        notifyListeners();
	        return states;
	    };
	    StateQueueManager.prototype.attachRoute = function (state) {
	        if (state.abstract || !state.url)
	            return;
	        var rulesApi = this.router.urlService.rules;
	        rulesApi.rule(rulesApi.urlRuleFactory.create(state));
	    };
	    return StateQueueManager;
	}());
	exports.StateQueueManager = StateQueueManager;
	//# sourceMappingURL=stateQueueManager.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateRegistry = void 0;
	var stateMatcher_1 = __webpack_require__(57);
	var stateBuilder_1 = __webpack_require__(56);
	var stateQueueManager_1 = __webpack_require__(58);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	/**
	 * A registry for all of the application's [[StateDeclaration]]s
	 *
	 * This API is found at `router.stateRegistry` ([[UIRouter.stateRegistry]])
	 */
	var StateRegistry = /** @class */ (function () {
	    /** @internal */
	    function StateRegistry(router) {
	        this.router = router;
	        this.states = {};
	        /** @internal */
	        this.listeners = [];
	        this.matcher = new stateMatcher_1.StateMatcher(this.states);
	        this.builder = new stateBuilder_1.StateBuilder(this.matcher, router.urlMatcherFactory);
	        this.stateQueue = new stateQueueManager_1.StateQueueManager(router, this.states, this.builder, this.listeners);
	        this._registerRoot();
	    }
	    /** @internal */
	    StateRegistry.prototype._registerRoot = function () {
	        var rootStateDef = {
	            name: '',
	            url: '^',
	            views: null,
	            params: {
	                '#': { value: null, type: 'hash', dynamic: true },
	            },
	            abstract: true,
	        };
	        var _root = (this._root = this.stateQueue.register(rootStateDef));
	        _root.navigable = null;
	    };
	    /** @internal */
	    StateRegistry.prototype.dispose = function () {
	        var _this = this;
	        this.stateQueue.dispose();
	        this.listeners = [];
	        this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
	    };
	    /**
	     * Listen for a State Registry events
	     *
	     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
	     *
	     * #### Example:
	     * ```js
	     * let allStates = registry.get();
	     *
	     * // Later, invoke deregisterFn() to remove the listener
	     * let deregisterFn = registry.onStatesChanged((event, states) => {
	     *   switch(event) {
	     *     case: 'registered':
	     *       states.forEach(state => allStates.push(state));
	     *       break;
	     *     case: 'deregistered':
	     *       states.forEach(state => {
	     *         let idx = allStates.indexOf(state);
	     *         if (idx !== -1) allStates.splice(idx, 1);
	     *       });
	     *       break;
	     *   }
	     * });
	     * ```
	     *
	     * @param listener a callback function invoked when the registered states changes.
	     *        The function receives two parameters, `event` and `state`.
	     *        See [[StateRegistryListener]]
	     * @return a function that deregisters the listener
	     */
	    StateRegistry.prototype.onStatesChanged = function (listener) {
	        this.listeners.push(listener);
	        return function deregisterListener() {
	            common_1.removeFrom(this.listeners)(listener);
	        }.bind(this);
	    };
	    /**
	     * Gets the implicit root state
	     *
	     * Gets the root of the state tree.
	     * The root state is implicitly created by UI-Router.
	     * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
	     *
	     * @return the root [[StateObject]]
	     */
	    StateRegistry.prototype.root = function () {
	        return this._root;
	    };
	    /**
	     * Adds a state to the registry
	     *
	     * Registers a [[StateDeclaration]] or queues it for registration.
	     *
	     * Note: a state will be queued if the state's parent isn't yet registered.
	     *
	     * @param stateDefinition the definition of the state to register.
	     * @returns the internal [[StateObject]] object.
	     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
	     *          If the state was only queued, then the object is not fully built.
	     */
	    StateRegistry.prototype.register = function (stateDefinition) {
	        return this.stateQueue.register(stateDefinition);
	    };
	    /** @internal */
	    StateRegistry.prototype._deregisterTree = function (state) {
	        var _this = this;
	        var all = this.get().map(function (s) { return s.$$state(); });
	        var getChildren = function (states) {
	            var _children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
	            return _children.length === 0 ? _children : _children.concat(getChildren(_children));
	        };
	        var children = getChildren([state]);
	        var deregistered = [state].concat(children).reverse();
	        deregistered.forEach(function (_state) {
	            var rulesApi = _this.router.urlService.rules;
	            // Remove URL rule
	            rulesApi
	                .rules()
	                .filter(hof_1.propEq('state', _state))
	                .forEach(function (rule) { return rulesApi.removeRule(rule); });
	            // Remove state from registry
	            delete _this.states[_state.name];
	        });
	        return deregistered;
	    };
	    /**
	     * Removes a state from the registry
	     *
	     * This removes a state from the registry.
	     * If the state has children, they are are also removed from the registry.
	     *
	     * @param stateOrName the state's name or object representation
	     * @returns {StateObject[]} a list of removed states
	     */
	    StateRegistry.prototype.deregister = function (stateOrName) {
	        var _state = this.get(stateOrName);
	        if (!_state)
	            throw new Error("Can't deregister state; not found: " + stateOrName);
	        var deregisteredStates = this._deregisterTree(_state.$$state());
	        this.listeners.forEach(function (listener) {
	            return listener('deregistered', deregisteredStates.map(function (s) { return s.self; }));
	        });
	        return deregisteredStates;
	    };
	    StateRegistry.prototype.get = function (stateOrName, base) {
	        var _this = this;
	        if (arguments.length === 0)
	            return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
	        var found = this.matcher.find(stateOrName, base);
	        return (found && found.self) || null;
	    };
	    /**
	     * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
	     * More than one BuilderFunction can be registered for a given property.
	     *
	     * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
	     *
	     * @param property The name of the State property being registered for.
	     * @param builderFunction The BuilderFunction which will be used to build the State property
	     * @returns a function which deregisters the BuilderFunction
	     */
	    StateRegistry.prototype.decorator = function (property, builderFunction) {
	        return this.builder.builder(property, builderFunction);
	    };
	    return StateRegistry;
	}());
	exports.StateRegistry = StateRegistry;
	//# sourceMappingURL=stateRegistry.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateService = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var queue_1 = __webpack_require__(36);
	var coreservices_1 = __webpack_require__(5);
	var pathUtils_1 = __webpack_require__(21);
	var pathNode_1 = __webpack_require__(39);
	var transitionService_1 = __webpack_require__(44);
	var rejectFactory_1 = __webpack_require__(12);
	var targetState_1 = __webpack_require__(17);
	var param_1 = __webpack_require__(16);
	var glob_1 = __webpack_require__(35);
	var resolveContext_1 = __webpack_require__(23);
	var lazyLoad_1 = __webpack_require__(51);
	var hof_1 = __webpack_require__(3);
	/**
	 * Provides services related to ui-router states.
	 *
	 * This API is located at `router.stateService` ([[UIRouter.stateService]])
	 */
	var StateService = /** @class */ (function () {
	    /** @internal */
	    function StateService(/** @internal */ router) {
	        this.router = router;
	        /** @internal */
	        this.invalidCallbacks = [];
	        /** @internal */
	        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
	            if ($error$ instanceof Error && $error$.stack) {
	                console.error($error$);
	                console.error($error$.stack);
	            }
	            else if ($error$ instanceof rejectFactory_1.Rejection) {
	                console.error($error$.toString());
	                if ($error$.detail && $error$.detail.stack)
	                    console.error($error$.detail.stack);
	            }
	            else {
	                console.error($error$);
	            }
	        };
	        var getters = ['current', '$current', 'params', 'transition'];
	        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
	        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
	    }
	    Object.defineProperty(StateService.prototype, "transition", {
	        /**
	         * The [[Transition]] currently in progress (or null)
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.transition]]
	         */
	        get: function () {
	            return this.router.globals.transition;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "params", {
	        /**
	         * The latest successful state parameters
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.params]]
	         */
	        get: function () {
	            return this.router.globals.params;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "current", {
	        /**
	         * The current [[StateDeclaration]]
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.current]]
	         */
	        get: function () {
	            return this.router.globals.current;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "$current", {
	        /**
	         * The current [[StateObject]] (an internal API)
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.$current]]
	         */
	        get: function () {
	            return this.router.globals.$current;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /** @internal */
	    StateService.prototype.dispose = function () {
	        this.defaultErrorHandler(common_1.noop);
	        this.invalidCallbacks = [];
	    };
	    /**
	     * Handler for when [[transitionTo]] is called with an invalid state.
	     *
	     * Invokes the [[onInvalid]] callbacks, in natural order.
	     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
	     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
	     *
	     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
	     *
	     * @internal
	     */
	    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
	        var _this = this;
	        var fromState = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, fromPath);
	        var globals = this.router.globals;
	        var latestThing = function () { return globals.transitionHistory.peekTail(); };
	        var latest = latestThing();
	        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
	        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
	        var checkForRedirect = function (result) {
	            if (!(result instanceof targetState_1.TargetState)) {
	                return;
	            }
	            var target = result;
	            // Recreate the TargetState, in case the state is now defined.
	            target = _this.target(target.identifier(), target.params(), target.options());
	            if (!target.valid()) {
	                return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
	            }
	            if (latestThing() !== latest) {
	                return rejectFactory_1.Rejection.superseded().toPromise();
	            }
	            return _this.transitionTo(target.identifier(), target.params(), target.options());
	        };
	        function invokeNextCallback() {
	            var nextCallback = callbackQueue.dequeue();
	            if (nextCallback === undefined)
	                return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
	            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
	            return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
	        }
	        return invokeNextCallback();
	    };
	    /**
	     * Registers an Invalid State handler
	     *
	     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
	     * has been called with an invalid state reference parameter
	     *
	     * Example:
	     * ```js
	     * stateService.onInvalid(function(to, from, injector) {
	     *   if (to.name() === 'foo') {
	     *     let lazyLoader = injector.get('LazyLoadService');
	     *     return lazyLoader.load('foo')
	     *         .then(() => stateService.target('foo'));
	     *   }
	     * });
	     * ```
	     *
	     * @param {function} callback invoked when the toState is invalid
	     *   This function receives the (invalid) toState, the fromState, and an injector.
	     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
	     *   If one is returned, it is treated as a redirect.
	     *
	     * @returns a function which deregisters the callback
	     */
	    StateService.prototype.onInvalid = function (callback) {
	        this.invalidCallbacks.push(callback);
	        return function deregisterListener() {
	            common_1.removeFrom(this.invalidCallbacks)(callback);
	        }.bind(this);
	    };
	    /**
	     * Reloads the current state
	     *
	     * A method that force reloads the current state, or a partial state hierarchy.
	     * All resolves are re-resolved, and components reinstantiated.
	     *
	     * #### Example:
	     * ```js
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * ```
	     *
	     * Note: `reload()` is just an alias for:
	     *
	     * ```js
	     * $state.transitionTo($state.current, $state.params, {
	     *   reload: true, inherit: false
	     * });
	     * ```
	     *
	     * @param reloadState A state name or a state object.
	     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
	     *
	     * #### Example:
	     * ```js
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
	     * //and current state is 'contacts.detail.item'
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * ```
	     *
	     * @returns A promise representing the state of the new transition. See [[StateService.go]]
	     */
	    StateService.prototype.reload = function (reloadState) {
	        return this.transitionTo(this.current, this.params, {
	            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
	            inherit: false,
	            notify: false,
	        });
	    };
	    /**
	     * Transition to a different state and/or parameters
	     *
	     * Convenience method for transitioning to a new state.
	     *
	     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
	     * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
	     * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
	     * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
	     * inherit from the current parameter values (because of `inherit: true`).
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to Absolute state name, state object, or relative state path (relative to current state).
	     *
	     * Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to the parent state
	     * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
	     * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
	     *
	     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
	     *
	     *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
	     *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
	     *
	     * @param options Transition options
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     */
	    StateService.prototype.go = function (to, params, options) {
	        var defautGoOpts = { relative: this.$current, inherit: true };
	        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
	        return this.transitionTo(to, params, transOpts);
	    };
	    /**
	     * Creates a [[TargetState]]
	     *
	     * This is a factory method for creating a TargetState
	     *
	     * This may be returned from a Transition Hook to redirect a transition, for example.
	     */
	    StateService.prototype.target = function (identifier, params, options) {
	        if (options === void 0) { options = {}; }
	        // If we're reloading, find the state object to reload from
	        if (predicates_1.isObject(options.reload) && !options.reload.name)
	            throw new Error('Invalid reload state object');
	        var reg = this.router.stateRegistry;
	        options.reloadState =
	            options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
	        if (options.reload && !options.reloadState)
	            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
	        return new targetState_1.TargetState(this.router.stateRegistry, identifier, params, options);
	    };
	    /** @internal */
	    StateService.prototype.getCurrentPath = function () {
	        var _this = this;
	        var globals = this.router.globals;
	        var latestSuccess = globals.successfulTransitions.peekTail();
	        var rootPath = function () { return [new pathNode_1.PathNode(_this.router.stateRegistry.root())]; };
	        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
	    };
	    /**
	     * Low-level method for transitioning to a new state.
	     *
	     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to State name or state object.
	     * @param toParams A map of the parameters that will be sent to the state,
	     *      will populate $stateParams.
	     * @param options Transition options
	     *
	     * @returns A promise representing the state of the new transition. See [[go]]
	     */
	    StateService.prototype.transitionTo = function (to, toParams, options) {
	        var _this = this;
	        if (toParams === void 0) { toParams = {}; }
	        if (options === void 0) { options = {}; }
	        var router = this.router;
	        var globals = router.globals;
	        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
	        var getCurrent = function () { return globals.transition; };
	        options = common_1.extend(options, { current: getCurrent });
	        var ref = this.target(to, toParams, options);
	        var currentPath = this.getCurrentPath();
	        if (!ref.exists())
	            return this._handleInvalidTargetState(currentPath, ref);
	        if (!ref.valid())
	            return common_1.silentRejection(ref.error());
	        if (options.supercede === false && getCurrent()) {
	            return (rejectFactory_1.Rejection.ignored('Another transition is in progress and supercede has been set to false in TransitionOptions for the transition. So the transition was ignored in favour of the existing one in progress.').toPromise());
	        }
	        /**
	         * Special handling for Ignored, Aborted, and Redirected transitions
	         *
	         * The semantics for the transition.run() promise and the StateService.transitionTo()
	         * promise differ. For instance, the run() promise may be rejected because it was
	         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
	         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
	         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
	         */
	        var rejectedTransitionHandler = function (trans) { return function (error) {
	            if (error instanceof rejectFactory_1.Rejection) {
	                var isLatest = router.globals.lastStartedTransitionId <= trans.$id;
	                if (error.type === rejectFactory_1.RejectType.IGNORED) {
	                    isLatest && router.urlRouter.update();
	                    // Consider ignored `Transition.run()` as a successful `transitionTo`
	                    return coreservices_1.services.$q.when(globals.current);
	                }
	                var detail = error.detail;
	                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
	                    // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
	                    // by returning the promise for the new (redirect) `Transition.run()`.
	                    var redirect = trans.redirect(detail);
	                    return redirect.run().catch(rejectedTransitionHandler(redirect));
	                }
	                if (error.type === rejectFactory_1.RejectType.ABORTED) {
	                    isLatest && router.urlRouter.update();
	                    return coreservices_1.services.$q.reject(error);
	                }
	            }
	            var errorHandler = _this.defaultErrorHandler();
	            errorHandler(error);
	            return coreservices_1.services.$q.reject(error);
	        }; };
	        var transition = this.router.transitionService.create(currentPath, ref);
	        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
	        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
	        // Return a promise for the transition, which also has the transition object on it.
	        return common_1.extend(transitionToPromise, { transition: transition });
	    };
	    /**
	     * Checks if the current state *is* the provided state
	     *
	     * Similar to [[includes]] but only checks for the full state name.
	     * If params is supplied then it will be tested for strict equality against the current
	     * active params object, so all params must match with none missing and no extras.
	     *
	     * #### Example:
	     * ```js
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     * ```
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * ```html
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * ```
	     *
	     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns Returns true if it is the state.
	     */
	    StateService.prototype.is = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (this.$current !== state)
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Checks if the current state *includes* the provided state
	     *
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * #### Example when `$state.$current.name === 'contacts.details.item'`
	     * ```js
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     * ```
	     *
	     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
	     * ```js
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * ```
	     *
	     * @param stateOrName A partial name, relative name, glob pattern,
	     *   or state object to be searched for within the current state name.
	     * @param params A param object, e.g. `{sectionId: section.id}`,
	     *   that you'd like to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    StateService.prototype.includes = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
	        if (glob) {
	            if (!glob.matches(this.$current.name))
	                return false;
	            stateOrName = this.$current.name;
	        }
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (!predicates_1.isDefined(include[state.name]))
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Generates a URL for a state and parameters
	     *
	     * Returns the url for the given state populated with the given params.
	     *
	     * #### Example:
	     * ```js
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * ```
	     *
	     * @param stateOrName The state name or state object you'd like to generate a url from.
	     * @param params An object of parameter values to fill the state's required parameters.
	     * @param options Options object. The options are:
	     *
	     * @returns {string} compiled state url
	     */
	    StateService.prototype.href = function (stateOrName, params, options) {
	        var defaultHrefOpts = {
	            lossy: true,
	            inherit: true,
	            absolute: false,
	            relative: this.$current,
	        };
	        options = common_1.defaults(options, defaultHrefOpts);
	        params = params || {};
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return null;
	        if (options.inherit)
	            params = this.params.$inherit(params, this.$current, state);
	        var nav = state && options.lossy ? state.navigable : state;
	        if (!nav || nav.url === undefined || nav.url === null) {
	            return null;
	        }
	        return this.router.urlRouter.href(nav.url, params, { absolute: options.absolute });
	    };
	    /**
	     * Sets or gets the default [[transitionTo]] error handler.
	     *
	     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
	     * This includes errors caused by resolves and transition hooks.
	     *
	     * Note:
	     * This handler does not receive certain Transition rejections.
	     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
	     *
	     * The built-in default error handler logs the error to the console.
	     *
	     * You can provide your own custom handler.
	     *
	     * #### Example:
	     * ```js
	     * stateService.defaultErrorHandler(function() {
	     *   // Do not log transitionTo errors
	     * });
	     * ```
	     *
	     * @param handler a global error handler function
	     * @returns the current global error handler
	     */
	    StateService.prototype.defaultErrorHandler = function (handler) {
	        return (this._defaultErrorHandler = handler || this._defaultErrorHandler);
	    };
	    StateService.prototype.get = function (stateOrName, base) {
	        var reg = this.router.stateRegistry;
	        if (arguments.length === 0)
	            return reg.get();
	        return reg.get(stateOrName, base || this.$current);
	    };
	    /**
	     * Lazy loads a state
	     *
	     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
	     *
	     * @param stateOrName the state that should be lazy loaded
	     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
	     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
	     * This noop transition is not actually run.
	     *
	     * @returns a promise to lazy load
	     */
	    StateService.prototype.lazyLoad = function (stateOrName, transition) {
	        var state = this.get(stateOrName);
	        if (!state || !state.lazyLoad)
	            throw new Error('Can not lazy load ' + stateOrName);
	        var currentPath = this.getCurrentPath();
	        var target = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, currentPath);
	        transition = transition || this.router.transitionService.create(currentPath, target);
	        return lazyLoad_1.lazyLoadState(transition, state);
	    };
	    return StateService;
	}());
	exports.StateService = StateService;
	//# sourceMappingURL=stateService.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HookBuilder = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var interface_1 = __webpack_require__(11);
	var transitionHook_1 = __webpack_require__(18);
	/**
	 * This class returns applicable TransitionHooks for a specific Transition instance.
	 *
	 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
	 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
	 * determined by the type of hook)
	 *
	 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
	 *
	 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
	 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
	 * in the Transition class, so we must also provide the Transition's _treeChanges)
	 */
	var HookBuilder = /** @class */ (function () {
	    function HookBuilder(transition) {
	        this.transition = transition;
	    }
	    HookBuilder.prototype.buildHooksForPhase = function (phase) {
	        var _this = this;
	        var $transitions = this.transition.router.transitionService;
	        return $transitions._pluginapi
	            ._getEvents(phase)
	            .map(function (type) { return _this.buildHooks(type); })
	            .reduce(common_1.unnestR, [])
	            .filter(common_1.identity);
	    };
	    /**
	     * Returns an array of newly built TransitionHook objects.
	     *
	     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
	     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
	     * - For each of the [[PathNode]]s, creates a TransitionHook
	     *
	     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
	     */
	    HookBuilder.prototype.buildHooks = function (hookType) {
	        var transition = this.transition;
	        var treeChanges = transition.treeChanges();
	        // Find all the matching registered hooks for a given hook type
	        var matchingHooks = this.getMatchingHooks(hookType, treeChanges, transition);
	        if (!matchingHooks)
	            return [];
	        var baseHookOptions = {
	            transition: transition,
	            current: transition.options().current,
	        };
	        var makeTransitionHooks = function (hook) {
	            // Fetch the Nodes that caused this hook to match.
	            var matches = hook.matches(treeChanges, transition);
	            // Select the PathNode[] that will be used as TransitionHook context objects
	            var matchingNodes = matches[hookType.criteriaMatchPath.name];
	            // Return an array of HookTuples
	            return matchingNodes.map(function (node) {
	                var _options = common_1.extend({
	                    bind: hook.bind,
	                    traceData: { hookType: hookType.name, context: node },
	                }, baseHookOptions);
	                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state.self : null;
	                var transitionHook = new transitionHook_1.TransitionHook(transition, state, hook, _options);
	                return { hook: hook, node: node, transitionHook: transitionHook };
	            });
	        };
	        return matchingHooks
	            .map(makeTransitionHooks)
	            .reduce(common_1.unnestR, [])
	            .sort(tupleSort(hookType.reverseSort))
	            .map(function (tuple) { return tuple.transitionHook; });
	    };
	    /**
	     * Finds all RegisteredHooks from:
	     * - The Transition object instance hook registry
	     * - The TransitionService ($transitions) global hook registry
	     *
	     * which matched:
	     * - the eventType
	     * - the matchCriteria (to, from, exiting, retained, entering)
	     *
	     * @returns an array of matched [[RegisteredHook]]s
	     */
	    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges, transition) {
	        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
	        // Instance and Global hook registries
	        var $transitions = this.transition.router.transitionService;
	        var registries = isCreate ? [$transitions] : [this.transition, $transitions];
	        return registries
	            .map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
	            .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
	            .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
	            .filter(function (hook) { return hook.matches(treeChanges, transition); }); // Only those satisfying matchCriteria
	    };
	    return HookBuilder;
	}());
	exports.HookBuilder = HookBuilder;
	/**
	 * A factory for a sort function for HookTuples.
	 *
	 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
	 * the EventHook priority.
	 *
	 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
	 * @returns a tuple sort function
	 */
	function tupleSort(reverseDepthSort) {
	    if (reverseDepthSort === void 0) { reverseDepthSort = false; }
	    return function nodeDepthThenPriority(l, r) {
	        var factor = reverseDepthSort ? -1 : 1;
	        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
	        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
	    };
	}
	//# sourceMappingURL=hookBuilder.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionEventType = void 0;
	var transitionHook_1 = __webpack_require__(18);
	/**
	 * This class defines a type of hook, such as `onBefore` or `onEnter`.
	 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
	 */
	var TransitionEventType = /** @class */ (function () {
	    /* tslint:disable:no-inferrable-types */
	    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        this.name = name;
	        this.hookPhase = hookPhase;
	        this.hookOrder = hookOrder;
	        this.criteriaMatchPath = criteriaMatchPath;
	        this.reverseSort = reverseSort;
	        this.getResultHandler = getResultHandler;
	        this.getErrorHandler = getErrorHandler;
	        this.synchronous = synchronous;
	    }
	    return TransitionEventType;
	}());
	exports.TransitionEventType = TransitionEventType;
	//# sourceMappingURL=transitionEventType.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlConfig = void 0;
	var params_1 = __webpack_require__(37);
	var common_1 = __webpack_require__(4);
	/**
	 * An API to customize the URL behavior and retrieve URL configuration
	 *
	 * This API is used to customize the behavior of the URL.
	 * This includes optional trailing slashes ([[strictMode]]), case sensitivity ([[caseInsensitive]]),
	 * and custom parameter encoding (custom [[type]]).
	 *
	 * It also has information about the location (url) configuration such as [[port]] and [[baseHref]].
	 * This information can be used to build absolute URLs, such as
	 * `https://example.com:443/basepath/state/substate?param1=a#hashvalue`;
	 *
	 * This API is found at `router.urlService.config` (see: [[UIRouter.urlService]], [[URLService.config]])
	 */
	var UrlConfig = /** @class */ (function () {
	    /** @internal */ function UrlConfig(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this.paramTypes = new params_1.ParamTypes();
	        /** @internal */ this._decodeParams = true;
	        /** @internal */ this._isCaseInsensitive = false;
	        /** @internal */ this._isStrictMode = true;
	        /** @internal */ this._defaultSquashPolicy = false;
	        /** @internal */ this.dispose = function () { return _this.paramTypes.dispose(); };
	        // Delegate these calls to the current LocationConfig implementation
	        /**
	         * Gets the base Href, e.g., `http://localhost/approot/`
	         *
	         * @return the application's base href
	         */
	        this.baseHref = function () { return _this.router.locationConfig.baseHref(); };
	        /**
	         * Gets or sets the hashPrefix
	         *
	         * This only applies when not running in [[html5Mode]] (pushstate mode)
	         *
	         * If the current url is `http://localhost/app#!/uirouter/path/#anchor`, it returns `!` which is the prefix for the "hashbang" portion.
	         *
	         * @return the hash prefix
	         */
	        this.hashPrefix = function (newprefix) { return _this.router.locationConfig.hashPrefix(newprefix); };
	        /**
	         * Gets the host, e.g., `localhost`
	         *
	         * @return the protocol
	         */
	        this.host = function () { return _this.router.locationConfig.host(); };
	        /**
	         * Returns true when running in pushstate mode
	         *
	         * @return true when running in html5 mode (pushstate mode).
	         */
	        this.html5Mode = function () { return _this.router.locationConfig.html5Mode(); };
	        /**
	         * Gets the port, e.g., `80`
	         *
	         * @return the port number
	         */
	        this.port = function () { return _this.router.locationConfig.port(); };
	        /**
	         * Gets the protocol, e.g., `http`
	         *
	         * @return the protocol
	         */
	        this.protocol = function () { return _this.router.locationConfig.protocol(); };
	    }
	    /**
	     * Defines whether URL matching should be case sensitive (the default behavior), or not.
	     *
	     * #### Example:
	     * ```js
	     * // Allow case insensitive url matches
	     * urlService.config.caseInsensitive(true);
	     * ```
	     *
	     * @param value `false` to match URL in a case sensitive manner; otherwise `true`;
	     * @returns the current value of caseInsensitive
	     */
	    UrlConfig.prototype.caseInsensitive = function (value) {
	        return (this._isCaseInsensitive = common_1.isDefined(value) ? value : this._isCaseInsensitive);
	    };
	    /**
	     * Sets the default behavior when generating or matching URLs with default parameter values.
	     *
	     * #### Example:
	     * ```js
	     * // Remove default parameter values from the url
	     * urlService.config.defaultSquashPolicy(true);
	     * ```
	     *
	     * @param value A string that defines the default parameter URL squashing behavior.
	     *    - `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	     *    - `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	     *      parameter is surrounded by slashes, squash (remove) one slash from the URL
	     *    - any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	     *      the parameter value from the URL and replace it with this string.
	     * @returns the current value of defaultSquashPolicy
	     */
	    UrlConfig.prototype.defaultSquashPolicy = function (value) {
	        if (common_1.isDefined(value) && value !== true && value !== false && !common_1.isString(value))
	            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	        return (this._defaultSquashPolicy = common_1.isDefined(value) ? value : this._defaultSquashPolicy);
	    };
	    /**
	     * Defines whether URLs should match trailing slashes, or not (the default behavior).
	     *
	     * #### Example:
	     * ```js
	     * // Allow optional trailing slashes
	     * urlService.config.strictMode(false);
	     * ```
	     *
	     * @param value `false` to match trailing slashes in URLs, otherwise `true`.
	     * @returns the current value of strictMode
	     */
	    UrlConfig.prototype.strictMode = function (value) {
	        return (this._isStrictMode = common_1.isDefined(value) ? value : this._isStrictMode);
	    };
	    /**
	     * Creates and registers a custom [[ParamType]] object
	     *
	     * A custom parameter type can be used to generate URLs with typed parameters or custom encoding/decoding.
	     *
	     * #### Note: Register custom types *before using them* in a state definition.
	     *
	     * #### Example:
	     * ```js
	     * // Encode object parameter as JSON string
	     * urlService.config.type('myjson', {
	     *   encode: (obj) => JSON.stringify(obj),
	     *   decode: (str) => JSON.parse(str),
	     *   is: (val) => typeof(val) === 'object',
	     *   pattern: /[^/]+/,
	     *   equals: (a, b) => _.isEqual(a, b),
	     * });
	     * ```
	     *
	     * See [[ParamTypeDefinition]] for more examples
	     *
	     * @param name The type name.
	     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
	     * @param definitionFn A function that is injected before the app runtime starts.
	     *        The result of this function should be a [[ParamTypeDefinition]].
	     *        The result is merged into the existing `definition`.
	     *        See [[ParamType]] for information on the values accepted.
	     *
	     * @returns if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
	     */
	    UrlConfig.prototype.type = function (name, definition, definitionFn) {
	        var type = this.paramTypes.type(name, definition, definitionFn);
	        return !common_1.isDefined(definition) ? type : this;
	    };
	    return UrlConfig;
	}());
	exports.UrlConfig = UrlConfig;
	//# sourceMappingURL=urlConfig.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcherFactory = exports.ParamFactory = void 0;
	var common_1 = __webpack_require__(4);
	var urlMatcher_1 = __webpack_require__(24);
	var params_1 = __webpack_require__(37);
	var ParamFactory = /** @class */ (function () {
	    function ParamFactory(router) {
	        this.router = router;
	    }
	    ParamFactory.prototype.fromConfig = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.CONFIG, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromPath = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.PATH, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromSearch = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.SEARCH, this.router.urlService.config, state);
	    };
	    return ParamFactory;
	}());
	exports.ParamFactory = ParamFactory;
	/**
	 * Factory for [[UrlMatcher]] instances.
	 *
	 * The factory is available to ng1 services as
	 * `$urlMatcherFactory` or ng1 providers as `$urlMatcherFactoryProvider`.
	 */
	var UrlMatcherFactory = /** @class */ (function () {
	    // TODO: move implementations to UrlConfig (urlService.config)
	    function UrlMatcherFactory(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** Creates a new [[Param]] for a given location (DefType) */
	        this.paramFactory = new ParamFactory(this.router);
	        // TODO: Check if removal of this will break anything, then remove these
	        this.UrlMatcher = urlMatcher_1.UrlMatcher;
	        this.Param = params_1.Param;
	        /** @deprecated use [[UrlConfig.caseInsensitive]] */
	        this.caseInsensitive = function (value) { return _this.router.urlService.config.caseInsensitive(value); };
	        /** @deprecated use [[UrlConfig.defaultSquashPolicy]] */
	        this.defaultSquashPolicy = function (value) { return _this.router.urlService.config.defaultSquashPolicy(value); };
	        /** @deprecated use [[UrlConfig.strictMode]] */
	        this.strictMode = function (value) { return _this.router.urlService.config.strictMode(value); };
	        /** @deprecated use [[UrlConfig.type]] */
	        this.type = function (name, definition, definitionFn) {
	            return _this.router.urlService.config.type(name, definition, definitionFn) || _this;
	        };
	    }
	    /**
	     * Creates a [[UrlMatcher]] for the specified pattern.
	     *
	     * @param pattern  The URL pattern.
	     * @param config  The config object hash.
	     * @returns The UrlMatcher.
	     */
	    UrlMatcherFactory.prototype.compile = function (pattern, config) {
	        var urlConfig = this.router.urlService.config;
	        // backward-compatible support for config.params -> config.state.params
	        var params = config && !config.state && config.params;
	        config = params ? __assign({ state: { params: params } }, config) : config;
	        var globalConfig = {
	            strict: urlConfig._isStrictMode,
	            caseInsensitive: urlConfig._isCaseInsensitive,
	            decodeParams: urlConfig._decodeParams,
	        };
	        return new urlMatcher_1.UrlMatcher(pattern, urlConfig.paramTypes, this.paramFactory, common_1.extend(globalConfig, config));
	    };
	    /**
	     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
	     *
	     * @param object  The object to perform the type check against.
	     * @returns `true` if the object matches the `UrlMatcher` interface, by
	     *          implementing all the same methods.
	     */
	    UrlMatcherFactory.prototype.isMatcher = function (object) {
	        // TODO: typeof?
	        if (!common_1.isObject(object))
	            return false;
	        var result = true;
	        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
	            if (common_1.isFunction(val))
	                result = result && common_1.isDefined(object[name]) && common_1.isFunction(object[name]);
	        });
	        return result;
	    };
	    /** @internal */
	    UrlMatcherFactory.prototype.$get = function () {
	        var urlConfig = this.router.urlService.config;
	        urlConfig.paramTypes.enqueue = false;
	        urlConfig.paramTypes._flushTypeQueue();
	        return this;
	    };
	    return UrlMatcherFactory;
	}());
	exports.UrlMatcherFactory = UrlMatcherFactory;
	//# sourceMappingURL=urlMatcherFactory.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlRouter = void 0;
	var common_1 = __webpack_require__(4);
	var urlRule_1 = __webpack_require__(45);
	function appendBasePath(url, isHtml5, absolute, baseHref) {
	    if (baseHref === '/')
	        return url;
	    if (isHtml5)
	        return common_1.stripLastPathElement(baseHref) + url;
	    if (absolute)
	        return baseHref.slice(1) + url;
	    return url;
	}
	/**
	 * Updates URL and responds to URL changes
	 *
	 * ### Deprecation warning:
	 * This class is now considered to be an internal API
	 * Use the [[UrlService]] instead.
	 * For configuring URL rules, use the [[UrlRules]] which can be found as [[UrlService.rules]].
	 */
	var UrlRouter = /** @class */ (function () {
	    /** @internal */
	    function UrlRouter(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        // Delegate these calls to [[UrlService]]
	        /** @deprecated use [[UrlService.sync]]*/
	        this.sync = function (evt) { return _this.router.urlService.sync(evt); };
	        /** @deprecated use [[UrlService.listen]]*/
	        this.listen = function (enabled) { return _this.router.urlService.listen(enabled); };
	        /** @deprecated use [[UrlService.deferIntercept]]*/
	        this.deferIntercept = function (defer) { return _this.router.urlService.deferIntercept(defer); };
	        /** @deprecated use [[UrlService.match]]*/
	        this.match = function (urlParts) { return _this.router.urlService.match(urlParts); };
	        // Delegate these calls to [[UrlRules]]
	        /** @deprecated use [[UrlRules.initial]]*/
	        this.initial = function (handler) {
	            return _this.router.urlService.rules.initial(handler);
	        };
	        /** @deprecated use [[UrlRules.otherwise]]*/
	        this.otherwise = function (handler) {
	            return _this.router.urlService.rules.otherwise(handler);
	        };
	        /** @deprecated use [[UrlRules.removeRule]]*/
	        this.removeRule = function (rule) { return _this.router.urlService.rules.removeRule(rule); };
	        /** @deprecated use [[UrlRules.rule]]*/
	        this.rule = function (rule) { return _this.router.urlService.rules.rule(rule); };
	        /** @deprecated use [[UrlRules.rules]]*/
	        this.rules = function () { return _this.router.urlService.rules.rules(); };
	        /** @deprecated use [[UrlRules.sort]]*/
	        this.sort = function (compareFn) { return _this.router.urlService.rules.sort(compareFn); };
	        /** @deprecated use [[UrlRules.when]]*/
	        this.when = function (matcher, handler, options) { return _this.router.urlService.rules.when(matcher, handler, options); };
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** Internal API. */
	    UrlRouter.prototype.update = function (read) {
	        var $url = this.router.locationService;
	        if (read) {
	            this.location = $url.url();
	            return;
	        }
	        if ($url.url() === this.location)
	            return;
	        $url.url(this.location, true);
	    };
	    /**
	     * Internal API.
	     *
	     * Pushes a new location to the browser history.
	     *
	     * @internal
	     * @param urlMatcher
	     * @param params
	     * @param options
	     */
	    UrlRouter.prototype.push = function (urlMatcher, params, options) {
	        var replace = options && !!options.replace;
	        this.router.urlService.url(urlMatcher.format(params || {}), replace);
	    };
	    /**
	     * Builds and returns a URL with interpolated parameters
	     *
	     * #### Example:
	     * ```js
	     * matcher = $umf.compile("/about/:person");
	     * params = { person: "bob" };
	     * $bob = $urlRouter.href(matcher, params);
	     * // $bob == "/about/bob";
	     * ```
	     *
	     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
	     * @param params An object of parameter values to fill the matcher's required parameters.
	     * @param options Options object. The options are:
	     *
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     *
	     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	     */
	    UrlRouter.prototype.href = function (urlMatcher, params, options) {
	        var url = urlMatcher.format(params);
	        if (url == null)
	            return null;
	        options = options || { absolute: false };
	        var cfg = this.router.urlService.config;
	        var isHtml5 = cfg.html5Mode();
	        if (!isHtml5 && url !== null) {
	            url = '#' + cfg.hashPrefix() + url;
	        }
	        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
	        if (!options.absolute || !url) {
	            return url;
	        }
	        var slash = !isHtml5 && url ? '/' : '';
	        var cfgPort = cfg.port();
	        var port = (cfgPort === 80 || cfgPort === 443 ? '' : ':' + cfgPort);
	        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
	    };
	    Object.defineProperty(UrlRouter.prototype, "interceptDeferred", {
	        /** @deprecated use [[UrlService.interceptDeferred]]*/
	        get: function () {
	            return this.router.urlService.interceptDeferred;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return UrlRouter;
	}());
	exports.UrlRouter = UrlRouter;
	//# sourceMappingURL=urlRouter.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlRules = void 0;
	var state_1 = __webpack_require__(40);
	var urlMatcher_1 = __webpack_require__(24);
	var common_1 = __webpack_require__(4);
	var urlRule_1 = __webpack_require__(45);
	var prioritySort = function (a, b) { return (b.priority || 0) - (a.priority || 0); };
	var typeSort = function (a, b) {
	    var weights = { STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1 };
	    return (weights[a.type] || 0) - (weights[b.type] || 0);
	};
	var urlMatcherSort = function (a, b) {
	    return !a.urlMatcher || !b.urlMatcher ? 0 : urlMatcher_1.UrlMatcher.compare(a.urlMatcher, b.urlMatcher);
	};
	var idSort = function (a, b) {
	    // Identically sorted STATE and URLMATCHER best rule will be chosen by `matchPriority` after each rule matches the URL
	    var useMatchPriority = { STATE: true, URLMATCHER: true };
	    var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
	    return equal ? 0 : (a.$id || 0) - (b.$id || 0);
	};
	/**
	 * Default rule priority sorting function.
	 *
	 * Sorts rules by:
	 *
	 * - Explicit priority (set rule priority using [[UrlRules.when]])
	 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
	 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
	 * - Rule registration order (for rule types other than STATE and URLMATCHER)
	 *   - Equally sorted State and UrlMatcher rules will each match the URL.
	 *     Then, the *best* match is chosen based on how many parameter values were matched.
	 */
	var defaultRuleSortFn;
	defaultRuleSortFn = function (a, b) {
	    var cmp = prioritySort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = typeSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = urlMatcherSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    return idSort(a, b);
	};
	function getHandlerFn(handler) {
	    if (!common_1.isFunction(handler) && !common_1.isString(handler) && !common_1.is(state_1.TargetState)(handler) && !state_1.TargetState.isDef(handler)) {
	        throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
	    }
	    return common_1.isFunction(handler) ? handler : common_1.val(handler);
	}
	/**
	 * API for managing URL rules
	 *
	 * This API is used to create and manage URL rules.
	 * URL rules are a mechanism to respond to specific URL patterns.
	 *
	 * The most commonly used methods are [[otherwise]] and [[when]].
	 *
	 * This API is found at `router.urlService.rules` (see: [[UIRouter.urlService]], [[URLService.rules]])
	 */
	var UrlRules = /** @class */ (function () {
	    /** @internal */
	    function UrlRules(/** @internal */ router) {
	        this.router = router;
	        /** @internal */ this._sortFn = defaultRuleSortFn;
	        /** @internal */ this._rules = [];
	        /** @internal */ this._id = 0;
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** @internal */
	    UrlRules.prototype.dispose = function (router) {
	        this._rules = [];
	        delete this._otherwiseFn;
	    };
	    /**
	     * Defines the initial state, path, or behavior to use when the app starts.
	     *
	     * This rule defines the initial/starting state for the application.
	     *
	     * This rule is triggered the first time the URL is checked (when the app initially loads).
	     * The rule is triggered only when the url matches either `""` or `"/"`.
	     *
	     * Note: The rule is intended to be used when the root of the application is directly linked to.
	     * When the URL is *not* `""` or `"/"` and doesn't match other rules, the [[otherwise]] rule is triggered.
	     * This allows 404-like behavior when an unknown URL is deep-linked.
	     *
	     * #### Example:
	     * Start app at `home` state.
	     * ```js
	     * .initial({ state: 'home' });
	     * ```
	     *
	     * #### Example:
	     * Start app at `/home` (by url)
	     * ```js
	     * .initial('/home');
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .initial((matchValue, url, router) => {
	     *   console.log('initial state');
	     *   return { state: 'home' };
	     * })
	     * ```
	     *
	     * @param handler The initial state or url path, or a function which returns the state or url path (or performs custom logic).
	     */
	    UrlRules.prototype.initial = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        var matchFn = function (urlParts, router) {
	            return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
	        };
	        this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
	    };
	    /**
	     * Defines the state, url, or behavior to use when no other rule matches the URL.
	     *
	     * This rule is matched when *no other rule* matches.
	     * It is generally used to handle unknown URLs (similar to "404" behavior, but on the client side).
	     *
	     * - If `handler` a string, it is treated as a url redirect
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `/index`
	     * ```js
	     * .otherwise('/index');
	     * ```
	     *
	     * - If `handler` is an object with a `state` property, the state is activated.
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `home` and provide a `dashboard` parameter value.
	     * ```js
	     * .otherwise({ state: 'home', params: { dashboard: 'default' } });
	     * ```
	     *
	     * - If `handler` is a function, the function receives the current url ([[UrlParts]]) and the [[UIRouter]] object.
	     *   The function can perform actions, and/or return a value.
	     *
	     * #### Example:
	     * When no other url rule matches, manually trigger a transition to the `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   router.stateService.go('home');
	     * });
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   return { state: 'home' };
	     * });
	     * ```
	     *
	     * @param handler The url path to redirect to, or a function which returns the url path (or performs custom logic).
	     */
	    UrlRules.prototype.otherwise = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        this._otherwiseFn = this.urlRuleFactory.create(common_1.val(true), handlerFn);
	        this._sorted = false;
	    };
	    /**
	     * Remove a rule previously registered
	     *
	     * @param rule the matcher rule that was previously registered using [[rule]]
	     */
	    UrlRules.prototype.removeRule = function (rule) {
	        common_1.removeFrom(this._rules, rule);
	    };
	    /**
	     * Manually adds a URL Rule.
	     *
	     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
	     * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
	     * Rules can be created using [[urlRuleFactory]], or created manually as simple objects.
	     *
	     * A rule should have a `match` function which returns truthy if the rule matched.
	     * It should also have a `handler` function which is invoked if the rule is the best match.
	     *
	     * @return a function that deregisters the rule
	     */
	    UrlRules.prototype.rule = function (rule) {
	        var _this = this;
	        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule))
	            throw new Error('invalid rule');
	        rule.$id = this._id++;
	        rule.priority = rule.priority || 0;
	        this._rules.push(rule);
	        this._sorted = false;
	        return function () { return _this.removeRule(rule); };
	    };
	    /**
	     * Gets all registered rules
	     *
	     * @returns an array of all the registered rules
	     */
	    UrlRules.prototype.rules = function () {
	        this.ensureSorted();
	        return this._rules.concat(this._otherwiseFn ? [this._otherwiseFn] : []);
	    };
	    /**
	     * Defines URL Rule priorities
	     *
	     * More than one rule ([[UrlRule]]) might match a given URL.
	     * This `compareFn` is used to sort the rules by priority.
	     * Higher priority rules should sort earlier.
	     *
	     * The [[defaultRuleSortFn]] is used by default.
	     *
	     * You only need to call this function once.
	     * The `compareFn` will be used to sort the rules as each is registered.
	     *
	     * If called without any parameter, it will re-sort the rules.
	     *
	     * ---
	     *
	     * Url rules may come from multiple sources: states's urls ([[StateDeclaration.url]]), [[when]], and [[rule]].
	     * Each rule has a (user-provided) [[UrlRule.priority]], a [[UrlRule.type]], and a [[UrlRule.$id]]
	     * The `$id` is is the order in which the rule was registered.
	     *
	     * The sort function should use these data, or data found on a specific type
	     * of [[UrlRule]] (such as [[StateRule.state]]), to order the rules as desired.
	     *
	     * #### Example:
	     * This compare function prioritizes rules by the order in which the rules were registered.
	     * A rule registered earlier has higher priority.
	     *
	     * ```js
	     * function compareFn(a, b) {
	     *   return a.$id - b.$id;
	     * }
	     * ```
	     *
	     * @param compareFn a function that compares to [[UrlRule]] objects.
	     *    The `compareFn` should abide by the `Array.sort` compare function rules.
	     *    Given two rules, `a` and `b`, return a negative number if `a` should be higher priority.
	     *    Return a positive number if `b` should be higher priority.
	     *    Return `0` if the rules are identical.
	     *
	     *    See the [mozilla reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description)
	     *    for details.
	     */
	    UrlRules.prototype.sort = function (compareFn) {
	        var sorted = this.stableSort(this._rules, (this._sortFn = compareFn || this._sortFn));
	        // precompute _sortGroup values and apply to each rule
	        var group = 0;
	        for (var i = 0; i < sorted.length; i++) {
	            sorted[i]._group = group;
	            if (i < sorted.length - 1 && this._sortFn(sorted[i], sorted[i + 1]) !== 0) {
	                group++;
	            }
	        }
	        this._rules = sorted;
	        this._sorted = true;
	    };
	    /** @internal */
	    UrlRules.prototype.ensureSorted = function () {
	        this._sorted || this.sort();
	    };
	    /** @internal */
	    UrlRules.prototype.stableSort = function (arr, compareFn) {
	        var arrOfWrapper = arr.map(function (elem, idx) { return ({ elem: elem, idx: idx }); });
	        arrOfWrapper.sort(function (wrapperA, wrapperB) {
	            var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
	            return cmpDiff === 0 ? wrapperA.idx - wrapperB.idx : cmpDiff;
	        });
	        return arrOfWrapper.map(function (wrapper) { return wrapper.elem; });
	    };
	    /**
	     * Registers a `matcher` and `handler` for custom URLs handling.
	     *
	     * The `matcher` can be:
	     *
	     * - a [[UrlMatcher]]: See: [[UrlMatcherFactory.compile]]
	     * - a `string`: The string is compiled to a [[UrlMatcher]]
	     * - a `RegExp`: The regexp is used to match the url.
	     *
	     * The `handler` can be:
	     *
	     * - a string: The url is redirected to the value of the string.
	     * - a function: The url is redirected to the return value of the function.
	     *
	     * ---
	     *
	     * When the `handler` is a `string` and the `matcher` is a `UrlMatcher` (or string), the redirect
	     * string is interpolated with parameter values.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when("/foo/:param1", "/bar/:param1")
	     * ```
	     *
	     * ---
	     *
	     * When the `handler` is a string and the `matcher` is a `RegExp`, the redirect string is
	     * interpolated with capture groups from the RegExp.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), "/bar/$1");
	     * ```
	     *
	     * ---
	     *
	     * When the handler is a function, it receives the matched value, the current URL, and the `UIRouter` object (See [[UrlRuleHandlerFn]]).
	     * The "matched value" differs based on the `matcher`.
	     * For [[UrlMatcher]]s, it will be the matched state params.
	     * For `RegExp`, it will be the match array from `regexp.exec()`.
	     *
	     * If the handler returns a string, the URL is redirected to the string.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), match => "/bar/" + match[1]);
	     * ```
	     *
	     * Note: the `handler` may also invoke arbitrary code, such as `$state.go()`
	     *
	     * @param matcher A pattern `string` to match, compiled as a [[UrlMatcher]], or a `RegExp`.
	     * @param handler The path to redirect to, or a function that returns the path.
	     * @param options `{ priority: number }`
	     *
	     * @return the registered [[UrlRule]]
	     */
	    UrlRules.prototype.when = function (matcher, handler, options) {
	        var rule = this.urlRuleFactory.create(matcher, handler);
	        if (common_1.isDefined(options && options.priority))
	            rule.priority = options.priority;
	        this.rule(rule);
	        return rule;
	    };
	    return UrlRules;
	}());
	exports.UrlRules = UrlRules;
	//# sourceMappingURL=urlRules.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlService = void 0;
	var common_1 = __webpack_require__(4);
	var urlRules_1 = __webpack_require__(66);
	var urlConfig_1 = __webpack_require__(63);
	var state_1 = __webpack_require__(40);
	/**
	 * API for URL management
	 */
	var UrlService = /** @class */ (function () {
	    /** @internal */
	    function UrlService(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this.interceptDeferred = false;
	        /**
	         * The nested [[UrlRules]] API for managing URL rules and rewrites
	         *
	         * See: [[UrlRules]] for details
	         */
	        this.rules = new urlRules_1.UrlRules(this.router);
	        /**
	         * The nested [[UrlConfig]] API to configure the URL and retrieve URL information
	         *
	         * See: [[UrlConfig]] for details
	         */
	        this.config = new urlConfig_1.UrlConfig(this.router);
	        // Delegate these calls to the current LocationServices implementation
	        /**
	         * Gets the current url, or updates the url
	         *
	         * ### Getting the current URL
	         *
	         * When no arguments are passed, returns the current URL.
	         * The URL is normalized using the internal [[path]]/[[search]]/[[hash]] values.
	         *
	         * For example, the URL may be stored in the hash ([[HashLocationServices]]) or
	         * have a base HREF prepended ([[PushStateLocationServices]]).
	         *
	         * The raw URL in the browser might be:
	         *
	         * ```
	         * http://mysite.com/somepath/index.html#/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * or
	         *
	         * ```
	         * http://mysite.com/basepath/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * then this method returns:
	         *
	         * ```
	         * /internal/path/123?param1=foo#anchor
	         * ```
	         *
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url(); // "/some/path?query=value#anchor"
	         * ```
	         *
	         * ### Updating the URL
	         *
	         * When `newurl` arguments is provided, changes the URL to reflect `newurl`
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url("/some/path?query=value#anchor", true);
	         * ```
	         *
	         * @param newurl The new value for the URL.
	         *               This url should reflect only the new internal [[path]], [[search]], and [[hash]] values.
	         *               It should not include the protocol, site, port, or base path of an absolute HREF.
	         * @param replace When true, replaces the current history entry (instead of appending it) with this new url
	         * @param state The history's state object, i.e., pushState (if the LocationServices implementation supports it)
	         *
	         * @return the url (after potentially being processed)
	         */
	        this.url = function (newurl, replace, state) {
	            return _this.router.locationService.url(newurl, replace, state);
	        };
	        /**
	         * Gets the path part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `/some/path`
	         *
	         * @return the path portion of the url
	         */
	        this.path = function () { return _this.router.locationService.path(); };
	        /**
	         * Gets the search part of the current url as an object
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `{ query: 'value' }`
	         *
	         * @return the search (query) portion of the url, as an object
	         */
	        this.search = function () { return _this.router.locationService.search(); };
	        /**
	         * Gets the hash part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `anchor`
	         *
	         * @return the hash (anchor) portion of the url
	         */
	        this.hash = function () { return _this.router.locationService.hash(); };
	        /**
	         * @internal
	         *
	         * Registers a low level url change handler
	         *
	         * Note: Because this is a low level handler, it's not recommended for general use.
	         *
	         * #### Example:
	         * ```js
	         * let deregisterFn = locationServices.onChange((evt) => console.log("url change", evt));
	         * ```
	         *
	         * @param callback a function that will be called when the url is changing
	         * @return a function that de-registers the callback
	         */
	        this.onChange = function (callback) { return _this.router.locationService.onChange(callback); };
	    }
	    /** @internal */
	    UrlService.prototype.dispose = function () {
	        this.listen(false);
	        this.rules.dispose();
	    };
	    /**
	     * Gets the current URL parts
	     *
	     * This method returns the different parts of the current URL (the [[path]], [[search]], and [[hash]]) as a [[UrlParts]] object.
	     */
	    UrlService.prototype.parts = function () {
	        return { path: this.path(), search: this.search(), hash: this.hash() };
	    };
	    /**
	     * Activates the best rule for the current URL
	     *
	     * Checks the current URL for a matching [[UrlRule]], then invokes that rule's handler.
	     * This method is called internally any time the URL has changed.
	     *
	     * This effectively activates the state (or redirect, etc) which matches the current URL.
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   // Find the matching URL and invoke the handler.
	     *   urlService.sync();
	     * });
	     * ```
	     */
	    UrlService.prototype.sync = function (evt) {
	        if (evt && evt.defaultPrevented)
	            return;
	        var _a = this.router, urlService = _a.urlService, stateService = _a.stateService;
	        var url = { path: urlService.path(), search: urlService.search(), hash: urlService.hash() };
	        var best = this.match(url);
	        var applyResult = common_1.pattern([
	            [common_1.isString, function (newurl) { return urlService.url(newurl, true); }],
	            [state_1.TargetState.isDef, function (def) { return stateService.go(def.state, def.params, def.options); }],
	            [common_1.is(state_1.TargetState), function (target) { return stateService.go(target.state(), target.params(), target.options()); }],
	        ]);
	        applyResult(best && best.rule.handler(best.match, url, this.router));
	    };
	    /**
	     * Starts or stops listening for URL changes
	     *
	     * Call this sometime after calling [[deferIntercept]] to start monitoring the url.
	     * This causes UI-Router to start listening for changes to the URL, if it wasn't already listening.
	     *
	     * If called with `false`, UI-Router will stop listening (call listen(true) to start listening again).
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   // Start responding to URL changes
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param enabled `true` or `false` to start or stop listening to URL changes
	     */
	    UrlService.prototype.listen = function (enabled) {
	        var _this = this;
	        if (enabled === false) {
	            this._stopListeningFn && this._stopListeningFn();
	            delete this._stopListeningFn;
	        }
	        else {
	            return (this._stopListeningFn =
	                this._stopListeningFn || this.router.urlService.onChange(function (evt) { return _this.sync(evt); }));
	        }
	    };
	    /**
	     * Disables monitoring of the URL.
	     *
	     * Call this method before UI-Router has bootstrapped.
	     * It will stop UI-Router from performing the initial url sync.
	     *
	     * This can be useful to perform some asynchronous initialization before the router starts.
	     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	     *
	     * #### Example:
	     * ```js
	     * // Prevent UI-Router from automatically intercepting URL changes when it starts;
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param defer Indicates whether to defer location change interception.
	     *        Passing no parameter is equivalent to `true`.
	     */
	    UrlService.prototype.deferIntercept = function (defer) {
	        if (defer === undefined)
	            defer = true;
	        this.interceptDeferred = defer;
	    };
	    /**
	     * Matches a URL
	     *
	     * Given a URL (as a [[UrlParts]] object), check all rules and determine the best matching rule.
	     * Return the result as a [[MatchResult]].
	     */
	    UrlService.prototype.match = function (url) {
	        var _this = this;
	        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
	        var rules = this.rules.rules();
	        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
	        var checkRule = function (rule) {
	            var match = rule.match(url, _this.router);
	            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
	        };
	        // The rules are pre-sorted.
	        // - Find the first matching rule.
	        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
	        // - Choose the rule with the highest match weight.
	        var best;
	        for (var i = 0; i < rules.length; i++) {
	            // Stop when there is a 'best' rule and the next rule sorts differently than it.
	            if (best && best.rule._group !== rules[i]._group)
	                break;
	            var current = checkRule(rules[i]);
	            // Pick the best MatchResult
	            best = !best || (current && current.weight > best.weight) ? current : best;
	        }
	        return best;
	    };
	    return UrlService;
	}());
	exports.UrlService = UrlService;
	//# sourceMappingURL=urlService.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BrowserLocationConfig = void 0;
	var predicates_1 = __webpack_require__(2);
	/** A `LocationConfig` that delegates to the browser's `location` object */
	var BrowserLocationConfig = /** @class */ (function () {
	    function BrowserLocationConfig(router, _isHtml5) {
	        if (_isHtml5 === void 0) { _isHtml5 = false; }
	        this._isHtml5 = _isHtml5;
	        this._baseHref = undefined;
	        this._hashPrefix = '';
	    }
	    BrowserLocationConfig.prototype.port = function () {
	        if (location.port) {
	            return Number(location.port);
	        }
	        return this.protocol() === 'https' ? 443 : 80;
	    };
	    BrowserLocationConfig.prototype.protocol = function () {
	        return location.protocol.replace(/:/g, '');
	    };
	    BrowserLocationConfig.prototype.host = function () {
	        return location.hostname;
	    };
	    BrowserLocationConfig.prototype.html5Mode = function () {
	        return this._isHtml5;
	    };
	    BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
	        return predicates_1.isDefined(newprefix) ? (this._hashPrefix = newprefix) : this._hashPrefix;
	    };
	    BrowserLocationConfig.prototype.baseHref = function (href) {
	        if (predicates_1.isDefined(href))
	            this._baseHref = href;
	        if (predicates_1.isUndefined(this._baseHref))
	            this._baseHref = this.getBaseHref();
	        return this._baseHref;
	    };
	    BrowserLocationConfig.prototype.getBaseHref = function () {
	        var baseTag = document.getElementsByTagName('base')[0];
	        if (baseTag && baseTag.href) {
	            return baseTag.href.replace(/^([^/:]*:)?\/\/[^/]*/, '');
	        }
	        return this._isHtml5 ? '/' : location.pathname || '/';
	    };
	    BrowserLocationConfig.prototype.dispose = function () { };
	    return BrowserLocationConfig;
	}());
	exports.BrowserLocationConfig = BrowserLocationConfig;
	//# sourceMappingURL=browserLocationConfig.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HashLocationService = void 0;
	var common_1 = __webpack_require__(4);
	var baseLocationService_1 = __webpack_require__(25);
	/** A `LocationServices` that uses the browser hash "#" to get/set the current location */
	var HashLocationService = /** @class */ (function (_super) {
	    __extends(HashLocationService, _super);
	    function HashLocationService(router) {
	        var _this = _super.call(this, router, false) || this;
	        common_1.root.addEventListener('hashchange', _this._listener, false);
	        return _this;
	    }
	    HashLocationService.prototype._get = function () {
	        return common_1.trimHashVal(this._location.hash);
	    };
	    HashLocationService.prototype._set = function (state, title, url, replace) {
	        this._location.hash = url;
	    };
	    HashLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('hashchange', this._listener);
	    };
	    return HashLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.HashLocationService = HashLocationService;
	//# sourceMappingURL=hashLocationService.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$injector = void 0;
	var index_1 = __webpack_require__(4);
	// globally available injectables
	var globals = {};
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
	var ARGUMENT_NAMES = /([^\s,]+)/g;
	/**
	 * A basic angular1-like injector api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 dependency injector](https://docs.angularjs.org/api/auto/service/$injector)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This object provides a naive implementation of a globally scoped dependency injection system.
	 * It supports the following DI approaches:
	 *
	 * ### Function parameter names
	 *
	 * A function's `.toString()` is called, and the parameter names are parsed.
	 * This only works when the parameter names aren't "mangled" by a minifier such as UglifyJS.
	 *
	 * ```js
	 * function injectedFunction(FooService, BarService) {
	 *   // FooService and BarService are injected
	 * }
	 * ```
	 *
	 * ### Function annotation
	 *
	 * A function may be annotated with an array of dependency names as the `$inject` property.
	 *
	 * ```js
	 * injectedFunction.$inject = [ 'FooService', 'BarService' ];
	 * function injectedFunction(fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }
	 * ```
	 *
	 * ### Array notation
	 *
	 * An array provides the names of the dependencies to inject (as strings).
	 * The function is the last element of the array.
	 *
	 * ```js
	 * [ 'FooService', 'BarService', function (fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }]
	 * ```
	 *
	 * @type {$InjectorLike}
	 */
	exports.$injector = {
	    /** Gets an object from DI based on a string token */
	    get: function (name) { return globals[name]; },
	    /** Returns true if an object named `name` exists in global DI */
	    has: function (name) { return exports.$injector.get(name) != null; },
	    /**
	     * Injects a function
	     *
	     * @param fn the function to inject
	     * @param context the function's `this` binding
	     * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
	     */
	    invoke: function (fn, context, locals) {
	        var all = index_1.extend({}, globals, locals || {});
	        var params = exports.$injector.annotate(fn);
	        var ensureExist = index_1.assertPredicate(function (key) { return all.hasOwnProperty(key); }, function (key) { return "DI can't find injectable: '" + key + "'"; });
	        var args = params.filter(ensureExist).map(function (x) { return all[x]; });
	        if (index_1.isFunction(fn))
	            return fn.apply(context, args);
	        else
	            return fn.slice(-1)[0].apply(context, args);
	    },
	    /**
	     * Returns a function's dependencies
	     *
	     * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
	     * @return an array of `string`s
	     */
	    annotate: function (fn) {
	        if (!index_1.isInjectable(fn))
	            throw new Error("Not an injectable function: " + fn);
	        if (fn && fn.$inject)
	            return fn.$inject;
	        if (index_1.isArray(fn))
	            return fn.slice(0, -1);
	        var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
	        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
	        return result || [];
	    },
	};
	//# sourceMappingURL=injector.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MemoryLocationConfig = void 0;
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	/** A `LocationConfig` mock that gets/sets all config from an in-memory object */
	var MemoryLocationConfig = /** @class */ (function () {
	    function MemoryLocationConfig() {
	        var _this = this;
	        this.dispose = common_1.noop;
	        this._baseHref = '';
	        this._port = 80;
	        this._protocol = 'http';
	        this._host = 'localhost';
	        this._hashPrefix = '';
	        this.port = function () { return _this._port; };
	        this.protocol = function () { return _this._protocol; };
	        this.host = function () { return _this._host; };
	        this.baseHref = function () { return _this._baseHref; };
	        this.html5Mode = function () { return false; };
	        this.hashPrefix = function (newval) { return (predicates_1.isDefined(newval) ? (_this._hashPrefix = newval) : _this._hashPrefix); };
	    }
	    return MemoryLocationConfig;
	}());
	exports.MemoryLocationConfig = MemoryLocationConfig;
	//# sourceMappingURL=memoryLocationConfig.js.map

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MemoryLocationService = void 0;
	var baseLocationService_1 = __webpack_require__(25);
	/** A `LocationServices` that gets/sets the current location from an in-memory object */
	var MemoryLocationService = /** @class */ (function (_super) {
	    __extends(MemoryLocationService, _super);
	    function MemoryLocationService(router) {
	        return _super.call(this, router, true) || this;
	    }
	    MemoryLocationService.prototype._get = function () {
	        return this._url;
	    };
	    MemoryLocationService.prototype._set = function (state, title, url, replace) {
	        this._url = url;
	    };
	    return MemoryLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.MemoryLocationService = MemoryLocationService;
	//# sourceMappingURL=memoryLocationService.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PushStateLocationService = void 0;
	var baseLocationService_1 = __webpack_require__(25);
	var common_1 = __webpack_require__(4);
	/**
	 * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
	 *
	 * Uses `history.pushState` and `history.replaceState`
	 */
	var PushStateLocationService = /** @class */ (function (_super) {
	    __extends(PushStateLocationService, _super);
	    function PushStateLocationService(router) {
	        var _this = _super.call(this, router, true) || this;
	        _this._config = router.urlService.config;
	        common_1.root.addEventListener('popstate', _this._listener, false);
	        return _this;
	    }
	    /**
	     * Gets the base prefix without:
	     * - trailing slash
	     * - trailing filename
	     * - protocol and hostname
	     *
	     * If <base href='/base/'>, this returns '/base'.
	     * If <base href='/foo/base/'>, this returns '/foo/base'.
	     * If <base href='/base/index.html'>, this returns '/base'.
	     * If <base href='http://localhost:8080/base/index.html'>, this returns '/base'.
	     * If <base href='/base'>, this returns ''.
	     * If <base href='http://localhost:8080'>, this returns ''.
	     * If <base href='http://localhost:8080/'>, this returns ''.
	     *
	     * See: https://html.spec.whatwg.org/dev/semantics.html#the-base-element
	     */
	    PushStateLocationService.prototype._getBasePrefix = function () {
	        return common_1.stripLastPathElement(this._config.baseHref());
	    };
	    PushStateLocationService.prototype._get = function () {
	        var _a = this._location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
	        search = common_1.splitQuery(search)[1]; // strip ? if found
	        hash = common_1.splitHash(hash)[1]; // strip # if found
	        var basePrefix = this._getBasePrefix();
	        var exactBaseHrefMatch = pathname === this._config.baseHref();
	        var startsWithBase = pathname.substr(0, basePrefix.length) === basePrefix;
	        pathname = exactBaseHrefMatch ? '/' : startsWithBase ? pathname.substring(basePrefix.length) : pathname;
	        return pathname + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	    };
	    PushStateLocationService.prototype._set = function (state, title, url, replace) {
	        var basePrefix = this._getBasePrefix();
	        var slash = url && url[0] !== '/' ? '/' : '';
	        var fullUrl = url === '' || url === '/' ? this._config.baseHref() : basePrefix + slash + url;
	        if (replace) {
	            this._history.replaceState(state, title, fullUrl);
	        }
	        else {
	            this._history.pushState(state, title, fullUrl);
	        }
	    };
	    PushStateLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('popstate', this._listener);
	    };
	    return PushStateLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.PushStateLocationService = PushStateLocationService;
	//# sourceMappingURL=pushStateLocationService.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$q = void 0;
	var index_1 = __webpack_require__(4);
	/**
	 * An angular1-like promise api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 promise api](https://docs.angularjs.org/api/ng/service/$q)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This API provides native ES6 promise support wrapped as a $q-like API.
	 * Internally, UI-Router uses this $q object to perform promise operations.
	 * The `angular-ui-router` (ui-router for angular 1) uses the $q API provided by angular.
	 *
	 * $q-like promise api
	 */
	exports.$q = {
	    /** Normalizes a value as a promise */
	    when: function (val) { return new Promise(function (resolve, reject) { return resolve(val); }); },
	    /** Normalizes a value as a promise rejection */
	    reject: function (val) {
	        return new Promise(function (resolve, reject) {
	            reject(val);
	        });
	    },
	    /** @returns a deferred object, which has `resolve` and `reject` functions */
	    defer: function () {
	        var deferred = {};
	        deferred.promise = new Promise(function (resolve, reject) {
	            deferred.resolve = resolve;
	            deferred.reject = reject;
	        });
	        return deferred;
	    },
	    /** Like Promise.all(), but also supports object key/promise notation like $q */
	    all: function (promises) {
	        if (index_1.isArray(promises)) {
	            return Promise.all(promises);
	        }
	        if (index_1.isObject(promises)) {
	            // Convert promises map to promises array.
	            // When each promise resolves, map it to a tuple { key: key, val: val }
	            var chain = Object.keys(promises).map(function (key) { return promises[key].then(function (val) { return ({ key: key, val: val }); }); });
	            // Then wait for all promises to resolve, and convert them back to an object
	            return exports.$q.all(chain).then(function (values) {
	                return values.reduce(function (acc, tuple) {
	                    acc[tuple.key] = tuple.val;
	                    return acc;
	                }, {});
	            });
	        }
	    },
	};
	//# sourceMappingURL=q.js.map

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ViewService = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var trace_1 = __webpack_require__(9);
	/**
	 * The View service
	 *
	 * This service pairs existing `ui-view` components (which live in the DOM)
	 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
	 *
	 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
	 *   The views from exited states are deactivated via [[deactivateViewConfig]].
	 *   (See: the [[registerActivateViews]] Transition Hook)
	 *
	 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
	 *
	 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
	 * are configured with the matching [[ViewConfig]](s)
	 *
	 */
	var ViewService = /** @class */ (function () {
	    /** @internal */
	    function ViewService(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this._uiViews = [];
	        /** @internal */ this._viewConfigs = [];
	        /** @internal */ this._viewConfigFactories = {};
	        /** @internal */ this._listeners = [];
	        /** @internal */
	        this._pluginapi = {
	            _rootViewContext: this._rootViewContext.bind(this),
	            _viewConfigFactory: this._viewConfigFactory.bind(this),
	            _registeredUIView: function (id) { return common_1.find(_this._uiViews, function (view) { return _this.router.$id + "." + view.id === id; }); },
	            _registeredUIViews: function () { return _this._uiViews; },
	            _activeViewConfigs: function () { return _this._viewConfigs; },
	            _onSync: function (listener) {
	                _this._listeners.push(listener);
	                return function () { return common_1.removeFrom(_this._listeners, listener); };
	            },
	        };
	    }
	    /**
	     * Normalizes a view's name from a state.views configuration block.
	     *
	     * This should be used by a framework implementation to calculate the values for
	     * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
	     *
	     * @param context the context object (state declaration) that the view belongs to
	     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
	     *
	     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
	     */
	    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
	        if (rawViewName === void 0) { rawViewName = ''; }
	        // TODO: Validate incoming view name with a regexp to allow:
	        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
	        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
	        var viewAtContext = rawViewName.split('@');
	        var uiViewName = viewAtContext[0] || '$default'; // default to unnamed view
	        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : '^'; // default to parent context
	        // Handle relative view-name sugar syntax.
	        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
	        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
	        if (relativeViewNameSugar) {
	            // Clobbers existing contextAnchor (rawViewName validation will fix this)
	            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
	            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
	        }
	        if (uiViewName.charAt(0) === '!') {
	            uiViewName = uiViewName.substr(1);
	            uiViewContextAnchor = ''; // target absolutely from root
	        }
	        // handle parent relative targeting "^.^.^"
	        var relativeMatch = /^(\^(?:\.\^)*)$/;
	        if (relativeMatch.exec(uiViewContextAnchor)) {
	            var anchorState = uiViewContextAnchor.split('.').reduce(function (anchor, x) { return anchor.parent; }, context);
	            uiViewContextAnchor = anchorState.name;
	        }
	        else if (uiViewContextAnchor === '.') {
	            uiViewContextAnchor = context.name;
	        }
	        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
	    };
	    /** @internal */
	    ViewService.prototype._rootViewContext = function (context) {
	        return (this._rootContext = context || this._rootContext);
	    };
	    /** @internal */
	    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
	        this._viewConfigFactories[viewType] = factory;
	    };
	    ViewService.prototype.createViewConfig = function (path, decl) {
	        var cfgFactory = this._viewConfigFactories[decl.$type];
	        if (!cfgFactory)
	            throw new Error('ViewService: No view config factory registered for type ' + decl.$type);
	        var cfgs = cfgFactory(path, decl);
	        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
	    };
	    /**
	     * Deactivates a ViewConfig.
	     *
	     * This function deactivates a `ViewConfig`.
	     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
	     *
	     * @param viewConfig The ViewConfig view to deregister.
	     */
	    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('<- Removing', viewConfig);
	        common_1.removeFrom(this._viewConfigs, viewConfig);
	    };
	    ViewService.prototype.activateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('-> Registering', viewConfig);
	        this._viewConfigs.push(viewConfig);
	    };
	    ViewService.prototype.sync = function () {
	        var _this = this;
	        var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(common_1.applyPairs, {});
	        // Return a weighted depth value for a uiView.
	        // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
	        // plus the depth of the state that is populating the uiView
	        function uiViewDepth(uiView) {
	            var stateDepth = function (context) { return (context && context.parent ? stateDepth(context.parent) + 1 : 1); };
	            return uiView.fqn.split('.').length * 10000 + stateDepth(uiView.creationContext);
	        }
	        // Return the ViewConfig's context's depth in the context tree.
	        function viewConfigDepth(config) {
	            var context = config.viewDecl.$context, count = 0;
	            while (++count && context.parent)
	                context = context.parent;
	            return count;
	        }
	        // Given a depth function, returns a compare function which can return either ascending or descending order
	        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
	        var matchingConfigPair = function (uiView) {
	            var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
	            if (matchingConfigs.length > 1) {
	                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
	                // Sort by depth and return the match from the deepest child
	                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
	                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
	            }
	            return { uiView: uiView, viewConfig: matchingConfigs[0] };
	        };
	        var configureUIView = function (tuple) {
	            // If a parent ui-view is reconfigured, it could destroy child ui-views.
	            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
	            if (_this._uiViews.indexOf(tuple.uiView) !== -1)
	                tuple.uiView.configUpdated(tuple.viewConfig);
	        };
	        // Sort views by FQN and state depth. Process uiviews nearest the root first.
	        var uiViewTuples = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
	        var matchedViewConfigs = uiViewTuples.map(function (tuple) { return tuple.viewConfig; });
	        var unmatchedConfigTuples = this._viewConfigs
	            .filter(function (config) { return !common_1.inArray(matchedViewConfigs, config); })
	            .map(function (viewConfig) { return ({ uiView: undefined, viewConfig: viewConfig }); });
	        uiViewTuples.forEach(configureUIView);
	        var allTuples = uiViewTuples.concat(unmatchedConfigTuples);
	        this._listeners.forEach(function (cb) { return cb(allTuples); });
	        trace_1.trace.traceViewSync(allTuples);
	    };
	    /**
	     * Registers a `ui-view` component
	     *
	     * When a `ui-view` component is created, it uses this method to register itself.
	     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
	     *
	     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
	     * and what the view's state context is.
	     *
	     * Note: There is no corresponding `deregisterUIView`.
	     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
	     *
	     * @param uiView The metadata for a UIView
	     * @return a de-registration function used when the view is destroyed.
	     */
	    ViewService.prototype.registerUIView = function (uiView) {
	        trace_1.trace.traceViewServiceUIViewEvent('-> Registering', uiView);
	        var uiViews = this._uiViews;
	        var fqnAndTypeMatches = function (uiv) { return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type; };
	        if (uiViews.filter(fqnAndTypeMatches).length)
	            trace_1.trace.traceViewServiceUIViewEvent('!!!! duplicate uiView named:', uiView);
	        uiViews.push(uiView);
	        this.sync();
	        return function () {
	            var idx = uiViews.indexOf(uiView);
	            if (idx === -1) {
	                trace_1.trace.traceViewServiceUIViewEvent('Tried removing non-registered uiView', uiView);
	                return;
	            }
	            trace_1.trace.traceViewServiceUIViewEvent('<- Deregistering', uiView);
	            common_1.removeFrom(uiViews)(uiView);
	        };
	    };
	    /**
	     * Returns the list of views currently available on the page, by fully-qualified name.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.available = function () {
	        return this._uiViews.map(hof_1.prop('fqn'));
	    };
	    /**
	     * Returns the list of views on the page containing loaded content.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.active = function () {
	        return this._uiViews.filter(hof_1.prop('$config')).map(hof_1.prop('name'));
	    };
	    /**
	     * Given a ui-view and a ViewConfig, determines if they "match".
	     *
	     * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
	     * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
	     *
	     * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
	     * can be a segmented ui-view path, describing a portion of a ui-view fqn.
	     *
	     * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
	     *
	     * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
	     * - the ui-view's name matches the ViewConfig's target name
	     * - the ui-view's context matches the ViewConfig's anchor
	     *
	     * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
	     * - There exists a parent ui-view where:
	     *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
	     *    - the parent ui-view's context matches the ViewConfig's anchor
	     * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
	     *
	     * Example:
	     *
	     * DOM:
	     * <ui-view>                        <!-- created in the root context (name: "") -->
	     *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
	     *     <ui-view>                    <!-- created in the context named: "A.B"    -->
	     *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
	     *       </ui-view>
	     *     </ui-view>
	     *   </ui-view>
	     * </ui-view>
	     *
	     * uiViews: [
	     *  { fqn: "$default",                  creationContext: { name: "" } },
	     *  { fqn: "$default.foo",              creationContext: { name: "A" } },
	     *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
	     *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
	     * ]
	     *
	     * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
	     *
	     * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
	     * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
	     * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
	     * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
	     *
	     * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
	     * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
	     * - There exists a parent ui-view (which has fqn: "$default.foo") where:
	     *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
	     *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
	     * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
	     *   the tail of the ui-view's fqn "default.bar"
	     *
	     * @internal
	     */
	    ViewService.matches = function (uiViewsByFqn, uiView) { return function (viewConfig) {
	        // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
	        if (uiView.$type !== viewConfig.viewDecl.$type)
	            return false;
	        // Split names apart from both viewConfig and uiView into segments
	        var vc = viewConfig.viewDecl;
	        var vcSegments = vc.$uiViewName.split('.');
	        var uivSegments = uiView.fqn.split('.');
	        // Check if the tails of the segment arrays match. ex, these arrays' tails match:
	        // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
	        if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
	            return false;
	        // Now check if the fqn ending at the first segment of the viewConfig matches the context:
	        // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
	        var negOffset = 1 - vcSegments.length || undefined;
	        var fqnToFirstSegment = uivSegments.slice(0, negOffset).join('.');
	        var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
	        return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
	    }; };
	    return ViewService;
	}());
	exports.ViewService = ViewService;
	//# sourceMappingURL=view.js.map

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	* angular-formly JavaScript Library v8.4.1
	*
	* @license MIT (http://license.angular-formly.com)
	*
	* built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us>
	* (ó ì_í)=óò=(ì_í ò)
	*/
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(7), __webpack_require__(77));
		else if(typeof define === 'function' && define.amd)
			define(["angular", "api-check"], factory);
		else if(typeof exports === 'object')
			exports["ngFormly"] = factory(require("angular"), require("api-check"));
		else
			root["ngFormly"] = factory(root["angular"], root["apiCheck"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _indexCommon = __webpack_require__(1);
	
		var _indexCommon2 = _interopRequireDefault(_indexCommon);
	
		exports['default'] = _indexCommon2['default'];
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _providersFormlyApiCheck = __webpack_require__(4);
	
		var _providersFormlyApiCheck2 = _interopRequireDefault(_providersFormlyApiCheck);
	
		var _otherDocsBaseUrl = __webpack_require__(6);
	
		var _otherDocsBaseUrl2 = _interopRequireDefault(_otherDocsBaseUrl);
	
		var _providersFormlyUsability = __webpack_require__(7);
	
		var _providersFormlyUsability2 = _interopRequireDefault(_providersFormlyUsability);
	
		var _providersFormlyConfig = __webpack_require__(8);
	
		var _providersFormlyConfig2 = _interopRequireDefault(_providersFormlyConfig);
	
		var _providersFormlyValidationMessages = __webpack_require__(10);
	
		var _providersFormlyValidationMessages2 = _interopRequireDefault(_providersFormlyValidationMessages);
	
		var _servicesFormlyUtil = __webpack_require__(11);
	
		var _servicesFormlyUtil2 = _interopRequireDefault(_servicesFormlyUtil);
	
		var _servicesFormlyWarn = __webpack_require__(12);
	
		var _servicesFormlyWarn2 = _interopRequireDefault(_servicesFormlyWarn);
	
		var _directivesFormlyCustomValidation = __webpack_require__(13);
	
		var _directivesFormlyCustomValidation2 = _interopRequireDefault(_directivesFormlyCustomValidation);
	
		var _directivesFormlyField = __webpack_require__(14);
	
		var _directivesFormlyField2 = _interopRequireDefault(_directivesFormlyField);
	
		var _directivesFormlyFocus = __webpack_require__(15);
	
		var _directivesFormlyFocus2 = _interopRequireDefault(_directivesFormlyFocus);
	
		var _directivesFormlyForm = __webpack_require__(16);
	
		var _directivesFormlyForm2 = _interopRequireDefault(_directivesFormlyForm);
	
		var _directivesFormlyFormController = __webpack_require__(17);
	
		var _directivesFormlyFormController2 = _interopRequireDefault(_directivesFormlyFormController);
	
		var _runFormlyNgModelAttrsManipulator = __webpack_require__(18);
	
		var _runFormlyNgModelAttrsManipulator2 = _interopRequireDefault(_runFormlyNgModelAttrsManipulator);
	
		var _runFormlyCustomTags = __webpack_require__(19);
	
		var _runFormlyCustomTags2 = _interopRequireDefault(_runFormlyCustomTags);
	
		var ngModuleName = 'formly';
	
		exports['default'] = ngModuleName;
	
		var ngModule = _angularFix2['default'].module(ngModuleName, []);
	
		ngModule.constant('formlyApiCheck', _providersFormlyApiCheck2['default']);
		ngModule.constant('formlyErrorAndWarningsUrlPrefix', _otherDocsBaseUrl2['default']);
		ngModule.constant('formlyVersion', ("8.4.1")); // <-- webpack variable
	
		ngModule.provider('formlyUsability', _providersFormlyUsability2['default']);
		ngModule.provider('formlyConfig', _providersFormlyConfig2['default']);
	
		ngModule.factory('formlyValidationMessages', _providersFormlyValidationMessages2['default']);
		ngModule.factory('formlyUtil', _servicesFormlyUtil2['default']);
		ngModule.factory('formlyWarn', _servicesFormlyWarn2['default']);
	
		ngModule.directive('formlyCustomValidation', _directivesFormlyCustomValidation2['default']);
		ngModule.directive('formlyField', _directivesFormlyField2['default']);
		ngModule.directive('formlyFocus', _directivesFormlyFocus2['default']);
		ngModule.directive('formlyForm', _directivesFormlyForm2['default']);
		ngModule.controller('FormlyFormController', _directivesFormlyFormController2['default']);
	
		ngModule.run(_runFormlyNgModelAttrsManipulator2['default']);
		ngModule.run(_runFormlyCustomTags2['default']);
		module.exports = exports['default'];
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		// some versions of angular don't export the angular module properly,
		// so we get it from window in this case.
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var angular = __webpack_require__(3);
	
		/* istanbul ignore next */
		if (!angular.version) {
		  angular = window.angular;
		}
		exports['default'] = angular;
		module.exports = exports['default'];
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _apiCheck = __webpack_require__(5);
	
		var _apiCheck2 = _interopRequireDefault(_apiCheck);
	
		var apiCheck = (0, _apiCheck2['default'])({
		  output: {
		    prefix: 'angular-formly:',
		    docsBaseUrl: __webpack_require__(6)
		  }
		});
	
		function shapeRequiredIfNot(otherProps, propChecker) {
		  if (!_angularFix2['default'].isArray(otherProps)) {
		    otherProps = [otherProps];
		  }
		  var type = 'specified if these are not specified: `' + otherProps.join(', ') + '` (otherwise it\'s optional)';
	
		  function shapeRequiredIfNotDefinition(prop, propName, location, obj) {
		    var propExists = obj && obj.hasOwnProperty(propName);
		    var otherPropsExist = otherProps.some(function (otherProp) {
		      return obj && obj.hasOwnProperty(otherProp);
		    });
		    if (!otherPropsExist && !propExists) {
		      return apiCheck.utils.getError(propName, location, type);
		    } else if (propExists) {
		      return propChecker(prop, propName, location, obj);
		    }
		  }
	
		  shapeRequiredIfNotDefinition.type = type;
		  return apiCheck.utils.checkerHelpers.setupChecker(shapeRequiredIfNotDefinition);
		}
	
		var formlyExpression = apiCheck.oneOfType([apiCheck.string, apiCheck.func]);
		var specifyWrapperType = apiCheck.typeOrArrayOf(apiCheck.string).nullable;
	
		var apiCheckProperty = apiCheck.func;
	
		var apiCheckInstanceProperty = apiCheck.shape.onlyIf('apiCheck', apiCheck.func.withProperties({
		  warn: apiCheck.func,
		  'throw': apiCheck.func,
		  shape: apiCheck.func
		}));
	
		var apiCheckFunctionProperty = apiCheck.shape.onlyIf('apiCheck', apiCheck.oneOf(['throw', 'warn']));
	
		var formlyWrapperType = apiCheck.shape({
		  name: shapeRequiredIfNot('types', apiCheck.string).optional,
		  template: apiCheck.shape.ifNot('templateUrl', apiCheck.string).optional,
		  templateUrl: apiCheck.shape.ifNot('template', apiCheck.string).optional,
		  types: apiCheck.typeOrArrayOf(apiCheck.string).optional,
		  overwriteOk: apiCheck.bool.optional,
		  apiCheck: apiCheckProperty.optional,
		  apiCheckInstance: apiCheckInstanceProperty.optional,
		  apiCheckFunction: apiCheckFunctionProperty.optional,
		  apiCheckOptions: apiCheck.object.optional
		}).strict;
	
		var expressionProperties = apiCheck.objectOf(apiCheck.oneOfType([formlyExpression, apiCheck.shape({
		  expression: formlyExpression,
		  message: formlyExpression.optional
		}).strict]));
	
		var modelChecker = apiCheck.oneOfType([apiCheck.string, apiCheck.object]);
	
		var templateManipulators = apiCheck.shape({
		  preWrapper: apiCheck.arrayOf(apiCheck.func).nullable.optional,
		  postWrapper: apiCheck.arrayOf(apiCheck.func).nullable.optional
		}).strict.nullable;
	
		var validatorChecker = apiCheck.objectOf(apiCheck.oneOfType([formlyExpression, apiCheck.shape({
		  expression: formlyExpression,
		  message: formlyExpression.optional
		}).strict]));
	
		var watcherChecker = apiCheck.typeOrArrayOf(apiCheck.shape({
		  expression: formlyExpression.optional,
		  listener: formlyExpression.optional,
		  runFieldExpressions: apiCheck.bool.optional
		}));
	
		var fieldOptionsApiShape = {
		  $$hashKey: apiCheck.any.optional,
		  type: apiCheck.shape.ifNot(['template', 'templateUrl'], apiCheck.string).optional,
		  template: apiCheck.shape.ifNot(['type', 'templateUrl'], apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  templateUrl: apiCheck.shape.ifNot(['type', 'template'], apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  key: apiCheck.oneOfType([apiCheck.string, apiCheck.number]).optional,
		  model: modelChecker.optional,
		  originalModel: modelChecker.optional,
		  className: apiCheck.string.optional,
		  id: apiCheck.string.optional,
		  name: apiCheck.string.optional,
		  expressionProperties: expressionProperties.optional,
		  extras: apiCheck.shape({
		    validateOnModelChange: apiCheck.bool.optional,
		    skipNgModelAttrsManipulator: apiCheck.oneOfType([apiCheck.string, apiCheck.bool]).optional
		  }).strict.optional,
		  data: apiCheck.object.optional,
		  templateOptions: apiCheck.object.optional,
		  wrapper: specifyWrapperType.optional,
		  modelOptions: apiCheck.shape({
		    updateOn: apiCheck.string.optional,
		    debounce: apiCheck.oneOfType([apiCheck.objectOf(apiCheck.number), apiCheck.number]).optional,
		    allowInvalid: apiCheck.bool.optional,
		    getterSetter: apiCheck.bool.optional,
		    timezone: apiCheck.string.optional
		  }).optional,
		  watcher: watcherChecker.optional,
		  validators: validatorChecker.optional,
		  asyncValidators: validatorChecker.optional,
		  parsers: apiCheck.arrayOf(formlyExpression).optional,
		  formatters: apiCheck.arrayOf(formlyExpression).optional,
		  noFormControl: apiCheck.bool.optional,
		  hide: apiCheck.bool.optional,
		  hideExpression: formlyExpression.optional,
		  ngModelElAttrs: apiCheck.objectOf(apiCheck.string).optional,
		  ngModelAttrs: apiCheck.objectOf(apiCheck.shape({
		    statement: apiCheck.shape.ifNot(['value', 'attribute', 'bound', 'boolean'], apiCheck.any).optional,
		    value: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
		    attribute: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
		    bound: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
		    boolean: apiCheck.shape.ifNot('statement', apiCheck.any).optional
		  }).strict).optional,
		  elementAttributes: apiCheck.objectOf(apiCheck.string).optional,
		  optionsTypes: apiCheck.typeOrArrayOf(apiCheck.string).optional,
		  link: apiCheck.func.optional,
		  controller: apiCheck.oneOfType([apiCheck.string, apiCheck.func, apiCheck.array]).optional,
		  validation: apiCheck.shape({
		    show: apiCheck.bool.nullable.optional,
		    messages: apiCheck.objectOf(formlyExpression).optional,
		    errorExistsAndShouldBeVisible: apiCheck.bool.optional
		  }).optional,
		  formControl: apiCheck.typeOrArrayOf(apiCheck.object).optional,
		  value: apiCheck.func.optional,
		  runExpressions: apiCheck.func.optional,
		  templateManipulators: templateManipulators.optional,
		  resetModel: apiCheck.func.optional,
		  updateInitialValue: apiCheck.func.optional,
		  initialValue: apiCheck.any.optional,
		  defaultValue: apiCheck.any.optional
		};
	
		var formlyFieldOptions = apiCheck.shape(fieldOptionsApiShape).strict;
	
		var formOptionsApi = apiCheck.shape({
		  formState: apiCheck.object.optional,
		  resetModel: apiCheck.func.optional,
		  updateInitialValue: apiCheck.func.optional,
		  removeChromeAutoComplete: apiCheck.bool.optional,
		  parseKeyArrays: apiCheck.bool.optional,
		  templateManipulators: templateManipulators.optional,
		  manualModelWatcher: apiCheck.oneOfType([apiCheck.bool, apiCheck.func]).optional,
		  watchAllExpressions: apiCheck.bool.optional,
		  wrapper: specifyWrapperType.optional,
		  fieldTransform: apiCheck.oneOfType([apiCheck.func, apiCheck.array]).optional,
		  data: apiCheck.object.optional
		}).strict;
	
		var fieldGroup = apiCheck.shape({
		  $$hashKey: apiCheck.any.optional,
		  key: apiCheck.oneOfType([apiCheck.string, apiCheck.number]).optional,
		  // danger. Nested field groups wont get api-checked...
		  fieldGroup: apiCheck.arrayOf(apiCheck.oneOfType([formlyFieldOptions, apiCheck.object])),
		  className: apiCheck.string.optional,
		  options: formOptionsApi.optional,
		  templateOptions: apiCheck.object.optional,
		  wrapper: specifyWrapperType.optional,
		  watcher: watcherChecker.optional,
		  hide: apiCheck.bool.optional,
		  hideExpression: formlyExpression.optional,
		  data: apiCheck.object.optional,
		  model: modelChecker.optional,
		  form: apiCheck.object.optional,
		  elementAttributes: apiCheck.objectOf(apiCheck.string).optional
		}).strict;
	
		var typeOptionsDefaultOptions = _angularFix2['default'].copy(fieldOptionsApiShape);
		typeOptionsDefaultOptions.key = apiCheck.string.optional;
	
		var formlyTypeOptions = apiCheck.shape({
		  name: apiCheck.string,
		  template: apiCheck.shape.ifNot('templateUrl', apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  templateUrl: apiCheck.shape.ifNot('template', apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  controller: apiCheck.oneOfType([apiCheck.func, apiCheck.string, apiCheck.array]).optional,
		  link: apiCheck.func.optional,
		  defaultOptions: apiCheck.oneOfType([apiCheck.func, apiCheck.shape(typeOptionsDefaultOptions)]).optional,
		  'extends': apiCheck.string.optional,
		  wrapper: specifyWrapperType.optional,
		  data: apiCheck.object.optional,
		  apiCheck: apiCheckProperty.optional,
		  apiCheckInstance: apiCheckInstanceProperty.optional,
		  apiCheckFunction: apiCheckFunctionProperty.optional,
		  apiCheckOptions: apiCheck.object.optional,
		  overwriteOk: apiCheck.bool.optional
		}).strict;
	
		_angularFix2['default'].extend(apiCheck, {
		  formlyTypeOptions: formlyTypeOptions, formlyFieldOptions: formlyFieldOptions, formlyExpression: formlyExpression, formlyWrapperType: formlyWrapperType, fieldGroup: fieldGroup, formOptionsApi: formOptionsApi
		});
	
		exports['default'] = apiCheck;
		module.exports = exports['default'];
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = "https://github.com/formly-js/angular-formly/blob/" + ("8.4.1") + "/other/ERRORS_AND_WARNINGS.md#";
		module.exports = exports["default"];
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyUsability.$inject = ["formlyApiCheck", "formlyErrorAndWarningsUrlPrefix"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = formlyUsability;
	
		// @ngInject
		function formlyUsability(formlyApiCheck, formlyErrorAndWarningsUrlPrefix) {
		  var _this = this;
	
		  _angularFix2['default'].extend(this, {
		    getFormlyError: getFormlyError,
		    getFieldError: getFieldError,
		    checkWrapper: checkWrapper,
		    checkWrapperTemplate: checkWrapperTemplate,
		    getErrorMessage: getErrorMessage,
		    $get: function $get() {
		      return _this;
		    }
		  });
	
		  function getFieldError(errorInfoSlug, message, field) {
		    if (arguments.length < 3) {
		      field = message;
		      message = errorInfoSlug;
		      errorInfoSlug = null;
		    }
		    return new Error(getErrorMessage(errorInfoSlug, message) + (' Field definition: ' + _angularFix2['default'].toJson(field)));
		  }
	
		  function getFormlyError(errorInfoSlug, message) {
		    if (!message) {
		      message = errorInfoSlug;
		      errorInfoSlug = null;
		    }
		    return new Error(getErrorMessage(errorInfoSlug, message));
		  }
	
		  function getErrorMessage(errorInfoSlug, message) {
		    var url = '';
		    if (errorInfoSlug !== null) {
		      url = '' + formlyErrorAndWarningsUrlPrefix + errorInfoSlug;
		    }
		    return 'Formly Error: ' + message + '. ' + url;
		  }
	
		  function checkWrapper(wrapper) {
		    formlyApiCheck['throw'](formlyApiCheck.formlyWrapperType, wrapper, {
		      prefix: 'formlyConfig.setWrapper',
		      urlSuffix: 'setwrapper-validation-failed'
		    });
		  }
	
		  function checkWrapperTemplate(template, additionalInfo) {
		    var formlyTransclude = '<formly-transclude></formly-transclude>';
		    if (template.indexOf(formlyTransclude) === -1) {
		      throw getFormlyError('Template wrapper templates must use "' + formlyTransclude + '" somewhere in them. ' + ('This one does not have "<formly-transclude></formly-transclude>" in it: ' + template) + '\n' + ('Additional information: ' + JSON.stringify(additionalInfo)));
		    }
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyConfig.$inject = ["formlyUsabilityProvider", "formlyErrorAndWarningsUrlPrefix", "formlyApiCheck"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _otherUtils = __webpack_require__(9);
	
		var _otherUtils2 = _interopRequireDefault(_otherUtils);
	
		exports['default'] = formlyConfig;
	
		// @ngInject
		function formlyConfig(formlyUsabilityProvider, formlyErrorAndWarningsUrlPrefix, formlyApiCheck) {
		  var _this2 = this;
	
		  var typeMap = {};
		  var templateWrappersMap = {};
		  var defaultWrapperName = 'default';
		  var _this = this;
		  var getError = formlyUsabilityProvider.getFormlyError;
	
		  _angularFix2['default'].extend(this, {
		    setType: setType,
		    getType: getType,
		    getTypes: getTypes,
		    getTypeHeritage: getTypeHeritage,
		    setWrapper: setWrapper,
		    getWrapper: getWrapper,
		    getWrapperByType: getWrapperByType,
		    removeWrapperByName: removeWrapperByName,
		    removeWrappersForType: removeWrappersForType,
		    disableWarnings: false,
		    extras: {
		      disableNgModelAttrsManipulator: false,
		      fieldTransform: [],
		      ngModelAttrsManipulatorPreferUnbound: false,
		      removeChromeAutoComplete: false,
		      parseKeyArrays: false,
		      defaultHideDirective: 'ng-if',
		      getFieldId: null
		    },
		    templateManipulators: {
		      preWrapper: [],
		      postWrapper: []
		    },
		    $get: function $get() {
		      return _this2;
		    }
		  });
	
		  function setType(options) {
		    if (_angularFix2['default'].isArray(options)) {
		      var _ret = (function () {
		        var allTypes = [];
		        _angularFix2['default'].forEach(options, function (item) {
		          allTypes.push(setType(item));
		        });
		        return {
		          v: allTypes
		        };
		      })();
	
		      if (typeof _ret === 'object') return _ret.v;
		    } else if (_angularFix2['default'].isObject(options)) {
		      checkType(options);
		      if (options['extends']) {
		        extendTypeOptions(options);
		      }
		      typeMap[options.name] = options;
		      return typeMap[options.name];
		    } else {
		      throw getError('You must provide an object or array for setType. You provided: ' + JSON.stringify(arguments));
		    }
		  }
	
		  function checkType(options) {
		    formlyApiCheck['throw'](formlyApiCheck.formlyTypeOptions, options, {
		      prefix: 'formlyConfig.setType',
		      url: 'settype-validation-failed'
		    });
		    if (!options.overwriteOk) {
		      checkOverwrite(options.name, typeMap, options, 'types');
		    } else {
		      options.overwriteOk = undefined;
		    }
		  }
	
		  function extendTypeOptions(options) {
		    var extendsType = getType(options['extends'], true, options);
		    extendTypeControllerFunction(options, extendsType);
		    extendTypeLinkFunction(options, extendsType);
		    extendTypeDefaultOptions(options, extendsType);
		    _otherUtils2['default'].reverseDeepMerge(options, extendsType);
		    extendTemplate(options, extendsType);
		  }
	
		  function extendTemplate(options, extendsType) {
		    if (options.template && extendsType.templateUrl) {
		      delete options.templateUrl;
		    } else if (options.templateUrl && extendsType.template) {
		      delete options.template;
		    }
		  }
	
		  function extendTypeControllerFunction(options, extendsType) {
		    var extendsCtrl = extendsType.controller;
		    if (!_angularFix2['default'].isDefined(extendsCtrl)) {
		      return;
		    }
		    var optionsCtrl = options.controller;
		    if (_angularFix2['default'].isDefined(optionsCtrl)) {
		      options.controller = function ($scope, $controller) {
		        $controller(extendsCtrl, { $scope: $scope });
		        $controller(optionsCtrl, { $scope: $scope });
		      };
		      options.controller.$inject = ['$scope', '$controller'];
		    } else {
		      options.controller = extendsCtrl;
		    }
		  }
	
		  function extendTypeLinkFunction(options, extendsType) {
		    var extendsFn = extendsType.link;
		    if (!_angularFix2['default'].isDefined(extendsFn)) {
		      return;
		    }
		    var optionsFn = options.link;
		    if (_angularFix2['default'].isDefined(optionsFn)) {
		      options.link = function () {
		        extendsFn.apply(undefined, arguments);
		        optionsFn.apply(undefined, arguments);
		      };
		    } else {
		      options.link = extendsFn;
		    }
		  }
	
		  function extendTypeDefaultOptions(options, extendsType) {
		    var extendsDO = extendsType.defaultOptions;
		    if (!_angularFix2['default'].isDefined(extendsDO)) {
		      return;
		    }
		    var optionsDO = options.defaultOptions || {};
		    var optionsDOIsFn = _angularFix2['default'].isFunction(optionsDO);
		    var extendsDOIsFn = _angularFix2['default'].isFunction(extendsDO);
		    if (extendsDOIsFn) {
		      options.defaultOptions = function defaultOptions(opts, scope) {
		        var extendsDefaultOptions = extendsDO(opts, scope);
		        var mergedDefaultOptions = {};
		        _otherUtils2['default'].reverseDeepMerge(mergedDefaultOptions, opts, extendsDefaultOptions);
		        var extenderOptionsDefaultOptions = optionsDO;
		        if (optionsDOIsFn) {
		          extenderOptionsDefaultOptions = extenderOptionsDefaultOptions(mergedDefaultOptions, scope);
		        }
		        _otherUtils2['default'].reverseDeepMerge(extenderOptionsDefaultOptions, extendsDefaultOptions);
		        return extenderOptionsDefaultOptions;
		      };
		    } else if (optionsDOIsFn) {
		      options.defaultOptions = function defaultOptions(opts, scope) {
		        var newDefaultOptions = {};
		        _otherUtils2['default'].reverseDeepMerge(newDefaultOptions, opts, extendsDO);
		        return optionsDO(newDefaultOptions, scope);
		      };
		    }
		  }
	
		  function getType(name, throwError, errorContext) {
		    if (!name) {
		      return undefined;
		    }
		    var type = typeMap[name];
		    if (!type && throwError === true) {
		      throw getError('There is no type by the name of "' + name + '": ' + JSON.stringify(errorContext));
		    } else {
		      return type;
		    }
		  }
	
		  function getTypes() {
		    return typeMap;
		  }
	
		  function getTypeHeritage(parent) {
		    var heritage = [];
		    var type = parent;
		    if (_angularFix2['default'].isString(type)) {
		      type = getType(parent);
		    }
		    parent = type['extends'];
		    while (parent) {
		      type = getType(parent);
		      heritage.push(type);
		      parent = type['extends'];
		    }
		    return heritage;
		  }
	
		  function setWrapper(_x, _x2) {
		    var _again = true;
	
		    _function: while (_again) {
		      var options = _x,
		          name = _x2;
		      _again = false;
	
		      if (_angularFix2['default'].isArray(options)) {
		        return options.map(function (wrapperOptions) {
		          return setWrapper(wrapperOptions);
		        });
		      } else if (_angularFix2['default'].isObject(options)) {
		        options.types = getOptionsTypes(options);
		        options.name = getOptionsName(options, name);
		        checkWrapperAPI(options);
		        templateWrappersMap[options.name] = options;
		        return options;
		      } else if (_angularFix2['default'].isString(options)) {
		        _x = {
		          template: options,
		          name: name
		        };
		        _x2 = undefined;
		        _again = true;
		        continue _function;
		      }
		    }
		  }
	
		  function getOptionsTypes(options) {
		    if (_angularFix2['default'].isString(options.types)) {
		      return [options.types];
		    }
		    if (!_angularFix2['default'].isDefined(options.types)) {
		      return [];
		    } else {
		      return options.types;
		    }
		  }
	
		  function getOptionsName(options, name) {
		    return options.name || name || options.types.join(' ') || defaultWrapperName;
		  }
	
		  function checkWrapperAPI(options) {
		    formlyUsabilityProvider.checkWrapper(options);
		    if (options.template) {
		      formlyUsabilityProvider.checkWrapperTemplate(options.template, options);
		    }
		    if (!options.overwriteOk) {
		      checkOverwrite(options.name, templateWrappersMap, options, 'templateWrappers');
		    } else {
		      delete options.overwriteOk;
		    }
		    checkWrapperTypes(options);
		  }
	
		  function checkWrapperTypes(options) {
		    var shouldThrow = !_angularFix2['default'].isArray(options.types) || !options.types.every(_angularFix2['default'].isString);
		    if (shouldThrow) {
		      throw getError('Attempted to create a template wrapper with types that is not a string or an array of strings');
		    }
		  }
	
		  function checkOverwrite(property, object, newValue, objectName) {
		    if (object.hasOwnProperty(property)) {
		      warn('overwriting-types-or-wrappers', ['Attempting to overwrite ' + property + ' on ' + objectName + ' which is currently', JSON.stringify(object[property]) + ' with ' + JSON.stringify(newValue), 'To supress this warning, specify the property "overwriteOk: true"'].join(' '));
		    }
		  }
	
		  function getWrapper(name) {
		    return templateWrappersMap[name || defaultWrapperName];
		  }
	
		  function getWrapperByType(type) {
		    /* eslint prefer-const:0 */
		    var wrappers = [];
		    for (var _name in templateWrappersMap) {
		      if (templateWrappersMap.hasOwnProperty(_name)) {
		        if (templateWrappersMap[_name].types && templateWrappersMap[_name].types.indexOf(type) !== -1) {
		          wrappers.push(templateWrappersMap[_name]);
		        }
		      }
		    }
		    return wrappers;
		  }
	
		  function removeWrapperByName(name) {
		    var wrapper = templateWrappersMap[name];
		    delete templateWrappersMap[name];
		    return wrapper;
		  }
	
		  function removeWrappersForType(type) {
		    var wrappers = getWrapperByType(type);
		    if (!wrappers) {
		      return undefined;
		    }
		    if (!_angularFix2['default'].isArray(wrappers)) {
		      return removeWrapperByName(wrappers.name);
		    } else {
		      wrappers.forEach(function (wrapper) {
		        return removeWrapperByName(wrapper.name);
		      });
		      return wrappers;
		    }
		  }
	
		  function warn() {
		    if (!_this.disableWarnings && console.warn) {
		      /* eslint no-console:0 */
		      var args = Array.prototype.slice.call(arguments);
		      var warnInfoSlug = args.shift();
		      args.unshift('Formly Warning:');
		      args.push('' + formlyErrorAndWarningsUrlPrefix + warnInfoSlug);
		      console.warn.apply(console, _toConsumableArray(args));
		    }
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = {
		  containsSelector: containsSelector, containsSpecialChar: containsSpecialChar, formlyEval: formlyEval, getFieldId: getFieldId, reverseDeepMerge: reverseDeepMerge, findByNodeName: findByNodeName,
		  arrayify: arrayify, extendFunction: extendFunction, extendArray: extendArray, startsWith: startsWith, contains: contains
		};
	
		function containsSelector(string) {
		  return containsSpecialChar(string, '.') || containsSpecialChar(string, '[') && containsSpecialChar(string, ']');
		}
	
		function containsSpecialChar(a, b) {
		  if (!a || !a.indexOf) {
		    return false;
		  }
		  return a.indexOf(b) !== -1;
		}
	
		function formlyEval(scope, expression, $modelValue, $viewValue, extraLocals) {
		  if (_angularFix2['default'].isFunction(expression)) {
		    return expression($viewValue, $modelValue, scope, extraLocals);
		  } else {
		    return scope.$eval(expression, _angularFix2['default'].extend({ $viewValue: $viewValue, $modelValue: $modelValue }, extraLocals));
		  }
		}
	
		function getFieldId(formId, options, index) {
		  if (options.id) {
		    return options.id;
		  }
		  var type = options.type;
		  if (!type && options.template) {
		    type = 'template';
		  } else if (!type && options.templateUrl) {
		    type = 'templateUrl';
		  }
	
		  return [formId, type, options.key, index].join('_');
		}
	
		function reverseDeepMerge(dest) {
		  _angularFix2['default'].forEach(arguments, function (src, index) {
		    if (!index) {
		      return;
		    }
		    _angularFix2['default'].forEach(src, function (val, prop) {
		      if (!_angularFix2['default'].isDefined(dest[prop])) {
		        dest[prop] = _angularFix2['default'].copy(val);
		      } else if (objAndSameType(dest[prop], val)) {
		        reverseDeepMerge(dest[prop], val);
		      }
		    });
		  });
		  return dest;
		}
	
		function objAndSameType(obj1, obj2) {
		  return _angularFix2['default'].isObject(obj1) && _angularFix2['default'].isObject(obj2) && Object.getPrototypeOf(obj1) === Object.getPrototypeOf(obj2);
		}
	
		// recurse down a node tree to find a node with matching nodeName, for custom tags jQuery.find doesn't work in IE8
		function findByNodeName(el, nodeName) {
		  if (!el.prop) {
		    // not a jQuery or jqLite object -> wrap it
		    el = _angularFix2['default'].element(el);
		  }
	
		  if (el.prop('nodeName') === nodeName.toUpperCase()) {
		    return el;
		  }
	
		  var c = el.children();
		  for (var i = 0; c && i < c.length; i++) {
		    var node = findByNodeName(c[i], nodeName);
		    if (node) {
		      return node;
		    }
		  }
		}
	
		function arrayify(obj) {
		  if (obj && !_angularFix2['default'].isArray(obj)) {
		    obj = [obj];
		  } else if (!obj) {
		    obj = [];
		  }
		  return obj;
		}
	
		function extendFunction() {
		  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
		    fns[_key] = arguments[_key];
		  }
	
		  return function extendedFunction() {
		    var args = arguments;
		    fns.forEach(function (fn) {
		      return fn.apply(null, args);
		    });
		  };
		}
	
		function extendArray(primary, secondary, property) {
		  if (property) {
		    primary = primary[property];
		    secondary = secondary[property];
		  }
		  if (secondary && primary) {
		    _angularFix2['default'].forEach(secondary, function (item) {
		      if (primary.indexOf(item) === -1) {
		        primary.push(item);
		      }
		    });
		    return primary;
		  } else if (secondary) {
		    return secondary;
		  } else {
		    return primary;
		  }
		}
	
		function startsWith(str, search) {
		  if (_angularFix2['default'].isString(str) && _angularFix2['default'].isString(search)) {
		    return str.length >= search.length && str.substring(0, search.length) === search;
		  } else {
		    return false;
		  }
		}
	
		function contains(str, search) {
		  if (_angularFix2['default'].isString(str) && _angularFix2['default'].isString(search)) {
		    return str.length >= search.length && str.indexOf(search) !== -1;
		  } else {
		    return false;
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = formlyValidationMessages;
	
		// @ngInject
		function formlyValidationMessages() {
	
		  var validationMessages = {
		    addTemplateOptionValueMessage: addTemplateOptionValueMessage,
		    addStringMessage: addStringMessage,
		    messages: {}
		  };
	
		  return validationMessages;
	
		  function addTemplateOptionValueMessage(name, prop, prefix, suffix, alternate) {
		    validationMessages.messages[name] = templateOptionValue(prop, prefix, suffix, alternate);
		  }
	
		  function addStringMessage(name, string) {
		    validationMessages.messages[name] = function () {
		      return string;
		    };
		  }
	
		  function templateOptionValue(prop, prefix, suffix, alternate) {
		    return function getValidationMessage(viewValue, modelValue, scope) {
		      if (typeof scope.options.templateOptions[prop] !== 'undefined') {
		        return prefix + ' ' + scope.options.templateOptions[prop] + ' ' + suffix;
		      } else {
		        return alternate;
		      }
		    };
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _otherUtils = __webpack_require__(9);
	
		var _otherUtils2 = _interopRequireDefault(_otherUtils);
	
		exports['default'] = formlyUtil;
	
		// @ngInject
		function formlyUtil() {
		  return _otherUtils2['default'];
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
		'use strict';
	
		formlyWarn.$inject = ["formlyConfig", "formlyErrorAndWarningsUrlPrefix", "$log"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		exports['default'] = formlyWarn;
	
		// @ngInject
		function formlyWarn(formlyConfig, formlyErrorAndWarningsUrlPrefix, $log) {
		  return function warn() {
		    if (!formlyConfig.disableWarnings) {
		      var args = Array.prototype.slice.call(arguments);
		      var warnInfoSlug = args.shift();
		      args.unshift('Formly Warning:');
		      args.push('' + formlyErrorAndWarningsUrlPrefix + warnInfoSlug);
		      $log.warn.apply($log, _toConsumableArray(args));
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyCustomValidation.$inject = ["formlyUtil"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = formlyCustomValidation;
	
		// @ngInject
		function formlyCustomValidation(formlyUtil) {
		  return {
		    restrict: 'A',
		    require: 'ngModel',
		    link: function formlyCustomValidationLink(scope, el, attrs, ctrl) {
		      var opts = scope.options;
		      opts.validation.messages = opts.validation.messages || {};
		      _angularFix2['default'].forEach(opts.validation.messages, function (message, key) {
		        opts.validation.messages[key] = function () {
		          return formlyUtil.formlyEval(scope, message, ctrl.$modelValue, ctrl.$viewValue);
		        };
		      });
	
		      var useNewValidatorsApi = ctrl.hasOwnProperty('$validators') && !attrs.hasOwnProperty('useParsers');
		      _angularFix2['default'].forEach(opts.validators, _angularFix2['default'].bind(null, addValidatorToPipeline, false));
		      _angularFix2['default'].forEach(opts.asyncValidators, _angularFix2['default'].bind(null, addValidatorToPipeline, true));
	
		      function addValidatorToPipeline(isAsync, validator, name) {
		        setupMessage(validator, name);
		        validator = _angularFix2['default'].isObject(validator) ? validator.expression : validator;
		        if (useNewValidatorsApi) {
		          setupWithValidators(validator, name, isAsync);
		        } else {
		          setupWithParsers(validator, name, isAsync);
		        }
		      }
	
		      function setupMessage(validator, name) {
		        var message = validator.message;
		        if (message) {
		          opts.validation.messages[name] = function () {
		            return formlyUtil.formlyEval(scope, message, ctrl.$modelValue, ctrl.$viewValue);
		          };
		        }
		      }
	
		      function setupWithValidators(validator, name, isAsync) {
		        var validatorCollection = isAsync ? '$asyncValidators' : '$validators';
	
		        ctrl[validatorCollection][name] = function evalValidity(modelValue, viewValue) {
		          return formlyUtil.formlyEval(scope, validator, modelValue, viewValue);
		        };
		      }
	
		      function setupWithParsers(validator, name, isAsync) {
		        var inFlightValidator = undefined;
		        ctrl.$parsers.unshift(function evalValidityOfParser(viewValue) {
		          var isValid = formlyUtil.formlyEval(scope, validator, ctrl.$modelValue, viewValue);
		          if (isAsync) {
		            ctrl.$pending = ctrl.$pending || {};
		            ctrl.$pending[name] = true;
		            inFlightValidator = isValid;
		            isValid.then(function () {
		              if (inFlightValidator === isValid) {
		                ctrl.$setValidity(name, true);
		              }
		            })['catch'](function () {
		              if (inFlightValidator === isValid) {
		                ctrl.$setValidity(name, false);
		              }
		            })['finally'](function () {
		              var $pending = ctrl.$pending || {};
		              if (Object.keys($pending).length === 1) {
		                delete ctrl.$pending;
		              } else {
		                delete ctrl.$pending[name];
		              }
		            });
		          } else {
		            ctrl.$setValidity(name, isValid);
		          }
		          return viewValue;
		        });
		      }
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyField.$inject = ["$http", "$q", "$compile", "$templateCache", "$interpolate", "formlyConfig", "formlyApiCheck", "formlyUtil", "formlyUsability", "formlyWarn"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _apiCheck = __webpack_require__(5);
	
		var _apiCheck2 = _interopRequireDefault(_apiCheck);
	
		exports['default'] = formlyField;
	
		/**
		 * @ngdoc directive
		 * @name formlyField
		 * @restrict AE
		 */
		// @ngInject
		function formlyField($http, $q, $compile, $templateCache, $interpolate, formlyConfig, formlyApiCheck, formlyUtil, formlyUsability, formlyWarn) {
		  FormlyFieldController.$inject = ["$scope", "$timeout", "$parse", "$controller", "formlyValidationMessages"];
		  var arrayify = formlyUtil.arrayify;
	
		  return {
		    restrict: 'AE',
		    transclude: true,
		    require: '?^formlyForm',
		    scope: {
		      options: '=',
		      model: '=',
		      originalModel: '=?',
		      formId: '@', // TODO remove formId in a breaking release
		      index: '=?',
		      fields: '=?',
		      formState: '=?',
		      formOptions: '=?',
		      form: '=?' },
		    // TODO require form in a breaking release
		    controller: FormlyFieldController,
		    link: fieldLink
		  };
	
		  // @ngInject
		  function FormlyFieldController($scope, $timeout, $parse, $controller, formlyValidationMessages) {
		    /* eslint max-statements:[2, 37] */
		    if ($scope.options.fieldGroup) {
		      setupFieldGroup();
		      return;
		    }
	
		    var fieldType = getFieldType($scope.options);
		    simplifyLife($scope.options);
		    mergeFieldOptionsWithTypeDefaults($scope.options, fieldType);
		    extendOptionsWithDefaults($scope.options, $scope.index);
		    checkApi($scope.options);
		    // set field id to link labels and fields
	
		    // initalization
		    setFieldIdAndName();
		    setDefaultValue();
		    setInitialValue();
		    runExpressions();
		    watchExpressions();
		    addValidationMessages($scope.options);
		    invokeControllers($scope, $scope.options, fieldType);
	
		    // function definitions
		    function runExpressions() {
		      var deferred = $q.defer();
		      // must run on next tick to make sure that the current value is correct.
		      $timeout(function runExpressionsOnNextTick() {
		        var promises = [];
		        var field = $scope.options;
		        var currentValue = valueGetterSetter();
		        _angularFix2['default'].forEach(field.expressionProperties, function runExpression(expression, prop) {
		          var setter = $parse(prop).assign;
		          var promise = $q.when(formlyUtil.formlyEval($scope, expression, currentValue, currentValue)).then(function setFieldValue(value) {
		            setter(field, value);
		          });
		          promises.push(promise);
		        });
		        $q.all(promises).then(function () {
		          deferred.resolve();
		        });
		      }, 0, false);
		      return deferred.promise;
		    }
	
		    function watchExpressions() {
		      if ($scope.formOptions.watchAllExpressions) {
		        (function () {
		          var field = $scope.options;
		          var currentValue = valueGetterSetter();
		          _angularFix2['default'].forEach(field.expressionProperties, function watchExpression(expression, prop) {
		            var setter = $parse(prop).assign;
		            $scope.$watch(function expressionPropertyWatcher() {
		              return formlyUtil.formlyEval($scope, expression, currentValue, currentValue);
		            }, function expressionPropertyListener(value) {
		              setter(field, value);
		            }, true);
		          });
		        })();
		      }
		    }
	
		    function valueGetterSetter(newVal) {
		      if (!$scope.model || !$scope.options.key) {
		        return undefined;
		      }
		      if (_angularFix2['default'].isDefined(newVal)) {
		        parseSet($scope.options.key, $scope.model, newVal);
		      }
		      return parseGet($scope.options.key, $scope.model);
		    }
	
		    function shouldNotUseParseKey(key) {
		      return _angularFix2['default'].isNumber(key) || !formlyUtil.containsSelector(key);
		    }
	
		    function keyContainsArrays(key) {
		      return (/\[\d{1,}\]/.test(key)
		      );
		    }
	
		    function deepAssign(obj, prop, value) {
		      if (_angularFix2['default'].isString(prop)) {
		        prop = prop.replace(/\[(\w+)\]/g, '.$1').split('.');
		      }
	
		      if (prop.length > 1) {
		        var e = prop.shift();
		        obj[e] = obj[e] || isNaN(prop[0]) ? {} : [];
		        deepAssign(obj[e], prop, value);
		      } else {
		        obj[prop[0]] = value;
		      }
		    }
	
		    function parseSet(key, model, newVal) {
		      // If either of these are null/undefined then just return undefined
		      if (!key && key !== 0 || !model) {
		        return;
		      }
		      // If we are working with a number then $parse wont work, default back to the old way for now
		      if (shouldNotUseParseKey(key)) {
		        // TODO: Fix this so we can get several levels instead of just one with properties that are numeric
		        model[key] = newVal;
		      } else if (formlyConfig.extras.parseKeyArrays && keyContainsArrays(key)) {
		        deepAssign($scope.model, key, newVal);
		      } else {
		        var setter = $parse($scope.options.key).assign;
		        if (setter) {
		          setter($scope.model, newVal);
		        }
		      }
		    }
	
		    function parseGet(key, model) {
		      // If either of these are null/undefined then just return undefined
		      if (!key && key !== 0 || !model) {
		        return undefined;
		      }
	
		      // If we are working with a number then $parse wont work, default back to the old way for now
		      if (shouldNotUseParseKey(key)) {
		        // TODO: Fix this so we can get several levels instead of just one with properties that are numeric
		        return model[key];
		      } else {
		        return $parse(key)(model);
		      }
		    }
	
		    function simplifyLife(options) {
		      // add a few empty objects (if they don't already exist) so you don't have to undefined check everywhere
		      formlyUtil.reverseDeepMerge(options, {
		        originalModel: options.model,
		        extras: {},
		        data: {},
		        templateOptions: {},
		        validation: {}
		      });
		      // create $scope.to so template authors can reference to instead of $scope.options.templateOptions
		      $scope.to = $scope.options.templateOptions;
		      $scope.formOptions = $scope.formOptions || {};
		    }
	
		    function setFieldIdAndName() {
		      if (_angularFix2['default'].isFunction(formlyConfig.extras.getFieldId)) {
		        $scope.id = formlyConfig.extras.getFieldId($scope.options, $scope.model, $scope);
		      } else {
		        var formName = $scope.form && $scope.form.$name || $scope.formId;
		        $scope.id = formlyUtil.getFieldId(formName, $scope.options, $scope.index);
		      }
		      $scope.options.id = $scope.id;
		      $scope.name = $scope.options.name || $scope.options.id;
		      $scope.options.name = $scope.name;
		    }
	
		    function setDefaultValue() {
		      if (_angularFix2['default'].isDefined($scope.options.defaultValue) && !_angularFix2['default'].isDefined(parseGet($scope.options.key, $scope.model))) {
		        parseSet($scope.options.key, $scope.model, $scope.options.defaultValue);
		      }
		    }
	
		    function setInitialValue() {
		      $scope.options.initialValue = $scope.model && parseGet($scope.options.key, $scope.model);
		    }
	
		    function mergeFieldOptionsWithTypeDefaults(options, type) {
		      if (type) {
		        mergeOptions(options, type.defaultOptions);
		      }
		      var properOrder = arrayify(options.optionsTypes).reverse(); // so the right things are overridden
		      _angularFix2['default'].forEach(properOrder, function (typeName) {
		        mergeOptions(options, formlyConfig.getType(typeName, true, options).defaultOptions);
		      });
		    }
	
		    function mergeOptions(options, extraOptions) {
		      if (extraOptions) {
		        if (_angularFix2['default'].isFunction(extraOptions)) {
		          extraOptions = extraOptions(options, $scope);
		        }
		        formlyUtil.reverseDeepMerge(options, extraOptions);
		      }
		    }
	
		    function extendOptionsWithDefaults(options, index) {
		      var key = options.key || index || 0;
		      _angularFix2['default'].extend(options, {
		        // attach the key in case the formly-field directive is used directly
		        key: key,
		        value: options.value || valueGetterSetter,
		        runExpressions: runExpressions,
		        resetModel: resetModel,
		        updateInitialValue: updateInitialValue
		      });
		    }
	
		    function resetModel() {
		      parseSet($scope.options.key, $scope.model, $scope.options.initialValue);
		      if ($scope.options.formControl) {
		        if (_angularFix2['default'].isArray($scope.options.formControl)) {
		          _angularFix2['default'].forEach($scope.options.formControl, function (formControl) {
		            resetFormControl(formControl, true);
		          });
		        } else {
		          resetFormControl($scope.options.formControl);
		        }
		      }
		      if ($scope.form) {
		        $scope.form.$setUntouched && $scope.form.$setUntouched();
		        $scope.form.$setPristine();
		      }
		    }
	
		    function resetFormControl(formControl, isMultiNgModel) {
		      if (!isMultiNgModel) {
		        formControl.$setViewValue(parseGet($scope.options.key, $scope.model));
		      }
	
		      formControl.$render();
		      formControl.$setUntouched && formControl.$setUntouched();
		      formControl.$setPristine();
	
		      // To prevent breaking change requiring a digest to reset $viewModel
		      if (!$scope.$root.$$phase) {
		        $scope.$digest();
		      }
		    }
	
		    function updateInitialValue() {
		      $scope.options.initialValue = parseGet($scope.options.key, $scope.model);
		    }
	
		    function addValidationMessages(options) {
		      options.validation.messages = options.validation.messages || {};
		      _angularFix2['default'].forEach(formlyValidationMessages.messages, function createFunctionForMessage(expression, name) {
		        if (!options.validation.messages[name]) {
		          options.validation.messages[name] = function evaluateMessage(viewValue, modelValue, scope) {
		            return formlyUtil.formlyEval(scope, expression, modelValue, viewValue);
		          };
		        }
		      });
		    }
	
		    function invokeControllers(scope) {
		      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
		      var type = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
		      _angularFix2['default'].forEach([type.controller, options.controller], function (controller) {
		        if (controller) {
		          $controller(controller, { $scope: scope });
		        }
		      });
		    }
	
		    function setupFieldGroup() {
		      $scope.options.options = $scope.options.options || {};
		      $scope.options.options.formState = $scope.formState;
		      $scope.to = $scope.options.templateOptions;
		    }
		  }
	
		  // link function
		  function fieldLink(scope, el, attrs, formlyFormCtrl) {
		    if (scope.options.fieldGroup) {
		      setFieldGroupTemplate();
		      return;
		    }
	
		    // watch the field model (if exists) if there is no parent formly-form directive (that would watch it instead)
		    if (!formlyFormCtrl && scope.options.model) {
		      scope.$watch('options.model', function () {
		        return scope.options.runExpressions();
		      }, true);
		    }
	
		    addAttributes();
		    addClasses();
	
		    var type = getFieldType(scope.options);
		    var args = arguments;
		    var thusly = this;
		    var fieldCount = 0;
		    var fieldManipulators = getManipulators(scope.options, scope.formOptions);
		    getFieldTemplate(scope.options).then(runManipulators(fieldManipulators.preWrapper)).then(transcludeInWrappers(scope.options, scope.formOptions)).then(runManipulators(fieldManipulators.postWrapper)).then(setElementTemplate).then(watchFormControl).then(callLinkFunctions)['catch'](function (error) {
		      formlyWarn('there-was-a-problem-setting-the-template-for-this-field', 'There was a problem setting the template for this field ', scope.options, error);
		    });
	
		    function setFieldGroupTemplate() {
		      checkFieldGroupApi(scope.options);
		      el.addClass('formly-field-group');
		      var extraAttributes = '';
		      if (scope.options.elementAttributes) {
		        extraAttributes = Object.keys(scope.options.elementAttributes).map(function (key) {
		          return key + '="' + scope.options.elementAttributes[key] + '"';
		        }).join(' ');
		      }
		      var modelValue = 'model';
		      scope.options.form = scope.form;
		      if (scope.options.key) {
		        modelValue = 'model[\'' + scope.options.key + '\']';
		      }
		      getTemplate('\n          <formly-form model="' + modelValue + '"\n                       fields="options.fieldGroup"\n                       options="options.options"\n                       form="options.form"\n                       class="' + scope.options.className + '"\n                       ' + extraAttributes + '\n                       is-field-group>\n          </formly-form>\n        ').then(transcludeInWrappers(scope.options, scope.formOptions)).then(setElementTemplate);
		    }
	
		    function addAttributes() {
		      if (scope.options.elementAttributes) {
		        el.attr(scope.options.elementAttributes);
		      }
		    }
	
		    function addClasses() {
		      if (scope.options.className) {
		        el.addClass(scope.options.className);
		      }
		      if (scope.options.type) {
		        el.addClass('formly-field-' + scope.options.type);
		      }
		    }
	
		    function setElementTemplate(templateString) {
		      el.html(asHtml(templateString));
		      $compile(el.contents())(scope);
		      return templateString;
		    }
	
		    function watchFormControl(templateString) {
		      var stopWatchingShowError = _angularFix2['default'].noop;
		      if (scope.options.noFormControl) {
		        return;
		      }
		      var templateEl = _angularFix2['default'].element('<div>' + templateString + '</div>');
		      var ngModelNodes = templateEl[0].querySelectorAll('[ng-model],[data-ng-model]');
	
		      if (ngModelNodes.length) {
		        _angularFix2['default'].forEach(ngModelNodes, function (ngModelNode) {
		          fieldCount++;
		          watchFieldNameOrExistence(ngModelNode.getAttribute('name'));
		        });
		      }
	
		      function watchFieldNameOrExistence(name) {
		        var nameExpressionRegex = /\{\{(.*?)}}/;
		        var nameExpression = nameExpressionRegex.exec(name);
		        if (nameExpression) {
		          name = $interpolate(name)(scope);
		        }
		        watchFieldExistence(name);
		      }
	
		      function watchFieldExistence(name) {
		        scope.$watch('form["' + name + '"]', function formControlChange(formControl) {
		          if (formControl) {
		            if (fieldCount > 1) {
		              if (!scope.options.formControl) {
		                scope.options.formControl = [];
		              }
		              scope.options.formControl.push(formControl);
		            } else {
		              scope.options.formControl = formControl;
		            }
		            scope.fc = scope.options.formControl; // shortcut for template authors
		            stopWatchingShowError();
		            addShowMessagesWatcher();
		            addParsers();
		            addFormatters();
		          }
		        });
		      }
	
		      function addShowMessagesWatcher() {
		        stopWatchingShowError = scope.$watch(function watchShowValidationChange() {
		          var customExpression = formlyConfig.extras.errorExistsAndShouldBeVisibleExpression;
		          var options = scope.options;
		          var formControls = arrayify(scope.fc);
		          if (!formControls.some(function (fc) {
		            return fc.$invalid;
		          })) {
		            return false;
		          } else if (typeof options.validation.show === 'boolean') {
		            return options.validation.show;
		          } else if (customExpression) {
		            return formControls.some(function (fc) {
		              return formlyUtil.formlyEval(scope, customExpression, fc.$modelValue, fc.$viewValue);
		            });
		          } else {
		            return formControls.some(function (fc) {
		              var noTouchedButDirty = _angularFix2['default'].isUndefined(fc.$touched) && fc.$dirty;
		              return fc.$touched || noTouchedButDirty;
		            });
		          }
		        }, function onShowValidationChange(show) {
		          scope.options.validation.errorExistsAndShouldBeVisible = show;
		          scope.showError = show; // shortcut for template authors
		        });
		      }
	
		      function addParsers() {
		        setParsersOrFormatters('parsers');
		      }
	
		      function addFormatters() {
		        setParsersOrFormatters('formatters');
		        var ctrl = scope.fc;
		        var formWasPristine = scope.form.$pristine;
		        if (scope.options.formatters) {
		          (function () {
		            var value = ctrl.$modelValue;
		            ctrl.$formatters.forEach(function (formatter) {
		              value = formatter(value);
		            });
	
		            ctrl.$setViewValue(value);
		            ctrl.$render();
		            ctrl.$setPristine();
		            if (formWasPristine) {
		              scope.form.$setPristine();
		            }
		          })();
		        }
		      }
	
		      function setParsersOrFormatters(which) {
		        var originalThingProp = 'originalParser';
		        if (which === 'formatters') {
		          originalThingProp = 'originalFormatter';
		        }
	
		        // init with type's parsers
		        var things = getThingsFromType(type);
	
		        // get optionsTypes things
		        things = formlyUtil.extendArray(things, getThingsFromOptionsTypes(scope.options.optionsTypes));
	
		        // get field's things
		        things = formlyUtil.extendArray(things, scope.options[which]);
	
		        // convert things into formlyExpression things
		        _angularFix2['default'].forEach(things, function (thing, index) {
		          things[index] = getFormlyExpressionThing(thing);
		        });
	
		        var ngModelCtrls = scope.fc;
		        if (!_angularFix2['default'].isArray(ngModelCtrls)) {
		          ngModelCtrls = [ngModelCtrls];
		        }
	
		        _angularFix2['default'].forEach(ngModelCtrls, function (ngModelCtrl) {
		          var _ngModelCtrl;
	
		          ngModelCtrl['$' + which] = (_ngModelCtrl = ngModelCtrl['$' + which]).concat.apply(_ngModelCtrl, _toConsumableArray(things));
		        });
	
		        function getThingsFromType(theType) {
		          if (!theType) {
		            return [];
		          }
		          if (_angularFix2['default'].isString(theType)) {
		            theType = formlyConfig.getType(theType, true, scope.options);
		          }
		          var typeThings = [];
	
		          // get things from parent
		          if (theType['extends']) {
		            typeThings = formlyUtil.extendArray(typeThings, getThingsFromType(theType['extends']));
		          }
	
		          // get own type's things
		          typeThings = formlyUtil.extendArray(typeThings, getDefaultOptionsProperty(theType, which, []));
	
		          // get things from optionsTypes
		          typeThings = formlyUtil.extendArray(typeThings, getThingsFromOptionsTypes(getDefaultOptionsOptionsTypes(theType)));
	
		          return typeThings;
		        }
	
		        function getThingsFromOptionsTypes() {
		          var optionsTypes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
		          var optionsTypesThings = [];
		          _angularFix2['default'].forEach(_angularFix2['default'].copy(arrayify(optionsTypes)).reverse(), function (optionsTypeName) {
		            optionsTypesThings = formlyUtil.extendArray(optionsTypesThings, getThingsFromType(optionsTypeName));
		          });
		          return optionsTypesThings;
		        }
	
		        function getFormlyExpressionThing(thing) {
		          formlyExpressionParserOrFormatterFunction[originalThingProp] = thing;
		          return formlyExpressionParserOrFormatterFunction;
	
		          function formlyExpressionParserOrFormatterFunction($viewValue) {
		            var $modelValue = scope.options.value();
		            return formlyUtil.formlyEval(scope, thing, $modelValue, $viewValue);
		          }
		        }
		      }
		    }
	
		    function callLinkFunctions() {
		      if (type && type.link) {
		        type.link.apply(thusly, args);
		      }
		      if (scope.options.link) {
		        scope.options.link.apply(thusly, args);
		      }
		    }
	
		    function runManipulators(manipulators) {
		      return function runManipulatorsOnTemplate(templateToManipulate) {
		        var chain = $q.when(templateToManipulate);
		        _angularFix2['default'].forEach(manipulators, function (manipulator) {
		          chain = chain.then(function (template) {
		            return $q.when(manipulator(template, scope.options, scope)).then(function (newTemplate) {
		              return _angularFix2['default'].isString(newTemplate) ? newTemplate : asHtml(newTemplate);
		            });
		          });
		        });
		        return chain;
		      };
		    }
		  }
	
		  // sort-of stateless util functions
		  function asHtml(el) {
		    var wrapper = _angularFix2['default'].element('<a></a>');
		    return wrapper.append(el).html();
		  }
	
		  function getFieldType(options) {
		    return options.type && formlyConfig.getType(options.type);
		  }
	
		  function getManipulators(options, formOptions) {
		    var preWrapper = [];
		    var postWrapper = [];
		    addManipulators(options.templateManipulators);
		    addManipulators(formOptions.templateManipulators);
		    addManipulators(formlyConfig.templateManipulators);
		    return { preWrapper: preWrapper, postWrapper: postWrapper };
	
		    function addManipulators(manipulators) {
		      /* eslint-disable */ // it doesn't understand this :-(
	
		      var _ref = manipulators || {};
	
		      var _ref$preWrapper = _ref.preWrapper;
		      var pre = _ref$preWrapper === undefined ? [] : _ref$preWrapper;
		      var _ref$postWrapper = _ref.postWrapper;
		      var post = _ref$postWrapper === undefined ? [] : _ref$postWrapper;
	
		      preWrapper = preWrapper.concat(pre);
		      postWrapper = postWrapper.concat(post);
		      /* eslint-enable */
		    }
		  }
	
		  function getFieldTemplate(options) {
		    function fromOptionsOrType(key, fieldType) {
		      if (_angularFix2['default'].isDefined(options[key])) {
		        return options[key];
		      } else if (fieldType && _angularFix2['default'].isDefined(fieldType[key])) {
		        return fieldType[key];
		      }
		    }
	
		    var type = formlyConfig.getType(options.type, true, options);
		    var template = fromOptionsOrType('template', type);
		    var templateUrl = fromOptionsOrType('templateUrl', type);
		    if (_angularFix2['default'].isUndefined(template) && !templateUrl) {
		      throw formlyUsability.getFieldError('type-type-has-no-template', 'Type \'' + options.type + '\' has no template. On element:', options);
		    }
	
		    return getTemplate(templateUrl || template, _angularFix2['default'].isUndefined(template), options);
		  }
	
		  function getTemplate(template, isUrl, options) {
		    var templatePromise = undefined;
		    if (_angularFix2['default'].isFunction(template)) {
		      templatePromise = $q.when(template(options));
		    } else {
		      templatePromise = $q.when(template);
		    }
	
		    if (!isUrl) {
		      return templatePromise;
		    } else {
		      var _ret3 = (function () {
		        var httpOptions = { cache: $templateCache };
		        return {
		          v: templatePromise.then(function (url) {
		            return $http.get(url, httpOptions);
		          }).then(function (response) {
		            return response.data;
		          })['catch'](function handleErrorGettingATemplate(error) {
		            formlyWarn('problem-loading-template-for-templateurl', 'Problem loading template for ' + template, error);
		          })
		        };
		      })();
	
		      if (typeof _ret3 === 'object') return _ret3.v;
		    }
		  }
	
		  function transcludeInWrappers(options, formOptions) {
		    var wrapper = getWrapperOption(options, formOptions);
	
		    return function transcludeTemplate(template) {
		      if (!wrapper.length) {
		        return $q.when(template);
		      }
	
		      wrapper.forEach(function (aWrapper) {
		        formlyUsability.checkWrapper(aWrapper, options);
		        runApiCheck(aWrapper, options);
		      });
		      var promises = wrapper.map(function (w) {
		        return getTemplate(w.template || w.templateUrl, !w.template);
		      });
		      return $q.all(promises).then(function (wrappersTemplates) {
		        wrappersTemplates.forEach(function (wrapperTemplate, index) {
		          formlyUsability.checkWrapperTemplate(wrapperTemplate, wrapper[index]);
		        });
		        wrappersTemplates.reverse(); // wrapper 0 is wrapped in wrapper 1 and so on...
		        var totalWrapper = wrappersTemplates.shift();
		        wrappersTemplates.forEach(function (wrapperTemplate) {
		          totalWrapper = doTransclusion(totalWrapper, wrapperTemplate);
		        });
		        return doTransclusion(totalWrapper, template);
		      });
		    };
		  }
	
		  function doTransclusion(wrapper, template) {
		    var superWrapper = _angularFix2['default'].element('<a></a>'); // this allows people not have to have a single root in wrappers
		    superWrapper.append(wrapper);
		    var transcludeEl = superWrapper.find('formly-transclude');
		    if (!transcludeEl.length) {
		      // try it using our custom find function
		      transcludeEl = formlyUtil.findByNodeName(superWrapper, 'formly-transclude');
		    }
		    transcludeEl.replaceWith(template);
		    return superWrapper.html();
		  }
	
		  function getWrapperOption(options, formOptions) {
		    /* eslint complexity:[2, 6] */
		    var wrapper = options.wrapper;
		    // explicit null means no wrapper
		    if (wrapper === null) {
		      return [];
		    }
	
		    // nothing specified means use the default wrapper for the type
		    if (!wrapper) {
		      // get all wrappers that specify they apply to this type
		      wrapper = arrayify(formlyConfig.getWrapperByType(options.type));
		    } else {
		      wrapper = arrayify(wrapper).map(formlyConfig.getWrapper);
		    }
	
		    // get all wrappers for that the type specified that it uses.
		    var type = formlyConfig.getType(options.type, true, options);
		    if (type && type.wrapper) {
		      var typeWrappers = arrayify(type.wrapper).map(formlyConfig.getWrapper);
		      wrapper = wrapper.concat(typeWrappers);
		    }
	
		    // add form wrappers
		    if (formOptions.wrapper) {
		      var formWrappers = arrayify(formOptions.wrapper).map(formlyConfig.getWrapper);
		      wrapper = wrapper.concat(formWrappers);
		    }
	
		    // add the default wrapper last
		    var defaultWrapper = formlyConfig.getWrapper();
		    if (defaultWrapper) {
		      wrapper.push(defaultWrapper);
		    }
		    return wrapper;
		  }
	
		  function checkApi(options) {
		    formlyApiCheck['throw'](formlyApiCheck.formlyFieldOptions, options, {
		      prefix: 'formly-field directive',
		      url: 'formly-field-directive-validation-failed'
		    });
		    // validate with the type
		    var type = options.type && formlyConfig.getType(options.type);
		    if (type) {
		      runApiCheck(type, options, true);
		    }
		    if (options.expressionProperties && options.expressionProperties.hide) {
		      formlyWarn('dont-use-expressionproperties.hide-use-hideexpression-instead', 'You have specified `hide` in `expressionProperties`. Use `hideExpression` instead', options);
		    }
		  }
	
		  function checkFieldGroupApi(options) {
		    formlyApiCheck['throw'](formlyApiCheck.fieldGroup, options, {
		      prefix: 'formly-field directive',
		      url: 'formly-field-directive-validation-failed'
		    });
		  }
	
		  function runApiCheck(_ref2, options, forType) {
		    var apiCheck = _ref2.apiCheck;
		    var apiCheckInstance = _ref2.apiCheckInstance;
		    var apiCheckFunction = _ref2.apiCheckFunction;
		    var apiCheckOptions = _ref2.apiCheckOptions;
	
		    runApiCheckForType(apiCheck, apiCheckInstance, apiCheckFunction, apiCheckOptions, options);
		    if (forType && options.type) {
		      _angularFix2['default'].forEach(formlyConfig.getTypeHeritage(options.type), function (type) {
		        runApiCheckForType(type.apiCheck, type.apiCheckInstance, type.apiCheckFunction, type.apiCheckOptions, options);
		      });
		    }
		  }
	
		  function runApiCheckForType(apiCheck, apiCheckInstance, apiCheckFunction, apiCheckOptions, options) {
		    /* eslint complexity:[2, 9] */
		    if (!apiCheck) {
		      return;
		    }
		    var instance = apiCheckInstance || formlyConfig.extras.apiCheckInstance || formlyApiCheck;
		    if (instance.config.disabled || _apiCheck2['default'].globalConfig.disabled) {
		      return;
		    }
		    var fn = apiCheckFunction || 'warn';
		    // this is the new API
		    var checkerObjects = apiCheck(instance);
		    _angularFix2['default'].forEach(checkerObjects, function (shape, name) {
		      var checker = instance.shape(shape);
		      var checkOptions = _angularFix2['default'].extend({
		        prefix: 'formly-field type ' + options.type + ' for property ' + name,
		        url: formlyApiCheck.config.output.docsBaseUrl + 'formly-field-type-apicheck-failed'
		      }, apiCheckOptions);
		      instance[fn](checker, options[name], checkOptions);
		    });
		  }
		}
	
		// Stateless util functions
		function getDefaultOptionsOptionsTypes(type) {
		  return getDefaultOptionsProperty(type, 'optionsTypes', []);
		}
	
		function getDefaultOptionsProperty(type, prop, defaultValue) {
		  return type.defaultOptions && type.defaultOptions[prop] || defaultValue;
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		'use strict';
	
		formlyFocus.$inject = ["$timeout", "$document"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = formlyFocus;
	
		// @ngInject
		function formlyFocus($timeout, $document) {
		  return {
		    restrict: 'A',
		    link: function formlyFocusLink(scope, element, attrs) {
		      var previousEl = null;
		      var el = element[0];
		      var doc = $document[0];
		      attrs.$observe('formlyFocus', function respondToFocusExpressionChange(value) {
		        /* eslint no-bitwise:0 */ // I know what I'm doing. I promise...
		        if (value === 'true') {
		          $timeout(function setElementFocus() {
		            previousEl = doc.activeElement;
		            el.focus();
		          }, ~ ~attrs.focusWait);
		        } else if (value === 'false') {
		          if (doc.activeElement === el) {
		            el.blur();
		            if (attrs.hasOwnProperty('refocus') && previousEl) {
		              previousEl.focus();
		            }
		          }
		        }
		      });
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyForm.$inject = ["formlyUsability", "formlyWarn", "$parse", "formlyConfig", "$interpolate"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = formlyForm;
	
		/**
		 * @ngdoc directive
		 * @name formlyForm
		 * @restrict AE
		 */
		// @ngInject
		function formlyForm(formlyUsability, formlyWarn, $parse, formlyConfig, $interpolate) {
		  var currentFormId = 1;
		  return {
		    restrict: 'AE',
		    template: formlyFormGetTemplate,
		    replace: true,
		    transclude: true,
		    scope: {
		      fields: '=',
		      model: '=',
		      form: '=?',
		      options: '=?'
		    },
		    controller: 'FormlyFormController',
		    link: formlyFormLink
		  };
	
		  function formlyFormGetTemplate(el, attrs) {
		    var rootEl = getRootEl();
		    var fieldRootEl = getFieldRootEl();
		    var formId = 'formly_' + currentFormId++;
		    var parentFormAttributes = '';
		    if (attrs.hasOwnProperty('isFieldGroup') && el.parent().parent().hasClass('formly')) {
		      parentFormAttributes = copyAttributes(el.parent().parent()[0].attributes);
		    }
		    return '\n        <' + rootEl + ' class="formly"\n                 name="' + getFormName() + '"\n                 role="form" ' + parentFormAttributes + '>\n          <' + fieldRootEl + ' formly-field\n               ng-repeat="field in fields ' + getTrackBy() + '"\n               ' + getHideDirective() + '="!field.hide"\n               class="formly-field"\n               options="field"\n               model="field.model || model"\n               original-model="model"\n               fields="fields"\n               form="theFormlyForm"\n               form-id="' + getFormName() + '"\n               form-state="options.formState"\n               form-options="options"\n               index="$index">\n          </' + fieldRootEl + '>\n          <div ng-transclude class="' + getTranscludeClass() + '"></div>\n        </' + rootEl + '>\n      ';
	
		    function getRootEl() {
		      return attrs.rootEl || 'ng-form';
		    }
	
		    function getFieldRootEl() {
		      return attrs.fieldRootEl || 'div';
		    }
	
		    function getHideDirective() {
		      return attrs.hideDirective || formlyConfig.extras.defaultHideDirective || 'ng-if';
		    }
	
		    function getTrackBy() {
		      if (!attrs.trackBy) {
		        return '';
		      } else {
		        return 'track by ' + attrs.trackBy;
		      }
		    }
	
		    function getFormName() {
		      var formName = formId;
		      var bindName = attrs.bindName;
		      if (bindName) {
		        if (_angularFix2['default'].version.minor < 3) {
		          throw formlyUsability.getFormlyError('bind-name attribute on formly-form not allowed in < angular 1.3');
		        }
		        // we can do a one-time binding here because we know we're in 1.3.x territory
		        formName = $interpolate.startSymbol() + '::\'formly_\' + ' + bindName + $interpolate.endSymbol();
		      }
		      return formName;
		    }
	
		    function getTranscludeClass() {
		      return attrs.transcludeClass || '';
		    }
	
		    function copyAttributes(attributes) {
		      var excluded = ['model', 'form', 'fields', 'options', 'name', 'role', 'class', 'data-model', 'data-form', 'data-fields', 'data-options', 'data-name'];
		      var arrayAttrs = [];
		      _angularFix2['default'].forEach(attributes, function (_ref) {
		        var nodeName = _ref.nodeName;
		        var value = _ref.value;
	
		        if (nodeName !== 'undefined' && excluded.indexOf(nodeName) === -1) {
		          arrayAttrs.push(toKebabCase(nodeName) + '="' + value + '"');
		        }
		      });
		      return arrayAttrs.join(' ');
		    }
		  }
	
		  function formlyFormLink(scope, el, attrs) {
		    setFormController();
		    fixChromeAutocomplete();
	
		    function setFormController() {
		      var formId = attrs.name;
		      scope.formId = formId;
		      scope.theFormlyForm = scope[formId];
		      if (attrs.form) {
		        var getter = $parse(attrs.form);
		        var setter = getter.assign;
		        var parentForm = getter(scope.$parent);
		        if (parentForm) {
		          scope.theFormlyForm = parentForm;
		          if (scope[formId]) {
		            scope.theFormlyForm.$removeControl(scope[formId]);
		          }
	
		          // this next line is probably one of the more dangerous things that angular-formly does to improve the
		          // API for angular-formly forms. It ensures that the NgModelControllers inside of formly-form will be
		          // attached to the form that is passed to formly-form rather than the one that formly-form creates
		          // this is necessary because it's confusing to have a step between the form you pass in
		          // and the fields in that form. It also is because angular doesn't propagate properties like $submitted down
		          // to children forms :-( This line was added to solve this issue:
		          // https://github.com/formly-js/angular-formly/issues/287
		          // luckily, this is how the formController has been accessed by the NgModelController since angular 1.0.0
		          // so I expect it will remain this way for the life of angular 1.x
		          el.removeData('$formController');
		        } else {
		          setter(scope.$parent, scope[formId]);
		        }
		      }
		      if (!scope.theFormlyForm && !formlyConfig.disableWarnings) {
		        /* eslint no-console:0 */
		        formlyWarn('formly-form-has-no-formcontroller', 'Your formly-form does not have a `form` property. Many functions of the form (like validation) may not work', el, scope);
		      }
		    }
	
		    /*
		     * chrome autocomplete lameness
		     * see https://code.google.com/p/chromium/issues/detail?id=468153#c14
		     * ლ(ಠ益ಠლ)   (╯°□°)╯︵ ┻━┻    (◞‸◟；)
		     */
		    function fixChromeAutocomplete() {
		      var global = formlyConfig.extras.removeChromeAutoComplete === true;
		      var offInstance = scope.options && scope.options.removeChromeAutoComplete === false;
		      var onInstance = scope.options && scope.options.removeChromeAutoComplete === true;
		      if (global && !offInstance || onInstance) {
		        var input = document.createElement('input');
		        input.setAttribute('autocomplete', 'address-level4');
		        input.setAttribute('hidden', 'true');
		        el[0].appendChild(input);
		      }
		    }
		  }
	
		  // stateless util functions
		  function toKebabCase(string) {
		    if (string) {
		      return string.replace(/([A-Z])/g, function ($1) {
		        return '-' + $1.toLowerCase();
		      });
		    } else {
		      return '';
		    }
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		FormlyFormController.$inject = ["formlyUsability", "formlyWarn", "formlyConfig", "$parse", "$scope", "formlyApiCheck", "formlyUtil"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var _slice = Array.prototype.slice;
		exports['default'] = FormlyFormController;
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		function isFieldGroup(field) {
		  return field && !!field.fieldGroup;
		}
	
		// @ngInject
	
		function FormlyFormController(formlyUsability, formlyWarn, formlyConfig, $parse, $scope, formlyApiCheck, formlyUtil) {
	
		  setupOptions();
		  $scope.model = $scope.model || {};
		  setupFields();
	
		  // watch the model and evaluate watch expressions that depend on it.
		  if (!$scope.options.manualModelWatcher) {
		    $scope.$watch('model', onModelOrFormStateChange, true);
		  } else if (_angularFix2['default'].isFunction($scope.options.manualModelWatcher)) {
		    $scope.$watch($scope.options.manualModelWatcher, onModelOrFormStateChange, true);
		  }
	
		  if ($scope.options.formState) {
		    $scope.$watch('options.formState', onModelOrFormStateChange, true);
		  }
	
		  function onModelOrFormStateChange() {
		    _angularFix2['default'].forEach($scope.fields, runFieldExpressionProperties);
		  }
	
		  function validateFormControl(formControl, promise) {
		    var validate = formControl.$validate;
		    if (promise) {
		      promise.then(function () {
		        return validate.apply(formControl);
		      });
		    } else {
		      validate();
		    }
		  }
	
		  function runFieldExpressionProperties(field, index) {
		    var model = field.model || $scope.model;
		    var promise = field.runExpressions && field.runExpressions();
		    if (field.hideExpression) {
		      // can't use hide with expressionProperties reliably
		      var val = model[field.key];
		      field.hide = evalCloseToFormlyExpression(field.hideExpression, val, field, index, { model: model });
		    }
		    if (field.extras && field.extras.validateOnModelChange && field.formControl) {
		      if (_angularFix2['default'].isArray(field.formControl)) {
		        _angularFix2['default'].forEach(field.formControl, function (formControl) {
		          validateFormControl(formControl, promise);
		        });
		      } else {
		        validateFormControl(field.formControl, promise);
		      }
		    }
		  }
	
		  function setupFields() {
		    $scope.fields = $scope.fields || [];
	
		    checkDeprecatedOptions($scope.options);
	
		    var fieldTransforms = $scope.options.fieldTransform || formlyConfig.extras.fieldTransform;
	
		    if (!_angularFix2['default'].isArray(fieldTransforms)) {
		      fieldTransforms = [fieldTransforms];
		    }
	
		    _angularFix2['default'].forEach(fieldTransforms, function transformFields(fieldTransform) {
		      if (fieldTransform) {
		        $scope.fields = fieldTransform($scope.fields, $scope.model, $scope.options, $scope.form);
		        if (!$scope.fields) {
		          throw formlyUsability.getFormlyError('fieldTransform must return an array of fields');
		        }
		      }
		    });
	
		    setupModels();
	
		    if ($scope.options.watchAllExpressions) {
		      _angularFix2['default'].forEach($scope.fields, setupHideExpressionWatcher);
		    }
	
		    _angularFix2['default'].forEach($scope.fields, attachKey); // attaches a key based on the index if a key isn't specified
		    _angularFix2['default'].forEach($scope.fields, setupWatchers); // setup watchers for all fields
		  }
	
		  function checkDeprecatedOptions(options) {
		    if (formlyConfig.extras.fieldTransform && _angularFix2['default'].isFunction(formlyConfig.extras.fieldTransform)) {
		      formlyWarn('fieldtransform-as-a-function-deprecated', 'fieldTransform as a function has been deprecated.', 'Attempted for formlyConfig.extras: ' + formlyConfig.extras.fieldTransform.name, formlyConfig.extras);
		    } else if (options.fieldTransform && _angularFix2['default'].isFunction(options.fieldTransform)) {
		      formlyWarn('fieldtransform-as-a-function-deprecated', 'fieldTransform as a function has been deprecated.', 'Attempted for form', options);
		    }
		  }
	
		  function setupOptions() {
		    formlyApiCheck['throw']([formlyApiCheck.formOptionsApi.optional], [$scope.options], { prefix: 'formly-form options check' });
		    $scope.options = $scope.options || {};
		    $scope.options.formState = $scope.options.formState || {};
	
		    _angularFix2['default'].extend($scope.options, {
		      updateInitialValue: updateInitialValue,
		      resetModel: resetModel
		    });
		  }
	
		  function updateInitialValue() {
		    _angularFix2['default'].forEach($scope.fields, function (field) {
		      if (isFieldGroup(field) && field.options) {
		        field.options.updateInitialValue();
		      } else {
		        field.updateInitialValue();
		      }
		    });
		  }
	
		  function resetModel() {
		    _angularFix2['default'].forEach($scope.fields, function (field) {
		      if (isFieldGroup(field) && field.options) {
		        field.options.resetModel();
		      } else if (field.resetModel) {
		        field.resetModel();
		      }
		    });
		  }
	
		  function setupModels() {
		    // a set of field models that are already watched (the $scope.model will have its own watcher)
		    var watchedModels = [$scope.model];
		    // we will not set up automatic model watchers if manual mode is set
		    var manualModelWatcher = $scope.options.manualModelWatcher;
	
		    if ($scope.options.formState) {
		      // $scope.options.formState will have its own watcher
		      watchedModels.push($scope.options.formState);
		    }
	
		    _angularFix2['default'].forEach($scope.fields, function (field) {
		      var isNewModel = initModel(field);
	
		      if (field.model && isNewModel && watchedModels.indexOf(field.model) === -1 && !manualModelWatcher) {
		        $scope.$watch(function () {
		          return field.model;
		        }, onModelOrFormStateChange, true);
		        watchedModels.push(field.model);
		      }
		    });
		  }
	
		  function setupHideExpressionWatcher(field, index) {
		    if (field.hideExpression) {
		      (function () {
		        // can't use hide with expressionProperties reliably
		        var model = field.model || $scope.model;
		        $scope.$watch(function hideExpressionWatcher() {
		          var val = model[field.key];
		          return evalCloseToFormlyExpression(field.hideExpression, val, field, index, { model: model });
		        }, function (hide) {
		          return field.hide = hide;
		        }, true);
		      })();
		    }
		  }
	
		  function initModel(field) {
		    var isNewModel = true;
	
		    if (_angularFix2['default'].isString(field.model)) {
		      (function () {
		        var expression = field.model;
	
		        isNewModel = !referencesCurrentlyWatchedModel(expression);
	
		        field.model = resolveStringModel(expression);
	
		        $scope.$watch(function () {
		          return resolveStringModel(expression);
		        }, function (model) {
		          return field.model = model;
		        });
		      })();
		    }
	
		    return isNewModel;
	
		    function resolveStringModel(expression) {
		      var index = $scope.fields.indexOf(field);
		      var model = evalCloseToFormlyExpression(expression, undefined, field, index, { model: $scope.model });
	
		      if (!model) {
		        throw formlyUsability.getFieldError('field-model-must-be-initialized', 'Field model must be initialized. When specifying a model as a string for a field, the result of the' + ' expression must have been initialized ahead of time.', field);
		      }
	
		      return model;
		    }
		  }
	
		  function referencesCurrentlyWatchedModel(expression) {
		    return ['model', 'formState'].some(function (item) {
		      return formlyUtil.startsWith(expression, item + '.') || formlyUtil.startsWith(expression, item + '[');
		    });
		  }
	
		  function attachKey(field, index) {
		    if (!isFieldGroup(field)) {
		      field.key = field.key || index || 0;
		    }
		  }
	
		  function setupWatchers(field, index) {
		    if (!_angularFix2['default'].isDefined(field.watcher)) {
		      return;
		    }
		    var watchers = field.watcher;
		    if (!_angularFix2['default'].isArray(watchers)) {
		      watchers = [watchers];
		    }
		    _angularFix2['default'].forEach(watchers, function setupWatcher(watcher) {
		      if (!_angularFix2['default'].isDefined(watcher.listener) && !watcher.runFieldExpressions) {
		        throw formlyUsability.getFieldError('all-field-watchers-must-have-a-listener', 'All field watchers must have a listener', field);
		      }
		      var watchExpression = getWatchExpression(watcher, field, index);
		      var watchListener = getWatchListener(watcher, field, index);
	
		      var type = watcher.type || '$watch';
		      watcher.stopWatching = $scope[type](watchExpression, watchListener, watcher.watchDeep);
		    });
		  }
	
		  function getWatchExpression(watcher, field, index) {
		    var watchExpression = undefined;
		    if (!_angularFix2['default'].isUndefined(watcher.expression)) {
		      watchExpression = watcher.expression;
		    } else if (field.key) {
		      watchExpression = 'model[\'' + field.key.toString().split('.').join('\'][\'') + '\']';
		    }
		    if (_angularFix2['default'].isFunction(watchExpression)) {
		      (function () {
		        // wrap the field's watch expression so we can call it with the field as the first arg
		        // and the stop function as the last arg as a helper
		        var originalExpression = watchExpression;
		        watchExpression = function formlyWatchExpression() {
		          var args = modifyArgs.apply(undefined, [watcher, index].concat(_slice.call(arguments)));
		          return originalExpression.apply(undefined, _toConsumableArray(args));
		        };
		        watchExpression.displayName = 'Formly Watch Expression for field for ' + field.key;
		      })();
		    } else if (field.model) {
		      watchExpression = $parse(watchExpression).bind(null, $scope, { model: field.model });
		    }
		    return watchExpression;
		  }
	
		  function getWatchListener(watcher, field, index) {
		    var watchListener = watcher.listener;
		    if (_angularFix2['default'].isFunction(watchListener) || watcher.runFieldExpressions) {
		      (function () {
		        // wrap the field's watch listener so we can call it with the field as the first arg
		        // and the stop function as the last arg as a helper
		        var originalListener = watchListener;
		        watchListener = function formlyWatchListener() {
		          var value = undefined;
		          if (originalListener) {
		            var args = modifyArgs.apply(undefined, [watcher, index].concat(_slice.call(arguments)));
		            value = originalListener.apply(undefined, _toConsumableArray(args));
		          }
		          if (watcher.runFieldExpressions) {
		            runFieldExpressionProperties(field, index);
		          }
		          return value;
		        };
		        watchListener.displayName = 'Formly Watch Listener for field for ' + field.key;
		      })();
		    }
		    return watchListener;
		  }
	
		  function modifyArgs(watcher, index) {
		    for (var _len = arguments.length, originalArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		      originalArgs[_key - 2] = arguments[_key];
		    }
	
		    return [$scope.fields[index]].concat(originalArgs, [watcher.stopWatching]);
		  }
	
		  function evalCloseToFormlyExpression(expression, val, field, index) {
		    var extraLocals = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
	
		    extraLocals = _angularFix2['default'].extend(getFormlyFieldLikeLocals(field, index), extraLocals);
		    return formlyUtil.formlyEval($scope, expression, val, val, extraLocals);
		  }
	
		  function getFormlyFieldLikeLocals(field, index) {
		    // this makes it closer to what a regular formlyExpression would be
		    return {
		      model: field.model,
		      options: field,
		      index: index,
		      formState: $scope.options.formState,
		      originalModel: $scope.model,
		      formOptions: $scope.options,
		      formId: $scope.formId
		    };
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		addFormlyNgModelAttrsManipulator.$inject = ["formlyConfig", "$interpolate"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _otherUtils = __webpack_require__(9);
	
		exports['default'] = addFormlyNgModelAttrsManipulator;
	
		// @ngInject
		function addFormlyNgModelAttrsManipulator(formlyConfig, $interpolate) {
		  if (formlyConfig.extras.disableNgModelAttrsManipulator) {
		    return;
		  }
		  formlyConfig.templateManipulators.preWrapper.push(ngModelAttrsManipulator);
	
		  function ngModelAttrsManipulator(template, options, scope) {
		    var node = document.createElement('div');
		    var skip = options.extras && options.extras.skipNgModelAttrsManipulator;
		    if (skip === true) {
		      return template;
		    }
		    node.innerHTML = template;
	
		    var modelNodes = getNgModelNodes(node, skip);
		    if (!modelNodes || !modelNodes.length) {
		      return template;
		    }
	
		    addIfNotPresent(modelNodes, 'id', scope.id);
		    addIfNotPresent(modelNodes, 'name', scope.name || scope.id);
	
		    addValidation();
		    alterNgModelAttr();
		    addModelOptions();
		    addTemplateOptionsAttrs();
		    addNgModelElAttrs();
	
		    return node.innerHTML;
	
		    function addValidation() {
		      if (_angularFix2['default'].isDefined(options.validators) || _angularFix2['default'].isDefined(options.validation.messages)) {
		        addIfNotPresent(modelNodes, 'formly-custom-validation', '');
		      }
		    }
	
		    function alterNgModelAttr() {
		      if (isPropertyAccessor(options.key)) {
		        addRegardlessOfPresence(modelNodes, 'ng-model', 'model.' + options.key);
		      }
		    }
	
		    function addModelOptions() {
		      if (_angularFix2['default'].isDefined(options.modelOptions)) {
		        addIfNotPresent(modelNodes, 'ng-model-options', 'options.modelOptions');
		        if (options.modelOptions.getterSetter) {
		          addRegardlessOfPresence(modelNodes, 'ng-model', 'options.value');
		        }
		      }
		    }
	
		    function addTemplateOptionsAttrs() {
		      if (!options.templateOptions && !options.expressionProperties) {
		        // no need to run these if there are no templateOptions or expressionProperties
		        return;
		      }
		      var to = options.templateOptions || {};
		      var ep = options.expressionProperties || {};
	
		      var ngModelAttributes = getBuiltInAttributes();
	
		      // extend with the user's specifications winning
		      _angularFix2['default'].extend(ngModelAttributes, options.ngModelAttrs);
	
		      // Feel free to make this more simple :-)
		      _angularFix2['default'].forEach(ngModelAttributes, function (val, name) {
		        /* eslint complexity:[2, 14] */
		        var attrVal = undefined,
		            attrName = undefined;
		        var ref = 'options.templateOptions[\'' + name + '\']';
		        var toVal = to[name];
		        var epVal = getEpValue(ep, name);
	
		        var inTo = _angularFix2['default'].isDefined(toVal);
		        var inEp = _angularFix2['default'].isDefined(epVal);
		        if (val.value) {
		          // I realize this looks backwards, but it's right, trust me...
		          attrName = val.value;
		          attrVal = name;
		        } else if (val.statement && inTo) {
		          attrName = val.statement;
		          if (_angularFix2['default'].isString(to[name])) {
		            attrVal = '$eval(' + ref + ')';
		          } else if (_angularFix2['default'].isFunction(to[name])) {
		            attrVal = ref + '(model[options.key], options, this, $event)';
		          } else {
		            throw new Error('options.templateOptions.' + name + ' must be a string or function: ' + JSON.stringify(options));
		          }
		        } else if (val.bound && inEp) {
		          attrName = val.bound;
		          attrVal = ref;
		        } else if ((val.attribute || val.boolean) && inEp) {
		          attrName = val.attribute || val.boolean;
		          attrVal = '' + $interpolate.startSymbol() + ref + $interpolate.endSymbol();
		        } else if (val.attribute && inTo) {
		          attrName = val.attribute;
		          attrVal = toVal;
		        } else if (val.boolean) {
		          if (inTo && !inEp && toVal) {
		            attrName = val.boolean;
		            attrVal = true;
		          } else {
		            /* eslint no-empty:0 */
		            // empty to illustrate that a boolean will not be added via val.bound
		            // if you want it added via val.bound, then put it in expressionProperties
		          }
		        } else if (val.bound && inTo) {
		            attrName = val.bound;
		            attrVal = ref;
		          }
	
		        if (_angularFix2['default'].isDefined(attrName) && _angularFix2['default'].isDefined(attrVal)) {
		          addIfNotPresent(modelNodes, attrName, attrVal);
		        }
		      });
		    }
	
		    function addNgModelElAttrs() {
		      _angularFix2['default'].forEach(options.ngModelElAttrs, function (val, name) {
		        addRegardlessOfPresence(modelNodes, name, val);
		      });
		    }
		  }
	
		  // Utility functions
		  function getNgModelNodes(node, skip) {
		    var selectorNot = _angularFix2['default'].isString(skip) ? ':not(' + skip + ')' : '';
		    var skipNot = ':not([formly-skip-ng-model-attrs-manipulator])';
		    var query = '[ng-model]' + selectorNot + skipNot + ', [data-ng-model]' + selectorNot + skipNot;
		    try {
		      return node.querySelectorAll(query);
		    } catch (e) {
		      //this code is needed for IE8, as it does not support the CSS3 ':not' selector
		      //it should be removed when IE8 support is dropped
		      return getNgModelNodesFallback(node, skip);
		    }
		  }
	
		  function getNgModelNodesFallback(node, skip) {
		    var allNgModelNodes = node.querySelectorAll('[ng-model], [data-ng-model]');
		    var matchingNgModelNodes = [];
	
		    //make sure this array is compatible with NodeList type by adding an 'item' function
		    matchingNgModelNodes.item = function (i) {
		      return this[i];
		    };
	
		    for (var i = 0; i < allNgModelNodes.length; i++) {
		      var ngModelNode = allNgModelNodes[i];
		      if (!ngModelNode.hasAttribute('formly-skip-ng-model-attrs-manipulator') && !(_angularFix2['default'].isString(skip) && nodeMatches(ngModelNode, skip))) {
		        matchingNgModelNodes.push(ngModelNode);
		      }
		    }
	
		    return matchingNgModelNodes;
		  }
	
		  function nodeMatches(node, selector) {
		    var div = document.createElement('div');
		    div.innerHTML = node.outerHTML;
		    return div.querySelector(selector);
		  }
	
		  function getBuiltInAttributes() {
		    var ngModelAttributes = {
		      focus: {
		        attribute: 'formly-focus'
		      }
		    };
		    var boundOnly = [];
		    var bothBooleanAndBound = ['required', 'disabled'];
		    var bothAttributeAndBound = ['pattern', 'minlength'];
		    var statementOnly = ['change', 'keydown', 'keyup', 'keypress', 'click', 'focus', 'blur'];
		    var attributeOnly = ['placeholder', 'min', 'max', 'step', 'tabindex', 'type'];
		    if (formlyConfig.extras.ngModelAttrsManipulatorPreferUnbound) {
		      bothAttributeAndBound.push('maxlength');
		    } else {
		      boundOnly.push('maxlength');
		    }
	
		    _angularFix2['default'].forEach(boundOnly, function (item) {
		      ngModelAttributes[item] = { bound: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(bothBooleanAndBound, function (item) {
		      ngModelAttributes[item] = { boolean: item, bound: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(bothAttributeAndBound, function (item) {
		      ngModelAttributes[item] = { attribute: item, bound: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(statementOnly, function (item) {
		      var propName = 'on' + item.substr(0, 1).toUpperCase() + item.substr(1);
		      ngModelAttributes[propName] = { statement: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(attributeOnly, function (item) {
		      ngModelAttributes[item] = { attribute: item };
		    });
		    return ngModelAttributes;
		  }
	
		  function getEpValue(ep, name) {
		    return ep['templateOptions.' + name] || ep['templateOptions[\'' + name + '\']'] || ep['templateOptions["' + name + '"]'];
		  }
	
		  function addIfNotPresent(nodes, attr, val) {
		    _angularFix2['default'].forEach(nodes, function (node) {
		      if (!node.getAttribute(attr)) {
		        node.setAttribute(attr, val);
		      }
		    });
		  }
	
		  function addRegardlessOfPresence(nodes, attr, val) {
		    _angularFix2['default'].forEach(nodes, function (node) {
		      node.setAttribute(attr, val);
		    });
		  }
	
		  function isPropertyAccessor(key) {
		    return (0, _otherUtils.contains)(key, '.') || (0, _otherUtils.contains)(key, '[') && (0, _otherUtils.contains)(key, ']');
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		addCustomTags.$inject = ["$document"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = addCustomTags;
	
		// @ngInject
		function addCustomTags($document) {
		  // IE8 check ->
		  // https://msdn.microsoft.com/en-us/library/cc196988(v=vs.85).aspx
		  if ($document && $document.documentMode < 9) {
		    (function () {
		      var document = $document.get(0);
		      // add the custom elements that we need for formly
		      var customElements = ['formly-field', 'formly-form'];
		      _angularFix2['default'].forEach(customElements, function (el) {
		        document.createElement(el);
		      });
		    })();
		  }
		}
		module.exports = exports['default'];
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! api-check version 7.5.5 built with ♥ by Kent C. Dodds <kent@doddsfamily.us> (http://kent.doddsfamily.us) (ó ì_í)=óò=(ì_í ò)
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define(factory);
		else if(typeof exports === 'object')
			exports["apiCheck"] = factory();
		else
			root["apiCheck"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _apiCheck = __webpack_require__(1);
	
		var _apiCheck2 = _interopRequireDefault(_apiCheck);
	
		exports['default'] = _apiCheck2['default'];
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var stringify = __webpack_require__(2);
		var apiCheckUtil = __webpack_require__(3);
		var each = apiCheckUtil.each;
		var isError = apiCheckUtil.isError;
		var t = apiCheckUtil.t;
		var arrayify = apiCheckUtil.arrayify;
		var getCheckerDisplay = apiCheckUtil.getCheckerDisplay;
		var typeOf = apiCheckUtil.typeOf;
		var getError = apiCheckUtil.getError;
	
		var checkers = __webpack_require__(4);
		var apiCheckApis = getApiCheckApis();
	
		module.exports = getApiCheckInstance;
		module.exports.VERSION = ("7.5.5");
		module.exports.utils = apiCheckUtil;
		module.exports.globalConfig = {
		  verbose: false,
		  disabled: false
		};
	
		var apiCheckApiCheck = getApiCheckInstance({
		  output: { prefix: 'apiCheck' }
		});
		module.exports.internalChecker = apiCheckApiCheck;
	
		each(checkers, function (checker, name) {
		  return module.exports[name] = checker;
		});
	
		function getApiCheckInstance() {
		  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		  var extraCheckers = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		  /* eslint complexity:[2, 6] */
		  if (apiCheckApiCheck && arguments.length) {
		    apiCheckApiCheck['throw'](apiCheckApis.getApiCheckInstanceCheckers, arguments, {
		      prefix: 'creating an apiCheck instance'
		    });
		  }
	
		  var additionalProperties = {
		    'throw': getApiCheck(true),
		    warn: getApiCheck(false),
		    getErrorMessage: getErrorMessage,
		    handleErrorMessage: handleErrorMessage,
		    config: {
		      output: config.output || {
		        prefix: '',
		        suffix: '',
		        docsBaseUrl: ''
		      },
		      verbose: config.verbose || false,
		      disabled: config.disabled || false
		    },
		    utils: apiCheckUtil
		  };
	
		  each(additionalProperties, function (wrapper, name) {
		    return apiCheck[name] = wrapper;
		  });
	
		  var disabled = apiCheck.disabled || module.exports.globalConfig.disabled;
		  each(checkers.getCheckers(disabled), function (checker, name) {
		    return apiCheck[name] = checker;
		  });
		  each(extraCheckers, function (checker, name) {
		    return apiCheck[name] = checker;
		  });
	
		  return apiCheck;
	
		  /**
		   * This is the instance function. Other things are attached to this see additional properties above.
		   * @param {Array} api - the checkers to check with
		   * @param {Array} args - the args to check
		   * @param {Object} output - output options
		   * @returns {Object} - if this has a failed = true property, then it failed
		   */
		  function apiCheck(api, args, output) {
		    /* eslint complexity:[2, 8] */
		    if (apiCheck.config.disabled || module.exports.globalConfig.disabled) {
		      return {
		        apiTypes: {}, argTypes: {},
		        passed: true, message: '',
		        failed: false
		      }; // empty version of what is normally returned
		    }
		    checkApiCheckApi(arguments);
		    if (!Array.isArray(api)) {
		      api = [api];
		      args = [args];
		    } else {
		      // turn arguments into an array
		      args = Array.prototype.slice.call(args);
		    }
		    var messages = checkEnoughArgs(api, args);
		    if (!messages.length) {
		      // this is where we actually go perform the checks.
		      messages = checkApiWithArgs(api, args);
		    }
	
		    var returnObject = getTypes(api, args);
		    returnObject.args = args;
		    if (messages.length) {
		      returnObject.message = apiCheck.getErrorMessage(api, args, messages, output);
		      returnObject.failed = true;
		      returnObject.passed = false;
		    } else {
		      returnObject.message = '';
		      returnObject.failed = false;
		      returnObject.passed = true;
		    }
		    return returnObject;
		  }
	
		  /**
		   * checkApiCheckApi, should be read like: check apiCheck api. As in, check the api for apiCheck :-)
		   * @param {Array} checkApiArgs - args provided to apiCheck function
		   */
		  function checkApiCheckApi(checkApiArgs) {
		    var api = checkApiArgs[0];
		    var args = checkApiArgs[1];
		    var isArrayOrArgs = Array.isArray(args) || args && typeof args === 'object' && typeof args.length === 'number';
	
		    if (Array.isArray(api) && !isArrayOrArgs) {
		      throw new Error(getErrorMessage(api, [args], ['If an array is provided for the api, an array must be provided for the args as well.'], { prefix: 'apiCheck' }));
		    }
		    // dog fooding here
		    var errors = checkApiWithArgs(apiCheckApis.checkApiCheckApi, checkApiArgs);
		    if (errors.length) {
		      var message = apiCheck.getErrorMessage(apiCheckApis.checkApiCheckApi, checkApiArgs, errors, {
		        prefix: 'apiCheck'
		      });
		      apiCheck.handleErrorMessage(message, true);
		    }
		  }
	
		  function getApiCheck(shouldThrow) {
		    return function apiCheckWrapper(api, args, output) {
		      var result = apiCheck(api, args, output);
		      apiCheck.handleErrorMessage(result.message, shouldThrow);
		      return result; // wont get here if an error is thrown
		    };
		  }
	
		  function handleErrorMessage(message, shouldThrow) {
		    if (shouldThrow && message) {
		      throw new Error(message);
		    } else if (message) {
		      /* eslint no-console:0 */
		      console.warn(message);
		    }
		  }
	
		  function getErrorMessage(api, args) {
		    var messages = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
		    var output = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
		    var gOut = apiCheck.config.output || {};
		    var prefix = getPrefix();
		    var suffix = getSuffix();
		    var url = getUrl();
		    var message = 'apiCheck failed! ' + messages.join(', ');
		    var passedAndShouldHavePassed = '\n\n' + buildMessageFromApiAndArgs(api, args);
		    return (prefix + ' ' + message + ' ' + suffix + ' ' + (url || '') + passedAndShouldHavePassed).trim();
	
		    function getPrefix() {
		      var p = output.onlyPrefix;
		      if (!p) {
		        p = ((gOut.prefix || '') + ' ' + (output.prefix || '')).trim();
		      }
		      return p;
		    }
	
		    function getSuffix() {
		      var s = output.onlySuffix;
		      if (!s) {
		        s = ((output.suffix || '') + ' ' + (gOut.suffix || '')).trim();
		      }
		      return s;
		    }
	
		    function getUrl() {
		      var u = output.url;
		      if (!u) {
		        u = gOut.docsBaseUrl && output.urlSuffix && ('' + gOut.docsBaseUrl + output.urlSuffix).trim();
		      }
		      return u;
		    }
		  }
	
		  function buildMessageFromApiAndArgs(api, args) {
		    var _getTypes = getTypes(api, args);
	
		    var apiTypes = _getTypes.apiTypes;
		    var argTypes = _getTypes.argTypes;
	
		    var copy = Array.prototype.slice.call(args || []);
		    var replacedItems = [];
		    replaceFunctionWithName(copy);
		    var passedArgs = getObjectString(copy);
		    argTypes = getObjectString(argTypes);
		    apiTypes = getObjectString(apiTypes);
	
		    return generateMessage();
	
		    // functions
	
		    function replaceFunctionWithName(obj) {
		      each(obj, function (val, name) {
		        /* eslint complexity:[2, 6] */
		        if (replacedItems.indexOf(val) === -1) {
		          // avoid recursive problems
		          replacedItems.push(val);
		          if (typeof val === 'object') {
		            replaceFunctionWithName(obj);
		          } else if (typeof val === 'function') {
		            obj[name] = val.displayName || val.name || 'anonymous function';
		          }
		        }
		      });
		    }
	
		    function getObjectString(types) {
		      if (!types || !types.length) {
		        return 'nothing';
		      } else if (types && types.length === 1) {
		        types = types[0];
		      }
		      return stringify(types, null, 2);
		    }
	
		    function generateMessage() {
		      var n = '\n';
		      var useS = true;
		      if (args && args.length === 1) {
		        if (typeof args[0] === 'object' && args[0] !== null) {
		          useS = !!Object.keys(args[0]).length;
		        } else {
		          useS = false;
		        }
		      }
		      var types = 'type' + (useS ? 's' : '');
		      var newLine = n + n;
		      return 'You passed:' + n + passedArgs + newLine + ('With the ' + types + ':' + n + argTypes + newLine) + ('The API calls for:' + n + apiTypes);
		    }
		  }
	
		  function getTypes(api, args) {
		    api = arrayify(api);
		    args = arrayify(args);
		    var apiTypes = api.map(function (checker, index) {
		      var specified = module.exports.globalConfig.hasOwnProperty('verbose');
		      return getCheckerDisplay(checker, {
		        terse: specified ? !module.exports.globalConfig.verbose : !apiCheck.config.verbose,
		        obj: args[index],
		        addHelpers: true
		      });
		    });
		    var argTypes = args.map(function (arg) {
		      return getArgDisplay(arg, []);
		    });
		    return { argTypes: argTypes, apiTypes: apiTypes };
		  }
		}
	
		// STATELESS FUNCTIONS
	
		/**
		 * This is where the magic happens for actually checking the arguments with the api.
		 * @param {Array} api - checkers
		 * @param  {Array} args - and arguments object
		 * @returns {Array} - the error messages
		 */
		function checkApiWithArgs(api, args) {
		  /* eslint complexity:[2, 7] */
		  var messages = [];
		  var failed = false;
		  var checkerIndex = 0;
		  var argIndex = 0;
		  var arg = undefined,
		      checker = undefined,
		      res = undefined,
		      lastChecker = undefined,
		      argName = undefined,
		      argFailed = undefined,
		      skipPreviousChecker = undefined;
		  /* jshint -W084 */
		  while ((checker = api[checkerIndex++]) && argIndex < args.length) {
		    arg = args[argIndex++];
		    argName = 'Argument ' + argIndex + (checker.isOptional ? ' (optional)' : '');
		    res = checker(arg, 'value', argName);
		    argFailed = isError(res);
		    lastChecker = checkerIndex >= api.length;
		    skipPreviousChecker = checkerIndex > 1 && api[checkerIndex - 1].isOptional;
		    if (argFailed && lastChecker || argFailed && !lastChecker && !checker.isOptional && !skipPreviousChecker) {
		      failed = true;
		      messages.push(getCheckerErrorMessage(res, checker, arg));
		    } else if (argFailed && checker.isOptional) {
		      argIndex--;
		    } else {
		      messages.push(t(argName) + ' passed');
		    }
		  }
		  return failed ? messages : [];
		}
	
		checkerTypeType.type = 'function with __apiCheckData property and `${function.type}` property';
		function checkerTypeType(checkerType, name, location) {
		  var apiCheckDataChecker = checkers.shape({
		    type: checkers.string,
		    optional: checkers.bool
		  });
		  var asFunc = checkers.func.withProperties({ __apiCheckData: apiCheckDataChecker });
		  var asShape = checkers.shape({ __apiCheckData: apiCheckDataChecker });
		  var wrongShape = checkers.oneOfType([asFunc, asShape])(checkerType, name, location);
		  if (isError(wrongShape)) {
		    return wrongShape;
		  }
		  if (typeof checkerType !== 'function' && !checkerType.hasOwnProperty(checkerType.__apiCheckData.type)) {
		    return getError(name, location, checkerTypeType.type);
		  }
		}
	
		function getCheckerErrorMessage(res, checker, val) {
		  var checkerHelp = getCheckerHelp(checker, val);
		  checkerHelp = checkerHelp ? ' - ' + checkerHelp : '';
		  return res.message + checkerHelp;
		}
	
		function getCheckerHelp(_ref, val) {
		  var help = _ref.help;
	
		  if (!help) {
		    return '';
		  }
		  if (typeof help === 'function') {
		    help = help(val);
		  }
		  return help;
		}
	
		function checkEnoughArgs(api, args) {
		  var requiredArgs = api.filter(function (a) {
		    return !a.isOptional;
		  });
		  if (args.length < requiredArgs.length) {
		    return ['Not enough arguments specified. Requires `' + requiredArgs.length + '`, you passed `' + args.length + '`'];
		  } else {
		    return [];
		  }
		}
	
		function getArgDisplay(arg, gottenArgs) {
		  /* eslint complexity:[2, 7] */
		  var cName = arg && arg.constructor && arg.constructor.name;
		  var type = typeOf(arg);
		  if (type === 'function') {
		    if (hasKeys()) {
		      var properties = stringify(getDisplayIfNotGotten());
		      return cName + ' (with properties: ' + properties + ')';
		    }
		    return cName;
		  }
	
		  if (arg === null) {
		    return 'null';
		  }
	
		  if (type !== 'array' && type !== 'object') {
		    return type;
		  }
	
		  if (hasKeys()) {
		    return getDisplayIfNotGotten();
		  }
	
		  return cName;
	
		  // utility functions
		  function hasKeys() {
		    return arg && Object.keys(arg).length;
		  }
	
		  function getDisplayIfNotGotten() {
		    if (gottenArgs.indexOf(arg) !== -1) {
		      return '[Circular]';
		    }
		    gottenArgs.push(arg);
		    return getDisplay(arg, gottenArgs);
		  }
		}
	
		function getDisplay(obj, gottenArgs) {
		  var argDisplay = {};
		  each(obj, function (v, k) {
		    return argDisplay[k] = getArgDisplay(v, gottenArgs);
		  });
		  return argDisplay;
		}
	
		function getApiCheckApis() {
		  var os = checkers.string.optional;
	
		  var checkerFnChecker = checkers.func.withProperties({
		    type: checkers.oneOfType([checkers.string, checkerTypeType]).optional,
		    displayName: checkers.string.optional,
		    shortType: checkers.string.optional,
		    notOptional: checkers.bool.optional,
		    notRequired: checkers.bool.optional
		  });
	
		  var getApiCheckInstanceCheckers = [checkers.shape({
		    output: checkers.shape({
		      prefix: checkers.string.optional,
		      suffix: checkers.string.optional,
		      docsBaseUrl: checkers.string.optional
		    }).strict.optional,
		    verbose: checkers.bool.optional,
		    disabled: checkers.bool.optional
		  }).strict.optional, checkers.objectOf(checkerFnChecker).optional];
	
		  var checkApiCheckApi = [checkers.typeOrArrayOf(checkerFnChecker), checkers.any.optional, checkers.shape({
		    prefix: os, suffix: os, urlSuffix: os, // appended case
		    onlyPrefix: os, onlySuffix: os, url: os // override case
		  }).strict.optional];
	
		  return {
		    checkerFnChecker: checkerFnChecker,
		    getApiCheckInstanceCheckers: getApiCheckInstanceCheckers,
		    checkApiCheckApi: checkApiCheckApi
		  };
		}
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = stringify;
	
		function getSerialize (fn, decycle) {
		  var seen = [], keys = [];
		  decycle = decycle || function(key, value) {
		    return '[Circular ' + getPath(value, seen, keys) + ']'
		  };
		  return function(key, value) {
		    var ret = value;
		    if (typeof value === 'object' && value) {
		      if (seen.indexOf(value) !== -1)
		        ret = decycle(key, value);
		      else {
		        seen.push(value);
		        keys.push(key);
		      }
		    }
		    if (fn) ret = fn(key, ret);
		    return ret;
		  }
		}
	
		function getPath (value, seen, keys) {
		  var index = seen.indexOf(value);
		  var path = [ keys[index] ];
		  for (index--; index >= 0; index--) {
		    if (seen[index][ path[0] ] === value) {
		      value = seen[index];
		      path.unshift(keys[index]);
		    }
		  }
		  return '~' + path.join('.');
		}
	
		function stringify(obj, fn, spaces, decycle) {
		  return JSON.stringify(obj, getSerialize(fn, decycle), spaces);
		}
	
		stringify.getSerialize = getSerialize;
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		var stringify = __webpack_require__(2);
		var checkerHelpers = {
		  addOptional: addOptional, getRequiredVersion: getRequiredVersion, setupChecker: setupChecker, addNullable: addNullable
		};
	
		module.exports = {
		  each: each, copy: copy, typeOf: typeOf, arrayify: arrayify, getCheckerDisplay: getCheckerDisplay,
		  isError: isError, list: list, getError: getError, nAtL: nAtL, t: t, undef: undef, checkerHelpers: checkerHelpers,
		  noop: noop
		};
	
		function copy(obj) {
		  var type = typeOf(obj);
		  var daCopy = undefined;
		  if (type === 'array') {
		    daCopy = [];
		  } else if (type === 'object') {
		    daCopy = {};
		  } else {
		    return obj;
		  }
		  each(obj, function (val, key) {
		    daCopy[key] = val; // cannot single-line this because we don't want to abort the each
		  });
		  return daCopy;
		}
	
		function typeOf(obj) {
		  if (Array.isArray(obj)) {
		    return 'array';
		  } else if (obj instanceof RegExp) {
		    return 'object';
		  } else {
		    return typeof obj;
		  }
		}
	
		function getCheckerDisplay(checker, options) {
		  /* eslint complexity:[2, 7] */
		  var display = undefined;
		  var short = options && options.short;
		  if (short && checker.shortType) {
		    display = checker.shortType;
		  } else if (!short && typeof checker.type === 'object' || checker.type === 'function') {
		    display = getCheckerType(checker, options);
		  } else {
		    display = getCheckerType(checker, options) || checker.displayName || checker.name;
		  }
		  return display;
		}
	
		function getCheckerType(_ref, options) {
		  var type = _ref.type;
	
		  if (typeof type === 'function') {
		    var __apiCheckData = type.__apiCheckData;
		    var typeTypes = type(options);
		    type = _defineProperty({
		      __apiCheckData: __apiCheckData
		    }, __apiCheckData.type, typeTypes);
		  }
		  return type;
		}
	
		function arrayify(obj) {
		  if (!obj) {
		    return [];
		  } else if (Array.isArray(obj)) {
		    return obj;
		  } else {
		    return [obj];
		  }
		}
	
		function each(obj, iterator, context) {
		  if (Array.isArray(obj)) {
		    return eachArry(obj, iterator, context);
		  } else {
		    return eachObj(obj, iterator, context);
		  }
		}
	
		function eachObj(obj, iterator, context) {
		  var ret = undefined;
		  var hasOwn = Object.prototype.hasOwnProperty;
		  /* eslint prefer-const:0 */ // some weird eslint bug?
		  for (var key in obj) {
		    if (hasOwn.call(obj, key)) {
		      ret = iterator.call(context, obj[key], key, obj);
		      if (ret === false) {
		        return ret;
		      }
		    }
		  }
		  return true;
		}
	
		function eachArry(obj, iterator, context) {
		  var ret = undefined;
		  var length = obj.length;
		  for (var i = 0; i < length; i++) {
		    ret = iterator.call(context, obj[i], i, obj);
		    if (ret === false) {
		      return ret;
		    }
		  }
		  return true;
		}
	
		function isError(obj) {
		  return obj instanceof Error;
		}
	
		function list(arry, join, finalJoin) {
		  arry = arrayify(arry);
		  var copy = arry.slice();
		  var last = copy.pop();
		  if (copy.length === 1) {
		    join = ' ';
		  }
		  return copy.join(join) + ('' + (copy.length ? join + finalJoin : '') + last);
		}
	
		function getError(name, location, checkerType) {
		  if (typeof checkerType === 'function') {
		    checkerType = checkerType({ short: true });
		  }
		  var stringType = typeof checkerType !== 'object' ? checkerType : stringify(checkerType);
		  return new Error(nAtL(name, location) + ' must be ' + t(stringType));
		}
	
		function nAtL(name, location) {
		  var tName = t(name || 'value');
		  var tLocation = !location ? '' : ' at ' + t(location);
		  return '' + tName + tLocation;
		}
	
		function t(thing) {
		  return '`' + thing + '`';
		}
	
		function undef(thing) {
		  return typeof thing === 'undefined';
		}
	
		/**
		 * This will set up the checker with all of the defaults that most checkers want like required by default and an
		 * optional version
		 *
		 * @param {Function} checker - the checker to setup with properties
		 * @param {Object} properties - properties to add to the checker
		 * @param {boolean} disabled - when set to true, this will set the checker to a no-op function
		 * @returns {Function} checker - the setup checker
		 */
		function setupChecker(checker, properties, disabled) {
		  /* eslint complexity:[2, 9] */
		  if (disabled) {
		    // swap out the checker for its own copy of noop
		    checker = getNoop();
		    checker.isNoop = true;
		  }
	
		  if (typeof checker.type === 'string') {
		    checker.shortType = checker.type;
		  }
	
		  // assign all properties given
		  each(properties, function (prop, name) {
		    return checker[name] = prop;
		  });
	
		  if (!checker.displayName) {
		    checker.displayName = 'apiCheck ' + t(checker.shortType || checker.type || checker.name) + ' type checker';
		  }
	
		  if (!checker.notRequired) {
		    checker = getRequiredVersion(checker, disabled);
		  }
	
		  if (!checker.notNullable) {
		    addNullable(checker, disabled);
		  }
	
		  if (!checker.notOptional) {
		    addOptional(checker, disabled);
		  }
	
		  return checker;
		}
	
		function getRequiredVersion(checker, disabled) {
		  var requiredChecker = disabled ? getNoop() : function requiredChecker(val, name, location, obj) {
		    if (undef(val) && !checker.isOptional) {
		      var tLocation = location ? ' in ' + t(location) : '';
		      var type = getCheckerDisplay(checker, { short: true });
		      var stringType = typeof type !== 'object' ? type : stringify(type);
		      return new Error('Required ' + t(name) + ' not specified' + tLocation + '. Must be ' + t(stringType));
		    } else {
		      return checker(val, name, location, obj);
		    }
		  };
		  copyProps(checker, requiredChecker);
		  requiredChecker.originalChecker = checker;
		  return requiredChecker;
		}
	
		function addOptional(checker, disabled) {
		  var optionalCheck = disabled ? getNoop() : function optionalCheck(val, name, location, obj) {
		    if (!undef(val)) {
		      return checker(val, name, location, obj);
		    }
		  };
		  // inherit all properties on the original checker
		  copyProps(checker, optionalCheck);
	
		  optionalCheck.isOptional = true;
		  optionalCheck.displayName = checker.displayName + ' (optional)';
		  optionalCheck.originalChecker = checker;
	
		  // the magic line that allows you to add .optional to the end of the checkers
		  checker.optional = optionalCheck;
	
		  fixType(checker, checker.optional);
		}
	
		function addNullable(checker, disabled) {
		  var nullableCheck = disabled ? getNoop() : function nullableCheck(val, name, location, obj) {
		    if (val !== null) {
		      return checker(val, name, location, obj);
		    }
		  };
		  // inherit all properties on the original checker
		  copyProps(checker, nullableCheck);
	
		  nullableCheck.isNullable = true;
		  nullableCheck.displayName = checker.displayName + ' (nullable)';
		  nullableCheck.originalChecker = checker;
	
		  // the magic line that allows you to add .nullable to the end of the checkers
		  checker.nullable = nullableCheck;
	
		  fixType(checker, checker.nullable);
		  if (!checker.notOptional) {
		    addOptional(checker.nullable, disabled);
		  }
		}
	
		function fixType(checker, checkerCopy) {
		  // fix type, because it's not a straight copy...
		  // the reason is we need to specify type.__apiCheckData.optional as true for the terse/verbose option.
		  // we also want to add "(optional)" to the types with a string
		  if (typeof checkerCopy.type === 'object') {
		    checkerCopy.type = copy(checkerCopy.type); // make our own copy of this
		  } else if (typeof checkerCopy.type === 'function') {
		      checkerCopy.type = function () {
		        return checker.type.apply(checker, arguments);
		      };
		    } else {
		      checkerCopy.type += ' (optional)';
		      return;
		    }
		  checkerCopy.type.__apiCheckData = copy(checker.type.__apiCheckData) || {}; // and this
		  checkerCopy.type.__apiCheckData.optional = true;
		}
	
		// UTILS
	
		function copyProps(src, dest) {
		  each(Object.keys(src), function (key) {
		    return dest[key] = src[key];
		  });
		}
	
		function noop() {}
	
		function getNoop() {
		  /* eslint no-shadow:0 */
		  /* istanbul ignore next */
		  return function noop() {};
		}
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var stringify = __webpack_require__(2);
	
		var _require = __webpack_require__(3);
	
		var typeOf = _require.typeOf;
		var each = _require.each;
		var copy = _require.copy;
		var getCheckerDisplay = _require.getCheckerDisplay;
		var isError = _require.isError;
		var arrayify = _require.arrayify;
		var list = _require.list;
		var getError = _require.getError;
		var nAtL = _require.nAtL;
		var t = _require.t;
		var checkerHelpers = _require.checkerHelpers;
		var undef = _require.undef;
		var setupChecker = checkerHelpers.setupChecker;
	
		var checkers = module.exports = getCheckers();
		module.exports.getCheckers = getCheckers;
	
		function getCheckers(disabled) {
		  return {
		    array: typeOfCheckGetter('Array'),
		    bool: typeOfCheckGetter('Boolean'),
		    number: typeOfCheckGetter('Number'),
		    string: typeOfCheckGetter('String'),
		    func: funcCheckGetter(),
		    object: objectCheckGetter(),
	
		    emptyObject: emptyObjectCheckGetter(),
	
		    instanceOf: instanceCheckGetter,
		    oneOf: oneOfCheckGetter,
		    oneOfType: oneOfTypeCheckGetter,
	
		    arrayOf: arrayOfCheckGetter,
		    objectOf: objectOfCheckGetter,
		    typeOrArrayOf: typeOrArrayOfCheckGetter,
	
		    range: rangeCheckGetter,
		    lessThan: lessThanCheckGetter,
		    greaterThan: greaterThanCheckGetter,
	
		    shape: getShapeCheckGetter(),
		    args: argumentsCheckerGetter(),
	
		    any: anyCheckGetter(),
		    'null': nullCheckGetter()
	
		  };
	
		  function typeOfCheckGetter(type) {
		    var lType = type.toLowerCase();
		    return setupChecker(function typeOfCheckerDefinition(val, name, location) {
		      if (typeOf(val) !== lType) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function funcCheckGetter() {
		    var type = 'Function';
		    var functionChecker = setupChecker(function functionCheckerDefinition(val, name, location) {
		      if (typeOf(val) !== 'function') {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
	
		    functionChecker.withProperties = function getWithPropertiesChecker(properties) {
		      var apiError = checkers.objectOf(checkers.func)(properties, 'properties', 'apiCheck.func.withProperties');
		      if (isError(apiError)) {
		        throw apiError;
		      }
		      var shapeChecker = checkers.shape(properties, true);
		      shapeChecker.type.__apiCheckData.type = 'func.withProperties';
	
		      return setupChecker(function functionWithPropertiesChecker(val, name, location) {
		        var notFunction = checkers.func(val, name, location);
		        if (isError(notFunction)) {
		          return notFunction;
		        }
		        return shapeChecker(val, name, location);
		      }, { type: shapeChecker.type, shortType: 'func.withProperties' }, disabled);
		    };
		    return functionChecker;
		  }
	
		  function objectCheckGetter() {
		    var type = 'Object';
		    var nullType = 'Object (null ok)';
		    var objectNullOkChecker = setupChecker(function objectNullOkCheckerDefinition(val, name, location) {
		      if (typeOf(val) !== 'object') {
		        return getError(name, location, nullType);
		      }
		    }, { type: nullType }, disabled);
	
		    var objectChecker = setupChecker(function objectCheckerDefinition(val, name, location) {
		      if (val === null || isError(objectNullOkChecker(val, name, location))) {
		        return getError(name, location, objectChecker.type);
		      }
		    }, { type: type, nullOk: objectNullOkChecker }, disabled);
	
		    return objectChecker;
		  }
	
		  function instanceCheckGetter(classToCheck) {
		    return setupChecker(function instanceCheckerDefinition(val, name, location) {
		      if (!(val instanceof classToCheck)) {
		        return getError(name, location, classToCheck.name);
		      }
		    }, { type: classToCheck.name }, disabled);
		  }
	
		  function oneOfCheckGetter(enums) {
		    var type = {
		      __apiCheckData: { optional: false, type: 'enum' },
		      'enum': enums
		    };
		    var shortType = 'oneOf[' + enums.map(function (enm) {
		      return stringify(enm);
		    }).join(', ') + ']';
		    return setupChecker(function oneOfCheckerDefinition(val, name, location) {
		      if (!enums.some(function (enm) {
		        return enm === val;
		      })) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function oneOfTypeCheckGetter(typeCheckers) {
		    var checkersDisplay = typeCheckers.map(function (checker) {
		      return getCheckerDisplay(checker, { short: true });
		    });
		    var shortType = 'oneOfType[' + checkersDisplay.join(', ') + ']';
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return typeCheckers.map(function (checker) {
		        return getCheckerDisplay(checker, options);
		      });
		    }
		    type.__apiCheckData = { optional: false, type: 'oneOfType' };
		    return setupChecker(function oneOfTypeCheckerDefinition(val, name, location) {
		      if (!typeCheckers.some(function (checker) {
		        return !isError(checker(val, name, location));
		      })) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function arrayOfCheckGetter(checker) {
		    var shortCheckerDisplay = getCheckerDisplay(checker, { short: true });
		    var shortType = 'arrayOf[' + shortCheckerDisplay + ']';
	
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return getCheckerDisplay(checker, options);
		    }
		    type.__apiCheckData = { optional: false, type: 'arrayOf' };
	
		    return setupChecker(function arrayOfCheckerDefinition(val, name, location) {
		      if (isError(checkers.array(val)) || !val.every(function (item) {
		        return !isError(checker(item));
		      })) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function objectOfCheckGetter(checker) {
		    var checkerDisplay = getCheckerDisplay(checker, { short: true });
		    var shortType = 'objectOf[' + checkerDisplay + ']';
	
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return getCheckerDisplay(checker, options);
		    }
		    type.__apiCheckData = { optional: false, type: 'objectOf' };
	
		    return setupChecker(function objectOfCheckerDefinition(val, name, location) {
		      var notObject = checkers.object(val, name, location);
		      if (isError(notObject)) {
		        return notObject;
		      }
		      var allTypesSuccess = each(val, function (item, key) {
		        if (isError(checker(item, key, name))) {
		          return false;
		        }
		      });
		      if (!allTypesSuccess) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function typeOrArrayOfCheckGetter(checker) {
		    var checkerDisplay = getCheckerDisplay(checker, { short: true });
		    var shortType = 'typeOrArrayOf[' + checkerDisplay + ']';
	
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return getCheckerDisplay(checker, options);
		    }
	
		    type.__apiCheckData = { optional: false, type: 'typeOrArrayOf' };
		    return setupChecker(function typeOrArrayOfDefinition(val, name, location, obj) {
		      if (isError(checkers.oneOfType([checker, checkers.arrayOf(checker)])(val, name, location, obj))) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function getShapeCheckGetter() {
		    function shapeCheckGetter(shape, nonObject) {
		      var shapeTypes = {};
		      each(shape, function (checker, prop) {
		        shapeTypes[prop] = getCheckerDisplay(checker);
		      });
		      function type() {
		        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		        var ret = {};
		        var terse = options.terse;
		        var obj = options.obj;
		        var addHelpers = options.addHelpers;
	
		        var parentRequired = options.required;
		        each(shape, function (checker, prop) {
		          /* eslint complexity:[2, 6] */
		          var specified = obj && obj.hasOwnProperty(prop);
		          var required = undef(parentRequired) ? !checker.isOptional : parentRequired;
		          if (!terse || (specified || !checker.isOptional)) {
		            ret[prop] = getCheckerDisplay(checker, { terse: terse, obj: obj && obj[prop], required: required, addHelpers: addHelpers });
		          }
		          if (addHelpers) {
		            modifyTypeDisplayToHelpOut(ret, prop, specified, checker, required);
		          }
		        });
		        return ret;
	
		        function modifyTypeDisplayToHelpOut(theRet, prop, specified, checker, required) {
		          if (!specified && required && !checker.isOptional) {
		            var item = 'ITEM';
		            if (checker.type && checker.type.__apiCheckData) {
		              item = checker.type.__apiCheckData.type.toUpperCase();
		            }
		            addHelper('missing', 'MISSING THIS ' + item, ' <-- YOU ARE MISSING THIS');
		          } else if (specified) {
		            var error = checker(obj[prop], prop, null, obj);
		            if (isError(error)) {
		              addHelper('error', 'THIS IS THE PROBLEM: ' + error.message, ' <-- THIS IS THE PROBLEM: ' + error.message);
		            }
		          }
	
		          function addHelper(property, objectMessage, stringMessage) {
		            if (typeof theRet[prop] === 'string') {
		              theRet[prop] += stringMessage;
		            } else {
		              theRet[prop].__apiCheckData[property] = objectMessage;
		            }
		          }
		        }
		      }
	
		      type.__apiCheckData = { strict: false, optional: false, type: 'shape' };
		      var shapeChecker = setupChecker(function shapeCheckerDefinition(val, name, location) {
		        /* eslint complexity:[2, 6] */
		        var isObject = !nonObject && checkers.object(val, name, location);
		        if (isError(isObject)) {
		          return isObject;
		        }
		        var shapePropError = undefined;
		        location = location ? location + (name ? '/' : '') : '';
		        name = name || '';
		        each(shape, function (checker, prop) {
		          if (val.hasOwnProperty(prop) || !checker.isOptional) {
		            shapePropError = checker(val[prop], prop, '' + location + name, val);
		            return !isError(shapePropError);
		          }
		        });
		        if (isError(shapePropError)) {
		          return shapePropError;
		        }
		      }, { type: type, shortType: 'shape' }, disabled);
	
		      function strictType() {
		        return type.apply(undefined, arguments);
		      }
	
		      strictType.__apiCheckData = copy(shapeChecker.type.__apiCheckData);
		      strictType.__apiCheckData.strict = true;
		      shapeChecker.strict = setupChecker(function strictShapeCheckerDefinition(val, name, location) {
		        var shapeError = shapeChecker(val, name, location);
		        if (isError(shapeError)) {
		          return shapeError;
		        }
		        var allowedProperties = Object.keys(shape);
		        var extraProps = Object.keys(val).filter(function (prop) {
		          return allowedProperties.indexOf(prop) === -1;
		        });
		        if (extraProps.length) {
		          return new Error(nAtL(name, location) + ' cannot have extra properties: ' + t(extraProps.join('`, `')) + '.' + ('It is limited to ' + t(allowedProperties.join('`, `'))));
		        }
		      }, { type: strictType, shortType: 'strict shape' }, disabled);
	
		      return shapeChecker;
		    }
	
		    shapeCheckGetter.ifNot = function ifNot(otherProps, propChecker) {
		      if (!Array.isArray(otherProps)) {
		        otherProps = [otherProps];
		      }
		      var description = undefined;
		      if (otherProps.length === 1) {
		        description = 'specified only if ' + otherProps[0] + ' is not specified';
		      } else {
		        description = 'specified only if none of the following are specified: [' + list(otherProps, ', ', 'and ') + ']';
		      }
		      var shortType = 'ifNot[' + otherProps.join(', ') + ']';
		      var type = getTypeForShapeChild(propChecker, description, shortType);
		      return setupChecker(function ifNotChecker(prop, propName, location, obj) {
		        var propExists = obj && obj.hasOwnProperty(propName);
		        var otherPropsExist = otherProps.some(function (otherProp) {
		          return obj && obj.hasOwnProperty(otherProp);
		        });
		        if (propExists === otherPropsExist) {
		          return getError(propName, location, type);
		        } else if (propExists) {
		          return propChecker(prop, propName, location, obj);
		        }
		      }, { notRequired: true, type: type, shortType: shortType }, disabled);
		    };
	
		    shapeCheckGetter.onlyIf = function onlyIf(otherProps, propChecker) {
		      otherProps = arrayify(otherProps);
		      var description = undefined;
		      if (otherProps.length === 1) {
		        description = 'specified only if ' + otherProps[0] + ' is also specified';
		      } else {
		        description = 'specified only if all of the following are specified: [' + list(otherProps, ', ', 'and ') + ']';
		      }
		      var shortType = 'onlyIf[' + otherProps.join(', ') + ']';
		      var type = getTypeForShapeChild(propChecker, description, shortType);
		      return setupChecker(function onlyIfCheckerDefinition(prop, propName, location, obj) {
		        var othersPresent = otherProps.every(function (property) {
		          return obj.hasOwnProperty(property);
		        });
		        if (!othersPresent) {
		          return getError(propName, location, type);
		        } else {
		          return propChecker(prop, propName, location, obj);
		        }
		      }, { type: type, shortType: shortType }, disabled);
		    };
	
		    shapeCheckGetter.requiredIfNot = function shapeRequiredIfNot(otherProps, propChecker) {
		      if (!Array.isArray(otherProps)) {
		        otherProps = [otherProps];
		      }
		      return getRequiredIfNotChecker(false, otherProps, propChecker);
		    };
	
		    shapeCheckGetter.requiredIfNot.all = function shapeRequiredIfNotAll(otherProps, propChecker) {
		      if (!Array.isArray(otherProps)) {
		        throw new Error('requiredIfNot.all must be passed an array');
		      }
		      return getRequiredIfNotChecker(true, otherProps, propChecker);
		    };
	
		    function getRequiredIfNotChecker(all, otherProps, propChecker) {
		      var props = t(otherProps.join(', '));
		      var ifProps = 'if ' + (all ? 'all of' : 'at least one of');
		      var description = 'specified ' + ifProps + ' these are not specified: ' + props + ' (otherwise it\'s optional)';
		      var shortType = 'requiredIfNot' + (all ? '.all' : '') + '[' + otherProps.join(', ') + '}]';
		      var type = getTypeForShapeChild(propChecker, description, shortType);
		      return setupChecker(function shapeRequiredIfNotDefinition(prop, propName, location, obj) {
		        var propExists = obj && obj.hasOwnProperty(propName);
		        var iteration = all ? 'every' : 'some';
		        var otherPropsExist = otherProps[iteration](function (otherProp) {
		          return obj && obj.hasOwnProperty(otherProp);
		        });
		        if (!otherPropsExist && !propExists) {
		          return getError(propName, location, type);
		        } else if (propExists) {
		          return propChecker(prop, propName, location, obj);
		        }
		      }, { type: type, notRequired: true }, disabled);
		    }
	
		    return shapeCheckGetter;
	
		    function getTypeForShapeChild(propChecker, description, shortType) {
		      function type(options) {
		        if (options && options.short) {
		          return shortType;
		        }
		        return getCheckerDisplay(propChecker);
		      }
		      type.__apiCheckData = { optional: false, type: 'ifNot', description: description };
		      return type;
		    }
		  }
	
		  function argumentsCheckerGetter() {
		    var type = 'function arguments';
		    return setupChecker(function argsCheckerDefinition(val, name, location) {
		      if (Array.isArray(val) || isError(checkers.object(val)) || isError(checkers.number(val.length))) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function anyCheckGetter() {
		    return setupChecker(function anyCheckerDefinition() {
		      // don't do anything
		    }, { type: 'any' }, disabled);
		  }
	
		  function nullCheckGetter() {
		    var type = 'null';
		    return setupChecker(function nullChecker(val, name, location) {
		      if (val !== null) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function rangeCheckGetter(min, max) {
		    var type = 'Range (' + min + ' - ' + max + ')';
		    return setupChecker(function rangeChecker(val, name, location) {
		      if (typeof val !== 'number' || val < min || val > max) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function lessThanCheckGetter(min) {
		    var type = 'lessThan[' + min + ']';
		    return setupChecker(function lessThanChecker(val, name, location) {
		      if (typeof val !== 'number' || val > min) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function greaterThanCheckGetter(max) {
		    var type = 'greaterThan[' + max + ']';
		    return setupChecker(function greaterThanChecker(val, name, location) {
		      if (typeof val !== 'number' || val < max) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function emptyObjectCheckGetter() {
		    var type = 'empty object';
		    return setupChecker(function emptyObjectChecker(val, name, location) {
		      if (typeOf(val) !== 'object' || val === null || Object.keys(val).length) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
		}
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 78 */,
/* 79 */
26,
/* 80 */
26,
/* 81 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReconfirmacionUsuarioController = function () {
	  ReconfirmacionUsuarioController.$inject = ["$uibModalInstance", "DataService", "_", "Util", "Message", "data"];
	  function ReconfirmacionUsuarioController($uibModalInstance, DataService, _, Util, Message, data) {
	    'ngInject';
	
	    _classCallCheck(this, ReconfirmacionUsuarioController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this._ = _;
	    this.Util = Util;
	    this.Message = Message;
	    this.usuario = data.usuario;
	    this.apiExtra = data.apiExtra;
	  }
	
	  _createClass(ReconfirmacionUsuarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.url = this.apiExtra ? this.apiExtra : 'usuario/reenviar-confirmacion';
	    }
	  }, {
	    key: 'reenviarCorreo',
	    value: function reenviarCorreo() {
	      var _this = this;
	
	      this.DataService.post(this.url, { correo: this.usuario.persona.correo, id_usuario: this.usuario.id_usuario }).then(function (response) {
	        if (response && response.finalizado) {
	          _this.Message.success(response.mensaje);
	          _this.$uibModalInstance.close(true);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return ReconfirmacionUsuarioController;
	}();
	
	exports.default = ReconfirmacionUsuarioController;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArchivoModalController = function () {
	  ArchivoModalController.$inject = ["$uibModalInstance", "data", "title", "icon", "DataService", "Message", "labelOk", "apiUrl"];
	  function ArchivoModalController($uibModalInstance, data, title, icon, DataService, Message, labelOk, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, ArchivoModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.title = title;
	    this.icon = icon;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.labelOk = labelOk;
	    this.apiUrl = apiUrl;
	  }
	
	  _createClass(ArchivoModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.descargas = {
	        manual: {
	          ruta: this.apiUrl + 'items/csv/manuales?archivo=manual_ods',
	          nombre: 'Manual ods'
	        },
	        modelo: {
	          ruta: this.apiUrl + 'items/csv/manuales?archivo=items&tipo=ods',
	          nombre: 'Modelo items'
	        }
	      };
	    }
	  }, {
	    key: 'registrar',
	    value: function registrar() {
	      this.$uibModalInstance.close(this.archivo);
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ArchivoModalController;
	}();
	
	exports.default = ArchivoModalController;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResumenProyectoController = function () {
	  ResumenProyectoController.$inject = ["$state", "$uibModalInstance", "DataService", "Storage", "data", "Util", "$filter", "$timeout", "Message", "Loading"];
	  function ResumenProyectoController($state, $uibModalInstance, DataService, Storage, data, Util, $filter, $timeout, Message, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, ResumenProyectoController);
	
	    this.$state = $state;
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.Util = Util;
	    this.$filter = $filter;
	    this.$timeout = $timeout;
	    this.Message = Message;
	    this.proyecto = data;
	    this.Loading = Loading;
	    this.conEstados = false;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(ResumenProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.opciones = {};
	    }
	  }, {
	    key: 'tieneRegistro',
	    value: function tieneRegistro() {
	      return ['ASIGNACION_TECNICO_FDI', 'REGISTRO_CONVENIO_FDI', 'ASIGNACION_EQUIPO_TECNICO_FDI', 'REGISTRO_DESEMBOLSO_FDI', 'APROBADO_FDI', 'CERRADO_FDI', 'MODIFICADO_FDI', 'EN_EJECUCION_FDI'].indexOf(this.proyecto.estado_proyecto) !== -1;
	    }
	  }, {
	    key: 'tieneConvenio',
	    value: function tieneConvenio() {
	      return ['REGISTRO_CONVENIO_FDI', 'ASIGNACION_EQUIPO_TECNICO_FDI', 'REGISTRO_DESEMBOLSO_FDI', 'APROBADO_FDI', 'CERRADO_FDI', 'MODIFICADO_FDI', 'EN_EJECUCION_FDI'].indexOf(this.proyecto.estado_proyecto) !== -1;
	    }
	  }, {
	    key: 'tieneDesembolso',
	    value: function tieneDesembolso() {
	      return ['ASIGNACION_EQUIPO_TECNICO_FDI', 'REGISTRO_DESEMBOLSO_FDI', 'APROBADO_FDI', 'CERRADO_FDI', 'MODIFICADO_FDI', 'EN_EJECUCION_FDI'].indexOf(this.proyecto.estado_proyecto) !== -1;
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return ResumenProyectoController;
	}();
	
	exports.default = ResumenProyectoController;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NuevaAdjudicacionModalController = function () {
	  NuevaAdjudicacionModalController.$inject = ["$uibModalInstance", "Storage", "data", "apiUrl", "$state", "Usuarios"];
	  function NuevaAdjudicacionModalController($uibModalInstance, Storage, data, apiUrl, $state, Usuarios) {
	    'ngInject';
	
	    _classCallCheck(this, NuevaAdjudicacionModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.Storage = Storage;
	    this.apiUrl = apiUrl;
	    this.$state = $state;
	    this.proyecto = data;
	    this.Usuarios = Usuarios;
	  }
	
	  _createClass(NuevaAdjudicacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.usuario = this.Storage.getUser();
	      this.asignarDatosDescarga();
	    }
	  }, {
	    key: 'asignarDatosDescarga',
	    value: function asignarDatosDescarga() {
	      var _this = this;
	
	      this.proyecto.supervisiones.map(function (supervision) {
	        supervision.urlPlanillaDescargaAvance = _this.apiUrl + 'proyectos/' + _this.proyecto.id_proyecto + '/doc/SUP_' + supervision.id_supervision + '/descargar';
	        supervision.urlPlanillaDescarga = _this.apiUrl + 'proyectos/' + _this.proyecto.id_proyecto + '/doc/PA_' + supervision.fid_adjudicacion + '-' + supervision.nro_supervision + '/descargar';
	        supervision.nombrePlanillaDescarga = 'Planilla de avance nro ' + supervision.nro_supervision;
	        supervision.urlComputosDescarga = _this.apiUrl + 'proyectos/' + _this.proyecto.id_proyecto + '/doc/CMR_' + supervision.nro_supervision + '/descargar';
	        supervision.nombreComputosDescarga = 'Resumen de computos metricos planilla_' + supervision.nro_supervision;
	      });
	    }
	  }, {
	    key: 'irAPlanilla',
	    value: function irAPlanilla(supervision) {
	      // this.$state.go('planilla-proyecto', { idSupervision: supervision.id_supervision });
	      window.open('#!/planilla-proyecto/' + supervision.id_supervision, 'ventana1', 'menu=0,tooltip=0,width=1200px,height=500px,resize=0');
	      // this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'puedeVerPlanilla',
	    value: function puedeVerPlanilla(idAdjudicacion, supervision) {
	      if (this.Usuarios.esFiscal() && ['EN_FISCAL_FDI', 'PENDIENTE_FDI'].indexOf(supervision.estado_supervision) == -1 || this.Usuarios.esResponsableProyecto() || this.Usuarios.esMae() || this.Usuarios.esVisorReportes()) return true;
	      for (var i = 0; i < this.proyecto.adjudicaciones.length; i++) {
	        if (this.proyecto.adjudicaciones[i].id_adjudicacion == idAdjudicacion) {
	          if (this.puedeProcesarPlanilla(idAdjudicacion, supervision)) return false;else return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeProcesarPlanilla',
	    value: function puedeProcesarPlanilla(idAdjudicacion, supervision) {
	      if (this.Usuarios.esFiscal() && ['EN_FISCAL_FDI', 'PENDIENTE_FDI'].indexOf(supervision.estado_supervision) != -1) return true;
	      for (var i = 0; i < this.proyecto.adjudicaciones.length; i++) {
	        if (this.proyecto.adjudicaciones[i].id_adjudicacion == idAdjudicacion && ['EN_ARCHIVO_FDI', 'PENDIENTE_FDI', 'EN_FISCAL_FDI'].indexOf(supervision.estado_supervision) === -1 && this.Usuarios.esSupervisor() && this.proyecto.adjudicaciones[i].esSupervisor) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeRevisarPlanilla',
	    value: function puedeRevisarPlanilla(idAdjudicacion) {
	      if (this.Usuarios.esFiscal() || this.Usuarios.esResponsableProyecto() || this.Usuarios.esMae() || this.Usuarios.esVisorReportes()) return true;
	      for (var i = 0; i < this.proyecto.adjudicaciones.length; i++) {
	        if (this.proyecto.adjudicaciones[i].id_adjudicacion == idAdjudicacion && this.proyecto.adjudicaciones[i].esSupervisor) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'verComponente',
	    value: function verComponente(idAdjudicacion) {
	      var nombre = '';
	      var adjudicacion = this.verAdjudicacion(idAdjudicacion);
	      if (adjudicacion.referencia) nombre = adjudicacion.referencia;
	      return nombre;
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'planillaEnArchivo',
	    value: function planillaEnArchivo(supervision) {
	      return supervision.estado_supervision === 'EN_ARCHIVO_FDI';
	    }
	  }, {
	    key: 'planillaEnAvance',
	    value: function planillaEnAvance(supervision) {
	      return ['EN_SUPERVISION_FDI', 'PENDIENTE_FDI', 'EN_FISCAL_FDI'].indexOf(supervision.estado_supervision) !== -1 || this.Usuarios.esTecnicoResponsable() && supervision.estado_supervision !== 'EN_ARCHIVO_FDI';
	    }
	  }]);
	
	  return NuevaAdjudicacionModalController;
	}();
	
	exports.default = NuevaAdjudicacionModalController;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ObservacionController = function () {
	  ObservacionController.$inject = ["$uibModalInstance", "data"];
	  function ObservacionController($uibModalInstance, data) {
	    'ngInject';
	
	    _classCallCheck(this, ObservacionController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	  }
	
	  _createClass(ObservacionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.data.observacion = null;
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'observar',
	    value: function observar() {
	      this.$uibModalInstance.close(this.data);
	    }
	  }]);
	
	  return ObservacionController;
	}();
	
	exports.default = ObservacionController;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FixFecha = function () {
	  FixFecha.$inject = ["$uibModalInstance", "data", "eventOk", "eventCancel"];
	  function FixFecha($uibModalInstance, data, eventOk, eventCancel) {
	    'ngInject';
	
	    _classCallCheck(this, FixFecha);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.doc = angular.copy(data);
	    this.eventOk = eventOk;
	    this.eventCancel = eventCancel;
	    this.cancel = true;
	  }
	
	  _createClass(FixFecha, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close(this.doc);
	      if (typeof this.eventOk == 'function') {
	        this.eventOk();
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.$uibModalInstance.dismiss('cancel');
	      if (typeof this.eventCancel == 'function') {
	        this.eventCancel();
	      }
	      this.$uibModalInstance.result.then(function () {}, function () {});
	    }
	  }]);
	
	  return FixFecha;
	}();
	
	exports.default = FixFecha;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(611);
	__webpack_require__(620);
	__webpack_require__(645);
	__webpack_require__(646);
	__webpack_require__(647);
	__webpack_require__(648);
	__webpack_require__(612);
	
	var MODULE_NAME = 'ui.bootstrap.module.datepicker';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.datepicker', 'uib/template/datepicker/datepicker.html', 'uib/template/datepicker/day.html', 'uib/template/datepicker/month.html', 'uib/template/datepicker/year.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(625);

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(632);
	
	var MODULE_NAME = 'ui.bootstrap.module.stackedMap';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.stackedMap']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(29);
	__webpack_require__(89);
	__webpack_require__(661);
	__webpack_require__(660);
	__webpack_require__(662);
	__webpack_require__(641);
	
	var MODULE_NAME = 'ui.bootstrap.module.tooltip';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tooltip', 'uib/template/tooltip/tooltip-popup.html', 'uib/template/tooltip/tooltip-html-popup.html', 'uib/template/tooltip/tooltip-template-popup.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Reenviar correo de confirmación</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>\n    Usuario/a: <strong>{{$ctrl.usuario.persona | nombreUnido}}</strong>\n  </p>\n\n  <ng-form name=\"formUsuario\">\n    <div class=\"row\">\n      <div class=\"md-input-group col-md-12\">\n        <c-input name=\"correo_miembro\" label=\"Correo Electrónico\" ng-model=\"$ctrl.usuario.persona.correo\"\n        ng-validation=\"correo\" ng-required=\"true\"></c-input>\n      </div>\n    </div>\n  </ng-form>\n  <div class=\"alert alert-info\">\n    <i class=\"fa fa-info-circle\"></i> Tome en cuenta que al reenviar el correo de confirmación la contraseña del usuario se actualizará a una generada por el sistema.\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.reenviarCorreo()\" validar-formulario=\"formUsuario\">\n    <i class=\"fa fa-send\"></i> Reenviar correo\n  </button>\n</div>\n"

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa {{$ctrl.icon}}\"></i> {{$ctrl.title}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.data.mensajeInformacion\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span ng-bind-html=\"$ctrl.data.mensajeInformacion\"></span>\n  </div>\n  <div ng-if=\"$ctrl.data.cargarItems\">\n\n    <button md-effect type=\"button\" class=\"btn btn-success btn-sm mr-1\" uib-tooltip=\"Descargar archivo modelo .ods de items\"\n    download-file=\"{{$ctrl.descargas.modelo.ruta}}\" file-name=\"{{$ctrl.descargas.modelo.nombre}}\" download-type=\"ods\">\n    <i class=\"fa fa-download\"></i> Modelo ODS</button>\n\n    <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Descargar manual para crear un archivo .ods de items\"\n    download-file=\"{{$ctrl.descargas.manual.ruta}}\" file-name=\"{{$ctrl.descargas.manual.nombre}}\">\n    <i class=\"fa fa-download\"></i> Manual ODS</button>\n  </div>\n\n  <ng-form name=\"formItem\">\n    <div class=\"row\">\n\n      <div class=\"md-input-group col-md-12\">\n        <ui-input-file name=\"doc_resmin_cife\"\n          file-base64=\"$ctrl.archivo\"\n          types=\"{{$ctrl.data.formatos}}\"\n          mime-types=\"{{$ctrl.data.tipos}}\"\n          maxfiles=\"1\" maxsize=\"3MB\"\n          ng-required=\"true\">\n        </ui-input-file>\n      </div>\n\n    </div>\n  </ng-form>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"button\" md-effect class=\"btn btn-primary\" validar-formulario=\"formItem\"\n    ng-click=\"$ctrl.registrar()\">\n    <i class=\"fa fa-upload\"></i> {{$ctrl.labelOk}}\n  </button>\n</div>\n"

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-eye\"></i> {{$ctrl.proyecto.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <ng-form name=\"formProyecto\">\n    <uib-tabset active=\"active\">\n      <uib-tab index=\"0\" heading=\"Datos Generales\">\n        <reg-datos-generales proyecto=\"$ctrl.proyecto\"></reg-datos-generales>                \n      </uib-tab>\n      <uib-tab index=\"1\" heading=\"Comunidades\" ng-if=\"$ctrl.tieneRegistro()\">\n        <reg-datos-generales-extra-resumen proyecto=\"$ctrl.proyecto\"></reg-datos-generales-extra-resumen>\n      </uib-tab>\n      <uib-tab index=\"2\" heading=\"Financiamiento\">\n        <reg-financiamiento proyecto=\"$ctrl.proyecto\"></reg-financiamiento>\n      </uib-tab>\n      <uib-tab index=\"3\" heading=\"Evaluación\" ng-if=\"$ctrl.tieneRegistro()\">\n        <reg-evaluacion proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\" ng-if=\"active==3\"></reg-evaluacion>\n      </uib-tab>\n      <uib-tab index=\"4\" heading=\"Informe\" ng-if=\"$ctrl.tieneRegistro()\">\n        <reg-informe-eval proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\" ng-if=\"active==4\"></reg-informe-eval>\n      </uib-tab>\n      <uib-tab index=\"5\" heading=\"Convenio\" ng-if=\"$ctrl.tieneConvenio()\">\n        <reg-convenio proyecto=\"$ctrl.proyecto\" ng-if=\"active == 5\"></reg-convenio>\n      </uib-tab>\n      <uib-tab index=\"6\" heading=\"Desembolso\" ng-if=\"$ctrl.tieneDesembolso()\">\n        <reg-desembolso proyecto=\"$ctrl.proyecto\" ng-if=\"active==6\"></reg-desembolso>\n      </uib-tab>\n\n    </uib-tabset>\n  </ng-form>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cerrar\n  </button>\n</div>\n"

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-list\"></i> {{$ctrl.proyecto.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\"><strong>PLANILLAS DE AVANCE</strong></p>\n  <div class=\"crud-table mt-3\">\n    <table class=\"table table-striped table-hover ng-table\">\n      <thead>\n        <tr>\n          <td><strong></strong></td>\n          <td><strong>Componente</strong></td>\n          <td><strong>Nombre</strong></td>\n          <td><strong>Estado</strong></td>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"supervision in $ctrl.proyecto.supervisiones\" ng-if=\"$ctrl.puedeRevisarPlanilla(supervision.adjudicacion.id_adjudicacion)\">\n          <td data-title=\"'Acción'\">\n            <button md-effect type=\"button\" class=\"btn btn-success btn-noborder btn-sm mb-1\"\n              uib-tooltip=\"Ver planilla {{supervision.nro_supervision}}\" ng-click=\"$ctrl.irAPlanilla(supervision)\" ng-if=\"$ctrl.puedeVerPlanilla(supervision.adjudicacion.id_adjudicacion,supervision)\">\n              <i class=\"fa fa-eye\"></i>\n            </button>\n            <button md-effect type=\"button\" class=\"btn btn-success btn-noborder btn-sm mb-1\"\n              uib-tooltip=\"Procesar planilla {{supervision.nro_supervision}}\" ng-click=\"$ctrl.irAPlanilla(supervision)\" ng-if=\"$ctrl.puedeProcesarPlanilla(supervision.adjudicacion.id_adjudicacion,supervision)\">\n              <i class=\"fa fa-edit\"></i>\n            </button>\n            <button md-effect type=\"button\" class=\"btn btn-info btn-noborder btn-sm mb-1\"\n                    uib-tooltip=\"Descargar planilla\" ng-if=\"$ctrl.planillaEnArchivo(supervision)\"\n                    download-file=\"{{supervision.urlPlanillaDescarga}}\" file-name=\"{{supervision.nombrePlanillaDescarga}}\">\n              <i class=\"fa fa-file-text\"></i>\n            </button>\n            <button md-effect type=\"button\" class=\"btn btn-info btn-noborder btn-sm mb-1\"\n                    uib-tooltip=\"Descargar planilla (pendiente de aprobación)\" ng-if=\"$ctrl.planillaEnAvance(supervision)\"\n                    download-file=\"{{supervision.urlPlanillaDescargaAvance}}\" file-name=\"{{supervision.nombrePlanillaDescarga}}\">\n              <i class=\"fa fa-file-text\"></i>\n            </button>\n            <button md-effect type=\"button\" class=\"btn btn-info btn-noborder btn-sm mb-1\"\n                    uib-tooltip=\"Descargar resumen de cómputos métricos\" ng-if=\"supervision.estado_supervision === 'EN_ARCHIVO_FDI'\"\n                    download-file=\"{{supervision.urlComputosDescarga}}\" file-name=\"{{supervision.nombreComputosDescarga}}\">\n              <i class=\"fa fa-table\"></i>\n            </button>\n          </td>\n          <td>{{supervision.adjudicacion.referencia}}</td>\n          <td>Planilla {{supervision.nro_supervision}}</td>\n          <td>{{supervision.estado_actual.nombre}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-rotate-left\"></i> Observando</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>¿Está seguro/a de observar el proceso y devolverlo al estado anterior?</p>\n\n  <ng-form name=\"formObservacion\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <c-textarea name=\"observacion\" label=\"Detalle de la observación\"\n          ng-model=\"$ctrl.data.observacion\"\n          ng-minlength=\"10\" maxlength=\"255\"\n          ng-required=\"true\"></c-textarea>\n      </div>\n    </div>\n  </ng-form>\n\n  <small><em>NOTA.- Debe registrar el detalle de la observación.</em></small>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formObservacion\" ng-click=\"$ctrl.observar()\">\n    <i class=\"fa fa-check\"></i> Observar\n  </button>\n</div>\n"

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-{{ $ctrl.icon }}\" ng-if=\"$ctrl.icon\"></i> {{ $ctrl.title }}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-if=\"$ctrl.btnClose\" ng-click=\"$ctrl.close()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<form name=\"form_fecha\">\n<div class=\"modal-body\">\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-4\">\n      <c-date name=\"fecha_documento\" label=\"Fecha del documento\" ng-model=\"$ctrl.doc.fecha_documento\"\n      ng-required=\"true\"></c-date>\n    </div>\n  </div>\n</div>\n</form>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.close()\" ng-if=\"$ctrl.cancel\">\n    <i class=\"fa fa-close\"></i> {{ $ctrl.labelCancel || 'Cancelar'}}\n  </button>\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n    <i class=\"fa fa-check\"></i> {{ $ctrl.labelOk || 'Aceptar' }}\n  </button>\n</div>\n"

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * State-based routing for AngularJS 1.x
	 * This bundle requires the ui-router-core.js bundle from the @uirouter/core package.
	 * @version v1.0.29
	 * @link https://ui-router.github.io
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(7), __webpack_require__(116)) :
	    typeof define === 'function' && define.amd ? define(['exports', 'angular', '@uirouter/core'], factory) :
	    (global = global || self, factory(global['@uirouter/angularjs'] = {}, global.angular, global['@uirouter/core']));
	}(this, (function (exports, ng_from_import, core) { 'use strict';
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */ var ng_from_global = angular;
	    /** @hidden */ var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
	
	    /** @publicapi @module ng1 */ /** */
	    /** @internalapi */
	    function getNg1ViewConfigFactory() {
	        var templateFactory = null;
	        return function (path, view) {
	            templateFactory = templateFactory || core.services.$injector.get('$templateFactory');
	            return [new Ng1ViewConfig(path, view, templateFactory)];
	        };
	    }
	    /** @internalapi */
	    var hasAnyKey = function (keys, obj) { return keys.reduce(function (acc, key) { return acc || core.isDefined(obj[key]); }, false); };
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `views`.
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
	     *
	     * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
	     * and applies the state-level configuration to a view named `$default`.
	     *
	     * @internalapi
	     */
	    function ng1ViewsBuilder(state) {
	        // Do not process root state
	        if (!state.parent)
	            return {};
	        var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
	        // Do not allow a state to have both state-level props and also a `views: {}` property.
	        // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
	        // However, the `$default` approach should not be mixed with a separate `views: ` block.
	        if (core.isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
	            throw new Error("State '" + state.name + "' has a 'views' object. " +
	                "It cannot also have \"view properties\" at the state level.  " +
	                "Move the following properties into a view (in the 'views' object): " +
	                (" " + allViewKeys.filter(function (key) { return core.isDefined(state[key]); }).join(', ')));
	        }
	        var views = {}, viewsObject = state.views || { $default: core.pick(state, allViewKeys) };
	        core.forEach(viewsObject, function (config, name) {
	            // Account for views: { "": { template... } }
	            name = name || '$default';
	            // Account for views: { header: "headerComponent" }
	            if (core.isString(config))
	                config = { component: config };
	            // Make a shallow copy of the config object
	            config = core.extend({}, config);
	            // Do not allow a view to mix props for component-style view with props for template/controller-style view
	            if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
	                throw new Error("Cannot combine: " + compKeys.join('|') + " with: " + nonCompKeys.join('|') + " in stateview: '" + name + "@" + state.name + "'");
	            }
	            config.resolveAs = config.resolveAs || '$resolve';
	            config.$type = 'ng1';
	            config.$context = state;
	            config.$name = name;
	            var normalized = core.ViewService.normalizeUIViewTarget(config.$context, config.$name);
	            config.$uiViewName = normalized.uiViewName;
	            config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
	            views[name] = config;
	        });
	        return views;
	    }
	    /** @hidden */
	    var id = 0;
	    /** @internalapi */
	    var Ng1ViewConfig = /** @class */ (function () {
	        function Ng1ViewConfig(path, viewDecl, factory) {
	            var _this = this;
	            this.path = path;
	            this.viewDecl = viewDecl;
	            this.factory = factory;
	            this.$id = id++;
	            this.loaded = false;
	            this.getTemplate = function (uiView, context) {
	                return _this.component
	                    ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings)
	                    : _this.template;
	            };
	        }
	        Ng1ViewConfig.prototype.load = function () {
	            var _this = this;
	            var $q = core.services.$q;
	            var context = new core.ResolveContext(this.path);
	            var params = this.path.reduce(function (acc, node) { return core.extend(acc, node.paramValues); }, {});
	            var promises = {
	                template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
	                controller: $q.when(this.getController(context)),
	            };
	            return $q.all(promises).then(function (results) {
	                core.trace.traceViewServiceEvent('Loaded', _this);
	                _this.controller = results.controller;
	                core.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
	                return _this;
	            });
	        };
	        /**
	         * Gets the controller for a view configuration.
	         *
	         * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
	         */
	        Ng1ViewConfig.prototype.getController = function (context) {
	            var provider = this.viewDecl.controllerProvider;
	            if (!core.isInjectable(provider))
	                return this.viewDecl.controller;
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        return Ng1ViewConfig;
	    }());
	
	    /** @publicapi @module view */ /** */
	    /**
	     * Service which manages loading of templates from a ViewConfig.
	     */
	    var TemplateFactory = /** @class */ (function () {
	        function TemplateFactory() {
	            var _this = this;
	            /** @hidden */ this._useHttp = ng.version.minor < 3;
	            /** @hidden */ this.$get = [
	                '$http',
	                '$templateCache',
	                '$injector',
	                function ($http, $templateCache, $injector) {
	                    _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
	                    _this.$http = $http;
	                    _this.$templateCache = $templateCache;
	                    return _this;
	                },
	            ];
	        }
	        /** @hidden */
	        TemplateFactory.prototype.useHttpService = function (value) {
	            this._useHttp = value;
	        };
	        /**
	         * Creates a template from a configuration object.
	         *
	         * @param config Configuration object for which to load a template.
	         * The following properties are search in the specified order, and the first one
	         * that is defined is used to create the template:
	         *
	         * @param params  Parameters to pass to the template function.
	         * @param context The resolve context associated with the template's view
	         *
	         * @return {string|object}  The template html as a string, or a promise for
	         * that string,or `null` if no template is configured.
	         */
	        TemplateFactory.prototype.fromConfig = function (config, params, context) {
	            var defaultTemplate = '<ui-view></ui-view>';
	            var asTemplate = function (result) { return core.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
	            var asComponent = function (result) { return core.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
	            return core.isDefined(config.template)
	                ? asTemplate(this.fromString(config.template, params))
	                : core.isDefined(config.templateUrl)
	                    ? asTemplate(this.fromUrl(config.templateUrl, params))
	                    : core.isDefined(config.templateProvider)
	                        ? asTemplate(this.fromProvider(config.templateProvider, params, context))
	                        : core.isDefined(config.component)
	                            ? asComponent(config.component)
	                            : core.isDefined(config.componentProvider)
	                                ? asComponent(this.fromComponentProvider(config.componentProvider, params, context))
	                                : asTemplate(defaultTemplate);
	        };
	        /**
	         * Creates a template from a string or a function returning a string.
	         *
	         * @param template html template as a string or function that returns an html template as a string.
	         * @param params Parameters to pass to the template function.
	         *
	         * @return {string|object} The template html as a string, or a promise for that
	         * string.
	         */
	        TemplateFactory.prototype.fromString = function (template, params) {
	            return core.isFunction(template) ? template(params) : template;
	        };
	        /**
	         * Loads a template from the a URL via `$http` and `$templateCache`.
	         *
	         * @param {string|Function} url url of the template to load, or a function
	         * that returns a url.
	         * @param {Object} params Parameters to pass to the url function.
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromUrl = function (url, params) {
	            if (core.isFunction(url))
	                url = url(params);
	            if (url == null)
	                return null;
	            if (this._useHttp) {
	                return this.$http
	                    .get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
	                    .then(function (response) {
	                    return response.data;
	                });
	            }
	            return this.$templateRequest(url);
	        };
	        /**
	         * Creates a template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a component's template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a template from a component's name
	         *
	         * This implements route-to-component.
	         * It works by retrieving the component (directive) metadata from the injector.
	         * It analyses the component's bindings, then constructs a template that instantiates the component.
	         * The template wires input and output bindings to resolves or from the parent component.
	         *
	         * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
	         * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
	         * @param component {string} Component's name in camel case.
	         * @param bindings An object defining the component's bindings: {foo: '<'}
	         * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
	            bindings = bindings || {};
	            // Bind once prefix
	            var prefix = ng.version.minor >= 3 ? '::' : '';
	            // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
	            var kebob = function (camelCase) {
	                var kebobed = core.kebobString(camelCase);
	                return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
	            };
	            var attributeTpl = function (input) {
	                var name = input.name, type = input.type;
	                var attrName = kebob(name);
	                // If the ui-view has an attribute which matches a binding on the routed component
	                // then pass that attribute through to the routed component template.
	                // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
	                if (uiView.attr(attrName) && !bindings[name])
	                    return attrName + "='" + uiView.attr(attrName) + "'";
	                var resolveName = bindings[name] || name;
	                // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
	                // some-attr="{{ ::$resolve.someResolveName }}"
	                if (type === '@')
	                    return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
	                // Wire "&" callbacks to resolves that return a callback function
	                // Get the result of the resolve (should be a function) and annotate it to get its arguments.
	                // some-attr="$resolve.someResolveResultName(foo, bar)"
	                if (type === '&') {
	                    var res = context.getResolvable(resolveName);
	                    var fn = res && res.data;
	                    var args = (fn && core.services.$injector.annotate(fn)) || [];
	                    // account for array style injection, i.e., ['foo', function(foo) {}]
	                    var arrayIdxStr = core.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
	                    return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(',') + ")'";
	                }
	                // some-attr="::$resolve.someResolveName"
	                return attrName + "='" + prefix + "$resolve." + resolveName + "'";
	            };
	            var attrs = getComponentBindings(component).map(attributeTpl).join(' ');
	            var kebobName = kebob(component);
	            return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
	        };
	        return TemplateFactory;
	    }());
	    // Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
	    function getComponentBindings(name) {
	        var cmpDefs = core.services.$injector.get(name + 'Directive'); // could be multiple
	        if (!cmpDefs || !cmpDefs.length)
	            throw new Error("Unable to find component named '" + name + "'");
	        return cmpDefs.map(getBindings).reduce(core.unnestR, []);
	    }
	    // Given a directive definition, find its object input attributes
	    // Use different properties, depending on the type of directive (component, bindToController, normal)
	    var getBindings = function (def) {
	        if (core.isObject(def.bindToController))
	            return scopeBindings(def.bindToController);
	        return scopeBindings(def.scope);
	    };
	    // for ng 1.2 style, process the scope: { input: "=foo" }
	    // for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
	    var scopeBindings = function (bindingsObj) {
	        return Object.keys(bindingsObj || {})
	            // [ 'input', [ '=foo', '=', 'foo' ] ]
	            .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
	            // skip malformed values
	            .filter(function (tuple) { return core.isDefined(tuple) && core.isArray(tuple[1]); })
	            // { name: ('foo' || 'input'), type: '=' }
	            .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); });
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * The Angular 1 `StateProvider`
	     *
	     * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	     * on state.
	     *
	     * A state corresponds to a "place" in the application in terms of the overall UI and
	     * navigation. A state describes (via the controller / template / view properties) what
	     * the UI looks like and does at that place.
	     *
	     * States often have things in common, and the primary way of factoring out these
	     * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	     * nested states.
	     *
	     * The `$stateProvider` provides interfaces to declare these states for your app.
	     */
	    var StateProvider = /** @class */ (function () {
	        function StateProvider(stateRegistry, stateService) {
	            this.stateRegistry = stateRegistry;
	            this.stateService = stateService;
	            core.createProxyFunctions(core.val(StateProvider.prototype), this, core.val(this));
	        }
	        /**
	         * Decorates states when they are registered
	         *
	         * Allows you to extend (carefully) or override (at your own peril) the
	         * `stateBuilder` object used internally by [[StateRegistry]].
	         * This can be used to add custom functionality to ui-router,
	         * for example inferring templateUrl based on the state name.
	         *
	         * When passing only a name, it returns the current (original or decorated) builder
	         * function that matches `name`.
	         *
	         * The builder functions that can be decorated are listed below. Though not all
	         * necessarily have a good use case for decoration, that is up to you to decide.
	         *
	         * In addition, users can attach custom decorators, which will generate new
	         * properties within the state's internal definition. There is currently no clear
	         * use-case for this beyond accessing internal states (i.e. $state.$current),
	         * however, expect this to become increasingly relevant as we introduce additional
	         * meta-programming features.
	         *
	         * **Warning**: Decorators should not be interdependent because the order of
	         * execution of the builder functions in non-deterministic. Builder functions
	         * should only be dependent on the state definition object and super function.
	         *
	         *
	         * Existing builder functions and current return values:
	         *
	         * - **parent** `{object}` - returns the parent state object.
	         * - **data** `{object}` - returns state data, including any inherited data that is not
	         *   overridden by own values (if any).
	         * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	         *   or `null`.
	         * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
	         *   navigable).
	         * - **params** `{object}` - returns an array of state params that are ensured to
	         *   be a super-set of parent's params.
	         * - **views** `{object}` - returns a views object where each key is an absolute view
	         *   name (i.e. "viewName@stateName") and each value is the config object
	         *   (template, controller) for the view. Even when you don't use the views object
	         *   explicitly on a state config, one is still created for you internally.
	         *   So by decorating this builder function you have access to decorating template
	         *   and controller properties.
	         * - **ownParams** `{object}` - returns an array of params that belong to the state,
	         *   not including any params defined by ancestor states.
	         * - **path** `{string}` - returns the full path from the root down to this state.
	         *   Needed for state activation.
	         * - **includes** `{object}` - returns an object that includes every state that
	         *   would pass a `$state.includes()` test.
	         *
	         * #### Example:
	         * Override the internal 'views' builder with a function that takes the state
	         * definition, and a reference to the internal function being overridden:
	         * ```js
	         * $stateProvider.decorator('views', function (state, parent) {
	         *   let result = {},
	         *       views = parent(state);
	         *
	         *   angular.forEach(views, function (config, name) {
	         *     let autoName = (state.name + '.' + name).replace('.', '/');
	         *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	         *     result[name] = config;
	         *   });
	         *   return result;
	         * });
	         *
	         * $stateProvider.state('home', {
	         *   views: {
	         *     'contact.list': { controller: 'ListController' },
	         *     'contact.item': { controller: 'ItemController' }
	         *   }
	         * });
	         * ```
	         *
	         *
	         * ```js
	         * // Auto-populates list and item views with /partials/home/contact/list.html,
	         * // and /partials/home/contact/item.html, respectively.
	         * $state.go('home');
	         * ```
	         *
	         * @param {string} name The name of the builder function to decorate.
	         * @param {object} func A function that is responsible for decorating the original
	         * builder function. The function receives two parameters:
	         *
	         *   - `{object}` - state - The state config object.
	         *   - `{object}` - super - The original builder function.
	         *
	         * @return {object} $stateProvider - $stateProvider instance
	         */
	        StateProvider.prototype.decorator = function (name, func) {
	            return this.stateRegistry.decorator(name, func) || this;
	        };
	        StateProvider.prototype.state = function (name, definition) {
	            if (core.isObject(name)) {
	                definition = name;
	            }
	            else {
	                definition.name = name;
	            }
	            this.stateRegistry.register(definition);
	            return this;
	        };
	        /**
	         * Registers an invalid state handler
	         *
	         * This is a passthrough to [[StateService.onInvalid]] for ng1.
	         */
	        StateProvider.prototype.onInvalid = function (callback) {
	            return this.stateService.onInvalid(callback);
	        };
	        return StateProvider;
	    }());
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
	     * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
	     *
	     * @internalapi
	     */
	    var getStateHookBuilder = function (hookName) {
	        return function stateHookBuilder(stateObject) {
	            var hook = stateObject[hookName];
	            var pathname = hookName === 'onExit' ? 'from' : 'to';
	            function decoratedNg1Hook(trans, state) {
	                var resolveContext = new core.ResolveContext(trans.treeChanges(pathname));
	                var subContext = resolveContext.subContext(state.$$state());
	                var locals = core.extend(getLocals(subContext), { $state$: state, $transition$: trans });
	                return core.services.$injector.invoke(hook, this, locals);
	            }
	            return hook ? decoratedNg1Hook : undefined;
	        };
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
	     * @internalapi
	     */
	    var Ng1LocationServices = /** @class */ (function () {
	        function Ng1LocationServices($locationProvider) {
	            // .onChange() registry
	            this._urlListeners = [];
	            this.$locationProvider = $locationProvider;
	            var _lp = core.val($locationProvider);
	            core.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
	        }
	        /**
	         * Applys ng1-specific path parameter encoding
	         *
	         * The Angular 1 `$location` service is a bit weird.
	         * It doesn't allow slashes to be encoded/decoded bi-directionally.
	         *
	         * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
	         *
	         * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
	         *
	         * @param router
	         */
	        Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
	            var pathType = router.urlMatcherFactory.type('path');
	            pathType.encode = function (x) {
	                return x != null ? x.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : x;
	            };
	            pathType.decode = function (x) {
	                return x != null ? x.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : x;
	            };
	        };
	        // eslint-disable-next-line @typescript-eslint/no-empty-function
	        Ng1LocationServices.prototype.dispose = function () { };
	        Ng1LocationServices.prototype.onChange = function (callback) {
	            var _this = this;
	            this._urlListeners.push(callback);
	            return function () { return core.removeFrom(_this._urlListeners)(callback); };
	        };
	        Ng1LocationServices.prototype.html5Mode = function () {
	            var html5Mode = this.$locationProvider.html5Mode();
	            html5Mode = core.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
	            return html5Mode && this.$sniffer.history;
	        };
	        Ng1LocationServices.prototype.baseHref = function () {
	            return this._baseHref || (this._baseHref = this.$browser.baseHref() || this.$window.location.pathname);
	        };
	        Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
	            if (replace === void 0) { replace = false; }
	            if (core.isDefined(newUrl))
	                this.$location.url(newUrl);
	            if (replace)
	                this.$location.replace();
	            if (state)
	                this.$location.state(state);
	            return this.$location.url();
	        };
	        Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser, $window) {
	            var _this = this;
	            this.$location = $location;
	            this.$sniffer = $sniffer;
	            this.$browser = $browser;
	            this.$window = $window;
	            // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
	            $rootScope.$on('$locationChangeSuccess', function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
	            var _loc = core.val($location);
	            // Bind these LocationService functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['replace', 'path', 'search', 'hash']);
	            // Bind these LocationConfig functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
	        };
	        return Ng1LocationServices;
	    }());
	
	    /** @publicapi @module url */ /** */
	    /**
	     * Manages rules for client-side URL
	     *
	     * ### Deprecation warning:
	     * This class is now considered to be an internal API
	     * Use the [[UrlService]] instead.
	     * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
	     *
	     * This class manages the router rules for what to do when the URL changes.
	     *
	     * This provider remains for backwards compatibility.
	     *
	     * @internalapi
	     * @deprecated
	     */
	    var UrlRouterProvider = /** @class */ (function () {
	        /** @hidden */
	        function UrlRouterProvider(/** @hidden */ router) {
	            this.router = router;
	        }
	        UrlRouterProvider.injectableHandler = function (router, handler) {
	            return function (match) { return core.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params }); };
	        };
	        /** @hidden */
	        UrlRouterProvider.prototype.$get = function () {
	            var urlService = this.router.urlService;
	            this.router.urlRouter.update(true);
	            if (!urlService.interceptDeferred)
	                urlService.listen();
	            return this.router.urlRouter;
	        };
	        /**
	         * Registers a url handler function.
	         *
	         * Registers a low level url handler (a `rule`).
	         * A rule detects specific URL patterns and returns a redirect, or performs some action.
	         *
	         * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Here's an example of how you might allow case insensitive urls
	         *   $urlRouterProvider.rule(function ($injector, $location) {
	         *     var path = $location.path(),
	         *         normalized = path.toLowerCase();
	         *
	         *     if (path !== normalized) {
	         *       return normalized;
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param ruleFn
	         * Handler function that takes `$injector` and `$location` services as arguments.
	         * You can use them to detect a url and return a different url as a string.
	         *
	         * @return [[UrlRouterProvider]] (`this`)
	         */
	        UrlRouterProvider.prototype.rule = function (ruleFn) {
	            var _this = this;
	            if (!core.isFunction(ruleFn))
	                throw new Error("'rule' must be a function");
	            var match = function () { return ruleFn(core.services.$injector, _this.router.locationService); };
	            var rule = new core.BaseUrlRule(match, core.identity);
	            this.router.urlService.rules.rule(rule);
	            return this;
	        };
	        /**
	         * Defines the path or behavior to use when no url can be matched.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // if the path doesn't match any of the urls you configured
	         *   // otherwise will take care of routing the user to the
	         *   // specified url
	         *   $urlRouterProvider.otherwise('/index');
	         *
	         *   // Example of using function rule as param
	         *   $urlRouterProvider.otherwise(function ($injector, $location) {
	         *     return '/a/valid/url';
	         *   });
	         * });
	         * ```
	         *
	         * @param rule
	         * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
	         * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
	         *
	         * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	         */
	        UrlRouterProvider.prototype.otherwise = function (rule) {
	            var _this = this;
	            var urlRules = this.router.urlService.rules;
	            if (core.isString(rule)) {
	                urlRules.otherwise(rule);
	            }
	            else if (core.isFunction(rule)) {
	                urlRules.otherwise(function () { return rule(core.services.$injector, _this.router.locationService); });
	            }
	            else {
	                throw new Error("'rule' must be a string or function");
	            }
	            return this;
	        };
	        /**
	         * Registers a handler for a given url matching.
	         *
	         * If the handler is a string, it is
	         * treated as a redirect, and is interpolated according to the syntax of match
	         * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	         *
	         * If the handler is a function, it is injectable.
	         * It gets invoked if `$location` matches.
	         * You have the option of inject the match object as `$match`.
	         *
	         * The handler can return
	         *
	         * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	         *   will continue trying to find another one that matches.
	         * - **string** which is treated as a redirect and passed to `$location.url()`
	         * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	         *     if ($state.$current.navigable !== state ||
	         *         !equalForKeys($match, $stateParams) {
	         *      $state.transitionTo(state, $match, false);
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param what A pattern string to match, compiled as a [[UrlMatcher]].
	         * @param handler The path (or function that returns a path) that you want to redirect your user to.
	         * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
	         *
	         * Note: the handler may also invoke arbitrary code, such as `$state.go()`
	         */
	        UrlRouterProvider.prototype.when = function (what, handler) {
	            if (core.isArray(handler) || core.isFunction(handler)) {
	                handler = UrlRouterProvider.injectableHandler(this.router, handler);
	            }
	            this.router.urlService.rules.when(what, handler);
	            return this;
	        };
	        /**
	         * Disables monitoring of the URL.
	         *
	         * Call this method before UI-Router has bootstrapped.
	         * It will stop UI-Router from performing the initial url sync.
	         *
	         * This can be useful to perform some asynchronous initialization before the router starts.
	         * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Prevent $urlRouter from automatically intercepting URL changes;
	         *   $urlRouterProvider.deferIntercept();
	         * })
	         *
	         * app.run(function (MyService, $urlRouter, $http) {
	         *   $http.get("/stuff").then(function(resp) {
	         *     MyService.doStuff(resp.data);
	         *     $urlRouter.listen();
	         *     $urlRouter.sync();
	         *   });
	         * });
	         * ```
	         *
	         * @param defer Indicates whether to defer location change interception.
	         *        Passing no parameter is equivalent to `true`.
	         */
	        UrlRouterProvider.prototype.deferIntercept = function (defer) {
	            this.router.urlService.deferIntercept(defer);
	        };
	        return UrlRouterProvider;
	    }());
	
	    /* eslint-disable @typescript-eslint/no-empty-function */
	    ng.module('ui.router.angular1', []);
	    var mod_init = ng.module('ui.router.init', ['ng']);
	    var mod_util = ng.module('ui.router.util', ['ui.router.init']);
	    var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
	    var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
	    var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
	    var mod_cmpt = ng.module('ui.router.compat', ['ui.router']);
	    var router = null;
	    $uiRouterProvider.$inject = ['$locationProvider'];
	    /** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
	    function $uiRouterProvider($locationProvider) {
	        // Create a new instance of the Router when the $uiRouterProvider is initialized
	        router = this.router = new core.UIRouter();
	        router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
	        // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
	        router.stateRegistry.decorator('views', ng1ViewsBuilder);
	        router.stateRegistry.decorator('onExit', getStateHookBuilder('onExit'));
	        router.stateRegistry.decorator('onRetain', getStateHookBuilder('onRetain'));
	        router.stateRegistry.decorator('onEnter', getStateHookBuilder('onEnter'));
	        router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
	        // Disable decoding of params by UrlMatcherFactory because $location already handles this
	        router.urlService.config._decodeParams = false;
	        var ng1LocationService = (router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider));
	        Ng1LocationServices.monkeyPatchPathParameterType(router);
	        // backwards compat: also expose router instance as $uiRouterProvider.router
	        router['router'] = router;
	        router['$get'] = $get;
	        $get.$inject = ['$location', '$browser', '$window', '$sniffer', '$rootScope', '$http', '$templateCache'];
	        function $get($location, $browser, $window, $sniffer, $rootScope, $http, $templateCache) {
	            ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser, $window);
	            delete router['router'];
	            delete router['$get'];
	            return router;
	        }
	        return router;
	    }
	    var getProviderFor = function (serviceName) { return [
	        '$uiRouterProvider',
	        function ($urp) {
	            var service = $urp.router[serviceName];
	            service['$get'] = function () { return service; };
	            return service;
	        },
	    ]; };
	    // This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
	    runBlock.$inject = ['$injector', '$q', '$uiRouter'];
	    function runBlock($injector, $q, $uiRouter) {
	        core.services.$injector = $injector;
	        core.services.$q = $q;
	        // https://github.com/angular-ui/ui-router/issues/3678
	        if (!Object.prototype.hasOwnProperty.call($injector, 'strictDi')) {
	            try {
	                $injector.invoke(function (checkStrictDi) { });
	            }
	            catch (error) {
	                $injector.strictDi = !!/strict mode/.exec(error && error.toString());
	            }
	        }
	        // The $injector is now available.
	        // Find any resolvables that had dependency annotation deferred
	        $uiRouter.stateRegistry
	            .get()
	            .map(function (x) { return x.$$state().resolvables; })
	            .reduce(core.unnestR, [])
	            .filter(function (x) { return x.deps === 'deferred'; })
	            .forEach(function (resolvable) { return (resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi)); });
	    }
	    // $urlRouter service and $urlRouterProvider
	    var getUrlRouterProvider = function (uiRouter) { return (uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter)); };
	    // $state service and $stateProvider
	    // $urlRouter service and $urlRouterProvider
	    var getStateProvider = function () { return core.extend(router.stateProvider, { $get: function () { return router.stateService; } }); };
	    watchDigests.$inject = ['$rootScope'];
	    function watchDigests($rootScope) {
	        $rootScope.$watch(function () {
	            core.trace.approximateDigests++;
	        });
	    }
	    mod_init.provider('$uiRouter', $uiRouterProvider);
	    mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
	    mod_util.provider('$urlService', getProviderFor('urlService'));
	    mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
	    mod_util.provider('$templateFactory', function () { return new TemplateFactory(); });
	    mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
	    mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
	    mod_state.provider('$transitions', getProviderFor('transitionService'));
	    mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
	    mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
	    mod_main.factory('$view', function () { return router.viewService; });
	    mod_main.service('$trace', function () { return core.trace; });
	    mod_main.run(watchDigests);
	    mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
	    mod_state.run(['$state', function ($state) { }]);
	    mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
	    mod_init.run(runBlock);
	    /** @hidden TODO: find a place to move this */
	    var getLocals = function (ctx) {
	        var tokens = ctx.getTokens().filter(core.isString);
	        var tuples = tokens.map(function (key) {
	            var resolvable = ctx.getResolvable(key);
	            var waitPolicy = ctx.getPolicy(resolvable).async;
	            return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
	        });
	        return tuples.reduce(core.applyPairs, {});
	    };
	
	    /* eslint-disable @typescript-eslint/no-empty-interface */
	    /** @hidden */
	    function parseStateRef(ref) {
	        var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
	        if (paramsOnly)
	            ref = '(' + paramsOnly[1] + ')';
	        var parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
	        if (!parsed || parsed.length !== 4)
	            throw new Error("Invalid state ref '" + ref + "'");
	        return { state: parsed[1] || null, paramExpr: parsed[3] || null };
	    }
	    /** @hidden */
	    function stateContext(el) {
	        var $uiView = el.parent().inheritedData('$uiView');
	        var path = core.parse('$cfg.path')($uiView);
	        return path ? core.tail(path).state.name : undefined;
	    }
	    /** @hidden */
	    function processedDef($state, $element, def) {
	        var uiState = def.uiState || $state.current.name;
	        var uiStateOpts = core.extend(defaultOpts($element, $state), def.uiStateOpts || {});
	        var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
	        return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
	    }
	    /** @hidden */
	    function getTypeInfo(el) {
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	        var isForm = el[0].nodeName === 'FORM';
	        return {
	            attr: isForm ? 'action' : isSvg ? 'xlink:href' : 'href',
	            isAnchor: el.prop('tagName').toUpperCase() === 'A',
	            clickable: !isForm,
	        };
	    }
	    /** @hidden */
	    function clickHook(el, $state, $timeout, type, getDef) {
	        return function (e) {
	            var button = e.which || e.button, target = getDef();
	            if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || el.attr('target'))) {
	                // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	                var transition_1 = $timeout(function () {
	                    if (!el.attr('disabled')) {
	                        $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
	                    }
	                });
	                e.preventDefault();
	                // if the state has no URL, ignore one preventDefault from the <a> directive.
	                var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
	                e.preventDefault = function () {
	                    if (ignorePreventDefaultCount_1-- <= 0)
	                        $timeout.cancel(transition_1);
	                };
	            }
	        };
	    }
	    /** @hidden */
	    function defaultOpts(el, $state) {
	        return {
	            relative: stateContext(el) || $state.$current,
	            inherit: true,
	            source: 'sref',
	        };
	    }
	    /** @hidden */
	    function bindEvents(element, scope, hookFn, uiStateOpts) {
	        var events;
	        if (uiStateOpts) {
	            events = uiStateOpts.events;
	        }
	        if (!core.isArray(events)) {
	            events = ['click'];
	        }
	        var on = element.on ? 'on' : 'bind';
	        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
	            var event_1 = events_1[_i];
	            element[on](event_1, hookFn);
	        }
	        scope.$on('$destroy', function () {
	            var off = element.off ? 'off' : 'unbind';
	            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
	                var event_2 = events_2[_i];
	                element[off](event_2, hookFn);
	            }
	        });
	    }
	    /**
	     * `ui-sref`: A directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of the `ui-sref` is the name of the state to link to.
	     *
	     * #### Example:
	     * This will activate the `home` state when the link is clicked.
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * ```
	     *
	     * ### Relative Links
	     * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create a relative `ui-sref` which always targets the same destination.
	     *
	     * #### Example:
	     * Both these links are relative to the parent state, even when a child state is currently active.
	     * ```html
	     * <a ui-sref=".child1">child 1 state</a>
	     * <a ui-sref=".child2">child 2 state</a>
	     * ```
	     *
	     * This link activates the parent state.
	     * ```html
	     * <a ui-sref="^">Return</a>
	     * ```
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * #### Example:
	     * Assuming the `users` state has a url of `/users/`
	     * ```html
	     * <a ui-sref="users" href="/users/">Users</a>
	     * ```
	     *
	     * ### Parameter Values
	     * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
	     * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
	     * The content inside the parentheses is an expression, evaluated to the parameter values.
	     *
	     * #### Example:
	     * This example renders a list of links to users.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="user in users">
	     *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * Note:
	     * The parameter values expression is `$watch`ed for updates.
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-sref-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Examples
	     * If you have the following template:
	     *
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * <a ui-sref="about">About</a>
	     * <a ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	     *     </li>
	     * </ul>
	     * ```
	     *
	     * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
	     *
	     * ```html
	     * <a href="#/home" ui-sref="home">Home</a>
	     * <a href="#/about" ui-sref="about">About</a>
	     * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	     *     </li>
	     * </ul>
	     *
	     * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	     * ```
	     *
	     * ### Notes
	     *
	     * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-sref="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     *
	     * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
	     * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
	     */
	    var uiSrefDirective;
	    uiSrefDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var ref = parseStateRef(attrs.uiSref);
	                    rawDef.uiState = ref.state;
	                    rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    if (ref.paramExpr) {
	                        scope.$watch(ref.paramExpr, function (val) {
	                            rawDef.uiStateParams = core.extend({}, val);
	                            update();
	                        }, true);
	                        rawDef.uiStateParams = core.extend({}, scope.$eval(ref.paramExpr));
	                    }
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    var hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-state`: A fully dynamic directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
	     * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
	     *
	     * #### Example:
	     * Create a list of links.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Relative Links
	     * If the expression evaluates to a relative path, it is processed like [[uiSref]].
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create relative `ui-state` which always targets the same destination.
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * ### Parameter Values
	     * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
	     * Param values should be provided using the `ui-state-params` attribute.
	     * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * This example renders a list of links with param values.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-state-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Notes
	     *
	     * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
	     *   However, it might be simpler to use [[uiSref]] parameter-only links.
	     *
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     * ```
	     */
	    var uiStateDirective;
	    uiStateDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDynamicDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var hookFn;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
	                    var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return ((acc[attr] = core.noop), acc); }, {});
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    inputAttrs.forEach(function (field) {
	                        rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
	                        attrs.$observe(field, function (expr) {
	                            watchDeregFns[field]();
	                            watchDeregFns[field] = scope.$watch(expr, function (newval) {
	                                rawDef[field] = newval;
	                                update();
	                            }, true);
	                        });
	                    });
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
	     *
	     * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
	     * related directive's state is active (and remove them when it is inactive).
	     *
	     * The primary use-case is to highlight the active link in navigation menus,
	     * distinguishing it from the inactive menu items.
	     *
	     * ### Linking to a `ui-sref` or `ui-state`
	     * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
	     * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
	     *
	     * ### Matching
	     *
	     * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
	     * This is a "fuzzy match" which uses [[StateService.includes]].
	     *
	     * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
	     * This is an "exact match" which uses [[StateService.is]].
	     *
	     * ### Parameter values
	     * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
	     * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
	     *
	     * #### Example:
	     * ```html
	     * <li ng-repeat="user in users" ui-sref-active="active">
	     *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Examples
	     *
	     * Given the following template:
	     * #### Example:
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item">
	     *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * When the app state is `app.user` (or any child state),
	     * and contains the state parameter "user" with value "bilbobaggins",
	     * the resulting HTML will appear as (note the 'active' class):
	     *
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item active">
	     *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * ### Glob mode
	     *
	     * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
	     * The objects keys represent active class names and values represent the respective state names/globs.
	     * `ui-sref-active` will match if the current active state **includes** any of
	     * the specified state names/globs, even the abstract ones.
	     *
	     * #### Example:
	     * Given the following template, with "admin" being an abstract state:
	     * ```html
	     * <div ui-sref-active="{'active': 'admin.**'}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * Arrays are also supported as values in the `ngClass`-like interface.
	     * This allows multiple states to add `active` class.
	     *
	     * #### Example:
	     * Given the following template, with "admin.roles" being the current state, the class will be added too:
	     * ```html
	     * <div ui-sref-active="{'active': ['owner.**', 'admin.**']}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * When the current state is "admin.roles" the "active" class will be applied to both the `<div>` and `<a>` elements.
	     * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
	     *
	     * ### Notes:
	     *
	     * - The class name is interpolated **once** during the directives link time (any further changes to the
	     * interpolated value are ignored).
	     *
	     * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
	     */
	    var uiSrefActiveDirective;
	    uiSrefActiveDirective = [
	        '$state',
	        '$stateParams',
	        '$interpolate',
	        '$uiRouter',
	        function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
	            return {
	                restrict: 'A',
	                controller: [
	                    '$scope',
	                    '$element',
	                    '$attrs',
	                    function ($scope, $element, $attrs) {
	                        var states = [];
	                        var activeEqClass;
	                        var uiSrefActive;
	                        // There probably isn't much point in $observing this
	                        // uiSrefActive and uiSrefActiveEq share the same directive object with some
	                        // slight difference in logic routing
	                        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	                        try {
	                            uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	                        }
	                        catch (e) {
	                            // Do nothing. uiSrefActive is not a valid expression.
	                            // Fall back to using $interpolate below
	                        }
	                        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	                        setStatesFromDefinitionObject(uiSrefActive);
	                        // Allow uiSref to communicate with uiSrefActive[Equals]
	                        this.$$addStateInfo = function (newState, newParams) {
	                            // we already got an explicit state provided by ui-sref-active, so we
	                            // shadow the one that comes from ui-sref
	                            if (core.isObject(uiSrefActive) && states.length > 0) {
	                                return;
	                            }
	                            var deregister = addState(newState, newParams, uiSrefActive);
	                            update();
	                            return deregister;
	                        };
	                        function updateAfterTransition(trans) {
	                            trans.promise.then(update, core.noop);
	                        }
	                        $scope.$on('$destroy', setupEventListeners());
	                        if ($uiRouter.globals.transition) {
	                            updateAfterTransition($uiRouter.globals.transition);
	                        }
	                        function setupEventListeners() {
	                            var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
	                            var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
	                            var deregisterStateChangeSuccessListener = $scope.$on('$stateChangeSuccess', update);
	                            return function cleanUp() {
	                                deregisterStatesChangedListener();
	                                deregisterOnStartListener();
	                                deregisterStateChangeSuccessListener();
	                            };
	                        }
	                        function handleStatesChanged() {
	                            setStatesFromDefinitionObject(uiSrefActive);
	                        }
	                        function setStatesFromDefinitionObject(statesDefinition) {
	                            if (core.isObject(statesDefinition)) {
	                                states = [];
	                                core.forEach(statesDefinition, function (stateOrName, activeClass) {
	                                    // Helper function to abstract adding state.
	                                    var addStateForClass = function (stateOrName, activeClass) {
	                                        var ref = parseStateRef(stateOrName);
	                                        addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	                                    };
	                                    if (core.isString(stateOrName)) {
	                                        // If state is string, just add it.
	                                        addStateForClass(stateOrName, activeClass);
	                                    }
	                                    else if (core.isArray(stateOrName)) {
	                                        // If state is an array, iterate over it and add each array item individually.
	                                        core.forEach(stateOrName, function (stateOrName) {
	                                            addStateForClass(stateOrName, activeClass);
	                                        });
	                                    }
	                                });
	                            }
	                        }
	                        function addState(stateName, stateParams, activeClass) {
	                            var state = $state.get(stateName, stateContext($element));
	                            var stateInfo = {
	                                state: state || { name: stateName },
	                                params: stateParams,
	                                activeClass: activeClass,
	                            };
	                            states.push(stateInfo);
	                            return function removeState() {
	                                core.removeFrom(states)(stateInfo);
	                            };
	                        }
	                        // Update route state
	                        function update() {
	                            var splitClasses = function (str) { return str.split(/\s/).filter(core.identity); };
	                            var getClasses = function (stateList) {
	                                return stateList
	                                    .map(function (x) { return x.activeClass; })
	                                    .map(splitClasses)
	                                    .reduce(core.unnestR, []);
	                            };
	                            var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(core.uniqR, []);
	                            var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
	                            var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
	                            var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
	                            var addClasses = fuzzyClasses.concat(exactClasses).reduce(core.uniqR, []);
	                            var removeClasses = allClasses.filter(function (cls) { return !core.inArray(addClasses, cls); });
	                            $scope.$evalAsync(function () {
	                                addClasses.forEach(function (className) { return $element.addClass(className); });
	                                removeClasses.forEach(function (className) { return $element.removeClass(className); });
	                            });
	                        }
	                        update();
	                    },
	                ],
	            };
	        },
	    ];
	    ng
	        .module('ui.router.state')
	        .directive('uiSref', uiSrefDirective)
	        .directive('uiSrefActive', uiSrefActiveDirective)
	        .directive('uiSrefActiveEq', uiSrefActiveDirective)
	        .directive('uiState', uiStateDirective);
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * `isState` Filter: truthy if the current state is the parameter
	     *
	     * Translates to [[StateService.is]] `$state.is("stateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
	     * ```
	     */
	    $IsStateFilter.$inject = ['$state'];
	    function $IsStateFilter($state) {
	        var isFilter = function (state, params, options) {
	            return $state.is(state, params, options);
	        };
	        isFilter.$stateful = true;
	        return isFilter;
	    }
	    /**
	     * `includedByState` Filter: truthy if the current state includes the parameter
	     *
	     * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
	     * ```
	     */
	    $IncludedByStateFilter.$inject = ['$state'];
	    function $IncludedByStateFilter($state) {
	        var includesFilter = function (state, params, options) {
	            return $state.includes(state, params, options);
	        };
	        includesFilter.$stateful = true;
	        return includesFilter;
	    }
	    ng.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);
	
	    /** @publicapi @module directives */ /** */
	    /**
	     * `ui-view`: A viewport directive which is filled in by a view from the active state.
	     *
	     * ### Attributes
	     *
	     * - `name`: (Optional) A view name.
	     *   The name should be unique amongst the other views in the same state.
	     *   You can have views of the same name that live in different states.
	     *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
	     *
	     * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
	     *   Uses [[$uiViewScroll]] to do the scrolling.
	     *
	     * - `onload`: Expression to evaluate whenever the view updates.
	     *
	     * #### Example:
	     * A view can be unnamed or named.
	     * ```html
	     * <!-- Unnamed -->
	     * <div ui-view></div>
	     *
	     * <!-- Named -->
	     * <div ui-view="viewName"></div>
	     *
	     * <!-- Named (different style) -->
	     * <ui-view name="viewName"></ui-view>
	     * ```
	     *
	     * You can only have one unnamed view within any template (or root html). If you are only using a
	     * single view and it is unnamed then you can populate it like so:
	     *
	     * ```html
	     * <div ui-view></div>
	     * $stateProvider.state("home", {
	     *   template: "<h1>HELLO!</h1>"
	     * })
	     * ```
	     *
	     * The above is a convenient shortcut equivalent to specifying your view explicitly with the
	     * [[Ng1StateDeclaration.views]] config property, by name, in this case an empty name:
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * But typically you'll only use the views property if you name your view or have more than one view
	     * in the same template. There's not really a compelling reason to name a view if its the only one,
	     * but you could if you wanted, like so:
	     *
	     * ```html
	     * <div ui-view="main"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "main": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * Really though, you'll use views to set up multiple views:
	     *
	     * ```html
	     * <div ui-view></div>
	     * <div ui-view="chart"></div>
	     * <div ui-view="data"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     },
	     *     "chart": {
	     *       template: "<chart_thing/>"
	     *     },
	     *     "data": {
	     *       template: "<data_thing/>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * #### Examples for `autoscroll`:
	     * ```html
	     * <!-- If autoscroll present with no expression,
	     *      then scroll ui-view into view -->
	     * <ui-view autoscroll/>
	     *
	     * <!-- If autoscroll present with valid expression,
	     *      then scroll ui-view into view if expression evaluates to true -->
	     * <ui-view autoscroll='true'/>
	     * <ui-view autoscroll='false'/>
	     * <ui-view autoscroll='scopeVariable'/>
	     * ```
	     *
	     * Resolve data:
	     *
	     * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	     * can be customized using [[Ng1ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	     *
	     * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	     * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	     * depends on `$resolve` data.
	     *
	     * #### Example:
	     * ```js
	     * $stateProvider.state('home', {
	     *   template: '<my-component user="$resolve.user"></my-component>',
	     *   resolve: {
	     *     user: function(UserService) { return UserService.fetchUser(); }
	     *   }
	     * });
	     * ```
	     */
	    var uiView;
	    // eslint-disable-next-line prefer-const
	    uiView = [
	        '$view',
	        '$animate',
	        '$uiViewScroll',
	        '$interpolate',
	        '$q',
	        function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
	            function getRenderer() {
	                return {
	                    enter: function (element, target, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.enter(element, null, target).then(cb);
	                        }
	                        else {
	                            $animate.enter(element, null, target, cb);
	                        }
	                    },
	                    leave: function (element, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.leave(element).then(cb);
	                        }
	                        else {
	                            $animate.leave(element, cb);
	                        }
	                    },
	                };
	            }
	            function configsEqual(config1, config2) {
	                return config1 === config2;
	            }
	            var rootData = {
	                $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
	                $uiView: {},
	            };
	            var directive = {
	                count: 0,
	                restrict: 'ECA',
	                terminal: true,
	                priority: 400,
	                transclude: 'element',
	                compile: function (tElement, tAttrs, $transclude) {
	                    return function (scope, $element, attrs) {
	                        var onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(), inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
	                        var previousEl, currentEl, currentScope, viewConfig;
	                        var activeUIView = {
	                            $type: 'ng1',
	                            id: directive.count++,
	                            name: name,
	                            fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + '.' + name : name,
	                            config: null,
	                            configUpdated: configUpdatedCallback,
	                            get creationContext() {
	                                // The context in which this ui-view "tag" was created
	                                var fromParentTagConfig = core.parse('$cfg.viewDecl.$context')(inherited);
	                                // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
	                                // See https://github.com/angular-ui/ui-router/issues/3355
	                                var fromParentTag = core.parse('$uiView.creationContext')(inherited);
	                                return fromParentTagConfig || fromParentTag;
	                            },
	                        };
	                        core.trace.traceUIViewEvent('Linking', activeUIView);
	                        function configUpdatedCallback(config) {
	                            if (config && !(config instanceof Ng1ViewConfig))
	                                return;
	                            if (configsEqual(viewConfig, config))
	                                return;
	                            core.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
	                            viewConfig = config;
	                            updateView(config);
	                        }
	                        $element.data('$uiView', { $uiView: activeUIView });
	                        updateView();
	                        var unregister = $view.registerUIView(activeUIView);
	                        scope.$on('$destroy', function () {
	                            core.trace.traceUIViewEvent('Destroying/Unregistering', activeUIView);
	                            unregister();
	                        });
	                        function cleanupLastView() {
	                            if (previousEl) {
	                                core.trace.traceUIViewEvent('Removing (previous) el', previousEl.data('$uiView'));
	                                previousEl.remove();
	                                previousEl = null;
	                            }
	                            if (currentScope) {
	                                core.trace.traceUIViewEvent('Destroying scope', activeUIView);
	                                currentScope.$destroy();
	                                currentScope = null;
	                            }
	                            if (currentEl) {
	                                var _viewData_1 = currentEl.data('$uiViewAnim');
	                                core.trace.traceUIViewEvent('Animate out', _viewData_1);
	                                renderer.leave(currentEl, function () {
	                                    _viewData_1.$$animLeave.resolve();
	                                    previousEl = null;
	                                });
	                                previousEl = currentEl;
	                                currentEl = null;
	                            }
	                        }
	                        function updateView(config) {
	                            var newScope = scope.$new();
	                            var animEnter = $q.defer(), animLeave = $q.defer();
	                            var $uiViewData = {
	                                $cfg: config,
	                                $uiView: activeUIView,
	                            };
	                            var $uiViewAnim = {
	                                $animEnter: animEnter.promise,
	                                $animLeave: animLeave.promise,
	                                $$animLeave: animLeave,
	                            };
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoading
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description
	                             *
	                             * Fired once the view **begins loading**, *before* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             * @param {string} viewName Name of the view.
	                             */
	                            newScope.$emit('$viewContentLoading', name);
	                            var cloned = $transclude(newScope, function (clone) {
	                                clone.data('$uiViewAnim', $uiViewAnim);
	                                clone.data('$uiView', $uiViewData);
	                                renderer.enter(clone, $element, function onUIViewEnter() {
	                                    animEnter.resolve();
	                                    if (currentScope)
	                                        currentScope.$emit('$viewContentAnimationEnded');
	                                    if ((core.isDefined(autoScrollExp) && !autoScrollExp) || scope.$eval(autoScrollExp)) {
	                                        $uiViewScroll(clone);
	                                    }
	                                });
	                                cleanupLastView();
	                            });
	                            currentEl = cloned;
	                            currentScope = newScope;
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoaded
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description           *
	                             * Fired once the view is **loaded**, *after* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             */
	                            currentScope.$emit('$viewContentLoaded', config || viewConfig);
	                            currentScope.$eval(onloadExp);
	                        }
	                    };
	                },
	            };
	            return directive;
	        },
	    ];
	    $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q'];
	    /** @hidden */
	    function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q) {
	        var getControllerAs = core.parse('viewDecl.controllerAs');
	        var getResolveAs = core.parse('viewDecl.resolveAs');
	        return {
	            restrict: 'ECA',
	            priority: -400,
	            compile: function (tElement) {
	                var initial = tElement.html();
	                tElement.empty();
	                return function (scope, $element) {
	                    var data = $element.data('$uiView');
	                    if (!data) {
	                        $element.html(initial);
	                        $compile($element.contents())(scope);
	                        return;
	                    }
	                    var cfg = data.$cfg || { viewDecl: {}, getTemplate: core.noop };
	                    var resolveCtx = cfg.path && new core.ResolveContext(cfg.path);
	                    $element.html(cfg.getTemplate($element, resolveCtx) || initial);
	                    core.trace.traceUIViewFill(data.$uiView, $element.html());
	                    var link = $compile($element.contents());
	                    var controller = cfg.controller;
	                    var controllerAs = getControllerAs(cfg);
	                    var resolveAs = getResolveAs(cfg);
	                    var locals = resolveCtx && getLocals(resolveCtx);
	                    scope[resolveAs] = locals;
	                    if (controller) {
	                        var controllerInstance = ($controller(controller, core.extend({}, locals, { $scope: scope, $element: $element })));
	                        if (controllerAs) {
	                            scope[controllerAs] = controllerInstance;
	                            scope[controllerAs][resolveAs] = locals;
	                        }
	                        // TODO: Use $view service as a central point for registering component-level hooks
	                        // Then, when a component is created, tell the $view service, so it can invoke hooks
	                        // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
	                        // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
	                        $element.data('$ngControllerController', controllerInstance);
	                        $element.children().data('$ngControllerController', controllerInstance);
	                        registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
	                    }
	                    // Wait for the component to appear in the DOM
	                    if (core.isString(cfg.component)) {
	                        var kebobName = core.kebobString(cfg.component);
	                        var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", 'i');
	                        var getComponentController = function () {
	                            var directiveEl = [].slice
	                                .call($element[0].children)
	                                .filter(function (el) { return el && el.tagName && tagRegexp_1.exec(el.tagName); });
	                            return directiveEl && ng.element(directiveEl).data("$" + cfg.component + "Controller");
	                        };
	                        var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
	                            if (!ctrlInstance)
	                                return;
	                            registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
	                            deregisterWatch_1();
	                        });
	                    }
	                    link(scope);
	                };
	            },
	        };
	    }
	    /** @hidden */
	    var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
	    /** @hidden incrementing id */
	    var _uiCanExitId = 0;
	    /** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
	    function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
	        // Call $onInit() ASAP
	        if (core.isFunction(controllerInstance.$onInit) &&
	            !((cfg.viewDecl.component || cfg.viewDecl.componentProvider) && hasComponentImpl)) {
	            controllerInstance.$onInit();
	        }
	        var viewState = core.tail(cfg.path).state.self;
	        var hookOptions = { bind: controllerInstance };
	        // Add component-level hook for onUiParamsChanged
	        if (core.isFunction(controllerInstance.uiOnParamsChanged)) {
	            var resolveContext = new core.ResolveContext(cfg.path);
	            var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
	            // Fire callback on any successful transition
	            var paramsUpdated = function ($transition$) {
	                // Exit early if the $transition$ is the same as the view was created within.
	                // Exit early if the $transition$ will exit the state the view is for.
	                if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
	                    return;
	                var toParams = $transition$.params('to');
	                var fromParams = $transition$.params('from');
	                var getNodeSchema = function (node) { return node.paramSchema; };
	                var toSchema = $transition$.treeChanges('to').map(getNodeSchema).reduce(core.unnestR, []);
	                var fromSchema = $transition$.treeChanges('from').map(getNodeSchema).reduce(core.unnestR, []);
	                // Find the to params that have different values than the from params
	                var changedToParams = toSchema.filter(function (param) {
	                    var idx = fromSchema.indexOf(param);
	                    return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
	                });
	                // Only trigger callback if a to param has changed or is new
	                if (changedToParams.length) {
	                    var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
	                    // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
	                    var newValues = core.filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
	                    controllerInstance.uiOnParamsChanged(newValues, $transition$);
	                }
	            };
	            $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
	        }
	        // Add component-level hook for uiCanExit
	        if (core.isFunction(controllerInstance.uiCanExit)) {
	            var id_1 = _uiCanExitId++;
	            var cacheProp_1 = '_uiCanExitIds';
	            // Returns true if a redirect transition already answered truthy
	            var prevTruthyAnswer_1 = function (trans) {
	                return !!trans && ((trans[cacheProp_1] && trans[cacheProp_1][id_1] === true) || prevTruthyAnswer_1(trans.redirectedFrom()));
	            };
	            // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
	            var wrappedHook = function (trans) {
	                var promise;
	                var ids = (trans[cacheProp_1] = trans[cacheProp_1] || {});
	                if (!prevTruthyAnswer_1(trans)) {
	                    promise = $q.when(controllerInstance.uiCanExit(trans));
	                    promise.then(function (val) { return (ids[id_1] = val !== false); });
	                }
	                return promise;
	            };
	            var criteria = { exiting: viewState.name };
	            $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
	        }
	    }
	    ng.module('ui.router.state').directive('uiView', uiView);
	    ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */
	    function $ViewScrollProvider() {
	        var useAnchorScroll = false;
	        this.useAnchorScroll = function () {
	            useAnchorScroll = true;
	        };
	        this.$get = [
	            '$anchorScroll',
	            '$timeout',
	            function ($anchorScroll, $timeout) {
	                if (useAnchorScroll) {
	                    return $anchorScroll;
	                }
	                return function ($element) {
	                    return $timeout(function () {
	                        $element[0].scrollIntoView();
	                    }, 0, false);
	                };
	            },
	        ];
	    }
	    ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	    /**
	     * Main entry point for angular 1.x build
	     * @publicapi @module ng1
	     */ /** */
	    var index = 'ui.router';
	
	    Object.keys(core).forEach(function (k) {
	        if (k !== 'default') Object.defineProperty(exports, k, {
	            enumerable: true,
	            get: function () {
	                return core[k];
	            }
	        });
	    });
	    exports.core = core;
	    exports.Ng1ViewConfig = Ng1ViewConfig;
	    exports.StateProvider = StateProvider;
	    exports.UrlRouterProvider = UrlRouterProvider;
	    exports.default = index;
	    exports.getLocals = getLocals;
	    exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
	    exports.ng1ViewsBuilder = ng1ViewsBuilder;
	    exports.watchDigests = watchDigests;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=ui-router-angularjs.js.map


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.treeChangesCleanup = exports.registerAddCoreResolvables = void 0;
	var transition_1 = __webpack_require__(43);
	var router_1 = __webpack_require__(55);
	var resolve_1 = __webpack_require__(53);
	var common_1 = __webpack_require__(4);
	function addCoreResolvables(trans) {
	    trans.addResolvable(resolve_1.Resolvable.fromData(router_1.UIRouter, trans.router), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData(transition_1.Transition, trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$transition$', trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$stateParams', trans.params()), '');
	    trans.entering().forEach(function (state) {
	        trans.addResolvable(resolve_1.Resolvable.fromData('$state$', state), state);
	    });
	}
	exports.registerAddCoreResolvables = function (transitionService) {
	    return transitionService.onCreate({}, addCoreResolvables);
	};
	var TRANSITION_TOKENS = ['$transition$', transition_1.Transition];
	var isTransition = common_1.inArray(TRANSITION_TOKENS);
	// References to Transition in the treeChanges pathnodes makes all
	// previous Transitions reachable in memory, causing a memory leak
	// This function removes resolves for '$transition$' and `Transition` from the treeChanges.
	// Do not use this on current transitions, only on old ones.
	exports.treeChangesCleanup = function (trans) {
	    var nodes = common_1.values(trans.treeChanges()).reduce(common_1.unnestR, []).reduce(common_1.uniqR, []);
	    // If the resolvable is a Transition, return a new resolvable with null data
	    var replaceTransitionWithNull = function (r) {
	        return isTransition(r.token) ? resolve_1.Resolvable.fromData(r.token, null) : r;
	    };
	    nodes.forEach(function (node) {
	        node.resolvables = node.resolvables.map(replaceTransitionWithNull);
	    });
	};
	//# sourceMappingURL=coreResolvables.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerIgnoredTransitionHook = void 0;
	var trace_1 = __webpack_require__(9);
	var rejectFactory_1 = __webpack_require__(12);
	/**
	 * A [[TransitionHookFn]] that skips a transition if it should be ignored
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 *
	 * If the transition should be ignored (because no parameter or states changed)
	 * then the transition is ignored and not processed.
	 */
	function ignoredHook(trans) {
	    var ignoredReason = trans._ignoredReason();
	    if (!ignoredReason)
	        return;
	    trace_1.trace.traceTransitionIgnored(trans);
	    var pending = trans.router.globals.transition;
	    // The user clicked a link going back to the *current state* ('A')
	    // However, there is also a pending transition in flight (to 'B')
	    // Abort the transition to 'B' because the user now wants to be back at 'A'.
	    if (ignoredReason === 'SameAsCurrent' && pending) {
	        pending.abort();
	    }
	    return rejectFactory_1.Rejection.ignored().toPromise();
	}
	exports.registerIgnoredTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, ignoredHook, { priority: -9999 });
	};
	//# sourceMappingURL=ignoredTransition.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerInvalidTransitionHook = void 0;
	/**
	 * A [[TransitionHookFn]] that rejects the Transition if it is invalid
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 * If the transition is invalid (for example, param values do not validate)
	 * then the transition is rejected.
	 */
	function invalidTransitionHook(trans) {
	    if (!trans.valid()) {
	        throw new Error(trans.error().toString());
	    }
	}
	exports.registerInvalidTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, invalidTransitionHook, { priority: -10000 });
	};
	//# sourceMappingURL=invalidTransition.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerOnEnterHook = exports.registerOnRetainHook = exports.registerOnExitHook = void 0;
	/**
	 * A factory which creates an onEnter, onExit or onRetain transition hook function
	 *
	 * The returned function invokes the (for instance) state.onEnter hook when the
	 * state is being entered.
	 */
	function makeEnterExitRetainHook(hookName) {
	    return function (transition, state) {
	        var _state = state.$$state();
	        var hookFn = _state[hookName];
	        return hookFn(transition, state);
	    };
	}
	/**
	 * The [[TransitionStateHookFn]] for onExit
	 *
	 * When the state is being exited, the state's .onExit function is invoked.
	 *
	 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
	 *
	 * See: [[IHookRegistry.onExit]]
	 */
	var onExitHook = makeEnterExitRetainHook('onExit');
	exports.registerOnExitHook = function (transitionService) {
	    return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onRetain
	 *
	 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
	 *
	 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
	 *
	 * See: [[IHookRegistry.onRetain]]
	 */
	var onRetainHook = makeEnterExitRetainHook('onRetain');
	exports.registerOnRetainHook = function (transitionService) {
	    return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onEnter
	 *
	 * When the state is being entered, the state's .onEnter function is invoked.
	 *
	 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
	 *
	 * See: [[IHookRegistry.onEnter]]
	 */
	var onEnterHook = makeEnterExitRetainHook('onEnter');
	exports.registerOnEnterHook = function (transitionService) {
	    return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
	};
	//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerRedirectToHook = void 0;
	var predicates_1 = __webpack_require__(2);
	var coreservices_1 = __webpack_require__(5);
	var targetState_1 = __webpack_require__(17);
	/**
	 * A [[TransitionHookFn]] that redirects to a different state or params
	 *
	 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
	 *
	 * See [[StateDeclaration.redirectTo]]
	 */
	var redirectToHook = function (trans) {
	    var redirect = trans.to().redirectTo;
	    if (!redirect)
	        return;
	    var $state = trans.router.stateService;
	    function handleResult(result) {
	        if (!result)
	            return;
	        if (result instanceof targetState_1.TargetState)
	            return result;
	        if (predicates_1.isString(result))
	            return $state.target(result, trans.params(), trans.options());
	        if (result['state'] || result['params'])
	            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
	    }
	    if (predicates_1.isFunction(redirect)) {
	        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
	    }
	    return handleResult(redirect);
	};
	exports.registerRedirectToHook = function (transitionService) {
	    return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
	};
	//# sourceMappingURL=redirectTo.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerResolveRemaining = exports.registerLazyResolveState = exports.registerEagerResolvePath = exports.RESOLVE_HOOK_PRIORITY = void 0;
	var common_1 = __webpack_require__(1);
	var resolveContext_1 = __webpack_require__(23);
	var hof_1 = __webpack_require__(3);
	exports.RESOLVE_HOOK_PRIORITY = 1000;
	/**
	 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
	 *
	 * Registered using `transitionService.onStart({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var eagerResolvePath = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('EAGER', trans).then(common_1.noop);
	};
	exports.registerEagerResolvePath = function (transitionService) {
	    return transitionService.onStart({}, eagerResolvePath, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
	 *
	 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState, { priority: 1000 });`
	 *
	 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var lazyResolveState = function (trans, state) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).subContext(state.$$state()).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerLazyResolveState = function (transitionService) {
	    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves any dynamically added (LAZY or EAGER) Resolvables.
	 *
	 * Registered using `transitionService.onFinish({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * After all entering states have been entered, this hook resolves any remaining Resolvables.
	 * These are typically dynamic resolves which were added by some Transition Hook using [[Transition.addResolvable]].
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var resolveRemaining = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerResolveRemaining = function (transitionService) {
	    return transitionService.onFinish({}, resolveRemaining, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	//# sourceMappingURL=resolve.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerUpdateGlobalState = void 0;
	var common_1 = __webpack_require__(1);
	/**
	 * A [[TransitionHookFn]] which updates global UI-Router state
	 *
	 * Registered using `transitionService.onBefore({}, updateGlobalState);`
	 *
	 * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
	 * After a successful [[Transition]], updates the global values of "the current state"
	 * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
	 *
	 * See also the deprecated properties:
	 * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
	 */
	var updateGlobalState = function (trans) {
	    var globals = trans.router.globals;
	    var transitionSuccessful = function () {
	        globals.successfulTransitions.enqueue(trans);
	        globals.$current = trans.$to();
	        globals.current = globals.$current.self;
	        common_1.copy(trans.params(), globals.params);
	    };
	    var clearCurrentTransition = function () {
	        // Do not clear globals.transition if a different transition has started in the meantime
	        if (globals.transition === trans)
	            globals.transition = null;
	    };
	    trans.onSuccess({}, transitionSuccessful, { priority: 10000 });
	    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
	};
	exports.registerUpdateGlobalState = function (transitionService) {
	    return transitionService.onCreate({}, updateGlobalState);
	};
	//# sourceMappingURL=updateGlobals.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerUpdateUrl = void 0;
	/**
	 * A [[TransitionHookFn]] which updates the URL after a successful transition
	 *
	 * Registered using `transitionService.onSuccess({}, updateUrl);`
	 */
	var updateUrl = function (transition) {
	    var options = transition.options();
	    var $state = transition.router.stateService;
	    var $urlRouter = transition.router.urlRouter;
	    // Dont update the url in these situations:
	    // The transition was triggered by a URL sync (options.source === 'url')
	    // The user doesn't want the url to update (options.location === false)
	    // The destination state, and all parents have no navigable url
	    if (options.source !== 'url' && options.location && $state.$current.navigable) {
	        var urlOptions = { replace: options.location === 'replace' };
	        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
	    }
	    $urlRouter.update(true);
	};
	exports.registerUpdateUrl = function (transitionService) {
	    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
	};
	//# sourceMappingURL=url.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerActivateViews = exports.registerLoadEnteringViews = void 0;
	var common_1 = __webpack_require__(1);
	var coreservices_1 = __webpack_require__(5);
	/**
	 * A [[TransitionHookFn]] which waits for the views to load
	 *
	 * Registered using `transitionService.onStart({}, loadEnteringViews);`
	 *
	 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
	 * In angular 1, this includes loading the templates.
	 */
	var loadEnteringViews = function (transition) {
	    var $q = coreservices_1.services.$q;
	    var enteringViews = transition.views('entering');
	    if (!enteringViews.length)
	        return;
	    return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(common_1.noop);
	};
	exports.registerLoadEnteringViews = function (transitionService) {
	    return transitionService.onFinish({}, loadEnteringViews);
	};
	/**
	 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
	 *
	 * Registered using `transitionService.onSuccess({}, activateViews);`
	 *
	 * After a transition is complete, this hook deactivates the old views from the previous state,
	 * and activates the new views from the destination state.
	 *
	 * See [[ViewService]]
	 */
	var activateViews = function (transition) {
	    var enteringViews = transition.views('entering');
	    var exitingViews = transition.views('exiting');
	    if (!enteringViews.length && !exitingViews.length)
	        return;
	    var $view = transition.router.viewService;
	    exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
	    enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
	    $view.sync();
	};
	exports.registerActivateViews = function (transitionService) {
	    return transitionService.onSuccess({}, activateViews);
	};
	//# sourceMappingURL=views.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(4), exports);
	__exportStar(__webpack_require__(37), exports);
	__exportStar(__webpack_require__(120), exports);
	__exportStar(__webpack_require__(53), exports);
	__exportStar(__webpack_require__(40), exports);
	__exportStar(__webpack_require__(122), exports);
	__exportStar(__webpack_require__(123), exports);
	__exportStar(__webpack_require__(129), exports);
	__exportStar(__webpack_require__(50), exports);
	__exportStar(__webpack_require__(55), exports);
	__exportStar(__webpack_require__(125), exports);
	__exportStar(__webpack_require__(117), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouterPluginBase = void 0;
	var UIRouterPluginBase = /** @class */ (function () {
	    function UIRouterPluginBase() {
	    }
	    UIRouterPluginBase.prototype.dispose = function (router) { };
	    return UIRouterPluginBase;
	}());
	exports.UIRouterPluginBase = UIRouterPluginBase;
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamTypes = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var coreservices_1 = __webpack_require__(5);
	var paramType_1 = __webpack_require__(38);
	/**
	 * A registry for parameter types.
	 *
	 * This registry manages the built-in (and custom) parameter types.
	 *
	 * The built-in parameter types are:
	 *
	 * - [[string]]
	 * - [[path]]
	 * - [[query]]
	 * - [[hash]]
	 * - [[int]]
	 * - [[bool]]
	 * - [[date]]
	 * - [[json]]
	 * - [[any]]
	 *
	 * To register custom parameter types, use [[UrlConfig.type]], i.e.,
	 *
	 * ```js
	 * router.urlService.config.type(customType)
	 * ```
	 */
	var ParamTypes = /** @class */ (function () {
	    function ParamTypes() {
	        this.enqueue = true;
	        this.typeQueue = [];
	        this.defaultTypes = common_1.pick(ParamTypes.prototype, [
	            'hash',
	            'string',
	            'query',
	            'path',
	            'int',
	            'bool',
	            'date',
	            'json',
	            'any',
	        ]);
	        // Register default types. Store them in the prototype of this.types.
	        var makeType = function (definition, name) { return new paramType_1.ParamType(common_1.extend({ name: name }, definition)); };
	        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
	    }
	    ParamTypes.prototype.dispose = function () {
	        this.types = {};
	    };
	    /**
	     * Registers a parameter type
	     *
	     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
	     */
	    ParamTypes.prototype.type = function (name, definition, definitionFn) {
	        if (!predicates_1.isDefined(definition))
	            return this.types[name];
	        if (this.types.hasOwnProperty(name))
	            throw new Error("A type named '" + name + "' has already been defined.");
	        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
	        if (definitionFn) {
	            this.typeQueue.push({ name: name, def: definitionFn });
	            if (!this.enqueue)
	                this._flushTypeQueue();
	        }
	        return this;
	    };
	    ParamTypes.prototype._flushTypeQueue = function () {
	        while (this.typeQueue.length) {
	            var type = this.typeQueue.shift();
	            if (type.pattern)
	                throw new Error("You cannot override a type's .pattern at runtime.");
	            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
	        }
	    };
	    return ParamTypes;
	}());
	exports.ParamTypes = ParamTypes;
	function initDefaultTypes() {
	    var makeDefaultType = function (def) {
	        var valToString = function (val) { return (val != null ? val.toString() : val); };
	        var defaultTypeBase = {
	            encode: valToString,
	            decode: valToString,
	            is: hof_1.is(String),
	            pattern: /.*/,
	            // tslint:disable-next-line:triple-equals
	            equals: function (a, b) { return a == b; },
	        };
	        return common_1.extend({}, defaultTypeBase, def);
	    };
	    // Default Parameter Type Definitions
	    common_1.extend(ParamTypes.prototype, {
	        string: makeDefaultType({}),
	        path: makeDefaultType({
	            pattern: /[^/]*/,
	        }),
	        query: makeDefaultType({}),
	        hash: makeDefaultType({
	            inherit: false,
	        }),
	        int: makeDefaultType({
	            decode: function (val) { return parseInt(val, 10); },
	            is: function (val) {
	                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
	            },
	            pattern: /-?\d+/,
	        }),
	        bool: makeDefaultType({
	            encode: function (val) { return (val && 1) || 0; },
	            decode: function (val) { return parseInt(val, 10) !== 0; },
	            is: hof_1.is(Boolean),
	            pattern: /0|1/,
	        }),
	        date: makeDefaultType({
	            encode: function (val) {
	                return !this.is(val)
	                    ? undefined
	                    : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join('-');
	            },
	            decode: function (val) {
	                if (this.is(val))
	                    return val;
	                var match = this.capture.exec(val);
	                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	            },
	            is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
	            equals: function (l, r) {
	                return ['getFullYear', 'getMonth', 'getDate'].reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
	            },
	            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/,
	        }),
	        json: makeDefaultType({
	            encode: common_1.toJson,
	            decode: common_1.fromJson,
	            is: hof_1.is(Object),
	            equals: common_1.equals,
	            pattern: /[^/]*/,
	        }),
	        // does not encode/decode
	        any: makeDefaultType({
	            encode: common_1.identity,
	            decode: common_1.identity,
	            is: function () { return true; },
	            equals: common_1.equals,
	        }),
	    });
	}
	initDefaultTypes();
	//# sourceMappingURL=paramTypes.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(39), exports);
	__exportStar(__webpack_require__(21), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 121 */
118,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # Transition subsystem
	 *
	 * This module contains APIs related to a Transition.
	 *
	 * See:
	 * - [[TransitionService]]
	 * - [[Transition]]
	 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
	 *
	 * @packageDocumentation @preferred
	 */
	__exportStar(__webpack_require__(11), exports);
	__exportStar(__webpack_require__(61), exports);
	__exportStar(__webpack_require__(42), exports);
	__exportStar(__webpack_require__(12), exports);
	__exportStar(__webpack_require__(43), exports);
	__exportStar(__webpack_require__(18), exports);
	__exportStar(__webpack_require__(62), exports);
	__exportStar(__webpack_require__(44), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(124), exports);
	__exportStar(__webpack_require__(24), exports);
	__exportStar(__webpack_require__(64), exports);
	__exportStar(__webpack_require__(65), exports);
	__exportStar(__webpack_require__(45), exports);
	__exportStar(__webpack_require__(67), exports);
	var urlRules_1 = __webpack_require__(66);
	Object.defineProperty(exports, "UrlRules", { enumerable: true, get: function () { return urlRules_1.UrlRules; } });
	var urlConfig_1 = __webpack_require__(63);
	Object.defineProperty(exports, "UrlConfig", { enumerable: true, get: function () { return urlConfig_1.UrlConfig; } });
	//# sourceMappingURL=index.js.map

/***/ }),
/* 124 */
118,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(126), exports);
	//# sourceMappingURL=vanilla.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Naive, pure JS implementation of core ui-router services
	 *
	 * @packageDocumentation
	 */
	__exportStar(__webpack_require__(127), exports);
	__exportStar(__webpack_require__(74), exports);
	__exportStar(__webpack_require__(70), exports);
	__exportStar(__webpack_require__(25), exports);
	__exportStar(__webpack_require__(69), exports);
	__exportStar(__webpack_require__(72), exports);
	__exportStar(__webpack_require__(73), exports);
	__exportStar(__webpack_require__(71), exports);
	__exportStar(__webpack_require__(68), exports);
	__exportStar(__webpack_require__(46), exports);
	__exportStar(__webpack_require__(128), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 127 */
118,
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.memoryLocationPlugin = exports.pushStateLocationPlugin = exports.hashLocationPlugin = exports.servicesPlugin = void 0;
	var browserLocationConfig_1 = __webpack_require__(68);
	var hashLocationService_1 = __webpack_require__(69);
	var utils_1 = __webpack_require__(46);
	var pushStateLocationService_1 = __webpack_require__(73);
	var memoryLocationService_1 = __webpack_require__(72);
	var memoryLocationConfig_1 = __webpack_require__(71);
	var injector_1 = __webpack_require__(70);
	var q_1 = __webpack_require__(74);
	var coreservices_1 = __webpack_require__(5);
	function servicesPlugin(router) {
	    coreservices_1.services.$injector = injector_1.$injector;
	    coreservices_1.services.$q = q_1.$q;
	    return { name: 'vanilla.services', $q: q_1.$q, $injector: injector_1.$injector, dispose: function () { return null; } };
	}
	exports.servicesPlugin = servicesPlugin;
	/** A `UIRouterPlugin` uses the browser hash to get/set the current location */
	exports.hashLocationPlugin = utils_1.locationPluginFactory('vanilla.hashBangLocation', false, hashLocationService_1.HashLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location using the browser's `location` and `history` apis */
	exports.pushStateLocationPlugin = utils_1.locationPluginFactory('vanilla.pushStateLocation', true, pushStateLocationService_1.PushStateLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location from an in-memory object */
	exports.memoryLocationPlugin = utils_1.locationPluginFactory('vanilla.memoryLocation', false, memoryLocationService_1.MemoryLocationService, memoryLocationConfig_1.MemoryLocationConfig);
	//# sourceMappingURL=plugins.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(130), exports);
	__exportStar(__webpack_require__(75), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 130 */
118,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 angular-file-upload v2.6.1
	 https://github.com/nervgh/angular-file-upload
	*/
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["angular-file-upload"] = factory();
		else
			root["angular-file-upload"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		var _options = __webpack_require__(2);
		
		var _options2 = _interopRequireDefault(_options);
		
		var _FileUploader = __webpack_require__(3);
		
		var _FileUploader2 = _interopRequireDefault(_FileUploader);
		
		var _FileLikeObject = __webpack_require__(4);
		
		var _FileLikeObject2 = _interopRequireDefault(_FileLikeObject);
		
		var _FileItem = __webpack_require__(5);
		
		var _FileItem2 = _interopRequireDefault(_FileItem);
		
		var _FileDirective = __webpack_require__(6);
		
		var _FileDirective2 = _interopRequireDefault(_FileDirective);
		
		var _FileSelect = __webpack_require__(7);
		
		var _FileSelect2 = _interopRequireDefault(_FileSelect);
		
		var _Pipeline = __webpack_require__(8);
		
		var _Pipeline2 = _interopRequireDefault(_Pipeline);
		
		var _FileDrop = __webpack_require__(9);
		
		var _FileDrop2 = _interopRequireDefault(_FileDrop);
		
		var _FileOver = __webpack_require__(10);
		
		var _FileOver2 = _interopRequireDefault(_FileOver);
		
		var _FileSelect3 = __webpack_require__(11);
		
		var _FileSelect4 = _interopRequireDefault(_FileSelect3);
		
		var _FileDrop3 = __webpack_require__(12);
		
		var _FileDrop4 = _interopRequireDefault(_FileDrop3);
		
		var _FileOver3 = __webpack_require__(13);
		
		var _FileOver4 = _interopRequireDefault(_FileOver3);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		angular.module(_config2.default.name, []).value('fileUploaderOptions', _options2.default).factory('FileUploader', _FileUploader2.default).factory('FileLikeObject', _FileLikeObject2.default).factory('FileItem', _FileItem2.default).factory('FileDirective', _FileDirective2.default).factory('FileSelect', _FileSelect2.default).factory('FileDrop', _FileDrop2.default).factory('FileOver', _FileOver2.default).factory('Pipeline', _Pipeline2.default).directive('nvFileSelect', _FileSelect4.default).directive('nvFileDrop', _FileDrop4.default).directive('nvFileOver', _FileOver4.default).run(['FileUploader', 'FileLikeObject', 'FileItem', 'FileDirective', 'FileSelect', 'FileDrop', 'FileOver', 'Pipeline', function (FileUploader, FileLikeObject, FileItem, FileDirective, FileSelect, FileDrop, FileOver, Pipeline) {
		    // only for compatibility
		    FileUploader.FileLikeObject = FileLikeObject;
		    FileUploader.FileItem = FileItem;
		    FileUploader.FileDirective = FileDirective;
		    FileUploader.FileSelect = FileSelect;
		    FileUploader.FileDrop = FileDrop;
		    FileUploader.FileOver = FileOver;
		    FileUploader.Pipeline = Pipeline;
		}]);
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = {"name":"angularFileUpload"}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = {
		    url: '/',
		    alias: 'file',
		    headers: {},
		    queue: [],
		    progress: 0,
		    autoUpload: false,
		    removeAfterUpload: false,
		    method: 'POST',
		    filters: [],
		    formData: [],
		    queueLimit: Number.MAX_VALUE,
		    withCredentials: false,
		    disableMultipart: false
		};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    bind = _angular.bind,
		    copy = _angular.copy,
		    extend = _angular.extend,
		    forEach = _angular.forEach,
		    isObject = _angular.isObject,
		    isNumber = _angular.isNumber,
		    isDefined = _angular.isDefined,
		    isArray = _angular.isArray,
		    isUndefined = _angular.isUndefined,
		    element = _angular.element;
		function __identity(fileUploaderOptions, $rootScope, $http, $window, $timeout, FileLikeObject, FileItem, Pipeline) {
		    var File = $window.File,
		        FormData = $window.FormData;
		
		    var FileUploader = function () {
		        /**********************
		         * PUBLIC
		         **********************/
		        /**
		         * Creates an instance of FileUploader
		         * @param {Object} [options]
		         * @constructor
		         */
		        function FileUploader(options) {
		            _classCallCheck(this, FileUploader);
		
		            var settings = copy(fileUploaderOptions);
		
		            extend(this, settings, options, {
		                isUploading: false,
		                _nextIndex: 0,
		                _directives: { select: [], drop: [], over: [] }
		            });
		
		            // add default filters
		            this.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
		            this.filters.unshift({ name: 'folder', fn: this._folderFilter });
		        }
		        /**
		         * Adds items to the queue
		         * @param {File|HTMLInputElement|Object|FileList|Array<Object>} files
		         * @param {Object} [options]
		         * @param {Array<Function>|String} filters
		         */
		
		
		        FileUploader.prototype.addToQueue = function addToQueue(files, options, filters) {
		            var _this = this;
		
		            var incomingQueue = this.isArrayLikeObject(files) ? Array.prototype.slice.call(files) : [files];
		            var arrayOfFilters = this._getFilters(filters);
		            var count = this.queue.length;
		            var addedFileItems = [];
		
		            var next = function next() {
		                var something = incomingQueue.shift();
		
		                if (isUndefined(something)) {
		                    return done();
		                }
		
		                var fileLikeObject = _this.isFile(something) ? something : new FileLikeObject(something);
		                var pipes = _this._convertFiltersToPipes(arrayOfFilters);
		                var pipeline = new Pipeline(pipes);
		                var onThrown = function onThrown(err) {
		                    var originalFilter = err.pipe.originalFilter;
		
		                    var _err$args = _slicedToArray(err.args, 2),
		                        fileLikeObject = _err$args[0],
		                        options = _err$args[1];
		
		                    _this._onWhenAddingFileFailed(fileLikeObject, originalFilter, options);
		                    next();
		                };
		                var onSuccessful = function onSuccessful(fileLikeObject, options) {
		                    var fileItem = new FileItem(_this, fileLikeObject, options);
		                    addedFileItems.push(fileItem);
		                    _this.queue.push(fileItem);
		                    _this._onAfterAddingFile(fileItem);
		                    next();
		                };
		                pipeline.onThrown = onThrown;
		                pipeline.onSuccessful = onSuccessful;
		                pipeline.exec(fileLikeObject, options);
		            };
		
		            var done = function done() {
		                if (_this.queue.length !== count) {
		                    _this._onAfterAddingAll(addedFileItems);
		                    _this.progress = _this._getTotalProgress();
		                }
		
		                _this._render();
		                if (_this.autoUpload) _this.uploadAll();
		            };
		
		            next();
		        };
		        /**
		         * Remove items from the queue. Remove last: index = -1
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.removeFromQueue = function removeFromQueue(value) {
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            if (item.isUploading) item.cancel();
		            this.queue.splice(index, 1);
		            item._destroy();
		            this.progress = this._getTotalProgress();
		        };
		        /**
		         * Clears the queue
		         */
		
		
		        FileUploader.prototype.clearQueue = function clearQueue() {
		            while (this.queue.length) {
		                this.queue[0].remove();
		            }
		            this.progress = 0;
		        };
		        /**
		         * Uploads a item from the queue
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.uploadItem = function uploadItem(value) {
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            var transport = this.isHTML5 ? '_xhrTransport' : '_iframeTransport';
		
		            item._prepareToUploading();
		            if (this.isUploading) return;
		
		            this._onBeforeUploadItem(item);
		            if (item.isCancel) return;
		
		            item.isUploading = true;
		            this.isUploading = true;
		            this[transport](item);
		            this._render();
		        };
		        /**
		         * Cancels uploading of item from the queue
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.cancelItem = function cancelItem(value) {
		            var _this2 = this;
		
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            var prop = this.isHTML5 ? '_xhr' : '_form';
		            if (!item) return;
		            item.isCancel = true;
		            if (item.isUploading) {
		                // It will call this._onCancelItem() & this._onCompleteItem() asynchronously
		                item[prop].abort();
		            } else {
		                var dummy = [undefined, 0, {}];
		                var onNextTick = function onNextTick() {
		                    _this2._onCancelItem.apply(_this2, [item].concat(dummy));
		                    _this2._onCompleteItem.apply(_this2, [item].concat(dummy));
		                };
		                $timeout(onNextTick); // Trigger callbacks asynchronously (setImmediate emulation)
		            }
		        };
		        /**
		         * Uploads all not uploaded items of queue
		         */
		
		
		        FileUploader.prototype.uploadAll = function uploadAll() {
		            var items = this.getNotUploadedItems().filter(function (item) {
		                return !item.isUploading;
		            });
		            if (!items.length) return;
		
		            forEach(items, function (item) {
		                return item._prepareToUploading();
		            });
		            items[0].upload();
		        };
		        /**
		         * Cancels all uploads
		         */
		
		
		        FileUploader.prototype.cancelAll = function cancelAll() {
		            var items = this.getNotUploadedItems();
		            forEach(items, function (item) {
		                return item.cancel();
		            });
		        };
		        /**
		         * Returns "true" if value an instance of File
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype.isFile = function isFile(value) {
		            return this.constructor.isFile(value);
		        };
		        /**
		         * Returns "true" if value an instance of FileLikeObject
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype.isFileLikeObject = function isFileLikeObject(value) {
		            return this.constructor.isFileLikeObject(value);
		        };
		        /**
		         * Returns "true" if value is array like object
		         * @param {*} value
		         * @returns {Boolean}
		         */
		
		
		        FileUploader.prototype.isArrayLikeObject = function isArrayLikeObject(value) {
		            return this.constructor.isArrayLikeObject(value);
		        };
		        /**
		         * Returns a index of item from the queue
		         * @param {Item|Number} value
		         * @returns {Number}
		         */
		
		
		        FileUploader.prototype.getIndexOfItem = function getIndexOfItem(value) {
		            return isNumber(value) ? value : this.queue.indexOf(value);
		        };
		        /**
		         * Returns not uploaded items
		         * @returns {Array}
		         */
		
		
		        FileUploader.prototype.getNotUploadedItems = function getNotUploadedItems() {
		            return this.queue.filter(function (item) {
		                return !item.isUploaded;
		            });
		        };
		        /**
		         * Returns items ready for upload
		         * @returns {Array}
		         */
		
		
		        FileUploader.prototype.getReadyItems = function getReadyItems() {
		            return this.queue.filter(function (item) {
		                return item.isReady && !item.isUploading;
		            }).sort(function (item1, item2) {
		                return item1.index - item2.index;
		            });
		        };
		        /**
		         * Destroys instance of FileUploader
		         */
		
		
		        FileUploader.prototype.destroy = function destroy() {
		            var _this3 = this;
		
		            forEach(this._directives, function (key) {
		                forEach(_this3._directives[key], function (object) {
		                    object.destroy();
		                });
		            });
		        };
		        /**
		         * Callback
		         * @param {Array} fileItems
		         */
		
		
		        FileUploader.prototype.onAfterAddingAll = function onAfterAddingAll(fileItems) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         */
		
		
		        FileUploader.prototype.onAfterAddingFile = function onAfterAddingFile(fileItem) {};
		        /**
		         * Callback
		         * @param {File|Object} item
		         * @param {Object} filter
		         * @param {Object} options
		         */
		
		
		        FileUploader.prototype.onWhenAddingFileFailed = function onWhenAddingFileFailed(item, filter, options) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         */
		
		
		        FileUploader.prototype.onBeforeUploadItem = function onBeforeUploadItem(fileItem) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         * @param {Number} progress
		         */
		
		
		        FileUploader.prototype.onProgressItem = function onProgressItem(fileItem, progress) {};
		        /**
		         * Callback
		         * @param {Number} progress
		         */
		
		
		        FileUploader.prototype.onProgressAll = function onProgressAll(progress) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onSuccessItem = function onSuccessItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onErrorItem = function onErrorItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onCancelItem = function onCancelItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onCompleteItem = function onCompleteItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         */
		
		
		        FileUploader.prototype.onTimeoutItem = function onTimeoutItem(item) {};
		        /**
		         * Callback
		         */
		
		
		        FileUploader.prototype.onCompleteAll = function onCompleteAll() {};
		        /**********************
		         * PRIVATE
		         **********************/
		        /**
		         * Returns the total progress
		         * @param {Number} [value]
		         * @returns {Number}
		         * @private
		         */
		
		
		        FileUploader.prototype._getTotalProgress = function _getTotalProgress(value) {
		            if (this.removeAfterUpload) return value || 0;
		
		            var notUploaded = this.getNotUploadedItems().length;
		            var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
		            var ratio = 100 / this.queue.length;
		            var current = (value || 0) * ratio / 100;
		
		            return Math.round(uploaded * ratio + current);
		        };
		        /**
		         * Returns array of filters
		         * @param {Array<Function>|String} filters
		         * @returns {Array<Function>}
		         * @private
		         */
		
		
		        FileUploader.prototype._getFilters = function _getFilters(filters) {
		            if (!filters) return this.filters;
		            if (isArray(filters)) return filters;
		            var names = filters.match(/[^\s,]+/g);
		            return this.filters.filter(function (filter) {
		                return names.indexOf(filter.name) !== -1;
		            });
		        };
		        /**
		        * @param {Array<Function>} filters
		        * @returns {Array<Function>}
		        * @private
		        */
		
		
		        FileUploader.prototype._convertFiltersToPipes = function _convertFiltersToPipes(filters) {
		            var _this4 = this;
		
		            return filters.map(function (filter) {
		                var fn = bind(_this4, filter.fn);
		                fn.isAsync = filter.fn.length === 3;
		                fn.originalFilter = filter;
		                return fn;
		            });
		        };
		        /**
		         * Updates html
		         * @private
		         */
		
		
		        FileUploader.prototype._render = function _render() {
		            if (!$rootScope.$$phase) $rootScope.$apply();
		        };
		        /**
		         * Returns "true" if item is a file (not folder)
		         * @param {File|FileLikeObject} item
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._folderFilter = function _folderFilter(item) {
		            return !!(item.size || item.type);
		        };
		        /**
		         * Returns "true" if the limit has not been reached
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._queueLimitFilter = function _queueLimitFilter() {
		            return this.queue.length < this.queueLimit;
		        };
		        /**
		         * Checks whether upload successful
		         * @param {Number} status
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._isSuccessCode = function _isSuccessCode(status) {
		            return status >= 200 && status < 300 || status === 304;
		        };
		        /**
		         * Transforms the server response
		         * @param {*} response
		         * @param {Object} headers
		         * @returns {*}
		         * @private
		         */
		
		
		        FileUploader.prototype._transformResponse = function _transformResponse(response, headers) {
		            var headersGetter = this._headersGetter(headers);
		            forEach($http.defaults.transformResponse, function (transformFn) {
		                response = transformFn(response, headersGetter);
		            });
		            return response;
		        };
		        /**
		         * Parsed response headers
		         * @param headers
		         * @returns {Object}
		         * @see https://github.com/angular/angular.js/blob/master/src/ng/http.js
		         * @private
		         */
		
		
		        FileUploader.prototype._parseHeaders = function _parseHeaders(headers) {
		            var parsed = {},
		                key,
		                val,
		                i;
		
		            if (!headers) return parsed;
		
		            forEach(headers.split('\n'), function (line) {
		                i = line.indexOf(':');
		                key = line.slice(0, i).trim().toLowerCase();
		                val = line.slice(i + 1).trim();
		
		                if (key) {
		                    parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
		                }
		            });
		
		            return parsed;
		        };
		        /**
		         * Returns function that returns headers
		         * @param {Object} parsedHeaders
		         * @returns {Function}
		         * @private
		         */
		
		
		        FileUploader.prototype._headersGetter = function _headersGetter(parsedHeaders) {
		            return function (name) {
		                if (name) {
		                    return parsedHeaders[name.toLowerCase()] || null;
		                }
		                return parsedHeaders;
		            };
		        };
		        /**
		         * The XMLHttpRequest transport
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._xhrTransport = function _xhrTransport(item) {
		            var _this5 = this;
		
		            var xhr = item._xhr = new XMLHttpRequest();
		            var sendable;
		
		            if (!item.disableMultipart) {
		                sendable = new FormData();
		                forEach(item.formData, function (obj) {
		                    forEach(obj, function (value, key) {
		                        sendable.append(key, value);
		                    });
		                });
		
		                sendable.append(item.alias, item._file, item.file.name);
		            } else {
		                sendable = item._file;
		            }
		
		            if (typeof item._file.size != 'number') {
		                throw new TypeError('The file specified is no longer valid');
		            }
		
		            xhr.upload.onprogress = function (event) {
		                var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
		                _this5._onProgressItem(item, progress);
		            };
		
		            xhr.onload = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                var gist = _this5._isSuccessCode(xhr.status) ? 'Success' : 'Error';
		                var method = '_on' + gist + 'Item';
		                _this5[method](item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.onerror = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                _this5._onErrorItem(item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.onabort = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                _this5._onCancelItem(item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.ontimeout = function (e) {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = "Request Timeout.";
		                _this5._onTimeoutItem(item);
		                _this5._onCompleteItem(item, response, 408, headers);
		            };
		
		            xhr.open(item.method, item.url, true);
		
		            xhr.timeout = item.timeout || 0;
		            xhr.withCredentials = item.withCredentials;
		
		            forEach(item.headers, function (value, name) {
		                xhr.setRequestHeader(name, value);
		            });
		
		            xhr.send(sendable);
		        };
		        /**
		         * The IFrame transport
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._iframeTransport = function _iframeTransport(item) {
		            var _this6 = this;
		
		            var form = element('<form style="display: none;" />');
		            var iframe = element('<iframe name="iframeTransport' + Date.now() + '">');
		            var input = item._input;
		
		            var timeout = 0;
		            var timer = null;
		            var isTimedOut = false;
		
		            if (item._form) item._form.replaceWith(input); // remove old form
		            item._form = form; // save link to new form
		
		            input.prop('name', item.alias);
		
		            forEach(item.formData, function (obj) {
		                forEach(obj, function (value, key) {
		                    var element_ = element('<input type="hidden" name="' + key + '" />');
		                    element_.val(value);
		                    form.append(element_);
		                });
		            });
		
		            form.prop({
		                action: item.url,
		                method: 'POST',
		                target: iframe.prop('name'),
		                enctype: 'multipart/form-data',
		                encoding: 'multipart/form-data' // old IE
		            });
		
		            iframe.bind('load', function () {
		                var html = '';
		                var status = 200;
		
		                try {
		                    // Fix for legacy IE browsers that loads internal error page
		                    // when failed WS response received. In consequence iframe
		                    // content access denied error is thrown becouse trying to
		                    // access cross domain page. When such thing occurs notifying
		                    // with empty response object. See more info at:
		                    // http://stackoverflow.com/questions/151362/access-is-denied-error-on-accessing-iframe-document-object
		                    // Note that if non standard 4xx or 5xx error code returned
		                    // from WS then response content can be accessed without error
		                    // but 'XHR' status becomes 200. In order to avoid confusion
		                    // returning response via same 'success' event handler.
		
		                    // fixed angular.contents() for iframes
		                    html = iframe[0].contentDocument.body.innerHTML;
		                } catch (e) {
		                    // in case we run into the access-is-denied error or we have another error on the server side
		                    // (intentional 500,40... errors), we at least say 'something went wrong' -> 500
		                    status = 500;
		                }
		
		                if (timer) {
		                    clearTimeout(timer);
		                }
		                timer = null;
		
		                if (isTimedOut) {
		                    return false; //throw 'Request Timeout'
		                }
		
		                var xhr = { response: html, status: status, dummy: true };
		                var headers = {};
		                var response = _this6._transformResponse(xhr.response, headers);
		
		                _this6._onSuccessItem(item, response, xhr.status, headers);
		                _this6._onCompleteItem(item, response, xhr.status, headers);
		            });
		
		            form.abort = function () {
		                var xhr = { status: 0, dummy: true };
		                var headers = {};
		                var response;
		
		                iframe.unbind('load').prop('src', 'javascript:false;');
		                form.replaceWith(input);
		
		                _this6._onCancelItem(item, response, xhr.status, headers);
		                _this6._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            input.after(form);
		            form.append(input).append(iframe);
		
		            timeout = item.timeout || 0;
		            timer = null;
		
		            if (timeout) {
		                timer = setTimeout(function () {
		                    isTimedOut = true;
		
		                    item.isCancel = true;
		                    if (item.isUploading) {
		                        iframe.unbind('load').prop('src', 'javascript:false;');
		                        form.replaceWith(input);
		                    }
		
		                    var headers = {};
		                    var response = "Request Timeout.";
		                    _this6._onTimeoutItem(item);
		                    _this6._onCompleteItem(item, response, 408, headers);
		                }, timeout);
		            }
		
		            form[0].submit();
		        };
		        /**
		         * Inner callback
		         * @param {File|Object} item
		         * @param {Object} filter
		         * @param {Object} options
		         * @private
		         */
		
		
		        FileUploader.prototype._onWhenAddingFileFailed = function _onWhenAddingFileFailed(item, filter, options) {
		            this.onWhenAddingFileFailed(item, filter, options);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         */
		
		
		        FileUploader.prototype._onAfterAddingFile = function _onAfterAddingFile(item) {
		            this.onAfterAddingFile(item);
		        };
		        /**
		         * Inner callback
		         * @param {Array<FileItem>} items
		         */
		
		
		        FileUploader.prototype._onAfterAddingAll = function _onAfterAddingAll(items) {
		            this.onAfterAddingAll(items);
		        };
		        /**
		         *  Inner callback
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._onBeforeUploadItem = function _onBeforeUploadItem(item) {
		            item._onBeforeUpload();
		            this.onBeforeUploadItem(item);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {Number} progress
		         * @private
		         */
		
		
		        FileUploader.prototype._onProgressItem = function _onProgressItem(item, progress) {
		            var total = this._getTotalProgress(progress);
		            this.progress = total;
		            item._onProgress(progress);
		            this.onProgressItem(item, progress);
		            this.onProgressAll(total);
		            this._render();
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onSuccessItem = function _onSuccessItem(item, response, status, headers) {
		            item._onSuccess(response, status, headers);
		            this.onSuccessItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onErrorItem = function _onErrorItem(item, response, status, headers) {
		            item._onError(response, status, headers);
		            this.onErrorItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onCancelItem = function _onCancelItem(item, response, status, headers) {
		            item._onCancel(response, status, headers);
		            this.onCancelItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onCompleteItem = function _onCompleteItem(item, response, status, headers) {
		            item._onComplete(response, status, headers);
		            this.onCompleteItem(item, response, status, headers);
		
		            var nextItem = this.getReadyItems()[0];
		            this.isUploading = false;
		
		            if (isDefined(nextItem)) {
		                nextItem.upload();
		                return;
		            }
		
		            this.onCompleteAll();
		            this.progress = this._getTotalProgress();
		            this._render();
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._onTimeoutItem = function _onTimeoutItem(item) {
		            item._onTimeout();
		            this.onTimeoutItem(item);
		        };
		        /**********************
		         * STATIC
		         **********************/
		        /**
		         * Returns "true" if value an instance of File
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.isFile = function isFile(value) {
		            return File && value instanceof File;
		        };
		        /**
		         * Returns "true" if value an instance of FileLikeObject
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.isFileLikeObject = function isFileLikeObject(value) {
		            return value instanceof FileLikeObject;
		        };
		        /**
		         * Returns "true" if value is array like object
		         * @param {*} value
		         * @returns {Boolean}
		         */
		
		
		        FileUploader.isArrayLikeObject = function isArrayLikeObject(value) {
		            return isObject(value) && 'length' in value;
		        };
		        /**
		         * Inherits a target (Class_1) by a source (Class_2)
		         * @param {Function} target
		         * @param {Function} source
		         */
		
		
		        FileUploader.inherit = function inherit(target, source) {
		            target.prototype = Object.create(source.prototype);
		            target.prototype.constructor = target;
		            target.super_ = source;
		        };
		
		        return FileUploader;
		    }();
		
		    /**********************
		     * PUBLIC
		     **********************/
		    /**
		     * Checks a support the html5 uploader
		     * @returns {Boolean}
		     * @readonly
		     */
		
		
		    FileUploader.prototype.isHTML5 = !!(File && FormData);
		    /**********************
		     * STATIC
		     **********************/
		    /**
		     * @borrows FileUploader.prototype.isHTML5
		     */
		    FileUploader.isHTML5 = FileUploader.prototype.isHTML5;
		
		    return FileUploader;
		}
		
		__identity.$inject = ['fileUploaderOptions', '$rootScope', '$http', '$window', '$timeout', 'FileLikeObject', 'FileItem', 'Pipeline'];
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    copy = _angular.copy,
		    isElement = _angular.isElement,
		    isString = _angular.isString;
		function __identity() {
		
		    return function () {
		        /**
		         * Creates an instance of FileLikeObject
		         * @param {File|HTMLInputElement|Object} fileOrInput
		         * @constructor
		         */
		        function FileLikeObject(fileOrInput) {
		            _classCallCheck(this, FileLikeObject);
		
		            var isInput = isElement(fileOrInput);
		            var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
		            var postfix = isString(fakePathOrObject) ? 'FakePath' : 'Object';
		            var method = '_createFrom' + postfix;
		            this[method](fakePathOrObject, fileOrInput);
		        }
		        /**
		         * Creates file like object from fake path string
		         * @param {String} path
		         * @private
		         */
		
		
		        FileLikeObject.prototype._createFromFakePath = function _createFromFakePath(path, input) {
		            this.lastModifiedDate = null;
		            this.size = null;
		            this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
		            this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
		            this.input = input;
		        };
		        /**
		         * Creates file like object from object
		         * @param {File|FileLikeObject} object
		         * @private
		         */
		
		
		        FileLikeObject.prototype._createFromObject = function _createFromObject(object) {
		            this.lastModifiedDate = copy(object.lastModifiedDate);
		            this.size = object.size;
		            this.type = object.type;
		            this.name = object.name;
		            this.input = object.input;
		        };
		
		        return FileLikeObject;
		    }();
		}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    copy = _angular.copy,
		    extend = _angular.extend,
		    element = _angular.element,
		    isElement = _angular.isElement;
		function __identity($compile, FileLikeObject) {
		
		  return function () {
		    /**
		     * Creates an instance of FileItem
		     * @param {FileUploader} uploader
		     * @param {File|HTMLInputElement|Object} some
		     * @param {Object} options
		     * @constructor
		     */
		    function FileItem(uploader, some, options) {
		      _classCallCheck(this, FileItem);
		
		      var isInput = !!some.input;
		      var input = isInput ? element(some.input) : null;
		      var file = !isInput ? some : null;
		
		      extend(this, {
		        url: uploader.url,
		        alias: uploader.alias,
		        headers: copy(uploader.headers),
		        formData: copy(uploader.formData),
		        removeAfterUpload: uploader.removeAfterUpload,
		        withCredentials: uploader.withCredentials,
		        disableMultipart: uploader.disableMultipart,
		        method: uploader.method,
		        timeout: uploader.timeout
		      }, options, {
		        uploader: uploader,
		        file: new FileLikeObject(some),
		        isReady: false,
		        isUploading: false,
		        isUploaded: false,
		        isSuccess: false,
		        isCancel: false,
		        isError: false,
		        progress: 0,
		        index: null,
		        _file: file,
		        _input: input
		      });
		
		      if (input) this._replaceNode(input);
		    }
		    /**********************
		     * PUBLIC
		     **********************/
		    /**
		     * Uploads a FileItem
		     */
		
		
		    FileItem.prototype.upload = function upload() {
		      try {
		        this.uploader.uploadItem(this);
		      } catch (e) {
		        var message = e.name + ':' + e.message;
		        this.uploader._onCompleteItem(this, message, e.code, []);
		        this.uploader._onErrorItem(this, message, e.code, []);
		      }
		    };
		    /**
		     * Cancels uploading of FileItem
		     */
		
		
		    FileItem.prototype.cancel = function cancel() {
		      this.uploader.cancelItem(this);
		    };
		    /**
		     * Removes a FileItem
		     */
		
		
		    FileItem.prototype.remove = function remove() {
		      this.uploader.removeFromQueue(this);
		    };
		    /**
		     * Callback
		     * @private
		     */
		
		
		    FileItem.prototype.onBeforeUpload = function onBeforeUpload() {};
		    /**
		     * Callback
		     * @param {Number} progress
		     * @private
		     */
		
		
		    FileItem.prototype.onProgress = function onProgress(progress) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onSuccess = function onSuccess(response, status, headers) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onError = function onError(response, status, headers) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onCancel = function onCancel(response, status, headers) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onComplete = function onComplete(response, status, headers) {};
		    /**
		     * Callback         
		     */
		
		
		    FileItem.prototype.onTimeout = function onTimeout() {};
		    /**********************
		     * PRIVATE
		     **********************/
		    /**
		     * Inner callback
		     */
		
		
		    FileItem.prototype._onBeforeUpload = function _onBeforeUpload() {
		      this.isReady = true;
		      this.isUploading = false;
		      this.isUploaded = false;
		      this.isSuccess = false;
		      this.isCancel = false;
		      this.isError = false;
		      this.progress = 0;
		      this.onBeforeUpload();
		    };
		    /**
		     * Inner callback
		     * @param {Number} progress
		     * @private
		     */
		
		
		    FileItem.prototype._onProgress = function _onProgress(progress) {
		      this.progress = progress;
		      this.onProgress(progress);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onSuccess = function _onSuccess(response, status, headers) {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = true;
		      this.isSuccess = true;
		      this.isCancel = false;
		      this.isError = false;
		      this.progress = 100;
		      this.index = null;
		      this.onSuccess(response, status, headers);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onError = function _onError(response, status, headers) {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = true;
		      this.isSuccess = false;
		      this.isCancel = false;
		      this.isError = true;
		      this.progress = 0;
		      this.index = null;
		      this.onError(response, status, headers);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onCancel = function _onCancel(response, status, headers) {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = false;
		      this.isSuccess = false;
		      this.isCancel = true;
		      this.isError = false;
		      this.progress = 0;
		      this.index = null;
		      this.onCancel(response, status, headers);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onComplete = function _onComplete(response, status, headers) {
		      this.onComplete(response, status, headers);
		      if (this.removeAfterUpload) this.remove();
		    };
		    /**
		     * Inner callback         
		     * @private
		     */
		
		
		    FileItem.prototype._onTimeout = function _onTimeout() {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = false;
		      this.isSuccess = false;
		      this.isCancel = false;
		      this.isError = true;
		      this.progress = 0;
		      this.index = null;
		      this.onTimeout();
		    };
		    /**
		     * Destroys a FileItem
		     */
		
		
		    FileItem.prototype._destroy = function _destroy() {
		      if (this._input) this._input.remove();
		      if (this._form) this._form.remove();
		      delete this._form;
		      delete this._input;
		    };
		    /**
		     * Prepares to uploading
		     * @private
		     */
		
		
		    FileItem.prototype._prepareToUploading = function _prepareToUploading() {
		      this.index = this.index || ++this.uploader._nextIndex;
		      this.isReady = true;
		    };
		    /**
		     * Replaces input element on his clone
		     * @param {JQLite|jQuery} input
		     * @private
		     */
		
		
		    FileItem.prototype._replaceNode = function _replaceNode(input) {
		      var clone = $compile(input.clone())(input.scope());
		      clone.prop('value', null); // FF fix
		      input.css('display', 'none');
		      input.after(clone); // remove jquery dependency
		    };
		
		    return FileItem;
		  }();
		}
		
		__identity.$inject = ['$compile', 'FileLikeObject'];
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    extend = _angular.extend;
		function __identity() {
		    var FileDirective = function () {
		        /**
		         * Creates instance of {FileDirective} object
		         * @param {Object} options
		         * @param {Object} options.uploader
		         * @param {HTMLElement} options.element
		         * @param {Object} options.events
		         * @param {String} options.prop
		         * @constructor
		         */
		        function FileDirective(options) {
		            _classCallCheck(this, FileDirective);
		
		            extend(this, options);
		            this.uploader._directives[this.prop].push(this);
		            this._saveLinks();
		            this.bind();
		        }
		        /**
		         * Binds events handles
		         */
		
		
		        FileDirective.prototype.bind = function bind() {
		            for (var key in this.events) {
		                var prop = this.events[key];
		                this.element.bind(key, this[prop]);
		            }
		        };
		        /**
		         * Unbinds events handles
		         */
		
		
		        FileDirective.prototype.unbind = function unbind() {
		            for (var key in this.events) {
		                this.element.unbind(key, this.events[key]);
		            }
		        };
		        /**
		         * Destroys directive
		         */
		
		
		        FileDirective.prototype.destroy = function destroy() {
		            var index = this.uploader._directives[this.prop].indexOf(this);
		            this.uploader._directives[this.prop].splice(index, 1);
		            this.unbind();
		            // this.element = null;
		        };
		        /**
		         * Saves links to functions
		         * @private
		         */
		
		
		        FileDirective.prototype._saveLinks = function _saveLinks() {
		            for (var key in this.events) {
		                var prop = this.events[key];
		                this[prop] = this[prop].bind(this);
		            }
		        };
		
		        return FileDirective;
		    }();
		
		    /**
		     * Map of events
		     * @type {Object}
		     */
		
		
		    FileDirective.prototype.events = {};
		
		    return FileDirective;
		}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular,
		    extend = _angular.extend;
		function __identity($compile, FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileSelect, _FileDirective);
		
		        /**
		         * Creates instance of {FileSelect} object
		         * @param {Object} options
		         * @constructor
		         */
		        function FileSelect(options) {
		            _classCallCheck(this, FileSelect);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy',
		                    change: 'onChange'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'select'
		            });
		
		            var _this = _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		
		            if (!_this.uploader.isHTML5) {
		                _this.element.removeAttr('multiple');
		            }
		            _this.element.prop('value', null); // FF fix
		            return _this;
		        }
		        /**
		         * Returns options
		         * @return {Object|undefined}
		         */
		
		
		        FileSelect.prototype.getOptions = function getOptions() {};
		        /**
		         * Returns filters
		         * @return {Array<Function>|String|undefined}
		         */
		
		
		        FileSelect.prototype.getFilters = function getFilters() {};
		        /**
		         * If returns "true" then HTMLInputElement will be cleared
		         * @returns {Boolean}
		         */
		
		
		        FileSelect.prototype.isEmptyAfterSelection = function isEmptyAfterSelection() {
		            return !!this.element.attr('multiple');
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileSelect.prototype.onChange = function onChange() {
		            var files = this.uploader.isHTML5 ? this.element[0].files : this.element[0];
		            var options = this.getOptions();
		            var filters = this.getFilters();
		
		            if (!this.uploader.isHTML5) this.destroy();
		            this.uploader.addToQueue(files, options, filters);
		            if (this.isEmptyAfterSelection()) {
		                this.element.prop('value', null);
		                this.element.replaceWith($compile(this.element.clone())(this.scope)); // IE fix
		            }
		        };
		
		        return FileSelect;
		    }(FileDirective);
		}
		
		__identity.$inject = ['$compile', 'FileDirective'];
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = __identity;
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    bind = _angular.bind,
		    isUndefined = _angular.isUndefined;
		function __identity($q) {
		
		  return function () {
		    /**
		     * @param {Array<Function>} pipes
		     */
		    function Pipeline() {
		      var pipes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		
		      _classCallCheck(this, Pipeline);
		
		      this.pipes = pipes;
		    }
		
		    Pipeline.prototype.next = function next(args) {
		      var pipe = this.pipes.shift();
		      if (isUndefined(pipe)) {
		        this.onSuccessful.apply(this, _toConsumableArray(args));
		        return;
		      }
		      var err = new Error('The filter has not passed');
		      err.pipe = pipe;
		      err.args = args;
		      if (pipe.isAsync) {
		        var deferred = $q.defer();
		        var onFulfilled = bind(this, this.next, args);
		        var onRejected = bind(this, this.onThrown, err);
		        deferred.promise.then(onFulfilled, onRejected);
		        pipe.apply(undefined, _toConsumableArray(args).concat([deferred]));
		      } else {
		        var isDone = Boolean(pipe.apply(undefined, _toConsumableArray(args)));
		        if (isDone) {
		          this.next(args);
		        } else {
		          this.onThrown(err);
		        }
		      }
		    };
		
		    Pipeline.prototype.exec = function exec() {
		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }
		
		      this.next(args);
		    };
		
		    Pipeline.prototype.onThrown = function onThrown(err) {};
		
		    Pipeline.prototype.onSuccessful = function onSuccessful() {};
		
		    return Pipeline;
		  }();
		}
		
		__identity.$inject = ['$q'];
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular,
		    extend = _angular.extend,
		    forEach = _angular.forEach;
		function __identity(FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileDrop, _FileDirective);
		
		        /**
		         * Creates instance of {FileDrop} object
		         * @param {Object} options
		         * @constructor
		         */
		        function FileDrop(options) {
		            _classCallCheck(this, FileDrop);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy',
		                    drop: 'onDrop',
		                    dragover: 'onDragOver',
		                    dragleave: 'onDragLeave'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'drop'
		            });
		
		            return _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		        }
		        /**
		         * Returns options
		         * @return {Object|undefined}
		         */
		
		
		        FileDrop.prototype.getOptions = function getOptions() {};
		        /**
		         * Returns filters
		         * @return {Array<Function>|String|undefined}
		         */
		
		
		        FileDrop.prototype.getFilters = function getFilters() {};
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDrop = function onDrop(event) {
		            var transfer = this._getTransfer(event);
		            if (!transfer) return;
		            var options = this.getOptions();
		            var filters = this.getFilters();
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._removeOverClass, this);
		            this.uploader.addToQueue(transfer.files, options, filters);
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDragOver = function onDragOver(event) {
		            var transfer = this._getTransfer(event);
		            if (!this._haveFiles(transfer.types)) return;
		            transfer.dropEffect = 'copy';
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._addOverClass, this);
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDragLeave = function onDragLeave(event) {
		            if (event.currentTarget === this.element[0]) return;
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._removeOverClass, this);
		        };
		        /**
		         * Helper
		         */
		
		
		        FileDrop.prototype._getTransfer = function _getTransfer(event) {
		            return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
		        };
		        /**
		         * Helper
		         */
		
		
		        FileDrop.prototype._preventAndStop = function _preventAndStop(event) {
		            event.preventDefault();
		            event.stopPropagation();
		        };
		        /**
		         * Returns "true" if types contains files
		         * @param {Object} types
		         */
		
		
		        FileDrop.prototype._haveFiles = function _haveFiles(types) {
		            if (!types) return false;
		            if (types.indexOf) {
		                return types.indexOf('Files') !== -1;
		            } else if (types.contains) {
		                return types.contains('Files');
		            } else {
		                return false;
		            }
		        };
		        /**
		         * Callback
		         */
		
		
		        FileDrop.prototype._addOverClass = function _addOverClass(item) {
		            item.addOverClass();
		        };
		        /**
		         * Callback
		         */
		
		
		        FileDrop.prototype._removeOverClass = function _removeOverClass(item) {
		            item.removeOverClass();
		        };
		
		        return FileDrop;
		    }(FileDirective);
		}
		
		__identity.$inject = ['FileDirective'];
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular,
		    extend = _angular.extend;
		function __identity(FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileOver, _FileDirective);
		
		        /**
		         * Creates instance of {FileDrop} object
		         * @param {Object} options
		         * @constructor
		         */
		        function FileOver(options) {
		            _classCallCheck(this, FileOver);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'over',
		                // Over class
		                overClass: 'nv-file-over'
		            });
		
		            return _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		        }
		        /**
		         * Adds over class
		         */
		
		
		        FileOver.prototype.addOverClass = function addOverClass() {
		            this.element.addClass(this.getOverClass());
		        };
		        /**
		         * Removes over class
		         */
		
		
		        FileOver.prototype.removeOverClass = function removeOverClass() {
		            this.element.removeClass(this.getOverClass());
		        };
		        /**
		         * Returns over class
		         * @returns {String}
		         */
		
		
		        FileOver.prototype.getOverClass = function getOverClass() {
		            return this.overClass;
		        };
		
		        return FileOver;
		    }(FileDirective);
		}
		
		__identity.$inject = ['FileDirective'];
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity($parse, FileUploader, FileSelect) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            var object = new FileSelect({
		                uploader: uploader,
		                element: element,
		                scope: scope
		            });
		
		            object.getOptions = $parse(attributes.options).bind(object, scope);
		            object.getFilters = function () {
		                return attributes.filters;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['$parse', 'FileUploader', 'FileSelect'];
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity($parse, FileUploader, FileDrop) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            if (!uploader.isHTML5) return;
		
		            var object = new FileDrop({
		                uploader: uploader,
		                element: element
		            });
		
		            object.getOptions = $parse(attributes.options).bind(object, scope);
		            object.getFilters = function () {
		                return attributes.filters;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['$parse', 'FileUploader', 'FileDrop'];
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity(FileUploader, FileOver) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            var object = new FileOver({
		                uploader: uploader,
		                element: element
		            });
		
		            object.getOverClass = function () {
		                return attributes.overClass || object.overClass;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['FileUploader', 'FileOver'];
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=angular-file-upload.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! angular-formly-templates-bootstrap version 6.5.1 built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us> (ó ì_í)=óò=(ì_í ò)
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(7), __webpack_require__(76), __webpack_require__(77));
		else if(typeof define === 'function' && define.amd)
			define(["angular", "angular-formly", "api-check"], factory);
		else if(typeof exports === 'object')
			exports["ngFormlyTemplatesBootstrap"] = factory(require("angular"), require("angular-formly"), require("api-check"));
		else
			root["ngFormlyTemplatesBootstrap"] = factory(root["angular"], root["ngFormly"], root["apiCheck"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var ngModuleName = 'formlyBootstrap';
		var angular = __webpack_require__(2);
		var ngModule = angular.module(ngModuleName, [__webpack_require__(4)]);
		ngModule.constant('formlyBootstrapApiCheck', __webpack_require__(5)({
		  output: {
		    prefix: 'angular-formly-bootstrap'
		  }
		}));
		ngModule.constant('formlyBootstrapVersion', ("6.5.1"));
	
		__webpack_require__(6)(ngModule);
		__webpack_require__(9)(ngModule);
		__webpack_require__(19)(ngModule);
	
		exports['default'] = ngModuleName;
		module.exports = exports['default'];
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		// some versions of angular don't export the angular module properly,
		// so we get it from window in this case.
		'use strict';
	
		var angular = __webpack_require__(3);
		if (!angular.version) {
		  angular = window.angular;
		}
		module.exports = angular;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addWrappers);
	
		  function addWrappers(formlyConfigProvider) {
		    formlyConfigProvider.setWrapper([{
		      name: 'bootstrapLabel',
		      template: __webpack_require__(7),
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            label: check.string.optional,
		            required: check.bool.optional,
		            labelSrOnly: check.bool.optional
		          }
		        };
		      }
		    }, { name: 'bootstrapHasError', template: __webpack_require__(8) }]);
		  }
		  addWrappers.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		module.exports = "<div>\n  <label for=\"{{id}}\" class=\"control-label {{to.labelSrOnly ? 'sr-only' : ''}}\" ng-if=\"to.label\">\n    {{to.label}}\n    {{to.required ? '*' : ''}}\n  </label>\n  <formly-transclude></formly-transclude>\n</div>\n"
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"form-group\" ng-class=\"{'has-error': showError}\">\n  <formly-transclude></formly-transclude>\n</div>\n"
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  __webpack_require__(10)(ngModule);
		  __webpack_require__(12)(ngModule);
		  __webpack_require__(14)(ngModule);
		  __webpack_require__(15)(ngModule);
		  __webpack_require__(17)(ngModule);
		  __webpack_require__(18)(ngModule);
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addCheckboxType);
	
		  function addCheckboxType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'checkbox',
		      template: __webpack_require__(11),
		      wrapper: ['bootstrapHasError'],
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            label: check.string
		          }
		        };
		      }
		    });
		  }
		  addCheckboxType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"checkbox\">\n\t<label>\n\t\t<input type=\"checkbox\"\n           class=\"formly-field-checkbox\"\n\t\t       ng-model=\"model[options.key]\">\n\t\t{{to.label}}\n\t\t{{to.required ? '*' : ''}}\n\t</label>\n</div>\n"
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addCheckboxType);
	
		  function addCheckboxType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'multiCheckbox',
		      template: __webpack_require__(13),
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            labelProp: check.string.optional,
		            valueProp: check.string.optional
		          }
		        };
		      },
		      defaultOptions: {
		        noFormControl: false,
		        ngModelAttrs: {
		          required: {
		            attribute: '',
		            bound: ''
		          }
		        }
		      },
		      controller: /* @ngInject */["$scope", function controller($scope) {
		        var to = $scope.to;
		        var opts = $scope.options;
		        $scope.multiCheckbox = {
		          checked: [],
		          change: setModel
		        };
	
		        // initialize the checkboxes check property
		        $scope.$watch('model', function modelWatcher(newModelValue) {
		          var modelValue, valueProp;
	
		          if (Object.keys(newModelValue).length) {
		            modelValue = newModelValue[opts.key];
	
		            $scope.$watch('to.options', function optionsWatcher(newOptionsValues) {
		              if (newOptionsValues && Array.isArray(newOptionsValues) && Array.isArray(modelValue)) {
		                valueProp = to.valueProp || 'value';
		                for (var index = 0; index < newOptionsValues.length; index++) {
		                  $scope.multiCheckbox.checked[index] = modelValue.indexOf(newOptionsValues[index][valueProp]) !== -1;
		                }
		              }
		            });
		          }
		        }, true);
	
		        function checkValidity(expressionValue) {
		          var valid;
	
		          if ($scope.to.required) {
		            valid = angular.isArray($scope.model[opts.key]) && $scope.model[opts.key].length > 0 && expressionValue;
	
		            $scope.fc.$setValidity('required', valid);
		          }
		        }
	
		        function setModel() {
		          $scope.model[opts.key] = [];
		          angular.forEach($scope.multiCheckbox.checked, function (checkbox, index) {
		            if (checkbox) {
		              $scope.model[opts.key].push(to.options[index][to.valueProp || 'value']);
		            }
		          });
	
		          // Must make sure we mark as touched because only the last checkbox due to a bug in angular.
		          $scope.fc.$setTouched();
		          checkValidity(true);
	
		          if ($scope.to.onChange) {
		            $scope.to.onChange();
		          }
		        }
	
		        if (opts.expressionProperties && opts.expressionProperties['templateOptions.required']) {
		          $scope.$watch(function () {
		            return $scope.to.required;
		          }, function (newValue) {
		            checkValidity(newValue);
		          });
		        }
	
		        if ($scope.to.required) {
		          var unwatchFormControl = $scope.$watch('fc', function (newValue) {
		            if (!newValue) {
		              return;
		            }
		            checkValidity(true);
		            unwatchFormControl();
		          });
		        }
		      }]
		    });
		  }
		  addCheckboxType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\"\n             id=\"{{id + '_'+ $index}}\"\n             ng-model=\"multiCheckbox.checked[$index]\"\n             ng-change=\"multiCheckbox.change()\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addInputType);
	
		  function addInputType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'input',
		      template: '<input class="form-control" ng-model="model[options.key]">',
		      wrapper: ['bootstrapLabel', 'bootstrapHasError']
		    });
		  }
		  addInputType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addRadioType);
	
		  function addRadioType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'radio',
		      template: __webpack_require__(16),
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: {
		        noFormControl: false
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            labelProp: check.string.optional,
		            valueProp: check.string.optional,
		            inline: check.bool.optional
		          }
		        };
		      }
		    });
		  }
		  addRadioType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" ng-class=\"{ 'radio': !to.inline, 'radio-inline': to.inline }\">\n    <label>\n      <input type=\"radio\"\n             id=\"{{id + '_'+ $index}}\"\n             tabindex=\"0\"\n             ng-value=\"option[to.valueProp || 'value']\"\n             ng-model=\"model[options.key]\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addSelectType);
	
		  var template = '<select class="form-control" ng-model="model[options.key]">\n      <option ng-hide="to.notNull" value="">{{to.nullDisplay}}</option>\n  </select>';
	
		  function addSelectType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'select',
		      template: template,
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: function defaultOptions(options) {
		        /* jshint maxlen:195 */
		        var ngOptions = options.templateOptions.ngOptions || 'option[to.valueProp || \'value\'] as option[to.labelProp || \'name\'] group by option[to.groupProp || \'group\'] for option in to.options';
		        return {
		          ngModelAttrs: _defineProperty({}, ngOptions, {
		            value: options.templateOptions.optionsAttr || 'ng-options'
		          })
		        };
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            optionsAttr: check.string.optional,
		            labelProp: check.string.optional,
		            valueProp: check.string.optional,
		            groupProp: check.string.optional,
		            notNull: check.bool.optional,
		            nullDisplay: check.string.optional
		          }
		        };
		      }
		    });
		  }
		  addSelectType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addTextareaType);
	
		  function addTextareaType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'textarea',
		      template: '<textarea class="form-control" ng-model="model[options.key]"></textarea>',
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: {
		        ngModelAttrs: {
		          rows: { attribute: 'rows' },
		          cols: { attribute: 'cols' }
		        }
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            rows: check.number.optional,
		            cols: check.number.optional
		          }
		        };
		      }
		    });
		  }
		  addTextareaType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _addons = __webpack_require__(20);
	
		var _addons2 = _interopRequireDefault(_addons);
	
		var _description = __webpack_require__(22);
	
		var _description2 = _interopRequireDefault(_description);
	
		exports['default'] = function (ngModule) {
		  (0, _addons2['default'])(ngModule);
		  (0, _description2['default'])(ngModule);
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.run(addAddonsManipulator);
	
		  function addAddonsManipulator(formlyConfig, formlyBootstrapApiCheck) {
		    var addonTemplate = __webpack_require__(21);
		    var addonChecker = formlyBootstrapApiCheck.shape({
		      'class': formlyBootstrapApiCheck.string.optional,
		      text: formlyBootstrapApiCheck.string.optional,
		      onClick: formlyBootstrapApiCheck.func.optional
		    }).strict.optional;
		    var api = formlyBootstrapApiCheck.shape({
		      templateOptions: formlyBootstrapApiCheck.shape({
		        addonLeft: addonChecker,
		        addonRight: addonChecker
		      })
		    });
		    formlyConfig.templateManipulators.preWrapper.push(function (template, options) {
		      if (!options.templateOptions.addonLeft && !options.templateOptions.addonRight) {
		        return template;
		      }
		      formlyBootstrapApiCheck.warn([api], [options]);
		      return addonTemplate.replace('<formly-transclude></formly-transclude>', template);
		    });
		  }
		  addAddonsManipulator.$inject = ["formlyConfig", "formlyBootstrapApiCheck"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		module.exports = "<div ng-class=\"{'input-group': to.addonLeft || to.addonRight}\">\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonLeft\"\n         ng-style=\"{cursor: to.addonLeft.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonLeft.onClick(options, this, $event)\">\n        <i class=\"{{to.addonLeft.class}}\" ng-if=\"to.addonLeft.class\"></i>\n        <span ng-if=\"to.addonLeft.text\">{{to.addonLeft.text}}</span>\n    </div>\n    <formly-transclude></formly-transclude>\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonRight\"\n         ng-style=\"{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonRight.onClick(options, this, $event)\">\n        <i class=\"{{to.addonRight.class}}\" ng-if=\"to.addonRight.class\"></i>\n        <span ng-if=\"to.addonRight.text\">{{to.addonRight.text}}</span>\n    </div>\n</div>\n"
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.run(addDescriptionManipulator);
	
		  function addDescriptionManipulator(formlyConfig) {
		    formlyConfig.templateManipulators.preWrapper.push(function ariaDescribedBy(template, options, scope) {
		      if (angular.isDefined(options.templateOptions.description)) {
		        var el = document.createElement('div');
		        el.appendChild(angular.element(template)[0]);
		        el.appendChild(angular.element('<p id="' + scope.id + '_description"' + 'class="help-block"' + 'ng-if="to.description">' + '{{to.description}}' + '</p>')[0]);
		        var modelEls = angular.element(el.querySelectorAll('[ng-model]'));
		        if (modelEls) {
		          modelEls.attr('aria-describedby', scope.id + '_description');
		        }
		        return el.innerHTML;
		      } else {
		        return template;
		      }
		    });
		  }
		  addDescriptionManipulator.$inject = ["formlyConfig"];
		};
	
		module.exports = exports['default'];
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("angular-jsoneditor",[],t):"object"==typeof exports?exports["angular-jsoneditor"]=t():e["angular-jsoneditor"]=t()}(this,function(){return function(e){function t(n){if(i[n])return i[n].exports;var r=i[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var i={};return t.m=e,t.c=i,t.p="",t(0)}([function(e,t,i){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var r=i(1),o=n(r);t.default=angular.module("angular-jsoneditor",[]).directive("angularJsoneditor",o.default),e.exports=t.default},function(e,t,i){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var r=i(2),o=n(r);i(75),i(78),t.default=function(){"ngInject";return{restrict:"E",require:"ngModel",scope:{options:"="},link:function(e,t,i,n){var r=void 0,s=function(i){var s=angular.extend({},{},i);return s.onChange=function(){var t=!1;try{n.$setViewValue(r.get()),t=!0}catch(e){throw e}finally{n.$setValidity("json",t),n.$setTouched(),e.$apply(),i.onChange&&"function"==typeof i.onChange&&i.onChange()}},t.html(""),new o.default(t[0],s)};r=s(e.options),e.$watch("options",function(t,i){for(var n in t)if(t.hasOwnProperty(n)){var o=t[n];if(t[n]!==i[n])if("mode"===n)r.setMode(o);else{if("name"!==n)return r=s(t),void e.updateJsonEditor();r.setName(o)}}},!0),e.$on("$destroy",function(){r=null}),e.updateJsonEditor=function(){r.set(n.$viewValue||{})},n.$render=e.updateJsonEditor,e.$watch(function(){return n.$modelValue},function(t){angular.equals(t,r.get())||e.updateJsonEditor()},!0)}}},e.exports=t.default},function(e,t,i){e.exports=i(3)},function(e,t,i){"use strict";function n(e,t,i){if(!(this instanceof n))throw new Error('JSONEditor constructor called without "new".');var r=a.getInternetExplorerVersion();if(r!=-1&&r<9)throw new Error("Unsupported browser, IE9 or newer required. Please install the newest version of your browser.");if(t&&(t.error&&(console.warn('Option "error" has been renamed to "onError"'),t.onError=t.error,delete t.error),t.change&&(console.warn('Option "change" has been renamed to "onChange"'),t.onChange=t.change,delete t.change),t.editable&&(console.warn('Option "editable" has been renamed to "onEditable"'),t.onEditable=t.editable,delete t.editable),t)){var o=["ace","theme","ajv","schema","onChange","onEditable","onError","onModeChange","escapeUnicode","history","search","mode","modes","name","indentation","sortObjectKeys"];Object.keys(t).forEach(function(e){o.indexOf(e)===-1&&console.warn('Unknown option "'+e+'". This option will be ignored')})}arguments.length&&this._create(e,t,i)}var r;try{r=i(4)}catch(e){}var o=i(55),s=i(66),a=i(58);n.modes={},n.prototype.DEBOUNCE_INTERVAL=150,n.prototype._create=function(e,t,i){this.container=e,this.options=t||{},this.json=i||{};var n=this.options.mode||"tree";this.setMode(n)},n.prototype.destroy=function(){},n.prototype.set=function(e){this.json=e},n.prototype.get=function(){return this.json},n.prototype.setText=function(e){this.json=a.parse(e)},n.prototype.getText=function(){return JSON.stringify(this.json)},n.prototype.setName=function(e){this.options||(this.options={}),this.options.name=e},n.prototype.getName=function(){return this.options&&this.options.name},n.prototype.setMode=function(e){var t,i,r=this.container,o=a.extend({},this.options),s=o.mode;o.mode=e;var l=n.modes[e];if(!l)throw new Error('Unknown mode "'+o.mode+'"');try{var c="text"==l.data;if(i=this.getName(),t=this[c?"getText":"get"](),this.destroy(),a.clear(this),a.extend(this,l.mixin),this.create(r,o),this.setName(i),this[c?"setText":"set"](t),"function"==typeof l.load)try{l.load.call(this)}catch(e){console.error(e)}if("function"==typeof o.onModeChange&&e!==s)try{o.onModeChange(e,s)}catch(e){console.error(e)}}catch(e){this._onError(e)}},n.prototype.getMode=function(){return this.options.mode},n.prototype._onError=function(e){if(!this.options||"function"!=typeof this.options.onError)throw e;this.options.onError(e)},n.prototype.setSchema=function(e){if(e){var t;try{t=this.options.ajv||r({allErrors:!0,verbose:!0})}catch(e){console.warn("Failed to create an instance of Ajv, JSON Schema validation is not available. Please use a JSONEditor bundle including Ajv, or pass an instance of Ajv as via the configuration option `ajv`.")}t&&(this.validateSchema=t.compile(e),this.options.schema=e,this.validate()),this.refresh()}else this.validateSchema=null,this.options.schema=null,this.validate(),this.refresh()},n.prototype.validate=function(){},n.prototype.refresh=function(){},n.registerMode=function(e){var t,i;if(a.isArray(e))for(t=0;t<e.length;t++)n.registerMode(e[t]);else{if(!("mode"in e))throw new Error('Property "mode" missing');if(!("mixin"in e))throw new Error('Property "mixin" missing');if(!("data"in e))throw new Error('Property "data" missing');var r=e.mode;if(r in n.modes)throw new Error('Mode "'+r+'" already registered');if("function"!=typeof e.mixin.create)throw new Error('Required function "create" missing on mixin');var o=["setMode","registerMode","modes"];for(t=0;t<o.length;t++)if(i=o[t],i in e.mixin)throw new Error('Reserved property "'+i+'" not allowed in mixin');n.modes[r]=e}},n.registerMode(o),n.registerMode(s),e.exports=n},function(e,t,i){"use strict";function n(e){return v.test(e)}function r(e){function t(e,t){var i;if("string"==typeof e){if(i=x(e),!i)throw new Error('no schema with key or ref "'+e+'"')}else{var n=$(e);i=n.validate||D(n)}var r=i(t);return i.async?"*"==P._opts.async?m(r):r:(P.errors=i.errors,r)}function w(e){var t=$(e);return t.validate||D(t)}function b(e,t,i,n){if(Array.isArray(e))for(var r=0;r<e.length;r++)b(e[r],void 0,i,n);else{t=s.normalizeId(t||e.id),j(t);var o=P._schemas[t]=$(e,i,!0);o.meta=n}}function A(e,t,i){b(e,t,i,!0)}function C(e,i){var r=e.$schema||P._opts.defaultMeta||E(),o=P._formats.uri;P._formats.uri="function"==typeof o?n:v;var s=t(r,e);if(P._formats.uri=o,!s&&i){var a="schema is invalid:"+B();if("log"!=P._opts.validateSchema)throw new Error(a);console.error(a)}return s}function E(){var e=P._opts.meta;return P._opts.defaultMeta="object"==typeof e?e.id||e:P._opts.v5?u.META_SCHEMA_ID:g,P._opts.defaultMeta}function x(e){var t=F(e);switch(typeof t){case"object":return t.validate||D(t);case"string":return x(t)}}function F(e){return e=s.normalizeId(e),P._schemas[e]||P._refs[e]}function k(e){switch(typeof e){case"undefined":return S(P._schemas),S(P._refs),void P._cache.clear();case"string":var t=F(e);return t&&P._cache.del(t.jsonStr),delete P._schemas[e],void delete P._refs[e];case"object":if(e instanceof RegExp)return S(P._schemas,e),void S(P._refs,e);var i=c(e);P._cache.del(i);var n=e.id;n&&(n=s.normalizeId(n),delete P._schemas[n],delete P._refs[n])}}function S(e,t){for(var i in e){var n=e[i];n.meta||t&&!t.test(i)||(P._cache.del(n.jsonStr),delete e[i])}}function $(e,t,i){if("object"!=typeof e)throw new Error("schema should be object");var n=c(e),r=P._cache.get(n);if(r)return r;i=i||P._opts.addUsedSchema!==!1;var o=s.normalizeId(e.id);o&&i&&j(o),P._opts.validateSchema===!1||t||C(e,!0);var a=s.ids.call(P,e),h=new l({id:o,schema:e,localRefs:a,jsonStr:n});return"#"!=o[0]&&i&&(P._refs[o]=h),P._cache.put(n,h),h}function D(e,t){function i(){var t=e.validate,n=t.apply(null,arguments);return i.errors=t.errors,n}if(e.compiling)return e.validate=i,i.schema=e.schema,i.errors=null,i.root=t?t:i,e.schema.$async===!0&&(i.async=!0),i;e.compiling=!0;var n;e.meta&&(n=P._opts,P._opts=P._metaOpts);var r;try{r=o.call(P,e.schema,t,e.localRefs)}finally{e.compiling=!1,e.meta&&(P._opts=n)}return e.validate=r,e.refs=r.refs,e.refVal=r.refVal,e.root=r.root,r}function B(e,t){if(e=e||P.errors,!e)return"No errors";t=t||{};for(var i=void 0===t.separator?", ":t.separator,n=void 0===t.dataVar?"data":t.dataVar,r="",o=0;o<e.length;o++){var s=e[o];s&&(r+=n+s.dataPath+" "+s.message+i)}return r.slice(0,-i.length)}function _(e,t){"string"==typeof t&&(t=new RegExp(t)),P._formats[e]=t}function L(){if(P._opts.meta!==!1){var e=i(54);A(e,g,!0),P._refs["http://json-schema.org/schema"]=g}var t=P._opts.schemas;if(t)if(Array.isArray(t))b(t);else for(var n in t)b(t[n],n)}function R(){for(var e in P._opts.formats){var t=P._opts.formats[e];_(e,t)}}function j(e){if(P._schemas[e]||P._refs[e])throw new Error('schema with key or id "'+e+'" already exists')}function T(){for(var e=f.copy(P._opts),t=0;t<y.length;t++)delete e[y[t]];return e}if(!(this instanceof r))return new r(e);var P=this;e=this._opts=f.copy(e)||{},this._schemas={},this._refs={},this._formats=h(e.format),this._cache=e.cache||new a,this._loadingSchemas={},this.RULES=d(),this.validate=t,this.compile=w,this.addSchema=b,this.addMetaSchema=A,this.validateSchema=C,this.getSchema=x,this.removeSchema=k,this.addFormat=_,this.errorsText=B,this._addSchema=$,this._compile=D,e.loopRequired=e.loopRequired||1/0,(e.async||e.transpile)&&p.setup(e),e.beautify===!0&&(e.beautify={indent_size:2}),"property"==e.errorDataPath&&(e._errorDataPathProperty=!0),this._metaOpts=T(),L(),e.formats&&R(),e.v5&&u.enable(this),"object"==typeof e.meta&&A(e.meta)}var o=i(5),s=i(6),a=i(25),l=i(20),c=i(16),h=i(26),d=i(27),u=i(47),f=i(15),p=i(21),m=i(23);e.exports=r,r.prototype.compileAsync=p.compile,r.prototype.addKeyword=i(53),r.ValidationError=i(24);var g="http://json-schema.org/draft-04/schema",v=/^(?:(?:[a-z][a-z0-9+-.]*:)?\/\/)?[^\s]*$/i,y=["removeAdditional","useDefaults","coerceTypes"]},function(module,exports,__webpack_require__){"use strict";function compile(schema,root,localRefs,baseId){function localCompile(_schema,_root,localRefs,baseId){var isRoot=!_root||_root&&_root.schema==_schema;if(_root.schema!=root.schema)return compile.call(self,_schema,_root,localRefs,baseId);var $async=_schema.$async===!0;$async&&!opts.transpile&&async.setup(opts);var sourceCode=validateGenerator({isTop:!0,schema:_schema,isRoot:isRoot,baseId:baseId,root:_root,schemaPath:"",errSchemaPath:"#",errorPath:'""',RULES:RULES,validate:validateGenerator,util:util,resolve:resolve,resolveRef:resolveRef,usePattern:usePattern,useDefault:useDefault,useCustomRule:useCustomRule,opts:opts,formats:formats,self:self});sourceCode=vars(refVal,refValCode)+vars(patterns,patternCode)+vars(defaults,defaultCode)+vars(customRules,customRuleCode)+sourceCode,opts.beautify&&(beautify?sourceCode=beautify(sourceCode,opts.beautify):console.error('"npm install js-beautify" to use beautify option'));var validate,validateCode,transpile=opts._transpileFunc;try{validateCode=$async&&transpile?transpile(sourceCode):sourceCode,eval(validateCode),refVal[0]=validate}catch(e){throw console.error("Error compiling schema, function code:",validateCode),e}return validate.schema=_schema,validate.errors=null,validate.refs=refs,validate.refVal=refVal,validate.root=isRoot?validate:_root,$async&&(validate.async=!0),validate.sourceCode=sourceCode,validate}function resolveRef(e,t,i){t=resolve.url(e,t);var n,r,o=refs[t];if(void 0!==o)return n=refVal[o],r="refVal["+o+"]",resolvedRef(n,r);if(!i){var s=root.refs[t];if(void 0!==s)return n=root.refVal[s],r=addLocalRef(t,n),resolvedRef(n,r)}r=addLocalRef(t);var a=resolve.call(self,localCompile,root,t);if(!a){var l=localRefs&&localRefs[t];l&&(a=resolve.inlineRef(l,opts.inlineRefs)?l:compile.call(self,l,root,localRefs,e))}return a?(replaceLocalRef(t,a),resolvedRef(a,r)):void 0}function addLocalRef(e,t){var i=refVal.length;return refVal[i]=t,refs[e]=i,"refVal"+i}function replaceLocalRef(e,t){var i=refs[e];refVal[i]=t}function resolvedRef(e,t){return"object"==typeof e?{code:t,schema:e,inline:!0}:{code:t,async:e&&e.async}}function usePattern(e){var t=patternsHash[e];return void 0===t&&(t=patternsHash[e]=patterns.length,patterns[t]=e),"pattern"+t}function useDefault(e){switch(typeof e){case"boolean":case"number":return""+e;case"string":return util.toQuotedString(e);case"object":if(null===e)return"null";var t=stableStringify(e),i=defaultsHash[t];return void 0===i&&(i=defaultsHash[t]=defaults.length,defaults[i]=e),"default"+i}}function useCustomRule(e,t,i,n){var r,o=e.definition.compile,s=e.definition.inline,a=e.definition.macro;o?r=o.call(self,t,i):a?(r=a.call(self,t,i),opts.validateSchema!==!1&&self.validateSchema(r,!0)):r=s?s.call(self,n,e.keyword,t,i):e.definition.validate;var l=customRules.length;return customRules[l]=r,{code:"customRule"+l,validate:r}}var self=this,opts=this._opts,refVal=[void 0],refs={},patterns=[],patternsHash={},defaults=[],defaultsHash={},customRules=[];root=root||{schema:schema,refVal:refVal,refs:refs};var formats=this._formats,RULES=this.RULES;return localCompile(schema,root,localRefs,baseId)}function patternCode(e,t){return"var pattern"+e+" = new RegExp("+util.toQuotedString(t[e])+");"}function defaultCode(e){return"var default"+e+" = defaults["+e+"];"}function refValCode(e,t){return t[e]?"var refVal"+e+" = refVal["+e+"];":""}function customRuleCode(e){return"var customRule"+e+" = customRules["+e+"];"}function vars(e,t){if(!e.length)return"";for(var i="",n=0;n<e.length;n++)i+=t(n,e);return i}var resolve=__webpack_require__(6),util=__webpack_require__(15),stableStringify=__webpack_require__(16),async=__webpack_require__(21),beautify=function(){try{return __webpack_require__(!function(){var e=new Error('Cannot find module "js-beautify"');throw e.code="MODULE_NOT_FOUND",e}()).js_beautify}catch(e){}}(),validateGenerator=__webpack_require__(22);module.exports=compile;var co=__webpack_require__(23),ucs2length=util.ucs2length,equal=__webpack_require__(14),ValidationError=__webpack_require__(24)},function(e,t,i){"use strict";function n(e,t,i){var o=this._refs[i];if("string"==typeof o){if(!this._refs[o])return n.call(this,e,t,o);o=this._refs[o]}if(o=o||this._schemas[i],o instanceof y)return a(o.schema,this._opts.inlineRefs)?o.schema:o.validate||this._compile(o);var s,l,c,h=r.call(this,t,i);return h&&(s=h.schema,t=h.root,c=h.baseId),s instanceof y?l=s.validate||e.call(this,s.schema,t,void 0,c):s&&(l=a(s,this._opts.inlineRefs)?s:e.call(this,s,t,void 0,c)),l}function r(e,t){var i=m.parse(t,!1,!0),n=d(i),r=h(e.schema.id);if(n!==r){var a=u(n),l=this._refs[a];if("string"==typeof l)return o.call(this,e,l,i);if(l instanceof y)l.validate||this._compile(l),e=l;else if(l=this._schemas[a],l instanceof y){if(l.validate||this._compile(l),a==u(t))return{schema:l,root:e,baseId:r};e=l}if(!e.schema)return;r=h(e.schema.id)}return s.call(this,i,r,e.schema,e)}function o(e,t,i){var n=r.call(this,e,t);if(n){var o=n.schema,a=n.baseId;return e=n.root,o.id&&(a=f(a,o.id)),s.call(this,i,a,o,e)}}function s(e,t,i,n){if(e.hash=e.hash||"","#/"==e.hash.slice(0,2)){for(var o=e.hash.split("/"),s=1;s<o.length;s++){var a=o[s];if(a){if(a=v.unescapeFragment(a),i=i[a],!i)break;if(i.id&&!w[a]&&(t=f(t,i.id)),i.$ref){var l=f(t,i.$ref),c=r.call(this,n,l);c&&(i=c.schema,n=c.root,t=c.baseId)}}}return i&&i!=n.schema?{schema:i,root:n,baseId:t}:void 0}}function a(e,t){return t!==!1&&(void 0===t||t===!0?l(e):t?c(e)<=t:void 0)}function l(e){var t;if(Array.isArray(e)){for(var i=0;i<e.length;i++)if(t=e[i],"object"==typeof t&&!l(t))return!1}else for(var n in e){if("$ref"==n)return!1;if(t=e[n],"object"==typeof t&&!l(t))return!1}return!0}function c(e){var t,i=0;if(Array.isArray(e)){for(var n=0;n<e.length;n++)if(t=e[n],"object"==typeof t&&(i+=c(t)),i==1/0)return 1/0}else for(var r in e){if("$ref"==r)return 1/0;if(b[r])i++;else if(t=e[r],"object"==typeof t&&(i+=c(t)+1),i==1/0)return 1/0}return i}function h(e,t){t!==!1&&(e=u(e));var i=m.parse(e,!1,!0);return d(i)}function d(e){return(e.protocol||"")+(e.protocol?"//":"")+(e.host||"")+(e.path||"")+"#"}function u(e){return e?e.replace(A,""):""}function f(e,t){return t=u(t),m.resolve(e,t)}function p(e){function t(e,i,r){if(Array.isArray(e))for(var o=0;o<e.length;o++)t.call(this,e[o],i+"/"+o,r);else if(e&&"object"==typeof e){if("string"==typeof e.id){var s=r=r?m.resolve(r,e.id):e.id;s=u(s);var a=this._refs[s];if("string"==typeof a&&(a=this._refs[a]),a&&a.schema){if(!g(e,a.schema))throw new Error('id "'+s+'" resolves to more than one schema')}else if(s!=u(i))if("#"==s[0]){if(n[s]&&!g(e,n[s]))throw new Error('id "'+s+'" resolves to more than one schema');n[s]=e}else this._refs[s]=i}for(var l in e)t.call(this,e[l],i+"/"+v.escapeFragment(l),r)}}var i=u(e.id),n={};return t.call(this,e,h(i,!1),i),n}var m=i(7),g=i(14),v=i(15),y=i(20);e.exports=n,n.normalizeId=u,n.fullPath=h,n.url=f,n.ids=p,n.inlineRef=a;var w=v.toHash(["properties","patternProperties","enum","dependencies","definitions"]),b=v.toHash(["type","format","pattern","maxLength","minLength","maxProperties","minProperties","maxItems","minItems","maximum","minimum","uniqueItems","multipleOf","required","enum"]),A=/#\/?$/},function(e,t,i){"use strict";function n(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}function r(e,t,i){if(e&&c.isObject(e)&&e instanceof n)return e;var r=new n;return r.parse(e,t,i),r}function o(e){return c.isString(e)&&(e=r(e)),e instanceof n?e.format():n.prototype.format.call(e)}function s(e,t){return r(e,!1,!0).resolve(t)}function a(e,t){return e?r(e,!1,!0).resolveObject(t):t}var l=i(8),c=i(10);t.parse=r,t.resolve=s,t.resolveObject=a,t.format=o,t.Url=n;var h=/^([a-z0-9.+-]+:)/i,d=/:[0-9]*$/,u=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,f=["<",">",'"',"`"," ","\r","\n","\t"],p=["{","}","|","\\","^","`"].concat(f),m=["'"].concat(p),g=["%","/","?",";","#"].concat(m),v=["/","?","#"],y=255,w=/^[+a-z0-9A-Z_-]{0,63}$/,b=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,A={javascript:!0,"javascript:":!0},C={javascript:!0,"javascript:":!0},E={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},x=i(11);n.prototype.parse=function(e,t,i){if(!c.isString(e))throw new TypeError("Parameter 'url' must be a string, not "+typeof e);var n=e.indexOf("?"),r=n!==-1&&n<e.indexOf("#")?"?":"#",o=e.split(r),s=/\\/g;o[0]=o[0].replace(s,"/"),e=o.join(r);var a=e;if(a=a.trim(),!i&&1===e.split("#").length){var d=u.exec(a);if(d)return this.path=a,this.href=a,this.pathname=d[1],d[2]?(this.search=d[2],t?this.query=x.parse(this.search.substr(1)):this.query=this.search.substr(1)):t&&(this.search="",this.query={}),this}var f=h.exec(a);if(f){f=f[0];var p=f.toLowerCase();this.protocol=p,a=a.substr(f.length)}if(i||f||a.match(/^\/\/[^@\/]+@[^@\/]+/)){var F="//"===a.substr(0,2);!F||f&&C[f]||(a=a.substr(2),this.slashes=!0)}if(!C[f]&&(F||f&&!E[f])){for(var k=-1,S=0;S<v.length;S++){var $=a.indexOf(v[S]);$!==-1&&(k===-1||$<k)&&(k=$)}var D,B;B=k===-1?a.lastIndexOf("@"):a.lastIndexOf("@",k),B!==-1&&(D=a.slice(0,B),a=a.slice(B+1),this.auth=decodeURIComponent(D)),k=-1;for(var S=0;S<g.length;S++){var $=a.indexOf(g[S]);$!==-1&&(k===-1||$<k)&&(k=$)}k===-1&&(k=a.length),this.host=a.slice(0,k),a=a.slice(k),this.parseHost(),this.hostname=this.hostname||"";var _="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!_)for(var L=this.hostname.split(/\./),S=0,R=L.length;S<R;S++){var j=L[S];if(j&&!j.match(w)){for(var T="",P=0,M=j.length;P<M;P++)T+=j.charCodeAt(P)>127?"x":j[P];if(!T.match(w)){var O=L.slice(0,S),N=L.slice(S+1),I=j.match(b);I&&(O.push(I[1]),N.unshift(I[2])),N.length&&(a="/"+N.join(".")+a),this.hostname=O.join(".");break}}}this.hostname.length>y?this.hostname="":this.hostname=this.hostname.toLowerCase(),_||(this.hostname=l.toASCII(this.hostname));var W=this.port?":"+this.port:"",H=this.hostname||"";this.host=H+W,this.href+=this.host,_&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==a[0]&&(a="/"+a))}if(!A[p])for(var S=0,R=m.length;S<R;S++){var z=m[S];if(a.indexOf(z)!==-1){var V=encodeURIComponent(z);V===z&&(V=escape(z)),a=a.split(z).join(V)}}var U=a.indexOf("#");U!==-1&&(this.hash=a.substr(U),a=a.slice(0,U));var K=a.indexOf("?");if(K!==-1?(this.search=a.substr(K),this.query=a.substr(K+1),t&&(this.query=x.parse(this.query)),a=a.slice(0,K)):t&&(this.search="",this.query={}),a&&(this.pathname=a),E[p]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){var W=this.pathname||"",q=this.search||"";this.path=W+q}return this.href=this.format(),this},n.prototype.format=function(){var e=this.auth||"";e&&(e=encodeURIComponent(e),e=e.replace(/%3A/i,":"),e+="@");var t=this.protocol||"",i=this.pathname||"",n=this.hash||"",r=!1,o="";this.host?r=e+this.host:this.hostname&&(r=e+(this.hostname.indexOf(":")===-1?this.hostname:"["+this.hostname+"]"),this.port&&(r+=":"+this.port)),this.query&&c.isObject(this.query)&&Object.keys(this.query).length&&(o=x.stringify(this.query));var s=this.search||o&&"?"+o||"";return t&&":"!==t.substr(-1)&&(t+=":"),this.slashes||(!t||E[t])&&r!==!1?(r="//"+(r||""),i&&"/"!==i.charAt(0)&&(i="/"+i)):r||(r=""),n&&"#"!==n.charAt(0)&&(n="#"+n),s&&"?"!==s.charAt(0)&&(s="?"+s),i=i.replace(/[?#]/g,function(e){return encodeURIComponent(e)}),s=s.replace("#","%23"),t+r+i+s+n},n.prototype.resolve=function(e){return this.resolveObject(r(e,!1,!0)).format()},n.prototype.resolveObject=function(e){if(c.isString(e)){var t=new n;t.parse(e,!1,!0),e=t}for(var i=new n,r=Object.keys(this),o=0;o<r.length;o++){var s=r[o];i[s]=this[s]}if(i.hash=e.hash,""===e.href)return i.href=i.format(),i;if(e.slashes&&!e.protocol){for(var a=Object.keys(e),l=0;l<a.length;l++){var h=a[l];"protocol"!==h&&(i[h]=e[h])}return E[i.protocol]&&i.hostname&&!i.pathname&&(i.path=i.pathname="/"),i.href=i.format(),i}if(e.protocol&&e.protocol!==i.protocol){if(!E[e.protocol]){for(var d=Object.keys(e),u=0;u<d.length;u++){var f=d[u];i[f]=e[f]}return i.href=i.format(),i}if(i.protocol=e.protocol,e.host||C[e.protocol])i.pathname=e.pathname;else{for(var p=(e.pathname||"").split("/");p.length&&!(e.host=p.shift()););e.host||(e.host=""),e.hostname||(e.hostname=""),""!==p[0]&&p.unshift(""),p.length<2&&p.unshift(""),i.pathname=p.join("/")}if(i.search=e.search,i.query=e.query,i.host=e.host||"",i.auth=e.auth,i.hostname=e.hostname||e.host,i.port=e.port,i.pathname||i.search){var m=i.pathname||"",g=i.search||"";i.path=m+g}return i.slashes=i.slashes||e.slashes,i.href=i.format(),i}var v=i.pathname&&"/"===i.pathname.charAt(0),y=e.host||e.pathname&&"/"===e.pathname.charAt(0),w=y||v||i.host&&e.pathname,b=w,A=i.pathname&&i.pathname.split("/")||[],p=e.pathname&&e.pathname.split("/")||[],x=i.protocol&&!E[i.protocol];if(x&&(i.hostname="",i.port=null,i.host&&(""===A[0]?A[0]=i.host:A.unshift(i.host)),i.host="",e.protocol&&(e.hostname=null,e.port=null,e.host&&(""===p[0]?p[0]=e.host:p.unshift(e.host)),e.host=null),w=w&&(""===p[0]||""===A[0])),y)i.host=e.host||""===e.host?e.host:i.host,i.hostname=e.hostname||""===e.hostname?e.hostname:i.hostname,i.search=e.search,i.query=e.query,A=p;else if(p.length)A||(A=[]),A.pop(),A=A.concat(p),i.search=e.search,i.query=e.query;else if(!c.isNullOrUndefined(e.search)){if(x){i.hostname=i.host=A.shift();var F=!!(i.host&&i.host.indexOf("@")>0)&&i.host.split("@");F&&(i.auth=F.shift(),i.host=i.hostname=F.shift())}return i.search=e.search,i.query=e.query,c.isNull(i.pathname)&&c.isNull(i.search)||(i.path=(i.pathname?i.pathname:"")+(i.search?i.search:"")),i.href=i.format(),i}if(!A.length)return i.pathname=null,i.search?i.path="/"+i.search:i.path=null,i.href=i.format(),i;for(var k=A.slice(-1)[0],S=(i.host||e.host||A.length>1)&&("."===k||".."===k)||""===k,$=0,D=A.length;D>=0;D--)k=A[D],"."===k?A.splice(D,1):".."===k?(A.splice(D,1),$++):$&&(A.splice(D,1),$--);if(!w&&!b)for(;$--;$)A.unshift("..");!w||""===A[0]||A[0]&&"/"===A[0].charAt(0)||A.unshift(""),S&&"/"!==A.join("/").substr(-1)&&A.push("");var B=""===A[0]||A[0]&&"/"===A[0].charAt(0);if(x){i.hostname=i.host=B?"":A.length?A.shift():"";var F=!!(i.host&&i.host.indexOf("@")>0)&&i.host.split("@");F&&(i.auth=F.shift(),i.host=i.hostname=F.shift())}return w=w||i.host&&A.length,w&&!B&&A.unshift(""),A.length?i.pathname=A.join("/"):(i.pathname=null,i.path=null),c.isNull(i.pathname)&&c.isNull(i.search)||(i.path=(i.pathname?i.pathname:"")+(i.search?i.search:"")),i.auth=e.auth||i.auth,i.slashes=i.slashes||e.slashes,i.href=i.format(),i},n.prototype.parseHost=function(){var e=this.host,t=d.exec(e);t&&(t=t[0],":"!==t&&(this.port=t.substr(1)),e=e.substr(0,e.length-t.length)),e&&(this.hostname=e)}},function(e,t,i){var n;(function(e,r){!function(o){function s(e){throw RangeError(L[e])}function a(e,t){for(var i=e.length,n=[];i--;)n[i]=t(e[i]);return n}function l(e,t){var i=e.split("@"),n="";i.length>1&&(n=i[0]+"@",e=i[1]),e=e.replace(_,".");var r=e.split("."),o=a(r,t).join(".");return n+o}function c(e){for(var t,i,n=[],r=0,o=e.length;r<o;)t=e.charCodeAt(r++),t>=55296&&t<=56319&&r<o?(i=e.charCodeAt(r++),56320==(64512&i)?n.push(((1023&t)<<10)+(1023&i)+65536):(n.push(t),r--)):n.push(t);return n}function h(e){return a(e,function(e){var t="";return e>65535&&(e-=65536,t+=T(e>>>10&1023|55296),e=56320|1023&e),t+=T(e)}).join("")}function d(e){return e-48<10?e-22:e-65<26?e-65:e-97<26?e-97:A}function u(e,t){return e+22+75*(e<26)-((0!=t)<<5)}function f(e,t,i){var n=0;for(e=i?j(e/F):e>>1,e+=j(e/t);e>R*E>>1;n+=A)e=j(e/R);return j(n+(R+1)*e/(e+x))}function p(e){var t,i,n,r,o,a,l,c,u,p,m=[],g=e.length,v=0,y=S,w=k;for(i=e.lastIndexOf($),i<0&&(i=0),n=0;n<i;++n)e.charCodeAt(n)>=128&&s("not-basic"),m.push(e.charCodeAt(n));for(r=i>0?i+1:0;r<g;){for(o=v,a=1,l=A;r>=g&&s("invalid-input"),c=d(e.charCodeAt(r++)),(c>=A||c>j((b-v)/a))&&s("overflow"),v+=c*a,u=l<=w?C:l>=w+E?E:l-w,!(c<u);l+=A)p=A-u,a>j(b/p)&&s("overflow"),a*=p;t=m.length+1,w=f(v-o,t,0==o),j(v/t)>b-y&&s("overflow"),y+=j(v/t),v%=t,m.splice(v++,0,y)}return h(m)}function m(e){var t,i,n,r,o,a,l,h,d,p,m,g,v,y,w,x=[];for(e=c(e),g=e.length,t=S,i=0,o=k,a=0;a<g;++a)m=e[a],m<128&&x.push(T(m));for(n=r=x.length,r&&x.push($);n<g;){for(l=b,a=0;a<g;++a)m=e[a],m>=t&&m<l&&(l=m);for(v=n+1,l-t>j((b-i)/v)&&s("overflow"),i+=(l-t)*v,t=l,a=0;a<g;++a)if(m=e[a],m<t&&++i>b&&s("overflow"),m==t){for(h=i,d=A;p=d<=o?C:d>=o+E?E:d-o,!(h<p);d+=A)w=h-p,y=A-p,x.push(T(u(p+w%y,0))),h=j(w/y);x.push(T(u(h,0))),o=f(i,v,n==r),i=0,++n}++i,++t}return x.join("")}function g(e){return l(e,function(e){return D.test(e)?p(e.slice(4).toLowerCase()):e})}function v(e){return l(e,function(e){return B.test(e)?"xn--"+m(e):e})}var y=("object"==typeof t&&t&&!t.nodeType&&t,"object"==typeof e&&e&&!e.nodeType&&e,"object"==typeof r&&r);y.global!==y&&y.window!==y&&y.self!==y||(o=y);var w,b=2147483647,A=36,C=1,E=26,x=38,F=700,k=72,S=128,$="-",D=/^xn--/,B=/[^\x20-\x7E]/,_=/[\x2E\u3002\uFF0E\uFF61]/g,L={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},R=A-C,j=Math.floor,T=String.fromCharCode;w={version:"1.3.2",ucs2:{decode:c,encode:h},decode:p,encode:m,toASCII:v,toUnicode:g},n=function(){return w}.call(t,i,t,e),!(void 0!==n&&(e.exports=n))}(this)}).call(t,i(9)(e),function(){return this}())},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children=[],e.webpackPolyfill=1),e}},function(e,t){"use strict";e.exports={isString:function(e){return"string"==typeof e},isObject:function(e){return"object"==typeof e&&null!==e},isNull:function(e){return null===e},isNullOrUndefined:function(e){return null==e}}},function(e,t,i){"use strict";t.decode=t.parse=i(12),t.encode=t.stringify=i(13)},function(e,t){"use strict";function i(e,t){return Object.prototype.hasOwnProperty.call(e,t)}e.exports=function(e,t,n,r){t=t||"&",n=n||"=";var o={};if("string"!=typeof e||0===e.length)return o;var s=/\+/g;e=e.split(t);var a=1e3;r&&"number"==typeof r.maxKeys&&(a=r.maxKeys);var l=e.length;a>0&&l>a&&(l=a);for(var c=0;c<l;++c){var h,d,u,f,p=e[c].replace(s,"%20"),m=p.indexOf(n);m>=0?(h=p.substr(0,m),d=p.substr(m+1)):(h=p,d=""),u=decodeURIComponent(h),f=decodeURIComponent(d),i(o,u)?Array.isArray(o[u])?o[u].push(f):o[u]=[o[u],f]:o[u]=f}return o}},function(e,t){"use strict";var i=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,n,r){return t=t||"&",n=n||"=",null===e&&(e=void 0),"object"==typeof e?Object.keys(e).map(function(r){var o=encodeURIComponent(i(r))+n;return Array.isArray(e[r])?e[r].map(function(e){return o+encodeURIComponent(i(e))}).join(t):o+encodeURIComponent(i(e[r]))}).join(t):r?encodeURIComponent(i(r))+n+encodeURIComponent(i(e)):""}},function(e,t){"use strict";e.exports=function e(t,i){if(t===i)return!0;var n,r=Array.isArray(t),o=Array.isArray(i);if(r&&o){if(t.length!=i.length)return!1;for(n=0;n<t.length;n++)if(!e(t[n],i[n]))return!1;return!0}if(r!=o)return!1;if(t&&i&&"object"==typeof t&&"object"==typeof i){var s=Object.keys(t);if(s.length!==Object.keys(i).length)return!1;for(n=0;n<s.length;n++)if(void 0===i[s[n]])return!1;for(n=0;n<s.length;n++)if(!e(t[s[n]],i[s[n]]))return!1;return!0}return!1}},function(e,t,i){"use strict";function n(e,t){t=t||{};for(var i in e)t[i]=e[i];return t}function r(e,t,i){var n=i?" !== ":" === ",r=i?" || ":" && ",o=i?"!":"",s=i?"":"!";switch(e){case"null":return t+n+"null";case"array":return o+"Array.isArray("+t+")";case"object":return"("+o+t+r+"typeof "+t+n+'"object"'+r+s+"Array.isArray("+t+"))";case"integer":return"(typeof "+t+n+'"number"'+r+s+"("+t+" % 1))";default:return"typeof "+t+n+'"'+e+'"'}}function o(e,t){switch(e.length){case 1:return r(e[0],t,!0);default:var i="",n=a(e);n.array&&n.object&&(i=n.null?"(":"(!"+t+" || ",i+="typeof "+t+' !== "object")',delete n.null,delete n.array,delete n.object),n.number&&delete n.integer;for(var o in n)i+=(i?" && ":"")+r(o,t,!0);return i}}function s(e){if(Array.isArray(e)){for(var t=[],i=0;i<e.length;i++){var n=e[i];F[n]&&(t[t.length]=n)}if(t.length)return t}else if(F[e])return[e]}function a(e){for(var t={},i=0;i<e.length;i++)t[e[i]]=!0;return t}function l(e){return"number"==typeof e?"["+e+"]":k.test(e)?"."+e:"['"+e.replace(S,"\\$&")+"']"}function c(e){return e.replace(S,"\\$&")}function h(e){for(var t,i=0,n=e.length,r=0;r<n;)i++,t=e.charCodeAt(r++),t>=55296&&t<=56319&&r<n&&(t=e.charCodeAt(r),56320==(64512&t)&&r++);return i}function d(e,t){t+="[^0-9]";var i=e.match(new RegExp(t,"g"));return i?i.length:0}function u(e,t,i){return t+="([^0-9])",i=i.replace(/\$/g,"$$$$"),e.replace(new RegExp(t,"g"),i+"$1")}function f(e){return e.replace($,"").replace(D,"").replace(B,"if (!($1))")}function p(e,t){var i=e.match(_);return i&&2===i.length?t?e.replace(R,"").replace(P,M):e.replace(L,"").replace(j,T):e}function m(e,t){for(var i in e)if(t[i])return!0}function g(e){return"'"+c(e)+"'"}function v(e,t,i,n){var r=i?"'/' + "+t+(n?"":".replace(/~/g, '~0').replace(/\\//g, '~1')"):n?"'[' + "+t+" + ']'":"'[\\'' + "+t+" + '\\']'";return b(e,r)}function y(e,t,i){var n=g(i?"/"+E(t):l(t));return b(e,n)}function w(e,t,i){var n=e.match(O);if(!n)throw new Error("Invalid relative JSON-pointer: "+e);var r=+n[1],o=n[2];if("#"==o){if(r>=t)throw new Error("Cannot access property/index "+r+" levels up, current level is "+t);return i[t-r]}if(r>t)throw new Error("Cannot access data "+r+" levels up, current level is "+t);var s="data"+(t-r||"");if(!o)return s;for(var a=s,c=o.split("/"),h=0;h<c.length;h++){var d=c[h];d&&(s+=l(x(d)),a+=" && "+s)}return a}function b(e,t){return'""'==e?t:(e+" + "+t).replace(/' \+ '/g,"")}function A(e){return x(decodeURIComponent(e))}function C(e){return encodeURIComponent(E(e))}function E(e){return e.replace(/~/g,"~0").replace(/\//g,"~1")}function x(e){return e.replace(/~1/g,"/").replace(/~0/g,"~")}e.exports={copy:n,checkDataType:r,checkDataTypes:o,coerceToTypes:s,toHash:a,getProperty:l,escapeQuotes:c,ucs2length:h,varOccurences:d,varReplace:u,cleanUpCode:f,cleanUpVarErrors:p,schemaHasRules:m,stableStringify:i(16),toQuotedString:g,getPathExpr:v,getPath:y,getData:w,unescapeFragment:A,escapeFragment:C,escapeJsonPointer:E};var F=a(["string","number","integer","boolean","null"]),k=/^[a-z$_][a-z$_0-9]*$/i,S=/'|\\/g,$=/else\s*{\s*}/g,D=/if\s*\([^)]+\)\s*\{\s*\}(?!\s*else)/g,B=/if\s*\(([^)]+)\)\s*\{\s*\}\s*else(?!\s*if)/g,_=/[^v\.]errors/g,L=/var errors = 0;|var vErrors = null;|validate.errors = vErrors;/g,R=/var errors = 0;|var vErrors = null;/g,j="return errors === 0;",T="validate.errors = null; return true;",P=/if \(errors === 0\) return true;\s*else throw new ValidationError\(vErrors\);/,M="return true;",O=/^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
	},function(e,t,i){var n="undefined"!=typeof JSON?JSON:i(17);e.exports=function(e,t){t||(t={}),"function"==typeof t&&(t={cmp:t});var i=t.space||"";"number"==typeof i&&(i=Array(i+1).join(" "));var s="boolean"==typeof t.cycles&&t.cycles,a=t.replacer||function(e,t){return t},l=t.cmp&&function(e){return function(t){return function(i,n){var r={key:i,value:t[i]},o={key:n,value:t[n]};return e(r,o)}}}(t.cmp),c=[];return function e(t,h,d,u){var f=i?"\n"+new Array(u+1).join(i):"",p=i?": ":":";if(d&&d.toJSON&&"function"==typeof d.toJSON&&(d=d.toJSON()),d=a.call(t,h,d),void 0!==d){if("object"!=typeof d||null===d)return n.stringify(d);if(r(d)){for(var m=[],g=0;g<d.length;g++){var v=e(d,g,d[g],u+1)||n.stringify(null);m.push(f+i+v)}return"["+m.join(",")+f+"]"}if(c.indexOf(d)!==-1){if(s)return n.stringify("__cycle__");throw new TypeError("Converting circular structure to JSON")}c.push(d);for(var y=o(d).sort(l&&l(d)),m=[],g=0;g<y.length;g++){var h=y[g],w=e(d,h,d[h],u+1);if(w){var b=n.stringify(h)+p+w;m.push(f+i+b)}}return c.splice(c.indexOf(d),1),"{"+m.join(",")+f+"}"}}({"":e},"",e,0)};var r=Array.isArray||function(e){return"[object Array]"==={}.toString.call(e)},o=Object.keys||function(e){var t=Object.prototype.hasOwnProperty||function(){return!0},i=[];for(var n in e)t.call(e,n)&&i.push(n);return i}},function(e,t,i){t.parse=i(18),t.stringify=i(19)},function(e,t){var i,n,r,o,s={'"':'"',"\\":"\\","/":"/",b:"\b",f:"\f",n:"\n",r:"\r",t:"\t"},a=function(e){throw{name:"SyntaxError",message:e,at:i,text:r}},l=function(e){return e&&e!==n&&a("Expected '"+e+"' instead of '"+n+"'"),n=r.charAt(i),i+=1,n},c=function(){var e,t="";for("-"===n&&(t="-",l("-"));n>="0"&&n<="9";)t+=n,l();if("."===n)for(t+=".";l()&&n>="0"&&n<="9";)t+=n;if("e"===n||"E"===n)for(t+=n,l(),"-"!==n&&"+"!==n||(t+=n,l());n>="0"&&n<="9";)t+=n,l();return e=+t,isFinite(e)?e:void a("Bad number")},h=function(){var e,t,i,r="";if('"'===n)for(;l();){if('"'===n)return l(),r;if("\\"===n)if(l(),"u"===n){for(i=0,t=0;t<4&&(e=parseInt(l(),16),isFinite(e));t+=1)i=16*i+e;r+=String.fromCharCode(i)}else{if("string"!=typeof s[n])break;r+=s[n]}else r+=n}a("Bad string")},d=function(){for(;n&&n<=" ";)l()},u=function(){switch(n){case"t":return l("t"),l("r"),l("u"),l("e"),!0;case"f":return l("f"),l("a"),l("l"),l("s"),l("e"),!1;case"n":return l("n"),l("u"),l("l"),l("l"),null}a("Unexpected '"+n+"'")},f=function(){var e=[];if("["===n){if(l("["),d(),"]"===n)return l("]"),e;for(;n;){if(e.push(o()),d(),"]"===n)return l("]"),e;l(","),d()}}a("Bad array")},p=function(){var e,t={};if("{"===n){if(l("{"),d(),"}"===n)return l("}"),t;for(;n;){if(e=h(),d(),l(":"),Object.hasOwnProperty.call(t,e)&&a('Duplicate key "'+e+'"'),t[e]=o(),d(),"}"===n)return l("}"),t;l(","),d()}}a("Bad object")};o=function(){switch(d(),n){case"{":return p();case"[":return f();case'"':return h();case"-":return c();default:return n>="0"&&n<="9"?c():u()}},e.exports=function(e,t){var s;return r=e,i=0,n=" ",s=o(),d(),n&&a("Syntax error"),"function"==typeof t?function e(i,n){var r,o,s=i[n];if(s&&"object"==typeof s)for(r in s)Object.prototype.hasOwnProperty.call(s,r)&&(o=e(s,r),void 0!==o?s[r]=o:delete s[r]);return t.call(i,n,s)}({"":s},""):s}},function(e,t){function i(e){return a.lastIndex=0,a.test(e)?'"'+e.replace(a,function(e){var t=l[e];return"string"==typeof t?t:"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+e+'"'}function n(e,t){var a,l,c,h,d,u=r,f=t[e];switch(f&&"object"==typeof f&&"function"==typeof f.toJSON&&(f=f.toJSON(e)),"function"==typeof s&&(f=s.call(t,e,f)),typeof f){case"string":return i(f);case"number":return isFinite(f)?String(f):"null";case"boolean":case"null":return String(f);case"object":if(!f)return"null";if(r+=o,d=[],"[object Array]"===Object.prototype.toString.apply(f)){for(h=f.length,a=0;a<h;a+=1)d[a]=n(a,f)||"null";return c=0===d.length?"[]":r?"[\n"+r+d.join(",\n"+r)+"\n"+u+"]":"["+d.join(",")+"]",r=u,c}if(s&&"object"==typeof s)for(h=s.length,a=0;a<h;a+=1)l=s[a],"string"==typeof l&&(c=n(l,f),c&&d.push(i(l)+(r?": ":":")+c));else for(l in f)Object.prototype.hasOwnProperty.call(f,l)&&(c=n(l,f),c&&d.push(i(l)+(r?": ":":")+c));return c=0===d.length?"{}":r?"{\n"+r+d.join(",\n"+r)+"\n"+u+"}":"{"+d.join(",")+"}",r=u,c}}var r,o,s,a=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,l={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"};e.exports=function(e,t,i){var a;if(r="",o="","number"==typeof i)for(a=0;a<i;a+=1)o+=" ";else"string"==typeof i&&(o=i);if(s=t,t&&"function"!=typeof t&&("object"!=typeof t||"number"!=typeof t.length))throw new Error("JSON.stringify");return n("",{"":e})}},function(e,t,i){"use strict";function n(e){r.copy(e,this)}var r=i(15);e.exports=n},function(module,exports,__webpack_require__){"use strict";function setupAsync(e,t){t!==!1&&(t=!0);var i,n=e.async,r=e.transpile;switch(typeof r){case"string":var o=TRANSPILE[r];if(!o)throw new Error("bad transpiler: "+r);return e._transpileFunc=o(e,t);case"undefined":case"boolean":if("string"==typeof n){if(i=ASYNC[n],!i)throw new Error("bad async mode: "+n);return e.transpile=i(e,t)}for(var s=0;s<MODES.length;s++){var a=MODES[s];if(setupAsync(a,!1))return util.copy(a,e),e.transpile}throw new Error("generators, nodent and regenerator are not available");case"function":return e._transpileFunc=e.transpile;default:throw new Error("bad transpiler: "+r)}}function checkGenerators(opts,required){try{return eval("(function*(){})()"),!0}catch(e){if(required)throw new Error("generators not supported")}}function checkAsyncFunction(opts,required){try{return eval("(async function(){})()"),!0}catch(e){if(required)throw new Error("es7 async functions not supported")}}function getRegenerator(e,t){try{return regenerator||(regenerator=__webpack_require__(!function(){var e=new Error('Cannot find module "regenerator"');throw e.code="MODULE_NOT_FOUND",e}()),regenerator.runtime()),e.async&&e.async!==!0||(e.async="es7"),regeneratorTranspile}catch(e){if(t)throw new Error("regenerator not available")}}function regeneratorTranspile(e){return regenerator.compile(e).code}function getNodent(e,t){try{return nodent||(nodent=__webpack_require__(!function(){var e=new Error('Cannot find module "nodent"');throw e.code="MODULE_NOT_FOUND",e}())({log:!1,dontInstallRequireHook:!0})),"es7"!=e.async&&(e.async&&e.async!==!0&&console.warn("nodent transpiles only es7 async functions"),e.async="es7"),nodentTranspile}catch(e){if(t)throw new Error("nodent not available")}}function nodentTranspile(e){return nodent.compile(e,"",{promises:!0,sourcemap:!1}).code}function compileAsync(e,t){function i(e,t,n){function o(n){function o(n,o){if(n)return t(n);if(!r._refs[s]&&!r._schemas[s])try{r.addSchema(o,s)}catch(e){return void t(e)}i(e,t)}var s=n.missingSchema;if(r._refs[s]||r._schemas[s])return t(new Error("Schema "+s+" is loaded but"+n.missingRef+"cannot be resolved"));var a=r._loadingSchemas[s];a?"function"==typeof a?r._loadingSchemas[s]=[a,o]:a[a.length]=o:(r._loadingSchemas[s]=o,r._opts.loadSchema(s,function(e,t){var i=r._loadingSchemas[s];if(delete r._loadingSchemas[s],"function"==typeof i)i(e,t);else for(var n=0;n<i.length;n++)i[n](e,t)}))}function s(e,i){return n?void setTimeout(function(){t(e,i)}):t(e,i)}var a;try{a=r.compile(e)}catch(e){return void(e.missingSchema?o(e):s(e))}s(null,a)}var n,r=this;try{n=this._addSchema(e)}catch(e){return void setTimeout(function(){t(e)})}if(n.validate)setTimeout(function(){t(null,n.validate)});else{if("function"!=typeof this._opts.loadSchema)throw new Error("options.loadSchema should be a function");i(e,t,!0)}}module.exports={setup:setupAsync,compile:compileAsync};var util=__webpack_require__(15),ASYNC={"*":checkGenerators,"co*":checkGenerators,es7:checkAsyncFunction},TRANSPILE={nodent:getNodent,regenerator:getRegenerator},MODES=[{async:"co*"},{async:"es7",transpile:"nodent"},{async:"co*",transpile:"regenerator"}],regenerator,nodent},function(e,t){"use strict";e.exports=function(e,t){function i(e){for(var t=0;t<e.rules.length;t++)if(n(e.rules[t]))return!0}function n(t){return void 0!==e.schema[t.keyword]||"properties"==t.keyword&&(e.schema.additionalProperties===!1||"object"==typeof e.schema.additionalProperties||e.schema.patternProperties&&Object.keys(e.schema.patternProperties).length||e.opts.v5&&e.schema.patternGroups&&Object.keys(e.schema.patternGroups).length)}var r="",o=e.schema.$async===!0;if(e.isTop){var s=e.isTop,a=e.level=0,l=e.dataLevel=0,c="data";if(e.rootId=e.resolve.fullPath(e.root.schema.id),e.baseId=e.baseId||e.rootId,o){e.async=!0;var h="es7"==e.opts.async;e.yieldAwait=h?"await":"yield"}delete e.isTop,e.dataPathArr=[void 0],r+=" validate = ",o?h?r+=" (async function ":("co*"==e.opts.async&&(r+="co.wrap"),r+="(function* "):r+=" (function ",r+=" (data, dataPath, parentData, parentDataProperty) { 'use strict'; var vErrors = null; ",r+=" var errors = 0;     "}else{var a=e.level,l=e.dataLevel,c="data"+(l||"");if(e.schema.id&&(e.baseId=e.resolve.url(e.baseId,e.schema.id)),o&&!e.async)throw new Error("async schema in sync schema");r+=" var errs_"+a+" = errors;"}var d,u="valid"+a,f=!e.opts.allErrors,p="",m="",g=e.schema.type,v=Array.isArray(g);if(g&&e.opts.coerceTypes){var y=e.util.coerceToTypes(g);if(y){var w=e.schemaPath+".type",b=e.errSchemaPath+"/type",A=v?"checkDataTypes":"checkDataType";r+=" if ("+e.util[A](g,c,!0)+") {  ";var C="dataType"+a,E="coerced"+a;r+=" var "+C+" = typeof "+c+"; var "+E+" = undefined; ";var x="",F=y;if(F)for(var k,S=-1,$=F.length-1;S<$;)k=F[S+=1],S&&(r+=" if ("+E+" === undefined) { ",x+="}"),"string"==k?r+=" if ("+C+" == 'number' || "+C+" == 'boolean') "+E+" = '' + "+c+"; else if ("+c+" === null) "+E+" = ''; ":"number"==k||"integer"==k?(r+=" if ("+C+" == 'boolean' || "+c+" === null || ("+C+" == 'string' && "+c+" && "+c+" == +"+c+" ","integer"==k&&(r+=" && !("+c+" % 1)"),r+=")) "+E+" = +"+c+"; "):"boolean"==k?r+=" if ("+c+" === 'false' || "+c+" === 0 || "+c+" === null) "+E+" = false; else if ("+c+" === 'true' || "+c+" === 1) "+E+" = true; ":"null"==k&&(r+=" if ("+c+" === '' || "+c+" === 0 || "+c+" === false) "+E+" = null; ");r+=" "+x+" if ("+E+" === undefined) {   ";var D=D||[];D.push(r),r="",e.createErrors!==!1?(r+=" { keyword: '"+(d||"type")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+b+"\" , params: { type: '",r+=v?""+g.join(","):""+g,r+="' } ",e.opts.messages!==!1&&(r+=" , message: 'should be ",r+=v?""+g.join(","):""+g,r+="' "),e.opts.verbose&&(r+=" , schema: validate.schema"+w+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),r+=" } "):r+=" {} ";var B=r;if(r=D.pop(),r+=!e.compositeRule&&f?e.async?" throw new ValidationError(["+B+"]); ":" validate.errors = ["+B+"]; return false; ":" var err = "+B+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",r+=" } else { ",l){var _="data"+(l-1||""),L=e.dataPathArr[l];r+=" "+c+" = "+_+"["+L+"] = "+E+"; "}else r+=" data = "+E+"; if (parentData !== undefined) parentData[parentDataProperty] = "+E+"; ";r+=" } } "}}var R=e.RULES;if(R)for(var j,T=-1,P=R.length-1;T<P;)if(j=R[T+=1],i(j)){if(j.type&&(r+=" if ("+e.util.checkDataType(j.type,c)+") { "),e.opts.useDefaults&&!e.compositeRule)if("object"==j.type&&e.schema.properties){var M=e.schema.properties,O=Object.keys(M),N=O;if(N)for(var I,W=-1,H=N.length-1;W<H;){I=N[W+=1];var z=M[I];if(void 0!==z.default){var V=c+e.util.getProperty(I);r+="  if ("+V+" === undefined) "+V+" = ",r+="clone"==e.opts.useDefaults?" "+JSON.stringify(z.default)+" ":" "+e.useDefault(z.default)+" ",r+="; "}}}else if("array"==j.type&&Array.isArray(e.schema.items)){var U=e.schema.items;if(U)for(var z,S=-1,K=U.length-1;S<K;)if(z=U[S+=1],void 0!==z.default){var V=c+"["+S+"]";r+="  if ("+V+" === undefined) "+V+" = ",r+="clone"==e.opts.useDefaults?" "+JSON.stringify(z.default)+" ":" "+e.useDefault(z.default)+" ",r+="; "}}var q=j.rules;if(q)for(var G,Y=-1,J=q.length-1;Y<J;)if(G=q[Y+=1],n(G)){if(G.custom){var M=e.schema[G.keyword],Q=e.useCustomRule(G,M,e.schema,e),X=Q.code+".errors",w=e.schemaPath+"."+G.keyword,b=e.errSchemaPath+"/"+G.keyword,Z="errs"+a,S="i"+a,ee="ruleErr"+a,te=G.definition,ie=te.async,ne=te.inline,re=te.macro;if(ie&&!e.async)throw new Error("async keyword in sync schema");if(ne||re||(r+=""+X+" = null;"),r+="var "+Z+" = errors;var valid"+a+";",ne&&te.statements)r+=" "+Q.validate;else if(re){var oe=e.util.copy(e);oe.level++,oe.schema=Q.validate,oe.schemaPath="";var se=e.compositeRule;e.compositeRule=oe.compositeRule=!0;var ae=e.validate(oe).replace(/validate\.schema/g,Q.code);e.compositeRule=oe.compositeRule=se,r+=" "+ae}else if(te.compile||te.validate){var D=D||[];D.push(r),r="",r+="  "+Q.code+".call( ",r+=e.opts.passContext?"this":"self";Q.validate.length;r+=te.compile||te.schema===!1?" , "+c+" ":" , validate.schema"+w+" , "+c+" , validate.schema"+e.schemaPath+" ",r+=" , (dataPath || '')",'""'!=e.errorPath&&(r+=" + "+e.errorPath),r+=l?" , data"+(l-1||"")+" , "+e.dataPathArr[l]+" ":" , parentData , parentDataProperty ",r+=" )  ";var le=r;r=D.pop(),te.errors!==!1&&(ie?(X="customErrors"+a,r+=" var "+X+" = null; try { valid"+a+" = "+e.yieldAwait+le+"; } catch (e) { valid"+a+" = false; if (e instanceof ValidationError) "+X+" = e.errors; else throw e; } "):r+=" "+Q.code+".errors = null; ")}r+="if (! ",r+=ne?te.statements?" valid"+a+" ":" ("+Q.validate+") ":re?" valid"+oe.level+" ":ie?te.errors===!1?" ("+e.yieldAwait+le+") ":" valid"+a+" ":" "+le+" ",r+=") { ",d=G.keyword;var D=D||[];D.push(r),r="";var D=D||[];D.push(r),r="",e.createErrors!==!1?(r+=" { keyword: '"+(d||"custom")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+b+"\" , params: { keyword: '"+G.keyword+"' } ",e.opts.messages!==!1&&(r+=" , message: 'should pass \""+G.keyword+"\" keyword validation' "),e.opts.verbose&&(r+=" , schema: validate.schema"+w+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),r+=" } "):r+=" {} ";var B=r;r=D.pop(),r+=!e.compositeRule&&f?e.async?" throw new ValidationError(["+B+"]); ":" validate.errors = ["+B+"]; return false; ":" var err = "+B+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";var ce=r;r=D.pop(),ne?te.errors?"full"!=te.errors&&(r+="  for (var "+S+"="+Z+"; "+S+"<errors; "+S+"++) { var "+ee+" = vErrors["+S+"]; if ("+ee+".dataPath === undefined) { "+ee+".dataPath = (dataPath || '') + "+e.errorPath+"; } if ("+ee+".schemaPath === undefined) { "+ee+'.schemaPath = "'+b+'"; } ',e.opts.verbose&&(r+=" "+ee+".schema = validate.schema"+w+"; "+ee+".data = "+c+"; "),r+=" } "):te.errors===!1?r+=" "+ce+" ":(r+=" if ("+Z+" == errors) { "+ce+" } else {  for (var "+S+"="+Z+"; "+S+"<errors; "+S+"++) { var "+ee+" = vErrors["+S+"]; if ("+ee+".dataPath === undefined) { "+ee+".dataPath = (dataPath || '') + "+e.errorPath+"; } if ("+ee+".schemaPath === undefined) { "+ee+'.schemaPath = "'+b+'"; } ',e.opts.verbose&&(r+=" "+ee+".schema = validate.schema"+w+"; "+ee+".data = "+c+"; "),r+=" } } "):re?(r+="   var err =   ",e.createErrors!==!1?(r+=" { keyword: '"+(d||"custom")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+b+"\" , params: { keyword: '"+G.keyword+"' } ",e.opts.messages!==!1&&(r+=" , message: 'should pass \""+G.keyword+"\" keyword validation' "),e.opts.verbose&&(r+=" , schema: validate.schema"+w+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),r+=" } "):r+=" {} ",r+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",!e.compositeRule&&f&&(r+=e.async?" throw new ValidationError(vErrors); ":" validate.errors = vErrors; return false ")):te.errors===!1?r+=" "+ce+" ":(r+=" if (Array.isArray("+X+")) { if (vErrors === null) vErrors = "+X+"; else vErrors.concat("+X+"); errors = vErrors.length;  for (var "+S+"="+Z+"; "+S+"<errors; "+S+"++) { var "+ee+" = vErrors["+S+"];  "+ee+".dataPath = (dataPath || '') + "+e.errorPath+";   "+ee+'.schemaPath = "'+b+'";  ',e.opts.verbose&&(r+=" "+ee+".schema = validate.schema"+w+"; "+ee+".data = "+c+"; "),r+=" } } else { "+ce+" } "),d=void 0,r+=" } ",f&&(r+=" else { ")}else r+=" "+G.code(e,G.keyword)+" ";f&&(p+="}")}if(f&&(r+=" "+p+" ",p=""),j.type&&(r+=" } ",g&&g===j.type)){var he=!0;r+=" else { ";var w=e.schemaPath+".type",b=e.errSchemaPath+"/type",D=D||[];D.push(r),r="",e.createErrors!==!1?(r+=" { keyword: '"+(d||"type")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+b+"\" , params: { type: '",r+=v?""+g.join(","):""+g,r+="' } ",e.opts.messages!==!1&&(r+=" , message: 'should be ",r+=v?""+g.join(","):""+g,r+="' "),e.opts.verbose&&(r+=" , schema: validate.schema"+w+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),r+=" } "):r+=" {} ";var B=r;r=D.pop(),r+=!e.compositeRule&&f?e.async?" throw new ValidationError(["+B+"]); ":" validate.errors = ["+B+"]; return false; ":" var err = "+B+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",r+=" } "}f&&(r+=" if (errors === ",r+=s?"0":"errs_"+a,r+=") { ",m+="}")}if(g&&!he&&(!e.opts.coerceTypes||!y)){var w=e.schemaPath+".type",b=e.errSchemaPath+"/type",A=v?"checkDataTypes":"checkDataType";r+=" if ("+e.util[A](g,c,!0)+") {   ";var D=D||[];D.push(r),r="",e.createErrors!==!1?(r+=" { keyword: '"+(d||"type")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+b+"\" , params: { type: '",r+=v?""+g.join(","):""+g,r+="' } ",e.opts.messages!==!1&&(r+=" , message: 'should be ",r+=v?""+g.join(","):""+g,r+="' "),e.opts.verbose&&(r+=" , schema: validate.schema"+w+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),r+=" } "):r+=" {} ";var B=r;r=D.pop(),r+=!e.compositeRule&&f?e.async?" throw new ValidationError(["+B+"]); ":" validate.errors = ["+B+"]; return false; ":" var err = "+B+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",r+=" }"}return f&&(r+=" "+m+" "),s?(o?(r+=" if (errors === 0) return true;           ",r+=" else throw new ValidationError(vErrors); "):(r+=" validate.errors = vErrors; ",r+=" return errors === 0;       "),r+=" });"):r+=" var "+u+" = errors === errs_"+a+";",r=e.util.cleanUpCode(r),s&&f&&(r=e.util.cleanUpVarErrors(r,o)),r}},function(e,t){function i(e){var t=this,i=d.call(arguments,1);return new Promise(function(r,o){function s(t){var i;try{i=e.next(t)}catch(e){return o(e)}c(i)}function l(t){var i;try{i=e.throw(t)}catch(e){return o(e)}c(i)}function c(e){if(e.done)return r(e.value);var i=n.call(t,e.value);return i&&a(i)?i.then(s,l):l(new TypeError('You may only yield a function, promise, generator, array, or object, but the following object was passed: "'+String(e.value)+'"'))}return"function"==typeof e&&(e=e.apply(t,i)),e&&"function"==typeof e.next?void s():r(e)})}function n(e){return e?a(e)?e:c(e)||l(e)?i.call(this,e):"function"==typeof e?r.call(this,e):Array.isArray(e)?o.call(this,e):h(e)?s.call(this,e):e:e}function r(e){var t=this;return new Promise(function(i,n){e.call(t,function(e,t){return e?n(e):(arguments.length>2&&(t=d.call(arguments,1)),void i(t))})})}function o(e){return Promise.all(e.map(n,this))}function s(e){function t(e,t){i[t]=void 0,o.push(e.then(function(e){i[t]=e}))}for(var i=new e.constructor,r=Object.keys(e),o=[],s=0;s<r.length;s++){var l=r[s],c=n.call(this,e[l]);c&&a(c)?t(c,l):i[l]=e[l]}return Promise.all(o).then(function(){return i})}function a(e){return"function"==typeof e.then}function l(e){return"function"==typeof e.next&&"function"==typeof e.throw}function c(e){var t=e.constructor;return!!t&&("GeneratorFunction"===t.name||"GeneratorFunction"===t.displayName||l(t.prototype))}function h(e){return Object==e.constructor}var d=Array.prototype.slice;e.exports=i.default=i.co=i,i.wrap=function(e){function t(){return i.call(this,e.apply(this,arguments))}return t.__generatorFunction__=e,t}},function(e,t){"use strict";function i(e){this.message="validation failed",this.errors=e,this.ajv=this.validation=!0}e.exports=i,i.prototype=Object.create(Error.prototype),i.prototype.constructor=i},function(e,t){"use strict";var i=e.exports=function(){this._cache={}};i.prototype.put=function(e,t){this._cache[e]=t},i.prototype.get=function(e){return this._cache[e]},i.prototype.del=function(e){delete this._cache[e]},i.prototype.clear=function(){this._cache={}}},function(e,t,i){"use strict";function n(e){e="full"==e?"full":"fast";var t=f.copy(n[e]);for(var i in n.compare)t[i]={validate:t[i],compare:n.compare[i]};return t}function r(e){var t=e.match(p);if(!t)return!1;var i=+t[1],n=+t[2];return i>=1&&i<=12&&n>=1&&n<=m[i]}function o(e,t){var i=e.match(g);if(!i)return!1;var n=i[1],r=i[2],o=i[3],s=i[5];return n<=23&&r<=59&&o<=59&&(!t||s)}function s(e){var t=e.split(C);return r(t[0])&&o(t[1],!0)}function a(e){return e.length<=255&&v.test(e)}function l(e){return E.test(e)&&y.test(e)}function c(e){try{return new RegExp(e),!0}catch(e){return!1}}function h(e,t){if(e&&t)return e>t?1:e<t?-1:e===t?0:void 0}function d(e,t){if(e&&t&&(e=e.match(g),t=t.match(g),e&&t))return e=e[1]+e[2]+e[3]+(e[4]||""),t=t[1]+t[2]+t[3]+(t[4]||""),e>t?1:e<t?-1:e===t?0:void 0}function u(e,t){if(e&&t){e=e.split(C),t=t.split(C);var i=h(e[0],t[0]);if(void 0!==i)return i||d(e[1],t[1])}}var f=i(15),p=/^\d\d\d\d-(\d\d)-(\d\d)$/,m=[0,31,29,31,30,31,30,31,31,30,31,30,31],g=/^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d:\d\d)?$/i,v=/^[a-z](?:(?:[-0-9a-z]{0,61})?[0-9a-z])?(\.[a-z](?:(?:[-0-9a-z]{0,61})?[0-9a-z])?)*$/i,y=/^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@\/?]|%[0-9a-f]{2})*)?(?:\#(?:[a-z0-9\-._~!$&'()*+,;=:@\/?]|%[0-9a-f]{2})*)?$/i,w=/^(?:urn\:uuid\:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,b=/^(?:\/(?:[^~\/]|~0|~1)+)*(?:\/)?$|^\#(?:\/(?:[a-z0-9_\-\.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)+)*(?:\/)?$/i,A=/^(?:0|[1-9][0-9]*)(?:\#|(?:\/(?:[^~\/]|~0|~1)+)*(?:\/)?)$/;e.exports=n,n.fast={date:/^\d\d\d\d-[0-1]\d-[0-3]\d$/,time:/^[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?(?:z|[+-]\d\d:\d\d)?$/i,"date-time":/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s][0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?(?:z|[+-]\d\d:\d\d)$/i,uri:/^(?:[a-z][a-z0-9+-.]*)?(?:\:|\/)\/?[^\s]*$/i,email:/^[a-z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,hostname:v,ipv4:/^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,ipv6:/^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,regex:c,uuid:w,"json-pointer":b,"relative-json-pointer":A},n.full={date:r,time:o,"date-time":s,uri:l,email:/^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&''*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,hostname:a,ipv4:/^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,ipv6:/^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,regex:c,uuid:w,"json-pointer":b,"relative-json-pointer":A},n.compare={date:h,time:d,"date-time":u};var C=/t|\s/i,E=/\/|\:/},function(e,t,i){"use strict";var n=i(28),r=i(15);e.exports=function(){var e=[{type:"number",rules:["maximum","minimum","multipleOf"]},{type:"string",rules:["maxLength","minLength","pattern","format"]},{type:"array",rules:["maxItems","minItems","uniqueItems","items"]},{type:"object",rules:["maxProperties","minProperties","required","dependencies","properties"]},{rules:["$ref","enum","not","anyOf","oneOf","allOf"]}];return e.all=["type","additionalProperties","patternProperties"],e.keywords=["additionalItems","$schema","id","title","description","default"],e.types=["number","integer","string","array","object","boolean","null"],e.forEach(function(t){t.rules=t.rules.map(function(t){return e.all.push(t),{keyword:t,code:n[t]}})}),e.keywords=r.toHash(e.all.concat(e.keywords)),e.all=r.toHash(e.all),e.types=r.toHash(e.types),e}},function(e,t,i){"use strict";e.exports={$ref:i(29),allOf:i(30),anyOf:i(31),dependencies:i(32),enum:i(33),format:i(34),items:i(35),maximum:i(36),minimum:i(36),maxItems:i(37),minItems:i(37),maxLength:i(38),minLength:i(38),maxProperties:i(39),minProperties:i(39),multipleOf:i(40),not:i(41),oneOf:i(42),pattern:i(43),properties:i(44),required:i(45),uniqueItems:i(46),validate:i(22)}},function(e,t){"use strict";e.exports=function(e,t){var i,n,r,o=" ",s=e.level,a=e.dataLevel,l=e.schema[t],c=e.errSchemaPath+"/"+t,h=!e.opts.allErrors,d="data"+(a||""),u="valid"+s;if("#"==l||"#/"==l)e.isRoot?(n=e.async,r="validate"):(n=e.root.schema.$async===!0,r="root.refVal[0]");else{var f=e.resolveRef(e.baseId,l,e.isRoot);if(void 0===f){var p="can't resolve reference "+l+" from id "+e.baseId;if("fail"==e.opts.missingRefs){console.log(p);var m=m||[];m.push(o),o="",e.createErrors!==!1?(o+=" { keyword: '"+(i||"$ref")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+c+"\" , params: { ref: '"+e.util.escapeQuotes(l)+"' } ",e.opts.messages!==!1&&(o+=" , message: 'can\\'t resolve reference "+e.util.escapeQuotes(l)+"' "),e.opts.verbose&&(o+=" , schema: "+e.util.toQuotedString(l)+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+d+" "),o+=" } "):o+=" {} ";var g=o;o=m.pop(),o+=!e.compositeRule&&h?e.async?" throw new ValidationError(["+g+"]); ":" validate.errors = ["+g+"]; return false; ":" var err = "+g+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",h&&(o+=" if (false) { ")}else{if("ignore"!=e.opts.missingRefs){var v=new Error(p);throw v.missingRef=e.resolve.url(e.baseId,l),v.missingSchema=e.resolve.normalizeId(e.resolve.fullPath(v.missingRef)),v}console.log(p),h&&(o+=" if (true) { ")}}else if(f.inline){var y=e.util.copy(e);y.level++,y.schema=f.schema,y.schemaPath="",y.errSchemaPath=l;var w=e.validate(y).replace(/validate\.schema/g,f.code);o+=" "+w+" ",h&&(o+=" if (valid"+y.level+") { ")}else n=f.async,r=f.code}if(r){var m=m||[];m.push(o),o="",o+=e.opts.passContext?" "+r+".call(this, ":" "+r+"( ",o+=" "+d+", (dataPath || '')",'""'!=e.errorPath&&(o+=" + "+e.errorPath),o+=a?" , data"+(a-1||"")+" , "+e.dataPathArr[a]+" ":" , parentData , parentDataProperty ",o+=")  ";var b=o;if(o=m.pop(),n){if(!e.async)throw new Error("async schema referenced by sync schema");o+=" try { ",h&&(o+="var "+u+" ="),o+=" "+e.yieldAwait+" "+b+"; } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; } ",h&&(o+=" if ("+u+") { ")}else o+=" if (!"+b+") { if (vErrors === null) vErrors = "+r+".errors; else vErrors = vErrors.concat("+r+".errors); errors = vErrors.length; } ",h&&(o+=" else { ")}return o}},function(e,t){"use strict";e.exports=function(e,t){var i=" ",n=e.schema[t],r=e.schemaPath+"."+t,o=e.errSchemaPath+"/"+t,s=!e.opts.allErrors,a=e.util.copy(e),l="";a.level++;var c=n;if(c)for(var h,d=-1,u=c.length-1;d<u;)h=c[d+=1],e.util.schemaHasRules(h,e.RULES.all)&&(a.schema=h,a.schemaPath=r+"["+d+"]",a.errSchemaPath=o+"/"+d,i+=" "+e.validate(a)+"  ",s&&(i+=" if (valid"+a.level+") { ",l+="}"));return s&&(i+=" "+l.slice(0,-1)),i=e.util.cleanUpCode(i)}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r,u="errs__"+r,f=e.util.copy(e),p="";f.level++;var m=s.every(function(t){return e.util.schemaHasRules(t,e.RULES.all)});if(m){n+=" var "+u+" = errors; var "+d+" = false;  ";var g=e.compositeRule;e.compositeRule=f.compositeRule=!0;var v=s;if(v)for(var y,w=-1,b=v.length-1;w<b;)y=v[w+=1],f.schema=y,f.schemaPath=a+"["+w+"]",f.errSchemaPath=l+"/"+w,n+=" "+e.validate(f)+" "+d+" = "+d+" || valid"+f.level+"; if (!"+d+") { ",p+="}";e.compositeRule=f.compositeRule=g,n+=" "+p+" if (!"+d+") {  var err =   ",e.createErrors!==!1?(n+=" { keyword: '"+(i||"anyOf")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: {} ',e.opts.messages!==!1&&(n+=" , message: 'should match some schema in anyOf' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ",n+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else {  errors = "+u+"; if (vErrors !== null) { if ("+u+") vErrors.length = "+u+"; else vErrors = null; } ",e.opts.allErrors&&(n+=" } "),n=e.util.cleanUpCode(n)}else c&&(n+=" if (true) { ");return n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="errs__"+r,u=e.util.copy(e),f="";u.level++;var p={},m={};for(w in s){var g=s[w],v=Array.isArray(g)?m:p;v[w]=g}n+="var "+d+" = errors;";var y=e.errorPath;n+="var missing"+r+";";for(var w in m){v=m[w],n+=" if ("+h+e.util.getProperty(w)+" !== undefined && ( ";var b=v;if(b)for(var A,C=-1,E=b.length-1;C<E;){A=b[C+=1],C&&(n+=" || ");var x=e.util.getProperty(A);n+=" ( "+h+x+" === undefined && (missing"+r+" = "+e.util.toQuotedString(e.opts.jsonPointers?A:x)+") ) ";
	}n+=")) {  ";var F="missing"+r,k="' + "+F+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.opts.jsonPointers?e.util.getPathExpr(y,F,!0):y+" + "+F);var S=S||[];S.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"dependencies")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { property: '"+e.util.escapeQuotes(w)+"', missingProperty: '"+k+"', depsCount: "+v.length+", deps: '"+e.util.escapeQuotes(1==v.length?v[0]:v.join(", "))+"' } ",e.opts.messages!==!1&&(n+=" , message: 'should have ",n+=1==v.length?"property "+e.util.escapeQuotes(v[0]):"properties "+e.util.escapeQuotes(v.join(", ")),n+=" when property "+e.util.escapeQuotes(w)+" is present' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var $=n;n=S.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+$+"]); ":" validate.errors = ["+$+"]; return false; ":" var err = "+$+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" }   ",c&&(f+="}",n+=" else { ")}e.errorPath=y;for(var w in p){var g=p[w];e.util.schemaHasRules(g,e.RULES.all)&&(n+=" valid"+u.level+" = true; if ("+h+"['"+w+"'] !== undefined) { ",u.schema=g,u.schemaPath=a+e.util.getProperty(w),u.errSchemaPath=l+"/"+e.util.escapeFragment(w),n+=" "+e.validate(u)+" }  ",c&&(n+=" if (valid"+u.level+") { ",f+="}"))}return c&&(n+="   "+f+" if ("+d+" == errors) {"),n=e.util.cleanUpCode(n)}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r,u=e.opts.v5&&s.$data,f=u?e.util.getData(s.$data,o,e.dataPathArr):s;u&&(n+=" var schema"+r+" = "+f+"; ",f="schema"+r);var p="i"+r;u||(n+=" var schema"+r+" = validate.schema"+a+";"),n+="var "+d+";",u&&(n+=" if (schema"+r+" === undefined) "+d+" = true; else if (!Array.isArray(schema"+r+")) "+d+" = false; else {"),n+=""+d+" = false;for (var "+p+"=0; "+p+"<schema"+r+".length; "+p+"++) if (equal("+h+", schema"+r+"["+p+"])) { "+d+" = true; break; }",u&&(n+="  }  "),n+=" if (!"+d+") {   ";var m=m||[];m.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"enum")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: {} ',e.opts.messages!==!1&&(n+=" , message: 'should be equal to one of the allowed values' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var g=n;return n=m.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+g+"]); ":" validate.errors = ["+g+"]; return false; ":" var err = "+g+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" }",c&&(n+=" else { "),n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||"");if(e.opts.format===!1)return c&&(n+=" if (true) { "),n;var d=e.opts.v5&&s.$data,u=d?e.util.getData(s.$data,o,e.dataPathArr):s;if(d&&(n+=" var schema"+r+" = "+u+"; ",u="schema"+r),d){var f="format"+r;n+=" var "+f+" = formats["+u+"]; var isObject"+r+" = typeof "+f+" == 'object' && !("+f+" instanceof RegExp) && "+f+".validate; if (isObject"+r+") { var async"+r+" = "+f+".async; "+f+" = "+f+".validate; } if (  ",d&&(n+=" ("+u+" !== undefined && typeof "+u+" != 'string') || "),n+=" ("+f+" && !(typeof "+f+" == 'function' ? ",n+=e.async?" (async"+r+" ? "+e.yieldAwait+" "+f+"("+h+") : "+f+"("+h+")) ":" "+f+"("+h+") ",n+=" : "+f+".test("+h+")))) {"}else{var f=e.formats[s];if(!f)return c&&(n+=" if (true) { "),n;var p="object"==typeof f&&!(f instanceof RegExp)&&f.validate;if(p){var m=f.async===!0;f=f.validate}if(m){if(!e.async)throw new Error("async format in sync schema");var g="formats"+e.util.getProperty(s)+".validate";n+=" if (!("+e.yieldAwait+" "+g+"("+h+"))) { "}else{n+=" if (! ";var g="formats"+e.util.getProperty(s);p&&(g+=".validate"),n+="function"==typeof f?" "+g+"("+h+") ":" "+g+".test("+h+") ",n+=") { "}}var v=v||[];v.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"format")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { format:  ',n+=d?""+u:""+e.util.toQuotedString(s),n+="  } ",e.opts.messages!==!1&&(n+=" , message: 'should match format \"",n+=d?"' + "+u+" + '":""+e.util.escapeQuotes(s),n+="\"' "),e.opts.verbose&&(n+=" , schema:  ",n+=d?"validate.schema"+a:""+e.util.toQuotedString(s),n+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var y=n;return n=v.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+y+"]); ":" validate.errors = ["+y+"]; return false; ":" var err = "+y+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } ",c&&(n+=" else { "),n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r,u="errs__"+r,f=e.util.copy(e),p="";f.level++;var m=f.dataLevel=e.dataLevel+1,g="data"+m;if(n+="var "+u+" = errors;var "+d+";",Array.isArray(s)){var v=e.schema.additionalItems;if(v===!1){n+=" "+d+" = "+h+".length <= "+s.length+"; ";var y=l;l=e.errSchemaPath+"/additionalItems",n+="  if (!"+d+") {   ";var w=w||[];w.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"additionalItems")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { limit: '+s.length+" } ",e.opts.messages!==!1&&(n+=" , message: 'should NOT have more than "+s.length+" items' "),e.opts.verbose&&(n+=" , schema: false , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var b=n;n=w.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+b+"]); ":" validate.errors = ["+b+"]; return false; ":" var err = "+b+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } ",l=y,c&&(p+="}",n+=" else { ")}var A=s;if(A)for(var C,E=-1,x=A.length-1;E<x;)if(C=A[E+=1],e.util.schemaHasRules(C,e.RULES.all)){n+=" valid"+f.level+" = true; if ("+h+".length > "+E+") { ";var F=h+"["+E+"]";f.schema=C,f.schemaPath=a+"["+E+"]",f.errSchemaPath=l+"/"+E,f.errorPath=e.util.getPathExpr(e.errorPath,E,e.opts.jsonPointers,!0),f.dataPathArr[m]=E;var k=e.validate(f);n+=e.util.varOccurences(k,g)<2?" "+e.util.varReplace(k,g,F)+" ":" var "+g+" = "+F+"; "+k+" ",n+=" }  ",c&&(n+=" if (valid"+f.level+") { ",p+="}")}if("object"==typeof v&&e.util.schemaHasRules(v,e.RULES.all)){f.schema=v,f.schemaPath=e.schemaPath+".additionalItems",f.errSchemaPath=e.errSchemaPath+"/additionalItems",n+=" valid"+f.level+" = true; if ("+h+".length > "+s.length+") {  for (var i"+r+" = "+s.length+"; i"+r+" < "+h+".length; i"+r+"++) { ",f.errorPath=e.util.getPathExpr(e.errorPath,"i"+r,e.opts.jsonPointers,!0);var F=h+"[i"+r+"]";f.dataPathArr[m]="i"+r;var k=e.validate(f);n+=e.util.varOccurences(k,g)<2?" "+e.util.varReplace(k,g,F)+" ":" var "+g+" = "+F+"; "+k+" ",c&&(n+=" if (!valid"+f.level+") break; "),n+=" } }  ",c&&(n+=" if (valid"+f.level+") { ",p+="}")}}else if(e.util.schemaHasRules(s,e.RULES.all)){f.schema=s,f.schemaPath=a,f.errSchemaPath=l,n+="  for (var i"+r+" = 0; i"+r+" < "+h+".length; i"+r+"++) { ",f.errorPath=e.util.getPathExpr(e.errorPath,"i"+r,e.opts.jsonPointers,!0);var F=h+"[i"+r+"]";f.dataPathArr[m]="i"+r;var k=e.validate(f);n+=e.util.varOccurences(k,g)<2?" "+e.util.varReplace(k,g,F)+" ":" var "+g+" = "+F+"; "+k+" ",c&&(n+=" if (!valid"+f.level+") break; "),n+=" }  ",c&&(n+=" if (valid"+f.level+") { ",p+="}")}return c&&(n+=" "+p+" if ("+u+" == errors) {"),n=e.util.cleanUpCode(n)}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d=e.opts.v5&&s.$data,u=d?e.util.getData(s.$data,o,e.dataPathArr):s;d&&(n+=" var schema"+r+" = "+u+"; ",u="schema"+r);var f="maximum"==t,p=f?"exclusiveMaximum":"exclusiveMinimum",m=e.schema[p],g=e.opts.v5&&m&&m.$data,v=f?"<":">",y=f?">":"<";if(g){var w=e.util.getData(m.$data,o,e.dataPathArr),b="exclusive"+r,A="op"+r,C="' + "+A+" + '";n+=" var schemaExcl"+r+" = "+w+"; ",w="schemaExcl"+r,n+=" var exclusive"+r+"; if (typeof "+w+" != 'boolean' && typeof "+w+" != 'undefined') { ";var i=p,E=E||[];E.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"_exclusiveLimit")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: {} ',e.opts.messages!==!1&&(n+=" , message: '"+p+" should be boolean' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var x=n;n=E.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+x+"]); ":" validate.errors = ["+x+"]; return false; ":" var err = "+x+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } else if( ",d&&(n+=" ("+u+" !== undefined && typeof "+u+" != 'number') || "),n+=" ((exclusive"+r+" = "+w+" === true) ? "+h+" "+y+"= "+u+" : "+h+" "+y+" "+u+")) { var op"+r+" = exclusive"+r+" ? '"+v+"' : '"+v+"=';"}else{var b=m===!0,C=v;b||(C+="=");var A="'"+C+"'";n+=" if ( ",d&&(n+=" ("+u+" !== undefined && typeof "+u+" != 'number') || "),n+=" "+h+" "+y,b&&(n+="="),n+=" "+u+") {"}var i=t,E=E||[];E.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"_limit")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { comparison: '+A+", limit: "+u+", exclusive: "+b+" } ",e.opts.messages!==!1&&(n+=" , message: 'should be "+C+" ",n+=d?"' + "+u:""+s+"'"),e.opts.verbose&&(n+=" , schema:  ",n+=d?"validate.schema"+a:""+s,n+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var x=n;return n=E.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+x+"]); ":" validate.errors = ["+x+"]; return false; ":" var err = "+x+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } ",c&&(n+=" else { "),n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d=e.opts.v5&&s.$data,u=d?e.util.getData(s.$data,o,e.dataPathArr):s;d&&(n+=" var schema"+r+" = "+u+"; ",u="schema"+r);var f="maxItems"==t?">":"<";n+="if ( ",d&&(n+=" ("+u+" !== undefined && typeof "+u+" != 'number') || "),n+=" "+h+".length "+f+" "+u+") { ";var i=t,p=p||[];p.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"_limitItems")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { limit: '+u+" } ",e.opts.messages!==!1&&(n+=" , message: 'should NOT have ",n+="maxItems"==t?"more":"less",n+=" than ",n+=d?"' + "+u+" + '":""+s,n+=" items' "),e.opts.verbose&&(n+=" , schema:  ",n+=d?"validate.schema"+a:""+s,n+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var m=n;return n=p.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+m+"]); ":" validate.errors = ["+m+"]; return false; ":" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+="} ",c&&(n+=" else { "),n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d=e.opts.v5&&s.$data,u=d?e.util.getData(s.$data,o,e.dataPathArr):s;d&&(n+=" var schema"+r+" = "+u+"; ",u="schema"+r);var f="maxLength"==t?">":"<";n+="if ( ",d&&(n+=" ("+u+" !== undefined && typeof "+u+" != 'number') || "),n+=e.opts.unicode===!1?" "+h+".length ":" ucs2length("+h+") ",n+=" "+f+" "+u+") { ";var i=t,p=p||[];p.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"_limitLength")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { limit: '+u+" } ",e.opts.messages!==!1&&(n+=" , message: 'should NOT be ",n+="maxLength"==t?"longer":"shorter",n+=" than ",n+=d?"' + "+u+" + '":""+s,n+=" characters' "),e.opts.verbose&&(n+=" , schema:  ",n+=d?"validate.schema"+a:""+s,n+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var m=n;return n=p.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+m+"]); ":" validate.errors = ["+m+"]; return false; ":" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+="} ",c&&(n+=" else { "),n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d=e.opts.v5&&s.$data,u=d?e.util.getData(s.$data,o,e.dataPathArr):s;d&&(n+=" var schema"+r+" = "+u+"; ",u="schema"+r);var f="maxProperties"==t?">":"<";n+="if ( ",d&&(n+=" ("+u+" !== undefined && typeof "+u+" != 'number') || "),n+=" Object.keys("+h+").length "+f+" "+u+") { ";var i=t,p=p||[];p.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"_limitProperties")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { limit: '+u+" } ",e.opts.messages!==!1&&(n+=" , message: 'should NOT have ",n+="maxProperties"==t?"more":"less",n+=" than ",n+=d?"' + "+u+" + '":""+s,n+=" properties' "),e.opts.verbose&&(n+=" , schema:  ",n+=d?"validate.schema"+a:""+s,n+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var m=n;return n=p.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+m+"]); ":" validate.errors = ["+m+"]; return false; ":" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+="} ",c&&(n+=" else { "),n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d=e.opts.v5&&s.$data,u=d?e.util.getData(s.$data,o,e.dataPathArr):s;d&&(n+=" var schema"+r+" = "+u+"; ",u="schema"+r),n+="var division"+r+";if (",d&&(n+=" "+u+" !== undefined && ( typeof "+u+" != 'number' || "),n+=" (division"+r+" = "+h+" / "+u+", ",n+=e.opts.multipleOfPrecision?" Math.abs(Math.round(division"+r+") - division"+r+") > 1e-"+e.opts.multipleOfPrecision+" ":" division"+r+" !== parseInt(division"+r+") ",n+=" ) ",d&&(n+="  )  "),n+=" ) {   ";var f=f||[];f.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"multipleOf")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { multipleOf: '+u+" } ",e.opts.messages!==!1&&(n+=" , message: 'should be multiple of ",n+=d?"' + "+u:""+s+"'"),e.opts.verbose&&(n+=" , schema:  ",n+=d?"validate.schema"+a:""+s,n+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var p=n;return n=f.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+p+"]); ":" validate.errors = ["+p+"]; return false; ":" var err = "+p+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+="} ",c&&(n+=" else { "),n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="errs__"+r,u=e.util.copy(e);if(u.level++,e.util.schemaHasRules(s,e.RULES.all)){u.schema=s,u.schemaPath=a,u.errSchemaPath=l,n+=" var "+d+" = errors;  ";var f=e.compositeRule;e.compositeRule=u.compositeRule=!0,u.createErrors=!1;var p;u.opts.allErrors&&(p=u.opts.allErrors,u.opts.allErrors=!1),n+=" "+e.validate(u)+" ",u.createErrors=!0,p&&(u.opts.allErrors=p),e.compositeRule=u.compositeRule=f,n+=" if (valid"+u.level+") {   ";var m=m||[];m.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"not")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: {} ',e.opts.messages!==!1&&(n+=" , message: 'should NOT be valid' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var g=n;n=m.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+g+"]); ":" validate.errors = ["+g+"]; return false; ":" var err = "+g+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } else {  errors = "+d+"; if (vErrors !== null) { if ("+d+") vErrors.length = "+d+"; else vErrors = null; } ",e.opts.allErrors&&(n+=" } ")}else n+="  var err =   ",e.createErrors!==!1?(n+=" { keyword: '"+(i||"not")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: {} ',e.opts.messages!==!1&&(n+=" , message: 'should NOT be valid' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ",n+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",c&&(n+=" if (false) { ");return n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r,u="errs__"+r,f=e.util.copy(e),p="";f.level++,n+="var "+u+" = errors;var prevValid"+r+" = false;var "+d+" = false; ";var m=e.compositeRule;e.compositeRule=f.compositeRule=!0;var g=s;if(g)for(var v,y=-1,w=g.length-1;y<w;)v=g[y+=1],e.util.schemaHasRules(v,e.RULES.all)?(f.schema=v,f.schemaPath=a+"["+y+"]",f.errSchemaPath=l+"/"+y,n+=" "+e.validate(f)+" "):n+=" var valid"+f.level+" = true; ",y&&(n+=" if (valid"+f.level+" && prevValid"+r+") "+d+" = false; else { ",p+="}"),n+=" if (valid"+f.level+") "+d+" = prevValid"+r+" = true;";e.compositeRule=f.compositeRule=m,n+=""+p+"if (!"+d+") {   ";var b=b||[];b.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"oneOf")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: {} ',e.opts.messages!==!1&&(n+=" , message: 'should match exactly one schema in oneOf' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var A=n;return n=b.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+A+"]); ":" validate.errors = ["+A+"]; return false; ":" var err = "+A+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+="} else {  errors = "+u+"; if (vErrors !== null) { if ("+u+") vErrors.length = "+u+"; else vErrors = null; }",e.opts.allErrors&&(n+=" } "),n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d=e.opts.v5&&s.$data,u=d?e.util.getData(s.$data,o,e.dataPathArr):s;d&&(n+=" var schema"+r+" = "+u+"; ",u="schema"+r);var f=d?"(new RegExp("+u+"))":e.usePattern(s);n+="if ( ",d&&(n+=" ("+u+" !== undefined && typeof "+u+" != 'string') || "),n+=" !"+f+".test("+h+") ) {   ";var p=p||[];p.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"pattern")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { pattern:  ',n+=d?""+u:""+e.util.toQuotedString(s),n+="  } ",e.opts.messages!==!1&&(n+=" , message: 'should match pattern \"",n+=d?"' + "+u+" + '":""+e.util.escapeQuotes(s),n+="\"' "),e.opts.verbose&&(n+=" , schema:  ",n+=d?"validate.schema"+a:""+e.util.toQuotedString(s),n+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var m=n;return n=p.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+m+"]); ":" validate.errors = ["+m+"]; return false; ":" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+="} ",c&&(n+=" else { "),n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r,u="errs__"+r,f=e.util.copy(e),p="";f.level++;var m=f.dataLevel=e.dataLevel+1,g="data"+m,v=Object.keys(s||{}),y=e.schema.patternProperties||{},w=Object.keys(y),b=e.schema.additionalProperties,A=v.length||w.length,C=b===!1,E="object"==typeof b&&Object.keys(b).length,x=e.opts.removeAdditional,F=C||E||x,k=e.schema.required;if(k&&(!e.opts.v5||!k.$data)&&k.length<e.opts.loopRequired)var S=e.util.toHash(k);if(e.opts.v5)var $=e.schema.patternGroups||{},D=Object.keys($);if(n+="var "+u+" = errors;var valid"+f.level+" = true;",F){if(n+=" for (var key"+r+" in "+h+") { ",A){if(n+=" var isAdditional"+r+" = !(false ",v.length)if(v.length>5)n+=" || validate.schema"+a+"[key"+r+"] ";else{var B=v;if(B)for(var _,L=-1,R=B.length-1;L<R;)_=B[L+=1],n+=" || key"+r+" == "+e.util.toQuotedString(_)+" "}if(w.length){var j=w;if(j)for(var T,P=-1,M=j.length-1;P<M;)T=j[P+=1],n+=" || "+e.usePattern(T)+".test(key"+r+") "}if(e.opts.v5&&D&&D.length){var O=D;if(O)for(var N,P=-1,I=O.length-1;P<I;)N=O[P+=1],n+=" || "+e.usePattern(N)+".test(key"+r+") "}n+=" ); if (isAdditional"+r+") { "}if("all"==x)n+=" delete "+h+"[key"+r+"]; ";else{var W=e.errorPath,H="' + key"+r+" + '";if(e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPathExpr(e.errorPath,"key"+r,e.opts.jsonPointers)),C)if(x)n+=" delete "+h+"[key"+r+"]; ";else{n+=" valid"+f.level+" = false; ";var z=l;l=e.errSchemaPath+"/additionalProperties";var V=V||[];V.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"additionalProperties")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { additionalProperty: '"+H+"' } ",e.opts.messages!==!1&&(n+=" , message: 'should NOT have additional properties' "),e.opts.verbose&&(n+=" , schema: false , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var U=n;n=V.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+U+"]); ":" validate.errors = ["+U+"]; return false; ":" var err = "+U+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",l=z,c&&(n+=" break; ")}else if(E)if("failing"==x){n+=" var "+u+" = errors;  ";var K=e.compositeRule;e.compositeRule=f.compositeRule=!0,f.schema=b,f.schemaPath=e.schemaPath+".additionalProperties",f.errSchemaPath=e.errSchemaPath+"/additionalProperties",f.errorPath=e.opts._errorDataPathProperty?e.errorPath:e.util.getPathExpr(e.errorPath,"key"+r,e.opts.jsonPointers);var q=h+"[key"+r+"]";f.dataPathArr[m]="key"+r;var G=e.validate(f);n+=e.util.varOccurences(G,g)<2?" "+e.util.varReplace(G,g,q)+" ":" var "+g+" = "+q+"; "+G+" ",n+=" if (!valid"+f.level+") { errors = "+u+"; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete "+h+"[key"+r+"]; }  ",e.compositeRule=f.compositeRule=K}else{f.schema=b,f.schemaPath=e.schemaPath+".additionalProperties",f.errSchemaPath=e.errSchemaPath+"/additionalProperties",f.errorPath=e.opts._errorDataPathProperty?e.errorPath:e.util.getPathExpr(e.errorPath,"key"+r,e.opts.jsonPointers);var q=h+"[key"+r+"]";f.dataPathArr[m]="key"+r;var G=e.validate(f);n+=e.util.varOccurences(G,g)<2?" "+e.util.varReplace(G,g,q)+" ":" var "+g+" = "+q+"; "+G+" ",c&&(n+=" if (!valid"+f.level+") break; ")}e.errorPath=W}A&&(n+=" } "),n+=" }  ",c&&(n+=" if (valid"+f.level+") { ",p+="}")}var Y=e.opts.useDefaults&&!e.compositeRule;if(v.length){var J=v;if(J)for(var _,Q=-1,X=J.length-1;Q<X;){_=J[Q+=1];var Z=s[_];if(e.util.schemaHasRules(Z,e.RULES.all)){var ee=e.util.getProperty(_),q=h+ee,te=Y&&void 0!==Z.default;f.schema=Z,f.schemaPath=a+ee,f.errSchemaPath=l+"/"+e.util.escapeFragment(_),f.errorPath=e.util.getPath(e.errorPath,_,e.opts.jsonPointers),f.dataPathArr[m]=e.util.toQuotedString(_);var G=e.validate(f);if(e.util.varOccurences(G,g)<2){G=e.util.varReplace(G,g,q);var ie=q}else{var ie=g;n+=" var "+g+" = "+q+"; "}if(te)n+=" "+G+" ";else{if(S&&S[_]){n+=" if ("+ie+" === undefined) { valid"+f.level+" = false; ";var W=e.errorPath,z=l,ne=e.util.escapeQuotes(_);e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPath(W,_,e.opts.jsonPointers)),l=e.errSchemaPath+"/required";var V=V||[];V.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"required")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { missingProperty: '"+ne+"' } ",e.opts.messages!==!1&&(n+=" , message: '",n+=e.opts._errorDataPathProperty?"is a required property":"should have required property \\'"+ne+"\\'",n+="' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var U=n;n=V.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+U+"]); ":" validate.errors = ["+U+"]; return false; ":" var err = "+U+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",l=z,e.errorPath=W,n+=" } else { "}else n+=c?" if ("+ie+" === undefined) { valid"+f.level+" = true; } else { ":" if ("+ie+" !== undefined) { ";n+=" "+G+" } "}}c&&(n+=" if (valid"+f.level+") { ",p+="}")}}var re=w;if(re)for(var T,oe=-1,se=re.length-1;oe<se;){T=re[oe+=1];var Z=y[T];if(e.util.schemaHasRules(Z,e.RULES.all)){f.schema=Z,f.schemaPath=e.schemaPath+".patternProperties"+e.util.getProperty(T),f.errSchemaPath=e.errSchemaPath+"/patternProperties/"+e.util.escapeFragment(T),n+=" for (var key"+r+" in "+h+") { if ("+e.usePattern(T)+".test(key"+r+")) { ",f.errorPath=e.util.getPathExpr(e.errorPath,"key"+r,e.opts.jsonPointers);var q=h+"[key"+r+"]";f.dataPathArr[m]="key"+r;var G=e.validate(f);n+=e.util.varOccurences(G,g)<2?" "+e.util.varReplace(G,g,q)+" ":" var "+g+" = "+q+"; "+G+" ",c&&(n+=" if (!valid"+f.level+") break; "),n+=" } ",c&&(n+=" else valid"+f.level+" = true; "),n+=" }  ",c&&(n+=" if (valid"+f.level+") { ",p+="}")}}if(e.opts.v5){var ae=D;if(ae)for(var N,le=-1,ce=ae.length-1;le<ce;){N=ae[le+=1];var he=$[N],Z=he.schema;if(e.util.schemaHasRules(Z,e.RULES.all)){f.schema=Z,f.schemaPath=e.schemaPath+".patternGroups"+e.util.getProperty(N)+".schema",f.errSchemaPath=e.errSchemaPath+"/patternGroups/"+e.util.escapeFragment(N)+"/schema",n+=" var pgPropCount"+r+" = 0; for (var key"+r+" in "+h+") { if ("+e.usePattern(N)+".test(key"+r+")) { pgPropCount"+r+"++; ",f.errorPath=e.util.getPathExpr(e.errorPath,"key"+r,e.opts.jsonPointers);var q=h+"[key"+r+"]";f.dataPathArr[m]="key"+r;var G=e.validate(f);n+=e.util.varOccurences(G,g)<2?" "+e.util.varReplace(G,g,q)+" ":" var "+g+" = "+q+"; "+G+" ",c&&(n+=" if (!valid"+f.level+") break; "),n+=" } ",c&&(n+=" else valid"+f.level+" = true; "),n+=" }  ",c&&(n+=" if (valid"+f.level+") { ",p+="}");var de=he.minimum,ue=he.maximum;if(void 0!==de||void 0!==ue){n+=" var "+d+" = true; ";var z=l;if(void 0!==de){var fe=de,pe="minimum",me="less";n+=" "+d+" = pgPropCount"+r+" >= "+de+"; ",l=e.errSchemaPath+"/patternGroups/minimum",n+="  if (!"+d+") {   ";var V=V||[];V.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"patternGroups")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { reason: '"+pe+"', limit: "+fe+", pattern: '"+e.util.escapeQuotes(N)+"' } ",e.opts.messages!==!1&&(n+=" , message: 'should NOT have "+me+" than "+fe+' properties matching pattern "'+e.util.escapeQuotes(N)+"\"' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var U=n;n=V.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+U+"]); ":" validate.errors = ["+U+"]; return false; ":" var err = "+U+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } ",void 0!==ue&&(n+=" else ")}if(void 0!==ue){var fe=ue,pe="maximum",me="more";n+=" "+d+" = pgPropCount"+r+" <= "+ue+"; ",l=e.errSchemaPath+"/patternGroups/maximum",n+="  if (!"+d+") {   ";var V=V||[];V.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"patternGroups")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { reason: '"+pe+"', limit: "+fe+", pattern: '"+e.util.escapeQuotes(N)+"' } ",e.opts.messages!==!1&&(n+=" , message: 'should NOT have "+me+" than "+fe+' properties matching pattern "'+e.util.escapeQuotes(N)+"\"' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var U=n;n=V.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+U+"]); ":" validate.errors = ["+U+"]; return false; ":" var err = "+U+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } "}l=z,c&&(n+=" if ("+d+") { ",p+="}")}}}}return c&&(n+=" "+p+" if ("+u+" == errors) {"),n=e.util.cleanUpCode(n)}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r,u=e.opts.v5&&s.$data,f=u?e.util.getData(s.$data,o,e.dataPathArr):s;if(u&&(n+=" var schema"+r+" = "+f+"; ",f="schema"+r),!u)if(s.length<e.opts.loopRequired&&e.schema.properties&&Object.keys(e.schema.properties).length){var p=[],m=s;if(m)for(var g,v=-1,y=m.length-1;v<y;){g=m[v+=1];var w=e.schema.properties[g];w&&e.util.schemaHasRules(w,e.RULES.all)||(p[p.length]=g)}}else var p=s;if(u||p.length){var b=e.errorPath,A=u||p.length>=e.opts.loopRequired;if(c)if(n+=" var missing"+r+"; ",A){u||(n+=" var schema"+r+" = validate.schema"+a+"; ");var C="i"+r,E="schema"+r+"["+C+"]",x="' + "+E+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPathExpr(b,E,e.opts.jsonPointers)),n+=" var "+d+" = true; ",u&&(n+=" if (schema"+r+" === undefined) "+d+" = true; else if (!Array.isArray(schema"+r+")) "+d+" = false; else {"),n+=" for (var "+C+" = 0; "+C+" < schema"+r+".length; "+C+"++) { "+d+" = "+h+"[schema"+r+"["+C+"]] !== undefined; if (!"+d+") break; } ",u&&(n+="  }  "),n+="  if (!"+d+") {   ";var F=F||[];F.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"required")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { missingProperty: '"+x+"' } ",e.opts.messages!==!1&&(n+=" , message: '",n+=e.opts._errorDataPathProperty?"is a required property":"should have required property \\'"+x+"\\'",n+="' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var k=n;n=F.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+k+"]); ":" validate.errors = ["+k+"]; return false; ":" var err = "+k+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } else { "}else{n+=" if ( ";var S=p;if(S)for(var $,C=-1,D=S.length-1;C<D;){$=S[C+=1],C&&(n+=" || ");var B=e.util.getProperty($);n+=" ( "+h+B+" === undefined && (missing"+r+" = "+e.util.toQuotedString(e.opts.jsonPointers?$:B)+") ) "}n+=") {  ";var E="missing"+r,x="' + "+E+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.opts.jsonPointers?e.util.getPathExpr(b,E,!0):b+" + "+E);var F=F||[];F.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"required")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { missingProperty: '"+x+"' } ",e.opts.messages!==!1&&(n+=" , message: '",n+=e.opts._errorDataPathProperty?"is a required property":"should have required property \\'"+x+"\\'",n+="' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var k=n;n=F.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+k+"]); ":" validate.errors = ["+k+"]; return false; ":" var err = "+k+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } else { "}else if(A){u||(n+=" var schema"+r+" = validate.schema"+a+"; ");var C="i"+r,E="schema"+r+"["+C+"]",x="' + "+E+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPathExpr(b,E,e.opts.jsonPointers)),u&&(n+=" if (schema"+r+" && !Array.isArray(schema"+r+")) {  var err =   ",
	e.createErrors!==!1?(n+=" { keyword: '"+(i||"required")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { missingProperty: '"+x+"' } ",e.opts.messages!==!1&&(n+=" , message: '",n+=e.opts._errorDataPathProperty?"is a required property":"should have required property \\'"+x+"\\'",n+="' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ",n+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (schema"+r+" !== undefined) { "),n+=" for (var "+C+" = 0; "+C+" < schema"+r+".length; "+C+"++) { if ("+h+"[schema"+r+"["+C+"]] === undefined) {  var err =   ",e.createErrors!==!1?(n+=" { keyword: '"+(i||"required")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { missingProperty: '"+x+"' } ",e.opts.messages!==!1&&(n+=" , message: '",n+=e.opts._errorDataPathProperty?"is a required property":"should have required property \\'"+x+"\\'",n+="' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ",n+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ",u&&(n+="  }  ")}else{var _=p;if(_)for(var g,C=-1,L=_.length-1;C<L;){g=_[C+=1];var B=e.util.getProperty(g),x=e.util.escapeQuotes(g);e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPath(b,g,e.opts.jsonPointers)),n+=" if ("+h+B+" === undefined) {  var err =   ",e.createErrors!==!1?(n+=" { keyword: '"+(i||"required")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { missingProperty: '"+x+"' } ",e.opts.messages!==!1&&(n+=" , message: '",n+=e.opts._errorDataPathProperty?"is a required property":"should have required property \\'"+x+"\\'",n+="' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ",n+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } "}}e.errorPath=b}else c&&(n+=" if (true) {");return n}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r,u=e.opts.v5&&s.$data,f=u?e.util.getData(s.$data,o,e.dataPathArr):s;if(u&&(n+=" var schema"+r+" = "+f+"; ",f="schema"+r),(s||u)&&e.opts.uniqueItems!==!1){u&&(n+=" var "+d+"; if ("+f+" === false || "+f+" === undefined) "+d+" = true; else if (typeof "+f+" != 'boolean') "+d+" = false; else { "),n+=" var "+d+" = true; if ("+h+".length > 1) { var i = "+h+".length, j; outer: for (;i--;) { for (j = i; j--;) { if (equal("+h+"[i], "+h+"[j])) { "+d+" = false; break outer; } } } } ",u&&(n+="  }  "),n+=" if (!"+d+") {   ";var p=p||[];p.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"uniqueItems")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { i: i, j: j } ',e.opts.messages!==!1&&(n+=" , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "),e.opts.verbose&&(n+=" , schema:  ",n+=u?"validate.schema"+a:""+s,n+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var m=n;n=p.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+m+"]); ":" validate.errors = ["+m+"]; return false; ":" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } ",c&&(n+=" else { ")}else c&&(n+=" if (true) { ");return n}},function(e,t,i){"use strict";function n(e){function t(t,i,r){var o={inline:r||n[t],statements:!0,errors:"full"};i&&(o.type=i),e.addKeyword(t,o)}var n={switch:i(48),constant:i(49),_formatLimit:i(50),patternRequired:i(51)};if(e._opts.meta!==!1){var s=i(52);e.addMetaSchema(s,o)}t("constant"),e.addKeyword("contains",{type:"array",macro:r}),t("formatMaximum","string",n._formatLimit),t("formatMinimum","string",n._formatLimit),e.addKeyword("exclusiveFormatMaximum"),e.addKeyword("exclusiveFormatMinimum"),e.addKeyword("patternGroups"),t("patternRequired","object"),t("switch")}function r(e){return{not:{items:{not:e}}}}var o="https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/json-schema-v5.json";e.exports={enable:n,META_SCHEMA_ID:o}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r,u="errs__"+r,f=e.util.copy(e),p="";f.level++;var m,g="ifPassed"+e.level;n+="var "+g+";";var v=s;if(v)for(var y,w=-1,b=v.length-1;w<b;){if(y=v[w+=1],w&&!m&&(n+=" if (!"+g+") { ",p+="}"),y.if&&e.util.schemaHasRules(y.if,e.RULES.all)){n+=" var "+u+" = errors;   ";var A=e.compositeRule;if(e.compositeRule=f.compositeRule=!0,f.createErrors=!1,f.schema=y.if,f.schemaPath=a+"["+w+"].if",f.errSchemaPath=l+"/"+w+"/if",n+=" "+e.validate(f)+" ",f.createErrors=!0,e.compositeRule=f.compositeRule=A,n+=" "+g+" = valid"+f.level+"; if ("+g+") {  ","boolean"==typeof y.then){if(y.then===!1){var C=C||[];C.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"switch")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { caseIndex: '+w+" } ",e.opts.messages!==!1&&(n+=" , message: 'should pass \"switch\" keyword validation' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var E=n;n=C.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+E+"]); ":" validate.errors = ["+E+"]; return false; ":" var err = "+E+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; "}n+=" var valid"+f.level+" = "+y.then+"; "}else f.schema=y.then,f.schemaPath=a+"["+w+"].then",f.errSchemaPath=l+"/"+w+"/then",n+=" "+e.validate(f)+" ";n+="  } else {  errors = "+u+"; if (vErrors !== null) { if ("+u+") vErrors.length = "+u+"; else vErrors = null; } } "}else if(n+=" "+g+" = true;  ","boolean"==typeof y.then){if(y.then===!1){var C=C||[];C.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"switch")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { caseIndex: '+w+" } ",e.opts.messages!==!1&&(n+=" , message: 'should pass \"switch\" keyword validation' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var E=n;n=C.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+E+"]); ":" validate.errors = ["+E+"]; return false; ":" var err = "+E+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; "}n+=" var valid"+f.level+" = "+y.then+"; "}else f.schema=y.then,f.schemaPath=a+"["+w+"].then",f.errSchemaPath=l+"/"+w+"/then",n+=" "+e.validate(f)+" ";m=y.continue}return n+=""+p+"var "+d+" = valid"+f.level+"; ",n=e.util.cleanUpCode(n)}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r,u=e.opts.v5&&s.$data,f=u?e.util.getData(s.$data,o,e.dataPathArr):s;u&&(n+=" var schema"+r+" = "+f+"; ",f="schema"+r),u||(n+=" var schema"+r+" = validate.schema"+a+";"),n+="var "+d+" = equal("+h+", schema"+r+"); if (!"+d+") {   ";var p=p||[];p.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"constant")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: {} ',e.opts.messages!==!1&&(n+=" , message: 'should be equal to constant' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var m=n;return n=p.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+m+"]); ":" validate.errors = ["+m+"]; return false; ":" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" }"}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r;if(n+="var "+d+" = undefined;",e.opts.format===!1)return n+=" "+d+" = true; ";var u=e.schema.format,f=e.opts.v5&&u.$data,p="";if(f){var m=e.util.getData(u.$data,o,e.dataPathArr),g="format"+r,v="compare"+r;n+=" var "+g+" = formats["+m+"] , "+v+" = "+g+" && "+g+".compare;"}else{var g=e.formats[u];if(!g||!g.compare)return n+="  "+d+" = true; ";var v="formats"+e.util.getProperty(u)+".compare"}var y="formatMaximum"==t,w="exclusiveFormat"+(y?"Maximum":"Minimum"),b=e.schema[w],A=e.opts.v5&&b&&b.$data,C=y?"<":">",E="result"+r,x=e.opts.v5&&s.$data,F=x?e.util.getData(s.$data,o,e.dataPathArr):s;if(x&&(n+=" var schema"+r+" = "+F+"; ",F="schema"+r),A){var k=e.util.getData(b.$data,o,e.dataPathArr),S="exclusive"+r,$="op"+r,D="' + "+$+" + '";n+=" var schemaExcl"+r+" = "+k+"; ",k="schemaExcl"+r,n+=" if (typeof "+k+" != 'boolean' && "+k+" !== undefined) { "+d+" = false; ";var i=w,B=B||[];B.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"_exclusiveFormatLimit")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: {} ',e.opts.messages!==!1&&(n+=" , message: '"+w+" should be boolean' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var _=n;n=B.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+_+"]); ":" validate.errors = ["+_+"]; return false; ":" var err = "+_+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" }  ",c&&(p+="}",n+=" else { "),x&&(n+=" if ("+F+" === undefined) "+d+" = true; else if (typeof "+F+" != 'string') "+d+" = false; else { ",p+="}"),f&&(n+=" if (!"+v+") "+d+" = true; else { ",p+="}"),n+=" var "+E+" = "+v+"("+h+",  ",n+=x?""+F:""+e.util.toQuotedString(s),n+=" ); if ("+E+" === undefined) "+d+" = false; var exclusive"+r+" = "+k+" === true; if ("+d+" === undefined) { "+d+" = exclusive"+r+" ? "+E+" "+C+" 0 : "+E+" "+C+"= 0; } if (!"+d+") var op"+r+" = exclusive"+r+" ? '"+C+"' : '"+C+"=';"}else{var S=b===!0,D=C;S||(D+="=");var $="'"+D+"'";x&&(n+=" if ("+F+" === undefined) "+d+" = true; else if (typeof "+F+" != 'string') "+d+" = false; else { ",p+="}"),f&&(n+=" if (!"+v+") "+d+" = true; else { ",p+="}"),n+=" var "+E+" = "+v+"("+h+",  ",n+=x?""+F:""+e.util.toQuotedString(s),n+=" ); if ("+E+" === undefined) "+d+" = false; if ("+d+" === undefined) "+d+" = "+E+" "+C,S||(n+="="),n+=" 0;"}n+=""+p+"if (!"+d+") { ";var i=t,B=B||[];B.push(n),n="",e.createErrors!==!1?(n+=" { keyword: '"+(i||"_formatLimit")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+'" , params: { limit:  ',n+=x?""+F:""+e.util.toQuotedString(s),n+="  } ",e.opts.messages!==!1&&(n+=" , message: 'should be "+D+' "',n+=x?"' + "+F+" + '":""+e.util.escapeQuotes(s),n+="\"' "),e.opts.verbose&&(n+=" , schema:  ",n+=x?"validate.schema"+a:""+e.util.toQuotedString(s),n+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var _=n;return n=B.pop(),n+=!e.compositeRule&&c?e.async?" throw new ValidationError(["+_+"]); ":" validate.errors = ["+_+"]; return false; ":" var err = "+_+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+="}"}},function(e,t){"use strict";e.exports=function(e,t){var i,n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+"."+t,l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||""),d="valid"+r,u="key"+r,f="patternMatched"+r,p="";n+="var "+d+" = true;";var m=s;if(m)for(var g,v=-1,y=m.length-1;v<y;){g=m[v+=1],n+=" var "+f+" = false; for (var "+u+" in "+h+") { "+f+" = "+e.usePattern(g)+".test("+u+"); if ("+f+") break; } ";var w=e.util.escapeQuotes(g);n+=" if (!"+f+") { "+d+" = false;  var err =   ",e.createErrors!==!1?(n+=" { keyword: '"+(i||"patternRequired")+"' , dataPath: (dataPath || '') + "+e.errorPath+' , schemaPath: "'+l+"\" , params: { missingPattern: '"+w+"' } ",e.opts.messages!==!1&&(n+=" , message: 'should have property matching pattern \\'"+w+"\\'' "),e.opts.verbose&&(n+=" , schema: validate.schema"+a+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ",n+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; }   ",c&&(p+="}",n+=" else { ")}return n+=""+p}},function(e,t){e.exports='{\n    "id": "https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/json-schema-v5.json#",\n    "$schema": "http://json-schema.org/draft-04/schema#",\n    "description": "Core schema meta-schema (v5 proposals)",\n    "definitions": {\n        "schemaArray": {\n            "type": "array",\n            "minItems": 1,\n            "items": { "$ref": "#" }\n        },\n        "positiveInteger": {\n            "type": "integer",\n            "minimum": 0\n        },\n        "positiveIntegerDefault0": {\n            "allOf": [ { "$ref": "#/definitions/positiveInteger" }, { "default": 0 } ]\n        },\n        "simpleTypes": {\n            "enum": [ "array", "boolean", "integer", "null", "number", "object", "string" ]\n        },\n        "stringArray": {\n            "type": "array",\n            "items": { "type": "string" },\n            "minItems": 1,\n            "uniqueItems": true\n        },\n        "$data": {\n            "type": "object",\n            "required": [ "$data" ],\n            "properties": {\n                "$data": {\n                    "type": "string",\n                    "format": "relative-json-pointer"\n                }\n            },\n            "additionalProperties": false\n        }\n    },\n    "type": "object",\n    "properties": {\n        "id": {\n            "type": "string",\n            "format": "uri"\n        },\n        "$schema": {\n            "type": "string",\n            "format": "uri"\n        },\n        "title": {\n            "type": "string"\n        },\n        "description": {\n            "type": "string"\n        },\n        "default": {},\n        "multipleOf": {\n            "anyOf": [\n                {\n                    "type": "number",\n                    "minimum": 0,\n                    "exclusiveMinimum": true\n                },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "maximum": {\n            "anyOf": [\n                { "type": "number" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "exclusiveMaximum": {\n            "anyOf": [\n                {\n                    "type": "boolean",\n                    "default": false\n                },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "minimum": {\n            "anyOf": [\n                { "type": "number" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "exclusiveMinimum": {\n            "anyOf": [\n                {\n                    "type": "boolean",\n                    "default": false\n                },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "maxLength": {\n            "anyOf": [\n                { "$ref": "#/definitions/positiveInteger" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "minLength": {\n            "anyOf": [\n                { "$ref": "#/definitions/positiveIntegerDefault0" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "pattern": {\n            "anyOf": [\n                {\n                    "type": "string",\n                    "format": "regex"\n                },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "additionalItems": {\n            "anyOf": [\n                { "type": "boolean" },\n                { "$ref": "#" },\n                { "$ref": "#/definitions/$data" }\n            ],\n            "default": {}\n        },\n        "items": {\n            "anyOf": [\n                { "$ref": "#" },\n                { "$ref": "#/definitions/schemaArray" }\n            ],\n            "default": {}\n        },\n        "maxItems": {\n            "anyOf": [\n                { "$ref": "#/definitions/positiveInteger" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "minItems": {\n            "anyOf": [\n                { "$ref": "#/definitions/positiveIntegerDefault0" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "uniqueItems": {\n            "anyOf": [\n                {\n                    "type": "boolean",\n                    "default": false\n                },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "maxProperties": {\n            "anyOf": [\n                { "$ref": "#/definitions/positiveInteger" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "minProperties": {\n            "anyOf": [\n                { "$ref": "#/definitions/positiveIntegerDefault0" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "required": {\n            "anyOf": [\n                { "$ref": "#/definitions/stringArray" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "additionalProperties": {\n            "anyOf": [\n                { "type": "boolean" },\n                { "$ref": "#" },\n                { "$ref": "#/definitions/$data" }\n            ],\n            "default": {}\n        },\n        "definitions": {\n            "type": "object",\n            "additionalProperties": { "$ref": "#" },\n            "default": {}\n        },\n        "properties": {\n            "type": "object",\n            "additionalProperties": { "$ref": "#" },\n            "default": {}\n        },\n        "patternProperties": {\n            "type": "object",\n            "additionalProperties": { "$ref": "#" },\n            "default": {}\n        },\n        "dependencies": {\n            "type": "object",\n            "additionalProperties": {\n                "anyOf": [\n                    { "$ref": "#" },\n                    { "$ref": "#/definitions/stringArray" }\n                ]\n            }\n        },\n        "enum": {\n            "anyOf": [\n                {\n                    "type": "array",\n                    "minItems": 1,\n                    "uniqueItems": true\n                },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "type": {\n            "anyOf": [\n                { "$ref": "#/definitions/simpleTypes" },\n                {\n                    "type": "array",\n                    "items": { "$ref": "#/definitions/simpleTypes" },\n                    "minItems": 1,\n                    "uniqueItems": true\n                }\n            ]\n        },\n        "allOf": { "$ref": "#/definitions/schemaArray" },\n        "anyOf": { "$ref": "#/definitions/schemaArray" },\n        "oneOf": { "$ref": "#/definitions/schemaArray" },\n        "not": { "$ref": "#" },\n        "format": {\n            "anyOf": [\n                { "type": "string" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "formatMaximum": {\n            "anyOf": [\n                { "type": "string" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "formatMinimum": {\n            "anyOf": [\n                { "type": "string" },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "exclusiveFormatMaximum": {\n            "anyOf": [\n                {\n                    "type": "boolean",\n                    "default": false\n                },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "exclusiveFormatMinimum": {\n            "anyOf": [\n                {\n                    "type": "boolean",\n                    "default": false\n                },\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "constant": {\n            "anyOf": [\n                {},\n                { "$ref": "#/definitions/$data" }\n            ]\n        },\n        "contains": { "$ref": "#" },\n        "patternGroups": {\n            "type": "object",\n            "additionalProperties": {\n                "type": "object",\n                "required": [ "schema" ],\n                "properties": {\n                    "maximum": {\n                        "anyOf": [\n                            { "$ref": "#/definitions/positiveInteger" },\n                            { "$ref": "#/definitions/$data" }\n                        ]\n                    },\n                    "minimum": {\n                        "anyOf": [\n                            { "$ref": "#/definitions/positiveIntegerDefault0" },\n                            { "$ref": "#/definitions/$data" }\n                        ]\n                    },\n                    "schema": { "$ref": "#" }\n                },\n                "additionalProperties": false\n            },\n            "default": {}\n        },\n        "switch": {\n            "type": "array",\n            "items": {\n                "required": [ "then" ],\n                "properties": {\n                    "if": { "$ref": "#" },\n                    "then": {\n                        "anyOf": [\n                            { "type": "boolean" },\n                            { "$ref": "#" }\n                        ]\n                    },\n                    "continue": { "type": "boolean" }\n                },\n                "additionalProperties": false,\n                "dependencies": {\n                    "continue": [ "if" ]\n                }\n            }\n        }\n    },\n    "dependencies": {\n        "exclusiveMaximum": [ "maximum" ],\n        "exclusiveMinimum": [ "minimum" ],\n        "formatMaximum": [ "format" ],\n        "formatMinimum": [ "format" ],\n        "exclusiveFormatMaximum": [ "formatMaximum" ],\n        "exclusiveFormatMinimum": [ "formatMinimum" ]\n    },\n    "default": {}\n}\n'},function(e,t){"use strict";var i=/^[a-z_$][a-z0-9_$]*$/i;e.exports=function(e,t){function n(e,t,i){for(var n,r=0;r<o.RULES.length;r++){var s=o.RULES[r];if(s.type==t){n=s;break}}n||(n={type:t,rules:[]},o.RULES.push(n));var a={keyword:e,definition:i,custom:!0};n.rules.push(a)}function r(e){if(!o.RULES.types[e])throw new Error("Unknown type "+e)}var o=this;if(this.RULES.keywords[e])throw new Error("Keyword "+e+" is already defined");if(!i.test(e))throw new Error("Keyword "+e+" is not a valid identifier");if(t){var s=t.type;if(Array.isArray(s)){var a,l=s.length;for(a=0;a<l;a++)r(s[a]);for(a=0;a<l;a++)n(e,s[a],t)}else s&&r(s),n(e,s,t)}this.RULES.keywords[e]=!0,this.RULES.all[e]=!0}},function(e,t){e.exports='{\n    "id": "http://json-schema.org/draft-04/schema#",\n    "$schema": "http://json-schema.org/draft-04/schema#",\n    "description": "Core schema meta-schema",\n    "definitions": {\n        "schemaArray": {\n            "type": "array",\n            "minItems": 1,\n            "items": { "$ref": "#" }\n        },\n        "positiveInteger": {\n            "type": "integer",\n            "minimum": 0\n        },\n        "positiveIntegerDefault0": {\n            "allOf": [ { "$ref": "#/definitions/positiveInteger" }, { "default": 0 } ]\n        },\n        "simpleTypes": {\n            "enum": [ "array", "boolean", "integer", "null", "number", "object", "string" ]\n        },\n        "stringArray": {\n            "type": "array",\n            "items": { "type": "string" },\n            "minItems": 1,\n            "uniqueItems": true\n        }\n    },\n    "type": "object",\n    "properties": {\n        "id": {\n            "type": "string",\n            "format": "uri"\n        },\n        "$schema": {\n            "type": "string",\n            "format": "uri"\n        },\n        "title": {\n            "type": "string"\n        },\n        "description": {\n            "type": "string"\n        },\n        "default": {},\n        "multipleOf": {\n            "type": "number",\n            "minimum": 0,\n            "exclusiveMinimum": true\n        },\n        "maximum": {\n            "type": "number"\n        },\n        "exclusiveMaximum": {\n            "type": "boolean",\n            "default": false\n        },\n        "minimum": {\n            "type": "number"\n        },\n        "exclusiveMinimum": {\n            "type": "boolean",\n            "default": false\n        },\n        "maxLength": { "$ref": "#/definitions/positiveInteger" },\n        "minLength": { "$ref": "#/definitions/positiveIntegerDefault0" },\n        "pattern": {\n            "type": "string",\n            "format": "regex"\n        },\n        "additionalItems": {\n            "anyOf": [\n                { "type": "boolean" },\n                { "$ref": "#" }\n            ],\n            "default": {}\n        },\n        "items": {\n            "anyOf": [\n                { "$ref": "#" },\n                { "$ref": "#/definitions/schemaArray" }\n            ],\n            "default": {}\n        },\n        "maxItems": { "$ref": "#/definitions/positiveInteger" },\n        "minItems": { "$ref": "#/definitions/positiveIntegerDefault0" },\n        "uniqueItems": {\n            "type": "boolean",\n            "default": false\n        },\n        "maxProperties": { "$ref": "#/definitions/positiveInteger" },\n        "minProperties": { "$ref": "#/definitions/positiveIntegerDefault0" },\n        "required": { "$ref": "#/definitions/stringArray" },\n        "additionalProperties": {\n            "anyOf": [\n                { "type": "boolean" },\n                { "$ref": "#" }\n            ],\n            "default": {}\n        },\n        "definitions": {\n            "type": "object",\n            "additionalProperties": { "$ref": "#" },\n            "default": {}\n        },\n        "properties": {\n            "type": "object",\n            "additionalProperties": { "$ref": "#" },\n            "default": {}\n        },\n        "patternProperties": {\n            "type": "object",\n            "additionalProperties": { "$ref": "#" },\n            "default": {}\n        },\n        "dependencies": {\n            "type": "object",\n            "additionalProperties": {\n                "anyOf": [\n                    { "$ref": "#" },\n                    { "$ref": "#/definitions/stringArray" }\n                ]\n            }\n        },\n        "enum": {\n            "type": "array",\n            "minItems": 1,\n            "uniqueItems": true\n        },\n        "type": {\n            "anyOf": [\n                { "$ref": "#/definitions/simpleTypes" },\n                {\n                    "type": "array",\n                    "items": { "$ref": "#/definitions/simpleTypes" },\n                    "minItems": 1,\n                    "uniqueItems": true\n                }\n            ]\n        },\n        "allOf": { "$ref": "#/definitions/schemaArray" },\n        "anyOf": { "$ref": "#/definitions/schemaArray" },\n        "oneOf": { "$ref": "#/definitions/schemaArray" },\n        "not": { "$ref": "#" }\n    },\n    "dependencies": {\n        "exclusiveMaximum": [ "maximum" ],\n        "exclusiveMinimum": [ "minimum" ]\n    },\n    "default": {}\n}\n'},function(e,t,i){"use strict";var n=i(56),r=i(57),o=i(60),s=i(61),a=i(62),l=i(65),c=i(58),h={};h.create=function(e,t){if(!e)throw new Error("No container element provided.");this.container=e,this.dom={},this.highlighter=new n,this.selection=void 0,this.multiselection={nodes:[]},this.validateSchema=null,this.errorNodes=[],this.node=null,this.focusTarget=null,this._setOptions(t),this.options.history&&"view"!==this.options.mode&&(this.history=new r(this)),this._createFrame(),this._createTable()},h.destroy=function(){this.frame&&this.container&&this.frame.parentNode==this.container&&(this.container.removeChild(this.frame),this.frame=null),this.container=null,this.dom=null,this.clear(),this.node=null,this.focusTarget=null,this.selection=null,this.multiselection=null,this.errorNodes=null,this.validateSchema=null,this._debouncedValidate=null,this.history&&(this.history.destroy(),this.history=null),this.searchBox&&(this.searchBox.destroy(),this.searchBox=null),this.modeSwitcher&&(this.modeSwitcher.destroy(),this.modeSwitcher=null)},h._setOptions=function(e){if(this.options={search:!0,history:!0,mode:"tree",name:void 0,schema:null},e)for(var t in e)e.hasOwnProperty(t)&&(this.options[t]=e[t]);this.setSchema(this.options.schema),this._debouncedValidate=c.debounce(this.validate.bind(this),this.DEBOUNCE_INTERVAL)},h.set=function(e,t){if(t&&(console.warn('Second parameter "name" is deprecated. Use setName(name) instead.'),this.options.name=t),e instanceof Function||void 0===e)this.clear();else{this.content.removeChild(this.table);var i={field:this.options.name,value:e},n=new a(this,i);this._setRoot(n),this.validate();var r=!1;this.node.expand(r),this.content.appendChild(this.table)}this.history&&this.history.clear(),this.searchBox&&this.searchBox.clear()},h.get=function(){if(this.focusTarget){var e=a.getNodeFromTarget(this.focusTarget);e&&e.blur()}return this.node?this.node.getValue():void 0},h.getText=function(){return JSON.stringify(this.get())},h.setText=function(e){this.set(c.parse(e))},h.setName=function(e){this.options.name=e,this.node&&this.node.updateField(this.options.name)},h.getName=function(){return this.options.name},h.focus=function(){var e=this.content.querySelector("[contenteditable=true]");e?e.focus():this.node.dom.expand?this.node.dom.expand.focus():this.node.dom.menu?this.node.dom.menu.focus():(e=this.frame.querySelector("button"),e&&e.focus())},h.clear=function(){this.node&&(this.node.collapse(),this.tbody.removeChild(this.node.getDom()),delete this.node)},h._setRoot=function(e){this.clear(),this.node=e,this.tbody.appendChild(e.getDom())},h.search=function(e){var t;return this.node?(this.content.removeChild(this.table),t=this.node.search(e),this.content.appendChild(this.table)):t=[],t},h.expandAll=function(){this.node&&(this.content.removeChild(this.table),this.node.expand(),this.content.appendChild(this.table))},h.collapseAll=function(){this.node&&(this.content.removeChild(this.table),this.node.collapse(),this.content.appendChild(this.table))},h._onAction=function(e,t){this.history&&this.history.add(e,t),this._onChange()},h._onChange=function(){if(this._debouncedValidate(),this.options.onChange)try{this.options.onChange()}catch(e){console.error("Error in onChange callback: ",e)}},h.validate=function(){this.errorNodes&&this.errorNodes.forEach(function(e){e.setError(null)});var e=this.node;if(e){var t=e.validate(),i=[];if(this.validateSchema){var n=this.validateSchema(e.getValue());n||(i=this.validateSchema.errors.map(function(e){return c.improveSchemaError(e)}).map(function(t){return{node:e.findNode(t.dataPath),error:t}}).filter(function(e){return null!=e.node}))}this.errorNodes=t.concat(i).reduce(function(e,t){return t.node.findParents().map(function(e){return{node:e,child:t.node,error:{message:"object"===e.type?"Contains invalid properties":"Contains invalid items"}}}).concat(e,[t])},[]).map(function(e){return e.node.setError(e.error,e.child),e.node})}},h.refresh=function(){this.node&&this.node.updateDom({recurse:!0})},h.startAutoScroll=function(e){var t=this,i=this.content,n=c.getAbsoluteTop(i),r=i.clientHeight,o=n+r,s=24,a=50;e<n+s&&i.scrollTop>0?this.autoScrollStep=(n+s-e)/3:e>o-s&&r+i.scrollTop<i.scrollHeight?this.autoScrollStep=(o-s-e)/3:this.autoScrollStep=void 0,this.autoScrollStep?this.autoScrollTimer||(this.autoScrollTimer=setInterval(function(){t.autoScrollStep?i.scrollTop-=t.autoScrollStep:t.stopAutoScroll();
	},a)):this.stopAutoScroll()},h.stopAutoScroll=function(){this.autoScrollTimer&&(clearTimeout(this.autoScrollTimer),delete this.autoScrollTimer),this.autoScrollStep&&delete this.autoScrollStep},h.setSelection=function(e){e&&("scrollTop"in e&&this.content&&(this.content.scrollTop=e.scrollTop),e.nodes&&this.select(e.nodes),e.range&&c.setSelectionOffset(e.range),e.dom&&e.dom.focus())},h.getSelection=function(){var e=c.getSelectionOffset();return e&&"DIV"!==e.container.nodeName&&(e=null),{dom:this.focusTarget,range:e,nodes:this.multiselection.nodes.slice(0),scrollTop:this.content?this.content.scrollTop:0}},h.scrollTo=function(e,t){var i=this.content;if(i){var n=this;n.animateTimeout&&(clearTimeout(n.animateTimeout),delete n.animateTimeout),n.animateCallback&&(n.animateCallback(!1),delete n.animateCallback);var r=i.clientHeight,o=i.scrollHeight-r,s=Math.min(Math.max(e-r/4,0),o),a=function(){var e=i.scrollTop,r=s-e;Math.abs(r)>3?(i.scrollTop+=r/3,n.animateCallback=t,n.animateTimeout=setTimeout(a,50)):(t&&t(!0),i.scrollTop=s,delete n.animateTimeout,delete n.animateCallback)};a()}else t&&t(!1)},h._createFrame=function(){function e(e){t._onEvent&&t._onEvent(e)}this.frame=document.createElement("div"),this.frame.className="jsoneditor jsoneditor-mode-"+this.options.mode,this.container.appendChild(this.frame);var t=this;this.frame.onclick=function(t){var i=t.target;e(t),"BUTTON"==i.nodeName&&t.preventDefault()},this.frame.oninput=e,this.frame.onchange=e,this.frame.onkeydown=e,this.frame.onkeyup=e,this.frame.oncut=e,this.frame.onpaste=e,this.frame.onmousedown=e,this.frame.onmouseup=e,this.frame.onmouseover=e,this.frame.onmouseout=e,c.addEventListener(this.frame,"focus",e,!0),c.addEventListener(this.frame,"blur",e,!0),this.frame.onfocusin=e,this.frame.onfocusout=e,this.menu=document.createElement("div"),this.menu.className="jsoneditor-menu",this.frame.appendChild(this.menu);var i=document.createElement("button");i.type="button",i.className="jsoneditor-expand-all",i.title="Expand all fields",i.onclick=function(){t.expandAll()},this.menu.appendChild(i);var n=document.createElement("button");if(n.type="button",n.title="Collapse all fields",n.className="jsoneditor-collapse-all",n.onclick=function(){t.collapseAll()},this.menu.appendChild(n),this.history){var r=document.createElement("button");r.type="button",r.className="jsoneditor-undo jsoneditor-separator",r.title="Undo last action (Ctrl+Z)",r.onclick=function(){t._onUndo()},this.menu.appendChild(r),this.dom.undo=r;var s=document.createElement("button");s.type="button",s.className="jsoneditor-redo",s.title="Redo (Ctrl+Shift+Z)",s.onclick=function(){t._onRedo()},this.menu.appendChild(s),this.dom.redo=s,this.history.onChange=function(){r.disabled=!t.history.canUndo(),s.disabled=!t.history.canRedo()},this.history.onChange()}if(this.options&&this.options.modes&&this.options.modes.length){var a=this;this.modeSwitcher=new l(this.menu,this.options.modes,this.options.mode,function(e){a.modeSwitcher.destroy(),a.setMode(e),a.modeSwitcher.focus()})}this.options.search&&(this.searchBox=new o(this,this.menu))},h._onUndo=function(){this.history&&(this.history.undo(),this._onChange())},h._onRedo=function(){this.history&&(this.history.redo(),this._onChange())},h._onEvent=function(e){"keydown"==e.type&&this._onKeyDown(e),"focus"==e.type&&(this.focusTarget=e.target),"mousedown"==e.type&&this._startDragDistance(e),"mousemove"!=e.type&&"mouseup"!=e.type&&"click"!=e.type||this._updateDragDistance(e);var t=a.getNodeFromTarget(e.target);if(t&&t.selected){if("click"==e.type){if(e.target==t.dom.menu)return void this.showContextMenu(e.target);e.hasMoved||this.deselect()}"mousedown"==e.type&&a.onDragStart(this.multiselection.nodes,e)}else"mousedown"==e.type&&(this.deselect(),t&&e.target==t.dom.drag?a.onDragStart(t,e):(!t||e.target!=t.dom.field&&e.target!=t.dom.value&&e.target!=t.dom.select)&&this._onMultiSelectStart(e));t&&t.onEvent(e)},h._startDragDistance=function(e){this.dragDistanceEvent={initialTarget:e.target,initialPageX:e.pageX,initialPageY:e.pageY,dragDistance:0,hasMoved:!1}},h._updateDragDistance=function(e){this.dragDistanceEvent||this._startDragDistance(e);var t=e.pageX-this.dragDistanceEvent.initialPageX,i=e.pageY-this.dragDistanceEvent.initialPageY;return this.dragDistanceEvent.dragDistance=Math.sqrt(t*t+i*i),this.dragDistanceEvent.hasMoved=this.dragDistanceEvent.hasMoved||this.dragDistanceEvent.dragDistance>10,e.dragDistance=this.dragDistanceEvent.dragDistance,e.hasMoved=this.dragDistanceEvent.hasMoved,e.dragDistance},h._onMultiSelectStart=function(e){var t=a.getNodeFromTarget(e.target);if("tree"===this.options.mode&&void 0===this.options.onEditable){this.multiselection={start:t||null,end:null,nodes:[]},this._startDragDistance(e);var i=this;this.mousemove||(this.mousemove=c.addEventListener(window,"mousemove",function(e){i._onMultiSelect(e)})),this.mouseup||(this.mouseup=c.addEventListener(window,"mouseup",function(e){i._onMultiSelectEnd(e)}))}},h._onMultiSelect=function(e){if(e.preventDefault(),this._updateDragDistance(e),e.hasMoved){var t=a.getNodeFromTarget(e.target);t&&(null==this.multiselection.start&&(this.multiselection.start=t),this.multiselection.end=t),this.deselect();var i=this.multiselection.start,n=this.multiselection.end||this.multiselection.start;i&&n&&(this.multiselection.nodes=this._findTopLevelNodes(i,n),this.select(this.multiselection.nodes))}},h._onMultiSelectEnd=function(e){this.multiselection.nodes[0]&&this.multiselection.nodes[0].dom.menu.focus(),this.multiselection.start=null,this.multiselection.end=null,this.mousemove&&(c.removeEventListener(window,"mousemove",this.mousemove),delete this.mousemove),this.mouseup&&(c.removeEventListener(window,"mouseup",this.mouseup),delete this.mouseup)},h.deselect=function(e){this.multiselection.nodes.forEach(function(e){e.setSelected(!1)}),this.multiselection.nodes=[],e&&(this.multiselection.start=null,this.multiselection.end=null)},h.select=function(e){if(!Array.isArray(e))return this.select([e]);if(e){this.deselect(),this.multiselection.nodes=e.slice(0);var t=e[0];e.forEach(function(e){e.setSelected(!0,e===t)})}},h._findTopLevelNodes=function(e,t){for(var i=e.getNodePath(),n=t.getNodePath(),r=0;r<i.length&&i[r]===n[r];)r++;var o=i[r-1],s=i[r],a=n[r];if(s&&a||(o.parent?(s=o,a=o,o=o.parent):(s=o.childs[0],a=o.childs[o.childs.length-1])),o&&s&&a){var l=o.childs.indexOf(s),c=o.childs.indexOf(a),h=Math.min(l,c),d=Math.max(l,c);return o.childs.slice(h,d+1)}return[]},h._onKeyDown=function(e){var t=e.which||e.keyCode,i=e.ctrlKey,n=e.shiftKey,r=!1;if(9==t){var o=this;setTimeout(function(){c.selectContentEditable(o.focusTarget)},0)}if(this.searchBox)if(i&&70==t)this.searchBox.dom.search.focus(),this.searchBox.dom.search.select(),r=!0;else if(114==t||i&&71==t){var s=!0;n?this.searchBox.previous(s):this.searchBox.next(s),r=!0}this.history&&(i&&!n&&90==t?(this._onUndo(),r=!0):i&&n&&90==t&&(this._onRedo(),r=!0)),r&&(e.preventDefault(),e.stopPropagation())},h._createTable=function(){var e=document.createElement("div");e.className="jsoneditor-outer",this.contentOuter=e,this.content=document.createElement("div"),this.content.className="jsoneditor-tree",e.appendChild(this.content),this.table=document.createElement("table"),this.table.className="jsoneditor-tree",this.content.appendChild(this.table);var t;this.colgroupContent=document.createElement("colgroup"),"tree"===this.options.mode&&(t=document.createElement("col"),t.width="24px",this.colgroupContent.appendChild(t)),t=document.createElement("col"),t.width="24px",this.colgroupContent.appendChild(t),t=document.createElement("col"),this.colgroupContent.appendChild(t),this.table.appendChild(this.colgroupContent),this.tbody=document.createElement("tbody"),this.table.appendChild(this.tbody),this.frame.appendChild(e)},h.showContextMenu=function(e,t){var i=[],n=this;i.push({text:"Duplicate",title:"Duplicate selected fields (Ctrl+D)",className:"jsoneditor-duplicate",click:function(){a.onDuplicate(n.multiselection.nodes)}}),i.push({text:"Remove",title:"Remove selected fields (Ctrl+Del)",className:"jsoneditor-remove",click:function(){a.onRemove(n.multiselection.nodes)}});var r=new s(i,{close:t});r.show(e,this.content)},e.exports=[{mode:"tree",mixin:h,data:"json"},{mode:"view",mixin:h,data:"json"},{mode:"form",mixin:h,data:"json"}]},function(e,t){"use strict";function i(){this.locked=!1}i.prototype.highlight=function(e){this.locked||(this.node!=e&&(this.node&&this.node.setHighlight(!1),this.node=e,this.node.setHighlight(!0)),this._cancelUnhighlight())},i.prototype.unhighlight=function(){if(!this.locked){var e=this;this.node&&(this._cancelUnhighlight(),this.unhighlightTimer=setTimeout(function(){e.node.setHighlight(!1),e.node=void 0,e.unhighlightTimer=void 0},0))}},i.prototype._cancelUnhighlight=function(){this.unhighlightTimer&&(clearTimeout(this.unhighlightTimer),this.unhighlightTimer=void 0)},i.prototype.lock=function(){this.locked=!0},i.prototype.unlock=function(){this.locked=!1},e.exports=i},function(e,t,i){"use strict";function n(e){this.editor=e,this.history=[],this.index=-1,this.clear(),this.actions={editField:{undo:function(e){e.node.updateField(e.oldValue)},redo:function(e){e.node.updateField(e.newValue)}},editValue:{undo:function(e){e.node.updateValue(e.oldValue)},redo:function(e){e.node.updateValue(e.newValue)}},changeType:{undo:function(e){e.node.changeType(e.oldType)},redo:function(e){e.node.changeType(e.newType)}},appendNodes:{undo:function(e){e.nodes.forEach(function(t){e.parent.removeChild(t)})},redo:function(e){e.nodes.forEach(function(t){e.parent.appendChild(t)})}},insertBeforeNodes:{undo:function(e){e.nodes.forEach(function(t){e.parent.removeChild(t)})},redo:function(e){e.nodes.forEach(function(t){e.parent.insertBefore(t,e.beforeNode)})}},insertAfterNodes:{undo:function(e){e.nodes.forEach(function(t){e.parent.removeChild(t)})},redo:function(e){var t=e.afterNode;e.nodes.forEach(function(i){e.parent.insertAfter(e.node,t),t=i})}},removeNodes:{undo:function(e){var t=e.parent,i=t.childs[e.index]||t.append;e.nodes.forEach(function(e){t.insertBefore(e,i)})},redo:function(e){e.nodes.forEach(function(t){e.parent.removeChild(t)})}},duplicateNodes:{undo:function(e){e.nodes.forEach(function(t){e.parent.removeChild(t)})},redo:function(e){var t=e.afterNode;e.nodes.forEach(function(i){e.parent.insertAfter(i,t),t=i})}},moveNodes:{undo:function(e){e.nodes.forEach(function(t){e.oldBeforeNode.parent.moveBefore(t,e.oldBeforeNode)})},redo:function(e){e.nodes.forEach(function(t){e.newBeforeNode.parent.moveBefore(t,e.newBeforeNode)})}},sort:{undo:function(e){var t=e.node;t.hideChilds(),t.sort=e.oldSort,t.childs=e.oldChilds,t.showChilds()},redo:function(e){var t=e.node;t.hideChilds(),t.sort=e.newSort,t.childs=e.newChilds,t.showChilds()}}}}i(58);n.prototype.onChange=function(){},n.prototype.add=function(e,t){this.index++,this.history[this.index]={action:e,params:t,timestamp:new Date},this.index<this.history.length-1&&this.history.splice(this.index+1,this.history.length-this.index-1),this.onChange()},n.prototype.clear=function(){this.history=[],this.index=-1,this.onChange()},n.prototype.canUndo=function(){return this.index>=0},n.prototype.canRedo=function(){return this.index<this.history.length-1},n.prototype.undo=function(){if(this.canUndo()){var e=this.history[this.index];if(e){var t=this.actions[e.action];t&&t.undo?(t.undo(e.params),e.params.oldSelection&&this.editor.setSelection(e.params.oldSelection)):console.error(new Error('unknown action "'+e.action+'"'))}this.index--,this.onChange()}},n.prototype.redo=function(){if(this.canRedo()){this.index++;var e=this.history[this.index];if(e){var t=this.actions[e.action];t&&t.redo?(t.redo(e.params),e.params.newSelection&&this.editor.setSelection(e.params.newSelection)):console.error(new Error('unknown action "'+e.action+'"'))}this.onChange()}},n.prototype.destroy=function(){this.editor=null,this.history=[],this.index=-1},e.exports=n},function(e,t,i){"use strict";var n=i(59);t.parse=function(e){try{return JSON.parse(e)}catch(i){throw t.validate(e),i}},t.sanitize=function(e){function t(){return e.charAt(h)}function i(){return e.charAt(h+1)}function n(){return e.charAt(h-1)}function r(){for(var e=c.length-1;e>=0;){var t=c[e];if(" "!==t&&"\n"!==t&&"\r"!==t&&"\t"!==t)return t;e--}return""}function o(){for(h+=2;h<e.length&&("*"!==t()||"/"!==i());)h++;h+=2}function s(){for(h+=2;h<e.length&&"\n"!==t();)h++}function a(i){c.push('"'),h++;for(var r=t();h<e.length&&r!==i;)'"'===r&&"\\"!==n()&&c.push("\\"),"\\"===r&&(h++,r=t(),"'"!==r&&c.push("\\")),c.push(r),h++,r=t();r===i&&(c.push('"'),h++)}function l(){for(var e=["null","true","false"],i="",n=t(),r=/[a-zA-Z_$\d]/;r.test(n);)i+=n,h++,n=t();e.indexOf(i)===-1?c.push('"'+i+'"'):c.push(i)}var c=[],h=0,d=e.match(/^\s*(\/\*(.|[\r\n])*?\*\/)?\s*[\da-zA-Z_$]+\s*\(([\s\S]*)\)\s*;?\s*$/);for(d&&(e=d[3]);h<e.length;){var u=t();"/"===u&&"*"===i()?o():"/"===u&&"/"===i()?s():"'"===u||'"'===u?a(u):/[a-zA-Z_$]/.test(u)&&["{",","].indexOf(r())!==-1?l():(c.push(u),h++)}return c.join("")},t.escapeUnicodeChars=function(e){return e.replace(/[\u007F-\uFFFF]/g,function(e){return"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)})},t.validate=function(e){"undefined"!=typeof n?n.parse(e):JSON.parse(e)},t.extend=function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);return e},t.clear=function(e){for(var t in e)e.hasOwnProperty(t)&&delete e[t];return e},t.type=function(e){return null===e?"null":void 0===e?"undefined":e instanceof Number||"number"==typeof e?"number":e instanceof String||"string"==typeof e?"string":e instanceof Boolean||"boolean"==typeof e?"boolean":e instanceof RegExp||"regexp"==typeof e?"regexp":t.isArray(e)?"array":"object"};var r=/^https?:\/\/\S+$/;t.isUrl=function(e){return("string"==typeof e||e instanceof String)&&r.test(e)},t.isArray=function(e){return"[object Array]"===Object.prototype.toString.call(e)},t.getAbsoluteLeft=function(e){var t=e.getBoundingClientRect();return t.left+window.pageXOffset||document.scrollLeft||0},t.getAbsoluteTop=function(e){var t=e.getBoundingClientRect();return t.top+window.pageYOffset||document.scrollTop||0},t.addClassName=function(e,t){var i=e.className.split(" ");i.indexOf(t)==-1&&(i.push(t),e.className=i.join(" "))},t.removeClassName=function(e,t){var i=e.className.split(" "),n=i.indexOf(t);n!=-1&&(i.splice(n,1),e.className=i.join(" "))},t.stripFormatting=function(e){for(var i=e.childNodes,n=0,r=i.length;n<r;n++){var o=i[n];o.style&&o.removeAttribute("style");var s=o.attributes;if(s)for(var a=s.length-1;a>=0;a--){var l=s[a];l.specified===!0&&o.removeAttribute(l.name)}t.stripFormatting(o)}},t.setEndOfContentEditable=function(e){var t,i;document.createRange&&(t=document.createRange(),t.selectNodeContents(e),t.collapse(!1),i=window.getSelection(),i.removeAllRanges(),i.addRange(t))},t.selectContentEditable=function(e){if(e&&"DIV"==e.nodeName){var t,i;window.getSelection&&document.createRange&&(i=document.createRange(),i.selectNodeContents(e),t=window.getSelection(),t.removeAllRanges(),t.addRange(i))}},t.getSelection=function(){if(window.getSelection){var e=window.getSelection();if(e.getRangeAt&&e.rangeCount)return e.getRangeAt(0)}return null},t.setSelection=function(e){if(e&&window.getSelection){var t=window.getSelection();t.removeAllRanges(),t.addRange(e)}},t.getSelectionOffset=function(){var e=t.getSelection();return e&&"startOffset"in e&&"endOffset"in e&&e.startContainer&&e.startContainer==e.endContainer?{startOffset:e.startOffset,endOffset:e.endOffset,container:e.startContainer.parentNode}:null},t.setSelectionOffset=function(e){if(document.createRange&&window.getSelection){var i=window.getSelection();if(i){var n=document.createRange();e.container.firstChild||e.container.appendChild(document.createTextNode("")),n.setStart(e.container.firstChild,e.startOffset),n.setEnd(e.container.firstChild,e.endOffset),t.setSelection(n)}}},t.getInnerText=function(e,i){var n=void 0==i;if(n&&(i={text:"",flush:function(){var e=this.text;return this.text="",e},set:function(e){this.text=e}}),e.nodeValue)return i.flush()+e.nodeValue;if(e.hasChildNodes()){for(var r=e.childNodes,o="",s=0,a=r.length;s<a;s++){var l=r[s];if("DIV"==l.nodeName||"P"==l.nodeName){var c=r[s-1],h=c?c.nodeName:void 0;h&&"DIV"!=h&&"P"!=h&&"BR"!=h&&(o+="\n",i.flush()),o+=t.getInnerText(l,i),i.set("\n")}else"BR"==l.nodeName?(o+=i.flush(),i.set("\n")):o+=t.getInnerText(l,i)}return o}return"P"==e.nodeName&&t.getInternetExplorerVersion()!=-1?i.flush():""},t.getInternetExplorerVersion=function(){if(o==-1){var e=-1;if("Microsoft Internet Explorer"==navigator.appName){var t=navigator.userAgent,i=new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");null!=i.exec(t)&&(e=parseFloat(RegExp.$1))}o=e}return o},t.isFirefox=function(){return navigator.userAgent.indexOf("Firefox")!=-1};var o=-1;t.addEventListener=function(e,i,n,r){if(e.addEventListener)return void 0===r&&(r=!1),"mousewheel"===i&&t.isFirefox()&&(i="DOMMouseScroll"),e.addEventListener(i,n,r),n;if(e.attachEvent){var o=function(){return n.call(e,window.event)};return e.attachEvent("on"+i,o),o}},t.removeEventListener=function(e,i,n,r){e.removeEventListener?(void 0===r&&(r=!1),"mousewheel"===i&&t.isFirefox()&&(i="DOMMouseScroll"),e.removeEventListener(i,n,r)):e.detachEvent&&e.detachEvent("on"+i,n)},t.parsePath=function e(t){var i,n;if(0===t.length)return[];var r=t.match(/^\.(\w+)/);if(r)i=r[1],n=t.substr(i.length+1);else{if("["!==t[0])throw new SyntaxError("Failed to parse path");var o=t.indexOf("]");if(o===-1)throw new SyntaxError("Character ] expected in path");if(1===o)throw new SyntaxError("Index expected after [");var s=t.substring(1,o);"'"===s[0]&&(s='"'+s.substring(1,s.length-1)+'"'),i="*"===s?s:JSON.parse(s),n=t.substr(o+1)}return[i].concat(e(n))},t.improveSchemaError=function(e){if("enum"===e.keyword&&Array.isArray(e.schema)){var t=e.schema;if(t){if(t=t.map(function(e){return JSON.stringify(e)}),t.length>5){var i=["("+(t.length-5)+" more...)"];t=t.slice(0,5),t.push(i)}e.message="should be equal to one of: "+t.join(", ")}}return"additionalProperties"===e.keyword&&(e.message="should NOT have additional property: "+e.params.additionalProperty),e},t.insideRect=function(e,t,i){var n=void 0!==i?i:0;return t.left-n>=e.left&&t.right+n<=e.right&&t.top-n>=e.top&&t.bottom+n<=e.bottom},t.debounce=function(e,t,i){var n;return function(){var r=this,o=arguments,s=function(){n=null,i||e.apply(r,o)},a=i&&!n;clearTimeout(n),n=setTimeout(s,t),a&&e.apply(r,o)}},t.textDiff=function(e,t){for(var i=t.length,n=0,r=e.length,o=t.length;t.charAt(n)===e.charAt(n)&&n<i;)n++;for(;t.charAt(o-1)===e.charAt(r-1)&&o>n&&r>0;)o--,r--;return{start:n,end:o}}},function(e,t,i){var n=function(){var e={trace:function(){},yy:{},symbols_:{error:2,JSONString:3,STRING:4,JSONNumber:5,NUMBER:6,JSONNullLiteral:7,NULL:8,JSONBooleanLiteral:9,TRUE:10,FALSE:11,JSONText:12,JSONValue:13,EOF:14,JSONObject:15,JSONArray:16,"{":17,"}":18,JSONMemberList:19,JSONMember:20,":":21,",":22,"[":23,"]":24,JSONElementList:25,$accept:0,$end:1},terminals_:{2:"error",4:"STRING",6:"NUMBER",8:"NULL",10:"TRUE",11:"FALSE",14:"EOF",17:"{",18:"}",21:":",22:",",23:"[",24:"]"},productions_:[0,[3,1],[5,1],[7,1],[9,1],[9,1],[12,2],[13,1],[13,1],[13,1],[13,1],[13,1],[13,1],[15,2],[15,3],[20,3],[19,1],[19,3],[16,2],[16,3],[25,1],[25,3]],performAction:function(e,t,i,n,r,o,s){var a=o.length-1;switch(r){case 1:this.$=e.replace(/\\(\\|")/g,"$1").replace(/\\n/g,"\n").replace(/\\r/g,"\r").replace(/\\t/g,"\t").replace(/\\v/g,"\v").replace(/\\f/g,"\f").replace(/\\b/g,"\b");break;case 2:this.$=Number(e);break;case 3:this.$=null;break;case 4:this.$=!0;break;case 5:this.$=!1;break;case 6:return this.$=o[a-1];case 13:this.$={};break;case 14:this.$=o[a-1];break;case 15:this.$=[o[a-2],o[a]];break;case 16:this.$={},this.$[o[a][0]]=o[a][1];break;case 17:this.$=o[a-2],o[a-2][o[a][0]]=o[a][1];break;case 18:this.$=[];break;case 19:this.$=o[a-1];break;case 20:this.$=[o[a]];break;case 21:this.$=o[a-2],o[a-2].push(o[a])}},table:[{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],12:1,13:2,15:7,16:8,17:[1,14],23:[1,15]},{1:[3]},{14:[1,16]},{14:[2,7],18:[2,7],22:[2,7],24:[2,7]},{14:[2,8],18:[2,8],22:[2,8],24:[2,8]},{14:[2,9],18:[2,9],22:[2,9],24:[2,9]},{14:[2,10],18:[2,10],22:[2,10],24:[2,10]},{14:[2,11],18:[2,11],22:[2,11],24:[2,11]},{14:[2,12],18:[2,12],22:[2,12],24:[2,12]},{14:[2,3],18:[2,3],22:[2,3],24:[2,3]},{14:[2,4],18:[2,4],22:[2,4],24:[2,4]},{14:[2,5],18:[2,5],22:[2,5],24:[2,5]},{14:[2,1],18:[2,1],21:[2,1],22:[2,1],24:[2,1]},{14:[2,2],18:[2,2],22:[2,2],24:[2,2]},{3:20,4:[1,12],18:[1,17],19:18,20:19},{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],13:23,15:7,16:8,17:[1,14],23:[1,15],24:[1,21],25:22},{1:[2,6]},{14:[2,13],18:[2,13],22:[2,13],24:[2,13]},{18:[1,24],22:[1,25]},{18:[2,16],22:[2,16]},{21:[1,26]},{14:[2,18],18:[2,18],22:[2,18],24:[2,18]},{22:[1,28],24:[1,27]},{22:[2,20],24:[2,20]},{14:[2,14],18:[2,14],22:[2,14],24:[2,14]},{3:20,4:[1,12],20:29},{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],13:30,15:7,16:8,17:[1,14],23:[1,15]},{14:[2,19],18:[2,19],22:[2,19],24:[2,19]},{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],13:31,15:7,16:8,17:[1,14],23:[1,15]},{18:[2,17],22:[2,17]},{18:[2,15],22:[2,15]},{22:[2,21],24:[2,21]}],defaultActions:{16:[2,6]},parseError:function(e,t){throw new Error(e)},parse:function(e){function t(e){r.length=r.length-2*e,o.length=o.length-e,s.length=s.length-e}function i(){var e;return e=n.lexer.lex()||1,"number"!=typeof e&&(e=n.symbols_[e]||e),e}var n=this,r=[0],o=[null],s=[],a=this.table,l="",c=0,h=0,d=0,u=2,f=1;this.lexer.setInput(e),this.lexer.yy=this.yy,this.yy.lexer=this.lexer,"undefined"==typeof this.lexer.yylloc&&(this.lexer.yylloc={});var p=this.lexer.yylloc;s.push(p),"function"==typeof this.yy.parseError&&(this.parseError=this.yy.parseError);for(var m,g,v,y,w,b,A,C,E,x={};;){if(v=r[r.length-1],this.defaultActions[v]?y=this.defaultActions[v]:(null==m&&(m=i()),y=a[v]&&a[v][m]),"undefined"==typeof y||!y.length||!y[0]){if(!d){E=[];for(b in a[v])this.terminals_[b]&&b>2&&E.push("'"+this.terminals_[b]+"'");var F="";F=this.lexer.showPosition?"Parse error on line "+(c+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+E.join(", ")+", got '"+this.terminals_[m]+"'":"Parse error on line "+(c+1)+": Unexpected "+(1==m?"end of input":"'"+(this.terminals_[m]||m)+"'"),this.parseError(F,{text:this.lexer.match,token:this.terminals_[m]||m,line:this.lexer.yylineno,loc:p,expected:E})}if(3==d){if(m==f)throw new Error(F||"Parsing halted.");h=this.lexer.yyleng,l=this.lexer.yytext,c=this.lexer.yylineno,p=this.lexer.yylloc,m=i()}for(;;){if(u.toString()in a[v])break;if(0==v)throw new Error(F||"Parsing halted.");t(1),v=r[r.length-1]}g=m,m=u,v=r[r.length-1],y=a[v]&&a[v][u],d=3}if(y[0]instanceof Array&&y.length>1)throw new Error("Parse Error: multiple actions possible at state: "+v+", token: "+m);switch(y[0]){case 1:r.push(m),o.push(this.lexer.yytext),s.push(this.lexer.yylloc),r.push(y[1]),m=null,g?(m=g,g=null):(h=this.lexer.yyleng,l=this.lexer.yytext,c=this.lexer.yylineno,p=this.lexer.yylloc,d>0&&d--);break;case 2:if(A=this.productions_[y[1]][1],x.$=o[o.length-A],x._$={first_line:s[s.length-(A||1)].first_line,last_line:s[s.length-1].last_line,first_column:s[s.length-(A||1)].first_column,last_column:s[s.length-1].last_column},w=this.performAction.call(x,l,h,c,this.yy,y[1],o,s),"undefined"!=typeof w)return w;A&&(r=r.slice(0,-1*A*2),o=o.slice(0,-1*A),s=s.slice(0,-1*A)),r.push(this.productions_[y[1]][0]),o.push(x.$),s.push(x._$),C=a[r[r.length-2]][r[r.length-1]],r.push(C);break;case 3:return!0}}return!0}},t=function(){var e={EOF:1,parseError:function(e,t){if(!this.yy.parseError)throw new Error(e);this.yy.parseError(e,t)},setInput:function(e){return this._input=e,this._more=this._less=this.done=!1,this.yylineno=this.yyleng=0,this.yytext=this.matched=this.match="",this.conditionStack=["INITIAL"],this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0},this},input:function(){var e=this._input[0];this.yytext+=e,this.yyleng++,this.match+=e,this.matched+=e;var t=e.match(/\n/);return t&&this.yylineno++,this._input=this._input.slice(1),e},unput:function(e){return this._input=e+this._input,this},more:function(){return this._more=!0,this},less:function(e){this._input=this.match.slice(e)+this._input},pastInput:function(){var e=this.matched.substr(0,this.matched.length-this.match.length);return(e.length>20?"...":"")+e.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var e=this.match;return e.length<20&&(e+=this._input.substr(0,20-e.length)),(e.substr(0,20)+(e.length>20?"...":"")).replace(/\n/g,"")},showPosition:function(){var e=this.pastInput(),t=new Array(e.length+1).join("-");return e+this.upcomingInput()+"\n"+t+"^"},next:function(){if(this.done)return this.EOF;this._input||(this.done=!0);var e,t,i,n,r;this._more||(this.yytext="",this.match="");for(var o=this._currentRules(),s=0;s<o.length&&(i=this._input.match(this.rules[o[s]]),!i||t&&!(i[0].length>t[0].length)||(t=i,n=s,this.options.flex));s++);return t?(r=t[0].match(/\n.*/g),r&&(this.yylineno+=r.length),this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:r?r[r.length-1].length-1:this.yylloc.last_column+t[0].length},this.yytext+=t[0],this.match+=t[0],this.yyleng=this.yytext.length,this._more=!1,this._input=this._input.slice(t[0].length),this.matched+=t[0],e=this.performAction.call(this,this.yy,this,o[n],this.conditionStack[this.conditionStack.length-1]),this.done&&this._input&&(this.done=!1),e?e:void 0):""===this._input?this.EOF:void this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})},lex:function(){var e=this.next();return"undefined"!=typeof e?e:this.lex()},begin:function(e){this.conditionStack.push(e)},popState:function(){return this.conditionStack.pop()},_currentRules:function(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules},topState:function(){return this.conditionStack[this.conditionStack.length-2]},pushState:function(e){this.begin(e)}};return e.options={},e.performAction=function(e,t,i,n){switch(i){case 0:break;case 1:return 6;case 2:return t.yytext=t.yytext.substr(1,t.yyleng-2),4;case 3:return 17;case 4:return 18;case 5:return 23;case 6:return 24;case 7:return 22;case 8:return 21;case 9:return 10;case 10:return 11;case 11:return 8;case 12:return 14;case 13:return"INVALID"}},e.rules=[/^(?:\s+)/,/^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/,/^(?:"(?:\\[\\"bfnrt\/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/,/^(?:\{)/,/^(?:\})/,/^(?:\[)/,/^(?:\])/,/^(?:,)/,/^(?::)/,/^(?:true\b)/,/^(?:false\b)/,/^(?:null\b)/,/^(?:$)/,/^(?:.)/],e.conditions={INITIAL:{rules:[0,1,2,3,4,5,6,7,8,9,10,11,12,13],inclusive:!0}},e}();return e.lexer=t,e}();t.parser=n,t.parse=n.parse.bind(n)},function(e,t){"use strict";function i(e,t){var i=this;this.editor=e,this.timeout=void 0,this.delay=200,this.lastText=void 0,this.dom={},this.dom.container=t;var n=document.createElement("table");this.dom.table=n,n.className="jsoneditor-search",t.appendChild(n);var r=document.createElement("tbody");this.dom.tbody=r,n.appendChild(r);var o=document.createElement("tr");r.appendChild(o);var s=document.createElement("td");o.appendChild(s);var a=document.createElement("div");this.dom.results=a,a.className="jsoneditor-results",s.appendChild(a),s=document.createElement("td"),o.appendChild(s);var l=document.createElement("div");this.dom.input=l,l.className="jsoneditor-frame",l.title="Search fields and values",s.appendChild(l);var c=document.createElement("table");l.appendChild(c);var h=document.createElement("tbody");c.appendChild(h),o=document.createElement("tr"),h.appendChild(o);var d=document.createElement("button");d.type="button",d.className="jsoneditor-refresh",s=document.createElement("td"),s.appendChild(d),o.appendChild(s);var u=document.createElement("input");this.dom.search=u,u.oninput=function(e){i._onDelayedSearch(e)},u.onchange=function(e){i._onSearch()},u.onkeydown=function(e){i._onKeyDown(e)},u.onkeyup=function(e){i._onKeyUp(e)},d.onclick=function(e){u.select()},s=document.createElement("td"),s.appendChild(u),o.appendChild(s);var f=document.createElement("button");f.type="button",f.title="Next result (Enter)",f.className="jsoneditor-next",f.onclick=function(){i.next()},s=document.createElement("td"),s.appendChild(f),o.appendChild(s);var p=document.createElement("button");p.type="button",p.title="Previous result (Shift+Enter)",p.className="jsoneditor-previous",p.onclick=function(){i.previous()},s=document.createElement("td"),s.appendChild(p),o.appendChild(s)}i.prototype.next=function(e){if(void 0!=this.results){var t=void 0!=this.resultIndex?this.resultIndex+1:0;t>this.results.length-1&&(t=0),this._setActiveResult(t,e)}},i.prototype.previous=function(e){if(void 0!=this.results){var t=this.results.length-1,i=void 0!=this.resultIndex?this.resultIndex-1:t;i<0&&(i=t),this._setActiveResult(i,e)}},i.prototype._setActiveResult=function(e,t){if(this.activeResult){var i=this.activeResult.node,n=this.activeResult.elem;"field"==n?delete i.searchFieldActive:delete i.searchValueActive,i.updateDom()}if(!this.results||!this.results[e])return this.resultIndex=void 0,void(this.activeResult=void 0);this.resultIndex=e;var r=this.results[this.resultIndex].node,o=this.results[this.resultIndex].elem;"field"==o?r.searchFieldActive=!0:r.searchValueActive=!0,this.activeResult=this.results[this.resultIndex],r.updateDom(),r.scrollTo(function(){t&&r.focus(o)})},i.prototype._clearDelay=function(){void 0!=this.timeout&&(clearTimeout(this.timeout),delete this.timeout)},i.prototype._onDelayedSearch=function(e){this._clearDelay();var t=this;this.timeout=setTimeout(function(e){t._onSearch()},this.delay)},i.prototype._onSearch=function(e){this._clearDelay();var t=this.dom.search.value,i=t.length>0?t:void 0;if(i!=this.lastText||e)if(this.lastText=i,this.results=this.editor.search(i),this._setActiveResult(void 0),void 0!=i){var n=this.results.length;switch(n){case 0:this.dom.results.innerHTML="no&nbsp;results";break;case 1:this.dom.results.innerHTML="1&nbsp;result";break;default:this.dom.results.innerHTML=n+"&nbsp;results"}}else this.dom.results.innerHTML=""},i.prototype._onKeyDown=function(e){var t=e.which;27==t?(this.dom.search.value="",this._onSearch(),e.preventDefault(),e.stopPropagation()):13==t&&(e.ctrlKey?this._onSearch(!0):e.shiftKey?this.previous():this.next(),e.preventDefault(),e.stopPropagation())},i.prototype._onKeyUp=function(e){var t=e.keyCode;27!=t&&13!=t&&this._onDelayedSearch(e)},i.prototype.clear=function(){this.dom.search.value="",this._onSearch()},i.prototype.destroy=function(){this.editor=null,this.dom.container.removeChild(this.dom.table),this.dom=null,this.results=null,this.activeResult=null,this._clearDelay()},e.exports=i},function(e,t,i){"use strict";function n(e,t){function i(e,t,r){r.forEach(function(r){if("separator"==r.type){var o=document.createElement("div");o.className="jsoneditor-separator",a=document.createElement("li"),a.appendChild(o),e.appendChild(a)}else{var s={},a=document.createElement("li");e.appendChild(a);var l=document.createElement("button");if(l.type="button",l.className=r.className,s.button=l,r.title&&(l.title=r.title),r.click&&(l.onclick=function(e){e.preventDefault(),n.hide(),r.click()}),a.appendChild(l),r.submenu){var c=document.createElement("div");c.className="jsoneditor-icon",l.appendChild(c),l.appendChild(document.createTextNode(r.text));var h;if(r.click){l.className+=" jsoneditor-default";var d=document.createElement("button");d.type="button",s.buttonExpand=d,d.className="jsoneditor-expand",d.innerHTML='<div class="jsoneditor-expand"></div>',a.appendChild(d),r.submenuTitle&&(d.title=r.submenuTitle),h=d}else{var u=document.createElement("div");u.className="jsoneditor-expand",l.appendChild(u),h=l}h.onclick=function(e){e.preventDefault(),n._onExpandItem(s),h.focus()};var f=[];s.subItems=f;var p=document.createElement("ul");s.ul=p,p.className="jsoneditor-menu",
	p.style.height="0",a.appendChild(p),i(p,f,r.submenu)}else l.innerHTML='<div class="jsoneditor-icon"></div>'+r.text;t.push(s)}})}this.dom={};var n=this,r=this.dom;this.anchor=void 0,this.items=e,this.eventListeners={},this.selection=void 0,this.onClose=t?t.close:void 0;var o=document.createElement("div");o.className="jsoneditor-contextmenu-root",r.root=o;var s=document.createElement("div");s.className="jsoneditor-contextmenu",r.menu=s,o.appendChild(s);var a=document.createElement("ul");a.className="jsoneditor-menu",s.appendChild(a),r.list=a,r.items=[];var l=document.createElement("button");l.type="button",r.focusButton=l;var c=document.createElement("li");c.style.overflow="hidden",c.style.height="0",c.appendChild(l),a.appendChild(c),i(a,this.dom.items,e),this.maxHeight=0,e.forEach(function(t){var i=24*(e.length+(t.submenu?t.submenu.length:0));n.maxHeight=Math.max(n.maxHeight,i)})}var r=i(58);n.prototype._getVisibleButtons=function(){var e=[],t=this;return this.dom.items.forEach(function(i){e.push(i.button),i.buttonExpand&&e.push(i.buttonExpand),i.subItems&&i==t.expandedItem&&i.subItems.forEach(function(t){e.push(t.button),t.buttonExpand&&e.push(t.buttonExpand)})}),e},n.visibleMenu=void 0,n.prototype.show=function(e,t){this.hide();var i=!0;if(t){var o=e.getBoundingClientRect(),s=t.getBoundingClientRect();o.bottom+this.maxHeight<s.bottom||o.top-this.maxHeight>s.top&&(i=!1)}if(i){var a=e.offsetHeight;this.dom.menu.style.left="0px",this.dom.menu.style.top=a+"px",this.dom.menu.style.bottom=""}else this.dom.menu.style.left="0px",this.dom.menu.style.top="",this.dom.menu.style.bottom="0px";var l=e.parentNode;l.insertBefore(this.dom.root,l.firstChild);var c=this,h=this.dom.list;this.eventListeners.mousedown=r.addEventListener(window,"mousedown",function(e){var t=e.target;t==h||c._isChildOf(t,h)||(c.hide(),e.stopPropagation(),e.preventDefault())}),this.eventListeners.keydown=r.addEventListener(window,"keydown",function(e){c._onKeyDown(e)}),this.selection=r.getSelection(),this.anchor=e,setTimeout(function(){c.dom.focusButton.focus()},0),n.visibleMenu&&n.visibleMenu.hide(),n.visibleMenu=this},n.prototype.hide=function(){this.dom.root.parentNode&&(this.dom.root.parentNode.removeChild(this.dom.root),this.onClose&&this.onClose());for(var e in this.eventListeners)if(this.eventListeners.hasOwnProperty(e)){var t=this.eventListeners[e];t&&r.removeEventListener(window,e,t),delete this.eventListeners[e]}n.visibleMenu==this&&(n.visibleMenu=void 0)},n.prototype._onExpandItem=function(e){var t=this,i=e==this.expandedItem,n=this.expandedItem;if(n&&(n.ul.style.height="0",n.ul.style.padding="",setTimeout(function(){t.expandedItem!=n&&(n.ul.style.display="",r.removeClassName(n.ul.parentNode,"jsoneditor-selected"))},300),this.expandedItem=void 0),!i){var o=e.ul;o.style.display="block";o.clientHeight;setTimeout(function(){t.expandedItem==e&&(o.style.height=24*o.childNodes.length+"px",o.style.padding="5px 10px")},0),r.addClassName(o.parentNode,"jsoneditor-selected"),this.expandedItem=e}},n.prototype._onKeyDown=function(e){var t,i,n,o,s=e.target,a=e.which,l=!1;27==a?(this.selection&&r.setSelection(this.selection),this.anchor&&this.anchor.focus(),this.hide(),l=!0):9==a?e.shiftKey?(t=this._getVisibleButtons(),i=t.indexOf(s),0==i&&(t[t.length-1].focus(),l=!0)):(t=this._getVisibleButtons(),i=t.indexOf(s),i==t.length-1&&(t[0].focus(),l=!0)):37==a?("jsoneditor-expand"==s.className&&(t=this._getVisibleButtons(),i=t.indexOf(s),n=t[i-1],n&&n.focus()),l=!0):38==a?(t=this._getVisibleButtons(),i=t.indexOf(s),n=t[i-1],n&&"jsoneditor-expand"==n.className&&(n=t[i-2]),n||(n=t[t.length-1]),n&&n.focus(),l=!0):39==a?(t=this._getVisibleButtons(),i=t.indexOf(s),o=t[i+1],o&&"jsoneditor-expand"==o.className&&o.focus(),l=!0):40==a&&(t=this._getVisibleButtons(),i=t.indexOf(s),o=t[i+1],o&&"jsoneditor-expand"==o.className&&(o=t[i+2]),o||(o=t[0]),o&&(o.focus(),l=!0),l=!0),l&&(e.stopPropagation(),e.preventDefault())},n.prototype._isChildOf=function(e,t){for(var i=e.parentNode;i;){if(i==t)return!0;i=i.parentNode}return!1},e.exports=n},function(e,t,i){"use strict";function n(e,t){this.editor=e,this.dom={},this.expanded=!1,t&&t instanceof Object?(this.setField(t.field,t.fieldEditable),this.setValue(t.value,t.type)):(this.setField(""),this.setValue(null)),this._debouncedOnChangeValue=a.debounce(this._onChangeValue.bind(this),n.prototype.DEBOUNCE_INTERVAL),this._debouncedOnChangeField=a.debounce(this._onChangeField.bind(this),n.prototype.DEBOUNCE_INTERVAL)}var r=i(63),o=i(61),s=i(64),a=i(58);n.prototype.DEBOUNCE_INTERVAL=150,n.prototype._updateEditability=function(){if(this.editable={field:!0,value:!0},this.editor&&(this.editable.field="tree"===this.editor.options.mode,this.editable.value="view"!==this.editor.options.mode,("tree"===this.editor.options.mode||"form"===this.editor.options.mode)&&"function"==typeof this.editor.options.onEditable)){var e=this.editor.options.onEditable({field:this.field,value:this.value,path:this.getPath()});"boolean"==typeof e?(this.editable.field=e,this.editable.value=e):("boolean"==typeof e.field&&(this.editable.field=e.field),"boolean"==typeof e.value&&(this.editable.value=e.value))}},n.prototype.getPath=function(){for(var e=this,t=[];e;){var i=e.parent?"array"!=e.parent.type?e.field:e.index:void 0;void 0!==i&&t.unshift(i),e=e.parent}return t},n.prototype.findNode=function(e){for(var t=a.parsePath(e),i=this;i&&t.length>0;){var n=t.shift();if("number"==typeof n){if("array"!==i.type)throw new Error("Cannot get child node at index "+n+": node is no array");i=i.childs[n]}else{if("object"!==i.type)throw new Error("Cannot get child node "+n+": node is no object");i=i.childs.filter(function(e){return e.field===n})[0]}}return i},n.prototype.findParents=function(){for(var e=[],t=this.parent;t;)e.unshift(t),t=t.parent;return e},n.prototype.setError=function(e,t){this.getDom(),this.error=e;var i=this.dom.tdError;if(e){i||(i=document.createElement("td"),this.dom.tdError=i,this.dom.tdValue.parentNode.appendChild(i));var n=document.createElement("div");n.className="jsoneditor-popover jsoneditor-right",n.appendChild(document.createTextNode(e.message));var r=document.createElement("button");for(r.type="button",r.className="jsoneditor-schema-error",r.appendChild(n),r.onmouseover=r.onfocus=function(){for(var e=["right","above","below","left"],t=0;t<e.length;t++){var i=e[t];n.className="jsoneditor-popover jsoneditor-"+i;var r=this.editor.content.getBoundingClientRect(),o=n.getBoundingClientRect(),s=20,l=a.insideRect(r,o,s);if(l)break}}.bind(this),t&&(r.onclick=function(){t.findParents().forEach(function(e){e.expand(!1)}),t.scrollTo(function(){t.focus()})});i.firstChild;)i.removeChild(i.firstChild);i.appendChild(r)}else i&&(this.dom.tdError.parentNode.removeChild(this.dom.tdError),delete this.dom.tdError)},n.prototype.getIndex=function(){return this.parent?this.parent.childs.indexOf(this):-1},n.prototype.setParent=function(e){this.parent=e},n.prototype.setField=function(e,t){this.field=e,this.previousField=e,this.fieldEditable=t===!0},n.prototype.getField=function(){return void 0===this.field&&this._getDomField(),this.field},n.prototype.setValue=function(e,t){var i,r,o=this.childs;if(o)for(;o.length;)this.removeChild(o[0]);if(this.type=this._getType(e),t&&t!=this.type){if("string"!=t||"auto"!=this.type)throw new Error('Type mismatch: cannot cast value of type "'+this.type+' to the specified type "'+t+'"');this.type=t}if("array"==this.type){this.childs=[];for(var s=0,a=e.length;s<a;s++)i=e[s],void 0===i||i instanceof Function||(r=new n(this.editor,{value:i}),this.appendChild(r));this.value=""}else if("object"==this.type){this.childs=[];for(var l in e)e.hasOwnProperty(l)&&(i=e[l],void 0===i||i instanceof Function||(r=new n(this.editor,{field:l,value:i}),this.appendChild(r)));this.value="",this.editor.options.sortObjectKeys===!0&&this.sort("asc")}else this.childs=void 0,this.value=e;this.previousValue=this.value},n.prototype.getValue=function(){if("array"==this.type){var e=[];return this.childs.forEach(function(t){e.push(t.getValue())}),e}if("object"==this.type){var t={};return this.childs.forEach(function(e){t[e.getField()]=e.getValue()}),t}return void 0===this.value&&this._getDomValue(),this.value},n.prototype.getLevel=function(){return this.parent?this.parent.getLevel()+1:0},n.prototype.getNodePath=function(){var e=this.parent?this.parent.getNodePath():[];return e.push(this),e},n.prototype.clone=function(){var e=new n(this.editor);if(e.type=this.type,e.field=this.field,e.fieldInnerText=this.fieldInnerText,e.fieldEditable=this.fieldEditable,e.value=this.value,e.valueInnerText=this.valueInnerText,e.expanded=this.expanded,this.childs){var t=[];this.childs.forEach(function(i){var n=i.clone();n.setParent(e),t.push(n)}),e.childs=t}else e.childs=void 0;return e},n.prototype.expand=function(e){this.childs&&(this.expanded=!0,this.dom.expand&&(this.dom.expand.className="jsoneditor-expanded"),this.showChilds(),e!==!1&&this.childs.forEach(function(t){t.expand(e)}))},n.prototype.collapse=function(e){this.childs&&(this.hideChilds(),e!==!1&&this.childs.forEach(function(t){t.collapse(e)}),this.dom.expand&&(this.dom.expand.className="jsoneditor-collapsed"),this.expanded=!1)},n.prototype.showChilds=function(){var e=this.childs;if(e&&this.expanded){var t=this.dom.tr,i=t?t.parentNode:void 0;if(i){var n=this.getAppend(),r=t.nextSibling;r?i.insertBefore(n,r):i.appendChild(n),this.childs.forEach(function(e){i.insertBefore(e.getDom(),n),e.showChilds()})}}},n.prototype.hide=function(){var e=this.dom.tr,t=e?e.parentNode:void 0;t&&t.removeChild(e),this.hideChilds()},n.prototype.hideChilds=function(){var e=this.childs;if(e&&this.expanded){var t=this.getAppend();t.parentNode&&t.parentNode.removeChild(t),this.childs.forEach(function(e){e.hide()})}},n.prototype.appendChild=function(e){if(this._hasChilds()){if(e.setParent(this),e.fieldEditable="object"==this.type,"array"==this.type&&(e.index=this.childs.length),this.childs.push(e),this.expanded){var t=e.getDom(),i=this.getAppend(),n=i?i.parentNode:void 0;i&&n&&n.insertBefore(t,i),e.showChilds()}this.updateDom({updateIndexes:!0}),e.updateDom({recurse:!0})}},n.prototype.moveBefore=function(e,t){if(this._hasChilds()){var i=this.dom.tr?this.dom.tr.parentNode:void 0;if(i){var n=document.createElement("tr");n.style.height=i.clientHeight+"px",i.appendChild(n)}e.parent&&e.parent.removeChild(e),t instanceof l?this.appendChild(e):this.insertBefore(e,t),i&&i.removeChild(n)}},n.prototype.moveTo=function(e,t){if(e.parent==this){var i=this.childs.indexOf(e);i<t&&t++}var n=this.childs[t]||this.append;this.moveBefore(e,n)},n.prototype.insertBefore=function(e,t){if(this._hasChilds()){if(t==this.append)e.setParent(this),e.fieldEditable="object"==this.type,this.childs.push(e);else{var i=this.childs.indexOf(t);if(i==-1)throw new Error("Node not found");e.setParent(this),e.fieldEditable="object"==this.type,this.childs.splice(i,0,e)}if(this.expanded){var n=e.getDom(),r=t.getDom(),o=r?r.parentNode:void 0;r&&o&&o.insertBefore(n,r),e.showChilds()}this.updateDom({updateIndexes:!0}),e.updateDom({recurse:!0})}},n.prototype.insertAfter=function(e,t){if(this._hasChilds()){var i=this.childs.indexOf(t),n=this.childs[i+1];n?this.insertBefore(e,n):this.appendChild(e)}},n.prototype.search=function(e){var t,i=[],n=e?e.toLowerCase():void 0;if(delete this.searchField,delete this.searchValue,void 0!=this.field){var r=String(this.field).toLowerCase();t=r.indexOf(n),t!=-1&&(this.searchField=!0,i.push({node:this,elem:"field"})),this._updateDomField()}if(this._hasChilds()){if(this.childs){var o=[];this.childs.forEach(function(t){o=o.concat(t.search(e))}),i=i.concat(o)}if(void 0!=n){var s=!1;0==o.length?this.collapse(s):this.expand(s)}}else{if(void 0!=this.value){var a=String(this.value).toLowerCase();t=a.indexOf(n),t!=-1&&(this.searchValue=!0,i.push({node:this,elem:"value"}))}this._updateDomValue()}return i},n.prototype.scrollTo=function(e){if(!this.dom.tr||!this.dom.tr.parentNode)for(var t=this.parent,i=!1;t;)t.expand(i),t=t.parent;this.dom.tr&&this.dom.tr.parentNode&&this.editor.scrollTo(this.dom.tr.offsetTop,e)},n.focusElement=void 0,n.prototype.focus=function(e){if(n.focusElement=e,this.dom.tr&&this.dom.tr.parentNode){var t=this.dom;switch(e){case"drag":t.drag?t.drag.focus():t.menu.focus();break;case"menu":t.menu.focus();break;case"expand":this._hasChilds()?t.expand.focus():t.field&&this.fieldEditable?(t.field.focus(),a.selectContentEditable(t.field)):t.value&&!this._hasChilds()?(t.value.focus(),a.selectContentEditable(t.value)):t.menu.focus();break;case"field":t.field&&this.fieldEditable?(t.field.focus(),a.selectContentEditable(t.field)):t.value&&!this._hasChilds()?(t.value.focus(),a.selectContentEditable(t.value)):this._hasChilds()?t.expand.focus():t.menu.focus();break;case"value":default:t.value&&!this._hasChilds()?(t.value.focus(),a.selectContentEditable(t.value)):t.field&&this.fieldEditable?(t.field.focus(),a.selectContentEditable(t.field)):this._hasChilds()?t.expand.focus():t.menu.focus()}}},n.select=function(e){setTimeout(function(){a.selectContentEditable(e)},0)},n.prototype.blur=function(){this._getDomValue(!1),this._getDomField(!1)},n.prototype.containsNode=function(e){if(this==e)return!0;var t=this.childs;if(t)for(var i=0,n=t.length;i<n;i++)if(t[i].containsNode(e))return!0;return!1},n.prototype._move=function(e,t){if(e!=t){if(e.containsNode(this))throw new Error("Cannot move a field into a child of itself");e.parent&&e.parent.removeChild(e);var i=e.clone();e.clearDom(),t?this.insertBefore(i,t):this.appendChild(i)}},n.prototype.removeChild=function(e){if(this.childs){var t=this.childs.indexOf(e);if(t!=-1){e.hide(),delete e.searchField,delete e.searchValue;var i=this.childs.splice(t,1)[0];return i.parent=null,this.updateDom({updateIndexes:!0}),i}}},n.prototype._remove=function(e){this.removeChild(e)},n.prototype.changeType=function(e){var t=this.type;if(t!=e){if("string"!=e&&"auto"!=e||"string"!=t&&"auto"!=t){var i,n=this.dom.tr?this.dom.tr.parentNode:void 0;i=this.expanded?this.getAppend():this.getDom();var r=i&&i.parentNode?i.nextSibling:void 0;this.hide(),this.clearDom(),this.type=e,"object"==e?(this.childs||(this.childs=[]),this.childs.forEach(function(e,t){e.clearDom(),delete e.index,e.fieldEditable=!0,void 0==e.field&&(e.field="")}),"string"!=t&&"auto"!=t||(this.expanded=!0)):"array"==e?(this.childs||(this.childs=[]),this.childs.forEach(function(e,t){e.clearDom(),e.fieldEditable=!1,e.index=t}),"string"!=t&&"auto"!=t||(this.expanded=!0)):this.expanded=!1,n&&(r?n.insertBefore(this.getDom(),r):n.appendChild(this.getDom())),this.showChilds()}else this.type=e;"auto"!=e&&"string"!=e||("string"==e?this.value=String(this.value):this.value=this._stringCast(String(this.value)),this.focus()),this.updateDom({updateIndexes:!0})}},n.prototype._getDomValue=function(e){if(this.dom.value&&"array"!=this.type&&"object"!=this.type&&(this.valueInnerText=a.getInnerText(this.dom.value)),void 0!=this.valueInnerText)try{var t;if("string"==this.type)t=this._unescapeHTML(this.valueInnerText);else{var i=this._unescapeHTML(this.valueInnerText);t=this._stringCast(i)}t!==this.value&&(this.value=t,this._debouncedOnChangeValue())}catch(t){if(this.value=void 0,e!==!0)throw t}},n.prototype._onChangeValue=function(){var e=this.editor.getSelection();if(e.range){var t=a.textDiff(String(this.value),String(this.previousValue));e.range.startOffset=t.start,e.range.endOffset=t.end}var i=this.editor.getSelection();if(i.range){var n=a.textDiff(String(this.previousValue),String(this.value));i.range.startOffset=n.start,i.range.endOffset=n.end}this.editor._onAction("editValue",{node:this,oldValue:this.previousValue,newValue:this.value,oldSelection:e,newSelection:i}),this.previousValue=this.value},n.prototype._onChangeField=function(){var e=this.editor.getSelection();if(e.range){var t=a.textDiff(this.field,this.previousField);e.range.startOffset=t.start,e.range.endOffset=t.end}var i=this.editor.getSelection();if(i.range){var n=a.textDiff(this.previousField,this.field);i.range.startOffset=n.start,i.range.endOffset=n.end}this.editor._onAction("editField",{node:this,oldValue:this.previousField,newValue:this.field,oldSelection:e,newSelection:i}),this.previousField=this.field},n.prototype._updateDomValue=function(){var e=this.dom.value;if(e){var t=["jsoneditor-value"],i=this.value,n="auto"==this.type?a.type(i):this.type,r="string"==n&&a.isUrl(i);t.push("jsoneditor-"+n),r&&t.push("jsoneditor-url");var o=""==String(this.value)&&"array"!=this.type&&"object"!=this.type;if(o&&t.push("jsoneditor-empty"),this.searchValueActive&&t.push("jsoneditor-highlight-active"),this.searchValue&&t.push("jsoneditor-highlight"),e.className=t.join(" "),"array"==n||"object"==n){var s=this.childs?this.childs.length:0;e.title=this.type+" containing "+s+" items"}else r&&this.editable.value?e.title="Ctrl+Click or Ctrl+Enter to open url in new window":e.title="";if("boolean"===n&&this.editable.value?(this.dom.checkbox||(this.dom.checkbox=document.createElement("input"),this.dom.checkbox.type="checkbox",this.dom.tdCheckbox=document.createElement("td"),this.dom.tdCheckbox.className="jsoneditor-tree",this.dom.tdCheckbox.appendChild(this.dom.checkbox),this.dom.tdValue.parentNode.insertBefore(this.dom.tdCheckbox,this.dom.tdValue)),this.dom.checkbox.checked=this.value):this.dom.tdCheckbox&&(this.dom.tdCheckbox.parentNode.removeChild(this.dom.tdCheckbox),delete this.dom.tdCheckbox,delete this.dom.checkbox),this.enum&&this.editable.value){if(!this.dom.select){this.dom.select=document.createElement("select"),this.id=this.field+"_"+(new Date).getUTCMilliseconds(),this.dom.select.id=this.id,this.dom.select.name=this.dom.select.id,this.dom.select.option=document.createElement("option"),this.dom.select.option.value="",this.dom.select.option.innerHTML="--",this.dom.select.appendChild(this.dom.select.option);for(var l=0;l<this.enum.length;l++)this.dom.select.option=document.createElement("option"),this.dom.select.option.value=this.enum[l],this.dom.select.option.innerHTML=this.enum[l],this.dom.select.option.value==this.value&&(this.dom.select.option.selected=!0),this.dom.select.appendChild(this.dom.select.option);this.dom.tdSelect=document.createElement("td"),this.dom.tdSelect.className="jsoneditor-tree",this.dom.tdSelect.appendChild(this.dom.select),this.dom.tdValue.parentNode.insertBefore(this.dom.tdSelect,this.dom.tdValue)}!this.schema||this.schema.hasOwnProperty("oneOf")||this.schema.hasOwnProperty("anyOf")||this.schema.hasOwnProperty("allOf")?delete this.valueFieldHTML:(this.valueFieldHTML=this.dom.tdValue.innerHTML,this.dom.tdValue.style.visibility="hidden",this.dom.tdValue.innerHTML="")}else this.dom.tdSelect&&(this.dom.tdSelect.parentNode.removeChild(this.dom.tdSelect),delete this.dom.tdSelect,delete this.dom.select,this.dom.tdValue.innerHTML=this.valueFieldHTML,this.dom.tdValue.style.visibility="",delete this.valueFieldHTML);a.stripFormatting(e)}},n.prototype._updateDomField=function(){var e=this.dom.field;if(e){var t=""==String(this.field)&&"array"!=this.parent.type;t?a.addClassName(e,"jsoneditor-empty"):a.removeClassName(e,"jsoneditor-empty"),this.searchFieldActive?a.addClassName(e,"jsoneditor-highlight-active"):a.removeClassName(e,"jsoneditor-highlight-active"),this.searchField?a.addClassName(e,"jsoneditor-highlight"):a.removeClassName(e,"jsoneditor-highlight"),a.stripFormatting(e)}},n.prototype._getDomField=function(e){if(this.dom.field&&this.fieldEditable&&(this.fieldInnerText=a.getInnerText(this.dom.field)),void 0!=this.fieldInnerText)try{var t=this._unescapeHTML(this.fieldInnerText);t!==this.field&&(this.field=t,this._debouncedOnChangeField())}catch(t){if(this.field=void 0,e!==!0)throw t}},n.prototype.validate=function(){var e=[];if("object"===this.type){for(var t={},i=[],n=0;n<this.childs.length;n++){var r=this.childs[n];t.hasOwnProperty(r.field)&&i.push(r.field),t[r.field]=!0}i.length>0&&(e=this.childs.filter(function(e){return i.indexOf(e.field)!==-1}).map(function(e){return{node:e,error:{message:'duplicate key "'+e.field+'"'}}}))}if(this.childs)for(var n=0;n<this.childs.length;n++){var o=this.childs[n].validate();o.length>0&&(e=e.concat(o))}return e},n.prototype.clearDom=function(){this.dom={}},n.prototype.getDom=function(){var e=this.dom;if(e.tr)return e.tr;if(this._updateEditability(),e.tr=document.createElement("tr"),e.tr.node=this,"tree"===this.editor.options.mode){var t=document.createElement("td");if(this.editable.field&&this.parent){var i=document.createElement("button");i.type="button",e.drag=i,i.className="jsoneditor-dragarea",i.title="Drag to move this field (Alt+Shift+Arrows)",t.appendChild(i)}e.tr.appendChild(t);var n=document.createElement("td"),r=document.createElement("button");r.type="button",e.menu=r,r.className="jsoneditor-contextmenu",r.title="Click to open the actions menu (Ctrl+M)",n.appendChild(e.menu),e.tr.appendChild(n)}var o=document.createElement("td");return e.tr.appendChild(o),e.tree=this._createDomTree(),o.appendChild(e.tree),this.updateDom({updateIndexes:!0}),e.tr},n.onDragStart=function(e,t){if(!Array.isArray(e))return n.onDragStart([e],t);if(0!==e.length){var i=e[0],r=e[e.length-1],o=n.getNodeFromTarget(t.target),s=r._nextSibling(),l=i.editor,c=a.getAbsoluteTop(o.dom.tr)-a.getAbsoluteTop(i.dom.tr);l.mousemove||(l.mousemove=a.addEventListener(window,"mousemove",function(t){n.onDrag(e,t)})),l.mouseup||(l.mouseup=a.addEventListener(window,"mouseup",function(t){n.onDragEnd(e,t)})),l.highlighter.lock(),l.drag={oldCursor:document.body.style.cursor,oldSelection:l.getSelection(),oldBeforeNode:s,mouseX:t.pageX,offsetY:c,level:i.getLevel()},document.body.style.cursor="move",t.preventDefault()}},n.onDrag=function(e,t){if(!Array.isArray(e))return n.onDrag([e],t);if(0!==e.length){var i,r,o,s,c,h,d,u,f,p,m,g,v,y,w=e[0].editor,b=t.pageY-w.drag.offsetY,A=t.pageX,C=!1,E=e[0];if(i=E.dom.tr,f=a.getAbsoluteTop(i),g=i.offsetHeight,b<f){r=i;do r=r.previousSibling,d=n.getNodeFromTarget(r),p=r?a.getAbsoluteTop(r):0;while(r&&b<p);d&&!d.parent&&(d=void 0),d||(h=i.parentNode.firstChild,r=h?h.nextSibling:void 0,d=n.getNodeFromTarget(r),d==E&&(d=void 0)),d&&(r=d.dom.tr,p=r?a.getAbsoluteTop(r):0,b>p+g&&(d=void 0)),d&&(e.forEach(function(e){d.parent.moveBefore(e,d)}),C=!0)}else{var x=e[e.length-1];if(c=x.expanded&&x.append?x.append.getDom():x.dom.tr,s=c?c.nextSibling:void 0){m=a.getAbsoluteTop(s),o=s;do u=n.getNodeFromTarget(o),o&&(v=o.nextSibling?a.getAbsoluteTop(o.nextSibling):0,y=o?v-m:0,u.parent.childs.length==e.length&&u.parent.childs[e.length-1]==x&&(f+=27)),o=o.nextSibling;while(o&&b>f+y);if(u&&u.parent){var F=A-w.drag.mouseX,k=Math.round(F/24/2),S=w.drag.level+k,$=u.getLevel();for(r=u.dom.tr.previousSibling;$<S&&r;){d=n.getNodeFromTarget(r);var D=e.some(function(e){return e===d||d._isChildOf(e)});if(D);else{if(!(d instanceof l))break;var B=d.parent.childs;if(B.length==e.length&&B[e.length-1]==x)break;u=n.getNodeFromTarget(r),$=u.getLevel()}r=r.previousSibling}c.nextSibling!=u.dom.tr&&(e.forEach(function(e){u.parent.moveBefore(e,u)}),C=!0)}}}C&&(w.drag.mouseX=A,w.drag.level=E.getLevel()),w.startAutoScroll(b),t.preventDefault()}},n.onDragEnd=function(e,t){if(!Array.isArray(e))return n.onDrag([e],t);if(0!==e.length){var i=e[0],r=i.editor,o=i.parent,s=o.childs.indexOf(i),l=o.childs[s+e.length]||o.append;e[0]&&e[0].dom.menu.focus();var c={nodes:e,oldSelection:r.drag.oldSelection,newSelection:r.getSelection(),oldBeforeNode:r.drag.oldBeforeNode,newBeforeNode:l};c.oldBeforeNode!=c.newBeforeNode&&r._onAction("moveNodes",c),document.body.style.cursor=r.drag.oldCursor,r.highlighter.unlock(),e.forEach(function(e){t.target!==e.dom.drag&&t.target!==e.dom.menu&&r.highlighter.unhighlight()}),delete r.drag,r.mousemove&&(a.removeEventListener(window,"mousemove",r.mousemove),delete r.mousemove),r.mouseup&&(a.removeEventListener(window,"mouseup",r.mouseup),delete r.mouseup),r.stopAutoScroll(),t.preventDefault()}},n.prototype._isChildOf=function(e){for(var t=this.parent;t;){if(t==e)return!0;t=t.parent}return!1},n.prototype._createDomField=function(){return document.createElement("div")},n.prototype.setHighlight=function(e){this.dom.tr&&(e?a.addClassName(this.dom.tr,"jsoneditor-highlight"):a.removeClassName(this.dom.tr,"jsoneditor-highlight"),this.append&&this.append.setHighlight(e),this.childs&&this.childs.forEach(function(t){t.setHighlight(e)}))},n.prototype.setSelected=function(e,t){this.selected=e,this.dom.tr&&(e?a.addClassName(this.dom.tr,"jsoneditor-selected"):a.removeClassName(this.dom.tr,"jsoneditor-selected"),t?a.addClassName(this.dom.tr,"jsoneditor-first"):a.removeClassName(this.dom.tr,"jsoneditor-first"),this.append&&this.append.setSelected(e),this.childs&&this.childs.forEach(function(t){t.setSelected(e)}))},n.prototype.updateValue=function(e){this.value=e,this.updateDom()},n.prototype.updateField=function(e){this.field=e,this.updateDom()},n.prototype.updateDom=function(e){var t=this.dom.tree;t&&(t.style.marginLeft=24*this.getLevel()+"px");var i=this.dom.field;if(i){this.fieldEditable?(i.contentEditable=this.editable.field,i.spellcheck=!1,i.className="jsoneditor-field"):i.className="jsoneditor-readonly";var n;n=void 0!=this.index?this.index:void 0!=this.field?this.field:this._hasChilds()?this.type:"",i.innerHTML=this._escapeHTML(n),this._updateSchema()}var r=this.dom.value;if(r){var o=this.childs?this.childs.length:0;"array"==this.type?(r.innerHTML="["+o+"]",a.addClassName(this.dom.tr,"jsoneditor-expandable")):"object"==this.type?(r.innerHTML="{"+o+"}",a.addClassName(this.dom.tr,"jsoneditor-expandable")):(r.innerHTML=this._escapeHTML(this.value),a.removeClassName(this.dom.tr,"jsoneditor-expandable"))}this._updateDomField(),this._updateDomValue(),e&&e.updateIndexes===!0&&this._updateDomIndexes(),e&&e.recurse===!0&&this.childs&&this.childs.forEach(function(t){t.updateDom(e)}),this.append&&this.append.updateDom()},n.prototype._updateSchema=function(){this.editor&&this.editor.options&&(this.schema=n._findSchema(this.editor.options.schema,this.getPath()),this.schema?this.enum=n._findEnum(this.schema):delete this.enum)},n._findEnum=function(e){if(e.enum)return e.enum;var t=e.oneOf||e.anyOf||e.allOf;if(t){var i=t.filter(function(e){return e.enum});if(i.length>0)return i[0].enum}return null},n._findSchema=function(e,t){for(var i=e,n=0;n<t.length&&i;n++){var r=t[n];"string"==typeof r&&i.properties?i=i.properties[r]||null:"number"==typeof r&&i.items&&(i=i.items)}return i},n.prototype._updateDomIndexes=function(){var e=this.dom.value,t=this.childs;e&&t&&("array"==this.type?t.forEach(function(e,t){e.index=t;var i=e.dom.field;i&&(i.innerHTML=t)}):"object"==this.type&&t.forEach(function(e){void 0!=e.index&&(delete e.index,void 0==e.field&&(e.field=""))}))},n.prototype._createDomValue=function(){var e;return"array"==this.type?(e=document.createElement("div"),e.innerHTML="[...]"):"object"==this.type?(e=document.createElement("div"),e.innerHTML="{...}"):!this.editable.value&&a.isUrl(this.value)?(e=document.createElement("a"),e.href=this.value,e.target="_blank",e.innerHTML=this._escapeHTML(this.value)):(e=document.createElement("div"),e.contentEditable=this.editable.value,e.spellcheck=!1,e.innerHTML=this._escapeHTML(this.value)),e},n.prototype._createDomExpandButton=function(){var e=document.createElement("button");return e.type="button",this._hasChilds()?(e.className=this.expanded?"jsoneditor-expanded":"jsoneditor-collapsed",e.title="Click to expand/collapse this field (Ctrl+E). \nCtrl+Click to expand/collapse including all childs."):(e.className="jsoneditor-invisible",e.title=""),e},n.prototype._createDomTree=function(){var e=this.dom,t=document.createElement("table"),i=document.createElement("tbody");t.style.borderCollapse="collapse",t.className="jsoneditor-values",t.appendChild(i);var n=document.createElement("tr");i.appendChild(n);var r=document.createElement("td");r.className="jsoneditor-tree",n.appendChild(r),e.expand=this._createDomExpandButton(),r.appendChild(e.expand),e.tdExpand=r;var o=document.createElement("td");o.className="jsoneditor-tree",n.appendChild(o),e.field=this._createDomField(),o.appendChild(e.field),e.tdField=o;var s=document.createElement("td");s.className="jsoneditor-tree",n.appendChild(s),"object"!=this.type&&"array"!=this.type&&(s.appendChild(document.createTextNode(":")),s.className="jsoneditor-separator"),e.tdSeparator=s;var a=document.createElement("td");return a.className="jsoneditor-tree",n.appendChild(a),e.value=this._createDomValue(),a.appendChild(e.value),e.tdValue=a,t},n.prototype.onEvent=function(e){var t=e.type,i=e.target||e.srcElement,n=this.dom,r=this,o=this._hasChilds();if(i!=n.drag&&i!=n.menu||("mouseover"==t?this.editor.highlighter.highlight(this):"mouseout"==t&&this.editor.highlighter.unhighlight()),"click"==t&&i==n.menu){var s=r.editor.highlighter;s.highlight(r),s.lock(),a.addClassName(n.menu,"jsoneditor-selected"),this.showContextMenu(n.menu,function(){a.removeClassName(n.menu,"jsoneditor-selected"),s.unlock(),s.unhighlight()})}if("click"==t&&(i==n.expand||("view"===r.editor.options.mode||"form"===r.editor.options.mode)&&"DIV"===i.nodeName)&&o){var l=e.ctrlKey;this._onExpand(l)}"change"==t&&i==n.checkbox&&(this.dom.value.innerHTML=!this.value,this._getDomValue()),"change"==t&&i==n.select&&(this.dom.value.innerHTML=n.select.value,this._getDomValue(),this._updateDomValue());var c=n.value;if(i==c)switch(t){case"blur":case"change":this._getDomValue(!0),this._updateDomValue(),this.value&&(c.innerHTML=this._escapeHTML(this.value));break;case"input":this._getDomValue(!0),this._updateDomValue();break;case"keydown":case"mousedown":this.editor.selection=this.editor.getSelection();break;case"click":!e.ctrlKey&&this.editable.value||a.isUrl(this.value)&&window.open(this.value,"_blank");break;case"keyup":this._getDomValue(!0),this._updateDomValue();break;case"cut":case"paste":setTimeout(function(){r._getDomValue(!0),r._updateDomValue()},1)}var h=n.field;if(i==h)switch(t){case"blur":case"change":this._getDomField(!0),this._updateDomField(),this.field&&(h.innerHTML=this._escapeHTML(this.field));break;case"input":this._getDomField(!0),this._updateSchema(),this._updateDomField(),this._updateDomValue();break;case"keydown":case"mousedown":this.editor.selection=this.editor.getSelection();break;case"keyup":this._getDomField(!0),this._updateDomField();break;case"cut":case"paste":setTimeout(function(){r._getDomField(!0),r._updateDomField()},1)}var d=n.tree;if(i==d.parentNode&&"click"==t&&!e.hasMoved){var u=void 0!=e.offsetX?e.offsetX<24*(this.getLevel()+1):e.pageX<a.getAbsoluteLeft(n.tdSeparator);u||o?h&&(a.setEndOfContentEditable(h),h.focus()):c&&!this.enum&&(a.setEndOfContentEditable(c),c.focus())}(i!=n.tdExpand||o)&&i!=n.tdField&&i!=n.tdSeparator||"click"!=t||e.hasMoved||h&&(a.setEndOfContentEditable(h),h.focus()),"keydown"==t&&this.onKeyDown(e)},n.prototype.onKeyDown=function(e){var t,i,r,o,s,c,h,d,u=e.which||e.keyCode,f=e.target||e.srcElement,p=e.ctrlKey,m=e.shiftKey,g=e.altKey,v=!1,y="tree"===this.editor.options.mode,w=this.editor.multiselection.nodes.length>0?this.editor.multiselection.nodes:[this],b=w[0],A=w[w.length-1];if(13==u){if(f==this.dom.value)this.editable.value&&!e.ctrlKey||a.isUrl(this.value)&&(window.open(this.value,"_blank"),v=!0);else if(f==this.dom.expand){var C=this._hasChilds();if(C){var E=e.ctrlKey;this._onExpand(E),f.focus(),v=!0}}}else if(68==u)p&&y&&(n.onDuplicate(w),v=!0);else if(69==u)p&&(this._onExpand(m),f.focus(),v=!0);else if(77==u&&y)p&&(this.showContextMenu(f),v=!0);else if(46==u&&y)p&&(n.onRemove(w),v=!0);else if(45==u&&y)p&&!m?(this._onInsertBefore(),v=!0):p&&m&&(this._onInsertAfter(),v=!0);else if(35==u){if(g){var x=this._lastNode();x&&x.focus(n.focusElement||this._getElementName(f)),v=!0}}else if(36==u){if(g){var F=this._firstNode();F&&F.focus(n.focusElement||this._getElementName(f)),v=!0}}else if(37==u){if(g&&!m){var k=this._previousElement(f);k&&this.focus(this._getElementName(k)),v=!0}else if(g&&m&&y){if(A.expanded){var S=A.getAppend();r=S?S.nextSibling:void 0}else{var $=A.getDom();r=$.nextSibling}r&&(i=n.getNodeFromTarget(r),o=r.nextSibling,_=n.getNodeFromTarget(o),i&&i instanceof l&&1!=A.parent.childs.length&&_&&_.parent&&(s=this.editor.getSelection(),
	c=A._nextSibling(),w.forEach(function(e){_.parent.moveBefore(e,_)}),this.focus(n.focusElement||this._getElementName(f)),this.editor._onAction("moveNodes",{nodes:w,oldBeforeNode:c,newBeforeNode:_,oldSelection:s,newSelection:this.editor.getSelection()})))}}else if(38==u)g&&!m?(t=this._previousNode(),t&&(this.editor.deselect(!0),t.focus(n.focusElement||this._getElementName(f))),v=!0):!g&&p&&m&&y?(t=this._previousNode(),t&&(d=this.editor.multiselection,d.start=d.start||this,d.end=t,h=this.editor._findTopLevelNodes(d.start,d.end),this.editor.select(h),t.focus("field")),v=!0):g&&m&&y&&(t=b._previousNode(),t&&t.parent&&(s=this.editor.getSelection(),c=A._nextSibling(),w.forEach(function(e){t.parent.moveBefore(e,t)}),this.focus(n.focusElement||this._getElementName(f)),this.editor._onAction("moveNodes",{nodes:w,oldBeforeNode:c,newBeforeNode:t,oldSelection:s,newSelection:this.editor.getSelection()})),v=!0);else if(39==u){if(g&&!m){var D=this._nextElement(f);D&&this.focus(this._getElementName(D)),v=!0}else if(g&&m&&y){$=b.getDom();var B=$.previousSibling;B&&(t=n.getNodeFromTarget(B),t&&t.parent&&t instanceof l&&!t.isVisible()&&(s=this.editor.getSelection(),c=A._nextSibling(),w.forEach(function(e){t.parent.moveBefore(e,t)}),this.focus(n.focusElement||this._getElementName(f)),this.editor._onAction("moveNodes",{nodes:w,oldBeforeNode:c,newBeforeNode:t,oldSelection:s,newSelection:this.editor.getSelection()})))}}else if(40==u)if(g&&!m)i=this._nextNode(),i&&(this.editor.deselect(!0),i.focus(n.focusElement||this._getElementName(f))),v=!0;else if(!g&&p&&m&&y)i=this._nextNode(),i&&(d=this.editor.multiselection,d.start=d.start||this,d.end=i,h=this.editor._findTopLevelNodes(d.start,d.end),this.editor.select(h),i.focus("field")),v=!0;else if(g&&m&&y){i=A.expanded?A.append?A.append._nextNode():void 0:A._nextNode();var _=i&&(i._nextNode()||i.parent.append);_&&_.parent&&(s=this.editor.getSelection(),c=A._nextSibling(),w.forEach(function(e){_.parent.moveBefore(e,_)}),this.focus(n.focusElement||this._getElementName(f)),this.editor._onAction("moveNodes",{nodes:w,oldBeforeNode:c,newBeforeNode:_,oldSelection:s,newSelection:this.editor.getSelection()})),v=!0}v&&(e.preventDefault(),e.stopPropagation())},n.prototype._onExpand=function(e){if(e){var t=this.dom.tr.parentNode,i=t.parentNode,n=i.scrollTop;i.removeChild(t)}this.expanded?this.collapse(e):this.expand(e),e&&(i.appendChild(t),i.scrollTop=n)},n.onRemove=function(e){if(!Array.isArray(e))return n.onRemove([e]);if(e&&e.length>0){var t=e[0],i=t.parent,r=t.editor,o=t.getIndex();r.highlighter.unhighlight();var s=r.getSelection();n.blurNodes(e);var a=r.getSelection();e.forEach(function(e){e.parent._remove(e)}),r._onAction("removeNodes",{nodes:e.slice(0),parent:i,index:o,oldSelection:s,newSelection:a})}},n.onDuplicate=function(e){if(!Array.isArray(e))return n.onDuplicate([e]);if(e&&e.length>0){var t=e[e.length-1],i=t.parent,r=t.editor;r.deselect(r.multiselection.nodes);var o=r.getSelection(),s=t,a=e.map(function(e){var t=e.clone();return i.insertAfter(t,s),s=t,t});1===e.length?a[0].focus():r.select(a);var l=r.getSelection();r._onAction("duplicateNodes",{afterNode:t,nodes:a,parent:i,oldSelection:o,newSelection:l})}},n.prototype._onInsertBefore=function(e,t,i){var r=this.editor.getSelection(),o=new n(this.editor,{field:void 0!=e?e:"",value:void 0!=t?t:"",type:i});o.expand(!0),this.parent.insertBefore(o,this),this.editor.highlighter.unhighlight(),o.focus("field");var s=this.editor.getSelection();this.editor._onAction("insertBeforeNodes",{nodes:[o],beforeNode:this,parent:this.parent,oldSelection:r,newSelection:s})},n.prototype._onInsertAfter=function(e,t,i){var r=this.editor.getSelection(),o=new n(this.editor,{field:void 0!=e?e:"",value:void 0!=t?t:"",type:i});o.expand(!0),this.parent.insertAfter(o,this),this.editor.highlighter.unhighlight(),o.focus("field");var s=this.editor.getSelection();this.editor._onAction("insertAfterNodes",{nodes:[o],afterNode:this,parent:this.parent,oldSelection:r,newSelection:s})},n.prototype._onAppend=function(e,t,i){var r=this.editor.getSelection(),o=new n(this.editor,{field:void 0!=e?e:"",value:void 0!=t?t:"",type:i});o.expand(!0),this.parent.appendChild(o),this.editor.highlighter.unhighlight(),o.focus("field");var s=this.editor.getSelection();this.editor._onAction("appendNodes",{nodes:[o],parent:this.parent,oldSelection:r,newSelection:s})},n.prototype._onChangeType=function(e){var t=this.type;if(e!=t){var i=this.editor.getSelection();this.changeType(e);var n=this.editor.getSelection();this.editor._onAction("changeType",{node:this,oldType:t,newType:e,oldSelection:i,newSelection:n})}},n.prototype.sort=function(e){if(this._hasChilds()){var t="desc"==e?-1:1,i="array"==this.type?"value":"field";this.hideChilds();var n=this.childs,o=this.sortOrder;this.childs=this.childs.concat(),this.childs.sort(function(e,n){return t*r(e[i],n[i])}),this.sortOrder=1==t?"asc":"desc",this.editor._onAction("sort",{node:this,oldChilds:n,oldSort:o,newChilds:this.childs,newSort:this.sortOrder}),this.showChilds()}},n.prototype.getAppend=function(){return this.append||(this.append=new l(this.editor),this.append.setParent(this)),this.append.getDom()},n.getNodeFromTarget=function(e){for(;e;){if(e.node)return e.node;e=e.parentNode}},n.blurNodes=function(e){if(!Array.isArray(e))return void n.blurNodes([e]);var t=e[0],i=t.parent,r=t.getIndex();i.childs[r+e.length]?i.childs[r+e.length].focus():i.childs[r-1]?i.childs[r-1].focus():i.focus()},n.prototype._nextSibling=function(){var e=this.parent.childs.indexOf(this);return this.parent.childs[e+1]||this.parent.append},n.prototype._previousNode=function(){var e=null,t=this.getDom();if(t&&t.parentNode){var i=t;do i=i.previousSibling,e=n.getNodeFromTarget(i);while(i&&e instanceof l&&!e.isVisible())}return e},n.prototype._nextNode=function(){var e=null,t=this.getDom();if(t&&t.parentNode){var i=t;do i=i.nextSibling,e=n.getNodeFromTarget(i);while(i&&e instanceof l&&!e.isVisible())}return e},n.prototype._firstNode=function(){var e=null,t=this.getDom();if(t&&t.parentNode){var i=t.parentNode.firstChild;e=n.getNodeFromTarget(i)}return e},n.prototype._lastNode=function(){var e=null,t=this.getDom();if(t&&t.parentNode){var i=t.parentNode.lastChild;for(e=n.getNodeFromTarget(i);i&&e instanceof l&&!e.isVisible();)i=i.previousSibling,e=n.getNodeFromTarget(i)}return e},n.prototype._previousElement=function(e){var t=this.dom;switch(e){case t.value:if(this.fieldEditable)return t.field;case t.field:if(this._hasChilds())return t.expand;case t.expand:return t.menu;case t.menu:if(t.drag)return t.drag;default:return null}},n.prototype._nextElement=function(e){var t=this.dom;switch(e){case t.drag:return t.menu;case t.menu:if(this._hasChilds())return t.expand;case t.expand:if(this.fieldEditable)return t.field;case t.field:if(!this._hasChilds())return t.value;default:return null}},n.prototype._getElementName=function(e){var t=this.dom;for(var i in t)if(t.hasOwnProperty(i)&&t[i]==e)return i;return null},n.prototype._hasChilds=function(){return"array"==this.type||"object"==this.type},n.TYPE_TITLES={auto:'Field type "auto". The field type is automatically determined from the value and can be a string, number, boolean, or null.',object:'Field type "object". An object contains an unordered set of key/value pairs.',array:'Field type "array". An array contains an ordered collection of values.',string:'Field type "string". Field type is not determined from the value, but always returned as string.'},n.prototype.showContextMenu=function(e,t){var i=this,r=n.TYPE_TITLES,s=[];if(this.editable.value&&s.push({text:"Type",title:"Change the type of this field",className:"jsoneditor-type-"+this.type,submenu:[{text:"Auto",className:"jsoneditor-type-auto"+("auto"==this.type?" jsoneditor-selected":""),title:r.auto,click:function(){i._onChangeType("auto")}},{text:"Array",className:"jsoneditor-type-array"+("array"==this.type?" jsoneditor-selected":""),title:r.array,click:function(){i._onChangeType("array")}},{text:"Object",className:"jsoneditor-type-object"+("object"==this.type?" jsoneditor-selected":""),title:r.object,click:function(){i._onChangeType("object")}},{text:"String",className:"jsoneditor-type-string"+("string"==this.type?" jsoneditor-selected":""),title:r.string,click:function(){i._onChangeType("string")}}]}),this._hasChilds()){var a="asc"==this.sortOrder?"desc":"asc";s.push({text:"Sort",title:"Sort the childs of this "+this.type,className:"jsoneditor-sort-"+a,click:function(){i.sort(a)},submenu:[{text:"Ascending",className:"jsoneditor-sort-asc",title:"Sort the childs of this "+this.type+" in ascending order",click:function(){i.sort("asc")}},{text:"Descending",className:"jsoneditor-sort-desc",title:"Sort the childs of this "+this.type+" in descending order",click:function(){i.sort("desc")}}]})}if(this.parent&&this.parent._hasChilds()){s.length&&s.push({type:"separator"});var l=i.parent.childs;i==l[l.length-1]&&s.push({text:"Append",title:"Append a new field with type 'auto' after this field (Ctrl+Shift+Ins)",submenuTitle:"Select the type of the field to be appended",className:"jsoneditor-append",click:function(){i._onAppend("","","auto")},submenu:[{text:"Auto",className:"jsoneditor-type-auto",title:r.auto,click:function(){i._onAppend("","","auto")}},{text:"Array",className:"jsoneditor-type-array",title:r.array,click:function(){i._onAppend("",[])}},{text:"Object",className:"jsoneditor-type-object",title:r.object,click:function(){i._onAppend("",{})}},{text:"String",className:"jsoneditor-type-string",title:r.string,click:function(){i._onAppend("","","string")}}]}),s.push({text:"Insert",title:"Insert a new field with type 'auto' before this field (Ctrl+Ins)",submenuTitle:"Select the type of the field to be inserted",className:"jsoneditor-insert",click:function(){i._onInsertBefore("","","auto")},submenu:[{text:"Auto",className:"jsoneditor-type-auto",title:r.auto,click:function(){i._onInsertBefore("","","auto")}},{text:"Array",className:"jsoneditor-type-array",title:r.array,click:function(){i._onInsertBefore("",[])}},{text:"Object",className:"jsoneditor-type-object",title:r.object,click:function(){i._onInsertBefore("",{})}},{text:"String",className:"jsoneditor-type-string",title:r.string,click:function(){i._onInsertBefore("","","string")}}]}),this.editable.field&&(s.push({text:"Duplicate",title:"Duplicate this field (Ctrl+D)",className:"jsoneditor-duplicate",click:function(){n.onDuplicate(i)}}),s.push({text:"Remove",title:"Remove this field (Ctrl+Del)",className:"jsoneditor-remove",click:function(){n.onRemove(i)}}))}var c=new o(s,{close:t});c.show(e,this.editor.content)},n.prototype._getType=function(e){return e instanceof Array?"array":e instanceof Object?"object":"string"==typeof e&&"string"!=typeof this._stringCast(e)?"string":"auto"},n.prototype._stringCast=function(e){var t=e.toLowerCase(),i=Number(e),n=parseFloat(e);return""==e?"":"null"==t?null:"true"==t||"false"!=t&&(isNaN(i)||isNaN(n)?e:i)},n.prototype._escapeHTML=function(e){if("string"!=typeof e)return String(e);var t=String(e).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/  /g," &nbsp;").replace(/^ /,"&nbsp;").replace(/ $/,"&nbsp;"),i=JSON.stringify(t),n=i.substring(1,i.length-1);return this.editor.options.escapeUnicode===!0&&(n=a.escapeUnicodeChars(n)),n},n.prototype._unescapeHTML=function(e){var t='"'+this._escapeJSON(e)+'"',i=a.parse(t);return i.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&nbsp;|\u00A0/g," ").replace(/&amp;/g,"&")},n.prototype._escapeJSON=function(e){for(var t="",i=0;i<e.length;){var n=e.charAt(i);"\n"==n?t+="\\n":"\\"==n?(t+=n,i++,n=e.charAt(i),""!==n&&'"\\/bfnrtu'.indexOf(n)!=-1||(t+="\\"),t+=n):t+='"'==n?'\\"':n,i++}return t};var l=s(n);e.exports=n},function(e,t){e.exports=function e(t,i){"use strict";var n,r,o=/(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,s=/(^[ ]*|[ ]*$)/g,a=/(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,l=/^0x[0-9a-f]+$/i,c=/^0/,h=function(t){return e.insensitive&&(""+t).toLowerCase()||""+t},d=h(t).replace(s,"")||"",u=h(i).replace(s,"")||"",f=d.replace(o,"\0$1\0").replace(/\0$/,"").replace(/^\0/,"").split("\0"),p=u.replace(o,"\0$1\0").replace(/\0$/,"").replace(/^\0/,"").split("\0"),m=parseInt(d.match(l),16)||1!==f.length&&d.match(a)&&Date.parse(d),g=parseInt(u.match(l),16)||m&&u.match(a)&&Date.parse(u)||null;if(g){if(m<g)return-1;if(m>g)return 1}for(var v=0,y=Math.max(f.length,p.length);v<y;v++){if(n=!(f[v]||"").match(c)&&parseFloat(f[v])||f[v]||0,r=!(p[v]||"").match(c)&&parseFloat(p[v])||p[v]||0,isNaN(n)!==isNaN(r))return isNaN(n)?1:-1;if(typeof n!=typeof r&&(n+="",r+=""),n<r)return-1;if(n>r)return 1}return 0}},function(e,t,i){"use strict";function n(e){function t(e){this.editor=e,this.dom={}}return t.prototype=new e,t.prototype.getDom=function(){var e=this.dom;if(e.tr)return e.tr;this._updateEditability();var t=document.createElement("tr");if(t.node=this,e.tr=t,"tree"===this.editor.options.mode){e.tdDrag=document.createElement("td");var i=document.createElement("td");e.tdMenu=i;var n=document.createElement("button");n.type="button",n.className="jsoneditor-contextmenu",n.title="Click to open the actions menu (Ctrl+M)",e.menu=n,i.appendChild(e.menu)}var r=document.createElement("td"),o=document.createElement("div");return o.innerHTML="(empty)",o.className="jsoneditor-readonly",r.appendChild(o),e.td=r,e.text=o,this.updateDom(),t},t.prototype.updateDom=function(){var e=this.dom,t=e.td;t&&(t.style.paddingLeft=24*this.getLevel()+26+"px");var i=e.text;i&&(i.innerHTML="(empty "+this.parent.type+")");var n=e.tr;this.isVisible()?e.tr.firstChild||(e.tdDrag&&n.appendChild(e.tdDrag),e.tdMenu&&n.appendChild(e.tdMenu),n.appendChild(t)):e.tr.firstChild&&(e.tdDrag&&n.removeChild(e.tdDrag),e.tdMenu&&n.removeChild(e.tdMenu),n.removeChild(t))},t.prototype.isVisible=function(){return 0==this.parent.childs.length},t.prototype.showContextMenu=function(t,i){var n=this,r=e.TYPE_TITLES,s=[{text:"Append",title:"Append a new field with type 'auto' (Ctrl+Shift+Ins)",submenuTitle:"Select the type of the field to be appended",className:"jsoneditor-insert",click:function(){n._onAppend("","","auto")},submenu:[{text:"Auto",className:"jsoneditor-type-auto",title:r.auto,click:function(){n._onAppend("","","auto")}},{text:"Array",className:"jsoneditor-type-array",title:r.array,click:function(){n._onAppend("",[])}},{text:"Object",className:"jsoneditor-type-object",title:r.object,click:function(){n._onAppend("",{})}},{text:"String",className:"jsoneditor-type-string",title:r.string,click:function(){n._onAppend("","","string")}}]}],a=new o(s,{close:i});a.show(t,this.editor.content)},t.prototype.onEvent=function(e){var t=e.type,i=e.target||e.srcElement,n=this.dom,o=n.menu;if(i==o&&("mouseover"==t?this.editor.highlighter.highlight(this.parent):"mouseout"==t&&this.editor.highlighter.unhighlight()),"click"==t&&i==n.menu){var s=this.editor.highlighter;s.highlight(this.parent),s.lock(),r.addClassName(n.menu,"jsoneditor-selected"),this.showContextMenu(n.menu,function(){r.removeClassName(n.menu,"jsoneditor-selected"),s.unlock(),s.unhighlight()})}"keydown"==t&&this.onKeyDown(e)},t}var r=i(58),o=i(61);e.exports=n},function(e,t,i){"use strict";function n(e,t,i,n){for(var o={code:{text:"Code",title:"Switch to code highlighter",click:function(){n("code")}},form:{text:"Form",title:"Switch to form editor",click:function(){n("form")}},text:{text:"Text",title:"Switch to plain text editor",click:function(){n("text")}},tree:{text:"Tree",title:"Switch to tree editor",click:function(){n("tree")}},view:{text:"View",title:"Switch to tree view",click:function(){n("view")}}},s=[],a=0;a<t.length;a++){var l=t[a],c=o[l];if(!c)throw new Error('Unknown mode "'+l+'"');c.className="jsoneditor-type-modes"+(i==l?" jsoneditor-selected":""),s.push(c)}var h=o[i];if(!h)throw new Error('Unknown mode "'+i+'"');var d=h.text,u=document.createElement("button");u.type="button",u.className="jsoneditor-modes jsoneditor-separator",u.innerHTML=d+" &#x25BE;",u.title="Switch editor mode",u.onclick=function(){var e=new r(s);e.show(u)};var f=document.createElement("div");f.className="jsoneditor-modes",f.style.position="relative",f.appendChild(u),e.appendChild(f),this.dom={container:e,box:u,frame:f}}var r=i(61);n.prototype.focus=function(){this.dom.box.focus()},n.prototype.destroy=function(){this.dom&&this.dom.frame&&this.dom.frame.parentNode&&this.dom.frame.parentNode.removeChild(this.dom.frame),this.dom=null},e.exports=n},function(e,t,i){"use strict";var n;try{n=i(67)}catch(e){}var r=i(65),o=i(58),s={},a=3,l="ace/theme/jsoneditor";s.create=function(e,t){t=t||{},this.options=t,t.indentation?this.indentation=Number(t.indentation):this.indentation=2;var s=t.ace?t.ace:n;this.mode="code"==t.mode?"code":"text","code"==this.mode&&"undefined"==typeof s&&(this.mode="text",console.warn("Failed to load Ace editor, falling back to plain text mode. Please use a JSONEditor bundle including Ace, or pass Ace as via the configuration option `ace`.")),this.theme=t.theme||l,this.theme===l&&window.ace&&i(74);var a=this;this.container=e,this.dom={},this.aceEditor=void 0,this.textarea=void 0,this.validateSchema=null,this._debouncedValidate=o.debounce(this.validate.bind(this),this.DEBOUNCE_INTERVAL),this.width=e.clientWidth,this.height=e.clientHeight,this.frame=document.createElement("div"),this.frame.className="jsoneditor jsoneditor-mode-"+this.options.mode,this.frame.onclick=function(e){e.preventDefault()},this.frame.onkeydown=function(e){a._onKeyDown(e)},this.menu=document.createElement("div"),this.menu.className="jsoneditor-menu",this.frame.appendChild(this.menu);var c=document.createElement("button");c.type="button",c.className="jsoneditor-format",c.title="Format JSON data, with proper indentation and line feeds (Ctrl+\\)",this.menu.appendChild(c),c.onclick=function(){try{a.format(),a._onChange()}catch(e){a._onError(e)}};var h=document.createElement("button");if(h.type="button",h.className="jsoneditor-compact",h.title="Compact JSON data, remove all whitespaces (Ctrl+Shift+\\)",this.menu.appendChild(h),h.onclick=function(){try{a.compact(),a._onChange()}catch(e){a._onError(e)}},this.options&&this.options.modes&&this.options.modes.length&&(this.modeSwitcher=new r(this.menu,this.options.modes,this.options.mode,function(e){a.setMode(e),a.modeSwitcher.focus()})),this.content=document.createElement("div"),this.content.className="jsoneditor-outer",this.frame.appendChild(this.content),this.container.appendChild(this.frame),"code"==this.mode){this.editorDom=document.createElement("div"),this.editorDom.style.height="100%",this.editorDom.style.width="100%",this.content.appendChild(this.editorDom);var d=s.edit(this.editorDom);d.$blockScrolling=1/0,d.setTheme(this.theme),d.setShowPrintMargin(!1),d.setFontSize(13),d.getSession().setMode("ace/mode/json"),d.getSession().setTabSize(this.indentation),d.getSession().setUseSoftTabs(!0),d.getSession().setUseWrapMode(!0),d.commands.bindKey("Ctrl-L",null),d.commands.bindKey("Command-L",null),this.aceEditor=d,this.hasOwnProperty("editor")||Object.defineProperty(this,"editor",{get:function(){return console.warn('Property "editor" has been renamed to "aceEditor".'),a.aceEditor},set:function(e){console.warn('Property "editor" has been renamed to "aceEditor".'),a.aceEditor=e}});var u=document.createElement("a");u.appendChild(document.createTextNode("powered by ace")),u.href="http://ace.ajax.org",u.target="_blank",u.className="jsoneditor-poweredBy",u.onclick=function(){window.open(u.href,u.target)},this.menu.appendChild(u),d.on("change",this._onChange.bind(this))}else{var f=document.createElement("textarea");f.className="jsoneditor-text",f.spellcheck=!1,this.content.appendChild(f),this.textarea=f,null===this.textarea.oninput?this.textarea.oninput=this._onChange.bind(this):this.textarea.onchange=this._onChange.bind(this)}this.setSchema(this.options.schema)},s._onChange=function(){if(this._debouncedValidate(),this.options.onChange)try{this.options.onChange()}catch(e){console.error("Error in onChange callback: ",e)}},s._onKeyDown=function(e){var t=e.which||e.keyCode,i=!1;220==t&&e.ctrlKey&&(e.shiftKey?(this.compact(),this._onChange()):(this.format(),this._onChange()),i=!0),i&&(e.preventDefault(),e.stopPropagation())},s.destroy=function(){this.aceEditor&&(this.aceEditor.destroy(),this.aceEditor=null),this.frame&&this.container&&this.frame.parentNode==this.container&&this.container.removeChild(this.frame),this.modeSwitcher&&(this.modeSwitcher.destroy(),this.modeSwitcher=null),this.textarea=null,this._debouncedValidate=null},s.compact=function(){var e=this.get(),t=JSON.stringify(e);this.setText(t)},s.format=function(){var e=this.get(),t=JSON.stringify(e,null,this.indentation);this.setText(t)},s.focus=function(){this.textarea&&this.textarea.focus(),this.aceEditor&&this.aceEditor.focus()},s.resize=function(){if(this.aceEditor){var e=!1;this.aceEditor.resize(e)}},s.set=function(e){this.setText(JSON.stringify(e,null,this.indentation))},s.get=function(){var e,t=this.getText();try{e=o.parse(t)}catch(i){t=o.sanitize(t),e=o.parse(t)}return e},s.getText=function(){return this.textarea?this.textarea.value:this.aceEditor?this.aceEditor.getValue():""},s.setText=function(e){var t;if(t=this.options.escapeUnicode===!0?o.escapeUnicodeChars(e):e,this.textarea&&(this.textarea.value=t),this.aceEditor){var i=this.options.onChange;this.options.onChange=null,this.aceEditor.setValue(t,-1),this.options.onChange=i}this.validate()},s.validate=function(){this.dom.validationErrors&&(this.dom.validationErrors.parentNode.removeChild(this.dom.validationErrors),this.dom.validationErrors=null,this.content.style.marginBottom="",this.content.style.paddingBottom="");var e,t=!1,i=[];try{e=this.get(),t=!0}catch(e){}if(t&&this.validateSchema){var n=this.validateSchema(e);n||(i=this.validateSchema.errors.map(function(e){return o.improveSchemaError(e)}))}if(i.length>0){var r=i.length>a;if(r){i=i.slice(0,a);var s=this.validateSchema.errors.length-a;i.push("("+s+" more errors...)")}var l=document.createElement("div");l.innerHTML='<table class="jsoneditor-text-errors"><tbody>'+i.map(function(e){var t;return t="string"==typeof e?'<td colspan="2"><pre>'+e+"</pre></td>":"<td>"+e.dataPath+"</td><td>"+e.message+"</td>",'<tr><td><button class="jsoneditor-schema-error"></button></td>'+t+"</tr>"}).join("")+"</tbody></table>",this.dom.validationErrors=l,this.frame.appendChild(l);var c=l.clientHeight;this.content.style.marginBottom=-c+"px",this.content.style.paddingBottom=c+"px"}if(this.aceEditor){var h=!1;this.aceEditor.resize(h)}},e.exports=[{mode:"text",mixin:s,data:"text",load:s.format},{mode:"code",mixin:s,data:"text",load:s.format}]},function(e,t,i){var n=i(68);i(71),i(73),e.exports=n},function(e,t,i){!function(){function e(e){var t=i;e&&(i[e]||(i[e]={}),t=i[e]),t.define&&t.define.packaged||(n.original=t.define,t.define=n,t.define.packaged=!0),t.acequire&&t.acequire.packaged||(o.original=t.acequire,t.acequire=o,t.acequire.packaged=!0)}var t="ace",i=function(){return this}();if(i||"undefined"==typeof window||(i=window),t||"undefined"==typeof acequirejs){var n=function(e,t,i){return"string"!=typeof e?void(n.original?n.original.apply(this,arguments):(console.error("dropping module because define wasn't a string."),console.trace())):(2==arguments.length&&(i=t),void(n.modules[e]||(n.payloads[e]=i,n.modules[e]=null)))};n.modules={},n.payloads={};var r=function(e,t,i){if("string"==typeof t){var n=a(e,t);if(void 0!=n)return i&&i(),n}else if("[object Array]"===Object.prototype.toString.call(t)){for(var r=[],s=0,l=t.length;s<l;++s){var c=a(e,t[s]);if(void 0==c&&o.original)return;r.push(c)}return i&&i.apply(null,r)||!0}},o=function(e,t){var i=r("",e,t);return void 0==i&&o.original?o.original.apply(this,arguments):i},s=function(e,t){if(t.indexOf("!")!==-1){var i=t.split("!");return s(e,i[0])+"!"+s(e,i[1])}if("."==t.charAt(0)){var n=e.split("/").slice(0,-1).join("/");for(t=n+"/"+t;t.indexOf(".")!==-1&&r!=t;){var r=t;t=t.replace(/\/\.\//,"/").replace(/[^\/]+\/\.\.\//,"")}}return t},a=function(e,t){t=s(e,t);var i=n.modules[t];if(!i){if(i=n.payloads[t],"function"==typeof i){var o={},a={id:t,uri:"",exports:o,packaged:!0},l=function(e,i){return r(t,e,i)},c=i(l,o,a);o=c||a.exports,n.modules[t]=o,delete n.payloads[t]}i=n.modules[t]=o||i}return i};e(t)}}(),ace.define("ace/lib/regexp",["require","exports","module"],function(e,t,i){"use strict";function n(e){return(e.global?"g":"")+(e.ignoreCase?"i":"")+(e.multiline?"m":"")+(e.extended?"x":"")+(e.sticky?"y":"")}function r(e,t,i){if(Array.prototype.indexOf)return e.indexOf(t,i);for(var n=i||0;n<e.length;n++)if(e[n]===t)return n;return-1}var o={exec:RegExp.prototype.exec,test:RegExp.prototype.test,match:String.prototype.match,replace:String.prototype.replace,split:String.prototype.split},s=void 0===o.exec.call(/()??/,"")[1],a=function(){var e=/^/g;return o.test.call(e,""),!e.lastIndex}();a&&s||(RegExp.prototype.exec=function(e){var t,i,l=o.exec.apply(this,arguments);if("string"==typeof e&&l){if(!s&&l.length>1&&r(l,"")>-1&&(i=RegExp(this.source,o.replace.call(n(this),"g","")),o.replace.call(e.slice(l.index),i,function(){for(var e=1;e<arguments.length-2;e++)void 0===arguments[e]&&(l[e]=void 0)})),this._xregexp&&this._xregexp.captureNames)for(var c=1;c<l.length;c++)t=this._xregexp.captureNames[c-1],t&&(l[t]=l[c]);!a&&this.global&&!l[0].length&&this.lastIndex>l.index&&this.lastIndex--}return l},a||(RegExp.prototype.test=function(e){var t=o.exec.call(this,e);return t&&this.global&&!t[0].length&&this.lastIndex>t.index&&this.lastIndex--,!!t}))}),ace.define("ace/lib/es5-shim",["require","exports","module"],function(e,t,i){function n(){}function r(e){try{return Object.defineProperty(e,"sentinel",{}),"sentinel"in e}catch(e){}}function o(e){return e=+e,e!==e?e=0:0!==e&&e!==1/0&&e!==-(1/0)&&(e=(e>0||-1)*Math.floor(Math.abs(e))),e}Function.prototype.bind||(Function.prototype.bind=function(e){var t=this;if("function"!=typeof t)throw new TypeError("Function.prototype.bind called on incompatible "+t);var i=p.call(arguments,1),r=function(){if(this instanceof r){var n=t.apply(this,i.concat(p.call(arguments)));return Object(n)===n?n:this}return t.apply(e,i.concat(p.call(arguments)))};return t.prototype&&(n.prototype=t.prototype,r.prototype=new n,n.prototype=null),r});var s,a,l,c,h,d=Function.prototype.call,u=Array.prototype,f=Object.prototype,p=u.slice,m=d.bind(f.toString),g=d.bind(f.hasOwnProperty);if((h=g(f,"__defineGetter__"))&&(s=d.bind(f.__defineGetter__),a=d.bind(f.__defineSetter__),l=d.bind(f.__lookupGetter__),c=d.bind(f.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function e(e){var t=new Array(e+2);return t[0]=t[1]=0,t}var t,i=[];if(i.splice.apply(i,e(20)),i.splice.apply(i,e(26)),t=i.length,i.splice(5,0,"XXX"),t+1==i.length,t+1==i.length)return!0}()){var v=Array.prototype.splice;Array.prototype.splice=function(e,t){return arguments.length?v.apply(this,[void 0===e?0:e,void 0===t?this.length-e:t].concat(p.call(arguments,2))):[]}}else Array.prototype.splice=function(e,t){var i=this.length;e>0?e>i&&(e=i):void 0==e?e=0:e<0&&(e=Math.max(i+e,0)),e+t<i||(t=i-e);var n=this.slice(e,e+t),r=p.call(arguments,2),o=r.length;if(e===i)o&&this.push.apply(this,r);else{var s=Math.min(t,i-e),a=e+s,l=a+o-s,c=i-a,h=i-s;if(l<a)for(var d=0;d<c;++d)this[l+d]=this[a+d];else if(l>a)for(d=c;d--;)this[l+d]=this[a+d];if(o&&e===h)this.length=h,this.push.apply(this,r);else for(this.length=h+o,d=0;d<o;++d)this[e+d]=r[d]}return n};Array.isArray||(Array.isArray=function(e){return"[object Array]"==m(e)});var y=Object("a"),w="a"!=y[0]||!(0 in y);if(Array.prototype.forEach||(Array.prototype.forEach=function(e){var t=T(this),i=w&&"[object String]"==m(this)?this.split(""):t,n=arguments[1],r=-1,o=i.length>>>0;if("[object Function]"!=m(e))throw new TypeError;for(;++r<o;)r in i&&e.call(n,i[r],r,t)}),Array.prototype.map||(Array.prototype.map=function(e){var t=T(this),i=w&&"[object String]"==m(this)?this.split(""):t,n=i.length>>>0,r=Array(n),o=arguments[1];if("[object Function]"!=m(e))throw new TypeError(e+" is not a function");for(var s=0;s<n;s++)s in i&&(r[s]=e.call(o,i[s],s,t));return r}),Array.prototype.filter||(Array.prototype.filter=function(e){var t,i=T(this),n=w&&"[object String]"==m(this)?this.split(""):i,r=n.length>>>0,o=[],s=arguments[1];if("[object Function]"!=m(e))throw new TypeError(e+" is not a function");for(var a=0;a<r;a++)a in n&&(t=n[a],e.call(s,t,a,i)&&o.push(t));return o}),Array.prototype.every||(Array.prototype.every=function(e){var t=T(this),i=w&&"[object String]"==m(this)?this.split(""):t,n=i.length>>>0,r=arguments[1];if("[object Function]"!=m(e))throw new TypeError(e+" is not a function");for(var o=0;o<n;o++)if(o in i&&!e.call(r,i[o],o,t))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(e){var t=T(this),i=w&&"[object String]"==m(this)?this.split(""):t,n=i.length>>>0,r=arguments[1];if("[object Function]"!=m(e))throw new TypeError(e+" is not a function");for(var o=0;o<n;o++)if(o in i&&e.call(r,i[o],o,t))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(e){var t=T(this),i=w&&"[object String]"==m(this)?this.split(""):t,n=i.length>>>0;if("[object Function]"!=m(e))throw new TypeError(e+" is not a function");if(!n&&1==arguments.length)throw new TypeError("reduce of empty array with no initial value");var r,o=0;if(arguments.length>=2)r=arguments[1];else for(;;){if(o in i){r=i[o++];break}if(++o>=n)throw new TypeError("reduce of empty array with no initial value")}for(;o<n;o++)o in i&&(r=e.call(void 0,r,i[o],o,t));return r}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(e){var t=T(this),i=w&&"[object String]"==m(this)?this.split(""):t,n=i.length>>>0;if("[object Function]"!=m(e))throw new TypeError(e+" is not a function");if(!n&&1==arguments.length)throw new TypeError("reduceRight of empty array with no initial value");var r,o=n-1;if(arguments.length>=2)r=arguments[1];else for(;;){if(o in i){r=i[o--];break}if(--o<0)throw new TypeError("reduceRight of empty array with no initial value")}do o in this&&(r=e.call(void 0,r,i[o],o,t));while(o--);return r}),Array.prototype.indexOf&&[0,1].indexOf(1,2)==-1||(Array.prototype.indexOf=function(e){var t=w&&"[object String]"==m(this)?this.split(""):T(this),i=t.length>>>0;if(!i)return-1;var n=0;for(arguments.length>1&&(n=o(arguments[1])),n=n>=0?n:Math.max(0,i+n);n<i;n++)if(n in t&&t[n]===e)return n;return-1}),Array.prototype.lastIndexOf&&[0,1].lastIndexOf(0,-3)==-1||(Array.prototype.lastIndexOf=function(e){var t=w&&"[object String]"==m(this)?this.split(""):T(this),i=t.length>>>0;if(!i)return-1;var n=i-1;for(arguments.length>1&&(n=Math.min(n,o(arguments[1]))),n=n>=0?n:i-Math.abs(n);n>=0;n--)if(n in t&&e===t[n])return n;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(e){return e.__proto__||(e.constructor?e.constructor.prototype:f)}),!Object.getOwnPropertyDescriptor){var b="Object.getOwnPropertyDescriptor called on a non-object: ";Object.getOwnPropertyDescriptor=function(e,t){if("object"!=typeof e&&"function"!=typeof e||null===e)throw new TypeError(b+e);if(g(e,t)){var i,n,r;if(i={enumerable:!0,configurable:!0},h){var o=e.__proto__;e.__proto__=f;var n=l(e,t),r=c(e,t);if(e.__proto__=o,n||r)return n&&(i.get=n),r&&(i.set=r),i}return i.value=e[t],i}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(e){return Object.keys(e)}),!Object.create){var A;A=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var e={};for(var t in e)e[t]=null;return e.constructor=e.hasOwnProperty=e.propertyIsEnumerable=e.isPrototypeOf=e.toLocaleString=e.toString=e.valueOf=e.__proto__=null,e},Object.create=function(e,t){var i;if(null===e)i=A();else{if("object"!=typeof e)throw new TypeError("typeof prototype["+typeof e+"] != 'object'");var n=function(){};n.prototype=e,i=new n,i.__proto__=e}return void 0!==t&&Object.defineProperties(i,t),i}}if(Object.defineProperty){var C=r({}),E="undefined"==typeof document||r(document.createElement("div"));if(!C||!E)var x=Object.defineProperty;
	}if(!Object.defineProperty||x){var F="Property description must be an object: ",k="Object.defineProperty called on non-object: ",S="getters & setters can not be defined on this javascript engine";Object.defineProperty=function(e,t,i){if("object"!=typeof e&&"function"!=typeof e||null===e)throw new TypeError(k+e);if("object"!=typeof i&&"function"!=typeof i||null===i)throw new TypeError(F+i);if(x)try{return x.call(Object,e,t,i)}catch(e){}if(g(i,"value"))if(h&&(l(e,t)||c(e,t))){var n=e.__proto__;e.__proto__=f,delete e[t],e[t]=i.value,e.__proto__=n}else e[t]=i.value;else{if(!h)throw new TypeError(S);g(i,"get")&&s(e,t,i.get),g(i,"set")&&a(e,t,i.set)}return e}}Object.defineProperties||(Object.defineProperties=function(e,t){for(var i in t)g(t,i)&&Object.defineProperty(e,i,t[i]);return e}),Object.seal||(Object.seal=function(e){return e}),Object.freeze||(Object.freeze=function(e){return e});try{Object.freeze(function(){})}catch(e){Object.freeze=function(e){return function(t){return"function"==typeof t?t:e(t)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(e){return e}),Object.isSealed||(Object.isSealed=function(e){return!1}),Object.isFrozen||(Object.isFrozen=function(e){return!1}),Object.isExtensible||(Object.isExtensible=function(e){if(Object(e)===e)throw new TypeError;for(var t="";g(e,t);)t+="?";e[t]=!0;var i=g(e,t);return delete e[t],i}),!Object.keys){var $=!0,D=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],B=D.length;for(var _ in{toString:null})$=!1;Object.keys=function e(t){if("object"!=typeof t&&"function"!=typeof t||null===t)throw new TypeError("Object.keys called on a non-object");var e=[];for(var i in t)g(t,i)&&e.push(i);if($)for(var n=0,r=B;n<r;n++){var o=D[n];g(t,o)&&e.push(o)}return e}}Date.now||(Date.now=function(){return(new Date).getTime()});var L="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff";if(!String.prototype.trim||L.trim()){L="["+L+"]";var R=new RegExp("^"+L+L+"*"),j=new RegExp(L+L+"*$");String.prototype.trim=function(){return String(this).replace(R,"").replace(j,"")}}var T=function(e){if(null==e)throw new TypeError("can't convert "+e+" to object");return Object(e)}}),ace.define("ace/lib/fixoldbrowsers",["require","exports","module","ace/lib/regexp","ace/lib/es5-shim"],function(e,t,i){"use strict";e("./regexp"),e("./es5-shim")}),ace.define("ace/lib/dom",["require","exports","module"],function(e,t,i){"use strict";var n="http://www.w3.org/1999/xhtml";return t.getDocumentHead=function(e){return e||(e=document),e.head||e.getElementsByTagName("head")[0]||e.documentElement},t.createElement=function(e,t){return document.createElementNS?document.createElementNS(t||n,e):document.createElement(e)},t.hasCssClass=function(e,t){var i=(e.className||"").split(/\s+/g);return i.indexOf(t)!==-1},t.addCssClass=function(e,i){t.hasCssClass(e,i)||(e.className+=" "+i)},t.removeCssClass=function(e,t){for(var i=e.className.split(/\s+/g);;){var n=i.indexOf(t);if(n==-1)break;i.splice(n,1)}e.className=i.join(" ")},t.toggleCssClass=function(e,t){for(var i=e.className.split(/\s+/g),n=!0;;){var r=i.indexOf(t);if(r==-1)break;n=!1,i.splice(r,1)}return n&&i.push(t),e.className=i.join(" "),n},t.setCssClass=function(e,i,n){n?t.addCssClass(e,i):t.removeCssClass(e,i)},t.hasCssString=function(e,t){var i,n=0;if(t=t||document,t.createStyleSheet&&(i=t.styleSheets)){for(;n<i.length;)if(i[n++].owningElement.id===e)return!0}else if(i=t.getElementsByTagName("style"))for(;n<i.length;)if(i[n++].id===e)return!0;return!1},t.importCssString=function(e,i,n){if(n=n||document,i&&t.hasCssString(i,n))return null;var r;i&&(e+="\n/*# sourceURL=ace/css/"+i+" */"),n.createStyleSheet?(r=n.createStyleSheet(),r.cssText=e,i&&(r.owningElement.id=i)):(r=t.createElement("style"),r.appendChild(n.createTextNode(e)),i&&(r.id=i),t.getDocumentHead(n).appendChild(r))},t.importCssStylsheet=function(e,i){if(i.createStyleSheet)i.createStyleSheet(e);else{var n=t.createElement("link");n.rel="stylesheet",n.href=e,t.getDocumentHead(i).appendChild(n)}},t.getInnerWidth=function(e){return parseInt(t.computedStyle(e,"paddingLeft"),10)+parseInt(t.computedStyle(e,"paddingRight"),10)+e.clientWidth},t.getInnerHeight=function(e){return parseInt(t.computedStyle(e,"paddingTop"),10)+parseInt(t.computedStyle(e,"paddingBottom"),10)+e.clientHeight},t.scrollbarWidth=function(e){var i=t.createElement("ace_inner");i.style.width="100%",i.style.minWidth="0px",i.style.height="200px",i.style.display="block";var n=t.createElement("ace_outer"),r=n.style;r.position="absolute",r.left="-10000px",r.overflow="hidden",r.width="200px",r.minWidth="0px",r.height="150px",r.display="block",n.appendChild(i);var o=e.documentElement;o.appendChild(n);var s=i.offsetWidth;r.overflow="scroll";var a=i.offsetWidth;return s==a&&(a=n.clientWidth),o.removeChild(n),s-a},"undefined"==typeof document?void(t.importCssString=function(){}):(void 0!==window.pageYOffset?(t.getPageScrollTop=function(){return window.pageYOffset},t.getPageScrollLeft=function(){return window.pageXOffset}):(t.getPageScrollTop=function(){return document.body.scrollTop},t.getPageScrollLeft=function(){return document.body.scrollLeft}),window.getComputedStyle?t.computedStyle=function(e,t){return t?(window.getComputedStyle(e,"")||{})[t]||"":window.getComputedStyle(e,"")||{}}:t.computedStyle=function(e,t){return t?e.currentStyle[t]:e.currentStyle},t.setInnerHtml=function(e,t){var i=e.cloneNode(!1);return i.innerHTML=t,e.parentNode.replaceChild(i,e),i},"textContent"in document.documentElement?(t.setInnerText=function(e,t){e.textContent=t},t.getInnerText=function(e){return e.textContent}):(t.setInnerText=function(e,t){e.innerText=t},t.getInnerText=function(e){return e.innerText}),void(t.getParentWindow=function(e){return e.defaultView||e.parentWindow}))}),ace.define("ace/lib/oop",["require","exports","module"],function(e,t,i){"use strict";t.inherits=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})},t.mixin=function(e,t){for(var i in t)e[i]=t[i];return e},t.implement=function(e,i){t.mixin(e,i)}}),ace.define("ace/lib/keys",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop"],function(e,t,i){"use strict";e("./fixoldbrowsers");var n=e("./oop"),r=function(){var e,t,i={MODIFIER_KEYS:{16:"Shift",17:"Ctrl",18:"Alt",224:"Meta"},KEY_MODS:{ctrl:1,alt:2,option:2,shift:4,super:8,meta:8,command:8,cmd:8},FUNCTION_KEYS:{8:"Backspace",9:"Tab",13:"Return",19:"Pause",27:"Esc",32:"Space",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"Left",38:"Up",39:"Right",40:"Down",44:"Print",45:"Insert",46:"Delete",96:"Numpad0",97:"Numpad1",98:"Numpad2",99:"Numpad3",100:"Numpad4",101:"Numpad5",102:"Numpad6",103:"Numpad7",104:"Numpad8",105:"Numpad9","-13":"NumpadEnter",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"Numlock",145:"Scrolllock"},PRINTABLE_KEYS:{32:" ",48:"0",49:"1",50:"2",51:"3",52:"4",53:"5",54:"6",55:"7",56:"8",57:"9",59:";",61:"=",65:"a",66:"b",67:"c",68:"d",69:"e",70:"f",71:"g",72:"h",73:"i",74:"j",75:"k",76:"l",77:"m",78:"n",79:"o",80:"p",81:"q",82:"r",83:"s",84:"t",85:"u",86:"v",87:"w",88:"x",89:"y",90:"z",107:"+",109:"-",110:".",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'",111:"/",106:"*"}};for(t in i.FUNCTION_KEYS)e=i.FUNCTION_KEYS[t].toLowerCase(),i[e]=parseInt(t,10);for(t in i.PRINTABLE_KEYS)e=i.PRINTABLE_KEYS[t].toLowerCase(),i[e]=parseInt(t,10);return n.mixin(i,i.MODIFIER_KEYS),n.mixin(i,i.PRINTABLE_KEYS),n.mixin(i,i.FUNCTION_KEYS),i.enter=i.return,i.escape=i.esc,i.del=i.delete,i[173]="-",function(){for(var e=["cmd","ctrl","alt","shift"],t=Math.pow(2,e.length);t--;)i.KEY_MODS[t]=e.filter(function(e){return t&i.KEY_MODS[e]}).join("-")+"-"}(),i.KEY_MODS[0]="",i.KEY_MODS[-1]="input-",i}();n.mixin(t,r),t.keyCodeToString=function(e){var t=r[e];return"string"!=typeof t&&(t=String.fromCharCode(e)),t.toLowerCase()}}),ace.define("ace/lib/useragent",["require","exports","module"],function(e,t,i){"use strict";if(t.OS={LINUX:"LINUX",MAC:"MAC",WINDOWS:"WINDOWS"},t.getOS=function(){return t.isMac?t.OS.MAC:t.isLinux?t.OS.LINUX:t.OS.WINDOWS},"object"==typeof navigator){var n=(navigator.platform.match(/mac|win|linux/i)||["other"])[0].toLowerCase(),r=navigator.userAgent;t.isWin="win"==n,t.isMac="mac"==n,t.isLinux="linux"==n,t.isIE="Microsoft Internet Explorer"==navigator.appName||navigator.appName.indexOf("MSAppHost")>=0?parseFloat((r.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]):parseFloat((r.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]),t.isOldIE=t.isIE&&t.isIE<9,t.isGecko=t.isMozilla=(window.Controllers||window.controllers)&&"Gecko"===window.navigator.product,t.isOldGecko=t.isGecko&&parseInt((r.match(/rv\:(\d+)/)||[])[1],10)<4,t.isOpera=window.opera&&"[object Opera]"==Object.prototype.toString.call(window.opera),t.isWebKit=parseFloat(r.split("WebKit/")[1])||void 0,t.isChrome=parseFloat(r.split(" Chrome/")[1])||void 0,t.isAIR=r.indexOf("AdobeAIR")>=0,t.isIPad=r.indexOf("iPad")>=0,t.isTouchPad=r.indexOf("TouchPad")>=0,t.isChromeOS=r.indexOf(" CrOS ")>=0}}),ace.define("ace/lib/event",["require","exports","module","ace/lib/keys","ace/lib/useragent"],function(e,t,i){"use strict";function n(e,t,i){var n=c(t);if(!s.isMac&&a){if(a.OSKey&&(n|=8),a.altGr){if(3==(3&n))return;a.altGr=0}if(18===i||17===i){var r="location"in t?t.location:t.keyLocation;if(17===i&&1===r)1==a[i]&&(l=t.timeStamp);else if(18===i&&3===n&&2===r){var h=t.timeStamp-l;h<50&&(a.altGr=!0)}}}if(i in o.MODIFIER_KEYS&&(i=-1),8&n&&i>=91&&i<=93&&(i=-1),!n&&13===i){var r="location"in t?t.location:t.keyLocation;if(3===r&&(e(t,n,-i),t.defaultPrevented))return}if(s.isChromeOS&&8&n){if(e(t,n,i),t.defaultPrevented)return;n&=-9}return!!(n||i in o.FUNCTION_KEYS||i in o.PRINTABLE_KEYS)&&e(t,n,i)}function r(){a=Object.create(null),a.count=0,a.lastT=0}var o=e("./keys"),s=e("./useragent"),a=null,l=0;t.addListener=function(e,t,i){if(e.addEventListener)return e.addEventListener(t,i,!1);if(e.attachEvent){var n=function(){i.call(e,window.event)};i._wrapper=n,e.attachEvent("on"+t,n)}},t.removeListener=function(e,t,i){return e.removeEventListener?e.removeEventListener(t,i,!1):void(e.detachEvent&&e.detachEvent("on"+t,i._wrapper||i))},t.stopEvent=function(e){return t.stopPropagation(e),t.preventDefault(e),!1},t.stopPropagation=function(e){e.stopPropagation?e.stopPropagation():e.cancelBubble=!0},t.preventDefault=function(e){e.preventDefault?e.preventDefault():e.returnValue=!1},t.getButton=function(e){return"dblclick"==e.type?0:"contextmenu"==e.type||s.isMac&&e.ctrlKey&&!e.altKey&&!e.shiftKey?2:e.preventDefault?e.button:{1:0,2:2,4:1}[e.button]},t.capture=function(e,i,n){function r(e){i&&i(e),n&&n(e),t.removeListener(document,"mousemove",i,!0),t.removeListener(document,"mouseup",r,!0),t.removeListener(document,"dragstart",r,!0)}return t.addListener(document,"mousemove",i,!0),t.addListener(document,"mouseup",r,!0),t.addListener(document,"dragstart",r,!0),r},t.addTouchMoveListener=function(e,i){if("ontouchmove"in e){var n,r;t.addListener(e,"touchstart",function(e){var t=e.changedTouches[0];n=t.clientX,r=t.clientY}),t.addListener(e,"touchmove",function(e){var t=1,o=e.changedTouches[0];e.wheelX=-(o.clientX-n)/t,e.wheelY=-(o.clientY-r)/t,n=o.clientX,r=o.clientY,i(e)})}},t.addMouseWheelListener=function(e,i){"onmousewheel"in e?t.addListener(e,"mousewheel",function(e){var t=8;void 0!==e.wheelDeltaX?(e.wheelX=-e.wheelDeltaX/t,e.wheelY=-e.wheelDeltaY/t):(e.wheelX=0,e.wheelY=-e.wheelDelta/t),i(e)}):"onwheel"in e?t.addListener(e,"wheel",function(e){var t=.35;switch(e.deltaMode){case e.DOM_DELTA_PIXEL:e.wheelX=e.deltaX*t||0,e.wheelY=e.deltaY*t||0;break;case e.DOM_DELTA_LINE:case e.DOM_DELTA_PAGE:e.wheelX=5*(e.deltaX||0),e.wheelY=5*(e.deltaY||0)}i(e)}):t.addListener(e,"DOMMouseScroll",function(e){e.axis&&e.axis==e.HORIZONTAL_AXIS?(e.wheelX=5*(e.detail||0),e.wheelY=0):(e.wheelX=0,e.wheelY=5*(e.detail||0)),i(e)})},t.addMultiMouseDownListener=function(e,i,n,r){function o(e){if(0!==t.getButton(e)?d=0:e.detail>1?(d++,d>4&&(d=1)):d=1,s.isIE){var o=Math.abs(e.clientX-l)>5||Math.abs(e.clientY-c)>5;h&&!o||(d=1),h&&clearTimeout(h),h=setTimeout(function(){h=null},i[d-1]||600),1==d&&(l=e.clientX,c=e.clientY)}if(e._clicks=d,n[r]("mousedown",e),d>4)d=0;else if(d>1)return n[r](u[d],e)}function a(e){d=2,h&&clearTimeout(h),h=setTimeout(function(){h=null},i[d-1]||600),n[r]("mousedown",e),n[r](u[d],e)}var l,c,h,d=0,u={2:"dblclick",3:"tripleclick",4:"quadclick"};Array.isArray(e)||(e=[e]),e.forEach(function(e){t.addListener(e,"mousedown",o),s.isOldIE&&t.addListener(e,"dblclick",a)})};var c=!s.isMac||!s.isOpera||"KeyboardEvent"in window?function(e){return 0|(e.ctrlKey?1:0)|(e.altKey?2:0)|(e.shiftKey?4:0)|(e.metaKey?8:0)}:function(e){return 0|(e.metaKey?1:0)|(e.altKey?2:0)|(e.shiftKey?4:0)|(e.ctrlKey?8:0)};if(t.getModifierString=function(e){return o.KEY_MODS[c(e)]},t.addCommandKeyListener=function(e,i){var o=t.addListener;if(s.isOldGecko||s.isOpera&&!("KeyboardEvent"in window)){var l=null;o(e,"keydown",function(e){l=e.keyCode}),o(e,"keypress",function(e){return n(i,e,l)})}else{var c=null;o(e,"keydown",function(e){var t=e.keyCode;a[t]=(a[t]||0)+1,91==t||92==t?a.OSKey=!0:a.OSKey&&e.timeStamp-a.lastT>200&&1==a.count&&r(),1==a[t]&&a.count++,a.lastT=e.timeStamp;var o=n(i,e,t);return c=e.defaultPrevented,o}),o(e,"keypress",function(e){c&&(e.ctrlKey||e.altKey||e.shiftKey||e.metaKey)&&(t.stopEvent(e),c=null)}),o(e,"keyup",function(e){var t=e.keyCode;a[t]?a.count=Math.max(a.count-1,0):r(),91!=t&&92!=t||(a.OSKey=!1),a[t]=null}),a||(r(),o(window,"focus",r))}},"object"==typeof window&&window.postMessage&&!s.isOldIE){var h=1;t.nextTick=function(e,i){i=i||window;var n="zero-timeout-message-"+h;t.addListener(i,"message",function r(o){o.data==n&&(t.stopPropagation(o),t.removeListener(i,"message",r),e())}),i.postMessage(n,"*")}}t.nextFrame="object"==typeof window&&(window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame),t.nextFrame?t.nextFrame=t.nextFrame.bind(window):t.nextFrame=function(e){setTimeout(e,17)}}),ace.define("ace/lib/lang",["require","exports","module"],function(e,t,i){"use strict";t.last=function(e){return e[e.length-1]},t.stringReverse=function(e){return e.split("").reverse().join("")},t.stringRepeat=function(e,t){for(var i="";t>0;)1&t&&(i+=e),(t>>=1)&&(e+=e);return i};var n=/^\s\s*/,r=/\s\s*$/;t.stringTrimLeft=function(e){return e.replace(n,"")},t.stringTrimRight=function(e){return e.replace(r,"")},t.copyObject=function(e){var t={};for(var i in e)t[i]=e[i];return t},t.copyArray=function(e){for(var t=[],i=0,n=e.length;i<n;i++)e[i]&&"object"==typeof e[i]?t[i]=this.copyObject(e[i]):t[i]=e[i];return t},t.deepCopy=function e(t){if("object"!=typeof t||!t)return t;var i;if(Array.isArray(t)){i=[];for(var n=0;n<t.length;n++)i[n]=e(t[n]);return i}var r=t.constructor;if(r===RegExp)return t;i=r();for(var n in t)i[n]=e(t[n]);return i},t.arrayToMap=function(e){for(var t={},i=0;i<e.length;i++)t[e[i]]=1;return t},t.createMap=function(e){var t=Object.create(null);for(var i in e)t[i]=e[i];return t},t.arrayRemove=function(e,t){for(var i=0;i<=e.length;i++)t===e[i]&&e.splice(i,1)},t.escapeRegExp=function(e){return e.replace(/([.*+?^${}()|[\]\/\\])/g,"\\$1")},t.escapeHTML=function(e){return e.replace(/&/g,"&#38;").replace(/"/g,"&#34;").replace(/'/g,"&#39;").replace(/</g,"&#60;")},t.getMatchOffsets=function(e,t){var i=[];return e.replace(t,function(e){i.push({offset:arguments[arguments.length-2],length:e.length})}),i},t.deferredCall=function(e){var t=null,i=function(){t=null,e()},n=function(e){return n.cancel(),t=setTimeout(i,e||0),n};return n.schedule=n,n.call=function(){return this.cancel(),e(),n},n.cancel=function(){return clearTimeout(t),t=null,n},n.isPending=function(){return t},n},t.delayedCall=function(e,t){var i=null,n=function(){i=null,e()},r=function(e){null==i&&(i=setTimeout(n,e||t))};return r.delay=function(e){i&&clearTimeout(i),i=setTimeout(n,e||t)},r.schedule=r,r.call=function(){this.cancel(),e()},r.cancel=function(){i&&clearTimeout(i),i=null},r.isPending=function(){return i},r}}),ace.define("ace/keyboard/textinput",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/lib/dom","ace/lib/lang"],function(e,t,i){"use strict";var n=e("../lib/event"),r=e("../lib/useragent"),o=e("../lib/dom"),s=e("../lib/lang"),a=r.isChrome<18,l=r.isIE,c=function(e,t){function i(e){if(!m){if(m=!0,S)t=0,i=e?0:d.value.length-1;else var t=e?2:1,i=2;try{d.setSelectionRange(t,i)}catch(e){}m=!1}}function c(){m||(d.value=u,r.isWebKit&&b.schedule())}function h(){clearTimeout(I),I=setTimeout(function(){g&&(d.style.cssText=g,g=""),null==t.renderer.$keepTextAreaAtCursor&&(t.renderer.$keepTextAreaAtCursor=!0,t.renderer.$moveTextAreaToCursor())},r.isOldIE?200:0)}var d=o.createElement("textarea");d.className="ace_text-input",r.isTouchPad&&d.setAttribute("x-palm-disable-auto-cap",!0),d.setAttribute("wrap","off"),d.setAttribute("autocorrect","off"),d.setAttribute("autocapitalize","off"),d.setAttribute("spellcheck",!1),d.style.opacity="0",r.isOldIE&&(d.style.top="-1000px"),e.insertBefore(d,e.firstChild);var u="",f=!1,p=!1,m=!1,g="",v=!0;try{var y=document.activeElement===d}catch(e){}n.addListener(d,"blur",function(e){t.onBlur(e),y=!1}),n.addListener(d,"focus",function(e){y=!0,t.onFocus(e),i()}),this.focus=function(){if(g)return d.focus();var e=d.style.top;d.style.position="fixed",d.style.top="0px",d.focus(),setTimeout(function(){d.style.position="","0px"==d.style.top&&(d.style.top=e)},0)},this.blur=function(){d.blur()},this.isFocused=function(){return y};var w=s.delayedCall(function(){y&&i(v)}),b=s.delayedCall(function(){m||(d.value=u,y&&i())});r.isWebKit||t.addEventListener("changeSelection",function(){t.selection.isEmpty()!=v&&(v=!v,w.schedule())}),c(),y&&t.onFocus();var A=function(e){return 0===e.selectionStart&&e.selectionEnd===e.value.length};if(!d.setSelectionRange&&d.createTextRange&&(d.setSelectionRange=function(e,t){var i=this.createTextRange();i.collapse(!0),i.moveStart("character",e),i.moveEnd("character",t),i.select()},A=function(e){try{var t=e.ownerDocument.selection.createRange()}catch(e){}return!(!t||t.parentElement()!=e)&&t.text==e.value}),r.isOldIE){var C=!1,E=function(e){if(!C){var t=d.value;if(!m&&t&&t!=u){if(e&&t==u[0])return x.schedule();D(t),C=!0,c(),C=!1}}},x=s.delayedCall(E);n.addListener(d,"propertychange",E);var F={13:1,27:1};n.addListener(d,"keyup",function(e){return!m||d.value&&!F[e.keyCode]||setTimeout(O,0),(d.value.charCodeAt(0)||0)<129?x.call():void(m?M():P())}),n.addListener(d,"keydown",function(e){x.schedule(50)})}var k=function(e){f?f=!1:A(d)?(t.selectAll(),i()):S&&i(t.selection.isEmpty())},S=null;this.setInputHandler=function(e){S=e},this.getInputHandler=function(){return S};var $=!1,D=function(e){S&&(e=S(e),S=null),p?(i(),e&&t.onPaste(e),p=!1):e==u.charAt(0)?$?t.execCommand("del",{source:"ace"}):t.execCommand("backspace",{source:"ace"}):(e.substring(0,2)==u?e=e.substr(2):e.charAt(0)==u.charAt(0)?e=e.substr(1):e.charAt(e.length-1)==u.charAt(0)&&(e=e.slice(0,-1)),e.charAt(e.length-1)==u.charAt(0)&&(e=e.slice(0,-1)),e&&t.onTextInput(e)),$&&($=!1)},B=function(e){if(!m){var t=d.value;D(t),c()}},_=function(e,t){var i=e.clipboardData||window.clipboardData;if(i&&!a){var n=l?"Text":"text/plain";return t?i.setData(n,t)!==!1:i.getData(n)}},L=function(e,r){var o=t.getCopyText();return o?void(_(e,o)?(r?t.onCut():t.onCopy(),n.preventDefault(e)):(f=!0,d.value=o,d.select(),setTimeout(function(){f=!1,c(),i(),r?t.onCut():t.onCopy()}))):n.preventDefault(e)},R=function(e){L(e,!0)},j=function(e){L(e,!1)},T=function(e){var o=_(e);"string"==typeof o?(o&&t.onPaste(o,e),r.isIE&&setTimeout(i),n.preventDefault(e)):(d.value="",p=!0)};n.addCommandKeyListener(d,t.onCommandKey.bind(t)),n.addListener(d,"select",k),n.addListener(d,"input",B),n.addListener(d,"cut",R),n.addListener(d,"copy",j),n.addListener(d,"paste",T),"oncut"in d&&"oncopy"in d&&"onpaste"in d||n.addListener(e,"keydown",function(e){if((!r.isMac||e.metaKey)&&e.ctrlKey)switch(e.keyCode){case 67:j(e);break;case 86:T(e);break;case 88:R(e)}});var P=function(e){m||!t.onCompositionStart||t.$readOnly||(m={},t.onCompositionStart(),setTimeout(M,0),t.on("mousedown",O),t.selection.isEmpty()||(t.insert(""),t.session.markUndoGroup(),t.selection.clearSelection()),t.session.markUndoGroup())},M=function(){if(m&&t.onCompositionUpdate&&!t.$readOnly){var e=d.value.replace(/\x01/g,"");if(m.lastValue!==e&&(t.onCompositionUpdate(e),m.lastValue&&t.undo(),m.lastValue=e,m.lastValue)){var i=t.selection.getRange();t.insert(m.lastValue),t.session.markUndoGroup(),m.range=t.selection.getRange(),t.selection.setRange(i),t.selection.clearSelection()}}},O=function(e){if(t.onCompositionEnd&&!t.$readOnly){var i=m;m=!1;var n=setTimeout(function(){n=null;var e=d.value.replace(/\x01/g,"");m||(e==i.lastValue?c():!i.lastValue&&e&&(c(),D(e)))});S=function(e){return n&&clearTimeout(n),e=e.replace(/\x01/g,""),e==i.lastValue?"":(i.lastValue&&n&&t.undo(),e)},t.onCompositionEnd(),t.removeListener("mousedown",O),"compositionend"==e.type&&i.range&&t.selection.setRange(i.range)}},N=s.delayedCall(M,50);n.addListener(d,"compositionstart",P),r.isGecko?n.addListener(d,"text",function(){N.schedule()}):(n.addListener(d,"keyup",function(){N.schedule()}),n.addListener(d,"keydown",function(){N.schedule()})),n.addListener(d,"compositionend",O),this.getElement=function(){return d},this.setReadOnly=function(e){d.readOnly=e},this.onContextMenu=function(e){$=!0,i(t.selection.isEmpty()),t._emit("nativecontextmenu",{target:t,domEvent:e}),this.moveToMouse(e,!0)},this.moveToMouse=function(e,i){if(i||!r.isOldIE){g||(g=d.style.cssText),d.style.cssText=(i?"z-index:100000;":"")+"height:"+d.style.height+";"+(r.isIE?"opacity:0.1;":"");var s=t.container.getBoundingClientRect(),a=o.computedStyle(t.container),l=s.top+(parseInt(a.borderTopWidth)||0),c=s.left+(parseInt(s.borderLeftWidth)||0),u=s.bottom-l-d.clientHeight-2,f=function(e){d.style.left=e.clientX-c-2+"px",d.style.top=Math.min(e.clientY-l-2,u)+"px"};f(e),"mousedown"==e.type&&(t.renderer.$keepTextAreaAtCursor&&(t.renderer.$keepTextAreaAtCursor=null),clearTimeout(I),r.isWin&&!r.isOldIE&&n.capture(t.container,f,h))}},this.onContextMenuClose=h;var I,W=function(e){t.textInput.onContextMenu(e),h()};n.addListener(d,"mouseup",W),n.addListener(d,"mousedown",function(e){e.preventDefault(),h()}),n.addListener(t.renderer.scroller,"contextmenu",W),n.addListener(d,"contextmenu",W)};t.TextInput=c}),ace.define("ace/mouse/default_handlers",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"],function(e,t,i){"use strict";function n(e){e.$clickSelection=null;var t=e.editor;t.setDefaultHandler("mousedown",this.onMouseDown.bind(e)),t.setDefaultHandler("dblclick",this.onDoubleClick.bind(e)),t.setDefaultHandler("tripleclick",this.onTripleClick.bind(e)),t.setDefaultHandler("quadclick",this.onQuadClick.bind(e)),t.setDefaultHandler("mousewheel",this.onMouseWheel.bind(e)),t.setDefaultHandler("touchmove",this.onTouchMove.bind(e));var i=["select","startSelect","selectEnd","selectAllEnd","selectByWordsEnd","selectByLinesEnd","dragWait","dragWaitEnd","focusWait"];i.forEach(function(t){e[t]=this[t]},this),e.selectByLines=this.extendSelectionBy.bind(e,"getLineRange"),e.selectByWords=this.extendSelectionBy.bind(e,"getWordRange")}function r(e,t,i,n){return Math.sqrt(Math.pow(i-e,2)+Math.pow(n-t,2))}function o(e,t){if(e.start.row==e.end.row)var i=2*t.column-e.start.column-e.end.column;else if(e.start.row!=e.end.row-1||e.start.column||e.end.column)var i=2*t.row-e.start.row-e.end.row;else var i=t.column-4;return i<0?{cursor:e.start,anchor:e.end}:{cursor:e.end,anchor:e.start}}var s=(e("../lib/dom"),e("../lib/event"),e("../lib/useragent"),0);(function(){this.onMouseDown=function(e){var t=e.inSelection(),i=e.getDocumentPosition();this.mousedownEvent=e;var n=this.editor,r=e.getButton();if(0!==r){var o=n.getSelectionRange(),s=o.isEmpty();return n.$blockScrolling++,(s||1==r)&&n.selection.moveToPosition(i),n.$blockScrolling--,void(2==r&&n.textInput.onContextMenu(e.domEvent))}return this.mousedownEvent.time=Date.now(),!t||n.isFocused()||(n.focus(),!this.$focusTimout||this.$clickSelection||n.inMultiSelectMode)?(this.captureMouse(e),this.startSelect(i,e.domEvent._clicks>1),e.preventDefault()):(this.setState("focusWait"),void this.captureMouse(e))},this.startSelect=function(e,t){e=e||this.editor.renderer.screenToTextCoordinates(this.x,this.y);var i=this.editor;i.$blockScrolling++,this.mousedownEvent.getShiftKey()?i.selection.selectToPosition(e):t||i.selection.moveToPosition(e),t||this.select(),i.renderer.scroller.setCapture&&i.renderer.scroller.setCapture(),i.setStyle("ace_selecting"),this.setState("select"),i.$blockScrolling--},this.select=function(){var e,t=this.editor,i=t.renderer.screenToTextCoordinates(this.x,this.y);if(t.$blockScrolling++,this.$clickSelection){var n=this.$clickSelection.comparePoint(i);if(n==-1)e=this.$clickSelection.end;else if(1==n)e=this.$clickSelection.start;else{var r=o(this.$clickSelection,i);i=r.cursor,e=r.anchor}t.selection.setSelectionAnchor(e.row,e.column)}t.selection.selectToPosition(i),t.$blockScrolling--,t.renderer.scrollCursorIntoView()},this.extendSelectionBy=function(e){var t,i=this.editor,n=i.renderer.screenToTextCoordinates(this.x,this.y),r=i.selection[e](n.row,n.column);if(i.$blockScrolling++,this.$clickSelection){var s=this.$clickSelection.comparePoint(r.start),a=this.$clickSelection.comparePoint(r.end);if(s==-1&&a<=0)t=this.$clickSelection.end,r.end.row==n.row&&r.end.column==n.column||(n=r.start);else if(1==a&&s>=0)t=this.$clickSelection.start,r.start.row==n.row&&r.start.column==n.column||(n=r.end);else if(s==-1&&1==a)n=r.end,t=r.start;else{var l=o(this.$clickSelection,n);n=l.cursor,t=l.anchor}i.selection.setSelectionAnchor(t.row,t.column)}i.selection.selectToPosition(n),i.$blockScrolling--,i.renderer.scrollCursorIntoView()},this.selectEnd=this.selectAllEnd=this.selectByWordsEnd=this.selectByLinesEnd=function(){this.$clickSelection=null,this.editor.unsetStyle("ace_selecting"),this.editor.renderer.scroller.releaseCapture&&this.editor.renderer.scroller.releaseCapture()},this.focusWait=function(){var e=r(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y),t=Date.now();(e>s||t-this.mousedownEvent.time>this.$focusTimout)&&this.startSelect(this.mousedownEvent.getDocumentPosition())},this.onDoubleClick=function(e){var t=e.getDocumentPosition(),i=this.editor,n=i.session,r=n.getBracketRange(t);r?(r.isEmpty()&&(r.start.column--,r.end.column++),this.setState("select")):(r=i.selection.getWordRange(t.row,t.column),this.setState("selectByWords")),this.$clickSelection=r,this.select()},this.onTripleClick=function(e){var t=e.getDocumentPosition(),i=this.editor;this.setState("selectByLines");var n=i.getSelectionRange();n.isMultiLine()&&n.contains(t.row,t.column)?(this.$clickSelection=i.selection.getLineRange(n.start.row),this.$clickSelection.end=i.selection.getLineRange(n.end.row).end):this.$clickSelection=i.selection.getLineRange(t.row),this.select()},this.onQuadClick=function(e){var t=this.editor;t.selectAll(),this.$clickSelection=t.getSelectionRange(),this.setState("selectAll")},this.onMouseWheel=function(e){if(!e.getAccelKey()){e.getShiftKey()&&e.wheelY&&!e.wheelX&&(e.wheelX=e.wheelY,e.wheelY=0);var t=e.domEvent.timeStamp,i=t-(this.$lastScrollTime||0),n=this.editor,r=n.renderer.isScrollableBy(e.wheelX*e.speed,e.wheelY*e.speed);return r||i<200?(this.$lastScrollTime=t,n.renderer.scrollBy(e.wheelX*e.speed,e.wheelY*e.speed),e.stop()):void 0}},this.onTouchMove=function(e){var t=e.domEvent.timeStamp,i=t-(this.$lastScrollTime||0),n=this.editor,r=n.renderer.isScrollableBy(e.wheelX*e.speed,e.wheelY*e.speed);if(r||i<200)return this.$lastScrollTime=t,n.renderer.scrollBy(e.wheelX*e.speed,e.wheelY*e.speed),e.stop()}}).call(n.prototype),t.DefaultHandlers=n}),ace.define("ace/tooltip",["require","exports","module","ace/lib/oop","ace/lib/dom"],function(e,t,i){"use strict";function n(e){this.isOpen=!1,this.$element=null,this.$parentNode=e}var r=(e("./lib/oop"),e("./lib/dom"));(function(){this.$init=function(){return this.$element=r.createElement("div"),this.$element.className="ace_tooltip",this.$element.style.display="none",this.$parentNode.appendChild(this.$element),this.$element},this.getElement=function(){return this.$element||this.$init()},this.setText=function(e){r.setInnerText(this.getElement(),e)},this.setHtml=function(e){this.getElement().innerHTML=e},this.setPosition=function(e,t){this.getElement().style.left=e+"px",this.getElement().style.top=t+"px"},this.setClassName=function(e){r.addCssClass(this.getElement(),e)},this.show=function(e,t,i){null!=e&&this.setText(e),null!=t&&null!=i&&this.setPosition(t,i),this.isOpen||(this.getElement().style.display="block",this.isOpen=!0)},this.hide=function(){this.isOpen&&(this.getElement().style.display="none",this.isOpen=!1)},this.getHeight=function(){return this.getElement().offsetHeight},this.getWidth=function(){return this.getElement().offsetWidth}}).call(n.prototype),t.Tooltip=n}),ace.define("ace/mouse/default_gutter_handler",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/event","ace/tooltip"],function(e,t,i){"use strict";function n(e){function t(){var t=d.getDocumentPosition().row,r=l.$annotations[t];if(!r)return i();var o=s.session.getLength();if(t==o){var a=s.renderer.pixelToScreenCoordinates(0,d.y).row,h=d.$pos;if(a>s.session.documentToScreenRow(h.row,h.column))return i()}if(u!=r)if(u=r.text.join("<br/>"),c.setHtml(u),c.show(),s.on("mousewheel",i),e.$tooltipFollowsMouse)n(d);else{var f=d.domEvent.target,p=f.getBoundingClientRect(),m=c.getElement().style;m.left=p.right+"px",m.top=p.bottom+"px"}}function i(){h&&(h=clearTimeout(h)),u&&(c.hide(),u=null,s.removeEventListener("mousewheel",i))}function n(e){c.setPosition(e.x,e.y)}var s=e.editor,l=s.renderer.$gutterLayer,c=new r(s.container);e.editor.setDefaultHandler("guttermousedown",function(t){if(s.isFocused()&&0==t.getButton()){var i=l.getRegion(t);if("foldWidgets"!=i){var n=t.getDocumentPosition().row,r=s.session.selection;if(t.getShiftKey())r.selectTo(n,0);else{if(2==t.domEvent.detail)return s.selectAll(),t.preventDefault();e.$clickSelection=s.selection.getLineRange(n)}return e.setState("selectByLines"),e.captureMouse(t),t.preventDefault()}}});var h,d,u;e.editor.setDefaultHandler("guttermousemove",function(r){var s=r.domEvent.target||r.domEvent.srcElement;return o.hasCssClass(s,"ace_fold-widget")?i():(u&&e.$tooltipFollowsMouse&&n(r),d=r,void(h||(h=setTimeout(function(){h=null,d&&!e.isMousePressed?t():i()},50))))}),a.addListener(s.renderer.$gutter,"mouseout",function(e){d=null,u&&!h&&(h=setTimeout(function(){h=null,i()},50))}),s.on("changeSession",i)}function r(e){l.call(this,e)}var o=e("../lib/dom"),s=e("../lib/oop"),a=e("../lib/event"),l=e("../tooltip").Tooltip;s.inherits(r,l),function(){this.setPosition=function(e,t){var i=window.innerWidth||document.documentElement.clientWidth,n=window.innerHeight||document.documentElement.clientHeight,r=this.getWidth(),o=this.getHeight();e+=15,t+=15,e+r>i&&(e-=e+r-i),t+o>n&&(t-=20+o),l.prototype.setPosition.call(this,e,t)}}.call(r.prototype),t.GutterHandler=n}),ace.define("ace/mouse/mouse_event",["require","exports","module","ace/lib/event","ace/lib/useragent"],function(e,t,i){"use strict";var n=e("../lib/event"),r=e("../lib/useragent"),o=t.MouseEvent=function(e,t){this.domEvent=e,this.editor=t,this.x=this.clientX=e.clientX,this.y=this.clientY=e.clientY,this.$pos=null,this.$inSelection=null,this.propagationStopped=!1,this.defaultPrevented=!1};(function(){this.stopPropagation=function(){n.stopPropagation(this.domEvent),this.propagationStopped=!0},this.preventDefault=function(){n.preventDefault(this.domEvent),this.defaultPrevented=!0},this.stop=function(){this.stopPropagation(),this.preventDefault()},this.getDocumentPosition=function(){
	return this.$pos?this.$pos:(this.$pos=this.editor.renderer.screenToTextCoordinates(this.clientX,this.clientY),this.$pos)},this.inSelection=function(){if(null!==this.$inSelection)return this.$inSelection;var e=this.editor,t=e.getSelectionRange();if(t.isEmpty())this.$inSelection=!1;else{var i=this.getDocumentPosition();this.$inSelection=t.contains(i.row,i.column)}return this.$inSelection},this.getButton=function(){return n.getButton(this.domEvent)},this.getShiftKey=function(){return this.domEvent.shiftKey},this.getAccelKey=r.isMac?function(){return this.domEvent.metaKey}:function(){return this.domEvent.ctrlKey}}).call(o.prototype)}),ace.define("ace/mouse/dragdrop_handler",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"],function(e,t,i){"use strict";function n(e){function t(e,t){var i=Date.now(),n=!t||e.row!=t.row,o=!t||e.column!=t.column;if(!$||n||o)g.$blockScrolling+=1,g.moveCursorToPosition(e),g.$blockScrolling-=1,$=i,D={x:b,y:A};else{var s=r(D.x,D.y,b,A);s>h?$=null:i-$>=c&&(g.renderer.scrollCursorIntoView(),$=null)}}function i(e,t){var i=Date.now(),n=g.renderer.layerConfig.lineHeight,r=g.renderer.layerConfig.characterWidth,o=g.renderer.scroller.getBoundingClientRect(),s={x:{left:b-o.left,right:o.right-b},y:{top:A-o.top,bottom:o.bottom-A}},a=Math.min(s.x.left,s.x.right),c=Math.min(s.y.top,s.y.bottom),h={row:e.row,column:e.column};a/r<=2&&(h.column+=s.x.left<s.x.right?-3:2),c/n<=1&&(h.row+=s.y.top<s.y.bottom?-1:1);var d=e.row!=h.row,u=e.column!=h.column,f=!t||e.row!=t.row;d||u&&!f?S?i-S>=l&&g.renderer.scrollCursorIntoView(h):S=i:S=null}function n(){var e=x;x=g.renderer.screenToTextCoordinates(b,A),t(x,e),i(x,e)}function d(){E=g.selection.toOrientedRange(),w=g.session.addMarker(E,"ace_selection",g.getSelectionStyle()),g.clearSelection(),g.isFocused()&&g.renderer.$cursorLayer.setBlinking(!1),clearInterval(C),n(),C=setInterval(n,20),_=0,s.addListener(document,"mousemove",f)}function u(){clearInterval(C),g.session.removeMarker(w),w=null,g.$blockScrolling+=1,g.selection.fromOrientedRange(E),g.$blockScrolling-=1,g.isFocused()&&!k&&g.renderer.$cursorLayer.setBlinking(!g.getReadOnly()),E=null,x=null,_=0,S=null,$=null,s.removeListener(document,"mousemove",f)}function f(){null==L&&(L=setTimeout(function(){null!=L&&w&&u()},20))}function p(e){var t=e.types;return!t||Array.prototype.some.call(t,function(e){return"text/plain"==e||"Text"==e})}function m(e){var t=["copy","copymove","all","uninitialized"],i=["move","copymove","linkmove","all","uninitialized"],n=a.isMac?e.altKey:e.ctrlKey,r="uninitialized";try{r=e.dataTransfer.effectAllowed.toLowerCase()}catch(e){}var o="none";return n&&t.indexOf(r)>=0?o="copy":i.indexOf(r)>=0?o="move":t.indexOf(r)>=0&&(o="copy"),o}var g=e.editor,v=o.createElement("img");v.src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",a.isOpera&&(v.style.cssText="width:1px;height:1px;position:fixed;top:0;left:0;z-index:2147483647;opacity:0;");var y=["dragWait","dragWaitEnd","startDrag","dragReadyEnd","onMouseDrag"];y.forEach(function(t){e[t]=this[t]},this),g.addEventListener("mousedown",this.onMouseDown.bind(e));var w,b,A,C,E,x,F,k,S,$,D,B=g.container,_=0;this.onDragStart=function(e){if(this.cancelDrag||!B.draggable){var t=this;return setTimeout(function(){t.startSelect(),t.captureMouse(e)},0),e.preventDefault()}E=g.getSelectionRange();var i=e.dataTransfer;i.effectAllowed=g.getReadOnly()?"copy":"copyMove",a.isOpera&&(g.container.appendChild(v),v.scrollTop=0),i.setDragImage&&i.setDragImage(v,0,0),a.isOpera&&g.container.removeChild(v),i.clearData(),i.setData("Text",g.session.getTextRange()),k=!0,this.setState("drag")},this.onDragEnd=function(e){if(B.draggable=!1,k=!1,this.setState(null),!g.getReadOnly()){var t=e.dataTransfer.dropEffect;F||"move"!=t||g.session.remove(g.getSelectionRange()),g.renderer.$cursorLayer.setBlinking(!0)}this.editor.unsetStyle("ace_dragging"),this.editor.renderer.setCursorStyle("")},this.onDragEnter=function(e){if(!g.getReadOnly()&&p(e.dataTransfer))return b=e.clientX,A=e.clientY,w||d(),_++,e.dataTransfer.dropEffect=F=m(e),s.preventDefault(e)},this.onDragOver=function(e){if(!g.getReadOnly()&&p(e.dataTransfer))return b=e.clientX,A=e.clientY,w||(d(),_++),null!==L&&(L=null),e.dataTransfer.dropEffect=F=m(e),s.preventDefault(e)},this.onDragLeave=function(e){if(_--,_<=0&&w)return u(),F=null,s.preventDefault(e)},this.onDrop=function(e){if(x){var t=e.dataTransfer;if(k)switch(F){case"move":E=E.contains(x.row,x.column)?{start:x,end:x}:g.moveText(E,x);break;case"copy":E=g.moveText(E,x,!0)}else{var i=t.getData("Text");E={start:x,end:g.session.insert(x,i)},g.focus(),F=null}return u(),s.preventDefault(e)}},s.addListener(B,"dragstart",this.onDragStart.bind(e)),s.addListener(B,"dragend",this.onDragEnd.bind(e)),s.addListener(B,"dragenter",this.onDragEnter.bind(e)),s.addListener(B,"dragover",this.onDragOver.bind(e)),s.addListener(B,"dragleave",this.onDragLeave.bind(e)),s.addListener(B,"drop",this.onDrop.bind(e));var L=null}function r(e,t,i,n){return Math.sqrt(Math.pow(i-e,2)+Math.pow(n-t,2))}var o=e("../lib/dom"),s=e("../lib/event"),a=e("../lib/useragent"),l=200,c=200,h=5;(function(){this.dragWait=function(){var e=Date.now()-this.mousedownEvent.time;e>this.editor.getDragDelay()&&this.startDrag()},this.dragWaitEnd=function(){var e=this.editor.container;e.draggable=!1,this.startSelect(this.mousedownEvent.getDocumentPosition()),this.selectEnd()},this.dragReadyEnd=function(e){this.editor.renderer.$cursorLayer.setBlinking(!this.editor.getReadOnly()),this.editor.unsetStyle("ace_dragging"),this.editor.renderer.setCursorStyle(""),this.dragWaitEnd()},this.startDrag=function(){this.cancelDrag=!1;var e=this.editor,t=e.container;t.draggable=!0,e.renderer.$cursorLayer.setBlinking(!1),e.setStyle("ace_dragging");var i=a.isWin?"default":"move";e.renderer.setCursorStyle(i),this.setState("dragReady")},this.onMouseDrag=function(e){var t=this.editor.container;if(a.isIE&&"dragReady"==this.state){var i=r(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y);i>3&&t.dragDrop()}if("dragWait"===this.state){var i=r(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y);i>0&&(t.draggable=!1,this.startSelect(this.mousedownEvent.getDocumentPosition()))}},this.onMouseDown=function(e){if(this.$dragEnabled){this.mousedownEvent=e;var t=this.editor,i=e.inSelection(),n=e.getButton(),r=e.domEvent.detail||1;if(1===r&&0===n&&i){if(e.editor.inMultiSelectMode&&(e.getAccelKey()||e.getShiftKey()))return;this.mousedownEvent.time=Date.now();var o=e.domEvent.target||e.domEvent.srcElement;if("unselectable"in o&&(o.unselectable="on"),t.getDragDelay()){if(a.isWebKit){this.cancelDrag=!0;var s=t.container;s.draggable=!0}this.setState("dragWait")}else this.startDrag();this.captureMouse(e,this.onMouseDrag.bind(this)),e.defaultPrevented=!0}}}}).call(n.prototype),t.DragdropHandler=n}),ace.define("ace/lib/net",["require","exports","module","ace/lib/dom"],function(e,t,i){"use strict";var n=e("./dom");t.get=function(e,t){var i=new XMLHttpRequest;i.open("GET",e,!0),i.onreadystatechange=function(){4===i.readyState&&t(i.responseText)},i.send(null)},t.loadScript=function(e,t){var i=n.getDocumentHead(),r=document.createElement("script");r.src=e,i.appendChild(r),r.onload=r.onreadystatechange=function(e,i){!i&&r.readyState&&"loaded"!=r.readyState&&"complete"!=r.readyState||(r=r.onload=r.onreadystatechange=null,i||t())}},t.qualifyURL=function(e){var t=document.createElement("a");return t.href=e,t.href}}),ace.define("ace/lib/event_emitter",["require","exports","module"],function(e,t,i){"use strict";var n={},r=function(){this.propagationStopped=!0},o=function(){this.defaultPrevented=!0};n._emit=n._dispatchEvent=function(e,t){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var i=this._eventRegistry[e]||[],n=this._defaultHandlers[e];if(i.length||n){"object"==typeof t&&t||(t={}),t.type||(t.type=e),t.stopPropagation||(t.stopPropagation=r),t.preventDefault||(t.preventDefault=o),i=i.slice();for(var s=0;s<i.length&&(i[s](t,this),!t.propagationStopped);s++);return n&&!t.defaultPrevented?n(t,this):void 0}},n._signal=function(e,t){var i=(this._eventRegistry||{})[e];if(i){i=i.slice();for(var n=0;n<i.length;n++)i[n](t,this)}},n.once=function(e,t){var i=this;t&&this.addEventListener(e,function n(){i.removeEventListener(e,n),t.apply(null,arguments)})},n.setDefaultHandler=function(e,t){var i=this._defaultHandlers;if(i||(i=this._defaultHandlers={_disabled_:{}}),i[e]){var n=i[e],r=i._disabled_[e];r||(i._disabled_[e]=r=[]),r.push(n);var o=r.indexOf(t);o!=-1&&r.splice(o,1)}i[e]=t},n.removeDefaultHandler=function(e,t){var i=this._defaultHandlers;if(i){var n=i._disabled_[e];if(i[e]==t){i[e];n&&this.setDefaultHandler(e,n.pop())}else if(n){var r=n.indexOf(t);r!=-1&&n.splice(r,1)}}},n.on=n.addEventListener=function(e,t,i){this._eventRegistry=this._eventRegistry||{};var n=this._eventRegistry[e];return n||(n=this._eventRegistry[e]=[]),n.indexOf(t)==-1&&n[i?"unshift":"push"](t),t},n.off=n.removeListener=n.removeEventListener=function(e,t){this._eventRegistry=this._eventRegistry||{};var i=this._eventRegistry[e];if(i){var n=i.indexOf(t);n!==-1&&i.splice(n,1)}},n.removeAllListeners=function(e){this._eventRegistry&&(this._eventRegistry[e]=[])},t.EventEmitter=n}),ace.define("ace/lib/app_config",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,i){"no use strict";function n(e){"undefined"!=typeof console&&console.warn&&console.warn.apply(console,arguments)}function r(e,t){var i=new Error(e);i.data=t,"object"==typeof console&&console.error&&console.error(i),setTimeout(function(){throw i})}var o=e("./oop"),s=e("./event_emitter").EventEmitter,a={setOptions:function(e){Object.keys(e).forEach(function(t){this.setOption(t,e[t])},this)},getOptions:function(e){var t={};return e?Array.isArray(e)||(t=e,e=Object.keys(t)):e=Object.keys(this.$options),e.forEach(function(e){t[e]=this.getOption(e)},this),t},setOption:function(e,t){if(this["$"+e]!==t){var i=this.$options[e];if(!i)return n('misspelled option "'+e+'"');if(i.forwardTo)return this[i.forwardTo]&&this[i.forwardTo].setOption(e,t);i.handlesSet||(this["$"+e]=t),i&&i.set&&i.set.call(this,t)}},getOption:function(e){var t=this.$options[e];return t?t.forwardTo?this[t.forwardTo]&&this[t.forwardTo].getOption(e):t&&t.get?t.get.call(this):this["$"+e]:n('misspelled option "'+e+'"')}},l=function(){this.$defaultOptions={}};(function(){o.implement(this,s),this.defineOptions=function(e,t,i){return e.$options||(this.$defaultOptions[t]=e.$options={}),Object.keys(i).forEach(function(t){var n=i[t];"string"==typeof n&&(n={forwardTo:n}),n.name||(n.name=t),e.$options[n.name]=n,"initialValue"in n&&(e["$"+n.name]=n.initialValue)}),o.implement(e,a),this},this.resetOptions=function(e){Object.keys(e.$options).forEach(function(t){var i=e.$options[t];"value"in i&&e.setOption(t,i.value)})},this.setDefaultValue=function(e,t,i){var n=this.$defaultOptions[e]||(this.$defaultOptions[e]={});n[t]&&(n.forwardTo?this.setDefaultValue(n.forwardTo,t,i):n[t].value=i)},this.setDefaultValues=function(e,t){Object.keys(t).forEach(function(i){this.setDefaultValue(e,i,t[i])},this)},this.warn=n,this.reportError=r}).call(l.prototype),t.AppConfig=l}),ace.define("ace/config",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/lib/net","ace/lib/app_config"],function(e,t,n){"no use strict";function r(r){if(c&&c.document){h.packaged=r||e.packaged||n.packaged||c.define&&i(69).packaged;for(var s={},a="",l=document.currentScript||document._currentScript,d=l&&l.ownerDocument||document,u=d.getElementsByTagName("script"),f=0;f<u.length;f++){var p=u[f],m=p.src||p.getAttribute("src");if(m){for(var g=p.attributes,v=0,y=g.length;v<y;v++){var w=g[v];0===w.name.indexOf("data-ace-")&&(s[o(w.name.replace(/^data-ace-/,""))]=w.value)}var b=m.match(/^(.*)\/ace(\-\w+)?\.js(\?|$)/);b&&(a=b[1])}}a&&(s.base=s.base||a,s.packaged=!0),s.basePath=s.base,s.workerPath=s.workerPath||s.base,s.modePath=s.modePath||s.base,s.themePath=s.themePath||s.base,delete s.base;for(var A in s)"undefined"!=typeof s[A]&&t.set(A,s[A])}}function o(e){return e.replace(/-(.)/g,function(e,t){return t.toUpperCase()})}var s=e("./lib/lang"),a=(e("./lib/oop"),e("./lib/net")),l=e("./lib/app_config").AppConfig;n.exports=t=new l;var c=function(){return this||"undefined"!=typeof window&&window}(),h={packaged:!1,workerPath:null,modePath:null,themePath:null,basePath:"",suffix:".js",$moduleUrls:{}};t.get=function(e){if(!h.hasOwnProperty(e))throw new Error("Unknown config key: "+e);return h[e]},t.set=function(e,t){if(!h.hasOwnProperty(e))throw new Error("Unknown config key: "+e);h[e]=t},t.all=function(){return s.copyObject(h)},t.moduleUrl=function(e,t){if(h.$moduleUrls[e])return h.$moduleUrls[e];var i=e.split("/");t=t||i[i.length-2]||"";var n="snippets"==t?"/":"-",r=i[i.length-1];if("worker"==t&&"-"==n){var o=new RegExp("^"+t+"[\\-_]|[\\-_]"+t+"$","g");r=r.replace(o,"")}(!r||r==t)&&i.length>1&&(r=i[i.length-2]);var s=h[t+"Path"];return null==s?s=h.basePath:"/"==n&&(t=n=""),s&&"/"!=s.slice(-1)&&(s+="/"),s+t+n+r+this.get("suffix")},t.setModuleUrl=function(e,t){return h.$moduleUrls[e]=t},t.$loading={},t.loadModule=function(i,n){var r,o;Array.isArray(i)&&(o=i[0],i=i[1]);try{r=e(i)}catch(e){}if(r&&!t.$loading[i])return n&&n(r);if(t.$loading[i]||(t.$loading[i]=[]),t.$loading[i].push(n),!(t.$loading[i].length>1)){var s=function(){e([i],function(e){t._emit("load.module",{name:i,module:e});var n=t.$loading[i];t.$loading[i]=null,n.forEach(function(t){t&&t(e)})})};return t.get("packaged")?void a.loadScript(t.moduleUrl(i,o),s):s()}},r(!0),t.init=r}),ace.define("ace/mouse/mouse_handler",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/mouse/default_handlers","ace/mouse/default_gutter_handler","ace/mouse/mouse_event","ace/mouse/dragdrop_handler","ace/config"],function(e,t,i){"use strict";var n=e("../lib/event"),r=e("../lib/useragent"),o=e("./default_handlers").DefaultHandlers,s=e("./default_gutter_handler").GutterHandler,a=e("./mouse_event").MouseEvent,l=e("./dragdrop_handler").DragdropHandler,c=e("../config"),h=function(e){var t=this;this.editor=e,new o(this),new s(this),new l(this);var i=function(t){var i=!document.hasFocus||!document.hasFocus()||!e.isFocused()&&document.activeElement==(e.textInput&&e.textInput.getElement());i&&window.focus(),e.focus()},a=e.renderer.getMouseEventTarget();n.addListener(a,"click",this.onMouseEvent.bind(this,"click")),n.addListener(a,"mousemove",this.onMouseMove.bind(this,"mousemove")),n.addMultiMouseDownListener([a,e.renderer.scrollBarV&&e.renderer.scrollBarV.inner,e.renderer.scrollBarH&&e.renderer.scrollBarH.inner,e.textInput&&e.textInput.getElement()].filter(Boolean),[400,300,250],this,"onMouseEvent"),n.addMouseWheelListener(e.container,this.onMouseWheel.bind(this,"mousewheel")),n.addTouchMoveListener(e.container,this.onTouchMove.bind(this,"touchmove"));var c=e.renderer.$gutter;n.addListener(c,"mousedown",this.onMouseEvent.bind(this,"guttermousedown")),n.addListener(c,"click",this.onMouseEvent.bind(this,"gutterclick")),n.addListener(c,"dblclick",this.onMouseEvent.bind(this,"gutterdblclick")),n.addListener(c,"mousemove",this.onMouseEvent.bind(this,"guttermousemove")),n.addListener(a,"mousedown",i),n.addListener(c,"mousedown",i),r.isIE&&e.renderer.scrollBarV&&(n.addListener(e.renderer.scrollBarV.element,"mousedown",i),n.addListener(e.renderer.scrollBarH.element,"mousedown",i)),e.on("mousemove",function(i){if(!t.state&&!t.$dragDelay&&t.$dragEnabled){var n=e.renderer.screenToTextCoordinates(i.x,i.y),r=e.session.selection.getRange(),o=e.renderer;!r.isEmpty()&&r.insideStart(n.row,n.column)?o.setCursorStyle("default"):o.setCursorStyle("")}})};(function(){this.onMouseEvent=function(e,t){this.editor._emit(e,new a(t,this.editor))},this.onMouseMove=function(e,t){var i=this.editor._eventRegistry&&this.editor._eventRegistry.mousemove;i&&i.length&&this.editor._emit(e,new a(t,this.editor))},this.onMouseWheel=function(e,t){var i=new a(t,this.editor);i.speed=2*this.$scrollSpeed,i.wheelX=t.wheelX,i.wheelY=t.wheelY,this.editor._emit(e,i)},this.onTouchMove=function(e,t){var i=new a(t,this.editor);i.speed=1,i.wheelX=t.wheelX,i.wheelY=t.wheelY,this.editor._emit(e,i)},this.setState=function(e){this.state=e},this.captureMouse=function(e,t){this.x=e.x,this.y=e.y,this.isMousePressed=!0;var i=this.editor.renderer;i.$keepTextAreaAtCursor&&(i.$keepTextAreaAtCursor=null);var o=this,s=function(e){if(e){if(r.isWebKit&&!e.which&&o.releaseMouse)return o.releaseMouse();o.x=e.clientX,o.y=e.clientY,t&&t(e),o.mouseEvent=new a(e,o.editor),o.$mouseMoved=!0}},l=function(e){clearInterval(h),c(),o[o.state+"End"]&&o[o.state+"End"](e),o.state="",null==i.$keepTextAreaAtCursor&&(i.$keepTextAreaAtCursor=!0,i.$moveTextAreaToCursor()),o.isMousePressed=!1,o.$onCaptureMouseMove=o.releaseMouse=null,e&&o.onMouseEvent("mouseup",e)},c=function(){o[o.state]&&o[o.state](),o.$mouseMoved=!1};if(r.isOldIE&&"dblclick"==e.domEvent.type)return setTimeout(function(){l(e)});o.$onCaptureMouseMove=s,o.releaseMouse=n.capture(this.editor.container,s,l);var h=setInterval(c,20)},this.releaseMouse=null,this.cancelContextMenu=function(){var e=function(t){t&&t.domEvent&&"contextmenu"!=t.domEvent.type||(this.editor.off("nativecontextmenu",e),t&&t.domEvent&&n.stopEvent(t.domEvent))}.bind(this);setTimeout(e,10),this.editor.on("nativecontextmenu",e)}}).call(h.prototype),c.defineOptions(h.prototype,"mouseHandler",{scrollSpeed:{initialValue:2},dragDelay:{initialValue:r.isMac?150:0},dragEnabled:{initialValue:!0},focusTimout:{initialValue:0},tooltipFollowsMouse:{initialValue:!0}}),t.MouseHandler=h}),ace.define("ace/mouse/fold_handler",["require","exports","module"],function(e,t,i){"use strict";function n(e){e.on("click",function(t){var i=t.getDocumentPosition(),n=e.session,r=n.getFoldAt(i.row,i.column,1);r&&(t.getAccelKey()?n.removeFold(r):n.expandFold(r),t.stop())}),e.on("gutterclick",function(t){var i=e.renderer.$gutterLayer.getRegion(t);if("foldWidgets"==i){var n=t.getDocumentPosition().row,r=e.session;r.foldWidgets&&r.foldWidgets[n]&&e.session.onFoldWidgetClick(n,t),e.isFocused()||e.focus(),t.stop()}}),e.on("gutterdblclick",function(t){var i=e.renderer.$gutterLayer.getRegion(t);if("foldWidgets"==i){var n=t.getDocumentPosition().row,r=e.session,o=r.getParentFoldRangeData(n,!0),s=o.range||o.firstRange;if(s){n=s.start.row;var a=r.getFoldAt(n,r.getLine(n).length,1);a?r.removeFold(a):(r.addFold("...",s),e.renderer.scrollCursorIntoView({row:s.start.row,column:0}))}t.stop()}})}t.FoldHandler=n}),ace.define("ace/keyboard/keybinding",["require","exports","module","ace/lib/keys","ace/lib/event"],function(e,t,i){"use strict";var n=e("../lib/keys"),r=e("../lib/event"),o=function(e){this.$editor=e,this.$data={editor:e},this.$handlers=[],this.setDefaultHandler(e.commands)};(function(){this.setDefaultHandler=function(e){this.removeKeyboardHandler(this.$defaultHandler),this.$defaultHandler=e,this.addKeyboardHandler(e,0)},this.setKeyboardHandler=function(e){var t=this.$handlers;if(t[t.length-1]!=e){for(;t[t.length-1]&&t[t.length-1]!=this.$defaultHandler;)this.removeKeyboardHandler(t[t.length-1]);this.addKeyboardHandler(e,1)}},this.addKeyboardHandler=function(e,t){if(e){"function"!=typeof e||e.handleKeyboard||(e.handleKeyboard=e);var i=this.$handlers.indexOf(e);i!=-1&&this.$handlers.splice(i,1),void 0==t?this.$handlers.push(e):this.$handlers.splice(t,0,e),i==-1&&e.attach&&e.attach(this.$editor)}},this.removeKeyboardHandler=function(e){var t=this.$handlers.indexOf(e);return t!=-1&&(this.$handlers.splice(t,1),e.detach&&e.detach(this.$editor),!0)},this.getKeyboardHandler=function(){return this.$handlers[this.$handlers.length-1]},this.getStatusText=function(){var e=this.$data,t=e.editor;return this.$handlers.map(function(i){return i.getStatusText&&i.getStatusText(t,e)||""}).filter(Boolean).join(" ")},this.$callKeyboardHandlers=function(e,t,i,n){for(var o,s=!1,a=this.$editor.commands,l=this.$handlers.length;l--&&(o=this.$handlers[l].handleKeyboard(this.$data,e,t,i,n),!(o&&o.command&&(s="null"==o.command||a.exec(o.command,this.$editor,o.args,n),s&&n&&e!=-1&&1!=o.passEvent&&1!=o.command.passEvent&&r.stopEvent(n),s))););return s||e!=-1||(o={command:"insertstring"},s=a.exec("insertstring",this.$editor,t)),s&&this.$editor._signal("keyboardActivity",o),s},this.onCommandKey=function(e,t,i){var r=n.keyCodeToString(i);this.$callKeyboardHandlers(t,r,i,e)},this.onTextInput=function(e){this.$callKeyboardHandlers(-1,e)}}).call(o.prototype),t.KeyBinding=o}),ace.define("ace/range",["require","exports","module"],function(e,t,i){"use strict";var n=function(e,t){return e.row-t.row||e.column-t.column},r=function(e,t,i,n){this.start={row:e,column:t},this.end={row:i,column:n}};(function(){this.isEqual=function(e){return this.start.row===e.start.row&&this.end.row===e.end.row&&this.start.column===e.start.column&&this.end.column===e.end.column},this.toString=function(){return"Range: ["+this.start.row+"/"+this.start.column+"] -> ["+this.end.row+"/"+this.end.column+"]"},this.contains=function(e,t){return 0==this.compare(e,t)},this.compareRange=function(e){var t,i=e.end,n=e.start;return t=this.compare(i.row,i.column),1==t?(t=this.compare(n.row,n.column),1==t?2:0==t?1:0):t==-1?-2:(t=this.compare(n.row,n.column),t==-1?-1:1==t?42:0)},this.comparePoint=function(e){return this.compare(e.row,e.column)},this.containsRange=function(e){return 0==this.comparePoint(e.start)&&0==this.comparePoint(e.end)},this.intersects=function(e){var t=this.compareRange(e);return t==-1||0==t||1==t},this.isEnd=function(e,t){return this.end.row==e&&this.end.column==t},this.isStart=function(e,t){return this.start.row==e&&this.start.column==t},this.setStart=function(e,t){"object"==typeof e?(this.start.column=e.column,this.start.row=e.row):(this.start.row=e,this.start.column=t)},this.setEnd=function(e,t){"object"==typeof e?(this.end.column=e.column,this.end.row=e.row):(this.end.row=e,this.end.column=t)},this.inside=function(e,t){return 0==this.compare(e,t)&&(!this.isEnd(e,t)&&!this.isStart(e,t))},this.insideStart=function(e,t){return 0==this.compare(e,t)&&!this.isEnd(e,t)},this.insideEnd=function(e,t){return 0==this.compare(e,t)&&!this.isStart(e,t)},this.compare=function(e,t){return this.isMultiLine()||e!==this.start.row?e<this.start.row?-1:e>this.end.row?1:this.start.row===e?t>=this.start.column?0:-1:this.end.row===e?t<=this.end.column?0:1:0:t<this.start.column?-1:t>this.end.column?1:0},this.compareStart=function(e,t){return this.start.row==e&&this.start.column==t?-1:this.compare(e,t)},this.compareEnd=function(e,t){return this.end.row==e&&this.end.column==t?1:this.compare(e,t)},this.compareInside=function(e,t){return this.end.row==e&&this.end.column==t?1:this.start.row==e&&this.start.column==t?-1:this.compare(e,t)},this.clipRows=function(e,t){if(this.end.row>t)var i={row:t+1,column:0};else if(this.end.row<e)var i={row:e,column:0};if(this.start.row>t)var n={row:t+1,column:0};else if(this.start.row<e)var n={row:e,column:0};return r.fromPoints(n||this.start,i||this.end)},this.extend=function(e,t){var i=this.compare(e,t);if(0==i)return this;if(i==-1)var n={row:e,column:t};else var o={row:e,column:t};return r.fromPoints(n||this.start,o||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return r.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new r(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new r(this.start.row,0,this.end.row,0)},this.toScreenRange=function(e){var t=e.documentToScreenPosition(this.start),i=e.documentToScreenPosition(this.end);return new r(t.row,t.column,i.row,i.column)},this.moveBy=function(e,t){this.start.row+=e,this.start.column+=t,this.end.row+=e,this.end.column+=t}}).call(r.prototype),r.fromPoints=function(e,t){return new r(e.row,e.column,t.row,t.column)},r.comparePoints=n,r.comparePoints=function(e,t){return e.row-t.row||e.column-t.column},t.Range=r}),ace.define("ace/selection",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/range"],function(e,t,i){"use strict";var n=e("./lib/oop"),r=e("./lib/lang"),o=e("./lib/event_emitter").EventEmitter,s=e("./range").Range,a=function(e){this.session=e,this.doc=e.getDocument(),this.clearSelection(),this.lead=this.selectionLead=this.doc.createAnchor(0,0),this.anchor=this.selectionAnchor=this.doc.createAnchor(0,0);var t=this;this.lead.on("change",function(e){t._emit("changeCursor"),t.$isEmpty||t._emit("changeSelection"),t.$keepDesiredColumnOnChange||e.old.column==e.value.column||(t.$desiredColumn=null)}),this.selectionAnchor.on("change",function(){t.$isEmpty||t._emit("changeSelection")})};(function(){n.implement(this,o),this.isEmpty=function(){return this.$isEmpty||this.anchor.row==this.lead.row&&this.anchor.column==this.lead.column},this.isMultiLine=function(){return!this.isEmpty()&&this.getRange().isMultiLine()},this.getCursor=function(){return this.lead.getPosition()},this.setSelectionAnchor=function(e,t){this.anchor.setPosition(e,t),this.$isEmpty&&(this.$isEmpty=!1,this._emit("changeSelection"))},this.getSelectionAnchor=function(){return this.$isEmpty?this.getSelectionLead():this.anchor.getPosition()},this.getSelectionLead=function(){return this.lead.getPosition()},this.shiftSelection=function(e){if(this.$isEmpty)return void this.moveCursorTo(this.lead.row,this.lead.column+e);var t=this.getSelectionAnchor(),i=this.getSelectionLead(),n=this.isBackwards();n&&0===t.column||this.setSelectionAnchor(t.row,t.column+e),(n||0!==i.column)&&this.$moveSelection(function(){this.moveCursorTo(i.row,i.column+e)})},this.isBackwards=function(){var e=this.anchor,t=this.lead;return e.row>t.row||e.row==t.row&&e.column>t.column},this.getRange=function(){var e=this.anchor,t=this.lead;return this.isEmpty()?s.fromPoints(t,t):this.isBackwards()?s.fromPoints(t,e):s.fromPoints(e,t)},this.clearSelection=function(){this.$isEmpty||(this.$isEmpty=!0,this._emit("changeSelection"))},this.selectAll=function(){var e=this.doc.getLength()-1;this.setSelectionAnchor(0,0),this.moveCursorTo(e,this.doc.getLine(e).length)},this.setRange=this.setSelectionRange=function(e,t){t?(this.setSelectionAnchor(e.end.row,e.end.column),this.selectTo(e.start.row,e.start.column)):(this.setSelectionAnchor(e.start.row,e.start.column),this.selectTo(e.end.row,e.end.column)),this.getRange().isEmpty()&&(this.$isEmpty=!0),this.$desiredColumn=null},this.$moveSelection=function(e){var t=this.lead;this.$isEmpty&&this.setSelectionAnchor(t.row,t.column),e.call(this)},this.selectTo=function(e,t){this.$moveSelection(function(){this.moveCursorTo(e,t)})},this.selectToPosition=function(e){this.$moveSelection(function(){this.moveCursorToPosition(e)})},this.moveTo=function(e,t){this.clearSelection(),this.moveCursorTo(e,t)},this.moveToPosition=function(e){this.clearSelection(),this.moveCursorToPosition(e)},this.selectUp=function(){this.$moveSelection(this.moveCursorUp)},this.selectDown=function(){this.$moveSelection(this.moveCursorDown)},this.selectRight=function(){this.$moveSelection(this.moveCursorRight)},this.selectLeft=function(){this.$moveSelection(this.moveCursorLeft)},this.selectLineStart=function(){this.$moveSelection(this.moveCursorLineStart)},this.selectLineEnd=function(){this.$moveSelection(this.moveCursorLineEnd)},this.selectFileEnd=function(){this.$moveSelection(this.moveCursorFileEnd)},this.selectFileStart=function(){this.$moveSelection(this.moveCursorFileStart)},this.selectWordRight=function(){this.$moveSelection(this.moveCursorWordRight)},this.selectWordLeft=function(){this.$moveSelection(this.moveCursorWordLeft)},this.getWordRange=function(e,t){if("undefined"==typeof t){var i=e||this.lead;e=i.row,t=i.column}return this.session.getWordRange(e,t)},this.selectWord=function(){this.setSelectionRange(this.getWordRange())},this.selectAWord=function(){var e=this.getCursor(),t=this.session.getAWordRange(e.row,e.column);this.setSelectionRange(t)},this.getLineRange=function(e,t){var i,n="number"==typeof e?e:this.lead.row,r=this.session.getFoldLine(n);return r?(n=r.start.row,i=r.end.row):i=n,t===!0?new s(n,0,i,this.session.getLine(i).length):new s(n,0,i+1,0)},this.selectLine=function(){this.setSelectionRange(this.getLineRange())},this.moveCursorUp=function(){this.moveCursorBy(-1,0)},this.moveCursorDown=function(){this.moveCursorBy(1,0)},this.moveCursorLeft=function(){var e,t=this.lead.getPosition();if(e=this.session.getFoldAt(t.row,t.column,-1))this.moveCursorTo(e.start.row,e.start.column);else if(0===t.column)t.row>0&&this.moveCursorTo(t.row-1,this.doc.getLine(t.row-1).length);else{var i=this.session.getTabSize();this.session.isTabStop(t)&&this.doc.getLine(t.row).slice(t.column-i,t.column).split(" ").length-1==i?this.moveCursorBy(0,-i):this.moveCursorBy(0,-1)}},this.moveCursorRight=function(){var e,t=this.lead.getPosition();if(e=this.session.getFoldAt(t.row,t.column,1))this.moveCursorTo(e.end.row,e.end.column);else if(this.lead.column==this.doc.getLine(this.lead.row).length)this.lead.row<this.doc.getLength()-1&&this.moveCursorTo(this.lead.row+1,0);else{var i=this.session.getTabSize(),t=this.lead;this.session.isTabStop(t)&&this.doc.getLine(t.row).slice(t.column,t.column+i).split(" ").length-1==i?this.moveCursorBy(0,i):this.moveCursorBy(0,1)}},this.moveCursorLineStart=function(){var e=this.lead.row,t=this.lead.column,i=this.session.documentToScreenRow(e,t),n=this.session.screenToDocumentPosition(i,0),r=this.session.getDisplayLine(e,null,n.row,n.column),o=r.match(/^\s*/);o[0].length==t||this.session.$useEmacsStyleLineStart||(n.column+=o[0].length),this.moveCursorToPosition(n)},this.moveCursorLineEnd=function(){var e=this.lead,t=this.session.getDocumentLastRowColumnPosition(e.row,e.column);if(this.lead.column==t.column){var i=this.session.getLine(t.row);if(t.column==i.length){var n=i.search(/\s+$/);n>0&&(t.column=n)}}this.moveCursorTo(t.row,t.column)},this.moveCursorFileEnd=function(){var e=this.doc.getLength()-1,t=this.doc.getLine(e).length;this.moveCursorTo(e,t)},this.moveCursorFileStart=function(){this.moveCursorTo(0,0)},this.moveCursorLongWordRight=function(){var e,t=this.lead.row,i=this.lead.column,n=this.doc.getLine(t),r=n.substring(i);this.session.nonTokenRe.lastIndex=0,this.session.tokenRe.lastIndex=0;var o=this.session.getFoldAt(t,i,1);return o?void this.moveCursorTo(o.end.row,o.end.column):((e=this.session.nonTokenRe.exec(r))&&(i+=this.session.nonTokenRe.lastIndex,this.session.nonTokenRe.lastIndex=0,r=n.substring(i)),i>=n.length?(this.moveCursorTo(t,n.length),this.moveCursorRight(),void(t<this.doc.getLength()-1&&this.moveCursorWordRight())):((e=this.session.tokenRe.exec(r))&&(i+=this.session.tokenRe.lastIndex,this.session.tokenRe.lastIndex=0),void this.moveCursorTo(t,i)))},this.moveCursorLongWordLeft=function(){var e,t=this.lead.row,i=this.lead.column;if(e=this.session.getFoldAt(t,i,-1))return void this.moveCursorTo(e.start.row,e.start.column);var n=this.session.getFoldStringAt(t,i,-1);null==n&&(n=this.doc.getLine(t).substring(0,i));var o,s=r.stringReverse(n);return this.session.nonTokenRe.lastIndex=0,this.session.tokenRe.lastIndex=0,(o=this.session.nonTokenRe.exec(s))&&(i-=this.session.nonTokenRe.lastIndex,s=s.slice(this.session.nonTokenRe.lastIndex),this.session.nonTokenRe.lastIndex=0),i<=0?(this.moveCursorTo(t,0),this.moveCursorLeft(),void(t>0&&this.moveCursorWordLeft())):((o=this.session.tokenRe.exec(s))&&(i-=this.session.tokenRe.lastIndex,this.session.tokenRe.lastIndex=0),void this.moveCursorTo(t,i))},this.$shortWordEndIndex=function(e){var t,i,n=0,r=/\s/,o=this.session.tokenRe;if(o.lastIndex=0,t=this.session.tokenRe.exec(e))n=this.session.tokenRe.lastIndex;else{for(;(i=e[n])&&r.test(i);)n++;if(n<1)for(o.lastIndex=0;(i=e[n])&&!o.test(i);)if(o.lastIndex=0,n++,r.test(i)){if(n>2){n--;break}for(;(i=e[n])&&r.test(i);)n++;if(n>2)break}}return o.lastIndex=0,n},this.moveCursorShortWordRight=function(){var e=this.lead.row,t=this.lead.column,i=this.doc.getLine(e),n=i.substring(t),r=this.session.getFoldAt(e,t,1);
	if(r)return this.moveCursorTo(r.end.row,r.end.column);if(t==i.length){var o=this.doc.getLength();do e++,n=this.doc.getLine(e);while(e<o&&/^\s*$/.test(n));/^\s+/.test(n)||(n=""),t=0}var s=this.$shortWordEndIndex(n);this.moveCursorTo(e,t+s)},this.moveCursorShortWordLeft=function(){var e,t=this.lead.row,i=this.lead.column;if(e=this.session.getFoldAt(t,i,-1))return this.moveCursorTo(e.start.row,e.start.column);var n=this.session.getLine(t).substring(0,i);if(0===i){do t--,n=this.doc.getLine(t);while(t>0&&/^\s*$/.test(n));i=n.length,/\s+$/.test(n)||(n="")}var o=r.stringReverse(n),s=this.$shortWordEndIndex(o);return this.moveCursorTo(t,i-s)},this.moveCursorWordRight=function(){this.session.$selectLongWords?this.moveCursorLongWordRight():this.moveCursorShortWordRight()},this.moveCursorWordLeft=function(){this.session.$selectLongWords?this.moveCursorLongWordLeft():this.moveCursorShortWordLeft()},this.moveCursorBy=function(e,t){var i=this.session.documentToScreenPosition(this.lead.row,this.lead.column);0===t&&(this.$desiredColumn?i.column=this.$desiredColumn:this.$desiredColumn=i.column);var n=this.session.screenToDocumentPosition(i.row+e,i.column);0!==e&&0===t&&n.row===this.lead.row&&n.column===this.lead.column&&this.session.lineWidgets&&this.session.lineWidgets[n.row]&&(n.row>0||e>0)&&n.row++,this.moveCursorTo(n.row,n.column+t,0===t)},this.moveCursorToPosition=function(e){this.moveCursorTo(e.row,e.column)},this.moveCursorTo=function(e,t,i){var n=this.session.getFoldAt(e,t,1);n&&(e=n.start.row,t=n.start.column),this.$keepDesiredColumnOnChange=!0,this.lead.setPosition(e,t),this.$keepDesiredColumnOnChange=!1,i||(this.$desiredColumn=null)},this.moveCursorToScreen=function(e,t,i){var n=this.session.screenToDocumentPosition(e,t);this.moveCursorTo(n.row,n.column,i)},this.detach=function(){this.lead.detach(),this.anchor.detach(),this.session=this.doc=null},this.fromOrientedRange=function(e){this.setSelectionRange(e,e.cursor==e.start),this.$desiredColumn=e.desiredColumn||this.$desiredColumn},this.toOrientedRange=function(e){var t=this.getRange();return e?(e.start.column=t.start.column,e.start.row=t.start.row,e.end.column=t.end.column,e.end.row=t.end.row):e=t,e.cursor=this.isBackwards()?e.start:e.end,e.desiredColumn=this.$desiredColumn,e},this.getRangeOfMovements=function(e){var t=this.getCursor();try{e(this);var i=this.getCursor();return s.fromPoints(t,i)}catch(e){return s.fromPoints(t,t)}finally{this.moveCursorToPosition(t)}},this.toJSON=function(){if(this.rangeCount)var e=this.ranges.map(function(e){var t=e.clone();return t.isBackwards=e.cursor==e.start,t});else{var e=this.getRange();e.isBackwards=this.isBackwards()}return e},this.fromJSON=function(e){if(void 0==e.start){if(this.rangeList){this.toSingleRange(e[0]);for(var t=e.length;t--;){var i=s.fromPoints(e[t].start,e[t].end);e[t].isBackwards&&(i.cursor=i.start),this.addRange(i,!0)}return}e=e[0]}this.rangeList&&this.toSingleRange(e),this.setSelectionRange(e,e.isBackwards)},this.isEqual=function(e){if((e.length||this.rangeCount)&&e.length!=this.rangeCount)return!1;if(!e.length||!this.ranges)return this.getRange().isEqual(e);for(var t=this.ranges.length;t--;)if(!this.ranges[t].isEqual(e[t]))return!1;return!0}}).call(a.prototype),t.Selection=a}),ace.define("ace/tokenizer",["require","exports","module","ace/config"],function(e,t,i){"use strict";var n=e("./config"),r=2e3,o=function(e){this.states=e,this.regExps={},this.matchMappings={};for(var t in this.states){for(var i=this.states[t],n=[],r=0,o=this.matchMappings[t]={defaultToken:"text"},s="g",a=[],l=0;l<i.length;l++){var c=i[l];if(c.defaultToken&&(o.defaultToken=c.defaultToken),c.caseInsensitive&&(s="gi"),null!=c.regex){c.regex instanceof RegExp&&(c.regex=c.regex.toString().slice(1,-1));var h=c.regex,d=new RegExp("(?:("+h+")|(.))").exec("a").length-2;Array.isArray(c.token)?1==c.token.length||1==d?c.token=c.token[0]:d-1!=c.token.length?(this.reportError("number of classes and regexp groups doesn't match",{rule:c,groupCount:d-1}),c.token=c.token[0]):(c.tokenArray=c.token,c.token=null,c.onMatch=this.$arrayTokens):"function"!=typeof c.token||c.onMatch||(d>1?c.onMatch=this.$applyToken:c.onMatch=c.token),d>1&&(/\\\d/.test(c.regex)?h=c.regex.replace(/\\([0-9]+)/g,function(e,t){return"\\"+(parseInt(t,10)+r+1)}):(d=1,h=this.removeCapturingGroups(c.regex)),c.splitRegex||"string"==typeof c.token||a.push(c)),o[r]=l,r+=d,n.push(h),c.onMatch||(c.onMatch=null)}}n.length||(o[0]=0,n.push("$")),a.forEach(function(e){e.splitRegex=this.createSplitterRegexp(e.regex,s)},this),this.regExps[t]=new RegExp("("+n.join(")|(")+")|($)",s)}};(function(){this.$setMaxTokenCount=function(e){r=0|e},this.$applyToken=function(e){var t=this.splitRegex.exec(e).slice(1),i=this.token.apply(this,t);if("string"==typeof i)return[{type:i,value:e}];for(var n=[],r=0,o=i.length;r<o;r++)t[r]&&(n[n.length]={type:i[r],value:t[r]});return n},this.$arrayTokens=function(e){if(!e)return[];var t=this.splitRegex.exec(e);if(!t)return"text";for(var i=[],n=this.tokenArray,r=0,o=n.length;r<o;r++)t[r+1]&&(i[i.length]={type:n[r],value:t[r+1]});return i},this.removeCapturingGroups=function(e){var t=e.replace(/\[(?:\\.|[^\]])*?\]|\\.|\(\?[:=!]|(\()/g,function(e,t){return t?"(?:":e});return t},this.createSplitterRegexp=function(e,t){if(e.indexOf("(?=")!=-1){var i=0,n=!1,r={};e.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g,function(e,t,o,s,a,l){return n?n="]"!=a:a?n=!0:s?(i==r.stack&&(r.end=l+1,r.stack=-1),i--):o&&(i++,1!=o.length&&(r.stack=i,r.start=l)),e}),null!=r.end&&/^\)*$/.test(e.substr(r.end))&&(e=e.substring(0,r.start)+e.substr(r.end))}return"^"!=e.charAt(0)&&(e="^"+e),"$"!=e.charAt(e.length-1)&&(e+="$"),new RegExp(e,(t||"").replace("g",""))},this.getLineTokens=function(e,t){if(t&&"string"!=typeof t){var i=t.slice(0);t=i[0],"#tmp"===t&&(i.shift(),t=i.shift())}else var i=[];var n=t||"start",o=this.states[n];o||(n="start",o=this.states[n]);var s=this.matchMappings[n],a=this.regExps[n];a.lastIndex=0;for(var l,c=[],h=0,d=0,u={type:null,value:""};l=a.exec(e);){var f=s.defaultToken,p=null,m=l[0],g=a.lastIndex;if(g-m.length>h){var v=e.substring(h,g-m.length);u.type==f?u.value+=v:(u.type&&c.push(u),u={type:f,value:v})}for(var y=0;y<l.length-2;y++)if(void 0!==l[y+1]){p=o[s[y]],f=p.onMatch?p.onMatch(m,n,i):p.token,p.next&&(n="string"==typeof p.next?p.next:p.next(n,i),o=this.states[n],o||(this.reportError("state doesn't exist",n),n="start",o=this.states[n]),s=this.matchMappings[n],h=g,a=this.regExps[n],a.lastIndex=g);break}if(m)if("string"==typeof f)p&&p.merge===!1||u.type!==f?(u.type&&c.push(u),u={type:f,value:m}):u.value+=m;else if(f){u.type&&c.push(u),u={type:null,value:""};for(var y=0;y<f.length;y++)c.push(f[y])}if(h==e.length)break;if(h=g,d++>r){for(d>2*e.length&&this.reportError("infinite loop with in ace tokenizer",{startState:t,line:e});h<e.length;)u.type&&c.push(u),u={value:e.substring(h,h+=2e3),type:"overflow"};n="start",i=[];break}}return u.type&&c.push(u),i.length>1&&i[0]!==n&&i.unshift("#tmp",n),{tokens:c,state:i.length?i:n}},this.reportError=n.reportError}).call(o.prototype),t.Tokenizer=o}),ace.define("ace/mode/text_highlight_rules",["require","exports","module","ace/lib/lang"],function(e,t,i){"use strict";var n=e("../lib/lang"),r=function(){this.$rules={start:[{token:"empty_line",regex:"^$"},{defaultToken:"text"}]}};(function(){this.addRules=function(e,t){if(t)for(var i in e){for(var n=e[i],r=0;r<n.length;r++){var o=n[r];(o.next||o.onMatch)&&("string"==typeof o.next&&0!==o.next.indexOf(t)&&(o.next=t+o.next),o.nextState&&0!==o.nextState.indexOf(t)&&(o.nextState=t+o.nextState))}this.$rules[t+i]=n}else for(var i in e)this.$rules[i]=e[i]},this.getRules=function(){return this.$rules},this.embedRules=function(e,t,i,r,o){var s="function"==typeof e?(new e).getRules():e;if(r)for(var a=0;a<r.length;a++)r[a]=t+r[a];else{r=[];for(var l in s)r.push(t+l)}if(this.addRules(s,t),i)for(var c=Array.prototype[o?"push":"unshift"],a=0;a<r.length;a++)c.apply(this.$rules[r[a]],n.deepCopy(i));this.$embeds||(this.$embeds=[]),this.$embeds.push(t)},this.getEmbeds=function(){return this.$embeds};var e=function(e,t){return("start"!=e||t.length)&&t.unshift(this.nextState,e),this.nextState},t=function(e,t){return t.shift(),t.shift()||"start"};this.normalizeRules=function(){function i(o){var s=r[o];s.processed=!0;for(var a=0;a<s.length;a++){var l=s[a];!l.regex&&l.start&&(l.regex=l.start,l.next||(l.next=[]),l.next.push({defaultToken:l.token},{token:l.token+".end",regex:l.end||l.start,next:"pop"}),l.token=l.token+".start",l.push=!0);var c=l.next||l.push;if(c&&Array.isArray(c)){var h=l.stateName;h||(h=l.token,"string"!=typeof h&&(h=h[0]||""),r[h]&&(h+=n++)),r[h]=c,l.next=h,i(h)}else"pop"==c&&(l.next=t);if(l.push&&(l.nextState=l.next||l.push,l.next=e,delete l.push),l.rules)for(var d in l.rules)r[d]?r[d].push&&r[d].push.apply(r[d],l.rules[d]):r[d]=l.rules[d];if(l.include||"string"==typeof l)var u=l.include||l,f=r[u];else Array.isArray(l)&&(f=l);if(f){var p=[a,1].concat(f);l.noEscape&&(p=p.filter(function(e){return!e.next})),s.splice.apply(s,p),a--,f=null}l.keywordMap&&(l.token=this.createKeywordMapper(l.keywordMap,l.defaultToken||"text",l.caseInsensitive),delete l.defaultToken)}}var n=0,r=this.$rules;Object.keys(r).forEach(i,this)},this.createKeywordMapper=function(e,t,i,n){var r=Object.create(null);return Object.keys(e).forEach(function(t){var o=e[t];i&&(o=o.toLowerCase());for(var s=o.split(n||"|"),a=s.length;a--;)r[s[a]]=t}),Object.getPrototypeOf(r)&&(r.__proto__=null),this.$keywordList=Object.keys(r),e=null,i?function(e){return r[e.toLowerCase()]||t}:function(e){return r[e]||t}},this.getKeywords=function(){return this.$keywords}}).call(r.prototype),t.TextHighlightRules=r}),ace.define("ace/mode/behaviour",["require","exports","module"],function(e,t,i){"use strict";var n=function(){this.$behaviours={}};(function(){this.add=function(e,t,i){switch(void 0){case this.$behaviours:this.$behaviours={};case this.$behaviours[e]:this.$behaviours[e]={}}this.$behaviours[e][t]=i},this.addBehaviours=function(e){for(var t in e)for(var i in e[t])this.add(t,i,e[t][i])},this.remove=function(e){this.$behaviours&&this.$behaviours[e]&&delete this.$behaviours[e]},this.inherit=function(e,t){if("function"==typeof e)var i=(new e).getBehaviours(t);else var i=e.getBehaviours(t);this.addBehaviours(i)},this.getBehaviours=function(e){if(e){for(var t={},i=0;i<e.length;i++)this.$behaviours[e[i]]&&(t[e[i]]=this.$behaviours[e[i]]);return t}return this.$behaviours}}).call(n.prototype),t.Behaviour=n}),ace.define("ace/unicode",["require","exports","module"],function(e,t,i){"use strict";function n(e){var i=/\w{4}/g;for(var n in e)t.packages[n]=e[n].replace(i,"\\u$&")}t.packages={},n({L:"0041-005A0061-007A00AA00B500BA00C0-00D600D8-00F600F8-02C102C6-02D102E0-02E402EC02EE0370-037403760377037A-037D03860388-038A038C038E-03A103A3-03F503F7-0481048A-05250531-055605590561-058705D0-05EA05F0-05F20621-064A066E066F0671-06D306D506E506E606EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA07F407F507FA0800-0815081A082408280904-0939093D09500958-0961097109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E460E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EC60EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10A0-10C510D0-10FA10FC1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317D717DC1820-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541AA71B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C7D1CE9-1CEC1CEE-1CF11D00-1DBF1E00-1F151F18-1F1D1F20-1F451F48-1F4D1F50-1F571F591F5B1F5D1F5F-1F7D1F80-1FB41FB6-1FBC1FBE1FC2-1FC41FC6-1FCC1FD0-1FD31FD6-1FDB1FE0-1FEC1FF2-1FF41FF6-1FFC2071207F2090-209421022107210A-211321152119-211D212421262128212A-212D212F-2139213C-213F2145-2149214E218321842C00-2C2E2C30-2C5E2C60-2CE42CEB-2CEE2D00-2D252D30-2D652D6F2D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE2E2F300530063031-3035303B303C3041-3096309D-309F30A1-30FA30FC-30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A48CA4D0-A4FDA500-A60CA610-A61FA62AA62BA640-A65FA662-A66EA67F-A697A6A0-A6E5A717-A71FA722-A788A78BA78CA7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2A9CFAA00-AA28AA40-AA42AA44-AA4BAA60-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADB-AADDABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB00-FB06FB13-FB17FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF21-FF3AFF41-FF5AFF66-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",Ll:"0061-007A00AA00B500BA00DF-00F600F8-00FF01010103010501070109010B010D010F01110113011501170119011B011D011F01210123012501270129012B012D012F01310133013501370138013A013C013E014001420144014601480149014B014D014F01510153015501570159015B015D015F01610163016501670169016B016D016F0171017301750177017A017C017E-0180018301850188018C018D019201950199-019B019E01A101A301A501A801AA01AB01AD01B001B401B601B901BA01BD-01BF01C601C901CC01CE01D001D201D401D601D801DA01DC01DD01DF01E101E301E501E701E901EB01ED01EF01F001F301F501F901FB01FD01FF02010203020502070209020B020D020F02110213021502170219021B021D021F02210223022502270229022B022D022F02310233-0239023C023F0240024202470249024B024D024F-02930295-02AF037103730377037B-037D039003AC-03CE03D003D103D5-03D703D903DB03DD03DF03E103E303E503E703E903EB03ED03EF-03F303F503F803FB03FC0430-045F04610463046504670469046B046D046F04710473047504770479047B047D047F0481048B048D048F04910493049504970499049B049D049F04A104A304A504A704A904AB04AD04AF04B104B304B504B704B904BB04BD04BF04C204C404C604C804CA04CC04CE04CF04D104D304D504D704D904DB04DD04DF04E104E304E504E704E904EB04ED04EF04F104F304F504F704F904FB04FD04FF05010503050505070509050B050D050F05110513051505170519051B051D051F0521052305250561-05871D00-1D2B1D62-1D771D79-1D9A1E011E031E051E071E091E0B1E0D1E0F1E111E131E151E171E191E1B1E1D1E1F1E211E231E251E271E291E2B1E2D1E2F1E311E331E351E371E391E3B1E3D1E3F1E411E431E451E471E491E4B1E4D1E4F1E511E531E551E571E591E5B1E5D1E5F1E611E631E651E671E691E6B1E6D1E6F1E711E731E751E771E791E7B1E7D1E7F1E811E831E851E871E891E8B1E8D1E8F1E911E931E95-1E9D1E9F1EA11EA31EA51EA71EA91EAB1EAD1EAF1EB11EB31EB51EB71EB91EBB1EBD1EBF1EC11EC31EC51EC71EC91ECB1ECD1ECF1ED11ED31ED51ED71ED91EDB1EDD1EDF1EE11EE31EE51EE71EE91EEB1EED1EEF1EF11EF31EF51EF71EF91EFB1EFD1EFF-1F071F10-1F151F20-1F271F30-1F371F40-1F451F50-1F571F60-1F671F70-1F7D1F80-1F871F90-1F971FA0-1FA71FB0-1FB41FB61FB71FBE1FC2-1FC41FC61FC71FD0-1FD31FD61FD71FE0-1FE71FF2-1FF41FF61FF7210A210E210F2113212F21342139213C213D2146-2149214E21842C30-2C5E2C612C652C662C682C6A2C6C2C712C732C742C76-2C7C2C812C832C852C872C892C8B2C8D2C8F2C912C932C952C972C992C9B2C9D2C9F2CA12CA32CA52CA72CA92CAB2CAD2CAF2CB12CB32CB52CB72CB92CBB2CBD2CBF2CC12CC32CC52CC72CC92CCB2CCD2CCF2CD12CD32CD52CD72CD92CDB2CDD2CDF2CE12CE32CE42CEC2CEE2D00-2D25A641A643A645A647A649A64BA64DA64FA651A653A655A657A659A65BA65DA65FA663A665A667A669A66BA66DA681A683A685A687A689A68BA68DA68FA691A693A695A697A723A725A727A729A72BA72DA72F-A731A733A735A737A739A73BA73DA73FA741A743A745A747A749A74BA74DA74FA751A753A755A757A759A75BA75DA75FA761A763A765A767A769A76BA76DA76FA771-A778A77AA77CA77FA781A783A785A787A78CFB00-FB06FB13-FB17FF41-FF5A",Lu:"0041-005A00C0-00D600D8-00DE01000102010401060108010A010C010E01100112011401160118011A011C011E01200122012401260128012A012C012E01300132013401360139013B013D013F0141014301450147014A014C014E01500152015401560158015A015C015E01600162016401660168016A016C016E017001720174017601780179017B017D018101820184018601870189-018B018E-0191019301940196-0198019C019D019F01A001A201A401A601A701A901AC01AE01AF01B1-01B301B501B701B801BC01C401C701CA01CD01CF01D101D301D501D701D901DB01DE01E001E201E401E601E801EA01EC01EE01F101F401F6-01F801FA01FC01FE02000202020402060208020A020C020E02100212021402160218021A021C021E02200222022402260228022A022C022E02300232023A023B023D023E02410243-02460248024A024C024E03700372037603860388-038A038C038E038F0391-03A103A3-03AB03CF03D2-03D403D803DA03DC03DE03E003E203E403E603E803EA03EC03EE03F403F703F903FA03FD-042F04600462046404660468046A046C046E04700472047404760478047A047C047E0480048A048C048E04900492049404960498049A049C049E04A004A204A404A604A804AA04AC04AE04B004B204B404B604B804BA04BC04BE04C004C104C304C504C704C904CB04CD04D004D204D404D604D804DA04DC04DE04E004E204E404E604E804EA04EC04EE04F004F204F404F604F804FA04FC04FE05000502050405060508050A050C050E05100512051405160518051A051C051E0520052205240531-055610A0-10C51E001E021E041E061E081E0A1E0C1E0E1E101E121E141E161E181E1A1E1C1E1E1E201E221E241E261E281E2A1E2C1E2E1E301E321E341E361E381E3A1E3C1E3E1E401E421E441E461E481E4A1E4C1E4E1E501E521E541E561E581E5A1E5C1E5E1E601E621E641E661E681E6A1E6C1E6E1E701E721E741E761E781E7A1E7C1E7E1E801E821E841E861E881E8A1E8C1E8E1E901E921E941E9E1EA01EA21EA41EA61EA81EAA1EAC1EAE1EB01EB21EB41EB61EB81EBA1EBC1EBE1EC01EC21EC41EC61EC81ECA1ECC1ECE1ED01ED21ED41ED61ED81EDA1EDC1EDE1EE01EE21EE41EE61EE81EEA1EEC1EEE1EF01EF21EF41EF61EF81EFA1EFC1EFE1F08-1F0F1F18-1F1D1F28-1F2F1F38-1F3F1F48-1F4D1F591F5B1F5D1F5F1F68-1F6F1FB8-1FBB1FC8-1FCB1FD8-1FDB1FE8-1FEC1FF8-1FFB21022107210B-210D2110-211221152119-211D212421262128212A-212D2130-2133213E213F214521832C00-2C2E2C602C62-2C642C672C692C6B2C6D-2C702C722C752C7E-2C802C822C842C862C882C8A2C8C2C8E2C902C922C942C962C982C9A2C9C2C9E2CA02CA22CA42CA62CA82CAA2CAC2CAE2CB02CB22CB42CB62CB82CBA2CBC2CBE2CC02CC22CC42CC62CC82CCA2CCC2CCE2CD02CD22CD42CD62CD82CDA2CDC2CDE2CE02CE22CEB2CEDA640A642A644A646A648A64AA64CA64EA650A652A654A656A658A65AA65CA65EA662A664A666A668A66AA66CA680A682A684A686A688A68AA68CA68EA690A692A694A696A722A724A726A728A72AA72CA72EA732A734A736A738A73AA73CA73EA740A742A744A746A748A74AA74CA74EA750A752A754A756A758A75AA75CA75EA760A762A764A766A768A76AA76CA76EA779A77BA77DA77EA780A782A784A786A78BFF21-FF3A",Lt:"01C501C801CB01F21F88-1F8F1F98-1F9F1FA8-1FAF1FBC1FCC1FFC",Lm:"02B0-02C102C6-02D102E0-02E402EC02EE0374037A0559064006E506E607F407F507FA081A0824082809710E460EC610FC17D718431AA71C78-1C7D1D2C-1D611D781D9B-1DBF2071207F2090-20942C7D2D6F2E2F30053031-3035303B309D309E30FC-30FEA015A4F8-A4FDA60CA67FA717-A71FA770A788A9CFAA70AADDFF70FF9EFF9F",Lo:"01BB01C0-01C3029405D0-05EA05F0-05F20621-063F0641-064A066E066F0671-06D306D506EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA0800-08150904-0939093D09500958-096109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E450E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10D0-10FA1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317DC1820-18421844-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C771CE9-1CEC1CEE-1CF12135-21382D30-2D652D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE3006303C3041-3096309F30A1-30FA30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A014A016-A48CA4D0-A4F7A500-A60BA610-A61FA62AA62BA66EA6A0-A6E5A7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2AA00-AA28AA40-AA42AA44-AA4BAA60-AA6FAA71-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADBAADCABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF66-FF6FFF71-FF9DFFA0-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",M:"0300-036F0483-04890591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DE-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0903093C093E-094E0951-0955096209630981-098309BC09BE-09C409C709C809CB-09CD09D709E209E30A01-0A030A3C0A3E-0A420A470A480A4B-0A4D0A510A700A710A750A81-0A830ABC0ABE-0AC50AC7-0AC90ACB-0ACD0AE20AE30B01-0B030B3C0B3E-0B440B470B480B4B-0B4D0B560B570B620B630B820BBE-0BC20BC6-0BC80BCA-0BCD0BD70C01-0C030C3E-0C440C46-0C480C4A-0C4D0C550C560C620C630C820C830CBC0CBE-0CC40CC6-0CC80CCA-0CCD0CD50CD60CE20CE30D020D030D3E-0D440D46-0D480D4A-0D4D0D570D620D630D820D830DCA0DCF-0DD40DD60DD8-0DDF0DF20DF30E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F3E0F3F0F71-0F840F860F870F90-0F970F99-0FBC0FC6102B-103E1056-1059105E-10601062-10641067-106D1071-10741082-108D108F109A-109D135F1712-17141732-1734175217531772177317B6-17D317DD180B-180D18A91920-192B1930-193B19B0-19C019C819C91A17-1A1B1A55-1A5E1A60-1A7C1A7F1B00-1B041B34-1B441B6B-1B731B80-1B821BA1-1BAA1C24-1C371CD0-1CD21CD4-1CE81CED1CF21DC0-1DE61DFD-1DFF20D0-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66F-A672A67CA67DA6F0A6F1A802A806A80BA823-A827A880A881A8B4-A8C4A8E0-A8F1A926-A92DA947-A953A980-A983A9B3-A9C0AA29-AA36AA43AA4CAA4DAA7BAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE3-ABEAABECABEDFB1EFE00-FE0FFE20-FE26",Mn:"0300-036F0483-04870591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DF-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0902093C0941-0948094D0951-095509620963098109BC09C1-09C409CD09E209E30A010A020A3C0A410A420A470A480A4B-0A4D0A510A700A710A750A810A820ABC0AC1-0AC50AC70AC80ACD0AE20AE30B010B3C0B3F0B41-0B440B4D0B560B620B630B820BC00BCD0C3E-0C400C46-0C480C4A-0C4D0C550C560C620C630CBC0CBF0CC60CCC0CCD0CE20CE30D41-0D440D4D0D620D630DCA0DD2-0DD40DD60E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F71-0F7E0F80-0F840F860F870F90-0F970F99-0FBC0FC6102D-10301032-10371039103A103D103E10581059105E-10601071-1074108210851086108D109D135F1712-17141732-1734175217531772177317B7-17BD17C617C9-17D317DD180B-180D18A91920-19221927192819321939-193B1A171A181A561A58-1A5E1A601A621A65-1A6C1A73-1A7C1A7F1B00-1B031B341B36-1B3A1B3C1B421B6B-1B731B801B811BA2-1BA51BA81BA91C2C-1C331C361C371CD0-1CD21CD4-1CE01CE2-1CE81CED1DC0-1DE61DFD-1DFF20D0-20DC20E120E5-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66FA67CA67DA6F0A6F1A802A806A80BA825A826A8C4A8E0-A8F1A926-A92DA947-A951A980-A982A9B3A9B6-A9B9A9BCAA29-AA2EAA31AA32AA35AA36AA43AA4CAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE5ABE8ABEDFB1EFE00-FE0FFE20-FE26",Mc:"0903093E-09400949-094C094E0982098309BE-09C009C709C809CB09CC09D70A030A3E-0A400A830ABE-0AC00AC90ACB0ACC0B020B030B3E0B400B470B480B4B0B4C0B570BBE0BBF0BC10BC20BC6-0BC80BCA-0BCC0BD70C01-0C030C41-0C440C820C830CBE0CC0-0CC40CC70CC80CCA0CCB0CD50CD60D020D030D3E-0D400D46-0D480D4A-0D4C0D570D820D830DCF-0DD10DD8-0DDF0DF20DF30F3E0F3F0F7F102B102C10311038103B103C105610571062-10641067-106D108310841087-108C108F109A-109C17B617BE-17C517C717C81923-19261929-192B193019311933-193819B0-19C019C819C91A19-1A1B1A551A571A611A631A641A6D-1A721B041B351B3B1B3D-1B411B431B441B821BA11BA61BA71BAA1C24-1C2B1C341C351CE11CF2A823A824A827A880A881A8B4-A8C3A952A953A983A9B4A9B5A9BAA9BBA9BD-A9C0AA2FAA30AA33AA34AA4DAA7BABE3ABE4ABE6ABE7ABE9ABEAABEC",Me:"0488048906DE20DD-20E020E2-20E4A670-A672",N:"0030-003900B200B300B900BC-00BE0660-066906F0-06F907C0-07C90966-096F09E6-09EF09F4-09F90A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BF20C66-0C6F0C78-0C7E0CE6-0CEF0D66-0D750E50-0E590ED0-0ED90F20-0F331040-10491090-10991369-137C16EE-16F017E0-17E917F0-17F91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C5920702074-20792080-20892150-21822185-21892460-249B24EA-24FF2776-27932CFD30073021-30293038-303A3192-31953220-32293251-325F3280-328932B1-32BFA620-A629A6E6-A6EFA830-A835A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",Nd:"0030-00390660-066906F0-06F907C0-07C90966-096F09E6-09EF0A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BEF0C66-0C6F0CE6-0CEF0D66-0D6F0E50-0E590ED0-0ED90F20-0F291040-10491090-109917E0-17E91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C59A620-A629A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",Nl:"16EE-16F02160-21822185-218830073021-30293038-303AA6E6-A6EF",No:"00B200B300B900BC-00BE09F4-09F90BF0-0BF20C78-0C7E0D70-0D750F2A-0F331369-137C17F0-17F920702074-20792080-20892150-215F21892460-249B24EA-24FF2776-27932CFD3192-31953220-32293251-325F3280-328932B1-32BFA830-A835",P:"0021-00230025-002A002C-002F003A003B003F0040005B-005D005F007B007D00A100AB00B700BB00BF037E0387055A-055F0589058A05BE05C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F3A-0F3D0F850FD0-0FD4104A-104F10FB1361-13681400166D166E169B169C16EB-16ED1735173617D4-17D617D8-17DA1800-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD32010-20272030-20432045-20512053-205E207D207E208D208E2329232A2768-277527C527C627E6-27EF2983-299829D8-29DB29FC29FD2CF9-2CFC2CFE2CFF2E00-2E2E2E302E313001-30033008-30113014-301F3030303D30A030FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFD3EFD3FFE10-FE19FE30-FE52FE54-FE61FE63FE68FE6AFE6BFF01-FF03FF05-FF0AFF0C-FF0FFF1AFF1BFF1FFF20FF3B-FF3DFF3FFF5BFF5DFF5F-FF65",Pd:"002D058A05BE140018062010-20152E172E1A301C303030A0FE31FE32FE58FE63FF0D",Ps:"0028005B007B0F3A0F3C169B201A201E2045207D208D23292768276A276C276E27702772277427C527E627E827EA27EC27EE2983298529872989298B298D298F299129932995299729D829DA29FC2E222E242E262E283008300A300C300E3010301430163018301A301DFD3EFE17FE35FE37FE39FE3BFE3DFE3FFE41FE43FE47FE59FE5BFE5DFF08FF3BFF5BFF5FFF62",Pe:"0029005D007D0F3B0F3D169C2046207E208E232A2769276B276D276F27712773277527C627E727E927EB27ED27EF298429862988298A298C298E2990299229942996299829D929DB29FD2E232E252E272E293009300B300D300F3011301530173019301B301E301FFD3FFE18FE36FE38FE3AFE3CFE3EFE40FE42FE44FE48FE5AFE5CFE5EFF09FF3DFF5DFF60FF63",Pi:"00AB2018201B201C201F20392E022E042E092E0C2E1C2E20",Pf:"00BB2019201D203A2E032E052E0A2E0D2E1D2E21",Pc:"005F203F20402054FE33FE34FE4D-FE4FFF3F",Po:"0021-00230025-0027002A002C002E002F003A003B003F0040005C00A100B700BF037E0387055A-055F058905C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F850FD0-0FD4104A-104F10FB1361-1368166D166E16EB-16ED1735173617D4-17D617D8-17DA1800-18051807-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD3201620172020-20272030-2038203B-203E2041-20432047-205120532055-205E2CF9-2CFC2CFE2CFF2E002E012E06-2E082E0B2E0E-2E162E182E192E1B2E1E2E1F2E2A-2E2E2E302E313001-3003303D30FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFE10-FE16FE19FE30FE45FE46FE49-FE4CFE50-FE52FE54-FE57FE5F-FE61FE68FE6AFE6BFF01-FF03FF05-FF07FF0AFF0CFF0EFF0FFF1AFF1BFF1FFF20FF3CFF61FF64FF65",S:"0024002B003C-003E005E0060007C007E00A2-00A900AC00AE-00B100B400B600B800D700F702C2-02C502D2-02DF02E5-02EB02ED02EF-02FF03750384038503F604820606-0608060B060E060F06E906FD06FE07F609F209F309FA09FB0AF10B700BF3-0BFA0C7F0CF10CF20D790E3F0F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-139917DB194019E0-19FF1B61-1B6A1B74-1B7C1FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE20442052207A-207C208A-208C20A0-20B8210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B2140-2144214A-214D214F2190-2328232B-23E82400-24262440-244A249C-24E92500-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE27C0-27C427C7-27CA27CC27D0-27E527F0-29822999-29D729DC-29FB29FE-2B4C2B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F309B309C319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A700-A716A720A721A789A78AA828-A82BA836-A839AA77-AA79FB29FDFCFDFDFE62FE64-FE66FE69FF04FF0BFF1C-FF1EFF3EFF40FF5CFF5EFFE0-FFE6FFE8-FFEEFFFCFFFD",Sm:"002B003C-003E007C007E00AC00B100D700F703F60606-060820442052207A-207C208A-208C2140-2144214B2190-2194219A219B21A021A321A621AE21CE21CF21D221D421F4-22FF2308-230B23202321237C239B-23B323DC-23E125B725C125F8-25FF266F27C0-27C427C7-27CA27CC27D0-27E527F0-27FF2900-29822999-29D729DC-29FB29FE-2AFF2B30-2B442B47-2B4CFB29FE62FE64-FE66FF0BFF1C-FF1EFF5CFF5EFFE2FFE9-FFEC",Sc:"002400A2-00A5060B09F209F309FB0AF10BF90E3F17DB20A0-20B8A838FDFCFE69FF04FFE0FFE1FFE5FFE6",Sk:"005E006000A800AF00B400B802C2-02C502D2-02DF02E5-02EB02ED02EF-02FF0375038403851FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE309B309CA700-A716A720A721A789A78AFF3EFF40FFE3",So:"00A600A700A900AE00B000B60482060E060F06E906FD06FE07F609FA0B700BF3-0BF80BFA0C7F0CF10CF20D790F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-1399194019E0-19FF1B61-1B6A1B74-1B7C210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B214A214C214D214F2195-2199219C-219F21A121A221A421A521A7-21AD21AF-21CD21D021D121D321D5-21F32300-2307230C-231F2322-2328232B-237B237D-239A23B4-23DB23E2-23E82400-24262440-244A249C-24E92500-25B625B8-25C025C2-25F72600-266E2670-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE2800-28FF2B00-2B2F2B452B462B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A828-A82BA836A837A839AA77-AA79FDFDFFE4FFE8FFEDFFEEFFFCFFFD",Z:"002000A01680180E2000-200A20282029202F205F3000",Zs:"002000A01680180E2000-200A202F205F3000",Zl:"2028",Zp:"2029",C:"0000-001F007F-009F00AD03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-0605061C061D0620065F06DD070E070F074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17B417B517DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF200B-200F202A-202E2060-206F20722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-F8FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFD-FF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFFBFFFEFFFF",
	Cc:"0000-001F007F-009F",Cf:"00AD0600-060306DD070F17B417B5200B-200F202A-202E2060-2064206A-206FFEFFFFF9-FFFB",Co:"E000-F8FF",Cs:"D800-DFFF",Cn:"03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-05FF06040605061C061D0620065F070E074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF2065-206920722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-D7FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFDFEFEFF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFF8FFFEFFFF"})}),ace.define("ace/token_iterator",["require","exports","module"],function(e,t,i){"use strict";var n=function(e,t,i){this.$session=e,this.$row=t,this.$rowTokens=e.getTokens(t);var n=e.getTokenAt(t,i);this.$tokenIndex=n?n.index:-1};(function(){this.stepBackward=function(){for(this.$tokenIndex-=1;this.$tokenIndex<0;){if(this.$row-=1,this.$row<0)return this.$row=0,null;this.$rowTokens=this.$session.getTokens(this.$row),this.$tokenIndex=this.$rowTokens.length-1}return this.$rowTokens[this.$tokenIndex]},this.stepForward=function(){this.$tokenIndex+=1;for(var e;this.$tokenIndex>=this.$rowTokens.length;){if(this.$row+=1,e||(e=this.$session.getLength()),this.$row>=e)return this.$row=e-1,null;this.$rowTokens=this.$session.getTokens(this.$row),this.$tokenIndex=0}return this.$rowTokens[this.$tokenIndex]},this.getCurrentToken=function(){return this.$rowTokens[this.$tokenIndex]},this.getCurrentTokenRow=function(){return this.$row},this.getCurrentTokenColumn=function(){var e=this.$rowTokens,t=this.$tokenIndex,i=e[t].start;if(void 0!==i)return i;for(i=0;t>0;)t-=1,i+=e[t].value.length;return i},this.getCurrentTokenPosition=function(){return{row:this.$row,column:this.getCurrentTokenColumn()}}}).call(n.prototype),t.TokenIterator=n}),ace.define("ace/mode/text",["require","exports","module","ace/tokenizer","ace/mode/text_highlight_rules","ace/mode/behaviour","ace/unicode","ace/lib/lang","ace/token_iterator","ace/range"],function(e,t,i){"use strict";var n=e("../tokenizer").Tokenizer,r=e("./text_highlight_rules").TextHighlightRules,o=e("./behaviour").Behaviour,s=e("../unicode"),a=e("../lib/lang"),l=e("../token_iterator").TokenIterator,c=e("../range").Range,h=function(){this.HighlightRules=r,this.$behaviour=new o};(function(){this.tokenRe=new RegExp("^["+s.packages.L+s.packages.Mn+s.packages.Mc+s.packages.Nd+s.packages.Pc+"\\$_]+","g"),this.nonTokenRe=new RegExp("^(?:[^"+s.packages.L+s.packages.Mn+s.packages.Mc+s.packages.Nd+s.packages.Pc+"\\$_]|\\s])+","g"),this.getTokenizer=function(){return this.$tokenizer||(this.$highlightRules=this.$highlightRules||new this.HighlightRules,this.$tokenizer=new n(this.$highlightRules.getRules())),this.$tokenizer},this.lineCommentStart="",this.blockComment="",this.toggleCommentLines=function(e,t,i,n){function r(e){for(var t=i;t<=n;t++)e(o.getLine(t),t)}var o=t.doc,s=!0,l=!0,c=1/0,h=t.getTabSize(),d=!1;if(this.lineCommentStart){if(Array.isArray(this.lineCommentStart))var u=this.lineCommentStart.map(a.escapeRegExp).join("|"),f=this.lineCommentStart[0];else var u=a.escapeRegExp(this.lineCommentStart),f=this.lineCommentStart;u=new RegExp("^(\\s*)(?:"+u+") ?"),d=t.getUseSoftTabs();var p=function(e,t){var i=e.match(u);if(i){var n=i[1].length,r=i[0].length;y(e,n,r)||" "!=i[0][r-1]||r--,o.removeInLine(t,n,r)}},m=f+" ",g=function(e,t){s&&!/\S/.test(e)||(y(e,c,c)?o.insertInLine({row:t,column:c},m):o.insertInLine({row:t,column:c},f))},v=function(e,t){return u.test(e)},y=function(e,t,i){for(var n=0;t--&&" "==e.charAt(t);)n++;if(n%h!=0)return!1;for(var n=0;" "==e.charAt(i++);)n++;return h>2?n%h!=h-1:n%h==0}}else{if(!this.blockComment)return!1;var f=this.blockComment.start,w=this.blockComment.end,u=new RegExp("^(\\s*)(?:"+a.escapeRegExp(f)+")"),b=new RegExp("(?:"+a.escapeRegExp(w)+")\\s*$"),g=function(e,t){v(e,t)||s&&!/\S/.test(e)||(o.insertInLine({row:t,column:e.length},w),o.insertInLine({row:t,column:c},f))},p=function(e,t){var i;(i=e.match(b))&&o.removeInLine(t,e.length-i[0].length,e.length),(i=e.match(u))&&o.removeInLine(t,i[1].length,i[0].length)},v=function(e,i){if(u.test(e))return!0;for(var n=t.getTokens(i),r=0;r<n.length;r++)if("comment"===n[r].type)return!0}}var A=1/0;r(function(e,t){var i=e.search(/\S/);i!==-1?(i<c&&(c=i),l&&!v(e,t)&&(l=!1)):A>e.length&&(A=e.length)}),c==1/0&&(c=A,s=!1,l=!1),d&&c%h!=0&&(c=Math.floor(c/h)*h),r(l?p:g)},this.toggleBlockComment=function(e,t,i,n){var r=this.blockComment;if(r){!r.start&&r[0]&&(r=r[0]);var o,s,a=new l(t,n.row,n.column),h=a.getCurrentToken(),d=(t.selection,t.selection.toOrientedRange());if(h&&/comment/.test(h.type)){for(var u,f;h&&/comment/.test(h.type);){var p=h.value.indexOf(r.start);if(p!=-1){var m=a.getCurrentTokenRow(),g=a.getCurrentTokenColumn()+p;u=new c(m,g,m,g+r.start.length);break}h=a.stepBackward()}for(var a=new l(t,n.row,n.column),h=a.getCurrentToken();h&&/comment/.test(h.type);){var p=h.value.indexOf(r.end);if(p!=-1){var m=a.getCurrentTokenRow(),g=a.getCurrentTokenColumn()+p;f=new c(m,g,m,g+r.end.length);break}h=a.stepForward()}f&&t.remove(f),u&&(t.remove(u),o=u.start.row,s=-r.start.length)}else s=r.start.length,o=i.start.row,t.insert(i.end,r.end),t.insert(i.start,r.start);d.start.row==o&&(d.start.column+=s),d.end.row==o&&(d.end.column+=s),t.selection.fromOrientedRange(d)}},this.getNextLineIndent=function(e,t,i){return this.$getIndent(t)},this.checkOutdent=function(e,t,i){return!1},this.autoOutdent=function(e,t,i){},this.$getIndent=function(e){return e.match(/^\s*/)[0]},this.createWorker=function(e){return null},this.createModeDelegates=function(e){this.$embeds=[],this.$modes={};for(var t in e)e[t]&&(this.$embeds.push(t),this.$modes[t]=new e[t]);for(var i=["toggleBlockComment","toggleCommentLines","getNextLineIndent","checkOutdent","autoOutdent","transformAction","getCompletions"],t=0;t<i.length;t++)!function(e){var n=i[t],r=e[n];e[i[t]]=function(){return this.$delegator(n,arguments,r)}}(this)},this.$delegator=function(e,t,i){var n=t[0];"string"!=typeof n&&(n=n[0]);for(var r=0;r<this.$embeds.length;r++)if(this.$modes[this.$embeds[r]]){var o=n.split(this.$embeds[r]);if(!o[0]&&o[1]){t[0]=o[1];var s=this.$modes[this.$embeds[r]];return s[e].apply(s,t)}}var a=i.apply(this,t);return i?a:void 0},this.transformAction=function(e,t,i,n,r){if(this.$behaviour){var o=this.$behaviour.getBehaviours();for(var s in o)if(o[s][t]){var a=o[s][t].apply(this,arguments);if(a)return a}}},this.getKeywords=function(e){if(!this.completionKeywords){var t=this.$tokenizer.rules,i=[];for(var n in t)for(var r=t[n],o=0,s=r.length;o<s;o++)if("string"==typeof r[o].token)/keyword|support|storage/.test(r[o].token)&&i.push(r[o].regex);else if("object"==typeof r[o].token)for(var a=0,l=r[o].token.length;a<l;a++)if(/keyword|support|storage/.test(r[o].token[a])){var n=r[o].regex.match(/\(.+?\)/g)[a];i.push(n.substr(1,n.length-2))}this.completionKeywords=i}return e?i.concat(this.$keywordList||[]):this.$keywordList},this.$createKeywordList=function(){return this.$highlightRules||this.getTokenizer(),this.$keywordList=this.$highlightRules.$keywordList||[]},this.getCompletions=function(e,t,i,n){var r=this.$keywordList||this.$createKeywordList();return r.map(function(e){return{name:e,value:e,score:0,meta:"keyword"}})},this.$id="ace/mode/text"}).call(h.prototype),t.Mode=h}),ace.define("ace/apply_delta",["require","exports","module"],function(e,t,i){"use strict";t.applyDelta=function(e,t,i){var n=t.start.row,r=t.start.column,o=e[n]||"";switch(t.action){case"insert":var s=t.lines;if(1===s.length)e[n]=o.substring(0,r)+t.lines[0]+o.substring(r);else{var a=[n,1].concat(t.lines);e.splice.apply(e,a),e[n]=o.substring(0,r)+e[n],e[n+t.lines.length-1]+=o.substring(r)}break;case"remove":var l=t.end.column,c=t.end.row;n===c?e[n]=o.substring(0,r)+o.substring(l):e.splice(n,c-n+1,o.substring(0,r)+e[c].substring(l))}}}),ace.define("ace/anchor",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,i){"use strict";var n=e("./lib/oop"),r=e("./lib/event_emitter").EventEmitter,o=t.Anchor=function(e,t,i){this.$onChange=this.onChange.bind(this),this.attach(e),"undefined"==typeof i?this.setPosition(t.row,t.column):this.setPosition(t,i)};(function(){function e(e,t,i){var n=i?e.column<=t.column:e.column<t.column;return e.row<t.row||e.row==t.row&&n}function t(t,i,n){var r="insert"==t.action,o=(r?1:-1)*(t.end.row-t.start.row),s=(r?1:-1)*(t.end.column-t.start.column),a=t.start,l=r?a:t.end;return e(i,a,n)?{row:i.row,column:i.column}:e(l,i,!n)?{row:i.row+o,column:i.column+(i.row==l.row?s:0)}:{row:a.row,column:a.column}}n.implement(this,r),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(e){if(!(e.start.row==e.end.row&&e.start.row!=this.row||e.start.row>this.row)){var i=t(e,{row:this.row,column:this.column},this.$insertRight);this.setPosition(i.row,i.column,!0)}},this.setPosition=function(e,t,i){var n;if(n=i?{row:e,column:t}:this.$clipPositionToDocument(e,t),this.row!=n.row||this.column!=n.column){var r={row:this.row,column:this.column};this.row=n.row,this.column=n.column,this._signal("change",{old:r,value:n})}},this.detach=function(){this.document.removeEventListener("change",this.$onChange)},this.attach=function(e){this.document=e||this.document,this.document.on("change",this.$onChange)},this.$clipPositionToDocument=function(e,t){var i={};return e>=this.document.getLength()?(i.row=Math.max(0,this.document.getLength()-1),i.column=this.document.getLine(i.row).length):e<0?(i.row=0,i.column=0):(i.row=e,i.column=Math.min(this.document.getLine(i.row).length,Math.max(0,t))),t<0&&(i.column=0),i}}).call(o.prototype)}),ace.define("ace/document",["require","exports","module","ace/lib/oop","ace/apply_delta","ace/lib/event_emitter","ace/range","ace/anchor"],function(e,t,i){"use strict";var n=e("./lib/oop"),r=e("./apply_delta").applyDelta,o=e("./lib/event_emitter").EventEmitter,s=e("./range").Range,a=e("./anchor").Anchor,l=function(e){this.$lines=[""],0===e.length?this.$lines=[""]:Array.isArray(e)?this.insertMergedLines({row:0,column:0},e):this.insert({row:0,column:0},e)};(function(){n.implement(this,o),this.setValue=function(e){var t=this.getLength()-1;this.remove(new s(0,0,t,this.getLine(t).length)),this.insert({row:0,column:0},e)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(e,t){return new a(this,e,t)},0==="aaa".split(/a/).length?this.$split=function(e){return e.replace(/\r\n|\r/g,"\n").split("\n")}:this.$split=function(e){return e.split(/\r\n|\r|\n/)},this.$detectNewLine=function(e){var t=e.match(/^.*?(\r\n|\r|\n)/m);this.$autoNewLine=t?t[1]:"\n",this._signal("changeNewLineMode")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case"windows":return"\r\n";case"unix":return"\n";default:return this.$autoNewLine||"\n"}},this.$autoNewLine="",this.$newLineMode="auto",this.setNewLineMode=function(e){this.$newLineMode!==e&&(this.$newLineMode=e,this._signal("changeNewLineMode"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(e){return"\r\n"==e||"\r"==e||"\n"==e},this.getLine=function(e){return this.$lines[e]||""},this.getLines=function(e,t){return this.$lines.slice(e,t+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(e){return this.getLinesForRange(e).join(this.getNewLineCharacter())},this.getLinesForRange=function(e){var t;if(e.start.row===e.end.row)t=[this.getLine(e.start.row).substring(e.start.column,e.end.column)];else{t=this.getLines(e.start.row,e.end.row),t[0]=(t[0]||"").substring(e.start.column);var i=t.length-1;e.end.row-e.start.row==i&&(t[i]=t[i].substring(0,e.end.column))}return t},this.insertLines=function(e,t){return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."),this.insertFullLines(e,t)},this.removeLines=function(e,t){return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."),this.removeFullLines(e,t)},this.insertNewLine=function(e){return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead."),this.insertMergedLines(e,["",""])},this.insert=function(e,t){return this.getLength()<=1&&this.$detectNewLine(t),this.insertMergedLines(e,this.$split(t))},this.insertInLine=function(e,t){var i=this.clippedPos(e.row,e.column),n=this.pos(e.row,e.column+t.length);return this.applyDelta({start:i,end:n,action:"insert",lines:[t]},!0),this.clonePos(n)},this.clippedPos=function(e,t){var i=this.getLength();void 0===e?e=i:e<0?e=0:e>=i&&(e=i-1,t=void 0);var n=this.getLine(e);return void 0==t&&(t=n.length),t=Math.min(Math.max(t,0),n.length),{row:e,column:t}},this.clonePos=function(e){return{row:e.row,column:e.column}},this.pos=function(e,t){return{row:e,column:t}},this.$clipPosition=function(e){var t=this.getLength();return e.row>=t?(e.row=Math.max(0,t-1),e.column=this.getLine(t-1).length):(e.row=Math.max(0,e.row),e.column=Math.min(Math.max(e.column,0),this.getLine(e.row).length)),e},this.insertFullLines=function(e,t){e=Math.min(Math.max(e,0),this.getLength());var i=0;e<this.getLength()?(t=t.concat([""]),i=0):(t=[""].concat(t),e--,i=this.$lines[e].length),this.insertMergedLines({row:e,column:i},t)},this.insertMergedLines=function(e,t){var i=this.clippedPos(e.row,e.column),n={row:i.row+t.length-1,column:(1==t.length?i.column:0)+t[t.length-1].length};return this.applyDelta({start:i,end:n,action:"insert",lines:t}),this.clonePos(n)},this.remove=function(e){var t=this.clippedPos(e.start.row,e.start.column),i=this.clippedPos(e.end.row,e.end.column);return this.applyDelta({start:t,end:i,action:"remove",lines:this.getLinesForRange({start:t,end:i})}),this.clonePos(t)},this.removeInLine=function(e,t,i){var n=this.clippedPos(e,t),r=this.clippedPos(e,i);return this.applyDelta({start:n,end:r,action:"remove",lines:this.getLinesForRange({start:n,end:r})},!0),this.clonePos(n)},this.removeFullLines=function(e,t){e=Math.min(Math.max(0,e),this.getLength()-1),t=Math.min(Math.max(0,t),this.getLength()-1);var i=t==this.getLength()-1&&e>0,n=t<this.getLength()-1,r=i?e-1:e,o=i?this.getLine(r).length:0,a=n?t+1:t,l=n?0:this.getLine(a).length,c=new s(r,o,a,l),h=this.$lines.slice(e,t+1);return this.applyDelta({start:c.start,end:c.end,action:"remove",lines:this.getLinesForRange(c)}),h},this.removeNewLine=function(e){e<this.getLength()-1&&e>=0&&this.applyDelta({start:this.pos(e,this.getLine(e).length),end:this.pos(e+1,0),action:"remove",lines:["",""]})},this.replace=function(e,t){if(e instanceof s||(e=s.fromPoints(e.start,e.end)),0===t.length&&e.isEmpty())return e.start;if(t==this.getTextRange(e))return e.end;this.remove(e);var i;return i=t?this.insert(e.start,t):e.start},this.applyDeltas=function(e){for(var t=0;t<e.length;t++)this.applyDelta(e[t])},this.revertDeltas=function(e){for(var t=e.length-1;t>=0;t--)this.revertDelta(e[t])},this.applyDelta=function(e,t){var i="insert"==e.action;(i?e.lines.length<=1&&!e.lines[0]:!s.comparePoints(e.start,e.end))||(i&&e.lines.length>2e4&&this.$splitAndapplyLargeDelta(e,2e4),r(this.$lines,e,t),this._signal("change",e))},this.$splitAndapplyLargeDelta=function(e,t){for(var i=e.lines,n=i.length,r=e.start.row,o=e.start.column,s=0,a=0;;){s=a,a+=t-1;var l=i.slice(s,a);if(a>n){e.lines=l,e.start.row=r+s,e.start.column=o;break}l.push(""),this.applyDelta({start:this.pos(r+s,o),end:this.pos(r+a,o=0),action:e.action,lines:l},!0)}},this.revertDelta=function(e){this.applyDelta({start:this.clonePos(e.start),end:this.clonePos(e.end),action:"insert"==e.action?"remove":"insert",lines:e.lines.slice()})},this.indexToPosition=function(e,t){for(var i=this.$lines||this.getAllLines(),n=this.getNewLineCharacter().length,r=t||0,o=i.length;r<o;r++)if(e-=i[r].length+n,e<0)return{row:r,column:e+i[r].length+n};return{row:o-1,column:i[o-1].length}},this.positionToIndex=function(e,t){for(var i=this.$lines||this.getAllLines(),n=this.getNewLineCharacter().length,r=0,o=Math.min(e.row,i.length),s=t||0;s<o;++s)r+=i[s].length+n;return r+e.column}}).call(l.prototype),t.Document=l}),ace.define("ace/background_tokenizer",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,i){"use strict";var n=e("./lib/oop"),r=e("./lib/event_emitter").EventEmitter,o=function(e,t){this.running=!1,this.lines=[],this.states=[],this.currentLine=0,this.tokenizer=e;var i=this;this.$worker=function(){if(i.running){for(var e=new Date,t=i.currentLine,n=-1,r=i.doc,o=t;i.lines[t];)t++;var s=r.getLength(),a=0;for(i.running=!1;t<s;){i.$tokenizeRow(t),n=t;do t++;while(i.lines[t]);if(a++,a%5===0&&new Date-e>20){i.running=setTimeout(i.$worker,20);break}}i.currentLine=t,o<=n&&i.fireUpdateEvent(o,n)}}};(function(){n.implement(this,r),this.setTokenizer=function(e){this.tokenizer=e,this.lines=[],this.states=[],this.start(0)},this.setDocument=function(e){this.doc=e,this.lines=[],this.states=[],this.stop()},this.fireUpdateEvent=function(e,t){var i={first:e,last:t};this._signal("update",{data:i})},this.start=function(e){this.currentLine=Math.min(e||0,this.currentLine,this.doc.getLength()),this.lines.splice(this.currentLine,this.lines.length),this.states.splice(this.currentLine,this.states.length),this.stop(),this.running=setTimeout(this.$worker,700)},this.scheduleStart=function(){this.running||(this.running=setTimeout(this.$worker,700))},this.$updateOnChange=function(e){var t=e.start.row,i=e.end.row-t;if(0===i)this.lines[t]=null;else if("remove"==e.action)this.lines.splice(t,i+1,null),this.states.splice(t,i+1,null);else{var n=Array(i+1);n.unshift(t,1),this.lines.splice.apply(this.lines,n),this.states.splice.apply(this.states,n)}this.currentLine=Math.min(t,this.currentLine,this.doc.getLength()),this.stop()},this.stop=function(){this.running&&clearTimeout(this.running),this.running=!1},this.getTokens=function(e){return this.lines[e]||this.$tokenizeRow(e)},this.getState=function(e){return this.currentLine==e&&this.$tokenizeRow(e),this.states[e]||"start"},this.$tokenizeRow=function(e){var t=this.doc.getLine(e),i=this.states[e-1],n=this.tokenizer.getLineTokens(t,i,e);return this.states[e]+""!=n.state+""?(this.states[e]=n.state,this.lines[e+1]=null,this.currentLine>e+1&&(this.currentLine=e+1)):this.currentLine==e&&(this.currentLine=e+1),this.lines[e]=n.tokens}}).call(o.prototype),t.BackgroundTokenizer=o}),ace.define("ace/search_highlight",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"],function(e,t,i){"use strict";var n=e("./lib/lang"),r=(e("./lib/oop"),e("./range").Range),o=function(e,t,i){this.setRegexp(e),this.clazz=t,this.type=i||"text"};(function(){this.MAX_RANGES=500,this.setRegexp=function(e){this.regExp+""!=e+""&&(this.regExp=e,this.cache=[])},this.update=function(e,t,i,o){if(this.regExp)for(var s=o.firstRow,a=o.lastRow,l=s;l<=a;l++){var c=this.cache[l];null==c&&(c=n.getMatchOffsets(i.getLine(l),this.regExp),c.length>this.MAX_RANGES&&(c=c.slice(0,this.MAX_RANGES)),c=c.map(function(e){return new r(l,e.offset,l,e.offset+e.length)}),this.cache[l]=c.length?c:"");for(var h=c.length;h--;)t.drawSingleLineMarker(e,c[h].toScreenRange(i),this.clazz,o)}}}).call(o.prototype),t.SearchHighlight=o}),ace.define("ace/edit_session/fold_line",["require","exports","module","ace/range"],function(e,t,i){"use strict";function n(e,t){this.foldData=e,Array.isArray(t)?this.folds=t:t=this.folds=[t];var i=t[t.length-1];this.range=new r(t[0].start.row,t[0].start.column,i.end.row,i.end.column),this.start=this.range.start,this.end=this.range.end,this.folds.forEach(function(e){e.setFoldLine(this)},this)}var r=e("../range").Range;(function(){this.shiftRow=function(e){this.start.row+=e,this.end.row+=e,this.folds.forEach(function(t){t.start.row+=e,t.end.row+=e})},this.addFold=function(e){if(e.sameRow){if(e.start.row<this.startRow||e.endRow>this.endRow)throw new Error("Can't add a fold to this FoldLine as it has no connection");this.folds.push(e),this.folds.sort(function(e,t){return-e.range.compareEnd(t.start.row,t.start.column)}),this.range.compareEnd(e.start.row,e.start.column)>0?(this.end.row=e.end.row,this.end.column=e.end.column):this.range.compareStart(e.end.row,e.end.column)<0&&(this.start.row=e.start.row,this.start.column=e.start.column)}else if(e.start.row==this.end.row)this.folds.push(e),this.end.row=e.end.row,this.end.column=e.end.column;else{if(e.end.row!=this.start.row)throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");this.folds.unshift(e),this.start.row=e.start.row,this.start.column=e.start.column}e.foldLine=this},this.containsRow=function(e){return e>=this.start.row&&e<=this.end.row},this.walk=function(e,t,i){var n,r,o,s=0,a=this.folds,l=!0;null==t&&(t=this.end.row,i=this.end.column);for(var c=0;c<a.length;c++){if(n=a[c],r=n.range.compareStart(t,i),r==-1)return void e(null,t,i,s,l);if(o=e(null,n.start.row,n.start.column,s,l),o=!o&&e(n.placeholder,n.start.row,n.start.column,s),o||0===r)return;l=!n.sameRow,s=n.end.column}e(null,t,i,s,l)},this.getNextFoldTo=function(e,t){for(var i,n,r=0;r<this.folds.length;r++){if(i=this.folds[r],n=i.range.compareEnd(e,t),n==-1)return{fold:i,kind:"after"};if(0===n)return{fold:i,kind:"inside"}}return null},this.addRemoveChars=function(e,t,i){var n,r,o=this.getNextFoldTo(e,t);if(o)if(n=o.fold,"inside"==o.kind&&n.start.column!=t&&n.start.row!=e)window.console&&window.console.log(e,t,n);else if(n.start.row==e){r=this.folds;var s=r.indexOf(n);for(0===s&&(this.start.column+=i),s;s<r.length;s++){if(n=r[s],n.start.column+=i,!n.sameRow)return;n.end.column+=i}this.end.column+=i}},this.split=function(e,t){var i=this.getNextFoldTo(e,t);if(!i||"inside"==i.kind)return null;var r=i.fold,o=this.folds,s=this.foldData,a=o.indexOf(r),l=o[a-1];this.end.row=l.end.row,this.end.column=l.end.column,o=o.splice(a,o.length-a);var c=new n(s,o);return s.splice(s.indexOf(this)+1,0,c),c},this.merge=function(e){for(var t=e.folds,i=0;i<t.length;i++)this.addFold(t[i]);var n=this.foldData;n.splice(n.indexOf(e),1)},this.toString=function(){var e=[this.range.toString()+": ["];return this.folds.forEach(function(t){e.push("  "+t.toString())}),e.push("]"),e.join("\n")},this.idxToPosition=function(e){for(var t=0,i=0;i<this.folds.length;i++){var n=this.folds[i];if(e-=n.start.column-t,e<0)return{row:n.start.row,column:n.start.column+e};if(e-=n.placeholder.length,e<0)return n.start;t=n.end.column}return{row:this.end.row,column:this.end.column+e}}}).call(n.prototype),t.FoldLine=n}),ace.define("ace/range_list",["require","exports","module","ace/range"],function(e,t,i){"use strict";var n=e("./range").Range,r=n.comparePoints,o=function(){this.ranges=[]};(function(){this.comparePoints=r,this.pointIndex=function(e,t,i){for(var n=this.ranges,o=i||0;o<n.length;o++){var s=n[o],a=r(e,s.end);if(!(a>0)){var l=r(e,s.start);return 0===a?t&&0!==l?-o-2:o:l>0||0===l&&!t?o:-o-1}}return-o-1},this.add=function(e){var t=!e.isEmpty(),i=this.pointIndex(e.start,t);i<0&&(i=-i-1);var n=this.pointIndex(e.end,t,i);return n<0?n=-n-1:n++,this.ranges.splice(i,n-i,e)},this.addList=function(e){for(var t=[],i=e.length;i--;)t.push.apply(t,this.add(e[i]));return t},this.substractPoint=function(e){var t=this.pointIndex(e);if(t>=0)return this.ranges.splice(t,1)},this.merge=function(){var e=[],t=this.ranges;t=t.sort(function(e,t){return r(e.start,t.start)});for(var i,n=t[0],o=1;o<t.length;o++){i=n,n=t[o];var s=r(i.end,n.start);s<0||(0!=s||i.isEmpty()||n.isEmpty())&&(r(i.end,n.end)<0&&(i.end.row=n.end.row,i.end.column=n.end.column),t.splice(o,1),e.push(n),n=i,o--)}return this.ranges=t,e},this.contains=function(e,t){return this.pointIndex({row:e,column:t})>=0},this.containsPoint=function(e){return this.pointIndex(e)>=0},this.rangeAtPoint=function(e){var t=this.pointIndex(e);if(t>=0)return this.ranges[t]},this.clipRows=function(e,t){var i=this.ranges;if(i[0].start.row>t||i[i.length-1].start.row<e)return[];var n=this.pointIndex({row:e,column:0});n<0&&(n=-n-1);var r=this.pointIndex({row:t,column:0},n);r<0&&(r=-r-1);for(var o=[],s=n;s<r;s++)o.push(i[s]);return o},this.removeAll=function(){return this.ranges.splice(0,this.ranges.length)},this.attach=function(e){this.session&&this.detach(),this.session=e,this.onChange=this.$onChange.bind(this),this.session.on("change",this.onChange)},this.detach=function(){this.session&&(this.session.removeListener("change",this.onChange),this.session=null)},this.$onChange=function(e){if("insert"==e.action)var t=e.start,i=e.end;else var i=e.start,t=e.end;for(var n=t.row,r=i.row,o=r-n,s=-t.column+i.column,a=this.ranges,l=0,c=a.length;l<c;l++){var h=a[l];if(!(h.end.row<n)){if(h.start.row>n)break;if(h.start.row==n&&h.start.column>=t.column&&(h.start.column==t.column&&this.$insertRight||(h.start.column+=s,h.start.row+=o)),h.end.row==n&&h.end.column>=t.column){if(h.end.column==t.column&&this.$insertRight)continue;h.end.column==t.column&&s>0&&l<c-1&&h.end.column>h.start.column&&h.end.column==a[l+1].start.column&&(h.end.column-=s),h.end.column+=s,h.end.row+=o}}}if(0!=o&&l<c)for(;l<c;l++){var h=a[l];h.start.row+=o,h.end.row+=o}}}).call(o.prototype),t.RangeList=o}),ace.define("ace/edit_session/fold",["require","exports","module","ace/range","ace/range_list","ace/lib/oop"],function(e,t,i){"use strict";function n(e,t){e.row-=t.row,0==e.row&&(e.column-=t.column)}function r(e,t){n(e.start,t),n(e.end,t)}function o(e,t){0==e.row&&(e.column+=t.column),e.row+=t.row}function s(e,t){o(e.start,t),o(e.end,t)}var a=(e("../range").Range,e("../range_list").RangeList),l=e("../lib/oop"),c=t.Fold=function(e,t){this.foldLine=null,this.placeholder=t,this.range=e,this.start=e.start,this.end=e.end,this.sameRow=e.start.row==e.end.row,this.subFolds=this.ranges=[]};l.inherits(c,a),function(){this.toString=function(){return'"'+this.placeholder+'" '+this.range.toString()},this.setFoldLine=function(e){this.foldLine=e,this.subFolds.forEach(function(t){t.setFoldLine(e)})},this.clone=function(){var e=this.range.clone(),t=new c(e,this.placeholder);return this.subFolds.forEach(function(e){t.subFolds.push(e.clone())}),t.collapseChildren=this.collapseChildren,t},this.addSubFold=function(e){if(!this.range.isEqual(e)){if(!this.range.containsRange(e))throw new Error("A fold can't intersect already existing fold"+e.range+this.range);r(e,this.start);for(var t=e.start.row,i=e.start.column,n=0,o=-1;n<this.subFolds.length&&(o=this.subFolds[n].range.compare(t,i),1==o);n++);var s=this.subFolds[n];if(0==o)return s.addSubFold(e);for(var t=e.range.end.row,i=e.range.end.column,a=n,o=-1;a<this.subFolds.length&&(o=this.subFolds[a].range.compare(t,i),1==o);a++);this.subFolds[a];if(0==o)throw new Error("A fold can't intersect already existing fold"+e.range+this.range);this.subFolds.splice(n,a-n,e);return e.setFoldLine(this.foldLine),e}},this.restoreRange=function(e){return s(e,this.start)}}.call(c.prototype)}),ace.define("ace/edit_session/folding",["require","exports","module","ace/range","ace/edit_session/fold_line","ace/edit_session/fold","ace/token_iterator"],function(e,t,i){"use strict";function n(){this.getFoldAt=function(e,t,i){var n=this.getFoldLine(e);if(!n)return null;for(var r=n.folds,o=0;o<r.length;o++){var s=r[o];if(s.range.contains(e,t)){if(1==i&&s.range.isEnd(e,t))continue;if(i==-1&&s.range.isStart(e,t))continue;return s}}},this.getFoldsInRange=function(e){var t=e.start,i=e.end,n=this.$foldData,r=[];t.column+=1,i.column-=1;for(var o=0;o<n.length;o++){var s=n[o].range.compareRange(e);if(2!=s){if(s==-2)break;for(var a=n[o].folds,l=0;l<a.length;l++){var c=a[l];if(s=c.range.compareRange(e),s==-2)break;if(2!=s){if(42==s)break;r.push(c)}}}}return t.column-=1,i.column+=1,r},this.getFoldsInRangeList=function(e){if(Array.isArray(e)){var t=[];e.forEach(function(e){t=t.concat(this.getFoldsInRange(e))},this)}else var t=this.getFoldsInRange(e);return t},this.getAllFolds=function(){for(var e=[],t=this.$foldData,i=0;i<t.length;i++)for(var n=0;n<t[i].folds.length;n++)e.push(t[i].folds[n]);return e},this.getFoldStringAt=function(e,t,i,n){if(n=n||this.getFoldLine(e),!n)return null;for(var r,o,s={end:{column:0}},a=0;a<n.folds.length;a++){o=n.folds[a];var l=o.range.compareEnd(e,t);if(l==-1){r=this.getLine(o.start.row).substring(s.end.column,o.start.column);break}if(0===l)return null;s=o}return r||(r=this.getLine(o.start.row).substring(s.end.column)),i==-1?r.substring(0,t-s.end.column):1==i?r.substring(t-s.end.column):r},this.getFoldLine=function(e,t){var i=this.$foldData,n=0;for(t&&(n=i.indexOf(t)),n==-1&&(n=0),n;n<i.length;n++){var r=i[n];if(r.start.row<=e&&r.end.row>=e)return r;if(r.end.row>e)return null}return null},this.getNextFoldLine=function(e,t){var i=this.$foldData,n=0;for(t&&(n=i.indexOf(t)),n==-1&&(n=0),n;n<i.length;n++){var r=i[n];if(r.end.row>=e)return r}return null},this.getFoldedRowCount=function(e,t){for(var i=this.$foldData,n=t-e+1,r=0;r<i.length;r++){var o=i[r],s=o.end.row,a=o.start.row;if(s>=t){a<t&&(a>=e?n-=t-a:n=0);break}s>=e&&(n-=a>=e?s-a:s-e+1)}return n},this.$addFoldLine=function(e){return this.$foldData.push(e),this.$foldData.sort(function(e,t){return e.start.row-t.start.row}),e},this.addFold=function(e,t){var i,n=this.$foldData,r=!1;e instanceof s?i=e:(i=new s(t,e),i.collapseChildren=t.collapseChildren),this.$clipRangeToDocument(i.range);var a=i.start.row,l=i.start.column,c=i.end.row,h=i.end.column;if(!(a<c||a==c&&l<=h-2))throw new Error("The range has to be at least 2 characters width");var d=this.getFoldAt(a,l,1),u=this.getFoldAt(c,h,-1);if(d&&u==d)return d.addSubFold(i);d&&!d.range.isStart(a,l)&&this.removeFold(d),u&&!u.range.isEnd(c,h)&&this.removeFold(u);var f=this.getFoldsInRange(i.range);f.length>0&&(this.removeFolds(f),f.forEach(function(e){i.addSubFold(e)}));for(var p=0;p<n.length;p++){var m=n[p];if(c==m.start.row){m.addFold(i),r=!0;break}if(a==m.end.row){
	if(m.addFold(i),r=!0,!i.sameRow){var g=n[p+1];if(g&&g.start.row==c){m.merge(g);break}}break}if(c<=m.start.row)break}return r||(m=this.$addFoldLine(new o(this.$foldData,i))),this.$useWrapMode?this.$updateWrapData(m.start.row,m.start.row):this.$updateRowLengthCache(m.start.row,m.start.row),this.$modified=!0,this._signal("changeFold",{data:i,action:"add"}),i},this.addFolds=function(e){e.forEach(function(e){this.addFold(e)},this)},this.removeFold=function(e){var t=e.foldLine,i=t.start.row,n=t.end.row,r=this.$foldData,o=t.folds;if(1==o.length)r.splice(r.indexOf(t),1);else if(t.range.isEnd(e.end.row,e.end.column))o.pop(),t.end.row=o[o.length-1].end.row,t.end.column=o[o.length-1].end.column;else if(t.range.isStart(e.start.row,e.start.column))o.shift(),t.start.row=o[0].start.row,t.start.column=o[0].start.column;else if(e.sameRow)o.splice(o.indexOf(e),1);else{var s=t.split(e.start.row,e.start.column);o=s.folds,o.shift(),s.start.row=o[0].start.row,s.start.column=o[0].start.column}this.$updating||(this.$useWrapMode?this.$updateWrapData(i,n):this.$updateRowLengthCache(i,n)),this.$modified=!0,this._signal("changeFold",{data:e,action:"remove"})},this.removeFolds=function(e){for(var t=[],i=0;i<e.length;i++)t.push(e[i]);t.forEach(function(e){this.removeFold(e)},this),this.$modified=!0},this.expandFold=function(e){this.removeFold(e),e.subFolds.forEach(function(t){e.restoreRange(t),this.addFold(t)},this),e.collapseChildren>0&&this.foldAll(e.start.row+1,e.end.row,e.collapseChildren-1),e.subFolds=[]},this.expandFolds=function(e){e.forEach(function(e){this.expandFold(e)},this)},this.unfold=function(e,t){var i,n;if(null==e?(i=new r(0,0,this.getLength(),0),t=!0):i="number"==typeof e?new r(e,0,e,this.getLine(e).length):"row"in e?r.fromPoints(e,e):e,n=this.getFoldsInRangeList(i),t)this.removeFolds(n);else for(var o=n;o.length;)this.expandFolds(o),o=this.getFoldsInRangeList(i);if(n.length)return n},this.isRowFolded=function(e,t){return!!this.getFoldLine(e,t)},this.getRowFoldEnd=function(e,t){var i=this.getFoldLine(e,t);return i?i.end.row:e},this.getRowFoldStart=function(e,t){var i=this.getFoldLine(e,t);return i?i.start.row:e},this.getFoldDisplayLine=function(e,t,i,n,r){null==n&&(n=e.start.row),null==r&&(r=0),null==t&&(t=e.end.row),null==i&&(i=this.getLine(t).length);var o=this.doc,s="";return e.walk(function(e,t,i,a){if(!(t<n)){if(t==n){if(i<r)return;a=Math.max(r,a)}s+=null!=e?e:o.getLine(t).substring(a,i)}},t,i),s},this.getDisplayLine=function(e,t,i,n){var r=this.getFoldLine(e);if(r)return this.getFoldDisplayLine(r,e,t,i,n);var o;return o=this.doc.getLine(e),o.substring(n||0,t||o.length)},this.$cloneFoldData=function(){var e=[];return e=this.$foldData.map(function(t){var i=t.folds.map(function(e){return e.clone()});return new o(e,i)})},this.toggleFold=function(e){var t,i,n=this.selection,r=n.getRange();if(r.isEmpty()){var o=r.start;if(t=this.getFoldAt(o.row,o.column))return void this.expandFold(t);(i=this.findMatchingBracket(o))?1==r.comparePoint(i)?r.end=i:(r.start=i,r.start.column++,r.end.column--):(i=this.findMatchingBracket({row:o.row,column:o.column+1}))?(1==r.comparePoint(i)?r.end=i:r.start=i,r.start.column++):r=this.getCommentFoldRange(o.row,o.column)||r}else{var s=this.getFoldsInRange(r);if(e&&s.length)return void this.expandFolds(s);1==s.length&&(t=s[0])}if(t||(t=this.getFoldAt(r.start.row,r.start.column)),t&&t.range.toString()==r.toString())return void this.expandFold(t);var a="...";if(!r.isMultiLine()){if(a=this.getTextRange(r),a.length<4)return;a=a.trim().substring(0,2)+".."}this.addFold(a,r)},this.getCommentFoldRange=function(e,t,i){var n=new a(this,e,t),o=n.getCurrentToken();if(o&&/^comment|string/.test(o.type)){var s=new r,l=new RegExp(o.type.replace(/\..*/,"\\."));if(1!=i){do o=n.stepBackward();while(o&&l.test(o.type));n.stepForward()}if(s.start.row=n.getCurrentTokenRow(),s.start.column=n.getCurrentTokenColumn()+2,n=new a(this,e,t),i!=-1){do o=n.stepForward();while(o&&l.test(o.type));o=n.stepBackward()}else o=n.getCurrentToken();return s.end.row=n.getCurrentTokenRow(),s.end.column=n.getCurrentTokenColumn()+o.value.length-2,s}},this.foldAll=function(e,t,i){void 0==i&&(i=1e5);var n=this.foldWidgets;if(n){t=t||this.getLength(),e=e||0;for(var r=e;r<t;r++)if(null==n[r]&&(n[r]=this.getFoldWidget(r)),"start"==n[r]){var o=this.getFoldWidgetRange(r);if(o&&o.isMultiLine()&&o.end.row<=t&&o.start.row>=e){r=o.end.row;try{var s=this.addFold("...",o);s&&(s.collapseChildren=i)}catch(e){}}}}},this.$foldStyles={manual:1,markbegin:1,markbeginend:1},this.$foldStyle="markbegin",this.setFoldStyle=function(e){if(!this.$foldStyles[e])throw new Error("invalid fold style: "+e+"["+Object.keys(this.$foldStyles).join(", ")+"]");if(this.$foldStyle!=e){this.$foldStyle=e,"manual"==e&&this.unfold();var t=this.$foldMode;this.$setFolding(null),this.$setFolding(t)}},this.$setFolding=function(e){if(this.$foldMode!=e){if(this.$foldMode=e,this.off("change",this.$updateFoldWidgets),this.off("tokenizerUpdate",this.$tokenizerUpdateFoldWidgets),this._signal("changeAnnotation"),!e||"manual"==this.$foldStyle)return void(this.foldWidgets=null);this.foldWidgets=[],this.getFoldWidget=e.getFoldWidget.bind(e,this,this.$foldStyle),this.getFoldWidgetRange=e.getFoldWidgetRange.bind(e,this,this.$foldStyle),this.$updateFoldWidgets=this.updateFoldWidgets.bind(this),this.$tokenizerUpdateFoldWidgets=this.tokenizerUpdateFoldWidgets.bind(this),this.on("change",this.$updateFoldWidgets),this.on("tokenizerUpdate",this.$tokenizerUpdateFoldWidgets)}},this.getParentFoldRangeData=function(e,t){var i=this.foldWidgets;if(!i||t&&i[e])return{};for(var n,r=e-1;r>=0;){var o=i[r];if(null==o&&(o=i[r]=this.getFoldWidget(r)),"start"==o){var s=this.getFoldWidgetRange(r);if(n||(n=s),s&&s.end.row>=e)break}r--}return{range:r!==-1&&s,firstRange:n}},this.onFoldWidgetClick=function(e,t){t=t.domEvent;var i={children:t.shiftKey,all:t.ctrlKey||t.metaKey,siblings:t.altKey},n=this.$toggleFoldWidget(e,i);if(!n){var r=t.target||t.srcElement;r&&/ace_fold-widget/.test(r.className)&&(r.className+=" ace_invalid")}},this.$toggleFoldWidget=function(e,t){if(this.getFoldWidget){var i=this.getFoldWidget(e),n=this.getLine(e),r="end"===i?-1:1,o=this.getFoldAt(e,r===-1?0:n.length,r);if(o)return void(t.children||t.all?this.removeFold(o):this.expandFold(o));var s=this.getFoldWidgetRange(e,!0);if(s&&!s.isMultiLine()&&(o=this.getFoldAt(s.start.row,s.start.column,1),o&&s.isEqual(o.range)))return void this.removeFold(o);if(t.siblings){var a=this.getParentFoldRangeData(e);if(a.range)var l=a.range.start.row+1,c=a.range.end.row;this.foldAll(l,c,t.all?1e4:0)}else t.children?(c=s?s.end.row:this.getLength(),this.foldAll(e+1,c,t.all?1e4:0)):s&&(t.all&&(s.collapseChildren=1e4),this.addFold("...",s));return s}},this.toggleFoldWidget=function(e){var t=this.selection.getCursor().row;t=this.getRowFoldStart(t);var i=this.$toggleFoldWidget(t,{});if(!i){var n=this.getParentFoldRangeData(t,!0);if(i=n.range||n.firstRange){t=i.start.row;var r=this.getFoldAt(t,this.getLine(t).length,1);r?this.removeFold(r):this.addFold("...",i)}}},this.updateFoldWidgets=function(e){var t=e.start.row,i=e.end.row-t;if(0===i)this.foldWidgets[t]=null;else if("remove"==e.action)this.foldWidgets.splice(t,i+1,null);else{var n=Array(i+1);n.unshift(t,1),this.foldWidgets.splice.apply(this.foldWidgets,n)}},this.tokenizerUpdateFoldWidgets=function(e){var t=e.data;t.first!=t.last&&this.foldWidgets.length>t.first&&this.foldWidgets.splice(t.first,this.foldWidgets.length)}}var r=e("../range").Range,o=e("./fold_line").FoldLine,s=e("./fold").Fold,a=e("../token_iterator").TokenIterator;t.Folding=n}),ace.define("ace/edit_session/bracket_match",["require","exports","module","ace/token_iterator","ace/range"],function(e,t,i){"use strict";function n(){this.findMatchingBracket=function(e,t){if(0==e.column)return null;var i=t||this.getLine(e.row).charAt(e.column-1);if(""==i)return null;var n=i.match(/([\(\[\{])|([\)\]\}])/);return n?n[1]?this.$findClosingBracket(n[1],e):this.$findOpeningBracket(n[2],e):null},this.getBracketRange=function(e){var t,i=this.getLine(e.row),n=!0,r=i.charAt(e.column-1),s=r&&r.match(/([\(\[\{])|([\)\]\}])/);if(s||(r=i.charAt(e.column),e={row:e.row,column:e.column+1},s=r&&r.match(/([\(\[\{])|([\)\]\}])/),n=!1),!s)return null;if(s[1]){var a=this.$findClosingBracket(s[1],e);if(!a)return null;t=o.fromPoints(e,a),n||(t.end.column++,t.start.column--),t.cursor=t.end}else{var a=this.$findOpeningBracket(s[2],e);if(!a)return null;t=o.fromPoints(a,e),n||(t.start.column++,t.end.column--),t.cursor=t.start}return t},this.$brackets={")":"(","(":")","]":"[","[":"]","{":"}","}":"{"},this.$findOpeningBracket=function(e,t,i){var n=this.$brackets[e],o=1,s=new r(this,t.row,t.column),a=s.getCurrentToken();if(a||(a=s.stepForward()),a){i||(i=new RegExp("(\\.?"+a.type.replace(".","\\.").replace("rparen",".paren").replace(/\b(?:end)\b/,"(?:start|begin|end)")+")+"));for(var l=t.column-s.getCurrentTokenColumn()-2,c=a.value;;){for(;l>=0;){var h=c.charAt(l);if(h==n){if(o-=1,0==o)return{row:s.getCurrentTokenRow(),column:l+s.getCurrentTokenColumn()}}else h==e&&(o+=1);l-=1}do a=s.stepBackward();while(a&&!i.test(a.type));if(null==a)break;c=a.value,l=c.length-1}return null}},this.$findClosingBracket=function(e,t,i){var n=this.$brackets[e],o=1,s=new r(this,t.row,t.column),a=s.getCurrentToken();if(a||(a=s.stepForward()),a){i||(i=new RegExp("(\\.?"+a.type.replace(".","\\.").replace("lparen",".paren").replace(/\b(?:start|begin)\b/,"(?:start|begin|end)")+")+"));for(var l=t.column-s.getCurrentTokenColumn();;){for(var c=a.value,h=c.length;l<h;){var d=c.charAt(l);if(d==n){if(o-=1,0==o)return{row:s.getCurrentTokenRow(),column:l+s.getCurrentTokenColumn()}}else d==e&&(o+=1);l+=1}do a=s.stepForward();while(a&&!i.test(a.type));if(null==a)break;l=0}return null}}}var r=e("../token_iterator").TokenIterator,o=e("../range").Range;t.BracketMatch=n}),ace.define("ace/edit_session",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/config","ace/lib/event_emitter","ace/selection","ace/mode/text","ace/range","ace/document","ace/background_tokenizer","ace/search_highlight","ace/edit_session/folding","ace/edit_session/bracket_match"],function(e,t,i){"use strict";var n=e("./lib/oop"),r=e("./lib/lang"),o=e("./config"),s=e("./lib/event_emitter").EventEmitter,a=e("./selection").Selection,l=e("./mode/text").Mode,c=e("./range").Range,h=e("./document").Document,d=e("./background_tokenizer").BackgroundTokenizer,u=e("./search_highlight").SearchHighlight,f=function(e,t){this.$breakpoints=[],this.$decorations=[],this.$frontMarkers={},this.$backMarkers={},this.$markerId=1,this.$undoSelect=!0,this.$foldData=[],this.$foldData.toString=function(){return this.join("\n")},this.on("changeFold",this.onChangeFold.bind(this)),this.$onChange=this.onChange.bind(this),"object"==typeof e&&e.getLine||(e=new h(e)),this.setDocument(e),this.selection=new a(this),o.resetOptions(this),this.setMode(t),o._signal("session",this)};(function(){function e(e){return!(e<4352)&&(e>=4352&&e<=4447||e>=4515&&e<=4519||e>=4602&&e<=4607||e>=9001&&e<=9002||e>=11904&&e<=11929||e>=11931&&e<=12019||e>=12032&&e<=12245||e>=12272&&e<=12283||e>=12288&&e<=12350||e>=12353&&e<=12438||e>=12441&&e<=12543||e>=12549&&e<=12589||e>=12593&&e<=12686||e>=12688&&e<=12730||e>=12736&&e<=12771||e>=12784&&e<=12830||e>=12832&&e<=12871||e>=12880&&e<=13054||e>=13056&&e<=19903||e>=19968&&e<=42124||e>=42128&&e<=42182||e>=43360&&e<=43388||e>=44032&&e<=55203||e>=55216&&e<=55238||e>=55243&&e<=55291||e>=63744&&e<=64255||e>=65040&&e<=65049||e>=65072&&e<=65106||e>=65108&&e<=65126||e>=65128&&e<=65131||e>=65281&&e<=65376||e>=65504&&e<=65510)}n.implement(this,s),this.setDocument=function(e){this.doc&&this.doc.removeListener("change",this.$onChange),this.doc=e,e.on("change",this.$onChange),this.bgTokenizer&&this.bgTokenizer.setDocument(this.getDocument()),this.resetCaches()},this.getDocument=function(){return this.doc},this.$resetRowCache=function(e){if(!e)return this.$docRowCache=[],void(this.$screenRowCache=[]);var t=this.$docRowCache.length,i=this.$getRowCacheIndex(this.$docRowCache,e)+1;t>i&&(this.$docRowCache.splice(i,t),this.$screenRowCache.splice(i,t))},this.$getRowCacheIndex=function(e,t){for(var i=0,n=e.length-1;i<=n;){var r=i+n>>1,o=e[r];if(t>o)i=r+1;else{if(!(t<o))return r;n=r-1}}return i-1},this.resetCaches=function(){this.$modified=!0,this.$wrapData=[],this.$rowLengthCache=[],this.$resetRowCache(0),this.bgTokenizer&&this.bgTokenizer.start(0)},this.onChangeFold=function(e){var t=e.data;this.$resetRowCache(t.start.row)},this.onChange=function(e){this.$modified=!0,this.$resetRowCache(e.start.row);var t=this.$updateInternalDataOnChange(e);this.$fromUndo||!this.$undoManager||e.ignore||(this.$deltasDoc.push(e),t&&0!=t.length&&this.$deltasFold.push({action:"removeFolds",folds:t}),this.$informUndoManager.schedule()),this.bgTokenizer&&this.bgTokenizer.$updateOnChange(e),this._signal("change",e)},this.setValue=function(e){this.doc.setValue(e),this.selection.moveTo(0,0),this.$resetRowCache(0),this.$deltas=[],this.$deltasDoc=[],this.$deltasFold=[],this.setUndoManager(this.$undoManager),this.getUndoManager().reset()},this.getValue=this.toString=function(){return this.doc.getValue()},this.getSelection=function(){return this.selection},this.getState=function(e){return this.bgTokenizer.getState(e)},this.getTokens=function(e){return this.bgTokenizer.getTokens(e)},this.getTokenAt=function(e,t){var i,n=this.bgTokenizer.getTokens(e),r=0;if(null==t)o=n.length-1,r=this.getLine(e).length;else for(var o=0;o<n.length&&(r+=n[o].value.length,!(r>=t));o++);return(i=n[o])?(i.index=o,i.start=r-i.value.length,i):null},this.setUndoManager=function(e){if(this.$undoManager=e,this.$deltas=[],this.$deltasDoc=[],this.$deltasFold=[],this.$informUndoManager&&this.$informUndoManager.cancel(),e){var t=this;this.$syncInformUndoManager=function(){t.$informUndoManager.cancel(),t.$deltasFold.length&&(t.$deltas.push({group:"fold",deltas:t.$deltasFold}),t.$deltasFold=[]),t.$deltasDoc.length&&(t.$deltas.push({group:"doc",deltas:t.$deltasDoc}),t.$deltasDoc=[]),t.$deltas.length>0&&e.execute({action:"aceupdate",args:[t.$deltas,t],merge:t.mergeUndoDeltas}),t.mergeUndoDeltas=!1,t.$deltas=[]},this.$informUndoManager=r.delayedCall(this.$syncInformUndoManager)}},this.markUndoGroup=function(){this.$syncInformUndoManager&&this.$syncInformUndoManager()},this.$defaultUndoManager={undo:function(){},redo:function(){},reset:function(){}},this.getUndoManager=function(){return this.$undoManager||this.$defaultUndoManager},this.getTabString=function(){return this.getUseSoftTabs()?r.stringRepeat(" ",this.getTabSize()):"\t"},this.setUseSoftTabs=function(e){this.setOption("useSoftTabs",e)},this.getUseSoftTabs=function(){return this.$useSoftTabs&&!this.$mode.$indentWithTabs},this.setTabSize=function(e){this.setOption("tabSize",e)},this.getTabSize=function(){return this.$tabSize},this.isTabStop=function(e){return this.$useSoftTabs&&e.column%this.$tabSize===0},this.$overwrite=!1,this.setOverwrite=function(e){this.setOption("overwrite",e)},this.getOverwrite=function(){return this.$overwrite},this.toggleOverwrite=function(){this.setOverwrite(!this.$overwrite)},this.addGutterDecoration=function(e,t){this.$decorations[e]||(this.$decorations[e]=""),this.$decorations[e]+=" "+t,this._signal("changeBreakpoint",{})},this.removeGutterDecoration=function(e,t){this.$decorations[e]=(this.$decorations[e]||"").replace(" "+t,""),this._signal("changeBreakpoint",{})},this.getBreakpoints=function(){return this.$breakpoints},this.setBreakpoints=function(e){this.$breakpoints=[];for(var t=0;t<e.length;t++)this.$breakpoints[e[t]]="ace_breakpoint";this._signal("changeBreakpoint",{})},this.clearBreakpoints=function(){this.$breakpoints=[],this._signal("changeBreakpoint",{})},this.setBreakpoint=function(e,t){void 0===t&&(t="ace_breakpoint"),t?this.$breakpoints[e]=t:delete this.$breakpoints[e],this._signal("changeBreakpoint",{})},this.clearBreakpoint=function(e){delete this.$breakpoints[e],this._signal("changeBreakpoint",{})},this.addMarker=function(e,t,i,n){var r=this.$markerId++,o={range:e,type:i||"line",renderer:"function"==typeof i?i:null,clazz:t,inFront:!!n,id:r};return n?(this.$frontMarkers[r]=o,this._signal("changeFrontMarker")):(this.$backMarkers[r]=o,this._signal("changeBackMarker")),r},this.addDynamicMarker=function(e,t){if(e.update){var i=this.$markerId++;return e.id=i,e.inFront=!!t,t?(this.$frontMarkers[i]=e,this._signal("changeFrontMarker")):(this.$backMarkers[i]=e,this._signal("changeBackMarker")),e}},this.removeMarker=function(e){var t=this.$frontMarkers[e]||this.$backMarkers[e];if(t){var i=t.inFront?this.$frontMarkers:this.$backMarkers;t&&(delete i[e],this._signal(t.inFront?"changeFrontMarker":"changeBackMarker"))}},this.getMarkers=function(e){return e?this.$frontMarkers:this.$backMarkers},this.highlight=function(e){if(!this.$searchHighlight){var t=new u(null,"ace_selected-word","text");this.$searchHighlight=this.addDynamicMarker(t)}this.$searchHighlight.setRegexp(e)},this.highlightLines=function(e,t,i,n){"number"!=typeof t&&(i=t,t=e),i||(i="ace_step");var r=new c(e,0,t,1/0);return r.id=this.addMarker(r,i,"fullLine",n),r},this.setAnnotations=function(e){this.$annotations=e,this._signal("changeAnnotation",{})},this.getAnnotations=function(){return this.$annotations||[]},this.clearAnnotations=function(){this.setAnnotations([])},this.$detectNewLine=function(e){var t=e.match(/^.*?(\r?\n)/m);t?this.$autoNewLine=t[1]:this.$autoNewLine="\n"},this.getWordRange=function(e,t){var i=this.getLine(e),n=!1;if(t>0&&(n=!!i.charAt(t-1).match(this.tokenRe)),n||(n=!!i.charAt(t).match(this.tokenRe)),n)var r=this.tokenRe;else if(/^\s+$/.test(i.slice(t-1,t+1)))var r=/\s/;else var r=this.nonTokenRe;var o=t;if(o>0){do o--;while(o>=0&&i.charAt(o).match(r));o++}for(var s=t;s<i.length&&i.charAt(s).match(r);)s++;return new c(e,o,e,s)},this.getAWordRange=function(e,t){for(var i=this.getWordRange(e,t),n=this.getLine(i.end.row);n.charAt(i.end.column).match(/[ \t]/);)i.end.column+=1;return i},this.setNewLineMode=function(e){this.doc.setNewLineMode(e)},this.getNewLineMode=function(){return this.doc.getNewLineMode()},this.setUseWorker=function(e){this.setOption("useWorker",e)},this.getUseWorker=function(){return this.$useWorker},this.onReloadTokenizer=function(e){var t=e.data;this.bgTokenizer.start(t.first),this._signal("tokenizerUpdate",e)},this.$modes={},this.$mode=null,this.$modeId=null,this.setMode=function(e,t){if(e&&"object"==typeof e){if(e.getTokenizer)return this.$onChangeMode(e);var i=e,n=i.path}else n=e||"ace/mode/text";return this.$modes["ace/mode/text"]||(this.$modes["ace/mode/text"]=new l),this.$modes[n]&&!i?(this.$onChangeMode(this.$modes[n]),void(t&&t())):(this.$modeId=n,o.loadModule(["mode",n],function(e){return this.$modeId!==n?t&&t():(this.$modes[n]&&!i?this.$onChangeMode(this.$modes[n]):e&&e.Mode&&(e=new e.Mode(i),i||(this.$modes[n]=e,e.$id=n),this.$onChangeMode(e)),void(t&&t()))}.bind(this)),void(this.$mode||this.$onChangeMode(this.$modes["ace/mode/text"],!0)))},this.$onChangeMode=function(e,t){if(t||(this.$modeId=e.$id),this.$mode!==e){this.$mode=e,this.$stopWorker(),this.$useWorker&&this.$startWorker();var i=e.getTokenizer();if(void 0!==i.addEventListener){var n=this.onReloadTokenizer.bind(this);i.addEventListener("update",n)}if(this.bgTokenizer)this.bgTokenizer.setTokenizer(i);else{this.bgTokenizer=new d(i);var r=this;this.bgTokenizer.addEventListener("update",function(e){r._signal("tokenizerUpdate",e)})}this.bgTokenizer.setDocument(this.getDocument()),this.tokenRe=e.tokenRe,this.nonTokenRe=e.nonTokenRe,t||(e.attachToSession&&e.attachToSession(this),this.$options.wrapMethod.set.call(this,this.$wrapMethod),this.$setFolding(e.foldingRules),this.bgTokenizer.start(0),this._emit("changeMode"))}},this.$stopWorker=function(){this.$worker&&(this.$worker.terminate(),this.$worker=null)},this.$startWorker=function(){try{this.$worker=this.$mode.createWorker(this)}catch(e){o.warn("Could not load worker",e),this.$worker=null}},this.getMode=function(){return this.$mode},this.$scrollTop=0,this.setScrollTop=function(e){this.$scrollTop===e||isNaN(e)||(this.$scrollTop=e,this._signal("changeScrollTop",e))},this.getScrollTop=function(){return this.$scrollTop},this.$scrollLeft=0,this.setScrollLeft=function(e){this.$scrollLeft===e||isNaN(e)||(this.$scrollLeft=e,this._signal("changeScrollLeft",e))},this.getScrollLeft=function(){return this.$scrollLeft},this.getScreenWidth=function(){return this.$computeWidth(),this.lineWidgets?Math.max(this.getLineWidgetMaxWidth(),this.screenWidth):this.screenWidth},this.getLineWidgetMaxWidth=function(){if(null!=this.lineWidgetsWidth)return this.lineWidgetsWidth;var e=0;return this.lineWidgets.forEach(function(t){t&&t.screenWidth>e&&(e=t.screenWidth)}),this.lineWidgetWidth=e},this.$computeWidth=function(e){if(this.$modified||e){if(this.$modified=!1,this.$useWrapMode)return this.screenWidth=this.$wrapLimit;for(var t=this.doc.getAllLines(),i=this.$rowLengthCache,n=0,r=0,o=this.$foldData[r],s=o?o.start.row:1/0,a=t.length,l=0;l<a;l++){if(l>s){if(l=o.end.row+1,l>=a)break;o=this.$foldData[r++],s=o?o.start.row:1/0}null==i[l]&&(i[l]=this.$getStringScreenWidth(t[l])[0]),i[l]>n&&(n=i[l])}this.screenWidth=n}},this.getLine=function(e){return this.doc.getLine(e)},this.getLines=function(e,t){return this.doc.getLines(e,t)},this.getLength=function(){return this.doc.getLength()},this.getTextRange=function(e){return this.doc.getTextRange(e||this.selection.getRange())},this.insert=function(e,t){return this.doc.insert(e,t)},this.remove=function(e){return this.doc.remove(e)},this.removeFullLines=function(e,t){return this.doc.removeFullLines(e,t)},this.undoChanges=function(e,t){if(e.length){this.$fromUndo=!0;for(var i=null,n=e.length-1;n!=-1;n--){var r=e[n];"doc"==r.group?(this.doc.revertDeltas(r.deltas),i=this.$getUndoSelection(r.deltas,!0,i)):r.deltas.forEach(function(e){this.addFolds(e.folds)},this)}return this.$fromUndo=!1,i&&this.$undoSelect&&!t&&this.selection.setSelectionRange(i),i}},this.redoChanges=function(e,t){if(e.length){this.$fromUndo=!0;for(var i=null,n=0;n<e.length;n++){var r=e[n];"doc"==r.group&&(this.doc.applyDeltas(r.deltas),i=this.$getUndoSelection(r.deltas,!1,i))}return this.$fromUndo=!1,i&&this.$undoSelect&&!t&&this.selection.setSelectionRange(i),i}},this.setUndoSelect=function(e){this.$undoSelect=e},this.$getUndoSelection=function(e,t,i){function n(e){return t?"insert"!==e.action:"insert"===e.action}var r,o,s=e[0],a=!1;n(s)?(r=c.fromPoints(s.start,s.end),a=!0):(r=c.fromPoints(s.start,s.start),a=!1);for(var l=1;l<e.length;l++)s=e[l],n(s)?(o=s.start,r.compare(o.row,o.column)==-1&&r.setStart(o),o=s.end,1==r.compare(o.row,o.column)&&r.setEnd(o),a=!0):(o=s.start,r.compare(o.row,o.column)==-1&&(r=c.fromPoints(s.start,s.start)),a=!1);if(null!=i){0===c.comparePoints(i.start,r.start)&&(i.start.column+=r.end.column-r.start.column,i.end.column+=r.end.column-r.start.column);var h=i.compareRange(r);1==h?r.setStart(i.start):h==-1&&r.setEnd(i.end)}return r},this.replace=function(e,t){return this.doc.replace(e,t)},this.moveText=function(e,t,i){var n=this.getTextRange(e),r=this.getFoldsInRange(e),o=c.fromPoints(t,t);if(!i){this.remove(e);var s=e.start.row-e.end.row,a=s?-e.end.column:e.start.column-e.end.column;a&&(o.start.row==e.end.row&&o.start.column>e.end.column&&(o.start.column+=a),o.end.row==e.end.row&&o.end.column>e.end.column&&(o.end.column+=a)),s&&o.start.row>=e.end.row&&(o.start.row+=s,o.end.row+=s)}if(o.end=this.insert(o.start,n),r.length){var l=e.start,h=o.start,s=h.row-l.row,a=h.column-l.column;this.addFolds(r.map(function(e){return e=e.clone(),e.start.row==l.row&&(e.start.column+=a),e.end.row==l.row&&(e.end.column+=a),e.start.row+=s,e.end.row+=s,e}))}return o},this.indentRows=function(e,t,i){i=i.replace(/\t/g,this.getTabString());for(var n=e;n<=t;n++)this.doc.insertInLine({row:n,column:0},i)},this.outdentRows=function(e){for(var t=e.collapseRows(),i=new c(0,0,0,0),n=this.getTabSize(),r=t.start.row;r<=t.end.row;++r){var o=this.getLine(r);i.start.row=r,i.end.row=r;for(var s=0;s<n&&" "==o.charAt(s);++s);s<n&&"\t"==o.charAt(s)?(i.start.column=s,i.end.column=s+1):(i.start.column=0,i.end.column=s),this.remove(i)}},this.$moveLines=function(e,t,i){if(e=this.getRowFoldStart(e),t=this.getRowFoldEnd(t),i<0){var n=this.getRowFoldStart(e+i);if(n<0)return 0;var r=n-e}else if(i>0){var n=this.getRowFoldEnd(t+i);if(n>this.doc.getLength()-1)return 0;var r=n-t}else{e=this.$clipRowToDocument(e),t=this.$clipRowToDocument(t);var r=t-e+1}var o=new c(e,0,t,Number.MAX_VALUE),s=this.getFoldsInRange(o).map(function(e){return e=e.clone(),e.start.row+=r,e.end.row+=r,e}),a=0==i?this.doc.getLines(e,t):this.doc.removeFullLines(e,t);return this.doc.insertFullLines(e+r,a),s.length&&this.addFolds(s),r},this.moveLinesUp=function(e,t){return this.$moveLines(e,t,-1)},this.moveLinesDown=function(e,t){return this.$moveLines(e,t,1)},this.duplicateLines=function(e,t){return this.$moveLines(e,t,0)},this.$clipRowToDocument=function(e){return Math.max(0,Math.min(e,this.doc.getLength()-1))},this.$clipColumnToRow=function(e,t){return t<0?0:Math.min(this.doc.getLine(e).length,t)},this.$clipPositionToDocument=function(e,t){if(t=Math.max(0,t),e<0)e=0,t=0;else{var i=this.doc.getLength();e>=i?(e=i-1,t=this.doc.getLine(i-1).length):t=Math.min(this.doc.getLine(e).length,t)}return{row:e,column:t}},this.$clipRangeToDocument=function(e){e.start.row<0?(e.start.row=0,e.start.column=0):e.start.column=this.$clipColumnToRow(e.start.row,e.start.column);var t=this.doc.getLength()-1;return e.end.row>t?(e.end.row=t,e.end.column=this.doc.getLine(t).length):e.end.column=this.$clipColumnToRow(e.end.row,e.end.column),e},this.$wrapLimit=80,this.$useWrapMode=!1,this.$wrapLimitRange={min:null,max:null},this.setUseWrapMode=function(e){if(e!=this.$useWrapMode){if(this.$useWrapMode=e,this.$modified=!0,this.$resetRowCache(0),e){var t=this.getLength();this.$wrapData=Array(t),this.$updateWrapData(0,t-1)}this._signal("changeWrapMode")}},this.getUseWrapMode=function(){return this.$useWrapMode},this.setWrapLimitRange=function(e,t){this.$wrapLimitRange.min===e&&this.$wrapLimitRange.max===t||(this.$wrapLimitRange={min:e,max:t},this.$modified=!0,this.$useWrapMode&&this._signal("changeWrapMode"))},this.adjustWrapLimit=function(e,t){var i=this.$wrapLimitRange;i.max<0&&(i={min:t,max:t});var n=this.$constrainWrapLimit(e,i.min,i.max);return n!=this.$wrapLimit&&n>1&&(this.$wrapLimit=n,this.$modified=!0,this.$useWrapMode&&(this.$updateWrapData(0,this.getLength()-1),this.$resetRowCache(0),this._signal("changeWrapLimit")),!0)},this.$constrainWrapLimit=function(e,t,i){return t&&(e=Math.max(t,e)),i&&(e=Math.min(i,e)),e},this.getWrapLimit=function(){return this.$wrapLimit},this.setWrapLimit=function(e){this.setWrapLimitRange(e,e)},this.getWrapLimitRange=function(){return{min:this.$wrapLimitRange.min,max:this.$wrapLimitRange.max}},this.$updateInternalDataOnChange=function(e){var t=this.$useWrapMode,i=e.action,n=e.start,r=e.end,o=n.row,s=r.row,a=s-o,l=null;if(this.$updating=!0,0!=a)if("remove"===i){this[t?"$wrapData":"$rowLengthCache"].splice(o,a);var c=this.$foldData;l=this.getFoldsInRange(e),this.removeFolds(l);var h=this.getFoldLine(r.row),d=0;if(h){h.addRemoveChars(r.row,r.column,n.column-r.column),h.shiftRow(-a);var u=this.getFoldLine(o);u&&u!==h&&(u.merge(h),h=u),d=c.indexOf(h)+1}for(d;d<c.length;d++){var h=c[d];h.start.row>=r.row&&h.shiftRow(-a)}s=o}else{var f=Array(a);f.unshift(o,0);var p=t?this.$wrapData:this.$rowLengthCache;p.splice.apply(p,f);var c=this.$foldData,h=this.getFoldLine(o),d=0;if(h){var m=h.range.compareInside(n.row,n.column);0==m?(h=h.split(n.row,n.column),h&&(h.shiftRow(a),h.addRemoveChars(s,0,r.column-n.column))):m==-1&&(h.addRemoveChars(o,0,r.column-n.column),h.shiftRow(a)),d=c.indexOf(h)+1}for(d;d<c.length;d++){var h=c[d];h.start.row>=o&&h.shiftRow(a)}}else{a=Math.abs(e.start.column-e.end.column),"remove"===i&&(l=this.getFoldsInRange(e),this.removeFolds(l),a=-a);var h=this.getFoldLine(o);h&&h.addRemoveChars(o,n.column,a)}return t&&this.$wrapData.length!=this.doc.getLength()&&console.error("doc.getLength() and $wrapData.length have to be the same!"),this.$updating=!1,t?this.$updateWrapData(o,s):this.$updateRowLengthCache(o,s),l},this.$updateRowLengthCache=function(e,t,i){this.$rowLengthCache[e]=null,this.$rowLengthCache[t]=null},this.$updateWrapData=function(e,t){var i,n,r=this.doc.getAllLines(),o=this.getTabSize(),s=this.$wrapData,l=this.$wrapLimit,c=e;for(t=Math.min(t,r.length-1);c<=t;)n=this.getFoldLine(c,n),n?(i=[],n.walk(function(e,t,n,o){var s;if(null!=e){s=this.$getDisplayTokens(e,i.length),s[0]=a;for(var l=1;l<s.length;l++)s[l]=h}else s=this.$getDisplayTokens(r[t].substring(o,n),i.length);i=i.concat(s)}.bind(this),n.end.row,r[n.end.row].length+1),s[n.start.row]=this.$computeWrapSplits(i,l,o),c=n.end.row+1):(i=this.$getDisplayTokens(r[c]),s[c]=this.$computeWrapSplits(i,l,o),c++)};var t=1,i=2,a=3,h=4,f=9,p=10,m=11,g=12;this.$computeWrapSplits=function(e,t,n){function r(){var t=0;if(0===y)return t;if(v)for(var i=0;i<e.length;i++){var r=e[i];if(r==p)t+=1;else{if(r!=m){if(r==g)continue;break}t+=n}}return u&&v!==!1&&(t+=n),Math.min(t,y)}function o(t){var i=e.slice(c,t),n=i.length;i.join("").replace(/12/g,function(){n-=1}).replace(/2/g,function(){n-=1}),s.length||(w=r(),s.indent=w),d+=n,s.push(d),c=t}if(0==e.length)return[];for(var s=[],l=e.length,c=0,d=0,u=this.$wrapAsCode,v=this.$indentedSoftWrap,y=t<=Math.max(2*n,8)||v===!1?0:Math.floor(t/2),w=0;l-c>t-w;){var b=c+t-w;if(e[b-1]>=p&&e[b]>=p)o(b);else if(e[b]!=a&&e[b]!=h){for(var A=Math.max(b-(t-(t>>2)),c-1);b>A&&e[b]<a;)b--;if(u){for(;b>A&&e[b]<a;)b--;for(;b>A&&e[b]==f;)b--}else for(;b>A&&e[b]<p;)b--;b>A?o(++b):(b=c+t,e[b]==i&&b--,o(b-w))}else{for(b;b!=c-1&&e[b]!=a;b--);if(b>c){o(b);continue}for(b=c+t;b<e.length&&e[b]==h;b++);if(b==e.length)break;o(b)}}return s},this.$getDisplayTokens=function(n,r){var o,s=[];r=r||0;for(var a=0;a<n.length;a++){var l=n.charCodeAt(a);if(9==l){o=this.getScreenTabSize(s.length+r),s.push(m);for(var c=1;c<o;c++)s.push(g)}else 32==l?s.push(p):l>39&&l<48||l>57&&l<64?s.push(f):l>=4352&&e(l)?s.push(t,i):s.push(t)}return s},this.$getStringScreenWidth=function(t,i,n){if(0==i)return[0,0];null==i&&(i=1/0),n=n||0;var r,o;for(o=0;o<t.length&&(r=t.charCodeAt(o),n+=9==r?this.getScreenTabSize(n):r>=4352&&e(r)?2:1,!(n>i));o++);return[n,o]},this.lineWidgets=null,this.getRowLength=function(e){if(this.lineWidgets)var t=this.lineWidgets[e]&&this.lineWidgets[e].rowCount||0;else t=0;return this.$useWrapMode&&this.$wrapData[e]?this.$wrapData[e].length+1+t:1+t},this.getRowLineCount=function(e){return this.$useWrapMode&&this.$wrapData[e]?this.$wrapData[e].length+1:1},this.getRowWrapIndent=function(e){if(this.$useWrapMode){var t=this.screenToDocumentPosition(e,Number.MAX_VALUE),i=this.$wrapData[t.row];return i.length&&i[0]<t.column?i.indent:0}return 0},this.getScreenLastRowColumn=function(e){var t=this.screenToDocumentPosition(e,Number.MAX_VALUE);return this.documentToScreenColumn(t.row,t.column)},this.getDocumentLastRowColumn=function(e,t){var i=this.documentToScreenRow(e,t);return this.getScreenLastRowColumn(i)},this.getDocumentLastRowColumnPosition=function(e,t){var i=this.documentToScreenRow(e,t);return this.screenToDocumentPosition(i,Number.MAX_VALUE/10)},this.getRowSplitData=function(e){return this.$useWrapMode?this.$wrapData[e]:void 0},this.getScreenTabSize=function(e){return this.$tabSize-e%this.$tabSize},this.screenToDocumentRow=function(e,t){return this.screenToDocumentPosition(e,t).row},this.screenToDocumentColumn=function(e,t){return this.screenToDocumentPosition(e,t).column},this.screenToDocumentPosition=function(e,t){if(e<0)return{row:0,column:0};var i,n,r=0,o=0,s=0,a=0,l=this.$screenRowCache,c=this.$getRowCacheIndex(l,e),h=l.length;if(h&&c>=0)var s=l[c],r=this.$docRowCache[c],d=e>l[h-1];else var d=!h;for(var u=this.getLength()-1,f=this.getNextFoldLine(r),p=f?f.start.row:1/0;s<=e&&(a=this.getRowLength(r),!(s+a>e||r>=u));)s+=a,r++,r>p&&(r=f.end.row+1,f=this.getNextFoldLine(r,f),p=f?f.start.row:1/0),d&&(this.$docRowCache.push(r),this.$screenRowCache.push(s));
	if(f&&f.start.row<=r)i=this.getFoldDisplayLine(f),r=f.start.row;else{if(s+a<=e||r>u)return{row:u,column:this.getLine(u).length};i=this.getLine(r),f=null}var m=0;if(this.$useWrapMode){var g=this.$wrapData[r];if(g){var v=Math.floor(e-s);n=g[v],v>0&&g.length&&(m=g.indent,o=g[v-1]||g[g.length-1],i=i.substring(o))}}return o+=this.$getStringScreenWidth(i,t-m)[1],this.$useWrapMode&&o>=n&&(o=n-1),f?f.idxToPosition(o):{row:r,column:o}},this.documentToScreenPosition=function(e,t){if("undefined"==typeof t)var i=this.$clipPositionToDocument(e.row,e.column);else i=this.$clipPositionToDocument(e,t);e=i.row,t=i.column;var n=0,r=null,o=null;o=this.getFoldAt(e,t,1),o&&(e=o.start.row,t=o.start.column);var s,a=0,l=this.$docRowCache,c=this.$getRowCacheIndex(l,e),h=l.length;if(h&&c>=0)var a=l[c],n=this.$screenRowCache[c],d=e>l[h-1];else var d=!h;for(var u=this.getNextFoldLine(a),f=u?u.start.row:1/0;a<e;){if(a>=f){if(s=u.end.row+1,s>e)break;u=this.getNextFoldLine(s,u),f=u?u.start.row:1/0}else s=a+1;n+=this.getRowLength(a),a=s,d&&(this.$docRowCache.push(a),this.$screenRowCache.push(n))}var p="";u&&a>=f?(p=this.getFoldDisplayLine(u,e,t),r=u.start.row):(p=this.getLine(e).substring(0,t),r=e);var m=0;if(this.$useWrapMode){var g=this.$wrapData[r];if(g){for(var v=0;p.length>=g[v];)n++,v++;p=p.substring(g[v-1]||0,p.length),m=v>0?g.indent:0}}return{row:n,column:m+this.$getStringScreenWidth(p)[0]}},this.documentToScreenColumn=function(e,t){return this.documentToScreenPosition(e,t).column},this.documentToScreenRow=function(e,t){return this.documentToScreenPosition(e,t).row},this.getScreenLength=function(){var e=0,t=null;if(this.$useWrapMode)for(var i=this.$wrapData.length,n=0,r=0,t=this.$foldData[r++],o=t?t.start.row:1/0;n<i;){var s=this.$wrapData[n];e+=s?s.length+1:1,n++,n>o&&(n=t.end.row+1,t=this.$foldData[r++],o=t?t.start.row:1/0)}else{e=this.getLength();for(var a=this.$foldData,r=0;r<a.length;r++)t=a[r],e-=t.end.row-t.start.row}return this.lineWidgets&&(e+=this.$getWidgetScreenLength()),e},this.$setFontMetrics=function(e){this.$enableVarChar&&(this.$getStringScreenWidth=function(t,i,n){if(0===i)return[0,0];i||(i=1/0),n=n||0;var r,o;for(o=0;o<t.length&&(r=t.charAt(o),n+="\t"===r?this.getScreenTabSize(n):e.getCharacterWidth(r),!(n>i));o++);return[n,o]})},this.destroy=function(){this.bgTokenizer&&(this.bgTokenizer.setDocument(null),this.bgTokenizer=null),this.$stopWorker()}}).call(f.prototype),e("./edit_session/folding").Folding.call(f.prototype),e("./edit_session/bracket_match").BracketMatch.call(f.prototype),o.defineOptions(f.prototype,"session",{wrap:{set:function(e){if(e&&"off"!=e?"free"==e?e=!0:"printMargin"==e?e=-1:"string"==typeof e&&(e=parseInt(e,10)||!1):e=!1,this.$wrap!=e)if(this.$wrap=e,e){var t="number"==typeof e?e:null;this.setWrapLimitRange(t,t),this.setUseWrapMode(!0)}else this.setUseWrapMode(!1)},get:function(){return this.getUseWrapMode()?this.$wrap==-1?"printMargin":this.getWrapLimitRange().min?this.$wrap:"free":"off"},handlesSet:!0},wrapMethod:{set:function(e){e="auto"==e?"text"!=this.$mode.type:"text"!=e,e!=this.$wrapAsCode&&(this.$wrapAsCode=e,this.$useWrapMode&&(this.$modified=!0,this.$resetRowCache(0),this.$updateWrapData(0,this.getLength()-1)))},initialValue:"auto"},indentedSoftWrap:{initialValue:!0},firstLineNumber:{set:function(){this._signal("changeBreakpoint")},initialValue:1},useWorker:{set:function(e){this.$useWorker=e,this.$stopWorker(),e&&this.$startWorker()},initialValue:!0},useSoftTabs:{initialValue:!0},tabSize:{set:function(e){isNaN(e)||this.$tabSize===e||(this.$modified=!0,this.$rowLengthCache=[],this.$tabSize=e,this._signal("changeTabSize"))},initialValue:4,handlesSet:!0},overwrite:{set:function(e){this._signal("changeOverwrite")},initialValue:!1},newLineMode:{set:function(e){this.doc.setNewLineMode(e)},get:function(){return this.doc.getNewLineMode()},handlesSet:!0},mode:{set:function(e){this.setMode(e)},get:function(){return this.$modeId}}}),t.EditSession=f}),ace.define("ace/search",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"],function(e,t,i){"use strict";var n=e("./lib/lang"),r=e("./lib/oop"),o=e("./range").Range,s=function(){this.$options={}};(function(){this.set=function(e){return r.mixin(this.$options,e),this},this.getOptions=function(){return n.copyObject(this.$options)},this.setOptions=function(e){this.$options=e},this.find=function(e){var t=this.$options,i=this.$matchIterator(e,t);if(!i)return!1;var n=null;return i.forEach(function(e,i,r){if(e.start)n=e;else{var s=e.offset+(r||0);if(n=new o(i,s,i,s+e.length),!e.length&&t.start&&t.start.start&&0!=t.skipCurrent&&n.isEqual(t.start))return n=null,!1}return!0}),n},this.findAll=function(e){var t=this.$options;if(!t.needle)return[];this.$assembleRegExp(t);var i=t.range,r=i?e.getLines(i.start.row,i.end.row):e.doc.getAllLines(),s=[],a=t.re;if(t.$isMultiLine){var l,c=a.length,h=r.length-c;e:for(var d=a.offset||0;d<=h;d++){for(var u=0;u<c;u++)if(r[d+u].search(a[u])==-1)continue e;var f=r[d],p=r[d+c-1],m=f.length-f.match(a[0])[0].length,g=p.match(a[c-1])[0].length;l&&l.end.row===d&&l.end.column>m||(s.push(l=new o(d,m,d+c-1,g)),c>2&&(d=d+c-2))}}else for(var v=0;v<r.length;v++)for(var y=n.getMatchOffsets(r[v],a),u=0;u<y.length;u++){var w=y[u];s.push(new o(v,w.offset,v,w.offset+w.length))}if(i){for(var b=i.start.column,A=i.start.column,v=0,u=s.length-1;v<u&&s[v].start.column<b&&s[v].start.row==i.start.row;)v++;for(;v<u&&s[u].end.column>A&&s[u].end.row==i.end.row;)u--;for(s=s.slice(v,u+1),v=0,u=s.length;v<u;v++)s[v].start.row+=i.start.row,s[v].end.row+=i.start.row}return s},this.replace=function(e,t){var i=this.$options,n=this.$assembleRegExp(i);if(i.$isMultiLine)return t;if(n){var r=n.exec(e);if(!r||r[0].length!=e.length)return null;if(t=e.replace(n,t),i.preserveCase){t=t.split("");for(var o=Math.min(e.length,e.length);o--;){var s=e[o];s&&s.toLowerCase()!=s?t[o]=t[o].toUpperCase():t[o]=t[o].toLowerCase()}t=t.join("")}return t}},this.$matchIterator=function(e,t){var i=this.$assembleRegExp(t);if(!i)return!1;var r;if(t.$isMultiLine)var s=i.length,a=function(t,n,a){var l=t.search(i[0]);if(l!=-1){for(var c=1;c<s;c++)if(t=e.getLine(n+c),t.search(i[c])==-1)return;var h=t.match(i[s-1])[0].length,d=new o(n,l,n+s-1,h);return 1==i.offset?(d.start.row--,d.start.column=Number.MAX_VALUE):a&&(d.start.column+=a),!!r(d)||void 0}};else if(t.backwards)var a=function(e,t,o){for(var s=n.getMatchOffsets(e,i),a=s.length-1;a>=0;a--)if(r(s[a],t,o))return!0};else var a=function(e,t,o){for(var s=n.getMatchOffsets(e,i),a=0;a<s.length;a++)if(r(s[a],t,o))return!0};var l=this.$lineIterator(e,t);return{forEach:function(e){r=e,l.forEach(a)}}},this.$assembleRegExp=function(e,t){if(e.needle instanceof RegExp)return e.re=e.needle;var i=e.needle;if(!e.needle)return e.re=!1;e.regExp||(i=n.escapeRegExp(i)),e.wholeWord&&(i="\\b"+i+"\\b");var r=e.caseSensitive?"gm":"gmi";if(e.$isMultiLine=!t&&/[\n\r]/.test(i),e.$isMultiLine)return e.re=this.$assembleMultilineRegExp(i,r);try{var o=new RegExp(i,r)}catch(e){o=!1}return e.re=o},this.$assembleMultilineRegExp=function(e,t){for(var i=e.replace(/\r\n|\r|\n/g,"$\n^").split("\n"),n=[],r=0;r<i.length;r++)try{n.push(new RegExp(i[r],t))}catch(e){return!1}return""==i[0]?(n.shift(),n.offset=1):n.offset=0,n},this.$lineIterator=function(e,t){var i=1==t.backwards,n=0!=t.skipCurrent,r=t.range,o=t.start;o||(o=r?r[i?"end":"start"]:e.selection.getRange()),o.start&&(o=o[n!=i?"end":"start"]);var s=r?r.start.row:0,a=r?r.end.row:e.getLength()-1,l=i?function(i){var n=o.row,r=e.getLine(n).substring(0,o.column);if(!i(r,n)){for(n--;n>=s;n--)if(i(e.getLine(n),n))return;if(0!=t.wrap)for(n=a,s=o.row;n>=s;n--)if(i(e.getLine(n),n))return}}:function(i){var n=o.row,r=e.getLine(n).substr(o.column);if(!i(r,n,o.column)){for(n+=1;n<=a;n++)if(i(e.getLine(n),n))return;if(0!=t.wrap)for(n=s,a=o.row;n<=a;n++)if(i(e.getLine(n),n))return}};return{forEach:l}}}).call(s.prototype),t.Search=s}),ace.define("ace/keyboard/hash_handler",["require","exports","module","ace/lib/keys","ace/lib/useragent"],function(e,t,i){"use strict";function n(e,t){this.platform=t||(s.isMac?"mac":"win"),this.commands={},this.commandKeyBinding={},this.addCommands(e),this.$singleCommand=!0}function r(e,t){n.call(this,e,t),this.$singleCommand=!1}var o=e("../lib/keys"),s=e("../lib/useragent"),a=o.KEY_MODS;r.prototype=n.prototype,function(){function e(e){return"object"==typeof e&&e.bindKey&&e.bindKey.position||0}this.addCommand=function(e){this.commands[e.name]&&this.removeCommand(e),this.commands[e.name]=e,e.bindKey&&this._buildKeyHash(e)},this.removeCommand=function(e,t){var i=e&&("string"==typeof e?e:e.name);e=this.commands[i],t||delete this.commands[i];var n=this.commandKeyBinding;for(var r in n){var o=n[r];if(o==e)delete n[r];else if(Array.isArray(o)){var s=o.indexOf(e);s!=-1&&(o.splice(s,1),1==o.length&&(n[r]=o[0]))}}},this.bindKey=function(e,t,i){if("object"==typeof e&&e&&(void 0==i&&(i=e.position),e=e[this.platform]),e)return"function"==typeof t?this.addCommand({exec:t,bindKey:e,name:t.name||e}):void e.split("|").forEach(function(e){var n="";if(e.indexOf(" ")!=-1){var r=e.split(/\s+/);e=r.pop(),r.forEach(function(e){var t=this.parseKeys(e),i=a[t.hashId]+t.key;n+=(n?" ":"")+i,this._addCommandToBinding(n,"chainKeys")},this),n+=" "}var o=this.parseKeys(e),s=a[o.hashId]+o.key;this._addCommandToBinding(n+s,t,i)},this)},this._addCommandToBinding=function(t,i,n){var r,o=this.commandKeyBinding;if(i)if(!o[t]||this.$singleCommand)o[t]=i;else{Array.isArray(o[t])?(r=o[t].indexOf(i))!=-1&&o[t].splice(r,1):o[t]=[o[t]],"number"!=typeof n&&(n=n||i.isDefault?-100:e(i));var s=o[t];for(r=0;r<s.length;r++){var a=s[r],l=e(a);if(l>n)break}s.splice(r,0,i)}else delete o[t]},this.addCommands=function(e){e&&Object.keys(e).forEach(function(t){var i=e[t];if(i){if("string"==typeof i)return this.bindKey(i,t);"function"==typeof i&&(i={exec:i}),"object"==typeof i&&(i.name||(i.name=t),this.addCommand(i))}},this)},this.removeCommands=function(e){Object.keys(e).forEach(function(t){this.removeCommand(e[t])},this)},this.bindKeys=function(e){Object.keys(e).forEach(function(t){this.bindKey(t,e[t])},this)},this._buildKeyHash=function(e){this.bindKey(e.bindKey,e)},this.parseKeys=function(e){var t=e.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(e){return e}),i=t.pop(),n=o[i];if(o.FUNCTION_KEYS[n])i=o.FUNCTION_KEYS[n].toLowerCase();else{if(!t.length)return{key:i,hashId:-1};if(1==t.length&&"shift"==t[0])return{key:i.toUpperCase(),hashId:-1}}for(var r=0,s=t.length;s--;){var a=o.KEY_MODS[t[s]];if(null==a)return"undefined"!=typeof console&&console.error("invalid modifier "+t[s]+" in "+e),!1;r|=a}return{key:i,hashId:r}},this.findKeyCommand=function(e,t){var i=a[e]+t;return this.commandKeyBinding[i]},this.handleKeyboard=function(e,t,i,n){if(!(n<0)){var r=a[t]+i,o=this.commandKeyBinding[r];return e.$keyChain&&(e.$keyChain+=" "+r,o=this.commandKeyBinding[e.$keyChain]||o),!o||"chainKeys"!=o&&"chainKeys"!=o[o.length-1]?(e.$keyChain&&(t&&4!=t||1!=i.length?(t==-1||n>0)&&(e.$keyChain=""):e.$keyChain=e.$keyChain.slice(0,-r.length-1)),{command:o}):(e.$keyChain=e.$keyChain||r,{command:"null"})}},this.getStatusText=function(e,t){return t.$keyChain||""}}.call(n.prototype),t.HashHandler=n,t.MultiHashHandler=r}),ace.define("ace/commands/command_manager",["require","exports","module","ace/lib/oop","ace/keyboard/hash_handler","ace/lib/event_emitter"],function(e,t,i){"use strict";var n=e("../lib/oop"),r=e("../keyboard/hash_handler").MultiHashHandler,o=e("../lib/event_emitter").EventEmitter,s=function(e,t){r.call(this,t,e),this.byName=this.commands,this.setDefaultHandler("exec",function(e){return e.command.exec(e.editor,e.args||{})})};n.inherits(s,r),function(){n.implement(this,o),this.exec=function(e,t,i){if(Array.isArray(e)){for(var n=e.length;n--;)if(this.exec(e[n],t,i))return!0;return!1}if("string"==typeof e&&(e=this.commands[e]),!e)return!1;if(t&&t.$readOnly&&!e.readOnly)return!1;var r={editor:t,command:e,args:i};return r.returnValue=this._emit("exec",r),this._signal("afterExec",r),r.returnValue!==!1},this.toggleRecording=function(e){if(!this.$inReplay)return e&&e._emit("changeStatus"),this.recording?(this.macro.pop(),this.removeEventListener("exec",this.$addCommandToMacro),this.macro.length||(this.macro=this.oldMacro),this.recording=!1):(this.$addCommandToMacro||(this.$addCommandToMacro=function(e){this.macro.push([e.command,e.args])}.bind(this)),this.oldMacro=this.macro,this.macro=[],this.on("exec",this.$addCommandToMacro),this.recording=!0)},this.replay=function(e){if(!this.$inReplay&&this.macro){if(this.recording)return this.toggleRecording(e);try{this.$inReplay=!0,this.macro.forEach(function(t){"string"==typeof t?this.exec(t,e):this.exec(t[0],e,t[1])},this)}finally{this.$inReplay=!1}}},this.trimMacro=function(e){return e.map(function(e){return"string"!=typeof e[0]&&(e[0]=e[0].name),e[1]||(e=e[0]),e})}}.call(s.prototype),t.CommandManager=s}),ace.define("ace/commands/default_commands",["require","exports","module","ace/lib/lang","ace/config","ace/range"],function(e,t,i){"use strict";function n(e,t){return{win:e,mac:t}}var r=e("../lib/lang"),o=e("../config"),s=e("../range").Range;t.commands=[{name:"showSettingsMenu",bindKey:n("Ctrl-,","Command-,"),exec:function(e){o.loadModule("ace/ext/settings_menu",function(t){t.init(e),e.showSettingsMenu()})},readOnly:!0},{name:"goToNextError",bindKey:n("Alt-E","Ctrl-E"),exec:function(e){o.loadModule("ace/ext/error_marker",function(t){t.showErrorMarker(e,1)})},scrollIntoView:"animate",readOnly:!0},{name:"goToPreviousError",bindKey:n("Alt-Shift-E","Ctrl-Shift-E"),exec:function(e){o.loadModule("ace/ext/error_marker",function(t){t.showErrorMarker(e,-1)})},scrollIntoView:"animate",readOnly:!0},{name:"selectall",bindKey:n("Ctrl-A","Command-A"),exec:function(e){e.selectAll()},readOnly:!0},{name:"centerselection",bindKey:n(null,"Ctrl-L"),exec:function(e){e.centerSelection()},readOnly:!0},{name:"gotoline",bindKey:n("Ctrl-L","Command-L"),exec:function(e){var t=parseInt(prompt("Enter line number:"),10);isNaN(t)||e.gotoLine(t)},readOnly:!0},{name:"fold",bindKey:n("Alt-L|Ctrl-F1","Command-Alt-L|Command-F1"),exec:function(e){e.session.toggleFold(!1)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"unfold",bindKey:n("Alt-Shift-L|Ctrl-Shift-F1","Command-Alt-Shift-L|Command-Shift-F1"),exec:function(e){e.session.toggleFold(!0)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"toggleFoldWidget",bindKey:n("F2","F2"),exec:function(e){e.session.toggleFoldWidget()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"toggleParentFoldWidget",bindKey:n("Alt-F2","Alt-F2"),exec:function(e){e.session.toggleFoldWidget(!0)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"foldall",bindKey:n(null,"Ctrl-Command-Option-0"),exec:function(e){e.session.foldAll()},scrollIntoView:"center",readOnly:!0},{name:"foldOther",bindKey:n("Alt-0","Command-Option-0"),exec:function(e){e.session.foldAll(),e.session.unfold(e.selection.getAllRanges())},scrollIntoView:"center",readOnly:!0},{name:"unfoldall",bindKey:n("Alt-Shift-0","Command-Option-Shift-0"),exec:function(e){e.session.unfold()},scrollIntoView:"center",readOnly:!0},{name:"findnext",bindKey:n("Ctrl-K","Command-G"),exec:function(e){e.findNext()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"findprevious",bindKey:n("Ctrl-Shift-K","Command-Shift-G"),exec:function(e){e.findPrevious()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"selectOrFindNext",bindKey:n("Alt-K","Ctrl-G"),exec:function(e){e.selection.isEmpty()?e.selection.selectWord():e.findNext()},readOnly:!0},{name:"selectOrFindPrevious",bindKey:n("Alt-Shift-K","Ctrl-Shift-G"),exec:function(e){e.selection.isEmpty()?e.selection.selectWord():e.findPrevious()},readOnly:!0},{name:"find",bindKey:n("Ctrl-F","Command-F"),exec:function(e){o.loadModule("ace/ext/searchbox",function(t){t.Search(e)})},readOnly:!0},{name:"overwrite",bindKey:"Insert",exec:function(e){e.toggleOverwrite()},readOnly:!0},{name:"selecttostart",bindKey:n("Ctrl-Shift-Home","Command-Shift-Up"),exec:function(e){e.getSelection().selectFileStart()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"gotostart",bindKey:n("Ctrl-Home","Command-Home|Command-Up"),exec:function(e){e.navigateFileStart()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"selectup",bindKey:n("Shift-Up","Shift-Up"),exec:function(e){e.getSelection().selectUp()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"golineup",bindKey:n("Up","Up|Ctrl-P"),exec:function(e,t){e.navigateUp(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttoend",bindKey:n("Ctrl-Shift-End","Command-Shift-Down"),exec:function(e){e.getSelection().selectFileEnd()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"gotoend",bindKey:n("Ctrl-End","Command-End|Command-Down"),exec:function(e){e.navigateFileEnd()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"selectdown",bindKey:n("Shift-Down","Shift-Down"),exec:function(e){e.getSelection().selectDown()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"golinedown",bindKey:n("Down","Down|Ctrl-N"),exec:function(e,t){e.navigateDown(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectwordleft",bindKey:n("Ctrl-Shift-Left","Option-Shift-Left"),exec:function(e){e.getSelection().selectWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotowordleft",bindKey:n("Ctrl-Left","Option-Left"),exec:function(e){e.navigateWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttolinestart",bindKey:n("Alt-Shift-Left","Command-Shift-Left"),exec:function(e){e.getSelection().selectLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotolinestart",bindKey:n("Alt-Left|Home","Command-Left|Home|Ctrl-A"),exec:function(e){e.navigateLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectleft",bindKey:n("Shift-Left","Shift-Left"),exec:function(e){e.getSelection().selectLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotoleft",bindKey:n("Left","Left|Ctrl-B"),exec:function(e,t){e.navigateLeft(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectwordright",bindKey:n("Ctrl-Shift-Right","Option-Shift-Right"),exec:function(e){e.getSelection().selectWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotowordright",bindKey:n("Ctrl-Right","Option-Right"),exec:function(e){e.navigateWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttolineend",bindKey:n("Alt-Shift-Right","Command-Shift-Right"),exec:function(e){e.getSelection().selectLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotolineend",bindKey:n("Alt-Right|End","Command-Right|End|Ctrl-E"),exec:function(e){e.navigateLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectright",bindKey:n("Shift-Right","Shift-Right"),exec:function(e){e.getSelection().selectRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotoright",bindKey:n("Right","Right|Ctrl-F"),exec:function(e,t){e.navigateRight(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectpagedown",bindKey:"Shift-PageDown",exec:function(e){e.selectPageDown()},readOnly:!0},{name:"pagedown",bindKey:n(null,"Option-PageDown"),exec:function(e){e.scrollPageDown()},readOnly:!0},{name:"gotopagedown",bindKey:n("PageDown","PageDown|Ctrl-V"),exec:function(e){e.gotoPageDown()},readOnly:!0},{name:"selectpageup",bindKey:"Shift-PageUp",exec:function(e){e.selectPageUp()},readOnly:!0},{name:"pageup",bindKey:n(null,"Option-PageUp"),exec:function(e){e.scrollPageUp()},readOnly:!0},{name:"gotopageup",bindKey:"PageUp",exec:function(e){e.gotoPageUp()},readOnly:!0},{name:"scrollup",bindKey:n("Ctrl-Up",null),exec:function(e){e.renderer.scrollBy(0,-2*e.renderer.layerConfig.lineHeight)},readOnly:!0},{name:"scrolldown",bindKey:n("Ctrl-Down",null),exec:function(e){e.renderer.scrollBy(0,2*e.renderer.layerConfig.lineHeight)},readOnly:!0},{name:"selectlinestart",bindKey:"Shift-Home",exec:function(e){e.getSelection().selectLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectlineend",bindKey:"Shift-End",exec:function(e){e.getSelection().selectLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"togglerecording",bindKey:n("Ctrl-Alt-E","Command-Option-E"),exec:function(e){e.commands.toggleRecording(e)},readOnly:!0},{name:"replaymacro",bindKey:n("Ctrl-Shift-E","Command-Shift-E"),exec:function(e){e.commands.replay(e)},readOnly:!0},{name:"jumptomatching",bindKey:n("Ctrl-P","Ctrl-P"),exec:function(e){e.jumpToMatching()},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"selecttomatching",bindKey:n("Ctrl-Shift-P","Ctrl-Shift-P"),exec:function(e){e.jumpToMatching(!0)},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"expandToMatching",bindKey:n("Ctrl-Shift-M","Ctrl-Shift-M"),exec:function(e){e.jumpToMatching(!0,!0)},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"passKeysToBrowser",bindKey:n(null,null),exec:function(){},passEvent:!0,readOnly:!0},{name:"copy",exec:function(e){},readOnly:!0},{name:"cut",exec:function(e){var t=e.getSelectionRange();e._emit("cut",t),e.selection.isEmpty()||(e.session.remove(t),e.clearSelection())},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"paste",exec:function(e,t){e.$handlePaste(t)},scrollIntoView:"cursor"},{name:"removeline",bindKey:n("Ctrl-D","Command-D"),exec:function(e){e.removeLines()},scrollIntoView:"cursor",multiSelectAction:"forEachLine"},{name:"duplicateSelection",bindKey:n("Ctrl-Shift-D","Command-Shift-D"),exec:function(e){e.duplicateSelection()},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"sortlines",bindKey:n("Ctrl-Alt-S","Command-Alt-S"),exec:function(e){e.sortLines()},scrollIntoView:"selection",multiSelectAction:"forEachLine"},{name:"togglecomment",bindKey:n("Ctrl-/","Command-/"),exec:function(e){e.toggleCommentLines()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"toggleBlockComment",bindKey:n("Ctrl-Shift-/","Command-Shift-/"),exec:function(e){e.toggleBlockComment()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"modifyNumberUp",bindKey:n("Ctrl-Shift-Up","Alt-Shift-Up"),exec:function(e){e.modifyNumber(1)},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"modifyNumberDown",bindKey:n("Ctrl-Shift-Down","Alt-Shift-Down"),exec:function(e){e.modifyNumber(-1)},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"replace",bindKey:n("Ctrl-H","Command-Option-F"),exec:function(e){o.loadModule("ace/ext/searchbox",function(t){t.Search(e,!0)})}},{name:"undo",bindKey:n("Ctrl-Z","Command-Z"),exec:function(e){e.undo()}},{name:"redo",bindKey:n("Ctrl-Shift-Z|Ctrl-Y","Command-Shift-Z|Command-Y"),exec:function(e){e.redo()}},{name:"copylinesup",bindKey:n("Alt-Shift-Up","Command-Option-Up"),exec:function(e){e.copyLinesUp()},scrollIntoView:"cursor"},{name:"movelinesup",bindKey:n("Alt-Up","Option-Up"),exec:function(e){e.moveLinesUp()},scrollIntoView:"cursor"},{name:"copylinesdown",bindKey:n("Alt-Shift-Down","Command-Option-Down"),exec:function(e){e.copyLinesDown()},scrollIntoView:"cursor"},{name:"movelinesdown",bindKey:n("Alt-Down","Option-Down"),exec:function(e){e.moveLinesDown()},scrollIntoView:"cursor"},{name:"del",bindKey:n("Delete","Delete|Ctrl-D|Shift-Delete"),exec:function(e){e.remove("right")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"backspace",bindKey:n("Shift-Backspace|Backspace","Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),exec:function(e){e.remove("left")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"cut_or_delete",bindKey:n("Shift-Delete",null),exec:function(e){return!!e.selection.isEmpty()&&void e.remove("left")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolinestart",bindKey:n("Alt-Backspace","Command-Backspace"),exec:function(e){e.removeToLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolineend",bindKey:n("Alt-Delete","Ctrl-K"),exec:function(e){e.removeToLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removewordleft",bindKey:n("Ctrl-Backspace","Alt-Backspace|Ctrl-Alt-Backspace"),exec:function(e){e.removeWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removewordright",bindKey:n("Ctrl-Delete","Alt-Delete"),exec:function(e){e.removeWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"outdent",bindKey:n("Shift-Tab","Shift-Tab"),exec:function(e){e.blockOutdent()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"indent",bindKey:n("Tab","Tab"),exec:function(e){e.indent()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"blockoutdent",bindKey:n("Ctrl-[","Ctrl-["),exec:function(e){e.blockOutdent()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"blockindent",bindKey:n("Ctrl-]","Ctrl-]"),exec:function(e){e.blockIndent()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"insertstring",exec:function(e,t){e.insert(t)},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"inserttext",exec:function(e,t){e.insert(r.stringRepeat(t.text||"",t.times||1))},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"splitline",bindKey:n(null,"Ctrl-O"),exec:function(e){e.splitLine()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"transposeletters",bindKey:n("Ctrl-T","Ctrl-T"),exec:function(e){e.transposeLetters()},multiSelectAction:function(e){e.transposeSelections(1)},scrollIntoView:"cursor"},{name:"touppercase",bindKey:n("Ctrl-U","Ctrl-U"),exec:function(e){e.toUpperCase()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"tolowercase",bindKey:n("Ctrl-Shift-U","Ctrl-Shift-U"),exec:function(e){e.toLowerCase()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"expandtoline",bindKey:n("Ctrl-Shift-L","Command-Shift-L"),exec:function(e){var t=e.selection.getRange();t.start.column=t.end.column=0,t.end.row++,e.selection.setRange(t,!1)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"joinlines",bindKey:n(null,null),exec:function(e){for(var t=e.selection.isBackwards(),i=t?e.selection.getSelectionLead():e.selection.getSelectionAnchor(),n=t?e.selection.getSelectionAnchor():e.selection.getSelectionLead(),o=e.session.doc.getLine(i.row).length,a=e.session.doc.getTextRange(e.selection.getRange()),l=a.replace(/\n\s*/," ").length,c=e.session.doc.getLine(i.row),h=i.row+1;h<=n.row+1;h++){var d=r.stringTrimLeft(r.stringTrimRight(e.session.doc.getLine(h)));0!==d.length&&(d=" "+d),c+=d}n.row+1<e.session.doc.getLength()-1&&(c+=e.session.doc.getNewLineCharacter()),e.clearSelection(),e.session.doc.replace(new s(i.row,0,n.row+2,0),c),l>0?(e.selection.moveCursorTo(i.row,i.column),e.selection.selectTo(i.row,i.column+l)):(o=e.session.doc.getLine(i.row).length>o?o+1:o,e.selection.moveCursorTo(i.row,o))},multiSelectAction:"forEach",readOnly:!0},{name:"invertSelection",bindKey:n(null,null),exec:function(e){var t=e.session.doc.getLength()-1,i=e.session.doc.getLine(t).length,n=e.selection.rangeList.ranges,r=[];n.length<1&&(n=[e.selection.getRange()]);for(var o=0;o<n.length;o++)o==n.length-1&&(n[o].end.row===t&&n[o].end.column===i||r.push(new s(n[o].end.row,n[o].end.column,t,i))),0===o?0===n[o].start.row&&0===n[o].start.column||r.push(new s(0,0,n[o].start.row,n[o].start.column)):r.push(new s(n[o-1].end.row,n[o-1].end.column,n[o].start.row,n[o].start.column));e.exitMultiSelectMode(),e.clearSelection();for(var o=0;o<r.length;o++)e.selection.addRange(r[o],!1)},readOnly:!0,scrollIntoView:"none"}]}),ace.define("ace/editor",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/keyboard/textinput","ace/mouse/mouse_handler","ace/mouse/fold_handler","ace/keyboard/keybinding","ace/edit_session","ace/search","ace/range","ace/lib/event_emitter","ace/commands/command_manager","ace/commands/default_commands","ace/config","ace/token_iterator"],function(e,t,i){"use strict";e("./lib/fixoldbrowsers");var n=e("./lib/oop"),r=e("./lib/dom"),o=e("./lib/lang"),s=e("./lib/useragent"),a=e("./keyboard/textinput").TextInput,l=e("./mouse/mouse_handler").MouseHandler,c=e("./mouse/fold_handler").FoldHandler,h=e("./keyboard/keybinding").KeyBinding,d=e("./edit_session").EditSession,u=e("./search").Search,f=e("./range").Range,p=e("./lib/event_emitter").EventEmitter,m=e("./commands/command_manager").CommandManager,g=e("./commands/default_commands").commands,v=e("./config"),y=e("./token_iterator").TokenIterator,w=function(e,t){var i=e.getContainerElement();this.container=i,this.renderer=e,this.commands=new m(s.isMac?"mac":"win",g),this.textInput=new a(e.getTextAreaContainer(),this),this.renderer.textarea=this.textInput.getElement(),this.keyBinding=new h(this),this.$mouseHandler=new l(this),new c(this),this.$blockScrolling=0,this.$search=(new u).set({wrap:!0}),this.$historyTracker=this.$historyTracker.bind(this),this.commands.on("exec",this.$historyTracker),this.$initOperationListeners(),this._$emitInputEvent=o.delayedCall(function(){this._signal("input",{}),this.session&&this.session.bgTokenizer&&this.session.bgTokenizer.scheduleStart()}.bind(this)),this.on("change",function(e,t){t._$emitInputEvent.schedule(31)}),this.setSession(t||new d("")),v.resetOptions(this),v._signal("editor",this)};(function(){n.implement(this,p),this.$initOperationListeners=function(){this.selections=[],this.commands.on("exec",this.startOperation.bind(this),!0),this.commands.on("afterExec",this.endOperation.bind(this),!0),this.$opResetTimer=o.delayedCall(this.endOperation.bind(this)),this.on("change",function(){this.curOp||this.startOperation(),this.curOp.docChanged=!0}.bind(this),!0),this.on("changeSelection",function(){this.curOp||this.startOperation(),this.curOp.selectionChanged=!0}.bind(this),!0)},this.curOp=null,this.prevOp={},this.startOperation=function(e){if(this.curOp){if(!e||this.curOp.command)return;this.prevOp=this.curOp}e||(this.previousCommand=null,e={}),this.$opResetTimer.schedule(),this.curOp={command:e.command||{},args:e.args,scrollTop:this.renderer.scrollTop},this.curOp.command.name&&void 0!==this.curOp.command.scrollIntoView&&this.$blockScrolling++},this.endOperation=function(e){if(this.curOp){if(e&&e.returnValue===!1)return this.curOp=null;this._signal("beforeEndOperation");var t=this.curOp.command;t.name&&this.$blockScrolling>0&&this.$blockScrolling--;var i=t&&t.scrollIntoView;if(i){switch(i){case"center-animate":i="animate";case"center":this.renderer.scrollCursorIntoView(null,.5);break;case"animate":case"cursor":this.renderer.scrollCursorIntoView();break;case"selectionPart":var n=this.selection.getRange(),r=this.renderer.layerConfig;(n.start.row>=r.lastRow||n.end.row<=r.firstRow)&&this.renderer.scrollSelectionIntoView(this.selection.anchor,this.selection.lead)}"animate"==i&&this.renderer.animateScrolling(this.curOp.scrollTop)}this.prevOp=this.curOp,this.curOp=null}},this.$mergeableCommands=["backspace","del","insertstring"],this.$historyTracker=function(e){if(this.$mergeUndoDeltas){var t=this.prevOp,i=this.$mergeableCommands,n=t.command&&e.command.name==t.command.name;if("insertstring"==e.command.name){var r=e.args;void 0===this.mergeNextCommand&&(this.mergeNextCommand=!0),n=n&&this.mergeNextCommand&&(!/\s/.test(r)||/\s/.test(t.args)),this.mergeNextCommand=!0}else n=n&&i.indexOf(e.command.name)!==-1;"always"!=this.$mergeUndoDeltas&&Date.now()-this.sequenceStartTime>2e3&&(n=!1),
	n?this.session.mergeUndoDeltas=!0:i.indexOf(e.command.name)!==-1&&(this.sequenceStartTime=Date.now())}},this.setKeyboardHandler=function(e,t){if(e&&"string"==typeof e){this.$keybindingId=e;var i=this;v.loadModule(["keybinding",e],function(n){i.$keybindingId==e&&i.keyBinding.setKeyboardHandler(n&&n.handler),t&&t()})}else this.$keybindingId=null,this.keyBinding.setKeyboardHandler(e),t&&t()},this.getKeyboardHandler=function(){return this.keyBinding.getKeyboardHandler()},this.setSession=function(e){if(this.session!=e){this.curOp&&this.endOperation(),this.curOp={};var t=this.session;if(t){this.session.off("change",this.$onDocumentChange),this.session.off("changeMode",this.$onChangeMode),this.session.off("tokenizerUpdate",this.$onTokenizerUpdate),this.session.off("changeTabSize",this.$onChangeTabSize),this.session.off("changeWrapLimit",this.$onChangeWrapLimit),this.session.off("changeWrapMode",this.$onChangeWrapMode),this.session.off("changeFold",this.$onChangeFold),this.session.off("changeFrontMarker",this.$onChangeFrontMarker),this.session.off("changeBackMarker",this.$onChangeBackMarker),this.session.off("changeBreakpoint",this.$onChangeBreakpoint),this.session.off("changeAnnotation",this.$onChangeAnnotation),this.session.off("changeOverwrite",this.$onCursorChange),this.session.off("changeScrollTop",this.$onScrollTopChange),this.session.off("changeScrollLeft",this.$onScrollLeftChange);var i=this.session.getSelection();i.off("changeCursor",this.$onCursorChange),i.off("changeSelection",this.$onSelectionChange)}this.session=e,e?(this.$onDocumentChange=this.onDocumentChange.bind(this),e.on("change",this.$onDocumentChange),this.renderer.setSession(e),this.$onChangeMode=this.onChangeMode.bind(this),e.on("changeMode",this.$onChangeMode),this.$onTokenizerUpdate=this.onTokenizerUpdate.bind(this),e.on("tokenizerUpdate",this.$onTokenizerUpdate),this.$onChangeTabSize=this.renderer.onChangeTabSize.bind(this.renderer),e.on("changeTabSize",this.$onChangeTabSize),this.$onChangeWrapLimit=this.onChangeWrapLimit.bind(this),e.on("changeWrapLimit",this.$onChangeWrapLimit),this.$onChangeWrapMode=this.onChangeWrapMode.bind(this),e.on("changeWrapMode",this.$onChangeWrapMode),this.$onChangeFold=this.onChangeFold.bind(this),e.on("changeFold",this.$onChangeFold),this.$onChangeFrontMarker=this.onChangeFrontMarker.bind(this),this.session.on("changeFrontMarker",this.$onChangeFrontMarker),this.$onChangeBackMarker=this.onChangeBackMarker.bind(this),this.session.on("changeBackMarker",this.$onChangeBackMarker),this.$onChangeBreakpoint=this.onChangeBreakpoint.bind(this),this.session.on("changeBreakpoint",this.$onChangeBreakpoint),this.$onChangeAnnotation=this.onChangeAnnotation.bind(this),this.session.on("changeAnnotation",this.$onChangeAnnotation),this.$onCursorChange=this.onCursorChange.bind(this),this.session.on("changeOverwrite",this.$onCursorChange),this.$onScrollTopChange=this.onScrollTopChange.bind(this),this.session.on("changeScrollTop",this.$onScrollTopChange),this.$onScrollLeftChange=this.onScrollLeftChange.bind(this),this.session.on("changeScrollLeft",this.$onScrollLeftChange),this.selection=e.getSelection(),this.selection.on("changeCursor",this.$onCursorChange),this.$onSelectionChange=this.onSelectionChange.bind(this),this.selection.on("changeSelection",this.$onSelectionChange),this.onChangeMode(),this.$blockScrolling+=1,this.onCursorChange(),this.$blockScrolling-=1,this.onScrollTopChange(),this.onScrollLeftChange(),this.onSelectionChange(),this.onChangeFrontMarker(),this.onChangeBackMarker(),this.onChangeBreakpoint(),this.onChangeAnnotation(),this.session.getUseWrapMode()&&this.renderer.adjustWrapLimit(),this.renderer.updateFull()):(this.selection=null,this.renderer.setSession(e)),this._signal("changeSession",{session:e,oldSession:t}),this.curOp=null,t&&t._signal("changeEditor",{oldEditor:this}),e&&e._signal("changeEditor",{editor:this})}},this.getSession=function(){return this.session},this.setValue=function(e,t){return this.session.doc.setValue(e),t?1==t?this.navigateFileEnd():t==-1&&this.navigateFileStart():this.selectAll(),e},this.getValue=function(){return this.session.getValue()},this.getSelection=function(){return this.selection},this.resize=function(e){this.renderer.onResize(e)},this.setTheme=function(e,t){this.renderer.setTheme(e,t)},this.getTheme=function(){return this.renderer.getTheme()},this.setStyle=function(e){this.renderer.setStyle(e)},this.unsetStyle=function(e){this.renderer.unsetStyle(e)},this.getFontSize=function(){return this.getOption("fontSize")||r.computedStyle(this.container,"fontSize")},this.setFontSize=function(e){this.setOption("fontSize",e)},this.$highlightBrackets=function(){if(this.session.$bracketHighlight&&(this.session.removeMarker(this.session.$bracketHighlight),this.session.$bracketHighlight=null),!this.$highlightPending){var e=this;this.$highlightPending=!0,setTimeout(function(){e.$highlightPending=!1;var t=e.session;if(t&&t.bgTokenizer){var i=t.findMatchingBracket(e.getCursorPosition());if(i)var n=new f(i.row,i.column,i.row,i.column+1);else if(t.$mode.getMatching)var n=t.$mode.getMatching(e.session);n&&(t.$bracketHighlight=t.addMarker(n,"ace_bracket","text"))}},50)}},this.$highlightTags=function(){if(!this.$highlightTagPending){var e=this;this.$highlightTagPending=!0,setTimeout(function(){e.$highlightTagPending=!1;var t=e.session;if(t&&t.bgTokenizer){var i=e.getCursorPosition(),n=new y(e.session,i.row,i.column),r=n.getCurrentToken();if(!r||!/\b(?:tag-open|tag-name)/.test(r.type))return t.removeMarker(t.$tagHighlight),void(t.$tagHighlight=null);if(r.type.indexOf("tag-open")==-1||(r=n.stepForward())){var o=r.value,s=0,a=n.stepBackward();if("<"==a.value){do a=r,r=n.stepForward(),r&&r.value===o&&r.type.indexOf("tag-name")!==-1&&("<"===a.value?s++:"</"===a.value&&s--);while(r&&s>=0)}else{do r=a,a=n.stepBackward(),r&&r.value===o&&r.type.indexOf("tag-name")!==-1&&("<"===a.value?s++:"</"===a.value&&s--);while(a&&s<=0);n.stepForward()}if(!r)return t.removeMarker(t.$tagHighlight),void(t.$tagHighlight=null);var l=n.getCurrentTokenRow(),c=n.getCurrentTokenColumn(),h=new f(l,c,l,c+r.value.length);t.$tagHighlight&&0!==h.compareRange(t.$backMarkers[t.$tagHighlight].range)&&(t.removeMarker(t.$tagHighlight),t.$tagHighlight=null),h&&!t.$tagHighlight&&(t.$tagHighlight=t.addMarker(h,"ace_bracket","text"))}}},50)}},this.focus=function(){var e=this;setTimeout(function(){e.textInput.focus()}),this.textInput.focus()},this.isFocused=function(){return this.textInput.isFocused()},this.blur=function(){this.textInput.blur()},this.onFocus=function(e){this.$isFocused||(this.$isFocused=!0,this.renderer.showCursor(),this.renderer.visualizeFocus(),this._emit("focus",e))},this.onBlur=function(e){this.$isFocused&&(this.$isFocused=!1,this.renderer.hideCursor(),this.renderer.visualizeBlur(),this._emit("blur",e))},this.$cursorChange=function(){this.renderer.updateCursor()},this.onDocumentChange=function(e){var t=this.session.$useWrapMode,i=e.start.row==e.end.row?e.end.row:1/0;this.renderer.updateLines(e.start.row,i,t),this._signal("change",e),this.$cursorChange(),this.$updateHighlightActiveLine()},this.onTokenizerUpdate=function(e){var t=e.data;this.renderer.updateLines(t.first,t.last)},this.onScrollTopChange=function(){this.renderer.scrollToY(this.session.getScrollTop())},this.onScrollLeftChange=function(){this.renderer.scrollToX(this.session.getScrollLeft())},this.onCursorChange=function(){this.$cursorChange(),this.$blockScrolling||(v.warn("Automatically scrolling cursor into view after selection change","this will be disabled in the next version","set editor.$blockScrolling = Infinity to disable this message"),this.renderer.scrollCursorIntoView()),this.$highlightBrackets(),this.$highlightTags(),this.$updateHighlightActiveLine(),this._signal("changeSelection")},this.$updateHighlightActiveLine=function(){var e,t=this.getSession();if(this.$highlightActiveLine&&("line"==this.$selectionStyle&&this.selection.isMultiLine()||(e=this.getCursorPosition()),!this.renderer.$maxLines||1!==this.session.getLength()||this.renderer.$minLines>1||(e=!1)),t.$highlightLineMarker&&!e)t.removeMarker(t.$highlightLineMarker.id),t.$highlightLineMarker=null;else if(!t.$highlightLineMarker&&e){var i=new f(e.row,e.column,e.row,1/0);i.id=t.addMarker(i,"ace_active-line","screenLine"),t.$highlightLineMarker=i}else e&&(t.$highlightLineMarker.start.row=e.row,t.$highlightLineMarker.end.row=e.row,t.$highlightLineMarker.start.column=e.column,t._signal("changeBackMarker"))},this.onSelectionChange=function(e){var t=this.session;if(t.$selectionMarker&&t.removeMarker(t.$selectionMarker),t.$selectionMarker=null,this.selection.isEmpty())this.$updateHighlightActiveLine();else{var i=this.selection.getRange(),n=this.getSelectionStyle();t.$selectionMarker=t.addMarker(i,"ace_selection",n)}var r=this.$highlightSelectedWord&&this.$getSelectionHighLightRegexp();this.session.highlight(r),this._signal("changeSelection")},this.$getSelectionHighLightRegexp=function(){var e=this.session,t=this.getSelectionRange();if(!t.isEmpty()&&!t.isMultiLine()){var i=t.start.column-1,n=t.end.column+1,r=e.getLine(t.start.row),o=r.length,s=r.substring(Math.max(i,0),Math.min(n,o));if(!(i>=0&&/^[\w\d]/.test(s)||n<=o&&/[\w\d]$/.test(s))&&(s=r.substring(t.start.column,t.end.column),/^[\w\d]+$/.test(s))){var a=this.$search.$assembleRegExp({wholeWord:!0,caseSensitive:!0,needle:s});return a}}},this.onChangeFrontMarker=function(){this.renderer.updateFrontMarkers()},this.onChangeBackMarker=function(){this.renderer.updateBackMarkers()},this.onChangeBreakpoint=function(){this.renderer.updateBreakpoints()},this.onChangeAnnotation=function(){this.renderer.setAnnotations(this.session.getAnnotations())},this.onChangeMode=function(e){this.renderer.updateText(),this._emit("changeMode",e)},this.onChangeWrapLimit=function(){this.renderer.updateFull()},this.onChangeWrapMode=function(){this.renderer.onResize(!0)},this.onChangeFold=function(){this.$updateHighlightActiveLine(),this.renderer.updateFull()},this.getSelectedText=function(){return this.session.getTextRange(this.getSelectionRange())},this.getCopyText=function(){var e=this.getSelectedText();return this._signal("copy",e),e},this.onCopy=function(){this.commands.exec("copy",this)},this.onCut=function(){this.commands.exec("cut",this)},this.onPaste=function(e,t){var i={text:e,event:t};this.commands.exec("paste",this,i)},this.$handlePaste=function(e){"string"==typeof e&&(e={text:e}),this._signal("paste",e);var t=e.text;if(!this.inMultiSelectMode||this.inVirtualSelectionMode)this.insert(t);else{var i=t.split(/\r\n|\r|\n/),n=this.selection.rangeList.ranges;if(i.length>n.length||i.length<2||!i[1])return this.commands.exec("insertstring",this,t);for(var r=n.length;r--;){var o=n[r];o.isEmpty()||this.session.remove(o),this.session.insert(o.start,i[r])}}},this.execCommand=function(e,t){return this.commands.exec(e,this,t)},this.insert=function(e,t){var i=this.session,n=i.getMode(),r=this.getCursorPosition();if(this.getBehavioursEnabled()&&!t){var o=n.transformAction(i.getState(r.row),"insertion",this,i,e);o&&(e!==o.text&&(this.session.mergeUndoDeltas=!1,this.$mergeNextCommand=!1),e=o.text)}if("\t"==e&&(e=this.session.getTabString()),this.selection.isEmpty()){if(this.session.getOverwrite()){var s=new f.fromPoints(r,r);s.end.column+=e.length,this.session.remove(s)}}else{var s=this.getSelectionRange();r=this.session.remove(s),this.clearSelection()}if("\n"==e||"\r\n"==e){var a=i.getLine(r.row);if(r.column>a.search(/\S|$/)){var l=a.substr(r.column).search(/\S|$/);i.doc.removeInLine(r.row,r.column,r.column+l)}}this.clearSelection();var c=r.column,h=i.getState(r.row),a=i.getLine(r.row),d=n.checkOutdent(h,a,e);i.insert(r,e);if(o&&o.selection&&(2==o.selection.length?this.selection.setSelectionRange(new f(r.row,c+o.selection[0],r.row,c+o.selection[1])):this.selection.setSelectionRange(new f(r.row+o.selection[0],o.selection[1],r.row+o.selection[2],o.selection[3]))),i.getDocument().isNewLine(e)){var u=n.getNextLineIndent(h,a.slice(0,r.column),i.getTabString());i.insert({row:r.row+1,column:0},u)}d&&n.autoOutdent(h,i,r.row)},this.onTextInput=function(e){this.keyBinding.onTextInput(e)},this.onCommandKey=function(e,t,i){this.keyBinding.onCommandKey(e,t,i)},this.setOverwrite=function(e){this.session.setOverwrite(e)},this.getOverwrite=function(){return this.session.getOverwrite()},this.toggleOverwrite=function(){this.session.toggleOverwrite()},this.setScrollSpeed=function(e){this.setOption("scrollSpeed",e)},this.getScrollSpeed=function(){return this.getOption("scrollSpeed")},this.setDragDelay=function(e){this.setOption("dragDelay",e)},this.getDragDelay=function(){return this.getOption("dragDelay")},this.setSelectionStyle=function(e){this.setOption("selectionStyle",e)},this.getSelectionStyle=function(){return this.getOption("selectionStyle")},this.setHighlightActiveLine=function(e){this.setOption("highlightActiveLine",e)},this.getHighlightActiveLine=function(){return this.getOption("highlightActiveLine")},this.setHighlightGutterLine=function(e){this.setOption("highlightGutterLine",e)},this.getHighlightGutterLine=function(){return this.getOption("highlightGutterLine")},this.setHighlightSelectedWord=function(e){this.setOption("highlightSelectedWord",e)},this.getHighlightSelectedWord=function(){return this.$highlightSelectedWord},this.setAnimatedScroll=function(e){this.renderer.setAnimatedScroll(e)},this.getAnimatedScroll=function(){return this.renderer.getAnimatedScroll()},this.setShowInvisibles=function(e){this.renderer.setShowInvisibles(e)},this.getShowInvisibles=function(){return this.renderer.getShowInvisibles()},this.setDisplayIndentGuides=function(e){this.renderer.setDisplayIndentGuides(e)},this.getDisplayIndentGuides=function(){return this.renderer.getDisplayIndentGuides()},this.setShowPrintMargin=function(e){this.renderer.setShowPrintMargin(e)},this.getShowPrintMargin=function(){return this.renderer.getShowPrintMargin()},this.setPrintMarginColumn=function(e){this.renderer.setPrintMarginColumn(e)},this.getPrintMarginColumn=function(){return this.renderer.getPrintMarginColumn()},this.setReadOnly=function(e){this.setOption("readOnly",e)},this.getReadOnly=function(){return this.getOption("readOnly")},this.setBehavioursEnabled=function(e){this.setOption("behavioursEnabled",e)},this.getBehavioursEnabled=function(){return this.getOption("behavioursEnabled")},this.setWrapBehavioursEnabled=function(e){this.setOption("wrapBehavioursEnabled",e)},this.getWrapBehavioursEnabled=function(){return this.getOption("wrapBehavioursEnabled")},this.setShowFoldWidgets=function(e){this.setOption("showFoldWidgets",e)},this.getShowFoldWidgets=function(){return this.getOption("showFoldWidgets")},this.setFadeFoldWidgets=function(e){this.setOption("fadeFoldWidgets",e)},this.getFadeFoldWidgets=function(){return this.getOption("fadeFoldWidgets")},this.remove=function(e){this.selection.isEmpty()&&("left"==e?this.selection.selectLeft():this.selection.selectRight());var t=this.getSelectionRange();if(this.getBehavioursEnabled()){var i=this.session,n=i.getState(t.start.row),r=i.getMode().transformAction(n,"deletion",this,i,t);if(0===t.end.column){var o=i.getTextRange(t);if("\n"==o[o.length-1]){var s=i.getLine(t.end.row);/^\s+$/.test(s)&&(t.end.column=s.length)}}r&&(t=r)}this.session.remove(t),this.clearSelection()},this.removeWordRight=function(){this.selection.isEmpty()&&this.selection.selectWordRight(),this.session.remove(this.getSelectionRange()),this.clearSelection()},this.removeWordLeft=function(){this.selection.isEmpty()&&this.selection.selectWordLeft(),this.session.remove(this.getSelectionRange()),this.clearSelection()},this.removeToLineStart=function(){this.selection.isEmpty()&&this.selection.selectLineStart(),this.session.remove(this.getSelectionRange()),this.clearSelection()},this.removeToLineEnd=function(){this.selection.isEmpty()&&this.selection.selectLineEnd();var e=this.getSelectionRange();e.start.column==e.end.column&&e.start.row==e.end.row&&(e.end.column=0,e.end.row++),this.session.remove(e),this.clearSelection()},this.splitLine=function(){this.selection.isEmpty()||(this.session.remove(this.getSelectionRange()),this.clearSelection());var e=this.getCursorPosition();this.insert("\n"),this.moveCursorToPosition(e)},this.transposeLetters=function(){if(this.selection.isEmpty()){var e=this.getCursorPosition(),t=e.column;if(0!==t){var i,n,r=this.session.getLine(e.row);t<r.length?(i=r.charAt(t)+r.charAt(t-1),n=new f(e.row,t-1,e.row,t+1)):(i=r.charAt(t-1)+r.charAt(t-2),n=new f(e.row,t-2,e.row,t)),this.session.replace(n,i)}}},this.toLowerCase=function(){var e=this.getSelectionRange();this.selection.isEmpty()&&this.selection.selectWord();var t=this.getSelectionRange(),i=this.session.getTextRange(t);this.session.replace(t,i.toLowerCase()),this.selection.setSelectionRange(e)},this.toUpperCase=function(){var e=this.getSelectionRange();this.selection.isEmpty()&&this.selection.selectWord();var t=this.getSelectionRange(),i=this.session.getTextRange(t);this.session.replace(t,i.toUpperCase()),this.selection.setSelectionRange(e)},this.indent=function(){var e=this.session,t=this.getSelectionRange();if(t.start.row<t.end.row){var i=this.$getSelectedRows();return void e.indentRows(i.first,i.last,"\t")}if(t.start.column<t.end.column){var n=e.getTextRange(t);if(!/^\s+$/.test(n)){var i=this.$getSelectedRows();return void e.indentRows(i.first,i.last,"\t")}}var r=e.getLine(t.start.row),s=t.start,a=e.getTabSize(),l=e.documentToScreenColumn(s.row,s.column);if(this.session.getUseSoftTabs())var c=a-l%a,h=o.stringRepeat(" ",c);else{for(var c=l%a;" "==r[t.start.column]&&c;)t.start.column--,c--;this.selection.setSelectionRange(t),h="\t"}return this.insert(h)},this.blockIndent=function(){var e=this.$getSelectedRows();this.session.indentRows(e.first,e.last,"\t")},this.blockOutdent=function(){var e=this.session.getSelection();this.session.outdentRows(e.getRange())},this.sortLines=function(){var e=this.$getSelectedRows(),t=this.session,i=[];for(r=e.first;r<=e.last;r++)i.push(t.getLine(r));i.sort(function(e,t){return e.toLowerCase()<t.toLowerCase()?-1:e.toLowerCase()>t.toLowerCase()?1:0});for(var n=new f(0,0,0,0),r=e.first;r<=e.last;r++){var o=t.getLine(r);n.start.row=r,n.end.row=r,n.end.column=o.length,t.replace(n,i[r-e.first])}},this.toggleCommentLines=function(){var e=this.session.getState(this.getCursorPosition().row),t=this.$getSelectedRows();this.session.getMode().toggleCommentLines(e,this.session,t.first,t.last)},this.toggleBlockComment=function(){var e=this.getCursorPosition(),t=this.session.getState(e.row),i=this.getSelectionRange();this.session.getMode().toggleBlockComment(t,this.session,i,e)},this.getNumberAt=function(e,t){var i=/[\-]?[0-9]+(?:\.[0-9]+)?/g;i.lastIndex=0;for(var n=this.session.getLine(e);i.lastIndex<t;){var r=i.exec(n);if(r.index<=t&&r.index+r[0].length>=t){var o={value:r[0],start:r.index,end:r.index+r[0].length};return o}}return null},this.modifyNumber=function(e){var t=this.selection.getCursor().row,i=this.selection.getCursor().column,n=new f(t,i-1,t,i),r=this.session.getTextRange(n);if(!isNaN(parseFloat(r))&&isFinite(r)){var o=this.getNumberAt(t,i);if(o){var s=o.value.indexOf(".")>=0?o.start+o.value.indexOf(".")+1:o.end,a=o.start+o.value.length-s,l=parseFloat(o.value);l*=Math.pow(10,a),e*=s!==o.end&&i<s?Math.pow(10,o.end-i-1):Math.pow(10,o.end-i),l+=e,l/=Math.pow(10,a);var c=l.toFixed(a),h=new f(t,o.start,t,o.end);this.session.replace(h,c),this.moveCursorTo(t,Math.max(o.start+1,i+c.length-o.value.length))}}},this.removeLines=function(){var e=this.$getSelectedRows();this.session.removeFullLines(e.first,e.last),this.clearSelection()},this.duplicateSelection=function(){var e=this.selection,t=this.session,i=e.getRange(),n=e.isBackwards();if(i.isEmpty()){var r=i.start.row;t.duplicateLines(r,r)}else{var o=n?i.start:i.end,s=t.insert(o,t.getTextRange(i),!1);i.start=o,i.end=s,e.setSelectionRange(i,n)}},this.moveLinesDown=function(){this.$moveLines(1,!1)},this.moveLinesUp=function(){this.$moveLines(-1,!1)},this.moveText=function(e,t,i){return this.session.moveText(e,t,i)},this.copyLinesUp=function(){this.$moveLines(-1,!0)},this.copyLinesDown=function(){this.$moveLines(1,!0)},this.$moveLines=function(e,t){var i,n,r=this.selection;if(!r.inMultiSelectMode||this.inVirtualSelectionMode){var o=r.toOrientedRange();i=this.$getSelectedRows(o),n=this.session.$moveLines(i.first,i.last,t?0:e),t&&e==-1&&(n=0),o.moveBy(n,0),r.fromOrientedRange(o)}else{var s=r.rangeList.ranges;r.rangeList.detach(this.session),this.inVirtualSelectionMode=!0;for(var a=0,l=0,c=s.length,h=0;h<c;h++){var d=h;s[h].moveBy(a,0),i=this.$getSelectedRows(s[h]);for(var u=i.first,f=i.last;++h<c;){l&&s[h].moveBy(l,0);var p=this.$getSelectedRows(s[h]);if(t&&p.first!=f)break;if(!t&&p.first>f+1)break;f=p.last}for(h--,a=this.session.$moveLines(u,f,t?0:e),t&&e==-1&&(d=h+1);d<=h;)s[d].moveBy(a,0),d++;t||(a=0),l+=a}r.fromOrientedRange(r.ranges[0]),r.rangeList.attach(this.session),this.inVirtualSelectionMode=!1}},this.$getSelectedRows=function(e){return e=(e||this.getSelectionRange()).collapseRows(),{first:this.session.getRowFoldStart(e.start.row),last:this.session.getRowFoldEnd(e.end.row)}},this.onCompositionStart=function(e){this.renderer.showComposition(this.getCursorPosition())},this.onCompositionUpdate=function(e){this.renderer.setCompositionText(e)},this.onCompositionEnd=function(){this.renderer.hideComposition()},this.getFirstVisibleRow=function(){return this.renderer.getFirstVisibleRow()},this.getLastVisibleRow=function(){return this.renderer.getLastVisibleRow()},this.isRowVisible=function(e){return e>=this.getFirstVisibleRow()&&e<=this.getLastVisibleRow()},this.isRowFullyVisible=function(e){return e>=this.renderer.getFirstFullyVisibleRow()&&e<=this.renderer.getLastFullyVisibleRow()},this.$getVisibleRowCount=function(){return this.renderer.getScrollBottomRow()-this.renderer.getScrollTopRow()+1},this.$moveByPage=function(e,t){var i=this.renderer,n=this.renderer.layerConfig,r=e*Math.floor(n.height/n.lineHeight);this.$blockScrolling++,t===!0?this.selection.$moveSelection(function(){this.moveCursorBy(r,0)}):t===!1&&(this.selection.moveCursorBy(r,0),this.selection.clearSelection()),this.$blockScrolling--;var o=i.scrollTop;i.scrollBy(0,r*n.lineHeight),null!=t&&i.scrollCursorIntoView(null,.5),i.animateScrolling(o)},this.selectPageDown=function(){this.$moveByPage(1,!0)},this.selectPageUp=function(){this.$moveByPage(-1,!0)},this.gotoPageDown=function(){this.$moveByPage(1,!1)},this.gotoPageUp=function(){this.$moveByPage(-1,!1)},this.scrollPageDown=function(){this.$moveByPage(1)},this.scrollPageUp=function(){this.$moveByPage(-1)},this.scrollToRow=function(e){this.renderer.scrollToRow(e)},this.scrollToLine=function(e,t,i,n){this.renderer.scrollToLine(e,t,i,n)},this.centerSelection=function(){var e=this.getSelectionRange(),t={row:Math.floor(e.start.row+(e.end.row-e.start.row)/2),column:Math.floor(e.start.column+(e.end.column-e.start.column)/2)};this.renderer.alignCursor(t,.5)},this.getCursorPosition=function(){return this.selection.getCursor()},this.getCursorPositionScreen=function(){return this.session.documentToScreenPosition(this.getCursorPosition())},this.getSelectionRange=function(){return this.selection.getRange()},this.selectAll=function(){this.$blockScrolling+=1,this.selection.selectAll(),this.$blockScrolling-=1},this.clearSelection=function(){this.selection.clearSelection()},this.moveCursorTo=function(e,t){this.selection.moveCursorTo(e,t)},this.moveCursorToPosition=function(e){this.selection.moveCursorToPosition(e)},this.jumpToMatching=function(e,t){var i=this.getCursorPosition(),n=new y(this.session,i.row,i.column),r=n.getCurrentToken(),o=r||n.stepForward();if(o){var s,a,l=!1,c={},h=i.column-o.start,d={")":"(","(":"(","]":"[","[":"[","{":"{","}":"{"};do{if(o.value.match(/[{}()\[\]]/g)){for(;h<o.value.length&&!l;h++)if(d[o.value[h]])switch(a=d[o.value[h]]+"."+o.type.replace("rparen","lparen"),isNaN(c[a])&&(c[a]=0),o.value[h]){case"(":case"[":case"{":c[a]++;break;case")":case"]":case"}":c[a]--,c[a]===-1&&(s="bracket",l=!0)}}else o&&o.type.indexOf("tag-name")!==-1&&(isNaN(c[o.value])&&(c[o.value]=0),"<"===r.value?c[o.value]++:"</"===r.value&&c[o.value]--,c[o.value]===-1&&(s="tag",l=!0));l||(r=o,o=n.stepForward(),h=0)}while(o&&!l);if(s){var u,p;if("bracket"===s)u=this.session.getBracketRange(i),u||(u=new f(n.getCurrentTokenRow(),n.getCurrentTokenColumn()+h-1,n.getCurrentTokenRow(),n.getCurrentTokenColumn()+h-1),p=u.start,(t||p.row===i.row&&Math.abs(p.column-i.column)<2)&&(u=this.session.getBracketRange(p)));else if("tag"===s){if(!o||o.type.indexOf("tag-name")===-1)return;var m=o.value;if(u=new f(n.getCurrentTokenRow(),n.getCurrentTokenColumn()-2,n.getCurrentTokenRow(),n.getCurrentTokenColumn()-2),0===u.compare(i.row,i.column)){l=!1;do o=r,r=n.stepBackward(),r&&(r.type.indexOf("tag-close")!==-1&&u.setEnd(n.getCurrentTokenRow(),n.getCurrentTokenColumn()+1),o.value===m&&o.type.indexOf("tag-name")!==-1&&("<"===r.value?c[m]++:"</"===r.value&&c[m]--,0===c[m]&&(l=!0)));while(r&&!l)}o&&o.type.indexOf("tag-name")&&(p=u.start,p.row==i.row&&Math.abs(p.column-i.column)<2&&(p=u.end))}p=u&&u.cursor||p,p&&(e?u&&t?this.selection.setRange(u):u&&u.isEqual(this.getSelectionRange())?this.clearSelection():this.selection.selectTo(p.row,p.column):this.selection.moveTo(p.row,p.column))}}},this.gotoLine=function(e,t,i){this.selection.clearSelection(),this.session.unfold({row:e-1,column:t||0}),this.$blockScrolling+=1,this.exitMultiSelectMode&&this.exitMultiSelectMode(),this.moveCursorTo(e-1,t||0),this.$blockScrolling-=1,this.isRowFullyVisible(e-1)||this.scrollToLine(e-1,!0,i)},this.navigateTo=function(e,t){this.selection.moveTo(e,t)},this.navigateUp=function(e){if(this.selection.isMultiLine()&&!this.selection.isBackwards()){var t=this.selection.anchor.getPosition();return this.moveCursorToPosition(t)}this.selection.clearSelection(),this.selection.moveCursorBy(-e||-1,0)},this.navigateDown=function(e){if(this.selection.isMultiLine()&&this.selection.isBackwards()){var t=this.selection.anchor.getPosition();return this.moveCursorToPosition(t)}this.selection.clearSelection(),this.selection.moveCursorBy(e||1,0)},this.navigateLeft=function(e){if(this.selection.isEmpty())for(e=e||1;e--;)this.selection.moveCursorLeft();else{var t=this.getSelectionRange().start;this.moveCursorToPosition(t)}this.clearSelection()},this.navigateRight=function(e){if(this.selection.isEmpty())for(e=e||1;e--;)this.selection.moveCursorRight();else{var t=this.getSelectionRange().end;this.moveCursorToPosition(t)}this.clearSelection()},this.navigateLineStart=function(){this.selection.moveCursorLineStart(),this.clearSelection()},this.navigateLineEnd=function(){this.selection.moveCursorLineEnd(),this.clearSelection()},this.navigateFileEnd=function(){this.selection.moveCursorFileEnd(),this.clearSelection()},this.navigateFileStart=function(){this.selection.moveCursorFileStart(),this.clearSelection()},this.navigateWordRight=function(){this.selection.moveCursorWordRight(),this.clearSelection()},this.navigateWordLeft=function(){this.selection.moveCursorWordLeft(),this.clearSelection()},this.replace=function(e,t){t&&this.$search.set(t);var i=this.$search.find(this.session),n=0;return i?(this.$tryReplace(i,e)&&(n=1),null!==i&&(this.selection.setSelectionRange(i),this.renderer.scrollSelectionIntoView(i.start,i.end)),n):n},this.replaceAll=function(e,t){t&&this.$search.set(t);var i=this.$search.findAll(this.session),n=0;if(!i.length)return n;this.$blockScrolling+=1;var r=this.getSelectionRange();this.selection.moveTo(0,0);for(var o=i.length-1;o>=0;--o)this.$tryReplace(i[o],e)&&n++;return this.selection.setSelectionRange(r),this.$blockScrolling-=1,n},this.$tryReplace=function(e,t){var i=this.session.getTextRange(e);return t=this.$search.replace(i,t),null!==t?(e.end=this.session.replace(e,t),e):null},this.getLastSearchOptions=function(){return this.$search.getOptions()},this.find=function(e,t,i){t||(t={}),"string"==typeof e||e instanceof RegExp?t.needle=e:"object"==typeof e&&n.mixin(t,e);var r=this.selection.getRange();null==t.needle&&(e=this.session.getTextRange(r)||this.$search.$options.needle,e||(r=this.session.getWordRange(r.start.row,r.start.column),e=this.session.getTextRange(r)),this.$search.set({needle:e})),this.$search.set(t),t.start||this.$search.set({start:r});var o=this.$search.find(this.session);return t.preventScroll?o:o?(this.revealRange(o,i),o):(t.backwards?r.start=r.end:r.end=r.start,void this.selection.setRange(r))},this.findNext=function(e,t){this.find({skipCurrent:!0,backwards:!1},e,t)},this.findPrevious=function(e,t){this.find(e,{skipCurrent:!0,backwards:!0},t)},this.revealRange=function(e,t){this.$blockScrolling+=1,this.session.unfold(e),this.selection.setSelectionRange(e),this.$blockScrolling-=1;var i=this.renderer.scrollTop;this.renderer.scrollSelectionIntoView(e.start,e.end,.5),t!==!1&&this.renderer.animateScrolling(i)},this.undo=function(){this.$blockScrolling++,this.session.getUndoManager().undo(),this.$blockScrolling--,this.renderer.scrollCursorIntoView(null,.5)},this.redo=function(){this.$blockScrolling++,this.session.getUndoManager().redo(),this.$blockScrolling--,this.renderer.scrollCursorIntoView(null,.5)},this.destroy=function(){this.renderer.destroy(),this._signal("destroy",this),this.session&&this.session.destroy()},this.setAutoScrollEditorIntoView=function(e){if(e){var t,i=this,n=!1;this.$scrollAnchor||(this.$scrollAnchor=document.createElement("div"));var r=this.$scrollAnchor;r.style.cssText="position:absolute",this.container.insertBefore(r,this.container.firstChild);var o=this.on("changeSelection",function(){n=!0}),s=this.renderer.on("beforeRender",function(){n&&(t=i.renderer.container.getBoundingClientRect())}),a=this.renderer.on("afterRender",function(){if(n&&t&&(i.isFocused()||i.searchBox&&i.searchBox.isFocused())){var e=i.renderer,o=e.$cursorLayer.$pixelPos,s=e.layerConfig,a=o.top-s.offset;n=o.top>=0&&a+t.top<0||!(o.top<s.height&&o.top+t.top+s.lineHeight>window.innerHeight)&&null,null!=n&&(r.style.top=a+"px",r.style.left=o.left+"px",r.style.height=s.lineHeight+"px",r.scrollIntoView(n)),n=t=null}});this.setAutoScrollEditorIntoView=function(e){e||(delete this.setAutoScrollEditorIntoView,this.off("changeSelection",o),this.renderer.off("afterRender",a),this.renderer.off("beforeRender",s))}}},this.$resetCursorStyle=function(){var e=this.$cursorStyle||"ace",t=this.renderer.$cursorLayer;t&&(t.setSmoothBlinking(/smooth/.test(e)),t.isBlinking=!this.$readOnly&&"wide"!=e,r.setCssClass(t.element,"ace_slim-cursors",/slim/.test(e)))}}).call(w.prototype),v.defineOptions(w.prototype,"editor",{selectionStyle:{set:function(e){this.onSelectionChange(),this._signal("changeSelectionStyle",{data:e})},initialValue:"line"},highlightActiveLine:{set:function(){this.$updateHighlightActiveLine()},initialValue:!0},highlightSelectedWord:{set:function(e){this.$onSelectionChange()},initialValue:!0},readOnly:{set:function(e){this.$resetCursorStyle()},initialValue:!1},cursorStyle:{set:function(e){this.$resetCursorStyle()},values:["ace","slim","smooth","wide"],initialValue:"ace"},mergeUndoDeltas:{values:[!1,!0,"always"],initialValue:!0},behavioursEnabled:{initialValue:!0},wrapBehavioursEnabled:{initialValue:!0},autoScrollEditorIntoView:{set:function(e){this.setAutoScrollEditorIntoView(e)}},keyboardHandler:{set:function(e){this.setKeyboardHandler(e)},get:function(){return this.keybindingId},handlesSet:!0},hScrollBarAlwaysVisible:"renderer",vScrollBarAlwaysVisible:"renderer",highlightGutterLine:"renderer",animatedScroll:"renderer",showInvisibles:"renderer",showPrintMargin:"renderer",printMarginColumn:"renderer",printMargin:"renderer",fadeFoldWidgets:"renderer",showFoldWidgets:"renderer",showLineNumbers:"renderer",showGutter:"renderer",displayIndentGuides:"renderer",fontSize:"renderer",fontFamily:"renderer",maxLines:"renderer",minLines:"renderer",scrollPastEnd:"renderer",fixedWidthGutter:"renderer",theme:"renderer",scrollSpeed:"$mouseHandler",dragDelay:"$mouseHandler",dragEnabled:"$mouseHandler",focusTimout:"$mouseHandler",tooltipFollowsMouse:"$mouseHandler",
	firstLineNumber:"session",overwrite:"session",newLineMode:"session",useWorker:"session",useSoftTabs:"session",tabSize:"session",wrap:"session",indentedSoftWrap:"session",foldStyle:"session",mode:"session"}),t.Editor=w}),ace.define("ace/undomanager",["require","exports","module"],function(e,t,i){"use strict";var n=function(){this.reset()};(function(){function e(e){return{action:e.action,start:e.start,end:e.end,lines:1==e.lines.length?null:e.lines,text:1==e.lines.length?e.lines[0]:null}}function t(e){return{action:e.action,start:e.start,end:e.end,lines:e.lines||[e.text]}}function i(e,t){for(var i=new Array(e.length),n=0;n<e.length;n++){for(var r=e[n],o={group:r.group,deltas:new Array(r.length)},s=0;s<r.deltas.length;s++){var a=r.deltas[s];o.deltas[s]=t(a)}i[n]=o}return i}this.execute=function(e){var t=e.args[0];this.$doc=e.args[1],e.merge&&this.hasUndo()&&(this.dirtyCounter--,t=this.$undoStack.pop().concat(t)),this.$undoStack.push(t),this.$redoStack=[],this.dirtyCounter<0&&(this.dirtyCounter=NaN),this.dirtyCounter++},this.undo=function(e){var t=this.$undoStack.pop(),i=null;return t&&(i=this.$doc.undoChanges(t,e),this.$redoStack.push(t),this.dirtyCounter--),i},this.redo=function(e){var t=this.$redoStack.pop(),i=null;return t&&(i=this.$doc.redoChanges(this.$deserializeDeltas(t),e),this.$undoStack.push(t),this.dirtyCounter++),i},this.reset=function(){this.$undoStack=[],this.$redoStack=[],this.dirtyCounter=0},this.hasUndo=function(){return this.$undoStack.length>0},this.hasRedo=function(){return this.$redoStack.length>0},this.markClean=function(){this.dirtyCounter=0},this.isClean=function(){return 0===this.dirtyCounter},this.$serializeDeltas=function(t){return i(t,e)},this.$deserializeDeltas=function(e){return i(e,t)}}).call(n.prototype),t.UndoManager=n}),ace.define("ace/layer/gutter",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter"],function(e,t,i){"use strict";var n=e("../lib/dom"),r=e("../lib/oop"),o=e("../lib/lang"),s=e("../lib/event_emitter").EventEmitter,a=function(e){this.element=n.createElement("div"),this.element.className="ace_layer ace_gutter-layer",e.appendChild(this.element),this.setShowFoldWidgets(this.$showFoldWidgets),this.gutterWidth=0,this.$annotations=[],this.$updateAnnotations=this.$updateAnnotations.bind(this),this.$cells=[]};(function(){r.implement(this,s),this.setSession=function(e){this.session&&this.session.removeEventListener("change",this.$updateAnnotations),this.session=e,e&&e.on("change",this.$updateAnnotations)},this.addGutterDecoration=function(e,t){window.console&&console.warn&&console.warn("deprecated use session.addGutterDecoration"),this.session.addGutterDecoration(e,t)},this.removeGutterDecoration=function(e,t){window.console&&console.warn&&console.warn("deprecated use session.removeGutterDecoration"),this.session.removeGutterDecoration(e,t)},this.setAnnotations=function(e){this.$annotations=[];for(var t=0;t<e.length;t++){var i=e[t],n=i.row,r=this.$annotations[n];r||(r=this.$annotations[n]={text:[]});var s=i.text;s=s?o.escapeHTML(s):i.html||"",r.text.indexOf(s)===-1&&r.text.push(s);var a=i.type;"error"==a?r.className=" ace_error":"warning"==a&&" ace_error"!=r.className?r.className=" ace_warning":"info"!=a||r.className||(r.className=" ace_info")}},this.$updateAnnotations=function(e){if(this.$annotations.length){var t=e.start.row,i=e.end.row-t;if(0===i);else if("remove"==e.action)this.$annotations.splice(t,i+1,null);else{var n=new Array(i+1);n.unshift(t,1),this.$annotations.splice.apply(this.$annotations,n)}}},this.update=function(e){for(var t=this.session,i=e.firstRow,r=Math.min(e.lastRow+e.gutterOffset,t.getLength()-1),o=t.getNextFoldLine(i),s=o?o.start.row:1/0,a=this.$showFoldWidgets&&t.foldWidgets,l=t.$breakpoints,c=t.$decorations,h=t.$firstLineNumber,d=0,u=t.gutterRenderer||this.$renderer,f=null,p=-1,m=i;;){if(m>s&&(m=o.end.row+1,o=t.getNextFoldLine(m,o),s=o?o.start.row:1/0),m>r){for(;this.$cells.length>p+1;)f=this.$cells.pop(),this.element.removeChild(f.element);break}f=this.$cells[++p],f||(f={element:null,textNode:null,foldWidget:null},f.element=n.createElement("div"),f.textNode=document.createTextNode(""),f.element.appendChild(f.textNode),this.element.appendChild(f.element),this.$cells[p]=f);var g="ace_gutter-cell ";l[m]&&(g+=l[m]),c[m]&&(g+=c[m]),this.$annotations[m]&&(g+=this.$annotations[m].className),f.element.className!=g&&(f.element.className=g);var v=t.getRowLength(m)*e.lineHeight+"px";if(v!=f.element.style.height&&(f.element.style.height=v),a){var y=a[m];null==y&&(y=a[m]=t.getFoldWidget(m))}if(y){f.foldWidget||(f.foldWidget=n.createElement("span"),f.element.appendChild(f.foldWidget));var g="ace_fold-widget ace_"+y;g+="start"==y&&m==s&&m<o.end.row?" ace_closed":" ace_open",f.foldWidget.className!=g&&(f.foldWidget.className=g);var v=e.lineHeight+"px";f.foldWidget.style.height!=v&&(f.foldWidget.style.height=v)}else f.foldWidget&&(f.element.removeChild(f.foldWidget),f.foldWidget=null);var w=d=u?u.getText(t,m):m+h;w!=f.textNode.data&&(f.textNode.data=w),m++}this.element.style.height=e.minHeight+"px",(this.$fixedWidth||t.$useWrapMode)&&(d=t.getLength()+h);var b=u?u.getWidth(t,d,e):d.toString().length*e.characterWidth,A=this.$padding||this.$computePadding();b+=A.left+A.right,b===this.gutterWidth||isNaN(b)||(this.gutterWidth=b,this.element.style.width=Math.ceil(this.gutterWidth)+"px",this._emit("changeGutterWidth",b))},this.$fixedWidth=!1,this.$showLineNumbers=!0,this.$renderer="",this.setShowLineNumbers=function(e){this.$renderer=!e&&{getWidth:function(){return""},getText:function(){return""}}},this.getShowLineNumbers=function(){return this.$showLineNumbers},this.$showFoldWidgets=!0,this.setShowFoldWidgets=function(e){e?n.addCssClass(this.element,"ace_folding-enabled"):n.removeCssClass(this.element,"ace_folding-enabled"),this.$showFoldWidgets=e,this.$padding=null},this.getShowFoldWidgets=function(){return this.$showFoldWidgets},this.$computePadding=function(){if(!this.element.firstChild)return{left:0,right:0};var e=n.computedStyle(this.element.firstChild);return this.$padding={},this.$padding.left=parseInt(e.paddingLeft)+1||0,this.$padding.right=parseInt(e.paddingRight)||0,this.$padding},this.getRegion=function(e){var t=this.$padding||this.$computePadding(),i=this.element.getBoundingClientRect();return e.x<t.left+i.left?"markers":this.$showFoldWidgets&&e.x>i.right-t.right?"foldWidgets":void 0}}).call(a.prototype),t.Gutter=a}),ace.define("ace/layer/marker",["require","exports","module","ace/range","ace/lib/dom"],function(e,t,i){"use strict";var n=e("../range").Range,r=e("../lib/dom"),o=function(e){this.element=r.createElement("div"),this.element.className="ace_layer ace_marker-layer",e.appendChild(this.element)};(function(){function e(e,t,i,n){return(e?1:0)|(t?2:0)|(i?4:0)|(n?8:0)}this.$padding=0,this.setPadding=function(e){this.$padding=e},this.setSession=function(e){this.session=e},this.setMarkers=function(e){this.markers=e},this.update=function(e){var e=e||this.config;if(e){this.config=e;var t=[];for(var i in this.markers){var n=this.markers[i];if(n.range){var r=n.range.clipRows(e.firstRow,e.lastRow);if(!r.isEmpty())if(r=r.toScreenRange(this.session),n.renderer){var o=this.$getTop(r.start.row,e),s=this.$padding+r.start.column*e.characterWidth;n.renderer(t,r,s,o,e)}else"fullLine"==n.type?this.drawFullLineMarker(t,r,n.clazz,e):"screenLine"==n.type?this.drawScreenLineMarker(t,r,n.clazz,e):r.isMultiLine()?"text"==n.type?this.drawTextMarker(t,r,n.clazz,e):this.drawMultiLineMarker(t,r,n.clazz,e):this.drawSingleLineMarker(t,r,n.clazz+" ace_start ace_br15",e)}else n.update(t,this,this.session,e)}this.element.innerHTML=t.join("")}},this.$getTop=function(e,t){return(e-t.firstRowScreen)*t.lineHeight},this.drawTextMarker=function(t,i,r,o,s){for(var a=this.session,l=i.start.row,c=i.end.row,h=l,d=0,u=0,f=a.getScreenLastRowColumn(h),p=new n(h,i.start.column,h,u);h<=c;h++)p.start.row=p.end.row=h,p.start.column=h==l?i.start.column:a.getRowWrapIndent(h),p.end.column=f,d=u,u=f,f=h+1<c?a.getScreenLastRowColumn(h+1):h==c?0:i.end.column,this.drawSingleLineMarker(t,p,r+(h==l?" ace_start":"")+" ace_br"+e(h==l||h==l+1&&i.start.column,d<u,u>f,h==c),o,h==c?0:1,s)},this.drawMultiLineMarker=function(e,t,i,n,r){var o=this.$padding,s=n.lineHeight,a=this.$getTop(t.start.row,n),l=o+t.start.column*n.characterWidth;r=r||"",e.push("<div class='",i," ace_br1 ace_start' style='","height:",s,"px;","right:0;","top:",a,"px;","left:",l,"px;",r,"'></div>"),a=this.$getTop(t.end.row,n);var c=t.end.column*n.characterWidth;if(e.push("<div class='",i," ace_br12' style='","height:",s,"px;","width:",c,"px;","top:",a,"px;","left:",o,"px;",r,"'></div>"),s=(t.end.row-t.start.row-1)*n.lineHeight,!(s<=0)){a=this.$getTop(t.start.row+1,n);var h=(t.start.column?1:0)|(t.end.column?0:8);e.push("<div class='",i,h?" ace_br"+h:"","' style='","height:",s,"px;","right:0;","top:",a,"px;","left:",o,"px;",r,"'></div>")}},this.drawSingleLineMarker=function(e,t,i,n,r,o){var s=n.lineHeight,a=(t.end.column+(r||0)-t.start.column)*n.characterWidth,l=this.$getTop(t.start.row,n),c=this.$padding+t.start.column*n.characterWidth;e.push("<div class='",i,"' style='","height:",s,"px;","width:",a,"px;","top:",l,"px;","left:",c,"px;",o||"","'></div>")},this.drawFullLineMarker=function(e,t,i,n,r){var o=this.$getTop(t.start.row,n),s=n.lineHeight;t.start.row!=t.end.row&&(s+=this.$getTop(t.end.row,n)-o),e.push("<div class='",i,"' style='","height:",s,"px;","top:",o,"px;","left:0;right:0;",r||"","'></div>")},this.drawScreenLineMarker=function(e,t,i,n,r){var o=this.$getTop(t.start.row,n),s=n.lineHeight;e.push("<div class='",i,"' style='","height:",s,"px;","top:",o,"px;","left:0;right:0;",r||"","'></div>")}}).call(o.prototype),t.Marker=o}),ace.define("ace/layer/text",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/lib/event_emitter"],function(e,t,i){"use strict";var n=e("../lib/oop"),r=e("../lib/dom"),o=e("../lib/lang"),s=(e("../lib/useragent"),e("../lib/event_emitter").EventEmitter),a=function(e){this.element=r.createElement("div"),this.element.className="ace_layer ace_text-layer",e.appendChild(this.element),this.$updateEolChar=this.$updateEolChar.bind(this)};(function(){n.implement(this,s),this.EOF_CHAR="¶",this.EOL_CHAR_LF="¬",this.EOL_CHAR_CRLF="¤",this.EOL_CHAR=this.EOL_CHAR_LF,this.TAB_CHAR="—",this.SPACE_CHAR="·",this.$padding=0,this.$updateEolChar=function(){var e="\n"==this.session.doc.getNewLineCharacter()?this.EOL_CHAR_LF:this.EOL_CHAR_CRLF;if(this.EOL_CHAR!=e)return this.EOL_CHAR=e,!0},this.setPadding=function(e){this.$padding=e,this.element.style.padding="0 "+e+"px"},this.getLineHeight=function(){return this.$fontMetrics.$characterSize.height||0},this.getCharacterWidth=function(){return this.$fontMetrics.$characterSize.width||0},this.$setFontMetrics=function(e){this.$fontMetrics=e,this.$fontMetrics.on("changeCharacterSize",function(e){this._signal("changeCharacterSize",e)}.bind(this)),this.$pollSizeChanges()},this.checkForSizeChanges=function(){this.$fontMetrics.checkForSizeChanges()},this.$pollSizeChanges=function(){return this.$pollSizeChangesTimer=this.$fontMetrics.$pollSizeChanges()},this.setSession=function(e){this.session=e,e&&this.$computeTabString()},this.showInvisibles=!1,this.setShowInvisibles=function(e){return this.showInvisibles!=e&&(this.showInvisibles=e,this.$computeTabString(),!0)},this.displayIndentGuides=!0,this.setDisplayIndentGuides=function(e){return this.displayIndentGuides!=e&&(this.displayIndentGuides=e,this.$computeTabString(),!0)},this.$tabStrings=[],this.onChangeTabSize=this.$computeTabString=function(){var e=this.session.getTabSize();this.tabSize=e;for(var t=this.$tabStrings=[0],i=1;i<e+1;i++)this.showInvisibles?t.push("<span class='ace_invisible ace_invisible_tab'>"+o.stringRepeat(this.TAB_CHAR,i)+"</span>"):t.push(o.stringRepeat(" ",i));if(this.displayIndentGuides){this.$indentGuideRe=/\s\S| \t|\t |\s$/;var n="ace_indent-guide",r="",s="";if(this.showInvisibles){n+=" ace_invisible",r=" ace_invisible_space",s=" ace_invisible_tab";var a=o.stringRepeat(this.SPACE_CHAR,this.tabSize),l=o.stringRepeat(this.TAB_CHAR,this.tabSize)}else var a=o.stringRepeat(" ",this.tabSize),l=a;this.$tabStrings[" "]="<span class='"+n+r+"'>"+a+"</span>",this.$tabStrings["\t"]="<span class='"+n+s+"'>"+l+"</span>"}},this.updateLines=function(e,t,i){this.config.lastRow==e.lastRow&&this.config.firstRow==e.firstRow||this.scrollLines(e),this.config=e;for(var n=Math.max(t,e.firstRow),r=Math.min(i,e.lastRow),o=this.element.childNodes,s=0,a=e.firstRow;a<n;a++){var l=this.session.getFoldLine(a);if(l){if(l.containsRow(n)){n=l.start.row;break}a=l.end.row}s++}for(var a=n,l=this.session.getNextFoldLine(a),c=l?l.start.row:1/0;;){if(a>c&&(a=l.end.row+1,l=this.session.getNextFoldLine(a,l),c=l?l.start.row:1/0),a>r)break;var h=o[s++];if(h){var d=[];this.$renderLine(d,a,!this.$useLineGroups(),a==c&&l),h.style.height=e.lineHeight*this.session.getRowLength(a)+"px",h.innerHTML=d.join("")}a++}},this.scrollLines=function(e){var t=this.config;if(this.config=e,!t||t.lastRow<e.firstRow)return this.update(e);if(e.lastRow<t.firstRow)return this.update(e);var i=this.element;if(t.firstRow<e.firstRow)for(var n=this.session.getFoldedRowCount(t.firstRow,e.firstRow-1);n>0;n--)i.removeChild(i.firstChild);if(t.lastRow>e.lastRow)for(var n=this.session.getFoldedRowCount(e.lastRow+1,t.lastRow);n>0;n--)i.removeChild(i.lastChild);if(e.firstRow<t.firstRow){var r=this.$renderLinesFragment(e,e.firstRow,t.firstRow-1);i.firstChild?i.insertBefore(r,i.firstChild):i.appendChild(r)}if(e.lastRow>t.lastRow){var r=this.$renderLinesFragment(e,t.lastRow+1,e.lastRow);i.appendChild(r)}},this.$renderLinesFragment=function(e,t,i){for(var n=this.element.ownerDocument.createDocumentFragment(),o=t,s=this.session.getNextFoldLine(o),a=s?s.start.row:1/0;;){if(o>a&&(o=s.end.row+1,s=this.session.getNextFoldLine(o,s),a=s?s.start.row:1/0),o>i)break;var l=r.createElement("div"),c=[];if(this.$renderLine(c,o,!1,o==a&&s),l.innerHTML=c.join(""),this.$useLineGroups())l.className="ace_line_group",n.appendChild(l),l.style.height=e.lineHeight*this.session.getRowLength(o)+"px";else for(;l.firstChild;)n.appendChild(l.firstChild);o++}return n},this.update=function(e){this.config=e;for(var t=[],i=e.firstRow,n=e.lastRow,r=i,o=this.session.getNextFoldLine(r),s=o?o.start.row:1/0;;){if(r>s&&(r=o.end.row+1,o=this.session.getNextFoldLine(r,o),s=o?o.start.row:1/0),r>n)break;this.$useLineGroups()&&t.push("<div class='ace_line_group' style='height:",e.lineHeight*this.session.getRowLength(r),"px'>"),this.$renderLine(t,r,!1,r==s&&o),this.$useLineGroups()&&t.push("</div>"),r++}this.element.innerHTML=t.join("")},this.$textToken={text:!0,rparen:!0,lparen:!0},this.$renderToken=function(e,t,i,n){var r=this,s=/\t|&|<|>|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\u3000\uFEFF\uFFF9-\uFFFC])|[\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3000-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]/g,a=function(e,i,n,s,a){if(i)return r.showInvisibles?"<span class='ace_invisible ace_invisible_space'>"+o.stringRepeat(r.SPACE_CHAR,e.length)+"</span>":e;if("&"==e)return"&#38;";if("<"==e)return"&#60;";if(">"==e)return"&#62;";if("\t"==e){var l=r.session.getScreenTabSize(t+s);return t+=l-1,r.$tabStrings[l]}if("　"==e){var c=r.showInvisibles?"ace_cjk ace_invisible ace_invisible_space":"ace_cjk",h=r.showInvisibles?r.SPACE_CHAR:"";return t+=1,"<span class='"+c+"' style='width:"+2*r.config.characterWidth+"px'>"+h+"</span>"}return n?"<span class='ace_invisible ace_invisible_space ace_invalid'>"+r.SPACE_CHAR+"</span>":(t+=1,"<span class='ace_cjk' style='width:"+2*r.config.characterWidth+"px'>"+e+"</span>")},l=n.replace(s,a);if(this.$textToken[i.type])e.push(l);else{var c="ace_"+i.type.replace(/\./g," ace_"),h="";"fold"==i.type&&(h=" style='width:"+i.value.length*this.config.characterWidth+"px;' "),e.push("<span class='",c,"'",h,">",l,"</span>")}return t+n.length},this.renderIndentGuide=function(e,t,i){var n=t.search(this.$indentGuideRe);return n<=0||n>=i?t:" "==t[0]?(n-=n%this.tabSize,e.push(o.stringRepeat(this.$tabStrings[" "],n/this.tabSize)),t.substr(n)):"\t"==t[0]?(e.push(o.stringRepeat(this.$tabStrings["\t"],n)),t.substr(n)):t},this.$renderWrappedLine=function(e,t,i,n){for(var r=0,s=0,a=i[0],l=0,c=0;c<t.length;c++){var h=t[c],d=h.value;if(0==c&&this.displayIndentGuides){if(r=d.length,d=this.renderIndentGuide(e,d,a),!d)continue;r-=d.length}if(r+d.length<a)l=this.$renderToken(e,l,h,d),r+=d.length;else{for(;r+d.length>=a;)l=this.$renderToken(e,l,h,d.substring(0,a-r)),d=d.substring(a-r),r=a,n||e.push("</div>","<div class='ace_line' style='height:",this.config.lineHeight,"px'>"),e.push(o.stringRepeat(" ",i.indent)),s++,l=0,a=i[s]||Number.MAX_VALUE;0!=d.length&&(r+=d.length,l=this.$renderToken(e,l,h,d))}}},this.$renderSimpleLine=function(e,t){var i=0,n=t[0],r=n.value;this.displayIndentGuides&&(r=this.renderIndentGuide(e,r)),r&&(i=this.$renderToken(e,i,n,r));for(var o=1;o<t.length;o++)n=t[o],r=n.value,i=this.$renderToken(e,i,n,r)},this.$renderLine=function(e,t,i,n){if(n||0==n||(n=this.session.getFoldLine(t)),n)var r=this.$getFoldLineTokens(t,n);else var r=this.session.getTokens(t);if(i||e.push("<div class='ace_line' style='height:",this.config.lineHeight*(this.$useLineGroups()?1:this.session.getRowLength(t)),"px'>"),r.length){var o=this.session.getRowSplitData(t);o&&o.length?this.$renderWrappedLine(e,r,o,i):this.$renderSimpleLine(e,r)}this.showInvisibles&&(n&&(t=n.end.row),e.push("<span class='ace_invisible ace_invisible_eol'>",t==this.session.getLength()-1?this.EOF_CHAR:this.EOL_CHAR,"</span>")),i||e.push("</div>")},this.$getFoldLineTokens=function(e,t){function i(e,t,i){for(var n=0,o=0;o+e[n].value.length<t;)if(o+=e[n].value.length,n++,n==e.length)return;if(o!=t){var s=e[n].value.substring(t-o);s.length>i-t&&(s=s.substring(0,i-t)),r.push({type:e[n].type,value:s}),o=t+s.length,n+=1}for(;o<i&&n<e.length;){var s=e[n].value;s.length+o>i?r.push({type:e[n].type,value:s.substring(0,i-o)}):r.push(e[n]),o+=s.length,n+=1}}var n=this.session,r=[],o=n.getTokens(e);return t.walk(function(e,t,s,a,l){null!=e?r.push({type:"fold",value:e}):(l&&(o=n.getTokens(t)),o.length&&i(o,a,s))},t.end.row,this.session.getLine(t.end.row).length),r},this.$useLineGroups=function(){return this.session.getUseWrapMode()},this.destroy=function(){clearInterval(this.$pollSizeChangesTimer),this.$measureNode&&this.$measureNode.parentNode.removeChild(this.$measureNode),delete this.$measureNode}}).call(a.prototype),t.Text=a}),ace.define("ace/layer/cursor",["require","exports","module","ace/lib/dom"],function(e,t,i){"use strict";var n,r=e("../lib/dom"),o=function(e){this.element=r.createElement("div"),this.element.className="ace_layer ace_cursor-layer",e.appendChild(this.element),void 0===n&&(n=!("opacity"in this.element.style)),this.isVisible=!1,this.isBlinking=!0,this.blinkInterval=1e3,this.smoothBlinking=!1,this.cursors=[],this.cursor=this.addCursor(),r.addCssClass(this.element,"ace_hidden-cursors"),this.$updateCursors=(n?this.$updateVisibility:this.$updateOpacity).bind(this)};(function(){this.$updateVisibility=function(e){for(var t=this.cursors,i=t.length;i--;)t[i].style.visibility=e?"":"hidden"},this.$updateOpacity=function(e){for(var t=this.cursors,i=t.length;i--;)t[i].style.opacity=e?"":"0"},this.$padding=0,this.setPadding=function(e){this.$padding=e},this.setSession=function(e){this.session=e},this.setBlinking=function(e){e!=this.isBlinking&&(this.isBlinking=e,this.restartTimer())},this.setBlinkInterval=function(e){e!=this.blinkInterval&&(this.blinkInterval=e,this.restartTimer())},this.setSmoothBlinking=function(e){e==this.smoothBlinking||n||(this.smoothBlinking=e,r.setCssClass(this.element,"ace_smooth-blinking",e),this.$updateCursors(!0),this.$updateCursors=this.$updateOpacity.bind(this),this.restartTimer())},this.addCursor=function(){var e=r.createElement("div");return e.className="ace_cursor",this.element.appendChild(e),this.cursors.push(e),e},this.removeCursor=function(){if(this.cursors.length>1){var e=this.cursors.pop();return e.parentNode.removeChild(e),e}},this.hideCursor=function(){this.isVisible=!1,r.addCssClass(this.element,"ace_hidden-cursors"),this.restartTimer()},this.showCursor=function(){this.isVisible=!0,r.removeCssClass(this.element,"ace_hidden-cursors"),this.restartTimer()},this.restartTimer=function(){var e=this.$updateCursors;if(clearInterval(this.intervalId),clearTimeout(this.timeoutId),this.smoothBlinking&&r.removeCssClass(this.element,"ace_smooth-blinking"),e(!0),this.isBlinking&&this.blinkInterval&&this.isVisible){this.smoothBlinking&&setTimeout(function(){r.addCssClass(this.element,"ace_smooth-blinking")}.bind(this));var t=function(){this.timeoutId=setTimeout(function(){e(!1)},.6*this.blinkInterval)}.bind(this);this.intervalId=setInterval(function(){e(!0),t()},this.blinkInterval),t()}},this.getPixelPosition=function(e,t){if(!this.config||!this.session)return{left:0,top:0};e||(e=this.session.selection.getCursor());var i=this.session.documentToScreenPosition(e),n=this.$padding+i.column*this.config.characterWidth,r=(i.row-(t?this.config.firstRowScreen:0))*this.config.lineHeight;return{left:n,top:r}},this.update=function(e){this.config=e;var t=this.session.$selectionMarkers,i=0,n=0;void 0!==t&&0!==t.length||(t=[{cursor:null}]);for(var i=0,r=t.length;i<r;i++){var o=this.getPixelPosition(t[i].cursor,!0);if(!((o.top>e.height+e.offset||o.top<0)&&i>1)){var s=(this.cursors[n++]||this.addCursor()).style;this.drawCursor?this.drawCursor(s,o,e,t[i],this.session):(s.left=o.left+"px",s.top=o.top+"px",s.width=e.characterWidth+"px",s.height=e.lineHeight+"px")}}for(;this.cursors.length>n;)this.removeCursor();var a=this.session.getOverwrite();this.$setOverwrite(a),this.$pixelPos=o,this.restartTimer()},this.drawCursor=null,this.$setOverwrite=function(e){e!=this.overwrite&&(this.overwrite=e,e?r.addCssClass(this.element,"ace_overwrite-cursors"):r.removeCssClass(this.element,"ace_overwrite-cursors"))},this.destroy=function(){clearInterval(this.intervalId),clearTimeout(this.timeoutId)}}).call(o.prototype),t.Cursor=o}),ace.define("ace/scrollbar",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/event","ace/lib/event_emitter"],function(e,t,i){"use strict";var n=e("./lib/oop"),r=e("./lib/dom"),o=e("./lib/event"),s=e("./lib/event_emitter").EventEmitter,a=function(e){this.element=r.createElement("div"),this.element.className="ace_scrollbar ace_scrollbar"+this.classSuffix,this.inner=r.createElement("div"),this.inner.className="ace_scrollbar-inner",this.element.appendChild(this.inner),e.appendChild(this.element),this.setVisible(!1),this.skipEvent=!1,o.addListener(this.element,"scroll",this.onScroll.bind(this)),o.addListener(this.element,"mousedown",o.preventDefault)};(function(){n.implement(this,s),this.setVisible=function(e){this.element.style.display=e?"":"none",this.isVisible=e}}).call(a.prototype);var l=function(e,t){a.call(this,e),this.scrollTop=0,t.$scrollbarWidth=this.width=r.scrollbarWidth(e.ownerDocument),this.inner.style.width=this.element.style.width=(this.width||15)+5+"px"};n.inherits(l,a),function(){this.classSuffix="-v",this.onScroll=function(){this.skipEvent||(this.scrollTop=this.element.scrollTop,this._emit("scroll",{data:this.scrollTop})),this.skipEvent=!1},this.getWidth=function(){return this.isVisible?this.width:0},this.setHeight=function(e){this.element.style.height=e+"px"},this.setInnerHeight=function(e){this.inner.style.height=e+"px"},this.setScrollHeight=function(e){this.inner.style.height=e+"px"},this.setScrollTop=function(e){this.scrollTop!=e&&(this.skipEvent=!0,this.scrollTop=this.element.scrollTop=e)}}.call(l.prototype);var c=function(e,t){a.call(this,e),this.scrollLeft=0,this.height=t.$scrollbarWidth,this.inner.style.height=this.element.style.height=(this.height||15)+5+"px"};n.inherits(c,a),function(){this.classSuffix="-h",this.onScroll=function(){this.skipEvent||(this.scrollLeft=this.element.scrollLeft,this._emit("scroll",{data:this.scrollLeft})),this.skipEvent=!1},this.getHeight=function(){return this.isVisible?this.height:0},this.setWidth=function(e){this.element.style.width=e+"px"},this.setInnerWidth=function(e){this.inner.style.width=e+"px"},this.setScrollWidth=function(e){this.inner.style.width=e+"px"},this.setScrollLeft=function(e){this.scrollLeft!=e&&(this.skipEvent=!0,this.scrollLeft=this.element.scrollLeft=e)}}.call(c.prototype),t.ScrollBar=l,t.ScrollBarV=l,t.ScrollBarH=c,t.VScrollBar=l,t.HScrollBar=c}),ace.define("ace/renderloop",["require","exports","module","ace/lib/event"],function(e,t,i){"use strict";var n=e("./lib/event"),r=function(e,t){this.onRender=e,this.pending=!1,this.changes=0,this.window=t||window};(function(){this.schedule=function(e){if(this.changes=this.changes|e,!this.pending&&this.changes){this.pending=!0;var t=this;n.nextFrame(function(){t.pending=!1;for(var e;e=t.changes;)t.changes=0,t.onRender(e)},this.window)}}}).call(r.prototype),t.RenderLoop=r}),ace.define("ace/layer/font_metrics",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/lib/event_emitter"],function(e,t,i){var n=e("../lib/oop"),r=e("../lib/dom"),o=e("../lib/lang"),s=e("../lib/useragent"),a=e("../lib/event_emitter").EventEmitter,l=0,c=t.FontMetrics=function(e){this.el=r.createElement("div"),this.$setMeasureNodeStyles(this.el.style,!0),this.$main=r.createElement("div"),this.$setMeasureNodeStyles(this.$main.style),this.$measureNode=r.createElement("div"),this.$setMeasureNodeStyles(this.$measureNode.style),this.el.appendChild(this.$main),this.el.appendChild(this.$measureNode),e.appendChild(this.el),l||this.$testFractionalRect(),this.$measureNode.innerHTML=o.stringRepeat("X",l),this.$characterSize={width:0,height:0},this.checkForSizeChanges()};(function(){n.implement(this,a),this.$characterSize={width:0,height:0},this.$testFractionalRect=function(){var e=r.createElement("div");this.$setMeasureNodeStyles(e.style),e.style.width="0.2px",document.documentElement.appendChild(e);var t=e.getBoundingClientRect().width;l=t>0&&t<1?50:100,e.parentNode.removeChild(e)},this.$setMeasureNodeStyles=function(e,t){e.width=e.height="auto",e.left=e.top="0px",e.visibility="hidden",e.position="absolute",e.whiteSpace="pre",s.isIE<8?e["font-family"]="inherit":e.font="inherit",e.overflow=t?"hidden":"visible"},this.checkForSizeChanges=function(){var e=this.$measureSizes();if(e&&(this.$characterSize.width!==e.width||this.$characterSize.height!==e.height)){this.$measureNode.style.fontWeight="bold";var t=this.$measureSizes();this.$measureNode.style.fontWeight="",this.$characterSize=e,this.charSizes=Object.create(null),this.allowBoldFonts=t&&t.width===e.width&&t.height===e.height,this._emit("changeCharacterSize",{data:e})}},this.$pollSizeChanges=function(){if(this.$pollSizeChangesTimer)return this.$pollSizeChangesTimer;var e=this;return this.$pollSizeChangesTimer=setInterval(function(){e.checkForSizeChanges()},500)},this.setPolling=function(e){e?this.$pollSizeChanges():this.$pollSizeChangesTimer&&(clearInterval(this.$pollSizeChangesTimer),this.$pollSizeChangesTimer=0)},this.$measureSizes=function(){if(50===l){var e=null;try{e=this.$measureNode.getBoundingClientRect()}catch(t){e={width:0,height:0}}var t={height:e.height,width:e.width/l}}else var t={height:this.$measureNode.clientHeight,width:this.$measureNode.clientWidth/l};return 0===t.width||0===t.height?null:t},this.$measureCharWidth=function(e){this.$main.innerHTML=o.stringRepeat(e,l);var t=this.$main.getBoundingClientRect();return t.width/l},this.getCharacterWidth=function(e){var t=this.charSizes[e];return void 0===t&&(t=this.charSizes[e]=this.$measureCharWidth(e)/this.$characterSize.width),t},this.destroy=function(){clearInterval(this.$pollSizeChangesTimer),this.el&&this.el.parentNode&&this.el.parentNode.removeChild(this.el)}}).call(c.prototype)}),ace.define("ace/virtual_renderer",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/config","ace/lib/useragent","ace/layer/gutter","ace/layer/marker","ace/layer/text","ace/layer/cursor","ace/scrollbar","ace/scrollbar","ace/renderloop","ace/layer/font_metrics","ace/lib/event_emitter"],function(e,t,i){"use strict";var n=e("./lib/oop"),r=e("./lib/dom"),o=e("./config"),s=e("./lib/useragent"),a=e("./layer/gutter").Gutter,l=e("./layer/marker").Marker,c=e("./layer/text").Text,h=e("./layer/cursor").Cursor,d=e("./scrollbar").HScrollBar,u=e("./scrollbar").VScrollBar,f=e("./renderloop").RenderLoop,p=e("./layer/font_metrics").FontMetrics,m=e("./lib/event_emitter").EventEmitter,g='.ace_editor {\tposition: relative;\toverflow: hidden;\tfont: 12px/normal \'Monaco\', \'Menlo\', \'Ubuntu Mono\', \'Consolas\', \'source-code-pro\', monospace;\tdirection: ltr;\t}\t.ace_scroller {\tposition: absolute;\toverflow: hidden;\ttop: 0;\tbottom: 0;\tbackground-color: inherit;\t-ms-user-select: none;\t-moz-user-select: none;\t-webkit-user-select: none;\tuser-select: none;\tcursor: text;\t}\t.ace_content {\tposition: absolute;\t-moz-box-sizing: border-box;\t-webkit-box-sizing: border-box;\tbox-sizing: border-box;\tmin-width: 100%;\t}\t.ace_dragging .ace_scroller:before{\tposition: absolute;\ttop: 0;\tleft: 0;\tright: 0;\tbottom: 0;\tcontent: \'\';\tbackground: rgba(250, 250, 250, 0.01);\tz-index: 1000;\t}\t.ace_dragging.ace_dark .ace_scroller:before{\tbackground: rgba(0, 0, 0, 0.01);\t}\t.ace_selecting, .ace_selecting * {\tcursor: text !important;\t}\t.ace_gutter {\tposition: absolute;\toverflow : hidden;\twidth: auto;\ttop: 0;\tbottom: 0;\tleft: 0;\tcursor: default;\tz-index: 4;\t-ms-user-select: none;\t-moz-user-select: none;\t-webkit-user-select: none;\tuser-select: none;\t}\t.ace_gutter-active-line {\tposition: absolute;\tleft: 0;\tright: 0;\t}\t.ace_scroller.ace_scroll-left {\tbox-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\t}\t.ace_gutter-cell {\tpadding-left: 19px;\tpadding-right: 6px;\tbackground-repeat: no-repeat;\t}\t.ace_gutter-cell.ace_error {\tbackground-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==");\tbackground-repeat: no-repeat;\tbackground-position: 2px center;\t}\t.ace_gutter-cell.ace_warning {\tbackground-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==");\tbackground-position: 2px center;\t}\t.ace_gutter-cell.ace_info {\tbackground-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=");\tbackground-position: 2px center;\t}\t.ace_dark .ace_gutter-cell.ace_info {\tbackground-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC");\t}\t.ace_scrollbar {\tposition: absolute;\tright: 0;\tbottom: 0;\tz-index: 6;\t}\t.ace_scrollbar-inner {\tposition: absolute;\tcursor: text;\tleft: 0;\ttop: 0;\t}\t.ace_scrollbar-v{\toverflow-x: hidden;\toverflow-y: scroll;\ttop: 0;\t}\t.ace_scrollbar-h {\toverflow-x: scroll;\toverflow-y: hidden;\tleft: 0;\t}\t.ace_print-margin {\tposition: absolute;\theight: 100%;\t}\t.ace_text-input {\tposition: absolute;\tz-index: 0;\twidth: 0.5em;\theight: 1em;\topacity: 0;\tbackground: transparent;\t-moz-appearance: none;\tappearance: none;\tborder: none;\tresize: none;\toutline: none;\toverflow: hidden;\tfont: inherit;\tpadding: 0 1px;\tmargin: 0 -1px;\ttext-indent: -1em;\t-ms-user-select: text;\t-moz-user-select: text;\t-webkit-user-select: text;\tuser-select: text;\twhite-space: pre!important;\t}\t.ace_text-input.ace_composition {\tbackground: inherit;\tcolor: inherit;\tz-index: 1000;\topacity: 1;\ttext-indent: 0;\t}\t.ace_layer {\tz-index: 1;\tposition: absolute;\toverflow: hidden;\tword-wrap: normal;\twhite-space: pre;\theight: 100%;\twidth: 100%;\t-moz-box-sizing: border-box;\t-webkit-box-sizing: border-box;\tbox-sizing: border-box;\tpointer-events: none;\t}\t.ace_gutter-layer {\tposition: relative;\twidth: auto;\ttext-align: right;\tpointer-events: auto;\t}\t.ace_text-layer {\tfont: inherit !important;\t}\t.ace_cjk {\tdisplay: inline-block;\ttext-align: center;\t}\t.ace_cursor-layer {\tz-index: 4;\t}\t.ace_cursor {\tz-index: 4;\tposition: absolute;\t-moz-box-sizing: border-box;\t-webkit-box-sizing: border-box;\tbox-sizing: border-box;\tborder-left: 2px solid;\ttransform: translatez(0);\t}\t.ace_slim-cursors .ace_cursor {\tborder-left-width: 1px;\t}\t.ace_overwrite-cursors .ace_cursor {\tborder-left-width: 0;\tborder-bottom: 1px solid;\t}\t.ace_hidden-cursors .ace_cursor {\topacity: 0.2;\t}\t.ace_smooth-blinking .ace_cursor {\t-webkit-transition: opacity 0.18s;\ttransition: opacity 0.18s;\t}\t.ace_editor.ace_multiselect .ace_cursor {\tborder-left-width: 1px;\t}\t.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\tposition: absolute;\tz-index: 3;\t}\t.ace_marker-layer .ace_selection {\tposition: absolute;\tz-index: 5;\t}\t.ace_marker-layer .ace_bracket {\tposition: absolute;\tz-index: 6;\t}\t.ace_marker-layer .ace_active-line {\tposition: absolute;\tz-index: 2;\t}\t.ace_marker-layer .ace_selected-word {\tposition: absolute;\tz-index: 4;\t-moz-box-sizing: border-box;\t-webkit-box-sizing: border-box;\tbox-sizing: border-box;\t}\t.ace_line .ace_fold {\t-moz-box-sizing: border-box;\t-webkit-box-sizing: border-box;\tbox-sizing: border-box;\tdisplay: inline-block;\theight: 11px;\tmargin-top: -2px;\tvertical-align: middle;\tbackground-image:\turl("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\turl("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=");\tbackground-repeat: no-repeat, repeat-x;\tbackground-position: center center, top left;\tcolor: transparent;\tborder: 1px solid black;\tborder-radius: 2px;\tcursor: pointer;\tpointer-events: auto;\t}\t.ace_dark .ace_fold {\t}\t.ace_fold:hover{\tbackground-image:\turl("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\turl("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC");\t}\t.ace_tooltip {\tbackground-color: #FFF;\tbackground-image: -webkit-linear-gradient(top, transparent, rgba(0, 0, 0, 0.1));\tbackground-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.1));\tborder: 1px solid gray;\tborder-radius: 1px;\tbox-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\tcolor: black;\tmax-width: 100%;\tpadding: 3px 4px;\tposition: fixed;\tz-index: 999999;\t-moz-box-sizing: border-box;\t-webkit-box-sizing: border-box;\tbox-sizing: border-box;\tcursor: default;\twhite-space: pre;\tword-wrap: break-word;\tline-height: normal;\tfont-style: normal;\tfont-weight: normal;\tletter-spacing: normal;\tpointer-events: none;\t}\t.ace_folding-enabled > .ace_gutter-cell {\tpadding-right: 13px;\t}\t.ace_fold-widget {\t-moz-box-sizing: border-box;\t-webkit-box-sizing: border-box;\tbox-sizing: border-box;\tmargin: 0 -12px 0 1px;\tdisplay: none;\twidth: 11px;\tvertical-align: top;\tbackground-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==");\tbackground-repeat: no-repeat;\tbackground-position: center;\tborder-radius: 3px;\tborder: 1px solid transparent;\tcursor: pointer;\t}\t.ace_folding-enabled .ace_fold-widget {\tdisplay: inline-block;   \t}\t.ace_fold-widget.ace_end {\tbackground-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==");\t}\t.ace_fold-widget.ace_closed {\tbackground-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==");\t}\t.ace_fold-widget:hover {\tborder: 1px solid rgba(0, 0, 0, 0.3);\tbackground-color: rgba(255, 255, 255, 0.2);\tbox-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\t}\t.ace_fold-widget:active {\tborder: 1px solid rgba(0, 0, 0, 0.4);\tbackground-color: rgba(0, 0, 0, 0.05);\tbox-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\t}\t.ace_dark .ace_fold-widget {\tbackground-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC");\t}\t.ace_dark .ace_fold-widget.ace_end {\tbackground-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==");\t}\t.ace_dark .ace_fold-widget.ace_closed {\tbackground-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==");\t}\t.ace_dark .ace_fold-widget:hover {\tbox-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\tbackground-color: rgba(255, 255, 255, 0.1);\t}\t.ace_dark .ace_fold-widget:active {\tbox-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\t}\t.ace_fold-widget.ace_invalid {\tbackground-color: #FFB4B4;\tborder-color: #DE5555;\t}\t.ace_fade-fold-widgets .ace_fold-widget {\t-webkit-transition: opacity 0.4s ease 0.05s;\ttransition: opacity 0.4s ease 0.05s;\topacity: 0;\t}\t.ace_fade-fold-widgets:hover .ace_fold-widget {\t-webkit-transition: opacity 0.05s ease 0.05s;\ttransition: opacity 0.05s ease 0.05s;\topacity:1;\t}\t.ace_underline {\ttext-decoration: underline;\t}\t.ace_bold {\tfont-weight: bold;\t}\t.ace_nobold .ace_bold {\tfont-weight: normal;\t}\t.ace_italic {\tfont-style: italic;\t}\t.ace_error-marker {\tbackground-color: rgba(255, 0, 0,0.2);\tposition: absolute;\tz-index: 9;\t}\t.ace_highlight-marker {\tbackground-color: rgba(255, 255, 0,0.2);\tposition: absolute;\tz-index: 8;\t}\t.ace_br1 {border-top-left-radius    : 3px;}\t.ace_br2 {border-top-right-radius   : 3px;}\t.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\t.ace_br4 {border-bottom-right-radius: 3px;}\t.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\t.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\t.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\t.ace_br8 {border-bottom-left-radius : 3px;}\t.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\t.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\t.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\t.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\t.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\t.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\t.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\t';
	r.importCssString(g,"ace_editor.css");var v=function(e,t){var i=this;this.container=e||r.createElement("div"),this.$keepTextAreaAtCursor=!s.isOldIE,r.addCssClass(this.container,"ace_editor"),this.setTheme(t),this.$gutter=r.createElement("div"),this.$gutter.className="ace_gutter",this.container.appendChild(this.$gutter),this.scroller=r.createElement("div"),this.scroller.className="ace_scroller",this.container.appendChild(this.scroller),this.content=r.createElement("div"),this.content.className="ace_content",this.scroller.appendChild(this.content),this.$gutterLayer=new a(this.$gutter),this.$gutterLayer.on("changeGutterWidth",this.onGutterResize.bind(this)),this.$markerBack=new l(this.content);var n=this.$textLayer=new c(this.content);this.canvas=n.element,this.$markerFront=new l(this.content),this.$cursorLayer=new h(this.content),this.$horizScroll=!1,this.$vScroll=!1,this.scrollBar=this.scrollBarV=new u(this.container,this),this.scrollBarH=new d(this.container,this),this.scrollBarV.addEventListener("scroll",function(e){i.$scrollAnimation||i.session.setScrollTop(e.data-i.scrollMargin.top)}),this.scrollBarH.addEventListener("scroll",function(e){i.$scrollAnimation||i.session.setScrollLeft(e.data-i.scrollMargin.left)}),this.scrollTop=0,this.scrollLeft=0,this.cursorPos={row:0,column:0},this.$fontMetrics=new p(this.container),this.$textLayer.$setFontMetrics(this.$fontMetrics),this.$textLayer.addEventListener("changeCharacterSize",function(e){i.updateCharacterSize(),i.onResize(!0,i.gutterWidth,i.$size.width,i.$size.height),i._signal("changeCharacterSize",e)}),this.$size={width:0,height:0,scrollerHeight:0,scrollerWidth:0,$dirty:!0},this.layerConfig={width:1,padding:0,firstRow:0,firstRowScreen:0,lastRow:0,lineHeight:0,characterWidth:0,minHeight:1,maxHeight:1,offset:0,height:1,gutterOffset:1},this.scrollMargin={left:0,right:0,top:0,bottom:0,v:0,h:0},this.$loop=new f(this.$renderChanges.bind(this),this.container.ownerDocument.defaultView),this.$loop.schedule(this.CHANGE_FULL),this.updateCharacterSize(),this.setPadding(4),o.resetOptions(this),o._emit("renderer",this)};(function(){this.CHANGE_CURSOR=1,this.CHANGE_MARKER=2,this.CHANGE_GUTTER=4,this.CHANGE_SCROLL=8,this.CHANGE_LINES=16,this.CHANGE_TEXT=32,this.CHANGE_SIZE=64,this.CHANGE_MARKER_BACK=128,this.CHANGE_MARKER_FRONT=256,this.CHANGE_FULL=512,this.CHANGE_H_SCROLL=1024,n.implement(this,m),this.updateCharacterSize=function(){this.$textLayer.allowBoldFonts!=this.$allowBoldFonts&&(this.$allowBoldFonts=this.$textLayer.allowBoldFonts,this.setStyle("ace_nobold",!this.$allowBoldFonts)),this.layerConfig.characterWidth=this.characterWidth=this.$textLayer.getCharacterWidth(),this.layerConfig.lineHeight=this.lineHeight=this.$textLayer.getLineHeight(),this.$updatePrintMargin()},this.setSession=function(e){this.session&&this.session.doc.off("changeNewLineMode",this.onChangeNewLineMode),this.session=e,e&&this.scrollMargin.top&&e.getScrollTop()<=0&&e.setScrollTop(-this.scrollMargin.top),this.$cursorLayer.setSession(e),this.$markerBack.setSession(e),this.$markerFront.setSession(e),this.$gutterLayer.setSession(e),this.$textLayer.setSession(e),e&&(this.$loop.schedule(this.CHANGE_FULL),this.session.$setFontMetrics(this.$fontMetrics),this.onChangeNewLineMode=this.onChangeNewLineMode.bind(this),this.onChangeNewLineMode(),this.session.doc.on("changeNewLineMode",this.onChangeNewLineMode))},this.updateLines=function(e,t,i){if(void 0===t&&(t=1/0),this.$changedLines?(this.$changedLines.firstRow>e&&(this.$changedLines.firstRow=e),this.$changedLines.lastRow<t&&(this.$changedLines.lastRow=t)):this.$changedLines={firstRow:e,lastRow:t},this.$changedLines.lastRow<this.layerConfig.firstRow){if(!i)return;this.$changedLines.lastRow=this.layerConfig.lastRow}this.$changedLines.firstRow>this.layerConfig.lastRow||this.$loop.schedule(this.CHANGE_LINES)},this.onChangeNewLineMode=function(){this.$loop.schedule(this.CHANGE_TEXT),this.$textLayer.$updateEolChar()},this.onChangeTabSize=function(){this.$loop.schedule(this.CHANGE_TEXT|this.CHANGE_MARKER),this.$textLayer.onChangeTabSize()},this.updateText=function(){this.$loop.schedule(this.CHANGE_TEXT)},this.updateFull=function(e){e?this.$renderChanges(this.CHANGE_FULL,!0):this.$loop.schedule(this.CHANGE_FULL)},this.updateFontSize=function(){this.$textLayer.checkForSizeChanges()},this.$changes=0,this.$updateSizeAsync=function(){this.$loop.pending?this.$size.$dirty=!0:this.onResize()},this.onResize=function(e,t,i,n){if(!(this.resizing>2)){this.resizing>0?this.resizing++:this.resizing=e?1:0;var r=this.container;n||(n=r.clientHeight||r.scrollHeight),i||(i=r.clientWidth||r.scrollWidth);var o=this.$updateCachedSize(e,t,i,n);if(!this.$size.scrollerHeight||!i&&!n)return this.resizing=0;e&&(this.$gutterLayer.$padding=null),e?this.$renderChanges(o|this.$changes,!0):this.$loop.schedule(o|this.$changes),this.resizing&&(this.resizing=0),this.scrollBarV.scrollLeft=this.scrollBarV.scrollTop=null}},this.$updateCachedSize=function(e,t,i,n){n-=this.$extraHeight||0;var r=0,o=this.$size,s={width:o.width,height:o.height,scrollerHeight:o.scrollerHeight,scrollerWidth:o.scrollerWidth};return n&&(e||o.height!=n)&&(o.height=n,r|=this.CHANGE_SIZE,o.scrollerHeight=o.height,this.$horizScroll&&(o.scrollerHeight-=this.scrollBarH.getHeight()),this.scrollBarV.element.style.bottom=this.scrollBarH.getHeight()+"px",r|=this.CHANGE_SCROLL),i&&(e||o.width!=i)&&(r|=this.CHANGE_SIZE,o.width=i,null==t&&(t=this.$showGutter?this.$gutter.offsetWidth:0),this.gutterWidth=t,this.scrollBarH.element.style.left=this.scroller.style.left=t+"px",o.scrollerWidth=Math.max(0,i-t-this.scrollBarV.getWidth()),this.scrollBarH.element.style.right=this.scroller.style.right=this.scrollBarV.getWidth()+"px",this.scroller.style.bottom=this.scrollBarH.getHeight()+"px",(this.session&&this.session.getUseWrapMode()&&this.adjustWrapLimit()||e)&&(r|=this.CHANGE_FULL)),o.$dirty=!i||!n,r&&this._signal("resize",s),r},this.onGutterResize=function(){var e=this.$showGutter?this.$gutter.offsetWidth:0;e!=this.gutterWidth&&(this.$changes|=this.$updateCachedSize(!0,e,this.$size.width,this.$size.height)),this.session.getUseWrapMode()&&this.adjustWrapLimit()?this.$loop.schedule(this.CHANGE_FULL):this.$size.$dirty?this.$loop.schedule(this.CHANGE_FULL):(this.$computeLayerConfig(),this.$loop.schedule(this.CHANGE_MARKER))},this.adjustWrapLimit=function(){var e=this.$size.scrollerWidth-2*this.$padding,t=Math.floor(e/this.characterWidth);return this.session.adjustWrapLimit(t,this.$showPrintMargin&&this.$printMarginColumn)},this.setAnimatedScroll=function(e){this.setOption("animatedScroll",e)},this.getAnimatedScroll=function(){return this.$animatedScroll},this.setShowInvisibles=function(e){this.setOption("showInvisibles",e)},this.getShowInvisibles=function(){return this.getOption("showInvisibles")},this.getDisplayIndentGuides=function(){return this.getOption("displayIndentGuides")},this.setDisplayIndentGuides=function(e){this.setOption("displayIndentGuides",e)},this.setShowPrintMargin=function(e){this.setOption("showPrintMargin",e)},this.getShowPrintMargin=function(){return this.getOption("showPrintMargin")},this.setPrintMarginColumn=function(e){this.setOption("printMarginColumn",e)},this.getPrintMarginColumn=function(){return this.getOption("printMarginColumn")},this.getShowGutter=function(){return this.getOption("showGutter")},this.setShowGutter=function(e){return this.setOption("showGutter",e)},this.getFadeFoldWidgets=function(){return this.getOption("fadeFoldWidgets")},this.setFadeFoldWidgets=function(e){this.setOption("fadeFoldWidgets",e)},this.setHighlightGutterLine=function(e){this.setOption("highlightGutterLine",e)},this.getHighlightGutterLine=function(){return this.getOption("highlightGutterLine")},this.$updateGutterLineHighlight=function(){var e=this.$cursorLayer.$pixelPos,t=this.layerConfig.lineHeight;if(this.session.getUseWrapMode()){var i=this.session.selection.getCursor();i.column=0,e=this.$cursorLayer.getPixelPosition(i,!0),t*=this.session.getRowLength(i.row)}this.$gutterLineHighlight.style.top=e.top-this.layerConfig.offset+"px",this.$gutterLineHighlight.style.height=t+"px"},this.$updatePrintMargin=function(){if(this.$showPrintMargin||this.$printMarginEl){if(!this.$printMarginEl){var e=r.createElement("div");e.className="ace_layer ace_print-margin-layer",this.$printMarginEl=r.createElement("div"),this.$printMarginEl.className="ace_print-margin",e.appendChild(this.$printMarginEl),this.content.insertBefore(e,this.content.firstChild)}var t=this.$printMarginEl.style;t.left=this.characterWidth*this.$printMarginColumn+this.$padding+"px",t.visibility=this.$showPrintMargin?"visible":"hidden",this.session&&this.session.$wrap==-1&&this.adjustWrapLimit()}},this.getContainerElement=function(){return this.container},this.getMouseEventTarget=function(){return this.scroller},this.getTextAreaContainer=function(){return this.container},this.$moveTextAreaToCursor=function(){if(this.$keepTextAreaAtCursor){var e=this.layerConfig,t=this.$cursorLayer.$pixelPos.top,i=this.$cursorLayer.$pixelPos.left;t-=e.offset;var n=this.textarea.style,r=this.lineHeight;if(t<0||t>e.height-r)return void(n.top=n.left="0");var o=this.characterWidth;if(this.$composition){var s=this.textarea.value.replace(/^\x01+/,"");o*=this.session.$getStringScreenWidth(s)[0]+2,r+=2}i-=this.scrollLeft,i>this.$size.scrollerWidth-o&&(i=this.$size.scrollerWidth-o),i+=this.gutterWidth,n.height=r+"px",n.width=o+"px",n.left=Math.min(i,this.$size.scrollerWidth-o)+"px",n.top=Math.min(t,this.$size.height-r)+"px"}},this.getFirstVisibleRow=function(){return this.layerConfig.firstRow},this.getFirstFullyVisibleRow=function(){return this.layerConfig.firstRow+(0===this.layerConfig.offset?0:1)},this.getLastFullyVisibleRow=function(){var e=this.layerConfig,t=e.lastRow,i=this.session.documentToScreenRow(t,0)*e.lineHeight;return i-this.session.getScrollTop()>e.height-e.lineHeight?t-1:t},this.getLastVisibleRow=function(){return this.layerConfig.lastRow},this.$padding=null,this.setPadding=function(e){this.$padding=e,this.$textLayer.setPadding(e),this.$cursorLayer.setPadding(e),this.$markerFront.setPadding(e),this.$markerBack.setPadding(e),this.$loop.schedule(this.CHANGE_FULL),this.$updatePrintMargin()},this.setScrollMargin=function(e,t,i,n){var r=this.scrollMargin;r.top=0|e,r.bottom=0|t,r.right=0|n,r.left=0|i,r.v=r.top+r.bottom,r.h=r.left+r.right,r.top&&this.scrollTop<=0&&this.session&&this.session.setScrollTop(-r.top),this.updateFull()},this.getHScrollBarAlwaysVisible=function(){return this.$hScrollBarAlwaysVisible},this.setHScrollBarAlwaysVisible=function(e){this.setOption("hScrollBarAlwaysVisible",e)},this.getVScrollBarAlwaysVisible=function(){return this.$vScrollBarAlwaysVisible},this.setVScrollBarAlwaysVisible=function(e){this.setOption("vScrollBarAlwaysVisible",e)},this.$updateScrollBarV=function(){var e=this.layerConfig.maxHeight,t=this.$size.scrollerHeight;!this.$maxLines&&this.$scrollPastEnd&&(e-=(t-this.lineHeight)*this.$scrollPastEnd,this.scrollTop>e-t&&(e=this.scrollTop+t,this.scrollBarV.scrollTop=null)),this.scrollBarV.setScrollHeight(e+this.scrollMargin.v),this.scrollBarV.setScrollTop(this.scrollTop+this.scrollMargin.top)},this.$updateScrollBarH=function(){this.scrollBarH.setScrollWidth(this.layerConfig.width+2*this.$padding+this.scrollMargin.h),this.scrollBarH.setScrollLeft(this.scrollLeft+this.scrollMargin.left)},this.$frozen=!1,this.freeze=function(){this.$frozen=!0},this.unfreeze=function(){this.$frozen=!1},this.$renderChanges=function(e,t){if(this.$changes&&(e|=this.$changes,this.$changes=0),!this.session||!this.container.offsetWidth||this.$frozen||!e&&!t)return void(this.$changes|=e);if(this.$size.$dirty)return this.$changes|=e,this.onResize(!0);this.lineHeight||this.$textLayer.checkForSizeChanges(),this._signal("beforeRender");var i=this.layerConfig;if(e&this.CHANGE_FULL||e&this.CHANGE_SIZE||e&this.CHANGE_TEXT||e&this.CHANGE_LINES||e&this.CHANGE_SCROLL||e&this.CHANGE_H_SCROLL){if(e|=this.$computeLayerConfig(),i.firstRow!=this.layerConfig.firstRow&&i.firstRowScreen==this.layerConfig.firstRowScreen){var n=this.scrollTop+(i.firstRow-this.layerConfig.firstRow)*this.lineHeight;n>0&&(this.scrollTop=n,e|=this.CHANGE_SCROLL,e|=this.$computeLayerConfig())}i=this.layerConfig,this.$updateScrollBarV(),e&this.CHANGE_H_SCROLL&&this.$updateScrollBarH(),this.$gutterLayer.element.style.marginTop=-i.offset+"px",this.content.style.marginTop=-i.offset+"px",this.content.style.width=i.width+2*this.$padding+"px",this.content.style.height=i.minHeight+"px"}return e&this.CHANGE_H_SCROLL&&(this.content.style.marginLeft=-this.scrollLeft+"px",this.scroller.className=this.scrollLeft<=0?"ace_scroller":"ace_scroller ace_scroll-left"),e&this.CHANGE_FULL?(this.$textLayer.update(i),this.$showGutter&&this.$gutterLayer.update(i),this.$markerBack.update(i),this.$markerFront.update(i),this.$cursorLayer.update(i),this.$moveTextAreaToCursor(),this.$highlightGutterLine&&this.$updateGutterLineHighlight(),void this._signal("afterRender")):e&this.CHANGE_SCROLL?(e&this.CHANGE_TEXT||e&this.CHANGE_LINES?this.$textLayer.update(i):this.$textLayer.scrollLines(i),this.$showGutter&&this.$gutterLayer.update(i),this.$markerBack.update(i),this.$markerFront.update(i),this.$cursorLayer.update(i),this.$highlightGutterLine&&this.$updateGutterLineHighlight(),this.$moveTextAreaToCursor(),void this._signal("afterRender")):(e&this.CHANGE_TEXT?(this.$textLayer.update(i),this.$showGutter&&this.$gutterLayer.update(i)):e&this.CHANGE_LINES?(this.$updateLines()||e&this.CHANGE_GUTTER&&this.$showGutter)&&this.$gutterLayer.update(i):(e&this.CHANGE_TEXT||e&this.CHANGE_GUTTER)&&this.$showGutter&&this.$gutterLayer.update(i),e&this.CHANGE_CURSOR&&(this.$cursorLayer.update(i),this.$moveTextAreaToCursor(),this.$highlightGutterLine&&this.$updateGutterLineHighlight()),e&(this.CHANGE_MARKER|this.CHANGE_MARKER_FRONT)&&this.$markerFront.update(i),e&(this.CHANGE_MARKER|this.CHANGE_MARKER_BACK)&&this.$markerBack.update(i),void this._signal("afterRender"))},this.$autosize=function(){var e=this.session.getScreenLength()*this.lineHeight,t=this.$maxLines*this.lineHeight,i=Math.max((this.$minLines||1)*this.lineHeight,Math.min(t,e))+this.scrollMargin.v+(this.$extraHeight||0);this.$horizScroll&&(i+=this.scrollBarH.getHeight());var n=e>t;if(i!=this.desiredHeight||this.$size.height!=this.desiredHeight||n!=this.$vScroll){n!=this.$vScroll&&(this.$vScroll=n,this.scrollBarV.setVisible(n));var r=this.container.clientWidth;this.container.style.height=i+"px",this.$updateCachedSize(!0,this.$gutterWidth,r,i),this.desiredHeight=i,this._signal("autosize")}},this.$computeLayerConfig=function(){var e=this.session,t=this.$size,i=t.height<=2*this.lineHeight,n=this.session.getScreenLength(),r=n*this.lineHeight,o=this.$getLongestLine(),s=!i&&(this.$hScrollBarAlwaysVisible||t.scrollerWidth-o-2*this.$padding<0),a=this.$horizScroll!==s;a&&(this.$horizScroll=s,this.scrollBarH.setVisible(s));var l=this.$vScroll;this.$maxLines&&this.lineHeight>1&&this.$autosize();var c=this.scrollTop%this.lineHeight,h=t.scrollerHeight+this.lineHeight,d=!this.$maxLines&&this.$scrollPastEnd?(t.scrollerHeight-this.lineHeight)*this.$scrollPastEnd:0;r+=d;var u=this.scrollMargin;this.session.setScrollTop(Math.max(-u.top,Math.min(this.scrollTop,r-t.scrollerHeight+u.bottom))),this.session.setScrollLeft(Math.max(-u.left,Math.min(this.scrollLeft,o+2*this.$padding-t.scrollerWidth+u.right)));var f=!i&&(this.$vScrollBarAlwaysVisible||t.scrollerHeight-r+d<0||this.scrollTop>u.top),p=l!==f;p&&(this.$vScroll=f,this.scrollBarV.setVisible(f));var m,g,v=Math.ceil(h/this.lineHeight)-1,y=Math.max(0,Math.round((this.scrollTop-c)/this.lineHeight)),w=y+v,b=this.lineHeight;y=e.screenToDocumentRow(y,0);var A=e.getFoldLine(y);A&&(y=A.start.row),m=e.documentToScreenRow(y,0),g=e.getRowLength(y)*b,w=Math.min(e.screenToDocumentRow(w,0),e.getLength()-1),h=t.scrollerHeight+e.getRowLength(w)*b+g,c=this.scrollTop-m*b;var C=0;return this.layerConfig.width!=o&&(C=this.CHANGE_H_SCROLL),(a||p)&&(C=this.$updateCachedSize(!0,this.gutterWidth,t.width,t.height),this._signal("scrollbarVisibilityChanged"),p&&(o=this.$getLongestLine())),this.layerConfig={width:o,padding:this.$padding,firstRow:y,firstRowScreen:m,lastRow:w,lineHeight:b,characterWidth:this.characterWidth,minHeight:h,maxHeight:r,offset:c,gutterOffset:Math.max(0,Math.ceil((c+t.height-t.scrollerHeight)/b)),height:this.$size.scrollerHeight},C},this.$updateLines=function(){var e=this.$changedLines.firstRow,t=this.$changedLines.lastRow;this.$changedLines=null;var i=this.layerConfig;if(!(e>i.lastRow+1||t<i.firstRow))return t===1/0?(this.$showGutter&&this.$gutterLayer.update(i),void this.$textLayer.update(i)):(this.$textLayer.updateLines(i,e,t),!0)},this.$getLongestLine=function(){var e=this.session.getScreenWidth();return this.showInvisibles&&!this.session.$useWrapMode&&(e+=1),Math.max(this.$size.scrollerWidth-2*this.$padding,Math.round(e*this.characterWidth))},this.updateFrontMarkers=function(){this.$markerFront.setMarkers(this.session.getMarkers(!0)),this.$loop.schedule(this.CHANGE_MARKER_FRONT)},this.updateBackMarkers=function(){this.$markerBack.setMarkers(this.session.getMarkers()),this.$loop.schedule(this.CHANGE_MARKER_BACK)},this.addGutterDecoration=function(e,t){this.$gutterLayer.addGutterDecoration(e,t)},this.removeGutterDecoration=function(e,t){this.$gutterLayer.removeGutterDecoration(e,t)},this.updateBreakpoints=function(e){this.$loop.schedule(this.CHANGE_GUTTER)},this.setAnnotations=function(e){this.$gutterLayer.setAnnotations(e),this.$loop.schedule(this.CHANGE_GUTTER)},this.updateCursor=function(){this.$loop.schedule(this.CHANGE_CURSOR)},this.hideCursor=function(){this.$cursorLayer.hideCursor()},this.showCursor=function(){this.$cursorLayer.showCursor()},this.scrollSelectionIntoView=function(e,t,i){this.scrollCursorIntoView(e,i),this.scrollCursorIntoView(t,i)},this.scrollCursorIntoView=function(e,t,i){if(0!==this.$size.scrollerHeight){var n=this.$cursorLayer.getPixelPosition(e),r=n.left,o=n.top,s=i&&i.top||0,a=i&&i.bottom||0,l=this.$scrollAnimation?this.session.getScrollTop():this.scrollTop;l+s>o?(t&&l+s>o+this.lineHeight&&(o-=t*this.$size.scrollerHeight),0===o&&(o=-this.scrollMargin.top),this.session.setScrollTop(o)):l+this.$size.scrollerHeight-a<o+this.lineHeight&&(t&&l+this.$size.scrollerHeight-a<o-this.lineHeight&&(o+=t*this.$size.scrollerHeight),this.session.setScrollTop(o+this.lineHeight-this.$size.scrollerHeight));var c=this.scrollLeft;c>r?(r<this.$padding+2*this.layerConfig.characterWidth&&(r=-this.scrollMargin.left),this.session.setScrollLeft(r)):c+this.$size.scrollerWidth<r+this.characterWidth?this.session.setScrollLeft(Math.round(r+this.characterWidth-this.$size.scrollerWidth)):c<=this.$padding&&r-c<this.characterWidth&&this.session.setScrollLeft(0)}},this.getScrollTop=function(){return this.session.getScrollTop()},this.getScrollLeft=function(){return this.session.getScrollLeft()},this.getScrollTopRow=function(){return this.scrollTop/this.lineHeight},this.getScrollBottomRow=function(){return Math.max(0,Math.floor((this.scrollTop+this.$size.scrollerHeight)/this.lineHeight)-1)},this.scrollToRow=function(e){this.session.setScrollTop(e*this.lineHeight)},this.alignCursor=function(e,t){"number"==typeof e&&(e={row:e,column:0});var i=this.$cursorLayer.getPixelPosition(e),n=this.$size.scrollerHeight-this.lineHeight,r=i.top-n*(t||0);return this.session.setScrollTop(r),r},this.STEPS=8,this.$calcSteps=function(e,t){var i=0,n=this.STEPS,r=[],o=function(e,t,i){return i*(Math.pow(e-1,3)+1)+t};for(i=0;i<n;++i)r.push(o(i/this.STEPS,e,t-e));return r},this.scrollToLine=function(e,t,i,n){var r=this.$cursorLayer.getPixelPosition({row:e,column:0}),o=r.top;t&&(o-=this.$size.scrollerHeight/2);var s=this.scrollTop;this.session.setScrollTop(o),i!==!1&&this.animateScrolling(s,n)},this.animateScrolling=function(e,t){var i=this.scrollTop;if(this.$animatedScroll){var n=this;if(e!=i){if(this.$scrollAnimation){var r=this.$scrollAnimation.steps;if(r.length&&(e=r[0],e==i))return}var o=n.$calcSteps(e,i);this.$scrollAnimation={from:e,to:i,steps:o},clearInterval(this.$timer),n.session.setScrollTop(o.shift()),n.session.$scrollTop=i,this.$timer=setInterval(function(){o.length?(n.session.setScrollTop(o.shift()),n.session.$scrollTop=i):null!=i?(n.session.$scrollTop=-1,n.session.setScrollTop(i),i=null):(n.$timer=clearInterval(n.$timer),n.$scrollAnimation=null,t&&t())},10)}}},this.scrollToY=function(e){this.scrollTop!==e&&(this.$loop.schedule(this.CHANGE_SCROLL),this.scrollTop=e)},this.scrollToX=function(e){this.scrollLeft!==e&&(this.scrollLeft=e),this.$loop.schedule(this.CHANGE_H_SCROLL)},this.scrollTo=function(e,t){this.session.setScrollTop(t),this.session.setScrollLeft(t)},this.scrollBy=function(e,t){t&&this.session.setScrollTop(this.session.getScrollTop()+t),e&&this.session.setScrollLeft(this.session.getScrollLeft()+e)},this.isScrollableBy=function(e,t){return t<0&&this.session.getScrollTop()>=1-this.scrollMargin.top||(t>0&&this.session.getScrollTop()+this.$size.scrollerHeight-this.layerConfig.maxHeight<-1+this.scrollMargin.bottom||(e<0&&this.session.getScrollLeft()>=1-this.scrollMargin.left||(e>0&&this.session.getScrollLeft()+this.$size.scrollerWidth-this.layerConfig.width<-1+this.scrollMargin.right||void 0)))},this.pixelToScreenCoordinates=function(e,t){var i=this.scroller.getBoundingClientRect(),n=(e+this.scrollLeft-i.left-this.$padding)/this.characterWidth,r=Math.floor((t+this.scrollTop-i.top)/this.lineHeight),o=Math.round(n);return{row:r,column:o,side:n-o>0?1:-1}},this.screenToTextCoordinates=function(e,t){var i=this.scroller.getBoundingClientRect(),n=Math.round((e+this.scrollLeft-i.left-this.$padding)/this.characterWidth),r=(t+this.scrollTop-i.top)/this.lineHeight;return this.session.screenToDocumentPosition(r,Math.max(n,0))},this.textToScreenCoordinates=function(e,t){var i=this.scroller.getBoundingClientRect(),n=this.session.documentToScreenPosition(e,t),r=this.$padding+Math.round(n.column*this.characterWidth),o=n.row*this.lineHeight;return{pageX:i.left+r-this.scrollLeft,pageY:i.top+o-this.scrollTop}},this.visualizeFocus=function(){r.addCssClass(this.container,"ace_focus")},this.visualizeBlur=function(){r.removeCssClass(this.container,"ace_focus")},this.showComposition=function(e){this.$composition||(this.$composition={keepTextAreaAtCursor:this.$keepTextAreaAtCursor,cssText:this.textarea.style.cssText}),this.$keepTextAreaAtCursor=!0,r.addCssClass(this.textarea,"ace_composition"),this.textarea.style.cssText="",this.$moveTextAreaToCursor()},this.setCompositionText=function(e){this.$moveTextAreaToCursor()},this.hideComposition=function(){this.$composition&&(r.removeCssClass(this.textarea,"ace_composition"),this.$keepTextAreaAtCursor=this.$composition.keepTextAreaAtCursor,this.textarea.style.cssText=this.$composition.cssText,this.$composition=null)},this.setTheme=function(e,t){function i(i){if(n.$themeId!=e)return t&&t();if(i.cssClass){r.importCssString(i.cssText,i.cssClass,n.container.ownerDocument),n.theme&&r.removeCssClass(n.container,n.theme.cssClass);var o="padding"in i?i.padding:"padding"in(n.theme||{})?4:n.$padding;n.$padding&&o!=n.$padding&&n.setPadding(o),n.$theme=i.cssClass,n.theme=i,r.addCssClass(n.container,i.cssClass),r.setCssClass(n.container,"ace_dark",i.isDark),n.$size&&(n.$size.width=0,n.$updateSizeAsync()),n._dispatchEvent("themeLoaded",{theme:i}),t&&t()}}var n=this;if(this.$themeId=e,n._dispatchEvent("themeChange",{theme:e}),e&&"string"!=typeof e)i(e);else{var s=e||this.$options.theme.initialValue;o.loadModule(["theme",s],i)}},this.getTheme=function(){return this.$themeId},this.setStyle=function(e,t){r.setCssClass(this.container,e,t!==!1)},this.unsetStyle=function(e){r.removeCssClass(this.container,e)},this.setCursorStyle=function(e){this.scroller.style.cursor!=e&&(this.scroller.style.cursor=e)},this.setMouseCursor=function(e){this.scroller.style.cursor=e},this.destroy=function(){this.$textLayer.destroy(),this.$cursorLayer.destroy()}}).call(v.prototype),o.defineOptions(v.prototype,"renderer",{animatedScroll:{initialValue:!1},showInvisibles:{set:function(e){this.$textLayer.setShowInvisibles(e)&&this.$loop.schedule(this.CHANGE_TEXT)},initialValue:!1},showPrintMargin:{set:function(){this.$updatePrintMargin()},initialValue:!0},printMarginColumn:{set:function(){this.$updatePrintMargin()},initialValue:80},printMargin:{set:function(e){"number"==typeof e&&(this.$printMarginColumn=e),this.$showPrintMargin=!!e,this.$updatePrintMargin()},get:function(){return this.$showPrintMargin&&this.$printMarginColumn}},showGutter:{set:function(e){this.$gutter.style.display=e?"block":"none",this.$loop.schedule(this.CHANGE_FULL),this.onGutterResize()},initialValue:!0},fadeFoldWidgets:{set:function(e){r.setCssClass(this.$gutter,"ace_fade-fold-widgets",e)},initialValue:!1},showFoldWidgets:{set:function(e){this.$gutterLayer.setShowFoldWidgets(e)},initialValue:!0},showLineNumbers:{set:function(e){this.$gutterLayer.setShowLineNumbers(e),this.$loop.schedule(this.CHANGE_GUTTER)},initialValue:!0},displayIndentGuides:{set:function(e){this.$textLayer.setDisplayIndentGuides(e)&&this.$loop.schedule(this.CHANGE_TEXT)},initialValue:!0},highlightGutterLine:{set:function(e){return this.$gutterLineHighlight?(this.$gutterLineHighlight.style.display=e?"":"none",void(this.$cursorLayer.$pixelPos&&this.$updateGutterLineHighlight())):(this.$gutterLineHighlight=r.createElement("div"),this.$gutterLineHighlight.className="ace_gutter-active-line",void this.$gutter.appendChild(this.$gutterLineHighlight))},initialValue:!1,value:!0},hScrollBarAlwaysVisible:{set:function(e){this.$hScrollBarAlwaysVisible&&this.$horizScroll||this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:!1},vScrollBarAlwaysVisible:{set:function(e){this.$vScrollBarAlwaysVisible&&this.$vScroll||this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:!1},fontSize:{set:function(e){"number"==typeof e&&(e+="px"),this.container.style.fontSize=e,this.updateFontSize()},initialValue:12},fontFamily:{set:function(e){this.container.style.fontFamily=e,this.updateFontSize()}},maxLines:{set:function(e){this.updateFull()}},minLines:{set:function(e){this.updateFull()}},scrollPastEnd:{set:function(e){e=+e||0,this.$scrollPastEnd!=e&&(this.$scrollPastEnd=e,this.$loop.schedule(this.CHANGE_SCROLL))},initialValue:0,handlesSet:!0},fixedWidthGutter:{set:function(e){this.$gutterLayer.$fixedWidth=!!e,this.$loop.schedule(this.CHANGE_GUTTER)}},theme:{set:function(e){this.setTheme(e)},get:function(){return this.$themeId||this.theme},initialValue:"./theme/textmate",handlesSet:!0}}),t.VirtualRenderer=v}),ace.define("ace/worker/worker_client",["require","exports","module","ace/lib/oop","ace/lib/net","ace/lib/event_emitter","ace/config"],function(e,t,n){"use strict";var r=e("../lib/oop"),o=e("../lib/net"),s=e("../lib/event_emitter").EventEmitter,a=e("../config"),l=function(t,n,r,o){if(this.$sendDeltaQueue=this.$sendDeltaQueue.bind(this),this.changeListener=this.changeListener.bind(this),this.onMessage=this.onMessage.bind(this),e.nameToUrl&&!e.toUrl&&(e.toUrl=e.nameToUrl),a.get("packaged")||!e.toUrl)o=o||a.moduleUrl(n.id,"worker");else{var s=this.$normalizePath;o=o||s(e.toUrl("ace/worker/worker.js",null,"_"));var l={};t.forEach(function(t){l[t]=s(e.toUrl(t,null,"_").replace(/(\.js)?(\?.*)?$/,""))})}try{var c=n.src,h=i(70),d=new h([c],{type:"application/javascript"}),u=(window.URL||window.webkitURL).createObjectURL(d);this.$worker=new Worker(u)}catch(e){if(!(e instanceof window.DOMException))throw e;var d=this.$workerBlob(o),f=window.URL||window.webkitURL,p=f.createObjectURL(d);this.$worker=new Worker(p),f.revokeObjectURL(p)}this.$worker.postMessage({init:!0,tlns:l,module:n.id,classname:r}),this.callbackId=1,this.callbacks={},this.$worker.onmessage=this.onMessage};(function(){r.implement(this,s),this.onMessage=function(e){var t=e.data;switch(t.type){case"event":this._signal(t.name,{data:t.data});break;case"call":var i=this.callbacks[t.id];i&&(i(t.data),delete this.callbacks[t.id]);break;case"error":this.reportError(t.data);break;case"log":window.console&&console.log&&console.log.apply(console,t.data)}},this.reportError=function(e){window.console&&console.error&&console.error(e)},this.$normalizePath=function(e){return o.qualifyURL(e)},this.terminate=function(){this._signal("terminate",{}),this.deltaQueue=null,this.$worker.terminate(),this.$worker=null,this.$doc&&this.$doc.off("change",this.changeListener),this.$doc=null},this.send=function(e,t){this.$worker.postMessage({command:e,args:t})},this.call=function(e,t,i){if(i){var n=this.callbackId++;this.callbacks[n]=i,t.push(n)}this.send(e,t)},this.emit=function(e,t){try{this.$worker.postMessage({event:e,data:{data:t.data}})}catch(e){console.error(e.stack)}},this.attachToDocument=function(e){this.$doc&&this.terminate(),this.$doc=e,this.call("setValue",[e.getValue()]),e.on("change",this.changeListener)},this.changeListener=function(e){this.deltaQueue||(this.deltaQueue=[],setTimeout(this.$sendDeltaQueue,0)),"insert"==e.action?this.deltaQueue.push(e.start,e.lines):this.deltaQueue.push(e.start,e.end)},this.$sendDeltaQueue=function(){var e=this.deltaQueue;e&&(this.deltaQueue=null,e.length>50&&e.length>this.$doc.getLength()>>1?this.call("setValue",[this.$doc.getValue()]):this.emit("change",{data:e}))},this.$workerBlob=function(e){var t="importScripts('"+o.qualifyURL(e)+"');";try{return new Blob([t],{type:"application/javascript"})}catch(e){var i=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder,n=new i;return n.append(t),n.getBlob("application/javascript")}}}).call(l.prototype);var c=function(e,t,i){this.$sendDeltaQueue=this.$sendDeltaQueue.bind(this),this.changeListener=this.changeListener.bind(this),this.callbackId=1,this.callbacks={},this.messageBuffer=[];var n=null,r=!1,o=Object.create(s),l=this;this.$worker={},this.$worker.terminate=function(){},this.$worker.postMessage=function(e){l.messageBuffer.push(e),n&&(r?setTimeout(c):c())},this.setEmitSync=function(e){r=e};var c=function(){var e=l.messageBuffer.shift();e.command?n[e.command].apply(n,e.args):e.event&&o._signal(e.event,e.data)};o.postMessage=function(e){l.onMessage({data:e})},o.callback=function(e,t){this.postMessage({type:"call",id:t,data:e})},o.emit=function(e,t){this.postMessage({type:"event",name:e,data:t})},a.loadModule(["worker",t],function(e){for(n=new e[i](o);l.messageBuffer.length;)c()})};c.prototype=l.prototype,t.UIWorkerClient=c,t.WorkerClient=l}),ace.define("ace/placeholder",["require","exports","module","ace/range","ace/lib/event_emitter","ace/lib/oop"],function(e,t,i){"use strict";var n=e("./range").Range,r=e("./lib/event_emitter").EventEmitter,o=e("./lib/oop"),s=function(e,t,i,n,r,o){var s=this;this.length=t,this.session=e,this.doc=e.getDocument(),this.mainClass=r,this.othersClass=o,this.$onUpdate=this.onUpdate.bind(this),this.doc.on("change",this.$onUpdate),this.$others=n,this.$onCursorChange=function(){setTimeout(function(){s.onCursorChange()})},this.$pos=i;var a=e.getUndoManager().$undoStack||e.getUndoManager().$undostack||{length:-1};this.$undoStackDepth=a.length,this.setup(),e.selection.on("changeCursor",this.$onCursorChange)};(function(){o.implement(this,r),this.setup=function(){var e=this,t=this.doc,i=this.session;this.selectionBefore=i.selection.toJSON(),i.selection.inMultiSelectMode&&i.selection.toSingleRange(),this.pos=t.createAnchor(this.$pos.row,this.$pos.column);var r=this.pos;r.$insertRight=!0,r.detach(),r.markerId=i.addMarker(new n(r.row,r.column,r.row,r.column+this.length),this.mainClass,null,!1),this.others=[],this.$others.forEach(function(i){var n=t.createAnchor(i.row,i.column);n.$insertRight=!0,n.detach(),e.others.push(n)}),i.setUndoSelect(!1)},this.showOtherMarkers=function(){if(!this.othersActive){var e=this.session,t=this;this.othersActive=!0,this.others.forEach(function(i){i.markerId=e.addMarker(new n(i.row,i.column,i.row,i.column+t.length),t.othersClass,null,!1)})}},this.hideOtherMarkers=function(){if(this.othersActive){this.othersActive=!1;for(var e=0;e<this.others.length;e++)this.session.removeMarker(this.others[e].markerId)}},this.onUpdate=function(e){
	if(this.$updating)return this.updateAnchors(e);var t=e;if(t.start.row===t.end.row&&t.start.row===this.pos.row){this.$updating=!0;var i="insert"===e.action?t.end.column-t.start.column:t.start.column-t.end.column,r=t.start.column>=this.pos.column&&t.start.column<=this.pos.column+this.length+1,o=t.start.column-this.pos.column;if(this.updateAnchors(e),r&&(this.length+=i),r&&!this.session.$fromUndo)if("insert"===e.action)for(var s=this.others.length-1;s>=0;s--){var a=this.others[s],l={row:a.row,column:a.column+o};this.doc.insertMergedLines(l,e.lines)}else if("remove"===e.action)for(var s=this.others.length-1;s>=0;s--){var a=this.others[s],l={row:a.row,column:a.column+o};this.doc.remove(new n(l.row,l.column,l.row,l.column-i))}this.$updating=!1,this.updateMarkers()}},this.updateAnchors=function(e){this.pos.onChange(e);for(var t=this.others.length;t--;)this.others[t].onChange(e);this.updateMarkers()},this.updateMarkers=function(){if(!this.$updating){var e=this,t=this.session,i=function(i,r){t.removeMarker(i.markerId),i.markerId=t.addMarker(new n(i.row,i.column,i.row,i.column+e.length),r,null,!1)};i(this.pos,this.mainClass);for(var r=this.others.length;r--;)i(this.others[r],this.othersClass)}},this.onCursorChange=function(e){if(!this.$updating&&this.session){var t=this.session.selection.getCursor();t.row===this.pos.row&&t.column>=this.pos.column&&t.column<=this.pos.column+this.length?(this.showOtherMarkers(),this._emit("cursorEnter",e)):(this.hideOtherMarkers(),this._emit("cursorLeave",e))}},this.detach=function(){this.session.removeMarker(this.pos&&this.pos.markerId),this.hideOtherMarkers(),this.doc.removeEventListener("change",this.$onUpdate),this.session.selection.removeEventListener("changeCursor",this.$onCursorChange),this.session.setUndoSelect(!0),this.session=null},this.cancel=function(){if(this.$undoStackDepth!==-1){for(var e=this.session.getUndoManager(),t=(e.$undoStack||e.$undostack).length-this.$undoStackDepth,i=0;i<t;i++)e.undo(!0);this.selectionBefore&&this.session.selection.fromJSON(this.selectionBefore)}}}).call(s.prototype),t.PlaceHolder=s}),ace.define("ace/mouse/multi_select_handler",["require","exports","module","ace/lib/event","ace/lib/useragent"],function(e,t,i){function n(e,t){return e.row==t.row&&e.column==t.column}function r(e){var t=e.domEvent,i=t.altKey,r=t.shiftKey,a=t.ctrlKey,l=e.getAccelKey(),c=e.getButton();if(a&&s.isMac&&(c=t.button),e.editor.inMultiSelectMode&&2==c)return void e.editor.textInput.onContextMenu(e.domEvent);if(!a&&!i&&!l)return void(0===c&&e.editor.inMultiSelectMode&&e.editor.exitMultiSelectMode());if(0===c){var h,d=e.editor,u=d.selection,f=d.inMultiSelectMode,p=e.getDocumentPosition(),m=u.getCursor(),g=e.inSelection()||u.isEmpty()&&n(p,m),v=e.x,y=e.y,w=function(e){v=e.clientX,y=e.clientY},b=d.session,A=d.renderer.pixelToScreenCoordinates(v,y),C=A;if(d.$mouseHandler.$enableJumpToDef)a&&i||l&&i?h=r?"block":"add":i&&d.$blockSelectEnabled&&(h="block");else if(l&&!i){if(h="add",!f&&r)return}else i&&d.$blockSelectEnabled&&(h="block");if(h&&s.isMac&&t.ctrlKey&&d.$mouseHandler.cancelContextMenu(),"add"==h){if(!f&&g)return;if(!f){var E=u.toOrientedRange();d.addSelectionMarker(E)}var x=u.rangeList.rangeAtPoint(p);d.$blockScrolling++,d.inVirtualSelectionMode=!0,r&&(x=null,E=u.ranges[0]||E,d.removeSelectionMarker(E)),d.once("mouseup",function(){var e=u.toOrientedRange();x&&e.isEmpty()&&n(x.cursor,e.cursor)?u.substractPoint(e.cursor):(r?u.substractPoint(E.cursor):E&&(d.removeSelectionMarker(E),u.addRange(E)),u.addRange(e)),d.$blockScrolling--,d.inVirtualSelectionMode=!1})}else if("block"==h){e.stop(),d.inVirtualSelectionMode=!0;var F,k=[],S=function(){var e=d.renderer.pixelToScreenCoordinates(v,y),t=b.screenToDocumentPosition(e.row,e.column);n(C,e)&&n(t,u.lead)||(C=e,d.$blockScrolling++,d.selection.moveToPosition(t),d.renderer.scrollCursorIntoView(),d.removeSelectionMarkers(k),k=u.rectangularRangeBlock(C,A),d.$mouseHandler.$clickSelection&&1==k.length&&k[0].isEmpty()&&(k[0]=d.$mouseHandler.$clickSelection.clone()),k.forEach(d.addSelectionMarker,d),d.updateSelectionMarkers(),d.$blockScrolling--)};d.$blockScrolling++,f&&!l?u.toSingleRange():!f&&l&&(F=u.toOrientedRange(),d.addSelectionMarker(F)),r?A=b.documentToScreenPosition(u.lead):u.moveToPosition(p),d.$blockScrolling--,C={row:-1,column:-1};var $=function(e){clearInterval(B),d.removeSelectionMarkers(k),k.length||(k=[u.toOrientedRange()]),d.$blockScrolling++,F&&(d.removeSelectionMarker(F),u.toSingleRange(F));for(var t=0;t<k.length;t++)u.addRange(k[t]);d.inVirtualSelectionMode=!1,d.$mouseHandler.$clickSelection=null,d.$blockScrolling--},D=S;o.capture(d.container,w,$);var B=setInterval(function(){D()},20);return e.preventDefault()}}}var o=e("../lib/event"),s=e("../lib/useragent");t.onMouseDown=r}),ace.define("ace/commands/multi_select_commands",["require","exports","module","ace/keyboard/hash_handler"],function(e,t,i){t.defaultCommands=[{name:"addCursorAbove",exec:function(e){e.selectMoreLines(-1)},bindKey:{win:"Ctrl-Alt-Up",mac:"Ctrl-Alt-Up"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorBelow",exec:function(e){e.selectMoreLines(1)},bindKey:{win:"Ctrl-Alt-Down",mac:"Ctrl-Alt-Down"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorAboveSkipCurrent",exec:function(e){e.selectMoreLines(-1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Up",mac:"Ctrl-Alt-Shift-Up"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorBelowSkipCurrent",exec:function(e){e.selectMoreLines(1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Down",mac:"Ctrl-Alt-Shift-Down"},scrollIntoView:"cursor",readOnly:!0},{name:"selectMoreBefore",exec:function(e){e.selectMore(-1)},bindKey:{win:"Ctrl-Alt-Left",mac:"Ctrl-Alt-Left"},scrollIntoView:"cursor",readOnly:!0},{name:"selectMoreAfter",exec:function(e){e.selectMore(1)},bindKey:{win:"Ctrl-Alt-Right",mac:"Ctrl-Alt-Right"},scrollIntoView:"cursor",readOnly:!0},{name:"selectNextBefore",exec:function(e){e.selectMore(-1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Left",mac:"Ctrl-Alt-Shift-Left"},scrollIntoView:"cursor",readOnly:!0},{name:"selectNextAfter",exec:function(e){e.selectMore(1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Right",mac:"Ctrl-Alt-Shift-Right"},scrollIntoView:"cursor",readOnly:!0},{name:"splitIntoLines",exec:function(e){e.multiSelect.splitIntoLines()},bindKey:{win:"Ctrl-Alt-L",mac:"Ctrl-Alt-L"},readOnly:!0},{name:"alignCursors",exec:function(e){e.alignCursors()},bindKey:{win:"Ctrl-Alt-A",mac:"Ctrl-Alt-A"},scrollIntoView:"cursor"},{name:"findAll",exec:function(e){e.findAll()},bindKey:{win:"Ctrl-Alt-K",mac:"Ctrl-Alt-G"},scrollIntoView:"cursor",readOnly:!0}],t.multiSelectCommands=[{name:"singleSelection",bindKey:"esc",exec:function(e){e.exitMultiSelectMode()},scrollIntoView:"cursor",readOnly:!0,isAvailable:function(e){return e&&e.inMultiSelectMode}}];var n=e("../keyboard/hash_handler").HashHandler;t.keyboardHandler=new n(t.multiSelectCommands)}),ace.define("ace/multi_select",["require","exports","module","ace/range_list","ace/range","ace/selection","ace/mouse/multi_select_handler","ace/lib/event","ace/lib/lang","ace/commands/multi_select_commands","ace/search","ace/edit_session","ace/editor","ace/config"],function(e,t,i){function n(e,t,i){return m.$options.wrap=!0,m.$options.needle=t,m.$options.backwards=i==-1,m.find(e)}function r(e,t){return e.row==t.row&&e.column==t.column}function o(e){e.$multiselectOnSessionChange||(e.$onAddRange=e.$onAddRange.bind(e),e.$onRemoveRange=e.$onRemoveRange.bind(e),e.$onMultiSelect=e.$onMultiSelect.bind(e),e.$onSingleSelect=e.$onSingleSelect.bind(e),e.$multiselectOnSessionChange=t.onSessionChange.bind(e),e.$checkMultiselectChange=e.$checkMultiselectChange.bind(e),e.$multiselectOnSessionChange(e),e.on("changeSession",e.$multiselectOnSessionChange),e.on("mousedown",h),e.commands.addCommands(f.defaultCommands),s(e))}function s(e){function t(t){n&&(e.renderer.setMouseCursor(""),n=!1)}var i=e.textInput.getElement(),n=!1;d.addListener(i,"keydown",function(i){var r=18==i.keyCode&&!(i.ctrlKey||i.shiftKey||i.metaKey);e.$blockSelectEnabled&&r?n||(e.renderer.setMouseCursor("crosshair"),n=!0):n&&t()}),d.addListener(i,"keyup",t),d.addListener(i,"blur",t)}var a=e("./range_list").RangeList,l=e("./range").Range,c=e("./selection").Selection,h=e("./mouse/multi_select_handler").onMouseDown,d=e("./lib/event"),u=e("./lib/lang"),f=e("./commands/multi_select_commands");t.commands=f.defaultCommands.concat(f.multiSelectCommands);var p=e("./search").Search,m=new p,g=e("./edit_session").EditSession;(function(){this.getSelectionMarkers=function(){return this.$selectionMarkers}}).call(g.prototype),function(){this.ranges=null,this.rangeList=null,this.addRange=function(e,t){if(e){if(!this.inMultiSelectMode&&0===this.rangeCount){var i=this.toOrientedRange();if(this.rangeList.add(i),this.rangeList.add(e),2!=this.rangeList.ranges.length)return this.rangeList.removeAll(),t||this.fromOrientedRange(e);this.rangeList.removeAll(),this.rangeList.add(i),this.$onAddRange(i)}e.cursor||(e.cursor=e.end);var n=this.rangeList.add(e);return this.$onAddRange(e),n.length&&this.$onRemoveRange(n),this.rangeCount>1&&!this.inMultiSelectMode&&(this._signal("multiSelect"),this.inMultiSelectMode=!0,this.session.$undoSelect=!1,this.rangeList.attach(this.session)),t||this.fromOrientedRange(e)}},this.toSingleRange=function(e){e=e||this.ranges[0];var t=this.rangeList.removeAll();t.length&&this.$onRemoveRange(t),e&&this.fromOrientedRange(e)},this.substractPoint=function(e){var t=this.rangeList.substractPoint(e);if(t)return this.$onRemoveRange(t),t[0]},this.mergeOverlappingRanges=function(){var e=this.rangeList.merge();e.length?this.$onRemoveRange(e):this.ranges[0]&&this.fromOrientedRange(this.ranges[0])},this.$onAddRange=function(e){this.rangeCount=this.rangeList.ranges.length,this.ranges.unshift(e),this._signal("addRange",{range:e})},this.$onRemoveRange=function(e){if(this.rangeCount=this.rangeList.ranges.length,1==this.rangeCount&&this.inMultiSelectMode){var t=this.rangeList.ranges.pop();e.push(t),this.rangeCount=0}for(var i=e.length;i--;){var n=this.ranges.indexOf(e[i]);this.ranges.splice(n,1)}this._signal("removeRange",{ranges:e}),0===this.rangeCount&&this.inMultiSelectMode&&(this.inMultiSelectMode=!1,this._signal("singleSelect"),this.session.$undoSelect=!0,this.rangeList.detach(this.session)),t=t||this.ranges[0],t&&!t.isEqual(this.getRange())&&this.fromOrientedRange(t)},this.$initRangeList=function(){this.rangeList||(this.rangeList=new a,this.ranges=[],this.rangeCount=0)},this.getAllRanges=function(){return this.rangeCount?this.rangeList.ranges.concat():[this.getRange()]},this.splitIntoLines=function(){if(this.rangeCount>1){var e=this.rangeList.ranges,t=e[e.length-1],i=l.fromPoints(e[0].start,t.end);this.toSingleRange(),this.setSelectionRange(i,t.cursor==t.start)}else{var i=this.getRange(),n=this.isBackwards(),r=i.start.row,o=i.end.row;if(r==o){if(n)var s=i.end,a=i.start;else var s=i.start,a=i.end;return this.addRange(l.fromPoints(a,a)),void this.addRange(l.fromPoints(s,s))}var c=[],h=this.getLineRange(r,!0);h.start.column=i.start.column,c.push(h);for(var d=r+1;d<o;d++)c.push(this.getLineRange(d,!0));h=this.getLineRange(o,!0),h.end.column=i.end.column,c.push(h),c.forEach(this.addRange,this)}},this.toggleBlockSelection=function(){if(this.rangeCount>1){var e=this.rangeList.ranges,t=e[e.length-1],i=l.fromPoints(e[0].start,t.end);this.toSingleRange(),this.setSelectionRange(i,t.cursor==t.start)}else{var n=this.session.documentToScreenPosition(this.selectionLead),r=this.session.documentToScreenPosition(this.selectionAnchor),o=this.rectangularRangeBlock(n,r);o.forEach(this.addRange,this)}},this.rectangularRangeBlock=function(e,t,i){var n=[],o=e.column<t.column;if(o)var s=e.column,a=t.column;else var s=t.column,a=e.column;var c=e.row<t.row;if(c)var h=e.row,d=t.row;else var h=t.row,d=e.row;s<0&&(s=0),h<0&&(h=0),h==d&&(i=!0);for(var u=h;u<=d;u++){var f=l.fromPoints(this.session.screenToDocumentPosition(u,s),this.session.screenToDocumentPosition(u,a));if(f.isEmpty()){if(p&&r(f.end,p))break;var p=f.end}f.cursor=o?f.start:f.end,n.push(f)}if(c&&n.reverse(),!i){for(var m=n.length-1;n[m].isEmpty()&&m>0;)m--;if(m>0)for(var g=0;n[g].isEmpty();)g++;for(var v=m;v>=g;v--)n[v].isEmpty()&&n.splice(v,1)}return n}}.call(c.prototype);var v=e("./editor").Editor;(function(){this.updateSelectionMarkers=function(){this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.addSelectionMarker=function(e){e.cursor||(e.cursor=e.end);var t=this.getSelectionStyle();return e.marker=this.session.addMarker(e,"ace_selection",t),this.session.$selectionMarkers.push(e),this.session.selectionMarkerCount=this.session.$selectionMarkers.length,e},this.removeSelectionMarker=function(e){if(e.marker){this.session.removeMarker(e.marker);var t=this.session.$selectionMarkers.indexOf(e);t!=-1&&this.session.$selectionMarkers.splice(t,1),this.session.selectionMarkerCount=this.session.$selectionMarkers.length}},this.removeSelectionMarkers=function(e){for(var t=this.session.$selectionMarkers,i=e.length;i--;){var n=e[i];if(n.marker){this.session.removeMarker(n.marker);var r=t.indexOf(n);r!=-1&&t.splice(r,1)}}this.session.selectionMarkerCount=t.length},this.$onAddRange=function(e){this.addSelectionMarker(e.range),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onRemoveRange=function(e){this.removeSelectionMarkers(e.ranges),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onMultiSelect=function(e){this.inMultiSelectMode||(this.inMultiSelectMode=!0,this.setStyle("ace_multiselect"),this.keyBinding.addKeyboardHandler(f.keyboardHandler),this.commands.setDefaultHandler("exec",this.$onMultiSelectExec),this.renderer.updateCursor(),this.renderer.updateBackMarkers())},this.$onSingleSelect=function(e){this.session.multiSelect.inVirtualMode||(this.inMultiSelectMode=!1,this.unsetStyle("ace_multiselect"),this.keyBinding.removeKeyboardHandler(f.keyboardHandler),this.commands.removeDefaultHandler("exec",this.$onMultiSelectExec),this.renderer.updateCursor(),this.renderer.updateBackMarkers(),this._emit("changeSelection"))},this.$onMultiSelectExec=function(e){var t=e.command,i=e.editor;if(i.multiSelect){if(t.multiSelectAction)"forEach"==t.multiSelectAction?n=i.forEachSelection(t,e.args):"forEachLine"==t.multiSelectAction?n=i.forEachSelection(t,e.args,!0):"single"==t.multiSelectAction?(i.exitMultiSelectMode(),n=t.exec(i,e.args||{})):n=t.multiSelectAction(i,e.args||{});else{var n=t.exec(i,e.args||{});i.multiSelect.addRange(i.multiSelect.toOrientedRange()),i.multiSelect.mergeOverlappingRanges()}return n}},this.forEachSelection=function(e,t,i){if(!this.inVirtualSelectionMode){var n,r=i&&i.keepOrder,o=1==i||i&&i.$byLines,s=this.session,a=this.selection,l=a.rangeList,h=(r?a:l).ranges;if(!h.length)return e.exec?e.exec(this,t||{}):e(this,t||{});var d=a._eventRegistry;a._eventRegistry={};var u=new c(s);this.inVirtualSelectionMode=!0;for(var f=h.length;f--;){if(o)for(;f>0&&h[f].start.row==h[f-1].end.row;)f--;u.fromOrientedRange(h[f]),u.index=f,this.selection=s.selection=u;var p=e.exec?e.exec(this,t||{}):e(this,t||{});n||void 0===p||(n=p),u.toOrientedRange(h[f])}u.detach(),this.selection=s.selection=a,this.inVirtualSelectionMode=!1,a._eventRegistry=d,a.mergeOverlappingRanges();var m=this.renderer.$scrollAnimation;return this.onCursorChange(),this.onSelectionChange(),m&&m.from==m.to&&this.renderer.animateScrolling(m.from),n}},this.exitMultiSelectMode=function(){this.inMultiSelectMode&&!this.inVirtualSelectionMode&&this.multiSelect.toSingleRange()},this.getSelectedText=function(){var e="";if(this.inMultiSelectMode&&!this.inVirtualSelectionMode){for(var t=this.multiSelect.rangeList.ranges,i=[],n=0;n<t.length;n++)i.push(this.session.getTextRange(t[n]));var r=this.session.getDocument().getNewLineCharacter();e=i.join(r),e.length==(i.length-1)*r.length&&(e="")}else this.selection.isEmpty()||(e=this.session.getTextRange(this.getSelectionRange()));return e},this.$checkMultiselectChange=function(e,t){if(this.inMultiSelectMode&&!this.inVirtualSelectionMode){var i=this.multiSelect.ranges[0];if(this.multiSelect.isEmpty()&&t==this.multiSelect.anchor)return;var n=t==this.multiSelect.anchor?i.cursor==i.start?i.end:i.start:i.cursor;n.row==t.row&&this.session.$clipPositionToDocument(n.row,n.column).column==t.column||this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange())}},this.findAll=function(e,t,i){if(t=t||{},t.needle=e||t.needle,void 0==t.needle){var n=this.selection.isEmpty()?this.selection.getWordRange():this.selection.getRange();t.needle=this.session.getTextRange(n)}this.$search.set(t);var r=this.$search.findAll(this.session);if(!r.length)return 0;this.$blockScrolling+=1;var o=this.multiSelect;i||o.toSingleRange(r[0]);for(var s=r.length;s--;)o.addRange(r[s],!0);return n&&o.rangeList.rangeAtPoint(n.start)&&o.addRange(n,!0),this.$blockScrolling-=1,r.length},this.selectMoreLines=function(e,t){var i=this.selection.toOrientedRange(),n=i.cursor==i.end,r=this.session.documentToScreenPosition(i.cursor);this.selection.$desiredColumn&&(r.column=this.selection.$desiredColumn);var o=this.session.screenToDocumentPosition(r.row+e,r.column);if(i.isEmpty())var s=o;else var a=this.session.documentToScreenPosition(n?i.end:i.start),s=this.session.screenToDocumentPosition(a.row+e,a.column);if(n){var c=l.fromPoints(o,s);c.cursor=c.start}else{var c=l.fromPoints(s,o);c.cursor=c.end}if(c.desiredColumn=r.column,this.selection.inMultiSelectMode){if(t)var h=i.cursor}else this.selection.addRange(i);this.selection.addRange(c),h&&this.selection.substractPoint(h)},this.transposeSelections=function(e){for(var t=this.session,i=t.multiSelect,n=i.ranges,r=n.length;r--;){var o=n[r];if(o.isEmpty()){var s=t.getWordRange(o.start.row,o.start.column);o.start.row=s.start.row,o.start.column=s.start.column,o.end.row=s.end.row,o.end.column=s.end.column}}i.mergeOverlappingRanges();for(var a=[],r=n.length;r--;){var o=n[r];a.unshift(t.getTextRange(o))}e<0?a.unshift(a.pop()):a.push(a.shift());for(var r=n.length;r--;){var o=n[r],s=o.clone();t.replace(o,a[r]),o.start.row=s.start.row,o.start.column=s.start.column}},this.selectMore=function(e,t,i){var r=this.session,o=r.multiSelect,s=o.toOrientedRange();if(!s.isEmpty()||(s=r.getWordRange(s.start.row,s.start.column),s.cursor=e==-1?s.start:s.end,this.multiSelect.addRange(s),!i)){var a=r.getTextRange(s),l=n(r,a,e);l&&(l.cursor=e==-1?l.start:l.end,this.$blockScrolling+=1,this.session.unfold(l),this.multiSelect.addRange(l),this.$blockScrolling-=1,this.renderer.scrollCursorIntoView(null,.5)),t&&this.multiSelect.substractPoint(s.cursor)}},this.alignCursors=function(){var e=this.session,t=e.multiSelect,i=t.ranges,n=-1,r=i.filter(function(e){return e.cursor.row==n||void(n=e.cursor.row)});if(i.length&&r.length!=i.length-1){r.forEach(function(e){t.substractPoint(e.cursor)});var o=0,s=1/0,a=i.map(function(t){var i=t.cursor,n=e.getLine(i.row),r=n.substr(i.column).search(/\S/g);return r==-1&&(r=0),i.column>o&&(o=i.column),r<s&&(s=r),r});i.forEach(function(t,i){var n=t.cursor,r=o-n.column,c=a[i]-s;r>c?e.insert(n,u.stringRepeat(" ",r-c)):e.remove(new l(n.row,n.column,n.row,n.column-r+c)),t.start.column=t.end.column=o,t.start.row=t.end.row=n.row,t.cursor=t.end}),t.fromOrientedRange(i[0]),this.renderer.updateCursor(),this.renderer.updateBackMarkers()}else{var c=this.selection.getRange(),h=c.start.row,d=c.end.row,f=h==d;if(f){var p,m=this.session.getLength();do p=this.session.getLine(d);while(/[=:]/.test(p)&&++d<m);do p=this.session.getLine(h);while(/[=:]/.test(p)&&--h>0);h<0&&(h=0),d>=m&&(d=m-1)}var g=this.session.removeFullLines(h,d);g=this.$reAlignText(g,f),this.session.insert({row:h,column:0},g.join("\n")+"\n"),f||(c.start.column=0,c.end.column=g[g.length-1].length),this.selection.setRange(c)}},this.$reAlignText=function(e,t){function i(e){return u.stringRepeat(" ",e)}function n(e){return e[2]?i(s)+e[2]+i(a-e[2].length+l)+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}function r(e){return e[2]?i(s+a-e[2].length)+e[2]+i(l," ")+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}function o(e){return e[2]?i(s)+e[2]+i(l)+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}var s,a,l,c=!0,h=!0;return e.map(function(e){var t=e.match(/(\s*)(.*?)(\s*)([=:].*)/);return t?null==s?(s=t[1].length,a=t[2].length,l=t[3].length,t):(s+a+l!=t[1].length+t[2].length+t[3].length&&(h=!1),s!=t[1].length&&(c=!1),s>t[1].length&&(s=t[1].length),a<t[2].length&&(a=t[2].length),l>t[3].length&&(l=t[3].length),t):[e]}).map(t?n:c?h?r:n:o)}}).call(v.prototype),t.onSessionChange=function(e){var t=e.session;t&&!t.multiSelect&&(t.$selectionMarkers=[],t.selection.$initRangeList(),t.multiSelect=t.selection),this.multiSelect=t&&t.multiSelect;var i=e.oldSession;i&&(i.multiSelect.off("addRange",this.$onAddRange),i.multiSelect.off("removeRange",this.$onRemoveRange),i.multiSelect.off("multiSelect",this.$onMultiSelect),i.multiSelect.off("singleSelect",this.$onSingleSelect),i.multiSelect.lead.off("change",this.$checkMultiselectChange),i.multiSelect.anchor.off("change",this.$checkMultiselectChange)),t&&(t.multiSelect.on("addRange",this.$onAddRange),t.multiSelect.on("removeRange",this.$onRemoveRange),t.multiSelect.on("multiSelect",this.$onMultiSelect),t.multiSelect.on("singleSelect",this.$onSingleSelect),t.multiSelect.lead.on("change",this.$checkMultiselectChange),t.multiSelect.anchor.on("change",this.$checkMultiselectChange)),t&&this.inMultiSelectMode!=t.selection.inMultiSelectMode&&(t.selection.inMultiSelectMode?this.$onMultiSelect():this.$onSingleSelect())},t.MultiSelect=o,e("./config").defineOptions(v.prototype,"editor",{enableMultiselect:{set:function(e){o(this),e?(this.on("changeSession",this.$multiselectOnSessionChange),this.on("mousedown",h)):(this.off("changeSession",this.$multiselectOnSessionChange),this.off("mousedown",h))},value:!0},enableBlockSelect:{set:function(e){this.$blockSelectEnabled=e},value:!0}})}),ace.define("ace/mode/folding/fold_mode",["require","exports","module","ace/range"],function(e,t,i){"use strict";var n=e("../../range").Range,r=t.FoldMode=function(){};(function(){this.foldingStartMarker=null,this.foldingStopMarker=null,this.getFoldWidget=function(e,t,i){var n=e.getLine(i);return this.foldingStartMarker.test(n)?"start":"markbeginend"==t&&this.foldingStopMarker&&this.foldingStopMarker.test(n)?"end":""},this.getFoldWidgetRange=function(e,t,i){return null},this.indentationBlock=function(e,t,i){var r=/\S/,o=e.getLine(t),s=o.search(r);if(s!=-1){for(var a=i||o.length,l=e.getLength(),c=t,h=t;++t<l;){var d=e.getLine(t).search(r);if(d!=-1){if(d<=s)break;h=t}}if(h>c){var u=e.getLine(h).length;return new n(c,a,h,u)}}},this.openingBracketBlock=function(e,t,i,r,o){var s={row:i,column:r+1},a=e.$findClosingBracket(t,s,o);if(a){var l=e.foldWidgets[a.row];return null==l&&(l=e.getFoldWidget(a.row)),"start"==l&&a.row>s.row&&(a.row--,a.column=e.getLine(a.row).length),n.fromPoints(s,a)}},this.closingBracketBlock=function(e,t,i,r,o){var s={row:i,column:r},a=e.$findOpeningBracket(t,s);if(a)return a.column++,s.column--,n.fromPoints(a,s)}}).call(r.prototype)}),ace.define("ace/theme/textmate",["require","exports","module","ace/lib/dom"],function(e,t,i){"use strict";t.isDark=!1,t.cssClass="ace-tm",t.cssText='.ace-tm .ace_gutter {\tbackground: #f0f0f0;\tcolor: #333;\t}\t.ace-tm .ace_print-margin {\twidth: 1px;\tbackground: #e8e8e8;\t}\t.ace-tm .ace_fold {\tbackground-color: #6B72E6;\t}\t.ace-tm {\tbackground-color: #FFFFFF;\tcolor: black;\t}\t.ace-tm .ace_cursor {\tcolor: black;\t}\t.ace-tm .ace_invisible {\tcolor: rgb(191, 191, 191);\t}\t.ace-tm .ace_storage,\t.ace-tm .ace_keyword {\tcolor: blue;\t}\t.ace-tm .ace_constant {\tcolor: rgb(197, 6, 11);\t}\t.ace-tm .ace_constant.ace_buildin {\tcolor: rgb(88, 72, 246);\t}\t.ace-tm .ace_constant.ace_language {\tcolor: rgb(88, 92, 246);\t}\t.ace-tm .ace_constant.ace_library {\tcolor: rgb(6, 150, 14);\t}\t.ace-tm .ace_invalid {\tbackground-color: rgba(255, 0, 0, 0.1);\tcolor: red;\t}\t.ace-tm .ace_support.ace_function {\tcolor: rgb(60, 76, 114);\t}\t.ace-tm .ace_support.ace_constant {\tcolor: rgb(6, 150, 14);\t}\t.ace-tm .ace_support.ace_type,\t.ace-tm .ace_support.ace_class {\tcolor: rgb(109, 121, 222);\t}\t.ace-tm .ace_keyword.ace_operator {\tcolor: rgb(104, 118, 135);\t}\t.ace-tm .ace_string {\tcolor: rgb(3, 106, 7);\t}\t.ace-tm .ace_comment {\tcolor: rgb(76, 136, 107);\t}\t.ace-tm .ace_comment.ace_doc {\tcolor: rgb(0, 102, 255);\t}\t.ace-tm .ace_comment.ace_doc.ace_tag {\tcolor: rgb(128, 159, 191);\t}\t.ace-tm .ace_constant.ace_numeric {\tcolor: rgb(0, 0, 205);\t}\t.ace-tm .ace_variable {\tcolor: rgb(49, 132, 149);\t}\t.ace-tm .ace_xml-pe {\tcolor: rgb(104, 104, 91);\t}\t.ace-tm .ace_entity.ace_name.ace_function {\tcolor: #0000A2;\t}\t.ace-tm .ace_heading {\tcolor: rgb(12, 7, 255);\t}\t.ace-tm .ace_list {\tcolor:rgb(185, 6, 144);\t}\t.ace-tm .ace_meta.ace_tag {\tcolor:rgb(0, 22, 142);\t}\t.ace-tm .ace_string.ace_regex {\tcolor: rgb(255, 0, 0)\t}\t.ace-tm .ace_marker-layer .ace_selection {\tbackground: rgb(181, 213, 255);\t}\t.ace-tm.ace_multiselect .ace_selection.ace_start {\tbox-shadow: 0 0 3px 0px white;\t}\t.ace-tm .ace_marker-layer .ace_step {\tbackground: rgb(252, 255, 0);\t}\t.ace-tm .ace_marker-layer .ace_stack {\tbackground: rgb(164, 229, 101);\t}\t.ace-tm .ace_marker-layer .ace_bracket {\tmargin: -1px 0 0 -1px;\tborder: 1px solid rgb(192, 192, 192);\t}\t.ace-tm .ace_marker-layer .ace_active-line {\tbackground: rgba(0, 0, 0, 0.07);\t}\t.ace-tm .ace_gutter-active-line {\tbackground-color : #dcdcdc;\t}\t.ace-tm .ace_marker-layer .ace_selected-word {\tbackground: rgb(250, 250, 255);\tborder: 1px solid rgb(200, 200, 250);\t}\t.ace-tm .ace_indent-guide {\tbackground: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y;\t}\t';var n=e("../lib/dom");n.importCssString(t.cssText,t.cssClass)}),ace.define("ace/line_widgets",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/range"],function(e,t,i){"use strict";function n(e){this.session=e,this.session.widgetManager=this,this.session.getRowLength=this.getRowLength,this.session.$getWidgetScreenLength=this.$getWidgetScreenLength,this.updateOnChange=this.updateOnChange.bind(this),this.renderWidgets=this.renderWidgets.bind(this),this.measureWidgets=this.measureWidgets.bind(this),this.session._changedWidgets=[],this.$onChangeEditor=this.$onChangeEditor.bind(this),this.session.on("change",this.updateOnChange),this.session.on("changeFold",this.updateOnFold),this.session.on("changeEditor",this.$onChangeEditor)}var r=(e("./lib/oop"),e("./lib/dom"));e("./range").Range;(function(){this.getRowLength=function(e){var t;return t=this.lineWidgets?this.lineWidgets[e]&&this.lineWidgets[e].rowCount||0:0,this.$useWrapMode&&this.$wrapData[e]?this.$wrapData[e].length+1+t:1+t},this.$getWidgetScreenLength=function(){var e=0;return this.lineWidgets.forEach(function(t){t&&t.rowCount&&!t.hidden&&(e+=t.rowCount)}),e},this.$onChangeEditor=function(e){this.attach(e.editor)},this.attach=function(e){e&&e.widgetManager&&e.widgetManager!=this&&e.widgetManager.detach(),this.editor!=e&&(this.detach(),this.editor=e,e&&(e.widgetManager=this,e.renderer.on("beforeRender",this.measureWidgets),e.renderer.on("afterRender",this.renderWidgets)))},this.detach=function(e){var t=this.editor;if(t){this.editor=null,t.widgetManager=null,t.renderer.off("beforeRender",this.measureWidgets),t.renderer.off("afterRender",this.renderWidgets);var i=this.session.lineWidgets;i&&i.forEach(function(e){e&&e.el&&e.el.parentNode&&(e._inDocument=!1,e.el.parentNode.removeChild(e.el))})}},this.updateOnFold=function(e,t){var i=t.lineWidgets;if(i&&e.action){for(var n=e.data,r=n.start.row,o=n.end.row,s="add"==e.action,a=r+1;a<o;a++)i[a]&&(i[a].hidden=s);i[o]&&(s?i[r]?i[o].hidden=s:i[r]=i[o]:(i[r]==i[o]&&(i[r]=void 0),i[o].hidden=s))}},this.updateOnChange=function(e){var t=this.session.lineWidgets;if(t){var i=e.start.row,n=e.end.row-i;if(0===n);else if("remove"==e.action){var r=t.splice(i+1,n);r.forEach(function(e){e&&this.removeLineWidget(e)},this),this.$updateRows()}else{var o=new Array(n);o.unshift(i,0),t.splice.apply(t,o),this.$updateRows()}}},this.$updateRows=function(){var e=this.session.lineWidgets;if(e){var t=!0;e.forEach(function(e,i){if(e)for(t=!1,e.row=i;e.$oldWidget;)e.$oldWidget.row=i,e=e.$oldWidget}),t&&(this.session.lineWidgets=null)}},this.addLineWidget=function(e){this.session.lineWidgets||(this.session.lineWidgets=new Array(this.session.getLength()));var t=this.session.lineWidgets[e.row];t&&(e.$oldWidget=t,t.el&&t.el.parentNode&&(t.el.parentNode.removeChild(t.el),t._inDocument=!1)),this.session.lineWidgets[e.row]=e,e.session=this.session;var i=this.editor.renderer;e.html&&!e.el&&(e.el=r.createElement("div"),e.el.innerHTML=e.html),e.el&&(r.addCssClass(e.el,"ace_lineWidgetContainer"),e.el.style.position="absolute",e.el.style.zIndex=5,i.container.appendChild(e.el),e._inDocument=!0),e.coverGutter||(e.el.style.zIndex=3),e.pixelHeight||(e.pixelHeight=e.el.offsetHeight),null==e.rowCount&&(e.rowCount=e.pixelHeight/i.layerConfig.lineHeight);var n=this.session.getFoldAt(e.row,0);if(e.$fold=n,n){var o=this.session.lineWidgets;e.row!=n.end.row||o[n.start.row]?e.hidden=!0:o[n.start.row]=e}return this.session._emit("changeFold",{data:{start:{row:e.row}}}),this.$updateRows(),this.renderWidgets(null,i),this.onWidgetChanged(e),e},this.removeLineWidget=function(e){if(e._inDocument=!1,e.session=null,e.el&&e.el.parentNode&&e.el.parentNode.removeChild(e.el),e.editor&&e.editor.destroy)try{e.editor.destroy()}catch(e){}if(this.session.lineWidgets){var t=this.session.lineWidgets[e.row];if(t==e)this.session.lineWidgets[e.row]=e.$oldWidget,e.$oldWidget&&this.onWidgetChanged(e.$oldWidget);else for(;t;){if(t.$oldWidget==e){t.$oldWidget=e.$oldWidget;break}t=t.$oldWidget}}this.session._emit("changeFold",{data:{start:{row:e.row}}}),this.$updateRows()},this.getWidgetsAtRow=function(e){for(var t=this.session.lineWidgets,i=t&&t[e],n=[];i;)n.push(i),i=i.$oldWidget;return n},this.onWidgetChanged=function(e){this.session._changedWidgets.push(e),this.editor&&this.editor.renderer.updateFull()},this.measureWidgets=function(e,t){var i=this.session._changedWidgets,n=t.layerConfig;if(i&&i.length){for(var r=1/0,o=0;o<i.length;o++){var s=i[o];if(s&&s.el&&s.session==this.session){if(!s._inDocument){if(this.session.lineWidgets[s.row]!=s)continue;s._inDocument=!0,t.container.appendChild(s.el)}s.h=s.el.offsetHeight,s.fixedWidth||(s.w=s.el.offsetWidth,s.screenWidth=Math.ceil(s.w/n.characterWidth));var a=s.h/n.lineHeight;s.coverLine&&(a-=this.session.getRowLineCount(s.row),a<0&&(a=0)),s.rowCount!=a&&(s.rowCount=a,s.row<r&&(r=s.row))}}r!=1/0&&(this.session._emit("changeFold",{data:{start:{row:r}}}),this.session.lineWidgetWidth=null),this.session._changedWidgets=[]}},this.renderWidgets=function(e,t){var i=t.layerConfig,n=this.session.lineWidgets;if(n){for(var r=Math.min(this.firstRow,i.firstRow),o=Math.max(this.lastRow,i.lastRow,n.length);r>0&&!n[r];)r--;this.firstRow=i.firstRow,this.lastRow=i.lastRow,t.$cursorLayer.config=i;for(var s=r;s<=o;s++){var a=n[s];if(a&&a.el)if(a.hidden)a.el.style.top=-100-(a.pixelHeight||0)+"px";else{a._inDocument||(a._inDocument=!0,t.container.appendChild(a.el));var l=t.$cursorLayer.getPixelPosition({row:s,column:0},!0).top;a.coverLine||(l+=i.lineHeight*this.session.getRowLineCount(a.row)),a.el.style.top=l-i.offset+"px";var c=a.coverGutter?0:t.gutterWidth;a.fixedWidth||(c-=t.scrollLeft),a.el.style.left=c+"px",a.fullWidth&&a.screenWidth&&(a.el.style.minWidth=i.width+2*i.padding+"px"),a.fixedWidth?a.el.style.right=t.scrollBar.getWidth()+"px":a.el.style.right=""}}}}}).call(n.prototype),t.LineWidgets=n}),ace.define("ace/ext/error_marker",["require","exports","module","ace/line_widgets","ace/lib/dom","ace/range"],function(e,t,i){"use strict";function n(e,t,i){for(var n=0,r=e.length-1;n<=r;){var o=n+r>>1,s=i(t,e[o]);if(s>0)n=o+1;else{if(!(s<0))return o;r=o-1}}return-(n+1)}function r(e,t,i){var r=e.getAnnotations().sort(a.comparePoints);if(r.length){var o=n(r,{row:t,column:-1},a.comparePoints);o<0&&(o=-o-1),o>=r.length?o=i>0?0:r.length-1:0===o&&i<0&&(o=r.length-1);
	var s=r[o];if(s&&i){if(s.row===t){do s=r[o+=i];while(s&&s.row===t);if(!s)return r.slice()}var l=[];t=s.row;do l[i<0?"unshift":"push"](s),s=r[o+=i];while(s&&s.row==t);return l.length&&l}}}var o=e("../line_widgets").LineWidgets,s=e("../lib/dom"),a=e("../range").Range;t.showErrorMarker=function(e,t){var i=e.session;i.widgetManager||(i.widgetManager=new o(i),i.widgetManager.attach(e));var n=e.getCursorPosition(),a=n.row,l=i.widgetManager.getWidgetsAtRow(a).filter(function(e){return"errorMarker"==e.type})[0];l?l.destroy():a-=t;var c,h=r(i,a,t);if(h){var d=h[0];n.column=(d.pos&&"number"!=typeof d.column?d.pos.sc:d.column)||0,n.row=d.row,c=e.renderer.$gutterLayer.$annotations[n.row]}else{if(l)return;c={text:["Looks good!"],className:"ace_ok"}}e.session.unfold(n.row),e.selection.moveToPosition(n);var u={row:n.row,fixedWidth:!0,coverGutter:!0,el:s.createElement("div"),type:"errorMarker"},f=u.el.appendChild(s.createElement("div")),p=u.el.appendChild(s.createElement("div"));p.className="error_widget_arrow "+c.className;var m=e.renderer.$cursorLayer.getPixelPosition(n).left;p.style.left=m+e.renderer.gutterWidth-5+"px",u.el.className="error_widget_wrapper",f.className="error_widget "+c.className,f.innerHTML=c.text.join("<br>"),f.appendChild(s.createElement("div"));var g=function(e,t,i){if(0===t&&("esc"===i||"return"===i))return u.destroy(),{command:"null"}};u.destroy=function(){e.$mouseHandler.isMousePressed||(e.keyBinding.removeKeyboardHandler(g),i.widgetManager.removeLineWidget(u),e.off("changeSelection",u.destroy),e.off("changeSession",u.destroy),e.off("mouseup",u.destroy),e.off("change",u.destroy))},e.keyBinding.addKeyboardHandler(g),e.on("changeSelection",u.destroy),e.on("changeSession",u.destroy),e.on("mouseup",u.destroy),e.on("change",u.destroy),e.session.widgetManager.addLineWidget(u),u.el.onmousedown=e.focus.bind(e),e.renderer.scrollCursorIntoView(null,.5,{bottom:u.el.offsetHeight})},s.importCssString("\t    .error_widget_wrapper {\t        background: inherit;\t        color: inherit;\t        border:none\t    }\t    .error_widget {\t        border-top: solid 2px;\t        border-bottom: solid 2px;\t        margin: 5px 0;\t        padding: 10px 40px;\t        white-space: pre-wrap;\t    }\t    .error_widget.ace_error, .error_widget_arrow.ace_error{\t        border-color: #ff5a5a\t    }\t    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\t        border-color: #F1D817\t    }\t    .error_widget.ace_info, .error_widget_arrow.ace_info{\t        border-color: #5a5a5a\t    }\t    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\t        border-color: #5aaa5a\t    }\t    .error_widget_arrow {\t        position: absolute;\t        border: solid 5px;\t        border-top-color: transparent!important;\t        border-right-color: transparent!important;\t        border-left-color: transparent!important;\t        top: -5px;\t    }\t","")}),ace.define("ace/ace",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/dom","ace/lib/event","ace/editor","ace/edit_session","ace/undomanager","ace/virtual_renderer","ace/worker/worker_client","ace/keyboard/hash_handler","ace/placeholder","ace/multi_select","ace/mode/folding/fold_mode","ace/theme/textmate","ace/ext/error_marker","ace/config"],function(e,t,i){"use strict";e("./lib/fixoldbrowsers");var n=e("./lib/dom"),r=e("./lib/event"),o=e("./editor").Editor,s=e("./edit_session").EditSession,a=e("./undomanager").UndoManager,l=e("./virtual_renderer").VirtualRenderer;e("./worker/worker_client"),e("./keyboard/hash_handler"),e("./placeholder"),e("./multi_select"),e("./mode/folding/fold_mode"),e("./theme/textmate"),e("./ext/error_marker"),t.config=e("./config"),t.acequire=e,t.edit=function(e){if("string"==typeof e){var i=e;if(e=document.getElementById(i),!e)throw new Error("ace.edit can't find div #"+i)}if(e&&e.env&&e.env.editor instanceof o)return e.env.editor;var s="";if(e&&/input|textarea/i.test(e.tagName)){var a=e;s=a.value,e=n.createElement("pre"),a.parentNode.replaceChild(e,a)}else e&&(s=n.getInnerText(e),e.innerHTML="");var c=t.createEditSession(s),h=new o(new l(e));h.setSession(c);var d={document:c,editor:h,onResize:h.resize.bind(h,null)};return a&&(d.textarea=a),r.addListener(window,"resize",d.onResize),h.on("destroy",function(){r.removeListener(window,"resize",d.onResize),d.editor.container.env=null}),h.container.env=h.env=d,h},t.createEditSession=function(e,t){var i=new s(e,t);return i.setUndoManager(new a),i},t.EditSession=s,t.UndoManager=a,t.version="1.2.3"}),function(){ace.acequire(["ace/ace"],function(e){e&&e.config.init(!0),window.ace||(window.ace=e);for(var t in e)e.hasOwnProperty(t)&&(window.ace[t]=e[t])})}(),e.exports=window.ace.acequire("ace/ace")},function(e,t){e.exports=function(){throw new Error("define cannot be used indirect")}},function(e,t){(function(t){function i(){if(t.Blob)try{return new Blob(["asdf"],{type:"text/plain"}),Blob}catch(e){}var e=t.WebKitBlobBuilder||t.MozBlobBuilder||t.MSBlobBuilder;return function(t,i){var n=new e,r=i.endings,o=i.type;if(r)for(var s=0,a=t.length;s<a;++s)n.append(t[s],r);else for(var s=0,a=t.length;s<a;++s)n.append(t[s]);return o?n.getBlob(o):n.getBlob()}}e.exports=i()}).call(t,function(){return this}())},function(e,t,i){ace.define("ace/mode/json_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,i){"use strict";var n=e("../lib/oop"),r=e("./text_highlight_rules").TextHighlightRules,o=function(){this.$rules={start:[{token:"variable",regex:'["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'},{token:"string",regex:'"',next:"string"},{token:"constant.numeric",regex:"0[xX][0-9a-fA-F]+\\b"},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:"constant.language.boolean",regex:"(?:true|false)\\b"},{token:"invalid.illegal",regex:"['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"},{token:"invalid.illegal",regex:"\\/\\/.*$"},{token:"paren.lparen",regex:"[[({]"},{token:"paren.rparen",regex:"[\\])}]"},{token:"text",regex:"\\s+"}],string:[{token:"constant.language.escape",regex:/\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/},{token:"string",regex:'[^"\\\\]+'},{token:"string",regex:'"',next:"start"},{token:"string",regex:"",next:"start"}]}};n.inherits(o,r),t.JsonHighlightRules=o}),ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"],function(e,t,i){"use strict";var n=e("../range").Range,r=function(){};(function(){this.checkOutdent=function(e,t){return!!/^\s+$/.test(e)&&/^\s*\}/.test(t)},this.autoOutdent=function(e,t){var i=e.getLine(t),r=i.match(/^(\s*\})/);if(!r)return 0;var o=r[1].length,s=e.findMatchingBracket({row:t,column:o});if(!s||s.row==t)return 0;var a=this.$getIndent(e.getLine(s.row));e.replace(new n(t,0,t,o-1),a)},this.$getIndent=function(e){return e.match(/^\s*/)[0]}}).call(r.prototype),t.MatchingBraceOutdent=r}),ace.define("ace/mode/behaviour/cstyle",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"],function(e,t,i){"use strict";var n,r=e("../../lib/oop"),o=e("../behaviour").Behaviour,s=e("../../token_iterator").TokenIterator,a=e("../../lib/lang"),l=["text","paren.rparen","punctuation.operator"],c=["text","paren.rparen","punctuation.operator","comment"],h={},d=function(e){var t=-1;return e.multiSelect&&(t=e.selection.index,h.rangeCount!=e.multiSelect.rangeCount&&(h={rangeCount:e.multiSelect.rangeCount})),h[t]?n=h[t]:void(n=h[t]={autoInsertedBrackets:0,autoInsertedRow:-1,autoInsertedLineEnd:"",maybeInsertedBrackets:0,maybeInsertedRow:-1,maybeInsertedLineStart:"",maybeInsertedLineEnd:""})},u=function(e,t,i,n){var r=e.end.row-e.start.row;return{text:i+t+n,selection:[0,e.start.column+1,r,e.end.column+(r?0:1)]}},f=function(){this.add("braces","insertion",function(e,t,i,r,o){var s=i.getCursorPosition(),l=r.doc.getLine(s.row);if("{"==o){d(i);var c=i.getSelectionRange(),h=r.doc.getTextRange(c);if(""!==h&&"{"!==h&&i.getWrapBehavioursEnabled())return u(c,h,"{","}");if(f.isSaneInsertion(i,r))return/[\]\}\)]/.test(l[s.column])||i.inMultiSelectMode?(f.recordAutoInsert(i,r,"}"),{text:"{}",selection:[1,1]}):(f.recordMaybeInsert(i,r,"{"),{text:"{",selection:[1,1]})}else if("}"==o){d(i);var p=l.substring(s.column,s.column+1);if("}"==p){var m=r.$findOpeningBracket("}",{column:s.column+1,row:s.row});if(null!==m&&f.isAutoInsertedClosing(s,l,o))return f.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}else{if("\n"==o||"\r\n"==o){d(i);var g="";f.isMaybeInsertedClosing(s,l)&&(g=a.stringRepeat("}",n.maybeInsertedBrackets),f.clearMaybeInsertedClosing());var p=l.substring(s.column,s.column+1);if("}"===p){var v=r.findMatchingBracket({row:s.row,column:s.column+1},"}");if(!v)return null;var y=this.$getIndent(r.getLine(v.row))}else{if(!g)return void f.clearMaybeInsertedClosing();var y=this.$getIndent(l)}var w=y+r.getTabString();return{text:"\n"+w+"\n"+y+g,selection:[1,w.length,1,w.length]}}f.clearMaybeInsertedClosing()}}),this.add("braces","deletion",function(e,t,i,r,o){var s=r.doc.getTextRange(o);if(!o.isMultiLine()&&"{"==s){d(i);var a=r.doc.getLine(o.start.row),l=a.substring(o.end.column,o.end.column+1);if("}"==l)return o.end.column++,o;n.maybeInsertedBrackets--}}),this.add("parens","insertion",function(e,t,i,n,r){if("("==r){d(i);var o=i.getSelectionRange(),s=n.doc.getTextRange(o);if(""!==s&&i.getWrapBehavioursEnabled())return u(o,s,"(",")");if(f.isSaneInsertion(i,n))return f.recordAutoInsert(i,n,")"),{text:"()",selection:[1,1]}}else if(")"==r){d(i);var a=i.getCursorPosition(),l=n.doc.getLine(a.row),c=l.substring(a.column,a.column+1);if(")"==c){var h=n.$findOpeningBracket(")",{column:a.column+1,row:a.row});if(null!==h&&f.isAutoInsertedClosing(a,l,r))return f.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}}),this.add("parens","deletion",function(e,t,i,n,r){var o=n.doc.getTextRange(r);if(!r.isMultiLine()&&"("==o){d(i);var s=n.doc.getLine(r.start.row),a=s.substring(r.start.column+1,r.start.column+2);if(")"==a)return r.end.column++,r}}),this.add("brackets","insertion",function(e,t,i,n,r){if("["==r){d(i);var o=i.getSelectionRange(),s=n.doc.getTextRange(o);if(""!==s&&i.getWrapBehavioursEnabled())return u(o,s,"[","]");if(f.isSaneInsertion(i,n))return f.recordAutoInsert(i,n,"]"),{text:"[]",selection:[1,1]}}else if("]"==r){d(i);var a=i.getCursorPosition(),l=n.doc.getLine(a.row),c=l.substring(a.column,a.column+1);if("]"==c){var h=n.$findOpeningBracket("]",{column:a.column+1,row:a.row});if(null!==h&&f.isAutoInsertedClosing(a,l,r))return f.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}}),this.add("brackets","deletion",function(e,t,i,n,r){var o=n.doc.getTextRange(r);if(!r.isMultiLine()&&"["==o){d(i);var s=n.doc.getLine(r.start.row),a=s.substring(r.start.column+1,r.start.column+2);if("]"==a)return r.end.column++,r}}),this.add("string_dquotes","insertion",function(e,t,i,n,r){if('"'==r||"'"==r){d(i);var o=r,s=i.getSelectionRange(),a=n.doc.getTextRange(s);if(""!==a&&"'"!==a&&'"'!=a&&i.getWrapBehavioursEnabled())return u(s,a,o,o);if(!a){var l=i.getCursorPosition(),c=n.doc.getLine(l.row),h=c.substring(l.column-1,l.column),f=c.substring(l.column,l.column+1),p=n.getTokenAt(l.row,l.column),m=n.getTokenAt(l.row,l.column+1);if("\\"==h&&p&&/escape/.test(p.type))return null;var g,v=p&&/string|escape/.test(p.type),y=!m||/string|escape/.test(m.type);if(f==o)g=v!==y;else{if(v&&!y)return null;if(v&&y)return null;var w=n.$mode.tokenRe;w.lastIndex=0;var b=w.test(h);w.lastIndex=0;var A=w.test(h);if(b||A)return null;if(f&&!/[\s;,.})\]\\]/.test(f))return null;g=!0}return{text:g?o+o:"",selection:[1,1]}}}}),this.add("string_dquotes","deletion",function(e,t,i,n,r){var o=n.doc.getTextRange(r);if(!r.isMultiLine()&&('"'==o||"'"==o)){d(i);var s=n.doc.getLine(r.start.row),a=s.substring(r.start.column+1,r.start.column+2);if(a==o)return r.end.column++,r}})};f.isSaneInsertion=function(e,t){var i=e.getCursorPosition(),n=new s(t,i.row,i.column);if(!this.$matchTokenType(n.getCurrentToken()||"text",l)){var r=new s(t,i.row,i.column+1);if(!this.$matchTokenType(r.getCurrentToken()||"text",l))return!1}return n.stepForward(),n.getCurrentTokenRow()!==i.row||this.$matchTokenType(n.getCurrentToken()||"text",c)},f.$matchTokenType=function(e,t){return t.indexOf(e.type||e)>-1},f.recordAutoInsert=function(e,t,i){var r=e.getCursorPosition(),o=t.doc.getLine(r.row);this.isAutoInsertedClosing(r,o,n.autoInsertedLineEnd[0])||(n.autoInsertedBrackets=0),n.autoInsertedRow=r.row,n.autoInsertedLineEnd=i+o.substr(r.column),n.autoInsertedBrackets++},f.recordMaybeInsert=function(e,t,i){var r=e.getCursorPosition(),o=t.doc.getLine(r.row);this.isMaybeInsertedClosing(r,o)||(n.maybeInsertedBrackets=0),n.maybeInsertedRow=r.row,n.maybeInsertedLineStart=o.substr(0,r.column)+i,n.maybeInsertedLineEnd=o.substr(r.column),n.maybeInsertedBrackets++},f.isAutoInsertedClosing=function(e,t,i){return n.autoInsertedBrackets>0&&e.row===n.autoInsertedRow&&i===n.autoInsertedLineEnd[0]&&t.substr(e.column)===n.autoInsertedLineEnd},f.isMaybeInsertedClosing=function(e,t){return n.maybeInsertedBrackets>0&&e.row===n.maybeInsertedRow&&t.substr(e.column)===n.maybeInsertedLineEnd&&t.substr(0,e.column)==n.maybeInsertedLineStart},f.popAutoInsertedClosing=function(){n.autoInsertedLineEnd=n.autoInsertedLineEnd.substr(1),n.autoInsertedBrackets--},f.clearMaybeInsertedClosing=function(){n&&(n.maybeInsertedBrackets=0,n.maybeInsertedRow=-1)},r.inherits(f,o),t.CstyleBehaviour=f}),ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"],function(e,t,i){"use strict";var n=e("../../lib/oop"),r=e("../../range").Range,o=e("./fold_mode").FoldMode,s=t.FoldMode=function(e){e&&(this.foldingStartMarker=new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/,"|"+e.start)),this.foldingStopMarker=new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/,"|"+e.end)))};n.inherits(s,o),function(){this.foldingStartMarker=/(\{|\[)[^\}\]]*$|^\s*(\/\*)/,this.foldingStopMarker=/^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/,this.singleLineBlockCommentRe=/^\s*(\/\*).*\*\/\s*$/,this.tripleStarBlockCommentRe=/^\s*(\/\*\*\*).*\*\/\s*$/,this.startRegionRe=/^\s*(\/\*|\/\/)#?region\b/,this._getFoldWidgetBase=this.getFoldWidget,this.getFoldWidget=function(e,t,i){var n=e.getLine(i);if(this.singleLineBlockCommentRe.test(n)&&!this.startRegionRe.test(n)&&!this.tripleStarBlockCommentRe.test(n))return"";var r=this._getFoldWidgetBase(e,t,i);return!r&&this.startRegionRe.test(n)?"start":r},this.getFoldWidgetRange=function(e,t,i,n){var r=e.getLine(i);if(this.startRegionRe.test(r))return this.getCommentRegionBlock(e,r,i);var o=r.match(this.foldingStartMarker);if(o){var s=o.index;if(o[1])return this.openingBracketBlock(e,o[1],i,s);var a=e.getCommentFoldRange(i,s+o[0].length,1);return a&&!a.isMultiLine()&&(n?a=this.getSectionRange(e,i):"all"!=t&&(a=null)),a}if("markbegin"!==t){var o=r.match(this.foldingStopMarker);if(o){var s=o.index+o[0].length;return o[1]?this.closingBracketBlock(e,o[1],i,s):e.getCommentFoldRange(i,s,-1)}}},this.getSectionRange=function(e,t){var i=e.getLine(t),n=i.search(/\S/),o=t,s=i.length;t+=1;for(var a=t,l=e.getLength();++t<l;){i=e.getLine(t);var c=i.search(/\S/);if(c!==-1){if(n>c)break;var h=this.getFoldWidgetRange(e,"all",t);if(h){if(h.start.row<=o)break;if(h.isMultiLine())t=h.end.row;else if(n==c)break}a=t}}return new r(o,s,a,e.getLine(a).length)},this.getCommentRegionBlock=function(e,t,i){for(var n=t.search(/\s*$/),o=e.getLength(),s=i,a=/^\s*(?:\/\*|\/\/|--)#?(end)?region\b/,l=1;++i<o;){t=e.getLine(i);var c=a.exec(t);if(c&&(c[1]?l--:l++,!l))break}var h=i;if(h>s)return new r(s,n,h,t.length)}}.call(s.prototype)}),ace.define("ace/mode/json",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/json_highlight_rules","ace/mode/matching_brace_outdent","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle","ace/worker/worker_client"],function(e,t,n){"use strict";var r=e("../lib/oop"),o=e("./text").Mode,s=e("./json_highlight_rules").JsonHighlightRules,a=e("./matching_brace_outdent").MatchingBraceOutdent,l=e("./behaviour/cstyle").CstyleBehaviour,c=e("./folding/cstyle").FoldMode,h=e("../worker/worker_client").WorkerClient,d=function(){this.HighlightRules=s,this.$outdent=new a,this.$behaviour=new l,this.foldingRules=new c};r.inherits(d,o),function(){this.getNextLineIndent=function(e,t,i){var n=this.$getIndent(t);if("start"==e){var r=t.match(/^.*[\{\(\[]\s*$/);r&&(n+=i)}return n},this.checkOutdent=function(e,t,i){return this.$outdent.checkOutdent(t,i)},this.autoOutdent=function(e,t,i){this.$outdent.autoOutdent(t,i)},this.createWorker=function(e){var t=new h(["ace"],i(72),"JsonWorker");return t.attachToDocument(e.getDocument()),t.on("annotate",function(t){e.setAnnotations(t.data)}),t.on("terminate",function(){e.clearAnnotations()}),t},this.$id="ace/mode/json"}.call(d.prototype),t.Mode=d})},function(e,t){e.exports.id="ace/mode/json_worker",e.exports.src='"no use strict";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail="";testPath;){var alias=paths[testPath];if("string"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,"/")+(tail||alias.main||alias.name);if(alias===!1)return"";var i=testPath.lastIndexOf("/");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:"log",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:"error",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf("!")){var chunks=moduleName.split("!");return window.normalizeModule(parentId,chunks[0])+"!"+window.normalizeModule(parentId,chunks[1])}if("."==moduleName.charAt(0)){var base=parentId.split("/").slice(0,-1).join("/");for(moduleName=(base?base+"/":"")+moduleName;-1!==moduleName.indexOf(".")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,"").replace(/\\/\\.\\//,"/").replace(/[^\\/]+\\/\\.\\.\\//,"")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error("worker.js acequire() accepts only (parentId, id) as arguments");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log("unable to load "+id);var path=resolveModuleId(id,window.acequire.tlns);return".js"!=path.slice(-3)&&(path+=".js"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,"string"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),"function"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=["require","exports","module"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case"require":return req;case"exports":return module.exports;case"module":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire("ace/lib/event_emitter").EventEmitter,oop=window.acequire("ace/lib/oop"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:"call",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:"event",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error("Unknown command:"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire("ace/lib/es5-shim"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define("ace/lib/oop",["require","exports","module"],function(acequire,exports){"use strict";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define("ace/range",["require","exports","module"],function(acequire,exports){"use strict";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return"Range: ["+this.start.row+"/"+this.start.column+"] -> ["+this.end.row+"/"+this.end.column+"]"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){"object"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){"object"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define("ace/apply_delta",["require","exports","module"],function(acequire,exports){"use strict";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||"";switch(delta.action){case"insert":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case"remove":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define("ace/lib/event_emitter",["require","exports","module"],function(acequire,exports){"use strict";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){"object"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?"unshift":"push"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define("ace/anchor",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(acequire,exports){"use strict";var oop=acequire("./lib/oop"),EventEmitter=acequire("./lib/event_emitter").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert="insert"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal("change",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener("change",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on("change",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define("ace/document",["require","exports","module","ace/lib/oop","ace/apply_delta","ace/lib/event_emitter","ace/range","ace/anchor"],function(acequire,exports){"use strict";var oop=acequire("./lib/oop"),applyDelta=acequire("./apply_delta").applyDelta,EventEmitter=acequire("./lib/event_emitter").EventEmitter,Range=acequire("./range").Range,Anchor=acequire("./anchor").Anchor,Document=function(textOrLines){this.$lines=[""],0===textOrLines.length?this.$lines=[""]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0==="aaa".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,"\\n").split("\\n")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:"\\n",this._signal("changeNewLineMode")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case"windows":return"\\r\\n";case"unix":return"\\n";default:return this.$autoNewLine||"\\n"}},this.$autoNewLine="",this.$newLineMode="auto",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal("changeNewLineMode"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return"\\r\\n"==text||"\\r"==text||"\\n"==text},this.getLine=function(row){return this.$lines[row]||""},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||"").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, [\'\', \'\']) instead."),this.insertMergedLines(position,["",""])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:"insert",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([""]),column=0):(lines=[""].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:"insert",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:"remove",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:"remove",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:"remove",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:"remove",lines:["",""]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert="insert"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal("change",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(""),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:"insert"==delta.action?"remove":"insert",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define("ace/lib/lang",["require","exports","module"],function(acequire,exports){"use strict";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split("").reverse().join("")},exports.stringRepeat=function(string,count){for(var result="";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,"")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,"")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&"object"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if("object"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}var cons=obj.constructor;if(cons===RegExp)return obj;copy=cons();for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,"\\\\$1")},exports.escapeHTML=function(str){return str.replace(/&/g,"&#38;").replace(/"/g,"&#34;").replace(/\'/g,"&#39;").replace(/</g,"&#60;")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define("ace/worker/mirror",["require","exports","module","ace/range","ace/document","ace/lib/lang"],function(acequire,exports){"use strict";acequire("../range").Range;var Document=acequire("../document").Document,lang=acequire("../lib/lang"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(""),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on("change",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:"insert",start:data[i],lines:data[i+1]};else var d={action:"remove",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define("ace/mode/json/json_parse",["require","exports","module"],function(){"use strict";var at,ch,text,value,escapee={\'"\':\'"\',"\\\\":"\\\\","/":"/",b:"\\b",f:"\\f",n:"\\n",r:"\\r",t:"\t"},error=function(m){throw{name:"SyntaxError",message:m,at:at,text:text}},next=function(c){return c&&c!==ch&&error("Expected \'"+c+"\' instead of \'"+ch+"\'"),ch=text.charAt(at),at+=1,ch},number=function(){var number,string="";for("-"===ch&&(string="-",next("-"));ch>="0"&&"9">=ch;)string+=ch,next();if("."===ch)for(string+=".";next()&&ch>="0"&&"9">=ch;)string+=ch;if("e"===ch||"E"===ch)for(string+=ch,next(),("-"===ch||"+"===ch)&&(string+=ch,next());ch>="0"&&"9">=ch;)string+=ch,next();return number=+string,isNaN(number)?(error("Bad number"),void 0):number},string=function(){var hex,i,uffff,string="";if(\'"\'===ch)for(;next();){if(\'"\'===ch)return next(),string;if("\\\\"===ch)if(next(),"u"===ch){for(uffff=0,i=0;4>i&&(hex=parseInt(next(),16),isFinite(hex));i+=1)uffff=16*uffff+hex;string+=String.fromCharCode(uffff)}else{if("string"!=typeof escapee[ch])break;string+=escapee[ch]}else string+=ch}error("Bad string")},white=function(){for(;ch&&" ">=ch;)next()},word=function(){switch(ch){case"t":return next("t"),next("r"),next("u"),next("e"),!0;case"f":return next("f"),next("a"),next("l"),next("s"),next("e"),!1;case"n":return next("n"),next("u"),next("l"),next("l"),null}error("Unexpected \'"+ch+"\'")},array=function(){var array=[];if("["===ch){if(next("["),white(),"]"===ch)return next("]"),array;for(;ch;){if(array.push(value()),white(),"]"===ch)return next("]"),array;next(","),white()}}error("Bad array")},object=function(){var key,object={};if("{"===ch){if(next("{"),white(),"}"===ch)return next("}"),object;for(;ch;){if(key=string(),white(),next(":"),Object.hasOwnProperty.call(object,key)&&error(\'Duplicate key "\'+key+\'"\'),object[key]=value(),white(),"}"===ch)return next("}"),object;next(","),white()}}error("Bad object")};return value=function(){switch(white(),ch){case"{":return object();case"[":return array();case\'"\':return string();case"-":return number();default:return ch>="0"&&"9">=ch?number():word()}},function(source,reviver){var result;return text=source,at=0,ch=" ",result=value(),white(),ch&&error("Syntax error"),"function"==typeof reviver?function walk(holder,key){var k,v,value=holder[key];if(value&&"object"==typeof value)for(k in value)Object.hasOwnProperty.call(value,k)&&(v=walk(value,k),void 0!==v?value[k]=v:delete value[k]);return reviver.call(holder,key,value)}({"":result},""):result}}),ace.define("ace/mode/json_worker",["require","exports","module","ace/lib/oop","ace/worker/mirror","ace/mode/json/json_parse"],function(acequire,exports){"use strict";var oop=acequire("../lib/oop"),Mirror=acequire("../worker/mirror").Mirror,parse=acequire("./json/json_parse"),JsonWorker=exports.JsonWorker=function(sender){Mirror.call(this,sender),this.setTimeout(200)};oop.inherits(JsonWorker,Mirror),function(){this.onUpdate=function(){var value=this.doc.getValue(),errors=[];try{value&&parse(value)}catch(e){var pos=this.doc.indexToPosition(e.at-1);errors.push({row:pos.row,column:pos.column,text:e.message,type:"error"})}this.sender.emit("annotate",errors)}}.call(JsonWorker.prototype)}),ace.define("ace/lib/es5-shim",["require","exports","module"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,"sentinel",{}),"sentinel"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if("function"!=typeof target)throw new TypeError("Function.prototype.bind called on incompatible "+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,"__defineGetter__"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,"XXX"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0\n}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return"[object Array]"==_toString(obj)});var boxedString=Object("a"),splitString="a"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&"[object String]"==_toString(this)?this.split(""):object,thisp=arguments[1],i=-1,length=self.length>>>0;if("[object Function]"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&"[object String]"==_toString(this)?this.split(""):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if("[object Function]"!=_toString(fun))throw new TypeError(fun+" is not a function");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&"[object String]"==_toString(this)?this.split(""):object,length=self.length>>>0,result=[],thisp=arguments[1];if("[object Function]"!=_toString(fun))throw new TypeError(fun+" is not a function");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&"[object String]"==_toString(this)?this.split(""):object,length=self.length>>>0,thisp=arguments[1];if("[object Function]"!=_toString(fun))throw new TypeError(fun+" is not a function");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&"[object String]"==_toString(this)?this.split(""):object,length=self.length>>>0,thisp=arguments[1];if("[object Function]"!=_toString(fun))throw new TypeError(fun+" is not a function");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&"[object String]"==_toString(this)?this.split(""):object,length=self.length>>>0;if("[object Function]"!=_toString(fun))throw new TypeError(fun+" is not a function");if(!length&&1==arguments.length)throw new TypeError("reduce of empty array with no initial value");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError("reduce of empty array with no initial value")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&"[object String]"==_toString(this)?this.split(""):object,length=self.length>>>0;if("[object Function]"!=_toString(fun))throw new TypeError(fun+" is not a function");if(!length&&1==arguments.length)throw new TypeError("reduceRight of empty array with no initial value");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError("reduceRight of empty array with no initial value")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&"[object String]"==_toString(this)?this.split(""):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&"[object String]"==_toString(this)?this.split(""):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT="Object.getOwnPropertyDescriptor called on a non-object: ";Object.getOwnPropertyDescriptor=function(object,property){if("object"!=typeof object&&"function"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if("object"!=typeof prototype)throw new TypeError("typeof prototype["+typeof prototype+"] != \'object\'");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom="undefined"==typeof document||doesDefinePropertyWork(document.createElement("div"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR="Property description must be an object: ",ERR_NON_OBJECT_TARGET="Object.defineProperty called on non-object: ",ERR_ACCESSORS_NOT_SUPPORTED="getters & setters can not be defined on this javascript engine";Object.defineProperty=function(object,property,descriptor){if("object"!=typeof object&&"function"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if("object"!=typeof descriptor&&"function"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,"value"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,"get")&&defineGetter(object,property,descriptor.get),owns(descriptor,"set")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return"function"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name="";owns(object,name);)name+="?";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if("object"!=typeof object&&"function"!=typeof object||null===object)throw new TypeError("Object.keys called on a non-object");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws="\t\\n\v\\f\\r   ᠎             　\\u2028\\u2029\ufeff";if(!String.prototype.trim||ws.trim()){ws="["+ws+"]";var trimBeginRegexp=RegExp("^"+ws+ws+"*"),trimEndRegexp=RegExp(ws+ws+"*$");String.prototype.trim=function(){return(this+"").replace(trimBeginRegexp,"").replace(trimEndRegexp,"")}}var toObject=function(o){if(null==o)throw new TypeError("can\'t convert "+o+" to object");return Object(o)}});';
	},function(e,t){ace.define("ace/ext/searchbox",["require","exports","module","ace/lib/dom","ace/lib/lang","ace/lib/event","ace/keyboard/hash_handler","ace/lib/keys"],function(e,t,i){"use strict";var n=e("../lib/dom"),r=e("../lib/lang"),o=e("../lib/event"),s="\t.ace_search {\tbackground-color: #ddd;\tborder: 1px solid #cbcbcb;\tborder-top: 0 none;\tmax-width: 325px;\toverflow: hidden;\tmargin: 0;\tpadding: 4px;\tpadding-right: 6px;\tpadding-bottom: 0;\tposition: absolute;\ttop: 0px;\tz-index: 99;\twhite-space: normal;\t}\t.ace_search.left {\tborder-left: 0 none;\tborder-radius: 0px 0px 5px 0px;\tleft: 0;\t}\t.ace_search.right {\tborder-radius: 0px 0px 0px 5px;\tborder-right: 0 none;\tright: 0;\t}\t.ace_search_form, .ace_replace_form {\tborder-radius: 3px;\tborder: 1px solid #cbcbcb;\tfloat: left;\tmargin-bottom: 4px;\toverflow: hidden;\t}\t.ace_search_form.ace_nomatch {\toutline: 1px solid red;\t}\t.ace_search_field {\tbackground-color: white;\tborder-right: 1px solid #cbcbcb;\tborder: 0 none;\t-webkit-box-sizing: border-box;\t-moz-box-sizing: border-box;\tbox-sizing: border-box;\tfloat: left;\theight: 22px;\toutline: 0;\tpadding: 0 7px;\twidth: 214px;\tmargin: 0;\t}\t.ace_searchbtn,\t.ace_replacebtn {\tbackground: #fff;\tborder: 0 none;\tborder-left: 1px solid #dcdcdc;\tcursor: pointer;\tfloat: left;\theight: 22px;\tmargin: 0;\tposition: relative;\t}\t.ace_searchbtn:last-child,\t.ace_replacebtn:last-child {\tborder-top-right-radius: 3px;\tborder-bottom-right-radius: 3px;\t}\t.ace_searchbtn:disabled {\tbackground: none;\tcursor: default;\t}\t.ace_searchbtn {\tbackground-position: 50% 50%;\tbackground-repeat: no-repeat;\twidth: 27px;\t}\t.ace_searchbtn.prev {\tbackground-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADFJREFUeNpiSU1NZUAC/6E0I0yACYskCpsJiySKIiY0SUZk40FyTEgCjGgKwTRAgAEAQJUIPCE+qfkAAAAASUVORK5CYII=);    \t}\t.ace_searchbtn.next {\tbackground-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADRJREFUeNpiTE1NZQCC/0DMyIAKwGJMUAYDEo3M/s+EpvM/mkKwCQxYjIeLMaELoLMBAgwAU7UJObTKsvAAAAAASUVORK5CYII=);    \t}\t.ace_searchbtn_close {\tbackground: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAAZ0lEQVR42u2SUQrAMAhDvazn8OjZBilCkYVVxiis8H4CT0VrAJb4WHT3C5xU2a2IQZXJjiQIRMdkEoJ5Q2yMqpfDIo+XY4k6h+YXOyKqTIj5REaxloNAd0xiKmAtsTHqW8sR2W5f7gCu5nWFUpVjZwAAAABJRU5ErkJggg==) no-repeat 50% 0;\tborder-radius: 50%;\tborder: 0 none;\tcolor: #656565;\tcursor: pointer;\tfloat: right;\tfont: 16px/16px Arial;\theight: 14px;\tmargin: 5px 1px 9px 5px;\tpadding: 0;\ttext-align: center;\twidth: 14px;\t}\t.ace_searchbtn_close:hover {\tbackground-color: #656565;\tbackground-position: 50% 100%;\tcolor: white;\t}\t.ace_replacebtn.prev {\twidth: 54px\t}\t.ace_replacebtn.next {\twidth: 27px\t}\t.ace_button {\tmargin-left: 2px;\tcursor: pointer;\t-webkit-user-select: none;\t-moz-user-select: none;\t-o-user-select: none;\t-ms-user-select: none;\tuser-select: none;\toverflow: hidden;\topacity: 0.7;\tborder: 1px solid rgba(100,100,100,0.23);\tpadding: 1px;\t-moz-box-sizing: border-box;\tbox-sizing:    border-box;\tcolor: black;\t}\t.ace_button:hover {\tbackground-color: #eee;\topacity:1;\t}\t.ace_button:active {\tbackground-color: #ddd;\t}\t.ace_button.checked {\tborder-color: #3399ff;\topacity:1;\t}\t.ace_search_options{\tmargin-bottom: 3px;\ttext-align: right;\t-webkit-user-select: none;\t-moz-user-select: none;\t-o-user-select: none;\t-ms-user-select: none;\tuser-select: none;\t}",a=e("../keyboard/hash_handler").HashHandler,l=e("../lib/keys");n.importCssString(s,"ace_searchbox");var c='<div class="ace_search right">\t    <button type="button" action="hide" class="ace_searchbtn_close"></button>\t    <div class="ace_search_form">\t        <input class="ace_search_field" placeholder="Search for" spellcheck="false"></input>\t        <button type="button" action="findNext" class="ace_searchbtn next"></button>\t        <button type="button" action="findPrev" class="ace_searchbtn prev"></button>\t        <button type="button" action="findAll" class="ace_searchbtn" title="Alt-Enter">All</button>\t    </div>\t    <div class="ace_replace_form">\t        <input class="ace_search_field" placeholder="Replace with" spellcheck="false"></input>\t        <button type="button" action="replaceAndFindNext" class="ace_replacebtn">Replace</button>\t        <button type="button" action="replaceAll" class="ace_replacebtn">All</button>\t    </div>\t    <div class="ace_search_options">\t        <span action="toggleRegexpMode" class="ace_button" title="RegExp Search">.*</span>\t        <span action="toggleCaseSensitive" class="ace_button" title="CaseSensitive Search">Aa</span>\t        <span action="toggleWholeWords" class="ace_button" title="Whole Word Search">\\b</span>\t    </div>\t</div>'.replace(/>\s+/g,">"),h=function(e,t,i){var r=n.createElement("div");r.innerHTML=c,this.element=r.firstChild,this.$init(),this.setEditor(e)};(function(){this.setEditor=function(e){e.searchBox=this,e.container.appendChild(this.element),this.editor=e},this.$initElements=function(e){this.searchBox=e.querySelector(".ace_search_form"),this.replaceBox=e.querySelector(".ace_replace_form"),this.searchOptions=e.querySelector(".ace_search_options"),this.regExpOption=e.querySelector("[action=toggleRegexpMode]"),this.caseSensitiveOption=e.querySelector("[action=toggleCaseSensitive]"),this.wholeWordOption=e.querySelector("[action=toggleWholeWords]"),this.searchInput=this.searchBox.querySelector(".ace_search_field"),this.replaceInput=this.replaceBox.querySelector(".ace_search_field")},this.$init=function(){var e=this.element;this.$initElements(e);var t=this;o.addListener(e,"mousedown",function(e){setTimeout(function(){t.activeInput.focus()},0),o.stopPropagation(e)}),o.addListener(e,"click",function(e){var i=e.target||e.srcElement,n=i.getAttribute("action");n&&t[n]?t[n]():t.$searchBarKb.commands[n]&&t.$searchBarKb.commands[n].exec(t),o.stopPropagation(e)}),o.addCommandKeyListener(e,function(e,i,n){var r=l.keyCodeToString(n),s=t.$searchBarKb.findKeyCommand(i,r);s&&s.exec&&(s.exec(t),o.stopEvent(e))}),this.$onChange=r.delayedCall(function(){t.find(!1,!1)}),o.addListener(this.searchInput,"input",function(){t.$onChange.schedule(20)}),o.addListener(this.searchInput,"focus",function(){t.activeInput=t.searchInput,t.searchInput.value&&t.highlight()}),o.addListener(this.replaceInput,"focus",function(){t.activeInput=t.replaceInput,t.searchInput.value&&t.highlight()})},this.$closeSearchBarKb=new a([{bindKey:"Esc",name:"closeSearchBar",exec:function(e){e.searchBox.hide()}}]),this.$searchBarKb=new a,this.$searchBarKb.bindKeys({"Ctrl-f|Command-f":function(e){var t=e.isReplace=!e.isReplace;e.replaceBox.style.display=t?"":"none",e.searchInput.focus()},"Ctrl-H|Command-Option-F":function(e){e.replaceBox.style.display="",e.replaceInput.focus()},"Ctrl-G|Command-G":function(e){e.findNext()},"Ctrl-Shift-G|Command-Shift-G":function(e){e.findPrev()},esc:function(e){setTimeout(function(){e.hide()})},Return:function(e){e.activeInput==e.replaceInput&&e.replace(),e.findNext()},"Shift-Return":function(e){e.activeInput==e.replaceInput&&e.replace(),e.findPrev()},"Alt-Return":function(e){e.activeInput==e.replaceInput&&e.replaceAll(),e.findAll()},Tab:function(e){(e.activeInput==e.replaceInput?e.searchInput:e.replaceInput).focus()}}),this.$searchBarKb.addCommands([{name:"toggleRegexpMode",bindKey:{win:"Alt-R|Alt-/",mac:"Ctrl-Alt-R|Ctrl-Alt-/"},exec:function(e){e.regExpOption.checked=!e.regExpOption.checked,e.$syncOptions()}},{name:"toggleCaseSensitive",bindKey:{win:"Alt-C|Alt-I",mac:"Ctrl-Alt-R|Ctrl-Alt-I"},exec:function(e){e.caseSensitiveOption.checked=!e.caseSensitiveOption.checked,e.$syncOptions()}},{name:"toggleWholeWords",bindKey:{win:"Alt-B|Alt-W",mac:"Ctrl-Alt-B|Ctrl-Alt-W"},exec:function(e){e.wholeWordOption.checked=!e.wholeWordOption.checked,e.$syncOptions()}}]),this.$syncOptions=function(){n.setCssClass(this.regExpOption,"checked",this.regExpOption.checked),n.setCssClass(this.wholeWordOption,"checked",this.wholeWordOption.checked),n.setCssClass(this.caseSensitiveOption,"checked",this.caseSensitiveOption.checked),this.find(!1,!1)},this.highlight=function(e){this.editor.session.highlight(e||this.editor.$search.$options.re),this.editor.renderer.updateBackMarkers()},this.find=function(e,t,i){var r=this.editor.find(this.searchInput.value,{skipCurrent:e,backwards:t,wrap:!0,regExp:this.regExpOption.checked,caseSensitive:this.caseSensitiveOption.checked,wholeWord:this.wholeWordOption.checked,preventScroll:i}),o=!r&&this.searchInput.value;n.setCssClass(this.searchBox,"ace_nomatch",o),this.editor._emit("findSearchBox",{match:!o}),this.highlight()},this.findNext=function(){this.find(!0,!1)},this.findPrev=function(){this.find(!0,!0)},this.findAll=function(){var e=this.editor.findAll(this.searchInput.value,{regExp:this.regExpOption.checked,caseSensitive:this.caseSensitiveOption.checked,wholeWord:this.wholeWordOption.checked}),t=!e&&this.searchInput.value;n.setCssClass(this.searchBox,"ace_nomatch",t),this.editor._emit("findSearchBox",{match:!t}),this.highlight(),this.hide()},this.replace=function(){this.editor.getReadOnly()||this.editor.replace(this.replaceInput.value)},this.replaceAndFindNext=function(){this.editor.getReadOnly()||(this.editor.replace(this.replaceInput.value),this.findNext())},this.replaceAll=function(){this.editor.getReadOnly()||this.editor.replaceAll(this.replaceInput.value)},this.hide=function(){this.element.style.display="none",this.editor.keyBinding.removeKeyboardHandler(this.$closeSearchBarKb),this.editor.focus()},this.show=function(e,t){this.element.style.display="",this.replaceBox.style.display=t?"":"none",this.isReplace=t,e&&(this.searchInput.value=e),this.find(!1,!1,!0),this.searchInput.focus(),this.searchInput.select(),this.editor.keyBinding.addKeyboardHandler(this.$closeSearchBarKb)},this.isFocused=function(){var e=document.activeElement;return e==this.searchInput||e==this.replaceInput}}).call(h.prototype),t.SearchBox=h,t.Search=function(e,t){var i=e.searchBox||new h(e);i.show(e.session.getTextRange(),t)}}),function(){ace.acequire(["ace/ext/searchbox"],function(){})}()},function(e,t){ace.define("ace/theme/jsoneditor",["require","exports","module","ace/lib/dom"],function(e,t,i){t.isDark=!1,t.cssClass="ace-jsoneditor",t.cssText='.ace-jsoneditor .ace_gutter {\tbackground: #ebebeb;\tcolor: #333\t}\t\t.ace-jsoneditor.ace_editor {\tfont-family: droid sans mono, consolas, monospace, courier new, courier, sans-serif;\tline-height: 1.3;\t}\t.ace-jsoneditor .ace_print-margin {\twidth: 1px;\tbackground: #e8e8e8\t}\t.ace-jsoneditor .ace_scroller {\tbackground-color: #FFFFFF\t}\t.ace-jsoneditor .ace_text-layer {\tcolor: gray\t}\t.ace-jsoneditor .ace_variable {\tcolor: #1a1a1a\t}\t.ace-jsoneditor .ace_cursor {\tborder-left: 2px solid #000000\t}\t.ace-jsoneditor .ace_overwrite-cursors .ace_cursor {\tborder-left: 0px;\tborder-bottom: 1px solid #000000\t}\t.ace-jsoneditor .ace_marker-layer .ace_selection {\tbackground: lightgray\t}\t.ace-jsoneditor.ace_multiselect .ace_selection.ace_start {\tbox-shadow: 0 0 3px 0px #FFFFFF;\tborder-radius: 2px\t}\t.ace-jsoneditor .ace_marker-layer .ace_step {\tbackground: rgb(255, 255, 0)\t}\t.ace-jsoneditor .ace_marker-layer .ace_bracket {\tmargin: -1px 0 0 -1px;\tborder: 1px solid #BFBFBF\t}\t.ace-jsoneditor .ace_marker-layer .ace_active-line {\tbackground: #FFFBD1\t}\t.ace-jsoneditor .ace_gutter-active-line {\tbackground-color : #dcdcdc\t}\t.ace-jsoneditor .ace_marker-layer .ace_selected-word {\tborder: 1px solid lightgray\t}\t.ace-jsoneditor .ace_invisible {\tcolor: #BFBFBF\t}\t.ace-jsoneditor .ace_keyword,\t.ace-jsoneditor .ace_meta,\t.ace-jsoneditor .ace_support.ace_constant.ace_property-value {\tcolor: #AF956F\t}\t.ace-jsoneditor .ace_keyword.ace_operator {\tcolor: #484848\t}\t.ace-jsoneditor .ace_keyword.ace_other.ace_unit {\tcolor: #96DC5F\t}\t.ace-jsoneditor .ace_constant.ace_language {\tcolor: darkorange\t}\t.ace-jsoneditor .ace_constant.ace_numeric {\tcolor: red\t}\t.ace-jsoneditor .ace_constant.ace_character.ace_entity {\tcolor: #BF78CC\t}\t.ace-jsoneditor .ace_invalid {\tcolor: #FFFFFF;\tbackground-color: #FF002A;\t}\t.ace-jsoneditor .ace_fold {\tbackground-color: #AF956F;\tborder-color: #000000\t}\t.ace-jsoneditor .ace_storage,\t.ace-jsoneditor .ace_support.ace_class,\t.ace-jsoneditor .ace_support.ace_function,\t.ace-jsoneditor .ace_support.ace_other,\t.ace-jsoneditor .ace_support.ace_type {\tcolor: #C52727\t}\t.ace-jsoneditor .ace_string {\tcolor: green\t}\t.ace-jsoneditor .ace_comment {\tcolor: #BCC8BA\t}\t.ace-jsoneditor .ace_entity.ace_name.ace_tag,\t.ace-jsoneditor .ace_entity.ace_other.ace_attribute-name {\tcolor: #606060\t}\t.ace-jsoneditor .ace_markup.ace_underline {\ttext-decoration: underline\t}\t.ace-jsoneditor .ace_indent-guide {\tbackground: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y\t}';var n=e("../lib/dom");n.importCssString(t.cssText,t.cssClass)})},function(e,t,i){var n=i(76);"string"==typeof n&&(n=[[e.id,n,""]]);i(79)(n,{});n.locals&&(e.exports=n.locals)},function(e,t,i){t=e.exports=i(77)(),t.push([e.id,'div.jsoneditor .jsoneditor-search input{height:auto;border:inherit}div.jsoneditor .jsoneditor-search input:focus{border:none!important;box-shadow:none!important}div.jsoneditor table{border-collapse:collapse;width:auto}div.jsoneditor td,div.jsoneditor th{padding:0;display:table-cell;text-align:left;vertical-align:inherit;border-radius:inherit}div.jsoneditor-field,div.jsoneditor-readonly,div.jsoneditor-value{border:1px solid transparent;min-height:16px;min-width:32px;padding:2px;margin:1px;word-wrap:break-word;float:left}div.jsoneditor-field p,div.jsoneditor-value p{margin:0}div.jsoneditor-value{word-break:break-word}div.jsoneditor-readonly{min-width:16px;color:gray}div.jsoneditor-empty{border-color:#d3d3d3;border-style:dashed;border-radius:2px}div.jsoneditor-field.jsoneditor-empty:after,div.jsoneditor-value.jsoneditor-empty:after{pointer-events:none;color:#d3d3d3;font-size:8pt}div.jsoneditor-field.jsoneditor-empty:after{content:"field"}div.jsoneditor-value.jsoneditor-empty:after{content:"value"}a.jsoneditor-value.jsoneditor-url,div.jsoneditor-value.jsoneditor-url{color:green;text-decoration:underline}a.jsoneditor-value.jsoneditor-url{display:inline-block;padding:2px;margin:2px}a.jsoneditor-value.jsoneditor-url:focus,a.jsoneditor-value.jsoneditor-url:hover{color:#ee422e}div.jsoneditor td.jsoneditor-separator{padding:3px 0;vertical-align:top;color:gray}div.jsoneditor-field.jsoneditor-highlight,div.jsoneditor-field[contenteditable=true]:focus,div.jsoneditor-field[contenteditable=true]:hover,div.jsoneditor-value.jsoneditor-highlight,div.jsoneditor-value[contenteditable=true]:focus,div.jsoneditor-value[contenteditable=true]:hover{background-color:#ffffab;border:1px solid #ff0;border-radius:2px}div.jsoneditor-field.jsoneditor-highlight-active,div.jsoneditor-field.jsoneditor-highlight-active:focus,div.jsoneditor-field.jsoneditor-highlight-active:hover,div.jsoneditor-value.jsoneditor-highlight-active,div.jsoneditor-value.jsoneditor-highlight-active:focus,div.jsoneditor-value.jsoneditor-highlight-active:hover{background-color:#fe0;border:1px solid #ffc700;border-radius:2px}div.jsoneditor-value.jsoneditor-string{color:green}div.jsoneditor-value.jsoneditor-array,div.jsoneditor-value.jsoneditor-object{min-width:16px;color:gray}div.jsoneditor-value.jsoneditor-number{color:#ee422e}div.jsoneditor-value.jsoneditor-boolean{color:#ff8c00}div.jsoneditor-value.jsoneditor-null{color:#004ed0}div.jsoneditor-value.jsoneditor-invalid{color:#000}div.jsoneditor-tree button{width:24px;height:24px;padding:0;margin:0;border:none;cursor:pointer;background:transparent url('+i(78)+")}div.jsoneditor-mode-form tr.jsoneditor-expandable td.jsoneditor-tree,div.jsoneditor-mode-view tr.jsoneditor-expandable td.jsoneditor-tree{cursor:pointer}div.jsoneditor-tree button.jsoneditor-collapsed{background-position:0 -48px}div.jsoneditor-tree button.jsoneditor-expanded{background-position:0 -72px}div.jsoneditor-tree button.jsoneditor-contextmenu{background-position:-48px -72px}div.jsoneditor-tree button.jsoneditor-contextmenu.jsoneditor-selected,div.jsoneditor-tree button.jsoneditor-contextmenu:focus,div.jsoneditor-tree button.jsoneditor-contextmenu:hover,tr.jsoneditor-selected.jsoneditor-first button.jsoneditor-contextmenu{background-position:-48px -48px}div.jsoneditor-tree :focus{outline:none}div.jsoneditor-tree button:focus{background-color:#f5f5f5;outline:1px solid #e5e5e5}div.jsoneditor-tree button.jsoneditor-invisible{visibility:hidden;background:none}div.jsoneditor{color:#1a1a1a;border:1px solid #3883fa;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;height:100%;overflow:hidden;position:relative;padding:0;line-height:100%}div.jsoneditor-tree table.jsoneditor-tree{border-collapse:collapse;border-spacing:0;width:100%;margin:0}div.jsoneditor-outer{position:static;width:100%;height:100%;margin:-35px 0 0;padding:35px 0 0;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}.ace-jsoneditor,textarea.jsoneditor-text{min-height:150px}div.jsoneditor-tree{width:100%;height:100%;position:relative;overflow:auto}textarea.jsoneditor-text{width:100%;height:100%;margin:0;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;outline-width:0;border:none;background-color:#fff;resize:none}tr.jsoneditor-highlight,tr.jsoneditor-selected{background-color:#e6e6e6}tr.jsoneditor-selected button.jsoneditor-contextmenu,tr.jsoneditor-selected button.jsoneditor-dragarea{visibility:hidden}tr.jsoneditor-selected.jsoneditor-first button.jsoneditor-contextmenu,tr.jsoneditor-selected.jsoneditor-first button.jsoneditor-dragarea{visibility:visible}div.jsoneditor-tree button.jsoneditor-dragarea{background:url("+i(78)+") -72px -72px;cursor:move}div.jsoneditor-tree button.jsoneditor-dragarea:focus,div.jsoneditor-tree button.jsoneditor-dragarea:hover,tr.jsoneditor-selected.jsoneditor-first button.jsoneditor-dragarea{background-position:-72px -48px}div.jsoneditor td,div.jsoneditor th,div.jsoneditor tr{padding:0;margin:0}div.jsoneditor td,div.jsoneditor td.jsoneditor-tree{vertical-align:top}.jsoneditor-schema-error,div.jsoneditor-field,div.jsoneditor-value,div.jsoneditor td,div.jsoneditor textarea,div.jsoneditor th{font-family:droid sans mono,consolas,monospace,courier new,courier,sans-serif;font-size:10pt;color:#1a1a1a}.jsoneditor-schema-error{cursor:default;display:inline-block;height:24px;line-height:24px;position:relative;text-align:center;width:24px}div.jsoneditor-tree .jsoneditor-schema-error{width:24px;height:24px;padding:0;margin:0 4px 0 0;background:url("+i(78)+') -168px -48px}.jsoneditor-schema-error .jsoneditor-popover{background-color:#4c4c4c;border-radius:3px;box-shadow:0 0 5px rgba(0,0,0,.4);color:#fff;display:none;padding:7px 10px;position:absolute;width:200px;z-index:4}.jsoneditor-schema-error .jsoneditor-popover.jsoneditor-above{bottom:32px;left:-98px}.jsoneditor-schema-error .jsoneditor-popover.jsoneditor-below{top:32px;left:-98px}.jsoneditor-schema-error .jsoneditor-popover.jsoneditor-left{top:-7px;right:32px}.jsoneditor-schema-error .jsoneditor-popover.jsoneditor-right{top:-7px;left:32px}.jsoneditor-schema-error .jsoneditor-popover:before{border-right:7px solid transparent;border-left:7px solid transparent;content:"";display:block;left:50%;margin-left:-7px;position:absolute}.jsoneditor-schema-error .jsoneditor-popover.jsoneditor-above:before{border-top:7px solid #4c4c4c;bottom:-7px}.jsoneditor-schema-error .jsoneditor-popover.jsoneditor-below:before{border-bottom:7px solid #4c4c4c;top:-7px}.jsoneditor-schema-error .jsoneditor-popover.jsoneditor-left:before{border-left:7px solid #4c4c4c;right:-14px;left:inherit}.jsoneditor-schema-error .jsoneditor-popover.jsoneditor-left:before,.jsoneditor-schema-error .jsoneditor-popover.jsoneditor-right:before{border-top:7px solid transparent;border-bottom:7px solid transparent;content:"";top:19px;margin-left:inherit;margin-top:-7px;position:absolute}.jsoneditor-schema-error .jsoneditor-popover.jsoneditor-right:before{border-right:7px solid #4c4c4c;left:-14px}.jsoneditor-schema-error:focus .jsoneditor-popover,.jsoneditor-schema-error:hover .jsoneditor-popover{display:block;-webkit-animation:fade-in .3s linear 1,move-up .3s linear 1;-moz-animation:fade-in .3s linear 1,move-up .3s linear 1;-ms-animation:fade-in .3s linear 1,move-up .3s linear 1}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@-moz-keyframes fade-in{0%{opacity:0}to{opacity:1}}@-ms-keyframes fade-in{0%{opacity:0}to{opacity:1}}.jsoneditor .jsoneditor-text-errors{width:100%;border-collapse:collapse;background-color:#ffef8b;border-top:1px solid gold}.jsoneditor .jsoneditor-text-errors td{padding:3px 6px;vertical-align:middle}.jsoneditor-text-errors .jsoneditor-schema-error{border:none;width:24px;height:24px;padding:0;margin:0 4px 0 0;background:url('+i(78)+") -168px -48px}div.jsoneditor-contextmenu-root{position:relative;width:0;height:0}div.jsoneditor-contextmenu{position:absolute;box-sizing:content-box;z-index:99999}div.jsoneditor-contextmenu li,div.jsoneditor-contextmenu ul{box-sizing:content-box}div.jsoneditor-contextmenu ul{position:relative;left:0;top:0;width:124px;background:#fff;border:1px solid #d3d3d3;box-shadow:2px 2px 12px hsla(0,0%,50%,.3);list-style:none;margin:0;padding:0}div.jsoneditor-contextmenu ul li button{padding:0;margin:0;width:124px;height:24px;border:none;cursor:pointer;color:#4d4d4d;background:transparent;font-size:10pt;font-family:arial,sans-serif;box-sizing:border-box;line-height:26px;text-align:left}div.jsoneditor-contextmenu ul li button::-moz-focus-inner{padding:0;border:0}div.jsoneditor-contextmenu ul li button:focus,div.jsoneditor-contextmenu ul li button:hover{color:#1a1a1a;background-color:#f5f5f5;outline:none}div.jsoneditor-contextmenu ul li button.jsoneditor-default{width:92px}div.jsoneditor-contextmenu ul li button.jsoneditor-expand{float:right;width:32px;height:24px;border-left:1px solid #e5e5e5}div.jsoneditor-contextmenu div.jsoneditor-icon{float:left;width:24px;height:24px;border:none;padding:0;margin:0;background-image:url("+i(78)+")}div.jsoneditor-contextmenu ul li button div.jsoneditor-expand{float:right;width:24px;height:24px;padding:0;margin:0 4px 0 0;background:url("+i(78)+") 0 -72px;opacity:.4}div.jsoneditor-contextmenu ul li.jsoneditor-selected div.jsoneditor-expand,div.jsoneditor-contextmenu ul li button.jsoneditor-expand:focus div.jsoneditor-expand,div.jsoneditor-contextmenu ul li button.jsoneditor-expand:hover div.jsoneditor-expand,div.jsoneditor-contextmenu ul li button:focus div.jsoneditor-expand,div.jsoneditor-contextmenu ul li button:hover div.jsoneditor-expand{opacity:1}div.jsoneditor-contextmenu div.jsoneditor-separator{height:0;border-top:1px solid #e5e5e5;padding-top:5px;margin-top:5px}div.jsoneditor-contextmenu button.jsoneditor-remove>div.jsoneditor-icon{background-position:-24px -24px}div.jsoneditor-contextmenu button.jsoneditor-remove:focus>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-remove:hover>div.jsoneditor-icon{background-position:-24px 0}div.jsoneditor-contextmenu button.jsoneditor-append>div.jsoneditor-icon{background-position:0 -24px}div.jsoneditor-contextmenu button.jsoneditor-append:focus>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-append:hover>div.jsoneditor-icon{background-position:0 0}div.jsoneditor-contextmenu button.jsoneditor-insert>div.jsoneditor-icon{background-position:0 -24px}div.jsoneditor-contextmenu button.jsoneditor-insert:focus>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-insert:hover>div.jsoneditor-icon{background-position:0 0}div.jsoneditor-contextmenu button.jsoneditor-duplicate>div.jsoneditor-icon{background-position:-48px -24px}div.jsoneditor-contextmenu button.jsoneditor-duplicate:focus>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-duplicate:hover>div.jsoneditor-icon{background-position:-48px 0}div.jsoneditor-contextmenu button.jsoneditor-sort-asc>div.jsoneditor-icon{background-position:-168px -24px}div.jsoneditor-contextmenu button.jsoneditor-sort-asc:focus>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-sort-asc:hover>div.jsoneditor-icon{background-position:-168px 0}div.jsoneditor-contextmenu button.jsoneditor-sort-desc>div.jsoneditor-icon{background-position:-192px -24px}div.jsoneditor-contextmenu button.jsoneditor-sort-desc:focus>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-sort-desc:hover>div.jsoneditor-icon{background-position:-192px 0}div.jsoneditor-contextmenu ul li button.jsoneditor-selected,div.jsoneditor-contextmenu ul li button.jsoneditor-selected:focus,div.jsoneditor-contextmenu ul li button.jsoneditor-selected:hover{color:#fff;background-color:#ee422e}div.jsoneditor-contextmenu ul li{overflow:hidden}div.jsoneditor-contextmenu ul li ul{display:none;position:relative;left:-10px;top:0;border:none;box-shadow:inset 0 0 10px hsla(0,0%,50%,.5);padding:0 10px;-webkit-transition:all .3s ease-out;-moz-transition:all .3s ease-out;-o-transition:all .3s ease-out;transition:all .3s ease-out}div.jsoneditor-contextmenu ul li ul li button{padding-left:24px;animation:all ease-in-out 1s}div.jsoneditor-contextmenu ul li ul li button:focus,div.jsoneditor-contextmenu ul li ul li button:hover{background-color:#f5f5f5}div.jsoneditor-contextmenu button.jsoneditor-type-string>div.jsoneditor-icon{background-position:-144px -24px}div.jsoneditor-contextmenu button.jsoneditor-type-string.jsoneditor-selected>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-type-string:focus>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-type-string:hover>div.jsoneditor-icon{background-position:-144px 0}div.jsoneditor-contextmenu button.jsoneditor-type-auto>div.jsoneditor-icon{background-position:-120px -24px}div.jsoneditor-contextmenu button.jsoneditor-type-auto.jsoneditor-selected>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-type-auto:focus>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-type-auto:hover>div.jsoneditor-icon{background-position:-120px 0}div.jsoneditor-contextmenu button.jsoneditor-type-object>div.jsoneditor-icon{background-position:-72px -24px}div.jsoneditor-contextmenu button.jsoneditor-type-object.jsoneditor-selected>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-type-object:focus>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-type-object:hover>div.jsoneditor-icon{background-position:-72px 0}div.jsoneditor-contextmenu button.jsoneditor-type-array>div.jsoneditor-icon{background-position:-96px -24px}div.jsoneditor-contextmenu button.jsoneditor-type-array.jsoneditor-selected>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-type-array:focus>div.jsoneditor-icon,div.jsoneditor-contextmenu button.jsoneditor-type-array:hover>div.jsoneditor-icon{background-position:-96px 0}div.jsoneditor-contextmenu button.jsoneditor-type-modes>div.jsoneditor-icon{background-image:none;width:6px}div.jsoneditor-menu{width:100%;height:35px;padding:2px;margin:0;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;color:#fff;background-color:#3883fa;border-bottom:1px solid #3883fa}div.jsoneditor-menu>button,div.jsoneditor-menu>div.jsoneditor-modes>button{width:26px;height:26px;margin:2px;padding:0;border-radius:2px;border:1px solid transparent;background:transparent url("+i(78)+");color:#fff;opacity:.8;font-family:arial,sans-serif;font-size:10pt;float:left}div.jsoneditor-menu>button:hover,div.jsoneditor-menu>div.jsoneditor-modes>button:hover{background-color:hsla(0,0%,100%,.2);border:1px solid hsla(0,0%,100%,.4)}div.jsoneditor-menu>button:active,div.jsoneditor-menu>button:focus,div.jsoneditor-menu>div.jsoneditor-modes>button:active,div.jsoneditor-menu>div.jsoneditor-modes>button:focus{background-color:hsla(0,0%,100%,.3)}div.jsoneditor-menu>button:disabled,div.jsoneditor-menu>div.jsoneditor-modes>button:disabled{opacity:.5}div.jsoneditor-menu>button.jsoneditor-collapse-all{background-position:0 -96px}div.jsoneditor-menu>button.jsoneditor-expand-all{background-position:0 -120px}div.jsoneditor-menu>button.jsoneditor-undo{background-position:-24px -96px}div.jsoneditor-menu>button.jsoneditor-undo:disabled{background-position:-24px -120px}div.jsoneditor-menu>button.jsoneditor-redo{background-position:-48px -96px}div.jsoneditor-menu>button.jsoneditor-redo:disabled{background-position:-48px -120px}div.jsoneditor-menu>button.jsoneditor-compact{background-position:-72px -96px}div.jsoneditor-menu>button.jsoneditor-format{background-position:-72px -120px}div.jsoneditor-menu>div.jsoneditor-modes{display:inline-block;float:left}div.jsoneditor-menu>div.jsoneditor-modes>button{background-image:none;width:auto;padding-left:6px;padding-right:6px}div.jsoneditor-menu>button.jsoneditor-separator,div.jsoneditor-menu>div.jsoneditor-modes>button.jsoneditor-separator{margin-left:10px}div.jsoneditor-menu a{font-family:arial,sans-serif;font-size:10pt;color:#fff;opacity:.8;vertical-align:middle}div.jsoneditor-menu a:hover{opacity:1}div.jsoneditor-menu a.jsoneditor-poweredBy{font-size:8pt;position:absolute;right:0;top:0;padding:10px}table.jsoneditor-search div.jsoneditor-results,table.jsoneditor-search input{font-family:arial,sans-serif;font-size:10pt;color:#1a1a1a;background:transparent}table.jsoneditor-search div.jsoneditor-results{color:#fff;padding-right:5px;line-height:24px}table.jsoneditor-search{position:absolute;right:4px;top:4px;border-collapse:collapse;border-spacing:0}table.jsoneditor-search div.jsoneditor-frame{border:1px solid transparent;background-color:#fff;padding:0 2px;margin:0}table.jsoneditor-search div.jsoneditor-frame table{border-collapse:collapse}table.jsoneditor-search input{width:120px;border:none;outline:none;margin:1px;line-height:20px}table.jsoneditor-search button{width:16px;height:24px;padding:0;margin:0;border:none;background:url("+i(78)+");vertical-align:top}table.jsoneditor-search button:hover{background-color:transparent}table.jsoneditor-search button.jsoneditor-refresh{width:18px;background-position:-99px -73px}table.jsoneditor-search button.jsoneditor-next{cursor:pointer;background-position:-124px -73px}table.jsoneditor-search button.jsoneditor-next:hover{background-position:-124px -49px}table.jsoneditor-search button.jsoneditor-previous{cursor:pointer;background-position:-148px -73px;margin-right:2px}table.jsoneditor-search button.jsoneditor-previous:hover{background-position:-148px -49px}",""])},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var i=this[t];i[2]?e.push("@media "+i[2]+"{"+i[1]+"}"):e.push(i[1])}return e.join("")},e.i=function(t,i){"string"==typeof t&&(t=[[null,t,""]]);for(var n={},r=0;r<this.length;r++){var o=this[r][0];"number"==typeof o&&(n[o]=!0)}for(r=0;r<t.length;r++){var s=t[r];"number"==typeof s[0]&&n[s[0]]||(i&&!s[2]?s[2]=i:i&&(s[2]="("+s[2]+") and ("+i+")"),e.push(s))}},e}},function(e,t){e.exports="\"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' width='216' height='144' id='svg4136' version='1.1' inkscape:version='0.91 r' sodipodi:docname='jsoneditor-icons.svg'%3E %3Ctitle id='title6512'%3EJSON Editor Icons%3C/title%3E %3Cmetadata id='metadata4148'%3E %3Crdf:RDF%3E %3Ccc:Work rdf:about=''%3E %3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E %3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E %3Cdc:title%3EJSON Editor Icons%3C/dc:title%3E %3C/cc:Work%3E %3C/rdf:RDF%3E %3C/metadata%3E %3Cdefs id='defs4146' /%3E %3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='1920' inkscape:window-height='1028' id='namedview4144' showgrid='true' inkscape:zoom='4' inkscape:cx='97.217248' inkscape:cy='59.950227' inkscape:window-x='0' inkscape:window-y='0' inkscape:window-maximized='1' inkscape:current-layer='svg4136' showguides='false' borderlayer='false' inkscape:showpageshadow='true' showborder='true'%3E %3Cinkscape:grid type='xygrid' id='grid4640' empspacing='24' /%3E %3C/sodipodi:namedview%3E %3C!-- Created with SVG-edit - http://svg-edit.googlecode.com/ --%3E %3Cg id='g4394'%3E %3Crect x='4' y='4' width='16' height='16' id='svg_1' style='fill:%231aae1c;fill-opacity:1;stroke:none;stroke-width:0' /%3E %3Crect style='fill:%23ec3f29;fill-opacity:0.94117647;stroke:none;stroke-width:0' x='28.000006' y='3.999995' width='16' height='16' id='svg_1-7' /%3E %3Crect id='rect4165' height='16' width='16' y='3.999995' x='52.000004' style='fill:%234c4c4c;fill-opacity:1;stroke:none;stroke-width:0' /%3E %3Crect style='fill:%234c4c4c;fill-opacity:1;stroke:none;stroke-width:0' x='172.00002' y='3.9999852' width='16' height='16' id='rect4175' /%3E %3Crect style='fill:%234c4c4c;fill-opacity:1;stroke:none;stroke-width:0' x='196' y='3.999995' width='16' height='16' id='rect4175-3' /%3E %3Cg style='stroke:none' id='g4299'%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:0' id='svg_1-1' height='1.9999986' width='9.9999924' y='10.999998' x='7.0000048' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:0' id='svg_1-1-1' height='9.9999838' width='1.9999955' y='7.0000114' x='11.000005' /%3E %3C/g%3E %3Cg style='stroke:none' transform='matrix(0.70710678,-0.70710678,0.70710678,0.70710678,19.029435,12.000001)' id='g4299-3'%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:0' id='svg_1-1-0' height='1.9999986' width='9.9999924' y='10.999998' x='7.0000048' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:0' id='svg_1-1-1-9' height='9.9999838' width='1.9999955' y='7.0000114' x='11.000005' /%3E %3C/g%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' x='55.000004' y='7.0000048' width='6.9999909' height='6.9999905' id='svg_1-7-5' /%3E %3Crect id='rect4354' height='6.9999905' width='6.9999909' y='10.00001' x='58' style='fill:%23ffffff;fill-opacity:1;stroke:%234c4c4c;stroke-width:2;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:%233c80df;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.94117647' x='58.000004' y='10.000005' width='6.9999909' height='6.9999905' id='svg_1-7-5-7' /%3E %3Cg id='g4378'%3E %3Crect id='svg_1-7-5-3' height='1.9999965' width='7.9999909' y='10.999999' x='198' style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' x='198' y='7.0000005' width='11.999995' height='1.9999946' id='rect4374' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' x='198' y='14.999996' width='3.9999928' height='1.9999995' id='rect4376' /%3E %3C/g%3E %3Cg id='g4383' transform='matrix(1,0,0,-1,-23.999995,23.999995)'%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' x='198' y='10.999999' width='7.9999909' height='1.9999965' id='rect4385' /%3E %3Crect id='rect4387' height='1.9999946' width='11.999995' y='7.0000005' x='198' style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' /%3E %3Crect id='rect4389' height='1.9999995' width='3.9999928' y='14.999996' x='198' style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' /%3E %3C/g%3E %3Crect y='3.9999199' x='76' height='16' width='16' id='rect3754-4' style='fill:%234c4c4c;fill-opacity:1;stroke:none' /%3E %3Cpath sodipodi:nodetypes='cccccccc' inkscape:connector-curvature='0' id='path4351' d='m 85.10447,6.0157384 -0.0156,1.4063 c 3.02669,-0.2402 0.33008,3.6507996 2.48438,4.5780996 -2.18694,1.0938 0.49191,4.9069 -2.45313,4.5781 l -0.0156,1.4219 c 5.70828,0.559 1.03264,-5.1005 4.70313,-5.2656 l 0,-1.4063 c -3.61303,-0.027 1.11893,-5.7069996 -4.70313,-5.3124996 z' style='fill:%23ffffff;fill-opacity:1;stroke:%23ffffff;stroke-width:0.2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' /%3E %3Cpath sodipodi:nodetypes='cccccccc' inkscape:connector-curvature='0' id='path4351-9' d='m 82.78125,5.9984384 0.0156,1.4063 c -3.02668,-0.2402 -0.33007,3.6506996 -2.48437,4.5780996 2.18694,1.0938 -0.49192,4.9069 2.45312,4.5781 l 0.0156,1.4219 c -5.70827,0.559 -1.03263,-5.1004 -4.70312,-5.2656 l 0,-1.4063 c 3.61303,-0.027 -1.11894,-5.7070996 4.70312,-5.3124996 z' style='fill:%23ffffff;fill-opacity:1;stroke:%23ffffff;stroke-width:0.2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' /%3E %3Crect y='3.9999199' x='100' height='16' width='16' id='rect3754-25' style='fill:%234c4c4c;fill-opacity:1;stroke:none' /%3E %3Cpath inkscape:connector-curvature='0' id='path2987' d='m 103.719,5.6719384 0,12.7187996 3.03125,0 0,-1.5313 -1.34375,0 0,-9.6249996 1.375,0 0,-1.5625 z' style='fill:%23ffffff;fill-opacity:1;stroke:none' /%3E %3Cpath inkscape:connector-curvature='0' id='path2987-1' d='m 112.2185,5.6721984 0,12.7187996 -3.03125,0 0,-1.5313 1.34375,0 0,-9.6249996 -1.375,0 0,-1.5625 z' style='fill:%23ffffff;fill-opacity:1;stroke:none' /%3E %3Crect y='3.9999199' x='124' height='16' width='16' id='rect3754-73' style='fill:%234c4c4c;fill-opacity:1;stroke:none' /%3E %3Cpath sodipodi:nodetypes='ccccccccc' inkscape:connector-curvature='0' id='path3780' d='m 126.2824,17.602938 1.78957,0 1.14143,-2.8641 5.65364,0 1.14856,2.8641 1.76565,0 -4.78687,-11.1610996 -1.91903,0 z' style='fill:%23ffffff;fill-opacity:1;stroke:none' /%3E %3Cpath inkscape:connector-curvature='0' id='path3782' d='m 129.72704,13.478838 4.60852,0.01 -2.30426,-5.5497996 z' style='fill:%234c4c4c;fill-opacity:1;stroke:none' /%3E %3Crect y='3.9999199' x='148' height='16' width='16' id='rect3754-35' style='fill:%234c4c4c;fill-opacity:1;stroke:none' /%3E %3Cpath sodipodi:nodetypes='ccccccc' inkscape:connector-curvature='0' id='path5008-2' d='m 156.47655,5.8917384 0,2.1797 0.46093,2.3983996 1.82813,0 0.39844,-2.3983996 0,-2.1797 z' style='fill:%23ffffff;fill-opacity:1;stroke:none' /%3E %3Cpath sodipodi:nodetypes='ccccccc' inkscape:connector-curvature='0' id='path5008-2-8' d='m 152.51561,5.8906384 0,2.1797 0.46094,2.3983996 1.82812,0 0.39844,-2.3983996 0,-2.1797 z' style='fill:%23ffffff;fill-opacity:1;stroke:none' /%3E %3C/g%3E %3Crect x='4' y='27.999994' width='16' height='16' id='rect4432' style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0' /%3E %3Crect style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0' x='28.000006' y='27.99999' width='16' height='16' id='rect4434' /%3E %3Crect id='rect4436' height='16' width='16' y='27.99999' x='52.000004' style='fill:%23d3d3d3;fill-opacity:1;stroke:%23000000;stroke-width:0' /%3E %3Crect style='fill:%23d3d3d3;stroke:%23000000;stroke-width:0' x='172.00002' y='27.999981' width='16' height='16' id='rect4446' /%3E %3Crect style='fill:%23d3d3d3;stroke:%23000000;stroke-width:0' x='196' y='27.99999' width='16' height='16' id='rect4448' /%3E %3Cg id='g4466' style='stroke:none' transform='translate(0,23.999995)'%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:0' id='rect4468' height='1.9999986' width='9.9999924' y='10.999998' x='7.0000048' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:0' id='rect4470' height='9.9999838' width='1.9999955' y='7.0000114' x='11.000005' /%3E %3C/g%3E %3Cg transform='matrix(0.70710678,-0.70710678,0.70710678,0.70710678,19.029435,35.999996)' id='g4472' style='stroke:none'%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:0' id='rect4474' height='1.9999986' width='9.9999924' y='10.999998' x='7.0000048' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:0' id='rect4476' height='9.9999838' width='1.9999955' y='7.0000114' x='11.000005' /%3E %3C/g%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' x='55.000004' y='31' width='6.9999909' height='6.9999905' id='rect4478' /%3E %3Crect id='rect4480' height='6.9999905' width='6.9999909' y='34.000008' x='58' style='fill:%23ffffff;fill-opacity:1;stroke:%23d3d3d3;stroke-width:2;stroke-miterlimit:4;stroke-dasharray:none' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:%23d3d3d3;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none' x='58.000004' y='34.000004' width='6.9999909' height='6.9999905' id='rect4482' /%3E %3Cg id='g4484' transform='translate(0,23.999995)'%3E %3Crect id='rect4486' height='1.9999965' width='7.9999909' y='10.999999' x='198' style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' x='198' y='7.0000005' width='11.999995' height='1.9999946' id='rect4488' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' x='198' y='14.999996' width='3.9999928' height='1.9999995' id='rect4490' /%3E %3C/g%3E %3Cg id='g4492' transform='matrix(1,0,0,-1,-23.999995,47.99999)'%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' x='198' y='10.999999' width='7.9999909' height='1.9999965' id='rect4494' /%3E %3Crect id='rect4496' height='1.9999946' width='11.999995' y='7.0000005' x='198' style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' /%3E %3Crect id='rect4498' height='1.9999995' width='3.9999928' y='14.999996' x='198' style='fill:%23ffffff;fill-opacity:1;stroke:%23000000;stroke-width:0' /%3E %3C/g%3E %3Crect style='fill:%23d3d3d3;fill-opacity:1;stroke:none' id='rect3754-8' width='16' height='16' x='76' y='27.99992' /%3E %3Cpath style='fill:%23ffffff;fill-opacity:1;stroke:%23ffffff;stroke-width:0.2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' d='m 85.10448,30.015537 -0.0156,1.4063 c 3.02668,-0.2402 0.33007,3.6508 2.48438,4.5781 -2.18695,1.0938 0.49191,4.90688 -2.45313,4.57808 l -0.0156,1.4219 c 5.70827,0.559 1.03263,-5.10048 4.70313,-5.26558 l 0,-1.4063 c -3.61304,-0.027 1.11893,-5.707 -4.70313,-5.3125 z' id='path4351-1' inkscape:connector-curvature='0' sodipodi:nodetypes='cccccccc' /%3E %3Cpath style='fill:%23ffffff;fill-opacity:1;stroke:%23ffffff;stroke-width:0.2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' d='m 82.78126,29.998237 0.0156,1.4063 c -3.02668,-0.2402 -0.33008,3.6507 -2.48438,4.5781 2.18694,1.0938 -0.49191,4.90688 2.45313,4.57808 l 0.0156,1.4219 c -5.70828,0.559 -1.03264,-5.10038 -4.70313,-5.26558 l 0,-1.4063 c 3.61303,-0.027 -1.11893,-5.7071 4.70313,-5.3125 z' id='path4351-9-5' inkscape:connector-curvature='0' sodipodi:nodetypes='cccccccc' /%3E %3Crect style='fill:%23d3d3d3;fill-opacity:1;stroke:none' id='rect3754-65' width='16' height='16' x='100' y='27.99992' /%3E %3Cpath style='fill:%23ffffff;fill-opacity:1;stroke:none' d='m 103.719,29.671937 0,12.71878 3.03125,0 0,-1.5313 -1.34375,0 0,-9.62498 1.375,0 0,-1.5625 z' id='path2987-8' inkscape:connector-curvature='0' /%3E %3Cpath style='fill:%23ffffff;fill-opacity:1;stroke:none' d='m 112.2185,29.671937 0,12.71878 -3.03125,0 0,-1.5313 1.34375,0 0,-9.62498 -1.375,0 0,-1.5625 z' id='path2987-1-9' inkscape:connector-curvature='0' /%3E %3Crect style='fill:%23d3d3d3;fill-opacity:1;stroke:none' id='rect3754-92' width='16' height='16' x='124' y='27.99992' /%3E %3Cpath style='fill:%23ffffff;fill-opacity:1;stroke:none' d='m 126.2824,41.602917 1.78957,0 1.14143,-2.86408 5.65364,0 1.14856,2.86408 1.76565,0 -4.78687,-11.16108 -1.91902,0 z' id='path3780-9' inkscape:connector-curvature='0' sodipodi:nodetypes='ccccccccc' /%3E %3Cpath style='fill:%23d3d3d3;fill-opacity:1;stroke:none' d='m 129.72704,37.478837 4.60852,0.01 -2.30426,-5.5498 z' id='path3782-2' inkscape:connector-curvature='0' /%3E %3Crect style='fill:%23d3d3d3;fill-opacity:1;stroke:none' id='rect3754-47' width='16' height='16' x='148' y='27.99992' /%3E %3Cpath style='fill:%23ffffff;fill-opacity:1;stroke:none' d='m 156.47656,29.891737 0,2.1797 0.46093,2.3984 1.82813,0 0.39844,-2.3984 0,-2.1797 z' id='path5008-2-1' inkscape:connector-curvature='0' sodipodi:nodetypes='ccccccc' /%3E %3Cpath style='fill:%23ffffff;fill-opacity:1;stroke:none' d='m 152.51562,29.890637 0,2.1797 0.46094,2.3984 1.82812,0 0.39844,-2.3984 0,-2.1797 z' id='path5008-2-8-8' inkscape:connector-curvature='0' sodipodi:nodetypes='ccccccc' /%3E %3Crect id='svg_1-7-2' height='1.9999961' width='11.999996' y='64' x='54' style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' /%3E %3Crect id='svg_1-7-2-2' height='2.9999905' width='2.9999907' y='52' x='80.000008' style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' /%3E %3Crect style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' x='85.000008' y='52' width='2.9999907' height='2.9999905' id='rect4561' /%3E %3Crect style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' x='80.000008' y='58' width='2.9999907' height='2.9999905' id='rect4563' /%3E %3Crect id='rect4565' height='2.9999905' width='2.9999907' y='58' x='85.000008' style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' /%3E %3Crect id='rect4567' height='2.9999905' width='2.9999907' y='64' x='80.000008' style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' /%3E %3Crect style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' x='85.000008' y='64' width='2.9999907' height='2.9999905' id='rect4569' /%3E %3Ccircle style='opacity:1;fill:none;fill-opacity:1;stroke:%234c4c4c;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none' id='path4571' cx='110.06081' cy='57.939209' r='4.7438836' /%3E %3Crect style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' x='116.64566' y='-31.79752' width='4.229713' height='6.4053884' id='rect4563-2' transform='matrix(0.70710678,0.70710678,-0.70710678,0.70710678,0,0)' /%3E %3Cpath style='fill:%234c4c4c;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' d='M 125,56 138.77027,56.095 132,64 Z' id='path4613' inkscape:connector-curvature='0' sodipodi:nodetypes='cccc' /%3E %3Cpath sodipodi:nodetypes='cccc' inkscape:connector-curvature='0' id='path4615' d='M 149,64 162.77027,63.905 156,56 Z' style='fill:%234c4c4c;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' /%3E %3Crect style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' x='54' y='53' width='11.999996' height='1.9999961' id='rect4638' /%3E %3Crect id='svg_1-7-2-24' height='1.9999957' width='12.99999' y='-56' x='53' style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' transform='matrix(0,1,-1,0,0,0)' /%3E %3Crect transform='matrix(0,1,-1,0,0,0)' style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' x='53' y='-66' width='12.99999' height='1.9999957' id='rect4657' /%3E %3Crect id='rect4659' height='0.99999291' width='11.999999' y='57' x='54' style='fill:%234c4c4c;fill-opacity:0.98431373;stroke:none;stroke-width:0' /%3E %3Crect style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' x='54' y='88.000122' width='11.999996' height='1.9999961' id='rect4661' /%3E %3Crect style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' x='80.000008' y='76.000122' width='2.9999907' height='2.9999905' id='rect4663' /%3E %3Crect id='rect4665' height='2.9999905' width='2.9999907' y='76.000122' x='85.000008' style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' /%3E %3Crect id='rect4667' height='2.9999905' width='2.9999907' y='82.000122' x='80.000008' style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' /%3E %3Crect style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' x='85.000008' y='82.000122' width='2.9999907' height='2.9999905' id='rect4669' /%3E %3Crect style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' x='80.000008' y='88.000122' width='2.9999907' height='2.9999905' id='rect4671' /%3E %3Crect id='rect4673' height='2.9999905' width='2.9999907' y='88.000122' x='85.000008' style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' /%3E %3Ccircle r='4.7438836' cy='81.939331' cx='110.06081' id='circle4675' style='opacity:1;fill:none;fill-opacity:1;stroke:%23d3d3d3;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' /%3E %3Crect transform='matrix(0.70710678,0.70710678,-0.70710678,0.70710678,0,0)' id='rect4677' height='6.4053884' width='4.229713' y='-14.826816' x='133.6163' style='fill:%23d3d3d3;fill-opacity:1;stroke:%23d3d3d3;stroke-width:0;stroke-opacity:1' /%3E %3Cpath sodipodi:nodetypes='cccc' inkscape:connector-curvature='0' id='path4679' d='m 125,80.000005 13.77027,0.09499 L 132,87.999992 Z' style='fill:%23d3d3d3;fill-opacity:1;fill-rule:evenodd;stroke:%23d3d3d3;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' /%3E %3Cpath style='fill:%23d3d3d3;fill-opacity:1;fill-rule:evenodd;stroke:%23d3d3d3;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' d='M 149,88.0002 162.77027,87.9052 156,80.0002 Z' id='path4681' inkscape:connector-curvature='0' sodipodi:nodetypes='cccc' /%3E %3Crect id='rect4683' height='1.9999961' width='11.999996' y='77.000122' x='54' style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' /%3E %3Crect transform='matrix(0,1,-1,0,0,0)' style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' x='77.000122' y='-56' width='12.99999' height='1.9999957' id='rect4685' /%3E %3Crect id='rect4687' height='1.9999957' width='12.99999' y='-66' x='77.000122' style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' transform='matrix(0,1,-1,0,0,0)' /%3E %3Crect style='fill:%23d3d3d3;fill-opacity:1;stroke:none;stroke-width:0;stroke-opacity:1' x='54' y='81.000122' width='11.999999' height='0.99999291' id='rect4689' /%3E %3Crect id='rect4761-1' height='1.9999945' width='15.99999' y='101' x='76.000008' style='fill:%23ffffff;fill-opacity:0.80000007;stroke:none;stroke-width:0' /%3E %3Crect id='rect4761-0' height='1.9999945' width='15.99999' y='105' x='76.000008' style='fill:%23ffffff;fill-opacity:0.80000007;stroke:none;stroke-width:0' /%3E %3Crect id='rect4761-7' height='1.9999945' width='9' y='109' x='76.000008' style='fill:%23ffffff;fill-opacity:0.80000007;stroke:none;stroke-width:0' /%3E %3Crect id='rect4761-1-1' height='1.9999945' width='12' y='125' x='76.000008' style='fill:%23ffffff;fill-opacity:0.80000007;stroke:none;stroke-width:0' /%3E %3Crect id='rect4761-1-1-4' height='1.9999945' width='10' y='137' x='76.000008' style='fill:%23ffffff;fill-opacity:0.80000007;stroke:none;stroke-width:0' /%3E %3Crect id='rect4761-1-1-4-4' height='1.9999945' width='10' y='129' x='82' style='fill:%23ffffff;fill-opacity:0.80000007;stroke:none;stroke-width:0' /%3E %3Crect id='rect4761-1-1-4-4-3' height='1.9999945' width='9' y='133' x='82' style='fill:%23ffffff;fill-opacity:0.80000007;stroke:none;stroke-width:0' /%3E %3Cpath inkscape:connector-curvature='0' style='color:%23000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:%23000000;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;baseline-shift:baseline;text-anchor:start;white-space:normal;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:0.8;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:%23000000;solid-opacity:1;fill:%23ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:2.66157866;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate' d='m 36.398438,100.0254 c -0.423362,-0.013 -0.846847,0.01 -1.265626,0.062 -1.656562,0.2196 -3.244567,0.9739 -4.507812,2.2266 L 29,100.5991 l -2.324219,7.7129 7.826172,-1.9062 -1.804687,-1.9063 c 1.597702,-1.5308 4.048706,-1.8453 5.984375,-0.7207 1.971162,1.1452 2.881954,3.3975 2.308593,5.5508 -0.573361,2.1533 -2.533865,3.6953 -4.830078,3.6953 l 0,3.0742 c 3.550756,0 6.710442,-2.4113 7.650391,-5.9414 0.939949,-3.5301 -0.618463,-7.2736 -3.710938,-9.0703 -1.159678,-0.6738 -2.431087,-1.0231 -3.701171,-1.0625 z' id='path4138' /%3E %3Cpath inkscape:connector-curvature='0' style='color:%23000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:%23000000;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;baseline-shift:baseline;text-anchor:start;white-space:normal;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:0.8;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:%23000000;solid-opacity:1;fill:%23ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:2.66157866;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate' d='m 59.722656,99.9629 c -1.270084,0.039 -2.541493,0.3887 -3.701172,1.0625 -3.092475,1.7967 -4.650886,5.5402 -3.710937,9.0703 0.939949,3.5301 4.09768,5.9414 7.648437,5.9414 l 0,-3.0742 c -2.296214,0 -4.256717,-1.542 -4.830078,-3.6953 -0.573361,-2.1533 0.337432,-4.4056 2.308594,-5.5508 1.935731,-1.1246 4.38863,-0.8102 5.986326,0.7207 l -1.806638,1.9063 7.828128,1.9062 -2.32422,-7.7129 -1.62696,1.7168 c -1.26338,-1.2531 -2.848917,-2.0088 -4.505855,-2.2285 -0.418778,-0.055 -0.842263,-0.076 -1.265625,-0.062 z' id='path4138-1' /%3E %3Cpath inkscape:connector-curvature='0' style='opacity:0.8;fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:1.966;stroke-miterlimit:4;stroke-dasharray:none' d='m 10.5,100 0,2 -2.4999996,0 L 12,107 l 4,-5 -2.5,0 0,-2 -3,0 z' id='path3055-0-77' /%3E %3Cpath style='opacity:0.8;fill:none;stroke:%23ffffff;stroke-width:1.966;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' d='m 4.9850574,108.015 14.0298856,-0.03' id='path5244-5-0-5' inkscape:connector-curvature='0' sodipodi:nodetypes='cc' /%3E %3Cpath style='opacity:0.8;fill:none;stroke:%23ffffff;stroke-width:1.966;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' d='m 4.9849874,132.015 14.0298866,-0.03' id='path5244-5-0-5-8' inkscape:connector-curvature='0' sodipodi:nodetypes='cc' /%3E %3Cpath inkscape:connector-curvature='0' style='color:%23000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:%23000000;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;baseline-shift:baseline;text-anchor:start;white-space:normal;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:0.4;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:%23000000;solid-opacity:1;fill:%234d4d4d;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:2.66157866;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate' d='m 36.398438,123.9629 c -0.423362,-0.013 -0.846847,0.01 -1.265626,0.062 -1.656562,0.2196 -3.244567,0.9739 -4.507812,2.2266 L 29,124.5366 l -2.324219,7.7129 7.826172,-1.9062 -1.804687,-1.9063 c 1.597702,-1.5308 4.048706,-1.8453 5.984375,-0.7207 1.971162,1.1453 2.881954,3.3975 2.308593,5.5508 -0.573361,2.1533 -2.533864,3.6953 -4.830078,3.6953 l 0,3.0742 c 3.550757,0 6.710442,-2.4093 7.650391,-5.9394 0.939949,-3.5301 -0.618463,-7.2756 -3.710938,-9.0723 -1.159678,-0.6737 -2.431087,-1.0231 -3.701171,-1.0625 z' id='path4138-12' /%3E %3Cpath inkscape:connector-curvature='0' style='color:%23000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:%23000000;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;baseline-shift:baseline;text-anchor:start;white-space:normal;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:0.4;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:%23000000;solid-opacity:1;fill:%234d4d4d;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:2.66157866;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate' d='m 59.722656,123.9629 c -1.270084,0.039 -2.541493,0.3888 -3.701172,1.0625 -3.092475,1.7967 -4.650886,5.5422 -3.710937,9.0723 0.939949,3.5301 4.09768,5.9394 7.648437,5.9394 l 0,-3.0742 c -2.296214,0 -4.256717,-1.542 -4.830078,-3.6953 -0.573361,-2.1533 0.337432,-4.4055 2.308594,-5.5508 1.935731,-1.1246 4.38863,-0.8102 5.986326,0.7207 l -1.806638,1.9063 7.828128,1.9062 -2.32422,-7.7129 -1.62696,1.7168 c -1.26338,-1.2531 -2.848917,-2.0088 -4.505855,-2.2285 -0.418778,-0.055 -0.842263,-0.076 -1.265625,-0.062 z' id='path4138-1-3' /%3E %3Cpath id='path6191' d='m 10.5,116 0,-2 -2.4999996,0 L 12,109 l 4,5 -2.5,0 0,2 -3,0 z' style='opacity:0.8;fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:1.966;stroke-miterlimit:4;stroke-dasharray:none' inkscape:connector-curvature='0' /%3E %3Cpath inkscape:connector-curvature='0' style='opacity:0.8;fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:1.966;stroke-miterlimit:4;stroke-dasharray:none' d='m 10.5,129 0,-2 -2.4999996,0 L 12,122 l 4,5 -2.5,0 0,2 -3,0 z' id='path6193' /%3E %3Cpath id='path6195' d='m 10.5,135 0,2 -2.4999996,0 L 12,142 l 4,-5 -2.5,0 0,-2 -3,0 z' style='opacity:0.8;fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:1.966;stroke-miterlimit:4;stroke-dasharray:none' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:type='star' style='fill:%234d4d4d;fill-opacity:0.90196078;stroke:%23d3d3d3;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none' id='path4500' sodipodi:sides='3' sodipodi:cx='11.55581' sodipodi:cy='60.073242' sodipodi:r1='5.1116104' sodipodi:r2='2.5558052' sodipodi:arg1='0' sodipodi:arg2='1.0471976' inkscape:flatsided='false' inkscape:rounded='0' inkscape:randomized='0' d='m 16.66742,60.073242 -3.833708,2.213392 -3.8337072,2.213393 0,-4.426785 0,-4.426784 3.8337082,2.213392 z' inkscape:transform-center-x='-1.2779026' /%3E %3Cpath inkscape:transform-center-x='1.277902' d='m -31.500004,60.073242 -3.833708,2.213392 -3.833707,2.213393 0,-4.426785 0,-4.426784 3.833707,2.213392 z' inkscape:randomized='0' inkscape:rounded='0' inkscape:flatsided='false' sodipodi:arg2='1.0471976' sodipodi:arg1='0' sodipodi:r2='2.5558052' sodipodi:r1='5.1116104' sodipodi:cy='60.073242' sodipodi:cx='-36.611614' sodipodi:sides='3' id='path4502' style='fill:%234d4d4d;fill-opacity:0.90196078;stroke:%23d3d3d3;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none' sodipodi:type='star' transform='scale(-1,1)' /%3E %3Cpath d='m 16.66742,60.073212 -3.833708,2.213392 -3.8337072,2.213392 0,-4.426784 0,-4.426785 3.8337082,2.213392 z' inkscape:randomized='0' inkscape:rounded='0' inkscape:flatsided='false' sodipodi:arg2='1.0471976' sodipodi:arg1='0' sodipodi:r2='2.5558052' sodipodi:r1='5.1116104' sodipodi:cy='60.073212' sodipodi:cx='11.55581' sodipodi:sides='3' id='path4504' style='fill:%234d4d4d;fill-opacity:0.90196078;stroke:%23d3d3d3;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none' sodipodi:type='star' transform='matrix(0,1,-1,0,72.0074,71.7877)' inkscape:transform-center-y='1.2779029' /%3E %3Cpath inkscape:transform-center-y='-1.2779026' transform='matrix(0,-1,-1,0,96,96)' sodipodi:type='star' style='fill:%234d4d4d;fill-opacity:0.90196078;stroke:%23d3d3d3;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none' id='path4506' sodipodi:sides='3' sodipodi:cx='11.55581' sodipodi:cy='60.073212' sodipodi:r1='5.1116104' sodipodi:r2='2.5558052' sodipodi:arg1='0' sodipodi:arg2='1.0471976' inkscape:flatsided='false' inkscape:rounded='0' inkscape:randomized='0' d='m 16.66742,60.073212 -3.833708,2.213392 -3.8337072,2.213392 0,-4.426784 0,-4.426785 3.8337082,2.213392 z' /%3E %3Cpath sodipodi:nodetypes='cccc' inkscape:connector-curvature='0' id='path4615-5' d='m 171.82574,65.174193 16.34854,0 -8.17427,-13.348454 z' style='fill:%23fbb917;fill-opacity:1;fill-rule:evenodd;stroke:%23fbb917;stroke-width:1.65161395;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' /%3E %3Cpath style='opacity:1;fill:%23ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' d='m 179,55 0,6 2,0 0,-6' id='path4300' inkscape:connector-curvature='0' sodipodi:nodetypes='cccc' /%3E %3Cpath style='opacity:1;fill:%23ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' d='m 179,62 0,2 2,0 0,-2' id='path4300-6' inkscape:connector-curvature='0' sodipodi:nodetypes='cccc' /%3E %3C/svg%3E\"";
	},function(e,t,i){function n(e,t){for(var i=0;i<e.length;i++){var n=e[i],r=f[n.id];if(r){r.refs++;for(var o=0;o<r.parts.length;o++)r.parts[o](n.parts[o]);for(;o<n.parts.length;o++)r.parts.push(c(n.parts[o],t))}else{for(var s=[],o=0;o<n.parts.length;o++)s.push(c(n.parts[o],t));f[n.id]={id:n.id,refs:1,parts:s}}}}function r(e){for(var t=[],i={},n=0;n<e.length;n++){var r=e[n],o=r[0],s=r[1],a=r[2],l=r[3],c={css:s,media:a,sourceMap:l};i[o]?i[o].parts.push(c):t.push(i[o]={id:o,parts:[c]})}return t}function o(e,t){var i=g(),n=w[w.length-1];if("top"===e.insertAt)n?n.nextSibling?i.insertBefore(t,n.nextSibling):i.appendChild(t):i.insertBefore(t,i.firstChild),w.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");i.appendChild(t)}}function s(e){e.parentNode.removeChild(e);var t=w.indexOf(e);t>=0&&w.splice(t,1)}function a(e){var t=document.createElement("style");return t.type="text/css",o(e,t),t}function l(e){var t=document.createElement("link");return t.rel="stylesheet",o(e,t),t}function c(e,t){var i,n,r;if(t.singleton){var o=y++;i=v||(v=a(t)),n=h.bind(null,i,o,!1),r=h.bind(null,i,o,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(i=l(t),n=u.bind(null,i),r=function(){s(i),i.href&&URL.revokeObjectURL(i.href)}):(i=a(t),n=d.bind(null,i),r=function(){s(i)});return n(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;n(e=t)}else r()}}function h(e,t,i,n){var r=i?"":n.css;if(e.styleSheet)e.styleSheet.cssText=b(t,r);else{var o=document.createTextNode(r),s=e.childNodes;s[t]&&e.removeChild(s[t]),s.length?e.insertBefore(o,s[t]):e.appendChild(o)}}function d(e,t){var i=t.css,n=t.media;if(n&&e.setAttribute("media",n),e.styleSheet)e.styleSheet.cssText=i;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(i))}}function u(e,t){var i=t.css,n=t.sourceMap;n&&(i+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(n))))+" */");var r=new Blob([i],{type:"text/css"}),o=e.href;e.href=URL.createObjectURL(r),o&&URL.revokeObjectURL(o)}var f={},p=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},m=p(function(){return/msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase())}),g=p(function(){return document.head||document.getElementsByTagName("head")[0]}),v=null,y=0,w=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=m()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var i=r(e);return n(i,t),function(e){for(var o=[],s=0;s<i.length;s++){var a=i[s],l=f[a.id];l.refs--,o.push(l)}if(e){var c=r(e);n(c,t)}for(var s=0;s<o.length;s++){var l=o[s];if(0===l.refs){for(var h=0;h<l.parts.length;h++)l.parts[h]();delete f[l.id]}}}};var b=function(){var e=[];return function(t,i){return e[t]=i,e.filter(Boolean).join("\n")}}()}])});
	//# sourceMappingURL=angular-jsoneditor.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	/*! 
	 * angular-loading-bar v0.9.0
	 * https://chieffancypants.github.io/angular-loading-bar
	 * Copyright (c) 2016 Wes Cruver
	 * License: MIT
	 */
	/*
	 * angular-loading-bar
	 *
	 * intercepts XHR requests and creates a loading bar.
	 * Based on the excellent nprogress work by rstacruz (more info in readme)
	 *
	 * (c) 2013 Wes Cruver
	 * License: MIT
	 */
	
	
	(function() {
	
	'use strict';
	
	// Alias the loading bar for various backwards compatibilities since the project has matured:
	angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
	angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);
	
	
	/**
	 * loadingBarInterceptor service
	 *
	 * Registers itself as an Angular interceptor and listens for XHR requests.
	 */
	angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar'])
	  .config(['$httpProvider', function ($httpProvider) {
	
	    var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {
	
	      /**
	       * The total number of requests made
	       */
	      var reqsTotal = 0;
	
	      /**
	       * The number of requests completed (either successfully or not)
	       */
	      var reqsCompleted = 0;
	
	      /**
	       * The amount of time spent fetching before showing the loading bar
	       */
	      var latencyThreshold = cfpLoadingBar.latencyThreshold;
	
	      /**
	       * $timeout handle for latencyThreshold
	       */
	      var startTimeout;
	
	
	      /**
	       * calls cfpLoadingBar.complete() which removes the
	       * loading bar from the DOM.
	       */
	      function setComplete() {
	        $timeout.cancel(startTimeout);
	        cfpLoadingBar.complete();
	        reqsCompleted = 0;
	        reqsTotal = 0;
	      }
	
	      /**
	       * Determine if the response has already been cached
	       * @param  {Object}  config the config option from the request
	       * @return {Boolean} retrns true if cached, otherwise false
	       */
	      function isCached(config) {
	        var cache;
	        var defaultCache = $cacheFactory.get('$http');
	        var defaults = $httpProvider.defaults;
	
	        // Choose the proper cache source. Borrowed from angular: $http service
	        if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	            cache = angular.isObject(config.cache) ? config.cache
	              : angular.isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	        }
	
	        var cached = cache !== undefined ?
	          cache.get(config.url) !== undefined : false;
	
	        if (config.cached !== undefined && cached !== config.cached) {
	          return config.cached;
	        }
	        config.cached = cached;
	        return cached;
	      }
	
	
	      return {
	        'request': function(config) {
	          // Check to make sure this request hasn't already been cached and that
	          // the requester didn't explicitly ask us to ignore this request:
	          if (!config.ignoreLoadingBar && !isCached(config)) {
	            $rootScope.$broadcast('cfpLoadingBar:loading', {url: config.url});
	            if (reqsTotal === 0) {
	              startTimeout = $timeout(function() {
	                cfpLoadingBar.start();
	              }, latencyThreshold);
	            }
	            reqsTotal++;
	            cfpLoadingBar.set(reqsCompleted / reqsTotal);
	          }
	          return config;
	        },
	
	        'response': function(response) {
	          if (!response || !response.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return response;
	          }
	
	          if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
	            reqsCompleted++;
	            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: response.config.url, result: response});
	            if (reqsCompleted >= reqsTotal) {
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return response;
	        },
	
	        'responseError': function(rejection) {
	          if (!rejection || !rejection.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return $q.reject(rejection);
	          }
	
	          if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
	            reqsCompleted++;
	            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: rejection.config.url, result: rejection});
	            if (reqsCompleted >= reqsTotal) {
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return $q.reject(rejection);
	        }
	      };
	    }];
	
	    $httpProvider.interceptors.push(interceptor);
	  }]);
	
	
	/**
	 * Loading Bar
	 *
	 * This service handles adding and removing the actual element in the DOM.
	 * Generally, best practices for DOM manipulation is to take place in a
	 * directive, but because the element itself is injected in the DOM only upon
	 * XHR requests, and it's likely needed on every view, the best option is to
	 * use a service.
	 */
	angular.module('cfp.loadingBar', [])
	  .provider('cfpLoadingBar', function() {
	
	    this.autoIncrement = true;
	    this.includeSpinner = true;
	    this.includeBar = true;
	    this.latencyThreshold = 100;
	    this.startSize = 0.02;
	    this.parentSelector = 'body';
	    this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
	    this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';
	
	    this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
	      var $animate;
	      var $parentSelector = this.parentSelector,
	        loadingBarContainer = angular.element(this.loadingBarTemplate),
	        loadingBar = loadingBarContainer.find('div').eq(0),
	        spinner = angular.element(this.spinnerTemplate);
	
	      var incTimeout,
	        completeTimeout,
	        started = false,
	        status = 0;
	
	      var autoIncrement = this.autoIncrement;
	      var includeSpinner = this.includeSpinner;
	      var includeBar = this.includeBar;
	      var startSize = this.startSize;
	
	      /**
	       * Inserts the loading bar element into the dom, and sets it to 2%
	       */
	      function _start() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        $timeout.cancel(completeTimeout);
	
	        // do not continually broadcast the started event:
	        if (started) {
	          return;
	        }
	
	        var document = $document[0];
	        var parent = document.querySelector ?
	          document.querySelector($parentSelector)
	          : $document.find($parentSelector)[0]
	        ;
	
	        if (! parent) {
	          parent = document.getElementsByTagName('body')[0];
	        }
	
	        var $parent = angular.element(parent);
	        var $after = parent.lastChild && angular.element(parent.lastChild);
	
	        $rootScope.$broadcast('cfpLoadingBar:started');
	        started = true;
	
	        if (includeBar) {
	          $animate.enter(loadingBarContainer, $parent, $after);
	        }
	
	        if (includeSpinner) {
	          $animate.enter(spinner, $parent, loadingBarContainer);
	        }
	
	        _set(startSize);
	      }
	
	      /**
	       * Set the loading bar's width to a certain percent.
	       *
	       * @param n any value between 0 and 1
	       */
	      function _set(n) {
	        if (!started) {
	          return;
	        }
	        var pct = (n * 100) + '%';
	        loadingBar.css('width', pct);
	        status = n;
	
	        // increment loadingbar to give the illusion that there is always
	        // progress but make sure to cancel the previous timeouts so we don't
	        // have multiple incs running at the same time.
	        if (autoIncrement) {
	          $timeout.cancel(incTimeout);
	          incTimeout = $timeout(function() {
	            _inc();
	          }, 250);
	        }
	      }
	
	      /**
	       * Increments the loading bar by a random amount
	       * but slows down as it progresses
	       */
	      function _inc() {
	        if (_status() >= 1) {
	          return;
	        }
	
	        var rnd = 0;
	
	        // TODO: do this mathmatically instead of through conditions
	
	        var stat = _status();
	        if (stat >= 0 && stat < 0.25) {
	          // Start out between 3 - 6% increments
	          rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
	        } else if (stat >= 0.25 && stat < 0.65) {
	          // increment between 0 - 3%
	          rnd = (Math.random() * 3) / 100;
	        } else if (stat >= 0.65 && stat < 0.9) {
	          // increment between 0 - 2%
	          rnd = (Math.random() * 2) / 100;
	        } else if (stat >= 0.9 && stat < 0.99) {
	          // finally, increment it .5 %
	          rnd = 0.005;
	        } else {
	          // after 99%, don't increment:
	          rnd = 0;
	        }
	
	        var pct = _status() + rnd;
	        _set(pct);
	      }
	
	      function _status() {
	        return status;
	      }
	
	      function _completeAnimation() {
	        status = 0;
	        started = false;
	      }
	
	      function _complete() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        $rootScope.$broadcast('cfpLoadingBar:completed');
	        _set(1);
	
	        $timeout.cancel(completeTimeout);
	
	        // Attempt to aggregate any start/complete calls within 500ms:
	        completeTimeout = $timeout(function() {
	          var promise = $animate.leave(loadingBarContainer, _completeAnimation);
	          if (promise && promise.then) {
	            promise.then(_completeAnimation);
	          }
	          $animate.leave(spinner);
	        }, 500);
	      }
	
	      return {
	        start            : _start,
	        set              : _set,
	        status           : _status,
	        inc              : _inc,
	        complete         : _complete,
	        autoIncrement    : this.autoIncrement,
	        includeSpinner   : this.includeSpinner,
	        latencyThreshold : this.latencyThreshold,
	        parentSelector   : this.parentSelector,
	        startSize        : this.startSize
	      };
	
	
	    }];     //
	  });       // wtf javascript. srsly
	})();       //


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134);
	module.exports = 'angular-loading-bar';


/***/ }),
/* 136 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.2
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var forEach;
	var isArray;
	var isString;
	var jqLite;
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage`, `ngMessageExp` and `ngMessageDefault` directives.
	 *
	 * ## Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritize messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, AngularJS may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate See the ngAnimate docs} to learn how to use JavaScript animations or to learn
	 * more about ngAnimate.
	 *
	 * ## Displaying a default message
	 * If the ngMessages renders no inner ngMessage directive (i.e. when none of the truthy
	 * keys are matched by a defined message), then it will render a default message
	 * using the {@link ngMessageDefault} directive.
	 * Note that matched messages will always take precedence over unmatched messages. That means
	 * the default message will not be displayed when another message is matched. This is also
	 * true for `ng-messages-multiple`.
	 *
	 * ```html
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 *   <div ng-message-default>This field has an input error</div>
	 * </div>
	 * ```
	 *
	
	 */
	angular.module('ngMessages', [], function initAngularHelpers() {
	  // Access helpers from AngularJS core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isString = angular.isString;
	  jqLite = angular.element;
	})
	  .info({ angularVersion: '1.8.2' })
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used (With {@link ngMessagesInclude}) to promote message
	   * reusability and messages can also be overridden.
	   *
	   * A default message can also be displayed when no `ngMessage` directive is inserted, using the
	   * {@link ngMessageDefault} directive.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   *   <ANY ng-message-default>...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   *   <ng-message-default>...</ng-message-default>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an AngularJS expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *         <div ng-message-default>This field has an input error</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function(collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                         isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var truthyKeys = 0;
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function(value, key) {
	                if (truthy(value) && !messageUsed) {
	                  truthyKeys++;
	
	                  if (messageCtrl.test(key)) {
	                    // this is to prevent the same error name from showing up twice
	                    if (matchedKeys[key]) return;
	                    matchedKeys[key] = true;
	
	                    messageUsed = true;
	                    messageCtrl.attach();
	                  }
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function(messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          var messageMatched = unmatchedMessages.length !== totalMessages;
	          var attachDefault = ctrl.default && !messageMatched && truthyKeys > 0;
	
	          if (attachDefault) {
	            ctrl.default.attach();
	          } else if (ctrl.default) {
	            ctrl.default.detach();
	          }
	
	          if (messageMatched || attachDefault) {
	            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
	          } else {
	            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	          }
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        this.reRender = function() {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function() {
	              if (renderLater && cachedCollection) {
	                ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function(comment, messageCtrl, isDefault) {
	          if (isDefault) {
	            ctrl.default = messageCtrl;
	          } else {
	            var nextKey = latestKey.toString();
	            messages[nextKey] = {
	              message: messageCtrl
	            };
	            insertMessageNode($element[0], comment, nextKey);
	            comment.$$ngMessageNode = nextKey;
	            latestKey++;
	          }
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function(comment, isDefault) {
	          if (isDefault) {
	            delete ctrl.default;
	          } else {
	            var key = comment.$$ngMessageNode;
	            delete comment.$$ngMessageNode;
	            removeMessageNode($element[0], comment, key);
	            delete messages[key];
	          }
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          // This message node may have already been removed by a call to deregister()
	          if (!messageNode) return;
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	     return (isString(attr) && attr.length === 0) || //empty attribute
	            truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude',
	    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function(html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function(contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ?
	          $compile.$$createComment('ngMessagesInclude', src) :
	          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   * @priority 1
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
	   * value, it accepts an expression to be evaluated for the message key.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory())
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageDefault
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessageDefault` is a directive with the purpose to show and hide a default message for
	   * {@link directive:ngMessages}, when none of provided messages matches.
	   *
	   * More information about using `ngMessageDefault` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-default>...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message-default>...</ng-message-default>
	   * </ng-messages>
	   *
	  */
	  .directive('ngMessageDefault', ngMessageDirectiveFactory(true));
	
	function ngMessageDirectiveFactory(isDefault) {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode, records, staticExp, dynamicExp;
	
	        if (!isDefault) {
	          commentNode = element[0];
	          staticExp = attrs.ngMessage || attrs.when;
	          dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	
	          var assignRecords = function(items) {
	            records = items
	                ? (isArray(items)
	                      ? items
	                      : items.split(/[\s,]+/))
	                : null;
	            ngMessagesCtrl.reRender();
	          };
	
	          if (dynamicExp) {
	            assignRecords(scope.$eval(dynamicExp));
	            scope.$watchCollection(dynamicExp, assignRecords);
	          } else {
	            assignRecords(staticExp);
	          }
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(function(elm, newScope) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  // If the message element was removed via a call to `detach` then `currentElement` will be null
	                  // So this handler only handles cases where something else removed the message element.
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode, isDefault);
	                    messageCtrl.detach();
	                  }
	                  newScope.$destroy();
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        }, isDefault);
	
	        // We need to ensure that this directive deregisters itself when it no longer exists
	        // Normally this is done when the attached element is destroyed; but if this directive
	        // gets removed before we attach the message to the DOM there is nothing to watch
	        // in which case we must deregister when the containing scope is destroyed.
	        scope.$on('$destroy', function() {
	          ngMessagesCtrl.deregister(commentNode, isDefault);
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(136);
	module.exports = 'ngMessages';


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.2
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var $resourceMinErr = angular.$$minErr('$resource');
	
	// Helper functions and regex to lookup a dotted path on an object
	// stopping at undefined/null.  The path must be composed of ASCII
	// identifiers (just like $parse)
	var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;
	
	function isValidDottedPath(path) {
	  return (path != null && path !== '' && path !== 'hasOwnProperty' &&
	      MEMBER_NAME_REGEX.test('.' + path));
	}
	
	function lookupDottedPath(obj, path) {
	  if (!isValidDottedPath(path)) {
	    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
	  }
	  var keys = path.split('.');
	  for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
	    var key = keys[i];
	    obj = (obj !== null) ? obj[key] : undefined;
	  }
	  return obj;
	}
	
	/**
	 * Create a shallow copy of an object and clear other fields from the destination
	 */
	function shallowClearAndCopy(src, dst) {
	  dst = dst || {};
	
	  angular.forEach(dst, function(value, key) {
	    delete dst[key];
	  });
	
	  for (var key in src) {
	    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	      dst[key] = src[key];
	    }
	  }
	
	  return dst;
	}
	
	/**
	 * @ngdoc module
	 * @name ngResource
	 * @description
	 *
	 * The `ngResource` module provides interaction support with RESTful services
	 * via the $resource service.
	 *
	 * See {@link ngResource.$resourceProvider} and {@link ngResource.$resource} for usage.
	 */
	
	/**
	 * @ngdoc provider
	 * @name $resourceProvider
	 *
	 * @description
	 *
	 * Use `$resourceProvider` to change the default behavior of the {@link ngResource.$resource}
	 * service.
	 *
	 * ## Dependencies
	 * Requires the {@link ngResource } module to be installed.
	 *
	 */
	
	/**
	 * @ngdoc service
	 * @name $resource
	 * @requires $http
	 * @requires ng.$log
	 * @requires $q
	 * @requires ng.$timeout
	 *
	 * @description
	 * A factory which creates a resource object that lets you interact with
	 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
	 *
	 * The returned resource object has action methods which provide high-level behaviors without
	 * the need to interact with the low level {@link ng.$http $http} service.
	 *
	 * Requires the {@link ngResource `ngResource`} module to be installed.
	 *
	 * By default, trailing slashes will be stripped from the calculated URLs,
	 * which can pose problems with server backends that do not expect that
	 * behavior.  This can be disabled by configuring the `$resourceProvider` like
	 * this:
	 *
	 * ```js
	     app.config(['$resourceProvider', function($resourceProvider) {
	       // Don't strip trailing slashes from calculated URLs
	       $resourceProvider.defaults.stripTrailingSlashes = false;
	     }]);
	 * ```
	 *
	 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
	 *   `/user/:username`. If you are using a URL with a port number (e.g.
	 *   `http://example.com:8080/api`), it will be respected.
	 *
	 *   If you are using a url with a suffix, just add the suffix, like this:
	 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
	 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
	 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
	 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
	 *   can escape it with `/\.`.
	 *
	 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
	 *   `actions` methods. If a parameter value is a function, it will be called every time
	 *   a param value needs to be obtained for a request (unless the param was overridden). The
	 *   function will be passed the current data value as an argument.
	 *
	 *   Each key value in the parameter object is first bound to url template if present and then any
	 *   excess keys are appended to the url search query after the `?`.
	 *
	 *   Given a template `/path/:verb` and parameter `{verb: 'greet', salutation: 'Hello'}` results in
	 *   URL `/path/greet?salutation=Hello`.
	 *
	 *   If the parameter value is prefixed with `@`, then the value for that parameter will be
	 *   extracted from the corresponding property on the `data` object (provided when calling actions
	 *   with a request body).
	 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
	 *   `someParam` will be `data.someProp`.
	 *   Note that the parameter will be ignored, when calling a "GET" action method (i.e. an action
	 *   method that does not accept a request body).
	 *
	 * @param {Object.<Object>=} actions Hash with declaration of custom actions that will be available
	 *   in addition to the default set of resource actions (see below). If a custom action has the same
	 *   key as a default action (e.g. `save`), then the default action will be *overwritten*, and not
	 *   extended.
	 *
	 *   The declaration should be created in the format of {@link ng.$http#usage $http.config}:
	 *
	 *       {
	 *         action1: {method:?, params:?, isArray:?, headers:?, ...},
	 *         action2: {method:?, params:?, isArray:?, headers:?, ...},
	 *         ...
	 *       }
	 *
	 *   Where:
	 *
	 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
	 *     your resource object.
	 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
	 *     `DELETE`, `JSONP`, etc).
	 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
	 *     the parameter value is a function, it will be called every time when a param value needs to
	 *     be obtained for a request (unless the param was overridden). The function will be passed the
	 *     current data value as an argument.
	 *   - **`url`** – {string} – Action specific `url` override. The url templating is supported just
	 *     like for the resource-level urls.
	 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
	 *     see `returns` section.
	 *   - **`transformRequest`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     Transform function or an array of such functions. The transform function takes the http
	 *     request body and headers and returns its transformed (typically serialized) version.
	 *     By default, transformRequest will contain one function that checks if the request data is
	 *     an object and serializes it using `angular.toJson`. To prevent this behavior, set
	 *     `transformRequest` to an empty array: `transformRequest: []`
	 *   - **`transformResponse`** –
	 *     `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	 *     Transform function or an array of such functions. The transform function takes the HTTP
	 *     response body, headers and status and returns its transformed (typically deserialized)
	 *     version.
	 *     By default, transformResponse will contain one function that checks if the response looks
	 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
	 *     set `transformResponse` to an empty array: `transformResponse: []`
	 *   - **`cache`** – `{boolean|Cache}` – A boolean value or object created with
	 *     {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	 *     See {@link $http#caching $http Caching} for more information.
	 *   - **`timeout`** – `{number}` – Timeout in milliseconds.<br />
	 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
	 *     **not** supported in `$resource`, because the same value would be used for multiple requests.
	 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
	 *   - **`cancellable`** – `{boolean}` – If true, the request made by a "non-instance" call will be
	 *     cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
	 *     value. Calling `$cancelRequest()` for a non-cancellable or an already completed/cancelled
	 *     request will have no effect.
	 *   - **`withCredentials`** – `{boolean}` – Whether to set the `withCredentials` flag on the
	 *     XHR object. See
	 *     [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials)
	 *     for more information.
	 *   - **`responseType`** – `{string}` – See
	 *     [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseType).
	 *   - **`interceptor`** – `{Object=}` – The interceptor object has four optional methods -
	 *     `request`, `requestError`, `response`, and `responseError`. See
	 *     {@link ng.$http#interceptors $http interceptors} for details. Note that
	 *     `request`/`requestError` interceptors are applied before calling `$http`, thus before any
	 *     global `$http` interceptors. Also, rejecting or throwing an error inside the `request`
	 *     interceptor will result in calling the `responseError` interceptor.
	 *     The resource instance or collection is available on the `resource` property of the
	 *     `http response` object passed to `response`/`responseError` interceptors.
	 *     Keep in mind that the associated promise will be resolved with the value returned by the
	 *     response interceptors. Make sure you return an appropriate value and not the `response`
	 *     object passed as input. For reference, the default `response` interceptor (which gets applied
	 *     if you don't specify a custom one) returns `response.resource`.<br />
	 *     See {@link ngResource.$resource#using-interceptors below} for an example of using
	 *     interceptors in `$resource`.
	 *   - **`hasBody`** – `{boolean}` – If true, then the request will have a body.
	 *     If not specified, then only POST, PUT and PATCH requests will have a body. *
	 * @param {Object} options Hash with custom settings that should extend the
	 *   default `$resourceProvider` behavior.  The supported options are:
	 *
	 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
	 *   slashes from any calculated URL will be stripped. (Defaults to true.)
	 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
	 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
	 *   This can be overwritten per action. (Defaults to false.)
	 *
	 * @returns {Object} A resource "class" object with methods for the default set of resource actions
	 *   optionally extended with custom `actions`. The default set contains these actions:
	 *   ```js
	 *   {
	 *     'get':    {method: 'GET'},
	 *     'save':   {method: 'POST'},
	 *     'query':  {method: 'GET', isArray: true},
	 *     'remove': {method: 'DELETE'},
	 *     'delete': {method: 'DELETE'}
	 *   }
	 *   ```
	 *
	 *   Calling these methods invoke {@link ng.$http} with the specified http method, destination and
	 *   parameters. When the data is returned from the server then the object is an instance of the
	 *   resource class. The actions `save`, `remove` and `delete` are available on it as methods with
	 *   the `$` prefix. This allows you to easily perform CRUD operations (create, read, update,
	 *   delete) on server-side data like this:
	 *   ```js
	 *   var User = $resource('/user/:userId', {userId: '@id'});
	 *   User.get({userId: 123}).$promise.then(function(user) {
	 *     user.abc = true;
	 *     user.$save();
	 *   });
	 *   ```
	 *
	 *   It is important to realize that invoking a `$resource` object method immediately returns an
	 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
	 *   server the existing reference is populated with the actual data. This is a useful trick since
	 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
	 *   object results in no rendering, once the data arrives from the server then the object is
	 *   populated with the data and the view automatically re-renders itself showing the new data. This
	 *   means that in most cases one never has to write a callback function for the action methods.
	 *
	 *   The action methods on the class object or instance object can be invoked with the following
	 *   parameters:
	 *
	 *   - "class" actions without a body: `Resource.action([parameters], [success], [error])`
	 *   - "class" actions with a body: `Resource.action([parameters], postData, [success], [error])`
	 *   - instance actions: `instance.$action([parameters], [success], [error])`
	 *
	 *
	 *   When calling instance methods, the instance itself is used as the request body (if the action
	 *   should have a body). By default, only actions using `POST`, `PUT` or `PATCH` have request
	 *   bodies, but you can use the `hasBody` configuration option to specify whether an action
	 *   should have a body or not (regardless of its HTTP method).
	 *
	 *
	 *   Success callback is called with (value (Object|Array), responseHeaders (Function),
	 *   status (number), statusText (string)) arguments, where `value` is the populated resource
	 *   instance or collection object. The error callback is called with (httpResponse) argument.
	 *
	 *   Class actions return an empty instance (with the additional properties listed below).
	 *   Instance actions return a promise for the operation.
	 *
	 *   The Resource instances and collections have these additional properties:
	 *
	 *   - `$promise`: The {@link ng.$q promise} of the original server interaction that created this
	 *     instance or collection.
	 *
	 *     On success, the promise is resolved with the same resource instance or collection object,
	 *     updated with data from server. This makes it easy to use in the
	 *     {@link ngRoute.$routeProvider `resolve` section of `$routeProvider.when()`} to defer view
	 *     rendering until the resource(s) are loaded.
	 *
	 *     On failure, the promise is rejected with the {@link ng.$http http response} object.
	 *
	 *     If an interceptor object was provided, the promise will instead be resolved with the value
	 *     returned by the response interceptor (on success) or responceError interceptor (on failure).
	 *
	 *   - `$resolved`: `true` after first server interaction is completed (either with success or
	 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
	 *      data-binding. If there is a response/responseError interceptor and it returns a promise,
	 *      `$resolved` will wait for that too.
	 *
	 *   The Resource instances and collections have these additional methods:
	 *
	 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
	 *      collection, calling this method will abort the request.
	 *
	 *   The Resource instances have these additional methods:
	 *
	 *   - `toJSON`: It returns a simple object without any of the extra properties added as part of
	 *     the Resource API. This object can be serialized through {@link angular.toJson} safely
	 *     without attaching AngularJS-specific fields. Notice that `JSON.stringify` (and
	 *     `angular.toJson`) automatically use this method when serializing a Resource instance
	 *     (see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON%28%29_behavior)).
	 *
	 * @example
	 *
	 * ### Basic usage
	 *
	   ```js
	     // Define a CreditCard class
	     var CreditCard = $resource('/users/:userId/cards/:cardId',
	       {userId: 123, cardId: '@id'}, {
	         charge: {method: 'POST', params: {charge: true}}
	       });
	
	     // We can retrieve a collection from the server
	     var cards = CreditCard.query();
	         // GET: /users/123/cards
	         // server returns: [{id: 456, number: '1234', name: 'Smith'}]
	
	     // Wait for the request to complete
	     cards.$promise.then(function() {
	       var card = cards[0];
	
	       // Each item is an instance of CreditCard
	       expect(card instanceof CreditCard).toEqual(true);
	
	       // Non-GET methods are mapped onto the instances
	       card.name = 'J. Smith';
	       card.$save();
	           // POST: /users/123/cards/456 {id: 456, number: '1234', name: 'J. Smith'}
	           // server returns: {id: 456, number: '1234', name: 'J. Smith'}
	
	       // Our custom method is mapped as well (since it uses POST)
	       card.$charge({amount: 9.99});
	           // POST: /users/123/cards/456?amount=9.99&charge=true {id: 456, number: '1234', name: 'J. Smith'}
	     });
	
	     // We can create an instance as well
	     var newCard = new CreditCard({number: '0123'});
	     newCard.name = 'Mike Smith';
	
	     var savePromise = newCard.$save();
	         // POST: /users/123/cards {number: '0123', name: 'Mike Smith'}
	         // server returns: {id: 789, number: '0123', name: 'Mike Smith'}
	
	     savePromise.then(function() {
	       // Once the promise is resolved, the created instance
	       // is populated with the data returned by the server
	       expect(newCard.id).toEqual(789);
	     });
	   ```
	 *
	 * The object returned from a call to `$resource` is a resource "class" which has one "static"
	 * method for each action in the definition.
	 *
	 * Calling these methods invokes `$http` on the `url` template with the given HTTP `method`,
	 * `params` and `headers`.
	 *
	 * @example
	 *
	 * ### Accessing the response
	 *
	 * When the data is returned from the server then the object is an instance of the resource type and
	 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
	 * operations (create, read, update, delete) on server-side data.
	 *
	   ```js
	     var User = $resource('/users/:userId', {userId: '@id'});
	     User.get({userId: 123}).$promise.then(function(user) {
	       user.abc = true;
	       user.$save();
	     });
	   ```
	 *
	 * It's worth noting that the success callback for `get`, `query` and other methods gets called with
	 * the resource instance (populated with the data that came from the server) as well as an `$http`
	 * header getter function, the HTTP status code and the response status text. So one could rewrite
	 * the above example and get access to HTTP headers as follows:
	 *
	   ```js
	     var User = $resource('/users/:userId', {userId: '@id'});
	     User.get({userId: 123}, function(user, getResponseHeaders) {
	       user.abc = true;
	       user.$save(function(user, putResponseHeaders) {
	         // `user` => saved `User` object
	         // `putResponseHeaders` => `$http` header getter
	       });
	     });
	   ```
	 *
	 * @example
	 *
	 * ### Creating custom actions
	 *
	 * In this example we create a custom method on our resource to make a PUT request:
	 *
	   ```js
	      var app = angular.module('app', ['ngResource']);
	
	      // Some APIs expect a PUT request in the format URL/object/ID
	      // Here we are creating an 'update' method
	      app.factory('Notes', ['$resource', function($resource) {
	        return $resource('/notes/:id', {id: '@id'}, {
	          update: {method: 'PUT'}
	        });
	      }]);
	
	      // In our controller we get the ID from the URL using `$location`
	      app.controller('NotesCtrl', ['$location', 'Notes', function($location, Notes) {
	        // First, retrieve the corresponding `Note` object from the server
	        // (Assuming a URL of the form `.../notes?id=XYZ`)
	        var noteId = $location.search().id;
	        var note = Notes.get({id: noteId});
	
	        note.$promise.then(function() {
	          note.content = 'Hello, world!';
	
	          // Now call `update` to save the changes on the server
	          Notes.update(note);
	              // This will PUT /notes/ID with the note object as the request payload
	
	          // Since `update` is a non-GET method, it will also be available on the instance
	          // (prefixed with `$`), so we could replace the `Note.update()` call with:
	          //note.$update();
	        });
	      }]);
	   ```
	 *
	 * @example
	 *
	 * ### Cancelling requests
	 *
	 * If an action's configuration specifies that it is cancellable, you can cancel the request related
	 * to an instance or collection (as long as it is a result of a "non-instance" call):
	 *
	   ```js
	     // ...defining the `Hotel` resource...
	     var Hotel = $resource('/api/hotels/:id', {id: '@id'}, {
	       // Let's make the `query()` method cancellable
	       query: {method: 'get', isArray: true, cancellable: true}
	     });
	
	     // ...somewhere in the PlanVacationController...
	     ...
	     this.onDestinationChanged = function onDestinationChanged(destination) {
	       // We don't care about any pending request for hotels
	       // in a different destination any more
	       if (this.availableHotels) {
	         this.availableHotels.$cancelRequest();
	       }
	
	       // Let's query for hotels in `destination`
	       // (calls: /api/hotels?location=<destination>)
	       this.availableHotels = Hotel.query({location: destination});
	     };
	   ```
	 *
	 * @example
	 *
	 * ### Using interceptors
	 *
	 * You can use interceptors to transform the request or response, perform additional operations, and
	 * modify the returned instance/collection. The following example, uses `request` and `response`
	 * interceptors to augment the returned instance with additional info:
	 *
	   ```js
	     var Thing = $resource('/api/things/:id', {id: '@id'}, {
	       save: {
	         method: 'POST',
	         interceptor: {
	           request: function(config) {
	             // Before the request is sent out, store a timestamp on the request config
	             config.requestTimestamp = Date.now();
	             return config;
	           },
	           response: function(response) {
	             // Get the instance from the response object
	             var instance = response.resource;
	
	             // Augment the instance with a custom `saveLatency` property, computed as the time
	             // between sending the request and receiving the response.
	             instance.saveLatency = Date.now() - response.config.requestTimestamp;
	
	             // Return the instance
	             return instance;
	           }
	         }
	       }
	     });
	
	     Thing.save({foo: 'bar'}).$promise.then(function(thing) {
	       console.log('That thing was saved in ' + thing.saveLatency + 'ms.');
	     });
	   ```
	 *
	 */
	angular.module('ngResource', ['ng']).
	  info({ angularVersion: '1.8.2' }).
	  provider('$resource', function ResourceProvider() {
	    var PROTOCOL_AND_IPV6_REGEX = /^https?:\/\/\[[^\]]*][^/]*/;
	
	    var provider = this;
	
	    /**
	     * @ngdoc property
	     * @name $resourceProvider#defaults
	     * @description
	     * Object containing default options used when creating `$resource` instances.
	     *
	     * The default values satisfy a wide range of usecases, but you may choose to overwrite any of
	     * them to further customize your instances. The available properties are:
	     *
	     * - **stripTrailingSlashes** – `{boolean}` – If true, then the trailing slashes from any
	     *   calculated URL will be stripped.<br />
	     *   (Defaults to true.)
	     * - **cancellable** – `{boolean}` – If true, the request made by a "non-instance" call will be
	     *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
	     *   value. For more details, see {@link ngResource.$resource}. This can be overwritten per
	     *   resource class or action.<br />
	     *   (Defaults to false.)
	     * - **actions** - `{Object.<Object>}` - A hash with default actions declarations. Actions are
	     *   high-level methods corresponding to RESTful actions/methods on resources. An action may
	     *   specify what HTTP method to use, what URL to hit, if the return value will be a single
	     *   object or a collection (array) of objects etc. For more details, see
	     *   {@link ngResource.$resource}. The actions can also be enhanced or overwritten per resource
	     *   class.<br />
	     *   The default actions are:
	     *   ```js
	     *   {
	     *     get: {method: 'GET'},
	     *     save: {method: 'POST'},
	     *     query: {method: 'GET', isArray: true},
	     *     remove: {method: 'DELETE'},
	     *     delete: {method: 'DELETE'}
	     *   }
	     *   ```
	     *
	     * #### Example
	     *
	     * For example, you can specify a new `update` action that uses the `PUT` HTTP verb:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['$resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions.update = {
	     *         method: 'PUT'
	     *       };
	     *     }]);
	     * ```
	     *
	     * Or you can even overwrite the whole `actions` list and specify your own:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['$resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions = {
	     *         create: {method: 'POST'},
	     *         get:    {method: 'GET'},
	     *         getAll: {method: 'GET', isArray:true},
	     *         update: {method: 'PUT'},
	     *         delete: {method: 'DELETE'}
	     *       };
	     *     });
	     * ```
	     *
	     */
	    this.defaults = {
	      // Strip slashes by default
	      stripTrailingSlashes: true,
	
	      // Make non-instance requests cancellable (via `$cancelRequest()`)
	      cancellable: false,
	
	      // Default actions configuration
	      actions: {
	        'get': {method: 'GET'},
	        'save': {method: 'POST'},
	        'query': {method: 'GET', isArray: true},
	        'remove': {method: 'DELETE'},
	        'delete': {method: 'DELETE'}
	      }
	    };
	
	    this.$get = ['$http', '$log', '$q', '$timeout', function($http, $log, $q, $timeout) {
	
	      var noop = angular.noop,
	          forEach = angular.forEach,
	          extend = angular.extend,
	          copy = angular.copy,
	          isArray = angular.isArray,
	          isDefined = angular.isDefined,
	          isFunction = angular.isFunction,
	          isNumber = angular.isNumber,
	          encodeUriQuery = angular.$$encodeUriQuery,
	          encodeUriSegment = angular.$$encodeUriSegment;
	
	      function Route(template, defaults) {
	        this.template = template;
	        this.defaults = extend({}, provider.defaults, defaults);
	        this.urlParams = {};
	      }
	
	      Route.prototype = {
	        setUrlParams: function(config, params, actionUrl) {
	          var self = this,
	            url = actionUrl || self.template,
	            val,
	            encodedVal,
	            protocolAndIpv6 = '';
	
	          var urlParams = self.urlParams = Object.create(null);
	          forEach(url.split(/\W/), function(param) {
	            if (param === 'hasOwnProperty') {
	              throw $resourceMinErr('badname', 'hasOwnProperty is not a valid parameter name.');
	            }
	            if (!(new RegExp('^\\d+$').test(param)) && param &&
	              (new RegExp('(^|[^\\\\]):' + param + '(\\W|$)').test(url))) {
	              urlParams[param] = {
	                isQueryParamValue: (new RegExp('\\?.*=:' + param + '(?:\\W|$)')).test(url)
	              };
	            }
	          });
	          url = url.replace(/\\:/g, ':');
	          url = url.replace(PROTOCOL_AND_IPV6_REGEX, function(match) {
	            protocolAndIpv6 = match;
	            return '';
	          });
	
	          params = params || {};
	          forEach(self.urlParams, function(paramInfo, urlParam) {
	            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
	            if (isDefined(val) && val !== null) {
	              if (paramInfo.isQueryParamValue) {
	                encodedVal = encodeUriQuery(val, true);
	              } else {
	                encodedVal = encodeUriSegment(val);
	              }
	              url = url.replace(new RegExp(':' + urlParam + '(\\W|$)', 'g'), function(match, p1) {
	                return encodedVal + p1;
	              });
	            } else {
	              url = url.replace(new RegExp('(/?):' + urlParam + '(\\W|$)', 'g'), function(match,
	                  leadingSlashes, tail) {
	                if (tail.charAt(0) === '/') {
	                  return tail;
	                } else {
	                  return leadingSlashes + tail;
	                }
	              });
	            }
	          });
	
	          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
	          if (self.defaults.stripTrailingSlashes) {
	            url = url.replace(/\/+$/, '') || '/';
	          }
	
	          // Collapse `/.` if found in the last URL path segment before the query.
	          // E.g. `http://url.com/id/.format?q=x` becomes `http://url.com/id.format?q=x`.
	          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
	          // Replace escaped `/\.` with `/.`.
	          // (If `\.` comes from a param value, it will be encoded as `%5C.`.)
	          config.url = protocolAndIpv6 + url.replace(/\/(\\|%5C)\./, '/.');
	
	
	          // set params - delegate param encoding to $http
	          forEach(params, function(value, key) {
	            if (!self.urlParams[key]) {
	              config.params = config.params || {};
	              config.params[key] = value;
	            }
	          });
	        }
	      };
	
	
	      function resourceFactory(url, paramDefaults, actions, options) {
	        var route = new Route(url, options);
	
	        actions = extend({}, provider.defaults.actions, actions);
	
	        function extractParams(data, actionParams) {
	          var ids = {};
	          actionParams = extend({}, paramDefaults, actionParams);
	          forEach(actionParams, function(value, key) {
	            if (isFunction(value)) { value = value(data); }
	            ids[key] = value && value.charAt && value.charAt(0) === '@' ?
	              lookupDottedPath(data, value.substr(1)) : value;
	          });
	          return ids;
	        }
	
	        function defaultResponseInterceptor(response) {
	          return response.resource;
	        }
	
	        function Resource(value) {
	          shallowClearAndCopy(value || {}, this);
	        }
	
	        Resource.prototype.toJSON = function() {
	          var data = extend({}, this);
	          delete data.$promise;
	          delete data.$resolved;
	          delete data.$cancelRequest;
	          return data;
	        };
	
	        forEach(actions, function(action, name) {
	          var hasBody = action.hasBody === true || (action.hasBody !== false && /^(POST|PUT|PATCH)$/i.test(action.method));
	          var numericTimeout = action.timeout;
	          var cancellable = isDefined(action.cancellable) ?
	              action.cancellable : route.defaults.cancellable;
	
	          if (numericTimeout && !isNumber(numericTimeout)) {
	            $log.debug('ngResource:\n' +
	                       '  Only numeric values are allowed as `timeout`.\n' +
	                       '  Promises are not supported in $resource, because the same value would ' +
	                       'be used for multiple requests. If you are looking for a way to cancel ' +
	                       'requests, you should use the `cancellable` option.');
	            delete action.timeout;
	            numericTimeout = null;
	          }
	
	          Resource[name] = function(a1, a2, a3, a4) {
	            var params = {}, data, onSuccess, onError;
	
	            switch (arguments.length) {
	              case 4:
	                onError = a4;
	                onSuccess = a3;
	                // falls through
	              case 3:
	              case 2:
	                if (isFunction(a2)) {
	                  if (isFunction(a1)) {
	                    onSuccess = a1;
	                    onError = a2;
	                    break;
	                  }
	
	                  onSuccess = a2;
	                  onError = a3;
	                  // falls through
	                } else {
	                  params = a1;
	                  data = a2;
	                  onSuccess = a3;
	                  break;
	                }
	                // falls through
	              case 1:
	                if (isFunction(a1)) onSuccess = a1;
	                else if (hasBody) data = a1;
	                else params = a1;
	                break;
	              case 0: break;
	              default:
	                throw $resourceMinErr('badargs',
	                  'Expected up to 4 arguments [params, data, success, error], got {0} arguments',
	                  arguments.length);
	            }
	
	            var isInstanceCall = this instanceof Resource;
	            var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
	            var httpConfig = {};
	            var requestInterceptor = action.interceptor && action.interceptor.request || undefined;
	            var requestErrorInterceptor = action.interceptor && action.interceptor.requestError ||
	              undefined;
	            var responseInterceptor = action.interceptor && action.interceptor.response ||
	              defaultResponseInterceptor;
	            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
	              $q.reject;
	            var successCallback = onSuccess ? function(val) {
	              onSuccess(val, response.headers, response.status, response.statusText);
	            } : undefined;
	            var errorCallback = onError || undefined;
	            var timeoutDeferred;
	            var numericTimeoutPromise;
	            var response;
	
	            forEach(action, function(value, key) {
	              switch (key) {
	                default:
	                  httpConfig[key] = copy(value);
	                  break;
	                case 'params':
	                case 'isArray':
	                case 'interceptor':
	                case 'cancellable':
	                  break;
	              }
	            });
	
	            if (!isInstanceCall && cancellable) {
	              timeoutDeferred = $q.defer();
	              httpConfig.timeout = timeoutDeferred.promise;
	
	              if (numericTimeout) {
	                numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
	              }
	            }
	
	            if (hasBody) httpConfig.data = data;
	            route.setUrlParams(httpConfig,
	              extend({}, extractParams(data, action.params || {}), params),
	              action.url);
	
	            // Start the promise chain
	            var promise = $q.
	              resolve(httpConfig).
	              then(requestInterceptor).
	              catch(requestErrorInterceptor).
	              then($http);
	
	            promise = promise.then(function(resp) {
	              var data = resp.data;
	
	              if (data) {
	                // Need to convert action.isArray to boolean in case it is undefined
	                if (isArray(data) !== (!!action.isArray)) {
	                  throw $resourceMinErr('badcfg',
	                      'Error in resource configuration for action `{0}`. Expected response to ' +
	                      'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object',
	                    isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
	                }
	                if (action.isArray) {
	                  value.length = 0;
	                  forEach(data, function(item) {
	                    if (typeof item === 'object') {
	                      value.push(new Resource(item));
	                    } else {
	                      // Valid JSON values may be string literals, and these should not be converted
	                      // into objects. These items will not have access to the Resource prototype
	                      // methods, but unfortunately there
	                      value.push(item);
	                    }
	                  });
	                } else {
	                  var promise = value.$promise;     // Save the promise
	                  shallowClearAndCopy(data, value);
	                  value.$promise = promise;         // Restore the promise
	                }
	              }
	
	              resp.resource = value;
	              response = resp;
	              return responseInterceptor(resp);
	            }, function(rejectionOrResponse) {
	              rejectionOrResponse.resource = value;
	              response = rejectionOrResponse;
	              return responseErrorInterceptor(rejectionOrResponse);
	            });
	
	            promise = promise['finally'](function() {
	              value.$resolved = true;
	              if (!isInstanceCall && cancellable) {
	                value.$cancelRequest = noop;
	                $timeout.cancel(numericTimeoutPromise);
	                timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
	              }
	            });
	
	            // Run the `success`/`error` callbacks, but do not let them affect the returned promise.
	            promise.then(successCallback, errorCallback);
	
	            if (!isInstanceCall) {
	              // we are creating instance / collection
	              // - set the initial promise
	              // - return the instance / collection
	              value.$promise = promise;
	              value.$resolved = false;
	              if (cancellable) value.$cancelRequest = cancelRequest;
	
	              return value;
	            }
	
	            // instance call
	            return promise;
	
	            function cancelRequest(value) {
	              promise.catch(noop);
	              if (timeoutDeferred !== null) {
	                timeoutDeferred.resolve(value);
	              }
	            }
	          };
	
	
	          Resource.prototype['$' + name] = function(params, success, error) {
	            if (isFunction(params)) {
	              error = success; success = params; params = {};
	            }
	            var result = Resource[name].call(this, params, this, success, error);
	            return result.$promise || result;
	          };
	        });
	
	        return Resource;
	      }
	
	      return resourceFactory;
	    }];
	  });
	
	
	})(window, window.angular);


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(138);
	module.exports = 'ngResource';


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.2
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var lowercase;
	var noop;
	var nodeContains;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a trusted URI list) are
	 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The trusted URIs for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationTrustedUrlList` and `imgSrcSanitizationTrustedUrlList` of {@link $compileProvider}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var hasBeenInstantiated = false;
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    hasBeenInstantiated = true;
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidElements
	   * @kind function
	   *
	   * @description
	   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
	   * and are not stripped off during sanitization. You can extend the following lists of elements:
	   *
	   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
	   *   elements. HTML elements considered safe will not be removed during sanitization. All other
	   *   elements will be stripped off.
	   *
	   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
	   *   "void elements" (similar to HTML
	   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
	   *   elements have no end tag and cannot have content.
	   *
	   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
	   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
	   *   `$sanitize`.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the elements you add.
	   * </div>
	   *
	   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
	   *   more of the following properties:
	   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     HTML elements.
	   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     void HTML elements; i.e. elements that do not have an end tag.
	   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
	   *     elements. The list of SVG elements is only taken into account if SVG is
	   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
	   *
	   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
	   *
	   * @return {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidElements = function(elements) {
	    if (!hasBeenInstantiated) {
	      if (isArray(elements)) {
	        elements = {htmlElements: elements};
	      }
	
	      addElementsTo(svgElements, elements.svgElements);
	      addElementsTo(voidElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlElements);
	    }
	
	    return this;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidAttrs
	   * @kind function
	   *
	   * @description
	   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
	   * not stripped off during sanitization.
	   *
	   * **Note**:
	   * The new attributes will not be treated as URI attributes, which means their values will not be
	   * sanitized as URIs using `$compileProvider`'s
	   * {@link ng.$compileProvider#aHrefSanitizationTrustedUrlList aHrefSanitizationTrustedUrlList} and
	   * {@link ng.$compileProvider#imgSrcSanitizationTrustedUrlList imgSrcSanitizationTrustedUrlList}.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the attributes you add.
	   * </div>
	   *
	   * @param {Array<String>} attrs - A list of valid attributes.
	   *
	   * @returns {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidAttrs = function(attrs) {
	    if (!hasBeenInstantiated) {
	      extend(validAttrs, arrayToMap(attrs, true));
	    }
	    return this;
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isDefined = angular.isDefined;
	  lowercase = angular.$$lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
	    // eslint-disable-next-line no-bitwise
	    return !!(this.compareDocumentPosition(arg) & 16);
	  };
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = stringToMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = stringToMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = stringToMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');
	
	  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function stringToMap(str, lowercaseKeys) {
	    return arrayToMap(str.split(','), lowercaseKeys);
	  }
	
	  function arrayToMap(items, lowercaseKeys) {
	    var obj = {}, i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  function addElementsTo(elementsMap, newElements) {
	    if (newElements && newElements.length) {
	      extend(elementsMap, arrayToMap(newElements));
	    }
	  }
	
	  /**
	   * Create an inert document that contains the dirty HTML that needs sanitizing.
	   * We use the DOMParser API by default and fall back to createHTMLDocument if DOMParser is not
	   * available.
	   */
	  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
	    if (isDOMParserAvailable()) {
	      return getInertBodyElement_DOMParser;
	    }
	
	    if (!document || !document.implementation) {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var inertDocument = document.implementation.createHTMLDocument('inert');
	    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');
	    return getInertBodyElement_InertDocument;
	
	    function isDOMParserAvailable() {
	      try {
	        return !!getInertBodyElement_DOMParser('');
	      } catch (e) {
	        return false;
	      }
	    }
	
	    function getInertBodyElement_DOMParser(html) {
	      // We add this dummy element to ensure that the rest of the content is parsed as expected
	      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
	      html = '<remove></remove>' + html;
	      try {
	        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
	        body.firstChild.remove();
	        return body;
	      } catch (e) {
	        return undefined;
	      }
	    }
	
	    function getInertBodyElement_InertDocument(html) {
	      inertBodyElement.innerHTML = html;
	
	      // Support: IE 9-11 only
	      // strip custom-namespaced attributes on IE<=11
	      if (document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	
	      return inertBodyElement;
	    }
	  })(window, window.document);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	
	    var inertBodyElement = getInertBodyElement(html);
	    if (!inertBodyElement) return '';
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // trigger mXSS if it is going to happen by reading and writing the innerHTML
	      html = inertBodyElement.innerHTML;
	      inertBodyElement = getInertBodyElement(html);
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = getNonDescendant('nextSibling', node);
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = getNonDescendant('parentNode', node);
	            if (node === inertBodyElement) break;
	            nextNode = getNonDescendant('nextSibling', node);
	            if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = getNonDescendant('nextSibling', node);
	    }
	  }
	
	  function getNonDescendant(propName, node) {
	    // An element is clobbered if its `propName` property points to one of its descendants
	    var nextNode = node[propName];
	    if (nextNode && nodeContains.call(node, nextNode)) {
	      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
	    }
	    return nextNode;
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', [])
	  .provider('$sanitize', $SanitizeProvider)
	  .info({ angularVersion: '1.8.2' });
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(140);
	module.exports = 'ngSanitize';


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	'use strict';
	angular.module('angular-timeline', []);// Source: src/timeline-badge-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-badge
	 * @restrict AE
	 *
	 * @description
	 * Shown in the centre pane (or left on narrow devices) to indicate the activity.
	 */
	angular.module('angular-timeline').directive('timelineBadge', function() {
	  return {
	    require: '^timelineEvent',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-badge" ng-transclude></div>'
	  };
	});
	
	// Source: src/timeline-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline
	 * @restrict AE
	 *
	 * @description
	 * Primary container for displaying a vertical set of timeline events.
	 */
	angular.module('angular-timeline').directive('timeline', function() {
	  return {
	    restrict: 'AE',
	    transclude: true,
	    template: '<ul class="timeline" ng-transclude></ul>',
	    controller: function() {}
	  };
	});
	
	// Source: src/timeline-event-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline
	 * @restrict AE
	 *
	 * @description
	 * Represents an event occuring at a point in time, displayed on the left or the right
	 * of the timeline line.
	 *
	 * You typically embed a `timeline-badge` and `timeline-panel` element within a `timeline-event`.
	 *
	 * @param {string=} side  Define the side of the element (i.e. side="left", side="right", or use an {{ expression }}).
	 */
	
	angular.module('angular-timeline').directive('timelineEvent', function() {
	  return {
	    require: '^timeline',
	    restrict: 'AE',
	    transclude: true,
	    template: '<li class="timeline-event" ng-class-odd="oddClass" ng-class-even="evenClass" ng-transclude></li>',
	    link: function(scope, element, attrs, controller) {
	
	      var checkClass = function(side, leftSide) {
	
	        var leftClass = '';
	        var rightClass = 'timeline-inverted';
	
	        if (side === 'left' || (!side && leftSide === true)) {
	          return leftClass;
	        }
	        else if ((side === 'alternate' || !side) && leftSide === false) {
	          return rightClass;
	        }
	        else if (side === 'right') {
	          return rightClass;
	        }
	        else {
	          return leftClass;
	        }
	      };
	
	      var updateRowClasses = function(value) {
	        scope.oddClass = checkClass(value, true);
	        scope.evenClass = checkClass(value, false);
	      };
	
	      attrs.$observe('side', function(newValue) {
	        updateRowClasses(newValue);
	      });
	
	      updateRowClasses(attrs.side);
	    }
	  };
	});
	
	// Source: src/timeline-footer-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-footer
	 * @restrict AE
	 *
	 * @description
	 * Optional element to add a footer section to the `timeline-panel` for links or other actions.
	 */
	angular.module('angular-timeline').directive('timelineFooter', function() {
	  return {
	    require: '^timelinePanel',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-footer" ng-transclude></div>'
	  };
	});
	
	// Source: src/timeline-heading-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-heading
	 * @restrict AE
	 *
	 * @description
	 * Optional element to show the heading for a `timeline-panel`.
	 */
	angular.module('angular-timeline').directive('timelineHeading', function() {
	  return {
	    require: '^timelinePanel',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-heading" ng-transclude></div>'
	  };
	});
	
	// Source: src/timeline-panel-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-panel
	 * @restrict AE
	 *
	 * @description
	 * An panel inside the `timeline-event` which shows detailed information about the event.
	 */
	angular.module('angular-timeline').directive('timelinePanel', function() {
	  return {
	    require: '^timeline',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-panel" ng-transclude></div>'
	  };
	});


/***/ }),
/* 143 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	
	  angular.module('toastr', [])
	    .factory('toastr', toastr);
	
	  toastr.$inject = ['$animate', '$injector', '$document', '$rootScope', '$sce', 'toastrConfig', '$q'];
	
	  function toastr($animate, $injector, $document, $rootScope, $sce, toastrConfig, $q) {
	    var container;
	    var index = 0;
	    var toasts = [];
	
	    var previousToastMessage = '';
	    var openToasts = {};
	
	    var containerDefer = $q.defer();
	
	    var toast = {
	      active: active,
	      clear: clear,
	      error: error,
	      info: info,
	      remove: remove,
	      success: success,
	      warning: warning,
	      refreshTimer: refreshTimer
	    };
	
	    return toast;
	
	    /* Public API */
	    function active() {
	      return toasts.length;
	    }
	
	    function clear(toast) {
	      // Bit of a hack, I will remove this soon with a BC
	      if (arguments.length === 1 && !toast) { return; }
	
	      if (toast) {
	        remove(toast.toastId);
	      } else {
	        for (var i = 0; i < toasts.length; i++) {
	          remove(toasts[i].toastId);
	        }
	      }
	    }
	
	    function error(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.error;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function info(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.info;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function success(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.success;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function warning(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.warning;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function refreshTimer(toast, newTime) {
	      if (toast && toast.isOpened && toasts.indexOf(toast) >= 0) {
	          toast.scope.refreshTimer(newTime);
	      }
	    }
	
	    function remove(toastId, wasClicked) {
	      var toast = findToast(toastId);
	
	      if (toast && ! toast.deleting) { // Avoid clicking when fading out
	        toast.deleting = true;
	        toast.isOpened = false;
	        $animate.leave(toast.el).then(function() {
	          if (toast.scope.options.onHidden) {
	            toast.scope.options.onHidden(!!wasClicked, toast);
	          }
	          toast.scope.$destroy();
	          var index = toasts.indexOf(toast);
	          delete openToasts[toast.scope.message];
	          toasts.splice(index, 1);
	          var maxOpened = toastrConfig.maxOpened;
	          if (maxOpened && toasts.length >= maxOpened) {
	            toasts[maxOpened - 1].open.resolve();
	          }
	          if (lastToast()) {
	            container.remove();
	            container = null;
	            containerDefer = $q.defer();
	          }
	        });
	      }
	
	      function findToast(toastId) {
	        for (var i = 0; i < toasts.length; i++) {
	          if (toasts[i].toastId === toastId) {
	            return toasts[i];
	          }
	        }
	      }
	
	      function lastToast() {
	        return !toasts.length;
	      }
	    }
	
	    /* Internal functions */
	    function _buildNotification(type, message, title, optionsOverride) {
	      if (angular.isObject(title)) {
	        optionsOverride = title;
	        title = null;
	      }
	
	      return _notify({
	        iconClass: type,
	        message: message,
	        optionsOverride: optionsOverride,
	        title: title
	      });
	    }
	
	    function _getOptions() {
	      return angular.extend({}, toastrConfig);
	    }
	
	    function _createOrGetContainer(options) {
	      if(container) { return containerDefer.promise; }
	
	      container = angular.element('<div></div>');
	      container.attr('id', options.containerId);
	      container.addClass(options.positionClass);
	      container.css({'pointer-events': 'auto'});
	
	      var target = angular.element(document.querySelector(options.target));
	
	      if ( ! target || ! target.length) {
	        throw 'Target for toasts doesn\'t exist';
	      }
	
	      $animate.enter(container, target).then(function() {
	        containerDefer.resolve();
	      });
	
	      return containerDefer.promise;
	    }
	
	    function _notify(map) {
	      var options = _getOptions();
	
	      if (shouldExit()) { return; }
	
	      var newToast = createToast();
	
	      toasts.push(newToast);
	
	      if (ifMaxOpenedAndAutoDismiss()) {
	        var oldToasts = toasts.slice(0, (toasts.length - options.maxOpened));
	        for (var i = 0, len = oldToasts.length; i < len; i++) {
	          remove(oldToasts[i].toastId);
	        }
	      }
	
	      if (maxOpenedNotReached()) {
	        newToast.open.resolve();
	      }
	
	      newToast.open.promise.then(function() {
	        _createOrGetContainer(options).then(function() {
	          newToast.isOpened = true;
	          if (options.newestOnTop) {
	            $animate.enter(newToast.el, container).then(function() {
	              newToast.scope.init();
	            });
	          } else {
	            var sibling = container[0].lastChild ? angular.element(container[0].lastChild) : null;
	            $animate.enter(newToast.el, container, sibling).then(function() {
	              newToast.scope.init();
	            });
	          }
	        });
	      });
	
	      return newToast;
	
	      function ifMaxOpenedAndAutoDismiss() {
	        return options.autoDismiss && options.maxOpened && toasts.length > options.maxOpened;
	      }
	
	      function createScope(toast, map, options) {
	        if (options.allowHtml) {
	          toast.scope.allowHtml = true;
	          toast.scope.title = $sce.trustAsHtml(map.title);
	          toast.scope.message = $sce.trustAsHtml(map.message);
	        } else {
	          toast.scope.title = map.title;
	          toast.scope.message = map.message;
	        }
	
	        toast.scope.toastType = toast.iconClass;
	        toast.scope.toastId = toast.toastId;
	        toast.scope.extraData = options.extraData;
	
	        toast.scope.options = {
	          extendedTimeOut: options.extendedTimeOut,
	          messageClass: options.messageClass,
	          onHidden: options.onHidden,
	          onShown: generateEvent('onShown'),
	          onTap: generateEvent('onTap'),
	          progressBar: options.progressBar,
	          tapToDismiss: options.tapToDismiss,
	          timeOut: options.timeOut,
	          titleClass: options.titleClass,
	          toastClass: options.toastClass
	        };
	
	        if (options.closeButton) {
	          toast.scope.options.closeHtml = options.closeHtml;
	        }
	
	        function generateEvent(event) {
	          if (options[event]) {
	            return function() {
	              options[event](toast);
	            };
	          }
	        }
	      }
	
	      function createToast() {
	        var newToast = {
	          toastId: index++,
	          isOpened: false,
	          scope: $rootScope.$new(),
	          open: $q.defer()
	        };
	        newToast.iconClass = map.iconClass;
	        if (map.optionsOverride) {
	          angular.extend(options, cleanOptionsOverride(map.optionsOverride));
	          newToast.iconClass = map.optionsOverride.iconClass || newToast.iconClass;
	        }
	
	        createScope(newToast, map, options);
	
	        newToast.el = createToastEl(newToast.scope);
	
	        return newToast;
	
	        function cleanOptionsOverride(options) {
	          var badOptions = ['containerId', 'iconClasses', 'maxOpened', 'newestOnTop',
	                            'positionClass', 'preventDuplicates', 'preventOpenDuplicates', 'templates'];
	          for (var i = 0, l = badOptions.length; i < l; i++) {
	            delete options[badOptions[i]];
	          }
	
	          return options;
	        }
	      }
	
	      function createToastEl(scope) {
	        var angularDomEl = angular.element('<div toast></div>'),
	          $compile = $injector.get('$compile');
	        return $compile(angularDomEl)(scope);
	      }
	
	      function maxOpenedNotReached() {
	        return options.maxOpened && toasts.length <= options.maxOpened || !options.maxOpened;
	      }
	
	      function shouldExit() {
	        var isDuplicateOfLast = options.preventDuplicates && map.message === previousToastMessage;
	        var isDuplicateOpen = options.preventOpenDuplicates && openToasts[map.message];
	
	        if (isDuplicateOfLast || isDuplicateOpen) {
	          return true;
	        }
	
	        previousToastMessage = map.message;
	        openToasts[map.message] = true;
	
	        return false;
	      }
	    }
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .constant('toastrConfig', {
	      allowHtml: false,
	      autoDismiss: false,
	      closeButton: false,
	      closeHtml: '<button>&times;</button>',
	      containerId: 'toast-container',
	      extendedTimeOut: 1000,
	      iconClasses: {
	        error: 'toast-error',
	        info: 'toast-info',
	        success: 'toast-success',
	        warning: 'toast-warning'
	      },
	      maxOpened: 0,
	      messageClass: 'toast-message',
	      newestOnTop: true,
	      onHidden: null,
	      onShown: null,
	      onTap: null,
	      positionClass: 'toast-top-right',
	      preventDuplicates: false,
	      preventOpenDuplicates: false,
	      progressBar: false,
	      tapToDismiss: true,
	      target: 'body',
	      templates: {
	        toast: 'directives/toast/toast.html',
	        progressbar: 'directives/progressbar/progressbar.html'
	      },
	      timeOut: 5000,
	      titleClass: 'toast-title',
	      toastClass: 'toast'
	    });
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .directive('progressBar', progressBar);
	
	  progressBar.$inject = ['toastrConfig'];
	
	  function progressBar(toastrConfig) {
	    return {
	      require: '^toast',
	      templateUrl: function() {
	        return toastrConfig.templates.progressbar;
	      },
	      link: linkFunction
	    };
	
	    function linkFunction(scope, element, attrs, toastCtrl) {
	      var intervalId, currentTimeOut, hideTime;
	
	      toastCtrl.progressBar = scope;
	
	      scope.start = function(duration) {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }
	
	        currentTimeOut = parseFloat(duration);
	        hideTime = new Date().getTime() + currentTimeOut;
	        intervalId = setInterval(updateProgress, 10);
	      };
	
	      scope.stop = function() {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }
	      };
	
	      function updateProgress() {
	        var percentage = ((hideTime - (new Date().getTime())) / currentTimeOut) * 100;
	        element.css('width', percentage + '%');
	      }
	
	      scope.$on('$destroy', function() {
	        // Failsafe stop
	        clearInterval(intervalId);
	      });
	    }
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .controller('ToastController', ToastController);
	
	  function ToastController() {
	    this.progressBar = null;
	
	    this.startProgressBar = function(duration) {
	      if (this.progressBar) {
	        this.progressBar.start(duration);
	      }
	    };
	
	    this.stopProgressBar = function() {
	      if (this.progressBar) {
	        this.progressBar.stop();
	      }
	    };
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .directive('toast', toast);
	
	  toast.$inject = ['$injector', '$interval', 'toastrConfig', 'toastr'];
	
	  function toast($injector, $interval, toastrConfig, toastr) {
	    return {
	      templateUrl: function() {
	        return toastrConfig.templates.toast;
	      },
	      controller: 'ToastController',
	      link: toastLinkFunction
	    };
	
	    function toastLinkFunction(scope, element, attrs, toastCtrl) {
	      var timeout;
	
	      scope.toastClass = scope.options.toastClass;
	      scope.titleClass = scope.options.titleClass;
	      scope.messageClass = scope.options.messageClass;
	      scope.progressBar = scope.options.progressBar;
	
	      if (wantsCloseButton()) {
	        var button = angular.element(scope.options.closeHtml),
	          $compile = $injector.get('$compile');
	        button.addClass('toast-close-button');
	        button.attr('ng-click', 'close(true, $event)');
	        $compile(button)(scope);
	        element.children().prepend(button);
	      }
	
	      scope.init = function() {
	        if (scope.options.timeOut) {
	          timeout = createTimeout(scope.options.timeOut);
	        }
	        if (scope.options.onShown) {
	          scope.options.onShown();
	        }
	      };
	
	      element.on('mouseenter', function() {
	        hideAndStopProgressBar();
	        if (timeout) {
	          $interval.cancel(timeout);
	        }
	      });
	
	      scope.tapToast = function () {
	        if (angular.isFunction(scope.options.onTap)) {
	          scope.options.onTap();
	        }
	        if (scope.options.tapToDismiss) {
	          scope.close(true);
	        }
	      };
	
	      scope.close = function (wasClicked, $event) {
	        if ($event && angular.isFunction($event.stopPropagation)) {
	          $event.stopPropagation();
	        }
	        toastr.remove(scope.toastId, wasClicked);
	      };
	      
	      scope.refreshTimer = function(newTime) {
	        if (timeout) {
	          $interval.cancel(timeout);
	          timeout = createTimeout(newTime || scope.options.timeOut);
	        }
	      };
	
	      element.on('mouseleave', function() {
	        if (scope.options.timeOut === 0 && scope.options.extendedTimeOut === 0) { return; }
	        scope.$apply(function() {
	          scope.progressBar = scope.options.progressBar;
	        });
	        timeout = createTimeout(scope.options.extendedTimeOut);
	      });
	
	      function createTimeout(time) {
	        toastCtrl.startProgressBar(time);
	        return $interval(function() {
	          toastCtrl.stopProgressBar();
	          toastr.remove(scope.toastId);
	        }, time, 1);
	      }
	
	      function hideAndStopProgressBar() {
	        scope.progressBar = false;
	        toastCtrl.stopProgressBar();
	      }
	
	      function wantsCloseButton() {
	        return scope.options.closeHtml;
	      }
	    }
	  }
	}());
	
	angular.module("toastr").run(["$templateCache", function($templateCache) {$templateCache.put("directives/progressbar/progressbar.html","<div class=\"toast-progress\"></div>\n");
	$templateCache.put("directives/toast/toast.html","<div class=\"{{toastClass}} {{toastType}}\" ng-click=\"tapToast()\">\n  <div ng-switch on=\"allowHtml\">\n    <div ng-switch-default ng-if=\"title\" class=\"{{titleClass}}\" aria-label=\"{{title}}\">{{title}}</div>\n    <div ng-switch-default class=\"{{messageClass}}\" aria-label=\"{{message}}\">{{message}}</div>\n    <div ng-switch-when=\"true\" ng-if=\"title\" class=\"{{titleClass}}\" ng-bind-html=\"title\"></div>\n    <div ng-switch-when=\"true\" class=\"{{messageClass}}\" ng-bind-html=\"message\"></div>\n  </div>\n  <progress-bar ng-if=\"progressBar\"></progress-bar>\n</div>\n");}]);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(143);
	module.exports = 'toastr';
	


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/*!
	 * angular-ui-mask
	 * https://github.com/angular-ui/ui-mask
	 * Version: 1.8.7 - 2016-07-26T16:01:23.393Z
	 * License: MIT
	 */
	
	
	(function () { 
	'use strict';
	/*
	 Attaches input mask onto input element
	 */
	angular.module('ui.mask', [])
	        .value('uiMaskConfig', {
	            maskDefinitions: {
	                '9': /\d/,
	                'A': /[a-zA-Z]/,
	                '*': /[a-zA-Z0-9]/
	            },
	            clearOnBlur: true,
	            clearOnBlurPlaceholder: false,
	            escChar: '\\',
	            eventsToHandle: ['input', 'keyup', 'click', 'focus'],
	            addDefaultPlaceholder: true,
	            allowInvalidValue: false
	        })
	        .provider('uiMask.Config', function() {
	            var options = {};
	
	            this.maskDefinitions = function(maskDefinitions) {
	                return options.maskDefinitions = maskDefinitions;
	            };
	            this.clearOnBlur = function(clearOnBlur) {
	                return options.clearOnBlur = clearOnBlur;
	            };
	            this.clearOnBlurPlaceholder = function(clearOnBlurPlaceholder) {
	                return options.clearOnBlurPlaceholder = clearOnBlurPlaceholder;
	            };
	            this.eventsToHandle = function(eventsToHandle) {
	                return options.eventsToHandle = eventsToHandle;
	            };
	            this.addDefaultPlaceholder = function(addDefaultPlaceholder) {
	                return options.addDefaultPlaceholder = addDefaultPlaceholder;
	            };
	            this.allowInvalidValue = function(allowInvalidValue) {
	                return options.allowInvalidValue = allowInvalidValue;
	            };
	            this.$get = ['uiMaskConfig', function(uiMaskConfig) {
	                var tempOptions = uiMaskConfig;
	                for(var prop in options) {
	                    if (angular.isObject(options[prop]) && !angular.isArray(options[prop])) {
	                        angular.extend(tempOptions[prop], options[prop]);
	                    } else {
	                        tempOptions[prop] = options[prop];
	                    }
	                }
	
	                return tempOptions;
	            }];
	        })
	        .directive('uiMask', ['uiMask.Config', function(maskConfig) {
	                function isFocused (elem) {
	                  return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	                }
	
	                return {
	                    priority: 100,
	                    require: 'ngModel',
	                    restrict: 'A',
	                    compile: function uiMaskCompilingFunction() {
	                        var options = angular.copy(maskConfig);
	
	                        return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
	                            var maskProcessed = false, eventsBound = false,
	                                    maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
	                                    // Minimum required length of the value to be considered valid
	                                    minRequiredLength,
	                                    value, valueMasked, isValid,
	                                    // Vars for initializing/uninitializing
	                                    originalPlaceholder = iAttrs.placeholder,
	                                    originalMaxlength = iAttrs.maxlength,
	                                    // Vars used exclusively in eventHandler()
	                                    oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength,
	                                    // Used for communicating if a backspace operation should be allowed between
	                                    // keydownHandler and eventHandler
	                                    preventBackspace;
	
	                            var originalIsEmpty = controller.$isEmpty;
	                            controller.$isEmpty = function(value) {
	                                if (maskProcessed) {
	                                    return originalIsEmpty(unmaskValue(value || ''));
	                                } else {
	                                    return originalIsEmpty(value);
	                                }
	                            };
	
	                            function initialize(maskAttr) {
	                                if (!angular.isDefined(maskAttr)) {
	                                    return uninitialize();
	                                }
	                                processRawMask(maskAttr);
	                                if (!maskProcessed) {
	                                    return uninitialize();
	                                }
	                                initializeElement();
	                                bindEventListeners();
	                                return true;
	                            }
	
	                            function initPlaceholder(placeholderAttr) {
	                                if ( ! placeholderAttr) {
	                                    return;
	                                }
	
	                                maskPlaceholder = placeholderAttr;
	
	                                // If the mask is processed, then we need to update the value
	                                // but don't set the value if there is nothing entered into the element
	                                // and there is a placeholder attribute on the element because that
	                                // will only set the value as the blank maskPlaceholder
	                                // and override the placeholder on the element
	                                if (maskProcessed && !(iElement.val().length === 0 && angular.isDefined(iAttrs.placeholder))) {
	                                    iElement.val(maskValue(unmaskValue(iElement.val())));
	                                }
	                            }
	
	                            function initPlaceholderChar() {
	                                return initialize(iAttrs.uiMask);
	                            }
	
	                            var modelViewValue = false;
	                            iAttrs.$observe('modelViewValue', function(val) {
	                                if (val === 'true') {
	                                    modelViewValue = true;
	                                }
	                            });
	
	                            iAttrs.$observe('allowInvalidValue', function(val) {
	                                linkOptions.allowInvalidValue = val === ''
	                                    ? true
	                                    : !!val;
	                                formatter(controller.$modelValue);
	                            });
	
	                            function formatter(fromModelValue) {
	                                if (!maskProcessed) {
	                                    return fromModelValue;
	                                }
	                                value = unmaskValue(fromModelValue || '');
	                                isValid = validateValue(value);
	                                controller.$setValidity('mask', isValid);
	
	                                if (!value.length) return undefined;
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return maskValue(value);
	                                } else {
	                                    return undefined;
	                                }
	                            }
	
	                            function parser(fromViewValue) {
	                                if (!maskProcessed) {
	                                    return fromViewValue;
	                                }
	                                value = unmaskValue(fromViewValue || '');
	                                isValid = validateValue(value);
	                                // We have to set viewValue manually as the reformatting of the input
	                                // value performed by eventHandler() doesn't happen until after
	                                // this parser is called, which causes what the user sees in the input
	                                // to be out-of-sync with what the controller's $viewValue is set to.
	                                controller.$viewValue = value.length ? maskValue(value) : '';
	                                controller.$setValidity('mask', isValid);
	
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return modelViewValue ? controller.$viewValue : value;
	                                }
	                            }
	
	                            var linkOptions = {};
	
	                            if (iAttrs.uiOptions) {
	                                linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
	                                if (angular.isObject(linkOptions[0])) {
	                                    // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
	                                    linkOptions = (function(original, current) {
	                                        for (var i in original) {
	                                            if (Object.prototype.hasOwnProperty.call(original, i)) {
	                                                if (current[i] === undefined) {
	                                                    current[i] = angular.copy(original[i]);
	                                                } else {
	                                                    if (angular.isObject(current[i]) && !angular.isArray(current[i])) {
	                                                        current[i] = angular.extend({}, original[i], current[i]);
	                                                    }
	                                                }
	                                            }
	                                        }
	                                        return current;
	                                    })(options, linkOptions[0]);
	                                } else {
	                                    linkOptions = options;  //gotta be a better way to do this..
	                                }
	                            } else {
	                                linkOptions = options;
	                            }
	
	                            iAttrs.$observe('uiMask', initialize);
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholder)) {
	                                iAttrs.$observe('uiMaskPlaceholder', initPlaceholder);
	                            }
	                            else {
	                                iAttrs.$observe('placeholder', initPlaceholder);
	                            }
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholderChar)) {
	                                iAttrs.$observe('uiMaskPlaceholderChar', initPlaceholderChar);
	                            }
	
	                            controller.$formatters.unshift(formatter);
	                            controller.$parsers.unshift(parser);
	
	                            function uninitialize() {
	                                maskProcessed = false;
	                                unbindEventListeners();
	
	                                if (angular.isDefined(originalPlaceholder)) {
	                                    iElement.attr('placeholder', originalPlaceholder);
	                                } else {
	                                    iElement.removeAttr('placeholder');
	                                }
	
	                                if (angular.isDefined(originalMaxlength)) {
	                                    iElement.attr('maxlength', originalMaxlength);
	                                } else {
	                                    iElement.removeAttr('maxlength');
	                                }
	
	                                iElement.val(controller.$modelValue);
	                                controller.$viewValue = controller.$modelValue;
	                                return false;
	                            }
	
	                            function initializeElement() {
	                                value = oldValueUnmasked = unmaskValue(controller.$modelValue || '');
	                                valueMasked = oldValue = maskValue(value);
	                                isValid = validateValue(value);
	                                if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
	                                    iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
	                                }
	                                if ( ! originalPlaceholder && linkOptions.addDefaultPlaceholder) {
	                                    iElement.attr('placeholder', maskPlaceholder);
	                                }
	                                var viewValue = controller.$modelValue;
	                                var idx = controller.$formatters.length;
	                                while(idx--) {
	                                    viewValue = controller.$formatters[idx](viewValue);
	                                }
	                                controller.$viewValue = viewValue || '';
	                                controller.$render();
	                                // Not using $setViewValue so we don't clobber the model value and dirty the form
	                                // without any kind of user interaction.
	                            }
	
	                            function bindEventListeners() {
	                                if (eventsBound) {
	                                    return;
	                                }
	                                iElement.bind('blur', blurHandler);
	                                iElement.bind('mousedown mouseup', mouseDownUpHandler);
	                                iElement.bind('keydown', keydownHandler);
	                                iElement.bind(linkOptions.eventsToHandle.join(' '), eventHandler);
	                                eventsBound = true;
	                            }
	
	                            function unbindEventListeners() {
	                                if (!eventsBound) {
	                                    return;
	                                }
	                                iElement.unbind('blur', blurHandler);
	                                iElement.unbind('mousedown', mouseDownUpHandler);
	                                iElement.unbind('mouseup', mouseDownUpHandler);
	                                iElement.unbind('keydown', keydownHandler);
	                                iElement.unbind('input', eventHandler);
	                                iElement.unbind('keyup', eventHandler);
	                                iElement.unbind('click', eventHandler);
	                                iElement.unbind('focus', eventHandler);
	                                eventsBound = false;
	                            }
	
	                            function validateValue(value) {
	                                // Zero-length value validity is ngRequired's determination
	                                return value.length ? value.length >= minRequiredLength : true;
	                            }
	
	                            function unmaskValue(value) {
	                                var valueUnmasked = '',
	                                    input = iElement[0],
	                                    maskPatternsCopy = maskPatterns.slice(),
	                                    selectionStart = oldCaretPosition,
	                                    selectionEnd = selectionStart + getSelectionLength(input),
	                                    valueOffset, valueDelta, tempValue = '';
	                                // Preprocess by stripping mask components from value
	                                value = value.toString();
	                                valueOffset = 0;
	                                valueDelta = value.length - maskPlaceholder.length;
	                                angular.forEach(maskComponents, function(component) {
	                                    var position = component.position;
	                                    //Only try and replace the component if the component position is not within the selected range
	                                    //If component was in selected range then it was removed with the user input so no need to try and remove that component
	                                    if (!(position >= selectionStart && position < selectionEnd)) {
	                                        if (position >= selectionStart) {
	                                            position += valueDelta;
	                                        }
	                                        if (value.substring(position, position + component.value.length) === component.value) {
	                                            tempValue += value.slice(valueOffset, position);// + value.slice(position + component.value.length);
	                                            valueOffset = position + component.value.length;
	                                        }
	                                    }
	                                });
	                                value = tempValue + value.slice(valueOffset);
	                                angular.forEach(value.split(''), function(chr) {
	                                    if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
	                                        valueUnmasked += chr;
	                                        maskPatternsCopy.shift();
	                                    }
	                                });
	
	                                return valueUnmasked;
	                            }
	
	                            function maskValue(unmaskedValue) {
	                                var valueMasked = '',
	                                        maskCaretMapCopy = maskCaretMap.slice();
	
	                                angular.forEach(maskPlaceholder.split(''), function(chr, i) {
	                                    if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
	                                        valueMasked += unmaskedValue.charAt(0) || '_';
	                                        unmaskedValue = unmaskedValue.substr(1);
	                                        maskCaretMapCopy.shift();
	                                    }
	                                    else {
	                                        valueMasked += chr;
	                                    }
	                                });
	                                return valueMasked;
	                            }
	
	                            function getPlaceholderChar(i) {
	                                var placeholder = angular.isDefined(iAttrs.uiMaskPlaceholder) ? iAttrs.uiMaskPlaceholder : iAttrs.placeholder,
	                                    defaultPlaceholderChar;
	
	                                if (angular.isDefined(placeholder) && placeholder[i]) {
	                                    return placeholder[i];
	                                } else {
	                                    defaultPlaceholderChar = angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar ? iAttrs.uiMaskPlaceholderChar : '_';
	                                    return (defaultPlaceholderChar.toLowerCase() === 'space') ? ' ' : defaultPlaceholderChar[0];
	                                }
	                            }
	
	                            // Generate array of mask components that will be stripped from a masked value
	                            // before processing to prevent mask components from being added to the unmasked value.
	                            // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
	                            function getMaskComponents() {
	                                var maskPlaceholderChars = maskPlaceholder.split(''),
	                                        maskPlaceholderCopy, components;
	
	                                //maskCaretMap can have bad values if the input has the ui-mask attribute implemented as an obversable property, e.g. the demo page
	                                if (maskCaretMap && !isNaN(maskCaretMap[0])) {
	                                    //Instead of trying to manipulate the RegEx based on the placeholder characters
	                                    //we can simply replace the placeholder characters based on the already built
	                                    //maskCaretMap to underscores and leave the original working RegEx to get the proper
	                                    //mask components
	                                    angular.forEach(maskCaretMap, function(value) {
	                                        maskPlaceholderChars[value] = '_';
	                                    });
	                                }
	                                maskPlaceholderCopy = maskPlaceholderChars.join('');
	                                components = maskPlaceholderCopy.replace(/[_]+/g, '_').split('_');
	                                components = components.filter(function(s) {
	                                    return s !== '';
	                                });
	
	                                // need a string search offset in cases where the mask contains multiple identical components
	                                // E.g., a mask of 99.99.99-999.99
	                                var offset = 0;
	                                return components.map(function(c) {
	                                    var componentPosition = maskPlaceholderCopy.indexOf(c, offset);
	                                    offset = componentPosition + 1;
	                                    return {
	                                        value: c,
	                                        position: componentPosition
	                                    };
	                                });
	                            }
	
	                            function processRawMask(mask) {
	                                var characterCount = 0;
	
	                                maskCaretMap = [];
	                                maskPatterns = [];
	                                maskPlaceholder = '';
	
	                                if (angular.isString(mask)) {
	                                    minRequiredLength = 0;
	
	                                    var isOptional = false,
	                                            numberOfOptionalCharacters = 0,
	                                            splitMask = mask.split('');
	
	                                    var inEscape = false;
	                                    angular.forEach(splitMask, function(chr, i) {
	                                        if (inEscape) {
	                                            inEscape = false;
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                        else if (linkOptions.escChar === chr) {
	                                            inEscape = true;
	                                        }
	                                        else if (linkOptions.maskDefinitions[chr]) {
	                                            maskCaretMap.push(characterCount);
	
	                                            maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
	                                            maskPatterns.push(linkOptions.maskDefinitions[chr]);
	
	                                            characterCount++;
	                                            if (!isOptional) {
	                                                minRequiredLength++;
	                                            }
	
	                                            isOptional = false;
	                                        }
	                                        else if (chr === '?') {
	                                            isOptional = true;
	                                            numberOfOptionalCharacters++;
	                                        }
	                                        else {
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                    });
	                                }
	                                // Caret position immediately following last position is valid.
	                                maskCaretMap.push(maskCaretMap.slice().pop() + 1);
	
	                                maskComponents = getMaskComponents();
	                                maskProcessed = maskCaretMap.length > 1 ? true : false;
	                            }
	
	                            var prevValue = iElement.val();
	                            function blurHandler() {
	                                if (linkOptions.clearOnBlur || ((linkOptions.clearOnBlurPlaceholder) && (value.length === 0) && iAttrs.placeholder)) {
	                                    oldCaretPosition = 0;
	                                    oldSelectionLength = 0;
	                                    if (!isValid || value.length === 0) {
	                                        valueMasked = '';
	                                        iElement.val('');
	                                        scope.$apply(function() {
	                                            //only $setViewValue when not $pristine to avoid changing $pristine state.
	                                            if (!controller.$pristine) {
	                                                controller.$setViewValue('');
	                                            }
	                                        });
	                                    }
	                                }
	                                //Check for different value and trigger change.
	                                //Check for different value and trigger change.
	                                if (value !== prevValue) {
	                                    // #157 Fix the bug from the trigger when backspacing exactly on the first letter (emptying the field)
	                                    // and then blurring out.
	                                    // Angular uses html element and calls setViewValue(element.value.trim()), setting it to the trimmed mask
	                                    // when it should be empty
	                                    var currentVal = iElement.val();
	                                    var isTemporarilyEmpty = value === '' && currentVal && angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar === 'space'; 
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val('');
	                                    }
	                                    triggerChangeEvent(iElement[0]);
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val(currentVal);
	                                    }
	                                }
	                                prevValue = value;
	                            }
	
	                            function triggerChangeEvent(element) {
	                                var change;
	                                if (angular.isFunction(window.Event) && !element.fireEvent) {
	                                    // modern browsers and Edge
	                                    change = new Event('change', {
	                                        view: window,
	                                        bubbles: true,
	                                        cancelable: false
	                                    });
	                                    element.dispatchEvent(change);
	                                } else if ('createEvent' in document) {
	                                    // older browsers
	                                    change = document.createEvent('HTMLEvents');
	                                    change.initEvent('change', false, true);
	                                    element.dispatchEvent(change);
	                                }
	                                else if (element.fireEvent) {
	                                    // IE <= 11
	                                    element.fireEvent('onchange');
	                                }
	                            }
	
	                            function mouseDownUpHandler(e) {
	                                if (e.type === 'mousedown') {
	                                    iElement.bind('mouseout', mouseoutHandler);
	                                } else {
	                                    iElement.unbind('mouseout', mouseoutHandler);
	                                }
	                            }
	
	                            iElement.bind('mousedown mouseup', mouseDownUpHandler);
	
	                            function mouseoutHandler() {
	                                /*jshint validthis: true */
	                                oldSelectionLength = getSelectionLength(this);
	                                iElement.unbind('mouseout', mouseoutHandler);
	                            }
	
	                            function keydownHandler(e) {
			              	/*jshint validthis: true */
					var isKeyBackspace = e.which === 8,
					caretPos = getCaretPosition(this) - 1 || 0, //value in keydown is pre change so bump caret position back to simulate post change
					isCtrlZ = e.which === 90 && e.ctrlKey; //ctrl+z pressed
			
					if (isKeyBackspace) {
						while(caretPos >= 0) {
							if (isValidCaretPosition(caretPos)) {
							//re-adjust the caret position.
							//Increment to account for the initial decrement to simulate post change caret position
							setCaretPosition(this, caretPos + 1);
							break;
							}
						caretPos--;
						}
					preventBackspace = caretPos === -1;
					}
					
					if (isCtrlZ) {
						// prevent IE bug - value should be returned to initial state
						iElement.val('');
						e.preventDefault();
					}
				}
	
	                            function eventHandler(e) {
	                                /*jshint validthis: true */
	                                e = e || {};
	                                // Allows more efficient minification
	                                var eventWhich = e.which,
	                                        eventType = e.type;
	
	                                // Prevent shift and ctrl from mucking with old values
	                                if (eventWhich === 16 || eventWhich === 91) {
	                                    return;
	                                }
	
	                                var val = iElement.val(),
	                                        valOld = oldValue,
	                                        valMasked,
	                                        valAltered = false,
	                                        valUnmasked = unmaskValue(val),
	                                        valUnmaskedOld = oldValueUnmasked,
	                                        caretPos = getCaretPosition(this) || 0,
	                                        caretPosOld = oldCaretPosition || 0,
	                                        caretPosDelta = caretPos - caretPosOld,
	                                        caretPosMin = maskCaretMap[0],
	                                        caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),
	                                        selectionLenOld = oldSelectionLength || 0,
	                                        isSelected = getSelectionLength(this) > 0,
	                                        wasSelected = selectionLenOld > 0,
	                                        // Case: Typing a character to overwrite a selection
	                                        isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
	                                        // Case: Delete and backspace behave identically on a selection
	                                        isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
	                                        isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes
	
	                                        isKeyLeftArrow = eventWhich === 37,
	                                        // Necessary due to "input" event not providing a key code
	                                        isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),
	                                        isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0) && !wasSelected),
	                                        // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
	                                        // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
	                                        // non-mask character. Also applied to click since users are (arguably) more likely to backspace
	                                        // a character when clicking within a filled input.
	                                        caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;
	
	                                oldSelectionLength = getSelectionLength(this);
	
	                                // These events don't require any action
	                                if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup' || eventType === 'focus'))) {
	                                    return;
	                                }
	
	                                if (isKeyBackspace && preventBackspace) {
	                                    iElement.val(maskPlaceholder);
	                                    // This shouldn't be needed but for some reason after aggressive backspacing the controller $viewValue is incorrect.
	                                    // This keeps the $viewValue updated and correct.
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(''); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                    setCaretPosition(this, caretPosOld);
	                                    return;
	                                }
	
	                                // Value Handling
	                                // ==============
	
	                                // User attempted to delete but raw value was unaffected--correct this grievous offense
	                                if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
	                                    while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
	                                        caretPos--;
	                                    }
	                                    while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
	                                        caretPos++;
	                                    }
	                                    var charIndex = maskCaretMap.indexOf(caretPos);
	                                    // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
	                                    valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
	
	                                    // If value has not changed, don't want to call $setViewValue, may be caused by IE raising input event due to placeholder
	                                    if (valUnmasked !== valUnmaskedOld)
	                                        valAltered = true;
	                                }
	
	                                // Update values
	                                valMasked = maskValue(valUnmasked);
	
	                                oldValue = valMasked;
	                                oldValueUnmasked = valUnmasked;
	
	                                //additional check to fix the problem where the viewValue is out of sync with the value of the element.
	                                //better fix for commit 2a83b5fb8312e71d220a497545f999fc82503bd9 (I think)
	                                if (!valAltered && val.length > valMasked.length)
	                                    valAltered = true;
	
	                                iElement.val(valMasked);
	
	                                //we need this check.  What could happen if you don't have it is that you'll set the model value without the user
	                                //actually doing anything.  Meaning, things like pristine and touched will be set.
	                                if (valAltered) {
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(valMasked); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                }
	
	                                // Caret Repositioning
	                                // ===================
	
	                                // Ensure that typing always places caret ahead of typed character in cases where the first char of
	                                // the input is a mask char and the caret is placed at the 0 position.
	                                if (isAddition && (caretPos <= caretPosMin)) {
	                                    caretPos = caretPosMin + 1;
	                                }
	
	                                if (caretBumpBack) {
	                                    caretPos--;
	                                }
	
	                                // Make sure caret is within min and max position limits
	                                caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
	
	                                // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
	                                while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
	                                    caretPos += caretBumpBack ? -1 : 1;
	                                }
	
	                                if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
	                                    caretPos++;
	                                }
	                                oldCaretPosition = caretPos;
	                                setCaretPosition(this, caretPos);
	                            }
	
	                            function isValidCaretPosition(pos) {
	                                return maskCaretMap.indexOf(pos) > -1;
	                            }
	
	                            function getCaretPosition(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return input.selectionStart;
	                                } else if (document.selection) {
	                                    if (isFocused(iElement[0])) {
	                                        // Curse you IE
	                                        input.focus();
	                                        var selection = document.selection.createRange();
	                                        selection.moveStart('character', input.value ? -input.value.length : 0);
	                                        return selection.text.length;
	                                    }
	                                }
	                                return 0;
	                            }
	
	                            function setCaretPosition(input, pos) {
	                                if (!input)
	                                    return 0;
	                                if (input.offsetWidth === 0 || input.offsetHeight === 0) {
	                                    return; // Input's hidden
	                                }
	                                if (input.setSelectionRange) {
	                                    if (isFocused(iElement[0])) {
	                                        input.focus();
	                                        input.setSelectionRange(pos, pos);
	                                    }
	                                }
	                                else if (input.createTextRange) {
	                                    // Curse you IE
	                                    var range = input.createTextRange();
	                                    range.collapse(true);
	                                    range.moveEnd('character', pos);
	                                    range.moveStart('character', pos);
	                                    range.select();
	                                }
	                            }
	
	                            function getSelectionLength(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return (input.selectionEnd - input.selectionStart);
	                                }
	                                if (window.getSelection) {
	                                    return (window.getSelection().toString().length);
	                                }
	                                if (document.selection) {
	                                    return (document.selection.createRange().text.length);
	                                }
	                                return 0;
	                            }
	
	                            // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
	                            if (!Array.prototype.indexOf) {
	                                Array.prototype.indexOf = function(searchElement /*, fromIndex */) {
	                                    if (this === null) {
	                                        throw new TypeError();
	                                    }
	                                    var t = Object(this);
	                                    var len = t.length >>> 0;
	                                    if (len === 0) {
	                                        return -1;
	                                    }
	                                    var n = 0;
	                                    if (arguments.length > 1) {
	                                        n = Number(arguments[1]);
	                                        if (n !== n) { // shortcut for verifying if it's NaN
	                                            n = 0;
	                                        } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
	                                            n = (n > 0 || -1) * Math.floor(Math.abs(n));
	                                        }
	                                    }
	                                    if (n >= len) {
	                                        return -1;
	                                    }
	                                    var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
	                                    for (; k < len; k++) {
	                                        if (k in t && t[k] === searchElement) {
	                                            return k;
	                                        }
	                                    }
	                                    return -1;
	                                };
	                            }
	
	                        };
	                    }
	                };
	            }
	        ]);
	
	}());

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//https://github.com/angular/angular.js/pull/10732
	
	var angular = __webpack_require__(7);
	var mask = __webpack_require__(145);
	
	module.exports = 'ui.mask';


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	/*!
	 * angular-ui-validate
	 * https://github.com/angular-ui/ui-validate
	 * Version: 1.2.3 - 2017-05-18T08:07:23.042Z
	 * License: MIT
	 */
	
	
	(function () { 
	'use strict';
	/**
	 * General-purpose validator for ngModel.
	 * angular.js comes with several built-in validation mechanism for input fields (ngRequired, ngPattern etc.) but using
	 * an arbitrary validation function requires creation of custom directives for interact with angular's validation mechanism.
	 * The ui-validate directive makes it easy to use any function(s) defined in scope as a validator function(s).
	 * A validator function will trigger validation on both model and input changes.
	 *
	 * This utility bring 'ui-validate' directives to handle regular validations and 'ui-validate-async' for asynchronous validations.
	 *
	 * @example <input ui-validate=" 'myValidatorFunction($value)' ">
	 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }">
	 * @example <input ui-validate="{ foo : '$value > anotherModel' }" ui-validate-watch=" 'anotherModel' ">
	 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }" ui-validate-watch=" { foo : 'anotherModel' } ">
	 * @example <input ui-validate-async=" 'myAsyncValidatorFunction($value)' ">
	 * @example <input ui-validate-async="{ foo: 'myAsyncValidatorFunction($value, anotherModel)' }" ui-validate-watch=" 'anotherModel' ">
	 *
	 * @param ui-validate {string|object literal} If strings is passed it should be a scope's function to be used as a validator.
	 * If an object literal is passed a key denotes a validation error key while a value should be a validator function.
	 * In both cases validator function should take a value to validate as its argument and should return true/false indicating a validation result.
	 * It is possible for a validator function to return a promise, however promises are better handled by ui-validate-async.
	 *
	 * @param ui-validate-async {string|object literal} If strings is passed it should be a scope's function to be used as a validator.
	 * If an object literal is passed a key denotes a validation error key while a value should be a validator function.
	 * Async validator function should take a value to validate as its argument and should return a promise that resolves if valid and reject if not,
	 * indicating a validation result.
	 * ui-validate-async supports non asyncronous validators. They are wrapped into a promise. Although is recomented to use ui-validate instead, since
	 * all validations declared in ui-validate-async are registered un ngModel.$asyncValidators that runs after ngModel.$validators if and only if
	 * all validators in ngModel.$validators reports as valid.
	 */
	angular.module('ui.validate',[])
	  .directive('uiValidate', ['$$uiValidateApplyWatch', '$$uiValidateApplyWatchCollection', function ($$uiValidateApplyWatch, $$uiValidateApplyWatchCollection) {
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function(scope, elm, attrs, ctrl) {
	      var validateFn, validateExpr = scope.$eval(attrs.uiValidate);
	
	      if (!validateExpr) {
	        return;
	      }
	
	      if (angular.isString(validateExpr)) {
	        validateExpr = {
	          validator: validateExpr
	        };
	      }
	
	      angular.forEach(validateExpr, function(exprssn, key) {
	        validateFn = function(modelValue, viewValue) {
	          // $value is left for retrocompatibility
	          var expression = scope.$eval(exprssn, {
	            '$value': modelValue,
	            '$modelValue': modelValue,
	            '$viewValue': viewValue,
	            '$name': ctrl.$name
	          });
	          // Keep support for promises for retrocompatibility
	          if (angular.isObject(expression) && angular.isFunction(expression.then)) {
	            expression.then(function() {
	              ctrl.$setValidity(key, true);
	            }, function() {
	              ctrl.$setValidity(key, false);
	            });
	            // Return as valid for now. Validity is updated when promise resolves.
	            return true;
	          } else {
	            return !!expression; // Transform 'undefined' to false (to avoid corrupting the NgModelController and the FormController)
	          }
	        };
	        ctrl.$validators[key] = validateFn;
	      });
	
	      // Support for ui-validate-watch
	      if (attrs.uiValidateWatch) {
	        $$uiValidateApplyWatch(scope, ctrl, scope.$eval(attrs.uiValidateWatch), attrs.uiValidateWatchObjectEquality);
	      }
	      if (attrs.uiValidateWatchCollection) {
	        $$uiValidateApplyWatchCollection(scope, ctrl, scope.$eval(attrs.uiValidateWatchCollection));
	      }
	    }
	  };
	}])
	  .directive('uiValidateAsync', ['$$uiValidateApplyWatch', '$$uiValidateApplyWatchCollection', '$timeout', '$q', function ($$uiValidateApplyWatch, $$uiValidateApplyWatchCollection, $timeout, $q) {
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function (scope, elm, attrs, ctrl) {
	      var validateFn, validateExpr = scope.$eval(attrs.uiValidateAsync);
	
	      if (!validateExpr){ return;}
	
	      if (angular.isString(validateExpr)) {
	        validateExpr = { validatorAsync: validateExpr };
	      }
	
	      angular.forEach(validateExpr, function (exprssn, key) {
	        validateFn = function(modelValue, viewValue) {
	          // $value is left for ease of use
	          var expression = scope.$eval(exprssn, {
	            '$value': modelValue,
	            '$modelValue': modelValue,
	            '$viewValue': viewValue,
	            '$name': ctrl.$name
	          });
	          // Check if it's a promise
	          if (angular.isObject(expression) && angular.isFunction(expression.then)) {
	            return expression;
	            // Support for validate non-async validators
	          } else {
	            return $q(function(resolve, reject) {
	              setTimeout(function() {
	                if (expression) {
	                  resolve();
	                } else {
	                  reject();
	                }
	              }, 0);
	            });
	          }
	        };
	        ctrl.$asyncValidators[key] = validateFn;
	      });
	
	      // Support for ui-validate-watch
	      if (attrs.uiValidateWatch){
	          $$uiValidateApplyWatch( scope, ctrl, scope.$eval(attrs.uiValidateWatch), attrs.uiValidateWatchObjectEquality);
	      }
	      if (attrs.uiValidateWatchCollection) {
	        $$uiValidateApplyWatchCollection(scope, ctrl, scope.$eval(attrs.uiValidateWatchCollection));
	      }
	    }
	  };
	}])
	  .service('$$uiValidateApplyWatch', function () {
	    return function (scope, ctrl, watch, objectEquality) {
	      var watchCallback = function () {
	        ctrl.$validate();
	      };
	
	      //string - update all validators on expression change
	      if (angular.isString(watch)) {
	        scope.$watch(watch, watchCallback, objectEquality);
	        //array - update all validators on change of any expression
	      } else if (angular.isArray(watch)) {
	        angular.forEach(watch, function (expression) {
	          scope.$watch(expression, watchCallback, objectEquality);
	        });
	        //object - update appropriate validator
	      } else if (angular.isObject(watch)) {
	        angular.forEach(watch, function (expression/*, validatorKey*/) {
	          //value is string - look after one expression
	          if (angular.isString(expression)) {
	            scope.$watch(expression, watchCallback, objectEquality);
	          }
	          //value is array - look after all expressions in array
	          if (angular.isArray(expression)) {
	            angular.forEach(expression, function (intExpression) {
	              scope.$watch(intExpression, watchCallback, objectEquality);
	            });
	          }
	        });
	      }
	    };
	  })
	  .service('$$uiValidateApplyWatchCollection', function () {
	    return function (scope, ctrl, watch) {
	      var watchCallback = function () {
	        ctrl.$validate();
	      };
	
	      //string - update all validators on expression change
	      if (angular.isString(watch)) {
	        scope.$watchCollection(watch, watchCallback);
	        //array - update all validators on change of any expression
	      } else if (angular.isArray(watch)) {
	        angular.forEach(watch, function (expression) {
	          scope.$watchCollection(expression, watchCallback);
	        });
	        //object - update appropriate validator
	      } else if (angular.isObject(watch)) {
	        angular.forEach(watch, function (expression/*, validatorKey*/) {
	          //value is string - look after one expression
	          if (angular.isString(expression)) {
	            scope.$watchCollection(expression, watchCallback);
	          }
	          //value is array - look after all expressions in array
	          if (angular.isArray(expression)) {
	            angular.forEach(expression, function (intExpression) {
	              scope.$watchCollection(intExpression, watchCallback);
	            });
	          }
	        });
	      }
	    };
	  });
	
	}());

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(147);
	module.exports = 'ui.validate';


/***/ }),
/* 149 */
/***/ (function(module, exports) {

	/**
	 * Easy to use Wizard library for Angular JS
	 * @version v1.1.1 - 2017-06-07 * @link https://github.com/mgonto/angular-wizard
	 * @author Martin Gontovnikas <martin@gon.to>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	angular.module('templates-angularwizard', ['step.html', 'wizard.html']);
	
	angular.module("step.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("step.html",
	    "<section ng-show=\"selected\" ng-class=\"{current: selected, done: completed}\" class=\"step\" ng-transclude>\n" +
	    "</section>");
	}]);
	
	angular.module("wizard.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("wizard.html",
	    "<div>\n" +
	    "    <h2 ng-show=\"selectedStep.wzHeadingTitle != ''\">{{ selectedStep.wzHeadingTitle }}</h2>\n" +
	    "\n" +
	    "    <div class=\"steps\" ng-if=\"indicatorsPosition === 'bottom'\" ng-transclude></div>\n" +
	    "    <ul class=\"steps-indicator steps-{{getEnabledSteps().length}}\" ng-if=\"!hideIndicators\">\n" +
	    "      <li ng-class=\"{default: !step.completed && !step.selected, current: step.selected && !step.completed, done: step.completed && !step.selected, editing: step.selected && step.completed}\" ng-repeat=\"step in getEnabledSteps()\">\n" +
	    "        <a ng-click=\"goTo(step)\">{{step.title || step.wzTitle}}</a>\n" +
	    "      </li>\n" +
	    "    </ul>\n" +
	    "    <div class=\"steps\" ng-if=\"indicatorsPosition === 'top'\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module('mgo-angular-wizard', ['templates-angularwizard']);
	
	angular.module('mgo-angular-wizard').directive('wzStep', function() {
	    return {
	        restrict: 'EA',
	        replace: true,
	        transclude: true,
	        scope: {
	            wzTitle: '@',
	            wzHeadingTitle: '@',
	            canenter : '=',
	            canexit : '=',
	            disabled: '@?wzDisabled',
	            description: '@',
	            wzData: '=',
	            wzOrder: '@?'
	        },
	        require: '^wizard',
	        templateUrl: function(element, attributes) {
	          return attributes.template || "step.html";
	        },
	        link: function ($scope, $element, $attrs, wizard) {
	            $attrs.$observe('wzTitle', function (value) {
	                $scope.title = $scope.wzTitle;
	            });
	            $scope.title = $scope.wzTitle;
	            wizard.addStep($scope);
	            $scope.$on('$destroy', function(){
	                wizard.removeStep($scope);
	            });
	        }
	    };
	});
	
	//wizard directive
	angular.module('mgo-angular-wizard').directive('wizard', function() {
	    return {
	        restrict: 'EA',
	        replace: true,
	        transclude: true,
	        scope: {
	            currentStep: '=',
	            onCancel: '&',
	            onFinish: '&',
	            hideIndicators: '=',
	            editMode: '=',
	            name: '@',
	            indicatorsPosition: '@?'
	        },
	        templateUrl: function(element, attributes) {
	            return attributes.template || "wizard.html";
	        },
	
	        //controller for wizard directive, treat this just like an angular controller
	        controller: ['$scope', '$element', '$log', 'WizardHandler', '$q', '$timeout', function ($scope, $element, $log, WizardHandler, $q, $timeout) {
	            //setting default step position if none declared.
	            if ($scope.indicatorsPosition == undefined) {
	                $scope.indicatorsPosition = 'bottom';
	            }
	            //this variable allows directive to load without having to pass any step validation
	            var firstRun = true;
	            //creating instance of wizard, passing this as second argument allows access to functions attached to this via Service
	            WizardHandler.addWizard($scope.name || WizardHandler.defaultName, this);
	
	            $scope.$on('$destroy', function() {
	                WizardHandler.removeWizard($scope.name || WizardHandler.defaultName);
	            });
	
	            //steps array where all the scopes of each step are added
	            $scope.steps = [];
	
	            var stepIdx = function(step) {
	                var idx = 0;
	                var res = -1;
	                angular.forEach($scope.getEnabledSteps(), function(currStep) {
	                  if (currStep === step) {
	                    res = idx;
	                  }
	                  idx++;
	                });
	                return res;
	            };
	
	            var stepByTitle = function(titleToFind) {
	              var foundStep = null;
	              angular.forEach($scope.getEnabledSteps(), function(step) {
	                if (step.wzTitle === titleToFind) {
	                  foundStep = step;
	                }
	              });
	              return foundStep;
	            };
	
	
	            //update completed state for each step based on the editMode and current step number
	            var handleEditModeChange = function() {
	                var editMode = $scope.editMode;
	                if (angular.isUndefined(editMode) || (editMode === null)) return;
	
	                //Set completed for all steps to the value of editMode
	                angular.forEach($scope.steps, function (step) {
	                    step.completed = editMode;
	                });
	
	                //If editMode is false, set ONLY ENABLED steps with index lower then completedIndex to completed
	                if (!editMode) {
	                    var completedStepsIndex = $scope.currentStepNumber() - 1;
	                    angular.forEach($scope.getEnabledSteps(), function(step, stepIndex) {
	                        if(stepIndex < completedStepsIndex) {
	                            step.completed = true;
	                        }
	                    });
	                }
	            };
	
	            //access to context object for step validation
	            $scope.context = {};
	
	            //watching changes to currentStep
	            $scope.$watch('currentStep', function(step) {
	                //checking to make sure currentStep is truthy value
	                if (!step) return;
	                //setting stepTitle equal to current step title or default title
	                var stepTitle = $scope.selectedStep.wzTitle;
	                if ($scope.selectedStep && stepTitle !== $scope.currentStep) {
	                    //invoking goTo() with step title as argument
	                    $scope.goTo(stepByTitle($scope.currentStep));
	                }
	            });
	
	            //watching steps array length and editMode value, if edit module is undefined or null the nothing is done
	            //if edit mode is truthy, then all steps are marked as completed
	            $scope.$watch('[editMode, steps.length]', function() {
	                handleEditModeChange();
	            }, true);
	
	            //called each time step directive is loaded
	            this.addStep = function(step) {
	                var wzOrder = (step.wzOrder >= 0 && !$scope.steps[step.wzOrder]) ? step.wzOrder : $scope.steps.length;
	                //adding the scope of directive onto step array
	                $scope.steps[wzOrder] = step;
	                //if this step is the new first then goTo it
	                if ($scope.getEnabledSteps()[0] === step) {
	                    //goTo first step
	                    $scope.goTo($scope.getEnabledSteps()[0]);
	                }
	            };
	
	            //called each time step directive is destroyed
	            this.removeStep = function (step) {
	                var index = $scope.steps.indexOf(step);
	                if (index > 0) {
	                    $scope.steps.splice(index, 1);
	                }
	            };
	
	            this.context = $scope.context;
	
	            $scope.getStepNumber = function(step) {
	                return stepIdx(step) + 1;
	            };
	
	            $scope.goTo = function(step) {
	                //if this is the first time the wizard is loading it bi-passes step validation
	                if(firstRun){
	                    //deselect all steps so you can set fresh below
	                    unselectAll();
	                    $scope.selectedStep = step;
	                    //making sure current step is not undefined
	                    if (!angular.isUndefined($scope.currentStep)) {
	                        $scope.currentStep = step.wzTitle;
	                    }
	                    //setting selected step to argument passed into goTo()
	                    step.selected = true;
	                    //emit event upwards with data on goTo() invoktion
	                    $scope.$emit('wizard:stepChanged', {step: step, index: stepIdx(step)});
	                    //setting variable to false so all other step changes must pass validation
	                    firstRun = false;
	                } else {
	                    //createing variables to capture current state that goTo() was invoked from and allow booleans
	                    var thisStep;
	                    //getting data for step you are transitioning out of
	                    if($scope.currentStepNumber() > 0){
	                        thisStep = $scope.currentStepNumber() - 1;
	                    } else if ($scope.currentStepNumber() === 0){
	                        thisStep = 0;
	                    }
	                    //$log.log('steps[thisStep] Data: ', $scope.getEnabledSteps()[thisStep].canexit);
	                    $q.all([canExitStep($scope.getEnabledSteps()[thisStep], step), canEnterStep(step)]).then(function(data) {
	                        if(data[0] && data[1]){
	                            //deselect all steps so you can set fresh below
	                            unselectAll();
	
	                            //$log.log('value for canExit argument: ', $scope.currentStep.canexit);
	                            $scope.selectedStep = step;
	                            //making sure current step is not undefined
	                            if(!angular.isUndefined($scope.currentStep)){
	                                $scope.currentStep = step.wzTitle;
	                            }
	                            //setting selected step to argument passed into goTo()
	                            step.selected = true;
	                            //emit event upwards with data on goTo() invoktion
	                            $scope.$emit('wizard:stepChanged', {step: step, index: stepIdx(step)});
	                            //$log.log('current step number: ', $scope.currentStepNumber());
	                        } else {
	                            $scope.$emit('wizard:stepChangeFailed', {step: step, index: _.indexOf($scope.getEnabledSteps(), step)});
	                        }
	                    });
	                }
	            };
	
	            function canEnterStep(step) {
	                var defer;
	                var canEnter;
	                //If no validation function is provided, allow the user to enter the step
	                if(step.canenter === undefined){
	                    return true;
	                }
	                //If canenter is a boolean value instead of a function, return the value
	                if(typeof step.canenter === 'boolean'){
	                    return step.canenter;
	                }
	                //If canenter is a string instead of a function, evaluate the function
	                if(typeof step.canenter === 'string'){
	                    var splitFunction = step.canenter.split('(');
	                    canEnter = eval('$scope.$parent.' + splitFunction[0] + '($scope.context' + splitFunction[1])
	                } else {
	                    canEnter = step.canenter($scope.context);
	                }
	                //Check to see if the canenter function is a promise which needs to be returned
	                if(angular.isFunction(canEnter.then)){
	                    defer = $q.defer();
	                    canEnter.then(function(response){
	                        defer.resolve(response);
	                    });
	                    return defer.promise;
	                } else {
	                    return canEnter === true;
	                }
	            }
	
	            function canExitStep(step, stepTo) {
	                var defer;
	                var canExit;
	                //Exiting the step should be allowed if no validation function was provided or if the user is moving backwards
	                if(typeof(step.canexit) === 'undefined' || $scope.getStepNumber(stepTo) < $scope.currentStepNumber()){
	                    return true;
	                }
	                //If canexit is a boolean value instead of a function, return the value
	                if(typeof step.canexit === 'boolean'){
	                    return step.canexit;
	                }
	                //If canenter is a string instead of a function, evaluate the function
	                if(typeof step.canexit === 'string'){
	                    var splitFunction = step.canexit.split('(');
	                    canExit = eval('$scope.$parent.' + splitFunction[0] + '($scope.context' + splitFunction[1])
	                } else {
	                    canExit = step.canexit($scope.context);
	                }
	                //Check to see if the canexit function is a promise which needs to be returned
	                if(angular.isFunction(canExit.then)){
	                    defer = $q.defer();
	                    canExit.then(function(response){
	                        defer.resolve(response);
	                    });
	                    return defer.promise;
	                } else {
	                    return canExit === true;
	                }
	            }
	
	            $scope.currentStepNumber = function() {
	                //retreive current step number
	                return stepIdx($scope.selectedStep) + 1;
	            };
	
	            $scope.getEnabledSteps = function() {
	                return $scope.steps.filter(function(step){
	                    return step && step.disabled !== 'true';
	                });
	            };
	
	            //unSelect All Steps
	            function unselectAll() {
	                //traverse steps array and set each "selected" property to false
	                angular.forEach($scope.getEnabledSteps(), function (step) {
	                    step.selected = false;
	                });
	                //set selectedStep variable to null
	                $scope.selectedStep = null;
	            }
	
	            //ALL METHODS ATTACHED TO this ARE ACCESSIBLE VIA WizardHandler.wizard().methodName()
	
	            this.currentStepTitle = function(){
	                return $scope.selectedStep.wzTitle;
	            };
	
	            this.currentStepDescription = function(){
	                return $scope.selectedStep.description;
	            };
	
	            this.currentStep = function(){
	                return $scope.selectedStep;
	            };
	
	            this.totalStepCount = function() {
	                return $scope.getEnabledSteps().length;
	            };
	
	            //Access to enabled steps from outside
	            this.getEnabledSteps = function(){
	                return $scope.getEnabledSteps();
	            };
	
	            //Access to current step number from outside
	            this.currentStepNumber = function(){
	                return $scope.currentStepNumber();
	            };
	            //method used for next button within step
	            this.next = function(callback) {
	                var enabledSteps = $scope.getEnabledSteps();
	                //setting variable equal to step  you were on when next() was invoked
	                var index = stepIdx($scope.selectedStep);
	                //checking to see if callback is a function
	                if(angular.isFunction(callback)){
	                   if(callback()){
	                        if (index === enabledSteps.length - 1) {
	                            this.finish();
	                        } else {
	                            //invoking goTo() with step number next in line
	                            $scope.goTo(enabledSteps[index + 1]);
	                        }
	                   } else {
	                        return;
	                   }
	                }
	                if (!callback) {
	                    //completed property set on scope which is used to add class/remove class from progress bar
	                    $scope.selectedStep.completed = true;
	                }
	                //checking to see if this is the last step.  If it is next behaves the same as finish()
	                if (index === enabledSteps.length - 1) {
	                    this.finish();
	                } else {
	                    //invoking goTo() with step number next in line
	                    $scope.goTo(enabledSteps[index + 1]);
	                }
	
	            };
	
	            //used to traverse to any step, step number placed as argument
	            this.goTo = function(step) {
	                //wrapped inside $timeout so newly enabled steps are included.
	                $timeout(function() {
	                    var enabledSteps = $scope.getEnabledSteps();
	                    var stepTo;
	                    //checking that step is a Number
	                    if (angular.isNumber(step)) {
	                        stepTo = enabledSteps[step];
	                    } else {
	                        //finding the step associated with the title entered as goTo argument
	                        stepTo = stepByTitle(step);
	                    }
	                    //going to step
	                    $scope.goTo(stepTo);
	                });
	            };
	
	            //calls finish() which calls onFinish() which is declared on an attribute and linked to controller via wizard directive.
	            this.finish = function() {
	                if ($scope.onFinish) {
	                    $scope.onFinish();
	                }
	            };
	
	            this.previous = function() {
	                //getting index of current step
	                var index = stepIdx($scope.selectedStep);
	                //ensuring you aren't trying to go back from the first step
	                if (index === 0) {
	                    throw new Error("Can't go back. It's already in step 0");
	                } else {
	                    //go back one step from current step
	                    $scope.goTo($scope.getEnabledSteps()[index - 1]);
	                }
	            };
	
	            //cancel is alias for previous.
	            this.cancel = function() {
	            	if ($scope.onCancel) {
	                    //onCancel is linked to controller via wizard directive:
	                    $scope.onCancel();
	                } else {
	                    //getting index of current step
	                    var index = stepIdx($scope.selectedStep);
	                    //ensuring you aren't trying to go back from the first step
	                    if (index === 0) {
	                        throw new Error("Can't go back. It's already in step 0");
	                    } else {
	                        //go back one step from current step
	                        $scope.goTo($scope.getEnabledSteps()[0]);
	                    }                	
	                }
	            };
	
	            //reset
	            this.reset = function(){
	                //traverse steps array and set each "completed" property to false
	                angular.forEach($scope.getEnabledSteps(), function (step) {
	                    step.completed = false;
	                });
	                //go to first step
	                this.goTo(0);
	            };
	
	            //change edit mode
	            this.setEditMode = function(mode) {
	                $scope.editMode = mode;
	                handleEditModeChange();
	            };
	        }]
	    };
	});
	
	function wizardButtonDirective(action) {
	    angular.module('mgo-angular-wizard')
	        .directive(action, function() {
	            return {
	                restrict: 'A',
	                replace: false,
	                require: '^wizard',
	                link: function($scope, $element, $attrs, wizard) {
	
	                    $element.on("click", function(e) {
	                        e.preventDefault();
	                        $scope.$apply(function() {
	                            $scope.$eval($attrs[action]);
	                            wizard[action.replace("wz", "").toLowerCase()]();
	                        });
	                    });
	                }
	            };
	        });
	}
	
	wizardButtonDirective('wzNext');
	wizardButtonDirective('wzPrevious');
	wizardButtonDirective('wzFinish');
	wizardButtonDirective('wzCancel');
	wizardButtonDirective('wzReset');
	
	angular.module('mgo-angular-wizard').factory('WizardHandler', function() {
	   var service = {};
	   
	   var wizards = {};
	   
	   service.defaultName = "defaultWizard";
	   
	   service.addWizard = function(name, wizard) {
	       wizards[name] = wizard;
	   };
	   
	   service.removeWizard = function(name) {
	       delete wizards[name];
	   };
	   
	   service.wizard = function(name) {
	       var nameToUse = name;
	       if (!name) {
	           nameToUse = service.defaultName;
	       }
	       
	       return wizards[nameToUse];
	   };
	   
	   return service;
	});


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.2
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5,
	  urlErrorParamsEnabled: true
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 *
	 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
	 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
	 *   generated error url is very long.
	 *
	 *   Default: true. When used without argument, it returns the current value.
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
	      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * AngularJS. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace'). Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	
	  var url = 'https://errors.angularjs.org/1.8.2/';
	  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
	  var errRegExp = new RegExp(regex, 'g');
	
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    // A minErr message has two parts: the message itself and the url that contains the
	    // encoded message.
	    // The message's parameters can contain other error messages which also include error urls.
	    // To prevent the messages from getting too long, we strip the error urls from the parameters.
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index].replace(errRegExp, '');
	      }
	
	      return match;
	    });
	
	    message += '\n' + url + (module ? module + '/' : '') + code;
	
	    if (minErrConfig.urlErrorParamsEnabled) {
	      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	      }
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  addDateMinutes,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	  UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (key !== '__proto__') {
	            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	            baseExtend(dst[key], [src], true);
	          }
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest using another, similar library for all-purpose merging,
	* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* `angular.merge` also does not support merging objects with circular references.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	function isArray(arr) {
	  return Array.isArray(arr) || arr instanceof Array;
	}
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
	 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
	 * function, and has several limitations (see below).
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 *
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 *   `angular.copy` does not check if destination and source are of the same type. It's the
	 *   developer's responsibility to make sure they are compatible.
	 * </div>
	 *
	 * @knownIssue
	 * This is a non-exhaustive list of object types / features that are not handled correctly by
	 * `angular.copy`. Note that since this functions is used by the change detection code, this
	 * means binding or watching objects of these types (or that include these types) might not work
	 * correctly.
	 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
	 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
	 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
	 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
	 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
	 * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
	 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
	 *
	 * @param {*} source The source that will be used to make a copy. Can be any type, including
	 *     primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
	 *     must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>leader = {{leader | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.leader = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.leader);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.leader);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since AngularJS uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div></div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for banned URL schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * @example
	 *
	 * ### Simple Usage
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * @example
	 *
	 * ### With `ngStrictDi`
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up AngularJS application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of AngularJS try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of AngularJS on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	  } else {
	    jqLite = JQLite;
	  }
	
	  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
	  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
	  // the $destroy event on all removed nodes.
	  originalCleanData = jqLite.cleanData;
	  jqLite.cleanData = function(elems) {
	    var events;
	    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	      events = (jqLite._data(elem) || {}).events;
	      if (events && events.$destroy) {
	        jqLite(elem).triggerHandler('$destroy');
	      }
	    }
	    originalCleanData(elems);
	  };
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
	 * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
	 * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
	 * your code for this change and remove your use of this function as soon as possible.
	
	 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
	 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
	 * about the workarounds.
	 */
	function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
	  JQLite.legacyXHTMLReplacement = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring AngularJS {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
	     * modules.
	     * All modules (AngularJS core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	           *    or an object map of components where the keys are the names and the values are the component definition objects.
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to configure services by injecting their
	           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
	           * {@link ngRoute.$routeProvider $routeProvider}.
	           *
	           * Note that you can only inject {@link angular.Module#provider `providers`} and
	           * {@link angular.Module#constant `constants`} into this function.
	           *
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  hiddenInputBrowserCacheDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRefDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $$IntervalFactoryProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $$TaskTrackerFactoryProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.8.2',
	  major: 1,
	  minor: 8,
	  dot: 2,
	  codeName: 'meteoric-mining'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    'UNSAFE_restoreLegacyJqLiteXHTMLReplacement': UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$lowercase': lowercase,
	    '$$stringify': stringify,
	    '$$uppercase': uppercase
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRef: ngRefDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective,
	          input: hiddenInputBrowserCacheDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $$intervalFactory: $$IntervalFactoryProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.8.2' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## AngularJS's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
	 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
	 * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
	 * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
	 * ```js
	 * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
	 * ```
	 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
	 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
	 * about the workarounds.
	 *
	 * ## jQuery/jqLite Extras
	 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	// Table parts need to be wrapped with `<table>` or they're
	// stripped to their contents when put in a div.
	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do, so we cannot shorten
	// this by omitting <tbody> or other required elements.
	var wrapMap = {
	  thead: ['table'],
	  col: ['colgroup', 'table'],
	  tr: ['tbody', 'table'],
	  td: ['tr', 'tbody', 'table']
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <10 only
	// IE 9 requires an option wrapper & it needs to have the whole table structure
	// set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
	var wrapMapIE9 = {
	  option: [1, '<select multiple="multiple">', '</select>'],
	  _default: [0, '', '']
	};
	
	for (var key in wrapMap) {
	  var wrapMapValueClosing = wrapMap[key];
	  var wrapMapValue = wrapMapValueClosing.slice().reverse();
	  wrapMapIE9[key] = [wrapMapValue.length, '<' + wrapMapValue.join('><') + '>', '</' + wrapMapValueClosing.join('></') + '>'];
	}
	
	wrapMapIE9.optgroup = wrapMapIE9.option;
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap, finalHtml,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    finalHtml = JQLite.legacyXHTMLReplacement ?
	      html.replace(XHTML_TAG_REGEXP, '<$1></$2>') :
	      html;
	
	    if (msie < 10) {
	      wrap = wrapMapIE9[tag] || wrapMapIE9._default;
	      tmp.innerHTML = wrap[1] + finalHtml + wrap[2];
	
	      // Descend through wrappers to the right content
	      i = wrap[0];
	      while (i--) {
	        tmp = tmp.firstChild;
	      }
	    } else {
	      wrap = wrapMap[tag] || [];
	
	      // Create wrappers & descend into them
	      i = wrap.length;
	      while (--i > -1) {
	        tmp.appendChild(window.document.createElement(wrap[i]));
	        tmp = tmp.firstChild;
	      }
	
	      tmp.innerHTML = finalHtml;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function isEmptyObject(obj) {
	  var name;
	
	  for (name in obj) {
	    return false;
	  }
	  return true;
	}
	
	function removeIfEmptyData(element) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  var events = expandoStore && expandoStore.events;
	  var data = expandoStore && expandoStore.data;
	
	  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	
	  removeIfEmptyData(element);
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	    } else {
	      expandoStore.data = {};
	    }
	
	    removeIfEmptyData(element);
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        newClasses += cssClass + ' ';
	      }
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	      jqLiteOff(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key !== this._lastKey) {
	      this._lastKey = key;
	      this._lastIndex = this._keys.indexOf(key);
	    }
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  has: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    return idx !== -1;
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running AngularJS app
	 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * ## Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ### Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ### `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ### Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * #### Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * #### The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * #### The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	/**
	 * @ngdoc method
	 * @name $injector#loadNewModules
	 *
	 * @description
	 *
	 * **This is a dangerous API, which you use at your own risk!**
	 *
	 * Add the specified modules to the current injector.
	 *
	 * This method will add each of the injectables to the injector and execute all of the config and run
	 * blocks for each module passed to the method.
	 *
	 * If a module has already been loaded into the injector then it will not be loaded again.
	 *
	 * * The application developer is responsible for loading the code containing the modules; and for
	 * ensuring that lazy scripts are not downloaded and executed more often that desired.
	 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
	 * * Modules cannot be unloaded.
	 *
	 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
	 * into the injector, which may indicate whether the script has been executed already.
	 *
	 * @example
	 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
	 *
	 * ```javascript
	 * app.factory('loadModule', function($injector) {
	 *   return function loadModule(moduleName, bundleUrl) {
	 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
	 *   };
	 * })
	 * ```
	 *
	 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * It is possible to inject other providers into the provider function,
	 * but the injected provider must have been defined before the one that requires it.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  instanceInjector.loadNewModules = function(mods) {
	    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
	  };
	
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * <div class="alert alert-warning">
	       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
	       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
	       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
	       * However, there are two exceptions:
	       *
	       * <ul>
	       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
	       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
	       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
	       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
	       *   the `setClass` event, but if it either removes or adds classes,
	       *   it will fire `animate` instead.</li>
	       * </ul>
	       *
	       * </div>
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered.
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       * * `data` - an object with these properties:
	       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
	       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
	       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
	       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
	       *
	       * Note that the callback does not trigger a scope digest. Wrap your call into a
	       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation and applies the end state of the animation.
	       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
	       * adding the element to the DOM.
	       *
	       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
	       *
	       * @example
	        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
	          <file name="app.js">
	            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
	              templateUrl: 'template.html',
	              controller: function($element, $animate) {
	                this.runner = null;
	
	                this.addClass = function() {
	                  this.runner = $animate.addClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.removeClass = function() {
	                  this.runner = $animate.removeClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.cancel = function() {
	                  $animate.cancel(this.runner);
	                };
	              }
	            });
	          </file>
	          <file name="template.html">
	            <p>
	              <button id="add" ng-click="$ctrl.addClass()">Add</button>
	              <button ng-click="$ctrl.removeClass()">Remove</button>
	              <br>
	              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
	              <br>
	              <div id="target">CSS-Animated Text</div>
	            </p>
	          </file>
	          <file name="index.html">
	            <cancel-example></cancel-example>
	          </file>
	          <file name="style.css">
	            .red-add, .red-remove {
	              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
	            }
	
	            .red,
	            .red-add.red-add-active {
	              color: #FF0000;
	              font-size: 40px;
	            }
	
	            .red-remove.red-remove-active {
	              font-size: 10px;
	              color: black;
	            }
	
	          </file>
	        </example>
	       */
	      cancel: function(runner) {
	        if (runner.cancel) {
	          runner.cancel();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} animationRunner the animation runner
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global getHash: true, stripHash: false */
	
	function getHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? '' : url.substr(index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/#$/, '');
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {},
	      taskTracker = $$taskTrackerFactory($log);
	
	  self.isMock = false;
	
	  //////////////////////////////////////////////////////////////
	  // Task-tracking API
	  //////////////////////////////////////////////////////////////
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = taskTracker.completeTask;
	  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;
	
	  // TODO(vojta): prefix this method with $$ ?
	  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of `location.href` (with a
	   * trailing `#` stripped of if the hash is empty).
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
	   * `location.href`/`location.replace` is used.
	   * Returns its own instance to allow chaining.
	   *
	   * NOTE: this api is intended for use only by the `$location` service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state State object to use with `pushState`/`replaceState`
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Normalize the inputted URL
	      url = urlResolve(url).href;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      return trimEmptyHash(pendingLocation || location.href);
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of AngularJS:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of AngularJS.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay, taskType) {
	    var timeoutId;
	
	    delay = delay || 0;
	    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;
	
	    taskTracker.incTaskCount(taskType);
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      taskTracker.completeTask(fn, taskType);
	    }, delay);
	    pendingDeferIds[timeoutId] = taskType;
	
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds.hasOwnProperty(deferId)) {
	      var taskType = pendingDeferIds[deferId];
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      taskTracker.completeTask(noop, taskType);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
	       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
	    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
	       * directive to cache templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
	 * {@link ng.$cacheFactory $cacheFactory}.
	 *
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
	 * or by consuming the `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
	 * element with {@link ngApp} attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with life-cycle hooks in the new Angular
	 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
	 *
	 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
	 *   `ngDoCheck` in Angular.
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance.)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
	 *   isn't  optional and doesn't exist, an exception
	 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
	 *   to the local value, since it will be impossible to sync them back to the parent scope.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr`
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   It's also possible to watch the evaluated value shallowly with
	 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
	 * The marker must come after the mode and before the attribute name.
	 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
	 * This is useful to refine the interface directives provide.
	 * One subtle difference between optional and non-optional happens **when the binding attribute is not
	 * set**:
	 * - the binding is optional: the property will not be defined
	 * - the binding is not optional: the property is defined
	 *
	 * ```js
	 *app.directive('testDir', function() {
	    return {
	      scope: {
	        notoptional: '=',
	        optional: '=?',
	      },
	      bindToController: true,
	      controller: function() {
	        this.$onInit = function() {
	          console.log(this.hasOwnProperty('notoptional')) // true
	          console.log(this.hasOwnProperty('optional')) // false
	        }
	      }
	    }
	  })
	 *```
	 *
	 *
	 * ##### Combining directives with different scope defintions
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace`
	 * <div class="alert alert-danger">
	 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
	 * </div>
	 *
	 * Specifies what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that are defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
	 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // Configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects '$compile'.
	        $compileProvider.directive('compile', function($compile) {
	          // The directive factory creates a link function.
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                // Watch the 'compile' expression for changes.
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // When the 'compile' expression changes
	                // assign it into the current DOM.
	                element.html(value);
	
	                // Compile the new DOM and link it to the current scope.
	                // NOTE: we only compile '.childNodes' so that we
	                // don't get into an infinite loop compiling ourselves.
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'AngularJS';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello AngularJS'.
	       expect(output.getText()).toBe('Hello AngularJS');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('AngularJS!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
	 *        elements (e.g. SVG elements). See also the `directive.controller` property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to `$digest`, which typically is done by
	 * AngularJS automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = angular.element('<p>{{total}}</p>');
	 *     $compile(element)(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
	 *   linking function:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>');
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       // Attach the clone to DOM document at the right place.
	 *     });
	 *
	 *     // Now we have reference to the cloned DOM via `clonedElement`.
	 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
	 *     //       `clonedElement` passed to `cloneAttachFn`.
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	
	 * @knownIssue
	
	   ### Issues with `replace: true`
	 *
	 * <div class="alert alert-danger">
	 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
	 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
	 * </div>
	 *
	 * #### Attribute values are not merged
	 *
	 * When a `replace` directive encounters the same attribute on the original and the replace node,
	 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
	 * the `style` attribute.
	 * ```html
	 * Original Node: <span class="original" style="color: red;"></span>
	 * Replace Template: <span class="replaced" style="background: blue;"></span>
	 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
	 * ```
	 *
	 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
	 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
	 *
	 * ```html
	 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
	 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
	 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
	 * ```
	 *
	 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
	 *
	 * #### Directives are not deduplicated before compilation
	 *
	 * When the original node and the replace template declare the same directive(s), they will be
	 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
	 * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
	 * attach `$formatters` and `$parsers` twice.
	 *
	 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
	 *
	 * #### `transclude: element` in the replace template root can have unexpected effects
	 *
	 * When the replace template has a directive at the root node that uses
	 * {@link $compile#-transclude- `transclude: element`}, e.g.
	 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
	 * See the following issues:
	 *
	 * - Incorrect scope on replaced element:
	 * [#9837](https://github.com/angular/angular.js/issues/9837)
	 * - Different DOM between `template` and `templateUrl`:
	 * [#10612](https://github.com/angular/angular.js/issues/14326)
	 *
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngProp
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-prop-propname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "propName"):
	 *
	 *
	 * ```html
	 * <ANY ng-prop-prop_name="expression">
	 * </ANY>
	 * ```
	 *
	 *
	 * @description
	 * The `ngProp` directive binds an expression to a DOM element property.
	 * `ngProp` allows writing to arbitrary properties by including
	 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
	 * the `value` property.
	 *
	 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
	 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
	 *
	 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
	 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
	 * custom elements.
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
	 * example, and for binding HTML {@link ngBindHtml} should be used.
	 *
	 * ## Security
	 *
	 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
	 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
	 * malicious code.
	 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
	 * This means vulnerable properties require their content to be "trusted", based on the
	 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
	 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
	 * this property are trusted as a `RESOURCE_URL`.
	 *
	 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
	 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
	 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
	 *
	 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
	 *
	 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
	 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
	 * the {@link $sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList()}
	 * and {@link $sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList()}.
	 *
	 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
	 *
	 * ### HTML Sanitization
	 *
	 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
	 * content.
	 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
	 * potentially dangerous HTML, e.g. strip non-trusted tags and attributes when binding to
	 * `innerHTML`.
	 *
	 * @example
	 * ### Binding to different contexts
	 *
	 * <example name="ngProp" module="exampleNgProp">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         Binding to a property without security context:
	 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerText</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... so that actually dangerous content cannot be executed:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Binding to innerHTML with ngSanitize
	 *
	 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', ['ngSanitize'])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         "Safe" content will be sanitized ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... as will dangerous content:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 */
	
	/** @ngdoc directive
	 * @name ngOn
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-on-eventname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "eventName"):
	 *
	 *
	 * ```html
	 * <ANY ng-on-event_name="expression">
	 * </ANY>
	 * ```
	 *
	 * @description
	 * The `ngOn` directive adds an event listener to a DOM element via
	 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
	 * fired.
	 * `ngOn` allows adding listeners for arbitrary events by including
	 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
	 * when the `drop` event is fired.
	 *
	 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
	 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
	 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
	 * standards.
	 *
	 * Another use-case for `ngOn` is listening to
	 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
	 * fired by
	 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `myEvent` must be written as `ng-on-my_event="expression"`.
	 *
	 * @example
	 * ### Bind to built-in DOM events
	 *
	 * <example name="ngOn" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.clickCount = 0;
	 *           this.mouseoverCount = 0;
	 *
	 *           this.loadingState = 0;
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
	 *       <button
	 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
	 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
	 *       clickCount: {{$ctrl.clickCount}}<br>
	 *       mouseover: {{$ctrl.mouseoverCount}}
	 *
	 *       <hr>
	 *
	 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
	 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
	 *       <div ng-switch="$ctrl.loadingState">
	 *         <span ng-switch-when="0">Image is loading</span>
	 *         <span ng-switch-when="-1">Image load error</span>
	 *         <span ng-switch-when="1">Image loaded successfully</span>
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Bind to custom DOM events
	 *
	 * <example name="ngOnCustom" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.eventLog = '';
	 *
	 *           this.listener = function($event) {
	 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
	 *           };
	 *         }
	 *       })
	 *       .component('childComponent', {
	 *         templateUrl: 'child.html',
	 *         controller: function($element) {
	 *           this.fireEvent = function() {
	 *             var event = new CustomEvent('customtype', { detail: new Date()});
	 *
	 *             $element[0].dispatchEvent(event);
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
	 *     <span>Event log: {{$ctrl.eventLog}}</span>
	 *   </file>
	 *   <file name="child.html">
	      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      definition = definition.trim();
	
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
	   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
	   *    are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationTrustedUrlList
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationTrustedUrlList`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $compileProvider#aHrefSanitizationTrustedUrlList
	   * aHrefSanitizationTrustedUrlList} instead.
	   */
	  Object.defineProperty(this, 'aHrefSanitizationWhitelist', {
	    get: function() {
	      return this.aHrefSanitizationTrustedUrlList;
	    },
	    set: function(value) {
	      this.aHrefSanitizationTrustedUrlList = value;
	    }
	  });
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationTrustedUrlList
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationTrustedUrlList`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $compileProvider#imgSrcSanitizationTrustedUrlList
	   * imgSrcSanitizationTrustedUrlList} instead.
	   */
	  Object.defineProperty(this, 'imgSrcSanitizationWhitelist', {
	    get: function() {
	      return this.imgSrcSanitizationTrustedUrlList;
	    },
	    set: function(value) {
	      this.imgSrcSanitizationTrustedUrlList = value;
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `ng-scope` and `ng-isolated-scope` CSS classes
	   * * `$binding` data property containing an array of the binding expressions
	   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
	   *   the element's scope.
	   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
	   *   E.g. `<!-- ngIf: shouldShow() -->`.
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
	   * otherwise return the current strictComponentBindingsEnabled state.
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable / disable the strict component bindings check. If enabled, the
	   * compiler will enforce that all scope / controller bindings of a
	   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
	   * that are not set as optional with `?`, must be provided when the directive is instantiated.
	   * If not provided, the compiler will throw the
	   * {@link error/$compile/missingattr $compile:missingattr error}.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	
	  /**
	   * The security context of DOM Properties.
	   * @private
	   */
	  var PROP_CONTEXTS = createMap();
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#addPropertySecurityContext
	   * @description
	   *
	   * Defines the security context for DOM properties bound by ng-prop-*.
	   *
	   * @param {string} elementName The element name or '*' to match any element.
	   * @param {string} propertyName The DOM property name.
	   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
	   * @returns {object} `this` for chaining
	   */
	  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
	    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());
	
	    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
	      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
	    }
	
	    PROP_CONTEXTS[key] = ctx;
	    return this;
	  };
	
	  /* Default property contexts.
	   *
	   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
	   * Changing:
	   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
	   * - STYLE => CSS
	   * - various URL => MEDIA_URL
	   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
	   */
	  (function registerNativePropertyContexts() {
	    function registerContext(ctx, values) {
	      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
	    }
	
	    registerContext(SCE_CONTEXTS.HTML, [
	      'iframe|srcdoc',
	      '*|innerHTML',
	      '*|outerHTML'
	    ]);
	    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
	    registerContext(SCE_CONTEXTS.URL, [
	      'area|href',       'area|ping',
	      'a|href',          'a|ping',
	      'blockquote|cite',
	      'body|background',
	      'del|cite',
	      'input|src',
	      'ins|cite',
	      'q|cite'
	    ]);
	    registerContext(SCE_CONTEXTS.MEDIA_URL, [
	      'audio|src',
	      'img|src',    'img|srcset',
	      'source|src', 'source|srcset',
	      'track|src',
	      'video|src',  'video|poster'
	    ]);
	    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
	      '*|formAction',
	      'applet|code',      'applet|codebase',
	      'base|href',
	      'embed|src',
	      'frame|src',
	      'form|action',
	      'head|profile',
	      'html|manifest',
	      'iframe|src',
	      'link|href',
	      'media|src',
	      'object|codebase',  'object|data',
	      'script|src'
	    ]);
	  })();
	
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function sanitizeSrcset(value, invokeType) {
	      if (!value) {
	        return value;
	      }
	      if (!isString(value)) {
	        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
	      }
	
	      // Such values are a bit too complex to handle automatically inside $sce.
	      // Instead, we sanitize each of the URIs individually, which works, even dynamically.
	
	      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
	      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
	      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
	      // `ng-bind-html` directive.
	
	      var result = '';
	
	      // first check if there are spaces because it's not the same pattern
	      var trimmedSrcset = trim(value);
	      //                (   999x   ,|   999w   ,|   ,|,   )
	      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	      // split srcset into tuple of uri and descriptor except for the last item
	      var rawUris = trimmedSrcset.split(pattern);
	
	      // for each tuples
	      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	      for (var i = 0; i < nbrUrisWith2parts; i++) {
	        var innerIdx = i * 2;
	        // sanitize the uri
	        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
	        // add the descriptor
	        result += ' ' + trim(rawUris[innerIdx + 1]);
	      }
	
	      // split the last item into uri and descriptor
	      var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	      // sanitize the last uri
	      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));
	
	      // and add the last descriptor if any
	      if (lastTuple.length === 2) {
	        result += (' ' + trim(lastTuple[1]));
	      }
	      return result;
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        // is set through this function since it may cause $updateClass to
	        // become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        // Sanitize img[srcset] values.
	        if (nodeName === 'img' && key === 'srcset') {
	          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              // jQuery skips special boolean attrs treatment in XML nodes for
	              // historical reasons and hence AngularJS cannot freely call
	              // `.attr(attrName, false) with such attributes. To avoid issues
	              // in XHTML, call `removeAttr` in such cases instead.
	              // See https://github.com/jquery/jquery/issues/4249
	              if (booleanKey && value === false) {
	                this.$$element.removeAttr(attrName);
	              } else {
	                this.$$element.attr(attrName, value);
	              }
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            var isNgAttr = false, isNgProp = false, isNgEvent = false;
	            var multiElementMatch;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            nName = directiveNormalize(name.toLowerCase());
	
	            // Support ng-attr-*, ng-prop-* and ng-on-*
	            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
	              isNgAttr = ngPrefixMatch[1] === 'Attr';
	              isNgProp = ngPrefixMatch[1] === 'Prop';
	              isNgEvent = ngPrefixMatch[1] === 'On';
	
	              // Normalize the non-prefixed name
	              name = name.replace(PREFIX_REGEXP, '')
	                .toLowerCase()
	                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	
	            // Support *-start / *-end multi element directives
	            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            if (isNgProp || isNgEvent) {
	              attrs[nName] = value;
	              attrsMap[nName] = attr.name;
	
	              if (isNgProp) {
	                addPropertyDirective(node, directives, nName, name);
	              } else {
	                addEventDirective(directives, nName, name);
	              }
	            } else {
	              // Update nName for cases where a prefix was removed
	              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
	              nName = directiveNormalize(name.toLowerCase());
	              attrsMap[nName] = name;
	
	              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	              }
	
	              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                            attrEndName);
	            }
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = window.document.createDocumentFragment();
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
	                  slots[slotName].appendChild(node);
	                } else {
	                  $template.appendChild(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
	                }
	              }
	
	              $template = jqLite($template.childNodes);
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          controller.instance = controller();
	          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	          controller.bindingInfo =
	            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	
	          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
	            // inheritedData() uses the documentElement when it finds the document, so we would
	            // require from the element itself.
	            value = null;
	          } else {
	            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	          }
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedAttrContext(nodeName, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      // All nodes with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media nodes, which require the MEDIA_URL context.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	        return $sce.MEDIA_URL;
	      } else if (attrNormalizedName === 'xlinkHref') {
	        // Some xlink:href are okay, most aren't
	        if (nodeName === 'image') return $sce.MEDIA_URL;
	        if (nodeName === 'a') return $sce.URL;
	        return $sce.RESOURCE_URL;
	      } else if (
	          // Formaction
	          (nodeName === 'form' && attrNormalizedName === 'action') ||
	          // If relative URLs can go where they are not expected to, then
	          // all sorts of trust issues can arise.
	          (nodeName === 'base' && attrNormalizedName === 'href') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (nodeName === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
	                                 attrNormalizedName === 'ngHref')) {
	        return $sce.URL;
	      }
	    }
	
	    function getTrustedPropContext(nodeName, propNormalizedName) {
	      var prop = propNormalizedName.toLowerCase();
	      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
	    }
	
	    function sanitizeSrcsetPropertyValue(value) {
	      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
	    }
	    function addPropertyDirective(node, directives, attrName, propName) {
	      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
	        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
	      }
	
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedPropContext(nodeName, propName);
	
	      var sanitizer = identity;
	      // Sanitize img[srcset] + source[srcset] values.
	      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
	        sanitizer = sanitizeSrcsetPropertyValue;
	      } else if (trustedContext) {
	        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function ngPropCompileFn(_, attr) {
	          var ngPropGetter = $parse(attr[attrName]);
	          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
	            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	            return $sce.valueOf(val);
	          });
	
	          return {
	            pre: function ngPropPreLinkFn(scope, $element) {
	              function applyPropValue() {
	                var propValue = ngPropGetter(scope);
	                $element[0][propName] = sanitizer(propValue);
	              }
	
	              applyPropValue();
	              scope.$watch(ngPropWatch, applyPropValue);
	            }
	          };
	        }
	      });
	    }
	
	    function addEventDirective(directives, attrName, eventName) {
	      directives.push(
	        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
	      );
	    }
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedAttrContext(nodeName, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var isLiteral = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            });
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in AngularJS:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by AngularJS to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {};
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in AngularJS expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          if (isFunction(toSerialize)) {
	            toSerialize = toSerialize();
	          }
	          parts.push(encodeUriQuery(prefix) + '=' +
	              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   */
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   */
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   */
	  var interceptorFactories = this.interceptors = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfTrustedOrigins
	   * @description
	   *
	   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
	   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
	   * XSRF.
	   *
	   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
	   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
	   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
	   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
	   * Examples: `http://example.com`, `https://api.example.com:9876`
	   *
	   * <div class="alert alert-warning">
	   *   It is not possible to trust specific URLs/paths. The `path`, `query` and `fragment` parts
	   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
	   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
	   *   `https://foo.com/` will include the XSRF token.
	   * </div>
	   *
	   * @example
	   *
	   * ```js
	   * // App served from `https://example.com/`.
	   * angular.
	   *   module('xsrfTrustedOriginsExample', []).
	   *   config(['$httpProvider', function($httpProvider) {
	   *     $httpProvider.xsrfTrustedOrigins.push('https://api.example.com');
	   *   }]).
	   *   run(['$http', function($http) {
	   *     // The XSRF token will be sent.
	   *     $http.get('https://api.example.com/preferences').then(...);
	   *
	   *     // The XSRF token will NOT be sent.
	   *     $http.get('https://stats.example.com/activity').then(...);
	   *   }]);
	   * ```
	   */
	  var xsrfTrustedOrigins = this.xsrfTrustedOrigins = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfWhitelistedOrigins
	   * @description
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This property is deprecated. Use {@link $httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}
	   * instead.
	   */
	  Object.defineProperty(this, 'xsrfWhitelistedOrigins', {
	    get: function() {
	      return this.xsrfTrustedOrigins;
	    },
	    set: function(origins) {
	      this.xsrfTrustedOrigins = origins;
	    }
	  });
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * A function to check request URLs against a list of allowed origins.
	     */
	    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfTrustedOrigins);
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core AngularJS service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
	     * resolved (request success) or rejected (request failure) with a
	     * {@link ng.$http#$http-returns response} object.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * AngularJS provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * AngularJS will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * AngularJS will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
	     * the cookie, your server can be assured that the XHR came from JavaScript running on your
	     * domain.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
	     * sure that only JavaScript running on your domain could have sent the request. The token must
	     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
	     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
	     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
	     * want to, you can trust additional origins to also receive the XSRF token, by adding them
	     * to {@link ng.$httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}. This might be
	     * useful, for example, if your application, served from `example.com`, needs to access your API
	     * at `api.example.com`.
	     * See {@link ng.$httpProvider#xsrfTrustedOrigins $httpProvider.xsrfTrustedOrigins} for
	     * more details.
	     *
	     * <div class="alert alert-danger">
	     *   **Warning**<br />
	     *   Only trusted origins that you have control over and make sure you understand the
	     *   implications of doing so.
	     * </div>
	     *
	     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
	     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
	     * `$http.defaults` at run-time, or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple AngularJS apps share the
	     * same domain or subdomain, we recommend that each application uses a unique cookie name.
	     *
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *
	     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
	     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
	     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
	     *
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
	     *   or rejected (request failure) with a response object.
	     *
	     *   The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with
	     *     the transform functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used
	     *     to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
	     *     (`complete`, `error`, `timeout` or `abort`).
	     *
	     *
	     *   A response status code between 200 and 299 is considered a success status
	     *   and will result in the success callback being called. Any response status
	     *   code outside of that range is considered an error status and will result
	     *   in the error callback being called.
	     *   Also, status codes less than -1 are normalized to zero. -1 usually means
	     *   the request was aborted, e.g. using a `config.timeout`. More information
	     *   about the status might be available in the `xhrStatus` property.
	     *
	     *   Note that if the response is a redirect, XMLHttpRequest will transparently
	     *   follow it, meaning that the outcome (success or error) will be determined
	     *   by the final response status code.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must add the JSONP endpoint that we are using to the trusted list to show that we trust it
	      $sceDelegateProvider.trustedResourceUrlList([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount('$http');
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop, '$http');
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the trusted resource URL list via
	     * {@link $sceDelegateProvider#trustedResourceUrlList  `$sceDelegateProvider.trustedResourceUrlList`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * You should avoid generating the URL for the JSONP request from user provided data.
	     * Provide additional query parameters via `params` property of the `config` parameter, rather than
	     * modifying the URL itself.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	      * See {@link ng.$http#$http-returns `$http()` return value}.
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsAllowedOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, cbKey) {
	      var parts = url.split('?');
	      if (parts.length > 2) {
	        // Throw if the url contains more than one `?` query indicator
	        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
	      }
	      var params = parseKeyValue(parts[1]);
	      forEach(params, function(value, key) {
	        if (value === 'JSON_CALLBACK') {
	          // Throw if the url already contains a reference to JSON_CALLBACK
	          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	        }
	        if (key === cbKey) {
	          // Throw if the callback param was already provided
	          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
	        }
	      });
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	      var abortedByTimeout = false;
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.ontimeout = requestTimeout;
	      xhr.onabort = requestAborted;
	
	      forEach(eventHandlers, function(value, key) {
	        xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    // Since we are using xhr.abort() when a request times out, we have to set a flag that
	    // indicates to requestAborted if the request timed out or was aborted.
	    //
	    // http.timeout = numerical timeout   timeout
	    // http.timeout = $timeout            timeout
	    // http.timeout = promise             abort
	    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
	    //                                    can be exposed with the xhrFactory)
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(function() {
	        timeoutRequest('timeout');
	      }, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(function() {
	        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
	      });
	    }
	
	    function timeoutRequest(reason) {
	      abortedByTimeout = reason === 'timeout';
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    }
	    return startSymbol;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    }
	    return endSymbol;
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'AngularJS';
	     *   expect(exp(context)).toEqual('Hello AngularJS!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;
	
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        if (mustHaveExpression) return;
	
	        var unescapedText = unescapeText(text);
	        if (contextAllowsConcatenation) {
	          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
	        }
	        var constantInterp = valueFn(unescapedText);
	        constantInterp.exp = text;
	        constantInterp.expressions = [];
	        constantInterp.$$watchDelegate = constantWatchDelegate;
	
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns,
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [],
	          singleExpression;
	
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      singleExpression = concat.length === 1 && expressionPositions.length === 1;
	      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
	      // objects rather than simple strings
	      // (we don't modify the expression if the input consists of only a single trusted input)
	      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
	      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
	      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
	      // that is more testable or make it obvious that you bound the value to some user controlled
	      // value.  This helps reduce the load when auditing for XSS issues.
	
	      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
	      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
	      // or on the overall concatenated string (losing trusted types used in the mix, by design).
	      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
	      // only used in srcdoc attributes, this would not be very useful.
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	
	          if (contextAllowsConcatenation) {
	            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
	            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
	          } else if (trustedContext && concat.length > 1) {
	            // This context does not allow more than one part, e.g. expr + string or exp + exp.
	            $interpolateMinErr.throwNoconcat(text);
	          }
	          // In an unprivileged context or only one part: just concatenate and return.
	          return concat.join('');
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
	          // parts of a full URL. We don't care about losing the trustedness here.
	          // In non-concatenable contexts, where there is only one expression, this interceptor is
	          // not applied to the expression.
	          value = (trustedContext && !contextAllowsConcatenation) ?
	                    $sce.getTrusted(trustedContext, value) :
	                    $sce.valueOf(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	var $intervalMinErr = minErr('$interval');
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$$intervalFactory', '$window',
	       function($$intervalFactory,   $window) {
	    var intervals = {};
	    var setIntervalFn = function(tick, delay, deferred) {
	      var id = $window.setInterval(tick, delay);
	      intervals[id] = deferred;
	      return id;
	    };
	    var clearIntervalFn = function(id) {
	      $window.clearInterval(id);
	      delete intervals[id];
	    };
	
	    /**
	     * @ngdoc service
	     * @name $interval
	     *
	     * @description
	     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	     * milliseconds.
	     *
	     * The return value of registering an interval function is a promise. This promise will be
	     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	     * run indefinitely if `count` is not defined. The value of the notification will be the
	     * number of iterations that have run.
	     * To cancel an interval, call `$interval.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	     * time.
	     *
	     * <div class="alert alert-warning">
	     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	     * with them.  In particular they are not automatically destroyed when a controller's scope or a
	     * directive's element are destroyed.
	     * You should take this into consideration and make sure to always cancel the interval at the
	     * appropriate moment.  See the example below for more details on how and when to do this.
	     * </div>
	     *
	     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	     *   are passed (see below), the function is called with the current iteration count.
	     * @param {number} delay Number of milliseconds between each function call.
	     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	     *   indefinitely.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	     *
	     * @example
	     * <example module="intervalExample" name="interval-service">
	     * <file name="index.html">
	     *   <script>
	     *     angular.module('intervalExample', [])
	     *       .controller('ExampleController', ['$scope', '$interval',
	     *         function($scope, $interval) {
	     *           $scope.format = 'M/d/yy h:mm:ss a';
	     *           $scope.blood_1 = 100;
	     *           $scope.blood_2 = 120;
	     *
	     *           var stop;
	     *           $scope.fight = function() {
	     *             // Don't start a new fight if we are already fighting
	     *             if ( angular.isDefined(stop) ) return;
	     *
	     *             stop = $interval(function() {
	     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	     *                 $scope.blood_1 = $scope.blood_1 - 3;
	     *                 $scope.blood_2 = $scope.blood_2 - 4;
	     *               } else {
	     *                 $scope.stopFight();
	     *               }
	     *             }, 100);
	     *           };
	     *
	     *           $scope.stopFight = function() {
	     *             if (angular.isDefined(stop)) {
	     *               $interval.cancel(stop);
	     *               stop = undefined;
	     *             }
	     *           };
	     *
	     *           $scope.resetFight = function() {
	     *             $scope.blood_1 = 100;
	     *             $scope.blood_2 = 120;
	     *           };
	     *
	     *           $scope.$on('$destroy', function() {
	     *             // Make sure that the interval is destroyed too
	     *             $scope.stopFight();
	     *           });
	     *         }])
	     *       // Register the 'myCurrentTime' directive factory method.
	     *       // We inject $interval and dateFilter service since the factory method is DI.
	     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	     *         function($interval, dateFilter) {
	     *           // return the directive link function. (compile function not needed)
	     *           return function(scope, element, attrs) {
	     *             var format,  // date format
	     *                 stopTime; // so that we can cancel the time updates
	     *
	     *             // used to update the UI
	     *             function updateTime() {
	     *               element.text(dateFilter(new Date(), format));
	     *             }
	     *
	     *             // watch the expression, and update the UI on change.
	     *             scope.$watch(attrs.myCurrentTime, function(value) {
	     *               format = value;
	     *               updateTime();
	     *             });
	     *
	     *             stopTime = $interval(updateTime, 1000);
	     *
	     *             // listen on DOM destroy (removal) event, and cancel the next UI update
	     *             // to prevent updating time after the DOM element was removed.
	     *             element.on('$destroy', function() {
	     *               $interval.cancel(stopTime);
	     *             });
	     *           }
	     *         }]);
	     *   </script>
	     *
	     *   <div>
	     *     <div ng-controller="ExampleController">
	     *       <label>Date format: <input ng-model="format"></label> <hr/>
	     *       Current time is: <span my-current-time="format"></span>
	     *       <hr/>
	     *       Blood 1 : <font color='red'>{{blood_1}}</font>
	     *       Blood 2 : <font color='red'>{{blood_2}}</font>
	     *       <button type="button" data-ng-click="fight()">Fight</button>
	     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	     *     </div>
	     *   </div>
	     *
	     * </file>
	     * </example>
	     */
	    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);
	
	    /**
	     * @ngdoc method
	     * @name $interval#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`.
	     *
	     * @param {Promise=} promise returned by the `$interval` function.
	     * @returns {boolean} Returns `true` if the task was successfully canceled.
	     */
	    interval.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$intervalId')) {
	        throw $intervalMinErr('badprom',
	            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
	      }
	
	      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;
	
	      var id = promise.$$intervalId;
	      var deferred = intervals[id];
	
	      // Interval cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      clearIntervalFn(id);
	
	      return true;
	    };
	
	    return interval;
	  }];
	}
	
	/** @this */
	function $$IntervalFactoryProvider() {
	  this.$get = ['$browser', '$q', '$$q', '$rootScope',
	       function($browser,   $q,   $$q,   $rootScope) {
	    return function intervalFactory(setIntervalFn, clearIntervalFn) {
	      return function intervalFn(fn, delay, count, invokeApply) {
	        var hasParams = arguments.length > 4,
	            args = hasParams ? sliceArgs(arguments, 4) : [],
	            iteration = 0,
	            skipApply = isDefined(invokeApply) && !invokeApply,
	            deferred = (skipApply ? $$q : $q).defer(),
	            promise = deferred.promise;
	
	        count = isDefined(count) ? count : 0;
	
	        function callback() {
	          if (!hasParams) {
	            fn(iteration);
	          } else {
	            fn.apply(null, args);
	          }
	        }
	
	        function tick() {
	          if (skipApply) {
	            $browser.defer(callback);
	          } else {
	            $rootScope.$evalAsync(callback);
	          }
	          deferred.notify(iteration++);
	
	          if (count > 0 && iteration >= count) {
	            deferred.resolve(iteration);
	            clearIntervalFn(promise.$$intervalId);
	          }
	
	          if (!skipApply) $rootScope.$apply();
	        }
	
	        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);
	
	        return promise;
	      };
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various AngularJS components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	/* global stripHash: true */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    // decode forward slashes to prevent them from being double encoded
	    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
	  }
	
	  return segments.join('/');
	}
	
	function decodePath(path, html5Mode) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = decodeURIComponent(segments[i]);
	    if (html5Mode) {
	      // encode forward slashes to prevent them from being mistaken for path separators
	      segments[i] = segments[i].replace(/\//g, '%2F');
	    }
	  }
	
	  return segments.join('/');
	}
	
	function normalizePath(pathValue, searchValue, hashValue) {
	  var search = toKeyValue(searchValue),
	    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
	    path = encodePath(pathValue);
	
	  return path + (search ? '?' + search : '') + hash;
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj, html5Mode) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
	  locationObj.$$path = decodePath(path, html5Mode);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this, true);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBaseNoFile + url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this, false);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of AngularJS, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBase + (url ? hashPrefix + url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$normalizeUrl = function(url) {
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    return appBase + hashPrefix + url;
	  };
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * Compose url and update `url` and `absUrl` property
	   * @private
	   */
	  $$compose: function() {
	    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
	    this.$$absUrl = this.$$normalizeUrl(this.$$url);
	    this.$$urlUpdatedByLocation = true;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    // Determine if two URLs are equal despite potentially having different encoding/normalizing
	    //  such as $location.absUrl() vs $browser.url()
	    // See https://github.com/angular/angular.js/issues/16592
	    function urlsEqual(a, b) {
	      return a === b || urlResolve(a).href === urlResolve(b).href;
	    }
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the AngularJS application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if ($location.absUrl() !== initialUrl) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = $browser.url();
	        var newUrl = $location.absUrl();
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing AngularJS Expressions
	// ------------------------------
	// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following AngularJS expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.getAst(text);
	    var fn = this.astCompiler.compile(ast.ast);
	    fn.literal = isLiteral(ast.ast);
	    fn.constant = isConstant(ast.ast);
	    fn.oneTime = ast.oneTime;
	    return fn;
	  },
	
	  getAst: function(exp) {
	    var oneTime = false;
	    exp = exp.trim();
	
	    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	      oneTime = true;
	      exp = exp.substring(2);
	    }
	    return {
	      ast: this.ast.ast(exp),
	      oneTime: oneTime
	    };
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts AngularJS {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'AngularJS'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('AngularJS');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    $parse.$$getAst = $$getAst;
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	
	            cache[cacheKey] = addWatchDelegate(parsedExpression);
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function $$getAst(exp) {
	      var lexer = new Lexer($parseOptions);
	      var parser = new Parser(lexer, $filter, $parseOptions);
	      return parser.getAst(exp).ast;
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	      var unwatch, lastValue;
	
	      var exp = parsedExpression.$$intercepted || parsedExpression;
	      var post = parsedExpression.$$interceptor || identity;
	
	      var useInputs = parsedExpression.inputs && !exp.inputs;
	
	      // Propogate the literal/inputs/constant attributes
	      // ... but not oneTime since we are handling it
	      oneTimeWatch.literal = parsedExpression.literal;
	      oneTimeWatch.constant = parsedExpression.constant;
	      oneTimeWatch.inputs = parsedExpression.inputs;
	
	      // Allow other delegates to run on this wrapped expression
	      addWatchDelegate(oneTimeWatch);
	
	      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);
	
	      return unwatch;
	
	      function unwatchIfDone() {
	        if (isDone(lastValue)) {
	          unwatch();
	        }
	      }
	
	      function oneTimeWatch(scope, locals, assign, inputs) {
	        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
	        if (isDone(lastValue)) {
	          scope.$$postDigest(unwatchIfDone);
	        }
	        return post(lastValue);
	      }
	    }
	
	    function isAllDefined(value) {
	      var allDefined = true;
	      forEach(value, function(val) {
	        if (!isDefined(val)) allDefined = false;
	      });
	      return allDefined;
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addWatchDelegate(parsedExpression) {
	      if (parsedExpression.constant) {
	        parsedExpression.$$watchDelegate = constantWatchDelegate;
	      } else if (parsedExpression.oneTime) {
	        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
	      } else if (parsedExpression.inputs) {
	        parsedExpression.$$watchDelegate = inputsWatchDelegate;
	      }
	
	      return parsedExpression;
	    }
	
	    function chainInterceptors(first, second) {
	      function chainedInterceptor(value) {
	        return second(first(value));
	      }
	      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
	      chainedInterceptor.$$pure = first.$$pure && second.$$pure;
	
	      return chainedInterceptor;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	
	      // Extract any existing interceptors out of the parsedExpression
	      // to ensure the original parsedExpression is always the $$intercepted
	      if (parsedExpression.$$interceptor) {
	        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
	        parsedExpression = parsedExpression.$$intercepted;
	      }
	
	      var useInputs = false;
	
	      var fn = function interceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value);
	      };
	
	      // Maintain references to the interceptor/intercepted
	      fn.$$intercepted = parsedExpression;
	      fn.$$interceptor = interceptorFn;
	
	      // Propogate the literal/oneTime/constant attributes
	      fn.literal = parsedExpression.literal;
	      fn.oneTime = parsedExpression.oneTime;
	      fn.constant = parsedExpression.constant;
	
	      // Treat the interceptor like filters.
	      // If it is not $stateful then only watch its inputs.
	      // If the expression itself has no inputs then use the full expression as an input.
	      if (!interceptorFn.$stateful) {
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	
	        if (!interceptorFn.$$pure) {
	          fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	        }
	      }
	
	      return addWatchDelegate(fn);
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * ## $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * ## The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * ## The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * ## Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * ## Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * ## Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	          // This error is explicitly marked for being passed to the $exceptionHandler
	          if (e && e.$$passToExceptionHandler === true) {
	            exceptionHandler(e);
	          }
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  // Built-in `$q` promises will always have a `$$state` property. This check is to allow
	  // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
	  // (Currently, this is the only method that might be called with a promise, even if it is not
	  // created by the built-in `$q`.)
	  if (q.$$state) {
	    markQStateExceptionHandled(q.$$state);
	  }
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	      this.$$suspended = false;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * ## Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$suspended = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are (or contain)
	       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * @example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	        var fn = isFunction(listener) ? listener : noop;
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: fn,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
	            newValues[i] = value;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          try {
	            if (firstRun) {
	              firstRun = false;
	              listener(newValues, newValues, self);
	            } else {
	              listener(newValues, oldValues, self);
	            }
	          } finally {
	            for (var i = 0; i < watchExpressions.length; i++) {
	              oldValues[i] = newValues[i];
	            }
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * @example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        // Mark the interceptor as
	        // ... $$pure when literal since the instance will change when any input changes
	        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
	        // ... $stateful when non-literal since we must read the state of the collection
	        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * @example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = asyncQueue.length ? $rootScope : this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = !current.$$suspended && current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            // (though it differs due to having the extra check for $$suspended and does not
	            // check $$listenerCount)
	            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$suspend
	       * @kind function
	       *
	       * @description
	       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
	       *
	       * This can be used to optimize your application when you know that running those watchers
	       * is redundant.
	       *
	       * **Warning**
	       *
	       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
	       * Only use this approach if you are confident that you know what you are doing and have
	       * ample tests to ensure that bindings get updated as you expect.
	       *
	       * Some of the things to consider are:
	       *
	       * * Any external event on a directive/component will not trigger a digest while the hosting
	       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
	       * * Transcluded content exists on a scope that inherits from outside a directive but exists
	       *   as a child of the directive's containing scope. If the containing scope is suspended the
	       *   transcluded scope will also be suspended, even if the scope from which the transcluded
	       *   scope inherits is not suspended.
	       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
	       *    * A call to `$suspend()` on an already suspended scope is a no-op.
	       *    * A call to `$resume()` on a non-suspended scope is a no-op.
	       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
	       *      longer be suspended. This could result in the other directive believing a scope to be
	       *      suspended when it is not.
	       * * If a parent scope is suspended then all its descendants will be also excluded from future
	       *   digests whether or not they have been suspended themselves. Note that this also applies to
	       *   isolate child scopes.
	       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
	       *   for that scope and its descendants. When digesting we only check whether the current scope is
	       *   locally suspended, rather than checking whether it has a suspended ancestor.
	       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
	       *   included in future digests until all its ancestors have been resumed.
	       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
	       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
	       *   initiated by a component that lives on a suspended scope.
	       */
	      $suspend: function() {
	        this.$$suspended = true;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$isSuspended
	       * @kind function
	       *
	       * @description
	       * Call this method to determine if this scope has been explicitly suspended. It will not
	       * tell you whether an ancestor has been suspended.
	       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
	       * for example, you must check all its ancestors:
	       *
	       * ```
	       * function isExcludedFromDigest(scope) {
	       *   while(scope) {
	       *     if (scope.$isSuspended()) return true;
	       *     scope = scope.$parent;
	       *   }
	       *   return false;
	       * ```
	       *
	       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
	       * even if `$isSuspended()` returns false.
	       *
	       * @returns true if the current scope has been suspended.
	       */
	      $isSuspended: function() {
	        return this.$$suspended;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$resume
	       * @kind function
	       *
	       * @description
	       * Resume watchers of this scope subtree in case it was suspended.
	       *
	       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
	       */
	      $resume: function() {
	        this.$$suspended = false;
	      },
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
	       * expressions.
	       *
	       * @example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          }, null, '$evalAsync');
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the AngularJS framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * **Life cycle: Pseudo-Code of `$apply()`**
	       *
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            // Use delete in the hope of the browser deallocating the memory for the array entry,
	            // while not shifting the array indexes of other listeners.
	            // See issue https://github.com/angular/angular.js/issues/16135
	            delete namedListeners[indexOfListener];
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            break;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount and
	          // does not check $$suspended)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        }, null, '$applyAsync');
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of AngularJS application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	
	  var aHrefSanitizationTrustedUrlList = /^\s*(https?|s?ftp|mailto|tel|file):/,
	    imgSrcSanitizationTrustedUrlList = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
	   *
	   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
	   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
	   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
	   *
	   * If the URL matches the `aHrefSanitizationTrustedUrlList` regular expression, it is returned unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationTrustedUrlList = regexp;
	      return this;
	    }
	    return aHrefSanitizationTrustedUrlList;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
	   *
	   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
	   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
	   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
	   * the potentially malicious URL.
	   *
	   * If the URL matches the `imgSrcSanitizationTrustedUrlList` regular expression, it is returned
	   * unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationTrustedUrlList = regexp;
	      return this;
	    }
	    return imgSrcSanitizationTrustedUrlList;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isMediaUrl) {
	      // if (!uri) return uri;
	      var regex = isMediaUrl ? imgSrcSanitizationTrustedUrlList : aHrefSanitizationTrustedUrlList;
	      var normalizedVal = urlResolve(uri && uri.trim()).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it refers to the source of media, which are not expected to be run
	  // as scripts, such as an image, audio, video, etc.
	  MEDIA_URL: 'mediaUrl',
	
	  // An URL used in a context where it does not refer to a resource that loads code.
	  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own trusted and banned resource lists for trusting URLs used for loading AngularJS resources
	 * such as templates.  Refer {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * $sceDelegateProvider.trustedResourceUrlList} and {@link
	 * ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the `trustedResourceUrlList` and
	 * `bannedResourceUrlList` used to ensure that the URLs used for sourcing AngularJS templates and
	 * other script-running URLs are safe (all places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * $sceDelegateProvider.trustedResourceUrlList} and
	 * {@link ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList},
	 *
	 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.trustedResourceUrlList([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The banned resource URL list overrides the trusted resource URL list so the open redirect
	 *    // here is blocked.
	 *    $sceDelegateProvider.bannedResourceUrlList([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty trusted resource URL list will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from the trusted resource URL lsit. This helps to mitigate the security impact of certain types
	 * of issues, like for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var trustedResourceUrlList = ['self'],
	      bannedResourceUrlList = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#trustedResourceUrlList
	   * @kind function
	   *
	   * @param {Array=} trustedResourceUrlList When provided, replaces the trustedResourceUrlList with
	   *     the value provided.  This must be an array or null.  A snapshot of this array is used so
	   *     further changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set trusted resource URL array.
	   *
	   * @description
	   * Sets/Gets the list trusted of resource URLs.
	   *
	   * The **default value** when no `trustedResourceUrlList` has been explicitly set is `['self']`
	   * allowing only same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default `trustedResourceUrlList` of 'self' is not recommended if your app shares
	   * its origin with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.trustedResourceUrlList = function(value) {
	    if (arguments.length) {
	      trustedResourceUrlList = adjustMatchers(value);
	    }
	    return trustedResourceUrlList;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $sceDelegateProvider#trustedResourceUrlList
	   * trustedResourceUrlList} instead.
	   */
	  Object.defineProperty(this, 'resourceUrlWhitelist', {
	    get: function() {
	      return this.trustedResourceUrlList;
	    },
	    set: function(value) {
	      this.trustedResourceUrlList = value;
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#bannedResourceUrlList
	   * @kind function
	   *
	   * @param {Array=} bannedResourceUrlList When provided, replaces the `bannedResourceUrlList` with
	   *     the value provided. This must be an array or null. A snapshot of this array is used so
	   *     further changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the `bannedResourceUrlList` is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the banned resource URL list overrides the trusted resource URL list** and has
	   *     the final say.
	   *
	   * @return {Array} The currently set `bannedResourceUrlList` array.
	   *
	   * @description
	   * Sets/Gets the `bannedResourceUrlList` of trusted resource URLs.
	   *
	   * The **default value** when no trusted resource URL list has been explicitly set is the empty
	   * array (i.e. there is no `bannedResourceUrlList`.)
	   */
	  this.bannedResourceUrlList = function(value) {
	    if (arguments.length) {
	      bannedResourceUrlList = adjustMatchers(value);
	    }
	    return bannedResourceUrlList;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $sceDelegateProvider#bannedResourceUrlList
	   * bannedResourceUrlList} instead.
	   */
	  Object.defineProperty(this, 'resourceUrlBlacklist', {
	    get: function() {
	      return this.bannedResourceUrlList;
	    },
	    set: function(value) {
	      this.bannedResourceUrlList = value;
	    }
	  });
	
	  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the trusted resource URL list allows this url.
	      for (i = 0, n = trustedResourceUrlList.length; i < n; i++) {
	        if (matchUrl(trustedResourceUrlList[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the banned resource URL list has blocked this url.
	        for (i = 0, n = bannedResourceUrlList.length; i < n; i++) {
	          if (matchUrl(bannedResourceUrlList[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Given an object and a security context in which to assign it, returns a value that's safe to
	     * use in this context, which was represented by the parameter. To do so, this function either
	     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
	     * the context and sanitizer availablility.
	     *
	     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
	     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
	     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
	     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#trustedResourceUrlList
	     * `$sceDelegateProvider.trustedResourceUrlList`} and {@link ng.$sceDelegateProvider#bannedResourceUrlList
	     * `$sceDelegateProvider.bannedResourceUrlList`} accepts that resource.
	     *
	     * This function will throw if the safe type isn't appropriate for this context, or if the
	     * value given cannot be accepted in the context (which might be caused by sanitization not
	     * being available, or the value not being recognized as safe).
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If maybeTrusted is a trusted class instance but not of the correct trusted type
	      // then unwrap it and allow it to pass through to the rest of the checks
	      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
	        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If we get here, then we will either sanitize the value or throw an exception.
	      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
	        // we attempt to sanitize non-resource URLs
	        return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
	      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * ## Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ### Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, trusted URL resource, depending on context), or throw
	 * when it cannot guarantee the security of the result. That behavior depends strongly on contexts:
	 * HTML can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ### In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ### How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ### Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, AngularJS only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either add them to the {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * trustedResourceUrlList} or {@link ng.$sce#trustAsResourceUrl wrap them} into trusted values.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ### This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
	 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
	 * when binding untrusted values to `$sce.HTML` context.
	 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#trustedResourceUrlList trusted resource URL list} and {@link
	 * ng.$sceDelegateProvider#bannedResourceUrlList banned resource URL list} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ### What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#trustedResourceUrlList $sceDelegateProvider#trustedResourceUrlList()} and {@link $sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider#bannedResourceUrlList()} can be used to restrict trusted origins for `RESOURCE_URL` |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 *
	 * <div class="alert alert-warning">
	 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
	 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
	 *
	 * **As of 1.7.0, this is no longer the case.**
	 *
	 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
	 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
	 * service evaluates the expressions.
	 * </div>
	 *
	 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
	 * functions aren't useful yet. This might evolve.
	 *
	 * ### Format of items in {@link ng.$sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList}/{@link ng.$sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      for matching resource URL lists.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ### Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $$taskTrackerFactory
	 * @description
	 * A function to create `TaskTracker` instances.
	 *
	 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
	 * parties when all pending tasks (or tasks of a specific type) have been completed.
	 *
	 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
	 *     execution.
	 *
	 * @this
	 */
	function $$TaskTrackerFactoryProvider() {
	  this.$get = valueFn(function(log) { return new TaskTracker(log); });
	}
	
	function TaskTracker(log) {
	  var self = this;
	  var taskCounts = {};
	  var taskCallbacks = [];
	
	  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
	  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';
	
	  /**
	   * Execute the specified function and decrement the appropriate `taskCounts` counter.
	   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
	   *
	   * @param {Function} fn - The function to execute.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
	   */
	  self.completeTask = completeTask;
	
	  /**
	   * Increase the task count for the specified task type (or the default task type if non is
	   * specified).
	   *
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
	   */
	  self.incTaskCount = incTaskCount;
	
	  /**
	   * Execute the specified callback when all pending tasks have been completed.
	   *
	   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
	   * the tasks that will be waited for to a specific type, by passing a `taskType`.
	   *
	   * @param {function} callback - The function to call when there are no pending tasks.
	   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
	   */
	  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;
	
	  function completeTask(fn, taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	
	    try {
	      fn();
	    } finally {
	      decTaskCount(taskType);
	
	      var countForType = taskCounts[taskType];
	      var countForAll = taskCounts[ALL_TASKS_TYPE];
	
	      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
	      if (!countForAll || !countForType) {
	        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
	        var nextCb;
	
	        while ((nextCb = getNextCallback(taskType))) {
	          try {
	            nextCb();
	          } catch (e) {
	            log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function decTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    if (taskCounts[taskType]) {
	      taskCounts[taskType]--;
	      taskCounts[ALL_TASKS_TYPE]--;
	    }
	  }
	
	  function getLastCallback() {
	    var cbInfo = taskCallbacks.pop();
	    return cbInfo && cbInfo.cb;
	  }
	
	  function getLastCallbackForType(taskType) {
	    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
	      var cbInfo = taskCallbacks[i];
	      if (cbInfo.type === taskType) {
	        taskCallbacks.splice(i, 1);
	        return cbInfo.cb;
	      }
	    }
	  }
	
	  function incTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
	    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
	  }
	
	  function notifyWhenNoPendingTasks(callback, taskType) {
	    taskType = taskType || ALL_TASKS_TYPE;
	    if (!taskCounts[taskType]) {
	      callback();
	    } else {
	      taskCallbacks.push({type: taskType, cb: callback});
	    }
	  }
	}
	
	var $templateRequestMinErr = minErr('$templateRequest');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
	   * as {@link ngInclude} to download and cache templates.
	   *
	   * 3rd party modules should use `$templateRequest` if their services or directives are loading
	   * templates.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through adding the template again to the trusted
	        // resources for keys that already are included in there. This also makes
	        // AngularJS accept any script directive, no matter its name. However, we
	        // still need to unwrap trusted types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            return $templateCache.put(tpl, response.data);
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when all pending tasks are completed.
	     *
	     * Types of tasks waited for include:
	     * - Pending timeouts (via {@link $timeout}).
	     * - Pending HTTP requests (via {@link $http}).
	     * - In-progress route transitions (via {@link $route}).
	     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
	     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
	     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	var $timeoutMinErr = minErr('$timeout');
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	    /**
	     * @ngdoc service
	     * @name $timeout
	     *
	     * @description
	     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	     * block and delegates any exceptions to
	     * {@link ng.$exceptionHandler $exceptionHandler} service.
	     *
	     * The return value of calling `$timeout` is a promise, which will be resolved when
	     * the delay has passed and the timeout function, if provided, is executed.
	     *
	     * To cancel a timeout request, call `$timeout.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	     * synchronously flush the queue of deferred functions.
	     *
	     * If you only want a promise that will be resolved after some specified delay
	     * then you can call `$timeout` without the `fn` function.
	     *
	     * @param {function()=} fn A function, whose execution should be delayed.
	     * @param {number=} [delay=0] Delay in milliseconds.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	     *   will be resolved with the return value of the `fn` function.
	     *
	     */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay, '$timeout');
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $timeout#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`. As a result of this, the promise will be
	     * resolved with a rejection.
	     *
	     * @param {Promise=} promise Promise returned by the `$timeout` function.
	     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	     *   canceled.
	     */
	    timeout.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$timeoutId')) {
	        throw $timeoutMinErr('badprom',
	            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
	      }
	
	      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;
	
	      var id = promise.$$timeoutId;
	      var deferred = deferreds[id];
	
	      // Timeout cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      delete deferreds[id];
	
	      return $browser.defer.cancel(id);
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	var baseUrlParsingNode;
	
	urlParsingNode.href = 'http://[::1]';
	
	// Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
	// IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
	// when parsed out of an anchor element.
	var ipv6InBrackets = urlParsingNode.hostname === '[::1]';
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
	 *     unchanged.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description                                                            |
	 *   |---------------|------------------------------------------------------------------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol without the trailing colon                                |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol                                 |
	 *   | hostname      | The hostname                                                           |
	 *   | port          | The port, without ":"                                                  |
	 *   | pathname      | The pathname, beginning with "/"                                       |
	 *
	 */
	function urlResolve(url) {
	  if (!isString(url)) return url;
	
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  var hostname = urlParsingNode.hostname;
	
	  if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
	    hostname = '[' + hostname + ']';
	  }
	
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application
	 * document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, originUrl);
	}
	
	/**
	 * Parse a request URL and determine whether it is same-origin as the current document base URL.
	 *
	 * Note: The base URL is usually the same as the document location (`location.href`) but can
	 * be overriden by using the `<base>` tag.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the URL is same-origin as the document base URL.
	 */
	function urlIsSameOriginAsBaseUrl(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, getBaseUrl());
	}
	
	/**
	 * Create a function that can check a URL's origin against a list of allowed/trusted origins.
	 * The current location's origin is implicitly trusted.
	 *
	 * @param {string[]} trustedOriginUrls - A list of URLs (strings), whose origins are trusted.
	 *
	 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
	 *     whether it is of an allowed origin.
	 */
	function urlIsAllowedOriginFactory(trustedOriginUrls) {
	  var parsedAllowedOriginUrls = [originUrl].concat(trustedOriginUrls.map(urlResolve));
	
	  /**
	   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
	   * based on a list of trusted-origin URLs. The current location's origin is implicitly
	   * trusted.
	   *
	   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
	   *     resolved or a parsed URL object).
	   *
	   * @returns {boolean} - Whether the specified URL is of an allowed origin.
	   */
	  return function urlIsAllowedOrigin(requestUrl) {
	    var parsedUrl = urlResolve(requestUrl);
	    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
	  };
	}
	
	/**
	 * Determine if two URLs share the same origin.
	 *
	 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
	 *     a dictionary object returned by `urlResolve()`.
	 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
	 *     of a dictionary object returned by `urlResolve()`.
	 *
	 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
	 */
	function urlsAreSameOrigin(url1, url2) {
	  url1 = urlResolve(url1);
	  url2 = urlResolve(url2);
	
	  return (url1.protocol === url2.protocol &&
	          url1.host === url2.host);
	}
	
	/**
	 * Returns the current document base URL.
	 * @returns {string}
	 */
	function getBaseUrl() {
	  if (window.document.baseURI) {
	    return window.document.baseURI;
	  }
	
	  // `document.baseURI` is available everywhere except IE
	  if (!baseUrlParsingNode) {
	    baseUrlParsingNode = window.document.createElement('a');
	    baseUrlParsingNode.href = '.';
	
	    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
	    // suitable here because we need to track changes to the base URL.
	    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
	  }
	  return baseUrlParsingNode.href;
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In AngularJS we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how AngularJS filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the AngularJS Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services. AngularJS comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // If the currency symbol is empty, trim whitespace around the symbol
	    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(currencySymbolRe, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 *    **Note:** `null` values use `'null'` as their type.
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, sorts values of different types by type and puts
	 * `undefined` and `null` values at the end of the sorted list.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types:
	 *    - If one of the values is undefined, consider it "greater than" the other.
	 *    - Else if one of the values is null, consider it "greater than" the other.
	 *    - Else compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
	 *           any other value (with undefined "greater than" null). This effectively means that `null`
	 *           and `undefined` values end up at the end of a list sorted in ascending order.
	 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = (type1 === 'undefined') ? 1 :
	        (type2 === 'undefined') ? -1 :
	        (type1 === 'null') ? 1 :
	        (type2 === 'null') ? -1 :
	        (type1 < type2) ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * AngularJS has a chance to replace the `{{hash}}` markup with its
	 * value. Until AngularJS replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
	        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
	          element(by.model('leader')).click();
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = ['$sce', function($sce) {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        // We need to sanitize the url at least once, in case it is a constant
	        // non-interpolated attribute.
	        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set might have sanitized the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  }];
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $getControls: valueFn([]),
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop,
	  $$setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$getControls
	   * @returns {Array} the controls that are currently part of this form
	   *
	   * @description
	   * This method returns a **shallow copy** of the controls that are currently part of this form.
	   * The controls can be instances of {@link form.FormController `FormController`}
	   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
	   * If you need access to the controls of child-forms, you have to call `$getControls()`
	   * recursively on them.
	   * This can be used for example to iterate over all controls to validate them.
	   *
	   * The controls can be accessed normally, but adding to, or removing controls from the array has
	   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
	   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
	   * Likewise, adding a control to, or removing a control from the form is not reflected
	   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
	   * you need access to the controls.
	   */
	  $getControls: function() {
	    return shallowCopy(this.$$controls);
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
	   * parent forms of the form.
	   */
	  $setSubmitted: function() {
	    var rootForm = this;
	    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
	      rootForm = rootForm.$$parentForm;
	    }
	    rootForm.$$setSubmitted();
	  },
	
	  $$setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    forEach(this.$$controls, function(control) {
	      if (control.$$setSubmitted) {
	        control.$$setSubmitted();
	      }
	    });
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Helper directive that makes it possible to create control groups inside a
	 * {@link ng.directive:form `form`} directive.
	 * These "child forms" can be used, for example, to determine the validity of a sub-group of
	 * controls.
	 *
	 * <div class="alert alert-danger">
	 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
	 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
	 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
	 * you cannot send data to the server with `ngForm`, or integrate it with
	 * {@link ng.directive:ngSubmit `ngSubmit`}.
	 * </div>
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
	 *                              be published into the related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * ## Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * ## CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * ## Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side AngularJS applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * @animations
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise AngularJS will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * The format of the displayed time can be adjusted with the
	    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	    * and `timeStripZeroSeconds`.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
	   * this is the timezone of the browser.
	   *
	   * The format of the displayed time can be adjusted with the
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	   * and `timeStripZeroSeconds`.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
	    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
	    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise AngularJS will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   *
	   *
	   * @knownIssue
	   *
	   * ### HTML5 constraint validation and `allowInvalid`
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   * @knownIssue
	   *
	   * ### Large numbers and `step` validation
	   *
	   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
	   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
	   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
	   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
	   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
	   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
	   * point for both implementations.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium, which may not fulfill your app's requirements.
	   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
	   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
	   * modify the built-in validators (see the {@link guide/forms Forms guide}).
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * **Note:**<br>
	   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
	   * value of their `name` attribute to determine the property under which their
	   * {@link ngModel.NgModelController NgModelController} will be published on the parent
	   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
	   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
	   * published on the parent `FormController` under that name. The rest of the controllers will
	   * continue to work as expected, but you won't be able to access them as properties on the parent
	   * `FormController`.
	   *
	   * <div class="alert alert-info">
	   *   <p>
	   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
	   *     that the browser can manage their state (checked/unchecked) based on the state of other
	   *     inputs in the same group.
	   *   </p>
	   *   <p>
	   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
	   *     value of the underlying model data.
	   *   </p>
	   * </div>
	   *
	   * <div class="alert alert-success">
	   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
	   *   unique name.
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for AngularJS:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, AngularJS will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
	   *                      to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    // Support: IE9+
	    element.on('compositionupdate', function(ev) {
	      // End composition when ev.data is empty string on 'compositionupdate' event.
	      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
	      // instead of 'compositionend'.
	      if (isUndefined(ev.data) || ev.data === '') {
	        composing = false;
	      }
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut drop', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, previousDate) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (previousDate) {
	          map = {
	            yyyy: previousDate.getFullYear(),
	            MM: previousDate.getMonth() + 1,
	            dd: previousDate.getDate(),
	            HH: previousDate.getHours(),
	            mm: previousDate.getMinutes(),
	            ss: previousDate.getSeconds(),
	            sss: previousDate.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	
	        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	        if (map.yyyy < 100) {
	          // In the constructor, 2-digit years map to 1900-1999.
	          // Use `setFullYear()` to set the correct year.
	          date.setFullYear(map.yyyy);
	        }
	
	        return date;
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	    badInputChecker(scope, element, attr, ctrl, type);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	    var isTimeType = type === 'time' || type === 'datetimelocal';
	    var previousDate;
	    var previousTimezone;
	
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
	      }
	      ctrl.$$parserName = type;
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        var timezone = ctrl.$options.getOption('timezone');
	
	        if (timezone) {
	          previousTimezone = timezone;
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	
	        return formatter(value, timezone);
	      } else {
	        previousDate = null;
	        previousTimezone = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal = attr.min || $parse(attr.ngMin)(scope);
	      var parsedMinVal = parseObservedDateValue(minVal);
	
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
	      };
	      attr.$observe('min', function(val) {
	        if (val !== minVal) {
	          parsedMinVal = parseObservedDateValue(val);
	          minVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal = attr.max || $parse(attr.ngMax)(scope);
	      var parsedMaxVal = parseObservedDateValue(maxVal);
	
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
	      };
	      attr.$observe('max', function(val) {
	        if (val !== maxVal) {
	          parsedMaxVal = parseObservedDateValue(val);
	          maxVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
	    }
	
	    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
	      var timezone = ctrl.$options.getOption('timezone');
	
	      if (previousTimezone && previousTimezone !== timezone) {
	        // If the timezone has changed, adjust the previousDate to the default timezone
	        // so that the new date is converted with the correct timezone offset
	        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
	      }
	
	      var parsedDate = parseDate(value, previousDate);
	
	      if (!isNaN(parsedDate) && timezone) {
	        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	      }
	      return parsedDate;
	    }
	
	    function formatter(value, timezone) {
	      var targetFormat = format;
	
	      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
	        targetFormat = format
	          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
	          .replace(/:$/, '');
	      }
	
	      var formatted =  $filter('date')(value, targetFormat, timezone);
	
	      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
	        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
	      }
	
	      return formatted;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl, parserName) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      if (validity.badInput || validity.typeMismatch) {
	        ctrl.$$parserName = parserName;
	        return undefined;
	      }
	
	      return value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	
	    ctrl.$$parserName = 'number';
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  badInputChecker(scope, element, attr, ctrl, 'number');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var parsedMinVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal = attr.min || $parse(attr.ngMin)(scope);
	    parsedMinVal = parseNumberAttrVal(minVal);
	
	    ctrl.$validators.min = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (val !== minVal) {
	        parsedMinVal = parseNumberAttrVal(val);
	        minVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal = attr.max || $parse(attr.ngMax)(scope);
	    var parsedMaxVal = parseNumberAttrVal(maxVal);
	
	    ctrl.$validators.max = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (val !== maxVal) {
	        parsedMaxVal = parseNumberAttrVal(val);
	        maxVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal = attr.step || $parse(attr.ngStep)(scope);
	    var parsedStepVal = parseNumberAttrVal(stepVal);
	
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) ||
	        isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      if (val !== stepVal) {
	        parsedStepVal = parseNumberAttrVal(val);
	        stepVal = val;
	        ctrl.$validate();
	      }
	
	    });
	
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl, 'range');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    minVal = parseNumberAttrVal(attr.min);
	
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    maxVal = parseNumberAttrVal(attr.max);
	
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    stepVal = parseNumberAttrVal(attr.step);
	
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    var oldVal = attr[htmlAttrName];
	    attr.$observe(htmlAttrName, function wrappedObserver(val) {
	      if (val !== oldVal) {
	        oldVal = val;
	        changeFn(val);
	      }
	    });
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (!supportsRange) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    } else if (ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	var hiddenInputBrowserCacheDirective = function() {
	  var valueProperty = {
	    configurable: true,
	    enumerable: false,
	    get: function() {
	      return this.getAttribute('value') || '';
	    },
	    set: function(val) {
	      this.setAttribute('value', val);
	    }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 200,
	    compile: function(_, attr) {
	      if (lowercase(attr.type) !== 'hidden') {
	        return;
	      }
	
	      return {
	        pre: function(scope, element, attr, ctrls) {
	          var node = element[0];
	
	          // Support: Edge
	          // Moving the DOM around prevents autofillling
	          if (node.parentNode) {
	            node.parentNode.insertBefore(node, node.nextSibling);
	          }
	
	          // Support: FF, IE
	          // Avoiding direct assignment to .value prevents autofillling
	          if (Object.defineProperty) {
	            Object.defineProperty(node, 'value', valueProperty);
	          }
	        }
	      };
	    }
	  };
	};
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element ANY
	 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 * @restrict A
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element ANY
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClassWatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClassWatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    if (!classValue) return classValue;
	
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    } else if (!isString(classValue)) {
	      classString = classValue + '';
	    }
	
	    return classString;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 * @element ANY
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
	 *
	 * ### ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 *
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example
	 * ### Basic
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   @example
	   ### Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassOdd`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-odd="'odd'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .odd {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .odd-add, .odd-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add odd class to odd entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassEven`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-even="'even'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .even {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .even-add, .even-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add even class to even entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the AngularJS community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * AngularJS has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect AngularJS:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related AngularJS features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 *
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	
	  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	  <example name="example.csp" module="cspExample" ng-csp="true">
	    <file name="index.html">
	      <div ng-controller="MainController as ctrl">
	        <div>
	          <button ng-click="ctrl.inc()" id="inc">Increment</button>
	          <span id="counter">
	            {{ctrl.counter}}
	          </span>
	        </div>
	
	        <div>
	          <button ng-click="ctrl.evil()" id="evil">Evil</button>
	          <span id="evilError">
	            {{ctrl.evilError}}
	          </span>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	       angular.module('cspExample', [])
	         .controller('MainController', function MainController() {
	            this.counter = 0;
	            this.inc = function() {
	              this.counter++;
	            };
	            this.evil = function() {
	              try {
	                eval('1+2'); // eslint-disable-line no-eval
	              } catch (e) {
	                this.evilError = e.message;
	              }
	            };
	          });
	    </file>
	    <file name="protractor.js" type="protractor">
	      var util, webdriver;
	
	      var incBtn = element(by.id('inc'));
	      var counter = element(by.id('counter'));
	      var evilBtn = element(by.id('evil'));
	      var evilError = element(by.id('evilError'));
	
	      function getAndClearSevereErrors() {
	        return browser.manage().logs().get('browser').then(function(browserLog) {
	          return browserLog.filter(function(logEntry) {
	            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	          });
	        });
	      }
	
	      function clearErrors() {
	        getAndClearSevereErrors();
	      }
	
	      function expectNoErrors() {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          expect(filteredLog.length).toEqual(0);
	          if (filteredLog.length) {
	            console.log('browser console errors: ' + util.inspect(filteredLog));
	          }
	        });
	      }
	
	      function expectError(regex) {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          var found = false;
	          filteredLog.forEach(function(log) {
	            if (log.message.match(regex)) {
	              found = true;
	            }
	          });
	          if (!found) {
	            throw new Error('expected an error that matches ' + regex);
	          }
	        });
	      }
	
	      beforeEach(function() {
	        util = require('util');
	        webdriver = require('selenium-webdriver');
	      });
	
	      // For now, we only test on Chrome,
	      // as Safari does not load the page with Protractor's injected scripts,
	      // and Firefox webdriver always disables content security policy (#6358)
	      if (browser.params.browser !== 'chrome') {
	        return;
	      }
	
	      it('should not report errors when the page is loaded', function() {
	        // clear errors so we are not dependent on previous tests
	        clearErrors();
	        // Need to reload the page as the page is already loaded when
	        // we come here
	        browser.driver.getCurrentUrl().then(function(url) {
	          browser.get(url);
	        });
	        expectNoErrors();
	      });
	
	      it('should evaluate expressions', function() {
	        expect(counter.getText()).toEqual('0');
	        incBtn.click();
	        expect(counter.getText()).toEqual('1');
	        expectNoErrors();
	      });
	
	      it('should throw and report an error when using "eval"', function() {
	        evilBtn.click();
	        expect(evilError.getText()).toMatch(/Content Security Policy/);
	        expectError(/Content Security Policy/);
	      });
	    </file>
	  </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * AngularJS expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
	      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
	    }];
	  }
	);
	
	function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
	  return {
	    restrict: 'A',
	    compile: function($element, attr) {
	      // NOTE:
	      // We expose the powerful `$event` object on the scope that provides access to the Window,
	      // etc. This is OK, because expressions are not sandboxed any more (and the expression
	      // sandbox was never meant to be a security feature anyway).
	      var fn = $parse(attr[directiveName]);
	      return function ngEventHandler(scope, element) {
	        element.on(eventName, function(event) {
	          var callback = function() {
	            fn(scope, {$event: event});
	          };
	
	          if (!$rootScope.$$phase) {
	            scope.$apply(callback);
	          } else if (forceAsync) {
	            scope.$evalAsync(callback);
	          } else {
	            try {
	              callback();
	            } catch (error) {
	              $exceptionHandler(error);
	            }
	          }
	        });
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 * @restrict A
	 * @element ANY
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 * @restrict A
	 * @element form
	 * @priority 0
	 *
	 * @description
	 * Enables binding AngularJS expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 * @scope
	 * @priority -400
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either add them to your {@link ng.$sceDelegateProvider#trustedResourceUrlList trusted
	 * resource URL list} or {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to
	 * AngularJS's {@link ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 * @priority 450
	 * @element ANY
	 *
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`:
	 * <ul>
	 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
	 *     as seen in the demo below.</li>
	 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
	 *   <li>injecting data via server side scripting.</li>
	 * </ul>
	 *
	 * Besides these few cases, you should use {@link guide/component Components} or
	 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 * @restrict A
	 * @priority 100
	 *
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * @example
	 * ### Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Splitting on newline
	 *
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
	 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
	 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
	 *     It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * AngularJS provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	  this.$$updateEvents = '';
	  // Attach the correct context to the event handler function for updateOn
	  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	  this.$$parserName = 'parse';
	
	  this.$$currentValidationRunId = 0;
	
	  this.$$scope = $scope;
	  this.$$rootScope = $scope.$root;
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * @example
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName;
	
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    // Reset any previous parse error
	    this.$setValidity(this.$$parserName, null);
	    this.$$parserName = 'parse';
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default']) &&
	      this.$options.getOption('updateOn').indexOf(trigger) === -1
	    ) {
	      debounceDelay = debounceDelay['default'];
	    } else if (isNumber(debounceDelay['*'])) {
	      debounceDelay = debounceDelay['*'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$rootScope.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** this function only affects the options set on the `ngModelController`,
	   * and not the options on the {@link ngModelOptions} directive from which they might have been
	   * obtained initially.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** it is not possible to override the `getterSetter` option.
	   * </div>
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	    this.$$setUpdateOnEvents();
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name  ngModel.NgModelController#$processModelValue
	
	   * @description
	   *
	   * Runs the model -> view pipeline on the current
	   * {@link ngModel.NgModelController#$modelValue $modelValue}.
	   *
	   * The following actions are performed by this method:
	   *
	   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
	   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
	   * - the `ng-empty` or `ng-not-empty` class is set on the element
	   * - if the `$viewValue` has changed:
	   *   - {@link ngModel.NgModelController#$render $render} is called on the control
	   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
	   *   the validation status is set.
	   *
	   * This method is called by ngModel internally when the bound scope value changes.
	   * Application developers usually do not have to call this function themselves.
	   *
	   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
	   * formatted and the `$modelValue` must be run through the `$formatters` again.
	   *
	   * @example
	   * Consider a text input with an autocomplete list (for fruit), where the items are
	   * objects with a name and an id.
	   * A user enters `ap` and then selects `Apricot` from the list.
	   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
	   * but the rendered value will still be `ap`.
	   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
	   * pipeline again, which formats the object to the string `Apricot`,
	   * then updates the `$viewValue`, and finally renders it in the DOM.
	   *
	   * <example module="inputExample" name="ng-model-process">
	     <file name="index.html">
	      <div ng-controller="inputController" style="display: flex;">
	        <div style="margin-right: 30px;">
	          Search Fruit:
	          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
	        </div>
	        <div>
	          Model:<br>
	          <pre>{{selectedFruit | json}}</pre>
	        </div>
	      </div>
	     </file>
	     <file name="app.js">
	      angular.module('inputExample', [])
	        .controller('inputController', function($scope) {
	          $scope.items = [
	            {name: 'Apricot', id: 443},
	            {name: 'Clementine', id: 972},
	            {name: 'Durian', id: 169},
	            {name: 'Jackfruit', id: 982},
	            {name: 'Strawberry', id: 863}
	          ];
	        })
	        .component('basicAutocomplete', {
	          bindings: {
	            items: '<',
	            onSelect: '&'
	          },
	          templateUrl: 'autocomplete.html',
	          controller: function($element, $scope) {
	            var that = this;
	            var ngModel;
	
	            that.$postLink = function() {
	              ngModel = $element.find('input').controller('ngModel');
	
	              ngModel.$formatters.push(function(value) {
	                return (value && value.name) || value;
	              });
	
	              ngModel.$parsers.push(function(value) {
	                var match = value;
	                for (var i = 0; i < that.items.length; i++) {
	                  if (that.items[i].name === value) {
	                    match = that.items[i];
	                    break;
	                  }
	                }
	
	                return match;
	              });
	            };
	
	            that.selectItem = function(item) {
	              ngModel.$setViewValue(item);
	              ngModel.$processModelValue();
	              that.onSelect({item: item});
	            };
	          }
	        });
	     </file>
	     <file name="autocomplete.html">
	       <div>
	         <input type="search" ng-model="$ctrl.searchTerm" />
	         <ul>
	           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
	             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
	           </li>
	         </ul>
	       </div>
	     </file>
	   * </example>
	   *
	   */
	  $processModelValue: function() {
	    var viewValue = this.$$format();
	
	    if (this.$viewValue !== viewValue) {
	      this.$$updateEmptyClasses(viewValue);
	      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
	      this.$render();
	      // It is possible that model and view value have been updated during render
	      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
	    }
	  },
	
	  /**
	   * This method is called internally to run the $formatters on the $modelValue
	   */
	  $$format: function() {
	    var formatters = this.$formatters,
	        idx = formatters.length;
	
	    var viewValue = this.$modelValue;
	    while (idx--) {
	      viewValue = formatters[idx](viewValue);
	    }
	
	    return viewValue;
	  },
	
	  /**
	   * This method is called internally when the bound scope value changes.
	   */
	  $$setModelValue: function(modelValue) {
	    this.$modelValue = this.$$rawModelValue = modelValue;
	    this.$$parserValid = undefined;
	    this.$processModelValue();
	  },
	
	  $$setUpdateOnEvents: function() {
	    if (this.$$updateEvents) {
	      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
	    }
	
	    this.$$updateEvents = this.$options.getOption('updateOn');
	    if (this.$$updateEvents) {
	      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
	    }
	  },
	
	  $$updateEventHandler: function(ev) {
	    this.$$debounceViewValueCommit(ev && ev.type);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // This cannot be moved to the action function, because it would not catch the
	    // case where the model is changed in the ngChange function or the model setter
	    if (modelValue !== ctrl.$modelValue &&
	      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	      // eslint-disable-next-line no-self-compare
	      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$$setModelValue(modelValue);
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 * @restrict A
	 * @priority 1
	 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * ## CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * @animations
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * ### Basic Usage
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * @example
	 * ### Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          modelCtrl.$$setUpdateOnEvents();
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /** @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 * @restrict A
	 * @priority 10
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ### Overriding immediate updates
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Debouncing updates
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ### Default events, extra triggers, and catch-all debounce values
	 *
	 * This example shows the relationship between "default" update events and
	 * additional `updateOn` triggers.
	 *
	 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
	 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
	 * in `updateOn` is considered a "default" event, since different control types have different
	 * default events.
	 *
	 * The control in this example updates by "default", "click", and "blur", with different `debounce`
	 * values. You can see that "click" doesn't have an individual `debounce` value -
	 * therefore it uses the `*` debounce value.
	 *
	 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
	 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
	 * it is considered a "default" event and will update the
	 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
	 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
	 *
	 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
	 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
	 *
	  <example name="ngModelOptions-advanced" module="optionsExample">
	    <file name="index.html">
	       <model-update-demo></model-update-demo>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .component('modelUpdateDemo', {
	          templateUrl: 'template.html',
	          controller: function() {
	            this.name = 'Chinua';
	
	            this.options = {
	              updateOn: 'default blur click',
	              debounce: {
	                default: 2000,
	                blur: 0,
	                '*': 1000
	              }
	            };
	
	            this.updateEvents = function() {
	              var eventList = this.options.updateOn.split(' ');
	              eventList.push('*');
	              var events = {};
	
	              for (var i = 0; i < eventList.length; i++) {
	                events[eventList[i]] = this.options.debounce[eventList[i]];
	              }
	
	              this.events = events;
	            };
	
	            this.updateOptions = function() {
	              var options = angular.extend(this.options, {
	                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
	                debounce: this.events
	              });
	
	              this.form.input.$overrideModelOptions(options);
	            };
	
	            // Initialize the event form
	            this.updateEvents();
	          }
	        });
	    </file>
	    <file name="template.html">
	      <form name="$ctrl.form">
	        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
	      </form>
	      Model: <tt>{{$ctrl.name}}</tt>
	      <hr>
	      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>
	
	      <hr>
	      <form ng-submit="$ctrl.updateOptions()">
	        <b>updateOn</b><br>
	        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">
	
	        <table>
	          <tr>
	            <th>Option</th>
	            <th>Debounce value</th>
	          </tr>
	          <tr ng-repeat="(key, value) in $ctrl.events">
	            <td>{{key}}</td>
	            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
	          </tr>
	        </table>
	
	        <br>
	        <input type="submit" value="Update options">
	      </form>
	    </file>
	  </example>
	 *
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Programmatically changing options
	 *
	 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
	 * watched for changes. However, it is possible to override the options on a single
	 * {@link ngModel.NgModelController} instance with
	 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
	 * See also the example for
	 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
	 * Default events, extra triggers, and catch-all debounce values}.
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 *
	 * ## Formatting the value of `time` and `datetime-local`
	 *
	 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
	 * that is displayed in the control. Note that browsers may apply their own formatting
	 * in the user interface.
	 *
	   <example name="ngModelOptions-time-format" module="timeExample">
	     <file name="index.html">
	       <time-example></time-example>
	     </file>
	     <file name="script.js">
	        angular.module('timeExample', [])
	          .component('timeExample', {
	            templateUrl: 'timeExample.html',
	            controller: function() {
	              this.time = new Date(1970, 0, 1, 14, 57, 0);
	
	              this.options = {
	                timeSecondsFormat: 'ss',
	                timeStripZeroSeconds: true
	              };
	
	              this.optionChange = function() {
	                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
	                this.time = new Date(this.time);
	              };
	            }
	          });
	     </file>
	     <file name="timeExample.html">
	       <form name="$ctrl.timeForm">
	         <strong>Default</strong>:
	         <input type="time" ng-model="$ctrl.time" step="any" /><br>
	         <strong>With options</strong>:
	         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
	         <br>
	
	         Options:<br>
	         <code>timeSecondsFormat</code>:
	         <input
	           type="text"
	           ng-model="$ctrl.options.timeSecondsFormat"
	           ng-change="$ctrl.optionChange()">
	         <br>
	         <code>timeStripZeroSeconds</code>:
	         <input
	           type="checkbox"
	           ng-model="$ctrl.options.timeStripZeroSeconds"
	           ng-change="$ctrl.optionChange()">
	        </form>
	      </file>
	 *  </example>
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents.
	 *
	 * **General options**:
	 *
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control. These are the events that are bound to
	 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
	 *
	 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
	 *     since different control types use different default events.
	 *
	 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
	 *     Triggering and debouncing model updates}.
	 *
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *     You can use the `*` key to specify a debounce value that applies to all events that are not
	 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur mouseup',
	 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *
	 *
	 *  **Input-type specific options**:
	 *
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *     Note that changing the timezone will have no effect on the current date, and is only applied after
	 *     the next input / model change.
	 *
	 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
	 *     milliseconds. The option follows the format string of {@link date date filter}.
	 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
	 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
	 *     seconds and milliseconds.
	 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
	 *     part of the time string, and may show the value differently in the user interface.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
	 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
	 *     after `timeSecondsFormat`.
	 *     This option can be used to make the formatting consistent over different browsers, as some
	 *     browsers with support for `time` will natively hide the milliseconds and
	 *     seconds if they are zero, but others won't, and browsers that don't implement these input
	 *     types will always show the full string.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 * @element ANY
	 *
	 * @description
	 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
	 * DOM element, including directives on the element itself that have a lower priority than
	 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
	 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
	 * that displays snippets of code, for instance.
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	  <example name="ng-non-bindable">
	    <file name="index.html">
	      <div>Normal: {{1 + 2}}</div>
	      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	    </file>
	    <file name="protractor.js" type="protractor">
	     it('should check ng-non-bindable', function() {
	       expect(element(by.binding('1 + 2')).getText()).toContain('3');
	       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	     });
	    </file>
	  </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * ## Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in AngularJS's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * ## Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * AngularJS expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * ## Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRef
	 * @restrict A
	 *
	 * @description
	 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
	 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
	 * element to the scope.
	 *
	 * If the element with `ngRef` is destroyed `null` is assigned to the property.
	 *
	 * Note that if you want to assign from a child into the parent scope, you must initialize the
	 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
	 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
	 * {@link ngRepeat}. See the second example below.
	 *
	 *
	 * @element ANY
	 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
	 *                       controller or jqlite-wrapped DOM element will be bound.
	 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
	 *                            or the special string `$element`. If a name is provided, `ngRef` will
	 *                            assign the matching controller. If `$element` is provided, the element
	 *                            itself is assigned (even if a controller is available).
	 *
	 *
	 * @example
	 * ### Simple toggle
	 * This example shows how the controller of the component toggle
	 * is reused in the template through the scope to use its logic.
	 * <example name="ng-ref-component" module="myApp">
	 *   <file name="index.html">
	 *     <my-toggle ng-ref="myToggle"></my-toggle>
	 *     <button ng-click="myToggle.toggle()">Toggle</button>
	 *     <div ng-show="myToggle.isOpen()">
	 *       You are using a component in the same template to show it.
	 *     </div>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myToggle', {
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should publish the toggle into the scope', function() {
	 *        var toggle = element(by.buttonText('Toggle'));
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
	 *        toggle.click();
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### ngRef inside scopes
	 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
	 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
	 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
	 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
	 * because the target property has not been initialized on the `myRoot` component controller.
	 *
	 * <example name="ng-ref-scopes" module="myApp">
	 *   <file name="index.html">
	 *     <my-root></my-root>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myRoot', {
	 *       templateUrl: 'root.html',
	 *       controller: function() {
	 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
	 *       }
	 *     })
	 *     .component('myToggle', {
	 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
	 *       transclude: true,
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     })
	 *     .component('myWrapper', {
	 *       transclude: true,
	 *       template: '<strong>myWrapper</strong>' +
	 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
	 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
	 *     });
	 *   </file>
	 *   <file name="root.html">
	 *     <strong>myRoot</strong>
	 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
	 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     <div><em>wrappers assigned to root</em><br>
	 *     <div ng-repeat="wrapper in $ctrl.wrappers">
	 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
	 *     </div>
	 *
	 *     <ul>
	 *       <li ng-repeat="(index, value) in [1,2,3]">
	 *         <strong>ngRepeat</strong>
	 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
	 *       </li>
	 *     </ul>
	 *
	 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
	 *       assigned to the child scope created by ngIf.
	 *     </div>
	 *     <div ng-if="true">
	          <strong>ngIf</strong>
	 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
	 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
	 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     </div>
	 *   </file>
	 *   <file name="styles.css">
	 *     ul {
	 *       list-style: none;
	 *       padding-left: 0;
	 *     }
	 *
	 *     li[ng-repeat] {
	 *       background: lightgreen;
	 *       padding: 8px;
	 *       margin: 8px;
	 *     }
	 *
	 *     [ng-if] {
	 *       background: lightgrey;
	 *       padding: 8px;
	 *     }
	 *
	 *     my-root {
	 *       background: lightgoldenrodyellow;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-wrapper {
	 *       background: lightsalmon;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-toggle {
	 *       background: lightblue;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      var OuterToggle = function() {
	 *        this.toggle = function() {
	 *          element(by.buttonText('Outer Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
	 *        };
	 *      };
	 *      var NgRepeatToggle = function(i) {
	 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *      var NgRepeatToggles = function() {
	 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
	 *        this.forEach = function(fn) {
	 *          toggles.forEach(fn);
	 *        };
	 *        this.isOuterOpen = function(i) {
	 *          return toggles[i - 1].isOuterOpen();
	 *        };
	 *      };
	 *      var NgIfToggle = function() {
	 *        var parent = element(by.css('[ng-if]'));
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngIf Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return by.binding('ngIfToggle.isOpen() | json').getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *
	 *      it('should toggle the outer toggle', function() {
	 *        var outerToggle = new OuterToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle all outer toggles', function() {
	 *        var outerToggle = new OuterToggle();
	 *        var repeatToggles = new NgRepeatToggles();
	 *        var ifToggle = new NgIfToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle each repeat iteration separately', function() {
	 *        var repeatToggles = new NgRepeatToggles();
	 *
	 *        repeatToggles.forEach(function(repeatToggle) {
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *          repeatToggle.toggle();
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        });
	 *      });
	 *   </file>
	 * </example>
	 *
	 */
	
	var ngRefMinErr = minErr('ngRef');
	
	var ngRefDirective = ['$parse', function($parse) {
	  return {
	    priority: -1, // Needed for compatibility with element transclusion on the same element
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      // Get the expected controller name, converts <data-some-thing> into "someThing"
	      var controllerName = directiveNormalize(nodeName_(tElement));
	
	      // Get the expression for value binding
	      var getter = $parse(tAttrs.ngRef);
	      var setter = getter.assign || function() {
	        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
	      };
	
	      return function(scope, element, attrs) {
	        var refValue;
	
	        if (attrs.hasOwnProperty('ngRefRead')) {
	          if (attrs.ngRefRead === '$element') {
	            refValue = element;
	          } else {
	            refValue = element.data('$' + attrs.ngRefRead + 'Controller');
	
	            if (!refValue) {
	              throw ngRefMinErr(
	                'noctrl',
	                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
	                attrs.ngRefRead,
	                tAttrs.ngRef
	              );
	            }
	          }
	        } else {
	          refValue = element.data('$' + controllerName + 'Controller');
	        }
	
	        refValue = refValue || element;
	
	        setter(scope, refValue);
	
	        // when the element is removed, remove it (nullify it)
	        element.on('$destroy', function() {
	          // only remove it if value has not changed,
	          // because animations (and other procedures) may duplicate elements
	          if (getter(scope) === refValue) {
	            setter(scope, null);
	          }
	        });
	      };
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * ## Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so AngularJS relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * ## Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * All different types of tracking functions, their syntax, and their support for duplicate
	 * items in collections can be found in the
	 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** If you are working with objects that have a unique identifier property, you
	 * should track by this identifier instead of the object instance,
	 * e.g. `item in items track by item.id`.
	 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
	 * it has already rendered, even if the JavaScript objects in the collection have been substituted
	 * for new ones. For large collections, this significantly improves rendering performance.
	 * </div>
	 *
	 * ### Effects of DOM Element re-use
	 *
	 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
	 * automatically update any active bindings on the template. However, other
	 * functionality will not be updated, because the element is not re-created:
	 *
	 * - Directives are not re-compiled
	 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
	 * updated if they have stabilized.
	 *
	 * The above affects all kinds of element re-use due to tracking, but may be especially visible
	 * when tracking by `$index` due to the way ngRepeat re-uses elements.
	 *
	 * The following example shows the effects of different actions with tracking:
	
	  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        var friends = [
	          {name:'John', age:25},
	          {name:'Mary', age:40},
	          {name:'Peter', age:85}
	        ];
	
	        $scope.removeFirst = function() {
	          $scope.friends.shift();
	        };
	
	        $scope.updateAge = function() {
	          $scope.friends.forEach(function(el) {
	            el.age = el.age + 5;
	          });
	        };
	
	        $scope.copy = function() {
	          $scope.friends = angular.copy($scope.friends);
	        };
	
	        $scope.reset = function() {
	          $scope.friends = angular.copy(friends);
	        };
	
	        $scope.reset();
	      });
	    </file>
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        <ol>
	          <li>When you click "Update Age", only the first list updates the age, because all others have
	          a one-time binding on the age property. If you then click "Copy", the current friend list
	          is copied, and now the second list updates the age, because the identity of the collection items
	          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
	          items are already known according to their tracking functions.
	          </li>
	          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
	          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
	          DOM element for the new first collection item, and so on. Since the age property is one-time
	          bound, the value remains from the collection item which was previously at this index.
	          </li>
	        </ol>
	
	        <button ng-click="removeFirst()">Remove First</button>
	        <button ng-click="updateAge()">Update Age</button>
	        <button ng-click="copy()">Copy</button>
	        <br><button ng-click="reset()">Reset List</button>
	        <br>
	        <code>track by $id(friend)</code> (default):
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $id(friend)</code> (default), with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by friend.name</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
	            {{friend.name}}  is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $index</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	  </example>
	
	 *
	 * ## Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
	 *     This implies that the DOM elements will be associated by item identity in the collection.
	 *
	 *     The built-in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the collection by identity. Moving the same object would move
	 *     the DOM element in the same way in the DOM.
	 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
	 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
	 *
	 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
	 *     id, for example with a function, or using a property on the collection items.
	 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
	 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
	 *     equivalent as long as their `id` property is same.
	 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
	 *
	 *     *$index*: This special property tracks the collection items by their index, and
	 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
	 *     be used for a performance improvement if no unique identfier is available and the identity of
	 *     the collection items cannot be easily computed. It also allows duplicates.
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
	 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
	 *       more info.
	 *     </div>
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
	 *       `item in items | filter:searchText as results  track by item.id`
	 *     </div>
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
	 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	  var trackByIdArrayFn = function($scope, key, value) {
	    return hashKey(value);
	  };
	
	  var trackByIdObjFn = function($scope, key) {
	    return key;
	  };
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByIdExpFn;
	
	      if (trackByExp) {
	        var hashFnLocals = {$id: hashKey};
	        var trackByExpGetter = $parse(trackByExp);
	
	        trackByIdExpFn = function($scope, key, value, index) {
	          // assign key, value, and $index to the locals so that they can be used in hash functions
	          if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	          hashFnLocals[valueIdentifier] = value;
	          hashFnLocals.$index = index;
	          return trackByExpGetter($scope, hashFnLocals);
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn($scope, key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // Clear the value property from the hashFnLocals object to prevent a reference to the last value
	          // being leaked into the ngRepeatCompile function scope
	          if (hashFnLocals) {
	            hashFnLocals[valueIdentifier] = undefined;
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngShow to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngHide to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, ''); });
	    }
	    if (newStyles) element.css(newStyles);
	  });
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
	 *       Error: The current model doesn't match any option</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 *  it('should show the error message when the unknown option is selected', function() {
	
	      var error = element(by.className('error'));
	
	      expect(error.getText()).toBe('Error: Please select a value');
	
	      element(by.cssContainingText('option', 'Option 1')).click();
	
	      expect(error.isPresent()).toBe(false);
	
	      element(by.tagName('button')).click();
	
	      expect(error.getText()).toBe('Error: Please select a value');
	    });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with AngularJS data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
	 *                                `required` attribute to the element and adds the `required`
	 *                                {@link ngModel.NgModelController#$validators `validator`}.
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the AngularJS expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      // For boolean attributes like required, presence means true
	      var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);
	
	      if (!attr.ngRequired) {
	        // force truthy in case we are on non input element
	        // (input elements do this automatically for boolean attributes like required)
	        attr.required = true;
	      }
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !value || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function(newVal) {
	
	        if (value !== newVal) {
	          value = newVal;
	          ctrl.$validate();
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 * @restrict A
	 *
	 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
	 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
	 *                                      more details.
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
	 * - the value is an AngularJS expression:
	 *   - If the expression evaluates to a RegExp object, then this is used directly.
	 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    compile: function(tElm, tAttr) {
	      var patternExp;
	      var parseFn;
	
	      if (tAttr.ngPattern) {
	        patternExp = tAttr.ngPattern;
	
	        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
	        // We get value of the attribute here, so we can compare the old and the new value
	        // in the observer to avoid unnecessary validations
	        if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
	          parseFn = function() { return tAttr.ngPattern; };
	        } else {
	          parseFn = $parse(tAttr.ngPattern);
	        }
	      }
	
	      return function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	
	        var attrVal = attr.pattern;
	
	        if (attr.ngPattern) {
	          attrVal = parseFn(scope);
	        } else {
	          patternExp = attr.pattern;
	        }
	
	        var regexp = parsePatternAttr(attrVal, patternExp, elm);
	
	        attr.$observe('pattern', function(newVal) {
	          var oldRegexp = regexp;
	
	          regexp = parsePatternAttr(newVal, patternExp, elm);
	
	          if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
	            ctrl.$validate();
	          }
	        });
	
	        ctrl.$validators.pattern = function(modelValue, viewValue) {
	          // HTML5 pattern constraint validates the input value, so we validate the viewValue
	          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	        };
	      };
	    }
	
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 * @restrict A
	 *
	 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `maxlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
	      var maxlengthParsed = parseLength(maxlength);
	
	      attr.$observe('maxlength', function(value) {
	        if (maxlength !== value) {
	          maxlengthParsed = parseLength(value);
	          maxlength = value;
	          ctrl.$validate();
	        }
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlengthParsed < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlengthParsed);
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 * @restrict A
	 *
	 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `minlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
	      var minlengthParsed = parseLength(minlength) || -1;
	
	      attr.$observe('minlength', function(value) {
	        if (minlength !== value) {
	          minlengthParsed = parseLength(value) || -1;
	          minlength = value;
	          ctrl.$validate();
	        }
	
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
	      };
	    }
	  };
	}];
	
	
	function parsePatternAttr(regex, patternExp, elm) {
	  if (!regex) return undefined;
	
	  if (isString(regex)) {
	    regex = new RegExp('^' + regex + '$');
	  }
	
	  if (!regex.test) {
	    throw minErr('ngPattern')('noregexp',
	      'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	      regex, startingTag(elm));
	  }
	
	  return regex;
	}
	
	function parseLength(val) {
	  var intVal = toInt(val);
	  return isNumberNaN(intVal) ? -1 : intVal;
	}
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load AngularJS more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element('<style>').text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 *  big.js v5.2.2
	 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
	 *  Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
	 *  https://github.com/MikeMcl/big.js/LICENCE
	 */
	;(function (GLOBAL) {
	  'use strict';
	  var Big,
	
	
	/************************************** EDITABLE DEFAULTS *****************************************/
	
	
	    // The default values below must be integers within the stated ranges.
	
	    /*
	     * The maximum number of decimal places (DP) of the results of operations involving division:
	     * div and sqrt, and pow with negative exponents.
	     */
	    DP = 20,          // 0 to MAX_DP
	
	    /*
	     * The rounding mode (RM) used when rounding to the above decimal places.
	     *
	     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
	     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
	     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
	     *  3  Away from zero.                                  (ROUND_UP)
	     */
	    RM = 1,             // 0, 1, 2 or 3
	
	    // The maximum value of DP and Big.DP.
	    MAX_DP = 1E6,       // 0 to 1000000
	
	    // The maximum magnitude of the exponent argument to the pow method.
	    MAX_POWER = 1E6,    // 1 to 1000000
	
	    /*
	     * The negative exponent (NE) at and beneath which toString returns exponential notation.
	     * (JavaScript numbers: -7)
	     * -1000000 is the minimum recommended exponent value of a Big.
	     */
	    NE = -7,            // 0 to -1000000
	
	    /*
	     * The positive exponent (PE) at and above which toString returns exponential notation.
	     * (JavaScript numbers: 21)
	     * 1000000 is the maximum recommended exponent value of a Big.
	     * (This limit is not enforced or checked.)
	     */
	    PE = 21,            // 0 to 1000000
	
	
	/**************************************************************************************************/
	
	
	    // Error messages.
	    NAME = '[big.js] ',
	    INVALID = NAME + 'Invalid ',
	    INVALID_DP = INVALID + 'decimal places',
	    INVALID_RM = INVALID + 'rounding mode',
	    DIV_BY_ZERO = NAME + 'Division by zero',
	
	    // The shared prototype object.
	    P = {},
	    UNDEFINED = void 0,
	    NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
	
	
	  /*
	   * Create and return a Big constructor.
	   *
	   */
	  function _Big_() {
	
	    /*
	     * The Big constructor and exported function.
	     * Create and return a new instance of a Big number object.
	     *
	     * n {number|string|Big} A numeric value.
	     */
	    function Big(n) {
	      var x = this;
	
	      // Enable constructor usage without new.
	      if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);
	
	      // Duplicate.
	      if (n instanceof Big) {
	        x.s = n.s;
	        x.e = n.e;
	        x.c = n.c.slice();
	      } else {
	        parse(x, n);
	      }
	
	      /*
	       * Retain a reference to this Big constructor, and shadow Big.prototype.constructor which
	       * points to Object.
	       */
	      x.constructor = Big;
	    }
	
	    Big.prototype = P;
	    Big.DP = DP;
	    Big.RM = RM;
	    Big.NE = NE;
	    Big.PE = PE;
	    Big.version = '5.2.2';
	
	    return Big;
	  }
	
	
	  /*
	   * Parse the number or string value passed to a Big constructor.
	   *
	   * x {Big} A Big number instance.
	   * n {number|string} A numeric value.
	   */
	  function parse(x, n) {
	    var e, i, nl;
	
	    // Minus zero?
	    if (n === 0 && 1 / n < 0) n = '-0';
	    else if (!NUMERIC.test(n += '')) throw Error(INVALID + 'number');
	
	    // Determine sign.
	    x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;
	
	    // Decimal point?
	    if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');
	
	    // Exponential form?
	    if ((i = n.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +n.slice(i + 1);
	      n = n.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = n.length;
	    }
	
	    nl = n.length;
	
	    // Determine leading zeros.
	    for (i = 0; i < nl && n.charAt(i) == '0';) ++i;
	
	    if (i == nl) {
	
	      // Zero.
	      x.c = [x.e = 0];
	    } else {
	
	      // Determine trailing zeros.
	      for (; nl > 0 && n.charAt(--nl) == '0';);
	      x.e = e - i - 1;
	      x.c = [];
	
	      // Convert string to array of digits without leading/trailing zeros.
	      for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Round Big x to a maximum of dp decimal places using rounding mode rm.
	   * Called by stringify, P.div, P.round and P.sqrt.
	   *
	   * x {Big} The Big to round.
	   * dp {number} Integer, 0 to MAX_DP inclusive.
	   * rm {number} 0, 1, 2 or 3 (DOWN, HALF_UP, HALF_EVEN, UP)
	   * [more] {boolean} Whether the result of division was truncated.
	   */
	  function round(x, dp, rm, more) {
	    var xc = x.c,
	      i = x.e + dp + 1;
	
	    if (i < xc.length) {
	      if (rm === 1) {
	
	        // xc[i] is the digit after the digit that may be rounded up.
	        more = xc[i] >= 5;
	      } else if (rm === 2) {
	        more = xc[i] > 5 || xc[i] == 5 &&
	          (more || i < 0 || xc[i + 1] !== UNDEFINED || xc[i - 1] & 1);
	      } else if (rm === 3) {
	        more = more || !!xc[0];
	      } else {
	        more = false;
	        if (rm !== 0) throw Error(INVALID_RM);
	      }
	
	      if (i < 1) {
	        xc.length = 1;
	
	        if (more) {
	
	          // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	          x.e = -dp;
	          xc[0] = 1;
	        } else {
	
	          // Zero.
	          xc[0] = x.e = 0;
	        }
	      } else {
	
	        // Remove any digits after the required decimal places.
	        xc.length = i--;
	
	        // Round up?
	        if (more) {
	
	          // Rounding up may mean the previous digit has to be rounded up.
	          for (; ++xc[i] > 9;) {
	            xc[i] = 0;
	            if (!i--) {
	              ++x.e;
	              xc.unshift(1);
	            }
	          }
	        }
	
	        // Remove trailing zeros.
	        for (i = xc.length; !xc[--i];) xc.pop();
	      }
	    } else if (rm < 0 || rm > 3 || rm !== ~~rm) {
	      throw Error(INVALID_RM);
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Return a string representing the value of Big x in normal or exponential notation.
	   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
	   *
	   * x {Big}
	   * id? {number} Caller id.
	   *         1 toExponential
	   *         2 toFixed
	   *         3 toPrecision
	   *         4 valueOf
	   * n? {number|undefined} Caller's argument.
	   * k? {number|undefined}
	   */
	  function stringify(x, id, n, k) {
	    var e, s,
	      Big = x.constructor,
	      z = !x.c[0];
	
	    if (n !== UNDEFINED) {
	      if (n !== ~~n || n < (id == 3) || n > MAX_DP) {
	        throw Error(id == 3 ? INVALID + 'precision' : INVALID_DP);
	      }
	
	      x = new Big(x);
	
	      // The index of the digit that may be rounded up.
	      n = k - x.e;
	
	      // Round?
	      if (x.c.length > ++k) round(x, n, Big.RM);
	
	      // toFixed: recalculate k as x.e may have changed if value rounded up.
	      if (id == 2) k = x.e + n + 1;
	
	      // Append zeros?
	      for (; x.c.length < k;) x.c.push(0);
	    }
	
	    e = x.e;
	    s = x.c.join('');
	    n = s.length;
	
	    // Exponential notation?
	    if (id != 2 && (id == 1 || id == 3 && k <= e || e <= Big.NE || e >= Big.PE)) {
	      s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;
	
	    // Normal notation.
	    } else if (e < 0) {
	      for (; ++e;) s = '0' + s;
	      s = '0.' + s;
	    } else if (e > 0) {
	      if (++e > n) for (e -= n; e--;) s += '0';
	      else if (e < n) s = s.slice(0, e) + '.' + s.slice(e);
	    } else if (n > 1) {
	      s = s.charAt(0) + '.' + s.slice(1);
	    }
	
	    return x.s < 0 && (!z || id == 4) ? '-' + s : s;
	  }
	
	
	  // Prototype/instance methods
	
	
	  /*
	   * Return a new Big whose value is the absolute value of this Big.
	   */
	  P.abs = function () {
	    var x = new this.constructor(this);
	    x.s = 1;
	    return x;
	  };
	
	
	  /*
	   * Return 1 if the value of this Big is greater than the value of Big y,
	   *       -1 if the value of this Big is less than the value of Big y, or
	   *        0 if they have the same value.
	  */
	  P.cmp = function (y) {
	    var isneg,
	      x = this,
	      xc = x.c,
	      yc = (y = new x.constructor(y)).c,
	      i = x.s,
	      j = y.s,
	      k = x.e,
	      l = y.e;
	
	    // Either zero?
	    if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
	
	    // Signs differ?
	    if (i != j) return i;
	
	    isneg = i < 0;
	
	    // Compare exponents.
	    if (k != l) return k > l ^ isneg ? 1 : -1;
	
	    j = (k = xc.length) < (l = yc.length) ? k : l;
	
	    // Compare digit by digit.
	    for (i = -1; ++i < j;) {
	      if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return k == l ? 0 : k > l ^ isneg ? 1 : -1;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
	   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
	   */
	  P.div = function (y) {
	    var x = this,
	      Big = x.constructor,
	      a = x.c,                  // dividend
	      b = (y = new Big(y)).c,   // divisor
	      k = x.s == y.s ? 1 : -1,
	      dp = Big.DP;
	
	    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
	
	    // Divisor is zero?
	    if (!b[0]) throw Error(DIV_BY_ZERO);
	
	    // Dividend is 0? Return +-0.
	    if (!a[0]) return new Big(k * 0);
	
	    var bl, bt, n, cmp, ri,
	      bz = b.slice(),
	      ai = bl = b.length,
	      al = a.length,
	      r = a.slice(0, bl),   // remainder
	      rl = r.length,
	      q = y,                // quotient
	      qc = q.c = [],
	      qi = 0,
	      d = dp + (q.e = x.e - y.e) + 1;    // number of digits of the result
	
	    q.s = k;
	    k = d < 0 ? 0 : d;
	
	    // Create version of divisor with leading zero.
	    bz.unshift(0);
	
	    // Add zeros to make remainder as long as divisor.
	    for (; rl++ < bl;) r.push(0);
	
	    do {
	
	      // n is how many times the divisor goes into current remainder.
	      for (n = 0; n < 10; n++) {
	
	        // Compare divisor and remainder.
	        if (bl != (rl = r.length)) {
	          cmp = bl > rl ? 1 : -1;
	        } else {
	          for (ri = -1, cmp = 0; ++ri < bl;) {
	            if (b[ri] != r[ri]) {
	              cmp = b[ri] > r[ri] ? 1 : -1;
	              break;
	            }
	          }
	        }
	
	        // If divisor < remainder, subtract divisor from remainder.
	        if (cmp < 0) {
	
	          // Remainder can't be more than 1 digit longer than divisor.
	          // Equalise lengths using divisor with extra leading zero?
	          for (bt = rl == bl ? b : bz; rl;) {
	            if (r[--rl] < bt[rl]) {
	              ri = rl;
	              for (; ri && !r[--ri];) r[ri] = 9;
	              --r[ri];
	              r[rl] += 10;
	            }
	            r[rl] -= bt[rl];
	          }
	
	          for (; !r[0];) r.shift();
	        } else {
	          break;
	        }
	      }
	
	      // Add the digit n to the result array.
	      qc[qi++] = cmp ? n : ++n;
	
	      // Update the remainder.
	      if (r[0] && cmp) r[rl] = a[ai] || 0;
	      else r = [a[ai]];
	
	    } while ((ai++ < al || r[0] !== UNDEFINED) && k--);
	
	    // Leading zero? Do not remove if result is simply zero (qi == 1).
	    if (!qc[0] && qi != 1) {
	
	      // There can't be more than one zero.
	      qc.shift();
	      q.e--;
	    }
	
	    // Round?
	    if (qi > d) round(q, dp, Big.RM, r[0] !== UNDEFINED);
	
	    return q;
	  };
	
	
	  /*
	   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
	   */
	  P.eq = function (y) {
	    return !this.cmp(y);
	  };
	
	
	  /*
	   * Return true if the value of this Big is greater than the value of Big y, otherwise return
	   * false.
	   */
	  P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
	   * return false.
	   */
	  P.gte = function (y) {
	    return this.cmp(y) > -1;
	  };
	
	
	  /*
	   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
	   */
	  P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
	   * return false.
	   */
	  P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big minus the value of Big y.
	   */
	  P.minus = P.sub = function (y) {
	    var i, j, t, xlty,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    // Signs differ?
	    if (a != b) {
	      y.s = -b;
	      return x.plus(y);
	    }
	
	    var xc = x.c.slice(),
	      xe = x.e,
	      yc = y.c,
	      ye = y.e;
	
	    // Either zero?
	    if (!xc[0] || !yc[0]) {
	
	      // y is non-zero? x is non-zero? Or both are zero.
	      return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);
	    }
	
	    // Determine which is the bigger number. Prepend zeros to equalise exponents.
	    if (a = xe - ye) {
	
	      if (xlty = a < 0) {
	        a = -a;
	        t = xc;
	      } else {
	        ye = xe;
	        t = yc;
	      }
	
	      t.reverse();
	      for (b = a; b--;) t.push(0);
	      t.reverse();
	    } else {
	
	      // Exponents equal. Check digit by digit.
	      j = ((xlty = xc.length < yc.length) ? xc : yc).length;
	
	      for (a = b = 0; b < j; b++) {
	        if (xc[b] != yc[b]) {
	          xlty = xc[b] < yc[b];
	          break;
	        }
	      }
	    }
	
	    // x < y? Point xc to the array of the bigger number.
	    if (xlty) {
	      t = xc;
	      xc = yc;
	      yc = t;
	      y.s = -y.s;
	    }
	
	    /*
	     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
	     * needs to start at yc.length.
	     */
	    if ((b = (j = yc.length) - (i = xc.length)) > 0) for (; b--;) xc[i++] = 0;
	
	    // Subtract yc from xc.
	    for (b = i; j > a;) {
	      if (xc[--j] < yc[j]) {
	        for (i = j; i && !xc[--i];) xc[i] = 9;
	        --xc[i];
	        xc[j] += 10;
	      }
	
	      xc[j] -= yc[j];
	    }
	
	    // Remove trailing zeros.
	    for (; xc[--b] === 0;) xc.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xc[0] === 0;) {
	      xc.shift();
	      --ye;
	    }
	
	    if (!xc[0]) {
	
	      // n - n = +0
	      y.s = 1;
	
	      // Result must be zero.
	      xc = [ye = 0];
	    }
	
	    y.c = xc;
	    y.e = ye;
	
	    return y;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big modulo the value of Big y.
	   */
	  P.mod = function (y) {
	    var ygtx,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    if (!y.c[0]) throw Error(DIV_BY_ZERO);
	
	    x.s = y.s = 1;
	    ygtx = y.cmp(x) == 1;
	    x.s = a;
	    y.s = b;
	
	    if (ygtx) return new Big(x);
	
	    a = Big.DP;
	    b = Big.RM;
	    Big.DP = Big.RM = 0;
	    x = x.div(y);
	    Big.DP = a;
	    Big.RM = b;
	
	    return this.minus(x.times(y));
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big plus the value of Big y.
	   */
	  P.plus = P.add = function (y) {
	    var t,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    // Signs differ?
	    if (a != b) {
	      y.s = -b;
	      return x.minus(y);
	    }
	
	    var xe = x.e,
	      xc = x.c,
	      ye = y.e,
	      yc = y.c;
	
	    // Either zero? y is non-zero? x is non-zero? Or both are zero.
	    if (!xc[0] || !yc[0]) return yc[0] ? y : new Big(xc[0] ? x : a * 0);
	
	    xc = xc.slice();
	
	    // Prepend zeros to equalise exponents.
	    // Note: reverse faster than unshifts.
	    if (a = xe - ye) {
	      if (a > 0) {
	        ye = xe;
	        t = yc;
	      } else {
	        a = -a;
	        t = xc;
	      }
	
	      t.reverse();
	      for (; a--;) t.push(0);
	      t.reverse();
	    }
	
	    // Point xc to the longer array.
	    if (xc.length - yc.length < 0) {
	      t = yc;
	      yc = xc;
	      xc = t;
	    }
	
	    a = yc.length;
	
	    // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
	    for (b = 0; a; xc[a] %= 10) b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;
	
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	
	    if (b) {
	      xc.unshift(b);
	      ++ye;
	    }
	
	    // Remove trailing zeros.
	    for (a = xc.length; xc[--a] === 0;) xc.pop();
	
	    y.c = xc;
	    y.e = ye;
	
	    return y;
	  };
	
	
	  /*
	   * Return a Big whose value is the value of this Big raised to the power n.
	   * If n is negative, round to a maximum of Big.DP decimal places using rounding
	   * mode Big.RM.
	   *
	   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
	   */
	  P.pow = function (n) {
	    var x = this,
	      one = new x.constructor(1),
	      y = one,
	      isneg = n < 0;
	
	    if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throw Error(INVALID + 'exponent');
	    if (isneg) n = -n;
	
	    for (;;) {
	      if (n & 1) y = y.times(x);
	      n >>= 1;
	      if (!n) break;
	      x = x.times(x);
	    }
	
	    return isneg ? one.div(y) : y;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big rounded using rounding mode rm
	   * to a maximum of dp decimal places, or, if dp is negative, to an integer which is a
	   * multiple of 10**-dp.
	   * If dp is not specified, round to 0 decimal places.
	   * If rm is not specified, use Big.RM.
	   *
	   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
	   * rm? 0, 1, 2 or 3 (ROUND_DOWN, ROUND_HALF_UP, ROUND_HALF_EVEN, ROUND_UP)
	   */
	  P.round = function (dp, rm) {
	    var Big = this.constructor;
	    if (dp === UNDEFINED) dp = 0;
	    else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
	    return round(new Big(this), dp, rm === UNDEFINED ? Big.RM : rm);
	  };
	
	
	  /*
	   * Return a new Big whose value is the square root of the value of this Big, rounded, if
	   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
	   */
	  P.sqrt = function () {
	    var r, c, t,
	      x = this,
	      Big = x.constructor,
	      s = x.s,
	      e = x.e,
	      half = new Big(0.5);
	
	    // Zero?
	    if (!x.c[0]) return new Big(x);
	
	    // Negative?
	    if (s < 0) throw Error(NAME + 'No square root');
	
	    // Estimate.
	    s = Math.sqrt(x + '');
	
	    // Math.sqrt underflow/overflow?
	    // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
	    if (s === 0 || s === 1 / 0) {
	      c = x.c.join('');
	      if (!(c.length + e & 1)) c += '0';
	      s = Math.sqrt(c);
	      e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
	      r = new Big((s == 1 / 0 ? '1e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
	    } else {
	      r = new Big(s);
	    }
	
	    e = r.e + (Big.DP += 4);
	
	    // Newton-Raphson iteration.
	    do {
	      t = r;
	      r = half.times(t.plus(x.div(t)));
	    } while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));
	
	    return round(r, Big.DP -= 4, Big.RM);
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big times the value of Big y.
	   */
	  P.times = P.mul = function (y) {
	    var c,
	      x = this,
	      Big = x.constructor,
	      xc = x.c,
	      yc = (y = new Big(y)).c,
	      a = xc.length,
	      b = yc.length,
	      i = x.e,
	      j = y.e;
	
	    // Determine sign of result.
	    y.s = x.s == y.s ? 1 : -1;
	
	    // Return signed 0 if either 0.
	    if (!xc[0] || !yc[0]) return new Big(y.s * 0);
	
	    // Initialise exponent of result as x.e + y.e.
	    y.e = i + j;
	
	    // If array xc has fewer digits than yc, swap xc and yc, and lengths.
	    if (a < b) {
	      c = xc;
	      xc = yc;
	      yc = c;
	      j = a;
	      a = b;
	      b = j;
	    }
	
	    // Initialise coefficient array of result with zeros.
	    for (c = new Array(j = a + b); j--;) c[j] = 0;
	
	    // Multiply.
	
	    // i is initially xc.length.
	    for (i = b; i--;) {
	      b = 0;
	
	      // a is yc.length.
	      for (j = a + i; j > i;) {
	
	        // Current sum of products at this digit position, plus carry.
	        b = c[j] + yc[i] * xc[j - i - 1] + b;
	        c[j--] = b % 10;
	
	        // carry
	        b = b / 10 | 0;
	      }
	
	      c[j] = (c[j] + b) % 10;
	    }
	
	    // Increment result exponent if there is a final carry, otherwise remove leading zero.
	    if (b) ++y.e;
	    else c.shift();
	
	    // Remove trailing zeros.
	    for (i = c.length; !c[--i];) c.pop();
	    y.c = c;
	
	    return y;
	  };
	
	
	  /*
	   * Return a string representing the value of this Big in exponential notation to dp fixed decimal
	   * places and rounded using Big.RM.
	   *
	   * dp? {number} Integer, 0 to MAX_DP inclusive.
	   */
	  P.toExponential = function (dp) {
	    return stringify(this, 1, dp, dp);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big in normal notation to dp fixed decimal
	   * places and rounded using Big.RM.
	   *
	   * dp? {number} Integer, 0 to MAX_DP inclusive.
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   */
	  P.toFixed = function (dp) {
	    return stringify(this, 2, dp, this.e + dp);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big rounded to sd significant digits using
	   * Big.RM. Use exponential notation if sd is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * sd {number} Integer, 1 to MAX_DP inclusive.
	   */
	  P.toPrecision = function (sd) {
	    return stringify(this, 3, sd, sd - 1);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big.
	   * Return exponential notation if this Big has a positive exponent equal to or greater than
	   * Big.PE, or a negative exponent equal to or less than Big.NE.
	   * Omit the sign for negative zero.
	   */
	  P.toString = function () {
	    return stringify(this);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big.
	   * Return exponential notation if this Big has a positive exponent equal to or greater than
	   * Big.PE, or a negative exponent equal to or less than Big.NE.
	   * Include the sign for negative zero.
	   */
	  P.valueOf = P.toJSON = function () {
	    return stringify(this, 4);
	  };
	
	
	  // Export
	
	
	  Big = _Big_();
	
	  Big['default'] = Big.Big = Big;
	
	  //AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return Big; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other CommonJS-like environments that support module.exports.
	  } else if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Big;
	
	  //Browser.
	  } else {
	    GLOBAL.Big = Big;
	  }
	})(this);


/***/ }),
/* 156 */,
/* 157 */,
/* 158 */
26,
/* 159 */
26,
/* 160 */
26,
/* 161 */
26,
/* 162 */
26,
/* 163 */
26,
/* 164 */
26,
/* 165 */
26,
/* 166 */
26,
/* 167 */
26,
/* 168 */
26,
/* 169 */
26,
/* 170 */
26,
/* 171 */
26,
/* 172 */
26,
/* 173 */
26,
/* 174 */
26,
/* 175 */
26,
/* 176 */
26,
/* 177 */
26,
/* 178 */
26,
/* 179 */
26,
/* 180 */
26,
/* 181 */
26,
/* 182 */
26,
/* 183 */
26,
/* 184 */
26,
/* 185 */
26,
/* 186 */
26,
/* 187 */
26,
/* 188 */
26,
/* 189 */
26,
/* 190 */
26,
/* 191 */
26,
/* 192 */
26,
/* 193 */
26,
/* 194 */
26,
/* 195 */
26,
/* 196 */
26,
/* 197 */
26,
/* 198 */
26,
/* 199 */
26,
/* 200 */
26,
/* 201 */
26,
/* 202 */
26,
/* 203 */
26,
/* 204 */
26,
/* 205 */
26,
/* 206 */
26,
/* 207 */
26,
/* 208 */
26,
/* 209 */
26,
/* 210 */
/***/ (function(module, exports) {

	module.exports = {"server":"https://sispro.fdi.gob.bo/ws/","serverAuth":"https://sispro.fdi.gob.bo/ws/","timeSessionExpired":30,"debug":false,"onbeforeunload":false,"port":3100,"subDomain":"/","portDev":8880}

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(34)(module)))

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(216);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppComponent = {
	  controller: _app2.default,
	  template: '\n    <app-sidenav ng-if="$root.auth" id="app-sidenav" ng-class="{ \'no-sidenav\' : !$ctrl.getSidenav() }"></app-sidenav>\n    <app-navbar ng-if="$root.auth"></app-navbar>\n    <div class="main" ng-class="{ \'no-login\' : !$root.auth }">\n      <app-breadcrumb ng-if="$root.auth"></app-breadcrumb>\n      <section class="main-section" ui-view style="{{!$root.auth ? \'height:100%; overflow:auto;\':\'\'}}"></section>\n    </div>\n    <app-footer></app-footer>\n    <app-loading></app-loading>\n  '
	};
	
	exports.default = AppComponent;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(210);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var server = _config2.default.server;
	var domain = _config2.default.subDomain;
	
	var Config = angular.module('app.config', []).constant('appName', 'FDI') // prefijo del sistema para el Storage y Sessiones
	.constant('systemName', 'Sistema de Proyectos  SISPRO').constant('timeSessionExpired', _config2.default.timeSessionExpired) //Tiempo en minutos para que la sesión se cierre automáticamente si existe i$
	.constant('onbeforeunload', _config2.default.onbeforeunload).constant('debug', _config2.default.debug).constant('PageNoLogin', ['login', 'restablecer-contrasenia', 'consultasqr']) // Rutas que no requieren autenticación
	.constant('authUrl', _config2.default.serverAuth + '/autenticar') // URL para autenticación
	.constant('authEmpresasUrl', _config2.default.serverAuth + '/autenticar/empresa') // URL para autenticación de empresas
	.constant('apiUrl', server + '/api/v1/') // Rest principal del sistema
	.constant('apiUrlPublic', server + '/public/') // URL publica del sistema
	.constant('baseUrl', server + '/') // Ruta base
	.constant('subDomain', '' + domain).constant('decimales', 6) // Número de decimales para campos numéricos
	.name;
	
	exports.default = Config;

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppController = function () {
	  AppController.$inject = ["$rootScope", "$location", "Storage", "Auth", "PageNoLogin", "timeSessionExpired", "SidenavFactory"];
	  function AppController($rootScope, $location, Storage, Auth, PageNoLogin, timeSessionExpired, SidenavFactory) {
	    'ngInject';
	
	    _classCallCheck(this, AppController);
	
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.Auth = Auth;
	    this.Storage = Storage;
	    this.PageNoLogin = PageNoLogin;
	    this.timeSessionExpired = timeSessionExpired;
	    this.SidenavFactory = SidenavFactory;
	  }
	
	  _createClass(AppController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      // this.$rootScope.auth = this.Auth.isAuthenticated(); // Descomentar cuando exista el backend
	      this.$rootScope.auth = this.Storage.existUser(); // Comentar cuando ya no se use el fake de autenticación
	
	      // Verificando si se está logueado
	      if (this.$rootScope.auth) {
	        this.Auth.timerSession();
	      } else {
	        var path = this.$location.path();
	
	        // Verificando si el path actual esa una página de excepción que no require autenticación
	        if (!this.exist(path)) {
	          if (path.length) {
	            this.Storage.set('path', path.replace('/', ''));
	          }
	          this.$location.path('login');
	        }
	      }
	    }
	  }, {
	    key: 'exist',
	    value: function exist(path) {
	      var paths = this.PageNoLogin;
	      for (var i in paths) {
	        if (path.indexOf('/' + paths[i]) === 0 || path.indexOf('/' + paths[i] + '/') === 0) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getSidenav',
	    value: function getSidenav() {
	      return this.SidenavFactory.getSidenav();
	    }
	  }]);
	
	  return AppController;
	}();
	
	exports.default = AppController;

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CommonConfig = function CommonConfig($httpProvider, $logProvider, $authProvider, authUrl, appName, DataServiceConfig, uibDatepickerPopupConfig, uibDatepickerConfig, formlyConfigProvider, debug, $compileProvider, cfpLoadingBarProvider) {
	  'ngInject';
	
	  // Habilitar los logs del sistema
	
	  $logProvider.debugEnabled(false);
	
	  // Configurando parametros para autenticación con Satellizer
	  // Config url auth
	  $authProvider.loginUrl = authUrl;
	  // $authProvider.signupUrl = "http://api.com/auth/signup";
	  $authProvider.tokenName = "token";
	  $authProvider.tokenPrefix = appName;
	  // $httpProvider.defaults.headers.get = { 'Access-Control-Allow-Origin': '*' };
	  // $authProvider.authToken = 'Bearer';
	
	  // Configurando salida de respuesta del rest backend para el DataService
	  // DataServiceConfig.filterResponse = function (response, Message) {
	  //     if (response.datos) {
	  //         response = response.datos;
	  //     } else {
	  //         if (!response.finalizado) {
	  //             Message.error(response.mensaje);
	  //             response = response.datos;
	  //         }
	  //     }
	  //     return response;
	  // };
	
	  // para que en la descarga de archivo quite el unsafe
	  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|blob):/);
	
	  // Configurando datepicker
	  uibDatepickerPopupConfig.appendToBody = true;
	  uibDatepickerPopupConfig.clearText = 'Limpiar';
	  uibDatepickerPopupConfig.closeText = 'Cerrar';
	  uibDatepickerPopupConfig.currentText = 'Hoy';
	  uibDatepickerPopupConfig.onOpenFocus = false;
	  uibDatepickerPopupConfig.datepickerPopup = 'dd/MM/yyyy';
	  uibDatepickerConfig.showWeeks = false;
	
	  // Configurando formly
	  formlyConfigProvider.setWrapper({
	    name: 'validation',
	    types: ['input', 'select', 'datepicker', 'textarea'],
	    template: '\n      <formly-transclude></formly-transclude>\n      <div class="form-error" ng-messages="fc.$error" ng-if="form.$submitted || options.formControl.$touched">\n        <div ng-message="{{ ::name }}" ng-repeat="(name, message) in ::options.validation.messages" class="message">{{ message(fc.$viewValue, fc.$modelValue, this)}}</div>\n      </div>\n    '
	  });
	
	  // Config loading
	  cfpLoadingBarProvider.spinnerTemplate = '<div id="loading-bar-spinner"><div class="loading-container"><span class="loading-text"></span> <span class="spinner-icon"></span></div></div>';
	};
	CommonConfig.$inject = ["$httpProvider", "$logProvider", "$authProvider", "authUrl", "appName", "DataServiceConfig", "uibDatepickerPopupConfig", "uibDatepickerConfig", "formlyConfigProvider", "debug", "$compileProvider", "cfpLoadingBarProvider"];
	
	exports.default = CommonConfig;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Importando css de las librerías del sistema
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(162);
	
	__webpack_require__(163);
	
	__webpack_require__(158);
	
	__webpack_require__(160);
	
	__webpack_require__(165);
	
	__webpack_require__(164);
	
	__webpack_require__(161);
	
	__webpack_require__(159);
	
	__webpack_require__(184);
	
	__webpack_require__(195);
	
	__webpack_require__(194);
	
	var _angularjs = __webpack_require__(106);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _satellizer = __webpack_require__(834);
	
	var _satellizer2 = _interopRequireDefault(_satellizer);
	
	var _angularLoadingBar = __webpack_require__(135);
	
	var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);
	
	var _angularSanitize = __webpack_require__(141);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularMessages = __webpack_require__(137);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _angularResource = __webpack_require__(139);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _uiSelect = __webpack_require__(838);
	
	var _uiSelect2 = _interopRequireDefault(_uiSelect);
	
	var _angularToastr = __webpack_require__(144);
	
	var _angularToastr2 = _interopRequireDefault(_angularToastr);
	
	var _angularUiValidate = __webpack_require__(148);
	
	var _angularUiValidate2 = _interopRequireDefault(_angularUiValidate);
	
	__webpack_require__(213);
	
	var _big = __webpack_require__(155);
	
	var _big2 = _interopRequireDefault(_big);
	
	__webpack_require__(76);
	
	__webpack_require__(132);
	
	__webpack_require__(131);
	
	__webpack_require__(666);
	
	__webpack_require__(149);
	
	__webpack_require__(142);
	
	__webpack_require__(675);
	
	__webpack_require__(133);
	
	var _common = __webpack_require__(217);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _common3 = __webpack_require__(219);
	
	var _common4 = _interopRequireDefault(_common3);
	
	var _lang = __webpack_require__(323);
	
	var _lang2 = _interopRequireDefault(_lang);
	
	var _core = __webpack_require__(220);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _layout = __webpack_require__(330);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import '../../../node_modules/leaflet/dist/leaflet'; //<-- agregado mediante webpack.config
	//import '../../../node_modules/angular-leaflet-directive/dist/angular-leaflet-directive';
	//import '../../../node_modules/leaflet-fullscreen/dist/Leaflet.fullscreen';
	
	// import jsonEditor from 'jsoneditor';
	
	// Importando dependencias
	var Common = angular.module('app.common', [_angularLoadingBar2.default, _angularSanitize2.default, _angularMessages2.default, _angularResource2.default, _satellizer2.default, 'angularFileUpload', 'formlyBootstrap', _angularToastr2.default, 'ngTable', _angularjs2.default, _uiSelect2.default, _lang2.default, _core2.default, _layout2.default, _angularUiValidate2.default, 'cfp.loadingBar', 'mgo-angular-wizard', 'angular-timeline', 'ngCsv', 'angular-jsoneditor']).config(_common2.default).run(_common4.default).constant('statePrevs', {}) // Controlar state(url) previos para cada state, si no se define en un state trabajara normal
	.constant('_', window._).constant('Big', _big2.default).name;
	//import '../../../node_modules/pdfjs-dist/build/pdf.combined'; //<-- agregado mediante webpack.config
	
	// import 'tether'; // Tether (required for Bootstrap 4.x)
	
	// import '../../../node_modules/jsoneditor/dist/jsoneditor.min.css';
	exports.default = Common;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var runBlock = function runBlock(onbeforeunload, $transitions, statePrevs, formlyConfig, $anchorScroll) {
	  'ngInject';
	
	  //Fullscreen event and hack mozilla
	
	  function exitFullScreen() {
	    angular.element(document.body).removeClass('fullscreen');
	  }
	
	  angular.element(window.document).on('keyup', function (e) {
	    if (e.keyCode == 27) {
	      exitFullScreen();
	    }
	  });
	
	  document.addEventListener("mozfullscreenchange", function () {
	    if (!document.mozFullScreen) {
	      exitFullScreen();
	    }
	  }, false);
	
	  if (onbeforeunload) {
	    window.onbeforeunload = function () {
	      return '¿Está seguro de abandonar la página?.';
	    };
	  }
	
	  for (var name in statePrevs) {
	    var prevs = statePrevs[name];
	    statePrevs[name] = {};
	    prevs.forEach(function (namePrev) {
	      statePrevs[name][namePrev] = !0;
	    });
	  }
	
	  $transitions.onStart({}, function (transition) {
	    if (transition.from().name != '' && statePrevs[transition.to().name] && !statePrevs[transition.to().name][transition.from().name]) {
	      // $log.log('abort')
	      transition.abort();
	    }
	  });
	
	  formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched || form.$submitted';
	
	  $anchorScroll.yOffset = 60;
	};
	runBlock.$inject = ["onbeforeunload", "$transitions", "statePrevs", "formlyConfig", "$anchorScroll"];
	
	exports.default = runBlock;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _service = __webpack_require__(248);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _filter = __webpack_require__(222);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _interceptor = __webpack_require__(227);
	
	var _interceptor2 = _interopRequireDefault(_interceptor);
	
	var _vendorModule = __webpack_require__(671);
	
	var _vendorModule2 = _interopRequireDefault(_vendorModule);
	
	var _util = __webpack_require__(320);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Core = angular.module('app.core', [_vendorModule2.default, _interceptor2.default, _filter2.default, _service2.default, _util2.default]).name;
	
	exports.default = Core;

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DatetimeFilter = function DatetimeFilter(Datetime) {
	    'ngInject';
	
	    return function (date, format) {
	
	        if (format) {
	            if (format == 'literal') {
	                return Datetime.dateLiteral(date);
	            }
	            if (format == 'year') {
	                return Datetime.now('YYYY');
	            }
	            if (format == 'timeLiteral') {
	                return Datetime.timeLiteral(date);
	            }
	            if (format == 'convert') {
	                return Datetime.toString(date);
	            }
	        }
	
	        return date;
	    };
	};
	DatetimeFilter.$inject = ["Datetime"];
	
	exports.default = DatetimeFilter;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _datetime = __webpack_require__(221);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _text = __webpack_require__(225);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _number = __webpack_require__(224);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _nombreUnido = __webpack_require__(223);
	
	var _nombreUnido2 = _interopRequireDefault(_nombreUnido);
	
	var _typeof = __webpack_require__(226);
	
	var _typeof2 = _interopRequireDefault(_typeof);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Filter = angular.module('app.filters', []).filter('datetime', _datetime2.default).filter('characters', _text2.default.characters).filter('splitcharacters', _text2.default.splitcharacters).filter('words', _text2.default.words).filter('numberToLiteral', _number2.default.numberToLiteral).filter('formatDecimal', _number2.default.formatDecimal).filter('nombreUnido', _nombreUnido2.default).filter('typeof', _typeof2.default).name;
	
	exports.default = Filter;

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var NombreUnidoFilter = function NombreUnidoFilter(_, Util) {
	    'ngInject';
	
	    return function (objPersona) {
	
	        if (!_.isEmpty(objPersona)) {
	            return Util.getNombreUnido(objPersona);
	        }
	
	        return objPersona;
	    };
	};
	NombreUnidoFilter.$inject = ["_", "Util"];
	
	exports.default = NombreUnidoFilter;

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NumberFilter = {
	  numberToLiteral: ["numToWord", function numberToLiteral(numToWord) {
	    'ngInject';
	
	    return function (valor) {
	      if (!valor || typeof valor !== 'number') {
	        return;
	      }
	      return numToWord.transformar(valor);
	    };
	  }],
	  formatDecimal: ["$locale", "Util", "decimales", function formatDecimal($locale, Util, decimales) {
	    'ngInject';
	
	    return function (valor, nDecimales) {
	      if (!valor) {
	        return;
	      }
	      if (typeof valor !== 'number') {
	        return valor;
	      }
	      nDecimales = nDecimales || decimales || 2;
	      var separadorDecimal = $locale.NUMBER_FORMATS.DECIMAL_SEP;
	      var separadordeMiles = $locale.NUMBER_FORMATS.GROUP_SEP;
	
	      var valorFormateado = Util.redondear(parseFloat(valor), nDecimales).toFixed(nDecimales);
	      valorFormateado = valorFormateado.replace('.', separadorDecimal);
	
	      var partes = ('' + valorFormateado).split(separadorDecimal);
	      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, separadordeMiles);
	
	      return partes.join(separadorDecimal);
	    };
	  }]
	};
	
	exports.default = NumberFilter;

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TextFilter = {
	    characters: function characters() {
	        return function (input, chars, breakOnWord) {
	            if (isNaN(chars)) return input;
	            if (chars <= 0) return '';
	            if (input && input.length > chars) {
	                input = input.substring(0, chars).replace(/(<([^>]+)>)/ig, "");
	
	                if (!breakOnWord) {
	                    var lastspace = input.lastIndexOf(' ');
	                    //get last space
	                    if (lastspace !== -1) {
	                        input = input.substr(0, lastspace);
	                    }
	                } else {
	                    while (input.charAt(input.length - 1) === ' ') {
	                        input = input.substr(0, input.length - 1);
	                    }
	                }
	                return input + '…';
	            }
	            return input;
	        };
	    },
	    splitcharacters: function splitcharacters() {
	        return function (input, chars) {
	            if (isNaN(chars)) return input;
	            if (chars <= 0) return '';
	            if (input && input.length > chars) {
	                input = input.replace(/(<([^>]+)>)/ig, "");
	                var prefix = input.substring(0, chars / 2);
	                var postfix = input.substring(input.length - chars / 2, input.length);
	                return prefix + '...' + postfix;
	            }
	            return input;
	        };
	    },
	    words: function words() {
	        return function (input, words) {
	            if (isNaN(words)) return input;
	            if (words <= 0) return '';
	            if (input) {
	                input = input.replace(/(<([^>]+)>)/ig, "");
	                var inputWords = input.split(/\s+/);
	                if (inputWords.length > words) {
	                    input = inputWords.slice(0, words).join(' ') + '…';
	                }
	            }
	            return input;
	        };
	    }
	};
	
	exports.default = TextFilter;

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var TypeofFilter = function TypeofFilter() {
	    'ngInject';
	
	    return function (object) {
	        return typeof object === 'undefined' ? 'undefined' : _typeof(object);
	    };
	};
	
	exports.default = TypeofFilter;

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Interceptor = angular.module('app.interceptors', []).factory('AuthInterceptor', ["$q", "$injector", "timeSessionExpired", function ($q, $injector, timeSessionExpired) {
	    'ngInject';
	
	    return {
	        'request': function request(config) {
	
	            // Actualizando el tiempo de sesión de inactividad
	            if (angular.TIME) {
	                angular.TIME = timeSessionExpired * 60;
	            }
	
	            // Agregando cabecera para evitar ataque CSRF
	            // if(config.url.indexOf('http://test-routes.herokuapp.com') != -1) {
	            //     config.headers['x-csrf-token'] = 'lalalalala';
	            // }
	
	            return config;
	        },
	
	        'requestError': function requestError(rejection) {
	
	            return $q.reject(rejection);
	        },
	
	        'response': function response(_response) {
	
	            return _response;
	        },
	
	        'responseError': function responseError(rejection) {
	
	            // Cerrando sesión si no se tiene permisos de acceso
	            if (rejection.status === 403) {
	                var Auth = $injector.get('Auth');
	                Auth.logout();
	            }
	            return $q.reject(rejection);
	        }
	    };
	}]).config(["$httpProvider", function ($httpProvider) {
	    $httpProvider.interceptors.push('AuthInterceptor');
	}]).name;
	
	exports.default = Interceptor;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArrayService = function () {
	    function ArrayService() {
	        "ngInject";
	
	        _classCallCheck(this, ArrayService);
	    }
	
	    _createClass(ArrayService, [{
	        key: "replace",
	        value: function replace(text, find, _replace) {
	            for (var i = 0, l = find.length, regex; i < l; i++) {
	                regex = new RegExp(find[i], "g");
	                text = text.replace(regex, _replace[i]);
	            }
	            return text;
	        }
	    }, {
	        key: "insert",
	        value: function insert(arr, index, item) {
	            return arr.splice(index, 0, item);
	        }
	    }]);
	
	    return ArrayService;
	}();
	
	exports.default = ArrayService;

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataTableService = function () {
	  DataTableService.$inject = ["NgTableParams", "DataService", "Util"];
	  function DataTableService(NgTableParams, DataService, Util) {
	    'ngInject';
	
	    _classCallCheck(this, DataTableService);
	
	    this.NgTableParams = NgTableParams;
	    this.DataService = DataService;
	    this.Util = Util;
	  }
	
	  _createClass(DataTableService, [{
	    key: 'getParams',
	    value: function getParams(url) {
	      var _this = this;
	
	      var queryExtra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return new this.NgTableParams({}, {
	        getData: function getData(params) {
	          var query = _this.getQuery(params.url());
	          return _this.DataService.list(url, angular.merge(query, queryExtra)).then(function (response) {
	            if (response && response.datos) {
	              params.total(response.datos.count);
	              _this.showEmptyTable(response.datos);
	              _this.renderLabels(_this.getLabels(query, response.datos));
	              return response.datos.rows;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getParamsList',
	    value: function getParamsList(data) {
	      if (this.Util.toType(data) !== 'array') {
	        return;
	      }
	      return new this.NgTableParams({}, {
	        dataset: data
	      });
	    }
	  }, {
	    key: 'getLabels',
	    value: function getLabels(query, data) {
	      return {
	        ini: (query.page - 1) * query.limit + 1,
	        end: query.page * query.limit < data.count ? query.page * query.limit : data.count,
	        total: data.count
	      };
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      setTimeout(function () {
	        if (document.querySelector('.ng-table-counts')) {
	          document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	        }
	        if (document.querySelector('.ng-table-pagination')) {
	          document.querySelector('.ng-table-pagination').setAttribute('data-content', params.ini + ' al ' + params.end + ' de ' + params.total + ' Registros.');
	        }
	      }, 100);
	    }
	  }, {
	    key: 'showEmptyTable',
	    value: function showEmptyTable(data) {
	      var areaPagination = angular.element(document.querySelector('div[ng-table-pagination]'));
	      var sinRegistros = '<div class="alert alert-warning empty-table"><i class="fa fa-warning"></i> No existen registros.</div>';
	      if (data.count === 0) {
	        setTimeout(function () {
	          if (!angular.isUndefined(angular.element(document.querySelector(".empty-table"))[0])) {
	            angular.element(document.querySelector('.empty-table')).remove();
	          }
	          areaPagination.append(sinRegistros);
	        }, 100);
	      } else {
	        angular.element(document.querySelector('.empty-table')).remove();
	      }
	    }
	  }, {
	    key: 'getQuery',
	    value: function getQuery(data) {
	      var query = {
	        limit: data.count,
	        page: data.page
	      };
	      var sort = this.getSorting(data);
	      if (sort) {
	        query.order = sort;
	      }
	      var filters = this.getFilters(data);
	      if (filters.length) {
	        if (filters[0].crudtable_search_term) {
	          query.filter = filters[0].crudtable_search_term;
	        } else {
	          for (var i in filters) {
	            var key = Object.keys(filters[i])[0];
	            query[key] = filters[i][key];
	          }
	        }
	      }
	      return query;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }]);
	
	  return DataTableService;
	}();
	
	exports.default = DataTableService;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Config = function Config($httpProvider) {
	    'ngInject';
	
	    //initialize get if not there
	
	    if (!$httpProvider.defaults.headers.get) {
	        $httpProvider.defaults.headers.get = {};
	    }
	
	    // Answer edited to include suggestions from comments
	    // because previous version of code introduced browser-related errors
	
	    // //disable IE ajax request caching
	    // $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
	    // extra
	    $httpProvider.defaults.headers.get['Cache-Control'] = 'private, no-cache, no-store, must-revalidate';
	    $httpProvider.defaults.headers.get.Pragma = 'no-cache';
	};
	Config.$inject = ["$httpProvider"];
	
	exports.default = Config;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _httpCanceler = __webpack_require__(233);
	
	var _httpCanceler2 = _interopRequireDefault(_httpCanceler);
	
	var _data = __webpack_require__(232);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _data3 = __webpack_require__(230);
	
	var _data4 = _interopRequireDefault(_data3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Data = angular.module('app.data', []).constant('DataServiceConfig', {
	    filterResponse: null
	}).service('HTTPCanceler', _httpCanceler2.default).service('DataService', _data2.default).config(_data4.default).name;
	
	exports.default = Data;

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["group", "dir", "groupEnd", "table"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataService = function () {
	  DataService.$inject = ["$http", "$q", "$location", "$sce", "DataServiceConfig", "HTTPCanceler", "Message", "Util", "apiUrl", "appName", "errorsLang", "debug", "$log", "Storage", "Loading", "Auth"];
	  function DataService($http, $q, $location, $sce, DataServiceConfig, HTTPCanceler, Message, Util, apiUrl, appName, errorsLang, debug, $log, Storage, Loading, Auth) {
	    'ngInject';
	
	    _classCallCheck(this, DataService);
	
	    this.$http = $http;
	    this.$sce = $sce;
	    this.defer = $q.defer();
	    this.Message = Message;
	    this.Util = Util;
	    this.debug = debug;
	    this.DataServiceConfig = DataServiceConfig;
	    this.HTTPCanceler = HTTPCanceler;
	    this.canceler = this.HTTPCanceler.get(this.defer, this.appName);
	    this.apiUrl = apiUrl;
	    this.errorsLang = errorsLang;
	    this.appName = appName;
	    this.Storage = Storage;
	    this.Loading = Loading;
	    this.Auth = Auth;
	
	    this.PATERN_HOST = $location.protocol() == 'https' ? /(https:\/\/|www\.)\S+/i : /(http:\/\/|www\.)\S+/i;
	    this.$log = $log;
	    this.usuario = this.Storage.getUser();
	  }
	
	  _createClass(DataService, [{
	    key: 'cancelRequest',
	    value: function cancelRequest() {
	      this.HTTPCanceler.cancel();
	      this.canceler = this.HTTPCanceler.get(this.defer, this.appName);
	      this.cancel = true;
	    }
	  }, {
	    key: 'getUrl',
	    value: function getUrl(url, id) {
	      id = typeof id == 'string' || typeof id == 'number' ? '' + id : (typeof id === 'undefined' ? 'undefined' : _typeof(id)) == 'object' && id.id ? '' + id.id : '';
	      if (url[url.length - 1] != '/' && id.length > 0) {
	        id = '/' + id;
	      }
	      return this.PATERN_HOST.test(url) ? url + id : this.apiUrl + url + id;
	    }
	  }, {
	    key: 'options',
	    value: function options(url) {
	      return this._http('options', url);
	    }
	  }, {
	    key: 'get',
	    value: function get(url, id) {
	      return this._http('get', url, id);
	    }
	  }, {
	    key: 'post',
	    value: function post(url, data) {
	      return this._http('post', url, data);
	    }
	  }, {
	    key: 'put',
	    value: function put(url, data) {
	      return this._http('put', url, data);
	    }
	  }, {
	    key: 'patch',
	    value: function patch(url, data) {
	      return this._http('patch', url, data);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(url, id) {
	      return this._http('delete', url, id);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(url, id) {
	      return this.delete(url, id);
	    }
	  }, {
	    key: 'list',
	    value: function list(url, query) {
	      query = query ? '?' + this.Util.serialize(query) : '';
	      return this._http('get', url + query);
	    }
	  }, {
	    key: 'save',
	    value: function save(url, data) {
	      return this._http(data.id ? 'put' : 'post', url, data);
	    }
	  }, {
	    key: '_http',
	    value: function _http(method, url, data) {
	      var _this = this;
	
	      url = this.getUrl(url, data);
	      this.usuario = this.Storage.getUser();
	      url = url.replace('rol=', '');
	      if (this.usuario) {
	        if (url.indexOf('?') !== -1) {
	          url += '&rol=' + this.usuario.rol.id_rol;
	        } else {
	          url += '?rol=' + this.usuario.rol.id_rol;
	        }
	      }
	
	      if (this.debug) {
	        console.group('Petición con DataService:');
	        this.$log.info('URL:', method.toUpperCase(), url);
	        if (data) {
	          this.$log.info('Params:', data);
	        }
	      }
	
	      var setting = {
	        method: method,
	        url: url,
	        timeout: this.canceler.promise
	      };
	
	      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object' && Object.keys(data).length) {
	        delete data.id;
	        setting.data = data;
	      }
	
	      return this.$http(setting).then(function (response) {
	        return _this.filterResponse(response.data);
	      }).catch(function (error) {
	        if (_this.Loading) {
	          _this.Loading.hide();
	        }
	        _this.msgError(error);
	        if (error.data && error.data.erroresValidacion) {
	          return _this.filterResponse(error.data);
	        }
	      });
	    }
	  }, {
	    key: 'file',
	    value: function file(url, type) {
	      var _this2 = this;
	
	      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      url = this.getUrl(url);
	      return this.$http.post(url, data, { responseType: 'arraybuffer' }).then(function (response) {
	        if (response.data) {
	          var file = new window.Blob([response.data], { type: type });
	          var fileURL = window.URL.createObjectURL(file);
	          return _this2.$sce.trustAsResourceUrl(fileURL);
	        }
	        return null;
	      }).catch(function (error) {
	        return _this2.msgError(error);
	      });
	    }
	  }, {
	    key: 'pdf',
	    value: function pdf(url) {
	      var _this3 = this;
	
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var onlyUrl = arguments[2];
	
	      url = this.getUrl(url, data);
	      return this.$http.post(url, data, { responseType: 'arraybuffer' }).then(function (response) {
	        if (response.data) {
	          var file = new window.Blob([response.data], { type: 'application/pdf' });
	          var fileURL = window.URL.createObjectURL(file);
	          return onlyUrl ? fileURL : _this3.$sce.trustAsResourceUrl(fileURL);
	        }
	        return null;
	      }).catch(function (error) {
	        return _this3.msgError(error);
	      });
	    }
	  }, {
	    key: 'setFormly',
	    value: function setFormly(data) {
	      this.formly = data;
	    }
	  }, {
	    key: 'filterResponse',
	    value: function filterResponse(response) {
	      this.Storage.set('dateNow', response.fecha);
	      var data = response.datos || response;
	      if (this.debug) {
	        this.$log.info("Respuesta:");
	        console.dir(data);
	      }
	      if (this.Util.toType(data) == 'array') {
	        if (this.debug) {
	          this.$log.info("La respuesta es un Array:");
	        }
	        if (window.navigator.appName == 'Netscape') {
	          if (this.debug) {
	            console.table(data);
	          }
	        } else {
	          if (this.debug) {
	            console.table(data.map(function (item) {
	              return [item];
	            }));
	          }
	        }
	      }
	      if (this.debug) {
	        console.groupEnd();
	      }
	      if (typeof this.DataServiceConfig.filterResponse == 'function') {
	        return this.DataServiceConfig.filterResponse(response, this.Message);
	      }
	      return response;
	    }
	  }, {
	    key: 'msgError',
	    value: function msgError(error) {
	      if (this.debug) {
	        console.dir('Error:', error);
	        console.groupEnd();
	      }
	      var statusErrors = [500, 404, 409, 403, 401, 400, 502, 412];
	
	      if (error.status === 408 || error.status === 504) {
	        return error;
	      } else if (this.errorsLang[error.status]) {
	        this.Message[statusErrors.indexOf(error.status) != -1 ? 'error' : 'warning'](error.data.mensaje && typeof error.data.mensaje == 'string' ? error.data.mensaje && error.data.errores ? this.getMessageErrors(error.data) : error.data.mensaje : this.parseError(error.data) || this.errorsLang[error.status], error.data.errors ? this.errorsLang.validation : null);
	      } else if (this.cancel) {
	        this.Message.warning(this.errorsLang.cancelRequest);
	        this.cancel = false;
	      } else {
	        this.Message.error(this.parseError(error.data) || this.errorsLang.connection, error && error.data && error.data.mensaje ? error.data.mensaje : null);
	      }
	      if (error.status === 401 && error.data && error.data.mensaje && error.data.mensaje.indexOf('ha expirado') > 0) {
	        this.Auth.logout();
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getMessageErrors',
	    value: function getMessageErrors(error) {
	      var message = [];
	      error = error.errores;
	      for (var i in error) {
	        if (error[i].mensajes.join) {
	          message.push(error[i].mensajes.join(', '));
	        } else {
	          message.push(error[i].mensajes);
	        }
	      }
	      return message.join('<br>');
	    }
	  }, {
	    key: 'parseError',
	    value: function parseError(error) {
	      var message = [];
	      if (error) {
	        if (error.errors) {
	          if (error.detail || error.error) {
	            return error.detail || error.error;
	          }
	          if (Object.keys(error.errors).length === 0) {
	            return error;
	          }
	
	          error = error.errors;
	          for (var i in error) {
	            message.push('<strong>' + (error[i].label || i) + ':</strong> ' + (this.Util.toType(error[i].errors) == 'array' ? error[i].errors.join(', ') : error[i].errors));
	          }
	          return message.join('<br>');
	        } else if (error.errorType && error.errorType == 'ValidationError') {
	          error = error.property;
	          for (var _i in error) {
	            message.push('<strong>' + (error[_i].label || _i) + ':</strong> ' + (this.Util.toType(error[_i].errors) == 'array' ? error[_i].errors.join(', ') : error[_i].errors));
	          }
	          return message.join('<br>');
	        }
	      }
	      return null;
	    }
	  }]);
	
	  return DataService;
	}();
	
	exports.default = DataService;

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HTTPCanceler = function () {
	    HTTPCanceler.$inject = ["$q"];
	    function HTTPCanceler($q) {
	        'ngInject';
	
	        _classCallCheck(this, HTTPCanceler);
	
	        this.$q = $q;
	        this.promisesToReject = {};
	        this.canceler = {};
	        this.inited = {};
	    }
	
	    _createClass(HTTPCanceler, [{
	        key: 'get',
	        value: function get(defer, namespace) {
	            namespace = namespace || 'default';
	            if (!this.promisesToReject[namespace]) {
	                this.promisesToReject[namespace] = [];
	                this.canceler[namespace] = null;
	                this.inited[namespace] = false;
	            }
	            if (defer) {
	                this.promisesToReject[namespace].push(defer);
	            }
	            //Create new defer in first time and when the promise was canceled before
	            if (!this.inited[namespace]) {
	                this.canceler[namespace] = this.$q.defer();
	                this.inited[namespace] = true;
	            }
	            return this.canceler[namespace];
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel(namespace) {
	            namespace = namespace || 'default';
	            angular.forEach(this.promisesToReject, function (promises, promiseNamespace) {
	                if (!this.canceler[promiseNamespace]) return;
	                if ('default' !== namespace && namespace != promiseNamespace) return;
	                this.canceler[promiseNamespace].resolve();
	                this.inited[promiseNamespace] = false;
	                // Reject namespace promises
	                angular.forEach(promises, function (defer) {
	                    defer.reject();
	                });
	                this.promisesToReject[promiseNamespace] = [];
	            });
	        }
	    }]);
	
	    return HTTPCanceler;
	}();
	
	exports.default = HTTPCanceler;

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatetimeService = function () {
	    DatetimeService.$inject = ["Util", "ArrayUtil"];
	    function DatetimeService(Util, ArrayUtil) {
	        "ngInject";
	
	        _classCallCheck(this, DatetimeService);
	
	        this.Util = Util;
	        this.ArrayUtil = ArrayUtil;
	
	        this.formatDate = 'dd/MM/YYYY';
	        this.months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
	        this.days = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
	        this.dayslong = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
	    }
	
	    // TODO: Verificar si esto funciona
	
	
	    _createClass(DatetimeService, [{
	        key: 'date',
	        value: function date(_date, separator) {
	            _date = _date.split(separator || '-');
	            return new Date(_date[0], _date[1] - 1, _date[2]);
	        }
	    }, {
	        key: 'parse',
	        value: function parse(date, separator) {
	            return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join(separator || '-');
	        }
	    }, {
	        key: 'dateMonth',
	        value: function dateMonth() {
	            var date = new Date();
	            return new Date(date.getFullYear(), date.getMonth(), 1);
	        }
	    }, {
	        key: 'getPrevDateMonth',
	        value: function getPrevDateMonth(data) {
	            data = data || 1;
	            var date = new Date();
	            var day = date.getDate();
	            var month = date.getMonth();
	            var year = date.getFullYear();
	
	            if (day < data) {
	                month--;
	                if (month < 0) {
	                    month = 11;
	                    year--;
	                }
	            }
	            return new Date(year, month, data);
	        }
	    }, {
	        key: 'toString',
	        value: function toString(date) {
	            if (this.Util.toType(date) == 'string') {
	                var pos = date.indexOf('T');
	                if (pos != -1 && pos <= 10 && pos >= 8) {
	                    var fecha = date.substring(0, pos);
	                    if (!/[a-zA-Z]+/g.test(fecha) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(fecha)) {
	                        fecha = fecha.split('-');
	                        return this.format(new Date(fecha[0], parseInt(fecha[1]) - 1, fecha[2]));
	                    }
	                }
	            } else {
	                if (this.Util.toType(date) == 'date') {
	                    return this.format(new Date(date));
	                }
	            }
	            return date;
	        }
	    }, {
	        key: 'toDate',
	        value: function toDate(string) {
	            if (this.Util.toType(string) == 'string') {
	                var pos = string.indexOf('T');
	                if (pos != -1 && pos <= 10 && pos >= 8) {
	                    var fecha = string.substring(0, pos);
	                    if (!/[a-zA-Z]+/g.test(fecha) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(fecha)) {
	                        fecha = fecha.split('-');
	                        return new Date(fecha[0], parseInt(fecha[1]) - 1, fecha[2]);
	                    }
	                }
	            }
	            return string;
	        }
	    }, {
	        key: 'isDate',
	        value: function isDate(date) {
	            if (this.Util.toType(date) == 'string') {
	                date = this.convert(date);
	            }
	            return this.isValid(date);
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid(date) {
	            if (this.Util.toType(date) != 'date') return false;
	            return !isNaN(date.getTime());
	        }
	    }, {
	        key: 'isLessThan',
	        value: function isLessThan(date) {
	            return this.milliseconds(date) < new Date().getTime();
	        }
	    }, {
	        key: 'isLessThanDays',
	        value: function isLessThanDays(date, data) {
	            return this.milliseconds(date) > this.subtractDays(new Date(), data);
	        }
	    }, {
	        key: 'isGreaterThan',
	        value: function isGreaterThan(date) {
	            return this.milliseconds(date) > new Date().getTime();
	        }
	    }, {
	        key: 'isGreaterThanDays',
	        value: function isGreaterThanDays(date, data) {
	            return this.milliseconds(date) < this.addDays(new Date(), data);
	        }
	    }, {
	        key: 'addDays',
	        value: function addDays(date, days) {
	            return this.milliseconds(date) + (days || 0) * 24 * 60 * 60 * 1000;
	        }
	    }, {
	        key: 'subtractDays',
	        value: function subtractDays(date, days) {
	            return this.milliseconds(date) - (days || 0) * 24 * 60 * 60 * 1000;
	        }
	    }, {
	        key: 'diff',
	        value: function diff(date2, date1) {
	            return this.milliseconds(date2) - this.milliseconds(date1);
	        }
	    }, {
	        key: 'milliseconds',
	        value: function milliseconds(date) {
	            if (this.Util.toType(date) == 'string') {
	                date = this.convert(date);
	            }
	            return date.getTime();
	        }
	    }, {
	        key: 'convert',
	        value: function convert(date) {
	            date = date.split('/');
	            return this.formatDate == 'dd/MM/YYYY' ? new Date(date[2], date[1] - 1, date[0]) : this.formatDate == 'MM/dd/YYYY' ? new Date(date[2], date[0] - 1, date[1]) : new Date(date[0], date[1] - 1, date[2]);
	        }
	    }, {
	        key: 'setFormatDate',
	        value: function setFormatDate(format) {
	            this.formatDate = format;
	        }
	    }, {
	        key: 'now',
	        value: function now(format) {
	            return this.replace(new Date(), format || this.formatDate);
	        }
	    }, {
	        key: 'dateLiteral',
	        value: function dateLiteral(date) {
	            return this.format(date, 'dd de MMM del YYYY');
	        }
	    }, {
	        key: 'time',
	        value: function time(date) {
	            return this.format(date, 'HH:mm');
	        }
	    }, {
	        key: 'timeLiteral',
	        value: function timeLiteral(time, txt) {
	            var text = '';
	            if (typeof time == 'number') {
	                if (time === 0) {
	                    return '';
	                }
	                if (time < 60) {
	                    text = time + 's';
	                } else if (time < 3600) {
	                    text = Math.floor(time / 60) + 'm ' + (time % 60 > 0 ? time % 60 + 's' : '');
	                } else {
	                    text = Math.floor(time / 3600) + 'h ' + (time % 3600 > 0 ? Math.floor(time / 60) + 'm ' : '') + (time % 60 > 0 ? time % 60 + 's' : '');
	                }
	                return (txt || '') + text;
	            } else {
	                if (time.length === 0) {
	                    return '';
	                }
	                time = time.split(':');
	                var hours = time[0],
	                    minutes = time[1];
	
	                if (parseInt(hours) > 0) {
	                    text += parseInt(hours) + 'h ';
	                }
	                if (parseInt(minutes) > 0) {
	                    text += parseInt(minutes) + 'm ';
	                }
	                if (time.length == 3 && parseInt(time[2]) > 0) {
	                    text += parseInt(time[2]) + 's';
	                }
	
	                return (txt || '') + text;
	            }
	        }
	    }, {
	        key: 'getSeconds',
	        value: function getSeconds(time) {
	            time = time.split(':');
	            var hours = time[0],
	                minutes = time[1],
	                total = 0;
	
	            if (parseInt(hours) > 0) {
	                total += parseInt(hours) * 3600;
	            }
	            if (parseInt(minutes) > 0) {
	                total += parseInt(minutes) * 60;
	            }
	            if (time.length == 3 && parseInt(time[2]) > 0) {
	                total += parseInt(time[2]);
	            }
	
	            return total;
	        }
	    }, {
	        key: 'datetimeLiteral',
	        value: function datetimeLiteral(date) {
	            return this.format(date, 'dddd dd de MMM del YYYY a la(s) HH:mm');
	        }
	    }, {
	        key: 'format',
	        value: function format(date, _format) {
	            var d = new Date(date);
	            if (this.isDate(d)) {
	                return this.replace(d, _format || this.formatDate);
	            }
	            return date;
	        }
	    }, {
	        key: 'standar',
	        value: function standar(date, format) {
	            if (date) {
	                var type = this.Util.toType(date);
	                if (type == 'date') {
	                    return date;
	                }
	                var day, month, year;
	                if (type == 'string') {
	                    format = format || this.formatDate;
	                    var separator = date.indexOf('/') != -1 ? '/' : '-';
	                    date = date.split(separator);
	
	                    if (format == 'dd-MM-YYYY' || format == 'dd/MM/YYYY') {
	                        day = date[0];
	                        month = date[1] - 1;
	                        year = date[2];
	                    }
	
	                    if (format == 'MM-dd-YYYY' || format == 'MM/dd/YYYY') {
	                        day = date[1];
	                        month = date[0] - 1;
	                        year = date[2];
	                    }
	
	                    if (format == 'YYYY-MM-dd' || format == 'YYYY/MM/dd') {
	                        day = date[2];
	                        month = date[1] - 1;
	                        year = date[0];
	                    }
	
	                    if (format == 'YYYY-dd-MM' || format == 'YYYY/dd/MM') {
	                        day = date[1];
	                        month = date[2] - 1;
	                        year = date[0];
	                    }
	                }
	                return new Date(year, month, day);
	            }
	            return null;
	        }
	    }, {
	        key: 'replace',
	        value: function replace(date, format) {
	            format = format || this.formatDate;
	            date = this.standar(date, format);
	            var monthLiteral = format.indexOf('MMM') != -1;
	            return this.ArrayUtil.replace(format, ["dddd", "ddd", "dd", monthLiteral ? 'MMM' : 'MM', 'YYYY', 'HH', 'mm', 'ss'], [this.dayslong[date.getDay()], this.days[date.getDay()], (date.getDate() < 10 ? '0' : '') + date.getDate(), monthLiteral ? this.months[date.getMonth()] : (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1), date.getFullYear(), (date.getHours() < 10 ? '0' : '') + date.getHours(), (date.getMinutes() < 10 ? '0' : '') + date.getMinutes(), (date.getSeconds() < 10 ? '0' : '') + date.getSeconds()]);
	        }
	    }, {
	        key: 'last',
	        value: function last(date) {
	            var now = new Date();
	            var days = this.daysBetweenTwoDates(date, now);
	            if (days > 31) {
	                return this.dateLiteral(date);
	            } else {
	                if (days > 7) {
	                    var weeks = parseInt(days / 7);
	                    return 'Hace ' + weeks + ' semana' + (weeks > 1 ? 's' : '');
	                } else {
	                    if (days >= 1) {
	                        return this.format(date, 'ddd a la(s) HH:mm');
	                    } else {
	                        var hours = this.hoursBetweenTwoDates(date, now);
	                        if (this.isYesterday(date, hours)) {
	                            return 'Ayer a la(s) ' + this.time(date);
	                        } else {
	                            if (hours >= 1) {
	                                return 'Hace ' + hours + ' hora' + (hours > 1 ? 's' : '');
	                            } else {
	                                var minutes = this.minutesBetweenTwoDates(date, now);
	                                if (minutes >= 1) {
	                                    return 'Hace ' + minutes + ' minuto' + (minutes > 1 ? 's' : '');
	                                } else {
	                                    var seconds = this.secondsBetweenTwoDates(date, now);
	                                    return 'Hace ' + seconds + ' segundo' + (seconds > 1 ? 's' : '');
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'secondsBetweenTwoDates',
	        value: function secondsBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "s", absolute);
	        }
	    }, {
	        key: 'minutesBetweenTwoDates',
	        value: function minutesBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "i", absolute);
	        }
	    }, {
	        key: 'hoursBetweenTwoDates',
	        value: function hoursBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "h", absolute);
	        }
	    }, {
	        key: 'daysBetweenTwoDates',
	        value: function daysBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "d", absolute);
	        }
	    }, {
	        key: 'betweenTwoDates',
	        value: function betweenTwoDates(date1, date2, type, absolute) {
	            var types = { s: 1000, i: 60 * 1000, h: 60 * 60 * 1000, d: 24 * 60 * 60 * 1000 };
	            var diff = parseInt((this.standar(date2).getTime() - this.standar(date1).getTime()) / types[type]);
	
	            if (typeof absolute !== 'undefined' && absolute !== false) {
	                return Math.abs(diff);
	            }
	            return diff;
	        }
	    }, {
	        key: 'isYesterday',
	        value: function isYesterday(date, hours) {
	            if (this.isDate(date)) {
	                date = date.split(' ');
	                var time = date[1].split(':');
	                return hours >= parseInt(time[0]);
	            }
	            return false;
	        }
	    }, {
	        key: 'parseDate',
	        value: function parseDate(date) {
	            var year = date.getFullYear();
	            var month = date.getMonth() + 1;
	            var day = date.getDate();
	            if (day < 10) {
	                day = '0' + day;
	            }
	            if (month < 10) {
	                month = '0' + month;
	            }
	
	            return [day, month, year].join('/');
	        }
	    }, {
	        key: 'parseDateDjango',
	        value: function parseDateDjango(date) {
	            return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
	        }
	    }, {
	        key: 'lessYearsToDate',
	        value: function lessYearsToDate(nYears, date) {
	            if (!date) {
	                date = new Date();
	            }
	            var vDate = this.date(date.toISOString().slice(0, 10));
	            return new Date(vDate.setYear(vDate.getFullYear() - nYears));
	        }
	    }, {
	        key: 'getFormatDate',
	        value: function getFormatDate(data) {
	            if (data.length === 10 && data.split('-')[0].length === 2) {
	                data = data.split('-').reverse().join('-');
	            }
	            data = data.substring(0, 10);
	            return this.date(data);
	        }
	    }, {
	        key: 'addDaysToDate',
	        value: function addDaysToDate(date, days) {
	            date.setDate(date.getDate() + days);
	            return date;
	        }
	    }]);
	
	    return DatetimeService;
	}();
	
	exports.default = DatetimeService;

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DownloadFile = function () {
	  function DownloadFile() {
	    _classCallCheck(this, DownloadFile);
	
	    this.restrict = 'A';
	    this.controller = DownloadFileController;
	  }
	
	  _createClass(DownloadFile, [{
	    key: 'link',
	    value: function link($scope, $element, $attrs, $ctrl) {
	      $element.bind('click', function () {
	        $ctrl.Loading.show('Preparando documento para su descarga', true);
	        var url = $attrs.downloadFile;
	        var dType = 'application/pdf';
	        if ($attrs.downloadType === 'csv') {
	          dType = 'text/csv';
	        }
	        $ctrl.$http.get(url, {
	          responseType: 'arraybuffer',
	          headers: { 'Authorization': 'Bearer ' + $ctrl.Storage.get('token') }
	        }).then(function (response) {
	          var blob = new Blob([response.data], {
	            type: dType
	          });
	          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	            window.navigator.msSaveOrOpenBlob(blob);
	          } else {
	            var url = URL.createObjectURL(blob);
	            var a = document.createElement('a');
	            var date = new Date();
	            a.href = url;
	            a.download = date.getTime() + '_' + $attrs.fileName + ($attrs.downloadType ? '.' + $attrs.downloadType : '');
	            a.target = '_self';
	            document.body.appendChild(a);
	            a.click();
	          }
	          $ctrl.Loading.hide();
	        });
	      });
	    }
	  }]);
	
	  return DownloadFile;
	}();
	
	var DownloadFileController = function DownloadFileController($http, Storage, Loading) {
	  'ngInject';
	
	  _classCallCheck(this, DownloadFileController);
	
	  this.$http = $http;
	  this.Storage = Storage;
	  this.Loading = Loading;
	};
	DownloadFileController.$inject = ["$http", "Storage", "Loading"];
	
	exports.default = DownloadFile;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _filter = __webpack_require__(237);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	__webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function paste(obj, e) {
	    e.stopPropagation();
	    e.preventDefault();
	
	    var pastedData = void 0;
	    if (window.clipboardData && window.clipboardData.getData) {
	        // IE       
	        pastedData = window.clipboardData.getData('Text');
	    } else if (e.clipboardData && e.clipboardData.getData) {
	        pastedData = e.clipboardData.getData('text/plain');
	    }
	
	    if (typeof pastedData == 'string' && pastedData.length) {
	        pastedData = pastedData.trim();
	    }
	
	    if (obj.maxLength !== undefined) {
	        var maxLength = parseInt(obj.maxLength);
	        if (maxLength && maxLength > 0 && typeof maxLength == 'number') {
	            pastedData = pastedData.substring(0, maxLength);
	        }
	    }
	
	    return pastedData;
	}
	
	function setTextPaste(scope, ngModel, text) {
	    ngModel = ngModel.replace('$ctrl.', '');
	    var model = ngModel.split('.');
	    if (model.length > 1) {
	        if (model.length == 2) {
	            scope.$ctrl[model[0]][model[1]] = text;
	        } else if (model.length == 3) {
	            scope.$ctrl[model[0]][model[1]][model[2]] = text;
	        } else if (model.length == 4) {
	            scope.$ctrl[model[0]][model[1]][model[2]][model[3]] = text;
	        }
	    } else {
	        scope.$ctrl[ngModel] = text;
	    }
	}
	
	var Filter = angular.module('app.service.filter', []).service('Filter', _filter2.default).directive('integer', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.integer(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isInteger(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isInteger(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('decimal', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.decimal(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isDecimal(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isDecimal(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('decimalPositive', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.decimalPositive(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isDecimalPositive(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isDecimalPositive(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('decimalFormat', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.decimalFormat(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isDecimalFormat(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isDecimalFormat(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('numeric', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.numeric(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isNumeric(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isNumeric(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('alpha', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.alpha(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isAlpha(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isAlpha(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('alphaNumeric', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.alphaNumeric(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isAlphaNumeric(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isAlphaNumeric(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('alphaDash', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.alphaDash(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isAlphaDash(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isAlphaDash(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('passport', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.passport(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isPassport(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isPassport(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('phone', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.phone(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isPhone(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isPhone(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('uppercase', function () {
	    return {
	        require: 'ngModel',
	        link: function link(scope, element) {
	            element.bind('change', function () {
	                // console.log('El elemento ha cambiado.',scope,ctrl,e)
	                if (scope.$ctrl.ngModel) {
	                    scope.$ctrl.ngModel = scope.$ctrl.ngModel.toUpperCase();
	                }
	            });
	            // ctrl.$parsers.push(function(input) {
	            //     return input ? input.toUpperCase() : "";
	            // });
	            // element.css("text-transform","uppercase");
	        }
	    };
	}).directive('nit', ["Filter", function (Filter) {
	    var $error = angular.element('<div class="md-error-nit">NIT inválido</div>');
	
	    return function (scope, element) {
	        element.bind("keydown", function (e) {
	            Filter.numeric(e);
	        }).bind("keyup", function () {
	            var isNit = Filter.isNit(element[0].value);
	            var $element = angular.element(element[0]).parent();
	            if (!isNit) {
	                $element.append($error);
	                $element.addClass('relative');
	            } else {
	                $error.remove();
	                $element.removeClass('relative');
	            }
	        }).bind('paste', function () {
	            setTimeout(function () {
	                if (!Filter.isNit(element[0].value)) {
	                    element[0].value = '';
	                }
	            }, 1);
	        });
	    };
	}]).directive('focusMe', ['$timeout', function ($timeout) {
	    return {
	        scope: { trigger: '@focusMe' },
	        link: function link(scope, element) {
	            scope.$watch('trigger', function (value) {
	                if (value === "true") {
	                    $timeout(function () {
	                        element[0].focus();
	                    });
	                }
	            });
	        }
	    };
	}]).directive('focusIf', ['$timeout', function ($timeout) {
	    function link($scope, $element, $attrs) {
	        var dom = $element[0];
	        if ($attrs.focusIf) {
	            $scope.$watch($attrs.focusIf, focus);
	        } else {
	            focus(true);
	        }
	        function focus(condition) {
	            if (condition) {
	                $timeout(function () {
	                    dom.focus();
	                }, $scope.$eval($attrs.focusDelay) || 0);
	            }
	        }
	    }
	    return {
	        restrict: 'A',
	        link: link
	    };
	}]).name;
	
	exports.default = Filter;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FilterService = function () {
	  function FilterService() {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, FilterService);
	
	    this.exceptions = {
	      "integer": [46, 8, 9, 27, 13, 110, 173, 189, 109],
	      "natural": [46, 8, 9, 27, 13, 110, 190],
	      "decimal": [46, 8, 9, 27, 13, 110, 190, 173, 189, 109],
	      "decimal_positive": [46, 8, 9, 27, 13, 110, 190],
	      "numeric": [46, 8, 9, 27, 13],
	      "alpha": [46, 8, 9, 27, 13, 32],
	      "alpha_dash": [46, 8, 9, 27, 13, 32, 173, 189, 109],
	      "passport": [46, 8, 9, 27, 13, 32, 173, 189, 109, 190, 0, 192]
	    };
	    this.exceptions.alpha_numeric = this.exceptions.alpha;
	    this.evaluate = {
	      numeric: function numeric(e) {
	        return (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105);
	      },
	      alpha: function alpha(e) {
	        return e.keyCode < 65 || e.keyCode > 90;
	      }
	    };
	    this.evaluate.integer = this.evaluate.numeric;
	    this.evaluate.decimal = this.evaluate.numeric;
	    this.evaluate.natural = this.evaluate.numeric;
	    this.evaluate.decimal_positive = this.evaluate.numeric;
	    this.evaluate.alpha_numeric = function (e) {
	      return _this.evaluate.alpha(e) && _this.evaluate.numeric(e);
	    };
	    this.evaluate.alpha_dash = this.evaluate.alpha_numeric;
	    this.evaluate.alpha_dash = this.evaluate.alpha_numeric;
	    this.evaluate.passport = this.evaluate.alpha_numeric;
	  }
	
	  _createClass(FilterService, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'nit',
	    value: function nit() {
	      var nit = {
	        verhoeff: function verhoeff(x, y) {
	          var m = ['0123456789', '1234067895', '2340178956', '3401289567', '4012395678', '5987604321', '6598710432', '7659821043', '8765932104', '9876543210'];
	          if (m[x] && m[x][y]) {
	            return parseInt(m[x][y]);
	          }
	          return -1;
	        },
	
	        permutations: function permutations(x, y) {
	          var m = ['0123456789', '1576283094', '5803796142', '8916043527', '9453126870', '4286573901', '2793806415', '7046913258'];
	          if (m[x] && m[x][y]) {
	            return parseInt(m[x][y]);
	          }
	          return -1;
	        },
	
	        evaluate: function evaluate(num) {
	          var check = 0,
	              x,
	              y,
	              z;
	
	          if (typeof num == 'string' && isNaN(num)) {
	            return false;
	          }
	          num = parseInt(num);
	          for (var i = 0, l = num.toString().length; i < l; i++) {
	            x = i % 8;
	            y = num % 10;
	            num = Math.floor(num / 10);
	            z = nit.permutations(x, y);
	            check = nit.verhoeff(check, z);
	          }
	
	          return check === 0;
	        }
	      };
	
	      return nit;
	    }
	  }, {
	    key: 'filterBase',
	    value: function filterBase(e, type) {
	      if (e.altKey === true && e.keyCode >= 96 && e.keyCode <= 105) {
	        e.preventDefault();
	      }
	      if (this.exceptions[type].indexOf(e.keyCode) !== -1 || e.keyCode == 86 && e.ctrlKey === true || e.keyCode == 65 && e.ctrlKey === true || e.keyCode >= 35 && e.keyCode <= 39) {
	        return;
	      }
	      if (this.evaluate[type](e)) {
	        if (type.indexOf('alpha') === 0) {
	          if (!(e.key == 'ñ' || e.key == 'Ñ')) {
	            e.preventDefault();
	          }
	        } else {
	          e.preventDefault();
	        }
	      }
	    }
	  }, {
	    key: 'isNumber',
	    value: function isNumber(o) {
	      return typeof o === 'number' && isFinite(o);
	    }
	  }, {
	    key: 'isFloat',
	    value: function isFloat(value) {
	      return value % 1 !== 0;
	    }
	  }, {
	    key: 'integer',
	    value: function integer(e) {
	      this.filterBase(e, 'integer');
	    }
	  }, {
	    key: 'isInteger',
	    value: function isInteger(value) {
	      if (/[a-zA-Z]+/g.test(value) || !/^-?[0-9.]*$/g.test(value)) {
	        return false;
	      }
	      value = this.convert(value);
	      if (value === 'NaN' || !this.isNumber(value)) {
	        return false;
	      }
	      return !this.isFloat(value);
	    }
	  }, {
	    key: 'decimal',
	    value: function decimal(e) {
	      this.filterBase(e, 'decimal');
	    }
	  }, {
	    key: 'isDecimal',
	    value: function isDecimal(value) {
	      if (/[a-zA-Z]+/g.test(value) || !/^-?[0-9.]+\,?[0-9]*$/g.test(value)) {
	        return false;
	      }
	      value = this.convert(value);
	      if (value === 'NaN') {
	        return false;
	      }
	      return this.isNumber(value);
	    }
	  }, {
	    key: 'decimalPositive',
	    value: function decimalPositive(e) {
	      this.filterBase(e, 'decimal_positive');
	    }
	  }, {
	    key: 'isDecimalPositive',
	    value: function isDecimalPositive(value) {
	      if (/[a-zA-Z]+/g.test(value) || !/^[0-9.]+\,?[0-9]*$/g.test(value)) {
	        return false;
	      }
	      value = this.convert(value);
	      if (value === 'NaN') {
	        return false;
	      }
	      return this.isNumber(value);
	    }
	  }, {
	    key: 'decimalFormat',
	    value: function decimalFormat(e) {
	
	      this.decimalPositive(e);
	
	      var valor = e.target.value;
	      var exceptions = [37, 39, 46, 8, 9];
	      var t = e.keyCode ? e.keyCode : e.which;
	      var target = e.target;
	
	      if (valor.match(/\./g)) {
	        if (t == 190 || t == 110) {
	          e.preventDefault();
	        }
	        var char = t >= 96 && t <= 105 ? t - 96 : String.fromCharCode(t);
	        var newValue = valor.substring(0, target.selectionStart) + char + valor.substring(target.selectionEnd);
	        if (!/^(\d+(?:\.?\d{0,2})?)?$/g.test(newValue) && exceptions.indexOf(t) == -1) {
	          e.preventDefault();
	        }
	      } else {
	        if (t == 190 || t == 110) {
	          var decimal = valor.substring(target.selectionEnd);
	          if (decimal.length > 2) {
	            decimal = decimal.substring(0, 2);
	            e.target.value = valor.substring(0, target.selectionStart) + '.' + decimal;
	            e.preventDefault();
	          }
	          if (valor.length === 0) {
	            e.target.value = '0';
	          }
	        }
	      }
	    }
	  }, {
	    key: 'isDecimalFormat',
	    value: function isDecimalFormat(value) {
	      return (/^(\d+(?:\.?\d{0,2})?)?$/g.test(value)
	      );
	    }
	  }, {
	    key: 'natural',
	    value: function natural(e) {
	      this.filterBase(e, 'natural');
	    }
	  }, {
	    key: 'isNatural',
	    value: function isNatural(value) {
	      if (/[a-zA-Z]+/g.test(value) || !/^[0-9]*$/g.test(value)) {
	        return false;
	      }
	      value = this.convert(value);
	      if (value === 'NaN' || !this.isNumber(value)) {
	        return false;
	      }
	      return !this.isFloat(value) && value >= 0;
	    }
	  }, {
	    key: 'numeric',
	    value: function numeric(e) {
	      this.filterBase(e, 'numeric');
	    }
	  }, {
	    key: 'isNumeric',
	    value: function isNumeric(value) {
	      return (/^([0-9])*$/.test(value)
	      );
	    }
	  }, {
	    key: 'alpha',
	    value: function alpha(e) {
	      this.filterBase(e, 'alpha');
	    }
	  }, {
	    key: 'isAlpha',
	    value: function isAlpha(value) {
	      return (/^[A-Z|a-z|À-Ö|Ø-ö|ø-ÿ|ñ|Ñ|\-|'|´| ]+$/.test(value)
	      );
	    }
	  }, {
	    key: 'alphaNumeric',
	    value: function alphaNumeric(e) {
	      this.filterBase(e, 'alpha_numeric');
	    }
	  }, {
	    key: 'isAlphaNumeric',
	    value: function isAlphaNumeric(value) {
	      return (/^[A-Z|a-z|À-Ö|Ø-ö|ø-ÿ|ñ|Ñ|\-|'|´| |0-9]*$/.test(value)
	      );
	    }
	  }, {
	    key: 'alphaDash',
	    value: function alphaDash(e) {
	      this.filterBase(e, 'alpha_dash');
	    }
	  }, {
	    key: 'isAlphaDash',
	    value: function isAlphaDash(value) {
	      return (/^[A-Z|a-z|À-Ö|Ø-ö|ø-ÿ|ñ|Ñ|\-|'|´| |0-9|_]*$/.test(value)
	      );
	    }
	  }, {
	    key: 'passport',
	    value: function passport(e) {
	      this.filterBase(e, 'passport');
	    }
	  }, {
	    key: 'isPassport',
	    value: function isPassport(value) {
	      return (/^[A-Z|a-z|À-Ö|Ø-ö|ø-ÿ|ñ|Ñ|\-|'|´| |0-9|_|\.]*$/.test(value)
	      );
	    }
	  }, {
	    key: 'isPhone',
	    value: function isPhone(value) {
	      return (/^(?:(?:\(?(?:00|\+)([1-e]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i.test(value)
	      );
	      // return /[\d()*+\- ]+/.test(value);
	    }
	  }, {
	    key: 'removeTagHTML',
	    value: function removeTagHTML(text) {
	      return text.replace(/<([^ >]+)[^>]*>.*?<\/\1>|<[^\/]+\/>/gi, "");
	    }
	  }, {
	    key: 'empty',
	    value: function empty(value) {
	      return value === undefined || value === null || value.length === 0 || /^\s+$/.test(value);
	    }
	  }, {
	    key: 'isEmail',
	    value: function isEmail(value) {
	      return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
	      );
	    }
	  }, {
	    key: 'convert',
	    value: function convert(value) {
	      return parseFloat(isNaN(value) ? value.replace(/\./g, '').replace(',', '.') : value);
	    }
	  }, {
	    key: 'isNit',
	    value: function isNit(value) {
	      return this.nit().evaluate(value);
	    }
	  }]);
	
	  return FilterService;
	}();
	
	exports.default = FilterService;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _flujos = __webpack_require__(239);
	
	var _flujos2 = _interopRequireDefault(_flujos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Flujos = angular.module('app.service.flujos', []).service('Flujos', _flujos2.default).name;
	
	exports.default = Flujos;

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FlujosService = function () {
	  FlujosService.$inject = ["Storage", "_"];
	  function FlujosService(Storage, _) {
	    "ngInject";
	
	    _classCallCheck(this, FlujosService);
	
	    this._ = _;
	    this.Storage = Storage;
	  }
	
	  _createClass(FlujosService, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'getAtributosPermitidos',
	    value: function getAtributosPermitidos(entidad) {
	      var estado = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'estado_actual';
	
	      this.usuario = this.Storage.getUser();
	      var atributos = [];
	      if (this.usuario) {
	        atributos = entidad[estado].atributos;
	        if (!Array.isArray(entidad[estado].atributos)) {
	          atributos = atributos[this.usuario.rol.id_rol];
	          if (!atributos) {
	            atributos = [];
	          }
	        }
	      }
	      entidad[estado].atributos = this._.zipObject(atributos, Array.from(new Array(atributos.length), function () {
	        return true;
	      }));
	    }
	  }]);
	
	  return FlujosService;
	}();
	
	exports.default = FlujosService;

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Formly = function () {
	  function Formly() {
	    'ngInject';
	
	    _classCallCheck(this, Formly);
	  }
	
	  _createClass(Formly, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarPlantillas();
	    }
	  }, {
	    key: 'nuevaPlantilla',
	    value: function nuevaPlantilla(tipo) {
	      return this.parse(this.templates[tipo].template);
	    }
	  }, {
	    key: 'init',
	    value: function init(formlyConfig) {
	      formlyConfig.setType({
	        name: 'texto',
	        templateUrl: 'app/common/util/formly/texto/texto.html'
	      });
	      formlyConfig.setType({
	        name: 'lista',
	        templateUrl: 'app/common/util/formly/listas/lista.html'
	      });
	    }
	  }, {
	    key: 'obtenerConfiguracionItem',
	    value: function obtenerConfiguracionItem(item) {
	      if (item.type === 'layout') return this.parse(item);
	      var obj = {
	        type: item.type,
	        key: item.key,
	        className: this.parse(item.className),
	        templateOptions: this.parse(item.templateOptions),
	        validation: this.parse(item.validation)
	      };
	      return obj;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(data) {
	      return angular.fromJson(angular.toJson(data));
	    }
	  }, {
	    key: 'listaAFormulario',
	    value: function listaAFormulario(listaPlantillas, configForm) {
	      var nro_columnas = configForm.columnas || 1,
	          clase = 'flex-gt-sm-' + parseInt(100 / nro_columnas),
	          nro_filas = parseInt(listaPlantillas / nro_columnas),
	          formularios = [];
	
	      for (var i = 0; i < nro_filas; i++) {
	        formularios.push({
	          elementAttributes: {
	            'layout-gt-sm': 'row',
	            'layout': 'column',
	            'layout-align-gt-sm': 'start-end'
	          },
	          fieldGroup: []
	        });
	      }
	
	      var nro_form = 0,
	          contador = 0;
	
	      while (nro_form < listaPlantillas.length) {
	        // var nro_col = 0;
	        while (nro_form < listaPlantillas.length && nro_form < nro_columnas) {
	          listaPlantillas[nro_form].className = clase;
	          if (listaPlantillas[nro_form].templateOptions.label === '' || listaPlantillas[nro_form].templateOptions.label === null) {
	            listaPlantillas[nro_form].key = listaPlantillas[nro_form].templateOptions.placeholder;
	          } else {
	            listaPlantillas[nro_form] = listaPlantillas[nro_form].templateOptions.label;
	          }
	
	          if (listaPlantillas[nro_form].type === 'radio') {
	            listaPlantillas[nro_form].templateOptions.className = 'layout  layout-wrap';
	          }
	
	          if (configForm.deshabilitar || false) {
	            listaPlantillas[nro_form].templateOptions.disabled = true;
	          } else {
	            listaPlantillas[nro_form].templateOptions.disabled = false;
	          }
	
	          if (configForm.todoMayuscula || false) {
	            if (listaPlantillas[nro_form].type === 'input') {
	              var onKeyUp = 'model["' + listaPlantillas[nro_form].key + '"]= model["' + listaPlantillas[nro_form].key + '"].toUpperCase()';
	              listaPlantillas[nro_form].templateOptions.onKeyUp = onKeyUp;
	            }
	          }
	
	          if (configForm.validacion || false) {
	            if (listaPlantillas[nro_form].type === 'input' || listaPlantillas[nro_form].type === 'datepicker') {
	              listaPlantillas[nro_form].validation = {
	                messages: { required: '"Debe llenar este campo."' }
	              };
	            }
	          }
	
	          formularios[contador].fieldGroup.push(this.obtenerConfiguracionItem(listaPlantillas[nro_form]));
	          nro_form++;
	          // nro_col++;
	        }
	        contador++;
	      }
	      return formularios;
	    }
	  }, {
	    key: 'filtrarDatos',
	    value: function filtrarDatos(listaPlantillas, listaValores) {
	      for (var i = 0; i < listaPlantillas.length; i++) {
	        if (listaPlantillas[i].type === "datepicker") {
	          var nombre = listaPlantillas[i].templateOptions.label;
	          if (listaValores.hasOwnProperty(nombre)) {
	            listaValores[nombre] = new Date(listaValores[nombre]);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'cargarPlantillas',
	    value: function cargarPlantillas() {
	      this.templates = {
	        input: {
	          template: {
	            type: 'input',
	            key: 'inputText',
	            templateOptions: {
	              type: 'text',
	              label: 'Campo de texto',
	              disabled: false
	            }
	          }
	        },
	        radio: {
	          template: {
	            type: 'radio',
	            key: 'inputRadio',
	            templateOptions: {
	              label: 'Selección simple',
	              labelProp: 'value',
	              valueProp: 'id',
	              vertical: false,
	              options: [{ value: 'Opción 1', id: 'op1' }, { value: 'Opción 2', id: 'op2' }]
	            }
	          }
	        },
	        select: {
	          template: {
	            type: 'select',
	            key: 'inputSelect',
	            templateOptions: {
	              label: 'Lista de selección',
	              multiple: false,
	              labelProp: 'value',
	              valueProp: 'id',
	              options: [{ value: 'Opción 1', id: 'op1' }, { value: 'Opción 2', id: 'op2' }]
	            }
	          }
	        },
	        select_multiple: {
	          template: {
	            type: 'select',
	            key: 'inputSelect',
	            templateOptions: {
	              label: 'Lista de selección multiple',
	              multiple: true,
	              labelProp: 'value',
	              valueProp: 'id',
	              options: [{ value: 'Opción 1', id: 'op1' }, { value: 'Opción 2', id: 'op2' }]
	            }
	          }
	        },
	        textarea: {
	          template: {
	            type: 'textarea',
	            key: 'inputTextArea',
	            templateOptions: {
	              label: 'Área de texto',
	              rows: 2,
	              grow: false
	            }
	          }
	        },
	        checkbox: {
	          template: {
	            type: 'checkbox',
	            key: 'inputCheckBox',
	            templateOptions: {
	              label: 'Casilla de verificación',
	              disabled: false
	            }
	          }
	        },
	        datepicker: {
	          template: {
	            type: 'datepicker',
	            key: 'inputDatePicker',
	            templateOptions: {
	              label: 'Calendario'
	            }
	          }
	        },
	        titulo: {
	          template: {
	            type: 'texto',
	            key: 'texto',
	            templateOptions: {
	              label: 'Título',
	              tipo: 'h2',
	              className: 'ap-text-left',
	              mTop: true,
	              mBot: true
	            }
	          }
	        },
	        subtitulo: {
	          template: {
	            type: 'texto',
	            key: 'texto',
	            templateOptions: {
	              label: 'Subtítulo',
	              tipo: 'h2',
	              className: 'ap-text-left',
	              mTop: true,
	              mBot: true
	            }
	          }
	        },
	        parrafo: {
	          template: {
	            type: 'texto',
	            key: 'parrafo',
	            templateOptions: {
	              label: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,\n            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris\n            nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in\n            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla\n            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in\n            culpa qui officia deserunt mollit anim id est laborum.',
	              tipo: 'p',
	              className: 'ap-text-justify',
	              mTop: true,
	              mBot: true
	            }
	          }
	        },
	        ccArchivo: {
	          template: {
	            type: 'ccArchivo',
	            key: 'ccArchivo',
	            templateOptions: {
	              labelw: 10,
	              label: 'CC/Archivo:'
	            }
	          }
	        },
	        cite: {
	          template: {
	            type: 'cite',
	            templateOptions: {
	              labelCite: 'CITE',
	              labelFecha: 'FECHA',
	              tipo: 'general',
	              numeracionPagina: 'false',
	              tipoHoja: 'Letter'
	            }
	          }
	        }
	      };
	    }
	  }, {
	    key: 'datosAVista',
	    value: function datosAVista(datos, modelo) {
	      var elem,
	          form = [],
	          llaves = [];
	
	      for (var i = 0; i < datos.length; i++) {
	        if (datos[i].type == "layout") {
	          var fg = this.parse(datos[i]);
	          var clase = " flex-" + parseInt(100 / fg.elementAttributes['num-cols']);
	          delete fg.type;
	          delete fg.elementAttributes['num-cols'];
	          fg.fieldGroup = [];
	          for (var j = 0; j < datos[j].fieldGroup.length; j++) {
	            elem = this.obtenerConfiguracionItem(datos[i].fieldGroup[j]);
	            elem.className += clase;
	            this.cambiarElemento(elem, llaves, modelo);
	            fg.fieldGroup.push(elem);
	          }
	          form.push(fg);
	        } else {
	          elem = this.obtenerConfiguracionItem(datos[i]);
	          this.cambiarElemento(elem, llaves, modelo);
	          form.push(elem);
	        }
	      }
	    }
	  }, {
	    key: 'tamanoObjeto',
	    value: function tamanoObjeto(objeto) {
	      return Object.keys(objeto).length;
	    }
	  }, {
	    key: 'mostrarErrorRecursivo',
	    value: function mostrarErrorRecursivo(errores) {
	      for (var error in errores) {
	        for (var i = 0; i < errores[error].length; i++) {
	          if (angular.isDefined(errores[error][i].$submitted)) {
	            errores[error][i].$submitted = true;
	            this.mostrarErrorRecursivo(errores[error][i].$error);
	          } else {
	            if (errores[error][i].$setTouched) errores[error][i].$setTouched(true);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'desactivarFormulario',
	    value: function desactivarFormulario(datos, habilitar) {
	      angular.forEach(datos, function (campo) {
	        if (angular.isDefined(campo.fieldGroup)) {
	          for (var i = 0; i < campo.fieldGroup.length; i++) {
	            if (campo.fieldGroup[i].templateOptions) {
	              campo.fieldGroup[i].templateOptions.disabled = habilitar;
	            } else {
	              if (campo.templateOptions) {
	                campo.templateOptions.disabled = habilitar;
	              }
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'limpiarModelo',
	    value: function limpiarModelo(datos, modelo) {
	      var elem,
	          nuevoModelo = {},
	          llaves = {};
	
	      for (var i = 0; i < datos.length; i++) {
	        if (datos[i].type == "layout") {
	          for (var j = 0; j < datos[i].fieldGroup.length; j++) {
	            elem = this.obtenerConfiguracionItem(datos[i].fieldGroup[j]);
	            this.limpiarElemento(elem, llaves, modelo, nuevoModelo);
	          }
	        } else {
	          elem = this.obtenerConfiguracionItem(datos[i]);
	          this.limpiarElemento(elem, llaves, modelo, nuevoModelo);
	        }
	      }
	    }
	  }, {
	    key: 'limpiarElemento',
	    value: function limpiarElemento(elemento, llaves, modelo, nuevoModelo) {
	      if (angular.isUndefined(llaves[elemento.type])) {
	        llaves[elemento.type] = 1;
	        elemento.key = elemento.type + "-0";
	      } else {
	        elemento.key = elemento.type + "-" + llaves[elemento.type];
	        llaves[elemento.type]++;
	      }
	      if (angular.isDefined(modelo[elemento.key])) {
	        nuevoModelo[elemento.key] = angular.copy(modelo[elemento.key]);
	      }
	    }
	  }, {
	    key: 'cambiarElemento',
	    value: function cambiarElemento(elemento, llaves, modelos) {
	      if (angular.isUndefined(llaves[elemento.type])) {
	        llaves[elemento.type] = 1;
	        elemento.key = elemento.type + "-0";
	      } else {
	        elemento.key = elemento.type + "-" + llaves[elemento.type];
	        llaves[elemento.type]++;
	      }
	      if (elemento.type === "radio") {
	        elemento.templateOptions.className = "layout layout-wrap";
	      }
	      if (elemento.type === "datepicker" && angular.isDefined(modelos) && angular.isDefined(modelos[elemento.key])) {
	        modelos[elemento.key] = new Date(modelos[elemento.key]);
	      }
	      if (elemento.type === "textarea") {
	        elemento.templateOptions.grow = true;
	      }
	
	      if (elemento.templateOptions) {
	        var validation = { messages: {} };
	        if (elemento.templateOptions.required) {
	          validation.messages.required = '"Debe llenar este campo."';
	        }
	        if (elemento.type === "input") {
	          var idx = {
	            '([a-zA-Zñáéíóú]+ ?)+': '"El campo debe contener solo palabras separadas por un espacio."',
	            '\\d+': '"El campo debe contener solo números."',
	            '([a-zA-Z0-9ñáéíóú]+ ?)+': '"El campo debe contener palabras y números separadas por un espacio."',
	            '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$': '"El campo debe ser un email válido."',
	            '^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$': '"El campo debe ser una hora en formato hh:mm (ej. 08:47)"'
	          };
	          if (elemento.templateOptions.pattern) validation.messages.pattern = idx[elemento.templateOptions.pattern];
	          //le da el efecto de slider al mensaje de error
	          validation.show = true;
	          elemento.validation = validation;
	        }
	      }
	    }
	  }]);
	
	  return Formly;
	}();
	
	exports.default = Formly;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _message = __webpack_require__(242);
	
	var _message2 = _interopRequireDefault(_message);
	
	__webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Message = angular.module('app.message', []).service('Message', _message2.default).config(["toastrConfig", function (toastrConfig) {
	    angular.extend(toastrConfig, {
	        allowHtml: true,
	        closeButton: true,
	        extendedTimeOut: 1000,
	        progressBar: true,
	        tapToDismiss: false,
	        timeOut: 6000
	    });
	}]).name;
	
	exports.default = Message;

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MessageService = function () {
	    MessageService.$inject = ["toastr", "$log"];
	    function MessageService(toastr, $log) {
	        "ngInject";
	
	        _classCallCheck(this, MessageService);
	
	        this.toastr = toastr;
	        this.$log = $log;
	    }
	
	    _createClass(MessageService, [{
	        key: 'success',
	        value: function success(msg, title, timeout, callback) {
	            var data = {
	                message: msg || 'La operación se realizó correctamente.',
	                title: title || 'Correcto',
	                type: 'success',
	                timeout: timeout,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: 'info',
	        value: function info(msg, title, timeout, callback) {
	            var data = {
	
	                message: msg || 'Revise la documentación.',
	                title: title || 'Información',
	                type: 'info',
	                timeout: timeout,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: 'error',
	        value: function error(msg, title, timeout, callback) {
	            var data = {
	                message: msg || 'Ocurrió un error al procesar su operación.',
	                title: title || 'Error',
	                type: 'error',
	                timeout: timeout,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: 'warning',
	        value: function warning(msg, title, timeout, callback) {
	            var data = {
	                message: msg || 'Ocurrió algo inesperado al procesar su operación.',
	                title: title || 'Advertencia',
	                type: 'warning',
	                timeout: timeout,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: '_render',
	        value: function _render(data) {
	            this.toastr[data.type](data.message, data.title);
	        }
	    }]);
	
	    return MessageService;
	}();
	
	exports.default = MessageService;

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImageviewerModalController = function () {
	  ImageviewerModalController.$inject = ["$uibModalInstance", "$timeout", "$window", "data"];
	  function ImageviewerModalController($uibModalInstance, $timeout, $window, data) {
	    'ngInject';
	
	    _classCallCheck(this, ImageviewerModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$timeout = $timeout;
	    this.$window = $window;
	
	    this.title = data.title ? data.title : '';
	    if (data.image) {
	      this.image = data.image;
	      if (data.image.nombre) {
	        this.title += this.title === '' ? data.image.nombre : ' - ' + data.image.nombre;
	      }
	    }
	  }
	
	  _createClass(ImageviewerModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$ivScope = {}; // TODO Buscar otra forma de obtener el $scope de la directiva image-viewer
	      this.$timeout(function () {
	        if (_this.$window.innerWidth > 768) {
	          document.querySelector('.modal-dialog').style.maxWidth = '90%';
	        } else {
	          document.querySelector('.modal-dialog').style.maxWidth = '100%';
	        }
	        document.querySelector('.modal-dialog').style.maxHeight = _this.$window.innerHeight + 'px';
	      }, 100);
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      this.$uibModalInstance.close(this.informe);
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'getBase64Image',
	    value: function getBase64Image() {
	      if (this.informe.base64.indexOf('base64,') > 0) {
	        return this.informe.base64;
	      }
	      return 'data:' + this.informe.tipo + ';base64,' + this.informe.base64;
	    }
	  }, {
	    key: 'getBlobImage',
	    value: function getBlobImage() {
	      var _this2 = this;
	
	      if (!this.descargando) {
	        this.descargando = true;
	        var file = void 0,
	            a = document.createElement('a');
	        a.innerHTML = '.';
	        document.body.appendChild(a);
	        file = this.$$b64toBlob(this.informe.base64.replace('data:' + this.informe.tipo + ';base64,' + this.informe.base64, ''), this.informe.tipo);
	        if (window.navigator.msSaveBlob) {
	          window.navigator.msSaveOrOpenBlob(file, this.informe.nombre || 'documento.pdf');
	          this.descargando = false;
	        } else {
	          a.href = window.URL.createObjectURL(file);
	          // let base64String = btoa(String.fromCharCode.apply(null, new window.Uint8Array(resp.data)));
	          // a.href = 'data:application/pdf;base64,' + base64String;
	          a.download = this.informe.nombre || 'documento.pdf';
	          a.target = '_blank';
	          this.$timeout(function () {
	            a.click();
	            _this2.descargando = false;
	            angular.element(a).remove();
	          }, 250);
	        }
	      }
	    }
	  }, {
	    key: 'descargarImg',
	    value: function descargarImg() {
	      if (this.$ivScope.imageDownload) this.$ivScope.imageDownload();
	    }
	  }, {
	    key: 'imprimirImg',
	    value: function imprimirImg() {
	      if (this.$ivScope.imagePrint) this.$ivScope.imagePrint();
	    }
	
	    /**
	     * b64toBlob - Convert base64 string to a Blob object
	     *
	     * @param  {string}  b64Data     Base64 string
	     * @param  {strig}   contentType Type of base64 file
	     * @param  {integer} sliceSize   Slice for performance
	     * @return {Blob}                Blob object
	     * @description https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
	     */
	
	  }, {
	    key: '$$b64toBlob',
	    value: function $$b64toBlob(b64Data, contentType, sliceSize) {
	      contentType = contentType || '';
	      sliceSize = sliceSize || 512;
	
	      var byteCharacters = void 0;
	      if (b64Data.split(',')[0].indexOf('base64') >= 0) {
	        byteCharacters = atob(b64Data.split(',')[1]);
	      } else {
	        byteCharacters = atob(b64Data);
	      }
	      var byteArrays = [];
	
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	
	        var byteArray = new window.Uint8Array(byteNumbers);
	
	        byteArrays.push(byteArray);
	      }
	
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    }
	  }]);
	
	  return ImageviewerModalController;
	}();
	
	exports.default = ImageviewerModalController;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalController = function () {
	    ModalController.$inject = ["$uibModalInstance", "data", "title", "icon", "message", "labelOk", "labelCancel", "cancel", "eventCancel", "eventOk", "btnClose"];
	    function ModalController($uibModalInstance, data, title, icon, message, labelOk, labelCancel, cancel, eventCancel, eventOk, btnClose) {
	        'ngInject';
	
	        _classCallCheck(this, ModalController);
	
	        this.data = data;
	        this.title = title;
	        this.icon = icon;
	        this.message = message;
	        this.labelOk = labelOk;
	        this.eventCancel = eventCancel;
	        this.eventOk = eventOk;
	        this.labelCancel = labelCancel;
	        this.cancel = typeof cancel == 'undefined' ? true : cancel === '' ? true : cancel;
	        this.$uibModalInstance = $uibModalInstance;
	        this.btnClose = typeof btnClose == 'undefined' ? true : btnClose;
	    }
	
	    _createClass(ModalController, [{
	        key: 'ok',
	        value: function ok() {
	            this.$uibModalInstance.close(this.data);
	
	            if (typeof this.eventOk == 'function') {
	                this.eventOk();
	            }
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.$uibModalInstance.dismiss('cancel');
	
	            if (typeof this.eventCancel == 'function') {
	                this.eventCancel();
	            }
	            // TODO Modal. Otra forma de quitar el mensaje: Possibly unhandled rejection: cancel
	            this.$uibModalInstance.result.then(function () {}, function () {});
	        }
	    }]);
	
	    return ModalController;
	}();
	
	exports.default = ModalController;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _modal = __webpack_require__(246);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = angular.module('app.modal', []).service('Modal', _modal2.default).name;
	
	exports.default = Modal;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(244);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(689);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	var _pdfviewModal = __webpack_require__(247);
	
	var _pdfviewModal2 = _interopRequireDefault(_pdfviewModal);
	
	var _pdfviewModal3 = __webpack_require__(691);
	
	var _pdfviewModal4 = _interopRequireDefault(_pdfviewModal3);
	
	var _document_view_base64Modal = __webpack_require__(690);
	
	var _document_view_base64Modal2 = _interopRequireDefault(_document_view_base64Modal);
	
	var _imageviewer = __webpack_require__(688);
	
	var _imageviewer2 = _interopRequireDefault(_imageviewer);
	
	var _imageviewer3 = __webpack_require__(243);
	
	var _imageviewer4 = _interopRequireDefault(_imageviewer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalService = function () {
	    ModalService.$inject = ["$uibModal"];
	    function ModalService($uibModal) {
	        "ngInject";
	
	        _classCallCheck(this, ModalService);
	
	        this.$uibModal = $uibModal;
	    }
	
	    _createClass(ModalService, [{
	        key: 'show',
	        value: function show(config) {
	            var setting = {
	                animation: true,
	                ariaLabelledBy: 'modal-title',
	                ariaDescribedBy: 'modal-body',
	                template: config.template || _modal4.default,
	                controller: config.controller || _modal2.default,
	                controllerAs: '$ctrl',
	                size: config.size,
	                keyboard: typeof config.keyboard == 'undefined' ? true : config.keyboard,
	                backdrop: 'static',
	                resolve: {}
	            };
	
	            setData(config, setting, 'data');
	            setData(config, setting, 'title');
	            setData(config, setting, 'icon');
	            setData(config, setting, 'message');
	            setData(config, setting, 'labelOk');
	            setData(config, setting, 'labelCancel');
	            setData(config, setting, 'cancel');
	            setData(config, setting, 'eventCancel');
	            setData(config, setting, 'eventOk');
	            setData(config, setting, 'btnClose');
	
	            return this.$uibModal.open(setting);
	        }
	    }, {
	        key: 'alert',
	        value: function alert(message, callbackOk, title, icon, size) {
	            this.show({
	                title: title || 'Alerta',
	                icon: icon || 'bell',
	                message: message,
	                size: size || 'sm',
	                cancel: false,
	                eventOk: callbackOk,
	                keyboard: false,
	                btnClose: false
	            });
	        }
	    }, {
	        key: 'confirm',
	        value: function confirm(message, callbackOk, callbackCancel, title, labelOk, labelCancel, icon, size) {
	            var config = {
	                title: title || 'Confirmar',
	                icon: icon || 'warning',
	                message: message,
	                eventOk: callbackOk,
	                eventCancel: callbackCancel,
	                labelOk: labelOk,
	                labelCancel: labelCancel,
	                btnClose: false
	            };
	            if (typeof size == 'string') {
	                config.size = size;
	            }
	            this.show(config);
	            // TODO Modal. Otra forma de quitar el mensaje: Possibly unhandled rejection: cancel
	            //this.show(config).result.then(()=>{},()=>{});
	        }
	    }, {
	        key: 'pdf',
	        value: function pdf(urlPdfFile, title) {
	            this.show({
	                template: _pdfviewModal4.default,
	                controller: _pdfviewModal2.default,
	                data: {
	                    urlPdf: urlPdfFile,
	                    title: title
	                },
	                size: 'lg'
	            });
	        }
	    }, {
	        key: 'showDocumentBase64',
	        value: function showDocumentBase64(urlPdfFile, title, type) {
	            this.show({
	                template: _document_view_base64Modal2.default,
	                controller: _pdfviewModal2.default,
	                data: {
	                    urlPdf: urlPdfFile,
	                    title: title,
	                    type: type ? type : 'base64'
	                },
	                size: 'lg'
	            }).result.then(function () {}, function () {});
	        }
	    }, {
	        key: 'showFormularioBase64',
	        value: function showFormularioBase64(urlPdfFile, title, type) {
	            this.show({
	                template: _document_view_base64Modal2.default,
	                controller: _pdfviewModal2.default,
	                data: {
	                    reload: true,
	                    urlPdf: urlPdfFile,
	                    title: title,
	                    type: type ? type : 'base64'
	                },
	                size: 'lg'
	            }).result.then(function () {}, function () {});
	        }
	    }, {
	        key: 'showImageBase64',
	        value: function showImageBase64(urlImgFile, title, type) {
	            this.show({
	                template: _imageviewer2.default,
	                controller: _imageviewer4.default,
	                data: {
	                    image: urlImgFile,
	                    title: title,
	                    type: type ? type : 'base64'
	                },
	                size: 'lg'
	            }).result.then(function () {}, function () {});
	        }
	    }]);
	
	    return ModalService;
	}();
	
	function setData(config, setting, data) {
	    setting.resolve[data] = function () {
	        return typeof config[data] == 'undefined' ? '' : config[data];
	    };
	}
	
	exports.default = ModalService;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PdfViewModalController = function () {
	  PdfViewModalController.$inject = ["$uibModalInstance", "data", "$sce", "DataService", "$log"];
	  function PdfViewModalController($uibModalInstance, data, $sce, DataService, $log) {
	    'ngInject';
	
	    _classCallCheck(this, PdfViewModalController);
	
	    this.item = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$sce = $sce;
	    this.DataService = DataService;
	    this.$log = $log;
	  }
	
	  _createClass(PdfViewModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.item.type === 'base64') {
	        this.getFileBase64();
	      } else if (this.item.type === 'strBase64') {
	        // TODO solo se asume archivos PDFs
	        this.documento = {
	          base64: this.item.urlPdf.indexOf('base64') > 0 ? this.item.urlPdf : 'data:application/pdf;base64,' + this.item.urlPdf,
	          tipo: 'application/pdf'
	        };
	      } else {
	        this.getFile();
	      }
	    }
	  }, {
	    key: 'getFile',
	    value: function getFile() {
	      var _this = this;
	
	      this.DataService.pdf(this.item.urlPdf, {}).then(function (response) {
	        _this.$log.log('Documento PDF = ', response);
	        if (response) {
	          _this.urlPdf = response;
	        }
	      });
	    }
	  }, {
	    key: 'reloadFile',
	    value: function reloadFile() {
	      if (this.item.type === 'base64') {
	        this.getFileBase64Reloaded();
	      } else if (this.item.type === 'strBase64') {
	        // TODO solo se asume archivos PDFs
	        this.documento = {
	          base64: this.item.urlPdf.indexOf('base64') > 0 ? this.item.urlPdf : 'data:application/pdf;base64,' + this.item.urlPdf,
	          tipo: 'application/pdf'
	        };
	      } else {
	        this.getFile();
	      }
	    }
	  }, {
	    key: 'getFileBase64Reloaded',
	    value: function getFileBase64Reloaded() {
	      var _this2 = this;
	
	      this.DataService.get(this.item.urlPdf + "&reload=1", {}).then(function (response) {
	        if (response) {
	          _this2.documento = {
	            base64: 'data:' + response.datos.tipo + ';base64,' + response.datos.base64,
	            tipo: response.datos.tipo
	          };
	        }
	      });
	    }
	  }, {
	    key: 'getFileBase64',
	    value: function getFileBase64() {
	      var _this3 = this;
	
	      this.DataService.get(this.item.urlPdf, {}).then(function (response) {
	        if (response) {
	          _this3.documento = {
	            base64: 'data:' + response.datos.tipo + ';base64,' + response.datos.base64,
	            tipo: response.datos.tipo
	          };
	        }
	      });
	    }
	  }, {
	    key: 'fix',
	    value: function fix() {
	      this.reloadFile();
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return PdfViewModalController;
	}();
	
	exports.default = PdfViewModalController;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * No se puede definir factories con las clases de EcmaScript 6, por lo cual se deben
	 * utilizar services para definir estos factories(factory), si se quieren factories
	 * se deben codificar de la manera tradicional con la estructura:
	 * function () { return {} };
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _filter = __webpack_require__(236);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _data = __webpack_require__(231);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _flujos = __webpack_require__(238);
	
	var _flujos2 = _interopRequireDefault(_flujos);
	
	var _storage = __webpack_require__(249);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _util = __webpack_require__(252);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _numeroaLetras = __webpack_require__(250);
	
	var _numeroaLetras2 = _interopRequireDefault(_numeroaLetras);
	
	var _urm2lat = __webpack_require__(251);
	
	var _urm2lat2 = _interopRequireDefault(_urm2lat);
	
	var _array = __webpack_require__(228);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _datetime = __webpack_require__(234);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _message = __webpack_require__(241);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _modal = __webpack_require__(245);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _formly = __webpack_require__(240);
	
	var _formly2 = _interopRequireDefault(_formly);
	
	var _dataTable = __webpack_require__(229);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _downloadFile = __webpack_require__(235);
	
	var _downloadFile2 = _interopRequireDefault(_downloadFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Core = angular.module('app.services', [_filter2.default, _data2.default, _message2.default, _modal2.default, _flujos2.default]).service('numToWord', _numeroaLetras2.default).service('urm2lat', _urm2lat2.default).service('Util', _util2.default).service('Storage', _storage2.default).service('ArrayUtil', _array2.default).service('Datetime', _datetime2.default).service('Formly', _formly2.default).service('DataTable', _dataTable2.default).directive('downloadFile', function () {
	    return new _downloadFile2.default();
	}).name;
	
	exports.default = Core;

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StorageService = function () {
	    StorageService.$inject = ["$window", "appName"];
	    function StorageService($window, appName) {
	        'ngInject';
	
	        _classCallCheck(this, StorageService);
	
	        this.appName = appName || 'app';
	        this.$local = $window.localStorage;
	        this.$session = $window.sessionStorage;
	        this.$JSON = $window.JSON;
	    }
	
	    _createClass(StorageService, [{
	        key: 'setUser',
	        value: function setUser(user) {
	            this.set('user', user);
	        }
	    }, {
	        key: 'getUser',
	        value: function getUser() {
	            return this.get('user');
	        }
	    }, {
	        key: 'existUser',
	        value: function existUser() {
	            return this.exist('user');
	        }
	    }, {
	        key: 'removeUser',
	        value: function removeUser() {
	            this.remove('user');
	            this.removeSession('user');
	        }
	
	        // LocalStorage
	
	    }, {
	        key: 'set',
	        value: function set(key, value) {
	            this.$local.setItem(this.appName + '_' + key, this.$JSON.stringify(value));
	        }
	    }, {
	        key: 'get',
	        value: function get(key) {
	            var data = this.$local.getItem(this.appName + '_' + key);
	            try {
	                return this.$JSON.parse(data);
	            } catch (Exception) {
	                return data;
	            }
	        }
	    }, {
	        key: 'remove',
	        value: function remove(key) {
	            this.$local.removeItem(this.appName + '_' + key);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy(key) {
	            this.remove(key);
	        }
	    }, {
	        key: 'exist',
	        value: function exist(key) {
	            var value = this.$local.getItem(this.appName + '_' + key);
	            return typeof value != 'undefined' && value != 'undefined' && value != null && value != 'null' && value != '[]';
	        }
	
	        // SessionStorage
	
	    }, {
	        key: 'setSession',
	        value: function setSession(key, value) {
	            this.$session.setItem(this.appName + '_' + key, this.$JSON.stringify(value));
	        }
	    }, {
	        key: 'getSession',
	        value: function getSession(key) {
	            return this.$JSON.parse(this.$session.getItem(this.appName + '_' + key));
	        }
	    }, {
	        key: 'removeSession',
	        value: function removeSession(key) {
	            this.$session.removeItem(this.appName + '_' + key);
	        }
	    }, {
	        key: 'existSession',
	        value: function existSession(key) {
	            var value = this.$session.getItem(this.appName + '_' + key);
	            return typeof value != 'undefined' && value != 'undefined' && value !== null && value != 'null' && value != '[]';
	        }
	
	        // Flash Data
	
	    }, {
	        key: 'getFlash',
	        value: function getFlash(key) {
	            if (this.exist(key)) {
	                var value = this.get(key);
	                this.remove(key);
	                return value;
	            }
	            return false;
	        }
	    }, {
	        key: 'flash',
	        value: function flash(key) {
	            this.getFlash(key);
	        }
	    }]);
	
	    return StorageService;
	}();
	
	exports.default = StorageService;

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	// NumeroALetras
	// The MIT License (MIT)
	//
	// Copyright (c) 2015 Luis Alfredo Chee
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in all
	// copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	// SOFTWARE.
	//
	// @author Rodolfo Carmona
	// @contributor Jean (jpbadoino@gmail.com)
	/*************************************************************/
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NumeroALetras = function () {
	  function NumeroALetras() {
	    _classCallCheck(this, NumeroALetras);
	  }
	
	  _createClass(NumeroALetras, [{
	    key: 'Unidades',
	    value: function Unidades(num) {
	
	      switch (num) {
	        case 1:
	          return 'UN';
	        case 2:
	          return 'DOS';
	        case 3:
	          return 'TRES';
	        case 4:
	          return 'CUATRO';
	        case 5:
	          return 'CINCO';
	        case 6:
	          return 'SEIS';
	        case 7:
	          return 'SIETE';
	        case 8:
	          return 'OCHO';
	        case 9:
	          return 'NUEVE';
	      }
	
	      return '';
	    } //Unidades()
	
	  }, {
	    key: 'Decenas',
	    value: function Decenas(num) {
	      var decena, unidad;
	      decena = Math.floor(num / 10);
	      unidad = num - decena * 10;
	
	      switch (decena) {
	        case 1:
	          switch (unidad) {
	            case 0:
	              return 'DIEZ';
	            case 1:
	              return 'ONCE';
	            case 2:
	              return 'DOCE';
	            case 3:
	              return 'TRECE';
	            case 4:
	              return 'CATORCE';
	            case 5:
	              return 'QUINCE';
	            default:
	              return 'DIECI' + this.Unidades(unidad);
	          }
	        case 2:
	          switch (unidad) {
	            case 0:
	              return 'VEINTE';
	            default:
	              return 'VEINTI' + this.Unidades(unidad);
	          }
	        case 3:
	          return this.DecenasY('TREINTA', unidad);
	        case 4:
	          return this.DecenasY('CUARENTA', unidad);
	        case 5:
	          return this.DecenasY('CINCUENTA', unidad);
	        case 6:
	          return this.DecenasY('SESENTA', unidad);
	        case 7:
	          return this.DecenasY('SETENTA', unidad);
	        case 8:
	          return this.DecenasY('OCHENTA', unidad);
	        case 9:
	          return this.DecenasY('NOVENTA', unidad);
	        case 0:
	          return this.Unidades(unidad);
	      }
	    } //Unidades()
	
	  }, {
	    key: 'DecenasY',
	    value: function DecenasY(strSin, numUnidades) {
	      if (numUnidades > 0) return strSin + ' Y ' + this.Unidades(numUnidades);
	
	      return strSin;
	    } //DecenasY()
	
	  }, {
	    key: 'Centenas',
	    value: function Centenas(num) {
	      var centenas, decenas;
	      centenas = Math.floor(num / 100);
	      decenas = num - centenas * 100;
	
	      switch (centenas) {
	        case 1:
	          if (decenas > 0) return 'CIENTO ' + this.Decenas(decenas);
	          return 'CIEN';
	        case 2:
	          return 'DOSCIENTOS ' + this.Decenas(decenas);
	        case 3:
	          return 'TRESCIENTOS ' + this.Decenas(decenas);
	        case 4:
	          return 'CUATROCIENTOS ' + this.Decenas(decenas);
	        case 5:
	          return 'QUINIENTOS ' + this.Decenas(decenas);
	        case 6:
	          return 'SEISCIENTOS ' + this.Decenas(decenas);
	        case 7:
	          return 'SETECIENTOS ' + this.Decenas(decenas);
	        case 8:
	          return 'OCHOCIENTOS ' + this.Decenas(decenas);
	        case 9:
	          return 'NOVECIENTOS ' + this.Decenas(decenas);
	      }
	
	      return this.Decenas(decenas);
	    } //Centenas()
	
	  }, {
	    key: 'Seccion',
	    value: function Seccion(num, divisor, strSingular, strPlural) {
	      var cientos, resto, letras;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      letras = '';
	
	      if (cientos > 0) if (cientos > 1) letras = this.Centenas(cientos) + ' ' + strPlural;else letras = strSingular;
	
	      if (resto > 0) letras += '';
	
	      return letras;
	    } //Seccion()
	
	  }, {
	    key: 'Miles',
	    value: function Miles(num) {
	      var divisor, cientos, resto, strMiles, strCentenas;
	      divisor = 1000;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      strMiles = this.Seccion(num, divisor, 'UN MIL', 'MIL');
	      strCentenas = this.Centenas(resto);
	
	      if (strMiles == '') return strCentenas;
	
	      return strMiles + ' ' + strCentenas;
	    } //Miles()
	
	  }, {
	    key: 'Millones',
	    value: function Millones(num) {
	      var divisor, cientos, resto, strMillones, strMiles;
	      divisor = 1000000;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      strMillones = this.Seccion(num, divisor, 'UN MILLON', 'MILLONES');
	      strMiles = this.Miles(resto);
	
	      if (strMillones == '') return strMiles;
	
	      return strMillones + ' ' + strMiles;
	    } //Millones()
	
	  }, {
	    key: 'Billones',
	    value: function Billones(num) {
	      var divisor, cientos, resto, strBillones, strMillones;
	      divisor = 1000000000;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      strBillones = this.Seccion(num, divisor, 'UN BILLON', 'BILLONES');
	      strMillones = this.Millones(resto);
	
	      if (strBillones == '') return strMillones;
	
	      return strBillones + ' ' + strMillones;
	    } //Millones()
	
	  }, {
	    key: 'transformar',
	    value: function transformar(num) {
	      var data = {
	        numero: num,
	        enteros: Math.floor(num),
	        centavos: Math.round(num * 100) - Math.floor(num) * 100,
	        letrasCentavos: '',
	        letrasMonedaPlural: 'Bs.', //'PESOS', 'Dólares', 'Bolívares', 'etcs'
	        letrasMonedaSingular: 'Bs.', //'PESO', 'Dólar', 'Bolivar', 'etc'
	        letrasMonedaCentavoPlural: 'Ctvs.',
	        letrasMonedaCentavoSingular: 'ctv.'
	      };
	
	      // if (data.centavos > 0) {
	      //   data.letrasCentavos = 'CON ' + (function (){
	      //     if (data.centavos == 1)
	      //       return this.Billones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular;
	      //     else
	      //       return this.Billones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural;
	      //   })();
	      // }
	
	      if (data.enteros == 0) return 'CERO CON ' + data.centavos + '/100 ' + data.letrasMonedaPlural;
	      if (data.enteros == 1) return this.Billones(data.enteros) + ' CON ' + data.centavos + '/100 ' + data.letrasMonedaSingular;else return this.Billones(data.enteros) + ' CON ' + data.centavos + '/100 ' + data.letrasMonedaPlural;
	    } //NumeroALetras()
	
	  }]);
	
	  return NumeroALetras;
	}();
	
	exports.default = NumeroALetras;

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	'use strict';
	// ***************************************************************************
	// Note: This is a JavaScript-powered form. 
	//
	// Programmers: The JavaScript source code in this document may be copied and 
	// reused without restriction.
	//
	// If you have a Java 1.1-compliant browser, and especially if you need to
	// use an ellipsoid model other than WGS84, you may want to try the Coordinate 
	// and Datum Transformations tool.
	// 
	// Download from http://home.hiwaay.net/~taylorc/toolbox/
	// *
	// ****************************************************************************/
	//
	//   This program is free software; you can redistribute it and/or modify
	//   it under the terms of the GNU General Public License as published by
	//   the Free Software Foundation; either version 2 of the License, or
	//   (at your option) any later version.
	// 
	//   This program is distributed in the hope that it will be useful,
	//   but WITHOUT ANY WARRANTY; without even the implied warranty of
	//   MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	//   GNU General Public License for more details.
	// 
	//
	//*****************************************************************************
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var urm2lat = function () {
	    function urm2lat() {
	        _classCallCheck(this, urm2lat);
	
	        this.pi = 3.14159265358979;
	        /* Ellipsoid model constants (actual values here are for WGS84) */
	        this.sm_a = 6378137.0;
	        this.sm_b = 6356752.314;
	        this.sm_EccSquared = 6.69437999013e-03;
	        this.UTMScaleFactor = 0.9996;
	    }
	    /*
	    * DegToRad
	    *
	    * Converts degrees to radians.
	    *
	    */
	
	
	    _createClass(urm2lat, [{
	        key: 'DegToRad',
	        value: function DegToRad(deg) {
	            return deg / 180.0 * this.pi;
	        }
	
	        /*
	        * RadToDeg
	        *
	        * Converts radians to degrees.
	        *
	        */
	
	    }, {
	        key: 'RadToDeg',
	        value: function RadToDeg(rad) {
	            return rad / this.pi * 180.0;
	        }
	
	        /*
	        * ArcLengthOfMeridian
	        *
	        * Computes the ellipsoidal distance from the equator to a point at a
	        * given latitude.
	        *
	        * Reference: Hoffmann-Wellenhof, B., Lichtenegger, H., and Collins, J.,
	        * GPS: Theory and Practice, 3rd ed.  New York: Springer-Verlag Wien, 1994.
	        *
	        * Inputs:
	        *     phi - Latitude of the point, in radians.
	        *
	        * Globals:
	        *     this.sm_a - Ellipsoid model major axis.
	        *     this.sm_b - Ellipsoid model minor axis.
	        *
	        * Returns:
	        *     The ellipsoidal distance of the point from the equator, in meters.
	        *
	        */
	
	    }, {
	        key: 'ArcLengthOfMeridian',
	        value: function ArcLengthOfMeridian(phi) {
	            var alpha, beta, gamma, delta, epsilon, n;
	            var result;
	            /* Precalculate n */
	            n = (this.sm_a - this.sm_b) / (this.sm_a + this.sm_b);
	            /* Precalculate alpha */
	            alpha = (this.sm_a + this.sm_b) / 2.0 * (1.0 + Math.pow(n, 2.0) / 4.0 + Math.pow(n, 4.0) / 64.0);
	            /* Precalculate beta */
	            beta = -3.0 * n / 2.0 + 9.0 * Math.pow(n, 3.0) / 16.0 + -3.0 * Math.pow(n, 5.0) / 32.0;
	            /* Precalculate gamma */
	            gamma = 15.0 * Math.pow(n, 2.0) / 16.0 + -15.0 * Math.pow(n, 4.0) / 32.0;
	            /* Precalculate delta */
	            delta = -35.0 * Math.pow(n, 3.0) / 48.0 + 105.0 * Math.pow(n, 5.0) / 256.0;
	            /* Precalculate epsilon */
	            epsilon = 315.0 * Math.pow(n, 4.0) / 512.0;
	            /* Now calculate the sum of the series and return */
	            result = alpha * (phi + beta * Math.sin(2.0 * phi) + gamma * Math.sin(4.0 * phi) + delta * Math.sin(6.0 * phi) + epsilon * Math.sin(8.0 * phi));
	
	            return result;
	        }
	
	        /*
	        * UTMCentralMeridian
	        *
	        * Determines the central meridian for the given UTM zone.
	        *
	        * Inputs:
	        *     zone - An integer value designating the UTM zone, range [1,60].
	        *
	        * Returns:
	        *   The central meridian for the given UTM zone, in radians, or zero
	        *   if the UTM zone parameter is outside the range [1,60].
	        *   Range of the central meridian is the radian equivalent of [-177,+177].
	        *
	        */
	
	    }, {
	        key: 'UTMCentralMeridian',
	        value: function UTMCentralMeridian(zone) {
	            var cmeridian;
	
	            cmeridian = this.DegToRad(-183.0 + zone * 6.0);
	
	            return cmeridian;
	        }
	
	        /*
	        * FootpointLatitude
	        *
	        * Computes the footpoint latitude for use in converting transverse
	        * Mercator coordinates to ellipsoidal coordinates.
	        *
	        * Reference: Hoffmann-Wellenhof, B., Lichtenegger, H., and Collins, J.,
	        *   GPS: Theory and Practice, 3rd ed.  New York: Springer-Verlag Wien, 1994.
	        *
	        * Inputs:
	        *   y - The UTM northing coordinate, in meters.
	        *
	        * Returns:
	        *   The footpoint latitude, in radians.
	        *
	        */
	
	    }, {
	        key: 'FootpointLatitude',
	        value: function FootpointLatitude(y) {
	            var y_, alpha_, beta_, gamma_, delta_, epsilon_, n;
	            var result;
	
	            /* Precalculate n (Eq. 10.18) */
	            n = (this.sm_a - this.sm_b) / (this.sm_a + this.sm_b);
	            /* Precalculate alpha_ (Eq. 10.22) */
	            /* (Same as alpha in Eq. 10.17) */
	            alpha_ = (this.sm_a + this.sm_b) / 2.0 * (1 + Math.pow(n, 2.0) / 4 + Math.pow(n, 4.0) / 64);
	            /* Precalculate y_ (Eq. 10.23) */
	            y_ = y / alpha_;
	            /* Precalculate beta_ (Eq. 10.22) */
	            beta_ = 3.0 * n / 2.0 + -27.0 * Math.pow(n, 3.0) / 32.0 + 269.0 * Math.pow(n, 5.0) / 512.0;
	            /* Precalculate gamma_ (Eq. 10.22) */
	            gamma_ = 21.0 * Math.pow(n, 2.0) / 16.0 + -55.0 * Math.pow(n, 4.0) / 32.0;
	            /* Precalculate delta_ (Eq. 10.22) */
	            delta_ = 151.0 * Math.pow(n, 3.0) / 96.0 + -417.0 * Math.pow(n, 5.0) / 128.0;
	            /* Precalculate epsilon_ (Eq. 10.22) */
	            epsilon_ = 1097.0 * Math.pow(n, 4.0) / 512.0;
	            /* Now calculate the sum of the series (Eq. 10.21) */
	            result = y_ + beta_ * Math.sin(2.0 * y_) + gamma_ * Math.sin(4.0 * y_) + delta_ * Math.sin(6.0 * y_) + epsilon_ * Math.sin(8.0 * y_);
	
	            return result;
	        }
	
	        /*
	        * MapLatLonToXY
	        *
	        * Converts a latitude/longitude pair to x and y coordinates in the
	        * Transverse Mercator projection.  Note that Transverse Mercator is not
	        * the same as UTM; a scale factor is required to convert between them.
	        *
	        * Reference: Hoffmann-Wellenhof, B., Lichtenegger, H., and Collins, J.,
	        * GPS: Theory and Practice, 3rd ed.  New York: Springer-Verlag Wien, 1994.
	        *
	        * Inputs:
	        *    phi - Latitude of the point, in radians.
	        *    lambda - Longitude of the point, in radians.
	        *    lambda0 - Longitude of the central meridian to be used, in radians.
	        *
	        * Outputs:
	        *    xy - A 2-element array containing the x and y coordinates
	        *         of the computed point.
	        *
	        * Returns:
	        *    The does not return a value.
	        *
	        */
	
	    }, {
	        key: 'MapLatLonToXY',
	        value: function MapLatLonToXY(phi, lambda, lambda0, xy) {
	            var N, nu2, ep2, t, t2, l;
	            var l3coef, l4coef, l5coef, l6coef, l7coef, l8coef;
	            //var tmp;
	            /* Precalculate ep2 */
	            ep2 = (Math.pow(this.sm_a, 2.0) - Math.pow(this.sm_b, 2.0)) / Math.pow(this.sm_b, 2.0);
	            /* Precalculate nu2 */
	            nu2 = ep2 * Math.pow(Math.cos(phi), 2.0);
	            /* Precalculate N */
	            N = Math.pow(this.sm_a, 2.0) / (this.sm_b * Math.sqrt(1 + nu2));
	            /* Precalculate t */
	            t = Math.tan(phi);
	            t2 = t * t;
	            //tmp = (t2 * t2 * t2) - Math.pow (t, 6.0);
	            /* Precalculate l */
	            l = lambda - lambda0;
	            /* Precalculate coefficients for l**n in the equations below
	               so a normal human being can read the expressions for easting
	               and northing
	               -- l**1 and l**2 have coefficients of 1.0 */
	            l3coef = 1.0 - t2 + nu2;
	            l4coef = 5.0 - t2 + 9 * nu2 + 4.0 * (nu2 * nu2);
	            l5coef = 5.0 - 18.0 * t2 + t2 * t2 + 14.0 * nu2 - 58.0 * t2 * nu2;
	            l6coef = 61.0 - 58.0 * t2 + t2 * t2 + 270.0 * nu2 - 330.0 * t2 * nu2;
	            l7coef = 61.0 - 479.0 * t2 + 179.0 * (t2 * t2) - t2 * t2 * t2;
	            l8coef = 1385.0 - 3111.0 * t2 + 543.0 * (t2 * t2) - t2 * t2 * t2;
	
	            /* Calculate easting (x) */
	            xy[0] = N * Math.cos(phi) * l + N / 6.0 * Math.pow(Math.cos(phi), 3.0) * l3coef * Math.pow(l, 3.0) + N / 120.0 * Math.pow(Math.cos(phi), 5.0) * l5coef * Math.pow(l, 5.0) + N / 5040.0 * Math.pow(Math.cos(phi), 7.0) * l7coef * Math.pow(l, 7.0);
	
	            /* Calculate northing (y) */
	            xy[1] = this.ArcLengthOfMeridian(phi) + t / 2.0 * N * Math.pow(Math.cos(phi), 2.0) * Math.pow(l, 2.0) + t / 24.0 * N * Math.pow(Math.cos(phi), 4.0) * l4coef * Math.pow(l, 4.0) + t / 720.0 * N * Math.pow(Math.cos(phi), 6.0) * l6coef * Math.pow(l, 6.0) + t / 40320.0 * N * Math.pow(Math.cos(phi), 8.0) * l8coef * Math.pow(l, 8.0);
	
	            return;
	        }
	
	        /*
	        * MapXYToLatLon
	        *
	        * Converts x and y coordinates in the Transverse Mercator projection to
	        * a latitude/longitude pair.  Note that Transverse Mercator is not
	        * the same as UTM; a scale factor is required to convert between them.
	        *
	        * Reference: Hoffmann-Wellenhof, B., Lichtenegger, H., and Collins, J.,
	        *   GPS: Theory and Practice, 3rd ed.  New York: Springer-Verlag Wien, 1994.
	        *
	        * Inputs:
	        *   x - The easting of the point, in meters.
	        *   y - The northing of the point, in meters.
	        *   lambda0 - Longitude of the central meridian to be used, in radians.
	        *
	        * Outputs:
	        *   philambda - A 2-element containing the latitude and longitude
	        *               in radians.
	        *
	        * Returns:
	        *   The does not return a value.
	        *
	        * Remarks:
	        *   The local variables Nf, nuf2, tf, and tf2 serve the same purpose as
	        *   N, nu2, t, and t2 in this.MapLatLonToXY, but they are computed with respect
	        *   to the footpoint latitude phif.
	        *
	        *   x1frac, x2frac, x2poly, x3poly, etc. are to enhance readability and
	        *   to optimize computations.
	        *
	        */
	
	    }, {
	        key: 'MapXYToLatLon',
	        value: function MapXYToLatLon(x, y, lambda0, philambda) {
	            var phif, Nf, Nfpow, nuf2, ep2, tf, tf2, tf4, cf;
	            var x1frac, x2frac, x3frac, x4frac, x5frac, x6frac, x7frac, x8frac;
	            var x2poly, x3poly, x4poly, x5poly, x6poly, x7poly, x8poly;
	            /* Get the value of phif, the footpoint latitude. */
	            phif = this.FootpointLatitude(y);
	            /* Precalculate ep2 */
	            ep2 = (Math.pow(this.sm_a, 2.0) - Math.pow(this.sm_b, 2.0)) / Math.pow(this.sm_b, 2.0);
	            /* Precalculate cos (phif) */
	            cf = Math.cos(phif);
	            /* Precalculate nuf2 */
	            nuf2 = ep2 * Math.pow(cf, 2.0);
	            /* Precalculate Nf and initialize Nfpow */
	            Nf = Math.pow(this.sm_a, 2.0) / (this.sm_b * Math.sqrt(1 + nuf2));
	            Nfpow = Nf;
	            /* Precalculate tf */
	            tf = Math.tan(phif);
	            tf2 = tf * tf;
	            tf4 = tf2 * tf2;
	
	            /* Precalculate fractional coefficients for x**n in the equations
	               below to simplify the expressions for latitude and longitude. */
	            x1frac = 1.0 / (Nfpow * cf);
	            Nfpow *= Nf; /* now equals Nf**2) */
	            x2frac = tf / (2.0 * Nfpow);
	            Nfpow *= Nf; /* now equals Nf**3) */
	            x3frac = 1.0 / (6.0 * Nfpow * cf);
	            Nfpow *= Nf; /* now equals Nf**4) */
	            x4frac = tf / (24.0 * Nfpow);
	            Nfpow *= Nf; /* now equals Nf**5) */
	            x5frac = 1.0 / (120.0 * Nfpow * cf);
	            Nfpow *= Nf; /* now equals Nf**6) */
	            x6frac = tf / (720.0 * Nfpow);
	            Nfpow *= Nf; /* now equals Nf**7) */
	            x7frac = 1.0 / (5040.0 * Nfpow * cf);
	            Nfpow *= Nf; /* now equals Nf**8) */
	            x8frac = tf / (40320.0 * Nfpow);
	            /* Precalculate polynomial coefficients for x**n.
	               -- x**1 does not have a polynomial coefficient. */
	            x2poly = -1.0 - nuf2;
	            x3poly = -1.0 - 2 * tf2 - nuf2;
	            x4poly = 5.0 + 3.0 * tf2 + 6.0 * nuf2 - 6.0 * tf2 * nuf2 - 3.0 * (nuf2 * nuf2) - 9.0 * tf2 * (nuf2 * nuf2);
	            x5poly = 5.0 + 28.0 * tf2 + 24.0 * tf4 + 6.0 * nuf2 + 8.0 * tf2 * nuf2;
	            x6poly = -61.0 - 90.0 * tf2 - 45.0 * tf4 - 107.0 * nuf2 + 162.0 * tf2 * nuf2;
	            x7poly = -61.0 - 662.0 * tf2 - 1320.0 * tf4 - 720.0 * (tf4 * tf2);
	            x8poly = 1385.0 + 3633.0 * tf2 + 4095.0 * tf4 + 1575 * (tf4 * tf2);
	            /* Calculate latitude */
	            philambda[0] = phif + x2frac * x2poly * (x * x) + x4frac * x4poly * Math.pow(x, 4.0) + x6frac * x6poly * Math.pow(x, 6.0) + x8frac * x8poly * Math.pow(x, 8.0);
	            /* Calculate longitude */
	            philambda[1] = lambda0 + x1frac * x + x3frac * x3poly * Math.pow(x, 3.0) + x5frac * x5poly * Math.pow(x, 5.0) + x7frac * x7poly * Math.pow(x, 7.0);
	            return;
	        }
	
	        /*
	        * LatLonToUTMXY
	        *
	        * Converts a latitude/longitude pair to x and y coordinates in the
	        * Universal Transverse Mercator projection.
	        *
	        * Inputs:
	        *   lat - Latitude of the point, in radians.
	        *   lon - Longitude of the point, in radians.
	        *   zone - UTM zone to be used for calculating values for x and y.
	        *          If zone is less than 1 or greater than 60, the routine
	        *          will determine the appropriate zone from the value of lon.
	        *
	        * Outputs:
	        *   xy - A 2-element array where the UTM x and y values will be stored.
	        *
	        * Returns:
	        *   The UTM zone used for calculating the values of x and y.
	        *
	        */
	
	    }, {
	        key: 'LatLonToUTMXY',
	        value: function LatLonToUTMXY(lat, lon, zone, xy) {
	            this.MapLatLonToXY(lat, lon, this.UTMCentralMeridian(zone), xy);
	
	            /* Adjust easting and northing for UTM system. */
	            xy[0] = xy[0] * this.UTMScaleFactor + 500000.0;
	            xy[1] = xy[1] * this.UTMScaleFactor;
	            if (xy[1] < 0.0) xy[1] = xy[1] + 10000000.0;
	            return zone;
	        }
	
	        /*
	        * UTMXYToLatLon
	        *
	        * Converts x and y coordinates in the Universal Transverse Mercator
	        * projection to a latitude/longitude pair.
	        *
	        * Inputs:
	        *	x - The easting of the point, in meters.
	        *	y - The northing of the point, in meters.
	        *	zone - The UTM zone in which the point lies.
	        *	southhemi - True if the point is in the southern hemisphere;
	        *               false otherwise.
	        *
	        * Outputs:
	        *	latlon - A 2-element array containing the latitude and
	        *            longitude of the point, in radians.
	        *
	        * Returns:
	        *	The does not return a value.
	        *
	        */
	
	    }, {
	        key: 'UTMXYToLatLon',
	        value: function UTMXYToLatLon(x, y, zone, southhemi, latlon) {
	            this.pi = 3.14159265358979;
	            /* Ellipsoid model constants (actual values here are for WGS84) */
	            this.sm_a = 6378137.0;
	            this.sm_b = 6356752.314;
	            this.sm_EccSquared = 6.69437999013e-03;
	            this.UTMScaleFactor = 0.9996;
	            var cmeridian;
	            x -= 500000.0;
	            x /= this.UTMScaleFactor;
	            /* If in southern hemisphere, adjust y accordingly. */
	            if (southhemi) y -= 10000000.0;
	            y /= this.UTMScaleFactor;
	            cmeridian = this.UTMCentralMeridian(zone);
	            this.MapXYToLatLon(x, y, cmeridian, latlon);
	            latlon[0] = this.RadToDeg(latlon[0]);
	            latlon[1] = this.RadToDeg(latlon[1]);
	            return;
	        }
	    }, {
	        key: 'DMS2Decimal',
	        value: function DMS2Decimal() {
	            var degrees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	            var minutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	            var seconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	            var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	            var directions = ['N', 'S', 'E', 'W'];
	            if (!directions.includes(direction.toUpperCase())) return 0;
	            if (!Number(minutes) || minutes < 0 || minutes > 59) return 0;
	            if (!Number(seconds) || seconds < 0 || seconds > 59) return 0;
	            if (!Number(degrees) || degrees < 0 || degrees > 180) return 0;
	
	            var decimal = degrees + minutes / 60 + seconds / 3600;
	            if (direction.toUpperCase() === 'S' || direction.toUpperCase() === 'W') decimal *= -1;
	            return decimal;
	        }
	    }, {
	        key: 'convDDToDMS',
	        value: function convDDToDMS(degree) {
	            var output = {};
	            output.deg = 0 | (degree < 0 ? degree = -degree : degree);
	            output.min = 0 | degree % 1 * 60;
	            output.sec = (0 | degree * 60 % 1 * 6000) / 100;
	            return output;
	        }
	    }]);
	
	    return urm2lat;
	}();
	
	exports.default = urm2lat;

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UtilService = function () {
	  UtilService.$inject = ["$injector", "$location", "$anchorScroll", "$log", "Message", "decimales", "Storage", "_", "Big", "Modal"];
	  function UtilService($injector, $location, $anchorScroll, $log, Message, decimales, Storage, _, Big, Modal) {
	    "ngInject";
	
	    _classCallCheck(this, UtilService);
	
	    this.$injector = $injector;
	    this.$location = $location;
	    this.$anchorScroll = $anchorScroll;
	    this.$log = $log;
	    this.Message = Message;
	    this.decimales = decimales;
	    this.Storage = Storage;
	    this._ = _;
	    this.Big = Big;
	    this.Modal = Modal;
	    this.camposInvalidos = {};
	  }
	
	  _createClass(UtilService, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.tmpl_print = '\n    <!DOCTYPE html>\n    <html lang="en">\n    <head>\n    <meta charset="UTF-8"/>\n    <title>Document</title>\n    <style>{css}</style>\n    </head>\n    <body>{body}</body>\n    </html>';
	    }
	  }, {
	    key: 'toType',
	    value: function toType(obj) {
	      return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
	    }
	  }, {
	    key: 'isJson',
	    value: function isJson(text) {
	      return (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))
	      );
	    }
	  }, {
	    key: 'stripHTML',
	    value: function stripHTML(texto) {
	      return texto.replace(/(<([^>]+)>)/ig, "");
	    }
	  }, {
	    key: 'nano',
	    value: function nano(template, data) {
	      return template.replace(/\{([\w\.]*)\}/g, function (str, key) {
	        var keys = key.split("."),
	            v = data[keys.shift()];
	        for (var i = 0, l = keys.length; i < l; i++) {
	          v = v[keys[i]];
	        }return typeof v !== "undefined" && v !== null ? v : "";
	      });
	    }
	  }, {
	    key: 'print',
	    value: function print(html, css) {
	      var _this = this;
	
	      if (typeof css == 'string') {
	        angular.element.get(css, function (response) {
	          var popup = window.open('', 'print');
	          popup.document.write(_this.nano(_this.tmpl_print, { body: html, css: response }));
	          popup.document.close();
	          popup.focus();
	          popup.print();
	          popup.close();
	        });
	      } else {
	        var popup = window.open('', 'print');
	        popup.document.write(this.nano(this.tmpl_print, { body: html, css: css }));
	        popup.document.close();
	        popup.focus();
	        popup.print();
	        popup.close();
	      }
	
	      return true;
	    }
	
	    /**
	    * Función para crear una pausa para ejecutar una instrucción:
	    *  Ejemplo:
	    *
	    *  let funcionConDelay = this.Util.debounce(function() {
	    *      // ... lo que se quiere ejecutar con el retraso
	    *  }, 1000);
	    *
	    *  funcionConDelay(); // Ejecutando el retraso
	    */
	
	  }, {
	    key: 'debounce',
	    value: function debounce(func, wait, immediate) {
	      var timeout;
	      return function () {
	        var context = this,
	            args = arguments;
	        var later = function later() {
	          timeout = null;
	          if (!immediate) func.apply(context, args);
	        };
	        var callNow = immediate && !timeout;
	        clearTimeout(timeout);
	        timeout = setTimeout(later, wait);
	        if (callNow) func.apply(context, args);
	      };
	    }
	  }, {
	    key: 'popup',
	    value: function popup(url) {
	      window.open(url, 'print');
	    }
	  }, {
	    key: 'fullscreen',
	    value: function fullscreen() {
	      if (!document.fullscreenElement && // alternative standard method
	      !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
	        // current working methods
	        if (document.documentElement.requestFullscreen) {
	          document.documentElement.requestFullscreen();
	        } else if (document.documentElement.msRequestFullscreen) {
	          document.documentElement.msRequestFullscreen();
	        } else if (document.documentElement.mozRequestFullScreen) {
	          document.documentElement.mozRequestFullScreen();
	        } else if (document.documentElement.webkitRequestFullscreen) {
	          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
	        }
	      } else {
	        if (document.exitFullscreen) {
	          document.exitFullscreen();
	        } else if (document.msExitFullscreen) {
	          document.msExitFullscreen();
	        } else if (document.mozCancelFullScreen) {
	          document.mozCancelFullScreen();
	        } else if (document.webkitExitFullscreen) {
	          document.webkitExitFullscreen();
	        }
	      }
	    }
	  }, {
	    key: 'size',
	    value: function size(obj) {
	      return Object.keys(obj).length;
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize(json) {
	      var string = [];
	      for (var i in json) {
	        string.push(i + '=' + json[i]);
	      }
	      return string.join('&');
	    }
	  }, {
	    key: 'getMenuOption',
	    value: function getMenuOption(menu, url) {
	      for (var i in menu) {
	        if (typeof menu[i].submenu != 'undefined') {
	          var pages = menu[i].submenu;
	          for (var j in pages) {
	            if (pages[j].url == url) {
	              return [menu[i].label, pages[j].label];
	            }
	          }
	        }
	      }
	      for (var k in menu) {
	        if (menu[k].url == url) {
	          return [menu[k].label, false];
	        }
	      }
	      return [false, false];
	    }
	  }, {
	    key: 'getKeys',
	    value: function getKeys(data) {
	      var types = {};
	
	      data.map(function (el) {
	        types[el.key] = el;
	      });
	
	      return types;
	    }
	
	    /**
	    * Public: funcion que retrasa la ejecucion de una funcion, y que al volverse a activar reinicia el timeout
	    * @param {Object} obj  objeto que guardara la referencia del intervalo
	    * @param {Integer} ms  tiempo en miliesgundos
	    * @param {Function} func funcion callback
	    * *
	    * Ejemplo
	    this.timer = {};
	    this.Util.funcDelay(this.timer, 1000, ()=> {
	    this.personalSave(form, per);
	    })
	    */
	
	  }, {
	    key: 'funcDelay',
	    value: function funcDelay(obj, ms, func) {
	      if (obj.timer_delay) clearTimeout(obj.timer_delay);
	
	      obj.timer_delay = setTimeout(function () {
	        obj.timer_delay = null;
	        func();
	      }, ms);
	    }
	  }, {
	    key: 'setTouchedForm',
	    value: function setTouchedForm(form, val, ignored, focusear) {
	      var focus, _funcRecursive;
	      // this.$log.log(form);
	      // this.$log.log(val, ignored);
	      if (ignored) {
	        focus = ignored.split(', ');
	        ignored = {};
	        focus.forEach(function (it) {
	          ignored[it] = true;
	        });
	      } else {
	        ignored = {};
	      }
	      if (angular.isUndefined(val)) val = true;
	      focus = val && angular.isDefined(focusear);
	      // var visits = {};
	      // this.$log.log(visits);
	      _funcRecursive = function funcRecursive(form, val, ignored) {
	        form.$$controls.forEach(function (field) {
	          // if (!visits[field.$name])
	          // visits[field.$name] = 0;
	          if (field.$name != '' && !ignored[field.$name]) {
	            // visits[field.$name]++;
	            if (field.$$controls) {
	              _funcRecursive(field, val, ignored);
	            } else {
	              if (focus && field.$invalid) {
	                // this.$log.log(field);
	                var node = field.$$element[0];
	                var x = node.contentEditable;
	                node.contentEditable = true;
	                if (node.disabled) {
	                  node.disabled = false;
	                  node.focus();
	                  node.disabled = true;
	                } else {
	                  node.focus();
	                }
	                node.contentEditable = x;
	                // this.$log.log(x, node);
	                node = field.$$element.closest(focusear);
	                if (node) {
	                  // this.gotoAnchor(null, node);
	                  node.classList.add('blink-container');
	                  setTimeout(function () {
	                    node.classList.remove('blink-container');
	                  }, 5000);
	                }
	
	                // field.$$element.closest('div.form-group').focus();
	                focus = !focus;
	              }
	              if (val) {
	                field.$setTouched();
	              } else {
	                field.$setUntouched();
	              }
	            }
	          }
	        });
	      };
	      _funcRecursive(form, val, ignored);
	    }
	  }, {
	    key: 'isValidForm',
	    value: function isValidForm(form, ignored) {
	      var _this2 = this;
	
	      var resp, _funcRecursive2;
	      // this.$log.log(form);
	      // this.$log.log(val, ignored);
	      if (ignored) {
	        resp = ignored.split(', ');
	        ignored = {};
	        resp.forEach(function (it) {
	          ignored[it] = true;
	        });
	      } else {
	        ignored = {};
	      }
	      resp = true;
	      //var visits = {};
	      // this.$log.log(visits);
	      _funcRecursive2 = function funcRecursive(form, ignored) {
	        form.$$controls.forEach(function (field) {
	          // if (!visits[field.$name])
	          // visits[field.$name] = 0;
	          if (field.$name != '' && !ignored[field.$name]) {
	            // visits[field.$name]++;
	            if (field.$$controls) {
	              _funcRecursive2(field, ignored);
	            } else {
	              if (field.$invalid) {
	                resp = false;
	                //console.log(field.$name+" NO VALIDO");
	                var elemento = angular.element(document.querySelector('[name=' + field.$name + ']'));
	                var label = _this2.obtenerLabel(field.$name, elemento);
	                if (angular.isUndefined(_this2.camposInvalidos[field.$name])) {
	                  if (label) {
	                    _this2.camposInvalidos[label] = label;
	                  } else {
	                    _this2.camposInvalidos[field.$name] = field.$name;
	                  }
	                }
	              }
	            }
	          }
	        });
	      };
	      _funcRecursive2(form, ignored);
	      return resp;
	    }
	  }, {
	    key: 'obtenerLabel',
	    value: function obtenerLabel(nombreCampo, elemento) {
	      var elementoPadre = elemento.parent();
	      var i = 0;
	      while (i < 10) {
	        var elemPadre = elementoPadre.find('label');
	        if (elemPadre.length > 0) {
	          for (var j = 0; j < elemPadre.length; j++) {
	            if (elemPadre[j].htmlFor === nombreCampo) {
	              var etiqueta = elemPadre[j].innerText;
	              if (elementoPadre[j].hasOwnProperty('title') && elemPadre[j].title !== '') {
	                etiqueta = elemPadre[j].title;
	              }
	              return etiqueta;
	            }
	          }
	        }
	        elementoPadre = elementoPadre.parent();
	        i++;
	      }
	      return null;
	    }
	  }, {
	    key: 'id',
	    value: function id() {
	      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
	
	      var zero = '';
	      for (var i = 0, l = length; i < l; i++) {
	        zero += '0';
	      }
	      return (zero + (Math.random() * Math.pow(36, length) << 0).toString(36)).slice(-1 * length);
	    }
	  }, {
	    key: 'gotoAnchor',
	    value: function gotoAnchor(id) {
	      if (this.$location.hash() !== id) {
	        this.$location.hash(id);
	      } else {
	        this.$anchorScroll();
	      }
	      var el = document.querySelector('#' + id);
	      if (el) {
	        el.classList.add('blink-container');
	        setTimeout(function () {
	          el.classList.remove('blink-container');
	        }, 8000);
	      }
	    }
	  }, {
	    key: 'isEmpty',
	    value: function isEmpty(data) {
	      var hasOwnProperty = Object.prototype.hasOwnProperty;
	      if (data == null) return true;
	      if (data.length > 0) return false;
	      if (data.length === 0) return true;
	      if (typeof data === "number") return false;
	      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== "object") return true;
	      for (var key in data) {
	        if (hasOwnProperty.call(data, key)) return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'isIEoEdge',
	    value: function isIEoEdge() {
	      if (window.navigator.msSaveBlob) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	      var device = this.isAndroid() || this.isBlackBerry() || this.isiOS() || this.isOpera() || this.isWindows();
	      return !this.isEmpty(device) ? true : false;
	    }
	  }, {
	    key: 'isAndroid',
	    value: function isAndroid() {
	      return navigator.userAgent.match(/Android/i);
	    }
	  }, {
	    key: 'isBlackBerry',
	    value: function isBlackBerry() {
	      return navigator.userAgent.match(/BlackBerry/i);
	    }
	  }, {
	    key: 'isiOS',
	    value: function isiOS() {
	      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	    }
	  }, {
	    key: 'isOpera',
	    value: function isOpera() {
	      return navigator.userAgent.match(/Opera Mini/i);
	    }
	  }, {
	    key: 'isWindows',
	    value: function isWindows() {
	      return navigator.userAgent.match(/IEMobile/i);
	    }
	  }, {
	    key: 'getFormatoRadioOptions',
	    value: function getFormatoRadioOptions(datos) {
	      return datos.map(function (item) {
	        return {
	          text: item.nombre,
	          field: item.codigo
	        };
	      });
	    }
	  }, {
	    key: 'limpiarEspaciosDobles',
	    value: function limpiarEspaciosDobles(texto) {
	      return texto.replace(/\s+/gi, ' ');
	    }
	  }, {
	    key: 'findArray',
	    value: function findArray(array, item) {
	      for (var i = 0; i < array.length; i++) {
	        if (array[i] === item) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'isValidFormFieldsAlerta',
	    value: function isValidFormFieldsAlerta(form, mensaje) {
	      this.camposInvalidos = {};
	      if (!this.isValidForm(form)) {
	        this.setTouchedForm(form);
	        this.Message.warning(mensaje || "Verifique, corrija y/o llene los campos resaltados.");
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'isValidFormFields',
	    value: function isValidFormFields(form, mensaje) {
	      this.camposInvalidos = {};
	      if (!this.isValidForm(form)) {
	        this.setTouchedForm(form);
	        this.Message.warning(mensaje || "Verifique, corrija y/o llene los campos resaltados.");
	        if (Object.keys(this.camposInvalidos).length > 0) {
	          var texto = '<p>Verifique, corrija y/o llene los siguientes campos:</p>';
	          texto += '<ul>';
	          angular.forEach(this.camposInvalidos, function (error) {
	            texto += '<li>' + error + '</li>';
	          });
	          texto += '</ul>';
	          //this.Message.warning(mensaje || "Verifique, corrija y/o llene los campos resaltados.");
	          this.Modal.alert(texto, function () {
	            return false;
	          }, 'Información incompleta', null, 'md');
	        }
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'getNombreUnido',
	    value: function getNombreUnido(datos) {
	      var nombre = '';
	      nombre += datos.primer_apellido ? datos.primer_apellido + ' ' : '';
	      nombre += datos.segundo_apellido ? datos.segundo_apellido + ' ' : '';
	      nombre += datos.nombres;
	      return nombre;
	    }
	
	    // Redondear utilizando la libreria Big.js
	
	  }, {
	    key: 'redondear',
	    value: function redondear(numero, decimales) {
	      numero = parseFloat(numero);
	      if (isNaN(numero)) {
	        return;
	      }
	      decimales = parseInt(decimales || this.decimales || 2);
	      return parseFloat(this.Big(numero).toFixed(decimales));
	    }
	
	    // TODO redondeo Funcion utilizada para redondear. reemplazado por existir algunos casos
	
	  }, {
	    key: 'redondear2',
	    value: function redondear2(numero, decimales) {
	      if (typeof numero !== 'number') {
	        return;
	      }
	      decimales = decimales || this.decimales || 2;
	      var ES_NEGATIVO = numero < 0;
	      numero = ES_NEGATIVO ? numero * -1 : numero;
	      var FACTOR_CONVERSION = Math.pow(10, decimales);
	      numero = parseFloat((numero * FACTOR_CONVERSION).toFixed(11));
	      numero = Math.round(numero) / FACTOR_CONVERSION;
	      numero = ES_NEGATIVO ? numero * -1 : numero;
	      return numero;
	    }
	  }, {
	    key: '_operar',
	    value: function _operar(parametros) {
	      var conRedondeo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var decimales = arguments[2];
	      var opcion = arguments[3];
	
	      var resultado = opcion === 'add' || opcion === 'minus' ? 0 : 1;
	      for (var i = 0; i < parametros.length; i++) {
	        parametros[i] = typeof parametros[i] === 'number' ? parametros[i] : opcion === 'add' || opcion === 'minus' ? 0 : 1;
	        var valor = this.Big(parametros[i]);
	        resultado = valor[opcion](resultado);
	      }
	      resultado = parseFloat(resultado.valueOf());
	      return conRedondeo ? this.redondear(resultado, decimales) : resultado;
	    }
	  }, {
	    key: 'multiplicar',
	    value: function multiplicar(parametros, redondear, decimales) {
	      return this._operar(parametros, redondear, decimales, 'mul');
	    }
	  }, {
	    key: 'sumar',
	    value: function sumar(parametros, redondear, decimales) {
	      return this._operar(parametros, redondear, decimales, 'add');
	    }
	  }, {
	    key: 'restar',
	    value: function restar(parametro1, parametro2, redondear, decimales) {
	      return this._operar([parametro2, parametro1], redondear, decimales, 'minus');
	    }
	  }, {
	    key: 'dividir',
	    value: function dividir(parametro1, parametro2, redondear, decimales) {
	      if (parametro2 === 0) {
	        return;
	      }
	      return this._operar([parametro2, parametro1], redondear, decimales, 'div');
	    }
	  }, {
	    key: 'valorAbsoluto',
	    value: function valorAbsoluto(valor) {
	      valor = typeof valor === 'number' && !isNaN(valor) ? valor : 0;
	      valor = this.Big(valor);
	      return parseFloat(valor.abs().valueOf());
	    }
	  }, {
	    key: 'esEmpresa',
	    value: function esEmpresa(usuario) {
	      usuario = usuario ? usuario : this.Storage.getUser();
	      return usuario.rol && usuario.rol.nombre === 'EMPRESA';
	    }
	  }, {
	    key: 'getNumeroOrdinal',
	    value: function getNumeroOrdinal(i) {
	      if (i === 1 || i === 3) {
	        return i + 'er';
	      }
	      if (i === 2) {
	        return i + 'do';
	      }
	      if (i === 4 || i === 5 || i === 6) {
	        return i + 'to';
	      }
	      if (i === 7 || i === 10) {
	        return i + 'mo';
	      }
	      if (i === 8) {
	        return i + 'vo';
	      }
	      if (i === 9) {
	        return i + 'no';
	      }
	      return i + 'avo';
	    }
	  }, {
	    key: 'getPorcentaje',
	    value: function getPorcentaje(numero, porcentaje) {
	      // return this.redondear(this.redondear(numero * porcentaje)/100);
	      return parseFloat(this.Big(numero).mul(porcentaje).div(100).toFixed(this.decimales || 2));
	    }
	  }, {
	    key: 'arrayToObject',
	    value: function arrayToObject(array) {
	      return this._.zipObject(array, Array.from(new Array(array.length), function () {
	        return true;
	      }));
	    }
	  }]);
	
	  return UtilService;
	}();
	
	exports.default = UtilService;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ButtonSpinner = function ButtonSpinner() {
	  _classCallCheck(this, ButtonSpinner);
	
	  this.restrict = 'A';
	  this.transclude = true;
	  this.scope = {
	    spinning: '=buttonSpinner',
	    spinningIcon: '@?',
	    buttonPrepend: '@?',
	    buttonAppend: '@?'
	  };
	  this.template = '<span ng-if="!!buttonPrepend" ng-hide="spinning"><i class="{{ buttonPrepend }}"></i>&nbsp;</span>\n                     <span ng-if="!!buttonPrepend" ng-show="spinning"><i class="{{ !!spinningIcon ? spinningIcon : \'fa fa-spinner fa-spin\' }}"></i>&nbsp;</span>\n                     <ng-transclude></ng-transclude>\n                     <span ng-if="!!buttonAppend" ng-hide="spinning">&nbsp;<i class="{{ buttonAppend }}"></i></span>\n                     <span ng-if="!buttonPrepend" ng-show="spinning">&nbsp;<i class="{{ !!spinningIcon ? spinningIcon : \'fa fa-spinner fa-spin\' }}"></i></span>';
	};
	
	exports.default = ButtonSpinner;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cCheckbox = __webpack_require__(255);
	
	var _cCheckbox2 = _interopRequireDefault(_cCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CCheckboxComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngDisabled: '=',
	    ngRequired: '='
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n    <label class="custom-control custom-checkbox">\n      <input type="checkbox" class="custom-control-input" name="$ctrl.name" ng-model="$ctrl.ngModel" ng-required="$ctrl.ngRequired" ng-req ng-disabled="$ctrl.ngDisabled">\n      <span class="custom-control-indicator"></span>\n      <span class="custom-control-description">{{$ctrl.label}}</span>\n    </label>\n    <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert">\n      <div ng-message="required"  ng-if="$ctrl.form[$ctrl.name].$touched">\n        <small class="form-text text-muted text-danger font-weight-bold">\n           El campo es requerido.\n        </small>\n      </div>\n    </div>\n      ',
	  controller: _cCheckbox2.default
	};
	
	exports.default = CCheckboxComponent;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CCheckboxController = function () {
	  function CCheckboxController() {
	    'ngInject';
	
	    _classCallCheck(this, CCheckboxController);
	  }
	
	  _createClass(CCheckboxController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return CCheckboxController;
	}();
	
	exports.default = CCheckboxController;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cInput = __webpack_require__(265);
	
	var _cInput2 = _interopRequireDefault(_cInput);
	
	var _cInputMoney = __webpack_require__(261);
	
	var _cInputMoney2 = _interopRequireDefault(_cInputMoney);
	
	var _cSelect = __webpack_require__(274);
	
	var _cSelect2 = _interopRequireDefault(_cSelect);
	
	var _maxlen = __webpack_require__(276);
	
	var _maxlen2 = _interopRequireDefault(_maxlen);
	
	var _allowClearClass = __webpack_require__(273);
	
	var _allowClearClass2 = _interopRequireDefault(_allowClearClass);
	
	var _cTextarea = __webpack_require__(279);
	
	var _cTextarea2 = _interopRequireDefault(_cTextarea);
	
	var _cCheckbox = __webpack_require__(254);
	
	var _cCheckbox2 = _interopRequireDefault(_cCheckbox);
	
	var _cRadiobutton = __webpack_require__(267);
	
	var _cRadiobutton2 = _interopRequireDefault(_cRadiobutton);
	
	var _cDate = __webpack_require__(257);
	
	var _cDate2 = _interopRequireDefault(_cDate);
	
	var _cInputChips = __webpack_require__(259);
	
	var _cInputChips2 = _interopRequireDefault(_cInputChips);
	
	var _cSelectDate = __webpack_require__(269);
	
	var _cSelectDate2 = _interopRequireDefault(_cSelectDate);
	
	var _cSelectDpa = __webpack_require__(271);
	
	var _cSelectDpa2 = _interopRequireDefault(_cSelectDpa);
	
	var _validacion = __webpack_require__(281);
	
	var _validacion2 = _interopRequireDefault(_validacion);
	
	var _buttonSpinner = __webpack_require__(253);
	
	var _buttonSpinner2 = _interopRequireDefault(_buttonSpinner);
	
	var _validarFormulario = __webpack_require__(283);
	
	var _validarFormulario2 = _interopRequireDefault(_validarFormulario);
	
	var _validarFormularioAlerta = __webpack_require__(282);
	
	var _validarFormularioAlerta2 = _interopRequireDefault(_validarFormularioAlerta);
	
	var _cInputNumeric = __webpack_require__(263);
	
	var _cInputNumeric2 = _interopRequireDefault(_cInputNumeric);
	
	var _cTable = __webpack_require__(277);
	
	var _cTable2 = _interopRequireDefault(_cTable);
	
	__webpack_require__(168);
	
	var _angularUiMask = __webpack_require__(146);
	
	var _angularUiMask2 = _interopRequireDefault(_angularUiMask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UiComponentsModule = angular.module('app.ccomponents', [_angularUiMask2.default
	// CDataTable
	]).component('cInput', _cInput2.default).component('cInputMoney', _cInputMoney2.default).component('cSelect', _cSelect2.default).directive('maxlen', function () {
	  return new _maxlen2.default();
	}).directive('allowClearClass', function () {
	  return new _allowClearClass2.default();
	}).component('cCheckbox', _cCheckbox2.default).component('cRadiobutton', _cRadiobutton2.default).component('cTextarea', _cTextarea2.default).component('cDate', _cDate2.default).component('cInputChips', _cInputChips2.default).component('cSelectDate', _cSelectDate2.default).component('cSelectDpa', _cSelectDpa2.default).component('cTable', _cTable2.default).component('cInputNumeric', _cInputNumeric2.default).service('ValidacionForms', _validacion2.default).directive('buttonSpinner', function () {
	  return new _buttonSpinner2.default();
	}).directive('validarFormulario', function () {
	  return new _validarFormulario2.default();
	}).directive('validarFormularioAlerta', function () {
	  return new _validarFormularioAlerta2.default();
	}).name;
	
	// libreria mascara para el date
	exports.default = UiComponentsModule;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cDate = __webpack_require__(258);
	
	var _cDate2 = _interopRequireDefault(_cDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CDateComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngDisabled: '=',
	    ngRequired: '=',
	    minDate: '=?',
	    mensajeMinDate: '@?',
	    maxDate: '=?',
	    mensajeMaxDate: '@?',
	    ngChange: '&',
	    initDate: '<',
	    minDateKey: '@',
	    maxDateKey: '@'
	  },
	  require: {
	    form: '^form'
	  },
	
	  template: '\n      <div class="md-form-group">\n        <label class="md-control-label" for="{{$ctrl.name}}" ng-class="{\'requerido\':$ctrl.ngRequired}" style="top:-1rem;font-size:11px;">{{$ctrl.label}}</label>\n        <div class="input-group">\n          <input type="text"\n                 id="{{$ctrl.name}}"\n                 name="{{$ctrl.name}}"\n                 class=""\n                 ui-mask="99/99/9999"\n                 maxlength="10"\n                 ng-disabled="$ctrl.ngDisabled"\n                 ng-required="$ctrl.ngRequired"\n                 model-view-value="true"\n                 ng-model="$ctrl.date"\n                 init-date="$ctrl.initDate"\n                 ng-model-options="{ getterSetter: true }"\n                 uib-datepicker-popup="dd/MM/yyyy"\n                 is-open="$ctrl.opened"\n                 datepicker-options="$ctrl.options"\n                 ng-click="$ctrl.open($event)"\n                 ng-change="$ctrl.actualizarValor(); $ctrl.ngChange({data:$ctrl.date})"\n                 ui-validate="{minDate: \'$ctrl.verifyMinDate($value)\', maxDate: \'$ctrl.verifyMaxDate($value)\'}"\n                 min-date="$ctrl.minDate"\n                 max-date="$ctrl.maxDate"\n                 >\n          <button type="button" class="btn btn-link p-0 m-0" ng-click="$ctrl.open($event)"><i class="fa fa-calendar"></i></button>\n        </div>\n        <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n        <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">\n          <div ng-message="required"> El campo es requerido. </div>\n          <div ng-message="date"> Introduzca una fecha v\xE1lida (dd/mm/aaaa). </div>\n          <div ng-message="minDate" ng-if="!$ctrl.mensajeMinDate"> La fecha debe ser mayor o igual a {{$ctrl.options.minDate | date:\'dd/MM/yyyy\' }}. </div>\n          <div ng-message="minDate" ng-if="$ctrl.mensajeMinDate"> {{$ctrl.mensajeMinDate}} </div>\n          <div ng-message="maxDate" ng-if="!$ctrl.mensajeMaxDate"> La fecha debe ser menor o igual a {{$ctrl.options.maxDate | date:\'dd/MM/yyyy\'}}. </div>\n          <div ng-message="maxDate" ng-if="$ctrl.mensajeMaxDate"> {{$ctrl.mensajeMaxDate}} </div>\n        </div>\n      </div>',
	  controller: _cDate2.default
	};
	
	exports.default = CDateComponent;

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CDateController = function () {
	  CDateController.$inject = ["Datetime", "$scope", "_"];
	  function CDateController(Datetime, $scope, _) {
	    'ngInject';
	
	    _classCallCheck(this, CDateController);
	
	    this.options = {};
	    this.Datetime = Datetime;
	    this._ = _;
	    this.$scope = $scope;
	  }
	
	  _createClass(CDateController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.formatoValor = 'YYYY-MM-dd';
	      this.options = {
	        maxDate: this.maxDate,
	        minDate: this.minDate,
	        formatYear: 'yyyy',
	        showWeeks: false
	      };
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.ngModel', function () {
	        if (_this._.isEmpty(_this.ngModel)) {
	          return;
	        }
	        _this.inicializarModel();
	      });
	    }
	  }, {
	    key: 'inicializarModel',
	    value: function inicializarModel() {
	      this.verificarFormatoModel();
	      this.date = this.Datetime.toDate(angular.copy(this.ngModel));
	      this.actualizarValor();
	    }
	  }, {
	    key: 'verificarFormatoModel',
	    value: function verificarFormatoModel() {
	      if (this.ngModel.length === 10) {
	        var valor = this.ngModel.split('-');
	        if (this.formatoValor == 'dd-MM-YYYY') {
	          if (valor.length === 3 && valor[0].length === 2 && valor[1].length === 2 && valor[2].length === 4) {
	            this.ngModel = valor[2] + '-' + valor[1] + '-' + valor[0] + 'T04:00:00.000Z';
	          }
	        }
	        if (this.formatoValor == 'YYYY-MM-dd') {
	          if (valor.length === 3 && valor[0].length === 4 && valor[1].length === 2 && valor[2].length === 2) {
	            this.ngModel = valor[0] + '-' + valor[1] + '-' + valor[2] + 'T04:00:00.000Z';
	          }
	        }
	        if (this.formatoValor == 'dd/MM/YYYY') {
	          valor = this.ngModel.split('/');
	          if (valor.length === 3 && valor[0].length === 2 && valor[1].length === 2 && valor[2].length === 4) {
	            this.ngModel = valor[2] + '-' + valor[1] + '-' + valor[0] + 'T04:00:00.000Z';
	          }
	        }
	      }
	    }
	  }, {
	    key: 'actualizarValor',
	    value: function actualizarValor() {
	      this.ngModel = this.formatearFecha(angular.copy(this.date));
	    }
	  }, {
	    key: 'formatearFecha',
	    value: function formatearFecha() {
	      if (this.ngModel) {
	        if (this.ngModel.indexOf('-') >= 1) {
	          if (this.ngModel.split('-')[0].length == 2) this.formatoValor = 'dd-MM-YYYY';
	          if (this.ngModel.split('-')[0].length == 4) this.formatoValor = 'YYYY-MM-dd';
	        }
	        if (this.ngModel.indexOf('/') >= 1) {
	          if (this.ngModel.split('/')[0].length == 2) this.formatoValor = 'dd/MM/YYYY';
	          if (this.ngModel.split('/')[0].length == 4) this.formatoValor = 'YYYY/MM/dd';
	        }
	      }
	      var f = this.Datetime.standar(this.date, this.formatoValor).toISOString().substr(0, 10);
	      return f;
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      this.opened = !this.opened;
	      if (this.options) {
	        if (this.maxDateKey) {
	          var MAX_DATE = angular.element(document.getElementById(this.maxDateKey)).val();
	          if (MAX_DATE) {
	            this.options.maxDate = this.Datetime.convert(MAX_DATE);
	          }
	        }
	        if (this.minDateKey) {
	          var MIN_DATE = angular.element(document.getElementById(this.minDateKey)).val();
	          if (MIN_DATE) {
	            this.options.minDate = this.Datetime.convert(MIN_DATE);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'verifyMaxDate',
	    value: function verifyMaxDate(value) {
	      if (!angular.isUndefined(this.options.maxDate)) {
	        this.options.maxDate = new Date(this.options.maxDate);
	        var dateSelected = new Date(value),
	            maxDate = new Date(this.options.maxDate.getFullYear(), this.options.maxDate.getMonth(), this.options.maxDate.getDate() + 1);
	        return dateSelected < maxDate;
	      }
	      return true;
	    }
	  }, {
	    key: 'verifyMinDate',
	    value: function verifyMinDate(value) {
	      if (!angular.isUndefined(this.options.minDate)) {
	        this.options.minDate = new Date(this.options.minDate);
	        var dateSelected = new Date(value),
	            minDate = new Date(this.options.minDate.getFullYear(), this.options.minDate.getMonth(), this.options.minDate.getDate() - 1);
	        return dateSelected > minDate;
	      }
	      return true;
	    }
	  }]);
	
	  return CDateController;
	}();
	
	exports.default = CDateController;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cInputChips = __webpack_require__(260);
	
	var _cInputChips2 = _interopRequireDefault(_cInputChips);
	
	__webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CInputChipsComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngRequired: '=',
	    ngDisabled: '=',
	    ngValidation: '@',
	    placeholder: '@',
	    maxTags: '@',
	    minLength: '@',
	    maxLength: '@'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n     <div class="md-form-group">\n      <tag-me\n        name="{{$ctrl.name}}"\n        type="input"\n        selected="$ctrl.ngModel"\n        placeholder="{{$ctrl.placeholder}}"\n        display-field="name"\n        typehead="false"\n        allow-outside-data-set="true"\n        same-input="false"\n        max="$ctrl.maxTags"\n        max-length="{{maxLength}}"\n        min-length="{{minLength}}"\n        validation="$ctrl.validation"\n        required="$ctrl.ngRequired"\n        theme="material">\n      </tag-me>\n        <label class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}" style="top:-1rem;font-size:11px;">{{$ctrl.label}}</label>\n       <div class="row">\n        <div class="col-md-6">\n          <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert">\n        <div ng-message="required"  ng-if="$ctrl.form[$ctrl.name].$touched">\n          <small class="form-text text-muted text-danger font-weight-bold">\n             El campo es requerido.\n          </small>\n        </div>\n         <div ng-message="pattern">\n           <small class="form-text text-muted text-danger font-weight-bold font-weight-bold">\n             {{$ctrl.messageErrorPattern}}\n            </small>\n        </div>\n         <div ng-message="minlength">\n            <small class="form-text text-muted text-danger font-weight-bold font-weight-bold">\n             El contenido es muy corto.\n            </small>\n        </div>\n         <div ng-message="maxlength">\n            <small class="form-text text-muted text-danger font-weight-bold font-weight-bold">\n             El contenido es muy largo.\n            </small>\n        </div>\n      </div>\n        </div>\n        <div class="col-md-6">\n          <div>\n           <small class="form-text text-muted pull-right">\n            N\xFAmero m\xE1ximo de elementos: {{$ctrl.maxTags}}\n            </small>\n        </div>\n        </div>\n       </div>\n     </div>\n  ',
	  controller: _cInputChips2.default
	};
	
	exports.default = CInputChipsComponent;

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CInputChipsController = function () {
	  function CInputChipsController() {
	    'ngInject';
	
	    _classCallCheck(this, CInputChipsController);
	
	    this.mensajeMaximo = false;
	  }
	
	  _createClass(CInputChipsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var tipoValidacion = this.ngValidation;
	      switch (tipoValidacion) {
	        case 'correo':
	          this.messageErrorPattern = 'Introduzca una dirección de correo válido.';
	          this.validation = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	          break;
	        case 'celular':
	          this.validation = /(6[0-9]{7}|7[0-9]{7})/;
	          this.messageErrorPattern = 'Introduzca un número de celular válido';
	          break;
	        case 'telefono':
	          this.validation = /^([0-9 +()-]{5,15})$/;
	          this.messageErrorPattern = 'Introduzca un número de teléfono o celular válido';
	          break;
	        default:
	          this.validation = null;
	      }
	      this.maxTags = angular.isUndefined(this.maxTags) ? 0 : this.maxTags;
	    }
	  }]);
	
	  return CInputChipsController;
	}();
	
	exports.default = CInputChipsController;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cInputMoney = __webpack_require__(262);
	
	var _cInputMoney2 = _interopRequireDefault(_cInputMoney);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CInputMoneyComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngDisabled: '=',
	    ngRequired: '=',
	    placeholder: '@?',
	    ngValidation: '@',
	    ngMinvalue: '@',
	    ngMaxvalue: '@',
	    ngBlur: '&?',
	    ngDecimals: '@',
	    icon: '<?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n     <div class="md-form-group" md-event-label>\n        <input ng-required="$ctrl.ngRequired"\n               ng-disabled="$ctrl.ngDisabled"\n               ng-readonly="$ctrl.ngReadonly"\n               ng-model="$ctrl.ngModel"\n               ng-maxlength="$ctrl.ngMaxlength"\n               ng-placeholder="$ctrl.placeholder"\n               ng-blur="$ctrl.ngBlur()"\n               name="{{$ctrl.name}}"\n               type="text"\n               numerico\n               min="$ctrl.ngMinvalue"\n               max="$ctrl.ngMaxvalue"\n               decimals="$ctrl.ngDecimals"\n               class="{{$ctrl.class}} {{$ctrl.icon===false?\'text-right\':\'\'}}" id="{{$ctrl.name}}">\n      <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}" style="padding-right:22px">{{ $ctrl.label }}</label>\n      <button ng-if="!($ctrl.icon===false)" type="button" class="btn btn-link p-0 m-0" style="position:absolute;top:5px;right:0"><i class="fa fa-money" aria-hidden="true"></i></button>\n      <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n      <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">\n        <div ng-message="required"> El campo es requerido. </div>\n      </div>\n    </div>',
	  controller: _cInputMoney2.default
	
	};
	
	exports.default = CInputMoneyComponent;

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CInputMoneyController = function () {
	  function CInputMoneyController() {
	    'ngInject';
	
	    _classCallCheck(this, CInputMoneyController);
	  }
	
	  _createClass(CInputMoneyController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return CInputMoneyController;
	}();
	
	exports.default = CInputMoneyController;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cInputNumeric = __webpack_require__(264);
	
	var _cInputNumeric2 = _interopRequireDefault(_cInputNumeric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CInputNumericComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngDisabled: '=?',
	    ngRequired: '=?',
	    ngBlur: '&?',
	    placeholder: '@?',
	    ngMinvalue: '@?',
	    ngMaxvalue: '@?',
	    ngDecimals: '@?',
	    ngFormatting: '<?',
	    class: '@?',
	    ngDirectives: '@?',
	    ngDecimalsDinamic: '<',
	    ngMaxDecimals: '@?',
	    ngNotNumber: '<?',
	    ngNumberDefault: '<?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n     <div class="md-form-group" md-event-label>\n      <input name="{{$ctrl.name}}"\n             id="{{$ctrl.name}}"\n             type="text"\n             ng-model="$ctrl.ngModel"\n             ng-required="$ctrl.ngRequired"\n             ng-disabled="$ctrl.ngDisabled"\n             ng-readonly="$ctrl.ngReadonly"\n             ng-maxlength="$ctrl.ngMaxlength"\n             ng-placeholder="$ctrl.placeholder"\n             ng-blur="$ctrl.ngBlur()"\n             numerico\n             min="$ctrl.ngMinvalue"\n             max="$ctrl.ngMaxvalue"\n             decimals="$ctrl.ngDecimals"\n             decimals-dinamic="$ctrl.ngDecimalsDinamic"\n             maxdecimals="$ctrl.ngMaxDecimals"\n             formatting="$ctrl.formatting"\n             class="{{$ctrl.class}}"\n             not-number="$ctrl.ngNotNumber"\n             number-default="$ctrl.ngNumberDefault"\n        >\n        <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}">{{ $ctrl.label }}</label>\n        <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n      <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">\n        <div ng-message="required"> El campo es requerido. </div>\n      </div>\n    </div>',
	  controller: _cInputNumeric2.default
	
	};
	
	exports.default = CInputNumericComponent;

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CInputNumericController = function () {
	  CInputNumericController.$inject = ["Util", "$scope", "$compile", "$element"];
	  function CInputNumericController(Util, $scope, $compile, $element) {
	    'ngInject';
	
	    _classCallCheck(this, CInputNumericController);
	
	    this.Util = Util;
	    this.$scope = $scope;
	    this.$compile = $compile;
	    this.$element = $element;
	  }
	
	  _createClass(CInputNumericController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.verificarAtributosAdicionales();
	      if (this.Util.isEmpty(this.ngModel)) {
	        this.ngModel = undefined;
	      }
	
	      this.$scope.$watch('$ctrl.ngModel', function () {
	        if (_this.ngDecimals == 0 && _this.ngModel && _this.ngModel % 1 !== 0) {
	          if (_this.ngModel % 1 >= 0.5) _this.ngModel = Math.floor(_this.ngModel) + 1;else _this.ngModel = Math.floor(_this.ngModel);
	        }
	      });
	    }
	  }, {
	    key: 'verificarAtributosAdicionales',
	    value: function verificarAtributosAdicionales() {
	      if (this.ngDirectives) {
	        var directivas = this.Util.limpiarEspaciosDobles(this.ngDirectives).split(' ');
	        for (var i = 0; i < directivas.length; i++) {
	          this.$compile(this.$element.find('input').attr(directivas[i], ''))(this.$scope);
	        }
	      }
	    }
	  }]);
	
	  return CInputNumericController;
	}();
	
	exports.default = CInputNumericController;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cInput = __webpack_require__(266);
	
	var _cInput2 = _interopRequireDefault(_cInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CInputComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    title: '@?',
	    type: '@?',
	    ngModel: '=',
	    ngDisabled: '=',
	    ngRequired: '=',
	    ngValidation: '@',
	    cUiValidate: '@?',
	    cUiValidateWatch: '@?',
	    ngMinlength: '@?',
	    ngMaxlength: '@?',
	    maxlength: '@?',
	    class: '@?',
	    ngDirectives: '@?',
	    ngBlur: '&?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n     <div class="md-form-group" md-event-label>\n        <input name="{{$ctrl.name}}" id="{{$ctrl.name}}"\n               ng-required="$ctrl.ngRequired"\n               ng-disabled="$ctrl.ngDisabled"\n               ng-readonly="$ctrl.ngReadonly"\n               ng-model="$ctrl.ngModel"\n               ng-pattern="$ctrl.validation"\n               ng-minlength="$ctrl.ngMinlength"\n               ng-maxlength="$ctrl.ngMaxlength"\n               maxlength="{{$ctrl.maxlength}}"\n               ui-validate ="{{$ctrl.cUiValidate}}"\n               ui-validate-watch ="{{$ctrl.cUiValidateWatch}}"\n               type="{{ $ctrl.type || \'text\' }}"\n               class="{{$ctrl.class}}"\n               ng-blur="$ctrl.ngBlur()"\n               autocapitalize="off">\n        <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}">{{ $ctrl.label }}</label>\n        <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n        <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">\n            <div ng-message="required"> El campo es requerido. </div>\n            <div ng-message="pattern"> {{$ctrl.messageErrorPattern}} </div>\n            <div ng-message="minlength"> El contenido es muy corto. </div>\n            <div ng-message="maxlength"> El contenido es muy largo. </div>\n            <div ng-message="parse"> {{$ctrl.messageErrorParse}} </div>\n            <div ng-message="contrasena"> Las contrase\xF1as son distintas. </div>\n        </div>\n    </div>',
	  controller: _cInput2.default
	};
	
	exports.default = CInputComponent;

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CInputController = function () {
	  CInputController.$inject = ["$scope", "$compile", "$element", "Util"];
	  function CInputController($scope, $compile, $element, Util) {
	    'ngInject';
	
	    _classCallCheck(this, CInputController);
	
	    this.$scope = $scope;
	    this.$compile = $compile;
	    this.$element = $element;
	    this.Util = Util;
	  }
	
	  _createClass(CInputController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.verificarAtributosAdicionales();
	      this.validation = '';
	      var tipoValidacion = this.ngValidation;
	
	      switch (tipoValidacion) {
	        case 'correo':
	          this.messageErrorPattern = 'Introduzca una dirección de correo válido.';
	          this.validation = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	          this.mayuscula = '';
	          break;
	        case 'celular':
	          this.validation = /(6[0-9]{7}|7[0-9]{7})/;
	          this.messageErrorPattern = 'Introduzca un número de celular válido';
	          break;
	        case 'telefono':
	          this.validation = /^(\+((\d{3}|\d{2}))( |-)\d{5,15}|(\d{7})|(\d{8}))$/;
	          this.messageErrorPattern = 'Introduzca un número de teléfono válido';
	          break;
	        case 'url':
	          this.validation = /^(http\:\/\/|https\:\/\/)?([a-z0-9][a-z0-9\-]*\.)+[a-z0-9][a-z0-9\-]*$/i;
	          this.messageErrorPattern = 'Introduzca una dirección web válida.';
	          this.mayuscula = '';
	          break;
	        case 'numerico':
	          this.validation = /^[0-9]+$/;
	          this.messageErrorPattern = 'Introduzca sólo números';
	          break;
	        case 'monetario':
	          this.validation = /^[0-9]|[0-9]+(\.[0-9]{1,2})+$/;
	          this.messageErrorPattern = 'Introduzca sólo números';
	          break;
	        case 'texto':
	          this.validation = /^[a-záéíóúñA-ZÁÉÍÓÚÑ\s]+$/;
	          this.messageErrorPattern = 'Introduzca solo texto';
	          break;
	        case 'texto-numerico':
	          this.validation = /^[0-9a-záéíóúñA-ZÁÉÍÓÚÑ."'&@\-\s]+$/;
	          this.messageErrorPattern = 'Introduzca solo texto o numeros y caracteres permitidos';
	          break;
	        case 'texto-numerico-minusculas':
	          this.validation = /^[0-9a-záéíóúñA-ZÁÉÍÓÚÑ."'&@\-\s]+$/;
	          this.messageErrorPattern = 'Introduzca solo texto o numeros y caracteres permitidos';
	          this.mayuscula = '';
	          break;
	        case 'alfa-numerico':
	          this.validation = /^[a-zñA-ZÑ0-9-".'\s]/;
	          this.messageErrorPattern = 'Introduzca solo texto, números o caracteres.';
	          break;
	        default:
	          this.validation = null;
	      }
	    }
	  }, {
	    key: 'verificarAtributosAdicionales',
	    value: function verificarAtributosAdicionales() {
	      if (this.ngDirectives) {
	        var directivas = this.Util.limpiarEspaciosDobles(this.ngDirectives).split(' ');
	        for (var i = 0; i < directivas.length; i++) {
	          this.$compile(this.$element.find('input').attr(directivas[i], directivas[i]))(this.$scope);
	        }
	      }
	    }
	  }]);
	
	  return CInputController;
	}();
	
	exports.default = CInputController;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cRadiobutton = __webpack_require__(268);
	
	var _cRadiobutton2 = _interopRequireDefault(_cRadiobutton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CRadioButtonComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngDisabled: '<',
	    ngRequired: '<',
	    options: '<',
	    horizontal: '<',
	    ngChange: '&?',
	    field: '@',
	    value: '@?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n  <div class="md-form-group">\n    <div ng-class="{\'row\':$ctrl.horizontal}">\n      <div ng-repeat="option in $ctrl.options" class="ml-3">\n        <label class="custom-control custom-radio">\n          <input type="radio" name="{{$ctrl.name}}" ng-model="$ctrl.ngModel"\n                 value="{{option[$ctrl.value] || option.codigo}}" class="custom-control-input"\n                 ng-change="$ctrl.controlCambioValor(option[$ctrl.value] || option.codigo)"\n                 ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled">\n          <span class="custom-control-indicator"></span>\n          <span class="custom-control-description">{{option[$ctrl.field]}}</span>\n        </label>\n      </div>\n    </div>\n    <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="md-label-radio" ng-class="{\'requerido\':$ctrl.ngRequired, \'{{$ctrl.classs}}\' : $ctrl.classs}">\n    {{$ctrl.label}}\n    </label>\n    <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">\n      <div ng-message="required"> El campo es requerido. </div>\n    </div>\n  </div>\n  ',
	  controller: _cRadiobutton2.default
	};
	
	exports.default = CRadioButtonComponent;

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CRadioButtonController = function () {
	  function CRadioButtonController() {
	    'ngInject';
	
	    _classCallCheck(this, CRadioButtonController);
	  }
	
	  _createClass(CRadioButtonController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'controlCambioValor',
	    value: function controlCambioValor(valor) {
	      if (this.ngChange && typeof this.ngChange === 'function') {
	        this.ngChange({ data: valor });
	      }
	    }
	  }]);
	
	  return CRadioButtonController;
	}();
	
	exports.default = CRadioButtonController;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _cSelectDate = __webpack_require__(270);
	
	var _cSelectDate2 = _interopRequireDefault(_cSelectDate);
	
	var _cSelectDate3 = __webpack_require__(692);
	
	var _cSelectDate4 = _interopRequireDefault(_cSelectDate3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CSelectDateComponent = {
	    template: _cSelectDate4.default,
	    controller: _cSelectDate2.default,
	    bindings: {
	        model: '=',
	        name: '@',
	        label: '@',
	        title: '@?',
	        options: '=',
	        field: '@',
	        isDisabled: '=?',
	        ngRequired: '=?',
	        onChange: '&',
	        minDate: '=?',
	        maxDate: '=?',
	        abreviacion: '@'
	    },
	    require: {
	        form: '^form'
	    }
	};
	
	exports.default = CSelectDateComponent;

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CSelectDateController = function () {
	  CSelectDateController.$inject = ["$scope", "$timeout", "Util"];
	  function CSelectDateController($scope, $timeout, Util) {
	    'ngInject';
	
	    _classCallCheck(this, CSelectDateController);
	
	    if (angular.isUndefined(this.isDisabled)) {
	      this.isDisabled = false;
	    }
	    if (angular.isUndefined(this.ngRequired)) this.ngRequired = false;
	
	    this.date = new Date();
	    this.listMonths = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
	    this.numDays = { '1': 31, '2': 28, '3': 31, '4': 30, '5': 31, '6': 30, '7': 31, '8': 31, '9': 30, '10': 31, '11': 30, '12': 31 };
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.Util = Util;
	  }
	
	  _createClass(CSelectDateController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.$on('resetForm', function () {
	        _this.day = '';
	        _this.month = '';
	        _this.year = '';
	      });
	      if (angular.isUndefined(this.abreviacion)) this.abreviacion = this.label;
	      this.years = this.initYears();
	      this.months = this.initMonths();
	      this.days = this.initDays();
	      if (this.maxDate) {
	        this.$scope.$watch(function () {
	          return _this.maxDate;
	        }, function () {
	          if (_this.model) {
	            _this.years = _this.initYears();
	            if (_this.year && _this.maxDate && _this.year.value > _this.maxDate.getFullYear()) {
	              _this.year = _this.years[0];
	            }
	          }
	        });
	      }
	      if (this.minDate) {
	        this.$scope.$watch(function () {
	          return _this.minDate;
	        }, function () {
	          if (_this.model) {
	            _this.years = _this.initYears();
	            if (_this.year && _this.minDate && _this.year.value < _this.minDate.getFullYear()) {
	              _this.year = _this.years[_this.years.length - 1];
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: '_verifMinMonth',
	    value: function _verifMinMonth() {
	      if (!this.minDate) {
	        this.minDate = new Date();
	        this.minDate.setFullYear(this.minDate.getFullYear() - 100);
	      }
	      return this.minDate && this.year && this.minDate.getFullYear() == this.year.value && this.month && this.minDate.getMonth() + 1 == this.month.value;
	    }
	  }, {
	    key: '_verifMaxMonth',
	    value: function _verifMaxMonth() {
	      if (!this.maxDate) {
	        this.maxDate = new Date();
	      }
	      return this.maxDate && this.year && this.maxDate.getFullYear() == this.year.value && this.month && this.maxDate.getMonth() + 1 == this.month.value;
	    }
	  }, {
	    key: 'initDays',
	    value: function initDays(lastDay) {
	      var _this2 = this;
	
	      var days = [];
	      var last = lastDay || 31;
	      for (var i = 1; i <= last; i++) {
	        days.push({
	          disabled: this._verifMinMonth() && i < this.maxDate.getDate() || this._verifMaxMonth() && i > this.maxDate.getDate(),
	          text: i,
	          value: i
	        });
	      }
	      if (this.day) {
	        this.day = days.find(function (d) {
	          return d.value == _this2.day.value;
	        });
	      }
	      return days;
	    }
	  }, {
	    key: '_verifMinYear',
	    value: function _verifMinYear() {
	      if (!this.minDate) {
	        this.minDate = new Date();
	        this.minDate.setFullYear(this.minDate.getFullYear() - 100);
	      }
	      return this.minDate && this.year && this.minDate.getFullYear() == this.year.value;
	    }
	  }, {
	    key: '_verifMaxYear',
	    value: function _verifMaxYear() {
	      if (!this.maxDate) {
	        this.maxDate = new Date();
	      }
	      return this.maxDate && this.year && this.maxDate.getFullYear() == this.year.value;
	    }
	  }, {
	    key: 'initMonths',
	    value: function initMonths() {
	      var _this3 = this;
	
	      var months = [];
	      for (var i = 0; i < 12; i++) {
	        months.push({
	          disabled: this._verifMinYear() && i < this.minDate.getMonth() || this._verifMaxYear() && i > this.maxDate.getMonth(),
	          text: this.listMonths[i],
	          value: i + 1
	        });
	      }
	      if (this.month) {
	        this.month = months.find(function (m) {
	          return m.value == _this3.month.value;
	        });
	      }
	      return months;
	    }
	  }, {
	    key: 'initYears',
	    value: function initYears() {
	      var maxYear = this.date.getFullYear(),
	          minYear = this.date.getFullYear() - 100,
	          years = [];
	      if (this.maxDate && this.maxDate.getFullYear()) {
	        maxYear = this.maxDate.getFullYear();
	      }
	      if (this.minDate && this.minDate.getFullYear()) {
	        minYear = this.minDate.getFullYear();
	      }
	
	      for (var i = maxYear; i >= minYear; i--) {
	        years.push({
	          text: i,
	          value: i
	        });
	      }
	      return years;
	    }
	  }, {
	    key: 'setDate',
	    value: function setDate() {
	      var _this4 = this;
	
	      this.$timeout(function () {
	        if (_this4.onChange && angular.isFunction(_this4.onChange)) {
	          _this4.onChange();
	        }
	
	        var day = _this4.verificarValor(_this4.day),
	            month = _this4.verificarValor(_this4.month),
	            year = _this4.verificarValor(_this4.year);
	
	        if (_this4._verifMaxYear() && month > _this4.maxDate.getMonth() + 1) {
	          _this4.month = _this4.months[_this4.maxDate.getMonth()];
	          month = _this4.verificarValor(_this4.month);
	        }
	        if (_this4._verifMinYear() && month < _this4.minDate.getMonth() + 1) {
	          _this4.month = _this4.months[_this4.minDate.getMonth()];
	          month = _this4.verificarValor(_this4.month);
	        }
	
	        // Verificar año biciesto
	        var nDays;
	        nDays = _this4.numDays[month];
	
	        if (nDays == 28 && year % 4 == 0) {
	          ++nDays;
	        }
	        if (day > nDays) {
	          _this4.day = _this4.days[nDays - 1];
	          day = _this4.verificarValor(_this4.day);
	        }
	        if (_this4._verifMaxMonth() && day > _this4.maxDate.getDate()) {
	          _this4.day = _this4.days[_this4.maxDate.getDate() - 1];
	          day = _this4.verificarValor(_this4.day);
	        }
	        if (_this4._verifMinMonth() && day < _this4.minDate.getDate()) {
	          _this4.day = _this4.days[_this4.minDate.getDate() - 1];
	          day = _this4.verificarValor(_this4.day);
	        }
	        if (day !== '00' && month !== '00' && year !== '00') {
	          _this4.model = new Date(month + '/' + day + '/' + year);
	        } else {
	          _this4.model = null;
	        }
	
	        _this4.months = _this4.initMonths();
	        _this4.days = _this4.initDays(nDays);
	      }, 100);
	    }
	  }, {
	    key: 'verificarValor',
	    value: function verificarValor(item) {
	      if (!angular.isUndefined(item) && item !== null) {
	        return item.value;
	      } else {
	        return '00';
	      }
	    }
	  }, {
	    key: 'inputDate',
	    value: function inputDate(data, lista, model) {
	      if (!data) {
	        return;
	      }
	      for (var i = 0; i < lista.length; i++) {
	        if (String(lista[i].text).toLowerCase() === data.toLowerCase()) {
	          this[model] = lista[i];
	          this.setDate();
	          return;
	        }
	      }
	    }
	  }]);
	
	  return CSelectDateController;
	}();
	
	exports.default = CSelectDateController;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cSelectDpa = __webpack_require__(272);
	
	var _cSelectDpa2 = _interopRequireDefault(_cSelectDpa);
	
	var _cSelectDpa3 = __webpack_require__(693);
	
	var _cSelectDpa4 = _interopRequireDefault(_cSelectDpa3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CSelectDPAComponent = {
	  bindings: {
	    ngModel: '=',
	    ngRequired: '<?',
	    ngDisabled: '<?',
	    departamentos: '=?',
	    provincias: '=?',
	    municipios: '=?',
	    selectMunicipio: '&?',
	    disableProvincia: '<?',
	    horizontal: '=?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: _cSelectDpa4.default,
	  controller: _cSelectDpa2.default
	};
	
	exports.default = CSelectDPAComponent;

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CSelectDPAController = function () {
	  CSelectDPAController.$inject = ["DataService", "Util"];
	  function CSelectDPAController(DataService, Util) {
	    'ngInject';
	
	    _classCallCheck(this, CSelectDPAController);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.departamentos = [];
	    this.provincias = [];
	    this.municipios = [];
	  }
	
	  _createClass(CSelectDPAController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.prepararListasDeVisualizacion();
	      this.getDatosDpa();
	    }
	  }, {
	    key: 'getDatosDpa',
	    value: function getDatosDpa() {
	      if (!this.ngDisabled) {
	        this.getDepartamentos();
	        if (!this.Util.isEmpty(this.ngModel)) {
	          this.getProvincias(this.ngModel.departamento, false);
	          this.getMunicipios(this.ngModel.provincia, false);
	        }
	      }
	    }
	
	    /**
	    * prepararListasDeVisualizacion - En caso de que se los datos solo serán visualizados,
	    * no se obtiene datos de provincias y municipios, entonces para los mobiles se prepara
	    * las listas que contienen los datos del modelo
	    */
	
	  }, {
	    key: 'prepararListasDeVisualizacion',
	    value: function prepararListasDeVisualizacion() {
	      if (!this.Util.isEmpty(this.ngModel) && this.ngDisabled) {
	        this.provincias.push(this.ngModel.provincia);
	        this.municipios.push(this.ngModel.municipio);
	      }
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      if (this.ngModel) {
	        this.ngModel.departamento = this.getElementoDeLista(this.ngModel.departamento, this.departamentos);
	        this.ngModel.provincia = this.getElementoDeLista(this.ngModel.provincia, this.provincias);
	        this.ngModel.municipio = this.getElementoDeLista(this.ngModel.municipio, this.municipios);
	      }
	    }
	  }, {
	    key: 'getElementoDeLista',
	    value: function getElementoDeLista(elemento, lista) {
	      if (!elemento) {
	        return null;
	      }
	      for (var i = 0; i < lista.length; i++) {
	        if (lista[i].codigo === elemento.codigo) {
	          return lista[i];
	        }
	      }
	      return elemento;
	    }
	
	    /**
	    * getDepartamentos - Obtiene departamentos, si ngModel no es undefined significa que existe un valor ya asignado,
	    * entonces se envía en query el código del departamento ya cargado. Setea los departamentos como habilitados.
	    */
	
	  }, {
	    key: 'getDepartamentos',
	    value: function getDepartamentos() {
	      var _this = this;
	
	      var query = !this.Util.isEmpty(this.ngModel) && this.ngDisabled ? '?codigo=' + this.ngModel.departamento.codigo : '';
	      this.DataService.get('departamentos/' + query).then(function (response) {
	        _this.departamentos = response;
	        if (_this.Util.isEmpty(_this.ngModel)) {
	          _this.ngModel = {};
	          _this.establecerDatosPorDefecto(response, 'departamento');
	        }
	      });
	    }
	  }, {
	    key: 'getProvincias',
	    value: function getProvincias(departamento, reset) {
	      var _this2 = this;
	
	      if (reset) {
	        this.resetearValores();
	      }
	      this.DataService.get('provincias/' + departamento.codigo).then(function (response) {
	        _this2.provincias = response;
	        _this2.establecerDatosPorDefecto(response, 'provincia');
	      });
	      this.getMunicipios(departamento, reset);
	    }
	  }, {
	    key: 'getMunicipios',
	    value: function getMunicipios(provincia, reset) {
	      var _this3 = this;
	
	      if (reset) {
	        this.ngModel.municipio = null;
	      }
	      this.DataService.get('municipios/' + provincia.codigo).then(function (response) {
	        _this3.municipios = response;
	        _this3.establecerDatosPorDefecto(response, 'municipio');
	      });
	    }
	  }, {
	    key: 'resetearValores',
	    value: function resetearValores() {
	      this.ngModel.provincia = null;
	      this.ngModel.municipio = null;
	      this.municipios = [];
	    }
	  }, {
	    key: 'setMunicipio',
	    value: function setMunicipio(municipio) {
	      if (typeof selectMunicipio == 'function') {
	        this.selectMunicipio({ item: municipio });
	      }
	      if (this.disableProvincia) {
	        this.ngModel.provincia = this.provincias.find(function (prov) {
	          return prov.codigo == municipio.codigo.substring(0, 4);
	        });
	      } else {
	        if (!this.ngModel.provincia) {
	          this.ngModel.provincia = this.provincias.find(function (prov) {
	            return prov.codigo == municipio.codigo.substring(0, 4);
	          });
	          this.municipios = this.municipios.filter(function (muni) {
	            return muni.codigo.substring(0, 4) == municipio.codigo.substring(0, 4);
	          });
	        }
	      }
	    }
	
	    /**
	    * establecerDatosPorDefecto - Si en la lista de opciones solo hay un elemento,éste es asignado
	    * a la variable que corresponde como dato por defecto. Además se asigna sólo si ngModel es indefinido.
	    *
	    * @param  {array} lista    Lista de opciones
	    * @param  {string} elemento elemento a asignar el valor
	    * @return {function}          Método que se ejecutará de acuerdo al elemento seleccionado
	    */
	
	  }, {
	    key: 'establecerDatosPorDefecto',
	    value: function establecerDatosPorDefecto(lista, elemento) {
	      if (lista.length !== 1) {
	        return;
	      }
	      this.ngModel[elemento] = lista[0];
	      switch (elemento) {
	        case 'departamento':
	          return this.getProvincias(lista[0]);
	        case 'provincia':
	          return this.getMunicipios(lista[0]);
	      }
	      return;
	    }
	  }]);
	
	  return CSelectDPAController;
	}();
	
	exports.default = CSelectDPAController;

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AllowClearClass = function () {
	  function AllowClearClass() {
	    'ngInject';
	
	    _classCallCheck(this, AllowClearClass);
	
	    this.restrict = 'A';
	  }
	
	  _createClass(AllowClearClass, [{
	    key: 'link',
	    value: function link($scope, $elem, $attr) {
	      if ($attr.allowClear) {
	        var find = angular.element($elem[0].querySelector('.glyphicon-remove'));
	        find.removeClass('glyphicon glyphicon-remove');
	        find.addClass('fa fa-remove');
	      }
	    }
	  }]);
	
	  return AllowClearClass;
	}();
	
	exports.default = AllowClearClass;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cSelect = __webpack_require__(275);
	
	var _cSelect2 = _interopRequireDefault(_cSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import './ui-select.scss';
	var CSelectComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    title: '@',
	    placeholder: '@',
	    ngModel: '=',
	    ngChange: '&',
	    onSelect: '&',
	    ngDisabled: '=',
	    ngRequired: '=',
	    options: '<',
	    field: '@',
	    keyValue: '@'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n      <div class="md-form-group md-select-group" md-event-label>\n        <ui-select ng-if="!$ctrl.Util.isMobile.any() && !$ctrl.keyValue" name="{{$ctrl.name}}" on-select="$ctrl.onSelect({item:$item})" ng-change="$ctrl.ngChange()" ng-model="$ctrl.ngModel" theme="bootstrap"\n        class="md-select" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled" maxlen="20">\n          <ui-select-match placeholder="{{$ctrl.placeholder}}" allow-clear="!$ctrl.ngRequired" allow-clear-class>\n            {{$select.selected[$ctrl.field]}}\n          </ui-select-match>\n          <ui-select-choices repeat="item in $ctrl.options | filter: $select.search">\n            <span ng-bind-html="item[$ctrl.field] | highlight: $select.search"></span>\n          </ui-select-choices>\n          <ui-select-no-choice>\n            <small> No se encontraron coincidencias </small>\n          </ui-select-no-choice>\n        </ui-select>\n\n        <ui-select ng-if="!$ctrl.Util.isMobile.any() && $ctrl.keyValue" name="{{$ctrl.name}}" on-select="$ctrl.onSelect({item:$item})" ng-change="$ctrl.ngChange()" ng-model="$ctrl.ngModel" theme="bootstrap"\n        class="md-select" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled" maxlen="20">\n          <ui-select-match placeholder="{{$ctrl.placeholder}}" allow-clear="!$ctrl.ngRequired" allow-clear-class>\n            {{$select.selected[$ctrl.field]}}\n          </ui-select-match>\n          <ui-select-choices repeat="item[$ctrl.keyValue] as item in $ctrl.options | filter: $select.search">\n            <span ng-bind-html="item[$ctrl.field] | highlight: $select.search"></span>\n          </ui-select-choices>\n          <ui-select-no-choice>\n            <small> No se encontraron coincidencias </small>\n          </ui-select-no-choice>\n        </ui-select>\n\n        <select class="select-mobile" ng-if="!!$ctrl.Util.isMobile.any()" name="{{$ctrl.name}}" ng-model="$ctrl.ngModel" ng-options="item[$ctrl.field] for item in $ctrl.options"\n        ng-change="$ctrl.ngChange()" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled"></select>\n\n        <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="{{!!$ctrl.Util.isMobile.any()? \'label-mobile\' : \'md-control-label\'}}" ng-class="{\'requerido\':$ctrl.ngRequired, \'md-control-label\': $ctrl.ngModel}">{{$ctrl.label}}</label>\n\n        <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n        <div ng-messages="$ctrl.form[$ctrl.name].$error" ap-error ng-if="$ctrl.form[$ctrl.name].$touched" role="alert">\n          <div ng-message="required"> El campo es requerido. </div>\n        </div>\n      </div>\n    ',
	  controller: _cSelect2.default
	};
	
	exports.default = CSelectComponent;

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CSelectController = function () {
	  CSelectController.$inject = ["Util"];
	  function CSelectController(Util) {
	    'ngInject';
	
	    _classCallCheck(this, CSelectController);
	
	    this.Util = Util;
	  }
	
	  _createClass(CSelectController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.field = angular.isUndefined(this.field) ? 'nombre' : this.field;
	      this.placeholder = angular.isUndefined(this.placeholder) ? 'Seleccione ...' : this.placeholder;
	      this.establecerDatosPorDefecto();
	    }
	
	    /**
	     * establecerDatosPorDefecto - Si en la lista de opciones solo hay un elemento,éste es asignado
	     * a la variable que corresponde como dato por defecto. Además se asigna sólo si ngModel es indefinido.
	     */
	
	  }, {
	    key: 'establecerDatosPorDefecto',
	    value: function establecerDatosPorDefecto() {
	      if (this.options && this.options.length === 1 && angular.isUndefined(this.ngModel)) {
	        if (this.keyValue) {
	          this.ngModel = this.options[0][this.keyValue];
	        } else {
	          this.ngModel = this.options[0];
	        }
	      }
	    }
	  }]);
	
	  return CSelectController;
	}();
	
	exports.default = CSelectController;

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MaxLen = function () {
	  function MaxLen() {
	    _classCallCheck(this, MaxLen);
	
	    this.restrict = 'A';
	  }
	
	  _createClass(MaxLen, [{
	    key: 'link',
	    value: function link($scope, $elem, $attr) {
	      var uiSelectSearch = angular.element($elem[0].querySelector('.ui-select-search'));
	      uiSelectSearch.attr("maxlength", $attr.maxlen);
	    }
	  }]);
	
	  return MaxLen;
	}();
	
	exports.default = MaxLen;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _cTable = __webpack_require__(278);
	
	var _cTable2 = _interopRequireDefault(_cTable);
	
	var _cTable3 = __webpack_require__(694);
	
	var _cTable4 = _interopRequireDefault(_cTable3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CTableComponent = {
	        bindings: {
	                columns: '<',
	                dataset: '<'
	        },
	        template: _cTable4.default,
	        controller: _cTable2.default
	};
	
	exports.default = CTableComponent;

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CTableController = function () {
	  CTableController.$inject = ["NgTableParams", "$scope"];
	  function CTableController(NgTableParams, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, CTableController);
	
	    this.NgTableParams = NgTableParams;
	    this.$scope = $scope;
	  }
	
	  _createClass(CTableController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.initTableParams();
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.dataset', function () {
	        _this.initTableParams();
	      }, true);
	    }
	  }, {
	    key: 'initTableParams',
	    value: function initTableParams() {
	      this.tableParams = new this.NgTableParams({
	        sorting: {}
	      }, {
	        dataset: this.dataset
	      });
	    }
	  }]);
	
	  return CTableController;
	}();
	
	exports.default = CTableController;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cTextarea = __webpack_require__(280);
	
	var _cTextarea2 = _interopRequireDefault(_cTextarea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CTextareaComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    title: '@',
	    ngModel: '=',
	    ngDisabled: '=',
	    ngRequired: '=',
	    rows: '@?',
	    ngMinlength: '@?',
	    ngMaxlength: '@?',
	    maxlength: '@?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '   <div class="md-form-group" md-event-label>\n        <textarea name="{{$ctrl.name}}"\n                  ng-required="$ctrl.ngRequired"\n                  ng-disabled="$ctrl.ngDisabled"\n                  ng-readonly="$ctrl.ngReadonly"\n                  ng-model="$ctrl.ngModel"\n                  ng-minlength="$ctrl.ngMinlength"\n                  ng-maxlength="$ctrl.ngMaxlength"\n                  maxlength="{{$ctrl.maxlength}}"\n                  rows="{{$ctrl.rows}}">\n        </textarea>\n        <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}" for="textarea">{{ $ctrl.label }}</label>\n        <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n        <div ng-messages="$ctrl.form[$ctrl.name].$error" ap-error ng-if="$ctrl.form[$ctrl.name].$touched && !$ctrl.form[$ctrl.name].$valid" role="alert">\n            <div ng-message="required"> El campo es requerido. </div>\n            <div ng-message="minlength"> El contenido es muy corto. </div>\n            <div ng-message="maxlength"> El contenido es muy largo. </div>\n        </div>\n    </div>\n  ',
	  controller: _cTextarea2.default
	};
	
	exports.default = CTextareaComponent;

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CTextAreaController = function () {
	  function CTextAreaController() {
	    'ngInject';
	
	    _classCallCheck(this, CTextAreaController);
	  }
	
	  _createClass(CTextAreaController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return CTextAreaController;
	}();
	
	exports.default = CTextAreaController;

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ValidacionFormsService = function () {
	  ValidacionFormsService.$inject = ["Modal"];
	  function ValidacionFormsService(Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ValidacionFormsService);
	
	    this.Modal = Modal;
	  }
	
	  _createClass(ValidacionFormsService, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'esFormularioValido',
	    value: function esFormularioValido(form) {
	      return form.$valid;
	    }
	  }, {
	    key: 'validarFormulario',
	    value: function validarFormulario(form, mostrarModal) {
	      var _this = this;
	
	      this.camposInvalidos = {};
	      if (this.esFormularioValido(form)) {
	        return;
	      } else {
	        angular.forEach(form.$error, function (campos) {
	          angular.forEach(campos, function (campo) {
	            if (campo.$name) {
	              var elemento = angular.element(document.querySelector('[name=' + campo.$name + ']'));
	              var label = _this.obtenerLabel(campo.$name, elemento);
	              if (angular.isUndefined(_this.camposInvalidos[campo.$name])) {
	                if (label) {
	                  _this.camposInvalidos[campo.$name] = label;
	                }
	              }
	            }
	            campo.$touched = true;
	          });
	        });
	      }
	      if (mostrarModal) {
	        this.mostrarCamposInvalidos(this.camposInvalidos);
	      } else {
	        return this.camposInvalidos;
	      }
	    }
	  }, {
	    key: 'obtenerLabel',
	    value: function obtenerLabel(nombreCampo, elemento) {
	      var elementoPadre = elemento.parent();
	      var i = 0;
	      while (i < 10) {
	        var elemPadre = elementoPadre.find('label');
	        if (elemPadre.length > 0) {
	          for (var j = 0; j < elemPadre.length; j++) {
	            if (elemPadre[j].htmlFor === nombreCampo) {
	              if (elemPadre[j].title !== '') {
	                return elemPadre[j].title;
	              }
	              return elemPadre[j].innerText;
	            }
	          }
	        }
	        elementoPadre = elementoPadre.parent();
	        i++;
	      }
	      return null;
	    }
	  }, {
	    key: 'mostrarCamposInvalidos',
	    value: function mostrarCamposInvalidos(camposInvalidos, titulo) {
	      this.Modal.alert(this.getMensajeCamposIncompletos(camposInvalidos), null, titulo || 'Campos incompletos', null, 'md');
	    }
	  }, {
	    key: 'getMensajeCamposIncompletos',
	    value: function getMensajeCamposIncompletos(camposInvalidos) {
	      var mensaje = '<p>Verifique, corrija y/o llene los siguientes campos:</p>';
	      mensaje += '<ul>';
	      angular.forEach(camposInvalidos || this.camposInvalidos, function (error) {
	        mensaje += '<li>' + error + '</li>';
	      });
	      return mensaje += '</ul>';
	    }
	  }]);
	
	  return ValidacionFormsService;
	}();
	
	exports.default = ValidacionFormsService;

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ValidarFormularioAlerta = function () {
	  function ValidarFormularioAlerta() {
	    'ngInject';
	
	    _classCallCheck(this, ValidarFormularioAlerta);
	
	    this.restrict = 'A';
	    this.controller = ValidarFormularioAlertaController;
	    this.scope = {
	      form: '=validarFormularioAlerta',
	      nombreForm: '@nombreFormulario',
	      method: '&ngClick',
	      methodValidation: '&validacionParalela'
	    };
	  }
	
	  _createClass(ValidarFormularioAlerta, [{
	    key: 'link',
	    value: function link($scope, $elem, $attr, $ctrl) {
	      var _this = this;
	
	      $elem.bind('click', function (event) {
	        if (!$scope.form && $scope.nombreForm) {
	          $scope.form = $scope.nombreForm;
	        }
	        if ($ctrl.Util.isEmpty($scope.form)) {
	          return;
	        }
	        event.stopImmediatePropagation();
	        if (_typeof($scope.form) === 'object') {
	          _this.validarFormularioAlerta($scope, $ctrl, $scope.form, event);
	        } else if (typeof $scope.form === 'string') {
	          var FORM = _this.buscarFormulario($scope);
	          if (!angular.isUndefined(FORM)) {
	            _this.validarFormularioAlerta($scope, $ctrl, FORM[$scope.form]);
	          }
	        }
	        $scope.$apply();
	      });
	    }
	  }, {
	    key: 'validarFormularioAlerta',
	    value: function validarFormularioAlerta($scope, $ctrl, form) {
	      if ($ctrl.Util.isValidFormFieldsAlerta(form)) {
	        $scope.method();
	      } else {
	        $scope.methodValidation();
	      }
	    }
	  }, {
	    key: 'buscarFormulario',
	    value: function buscarFormulario($scope) {
	      return angular.element(document.querySelector('[name=' + $scope.form + ']')).scope();
	    }
	  }]);
	
	  return ValidarFormularioAlerta;
	}();
	
	var ValidarFormularioAlertaController = function ValidarFormularioAlertaController(Util) {
	  'ngInject';
	
	  _classCallCheck(this, ValidarFormularioAlertaController);
	
	  this.Util = Util;
	};
	ValidarFormularioAlertaController.$inject = ["Util"];
	
	exports.default = ValidarFormularioAlerta;

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ValidarFormulario = function () {
	  function ValidarFormulario() {
	    'ngInject';
	
	    _classCallCheck(this, ValidarFormulario);
	
	    this.restrict = 'A';
	    this.controller = ValidarFormularioController;
	    this.scope = {
	      form: '=validarFormulario',
	      nombreForm: '@nombreFormulario',
	      method: '&ngClick',
	      methodValidation: '&validacionParalela'
	    };
	  }
	
	  _createClass(ValidarFormulario, [{
	    key: 'link',
	    value: function link($scope, $elem, $attr, $ctrl) {
	      var _this = this;
	
	      $elem.bind('click', function (event) {
	        if (!$scope.form && $scope.nombreForm) {
	          $scope.form = $scope.nombreForm;
	        }
	        if ($ctrl.Util.isEmpty($scope.form)) {
	          return;
	        }
	        event.stopImmediatePropagation();
	        if (_typeof($scope.form) === 'object') {
	          _this.validarFormulario($scope, $ctrl, $scope.form, event);
	        } else if (typeof $scope.form === 'string') {
	          var FORM = _this.buscarFormulario($scope);
	          if (!angular.isUndefined(FORM)) {
	            _this.validarFormulario($scope, $ctrl, FORM[$scope.form]);
	          }
	        }
	        $scope.$apply();
	      });
	    }
	  }, {
	    key: 'validarFormulario',
	    value: function validarFormulario($scope, $ctrl, form) {
	      if ($ctrl.Util.isValidFormFields(form)) {
	        $scope.method();
	      } else {
	        $scope.methodValidation();
	      }
	    }
	  }, {
	    key: 'buscarFormulario',
	    value: function buscarFormulario($scope) {
	      return angular.element(document.querySelector('[name=' + $scope.form + ']')).scope();
	    }
	  }]);
	
	  return ValidarFormulario;
	}();
	
	var ValidarFormularioController = function ValidarFormularioController(Util) {
	  'ngInject';
	
	  _classCallCheck(this, ValidarFormularioController);
	
	  this.Util = Util;
	};
	ValidarFormularioController.$inject = ["Util"];
	
	exports.default = ValidarFormulario;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _crudTable = __webpack_require__(285);
	
	var _crudTable2 = _interopRequireDefault(_crudTable);
	
	var _crudTable3 = __webpack_require__(695);
	
	var _crudTable4 = _interopRequireDefault(_crudTable3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CrudTableComponent = {
	    bindings: {
	        url: '<',
	        title: '<',
	        fields: '<',
	        fieldsCreate: '<',
	        fieldsUpdate: '<',
	        fieldsSave: '<',
	        fks: '<',
	        buttonsTop: '<',
	        buttons: '<',
	        checks: '<',
	        clases: '<',
	        queryExtra: '<',
	        permission: '<',
	        modalController: '<',
	        modalTemplate: '<',
	        addModalTemplate: '<',
	        addModalController: '<',
	        editModalTemplate: '<',
	        editModalController: '<',
	        inline: '@',
	        editable: '@',
	        pagination: '@',
	        formly: '<',
	        data: '=',
	        callbackSave: '<',
	        hiddenFields: '<',
	        mergeFields: '<',
	        eventCreate: '<',
	        eventEdit: '<',
	        eventDelete: '<',
	        labels: '<',
	        delete: '<',
	        update: '<'
	    },
	    controller: _crudTable2.default,
	    template: _crudTable4.default
	};
	
	exports.default = CrudTableComponent;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _crudTableModal = __webpack_require__(286);
	
	var _crudTableModal2 = _interopRequireDefault(_crudTableModal);
	
	var _crudTableModal3 = __webpack_require__(696);
	
	var _crudTableModal4 = _interopRequireDefault(_crudTableModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrudTableController = function () {
	    CrudTableController.$inject = ["$scope", "DataService", "NgTableParams", "Modal", "CrudTable", "Util", "ArrayUtil", "Message", "Datetime", "$log"];
	    function CrudTableController($scope, DataService, NgTableParams, Modal, CrudTable, Util, ArrayUtil, Message, Datetime, $log) {
	        'ngInject';
	
	        _classCallCheck(this, CrudTableController);
	
	        this.$scope = $scope;
	        this.DataService = DataService;
	        this.NgTableParams = NgTableParams;
	        this.Modal = Modal;
	        this.Message = Message;
	        this.Util = Util;
	        this.CrudTable = CrudTable;
	        this.ArrayUtil = ArrayUtil;
	        this.Datetime = Datetime;
	        this.$log = $log;
	
	        this.formlyDefault = [{
	            key: '',
	            templateOptions: {
	                required: false
	            },
	            hideExpression: 'true'
	        }, {
	            key: 'updatedAt',
	            templateOptions: {
	                required: false
	            },
	            hideExpression: 'true'
	        }, {
	            key: 'createdAt',
	            templateOptions: {
	                required: false
	            },
	            hideExpression: 'true'
	        }];
	
	        this.permissions = {
	            create: true,
	            read: true,
	            update: true,
	            delete: true,
	            print: false,
	            filter: true
	        };
	
	        this.options = {};
	    }
	
	    _createClass(CrudTableController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            // this.$log.log(this);
	            this.getFields();
	
	            if (this.data && this.data.list && this.Util.toType(this.data.list) == 'array') {
	                this.showFilter = false;
	            } else {
	                this.showFilter = true;
	            }
	
	            this.$scope.$on('refresh_crud_table', function (ev, url) {
	                if (url == _this.url) _this.refresh();
	            });
	        }
	    }, {
	        key: 'renderLabels',
	        value: function renderLabels(params) {
	            setTimeout(function () {
	                if (document.querySelector('.ng-table-counts')) {
	                    document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	                }
	                if (document.querySelector('.ng-table-pagination')) {
	                    document.querySelector('.ng-table-pagination').setAttribute('data-content', params.ini + ' al ' + params.end + ' de ' + params.total + ' Registros.');
	                }
	            }, 100);
	        }
	    }, {
	        key: 'addOptionSelected',
	        value: function addOptionSelected(data, options) {
	            for (var i in data) {
	                if (data[i].type == 'select') {
	                    var item = this.CrudTable.searchField(options, data[i].key);
	                    if (item) {
	                        this.ArrayUtil.insert(data[i].templateOptions.options, 0, {
	                            name: item.text || 'Seleccione',
	                            value: item.value || ''
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'getFields',
	        value: function getFields() {
	            var _this2 = this;
	
	            if (this.data && this.data.formly && this.Util.toType(this.data.formly) == 'array') {
	                this.setDataFields(this.data.formly);
	            } else {
	                this.DataService.options(this.url).then(function (response) {
	                    response = response.datos;
	                    _this2.setDataFields(response);
	                });
	            }
	        }
	    }, {
	        key: 'setDataFields',
	        value: function setDataFields() {
	            var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            this.fieldsData = this.CrudTable.filterFields(fields, this.fields);
	            this.idKey = this.CrudTable.getId(this.fieldsData);
	            this.formlyDefault[0].key = this.idKey;
	
	            if (this.formly && this.Util.toType(this.formly) == 'array') {
	                this.formly = this.CrudTable.addPropertiesFormly(this.formlyDefault, this.formly);
	            } else {
	                this.formly = this.formlyDefault;
	            }
	
	            // this.$log.log('formly:', this.formly);
	            this.fieldsData = this.CrudTable.addPropertiesFormly(this.fieldsData, this.formly);
	            this.addOptionSelected(this.fieldsData, this.optionSelected);
	            this.DataService.setFormly(this.fieldsData);
	
	            // this.$log.log('fields:', this.fieldsData);
	            this.setHeaders(this.fieldsData);
	            if (this.editable) {
	                this.types = this.CrudTable.getKeys(this.fieldsData);
	            }
	            this.getData();
	
	            /**
	             * Campos para el formulario de adición
	             */
	            if (this.Util.toType(this.fieldsCreate) == 'array') {
	                this.fieldsCreate = this.CrudTable.filterFields(fields, this.fieldsCreate);
	                this.fieldsCreate = this.CrudTable.addPropertiesFormly(this.fieldsCreate, this.formly);
	            }
	
	            /**
	             * Campos para el formulario de actualización
	             */
	            if (this.Util.toType(this.fieldsUpdate) == 'array') {
	                this.fieldsUpdate = this.CrudTable.filterFields(fields, this.fieldsUpdate);
	                this.fieldsUpdate = this.CrudTable.addPropertiesFormly(this.fieldsUpdate, this.formly);
	            }
	
	            /**
	             * Campos para el formulario de adición/actualización
	             */
	            if (this.Util.toType(this.fieldsSave) == 'array') {
	                this.fieldsSave = this.CrudTable.filterFields(fields, this.fieldsSave);
	                this.fieldsSave = this.CrudTable.addPropertiesFormly(this.fieldsSave, this.formly);
	            }
	
	            if (this.permission) {
	                this.permissions = angular.merge(this.permissions, this.permission);
	            }
	        }
	    }, {
	        key: 'setHeaders',
	        value: function setHeaders(fields) {
	            var headers = [{
	                field: "action",
	                title: "Acciones",
	                dataType: "command"
	            }];
	            var hiddenFields = this.Util.toType(this.hiddenFields) == 'array';
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var field = _step.value;
	
	                    var config = {
	                        field: field.key,
	                        title: field.templateOptions.label,
	                        headerTitle: field.templateOptions.label,
	                        sortable: field.key,
	                        show: hiddenFields ? this.hiddenFields.indexOf(field.key) === -1 && field.key != this.idKey : field.key != this.idKey
	                    };
	                    if (this.inline === undefined) {
	                        var filter = _defineProperty({}, field.key, field.templateOptions.type);
	                        // console.log('filter', filter);
	                        if (field.templateOptions.type == 'select' && field.templateOptions.options) {
	                            config.filterData = field.templateOptions.options;
	                        }
	                        config.filter = filter;
	                    }
	                    headers.push(config);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            this.headers = headers;
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            this.getData();
	        }
	    }, {
	        key: 'getData',
	        value: function getData() {
	            var _this3 = this;
	
	            if (this.data && this.data.list && this.Util.toType(this.data.list) == 'array') {
	                var data = { dataset: this.filterItems(this.data.list) };
	                var config = {};
	                if (this.pagination === false || this.pagination === 'false') {
	                    config.count = this.data.list.length;
	                    data.counts = [];
	                }
	
	                this.tableParams = new this.NgTableParams(config, data);
	            } else {
	                this.tableParams = new this.NgTableParams({}, {
	                    getData: function getData(params) {
	                        var data = params.url();
	                        var query = {
	                            limit: data.count,
	                            page: data.page
	                        };
	                        var sort = _this3.getSorting(data);
	                        if (sort) {
	                            query.order = sort;
	                        }
	                        var filters = _this3.getFilters(data);
	                        if (filters.length) {
	                            if (filters[0].crudtable_search_term) {
	                                query.filter = filters[0].crudtable_search_term;
	                            } else {
	                                for (var i in filters) {
	                                    var key = Object.keys(filters[i])[0];
	                                    if (filters[i][key] && filters[i][key] !== null && filters[i][key] != 'null') {
	                                        query[key] = filters[i][key];
	                                    }
	                                }
	                                // query.filter = JSON.stringify(filters);
	                            }
	                        }
	
	                        if (_this3.queryExtra) {
	                            angular.extend(query, _this3.queryExtra);
	                        }
	
	                        // this.$log.log('data:', data);
	                        return _this3.DataService.list(_this3.url, query).then(function (response) {
	                            response = response.datos;
	                            if (response && (response.results || response.rows)) {
	                                params.total(response.count);
	                                _this3.emptyTable = response.count === 0;
	                                var items = _this3.filterItems(response.results || response.rows);
	                                _this3.renderLabels({
	                                    ini: (query.page - 1) * query.limit + 1,
	                                    end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                                    total: response.count
	                                });
	                                return items;
	                            }
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'getSorting',
	        value: function getSorting(params) {
	            for (var key in params) {
	                if (key.indexOf('sorting') != -1) {
	                    return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getFilters',
	        value: function getFilters(params) {
	            var filters = [];
	            for (var key in params) {
	                if (key.indexOf('filter') != -1) {
	                    filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	                }
	            }
	            return filters;
	        }
	    }, {
	        key: 'removeCorchete',
	        value: function removeCorchete(string, search) {
	            return string.replace(search + '[', '').replace(']', '');
	        }
	    }, {
	        key: 'filterItems',
	        value: function filterItems(data) {
	            data = angular.copy(data);
	            var fields = this.fields !== undefined;
	            var fks = this.fks !== undefined;
	            var relations = this.relations !== undefined;
	            var array = [];
	            for (var i in data) {
	                for (var j in data[i]) {
	                    if (fields && this.fields.indexOf(j) == -1) {
	                        delete data[i][j];
	                    } else {
	                        if (this.editable === undefined) {
	                            if (typeof data[i][j] == 'boolean') {
	                                data[i][j] = data[i][j] ? 'boolean_true' : 'boolean_false';
	                            } else if (relations && this.relations[j]) {
	                                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	                            } else if (fks && this.fks.indexOf(j) != -1) {
	                                if (this.Util.toType(data[i][j]) == 'array') {
	                                    var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                                    if (l > 1 && l == data[i][j].length) {
	                                        data[i][j] = 'Todos';
	                                    } else {
	                                        var text = [];
	                                        var _iteratorNormalCompletion2 = true;
	                                        var _didIteratorError2 = false;
	                                        var _iteratorError2 = undefined;
	
	                                        try {
	                                            for (var _iterator2 = data[i][j][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                                var e = _step2.value;
	
	                                                text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                                            }
	                                        } catch (err) {
	                                            _didIteratorError2 = true;
	                                            _iteratorError2 = err;
	                                        } finally {
	                                            try {
	                                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                                    _iterator2.return();
	                                                }
	                                            } finally {
	                                                if (_didIteratorError2) {
	                                                    throw _iteratorError2;
	                                                }
	                                            }
	                                        }
	
	                                        data[i][j] = text.join(', ');
	                                    }
	                                } else {
	                                    data[i][j + '_fk'] = data[i][j];
	                                    data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                                }
	                            } else if (this.Util.toType(data[i][j]) == 'array') {
	                                data[i][j] = data[i][j][0];
	                            }
	                            if (this.mergeFields && typeof this.mergeFields[j] == 'function') {
	                                data[i][j] = this.mergeFields[j](data[i]);
	                            }
	                        }
	                    }
	                }
	                array.push(this.orderItem(data[i], this.fieldsData, i));
	            }
	            return array;
	        }
	    }, {
	        key: 'orderItem',
	        value: function orderItem(data, fields, pos) {
	            if (fields === undefined || fields.length === 0) {
	                return data;
	            }
	
	            var item = {};
	            for (var i in fields) {
	                var field = fields[i].key;
	                if (data[field] !== undefined || data[field + '_fk'] !== undefined) {
	                    if (this.editable) {
	                        if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	                            var date = data[field].split('-');
	                            this.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	                        } else {
	                            this.dataGrid[pos + '_' + field] = data[field];
	                        }
	                        item[field] = pos + '_' + field;
	                    } else {
	                        if (item[field + '_fk']) {
	                            item[field + '_fk'] = data[field];
	                        } else {
	                            item[field] = data[field];
	                        }
	                    }
	                }
	            }
	
	            return item;
	        }
	    }, {
	        key: 'add',
	        value: function add(item, editModalController, editModalTemplate) {
	            var _this4 = this;
	
	            if (typeof this.eventCreate == 'function') {
	                this.eventCreate();
	            } else {
	                var fields = null;
	                if (item) {
	                    fields = this.fieldsSave || this.fieldsUpdate || this.fieldsData;
	                } else {
	                    fields = this.fieldsSave || this.fieldsCreate || this.fieldsData;
	                }
	
	                var modalInstance = this.Modal.show({
	                    template: editModalTemplate || this.addModalTemplate || this.modalTemplate || _crudTableModal4.default,
	                    controller: editModalController || this.addModalController || this.modalController || _crudTableModal2.default,
	                    data: {
	                        fields: fields,
	                        url: this.url,
	                        title: this.ngTitle,
	                        idKey: this.idKey,
	                        item: item
	                    }
	                });
	
	                modalInstance.result.then(function (data) {
	                    if (data && data[_this4.idKey]) {
	                        _this4.Message.success();
	                        _this4.refresh();
	                    }
	                }, function (error) {
	                    _this4.$log.info('Modal dismissed at: ' + new Date(), error);
	                });
	            }
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            var _this5 = this;
	
	            if (typeof this.eventEdit == 'function') {
	                this.eventEdit(item);
	            } else {
	                if (this.data && this.data.list) {
	                    this.editItem = true;
	                    this.modelInline = angular.copy(this.filterById(item[this.idKey], this.data.list));
	                } else {
	                    this.DataService.get(this.url, item[this.idKey]).then(function (response) {
	                        response = response.datos;
	                        if (response) {
	                            _this5.add(response, _this5.editModalController, _this5.editModalTemplate);
	                        }
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'editCancel',
	        value: function editCancel() {
	            this.editItem = false;
	            this.modelInline = this.resetModel(this.modelInline);
	            this.data.list.map(function (e) {
	                delete e.edit;
	                return e;
	            });
	        }
	    }, {
	        key: 'deleteRow',
	        value: function deleteRow(item) {
	            var _this6 = this;
	
	            if (typeof this.eventDelete == 'function') {
	                this.eventDelete(item);
	            } else {
	                this.Modal.confirm('¿Desea eliminar este registro?', function () {
	                    if (_this6.data && _this6.data.list) {
	                        if (_this6.data.urlUpdate) {
	                            var list = angular.copy(_this6.data.list);
	                            list.map(function (e) {
	                                e = _this6.CrudTable.cleanData(e);
	                                return e;
	                            });
	
	                            var pos = _this6.getIdPosition(list, item);
	                            if (pos !== -1) {
	                                list.splice(pos, 1);
	                                _this6.DataService.put(_this6.data.urlUpdate, list).then(function (response) {
	                                    response = response.datos;
	                                    if (response) {
	                                        _this6.data.list = response;
	                                        _this6.refresh();
	                                        if (typeof _this6.callbackDelete == 'function') {
	                                            _this6.callbackDelete(_this6.data.list);
	                                        }
	                                    }
	                                });
	                            }
	                        } else {
	                            var _pos = _this6.getIdPosition(_this6.data.list, item);
	                            if (_pos !== -1) {
	                                _this6.data.list.splice(_pos, 1);
	                                _this6.refresh();
	                            }
	                        }
	                        _this6.inlineOptions = false;
	                        _this6.itemSelected = null;
	                    } else {
	                        _this6.DataService.delete(_this6.url, item[_this6.idKey]).then(function () {
	                            _this6.Message.success('Su registro fue eliminado correctamente.');
	                            _this6.refresh();
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            this.tableParams.filter({ 'crudtable_search_term': this.searchTerm });
	        }
	    }, {
	        key: 'cleanSearch',
	        value: function cleanSearch() {
	            this.searchTerm = '';
	            this.refresh();
	        }
	    }, {
	        key: 'getFieldClass',
	        value: function getFieldClass(row, col) {
	            if (this.clases && this.clases[col.field]) {
	                return this.clases[col.field](row, col);
	            } else {
	                return;
	            }
	        }
	    }, {
	        key: 'buttonEvent',
	        value: function buttonEvent(event, item, callback) {
	            if (typeof callback == 'function') {
	                callback(event, item);
	            }
	        }
	    }, {
	        key: 'buttonIf',
	        value: function buttonIf(event, item, callback) {
	            if (typeof callback == 'function') {
	                return callback(event, item);
	            } else {
	                return true;
	            }
	        }
	
	        // Form inline
	
	    }, {
	        key: 'saveFormInline',
	        value: function saveFormInline() {
	            var _this7 = this;
	
	            if (this.data && this.data.list && this.Util.toType(this.data.list) == 'array') {
	                if (this.formInline.$valid) {
	                    var data = this.modelInline;
	                    if (data[this.idKey] === undefined) {
	                        if (this.data.urlUpdate) {
	                            var list = angular.copy(this.data.list);
	                            list.map(function (e) {
	                                e = _this7.CrudTable.cleanData(e);
	                                return e;
	                            });
	                            list.push(data);
	                            this.DataService.put(this.data.urlUpdate, list).then(function (response) {
	                                response = response.datos;
	                                if (response) {
	                                    _this7.data.list = response;
	                                    _this7.modelInline = _this7.resetModel(_this7.modelInline);
	                                    _this7.formInline.$submitted = false;
	                                    _this7.Util.setTouchedForm(_this7.formInline, false);
	                                    _this7.refresh();
	                                    if (typeof _this7.callbackSave == 'function') {
	                                        _this7.callbackSave(_this7.data.list);
	                                    }
	                                }
	                            });
	                        } else {
	                            data[this.idKey] = this.Util.id();
	                            data.new = true;
	                            this.data.list.push(data);
	                            this.modelInline = this.resetModel(this.modelInline);
	                            this.formInline.$submitted = false;
	                            this.Util.setTouchedForm(this.formInline, false);
	                            this.refresh();
	                        }
	                    } else {
	                        delete data.edit;
	                        this.editItem = false;
	                        if (this.data.urlUpdate) {
	                            var _list = angular.copy(this.data.list);
	                            _list.map(function (e) {
	                                e = _this7.CrudTable.cleanData(e);
	                                return e;
	                            });
	                            this.setItem(_list, data);
	                            this.DataService.put(this.data.urlUpdate, _list).then(function (response) {
	                                response = response.datos;
	                                if (response) {
	                                    _this7.data.list = response;
	                                    _this7.modelInline = _this7.resetModel(_this7.modelInline);
	                                    _this7.formInline.$submitted = false;
	                                    _this7.Util.setTouchedForm(_this7.formInline, false);
	                                    _this7.refresh();
	                                    if (typeof _this7.callbackSave == 'function') {
	                                        _this7.callbackSave(_this7.data.list);
	                                    }
	                                }
	                            });
	                        } else {
	                            this.setItem(this.data.list, data);
	                            this.modelInline = this.resetModel(this.modelInline);
	                            this.formInline.$submitted = false;
	                            this.Util.setTouchedForm(this.formInline, false);
	                            this.refresh();
	                        }
	                        this.inlineOptions = false;
	                        this.itemSelected = null;
	                    }
	                    // this.$log.log('Lista:', this.data.list);
	                }
	            }
	        }
	    }, {
	        key: 'resetModel',
	        value: function resetModel(model) {
	            var obj = {};
	            for (var key in model) {
	                var formly = this.CrudTable.searchField(this.fieldsData, key);
	                if (formly && formly.defaultValue) {
	                    obj[key] = formly.defaultValue;
	                }
	            }
	            return obj;
	        }
	    }, {
	        key: 'getIdPosition',
	        value: function getIdPosition(list, item) {
	            for (var i in list) {
	                if (list[i][this.idKey] == item[this.idKey]) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }, {
	        key: 'setItem',
	        value: function setItem(list, item) {
	            for (var i in list) {
	                if (list[i][this.idKey] == item[this.idKey]) {
	                    list[i] = item;
	                    break;
	                }
	            }
	        }
	    }, {
	        key: 'filterById',
	        value: function filterById(id, list) {
	            for (var i in list) {
	                if (list[i][this.idKey] == id) {
	                    return this.CrudTable.cleanData(list[i]);
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'selectRow',
	        value: function selectRow(row, list) {
	            var _this8 = this;
	
	            list.map(function (e, i) {
	                if (row[_this8.idKey] != list[i][_this8.idKey]) {
	                    delete list[i].edit;
	                }
	            });
	            if (row.edit) {
	                row.edit = false;
	                this.inlineOptions = false;
	                this.itemSelected = null;
	            } else {
	                row.edit = true;
	                this.inlineOptions = true;
	                this.itemSelected = row;
	            }
	        }
	    }, {
	        key: 'actionChecks',
	        value: function actionChecks() {
	            if (this.checks.cbButton) {
	                this.checks.cbButton(this.tableParams.data);
	            }
	        }
	    }, {
	        key: 'selectAllChecks',
	        value: function selectAllChecks() {
	            var _this9 = this;
	
	            this.tableParams.data.forEach(function (it) {
	                it.checked = _this9.modelSelectAllCheks;
	                if (_this9.checks.if && !_this9.checks.if(it)) {
	                    delete it.checked;
	                }
	            });
	            // this.$log.log(this.data)
	            // this.$log.log(this.data.list)
	        }
	    }, {
	        key: 'selectCheck',
	        value: function selectCheck(event, row) {
	            var _this10 = this;
	
	            var c = 0,
	                ct = 0;
	            this.tableParams.data.forEach(function (it) {
	                c += it.checked ? 1 : 0;
	                ct++;
	                if (_this10.checks.if && !_this10.checks.if(it)) {
	                    ct--;
	                }
	            });
	            this.modelSelectAllCheks = c == ct;
	
	            if (this.checks.cbCheck) {
	                this.checks.cbCheck(event, row);
	            }
	        }
	    }, {
	        key: 'checkIf',
	        value: function checkIf(row) {
	            if (this.checks.if) {
	                return this.checks.if(row);
	            } else {
	                return true;
	            }
	        }
	    }]);
	
	    return CrudTableController;
	}();
	
	exports.default = CrudTableController;

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrudTableModalController = function () {
	    CrudTableModalController.$inject = ["$scope", "$uibModalInstance", "data", "DataService", "$log"];
	    function CrudTableModalController($scope, $uibModalInstance, data, DataService, $log) {
	        'ngInject';
	
	        _classCallCheck(this, CrudTableModalController);
	
	        this.fields = data.fields;
	        this.url = data.url;
	        this.title = data.title;
	        this.idKey = data.idKey;
	        this.DataService = DataService;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$log = $log;
	
	        if (data.item) {
	            this.model = data.item;
	        }
	    }
	
	    _createClass(CrudTableModalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.options = {
	                formState: {}
	            };
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this = this;
	
	            if (this.model[this.idKey]) {
	                this.model.id = this.model[this.idKey];
	            }
	            this.DataService.save(this.url, this.model).then(function (response) {
	                if (response) {
	                    _this.$uibModalInstance.close(response);
	                }
	            });
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$uibModalInstance.dismiss('cancel');
	        }
	    }]);
	
	    return CrudTableModalController;
	}();
	
	exports.default = CrudTableModalController;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _crudTable = __webpack_require__(284);
	
	var _crudTable2 = _interopRequireDefault(_crudTable);
	
	var _crudTable3 = __webpack_require__(288);
	
	var _crudTable4 = _interopRequireDefault(_crudTable3);
	
	__webpack_require__(170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CrudTableModule = angular.module('app.crud-table', []).service('CrudTable', _crudTable4.default).component('crudTable', _crudTable2.default).name;
	
	exports.default = CrudTableModule;

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	'use strict';
	'use-strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrudTableService = function () {
	    CrudTableService.$inject = ["Datetime"];
	    function CrudTableService(Datetime) {
	        'ngInject';
	
	        _classCallCheck(this, CrudTableService);
	
	        this.Datetime = Datetime;
	    }
	
	    _createClass(CrudTableService, [{
	        key: 'filterFields',
	        value: function filterFields(data, fields) {
	            if (typeof fields == 'undefined' || fields.length === 0) {
	                return data;
	            }
	            var filter = [];
	            for (var i in fields) {
	                var field = this.searchField(data, fields[i]);
	                if (field) {
	                    filter.push(field);
	                }
	            }
	            return filter;
	        }
	    }, {
	        key: 'searchField',
	        value: function searchField(fields, field) {
	            for (var i in fields) {
	                if (fields[i].key == field) {
	                    return fields[i];
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'searchFieldData',
	        value: function searchFieldData(fields, field) {
	            for (var i in fields) {
	                if (fields[i].key == field) {
	                    return fields[i].value;
	                }
	            }
	            return field;
	        }
	    }, {
	        key: 'addPropertiesFormly',
	        value: function addPropertiesFormly(data, formly) {
	            if (typeof formly == 'undefined' || formly.length === 0) {
	                return data;
	            }
	            for (var i in data) {
	                var field = this.searchField(formly, data[i].key);
	                if (field) {
	                    data[i] = angular.merge({}, data[i], field);
	                }
	            }
	            return data;
	        }
	    }, {
	        key: 'parseSave',
	        value: function parseSave(data, formly) {
	
	            var item = {};
	            for (var i in data) {
	                if (this.toType(data[i]) == 'date') {
	                    item[i] = this.Datetime.format(data[i], 'YYYY-MM-dd');
	                } else {
	                    if (typeof data[i] == 'string' && (data[i] == 'true' || data[i] == 'false')) {
	                        item[i] = item[i] == 'true';
	                    } else {
	                        item[i] = data[i];
	                    }
	                }
	            }
	            item.id = this.getId(item, formly);
	            return item;
	        }
	    }, {
	        key: 'getId',
	        value: function getId(formly, item) {
	            for (var i in formly) {
	                if (formly[i].templateOptions.label && formly[i].templateOptions.label == 'ID') {
	                    if (item) {
	                        return item[formly[i].key];
	                    } else {
	                        return formly[i].key;
	                    }
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getFkData',
	        value: function getFkData(fieldsData, key, value) {
	            fieldsData.filter(function (e) {
	                if (e.key == key && e.templateOptions.options) {
	                    e.templateOptions.options.filter(function (elem) {
	                        if (elem.value == value) {
	                            value = elem.name;
	                        }
	                    });
	                }
	            });
	            return value;
	        }
	    }, {
	        key: 'filterItem',
	        value: function filterItem(data) {
	            for (var i in data) {
	                if (typeof data[i] == 'string') {
	                    if (this.Datetime.isDate(new Date(data[i]))) {
	                        data[i] = new Date(data[i]);
	                    } else if (!/[a-zA-Z]+/g.test(data[i]) && /^-?[0-9.]+\:?[0-9]+\:?[0-9]*$/g.test(data[i]) && data[i].length == 8) {
	                        // data[i] = formatTime(data[i]);
	                    }
	                }
	            }
	            return data;
	        }
	    }, {
	        key: 'lengthOptions',
	        value: function lengthOptions(data, key) {
	            for (var i in data) {
	                if (data[i].key == key && data[i].templateOptions && data[i].templateOptions.options) {
	                    return data[i].templateOptions.options.length;
	                }
	            }
	            return 0;
	        }
	    }, {
	        key: 'cleanData',
	        value: function cleanData(item) {
	            for (var key in item) {
	                if (item[key + '_fk']) {
	                    item[key] = item[key + '_fk'];
	                    delete item[key + '_fk'];
	                }
	                if (item[key] == 'boolean_true') {
	                    item[key] = true;
	                } else if (item[key] == 'boolean_false') {
	                    item[key] = false;
	                } else {
	                    item[key] = this.Datetime.toDate(item[key]);
	                }
	            }
	            return item;
	        }
	    }]);
	
	    return CrudTableService;
	}();
	
	exports.default = CrudTableService;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _archivo = __webpack_require__(290);
	
	var _archivo2 = _interopRequireDefault(_archivo);
	
	var _archivo3 = __webpack_require__(697);
	
	var _archivo4 = _interopRequireDefault(_archivo3);
	
	__webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArchivoComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    types: '@',
	    mimeTypes: '@',
	    maxsize: '@',
	    modoVista: '<?',
	    url: '@',
	    urlDescarga: '@',
	    apiUrl: '@',
	    ver: '<',
	    descargar: '<'
	  },
	  controller: _archivo2.default,
	  template: _archivo4.default
	};
	
	exports.default = ArchivoComponent;

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArchivoController = function () {
	  ArchivoController.$inject = ["Modal", "apiUrl", "$scope"];
	  function ArchivoController(Modal, apiUrl, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, ArchivoController);
	
	    this.Modal = Modal;
	    this.api = apiUrl;
	    this.$scope = $scope;
	  }
	
	  _createClass(ArchivoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.ver = angular.isUndefined(this.ver) ? true : this.ver;
	      this.descargar = angular.isUndefined(this.descargar) ? true : this.descargar;
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.urlDescarga', function () {
	        if (_this.urlDescarga) {
	          _this.urlDescargaDocumento = angular.isUndefined(_this.apiUrl) ? '' + _this.api + _this.urlDescarga : '' + _this.apiUrl + _this.urlDescarga;
	        }
	      });
	    }
	  }, {
	    key: 'mostrarArchivo',
	    value: function mostrarArchivo() {
	      return !this.modoVista && _typeof(this.ngModel) !== 'object' && !angular.isUndefined(this.ngModel);
	    }
	  }, {
	    key: 'vistaPrevia',
	    value: function vistaPrevia() {
	      this.Modal.showDocumentBase64(this.url, this.label);
	    }
	  }]);
	
	  return ArchivoController;
	}();
	
	exports.default = ArchivoController;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _documentoIdentidad = __webpack_require__(292);
	
	var _documentoIdentidad2 = _interopRequireDefault(_documentoIdentidad);
	
	var _documentoIdentidad3 = __webpack_require__(698);
	
	var _documentoIdentidad4 = _interopRequireDefault(_documentoIdentidad3);
	
	__webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var documentoIdentidadComponent = {
	    bindings: {
	        ngModel: '=',
	        onlyCi: '<?',
	        ngId: '@?',
	        conf: '<',
	        url: '<',
	        callbackSearch: '&',
	        edadMaxima: '=?',
	        edadMinima: '=?',
	        modoVista: '<?'
	    },
	    controller: _documentoIdentidad2.default,
	    template: _documentoIdentidad4.default
	};
	
	exports.default = documentoIdentidadComponent;

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DocumentoIdentidadController = function () {
	  DocumentoIdentidadController.$inject = ["$scope", "DataService", "Datetime", "Message", "$log"];
	  function DocumentoIdentidadController($scope, DataService, Datetime, Message, $log) {
	    'ngInject';
	
	    _classCallCheck(this, DocumentoIdentidadController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.Message = Message;
	    this.$log = $log;
	  }
	
	  _createClass(DocumentoIdentidadController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.tiposPersona = [{ nombre: 'Nacional', valor: '1' }, { nombre: 'Extranjero', valor: '2' }];
	      this.tipoDocumento = 'Contrastación';
	      this.ngModel.tipo_persona = '1';
	      // envio de parametro para no verificar con segig
	      setTimeout(function () {
	        // console.log('seguimiento controller', this.proyecto)
	        _this.ngModel.noVerificar = true;
	      }, 1000);
	      this.establecerRangoValido();
	      this.initDefault('tipo_documento', 'TD_PASS');
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.ngModel', function () {
	        if (_this2.ngModel) {
	          _this2.cargando_valores = true;
	          if (!_this2.ngModel.tipo_persona) {
	            _this2.ngModel.tipo_persona = '1';
	          }
	          return;
	        }
	        if (!_this2.ngModel) {
	          _this2.ngModel = {};
	        }
	        _this2.initDefault('tipo_documento', 'TD_PASS');
	      }, true);
	    }
	  }, {
	    key: 'initDefault',
	    value: function initDefault(key, val) {
	      if (!this.ngModel[key]) {
	        this.ngModel[key] = val;
	      }
	    }
	  }, {
	    key: 'establecerRangoValido',
	    value: function establecerRangoValido() {
	      if (this.edadMinima) {
	        this.maxDate = this.Datetime.lessYearsToDate(this.edadMinima);
	      }
	      if (this.edadMaxima) {
	        this.minDate = this.Datetime.lessYearsToDate(this.edadMaxima);
	      }
	    }
	  }, {
	    key: 'isCI',
	    value: function isCI() {
	      if (angular.isUndefined(this.ngModel)) {
	        return;
	      }
	      if (angular.isUndefined(this.ngModel.tipo_documento)) {
	        return;
	      }
	      return this.ngModel.tipo_documento === 'TD_CI';
	    }
	  }, {
	    key: 'isFill',
	    value: function isFill() {
	      if (angular.isUndefined(this.ngModel)) {
	        return;
	      }
	      return this.ngModel.estado == 'ACTIVO';
	      // return this.ngModel.nombres && this.ngModel.primer_apellido && this.ngModel.tipo_documento==='TD_CI';
	    }
	  }, {
	    key: 'changeType',
	    value: function changeType() {
	      if (!this.cargando_valores) {
	        this.nombreDel();
	      }
	      this.cargando_valores = false;
	    }
	  }, {
	    key: 'nombreDel',
	    value: function nombreDel() {
	      delete this.ngModel.nombres;
	      delete this.ngModel.primer_apellido;
	      delete this.ngModel.segundo_apellido;
	      delete this.ngModel.id_persona;
	      delete this.ngModel.estado;
	      delete this.ngModel.complemento;
	      delete this.ngModel.complemento_visible;
	      delete this.ngModel.telefono;
	      delete this.ngModel.correo;
	      delete this.ngModel.fecha_nacimiento;
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled() {
	      if (angular.isUndefined(this.ngModel)) {
	        return;
	      }
	      // revisar esta parte porque se ejecuta varias veces esta funcion
	      return angular.isUndefined(this.ngModel.numero_documento);
	    }
	  }, {
	    key: 'search',
	    value: function search() {
	      var _this3 = this;
	
	      var ci = void 0,
	          datos = void 0;
	      if (this.ngModel.numero_documento.indexOf('-') !== -1) {
	        datos = this.ngModel.numero_documento.split('-');
	        ci = datos[0];
	      } else {
	        ci = this.ngModel.numero_documento;
	      }
	
	      var url = 'personas/' + ci + '/' + this.ngModel.fecha_nacimiento;
	      if (this.ngModel.complemento) {
	        url += '?complemento=' + this.ngModel.complemento;
	      }
	      this.DataService.get(url).then(function (response) {
	        _this3.$log.log(response);
	        _this3.nombreDel();
	        if (response) {
	          _this3.ngModel.primer_apellido = response.datos.primer_apellido;
	          _this3.ngModel.segundo_apellido = response.datos.segundo_apellido;
	          _this3.ngModel.nombres = response.datos.nombres;
	          _this3.ngModel.id_persona = response.datos.id_persona;
	          delete _this3.ngModel.telefono;if (response.datos.telefono) {
	            _this3.ngModel.telefono = response.datos.telefono;
	          }
	          _this3.ngModel.correo = response.datos.correo;
	
	          if (typeof _this3.callbackSearch == 'function') {
	            _this3.callbackSearch({ data: _this3.ngModel });
	          }
	          if (response.finalizado) {
	            _this3.ngModel.estado = 'ACTIVO';
	          }
	        }
	      });
	    }
	  }, {
	    key: 'buscarPersona',
	    value: function buscarPersona() {
	      var _this4 = this;
	
	      this.DataService.get('personas/buscarLocal/?ci=' + this.ngModel.numero_documento)
	      // this.$log.log("fecha nacimiento : ", this.ngModel.fecha_nacimiento)
	      .then(function (response) {
	        if (response && response.datos) {
	          _this4.ngModel.primer_apellido = response.datos.primer_apellido;
	          _this4.ngModel.segundo_apellido = response.datos.segundo_apellido;
	          _this4.ngModel.fecha_nacimiento = response.datos.fecha_nacimiento; //tipo string
	          _this4.ngModel.nombres = response.datos.nombres;
	          delete _this4.ngModel.telefono;if (response.datos.telefono) {
	            _this4.ngModel.telefono = response.datos.telefono;
	          }
	          _this4.ngModel.correo = response.datos.correo;
	        } else {
	          delete _this4.ngModel.primer_apellido;
	          delete _this4.ngModel.segundo_apellido;
	          delete _this4.ngModel.fecha_nacimiento; // no entiendo porque no se borra el valor fechanacimiento
	          delete _this4.ngModel.nombres;
	          delete _this4.ngModel.telefono;
	          delete _this4.ngModel.correo;
	          // this.nombreDel();
	        }
	      });
	    }
	  }, {
	    key: 'contrastar',
	    value: function contrastar() {
	      var _this5 = this;
	
	      var campo = {
	        ci: this.ngModel.numero_documento,
	        complemento: this.ngModel.complemento,
	        nombres: this.ngModel.nombres,
	        primer_apellido: this.ngModel.primer_apellido,
	        segundo_apellido: this.ngModel.segundo_apellido,
	        fecha: this.ngModel.fecha_nacimiento
	
	        // this.DataService.get(`personas/${ci}/${this.ngModel.fecha_nacimiento}?tipo=${1}&campo=${JSON.stringify(campo)}`)
	        // Enviar datos al backend
	      };this.DataService.get('personas/contrastacion/?tipo=' + this.ngModel.tipo_persona + '&campo=' + JSON.stringify(campo)).then(function (response) {
	        _this5.$log.log(response);
	        // this.nombreDel();
	        if (response) {
	          _this5.ngModel.primer_apellido = response.datos.primer_apellido;
	          _this5.ngModel.segundo_apellido = response.datos.segundo_apellido;
	          _this5.ngModel.nombres = response.datos.nombres;
	          _this5.ngModel.id_persona = response.datos.id_persona;
	          delete _this5.ngModel.telefono;if (response.datos.telefono) {
	            _this5.ngModel.telefono = response.datos.telefono;
	          }
	          _this5.ngModel.correo = response.datos.correo;
	
	          if (typeof _this5.callbackSearch == 'function') {
	            _this5.callbackSearch({ data: _this5.ngModel });
	          }
	          if (response.finalizado) {
	            _this5.ngModel.estado = 'ACTIVO';
	          }
	        }
	      });
	    }
	  }]);
	
	  return DocumentoIdentidadController;
	}();
	
	exports.default = DocumentoIdentidadController;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fileUpload = __webpack_require__(294);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _fileUpload3 = __webpack_require__(699);
	
	var _fileUpload4 = _interopRequireDefault(_fileUpload3);
	
	__webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileUploadComponent = {
	    bindings: {
	        onCompleteItem: '=',
	        onCompleteAll: '=',
	        onAfterAddingFile: '=',
	        onBeforeUploadItem: '=',
	        label: '@',
	        textUpload: '@',
	        multiple: '@',
	        types: '@',
	        name: '@',
	        url: '=',
	        form: '<',
	        data: '='
	    },
	    controller: _fileUpload2.default,
	    template: _fileUpload4.default
	};
	
	exports.default = FileUploadComponent;

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdFileUploadController = function () {
	    MdFileUploadController.$inject = ["$scope", "FileUploader", "Message", "Util", "Loading", "Storage", "Auth", "baseUrl", "$log"];
	    function MdFileUploadController($scope, FileUploader, Message, Util, Loading, Storage, Auth, baseUrl, $log) {
	        'ngInject';
	
	        _classCallCheck(this, MdFileUploadController);
	
	        this.FileUploader = FileUploader;
	        this.Message = Message;
	        this.Util = Util;
	        this.baseUrl = baseUrl;
	        this.Loading = Loading;
	        this.Storage = Storage;
	        this.Auth = Auth;
	        this.$log = $log;
	        this.$scope = $scope;
	
	        this.charset = {
	            'xlsx': ['vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.openxmlformats'],
	            'xls': 'vnd.ms-excel',
	            'ods': 'x-vnd.oasis.opendocument.spreadsheet',
	            'rar': 'x-rar',
	            'pdf': 'pdf',
	            'csv': ['csv', 'vnd.ms-excel'],
	            'plain': 'plain',
	            'jpg': 'jpg',
	            'png': 'png',
	            'jpeg': 'jpeg',
	            'bmp': 'bmp',
	            'gif': 'gif'
	        };
	    }
	
	    _createClass(MdFileUploadController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.idFile = 'file-' + this.Util.id();
	            var log = this.$log;
	
	            var uploader = this.$scope.uploader = new this.FileUploader({
	                url: this.url,
	                alias: this.name || 'file',
	                formData: this.form || []
	            });
	
	            // FILTERS
	
	            uploader.filters.push({
	                name: 'customFilter',
	                fn: function fn() /*item, {File|FileLikeObject}, options*/{
	                    return this.queue.length < 10;
	                }
	            });
	
	            if (this.types) {
	                uploader.filters.push({
	                    name: 'typesFilter',
	                    fn: function fn(item) {
	                        var valid = _this.isType(item, _this.types);
	                        if (!valid) {
	                            _this.Message.warning('Los formatos permitidos son: <strong>' + _this.types.replace(/^\|+|\|+$/gm, '').replace(/\|/, ', ') + '</strong>.', 'Formato de archivo inválido');
	                        }
	                        return valid;
	                    }
	                });
	            }
	
	            this.$log.log('Token', this.Storage.get('token'));
	            uploader.headers.Authorization = 'Bearer ' + this.Storage.get('token');
	
	            // CALLBACKS
	
	            uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
	                log.info('onWhenAddingFileFailed', item, filter, options);
	            };
	            uploader.onAfterAddingFile = function (fileItem) {
	                if (typeof _this.multiple == 'undefined' && uploader.queue.length > 1) {
	                    uploader.queue = uploader.queue.splice(1);
	                }
	                if (_this.onAfterAddingFile) {
	                    _this.onAfterAddingFile(fileItem);
	                }
	                log.info('onAfterAddingFile', fileItem);
	            };
	            uploader.onAfterAddingAll = function (addedFileItems) {
	                log.info('onAfterAddingAll', addedFileItems);
	            };
	            uploader.onBeforeUploadItem = function (item) {
	                if (_this.onBeforeUploadItem) {
	                    _this.onBeforeUploadItem(item);
	                }
	                for (var i in _this.form) {
	                    if (isNaN(i)) {
	                        var data = {};
	                        data[i] = _this.form[i];
	                        item.formData.push(data);
	                    }
	                }
	                log.info('onBeforeUploadItem', item);
	            };
	            uploader.onProgressItem = function (fileItem, progress) {
	                log.info('onProgressItem', fileItem, progress);
	            };
	            uploader.onProgressAll = function (progress) {
	                log.info('onProgressAll', progress);
	            };
	            uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                log.info('onSuccessItem', fileItem, response, status, headers);
	            };
	            uploader.onErrorItem = function (fileItem, response, status, headers) {
	                log.info('onErrorItem', fileItem, response, status, headers);
	            };
	            uploader.onCancelItem = function (fileItem, response, status, headers) {
	                log.info('onCancelItem', fileItem, response, status, headers);
	            };
	            uploader.onCompleteItem = function (fileItem, response, status, headers) {
	                if (_this.onCompleteItem) {
	                    _this.onCompleteItem(fileItem, response, status, headers, _this.reset);
	                }
	                log.info('onCompleteItem', fileItem, response, status, headers);
	            };
	            uploader.onCompleteAll = function () {
	                if (_this.onCompleteAll) {
	                    _this.onCompleteAll(_this.reset);
	                }
	                log.info('onCompleteAll');
	            };
	        }
	    }, {
	        key: 'isType',
	        value: function isType(item, types) {
	            var type = item.type.slice(item.type.lastIndexOf('/') + 1);
	            var extension = null;
	            if (item.name) {
	                extension = item.name.split('.');
	                extension = extension[extension.length - 1];
	
	                // Hack para firefox que carga un csv con charset text/plain
	                if ((type == 'plain' || type == 'download') && extension == 'csv') {
	                    return true;
	                }
	            }
	
	            for (var i in this.charset) {
	                if (this.Util.toType(this.charset[i]) == 'array') {
	                    var subtypes = this.charset[i];
	                    for (var j in subtypes) {
	                        if (types.indexOf(i) != -1 && type == subtypes[j]) {
	                            return true;
	                        }
	                    }
	                } else {
	                    if (types.indexOf(i) != -1 && type == this.charset[i]) {
	                        return true;
	                    }
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'isImage',
	        value: function isImage(item) {
	            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	    }]);
	
	    return MdFileUploadController;
	}();
	
	exports.default = MdFileUploadController;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fileUpload = __webpack_require__(293);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.fileUpload.component', []).component('uiFileUpload', _fileUpload2.default).directive('ngThumb', ['$window', function ($window) {
	    var helper = {
	        support: !!($window.FileReader && $window.CanvasRenderingContext2D),
	        isFile: function isFile(item) {
	            return angular.isObject(item) && item instanceof $window.File;
	        },
	        isImage: function isImage(file) {
	            var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	    };
	
	    return {
	        restrict: 'A',
	        template: '<canvas/>',
	        link: function link(scope, element, attributes) {
	            if (!helper.support) return;
	
	            var params = scope.$eval(attributes.ngThumb);
	
	            if (!helper.isFile(params.file)) return;
	            if (!helper.isImage(params.file)) return;
	
	            var canvas = element.find('canvas');
	            var reader = new window.FileReader();
	
	            reader.onload = onLoadFile;
	            reader.readAsDataURL(params.file);
	
	            function onLoadFile(event) {
	                var img = new window.Image();
	                img.onload = onLoadImage;
	                img.src = event.target.result;
	            }
	
	            function onLoadImage() {
	                var width = params.width || this.width / this.height * params.height;
	                var height = params.height || this.height / this.width * params.width;
	                canvas.attr({ width: width, height: height });
	                canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
	            }
	        }
	    };
	}]).name;
	
	exports.default = Components;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectDate = __webpack_require__(300);
	
	var _selectDate2 = _interopRequireDefault(_selectDate);
	
	var _selectMunicipio = __webpack_require__(302);
	
	var _selectMunicipio2 = _interopRequireDefault(_selectMunicipio);
	
	var _documentoIdentidad = __webpack_require__(291);
	
	var _documentoIdentidad2 = _interopRequireDefault(_documentoIdentidad);
	
	var _selectParametro = __webpack_require__(304);
	
	var _selectParametro2 = _interopRequireDefault(_selectParametro);
	
	var _uibSelect = __webpack_require__(306);
	
	var _uibSelect2 = _interopRequireDefault(_uibSelect);
	
	var _fileUpload = __webpack_require__(295);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _inputFile = __webpack_require__(299);
	
	var _inputFile2 = _interopRequireDefault(_inputFile);
	
	var _archivo = __webpack_require__(289);
	
	var _archivo2 = _interopRequireDefault(_archivo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialModule = angular.module('app.forms', [_fileUpload2.default, _inputFile2.default]).component('selectDate', _selectDate2.default).component('selectMunicipio', _selectMunicipio2.default).component('documentoIdentidad', _documentoIdentidad2.default).component('selectParametro', _selectParametro2.default).component('uibSelect', _uibSelect2.default).component('archivo', _archivo2.default)
	// .component
	.directive('apError', function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      $element.addClass('form-error');
	      var $parent = angular.element($element.closest('div.form-group'));
	      $scope.$watch(function () {
	        return $element[0].scrollHeight;
	      }, function (newValue) {
	        // $log.log(newValue);
	        $parent.removeClass('has-danger');
	        if (newValue) {
	          $parent.addClass('has-danger');
	        }
	      });
	      $scope.$on('$destroy', function () {
	        $parent.removeClass('has-danger');
	      });
	    }
	  };
	}).name;
	
	exports.default = MaterialModule;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inputFile = __webpack_require__(298);
	
	var _inputFile2 = _interopRequireDefault(_inputFile);
	
	var _inputFile3 = __webpack_require__(700);
	
	var _inputFile4 = _interopRequireDefault(_inputFile3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputFileComponent = {
	    bindings: {
	        onCompleteItem: '=',
	        onCompleteAll: '=',
	        onAfterAddingFile: '=',
	        onBeforeUploadItem: '=',
	        label: '@',
	        labelSubir: '@',
	        textUpload: '@',
	        multiple: '@',
	        maxfiles: '@',
	        types: '@',
	        mimeTypes: '@',
	        name: '@',
	        url: '=',
	        uploadCallback: '<',
	        form: '<',
	        data: '=',
	        maxsize: '@',
	        fileBase64: '=',
	        fileSelect: '='
	    },
	    controller: _inputFile2.default,
	    template: _inputFile4.default
	};
	
	exports.default = InputFileComponent;

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdFileUploadController = function () {
	    MdFileUploadController.$inject = ["$scope", "FileUploader", "Message", "Util", "Loading", "Storage", "Auth", "baseUrl"];
	    function MdFileUploadController($scope, FileUploader, Message, Util, Loading, Storage, Auth, baseUrl) {
	        'ngInject';
	
	        _classCallCheck(this, MdFileUploadController);
	
	        this.FileUploader = FileUploader;
	        this.Message = Message;
	        this.Util = Util;
	        this.baseUrl = baseUrl;
	        this.Loading = Loading;
	        this.Storage = Storage;
	        this.Auth = Auth;
	        this.$scope = $scope;
	
	        this.charset = {
	            'xlsx': ['vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.openxmlformats'],
	            'xls': 'vnd.ms-excel',
	            'ods': ['x-vnd.oasis.opendocument.spreadsheet', 'vnd.oasis.opendocument.spreadsheet'],
	            'rar': 'x-rar',
	            'pdf': 'pdf',
	            'csv': ['csv', 'vnd.ms-excel'],
	            'plain': 'plain',
	            'jpg': 'jpg',
	            'png': 'png',
	            'jpeg': 'jpeg',
	            'bmp': 'bmp',
	            'gif': 'gif'
	        };
	    }
	
	    _createClass(MdFileUploadController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            // Flag para verificar si se ha seleccionado o no algún archivo (útil para casos donde se adjunta un archivo)
	            if (!angular.isUndefined(this.fileSelect)) this.fileSelect = false;
	
	            this.idFile = 'file-' + this.Util.id();
	
	            var uploader = this.$scope.uploader = new this.FileUploader({
	                url: this.url,
	                alias: this.name || 'file',
	                formData: this.form || []
	            });
	
	            // FILTERS
	
	            uploader.filters.push({
	                name: 'customFilter',
	                fn: function fn() /*item, {File|FileLikeObject}, options*/{
	                    return this.queue.length < 10;
	                }
	            });
	
	            if (this.types) {
	                uploader.filters.push({
	                    name: 'typesFilter',
	                    fn: function fn(item) {
	                        var valid = _this.isType(item, _this.types);
	                        if (!valid) {
	                            _this.Message.warning(_this.getTypes().message, 'Formato de archivo inválido');
	                        }
	                        return valid;
	                    }
	                });
	            }
	
	            uploader.headers.Authorization = 'Bearer ' + this.Storage.get('token');
	
	            if (this.maxsize) {
	                if (this.maxsize.indexOf('MB') >= 0) {
	                    var s = parseFloat(this.maxsize.replace('MB'));
	                    this.$$maxsize = s ? s * 1024 * 1024 : 20971520;
	                } else if (this.maxsize.indexOf('KB') >= 0) {
	                    var _s = parseFloat(this.maxsize.replace('KB'));
	                    this.$$maxsize = _s ? _s * 1024 : 20971520;
	                }
	                // this.$$maxsize = parseFloat(this.$$maxsize)? parseFloat(this.$$maxsize): parseFloat(this.maxsize)? parseFloat(this.maxsize): 20971520;
	            }
	            // CALLBACKS
	            // uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
	            //     log.info('onWhenAddingFileFailed', item, filter, options);
	            // };
	            uploader.onAfterAddingFile = function (fileItem) {
	                if (_this.multiple) {
	                    _this.fileBase64 = [];
	                }
	                if (typeof _this.multiple == 'undefined' && uploader.queue.length > 1) {
	                    uploader.queue = uploader.queue.splice(1);
	                }
	                if (_this.onAfterAddingFile) {
	                    _this.onAfterAddingFile(fileItem);
	                }
	                if (_this.$$maxsize && fileItem._file.size > _this.$$maxsize) {
	                    fileItem.remove();
	                    _this.Message.warning('El tamaño del archivo excede al máximo permitido.');
	                    return;
	                }
	                if (!angular.isUndefined(_this.fileSelect)) _this.fileSelect = true;
	                // Convertir archivo a base64
	                var reader = new FileReader();
	                reader.onload = function (loadEvent) {
	                    if (_this.multiple && _this.fileBase64 && _this.fileBase64.length < _this.maxfiles || !_this.multiple) {
	                        // this.$log.log('After11111',this.fileBase64.length, this.maxfiles);
	                        var file = {
	                            nombre: fileItem._file.name,
	                            path: fileItem._file.name,
	                            size: fileItem._file.size,
	                            tipo: fileItem._file.type,
	                            base64: loadEvent.target.result.split(',')[1]
	                        };
	                        if (_this.multiple) {
	                            _this.fileBase64.push(file);
	                        } else {
	                            _this.fileBase64 = file;
	                        }
	                    } else {
	                        fileItem.remove();
	                    }
	                    _this.$scope.$apply();
	                };
	                reader.readAsDataURL(fileItem._file);
	                // log.info('onAfterAddingFile', fileItem);
	            };
	            // uploader.onAfterAddingAll = function(addedFileItems) {
	            //     log.info('onAfterAddingAll', addedFileItems);
	            // };
	            uploader.onBeforeUploadItem = function (item) {
	                if (_this.onBeforeUploadItem) {
	                    _this.onBeforeUploadItem(item);
	                }
	                for (var i in _this.form) {
	                    if (isNaN(i)) {
	                        var data = {};
	                        data[i] = _this.form[i];
	                        item.formData.push(data);
	                    }
	                }
	                // log.info('onBeforeUploadItem', item);
	            };
	            // uploader.onProgressItem = function(fileItem, progress) {
	            //     log.info('onProgressItem', fileItem, progress);
	            // };
	            // uploader.onProgressAll = function(progress) {
	            //     log.info('onProgressAll', progress);
	            // };
	            // uploader.onSuccessItem = function(fileItem, response, status, headers) {
	            //     log.info('onSuccessItem', fileItem, response, status, headers);
	            // };
	            // uploader.onErrorItem = function(fileItem, response, status, headers) {
	            //     log.info('onErrorItem', fileItem, response, status, headers);
	            // };
	            // uploader.onCancelItem = function(fileItem, response, status, headers) {
	            //     log.info('onCancelItem', fileItem, response, status, headers);
	            // };
	            uploader.onCompleteItem = function (fileItem, response, status, headers) {
	                if (_this.onCompleteItem) {
	                    _this.onCompleteItem(fileItem, response, status, headers, _this.reset);
	                }
	                // log.info('onCompleteItem', fileItem, response, status, headers);
	            };
	            uploader.onCompleteAll = function () {
	                if (_this.onCompleteAll) {
	                    _this.onCompleteAll(_this.reset);
	                }
	                // log.info('onCompleteAll');
	            };
	        }
	    }, {
	        key: 'getTypes',
	        value: function getTypes() {
	            var types = this.Util.limpiarEspaciosDobles(this.types).split('|');
	            return {
	                types: types,
	                message: types.length > 1 ? 'Los formatos permitidos son: <strong>' + types.join(', ') + '</strong>' : 'El formato permitido es: <strong>' + types.join(', ') + '</strong>'
	            };
	        }
	    }, {
	        key: 'isType',
	        value: function isType(item, types) {
	            var type = item.type.slice(item.type.lastIndexOf('/') + 1);
	            var extension = null;
	            if (item.name) {
	                extension = item.name.split('.');
	                extension = extension[extension.length - 1];
	
	                // Hack para firefox que carga un csv con charset text/plain
	                if ((type == 'plain' || type == 'download') && extension == 'csv') {
	                    return true;
	                }
	            }
	
	            for (var i in this.charset) {
	                if (this.Util.toType(this.charset[i]) == 'array') {
	                    var subtypes = this.charset[i];
	                    for (var j in subtypes) {
	                        if (types.indexOf(i) != -1 && type == subtypes[j]) {
	                            return true;
	                        }
	                    }
	                } else {
	                    if (types.indexOf(i) != -1 && type == this.charset[i]) {
	                        return true;
	                    }
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'isImage',
	        value: function isImage(item) {
	            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	
	        // Mis modificaciones
	
	    }, {
	        key: 'clearQueue',
	        value: function clearQueue(uploader) {
	            this.fileBase64 = this.multiple ? [] : null;
	            uploader.clearQueue();
	        }
	    }, {
	        key: 'remove',
	        value: function remove(item) {
	            if (!this.multiple) {
	                this.fileBase64 = null;
	                item.remove();
	                return;
	            }
	            var cant = this.fileBase64.length;
	            for (var i = 0; i < cant; i++) {
	                var file = this.fileBase64.shift();
	                if (file.size != item._file.size && file.name != item._file.name) {
	                    this.fileBase64.push(file);
	                }
	            }
	            if (!angular.isUndefined(this.fileSelect)) this.fileSelect = false;
	            item.remove();
	        }
	    }, {
	        key: 'upload',
	        value: function upload() {
	            if (!this.multiple) {
	                this.fileBase64.name = this.name;
	                this.uploadCallback(this.fileBase64);
	            }
	        }
	    }]);
	
	    return MdFileUploadController;
	}();
	
	exports.default = MdFileUploadController;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inputFile = __webpack_require__(297);
	
	var _inputFile2 = _interopRequireDefault(_inputFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.fileUploadInfo.component', []).component('uiInputFile', _inputFile2.default).directive('ngThumbInfo', ['$window', function ($window) {
	    var helper = {
	        support: !!($window.FileReader && $window.CanvasRenderingContext2D),
	        isFile: function isFile(item) {
	            return angular.isObject(item) && item instanceof $window.File;
	        },
	        isImage: function isImage(file) {
	            var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	    };
	
	    return {
	        restrict: 'A',
	        template: '<canvas/>',
	        link: function link(scope, element, attributes) {
	            if (!helper.support) return;
	
	            var params = scope.$eval(attributes.ngThumb);
	
	            if (!helper.isFile(params.file)) return;
	            if (!helper.isImage(params.file)) return;
	
	            var canvas = element.find('canvas');
	            var reader = new window.FileReader();
	
	            reader.onload = onLoadFile;
	            reader.readAsDataURL(params.file);
	
	            function onLoadFile(event) {
	                var img = new window.Image();
	                img.onload = onLoadImage;
	                img.src = event.target.result;
	            }
	
	            function onLoadImage() {
	                var width = params.width || this.width / this.height * params.height;
	                var height = params.height || this.height / this.width * params.width;
	                canvas.attr({ width: width, height: height });
	                canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
	            }
	        }
	    };
	}]).name;
	
	exports.default = Components;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectDate = __webpack_require__(301);
	
	var _selectDate2 = _interopRequireDefault(_selectDate);
	
	var _selectDate3 = __webpack_require__(701);
	
	var _selectDate4 = _interopRequireDefault(_selectDate3);
	
	__webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectDateComponent = {
	    bindings: {
	        ngModel: '=',
	        ngRequired: '<',
	        label: '@',
	        ngDisabled: '<'
	    },
	    controller: _selectDate2.default,
	    template: _selectDate4.default
	};
	
	exports.default = selectDateComponent;

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectDateController = function () {
	  SelectDateController.$inject = ["$scope", "$log", "Datetime"];
	  function SelectDateController($scope, $log, Datetime) {
	    'ngInject';
	
	    _classCallCheck(this, SelectDateController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.Datetime = Datetime;
	  }
	
	  _createClass(SelectDateController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log('SelectDateController init');
	      // this.$log.log(this);
	      this.nowYear = new Date().getUTCFullYear();
	      this.$scope.$watch('$ctrl.ngModel', function () {
	        // this.$log.log('date', this.ngModel)
	        if (angular.isUndefined(_this.ngModel)) {
	          _this.day = null;
	          _this.month = null;
	          _this.year = null;
	        } else {
	          if (!_this.internal_change) {
	            var date = _this.ngModel;
	            if (typeof date == 'string') {
	              date = new Date(date);
	              _this.ngModel = new Date(_this.ngModel);
	            }
	            if (_this.Datetime.isDate(date)) {
	              _this.day = date.getUTCDate();
	              _this.month = date.getUTCMonth() + 1;
	              _this.year = date.getUTCFullYear();
	            }
	          }
	          delete _this.internal_change;
	        }
	      });
	      this.initMonths();
	    }
	  }, {
	    key: 'initMonths',
	    value: function initMonths() {
	      var months = [];
	      for (var i = 0; i < 12; i++) {
	        months.push({
	          val: i + 1,
	          name: this.Datetime.months[i]
	        });
	      }
	      this.months = months;
	    }
	  }, {
	    key: 'changeDate',
	    value: function changeDate(prop) {
	      if (prop == 'day') {
	        if (!(0 < this.day && this.day < 32)) {
	          this.day = null;
	        }
	      }
	      // if (prop=='month') {
	      //
	      // }
	      if (prop == 'year') {
	        // this.$log.log('year', angular.copy(this.year))
	        if (this.year < this.nowYear - 120) {
	          this.year = null;
	        }
	        if (this.year > this.nowYear) {
	          this.year = null;
	        }
	        // this.$log.log('year', angular.copy(this.year))
	      }
	      if (this.year && this.month && this.day) {
	        this.internal_change = true;
	        this.ngModel = new Date(this.year, this.month - 1, this.day);
	      }
	    }
	  }]);
	
	  return SelectDateController;
	}();
	
	exports.default = SelectDateController;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectMunicipio = __webpack_require__(303);
	
	var _selectMunicipio2 = _interopRequireDefault(_selectMunicipio);
	
	var _selectMunicipio3 = __webpack_require__(702);
	
	var _selectMunicipio4 = _interopRequireDefault(_selectMunicipio3);
	
	__webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectMunicipioComponent = {
	    bindings: {
	        departamento: '=',
	        provincia: '=',
	        municipio: '=',
	        conf: '<'
	    },
	    controller: _selectMunicipio2.default,
	    template: _selectMunicipio4.default
	};
	
	exports.default = selectMunicipioComponent;

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectMunicipioController = function () {
	  SelectMunicipioController.$inject = ["$scope", "$log", "DataService"];
	  function SelectMunicipioController($scope, $log, DataService) {
	    'ngInject';
	
	    _classCallCheck(this, SelectMunicipioController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.DataService = DataService;
	  }
	
	  _createClass(SelectMunicipioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log(this);
	
	      this.departamentosLoad();
	      this.init_provincias = this.provincia;
	      this.init_municipios = this.municipio;
	      this.$scope.$watch('$ctrl.departamento', function () {
	        // this.$log.log('departamentoChange', this);
	        if (_this.departamento) {
	          _this.provinciasLoad();
	        }
	      });
	      this.$scope.$watch('$ctrl.provincia', function () {
	        if (_this.provincia) {
	          _this.municipiosLoad();
	        }
	      });
	    }
	  }, {
	    key: 'departamentosLoad',
	    value: function departamentosLoad() {
	      var _this2 = this;
	
	      this.departamentos = [];
	      this.provincias = [];
	      this.municipios = [];
	
	      this.DataService.get('departamento').then(function (response) {
	        if (response) {
	          _this2.departamentos = response;
	        }
	      });
	    }
	  }, {
	    key: 'provinciasLoad',
	    value: function provinciasLoad() {
	      var _this3 = this;
	
	      this.provincias = [];
	      this.municipios = [];
	      if (!this.init_provincias) {
	        delete this.provincia;
	        delete this.municipio;
	      }
	      this.init_provincias = !1;
	
	      this.DataService.get('provincia/departamento/' + this.departamento).then(function (response) {
	        if (response) {
	          _this3.provincias = response;
	        }
	      });
	    }
	  }, {
	    key: 'municipiosLoad',
	    value: function municipiosLoad() {
	      var _this4 = this;
	
	      this.municipios = [];
	      if (!this.init_municipios) {
	        delete this.municipio;
	      }
	      this.init_municipios = !1;
	      this.DataService.get('municipio/provincia/' + this.provincia).then(function (response) {
	        if (response) {
	          _this4.municipios = response;
	        }
	      });
	    }
	  }]);
	
	  return SelectMunicipioController;
	}();
	
	exports.default = SelectMunicipioController;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectParametro = __webpack_require__(305);
	
	var _selectParametro2 = _interopRequireDefault(_selectParametro);
	
	var _selectParametro3 = __webpack_require__(703);
	
	var _selectParametro4 = _interopRequireDefault(_selectParametro3);
	
	__webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectParametroComponent = {
	    bindings: {
	        ngModel: '=',
	        name: '@',
	        ngRequired: '<',
	        ngDisabled: '<',
	        ngChange: '&',
	        parametro: '@',
	        query: '@',
	        selectModel: '=',
	        label: '@',
	        opcional: '@'
	    },
	    controller: _selectParametro2.default,
	    template: _selectParametro4.default
	};
	
	exports.default = selectParametroComponent;

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectParametroController = function () {
	  SelectParametroController.$inject = ["DataService", "$log", "$scope"];
	  function SelectParametroController(DataService, $log, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, SelectParametroController);
	
	    this.DataService = DataService;
	    this.$log = $log;
	    this.$scope = $scope;
	  }
	
	  _createClass(SelectParametroController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var url = 'parametricas/' + this.parametro;
	      if (this.query) url += this.query;
	      this.DataService.get(url).then(function (response) {
	        _this.items = response.datos.rows;
	
	        //si es opcional aniadimos un valor al combo que sera la bandera para no validar demas eventos
	        var isTrueSet = _this.opcional === 'true';
	        if (isTrueSet) {
	          _this.$log.log(' OPCIONAL***: ');
	          _this.items.unshift({
	            codigo: 'NN',
	            nombre: 'Ninguno',
	            descripcion: 'Sin valor'
	          });
	        }
	
	        if (_this.parametro === 'UNIDAD') {
	          _this.$log.log(' PERMITE "OTRO"***: ');
	          _this.items.push({
	            codigo: 'OTRO',
	            nombre: 'Otro',
	            descripcion: 'otro'
	          });
	        }
	      });
	
	      this.$scope.$watch('$ctrl.ngModel', function (newValue, oldValue) {
	        if (angular.toJson(newValue) != angular.toJson(oldValue)) {
	          _this.ngChange({ item: newValue });
	        }
	      });
	    }
	  }]);
	
	  return SelectParametroController;
	}();
	
	exports.default = SelectParametroController;

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MdSelectComponent = {
	    bindings: {
	        label: '@',
	        required: '@',
	        disabled: '@',
	        ngRequired: '<',
	        ngDisabled: '<',
	        ngModel: '=',
	        ngModelOptions: '<',
	        items: '<',
	        groupBy: '@',
	        keyText: '@',
	        keyValue: '@',
	        ngTitle: '@',
	        placeholder: '@'
	    },
	    template: '\n    <div class="form-group" ng-if="!$ctrl.keyValue">\n        <label for="input" ng-if="$ctrl.label" ng-class="{\'ap-req\':$ctrl.required||$ctrl.ngRequired}">{{ $ctrl.label }}</label>\n        <ui-select\n            ng-model="$ctrl.ngModel"\n            theme="bootstrap"\n            ng-required="$ctrl.required || $ctrl.ngRequired"\n            ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"\n            title="{{ $ctrl.ngTitle || \'Seleccione un item\' }}">\n            <ui-select-match placeholder="{{ $ctrl.placeholder || \'Seleccione o busque un item de la lista...\' }}">\n                {{$select.selected[$ctrl.keyText||\'text\']}}\n            </ui-select-match>\n            <ui-select-choices group-by="$ctrl.groupBy" repeat="item in $ctrl.items | filter: $select.search">\n                <span ng-bind-html="item[$ctrl.keyText||\'text\'] | highlight: $select.search"></span>\n                <small ng-bind-html="item.code | highlight: $select.search"></small>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n    <div class="form-group" ng-if="$ctrl.keyValue">\n        <label for="input" ng-if="$ctrl.label" ng-class="{\'ap-req\':$ctrl.required||$ctrl.ngRequired}">{{ $ctrl.label }}</label>\n        <ui-select\n            ng-model="$ctrl.ngModel"\n            theme="bootstrap"\n            ng-required="$ctrl.required || $ctrl.ngRequired"\n            ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"\n            title="{{ $ctrl.ngTitle || \'Seleccione un item\' }}">\n            <ui-select-match placeholder="{{ $ctrl.placeholder || \'Seleccione o busque un item de la lista...\' }}">\n                {{$select.selected[$ctrl.keyText||\'text\']}}\n            </ui-select-match>\n            <ui-select-choices group-by="$ctrl.groupBy" repeat="item[$ctrl.keyValue] as item in $ctrl.items | filter: $select.search">\n                <span ng-bind-html="item[$ctrl.keyText||\'text\'] | highlight: $select.search"></span>\n                <small ng-bind-html="item.code | highlight: $select.search"></small>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n    '
	};
	
	exports.default = MdSelectComponent;

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HelpService = function () {
	    HelpService.$inject = ["$window", "$document", "$compile"];
	    function HelpService($window, $document, $compile) {
	        'ngInject';
	
	        _classCallCheck(this, HelpService);
	
	        this.$window = $window;
	        this.$document = $document;
	        this.$compile = $compile;
	
	        this.template = '\n            <div class="ui-help-content">\n                <div class="ui-help-header">\n                    <i class="fa fa-question-circle"></i> <span class="ui-help-title"></span>\n                    <hr>\n                </div>\n                <div class="ui-help-body"><span class="ui-help-message"></span></div>\n            </div>';
	
	        this.fadeSleep = 500;
	    }
	
	    _createClass(HelpService, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'renderSleep',
	        value: function renderSleep(el) {
	            setTimeout(function () {
	                el.remove();
	            }, this.fadeSleep);
	        }
	    }, {
	        key: 'fadeOut',
	        value: function fadeOut(el) {
	            el.style.opacity = 1;
	
	            (function fade() {
	                if ((el.style.opacity -= .1) < 0) {
	                    el.style.display = "none";
	                } else {
	                    window.requestAnimationFrame(fade);
	                }
	            })();
	        }
	    }, {
	        key: 'fadeIn',
	        value: function fadeIn(el, display) {
	            el.style.opacity = 0;
	            el.style.display = display || "block";
	
	            (function fade() {
	                var val = parseFloat(el.style.opacity);
	
	                if (!((val += .1) > 1)) {
	                    el.style.opacity = val;
	                    window.requestAnimationFrame(fade);
	                }
	            })();
	        }
	    }, {
	        key: 'render',
	        value: function render($scope, title, message, idHelp, positionIn, classNew, width, fade) {
	            var _this = this;
	
	            if (fade) {
	                var helps = document.querySelectorAll('.ui-help-content');
	                if (helps.length) {
	                    for (var i in helps) {
	                        if (helps[i].classList) {
	                            this.fadeOut(helps[i]);
	                            this.renderSleep(helps[i]);
	                        }
	                    }
	                }
	            } else {
	                angular.element(document.querySelectorAll('.ui-help-content')).remove();
	            }
	            var element = angular.element(this.template)[0];
	            if (classNew) {
	                element.classList.add(classNew);
	            }
	            angular.element(document.body).append(element);
	            if (fade) {
	                element.classList.add('fade');
	                this.fadeIn(element);
	            }
	
	            if (typeof title != 'boolean') {
	                element.querySelector('.ui-help-title').innerHTML = title || 'Ayuda';
	            }
	            var content = this.$compile('<div>' + (message || 'Texto de ayuda') + '</div>')($scope);
	            angular.element(element.querySelector('.ui-help-message')).append(content);
	            var height = element.clientHeight;
	            if (width) {
	                element.style.width = width + 'px';
	            } else {
	                width = element.clientWidth;
	            }
	
	            if (idHelp === undefined || idHelp === null) {
	                element.classList.add('ui-help-center');
	                element.style.marginTop = -1 * (height / 2) - 20 + 'px';
	                element.style.marginLeft = -1 * (width / 2) + 'px';
	            } else {
	
	                this.renderPosition(element, idHelp, positionIn, height, width);
	
	                window.addEventListener('resize', function () {
	                    _this.renderPosition(element, idHelp, positionIn, height, width);
	                });
	            }
	
	            return element;
	        }
	    }, {
	        key: 'renderPosition',
	        value: function renderPosition(element, idHelp, positionIn, height, width) {
	            var position = null;
	            if (typeof idHelp == 'string') {
	                var elem = document.getElementById(idHelp);
	                if (elem) {
	                    position = elem.getBoundingClientRect();
	                } else {
	                    return false;
	                }
	            } else {
	                position = idHelp.getBoundingClientRect();
	            }
	            var heightWindow = this.$window.innerHeight;
	            var widthWindow = this.$window.innerWidth;
	            var posInitial = position;
	            var className = '';
	            var direction = positionIn || 'right';
	
	            if (direction == 'top') {
	                position = this.top(posInitial, height, width);
	                if (position.top < 0) {
	                    direction = 'bottom';
	                }
	            }
	            if (direction == 'right') {
	                position = this.right(posInitial, height);
	                if (position.left + width > widthWindow) {
	                    direction = 'left';
	                }
	            }
	            if (direction == 'bottom') {
	                position = this.bottom(posInitial, width);
	                if (position.top + height > heightWindow) {
	                    direction = 'top';
	                    position = this.top(posInitial, height, width);
	                }
	            }
	            if (direction == 'left') {
	                position = this.left(posInitial, height, width);
	                if (position.left < 0) {
	                    direction = 'right';
	                    position = this.right(posInitial, height);
	                }
	            }
	
	            className = direction;
	
	            if (direction == 'top') {
	                if (position.left + width > widthWindow) {
	                    position = this.top_left(posInitial, height, width);
	                    className = 'top-left';
	                } else {
	                    if (position.left < 0) {
	                        position = this.top_right(posInitial, height, width);
	                        className = 'top-right';
	                    }
	                }
	            }
	
	            if (direction == 'right') {
	                if (position.top + height > heightWindow) {
	                    position = this.right_top(posInitial, height);
	                    className = 'right-top';
	                } else {
	                    if (position.top < 0) {
	                        position = this.right_bottom(posInitial, width);
	                        className = 'right-bottom';
	                    }
	                }
	            }
	
	            if (direction == 'bottom') {
	                if (position.left + width > widthWindow) {
	                    position = this.bottom_left(posInitial, width);
	                    className = 'bottom-left';
	                } else {
	                    if (position.left < 0) {
	                        position = this.bottom_right(posInitial);
	                        className = 'bottom-right';
	                    }
	                }
	            }
	
	            if (direction == 'left') {
	                if (position.top + height > heightWindow) {
	                    position = this.left_top(posInitial, height, width);
	                    className = 'left-top';
	                } else {
	                    if (position.top < 0) {
	                        position = this.left_bottom(posInitial, width);
	                        className = 'left-bottom';
	                    }
	                }
	            }
	
	            // console.log('H:', height, 'W:', width, 'HW', heightWindow, 'WW', widthWindow);
	            // console.log('INITIAL:', posInitial, 'END:', position, 'POSITION', className, 'ELEMENT', element);
	
	            element.classList.remove('top');
	            element.classList.remove('right');
	            element.classList.remove('bottom');
	            element.classList.remove('left');
	            element.classList.remove('top-left');
	            element.classList.remove('top-right');
	            element.classList.remove('right-top');
	            element.classList.remove('right-bottom');
	            element.classList.remove('bottom-left');
	            element.classList.remove('bottom-right');
	            element.classList.remove('left-top');
	            element.classList.remove('left-bottom');
	            element.classList.add(className);
	            element.style.top = position.top + 'px';
	            element.style.left = position.left + 'px';
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy(element, fade) {
	            if (element) {
	                if (fade) {
	                    this.fadeOut(element);
	                    setTimeout(function () {
	                        element.remove();
	                    }, this.fadeSleep);
	                } else {
	                    element.remove();
	                }
	            }
	        }
	    }, {
	        key: 'top',
	        value: function top(position, height, width) {
	            return {
	                top: position.top - height - 12,
	                left: position.left - (width / 2 - position.width / 2)
	            };
	        }
	    }, {
	        key: 'top_right',
	        value: function top_right(position, height) {
	            return {
	                top: position.top - height - 12,
	                left: position.left + position.width / 2 - 20
	            };
	        }
	    }, {
	        key: 'top_left',
	        value: function top_left(position, height, width) {
	            return {
	                top: position.top - height - 12,
	                left: position.left + position.width / 2 + 20 - width
	            };
	        }
	    }, {
	        key: 'right',
	        value: function right(position, height) {
	            return {
	                top: position.top - (height / 2 - position.height / 2),
	                left: position.left + position.width + 12
	            };
	        }
	    }, {
	        key: 'right_top',
	        value: function right_top(position, height) {
	            return {
	                top: position.top + position.height / 2 - height + 20,
	                left: position.left + position.width + 12
	            };
	        }
	    }, {
	        key: 'right_bottom',
	        value: function right_bottom(position) {
	            return {
	                top: position.top + position.height / 2 - 20,
	                left: position.left + position.width + 12
	            };
	        }
	    }, {
	        key: 'bottom',
	        value: function bottom(position, width) {
	            return {
	                top: position.top + position.height + 12,
	                left: position.left - (width / 2 - position.width / 2)
	            };
	        }
	    }, {
	        key: 'bottom_right',
	        value: function bottom_right(position) {
	            return {
	                top: position.top + position.height + 12,
	                left: position.left + position.width / 2 - 20
	            };
	        }
	    }, {
	        key: 'bottom_left',
	        value: function bottom_left(position, width) {
	            return {
	                top: position.top + position.height + 12,
	                left: position.left + position.width / 2 + 20 - width
	            };
	        }
	    }, {
	        key: 'left',
	        value: function left(position, height, width) {
	            return {
	                top: position.top - (height / 2 - position.height / 2),
	                left: position.left - width - 12
	            };
	        }
	    }, {
	        key: 'left_top',
	        value: function left_top(position, height, width) {
	            return {
	                top: position.top + position.height / 2 - height + 20,
	                left: position.left - width - 12
	            };
	        }
	    }, {
	        key: 'left_bottom',
	        value: function left_bottom(position, width) {
	            return {
	                top: position.top + position.height / 2 - 20,
	                left: position.left - width - 12
	            };
	        }
	    }]);
	
	    return HelpService;
	}();
	
	exports.default = HelpService;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _help = __webpack_require__(309);
	
	var _help2 = _interopRequireDefault(_help);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var help = {
	    bindings: {
	        message: '<',
	        title: '<',
	        position: '@',
	        direction: '@',
	        idHelp: '@'
	    },
	    template: '\n        <span class="ui-help" ng-if="$ctrl.message" id-help ng-mouseover="$ctrl.hoverIn()" ng-mouseleave="$ctrl.hoverOut()">\n            <i class="fa fa-question-circle"></i>\n        </span>\n    ',
	    controller: _help2.default
	};
	
	exports.default = help;

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HelpComponent = function () {
	    HelpComponent.$inject = ["$scope", "$rootScope", "HelpPopup"];
	    function HelpComponent($scope, $rootScope, HelpPopup) {
	        'ngInject';
	
	        _classCallCheck(this, HelpComponent);
	
	        this.$rootScope = $rootScope;
	        this.HelpPopup = HelpPopup;
	        this.$scope = $scope;
	    }
	
	    _createClass(HelpComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	
	            this.$element = null;
	
	            this.idHelp = null;
	
	            this.$rootScope.$on('$stateChangeStart', function () /*event, toState, toParams, fromState, fromParams*/{
	                if (this.$element) {
	                    this.$element.remove();
	                }
	            });
	        }
	    }, {
	        key: 'hoverIn',
	        value: function hoverIn() {
	            this.$element = this.HelpPopup.render(this.$scope, this.title, this.message, this.idHelp, this.position || this.direction);
	        }
	    }, {
	        key: 'hoverOut',
	        value: function hoverOut() {
	            this.HelpPopup.destroy(this.$element);
	        }
	    }]);
	
	    return HelpComponent;
	}();
	
	exports.default = HelpComponent;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _help = __webpack_require__(308);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _helpPopup = __webpack_require__(307);
	
	var _helpPopup2 = _interopRequireDefault(_helpPopup);
	
	var _tourHelp = __webpack_require__(313);
	
	var _tourHelp2 = _interopRequireDefault(_tourHelp);
	
	__webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpModule = angular.module('angular-help', [_tourHelp2.default]).directive('idHelp', ['Util', function (Util) {
	    return {
	        link: function link(scope, element /*, attrs*/) {
	            var id = 'ui-help-' + Util.id();
	            element[0].setAttribute('id', id);
	            scope.$ctrl.idHelp = id;
	        }
	    };
	}]).service('HelpPopup', _helpPopup2.default).component('uiHelp', _help2.default).name;
	
	exports.default = HelpModule;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tourHelp = __webpack_require__(312);
	
	var _tourHelp2 = _interopRequireDefault(_tourHelp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tourhelp = {
	    bindings: {
	        tour: '<',
	        tourEnd: '<',
	        tourLabel: '<'
	    },
	    template: '',
	    controller: _tourHelp2.default
	};
	
	exports.default = Tourhelp;

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TourHelpController = function () {
	    TourHelpController.$inject = ["$scope", "$rootScope", "$window", "$document", "HelpPopup"];
	    function TourHelpController($scope, $rootScope, $window, $document, HelpPopup) {
	        'ngInject';
	
	        _classCallCheck(this, TourHelpController);
	
	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$window = $window;
	        this.$document = $document;
	        this.HelpPopup = HelpPopup;
	    }
	
	    _createClass(TourHelpController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.$element = null;
	            this.position = 0;
	
	            this.tmplFinish = '<button class="btn btn-primary" ng-click="$ctrl.finish()"><i class="fa fa-check-circle"></i> ' + (this.tourLabel && this.tourLabel.end ? this.tourLabel.end : 'Terminar') + '</button>';
	
	            if (this.tour && this.tour.length) {
	                this.step();
	            }
	        }
	    }, {
	        key: 'renderButton',
	        value: function renderButton(setting) {
	            return ['<button type="button" class="btn ' + (setting.className || '') + '" ng-click="' + (setting.onClick || '') + '">', setting.icon && setting.icon.length ? '<i class="fa fa-' + setting.icon + '"></i>' : '', setting.label, '</button>'].join(' ');
	        }
	    }, {
	        key: 'step',
	        value: function step() {
	            var buttons = '<div class="tour-help-buttons">';
	            if (this.position > 0 && (this.tour[this.position].btnPrev === undefined || this.tour[this.position].btnPrev)) {
	                buttons += this.renderButton({
	                    label: this.tour[this.position].labelPrev || 'Anterior',
	                    icon: this.tour[this.position].iconPrev || 'angle-double-left',
	                    className: this.tour[this.position].classPrev || '',
	                    onClick: '$ctrl.prev()'
	                });
	            }
	            if (this.position < this.tour.length - 1 && (this.tour[this.position].btnNext === undefined || this.tour[this.position].btnNext)) {
	                buttons += this.renderButton({
	                    label: this.tour[this.position].labelNext || 'Siguiente',
	                    icon: this.tour[this.position].iconNext || 'angle-double-right',
	                    className: this.tour[this.position].classNext || '',
	                    onClick: '$ctrl.next()'
	                });
	            }
	            if (this.tour[this.position].btnFinish === undefined || this.tour[this.position].btnFinish) {
	                buttons += this.tmplFinish;
	            }
	            buttons += '</div>';
	            this.$element = this.HelpPopup.render(this.$scope, this.tour[this.position].title, this.tour[this.position].text + buttons, this.tour[this.position].id, this.tour[this.position].position || 'bottom', 'tour-popup', this.tour[this.position].width, true);
	            if (this.$element) {
	                this.drawBackdrop(this.tour[this.position].id, this.$element);
	            }
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            var _this = this;
	
	            if (typeof this.tour[this.position].next == 'function') {
	                this.tour[this.position].next();
	            }
	            this.position++;
	            setTimeout(function () {
	                _this.step();
	            }, this.tour[this.position].sleepShow || 0);
	        }
	    }, {
	        key: 'prev',
	        value: function prev() {
	            var _this2 = this;
	
	            if (typeof this.tour[this.position].prev == 'function') {
	                this.tour[this.position].prev();
	            }
	            this.position--;
	            setTimeout(function () {
	                _this2.step();
	            }, this.tour[this.position].sleepPrev || 0);
	        }
	    }, {
	        key: 'finish',
	        value: function finish() {
	            if (typeof this.tourEnd == 'function') {
	                this.tourEnd();
	            }
	            this.HelpPopup.destroy(this.$element, true);
	            this.destroyBackdrop();
	        }
	    }, {
	        key: 'destroyBackdrop',
	        value: function destroyBackdrop() {
	            angular.element(document.querySelectorAll('.tour-help-backdrop')).remove();
	        }
	    }, {
	        key: 'drawBackdrop',
	        value: function drawBackdrop(id, $help) {
	            var _this3 = this;
	
	            this.destroyBackdrop();
	
	            if (id) {
	                var pos = this.getPosition(id, $help);
	
	                this.createDiv(pos.top, 'top');
	                this.createDiv(pos.right, 'right');
	                this.createDiv(pos.bottom, 'bottom');
	                this.createDiv(pos.left, 'left');
	                this.createDiv({
	                    top: this.transform(pos.elem.top - pos.body.top),
	                    left: this.transform(pos.elem.left),
	                    height: this.transform(pos.elem.height),
	                    width: this.transform(pos.elem.width)
	                }, 'tour-transparent');
	
	                window.addEventListener('resize', function () {
	                    var pos = _this3.getPosition(id, $help);
	                    if (pos) {
	                        _this3.changePosition(pos.top, 'top');
	                        _this3.changePosition(pos.right, 'right');
	                        _this3.changePosition(pos.bottom, 'bottom');
	                        _this3.changePosition(pos.left, 'left');
	                        _this3.changePosition({
	                            top: _this3.transform(pos.elem.top - pos.body.top),
	                            left: _this3.transform(pos.elem.left),
	                            height: _this3.transform(pos.elem.height),
	                            width: _this3.transform(pos.elem.width)
	                        }, 'tour-transparent');
	                    }
	                });
	            } else {
	                var body = document.body.getBoundingClientRect();
	                this.createDiv({
	                    top: 0,
	                    left: 0,
	                    height: this.transform(body.height),
	                    width: this.transform(body.width)
	                }, 'tour-transparent-center');
	
	                window.addEventListener('resize', function () {
	                    var body = document.body.getBoundingClientRect();
	                    _this3.changePosition({
	                        top: 0,
	                        left: 0,
	                        height: _this3.transform(body.height),
	                        width: _this3.transform(body.width)
	                    }, 'tour-transparent-center');
	                });
	            }
	        }
	    }, {
	        key: 'getPosition',
	        value: function getPosition(id, $help) {
	            var body = document.body.getBoundingClientRect();
	            var elem = null;
	            if (typeof id == 'string' && id.length) {
	                elem = document.querySelector('#' + id);
	                if (elem) {
	                    elem = elem.getBoundingClientRect();
	                } else {
	                    return false;
	                }
	            } else {
	                elem = id.getBoundingClientRect();
	            }
	
	            var position = {
	                elem: elem,
	                body: body
	            };
	
	            position.top = {
	                top: 0,
	                left: 0,
	                height: this.transform(elem.top - body.top),
	                width: this.transform(body.width)
	            };
	            position.right = {
	                top: this.transform(elem.top - body.top),
	                left: this.transform(elem.right),
	                height: this.transform(elem.height),
	                width: this.transform(body.width - elem.right)
	            };
	            position.bottom = {
	                top: this.transform(elem.top + elem.height - body.top),
	                left: this.transform(0),
	                height: this.transform(body.height - (elem.top + elem.height - body.top)),
	                width: this.transform(body.width)
	            };
	            position.left = {
	                top: this.transform(elem.top - body.top),
	                left: this.transform(0),
	                height: this.transform(elem.height),
	                width: this.transform(elem.left)
	            };
	
	            if (elem.top + elem.height > body.height) {
	                var scrollY = elem.top + elem.height - body.height;
	                $help.css('top', parseInt($help.css('top')) - (scrollY + 30));
	                window.scrollTo(0, scrollY + 30 - body.top);
	                // bottom.height = this.transform(30);
	            }
	
	            return position;
	        }
	    }, {
	        key: 'transform',
	        value: function transform(number) {
	            return parseFloat(number).toFixed(2) + "px";
	        }
	    }, {
	        key: 'changePosition',
	        value: function changePosition(css, className) {
	            this.setCss(document.querySelector('.tour-help-backdrop.' + className), css);
	        }
	    }, {
	        key: 'createDiv',
	        value: function createDiv(css, className) {
	            var div = document.createElement('div');
	            div.className = "tour-help-backdrop";
	            if (className) {
	                div.classList.add(className);
	            }
	            this.setCss(div, css);
	            document.body.appendChild(div);
	        }
	    }, {
	        key: 'setCss',
	        value: function setCss(obj, data) {
	            if (obj) {
	                for (var i in data) {
	                    obj.style[i] = data[i];
	                }
	            }
	        }
	    }]);
	
	    return TourHelpController;
	}();
	
	exports.default = TourHelpController;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tourHelp = __webpack_require__(311);
	
	var _tourHelp2 = _interopRequireDefault(_tourHelp);
	
	__webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TourHelpModule = angular.module('angular-tour-help', []).component('uiTourHelp', _tourHelp2.default).name;
	
	exports.default = TourHelpModule;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mdInput = __webpack_require__(316);
	
	var _mdInput2 = _interopRequireDefault(_mdInput);
	
	var _mdTextarea = __webpack_require__(319);
	
	var _mdTextarea2 = _interopRequireDefault(_mdTextarea);
	
	var _mdSelect = __webpack_require__(318);
	
	var _mdSelect2 = _interopRequireDefault(_mdSelect);
	
	var _mdEventLabel = __webpack_require__(315);
	
	var _mdEventLabel2 = _interopRequireDefault(_mdEventLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialModule = angular.module('app.material', []).component('mdInput', _mdInput2.default).component('mdTextarea', _mdTextarea2.default).component('mdSelect', _mdSelect2.default).directive('mdEventLabel', function () {
	    return new _mdEventLabel2.default();
	}).name;
	
	exports.default = MaterialModule;

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdEventLabel = function () {
	    function MdEventLabel() {
	        _classCallCheck(this, MdEventLabel);
	
	        this.restrict = 'A';
	    }
	
	    _createClass(MdEventLabel, [{
	        key: 'link',
	        value: function link($scope, $elem) {
	            if ($scope.$ctrl.required === undefined || $scope.$ctrl.ngRequired === undefined) {
	                var $input = $elem.find('input');
	                if ($input.length === 0) {
	                    $input = $elem.find('textarea');
	                }
	                if ($input.length) {
	                    if ($input.val().length === 0) {
	                        $input.addClass('not-required');
	                    }
	                    $input.on('focus', function () {
	                        $input.removeClass('not-required');
	                    }).on('blur', function () {
	                        $input[$input.val().length ? 'removeClass' : 'addClass']('not-required');
	                    });
	                } else {
	                    setTimeout(function () {
	                        $input = $elem.find('input');
	                        $input.on('focus', function () {
	                            $input.parent().addClass('not-required-select').parent().addClass('md-focus');
	                        }).on('blur', function () {
	                            if (!$input.parent().hasClass('open')) {
	                                setTimeout(function () {
	                                    $input.parent()[$input.parent()[0].querySelector('.ui-select-match-text').innerHTML.length ? 'addClass' : 'removeClass']('not-required-select').parent().removeClass('md-focus');
	                                }, 1);
	                            }
	                        });
	                    }, 1000);
	                }
	            }
	        }
	    }]);
	
	    return MdEventLabel;
	}();
	
	exports.default = MdEventLabel;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mdInput = __webpack_require__(317);
	
	var _mdInput2 = _interopRequireDefault(_mdInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './md-input.scss';
	
	var MdInputComponent = {
	    bindings: {
	        label: '@',
	        name: '@',
	        type: '@',
	        required: '@',
	        ngRequired: '@',
	        disabled: '@',
	        ngDisabled: '@',
	        readonly: '@',
	        ngReadonly: '@',
	        ngModel: '=',
	        ngClick: '<',
	        ngChange: '<',
	        ngModelOptions: '<',
	        value: '<',
	        ngValue: '<',
	        ngDefault: '<'
	    },
	    template: '\n    <div class="md-form-group" md-event-label>\n        <input name="{{$ctrl.name}}" id="{{$ctrl.name}}" ng-required="$ctrl.required || $ctrl.ngRequired"\n               ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"\n               ng-readonly="$ctrl.readonly || $ctrl.ngReadonly"\n               ng-model="$ctrl.ngModel"\n               ng-click="$ctrl.ngClick"\n               ng-change="$ctrl.ngChange"\n               ng-model-options="$ctrl.ngModelOptions"\n               ng-placeholder="$ctrl.placeholder"\n               type="{{ $ctrl.type || \'text\' }}"\n               $ctrl.ngValue || $ctrl.ngDefault || $ctrl.value || \'\'\n               autocapitalize="off">\n        <label for="{{$ctrl.name}}" class="md-control-label" for="input">{{ $ctrl.label }}</label>\n        <i class="md-bar"></i>\n    </div>\n    ',
	    controller: _mdInput2.default
	};
	
	exports.default = MdInputComponent;

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdInputController = function () {
	    function MdInputController() {
	        _classCallCheck(this, MdInputController);
	    }
	
	    _createClass(MdInputController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }]);
	
	    return MdInputController;
	}();
	
	exports.default = MdInputController;

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MdSelectComponent = {
	    bindings: {
	        label: '@',
	        required: '@',
	        ngRequired: '@',
	        disabled: '@',
	        ngDisabled: '@',
	        ngModel: '=',
	        ngChange: '<',
	        ngModelOptions: '<',
	        items: '<'
	    },
	    template: '\n    <div class="md-form-group">\n        <select ng-required="$ctrl.required || $ctrl.ngRequired" \n                ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"  \n                ng-model="$ctrl.ngModel" \n                ng-change="$ctrl.ngChange" \n                ng-model-options="$ctrl.ngModelOptions">\n            <option value="{{ item.value }}" ng-if="item.value" ng-repeat="item in $ctrl.items">{{item.text}}</option>\n        </select>\n        <label class="md-control-label" for="select">{{ $ctrl.label }}</label>\n        <i class="md-bar"></i>\n    </div>\n    '
	};
	
	exports.default = MdSelectComponent;

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MdTextareaComponent = {
	    bindings: {
	        label: '@',
	        required: '@',
	        ngRequired: '@',
	        disabled: '@',
	        ngDisabled: '@',
	        readonly: '@',
	        ngReadonly: '@',
	        ngModel: '=',
	        ngClick: '<',
	        ngChange: '<',
	        ngModelOptions: '<',
	        value: '<',
	        ngValue: '<',
	        ngDefault: '<'
	    },
	    template: '\n    <div class="md-form-group" md-event-label>\n        <textarea ng-required="$ctrl.required || $ctrl.ngRequired" \n                  ng-disabled="$ctrl.disabled || $ctrl.ngDisabled" \n                  ng-readonly="$ctrl.readonly || $ctrl.ngReadonly" \n                  ng-model="$ctrl.ngModel" \n                  ng-click="$ctrl.ngClick" \n                  ng-change="$ctrl.ngChange" \n                  ng-model-options="$ctrl.ngModelOptions"\n                  ng-placeholder="$ctrl.placeholder">{{ $ctrl.ngValue || $ctrl.ngDefault || $ctrl.value || \'\' }}</textarea>\n        <label class="md-control-label" for="textarea">{{ $ctrl.label }}</label>\n        <i class="md-bar"></i>\n    </div>\n    '
	};
	
	exports.default = MdTextareaComponent;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _crudTable = __webpack_require__(287);
	
	var _crudTable2 = _interopRequireDefault(_crudTable);
	
	var _material = __webpack_require__(314);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _forms = __webpack_require__(296);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _help = __webpack_require__(310);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _cComponents = __webpack_require__(256);
	
	var _cComponents2 = _interopRequireDefault(_cComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.util', [_crudTable2.default, _material2.default, _forms2.default, _help2.default, _cComponents2.default]).name;
	
	exports.default = Components;

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Errors = {
	    '401': 'No se pudo realizar la operación.',
	    '412': 'No se pudo realizar la operación.',
	    '403': 'Su sesión ha caducado o no tiene los permisos necesarios.',
	    '404': 'No existe el recurso solicitado.',
	    '407': 'Necesita configurar su Proxy para poder usar el sistema.',
	    '408': 'El servidor no responde intente más tarde.',
	    '409': 'Los datos no son válidos',
	    '410': 'El recurso solicitado ya no está disponible y no lo estará de nuevo.',
	    '422': 'Error de validación, revise los datos.',
	    '500': 'Se produjo un error en el servidor, inténtelo más tarde.',
	    '502': 'El sistema no está disponible en estos momentos, inténtelo más tarde.',
	    '503': 'El sistema se encuentra en mantenimiento en estos momentos, vuelva a intentarlo más tarde por favor.',
	    // '504': 'Gateway timeout - Tiempo de espera agota.', // Esto debe ser implementado en el frontend para reintentar las peticiones
	    'connection': 'No se pudo establecer conexión con el servidor.',
	    'cancelRequest': 'Petición cancelada.',
	    'validation': 'Error de validación'
	};
	
	exports.default = Errors;

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Help = {
	    'ejemplo': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Impedit, minima!',
	    'nro_fam': 'Numero de hombres y mujeres de familias beneficiadas',
	    'plazo_cierre': 'El plazo cierre por defecto es 60 dias'
	};
	
	exports.default = Help;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _errors = __webpack_require__(321);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _help = __webpack_require__(322);
	
	var _help2 = _interopRequireDefault(_help);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lang = angular.module('app.lang', []).constant('errorsLang', _errors2.default).constant('helpLang', _help2.default).run(["$rootScope", "errorsLang", "helpLang", function ($rootScope, errorsLang, helpLang) {
	    "ngInject";
	
	    $rootScope.lang = {
	        errorsLang: errorsLang,
	        helpLang: helpLang
	    };
	}]).name;
	
	exports.default = Lang;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _breadcrumb = __webpack_require__(325);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	__webpack_require__(188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BreadcrumbComponent = {
	    template: '\n        <ol class="breadcrumb">\n            <li class="breadcrumb-item"><i class="fa fa-home"></i> <a href="/">Home</a></li>\n            <li class="breadcrumb-item" ng-if="$ctrl.getParent()">{{$ctrl.getParent()}}</li>\n            <li class="breadcrumb-item active" ng-if="$ctrl.getCurrent()">{{$ctrl.getCurrent()}}</li>\n        </ol>\n    ',
	    controller: _breadcrumb2.default
	};
	
	exports.default = BreadcrumbComponent;

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BreadcrumbController = function () {
	    BreadcrumbController.$inject = ["Storage", "$location", "BreadcrumbFactory", "Util"];
	    function BreadcrumbController(Storage, $location, BreadcrumbFactory, Util) {
	        'ngInject';
	
	        _classCallCheck(this, BreadcrumbController);
	
	        this.Storage = Storage;
	        this.$location = $location;
	        this.BreadcrumbFactory = BreadcrumbFactory;
	        this.Util = Util;
	    }
	
	    _createClass(BreadcrumbController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            if (this.Storage.exist('menu')) {
	                var page = this.Util.getMenuOption(this.Storage.get('menu'), this.$location.path().replace('/', ''));
	                this.BreadcrumbFactory.setParent(page[0]);
	                this.BreadcrumbFactory.setCurrent(page[1]);
	            }
	        }
	    }, {
	        key: 'getParent',
	        value: function getParent() {
	            return this.BreadcrumbFactory.getParent();
	        }
	    }, {
	        key: 'getCurrent',
	        value: function getCurrent() {
	            return this.BreadcrumbFactory.getCurrent();
	        }
	    }]);
	
	    return BreadcrumbController;
	}();
	
	exports.default = BreadcrumbController;

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var BreadcrumbFactory = function BreadcrumbFactory() {
	    var _this = this;
	
	    var factory = {
	        parent: '',
	        current: '',
	        setParent: function setParent(parent) {
	            _this.parent = parent;
	        },
	        setCurrent: function setCurrent(current) {
	            _this.current = current;
	        },
	        getParent: function getParent() {
	            return _this.parent;
	        },
	        getCurrent: function getCurrent() {
	            return _this.current;
	        }
	    };
	
	    return factory;
	};
	
	exports.default = BreadcrumbFactory;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _breadcrumb = __webpack_require__(324);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _breadcrumb3 = __webpack_require__(326);
	
	var _breadcrumb4 = _interopRequireDefault(_breadcrumb3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumb = angular.module('app.breadcrumb', []).factory('BreadcrumbFactory', _breadcrumb4.default).component('appBreadcrumb', _breadcrumb2.default).name;
	
	exports.default = Breadcrumb;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _footer = __webpack_require__(329);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterComponent = {
	    template: '\n        <footer class="footer text-info">\n            FDI {{ $ctrl.year }}\n        </footer>\n    ',
	    controller: _footer2.default
	};
	
	exports.default = FooterComponent;

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterController = function () {
	    function FooterController() {
	        _classCallCheck(this, FooterController);
	    }
	
	    _createClass(FooterController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var date = new Date();
	            this.year = date.getFullYear();
	        }
	    }]);
	
	    return FooterController;
	}();
	
	exports.default = FooterController;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(7);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _sidenav = __webpack_require__(341);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _breadcrumb = __webpack_require__(327);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _loading = __webpack_require__(333);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _navbar = __webpack_require__(336);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(328);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = _angular2.default.module('app.layout', [_sidenav2.default, _breadcrumb2.default, _loading2.default]).component('appNavbar', _navbar2.default).component('appFooter', _footer2.default).name;
	
	exports.default = Layout;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loading = __webpack_require__(332);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	__webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadingComponent = {
	    template: '\n        <div class="loading">Loading</div>\n    ',
	    controller: _loading2.default
	};
	
	exports.default = LoadingComponent;

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoadingController = function () {
	    function LoadingController() {
	        // this.DataService = DataService;
	
	        _classCallCheck(this, LoadingController);
	    }
	
	    _createClass(LoadingController, [{
	        key: 'cancelRequest',
	        value: function cancelRequest() {
	            // this.DataService.cancelRequest();
	        }
	    }]);
	
	    return LoadingController;
	}();
	
	exports.default = LoadingController;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loading = __webpack_require__(331);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _loading3 = __webpack_require__(334);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loading = angular.module('app.loading', []).component('appLoading', _loading2.default).service('Loading', _loading4.default).name;
	
	exports.default = Loading;

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoadingService = function () {
	    LoadingService.$inject = ["cfpLoadingBar"];
	    function LoadingService(cfpLoadingBar) {
	        'ngInject';
	
	        _classCallCheck(this, LoadingService);
	
	        this.cfpLoadingBar = cfpLoadingBar;
	    }
	
	    _createClass(LoadingService, [{
	        key: 'show',
	        value: function show(message, locked) {
	            // this.cfpLoadingBar.start();
	            // document.querySelector('#loading-bar-spinner .loading-text').innerHTML = message || 'Cargando';
	
	            // if (locked) {
	            //     document.querySelector('#loading-bar-spinner').classList.add('screen-locked');
	            // } else {
	            //     document.querySelector('#loading-bar-spinner').classList.remove('screen-locked');
	            // }
	            this.cfpLoadingBar.start();
	            var loading1 = document.querySelector('#loading-bar-spinner .loading-text');
	            if (loading1) loading1.innerHTML = message || 'Cargando';
	
	            var loading2 = document.querySelector('#loading-bar-spinner');
	            if (locked) {
	                if (loading2) loading2.classList.add('screen-locked');
	            } else {
	                if (loading2) loading2.classList.remove('screen-locked');
	            }
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            // this.cfpLoadingBar.complete();
	            // if (document.querySelector('#loading-bar-spinner .loading-text')) {
	            //   document.querySelector('#loading-bar-spinner .loading-text').innerHTML = 'Cargando';
	            //   document.querySelector('#loading-bar-spinner').classList.remove('screen-locked');
	            // }
	            this.cfpLoadingBar.complete();
	            var loading1 = document.querySelector('#loading-bar-spinner .loading-text');
	            if (loading1) loading1.innerHTML = 'Cargando';
	            var loading2 = document.querySelector('#loading-bar-spinner');
	            if (loading2) loading2.classList.remove('screen-locked');
	        }
	    }]);
	
	    return LoadingService;
	}();
	
	exports.default = LoadingService;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PasswordModalController = function () {
	  PasswordModalController.$inject = ["$uibModalInstance", "data", "DataService", "apiUrl", "Message", "Storage", "Auth", "$location"];
	  function PasswordModalController($uibModalInstance, data, DataService, apiUrl, Message, Storage, Auth, $location) {
	    'ngInject';
	
	    _classCallCheck(this, PasswordModalController);
	
	    this.items = data;
	    this.DataService = DataService;
	    this.apiUrl = apiUrl;
	    this.Message = Message;
	    this.$uibModalInstance = $uibModalInstance;
	    this.Storage = Storage;
	    this.datos = {};
	    if (!Auth.$rootScope.auth) $location.path('/');$location.replace();
	  }
	
	  _createClass(PasswordModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.usuario = this.Storage.getUser();
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      this.enviando = true;
	      if (this.datos.actual === this.datos.nueva) {
	        this.Message.warning("Las contraseñas son iguales, no se ha realizado ningúna modificación.", null, 0);
	        this.$uibModalInstance.dismiss('cancel');
	        return;
	      }
	      if (this.datos.actual && this.datos.nueva && this.datos.confirmado) {
	        this.DataService.put('contrasena/' + this.usuario.id_usuario + '/usuario', this.datos).then(function (response) {
	          _this.enviando = false;
	          if (response === null) return; //throw new Error("No se pudo realizar el cambio.");
	
	          _this.$uibModalInstance.close(_this.datos);
	          _this.Message.success(response.mensaje, null, 0);
	        }).catch(function (error) {
	          _this.enviando = false;
	          _this.Message.error(error, null, 0);
	        });
	      } else {
	        this.enviando = false;
	        this.Message.warning("Verifique los datos introducidos.", null, 0);
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return PasswordModalController;
	}();
	
	exports.default = PasswordModalController;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _navbar = __webpack_require__(708);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbarController = __webpack_require__(337);
	
	var _navbarController2 = _interopRequireDefault(_navbarController);
	
	__webpack_require__(192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarComponent = {
	    bindings: {},
	    template: _navbar2.default,
	    controller: _navbarController2.default
	};
	
	exports.default = NavbarComponent;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cuenta = __webpack_require__(335);
	
	var _cuenta2 = _interopRequireDefault(_cuenta);
	
	var _cuenta3 = __webpack_require__(707);
	
	var _cuenta4 = _interopRequireDefault(_cuenta3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarController = function () {
	  NavbarController.$inject = ["$state", "$location", "$window", "Util", "Auth", "Storage", "SidenavFactory", "Modal", "$log"];
	  function NavbarController($state, $location, $window, Util, Auth, Storage, SidenavFactory, Modal, $log) {
	    "ngInject";
	
	    _classCallCheck(this, NavbarController);
	
	    this.$state = $state;
	    this.$window = $window;
	    this.$location = $location;
	    this.Util = Util;
	    this.Auth = Auth;
	    this.$log = $log;
	    this.Storage = Storage;
	    this.SidenavFactory = SidenavFactory;
	    this.Modal = Modal;
	  }
	
	  _createClass(NavbarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.user = this.Storage.getUser();
	      window.setTimeout(function () {
	        if (_this.$window.innerWidth < 990) {
	          document.querySelector('#app-sidenav').classList.toggle('sidenav-close');
	        }
	      }, 750);
	    }
	  }, {
	    key: 'toggleSidenav',
	    value: function toggleSidenav() {
	      document.querySelector('#app-sidenav').classList.toggle('sidenav-close');
	    }
	  }, {
	    key: 'fullscreen',
	    value: function fullscreen() {
	      document.querySelector('body').classList.toggle('fullscreen');
	      this.Util.fullscreen();
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.$state.reload();
	    }
	  }, {
	    key: 'toggled',
	    value: function toggled(open) {
	      this.$log.log('open', open);
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.Auth.logout();
	    }
	  }, {
	    key: 'account',
	    value: function account() {
	      var _this2 = this;
	
	      //this.Sidenav.path("account");
	      this.Modal.show({
	        template: _cuenta4.default,
	        controller: _cuenta2.default,
	        data: {},
	        size: ''
	      }).result.then(function () {
	        _this2.logout();
	      });
	    }
	  }, {
	    key: 'changeRol',
	    value: function changeRol(rol) {
	      var _this3 = this;
	
	      this.user.rol = rol;
	      // this.refresh();
	      // Set rol
	      this.Storage.set('menu', rol.menu);
	      this.SidenavFactory.setMenu(this.Storage.get('menu'));
	
	      this.SidenavFactory.setRol(rol);
	      this.Storage.set('rol', this.SidenavFactory.getRol());
	      this.Storage.setUser(this.user);
	
	      var rutaAnt = this.$location.path();
	      var ruta = rol.menu[0].submenu[0].url;
	      this.$location.path(ruta).replace();
	      if (rutaAnt.indexOf(ruta) >= 0 || ruta.indexOf(rutaAnt) >= 0) {
	        this.$window.setTimeout(function () {
	          _this3.refresh();
	        }, 400);
	      }
	    }
	  }]);
	
	  return NavbarController;
	}();
	
	exports.default = NavbarController;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(193);
	
	var _sidenav = __webpack_require__(709);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _sidenav3 = __webpack_require__(339);
	
	var _sidenav4 = _interopRequireDefault(_sidenav3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidenavComponent = {
	    bindings: {},
	    template: _sidenav2.default,
	    controller: _sidenav4.default
	};
	
	exports.default = SidenavComponent;

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SidenavController = function () {
	    SidenavController.$inject = ["$location", "Storage", "Util", "BreadcrumbFactory", "SidenavFactory", "Auth", "systemName", "Filter"];
	    function SidenavController($location, Storage, Util, BreadcrumbFactory, SidenavFactory, Auth, systemName, Filter) {
	        "ngInject";
	
	        _classCallCheck(this, SidenavController);
	
	        this.$location = $location;
	        this.Storage = Storage;
	        this.Util = Util;
	        this.BreadcrumbFactory = BreadcrumbFactory;
	        this.SidenavFactory = SidenavFactory;
	        this.Auth = Auth;
	        this.Filter = Filter;
	        this.systemName = systemName;
	    }
	
	    _createClass(SidenavController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var color = ['info', 'success', 'danger', 'warning', 'primary'];
	
	            this.url = this.$location.path().replace('/', '');
	
	            if (this.Storage.existUser()) {
	                this.SidenavFactory.setUser(this.Storage.getUser());
	                this.SidenavFactory.setMenu(this.Storage.get('menu'));
	                this.SidenavFactory.setVisible(this.Storage.get('visible'));
	                this.SidenavFactory.setSidenav(this.Storage.get('sidenav'));
	            }
	            this.menu = this.SidenavFactory.getMenu();
	            this.Storage.set('menu', this.menu);
	
	            this.SidenavFactory.userColor = color[parseInt(Math.random() * color.length)];
	
	            window.setTimeout(function () {
	                var el = document.querySelector('#sidenav-menu .sidenav-submenu-item.active');
	                if (el) {
	                    el.parentNode.parentNode.previousElementSibling.dispatchEvent(new window.Event('click'));
	                }
	            }, 500);
	        }
	    }, {
	        key: 'send',
	        value: function send(url, submenu) {
	            if (typeof submenu == 'undefined') {
	                if (this.Storage.exist('menu')) {
	                    var page = this.Util.getMenuOption(this.Storage.get('menu'), url);
	                    this.BreadcrumbFactory.setParent(page[0]);
	                    this.BreadcrumbFactory.setCurrent(page[1]);
	                }
	                var el = document.querySelector('#sidenav-menu .sidenav-submenu-item.active');
	                if (el) {
	                    el.classList.remove('active');
	                }
	                if (!this.Filter.empty(url)) {
	                    el = document.querySelector('#sidenav-menu .sidenav-submenu-item[data-url=' + url + ']');
	                    if (el) {
	                        el.classList.add('active');
	                    }
	                }
	                this.$location.path(url).replace();
	            }
	        }
	    }, {
	        key: 'getColor',
	        value: function getColor() {
	            return this.SidenavFactory.userColor;
	        }
	    }, {
	        key: 'getName',
	        value: function getName() {
	            var user = this.SidenavFactory.getUser();
	            if (user) {
	                user = user.usuario || user.username;
	                if (user && user.split('@').length > 1) {
	                    user = user.split('@')[0];
	                }
	                return user;
	            }
	            return "";
	        }
	    }, {
	        key: 'getEmail',
	        value: function getEmail() {
	            return this.SidenavFactory.getUser().email;
	        }
	    }, {
	        key: 'getInitial',
	        value: function getInitial() {
	            var firstName;
	            if (this.SidenavFactory.getUser().usuario) {
	                firstName = this.SidenavFactory.getUser().usuario;
	                return firstName.length ? firstName[0].toUpperCase() : '?';
	            } else if (this.SidenavFactory.getUser().username) {
	                firstName = this.SidenavFactory.getUser().username;
	                return firstName.length ? firstName[0].toUpperCase() : '?';
	            }
	            return '?';
	        }
	    }, {
	        key: 'getMenu',
	        value: function getMenu() {
	            return this.SidenavFactory.getMenu();
	        }
	    }, {
	        key: 'getVisible',
	        value: function getVisible() {
	            return this.SidenavFactory.getVisible();
	        }
	    }, {
	        key: 'getSidenav',
	        value: function getSidenav() {
	            return this.SidenavFactory.getSidenav();
	        }
	    }, {
	        key: 'setVisible',
	        value: function setVisible(visible) {
	            this.Storage.set('visible', visible);
	            this.SidenavFactory.setVisible(visible);
	        }
	    }, {
	        key: 'setSidenav',
	        value: function setSidenav(sidenav) {
	            this.Storage.set('sidenav', sidenav);
	            this.SidenavFactory.setSidenav(sidenav);
	        }
	    }]);
	
	    return SidenavController;
	}();
	
	exports.default = SidenavController;

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SidenavFactory = function SidenavFactory() {
	
	    var factory = {
	        user: {
	            id: '',
	            first_name: '',
	            last_name: '',
	            cargo: '',
	            email: '',
	            photo: '',
	            nit: '',
	            user: ''
	        },
	        userColor: '',
	        menu: [],
	        rol: '',
	        visible: true,
	        sidenav: true,
	        getMenu: function getMenu() {
	            return this.menu;
	        },
	        setMenu: function setMenu(menu) {
	            this.menu = menu;
	        },
	        getUser: function getUser() {
	            return this.user;
	        },
	        setUser: function setUser(user) {
	            this.user = user;
	        },
	        getRol: function getRol() {
	            return this.rol;
	        },
	        setRol: function setRol(rol) {
	            this.rol = rol;
	        },
	        getVisible: function getVisible() {
	            return this.visible;
	        },
	        setVisible: function setVisible(visible) {
	            this.visible = visible;
	        },
	        getSidenav: function getSidenav() {
	            return this.sidenav;
	        },
	        setSidenav: function setSidenav(sidenav) {
	            this.sidenav = sidenav;
	        }
	    };
	
	    return factory;
	};
	
	exports.default = SidenavFactory;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _sidenav = __webpack_require__(338);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _sidenav3 = __webpack_require__(342);
	
	var _sidenav4 = _interopRequireDefault(_sidenav3);
	
	var _sidenav5 = __webpack_require__(340);
	
	var _sidenav6 = _interopRequireDefault(_sidenav5);
	
	var _toggleMenu = __webpack_require__(343);
	
	var _toggleMenu2 = _interopRequireDefault(_toggleMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sidenav = angular.module('app.sidenav', []).service('Sidenav', _sidenav4.default).component('appSidenav', _sidenav2.default).directive('toggleMenu', function () {
	    return new _toggleMenu2.default();
	}).factory('SidenavFactory', _sidenav6.default).name;
	
	exports.default = Sidenav;

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SidenavService = function () {
	    SidenavService.$inject = ["$location", "Filter"];
	    function SidenavService($location, Filter) {
	        'ngInject';
	
	        _classCallCheck(this, SidenavService);
	
	        this.$location = $location;
	        this.Filter = Filter;
	    }
	
	    _createClass(SidenavService, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'path',
	        value: function path(url) {
	            var _this = this;
	
	            this.$location.path(url).replace();
	
	            setTimeout(function () {
	                var origin = null;
	                var el = document.querySelector('#sidenav-menu .sidenav-submenu-item.active');
	                if (el) {
	                    el.classList.remove('active');
	                    origin = el.parentNode.parentNode.previousElementSibling.getAttribute('data-url');
	                }
	
	                if (!_this.Filter.empty(url)) {
	                    el = document.querySelector('#sidenav-menu .sidenav-submenu-item[data-url=' + url + ']');
	                    if (el) {
	                        el.classList.add('active');
	                        el = el.parentNode.parentNode.previousElementSibling;
	                        if (el.getAttribute('data-url') != origin) {
	                            el.dispatchEvent(new window.Event('click'));
	                        }
	                    }
	                }
	            }, 100);
	        }
	    }]);
	
	    return SidenavService;
	}();
	
	exports.default = SidenavService;

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ToggleMenu = function () {
	    function ToggleMenu() {
	        _classCallCheck(this, ToggleMenu);
	
	        this.restrict = 'A';
	    }
	
	    _createClass(ToggleMenu, [{
	        key: 'link',
	        value: function link($scope, $elem) {
	            $elem.on('click', function (e) {
	                e.preventDefault();
	
	                var $submenu = $elem.next();
	                var $items = $submenu.find('a');
	
	                if ($items.length) {
	                    if ($elem.parent().hasClass('sidenav-open')) {
	                        $elem.next().css('height', 0);
	                        $elem.parent().removeClass('sidenav-open');
	                        $elem.removeClass('active');
	                    } else {
	                        angular.forEach(document.querySelectorAll('#sidenav-menu .sidenav-open'), function (el) {
	                            el.querySelector('ul').style.height = 0;
	                            el.classList.remove('sidenav-open');
	                            el.querySelector('.active').classList.remove('active');
	                        });
	                        $submenu.css('height', $items.length * $items[0].offsetHeight + 20 + 'px');
	                        $elem.parent().addClass('sidenav-open');
	                        $elem.addClass('active');
	                    }
	                }
	            });
	        }
	    }]);
	
	    return ToggleMenu;
	}();
	
	exports.default = ToggleMenu;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dashboard = __webpack_require__(358);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _login = __webpack_require__(369);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _consultasqr = __webpack_require__(350);
	
	var _consultasqr2 = _interopRequireDefault(_consultasqr);
	
	var _user = __webpack_require__(396);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _usuarios = __webpack_require__(404);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _proyectos = __webpack_require__(381);
	
	var _proyectos2 = _interopRequireDefault(_proyectos);
	
	var _parametricas = __webpack_require__(375);
	
	var _parametricas2 = _interopRequireDefault(_parametricas);
	
	var _orgInstitucion = __webpack_require__(372);
	
	var _orgInstitucion2 = _interopRequireDefault(_orgInstitucion);
	
	var _techos_presupuestarios = __webpack_require__(390);
	
	var _techos_presupuestarios2 = _interopRequireDefault(_techos_presupuestarios);
	
	var _restablecer_contrasenia = __webpack_require__(384);
	
	var _restablecer_contrasenia2 = _interopRequireDefault(_restablecer_contrasenia);
	
	var _estados = __webpack_require__(365);
	
	var _estados2 = _interopRequireDefault(_estados);
	
	var _cartera = __webpack_require__(347);
	
	var _cartera2 = _interopRequireDefault(_cartera);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Admin = angular.module('app.admin', [_dashboard2.default, _login2.default, _consultasqr2.default, _user2.default, _usuarios2.default, _proyectos2.default, _parametricas2.default, _orgInstitucion2.default, _techos_presupuestarios2.default, _restablecer_contrasenia2.default, _estados2.default, _cartera2.default]).name;
	
	exports.default = Admin;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cartera = __webpack_require__(346);
	
	var _cartera2 = _interopRequireDefault(_cartera);
	
	var _cartera3 = __webpack_require__(710);
	
	var _cartera4 = _interopRequireDefault(_cartera3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var carteracomponent = {
	  controller: _cartera2.default,
	  template: _cartera4.default
	};
	
	exports.default = carteracomponent;

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CarteraController = function () {
	  CarteraController.$inject = ["DataService", "Message", "$state"];
	  function CarteraController(DataService, Message, $state) {
	    'ngInject';
	
	    _classCallCheck(this, CarteraController);
	
	    this.DataService = DataService;
	    this.Message = Message;
	    this.$state = $state;
	  }
	
	  _createClass(CarteraController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.DataService.get('cartera/', {}).then(function (response) {
	        if (response) {
	          _this.carteras = response.datos;
	        }
	      });
	    }
	  }, {
	    key: 'guardar',
	    value: function guardar() {
	      var _this2 = this;
	
	      var datos = {
	        num_cartera: this.cartera,
	        descripcion: this.descripcion,
	        _usuario_creacion: 1
	      };
	      this.DataService.post('cartera/', datos).then(function (response) {
	        if (response) {
	          _this2.Message.success('Registrado Correctamente...');
	          _this2.$state.reload();
	        }
	      });
	    }
	    // ...
	
	  }, {
	    key: 'metodoN',
	    value: function metodoN() {}
	  }]);
	
	  return CarteraController;
	}();
	
	exports.default = CarteraController;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(7);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _cartera = __webpack_require__(345);
	
	var _cartera2 = _interopRequireDefault(_cartera);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cartera = _angular2.default.module('app.admin.cartera', []).component('carteraComponent', _cartera2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('cartera', {
	    url: '/cartera',
	    component: 'carteraComponent'
	  });
	  //$urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Cartera;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _consultasqr = __webpack_require__(349);
	
	var _consultasqr2 = _interopRequireDefault(_consultasqr);
	
	var _consultasqr3 = __webpack_require__(711);
	
	var _consultasqr4 = _interopRequireDefault(_consultasqr3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consultasqrComponent = {
	    bindings: {},
	    controller: _consultasqr2.default,
	    template: _consultasqr4.default
	};
	
	exports.default = consultasqrComponent;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(712);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(351);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var consultaqrController = function () {
	  consultaqrController.$inject = ["$http", "$stateParams", "$rootScope", "$location", "$scope", "Storage", "Message", "baseUrl", "$sce", "Modal"];
	  function consultaqrController($http, $stateParams, $rootScope, $location, $scope, Storage, Message, baseUrl, $sce, Modal) {
	    'ngInject';
	
	    _classCallCheck(this, consultaqrController);
	
	    this.$stateParams = $stateParams;
	    this.$http = $http;
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.$scope = $scope;
	    this.Storage = Storage;
	    this.Message = Message;
	    this.baseUrl = baseUrl;
	    this.$sce = $sce;
	    this.Modal = Modal;
	  }
	
	  _createClass(consultaqrController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      console.log("fecha_inicio");
	      this.codProyecto = this.$stateParams.codigo;
	      console.log(this.codProyecto);
	      this.proyecto = null;
	      this.buscarProyecto();
	      console.log(this.baseUrl, "base urlllllllllll");
	    }
	  }, {
	    key: 'verArchivo',
	    value: function verArchivo() {
	      var _this = this;
	
	      this.$http({
	        method: 'GET',
	        url: this.baseUrl + ('proyectos/' + this.proyecto[0].id_proyecto + '/doc/C')
	      }).then(function (response) {
	        console.log(response, "asdfdfsdfd");
	        //this.urlIframe = this.$sce.trustAsResourceUrl(`data:application/pdf;base64,${response.data.datos.base64}`)
	        _this.urlIframe = 'data:application/pdf;base64,' + response.data.datos.base64;
	        _this.Modal.show({ data: _this.urlIframe, template: _modal2.default, controller: _modal4.default, size: 'lg' });
	      }).catch(function (error) {
	        console.log(error, "error");
	        _this.Message.error("No existe!");
	      });
	    }
	  }, {
	    key: 'buscarProyecto',
	    value: function buscarProyecto() {
	      var _this2 = this;
	
	      this.$http({
	        method: 'GET',
	        url: this.baseUrl + 'proyect?codigo=' + this.codProyecto
	      }).then(function (response) {
	        console.log(response, "respuesta con $http angular");
	        _this2.proyecto = response.data.datos;
	        console.log("antes del return::", _this2.proyecto);
	      });
	      /*this.DataService.post(`proyect/scan`,datos)
	        .then(response=>{
	          if(response){
	            this.Message.success('QR Generado Correctamente...')
	          }
	        })*/
	    }
	  }]);
	
	  return consultaqrController;
	}();
	
	exports.default = consultaqrController;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _consultasqr = __webpack_require__(348);
	
	var _consultasqr2 = _interopRequireDefault(_consultasqr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Consultasqr = angular.module('app.consultasqr', []).component('appconsultasQR', _consultasqr2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('consultasqr', {
	        url: '/consultasqr/{codigo: string}',
	        component: 'appconsultasQR',
	        params: {
	            urlProcesado: ''
	        }
	    });
	}]).name;
	
	exports.default = Consultasqr;

/***/ }),
/* 351 */
244,
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(353);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(713);
	
	var _button4 = _interopRequireDefault(_button3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CodigoConvenioComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _button2.default,
	  template: _button4.default
	};
	
	exports.default = CodigoConvenioComponent;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(354);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(714);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CodigoConvenioController = function () {
	  CodigoConvenioController.$inject = ["Modal"];
	  function CodigoConvenioController(Modal) {
	    'ngInject';
	
	    _classCallCheck(this, CodigoConvenioController);
	
	    this.Modal = Modal;
	  }
	
	  _createClass(CodigoConvenioController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'getIcon',
	    value: function getIcon() {
	      return this.proyecto.estado == 'INACTIVO' ? 'fa-eye' : 'fa-eye-slash';
	    }
	  }, {
	    key: 'getTooltip',
	    value: function getTooltip() {
	      return this.proyecto.estado == 'INACTIVO' ? 'ACTIVAR' : 'INACTIVAR';
	    }
	  }, {
	    key: 'verRegistro',
	    value: function verRegistro() {
	      this.Modal.show({
	        template: _modal4.default,
	        controller: _modal2.default,
	        data: this.proyecto,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return CodigoConvenioController;
	}();
	
	exports.default = CodigoConvenioController;

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CambiarCodigoController = function () {
	  CambiarCodigoController.$inject = ["$uibModalInstance", "data", "DataService", "Message", "Modal", "$state"];
	  function CambiarCodigoController($uibModalInstance, data, DataService, Message, Modal, $state) {
	    'ngInject';
	
	    _classCallCheck(this, CambiarCodigoController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.proyecto = data;
	    this.Modal = Modal;
	    this.duplicados = [];
	    this.$state = $state;
	  }
	
	  _createClass(CambiarCodigoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/duplicados', {}).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this.duplicados = resp.datos;
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'corregir',
	    value: function corregir() {
	      var _this2 = this;
	
	      this.Modal.confirm('¿Esta seguro/a de modificar los datos? Deberá regenerar los documentos de evaluacion y/o informes.', function () {
	        var datos = {
	          id_proyecto: _this2.proyecto.id_proyecto,
	          nro_convenio: '' + _this2.proyecto.nro_convenio
	        };
	        _this2.DataService.put('proyectos/' + _this2.proyecto.id_proyecto, datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this2.Message.success(resp.mensaje);
	            _this2.$uibModalInstance.close(false);
	            _this2.$state.reload();
	          }
	        });
	      }, null, 'Modificar datos', 'Si, estoy seguro/a');
	    }
	  }]);
	
	  return CambiarCodigoController;
	}();
	
	exports.default = CambiarCodigoController;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dashboard = __webpack_require__(715);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(356);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardComponent = {
	    template: _dashboard2.default,
	    controller: _dashboard4.default
	};
	
	exports.default = DashboardComponent;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dashboardModalController = __webpack_require__(357);
	
	var _dashboardModalController2 = _interopRequireDefault(_dashboardModalController);
	
	var _dashboardModal = __webpack_require__(716);
	
	var _dashboardModal2 = _interopRequireDefault(_dashboardModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DashboardController = function () {
	  DashboardController.$inject = ["apiUrl", "Message", "Modal", "Loading", "$log", "helpLang"];
	  function DashboardController(apiUrl, Message, Modal, Loading, $log, helpLang) {
	    'ngInject';
	
	    _classCallCheck(this, DashboardController);
	
	    this.dt = new Date();
	    this.Message = Message;
	    this.Modal = Modal;
	    this.apiUrl = apiUrl;
	    this.Loading = Loading;
	    this.helpLang = helpLang;
	    this.$log = $log;
	  }
	
	  _createClass(DashboardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.items = [{ value: 1, text: 'Item uno' }, { value: 2, text: 'Item dos' }, { value: 3, text: 'Item tres' }, { value: 4, text: 'Item cuatro' }, { value: 5, text: 'Item cinco' }];
	
	      // Configuración para el datepicker
	      this.dateOptions = {
	        maxDate: new Date(2020, 5, 22),
	        minDate: new Date(),
	        startingDay: 1,
	        showWeeks: false
	      };
	
	      // Configuración para el timepicker
	      this.mytime = new Date();
	
	      // Configuración para los tabs
	      this.tabs = [{ title: 'Título dinámico 1', content: 'Contenido dinámico 1' }, { title: 'Título dinámico 2', content: 'Contenido dinámico 2', disabled: true }];
	
	      // Configuraciones del file upload
	      this.upload = {
	        url: 'http://posttestserver.com/post.php', // Url donde se subirá el archivo
	        onCompleteItem: function onCompleteItem(fileItem, response, status, headers) {
	          // Acción con la que se indica que se hará después de subir el archivo
	          _this.$log('file upload', fileItem, response, status, headers);
	        },
	        onCompleteAll: function onCompleteAll() {
	          // Acción con la que se indica que se hará después de subir todos los archivos
	        },
	        onAfterAddingFile: function onAfterAddingFile(fileItem) {
	          _this.$log('fileItem', fileItem);
	          // Acción con la que se indica que se hará después de agregar el archivo a la lista de archivos por subir
	        },
	        onBeforeUploadItem: function onBeforeUploadItem(item) {
	          _this.$log('item', item);
	          // Acción con la que se indica que se hará antes de subir el archivo
	        }
	      };
	    }
	
	    // Modales de ejemplo
	
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      this.Modal.show({
	        template: _dashboardModal2.default,
	        controller: _dashboardModalController2.default,
	        data: this.items,
	        size: size
	      });
	    }
	  }, {
	    key: 'openMessage',
	    value: function openMessage(type) {
	      this.Message[type]();
	    }
	  }, {
	    key: 'openAlert',
	    value: function openAlert() {
	      this.Modal.alert('¡Hola mundo!');
	    }
	  }, {
	    key: 'openConfirm',
	    value: function openConfirm() {
	      var _this2 = this;
	
	      this.Modal.confirm('¿Está seguro de continuar?', function () {
	        _this2.Modal.alert("Hola!!!");
	      });
	    }
	
	    // Loading bar
	
	  }, {
	    key: 'loadingInit',
	    value: function loadingInit() {
	      this.Loading.show();
	    }
	  }, {
	    key: 'loadingInitText',
	    value: function loadingInitText() {
	      this.Loading.show('Mensaje personalizado de carga');
	    }
	  }, {
	    key: 'loadingInitLocked',
	    value: function loadingInitLocked() {
	      var _this3 = this;
	
	      this.Loading.show('Mensaje en pantalla completa', true);
	
	      // Forzamos a terminar el loading, por defecto se cierra automáticamente cuando termina la petición
	      setTimeout(function () {
	        return _this3.Loading.hide();
	      }, 3000);
	    }
	  }, {
	    key: 'loadingEnd',
	    value: function loadingEnd() {
	      this.Loading.hide();
	    }
	  }]);
	
	  return DashboardController;
	}();
	
	exports.default = DashboardController;

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DashboardModalController = function () {
	    DashboardModalController.$inject = ["$uibModalInstance", "data"];
	    function DashboardModalController($uibModalInstance, data) {
	        'ngInject';
	
	        _classCallCheck(this, DashboardModalController);
	
	        this.items = data;
	        this.$uibModalInstance = $uibModalInstance;
	    }
	
	    _createClass(DashboardModalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            // this.selected es un dato de ejemplo
	            this.selected = {
	                item: this.items[0]
	            };
	        }
	    }, {
	        key: 'ok',
	        value: function ok() {
	            // si se quiere enviar información al contenedor padre que llamó el modal se lo hace de esta manera:
	            this.$uibModalInstance.close(this.selected.item); // this.selected.item se envía al contenedor padre que lo invocó
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$uibModalInstance.dismiss('cancel');
	        }
	    }]);
	
	    return DashboardModalController;
	}();
	
	exports.default = DashboardModalController;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dashboard = __webpack_require__(355);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dashboard = angular.module('app.admin.dashboard', []).component('appDashboard', _dashboard2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('dashboard', {
	        url: '/',
	        component: 'appDashboard'
	    });
	}]).name;
	
	exports.default = Dashboard;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(360);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(717);
	
	var _button4 = _interopRequireDefault(_button3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonEstadoComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _button2.default,
	  template: _button4.default
	};
	
	exports.default = ButtonEstadoComponent;

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EstadoController = function () {
	  EstadoController.$inject = ["Modal", "DataService", "Message"];
	  function EstadoController(Modal, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, EstadoController);
	
	    this.Modal = Modal;
	    this.DataService = DataService;
	    this.Message = Message;
	  }
	
	  _createClass(EstadoController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'getIcon',
	    value: function getIcon() {
	      return this.proyecto.estado == 'INACTIVO' ? 'fa-eye' : 'fa-eye-slash';
	    }
	  }, {
	    key: 'getTooltip',
	    value: function getTooltip() {
	      return this.proyecto.estado == 'INACTIVO' ? 'ACTIVAR' : 'INACTIVAR';
	    }
	  }, {
	    key: 'puedeCambiarEstado',
	    value: function puedeCambiarEstado() {
	      return ["RECHAZADO_FDI"].indexOf(this.proyecto.estado_proyecto) !== -1;
	    }
	  }, {
	    key: 'cambiarEstado',
	    value: function cambiarEstado() {
	      var _this = this;
	
	      var nuevoEstado = this.proyecto.estado == 'INACTIVO' ? 'ACTIVO' : 'INACTIVO';
	      this.Modal.confirm('¿Esta seguro/a de modificar el estado? No estara disponible para los demás usuarios.', function () {
	        var datos = {
	          id_proyecto: _this.proyecto.id_proyecto,
	          estado: '' + nuevoEstado
	        };
	        _this.DataService.put('proyectos/' + _this.proyecto.id_proyecto, datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this.proyecto.estado = nuevoEstado;
	            _this.Message.success(resp.mensaje);
	            _this.$state.reload();
	          }
	        });
	      }, null, 'Modificar datos', 'Si, estoy seguro/a');
	    }
	  }]);
	
	  return EstadoController;
	}();
	
	exports.default = EstadoController;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _estado_editar = __webpack_require__(362);
	
	var _estado_editar2 = _interopRequireDefault(_estado_editar);
	
	var _estado_editar3 = __webpack_require__(718);
	
	var _estado_editar4 = _interopRequireDefault(_estado_editar3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var estadoEditarComponent = {
	  bindings: {},
	  controller: _estado_editar2.default,
	  template: _estado_editar4.default
	};
	
	exports.default = estadoEditarComponent;

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EstadoEditarController = function () {
	  EstadoEditarController.$inject = ["$scope", "DataService", "Storage", "Modal", "$state", "$stateParams", "DataTable", "Proyecto", "$log", "Util", "Message"];
	  function EstadoEditarController($scope, DataService, Storage, Modal, $state, $stateParams, DataTable, Proyecto, $log, Util, Message) {
	    'ngInject';
	
	    _classCallCheck(this, EstadoEditarController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.DataTable = DataTable;
	    this.Proyecto = Proyecto;
	    this.$log = $log;
	    this.Util = Util;
	    this.Message = Message;
	  }
	
	  _createClass(EstadoEditarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.codigo = this.$stateParams.codigo == "" ? null : this.$stateParams.codigo;
	      // this.$log.log(this);
	
	      this.jsoneditorOptions = {
	        "mode": 'code'
	      };
	
	      this.getEstado();
	
	      // this.$scope.$watch('$ctrl.estado.areas', () => {
	      //   if (!this.estado.areas || this.estado.areas !== '') {
	      //     this.$log.log('El campo esta vacío!!!');
	      //   }
	      // });
	    }
	  }, {
	    key: 'getEstado',
	    value: function getEstado() {
	      var _this = this;
	
	      this.DataService.get('estados/editar/' + this.codigo).then(function (response) {
	        if (response) {
	          _this.estado = response.datos;
	        }
	      });
	    }
	  }, {
	    key: 'guardarDatos',
	    value: function guardarDatos() {
	      var _this2 = this;
	
	      if (this.estado) {
	        if (!this.estado.nombre || this.estado.nombre === '') {
	          this.Message.warning('Debe especificar un nombre');
	        }
	
	        // if (typeof this.estado.areas !== 'object' && typeof this.estado.areas !== 'array') {
	        //   this.Message.warning('El campo ´areas debe ser un objeto o un array');
	        // }
	
	        // this.DataService.save(`estados`, this.estado)
	        // .then( response => {
	        //   if (response) {
	        //     this.Message.warning(response.mensaje);
	        //     if (!this.codigo) {
	        //       this.$state.go('admin-estados');
	        //     }
	        //   }
	        // });
	
	        this.DataService.put('estados/' + this.codigo, this.estado).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this2.Message.success(resp.mensaje);
	          } else {
	            _this2.Message.warning(resp.mensaje);
	          }
	        });
	      } else {
	        this.Message.warning('No existen datos pendientes para guardar');
	      }
	    }
	
	    // alertarError() {
	    //   this.$log.log('json invalido');
	    // }
	
	  }]);
	
	  return EstadoEditarController;
	}();
	
	exports.default = EstadoEditarController;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _estados = __webpack_require__(364);
	
	var _estados2 = _interopRequireDefault(_estados);
	
	var _estados3 = __webpack_require__(719);
	
	var _estados4 = _interopRequireDefault(_estados3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EstadoComponent = {
	  bindings: {},
	  controller: _estados2.default,
	  template: _estados4.default
	};
	
	exports.default = EstadoComponent;

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EstadosController = function () {
	  EstadosController.$inject = ["$state", "DataService", "Modal", "Message"];
	  function EstadosController($state, DataService, Modal, Message) {
	    'ngInject';
	
	    _classCallCheck(this, EstadosController);
	
	    this.$state = $state;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Message = Message;
	  }
	
	  _createClass(EstadosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this = this;
	
	      var colors = {
	        INACTIVO: 'warning',
	        ACTIVO: 'success',
	        ELIMINADO: 'danger'
	      };
	      this.estados = {
	        url: 'estados',
	        // queryExtra: { fid_proyecto: this.idProyecto, origen: 'bandeja' },
	        data: {
	          formly: [{
	            key: 'codigo',
	            type: 'input',
	            templateOptions: {
	              label: 'Código',
	              type: 'text'
	            }
	          }, {
	            key: 'codigo_proceso',
	            type: 'input',
	            templateOptions: {
	              label: 'Código de proceso',
	              type: 'text'
	            }
	          }, {
	            key: 'nombre',
	            type: 'input',
	            templateOptions: {
	              label: 'Estado',
	              type: 'text'
	            }
	          }, {
	            key: 'tipo',
	            type: 'input',
	            templateOptions: {
	              label: 'Tipo',
	              type: 'text'
	            }
	          }, {
	            key: 'estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              options: [{ value: 'ACTIVO', name: 'ACTIVO' }, { value: 'INACTIVO', name: 'INACTIVO' }, { value: 'ELIMINADO', name: 'ELIMINADO' }]
	            }
	          }]
	        },
	        fields: ['codigo', 'codigo_proceso', 'nombre', 'tipo', 'estado'],
	        permission: {
	          create: false,
	          update: true,
	          delete: false,
	          filter: false
	        },
	        labels: { update: 'Recargar tabla' },
	        eventEdit: function eventEdit(estado) {
	          _this.$state.go('estados/editar', { codigo: estado.codigo });
	        },
	        clases: {
	          'estado': function estado(item) {
	            return ['badge', 'badge-' + colors[item.estado]];
	          }
	        }
	      };
	    }
	
	    // reestablecerValores() {
	    //   this.Modal.confirm(`¿Está seguro/a de reestablecer los valores de los montos usados en cada municipio? Este cambio no podrá ser revertido.`, () => {
	    //     this.DataService.put(`techo_presupuestario/reestablecer`, {reestablecer: true}).then((resp) => {
	    //       if (resp && resp.finalizado) {
	    //         this.Message.success('Se han reestablecido los valores por defecto correctamente');
	    //         this.$state.reload();
	    //       }
	    //     });
	    //   }, null, null, 'Si estoy seguro/a', '');
	    // }
	
	  }]);
	
	  return EstadosController;
	}();
	
	exports.default = EstadosController;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _estados = __webpack_require__(363);
	
	var _estados2 = _interopRequireDefault(_estados);
	
	var _estado_editar = __webpack_require__(361);
	
	var _estado_editar2 = _interopRequireDefault(_estado_editar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminEstados = angular.module('app.estados', []).component('adminEstados', _estados2.default).component('estadoEditar', _estado_editar2.default).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin-estados', {
	    url: '/admin-estados',
	    component: 'adminEstados'
	  }).state('estados/editar', {
	    url: '/estados/editar/:codigo',
	    component: 'estadoEditar'
	  });
	}]).name;
	
	exports.default = adminEstados;

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthService = function () {
	    AuthService.$inject = ["$http", "$auth", "$location", "$rootScope", "Filter", "$uibModalStack", "Storage", "SidenavFactory", "BreadcrumbFactory", "Util", "timeSessionExpired", "Message", "$log"];
	    function AuthService($http, $auth, $location, $rootScope, Filter, $uibModalStack, Storage, SidenavFactory, BreadcrumbFactory, Util, timeSessionExpired, Message, $log) {
	        "ngInject";
	
	        _classCallCheck(this, AuthService);
	
	        this.$http = $http;
	        this.$auth = $auth;
	        this.$rootScope = $rootScope;
	        this.$uibModalStack = $uibModalStack;
	        this.$location = $location;
	        this.Storage = Storage;
	        this.Util = Util;
	        this.Message = Message;
	        this.Filter = Filter;
	        this.$log = $log;
	        this.SidenavFactory = SidenavFactory;
	        this.BreadcrumbFactory = BreadcrumbFactory;
	        this.timeSessionExpired = timeSessionExpired;
	    }
	
	    _createClass(AuthService, [{
	        key: 'signin',
	        value: function signin(data, url) {
	            var _this = this;
	
	            this.$auth.login(data, url).then(function (response) {
	                var user = response.data.datos.usuario;
	                var menu = response.data.datos.menu;
	                var rol = user.rol;
	                // data.path = data.path || 'dashboard';
	                var pathRedirect = data.path || response.data.datos.menuEntrar;
	                user.pathLogin = data.pathLogin || 'login';
	
	                _this.$rootScope.auth = true;
	
	                // Set user
	                user.pathInicio = pathRedirect;
	                _this.SidenavFactory.setUser(user);
	                _this.Storage.setUser(user);
	
	                // Set Menu
	                _this.SidenavFactory.setMenu(menu);
	                _this.Storage.set('menu', _this.SidenavFactory.getMenu());
	
	                // Set rol
	                _this.SidenavFactory.setRol(rol);
	                _this.Storage.set('rol', _this.SidenavFactory.getRol());
	
	                // Set Visible
	                _this.SidenavFactory.setVisible(data.menu === undefined ? true : data.menu);
	                _this.Storage.set('visible', _this.SidenavFactory.getVisible());
	
	                // Set Sidenav
	                _this.SidenavFactory.setSidenav(data.sidenav === undefined ? true : data.sidenav);
	                _this.Storage.set('sidenav', _this.SidenavFactory.getSidenav());
	
	                var path = pathRedirect || _this.Storage.get('path');
	
	                if (path) {
	                    var route = path.replace('/', '');
	
	                    // Set breadcrumb
	                    var page = _this.Util.getMenuOption(_this.Storage.get('menu'), route);
	                    _this.BreadcrumbFactory.setParent(page[0]);
	                    _this.BreadcrumbFactory.setCurrent(page[1]);
	                }
	
	                _this.timerSession();
	
	                // Redirect to dashboard
	                _this.$location.path(path && path.indexOf('login') == -1 ? path : data.path || '/').replace();
	            }).catch(function (error) {
	                if (error.data && error.data.mensaje) {
	                    _this.Message.error(error.data.mensaje);
	                } else {
	                    _this.Message.error('No se pudo conectar con el servicio, por favor revise su conexión a internet o intente nuevamente más tarde.');
	                }
	            });
	        }
	    }, {
	        key: 'timerSession',
	        value: function timerSession() {
	            // Definiendo el tiempo que dura una sesión sin actividad
	            angular.TIME = this.timeSessionExpired * 60;
	            var ctrl = this;
	            angular.sessionInterval = window.setInterval(function () {
	                angular.TIME--;
	                if (angular.TIME <= 0) {
	                    angular.expired = true;
	                    ctrl.logout();
	                }
	            }, 1000);
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            var _this2 = this;
	
	            var pathLogin = 'login';
	            if (this.Storage.existUser() && this.Storage.getUser() && this.Storage.getUser().pathLogin) {
	                pathLogin = this.Storage.getUser().pathLogin;
	            }
	
	            this.$auth.logout().then(function () {
	
	                if (angular.sessionInterval) {
	                    window.clearInterval(angular.sessionInterval);
	                    angular.sessionInterval = null;
	                }
	
	                setTimeout(function () {
	                    _this2.$uibModalStack.dismissAll('Cerrando sesión');
	                }, 1000);
	
	                _this2.Storage.removeUser();
	                _this2.Storage.remove('menu');
	                _this2.Storage.remove('visible');
	                _this2.Storage.remove('rol');
	                _this2.Storage.remove('sidenav');
	                _this2.Storage.remove('dateNow');
	                // this.Storage.remove('path');
	
	                _this2.SidenavFactory.setUser({});
	                _this2.SidenavFactory.setMenu([]);
	                _this2.SidenavFactory.setVisible(false);
	
	                if (angular.expired) {
	                    _this2.Storage.set('expired', true);
	                    delete angular.expired;
	                }
	                _this2.$location.path(pathLogin).replace();
	            });
	        }
	    }, {
	        key: 'isAuthenticated',
	        value: function isAuthenticated() {
	            return this.$auth.isAuthenticated();
	        }
	    }]);
	
	    return AuthService;
	}();
	
	exports.default = AuthService;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _login = __webpack_require__(368);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(720);
	
	var _login4 = _interopRequireDefault(_login3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginComponent = {
	    bindings: {},
	    controller: _login2.default,
	    template: _login4.default
	};
	
	exports.default = LoginComponent;

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	  LoginController.$inject = ["$rootScope", "$location", "$scope", "Storage", "Message", "timeSessionExpired", "Auth", "authUrl", "authEmpresasUrl", "DataService", "apiUrlPublic"];
	  function LoginController($rootScope, $location, $scope, Storage, Message, timeSessionExpired, Auth, authUrl, authEmpresasUrl, DataService, apiUrlPublic) {
	    'ngInject';
	
	    _classCallCheck(this, LoginController);
	
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.$scope = $scope;
	    this.Storage = Storage;
	    this.Message = Message;
	    this.Auth = Auth;
	    this.authUrl = authUrl;
	    this.authEmpresasUrl = authEmpresasUrl;
	    this.apiUrlPublic = apiUrlPublic;
	    this.timeSessionExpired = timeSessionExpired;
	    this.DataService = DataService;
	
	    this.$rootScope.auth = false;
	  }
	
	  _createClass(LoginController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$rootScope.auth = false;
	
	      if (this.Storage.exist('expired')) {
	        this.Message.warning('Su sesión ha sido cerrada automáticamente después de ' + this.timeSessionExpired + ' minutos de inactividad.', null, 0);
	        this.Storage.destroy('expired');
	      }
	      if (this.Storage.exist('menu') && this.Storage.existUser() && this.Storage.exist('token') && this.Storage.getUser().estado == 'ACTIVO') {
	        this.$rootScope.auth = true;
	        this.$location.path(this.Storage.getUser().pathInicio).replace();
	      }
	      this.$scope.$watch('$ctrl.password', function () {
	        if (_this.password) {
	          var el = document.getElementById('password');
	          if (el) {
	            angular.element(el).find('input').removeClass('not-required');
	          }
	        }
	      }, true);
	      this.$scope.$watch('$ctrl.username', function () {
	        if (_this.username) {
	          var el = document.getElementById('username');
	          if (el) {
	            angular.element(el).find('input').removeClass('not-required');
	          }
	        }
	      }, true);
	    }
	  }, {
	    key: 'signin',
	    value: function signin() {
	      this.Auth.signin({
	        username: this.username,
	        password: this.password,
	        // path: 'pendientes',
	        pathLogin: 'login',
	        menu: true,
	        sidenav: true
	      });
	    }
	  }, {
	    key: 'signinEmpresa',
	    value: function signinEmpresa() {
	      this.Auth.signin({
	        nit: this.nit,
	        usuario: this.username,
	        clave: this.password,
	        path: 'matriculas',
	        pathLogin: 'login',
	        menu: true,
	        sidenav: true
	      }, { url: this.authEmpresasUrl });
	    }
	  }, {
	    key: 'recovery',
	    value: function recovery() {
	      this.flip = true;
	      this.username = '';
	      this.password = '';
	    }
	  }, {
	    key: 'goLogin',
	    value: function goLogin() {
	      this.flip = false;
	      this.correo = '';
	    }
	  }, {
	    key: 'iniciarSesion',
	    value: function iniciarSesion() {
	      if (!this.empresa) {
	        this.signin();
	      } else {
	        this.signinEmpresa();
	      }
	    }
	  }, {
	    key: 'recuperarContrasenia',
	    value: function recuperarContrasenia() {
	      var _this2 = this;
	
	      if (!this.correo) {
	        this.Message.warning('Debe escribir su dirección de correo electrónico', null, 0);
	      } else {
	        var datos = {
	          email: this.correo
	        };
	        this.DataService.post(this.authUrl + '/restablecercontrasenia', datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this2.Message.success(resp.mensaje, null, 0);
	          }
	        });
	      }
	    }
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _login = __webpack_require__(367);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _auth = __webpack_require__(366);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	__webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Login = angular.module('app.login', []).service('Auth', _auth2.default).component('appAdminLogin', _login2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('login', {
	        url: '/login',
	        component: 'appAdminLogin'
	    }).state('logout', {
	        url: '/logout',
	        controller: ["Auth", function controller(Auth) {
	            Auth.logout();
	        }]
	    });
	}]).name;
	
	exports.default = Login;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _orgInstitucion = __webpack_require__(371);
	
	var _orgInstitucion2 = _interopRequireDefault(_orgInstitucion);
	
	var _orgInstitucion3 = __webpack_require__(721);
	
	var _orgInstitucion4 = _interopRequireDefault(_orgInstitucion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrgInstitucionComponent = {
	  bindings: {},
	  controller: _orgInstitucion2.default,
	  template: _orgInstitucion4.default
	};
	
	exports.default = OrgInstitucionComponent;

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrgInstitucionalesController = function () {
	  OrgInstitucionalesController.$inject = ["$state", "DataService", "Modal", "Message"];
	  function OrgInstitucionalesController($state, DataService, Modal, Message) {
	    'ngInject';
	
	    _classCallCheck(this, OrgInstitucionalesController);
	
	    this.$state = $state;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Message = Message;
	  }
	
	  _createClass(OrgInstitucionalesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$$obtenerorg_instituciones();
	      this.obtenerConfigParams();
	    }
	  }, {
	    key: '$$obtenerorg_instituciones',
	    value: function $$obtenerorg_instituciones() {
	      var _this = this;
	
	      this.DataService.get('parametricas/ORG_INSTITUCION').then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this.org_instituciones = [];
	          for (var i in resp.datos.rows) {
	            resp.datos.rows[i].codigo_ant = resp.datos.rows[i].codigo;
	            resp.datos.rows[i].nombre_ant = resp.datos.rows[i].nombre;
	            resp.datos.rows[i].descripcion_ant = resp.datos.rows[i].descripcion;
	            _this.org_instituciones.push(resp.datos.rows[i]);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'obtenerConfigParams',
	    value: function obtenerConfigParams() {
	      var _this2 = this;
	
	      this.DataService.get('parametricas/CONFIG').then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this2.configParams = [];
	          for (var i in resp.datos.rows) {
	            resp.datos.rows[i].codigo_ant = resp.datos.rows[i].codigo;
	            resp.datos.rows[i].nombre_ant = resp.datos.rows[i].nombre;
	            resp.datos.rows[i].descripcion_ant = resp.datos.rows[i].descripcion;
	            _this2.configParams.push(resp.datos.rows[i]);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'obtenerIncompletos',
	    value: function obtenerIncompletos() {
	      return this.org_instituciones.find(function (institucion) {
	        return !institucion.codigo || !institucion.nombre || !institucion.descripcion;
	      });
	    }
	  }, {
	    key: 'obtenerModificados',
	    value: function obtenerModificados() {
	      return this.org_instituciones.find(function (institucion) {
	        return institucion.codigo != institucion.codigo_ant || institucion.nombre != institucion.nombre_ant || institucion.descripcion != institucion.descripcion_ant;
	      });
	    }
	  }, {
	    key: 'nuevo',
	    value: function nuevo() {
	      if (!this.obtenerIncompletos() && !this.obtenerModificados()) {
	        this.org_instituciones.push({});
	      } else {
	        this.Message.warning('Debe guardar los cambios antes de agregar un nuevo parametro.');
	      }
	    }
	  }, {
	    key: 'actualizar',
	    value: function actualizar(param, type) {
	      var _this3 = this;
	
	      if (param.codigo && param.nombre && param.descripcion && (param.codigo != param.codigo_ant || param.nombre != param.nombre_ant || param.descripcion != param.descripcion_ant)) {
	        if (!param.codigo_ant) {
	          this.Modal.confirm('\xBFEst\xE1 seguro/a de agregar el nuevo c\xF3digo <b>' + param.codigo + '</b> del parametro? No podra modificar el c\xF3digo mas adelante.', function () {
	            _this3.DataService.post('parametricas/' + type, param).then(function (resp) {
	              if (resp && resp.finalizado) {
	                param.codigo_ant = param.codigo;
	                param.nombre_ant = param.nombre;
	                param.descripcion_ant = param.descripcion;
	              }
	            });
	          }, null, null, 'Si estoy seguro/a', '');
	        } else {
	          this.DataService.put('parametricas/' + type, param).then(function (resp) {
	            if (resp && resp.finalizado) {
	              param.nombre_ant = param.nombre;
	              param.descripcion_ant = param.descripcion;
	            }
	          });
	        }
	      }
	    }
	  }]);
	
	  return OrgInstitucionalesController;
	}();
	
	exports.default = OrgInstitucionalesController;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _orgInstitucion = __webpack_require__(370);
	
	var _orgInstitucion2 = _interopRequireDefault(_orgInstitucion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminproyectos = angular.module('app.org-instituciones', []).component('adminOrgInstitucion', _orgInstitucion2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('admin-org-instituciones', {
	        url: '/admin-org-instituciones',
	        component: 'adminOrgInstitucion'
	    });
	}]).name;
	
	exports.default = adminproyectos;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parametricas = __webpack_require__(374);
	
	var _parametricas2 = _interopRequireDefault(_parametricas);
	
	var _parametricas3 = __webpack_require__(722);
	
	var _parametricas4 = _interopRequireDefault(_parametricas3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ParametricasComponent = {
	  bindings: {},
	  controller: _parametricas2.default,
	  template: _parametricas4.default
	};
	
	exports.default = ParametricasComponent;

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ParametricasController = function () {
	  ParametricasController.$inject = ["$state", "DataService", "Modal", "Message"];
	  function ParametricasController($state, DataService, Modal, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ParametricasController);
	
	    this.$state = $state;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Message = Message;
	  }
	
	  _createClass(ParametricasController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$$obtenerUnidades();
	    }
	  }, {
	    key: '$$obtenerUnidades',
	    value: function $$obtenerUnidades() {
	      var _this = this;
	
	      this.DataService.get('parametricas/UNIDAD').then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this.unidades = [];
	          for (var i in resp.datos.rows) {
	            resp.datos.rows[i].codigo_ant = resp.datos.rows[i].codigo;
	            resp.datos.rows[i].nombre_ant = resp.datos.rows[i].nombre;
	            resp.datos.rows[i].descripcion_ant = resp.datos.rows[i].descripcion;
	            _this.unidades.push(resp.datos.rows[i]);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'obtenerIncompletos',
	    value: function obtenerIncompletos() {
	      return this.unidades.find(function (unidad) {
	        return !unidad.codigo || !unidad.nombre || !unidad.descripcion;
	      });
	    }
	  }, {
	    key: 'obtenerModificados',
	    value: function obtenerModificados() {
	      return this.unidades.find(function (unidad) {
	        return unidad.codigo != unidad.codigo_ant || unidad.nombre != unidad.nombre_ant || unidad.descripcion != unidad.descripcion_ant;
	      });
	    }
	  }, {
	    key: 'nuevo',
	    value: function nuevo() {
	      if (!this.obtenerIncompletos() && !this.obtenerModificados()) {
	        this.unidades.push({});
	      } else {
	        this.Message.warning('Debe guardar los cambios antes de agregar un nuevo parametro.');
	      }
	    }
	  }, {
	    key: 'actualizar',
	    value: function actualizar(unidad) {
	      var _this2 = this;
	
	      if (unidad.codigo && unidad.nombre && unidad.descripcion && (unidad.codigo != unidad.codigo_ant || unidad.nombre != unidad.nombre_ant || unidad.descripcion != unidad.descripcion_ant)) {
	        if (!unidad.codigo_ant) {
	          this.Modal.confirm('\xBFEst\xE1 seguro/a de agregar el nuevo c\xF3digo <b>' + unidad.codigo + '</b> del parametro? No podra modificar el c\xF3digo mas adelante.', function () {
	            _this2.DataService.post('parametricas/UNIDAD', unidad).then(function (resp) {
	              if (resp && resp.finalizado) {
	                unidad.codigo_ant = unidad.codigo;
	                unidad.nombre_ant = unidad.nombre;
	                unidad.descripcion_ant = unidad.descripcion;
	              }
	            });
	          }, null, null, 'Si estoy seguro/a', '');
	        } else {
	          this.DataService.put('parametricas/UNIDAD', unidad).then(function (resp) {
	            if (resp && resp.finalizado) {
	              unidad.nombre_ant = unidad.nombre;
	              unidad.descripcion_ant = unidad.descripcion;
	            }
	          });
	        }
	      }
	    }
	  }]);
	
	  return ParametricasController;
	}();
	
	exports.default = ParametricasController;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _parametricas = __webpack_require__(373);
	
	var _parametricas2 = _interopRequireDefault(_parametricas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminproyectos = angular.module('app.parametricas', []).component('adminParametricas', _parametricas2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('admin-parametricas', {
	        url: '/admin-parametricas',
	        component: 'adminParametricas'
	    });
	}]).name;
	
	exports.default = adminproyectos;

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReasignarUsuarioController = function () {
	  ReasignarUsuarioController.$inject = ["$uibModalInstance", "data", "DataService", "Message"];
	  function ReasignarUsuarioController($uibModalInstance, data, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ReasignarUsuarioController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.transicion = data.transicion;
	    this.DataService = DataService;
	    this.Message = Message;
	  }
	
	  _createClass(ReasignarUsuarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.datos = {
	        nro_usuario: this.transicion.usuario_asignado.nro,
	        nro_rol: this.transicion.usuario_asignado_rol.nro
	      };
	      var roles = [];
	      roles.push(this.transicion.usuario_asignado_rol.nro);
	      this.DataService.get('proyectos/' + this.transicion.objeto + '/usuarios?roles=[' + roles.join(',') + ']').then(function (response) {
	        if (response) {
	          _this.usuariosParaAsignar = response.datos;
	        }
	      });
	    }
	  }, {
	    key: 'reasignarUsuario',
	    value: function reasignarUsuario() {
	      var _this2 = this;
	
	      var datos = angular.copy(this.datos);
	      if (datos.seleccionado) {
	        datos.nuevo_nro_rol = datos.seleccionado.id_rol || null;
	        datos.nuevo_nro_usuario = datos.seleccionado.id_usuario || null;
	        delete datos.seleccionado;
	      }
	      this.DataService.put('adminproyectos/' + this.transicion.objeto + '/usuarios', datos).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this2.Message.success(resp.mensaje);
	          _this2.$uibModalInstance.close(true);
	          setTimeout(function () {
	            // cerrar ventana luego de 0.5s
	            window.close();
	          }, 500);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return ReasignarUsuarioController;
	}();
	
	exports.default = ReasignarUsuarioController;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datos = __webpack_require__(378);
	
	var _datos2 = _interopRequireDefault(_datos);
	
	var _datos3 = __webpack_require__(724);
	
	var _datos4 = _interopRequireDefault(_datos3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProyectoComponent = {
	  bindings: {},
	  controller: _datos2.default,
	  template: _datos4.default
	};
	
	exports.default = ProyectoComponent;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reasignarusuario = __webpack_require__(376);
	
	var _reasignarusuario2 = _interopRequireDefault(_reasignarusuario);
	
	var _reasignarusuario3 = __webpack_require__(723);
	
	var _reasignarusuario4 = _interopRequireDefault(_reasignarusuario3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProyectoController = function () {
	  ProyectoController.$inject = ["$state", "$stateParams", "DataService", "Modal"];
	  function ProyectoController($state, $stateParams, DataService, Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ProyectoController);
	
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.proyecto = {};
	  }
	
	  _createClass(ProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$$cargarDatos();
	    }
	  }, {
	    key: '$$cargarDatos',
	    value: function $$cargarDatos() {
	      var _this = this;
	
	      this.DataService.get('adminproyectos/' + this.$stateParams.codigo + '/usuarios').then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this.proyecto = resp.datos;
	        }
	      });
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor(dato) {
	      if (dato == 'TECNICO_FDI') {
	        return 'bg-warning';
	      }
	    }
	  }, {
	    key: 'reasignarUsuario',
	    value: function reasignarUsuario(transicion) {
	      var _this2 = this;
	
	      var REENVIO = this.Modal.show({
	        template: _reasignarusuario4.default,
	        controller: _reasignarusuario2.default,
	        data: {
	          transicion: transicion
	        }
	      });
	      REENVIO.result.then(function (result) {
	        if (result) {
	          _this2.$state.reload();
	        }
	      }).catch(function () {});
	    }
	  }, {
	    key: 'reasignarUsuarioProy',
	    value: function reasignarUsuarioProy(proyecto) {
	      var _this3 = this;
	
	      var transicion = {
	        objeto: proyecto.id_proyecto,
	        tipo: 'proyecto',
	        usuario_asignado: proyecto.usuario,
	        usuario_asignado_rol: proyecto.usuario_rol
	      };
	      var REENVIO = this.Modal.show({
	        template: _reasignarusuario4.default,
	        controller: _reasignarusuario2.default,
	        data: {
	          transicion: transicion
	        }
	      });
	      REENVIO.result.then(function (result) {
	        if (result) {
	          _this3.$state.reload();
	        }
	      }).catch(function () {});
	    }
	  }, {
	    key: 'usuarioEnTransiciones',
	    value: function usuarioEnTransiciones() {
	      var idBuscar = this.proyecto.usuario && this.proyecto.usuario.nro ? this.proyecto.usuario.nro : null;
	      var existe = false;
	      if (idBuscar) {
	        for (var i in this.proyecto.transicion) {
	          var usuario = this.proyecto.transicion[i].usuario_asignado;
	          if (usuario.nro === idBuscar) {
	            existe = true;
	          }
	        }
	      }
	      return existe;
	    }
	  }]);
	
	  return ProyectoController;
	}();
	
	exports.default = ProyectoController;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proyectos = __webpack_require__(380);
	
	var _proyectos2 = _interopRequireDefault(_proyectos);
	
	var _proyectos3 = __webpack_require__(725);
	
	var _proyectos4 = _interopRequireDefault(_proyectos3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProyectosComponent = {
	  bindings: {},
	  controller: _proyectos2.default,
	  template: _proyectos4.default
	};
	
	exports.default = ProyectosComponent;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProyectosController = function () {
	  ProyectosController.$inject = ["$state", "Message"];
	  function ProyectosController($state, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ProyectosController);
	
	    this.$state = $state;
	    this.Message = Message;
	  }
	
	  _createClass(ProyectosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var colors = {
	        INACTIVO: 'warning',
	        ACTIVO: 'success'
	      };
	      this.proyectos = {
	        url: 'adminproyectos',
	        queryExtra: { fid_proyecto: this.idProyecto, origen: 'bandeja' },
	        data: {
	          formly: [{
	            key: 'id_proyecto',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'version',
	            type: 'input',
	            templateOptions: {
	              label: 'Versión',
	              type: 'text'
	            }
	          }, {
	            key: 'nro_convenio',
	            type: 'input',
	            templateOptions: {
	              label: 'Código',
	              type: 'text'
	            }
	          }, {
	            key: 'nombre',
	            type: 'input',
	            templateOptions: {
	              label: 'Nombre',
	              type: 'text'
	            }
	          }, {
	            key: 'estado_proyecto',
	            type: 'input',
	            templateOptions: {
	              label: 'estado',
	              type: 'text'
	            }
	          }, {
	            key: 'estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              options: [{ value: 'ACTIVO', name: 'ACTIVO' }, { value: 'INACTIVO', name: 'INACTIVO' }]
	            }
	          }, {
	            key: '_fecha_modificacion',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha de modificación',
	              type: 'datepicker'
	            }
	          }]
	        },
	        fields: ['id_proyecto', 'version', 'codigo', 'nro_convenio', 'tipo', 'nombre', 'estado_proyecto', 'estado', '_fecha_modificacion'],
	        hiddenFields: ['id_proyecto'],
	        // fks: ['fid_formulario'],
	        permission: {
	          create: false,
	          update: true,
	          delete: false,
	          filter: false
	        },
	        labels: { create: 'NUEVO USUARIO' },
	        eventCreate: function eventCreate() {
	          _this.$state.go('adminproyectos', { codigo: null });
	        },
	        eventEdit: function eventEdit(proyecto) {
	          _this.$state.go('adminproyecto', { codigo: proyecto.id_proyecto });
	        },
	        clases: {
	          'estado': function estado(item) {
	            // this.$log.log(item);
	            return ['badge', 'badge-' + colors[item.estado]];
	          }
	        }
	      };
	    }
	  }]);
	
	  return ProyectosController;
	}();
	
	exports.default = ProyectosController;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proyectos = __webpack_require__(379);
	
	var _proyectos2 = _interopRequireDefault(_proyectos);
	
	var _datos = __webpack_require__(377);
	
	var _datos2 = _interopRequireDefault(_datos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import reconfirmacionUsuarioComponent from './reenviar-confirmacion/reconfirmacion.component';
	// import UsuariosService from './adminproyectos.service';
	
	var adminproyectos = angular.module('app.adminproyectos', []).component('adminproyectos', _proyectos2.default).component('adminproyecto', _datos2.default).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('adminproyectos', {
	    url: '/admin-proyectos',
	    component: 'adminproyectos'
	  }).state('adminproyecto', {
	    url: '/admin-proyecto/{codigo:int}',
	    component: 'adminproyecto'
	  });
	}]).name;
	
	exports.default = adminproyectos;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _restablecer_contrasenia = __webpack_require__(383);
	
	var _restablecer_contrasenia2 = _interopRequireDefault(_restablecer_contrasenia);
	
	var _restablecer_contrasenia3 = __webpack_require__(726);
	
	var _restablecer_contrasenia4 = _interopRequireDefault(_restablecer_contrasenia3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginComponent = {
	    bindings: {},
	    controller: _restablecer_contrasenia2.default,
	    template: _restablecer_contrasenia4.default
	};
	
	exports.default = LoginComponent;

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	  LoginController.$inject = ["$rootScope", "$location", "$scope", "Storage", "Message", "timeSessionExpired", "Auth", "authUrl", "authEmpresasUrl", "DataService", "apiUrlPublic", "$stateParams", "$log"];
	  function LoginController($rootScope, $location, $scope, Storage, Message, timeSessionExpired, Auth, authUrl, authEmpresasUrl, DataService, apiUrlPublic, $stateParams, $log) {
	    'ngInject';
	
	    _classCallCheck(this, LoginController);
	
	    this.$rootScope = $rootScope;
	
	    this.$scope = $scope;
	    this.Storage = Storage;
	    this.Message = Message;
	    this.Auth = Auth;
	    this.authEmpresasUrl = authEmpresasUrl;
	    this.apiUrlPublic = apiUrlPublic;
	    this.timeSessionExpired = timeSessionExpired;
	    this.DataService = DataService;
	
	    this.$rootScope.auth = false;
	
	    this.$location = $location;
	    this.$stateParams = $stateParams;
	    this.authUrl = authUrl;
	    this.$log = $log;
	  }
	
	  _createClass(LoginController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$rootScope.auth = false;
	      this.codigo = this.$stateParams.codigo == "" ? null : this.$stateParams.codigo;
	      this.pathLogin = 'login';
	
	      console.log('------------------------------------');
	      console.log('reached restablecer');
	      console.log('------------------------------------');
	      console.log(this.codigo);
	      console.log('------------------------------------');
	
	      if (!this.codigo) {
	        console.log('------------------------------------');
	        console.log('no se ha especificado un codigo');
	        console.log('------------------------------------');
	        this.$location.path(this.pathLogin);
	      }
	
	      this.verificarCodigo();
	
	      /*
	      if (this.Storage.exist('expired')) {
	          this.Message.warning('Su sesión ha sido cerrada automáticamente después de ' + this.timeSessionExpired + ' minutos de inactividad.', null, 0);
	          this.Storage.destroy('expired');
	      }
	      if (this.Storage.exist('menu') && this.Storage.existUser() && this.Storage.exist('token') && this.Storage.getUser().estado == 'ACTIVO') {
	          this.$rootScope.auth = true;
	          this.$location.path(this.Storage.getUser().pathInicio);
	      }
	      this.$scope.$watch('$ctrl.password', () => {
	        if (this.password) {
	          let el = document.getElementById('password');
	          if (el) {
	            angular.element(el).find('input').removeClass('not-required');
	          }
	        }
	      }, true);
	      this.$scope.$watch('$ctrl.username', () => {
	        if (this.username) {
	          let el = document.getElementById('username');
	          if (el) {
	            angular.element(el).find('input').removeClass('not-required');
	          }
	        }
	      }, true);
	      */
	    }
	  }, {
	    key: 'verificarCodigo',
	    value: function verificarCodigo() {
	      var _this = this;
	
	      var datos = {
	        codigo: this.codigo
	      };
	
	      this.DataService.post(this.authUrl + '/verificarcodigo', datos).then(function (resp) {
	        console.log('---------resp verificacion----------');
	        console.log(resp);
	        console.log('------------------------------------');
	        if (resp && resp.finalizado) {
	          console.log('------------------------------------');
	          console.log('codigo correcto');
	          console.log('------------------------------------');
	        } else {
	          console.log('------------------------------------');
	          console.log('el codigo no esta en DB');
	          console.log('------------------------------------');
	          _this.$location.path(_this.pathLogin);
	        }
	      }).catch(function (error) {
	        _this.$log.log(error);
	        _this.$location.path(_this.pathLogin);
	      });
	    }
	  }, {
	    key: 'inicioDeSesion',
	    value: function inicioDeSesion() {
	      this.$location.path(this.pathLogin);
	    }
	  }, {
	    key: 'cambiarContrasena',
	    value: function cambiarContrasena() {
	      var _this2 = this;
	
	      console.log('--------------------nueva-----------');
	      console.log(this.nueva);
	      console.log('--------confirmado------------------');
	      console.log(this.confirmada);
	      console.log('------------------------------------');
	      var datos = {
	        codigo: this.codigo,
	        nueva: this.nueva,
	        confirmada: this.confirmada
	      };
	      this.DataService.post(this.authUrl + '/cambiarcontrasenia', datos).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this2.Message.success(resp.mensaje, null, 0);
	          _this2.$location.path(_this2.pathLogin);
	        }
	      });
	    }
	
	    /*
	    signin() {
	        this.Auth.signin({
	            username: this.username,
	            password: this.password,
	            // path: 'pendientes',
	            pathLogin: 'login',
	            menu: true,
	            sidenav: true
	        });
	    }
	     signinEmpresa() {
	      this.Auth.signin({
	        nit: this.nit,
	        usuario: this.username,
	        clave: this.password,
	        path: 'matriculas',
	        pathLogin: 'login',
	        menu: true,
	        sidenav: true
	      }, {url: this.authEmpresasUrl});
	    }
	     recovery() {
	        this.flip = true;
	        this.username = '';
	        this.password = '';
	    }
	     goLogin() {
	        this.flip = false;
	        this.correo = '';
	    }
	     iniciarSesion() {
	      if (!this.empresa) {
	        this.signin();
	      } else {
	        this.signinEmpresa();
	      }
	    }
	     recuperarContrasenia() {
	      if (!this.correo) {
	        this.Message.warning('Debe escribir su dirección de correo electrónico', null, 0);
	      } else {
	        let datos = {
	          email: this.correo
	        }
	        this.DataService.post(`${this.authUrl}/restablecercontrasenia`, datos).then((resp) => {
	          if (resp && resp.finalizado) {
	            this.Message.success(resp.mensaje, null, 0);
	          }
	        });
	      }
	    }
	    */
	
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _restablecer_contrasenia = __webpack_require__(382);
	
	var _restablecer_contrasenia2 = _interopRequireDefault(_restablecer_contrasenia);
	
	var _restablecer_contrasenia3 = __webpack_require__(385);
	
	var _restablecer_contrasenia4 = _interopRequireDefault(_restablecer_contrasenia3);
	
	__webpack_require__(197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RestablecerContrasenia = angular.module('app.restablecerContrasenia', []).service('RestablecerContrasenia', _restablecer_contrasenia4.default).component('appAdminRestablecerContrasenia', _restablecer_contrasenia2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('restablecerContrasenia', {
	        url: '/restablecer-contrasenia/:codigo',
	        component: 'appAdminRestablecerContrasenia'
	    });
	}]).name;
	
	exports.default = RestablecerContrasenia;

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthService = function AuthService($http, $auth, $location, $rootScope, Filter, $uibModalStack, Storage, SidenavFactory, BreadcrumbFactory, Util, timeSessionExpired, Message, $log) {
	    "ngInject";
	
	    _classCallCheck(this, AuthService);
	
	    this.$http = $http;
	    this.$auth = $auth;
	    this.$rootScope = $rootScope;
	    this.$uibModalStack = $uibModalStack;
	    this.$location = $location;
	    this.Storage = Storage;
	    this.Util = Util;
	    this.Message = Message;
	    this.Filter = Filter;
	    this.$log = $log;
	    this.SidenavFactory = SidenavFactory;
	    this.BreadcrumbFactory = BreadcrumbFactory;
	    this.timeSessionExpired = timeSessionExpired;
	}
	
	/*
	signin(data, url) {
	    this.$auth.login(data, url)
	    .then(response => {
	        let user = response.data.datos.usuario;
	        let menu = response.data.datos.menu;
	        let rol = user.rol;
	        // data.path = data.path || 'dashboard';
	        let pathRedirect = data.path || response.data.datos.menuEntrar;
	        user.pathLogin = data.pathLogin || 'login';
	         this.$rootScope.auth = true;
	         // Set user
	        user.pathInicio = pathRedirect;
	        this.SidenavFactory.setUser(user);
	        this.Storage.setUser(user);
	         // Set Menu
	        this.SidenavFactory.setMenu(menu);
	        this.Storage.set('menu', this.SidenavFactory.getMenu());
	         // Set rol
	        this.SidenavFactory.setRol(rol);
	        this.Storage.set('rol', this.SidenavFactory.getRol());
	         // Set Visible
	        this.SidenavFactory.setVisible(data.menu === undefined ? true : data.menu);
	        this.Storage.set('visible', this.SidenavFactory.getVisible());
	         // Set Sidenav
	        this.SidenavFactory.setSidenav(data.sidenav === undefined ? true : data.sidenav);
	        this.Storage.set('sidenav', this.SidenavFactory.getSidenav());
	         let path = pathRedirect || this.Storage.get('path');
	         if (path) {
	            let route = path.replace('/', '');
	             // Set breadcrumb
	            let page = this.Util.getMenuOption(this.Storage.get('menu'), route);
	            this.BreadcrumbFactory.setParent(page[0]);
	            this.BreadcrumbFactory.setCurrent(page[1]);
	        }
	         this.timerSession();
	         // Redirect to dashboard
	        this.$location.path(path && path.indexOf('login') == -1 ? path : (data.path || '/'));
	    }).catch(error => {
	        if (error.data && error.data.mensaje) {
	            this.Message.error(error.data.mensaje);
	        } else {
	            this.Message.error('No se pudo conectar con el servicio, por favor revise su conexión a internet o intente nuevamente más tarde.');
	        }
	    });
	}
	 timerSession() {
	    // Definiendo el tiempo que dura una sesión sin actividad
	    angular.TIME = this.timeSessionExpired * 60;
	    var ctrl = this;
	    angular.sessionInterval = window.setInterval(function () {
	        angular.TIME--;
	        if (angular.TIME <= 0) {
	            angular.expired = true;
	            ctrl.logout();
	        }
	    }, 1000);
	}
	 logout() {
	    let pathLogin = 'login';
	    if (this.Storage.existUser() && this.Storage.getUser() && this.Storage.getUser().pathLogin) {
	        pathLogin = this.Storage.getUser().pathLogin;
	    }
	     this.$auth.logout()
	    .then(() => {
	         if (angular.sessionInterval) {
	            window.clearInterval(angular.sessionInterval);
	            angular.sessionInterval = null;
	        }
	         setTimeout(() => {
	            this.$uibModalStack.dismissAll('Cerrando sesión');
	        }, 1000);
	         this.Storage.removeUser();
	        this.Storage.remove('menu');
	        this.Storage.remove('visible');
	        this.Storage.remove('rol');
	        this.Storage.remove('sidenav');
	        this.Storage.remove('dateNow');
	        // this.Storage.remove('path');
	         this.SidenavFactory.setUser({});
	        this.SidenavFactory.setMenu([]);
	        this.SidenavFactory.setVisible(false);
	         if (angular.expired) {
	            this.Storage.set('expired', true);
	            delete angular.expired;
	        }
	        this.$location.path(pathLogin);
	    });
	}
	 isAuthenticated () {
	    return this.$auth.isAuthenticated();
	}
	*/
	;
	AuthService.$inject = ["$http", "$auth", "$location", "$rootScope", "Filter", "$uibModalStack", "Storage", "SidenavFactory", "BreadcrumbFactory", "Util", "timeSessionExpired", "Message", "$log"];
	
	exports.default = AuthService;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _techo_presupuestario = __webpack_require__(387);
	
	var _techo_presupuestario2 = _interopRequireDefault(_techo_presupuestario);
	
	var _techo_presupuestario3 = __webpack_require__(727);
	
	var _techo_presupuestario4 = _interopRequireDefault(_techo_presupuestario3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var techoPresupuestarioComponent = {
	  bindings: {},
	  controller: _techo_presupuestario2.default,
	  template: _techo_presupuestario4.default
	};
	
	exports.default = techoPresupuestarioComponent;

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TechoPresupuestarioController = function () {
	  TechoPresupuestarioController.$inject = ["$scope", "DataService", "Storage", "Modal", "$state", "$stateParams", "DataTable", "Proyecto", "$log", "Util", "Message"];
	  function TechoPresupuestarioController($scope, DataService, Storage, Modal, $state, $stateParams, DataTable, Proyecto, $log, Util, Message) {
	    'ngInject';
	
	    _classCallCheck(this, TechoPresupuestarioController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.DataTable = DataTable;
	    this.Proyecto = Proyecto;
	    this.$log = $log;
	    this.Util = Util;
	    this.Message = Message;
	  }
	
	  _createClass(TechoPresupuestarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (!this.$stateParams.gestion) {
	        this.$state.go('admin-techos-presupuestarios');
	      }
	      this.codigo = this.$stateParams.codigo == "" ? null : this.$stateParams.codigo;
	      // this.$log.log(this);
	
	      this.techo_presupuestario = {
	        estado: 'ACTIVO'
	      };
	      this.estados = [{ value: 'ACTIVO', text: 'ACTIVO' }, { value: 'INACTIVO', text: 'INACTIVO' }];
	
	      this.getTechoPresupuestario();
	
	      this.$scope.$watch('$ctrl.techo_presupuestario.techo_presupuestal', function () {
	        _this.techo_presupuestario.monto_disponible = _this.techo_presupuestario.techo_presupuestal - _this.techo_presupuestario.monto_usado;
	        if (_this.techo_presupuestario.monto_disponible < 0) {
	          _this.techo_presupuestario.monto_disponible = 0;
	        }
	      });
	    }
	  }, {
	    key: 'getTechoPresupuestario',
	    value: function getTechoPresupuestario() {
	      var _this2 = this;
	
	      this.DataService.get('techo_presupuestario/' + this.codigo + '?gestion=' + this.$stateParams.gestion).then(function (response) {
	        if (response) {
	          _this2.techo_presupuestario = response.datos;
	        }
	      });
	    }
	  }, {
	    key: 'guardarDatos',
	    value: function guardarDatos(form) {
	      var _this3 = this;
	
	      // this.$log.log(form);
	      if (form.$valid) {
	        if (this.codigo) {
	          this.techo_presupuestario.codigo = this.codigo;
	        }
	        // this.$log.log('form valido', angular.copy(this.usuario));
	        // this.DataService.save(`techo_presupuestario`, this.techo_presupuestario)
	        // .then( response => {
	        //   if (response) {
	        //     this.Message.warning(response.mensaje);
	        //     if (!this.codigo) {
	        //       this.$state.go('admin-techos-presupuestarios');
	        //     }
	        //     // this.$log.log('exacto', response);
	        //   }
	        // });
	        this.DataService.put('techo_presupuestario/' + this.codigo + '?gestion=' + this.$stateParams.gestion, this.techo_presupuestario).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this3.Message.success(resp.mensaje);
	          } else {
	            _this3.Message.warning(resp.mensaje);
	          }
	        });
	      } else {
	        this.Util.setTouchedForm(form);
	      }
	    }
	  }]);
	
	  return TechoPresupuestarioController;
	}();
	
	exports.default = TechoPresupuestarioController;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _techos_presupuestarios = __webpack_require__(389);
	
	var _techos_presupuestarios2 = _interopRequireDefault(_techos_presupuestarios);
	
	var _techos_presupuestarios3 = __webpack_require__(728);
	
	var _techos_presupuestarios4 = _interopRequireDefault(_techos_presupuestarios3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TechosPresupuestariosComponent = {
	  bindings: {},
	  controller: _techos_presupuestarios2.default,
	  template: _techos_presupuestarios4.default
	};
	
	exports.default = TechosPresupuestariosComponent;

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TechosPresupuestariosController = function () {
	  TechosPresupuestariosController.$inject = ["$state", "$stateParams", "DataService", "Modal", "Message"];
	  function TechosPresupuestariosController($state, $stateParams, DataService, Modal, Message) {
	    'ngInject';
	
	    _classCallCheck(this, TechosPresupuestariosController);
	
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Message = Message;
	  }
	
	  _createClass(TechosPresupuestariosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$$obtenerLista();
	      this.gestiones = [];
	      var gestion = new Date();
	      for (var nombre = 2018; nombre <= 1900 + gestion.getYear(); nombre++) {
	        this.gestiones.push({ nombre: nombre });
	        this.gestion = this.gestiones[this.gestiones.length - 1];
	      }
	      if (this.$stateParams.gestion) this.gestion = this.gestiones.find(function (g) {
	        return g.nombre == _this.$stateParams.gestion;
	      });
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this2 = this;
	
	      var colors = {
	        INACTIVO: 'warning',
	        ACTIVO: 'success',
	        ELIMINADO: 'danger'
	      };
	      this.techos_presupuestarios = {
	        url: 'techo_presupuestario',
	        queryExtra: { gestion: this.gestion.nombre },
	        data: {
	          formly: [{
	            key: 'codigo',
	            type: 'input',
	            templateOptions: {
	              label: 'Código',
	              type: 'number'
	            }
	          }, {
	            key: 'nombre_municipio',
	            type: 'input',
	            templateOptions: {
	              label: 'Municipio',
	              type: 'text'
	            }
	          }, {
	            key: 'techo_presupuestal',
	            type: 'input',
	            templateOptions: {
	              label: 'Techo Presupuestario [Bs]',
	              type: 'number'
	            }
	          }, {
	            key: 'monto_usado',
	            type: 'input',
	            templateOptions: {
	              label: 'Monto usado',
	              type: 'number'
	            }
	          }, {
	            key: 'monto_disponible',
	            type: 'input',
	            templateOptions: {
	              label: 'Monto Disponible',
	              type: 'number'
	            }
	          }, {
	            key: 'estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              options: [{ value: 'ACTIVO', name: 'ACTIVO' }, { value: 'INACTIVO', name: 'INACTIVO' }, { value: 'ELIMINADO', name: 'ELIMINADO' }]
	            }
	          }]
	        },
	        fields: ['codigo', 'nombre_municipio', 'techo_presupuestal', 'monto_usado', 'monto_disponible', 'estado'],
	        permission: {
	          create: false,
	          update: true,
	          delete: false,
	          filter: false
	        },
	        labels: { update: 'Recargar tabla' },
	        eventEdit: function eventEdit(techo_presupuestario) {
	          _this2.$state.go('techo_presupuestario', { codigo: techo_presupuestario.codigo, gestion: _this2.gestion.nombre });
	        },
	        clases: {
	          'estado': function estado(item) {
	            return ['badge', 'badge-' + colors[item.estado]];
	          }
	        }
	      };
	    }
	  }, {
	    key: '$$obtenerLista',
	    value: function $$obtenerLista() {
	      var _this3 = this;
	
	      this.DataService.get('techo_presupuestario').then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this3.techos_presupuestarios = [];
	          for (var i in resp.datos) {
	            resp.datos[i].codigo_ant = resp.datos[i].codigo;
	            resp.datos[i].nombre_municipio_ant = resp.datos[i].nombre_municipio;
	            resp.datos[i].techo_presupuestal_ant = resp.datos[i].techo_presupuestal;
	            resp.datos[i].monto_usado_ant = resp.datos[i].monto_usado;
	            resp.datos[i].monto_disponible_ant = resp.datos[i].monto_disponible;
	            _this3.techos_presupuestarios.push(resp.datos[i]);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'cambiarGestion',
	    value: function cambiarGestion(a) {
	      this.techos_presupuestarios.queryExtra.gestion = this.gestion.nombre;
	      this.$stateParams.gestion = a.nombre;
	      this.$state.reload();
	      // this.$state.go(`admin-techos-presupuestarios`,{gestion:a.nombre},{reload:true});
	    }
	  }, {
	    key: 'actualizar',
	    value: function actualizar(techo) {
	      var _this4 = this;
	
	      if (techo.codigo && techo.nombre_municipio && techo.techo_presupuestal && (techo.nombre_municipio != techo.nombre_municipio_ant || techo.techo_presupuestal != techo.techo_presupuestal_ant)) {
	        // if (!techo.codigo_ant) {
	        //   this.Modal.confirm(`¿Está seguro/a de agregar el nuevo código <b>${techo.codigo}</b> del parametro? No podra modificar el código mas adelante.`, ()=>{
	        //     this.DataService.post(`parametricas/UNIDAD`, techo).then((resp)=>{
	        //       if (resp && resp.finalizado) {
	        //         techo.codigo_ant = techo.codigo;
	        //         techo.nombre_ant = techo.nombre;
	        //         techo.descripcion_ant = techo.descripcion;
	        //       }
	        //     });
	        //   }, null, null, 'Si estoy seguro/a', '');
	        // } else {
	        if (techo.techo_presupuestal < techo.monto_usado) {
	          this.Message.error('El valor del techo presupuestario no puede ser inferior al monto usado actualmente');
	        } else {
	          var actualizarValor = JSON.parse(JSON.stringify(techo));
	          var codigo = techo.codigo;
	          delete actualizarValor.codigo;
	          this.DataService.put('techo_presupuestario/' + codigo, techo).then(function (resp) {
	            if (resp && resp.finalizado) {
	              _this4.Message.success('Se ha realizado el cambio correctamente');
	              techo.nombre_municipio_ant = techo.nombre_municipio;
	              techo.techo_presupuestal_ant = techo.techo_presupuestal;
	            }
	          });
	        }
	        // }
	      }
	    }
	  }, {
	    key: 'reestablecerValores',
	    value: function reestablecerValores() {
	      var _this5 = this;
	
	      this.Modal.confirm('\xBFEst\xE1 seguro/a de reestablecer los valores de los montos usados en cada municipio? Este cambio no podr\xE1 ser revertido.', function () {
	        _this5.DataService.put('techo_presupuestario/reestablecer', { reestablecer: true, gestion: _this5.gestion.nombre }).then(function (resp) {
	          if (resp && resp.finalizado) {
	            // this.$$obtenerLista();
	            _this5.Message.success('Se han reestablecido los valores por defecto correctamente');
	            _this5.$state.reload();
	          }
	        });
	      }, null, null, 'Si estoy seguro/a', '');
	    }
	  }]);
	
	  return TechosPresupuestariosController;
	}();
	
	exports.default = TechosPresupuestariosController;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _techos_presupuestarios = __webpack_require__(388);
	
	var _techos_presupuestarios2 = _interopRequireDefault(_techos_presupuestarios);
	
	var _techo_presupuestario = __webpack_require__(386);
	
	var _techo_presupuestario2 = _interopRequireDefault(_techo_presupuestario);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminTechosPresupuestarios = angular.module('app.techos_presupuestarios', []).component('adminTechosPresupuestarios', _techos_presupuestarios2.default).component('techoPresupuestario', _techo_presupuestario2.default).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin-techos-presupuestarios', {
	    url: '/admin-techos-presupuestarios',
	    component: 'adminTechosPresupuestarios',
	    params: {
	      gestion: 0
	    }
	  }).state('techo_presupuestario', {
	    url: '/techo_presupuestario/:codigo',
	    component: 'techoPresupuestario',
	    params: {
	      gestion: 0
	    }
	  });
	}]).name;
	
	exports.default = adminTechosPresupuestarios;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(392);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(729);
	
	var _button4 = _interopRequireDefault(_button3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonTimelineComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _button2.default,
	  template: _button4.default
	};
	
	exports.default = ButtonTimelineComponent;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _timeline = __webpack_require__(393);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _timeline3 = __webpack_require__(730);
	
	var _timeline4 = _interopRequireDefault(_timeline3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalTimelineController = function () {
	  ModalTimelineController.$inject = ["Modal"];
	  function ModalTimelineController(Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ModalTimelineController);
	
	    this.Modal = Modal;
	  }
	
	  _createClass(ModalTimelineController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verRegistro',
	    value: function verRegistro() {
	      this.Modal.show({
	        template: _timeline4.default,
	        controller: _timeline2.default,
	        data: this.proyecto,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return ModalTimelineController;
	}();
	
	exports.default = ModalTimelineController;

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReasignarUsuarioController = function () {
	  ReasignarUsuarioController.$inject = ["$uibModalInstance", "data", "DataService", "Message"];
	  function ReasignarUsuarioController($uibModalInstance, data, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ReasignarUsuarioController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.proyecto = data;
	  }
	
	  _createClass(ReasignarUsuarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.eventos = [];
	
	      this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/logs').then(function (resp) {
	        if (resp && resp.finalizado) {
	          for (var i in resp.datos) {
	            var persona = resp.datos[i].usuario.persona;
	            _this.eventos.push({
	              side: 'right',
	              badgeClass: 'warning',
	              badgeIconClass: 'info-circle',
	              estado: resp.datos[i].estado.nombre,
	              fecha: resp.datos[i]._fecha_creacion
	            });
	            _this.eventos.push({
	              side: 'left',
	              badgeClass: 'info',
	              badgeIconClass: resp.datos[i].observacion ? 'eye' : resp.datos[i].objeto_tipo === 'proyecto' ? 'check-circle' : 'edit',
	              nombre: persona ? (persona.nombres || '') + ' ' + (persona.primer_apellido || '') + ' ' + (persona.segundo_apellido || '') : '',
	              rol: resp.datos[i].usuario_rol.descripcion,
	              contenido: resp.datos[i].observacion,
	              fecha: resp.datos[i]._fecha_creacion
	            });
	          }
	          _this.Message.success(resp.mensaje);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return ReasignarUsuarioController;
	}();
	
	exports.default = ReasignarUsuarioController;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _user = __webpack_require__(395);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserComponent = {
	    bindings: {},
	    controller: _user2.default,
	    template: '\n        <div class="container">\n            <h2 class="page-title"><i class="fa fa-user"></i> Usuarios <small><strong>del sistema</strong></small></h2>\n            <div class="card">\n                <div class="card-body">\n                    <crud-table url="$ctrl.url"\n                                ng-title="$ctrl.title"\n                                fields="$ctrl.fields"\n                                fields-create="$ctrl.fieldsCreate"></crud-table>\n                </div>\n            </div>\n        </div>\n    '
	};
	
	exports.default = UserComponent;

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserController = function () {
	    function UserController() {
	        'ngInject';
	
	        _classCallCheck(this, UserController);
	    }
	
	    _createClass(UserController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.url = '/users/';
	            this.title = 'Usuario';
	
	            /**
	             * Campos para el listado de la tabla del crud-table
	             * @type {Array}
	             */
	            this.fields = ['id_user', 'username', 'first_name', 'last_name', 'email', 'ci', 'birthday', 'phone'];
	
	            /**
	             * Campos para el formulario de adición del crud-table
	             * @type {Array}
	             */
	            this.fieldsCreate = ['id_user', 'username', 'password', 'first_name', 'last_name', 'email', 'ci', 'birthday', 'phone'];
	        }
	    }]);
	
	    return UserController;
	}();
	
	exports.default = UserController;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _user = __webpack_require__(394);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.user', []).component('appAdminUser', _user2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('user', {
	        url: '/user',
	        component: 'appAdminUser'
	    });
	}]).name;
	
	exports.default = User;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reconfirmacion = __webpack_require__(398);
	
	var _reconfirmacion2 = _interopRequireDefault(_reconfirmacion);
	
	var _reconfirmacion3 = __webpack_require__(731);
	
	var _reconfirmacion4 = _interopRequireDefault(_reconfirmacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReconfirmacionUsuariosComponent = {
	  bindings: {
	    usuario: '=',
	    api: '@?'
	  },
	  controller: _reconfirmacion2.default,
	  template: _reconfirmacion4.default
	};
	
	exports.default = ReconfirmacionUsuariosComponent;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reconfirmacionModal = __webpack_require__(81);
	
	var _reconfirmacionModal2 = _interopRequireDefault(_reconfirmacionModal);
	
	var _reconfirmacionModal3 = __webpack_require__(94);
	
	var _reconfirmacionModal4 = _interopRequireDefault(_reconfirmacionModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReconfirmarUsuarioController = function () {
	  ReconfirmarUsuarioController.$inject = ["Modal", "DataService", "_"];
	  function ReconfirmarUsuarioController(Modal, DataService, _) {
	    'ngInject';
	
	    _classCallCheck(this, ReconfirmarUsuarioController);
	
	    this.Modal = Modal;
	    this.DataService = DataService;
	    this._ = _;
	  }
	
	  _createClass(ReconfirmarUsuarioController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'reenviarCorreo',
	    value: function reenviarCorreo() {
	      var _this = this;
	
	      var USUARIO = angular.copy(this.usuario);
	      var REENVIO = this.Modal.show({
	        template: _reconfirmacionModal4.default,
	        controller: _reconfirmacionModal2.default,
	        data: {
	          usuario: this.usuario,
	          apiExtra: this.api
	        }
	      });
	      REENVIO.result.then(function (correoReenviado) {
	        if (!correoReenviado) {
	          _this.usuario = USUARIO;
	        }
	      }).catch(function () {});
	    }
	  }]);
	
	  return ReconfirmarUsuarioController;
	}();
	
	exports.default = ReconfirmarUsuarioController;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _usuario = __webpack_require__(400);
	
	var _usuario2 = _interopRequireDefault(_usuario);
	
	var _usuario3 = __webpack_require__(732);
	
	var _usuario4 = _interopRequireDefault(_usuario3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsuarioComponent = {
	  bindings: {},
	  controller: _usuario2.default,
	  template: _usuario4.default
	};
	
	exports.default = UsuarioComponent;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reconfirmacionModal = __webpack_require__(81);
	
	var _reconfirmacionModal2 = _interopRequireDefault(_reconfirmacionModal);
	
	var _reconfirmacionModal3 = __webpack_require__(94);
	
	var _reconfirmacionModal4 = _interopRequireDefault(_reconfirmacionModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsuarioController = function () {
	  UsuarioController.$inject = ["DataService", "Storage", "Modal", "$state", "$stateParams", "DataTable", "Proyecto", "$log", "Util", "Message"];
	  function UsuarioController(DataService, Storage, Modal, $state, $stateParams, DataTable, Proyecto, $log, Util, Message) {
	    'ngInject';
	
	    _classCallCheck(this, UsuarioController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.DataTable = DataTable;
	    this.Proyecto = Proyecto;
	    this.$log = $log;
	    this.Util = Util;
	    this.Message = Message;
	  }
	
	  _createClass(UsuarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.idUsuario = this.$stateParams.idUsuario == "" ? null : this.$stateParams.idUsuario;
	      // this.$log.log(this);
	
	      this.usuario = {
	        estado: 'ACTIVO',
	        // tipo_departamento: 'UNICO',
	        persona: {
	          // tipo_documento: 'TD_CI',
	        },
	        roles: []
	      };
	      this.estados = [{ value: 'ACTIVO', text: 'ACTIVO' }, { value: 'INACTIVO', text: 'INACTIVO' }];
	
	      // this.tipos_departamento = [
	      //   { value: 'UNICO', text: 'Único' },
	      //   { value: 'REG_OCC', text: 'Regional occidental' },
	      //   { value: 'REG_CEN', text: 'Regional central' },
	      //   { value: 'REG_ORI', text: 'Regional oriental' },
	      //   { value: 'TODOS', text: 'Todos' },
	      // ];
	
	      this.departamentos = [];
	
	      this.roles = [];
	      this.getUsuario();
	    }
	  }, {
	    key: 'getUsuario',
	    value: function getUsuario() {
	      var _this = this;
	
	      this.DataService.get('departamentos').then(function (response) {
	        _this.departamentos = response;
	        _this.departamentos_obj = {};
	        _this.departamentos.forEach(function (dep) {
	          if (!_this.departamentos_obj[dep.codigo]) {
	            _this.departamentos_obj[dep.codigo] = dep;
	          }
	        });
	        return _this.DataService.get('rol');
	      }).then(function (response) {
	        _this.roles = response.datos.rows;
	        _this.roles_obj = {};
	        _this.roles.forEach(function (rol) {
	          if (!_this.roles_obj[rol.id_rol]) {
	            _this.roles_obj[rol.id_rol] = rol;
	          }
	        });
	        if (_this.idUsuario) {
	          return _this.DataService.get('usuario/' + _this.idUsuario);
	        }
	      }).then(function (response) {
	        if (response) {
	          _this.usuario = response.datos;
	          // angular.extend(this.usuario, response.datos);
	          _this.usuario.usuarios_roles.forEach(function (item) {
	            _this.roles_obj[item.fid_rol].valor = true;
	          });
	          _this.usuario.fcod_departamento.forEach(function (item) {
	            _this.departamentos_obj[item].valor = true;
	          });
	        }
	      });
	    }
	  }, {
	    key: 'guardarDatos',
	    value: function guardarDatos(form) {
	      var _this2 = this;
	
	      // this.$log.log(form);
	      if (form.$valid) {
	        this.usuario.roles = [];
	        this.roles.forEach(function (rol) {
	          if (rol.valor) {
	            _this2.usuario.roles.push(rol.id_rol);
	          }
	        });
	
	        this.usuario.fcod_departamento = [];
	        this.departamentos.forEach(function (dep) {
	          if (dep.valor) {
	            _this2.usuario.fcod_departamento.push(dep.codigo);
	          }
	        });
	
	        if (this.idUsuario) {
	          this.usuario.id = this.idUsuario;
	        }
	        // this.$log.log('form valido', angular.copy(this.usuario));
	        if (this.usuario.persona && this.usuario.persona.numero_documento && this.usuario.persona.numero_documento.indexOf('-') >= 0) {
	          this.usuario.persona.numero_documento = this.usuario.persona.numero_documento.split('-')[0];
	        }
	        this.DataService.save('usuario', this.usuario).then(function (response) {
	          if (response) {
	            _this2.Message.warning(response.mensaje);
	            if (!_this2.idUsuario) {
	              _this2.$state.go('usuarios');
	            }
	            // this.$log.log('exacto', response);
	          }
	        });
	      } else {
	        this.Util.setTouchedForm(form);
	      }
	    }
	  }, {
	    key: 'reenviarContrasenia',
	    value: function reenviarContrasenia() {
	      var _this3 = this;
	
	      var USUARIO = angular.copy(this.usuario);
	      var REENVIO = this.Modal.show({
	        template: _reconfirmacionModal4.default,
	        controller: _reconfirmacionModal2.default,
	        data: {
	          usuario: this.usuario
	        }
	      });
	      REENVIO.result.then(function (correoReenviado) {
	        if (!correoReenviado) {
	          _this3.usuario = USUARIO;
	        }
	      }).catch(function () {});
	    }
	  }]);
	
	  return UsuarioController;
	}();
	
	exports.default = UsuarioController;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usuario = __webpack_require__(399);
	
	var _usuario2 = _interopRequireDefault(_usuario);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usuario = angular.module('app.usuario', []).component('usuario', _usuario2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('usuario', {
	        url: '/usuario/:idUsuario',
	        component: 'usuario'
	    });
	}]).name;
	
	exports.default = usuario;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _usuarios = __webpack_require__(403);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _usuarios3 = __webpack_require__(733);
	
	var _usuarios4 = _interopRequireDefault(_usuarios3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsuariosComponent = {
	  bindings: {},
	  controller: _usuarios2.default,
	  template: _usuarios4.default
	};
	
	exports.default = UsuariosComponent;

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsuariosController = function () {
	  UsuariosController.$inject = ["$state", "$log", "DataService", "Modal", "Message"];
	  function UsuariosController($state, $log, DataService, Modal, Message) {
	    'ngInject';
	
	    _classCallCheck(this, UsuariosController);
	
	    this.$state = $state;
	    this.$log = $log;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Message = Message;
	  }
	
	  _createClass(UsuariosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      // this.getProyecto();
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this = this;
	
	      var colors = {
	        INACTIVO: 'warning',
	        // ENVIADO: 'primary',
	        ACTIVO: 'success'
	        // INACTIVO: 'warning',
	        // OBSERVADO: 'danger',
	      };
	      this.usuarios = {
	        url: 'usuario',
	        queryExtra: { fid_proyecto: this.idProyecto, origen: 'bandeja' },
	        data: {
	          formly: [{
	            key: 'id_usuario',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          },
	          // {
	          //   key: 'fid_persona',
	          //   type: 'fid_persona',
	          //   templateOptions: {
	          //     label: 'ID proyecto',
	          //     type: 'number'
	          //   }
	          // },
	          {
	            key: 'usuario',
	            type: 'input',
	            templateOptions: {
	              label: 'Usuario',
	              type: 'text'
	            }
	          }, {
	            key: 'numero_documento',
	            type: 'input',
	            templateOptions: {
	              label: 'Nro. de documento',
	              type: 'text'
	            }
	          }, {
	            key: 'nombres',
	            type: 'input',
	            templateOptions: {
	              label: 'Nombre(s)',
	              type: 'text'
	            }
	          }, {
	            key: 'primer_apellido',
	            type: 'input',
	            templateOptions: {
	              label: 'Ap. Paterno',
	              type: 'text'
	            }
	          }, {
	            key: 'segundo_apellido',
	            type: 'input',
	            templateOptions: {
	              label: 'Ap. Materno',
	              type: 'text'
	            }
	          }, {
	            key: 'correo',
	            type: 'input',
	            templateOptions: {
	              label: 'Email',
	              type: 'text'
	            }
	          }, {
	            key: 'roles',
	            type: 'extra',
	            templateOptions: {
	              label: 'Roles',
	              type: 'hidden'
	            }
	          }, {
	            key: 'departamentos',
	            type: 'extra',
	            templateOptions: {
	              label: 'Departamentos',
	              type: 'hidden'
	            }
	          }, {
	            key: 'estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              options: [{ value: 'ACTIVO', name: 'ACTIVO' }, { value: 'INACTIVO', name: 'INACTIVO' }, { value: 'ELIMINADO', name: 'ELIMINADO' }]
	            }
	          }]
	        },
	        fields: ['id_usuario', 'usuario', 'fid_persona', 'numero_documento', 'nombres', 'primer_apellido', 'segundo_apellido', 'correo', 'roles', 'departamentos', 'estado', '_fecha_modificación'],
	        hiddenFields: ['id_usuario', 'fid_persona'],
	        // fks: ['fid_formulario'],
	        permission: {
	          create: true,
	          update: true,
	          delete: false,
	          filter: false
	        },
	        labels: { create: 'NUEVO USUARIO' },
	        eventCreate: function eventCreate() {
	          _this.$state.go('usuario', { idUsuario: null });
	        },
	        eventEdit: function eventEdit(usuario) {
	          _this.$state.go('usuario', { idUsuario: usuario.id_usuario });
	        },
	        clases: {
	          'estado': function estado(item) {
	            // this.$log.log(item);
	            return ['badge', 'badge-' + colors[item.estado]];
	          }
	        }
	      };
	    }
	  }]);
	
	  return UsuariosController;
	}();
	
	exports.default = UsuariosController;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _usuarios = __webpack_require__(402);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _usuario = __webpack_require__(401);
	
	var _usuario2 = _interopRequireDefault(_usuario);
	
	var _reconfirmacion = __webpack_require__(397);
	
	var _reconfirmacion2 = _interopRequireDefault(_reconfirmacion);
	
	var _usuarios3 = __webpack_require__(405);
	
	var _usuarios4 = _interopRequireDefault(_usuarios3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usuarios = angular.module('app.usuarios', [_usuario2.default]).component('usuarios', _usuarios2.default).component('reconfirmacionUsuario', _reconfirmacion2.default).service('Usuarios', _usuarios4.default).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('usuarios', {
	    url: '/usuarios',
	    component: 'usuarios'
	  });
	}]).name;
	
	exports.default = usuarios;

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsuariosService = function () {
	  UsuariosService.$inject = ["Storage"];
	  function UsuariosService(Storage) {
	    'ngInject';
	
	    _classCallCheck(this, UsuariosService);
	
	    this.Storage = Storage;
	    this.usuario = this.Storage.getUser(); // Solo ejecuta la captura de usuario una vez
	  }
	
	  _createClass(UsuariosService, [{
	    key: 'getRolesResponsableGAM',
	    value: function getRolesResponsableGAM() {
	      return ['RESP_GAM_GAIOC'];
	    }
	  }, {
	    key: 'getRolesSupervisor',
	    value: function getRolesSupervisor() {
	      return ['SUPERVISOR_FDI'];
	    }
	  }, {
	    key: 'getRolesResponsable',
	    value: function getRolesResponsable() {
	      return ['TECNICO_FDI', 'RESP_GAM_GAIOC', 'MAE_FDI', 'JEFE_REVISION_FDI', 'VISOR_REPORTES', 'FISCAL_FDI'];
	    }
	  }, {
	    key: 'getRolesTecnico',
	    value: function getRolesTecnico() {
	      return ['TECNICO_FDI'];
	    }
	  }, {
	    key: 'getRolesFiscal',
	    value: function getRolesFiscal() {
	      return ['FISCAL_FDI'];
	    }
	  }, {
	    key: 'getRolesJefeRevision',
	    value: function getRolesJefeRevision() {
	      return ['JEFE_REVISION_FDI'];
	    }
	  }, {
	    key: 'getRolesJefeCierre',
	    value: function getRolesJefeCierre() {
	      return ['JEFE_CIERRE_FDI'];
	    }
	  }, {
	    key: 'getRolesRecepcion',
	    value: function getRolesRecepcion() {
	      return ['RESP_RECEPCION_FDI'];
	    }
	  }, {
	    key: 'getRolesFinanciero',
	    value: function getRolesFinanciero() {
	      return ['FINANCIERO_FDI'];
	    }
	  }, {
	    key: 'getRolesVisorReportes',
	    value: function getRolesVisorReportes() {
	      return ['VISOR_REPORTES'];
	    }
	  }, {
	    key: 'getRolesTecnicoCierre',
	    value: function getRolesTecnicoCierre() {
	      return ['TECNICO_CIERRE'];
	    }
	  }, {
	    key: 'getRolesMae',
	    value: function getRolesMae() {
	      return ['MAE_FDI'];
	    }
	  }, {
	    key: 'esTecnicoResponsable',
	    value: function esTecnicoResponsable() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesTecnico().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esResponsableProyecto',
	    value: function esResponsableProyecto() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesResponsable().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esResponsableGAM',
	    value: function esResponsableGAM() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesResponsableGAM().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esSupervisor',
	    value: function esSupervisor() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesSupervisor().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esFiscal',
	    value: function esFiscal() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesFiscal().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esJefeRevision',
	    value: function esJefeRevision() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesJefeRevision().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esJefeCierre',
	    value: function esJefeCierre() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesJefeCierre().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esRecepcion',
	    value: function esRecepcion() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesRecepcion().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esFinanciero',
	    value: function esFinanciero() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesFinanciero().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esMae',
	    value: function esMae() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesMae().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esVisorReportes',
	    value: function esVisorReportes() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesVisorReportes().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'esTecnicoCierre',
	    value: function esTecnicoCierre() {
	      this.obtenerUsuario();
	      return this.usuario && this.usuario.rol && this.getRolesTecnicoCierre().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }, {
	    key: 'obtenerUsuario',
	    value: function obtenerUsuario() {
	      this.usuario = this.Storage.getUser();
	    }
	  }]);
	
	  return UsuariosService;
	}();
	
	exports.default = UsuariosService;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _admin = __webpack_require__(344);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _proyectos = __webpack_require__(477);
	
	var _proyectos2 = _interopRequireDefault(_proyectos);
	
	var _empresas = __webpack_require__(435);
	
	var _empresas2 = _interopRequireDefault(_empresas);
	
	var _proyectos3 = __webpack_require__(587);
	
	var _proyectos4 = _interopRequireDefault(_proyectos3);
	
	var _empresas3 = __webpack_require__(491);
	
	var _empresas4 = _interopRequireDefault(_empresas3);
	
	var _reportes = __webpack_require__(592);
	
	var _reportes2 = _interopRequireDefault(_reportes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.components', [_admin2.default, _proyectos2.default, _empresas2.default, _proyectos4.default, _empresas4.default, _reportes2.default]).name;
	
	exports.default = Components;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proyectoAdjudicado = __webpack_require__(429);
	
	var _proyectoAdjudicado2 = _interopRequireDefault(_proyectoAdjudicado);
	
	var _codigoContrato = __webpack_require__(408);
	
	var _codigoContrato2 = _interopRequireDefault(_codigoContrato);
	
	var _datosEmpresa = __webpack_require__(414);
	
	var _datosEmpresa2 = _interopRequireDefault(_datosEmpresa);
	
	var _datosAsociacion = __webpack_require__(412);
	
	var _datosAsociacion2 = _interopRequireDefault(_datosAsociacion);
	
	var _datosIntegrantes = __webpack_require__(416);
	
	var _datosIntegrantes2 = _interopRequireDefault(_datosIntegrantes);
	
	var _presupuestoItems = __webpack_require__(427);
	
	var _presupuestoItems2 = _interopRequireDefault(_presupuestoItems);
	
	var _experiencia = __webpack_require__(423);
	
	var _experiencia2 = _interopRequireDefault(_experiencia);
	
	var _empleados = __webpack_require__(418);
	
	var _empleados2 = _interopRequireDefault(_empleados);
	
	var _equipoMinimo = __webpack_require__(421);
	
	var _equipoMinimo2 = _interopRequireDefault(_equipoMinimo);
	
	var _cronogramas = __webpack_require__(410);
	
	var _cronogramas2 = _interopRequireDefault(_cronogramas);
	
	var _formularios = __webpack_require__(425);
	
	var _formularios2 = _interopRequireDefault(_formularios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CEmpresas = angular.module('app.cEmpresas', []).component('proyectoAdjudicado', _proyectoAdjudicado2.default).component('codigoContrato', _codigoContrato2.default).component('datosEmpresa', _datosEmpresa2.default).component('datosAsociacion', _datosAsociacion2.default).component('datosIntegrantes', _datosIntegrantes2.default).component('presupuestoItems', _presupuestoItems2.default).component('experienciaEmpresa', _experiencia2.default).component('empleados', _empleados2.default).component('equipoMinimo', _equipoMinimo2.default).component('cronogramas', _cronogramas2.default).component('formulariosGenerados', _formularios2.default).name;
	
	exports.default = CEmpresas;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _codigoContrato = __webpack_require__(409);
	
	var _codigoContrato2 = _interopRequireDefault(_codigoContrato);
	
	var _codigoContrato3 = __webpack_require__(734);
	
	var _codigoContrato4 = _interopRequireDefault(_codigoContrato3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CodigoContratoComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<',
	    tieneDocumentacion: '=?',
	    codigoDocumentacion: '<?'
	  },
	  controller: _codigoContrato2.default,
	  template: _codigoContrato4.default
	};
	
	exports.default = CodigoContratoComponent;

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CodigoContratoController = function () {
	  CodigoContratoController.$inject = ["Modal"];
	  function CodigoContratoController(Modal) {
	    'ngInject';
	
	    _classCallCheck(this, CodigoContratoController);
	
	    this.Modal = Modal;
	  }
	
	  _createClass(CodigoContratoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.proyecto.cod_documentacion_exp) {
	        this.tieneDocumentacion = true;
	      }
	    }
	  }, {
	    key: 'cambiarDocumentacion',
	    value: function cambiarDocumentacion() {
	      var _this = this;
	
	      this.Modal.confirm('¿Está seguro/a de modificar la información registrada de la empresa?', function () {
	        _this.tieneDocumentacion = false;
	      });
	    }
	  }, {
	    key: 'cancelarCambio',
	    value: function cancelarCambio() {
	      this.proyecto.cod_documentacion_exp = this.codigoDocumentacion;
	      this.tieneDocumentacion = true;
	    }
	  }]);
	
	  return CodigoContratoController;
	}();
	
	exports.default = CodigoContratoController;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cronogramas = __webpack_require__(411);
	
	var _cronogramas2 = _interopRequireDefault(_cronogramas);
	
	var _cronogramas3 = __webpack_require__(735);
	
	var _cronogramas4 = _interopRequireDefault(_cronogramas3);
	
	__webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cronogramasComponent = {
	  bindings: {
	    proyecto: '='
	  },
	  controller: _cronogramas2.default,
	  template: _cronogramas4.default
	};
	
	exports.default = cronogramasComponent;

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CronogramasController = function () {
	  CronogramasController.$inject = ["DataService", "_", "$log", "Modal", "apiUrl"];
	  function CronogramasController(DataService, _, $log, Modal, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, CronogramasController);
	
	    this.DataService = DataService;
	    this._ = _;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.apiUrl = apiUrl;
	  }
	
	  _createClass(CronogramasController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.documentos = this.getConfiguracion();
	      this.verificarArchivosCargados();
	    }
	  }, {
	    key: 'getConfiguracion',
	    value: function getConfiguracion() {
	      var _this = this;
	
	      return {
	        lista: [{
	          codigo: 'c_ejecucion',
	          nombre: 'Cronograma de ejecución',
	          nombre_formulario: 'Formulario A8',
	          tipo: 'A8',
	          urlDescarga: this.apiUrl + 'proyectos/' + this.proyecto.id_proyecto + '/doc/A8/descargar'
	        }, {
	          codigo: 'c_desembolsos',
	          nombre: 'Cronograma de Desembolsos',
	          nombre_formulario: 'Formulario B5',
	          tipo: 'B5',
	          urlDescarga: this.apiUrl + 'proyectos/' + this.proyecto.id_proyecto + '/doc/B5/descargar'
	        }, {
	          codigo: 'analisis_precios_unitarios',
	          nombre: 'Análisis de Precios Unitarios',
	          nombre_formulario: 'Formulario B2',
	          tipo: 'B2',
	          urlDescarga: this.apiUrl + 'proyectos/' + this.proyecto.id_proyecto + '/doc/B2/descargar'
	        }],
	        uploadCallback: function uploadCallback(file) {
	          var data = {
	            documento: angular.copy(file)
	          };
	          _this.DataService.put('proyectos/' + _this.proyecto.id_proyecto + '/doc/' + _this.getTipo(file) + '/subir', data).then(function (response) {
	            _this.$log.log('response------', response);
	            if (response && response.finalizado) {
	              _this.asignarDatos(file, response.datos.documento);
	            }
	          });
	        }
	      };
	    }
	  }, {
	    key: 'verificarArchivosCargados',
	    value: function verificarArchivosCargados() {
	      var _this2 = this;
	
	      this.documentos.lista.map(function (documento) {
	        var FORMULARIO = _this2.getFormularioRegistrado(documento);
	        if (FORMULARIO) {
	          documento.registrado = true;
	          documento.nombre_archivo = FORMULARIO.nombre_archivo;
	        }
	      });
	    }
	  }, {
	    key: 'asignarDatos',
	    value: function asignarDatos(archivo, docCreado) {
	      var index = this._.findIndex(this.documentos.lista, { codigo: archivo.name });
	      this.documentos.lista[index].base64 = archivo.base64;
	      this.documentos.lista[index].nombre_formulario = docCreado.nombre;
	      this.documentos.lista[index].nombre_archivo = docCreado.nombre_archivo;
	      this.documentos.lista[index].registrado = true;
	      var formulario = this.getFormularioRegistrado(docCreado);
	      if (!formulario) {
	        if (!this.proyecto.formularios) {
	          this.proyecto.formularios = [];
	        }
	        this.proyecto.formularios.push(docCreado);
	      } else {
	        formulario = docCreado;
	      }
	    }
	  }, {
	    key: 'getFormularioRegistrado',
	    value: function getFormularioRegistrado(documento) {
	      return this._.find(this.proyecto.formularios, { codigo_documento: documento.tipo });
	    }
	  }, {
	    key: 'cambiar',
	    value: function cambiar(documento) {
	      if (documento.registrado) {
	        this.Modal.confirm('\xBFEst\xE1 seguro/a de cambiar el ' + documento.nombre + '?', function () {
	          documento.registrado = false;
	        }, null, null, 'Si, estoy seguro', 'Cancelar');
	      }
	    }
	  }, {
	    key: 'verDocumento',
	    value: function verDocumento(documento) {
	      var URL = 'proyectos/' + this.proyecto.id_proyecto + '/doc/' + documento.tipo;
	      this.Modal.showDocumentBase64(URL, '' + documento.nombre);
	    }
	  }, {
	    key: 'getTipo',
	    value: function getTipo(archivo) {
	      return this._.find(this.documentos.lista, { codigo: archivo.name }).tipo;
	    }
	  }]);
	
	  return CronogramasController;
	}();
	
	exports.default = CronogramasController;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datosAsociacion = __webpack_require__(413);
	
	var _datosAsociacion2 = _interopRequireDefault(_datosAsociacion);
	
	var _datosAsociacion3 = __webpack_require__(736);
	
	var _datosAsociacion4 = _interopRequireDefault(_datosAsociacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosAsociacionComponent = {
	  bindings: {
	    empresa: '=',
	    asociacion: '='
	  },
	  controller: _datosAsociacion2.default,
	  template: _datosAsociacion4.default
	};
	
	exports.default = DatosAsociacionComponent;

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosAsociacionController = function DatosAsociacionController() {
	  _classCallCheck(this, DatosAsociacionController);
	};
	
	exports.default = DatosAsociacionController;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datosEmpresa = __webpack_require__(415);
	
	var _datosEmpresa2 = _interopRequireDefault(_datosEmpresa);
	
	var _datosEmpresa3 = __webpack_require__(737);
	
	var _datosEmpresa4 = _interopRequireDefault(_datosEmpresa3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosEmpresaComponent = {
	  bindings: {
	    empresa: '='
	  },
	  controller: _datosEmpresa2.default,
	  template: _datosEmpresa4.default
	};
	
	exports.default = DatosEmpresaComponent;

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosEmpresaController = function DatosEmpresaController() {
	  _classCallCheck(this, DatosEmpresaController);
	};
	
	exports.default = DatosEmpresaController;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datosIntegrantes = __webpack_require__(417);
	
	var _datosIntegrantes2 = _interopRequireDefault(_datosIntegrantes);
	
	var _datosIntegrantes3 = __webpack_require__(738);
	
	var _datosIntegrantes4 = _interopRequireDefault(_datosIntegrantes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosIntegrantesComponent = {
	  bindings: {
	    integrantes: '='
	  },
	  controller: _datosIntegrantes2.default,
	  template: _datosIntegrantes4.default
	};
	
	exports.default = DatosIntegrantesComponent;

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosIntegrantesController = function DatosIntegrantesController() {
	  _classCallCheck(this, DatosIntegrantesController);
	};
	
	exports.default = DatosIntegrantesController;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _empleados = __webpack_require__(419);
	
	var _empleados2 = _interopRequireDefault(_empleados);
	
	var _empleados3 = __webpack_require__(739);
	
	var _empleados4 = _interopRequireDefault(_empleados3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmpleadosComponent = {
	  bindings: {
	    empleados: '='
	  },
	  controller: _empleados2.default,
	  template: _empleados4.default
	};
	
	exports.default = EmpleadosComponent;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _experienciaEmpleadoModalController = __webpack_require__(420);
	
	var _experienciaEmpleadoModalController2 = _interopRequireDefault(_experienciaEmpleadoModalController);
	
	var _experienciaEmpleadoModal = __webpack_require__(740);
	
	var _experienciaEmpleadoModal2 = _interopRequireDefault(_experienciaEmpleadoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EmpleadosController = function () {
	  EmpleadosController.$inject = ["DataTable", "Modal", "$scope"];
	  function EmpleadosController(DataTable, Modal, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, EmpleadosController);
	
	    this.DataTable = DataTable;
	    this.Modal = Modal;
	    this.$scope = $scope;
	  }
	
	  _createClass(EmpleadosController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.empleados', function () {
	        _this.iniciarDatos();
	      }, true);
	    }
	  }, {
	    key: 'iniciarDatos',
	    value: function iniciarDatos() {
	      this.tableParams = this.DataTable.getParamsList(this.getFormatoLista());
	    }
	  }, {
	    key: 'getFormatoLista',
	    value: function getFormatoLista() {
	      var _this2 = this;
	
	      var lista = [];
	      this.empleados.map(function (empleado) {
	        lista.push(_this2.formatearEstructuraDatos(empleado));
	      });
	      return lista;
	    }
	  }, {
	    key: 'formatearEstructuraDatos',
	    value: function formatearEstructuraDatos(datos) {
	      return {
	        nombre: datos.nombre,
	        documento_identidad: datos.persona.documento_identidad,
	        nacionalidad: datos.persona.nacionalidad,
	        profesion: datos.profesion,
	        nro_registro_profesional: datos.nro_registro_profesional,
	        cargo_actual: datos.cargo_actual,
	        experiencias: datos.experiencias
	      };
	    }
	  }, {
	    key: 'verExperiencia',
	    value: function verExperiencia(empleado) {
	      this.Modal.show({
	        template: _experienciaEmpleadoModal2.default,
	        controller: _experienciaEmpleadoModalController2.default,
	        data: {
	          empleado: empleado
	        },
	        size: 'xlg'
	      });
	    }
	  }]);
	
	  return EmpleadosController;
	}();
	
	exports.default = EmpleadosController;

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormExperienciaEmpleadoController = function () {
	  FormExperienciaEmpleadoController.$inject = ["$uibModalInstance", "data"];
	  function FormExperienciaEmpleadoController($uibModalInstance, data) {
	    'ngInject';
	
	    _classCallCheck(this, FormExperienciaEmpleadoController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.empleado = data.empleado;
	  }
	
	  _createClass(FormExperienciaEmpleadoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.camposExperiencia = this.definirColumnasEmpleados();
	    }
	  }, {
	    key: 'definirColumnasEmpleados',
	    value: function definirColumnasEmpleados() {
	      return [{ title: 'Empresa/Entidad', field: 'nombre_empresa', filter: { nombre_empresa: "text" }, sortable: "nombre_empresa" }, { title: 'Objeto de la obra', field: 'objeto_obra', filter: { objeto_obra: "text" }, sortable: "objeto_obra" }, { title: 'Monto de la obra en Bs.', field: 'monto_obra', filter: { monto_obra: "text" }, sortable: "monto_obra" }, { title: 'Cargo', field: 'cargo', filter: { cargo: "text" }, sortable: "cargo" }, { title: 'Desde', field: 'fecha_inicio', filter: { fecha_inicio: "text" }, sortable: "fecha_inicio" }, { title: 'Hasta', field: 'fecha_fin', filter: { fecha_fin: "text" }, sortable: "fecha_fin" }];
	    }
	  }, {
	    key: 'aceptar',
	    value: function aceptar() {
	      this.$uibModalInstance.close(null);
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return FormExperienciaEmpleadoController;
	}();
	
	exports.default = FormExperienciaEmpleadoController;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _equipoMinimo = __webpack_require__(422);
	
	var _equipoMinimo2 = _interopRequireDefault(_equipoMinimo);
	
	var _equipoMinimo3 = __webpack_require__(741);
	
	var _equipoMinimo4 = _interopRequireDefault(_equipoMinimo3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EquipoMinimoComponent = {
	  bindings: {
	    equipo: '='
	  },
	  controller: _equipoMinimo2.default,
	  template: _equipoMinimo4.default
	};
	
	exports.default = EquipoMinimoComponent;

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EquipoMinimoController = function () {
	  EquipoMinimoController.$inject = ["DataTable"];
	  function EquipoMinimoController(DataTable) {
	    'ngInject';
	
	    _classCallCheck(this, EquipoMinimoController);
	
	    this.DataTable = DataTable;
	  }
	
	  _createClass(EquipoMinimoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.camposEquipo = this.definirColumnasEquipoTrabajo();
	    }
	  }, {
	    key: 'definirColumnasEquipoTrabajo',
	    value: function definirColumnasEquipoTrabajo() {
	      return [{ title: 'Descripción', field: 'descripcion', filter: { descripcion: "text" }, sortable: "descripcion" }, { title: 'Unidad', field: 'unidad', filter: { unidad: "text" }, sortable: "unidad" }, { title: 'Cantidad', field: 'cantidad', filter: { cantidad: "text" }, sortable: "cantidad" }, { title: 'Potencia', field: 'potencia', filter: { potencia: "text" }, sortable: "potencia" }, { title: 'Capacidad', field: 'capacidad', filter: { capacidad: "text" }, sortable: "capacidad" }, { title: 'Campo adicional', field: 'campo_adicional', filter: { campo_adicional: "text" }, sortable: "campo_adicional" }];
	    }
	  }]);
	
	  return EquipoMinimoController;
	}();
	
	exports.default = EquipoMinimoController;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _experiencia = __webpack_require__(424);
	
	var _experiencia2 = _interopRequireDefault(_experiencia);
	
	var _experiencia3 = __webpack_require__(742);
	
	var _experiencia4 = _interopRequireDefault(_experiencia3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExperienciaEmpresaComponent = {
	  bindings: {
	    experiencias: '='
	  },
	  controller: _experiencia2.default,
	  template: _experiencia4.default
	};
	
	exports.default = ExperienciaEmpresaComponent;

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExperienciaEmpresaController = function () {
	  ExperienciaEmpresaController.$inject = ["DataTable", "_", "Util", "$scope"];
	  function ExperienciaEmpresaController(DataTable, _, Util, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, ExperienciaEmpresaController);
	
	    this.DataTable = DataTable;
	    this._ = _;
	    this.Util = Util;
	    this.$scope = $scope;
	    this.totalDolares = 0;
	    this.totalBolivianos = 0;
	  }
	
	  _createClass(ExperienciaEmpresaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.camposExperiencia = this.definirColumnasExperiencias();
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.experiencias', function () {
	        _this.calcularSumasDeMontos();
	      }, true);
	    }
	  }, {
	    key: 'calcularSumasDeMontos',
	    value: function calcularSumasDeMontos() {
	      this.totalesExpGeneral = this.calcularSumas(this.experiencias.generales);
	      this.totalesExpEspecifica = this.calcularSumas(this.experiencias.especificas);
	    }
	  }, {
	    key: 'calcularSumas',
	    value: function calcularSumas(experiencias) {
	      var total = {
	        dolares: null,
	        bolivianos: null
	      };
	      if (this.tieneMontosEnDolaresCompletos(experiencias)) {
	        total.dolares = this.calcularTotales(experiencias, 'monto_final_contrato_sus');
	      }
	      total.bolivianos = this.calcularTotales(experiencias, 'monto_final_contrato_bs');
	      return total;
	    }
	  }, {
	    key: 'tieneMontosEnDolaresCompletos',
	    value: function tieneMontosEnDolaresCompletos(experiencias) {
	      return this._.isEmpty(this._.find(experiencias, {
	        monto_final_contrato_sus: null
	      }));
	    }
	  }, {
	    key: 'calcularTotales',
	    value: function calcularTotales(experiencias, tipo) {
	      return this.Util.redondear(this._.sum(this._.map(experiencias, tipo)));
	    }
	  }, {
	    key: 'definirColumnasExperiencias',
	    value: function definirColumnasExperiencias() {
	      return [{ title: 'Nombre del Contratante', field: 'nombre_contratante', filter: { nombre_contratante: "text" }, visible: true, sortable: "nombre_contratante" }, { title: 'Dirección de Contacto', field: 'direccion_contacto', filter: { direccion_contacto: "text" }, visible: true, sortable: "direccion_contacto" }, { title: 'Objeto de Contrato', field: 'objeto_contratacion', filter: { objeto_contratacion: "text" }, visible: true, sortable: "objeto_contratacion" }, { title: 'Ubicación', field: 'ubicacion', filter: { ubicacion: "text" }, visible: true, sortable: "ubicacion" }, { title: 'Monto Final de Contrato Bs', field: 'monto_final_contrato_bs', filter: { monto_final_contrato_bs: "number" }, visible: true, sortable: "monto_final_contrato_bs" }, { title: 'Monto Final de Contrato $us', field: 'monto_final_contrato_sus', filter: { monto_final_contrato_sus: "number" }, visible: true, sortable: "monto_final_contrato_sus" }, { title: 'Inicio', field: 'fecha_inicio_ejecucion', filter: { fecha_inicio_ejecucion: "text" }, visible: true, sortable: "fecha_inicio_ejecucion" }, { title: 'Finalización', field: 'fecha_fin_ejecucion', filter: { fecha_fin_ejecucion: "text" }, visible: true, sortable: "fecha_fin_ejecucion" }, { title: '% de Participación', field: 'participacion', filter: { participacion: "text" }, visible: true, sortable: "participacion" }, { title: 'Nombre del Socio', field: 'socio', filter: { socio: "text" }, visible: true, sortable: "socio" }, { title: 'Profesional Responsable', field: 'profesional_responsable', filter: { profesional_responsable: "text" }, visible: true, sortable: "profesional_responsable" }];
	    }
	  }]);
	
	  return ExperienciaEmpresaController;
	}();
	
	exports.default = ExperienciaEmpresaController;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formularios = __webpack_require__(426);
	
	var _formularios2 = _interopRequireDefault(_formularios);
	
	var _formularios3 = __webpack_require__(743);
	
	var _formularios4 = _interopRequireDefault(_formularios3);
	
	__webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormulariosGeneradosComponent = {
	  bindings: {
	    proyecto: '='
	  },
	  controller: _formularios2.default,
	  template: _formularios4.default
	};
	
	exports.default = FormulariosGeneradosComponent;

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormulariosGeneradosController = function () {
	  FormulariosGeneradosController.$inject = ["DataService", "$stateParams", "Message", "_", "Modal", "apiUrl"];
	  function FormulariosGeneradosController(DataService, $stateParams, Message, _, Modal, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, FormulariosGeneradosController);
	
	    this.DataService = DataService;
	    this.$stateParams = $stateParams;
	    this.Message = Message;
	    this._ = _;
	    this.Modal = Modal;
	    this.apiUrl = apiUrl;
	    this.url = '';
	  }
	
	  _createClass(FormulariosGeneradosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.url = 'proyectos/' + this.proyecto.id_proyecto + '/doc';
	      this.prepararLista();
	    }
	  }, {
	    key: 'prepararLista',
	    value: function prepararLista() {
	      var _this = this;
	
	      if (this.proyecto.formularios) {
	        this.asignarPath();
	      } else {
	        this.DataService.get(this.url).then(function (result) {
	          if (result && result.finalizado) {
	            _this.proyecto.formularios = result.datos.formularios;
	            _this.asignarPath();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'asignarPath',
	    value: function asignarPath() {
	      var _this2 = this;
	
	      this.proyecto.formularios.map(function (formulario) {
	        formulario.path = _this2.apiUrl + 'proyectos/' + _this2.proyecto.id_proyecto + '/doc/' + formulario.codigo_documento + '/descargar';
	      });
	    }
	  }, {
	    key: 'ver',
	    value: function ver(formulario) {
	      this.Modal.showDocumentBase64(this.url + '/' + formulario.codigo_documento, '' + formulario.nombre);
	    }
	  }]);
	
	  return FormulariosGeneradosController;
	}();
	
	exports.default = FormulariosGeneradosController;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _presupuestoItems = __webpack_require__(428);
	
	var _presupuestoItems2 = _interopRequireDefault(_presupuestoItems);
	
	var _presupuestoItems3 = __webpack_require__(744);
	
	var _presupuestoItems4 = _interopRequireDefault(_presupuestoItems3);
	
	__webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PresupuestoItemsComponent = {
	  bindings: {
	    proyecto: '='
	  },
	  controller: _presupuestoItems2.default,
	  template: _presupuestoItems4.default
	};
	
	exports.default = PresupuestoItemsComponent;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PresupuestoItemsController = function () {
	  PresupuestoItemsController.$inject = ["DataService", "$stateParams", "Message", "_", "Util", "Big", "decimales"];
	  function PresupuestoItemsController(DataService, $stateParams, Message, _, Util, Big, decimales) {
	    'ngInject';
	
	    _classCallCheck(this, PresupuestoItemsController);
	
	    this.DataService = DataService;
	    this.$stateParams = $stateParams;
	    this.Message = Message;
	    this._ = _;
	    this.Util = Util;
	    this.Big = Big;
	    this.decimales = decimales;
	    this.precioTotal = 0;
	  }
	
	  _createClass(PresupuestoItemsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // Monto fisico total avanzado hasta la rescision de contrato.
	      if (this.proyecto.monto_total_ejecutado) {
	        this.proyecto.monto_total_actual = this.proyecto.monto_total; // Monto total con modificaciones hasta la rescision de contrato.
	      }
	      this.proyecto.monto_total = null;
	      this.DataService.get('items/proyectos/' + this.$stateParams.codigo).then(function (response) {
	        if (response) {
	          _this.proyecto.items = response.datos.rows;
	          _this.copiarItems();
	          _this.calcularTotal();
	        }
	      });
	    }
	  }, {
	    key: 'copiarItems',
	    value: function copiarItems() {
	      this.cItems = angular.copy(this.proyecto.items);
	    }
	  }, {
	    key: 'registrarPrecioItem',
	    value: function registrarPrecioItem(item) {
	      var _this2 = this;
	
	      if (!this.esPrecioActualizado(item) || angular.isUndefined(item.precio_unitario)) {
	        return;
	      }
	      this.DataService.put('items/' + item.id_item, { precio_unitario: item.precio_unitario }).then(function (result) {
	        if (result) {
	          _this2.actualizarCopiaItems(result.datos);
	          _this2.calcularTotal();
	        }
	      });
	    }
	  }, {
	    key: 'esPrecioActualizado',
	    value: function esPrecioActualizado(item) {
	      var cItem = this.cItems[this._.findIndex(this.cItems, { id_item: item.id_item })];
	      return cItem.precio_unitario !== item.precio_unitario;
	    }
	  }, {
	    key: 'actualizarCopiaItems',
	    value: function actualizarCopiaItems(item) {
	      this.cItems[this._.findIndex(this.cItems, { id_item: item.id_item })] = item;
	    }
	  }, {
	    key: 'calcularTotal',
	    value: function calcularTotal() {
	      var _this3 = this;
	
	      this.precioTotal = 0;
	      this.proyecto.items.map(function (item) {
	        if (item.cantidad && item.precio_unitario) {
	          _this3.precioTotal = _this3.Util.sumar([_this3.precioTotal, _this3.Util.multiplicar([item.cantidad, item.precio_unitario])]);
	        }
	      });
	      this.precioTotal = this.Util.redondear(this.precioTotal);
	      if (this.esPresupuestoValido()) {
	        this.proyecto.monto_total = this.precioTotal;
	      } else {
	        this.proyecto.monto_total = null;
	        if (this.proyecto.monto_total_rest) {
	          this.Message.error('El precio total no debe ser mayor al monto total restante del proyecto.');
	        } else {
	          this.Message.error('El precio total no debe ser mayor al monto total del convenio del proyecto.');
	        }
	      }
	    }
	  }, {
	    key: 'esPresupuestoValido',
	    value: function esPresupuestoValido() {
	      if (this.proyecto.monto_total_rest) {
	        return this.precioTotal <= this.proyecto.monto_total_actual - this.proyecto.monto_total_rest;
	      }
	      return this.precioTotal <= this.proyecto.monto_total_convenio;
	    }
	  }]);
	
	  return PresupuestoItemsController;
	}();
	
	exports.default = PresupuestoItemsController;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proyectoAdjudicado = __webpack_require__(430);
	
	var _proyectoAdjudicado2 = _interopRequireDefault(_proyectoAdjudicado);
	
	var _proyectoAdjudicado3 = __webpack_require__(745);
	
	var _proyectoAdjudicado4 = _interopRequireDefault(_proyectoAdjudicado3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProyectoAdjudicadoComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _proyectoAdjudicado2.default,
	  template: _proyectoAdjudicado4.default
	};
	
	exports.default = ProyectoAdjudicadoComponent;

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProyectoAdjudicadoController = function ProyectoAdjudicadoController() {
	  _classCallCheck(this, ProyectoAdjudicadoController);
	};
	
	exports.default = ProyectoAdjudicadoController;

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ObservacionController = function () {
	    ObservacionController.$inject = ["$uibModalInstance", "data"];
	    function ObservacionController($uibModalInstance, data) {
	        'ngInject';
	
	        _classCallCheck(this, ObservacionController);
	
	        this.$uibModalInstance = $uibModalInstance;
	        this.proyecto = data;
	    }
	
	    _createClass(ObservacionController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'cerrar',
	        value: function cerrar() {
	            this.$uibModalInstance.dismiss('cancel');
	        }
	    }, {
	        key: 'aceptar',
	        value: function aceptar() {
	            this.$uibModalInstance.close(this.proyecto);
	        }
	    }]);
	
	    return ObservacionController;
	}();
	
	exports.default = ObservacionController;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _documentacionProyecto = __webpack_require__(433);
	
	var _documentacionProyecto2 = _interopRequireDefault(_documentacionProyecto);
	
	var _documentacionProyecto3 = __webpack_require__(747);
	
	var _documentacionProyecto4 = _interopRequireDefault(_documentacionProyecto3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentacionProyectoComponent = {
	  bindings: {},
	  controller: _documentacionProyecto2.default,
	  template: _documentacionProyecto4.default
	};
	
	exports.default = DocumentacionProyectoComponent;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _confirmacionModalController = __webpack_require__(431);
	
	var _confirmacionModalController2 = _interopRequireDefault(_confirmacionModalController);
	
	var _confirmacionModal = __webpack_require__(746);
	
	var _confirmacionModal2 = _interopRequireDefault(_confirmacionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DocumentacionProyectoController = function () {
	  DocumentacionProyectoController.$inject = ["$scope", "$stateParams", "Storage", "DataService", "Message", "WizardHandler", "Modal", "_", "$q", "$state", "Proyecto", "Loading"];
	  function DocumentacionProyectoController($scope, $stateParams, Storage, DataService, Message, WizardHandler, Modal, _, $q, $state, Proyecto, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, DocumentacionProyectoController);
	
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.WizardHandler = WizardHandler;
	    this.Modal = Modal;
	    this._ = _;
	    this.$q = $q;
	    this.$state = $state;
	    this.Proyecto = Proyecto;
	    this.Loading = Loading;
	    this.idProyecto = this.$stateParams.codigo;
	    this.urlProyectos = 'proyectos/' + this.idProyecto;
	    this.usuario = Storage.getUser();
	    this.tieneDocumentacion = false;
	    this.estaCompleto = false;
	  }
	
	  _createClass(DocumentacionProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.getDatosProyectoAdjudicado();
	      this.$scope.$on('refrescar-documentacion-proyecto', function () {
	        _this.$state.reload();
	        _this.WizardHandler.wizard().goTo(1);
	      });
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.tieneDocumentacion', function () {
	        if (!_this2.tieneDocumentacion && _this2.WizardHandler.wizard()) {
	          _this2.WizardHandler.wizard().reset();
	        }
	      });
	    }
	  }, {
	    key: 'getDatosProyectoAdjudicado',
	    value: function getDatosProyectoAdjudicado() {
	      var _this3 = this;
	
	      this.DataService.get('proyectos/empresas/' + this.usuario.matricula + '/' + this.idProyecto).then(function (response) {
	        if (response) {
	          _this3.proyecto = response.datos;
	          _this3.esEmpresa = _this3.proyecto.documentacion_exp && _this3.proyecto.documentacion_exp.datos_asociacion && _this3.proyecto.documentacion_exp.datos_asociacion.id_asociacion_accidental ? false : true;
	          _this3.Proyecto.setEstadoActual(_this3.proyecto.estado_actual);
	          _this3.esModoEdicion = _this3.Proyecto.esEditable('plazo_ejecucion');
	          if (_this3.existeFormulario()) {
	            _this3.codigoDocumentoProy = angular.copy(_this3.proyecto.cod_documentacion_exp);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'ejecutarAccionPaso',
	    value: function ejecutarAccionPaso() {
	      var paso = this.WizardHandler.wizard().currentStepNumber();
	      switch (paso) {
	        case 1:
	          this.verificarCodigoYContrato();
	          break;
	        default:
	          this.siguiente();
	      }
	    }
	  }, {
	    key: 'verificarCodigoYContrato',
	    value: function verificarCodigoYContrato() {
	      if (!this.proyecto.cod_documentacion_exp) {
	        this.Message.warning('Debe registrar el c\xF3digo y el n\xFAmero de invitaci\xF3n.');
	        return;
	      }
	      if (!this.tieneDocumentacion) {
	        return this.relacionarFormDocumentacionEmpresaAProyecto();
	      }
	      this.siguiente();
	    }
	  }, {
	    key: 'relacionarFormDocumentacionEmpresaAProyecto',
	    value: function relacionarFormDocumentacionEmpresaAProyecto() {
	      var _this4 = this;
	
	      if (this.existeFormulario() && this.codigoDocumentoProy === this.proyecto.cod_documentacion_exp) {
	        this.tieneDocumentacion = true;
	        this.siguiente();
	        return;
	      }
	      var data = {
	        cod_documentacion_exp: this.proyecto.cod_documentacion_exp,
	        nro_invitacion: this.proyecto.nro_invitacion
	      };
	      var ITEMS = this.proyecto.items ? this.proyecto.items : [];
	      var FORMULARIOS = this.proyecto.formularios ? this.proyecto.formularios : [];
	      var MONTO_TOTAL = this.proyecto.monto_total ? this.proyecto.monto_total : 0;
	      this.Loading.show('Obteniendo datos del formulario.', true);
	      this.DataService.put(this.urlProyectos, data).then(function (result) {
	        if (result) {
	          _this4.proyecto = result.datos;
	          _this4.proyecto.items = ITEMS;
	          _this4.proyecto.formularios = FORMULARIOS;
	          _this4.proyecto.monto_total = MONTO_TOTAL;
	          _this4.Message.success('Se obtuvo datos de la documentaci\xF3n de la empresa correctamente.');
	          _this4.tieneDocumentacion = true;
	          _this4.codigoDocumentoProy = angular.copy(_this4.proyecto.cod_documentacion_exp);
	          _this4.esEmpresa = _this4.proyecto.documentacion_exp && _this4.proyecto.documentacion_exp.datos_asociacion && _this4.proyecto.documentacion_exp.datos_asociacion.id_asociacion_accidental ? false : true;
	          _this4.siguiente();
	          _this4.Loading.hide();
	        }
	      });
	    }
	  }, {
	    key: 'validarPresupuesto',
	    value: function validarPresupuesto(contextObj) {
	      if (contextObj.step1Valid) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'confirmacionGeneracion',
	    value: function confirmacionGeneracion() {
	      var _this5 = this;
	
	      var defer = this.$q.defer();
	      if (!this.puedeGenerarFormularios()) {
	        defer.reject();
	      } else {
	        var modalConfirmacion = this.Modal.show({
	          template: _confirmacionModal2.default,
	          controller: _confirmacionModalController2.default,
	          data: this.proyecto,
	          size: 'lg'
	        });
	        modalConfirmacion.result.then(function (proyecto) {
	          _this5.proyecto = proyecto;
	          defer.resolve();
	        }, function () {});
	      }
	      return defer.promise;
	    }
	  }, {
	    key: 'puedeGenerarFormularios',
	    value: function puedeGenerarFormularios() {
	      if (this.existeFormulario() && this.tienePresupuestoCompleto() && this.proyecto.monto_total && this.tieneCronogramas()) {
	        return true;
	      } else {
	        this.Modal.alert('Debe completar los precios de los items en Presupuesto y cargar los archivos en Cronogramas.');
	      }
	      return false;
	    }
	  }, {
	    key: 'esDocumentacionCompleta',
	    value: function esDocumentacionCompleta() {
	      if (this.existeFormulario() && this.tienePresupuestoCompleto() && this.proyecto.monto_total && this.tieneCronogramas()) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'tienePresupuestoCompleto',
	    value: function tienePresupuestoCompleto() {
	      var PRECIOS_ITEMS = this._.map(this.proyecto.items, 'precio_unitario');
	      return this._.indexOf(PRECIOS_ITEMS, undefined) === -1;
	    }
	  }, {
	    key: 'tieneCronogramas',
	    value: function tieneCronogramas() {
	      return this.proyecto.formularios && this.existeDocumento('A8') && this.existeDocumento('B5') && this.existeDocumento('B2');
	    }
	  }, {
	    key: 'existeDocumento',
	    value: function existeDocumento(codigo) {
	      return !this._.isEmpty(this._.find(this.proyecto.formularios, { codigo_documento: codigo }));
	    }
	  }, {
	    key: 'verificarSiTieneForm',
	    value: function verificarSiTieneForm() {
	      if (this.WizardHandler.wizard() && this.existeFormulario()) {
	        this.WizardHandler.wizard().setEditMode();
	      }
	    }
	  }, {
	    key: 'siguiente',
	    value: function siguiente() {
	      this.WizardHandler.wizard().next();
	    }
	  }, {
	    key: 'anterior',
	    value: function anterior() {
	      this.WizardHandler.wizard().previous();
	    }
	  }, {
	    key: 'existeFormulario',
	    value: function existeFormulario() {
	      if (!this.proyecto) {
	        return false;
	      }
	      if (this.proyecto.cod_documentacion_exp && this.proyecto.documentacion_exp) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'getRolUsuario',
	    value: function getRolUsuario() {
	      var id_rol = null;
	      if (this.usuario.rol) {
	        id_rol = this.usuario.rol.id_rol;
	      } else {
	        id_rol = this.usuario.matricula ? 8 : 0;
	      }
	      return id_rol;
	    }
	
	    // esModoEdicion() {
	    //   if (!this.proyecto) {
	    //     return;
	    //   }
	    //   return this.Proyecto.esEditable('plazo_ejecucion');
	    // }
	
	  }]);
	
	  return DocumentacionProyectoController;
	}();
	
	exports.default = DocumentacionProyectoController;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _documentacionProyecto = __webpack_require__(432);
	
	var _documentacionProyecto2 = _interopRequireDefault(_documentacionProyecto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentacionProyecto = angular.module('app.documentacionProyecto', []).component('documentacionProyecto', _documentacionProyecto2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('documentacion-proyecto', {
	        url: '/documentacion-proyecto/{codigo:int}',
	        component: 'documentacionProyecto'
	    });
	}]).name;
	
	exports.default = DocumentacionProyecto;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matriculas = __webpack_require__(438);
	
	var _matriculas2 = _interopRequireDefault(_matriculas);
	
	var _documentacionProyecto = __webpack_require__(434);
	
	var _documentacionProyecto2 = _interopRequireDefault(_documentacionProyecto);
	
	var _planillaProyecto = __webpack_require__(448);
	
	var _planillaProyecto2 = _interopRequireDefault(_planillaProyecto);
	
	var _supervision = __webpack_require__(451);
	
	var _supervision2 = _interopRequireDefault(_supervision);
	
	var _cEmpresas = __webpack_require__(407);
	
	var _cEmpresas2 = _interopRequireDefault(_cEmpresas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Modificacion from './modificacion/modificacion.module';
	
	// import ComputoProyecto from './computo-proyecto/computo-proyecto.module';
	var Empresas = angular.module('app.empresas', [_matriculas2.default, _documentacionProyecto2.default,
	// AvanceProyecto,
	_planillaProyecto2.default,
	// ComputoProyecto,
	_cEmpresas2.default
	// Modificacion
	]).service('Supervision', _supervision2.default).name;
	// import AvanceProyecto from './avance-proyecto/avance-proyecto.module';
	exports.default = Empresas;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matriculas = __webpack_require__(437);
	
	var _matriculas2 = _interopRequireDefault(_matriculas);
	
	var _matriculas3 = __webpack_require__(748);
	
	var _matriculas4 = _interopRequireDefault(_matriculas3);
	
	__webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatriculasComponent = {
	  bindings: {},
	  controller: _matriculas2.default,
	  template: _matriculas4.default
	};
	
	exports.default = MatriculasComponent;

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MatriculasController = function () {
	  MatriculasController.$inject = ["DataService", "Storage", "SidenavFactory", "$state", "Loading"];
	  function MatriculasController(DataService, Storage, SidenavFactory, $state, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, MatriculasController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.SidenavFactory = SidenavFactory;
	    this.$state = $state;
	    this.Loading = Loading;
	  }
	
	  _createClass(MatriculasController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getMatriculas();
	    }
	  }, {
	    key: 'getMatriculas',
	    value: function getMatriculas() {
	      var _this = this;
	
	      this.Loading.show('Cargando datos.', true);
	      this.DataService.get('empresas/' + this.Storage.getUser().nit + '/matriculas').then(function (response) {
	        _this.Loading.hide();
	        if (response) {
	          if (response.datos.length === 1) {
	            _this.cargarDatosMatricula(response.datos[0]);
	          } else {
	            _this.matriculas = response.datos;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'cargarDatosMatricula',
	    value: function cargarDatosMatricula(matricula) {
	      var empresa = Object.assign(this.Storage.getUser(), {
	        matricula: matricula.IdMatricula,
	        username: matricula.RazonSocial
	      });
	      this.Storage.setUser(empresa);
	      this.SidenavFactory.setUser(empresa);
	      this.$state.go('pendientes');
	    }
	  }]);
	
	  return MatriculasController;
	}();
	
	exports.default = MatriculasController;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matriculas = __webpack_require__(436);
	
	var _matriculas2 = _interopRequireDefault(_matriculas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Matriculas = angular.module('app.matriculas', []).component('matriculas', _matriculas2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('matriculas', {
	        url: '/matriculas',
	        component: 'matriculas'
	    });
	}]).name;
	
	exports.default = Matriculas;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ComputoMetricosModalController = function () {
	  ComputoMetricosModalController.$inject = ["$uibModalInstance", "$scope", "DataService", "Message", "data", "_"];
	  function ComputoMetricosModalController($uibModalInstance, $scope, DataService, Message, data, _) {
	    'ngInject';
	
	    _classCallCheck(this, ComputoMetricosModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.data = data;
	    this._ = _;
	    this.supervision = data.supervision;
	    this.item = data.item;
	    this.modoVista = data.modoVista;
	    this.existeCambios = false;
	  }
	
	  _createClass(ComputoMetricosModalController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      if (this.modificados.length > 0) {
	        this.$uibModalInstance.close(this.modificados);
	      } else {
	        this.$uibModalInstance.dismiss('cancel');
	      }
	    }
	  }, {
	    key: 'guardar',
	    value: function guardar() {
	      var _this = this;
	
	      if (this.existeCambiosItem) {
	        this.$scope.$broadcast('guardarComputosMetricos', function () {
	          _this.$uibModalInstance.close(_this.modificados);
	        });
	      } else if (this.modificados.length > 0) {
	        this.$uibModalInstance.close(this.modificados);
	      } else {
	        this.$uibModalInstance.close(null);
	      }
	    }
	  }, {
	    key: 'tieneComputosMetricos',
	    value: function tieneComputosMetricos() {
	      return !this._.isEmpty(JSON.parse(angular.toJson(this.computos))[0]);
	    }
	  }]);
	
	  return ComputoMetricosModalController;
	}();
	
	exports.default = ComputoMetricosModalController;

/***/ }),
/* 440 */
[852, 441, 750],
/* 441 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EmpresaAnteriorController = function () {
	  EmpresaAnteriorController.$inject = ["$state", "DataService", "Storage"];
	  function EmpresaAnteriorController($state, DataService, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, EmpresaAnteriorController);
	
	    this.$state = $state;
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.user = Storage.getUser();
	    this.historialEmpresas = false;
	  }
	
	  _createClass(EmpresaAnteriorController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var idProyecto = this.supervision.fid_proyecto;
	      this.DataService.get('proyectos/' + idProyecto + '/empresas/avance').then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this.historico = resp.datos;
	          if (resp.datos && resp.datos.proyectos.length > 0) {
	            _this.historialEmpresas = true;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'verSupervision',
	    value: function verSupervision(avance) {
	      this.$state.go('planilla-proyecto', { idSupervision: avance.supervisiones[0].id_supervision });
	    }
	  }]);
	
	  return EmpresaAnteriorController;
	}();
	
	exports.default = EmpresaAnteriorController;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FotoSupervisionController = function () {
	  FotoSupervisionController.$inject = ["$uibModalInstance", "DataService", "$stateParams", "data", "_"];
	  function FotoSupervisionController($uibModalInstance, DataService, $stateParams, data, _) {
	    'ngInject';
	
	    _classCallCheck(this, FotoSupervisionController);
	
	    this.DataService = DataService;
	    this.$stateParams = $stateParams;
	    this.data = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this._ = _;
	    this.foto = data.foto;
	    this.fotos = data.fotos;
	  }
	
	  _createClass(FotoSupervisionController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'irAPosicion',
	    value: function irAPosicion(tipo) {
	      var POSICION = tipo === 'anterior' ? this.foto.nro - 1 : tipo === 'siguiente' ? this.foto.nro + 1 : this.foto.nro;
	      this.foto = this._.find(this.fotos, { nro: POSICION });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return FotoSupervisionController;
	}();
	
	exports.default = FotoSupervisionController;

/***/ }),
/* 443 */
[853, 444, 752, 202],
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fotoSupervisionModal = __webpack_require__(442);
	
	var _fotoSupervisionModal2 = _interopRequireDefault(_fotoSupervisionModal);
	
	var _fotoSupervisionModal3 = __webpack_require__(751);
	
	var _fotoSupervisionModal4 = _interopRequireDefault(_fotoSupervisionModal3);
	
	var _modal = __webpack_require__(450);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(756);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FotosSupervisionController = function () {
	  FotosSupervisionController.$inject = ["DataService", "Storage", "SidenavFactory", "$state", "Modal", "Message", "$window"];
	  function FotosSupervisionController(DataService, Storage, SidenavFactory, $state, Modal, Message, $window) {
	    'ngInject';
	
	    _classCallCheck(this, FotosSupervisionController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.SidenavFactory = SidenavFactory;
	    this.$state = $state;
	    this.$window = $window;
	    this.Modal = Modal;
	    this.Message = Message;
	
	    this.user = Storage.getUser();
	  }
	
	  _createClass(FotosSupervisionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      for (var i = 0; i < this.fotos.length; i++) {
	        this.fotos[i].nro = i + 1;
	        this.getFoto(this.fotos[i]);
	      }
	      this.puedeEliminar = this.user.rol.nombre === 'SUPERVISOR' && this.supervision && this.supervision.estado_actual && this.supervision.estado_actual.codigo === 'EN_SUPERVISOR';
	    }
	  }, {
	    key: 'getFoto',
	    value: function getFoto(foto) {
	      this.DataService.get('fotos/' + foto.id_foto_supervision).then(function (response) {
	        foto.base64 = response.datos;
	        foto.coordenadas = response.coordenadas;
	        foto.mostrar = true;
	      });
	    }
	  }, {
	    key: 'mostrarPopup2',
	    value: function mostrarPopup2(foto) {
	      if (foto.base64) {
	        this.Modal.showImageBase64(foto, 'Foto Supervision ' + foto.nro);
	      }
	    }
	  }, {
	    key: 'mostrarPopup',
	    value: function mostrarPopup(foto) {
	      this.Modal.show({
	        template: _fotoSupervisionModal4.default,
	        controller: _fotoSupervisionModal2.default,
	        data: {
	          foto: foto,
	          fotos: this.fotos
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'mostrarUbicacion',
	    value: function mostrarUbicacion(foto) {
	      //this.$window.open(`https://www.openstreetmap.org/?mlat=${foto.coordenadas.coordinates[1]}&mlon=${foto.coordenadas.coordinates[0]}#map=18/${foto.coordenadas.coordinates[1]}/${foto.coordenadas.coordinates[0]}`,'_blank');
	      this.Modal.show({
	        template: _modal4.default,
	        controller: _modal2.default,
	        data: {
	          foto: foto,
	          fotos: this.fotos
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'eliminarFoto',
	    value: function eliminarFoto(foto) {
	      var _this = this;
	
	      var datos = angular.copy(foto);
	      datos.path_fotografia = foto.path_fotografia.substring(foto.path_fotografia.indexOf('_') + 1);
	      datos.fid_supervision = foto.fid_supervision || this.supervision.id_supervision;
	      this.Modal.confirm('\xBFEst\xE1 seguro/a de eliminar la Foto supervisi\xF3n ' + foto.nro + '?', function () {
	        _this.DataService.delete('fotos/' + foto.id_foto_supervision + '?supervision=' + datos.fid_supervision, datos).then(function (result) {
	          if (result && result.finalizado) {
	            _this.Message.success(result.mensaje);
	            _this.$state.reload();
	          }
	        });
	      });
	    }
	  }]);
	
	  return FotosSupervisionController;
	}();
	
	exports.default = FotosSupervisionController;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemsNoCerradosModalController = function () {
	  ItemsNoCerradosModalController.$inject = ["$uibModalInstance", "$scope", "DataService", "Message", "data", "_"];
	  function ItemsNoCerradosModalController($uibModalInstance, $scope, DataService, Message, data, _) {
	    'ngInject';
	
	    _classCallCheck(this, ItemsNoCerradosModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.data = data;
	    this._ = _;
	    this.items = data.items;
	  }
	
	  _createClass(ItemsNoCerradosModalController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'aprobar',
	    value: function aprobar() {
	      this.$uibModalInstance.close(true);
	    }
	  }]);
	
	  return ItemsNoCerradosModalController;
	}();
	
	exports.default = ItemsNoCerradosModalController;

/***/ }),
/* 446 */
[854, 447, 754, 203],
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _computoMetricoModal = __webpack_require__(749);
	
	var _computoMetricoModal2 = _interopRequireDefault(_computoMetricoModal);
	
	var _computoMetricoModal3 = __webpack_require__(439);
	
	var _computoMetricoModal4 = _interopRequireDefault(_computoMetricoModal3);
	
	var _verificacionAnticipoModal = __webpack_require__(755);
	
	var _verificacionAnticipoModal2 = _interopRequireDefault(_verificacionAnticipoModal);
	
	var _verificacionAnticipoModal3 = __webpack_require__(449);
	
	var _verificacionAnticipoModal4 = _interopRequireDefault(_verificacionAnticipoModal3);
	
	var _itemsNoCerradosModal = __webpack_require__(753);
	
	var _itemsNoCerradosModal2 = _interopRequireDefault(_itemsNoCerradosModal);
	
	var _itemsNoCerradosModal3 = __webpack_require__(445);
	
	var _itemsNoCerradosModal4 = _interopRequireDefault(_itemsNoCerradosModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PlanillaProyectoController = function () {
	  PlanillaProyectoController.$inject = ["$scope", "DataService", "Modal", "$state", "$stateParams", "Supervision", "_", "Storage", "Util", "$q", "Flujos", "apiUrl", "Message"];
	  function PlanillaProyectoController($scope, DataService, Modal, $state, $stateParams, Supervision, _, Storage, Util, $q, Flujos, apiUrl, Message) {
	    'ngInject';
	
	    _classCallCheck(this, PlanillaProyectoController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.Supervision = Supervision;
	    this._ = _;
	    this.Storage = Storage;
	    this.Util = Util;
	    this.$q = $q;
	    this.Flujos = Flujos;
	    this.apiUrl = apiUrl;
	    this.Message = Message;
	    this.items_modulo = [];
	    this.items_x = [];
	    this.filtroItems = 'TODOS';
	  }
	
	  _createClass(PlanillaProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.usuario = this.Storage.getUser();
	      this.idSupervision = this.$stateParams.idSupervision;
	      this.getTipoUnidades();
	      this.getSupervision();
	      // TODO enviar rol si el usuario tiene mas de un rol
	      this.url = 'supervisiones/' + this.idSupervision + '?rol=' + this.Storage.get('rol').id_rol;
	
	      this.$scope.$on('transicion_accion_ejecutada', function () {
	        _this.$state.go('mis-proyectos');
	      });
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.filtroItems', function () {
	        if (!_this2.supervision) {
	          return;
	        }
	        _this2.mostrarItems();
	      });
	    }
	  }, {
	    key: 'mostrarItems',
	    value: function mostrarItems() {
	      switch (this.filtroItems) {
	        case 'COMPLETADOS':
	          this.filtrarItems(function (item) {
	            return item.completado;
	          });
	          break;
	        case 'INCOMPLETOS':
	          this.filtrarItems(function (item) {
	            return !item.completado;
	          });
	          break;
	        case 'PARA_ENVIAR':
	          this.filtrarItems(function (item) {
	            return item.cantidad_actual_fis !== 0;
	          });
	          break;
	        default:
	          this.filtrarItems();
	      }
	    }
	  }, {
	    key: 'getSupervision',
	    value: function getSupervision() {
	      var _this3 = this;
	
	      this.DataService.get('supervisiones/' + this.idSupervision).then(function (response) {
	        if (response) {
	          _this3.supervision = _this3.verificarModificaciones(response.datos);
	          _this3.asignarDatosProyecto();
	          _this3.mostrarItems();
	          _this3.Flujos.getAtributosPermitidos(_this3.supervision);
	          _this3.Supervision.setUsuario(_this3.usuario);
	          _this3.Supervision.setSupervision(_this3.supervision);
	
	          _this3.esEditable = _this3.Supervision.esEditable('computos');
	          _this3.esEtapaEdicion = _this3.supervision.estado_supervision === 'REGISTRO_PLANILLA';
	          if (!_this3.esEtapaEdicion) {
	            _this3.filtroItems = 'PARA_ENVIAR';
	          }
	          _this3.prepararBoletas();
	          _this3.supervision.supervisiones_anteriores.map(function (supervision) {
	            supervision.numero = _this3.Util.getNumeroOrdinal(supervision.nro_supervision);
	          });
	          var DESEMBOLSOS = _this3._.map(_this3.supervision.supervisiones_anteriores, 'desembolso');
	          _this3.supervision.monto_desembolso_total = _this3.Util.sumar(DESEMBOLSOS);
	          _this3.verificarDeudas();
	          _this3.verificarItemsNoCerrados();
	        }
	      });
	    }
	  }, {
	    key: 'verificarModificaciones',
	    value: function verificarModificaciones(datos) {
	      // TODO optimizar
	      var cabecera = datos.modulos[0].items[0].item_historico;
	      for (var i in datos.modulos) {
	        var items = datos.modulos[i].items;
	        for (var j in items) {
	          var ij = items[j].item_historico.length;
	          for (var k = cabecera.length; k > ij; k--) {
	            items[j].item_historico.unshift({
	              version: cabecera[k - 1].version - ij
	            });
	          }
	        }
	      }
	
	      if (datos.proyecto.proyecto_historico[0] && !datos.proyecto.proyecto_historico[0].tipo_modificacion_proyecto) {
	        datos.proyecto.proyecto_historico[0].tipo_modificacion_proyecto = {
	          nombre: 'Contrato Original'
	        };
	      }
	      return datos;
	    }
	  }, {
	    key: 'asignarDatosProyecto',
	    value: function asignarDatosProyecto() {
	      this.proyecto = this.supervision.proyecto;
	      if (this.proyecto.doc_especificaciones_tecnicas) {
	        this.urlDescEspTecnicas = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/ET/descargar';
	      }
	      if (this.supervision.version_proyecto) {
	        this.urlDescPlanilla = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/PA_' + this.supervision.nro_supervision + '/descargar';
	        this.urlDescComputosResumen = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/CMR_' + this.supervision.nro_supervision + '/descargar';
	        this.urlDescComputosItem = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/CM_';
	      }
	    }
	  }, {
	    key: 'irComputo',
	    value: function irComputo(item) {
	      this.$state.go('computo-proyecto', { idSupervision: this.idSupervision, idItem: item.id_item });
	    }
	  }, {
	    key: 'mostrarComputo',
	    value: function mostrarComputo(item) {
	      var _this4 = this;
	
	      this.Modal.show({
	        template: _computoMetricoModal2.default,
	        controller: _computoMetricoModal4.default,
	        size: 'xlg',
	        data: {
	          supervision: this.supervision,
	          item: item,
	          modoVista: this.supervision.estado_actual.atributos['computos'] ? false : true
	        }
	      }).result.then(function (modificados) {
	        if (!modificados) {
	          return;
	        }
	        if (_this4.Supervision.esEditable('computos') && modificados.length > 0) {
	          _this4.getSupervision();
	        }
	      }).catch(function () {});
	    }
	  }, {
	    key: 'getTipoUnidades',
	    value: function getTipoUnidades() {
	      var _this5 = this;
	
	      this.DataService.get('parametricas/UNIDAD').then(function (response) {
	        if (response) {
	          _this5.unidades = response.datos.rows;
	          _this5.unidades_obj = {};
	          _this5.unidades.forEach(function (uni) {
	            _this5.unidades_obj[uni.codigo] = uni;
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getMgColor',
	    value: function getMgColor(item) {
	      if (item.total_acumulado_fis === item.cantidad) {
	        return 'bl-success';
	      }
	      if (item.total_acumulado_fis === 0) {
	        return 'bl-primary';
	      }
	      if (item.cantidad_actual_fis > 0) {
	        return 'bl-info';
	      }
	      return 'bl-warning';
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle(item) {
	      if (item.total_acumulado_fis === item.cantidad) {
	        return 'Completado';
	      }
	      if (item.total_acumulado_fis === 0) {
	        return 'Sin avance';
	      }
	      if (item.cantidad_actual_fis > 0) {
	        return 'Con avance';
	      }
	      return 'Con avance en anterior(es) planilla(s)';
	    }
	
	    // TODO obtener valores desde el backend
	
	  }, {
	    key: 'calcularFechaAmpliada',
	    value: function calcularFechaAmpliada(fecha) {
	      if (fecha && this.proyecto && this.proyecto.plazo_ampliacion) {
	        fecha = new Date(fecha);
	        fecha.setDate(fecha.getDate() + this.proyecto.plazo_ampliacion.por_volumenes + this.proyecto.plazo_ampliacion.por_compensacion);
	      }
	      return fecha;
	    }
	  }, {
	    key: 'filtrarItems',
	    value: function filtrarItems() {
	      var _this6 = this;
	
	      var condicion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	        return true;
	      };
	
	      this.supervision.modulos.forEach(function (modulo) {
	        modulo.items.forEach(function (item) {
	          item.show = condicion(item);
	        });
	        modulo.show = _this6._.some(modulo.items, { show: true });
	      });
	      this.Supervision.setSupervision(this.supervision);
	    }
	  }, {
	    key: 'volverSupervisiones',
	    value: function volverSupervisiones() {
	      this.$state.go('avance-proyecto', { idProyecto: this.supervision.fid_proyecto, matricula: this.Storage.get('user').matricula });
	    }
	  }, {
	    key: 'verificarDeudas',
	    value: function verificarDeudas() {
	      if (this.proyecto.anticipo === 0) {
	        return;
	      }
	      var DESCUENTOS = this._.map(this.supervision.supervisiones_anteriores, 'descuento_anticipo');
	      var TOTAL_DESCUENTOS = this.Util.sumar(DESCUENTOS);
	      this.deudaAnticipo = this.Util.restar(this.proyecto.anticipo, TOTAL_DESCUENTOS);
	      if (this.deudaAnticipo === 0) {
	        return;
	      }
	      this.tieneDeudas = true;
	      this.desembolso = this.Supervision.calcularDescuento(this.supervision.tipo_descuento_anticipo, this.supervision.monto_total_actual_ejecutado, this.deudaAnticipo, this.proyecto.porcentaje_anticipo);
	    }
	  }, {
	    key: 'verificarItemsNoCerrados',
	    value: function verificarItemsNoCerrados() {
	      var ITEMS = this.Supervision.getItems();
	      this.itemsNoCerrados = this._.filter(ITEMS, function (item) {
	        return (item.falta_ejecutar_fis === 0 && item.falta_ejecutar_fin !== 0 || item.ejecutar_porcentaje_fis === 0 && item.falta_ejecutar_fis > 0) && item.estado !== 'CERRADO';
	      });
	    }
	  }, {
	    key: 'verificarPlanilla',
	    value: function verificarPlanilla() {
	      var defer = this.$q.defer();
	      if (this.Supervision.esEditable('tipo_descuento_anticipo')) {
	        return this.verificarAnticipo(defer);
	      }
	      if (this.estaEnTecnico(defer)) {
	        return this.verificarDatosParaTecnico(defer);
	      }
	      defer.resolve({ confirmar: true });
	      return defer.promise;
	    }
	  }, {
	    key: 'verificarAnticipo',
	    value: function verificarAnticipo(defer) {
	      if (!this.tieneAvances()) {
	        this.Message.warning('No tiene avances para enviar.');
	        return defer.promise;
	      }
	
	      if (this.tieneAnticipo() && this.deudaAnticipo > 0) {
	        var modalConfirmacion = this.Modal.show({
	          template: _verificacionAnticipoModal2.default,
	          controller: _verificacionAnticipoModal4.default,
	          data: {
	            supervision: this.supervision,
	            deudaAnticipo: this.deudaAnticipo,
	            esPlanillaCierre: this.supervision.monto_total_por_ejecutar === 0
	          },
	          size: 'lg'
	        });
	        modalConfirmacion.result.then(function () {
	          defer.resolve();
	        }, function () {});
	      } else {
	        defer.resolve();
	      }
	      return defer.promise;
	    }
	  }, {
	    key: 'verificarDatosParaTecnico',
	    value: function verificarDatosParaTecnico(defer) {
	      if (this.itemsNoCerrados.length > 0) {
	        var modalConfirmacion = this.Modal.show({
	          template: _itemsNoCerradosModal2.default,
	          controller: _itemsNoCerradosModal4.default,
	          data: {
	            items: this.itemsNoCerrados
	          },
	          size: 'lg'
	        });
	        modalConfirmacion.result.then(function (aprobar) {
	          if (aprobar) {
	            defer.resolve();
	          }
	        }, function () {});
	      } else if (this.supervision.porcentaje_avance_fis === 100) {
	        this.Modal.confirm('Se le recuerda que \xE9sta es la <strong>Planilla de Cierre</strong>.\n        <p>\xBFEst\xE1 seguro/a de aprobar la presente planilla, tomando en cuenta que con ella finalizar\xE1 el registro de los avances del proyecto?</p>\n        <p>En caso de estar seguro/a seleccione la opci\xF3n <b>APROBAR</b>.</p>', function () {
	          defer.resolve();
	        }, null, 'Confirmaci\xF3n previa al cierre del proyecto', 'APROBAR');
	      } else {
	        defer.resolve({ confirmar: true });
	      }
	      return defer.promise;
	    }
	  }, {
	    key: 'tieneAnticipo',
	    value: function tieneAnticipo() {
	      return this.supervision.proyecto.porcentaje_anticipo > 0;
	    }
	  }, {
	    key: 'tieneAvances',
	    value: function tieneAvances() {
	      return this.supervision.monto_total_actual_ejecutado > 0;
	    }
	  }, {
	    key: 'estaEnTecnico',
	    value: function estaEnTecnico() {
	      return this.supervision.estado_supervision === 'EN_TECNICO';
	    }
	  }, {
	    key: 'irAtras',
	    value: function irAtras() {
	      window.history.back();
	    }
	  }, {
	    key: 'prepararBoletas',
	    value: function prepararBoletas() {
	      this.boletasAnticipo = this.getBoletaPorTipo('TB_CORRECTA_INVERSION');
	      this.boletasCcontrato = this.getBoletaPorTipo('TB_CUMPLIMIENTO_CONTRATO');
	    }
	  }, {
	    key: 'getBoletaPorTipo',
	    value: function getBoletaPorTipo(tipo) {
	      return this._.filter(this.supervision.proyecto.boletas, function (boleta) {
	        return boleta.tipo_boleta === tipo && boleta.estado === 'ACTIVO';
	      });
	    }
	  }, {
	    key: 'getTipoClass',
	    value: function getTipoClass(tipo_modificacion) {
	      if (tipo_modificacion == 'TM_CONTRATO_MODIFICATORIO') return 'cmodificatorio';
	      if (tipo_modificacion == 'TM_ORDEN_CAMBIO') return 'orden-cambio';
	      if (tipo_modificacion == 'TM_ORDEN_TRABAJO') return 'orden-trabajo';
	      return '';
	    }
	  }]);
	
	  return PlanillaProyectoController;
	}();
	
	exports.default = PlanillaProyectoController;

/***/ }),
/* 448 */
[855, 446, 443, 440],
/* 449 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VerificacionAnticipoModalController = function () {
	  VerificacionAnticipoModalController.$inject = ["$uibModalInstance", "$scope", "DataService", "Message", "data", "_", "Util", "Supervision", "Big", "decimales"];
	  function VerificacionAnticipoModalController($uibModalInstance, $scope, DataService, Message, data, _, Util, Supervision, Big, decimales) {
	    'ngInject';
	
	    _classCallCheck(this, VerificacionAnticipoModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this._ = _;
	    this.Util = Util;
	    this.Supervision = Supervision;
	    this.Big = Big;
	    this.decimales = decimales;
	    this.supervision = data.supervision;
	    this.deudaAnticipo = data.deudaAnticipo;
	    this.totalDescuentos = data.totalDescuentos;
	    this.esPlanillaCierre = data.esPlanillaCierre;
	  }
	
	  _createClass(VerificacionAnticipoModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.tiposDescuento = [{ codigo: 'TOTAL', nombre: 'Por la totalidad del anticipo ' + (this.supervision.supervisiones_anteriores.length > 0 ? 'pendiente' : '') + ' (*)' }, { codigo: 'PROGRESIVO', nombre: 'Progresivo (**)' }];
	      this.verificarSiPuedeDescuentoTotal();
	      this.verSiPuedeDescuentoProgresivo();
	      if (this.esPlanillaCierre) {
	        this.calcularDescuento('TOTAL');
	      }
	    }
	  }, {
	    key: 'verificarSiPuedeDescuentoTotal',
	    value: function verificarSiPuedeDescuentoTotal() {
	      if (this.supervision.monto_total_actual_ejecutado < this.deudaAnticipo) {
	        this.puedeDescuentoTotal = false;
	        this.supervision.tipo_descuento_anticipo = 'PROGRESIVO';
	        this.calcularDescuento('PROGRESIVO');
	      } else {
	        this.supervision.tipo_descuento_anticipo = null;
	        this.puedeDescuentoTotal = true;
	      }
	    }
	  }, {
	    key: 'verSiPuedeDescuentoProgresivo',
	    value: function verSiPuedeDescuentoProgresivo() {
	      this.puedeDescuentoProgresivo = this.esValidoDescuentoProgresivo();
	      if (!this.puedeDescuentoProgresivo) {
	        this.supervision.tipo_descuento_anticipo = 'TOTAL';
	        this.calcularDescuento('TOTAL');
	      }
	    }
	  }, {
	    key: 'esValidoDescuentoProgresivo',
	    value: function esValidoDescuentoProgresivo() {
	      this.calcularDescuento('PROGRESIVO');
	      if (this.desembolso.descuento > this.deudaAnticipo || this.esPlanillaCierre) {
	        return false;
	      }
	      this.desembolso = null;
	      return true;
	    }
	  }, {
	    key: 'calcularDescuento',
	    value: function calcularDescuento(tipo) {
	      this.desembolso = this.Supervision.calcularDescuento(tipo, this.supervision.monto_total_actual_ejecutado, this.deudaAnticipo, this.supervision.proyecto.porcentaje_anticipo);
	    }
	  }, {
	    key: 'getPorcentaje',
	    value: function getPorcentaje(numero, porcentaje) {
	      //return this.Util.redondear(this.Util.redondear(numero * porcentaje)/100);
	      return parseFloat(this.Big(numero).mul(porcentaje).div(100).toFixed(this.decimales || 2));
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'registrar',
	    value: function registrar() {
	      this.$uibModalInstance.close(this.supervision);
	    }
	  }, {
	    key: 'tieneComputosMetricos',
	    value: function tieneComputosMetricos() {
	      return !this._.isEmpty(JSON.parse(angular.toJson(this.computos))[0]);
	    }
	  }]);
	
	  return VerificacionAnticipoModalController;
	}();
	
	exports.default = VerificacionAnticipoModalController;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UbicacionModalController = function () {
	  UbicacionModalController.$inject = ["$uibModalInstance", "$stateParams", "data"];
	  function UbicacionModalController($uibModalInstance, $stateParams, data) {
	    'ngInject';
	
	    _classCallCheck(this, UbicacionModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$stateParams = $stateParams;
	    this.foto = data.foto;
	    this.fotos = data.fotos;
	  }
	
	  _createClass(UbicacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.mapa = {
	        marcadores: []
	      };
	      if (this.foto && this.foto.coordenadas && this.foto.coordenadas.coordinates && this.foto.coordenadas.coordinates[0] && this.foto.coordenadas.coordinates[1]) {
	        this.mapa.centro = {
	          lat: this.foto.coordenadas.coordinates[1],
	          lng: this.foto.coordenadas.coordinates[0],
	          zoom: 15
	        };
	      } else {
	        this.mapa.centro = {
	          lat: -16.5286043,
	          lng: -68.1798767,
	          zoom: 15
	        };
	      }
	
	      var icon = {
	        iconUrl: 'images/marker-sm-green.png',
	        iconSize: [38, 40]
	      };
	      var icon2 = {
	        iconUrl: 'images/marker-sm-red.png',
	        iconSize: [38, 40]
	      };
	      for (var i in this.fotos) {
	        if (this.fotos[i].coordenadas && this.fotos[i].coordenadas.coordinates && this.fotos[i].coordenadas.coordinates[0] && this.fotos[i].coordenadas.coordinates[1]) {
	          this.mapa.marcadores.push({
	            lat: this.fotos[i].coordenadas.coordinates[1],
	            lng: this.fotos[i].coordenadas.coordinates[0],
	            focus: this.fotos[i].nro == this.foto.nro,
	            draggable: false,
	            message: 'Foto ' + this.fotos[i].nro,
	            icon: this.fotos[i].nro == this.foto.nro ? icon : icon2
	          });
	        }
	      }
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return UbicacionModalController;
	}();
	
	exports.default = UbicacionModalController;

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SupervisionService = function () {
	  SupervisionService.$inject = ["DataService", "$q", "Datetime", "Util", "$window", "_"];
	  function SupervisionService(DataService, $q, Datetime, Util, $window, _) {
	    'ngInject';
	
	    _classCallCheck(this, SupervisionService);
	
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.estadoActual = null;
	    this.Util = Util;
	    this.$window = $window;
	    this.$q = $q;
	    this.proyectoOrigen = {};
	    this._ = _;
	  }
	
	  _createClass(SupervisionService, [{
	    key: 'setSupervision',
	    value: function setSupervision(pSupervision) {
	      this.supervision = angular.copy(pSupervision);
	      this.supervision.estado_actual.areas = this._.zipObject(this.supervision.estado_actual.areas, Array.from(new Array(this.supervision.estado_actual.areas.length), function () {
	        return true;
	      }));
	    }
	  }, {
	    key: 'getSupervision',
	    value: function getSupervision() {
	      return this.supervision || null;
	    }
	  }, {
	    key: 'isSetSupervision',
	    value: function isSetSupervision() {
	      return angular.isDefined(this.supervision);
	    }
	  }, {
	    key: 'setUsuario',
	    value: function setUsuario(pUsuario) {
	      this.usuario = angular.copy(pUsuario);
	      this.id_rol = null;
	      if (this.usuario.rol) {
	        this.id_rol = this.usuario.rol.id_rol;
	      } else {
	        this.id_rol = this.usuario.matricula ? 8 : 0;
	      }
	    }
	  }, {
	    key: 'esRolPermitido',
	    value: function esRolPermitido() {
	      return this.supervision.estado_actual.roles.indexOf(this.id_rol) !== -1;
	    }
	  }, {
	    key: 'esRolEstadoSupervisor',
	    value: function esRolEstadoSupervisor() {
	      return this.supervision.estado_supervision === 'EN_SUPERVISOR' && this.id_rol == 9;
	    }
	
	    /**
	     * getItems - Prepara y envía una lista de items que tienen el atributo show = true (que se va asignando de acuerdo a los filtros de la planilla)
	     *
	     * @return {array}  Lista de items filtrados por el atributo show = true
	     */
	
	  }, {
	    key: 'getItems',
	    value: function getItems() {
	      var _this = this;
	
	      if (!this.supervision) {
	        return null;
	      }
	      var items = [];
	      this.supervision.modulos.map(function (modulo) {
	        if (modulo.show) {
	          items = _this._.unionWith(items, _this._.reject(modulo.items, { 'show': false }));
	        }
	      });
	      return this._.orderBy(items, 'nro_item', 'asc');
	    }
	  }, {
	    key: 'getDatosSegunEstado',
	    value: function getDatosSegunEstado(supervision) {
	      var _this2 = this;
	
	      var nSupervision = {};
	      var atributos = Array.isArray(supervision.estado_actual.atributos) ? supervision.estado_actual.atributos : this._.keys(supervision.estado_actual.atributos);
	      atributos.map(function (atributo) {
	        if (!_this2.Util.isEmpty(supervision[atributo])) {
	          nSupervision[atributo] = supervision[atributo];
	        }
	      });
	      return nSupervision;
	    }
	  }, {
	    key: 'esAreaPermitida',
	    value: function esAreaPermitida(area) {
	      if (this.Util.isEmpty(this.supervision)) {
	        return;
	      }
	      return this.supervision.estado_actual.areas[area] ? true : false;
	    }
	  }, {
	    key: 'esEditable',
	    value: function esEditable(atributo) {
	      return this.supervision.estado_actual.atributos[atributo] ? true : false;
	    }
	  }, {
	    key: 'calcularDescuento',
	    value: function calcularDescuento(tipo, montoEjecutado, deudaAnticipo, porcentajeAnticipo) {
	      var DESCUENTO = {};
	      switch (tipo) {
	        case 'TOTAL':
	          DESCUENTO.descuento = deudaAnticipo;
	          DESCUENTO.total = this.Util.restar(montoEjecutado, deudaAnticipo);
	          break;
	        case 'PROGRESIVO':
	          DESCUENTO.descuento = this.Util.getPorcentaje(montoEjecutado, porcentajeAnticipo);
	          DESCUENTO.total = this.Util.restar(montoEjecutado, DESCUENTO.descuento);
	          break;
	      }
	      return DESCUENTO;
	    }
	  }]);
	
	  return SupervisionService;
	}();
	
	exports.default = SupervisionService;

/***/ }),
/* 452 */
[856, 453, 757],
/* 453 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AsignacionResponsable = function () {
	  AsignacionResponsable.$inject = ["DataService", "Util", "Proyecto"];
	  function AsignacionResponsable(DataService, Util, Proyecto) {
	    'ngInject';
	
	    _classCallCheck(this, AsignacionResponsable);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	  }
	
	  _createClass(AsignacionResponsable, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/usuarios').then(function (response) {
	        if (response) {
	          _this.usuariosParaAsignar = [];
	          for (var i in response.datos) {
	            response.datos[i].nombre = '' + response.datos[i].nombre + (response.datos[i].rol_nombre ? ' (' + response.datos[i].rol_nombre + ')' : '');
	            _this.usuariosParaAsignar.push(response.datos[i]);
	            if (response.datos[i].id_usuario == _this.proyecto.fid_usuario_asignado) {
	              _this.usuario_asignado = _this.usuariosParaAsignar[i];
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'seleccionado',
	    value: function seleccionado() {
	      this.proyecto.fid_usuario_asignado = this.usuario_asignado.id_usuario || null;
	      this.proyecto.fid_usuario_asignado_rol = this.usuario_asignado.id_rol || null;
	    }
	  }]);
	
	  return AsignacionResponsable;
	}();
	
	exports.default = AsignacionResponsable;

/***/ }),
/* 454 */
[857, 455, 758],
/* 455 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AutoridadBeneficiariaController = function () {
	  AutoridadBeneficiariaController.$inject = ["DataService", "Util", "Proyecto"];
	  function AutoridadBeneficiariaController(DataService, Util, Proyecto) {
	    'ngInject';
	
	    _classCallCheck(this, AutoridadBeneficiariaController);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	  }
	
	  _createClass(AutoridadBeneficiariaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.Util.isEmpty(this.proyecto.autoridad_beneficiaria)) {
	        this.proyecto.autoridad_beneficiaria = {};
	      }
	    }
	  }]);
	
	  return AutoridadBeneficiariaController;
	}();
	
	exports.default = AutoridadBeneficiariaController;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boletaGarantia = __webpack_require__(457);
	
	var _boletaGarantia2 = _interopRequireDefault(_boletaGarantia);
	
	var _boletaGarantia3 = __webpack_require__(759);
	
	var _boletaGarantia4 = _interopRequireDefault(_boletaGarantia3);
	
	__webpack_require__(204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoletaGarantiaComponent = {
	  bindings: {
	    proyecto: '=',
	    datos: '=',
	    porcentaje: '=',
	    monto: '=',
	    tipo: '@',
	    boletas: '=',
	    modoVista: '<'
	  },
	  controller: _boletaGarantia2.default,
	  template: _boletaGarantia4.default
	};
	
	exports.default = BoletaGarantiaComponent;

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BoletaGarantiaController = function () {
	  BoletaGarantiaController.$inject = ["$state", "$scope", "Storage", "Proyecto", "Modal", "Message", "DataService", "Util", "_", "Datetime"];
	  function BoletaGarantiaController($state, $scope, Storage, Proyecto, Modal, Message, DataService, Util, _, Datetime) {
	    'ngInject';
	
	    _classCallCheck(this, BoletaGarantiaController);
	
	    this.$scope = $scope;
	    this.$state = $state;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.Message = Message;
	    this.DataService = DataService;
	    this.Util = Util;
	    this._ = _;
	    this.Datetime = Datetime;
	    this.mostrarBoletas = false;
	    this.auxBoleta = {};
	    this.completado = false;
	
	    this.user = Storage.getUser();
	    this.pModificar = false;
	  }
	
	  _createClass(BoletaGarantiaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (!this.boletas) {
	        this.boletas = [];
	      }
	      if (!this.boletasEx) {
	        this.boletasEx = [];
	      }
	      if (this.proyecto.tipo === 'TP_CIF') {
	        var fechaDesembolso = this.Datetime.getFormatDate(angular.copy(this.proyecto.fecha_desembolso));
	        this.validaciones = {
	          fec_ini_minima: this.Datetime.addDaysToDate(angular.copy(fechaDesembolso), 1),
	          mensaje_fecminima: 'La fecha debe ser mayor a la fecha del desembolso (' + this.Datetime.parseDate(fechaDesembolso, '/') + ')'
	        };
	        this.pModificar = 'EMPRESA' === this.user.rol.nombre && this.modoVista;
	      } else {
	        var fechaConvenio = this.Datetime.getFormatDate(angular.copy(this.proyecto.fecha_suscripcion_convenio));
	        this.validaciones = {
	          fec_ini_minima: this.Datetime.addDaysToDate(angular.copy(fechaConvenio), 1),
	          mensaje_fecminima: 'La fecha debe ser mayor a la fecha del convenio (' + this.Datetime.parseDate(fechaConvenio, '/') + ')'
	        };
	        this.pModificar = 'FINANCIERO_UPRE' === this.user.rol.nombre && this.modoVista;
	      }
	
	      // validaciones para modificar boletas
	      this.validacionesEx = {
	        fec_ini_minima: this.validaciones.fec_ini_minima,
	        mensaje_fecminima: this.validaciones.mensaje_fecminima
	      };
	      if (this.boletas.length == 1) {
	        this.validacionesEx.fec_ini_minima = new Date(this.boletas[0].fecha_fin_validez);
	        this.validacionesEx.mensaje_fecminima = 'La fecha debe ser mayor o igual a la boleta anterior (' + this.Datetime.parseDate(this.validacionesEx.fec_ini_minima, '/') + ')';
	      }
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.porcentaje', function () {
	        if (!_this.porcentaje) {
	          _this.monto = null;
	        }
	        _this.verificarValor();
	      });
	      this.$scope.$watch('$ctrl.boletas', function () {
	        _this.$scope.$emit('actualizarBoletas');
	        _this.verificarMontoTotalAnticipo();
	      }, true);
	      this.$scope.$watch('$ctrl.boletasEx', function () {
	        _this.verificarMontoTotalAnticipo();
	      }, true);
	    }
	  }, {
	    key: 'verificarValor',
	    value: function verificarValor() {
	      this.calcularAnticipo();
	      if (this.porcentaje === 0) {
	        this.boletas = [];
	      }
	      this.mostrarBoletas = this.porcentaje > 0;
	    }
	  }, {
	    key: 'calcularAnticipo',
	    value: function calcularAnticipo() {
	      if (typeof this.porcentaje === 'number' && this.porcentaje <= 20) {
	        this.monto = this.Util.getPorcentaje(this.proyecto.monto_total, this.porcentaje);
	      }
	    }
	  }, {
	    key: 'adicionarBoleta',
	    value: function adicionarBoleta() {
	      this.boletas.push({ tipo_boleta: this.tipo, estado: 'ACTIVO' });
	    }
	  }, {
	    key: 'quitarBoleta',
	    value: function quitarBoleta(indice) {
	      this.boletas.splice(indice, 1);
	    }
	  }, {
	    key: 'invalidarBoleta',
	    value: function invalidarBoleta(indice) {
	      var _this2 = this;
	
	      this.Modal.confirm('\xBFEsta seguro/a de renovar esta boleta?\nDeber\xE1 agregar una nueva boleta.', function () {
	        var datos = {
	          id_boleta: _this2.boletas[indice].id_boleta,
	          estado: 'INACTIVO'
	        };
	        _this2.DataService.put('proyectos/' + _this2.proyecto.id_proyecto + '/boletas/' + datos.id_boleta, datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this2.Message.success('La boleta fue invalidada correctamente.');
	            _this2.boletas.splice(indice, 1);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'verificarMontoTotalAnticipo',
	    value: function verificarMontoTotalAnticipo() {
	      //this.sumaMontoBoletas = this.boletas.length > 0 ? this._.sum(this._.map(this.boletas, 'monto')) : 0;
	      this.sumaMontoBoletas = 0;
	      for (var i in this.boletas) {
	        if (this.boletas[i].estado == 'ACTIVO') {
	          this.sumaMontoBoletas += parseFloat(this.boletas[i].monto);
	        }
	      }
	      for (var _i in this.boletasEx) {
	        if (parseFloat(this.boletasEx[_i].monto)) {
	          this.sumaMontoBoletas += parseFloat(this.boletasEx[_i].monto);
	        }
	      }
	      this.completado = this.monto ? this.sumaMontoBoletas >= this.monto : false;
	      this.incompleto = this.sumaMontoBoletas < this.monto;
	      if (this.monto) {
	        this.mensaje = {
	          class: this.completado ? 'success' : this.incompleto ? 'warning' : '',
	          mensaje: this.completado ? 'Se completó el monto' : this.incompleto ? 'Debe completar el monto' : '',
	          icono: this.completado ? 'check' : this.incompleto ? 'warning' : ''
	        };
	      }
	    }
	
	    // Boletas extras
	
	  }, {
	    key: 'adicionarBoletaEx',
	    value: function adicionarBoletaEx() {
	      this.boletasEx.push({ tipo_boleta: this.tipo, estado: 'ACTIVO' });
	    }
	  }, {
	    key: 'quitarBoletaEx',
	    value: function quitarBoletaEx(indice) {
	      this.boletasEx.splice(indice, 1);
	    }
	  }, {
	    key: 'enviarBoletaEx',
	    value: function enviarBoletaEx() {
	      var _this3 = this;
	
	      this.Modal.confirm('\xBFEsta seguro/a de agregar las boletas?', function () {
	        _this3.DataService.post('boletas/proyecto/' + _this3.proyecto.id_proyecto, { boletas: _this3.boletasEx }).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this3.Message.success('Boleta(s) agregadas correctamente.');
	            _this3.$state.reload();
	          }
	        });
	      });
	    }
	  }]);
	
	  return BoletaGarantiaController;
	}();
	
	exports.default = BoletaGarantiaController;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boleta = __webpack_require__(459);
	
	var _boleta2 = _interopRequireDefault(_boleta);
	
	var _boleta3 = __webpack_require__(760);
	
	var _boleta4 = _interopRequireDefault(_boleta3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoletaComponent = {
	  bindings: {
	    model: '=',
	    indice: '<',
	    validaciones: '<',
	    tipoBoleta: '<',
	    modoVista: '<',
	    bid: '<'
	  },
	  controller: _boleta2.default,
	  template: _boleta4.default
	};
	
	exports.default = BoletaComponent;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BoletaController = function () {
	  BoletaController.$inject = ["$scope", "Proyecto", "Modal", "Util"];
	  function BoletaController($scope, Proyecto, Modal, Util) {
	    'ngInject';
	
	    _classCallCheck(this, BoletaController);
	
	    this.$scope = $scope;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.Util = Util;
	    this.mostrarBoletas = false;
	  }
	
	  _createClass(BoletaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.tiposDocumento = [{ codigo: 'BOLETA', nombre: 'Boleta' }, { codigo: 'POLIZA', nombre: 'Póliza' }];
	
	      this.opcionesFechaInicio = {
	        maxDateKey: 'fecha_fin_validez'
	      };
	
	      this.opcionesFechaFin = {
	        minDateKey: 'fecha_inicio_validez'
	      };
	    }
	  }]);
	
	  return BoletaController;
	}();
	
	exports.default = BoletaController;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _datosGenerales = __webpack_require__(463);
	
	var _datosGenerales2 = _interopRequireDefault(_datosGenerales);
	
	var _convenio = __webpack_require__(461);
	
	var _convenio2 = _interopRequireDefault(_convenio);
	
	var _asignacionResponsable = __webpack_require__(452);
	
	var _asignacionResponsable2 = _interopRequireDefault(_asignacionResponsable);
	
	var _desembolso = __webpack_require__(467);
	
	var _desembolso2 = _interopRequireDefault(_desembolso);
	
	var _autoridadBeneficiaria = __webpack_require__(454);
	
	var _autoridadBeneficiaria2 = _interopRequireDefault(_autoridadBeneficiaria);
	
	var _items = __webpack_require__(471);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _dbc = __webpack_require__(465);
	
	var _dbc2 = _interopRequireDefault(_dbc);
	
	var _garantia = __webpack_require__(469);
	
	var _garantia2 = _interopRequireDefault(_garantia);
	
	var _boletaGarantia = __webpack_require__(456);
	
	var _boletaGarantia2 = _interopRequireDefault(_boletaGarantia);
	
	var _boleta = __webpack_require__(458);
	
	var _boleta2 = _interopRequireDefault(_boleta);
	
	var _ordenProceder = __webpack_require__(475);
	
	var _ordenProceder2 = _interopRequireDefault(_ordenProceder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComponentsProyectos = angular.module('app.cforms', []).component('datosGenerales', _datosGenerales2.default).component('convenio', _convenio2.default).component('asignacionResponsable', _asignacionResponsable2.default).component('desembolso', _desembolso2.default).component('autoridadBeneficiaria', _autoridadBeneficiaria2.default).component('items', _items2.default)
	// .component('ejecutarTransicion', EjecutarTransicion)
	.component('dbc', _dbc2.default).component('garantia', _garantia2.default).component('boletaGarantia', _boletaGarantia2.default).component('boleta', _boleta2.default)
	// .component('equipoTecnico', EquipoTecnico)
	.component('ordenProceder', _ordenProceder2.default).name;
	// import EquipoTecnico from './equipo-tecnico/equipo-tecnico.component';
	
	// import EjecutarTransicion from './ejecutar-transicion/ejecutar-transicion.component';
	exports.default = ComponentsProyectos;

/***/ }),
/* 461 */
[858, 462, 761],
/* 462 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosGenerales = function () {
	  DatosGenerales.$inject = ["$scope", "Util", "Proyecto", "Modal", "_"];
	  function DatosGenerales($scope, Util, Proyecto, Modal, _) {
	    'ngInject';
	
	    _classCallCheck(this, DatosGenerales);
	
	    this.$scope = $scope;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this._ = _;
	    this.archivos = null;
	  }
	
	  _createClass(DatosGenerales, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.archivos = {
	        urlDocConvenio: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/C' : '',
	        urlDocConvenioDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/C/descargar' : '',
	        urlDocResolucion: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/RM' : '',
	        urlDocResolucionDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/RM/descargar' : ''
	      };
	      this.mostrar = true;
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.proyecto.monto_upre', function () {
	        if (!_this.proyecto) {
	          return;
	        }
	        _this.calcularMontoConvenio();
	      });
	      this.$scope.$watch('$ctrl.proyecto.monto_contraparte', function () {
	        if (!_this.proyecto) {
	          return;
	        }
	        _this.calcularMontoConvenio();
	      });
	    }
	  }, {
	    key: 'calcularMontoConvenio',
	    value: function calcularMontoConvenio() {
	      this.proyecto.monto_total_convenio = this.Util.redondear((this.proyecto.monto_upre ? this.proyecto.monto_upre : 0) + (this.proyecto.monto_contraparte ? this.proyecto.monto_contraparte : 0));
	    }
	  }]);
	
	  return DatosGenerales;
	}();
	
	exports.default = DatosGenerales;

/***/ }),
/* 463 */
[859, 464, 762],
/* 464 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosGenerales = function () {
	  DatosGenerales.$inject = ["DataService", "Util", "Proyecto", "Modal", "_"];
	  function DatosGenerales(DataService, Util, Proyecto, Modal, _) {
	    'ngInject';
	
	    _classCallCheck(this, DatosGenerales);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this._ = _;
	  }
	
	  _createClass(DatosGenerales, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verDocumento',
	    value: function verDocumento(tipo, nombreDocumento) {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/documentos/' + tipo, nombreDocumento);
	    }
	  }]);
	
	  return DatosGenerales;
	}();
	
	exports.default = DatosGenerales;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dbc = __webpack_require__(466);
	
	var _dbc2 = _interopRequireDefault(_dbc);
	
	var _dbc3 = __webpack_require__(763);
	
	var _dbc4 = _interopRequireDefault(_dbc3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dbcComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _dbc2.default,
	  template: _dbc4.default
	};
	
	exports.default = dbcComponent;

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DbcController = function () {
	  DbcController.$inject = ["Util", "Proyecto", "Modal"];
	  function DbcController(Util, Proyecto, Modal) {
	    'ngInject';
	
	    _classCallCheck(this, DbcController);
	
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	  }
	
	  _createClass(DbcController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verDocumento',
	    value: function verDocumento() {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/DBC', 'Documento Base de Contrataci\xF3n');
	    }
	  }, {
	    key: 'estaRegistrado',
	    value: function estaRegistrado() {
	      return typeof this.proyecto.doc_base_contratacion === 'string';
	    }
	  }]);
	
	  return DbcController;
	}();
	
	exports.default = DbcController;

/***/ }),
/* 467 */
[860, 468, 764],
/* 468 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DesembolsoController = function () {
	  DesembolsoController.$inject = ["Proyecto", "Modal", "Util", "Datetime"];
	  function DesembolsoController(Proyecto, Modal, Util, Datetime) {
	    'ngInject';
	
	    _classCallCheck(this, DesembolsoController);
	
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.Util = Util;
	    this.Datetime = Datetime;
	  }
	
	  _createClass(DesembolsoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.archivo = {
	        urlDocCertificacion: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CIP' : '',
	        urlDocCertificacionDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CIP/descargar' : ''
	      };
	      var fechaConvenio = this.Datetime.getFormatDate(this.proyecto.fecha_suscripcion_convenio);
	      this.validacion = {
	        fecha_minima: this.Datetime.addDaysToDate(angular.copy(fechaConvenio), 1),
	        mensaje_fecminima: 'La fecha debe ser mayor a la fecha del convenio (' + this.Datetime.parseDate(fechaConvenio, '/') + ')'
	      };
	    }
	  }]);
	
	  return DesembolsoController;
	}();
	
	exports.default = DesembolsoController;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _garantia = __webpack_require__(470);
	
	var _garantia2 = _interopRequireDefault(_garantia);
	
	var _garantia3 = __webpack_require__(765);
	
	var _garantia4 = _interopRequireDefault(_garantia3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GarantiaComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _garantia2.default,
	  template: _garantia4.default
	};
	
	exports.default = GarantiaComponent;

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GarantiaController = function () {
	  GarantiaController.$inject = ["$scope", "Proyecto", "_"];
	  function GarantiaController($scope, Proyecto, _) {
	    'ngInject';
	
	    _classCallCheck(this, GarantiaController);
	
	    this.$scope = $scope;
	    this.Proyecto = Proyecto;
	    this._ = _;
	  }
	
	  _createClass(GarantiaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.cContrato = {
	        porcentajeFijo: true,
	        porcentaje: 7,
	        monto: 0,
	        nombrePorcentaje: 'porcentaje_ccontrato',
	        nombreMonto: 'monto_ccontrato',
	        tipo: 'TB_CUMPLIMIENTO_CONTRATO'
	      };
	      this.anticipo = {
	        porcentajeFijo: false,
	        porcentaje: this.proyecto.porcentaje_anticipo,
	        monto: this.proyecto.anticipo,
	        nombrePorcentaje: 'porcentaje_anticipo',
	        nombreMonto: 'monto_anticipo',
	        tipo: 'TB_CORRECTA_INVERSION'
	      };
	
	      this.prepararBoletas();
	      this.$scope.$on('actualizarBoletas', function () {
	        _this.actualizarBoletas();
	      });
	    }
	  }, {
	    key: 'prepararBoletas',
	    value: function prepararBoletas() {
	      this.boletasCcontrato = this.getBoletasPorTipo('TB_CUMPLIMIENTO_CONTRATO');
	      this.boletasAnticipo = this.getBoletasPorTipo('TB_CORRECTA_INVERSION');
	    }
	  }, {
	    key: 'getBoletasPorTipo',
	    value: function getBoletasPorTipo(tipo) {
	      var BOLETAS = angular.copy(this.proyecto.boletas);
	      return this._.filter(BOLETAS, function (boleta) {
	        return boleta.tipo_boleta === tipo;
	      });
	    }
	  }, {
	    key: 'actualizarBoletas',
	    value: function actualizarBoletas() {
	      this.proyecto.boletas = this.boletasAnticipo.concat(this.boletasCcontrato);
	    }
	  }]);
	
	  return GarantiaController;
	}();
	
	exports.default = GarantiaController;

/***/ }),
/* 471 */
[861, 472, 766, 205],
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moduloModal = __webpack_require__(474);
	
	var _moduloModal2 = _interopRequireDefault(_moduloModal);
	
	var _moduloModal3 = __webpack_require__(768);
	
	var _moduloModal4 = _interopRequireDefault(_moduloModal3);
	
	var _archivoModal = __webpack_require__(82);
	
	var _archivoModal2 = _interopRequireDefault(_archivoModal);
	
	var _archivoModal3 = __webpack_require__(95);
	
	var _archivoModal4 = _interopRequireDefault(_archivoModal3);
	
	var _validacion = __webpack_require__(473);
	
	var _validacion2 = _interopRequireDefault(_validacion);
	
	var _validacion3 = __webpack_require__(767);
	
	var _validacion4 = _interopRequireDefault(_validacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemsController = function () {
	  ItemsController.$inject = ["DataService", "Util", "Modal", "NgTableParams", "_", "Message", "Proyecto", "Storage"];
	  function ItemsController(DataService, Util, Modal, NgTableParams, _, Message, Proyecto, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, ItemsController);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Modal = Modal;
	    this.NgTableParams = NgTableParams;
	    this._ = _;
	    this.Message = Message;
	    this.Proyecto = Proyecto;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(ItemsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modulos = [];
	      this.getListaModulos();
	      this.getTipoUnidades();
	    }
	  }, {
	    key: 'getListaModulos',
	    value: function getListaModulos(modulo) {
	      var _this = this;
	
	      this.DataService.get('modulos/proyectos/' + this.proyecto.id_proyecto).then(function (response) {
	        if (response && response.finalizado) {
	          _this.modulos = response.datos.rows;
	          if (modulo && _this.modulos.length) {
	            for (var i in _this.modulos) {
	              if (_this.modulos[i].id_modulo == modulo.id_modulo) {
	                _this.modulos[i].show = true;
	              }
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getTipoUnidades',
	    value: function getTipoUnidades() {
	      var _this2 = this;
	
	      this.DataService.get('parametricas/UNIDAD').then(function (response) {
	        if (response) {
	          _this2.unidades = response.datos.rows;
	        }
	      });
	    }
	  }, {
	    key: 'adicionarModulo',
	    value: function adicionarModulo() {
	      var _this3 = this;
	
	      var modulo = {
	        fid_proyecto: this.proyecto.id_proyecto
	      };
	      var modalModulo = this.mostrarModal('Nuevo Módulo', 'fa-plus', modulo, _moduloModal4.default, _moduloModal2.default);
	      modalModulo.result.then(function (result) {
	        if (result && result.datos) {
	          _this3.modulos.push(result.datos);
	        }
	      });
	    }
	  }, {
	    key: 'editarModulo',
	    value: function editarModulo(modulo) {
	      this.mostrarModal('Editando Módulo', 'fa-edit', modulo, _moduloModal4.default, _moduloModal2.default);
	    }
	  }, {
	    key: 'eliminarModulo',
	    value: function eliminarModulo(modulo) {
	      var _this4 = this;
	
	      var msg = modulo && modulo.items && modulo.items.length ? '\xBFEst\xE1 seguro/a de eliminar el m\xF3dulo ' + modulo.nombre + ' y los ' + modulo.items.length + ' items?' : '\xBFEst\xE1 seguro/a de eliminar el m\xF3dulo ' + modulo.nombre + '?';
	      this.Modal.confirm(msg, function () {
	        _this4.DataService.delete('modulos/' + modulo.id_modulo).then(function (result) {
	          if (result) {
	            _this4.modulos = _this4.eliminarElementoDeLista(_this4.modulos, modulo, 'id_modulo');
	            _this4.Message.success('Se elimin\xF3 el m\xF3dulo "' + modulo.nombre + '" correctamente.');
	            _this4.refrescarLista();
	          }
	        });
	      }, null, null, 'Si, estoy seguro/a');
	    }
	  }, {
	    key: 'adicionarItem',
	    value: function adicionarItem(modulo) {
	      if (!modulo.items) {
	        modulo.items = [];
	      }
	      for (var i in this.modulos) {
	        for (var j in this.modulos[i].items) {
	          if (!this.modulos[i].items[j].id_item || this.modulos[i].items[j].edicion) {
	            this.Message.warning('Debe guardar el item "' + (this.modulos[i].items[j].nombre || 'Sin nombre') + '"');
	            return;
	          }
	        }
	      }
	      modulo.items.push({ edicion: true });
	    }
	  }, {
	    key: 'guardarItem',
	    value: function guardarItem(item, index, indexModulo, modulo) {
	      var _this5 = this;
	
	      if (!this.sonDatosValidosItem(modulo, index)) {
	        return;
	      }
	      item.fid_modulo = modulo.id_modulo;
	      this.DataService.post('items', item).then(function (response) {
	        if (response) {
	          _this5.Message.success('Se registr\xF3 el item "' + item.nombre + '" correctamente.');
	          _this5.modulos[indexModulo].items[index] = response.datos;
	          _this5.refrescarLista(modulo);
	        }
	      });
	    }
	  }, {
	    key: 'actualizarItem',
	    value: function actualizarItem(item, index, modulo) {
	      var _this6 = this;
	
	      if (!this.sonDatosValidosItem(modulo, index)) {
	        return;
	      }
	      this.DataService.put('items/' + item.id_item, item).then(function (response) {
	        if (response) {
	          _this6.Message.success('Se actualizó los datos del item correctamente.');
	          item.edicion = false;
	        }
	      });
	    }
	  }, {
	    key: 'eliminarItem',
	    value: function eliminarItem(item, $index, modulo) {
	      var _this7 = this;
	
	      if (!item.id_item) {
	        modulo.items.splice($index, 1);
	        return;
	      }
	      this.DataService.delete('items/' + item.id_item).then(function (result) {
	        if (result) {
	          _this7.Message.success('Se elimin\xF3 el item "' + item.nombre + '" correctamente.');
	          modulo.items = _this7.eliminarElementoDeLista(modulo.items, item, 'id_item');
	          _this7.refrescarLista(modulo);
	        }
	      });
	    }
	  }, {
	    key: 'eliminarElementoDeLista',
	    value: function eliminarElementoDeLista(lista, elemento, atributo) {
	      return this._.reject(lista, function (item) {
	        return item[atributo] === elemento[atributo];
	      });
	    }
	  }, {
	    key: 'mostrarModal',
	    value: function mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
	      return this.Modal.show({
	        template: template,
	        controller: controller,
	        data: data || {},
	        title: titulo,
	        icon: icon,
	        size: size ? size : 'md',
	        labelOk: labelOk
	      });
	    }
	  }, {
	    key: 'guardarDatosModulo',
	    value: function guardarDatosModulo(modulo) {
	      var _this8 = this;
	
	      this.DataService.put('modulos/' + modulo.id_modulo, modulo).then(function (response) {
	        if (response) {
	          //modulo.items = response.datos.items;
	          _this8.Message.success('Se guard\xF3 correctamente los datos del m\xF3dulo "' + modulo.nombre + '".');
	          _this8.refrescarLista(modulo);
	        }
	      });
	    }
	  }, {
	    key: 'sonDatosValidosItem',
	    value: function sonDatosValidosItem(modulo, posicion) {
	      var nombreForm = 'form_' + modulo.id_modulo;
	      var FORM = angular.element(document.querySelector('[name=' + nombreForm + ']')).scope()[nombreForm];
	      var esValido = FORM['item_nombre_' + posicion].$valid && FORM['item_unidad_' + posicion].$valid && FORM['item_cantidad_' + posicion].$valid;
	
	      if (!esValido) {
	        FORM['item_nombre_' + posicion].$setTouched();
	        FORM['item_unidad_' + posicion].$setTouched();
	        FORM['item_cantidad_' + posicion].$setTouched();
	      }
	      if (!esValido) {
	        this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'importarItems',
	    value: function importarItems() {
	      var _this9 = this;
	
	      var confArchivo = {
	        //formatos: 'csv, xlsx, ods', //types
	        formatos: 'ods', //types
	        tipos: '.csv,.xlsx,.ods', //mime-types
	        cargarItems: true,
	        mensajeInformacion: 'Puede importar items desde un <strong>archivo en formato .ods</strong>.'
	      };
	      this.mostrarModal('Importar Items', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Importar').result.then(function (documento) {
	        var items = {
	          id_proyecto: _this9.proyecto.id_proyecto,
	          base64: documento.base64
	        };
	        _this9.DataService.post('items/file', items).then(function (result) {
	          if (result.finalizado) {
	            _this9.Message.success('Se importó correctamente los items.');
	            _this9.modulos = result.datos;
	          }
	          if (result.erroresValidacion) {
	            var modalModulo = _this9.mostrarModal('Observaciones en el archivo', 'fa-check', result.erroresValidacion, _validacion4.default, _validacion2.default, null, 'lg');
	            modalModulo.result.then(function (result) {
	              result;
	            });
	          }
	        });
	      });
	    }
	  }, {
	    key: 'cargarEspecificacionesTecnicas',
	    value: function cargarEspecificacionesTecnicas() {
	      var _this10 = this;
	
	      var confArchivo = {
	        formatos: 'pdf',
	        tipos: '.pdf',
	        mensajeInformacion: 'El archivo representará a las especificaciones técnicas de los items en general.'
	      };
	      this.mostrarModal('Especificaciones T\xE9cnicas', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (docEspecificaciones) {
	        if (angular.isUndefined(docEspecificaciones)) {
	          return;
	        }
	        _this10.DataService.put('proyectos/' + _this10.proyecto.id_proyecto, { doc_especificaciones_tecnicas: docEspecificaciones, rol: _this10.user.rol.id_rol }).then(function (result) {
	          if (result) {
	            _this10.Message.success('Se registr\xF3 el documento de especificaciones t\xE9cnicas correctamente.');
	            _this10.proyecto.doc_especificaciones_tecnicas = result.datos.doc_especificaciones_tecnicas;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'verEspecificacionesTecnicas',
	    value: function verEspecificacionesTecnicas() {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/ET', 'Especificaciones T\xE9cnicas');
	    }
	  }, {
	    key: 'cargarEspecificacionesItem',
	    value: function cargarEspecificacionesItem(item) {
	      var _this11 = this;
	
	      var confArchivo = {
	        formatos: 'pdf',
	        tipos: '.pdf'
	      };
	      this.mostrarModal('Especificaciones T\xE9cnicas - "' + item.nombre + '"', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (docEspecificaciones) {
	        if (angular.isUndefined(docEspecificaciones)) {
	          return;
	        }
	        _this11.DataService.put('items/' + item.id_item, { especificaciones: docEspecificaciones }).then(function (result) {
	          if (result && result.finalizado) {
	            _this11.Message.success('Se registr\xF3 el documento de especificaciones t\xE9cnicas del item "' + item.nombre + '" correctamente.');
	            item.especificaciones = docEspecificaciones;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'verEspecificacionesItem',
	    value: function verEspecificacionesItem(item) {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/ET_' + item.id_item, 'Especificaciones T\xE9cnicas - "' + item.nombre + '"');
	    }
	  }, {
	    key: 'refrescarLista',
	    value: function refrescarLista(modulo) {
	      this.getListaModulos(modulo);
	    }
	  }]);
	
	  return ItemsController;
	}();
	
	exports.default = ItemsController;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModuloController = function () {
	  ModuloController.$inject = ["$uibModalInstance", "data", "title", "icon", "DataService", "Message"];
	  function ModuloController($uibModalInstance, data, title, icon, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ModuloController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.title = title;
	    this.icon = icon;
	    this.DataService = DataService;
	    this.Message = Message;
	  }
	
	  _createClass(ModuloController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modulos = [];
	      this.mensajes = this.data;
	    }
	  }, {
	    key: 'guardar',
	    value: function guardar() {
	      var _this = this;
	
	      this.DataService.post('modulos', this.modulo).then(function (resp) {
	        if (resp) {
	          _this.Message.success("Se registró el módulo correctamente.");
	          _this.$uibModalInstance.close(resp);
	        }
	      });
	    }
	  }, {
	    key: 'actualizar',
	    value: function actualizar() {
	      var _this2 = this;
	
	      this.DataService.put('modulos/' + this.modulo.id_modulo, this.modulo).then(function (resp) {
	        if (resp) {
	          _this2.Message.success("Se actualizó el módulo correctamente.");
	          _this2.$uibModalInstance.close(resp);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ModuloController;
	}();
	
	exports.default = ModuloController;

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModuloController = function () {
	  ModuloController.$inject = ["$uibModalInstance", "data", "title", "icon", "DataService", "Message"];
	  function ModuloController($uibModalInstance, data, title, icon, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ModuloController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.title = title;
	    this.icon = icon;
	    this.DataService = DataService;
	    this.Message = Message;
	  }
	
	  _createClass(ModuloController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modulos = [];
	      this.modulo = this.data;
	    }
	  }, {
	    key: 'guardar',
	    value: function guardar() {
	      var _this = this;
	
	      this.DataService.post('modulos', this.modulo).then(function (resp) {
	        if (resp) {
	          _this.Message.success("Se registró el módulo correctamente.");
	          _this.$uibModalInstance.close(resp);
	        }
	      });
	    }
	  }, {
	    key: 'actualizar',
	    value: function actualizar() {
	      var _this2 = this;
	
	      this.DataService.put('modulos/' + this.modulo.id_modulo, this.modulo).then(function (resp) {
	        if (resp) {
	          _this2.Message.success("Se actualizó el módulo correctamente.");
	          _this2.$uibModalInstance.close(resp);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ModuloController;
	}();
	
	exports.default = ModuloController;

/***/ }),
/* 475 */
[862, 476, 769],
/* 476 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DesembolsoController = function () {
	  DesembolsoController.$inject = ["Proyecto", "_", "Datetime"];
	  function DesembolsoController(Proyecto, _, Datetime) {
	    'ngInject';
	
	    _classCallCheck(this, DesembolsoController);
	
	    this.Proyecto = Proyecto;
	    this._ = _;
	    this.Datetime = Datetime;
	  }
	
	  _createClass(DesembolsoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.prepararValidacionesFecha();
	    }
	  }, {
	    key: 'prepararValidacionesFecha',
	    value: function prepararValidacionesFecha() {
	      var fechaDesde = void 0,
	          mensajeError = 'La fecha debe ser mayor a la fecha';
	      if (this.tieneBoletas()) {
	        fechaDesde = this.fechaMasAntiguaDeBoletas();
	        mensajeError = mensajeError + ' de inicio de la boleta de anticipo m\xE1s antigua';
	      } else if (this.proyecto.tipo === 'TP_CIF') {
	        fechaDesde = this.proyecto.fecha_desembolso;
	        mensajeError = mensajeError + ' del desembolso';
	      } else {
	        fechaDesde = this.proyecto.fecha_suscripcion_convenio;
	        mensajeError = mensajeError + ' del convenio';
	      }
	      fechaDesde = this.Datetime.getFormatDate(fechaDesde);
	      this.validacion = {
	        fecha_minima: this.Datetime.addDaysToDate(angular.copy(fechaDesde), 1),
	        mensaje_fecminima: mensajeError + ' (' + this.Datetime.parseDate(fechaDesde, '/') + ')'
	      };
	    }
	  }, {
	    key: 'tieneBoletas',
	    value: function tieneBoletas() {
	      return this.proyecto.boletas.length > 0;
	    }
	  }, {
	    key: 'fechaMasAntiguaDeBoletas',
	    value: function fechaMasAntiguaDeBoletas() {
	      return this._.sortBy(this.proyecto.boletas, function (boleta) {
	        return boleta.fecha_inicio_validez;
	      })[0].fecha_inicio_validez;
	    }
	  }]);
	
	  return DesembolsoController;
	}();
	
	exports.default = DesembolsoController;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// import Bandeja from './bandeja/bandeja.module';
	// import Proyecto from './proyecto/proyecto.module';
	// import ProyectoService from './proyectos.service';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _cProyectos = __webpack_require__(460);
	
	var _cProyectos2 = _interopRequireDefault(_cProyectos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Proyectos = angular.module('app.proyectos', [
	// Bandeja,
	// Proyecto,
	_cProyectos2.default])
	// .service('Proyecto', ProyectoService)
	.name;exports.default = Proyectos;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _avanceProyecto = __webpack_require__(479);
	
	var _avanceProyecto2 = _interopRequireDefault(_avanceProyecto);
	
	var _avanceProyecto3 = __webpack_require__(770);
	
	var _avanceProyecto4 = _interopRequireDefault(_avanceProyecto3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvanceProyectoComponent = {
	  bindings: {},
	  controller: _avanceProyecto2.default,
	  template: _avanceProyecto4.default
	};
	
	exports.default = AvanceProyectoComponent;

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AvanceProyectoController = function () {
	  AvanceProyectoController.$inject = ["DataService", "Storage", "Modal", "$state", "$stateParams", "DataTable", "Proyecto"];
	  function AvanceProyectoController(DataService, Storage, Modal, $state, $stateParams, DataTable, Proyecto) {
	    'ngInject';
	
	    _classCallCheck(this, AvanceProyectoController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.DataTable = DataTable;
	    this.Proyecto = Proyecto;
	  }
	
	  _createClass(AvanceProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.idProyecto = this.$stateParams.idProyecto;
	      this.matricula = this.$stateParams.matricula;
	      this.getProyecto();
	      this.cargarTabla();
	    }
	  }, {
	    key: 'getProyecto',
	    value: function getProyecto() {
	      var _this = this;
	
	      this.DataService.get('proyectos/empresas/' + this.matricula + '/' + this.idProyecto).then(function (response) {
	        _this.proyecto = response.datos;
	        _this.Proyecto.setCopia(response.datos);
	      });
	    }
	  }, {
	    key: 'nuevaSupervision',
	    value: function nuevaSupervision() {
	      var _this2 = this;
	
	      var data = {
	        fid_proyecto: this.idProyecto,
	        computo_metrico: []
	      };
	      this.DataService.post('supervisiones', data).then(function (response) {
	        _this2.irPlanilla(_this2.matricula, _this2.idProyecto, response.datos.id_supervision);
	      });
	    }
	  }, {
	    key: 'irPlanilla',
	    value: function irPlanilla(matricula, idProyecto, idSupervision) {
	      this.$state.go('planilla-proyecto', { idSupervision: idSupervision });
	    }
	
	    // nuevaPlanilla() {
	    //   this.$state.go('planilla', {codigo: this.idProyecto});
	    //   // this.Modal.show({
	    //   //   template: modalPlanillasTemplate,
	    //   //   controller: modalAvanceProyectoController,
	    //   //   size: 'md'
	    //   // }).result.then( result => {
	    //   //   this.$state.go('documentacion-proyecto', {codigo: result.id_proyecto});
	    //   // });
	    // }
	
	
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this3 = this;
	
	      var colors = {
	        NUEVO: 'default',
	        ENVIADO: 'primary',
	        APROBADO: 'success',
	        PENDIENTE_PAGO: 'warning',
	        OBSERVADO: 'danger'
	      };
	      this.planillas = {
	        url: 'supervisiones',
	        queryExtra: { fid_proyecto: this.idProyecto, origen: 'bandeja' },
	        data: {
	          formly: [{
	            key: 'id_supervision',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'fid_proyecto',
	            type: 'fid_proyecto',
	            templateOptions: {
	              label: 'ID proyecto',
	              type: 'number'
	            }
	          }, {
	            key: 'nro_supervision',
	            type: 'input',
	            templateOptions: {
	              label: 'Nro',
	              type: 'number'
	            }
	          }, {
	            key: 'fecha_inicio',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha de creación',
	              type: 'date'
	            }
	          }, {
	            key: 'fecha_fin',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha de creación',
	              type: 'date'
	            }
	          }, {
	            key: 'data',
	            type: 'input',
	            templateOptions: {
	              label: 'Fid caeb',
	              type: 'number'
	            }
	          }, {
	            key: 'estado_supervision',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              options: [{ value: 'NUEVO', name: 'NUEVO' }, { value: 'ENVIADO', name: 'ENVIADO' }, { value: 'APROBADO', name: 'APROBADO' }, { value: 'OBSERVADO', name: 'OBSERVADO' }]
	            }
	          }]
	        },
	        fields: ['id_supervision', 'fid_proyecto', 'nro_supervision', 'fecha_inicio', 'fecha_fin', 'data', 'estado_supervision'],
	        hiddenFields: ['id_supervision', 'fid_proyecto', 'id_producto', 'extra'],
	        // fks: ['fid_formulario'],
	        permission: {
	          create: true,
	          update: false,
	          delete: false,
	          filter: false
	        },
	        labels: { create: 'NUEVA PLANILLA' },
	        eventCreate: function eventCreate() {
	          _this3.nuevaSupervision();
	        },
	        buttons: [{
	          icon: 'eye',
	          tooltip: 'Ver planilla',
	          // if: (ev, item) => { return item.estado==='APROBADO'; },
	          onclick: function onclick(ev, item) {
	
	            _this3.irPlanilla(_this3.matricula, _this3.idProyecto, item.id_supervision);
	            // this.$log.log(ev, item);
	            // this.Modal.pdf(`cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/${item.id_sello_bolivia}`);
	          }
	        }],
	        clases: {
	          estado: function estado(item) {
	            // this.$log.log(item);
	            return ['badge', 'badge-' + colors[item.estado]];
	          }
	        }
	      };
	    }
	  }]);
	
	  return AvanceProyectoController;
	}();
	
	exports.default = AvanceProyectoController;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _avanceProyecto = __webpack_require__(478);
	
	var _avanceProyecto2 = _interopRequireDefault(_avanceProyecto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var avanceProyecto = angular.module('app.avanceProyecto', []).component('avanceProyecto', _avanceProyecto2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('avance-proyecto', {
	        url: '/avance-proyecto/:matricula/:idProyecto',
	        component: 'avanceProyecto'
	    });
	}]).name;
	
	exports.default = avanceProyecto;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _computoProyecto = __webpack_require__(482);
	
	var _computoProyecto2 = _interopRequireDefault(_computoProyecto);
	
	var _computoProyecto3 = __webpack_require__(771);
	
	var _computoProyecto4 = _interopRequireDefault(_computoProyecto3);
	
	__webpack_require__(206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComputoProyectoComponent = {
	  bindings: {
	    supervision: '<',
	    item: '<',
	    computos: '=',
	    modoVista: '<?',
	    modificados: '=',
	    existeCambios: '='
	  },
	  controller: _computoProyecto2.default,
	  template: _computoProyecto4.default
	};
	
	exports.default = ComputoProyectoComponent;

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ComputoProyectoController = function () {
	  ComputoProyectoController.$inject = ["$scope", "DataService", "Supervision", "Computo", "_", "Util", "Loading"];
	  function ComputoProyectoController($scope, DataService, Supervision, Computo, _, Util, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, ComputoProyectoController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Supervision = Supervision;
	    this.Computo = Computo;
	    this._ = _;
	    this.Util = Util;
	    this.Loading = Loading;
	    this.items = [];
	    this.esEditable = false;
	    this.supervisionHistorica = {};
	    this.computoFinalizado = true;
	  }
	
	  _createClass(ComputoProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modificados = [];
	      this.idSupervision = this.supervision.id_supervision;
	
	      this.resumen = {
	        cant_ejecutada: 0,
	        cant_faltante: 0,
	        cant_anterior: 0 // cantidad total de las planillas anteriores
	      };
	
	      this.inicializarDatos();
	      this.items = this.Supervision.getItems();
	    }
	  }, {
	    key: 'inicializarDatos',
	    value: function inicializarDatos() {
	      this.getDatosItem();
	      this.supervisiones = [];
	      this.supervisionHistorica = {};
	      this.computoFinalizado = true;
	    }
	  }, {
	    key: 'getDatosItem',
	    value: function getDatosItem() {
	      var _this = this;
	
	      this.Loading.show('Cargando datos del item.', true);
	      this.DataService.get('items/' + this.item.id_item + '/resumen').then(function (response) {
	        _this.item = response.datos;
	        _this.getSupervisionesItem();
	        _this.getComputosItem(_this.supervision.id_supervision);
	        _this.$scope.$broadcast('recargarFotos');
	      });
	    }
	
	    /**
	     * getSupervisionesItem - Obteniendo las supervisiones en las que se han registrado cómputos métricos de un item
	     */
	
	  }, {
	    key: 'getSupervisionesItem',
	    value: function getSupervisionesItem() {
	      var _this2 = this;
	
	      this.DataService.get('items/' + this.item.id_item + '/supervisiones').then(function (response) {
	        _this2.prepararSupervisiones(response.datos);
	      });
	    }
	  }, {
	    key: 'getComputosItem',
	    value: function getComputosItem(idSupervision) {
	      var _this3 = this;
	
	      this.DataService.get('computos_metricos?item=' + this.item.id_item + '&supervision=' + idSupervision).then(function (response) {
	        _this3.resumen.cant_anterior = response.datos.cantidad_anterior;
	        _this3.computos = _this3.Computo.getListaOrdenadaComputos(response.datos.computos, _this3.item);
	        _this3.copiaComputos = angular.copy(_this3.computos);
	        _this3.procesarFotos(response.datos.fotos);
	        _this3.$scope.$broadcast('recargarDatosComputos');
	        _this3.actualizarResumen();
	        _this3.establecerEdicion();
	        _this3.Loading.hide();
	      });
	    }
	  }, {
	    key: 'procesarFotos',
	    value: function procesarFotos(fotos) {
	      var _this4 = this;
	
	      fotos.forEach(function (foto) {
	        foto.name = foto.nombre.substring(0, foto.nombre.indexOf('_'));
	        foto.nombre = foto.nombre.substring(foto.nombre.indexOf('_') + 1);
	        foto.show = true;
	        _this4.fotos[foto.name] = foto;
	        //guardamos backup para recuperar el id_foto_supervision
	        _this4.fotos.backups[foto.name] = angular.copy(_this4.fotos[foto.name]);
	      });
	    }
	  }, {
	    key: 'actualizarResumen',
	    value: function actualizarResumen() {
	      this.resumen = this.Computo.getResumen(this.item, this.computos, this.resumen);
	    }
	  }, {
	    key: 'establecerEdicion',
	    value: function establecerEdicion() {
	      this.esEditable = this.Supervision.esEditable('computos') && this.item.cantidad > 0 && this.Supervision.getSupervision().id_supervision === this.supervisionHistorica.id_supervision;
	    }
	  }, {
	    key: 'irItemPosicion',
	    value: function irItemPosicion(opcion) {
	      var _this5 = this;
	
	      if (!opcion) {
	        return;
	      }
	      if (this.existeCambios) {
	        this.$scope.$broadcast('guardarComputosMetricos', function () {
	          _this5.siguienteAnterior(opcion);
	        });
	      } else {
	        this.siguienteAnterior(opcion);
	      }
	    }
	  }, {
	    key: 'siguienteAnterior',
	    value: function siguienteAnterior(opcion) {
	      var POSICION = this._.findIndex(this.items, { id_item: parseInt(this.item.id_item) });
	      if (opcion === 'siguiente' && POSICION === this.items.length - 1 || opcion === 'anterior' && POSICION === 0) {
	        return;
	      } else {
	        var POSICION_SIGUIENTE = opcion === 'siguiente' ? POSICION + 1 : opcion === 'anterior' ? POSICION - 1 : POSICION;
	        this.item = this.items[POSICION_SIGUIENTE];
	        this.inicializarDatos();
	      }
	    }
	  }, {
	    key: 'esPrimerItem',
	    value: function esPrimerItem() {
	      return this._.findIndex(this.items, { id_item: this.item.id_item }) === 0;
	    }
	  }, {
	    key: 'esUltimoItem',
	    value: function esUltimoItem() {
	      return this._.findIndex(this.items, { id_item: this.item.id_item }) === this.items.length - 1;
	    }
	  }, {
	    key: 'prepararSupervisiones',
	    value: function prepararSupervisiones(supervisiones) {
	      var _this6 = this;
	
	      if (this.supervision.estado_supervision === 'REGISTRO_PLANILLA_FDI') {
	        var SUPERVISION_ACTUAL = {
	          id_supervision: this.supervision.id_supervision,
	          estado_supervision: this.supervision.estado_supervision
	        };
	        if (supervisiones.length === 0) {
	          supervisiones = [SUPERVISION_ACTUAL];
	        } else {
	          var FINALIZADO = this._.find(supervisiones, { estado_supervision: 'EN_ARCHIVO_FDI' });
	          if (FINALIZADO && !this.item.completado) {
	            supervisiones.push(SUPERVISION_ACTUAL);
	          }
	        }
	      }
	
	      supervisiones.map(function (supervision) {
	        if (supervision.estado_supervision === 'REGISTRO_PLANILLA_FDI') {
	          Object.assign(supervision, { nombre: 'En proceso' });
	          _this6.asignarValorSupervHistorica(supervision);
	        } else {
	          if (supervision.nro_supervision) {
	            Object.assign(supervision, { nombre: 'Planilla ' + supervision.nro_supervision });
	          }
	        }
	      });
	
	      this.supervisiones = supervisiones;
	      if (!this.esEditable) {
	        var _SUPERVISION_ACTUAL = this._.find(this.supervisiones, { id_supervision: this.supervision.id_supervision });
	        if (_SUPERVISION_ACTUAL) {
	          this.asignarValorSupervHistorica(_SUPERVISION_ACTUAL);
	        }
	      }
	    }
	  }, {
	    key: 'asignarValorSupervHistorica',
	    value: function asignarValorSupervHistorica(supervision) {
	      this.supervisionHistorica = supervision;
	      this.verificarComputoFinalizado();
	    }
	  }, {
	    key: 'mostrarDatosSupervision',
	    value: function mostrarDatosSupervision() {
	      this.verificarComputoFinalizado();
	      this.getComputosItem(this.supervisionHistorica.id_supervision);
	      this.$scope.$broadcast('recargarFotos');
	    }
	  }, {
	    key: 'verificarComputoFinalizado',
	    value: function verificarComputoFinalizado() {
	      this.computoFinalizado = this.supervisionHistorica.estado_supervision === 'EN_ARCHIVO_FDI';
	    }
	  }, {
	    key: 'puedeVerComputos',
	    value: function puedeVerComputos() {
	      return (this.supervision.estado_supervision === 'REGISTRO_PLANILLA_FDI' ? true : this.resumen.total_actual > 0 && this.item.estado !== 'CERRADO_FDI') || this.supervisionHistorica.id_supervision && this.supervisionHistorica.id_supervision !== this.supervision.id_supervision;
	    }
	  }]);
	
	  return ComputoProyectoController;
	}();
	
	exports.default = ComputoProyectoController;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _computoProyecto = __webpack_require__(481);
	
	var _computoProyecto2 = _interopRequireDefault(_computoProyecto);
	
	var _resumen = __webpack_require__(489);
	
	var _resumen2 = _interopRequireDefault(_resumen);
	
	var _fotos = __webpack_require__(487);
	
	var _fotos2 = _interopRequireDefault(_fotos);
	
	var _computosMetricos = __webpack_require__(485);
	
	var _computosMetricos2 = _interopRequireDefault(_computosMetricos);
	
	var _computo = __webpack_require__(484);
	
	var _computo2 = _interopRequireDefault(_computo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var computoProyecto = angular.module('app.computoProyecto', []).component('computoProyecto', _computoProyecto2.default).component('resumenComputos', _resumen2.default).component('fotosComputos', _fotos2.default).component('computosMetricos', _computosMetricos2.default).service('Computo', _computo2.default).name;
	
	exports.default = computoProyecto;

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ComputosService = function () {
	  ComputosService.$inject = ["DataService", "$q", "Datetime", "Util", "$window", "_", "Big", "decimales"];
	  function ComputosService(DataService, $q, Datetime, Util, $window, _, Big, decimales) {
	    'ngInject';
	
	    _classCallCheck(this, ComputosService);
	
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.estadoActual = null;
	    this.Util = Util;
	    this.$window = $window;
	    this.$q = $q;
	    this.proyectoOrigen = {};
	    this._ = _;
	    this.Big = Big;
	    this.decimales = decimales;
	  }
	
	  _createClass(ComputosService, [{
	    key: 'setCantParcial',
	    value: function setCantParcial(unidad, computo) {
	      unidad = unidad || '';
	      unidad = unidad.toUpperCase();
	      var cantidadParcial = 0;
	      var cc = this.Big(computo.cantidad ? computo.cantidad : 0);
	      var cff = this.Big(computo.factor_forma ? computo.factor_forma : 0);
	      var clargo = this.Big(computo.largo ? computo.largo : 0);
	      var calto = this.Big(computo.alto ? computo.alto : 0);
	      var cancho = this.Big(computo.ancho ? computo.ancho : 0);
	      switch (unidad) {
	        case 'UN_METRO_CUB':
	          // con redondeos intermedios
	          // computo.area = cff.mul(clargo.mul(cancho).mul(calto).toFixed(this.decimales||2)).toFixed(this.decimales||2).toString();
	          // cantidadParcial = cc.mul(computo.area).toString();
	          // sin redondeos intermedios
	          computo.area = cff.mul(clargo).mul(cancho).mul(calto).toFixed(this.decimales || 2).toString();
	          cantidadParcial = cc.mul(cff).mul(clargo).mul(cancho).mul(calto).toFixed(this.decimales || 2).toString();
	          break;
	        case 'UN_METRO_CUAD':
	          // con redondeos intermedios
	          // computo.area = cff.mul(clargo.mul(calto).toFixed(this.decimales||2)).toFixed(this.decimales||2).toString();
	          // cantidadParcial = cc.mul(computo.area).toString();
	          // sin redondeos intermedios
	          if (computo.alto && !computo.ancho) {
	            computo.area = cff.mul(clargo.mul(calto)).toFixed(this.decimales || 2).toString();
	            cantidadParcial = cc.mul(cff).mul(clargo).mul(calto).toFixed(this.decimales || 2).toString();
	          } else if (computo.ancho && !computo.alto) {
	            computo.area = cff.mul(clargo.mul(cancho)).toFixed(this.decimales || 2).toString();
	            cantidadParcial = cc.mul(cff).mul(clargo).mul(cancho).toFixed(this.decimales || 2).toString();
	          } else {
	            cantidadParcial = 0;
	            computo.area = cantidadParcial.toFixed(this.decimales || 2).toString();
	            cantidadParcial = cantidadParcial.toFixed(this.decimales || 2).toString();
	          }
	          break;
	        case 'UN_METRO':
	          cantidadParcial = cc.mul(clargo).toString();
	          break;
	        case 'UN_PIEZA':
	        case 'UN_PUNTO':
	        case 'UN_GLOBAL':
	        default:
	          cantidadParcial = computo.cantidad;
	          break;
	      }
	      computo.cantidad_parcial = cantidadParcial;
	    }
	  }, {
	    key: 'getConf',
	    value: function getConf(unidad) {
	      unidad = unidad || '';
	      unidad = unidad.toUpperCase();
	      var val = {}; // valor a retornar
	      switch (unidad) {
	        case 'UN_METRO_CUB':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false, decimals: 0 },
	            factor_forma: { required: true, disabled: false },
	            largo: { required: true, disabled: false },
	            ancho: { required: true, disabled: false },
	            alto: { required: true, disabled: false },
	            area: { required: true, disabled: true, class: 'bg-white' },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_METRO_CUAD':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false, decimals: 0 },
	            factor_forma: { required: true, disabled: false },
	            largo: { required: true, disabled: false },
	            ancho: { required: false, disabled: false },
	            alto: { required: false, disabled: false },
	            area: { required: true, disabled: true, class: 'bg-white' },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_METRO':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false, decimals: 0 },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: true, disabled: false },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_PIEZA':
	        case 'UN_PUNTO':
	        case 'UN_GLOBAL':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false, decimals: 0 },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: false, disabled: true },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        default:
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false, decimals: 2 },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: false, disabled: true },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	      }
	      return val;
	    }
	  }, {
	    key: 'getListaOrdenadaComputos',
	    value: function getListaOrdenadaComputos(computos, item) {
	      if (computos.length == 0) {
	        computos.push({});
	      } else {
	        // Se ordena por subtitulo
	        var indexs_subtitulos = {}; // buscar todos los subtitulos y luego añadirlos;
	        var computo_auxiliar = computos[0];
	        indexs_subtitulos[0] = computo_auxiliar.subtitulo;
	        computos.forEach(function (computo, i) {
	          if (computo.subtitulo != computo_auxiliar.subtitulo) {
	            indexs_subtitulos[i] = computo.subtitulo;
	            computo_auxiliar = computo;
	          }
	          if (item.unidad_medida === 'UN_METRO_CUB') {
	            computo.area = computo.volumen;
	          }
	        });
	        var i = 0;
	        for (var k in indexs_subtitulos) {
	          if (indexs_subtitulos[k]) {
	            computos.splice(parseInt(k) + i, 0, { isSubtitulo: true, descripcion: indexs_subtitulos[k] });
	            i++;
	          }
	        }
	      }
	      return computos;
	    }
	  }, {
	    key: 'getResumen',
	    value: function getResumen(item, computos, resumen) {
	      var _this = this;
	
	      resumen.total_actual = 0;
	      computos.forEach(function (computo) {
	        if (!computo.isSubtitulo) {
	          resumen.total_actual = _this.Util.sumar([resumen.total_actual, parseFloat(computo.cantidad_parcial) || 0], true, 6);
	        }
	      });
	      resumen.cant_ejecutada = this.Util.sumar([resumen.total_actual, resumen.cant_anterior], true, 6);
	      resumen.cant_faltante = item.cantidad > 0 ? this.Util.restar(item.cantidad, resumen.cant_ejecutada) : 0;
	      return resumen;
	    }
	  }]);
	
	  return ComputosService;
	}();
	
	exports.default = ComputosService;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _computosMetricos = __webpack_require__(486);
	
	var _computosMetricos2 = _interopRequireDefault(_computosMetricos);
	
	var _computosMetricos3 = __webpack_require__(772);
	
	var _computosMetricos4 = _interopRequireDefault(_computosMetricos3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComputoProyectoComponent = {
	  bindings: {
	    supervision: '=',
	    item: '=',
	    computos: '=',
	    copiaComputos: '=',
	    resumen: '=',
	    fotos: '=',
	    modoVista: '<?',
	    existeCambios: '=',
	    modificados: '='
	  },
	  controller: _computosMetricos2.default,
	  template: _computosMetricos4.default
	};
	
	exports.default = ComputoProyectoComponent;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ComputosMetricosController = function () {
	  ComputosMetricosController.$inject = ["$scope", "DataService", "Modal", "Message", "Computo", "Util", "Loading", "_", "apiUrl"];
	  function ComputosMetricosController($scope, DataService, Modal, Message, Computo, Util, Loading, _, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, ComputosMetricosController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Message = Message;
	    this.Computo = Computo;
	    this.Util = Util;
	    this.Loading = Loading;
	    this._ = _;
	    this.apiUrl = apiUrl;
	    this.copiaComputos = {};
	  }
	
	  _createClass(ComputosMetricosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.descargaEsp = {
	        url: this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/ET_' + this.item.id_item + '/descargar',
	        nombre: 'Especificaciones item ' + this.item.nro_item
	      };
	      // `${this.apiUrl}proyectos/${this.supervision.fid_proyecto}/doc/ET/descargar`;
	      this.$scope.$on('recargarDatosComputos', function () {
	        _this.recargarDatos();
	      });
	      this.$scope.$on('guardarComputosMetricos', function (event, callback) {
	        _this.saveAllRow(callback);
	      });
	    }
	  }, {
	    key: 'recargarDatos',
	    value: function recargarDatos() {
	      this.sacarCopiaComputos();
	      this.configSegunUnidadMedida();
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.computos', function () {
	        if (!_this2.computos) {
	          return;
	        }
	        _this2.determinarCambiosEnComputos();
	      }, true);
	    }
	  }, {
	    key: 'determinarCambiosEnComputos',
	    value: function determinarCambiosEnComputos() {
	      this.existeCambios = !angular.equals(JSON.parse(angular.toJson(this.computos)), this.copiaComputos);
	      if (this.existeCambios) {
	        this.actualizarItemsModificados();
	      }
	    }
	  }, {
	    key: 'actualizarItemsModificados',
	    value: function actualizarItemsModificados() {
	      if (this.modificados.indexOf(this.item.id_item) === -1) {
	        this.modificados.push(this.item.id_item);
	      }
	    }
	  }, {
	    key: 'configSegunUnidadMedida',
	    value: function configSegunUnidadMedida() {
	      this.conf = this.Computo.getConf(this.item.unidad_medida);
	    }
	
	    // esCantidadEntera() {
	    //   const unidades_convencionales = ['UN_METRO_CUB', 'UN_METRO_CUAD', 'UN_METRO', 'UN_GLOBAL', 'UN_PIEZA', 'UN_PUNTO'];
	    //   return unidades_convencionales.indexOf(this.item.unidad_medida) !== -1;
	    // }
	
	  }, {
	    key: 'changeComputo',
	    value: function changeComputo(computo) {
	      this.Computo.setCantParcial(this.item.unidad_medida, computo);
	      this.actualizarResumen();
	    }
	  }, {
	    key: 'uniformarArea',
	    value: function uniformarArea(nuevo, computo) {
	      if (this.item.unidad_medida === 'UN_METRO_CUAD') {
	        if (nuevo === 'alto' && computo.alto) delete computo.ancho;
	        if (nuevo === 'ancho' && computo.ancho) delete computo.alto;
	      }
	    }
	  }, {
	    key: 'addRow',
	    value: function addRow() {
	      // Avance de unidades Globales puede tener mas de una fila
	      // if (this.item.unidad_medida === 'UN_GLOBAL' && this.computos.length == 1) {
	      //   this.Message.warning('Solo puede tener un computo para la unidad de medida GLOBAL');
	      //   return;
	      // }
	      var subtitulo = null;
	      for (var i = this.computos.length - 1; i >= 0; i--) {
	        if (this.computos[i].isSubtitulo) {
	          subtitulo = this.computos[i].descripcion;
	          break;
	        }
	      }
	      this.computos.push({ subtitulo: subtitulo });
	    }
	  }, {
	    key: 'saveRow',
	    value: function saveRow(computo, i) {
	      var _this3 = this;
	
	      if (!this.sonDatosValidos(i)) {
	        return;
	      }
	      computo.id = computo.id_computo_metrico;
	      computo.fid_item = this.item.id_item;
	      computo.fid_supervision = this.supervision.id_supervision;
	      computo.orden = i;
	      computo = this.quitarCamposNulos(computo);
	      if (!computo.subtitulo) {
	        computo.subtitulo = null;
	      }
	      this.DataService.save('computos_metricos/', computo).then(function (response) {
	        if (response && response.finalizado) {
	          _this3.Message.success(response.mensaje);
	          angular.extend(computo, response.datos);
	          if (_this3.item.unidad_medida === 'UN_METRO_CUB') {
	            computo.area = response.datos.volumen;
	          }
	          _this3.sacarCopiaComputos(computo);
	        }
	      });
	    }
	  }, {
	    key: 'saveAllRow',
	    value: function saveAllRow(callback) {
	      var _this4 = this;
	
	      if (!this.sonDatosValidos()) {
	        return;
	      }
	      var datos = {
	        computos: []
	      };
	      if (this.computos.length) {
	        var fila = this.computos[0];
	        var subtitulo = fila.isSubtitulo ? fila.descripcion : null;
	        for (var i = 0; i < this.computos.length; i++) {
	          if (this.computos[i].isSubtitulo) {
	            subtitulo = this.computos[i].descripcion;
	          } else {
	            this.computos[i].subtitulo = subtitulo;
	            this.computos[i].fid_item = this.item.id_item;
	            this.computos[i].fid_supervision = this.supervision.id_supervision;
	            this.computos[i].orden = i;
	            datos.computos.push(this.quitarCamposNulos(this.computos[i]));
	          }
	        }
	
	        this.DataService.put('computos_metricos/items/' + this.item.id_item, datos).then(function (response) {
	          if (response && response.finalizado) {
	            _this4.Message.success(response.mensaje);
	            _this4.computos = _this4.Computo.getListaOrdenadaComputos(response.datos, _this4.item);
	            _this4.sacarCopiaComputos();
	            if (callback) {
	              callback();
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'deleteRow',
	    value: function deleteRow(computo, index) {
	      var _this5 = this;
	
	      if (computo.id_computo_metrico) {
	        this.Modal.confirm('¿Está seguro/a de eliminar el cómputo?', function () {
	          _this5.DataService.delete('computos_metricos/' + computo.id_computo_metrico, computo).then(function (response) {
	            if (response) {
	              _this5.Message.success(response.mensaje);
	              _this5.quitarComputoDeLista(index);
	              _this5.actualizarResumen();
	            }
	          });
	        }, null, null, 'Sí, estoy seguro/a', 'Cancelar');
	      } else {
	        this.quitarComputoDeLista(index);
	        this.actualizarResumen();
	      }
	    }
	  }, {
	    key: 'deleteAllRow',
	    value: function deleteAllRow() {
	      var _this6 = this;
	
	      if (!this.tieneDatos()) {
	        this.Message.warning('No tiene c\xF3mputos m\xE9tricos para eliminar.');
	        return;
	      }
	
	      this.Modal.confirm('¿Está seguro/a de eliminar todos los cómputos de este item?', function () {
	        var i = _this6.computos.length;
	        while (i--) {
	          if (!_this6.computos[i].id_computo_metrico) {
	            _this6.quitarComputoDeLista(i);
	          }
	        }
	        if (_this6.computos.length === 1 && _this6._.isEmpty(_this6.computos[0])) {
	          _this6.actualizarResumen();
	          return;
	        }
	        _this6.DataService.delete('computos_metricos/' + _this6.supervision.id_supervision + '/todos/' + _this6.item.id_item).then(function (response) {
	          if (response) {
	            _this6.quitarComputoDeLista(null, true);
	            _this6.actualizarResumen();
	            _this6.Message.success(response.mensaje);
	          }
	        });
	      }, null, null, 'Sí, estoy seguro/a', 'Cancelar');
	    }
	  }, {
	    key: 'actualizarResumen',
	    value: function actualizarResumen() {
	      this.resumen = this.Computo.getResumen(this.item, this.computos, this.resumen);
	    }
	  }, {
	    key: 'tieneDatos',
	    value: function tieneDatos() {
	      if (!this.computos || this.computos.length === 1 && !this.computos[0].cantidad) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'sonDatosValidos',
	    value: function sonDatosValidos(fila) {
	      if (this.resumen.cant_faltante < 0) {
	        this.Message.error('La cantidad faltante no puede ser negativa, reajuste los valores.');
	        return false;
	      }
	      var form = this.$scope.form_computo;
	      var sonCamposValidos = void 0;
	      if (fila) {
	        sonCamposValidos = this.verificarDatosComputo(form, fila);
	      } else {
	        for (var i = 0; i < this.computos.length; i++) {
	          if (!this.computos[i].isSubtitulo) {
	            sonCamposValidos = this.verificarDatosComputo(form, i);
	          }
	        }
	      }
	      if (!sonCamposValidos) {
	        this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'verificarDatosComputo',
	    value: function verificarDatosComputo(form, i) {
	      var esValido = form['descripcion_' + i].$valid && form['cantidad_' + i].$valid && form['factor_forma_' + i].$valid && form['largo_' + i].$valid && form['ancho_' + i].$valid && form['alto_' + i].$valid && form['area_' + i].$valid && form['cantidad_parcial_' + i].$valid;
	      if (!esValido) {
	        form['descripcion_' + i].$setTouched();
	        form['cantidad_' + i].$setTouched();
	        form['factor_forma_' + i].$setTouched();
	        form['largo_' + i].$setTouched();
	        form['ancho_' + i].$setTouched();
	        form['alto_' + i].$setTouched();
	        form['area_' + i].$setTouched();
	        form['cantidad_parcial_' + i].$setTouched();
	        form['area_' + i].$setDirty();
	        form['cantidad_parcial_' + i].$setDirty();
	      }
	      return esValido;
	    }
	  }, {
	    key: 'quitarCamposNulos',
	    value: function quitarCamposNulos(computo) {
	      for (var k in computo) {
	        if (computo[k] === null) {
	          delete computo[k];
	        }
	      }
	      return computo;
	    }
	  }, {
	    key: 'quitarComputoDeLista',
	    value: function quitarComputoDeLista(posicion, todos) {
	      if (this.computos.length === 1 || todos) {
	        this.computos = [{}];
	      } else {
	        this.computos.splice(posicion, 1);
	      }
	      this.sacarCopiaComputos();
	      this.actualizarItemsModificados();
	    }
	  }, {
	    key: 'addSubtitulo',
	    value: function addSubtitulo() {
	      if (angular.isUndefined(this.index_subtitulo)) {
	        this.Message.warning('Debe hacer click en una fila para añadir un subtítulo, y se añadirá sobre la misma.');
	      } else {
	        this.computos.splice(this.index_subtitulo, 0, { isSubtitulo: true });
	      }
	    }
	  }, {
	    key: 'setIndexSubtitulo',
	    value: function setIndexSubtitulo(index) {
	      this.index_subtitulo = index;
	    }
	  }, {
	    key: 'moveSubtitulo',
	    value: function moveSubtitulo(direccion, index) {
	      var computo_auxiliar = angular.copy(this.computos[index]);
	      if (direccion == 'up' && index > 0 && !this.computos[index - 1].isSubtitulo) {
	        this.computos.splice(index, 1);
	        this.computos.splice(index - 1, 0, computo_auxiliar);
	        this.computos[index].subtitulo = computo_auxiliar.descripcion;
	      } else if (direccion == 'down' && index + 1 < this.computos.length && !this.computos[index + 1].isSubtitulo) {
	        this.computos.splice(index, 1);
	        this.computos.splice(index + 1, 0, computo_auxiliar);
	        this.computos[index].subtitulo = null;
	        for (var i = index; i >= 0; i--) {
	          if (this.computos[i].isSubtitulo) {
	            this.computos[index].subtitulo = this.computos[i].descripcion;
	            break;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'saveSubtitulo',
	    value: function saveSubtitulo(subtitulo, index) {
	      var index_final = this.computos.length;
	      for (var i = index + 1; i < this.computos.length; i++) {
	        if (this.computos[i].isSubtitulo) {
	          index_final = i;
	          break;
	        } else {
	          this.computos[i].subtitulo = subtitulo.descripcion;
	        }
	      }
	      this.saveIniFinRow(index + 1, index_final);
	    }
	  }, {
	    key: 'saveIniFinRow',
	    value: function saveIniFinRow(inicio, fin, all) {
	      if (!fin) {
	        fin = this.computos.length;
	      }
	      for (var i = inicio; i < fin; i++) {
	        if (!this.computos[i].isSubtitulo && (this.computos[i].id_computo_metrico || all)) {
	          this.saveRow(this.computos[i], i);
	        }
	      }
	    }
	  }, {
	    key: 'deleteSubtitulo',
	    value: function deleteSubtitulo(subtitulo, index) {
	      var descripcion = null;
	      for (var i = index - 1; i >= 0; i--) {
	        if (this.computos[i].isSubtitulo) {
	          descripcion = this.computos[i].descripcion;
	          break;
	        }
	      }
	      this.saveSubtitulo({ descripcion: descripcion }, index);
	      this.computos.splice(index, 1);
	    }
	
	    /**
	     * sacarCopiaComputos - Copiar los computos en la variable auxiliar "this.copiaComputos", el parámetro computo es opcional,
	     * en caso de tener este parámetro se reemplaza o se adiciona a la variable auxiliar. Esto con el fin de determinar
	     * si hay modificaciones o no para guardar los cómputos cuando el usuario presione "Aceptar" o las opciones "Anterior/Siguiente"
	     * si no ha guardado los datos de algunos o todos sus cómputos métricos.
	     *
	     * @param  {type} computo Objeto con datos de un cómputo métrico
	     */
	
	  }, {
	    key: 'sacarCopiaComputos',
	    value: function sacarCopiaComputos(computo) {
	      if (computo) {
	        var INDEX = this._.findIndex(this.copiaComputos, { id_computo_metrico: computo.id_computo_metrico });
	        if (INDEX === -1) {
	          if (this.copiaComputos.length === 1 && this._.isEmpty(this.copiaComputos[0])) {
	            this.copiaComputos[0] = computo;
	          } else {
	            this.copiaComputos.push(computo);
	          }
	        } else {
	          this.copiaComputos[INDEX] = angular.copy(computo);
	        }
	      } else {
	        this.copiaComputos = angular.copy(this.computos);
	      }
	    }
	  }]);
	
	  return ComputosMetricosController;
	}();
	
	exports.default = ComputosMetricosController;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fotos = __webpack_require__(488);
	
	var _fotos2 = _interopRequireDefault(_fotos);
	
	var _fotos3 = __webpack_require__(773);
	
	var _fotos4 = _interopRequireDefault(_fotos3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FotosComputosComponent = {
	  bindings: {
	    item: '<',
	    supervision: '<',
	    fotos: '=',
	    modoVista: '<?',
	    archivado: '<'
	  },
	  controller: _fotos2.default,
	  template: _fotos4.default
	};
	
	exports.default = FotosComputosComponent;

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FotosComputosController = function () {
	  FotosComputosController.$inject = ["DataService", "Modal", "$scope"];
	  function FotosComputosController(DataService, Modal, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, FotosComputosController);
	
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.$scope = $scope;
	  }
	
	  _createClass(FotosComputosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.initConfiguracion();
	      this.$scope.$on('recargarFotos', function () {
	        _this.initConfiguracion();
	      });
	    }
	  }, {
	    key: 'initConfiguracion',
	    value: function initConfiguracion() {
	      var _this2 = this;
	
	      this.fotos = {
	        backups: {},
	        uploadCallback: function uploadCallback(file) {
	          var data = angular.copy(file);
	          data.fid_supervision = _this2.supervision.id_supervision;
	          data.fid_item = _this2.item.id_item;
	          data.tipo = 'TF_EMPRESA';
	          data.path_fotografia = data.name + '_' + data.nombre.replace(/\s/, '_');
	          if (_this2.fotos.backups[file.name]) {
	            data.id_foto_supervision = _this2.fotos.backups[file.name].id_foto_supervision;
	            data.id = data.id_foto_supervision;
	          }
	
	          _this2.DataService.save('fotos', data).then(function (response) {
	            if (response && response.finalizado) {
	              if (response.datos.path_fotografia.indexOf('.pdf') > 0) {
	                var cod = 'CMPDF_' + response.datos.path_fotografia,
	                    id = _this2.supervision ? _this2.supervision.fid_proyecto : 0;
	                _this2.urlViewBase64 = id ? 'proyectos/' + id + '/doc/' + cod : '';
	                _this2.urlDownloadBase64 = id ? 'proyectos/' + id + '/doc/' + cod + '/descargar' : '';
	              }
	            }
	            _this2.fotos[file.name] = {
	              id_foto_supervision: response.datos.id_foto_supervision,
	              base64: data.base64,
	              nombre: data.nombre.replace(/\s/, '_'),
	              show: true,
	              showImage: true
	              //guardamos backup para recuperar el id_foto_supervision
	            };_this2.fotos.backups[file.name] = angular.copy(_this2.fotos[file.name]);
	          });
	        }
	      };
	    }
	
	    // showImage(key) {
	    //   var foto = this.fotos[key];
	    //   if (foto.base64) {
	    //     foto.showImage = !foto.showImage;
	    //   } else {
	    //     this.DataService.get(`fotos/${foto.id_foto_supervision}`).then(response => {
	    //       foto.base64 = response.datos;
	    //       // TODO El backend debe enviar el tipo de archivo recuperado
	    //       this.urlDownloadBase64 = foto.base64.indexOf('base64') > 0 ? foto.base64 : 'data:application/pdf;base64,' + foto.base64;
	    //       foto.showImage = true;
	    //       foto.show = true;
	    //     })
	    //   }
	    // }
	
	  }, {
	    key: 'showImage',
	    value: function showImage(key) {
	      var foto = this.fotos[key];
	      if (foto.base64) {
	        foto.showImage = !foto.showImage;
	      } else {
	        if (foto.nombre.indexOf('.pdf') > 0) {
	          var cod = 'CMPDF_' + foto.codigo + '_plano_' + foto.nombre,
	              id = this.supervision ? this.supervision.fid_proyecto : 0;
	          this.urlViewBase64 = id ? 'proyectos/' + id + '/doc/' + cod : '';
	          this.urlDownloadBase64 = id ? 'proyectos/' + id + '/doc/' + cod + '/descargar' : '';
	          foto.showImage = true;
	          foto.show = true;
	        } else {
	          this.DataService.get('fotos/' + foto.id_foto_supervision).then(function (response) {
	            foto.base64 = response.datos;
	            foto.showImage = true;
	            foto.show = true;
	          });
	        }
	      }
	    }
	  }, {
	    key: 'changeImage',
	    value: function changeImage(key) {
	      var foto = this.fotos[key];
	      if (foto.show) {
	        this.Modal.confirm('¿Está seguro/a de cambiar la imagen?', function () {
	          foto.show = false;
	        }, null, null, 'Sí, estoy seguro/a', 'Cancelar');
	      } else {
	        foto.show = true;
	      }
	    }
	  }, {
	    key: 'vistaPrevia',
	    value: function vistaPrevia() {
	      if (this.fotos['plano'].base64) {
	        this.Modal.showDocumentBase64(this.fotos['plano'].base64, this.label, 'strBase64');
	      }
	    }
	  }, {
	    key: 'vistaImagen',
	    value: function vistaImagen(imgData) {
	      if (imgData.base64) {
	        this.Modal.showImageBase64(imgData, null);
	      }
	    }
	  }]);
	
	  return FotosComputosController;
	}();
	
	exports.default = FotosComputosController;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _resumen = __webpack_require__(490);
	
	var _resumen2 = _interopRequireDefault(_resumen);
	
	var _resumen3 = __webpack_require__(774);
	
	var _resumen4 = _interopRequireDefault(_resumen3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumenComputosComponent = {
	  bindings: {
	    item: '<',
	    resumen: '<'
	  },
	  controller: _resumen2.default,
	  template: _resumen4.default
	};
	
	exports.default = ResumenComputosComponent;

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResumenComputosController = function () {
	  function ResumenComputosController() {
	    'ngInject';
	
	    _classCallCheck(this, ResumenComputosController);
	  }
	
	  _createClass(ResumenComputosController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return ResumenComputosController;
	}();
	
	exports.default = ResumenComputosController;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// import Matriculas from './matriculas/matriculas.module';
	// import DocumentacionProyecto from './documentacion-proyecto/documentacion-proyecto.module';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _avanceProyecto = __webpack_require__(480);
	
	var _avanceProyecto2 = _interopRequireDefault(_avanceProyecto);
	
	var _planillaProyecto = __webpack_require__(508);
	
	var _planillaProyecto2 = _interopRequireDefault(_planillaProyecto);
	
	var _computoProyecto = __webpack_require__(483);
	
	var _computoProyecto2 = _interopRequireDefault(_computoProyecto);
	
	var _supervision = __webpack_require__(511);
	
	var _supervision2 = _interopRequireDefault(_supervision);
	
	var _modificacion = __webpack_require__(495);
	
	var _modificacion2 = _interopRequireDefault(_modificacion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empresas = angular.module('app.rempresas', [
	// Matriculas,
	// DocumentacionProyecto,
	_avanceProyecto2.default, _planillaProyecto2.default, _computoProyecto2.default,
	// CEmpresas,
	_modificacion2.default]).service('Supervision', _supervision2.default).name;
	// import CEmpresas from './c-empresas/c-empresas.module';
	exports.default = Empresas;

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FechaModificacionController = function () {
	  FechaModificacionController.$inject = ["$uibModalInstance", "Storage", "data", "Usuarios"];
	  function FechaModificacionController($uibModalInstance, Storage, data, Usuarios) {
	    'ngInject';
	
	    _classCallCheck(this, FechaModificacionController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.proyecto = data;
	    this.Usuarios = Usuarios;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(FechaModificacionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var esSupervisor = this.Usuarios.esSupervisor() || this.Usuarios.esFiscal();
	      this.option = {
	        confirm_txt: esSupervisor ? '¿Está seguro/a de finalizar y enviar las modificaciones?' : '¿Está seguro/a de aprobar las modificaciones?',
	        action: esSupervisor ? 'Registrar' : 'Revisar',
	        disabled: !esSupervisor
	      };
	      this.validacion = {
	        fecha_minima: new Date(this.proyecto.adjudicacion.orden_proceder)
	      };
	      this.validacion.fecha_minima.setDate(this.validacion.fecha_minima.getDate() + 1);
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'aceptar',
	    value: function aceptar() {
	      this.$uibModalInstance.close(this.proyecto);
	    }
	  }]);
	
	  return FechaModificacionController;
	}();
	
	exports.default = FechaModificacionController;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modificacion = __webpack_require__(494);
	
	var _modificacion2 = _interopRequireDefault(_modificacion);
	
	var _modificacion3 = __webpack_require__(776);
	
	var _modificacion4 = _interopRequireDefault(_modificacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModificacionComponent = {
	  bindings: {},
	  controller: _modificacion2.default,
	  template: _modificacion4.default
	};
	
	exports.default = ModificacionComponent;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fechamodificacion = __webpack_require__(775);
	
	var _fechamodificacion2 = _interopRequireDefault(_fechamodificacion);
	
	var _fechamodificacionController = __webpack_require__(492);
	
	var _fechamodificacionController2 = _interopRequireDefault(_fechamodificacionController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModificacionController = function () {
	  ModificacionController.$inject = ["$scope", "$state", "$stateParams", "$q", "$window", "DataService", "Modal", "Storage", "Util", "Message", "Modificacion", "decimales", "Usuarios"];
	  function ModificacionController($scope, $state, $stateParams, $q, $window, DataService, Modal, Storage, Util, Message, Modificacion, decimales, Usuarios) {
	    'ngInject';
	
	    _classCallCheck(this, ModificacionController);
	
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$q = $q;
	    this.$window = $window;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.Util = Util;
	    this.Message = Message;
	    this.Modificacion = Modificacion;
	    this.decimales = decimales;
	    this.Usuarios = Usuarios;
	
	    this.usuario = this.Storage.getUser();
	    if (['SUPERVISOR_FDI', 'TECNICO_FDI', 'FISCAL_FDI', 'JEFE_REVISION_FDI', 'RESP_GAM_GAIOC', 'VISOR_REPORTES', 'TECNICO_CIERRE'].indexOf(this.usuario.rol.nombre) < 0) {
	      Message.warning('No tiene permisos suficientes para ver la modificación');
	      this.$window.history.back();
	    }
	    this.filtroItems = 'TODOS';
	
	    this.tipoModificacion = $stateParams.tipoModificacion;
	    this.adjudicacion = $stateParams.adjudicacion;
	    this.tabIndex = 1;
	    this.configRestarDias = 0;
	  }
	
	  _createClass(ModificacionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (this.$stateParams.crear) {
	        this.$stateParams.crear = false;
	        this.crearModificacion();
	      } else {
	        this.obtenerModificacion();
	        this.obtenerConfigCalcFechas();
	      }
	
	      // TODO verificar la URL con el backend
	      this.url = 'proyectos/' + this.$stateParams.proyecto + '/adjudicaciones/' + this.$stateParams.adjudicacion + '/procesar?rol=' + this.Storage.get('rol').id_rol;
	
	      this.mensajeConfirmacion = {
	        "Finalizar": '\xBFEst\xE1 seguro de finalizar y enviar las modificaciones?<br>\n                    Se le informa que estas modificaciones, una vez aprobadas ser\xE1n incorporadas a la planilla de avance.',
	        "Cancelar": '\xBFEst\xE1 seguro/a de cancelar la modificaci\xF3n?<br>La cancelaci\xF3n revertir\xE1 los cambios realizados en la presente modificaci\xF3n.',
	        "Guardar": 'Se guardar\xE1n los cambios realizados.'
	      };
	
	      this.modificandoPlazo = this.modificandoItems = this.modoVista = !this.$stateParams.edicion;
	
	      this.$scope.$on('transicion_accion_ejecutada', function () {
	        _this.$state.go('proyectos-pendientes');
	      });
	
	      /* DOCUMENTO */
	      this.uploadCallback = function (file) {
	        var data = {
	          "doc_respaldo_modificacion": angular.copy(file)
	        };
	        _this.DataService.put('proyectos/' + _this.$stateParams.proyecto + '/adjudicaciones/' + _this.$stateParams.adjudicacion + '/guardar', data).then(function (response) {
	          if (response && response.finalizado) {
	            _this.informe_tecnico_registrado = true;
	            //this.asignarDatos(file, response.datos.documento);
	          }
	        });
	      };
	      this.uploadRespaldo = function (file) {
	        if (!file.name) {
	          _this.Message.warning('Debe escribir el t\xEDtulo del documento.');
	          return;
	        }
	        var datos = _this.proyecto.adjudicacion.documentos.find(function (d) {
	          return d.datos.name == file.name;
	        });
	        if (datos) datos = datos.datos;
	        var data = { documento_tecnico: angular.copy(file) };
	        data.documento_tecnico.datos = datos;
	        _this.DataService.put('proyectos/' + _this.$stateParams.proyecto + '/adjudicaciones/' + _this.$stateParams.adjudicacion + '/guardar', data).then(function (response) {
	          if (response && response.finalizado) {
	            var temp = response.datos.documentos.find(function (d) {
	              return d.name == datos.name;
	            });
	            if (temp) {
	              datos.archivo = temp.archivo;
	              datos.codigo = temp.codigo;
	            }
	          }
	        });
	      };
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.filtroItems', function () {
	        if (!_this2.proyecto) {
	          return;
	        }
	        _this2.mostrarItems();
	      });
	    }
	  }, {
	    key: 'cancelar',
	    value: function cancelar() {
	      this.Modal.confirm('\xBFEst\xE1 seguro/a de cancelar la modificaci\xF3n?<br>Se revertir\xE1n los cambios realizados en la presente modificaci\xF3n.', function () {}, null, 'Cancelación de modificación', 'Sí, estoy seguro/a');
	    }
	  }, {
	    key: 'finalizar',
	    value: function finalizar() {
	      this.Modal.confirm('\xBFEst\xE1 seguro de finalizar y enviar las modificaciones?<br>\n      Se le informa que estas modificaciones de fecha __/__/__ una vez aprobadas ser\xE1n incorporadas a la planilla de avance.', function () {}, null, 'Finalizar Modificación', 'Sí, estoy seguro/a');
	    }
	  }, {
	    key: 'crearModificacion',
	    value: function crearModificacion() {
	      var _this3 = this;
	
	      var tipo = 'TM';
	      switch (this.tipoModificacion) {
	        case 1:
	          tipo = 'TM_ORDEN_TRABAJO';
	          break;
	        case 2:
	          tipo = 'TM_ORDEN_CAMBIO';
	          break;
	        case 3:
	          tipo = 'TM_CONTRATO_MODIFICATORIO';
	          break;
	        default:
	          tipo = 'TM';
	          break;
	      }
	      // let tipo = this.tipoModificacion === 3 ? 'TM_CONTRATO_MODIFICATORIO' : this.tipoModificacion === 2 ? 'TM_ORDEN_CAMBIO' : this.tipoModificacion === 1 ? 'TM_ORDEN_TRABAJO' : 'TM';
	      this.DataService.put('proyectos/' + this.$stateParams.proyecto + '/modificaciones/' + this.adjudicacion + '?tipo=' + tipo).then(function (result) {
	        if (result && result.finalizado) {
	          //this.proyecto = result.datos;
	          //this.agregarCamposModificar(result.datos);
	          _this3.$state.go('modificacion', {
	            proyecto: _this3.$stateParams.proyecto,
	            adjudicacion: _this3.adjudicacion,
	            version: result.datos.adjudicacion.version,
	            tipoModificacion: tipo,
	            edicion: true,
	            crear: false
	          });
	        } else {
	          //this.$state.go('mis-proyectos',null);
	          _this3.$window.history.back();
	        }
	      });
	    }
	  }, {
	    key: 'obtenerModificacion',
	    value: function obtenerModificacion() {
	      var _this4 = this;
	
	      var storedRol = this.Storage.get('rol');
	      var query = {};
	      if ((typeof storedRol === 'undefined' ? 'undefined' : _typeof(storedRol)) === Array && storedRol.length > 0) {
	        query = {
	          rol: storedRol[0].id_rol // Se envia el id del primer rol en el array (Si existe mas de uno)
	        };
	      } else if (storedRol.hasOwnProperty('id_rol')) {
	        query = {
	          rol: storedRol.id_rol
	        };
	      }
	
	      if (this.$stateParams.version) {
	        query.version = this.$stateParams.version;
	      }
	      var url = 'proyectos/' + this.$stateParams.proyecto + '/modificaciones/' + this.$stateParams.adjudicacion + '?' + this.Util.serialize(query);
	      this.DataService.get(url).then(function (result) {
	        if (result && result.finalizado) {
	
	          switch (result.datos.adjudicacion.tipo_modificacion) {
	            case 'TM_ORDEN_TRABAJO':
	              _this4.tipoModificacion = 1;
	              break;
	            case 'TM_ORDEN_CAMBIO':
	              _this4.tipoModificacion = 2;
	              break;
	            case 'TM_CONTRATO_MODIFICATORIO':
	              _this4.tipoModificacion = 3;
	              break;
	            default:
	              _this4.tipoModificacion = 0;
	              break;
	          }
	
	          if (!result.datos.modificaciones || !result.datos.modificaciones.nombre) {
	            if (_this4.tipoModificacion != 0) _this4.$state.go('proyectos-pendientes', null);
	          }
	          //this.proyecto = result.datos;
	          _this4.agregarCamposModificar(result.datos);
	          _this4.proyecto.idProyecto = _this4.$stateParams.proyecto;
	
	          if (_this4.proyecto.adjudicacion.doc_respaldo_modificacion) {
	            var a = _this4.proyecto.adjudicacion.doc_respaldo_modificacion.indexOf('[') + 1;
	            var b = _this4.proyecto.adjudicacion.doc_respaldo_modificacion.indexOf(']');
	            var codigo = _this4.proyecto.adjudicacion.doc_respaldo_modificacion.substring(a, b);
	            _this4.DataService.get('proyectos/' + _this4.proyecto.idProyecto + '/doc/' + codigo).then(function (doc) {
	              if (doc && doc.finalizado) {
	                _this4.informe_tecnico = doc.datos;
	                _this4.informe_tecnico_registrado = true;
	              }
	            });
	          }
	          // Documentos adjuntos
	          if (_this4.proyecto.adjudicacion.documentos) {
	            var documentos = [];
	            for (var i in _this4.proyecto.adjudicacion.documentos) {
	              documentos.push({ datos: _this4.proyecto.adjudicacion.documentos[i] });
	            }
	            _this4.proyecto.adjudicacion.documentos = documentos;
	          }
	          if (!_this4.$stateParams.edicion && _this4.proyecto.adjudicacion.estado_actual) {
	            _this4.$stateParams.edicion = _this4.proyecto.adjudicacion.estado_actual.codigo === 'MODIFICADO_FDI' && _this4.Usuarios.esSupervisor();
	            _this4.modoVista = !_this4.$stateParams.edicion;
	          }
	        } else {
	          _this4.$state.go('proyectos-pendientes', null);
	        }
	      });
	    }
	  }, {
	    key: 'agregarCamposModificar',
	    value: function agregarCamposModificar(proyecto) {
	      if (proyecto) {
	        // Historial
	        proyecto.modificaciones.total_variacion = 0; // Monto total de variacion sumando todas los tipos de modificaciones
	        proyecto.modificaciones.total_variacion_ot = 0; // Monto total de variacion sumando las modificaciones ORDEN_TRABAJO
	        proyecto.modificaciones.total_variacion_oc = 0; // Monto total de variacion sumando las modificaciones ORDEN_CAMBIO
	        proyecto.modificaciones.total_variacion_cm = 0; // Monto total de variacion sumando las modificaciones CONTRATO_MODIFICATORIO
	        proyecto.modificaciones.total_variacion_porcentaje = 0;
	        proyecto.modificaciones.total_variacion_porcentaje_ot = 0;
	        proyecto.modificaciones.total_variacion_porcentaje_oc = 0;
	        proyecto.modificaciones.total_variacion_porcentaje_cm = 0;
	        proyecto.plazo_ampliacion_total = 0;
	        for (var i in proyecto.modificaciones.historial) {
	          var version = proyecto.modificaciones.historial[i];
	          proyecto.modificaciones.total_variacion = this.Util.sumar([version.variacion, proyecto.modificaciones.total_variacion]);
	          if (version.tipo_modificacion === 'TM_ORDEN_TRABAJO') {
	            proyecto.modificaciones.total_variacion_ot = this.Util.sumar([version.variacion, proyecto.modificaciones.total_variacion_ot]);
	            // version.variacion_porcentaje_ot = this.Util.dividir( this.Util.multiplicar([version.variacion, 100]), proyecto.version_inicial.monto);
	            // proyecto.modificaciones.total_variacion_porcentaje_ot = this.Util.sumar([proyecto.modificaciones.total_variacion_porcentaje_ot, version.variacion_porcentaje_ot]);
	          }
	          if (version.tipo_modificacion === 'TM_ORDEN_CAMBIO') {
	            proyecto.modificaciones.total_variacion_oc = this.Util.sumar([version.variacion, proyecto.modificaciones.total_variacion_oc]);
	            version.variacion_porcentaje_oc = this.Util.dividir(this.Util.multiplicar([version.variacion, 100]), proyecto.version_inicial.monto);
	            proyecto.modificaciones.total_variacion_porcentaje_oc = this.Util.sumar([proyecto.modificaciones.total_variacion_porcentaje_oc, version.variacion_porcentaje_oc]);
	          }
	          if (version.tipo_modificacion === 'TM_CONTRATO_MODIFICATORIO') {
	            proyecto.modificaciones.total_variacion_cm = this.Util.sumar([version.variacion, proyecto.modificaciones.total_variacion_cm]);
	            version.variacion_porcentaje_cm = this.Util.dividir(this.Util.multiplicar([version.variacion, 100]), proyecto.version_inicial.monto);
	            proyecto.modificaciones.total_variacion_porcentaje_cm = this.Util.sumar([proyecto.modificaciones.total_variacion_porcentaje_cm, version.variacion_porcentaje_cm]);
	          }
	          version.plazo_ampliacion_total = proyecto.plazo_ampliacion_total += version.plazo_ampliacion ? version.plazo_ampliacion.por_volumenes + version.plazo_ampliacion.por_compensacion : 0;
	          version.nueva_fecha_provisional = new Date(proyecto.orden_proceder);
	          version.nueva_fecha_provisional.setDate(version.nueva_fecha_provisional.getDate() + version.plazo_ampliacion_total + proyecto.plazo_ejecucion - this.configRestarDias);
	        }
	        proyecto.modificaciones.total_variacion_h = 0;
	        if (proyecto.tipo_modificacion === 'TM_ORDEN_TRABAJO') {
	          proyecto.modificaciones.total_variacion_h = proyecto.modificaciones.total_variacion_ot;
	        }
	        if (proyecto.tipo_modificacion === 'TM_ORDEN_CAMBIO') {
	          proyecto.modificaciones.total_variacion_h = proyecto.modificaciones.total_variacion_oc;
	        }
	        if (proyecto.tipo_modificacion === 'TM_CONTRATO_MODIFICATORIO') {
	          proyecto.modificaciones.total_variacion_h = proyecto.modificaciones.total_variacion_cm;
	        }
	        // Modulos
	        this.nuevosmodulos = [];
	        this.cabecera = angular.copy(proyecto.modulos[0].items[0]);
	        if (!proyecto.version_anterior || !proyecto.version_anterior.tipo_modificacion_adjudicacion) {
	          this.cabecera.version_anterior = null;
	        }
	        // TODO verificar backend
	        if (proyecto.adjudicacion.version == 2 && !this.cabecera.version_inicial) {
	          this.cabecera.version_anterior = {};
	        }
	        if (proyecto.adjudicacion.version == 1) {
	          proyecto.modificaciones.nombre = "Contrato Original";
	        }
	        var modulos = [];
	        for (var _i in proyecto.modulos) {
	          if (proyecto.modulos[_i].nombre.indexOf(proyecto.modificaciones.nombre) >= 0) {
	            this.nuevosmodulos.push(proyecto.modulos[_i]);
	            this.modificandoItems = true;
	          } else {
	            var modulo = proyecto.modulos[_i];
	            modulo.isCollapsed = true && !this.modoVista;
	            for (var j in modulo.items) {
	              if (modulo.items[j].version_anterior && modulo.items[j].cantidad != modulo.items[j].version_anterior.cantidad) {
	                this.modificandoItems = true;
	                modulo.isCollapsed = false;
	              }
	              // Verificar avance
	              if (!modulo.items[j].avance_actual) {
	                modulo.items[j].avance_actual = 0;
	              }
	              if (modulo.items[j].estado === 'CERRADO') {
	                modulo.items[j].avance_actual = modulo.items[j].cantidad;
	              }
	              // Verificar cabeceras
	              if (!modulo.items[j].version_inicial && this.cabecera.version_inicial) {
	                modulo.items[j].version_inicial = {};
	              }
	              modulo.items[j].show = true;
	              // Para verificar si se modifico el valor
	              modulo.items[j].cantidad_ant = modulo.items[j].cantidad;
	            }
	            modulos.push(modulo);
	          }
	        }
	        proyecto.modulos = modulos;
	        this.proyecto = proyecto;
	        this.modificandoPlazo = this.proyecto.plazo_ampliacion && (this.proyecto.plazo_ampliacion.por_volumenes || this.proyecto.plazo_ampliacion.por_compensacion);
	        this.recalcularMontos();
	        this.recalcularFechas();
	        // Valores para verificar se se han cambiado los datos.
	        this.proyecto.plazo_ampliacion_ant = {};
	      }
	    }
	
	    // TODO obtener valores desde el backend
	
	  }, {
	    key: 'calcularFechaAmpliada',
	    value: function calcularFechaAmpliada(fecha) {
	      if (fecha && this.proyecto && this.proyecto.plazo_ampliacion) {
	        fecha = new Date(fecha);
	        fecha.setDate(fecha.getDate() + this.proyecto.plazo_ampliacion.por_volumenes + this.proyecto.plazo_ampliacion.por_compensacion);
	      }
	      return fecha;
	    }
	
	    /* MODIFICAR ITEMS */
	
	  }, {
	    key: 'modificarCantidadItem',
	    value: function modificarCantidadItem(item) {
	      var _this5 = this;
	
	      if (item && item.cantidad_ant != item.cantidad) {
	        this.DataService.put('items/' + item.id_item, { cantidad: item.cantidad }).then(function (result) {
	          if (result && result.finalizado) {
	            _this5.Message.success(result.mensaje);
	            item.error = false;
	          } else {
	            item.error = true;
	          }
	          item.cantidad_ant = item.cantidad;
	        });
	        this.recalcularMontos();
	      }
	    }
	  }, {
	    key: 'modificarPesoItem',
	    value: function modificarPesoItem(item) {
	      var _this6 = this;
	
	      if (item && item.id_item > 0) {
	        this.DataService.put('items/' + item.id_item, { peso_ponderado: item.peso_ponderado }).then(function (result) {
	          if (result && result.finalizado) {
	            _this6.Message.success(result.mensaje);
	          } else {
	            _this6.Message.warning('Sucedió un error al tratar de actualizar el item, intente de nuevo por favor');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'recalcularMontos',
	    value: function recalcularMontos(item) {
	      // TODO para optimizar solo sumar o restar el item modificado. (probar con item eliminado)
	      item;
	      // Recalcular monto total
	      this.cantItems = 0;
	      this.proyecto.monto_total_variacion_modificado = 0;
	      for (var i in this.proyecto.modulos) {
	        for (var j in this.proyecto.modulos[i].items) {
	          this.cantItems++;
	          var itemLooped = this.proyecto.modulos[i].items[j];
	          // if(itemLooped.version_anterior && itemLooped.version_anterior.cantidad != itemLooped.cantidad) {
	          //   this.proyecto.monto_total_variacion_modificado += this.Util.redondear(itemLooped.precio_unitario * (itemLooped.cantidad - itemLooped.version_anterior.cantidad));
	          // }
	          this.proyecto.monto_total_variacion_modificado = this.Util.sumar([this.proyecto.monto_total_variacion_modificado, this.Util.multiplicar([itemLooped.precio_unitario, itemLooped.cantidad], true, 2)]);
	        }
	      }
	      for (var _i2 in this.nuevosmodulos) {
	        for (var _j in this.nuevosmodulos[_i2].items) {
	          var _itemLooped = this.nuevosmodulos[_i2].items[_j];
	          _itemLooped.nro_item = ++this.cantItems;
	          if (_itemLooped.precio_unitario && _itemLooped.cantidad) {
	            //this.proyecto.monto_total_variacion_modificado += this.Util.redondear(itemLooped.precio_unitario * itemLooped.cantidad);
	            this.proyecto.monto_total_variacion_modificado = this.Util.sumar([this.proyecto.monto_total_variacion_modificado, this.Util.multiplicar([_itemLooped.precio_unitario, _itemLooped.cantidad], true, 2)]);
	          }
	        }
	      }
	      this.proyecto.monto_total_variacion_modificado = this.Util.restar(this.proyecto.monto_total_variacion_modificado, this.proyecto.version_anterior.monto);
	      //this.proyecto.porcentaje_variacion = (this.proyecto.monto_total_variacion_modificado * 100) / this.proyecto.version_inicial.monto;
	      // this.proyecto.porcentaje_variacion = this.Util.multiplicar([this.proyecto.monto_total_variacion_modificado, this.Util.dividir(100, this.proyecto.version_inicial.monto)]);
	      this.proyecto.porcentaje_variacion = this.Util.dividir(this.Util.multiplicar([this.proyecto.monto_total_variacion_modificado, 100]), this.proyecto.version_inicial.monto);
	      this.porcentajeLimite = this.tipoModificacion === 3 ? 0.1 : this.tipoModificacion === 2 ? 0.05 : 0;
	      // TODO tambien debe sumarse con las anteriores modificaciones.
	      //let monto_variacion = this.Util.redondear(this.proyecto.monto_total_variacion_modificado + this.proyecto.modificaciones.total_variacion);
	      var monto_variacion = this.Util.sumar([this.proyecto.monto_total_variacion_modificado, this.proyecto.modificaciones.total_variacion_h]);
	      //let monto_limite = this.Util.redondear(this.proyecto.version_inicial.monto * this.porcentajeLimite);
	      var monto_limite = this.Util.multiplicar([this.proyecto.version_inicial.monto, this.porcentajeLimite]);
	      this.porcentajeExcedido = monto_variacion > monto_limite || this.Util.restar(0, monto_variacion) > monto_limite;
	    }
	  }, {
	    key: 'adicionarModulo',
	    value: function adicionarModulo() {
	      var _this7 = this;
	
	      if (!this.nuevosmodulos || !this.nuevosmodulos[0]) {
	        var datos = {
	          fid_proyecto: this.$stateParams.proyecto,
	          fid_adjudicacion: this.$stateParams.adjudicacion,
	          nombre: 'ITEMS NUEVOS (' + this.proyecto.modificaciones.nombre + ')'
	        };
	        this.DataService.post('modulos', datos).then(function (result) {
	          if (result && result.finalizado) {
	            if (!_this7.nuevosmodulos) {
	              _this7.nuevosmodulos = [];
	            }
	            _this7.Message.success(result.mensaje);
	            if (!result.datos.items) {
	              result.datos.items = [];
	            }
	            if (result.datos.items.length <= 0) {
	              result.datos.items.push({ edicion: true });
	            }
	            _this7.nuevosmodulos.push(result.datos);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'modificarItems',
	    value: function modificarItems() {
	      this.modificandoItems = !this.modificandoItems;
	    }
	
	    /* MODIFICACION DEL PLAZO */
	
	  }, {
	    key: 'modificarPlazoAmpliacion',
	    value: function modificarPlazoAmpliacion(plazo_ampliacion) {
	      var _this8 = this;
	
	      if (plazo_ampliacion) {
	        plazo_ampliacion.por_compensacion = plazo_ampliacion.por_compensacion || 0;
	        plazo_ampliacion.por_volumenes = plazo_ampliacion.por_volumenes || 0;
	        var datos = {
	          plazo_ampliacion: {
	            por_compensacion: parseInt(plazo_ampliacion.por_compensacion || 0),
	            por_volumenes: parseInt(plazo_ampliacion.por_volumenes || 0)
	          }
	        };
	        if (this.proyecto.plazo_ampliacion_ant.por_volumenes != plazo_ampliacion.por_volumenes || this.proyecto.plazo_ampliacion_ant.por_compensacion != plazo_ampliacion.por_compensacion) {
	          delete this.proyecto.nueva_fecha_provisional;
	          delete this.proyecto.nueva_fecha_definitiva;
	          this.DataService.put('proyectos/' + this.$stateParams.proyecto, datos).then(function (result) {
	            if (result && result.finalizado) {
	              _this8.Message.success(result.mensaje);
	              _this8.proyecto.plazo_ampliacion_ant = angular.copy(plazo_ampliacion);
	              _this8.recalcularFechas();
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'recalcularFechas',
	    value: function recalcularFechas() {
	      var plazo_ampliacion = this.proyecto.plazo_ampliacion;
	      var nro_dias = this.proyecto.plazo_recepcion_definitiva || 90;
	      if (plazo_ampliacion && (parseInt(plazo_ampliacion.por_compensacion) || parseInt(plazo_ampliacion.por_volumenes))) {
	        this.proyecto.nueva_fecha_provisional = new Date(this.proyecto.orden_proceder);
	        // this.proyecto.nueva_fecha_provisional.setDate(this.proyecto.nueva_fecha_provisional.getDate() + parseInt(plazo_ampliacion.por_volumenes) + parseInt(plazo_ampliacion.por_compensacion) + this.proyecto.plazo_ejecucion - this.configRestarDias);
	        this.proyecto.fecha_recepcion_provisional = this.proyecto.nueva_fecha_provisional.setDate(this.proyecto.nueva_fecha_provisional.getDate() + parseInt(plazo_ampliacion.por_volumenes) + parseInt(plazo_ampliacion.por_compensacion) + this.proyecto.plazo_ejecucion + this.proyecto.plazo_ampliacion_total - this.configRestarDias);
	        this.proyecto.nueva_fecha_definitiva = new Date(this.proyecto.nueva_fecha_provisional);
	        // this.proyecto.nueva_fecha_definitiva.setDate(this.proyecto.nueva_fecha_provisional.getDate() + nro_dias);
	        this.proyecto.fecha_recepcion_definitiva = this.proyecto.nueva_fecha_definitiva.setDate(this.proyecto.nueva_fecha_provisional.getDate() + nro_dias);
	      } else {
	        delete this.proyecto.nueva_fecha_provisional;
	        delete this.proyecto.nueva_fecha_definitiva;
	        this.proyecto.fecha_recepcion_provisional = new Date(this.proyecto.orden_proceder);
	        this.proyecto.fecha_recepcion_provisional.setDate(this.proyecto.fecha_recepcion_provisional.getDate() + this.proyecto.plazo_ejecucion + this.proyecto.plazo_ampliacion_total - this.configRestarDias);
	        this.proyecto.fecha_recepcion_definitiva = new Date(this.proyecto.fecha_recepcion_provisional);
	        this.proyecto.fecha_recepcion_definitiva.setDate(this.proyecto.fecha_recepcion_definitiva.getDate() + nro_dias);
	      }
	    }
	  }, {
	    key: 'fechaSumDias',
	    value: function fechaSumDias(fecha, dias) {
	      var fechaNueva = new Date(fecha);
	      if (!isNaN(fechaNueva.getTime()) && !isNaN(parseInt(dias))) {
	        fechaNueva.setDate(fechaNueva.getDate() + parseInt(dias));
	        return fechaNueva;
	      }
	      return fecha;
	    }
	  }, {
	    key: 'modificarPlazo',
	    value: function modificarPlazo() {
	      this.modificandoPlazo = !this.modificandoPlazo;
	    }
	
	    /* INFOMRE TECNICO */
	
	  }, {
	    key: 'verInformeTecnico',
	    value: function verInformeTecnico() {
	      this.Modal.showDocumentBase64(this.informe_tecnico.base64, 'Informe', 'strBase64');
	    }
	  }, {
	    key: 'quitarInformeTecnico',
	    value: function quitarInformeTecnico() {
	      this.informe_tecnico_registrado = false;
	      delete this.informe_tecnico;
	    }
	    /* RESPALDO TECNICO */
	
	  }, {
	    key: 'modoEdicionDoc',
	    value: function modoEdicionDoc(documento) {
	      return documento.datos.estado.nombre === this.proyecto.adjudicacion.estado_actual.codigo && documento.datos.rol.nombre === this.Usuarios.usuario.rol.nombre;
	    }
	  }, {
	    key: 'verRespaldoTecnico',
	    value: function verRespaldoTecnico(documento) {
	      var _this9 = this;
	
	      this.DataService.get('proyectos/' + this.proyecto.idProyecto + '/doc/' + documento.datos.codigo + '?name=' + documento.datos.name).then(function (doc) {
	        if (doc && doc.finalizado) {
	          documento.file = doc.datos;
	          _this9.Modal.showDocumentBase64(documento.file.base64, 'Informe', 'strBase64');
	        }
	      });
	    }
	  }, {
	    key: 'cambiarRespaldoTecnico',
	    value: function cambiarRespaldoTecnico(documento) {
	      delete documento.datos.archivo;
	    }
	  }, {
	    key: 'agregarRespaldoTecnico',
	    value: function agregarRespaldoTecnico() {
	      if (!this.proyecto.adjudicacion.documentos) this.proyecto.adjudicacion.documentos = [];
	      this.proyecto.adjudicacion.documentos.push({
	        datos: {
	          rol: {
	            nombre: this.Usuarios.usuario.rol.nombre,
	            descripcion: this.Usuarios.usuario.rol.descripcion
	          },
	          estado: {
	            nombre: this.proyecto.adjudicacion.estado_actual.codigo,
	            descripcion: this.proyecto.adjudicacion.estado_actual.nombre
	          }
	        }
	      });
	    }
	  }, {
	    key: 'eliminarRespaldoTecnico',
	    value: function eliminarRespaldoTecnico(documento) {
	      var _this10 = this;
	
	      var eliminado = false;
	      var i = 0;
	      this.Modal.confirm('\xBFEst\xE1 seguro de eliminar por completo el documento?', function () {
	        while (!eliminado && _this10.proyecto.adjudicacion.documentos[i]) {
	          if (_this10.proyecto.adjudicacion.documentos[i].datos.name == documento.datos.name) {
	            _this10.DataService.put('proyectos/' + _this10.$stateParams.proyecto + '/adjudicaciones/' + _this10.$stateParams.adjudicacion + '/respaldo', documento).then(function (doc) {
	              if (doc && doc.finalizado) {
	                _this10.proyecto.adjudicacion.documentos.splice(i, 1);
	              }
	            });
	            eliminado = true;
	            break;
	          }
	          i++;
	        }
	      }, null, 'Eliminar documento', 'Sí, estoy seguro/a');
	    }
	
	    /* FUNCIONES UTILES */
	
	  }, {
	    key: 'mostrarItems',
	    value: function mostrarItems() {
	      switch (this.filtroItems) {
	        case 'COMPLETADOS':
	          this.filtrarItems(function (item) {
	            return item.avance_actual === item.cantidad;
	          });
	          break;
	        case 'INCOMPLETOS':
	          this.filtrarItems(function (item) {
	            return item.avance_actual !== item.cantidad;
	          });
	          break;
	        default:
	          this.filtrarItems();
	      }
	    }
	  }, {
	    key: 'getMgColor',
	    value: function getMgColor(item) {
	      if (item.avance_actual === item.cantidad || item.estado === 'CERRADO') {
	        return 'bl-success';
	      }
	      if (item.avance_actual === 0) {
	        return 'bl-primary';
	      }
	      if (item.avance_actual > 0) {
	        return 'bl-info';
	      }
	      return 'bl-warning';
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle(item) {
	      if (item.avance_actual === item.cantidad || item.estado === 'CERRADO') {
	        return 'Completado';
	      }
	      if (item.avance_actual === 0) {
	        return 'Sin avance';
	      }
	      if (item.avance_actual > 0) {
	        return 'Con avance';
	      }
	      return 'Con avance';
	    }
	  }, {
	    key: 'filtrarItems',
	    value: function filtrarItems() {
	      var condicion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	        return true;
	      };
	
	      this.proyecto.modulos.forEach(function (modulo) {
	        modulo.items.forEach(function (item) {
	          item.show = condicion(item);
	        });
	        //modulo.show = this._.some(modulo.items, { show: true });
	      });
	    }
	  }, {
	    key: 'irAtras',
	    value: function irAtras() {
	      window.history.back();
	    }
	  }, {
	    key: 'verificarInformeTecnico',
	    value: function verificarInformeTecnico() {
	      if (!this.informe_tecnico_registrado) {
	        this.Message.warning('Debe cargar el documento con la aprobaci\xF3n de la modificaci\xF3n.');
	      }
	      return this.informe_tecnico_registrado;
	    }
	  }, {
	    key: 'verificarNuevosItems',
	    value: function verificarNuevosItems() {
	      // Verificar documentos adjuntos
	      // TODO debe ser configurable
	      // if (this.nuevosmodulos && this.nuevosmodulos[0]) {
	      //   for (let i in this.nuevosmodulos[0].items) {
	      //     let item = this.nuevosmodulos[0].items[i];
	      //     if (item.id_item && !item.especificaciones) {
	      //       this.Message.warning(`Debe cargar el documento de especificaciones técnicas del item<br>Nro. ${item.nro_item} - <strong>${item.nombre}</strong>`);
	      //       return false;
	      //     }
	      //     if (!this.nuevosmodulos[0].items[i].analisis_precios) {
	      //       this.Message.warning(`Debe cargar el documento de análisis de precios unitarios del item<br>Nro. ${item.nro_item} - <strong>${item.nombre}</strong>`);
	      //       return false;
	      //     }
	      //   }
	      // }
	      return true;
	    }
	
	    /* TRANSICION */
	
	  }, {
	    key: 'verificarModificacion',
	    value: function verificarModificacion(accion) {
	      var _this11 = this;
	
	      var defer = this.$q.defer();
	      // TODO Se debe verificar segun tipo modificacion
	      // ---
	      // Registrar la fecha de modificacion
	      if (accion.label === 'Cancelar') {
	        this.proyecto.fecha_modificacion = new Date();
	        defer.resolve({ confirmar: true });
	      } else {
	        // verificar campos requeridos
	        if (!this.verificarInformeTecnico()) {
	          defer.reject();
	          return defer.promise;
	        }
	        if (!this.verificarNuevosItems()) {
	          defer.reject();
	          return defer.promise;
	        }
	        // Modal para registrar fecha
	        var modalFechaModificacion = this.Modal.show({
	          template: _fechamodificacion2.default,
	          controller: _fechamodificacionController2.default,
	          data: this.proyecto,
	          size: 'md'
	        });
	        modalFechaModificacion.result.then(function (proyecto) {
	          _this11.proyecto = proyecto;
	          defer.resolve();
	        }, function () {});
	      }
	      //defer.resolve({confirmar: true});
	      return defer.promise;
	    }
	  }, {
	    key: 'obtenerConfigCalcFechas',
	    value: function obtenerConfigCalcFechas() {
	      var _this12 = this;
	
	      this.DataService.get('parametricas/CONFIG').then(function (result) {
	        if (result && result.finalizado && result.datos && result.datos.rows) {
	          result.datos.rows.forEach(function (element) {
	            if (element.codigo === 'CFG_CALC_FECHA') {
	              _this12.configRestarDias = parseInt(element.descripcion) || 0;
	            }
	          });
	        }
	      });
	    }
	  }]);
	
	  return ModificacionController;
	}();
	
	exports.default = ModificacionController;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modificacion = __webpack_require__(493);
	
	var _modificacion2 = _interopRequireDefault(_modificacion);
	
	var _modulo = __webpack_require__(497);
	
	var _modulo2 = _interopRequireDefault(_modulo);
	
	var _modificacion3 = __webpack_require__(496);
	
	var _modificacion4 = _interopRequireDefault(_modificacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modificacion = angular.module('app.modificacion', []).component('modificacion', _modificacion2.default).component('modulo', _modulo2.default).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('modificacion', {
	    url: '/modificacion/{proyecto:int}/{adjudicacion:int}/version/{version:int}',
	    component: 'modificacion',
	    params: {
	      adjudicacion: 0,
	      tipoModificacion: 0,
	      version: 0,
	      edicion: false,
	      crear: false
	    }
	  });
	}]).service('Modificacion', _modificacion4.default).name;
	
	exports.default = Modificacion;

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModificacionService = function () {
	  ModificacionService.$inject = ["Util", "_"];
	  function ModificacionService(Util, _) {
	    'ngInject';
	
	    _classCallCheck(this, ModificacionService);
	
	    this.Util = Util;
	    this._ = _;
	  }
	
	  _createClass(ModificacionService, [{
	    key: 'getDatosSegunEstado',
	    value: function getDatosSegunEstado(supervision) {
	      var _this = this;
	
	      var nSupervision = {};
	      var atributos = Array.isArray(supervision.estado_actual.atributos) ? supervision.estado_actual.atributos : this._.keys(supervision.estado_actual.atributos);
	      atributos.map(function (atributo) {
	        if (!_this.Util.isEmpty(supervision[atributo])) {
	          nSupervision[atributo] = supervision[atributo];
	        }
	      });
	      return nSupervision;
	    }
	  }]);
	
	  return ModificacionService;
	}();
	
	exports.default = ModificacionService;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modulo = __webpack_require__(498);
	
	var _modulo2 = _interopRequireDefault(_modulo);
	
	var _modulo3 = __webpack_require__(777);
	
	var _modulo4 = _interopRequireDefault(_modulo3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModuloComponent = {
	  bindings: {
	    modulo: '=',
	    modoVista: '<',
	    callback: '&',
	    options: '<'
	  },
	  controller: _modulo2.default,
	  template: _modulo4.default
	};
	
	exports.default = ModuloComponent;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _archivoModal = __webpack_require__(82);
	
	var _archivoModal2 = _interopRequireDefault(_archivoModal);
	
	var _archivoModal3 = __webpack_require__(95);
	
	var _archivoModal4 = _interopRequireDefault(_archivoModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModuloController = function () {
	  ModuloController.$inject = ["DataService", "Util", "Modal", "NgTableParams", "Message", "$log"];
	  function ModuloController(DataService, Util, Modal, NgTableParams, Message, $log) {
	    'ngInject';
	
	    _classCallCheck(this, ModuloController);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Modal = Modal;
	    this.NgTableParams = NgTableParams;
	    this.Message = Message;
	    this.$log = $log;
	
	    if (!this.options) {
	      // Configuracion por defecto
	      this.options = {
	        guardar: true,
	        adicionar: true,
	        editar: true,
	        eliminar: true
	      };
	    }
	  }
	
	  _createClass(ModuloController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getTipoUnidades();
	    }
	  }, {
	    key: 'getTipoUnidades',
	    value: function getTipoUnidades() {
	      var _this = this;
	
	      this.DataService.get('parametricas/UNIDAD').then(function (response) {
	        if (response) {
	          _this.unidades = response.datos.rows;
	        }
	      });
	    }
	
	    /*
	    * MODULO
	    */
	
	  }, {
	    key: 'guardarDatosModulo',
	    value: function guardarDatosModulo() {}
	  }, {
	    key: 'adicionarItem',
	    value: function adicionarItem(modulo) {
	      this.$log.log('adicionarItem', modulo);
	      if (!modulo.items) {
	        modulo.items = [];
	      }
	      modulo.items.push({ edicion: true });
	    }
	  }, {
	    key: 'editarModulo',
	    value: function editarModulo() {}
	  }, {
	    key: 'eliminarModulo',
	    value: function eliminarModulo() {
	      var _this2 = this;
	
	      if (this.modulo) {
	        this.Modal.confirm('\xBFEst\xE1 seguro/a de eliminar el nuevo m\xF3dulo y los items adicionados?', function () {
	          _this2.DataService.delete('modulos/' + _this2.modulo.id_modulo).then(function (result) {
	            if (result && result.finalizado) {
	              _this2.Message.success(result.mensaje);
	              _this2.modulo = null;
	            }
	          });
	        }, null, 'Eliminar el nuevo módulo', 'Sí, estoy seguro/a');
	      }
	    }
	
	    /*
	    * ITEMS
	    */
	
	  }, {
	    key: 'guardarItem',
	    value: function guardarItem(item) {
	      var _this3 = this;
	
	      this.$log.log('guardarItem', item);
	      item.fid_modulo = this.modulo.id_modulo;
	      this.DataService.post('items', item).then(function (result) {
	        if (result && result.finalizado) {
	          _this3.Message.success(result.mensaje);
	          item.id_item = result.datos.id_item;
	          item.edicion = false;
	          _this3.callback({ data: item });
	        }
	      });
	    }
	  }, {
	    key: 'actualizarItem',
	    value: function actualizarItem(item) {
	      var _this4 = this;
	
	      this.$log.log('actualizarItem', item);
	      this.DataService.put('items/' + item.id_item, item).then(function (result) {
	        if (result && result.finalizado) {
	          _this4.Message.success(result.mensaje);
	          item.edicion = false;
	          _this4.callback({ data: item });
	        }
	      });
	    }
	  }, {
	    key: 'verPdfItem',
	    value: function verPdfItem(item, codigo) {
	      if (codigo && (codigo == 'ET' || codigo == 'APU')) {
	        var datos = {
	          codigo: codigo + '_' + item.id_item,
	          titulo: codigo === 'ET' ? 'Especificaciones T\xE9cnicas - "' + item.nombre + '"' : 'Analisis de Precios Unitarios - "' + item.nombre + '"'
	        };
	        this.Modal.showDocumentBase64('proyectos/' + this.options.idProyecto + '/doc/' + datos.codigo, datos.titulo);
	      }
	    }
	  }, {
	    key: 'cargarPdfItem',
	    value: function cargarPdfItem(item, codigo) {
	      var _this5 = this;
	
	      if (codigo && (codigo == 'ET' || codigo == 'APU')) {
	        var titulo = codigo === 'ET' ? 'Especificaciones T\xE9cnicas - "' + item.nombre + '"' : 'Analisis de Precios Unitarios - "' + item.nombre + '"';
	        var confArchivo = {
	          formatos: 'pdf',
	          tipos: '.pdf'
	        };
	        this.mostrarModal(titulo, 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (docEspecificaciones) {
	          if (angular.isUndefined(docEspecificaciones)) {
	            return;
	          }
	          var datos = {};
	          if (codigo === 'ET') datos.especificaciones = docEspecificaciones;
	          if (codigo === 'APU') datos.analisis_precios = docEspecificaciones;
	          _this5.DataService.put('items/' + item.id_item, datos).then(function (result) {
	            if (result && result.finalizado) {
	              _this5.Message.success('Se registr\xF3 el documento del item "' + item.nombre + '" correctamente.');
	              // item.especificaciones = docEspecificaciones;
	              if (codigo === 'ET') item.especificaciones = docEspecificaciones;
	              if (codigo === 'APU') item.analisis_precios = docEspecificaciones;
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'eliminarItem',
	    value: function eliminarItem(item, $index) {
	      var _this6 = this;
	
	      if (!item.id_item) {
	        this.modulo.items.splice($index, 1);
	        this.callback({ data: item });
	        return;
	      }
	      this.Modal.confirm('\xBFEst\xE1 seguro/a de eliminar el item ' + item.nombre + '?', function () {
	        _this6.DataService.delete('items/' + item.id_item).then(function (result) {
	          if (result && result.finalizado) {
	            _this6.Message.success(result.mensaje);
	            _this6.modulo.items.splice($index, 1);
	            _this6.callback({ data: item });
	          }
	        });
	      }, null, 'Eliminar item', 'Sí, estoy seguro/a');
	    }
	
	    // Modal
	
	  }, {
	    key: 'mostrarModal',
	    value: function mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
	      return this.Modal.show({
	        template: template,
	        controller: controller,
	        data: data || {},
	        title: titulo,
	        icon: icon,
	        size: size ? size : 'md',
	        labelOk: labelOk
	      });
	    }
	  }]);
	
	  return ModuloController;
	}();
	
	exports.default = ModuloController;

/***/ }),
/* 499 */
439,
/* 500 */
[852, 501, 779],
/* 501 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EmpresaAnteriorController = function () {
	  EmpresaAnteriorController.$inject = ["$state", "DataService", "Storage"];
	  function EmpresaAnteriorController($state, DataService, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, EmpresaAnteriorController);
	
	    this.$state = $state;
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.user = Storage.getUser();
	    this.historialEmpresas = false;
	  }
	
	  _createClass(EmpresaAnteriorController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var idProyecto = this.supervision.fid_proyecto;
	      this.DataService.get('proyectos/' + idProyecto + '/empresas/avance').then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this.historico = resp.datos;
	          if (resp.datos && resp.datos.proyectos.length > 0) {
	            _this.historialEmpresas = true;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'verSupervision',
	    value: function verSupervision(avance) {
	      this.$state.go('planilla-proyecto', { idSupervision: avance.supervisiones[0].id_supervision });
	    }
	  }]);
	
	  return EmpresaAnteriorController;
	}();
	
	exports.default = EmpresaAnteriorController;

/***/ }),
/* 502 */
442,
/* 503 */
[853, 504, 781, 207],
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fotoSupervisionModal = __webpack_require__(502);
	
	var _fotoSupervisionModal2 = _interopRequireDefault(_fotoSupervisionModal);
	
	var _fotoSupervisionModal3 = __webpack_require__(780);
	
	var _fotoSupervisionModal4 = _interopRequireDefault(_fotoSupervisionModal3);
	
	var _modal = __webpack_require__(510);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(785);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FotosSupervisionController = function () {
	  FotosSupervisionController.$inject = ["DataService", "Storage", "SidenavFactory", "$state", "Modal", "Message", "$window", "Usuarios"];
	  function FotosSupervisionController(DataService, Storage, SidenavFactory, $state, Modal, Message, $window, Usuarios) {
	    'ngInject';
	
	    _classCallCheck(this, FotosSupervisionController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.SidenavFactory = SidenavFactory;
	    this.$state = $state;
	    this.$window = $window;
	    this.Modal = Modal;
	    this.Message = Message;
	    this.Usuarios = Usuarios;
	
	    this.user = Storage.getUser();
	  }
	
	  _createClass(FotosSupervisionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      for (var i = 0; i < this.fotos.length; i++) {
	        this.fotos[i].nro = i + 1;
	        // this.getFoto(this.fotos[i]);
	      }
	      this.puedeEliminar = this.Usuarios.esSupervisor() && this.supervision && this.supervision.estado_actual && this.supervision.estado_actual.codigo === 'EN_SUPERVISION_FDI';
	    }
	  }, {
	    key: 'getFoto',
	    value: function getFoto(foto) {
	      this.DataService.get('fotos/' + foto.id_foto_supervision).then(function (response) {
	        foto.base64 = response.datos;
	        foto.coordenadas = response.coordenadas;
	        foto.mostrar = true;
	      });
	    }
	  }, {
	    key: 'mostrarPopup2',
	    value: function mostrarPopup2(foto) {
	      if (foto.base64) {
	        this.Modal.showImageBase64(foto, 'Foto Supervision ' + foto.nro);
	      }
	    }
	  }, {
	    key: 'mostrarPopup',
	    value: function mostrarPopup(foto) {
	      this.Modal.show({
	        template: _fotoSupervisionModal4.default,
	        controller: _fotoSupervisionModal2.default,
	        data: {
	          foto: foto,
	          fotos: this.fotos
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'mostrarUbicacion',
	    value: function mostrarUbicacion(foto) {
	      //this.$window.open(`https://www.openstreetmap.org/?mlat=${foto.coordenadas.coordinates[1]}&mlon=${foto.coordenadas.coordinates[0]}#map=18/${foto.coordenadas.coordinates[1]}/${foto.coordenadas.coordinates[0]}`,'_blank');
	      this.Modal.show({
	        template: _modal4.default,
	        controller: _modal2.default,
	        data: {
	          foto: foto,
	          fotos: this.fotos
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'eliminarFoto',
	    value: function eliminarFoto(foto) {
	      var _this = this;
	
	      var datos = angular.copy(foto);
	      datos.path_fotografia = foto.path_fotografia.substring(foto.path_fotografia.indexOf('_') + 1);
	      datos.fid_supervision = foto.fid_supervision || this.supervision.id_supervision;
	      this.Modal.confirm('\xBFEst\xE1 seguro/a de eliminar la Foto supervisi\xF3n ' + foto.nro + '?', function () {
	        _this.DataService.delete('fotos/' + foto.id_foto_supervision + '?supervision=' + datos.fid_supervision, datos).then(function (result) {
	          if (result && result.finalizado) {
	            _this.Message.success(result.mensaje);
	            _this.$state.reload();
	          }
	        });
	      });
	    }
	  }]);
	
	  return FotosSupervisionController;
	}();
	
	exports.default = FotosSupervisionController;

/***/ }),
/* 505 */
445,
/* 506 */
[854, 507, 783, 208],
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _computoMetricoModal = __webpack_require__(778);
	
	var _computoMetricoModal2 = _interopRequireDefault(_computoMetricoModal);
	
	var _computoMetricoModal3 = __webpack_require__(499);
	
	var _computoMetricoModal4 = _interopRequireDefault(_computoMetricoModal3);
	
	var _verificacionAnticipoModal = __webpack_require__(784);
	
	var _verificacionAnticipoModal2 = _interopRequireDefault(_verificacionAnticipoModal);
	
	var _verificacionAnticipoModal3 = __webpack_require__(509);
	
	var _verificacionAnticipoModal4 = _interopRequireDefault(_verificacionAnticipoModal3);
	
	var _itemsNoCerradosModal = __webpack_require__(782);
	
	var _itemsNoCerradosModal2 = _interopRequireDefault(_itemsNoCerradosModal);
	
	var _itemsNoCerradosModal3 = __webpack_require__(505);
	
	var _itemsNoCerradosModal4 = _interopRequireDefault(_itemsNoCerradosModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PlanillaProyectoController = function () {
	  PlanillaProyectoController.$inject = ["$scope", "DataService", "Modal", "$state", "$stateParams", "Supervision", "_", "Storage", "Util", "$q", "Flujos", "apiUrl", "Message", "Usuarios", "$log"];
	  function PlanillaProyectoController($scope, DataService, Modal, $state, $stateParams, Supervision, _, Storage, Util, $q, Flujos, apiUrl, Message, Usuarios, $log) {
	    'ngInject';
	
	    _classCallCheck(this, PlanillaProyectoController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.Supervision = Supervision;
	    this._ = _;
	    this.Storage = Storage;
	    this.Util = Util;
	    this.$q = $q;
	    this.Flujos = Flujos;
	    this.apiUrl = apiUrl;
	    this.Message = Message;
	    this.items_modulo = [];
	    this.items_x = [];
	    this.filtroItems = 'TODOS';
	    this.archivos = {};
	    this.Usuarios = Usuarios;
	    this.log = $log;
	  }
	
	  _createClass(PlanillaProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.idSupervision = this.$stateParams.idSupervision;
	      this.getTipoUnidades();
	      this.getSupervision();
	
	      this.anticipo = 0;
	
	      var rol = this.Storage.get('rol');
	      if (rol && (typeof rol === 'undefined' ? 'undefined' : _typeof(rol)) === Array && rol.length > 0) {
	        this.url = 'supervisiones/' + this.idSupervision + '?rol=' + rol[0].id_rol;
	      } else {
	        this.url = 'supervisiones/' + this.idSupervision + '?rol=' + rol.id_rol;
	      }
	
	      this.$scope.$on('transicion_accion_ejecutada', function () {
	        _this.$state.go('mis-proyectos');
	      });
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.filtroItems', function () {
	        if (!_this2.supervision) {
	          return;
	        }
	        _this2.mostrarItems();
	      });
	    }
	  }, {
	    key: 'mostrarItems',
	    value: function mostrarItems() {
	      switch (this.filtroItems) {
	        case 'COMPLETADOS':
	          this.filtrarItems(function (item) {
	            return item.completado;
	          });
	          break;
	        case 'INCOMPLETOS':
	          this.filtrarItems(function (item) {
	            return !item.completado;
	          });
	          break;
	        case 'PARA_ENVIAR':
	          this.filtrarItems(function (item) {
	            return item.cantidad_actual_fis !== 0;
	          });
	          break;
	        default:
	          this.filtrarItems();
	      }
	    }
	  }, {
	    key: 'getSupervision',
	    value: function getSupervision() {
	      var _this3 = this;
	
	      this.usuario = this.Storage.getUser();
	      this.DataService.get('supervisiones/' + this.idSupervision).then(function (response) {
	        if (response) {
	          _this3.supervision = _this3.verificarModificaciones(response.datos);
	          _this3.asignarDatosProyecto();
	          _this3.mostrarItems();
	          _this3.Flujos.getAtributosPermitidos(_this3.supervision);
	          _this3.Supervision.setUsuario(_this3.usuario);
	          _this3.Supervision.setSupervision(_this3.supervision);
	
	          _this3.esEditable = _this3.Supervision.esEditable('computos');
	          _this3.esEtapaEdicion = _this3.supervision.estado_supervision === 'REGISTRO_PLANILLA_FDI';
	          if (!_this3.esEtapaEdicion) {
	            _this3.filtroItems = 'PARA_ENVIAR';
	          }
	          _this3.prepararBoletas();
	          _this3.supervision.supervisiones_anteriores.map(function (supervision) {
	            supervision.numero = _this3.Util.getNumeroOrdinal(supervision.nro_supervision);
	          });
	          var DESEMBOLSOS = _this3._.map(_this3.supervision.supervisiones_anteriores, 'desembolso');
	          _this3.supervision.monto_desembolso_total = _this3.Util.sumar(DESEMBOLSOS);
	          _this3.verificarDeudas();
	          _this3.verificarItemsNoCerrados();
	          _this3.verificarItemsVariacion();
	
	          var comprobante = 'SupCP_Comprobante';
	          if (_this3.supervision.path_comprobante) {
	            comprobante = _this3.supervision.path_comprobante.substring(1, _this3.supervision.path_comprobante.indexOf(']'));
	          }
	
	          _this3.archivos = {
	            urlDocComprobantePago: _this3.supervision ? 'proyectos/' + _this3.supervision.fid_proyecto + '/doc/' + comprobante : '',
	            urlDocComprobantePagoDescarga: _this3.supervision ? 'proyectos/' + _this3.supervision.fid_proyecto + '/doc/' + comprobante + '/descargar' : ''
	          };
	          _this3.calcularAnticipos(_this3.supervision.adjudicacion.monto_inicial, _this3.supervision.monto_total_actual_ejecutado);
	        }
	      });
	    }
	  }, {
	    key: 'mensajeGuardado',
	    value: function mensajeGuardado() {
	      var _this4 = this;
	
	      this.usuario = this.Storage.getUser();
	
	      if (this.usuario.rol.id_rol == 16) {
	        this.DataService.put('supervisiones/anticipos/' + this.idSupervision, this.supervision).then(function (response) {
	          _this4.log.log(response, "--");
	          if (_this4.usuario.rol.id_rol == 16) {
	            _this4.Message.success('Guardado!');
	          }
	        });
	      } else {
	        this.Message.warning('No tiene permisos para modificar.');
	      }
	    }
	  }, {
	    key: 'esSupervisor',
	    value: function esSupervisor() {
	      // console.log(estado_supervision,"supervision")
	      this.usuario = this.Storage.getUser();
	      if (this.usuario.rol.id_rol == 16) {
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'calcularAnticipos',
	    value: function calcularAnticipos(adjudicacionMonto, montoActualEjecutado) {
	      console.log(this.supervision.retencion);
	      if (this.supervision.retencion) {
	        // console.log(response.datos.adjudicacion.monto, "%20 = ", response.datos.adjudicacion.monto * (this.anticipo /100));
	        this.anticipo20 = this.Util.multiplicar([adjudicacionMonto, this.supervision.anticipo / 100]);
	        this.descuentoAnticipo = this.Util.multiplicar([this.anticipo20, this.supervision.dpanticipo / 100]);
	        this.retension = this.Util.multiplicar([montoActualEjecutado, 7 / 100]);
	        this.liquidoPagable = montoActualEjecutado - this.descuentoAnticipo - this.retension;
	      } else {
	        // console.log(response.datos.adjudicacion.monto, "%20 = ", response.datos.adjudicacion.monto * (this.anticipo /100));
	        this.anticipo20 = this.Util.multiplicar([adjudicacionMonto, this.supervision.anticipo / 100]);
	        this.descuentoAnticipo = this.Util.multiplicar([this.anticipo20, this.supervision.dpanticipo / 100]);
	        this.retension = 0;
	        this.liquidoPagable = montoActualEjecutado - this.descuentoAnticipo - this.retension;
	      }
	    }
	  }, {
	    key: 'verificarModificaciones',
	    value: function verificarModificaciones(datos) {
	      // TODO optimizar
	      var cabecera = datos.modulos[0].items[0].item_historico ? datos.modulos[0].items[0].item_historico : [];
	      for (var i in datos.modulos) {
	        var items = datos.modulos[i].items;
	        for (var j in items) {
	          var ij = items[j].item_historico ? items[j].item_historico.length : 0;
	          for (var k = cabecera.length; k > ij; k--) {
	            items[j].item_historico.unshift({
	              version: cabecera[k - 1].version - ij
	            });
	          }
	        }
	      }
	
	      if (datos.proyecto.proyecto_historico[0] && !datos.proyecto.proyecto_historico[0].tipo_modificacion_proyecto) {
	        datos.proyecto.proyecto_historico[0].tipo_modificacion_proyecto = {
	          nombre: 'Contrato Original'
	        };
	      }
	      return datos;
	    }
	  }, {
	    key: 'asignarDatosProyecto',
	    value: function asignarDatosProyecto() {
	      this.proyecto = this.supervision.proyecto;
	      if (this.proyecto.doc_especificaciones_tecnicas) {
	        this.urlDescEspTecnicas = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/ET/descargar';
	      }
	      this.urlDescPlanilla = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/PA_' + this.supervision.fid_adjudicacion + '-' + this.supervision.nro_supervision + '/descargar';
	      if (this.supervision.version_adjudicacion) {
	        this.urlDescPlanilla = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/PA_' + this.supervision.fid_adjudicacion + '-' + this.supervision.nro_supervision + '/descargar';
	        this.urlDescComputosResumen = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/CMR_' + this.supervision.nro_supervision + '/descargar';
	        this.urlDescComputosItem = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/CM_';
	      }
	
	      this.financiamiento = this.proyecto.formularios && this.proyecto.formularios.length > 0 ? this.proyecto.formularios[0] : {};
	      this.monto_contraparte = this.financiamiento.form_model && this.financiamiento.form_model.monto_contraparte ? this.financiamiento.form_model.monto_contraparte : 0;
	      this.monto_beneficiarios = this.financiamiento.form_model && this.financiamiento.form_model.monto_beneficiarios ? this.financiamiento.form_model.monto_beneficiarios : 0;
	      this.monto_otros = this.financiamiento.form_model && this.financiamiento.form_model.monto_otros ? this.financiamiento.form_model.monto_otros : 0;
	    }
	  }, {
	    key: 'irComputo',
	    value: function irComputo(item) {
	      this.$state.go('computo-proyecto', { idSupervision: this.idSupervision, idItem: item.id_item });
	    }
	  }, {
	    key: 'mostrarComputo',
	    value: function mostrarComputo(item) {
	      var _this5 = this;
	
	      this.Modal.show({
	        template: _computoMetricoModal2.default,
	        controller: _computoMetricoModal4.default,
	        size: 'xlg',
	        data: {
	          supervision: this.supervision,
	          item: item,
	          modoVista: this.supervision.estado_actual.atributos['computos'] ? false : true
	        }
	      }).result.then(function (modificados) {
	        if (!modificados) {
	          return;
	        }
	        if (_this5.Supervision.esEditable('computos') && modificados.length > 0) {
	          _this5.getSupervision();
	        }
	      }).catch(function () {});
	    }
	  }, {
	    key: 'getTipoUnidades',
	    value: function getTipoUnidades() {
	      var _this6 = this;
	
	      this.DataService.get('parametricas/UNIDAD').then(function (response) {
	        if (response) {
	          _this6.unidades = response.datos.rows;
	          _this6.unidades_obj = {};
	          _this6.unidades.forEach(function (uni) {
	            _this6.unidades_obj[uni.codigo] = uni;
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getMgColor',
	    value: function getMgColor(item) {
	      if (item.total_acumulado_fis === item.cantidad) {
	        return 'bl-success';
	      }
	      if (item.total_acumulado_fis === 0) {
	        return 'bl-danger';
	      }
	      if (item.cantidad_actual_fis > 0) {
	        return 'bl-secondary';
	      }
	      return 'bl-warning';
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle(item) {
	      if (item.total_acumulado_fis === item.cantidad) {
	        return 'Completado';
	      }
	      if (item.total_acumulado_fis === 0) {
	        return 'Sin avance';
	      }
	      if (item.cantidad_actual_fis > 0) {
	        return 'Con avance';
	      }
	      return 'Con avance en anterior(es) planilla(s)';
	    }
	
	    // TODO obtener valores desde el backend
	
	  }, {
	    key: 'calcularFechaAmpliada',
	    value: function calcularFechaAmpliada(fecha) {
	      if (fecha && this.proyecto && this.proyecto.plazo_ampliacion) {
	        fecha = new Date(fecha);
	        fecha.setDate(fecha.getDate() + this.proyecto.plazo_ampliacion.por_volumenes + this.proyecto.plazo_ampliacion.por_compensacion);
	      }
	      return fecha;
	    }
	  }, {
	    key: 'filtrarItems',
	    value: function filtrarItems() {
	      var _this7 = this;
	
	      var condicion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	        return true;
	      };
	
	      this.supervision.modulos.forEach(function (modulo) {
	        modulo.items.forEach(function (item) {
	          item.show = condicion(item);
	        });
	        modulo.show = _this7._.some(modulo.items, { show: true });
	      });
	      this.Supervision.setSupervision(this.supervision);
	    }
	  }, {
	    key: 'volverSupervisiones',
	    value: function volverSupervisiones() {
	      this.$state.go('avance-proyecto', { idProyecto: this.supervision.fid_proyecto, matricula: this.Storage.get('user').matricula });
	    }
	  }, {
	    key: 'verificarDeudas',
	    value: function verificarDeudas() {
	      if (this.proyecto.anticipo === 0) {
	        return;
	      }
	      var DESCUENTOS = this._.map(this.supervision.supervisiones_anteriores, 'descuento_anticipo');
	      var TOTAL_DESCUENTOS = this.Util.sumar(DESCUENTOS);
	      this.deudaAnticipo = this.Util.restar(this.proyecto.anticipo, TOTAL_DESCUENTOS);
	      if (this.deudaAnticipo === 0) {
	        return;
	      }
	      this.tieneDeudas = true;
	      this.desembolso = this.Supervision.calcularDescuento(this.supervision.tipo_descuento_anticipo, this.supervision.monto_total_actual_ejecutado, this.deudaAnticipo, this.proyecto.porcentaje_anticipo);
	    }
	  }, {
	    key: 'verificarItemsNoCerrados',
	    value: function verificarItemsNoCerrados() {
	      var ITEMS = this.Supervision.getItems();
	      this.itemsNoCerrados = this._.filter(ITEMS, function (item) {
	        return (item.falta_ejecutar_fis === 0 && item.falta_ejecutar_fin !== 0 || item.ejecutar_porcentaje_fis === 0 && item.falta_ejecutar_fis > 0) && item.estado !== 'CERRADO';
	      });
	    }
	  }, {
	    key: 'verificarItemsVariacion',
	    value: function verificarItemsVariacion() {
	      var ITEMS = this.Supervision.getItems();
	      this.itemsVariacion = this._.filter(ITEMS, function (item) {
	        return item.variacion;
	      });
	    }
	  }, {
	    key: 'verificarPlanilla',
	    value: function verificarPlanilla() {
	      var defer = this.$q.defer();
	      if (this.Supervision.esEditable('tipo_descuento_anticipo')) {
	        return this.verificarAnticipo(defer);
	      }
	      if (this.estaEnTecnico(defer)) {
	        return this.verificarDatosParaTecnico(defer);
	      }
	      if (this.requiereInforme(defer)) {
	        if (!this.tieneInforme()) {
	          this.Message.warning('Debe completar el informe técnico de conclusiones');
	          defer.reject();
	        } else {
	          defer.resolve({ confirmar: true });
	        }
	      } else {
	        defer.resolve({ confirmar: true });
	      }
	      return defer.promise;
	    }
	  }, {
	    key: 'verificarAnticipo',
	    value: function verificarAnticipo(defer) {
	      if (!this.tieneAvances()) {
	        this.Message.warning('No tiene avances para enviar.');
	        return defer.promise;
	      }
	
	      if (this.tieneAnticipo() && this.deudaAnticipo > 0) {
	        var modalConfirmacion = this.Modal.show({
	          template: _verificacionAnticipoModal2.default,
	          controller: _verificacionAnticipoModal4.default,
	          data: {
	            supervision: this.supervision,
	            deudaAnticipo: this.deudaAnticipo,
	            esPlanillaCierre: this.supervision.monto_total_por_ejecutar === 0
	          },
	          size: 'lg'
	        });
	        modalConfirmacion.result.then(function () {
	          defer.resolve();
	        }, function () {});
	      } else {
	        defer.resolve();
	      }
	      return defer.promise;
	    }
	  }, {
	    key: 'tieneInforme',
	    value: function tieneInforme() {
	      return this.supervision.informe ? true : false;
	    }
	  }, {
	    key: 'verificarDatosParaTecnico',
	    value: function verificarDatosParaTecnico(defer) {
	      if (this.itemsNoCerrados.length > 0) {
	        var modalConfirmacion = this.Modal.show({
	          template: _itemsNoCerradosModal2.default,
	          controller: _itemsNoCerradosModal4.default,
	          data: {
	            items: this.itemsNoCerrados
	          },
	          size: 'lg'
	        });
	        modalConfirmacion.result.then(function (aprobar) {
	          if (aprobar) {
	            defer.resolve();
	          }
	        }, function () {});
	      } else if (this.supervision.porcentaje_avance_fis === 100) {
	        this.Modal.confirm('Se le recuerda que \xE9sta es la <strong>Planilla de Cierre</strong>.\n        <p>\xBFEst\xE1 seguro/a de aprobar la presente planilla, tomando en cuenta que con ella finalizar\xE1 el registro de los avances del proyecto?</p>\n        <p>En caso de estar seguro/a seleccione la opci\xF3n <b>APROBAR</b>.</p>', function () {
	          defer.resolve();
	        }, null, 'Confirmaci\xF3n previa al cierre del proyecto', 'APROBAR');
	      } else {
	        defer.resolve({ confirmar: true });
	      }
	      return defer.promise;
	    }
	  }, {
	    key: 'tieneAnticipo',
	    value: function tieneAnticipo() {
	      return this.supervision.proyecto.porcentaje_anticipo > 0;
	    }
	  }, {
	    key: 'tieneAvances',
	    value: function tieneAvances() {
	      return this.supervision.monto_total_actual_ejecutado > 0;
	    }
	  }, {
	    key: 'estaEnTecnico',
	    value: function estaEnTecnico() {
	      return this.supervision.estado_supervision === 'EN_TECNICO_FDI';
	    }
	  }, {
	    key: 'requiereInforme',
	    value: function requiereInforme() {
	      return this.supervision.estado_supervision === 'EN_SUPERVISION_FDI';
	    }
	  }, {
	    key: 'irAtras',
	    value: function irAtras() {
	      window.history.back();
	    }
	  }, {
	    key: 'prepararBoletas',
	    value: function prepararBoletas() {
	      this.boletasAnticipo = this.getBoletaPorTipo('TB_CORRECTA_INVERSION');
	      this.boletasCcontrato = this.getBoletaPorTipo('TB_CUMPLIMIENTO_CONTRATO');
	    }
	  }, {
	    key: 'getBoletaPorTipo',
	    value: function getBoletaPorTipo(tipo) {
	      return this._.filter(this.supervision.proyecto.boletas, function (boleta) {
	        return boleta.tipo_boleta === tipo && boleta.estado === 'ACTIVO';
	      });
	    }
	  }, {
	    key: 'getTipoClass',
	    value: function getTipoClass(tipo_modificacion) {
	      if (tipo_modificacion == 'TM_CONTRATO_MODIFICATORIO') return 'cmodificatorio';
	      if (tipo_modificacion == 'TM_ORDEN_CAMBIO') return 'orden-cambio';
	      if (tipo_modificacion == 'TM_ORDEN_TRABAJO') return 'orden-trabajo';
	      return '';
	    }
	  }, {
	    key: 'esTecnico',
	    value: function esTecnico() {
	      return this.Usuarios.esTecnicoResponsable();
	    }
	  }, {
	    key: 'permitirVerAreaComprobante',
	    value: function permitirVerAreaComprobante() {
	      return this.supervision && (this.supervision.estado_supervision == 'EN_FISCAL_FDI' || this.supervision.estado_supervision == 'EN_ARCHIVO_FDI');
	    }
	  }, {
	    key: 'permiteModificarComprobante',
	    value: function permiteModificarComprobante() {
	      return this.supervision.estado_supervision == 'EN_FISCAL_FDI' && this.Usuarios.esFiscal();
	    }
	  }]);
	
	  return PlanillaProyectoController;
	}();
	
	exports.default = PlanillaProyectoController;

/***/ }),
/* 508 */
[855, 506, 503, 500],
/* 509 */
449,
/* 510 */
450,
/* 511 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SupervisionService = function () {
	  SupervisionService.$inject = ["DataService", "$q", "Datetime", "Util", "$window", "_"];
	  function SupervisionService(DataService, $q, Datetime, Util, $window, _) {
	    'ngInject';
	
	    _classCallCheck(this, SupervisionService);
	
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.estadoActual = null;
	    this.Util = Util;
	    this.$window = $window;
	    this.$q = $q;
	    this.proyectoOrigen = {};
	    this._ = _;
	  }
	
	  _createClass(SupervisionService, [{
	    key: 'setSupervision',
	    value: function setSupervision(pSupervision) {
	      this.supervision = angular.copy(pSupervision);
	      this.supervision.estado_actual.areas = this._.zipObject(this.supervision.estado_actual.areas, Array.from(new Array(this.supervision.estado_actual.areas.length), function () {
	        return true;
	      }));
	    }
	  }, {
	    key: 'getSupervision',
	    value: function getSupervision() {
	      return this.supervision || null;
	    }
	  }, {
	    key: 'isSetSupervision',
	    value: function isSetSupervision() {
	      return angular.isDefined(this.supervision);
	    }
	  }, {
	    key: 'setUsuario',
	    value: function setUsuario(pUsuario) {
	      this.usuario = angular.copy(pUsuario);
	      this.id_rol = this.usuario.rol ? this.usuario.rol.id_rol : 0;
	      // this.id_rol = null;
	      // if (this.usuario.rol) {
	      //   this.id_rol = this.usuario.rol.id_rol;
	      // } else {
	      //   this.id_rol = this.usuario.matricula? 8 : 0;
	      // }
	    }
	  }, {
	    key: 'esRolPermitido',
	    value: function esRolPermitido() {
	      return this.supervision.estado_actual.roles.indexOf(this.id_rol) !== -1;
	    }
	  }, {
	    key: 'esRolEstadoSupervisor',
	    value: function esRolEstadoSupervisor() {
	      return this.supervision.estado_supervision === 'EN_SUPERVISOR_FDI' && this.id_rol == 16;
	    }
	
	    /**
	     * getItems - Prepara y envía una lista de items que tienen el atributo show = true (que se va asignando de acuerdo a los filtros de la planilla)
	     *
	     * @return {array}  Lista de items filtrados por el atributo show = true
	     */
	
	  }, {
	    key: 'getItems',
	    value: function getItems() {
	      var _this = this;
	
	      if (!this.supervision) {
	        return null;
	      }
	      var items = [];
	      this.supervision.modulos.map(function (modulo) {
	        if (modulo.show) {
	          items = _this._.unionWith(items, _this._.reject(modulo.items, { 'show': false }));
	        }
	      });
	      return this._.orderBy(items, 'nro_item', 'asc');
	    }
	  }, {
	    key: 'getDatosSegunEstado',
	    value: function getDatosSegunEstado(supervision) {
	      var _this2 = this;
	
	      var nSupervision = {};
	      var atributos = Array.isArray(supervision.estado_actual.atributos) ? supervision.estado_actual.atributos : this._.keys(supervision.estado_actual.atributos);
	      atributos.map(function (atributo) {
	        if (!_this2.Util.isEmpty(supervision[atributo])) {
	          nSupervision[atributo] = supervision[atributo];
	        }
	      });
	      return nSupervision;
	    }
	  }, {
	    key: 'esAreaPermitida',
	    value: function esAreaPermitida(area) {
	      if (this.Util.isEmpty(this.supervision)) {
	        return;
	      }
	      return this.supervision.estado_actual.areas[area] ? true : false;
	    }
	  }, {
	    key: 'esEditable',
	    value: function esEditable(atributo) {
	      return this.supervision.estado_actual.atributos[atributo] ? true : false;
	    }
	  }, {
	    key: 'calcularDescuento',
	    value: function calcularDescuento(tipo, montoEjecutado, deudaAnticipo, porcentajeAnticipo) {
	      var DESCUENTO = {};
	      switch (tipo) {
	        case 'TOTAL':
	          DESCUENTO.descuento = deudaAnticipo;
	          DESCUENTO.total = this.Util.restar(montoEjecutado, deudaAnticipo);
	          break;
	        case 'PROGRESIVO':
	          DESCUENTO.descuento = this.Util.getPorcentaje(montoEjecutado, porcentajeAnticipo);
	          DESCUENTO.total = this.Util.restar(montoEjecutado, DESCUENTO.descuento);
	          break;
	      }
	      return DESCUENTO;
	    }
	  }]);
	
	  return SupervisionService;
	}();
	
	exports.default = SupervisionService;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _listado = __webpack_require__(519);
	
	var _listado2 = _interopRequireDefault(_listado);
	
	var _municipio = __webpack_require__(517);
	
	var _municipio2 = _interopRequireDefault(_municipio);
	
	var _pendientes = __webpack_require__(526);
	
	var _pendientes2 = _interopRequireDefault(_pendientes);
	
	var _procesados = __webpack_require__(530);
	
	var _procesados2 = _interopRequireDefault(_procesados);
	
	var _supervisiones = __webpack_require__(533);
	
	var _supervisiones2 = _interopRequireDefault(_supervisiones);
	
	var _button = __webpack_require__(521);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(391);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _button5 = __webpack_require__(359);
	
	var _button6 = _interopRequireDefault(_button5);
	
	var _button7 = __webpack_require__(352);
	
	var _button8 = _interopRequireDefault(_button7);
	
	var _button9 = __webpack_require__(523);
	
	var _button10 = _interopRequireDefault(_button9);
	
	var _consejoConsultivo = __webpack_require__(513);
	
	var _consejoConsultivo2 = _interopRequireDefault(_consejoConsultivo);
	
	var _listaConvenio = __webpack_require__(515);
	
	var _listaConvenio2 = _interopRequireDefault(_listaConvenio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bandeja = angular.module('app.rbandeja', []).component('rBandejaMAE', _listado2.default).component('rProyectosMunicipioMAE', _municipio2.default).component('rBandejaPendientes', _pendientes2.default).component('rBandejaProcesados', _procesados2.default).component('listaSupervisiones', _supervisiones2.default).component('listaModificaciones', _button2.default).component('buttonTimeline', _button4.default).component('buttonEstado', _button6.default).component('buttonCambiarCodigo', _button8.default).component('buttonParalizar', _button10.default).component('rProyectosEjecutados', _consejoConsultivo2.default).component('rListaConvenios', _listaConvenio2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('lista-proyectos', {
	        url: '/lista-proyectos',
	        component: 'rBandejaMAE'
	    }).state('lista-proyectos-municipio', {
	        url: '/lista-proyectos-municipio',
	        component: 'rProyectosMunicipioMAE'
	    }).state('proyectos-pendientes', {
	        url: '/proyectos-pendientes',
	        component: 'rBandejaPendientes'
	    }).state('proyectos-registrados', {
	        url: '/proyectos-registrados',
	        component: 'rBandejaProcesados'
	    }).state('proyectos-ejecutados', {
	        url: '/proyectos-ejecutados',
	        component: 'rProyectosEjecutados'
	    }).state('lista-proyectos-convenios', {
	        url: '/lista-proyectos-convenios',
	        component: 'rListaConvenios'
	    });
	    $urlRouterProvider.otherwise('/proyectos-pendientes');
	}]).name;
	
	exports.default = Bandeja;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _consejoConsultivo = __webpack_require__(514);
	
	var _consejoConsultivo2 = _interopRequireDefault(_consejoConsultivo);
	
	var _consejoConsultivo3 = __webpack_require__(786);
	
	var _consejoConsultivo4 = _interopRequireDefault(_consejoConsultivo3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConsejoComponent = {
	  bindings: {},
	  controller: _consejoConsultivo2.default,
	  template: _consejoConsultivo4.default
	};
	
	exports.default = ConsejoComponent;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _resumenProyectoModal = __webpack_require__(83);
	
	var _resumenProyectoModal2 = _interopRequireDefault(_resumenProyectoModal);
	
	var _resumenProyectoModal3 = __webpack_require__(96);
	
	var _resumenProyectoModal4 = _interopRequireDefault(_resumenProyectoModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// private
	var local = {
	  calcularTotales: function calcularTotales($ctrl, datos) {
	    $ctrl.totales = {
	      total: 0,
	      fdi: 0,
	      gam: 0,
	      beneficiarios: 0,
	      ejecucion: 0,
	      avance_fisico: 0
	    };
	    for (var i in datos) {
	      $ctrl.totales.total = local.Util.sumar([$ctrl.totales.total, datos[i].financiamiento.monto_total_proyecto]);
	      $ctrl.totales.fdi = local.Util.sumar([$ctrl.totales.fdi, datos[i].financiamiento.monto_fdi]);
	      $ctrl.totales.gam = local.Util.sumar([$ctrl.totales.gam, datos[i].financiamiento.monto_contraparte]);
	      $ctrl.totales.beneficiarios = local.Util.sumar([$ctrl.totales.beneficiarios, datos[i].financiamiento.monto_beneficiarios]);
	    }
	  },
	  calcularTotalesEval: function calcularTotalesEval($ctrl, datos) {
	    $ctrl.totalesEval = {
	      total: 0,
	      fdi: 0,
	      gam: 0,
	      beneficiarios: 0,
	      ejecucion: 0,
	      avance_fisico: 0
	    };
	    for (var i in datos) {
	      $ctrl.totalesEval.total = local.Util.sumar([$ctrl.totalesEval.total, datos[i].financiamiento.monto_total_proyecto]);
	      $ctrl.totalesEval.fdi = local.Util.sumar([$ctrl.totalesEval.fdi, datos[i].financiamiento.monto_fdi]);
	      $ctrl.totalesEval.gam = local.Util.sumar([$ctrl.totalesEval.gam, datos[i].financiamiento.monto_contraparte]);
	      $ctrl.totalesEval.beneficiarios = local.Util.sumar([$ctrl.totalesEval.beneficiarios, datos[i].financiamiento.monto_beneficiarios]);
	    }
	  },
	  calcularTotalesConv: function calcularTotalesConv($ctrl, datos) {
	    $ctrl.totalesConv = {
	      total: 0,
	      fdi: 0,
	      gam: 0,
	      beneficiarios: 0,
	      ejecucion: 0,
	      avance_fisico: 0
	    };
	    for (var i in datos) {
	      $ctrl.totalesConv.total = local.Util.sumar([$ctrl.totalesConv.total, datos[i].financiamiento.monto_total_proyecto]);
	      $ctrl.totalesConv.fdi = local.Util.sumar([$ctrl.totalesConv.fdi, datos[i].financiamiento.monto_fdi]);
	      $ctrl.totalesConv.gam = local.Util.sumar([$ctrl.totalesConv.gam, datos[i].financiamiento.monto_contraparte]);
	      $ctrl.totalesConv.beneficiarios = local.Util.sumar([$ctrl.totalesConv.beneficiarios, datos[i].financiamiento.monto_beneficiarios]);
	    }
	  },
	  calcularTotalesDesem: function calcularTotalesDesem($ctrl, datos) {
	    $ctrl.totalesDesem = {
	      total: 0,
	      fdi: 0,
	      gam: 0,
	      beneficiarios: 0,
	      ejecucion: 0,
	      avance_fisico: 0
	    };
	    for (var i in datos) {
	      $ctrl.totalesDesem.total = local.Util.sumar([$ctrl.totalesDesem.total, datos[i].financiamiento.monto_total_proyecto]);
	      $ctrl.totalesDesem.fdi = local.Util.sumar([$ctrl.totalesDesem.fdi, datos[i].financiamiento.monto_fdi]);
	      $ctrl.totalesDesem.gam = local.Util.sumar([$ctrl.totalesDesem.gam, datos[i].financiamiento.monto_contraparte]);
	      $ctrl.totalesDesem.beneficiarios = local.Util.sumar([$ctrl.totalesDesem.beneficiarios, datos[i].financiamiento.monto_beneficiarios]);
	    }
	  },
	  calcularTotalesEjec: function calcularTotalesEjec($ctrl, datos) {
	    $ctrl.totalesEjec = {
	      total: 0,
	      fdi: 0,
	      gam: 0,
	      beneficiarios: 0,
	      ejecucion: 0,
	      avance_fisico: 0,
	      totalFamilias: 0,
	      primer_desembolso: 0,
	      segundo_desembolso: 0,
	      tercer_desembolso: 0,
	      transferidos: 0
	    };
	    var promedioEjec = 0;
	    for (var i in datos) {
	      /*Inicio calculos para fecha finalizacion y ejecucion presupuestario FDI*/
	      var finfecha = new Date(datos[i].orden_proceder);
	      var totalTransferido = local.Util.sumar([datos[i].cronograma_desembolsos.monto_1, datos[i].cronograma_desembolsos.monto_2, datos[i].cronograma_desembolsos.monto_3]);
	      var ejecupress = local.Util.sumar([datos[i].cronograma_desembolsos.porcentaje_1, datos[i].cronograma_desembolsos.porcentaje_2, datos[i].cronograma_desembolsos.porcentaje_3]);
	      datos[i].ejecuPres = ejecupress;
	      datos[i].totalTransferido = totalTransferido;
	      finfecha.setDate(finfecha.getDate() + parseInt(datos[i].plazo_ejecucion));
	      datos[i].fecha_conclusion = finfecha;
	
	      promedioEjec = local.Util.sumar([promedioEjec, ejecupress]);
	      /*Fin de calculos para fecha finalizacion y ejecucion presupuestario FDI*/
	      $ctrl.totalesEjec.fdi = local.Util.sumar([$ctrl.totalesEjec.fdi, datos[i].financiamiento.monto_fdi]);
	      $ctrl.totalesEjec.totalFamilias = local.Util.sumar([$ctrl.totalesEjec.totalFamilias, datos[i].beneficiarios.nro_familias]);
	      $ctrl.totalesEjec.gam = local.Util.sumar([$ctrl.totalesEjec.gam, datos[i].financiamiento.monto_contraparte]);
	
	      $ctrl.totalesEjec.total = local.Util.sumar([$ctrl.totalesEjec.total, datos[i].financiamiento.monto_total_proyecto]);
	      $ctrl.totalesEjec.primer_desembolso = local.Util.sumar([$ctrl.totalesEjec.primer_desembolso, datos[i].cronograma_desembolsos.monto_1]);
	      $ctrl.totalesEjec.segundo_desembolso = local.Util.sumar([$ctrl.totalesEjec.segundo_desembolso, datos[i].cronograma_desembolsos.monto_2]);
	      $ctrl.totalesEjec.tercer_desembolso = local.Util.sumar([$ctrl.totalesEjec.tercer_desembolso, datos[i].cronograma_desembolsos.monto_3]);
	      $ctrl.totalesEjec.beneficiarios = local.Util.sumar([$ctrl.totalesEjec.beneficiarios, datos[i].financiamiento.monto_beneficiarios]);
	      $ctrl.totalesEjec.transferidos = local.Util.sumar([$ctrl.totalesEjec.transferidos, totalTransferido]);
	    }
	    $ctrl.totalesEjec.ejecucion = Math.round(promedioEjec / datos.length);
	  },
	  obtenerResumen: function obtenerResumen($ctrl, dpa) {
	    if (dpa && dpa.departamento) {
	      var _ruta = dpa.departamento.codigo;
	      if (dpa.municipio) {
	        _ruta += '/' + dpa.municipio.codigo;
	      }
	      local.DataService.get('proyectos/municipios/' + _ruta + '?cartera=' + $ctrl.carteraSelected).then(function (resp) {
	        // local.$log.log('resp', resp);
	        if (resp && resp.finalizado) {
	          $ctrl.datos = resp.datos;
	          local.calcularTotales($ctrl, resp.datos);
	          $ctrl.carteraSelected == 9 ? $ctrl.titulo = resp.titulo + ' - Cartera 3 y 4' : $ctrl.titulo = resp.titulo + ' - Cartera ' + $ctrl.carteraSelected;
	          // $ctrl.titulo = resp.titulo + ' - Cartera ' + $ctrl.carteraSelected;
	          $ctrl.fechaRep = resp.fechaRep;
	          $ctrl.datosEval = resp.datosEval;
	          $ctrl.datosConv = resp.datosConv;
	          $ctrl.datosDesem = resp.datosDesem;
	          $ctrl.datosEjec = resp.datosEjec;
	          $ctrl.datosRechazados = resp.datosRechazados;
	          $ctrl.datoslista = resp.datoslista;
	          local.calcularTotalesEval($ctrl, resp.datosEval);
	          local.calcularTotalesConv($ctrl, resp.datosConv);
	          local.calcularTotalesDesem($ctrl, resp.datosDesem);
	          local.calcularTotalesEjec($ctrl, resp.datosEjec);
	          local.calcularTotalesEjec($ctrl, resp.datoslista);
	        }
	      });
	    } else {
	      $ctrl.datos = [];
	      $ctrl.datosEval = [];
	      $ctrl.datosRechazados = [];
	      $ctrl.datosConv = [];
	      $ctrl.datosDesem = [];
	      $ctrl.datosEjec = [];
	    }
	  }
	};
	
	var ConsejoController = function () {
	  ConsejoController.$inject = ["$log", "DataService", "$state", "Util", "Modal", "Loading"];
	  function ConsejoController($log, DataService, $state, Util, Modal, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, ConsejoController);
	
	    local.$log = $log;
	    local.DataService = DataService;
	    local.Util = Util;
	    local.titulo = '';
	    local.Loading = Loading;
	    this.$state = $state;
	    this.Modal = Modal;
	  }
	
	  _createClass(ConsejoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var gestion = new Date();
	      this.gestiones = [];
	      for (var nombre = 2018; nombre <= 1900 + gestion.getYear(); nombre++) {
	        this.gestiones.unshift({ nombre: nombre });
	        this.gestion = this.gestiones[0];
	      }
	      local.DataService.get('cartera/', {}).then(function (response) {
	        if (response) {
	          _this.carteras = response.datos;
	          // console.log('hay '+this.carteras.length+' carteras :',this.carteras)
	          _this.carteras = [{ id_cartera: 9, descripcion: "TODOS" }, { id_cartera: 3, descripcion: "CARTERA 3" }, { id_cartera: 4, descripcion: "CARTERA 4" }];
	        }
	      });
	      this.carteraSelected = 3;
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      var d1 = this.dpa && this.dpa.departamento;
	      var d2 = local.dpa && local.dpa.departamento;
	
	      var m1 = this.dpa && this.dpa.municipio;
	      var m2 = local.dpa && local.dpa.municipio;
	
	      if (d1 && !d2 || !d1 && d2 || d1 && d2 && d1.codigo != d2.codigo || m1 && !m2 || !m1 && m2 || m1 && m2 && m1.codigo != m2.codigo) {
	        local.dpa = angular.copy(this.dpa);
	        local.obtenerResumen(this, local.dpa);
	      }
	    }
	  }, {
	    key: 'cambiarGestion',
	    value: function cambiarGestion() {
	      local.obtenerResumen(this, local.dpa);
	    }
	  }, {
	    key: 'verProyecto',
	    value: function verProyecto(proyecto) {
	      var _this2 = this;
	
	      //this.$state.go('reg-proyecto', {codigo: proyecto.id_proyecto, urlProcesado: 'procesados'});
	      local.DataService.get('proyectos/' + proyecto.id_proyecto + '/procesados').then(function (resp) {
	        _this2.Modal.show({
	          template: _resumenProyectoModal4.default,
	          controller: _resumenProyectoModal2.default,
	          data: resp.datos,
	          size: 'xlg'
	        });
	      });
	    }
	  }, {
	    key: 'generarPDF',
	    value: function generarPDF() {
	      var tabla = document.getElementById('tabla1');
	
	      local.DataService.pdf('reportes/consejo', { html: tabla.outerHTML }, true).then(function (resp) {
	        if (resp) {
	
	          window.open(resp, 'ventana1', 'menu=0,tooltip=0,width=900px,height=700px,resize=0');
	          // console.log(resp)
	        }
	      });
	    }
	  }, {
	    key: 'fichaProyecto',
	    value: function fichaProyecto(proyecto) {
	      local.Loading.show('Se estan obteniendo los datos, espere por favor', true);
	      local.DataService.get('reportes/ficha_tecnica/' + proyecto.id_proyecto).then(function (resp) {
	        if (resp && resp.finalizado) {
	          local.Loading.hide();
	          var base64 = 'data:application/pdf;base64,' + resp.datos.base64;
	          var aLink = document.createElement("a");
	          var fileName = 'Ficha_Tecnica_' + proyecto.nro_convenio.replace(/\//g, '.') + '.pdf';
	
	          aLink.href = base64;
	          aLink.download = fileName;
	          aLink.click();
	        } else {
	          local.Loading.hide();
	        }
	      });
	    }
	  }]);
	
	  return ConsejoController;
	}();
	
	exports.default = ConsejoController;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _listaConvenio = __webpack_require__(516);
	
	var _listaConvenio2 = _interopRequireDefault(_listaConvenio);
	
	var _listaConvenio3 = __webpack_require__(787);
	
	var _listaConvenio4 = _interopRequireDefault(_listaConvenio3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listConvComponent = {
		binding: {},
		controller: _listaConvenio2.default,
		template: _listaConvenio4.default
	};
	
	exports.default = listConvComponent;

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var listConvController = function () {
		listConvController.$inject = ["$log", "DataService", "Message"];
		function listConvController($log, DataService, Message) {
			'ngInject';
	
			_classCallCheck(this, listConvController);
	
			this.log = $log;
			this.DataService = DataService;
			this.Message = Message;
		}
	
		_createClass(listConvController, [{
			key: '$onInit',
			value: function $onInit() {
				this.carteraSelected = 3;
				this.carteras = [{
					id_cartera: 3,
					num_cartera: 3,
					descripcion: 'Cartera 3'
				}, {
					id_cartera: 4,
					num_cartera: 4,
					descripcion: 'Cartera 4'
				}];
			}
		}, {
			key: 'buscar',
			value: function buscar(dpa, car) {
				var _this = this;
	
				if (dpa && dpa.departamento) {
					var _ruta = dpa.departamento.codigo;
					if (dpa.municipio) {
						_ruta += '/' + dpa.municipio.codigo;
					}
					this.log.log(dpa);
					this.log.log(car);
					// this.log.log(this.dpa)
					// this.log.log(this.carteraSelected)
					this.DataService.get('proyectos/municipios/' + _ruta + '?cartera=' + car).then(function (resp) {
						if (resp && resp.finalizado) {
							_this.datos = resp.datos;
							_this.fechaRep = resp.fechaRep;
							_this.titulo = resp.titulo;
						}
					});
				} else {
					this.Message.warning("Seleccione un departamento");
				}
			}
		}, {
			key: 'generarPDF',
			value: function generarPDF() {
				var tabla = document.getElementById('tabla1');
	
				this.DataService.pdf('reportes/consejo', { html: tabla.outerHTML }, true).then(function (resp) {
					if (resp) {
						window.open(resp, 'ventana1', 'menu=0,tooltip=0,width=900px,height=700px,resize=0');
						// console.log(resp)
					}
				});
			}
		}]);
	
		return listConvController;
	}();
	
	exports.default = listConvController;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _municipio = __webpack_require__(518);
	
	var _municipio2 = _interopRequireDefault(_municipio);
	
	var _municipio3 = __webpack_require__(788);
	
	var _municipio4 = _interopRequireDefault(_municipio3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListadoComponent = {
	  bindings: {},
	  controller: _municipio2.default,
	  template: _municipio4.default
	};
	
	exports.default = ListadoComponent;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _resumenProyectoModal = __webpack_require__(83);
	
	var _resumenProyectoModal2 = _interopRequireDefault(_resumenProyectoModal);
	
	var _resumenProyectoModal3 = __webpack_require__(96);
	
	var _resumenProyectoModal4 = _interopRequireDefault(_resumenProyectoModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// private
	var local = {
	  calcularTotales: function calcularTotales($ctrl, datos) {
	    $ctrl.totales = {
	      total: 0,
	      fdi: 0,
	      gam: 0,
	      beneficiarios: 0,
	      ejecucion: 0,
	      avance_fisico: 0
	    };
	    for (var i in datos) {
	      $ctrl.totales.total = local.Util.sumar([$ctrl.totales.total, datos[i].financiamiento.monto_total_proyecto]);
	      $ctrl.totales.fdi = local.Util.sumar([$ctrl.totales.fdi, datos[i].financiamiento.monto_fdi]);
	      $ctrl.totales.gam = local.Util.sumar([$ctrl.totales.gam, datos[i].financiamiento.monto_contraparte]);
	      $ctrl.totales.beneficiarios = local.Util.sumar([$ctrl.totales.beneficiarios, datos[i].financiamiento.monto_beneficiarios]);
	    }
	  },
	  calcularTotalesEval: function calcularTotalesEval($ctrl, datos) {
	    $ctrl.totalesEval = {
	      total: 0,
	      fdi: 0,
	      gam: 0,
	      beneficiarios: 0,
	      ejecucion: 0,
	      avance_fisico: 0
	    };
	    for (var i in datos) {
	      $ctrl.totalesEval.total = local.Util.sumar([$ctrl.totalesEval.total, datos[i].financiamiento.monto_total_proyecto]);
	      $ctrl.totalesEval.fdi = local.Util.sumar([$ctrl.totalesEval.fdi, datos[i].financiamiento.monto_fdi]);
	      $ctrl.totalesEval.gam = local.Util.sumar([$ctrl.totalesEval.gam, datos[i].financiamiento.monto_contraparte]);
	      $ctrl.totalesEval.beneficiarios = local.Util.sumar([$ctrl.totalesEval.beneficiarios, datos[i].financiamiento.monto_beneficiarios]);
	    }
	  },
	  calcularTotalesConv: function calcularTotalesConv($ctrl, datos) {
	    $ctrl.totalesConv = {
	      total: 0,
	      fdi: 0,
	      gam: 0,
	      beneficiarios: 0,
	      ejecucion: 0,
	      avance_fisico: 0
	    };
	    for (var i in datos) {
	      $ctrl.totalesConv.total = local.Util.sumar([$ctrl.totalesConv.total, datos[i].financiamiento.monto_total_proyecto]);
	      $ctrl.totalesConv.fdi = local.Util.sumar([$ctrl.totalesConv.fdi, datos[i].financiamiento.monto_fdi]);
	      $ctrl.totalesConv.gam = local.Util.sumar([$ctrl.totalesConv.gam, datos[i].financiamiento.monto_contraparte]);
	      $ctrl.totalesConv.beneficiarios = local.Util.sumar([$ctrl.totalesConv.beneficiarios, datos[i].financiamiento.monto_beneficiarios]);
	    }
	  },
	  calcularTotalesDesem: function calcularTotalesDesem($ctrl, datos) {
	    $ctrl.totalesDesem = {
	      total: 0,
	      fdi: 0,
	      gam: 0,
	      beneficiarios: 0,
	      ejecucion: 0,
	      avance_fisico: 0
	    };
	    for (var i in datos) {
	      $ctrl.totalesDesem.total = local.Util.sumar([$ctrl.totalesDesem.total, datos[i].financiamiento.monto_total_proyecto]);
	      $ctrl.totalesDesem.fdi = local.Util.sumar([$ctrl.totalesDesem.fdi, datos[i].financiamiento.monto_fdi]);
	      $ctrl.totalesDesem.gam = local.Util.sumar([$ctrl.totalesDesem.gam, datos[i].financiamiento.monto_contraparte]);
	      $ctrl.totalesDesem.beneficiarios = local.Util.sumar([$ctrl.totalesDesem.beneficiarios, datos[i].financiamiento.monto_beneficiarios]);
	    }
	  },
	  calcularTotalesEjec: function calcularTotalesEjec($ctrl, datos) {
	    $ctrl.totalesEjec = {
	      total: 0,
	      fdi: 0,
	      gam: 0,
	      beneficiarios: 0,
	      ejecucion: 0,
	      avance_fisico: 0
	    };
	    var promedioEjec = 0;
	    for (var i in datos) {
	      /*Inicio calculos para fecha finalizacion y ejecucion presupuestario FDI*/
	      var finfecha = new Date(datos[i].orden_proceder);
	      var ejecupress = local.Util.sumar([datos[i].cronograma_desembolsos.porcentaje_1, datos[i].cronograma_desembolsos.porcentaje_2, datos[i].cronograma_desembolsos.porcentaje_3]);
	      datos[i].ejecuPres = ejecupress;
	      finfecha.setDate(finfecha.getDate() + parseInt(datos[i].plazo_ejecucion));
	      datos[i].fecha_conclusion = finfecha;
	
	      promedioEjec = local.Util.sumar([promedioEjec, ejecupress]);
	      /*Fin de calculos para fecha finalizacion y ejecucion presupuestario FDI*/
	      $ctrl.totalesEjec.total = local.Util.sumar([$ctrl.totalesEjec.total, datos[i].financiamiento.monto_total_proyecto]);
	      $ctrl.totalesEjec.fdi = local.Util.sumar([$ctrl.totalesEjec.fdi, datos[i].financiamiento.monto_fdi]);
	      $ctrl.totalesEjec.gam = local.Util.sumar([$ctrl.totalesEjec.gam, datos[i].financiamiento.monto_contraparte]);
	      $ctrl.totalesEjec.beneficiarios = local.Util.sumar([$ctrl.totalesEjec.beneficiarios, datos[i].financiamiento.monto_beneficiarios]);
	    }
	    $ctrl.totalesEjec.ejecucion = Math.round(promedioEjec / datos.length);
	  },
	  obtenerResumen: function obtenerResumen($ctrl, dpa) {
	    if (dpa && dpa.departamento) {
	      var _ruta = dpa.departamento.codigo;
	      if (dpa.municipio) {
	        _ruta += '/' + dpa.municipio.codigo;
	      }
	      local.DataService.get('proyectos/municipios/' + _ruta + '?cartera=' + $ctrl.carteraSelected).then(function (resp) {
	        // local.$log.log('resp', resp);
	        if (resp && resp.finalizado) {
	          $ctrl.datos = resp.datos;
	          local.calcularTotales($ctrl, resp.datos);
	          $ctrl.titulo = resp.titulo;
	          $ctrl.datosEval = resp.datosEval;
	          $ctrl.datosConv = resp.datosConv;
	          $ctrl.datosDesem = resp.datosDesem;
	          $ctrl.datosEjec = resp.datosEjec;
	          $ctrl.datosRechazados = resp.datosRechazados;
	          local.calcularTotalesEval($ctrl, resp.datosEval);
	          local.calcularTotalesConv($ctrl, resp.datosConv);
	          local.calcularTotalesDesem($ctrl, resp.datosDesem);
	          local.calcularTotalesEjec($ctrl, resp.datosEjec);
	        }
	      });
	    } else {
	      $ctrl.datos = [];
	      $ctrl.datosEval = [];
	      $ctrl.datosRechazados = [];
	      $ctrl.datosConv = [];
	      $ctrl.datosDesem = [];
	      $ctrl.datosEjec = [];
	    }
	  }
	};
	
	// public
	
	var ListadoController = function () {
	  ListadoController.$inject = ["$log", "DataService", "$state", "Util", "Modal", "Loading"];
	  function ListadoController($log, DataService, $state, Util, Modal, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, ListadoController);
	
	    local.$log = $log;
	    local.DataService = DataService;
	    local.Util = Util;
	    local.titulo = '';
	    local.Loading = Loading;
	    this.$state = $state;
	    this.Modal = Modal;
	  }
	
	  _createClass(ListadoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var gestion = new Date();
	      this.gestiones = [];
	      for (var nombre = 2018; nombre <= 1900 + gestion.getYear(); nombre++) {
	        this.gestiones.unshift({ nombre: nombre });
	        this.gestion = this.gestiones[0];
	      }
	      local.DataService.get('cartera/', {}).then(function (response) {
	        if (response) {
	          _this.carteras = response.datos;
	          // console.log('hay '+this.carteras.length+' carteras :',this.carteras)
	        }
	      });
	      this.carteraSelected = 3;
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      var d1 = this.dpa && this.dpa.departamento;
	      var d2 = local.dpa && local.dpa.departamento;
	
	      var m1 = this.dpa && this.dpa.municipio;
	      var m2 = local.dpa && local.dpa.municipio;
	
	      if (d1 && !d2 || !d1 && d2 || d1 && d2 && d1.codigo != d2.codigo || m1 && !m2 || !m1 && m2 || m1 && m2 && m1.codigo != m2.codigo) {
	        local.dpa = angular.copy(this.dpa);
	        local.obtenerResumen(this, local.dpa);
	      }
	    }
	  }, {
	    key: 'cambiarGestion',
	    value: function cambiarGestion() {
	      local.obtenerResumen(this, local.dpa);
	    }
	  }, {
	    key: 'verProyecto',
	    value: function verProyecto(proyecto) {
	      var _this2 = this;
	
	      //this.$state.go('reg-proyecto', {codigo: proyecto.id_proyecto, urlProcesado: 'procesados'});
	      local.DataService.get('proyectos/' + proyecto.id_proyecto + '/procesados').then(function (resp) {
	        _this2.Modal.show({
	          template: _resumenProyectoModal4.default,
	          controller: _resumenProyectoModal2.default,
	          data: resp.datos,
	          size: 'xlg'
	        });
	      });
	    }
	  }, {
	    key: 'fichaProyecto',
	    value: function fichaProyecto(proyecto) {
	      local.Loading.show('Se estan obteniendo los datos, espere por favor', true);
	      local.DataService.get('reportes/ficha_tecnica/' + proyecto.id_proyecto).then(function (resp) {
	        if (resp && resp.finalizado) {
	          local.Loading.hide();
	          var base64 = 'data:application/pdf;base64,' + resp.datos.base64;
	          var aLink = document.createElement("a");
	          var fileName = 'Ficha_Tecnica_' + proyecto.nro_convenio.replace(/\//g, '.') + '.pdf';
	
	          aLink.href = base64;
	          aLink.download = fileName;
	          aLink.click();
	        } else {
	          local.Loading.hide();
	        }
	      });
	    }
	  }]);
	
	  return ListadoController;
	}();
	
	exports.default = ListadoController;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _listado = __webpack_require__(520);
	
	var _listado2 = _interopRequireDefault(_listado);
	
	var _listado3 = __webpack_require__(789);
	
	var _listado4 = _interopRequireDefault(_listado3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListadoComponent = {
	  bindings: {},
	  controller: _listado2.default,
	  template: _listado4.default
	};
	
	exports.default = ListadoComponent;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modificacionesModal = __webpack_require__(28);
	
	var _modificacionesModal2 = _interopRequireDefault(_modificacionesModal);
	
	var _modificacionesModal3 = __webpack_require__(32);
	
	var _modificacionesModal4 = _interopRequireDefault(_modificacionesModal3);
	
	var _modal = __webpack_require__(13);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(14);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ListadoController = function () {
	  ListadoController.$inject = ["apiUrl", "Storage", "DataService", "Modal", "DataTable", "$state", "$location", "$log", "Usuarios"];
	  function ListadoController(apiUrl, Storage, DataService, Modal, DataTable, $state, $location, $log, Usuarios) {
	    'ngInject';
	
	    _classCallCheck(this, ListadoController);
	
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.apiUrl = apiUrl;
	    this.$location = $location;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.DataTable = DataTable;
	    this.Usuarios = Usuarios;
	  }
	
	  _createClass(ListadoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.datos = {};
	      this.usuario = angular.fromJson(this.Storage.getUser());
	      this.config = this.obtenerConfiguracion();
	      this.esEmpresa = this.esUsuarioEmpresa();
	      this.verModificacion = this.puedeVerModificacion();
	      var QUERY = this.esUsuarioEmpresa() ? { matricula: this.usuario.matricula } : { rol: this.Storage.get('rol').id_rol };
	      this.tableParams = this.DataTable.getParams('proyectos/procesados/mae', QUERY);
	    }
	  }, {
	    key: 'obtenerConfiguracion',
	    value: function obtenerConfiguracion() {
	      var configuracion = {};
	      if (this.usuario.rol) {
	        switch (this.usuario.rol.nombre) {
	          // case 'EMPRESA':
	          //   configuracion = {
	          //     opciones: [{icon: 'plus', tooltip: 'Adjudicar', md: 'success', metodo: this.nuevaAdjudicacion.bind(this)}],
	          //   };
	          //   break;
	          default:
	        }
	        configuracion.acciones = [{ icon: 'eye', tooltip: 'Ver', md: 'primary', metodo: this.observarProy.bind(this) }];
	      }
	      return configuracion;
	    }
	  }, {
	    key: 'eventoOpcion',
	    value: function eventoOpcion(event, item, data) {
	      if (typeof item.metodo === 'function') {
	        item.metodo(event, data);
	      }
	    }
	
	    // nuevaAdjudicacion() {
	    // }
	
	  }, {
	    key: 'observarProy',
	    value: function observarProy(event, proyecto) {
	      // if (this.esEmpresa() && proyecto.estado_proyecto === 'REGISTRO_EMPRESA') {
	      //   return this.documentarProyecto(proyecto);
	      // }
	      this.$log.log('Proyecto', event, proyecto);
	      this.$state.go('reg-proyecto', { codigo: proyecto.id_proyecto, urlProcesado: 'procesados' });
	    }
	  }, {
	    key: 'documentar',
	    value: function documentar() {}
	  }, {
	    key: 'nuevaPlanilla',
	    value: function nuevaPlanilla(proyecto) {
	      var _this = this;
	
	      var data = {
	        fid_proyecto: proyecto.id_proyecto,
	        computo_metrico: []
	      };
	      this.DataService.post('supervisiones', data).then(function (response) {
	        if (response) {
	          _this.irPlanilla(response.datos.id_supervision);
	        }
	      });
	    }
	  }, {
	    key: 'irPlanilla',
	    value: function irPlanilla(idSupervision) {
	      this.$state.go('planilla-proyecto', { idSupervision: idSupervision });
	    }
	  }, {
	    key: 'esUsuarioEmpresa',
	    value: function esUsuarioEmpresa() {
	      return !angular.isUndefined(this.usuario.nit);
	    }
	  }, {
	    key: 'puedeCrearPlanilla',
	    value: function puedeCrearPlanilla(proyecto) {
	      if (proyecto.supervisiones.length > 0) {
	        return proyecto.supervisiones[0].estado_supervision === 'EN_ARCHIVO';
	      }
	      return true;
	    }
	  }, {
	    key: 'puedeVerSupervision',
	    value: function puedeVerSupervision(proyecto) {
	      if (proyecto) {
	        return ['APROBADO', 'EN_EJECUCION_FDI', 'REVISION_SEGUIMIENTO_FDI', 'EN_CIERRE_FDI', 'CERRADO', 'MODIFICADO', 'PARALIZADO'].indexOf(proyecto.estado_proyecto) >= 0 && proyecto.supervisiones && proyecto.supervisiones.length > 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeVerModificacion',
	    value: function puedeVerModificacion(proyecto) {
	      var enSupervision = false;
	      if (proyecto) {
	        if (proyecto.supervisiones) {
	          enSupervision = proyecto.supervisiones.find(function (sup) {
	            return sup.estado_supervision == 'EN_FISCAL';
	          });
	        }
	        return ['SUPERVISOR', 'TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'ENCAR_REGIONAL_UPRE', 'EMPRESA'].indexOf(this.usuario.rol.nombre) >= 0 && !enSupervision && ['APROBADO', 'REVISION_MODIFICACION', 'MODIFICADO', 'CERRADO', 'PARALIZADO'].indexOf(proyecto.estado_actual.codigo) >= 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeParalizar',
	    value: function puedeParalizar(proyecto) {
	      if (proyecto) {
	        return ['TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE'].indexOf(this.usuario.rol.nombre) >= 0 && ['APROBADO'].indexOf(proyecto.estado_actual.codigo) >= 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeVerModificaciones',
	    value: function puedeVerModificaciones(proyecto) {
	      if (!proyecto.orden_proceder) return false;
	      if (this.Usuarios.esSupervisor() || this.Usuarios.esFiscal() || this.Usuarios.esResponsableProyecto() || this.Usuarios.esJefeRevision()) return true;
	      return false;
	    }
	  }, {
	    key: 'irAModificaciones',
	    value: function irAModificaciones(proyecto) {
	      if (proyecto.adjudicaciones.length > 1) {
	        if (proyecto.id_proyecto > 0) {
	          this.Modal.show({
	            template: _modificacionesModal4.default,
	            controller: _modificacionesModal2.default,
	            data: proyecto,
	            size: 'lg'
	          });
	        }
	      } else {
	        proyecto.adjudicacion = proyecto.adjudicaciones[0];
	        this.Modal.show({
	          template: _modal4.default,
	          controller: _modal2.default,
	          data: proyecto,
	          size: 'lg'
	        });
	      }
	    }
	  }]);
	
	  return ListadoController;
	}();
	
	exports.default = ListadoController;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(522);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(790);
	
	var _button4 = _interopRequireDefault(_button3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListaModificacionesComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _button2.default,
	  template: _button4.default
	};
	
	exports.default = ListaModificacionesComponent;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(13);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(14);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ListaModificacionesController = function () {
	  ListaModificacionesController.$inject = ["Modal"];
	  function ListaModificacionesController(Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ListaModificacionesController);
	
	    this.Modal = Modal;
	  }
	
	  _createClass(ListaModificacionesController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verModificaciones',
	    value: function verModificaciones() {
	      this.Modal.show({
	        template: _modal4.default,
	        controller: _modal2.default,
	        data: this.proyecto,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return ListaModificacionesController;
	}();
	
	exports.default = ListaModificacionesController;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(524);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(791);
	
	var _button4 = _interopRequireDefault(_button3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonParalizarComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _button2.default,
	  template: _button4.default
	};
	
	exports.default = ButtonParalizarComponent;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(525);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(792);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ButtonParalizarController = function () {
	  ButtonParalizarController.$inject = ["Modal"];
	  function ButtonParalizarController(Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ButtonParalizarController);
	
	    this.Modal = Modal;
	  }
	
	  _createClass(ButtonParalizarController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verMensaje',
	    value: function verMensaje() {
	      this.Modal.show({
	        template: _modal4.default,
	        controller: _modal2.default,
	        data: this.proyecto,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return ButtonParalizarController;
	}();
	
	exports.default = ButtonParalizarController;

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ParalizarModalController = function () {
	  ParalizarModalController.$inject = ["$uibModalInstance", "$state", "data", "Modal", "DataService", "Storage", "_"];
	  function ParalizarModalController($uibModalInstance, $state, data, Modal, DataService, Storage, _) {
	    'ngInject';
	
	    _classCallCheck(this, ParalizarModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$state = $state;
	    this.proyecto = data;
	    this.DataService = DataService;
	    this._ = _;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(ParalizarModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.existeSupervisionesEnCurso = this.tieneSupervisionesEnCurso();
	    }
	  }, {
	    key: 'tieneSupervisionesEnCurso',
	    value: function tieneSupervisionesEnCurso() {
	      return this._.some(this.proyecto.supervisiones, function (supervision) {
	        return supervision.estado_supervision !== 'EN_ARCHIVO_FDI' && supervision.estado_supervision !== 'REGISTRO_PLANILLA_FDI';
	      });
	    }
	  }, {
	    key: 'paralizarProyecto',
	    value: function paralizarProyecto() {
	      var _this = this;
	
	      this.DataService.put('proyectos/' + this.proyecto.id_proyecto + '/empresas/paralizar').then(function (resp) {
	        if (resp && resp.finalizado) {
	          //this.$state.go('mis-proyectos', {});
	          _this.$uibModalInstance.close(true);
	          _this.$state.reload();
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return ParalizarModalController;
	}();
	
	exports.default = ParalizarModalController;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pendientes = __webpack_require__(527);
	
	var _pendientes2 = _interopRequireDefault(_pendientes);
	
	var _pendientes3 = __webpack_require__(793);
	
	var _pendientes4 = _interopRequireDefault(_pendientes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaPendientesComponent = {
	  bindings: {},
	  controller: _pendientes2.default,
	  template: _pendientes4.default
	};
	
	exports.default = BandejaPendientesComponent;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	
	
	var _adjudicacionesModal = __webpack_require__(532);
	
	var _adjudicacionesModal2 = _interopRequireDefault(_adjudicacionesModal);
	
	var _adjudicacionesModal3 = __webpack_require__(797);
	
	var _adjudicacionesModal4 = _interopRequireDefault(_adjudicacionesModal3);
	
	var _modificacionesModal = __webpack_require__(28);
	
	var _modificacionesModal2 = _interopRequireDefault(_modificacionesModal);
	
	var _modificacionesModal3 = __webpack_require__(32);
	
	var _modificacionesModal4 = _interopRequireDefault(_modificacionesModal3);
	
	var _modal = __webpack_require__(13);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(14);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	'use strict';
	
	var BandejaPendientesController = function () {
	  BandejaPendientesController.$inject = ["Storage", "DataService", "DataTable", "$state", "_", "Modal", "Usuarios", "apiUrl"];
	  function BandejaPendientesController(Storage, DataService, DataTable, $state, _, Modal, Usuarios, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, BandejaPendientesController);
	
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.DataTable = DataTable;
	    this.$state = $state;
	    this._ = _;
	    this.Modal = Modal;
	    this.Usuarios = Usuarios;
	    this.apiUrl = apiUrl;
	  }
	
	  _createClass(BandejaPendientesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.usuario = angular.fromJson(this.Storage.getUser());
	      this.config = this.getConfiguracion();
	      this.configSupervisiones = this.getConfiguracionSupervisiones();
	      var QUERY = {
	        rol: this.Storage.get('rol').id_rol
	      }; // this.esEmpresa() ? {matricula: this.usuario.matricula} : {rol:this.Storage.get('rol').id_rol};
	      // console.log("USUARIO>>>>>>",this.usuario)
	      // console.log("QUERY>>>>>>>", QUERY)
	      if (this.usuario.rol.nombre == 'TECNICO_CIERRE') {
	        // Solo consultar proyectos en etapa de cierre
	        this.tableParams = this.DataTable.getParams('pendientes/cierre', QUERY);
	        // console.log("this.tableParams>>>>>",this.tableParams)
	      } else {
	        this.tableParams = this.DataTable.getParams('proyectos', QUERY);
	        // console.log("this.tableParams>>>>>",this.tableParams)
	      }
	      this.verModificacion = this.puedeVerModificacion();
	    }
	  }, {
	    key: 'getConfiguracion',
	    value: function getConfiguracion() {
	      if (!this.usuario.rol) {
	        return;
	      }
	      var configuracion = {
	        acciones: [{ icon: 'edit', tooltip: 'Procesar proyecto', md: 'primary', metodo: this.procesarProyecto.bind(this) }]
	      };
	      if (this.Usuarios.esFiscal()) {
	        configuracion = {
	          acciones: [{ icon: 'eye', tooltip: 'Ver', md: 'primary', metodo: this.procesarProyecto.bind(this) }]
	        };
	      }
	      return configuracion;
	    }
	  }, {
	    key: 'getConfiguracionSupervisiones',
	    value: function getConfiguracionSupervisiones() {
	      var configuracion = {};
	      if (!this.usuario.rol) {
	        return;
	      }
	      switch (this.usuario.rol.nombre) {
	        default:
	          configuracion = {
	            acciones: [{
	              icon: 'edit',
	              tooltip: 'Procesar planilla',
	              md: 'tertiary',
	              metodo: this.procesarPlanilla.bind(this)
	            }]
	          };
	      }
	      return configuracion;
	    }
	  }, {
	    key: 'urlPlanillaConsolidada',
	    value: function urlPlanillaConsolidada(proyecto) {
	      return this.urlPlanillaConsolidadaDescarga = this.apiUrl + 'proyectos/' + proyecto.id_proyecto + '/doc/PAC_' + proyecto.id_proyecto + '/descargar';
	    }
	  }, {
	    key: 'puedeProcesarProyecto',
	    value: function puedeProcesarProyecto(proyecto) {
	      if (proyecto.estado_proyecto == 'APROBADO_FDI' && this.Usuarios.esResponsableGAM()) return true;
	      if (proyecto.estado_proyecto == 'APROBADO_FDI' && this.Usuarios.esSupervisor()) return true;
	      if (proyecto.estado_proyecto == 'APROBADO_FDI' && this.Usuarios.esFinanciero()) return true;
	      if (proyecto.estado_proyecto == 'APROBADO_FDI' && this.Usuarios.esTecnicoResponsable()) return true;
	      if (proyecto.estado_proyecto == 'APROBADO_FDI' && this.usuario.rol.id_rol == 14) return true;
	      // if(proyecto.estado_proyecto == 'EN_EJECUCION_FDI' && this.Usuarios.esFiscal()) return false;
	      return proyecto.estado_proyecto !== 'APROBADO_FDI' || proyecto.estado_proyecto === 'APROBADO_FDI' && this.Usuarios.esSupervisor();
	    }
	  }, {
	    key: 'procesarProyecto',
	    value: function procesarProyecto(proyecto) {
	      // if (this.esEmpresa() && proyecto.estado_proyecto === 'REGISTRO_EMPRESA') {
	      //   return this.documentarProyecto(proyecto);
	      // }
	      if (this.Usuarios.esSupervisor() && proyecto.estado_proyecto === 'MODIFICADO_FDI' || (this.Usuarios.esTecnicoResponsable() || this.Usuarios.esJefeRevision()) && proyecto.estado_proyecto === 'REVISION_MODIFICADO_FDI') {
	        return this.procesarModificacion(proyecto);
	      }
	      this.$state.go('reg-proyecto', { codigo: proyecto.id_proyecto });
	    }
	
	    // documentarProyecto(proyecto) {
	    //   this.$state.go('documentacion-proyecto', {codigo: proyecto.id_proyecto});
	    // }
	
	  }, {
	    key: 'procesarPlanilla',
	    value: function procesarPlanilla(proyecto) {
	      this.$state.go('planilla-proyecto', { idSupervision: proyecto.supervisiones[0].id_supervision });
	    }
	  }, {
	    key: 'procesarModificacion',
	    value: function procesarModificacion(proyecto) {
	      var _this = this;
	
	      this.DataService.get('proyectos/' + proyecto.id_proyecto + '/modificaciones/historial').then(function (result) {
	        if (result && result.finalizado) {
	          var modificacion = result.datos[0];
	          var tipoModificacion = modificacion.tipo_modificacion === 'TM_ORDEN_TRABAJO' ? 1 : modificacion.tipo_modificacion === 'TM_ORDEN_CAMBIO' ? 2 : modificacion.tipo_modificacion === 'TM_CONTRATO_MODIFICATORIO' ? 3 : 0;
	          if (modificacion && ['MODIFICADO_FDI', 'REVISION_MODIFICADO_FDI'].indexOf(modificacion.estado_proyecto) >= 0) {
	            _this.$state.go('modificacion', {
	              proyecto: proyecto.id_proyecto,
	              version: modificacion.version,
	              tipoModificacion: tipoModificacion,
	              edicion: _this.Usuarios.esSupervisor()
	            });
	          }
	        }
	      });
	    }
	
	    // esEmpresa() {
	    //   return !angular.isUndefined(this.usuario.nit);
	    // }
	
	  }, {
	    key: 'puedeVerConsolidado',
	    value: function puedeVerConsolidado(proyecto) {
	      return ['RESP_GAM_GAIOC', 'FINANCIERO_FDI', 'TECNICO_FDI', 'FISCAL_FDI'].indexOf(this.usuario.rol.nombre) !== -1 && ['APROBADO_FDI', 'EN_EJECUCION_FDI'].indexOf(proyecto.estado_proyecto) !== -1;
	    }
	  }, {
	    key: 'puedeVerSupervision',
	    value: function puedeVerSupervision(proyecto) {
	      if (this.Usuarios.esFinanciero()) return false;
	      if (proyecto) {
	        return ['APROBADO_FDI', 'EN_EJECUCION_FDI', 'MODIFICADO_FDI', 'REVISION_SEGUIMIENTO_FDI', 'ASIGNACION_TECNICO_CIERRE_FDI', 'EN_CIERRE_FDI'].indexOf(proyecto.estado_proyecto) >= 0 && proyecto.supervisiones && proyecto.supervisiones.length > 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeVerModificacion',
	    value: function puedeVerModificacion(proyecto) {
	      if (proyecto) {
	        // TODO Se deberia obtener desde una configuracion del proyecto Base de Datos
	        return ['SUPERVISOR_FDI', 'TECNICO_FDI', 'JEFE_REVISION_FDI'].indexOf(this.usuario.rol.nombre) >= 0 && ['REVISION_MODIFICADO_FDI', 'MODIFICADO_FDI', 'EN_EJECUCION_FDI'].indexOf(proyecto.estado_proyecto) >= 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeCrearPlanilla',
	    value: function puedeCrearPlanilla(proyecto) {
	      if (!proyecto.orden_proceder) return false;
	      if (['EN_EJECUCION_FDI', 'REVISION_SEGUIMIENTO_FDI', 'ASIGNACION_TECNICO_CIERRE_FDI', 'EN_CIERRE_FDI'].indexOf(proyecto.estado_proyecto) < 0) return false;
	      //revisar adjudicaciones
	      for (var i = 0; i < proyecto.adjudicaciones.length; i++) {
	        if (proyecto.adjudicaciones[i].supervision.length <= 0 && proyecto.adjudicaciones[i].avance && !proyecto.adjudicaciones[i].avance.completo && proyecto.adjudicaciones[i].esSupervisor) return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeVerModificaciones',
	    value: function puedeVerModificaciones(proyecto) {
	      if (!proyecto.orden_proceder) return false;
	      if ((this.Usuarios.esSupervisor() || this.Usuarios.esFiscal() || this.Usuarios.esResponsableGAM() || this.Usuarios.esTecnicoResponsable() || this.Usuarios.esTecnicoCierre()) && ['EN_EJECUCION_FDI', 'REVISION_SEGUIMIENTO_FDI', 'ASIGNACION_TECNICO_CIERRE_FDI', 'EN_CIERRE_FDI'].indexOf(proyecto.estado_proyecto) !== -1) return true;
	      return false;
	    }
	  }, {
	    key: 'irAModificaciones',
	    value: function irAModificaciones(proyecto) {
	      if (proyecto.adjudicaciones.length > 1) {
	        if (proyecto.id_proyecto > 0) {
	          this.Modal.show({
	            template: _modificacionesModal4.default,
	            controller: _modificacionesModal2.default,
	            data: proyecto,
	            size: 'lg'
	          });
	        }
	      } else {
	        proyecto.adjudicacion = proyecto.adjudicaciones[0];
	        this.Modal.show({
	          template: _modal4.default,
	          controller: _modal2.default,
	          data: proyecto,
	          size: 'lg'
	        });
	      }
	    }
	  }, {
	    key: 'nuevaPlanilla',
	    value: function nuevaPlanilla(proyecto) {
	      var _this2 = this;
	
	      if (proyecto.adjudicaciones.length > 1) {
	        if (proyecto.id_proyecto > 0) {
	          this.Modal.show({
	            template: _adjudicacionesModal4.default,
	            controller: _adjudicacionesModal2.default,
	            data: proyecto,
	            size: 'lg'
	          });
	        }
	      } else {
	        var data = {
	          fid_proyecto: proyecto.id_proyecto,
	          computo_metrico: []
	        };
	        this.DataService.post('supervisiones/adjudicacion/' + proyecto.adjudicaciones[0].id_adjudicacion, data).then(function (response) {
	          if (response) {
	            _this2.irPlanilla(response.datos.id_supervision);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'irPlanilla',
	    value: function irPlanilla(idSupervision) {
	      this.$state.go('planilla-proyecto', { idSupervision: idSupervision });
	    }
	  }]);
	
	  return BandejaPendientesController;
	}();
	
	exports.default = BandejaPendientesController;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _gestion = __webpack_require__(795);
	
	var _gestion2 = _interopRequireDefault(_gestion);
	
	var _gestionController = __webpack_require__(529);
	
	var _gestionController2 = _interopRequireDefault(_gestionController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConvenioModalController = function () {
	  ConvenioModalController.$inject = ["$state", "$uibModalInstance", "DataService", "Storage", "data", "Util", "$filter", "$timeout", "Message", "Proyecto", "Loading", "Modal"];
	  function ConvenioModalController($state, $uibModalInstance, DataService, Storage, data, Util, $filter, $timeout, Message, Proyecto, Loading, Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ConvenioModalController);
	
	    this.$state = $state;
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.Util = Util;
	    this.$filter = $filter;
	    this.data = data;
	    this.$timeout = $timeout;
	    this.Message = Message;
	    this.Proyecto = Proyecto;
	    this.Loading = Loading;
	    this.Modal = Modal;
	    this.conEstados = false;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(ConvenioModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.opciones = {};
	      this.modoVistaConvenio = false;
	      this.getDatosEstadoInicial();
	    }
	  }, {
	    key: 'getDatosEstadoInicial',
	    value: function getDatosEstadoInicial() {
	      var _this = this;
	
	      if (this.data.id_proyecto_referencia) {
	        this.DataService.get('estados/PROYECTO-FDI/' + this.data.id_proyecto_referencia).then(function (response) {
	          if (response) {
	            _this.Proyecto.setEstadoActual(response.datos);
	            _this.conEstados = true;
	            if (!_this.proyecto) {
	              _this.proyecto = {
	                fecha_suscripcion_convenio: response.datos.fecha_actual,
	                nro_convenio: response.datos.codigo_generado,
	                id_proyecto_referencia: _this.data.id_proyecto_referencia,
	                nro_convenio_referencia: _this.data.nro_convenio_referencia
	              };
	            }
	          }
	        });
	      } else {
	        var modalGestion = this.Modal.show({
	          template: _gestion2.default,
	          controller: _gestionController2.default,
	          data: {},
	          size: 'md'
	        });
	        modalGestion.result.then(function (gestion) {
	          _this.DataService.get('estados/PROYECTO-FDI?gestion=' + gestion).then(function (response) {
	            if (response) {
	              _this.Proyecto.setEstadoActual(response.datos);
	              _this.conEstados = true;
	              if (!_this.proyecto) {
	                _this.proyecto = {
	                  fecha_suscripcion_convenio: response.datos.fecha_actual,
	                  nro_convenio: response.datos.codigo_generado
	                };
	              }
	            }
	          });
	        }, function () {});
	      }
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'guardarDatos',
	    value: function guardarDatos() {
	      var _this2 = this;
	
	      this.Loading.show('Registrando proyecto', true);
	      this.DataService.post('proyectos/reg', this.formatoDatosConvenio()).then(function (response) {
	        if (response) {
	          _this2.Message.success("Proyecto creado correctamente.");
	          _this2.cerrar();
	          _this2.Loading.hide();
	          if (response.datos && response.datos.nro_convenio) {
	            _this2.Modal.alert('El c\xF3digo de la solicitud es<br><strong>' + response.datos.nro_convenio + '</strong>.', function () {
	              _this2.$state.reload();
	            }, 'Solicitud enviada');
	          } else {
	            _this2.$state.reload();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'formatoDatosConvenio',
	    value: function formatoDatosConvenio() {
	      var convenio = angular.copy(this.proyecto);
	      convenio.fcod_municipio = convenio.dpa.municipio.codigo;
	      convenio.rol = this.user.rol.id_rol;
	      convenio.cartera = convenio.cartera; // agregar cartera al objeto para registro
	      // Convenio corregido
	      convenio.nro_convenio = '' + this.proyecto.cite_codigo + this.proyecto.cite_nro;
	      // Para proyectos FDI
	      if (!convenio.tipo) {
	        convenio.tipo = 'TP_CIFE';
	      }
	      delete convenio.dpa;
	
	      return convenio;
	    }
	  }]);
	
	  return ConvenioModalController;
	}();
	
	exports.default = ConvenioModalController;

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GestionController = function () {
	  GestionController.$inject = ["data", "$uibModalInstance"];
	  function GestionController(data, $uibModalInstance) {
	    'ngInject';
	
	    _classCallCheck(this, GestionController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	  }
	
	  _createClass(GestionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var gestion = new Date();
	      this.gestiones = [];
	      for (var nombre = 2017; nombre <= 1900 + gestion.getYear(); nombre++) {
	        this.gestiones.unshift({ nombre: nombre });
	        this.gestion = this.gestiones[0];
	      }
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      // this.$uibModalInstance.dismiss('cancel');
	      this.$uibModalInstance.close(this.gestion.nombre);
	    }
	  }, {
	    key: 'aceptar',
	    value: function aceptar() {
	      this.$uibModalInstance.close(this.gestion.nombre);
	    }
	  }]);
	
	  return GestionController;
	}();
	
	exports.default = GestionController;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _procesados = __webpack_require__(531);
	
	var _procesados2 = _interopRequireDefault(_procesados);
	
	var _procesados3 = __webpack_require__(796);
	
	var _procesados4 = _interopRequireDefault(_procesados3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaProcesadosComponent = {
	  bindings: {},
	  controller: _procesados2.default,
	  template: _procesados4.default
	};
	
	exports.default = BandejaProcesadosComponent;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	// import modalController from './crear-proyecto.modal.controller';
	// import crearProyectoTemplate from './crear-proyecto.modal.html';
	// import modalAdjudicacionTemplate from './adjudicacion.modal.html';
	// import modalAdjudicacionController from './adjudicacion.modal.controller';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fdiCrearProyectoModal = __webpack_require__(528);
	
	var _fdiCrearProyectoModal2 = _interopRequireDefault(_fdiCrearProyectoModal);
	
	var _fdiCrearProyectoModal3 = __webpack_require__(794);
	
	var _fdiCrearProyectoModal4 = _interopRequireDefault(_fdiCrearProyectoModal3);
	
	var _modificacionesModal = __webpack_require__(28);
	
	var _modificacionesModal2 = _interopRequireDefault(_modificacionesModal);
	
	var _modificacionesModal3 = __webpack_require__(32);
	
	var _modificacionesModal4 = _interopRequireDefault(_modificacionesModal3);
	
	var _modal = __webpack_require__(13);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(14);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejaProcesadosController = function () {
	  BandejaProcesadosController.$inject = ["Storage", "DataService", "apiUrl", "$location", "Modal", "$log", "$state", "DataTable", "Usuarios"];
	  function BandejaProcesadosController(Storage, DataService, apiUrl, $location, Modal, $log, $state, DataTable, Usuarios) {
	    'ngInject';
	
	    _classCallCheck(this, BandejaProcesadosController);
	
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.apiUrl = apiUrl;
	    this.$location = $location;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.DataTable = DataTable;
	    this.Usuarios = Usuarios;
	  }
	
	  _createClass(BandejaProcesadosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.datos = {};
	      this.usuario = angular.fromJson(this.Storage.getUser());
	      this.config = this.obtenerConfiguracion();
	      // this.esEmpresa = this.esUsuarioEmpresa();
	      this.esSupervisor = this.Usuarios.esSupervisor();
	      this.verModificacion = this.puedeVerModificacion();
	      var QUERY = { rol: this.Storage.get('rol').id_rol }; // this.esUsuarioEmpresa()? {matricula: this.usuario.matricula} : {rol:this.Storage.get('rol').id_rol};
	      this.tableParams = this.DataTable.getParams('proyectos/procesados', QUERY);
	    }
	  }, {
	    key: 'obtenerConfiguracion',
	    value: function obtenerConfiguracion() {
	      var configuracion = {};
	      if (this.usuario.rol) {
	        switch (this.usuario.rol.nombre) {
	          // case 'LEGAL_FDI':
	          //   configuracion = {
	          //     opciones: [{icon:'plus', tooltip:'Nuevo proyecto', md:'success', metodo: this.fdicrearProyecto.bind(this)}],
	          //   };
	          //   break;
	          case 'RESP_RECEPCION_FDI':
	          case 'TECNICO_FDI':
	            configuracion = {
	              opciones: [{ icon: 'plus', tooltip: 'Nuevo proyecto', md: 'success', metodo: this.fdiCrearProyecto.bind(this) }]
	            };
	            break;
	          // case 'EMPRESA':
	          //   configuracion = {
	          //     opciones: [{icon: 'plus', tooltip: 'Adjudicar', md: 'success', metodo: this.nuevaAdjudicacion.bind(this)}],
	          //   };
	          //   break;
	          default:
	        }
	        configuracion.acciones = [{ icon: 'eye', tooltip: 'Ver', md: 'primary', metodo: this.observarProy.bind(this) }];
	      }
	      return configuracion;
	    }
	  }, {
	    key: 'eventoOpcion',
	    value: function eventoOpcion(event, item, data) {
	      if (typeof item.metodo === 'function') {
	        item.metodo(event, data);
	      }
	    }
	
	    // crearProyecto() {
	    //   this.Modal.show({
	    //     template: crearProyectoTemplate,
	    //     controller: modalController,
	    //     data: {},
	    //     size: 'xlg'
	    //   });
	    // }
	
	  }, {
	    key: 'fdiCrearProyecto',
	    value: function fdiCrearProyecto() {
	      this.Modal.show({
	        template: _fdiCrearProyectoModal4.default,
	        controller: _fdiCrearProyectoModal2.default,
	        data: {},
	        size: 'xlg'
	      });
	    }
	  }, {
	    key: 'fdiCrearProyectoModificado',
	    value: function fdiCrearProyectoModificado(proyecto) {
	      this.Modal.show({
	        template: _fdiCrearProyectoModal4.default,
	        controller: _fdiCrearProyectoModal2.default,
	        data: { id_proyecto_referencia: proyecto.id_proyecto, nro_convenio_referencia: proyecto.nro_convenio },
	        size: 'xlg'
	      });
	    }
	  }, {
	    key: 'fdiAgregarAdjudicacion',
	    value: function fdiAgregarAdjudicacion(proyecto) {
	      // Se agrega un flag a la url para la consulta en backend
	      this.$state.go('reg-proyecto', { codigo: proyecto.id_proyecto, urlProcesado: 'usar-flag/agregar-adjudicaciones' });
	    }
	
	    // nuevaAdjudicacion() {
	    //   this.Modal.show({
	    //     template: modalAdjudicacionTemplate,
	    //     controller: modalAdjudicacionController,
	    //     size: 'md'
	    //   }).result.then( result => {
	    //     this.$state.go('documentacion-proyecto', {codigo: result.id_proyecto});
	    //   }).catch( () => {});
	    // }
	
	  }, {
	    key: 'observarProy',
	    value: function observarProy(event, proyecto) {
	      // if (this.esEmpresa() && proyecto.estado_proyecto === 'REGISTRO_EMPRESA') {
	      //   return this.documentarProyecto(proyecto);
	      // }
	      this.$state.go('reg-proyecto', { codigo: proyecto.id_proyecto, urlProcesado: 'procesados' });
	    }
	  }, {
	    key: 'verUsuarios',
	    value: function verUsuarios(proyecto) {
	      // this.$state.go('adminproyecto', { codigo: proyecto.id_proyecto });
	
	      window.open('#!/admin-proyecto/' + proyecto.id_proyecto, 'ventana1', 'menu=0,tooltip=0,width=1200px,height=500px,resize=0');
	    }
	
	    // documentar() {
	
	    // }
	
	  }, {
	    key: 'nuevaPlanilla',
	    value: function nuevaPlanilla(proyecto) {
	      var _this = this;
	
	      var data = {
	        fid_proyecto: proyecto.id_proyecto,
	        computo_metrico: []
	      };
	      this.DataService.post('supervisiones', data).then(function (response) {
	        if (response) {
	          _this.irPlanilla(response.datos.id_supervision);
	        }
	      });
	    }
	  }, {
	    key: 'irPlanilla',
	    value: function irPlanilla(idSupervision) {
	      this.$state.go('planilla-proyecto', { idSupervision: idSupervision });
	    }
	
	    // esUsuarioEmpresa() {
	    //   return !angular.isUndefined(this.usuario.nit);
	    // }
	
	  }, {
	    key: 'esUsuarioRegistro',
	    value: function esUsuarioRegistro() {
	      return this.Usuarios.esRecepcion() || this.Usuarios.esTecnicoResponsable();
	    }
	  }, {
	    key: 'puedeCrearPlanilla',
	    value: function puedeCrearPlanilla(proyecto) {
	      if (proyecto.supervisiones.length > 0) {
	        return proyecto.supervisiones[0].estado_supervision === 'EN_ARCHIVO_FDI';
	      }
	      return true;
	    }
	  }, {
	    key: 'puedeVerConsolidado',
	    value: function puedeVerConsolidado(proyecto) {
	      return ['RESP_GAM_GAIOC', 'FINANCIERO_FDI', 'TECNICO_FDI', 'FISCAL_FDI'].indexOf(this.usuario.rol.nombre) !== -1 && ['APROBADO_FDI', 'EN_EJECUCION_FDI'].indexOf(proyecto.estado_proyecto) !== -1;
	    }
	  }, {
	    key: 'urlPlanillaConsolidada',
	    value: function urlPlanillaConsolidada(proyecto) {
	      return this.urlPlanillaConsolidadaDescarga = this.apiUrl + 'proyectos/' + proyecto.id_proyecto + '/doc/PAC_' + proyecto.id_proyecto + '/descargar';
	    }
	  }, {
	    key: 'puedeVerSupervision',
	    value: function puedeVerSupervision(proyecto) {
	      if (proyecto) {
	        return proyecto.supervisiones && proyecto.supervisiones.length > 0 && ['APROBADO_FDI', 'EN_EJECUCION_FDI', 'MODIFICADO_FDI', 'CERRADO_FDI'].indexOf(proyecto.estado_proyecto) >= 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeVerModificacion',
	    value: function puedeVerModificacion(proyecto) {
	      var enSupervision = false;
	      if (proyecto) {
	        if (proyecto.supervisiones) {
	          enSupervision = proyecto.supervisiones.find(function (sup) {
	            return ['PENDIENTE_FDI', 'EN_FISCAL_FDI'].indexOf(sup.estado_supervision) != -1;
	          });
	        }
	        return !enSupervision && ['SUPERVISOR_FDI', 'TECNICO_FDI', 'JEFE_REVISION_FDI'].indexOf(this.usuario.rol.nombre) >= 0 && ['APROBADO_FDI', 'EN_EJECUCION_FDI', 'REVISION_MODIFICADO_FDI', 'MODIFICADO_FDI', 'CERRADO_FDI', 'PARALIZADO_FDI'].indexOf(proyecto.estado_proyecto) >= 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeParalizar',
	    value: function puedeParalizar(proyecto) {
	      if (proyecto) {
	        return (this.Usuarios.esJefeRevision() || this.Usuarios.esTecnicoResponsable()) && ['APROBADO_FDI'].indexOf(proyecto.estado_proyecto) >= 0;
	      }
	      return false;
	    }
	
	    // puedeAgregarAdjudicacion(proyecto) {
	    //   if (proyecto) {
	    //     return this.Usuarios.esResponsableGAM() && ['APROBADO_FDI'].indexOf(proyecto.estado_proyecto) >= 0;
	    //   }
	    //   return false;
	    // }
	
	  }, {
	    key: 'puedeReferenciarProyecto',
	    value: function puedeReferenciarProyecto(proyecto) {
	      if (proyecto) {
	        /* return ['RESP_RECEPCION_FDI','TECNICO_FDI'].indexOf(this.usuario.rol.nombre) >= 0
	                && ['RECHAZADO_FDI'].indexOf(proyecto.estado_proyecto) >= 0 && proyecto.proyectos.length == 0; */
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeVerModificaciones',
	    value: function puedeVerModificaciones(proyecto) {
	      if (!proyecto.orden_proceder) return false;
	      if (this.Usuarios.esSupervisor() || this.Usuarios.esFiscal() || this.Usuarios.esResponsableProyecto() || this.Usuarios.esJefeRevision()) return true;
	      return false;
	    }
	  }, {
	    key: 'irAModificaciones',
	    value: function irAModificaciones(proyecto) {
	      if (proyecto.adjudicaciones.length > 1) {
	        if (proyecto.id_proyecto > 0) {
	          this.Modal.show({
	            template: _modificacionesModal4.default,
	            controller: _modificacionesModal2.default,
	            data: proyecto,
	            size: 'lg'
	          });
	        }
	      } else {
	        proyecto.adjudicacion = proyecto.adjudicaciones[0];
	        this.Modal.show({
	          template: _modal4.default,
	          controller: _modal2.default,
	          data: proyecto,
	          size: 'lg'
	        });
	      }
	    }
	  }]);
	
	  return BandejaProcesadosController;
	}();
	
	exports.default = BandejaProcesadosController;

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NuevaAdjudicacionModalController = function () {
	  NuevaAdjudicacionModalController.$inject = ["$uibModalInstance", "DataService", "Storage", "data", "apiUrl", "$state", "Usuarios"];
	  function NuevaAdjudicacionModalController($uibModalInstance, DataService, Storage, data, apiUrl, $state, Usuarios) {
	    'ngInject';
	
	    _classCallCheck(this, NuevaAdjudicacionModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.Storage = Storage;
	    this.apiUrl = apiUrl;
	    this.$state = $state;
	    this.proyecto = data;
	    this.Usuarios = Usuarios;
	    this.DataService = DataService;
	  }
	
	  _createClass(NuevaAdjudicacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.usuario = this.Storage.getUser();
	    }
	  }, {
	    key: 'puedeCrearPlanilla',
	    value: function puedeCrearPlanilla(adjudicacion) {
	      if (adjudicacion.supervision.length > 0) {
	        return false;
	      }
	      return adjudicacion.avance && !adjudicacion.avance.completo && adjudicacion.esSupervisor;
	    }
	  }, {
	    key: 'nuevaPlanilla',
	    value: function nuevaPlanilla(proyecto, idAjudicacion) {
	      var _this = this;
	
	      var data = {
	        fid_proyecto: proyecto.id_proyecto,
	        computo_metrico: []
	      };
	      this.DataService.post('supervisiones/adjudicacion/' + idAjudicacion, data).then(function (response) {
	        if (response) {
	          _this.$uibModalInstance.close(false);
	          _this.irPlanilla(response.datos.id_supervision);
	        }
	      });
	    }
	  }, {
	    key: 'irPlanilla',
	    value: function irPlanilla(idSupervision) {
	      this.$state.go('planilla-proyecto', { idSupervision: idSupervision });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return NuevaAdjudicacionModalController;
	}();
	
	exports.default = NuevaAdjudicacionModalController;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _supervisiones = __webpack_require__(534);
	
	var _supervisiones2 = _interopRequireDefault(_supervisiones);
	
	var _supervisiones3 = __webpack_require__(798);
	
	var _supervisiones4 = _interopRequireDefault(_supervisiones3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListaSupervisionesComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _supervisiones2.default,
	  template: _supervisiones4.default
	};
	
	exports.default = ListaSupervisionesComponent;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _supervisionesModal = __webpack_require__(84);
	
	var _supervisionesModal2 = _interopRequireDefault(_supervisionesModal);
	
	var _supervisionesModal3 = __webpack_require__(97);
	
	var _supervisionesModal4 = _interopRequireDefault(_supervisionesModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ListaSupervisionesController = function () {
	  ListaSupervisionesController.$inject = ["Storage", "DataService", "DataTable", "$state", "_", "Modal"];
	  function ListaSupervisionesController(Storage, DataService, DataTable, $state, _, Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ListaSupervisionesController);
	
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.DataTable = DataTable;
	    this.$state = $state;
	    this._ = _;
	    this.Modal = Modal;
	  }
	
	  _createClass(ListaSupervisionesController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verSupervisiones',
	    value: function verSupervisiones() {
	      this.Modal.show({
	        template: _supervisionesModal4.default,
	        controller: _supervisionesModal2.default,
	        data: this.proyecto,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return ListaSupervisionesController;
	}();
	
	exports.default = ListaSupervisionesController;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ampliacion = __webpack_require__(536);
	
	var _ampliacion2 = _interopRequireDefault(_ampliacion);
	
	var _ampliacion3 = __webpack_require__(799);
	
	var _ampliacion4 = _interopRequireDefault(_ampliacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AmpliacionComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _ampliacion2.default,
	  template: _ampliacion4.default
	};
	
	exports.default = AmpliacionComponent;

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Ampliacion = function () {
	  Ampliacion.$inject = ["$scope", "Util", "Proyecto", "Modal", "_", "DataService", "Message", "$http", "subDomain", "baseUrl"];
	  function Ampliacion($scope, Util, Proyecto, Modal, _, DataService, Message, $http, subDomain, baseUrl) {
	    'ngInject';
	
	    _classCallCheck(this, Ampliacion);
	
	    this.$http = $http;
	    this.$scope = $scope;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this._ = _;
	    this.archivos = null;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.qrimage = null;
	    this.subDomain = subDomain;
	    this.baseUrl = baseUrl;
	  }
	
	  _createClass(Ampliacion, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.tipos_plazo_ampliado = [{
	        codigo: 'adenda_cierre',
	        nombre: 'Adenda'
	      }];
	      this.plazo_cierre = [];
	      setTimeout(function () {
	        if (!_this.proyecto.cierre.ampliacion) {
	          _this.proyecto.cierre.ampliacion = {};
	          _this.proyecto.cierre.ampliacion.cierre = [];
	        }
	        for (var i in _this.proyecto.cierre.ampliacion.cierre) {
	          _this.calcularPlazos(i);
	        }
	      }, 2000);
	    }
	  }, {
	    key: 'adicionar',
	    value: function adicionar(value) {
	      // console.log("ADICIONAR AMPLIACION",value)
	      if (!value) {
	        // console.log("no tiene valor")
	        value = [];
	      }
	      // for(let i in value){
	      //   // console.log(value[i].id_avance_fisico,"<<")
	      //   if (!value[i].plazo || value[i].edicion) {
	      //     // console.log(value[i].id_avance_fisico, value[i].edicion)
	      //     this.Message.warning(`Debe guardar el registro antes de crear otro`);
	      //     return;
	      //   }
	      // }
	      value.push({ edicion: true });
	    }
	  }, {
	    key: 'guardar',
	    value: function guardar() {
	      var _this2 = this;
	
	      this.DataService.post('proyectos/cie', this.proyecto).then(function (response) {
	        if (response) {
	
	          _this2.Message.success("Actualizado correctamente.");
	        }
	      });
	      //  value.edicion = false;
	    }
	  }, {
	    key: 'eliminar',
	    value: function eliminar(value, index) {
	      this.proyecto.cierre.ampliacion.cierre.splice(index, 1);
	      this.plazo_cierre.splice(index, 1);
	    }
	  }, {
	    key: 'calcularPlazos',
	    value: function calcularPlazos(key) {
	
	      if (key == 0) {
	        this.plazo_cierre[key] = new Date(this.proyecto.cierre.fecha_inicio);
	
	        this.plazo_cierre[key].setDate(this.plazo_cierre[key].getDate() + parseInt(this.proyecto.cierre.plazo_cierre) + parseInt(this.proyecto.cierre.ampliacion.cierre[key].plazo));
	        this.plazo_cierre[key] = this.plazo_cierre[key].toISOString();
	      }
	      if (key >= 1) {
	        this.plazo_cierre[key] = new Date(this.plazo_cierre[key - 1]);
	        this.plazo_cierre[key].setDate(this.plazo_cierre[key].getDate() + parseInt(this.proyecto.cierre.ampliacion.cierre[key].plazo));
	        this.plazo_cierre[key] = this.plazo_cierre[key].toISOString();
	      }
	      // console.log("plazo_cierre["+key+"] : ", this.plazo_cierre[key])
	
	    }
	  }]);
	
	  return Ampliacion;
	}();
	
	exports.default = Ampliacion;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _archivo_adjunto = __webpack_require__(538);
	
	var _archivo_adjunto2 = _interopRequireDefault(_archivo_adjunto);
	
	var _archivo_adjunto3 = __webpack_require__(800);
	
	var _archivo_adjunto4 = _interopRequireDefault(_archivo_adjunto3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArchivoAdjuntoComponent = {
	  bindings: {
	    proyecto: '<',
	    modoVista: '<'
	  },
	  controller: _archivo_adjunto2.default,
	  template: _archivo_adjunto4.default
	};
	
	exports.default = ArchivoAdjuntoComponent;

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArchivoAdjunto = function () {
	  ArchivoAdjunto.$inject = ["$scope", "Util", "Usuarios", "Proyecto", "Modal", "DataService", "Message", "Storage"];
	  function ArchivoAdjunto($scope, Util, Usuarios, Proyecto, Modal, DataService, Message, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, ArchivoAdjunto);
	
	    this.$scope = $scope;
	    this.Util = Util;
	    this.Usuarios = Usuarios;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.archivos = null;
	    this.Storage = Storage;
	  }
	
	  _createClass(ArchivoAdjunto, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.usuario = this.Storage.getUser();
	      console.log(this.usuario, "USUARIO");
	      if (this.usuario.rol.id_rol == 15) {
	        this.tipos_documentos = [{
	          codigo: 'Informe_Financiero',
	          nombre: 'Informe Financiero'
	        }];
	      }
	      if (this.usuario.rol.id_rol == 14) {
	        this.tipos_documentos = [{
	          codigo: 'Informe_Legal',
	          nombre: 'Informe Legal'
	        }];
	      }
	
	      this.uploadArchivoAdjunto = function (file) {
	        if (!file.name) {
	          _this.Message.warning('Debe escribir el t\xEDtulo del archivo.');
	          return;
	        }
	        var datos = _this.proyecto.archivo_adjunto.find(function (d) {
	          return d.datos.titulo == file.name;
	        });
	        if (!datos.file) {
	          _this.Message.warning('No se puede crear subir un documento con titulo \'' + file.name + '\'. Puede ser que ya exista uno similar.');
	          return;
	        }
	        if (datos.datos.id_archivo_adjunto) {
	          datos.p = 'change';
	        } else {
	          datos.p = 'save';
	        }
	        _this.DataService.put('proyectos/' + _this.proyecto.id_proyecto + '/archivo_adjunto', datos).then(function (response) {
	          if (response && response.finalizado) {
	            datos.datos.id_archivo_adjunto = response.datos.id_archivo_adjunto;
	            datos.datos.ruta = response.datos.ruta;
	            datos.datos.nombre_original = response.datos.nombre_original;
	          }
	        });
	      };
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(a) {
	      var _this2 = this;
	
	      if (!a.proyecto.previousValue && a.proyecto.currentValue.id_proyecto) {
	        this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/archivo_adjunto').then(function (resp) {
	          if (resp.finalizado) {
	            // Documentos adjuntos
	            var documentos = [];
	            for (var i in resp.datos.rows) {
	              documentos.push({ datos: resp.datos.rows[i] });
	            }
	            _this2.proyecto.archivo_adjunto = documentos;
	          }
	        });
	      }
	    }
	
	    /* RESPALDO TECNICO */
	
	  }, {
	    key: 'modoEdicionDoc',
	    value: function modoEdicionDoc(archivo) {
	      if (this.usuario.rol.id_rol != 13 && this.usuario.rol.id_rol != 14 && this.usuario.rol.id_rol != 18) {
	        return false;
	      }
	      return archivo.datos.codigo_estado === this.proyecto.estado_actual.codigo;
	    }
	  }, {
	    key: 'inhabilitarBotonEliminar',
	    value: function inhabilitarBotonEliminar(archivo) {
	      // SOLO EL USUARIO QUE SUBIO EL ADJUNTO TIENE PERMITIDO ELIMINAR ADJUNTO
	      // SOLO EL USUARIO QUE GENERA EL REGISTRO TIENE PERMITIDO ELIMINAR EL REGISTRO
	      if (!archivo.datos.id_archivo_adjunto || this.usuario.id_usuario === archivo.datos._usuario_creacion) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'verArchivoAdjunto',
	    value: function verArchivoAdjunto(archivo) {
	      var _this3 = this;
	
	      if (archivo.file && archivo.file.base64) {
	        this.Modal.showDocumentBase64(archivo.file.base64, 'Informe', 'strBase64');
	        return;
	      }
	      this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/archivo_adjunto/' + archivo.datos.id_archivo_adjunto).then(function (doc) {
	        if (doc && doc.finalizado) {
	          archivo.file = doc.datos.file;
	          _this3.Modal.showDocumentBase64(archivo.file.base64, 'Informe', 'strBase64');
	        }
	      });
	    }
	  }, {
	    key: 'cambiarArchivoAdjunto',
	    value: function cambiarArchivoAdjunto(archivo) {
	      delete archivo.datos.ruta;
	    }
	  }, {
	    key: 'agregarArchivoAdjunto',
	    value: function agregarArchivoAdjunto() {
	      console.log('agregar', this.proyecto);
	      if (!this.proyecto || !this.proyecto.id_proyecto) return;
	      if (!this.proyecto.archivo_adjunto) this.proyecto.archivo_adjunto = [];
	      this.proyecto.archivo_adjunto.push({
	        datos: {
	          titulo: null,
	          descripcion: null,
	          rol: {
	            nombre: this.Usuarios.usuario.rol.nombre,
	            descripcion: this.Usuarios.usuario.rol.descripcion
	          },
	          codigo_estado: this.proyecto.estado_actual.codigo
	        }
	      });
	    }
	  }, {
	    key: 'agregarTodosArchivos',
	    value: function agregarTodosArchivos() {
	      if (this.usuario.rol.id_rol == 13) {
	        // solo para rol tecnico responsable
	        if (this.proyecto.cartera == 3) {
	          this.tipos_documentos = [{
	            codigo: 'carta_solicitud_financiamiento',
	            nombre: '01 Carta de Presentacion y Solicitud de financiamiento'
	          }, {
	            codigo: 'lista_beneficiarios',
	            nombre: '02 Lista de beneficiarios'
	          }, {
	            codigo: 'Acta_compromiso_cumplimiento',
	            nombre: '03 Acta de compromiso de cumplimiento de contrapartes'
	          }, {
	            codigo: 'Acta_verificacion_campo_gam_gaioc',
	            nombre: '04 Acta de verificacion de campo del GAM o GAIOC'
	          }, {
	            codigo: 'ddjj_proyecto_no_afecta_tierras_fiscales',
	            nombre: '05 DDJJ notariada que establesca que el proyecto no afecta a tierras fiscales'
	          }, {
	            codigo: 'certificacion_sedcam',
	            nombre: '06 Certificacion del SEDCAM en la juridiccion del tramo (solo puentes)'
	          }, {
	            codigo: 'Acta_consenso_pueblos',
	            nombre: '07 Acta de consenso (pueblos indigenas originarios)'
	          }, {
	            codigo: 'hoja_firmada_responsables_edtp',
	            nombre: '08 Hoja firmada por Responsables EDTP'
	          }, {
	            codigo: 'ficha_tecnica',
	            nombre: '09 Ficha Tecnica'
	          }, {
	            codigo: 'informe_verificacion_campo',
	            nombre: '10 Informe y acta de verificacion de campo.'
	          }, {
	            codigo: 'informe_evaluacion_edtp',
	            nombre: '11 Informe de Evaluacion del EDTP (con firmas)'
	          }, {
	            codigo: 'formulario_evaluacion_edtp',
	            nombre: '12 Formulario de Evaluacion del EDTP (con firmas)'
	          }, {
	            codigo: 'ficha_tecnica_proyecto',
	            nombre: '13 Ficha Tecncia del proyecto (con firmas)'
	          }, {
	            codigo: 'acta_validacion_tecnica',
	            nombre: '14 Acta de validacion tecnica'
	          }];
	        }
	        if (this.proyecto.cartera == 4) {
	          this.tipos_documentos = [{
	            codigo: 'informe_evaluacion_edtp',
	            nombre: '01 INFORME DE EVALUACION DEL EDTP (CON FIRMAS Y V°B°)'
	          }, {
	            codigo: 'formulario_evaluacion_edtp',
	            nombre: '02 FORMULARIO DE EVALUACION DEL EDTP (CON FIRMAS Y  V°B°)'
	          }, {
	            codigo: 'ficha_tecnica',
	            nombre: '03 FICHA TECNCIA DEL PROYECTO (CON FIRMAS)'
	          }, {
	            codigo: 'Acta_verificacion_campo_fdi',
	            nombre: '04 INFORME Y ACTA DE VERIFICACION DE CAMPO - FDI. (CON FIRMAS Y V°B°)'
	          }, {
	            codigo: 'verificacion_criterios_elegibilidad',
	            nombre: '05 VERIFICACION DE CUMPLIMIENTO DE CRITERIOS DE ELEGIBILIDAD'
	          }, {
	            codigo: 'acta_aprobacion_socioeconomica',
	            nombre: '06 ACTA DE APROBACION PARTE SOCIOECONOMICA'
	          }, {
	            codigo: 'carta_solicitud_financiamiento',
	            nombre: '07 CARTA DE PRESENTACION Y SOLICITUD DE FINANCIAMIENTO'
	          }, {
	            codigo: 'informe_tecnico_condiciones_previas',
	            nombre: '08 INFORME TECNICO DE CONDICIONES PREVIAS ITCP'
	          }, {
	            codigo: 'ficha_tecnica_gam',
	            nombre: '09 FICHA TECNICA DEL GAM'
	          }, {
	            codigo: 'marco_logico',
	            nombre: '10 MARCO LOGICO DEL PROYECTO'
	          }, {
	            codigo: 'cronograma_ejecucion_proyecto',
	            nombre: '11 CRONOGRAMA DE EJECUCION DEL PROYECTO'
	          }, {
	            codigo: 'lista_beneficiarios',
	            nombre: '12 LISTA DE BENEFICIARIOS POR FAMILIA CON CEDULA DE IDENTIDAD Y FIRMA (PARA PUENTES LISTA DE COMUNIDAD)'
	          }, {
	            codigo: 'Acta_compromiso_cumplimiento',
	            nombre: '13 ACTA DE COMPROMISO DE CUMPLIMIENTO DE CONTRAPARTES'
	          }, {
	            codigo: 'Acta_verificacion_campo_gam_gaioc',
	            nombre: '14 ACTA DE VERIFICACION DE CAMPO DEL GAM O GAIOC'
	          }, {
	            codigo: 'acta_aprobacion__edtp_gam',
	            nombre: '15 ACTA DE APROBACION DEL EDTP ELABORADO POR EL GAM / GAIOC'
	          }, {
	            codigo: 'acta_consenso_proyecto',
	            nombre: '16 ACTA DE CONSENSO DE PRIORIZACIÓN DEL PROGRAMA O PROYECTO'
	          }, {
	            codigo: 'ddjj_proyecto_no_afecta_tierras_fiscales',
	            nombre: '17 DDJJ NOTARIADA QUE ESTABLEZCA QUE EL PROYECTO NO AFECTA A TIERRAS FISCALES'
	          }, {
	            codigo: 'certificacion_sedcam',
	            nombre: '18 CERTIFICACION DEL SEDCAM EN LA JURIDICCION DEL TRAMO (SOLO PUENTES VEHICULARES)'
	          }, {
	            codigo: 'formulacion_aprobado',
	            nombre: '19 FORMULARIO SUSCRITO POR LOS PROFESIONALES RESPONSABLES DE LA ELABORACION Y APROBACION DEL EDTP DEL PROYECTO'
	          }];
	        }
	      }
	      if (!this.proyecto || !this.proyecto.id_proyecto) return;
	      if (!this.proyecto.archivo_adjunto) this.proyecto.archivo_adjunto = [];
	      for (var i = 0; i < this.tipos_documentos.length; i++) {
	        this.proyecto.archivo_adjunto.push({
	          datos: {
	            titulo: this.tipos_documentos[i].nombre,
	            descripcion: null,
	            rol: {
	              nombre: this.Usuarios.usuario.rol.nombre,
	              descripcion: this.Usuarios.usuario.rol.descripcion
	            },
	            codigo_estado: this.proyecto.estado_actual.codigo
	          }
	        });
	      }
	    }
	  }, {
	    key: 'eliminarArchivoAdjunto',
	    value: function eliminarArchivoAdjunto(archivo, index) {
	      var _this4 = this;
	
	      var eliminado = false;
	      var i = 0;
	      if (!archivo.datos.id_archivo_adjunto) {
	        // para eliminar elemento sin adjunto
	        this.proyecto.archivo_adjunto.splice(index, 1);
	        return;
	      }
	      this.Modal.confirm('\xBFEst\xE1 seguro de eliminar por completo el archivo?', function () {
	        while (!eliminado && _this4.proyecto.archivo_adjunto[i]) {
	          if (_this4.proyecto.archivo_adjunto[i].datos.titulo == archivo.datos.titulo) {
	            archivo.datos.p = 'delete';
	            _this4.DataService.put('proyectos/' + _this4.proyecto.id_proyecto + '/archivo_adjunto/' + archivo.datos.id_archivo_adjunto, archivo.datos).then(function (doc) {
	              if (doc && doc.finalizado) {
	                _this4.proyecto.archivo_adjunto.splice(i, 1);
	              }
	            });
	            eliminado = true;
	            break;
	          }
	          i++;
	        }
	      }, null, 'Eliminar archivo', 'Sí, estoy seguro/a');
	    }
	  }]);
	
	  return ArchivoAdjunto;
	}();
	
	exports.default = ArchivoAdjunto;

/***/ }),
/* 539 */
[856, 540, 801],
/* 540 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AsignacionResponsable = function () {
	  AsignacionResponsable.$inject = ["DataService", "Util", "Proyecto"];
	  function AsignacionResponsable(DataService, Util, Proyecto) {
	    'ngInject';
	
	    _classCallCheck(this, AsignacionResponsable);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	  }
	
	  _createClass(AsignacionResponsable, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/usuarios').then(function (response) {
	        if (response) {
	          _this.usuariosParaAsignar = [];
	          for (var i in response.datos) {
	            if (_this.proyecto.estado_proyecto == 'ASIGNACION_TECNICO_CIERRE_FDI' && response.datos[i].id_rol == 22) {
	              response.datos[i].nombre = '' + response.datos[i].nombre + (response.datos[i].rol_nombre ? ' (' + response.datos[i].rol_nombre + ')' : '');
	
	              //response.datos[i].nombre = `${response.datos[i].nombre}` + (response.datos[i].rol_nombre? ` (${response.datos[i].rol_nombre})`:``);
	              _this.usuariosParaAsignar.push(response.datos[i]);
	            }
	            if (_this.proyecto.estado_proyecto != 'ASIGNACION_TECNICO_CIERRE_FDI' && response.datos[i].id_rol != 22) {
	              // si el proyecto no esta en el estado 'ASIGNACION_TECNICO_CIERRE_FDI' y no es usuario con rol 'TECNICO_CIERRE' ejecuta este bloque
	              response.datos[i].nombre = '' + response.datos[i].nombre + (response.datos[i].rol_nombre ? ' (' + response.datos[i].rol_nombre + ')' : '');
	              _this.usuariosParaAsignar.push(response.datos[i]);
	            }
	            if (response.datos[i].id_usuario == _this.proyecto.fid_usuario_asignado && response.datos[i].id_rol == _this.proyecto.fid_usuario_asignado_rol) {
	              _this.usuario_asignado = _this.usuariosParaAsignar[i];
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'seleccionado',
	    value: function seleccionado() {
	      this.proyecto.fid_usuario_asignado = this.usuario_asignado.id_usuario || null;
	      this.proyecto.fid_usuario_asignado_rol = this.usuario_asignado.id_rol || null;
	    }
	  }]);
	
	  return AsignacionResponsable;
	}();
	
	exports.default = AsignacionResponsable;

/***/ }),
/* 541 */
[857, 542, 802],
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _registroGamModal = __webpack_require__(543);
	
	var _registroGamModal2 = _interopRequireDefault(_registroGamModal);
	
	var _registroGamModal3 = __webpack_require__(803);
	
	var _registroGamModal4 = _interopRequireDefault(_registroGamModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AutoridadBeneficiariaController = function () {
	  AutoridadBeneficiariaController.$inject = ["Modal", "DataService", "Util", "Proyecto", "Message", "Usuarios", "$scope"];
	  function AutoridadBeneficiariaController(Modal, DataService, Util, Proyecto, Message, Usuarios, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, AutoridadBeneficiariaController);
	
	    this.Modal = Modal;
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Message = Message;
	    this.Usuarios = Usuarios;
	    this.$scope = $scope;
	  }
	
	  _createClass(AutoridadBeneficiariaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (this.Util.isEmpty(this.proyecto.autoridad_beneficiaria)) {
	        this.proyecto.autoridad_beneficiaria = {};
	        this.proyecto.cargo_autoridad_beneficiaria = 'Responsable GAM/GAIOC Aprobación Proyectos';
	      }
	      if (this.proyecto.autoridad_beneficiaria.estado === 'INACTIVO') {
	        this.proyecto.autoridad_beneficiaria.noVerificar = true;
	      }
	      if (!this.proyecto.contactos) this.proyecto.contactos = {};
	      if (!this.proyecto.contactos.datos) this.proyecto.contactos.datos = [];
	      if (!this.proyecto.contactos.datos.length) {
	        this.proyecto.contactos.datos.push({
	          cargo: 'Técnico Encargado de la Elaboración del EDTP',
	          persona: {}
	        });
	      } else {
	        this.proyecto.contactos.datos[0].cargo = 'Técnico Encargado de la Elaboración del EDTP';
	      }
	      this.esJefeRevision = this.Usuarios.esJefeRevision();
	      this.esTecnicoResponsable = this.Usuarios.esTecnicoResponsable();
	      if (this.proyecto.fid_autoridad_beneficiaria && (this.esJefeRevision || this.esTecnicoResponsable)) {
	        this.obtenerUsuarioGam();
	      }
	
	      this.$scope.$watch('$ctrl.usuarioGam.persona.correo', function () {
	        if (_this.usuarioGam && _this.usuarioGam.persona && _this.proyecto.autoridad_beneficiaria.correo !== _this.usuarioGam.persona.correo) {
	          _this.proyecto.autoridad_beneficiaria.correo = _this.usuarioGam.persona.correo;
	        }
	      });
	    }
	  }, {
	    key: 'agregarContacto',
	    value: function agregarContacto() {
	      if (!this.proyecto.contactos.datos) {
	        this.proyecto.contactos.datos = [];
	      }
	
	      this.proyecto.contactos.datos.push({
	        persona: {}
	      });
	    }
	  }, {
	    key: 'quitarContacto',
	    value: function quitarContacto(index) {
	      if (this.proyecto.contactos.datos.length > 1) {
	        this.proyecto.contactos.datos.splice(index, 1);
	      }
	    }
	  }, {
	    key: 'verificar',
	    value: function verificar(data, index) {
	      var persona = this.proyecto.autoridad_beneficiaria;
	      if (persona && persona.nombres == data.nombres && persona.primer_apellido == data.primer_apellido && persona.segundo_apellido == data.segundo_apellido && persona.numero_documento == data.numero_documento && persona.fecha_nacimiento == data.fecha_nacimiento) {
	        this.Message.warning('Ya existe una persona de contacto con los mismos nombres y número de documento.' + index);
	        this.proyecto.contactos.datos[index] = {
	          persona: {}
	        };
	        return;
	      }
	      for (var i in this.proyecto.contactos.datos) {
	        persona = this.proyecto.contactos.datos[i].persona;
	        if (i != index && persona.nombres == data.nombres && persona.primer_apellido == data.primer_apellido && persona.segundo_apellido == data.segundo_apellido && persona.numero_documento == data.numero_documento && persona.complemento == data.complemento) {
	          this.Message.warning('Ya existe una persona de contacto con los mismos nombres y número de documento.' + index);
	          this.proyecto.contactos.datos[index] = {
	            persona: {}
	          };
	          return;
	        }
	      }
	    }
	  }, {
	    key: 'puedeReenviarConfirmacion',
	    value: function puedeReenviarConfirmacion() {
	      return (this.esJefeRevision || this.esTecnicoResponsable) && this.usuarioGam && this.proyecto.estado_proyecto !== 'CERRADO_FDI';
	    }
	  }, {
	    key: 'adicionarResponsableModal',
	    value: function adicionarResponsableModal(callbackOk, callbackCancel) {
	      var adicionMiembro = this.Modal.show({
	        template: _registroGamModal4.default,
	        controller: _registroGamModal2.default,
	        data: {
	          registrar: !callbackOk
	        },
	        size: 'lg'
	      });
	      adicionMiembro.result.then(function (result) {
	        if (result) {
	          if (typeof callbackOk === 'function') {
	            callbackOk(result);
	          }
	        } else {
	          if (typeof callbackCancel === 'function') {
	            callbackCancel();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'inactivarUsuarioResponsableGam',
	    value: function inactivarUsuarioResponsableGam(usuario) {
	      var _this2 = this;
	
	      this.Modal.confirm('Esta seguro/a de inhabilitar al Responsable GAM/GAIOC?<br><br>Este usuario ya no podra ser habilitado nuevamente con el mismo cargo.<br><br>* Deber\xE1 agregar un nuevo usuario.', function () {
	        usuario.estado = 'INACTIVO';
	        _this2.adicionarResponsableModal(function (persona) {
	          _this2.DataService.put('proyectos/' + _this2.proyecto.id_proyecto + '/contactos/' + usuario.id_usuario + '/reemplazar', persona).then(function (resp) {
	            if (resp && resp.finalizado) {
	              if (resp.datos && resp.datos.autoridad_beneficiaria) {
	                var aux = resp.datos.autoridad_beneficiaria;
	                _this2.proyecto.autoridad_beneficiaria = {
	                  correo: aux.correo,
	                  fecha_nacimiento: aux.fecha_nacimiento,
	                  nombres: aux.nombres,
	                  numero_documento: aux.numero_documento,
	                  primer_apellido: aux.primer_apellido,
	                  segundo_apellido: aux.segundo_apellido,
	                  telefono: aux.telefono,
	                  tipo_documento: aux.tipo_documento
	                };
	              }
	              _this2.Message.success(resp.mensaje);
	            } else {
	              _this2.Message.warning('No se pudo realizar la inhabilitación.');
	            }
	          });
	        }, function () {
	          usuario.estado = 'ACTIVO';
	        });
	      }, null, 'Inhabilitar', 'Si estoy seguro/a', null, 'ban');
	    }
	  }, {
	    key: 'obtenerUsuarioGam',
	    value: function obtenerUsuarioGam() {
	      var _this3 = this;
	
	      this.DataService.get('usuario/persona/' + this.proyecto.fid_autoridad_beneficiaria).then(function (response) {
	        if (response) {
	          _this3.usuarioGam = response.datos;
	          _this3.urlReconfirmacion = 'proyectos/' + _this3.proyecto.id_proyecto + '/contactos/' + _this3.usuarioGam.id_usuario + '/notificar';
	        }
	      });
	    }
	  }]);
	
	  return AutoridadBeneficiariaController;
	}();
	
	exports.default = AutoridadBeneficiariaController;

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RegistroFiscalSupervisorController = function () {
	  RegistroFiscalSupervisorController.$inject = ["$uibModalInstance", "DataService", "$stateParams", "data", "_", "Message"];
	  function RegistroFiscalSupervisorController($uibModalInstance, DataService, $stateParams, data, _, Message) {
	    'ngInject';
	
	    _classCallCheck(this, RegistroFiscalSupervisorController);
	
	    this.DataService = DataService;
	    this.$stateParams = $stateParams;
	    this.data = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this._ = _;
	    this.Message = Message;
	    this.miembro = null;
	    this.miembro = this.data.miembro || {};
	    this.modoEdicion = true;
	  }
	
	  _createClass(RegistroFiscalSupervisorController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.miembro.id_usuario) {
	        this.getDatosMiembroEquipo();
	      }
	    }
	  }, {
	    key: 'getDatosMiembroEquipo',
	    value: function getDatosMiembroEquipo() {
	      var _this = this;
	
	      this.DataService.get('proyectos/' + this.miembro.fid_proyecto + '/equipos_tecnicos/' + this.miembro.id_equipo_tecnico).then(function (result) {
	        _this.miembro = result.datos;
	        angular.extend(_this.miembro, result.datos.usuario.persona);
	        delete _this.miembro.usuario;
	        _this.datosIniciales = angular.copy(_this.miembro);
	        if (_this.miembro.tipo_equipo !== 'TE_FDI' && _this.miembro.doc_designacion) {
	          var docDesignacion = _this.miembro.doc_designacion.substring(1, _this.miembro.doc_designacion.indexOf(']'));
	          _this.archivo = {
	            url: 'proyectos/' + _this.miembro.fid_proyecto + '/doc/' + docDesignacion,
	            urlDescarga: 'proyectos/' + _this.miembro.fid_proyecto + '/doc/' + docDesignacion + '/descargar'
	          };
	        }
	      });
	    }
	  }, {
	    key: 'registrar',
	    value: function registrar() {
	      // let url = `proyectos/${this.$stateParams.codigo}/contactos`;
	      // let servicio = 'post';
	      // let miembroEquipo = angular.copy(this.miembro);
	      // if (this.miembro.id_equipo_tecnico) {
	      //   url += `/${this.miembro.id_equipo_tecnico}`;
	      //   servicio = 'put';
	      // }
	      // this.DataService[servicio](url, miembroEquipo).then(result => {
	      //   if (result) {
	      //     this.Message.success(result.mensaje);
	      this.$uibModalInstance.close(this.miembro);
	      //   }
	      // });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return RegistroFiscalSupervisorController;
	}();
	
	exports.default = RegistroFiscalSupervisorController;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _datosGenerales = __webpack_require__(554);
	
	var _datosGenerales2 = _interopRequireDefault(_datosGenerales);
	
	var _datosGenerales3 = __webpack_require__(551);
	
	var _datosGenerales4 = _interopRequireDefault(_datosGenerales3);
	
	var _datosGeneralesResumen = __webpack_require__(549);
	
	var _datosGeneralesResumen2 = _interopRequireDefault(_datosGeneralesResumen);
	
	var _financiamiento = __webpack_require__(566);
	
	var _financiamiento2 = _interopRequireDefault(_financiamiento);
	
	var _convenio = __webpack_require__(547);
	
	var _convenio2 = _interopRequireDefault(_convenio);
	
	var _asignacionResponsable = __webpack_require__(539);
	
	var _asignacionResponsable2 = _interopRequireDefault(_asignacionResponsable);
	
	var _desembolso = __webpack_require__(556);
	
	var _desembolso2 = _interopRequireDefault(_desembolso);
	
	var _autoridadBeneficiaria = __webpack_require__(541);
	
	var _autoridadBeneficiaria2 = _interopRequireDefault(_autoridadBeneficiaria);
	
	var _items = __webpack_require__(571);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _ejecutarTransicion = __webpack_require__(558);
	
	var _ejecutarTransicion2 = _interopRequireDefault(_ejecutarTransicion);
	
	var _equipoTecnico = __webpack_require__(561);
	
	var _equipoTecnico2 = _interopRequireDefault(_equipoTecnico);
	
	var _ordenProceder = __webpack_require__(578);
	
	var _ordenProceder2 = _interopRequireDefault(_ordenProceder);
	
	var _recepcionDefinitiva = __webpack_require__(580);
	
	var _recepcionDefinitiva2 = _interopRequireDefault(_recepcionDefinitiva);
	
	var _evaluacion = __webpack_require__(564);
	
	var _evaluacion2 = _interopRequireDefault(_evaluacion);
	
	var _informe = __webpack_require__(568);
	
	var _informe2 = _interopRequireDefault(_informe);
	
	var _archivo_adjunto = __webpack_require__(537);
	
	var _archivo_adjunto2 = _interopRequireDefault(_archivo_adjunto);
	
	var _seguimiento = __webpack_require__(582);
	
	var _seguimiento2 = _interopRequireDefault(_seguimiento);
	
	var _listaCierre = __webpack_require__(576);
	
	var _listaCierre2 = _interopRequireDefault(_listaCierre);
	
	var _cierre = __webpack_require__(545);
	
	var _cierre2 = _interopRequireDefault(_cierre);
	
	var _ampliacion = __webpack_require__(535);
	
	var _ampliacion2 = _interopRequireDefault(_ampliacion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Dbc from './dbc/dbc.component';
	// import Garantia from './garantia/garantia.component';
	// import BoletaGarantia from './boleta-garantia/boleta-garantia.component';
	// import Boleta from './boleta-garantia/boleta/boleta.component';
	var ComponentsProyectos = angular.module('app.rcforms', []).component('regDatosGenerales', _datosGenerales2.default).component('regDatosGeneralesExtra', _datosGenerales4.default).component('regDatosGeneralesExtraResumen', _datosGeneralesResumen2.default).component('regFinanciamiento', _financiamiento2.default).component('regConvenio', _convenio2.default).component('regAsignacionResponsable', _asignacionResponsable2.default).component('regDesembolso', _desembolso2.default).component('regAutoridadBeneficiaria', _autoridadBeneficiaria2.default).component('regItems', _items2.default).component('ejecutarTransicion', _ejecutarTransicion2.default)
	// .component('dbc', Dbc)
	// .component('garantia', Garantia)
	// .component('boletaGarantia', BoletaGarantia)
	// .component('boleta', Boleta)
	.component('regSeguimiento', _seguimiento2.default).component('regListaCierre', _listaCierre2.default).component('regCierre', _cierre2.default).component('regAmpliacion', _ampliacion2.default).component('equipoTecnico', _equipoTecnico2.default).component('regOrdenProceder', _ordenProceder2.default).component('regRecepcionDefinitiva', _recepcionDefinitiva2.default).component('regEvaluacion', _evaluacion2.default).component('regInformeEval', _informe2.default).component('regArchivoAdjunto', _archivo_adjunto2.default).name;
	
	exports.default = ComponentsProyectos;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _cierre = __webpack_require__(546);
	
	var _cierre2 = _interopRequireDefault(_cierre);
	
	var _cierre3 = __webpack_require__(804);
	
	var _cierre4 = _interopRequireDefault(_cierre3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cierre = {
		bindings: {
			proyecto: '=',
			modoVista: '<'
		},
		controller: _cierre2.default,
		template: _cierre4.default
	};
	
	exports.default = cierre;

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CierreController = function () {
		CierreController.$inject = ["helpLang", "Usuarios", "Proyecto", "DataService", "Message", "Storage", "Modal"];
		function CierreController(helpLang, Usuarios, Proyecto, DataService, Message, Storage, Modal) {
			'ngInject';
	
			_classCallCheck(this, CierreController);
	
			this.helpLang = helpLang;
			this.Usuarios = Usuarios;
			this.Proyecto = Proyecto;
			this.DataService = DataService;
			this.Message = Message;
			this.Storage = Storage;
			this.Modal = Modal;
		}
	
		_createClass(CierreController, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.items = [{ value: 1, text: 'Cierre' }];
				this.mensajeAyuda = 'Hola mundo!...';
				this.usuario = this.Storage.getUser();
	
				setTimeout(function () {
					// por defecto se asignara la fecha del ultimo desembolso
					// this.proyecto.cierre.fecha_inicio = this.proyecto.cronograma_desembolsos.fecha_3;
					_this.archivos = {
						urlDocIT: _this.proyecto ? 'proyectos/' + _this.proyecto.id_proyecto + '/doc/IT' : '',
						urlDocITDescarga: _this.proyecto ? 'proyectos/' + _this.proyecto.id_proyecto + '/doc/IT/descargar' : ''
					};
					_this.DataService.get('proyectos/' + _this.proyecto.id_proyecto + '/usuarios').then(function (response) {
						if (response) {
							_this.usuariosParaAsignar = [];
							for (var i in response.datos) {
								response.datos[i].nom = response.datos[i].nombre.split("(")[0];
								_this.usuariosParaAsignar.push(response.datos[i]);
	
								// if (response.datos[i].id_usuario==this.proyecto.fid_usuario_asignado && response.datos[i].id_rol==this.proyecto.fid_usuario_asignado_rol) {
								// 	this.usuario_asignado = this.usuariosParaAsignar[i];
								// }
							}
						}
					});
					_this.calcularPlazos();
				}, 2000);
			}
		}, {
			key: 'addIc',
			value: function addIc(value) {
	
				if (!value) {
					value = [];
				}
				for (var i in value) {
					// console.log(value[i].id_avance_fisico,"<<")
					if (!value[i].id_inspeccion_campo || value[i].edicion) {
						// console.log(value[i].id_avance_fisico, value[i].edicion)
						this.Message.warning('Debe guardar el registro antes de crear otro');
						return;
					}
				}
				value.push({ edicion: true });
			}
		}, {
			key: 'eliminarInspeccion',
			value: function eliminarInspeccion(value, index) {
				// Elimina la inspeccion de campo
				if (!value.id_inspeccion_campo) {
					this.proyecto.cierre.inspeccion_campo.splice(index, 1);
					return;
				}
			}
		}, {
			key: 'guardarInspeccion',
			value: function guardarInspeccion(value, index) {
				var _this2 = this;
	
				// Guardar inspeccion de campo
				value.objeto_id = this.proyecto.cierre.id_cierre;
				value.id_proyecto = this.proyecto.id_proyecto;
				value.cant_inspec = this.proyecto.cierre.inspeccion_campo.length;
				value.tipo_inspeccion = 'cierre';
				if (!this.sonDatosValidosInspeccion(index)) {
					return;
				}
				this.DataService.post('proyectos/inspeccion', value).then(function (response) {
					if (response) {
						// console.log(response)
						value.id_inspeccion_campo = response.datos.id_inspeccion_campo;
						value.fecha = response.datos.fecha;
						value.doc_informe = response.datos.doc_informe;
						value.detalle = response.datos.detalle;
						value.tecnico_inspeccion = response.datos.tecnico_inspeccion;
						_this2.Message.success("guardado correctamente.");
					}
				});
				value.edicion = false;
			}
		}, {
			key: 'obtenerInspeccion',
			value: function obtenerInspeccion(value) {
				if (!value) {
					this.Message.warning('No se encontro el documento');
					return;
				}
				var exreg = /\[(.*?)\]\s*(.*)/;
				var codigo = value.split(exreg)[1];
				this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/' + codigo, value);
			}
		}, {
			key: 'guardarDatosCierre',
			value: function guardarDatosCierre() {
				var _this3 = this;
	
				// console.log(this.proyecto)
	
				// this.datos = {
				// 	fid_proyecto: this.proyecto.id_proyecto,
				// 	plazo_cierre: this.proyecto.cierre.plazo_cierre,
				// 	_usuario_creacion: this.usuario.id_usuario
				// };
	
				this.DataService.post('proyectos/cie', this.proyecto).then(function (response) {
					if (response) {
						_this3.Message.success("Proyecto actualizado correctamente.");
						//this.proyecto.seguimiento = response.datos
						// console.log("datos recibidos despues de guardar: ",this.proyecto)
	
						_this3.Loading.hide();
						//this.$state.reload();			
					}
				});
			}
		}, {
			key: 'sonDatosValidosInspeccion',
			value: function sonDatosValidosInspeccion(posicion) {
				// Validar avance fisico
	
				var FORM = angular.element(document.querySelector('[name=form_inspeccion_c')).scope()['form_inspeccion_c'];
	
				var esValido = FORM['fecha_inspeccion_' + posicion].$valid && FORM['listaTecnico_' + posicion].$valid && FORM['detalle_inf_' + posicion].$valid;
	
				if (!esValido) {
	
					FORM['fecha_inspeccion_' + posicion].$setTouched();
					FORM['listaTecnico_' + posicion].$setTouched();
					FORM['detalle_inf_' + posicion].$setTouched();
	
					this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
					return false;
				}
				return true;
			}
	
			// funcion para calcular plazos en la etapa de cierre
	
		}, {
			key: 'calcularPlazos',
			value: function calcularPlazos() {
				// console.log("SE EJECUTA LA FUNCION CALCULAR PLAZOS")
				this.plazo_cierre = new Date(this.proyecto.cierre.fecha_inicio);
				this.plazo_cierre.setDate(this.plazo_cierre.getDate() + parseInt(this.proyecto.cierre.plazo_cierre));
				this.plazo_cierre = this.plazo_cierre.toISOString();
			}
		}]);
	
		return CierreController;
	}();
	
	exports.default = CierreController;

/***/ }),
/* 547 */
[858, 548, 805],
/* 548 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosGenerales = function () {
	  DatosGenerales.$inject = ["$scope", "Util", "Proyecto", "Modal", "_", "DataService", "Message", "$http", "subDomain", "baseUrl"];
	  function DatosGenerales($scope, Util, Proyecto, Modal, _, DataService, Message, $http, subDomain, baseUrl) {
	    'ngInject';
	
	    _classCallCheck(this, DatosGenerales);
	
	    this.$http = $http;
	    this.$scope = $scope;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this._ = _;
	    this.archivos = null;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.qrimage = null;
	    this.subDomain = subDomain;
	    this.baseUrl = baseUrl;
	  }
	
	  _createClass(DatosGenerales, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.tipos_plazo_ampliado = [{
	        codigo: 'Convenio modificatorio',
	        nombre: 'Convenio modificatorio'
	      }, {
	        codigo: 'Adenda al convenio',
	        nombre: 'Adenda al convenio'
	      }];
	      // console.log(this.proyecto)
	      this.generar();
	      //this.opciones_plazo_administrativo = [{codigo:240,nombre:'240 días (8 meses)'},{codigo:255,nombre:'255 días (8 1/2 meses)'}];
	      if (!this.proyecto.convenio) this.proyecto.convenio = {};
	      this.proyecto.convenio.plazo_tiempo_administrativo = this.proyecto.financiamiento.plazo_tiempo_administrativo.codigo;
	      this.proyecto.convenio.plazo_convenio_ampliado = this.proyecto.convenio.plazo_convenio_ampliado || 0;
	
	      this.$scope.$watch('$ctrl.proyecto.convenio.plazo_tiempo_administrativo', function () {
	        if (_this.proyecto.convenio.plazo_tiempo_administrativo) {
	          _this.proyecto.convenio.plazo_convenio = _this.proyecto.plazo_ejecucion + _this.proyecto.convenio.plazo_tiempo_administrativo;
	        }
	      });
	
	      this.archivos = {
	        urlDocConvenio: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/C' : '',
	        urlDocConvenioDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/C/descargar' : '',
	        urlDocConvenioExtendido: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT' : '',
	        urlDocConvenioExtendidoDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT/descargar' : '',
	        urlDocConvenioExtendido2: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT2' : '',
	        urlDocConvenioExtendidoDescarga2: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT2/descargar' : '',
	        urlDocConvenioExtendido3: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT3' : '',
	        urlDocConvenioExtendidoDescarga3: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT3/descargar' : '',
	        urlDocConvenioExtendido4: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT4' : '',
	        urlDocConvenioExtendidoDescarga4: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT4/descargar' : '',
	        urlDocConvenioExtendido5: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT5' : '',
	        urlDocConvenioExtendidoDescarga5: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT5/descargar' : '',
	        urlDocConvenioExtendido6: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT6' : '',
	        urlDocConvenioExtendidoDescarga6: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT6/descargar' : '',
	        urlDocConvenioExtendido7: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT7' : '',
	        urlDocConvenioExtendidoDescarga7: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT7/descargar' : '',
	        urlDocConvenioExtendido8: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT8' : '',
	        urlDocConvenioExtendidoDescarga8: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT8/descargar' : '',
	        urlDocConvenioExtendido9: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT9' : '',
	        urlDocConvenioExtendidoDescarga9: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT9/descargar' : '',
	        urlDocConvenioExtendido10: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT10' : '',
	        urlDocConvenioExtendidoDescarga10: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT10/descargar' : '',
	        urlDocConvenioExtendido11: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT11' : '',
	        urlDocConvenioExtendidoDescarga11: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT11/descargar' : '',
	        urlDocConvenioExtendido12: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT12' : '',
	        urlDocConvenioExtendidoDescarga12: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT12/descargar' : '',
	        urlDocConvenioExtendido13: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT13' : '',
	        urlDocConvenioExtendidoDescarga13: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT13/descargar' : '',
	        urlDocConvenioExtendido14: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT14' : '',
	        urlDocConvenioExtendidoDescarga14: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CXT14/descargar' : '',
	        urlDocResolucion: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/RM' : '',
	        urlDocResolucionDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/RM/descargar' : ''
	      };
	
	      if (this.proyecto.orden_proceder) {
	        this.diaActual = new Date();
	        this.plazo_convenio0 = new Date(this.proyecto.orden_proceder);
	        this.plazo_con_ampliaciones = new Date(this.proyecto.orden_proceder);
	
	        this.plazo_amp1 = this.proyecto.convenio.plazo_convenio_ampliado ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado) : 0;
	        this.plazo_amp2 = this.proyecto.convenio.plazo_convenio_ampliado2 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado2) : 0;
	        this.plazo_amp3 = this.proyecto.convenio.plazo_convenio_ampliado3 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado3) : 0;
	        this.plazo_amp4 = this.proyecto.convenio.plazo_convenio_ampliado4 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado4) : 0;
	        this.plazo_amp5 = this.proyecto.convenio.plazo_convenio_ampliado5 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado5) : 0;
	        this.plazo_amp6 = this.proyecto.convenio.plazo_convenio_ampliado6 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado6) : 0;
	        this.plazo_amp7 = this.proyecto.convenio.plazo_convenio_ampliado7 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado7) : 0;
	        this.plazo_amp8 = this.proyecto.convenio.plazo_convenio_ampliado8 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado8) : 0;
	        this.plazo_amp9 = this.proyecto.convenio.plazo_convenio_ampliado9 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado9) : 0;
	        this.plazo_amp10 = this.proyecto.convenio.plazo_convenio_ampliado10 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado10) : 0;
	        this.plazo_amp11 = this.proyecto.convenio.plazo_convenio_ampliado11 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado11) : 0;
	        this.plazo_amp12 = this.proyecto.convenio.plazo_convenio_ampliado12 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado12) : 0;
	        this.plazo_amp13 = this.proyecto.convenio.plazo_convenio_ampliado13 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado13) : 0;
	        this.plazo_amp14 = this.proyecto.convenio.plazo_convenio_ampliado14 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado14) : 0;
	        // console.log(this.plazo_convenio0,'this.plazo_convenio0')
	        // console.log(this.proyecto.plazo_ejecucion,'convenio plazoo')
	        //  console.log(this.plazo_convenio.get(), 'getDate')
	        // console.log(this.plazo_convenio0.getDate()+' + '+ parseInt(this.proyecto.convenio.plazo))
	        this.plazo_convenio0.setDate(this.plazo_convenio0.getDate() + parseInt(this.proyecto.plazo_ejecucion));
	        this.plazo_con_ampliaciones.setDate(this.plazo_con_ampliaciones.getDate() + parseInt(this.proyecto.plazo_ejecucion) + this.plazo_amp1 + this.plazo_amp2 + this.plazo_amp3 + this.plazo_amp4 + this.plazo_amp5 + this.plazo_amp6 + this.plazo_amp7 + this.plazo_amp8 + this.plazo_amp9 + this.plazo_amp10 + this.plazo_amp11 + this.plazo_amp12 + this.plazo_amp13 + this.plazo_amp14);
	        // console.log('firestoneeeeee ', this.plazo_convenio0)
	        // this.fechaAlerta = new Date(this.plazo_convenio0);
	        // this.fechaAlerta.setDate(this.fechaAlerta.getDate() - 30)
	
	        // if(this.diaActual < this.fechaAlerta){
	
	        //   this.Modal.alert('Plazo Convenio Vigente hasta: ' + new Date(this.plazo_convenio0))
	        // }else{
	        //   if(this.diaActual < new Date(this.plazo_convenio0)){
	        //     this.Modal.alert('Faltan menos de 30 días para el vencimiento del plazo convenio:  '+ new Date(this.plazo_convenio0))
	        //   }else{
	        //     this.Modal.alert('Se ha vencido el plazo convenio el : ' + new Date(this.plazo_convenio0))
	        //   }       
	        // }
	        // console.log(this.plazo_convenio0,"plazo_convenio0")
	        // console.log(this.plazo_con_ampliaciones," plazo con ampliaciones")
	        if (this.plazo_amp1) {
	          this.diasRestantes = Math.floor((this.plazo_con_ampliaciones - this.diaActual) / (1000 * 60 * 60 * 24));
	        } else {
	          this.diasRestantes = Math.floor((this.plazo_convenio0 - this.diaActual) / (1000 * 60 * 60 * 24));
	        }
	
	        //this.Modal.alert('dias restantes sin ampliacion'+ this.diasRestantes) 
	
	
	        if (this.diasRestantes > 0) {
	          this.Modal.alert('Falta ' + this.diasRestantes + ' días para el vencimiento del plazo convenio ');
	        } else {
	          if (this.diaActual > this.plazo_con_ampliaciones) {
	            this.Modal.alert('Se ha vencido el plazo convenio el : ' + new Date(this.plazo_con_ampliaciones));
	          } else {
	            this.Modal.alert('El plazo de convenio vence hoy: ' + new Date(this.plazo_con_ampliaciones));
	          }
	        }
	
	        this.plazo_convenio0 = this.plazo_convenio0.toISOString();
	      } else {
	        this.plazo_convenio0 = null;
	      }
	      this.mostrar = true;
	      this.recalcularPlazoConvenio1();
	      this.recalcularPlazoConvenio2();
	      this.recalcularPlazoConvenio3();
	      this.recalcularPlazoConvenio4();
	      this.recalcularPlazoConvenio5();
	      this.recalcularPlazoConvenio6();
	      this.recalcularPlazoConvenio7();
	      this.recalcularPlazoConvenio8();
	      this.recalcularPlazoConvenio9();
	      this.recalcularPlazoConvenio10();
	      this.recalcularPlazoConvenio11();
	      this.recalcularPlazoConvenio12();
	      this.recalcularPlazoConvenio13();
	      this.recalcularPlazoConvenio14();
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.proyecto.monto_fdi', function () {
	        if (!_this2.proyecto) {
	          return;
	        }
	        _this2.calcularMontoConvenio();
	      });
	      this.$scope.$watch('$ctrl.proyecto.monto_contraparte', function () {
	        if (!_this2.proyecto) {
	          return;
	        }
	        _this2.calcularMontoConvenio();
	      });
	    }
	  }, {
	    key: 'calcularMontoConvenio',
	    value: function calcularMontoConvenio() {
	      this.proyecto.monto_total_convenio = this.Util.redondear((this.proyecto.monto_fdi ? this.proyecto.monto_fdi : 0) + (this.proyecto.monto_contraparte ? this.proyecto.monto_contraparte : 0));
	    }
	  }, {
	    key: 'recalcularPlazoConvenio1',
	    value: function recalcularPlazoConvenio1() {
	      if (this.plazo_convenio0) {
	        this.plazo_convenio1 = new Date(this.plazo_convenio0);
	        this.plazo_convenio1.setDate(this.plazo_convenio1.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado));
	        this.plazo_convenio1 = this.plazo_convenio1.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio2',
	    value: function recalcularPlazoConvenio2() {
	      if (this.plazo_convenio1 && this.proyecto.convenio.plazo_convenio_ampliado2 >= 0) {
	        this.plazo_convenio2 = new Date(this.plazo_convenio1);
	        this.plazo_convenio2.setDate(this.plazo_convenio2.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado2));
	        this.plazo_convenio2 = this.plazo_convenio2.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio3',
	    value: function recalcularPlazoConvenio3() {
	      if (this.plazo_convenio2 && this.proyecto.convenio.plazo_convenio_ampliado3 >= 0) {
	        this.plazo_convenio3 = new Date(this.plazo_convenio2);
	        this.plazo_convenio3.setDate(this.plazo_convenio3.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado3));
	        this.plazo_convenio3 = this.plazo_convenio3.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio4',
	    value: function recalcularPlazoConvenio4() {
	      if (this.plazo_convenio3 && this.proyecto.convenio.plazo_convenio_ampliado4 >= 0) {
	        this.plazo_convenio4 = new Date(this.plazo_convenio3);
	        this.plazo_convenio4.setDate(this.plazo_convenio4.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado4));
	        this.plazo_convenio4 = this.plazo_convenio4.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio5',
	    value: function recalcularPlazoConvenio5() {
	      if (this.plazo_convenio4 && this.proyecto.convenio.plazo_convenio_ampliado5 >= 0) {
	        this.plazo_convenio5 = new Date(this.plazo_convenio4);
	        this.plazo_convenio5.setDate(this.plazo_convenio5.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado5));
	        this.plazo_convenio5 = this.plazo_convenio5.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio6',
	    value: function recalcularPlazoConvenio6() {
	      if (this.plazo_convenio5 && this.proyecto.convenio.plazo_convenio_ampliado6 >= 0) {
	        this.plazo_convenio6 = new Date(this.plazo_convenio5);
	        this.plazo_convenio6.setDate(this.plazo_convenio6.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado6));
	        this.plazo_convenio6 = this.plazo_convenio6.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio7',
	    value: function recalcularPlazoConvenio7() {
	      if (this.plazo_convenio6 && this.proyecto.convenio.plazo_convenio_ampliado7 >= 0) {
	        this.plazo_convenio7 = new Date(this.plazo_convenio6);
	        this.plazo_convenio7.setDate(this.plazo_convenio7.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado7));
	        this.plazo_convenio7 = this.plazo_convenio7.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio8',
	    value: function recalcularPlazoConvenio8() {
	      if (this.plazo_convenio7 && this.proyecto.convenio.plazo_convenio_ampliado8 >= 0) {
	        this.plazo_convenio8 = new Date(this.plazo_convenio7);
	        this.plazo_convenio8.setDate(this.plazo_convenio8.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado8));
	        this.plazo_convenio8 = this.plazo_convenio8.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio9',
	    value: function recalcularPlazoConvenio9() {
	      if (this.plazo_convenio8 && this.proyecto.convenio.plazo_convenio_ampliado9 >= 0) {
	        this.plazo_convenio9 = new Date(this.plazo_convenio8);
	        this.plazo_convenio9.setDate(this.plazo_convenio9.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado9));
	        this.plazo_convenio9 = this.plazo_convenio9.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio10',
	    value: function recalcularPlazoConvenio10() {
	      if (this.plazo_convenio9 && this.proyecto.convenio.plazo_convenio_ampliado10 >= 0) {
	        this.plazo_convenio10 = new Date(this.plazo_convenio9);
	        this.plazo_convenio10.setDate(this.plazo_convenio10.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado10));
	        this.plazo_convenio10 = this.plazo_convenio10.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio11',
	    value: function recalcularPlazoConvenio11() {
	      if (this.plazo_convenio10 && this.proyecto.convenio.plazo_convenio_ampliado11 >= 0) {
	        this.plazo_convenio11 = new Date(this.plazo_convenio10);
	        this.plazo_convenio11.setDate(this.plazo_convenio11.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado11));
	        this.plazo_convenio11 = this.plazo_convenio11.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio12',
	    value: function recalcularPlazoConvenio12() {
	      if (this.plazo_convenio11 && this.proyecto.convenio.plazo_convenio_ampliado12 >= 0) {
	        this.plazo_convenio12 = new Date(this.plazo_convenio11);
	        this.plazo_convenio12.setDate(this.plazo_convenio12.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado12));
	        this.plazo_convenio12 = this.plazo_convenio12.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio13',
	    value: function recalcularPlazoConvenio13() {
	      if (this.plazo_convenio12 && this.proyecto.convenio.plazo_convenio_ampliado13 >= 0) {
	        this.plazo_convenio13 = new Date(this.plazo_convenio12);
	        this.plazo_convenio13.setDate(this.plazo_convenio13.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado13));
	        this.plazo_convenio13 = this.plazo_convenio13.toISOString();
	      }
	    }
	  }, {
	    key: 'recalcularPlazoConvenio14',
	    value: function recalcularPlazoConvenio14() {
	      if (this.plazo_convenio13 && this.proyecto.convenio.plazo_convenio_ampliado14 >= 0) {
	        this.plazo_convenio14 = new Date(this.plazo_convenio13);
	        this.plazo_convenio14.setDate(this.plazo_convenio14.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado14));
	        this.plazo_convenio14 = this.plazo_convenio14.toISOString();
	      }
	    }
	  }, {
	    key: 'generar',
	    value: function generar() {
	      var _this3 = this;
	
	      console.log(window.location.origin + this.subDomain + '#!/consultasqr/' + this.proyecto.codigo);
	      var datos = {
	        url: window.location.origin + this.subDomain + '#!/consultasqr/' + this.proyecto.codigo
	      };
	      console.log("datos", datos);
	      this.$http({
	        method: 'POST',
	        url: this.baseUrl + 'proyect/scan',
	        data: datos
	      }).then(function (response) {
	        _this3.qrimage = response.data.datos;
	        // console.log(response.data.datos)
	      });
	      /*this.DataService.post(`proyect/scan`,datos)
	        .then(response=>{
	          if(response){
	            this.Message.success('QR Generado Correctamente...')
	          }
	        })*/
	    }
	  }]);
	
	  return DatosGenerales;
	}();
	
	exports.default = DatosGenerales;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datosGeneralesResumen = __webpack_require__(550);
	
	var _datosGeneralesResumen2 = _interopRequireDefault(_datosGeneralesResumen);
	
	var _datosGeneralesResumen3 = __webpack_require__(806);
	
	var _datosGeneralesResumen4 = _interopRequireDefault(_datosGeneralesResumen3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosGenerales = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _datosGeneralesResumen2.default,
	  template: _datosGeneralesResumen4.default
	};
	
	exports.default = DatosGenerales;

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosGenerales = function () {
	  DatosGenerales.$inject = ["DataService", "Util", "Proyecto", "Modal", "$scope", "urm2lat", "Usuarios", "leafletData"];
	  function DatosGenerales(DataService, Util, Proyecto, Modal, $scope, urm2lat, Usuarios, leafletData) {
	    'ngInject';
	
	    _classCallCheck(this, DatosGenerales);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.$scope = $scope;
	    this.urm2lat = urm2lat;
	    this.Usuarios = Usuarios;
	    this.leafletData = leafletData;
	    this.showMap = false;
	  }
	
	  _createClass(DatosGenerales, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.$watch("$ctrl.showMap", function () {
	        _this.leafletData.getMap().then(function (map) {
	          setTimeout(function () {
	            map.invalidateSize();
	          }, 3000);
	        });
	      });
	
	      this.lista_comunidades = "";
	      this.ver_comunidades = true;
	      this.$$iniciarLeaflet();
	      this.showMap = true;
	      this.sectorProductivo = [];
	      this.seleccion_unidades = [];
	      this.subtipos = 'inicio';
	
	      this.$scope.$watch('$ctrl.proyecto.beneficiarios.tipo', function () {
	        if (_this.proyecto.beneficiarios.tipo != 'OP_TP_PRODUCTIVO') {
	          _this.seleccion_unidades = [];
	          _this.limpiarMatriz();
	        }
	      });
	
	      if (typeof this.proyecto.beneficiarios.indicadores_impacto === 'string') {
	        this.proyecto.beneficiarios.indicadores_impacto = [{
	          combinado: this.proyecto.beneficiarios.indicadores_impacto,
	          numero: this.proyecto.beneficiarios.indicadores_impacto_numero,
	          unidades: this.proyecto.beneficiarios.indicadores_impacto_unidades,
	          otro: this.proyecto.beneficiarios.indicadores_impacto_otro
	        }];
	      }
	
	      this.$scope.$watch('$ctrl.proyecto.beneficiarios.subtipo_productivo', function () {
	        switch (_this.proyecto.beneficiarios.subtipo_productivo) {
	          case 'ST_PROD_AGRICOLA':
	          case 'ST_PROD_PISCICOLA':
	          case 'ST_PROD_APICULTURA':
	            _this.seleccion_unidades = [{ codigo: 't', nombre: 't' }];
	            break;
	          case 'ST_PROD_MAQUINARIA':
	            _this.seleccion_unidades = [{ codigo: 'HA', nombre: 'HA' }]; //otros
	            break;
	          case 'ST_PROD_BOVINO':
	          case 'ST_PROD_CAMELIDOS':
	          case 'ST_PROD_GANADO_MENOR':
	            _this.seleccion_unidades = [{ codigo: 'cabezas', nombre: 'cabezas' }];
	            break;
	          case 'ST_PROD_TRANSFORMACION':
	            //this.seleccion_unidades = [{codigo:'T',nombre:'T'},{codigo:'l',nombre:'l'},{codigo:'Otro',nombre:'Otro'}];
	            _this.seleccion_unidades = [{ codigo: 't', nombre: 't' }, { codigo: 'l', nombre: 'l' }]; //otros
	            break;
	          case 'ST_PROD_AVICOLA':
	            _this.seleccion_unidades = [{ codigo: 'aves', nombre: 'aves' }];
	            break;
	          case 'ST_PROD_INFRAESTRUCTURA':
	            _this.seleccion_unidades = [{ codigo: 'unidades', nombre: 'unidades' }];
	            break;
	          case 'ST_PROD_LACTEOS':
	            _this.seleccion_unidades = [{ codigo: 'l', nombre: 'l' }];
	            break;
	          default:
	            break;
	        }
	        _this.seleccion_unidades.push({ codigo: 'Otro', nombre: 'Otro' });
	
	        // if (this.seleccion_unidades.length === 1 && this.proyecto.beneficiarios.tipo === 'OP_TP_PRODUCTIVO') {
	        //   this.proyecto.beneficiarios.indicadores_impacto_unidades = [];
	        //   this.proyecto.beneficiarios.indicadores_impacto_unidades.push(this.seleccion_unidades[0].codigo);
	        // }
	        // if (this.seleccion_unidades.length > 1 && this.proyecto.beneficiarios.tipo === 'OP_TP_PRODUCTIVO') {
	        //   this.proyecto.beneficiarios.indicadores_impacto_unidades = [];
	        //   this.proyecto.beneficiarios.indicadores_impacto_unidades.push(this.seleccion_unidades[0]);
	        // }
	
	        // NUEVO CUADRO SEGUN SUBTIPO
	        if (_this.proyecto.beneficiarios.subtipo_productivo) {
	          _this.DataService.get('contenidos/' + _this.proyecto.beneficiarios.subtipo_productivo + '/1').then(function (response) {
	            if (response) {
	              if (response.datos && response.datos.estructura) {
	                if (_this.subtipos != 'inicio') {
	                  _this.limpiarMatriz();
	                } else {
	                  _this.subtipos = '';
	                }
	
	                _this.sectorProductivo = response.datos.estructura.reduce(function (a, b) {
	                  var temp = b;
	                  if (temp.templateOptions) {
	                    temp.templateOptions.disabled = !_this.editarBeneficiarios(); // Habilitar o deshabilitar los campos del formulario
	                  }
	                  a.push(temp);
	                  return a;
	                }, []);
	
	                // Si solo existe una opcion en la matriz, esta es seleccionada por defecto
	                if (_this.sectorProductivo.length === 1 && _this.sectorProductivo[0].hasOwnProperty('key')) {
	                  _this.proyecto.beneficiarios.productivo[_this.sectorProductivo[0].key] = true;
	                }
	              }
	            }
	          });
	        }
	      });
	
	      // this.$scope.$watch('$ctrl.proyecto.beneficiarios.indicadores_impacto_unidades', () => {
	      //   this.combinarIndicadoresImpacto();
	      // });
	
	      /*this.DataService.get(`contenidos/sector_productivo/1`).then(response => {
	        if (response) {
	          if (response.datos && response.datos.estructura) {
	            this.sectorProductivo = response.datos.estructura.reduce((a, b) => {
	              let temp = b;
	              if (temp.templateOptions) {
	                temp.templateOptions.disabled = !this.editarBeneficiarios(); // Habilitar o deshabilitar los campos del formulario
	              }
	              a.push(temp);
	              return a;
	            }, []);
	          }
	        }
	      });*/
	
	      // this.sectorProductivo = [
	      //   {
	      //     key: 'agricola',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Agrícola',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'prod_agroeco_organica',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Producción Agroecológica y Orgánica',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'pecuario',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Pecuario',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'pesca',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Pesca',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'integral_sustentable_bosque',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Manejo Integral y Sustentable de Bosques',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'sis_agroforestales',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Manejo en Sistemas agroforestales',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'maquinaria',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Entrega Maquinaria',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'piscicultura',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Piscicultura',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'aprovecha_biodiversidad',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Aprovechamiento sustentable de la biodiversidad',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      // ];
	
	      if (this.proyecto.dpa && this.proyecto.dpa.municipio && this.proyecto.dpa.municipio.point && this.proyecto.dpa.municipio.point.coordinates) {
	        this.mapa.centro = {
	          lat: this.proyecto.dpa.municipio.point.coordinates[1],
	          lng: this.proyecto.dpa.municipio.point.coordinates[0],
	          zoom: 9
	        };
	      } else {
	        this.mapa.centro = {
	          lat: -16.5286043,
	          lng: -68.1798767,
	          zoom: 8
	        };
	      }
	      this.mapa.marcadores = [];
	      if (this.proyecto.beneficiarios && this.proyecto.beneficiarios.comunidades && this.proyecto.beneficiarios.comunidades.length > 0) {
	        for (var i in this.proyecto.beneficiarios.comunidades) {
	          var icon = {
	            iconUrl: 'images/marker.png',
	            iconSize: [38, 40]
	          };
	          this.mapa.marcadores.push({
	            lat: this.proyecto.beneficiarios.comunidades[i].coordenadas.lat,
	            lng: this.proyecto.beneficiarios.comunidades[i].coordenadas.lng,
	            focus: false,
	            draggable: !this.noEditarCoordenadas(),
	            message: '-' + this.proyecto.beneficiarios.comunidades[i].nombre,
	            icon: icon
	          });
	        }
	      }
	
	      this.$scope.$on('leafletDirectiveMarker.dragend', function (event, args) {
	        _this.mapa.marcadores[args.modelName].lat = args.model.lat;
	        _this.mapa.marcadores[args.modelName].lng = args.model.lng;
	        _this.proyecto.beneficiarios.comunidades[args.modelName].coordenadas.lat = args.model.lat;
	        _this.proyecto.beneficiarios.comunidades[args.modelName].coordenadas.lng = args.model.lng;
	
	        _this.proyecto.beneficiarios.comunidades[args.modelName].coordenadas.este_x = '';
	        _this.proyecto.beneficiarios.comunidades[args.modelName].coordenadas.norte_y = '';
	        _this.proyecto.beneficiarios.comunidades[args.modelName].coordenadas.zona = '';
	      });
	    }
	  }, {
	    key: 'agregarComunidades',
	    value: function agregarComunidades() {
	      this.ver_comunidades = !this.ver_comunidades;
	    }
	  }, {
	    key: 'limpiarListaComunidades',
	    value: function limpiarListaComunidades() {
	      this.lista_comunidades = "";
	    }
	  }, {
	    key: 'agregarComunidadesImportar',
	    value: function agregarComunidadesImportar() {
	      var filas = this.lista_comunidades.split(/\n/g);
	      if (filas.length > 0) {
	        for (var i = 0; i < filas.length; i++) {
	          if (filas[i].trim() != "") {
	            var columnas = filas[i].split(/\t/g); //"|"
	            if (columnas.length >= 3) {
	              console.log(columnas);
	              if (columnas.length > 3 && columnas[3].trim() != "") {
	                var latlon = new Array(2);
	                this.urm2lat.UTMXYToLatLon(parseFloat(columnas[2]), parseFloat(columnas[3]), parseInt(columnas[1]), true, latlon);
	                if (latlon.length > 0) {
	                  this.agregarComunidadManual(columnas[0].trim(), parseFloat(latlon[0]), parseFloat(latlon[1]));
	                }
	              } else {
	                this.agregarComunidadManual(columnas[0].trim(), parseFloat(columnas[1]), parseFloat(columnas[2]));
	              }
	            }
	          }
	        }
	      }
	      this.ver_comunidades = !this.ver_comunidades;
	    }
	  }, {
	    key: 'agregarComunidadManual',
	    value: function agregarComunidadManual(_nombre, _lat, _lng) {
	      if (!this.proyecto.beneficiarios) {
	        this.proyecto.beneficiarios = {};
	      }
	      if (!this.proyecto.beneficiarios.comunidades) {
	        this.proyecto.beneficiarios.comunidades = [];
	      }
	      var comunidad = {
	        nro: this.proyecto.beneficiarios.nro_comunidades ? this.proyecto.beneficiarios.nro_comunidades + 1 : 1,
	        nombre: _nombre,
	        coordenadas: {
	          lat: _lat,
	          lng: _lng
	        }
	      };
	      this.proyecto.beneficiarios.comunidades.push(comunidad);
	      this.proyecto.beneficiarios.nro_comunidades = this.proyecto.beneficiarios.comunidades.length;
	
	      var icon = {
	        iconUrl: 'images/marker.png',
	        iconSize: [38, 40],
	        iconAnchor: [19, 30]
	      };
	      this.mapa.marcadores.push({
	        lat: _lat,
	        lng: _lng,
	        focus: false,
	        draggable: true,
	        message: _nombre,
	        icon: icon
	      });
	    }
	  }, {
	    key: 'agregarComunidad',
	    value: function agregarComunidad() {
	      if (!this.proyecto.beneficiarios) {
	        this.proyecto.beneficiarios = {};
	      }
	      if (!this.proyecto.beneficiarios.comunidades) {
	        this.proyecto.beneficiarios.comunidades = [];
	      }
	      var comunidad = {
	        nro: this.proyecto.beneficiarios.nro_comunidades ? this.proyecto.beneficiarios.nro_comunidades + 1 : 1,
	        nombre: '',
	        coordenadas: {
	          lat: this.mapa.centro.lat,
	          lng: this.mapa.centro.lng
	        }
	      };
	      this.proyecto.beneficiarios.comunidades.push(comunidad);
	      this.proyecto.beneficiarios.nro_comunidades = this.proyecto.beneficiarios.comunidades.length;
	
	      var icon = {
	        iconUrl: 'images/marker.png',
	        iconSize: [38, 40],
	        iconAnchor: [19, 30]
	      };
	      this.mapa.marcadores.push({
	        lat: this.mapa.centro.lat,
	        lng: this.mapa.centro.lng,
	        focus: false,
	        draggable: true,
	        message: '-',
	        icon: icon
	      });
	    }
	  }, {
	    key: 'quitarComunidad',
	    value: function quitarComunidad(index) {
	      if (this.proyecto.beneficiarios.comunidades && this.proyecto.beneficiarios.comunidades.length > 0) {
	        this.proyecto.beneficiarios.comunidades.splice(index, 1);
	        this.proyecto.beneficiarios.nro_comunidades = this.proyecto.beneficiarios.comunidades.length;
	        this.mapa.marcadores.splice(index, 1);
	      }
	    }
	  }, {
	    key: 'renombrarComunidad',
	    value: function renombrarComunidad(index, comunidad) {
	      this.mapa.marcadores[index].message = '' + comunidad.nombre;
	    }
	  }, {
	    key: 'coordenadaManual',
	    value: function coordenadaManual(index, comunidad) {
	      if (comunidad.coordenadas.zona && comunidad.coordenadas.zona != '' && comunidad.coordenadas.este_x && comunidad.coordenadas.este_x != 0 && comunidad.coordenadas.norte_y && comunidad.coordenadas.norte_y != 0) {
	        var latlon = new Array(2);
	        this.urm2lat.UTMXYToLatLon(parseFloat(comunidad.coordenadas.este_x), parseFloat(comunidad.coordenadas.norte_y), parseInt(comunidad.coordenadas.zona), true, latlon);
	        if (latlon.length > 0) {
	          comunidad.coordenadas.lat = this.mapa.marcadores[index].lat = parseFloat(latlon[0]);
	          comunidad.coordenadas.lng = this.mapa.marcadores[index].lng = parseFloat(latlon[1]);
	        }
	      } else {
	        comunidad.coordenadas.lat = this.mapa.marcadores[index].lat = parseFloat(comunidad.coordenadas.lat);
	        comunidad.coordenadas.lng = this.mapa.marcadores[index].lng = parseFloat(comunidad.coordenadas.lng);
	      }
	    }
	  }, {
	    key: 'plazoEjecucion',
	    value: function plazoEjecucion() {
	      this.proyecto.plazo_ejecucion = this.proyecto.beneficiarios.plazo_ejecucion;
	    }
	  }, {
	    key: 'verDocumento',
	    value: function verDocumento(tipo, nombreDocumento) {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/documentos/' + tipo, nombreDocumento);
	    }
	  }, {
	    key: 'selTipoFinanciamiento',
	    value: function selTipoFinanciamiento(item) {
	      if (item.indexOf('PUBLICA') >= 0 || item.indexOf('PRIVADA') >= 0) {
	        this.$$obtenerCuadro(1);
	        // this.$$obtenerCuadro1();
	        // this.proyecto.financiamiento.cuadro.tipo = 1;
	      } else if (item.indexOf('MIXTA') >= 0) {
	        this.$$obtenerCuadro(2);
	        // this.$$obtenerCuadro2();
	        // this.proyecto.financiamiento.cuadro.tipo = 2;
	      }
	    }
	  }, {
	    key: '$$obtenerCuadro',
	    value: function $$obtenerCuadro(tipo) {
	      var _this2 = this;
	
	      // this.proyecto.financiamiento.cuadro = {};
	      this.DataService.get('contenidos/cuadro_financiamiento/' + tipo).then(function (response) {
	        if (response) {
	          if (response.datos && response.datos.estructura) {
	            _this2.proyecto.financiamiento.cuadro = response.datos.estructura;
	            // console.log('-------------cuadro--------------');
	            // console.log(this.proyecto.financiamiento.cuadro);
	            // console.log('---------------------------------');
	          }
	        }
	      });
	    }
	
	    // $$obtenerCuadro1() {
	    //   // this.proyecto.financiamiento.cuadro = {};
	    //   this.DataService.get(`contenidos/cuadro_financiamiento/1`).then(response => {
	    //     if (response) {
	    //       if (response.datos && response.datos.estructura) {
	    //         this.proyecto.financiamiento.cuadro = response.datos.estructura;
	    //         // console.log('-------------cuadro--------------');
	    //         // console.log(this.proyecto.financiamiento.cuadro);
	    //         // console.log('---------------------------------');
	    //       }
	    //     }
	    //   });
	
	    // this.proyecto.financiamiento.cuadro = {
	    //   datos: [
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 4,
	    //           contenido: `Inversión fija`,
	    //         },
	    //         { contenido: `Infraestructura productiva` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Bienes y/o equipamiento` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Medidas Físicas (infraestructura) de prevención y/o mitigación de impactos ambientales` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Medidas Físicas (infraestructura) de gestión de riesgos` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	
	    //     //*******
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 3,
	    //           contenido: `Capital de trabajo`,
	    //         },
	    //         { contenido: `Mano de obra` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Materia prima e insumos` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Servicios` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	
	    //     //*****
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 5,
	    //           contenido: `Inversión diferida`,
	    //         },
	    //         { contenido: `Gerenciamiento del Proyecto (Administración directa o delegada)` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Capacitación y/o Asistencia Técnica` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Supervisión` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Fiscalización` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Auditoria externa` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //   ],
	    //   totales: {
	    //     costo_total: 0,
	    //     fdi: 0,
	    //     gam: 0,
	    //     beneficiarios: 0,
	    //     otros: 0
	    //   },
	    //   tipo: 1
	    // };
	    // }
	
	    // $$obtenerCuadro2() {
	    //   // this.proyecto.financiamiento.cuadro = {};
	    //   this.DataService.get(`contenidos/cuadro_financiamiento/2`).then(response => {
	    //     if (response) {
	    //       if (response.datos && response.datos.estructura) {
	    //         this.proyecto.financiamiento.cuadro = response.datos.estructura;
	    //         // console.log('-------------cuadro2-------------');
	    //         // console.log(this.proyecto.financiamiento.cuadro);
	    //         // console.log('---------------------------------');
	    //       }
	    //     }
	    //   });
	
	    // this.proyecto.financiamiento.cuadro = {
	    //   datos: [
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 4,
	    //           contenido: `Inversión fija`,
	    //         },
	    //         { contenido: `Infraestructura productiva` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Bienes y/o equipamiento` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Medidas Físicas (infraestructura) de prevención y/o mitigación de impactos ambientales` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Medidas Físicas (infraestructura) de gestión de riesgos` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	
	    //     //*******
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 3,
	    //           contenido: `Capital de trabajo`,
	    //         },
	    //         { contenido: `Mano de obra` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Materia prima e insumos` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Servicios` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	
	    //     //*****
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 5,
	    //           contenido: `Inversión diferida`,
	    //         },
	    //         { contenido: `Gerenciamiento del Proyecto (Administración directa o delegada)` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Capacitación y/o Asistencia Técnica` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Supervisión (Hasta el 6%)` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Fiscalización` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Auditoria externa (Hasta el 2% del FDI)` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //   ],
	    //   totales: {
	    //     fdi: 0,
	    //     gam: 0,
	    //     publico: 0,
	    //     privado: 0,
	    //     fdi_pp: 0,
	    //     fdi_gam: 0
	    //   },
	    //   tipo: 2
	    // };
	    // }
	
	    // establecerIndicadoresImpacto() {
	    //   if (this.proyecto.beneficiarios && this.proyecto.beneficiarios.indicadores_impacto) {
	    //     let indicadores = this.proyecto.beneficiarios.indicadores_impacto.split(" ");
	    //     if (indicadores.length>0) {
	    //       this.proyecto.beneficiarios.indicadores_impacto_numero = indicadores[0];
	    //       this.proyecto.beneficiarios.indicadores_impacto_unidades = indicadores[1];
	    //     }
	    //   }
	    // }
	
	  }, {
	    key: 'setIndicadores',
	    value: function setIndicadores() {
	      this.proyecto.beneficiarios.subtipo_productivo = null;
	
	      this.proyecto.beneficiarios.indicadores_impacto = [{
	        combinado: null,
	        numero: null,
	        unidades: null,
	        otro: null
	      }];
	    }
	  }, {
	    key: 'cambiarUnidades',
	    value: function cambiarUnidades() {
	      var _unidad = null;
	      switch (this.proyecto.beneficiarios.tipo) {
	        case 'OP_TP_RIEGO':
	          _unidad = 'HA';
	          break;
	        case 'OP_TP_PUENTES':
	          _unidad = 'M';
	          break;
	        default:
	          break;
	      }
	      this.proyecto.beneficiarios.indicadores_impacto[0].unidades = _unidad;
	      if (this.proyecto.informe) {
	        this.proyecto.informe.valoracion[5].cols[0].contenido = 'Valor ' + (this.proyecto.beneficiarios.tipo !== 'OP_TP_PRODUCTIVO' ? 'VANS' : 'VANE');
	        this.proyecto.informe.valoracion[6].cols[0].contenido = 'Valor ' + (this.proyecto.beneficiarios.tipo !== 'OP_TP_PRODUCTIVO' ? 'VANP' : 'VANF');
	      }
	    }
	  }, {
	    key: 'combinarIndicadoresImpacto',
	    value: function combinarIndicadoresImpacto() {
	      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.proyecto.beneficiarios.indicadores_impacto[idx].numero && this.proyecto.beneficiarios.indicadores_impacto[idx].unidades) {
	        if (_typeof(this.proyecto.beneficiarios.indicadores_impacto[idx].unidades) === 'object') {
	          if (this.proyecto.beneficiarios.indicadores_impacto[idx].unidades.codigo === 'Otro') {
	            if (this.proyecto.beneficiarios.indicadores_impacto[idx].otro) {
	              this.proyecto.beneficiarios.indicadores_impacto[idx].combinado = this.proyecto.beneficiarios.indicadores_impacto[idx].numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto[idx].otro;
	            } else {
	              this.proyecto.beneficiarios.indicadores_impacto[idx].combinado = this.proyecto.beneficiarios.indicadores_impacto[idx].numero;
	            }
	          } else {
	            this.proyecto.beneficiarios.indicadores_impacto[idx].combinado = this.proyecto.beneficiarios.indicadores_impacto[idx].numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto[idx].unidades.nombre;
	          }
	        } else {
	          this.proyecto.beneficiarios.indicadores_impacto[idx].combinado = this.proyecto.beneficiarios.indicadores_impacto[idx].numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto[idx].unidades;
	        }
	      }
	
	      // if (this.proyecto.beneficiarios.indicadores_impacto_numero && this.proyecto.beneficiarios.indicadores_impacto_unidades) {
	      //   if (typeof this.proyecto.beneficiarios.indicadores_impacto_unidades === 'object') {
	      //     if (this.proyecto.beneficiarios.indicadores_impacto_unidades.codigo === 'Otro') {
	      //       if (this.proyecto.beneficiarios.indicadores_impacto_otro) {
	      //         this.proyecto.beneficiarios.indicadores_impacto = this.proyecto.beneficiarios.indicadores_impacto_numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto_otro;
	      //       } else {
	      //         this.proyecto.beneficiarios.indicadores_impacto = this.proyecto.beneficiarios.indicadores_impacto_numero;
	      //       }
	      //     } else {
	      //       this.proyecto.beneficiarios.indicadores_impacto = this.proyecto.beneficiarios.indicadores_impacto_numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto_unidades.nombre;
	      //     }
	      //   } else {
	      //     this.proyecto.beneficiarios.indicadores_impacto = this.proyecto.beneficiarios.indicadores_impacto_numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto_unidades;
	      //   }
	      // }
	
	      console.log('----------------combine-------------');
	      console.log(this.proyecto.beneficiarios.indicadores_impacto);
	      console.log('------------------------------------');
	    }
	  }, {
	    key: 'actualizarIndicadoresImpacto',
	    value: function actualizarIndicadoresImpacto() {
	      if (this.proyecto.informe) {
	        if (!this.proyecto.informe.indicador) this.proyecto.informe.indicador = {};
	        this.proyecto.informe.indicador.proceso = this.proyecto.beneficiarios.indicadores_impacto[0].combinado;
	      }
	    }
	  }, {
	    key: 'adicionarIndicador',
	    value: function adicionarIndicador() {
	      if (!this.proyecto.beneficiarios.indicadores_impacto) this.proyecto.beneficiarios.indicadores_impacto = [];
	
	      this.proyecto.beneficiarios.indicadores_impacto.push({
	        combinado: null,
	        numero: null,
	        unidades: null,
	        otro: null
	      });
	
	      console.log('----------------add-----------------');
	      console.log(this.proyecto.beneficiarios.indicadores_impacto);
	      console.log('------------------------------------');
	    }
	  }, {
	    key: 'eliminarIndicador',
	    value: function eliminarIndicador($index) {
	      this.proyecto.beneficiarios.indicadores_impacto.splice($index, 1);
	      return;
	    }
	  }, {
	    key: 'limpiarMatriz',
	    value: function limpiarMatriz() {
	      this.proyecto.beneficiarios.productivo = {};
	    }
	  }, {
	    key: 'editarBeneficiarios',
	    value: function editarBeneficiarios() {
	      // if (this.Usuarios.esSupervisor()) return false;
	      return this.Proyecto.esEditable('beneficiarios');
	    }
	  }, {
	    key: 'editarIndicadores',
	    value: function editarIndicadores() {
	      // return this.Usuarios.esTecnicoResponsable() ? true : false;
	      return this.Proyecto.esEditable('evaluacion');
	    }
	  }, {
	    key: 'noEditarCoordenadas',
	    value: function noEditarCoordenadas() {
	      if (this.Usuarios.esSupervisor()) return false;
	      return this.modoVista || !this.editarBeneficiarios();
	    }
	  }, {
	    key: '$$iniciarLeaflet',
	    value: function $$iniciarLeaflet() {
	      this.mapa = {
	        defaults: {
	          minZoom: 5
	        },
	        maxbounds: {
	          northEast: {
	            lat: -8.433237,
	            lng: -71.367187
	          },
	          southWest: {
	            lat: -23.596439,
	            lng: -56.118164
	          }
	        }
	      };
	      var layers = {
	        geobolivia_topo: {
	          name: 'GeoBolivia Topográfico',
	          url: 'https://test.geo.gob.bo/raster/service/wmts?',
	          type: 'wms',
	          visible: true,
	          layerParams: {
	            layers: 'mapbox_terrain',
	            format: "image/png",
	            transparent: true
	            //crs: L.CRS.EPSG4326,
	            //version: '1.1.1',
	          },
	          layerOptions: {
	            attribution: '<a href="https://geo.gob.bo" target="_blank">GeoBolivia</a>',
	            continuousWorld: false
	          }
	        },
	        geobolivia_sat: {
	          name: 'GeoBolivia Satelital',
	          url: 'https://test.geo.gob.bo/raster/service/wms?',
	          type: 'wms',
	          visible: true,
	          layerParams: {
	            layers: 'mapbox_bolivia',
	            format: "image/png",
	            transparent: true
	            //crs: L.CRS.EPSG4326,
	            //version: '1.1.1',
	          },
	          layerOptions: {
	            attribution: '<a href="https://geo.gob.bo" target="_blank">GeoBolivia</a>',
	            continuousWorld: false
	          }
	        },
	        openstreetmap: {
	          name: 'OpenStreetMap',
	          type: 'xyz',
	          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
	          layerOptions: {
	            subdomains: ['a', 'b', 'c'],
	            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
	            continuousWorld: false
	          }
	        },
	        arcgis: {
	          name: 'Topográfico',
	          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
	          type: 'xyz',
	          layerOptions: {
	            attribution: '<a href="https://www.arcgis.com/home/webmap/viewer.html" target="_blank">ArcGIS</a>',
	            continuousWorld: false
	          }
	        },
	        mapbox_api: {
	          name: 'Escala de grises',
	          url: 'https://api.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
	          type: 'xyz',
	          layerOptions: {
	            apikey: 'pk.eyJ1IjoiY2hlbG9hbGVqb2MiLCJhIjoiY2lod2lkZHdrMDJueHUxbTFqMXRodGUzdyJ9.Vs-56Km_o5AXT9N5QrcLsw',
	            mapid: 'landplanner.map-dsn5dtki',
	            attribution: '<a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a>'
	          }
	        },
	        arcgisimage: {
	          name: 'Imágenes',
	          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
	          type: 'xyz',
	          layerOptions: {
	            attribution: '<a href="https://www.arcgis.com/home/webmap/viewer.html" target="_blank">ArcGIS</a>',
	            continuousWorld: false
	          }
	        }
	      };
	
	      this.myLayers = {
	        baselayers: layers
	      };
	    }
	  }]);
	
	  return DatosGenerales;
	}();
	
	exports.default = DatosGenerales;

/***/ }),
/* 551 */
[859, 552, 807],
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _selectComuModal = __webpack_require__(808);
	
	var _selectComuModal2 = _interopRequireDefault(_selectComuModal);
	
	var _selectComuController = __webpack_require__(553);
	
	var _selectComuController2 = _interopRequireDefault(_selectComuController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosGenerales = function () {
	  DatosGenerales.$inject = ["DataService", "Util", "Proyecto", "Modal", "$scope", "urm2lat", "Usuarios", "$http", "helpLang"];
	  function DatosGenerales(DataService, Util, Proyecto, Modal, $scope, urm2lat, Usuarios, $http, helpLang) {
	    'ngInject';
	
	    _classCallCheck(this, DatosGenerales);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.$scope = $scope;
	    this.urm2lat = urm2lat;
	    this.Usuarios = Usuarios;
	    this.$http = $http;
	    this.helpLang = helpLang;
	  }
	
	  _createClass(DatosGenerales, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      console.log(this.proyecto, "proyectooo");
	      this.lista_comunidades = "";
	      this.ver_comunidades = true;
	      this.$$iniciarLeaflet();
	      this.sectorProductivo = [];
	      this.seleccion_unidades = [];
	      this.subtipos = 'inicio';
	
	      this.$scope.$watch('$ctrl.proyecto.beneficiarios.tipo', function () {
	        // if (this.proyecto.beneficiarios.tipo != 'OP_TP_PRODUCTIVO' && this.proyecto.beneficiarios.tipo != 'OP_TP_MAQUINARIA') {
	        if (!_this.Proyecto.tratarComoProductivo(_this.proyecto)) {
	          _this.seleccion_unidades = [];
	          _this.limpiarMatriz();
	        }
	      });
	
	      if (typeof this.proyecto.beneficiarios.indicadores_impacto === 'string') {
	        this.proyecto.beneficiarios.indicadores_impacto = [{
	          combinado: this.proyecto.beneficiarios.indicadores_impacto,
	          numero: this.proyecto.beneficiarios.indicadores_impacto_numero,
	          unidades: this.proyecto.beneficiarios.indicadores_impacto_unidades,
	          otro: this.proyecto.beneficiarios.indicadores_impacto_otro
	        }];
	      }
	
	      this.$scope.$watch('$ctrl.proyecto.beneficiarios.subtipo_productivo', function () {
	        switch (_this.proyecto.beneficiarios.subtipo_productivo) {
	          case 'ST_PROD_AGRICOLA':
	          case 'ST_PROD_PISCICOLA':
	          case 'ST_PROD_APICULTURA':
	            _this.seleccion_unidades = [{ codigo: 't', nombre: 't' }];
	            break;
	          case 'ST_PROD_MAQUINARIA':
	            _this.seleccion_unidades = [{ codigo: 'HA', nombre: 'HA' }]; //otros
	            break;
	          case 'ST_PROD_BOVINO':
	          case 'ST_PROD_CAMELIDOS':
	          case 'ST_PROD_GANADO_MENOR':
	            _this.seleccion_unidades = [{ codigo: 'cabezas', nombre: 'cabezas' }];
	            break;
	          case 'ST_PROD_TRANSFORMACION':
	            //this.seleccion_unidades = [{codigo:'T',nombre:'T'},{codigo:'l',nombre:'l'},{codigo:'Otro',nombre:'Otro'}];
	            _this.seleccion_unidades = [{ codigo: 't', nombre: 't' }, { codigo: 'l', nombre: 'l' }]; //otros
	            break;
	          case 'ST_PROD_AVICOLA':
	            _this.seleccion_unidades = [{ codigo: 'aves', nombre: 'aves' }];
	            break;
	          case 'ST_PROD_INFRAESTRUCTURA':
	            _this.seleccion_unidades = [{ codigo: 'unidades', nombre: 'unidades' }];
	            break;
	          case 'ST_PROD_LACTEOS':
	            _this.seleccion_unidades = [{ codigo: 'l', nombre: 'l' }];
	            break;
	          default:
	            break;
	        }
	        _this.seleccion_unidades.push({ codigo: 'Otro', nombre: 'Otro' });
	
	        // if (this.seleccion_unidades.length === 1 && this.proyecto.beneficiarios.tipo === 'OP_TP_PRODUCTIVO') {
	        //   this.proyecto.beneficiarios.indicadores_impacto_unidades = [];
	        //   this.proyecto.beneficiarios.indicadores_impacto_unidades.push(this.seleccion_unidades[0].codigo);
	        // }
	        // if (this.seleccion_unidades.length > 1 && this.proyecto.beneficiarios.tipo === 'OP_TP_PRODUCTIVO') {
	        //   this.proyecto.beneficiarios.indicadores_impacto_unidades = [];
	        //   this.proyecto.beneficiarios.indicadores_impacto_unidades.push(this.seleccion_unidades[0]);
	        // }
	
	        // NUEVO CUADRO SEGUN SUBTIPO
	        if (_this.proyecto.beneficiarios.subtipo_productivo) {
	          _this.DataService.get('contenidos/' + _this.proyecto.beneficiarios.subtipo_productivo + '/1').then(function (response) {
	            if (response) {
	              if (response.datos && response.datos.estructura) {
	                if (_this.subtipos != 'inicio') {
	                  _this.limpiarMatriz();
	                } else {
	                  _this.subtipos = '';
	                }
	
	                _this.sectorProductivo = response.datos.estructura.reduce(function (a, b) {
	                  var temp = b;
	                  if (temp.templateOptions) {
	                    temp.templateOptions.disabled = !_this.editarBeneficiarios(); // Habilitar o deshabilitar los campos del formulario
	                  }
	                  a.push(temp);
	                  return a;
	                }, []);
	
	                // Si solo existe una opcion en la matriz, esta es seleccionada por defecto
	                if (_this.sectorProductivo.length === 1 && _this.sectorProductivo[0].hasOwnProperty('key')) {
	                  _this.proyecto.beneficiarios.productivo[_this.sectorProductivo[0].key] = true;
	                }
	              }
	            }
	          });
	        }
	      });
	
	      // this.$scope.$watch('$ctrl.proyecto.beneficiarios.indicadores_impacto_unidades', () => {
	      //   this.combinarIndicadoresImpacto();
	      // });
	
	      /*this.DataService.get(`contenidos/sector_productivo/1`).then(response => {
	        if (response) {
	          if (response.datos && response.datos.estructura) {
	            this.sectorProductivo = response.datos.estructura.reduce((a, b) => {
	              let temp = b;
	              if (temp.templateOptions) {
	                temp.templateOptions.disabled = !this.editarBeneficiarios(); // Habilitar o deshabilitar los campos del formulario
	              }
	              a.push(temp);
	              return a;
	            }, []);
	          }
	        }
	      });*/
	
	      // this.sectorProductivo = [
	      //   {
	      //     key: 'agricola',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Agrícola',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'prod_agroeco_organica',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Producción Agroecológica y Orgánica',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'pecuario',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Pecuario',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'pesca',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Pesca',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'integral_sustentable_bosque',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Manejo Integral y Sustentable de Bosques',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'sis_agroforestales',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Manejo en Sistemas agroforestales',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'maquinaria',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Entrega Maquinaria',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'piscicultura',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Piscicultura',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      //   {
	      //     key: 'aprovecha_biodiversidad',
	      //     type: 'checkbox',
	      //     className: 'col-md-6 col-lg-4',
	      //     templateOptions: {
	      //       label: 'Aprovechamiento sustentable de la biodiversidad',
	      //       disabled: !this.editarBeneficiarios()
	      //     }
	      //   },
	      // ];
	
	      if (this.proyecto.dpa && this.proyecto.dpa.municipio && this.proyecto.dpa.municipio.point && this.proyecto.dpa.municipio.point.coordinates) {
	        this.mapa.centro = {
	          lat: this.proyecto.dpa.municipio.point.coordinates[1],
	          lng: this.proyecto.dpa.municipio.point.coordinates[0],
	          zoom: 9
	        };
	      } else {
	        this.mapa.centro = {
	          lat: -16.5286043,
	          lng: -68.1798767,
	          zoom: 8
	        };
	      }
	      this.mapa.marcadores = [];
	      if (this.proyecto.beneficiarios && this.proyecto.beneficiarios.comunidades && this.proyecto.beneficiarios.comunidades.length > 0) {
	        for (var i in this.proyecto.beneficiarios.comunidades) {
	          var icon = {
	            iconUrl: 'images/marker.png',
	            iconSize: [38, 40]
	          };
	          this.mapa.marcadores.push({
	            lat: this.proyecto.beneficiarios.comunidades[i].coordenadas.lat,
	            lng: this.proyecto.beneficiarios.comunidades[i].coordenadas.lng,
	            focus: false,
	            draggable: !this.noEditarCoordenadas(),
	            message: '-' + this.proyecto.beneficiarios.comunidades[i].nombre,
	            icon: icon
	          });
	        }
	      }
	
	      this.$scope.$on('leafletDirectiveMarker.dragend', function (event, args) {
	        _this.mapa.marcadores[args.modelName].lat = args.model.lat;
	        _this.mapa.marcadores[args.modelName].lng = args.model.lng;
	        _this.proyecto.beneficiarios.comunidades[args.modelName].coordenadas.lat = args.model.lat;
	        _this.proyecto.beneficiarios.comunidades[args.modelName].coordenadas.lng = args.model.lng;
	
	        _this.proyecto.beneficiarios.comunidades[args.modelName].coordenadas.este_x = '';
	        _this.proyecto.beneficiarios.comunidades[args.modelName].coordenadas.norte_y = '';
	        _this.proyecto.beneficiarios.comunidades[args.modelName].coordenadas.zona = '';
	      });
	    }
	  }, {
	    key: 'agregarComunidades',
	    value: function agregarComunidades() {
	      this.ver_comunidades = !this.ver_comunidades;
	    }
	  }, {
	    key: 'extraerComunidades',
	    value: function extraerComunidades() {
	      var _this2 = this;
	
	      this.DataService.get('comunidad/?id_municipio=' + this.proyecto.fcod_municipio).then(function (response) {
	        if (response) {
	          //console.log(response.datos,"respuesta de dataservice comunidades")
	          console.log("comunidadees >>>>>>>>", _this2.proyecto.beneficiarios.comunidades);
	          console.log("marcadores >>>>>>>>", _this2.mapa.marcadores);
	
	          // iteraciones para verificar los seleccionados en el checklist
	          for (var i = _this2.proyecto.beneficiarios.comunidades.length - 1; i >= 0; i--) {
	            //console.log(this.proyecto.beneficiarios.comunidades[i],"iterando con decrementacion")
	            for (var j = response.datos.length - 1; j >= 0; j--) {
	              if (_this2.proyecto.beneficiarios.comunidades[i].nombre == response.datos[j].comunidad) {
	                console.log(response.datos[j].comunidad);
	                response.datos[j].seleccionado = true;
	              }
	            }
	          }
	          console.log(response, "despues de la iteracion");
	          console.log(_this2.mapa.marcadores);
	          //this.mapa.marcadores= [];
	          //this.proyecto.beneficiarios.comunidades=[];
	          //this.proyecto.beneficiarios.nro_comunidades=0;
	          _this2.Modal.show({
	            template: _selectComuModal2.default,
	            controller: _selectComuController2.default,
	            data: response,
	            size: 'md'
	          }).result.then(function (resp) {
	            console.log("retorno", resp);
	            if (resp) {
	              //elimina marcadores y comunidades registrados anteriormente para luego registrar con nuevos valores
	              // this.mapa.marcadores= [];
	
	              // this.proyecto.beneficiarios.comunidades=[];
	              // this.proyecto.beneficiarios.nro_comunidades=0;
	
	              var _iteratorNormalCompletion = true;
	              var _didIteratorError = false;
	              var _iteratorError = undefined;
	
	              try {
	                for (var _iterator = resp[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                  var comuni = _step.value;
	
	                  for (var i = _this2.proyecto.beneficiarios.comunidades.length - 1; i >= 0; i--) {
	                    //console.log(this.proyecto.beneficiarios.comunidades)
	                    if (_this2.proyecto.beneficiarios.comunidades[i].nombre == comuni.comunidad) {
	                      var removed = _this2.proyecto.beneficiarios.comunidades.splice(i, 1);
	                      var removedMarcadores = _this2.mapa.marcadores.splice(i, 1);
	                      console.log(removed, "valor removido!!!!!!!");
	                      console.log(removedMarcadores, "marcador removido !!!!");
	                      console.log(_this2.proyecto.beneficiarios.comunidades);
	                    }
	                  }
	                  _this2.agregarComunidadManual(comuni.comunidad, parseFloat(comuni.y_lat.replace(',', '.')), parseFloat(comuni.x_long.replace(',', '.')));
	                }
	              } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                  }
	                } finally {
	                  if (_didIteratorError) {
	                    throw _iteratorError;
	                  }
	                }
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'limpiarListaComunidades',
	    value: function limpiarListaComunidades() {
	      this.lista_comunidades = "";
	    }
	  }, {
	    key: 'agregarComunidadesImportar',
	    value: function agregarComunidadesImportar() {
	      var filas = this.lista_comunidades.split(/\n/g);
	      if (filas.length > 0) {
	        for (var i = 0; i < filas.length; i++) {
	          if (filas[i].trim() != "") {
	            var columnas = filas[i].split("|"); //"|"
	            if (columnas.length >= 3) {
	              console.log(columnas);
	              if (columnas.length > 3 && columnas[3].trim() != "") {
	                var latlon = new Array(2);
	                this.urm2lat.UTMXYToLatLon(parseFloat(columnas[2]), parseFloat(columnas[3]), parseInt(columnas[1]), true, latlon);
	                if (latlon.length > 0) {
	                  this.agregarComunidadManual(columnas[0].trim(), parseFloat(latlon[0]), parseFloat(latlon[1]));
	                }
	              } else {
	                this.agregarComunidadManual(columnas[0].trim(), parseFloat(columnas[1]), parseFloat(columnas[2]));
	              }
	            }
	          }
	        }
	      }
	      this.ver_comunidades = !this.ver_comunidades;
	    }
	  }, {
	    key: 'agregarComunidadManual',
	    value: function agregarComunidadManual(_nombre, _lat, _lng) {
	      if (!this.proyecto.beneficiarios) {
	        this.proyecto.beneficiarios = {};
	      }
	      if (!this.proyecto.beneficiarios.comunidades) {
	        this.proyecto.beneficiarios.comunidades = [];
	      }
	      var comunidad = {
	        nro: this.proyecto.beneficiarios.nro_comunidades ? this.proyecto.beneficiarios.nro_comunidades + 1 : 1,
	        nombre: _nombre,
	        coordenadas: {
	          lat: _lat,
	          lng: _lng
	        }
	      };
	      this.proyecto.beneficiarios.comunidades.push(comunidad);
	      this.proyecto.beneficiarios.nro_comunidades = this.proyecto.beneficiarios.comunidades.length;
	
	      var icon = {
	        iconUrl: 'images/marker.png',
	        iconSize: [38, 40],
	        iconAnchor: [19, 30]
	      };
	      this.mapa.marcadores.push({
	        lat: _lat,
	        lng: _lng,
	        focus: false,
	        draggable: true,
	        message: _nombre,
	        icon: icon
	      });
	    }
	  }, {
	    key: 'agregarComunidad',
	    value: function agregarComunidad() {
	      if (!this.proyecto.beneficiarios) {
	        this.proyecto.beneficiarios = {};
	      }
	      if (!this.proyecto.beneficiarios.comunidades) {
	        this.proyecto.beneficiarios.comunidades = [];
	      }
	      var comunidad = {
	        nro: this.proyecto.beneficiarios.nro_comunidades ? this.proyecto.beneficiarios.nro_comunidades + 1 : 1,
	        nombre: '',
	        coordenadas: {
	          lat: this.mapa.centro.lat,
	          lng: this.mapa.centro.lng
	        }
	      };
	      this.proyecto.beneficiarios.comunidades.push(comunidad);
	      this.proyecto.beneficiarios.nro_comunidades = this.proyecto.beneficiarios.comunidades.length;
	
	      var icon = {
	        iconUrl: 'images/marker.png',
	        iconSize: [38, 40],
	        iconAnchor: [19, 30]
	      };
	      this.mapa.marcadores.push({
	        lat: this.mapa.centro.lat,
	        lng: this.mapa.centro.lng,
	        focus: false,
	        draggable: true,
	        message: '-',
	        icon: icon
	      });
	    }
	  }, {
	    key: 'quitarComunidad',
	    value: function quitarComunidad(index) {
	      if (this.proyecto.beneficiarios.comunidades && this.proyecto.beneficiarios.comunidades.length > 0) {
	        this.proyecto.beneficiarios.comunidades.splice(index, 1);
	        this.proyecto.beneficiarios.nro_comunidades = this.proyecto.beneficiarios.comunidades.length;
	        this.mapa.marcadores.splice(index, 1);
	      }
	    }
	  }, {
	    key: 'renombrarComunidad',
	    value: function renombrarComunidad(index, comunidad) {
	      this.mapa.marcadores[index].message = '' + comunidad.nombre;
	    }
	  }, {
	    key: 'coordenadaManual',
	    value: function coordenadaManual(index, comunidad) {
	      if (comunidad.coordenadas.degrees1 && comunidad.coordenadas.minutes1 && comunidad.coordenadas.seconds1 && comunidad.coordenadas.direction1) {
	        var decimal = this.urm2lat.DMS2Decimal(parseInt(comunidad.coordenadas.degrees1), parseInt(comunidad.coordenadas.minutes1), parseFloat(comunidad.coordenadas.seconds1), comunidad.coordenadas.direction1);
	        console.log(decimal, "conversion realizada!");
	        comunidad.coordenadas.lat = this.mapa.marcadores[index].lat = parseFloat(decimal);
	      }
	
	      if (comunidad.coordenadas.degrees2 && comunidad.coordenadas.minutes2 && comunidad.coordenadas.seconds2 && comunidad.coordenadas.direction2) {
	        var decimallng = this.urm2lat.DMS2Decimal(parseInt(comunidad.coordenadas.degrees2), parseInt(comunidad.coordenadas.minutes2), parseFloat(comunidad.coordenadas.seconds2), comunidad.coordenadas.direction2);
	        console.log(decimallng, "conversion realizada!");
	        comunidad.coordenadas.lng = this.mapa.marcadores[index].lng = parseFloat(decimallng);
	      }
	      if (comunidad.coordenadas.zona && comunidad.coordenadas.este_x && comunidad.coordenadas.norte_y) {
	        var latlon = new Array(2);
	        this.urm2lat.UTMXYToLatLon(parseFloat(comunidad.coordenadas.este_x), parseFloat(comunidad.coordenadas.norte_y), parseInt(comunidad.coordenadas.zona), true, latlon);
	        if (latlon.length > 0) {
	          comunidad.coordenadas.lat = this.mapa.marcadores[index].lat = parseFloat(latlon[0]);
	          comunidad.coordenadas.lng = this.mapa.marcadores[index].lng = parseFloat(latlon[1]);
	        }
	      } else {
	        comunidad.coordenadas.lat = this.mapa.marcadores[index].lat = parseFloat(comunidad.coordenadas.lat);
	        comunidad.coordenadas.lng = this.mapa.marcadores[index].lng = parseFloat(comunidad.coordenadas.lng);
	      }
	    }
	  }, {
	    key: 'plazoEjecucion',
	    value: function plazoEjecucion() {
	      this.proyecto.plazo_ejecucion = this.proyecto.beneficiarios.plazo_ejecucion;
	    }
	  }, {
	    key: 'verDocumento',
	    value: function verDocumento(tipo, nombreDocumento) {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/documentos/' + tipo, nombreDocumento);
	    }
	  }, {
	    key: 'selTipoFinanciamiento',
	    value: function selTipoFinanciamiento(item) {
	      if (item.indexOf('PUBLICA') >= 0 || item.indexOf('PRIVADA') >= 0) {
	        this.$$obtenerCuadro(1);
	        // this.$$obtenerCuadro1();
	        // this.proyecto.financiamiento.cuadro.tipo = 1;
	      } else if (item.indexOf('MIXTA') >= 0) {
	        this.$$obtenerCuadro(2);
	        // this.$$obtenerCuadro2();
	        // this.proyecto.financiamiento.cuadro.tipo = 2;
	      }
	    }
	  }, {
	    key: '$$obtenerCuadro',
	    value: function $$obtenerCuadro(tipo) {
	      var _this3 = this;
	
	      // this.proyecto.financiamiento.cuadro = {};
	      this.DataService.get('contenidos/cuadro_financiamiento/' + tipo).then(function (response) {
	        if (response) {
	          if (response.datos && response.datos.estructura) {
	            _this3.proyecto.financiamiento.cuadro = response.datos.estructura;
	            // console.log('-------------cuadro--------------');
	            // console.log(this.proyecto.financiamiento.cuadro);
	            // console.log('---------------------------------');
	          }
	        }
	      });
	    }
	
	    // $$obtenerCuadro1() {
	    //   // this.proyecto.financiamiento.cuadro = {};
	    //   this.DataService.get(`contenidos/cuadro_financiamiento/1`).then(response => {
	    //     if (response) {
	    //       if (response.datos && response.datos.estructura) {
	    //         this.proyecto.financiamiento.cuadro = response.datos.estructura;
	    //         // console.log('-------------cuadro--------------');
	    //         // console.log(this.proyecto.financiamiento.cuadro);
	    //         // console.log('---------------------------------');
	    //       }
	    //     }
	    //   });
	
	    // this.proyecto.financiamiento.cuadro = {
	    //   datos: [
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 4,
	    //           contenido: `Inversión fija`,
	    //         },
	    //         { contenido: `Infraestructura productiva` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Bienes y/o equipamiento` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Medidas Físicas (infraestructura) de prevención y/o mitigación de impactos ambientales` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Medidas Físicas (infraestructura) de gestión de riesgos` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	
	    //     //*******
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 3,
	    //           contenido: `Capital de trabajo`,
	    //         },
	    //         { contenido: `Mano de obra` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Materia prima e insumos` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Servicios` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	
	    //     //*****
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 5,
	    //           contenido: `Inversión diferida`,
	    //         },
	    //         { contenido: `Gerenciamiento del Proyecto (Administración directa o delegada)` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Capacitación y/o Asistencia Técnica` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Supervisión` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Fiscalización` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Auditoria externa` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'costo_total', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'fdi' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'beneficiarios' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'otros' } },
	    //       ]
	    //     },
	    //   ],
	    //   totales: {
	    //     costo_total: 0,
	    //     fdi: 0,
	    //     gam: 0,
	    //     beneficiarios: 0,
	    //     otros: 0
	    //   },
	    //   tipo: 1
	    // };
	    // }
	
	    // $$obtenerCuadro2() {
	    //   // this.proyecto.financiamiento.cuadro = {};
	    //   this.DataService.get(`contenidos/cuadro_financiamiento/2`).then(response => {
	    //     if (response) {
	    //       if (response.datos && response.datos.estructura) {
	    //         this.proyecto.financiamiento.cuadro = response.datos.estructura;
	    //         // console.log('-------------cuadro2-------------');
	    //         // console.log(this.proyecto.financiamiento.cuadro);
	    //         // console.log('---------------------------------');
	    //       }
	    //     }
	    //   });
	
	    // this.proyecto.financiamiento.cuadro = {
	    //   datos: [
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 4,
	    //           contenido: `Inversión fija`,
	    //         },
	    //         { contenido: `Infraestructura productiva` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Bienes y/o equipamiento` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Medidas Físicas (infraestructura) de prevención y/o mitigación de impactos ambientales` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Medidas Físicas (infraestructura) de gestión de riesgos` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	
	    //     //*******
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 3,
	    //           contenido: `Capital de trabajo`,
	    //         },
	    //         { contenido: `Mano de obra` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Materia prima e insumos` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Servicios` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	
	    //     //*****
	    //     {
	    //       cols: [
	    //         {
	    //           rowspan: 5,
	    //           contenido: `Inversión diferida`,
	    //         },
	    //         { contenido: `Gerenciamiento del Proyecto (Administración directa o delegada)` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Capacitación y/o Asistencia Técnica` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Supervisión (Hasta el 6%)` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Fiscalización` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //     {
	    //       cols: [
	    //         { contenido: `Auditoria externa (Hasta el 2% del FDI)` },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'tfdi', disabled: true } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'gam' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'publico' } },
	    //         { contenido: { type: 'inputMoney', value: 0, name: 'privado' } },
	    //       ]
	    //     },
	    //   ],
	    //   totales: {
	    //     fdi: 0,
	    //     gam: 0,
	    //     publico: 0,
	    //     privado: 0,
	    //     fdi_pp: 0,
	    //     fdi_gam: 0
	    //   },
	    //   tipo: 2
	    // };
	    // }
	
	    // establecerIndicadoresImpacto() {
	    //   if (this.proyecto.beneficiarios && this.proyecto.beneficiarios.indicadores_impacto) {
	    //     let indicadores = this.proyecto.beneficiarios.indicadores_impacto.split(" ");
	    //     if (indicadores.length>0) {
	    //       this.proyecto.beneficiarios.indicadores_impacto_numero = indicadores[0];
	    //       this.proyecto.beneficiarios.indicadores_impacto_unidades = indicadores[1];
	    //     }
	    //   }
	    // }
	
	  }, {
	    key: 'setIndicadores',
	    value: function setIndicadores() {
	      this.proyecto.beneficiarios.subtipo_productivo = null;
	
	      this.proyecto.beneficiarios.indicadores_impacto = [{
	        combinado: null,
	        numero: null,
	        unidades: null,
	        otro: null
	      }];
	    }
	  }, {
	    key: 'cambiarUnidades',
	    value: function cambiarUnidades() {
	      var _unidad = null;
	      switch (this.proyecto.beneficiarios.tipo) {
	        case 'OP_TP_RIEGO':
	          _unidad = 'HA';
	          break;
	        case 'OP_TP_PUENTES':
	          _unidad = 'M';
	          break;
	        default:
	          break;
	      }
	      this.proyecto.beneficiarios.indicadores_impacto[0].unidades = _unidad;
	      if (this.proyecto.informe) {
	        // this.proyecto.informe.valoracion[5].cols[0].contenido = `Valor ${(this.proyecto.beneficiarios.tipo !== 'OP_TP_PRODUCTIVO' && this.proyecto.beneficiarios.tipo !== 'OP_TP_MAQUINARIA') ? 'VANS': 'VANE'}`;
	        // this.proyecto.informe.valoracion[6].cols[0].contenido = `Valor ${(this.proyecto.beneficiarios.tipo !== 'OP_TP_PRODUCTIVO' && this.proyecto.beneficiarios.tipo !== 'OP_TP_MAQUINARIA') ? 'VANP': 'VANF'}`;
	        this.proyecto.informe.valoracion[5].cols[0].contenido = 'valor ' + (!this.Proyecto.tratarComoProductivo(this.proyecto) ? 'VANS' : 'VANE');
	        this.proyecto.informe.valoracion[6].cols[0].contenido = 'valor ' + (!this.Proyecto.tratarComoProductivo(this.proyecto) ? 'VANP' : 'VANF');
	      }
	    }
	  }, {
	    key: 'clearIndicadores',
	    value: function clearIndicadores() {
	      this.proyecto.beneficiarios.indicadores_impacto = [{
	        combinado: null,
	        numero: null,
	        unidades: null,
	        otro: null
	      }];
	    }
	  }, {
	    key: 'combinarIndicadoresImpacto',
	    value: function combinarIndicadoresImpacto() {
	      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.proyecto.beneficiarios.indicadores_impacto[idx].numero && this.proyecto.beneficiarios.indicadores_impacto[idx].unidades) {
	        if (_typeof(this.proyecto.beneficiarios.indicadores_impacto[idx].unidades) === 'object') {
	          if (this.proyecto.beneficiarios.indicadores_impacto[idx].unidades.codigo === 'Otro') {
	            if (this.proyecto.beneficiarios.indicadores_impacto[idx].otro) {
	              this.proyecto.beneficiarios.indicadores_impacto[idx].combinado = this.proyecto.beneficiarios.indicadores_impacto[idx].numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto[idx].otro;
	            } else {
	              this.proyecto.beneficiarios.indicadores_impacto[idx].combinado = this.proyecto.beneficiarios.indicadores_impacto[idx].numero;
	            }
	          } else {
	            this.proyecto.beneficiarios.indicadores_impacto[idx].combinado = this.proyecto.beneficiarios.indicadores_impacto[idx].numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto[idx].unidades.nombre;
	          }
	        } else {
	          this.proyecto.beneficiarios.indicadores_impacto[idx].combinado = this.proyecto.beneficiarios.indicadores_impacto[idx].numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto[idx].unidades;
	        }
	      }
	
	      // if (this.proyecto.beneficiarios.indicadores_impacto_numero && this.proyecto.beneficiarios.indicadores_impacto_unidades) {
	      //   if (typeof this.proyecto.beneficiarios.indicadores_impacto_unidades === 'object') {
	      //     if (this.proyecto.beneficiarios.indicadores_impacto_unidades.codigo === 'Otro') {
	      //       if (this.proyecto.beneficiarios.indicadores_impacto_otro) {
	      //         this.proyecto.beneficiarios.indicadores_impacto = this.proyecto.beneficiarios.indicadores_impacto_numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto_otro;
	      //       } else {
	      //         this.proyecto.beneficiarios.indicadores_impacto = this.proyecto.beneficiarios.indicadores_impacto_numero;
	      //       }
	      //     } else {
	      //       this.proyecto.beneficiarios.indicadores_impacto = this.proyecto.beneficiarios.indicadores_impacto_numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto_unidades.nombre;
	      //     }
	      //   } else {
	      //     this.proyecto.beneficiarios.indicadores_impacto = this.proyecto.beneficiarios.indicadores_impacto_numero + ' ' + this.proyecto.beneficiarios.indicadores_impacto_unidades;
	      //   }
	      // }
	
	      console.log('----------------combine-------------');
	      console.log(this.proyecto.beneficiarios.indicadores_impacto);
	      console.log('------------------------------------');
	    }
	  }, {
	    key: 'actualizarIndicadoresImpacto',
	    value: function actualizarIndicadoresImpacto() {
	      if (this.proyecto.informe) {
	        if (!this.proyecto.informe.indicador) this.proyecto.informe.indicador = {};
	        this.proyecto.informe.indicador.proceso = this.proyecto.beneficiarios.indicadores_impacto[0].combinado;
	      }
	    }
	  }, {
	    key: 'adicionarIndicador',
	    value: function adicionarIndicador() {
	      if (!this.proyecto.beneficiarios.indicadores_impacto) this.proyecto.beneficiarios.indicadores_impacto = [];
	
	      this.proyecto.beneficiarios.indicadores_impacto.push({
	        combinado: null,
	        numero: null,
	        unidades: null,
	        otro: null
	      });
	
	      console.log('----------------add-----------------');
	      console.log(this.proyecto.beneficiarios.indicadores_impacto);
	      console.log('------------------------------------');
	    }
	  }, {
	    key: 'eliminarIndicador',
	    value: function eliminarIndicador($index) {
	      this.proyecto.beneficiarios.indicadores_impacto.splice($index, 1);
	      return;
	    }
	  }, {
	    key: 'limpiarMatriz',
	    value: function limpiarMatriz() {
	      this.proyecto.beneficiarios.productivo = {};
	    }
	  }, {
	    key: 'editarBeneficiarios',
	    value: function editarBeneficiarios() {
	      // if (this.Usuarios.esSupervisor()) return false;
	      return this.Proyecto.esEditable('beneficiarios');
	    }
	  }, {
	    key: 'editarIndicadores',
	    value: function editarIndicadores() {
	      // return this.Usuarios.esTecnicoResponsable() ? true : false;
	      return this.Proyecto.esEditable('evaluacion');
	    }
	  }, {
	    key: 'noEditarCoordenadas',
	    value: function noEditarCoordenadas() {
	      if (this.Usuarios.esSupervisor()) return true;
	      return this.modoVista || !this.editarBeneficiarios();
	    }
	  }, {
	    key: '$$iniciarLeaflet',
	    value: function $$iniciarLeaflet() {
	      this.mapa = {
	        defaults: {
	          minZoom: 5
	        },
	        maxbounds: {
	          northEast: {
	            lat: -8.433237,
	            lng: -71.367187
	          },
	          southWest: {
	            lat: -23.596439,
	            lng: -56.118164
	          }
	        }
	      };
	      var layers = {
	        // Ya no esta disponible estas capas de GeoBolivia
	        // geobolivia_topo: {
	        //   name: 'GeoBolivia Topográfico',
	        //   url: 'https://test.geo.gob.bo/raster/service/wmts?',
	        //   type: 'wms',
	        //   visible: true,
	        //   layerParams: {
	        //     layers: 'mapbox_terrain',
	        //     format: "image/png",
	        //     transparent: true,
	        //     //crs: L.CRS.EPSG4326,
	        //     //version: '1.1.1',
	        //   },
	        //   layerOptions: {
	        //     attribution: '<a href="https://geo.gob.bo" target="_blank">GeoBolivia</a>',
	        //     continuousWorld: false
	        //   }
	        // },
	        // geobolivia_sat: {
	        //   name: 'GeoBolivia Satelital',
	        //   url: 'https://test.geo.gob.bo/raster/service/wms?',
	        //   type: 'wms',
	        //   visible: true,
	        //   layerParams: {
	        //     layers: 'mapbox_bolivia',
	        //     format: "image/png",
	        //     transparent: true,
	        //     //crs: L.CRS.EPSG4326,
	        //     //version: '1.1.1',
	        //   },
	        //   layerOptions: {
	        //     attribution: '<a href="https://geo.gob.bo" target="_blank">GeoBolivia</a>',
	        //     continuousWorld: false
	        //   }
	        // },
	        openstreetmap: {
	          name: 'OpenStreetMap',
	          type: 'xyz',
	          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
	          layerOptions: {
	            subdomains: ['a', 'b', 'c'],
	            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
	            continuousWorld: false
	          }
	        },
	        arcgis: {
	          name: 'Topográfico',
	          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
	          type: 'xyz',
	          layerOptions: {
	            attribution: '<a href="https://www.arcgis.com/home/webmap/viewer.html" target="_blank">ArcGIS</a>',
	            continuousWorld: false
	          }
	        },
	        mapbox_api: {
	          name: 'Escala de grises',
	          url: 'https://api.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
	          type: 'xyz',
	          layerOptions: {
	            apikey: 'pk.eyJ1IjoiY2hlbG9hbGVqb2MiLCJhIjoiY2lod2lkZHdrMDJueHUxbTFqMXRodGUzdyJ9.Vs-56Km_o5AXT9N5QrcLsw',
	            mapid: 'landplanner.map-dsn5dtki',
	            attribution: '<a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a>'
	          }
	        },
	        arcgisimage: {
	          name: 'Imágenes',
	          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
	          type: 'xyz',
	          layerOptions: {
	            attribution: '<a href="https://www.arcgis.com/home/webmap/viewer.html" target="_blank">ArcGIS</a>',
	            continuousWorld: false
	          }
	        }
	      };
	      var sublayers = { //https://geo.gob.bo/geoserver/ows?SERVICE=WMS
	        geobolivia_limit: {
	          name: 'GeoBolivia limite municipio',
	          url: 'https://geo.gob.bo/geoserver/ows',
	          type: 'wms',
	          visible: true,
	          layerParams: {
	            layers: 'municipal',
	            format: "image/png",
	            transparent: true
	            //crs: L.CRS.EPSG4326,
	            //version: '1.1.1',
	          },
	          layerOptions: {
	            attribution: '<a href="https://geo.gob.bo" target="_blank">GeoBolivia</a>',
	            continuousWorld: false
	          }
	        }
	      };
	      this.myLayers = {
	        baselayers: layers,
	        overlays: sublayers
	      };
	    }
	  }]);
	
	  return DatosGenerales;
	}();
	
	exports.default = DatosGenerales;

/***/ }),
/* 553 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var comuControllerModal = function () {
	  comuControllerModal.$inject = ["$uibModalInstance", "DataService", "Loading", "Modal", "data"];
	  function comuControllerModal($uibModalInstance, DataService, Loading, Modal, data) {
	    'ngInject';
	
	    _classCallCheck(this, comuControllerModal);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.Loading = Loading;
	    this.Modal = Modal;
	    this.data = data;
	  }
	
	  _createClass(comuControllerModal, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.opciones = {};
	      this.modoVistaConvenio = false;
	      //console.log("dataaa",this.data);
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'aceptar',
	    value: function aceptar() {
	      this.$uibModalInstance.close(this.data.datos.filter(function (comun) {
	
	        return comun.seleccionado;
	      }));
	    }
	  }]);
	
	  return comuControllerModal;
	}();
	
	exports.default = comuControllerModal;

/***/ }),
/* 554 */
[859, 555, 809],
/* 555 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosGenerales = function () {
	  DatosGenerales.$inject = ["DataService", "apiUrl", "Util", "Proyecto", "Modal", "Message", "$state", "Storage", "$log"];
	  function DatosGenerales(DataService, apiUrl, Util, Proyecto, Modal, Message, $state, Storage, $log) {
	    'ngInject';
	
	    _classCallCheck(this, DatosGenerales);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.Message = Message;
	    this.user = Storage.getUser();
	    this.apiUrl = apiUrl;
	    this.$state = $state;
	    this.log = $log;
	  }
	
	  _createClass(DatosGenerales, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // recogiendo datos cartera de backend con metodo get
	      this.DataService.get('cartera/', {}).then(function (response) {
	        if (response) {
	          _this.carteras = response.datos;
	          _this.log.log('hay ' + _this.carteras.length + ' carteras :', _this.carteras);
	        }
	      });
	
	      // Parámetros de descarga
	      this.descarga = {
	        urlDescarga: this.apiUrl + 'proyectos/' + this.proyecto.id_proyecto + '/doc/RIR/descargar',
	        nombreDescarga: 'Informe Rechazo'
	      };
	      this.proyecto.cite_nro = this.proyecto.nro_convenio.substr(-9);
	      this.proyecto.cite_codigo = this.proyecto.nro_convenio.replace(this.proyecto.cite_nro, '');
	    }
	  }, {
	    key: 'verDocumento',
	    value: function verDocumento(tipo, nombreDocumento) {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/documentos/' + tipo, nombreDocumento);
	    }
	
	    // Funcion temporal para corregir codigo y fecha de solicitud
	
	  }, {
	    key: 'corregirDatosGenerales',
	    value: function corregirDatosGenerales() {
	      var _this2 = this;
	
	      this.Modal.confirm('¿Esta seguro/a de modificar los datos? Deberá regenerar los documentos de evaluacion y/o informes.', function () {
	        var datos = {
	          id_proyecto: _this2.proyecto.id_proyecto,
	          nro_convenio: '' + _this2.proyecto.cite_codigo + _this2.proyecto.cite_nro,
	          fecha_suscripcion_convenio: _this2.proyecto.fecha_suscripcion_convenio
	        };
	        _this2.DataService.put('proyectos/' + _this2.proyecto.id_proyecto, datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this2.Message.success(resp.mensaje);
	            _this2.$state.reload();
	          }
	        });
	      }, null, 'Modificar datos', 'Si, estoy seguro/a');
	    }
	  }, {
	    key: 'modificarUbicacion',
	    value: function modificarUbicacion() {
	      var ubicacion_editable = this.Proyecto.esEditable('fcod_municipio');
	      if (this.proyecto.estado_proyecto == 'REGISTRO_PROYECTO_FDI' && [13, 18].indexOf(this.user.rol.id_rol) >= 0) {
	        ubicacion_editable = true;
	      }
	      return this.modoVista || !ubicacion_editable;
	    }
	  }, {
	    key: 'validarCite',
	    value: function validarCite() {
	      var formato = new RegExp('^[0-9]{4}-[0-9]{4}$');
	      return !formato.test(this.proyecto.cite_nro) || this.proyecto.cite_nro.substr(-4) < 2017;
	    }
	  }, {
	    key: 'puedeModificarCodigo',
	    value: function puedeModificarCodigo(campo) {
	      return (this.proyecto.estado_proyecto == 'RECHAZADO_FDI' || this.Proyecto.esEditable(campo)) && this.proyecto.id_proyecto;
	    }
	  }]);
	
	  return DatosGenerales;
	}();
	
	exports.default = DatosGenerales;

/***/ }),
/* 556 */
[860, 557, 810],
/* 557 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DesembolsoController = function () {
	  DesembolsoController.$inject = ["$timeout", "Proyecto", "Modal", "Util", "Datetime", "Message"];
	  function DesembolsoController($timeout, Proyecto, Modal, Util, Datetime, Message) {
	    'ngInject';
	
	    _classCallCheck(this, DesembolsoController);
	
	    this.$timeout = $timeout;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.Util = Util;
	    this.Datetime = Datetime;
	    this.monto_3 = 0;
	    this.porcentaje_3 = 0;
	    this.Message = Message;
	  }
	
	  _createClass(DesembolsoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.archivo = {
	        urlDocCertificacion: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CIP' : '',
	        urlDocCertificacion2: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CIP2' : '',
	        urlDocCertificacion3: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CIP3' : '',
	        urlDocCertificacionDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CIP/descargar' : '',
	        urlDocCertificacionDescarga2: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CIP2/descargar' : '',
	        urlDocCertificacionDescarga3: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CIP3/descargar' : ''
	      };
	      var fechaConvenio = this.Datetime.getFormatDate(this.proyecto.convenio.fecha_suscripcion);
	      this.validacion = {
	        fecha_minima: this.Datetime.addDaysToDate(angular.copy(fechaConvenio), 0),
	        mensaje_fecminima: 'La fecha debe ser igual o mayor a la fecha del convenio (' + this.Datetime.parseDate(fechaConvenio, '/') + ')',
	        fec_min_inscripcion: this.Datetime.getFormatDate(this.proyecto.convenio.fecha_suscripcion),
	        mensaje_fecminima_desembolso1: 'La fecha debe ser igual o mayor a la fecha de inscripci\xF3n presupuestaria.',
	        mensaje_fecminima_desembolso2: 'La fecha debe ser igual o mayor a la fecha del desembolso anterior.'
	      };
	
	      if (!this.proyecto.cronograma_desembolsos) {
	        if (this.proyecto.beneficiarios.productivo && this.proyecto.beneficiarios.productivo.maquinaria) {
	          this.proyecto.cronograma_desembolsos = {
	            porcentaje_1: 40, //50,
	            porcentaje_2: 40, //30,
	            porcentaje_3: 20 //20,
	          };
	        } else {
	          this.proyecto.cronograma_desembolsos = {
	            porcentaje_1: 40, //20,
	            porcentaje_2: 40, //40,
	            porcentaje_3: 20 //40,
	          };
	        }
	      }
	      if (this.proyecto.financiamiento.monto_total_proyecto) {
	        this.proyecto.cronograma_desembolsos.monto_1 = this.Util.multiplicar([this.proyecto.financiamiento.monto_fdi, this.proyecto.cronograma_desembolsos.porcentaje_1 / 100]);
	        this.proyecto.cronograma_desembolsos.monto_2 = this.Util.multiplicar([this.proyecto.financiamiento.monto_fdi, this.proyecto.cronograma_desembolsos.porcentaje_2 / 100]);
	        this.proyecto.cronograma_desembolsos.monto_3 = this.Util.multiplicar([this.proyecto.financiamiento.monto_fdi, this.proyecto.cronograma_desembolsos.porcentaje_3 / 100]);
	        // this.monto_3 = this.proyecto.cronograma_desembolsos.monto_3;
	        // this.porcentaje_3 = this.proyecto.cronograma_desembolsos.porcentaje_3;
	      }
	
	      this.monto_privado = this.proyecto.financiamiento.cuadro.totales.privado - (this.proyecto.cronograma_desembolsos.priv1 || 0) - (this.proyecto.cronograma_desembolsos.priv2 || 0) - (this.proyecto.cronograma_desembolsos.priv3 || 0);
	      this.monto_publico = this.proyecto.financiamiento.cuadro.totales.publico - (this.proyecto.cronograma_desembolsos.pub1 || 0) - (this.proyecto.cronograma_desembolsos.pub2 || 0) - (this.proyecto.cronograma_desembolsos.pub3 || 0);
	    }
	  }, {
	    key: 'recalcularPorcentaje',
	    value: function recalcularPorcentaje() {
	      // para calcular con porcentajes
	      // this.proyecto.cronograma_desembolsos.monto_1 = this.Util.multiplicar([this.proyecto.financiamiento.monto_fdi,this.proyecto.cronograma_desembolsos.porcentaje_1/100]);
	      // this.proyecto.cronograma_desembolsos.monto_2 = this.Util.multiplicar([this.proyecto.financiamiento.monto_fdi,this.proyecto.cronograma_desembolsos.porcentaje_2/100]);
	      // this.proyecto.cronograma_desembolsos.monto_3 = this.Util.multiplicar([this.proyecto.financiamiento.monto_fdi,this.proyecto.cronograma_desembolsos.porcentaje_3/100]);
	      // this.proyecto.cronograma_desembolsos.monto_4 = this.proyecto.financiamiento.monto_fdi - this.proyecto.cronograma_desembolsos.monto_1 - this.proyecto.cronograma_desembolsos.monto_2 -this.proyecto.cronograma_desembolsos.monto_3;
	      // this.proyecto.cronograma_desembolsos.porcentaje_4 = 100 - this.proyecto.cronograma_desembolsos.porcentaje_3 - this.proyecto.cronograma_desembolsos.porcentaje_2 - this.proyecto.cronograma_desembolsos.porcentaje_1;
	      // this.monto_3 = this.proyecto.cronograma_desembolsos.monto_3;
	      // this.porcentaje_3 = this.proyecto.cronograma_desembolsos.porcentaje_3;
	      //para calcular con montos
	      this.proyecto.cronograma_desembolsos.porcentaje_1 = this.proyecto.cronograma_desembolsos.monto_1 / this.proyecto.financiamiento.monto_fdi * 100;
	      this.proyecto.cronograma_desembolsos.porcentaje_2 = this.proyecto.cronograma_desembolsos.monto_2 / this.proyecto.financiamiento.monto_fdi * 100;
	      this.proyecto.cronograma_desembolsos.porcentaje_3 = this.proyecto.cronograma_desembolsos.monto_3 / this.proyecto.financiamiento.monto_fdi * 100;
	
	      this.proyecto.cronograma_desembolsos.monto_4 = this.proyecto.financiamiento.monto_fdi - this.proyecto.cronograma_desembolsos.monto_1 - this.proyecto.cronograma_desembolsos.monto_2 - this.proyecto.cronograma_desembolsos.monto_3;
	      this.proyecto.cronograma_desembolsos.porcentaje_4 = this.proyecto.cronograma_desembolsos.monto_4 / this.proyecto.financiamiento.monto_fdi * 100;
	
	      // this.monto_privado = this.proyecto.financiamiento.cuadro.totales.privado - this.proyecto.cronograma_desembolsos.priv1 - this.proyecto.cronograma_desembolsos.priv2 - this.proyecto.cronograma_desembolsos.priv3;
	      // this.monto_publico = this.proyecto.financiamiento.cuadro.totales.publico - this.proyecto.cronograma_desembolsos.pub1 - this.proyecto.cronograma_desembolsos.pub2 - this.proyecto.cronograma_desembolsos.pub3;
	      if (this.proyecto.cronograma_desembolsos.monto_1 + this.proyecto.cronograma_desembolsos.monto_2 + this.proyecto.cronograma_desembolsos.monto_3 > this.proyecto.financiamiento.monto_fdi) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.monto_fdi);
	        this.Message.info('El monto asignado para desembolso excede al montoFDI asignado');
	      }
	
	      this.monto_publico = this.proyecto.financiamiento.cuadro.totales.publico - (this.proyecto.cronograma_desembolsos.pub1 || 0) - (this.proyecto.cronograma_desembolsos.pub2 || 0) - (this.proyecto.cronograma_desembolsos.pub3 || 0);
	
	      this.monto_privado = this.proyecto.financiamiento.cuadro.totales.privado - (this.proyecto.cronograma_desembolsos.priv1 || 0) - (this.proyecto.cronograma_desembolsos.priv2 || 0) - (this.proyecto.cronograma_desembolsos.priv3 || 0);
	    }
	  }, {
	    key: 'sumaMontos',
	    value: function sumaMontos() {
	      var _this = this;
	
	      this.proyecto.cronograma_desembolsos.monto_1 = (this.proyecto.cronograma_desembolsos.priv1 || 0) + (this.proyecto.cronograma_desembolsos.pub1 || 0);
	      this.proyecto.cronograma_desembolsos.monto_2 = (this.proyecto.cronograma_desembolsos.priv2 || 0) + (this.proyecto.cronograma_desembolsos.pub2 || 0);
	      this.proyecto.cronograma_desembolsos.monto_3 = (this.proyecto.cronograma_desembolsos.priv3 || 0) + (this.proyecto.cronograma_desembolsos.pub3 || 0);
	
	      // this.monto_privado = this.proyecto.financiamiento.cuadro.totales.privado - this.proyecto.cronograma_desembolsos.priv1 - this.proyecto.cronograma_desembolsos.priv2 - this.proyecto.cronograma_desembolsos.priv3;
	      // this.monto_publico = this.proyecto.financiamiento.cuadro.totales.publico - this.proyecto.cronograma_desembolsos.pub1 - this.proyecto.cronograma_desembolsos.pub2 - this.proyecto.cronograma_desembolsos.pub3;
	
	      if (this.proyecto.cronograma_desembolsos.monto_1 + this.proyecto.cronograma_desembolsos.monto_2 + this.proyecto.cronograma_desembolsos.monto_3 > this.proyecto.financiamiento.monto_fdi) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.monto_fdi);
	        this.Message.warning('El monto asignado para desembolso excede al montoFDI asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.monto_1 > this.proyecto.financiamiento.monto_fdi) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.monto_fdi);
	        this.Message.warning('El monto asignado para desembolso excede al montoFDI asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.monto_2 > this.proyecto.financiamiento.monto_fdi) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.monto_fdi);
	        this.Message.warning('El monto asignado para desembolso excede al montoFDI asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.monto_3 > this.proyecto.financiamiento.monto_fdi) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.monto_fdi);
	        this.Message.warning('El monto asignado para desembolso excede al montoFDI asignado');
	        return;
	      }
	
	      // validando montos excedidos de acuerdo a los montos privados y publicos
	      if (this.proyecto.cronograma_desembolsos.priv1 > this.proyecto.financiamiento.cuadro.totales.privado) {
	        // this.Modal.alert('El monto asignado supera los : '+ this.proyecto.financiamiento.cuadro.totales.privado);
	        this.Modal.alert('El monto asignado supero los : ' + this.proyecto.financiamiento.cuadro.totales.privado, function () {
	          _this.proyecto.cronograma_desembolsos.priv1 = 0;
	          _this.sumaMontos();
	          _this.recalcularPorcentaje();
	        });
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado*/**');
	
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.pub1 > this.proyecto.financiamiento.cuadro.totales.publico) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.financiamiento.cuadro.totales.publico, function () {
	          _this.proyecto.cronograma_desembolsos.pub1 = 0;
	          _this.sumaMontos();
	          _this.recalcularPorcentaje();
	        });
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.priv2 > this.proyecto.financiamiento.cuadro.totales.privado) {
	        this.Modal.alert('El monto asignado supero los : ' + this.proyecto.financiamiento.cuadro.totales.privado, function () {
	          _this.proyecto.cronograma_desembolsos.priv2 = 0;
	          _this.sumaMontos();
	          _this.recalcularPorcentaje();
	        });
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.pub2 > this.proyecto.financiamiento.cuadro.totales.publico) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.financiamiento.cuadro.totales.publico, function () {
	          _this.proyecto.cronograma_desembolsos.pub2 = 0;
	          _this.sumaMontos();
	          _this.recalcularPorcentaje();
	        });
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.priv3 > this.proyecto.financiamiento.cuadro.totales.privado) {
	        this.Modal.alert('El monto asignado supero los : ' + this.proyecto.financiamiento.cuadro.totales.privado, function () {
	          _this.proyecto.cronograma_desembolsos.priv3 = 0;
	          _this.sumaMontos();
	          _this.recalcularPorcentaje();
	        });
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.pub3 > this.proyecto.financiamiento.cuadro.totales.publico) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.financiamiento.cuadro.totales.publico, function () {
	          _this.proyecto.cronograma_desembolsos.pub3 = 0;
	          _this.sumaMontos();
	          _this.recalcularPorcentaje();
	        });
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	
	      if (this.proyecto.cronograma_desembolsos.priv1 + this.proyecto.cronograma_desembolsos.priv2 + this.proyecto.cronograma_desembolsos.priv3 > this.proyecto.financiamiento.cuadro.totales.privado) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.financiamiento.cuadro.totales.privado);
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.pub1 + this.proyecto.cronograma_desembolsos.pub2 + this.proyecto.cronograma_desembolsos.pub3 > this.proyecto.financiamiento.cuadro.totales.publico) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.financiamiento.cuadro.totales.publico);
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	
	      if (this.proyecto.cronograma_desembolsos.priv1 + this.proyecto.cronograma_desembolsos.priv2 > this.proyecto.financiamiento.cuadro.totales.privado) {
	        // this.Modal.alert('El monto asignado supera los : '+ this.proyecto.financiamiento.cuadro.totales.privado);
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.pub1 + this.proyecto.cronograma_desembolsos.pub2 > this.proyecto.financiamiento.cuadro.totales.publico) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.financiamiento.cuadro.totales.publico);
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	
	      if (this.proyecto.cronograma_desembolsos.priv1 + this.proyecto.cronograma_desembolsos.priv3 > this.proyecto.financiamiento.cuadro.totales.privado) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.financiamiento.cuadro.totales.privado);
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.pub1 + this.proyecto.cronograma_desembolsos.pub3 > this.proyecto.financiamiento.cuadro.totales.publico) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.financiamiento.cuadro.totales.publico);
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	
	      if (this.proyecto.cronograma_desembolsos.priv2 + this.proyecto.cronograma_desembolsos.priv3 > this.proyecto.financiamiento.cuadro.totales.privado) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.financiamiento.cuadro.totales.privado);
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	      if (this.proyecto.cronograma_desembolsos.pub2 + this.proyecto.cronograma_desembolsos.pub3 > this.proyecto.financiamiento.cuadro.totales.publico) {
	        this.Modal.alert('El monto asignado supera los : ' + this.proyecto.financiamiento.cuadro.totales.publico);
	        this.Message.warning('El monto asignado para desembolso excede al monto privado asignado');
	        return;
	      }
	    }
	  }, {
	    key: 'selFechaDesembolso',
	    value: function selFechaDesembolso() {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        _this2.proyecto.fecha_desembolso = _this2.proyecto.cronograma_desembolsos.fecha_1;
	      }, 5);
	    }
	  }]);
	
	  return DesembolsoController;
	}();
	
	exports.default = DesembolsoController;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ejecutarTransicion = __webpack_require__(559);
	
	var _ejecutarTransicion2 = _interopRequireDefault(_ejecutarTransicion);
	
	var _ejecutarTransicion3 = __webpack_require__(811);
	
	var _ejecutarTransicion4 = _interopRequireDefault(_ejecutarTransicion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EjecutarTransicion = {
	  bindings: {
	    proyecto: '=',
	    supervision: '=',
	    elemento: '=',
	    servicio: '<', // servicio del elemento (Proyecto/Computo)
	    form: '<',
	    atributoEstado: '@',
	    url: '<',
	    opcionCancelar: '<?',
	    confirmar: '<?',
	    mensajeConfirmacion: '@?',
	    mensajeButton: '<?', // objeto de mensajes segun label del boton.
	    metodoPrevio: '&?',
	    metodoPosterior: '@?', // debe ser un string ya que se usará $emit
	    validacionParalela: '&?' // metodo que permite realizar una validacion paralela en el componente origen conjuntamente la directiva "validarFormulario"
	  },
	  controller: _ejecutarTransicion2.default,
	  template: _ejecutarTransicion4.default
	};
	
	exports.default = EjecutarTransicion;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _observacionModalController = __webpack_require__(85);
	
	var _observacionModalController2 = _interopRequireDefault(_observacionModalController);
	
	var _observacionModal = __webpack_require__(98);
	
	var _observacionModal2 = _interopRequireDefault(_observacionModal);
	
	var _rechazarModalController = __webpack_require__(560);
	
	var _rechazarModalController2 = _interopRequireDefault(_rechazarModalController);
	
	var _rechazarModal = __webpack_require__(812);
	
	var _rechazarModal2 = _interopRequireDefault(_rechazarModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EjecutarTransicion = function () {
	  EjecutarTransicion.$inject = ["DataService", "Util", "Proyecto", "$state", "Modal", "Loading", "Message", "$scope", "_", "Storage", "$q", "$log", "Computo"];
	  function EjecutarTransicion(DataService, Util, Proyecto, $state, Modal, Loading, Message, $scope, _, Storage, $q, $log, Computo) {
	    'ngInject';
	
	    _classCallCheck(this, EjecutarTransicion);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.$state = $state;
	    this.Modal = Modal;
	    this.Loading = Loading;
	    this.Message = Message;
	    this.$scope = $scope;
	    this._ = _;
	    this.Storage = Storage;
	    this.$q = $q;
	    this.$log = $log;
	    this.Computo = Computo;
	  }
	
	  _createClass(EjecutarTransicion, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      setTimeout(function () {
	        if ([13].indexOf(_this.getRolUsuario()) !== -1 && _this.Proyecto.estadoActual && _this.Proyecto.estadoActual.codigo === 'REGISTRO_PROYECTO_FDI') {
	          console.log('autoguardado activado');
	          // Autoguardado cada 5 minutos
	          _this.interval = setInterval(function () {
	            var usuario = _this.Storage.getUser();
	            // Verificar si puede guardar
	            if (!usuario || usuario.id_usuario !== _this.usuario.id_usuario || _this.$state.$current.name !== 'reg-proyecto') {
	              clearInterval(_this.interval);
	              return;
	            }
	            var accionAutoguardado = {
	              estado: 'REGISTRO_PROYECTO_FDI',
	              label: 'Guardar',
	              autoguardado: true
	            };
	            _this.ejecutarAccion(accionAutoguardado);
	          }, 120000);
	        }
	      }, 3000);
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      clearInterval(this.interval);
	    }
	  }, {
	    key: 'getRolUsuario',
	    value: function getRolUsuario() {
	      this.usuario = this.Storage.getUser();
	      return this.usuario.rol.id_rol;
	    }
	  }, {
	    key: 'puedeAcceder',
	    value: function puedeAcceder() {
	      if (!this.elemento || !this.elemento.estado_actual || !this.elemento.estado_actual.roles) {
	        return;
	      }
	      return this.elemento.estado_actual.roles.indexOf(this.getRolUsuario()) !== -1 || this.elemento.estado_actual.codigo == 'ASIGNACION_EQUIPO_TECNICO_FDI' && [13].indexOf(this.getRolUsuario()) !== -1 || this.elemento.estado_actual.codigo == 'APROBADO_FDI' && [18, 16].indexOf(this.getRolUsuario()) !== -1 || this.elemento.estado_actual.codigo == 'EN_EJECUCION_FDI' && [18, 17, 16, 15, 14, 13].indexOf(this.getRolUsuario()) !== -1 || this.elemento.estado_actual.codigo == 'NO_OBJECION_FDI' && [22].indexOf(this.getRolUsuario()) !== -1;
	    }
	
	    /**
	     * ejecutarAccion - Ejecuta la transición para un elemento, verifica si previa a la ejecución
	     * se debe registrar una observación o simplemente realizar un guardado (sin pasar a un siguiente estado)
	     * o en todo caso si existe un método previo a ejecutar (obtenido del controlador de donde se llama a este componente)
	     * se ejecuta el mismo para luego proceder a ejecutar la transición
	     *
	     * @param  {object} accion Objeto donde se tiene los detalles de la acción a ejecutar
	     * @return {function}        Devuelve el método a ejecutar
	     */
	
	  }, {
	    key: 'ejecutarAccion',
	    value: function ejecutarAccion(accion) {
	      var _this2 = this;
	
	      if (accion.rechazar) {
	        return this.rechazarProyecto(accion);
	      }
	      if (accion.observacion) {
	        return this.registrarObservacion(accion);
	      }
	      if (accion.guardar) {
	        return this.guardarDatos();
	      }
	      if (accion.autoguardado) {
	        return this.ejecutarAutoguardado();
	      }
	      if (!this.metodoPrevio || accion.retroceder) {
	        return this.ejecutarTransicion(accion);
	      } else {
	        this.metodoPrevio({ accion: accion }).then(function (result) {
	          _this2.confirmar = result && result.confirmar && !accion.continuar && !accion.retroceder ? result.confirmar : false;
	          return _this2.ejecutarTransicion(accion);
	        }).catch(function () {});
	      }
	    }
	  }, {
	    key: 'registrarObservacion',
	    value: function registrarObservacion(accion) {
	      var _this3 = this;
	
	      var modalObservacion = this.Modal.show({
	        template: _observacionModal2.default,
	        controller: _observacionModalController2.default,
	        data: this.elemento,
	        size: 'md'
	      });
	
	      modalObservacion.result.then(function (elementoActualizado) {
	        _this3.elemento = elementoActualizado;
	        return _this3.ejecutarTransicion(accion);
	      }).catch(function () {});
	    }
	  }, {
	    key: 'rechazarProyecto',
	    value: function rechazarProyecto(accion) {
	      var _this4 = this;
	
	      var modalRechazo = this.Modal.show({
	        template: _rechazarModal2.default,
	        controller: _rechazarModalController2.default,
	        data: this.elemento,
	        size: 'lg'
	      });
	
	      modalRechazo.result.then(function (elementoActualizado) {
	        _this4.elemento = elementoActualizado;
	        return _this4.ejecutarTransicion(accion);
	      }).catch(function () {});
	    }
	  }, {
	    key: 'ejecutarTransicion',
	    value: function ejecutarTransicion(accion) {
	      var DATOS = {};
	      DATOS[this.atributoEstado] = accion.estado;
	      var registrar = void 0;
	      if (accion.continuar || accion.retroceder) {
	        // Cambia de estado sin redirigir a bandeja
	        registrar = this.registrarTransicion.bind(this, DATOS, null, null, this.recargarActual.bind(this));
	      } else {
	        registrar = this.registrarTransicion.bind(this, DATOS, null, null, this.volverABandeja.bind(this));
	      }
	      if (this.confirmar && !accion.rechazar && !accion.observacion && !accion.continuar && !accion.retroceder) {
	        return this.confirmacionPrevia(registrar, accion);
	      }
	      return registrar();
	    }
	  }, {
	    key: 'confirmacionPrevia',
	    value: function confirmacionPrevia(callback, accion) {
	      var mensaje = this.mensajeConfirmacion || '\xBFEst\xE1 seguro/a de derivar el proceso a la siguiente instancia?';
	      if (this.mensajeButton && this.mensajeButton[accion.label]) {
	        mensaje = this.mensajeButton[accion.label];
	      }
	      this.Modal.confirm(mensaje, function () {
	        return callback();
	      }, null, 'Confirmar envío', 'Si, estoy seguro/a', 'Cancelar');
	    }
	  }, {
	    key: 'registrarTransicion',
	    value: function registrarTransicion(data, mensajeLoading, mensajeExito, metodoPosterior) {
	      var _this5 = this;
	
	      this.Loading.show(mensajeLoading || 'Derivando', true);
	      var DATOS = angular.merge(this.servicio.getDatosSegunEstado(this.elemento, this.form), data || {});
	
	      // DATOS.rol = this.usuario.rol.id_rol;
	      DATOS.rol = this.getRolUsuario();
	      this.DataService.put('' + this.url, DATOS).then(function (response) {
	        _this5.Loading.hide();
	        if (response) {
	          _this5.Message.success(mensajeExito || response.mensaje || 'Se envió el proceso a la siguiente instancia correctamente.');
	          if (_this5.metodoPosterior) {
	            _this5.$scope.$emit(_this5.metodoPosterior);
	          } else if (metodoPosterior) {
	            return metodoPosterior(response.datos);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'guardarDatos',
	    value: function guardarDatos() {
	      delete this.elemento[this.atributoEstado];
	      return this.registrarTransicion(null, 'Guardando datos', 'Se guardó los datos', this.actualizarDatosElemento.bind(this));
	    }
	  }, {
	    key: 'ejecutarAutoguardado',
	    value: function ejecutarAutoguardado() {
	      delete this.elemento[this.atributoEstado];
	      var DATOS = angular.merge(this.servicio.getDatosSegunEstado(this.elemento, this.form), {});
	      // DATOS.rol = this.usuario.rol.id_rol;
	      DATOS.rol = this.getRolUsuario();
	      this.DataService.put('' + this.url, DATOS).then(function (response) {
	        if (response) {
	          console.log('autoguardado ' + new Date());
	        }
	      });
	    }
	
	    /**
	     * actualizarDatosElemento - Actualizando datos de un elemento, de acuerdo a los atributos modificados
	     *
	     * @param  {Object} aElemento Datos del elemento actualizado mediante servicio
	     */
	
	  }, {
	    key: 'actualizarDatosElemento',
	    value: function actualizarDatosElemento(aElemento) {
	      var _this6 = this;
	
	      this._.keys(this.servicio.getDatosSegunEstado(this.elemento, this.form)).map(function (item) {
	        _this6.elemento[item] = aElemento[item];
	      });
	      this.servicio.setCopia(this.elemento);
	      if (!this.elemento.hasOwnProperty('' + this.atributoEstado) || this.elemento[this.atributoEstado] == "") {
	        if (aElemento.hasOwnProperty('' + this.atributoEstado)) {
	          this.elemento[this.atributoEstado] = aElemento[this.atributoEstado];
	        }
	      }
	    }
	  }, {
	    key: 'cancelar',
	    value: function cancelar() {
	      this.volverABandeja();
	    }
	  }, {
	    key: 'volverABandeja',
	    value: function volverABandeja() {
	      this.usuario = this.Storage.getUser();
	      this.$state.go(this.usuario.pathInicio.replace('/', ''));
	    }
	  }, {
	    key: 'recargarActual',
	    value: function recargarActual() {
	      this.$state.reload();
	    }
	  }]);
	
	  return EjecutarTransicion;
	}();
	
	exports.default = EjecutarTransicion;

/***/ }),
/* 560 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RechazarController = function () {
	  RechazarController.$inject = ["$uibModalInstance", "data"];
	  function RechazarController($uibModalInstance, data) {
	    'ngInject';
	
	    _classCallCheck(this, RechazarController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	  }
	
	  _createClass(RechazarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.data.observacion = null;
	      this.data.rechazo_definitivo = null;
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.data.observacion = null;
	      this.data.motivo_rechazo = null;
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'rechazar',
	    value: function rechazar() {
	      this.$uibModalInstance.close(this.data);
	    }
	  }]);
	
	  return RechazarController;
	}();
	
	exports.default = RechazarController;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _equipoTecnico = __webpack_require__(562);
	
	var _equipoTecnico2 = _interopRequireDefault(_equipoTecnico);
	
	var _equipoTecnico3 = __webpack_require__(813);
	
	var _equipoTecnico4 = _interopRequireDefault(_equipoTecnico3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EquipoTecnicoComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _equipoTecnico2.default,
	  template: _equipoTecnico4.default
	};
	
	exports.default = EquipoTecnicoComponent;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _registroModal = __webpack_require__(563);
	
	var _registroModal2 = _interopRequireDefault(_registroModal);
	
	var _registroModal3 = __webpack_require__(814);
	
	var _registroModal4 = _interopRequireDefault(_registroModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EquipoTecnicoController = function () {
	  EquipoTecnicoController.$inject = ["Modal", "DataService", "_", "Usuarios", "Message", "Storage", "Util"];
	  function EquipoTecnicoController(Modal, DataService, _, Usuarios, Message, Storage, Util) {
	    'ngInject';
	
	    _classCallCheck(this, EquipoTecnicoController);
	
	    this.Modal = Modal;
	    this.Message = Message;
	    this.DataService = DataService;
	    this.user = Storage.getUser();
	    this._ = _;
	    this.Usuarios = Usuarios;
	    this.url = '';
	    this.esEquipoCompleto = true;
	    this.Util = Util;
	  }
	
	  _createClass(EquipoTecnicoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.listaEquipo = [];
	      if (!this.adjudicaciones) {
	        this.adjudicaciones = {};
	      }
	      if (!this.adjudicaciones.empresas) {
	        this.adjudicaciones.empresas = [];
	      }
	      this.adjudicaciones.nro_adjudicaciones = this.adjudicaciones.empresas.length;
	
	      this.url = 'proyectos/' + this.proyecto.id_proyecto + '/equipos_tecnicos';
	      this.getCargos();
	      this.getListaEquipo();
	      this.urlReconfirmacion = 'proyectos/' + this.proyecto.id_proyecto + '/equipos_tecnicos/';
	      this.esResponsableProy = this.Usuarios.esResponsableProyecto();
	      this.esResponsableGAM = this.Usuarios.esResponsableGAM();
	      this.esFiscal = this.Usuarios.esFiscal();
	
	      this.monto_total = this.proyecto.financiamiento.monto_total_proyecto > this.proyecto.monto_total ? this.proyecto.financiamiento.monto_total_proyecto : this.proyecto.monto_total;
	      this.monto_restante = this.proyecto.monto_total;
	      this.monto_total_adjudicado = 0;
	      this.obtenerAdjudicaciones();
	    }
	  }, {
	    key: 'getListaEquipo',
	    value: function getListaEquipo() {
	      var _this = this;
	
	      this.DataService.get(this.url + '?rol=' + this.user.rol.id_rol).then(function (result) {
	        if (result && result.finalizado) {
	          _this.listaEquipo = result.datos.rows;
	          _this.verificarEquipoCompleto();
	          _this.proyecto.equipo_tecnico = _this.listaEquipo;
	        }
	      });
	    }
	  }, {
	    key: 'getCargos',
	    value: function getCargos() {
	      var _this2 = this;
	
	      this.DataService.get('parametricas/CARGO').then(function (response) {
	        if (response) {
	          _this2.cargos = response.datos.rows;
	          _this2.verificarEquipoCompleto();
	        }
	      });
	    }
	  }, {
	    key: 'adicionar',
	    value: function adicionar(callbackOk, callbackCancel) {
	      var _this3 = this;
	
	      var adicionMiembro = this.Modal.show({
	        template: _registroModal4.default,
	        controller: _registroModal2.default,
	        data: { equipo: this.listaEquipo, cargos: this.cargos, registrar: !callbackOk },
	        size: 'lg'
	      });
	      adicionMiembro.result.then(function (result) {
	        if (result) {
	          if (typeof callbackOk === 'function') {
	            callbackOk(result);
	          }
	          _this3.getListaEquipo();
	        } else {
	          if (typeof callbackCancel === 'function') {
	            callbackCancel();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getListaEquipoAdjudicacion',
	    value: function getListaEquipoAdjudicacion(index) {
	      var _this4 = this;
	
	      var urlEquipoTecnico = 'proyectos/' + this.proyecto.id_proyecto + '/equipos_tecnicos/adjudicaciones/' + this.adjudicaciones.empresas[index].id_adjudicacion;
	      var servicioEquipoTecnico = 'get';
	      this.DataService[servicioEquipoTecnico](urlEquipoTecnico).then(function (resultEquipoTecnico) {
	        if (resultEquipoTecnico) {
	          _this4.adjudicaciones.empresas[index].equipo = resultEquipoTecnico.datos.rows;
	        }
	      });
	    }
	  }, {
	    key: 'cargoSupervisor',
	    value: function cargoSupervisor() {
	      var supervisor = [];
	      for (var i = 0; i < this.cargos.length; i++) {
	        if (this.cargos[i].codigo == 'CG_SUPERVISOR') {
	          supervisor.push(this.cargos[i]);
	        }
	      }
	      return supervisor;
	    }
	  }, {
	    key: 'adicionarSupervisorAdjudicacion',
	    value: function adicionarSupervisorAdjudicacion(index, callbackOk, callbackCancel) {
	      var _this5 = this;
	
	      var adicionMiembro = this.Modal.show({
	        template: _registroModal4.default,
	        controller: _registroModal2.default,
	        data: {
	          id_adjudicacion: this.adjudicaciones.empresas[index].id_adjudicacion,
	          referencia: this.adjudicaciones.empresas[index].referencia,
	          equipo: this.adjudicaciones.empresas[index].equipo,
	          cargos: this.cargoSupervisor(),
	          registrar: !callbackOk
	        },
	        size: 'lg'
	      });
	      adicionMiembro.result.then(function (result) {
	        if (result) {
	          if (typeof callbackOk === 'function') {
	            callbackOk(result);
	          }
	          _this5.getListaEquipoAdjudicacion(index);
	        } else {
	          if (typeof callbackCancel === 'function') {
	            callbackCancel();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'verificarEquipoCompleto',
	    value: function verificarEquipoCompleto() {
	      var _this6 = this;
	
	      var nroMiembros = 0;
	      this.cargos.map(function (cargo) {
	        var MIEMBRO = _this6._.find(_this6.listaEquipo, function (miembro) {
	          return miembro.cargo === cargo.codigo;
	        });
	        if (MIEMBRO) {
	          nroMiembros++;
	        }
	      });
	      this.esEquipoCompleto = this.cargos.length === nroMiembros;
	    }
	  }, {
	    key: 'esSupervisorOFiscal',
	    value: function esSupervisorOFiscal(usuario) {
	      return usuario.estado == 'ACTIVO' && ['CG_SUPERVISOR', 'CG_FISCAL'].indexOf(usuario.cargo) >= 0;
	    }
	  }, {
	    key: 'verDatos',
	    value: function verDatos(miembro) {
	      var _this7 = this;
	
	      var EDICION = this.Modal.show({
	        template: _registroModal4.default,
	        controller: _registroModal2.default,
	        data: { equipo: this.listaEquipo, cargos: this.cargos, miembro: miembro, modoVista: this.modoVista },
	        size: 'lg'
	      });
	
	      EDICION.result.then(function (result) {
	        if (result) {
	          _this7.getListaEquipo();
	        }
	      });
	    }
	  }, {
	    key: 'inactivarUsuarioAdjudicacion',
	    value: function inactivarUsuarioAdjudicacion(usuario, index) {
	      var _this8 = this;
	
	      console.log("index usuario=>" + usuario);
	      var datos_usuario = this.adjudicaciones.empresas[index].equipo[usuario];
	      console.log(datos_usuario);
	      var mensaje = 'Esta seguro/a de inhabilitar al ' + datos_usuario.cargo_usuario.nombre + '?<br><br>Este usuario ya no podra ser habilitado nuevamente con el mismo cargo.<br><br>* Deber\xE1 agregar un nuevo usuario.';
	      this.Modal.confirm(mensaje, function () {
	        console.log("inactivar");
	        _this8.adjudicaciones.empresas[index].equipo[usuario].estado = 'INACTIVO';
	        _this8.adicionarSupervisorAdjudicacion(index, function (persona) {
	          _this8.DataService.put(_this8.url + '/' + datos_usuario.id_equipo_tecnico + '/reemplazar', persona).then(function (resp) {
	            if (resp && resp.finalizado) {
	              _this8.getListaEquipoAdjudicacion(index);
	            } else {
	              _this8.Message.warning('Sucedió un problema al realizar la inhabilitación.');
	            }
	          });
	        }, function () {
	          _this8.adjudicaciones.empresas[index].equipo[usuario].estado = 'ACTIVO';
	        });
	      }, null, 'Inhabilitar', 'Si estoy seguro/a', null, 'ban');
	    }
	  }, {
	    key: 'inactivarUsuario',
	    value: function inactivarUsuario(usuario) {
	      var _this9 = this;
	
	      var mensaje = 'Esta seguro/a de inhabilitar al ' + usuario.cargo_usuario.nombre + '?<br><br>Este usuario ya no podra ser habilitado nuevamente con el mismo cargo.<br><br>* Deber\xE1 agregar un nuevo usuario.';
	      this.Modal.confirm(mensaje, function () {
	        usuario.estado = 'INACTIVO';
	        _this9.adicionar(function (persona) {
	          _this9.DataService.put(_this9.url + '/' + usuario.id_equipo_tecnico + '/reemplazar', persona).then(function (resp) {
	            if (resp && resp.finalizado) {
	              _this9.getListaEquipo();
	            } else {
	              _this9.Message.warning('Sucedió un problema al realizar la inhabilitación.');
	            }
	          });
	        }, function () {
	          usuario.estado = 'ACTIVO';
	        });
	      }, null, 'Inhabilitar', 'Si estoy seguro/a', null, 'ban');
	    }
	  }, {
	    key: 'guardarAdjudicacion',
	    value: function guardarAdjudicacion(index) {
	      var _this10 = this;
	
	      var url = 'proyectos/' + this.proyecto.id_proyecto + '/adjudicaciones';
	      var servicio = 'post';
	      if (this.adjudicaciones.empresas[index].id_adjudicacion > 0) {
	        url = 'proyectos/' + this.proyecto.id_proyecto + '/adjudicaciones/' + this.adjudicaciones.empresas[index].id_adjudicacion;
	        servicio = 'put';
	      }
	
	      var adjudicacion = angular.copy(this.adjudicaciones.empresas[index]);
	      if (adjudicacion.doc_adjudicacion === null) {
	        delete adjudicacion.doc_adjudicacion;
	      }
	      // if (adjudicacion.monto <= this.monto_restante) {
	      this.DataService[servicio](url, adjudicacion).then(function (result) {
	        if (result) {
	          _this10.Message.success(result.mensaje);
	          _this10.adjudicaciones.empresas[index].id_adjudicacion = result.datos.id_adjudicacion;
	          _this10.adjudicaciones.empresas[index].doc_adjudicacion = result.datos.doc_adjudicacion;
	          _this10.adjudicaciones.empresas[index].archivo = {};
	          var docAdjudicacion = _this10.adjudicaciones.empresas[index].doc_adjudicacion.substring(1, _this10.adjudicaciones.empresas[index].doc_adjudicacion.indexOf(']'));
	          _this10.adjudicaciones.empresas[index].archivo.url = 'proyectos/' + _this10.proyecto.id_proyecto + '/doc/' + docAdjudicacion;
	          _this10.adjudicaciones.empresas[index].archivo.urlDescarga = 'proyectos/' + _this10.proyecto.id_proyecto + '/doc/' + docAdjudicacion + '/descargar';
	          _this10.monto_restante = _this10.calcularMontoRestante();
	        }
	      });
	      // } else {
	      //   this.Message.warning('El monto asignado excede el monto disponible restante para adjudicaciones');
	      // }
	    }
	  }, {
	    key: 'agregarAdjudicacion',
	    value: function agregarAdjudicacion() {
	      if (!this.adjudicaciones) {
	        this.adjudicaciones = {};
	      }
	      if (!this.adjudicaciones.empresas) {
	        this.adjudicaciones.empresas = [];
	      }
	      var empresa = {
	        id_adjudicacion: 0,
	        nro: this.adjudicaciones.nro_adjudicaciones ? this.adjudicaciones.nro_adjudicaciones + 1 : 1,
	        monto: 0,
	        referencia: '',
	        doc_adjudicacion: null
	      };
	      this.adjudicaciones.empresas.push(empresa);
	      this.adjudicaciones.nro_adjudicaciones = this.adjudicaciones.empresas.length;
	    }
	  }, {
	    key: 'quitarAdjudicacion',
	    value: function quitarAdjudicacion(index) {
	      var _this11 = this;
	
	      if (this.adjudicaciones.empresas[index].id_adjudicacion > 0) {
	        this.Modal.confirm('Esta seguro/a de Eliminar la Adjudicacion ' + this.adjudicaciones.empresas[index].referencia, function () {
	          var adjudicacion = _this11.adjudicaciones.empresas[index];
	          adjudicacion.estado = 'INACTIVO';
	          var url = 'proyectos/' + _this11.proyecto.id_proyecto + '/adjudicaciones/' + adjudicacion.id_adjudicacion + '/eliminar';
	          var servicio = 'put';
	          _this11.DataService[servicio](url, adjudicacion).then(function (result) {
	            if (result) {
	              _this11.Message.success(result.mensaje);
	              _this11.adjudicaciones.empresas.splice(index, 1);
	              _this11.adjudicaciones.nro_adjudicaciones = _this11.adjudicaciones.empresas.length;
	              _this11.monto_restante = _this11.calcularMontoRestante();
	            }
	          });
	        }, null, 'Inhabilitar', 'Si estoy seguro/a', null, 'ban');
	      } else {
	        if (this.adjudicaciones.empresas && this.adjudicaciones.empresas.length > 0) {
	          this.adjudicaciones.empresas.splice(index, 1);
	          this.adjudicaciones.nro_adjudicaciones = this.adjudicaciones.empresas.length;
	          this.monto_restante = this.calcularMontoRestante();
	        }
	      }
	    }
	  }, {
	    key: 'tieneFiscal',
	    value: function tieneFiscal() {
	      for (var i = 0; i < this.listaEquipo.length; i++) {
	        if (this.listaEquipo[i].cargo == 'CG_FISCAL') {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'tieneSupervisor',
	    value: function tieneSupervisor(adjudicacion) {
	      if (adjudicacion && adjudicacion.equipo && adjudicacion.equipo.length > 0) {
	        for (var i = 0; i < adjudicacion.equipo.length; i++) {
	          if (adjudicacion.equipo[i].cargo === 'CG_SUPERVISOR') {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'tieneSupervisiones',
	    value: function tieneSupervisiones(index) {
	      if (this.adjudicaciones.empresas && this.adjudicaciones.empresas[index].id_adjudicacion > 0) {
	        var adjudicacionActual = this.adjudicaciones.empresas[index].id_adjudicacion;
	        if (this.proyecto && this.proyecto.supervisiones && this.proyecto.supervisiones.length > 0) {
	          for (var i in this.proyecto.supervisiones) {
	            if (this.proyecto.supervisiones[i].fid_adjudicacion === adjudicacionActual) {
	              return true;
	            }
	          }
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeVerAdjudicaciones',
	    value: function puedeVerAdjudicaciones() {
	      return this.proyecto && ['ASIGNACION_EQUIPO_TECNICO_FDI', 'APROBADO_FDI', 'EN_EJECUCION_FDI', 'REVISION_SEGUIMIENTO_FDI', 'ASIGNACION_TECNICO_CIERRE_FDI', 'EN_CIERRE_FDI', 'REVISION_CIERRE_FDI', 'VALIDACION_JEFE_DTP'].indexOf(this.proyecto.estado_proyecto) >= 0 && this.tieneFiscal();
	    }
	  }, {
	    key: 'obtenerAdjudicaciones',
	    value: function obtenerAdjudicaciones() {
	      var _this12 = this;
	
	      var url = 'proyectos/' + this.proyecto.id_proyecto + '/adjudicaciones';
	      var servicio = 'get';
	      this.DataService[servicio](url).then(function (result) {
	        if (result) {
	          var _loop = function _loop(i) {
	            var adjudicacion = result.datos.rows[i];
	            adjudicacion.archivo = {};
	            var docAdjudicacion = adjudicacion.doc_adjudicacion.substring(1, adjudicacion.doc_adjudicacion.indexOf(']'));
	            adjudicacion.archivo.url = 'proyectos/' + _this12.proyecto.id_proyecto + '/doc/' + docAdjudicacion;
	            adjudicacion.archivo.urlDescarga = 'proyectos/' + _this12.proyecto.id_proyecto + '/doc/' + docAdjudicacion + '/descargar';
	            _this12.adjudicaciones.empresas.push(adjudicacion);
	            var urlEquipoTecnico = 'proyectos/' + _this12.proyecto.id_proyecto + '/equipos_tecnicos/adjudicaciones/' + adjudicacion.id_adjudicacion;
	            var servicioEquipoTecnico = 'get';
	            _this12.DataService[servicioEquipoTecnico](urlEquipoTecnico).then(function (resultEquipoTecnico) {
	              if (resultEquipoTecnico) {
	                adjudicacion.equipo = resultEquipoTecnico.datos.rows;
	              }
	            });
	          };
	
	          for (var i = 0; i < result.datos.rows.length; i++) {
	            _loop(i);
	          }
	          _this12.adjudicaciones.nro_adjudicaciones = _this12.adjudicaciones.empresas.length;
	          if (_this12.adjudicaciones.nro_adjudicaciones > 0) {
	            _this12.monto_restante = _this12.calcularMontoRestante();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'calcularMontoRestante',
	    value: function calcularMontoRestante() {
	      this.proyecto.monto_transferido = this.Util.sumar([this.proyecto.cronograma_desembolsos.monto_1, this.proyecto.cronograma_desembolsos.monto_2, this.proyecto.cronograma_desembolsos.monto_3]);
	      var monto_restante = this.proyecto.monto_fdi;
	      // console.log(this,"monto_restante")
	      for (var i in this.adjudicaciones.empresas) {
	        // console.log("this.adjudicaciones.empresasp["+i+"]",this.adjudicaciones.empresas[i])
	        var _adjudicacion = this.adjudicaciones.empresas[i];
	        if (_adjudicacion.estado !== 'INACTIVO') {
	          monto_restante -= _adjudicacion.monto ? _adjudicacion.monto : 0;
	          this.monto_total_adjudicado = _adjudicacion.monto ? this.monto_total_adjudicado + _adjudicacion.monto : 0;
	          // console.log("monto_restante :",monto_restante)
	        }
	      }
	      return monto_restante;
	    }
	  }]);
	
	  return EquipoTecnicoController;
	}();
	
	exports.default = EquipoTecnicoController;

/***/ }),
/* 563 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RegistroFiscalSupervisorController = function () {
	  RegistroFiscalSupervisorController.$inject = ["$uibModalInstance", "DataService", "$stateParams", "data", "_", "Message"];
	  function RegistroFiscalSupervisorController($uibModalInstance, DataService, $stateParams, data, _, Message) {
	    'ngInject';
	
	    _classCallCheck(this, RegistroFiscalSupervisorController);
	
	    this.DataService = DataService;
	    this.$stateParams = $stateParams;
	    this.data = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this._ = _;
	    this.Message = Message;
	    this.miembro = null;
	    if (this.data.referencia) this.referencia = this.data.referencia;
	    if (this.data.id_adjudicacion) this.id_adjudicacion = this.data.id_adjudicacion;
	    this.equipo = this.data.equipo;
	    this.cargos = angular.copy(this.data.cargos);
	    this.miembro = this.data.miembro || {};
	    this.modoEdicion = false;
	    this.modoVista = this.data.modoVista;
	  }
	
	  _createClass(RegistroFiscalSupervisorController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.miembro.tipo_equipo = 'TE_BENEFICIARIO';
	      console.log(this.cargos);
	      this.estadoMiembro = this.miembro.estado;
	      if (this.miembro.id_equipo_tecnico) {
	        this.getDatosMiembroEquipo();
	      } else {
	        this.quitarCargosOcupados();
	        this.modoEdicion = true;
	      }
	      if (!this.data.id_adjudicacion) {
	        this.quitarCargoSupervisor();
	      }
	    }
	  }, {
	    key: 'quitarCargosOcupados',
	    value: function quitarCargosOcupados(cargoIgnorado) {
	      var _this = this;
	
	      this._.remove(this.cargos, function (cargo) {
	        var CARGO_EXISTENTE = _this._.find(_this.equipo, { cargo: cargo.codigo, estado: 'ACTIVO' });
	        if (CARGO_EXISTENTE && CARGO_EXISTENTE.cargo === cargoIgnorado) {
	          return false;
	        }
	        return CARGO_EXISTENTE && CARGO_EXISTENTE.estado === 'ACTIVO';
	      });
	    }
	  }, {
	    key: 'quitarCargoSupervisor',
	    value: function quitarCargoSupervisor() {
	      this._.remove(this.cargos, function (cargo) {
	        if (cargo.codigo === 'CG_SUPERVISOR') {
	          return true;
	        } else {
	          return false;
	        }
	      });
	    }
	  }, {
	    key: 'getDatosMiembroEquipo',
	    value: function getDatosMiembroEquipo() {
	      var _this2 = this;
	
	      this.DataService.get('proyectos/' + this.miembro.fid_proyecto + '/equipos_tecnicos/' + this.miembro.id_equipo_tecnico).then(function (result) {
	        _this2.miembro = result.datos;
	        angular.extend(_this2.miembro, result.datos.usuario.persona);
	        delete _this2.miembro.usuario;
	        _this2.datosIniciales = angular.copy(_this2.miembro);
	        _this2.quitarCargosOcupados(_this2.miembro.cargo);
	        if (_this2.miembro.tipo_equipo !== 'TE_FDI' && _this2.miembro.doc_designacion) {
	          var docDesignacion = _this2.miembro.doc_designacion.substring(1, _this2.miembro.doc_designacion.indexOf(']'));
	          _this2.archivo = {
	            url: 'proyectos/' + _this2.miembro.fid_proyecto + '/doc/' + docDesignacion,
	            urlDescarga: 'proyectos/' + _this2.miembro.fid_proyecto + '/doc/' + docDesignacion + '/descargar'
	          };
	        }
	      });
	    }
	  }, {
	    key: 'registrar',
	    value: function registrar() {
	      var _this3 = this;
	
	      if (!this.miembro.doc_designacion) {
	        this.Message.warning('Debe seleccionar el archivo de designación.');
	        return;
	      }
	      // if (!this.data.registrar) {
	      //   return this.$uibModalInstance.close(this.miembro);
	      // }
	      var url = 'proyectos/' + this.$stateParams.codigo + '/equipos_tecnicos';
	      var servicio = 'post';
	      var miembroEquipo = angular.copy(this.miembro);
	      if (this.miembro.id_equipo_tecnico) {
	        url += '/' + this.miembro.id_equipo_tecnico;
	        servicio = 'put';
	        if (typeof this.miembro.doc_designacion === 'string') {
	          delete miembroEquipo.doc_designacion;
	        }
	      }
	      if (this.id_adjudicacion != null) {
	        miembroEquipo.fid_adjudicacion = this.id_adjudicacion;
	      }
	      this.DataService[servicio](url, miembroEquipo).then(function (result) {
	        if (result) {
	          _this3.Message.success(result.mensaje);
	          _this3.$uibModalInstance.close(_this3.miembro);
	        }
	      });
	    }
	  }, {
	    key: 'esSupervisor',
	    value: function esSupervisor() {
	      return this.miembro.cargo === 'CG_SUPERVISOR';
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return RegistroFiscalSupervisorController;
	}();
	
	exports.default = RegistroFiscalSupervisorController;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _evaluacion = __webpack_require__(565);
	
	var _evaluacion2 = _interopRequireDefault(_evaluacion);
	
	var _evaluacion3 = __webpack_require__(815);
	
	var _evaluacion4 = _interopRequireDefault(_evaluacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosEvaluacion = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _evaluacion2.default,
	  template: _evaluacion4.default
	};
	
	exports.default = DatosEvaluacion;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fixFecha = __webpack_require__(86);
	
	var _fixFecha2 = _interopRequireDefault(_fixFecha);
	
	var _fixFecha3 = __webpack_require__(99);
	
	var _fixFecha4 = _interopRequireDefault(_fixFecha3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosEvaluacion = function () {
	  DatosEvaluacion.$inject = ["$scope", "$timeout", "Proyecto", "DataService", "Message", "Modal", "Storage"];
	  function DatosEvaluacion($scope, $timeout, Proyecto, DataService, Message, Modal, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, DatosEvaluacion);
	
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.Proyecto = Proyecto;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Modal = Modal;
	    this.user = Storage.getUser();
	    this.esTecEval = [12, 13].indexOf(this.user.rol.id_rol) >= 0;
	  }
	
	  _createClass(DatosEvaluacion, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.plazo_convenio = 0;
	      this.archivos = {
	        urlDocEvExterna: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/EVE' : '',
	        urlDocEvExternaDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/EVE/descargar' : ''
	      };
	
	      this.$scope.$watch('$ctrl.proyecto.beneficiarios.tipo', function () {
	        if (_this.Proyecto.tratarComoProductivo(_this.proyecto)) {
	          if (!_this.proyecto.evaluacion.datos || !_this.proyecto.evaluacion.datos2 || !_this.proyecto.evaluacion.datos3 || !_this.proyecto.evaluacion.datos4 || !_this.proyecto.evaluacion.datos5) {
	            _this.obtenerFormEvaluacion();
	          }
	        }
	      });
	      this.$scope.$watch('$ctrl.proyecto.beneficiarios.plazo_ejecucion', function () {
	        var plazo_tiempo_administrativo = 0;
	        if (_this.proyecto.financiamiento && _this.proyecto.financiamiento.plazo_tiempo_administrativo) plazo_tiempo_administrativo = _this.proyecto.financiamiento.plazo_tiempo_administrativo.codigo;
	        _this.plazo_convenio = _this.proyecto.beneficiarios.plazo_ejecucion + plazo_tiempo_administrativo;
	      });
	      // this.interval = setInterval(() => {
	      //   const accionAutoguardado = {
	      //     estado: 'REGISTRO_PROYECTO_FDI',
	      //     guardar: true,
	      //     label: 'Guardar'
	      //   };
	      //   this.$scope.$emit('ejecutarGuardado', accionAutoguardado);
	      // }, 3000);
	      this.esRechazado = this.proyecto.estado_proyecto === 'RECHAZADO_FDI';
	    }
	
	    // $onDestroy() {
	    //   clearInterval(this.interval);
	    // }
	
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      if (this.proyecto) {
	        var datos = void 0;
	        if (this.proyecto.evaluacion) {
	          this.proyecto.evaluacion.nombre = this.proyecto.nombre;
	          this.proyecto.evaluacion.financiamiento = angular.copy(this.proyecto.financiamiento);
	          this.proyecto.evaluacion.beneficiarios = angular.copy(this.proyecto.beneficiarios);
	          datos = this.proyecto.autoridad_beneficiaria;
	          if (datos) {
	            // this.proyecto.evaluacion.responsable_gam_gaioc = `${datos.nombres||''} ${datos.primer_apellido||''} ${datos.segundo_apellido||''} \n${this.proyecto.autoridad_beneficiaria.correo||''} - ${this.proyecto.autoridad_beneficiaria.telefono||''} - ${this.proyecto.fax_autoridad_beneficiaria||''}`;
	            var contactoGam = '';
	            contactoGam = (datos.nombres || '') + ' ' + (datos.primer_apellido || '') + ' ' + (datos.segundo_apellido || '') + '<br>';
	            if (this.proyecto.autoridad_beneficiaria.correo) contactoGam += '' + this.proyecto.autoridad_beneficiaria.correo;
	            if (this.proyecto.autoridad_beneficiaria.telefono) contactoGam += ' - ' + this.proyecto.autoridad_beneficiaria.telefono;
	            if (this.proyecto.fax_autoridad_beneficiaria) contactoGam += ' - ' + this.proyecto.fax_autoridad_beneficiaria;
	            this.proyecto.evaluacion.responsable_gam_gaioc = contactoGam;
	          }
	        }
	        if (this.proyecto.contactos) {
	          datos = this.proyecto.contactos.datos[0];
	          if (datos && this.proyecto.evaluacion) {
	            // this.proyecto.evaluacion.responsable_edtp = `${datos.persona.nombres||''} ${datos.persona.primer_apellido||''} ${datos.persona.segundo_apellido||''} \n${datos.correo||''} - ${datos.telefono||''} - ${datos.fax||''}`;
	            var contactoEdtp = '';
	            contactoEdtp = (datos.persona.nombres || '') + ' ' + (datos.persona.primer_apellido || '') + ' ' + (datos.persona.segundo_apellido || '') + '<br>';
	            if (datos.correo) contactoEdtp += '' + datos.correo;
	            if (datos.telefono) contactoEdtp += ' - ' + datos.telefono;
	            if (datos.fax) contactoEdtp += ' - ' + datos.fax;
	            this.proyecto.evaluacion.responsable_edtp = contactoEdtp;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'regenerarFormulario',
	    value: function regenerarFormulario() {
	      this.obtenerFormEvaluacion();
	    }
	  }, {
	    key: 'initPlantilla',
	    value: function initPlantilla() {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        if (_this2.proyecto) {
	          if (!_this2.proyecto.evaluacion) {
	            _this2.proyecto.evaluacion = {
	              $_plantilla: 101,
	              $_nombre: 'evaluacion',
	              cod: _this2.proyecto.id_proyecto,
	              nombre: _this2.proyecto.nombre,
	              codigo: _this2.proyecto.codigo,
	              municipio: angular.copy(_this2.proyecto.dpa.municipio),
	              provincia: angular.copy(_this2.proyecto.dpa.provincia),
	              departamento: angular.copy(_this2.proyecto.dpa.departamento),
	              financiamiento: angular.copy(_this2.proyecto.financiamiento),
	              beneficiarios: angular.copy(_this2.proyecto.beneficiarios)
	            };
	            if (_this2.Proyecto.tratarComoProductivo(_this2.proyecto)) {
	              _this2.obtenerFormEvaluacion();
	            } else {
	              _this2.obtenerFormEvaluacion();
	            }
	          }
	          _this2.DataService.get('proyectos/' + _this2.proyecto.id_proyecto + '/evaluaciones').then(function (resp) {
	            if (resp && resp.finalizado) {
	              _this2.documentos = resp.datos;
	            }
	          });
	        }
	
	        if (!_this2.proyecto.evaluacion.revisor) _this2.proyecto.evaluacion.revisor = {};
	        //if (this.proyecto.evaluacion.revisor.nombre == undefined || this.proyecto.evaluacion.revisor.nombre.trim() == "" || this.proyecto.evaluacion.revisor.nombre !== (this.proyecto.revisor.persona.nombres+" "+this.proyecto.revisor.persona.primer_apellido+" "+this.proyecto.revisor.persona.segundo_apellido).trim()) {
	        if (_this2.proyecto.revisor) {
	          _this2.proyecto.evaluacion.revisor.nombre = (_this2.proyecto.revisor.persona.nombres + " " + _this2.proyecto.revisor.persona.primer_apellido + " " + _this2.proyecto.revisor.persona.segundo_apellido).trim();
	          _this2.proyecto.evaluacion.revisor.cargo = _this2.proyecto.revisor.cargo;
	        }
	        //}
	
	        if (!_this2.proyecto.evaluacion.jefe_area) _this2.proyecto.evaluacion.jefe_area = {};
	        //if (this.proyecto.evaluacion.jefe_area.nombre == undefined || this.proyecto.evaluacion.jefe_area.nombre.trim() == "") {
	        if (_this2.proyecto.jefe_area) {
	          _this2.proyecto.evaluacion.jefe_area.nombre = (_this2.proyecto.jefe_area.persona.nombres + " " + _this2.proyecto.jefe_area.persona.primer_apellido + " " + _this2.proyecto.jefe_area.persona.segundo_apellido).trim();
	          _this2.proyecto.evaluacion.jefe_area.cargo = _this2.proyecto.jefe_area.cargo;
	        }
	        //}
	
	        if (!_this2.proyecto.evaluacion.jefe_depto) _this2.proyecto.evaluacion.jefe_depto = {};
	        //if (this.proyecto.evaluacion.jefe_depto.nombre == undefined || this.proyecto.evaluacion.jefe_depto.nombre.trim() == "") {
	        if (_this2.proyecto.jefe_depto) {
	          _this2.proyecto.evaluacion.jefe_depto.nombre = _this2.proyecto.jefe_depto.nombre.trim();
	          _this2.proyecto.evaluacion.jefe_depto.cargo = _this2.proyecto.jefe_depto.cargo;
	        }
	        //}
	      }, 500);
	    }
	  }, {
	    key: 'criteriosElegibilidad',
	    value: function criteriosElegibilidad() {
	      return this.Proyecto.tratarComoProductivo(this.proyecto);
	    }
	  }, {
	    key: 'visibilidad',
	    value: function visibilidad(item) {
	      var resultado = 0;
	      for (var i in this.proyecto.evaluacion.datos3) {
	        var fila = this.proyecto.evaluacion.datos3[i];
	        var fila_requerida = false;
	
	        if (this.Proyecto.tratarComoProductivo(this.proyecto)) fila_requerida = false;
	
	        if (this.proyecto.beneficiarios.productivo) {
	          if (this.proyecto.beneficiarios.productivo.hasOwnProperty(fila.key) && this.proyecto.beneficiarios.productivo[fila.key]) fila_requerida = true;
	          /*if (fila.key == 'agricola' && this.proyecto.beneficiarios.productivo.agricola) fila_requerida = true;
	          if (fila.key == 'pecuario' && this.proyecto.beneficiarios.productivo.pecuario) fila_requerida = true;
	          if (fila.key == 'pesca' && this.proyecto.beneficiarios.productivo.pesca) fila_requerida = true;
	          if (fila.key == 'piscicultura' && this.proyecto.beneficiarios.productivo.piscicultura) fila_requerida = true;
	          if (fila.key == 'aprovecha_biodiversidad' && this.proyecto.beneficiarios.productivo.aprovecha_biodiversidad) fila_requerida = true;
	          if (fila.key == 'integral_sustentable_bosque' && this.proyecto.beneficiarios.productivo.integral_sustentable_bosque) fila_requerida = true;
	          if (fila.key == 'maquinaria' && this.proyecto.beneficiarios.productivo.maquinaria) fila_requerida = true;
	          if (fila.key == 'prod_agroeco_organica' && this.proyecto.beneficiarios.productivo.prod_agroeco_organica) fila_requerida = true;
	          if (fila.key == 'sis_agroforestales' && this.proyecto.beneficiarios.productivo.sis_agroforestales) fila_requerida = true;
	          if (fila.key == 'infraestructura' && this.proyecto.beneficiarios.productivo.infraestructura) fila_requerida = true;
	          if (fila.key == 'transformacion' && this.proyecto.beneficiarios.productivo.transformacion) fila_requerida = true;*/
	        }
	
	        for (var j in fila.cols) {
	          if (!fila_requerida) {
	            if (fila.cols[j].contenido && fila.cols[j].contenido.name == 'CUMPLE') {
	              fila.cols[j].contenido.value = false;
	            }
	            if (fila.cols[j].contenido && fila.cols[j].contenido.name == 'NO_CUMPLE') {
	              fila.cols[j].contenido.value = false;
	            }
	            if (fila.cols[j].contenido && fila.cols[j].contenido.name == 'NO_APLICA') {
	              fila.cols[j].contenido.value = true;
	            }
	          }
	        }
	      }
	
	      if (this.proyecto.beneficiarios.productivo) {
	        if (this.proyecto.beneficiarios.productivo.hasOwnProperty(item) && this.proyecto.beneficiarios.productivo[item]) resultado = this.proyecto.beneficiarios.productivo[item];
	        /*switch (item) {
	          case 'pecuario':
	            resultado = this.proyecto.beneficiarios.productivo.pecuario;
	            break;
	          case 'agricola':
	            resultado = this.proyecto.beneficiarios.productivo.agricola;
	            break;
	          case 'pesca':
	            resultado = this.proyecto.beneficiarios.productivo.pesca;
	            break;
	          case 'piscicultura':
	            resultado = this.proyecto.beneficiarios.productivo.piscicultura;
	            break;
	          case 'aprovecha_biodiversidad':
	            resultado = this.proyecto.beneficiarios.productivo.aprovecha_biodiversidad;
	            break;
	          case 'integral_sustentable_bosque':
	            resultado = this.proyecto.beneficiarios.productivo.integral_sustentable_bosque;
	            break;
	          case 'maquinaria':
	            resultado = this.proyecto.beneficiarios.productivo.maquinaria;
	            break;
	          case 'prod_agroeco_organica':
	            resultado = this.proyecto.beneficiarios.productivo.prod_agroeco_organica;
	            break;
	          case 'sis_agroforestales':
	            resultado = this.proyecto.beneficiarios.productivo.sis_agroforestales;
	            break;
	          case 'infraestructura':
	            resultado = this.proyecto.beneficiarios.productivo.infraestructura;
	            break;
	          case 'transformacion':
	            resultado = this.proyecto.beneficiarios.productivo.transformacion;
	            break;
	          default:
	          break;
	        } */
	        return resultado;
	      }
	    }
	  }, {
	    key: 'visibilidadAnalisisFactibilidad',
	    value: function visibilidadAnalisisFactibilidad(item) {
	      var resultado = 1;
	      if (this.proyecto.beneficiarios && this.proyecto.beneficiarios.tamanio_proyecto == 'OP_TP_MENORES') {
	        for (var i in this.proyecto.evaluacion.datos4) {
	          var fila = this.proyecto.evaluacion.datos4[i];
	          if (fila.key == 'seccion_4_1' && item == fila.key) {
	            resultado = 0;
	          }
	        }
	      }
	      return resultado;
	    }
	  }, {
	    key: 'radioChangeWithValidation',
	    value: function radioChangeWithValidation(cols, index) {
	      if (!this.modoVista) {
	        if (!this.cumpleCriterios() && cols[index].contenido.name === 'APROBADO') {
	          this.Message.error('Uno o mas criterios de evaluación están marcados como "no cumple". Corrija estos datos para poder aprobar el formulario');
	        } else {
	          this.radioChange(cols, index);
	        }
	      }
	    }
	  }, {
	    key: 'radioChange',
	    value: function radioChange(cols, index) {
	      if (!this.modoVista) {
	        for (var i in cols) {
	          if (cols[i].contenido && cols[i].contenido.type === 'radio') {
	            cols[i].contenido.value = i == index;
	          }
	        }
	        if (cols[index].contenido.name === 'NO_CUMPLE') {
	          this.marcarInformeRechazado();
	        }
	      }
	    }
	  }, {
	    key: 'radioColor',
	    value: function radioColor(contenido) {
	      if (contenido.value && contenido.name == 'CUMPLE') return 'btn-success';
	      if (contenido.value && contenido.name == 'NO_CUMPLE') return 'btn-danger';
	      if (contenido.value && contenido.name == 'NO_APLICA') return 'btn-primary';
	      if (contenido.value && contenido.name == 'APROBADO') return 'btn-success';
	      if (contenido.value && contenido.name == 'AJUSTE') return 'btn-warning';
	      if (contenido.value && contenido.name == 'RECHAZO') return 'btn-danger';
	      return 'btn-secondary';
	    }
	  }, {
	    key: 'marcarInformeRechazado',
	    value: function marcarInformeRechazado() {
	      for (var i in this.proyecto.evaluacion.datos5) {
	        var fila = this.proyecto.evaluacion.datos5[i];
	        for (var j in fila.cols) {
	          if (fila.cols[j].contenido && fila.cols[j].contenido.type == 'radio') {
	            fila.cols[j].contenido.value = fila.cols[j].contenido.name == 'RECHAZO' ? true : false;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'generarEvaluacionPdf',
	    value: function generarEvaluacionPdf() {
	      var _this3 = this;
	
	      for (var i in this.proyecto.evaluacion.datos3) {
	        var fila = this.proyecto.evaluacion.datos3[i];
	        var fila_requerida = false;
	
	        if (this.Proyecto.tratarComoProductivo(this.proyecto)) fila_requerida = false;
	
	        if (this.proyecto.beneficiarios.productivo) {
	          if (this.proyecto.beneficiarios.productivo.hasOwnProperty(fila.key) && this.proyecto.beneficiarios.productivo[fila.key]) fila_requerida = true;
	          /*if (fila.key=='agricola' && this.proyecto.beneficiarios.productivo.agricola) fila_requerida = true;
	          if (fila.key=='pecuario' && this.proyecto.beneficiarios.productivo.pecuario) fila_requerida = true;
	          if (fila.key=='pesca' && this.proyecto.beneficiarios.productivo.pesca) fila_requerida = true;
	          if (fila.key=='piscicultura' && this.proyecto.beneficiarios.productivo.piscicultura) fila_requerida = true;
	          if (fila.key=='aprovecha_biodiversidad' && this.proyecto.beneficiarios.productivo.aprovecha_biodiversidad) fila_requerida = true;
	          if (fila.key=='integral_sustentable_bosque' && this.proyecto.beneficiarios.productivo.integral_sustentable_bosque) fila_requerida = true;
	          if (fila.key=='maquinaria' && this.proyecto.beneficiarios.productivo.maquinaria) fila_requerida = true;
	          if (fila.key=='prod_agroeco_organica' && this.proyecto.beneficiarios.productivo.prod_agroeco_organica) fila_requerida = true;
	          if (fila.key=='sis_agroforestales' && this.proyecto.beneficiarios.productivo.sis_agroforestales) fila_requerida = true;*/
	        }
	
	        for (var j in fila.cols) {
	          if (!fila_requerida) {
	            if (fila.cols[j].contenido && fila.cols[j].contenido.name == 'CUMPLE') {
	              fila.cols[j].contenido.value = false;
	            }
	            if (fila.cols[j].contenido && fila.cols[j].contenido.name == 'NO_CUMPLE') {
	              fila.cols[j].contenido.value = false;
	            }
	            if (fila.cols[j].contenido && fila.cols[j].contenido.name == 'NO_APLICA') {
	              fila.cols[j].contenido.value = true;
	            }
	          }
	        }
	      }
	
	      this.Modal.confirm('¿Esta seguro/a de generar el formulario? Este se guardará como parte del historial de formularios de evaluación.', function () {
	        var _datos = _this3.proyecto.evaluacion;
	        _datos.nro_convenio = _this3.proyecto.nro_convenio;
	        _this3.DataService.post('proyectos/' + _this3.proyecto.id_proyecto + '/evaluaciones', _datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this3.Message.success(resp.mensaje);
	            _this3.documentos.push(resp.datos);
	          }
	        });
	      }, null, null, 'Si estoy seguro/a');
	    }
	  }, {
	    key: 'verEvaluacion',
	    value: function verEvaluacion(doc) {
	      this.verDocumentoEvaluacion(doc);
	    }
	  }, {
	    key: 'verDocumentoEvaluacion',
	    value: function verDocumentoEvaluacion(doc) {
	      this.Modal.showFormularioBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/EVAL?codigo=' + doc.codigo_documento, 'Formulario de evaluaci\xF3n');
	    }
	  }, {
	    key: 'corregirFecha',
	    value: function corregirFecha(doc) {
	      var _this4 = this;
	
	      this.Modal.show({
	        title: 'Modificar fecha!',
	        controller: _fixFecha2.default,
	        template: _fixFecha4.default,
	        data: doc
	      }).result.then(function (resp) {
	        var datos = {
	          codigo_documento: resp.codigo_documento,
	          fecha_documento: resp.fecha_documento
	        };
	        _this4.DataService.put('proyectos/' + _this4.proyecto.id_proyecto + '/formulario/evaluacion/' + resp.id_formulario, datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            doc.fecha_documento = resp.datos.fecha_documento;
	            _this4.Message.success(resp.mensaje);
	          }
	        });
	      }).catch(function () {});
	    }
	  }, {
	    key: 'estado',
	    value: function estado(doc) {
	      var _this5 = this;
	
	      this.Modal.confirm('¿Esta seguro/a de cambiar el estado?.', function () {
	        var datos = {
	          codigo_documento: doc.codigo_documento,
	          estado: doc.estado === 'INACTIVO' ? 'ELABORADO' : 'INACTIVO'
	        };
	        _this5.DataService.put('proyectos/' + _this5.proyecto.id_proyecto + '/formulario/evaluacion/' + doc.id_formulario, datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            doc.estado = resp.datos.estado;
	            _this5.Message.success(resp.mensaje);
	          }
	        });
	      }, null, null, 'Si estoy seguro/a');
	    }
	
	    // TODO optimizar estas funciones
	
	  }, {
	    key: 'limitarTexto',
	    value: function limitarTexto(texto) {
	      if (!texto) return '';
	      var palabras = this.parsearTexto(texto);
	      palabras = palabras.split(' ').slice(0, 5);
	      return palabras.join(' ') + '...';
	    }
	  }, {
	    key: 'parsearTexto',
	    value: function parsearTexto(texto) {
	      if (!texto) return '';
	      return texto.replace(/<b>|<\/b>|<li>|<ul>|<\/ul>/g, '').replace(/<\/li>/g, ' \n');
	    }
	  }, {
	    key: 'cumpleCriterios',
	    value: function cumpleCriterios() {
	      var cumple = true;
	      var datos = this.proyecto.evaluacion.datos.concat(this.proyecto.evaluacion.datos2, this.proyecto.evaluacion.datos4);
	      for (var i in datos) {
	        if (!(this.proyecto.beneficiarios && this.proyecto.beneficiarios.tamanio_proyecto == 'OP_TP_MENORES' && datos[i].key == 'seccion_4_1')) {
	          if (datos[i].cols.find(function (col) {
	            return col.contenido && col.contenido.name == 'NO_CUMPLE' && col.contenido.value;
	          })) {
	            cumple = false;
	            break;
	          }
	        }
	      }
	
	      if (cumple) {
	        for (var _i in this.proyecto.evaluacion.datos3) {
	          var fila = this.proyecto.evaluacion.datos3[_i];
	          var fila_requerida = false;
	
	          if (this.Proyecto.tratarComoProductivo(this.proyecto)) fila_requerida = false;
	
	          if (this.proyecto.beneficiarios.productivo) {
	            if (this.proyecto.beneficiarios.productivo.hasOwnProperty(fila.key) && this.proyecto.beneficiarios.productivo[fila.key]) fila_requerida = true;
	            /*if (fila.key == 'agricola' && this.proyecto.beneficiarios.productivo.agricola) fila_requerida = true;
	            if (fila.key == 'pecuario' && this.proyecto.beneficiarios.productivo.pecuario) fila_requerida = true;
	            if (fila.key == 'pesca' && this.proyecto.beneficiarios.productivo.pesca) fila_requerida = true;
	            if (fila.key == 'piscicultura' && this.proyecto.beneficiarios.productivo.piscicultura) fila_requerida = true;
	            if (fila.key == 'aprovecha_biodiversidad' && this.proyecto.beneficiarios.productivo.aprovecha_biodiversidad) fila_requerida = true;
	            if (fila.key == 'integral_sustentable_bosque' && this.proyecto.beneficiarios.productivo.integral_sustentable_bosque) fila_requerida = true;
	            if (fila.key == 'maquinaria' && this.proyecto.beneficiarios.productivo.maquinaria) fila_requerida = true;
	            if (fila.key == 'prod_agroeco_organica' && this.proyecto.beneficiarios.productivo.prod_agroeco_organica) fila_requerida = true;
	            if (fila.key == 'sis_agroforestales' && this.proyecto.beneficiarios.productivo.sis_agroforestales) fila_requerida = true;*/
	          }
	
	          if (fila_requerida) {
	            if (fila.cols.find(function (col) {
	              return col.contenido && col.contenido.name == 'NO_CUMPLE' && col.contenido.value;
	            })) {
	              cumple = false;
	              break;
	            }
	          }
	        }
	      }
	
	      // if (cumple) {
	      //   for (let i in this.proyecto.evaluacion.datos2) {
	      //     if (cumple) {
	      //       let fila = this.proyecto.evaluacion.datos2[i];
	      //       for (let j in fila.cols) {
	      //         if (fila.cols[j].contenido && fila.cols[j].contenido.name == 'NO_CUMPLE' && fila.cols[j].contenido.value) {
	      //           cumple = false;
	      //         }
	      //       }
	      //     }
	      //   }
	      // }
	      // if (cumple) {
	      //   for (let i in this.proyecto.evaluacion.datos3) {
	      //     if (cumple) {
	      //       let fila = this.proyecto.evaluacion.datos3[i];
	      //       let fila_requerida = false;
	
	      //       if(this.proyecto.beneficiarios.tipo == 'OP_TP_PRODUCTIVO') fila_requerida = false;
	
	      //       if(this.proyecto.beneficiarios.productivo){
	      //         if(fila.key=='agricola' && this.proyecto.beneficiarios.productivo.agricola) fila_requerida = true;
	      //         if(fila.key=='pecuario' && this.proyecto.beneficiarios.productivo.pecuario) fila_requerida = true;
	      //         if(fila.key=='pesca' && this.proyecto.beneficiarios.productivo.pesca) fila_requerida = true;
	      //         if(fila.key=='piscicultura' && this.proyecto.beneficiarios.productivo.piscicultura) fila_requerida = true;
	      //         if(fila.key=='aprovecha_biodiversidad' && this.proyecto.beneficiarios.productivo.aprovecha_biodiversidad) fila_requerida = true;
	      //         if(fila.key=='integral_sustentable_bosque' && this.proyecto.beneficiarios.productivo.integral_sustentable_bosque) fila_requerida = true;
	      //         if(fila.key=='maquinaria' && this.proyecto.beneficiarios.productivo.maquinaria) fila_requerida = true;
	      //         if(fila.key=='prod_agroeco_organica' && this.proyecto.beneficiarios.productivo.prod_agroeco_organica) fila_requerida = true;
	      //         if(fila.key=='sis_agroforestales' && this.proyecto.beneficiarios.productivo.sis_agroforestales) fila_requerida = true;
	      //       }
	
	      //       for (let j in fila.cols) {
	      //         if (fila_requerida) {
	      //           if (fila.cols[j].contenido && fila.cols[j].contenido.name == 'NO_CUMPLE' && fila.cols[j].contenido.value) {
	      //             cumple = false;
	      //           }
	      //         }
	      //       }
	      //     }
	      //   }
	      // }
	      // if (cumple) {
	      //   for (let i in this.proyecto.evaluacion.datos4) {
	      //     if (cumple) {
	      //       let fila = this.proyecto.evaluacion.datos4[i];
	      //       for (let j in fila.cols) {
	      //         if (fila.cols[j].contenido && fila.cols[j].contenido.name == 'NO_CUMPLE' && fila.cols[j].contenido.value) {
	      //           cumple = false;
	      //         }
	      //       }
	      //     }
	      //   }
	      // }
	      return cumple;
	    }
	  }, {
	    key: 'obtenerFormEvaluacion',
	    value: function obtenerFormEvaluacion() {
	      var _this6 = this;
	
	      this.proyecto.evaluacion.datos = [];
	      this.proyecto.evaluacion.datos2 = [];
	      this.proyecto.evaluacion.datos3 = [];
	      this.proyecto.evaluacion.datos4 = [];
	      this.proyecto.evaluacion.datos5 = [];
	
	      this.xyz = '';
	      if (this.proyecto.cartera === 3) {
	        if (this.proyecto.beneficiarios.tipo === 'OP_TP_RIEGO') {
	          this.xyz = 'evaluacionriego';
	        }
	        if (this.proyecto.beneficiarios.tipo === 'OP_TP_PUENTES') {
	          this.xyz = 'evaluacionpuente';
	        }
	        if (this.proyecto.beneficiarios.tipo === 'OP_TP_PRODUCTIVO') {
	          this.xyz = 'evaluacion';
	        }
	        if (this.proyecto.beneficiarios.tipo === 'OP_TP_MAQUINARIA') {
	          this.xyz = 'evaluacion';
	        }
	        this.DataService.get('contenidos/' + this.xyz).then(function (response) {
	          console.log("responseeeeeeeeeeee", response);
	          if (response) {
	            for (var row in response.datos) {
	              var a = response.datos[row];
	              if (a.seccion === "1" && a.estructura) {
	                _this6.proyecto.evaluacion.datos = a.estructura;
	              } else if (a.seccion === "2" && a.estructura) {
	                _this6.proyecto.evaluacion.datos2 = a.estructura;
	              } else if (a.seccion === "3" && a.estructura) {
	                _this6.proyecto.evaluacion.datos3 = a.estructura;
	              } else if (a.seccion === "4" && a.estructura) {
	                _this6.proyecto.evaluacion.datos4 = a.estructura;
	                // if (this.proyecto.beneficiarios.tamanio_proyecto == 'OP_TP_MENORES') {
	                //   this.proyecto.evaluacion.datos4[0].cols[5].contenido.value = false;
	                //   this.proyecto.evaluacion.datos4[0].cols[6].contenido.value = true;
	                //   this.proyecto.evaluacion.datos4[1].cols[3].contenido.value = false;
	                //   this.proyecto.evaluacion.datos4[1].cols[4].contenido.value = true;
	                // }
	              } else if (a.seccion === "5" && a.estructura) {
	                _this6.proyecto.evaluacion.datos5 = a.estructura;
	              }
	            }
	          }
	        });
	      } else {
	        if (this.proyecto.beneficiarios.tipo === 'OP_TP_RIEGO') {
	          this.xyz = 'evaluacionriego';
	        }
	        if (this.proyecto.beneficiarios.tipo === 'OP_TP_PUENTES') {
	          this.xyz = 'evaluacionpuente';
	        }
	        if (this.proyecto.beneficiarios.tipo === 'OP_TP_PRODUCTIVO') {
	          this.xyz = 'evaluacion';
	        }
	        if (this.proyecto.beneficiarios.tipo === 'OP_TP_MAQUINARIA') {
	          this.xyz = 'evaluacion';
	        }
	        this.DataService.get('contenidos/' + this.xyz + '?version=2').then(function (response) {
	          console.log("responseeeeeeeeeeee", response);
	          if (response) {
	            for (var row in response.datos) {
	              var a = response.datos[row];
	              if (a.seccion === "1" && a.estructura) {
	                _this6.proyecto.evaluacion.datos = a.estructura;
	              } else if (a.seccion === "2" && a.estructura) {
	                _this6.proyecto.evaluacion.datos2 = a.estructura;
	              } else if (a.seccion === "3" && a.estructura) {
	                _this6.proyecto.evaluacion.datos3 = a.estructura;
	              } else if (a.seccion === "4" && a.estructura) {
	                _this6.proyecto.evaluacion.datos4 = a.estructura;
	                // if (this.proyecto.beneficiarios.tamanio_proyecto == 'OP_TP_MENORES') {
	                //   this.proyecto.evaluacion.datos4[0].cols[5].contenido.value = false;
	                //   this.proyecto.evaluacion.datos4[0].cols[6].contenido.value = true;
	                //   this.proyecto.evaluacion.datos4[1].cols[3].contenido.value = false;
	                //   this.proyecto.evaluacion.datos4[1].cols[4].contenido.value = true;
	                // }
	              } else if (a.seccion === "5" && a.estructura) {
	                _this6.proyecto.evaluacion.datos5 = a.estructura;
	              }
	            }
	          }
	        });
	      }
	    }
	  }]);
	
	  return DatosEvaluacion;
	}();
	
	exports.default = DatosEvaluacion;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financiamiento = __webpack_require__(567);
	
	var _financiamiento2 = _interopRequireDefault(_financiamiento);
	
	var _financiamiento3 = __webpack_require__(816);
	
	var _financiamiento4 = _interopRequireDefault(_financiamiento3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosFinanciamiento = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _financiamiento2.default,
	  template: _financiamiento4.default
	};
	
	exports.default = DatosFinanciamiento;

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosFinanciamiento = function () {
	  DatosFinanciamiento.$inject = ["$timeout", "Proyecto", "Util", "Message", "Usuarios"];
	  function DatosFinanciamiento($timeout, Proyecto, Util, Message, Usuarios) {
	    'ngInject';
	
	    _classCallCheck(this, DatosFinanciamiento);
	
	    this.$timeout = $timeout;
	    this.Proyecto = Proyecto;
	    this.Message = Message;
	    this.Util = Util;
	    this.Usuarios = Usuarios;
	  }
	
	  _createClass(DatosFinanciamiento, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.opciones_plazo_administrativo = [{ codigo: 0, nombre: '0 días (0 meses)' }, { codigo: 240, nombre: '240 días (8 meses)' }, { codigo: 255, nombre: '255 días (8 1/2 meses)' }, { codigo: 270, nombre: '270 días (9 meses)' }];
	      if (this.proyecto) {
	        if (!this.proyecto.estado_actual || !this.proyecto.estado_actual.areas || !this.proyecto.estado_actual.areas.DATOS_GENERALES_EXTRA) {
	          if (this.proyecto.financiamiento) {
	            this.proyecto.financiamiento.cuadro = null;
	          }
	        }
	
	        if (this.proyecto.financiamiento) this.proyecto.financiamiento.plazo_tiempo_administrativo = { codigo: 0, nombre: '0 días (0 meses)' };
	      }
	    }
	  }, {
	    key: 'initPlantilla',
	    value: function initPlantilla() {
	      var _this = this;
	
	      this.$timeout(function () {
	        if (_this.proyecto) {
	          if (!_this.proyecto.financiamiento) {
	            _this.proyecto.financiamiento = {
	              $_plantilla: 2,
	              $_nombre: 'financiamiento'
	            };
	          }
	          _this.monto_previo = _this.proyecto.monto_total || 0;
	          if (_this.proyecto.estado_proyecto === 'REGISTRO_PROYECTO_FDI' && _this.Usuarios.esTecnicoResponsable()) {
	            _this.obtenerTechoPresupuestario();
	          }
	          if (_this.proyecto.financiamiento && _this.proyecto.financiamiento.cuadro) {
	            // if (!this.proyecto.financiamiento.cuadro.porcentajes) {
	            _this.calTotales();
	            // }
	          }
	        }
	      }, 500);
	    }
	  }, {
	    key: 'calcularFinanciamiento',
	    value: function calcularFinanciamiento() {
	      this.proyecto.financiamiento.monto_total_proyecto = (this.proyecto.financiamiento.monto_fdi || 0) + (this.proyecto.financiamiento.monto_contraparte || 0) + (this.proyecto.financiamiento.monto_beneficiarios || 0) + (this.proyecto.financiamiento.monto_otros || 0);
	      this.proyecto.monto_total = this.proyecto.financiamiento.monto_total_proyecto;
	      this.proyecto.monto_fdi = this.proyecto.financiamiento.monto_fdi || 0;
	      // Verificar monto total con techo presupuestario
	      if (this.techoPresupuestario) {
	        if (this.proyecto.observacion.mensaje) {
	          this.techoPresupuestario.monto_restante = this.techoPresupuestario.monto_disponible - this.proyecto.financiamiento.monto_fdi + this.monto_previo;
	        } else {
	          this.techoPresupuestario.monto_restante = this.techoPresupuestario.monto_disponible - this.proyecto.financiamiento.monto_fdi;
	        }
	        this.techoPresupuestario.monto_restante = this.techoPresupuestario.monto_restante > this.techoPresupuestario.techo_presupuestal ? this.techoPresupuestario.techo_presupuestal : this.techoPresupuestario.monto_restante;
	        if (this.techoPresupuestario.monto_restante < 0) {
	          this.Message.warning('El monto asignado al FDI según la tabla de estructura de financiamiento excede el techo presupuestario para el municipio seleccionado');
	          // this.proyecto.montoFinanciamientoExcedido = true;
	          this.proyecto.montoFinanciamientoExcedido = false;
	          // } else {
	          //   this.proyecto.montoFinanciamientoExcedido = false;
	        }
	      }
	      if (this.proyecto.estado_proyecto === 'REGISTRO_PROYECTO_FDI' && this.Usuarios.esTecnicoResponsable()) {
	        this.calcularPorcentajes(this.proyecto.financiamiento.monto_total_proyecto);
	      }
	    }
	  }, {
	    key: 'limpiarCero',
	    value: function limpiarCero(columna, disabled) {
	      if (columna.contenido.value === 0 && !disabled) {
	        columna.contenido.value = '';
	      }
	    }
	  }, {
	    key: 'reemplazarVacio',
	    value: function reemplazarVacio(columna) {
	      if (columna.contenido.value === null || columna.contenido.value === '') {
	        columna.contenido.value = +0;
	      }
	    }
	  }, {
	    key: 'calTotales',
	    value: function calTotales() {
	      var cuadro = this.proyecto.financiamiento.cuadro;
	      cuadro.totales.costo_total = 0;
	      cuadro.totales.fdi = 0;
	      cuadro.totales.gam = 0;
	      cuadro.totales.beneficiarios = 0;
	      cuadro.totales.otros = 0;
	      cuadro.totales.publico = 0;
	      cuadro.totales.privado = 0;
	      // Recorrer filas y columnas para calcular totales
	      var campo = cuadro.tipo === 1 ? ['fdi', 'gam', 'beneficiarios', 'otros'] : this.proyecto.cartera >= 4 && cuadro.tipo === 2 ? ['gam', 'beneficiarios', 'otros', 'publico', 'privado', 'gamprivado', 'gampublico'] : cuadro.tipo === 2 ? ['gam', 'beneficiarios', 'otros', 'publico', 'privado'] : [];
	      var param = {};
	      // filas
	      for (var i in cuadro.datos) {
	        var columna_total = null;
	        var fila_total = null;
	        var fila_gam = null;
	        var campo_sumando = [];
	        var fila_sumando = [];
	        var filas_sumando = [];
	        // columnas
	        for (var j in cuadro.datos[i].cols) {
	          var contenido = cuadro.datos[i].cols[j].contenido;
	          if (cuadro.tipo === 1 && contenido && contenido.name === 'costo_total') {
	            columna_total = contenido;
	          }
	          if (cuadro.tipo === 2 && contenido && contenido.name === 'tfdi') {
	            columna_total = contenido;
	          }
	          if (this.proyecto.cartera >= 4 && cuadro.tipo === 2 && contenido && contenido.name === 'gam') {
	            fila_gam = contenido;
	          }
	          if (this.proyecto.cartera >= 4 && cuadro.tipo === 2 && contenido && contenido.name === 'costo_total') {
	            fila_total = contenido;
	          }
	          if (contenido && campo.indexOf(contenido.name) >= 0) {
	            if (!param[contenido.name]) {
	              param[contenido.name] = [];
	            }
	            param[contenido.name].push(contenido.value);
	            // Calcular columna costo total
	            if (cuadro.tipo === 1) {
	              campo_sumando.push(contenido.value);
	            }
	            // Calcular columna columna fdil
	            if (cuadro.tipo === 2 && contenido.name != 'gam' && contenido.name != 'beneficiarios' && contenido.name != 'otros' && contenido.name != 'gampublico' && contenido.name != 'gamprivado') {
	              campo_sumando.push(contenido.value);
	              // console.log(campo_sumando,"campo_sumando",contenido)
	            }
	            //Calcular filas gam privado y publico
	            if (cuadro.tipo === 2 && contenido.name != 'gam' && contenido.name != 'beneficiarios' && contenido.name != 'otros' && contenido.name != 'publico' && contenido.name != 'privado') {
	              fila_sumando.push(contenido.value);
	              // console.log("i: ",i,"j:",j,campo_sumando,"campo_sumando",contenido)
	            }
	            if (cuadro.tipo === 2 && contenido.name != 'gam') {
	              filas_sumando.push(contenido.value);
	              // console.log(campo_sumando,"campo_sumando",contenido)
	            }
	          }
	        }
	        if (columna_total) {
	          columna_total.value = this.Util.sumar(campo_sumando);
	        }
	        if (fila_total) {
	          fila_total.value = this.Util.sumar(filas_sumando);
	        }
	        if (fila_gam) {
	          fila_gam.value = this.Util.sumar(fila_sumando);
	        }
	      }
	      // Sumar arrays
	      for (var p in campo) {
	        // param[campo[p]] = [cuadro.totales[campo[p]]]
	        cuadro.totales[campo[p]] = this.Util.sumar(param[campo[p]]);
	      }
	
	      // Calcular totales finales
	      if (cuadro.tipo === 1 || cuadro.tipo === 2) {
	        if (cuadro.tipo === 2) {
	          this.proyecto.financiamiento.cuadro.totales.fdi_pp = this.Util.sumar([this.proyecto.financiamiento.cuadro.totales.publico, this.proyecto.financiamiento.cuadro.totales.privado]);
	          this.proyecto.financiamiento.cuadro.totales.gam_pp = this.Util.sumar([this.proyecto.financiamiento.cuadro.totales.gampublico, this.proyecto.financiamiento.cuadro.totales.gamprivado]);
	          this.proyecto.financiamiento.cuadro.totales.fdi = this.proyecto.financiamiento.cuadro.totales.fdi_pp;
	          // this.proyecto.financiamiento.cuadro.totales.gam = this.proyecto.financiamiento.cuadro.totales.gam_pp;
	          this.proyecto.financiamiento.cuadro.totales.fdi_gam = this.Util.sumar([this.proyecto.financiamiento.cuadro.totales.fdi, this.proyecto.financiamiento.cuadro.totales.gam]);
	        }
	
	        this.proyecto.financiamiento.cuadro.totales.costo_total = this.Util.sumar([this.proyecto.financiamiento.cuadro.totales.fdi, this.proyecto.financiamiento.cuadro.totales.gam, this.proyecto.financiamiento.cuadro.totales.beneficiarios, this.proyecto.financiamiento.cuadro.totales.otros]);
	      }
	
	      // Valores resumen
	      this.proyecto.financiamiento.monto_fdi = this.proyecto.financiamiento.cuadro.totales.fdi || 0;
	      this.proyecto.financiamiento.monto_contraparte = this.proyecto.financiamiento.cuadro.totales.gam || 0;
	      this.proyecto.financiamiento.monto_beneficiarios = this.proyecto.financiamiento.cuadro.totales.beneficiarios || 0;
	      this.proyecto.financiamiento.monto_otros = this.proyecto.financiamiento.cuadro.totales.otros || 0;
	
	      // this.proyecto.financiamiento.cuadro.totales.fdi_pp
	      if (!this.proyecto.org_sociales) {
	        // si no es org_social se valida con el techo presupuestario
	        // console.log("no es organizacion solcial")
	        this.calcularFinanciamiento();
	      } else {
	        // arreglo temporal para el calculo de porcentajes en proyectos de organizaciones sociales
	        if (this.proyecto.estado_proyecto === 'REGISTRO_PROYECTO_FDI' && this.Usuarios.esTecnicoResponsable()) {
	          this.proyecto.financiamiento.monto_total_proyecto = (this.proyecto.financiamiento.monto_fdi || 0) + (this.proyecto.financiamiento.monto_contraparte || 0) + (this.proyecto.financiamiento.monto_beneficiarios || 0) + (this.proyecto.financiamiento.monto_otros || 0);
	          this.proyecto.monto_total = this.proyecto.financiamiento.monto_total_proyecto;
	          this.proyecto.monto_fdi = this.proyecto.financiamiento.monto_fdi || 0;
	          this.calcularPorcentajes(this.proyecto.financiamiento.monto_total_proyecto);
	        }
	      }
	    }
	  }, {
	    key: 'calcularPorcentajes',
	    value: function calcularPorcentajes(referencia) {
	      if (this.proyecto.financiamiento.cuadro.tipo === 1 || this.proyecto.financiamiento.cuadro.tipo === 2) {
	        this.proyecto.financiamiento.cuadro.porcentajes = {
	          total_referencia: referencia > 0 ? 100 : 0,
	          porcentaje_fdi: referencia > 0 ? this.proyecto.financiamiento.cuadro.totales.fdi / referencia * 100 : 0,
	          porcentaje_gam: referencia > 0 ? this.proyecto.financiamiento.cuadro.totales.gam / referencia * 100 : 0,
	          porcentaje_beneficiarios: referencia > 0 ? this.proyecto.financiamiento.cuadro.totales.beneficiarios / referencia * 100 : 0,
	          porcentaje_otros: referencia > 0 ? this.proyecto.financiamiento.cuadro.totales.otros / referencia * 100 : 0
	        };
	
	        if (this.proyecto.financiamiento.cuadro.tipo === 2) {
	          this.proyecto.financiamiento.cuadro.porcentajes.porcentaje_fdi_publico = referencia > 0 ? this.proyecto.financiamiento.cuadro.totales.publico / referencia * 100 : 0;
	          this.proyecto.financiamiento.cuadro.porcentajes.porcentaje_fdi_privado = referencia > 0 ? this.proyecto.financiamiento.cuadro.totales.privado / referencia * 100 : 0;
	          this.proyecto.financiamiento.cuadro.porcentajes.porcentaje_gam_publico = referencia > 0 ? this.proyecto.financiamiento.cuadro.totales.gampublico / referencia * 100 : 0;
	          this.proyecto.financiamiento.cuadro.porcentajes.porcentaje_gam_privado = referencia > 0 ? this.proyecto.financiamiento.cuadro.totales.gamprivado / referencia * 100 : 0;
	        }
	      }
	    }
	  }, {
	    key: 'obtenerTechoPresupuestario',
	    value: function obtenerTechoPresupuestario() {
	      var _this2 = this;
	
	      var codMunicipio = this.proyecto && this.proyecto.dpa && this.proyecto.dpa.municipio && this.proyecto.dpa.municipio.codigo ? this.proyecto.dpa.municipio.codigo : 0;
	      if (codMunicipio !== 0) {
	        this.Proyecto.DataService.get('techo_presupuestario/' + codMunicipio + '?gestion=' + this.proyecto.nro_convenio.substr(-4)).then(function (response) {
	          if (response) {
	            _this2.techoPresupuestario = response.datos;
	            // this.techoPresupuestario.monto_restante = response.datos.monto_disponible - this.proyecto.monto_total;
	            if (_this2.proyecto.observacion.mensaje) {
	              _this2.techoPresupuestario.monto_restante = response.datos.monto_disponible - _this2.proyecto.financiamiento.monto_fdi + _this2.monto_previo;
	            } else {
	              _this2.techoPresupuestario.monto_restante = response.datos.monto_disponible - _this2.proyecto.financiamiento.monto_fdi;
	            }
	            _this2.techoPresupuestario.monto_restante = _this2.techoPresupuestario.monto_restante > _this2.techoPresupuestario.techo_presupuestal ? _this2.techoPresupuestario.techo_presupuestal : _this2.techoPresupuestario.monto_restante;
	          }
	        });
	      }
	    }
	  }]);
	
	  return DatosFinanciamiento;
	}();
	
	exports.default = DatosFinanciamiento;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _informe = __webpack_require__(569);
	
	var _informe2 = _interopRequireDefault(_informe);
	
	var _informe3 = __webpack_require__(817);
	
	var _informe4 = _interopRequireDefault(_informe3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InformeEvaluacion = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _informe2.default,
	  template: _informe4.default
	};
	
	exports.default = InformeEvaluacion;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fixFecha = __webpack_require__(86);
	
	var _fixFecha2 = _interopRequireDefault(_fixFecha);
	
	var _fixFecha3 = __webpack_require__(99);
	
	var _fixFecha4 = _interopRequireDefault(_fixFecha3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InformeController = function () {
	  InformeController.$inject = ["$scope", "$log", "$timeout", "DataService", "Message", "Modal", "Loading", "apiUrl", "Util", "Storage", "Usuarios", "Proyecto"];
	  function InformeController($scope, $log, $timeout, DataService, Message, Modal, Loading, apiUrl, Util, Storage, Usuarios, Proyecto) {
	    'ngInject';
	
	    _classCallCheck(this, InformeController);
	
	    this.$scope = $scope;
	    this.apiUrl = apiUrl;
	    // this.$log = $log;
	    this.$timeout = $timeout;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Message = Message;
	    this.Loading = Loading;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.user = Storage.getUser();
	    this.esTecEval = [12, 13].indexOf(this.user.rol.id_rol) >= 0;
	    this.Usuarios = Usuarios;
	  }
	
	  _createClass(InformeController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (!this.proyecto.informe) {
	        this.proyecto.informe = {};
	        // Obtener plantilla de datos requeridos.
	        this.$obtenerFormInforme();
	
	        if (!this.proyecto.informe.director || this.proyecto.informe.director == undefined || this.proyecto.informe.director.trim() == "") {
	          this.proyecto.informe.director = this.proyecto.director_gral.nombre || '';
	        }
	
	        if (!this.proyecto.informe.indicador) this.proyecto.informe.indicador = {};
	        if (!this.proyecto.informe.indicador.proceso || this.proyecto.informe.indicador.proceso == '') {
	          this.proyecto.informe.indicador.proceso = this.proyecto.beneficiarios.indicadores_impacto[0].combinado || '0';
	        }
	      }
	
	      // Parámetros de descarga
	      this.descarga = {
	        urlDescarga: this.apiUrl + 'proyectos/' + this.proyecto.id_proyecto + '/doc/RIE/descargar',
	        nombreDescarga: 'Informe resumen'
	      };
	
	      if (this.proyecto.informe.valoracion.length < 9) {
	        this.agregarOpcionFps();
	      }
	
	      this.$scope.$watch('$ctrl.proyecto.beneficiarios.indicadores_impacto', function () {
	        _this.actualizarIndicadoresImpacto();
	      });
	
	      this.$scope.$watch('$ctrl.proyecto.informe.indicador.linea_base', function () {
	        // this.$log.log('Nuevo indicador de impacto', this);
	        _this.actualizarIndicadoresImpacto();
	      });
	    }
	  }, {
	    key: 'actualizarIndicadoresImpacto',
	    value: function actualizarIndicadoresImpacto() {
	      this.proyecto.informe.indicador.proceso = this.proyecto.beneficiarios.indicadores_impacto[0].combinado;
	      var _linea_base = parseFloat(this.proyecto.informe.indicador.linea_base);
	      _linea_base = isNaN(_linea_base) ? 0 : _linea_base;
	
	      var _indicador_impacto = this.proyecto.informe.indicador.proceso;
	      var _indicador_impacto_numero = _indicador_impacto ? parseFloat(_indicador_impacto.split(' ')[0]) : 0;
	      var _indicador_impacto_unidad = _indicador_impacto ? _indicador_impacto.split(' ')[1] : '';
	      _indicador_impacto_numero = isNaN(_indicador_impacto_numero) ? 0 : _indicador_impacto_numero;
	      this.proyecto.informe.indicador.impacto = this.Util.redondear(_linea_base + _indicador_impacto_numero) + ' ' + _indicador_impacto_unidad;
	    }
	  }, {
	    key: 'radioChange',
	    value: function radioChange(cols, index) {
	      if (!this.modoVista) {
	        for (var i in cols) {
	          if (cols[i].contenido && cols[i].contenido.type === 'radio') {
	            cols[i].contenido.value = i == index;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'radioColor',
	    value: function radioColor(contenido) {
	      if (contenido.value && contenido.name == 'CUMPLE') return 'btn-success';
	      if (contenido.value && contenido.name == 'NO_CUMPLE') return 'btn-danger';
	      return 'btn-secondary';
	    }
	  }, {
	    key: 'generarInformePdf',
	    value: function generarInformePdf(form) {
	      var _this2 = this;
	
	      if (!this.proyecto.evaluacion) {
	        this.Message.warning('Debe completar la pestaña de evaluación para poder continuar!');
	        return;
	      }
	      // Obtener estado de la evaluacion que tenga valor true
	      var estado_evaluacion = 'APROBAR';
	      if (this.Proyecto.tratarComoProductivo(this.proyecto)) {
	        estado_evaluacion = this.proyecto.evaluacion.datos5[0].cols.find(function (col) {
	          return col.contenido && col.contenido.value;
	        });
	        if (!estado_evaluacion || !estado_evaluacion.contenido || !(estado_evaluacion.contenido.name === 'APROBADO' || estado_evaluacion.contenido.name === 'RECHAZO')) {
	          this.Message.warning('La evaluación debe estar en estado APROBADO ó RECHAZADO!');
	          return;
	        }
	        estado_evaluacion = estado_evaluacion.contenido.name == 'RECHAZO' ? 'RECHAZAR' : 'APROBAR';
	      }
	      if (!this.$$datosCompletos(form)) {
	        this.Message.warning('Debe completar los campos marcados con *');
	        return;
	      }
	      this.Modal.confirm('¿Esta seguro/a de generar el informe?.', function () {
	        // Parsear datos a enviar
	        var _datos = angular.copy(_this2.proyecto.informe);
	        _datos.id_proyecto = _this2.proyecto.id_proyecto;
	        _datos.$_plantilla = 102;
	        _datos.$_nombre = 'informe';
	        _datos.codigo = _this2.proyecto.codigo;
	        _datos.estado_evaluacion = estado_evaluacion;
	        _datos.revisor = _this2.proyecto.evaluacion.revisor;
	        _datos.jefe_area = _this2.proyecto.evaluacion.jefe_area;
	        _datos.jefe_depto = _this2.proyecto.evaluacion.jefe_depto;
	        _this2.DataService.post('proyectos/' + _this2.proyecto.id_proyecto + '/informe-evaluacion', _datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this2.Message.success(resp.mensaje);
	            _this2.documentos.push(resp.datos);
	            _this2.proyecto.informe.codigo_documento = resp.datos.codigo_documento;
	          }
	        });
	      }, null, null, 'Si estoy seguro/a');
	    }
	  }, {
	    key: 'verInforme',
	    value: function verInforme(doc) {
	      this.Modal.showFormularioBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/INF?codigo=' + doc.codigo_documento, 'Informe de evaluaci\xF3n');
	    }
	  }, {
	    key: 'guardarDatos',
	    value: function guardarDatos() {
	      this.Loading.show('Registrando proyecto', true);
	      this.Message.success("Informe de evaluación creado.");
	      this.cerrar();
	      this.Loading.hide();
	    }
	  }, {
	    key: 'initPlantilla',
	    value: function initPlantilla() {
	      var _this3 = this;
	
	      this.$timeout(function () {
	        if (_this3.proyecto) {
	          _this3.DataService.get('proyectos/' + _this3.proyecto.id_proyecto + '/informes').then(function (resp) {
	            if (resp && resp.finalizado) {
	              _this3.documentos = resp.datos;
	            }
	          });
	        }
	      }, 500);
	    }
	  }, {
	    key: 'agregarOpcionFps',
	    value: function agregarOpcionFps() {
	      this.proyecto.informe.valoracion.push({
	        "cols": [{ "contenido": "Trabajo conjunto FPS" }, { "contenido": "La evaluación de este proyecto fue realizada en colaboración con el FPS" }, { "colspan": 2, "contenido": { "type": "select", "options": [{ "codigo": "0", "nombre": "No" }, { "codigo": "1", "nombre": "Si" }], "label": "evaluación realizada por el FPS", "value": "No" } }]
	      });
	    }
	  }, {
	    key: '$obtenerFormInforme',
	    value: function $obtenerFormInforme() {
	      var _this4 = this;
	
	      this.proyecto.informe.valoracion = [];
	      this.DataService.get('contenidos/informe_evaluacion/1').then(function (response) {
	        if (response) {
	          if (response.datos && response.datos.estructura) {
	            if (response.datos.estructura.length > 6) {
	              var row5 = response.datos.estructura[5];
	              var row6 = response.datos.estructura[6];
	              // Se cargan las condiciones necesarias
	              if (row5.cols && row5.cols.length > 0) {
	                row5.cols[0].contenido = 'Valor ' + (!_this4.Proyecto.tratarComoProductivo(_this4.proyecto) ? 'VANS' : 'VANE');
	              }
	              if (row6.cols && row6.cols.length > 0) {
	                row6.cols[0].contenido = 'Valor ' + (!_this4.Proyecto.tratarComoProductivo(_this4.proyecto) ? 'VANP' : 'VANF');
	              }
	
	              response.datos.estructura[5] = row5;
	              response.datos.estructura[6] = row6;
	
	              _this4.proyecto.informe.valoracion = response.datos.estructura;
	            }
	          }
	        }
	      });
	
	      // this.proyecto.informe.valoracion = [
	      //   {
	      //     cols: [
	      //       { rowspan: 2, contenido: 'Sostenibilidad técnica' },
	      //       { contenido: 'Requerimiento de componentes necesarios para la operación y/o funcionamiento del proyecto.' },
	      //       { contenido: { type: 'radio', value: false, name: 'CUMPLE' } },
	      //       { contenido: { type: 'radio', value: true, name: 'NO_CUMPLE' } },
	      //     ]
	      //   },
	      //   {
	      //     cols: [
	      //       { contenido: 'Distribución porcentual de los costos de inversión fija, capital de trabajo e inversión diferida.' },
	      //       { contenido: { type: 'radio', value: false, name: 'CUMPLE' } },
	      //       { contenido: { type: 'radio', value: true, name: 'NO_CUMPLE' } },
	      //     ]
	      //   },
	      //   {
	      //     cols: [
	      //       { contenido: 'Sostenibilidad social' },
	      //       { contenido: 'Actas de consenso y socialización' },
	      //       { contenido: { type: 'radio', value: false, name: 'CUMPLE' } },
	      //       { contenido: { type: 'radio', value: true, name: 'NO_CUMPLE' } },
	      //     ]
	      //   },
	      //   {
	      //     cols: [
	      //       { contenido: 'Sostenibilidad organizativo institucional' },
	      //       { contenido: 'Actores y roles definidos para la operación, mantenimiento y administración del proyecto' },
	      //       { contenido: { type: 'radio', value: false, name: 'CUMPLE' } },
	      //       { contenido: { type: 'radio', value: true, name: 'NO_CUMPLE' } },
	      //     ]
	      //   },
	      //   {
	      //     cols: [
	      //       { rowspan: 3, contenido: 'Sostenibilidad económica' },
	      //       { contenido: 'Tiempo de operación del proyecto' },
	      //       { contenido: { type: 'radio', value: false, name: 'CUMPLE' } },
	      //       { contenido: { type: 'radio', value: true, name: 'NO_CUMPLE' } },
	      //     ]
	      //   },
	      //   {
	      //     cols: [
	      //       { contenido: `Valor ${(this.proyecto.beneficiarios.tipo!=='OP_TP_PRODUCTIVO')? 'VACP': 'VANE'}` },
	      //       { colspan: 2, contenido: { type: 'inputMoney', value: 0, name: 'valor_vane' } },
	      //     ]
	      //   },
	      //   {
	      //     cols: [
	      //       { contenido: `Valor ${(this.proyecto.beneficiarios.tipo!=='OP_TP_PRODUCTIVO')? 'VACS': 'VANF'}` },
	      //       { colspan: 2, contenido: { type: 'inputMoney', value: 0, name: 'valor_vanf' } },
	      //     ]
	      //   },
	      //   {
	      //     cols: [
	      //       { contenido: 'Sostenibilidad ambiental' },
	      //       { contenido: 'Dispensación o Evaluación del Impacto Ambiental' },
	      //       { colspan: 2, contenido: { type: 'textarea', value: '* El proyecto cuenta con certificado de dispensación ambiental\n* Se encuentra en proceso de tramite' } }
	      //     ]
	      //   }
	      // ];
	
	      //     this.proyecto.informe.criterios = [
	      //       //*******
	      //       {
	      //         cols: [
	      //           { contenido: '1' },
	      //           { contenido: { type: 'textarea', value: 'El proyecto ha sido priorizado de manera consensuada por las organizaciones indígenas originario campesinas.' } },
	      //           { contenido: { type: 'textarea', value: 'Acta de consenso de priorización del proyecto, firmada por las Organizaciones Indígenas Originario Campesinas.' } }
	      //         ]
	      //       },
	      //       {
	      //         cols: [
	      //           { contenido: '2' },
	      //           { contenido: { type: 'textarea', value: 'El EDTP corresponde a uno de los tipos de programas y/o proyectos establecidos por el FDI.' } },
	      //           { contenido: { type: 'textarea', value: 'Documento del EDTP.' } }
	      //         ]
	      //       },
	      //       {
	      //         cols: [
	      //           { contenido: '3' },
	      //           { contenido: { type: 'textarea', value: `${(this.proyecto.beneficiarios.tipo!=='OP_TP_PRODUCTIVO')?'El EDTP está elaborado en el formato del Viceministerio de Recursos Hídricos y Riego, dependiente del Ministerio de Medio Ambiente y Agua.\n':''}
	      // El EDTP está elaborado en el formato correspondiente de acuerdo a lo establecido por el FDI.` } },
	      //           { contenido: { type: 'textarea', value: 'Documento del EDTP' } }
	      //         ]
	      //       },
	      //       {
	      //         cols: [
	      //           { contenido: '4' },
	      //           { contenido: { type: 'textarea', value: 'La población beneficiaria del proyecto está constituida por familias de pequeños productores de los pueblos indígena originario campesinos, comunidades interculturales y/o afrobolivianas.' } },
	      //           { contenido: { type: 'textarea', value: 'Lista de beneficiarios con N° de Cédula de Identidad y firma.' } }
	      //         ]
	      //       },
	      //       {
	      //         cols: [
	      //           { contenido: '5' },
	      //           { contenido: { type: 'textarea', value: 'El proyecto no sobrepasa los techos presupuestarios definidos por el FDI.' } },
	      //           { contenido: { type: 'textarea', value: 'Estructura de financiamiento del proyecto.' } }
	      //         ]
	      //       }
	      //       //*******
	      //     ];
	    }
	  }, {
	    key: 'corregirFecha',
	    value: function corregirFecha(doc) {
	      var _this5 = this;
	
	      this.Modal.show({
	        title: 'Modificar fecha!',
	        controller: _fixFecha2.default,
	        template: _fixFecha4.default,
	        data: doc
	      }).result.then(function (resp) {
	        var datos = {
	          codigo_documento: resp.codigo_documento,
	          fecha_documento: resp.fecha_documento
	        };
	        _this5.DataService.put('proyectos/' + _this5.proyecto.id_proyecto + '/formulario/informe/' + resp.id_formulario, datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            doc.fecha_documento = resp.datos.fecha_documento;
	            _this5.Message.success(resp.mensaje);
	          }
	        });
	      }).catch(function () {});
	    }
	  }, {
	    key: 'estado',
	    value: function estado(doc) {
	      var _this6 = this;
	
	      this.Modal.confirm('¿Esta seguro/a de cambiar el estado?.', function () {
	        var datos = {
	          codigo_documento: doc.codigo_documento,
	          estado: doc.estado === 'INACTIVO' ? 'ELABORADO' : 'INACTIVO'
	        };
	        _this6.DataService.put('proyectos/' + _this6.proyecto.id_proyecto + '/formulario/informe/' + doc.id_formulario, datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            doc.estado = resp.datos.estado;
	            _this6.Message.success(resp.mensaje);
	          }
	        });
	      }, null, null, 'Si estoy seguro/a');
	    }
	
	    // Metodos privados
	
	  }, {
	    key: '$$datosCompletos',
	    value: function $$datosCompletos(form) {
	      return form.$valid;
	    }
	  }]);
	
	  return InformeController;
	}();
	
	exports.default = InformeController;

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArchivoModalController = function () {
	  ArchivoModalController.$inject = ["$uibModalInstance", "data", "title", "icon", "DataService", "Message", "labelOk", "apiUrl"];
	  function ArchivoModalController($uibModalInstance, data, title, icon, DataService, Message, labelOk, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, ArchivoModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.title = title;
	    this.icon = icon;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.labelOk = labelOk;
	    this.apiUrl = apiUrl;
	  }
	
	  _createClass(ArchivoModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.descargas = {
	        // manual: {
	        //   ruta: `${this.apiUrl}items/csv/manuales?archivo=manual_csv`,
	        //   nombre: 'Manual csv'
	        // },
	        // modelo: {
	        //   ruta: `${this.apiUrl}items/csv/manuales?archivo=items&tipo=csv`,
	        //   nombre: 'Modelo items'
	        // }
	        manual: {
	          ruta: this.apiUrl + 'items/csv/manuales?archivo=manual_ods',
	          nombre: 'Manual ods'
	        },
	        modelo: {
	          ruta: this.apiUrl + 'items/csv/manuales?archivo=items&tipo=ods',
	          nombre: 'Modelo items'
	        }
	      };
	    }
	  }, {
	    key: 'registrar',
	    value: function registrar() {
	      this.$uibModalInstance.close(this.archivo);
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ArchivoModalController;
	}();
	
	exports.default = ArchivoModalController;

/***/ }),
/* 571 */
[861, 572, 819, 209],
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moduloModal = __webpack_require__(574);
	
	var _moduloModal2 = _interopRequireDefault(_moduloModal);
	
	var _moduloModal3 = __webpack_require__(821);
	
	var _moduloModal4 = _interopRequireDefault(_moduloModal3);
	
	var _archivoModal = __webpack_require__(570);
	
	var _archivoModal2 = _interopRequireDefault(_archivoModal);
	
	var _archivoModal3 = __webpack_require__(818);
	
	var _archivoModal4 = _interopRequireDefault(_archivoModal3);
	
	var _validacion = __webpack_require__(573);
	
	var _validacion2 = _interopRequireDefault(_validacion);
	
	var _validacion3 = __webpack_require__(820);
	
	var _validacion4 = _interopRequireDefault(_validacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemsController = function () {
	  ItemsController.$inject = ["$scope", "$window", "DataService", "Util", "Modal", "NgTableParams", "_", "Message", "Proyecto", "Storage", "Usuarios", "Datetime"];
	  function ItemsController($scope, $window, DataService, Util, Modal, NgTableParams, _, Message, Proyecto, Storage, Usuarios, Datetime) {
	    'ngInject';
	
	    _classCallCheck(this, ItemsController);
	
	    this.$scope = $scope;
	    this.$window = $window;
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Modal = Modal;
	    this.NgTableParams = NgTableParams;
	    this._ = _;
	    this.Message = Message;
	    this.Proyecto = Proyecto;
	    this.Usuarios = Usuarios;
	    this.Datetime = Datetime;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(ItemsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.modulos = [];
	      this.getTipoUnidades();
	      // Lista general para tecnico y responsable
	      console.log(this.user);
	
	      if (this.Usuarios.esResponsableProyecto()) {
	        this.getListaModulos();
	      } else {
	        this.obtenerAdjudicaciones();
	        // this.getEquipoTecnico();
	      }
	
	      this.$scope.$watch('$ctrl.adjudicacionSeleccionada', function (newValue, oldValue) {
	        if (angular.toJson(newValue) != angular.toJson(oldValue)) {
	          _this.getAdjudicacion(newValue.id_adjudicacion);
	        }
	      });
	    }
	  }, {
	    key: 'getListaModulos',
	    value: function getListaModulos(modulo) {
	      var _this2 = this;
	
	      this.DataService.get('modulos/proyectos/' + this.proyecto.id_proyecto).then(function (response) {
	        if (response && response.finalizado) {
	          _this2.modulos = response.datos.rows;
	          if (modulo && _this2.modulos.length) {
	            for (var i in _this2.modulos) {
	              if (_this2.modulos[i].id_modulo == modulo.id_modulo) {
	                _this2.modulos[i].show = true;
	              }
	            }
	          }
	          // this.copiarItems();
	          _this2.calcularTotal();
	        }
	      });
	    }
	  }, {
	    key: 'getListaModulosPorAdjudicacion',
	    value: function getListaModulosPorAdjudicacion(modulo) {
	      var _this3 = this;
	
	      this.DataService.get('modulos/proyectos/' + this.proyecto.id_proyecto + '/' + this.adjudicacion.id_adjudicacion).then(function (response) {
	        if (response && response.finalizado) {
	          _this3.modulos = response.datos.rows;
	          if (modulo && _this3.modulos.length) {
	            for (var i in _this3.modulos) {
	              if (_this3.modulos[i].id_modulo == modulo.id_modulo) {
	                _this3.modulos[i].show = true;
	              }
	            }
	          }
	          // this.copiarItems();
	          _this3.calcularTotal();
	        }
	      });
	    }
	  }, {
	    key: 'getItems',
	    value: function getItems(modulo) {
	      var _this4 = this;
	
	      if (!modulo.show) {
	        if (!modulo.items) {
	          this.DataService.get('items/modulo/' + modulo.id_modulo).then(function (response) {
	            if (response && response.finalizado) {
	              modulo.items = response.datos.rows;
	              _this4.calcularTotal();
	            }
	          });
	        }
	      }
	      modulo.show = !modulo.show;
	    }
	  }, {
	    key: 'getTipoUnidades',
	    value: function getTipoUnidades() {
	      var _this5 = this;
	
	      this.DataService.get('parametricas/UNIDAD').then(function (response) {
	        if (response) {
	          _this5.unidades = response.datos.rows;
	        }
	      });
	    }
	
	    // getEquipoTecnico() {
	    //   this.DataService.get(`proyectos/${this.proyecto.id_proyecto}/equipos_tecnicos/supervisor`).then(response => {
	    //     if (response) {
	    //       this.equipos_tecnicos = response.datos;
	    //       this.obtenerAdjudicaciones();
	    //     }
	    //   });
	    // }
	
	  }, {
	    key: 'obtenerAdjudicaciones',
	    value: function obtenerAdjudicaciones() {
	      var _this6 = this;
	
	      this.opcionesAdjudicaciones = [];
	      // for (let eqTecnico in this.equipos_tecnicos) {
	      // const equipo_tecnico = this.equipos_tecnicos[eqTecnico];
	      // if (equipo_tecnico.fid_adjudicacion) {
	      this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/adjudicaciones/supervision').then(function (response) {
	        if (response) {
	          _this6.opcionesAdjudicaciones = response.datos;
	          // this.adjudicacion = response.datos;
	          // this.getListaModulosPorAdjudicacion();
	        }
	      });
	      // }
	      // }
	    }
	  }, {
	    key: 'getAdjudicacion',
	    value: function getAdjudicacion(id_adjudicacion) {
	      var _this7 = this;
	
	      // if (this.equipo_tecnico && this.equipo_tecnico.fid_adjudicacion) {
	      delete this.proyecto.adj;
	      this.DataService.get('proyectos/adjudicaciones/' + id_adjudicacion).then(function (response) {
	        if (response) {
	          _this7.adjudicacion = response.datos;
	          _this7.getListaModulosPorAdjudicacion();
	          _this7.prepararValidacionesFecha();
	          _this7.proyecto.adj = {
	            id_adjudicacion: _this7.adjudicacion.id_adjudicacion,
	            monto_supervision: _this7.adjudicacion.monto_supervision,
	            orden_proceder: _this7.adjudicacion.orden_proceder,
	            doc_especificaciones_tecnicas: _this7.adjudicacion.doc_especificaciones_tecnicas
	          };
	        }
	      });
	      // }
	    }
	  }, {
	    key: 'adicionarModulo',
	    value: function adicionarModulo() {
	      var _this8 = this;
	
	      if (this.adjudicacion) {
	        var modulo = {
	          fid_proyecto: this.proyecto.id_proyecto,
	          referencia: this.adjudicacion.referencia,
	          fid_adjudicacion: this.adjudicacion.id_adjudicacion
	        };
	        var modalModulo = this.mostrarModal('Nuevo módulo', 'fa-plus', modulo, _moduloModal4.default, _moduloModal2.default);
	        modalModulo.result.then(function (result) {
	          if (result && result.datos) {
	            _this8.modulos.push(result.datos);
	          }
	        });
	      } else {
	        this.Message.error('Debe seleccionar una adjudicaci\xF3n antes de agregar un m\xF3dulo');
	      }
	    }
	  }, {
	    key: 'editarModulo',
	    value: function editarModulo(modulo) {
	      modulo.referencia = this.adjudicacion.referencia;
	      modulo.componente = modulo.nombre.split('|')[0];
	      modulo.modulo = modulo.nombre.split('|')[1];
	      this.mostrarModal('Editar módulo', 'fa-edit', modulo, _moduloModal4.default, _moduloModal2.default);
	    }
	  }, {
	    key: 'eliminarModulo',
	    value: function eliminarModulo(modulo) {
	      var _this9 = this;
	
	      var msg = '\xBFEst\xE1 seguro/a de eliminar el m\xF3dulo <strong>' + modulo.nombre.split('|')[1] + '</strong>' + (modulo && modulo.items && modulo.items.length ? modulo.items.length === 1 ? ' y su único item?' : ' y sus ' + modulo.items.length + ' items?' : '?');
	      this.Modal.confirm(msg, function () {
	        _this9.DataService.delete('modulos/' + modulo.id_modulo).then(function (result) {
	          if (result) {
	            _this9.modulos = _this9.eliminarElementoDeLista(_this9.modulos, modulo, 'id_modulo');
	            _this9.Message.success('El m\xF3dulo "' + modulo.nombre + '" ha sido eliminado.');
	            _this9.$window.setTimeout(function () {
	              _this9.refrescarLista();
	            }, 500);
	          }
	        });
	      }, null, null, 'Si, estoy seguro/a');
	    }
	  }, {
	    key: 'calcularItem',
	    value: function calcularItem(item, index, idxModulo) {
	      this.modulos[idxModulo].items[index].subtotal = this.Util.multiplicar([this.modulos[idxModulo].items[index].precio_unitario, this.modulos[idxModulo].items[index].cantidad]) + this.modulos[idxModulo].items[index].variacion;
	      // this.calcularTotal()
	    }
	  }, {
	    key: 'adicionarItem',
	    value: function adicionarItem(modulo) {
	      if (!modulo.items) {
	        modulo.items = [];
	      }
	      for (var i in this.modulos) {
	        for (var j in this.modulos[i].items) {
	          if (!this.modulos[i].items[j].id_item || this.modulos[i].items[j].edicion) {
	            this.Message.warning('Debe guardar el item "' + (this.modulos[i].items[j].nombre || 'Sin nombre') + '"');
	            return;
	          }
	        }
	      }
	      modulo.items.push({ edicion: true });
	    }
	  }, {
	    key: 'guardarItem',
	    value: function guardarItem(item, index, idxModulo, modulo) {
	      var _this10 = this;
	
	      if (!this.sonDatosValidosItem(modulo, index)) {
	        return;
	      }
	      item.fid_modulo = modulo.id_modulo;
	      this.DataService.post('items', item).then(function (response) {
	        if (response) {
	          _this10.Message.success('Item "' + item.nombre + '" registrado correctamente.');
	          _this10.modulos[idxModulo].items[index] = response.datos;
	          // this.refrescarLista(modulo);
	          _this10.calcularTotal();
	        }
	      });
	    }
	  }, {
	    key: 'actualizarItem',
	    value: function actualizarItem(item, index, modulo) {
	      var _this11 = this;
	
	      if (!this.sonDatosValidosItem(modulo, index)) {
	        return;
	      }
	      this.DataService.put('items/' + item.id_item, item).then(function (response) {
	        if (response) {
	          _this11.Message.success('Item "' + item.nombre + '" actualizado correctamente.');
	          item.edicion = false;
	          // this.refrescarLista(modulo);
	          _this11.calcularTotal();
	        }
	      });
	    }
	  }, {
	    key: 'eliminarItem',
	    value: function eliminarItem(item, $index, modulo) {
	      var _this12 = this;
	
	      if (!item.id_item) {
	        modulo.items.splice($index, 1);
	        return;
	      }
	      this.DataService.delete('items/' + item.id_item).then(function (result) {
	        if (result) {
	          _this12.Message.success('Item "' + item.nombre + '" eliminado correctamente.');
	          modulo.items = _this12.eliminarElementoDeLista(modulo.items, item, 'id_item');
	          _this12.$window.setTimeout(function () {
	            // this.refrescarLista(modulo);
	            _this12.calcularTotal();
	          }, 500);
	        }
	      });
	    }
	  }, {
	    key: 'eliminarElementoDeLista',
	    value: function eliminarElementoDeLista(lista, elemento, atributo) {
	      return this._.reject(lista, function (item) {
	        return item[atributo] === elemento[atributo];
	      });
	    }
	  }, {
	    key: 'mostrarModal',
	    value: function mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
	      return this.Modal.show({
	        template: template,
	        controller: controller,
	        data: data || {},
	        title: titulo,
	        icon: icon,
	        size: size ? size : 'md',
	        labelOk: labelOk
	      });
	    }
	  }, {
	    key: 'guardarDatosModulo',
	    value: function guardarDatosModulo(modulo) {
	      var _this13 = this;
	
	      this.DataService.put('modulos/' + modulo.id_modulo, modulo).then(function (response) {
	        if (response) {
	          //modulo.items = response.datos.items;
	          _this13.Message.success('Los datos del m\xF3dulo "' + modulo.nombre + '" se guardaron correctamente.');
	          _this13.refrescarLista(modulo);
	        }
	      });
	    }
	  }, {
	    key: 'sonDatosValidosItem',
	    value: function sonDatosValidosItem(modulo, posicion) {
	      var nombreForm = 'form_' + modulo.id_modulo;
	      var FORM = angular.element(document.querySelector('[name=' + nombreForm + ']')).scope()[nombreForm];
	      var esValido = FORM['item_nombre_' + posicion].$valid && FORM['item_unidad_' + posicion].$valid && FORM['item_cantidad_' + posicion].$valid;
	
	      if (!esValido) {
	        FORM['item_nombre_' + posicion].$setTouched();
	        FORM['item_unidad_' + posicion].$setTouched();
	        FORM['item_cantidad_' + posicion].$setTouched();
	
	        this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'importarItems',
	    value: function importarItems() {
	      var _this14 = this;
	
	      if (this.adjudicacion) {
	        var confArchivo = {
	          formatos: ' ods', //types
	          tipos: '.csv,.xlsx,.ods', //mime-types
	          cargarItems: true,
	          mensajeInformacion: 'Puede importar items desde un <strong>archivo en formato .ods</strong>.'
	        };
	        this.mostrarModal('Importar Items', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Importar').result.then(function (documento) {
	          var items = {
	            id_proyecto: _this14.proyecto.id_proyecto,
	            id_adjudicacion: _this14.adjudicacion.id_adjudicacion,
	            base64: documento.base64
	          };
	          _this14.DataService.post('items/file', items).then(function (result) {
	            if (result.finalizado) {
	              _this14.Message.success('Se importó correctamente los items.');
	              // this.modulos = result.datos;
	              // this.calcularTotal();
	              _this14.$window.setTimeout(function () {
	                _this14.getListaModulosPorAdjudicacion();
	              }, 500);
	            }
	            if (result.erroresValidacion) {
	              var modalModulo = _this14.mostrarModal('Observaciones en el archivo CSV', 'fa-check', result.erroresValidacion, _validacion4.default, _validacion2.default, null, 'lg');
	              modalModulo.result.then(function (result) {
	                result;
	              });
	            }
	          });
	        });
	      } else {
	        this.Message.error('Debe seleccionar una adjudicaci\xF3n antes de cargar items');
	      }
	    }
	  }, {
	    key: 'cargarEspecificacionesTecnicas',
	    value: function cargarEspecificacionesTecnicas() {
	      var _this15 = this;
	
	      if (this.adjudicacion) {
	        var confArchivo = {
	          formatos: 'pdf',
	          tipos: '.pdf',
	          mensajeInformacion: 'El archivo representará a las especificaciones técnicas de los items contenidos en la presente adjudicación.'
	        };
	        this.mostrarModal('Especificaciones T\xE9cnicas', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (docEspecificaciones) {
	          if (angular.isUndefined(docEspecificaciones)) {
	            return;
	          }
	          var datos = {
	            doc_especificaciones_tecnicas: docEspecificaciones,
	            rol: _this15.user.rol.id_rol
	          };
	          _this15.DataService.put('proyectos/' + _this15.proyecto.id_proyecto + '/adjudicaciones/' + _this15.adjudicacion.id_adjudicacion + '/esp_tecnicas', datos).then(function (result) {
	            if (result) {
	              _this15.Message.success('Se registr\xF3 el documento de especificaciones t\xE9cnicas correctamente.');
	              _this15.adjudicacion.doc_especificaciones_tecnicas = result.datos.doc_especificaciones_tecnicas;
	              _this15.proyecto.adj.doc_especificaciones_tecnicas = result.datos.doc_especificaciones_tecnicas;
	            }
	          });
	          // this.DataService.put(`proyectos/${this.proyecto.id_proyecto}`, {doc_especificaciones_tecnicas: docEspecificaciones, rol: this.user.rol.id_rol}).then(result => {
	          //   if (result) {
	          //     this.Message.success(`Se registró el documento de especificaciones técnicas correctamente.`);
	          //     this.proyecto.doc_especificaciones_tecnicas = result.datos.doc_especificaciones_tecnicas;
	          //   }
	          // });
	        });
	      } else {
	        this.Message.error('Debe seleccionar una adjudicación antes de cargar las especificaciones técnicas');
	      }
	    }
	  }, {
	    key: 'verEspecificacionesTecnicas',
	    value: function verEspecificacionesTecnicas() {
	      // this.Modal.showDocumentBase64(`proyectos/${this.proyecto.id_proyecto}/doc/ET`,
	      // `Especificaciones Técnicas`);
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/' + this.adjudicacion.doc_especificaciones_tecnicas.substring(1, this.adjudicacion.doc_especificaciones_tecnicas.indexOf(']')), 'Especificaciones T\xE9cnicas');
	    }
	  }, {
	    key: 'cargarEspecificacionesItem',
	    value: function cargarEspecificacionesItem(item) {
	      var _this16 = this;
	
	      var confArchivo = {
	        formatos: 'pdf',
	        tipos: '.pdf'
	      };
	      this.mostrarModal('Especificaciones T\xE9cnicas - "' + item.nombre + '"', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (docEspecificaciones) {
	        if (angular.isUndefined(docEspecificaciones)) {
	          return;
	        }
	        _this16.DataService.put('items/' + item.id_item, { especificaciones: docEspecificaciones }).then(function (result) {
	          if (result && result.finalizado) {
	            _this16.Message.success('Se registr\xF3 el documento de especificaciones t\xE9cnicas del item "' + item.nombre + '" correctamente.');
	            item.especificaciones = docEspecificaciones;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'verEspecificacionesItem',
	    value: function verEspecificacionesItem(item) {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/ET_' + item.id_item, 'Especificaciones T\xE9cnicas - "' + item.nombre + '"');
	    }
	  }, {
	    key: 'refrescarLista',
	    value: function refrescarLista(modulo) {
	      this.getListaModulosPorAdjudicacion(modulo);
	    }
	
	    /* Registrar precios unitarios */
	    // registrarPrecioItem(item) {
	    //   if (!this.esPrecioActualizado(item) || angular.isUndefined(item.precio_unitario) || angular.isUndefined(item.id_item)) {
	    //     return;
	    //   }
	    //   this.DataService.put(`items/${item.id_item}`, {precio_unitario: item.precio_unitario})
	    //   .then( result => {
	    //     if (result) {
	    //       this.actualizarCopiaItems(result.datos);
	    //       this.calcularTotal(item);
	    //     }
	    //   });
	    // }
	
	  }, {
	    key: 'copiarItems',
	    value: function copiarItems() {
	      this.cModulos = angular.copy(this.modulos);
	    }
	  }, {
	    key: 'esPrecioActualizado',
	    value: function esPrecioActualizado(item) {
	      // const cItem = this.cItems[this._.findIndex(this.cItems, {id_item: item.id_item})];
	      // return cItem.precio_unitario !== item.precio_unitario;
	      return item;
	    }
	  }, {
	    key: 'actualizarCopiaItems',
	    value: function actualizarCopiaItems(item) {
	      // this.cItems[this._.findIndex(this.cItems, {id_item: item.id_item})] = item;
	      return item;
	    }
	  }, {
	    key: 'checkboxRegularizar',
	    value: function checkboxRegularizar(item, index, idxModulo) {
	      console.log("this.modulos.item.regularizar", this.modulos[idxModulo].items[index].regularizar);
	      if (!this.modulos[idxModulo].items[index].regularizar) {
	        this.modulos[idxModulo].items[index].variacion = 0;
	      }
	    }
	  }, {
	    key: 'calcularTotal',
	    value: function calcularTotal(item) {
	      this.precioTotal = 0;
	      /*this.modulos.map(modulo => {
	        modulo.items.map(item => {
	          if (item.cantidad && item.precio_unitario) {
	            item.subtotal = this.Util.multiplicar([item.cantidad, item.precio_unitario]);
	            this.precioTotal = this.Util.sumar([this.precioTotal, this.Util.multiplicar([item.cantidad, item.precio_unitario])])
	          }
	        });
	      });  */
	
	      for (var idxModulo in this.modulos) {
	        // console.log(idxModulo,"idxmodulo", this.modulos[idxModulo])
	        var modulo = this.modulos[idxModulo];
	        var totalModulo = 0;
	        for (var j in modulo.items) {
	          var _item = modulo.items[j];
	          // console.log(item.variacion,"variacion decimal")
	          if (_item.variacion) {
	            _item.subtotal = this.Util.multiplicar([_item.precio_unitario, _item.cantidad]) + _item.variacion;
	          } else {
	            _item.subtotal = this.Util.multiplicar([_item.precio_unitario, _item.cantidad], true, 2);
	          }
	          // item.subtotal = this.Util.multiplicar([item.precio_unitario, item.cantidad]);
	          // console.log(item.subtotal,"subtotal")
	          totalModulo = this.Util.sumar([_item.subtotal, totalModulo]);
	        }
	        modulo.subtotal = modulo.items && modulo.items.length > 0 ? this.Util.redondear(totalModulo) : modulo.precio;
	        // this.precioTotal = this.Util.sumar([this.precioTotal, totalModulo]);
	        this.precioTotal = this.Util.sumar([this.precioTotal, modulo.subtotal]);
	      }
	      /*for(let idxModulo in this.modulos) {
	        let totalModulo = 0;
	        for (let index in this.modulos[idxModulo].items) {
	          this.modulos[idxModulo].items[index].subtotal = this.Util.multiplicar([this.modulos[idxModulo].items[index].precio_unitario, this.modulos[idxModulo].items[index].cantidad]);
	          totalModulo = this.Util.sumar(this.modulos[idxModulo].items[index].subtotal, totalModulo);
	        }
	        this.modulos[idxModulo].subtotal = this.Util.redondear(totalModulo);
	        this.precioTotal = this.Util.sumar(this.precioTotal, totalModulo);
	      }*/
	
	      this.precioTotal = this.Util.redondear(this.precioTotal);
	      this.diferencia = this.adjudicacion.monto - this.precioTotal;
	      if (this.esPresupuestoValido()) {
	        // this.proyecto.monto_total = this.precioTotal;
	        this.proyecto.montoItemsExcedido = false;
	        if (this.proyecto.adj) {
	          this.proyecto.adj.monto_supervision = this.precioTotal;
	        }
	      } else {
	        // this.proyecto.monto_total = null;
	        this.proyecto.montoItemsExcedido = true;
	        this.Message.error('El precio total de los items no debe ser mayor al monto total adjudicado.');
	        if (item) item.precio_unitario = '';
	      }
	    }
	  }, {
	    key: 'esPresupuestoValido',
	    value: function esPresupuestoValido() {
	      if (this.adjudicacion) {
	        return this.precioTotal <= this.adjudicacion.monto;
	      } else {
	        return this.precioTotal <= this.proyecto.financiamiento.monto_total_proyecto;
	      }
	    }
	  }, {
	    key: 'tieneSupervisiones',
	    value: function tieneSupervisiones(modulo) {
	      if (this.proyecto && this.proyecto.supervisiones && this.proyecto.supervisiones.length > 0) {
	        for (var i in this.proyecto.supervisiones) {
	          if (modulo && this.proyecto.supervisiones[i].fid_adjudicacion === modulo.fid_adjudicacion || this.adjudicacion && this.proyecto.supervisiones[i].fid_adjudicacion === this.adjudicacion.id_adjudicacion) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'prepararValidacionesFecha',
	    value: function prepararValidacionesFecha() {
	      var fechaDesde = void 0,
	          mensajeError = 'La fecha debe ser mayor a la fecha';
	      // if (this.proyecto.orden_proceder) {
	      //   let desde = this.proyecto.orden_proceder;
	      //   desde = this.Datetime.getFormatDate(desde);
	      //   desde = this.Datetime.subtractDays(desde, 1);
	      //   desde = new Date(desde);
	      //   let mes = desde.getMonth() + 1;
	      //   fechaDesde = desde.getDate() + "-" + (mes <= 9 ? '0'+mes : mes) + "-" + desde.getFullYear();
	      //   mensajeError = `La fecha debe ser mayor o igual a la fecha de orden de proceder del proyecto`;
	      //   fechaDesde = this.Datetime.getFormatDate(fechaDesde);
	      //   this.validacion = {
	      //     fecha_minima: this.Datetime.addDaysToDate(angular.copy(fechaDesde), 1),
	      //     mensaje_fecminima: `${mensajeError} (${this.Datetime.parseDate(this.Datetime.addDaysToDate(angular.copy(fechaDesde), 1), '/')})`
	      //   };
	      // } else
	      {
	        // SE COMENTÓ LO DE ABAJO PORQUE NO SE USAN BOLETAS EN ESTOS PROYECTOS
	        // ESTO GENERABA UN ERROR EN EL SISTEMA AL MOMENTO DE MOSTRAR LA FECHA DE ORDEN PROCEDER DE ESTA ADJUDICACION
	        // if (this.tieneBoletas()) {
	        //   fechaDesde = this.fechaMasAntiguaDeBoletas();
	        //   mensajeError = `${mensajeError} de inicio de la boleta de anticipo más antigua`;
	        // } else 
	        if (this.proyecto.tipo === 'TP_CIF' || this.proyecto.fecha_desembolso) {
	          fechaDesde = this.proyecto.fecha_desembolso;
	          mensajeError = mensajeError + ' del desembolso';
	        } else {
	          fechaDesde = this.proyecto.convenio.fecha_suscripcion;
	          mensajeError = mensajeError + ' del convenio';
	        }
	        fechaDesde = this.Datetime.getFormatDate(fechaDesde);
	        this.validacion = {
	          fecha_minima: this.Datetime.addDaysToDate(angular.copy(fechaDesde), 1),
	          mensaje_fecminima: mensajeError + ' (' + this.Datetime.parseDate(fechaDesde, '/') + ')'
	        };
	      }
	    }
	  }, {
	    key: 'tieneBoletas',
	    value: function tieneBoletas() {
	      return this.proyecto.boletas.length > 0;
	    }
	  }, {
	    key: 'fechaMasAntiguaDeBoletas',
	    value: function fechaMasAntiguaDeBoletas() {
	      return this._.sortBy(this.proyecto.boletas, function (boleta) {
	        return boleta.fecha_inicio_validez;
	      })[0].fecha_inicio_validez;
	    }
	  }, {
	    key: 'actualizarPesoItem',
	    value: function actualizarPesoItem(item) {
	      var _this17 = this;
	
	      if (!item.peso_ponderado) {
	        item.peso_ponderado = 0;
	      }
	      if (item && item.id_item > 0 && !item.edicion) {
	        this.DataService.put('items/' + item.id_item, { peso_ponderado: item.peso_ponderado }).then(function (result) {
	          if (result && result.finalizado) {
	            _this17.Message.success(result.mensaje);
	          } else {
	            _this17.Message.warning('Sucedió un error al tratar de actualizar el item, intente de nuevo por favor');
	          }
	        });
	      }
	    }
	  }]);
	
	  return ItemsController;
	}();
	
	exports.default = ItemsController;

/***/ }),
/* 573 */
473,
/* 574 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModuloController = function () {
	  ModuloController.$inject = ["$uibModalInstance", "data", "title", "icon", "DataService", "Message"];
	  function ModuloController($uibModalInstance, data, title, icon, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ModuloController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.title = title;
	    this.icon = icon;
	    this.DataService = DataService;
	    this.Message = Message;
	  }
	
	  _createClass(ModuloController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modulos = [];
	      this.modulo = this.data;
	      this.modulo.componente = this.modulo.referencia.toUpperCase();
	
	      // this.opcionesComponente = this.obtenerOpcionesComponente();
	    }
	
	    // obtenerOpcionesComponente() {
	    //   let opcionesComponente = [];
	    //   if (this.modulo && this.modulo.referencia) {
	    //     opcionesComponente = this.modulo.referencia.split(',');
	    //     for (let i in opcionesComponente) {
	    //       opcionesComponente[i] = {
	    //         nombre: opcionesComponente[i].trim().toUpperCase()
	    //       };
	    //     }
	    //   }
	    //   return opcionesComponente;
	    // }
	
	  }, {
	    key: 'guardar',
	    value: function guardar() {
	      var _this = this;
	
	      // if (typeof this.modulo.componente === 'object') {
	      //   this.modulo.nombre = this.modulo.componente.nombre +'|'+ this.modulo.resultado;
	      // } else {
	      this.modulo.nombre = this.modulo.componente + '|' + this.modulo.modulo;
	      // }
	      this.DataService.post('modulos', this.modulo).then(function (resp) {
	        if (resp) {
	          _this.Message.success("Se registró el módulo correctamente.");
	          _this.$uibModalInstance.close(resp);
	        }
	      });
	    }
	  }, {
	    key: 'actualizar',
	    value: function actualizar() {
	      var _this2 = this;
	
	      // if (typeof this.modulo.componente === 'object') {
	      //   this.modulo.nombre = this.modulo.componente.nombre +'|'+ this.modulo.resultado;
	      // } else {
	      this.modulo.nombre = this.modulo.componente + '|' + this.modulo.modulo;
	      // }
	      this.DataService.put('modulos/' + this.modulo.id_modulo, this.modulo).then(function (resp) {
	        if (resp) {
	          _this2.Message.success("Se actualizó el módulo correctamente.");
	          _this2.$uibModalInstance.close(resp);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ModuloController;
	}();
	
	exports.default = ModuloController;

/***/ }),
/* 575 */
570,
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _listaCierre = __webpack_require__(577);
	
	var _listaCierre2 = _interopRequireDefault(_listaCierre);
	
	var _listaCierre3 = __webpack_require__(823);
	
	var _listaCierre4 = _interopRequireDefault(_listaCierre3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListaCierre = {
		bindings: {
			proyecto: '=',
			modoVista: '<'
		},
		controller: _listaCierre2.default,
		template: _listaCierre4.default
	};
	
	exports.default = ListaCierre;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _archivoModal = __webpack_require__(575);
	
	var _archivoModal2 = _interopRequireDefault(_archivoModal);
	
	var _archivoModal3 = __webpack_require__(822);
	
	var _archivoModal4 = _interopRequireDefault(_archivoModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var listaCierreController = function () {
	  listaCierreController.$inject = ["Proyecto", "DataService", "Storage", "Modal"];
	  function listaCierreController(Proyecto, DataService, Storage, Modal) {
	    'ngInject';
	
	    _classCallCheck(this, listaCierreController);
	
	    this.Proyecto = Proyecto;
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Modal = Modal;
	  }
	
	  _createClass(listaCierreController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.usuario = this.Storage.getUser();
	      setTimeout(function () {
	        if (!_this.proyecto.cierre.lista_cierre) {
	          _this.obtenerFormCierre();
	        }
	      }, 2000);
	
	      this.prueba = 'hola mundo';
	      // console.log(this.formulario.cierre)
	    }
	  }, {
	    key: 'obtenerFormEvaluacion',
	    value: function obtenerFormEvaluacion() {}
	  }, {
	    key: 'radioChange',
	    value: function radioChange(cols, index, indexfila) {
	      if (!this.modoVista) {
	        for (var i in cols) {
	
	          if (cols[i].contenido && cols[i].contenido.type === 'radio') {
	            if (indexfila == 5) {
	              // console.log('tiene acta provisional?', (this.proyecto.seguimiento.doc_acta_provisional != null))
	            }
	            cols[i].contenido.value = i == index;
	            // console.log("(i == index)   Muestra   ",(i == index))
	          }
	        }
	        // if (cols[index].contenido.name === 'NO_CUMPLE') {
	        //   this.marcarInformeRechazado();
	        // }
	      }
	    }
	  }, {
	    key: 'radioColor',
	    value: function radioColor(contenido) {
	      if (contenido.value && contenido.name == 'CUMPLE') return 'btn-success';
	      if (contenido.value && contenido.name == 'NO_CUMPLE') return 'btn-danger';
	      if (contenido.value && contenido.name == 'NO_APLICA') return 'btn-primary';
	      if (contenido.value && contenido.name == 'APROBADO') return 'btn-success';
	      if (contenido.value && contenido.name == 'AJUSTE') return 'btn-warning';
	      if (contenido.value && contenido.name == 'RECHAZO') return 'btn-danger';
	      return 'btn-secondary';
	    }
	  }, {
	    key: 'guardarChecklist',
	    value: function guardarChecklist() {
	      var _this2 = this;
	
	      // this.datos = {
	      // 	fid_proyecto: this.proyecto.id_proyecto,
	      // 	//plazo_cierre: this.proyecto.cierre.plazo_cierre,
	      // 	lista_cierre: this.proyecto.
	      // 	_usuario_creacion: this.usuario.id_usuario
	      // };
	
	      this.DataService.post('proyectos/cie', this.proyecto).then(function (response) {
	        if (response) {
	          _this2.Message.success("Proyecto actualizado correctamente.");
	          //this.proyecto.seguimiento = response.datos
	          // console.log("datos recibidos despues de guardar: ",this.proyecto)
	
	          _this2.Loading.hide();
	          //this.$state.reload();			
	        }
	      });
	    }
	  }, {
	    key: 'obtenerFormCierre',
	    value: function obtenerFormCierre() {
	      var _this3 = this;
	
	      this.proyecto.cierre.lista_cierre = [];
	      this.DataService.get('contenidos/listacierre/1').then(function (response) {
	        if (response) {
	          if (response.datos && response.datos.estructura) {
	
	            _this3.proyecto.cierre.lista_cierre = response.datos.estructura;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'regenerarFormulario',
	    value: function regenerarFormulario() {
	      this.obtenerFormCierre();
	    }
	  }, {
	    key: 'mostrarModal',
	    value: function mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
	      return this.Modal.show({
	        template: template,
	        controller: controller,
	        data: data || {},
	        title: titulo,
	        icon: icon,
	        size: size ? size : 'md',
	        labelOk: labelOk
	      });
	    }
	  }, {
	    key: 'cargarAdjunto',
	    value: function cargarAdjunto(adj) {
	      var _this4 = this;
	
	      var confArchivo = {
	        formatos: 'pdf',
	        tipos: '.pdf'
	      };
	      // console.log(adj)
	      var codigo_documento = [];
	      if (adj[1].codigo == 'doc_solicitud_cierre') codigo_documento = ['doc_solicitud_cierre', adj[1].titulo];
	      if (adj[0].codigo == 'doc_acta_cierre') codigo_documento = ['doc_acta_cierre', adj[0].titulo];
	      if (adj[1].codigo == 'doc_informe_auditoria_final') codigo_documento = ['doc_informe_auditoria_final', adj[1].titulo];
	
	      // console.log(codigo_documento)
	
	      this.mostrarModal(' - "' + codigo_documento[1] + '"', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (documentoAdjunto) {
	        if (angular.isUndefined(documentoAdjunto)) {
	          return;
	        }
	        _this4.DataService.put('cierre/' + _this4.proyecto.id_proyecto, { datos_adjunto: documentoAdjunto, cod_doc: codigo_documento }).then(function (result) {
	          if (result && result.finalizado) {
	            //this.Message.success(`Se registró el documento de especificaciones técnicas del item "${item.nombre}" correctamente.`);
	            // item.especificaciones = docEspecificaciones;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'verAdjunto',
	    value: function verAdjunto(index, adj) {
	      // this.Modal.alert('Aqui vendra el adjunto : '+ adj[0].titulo)
	      var codigo_documento = [];
	      if (adj[1].codigo == 'doc_solicitud_cierre') codigo_documento = ['doc_solicitud_cierre', adj[1].titulo];
	      if (adj[0].codigo == 'doc_acta_cierre') codigo_documento = ['doc_acta_cierre', adj[0].titulo];
	      if (adj[1].codigo == 'doc_informe_auditoria_final') codigo_documento = ['doc_informe_auditoria_final', adj[1].titulo];
	
	      if (codigo_documento[0] == 'doc_solicitud_cierre') {
	        this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/SCC', ' -"' + codigo_documento[1] + '"');
	      }
	
	      if (codigo_documento[0] == 'doc_acta_cierre') {
	        this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/DAC', ' -"' + codigo_documento[1] + '"');
	      }
	
	      if (codigo_documento[0] == 'doc_informe_auditoria_final') {
	        this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/IAF', ' -"' + codigo_documento[1] + '"');
	      }
	    }
	  }, {
	    key: 'verAdjuntoSeguimiento',
	    value: function verAdjuntoSeguimiento(index) {
	      if (index == 5) {
	        this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/ACP');
	      }
	
	      if (index == 6) {
	        this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/ACD');
	      }
	
	      if (index == 7) {
	        this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/ODP');
	      }
	    }
	  }]);
	
	  return listaCierreController;
	}();
	
	exports.default = listaCierreController;

/***/ }),
/* 578 */
[862, 579, 824],
/* 579 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DesembolsoController = function () {
	  DesembolsoController.$inject = ["$scope", "Proyecto", "_", "Datetime", "Storage", "DataService", "Loading", "Message", "$state", "Usuarios"];
	  function DesembolsoController($scope, Proyecto, _, Datetime, Storage, DataService, Loading, Message, $state, Usuarios) {
	    'ngInject';
	
	    _classCallCheck(this, DesembolsoController);
	
	    this.$scope = $scope;
	    this.Proyecto = Proyecto;
	    this._ = _;
	    this.Datetime = Datetime;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Loading = Loading;
	    this.Message = Message;
	    this.$state = $state;
	    this.Usuarios = Usuarios;
	  }
	
	  _createClass(DesembolsoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.usuario = this.Storage.getUser();
	      this.ordenProcederOriginal = this.proyecto.orden_proceder;
	      this.archivos = {
	        urlDocOrdenProceder: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/ODP' : '',
	        urlDocOrdenProcederDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/ODP/descargar' : ''
	      };
	      this.prepararValidacionesFecha();
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.proyecto.adj.orden_proceder', function () {
	        _this.proyecto.orden_proceder = _this.ordenProcederOriginal;
	        // if (this.proyecto.adj) {
	        //   console.log(new Date(this.proyecto.adj.orden_proceder), this.proyecto.orden_proceder, this.proyecto.adj.orden_proceder < this.proyecto.orden_proceder);
	        //   console.log(this.ordenProcederOriginal);
	        // }
	        if (_this.proyecto.adj && _this.proyecto.adj.orden_proceder) {
	          if (!_this.proyecto.orden_proceder || _this.proyecto.adj.orden_proceder < _this.proyecto.orden_proceder) {
	            _this.proyecto.orden_proceder = _this.proyecto.adj.orden_proceder;
	          } else {
	            _this.proyecto.orden_proceder = _this.ordenProcederOriginal;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'prepararValidacionesFecha',
	    value: function prepararValidacionesFecha() {
	      var fechaDesde = void 0,
	          mensajeError = 'La fecha debe ser mayor a la fecha';
	      if (this.tieneBoletas()) {
	        fechaDesde = this.fechaMasAntiguaDeBoletas();
	        mensajeError = mensajeError + ' de inicio de la boleta de anticipo m\xE1s antigua';
	      } else if (this.proyecto.tipo === 'TP_CIF') {
	        fechaDesde = this.proyecto.fecha_desembolso;
	        mensajeError = mensajeError + ' del desembolso';
	      } else {
	        fechaDesde = this.proyecto.convenio.fecha_suscripcion;
	        mensajeError = mensajeError + ' del convenio';
	      }
	      fechaDesde = this.Datetime.getFormatDate(fechaDesde);
	      this.validacion = {
	        fecha_minima: this.Datetime.addDaysToDate(angular.copy(fechaDesde), 1),
	        mensaje_fecminima: mensajeError + ' (' + this.Datetime.parseDate(fechaDesde, '/') + ')'
	      };
	    }
	  }, {
	    key: 'tieneBoletas',
	    value: function tieneBoletas() {
	      return this.proyecto.boletas.length > 0;
	    }
	  }, {
	    key: 'fechaMasAntiguaDeBoletas',
	    value: function fechaMasAntiguaDeBoletas() {
	      return this._.sortBy(this.proyecto.boletas, function (boleta) {
	        return boleta.fecha_inicio_validez;
	      })[0].fecha_inicio_validez;
	    }
	  }, {
	    key: 'tieneSupervisiones',
	    value: function tieneSupervisiones() {
	      // console.log("tieneSupervisiones : ",(this.proyecto && this.proyecto.supervisiones && this.proyecto.supervisiones.length > 0))
	      return this.proyecto && this.proyecto.supervisiones && this.proyecto.supervisiones.length > 0;
	    }
	  }, {
	    key: 'tieneOrdenProceder',
	    value: function tieneOrdenProceder() {
	      // this.$log.log("tieneOrdenProceder : ");
	      return this.ordenProcederOriginal ? true : false;
	    }
	  }, {
	    key: 'guardarDatos',
	    value: function guardarDatos() {
	      var _this2 = this;
	
	      // console.log(this.proyecto,"proyecto seguimiento")
	      this.datos = {
	        id_proyecto: this.proyecto.id_proyecto,
	        orden_proceder: this.proyecto.orden_proceder,
	        doc_orden_proceder: this.proyecto.doc_orden_proceder,
	        obs_orden_proceder: this.proyecto.obs_orden_proceder,
	        _usuario_modificacion: this.usuario.id_usuario
	      };
	
	      // console.log('datos para enviar : ', this.datos)
	      this.Loading.show('Guardando', true);
	      this.DataService.post('proyectos/ordenProceder', this.datos).then(function (response) {
	        if (response) {
	          _this2.Message.success("Proyecto actualizado correctamente.");
	
	          _this2.Loading.hide();
	          _this2.$state.reload();
	        }
	      });
	    }
	  }]);
	
	  return DesembolsoController;
	}();
	
	exports.default = DesembolsoController;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recepcionDefinitiva = __webpack_require__(581);
	
	var _recepcionDefinitiva2 = _interopRequireDefault(_recepcionDefinitiva);
	
	var _recepcionDefinitiva3 = __webpack_require__(825);
	
	var _recepcionDefinitiva4 = _interopRequireDefault(_recepcionDefinitiva3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecepcionDefinitivaComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _recepcionDefinitiva2.default,
	  template: _recepcionDefinitiva4.default
	};
	
	exports.default = RecepcionDefinitivaComponent;

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RecepcionDefinitivaController = function () {
	  RecepcionDefinitivaController.$inject = ["$scope", "Proyecto", "_"];
	  function RecepcionDefinitivaController($scope, Proyecto, _) {
	    'ngInject';
	
	    _classCallCheck(this, RecepcionDefinitivaController);
	
	    this.$scope = $scope;
	    this.Proyecto = Proyecto;
	    this._ = _;
	  }
	
	  _createClass(RecepcionDefinitivaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.recepcionDefinitivaOriginal = this.proyecto.plazo_recepcion_definitiva;
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      // this.$scope.$watch('$ctrl.proyecto.plazo_recepcion_definitiva', () => {
	
	      // });
	    }
	  }, {
	    key: 'validarPlazo',
	    value: function validarPlazo() {
	      if (this.proyecto && this.proyecto.plazo_recepcion_definitiva && this.proyecto.plazo_recepcion_definitiva >= 1) {
	        return;
	      } else {
	        this.proyecto.plazo_recepcion_definitiva = this.recepcionDefinitivaOriginal;
	      }
	    }
	
	    // tieneOrdenProceder() {
	    //   return this.ordenProcederOriginal ? true : false;
	    // }
	
	  }]);
	
	  return RecepcionDefinitivaController;
	}();
	
	exports.default = RecepcionDefinitivaController;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _seguimiento = __webpack_require__(583);
	
	var _seguimiento2 = _interopRequireDefault(_seguimiento);
	
	var _seguimiento3 = __webpack_require__(826);
	
	var _seguimiento4 = _interopRequireDefault(_seguimiento3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SeguimientoComponent = {
		bindings: {
			proyecto: '=',
			modoVista: '<'
		},
		controller: _seguimiento2.default,
		template: _seguimiento4.default
	};
	
	exports.default = SeguimientoComponent;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _observacionModalController = __webpack_require__(85);
	
	var _observacionModalController2 = _interopRequireDefault(_observacionModalController);
	
	var _observacionModal = __webpack_require__(98);
	
	var _observacionModal2 = _interopRequireDefault(_observacionModal);
	
	var _modificacionesModal = __webpack_require__(28);
	
	var _modificacionesModal2 = _interopRequireDefault(_modificacionesModal);
	
	var _modificacionesModal3 = __webpack_require__(32);
	
	var _modificacionesModal4 = _interopRequireDefault(_modificacionesModal3);
	
	var _modal = __webpack_require__(13);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(14);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	var _supervisionesModal = __webpack_require__(84);
	
	var _supervisionesModal2 = _interopRequireDefault(_supervisionesModal);
	
	var _supervisionesModal3 = __webpack_require__(97);
	
	var _supervisionesModal4 = _interopRequireDefault(_supervisionesModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SeguimientoController = function () {
		SeguimientoController.$inject = ["DataService", "Proyecto", "Loading", "Message", "Storage", "$state", "Modal", "Usuarios"];
		function SeguimientoController(DataService, Proyecto, Loading, Message, Storage, $state, Modal, Usuarios) {
			'ngInject';
	
			_classCallCheck(this, SeguimientoController);
	
			this.DataService = DataService;
			this.Proyecto = Proyecto;
			this.Loading = Loading;
			this.Message = Message;
			this.Storage = Storage;
			this.$state = $state;
			this.Modal = Modal;
			this.Usuarios = Usuarios;
		}
	
		_createClass(SeguimientoController, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.items = [{ value: 1, text: 'Medio Termino' }, { value: 2, text: 'Final' }];
				this.valorMinimo = "0";
	
				this.tipos_plazo_ampliado = [{
					codigo: 'Convenio modificatorio',
					nombre: 'Convenio modificatorio'
				}, {
					codigo: 'Adenda al convenio',
					nombre: 'Adenda al convenio'
				}];
	
				// console.log(this)
				// setTimeout(()=>{
				// 	console.log(this.proyecto)
				// },1000)
				// console.log(this.proyecto)
				this.usuario = this.Storage.getUser();
	
				this.calcularPlazos();
	
				// console.log("plazo_convenio0 : ",this.plazo_convenio0)
	
				// popover dinamico
				this.dynamicPopover = {
					content: 'Hello, World!',
					templateUrl: 'myPopoverTemplate.html',
					title: 'Titulo de popover'
				};
				this.dynamicPopover2 = {
					content: 'Hello, World!',
					templateUrl: 'myPopoverTemplate2.html',
					title: 'Titulo de popover'
				};
				this.recalcularPlazoConvenio1();
				this.recalcularPlazoConvenio2();
				this.recalcularPlazoConvenio3();
				this.recalcularPlazoConvenio4();
				this.recalcularPlazoConvenio5();
				this.recalcularPlazoConvenio6();
				this.recalcularPlazoConvenio7();
				this.recalcularPlazoConvenio8();
				this.recalcularPlazoConvenio9();
				this.recalcularPlazoConvenio10();
				this.recalcularPlazoConvenio11();
				this.recalcularPlazoConvenio12();
				this.recalcularPlazoConvenio13();
				this.recalcularPlazoConvenio14();
				// let thislocal = this;
				// console.log('seguimiento controller..', this.proyecto)
	
				// setTimeout(()=>{
				// console.log(this.proyecto,"<--------")
				// if(!this.proyecto.inspecciones){
				// 	this.proyecto.inspecciones = {}
				// }
				// if(!this.proyecto.seguimiento){
				// 	this.proyecto.seguimiento = {}
				// }
				// },1500)
				setTimeout(function () {
					if (_this.proyecto.seguimiento.avance_fis && _this.proyecto.seguimiento.avance_fis.length > 0) {
						_this.valorMinimo = _this.proyecto.seguimiento.avance_fis[_this.proyecto.seguimiento.avance_fis.length - 1].porcentaje.toString();
					}
					_this.archivos = {
						urlDocActaProv: _this.proyecto ? 'proyectos/' + _this.proyecto.id_proyecto + '/doc/ACP' : '',
						urlDocActaProvDescarga: _this.proyecto ? 'proyectos/' + _this.proyecto.id_proyecto + '/doc/ACP/descargar' : '',
						urlDocActaDef: _this.proyecto ? 'proyectos/' + _this.proyecto.id_proyecto + '/doc/ACD' : '',
						urlDocActaDefDescarga: _this.proyecto ? 'proyectos/' + _this.proyecto.id_proyecto + '/doc/ACD/descargar' : '',
						urlDocIT: _this.proyecto ? 'proyectos/' + _this.proyecto.id_proyecto + '/doc/IT' : '',
						urlDocITDescarga: _this.proyecto ? 'proyectos/' + _this.proyecto.id_proyecto + '/doc/IT/descargar' : '',
						urlDocLMT: _this.proyecto ? 'proyectos/' + _this.proyecto.id_proyecto + '/doc/LMT' : '',
						urlDocLMTDescarga: _this.proyecto ? 'proyectos/' + _this.proyecto.id_proyecto + '/doc/LMT/descargar' : ''
					};
	
					_this.DataService.get('proyectos/' + _this.proyecto.id_proyecto + '/usuarios').then(function (response) {
						if (response) {
							_this.usuariosParaAsignar = [];
							for (var i in response.datos) {
								response.datos[i].nom = response.datos[i].nombre.split("(")[0];
								_this.usuariosParaAsignar.push(response.datos[i]);
	
								// if (response.datos[i].id_usuario==this.proyecto.fid_usuario_asignado && response.datos[i].id_rol==this.proyecto.fid_usuario_asignado_rol) {
								// 	this.usuario_asignado = this.usuariosParaAsignar[i];
								// }
							}
						}
					});
				}, 4500);
			}
	
			// extraerProyecto(){
			// 	console.log("INICIANDO COMPONENTE SEGUIMIENTO CONTROLLERs");
			// 	console.log(this.proyecto,"EXTRAYENDO DATOS DE PROYECTO")
			// 	if (!this.proyecto.inspecciones){
			// 		this.proyecto.inspecciones = {}
			// 	}
			// 	if (!this.proyecto.seguimiento){
			// 		this.proyecto.seguimiento = {}
			// 	}
			// }
	
		}, {
			key: 'obtenerInspeccion',
			value: function obtenerInspeccion(value) {
				if (!value) {
					this.Message.warning('No se encontro el documento');
					return;
				}
				var exreg = /\[(.*?)\]\s*(.*)/;
				var codigo = value.split(exreg)[1];
				this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/' + codigo, value);
			}
		}, {
			key: 'descargarInspeccion',
			value: function descargarInspeccion(index) {
				return 'proyectos/' + this.proyecto.id_proyecto + '/doc/IC_' + index + '/descargar';
			}
		}, {
			key: 'verAdenda',
			value: function verAdenda(codigo) {
				this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/' + codigo, 'Documento ' + codigo);
			}
		}, {
			key: 'addAf',
			value: function addAf(value) {
				if (!value) {
					value = [];
				}
				for (var i in value) {
					// console.log(value[i].id_avance_fisico,"<<")
					if (!value[i].id_avance_fisico || value[i].edicion) {
						// console.log(value[i].id_avance_fisico, value[i].edicion)
						this.Message.warning('Debe guardar el registro antes de crear otro');
						return;
					}
				}
				value.push({ edicion: true, porcentaje: value.length ? value[value.length - 1].porcentaje : 0 });
				// console.log("value: ", value)
			}
		}, {
			key: 'puedeVerModificaciones',
			value: function puedeVerModificaciones(proyecto) {
				if (!proyecto.orden_proceder) return false;
				if ((this.Usuarios.esSupervisor() || this.Usuarios.esFiscal() || this.Usuarios.esResponsableGAM() || this.Usuarios.esTecnicoResponsable() || this.Usuarios.esVisorReportes()) && ['EN_EJECUCION_FDI'].indexOf(proyecto.estado_proyecto) !== -1) return true;
				return false;
			}
		}, {
			key: 'irAModificaciones',
			value: function irAModificaciones(proyecto) {
				if (proyecto.adjudicaciones.length > 1) {
					if (proyecto.id_proyecto > 0) {
						this.Modal.show({
							template: _modificacionesModal4.default,
							controller: _modificacionesModal2.default,
							data: proyecto,
							size: 'lg'
						});
					}
				} else {
					proyecto.adjudicacion = proyecto.adjudicaciones[0];
					this.Modal.show({
						template: _modal4.default,
						controller: _modal2.default,
						data: proyecto,
						size: 'lg'
					});
				}
			}
		}, {
			key: 'verSupervisiones',
			value: function verSupervisiones() {
				this.Modal.show({
					template: _supervisionesModal4.default,
					controller: _supervisionesModal2.default,
					data: this.proyecto,
					size: 'lg'
				});
			}
		}, {
			key: 'puedeVerSupervision',
			value: function puedeVerSupervision(proyecto) {
				if (proyecto) {
					return ['APROBADO', 'EN_EJECUCION_FDI', 'REVISION_SEGUIMIENTO_FDI', 'ASIGNACION_TECNICO_CIERRE_FDI', 'EN_CIERRE_FDI', 'CERRADO', 'MODIFICADO', 'PARALIZADO'].indexOf(proyecto.estado_proyecto) >= 0 && proyecto.supervisiones && proyecto.supervisiones.length > 0;
				}
				return false;
			}
		}, {
			key: 'addIc',
			value: function addIc(value) {
				if (!value) {
					value = [];
				}
				for (var i in value) {
					// console.log(value[i].id_avance_fisico,"<<")
					if (!value[i].id_inspeccion_campo || value[i].edicion) {
						// console.log(value[i].id_avance_fisico, value[i].edicion)
						this.Message.warning('Debe guardar el registro antes de crear otro');
						return;
					}
				}
				value.push({ edicion: true });
			}
		}, {
			key: 'guardarDatos',
			value: function guardarDatos() {
				var _this2 = this;
	
				// console.log(this.proyecto)
				// console.log(this.proyecto,"proyecto seguimiento")
				this.datos = {
					fid_proyecto: this.proyecto.id_proyecto,
					impacto: this.proyecto.seguimiento.impacto,
					fecha_acta_provisional: this.proyecto.seguimiento.fecha_acta_provisional,
					doc_acta_provisional: this.proyecto.seguimiento.doc_acta_provisional,
					fecha_acta_definitiva: this.proyecto.seguimiento.fecha_acta_definitiva,
					doc_acta_definitiva: this.proyecto.seguimiento.doc_acta_definitiva,
					fecha_informe: this.proyecto.seguimiento.fecha_informe,
					doc_informe: this.proyecto.seguimiento.doc_informe,
					fecha_ley_mun: this.proyecto.seguimiento.fecha_ley_mun,
					doc_ley_mun: this.proyecto.seguimiento.doc_ley_mun,
					_usuario_creacion: this.usuario.id_usuario
				};
	
				// console.log('datos para enviar : ', this.datos)
				this.Loading.show('Guardando', true);
				this.DataService.post('proyectos/seg', this.datos).then(function (response) {
					if (response) {
						_this2.Message.success("Proyecto actualizado correctamente.");
						_this2.proyecto.seguimiento = response.datos;
						// console.log("datos recibidos despues de guardar: ",this.proyecto)
	
						_this2.Loading.hide();
						_this2.$state.reload();
					}
				});
			}
		}, {
			key: 'actualizarInspeccion',
			value: function actualizarInspeccion(value) {
				var _this3 = this;
	
				// solo actualiza la fecha del informe
				this.DataService.put('proyectos/inspeccion/' + value.id_inspeccion_campo, value).then(function (response) {
					if (response) {
						_this3.Message.success("Actualizado correctamente.");
						value.tecnico_inspeccion = value.tecnico_inspeccion.nom;
						value.detalle = value.text;
					}
				});
				value.edicion = false;
			}
		}, {
			key: 'guardarInspeccion',
			value: function guardarInspeccion(value, index) {
				var _this4 = this;
	
				// Guardar inspeccion de campo
				value.objeto_id = this.proyecto.seguimiento.id_seguimiento;
				value.id_proyecto = this.proyecto.id_proyecto;
				value.cant_inspec = this.proyecto.seguimiento.inspeccion_campo.length;
				value.tipo_inspeccion = 'seguimiento';
				if (!this.sonDatosValidosInspeccion(index)) {
					return;
				}
				this.DataService.post('proyectos/inspeccion', value).then(function (response) {
					if (response) {
						// console.log(response)
						value.id_inspeccion_campo = response.datos.id_inspeccion_campo;
						value.fecha = response.datos.fecha;
						value.doc_informe = response.datos.doc_informe;
						value.detalle = response.datos.detalle;
						value.tecnico_inspeccion = response.datos.tecnico_inspeccion;
						_this4.Message.success("guardado correctamente.");
					}
				});
				value.edicion = false;
			}
		}, {
			key: 'eliminarInspeccion',
			value: function eliminarInspeccion(value, index) {
				// Elimina la inspeccion de campo
				if (!value.id_inspeccion_campo) {
					this.proyecto.seguimiento.inspeccion_campo.splice(index, 1);
					return;
				}
			}
		}, {
			key: 'guardarAvance',
			value: function guardarAvance(value, index) {
				var _this5 = this;
	
				// Guarda el avance fisico
				value.id_seguimiento = this.proyecto.seguimiento.id_seguimiento;
				value.id_proyecto = this.proyecto.id_proyecto;
				if (!this.sonDatosValidosAvance(index)) {
					return;
				}
				this.DataService.post('proyectos/avancefisico', value).then(function (response) {
					if (response) {
						value.id_avance_fisico = response.datos.id_avance_fisico;
						_this5.Message.success("Actualizado correctamente.");
					}
				});
				value.edicion = false;
			}
		}, {
			key: 'eliminarAvance',
			value: function eliminarAvance(value, index) {
				//Elimina el registro nuevo del avance fisico
				if (!value.id_avance_fisico) {
					this.proyecto.seguimiento.avance_fis.splice(index, 1);
					return;
				}
			}
		}, {
			key: 'sonDatosValidosAvance',
			value: function sonDatosValidosAvance(posicion) {
				// Validar avance fisico
				var FORM = angular.element(document.querySelector('[name=form_avance')).scope()['form_avance'];
				var esValido = FORM['fecha_' + posicion].$valid && FORM['porcentaje_' + posicion].$valid && FORM['situacion_actual_' + posicion].$valid;
	
				if (!esValido) {
					FORM['fecha_' + posicion].$setTouched();
					FORM['porcentaje_' + posicion].$setTouched();
					FORM['situacion_actual_' + posicion].$setTouched();
	
					this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
					return false;
				}
				return true;
			}
		}, {
			key: 'sonDatosValidosInspeccion',
			value: function sonDatosValidosInspeccion(posicion) {
				// Validar avance fisico
				var FORM = angular.element(document.querySelector('[name=form_inspeccion')).scope()['form_inspeccion'];
				var esValido = FORM['fecha_inspeccion_' + posicion].$valid && FORM['listaTecnico_' + posicion].$valid && FORM['detalle_inf_' + posicion].$valid;
	
				if (!esValido) {
					FORM['fecha_inspeccion_' + posicion].$setTouched();
					FORM['listaTecnico_' + posicion].$setTouched();
					FORM['detalle_inf_' + posicion].$setTouched();
	
					this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
					return false;
				}
				return true;
			}
		}, {
			key: 'guardarAdendas',
			value: function guardarAdendas() {
				var _this6 = this;
	
				// console.log(this.proyecto.convenio,"<<<---")
				this.data = {
					id_proyecto: this.proyecto.id_proyecto,
					datos: this.proyecto.convenio,
					estado_proyecto: this.proyecto.estado_proyecto
				};
				this.DataService.post('proyectos/adendas', this.data).then(function (response) {
					if (response) {
						_this6.Message.success("Proyecto actualizado correctamente.");
	
						_this6.Loading.hide();
					}
				});
			}
		}, {
			key: 'calcularPlazos',
			value: function calcularPlazos() {
				this.plazo_convenio0 = new Date(this.proyecto.orden_proceder);
				this.plazo_convenio0.setDate(this.plazo_convenio0.getDate() + parseInt(this.proyecto.plazo_ejecucion));
				this.plazo_convenio0 = this.plazo_convenio0.toISOString();
			}
		}, {
			key: 'recalcularPlazoConvenio1',
			value: function recalcularPlazoConvenio1() {
				if (this.plazo_convenio0) {
					this.plazo_convenio1 = new Date(this.plazo_convenio0);
					this.plazo_convenio1.setDate(this.plazo_convenio1.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado));
					this.plazo_convenio1 = this.plazo_convenio1.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio2',
			value: function recalcularPlazoConvenio2() {
				if (this.plazo_convenio1 && this.proyecto.convenio.plazo_convenio_ampliado2 >= 0) {
					this.plazo_convenio2 = new Date(this.plazo_convenio1);
					this.plazo_convenio2.setDate(this.plazo_convenio2.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado2));
					this.plazo_convenio2 = this.plazo_convenio2.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio3',
			value: function recalcularPlazoConvenio3() {
				if (this.plazo_convenio2 && this.proyecto.convenio.plazo_convenio_ampliado3 >= 0) {
					this.plazo_convenio3 = new Date(this.plazo_convenio2);
					this.plazo_convenio3.setDate(this.plazo_convenio3.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado3));
					this.plazo_convenio3 = this.plazo_convenio3.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio4',
			value: function recalcularPlazoConvenio4() {
				if (this.plazo_convenio3 && this.proyecto.convenio.plazo_convenio_ampliado4 >= 0) {
					this.plazo_convenio4 = new Date(this.plazo_convenio3);
					this.plazo_convenio4.setDate(this.plazo_convenio4.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado4));
					this.plazo_convenio4 = this.plazo_convenio4.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio5',
			value: function recalcularPlazoConvenio5() {
				if (this.plazo_convenio4 && this.proyecto.convenio.plazo_convenio_ampliado5 >= 0) {
					this.plazo_convenio5 = new Date(this.plazo_convenio4);
					this.plazo_convenio5.setDate(this.plazo_convenio5.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado5));
					this.plazo_convenio5 = this.plazo_convenio5.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio6',
			value: function recalcularPlazoConvenio6() {
				if (this.plazo_convenio5 && this.proyecto.convenio.plazo_convenio_ampliado6 >= 0) {
					this.plazo_convenio6 = new Date(this.plazo_convenio5);
					this.plazo_convenio6.setDate(this.plazo_convenio6.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado6));
					this.plazo_convenio6 = this.plazo_convenio6.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio7',
			value: function recalcularPlazoConvenio7() {
				if (this.plazo_convenio6 && this.proyecto.convenio.plazo_convenio_ampliado7 >= 0) {
					this.plazo_convenio7 = new Date(this.plazo_convenio6);
					this.plazo_convenio7.setDate(this.plazo_convenio7.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado7));
					this.plazo_convenio7 = this.plazo_convenio7.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio8',
			value: function recalcularPlazoConvenio8() {
				if (this.plazo_convenio7 && this.proyecto.convenio.plazo_convenio_ampliado8 >= 0) {
					this.plazo_convenio8 = new Date(this.plazo_convenio7);
					this.plazo_convenio8.setDate(this.plazo_convenio8.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado8));
					this.plazo_convenio8 = this.plazo_convenio8.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio9',
			value: function recalcularPlazoConvenio9() {
				if (this.plazo_convenio8 && this.proyecto.convenio.plazo_convenio_ampliado9 >= 0) {
					this.plazo_convenio9 = new Date(this.plazo_convenio8);
					this.plazo_convenio9.setDate(this.plazo_convenio9.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado9));
					this.plazo_convenio9 = this.plazo_convenio9.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio10',
			value: function recalcularPlazoConvenio10() {
				if (this.plazo_convenio9 && this.proyecto.convenio.plazo_convenio_ampliado10 >= 0) {
					this.plazo_convenio10 = new Date(this.plazo_convenio9);
					this.plazo_convenio10.setDate(this.plazo_convenio10.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado10));
					this.plazo_convenio10 = this.plazo_convenio10.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio11',
			value: function recalcularPlazoConvenio11() {
				if (this.plazo_convenio10 && this.proyecto.convenio.plazo_convenio_ampliado11 >= 0) {
					this.plazo_convenio11 = new Date(this.plazo_convenio10);
					this.plazo_convenio11.setDate(this.plazo_convenio11.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado11));
					this.plazo_convenio11 = this.plazo_convenio11.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio12',
			value: function recalcularPlazoConvenio12() {
				if (this.plazo_convenio11 && this.proyecto.convenio.plazo_convenio_ampliado12 >= 0) {
					this.plazo_convenio12 = new Date(this.plazo_convenio11);
					this.plazo_convenio12.setDate(this.plazo_convenio12.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado12));
					this.plazo_convenio12 = this.plazo_convenio12.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio13',
			value: function recalcularPlazoConvenio13() {
				if (this.plazo_convenio12 && this.proyecto.convenio.plazo_convenio_ampliado13 >= 0) {
					this.plazo_convenio13 = new Date(this.plazo_convenio12);
					this.plazo_convenio13.setDate(this.plazo_convenio13.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado13));
					this.plazo_convenio13 = this.plazo_convenio13.toISOString();
				}
			}
		}, {
			key: 'recalcularPlazoConvenio14',
			value: function recalcularPlazoConvenio14() {
				if (this.plazo_convenio13 && this.proyecto.convenio.plazo_convenio_ampliado14 >= 0) {
					this.plazo_convenio14 = new Date(this.plazo_convenio13);
					this.plazo_convenio14.setDate(this.plazo_convenio14.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado14));
					this.plazo_convenio14 = this.plazo_convenio14.toISOString();
				}
			}
		}, {
			key: 'derivarProyecto',
			value: function derivarProyecto() {
				var _this7 = this;
	
				this.Modal.confirm('\xBFEst\xE1 seguro/a de derivar el proceso a la siguiente instancia?', function () {
					var estadoDestino = {
						id_proyecto: _this7.proyecto.id_proyecto,
						estado_proyecto: 'REVISION_SEGUIMIENTO_FDI'
					};
					_this7.DataService.post('proyectos/derivar', estadoDestino).then(function (response) {
						if (response) {
							_this7.Message.success("Proyecto derivado correctamente.");
							_this7.respuesta = response;
							// console.log(this.respuesta,"response")
							_this7.usuario = _this7.Storage.getUser();
							_this7.$state.go(_this7.usuario.pathInicio.replace('/', ''));
						}
					});
				}, null, 'Confirmar envío', 'Si, estoy seguro/a', 'Cancelar');
			}
		}, {
			key: 'devolverProyecto',
			value: function devolverProyecto() {
				var _this8 = this;
	
				var modalObservacion = this.Modal.show({
					template: _observacionModal2.default,
					controller: _observacionModalController2.default,
					data: {},
					size: 'md'
				});
				modalObservacion.result.then(function (elementoActualizado) {
					// console.log("detalle de observacion : ", elementoActualizado)
					var estadoDestino = {
						id_proyecto: _this8.proyecto.id_proyecto,
						estado_proyecto: 'EN_EJECUCION_FDI',
						observacion: elementoActualizado.observacion
					};
					_this8.DataService.post('proyectos/derivar', estadoDestino).then(function (response) {
						if (response) {
							_this8.Message.success("Proyecto derivado correctamente.");
							_this8.respuesta = response;
							// console.log(this.respuesta,"response")
							_this8.usuario = _this8.Storage.getUser();
							_this8.$state.go(_this8.usuario.pathInicio.replace('/', ''));
						}
					});
				}).catch(function () {});
			}
		}, {
			key: 'enviarACierre',
			value: function enviarACierre() {
				this.Message.warning("En desarrollo...");
			}
		}]);
	
		return SeguimientoController;
	}();
	
	exports.default = SeguimientoController;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proyecto = __webpack_require__(585);
	
	var _proyecto2 = _interopRequireDefault(_proyecto);
	
	var _proyecto3 = __webpack_require__(827);
	
	var _proyecto4 = _interopRequireDefault(_proyecto3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProyectoComponent = {
	  bindings: {},
	  controller: _proyecto2.default,
	  template: _proyecto4.default
	};
	
	exports.default = ProyectoComponent;

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProyectoController = function () {
	  ProyectoController.$inject = ["$stateParams", "Storage", "Proyecto", "$state", "$q", "Message", "_", "Modal", "DataService", "Loading"];
	  function ProyectoController($stateParams, Storage, Proyecto, $state, $q, Message, _, Modal, DataService, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, ProyectoController);
	
	    this.$stateParams = $stateParams;
	    this.Proyecto = Proyecto;
	    this.Storage = Storage;
	    this.$q = $q;
	    this.$state = $state;
	    this.Message = Message;
	    this._ = _;
	    this.Modal = Modal;
	    this.DataService = DataService;
	    this.Loading2 = Loading;
	  }
	
	  _createClass(ProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.idProyecto = this.$stateParams.codigo;
	      console.log(this.idProyecto);
	      this.Proyecto.setEstadoActual(null);
	      this.getProyecto();
	      this.url = 'proyectos/' + this.idProyecto + '?rol=' + this.Storage.get('rol').id_rol;
	    }
	  }, {
	    key: 'getProyecto',
	    value: function getProyecto() {
	      var _this = this;
	
	      this.Proyecto.get(this.idProyecto, this.$stateParams.urlProcesado).then(function (response) {
	        if (response) {
	          _this.Proyecto.setEstadoActual(response.datos.estado_actual);
	          _this.proyecto = response.datos;
	          _this.estadoActual = response.datos.estado_actual;
	        } else {
	          _this.$state.go('pendientes');
	        }
	      });
	    }
	  }, {
	    key: 'verificarSegunEstado',
	    value: function verificarSegunEstado() {
	      var tieneError = false;
	      var defer = this.$q.defer();
	
	      if (this.Proyecto.esEditable('beneficiarios') && !this.sonDatosCompletosProductivo()) {
	        tieneError = true;
	      }
	      if (!tieneError && this.Proyecto.esEditable('autoridad_beneficiaria') && !this.sonDatosCompletosAutoridad()) {
	        tieneError = true;
	      }
	      if (!tieneError && this.Proyecto.esEditable('modulos') && (!this.sonDatosCompletosModulos() || !this.montosItemValidos())) {
	        tieneError = true;
	      }
	      if (!tieneError && this.Proyecto.esEditable('financiamiento') && !this.montoFinanciamientoValido()) {
	        tieneError = true;
	      }
	      if (!tieneError && this.Proyecto.esEditable('evaluacion')) {
	        if (!tieneError && this.Proyecto.tratarComoProductivo(this.proyecto) && !this.sonDatosCompletosEvaluacion()) {
	          tieneError = true;
	        }
	        if (!tieneError && !this.Proyecto.tratarComoProductivo(this.proyecto) && !this.Proyecto.tratarComoRiego(this.proyecto) && !this.Proyecto.tratarComoPuente(this.proyecto) && !this.tieneEvaluacionExterna()) {
	          //if (!tieneError && !this.Proyecto.tratarComoProductivo(this.proyecto) && !this.tieneEvaluacionExterna()) {
	          tieneError = true;
	        }
	        if (!tieneError && !this.sonDatosCompletosInforme()) {
	          tieneError = true;
	        }
	      }
	      if (!tieneError && this.Proyecto.esEditable('equipo_tecnico') && !this.tieneFiscalEquipoTecnico()) {
	        // if (!this.tieneEquipoTecnico()) {
	        // this.Modal.alert(`Debe registrar al Supervisor y Fiscal del proyecto, en el apartado Equipo Técnico.`, null, 'Información incompleta', null, 'md');
	        tieneError = true;
	      }
	      if (this.Proyecto.esEditable('seguimiento') && !this.sonDatosCompletosInspeccion()) {
	        return true;
	      }
	
	      if (tieneError) {
	        defer.reject();
	      } else {
	        // Ejecutar acciones adicionales
	        // if (this.proyecto.hasOwnProperty('montoFinanciamientoExcedido') && this.proyecto.montoFinanciamientoExcedido === false) {
	        //   this.actualizarTechoDisponible();
	        // }
	        defer.resolve({ confirmar: true });
	      }
	
	      return defer.promise;
	    }
	  }, {
	    key: 'tieneEquipoTecnico',
	    value: function tieneEquipoTecnico() {
	      var TIENE_SUPERVISOR = this._.find(this.proyecto.equipo_tecnico, { cargo: 'CG_SUPERVISOR' });
	      var TIENE_FISCAL = this._.find(this.proyecto.equipo_tecnico, { cargo: 'CG_FISCAL' });
	      // return TIENE_SUPERVISOR && TIENE_FISCAL ? true : false;
	      var mensaje = [];
	      if (!TIENE_SUPERVISOR || !TIENE_FISCAL) {
	        mensaje.push({ area: 'Módulos/Equipo técnico', mensaje: 'Debe registrar al Supervisor y Fiscal del proyecto, en el apartado Equipo Técnico.' });
	      }
	      if (mensaje.length > 0) {
	        var titulo = 'Equipo técnico';
	        this.mostrarErroresModal(mensaje, titulo);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'tieneFiscalEquipoTecnico',
	    value: function tieneFiscalEquipoTecnico() {
	      var TIENE_FISCAL = this._.find(this.proyecto.equipo_tecnico, { cargo: 'CG_FISCAL' });
	      var mensaje = [];
	      if (!TIENE_FISCAL) {
	        mensaje.push({ area: 'Módulos/Equipo técnico', mensaje: 'Debe registrar al Fiscal del proyecto, en el apartado Equipo Técnico.' });
	      }
	      if (mensaje.length > 0) {
	        var titulo = 'Registrar Fiscal';
	        this.mostrarErroresModal(mensaje, titulo);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'sonDatosCompletosAutoridad',
	    value: function sonDatosCompletosAutoridad() {
	      var mensaje = [];
	      if (!this.proyecto.autoridad_beneficiaria || !this.proyecto.autoridad_beneficiaria.nombres || !this.proyecto.autoridad_beneficiaria.telefono || !this.proyecto.cargo_autoridad_beneficiaria) {
	        mensaje.push({ area: 'Contactos', mensaje: 'Datos de los contactos responsables.' });
	      }
	      if (mensaje.length > 0) {
	        var titulo = 'Contactos';
	        // let texto = '<p>Debe completar la información de los siguientes apartados:</p><ul>';
	        // mensaje.map(obs => {
	        //   texto += `<li><strong>${obs.area}</strong>: ${obs.mensaje}</li>`;
	        // });
	        // texto +='</ul>';
	        // this.Modal.alert(texto, () => { return false; }, titulo, null, 'md');
	        this.mostrarErroresModal(mensaje, titulo);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'mostrarErroresModal',
	    value: function mostrarErroresModal(mensaje, titulo) {
	      var texto = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var text = texto ? texto : '<p>Debe completar la información de los siguientes apartados:</p><ul>';
	      mensaje.map(function (obs) {
	        text += '<li><strong>' + obs.area + '</strong>: ' + obs.mensaje + '</li>';
	      });
	      text += '</ul>';
	      this.Modal.alert(text, function () {
	        return false;
	      }, titulo, null, 'md');
	    }
	  }, {
	    key: 'sonDatosCompletosModulos',
	    value: function sonDatosCompletosModulos() {
	      var mensaje = [];
	      if (!this.modulos || this.modulos.length < 1) {
	        mensaje.push({ area: 'Módulos/Items', mensaje: 'Registre al menos un módulo' });
	      } else {
	        var INCOMPLETOS = this.getModulosIncompletos();
	        if (INCOMPLETOS > 0) {
	          mensaje.push({ area: 'Módulos/Items', mensaje: INCOMPLETOS > 1 ? 'Algunos m\xF3dulos no tienen items registrados, o no fueron guardados.' : 'El m\xF3dulo no tiene items registrados, o no fue guardado.' });
	        }
	      }
	      // if (!this.proyecto.doc_especificaciones_tecnicas) {
	      //   mensaje.push({area: 'Módulos/Items', mensaje: 'Registre el documento de especificaciones técnicas'});
	      // }
	      if (this.Proyecto.esEditable('doc_base_contratacion') && !this.proyecto.doc_base_contratacion) {
	        mensaje.push({ area: 'DBC', mensaje: 'Registre el Documento Base de Contratación' });
	      }
	      if (mensaje.length > 0) {
	        var titulo = 'Información incompleta';
	        this.mostrarErroresModal(mensaje, titulo);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'sonDatosCompletosInspeccion',
	    value: function sonDatosCompletosInspeccion() {
	      var mensaje = [];
	      if (!this.proyecto.seguimiento.avance_fis || this.proyecto.seguimiento.avance_fis.length < 1) {
	        mensaje.push({ area: 'Avance fisico', mensaje: 'Registre al menos un registro en el avance fisico' });
	      } else {
	        if (this.proyecto.seguimiento.avance_fis[this.proyecto.seguimiento.avance_fis.length - 1].porcentaje != 100) {
	          mensaje.push({ area: 'Avance fisico', mensaje: 'Debe completar al 100% del avance fisico del proyecto' });
	        }
	      }
	      if (!this.proyecto.seguimiento.inspeccion_campo || this.proyecto.seguimiento.inspeccion_campo.length < 1) {
	        mensaje.push({ area: 'Inspección de campo', mensaje: 'Registre al menos una inspección de campo' });
	      }
	      if (mensaje.length > 0) {
	        var titulo = 'Información incompleta';
	        this.mostrarErroresModal(mensaje, titulo);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'montosItemValidos',
	    value: function montosItemValidos() {
	      var mensaje = [];
	      if (this.proyecto.montoItemsExcedido) {
	        mensaje.push({ area: 'Módulos/Items', mensaje: 'Corrija el monto excedente para guardar la lista de items' });
	      }
	      if (mensaje.length > 0) {
	        var titulo = 'Monto excedente';
	        this.mostrarErroresModal(mensaje, titulo);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'montoFinanciamientoValido',
	    value: function montoFinanciamientoValido() {
	      var mensaje = [];
	      if (this.proyecto.montoFinanciamientoExcedido) {
	        mensaje.push({ area: 'Módulos/Financiamiento', mensaje: 'El monto total del proyecto excede el monto disponible según techo presupuestario' });
	      }
	      if (mensaje.length > 0) {
	        var titulo = 'Monto excedente';
	        this.mostrarErroresModal(mensaje, titulo);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'sonDatosCompletosEvaluacion',
	    value: function sonDatosCompletosEvaluacion() {
	      if (!this.proyecto.evaluacion) {
	        var texto = '<p>Debe completar la información de los siguientes apartados:</p><ul><li><strong>Evaluación</strong>: La tabla de criterios de evaluación esta incompleta</li></ul>';
	        var titulo = 'Evaluación';
	        this.mostrarErroresModal([], titulo, texto);
	      } else {
	        if (this.Proyecto.tratarComoProductivo(this.proyecto)) {
	          var count = 0;
	          var mensaje = [];
	          for (var i in this.proyecto.evaluacion.datos) {
	            var fila = this.proyecto.evaluacion.datos[i];
	            for (var j in fila.cols) {
	              if (fila.cols[j].contenido && fila.cols[j].contenido.name == 'NO_CUMPLE' && fila.cols[j].contenido.value) {
	                if (mensaje.length < 3) {
	                  mensaje.push({ area: '1. Criterios de evaluación', mensaje: '' + fila.cols[j - 2].contenido });
	                } else {
	                  count++;
	                }
	              }
	            }
	          }
	          for (var _i in this.proyecto.evaluacion.datos2) {
	            var _fila = this.proyecto.evaluacion.datos2[_i];
	            for (var _j in _fila.cols) {
	              if (_fila.cols[_j].contenido && _fila.cols[_j].contenido.name == 'NO_CUMPLE' && _fila.cols[_j].contenido.value) {
	                if (mensaje.length < 3) {
	                  mensaje.push({ area: '2. Criterios generales de elegibilidad', mensaje: '' + _fila.cols[_j - 2].contenido });
	                } else {
	                  count++;
	                }
	              }
	            }
	          }
	
	          for (var _i2 in this.proyecto.evaluacion.datos3) {
	            var _fila2 = this.proyecto.evaluacion.datos3[_i2];
	            var fila_requerida = false;
	
	            if (this.Proyecto.tratarComoProductivo(this.proyecto)) fila_requerida = false;
	
	            if (this.proyecto.beneficiarios.productivo) {
	              if (this.proyecto.beneficiarios.productivo.hasOwnProperty(_fila2.key) && this.proyecto.beneficiarios.productivo[_fila2.key]) fila_requerida = true;
	              /*if(fila.key=='agricola' && this.proyecto.beneficiarios.productivo.agricola) fila_requerida = true;
	              if(fila.key=='pecuario' && this.proyecto.beneficiarios.productivo.pecuario) fila_requerida = true;
	              if(fila.key=='pesca' && this.proyecto.beneficiarios.productivo.pesca) fila_requerida = true;
	              if(fila.key=='piscicultura' && this.proyecto.beneficiarios.productivo.piscicultura) fila_requerida = true;
	              if(fila.key=='aprovecha_biodiversidad' && this.proyecto.beneficiarios.productivo.aprovecha_biodiversidad) fila_requerida = true;
	              if(fila.key=='integral_sustentable_bosque' && this.proyecto.beneficiarios.productivo.integral_sustentable_bosque) fila_requerida = true;
	              if(fila.key=='maquinaria' && this.proyecto.beneficiarios.productivo.maquinaria) fila_requerida = true;
	              if(fila.key=='prod_agroeco_organica' && this.proyecto.beneficiarios.productivo.prod_agroeco_organica) fila_requerida = true;
	              if(fila.key=='sis_agroforestales' && this.proyecto.beneficiarios.productivo.sis_agroforestales) fila_requerida = true;
	              if(fila.key=='infraestructura' && this.proyecto.beneficiarios.productivo.infraestructura) fila_requerida = true;
	              if(fila.key=='transformacion' && this.proyecto.beneficiarios.productivo.transformacion) fila_requerida = true;*/
	            }
	
	            for (var _j2 in _fila2.cols) {
	              if (fila_requerida) {
	                if (_fila2.cols[_j2].contenido && _fila2.cols[_j2].contenido.name == 'NO_CUMPLE' && _fila2.cols[_j2].contenido.value) {
	                  if (mensaje.length < 3) {
	                    mensaje.push({ area: '3. Criterios específicos de elegibilidad', mensaje: '' + _fila2.cols[_j2 - 2].contenido });
	                  } else {
	                    count++;
	                  }
	                }
	              } else {
	                if (_fila2.cols[_j2].contenido && _fila2.cols[_j2].contenido.name == 'CUMPLE') {
	                  _fila2.cols[_j2].contenido.value = false;
	                }
	                if (_fila2.cols[_j2].contenido && _fila2.cols[_j2].contenido.name == 'NO_CUMPLE') {
	                  _fila2.cols[_j2].contenido.value = false;
	                }
	                if (_fila2.cols[_j2].contenido && _fila2.cols[_j2].contenido.name == 'NO_APLICA') {
	                  _fila2.cols[_j2].contenido.value = true;
	                }
	              }
	            }
	          }
	
	          for (var _i3 in this.proyecto.evaluacion.datos4) {
	            var _fila3 = this.proyecto.evaluacion.datos4[_i3];
	            for (var _j3 in _fila3.cols) {
	              //verificacion fila 16
	              if (!(this.proyecto.beneficiarios && this.proyecto.beneficiarios.tamanio_proyecto == 'OP_TP_MENORES' && _fila3.key == 'seccion_4_1')) {
	                if (_fila3.cols[_j3].contenido && _fila3.cols[_j3].contenido.name == 'NO_CUMPLE' && _fila3.cols[_j3].contenido.value) {
	                  if (mensaje.length < 3) {
	                    mensaje.push({ area: '4. Factibilidad del proyecto', mensaje: '' + _fila3.cols[_j3 - 2].contenido });
	                  } else {
	                    count++;
	                  }
	                }
	              }
	            }
	          }
	
	          if (mensaje.length > 0) {
	            if (count > 0) {
	              mensaje.push({ area: '...', mensaje: 'Y ' + count + ' criterio/s mas...' });
	            }
	            var _texto = '<p>El proyecto tiene parámetros o criterios de evaluación que "no cumplen" para su aprobación:</p><ul>';
	            var _titulo = 'Información incompleta';
	            this.mostrarErroresModal(mensaje, _titulo, _texto);
	          } else {
	            return true;
	          }
	        } else {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'sonDatosCompletosInforme',
	    value: function sonDatosCompletosInforme() {
	      if (!this.proyecto.informe) {
	        var texto = '<p>Debe completar la información de los siguientes apartados:</p><ul><li><strong>Informe de Evaluación</strong>: No existe ningún informe.</li></ul>';
	        var titulo = 'Informe';
	        this.mostrarErroresModal([], titulo, texto);
	      } else {
	        var count = 0;
	        var mensaje = [];
	
	        if (this.proyecto.informe) {
	          if (!this.proyecto.informe.director) {
	            if (mensaje.length < 3) {
	              mensaje.push({ area: 'Informe', mensaje: 'Nombre del director' });
	            } else {
	              count++;
	            }
	          }
	        }
	        if (this.proyecto.informe) {
	          if (!this.proyecto.informe.codigo_documento) {
	            if (mensaje.length < 3) {
	              mensaje.push({ area: 'Informe', mensaje: 'El informe no se ha generado' });
	            } else {
	              count++;
	            }
	          }
	        }
	        if (this.Proyecto.tratarComoProductivo(this.proyecto)) {
	          var estado_evaluacion = this.proyecto.evaluacion.datos5[0].cols.find(function (col) {
	            return col.contenido && col.contenido.value;
	          });
	          if (!estado_evaluacion || !estado_evaluacion.contenido || estado_evaluacion.contenido.name != 'APROBADO') {
	            mensaje.push({ area: 'Informe', mensaje: 'De acuerdo a la revisi\xF3n realizada el proyecto no se encuentra aprobado.' });
	          }
	        }
	        if (mensaje.length > 0) {
	          if (count > 0) {
	            mensaje.push({ area: '...', mensaje: 'Y ' + count + ' criterio/s mas...' });
	          }
	          var _texto2 = '<p>El proyecto tiene criterios que deben ser cumplidos:</p><ul>';
	          var _titulo2 = 'Información incompleta';
	          this.mostrarErroresModal(mensaje, _titulo2, _texto2);
	        } else {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'sonDatosCompletosProductivo',
	    value: function sonDatosCompletosProductivo() {
	      if (this.proyecto.beneficiarios && this.Proyecto.tratarComoProductivo(this.proyecto)) {
	        if (!this.proyecto.beneficiarios.productivo) {
	          var texto = '<p>Debe completar la información:</p><ul><li><strong>Proyecto Productivo</strong>: Marcar una o mas subclasificaciones.</li></ul>';
	          var titulo = 'Informe';
	          this.mostrarErroresModal([], titulo, texto);
	          return false;
	        } else {
	          var count = 0;
	
	          for (var i in this.proyecto.beneficiarios.productivo) {
	            if (this.proyecto.beneficiarios.productivo[i]) {
	              count++;
	            }
	          }
	          if (count == 0) {
	            var _texto3 = '<p>Debe completar la información:</p><ul><li><strong>Proyecto Productivo</strong>: Marcar una o mas subclasificaciones.</li></ul>';
	            var _titulo3 = 'Informe';
	            this.mostrarErroresModal([], _titulo3, _texto3);
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	  }, {
	    key: 'getModulosIncompletos',
	    value: function getModulosIncompletos() {
	      var incompletos = 0;
	      this.modulos.map(function (modulo) {
	        if (!modulo.items || modulo.items.length < 1) {
	          incompletos++;
	        }
	        for (var i in modulo.items) {
	          if (!modulo.items[i].id_item || modulo.items[i].edicion) {
	            incompletos++;
	          }
	        }
	      });
	      return incompletos;
	    }
	  }, {
	    key: 'existeOrdenDeProceder',
	    value: function existeOrdenDeProceder() {
	      if (!this.proyecto.adj || !this.proyecto.adj.orden_proceder) {
	        var texto = '<p>Debe completar la información de los siguientes apartados:</p><ul><li><strong>Actvidades e items</strong>: No ha especificado la fecha de orden de proceder de la adjudicación seleccionada.</li></ul>';
	        var titulo = 'Orden de proceder de adjudicación';
	        this.mostrarErroresModal([], titulo, texto);
	      } else if (!this.proyecto.orden_proceder) {
	        var _texto4 = '<p>Debe completar la información de los siguientes apartados:</p><ul><li><strong>Datos Generales</strong>: No ha especificado la fecha de orden de proceder.</li></ul>';
	        var _titulo4 = 'Orden de proceder';
	        this.mostrarErroresModal([], _titulo4, _texto4);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'existeDocEspTecnicas',
	    value: function existeDocEspTecnicas() {
	      if (!this.proyecto.adj || !this.proyecto.adj.doc_especificaciones_tecnicas) {
	        var texto = '<p>Debe completar la información en los siguientes apartados:<ul><li><strong>Actividades e items</strong>: No ha cargado el documento de especificaciones técnicas de la adjudicación deleccionada.</li></ul>';
	        var titulo = 'Documento de especificaciones técnicas';
	        this.mostrarErroresModal([], titulo, texto);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'verificarEnParalelo',
	    value: function verificarEnParalelo(accion) {
	      if (accion.label === 'Guardar') {
	        return false;
	      }
	      if (this.Proyecto.esEditable('beneficiarios') && !this.sonDatosCompletosProductivo()) {
	        return true;
	      }
	      if (this.Proyecto.esEditable('autoridad_beneficiaria') && !this.sonDatosCompletosAutoridad()) {
	        return true;
	      }
	      if (this.Proyecto.esEditable('modulos') && !this.sonDatosCompletosModulos()) {
	        return true;
	      }
	      if (this.Proyecto.esEditable('evaluacion') && !this.sonDatosCompletosEvaluacion()) {
	        return true;
	      }
	      if (this.Proyecto.esEditable('evaluacion') && !this.sonDatosCompletosInforme()) {
	        return true;
	      }
	      if (this.Proyecto.esEditable('doc_especificaciones_tecnicas') && !this.existeDocEspTecnicas()) {
	        return true;
	      }
	      if (this.Proyecto.esEditable('orden_proceder_adj') && !this.existeOrdenDeProceder()) {
	        return true;
	      }
	      if (this.Proyecto.esEditable('seguimiento') && !this.sonDatosCompletosInspeccion()) {
	        return true;
	      }
	      return false;
	    }
	
	    // actualizarTechoDisponible() {
	    //   const data = {
	    //     idProyecto: this.proyecto.id_proyecto,
	    //     montoActualizar: this.proyecto.financiamiento.monto_fdi ? this.proyecto.financiamiento.monto_fdi : 0,
	    //     fechaValidos: this.proyecto._fecha_creacion
	    //   };
	    //   const codigo = this.proyecto.dpa.municipio.codigo;
	    //   this.DataService.put(`techo_presupuestario/${codigo}/recalcular`, data).then((resp) => {
	    //     if (resp && resp.finalizado) {
	    //       console.log('------------------------------------');
	    //       console.log(resp);
	    //       console.log('------------------------------------');
	    //     }
	    //   });
	    // }
	
	  }, {
	    key: 'tieneEvaluacionExterna',
	    value: function tieneEvaluacionExterna() {
	      var mensaje = [];
	      console.log("EVALUACION EXTERNA");
	      console.log(this.proyecto.doc_ev_externa);
	      if (!this.proyecto.doc_ev_externa || !this.proyecto.doc_ev_externa.base64 || !this.proyecto.doc_ev_externa.nombre || !this.proyecto.doc_ev_externa.path || !this.proyecto.doc_ev_externa.size || !this.proyecto.doc_ev_externa.tipo) {
	        if (typeof this.proyecto.doc_ev_externa === 'string' || this.proyecto.doc_ev_externa instanceof String) {
	          if (this.proyecto.doc_ev_externa == "") {
	            mensaje.push({ area: 'Módulos/Evaluación', mensaje: 'Debe cargar el documento de evaluación externa en el apartado Evaluación.' });
	          }
	        } else {
	          mensaje.push({ area: 'Módulos/Evaluación', mensaje: 'Debe cargar el documento de evaluación externa en el apartado Evaluación.' });
	        }
	      }
	      if (mensaje.length > 0) {
	        var titulo = 'Documento de Evaluación externa';
	        this.mostrarErroresModal(mensaje, titulo);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'fichaProyecto',
	    value: function fichaProyecto(proyecto) {
	      var _this2 = this;
	
	      this.Loading2.show('Se estan obteniendo los datos, espere por favor', true);
	      console.log("id recibidoooo", proyecto);
	      this.DataService.get('reportes/ficha_tecnica/' + proyecto).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this2.Loading2.hide();
	          var base64 = 'data:application/pdf;base64,' + resp.datos.base64;
	          var aLink = document.createElement("a");
	          var fileName = 'Ficha_Tecnica_' + proyecto + '.pdf';
	
	          aLink.href = base64;
	          aLink.download = fileName;
	          aLink.click();
	        } else {
	          _this2.Loading2.hide();
	        }
	      });
	    }
	  }]);
	
	  return ProyectoController;
	}();
	
	exports.default = ProyectoController;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _proyecto = __webpack_require__(584);
	
	var _proyecto2 = _interopRequireDefault(_proyecto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Proyecto = angular.module('app.rproyecto', []).component('regProyecto', _proyecto2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('reg-proyecto', {
	        url: '/reg-proyecto/{codigo: int}',
	        component: 'regProyecto',
	        params: {
	            urlProcesado: ''
	        }
	    });
	}]).name;
	
	exports.default = Proyecto;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bandeja = __webpack_require__(512);
	
	var _bandeja2 = _interopRequireDefault(_bandeja);
	
	var _proyecto = __webpack_require__(586);
	
	var _proyecto2 = _interopRequireDefault(_proyecto);
	
	var _proyectos = __webpack_require__(588);
	
	var _proyectos2 = _interopRequireDefault(_proyectos);
	
	var _cProyectos = __webpack_require__(544);
	
	var _cProyectos2 = _interopRequireDefault(_cProyectos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Proyectos = angular.module('app.rproyectos', [_bandeja2.default, _proyecto2.default, _cProyectos2.default]).service('Proyecto', _proyectos2.default).name;
	
	exports.default = Proyectos;

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProyectoService = function () {
	  ProyectoService.$inject = ["Storage", "DataService", "$q", "Datetime", "Util", "$window", "_"];
	  function ProyectoService(Storage, DataService, $q, Datetime, Util, $window, _) {
	    'ngInject';
	
	    _classCallCheck(this, ProyectoService);
	
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.estadoActual = null;
	    this.Util = Util;
	    this.$window = $window;
	    this.$q = $q;
	    this.proyectoOrigen = {};
	    this._ = _;
	  }
	
	  _createClass(ProyectoService, [{
	    key: 'setCopia',
	    value: function setCopia(proyecto) {
	      this.proyectoOrigen = angular.copy(proyecto);
	    }
	  }, {
	    key: 'setEstadoActual',
	    value: function setEstadoActual(estado) {
	      this.estadoActual = estado;
	      this.prepararDatosEstado(this.estadoActual);
	    }
	  }, {
	    key: 'getEstadoActual',
	    value: function getEstadoActual() {
	      return this.estadoActual;
	    }
	  }, {
	    key: 'get',
	    value: function get(idProyecto, procesado) {
	      var _this = this;
	
	      if (!procesado) procesado = '';
	      var url = 'proyectos/' + idProyecto + '/' + procesado;
	      url += '?rol=' + this.Storage.get('rol').id_rol;
	      var defer = this.$q.defer();
	      this.DataService.get(url).then(function (resp) {
	        if (resp) {
	          _this.setCopia(resp.datos);
	        }
	        defer.resolve(resp);
	      });
	      return defer.promise;
	    }
	
	    /**
	     * prepararDatosEstado - Convierte el array a objetos (de atributos, requeridos y áreas) para hacer más simple la búsqueda por atributos o campos
	     *
	     * @param  {type} estado Estado actual del proyecto
	     */
	
	  }, {
	    key: 'prepararDatosEstado',
	    value: function prepararDatosEstado(estado) {
	      if (this._.isEmpty(estado)) {
	        return;
	      }
	      if (estado.atributos) estado.atributos = this.Util.arrayToObject(estado.atributos);
	      if (estado.requeridos) estado.requeridos = this.Util.arrayToObject(estado.requeridos);
	      if (estado.areas) estado.areas = this.Util.arrayToObject(estado.areas);
	    }
	
	    /**
	     * esEditable - Verifica si el campo es editable de acuerdo a los datos del estado actual del proyecto
	     *
	     * @param  {string} nombreCampo nombre del campo a verificar
	     * @return {boolean}             true si el campo se encuentra en la lista permitida de acuerdo a la etapa actual
	     */
	
	  }, {
	    key: 'esEditable',
	    value: function esEditable(nombreCampo) {
	      if (this.Util.isEmpty(this.estadoActual) || this.Util.isEmpty(this.estadoActual.atributos)) {
	        return;
	      }
	      return this.estadoActual.atributos[nombreCampo] ? true : false;
	    }
	
	    /**
	     * esRequerido - Verifica si el campo es requerido de acuerdo a los datos del estado actual del proyecto
	     *
	     * @param  {string} nombreCampo nombre del campo a verificar
	     * @return {boolean}             true si el campo se encuentra en la lista permitida de acuerdo a la etapa actual
	     */
	
	  }, {
	    key: 'esRequerido',
	    value: function esRequerido(nombreCampo) {
	      if (this.Util.isEmpty(this.estadoActual) || this.Util.isEmpty(this.estadoActual.requeridos)) {
	        return;
	      }
	      return this.estadoActual.requeridos[nombreCampo] ? true : false;
	    }
	
	    /**
	     * getDatosSegunEstado - Preparando datos para enviar, de acuerdo a los atributos que se registran
	     * según el estado del proyecto
	     *
	     * @param  {object} proyecto objeto con datos del proyecto, entre ellos el estado_actual
	     * @return {object}          objeto con los atributosa enviar según el estado actual del proyecto
	     */
	
	  }, {
	    key: 'getDatosSegunEstado',
	    value: function getDatosSegunEstado(proyecto) {
	      var _this2 = this;
	
	      var nProyecto = {};
	      var ATRIBUTOS = Array.isArray(proyecto.estado_actual.atributos) ? proyecto.estado_actual.atributos : this._.keys(proyecto.estado_actual.atributos);
	      ATRIBUTOS.map(function (atributo) {
	        if (atributo === 'fcod_municipio' && proyecto.dpa && proyecto[atributo] !== proyecto.dpa.municipio.codigo) {
	          nProyecto[atributo] = proyecto.dpa.municipio.codigo;
	        }
	        if (!_this2.esAtributoModificado(atributo, proyecto)) {
	          return;
	        }
	        if (!_this2.Util.isEmpty(proyecto[atributo])) {
	          nProyecto[atributo] = proyecto[atributo];
	        }
	      });
	      return nProyecto;
	    }
	
	    /**
	     * esAtributoModificado - Verificando si el atributo fue modificado, la comparación
	     * se realiza entre los datos del proyecto en edición y los datos antes de su edición
	     *
	     * @param  {string} atributo nombre del atributo a verificar
	     * @param  {object} proyecto objeto con datos del proyecto en edición
	     * @return {boolean}          true si el atributo fue modificado y false en caso contrario
	     */
	
	  }, {
	    key: 'esAtributoModificado',
	    value: function esAtributoModificado(atributo, proyecto) {
	      return !angular.equals(this.proyectoOrigen[atributo], proyecto[atributo]);
	    }
	
	    /**
	     * esAreaPermitida - Verifica si un área determinada es permitida para su visualización
	     * de acuerdo al estado del proyecto (datos obtenidos en el servicio)
	     *
	     * @param  {String} area Nombre del área a verificar
	     * @return {Boolean}      true si el area se encuentra en la lista de áreas habilitadas
	     * y false en caso contrario
	     */
	
	  }, {
	    key: 'esAreaPermitida',
	    value: function esAreaPermitida(area) {
	      if (this.Util.isEmpty(this.estadoActual) || this.Util.isEmpty(this.estadoActual.areas)) {
	        return;
	      }
	      return this.estadoActual.areas[area] ? true : false;
	    }
	  }, {
	    key: 'tratarComoProductivo',
	    value: function tratarComoProductivo(proyecto) {
	      if (proyecto) {
	        return proyecto.beneficiarios.tipo === 'OP_TP_PRODUCTIVO' || proyecto.beneficiarios.tipo === 'OP_TP_MAQUINARIA';
	      }
	      return false;
	    }
	  }, {
	    key: 'tratarComoRiego',
	    value: function tratarComoRiego(proyecto) {
	      // console.log(proyecto,"PTYECTO RIEGOOOOOOORiego#")
	      if (proyecto) {
	        if (proyecto.cartera == 3 || proyecto.cartera == 4) {
	          return proyecto.beneficiarios.tipo === 'OP_TP_RIEGO';
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'tratarComoPuente',
	    value: function tratarComoPuente(proyecto) {
	      // console.log(proyecto,"PTYECTO Puenteeeeeee#")
	      if (proyecto) {
	        if (proyecto.cartera == 3 || proyecto.cartera == 4) {
	          return proyecto.beneficiarios.tipo === 'OP_TP_PUENTES';
	        }
	      }
	      return false;
	    }
	  }]);
	
	  return ProyectoService;
	}();
	
	exports.default = ProyectoService;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _csvGeneral = __webpack_require__(828);
	
	var _csvGeneral2 = _interopRequireDefault(_csvGeneral);
	
	var _csvGeneral3 = __webpack_require__(590);
	
	var _csvGeneral4 = _interopRequireDefault(_csvGeneral3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReporteCsvComponent = {
	    template: _csvGeneral2.default,
	    controller: _csvGeneral4.default
	};
	
	exports.default = ReporteCsvComponent;

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReporteCsvController = function () {
	  ReporteCsvController.$inject = ["$q", "DataService", "Message", "$scope", "$http", "apiUrl", "Loading", "Storage", "$log"];
	  function ReporteCsvController($q, DataService, Message, $scope, $http, apiUrl, Loading, Storage, $log) {
	    'ngInject';
	
	    _classCallCheck(this, ReporteCsvController);
	
	    this.$q = $q;
	    this.$scope = $scope;
	    this.$http = $http;
	    this.apiUrl = apiUrl;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Loading = Loading;
	    this.Storage = Storage;
	    this.log = $log;
	    this.tiposReporte = [{ valor: 'general', texto: 'Reporte general de proyectos' },
	    // {valor:'porMunicipio', texto:'Reporte de avance de proyectos por municipio'},
	    // {valor:'porDepartamento', texto:'Reporte de avance de proyectos por departamento'},
	    // {valor:'porDptoEmpleo', texto:'Proyectos ejecutados por departamento (Empleo)'},
	    // {valor:'porDptoPPTO', texto:'Proyectos ejecutados por departamento (PPTO)'},
	    { valor: 'porDptoMetas', texto: 'Reporte proyectos por departamento (Metas y resultados, linea base, indicador de proceso e indicador de impacto)' },
	    // {valor:'agrupadoFisicoFinanciero', texto:'Reporte de avance físico financiero'},
	    // {valor:'agrupadoTiposDpto', texto:'Resumen de proyectos de gobiernos autónomos municipales por departamento'},
	    { valor: 'reporteFinanciamiento', texto: 'Reporte general de proyectos (estructura de financiamiento) ' }];
	    this.filenames = {
	      general: 'reporte_general_de_proyectos.csv',
	      porMunicipio: 'reporte_avance_de_proyectos_por_municipio.csv',
	      porDepartamento: 'reporte_avance_de_proyectos_por_departamento.csv',
	      porDptoEmpleo: 'reporte_empleo_por_departamento.csv',
	      porDptoPPTO: 'reporte_ppto_por_departamento.csv',
	      porDptoMetas: 'reporte_metas_por_departamento.csv',
	      agrupadoFisicoFinanciero: 'reporte_avance_fisico_financiero.csv',
	      agrupadoTiposDpto: 'resumen_proyectos_de_gam_por_departamento.csv',
	      reporteFinanciamiento: 'reporte_estructura_financiamiento.csv'
	    };
	    this.tipoReporte = 'general';
	    this.filename = 'sample.csv';
	    this.showDpa = false;
	  }
	
	  _createClass(ReporteCsvController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.generandoCSV = true;
	
	      var gestion = new Date();
	      this.gestiones = [];
	      for (var nombre = 2018; nombre <= 1900 + gestion.getYear(); nombre++) {
	        this.gestiones.unshift({ nombre: nombre });
	        this.gestion = this.gestiones[0];
	      }
	
	      this.DataService.get('cartera/', {}).then(function (response) {
	        if (response) {
	          _this.carteras = response.datos;
	          _this.log.log('hay ' + _this.carteras.length + ' carteras :', _this.carteras);
	        }
	      });
	      // this.carteraSelected = 1;
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.tipoReporte', function () {
	        _this2.limpiarDatosReporte();
	        _this2.filename = _this2.filenames[_this2.tipoReporte];
	        // console.log('-----------filename-----------------');
	        // console.log(this.filename);
	        // console.log('------------------------------------');
	      });
	      this.$scope.$watch('$ctrl.gestion.nombre', function () {
	        _this2.limpiarDatosReporte();
	      });
	      this.$scope.$watch('$ctrl.dpa.departamento.codigo', function () {
	        _this2.limpiarDatosReporte();
	      });
	      this.$scope.$watch('$ctrl.dpa.municipio.codigo', function () {
	        _this2.limpiarDatosReporte();
	      });
	    }
	  }, {
	    key: 'aplicarTipo',
	    value: function aplicarTipo() {
	      // console.log('------tipo--------------------------');
	      // console.log(this.tipoReporte);
	      // console.log('------------------------------------');
	      var requierenDpa = ['porMunicipio', 'porDepartamento', 'agrupadoTiposDpto', 'porDptoEmpleo', 'porDptoPPTO', 'porDptoMetas'];
	      // if (this.tipoReporte === 'porMunicipio' || this.tipoReporte === 'porDepartamento' || this.tipoReporte === 'agrupadoTiposDpto' || this.tipoReporte === 'porDptoEmpleo' || this.tipoReporte === 'porDptoPPTO' || this.tipoReporte === 'porDptoMetas') {
	      if (requierenDpa.indexOf(this.tipoReporte) > -1) {
	        this.showDpa = true;
	      } else {
	        this.showDpa = false;
	      }
	      this.dpa = {};
	    }
	  }, {
	    key: 'descargarCSV',
	    value: function descargarCSV(format) {
	      var _this3 = this;
	
	      // console.log('------------dpa---------------------');
	      // console.log(this.dpa);
	      // console.log('------------gestion-----------------');
	      // console.log(this.gestion);
	      // console.log('------------------------------------');
	      var rutaReporte = 'reportes/csv?cartera=' + this.carteraSelected; // default general
	      if (format) {
	        rutaReporte += '&format=' + format;
	      }
	
	      if (this.tipoReporte !== 'general') {
	        // if (this.gestion && this.gestion.nombre) {
	        rutaReporte = 'reportes/csv/' + this.tipoReporte + '?cartera=' + this.carteraSelected;
	        if (this.tipoReporte === 'porDepartamento' || this.tipoReporte === 'agrupadoTiposDpto' || this.tipoReporte === 'porDptoEmpleo' || this.tipoReporte === 'porDptoPPTO' || this.tipoReporte === 'porDptoMetas') {
	          if (this.dpa.departamento && this.dpa.departamento.codigo) {
	            rutaReporte = rutaReporte + ('&dpto=' + this.dpa.departamento.codigo);
	          } else {
	            this.Message.warning('Debe seleccionar un departamento');
	            return;
	          }
	        } else if (this.tipoReporte === 'porMunicipio') {
	          if (this.dpa.municipio && this.dpa.municipio.codigo) {
	            rutaReporte = rutaReporte + ('&municipio=' + this.dpa.municipio.codigo);
	          } else {
	            this.Message.warning('Debe seleccionar un municipio');
	            return;
	          }
	        }
	        if (format) {
	          rutaReporte += '&format=' + format;
	        }
	        // } else {
	        //   this.Message.warning('Debe seleccionar una gestión');
	        //   return
	        // }
	      }
	
	      // console.log('----------ruta reporte--------------');
	      // console.log(rutaReporte);
	      // console.log('------------------------------------');
	
	      this.Loading.show('Se estan obteniendo los datos, espere por favor', true);
	
	      if (format) {
	        this.usuario = this.Storage.getUser();
	        rutaReporte += '&rol=' + this.usuario.rol.id_rol;
	        console.log(rutaReporte);
	        this.$http({
	          url: '' + this.apiUrl + rutaReporte,
	          method: 'GET',
	          headers: {
	            'Content-type': 'application/octet-stream'
	          },
	          responseType: "arraybuffer"
	        }).then(function (data) {
	          // console.log('resp', resp)
	          var ieEDGE = navigator.userAgent.match(/Edge/g);
	          var ie = navigator.userAgent.match(/.NET/g); // IE 11+
	          var oldIE = navigator.userAgent.match(/MSIE/g);
	
	          var blob = new window.Blob([data.data], { type: 'application/octet-stream' });
	
	          if (ie || oldIE || ieEDGE) {
	
	            var fileName = _this3.filename + '.xlsx';
	            window.navigator.msSaveBlob(blob, fileName);
	          } else {
	
	            var file = new Blob([data.data], {
	              type: 'application/octet-stream'
	            });
	
	            var fileURL = URL.createObjectURL(file);
	            var a = document.createElement('a');
	            a.href = fileURL;
	            a.target = '_blank';
	            a.download = _this3.filename + '.xlsx';
	            document.body.appendChild(a);
	
	            a.click();
	          }
	        }).catch(function (data, status) {
	          console.error(data, status);
	        });
	        return;
	      }
	
	      var deferred = this.$q.defer();
	      this.DataService.get(rutaReporte).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this3.Loading.hide();
	          // console.log('---------datos----------------------');
	          // console.log(resp.datos);
	          // console.log('------------------------------------');
	          _this3.Message.success(resp.mensaje);
	          _this3.cabeceras = ['Sin_registros'];
	          _this3.getArray = [];
	          if (resp.datos.rows[0]) {
	            _this3.cabeceras = _this3.$$obtenerCabeceras(resp.datos.rows[0]);
	            _this3.getArray = resp.datos.rows;
	          }
	          deferred.resolve(_this3.getArray);
	          _this3.cantidad = resp.datos.count;
	          _this3.generandoCSV = resp.datos.count > 0;
	        } else {
	          _this3.Loading.hide();
	          deferred.reject();
	        }
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'obtenerCabeceras',
	    value: function obtenerCabeceras() {
	      return this.cabeceras;
	    }
	  }, {
	    key: '$$obtenerCabeceras',
	    value: function $$obtenerCabeceras(datos) {
	      var cabeceras = [];
	      for (var i in datos) {
	        cabeceras.push(i);
	      }
	      return cabeceras;
	    }
	  }, {
	    key: 'limpiarDatosReporte',
	    value: function limpiarDatosReporte() {
	      if (this.cantidad > 0) {
	        this.cabeceras = ['Sin_registros'];
	        this.getArray = [];
	        this.cantidad = 0;
	      }
	    }
	  }]);
	
	  return ReporteCsvController;
	}();
	
	exports.default = ReporteCsvController;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _csvGeneral = __webpack_require__(589);
	
	var _csvGeneral2 = _interopRequireDefault(_csvGeneral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dashboard = angular.module('app.reporte.csv', []).component('appReporteCsv', _csvGeneral2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('reporte-general', {
	        url: '/reporte-general',
	        component: 'appReporteCsv'
	    });
	}]).name;
	
	exports.default = Dashboard;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _csvGeneral = __webpack_require__(591);
	
	var _csvGeneral2 = _interopRequireDefault(_csvGeneral);
	
	var _repoGam = __webpack_require__(595);
	
	var _repoGam2 = _interopRequireDefault(_repoGam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Reporte = angular.module('app.reporte', [_csvGeneral2.default, _repoGam2.default]).name;
	
	exports.default = Reporte;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _repoGam = __webpack_require__(829);
	
	var _repoGam2 = _interopRequireDefault(_repoGam);
	
	var _repoGam3 = __webpack_require__(594);
	
	var _repoGam4 = _interopRequireDefault(_repoGam3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReporteGamComponent = {
	    template: _repoGam2.default,
	    controller: _repoGam4.default
	};
	
	exports.default = ReporteGamComponent;

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReporteGamController = function () {
	  ReporteGamController.$inject = ["$q", "DataService", "Message", "$scope", "$http", "apiUrl", "Loading", "Storage", "$log", "baseUrl", "DataTable"];
	  function ReporteGamController($q, DataService, Message, $scope, $http, apiUrl, Loading, Storage, $log, baseUrl, DataTable) {
	    'ngInject';
	
	    _classCallCheck(this, ReporteGamController);
	
	    this.$q = $q;
	    this.$scope = $scope;
	    this.$http = $http;
	    this.apiUrl = apiUrl;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Loading = Loading;
	    this.Storage = Storage;
	    this.log = $log;
	    this.baseUrl = baseUrl;
	    this.DataTable = DataTable;
	  }
	
	  _createClass(ReporteGamController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      this.obtenerDatosSeguimiento();
	    }
	  }, {
	    key: 'obtenerDatosSeguimiento',
	    value: function obtenerDatosSeguimiento() {
	
	      this.tableParams = this.DataTable.getParams('reportes/gam-seguimiento');
	      // this.DataService.get(`reportes/gam-seguimiento`,{})
	      // .then(response=>{
	      //   if(response){
	      //     console.log(response)
	      //     this.datosGam = response.datos;
	
	      //   }
	      // })
	    }
	  }, {
	    key: 'generarPDF',
	    value: function generarPDF() {
	      var tabla = document.getElementById('tabla1');
	
	      this.DataService.pdf('reportes/consejo', { html: tabla.outerHTML }, true).then(function (resp) {
	        if (resp) {
	
	          window.open(resp, 'ventana1', 'menu=0,tooltip=0,width=900px,height=700px,resize=0');
	          // console.log(resp)
	        }
	      });
	    }
	  }]);
	
	  return ReporteGamController;
	}();
	
	exports.default = ReporteGamController;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _repoGam = __webpack_require__(593);
	
	var _repoGam2 = _interopRequireDefault(_repoGam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardGam = angular.module('app.reporte.gam', []).component('appReporteGam', _repoGam2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('reporte-gam', {
	        url: '/reporte-gam',
	        component: 'appReporteGam'
	    });
	}]).name;
	
	exports.default = DashboardGam;

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Created on 7/16/2016.
	 * Theophilus Omoregbee <theo4u@ymail.com>
	 */
	
	/**
	 * Tag input allows input from client and this input objects must contain the
	 * 'text' field or use the data-field='field_in_ur_array_or_object' to specify which field you want us to use
	 * i.e data set =[ {text:'View', value:'value1'[,..:...]}, {text:'View', value:'value2'[,..:...]}, ....]
	 * where the text is used in displaying the content to users and checking if the text matches any data set
	 * field to add to our selected tag as return array of objects
	 *
	 *
	 * it generates a default view for the entered input when the allow outside data set is used , if it exist on our
	 * data set use the object in the data set and add it to our selected data set
	 * else if  not in our data set then use the $scope.default_input={text:input}
	 *
	 * required is only triggered when the required field is true and the selected tag is empty throw required on the input
	 * name is specified so as to alert the form that the input with the name is needed
	 *
	 * Ability to style it , but comes with two styled themes
	 *          1. Material
	 *          2. Default
	 *
	 * The directive calls some few events
	 *          1. tag-added calls the onTagAdded with the added item to the parent method as parameter which is the a child in the event
	 *          2. tag-removed calls the onTagRemoved with the removed item to the parent method as parameter which is the a child in the event
	 *          3. tag-active same happens it notifies the user via the onTagActive function with the event containing the item
	 *          4. tag-maximum same as above this is calls onTagMaximum when the selected tags count hits its maximum specified in the $scope.max
	 *
	 * Delimiter can be array of delimiters[default=','] or enter key which is default for the system to use despite the delimiters
	 * Max helps in monitoring how many tag is added or selected
	 *
	 * You can delete tag by Either
	 *          1. Backspace
	 *          2. Delete
	 *
	 *  Type Head features
	 *         1. normal type head which is based on the data set , as user types it opens the type head for assistance
	 *             it is triggered by default, users can decide to off it , by turning it to false
	 *        2. For type head animation just inject ngAnimate
	 */
	
	(function () {
	
	    /**
	    * This method takes in a variable to determine if the variable was initialized or null then use the default specified
	    * @param variable
	    * @param default_value
	    * @returns {*}
	    */
	    var data_init = function data_init(variable, default_value) {
	
	        if (variable === undefined || variable === null) return default_value;else return variable;
	    };
	
	    /**
	     * Our Controller for the tags-input
	     * @param $scope
	     * @param $filter
	     */
	    var controllerFunction = function controllerFunction($scope, $filter, $log, $timeout) {
	        $scope.hasError = false; //when there is error while entrying record
	        $scope.delimiter = data_init($scope.delimiter, [',']); //used in specifying which separator to use or use default ,
	        $scope.data = data_init($scope.data, []);
	        $scope.selected = data_init($scope.selected, []);
	        $scope.allowOutsideDataSet = data_init($scope.allowOutsideDataSet, false);
	        $scope.sameInput = data_init($scope.sameInput, false);
	        $scope.default_input = {}; //default view when a new object is added i.e when
	        $scope.theme = data_init($scope.theme, 'default');
	        $scope.typehead = data_init($scope.typehead, true); //used in displaying type head or not
	        $scope.displayField = data_init($scope.displayField, 'text'); //used in displaying which field inside the data set we need
	        $scope.placeholder = data_init($scope.placeholder, 'Enter Text with , separated'); //this is helps for custom placeholder
	        $scope.max = data_init($scope.max, undefined); //this is helps to allow infinity value of input tag by default
	        $scope.required = data_init($scope.required, false);
	        $scope.name = data_init($scope.name, 'tagMe'); //used in getting the name of our input field
	
	        $scope.active_index = -1; //this hold the active selected tag index
	        $scope.typeheadOpened = false; //notify and holds the true or false , depending when the typehead options is showed for selection
	
	
	        /**
	         * This method checks if an item(input) exist inside an array
	         * @param array
	         * @param input
	         * @returns {*}
	         */
	        $scope.check_data = function (array, input) {
	            return $filter('filter')(array, function (value, index) {
	                return value[$scope.displayField] == input;
	            })[0];
	        };
	
	        /**
	         * This method strips off any delimiter in our input and return a refined input with no delimiter
	         * @param input the input to strip delimiter of
	         * @returns {*}
	         */
	        $scope.strip_delimiters = function (input) {
	            var n = $scope.delimiter.length;
	            for (var i = 0; i < n; i++) {
	                input = input.replace($scope.delimiter[i], '');
	            }return input; //stripped input with no delimiter
	        };
	
	        /**
	         * This method checks if there exist a delimiter in our input
	         * @param input to work on
	         * @returns {boolean} returns either true or false , if found true else false
	         */
	        $scope.check_delimiter = function (input) {
	            var n = $scope.delimiter.length;
	            //$log.log("Size:"+n+"--"+$scope.delimiter);
	            for (var i = 0; i < n; i++) {
	                if (input.indexOf($scope.delimiter[i]) > -1) return true;
	            }return false;
	        };
	
	        /**
	         * on key up call this function to help process our tag input
	         */
	        $scope.on_input_keyup = function (event) {
	            var input = '';
	            if ($scope.input !== undefined) input = $scope.strip_delimiters($scope.input);
	            //$log.log("striped input:"+input);
	            //if user just type and uses our defined delimiter do this function
	            if ($scope.input !== undefined && $scope.check_delimiter($scope.input) === true) {
	                if (input !== "") $scope.processor(input);
	                return 0;
	            }
	
	            //if user types and presses enter key (keyCode 13 ASCII)
	            if (event.keyCode === 13 && input !== "") {
	                $scope.processor(input);
	                return 0;
	            }
	            if (event.keyCode === 32 && input !== "") {
	                $scope.processor(input);
	                return 0;
	            }
	
	            //let's check if the user pressed the backspace button so we know when to enter the tag after the input i.e activate the tag as active
	            //and check if the backspace is pressed and nothing to backspace then move to our last added tag
	            if (event.keyCode === 8 && input.slice(0, $scope.getCursorPosition(event.target)) === "") {
	                // $log.info("backspace activated");
	                var last_index = $scope.selected.length - 1;
	                //if backspace is clicked twice with input empty delete
	                if (last_index === $scope.active_index) {}
	                /* $scope.remove($scope.selected[$scope.active_index]);
	                 last_index = -1;*/
	
	
	                //  $scope.moveToTag(event,last_index);//-1 means move the tag to the last tag
	                return 0;
	            }
	
	            //when the user clicked on the delete button removed the active one and if the input field delete action is dummant i.e
	            //when user press it no text to remove from behind again
	            if (event.keyCode === 46 && input.slice($scope.getCursorPosition(event.target), input.length) === "") {
	                // $scope.remove($scope.selected[$scope.active_index]);
	                return 0;
	            }
	        };
	
	        /**
	         * This method is to help navigate between or added tags when the key arrow left,down,up and right is pressed
	         * and this works with only the keypress down event
	         * @param event
	         */
	        $scope.on_input_keydown = function (event) {
	            var input = '';
	            if ($scope.input !== undefined) input = $scope.input.replace($scope.delimiter, '');
	
	            //when user press the directional key left check if the cursor position is at the extreme left of the input field
	            if (event.keyCode === 37 && $scope.getCursorPosition(event.target) === 0) {
	                var last_index = $scope.active_index === -1 || $scope.active_index === 0 ? $scope.selected.length - 1 : $scope.active_index - 1;
	                $scope.moveToTag(event, last_index);
	                return;
	            }
	
	            //when user press the directional key right check if the cursor position is at the extreme right of the input field
	            if (event.keyCode === 39 && $scope.getCursorPosition(event.target) === input.length) {
	                var first_index = $scope.active_index === -1 || $scope.active_index === $scope.selected.length - 1 ? 0 : $scope.active_index + 1;
	                $scope.moveToTag(event, first_index);
	                return 0;
	            }
	
	            // when the user press the down button and typehead is true activate our type head to show and move down the list
	            if (event.keyCode === 40 && $scope.typehead === true) {
	                $scope.typeheadOpened = true; //open the typehead
	                var active = $scope.getActiveTypeHead(event);
	                var first_index = active === -1 || active === $scope.data.length - 1 ? 0 : active + 1;
	                $scope.moveToTagTypeHead(event, first_index);
	                return 0;
	            }
	
	            // when the user press the up button and typehead is true activate our type head to show
	            if (event.keyCode === 38 && $scope.typehead === true) {
	                $scope.typeheadOpened = true; //open the typehead
	                return 0;
	            }
	        };
	
	        /**
	         * This function is fired to help handle on blur on our input which should only occur when the user loses focus on the input
	         * this helps handle when the user loses focus just wait small and close it and when user click on it dont hide it on time wait for
	         * specified time
	         */
	        $scope.onblur = function () {
	            $timeout(function () {
	                $scope.typeheadOpened = false;
	                $scope.isFocus = false;
	            }, 300);
	        };
	
	        /**
	         * Thanks to Dasari Srinivas http://blog.sodhanalibrary.com/2015/02/get-cursor-position-in-text-input-field.html#.V5Ly47grK00
	         *  This method helps in getting the cursor position in our text field so we can check if there was something
	         * @param oField which is the html field our text field in this case
	         * @returns {number}
	         */
	        $scope.getCursorPosition = function (oField) {
	
	            // Initialize
	            var iCaretPos = 0;
	
	            // IE Support
	            if (document.selection) {
	
	                // Set focus on the element
	                oField.focus();
	
	                // To get cursor position, get empty selection range
	                var oSel = document.selection.createRange();
	
	                // Move selection start to 0 position
	                oSel.moveStart('character', -oField.value.length);
	
	                // The caret position is selection length
	                iCaretPos = oSel.text.length;
	            }
	
	            // Firefox support
	            else if (oField.selectionStart || oField.selectionStart === '0') iCaretPos = oField.selectionStart;
	
	            // Return results
	            return iCaretPos;
	        };
	
	        /**
	         * this method updates our tag view with the input parameter, and pass an event to the parent that an object is gotten
	         * and it checks if the max is specified i.e if the maximum tags is reached or if not specified it should allow tags till infinity
	         *
	         * it sends two event when the a tag is added and when the selected tags hits maximum allowed
	         * @param input
	         */
	        $scope.update = function (input) {
	            if ($scope.selected.length < $scope.max || $scope.max === undefined) {
	                $scope.selected.push(angular.copy(input));
	                $scope.input = "";
	                $scope.typeheadOpened = false;
	                $scope.hasError = false;
	                var event_temp = { action: 'added', item: input };
	                $scope.onTagAdded({ event: event_temp });
	            } else {
	                $scope.hasError = true;
	                var event = { action: 'maximum', item: input };
	                $scope.onTagMaximum({ event: event });
	            }
	        };
	
	        /**
	         * This method removes the item from our selected tags, and it broadcast an event that an element has been removed to its parent
	         * @param item
	         */
	        $scope.remove = function (item) {
	            $scope.selected = $filter('filter')($scope.selected, function (value, index) {
	                return value !== item;
	            });
	            $scope.active_index = -1;
	            var event = { action: 'removed', item: item };
	            $scope.onTagRemoved({ event: event });
	        };
	
	        /**
	         * This method check if data check is defined , if it is defined , so we know if the entered item is in our data_set or not
	         * @param data_check
	         * @param input
	         * @returns {*}
	         */
	        $scope.return_value = function (data_check, input) {
	            if (data_check === undefined) {
	                $scope.default_input["" + $scope.displayField] = input;
	                return $scope.default_input;
	            } else return data_check; //means is on our data set , so pick the item from there
	        };
	
	        /**
	         * This method moves the cursor to the tag in a particular index  of our event which holds the parent and set it to be active
	         * @param event
	         * @param index
	         */
	        $scope.moveToTag = function (event, index) {
	            var lis = angular.element(event.target.parentNode.parentNode).find('li');
	            var size = lis.length;
	            for (var i = 0; i < size - 1; i++) {
	                if (i === index) {
	                    //check if it contains active before then toggle
	                    if ($scope.active_index !== index) {
	                        $scope.active_index = index;
	                        angular.element(lis[i]).addClass('active');
	                        var event_temp = { action: 'active', item: $scope.selected[$scope.active_index] };
	                        $scope.onTagActive({ event: event_temp });
	                    } else {
	                        $scope.active_index = -1;
	                        angular.element(lis[i]).removeClass('active');
	                    }
	                } else angular.element(lis[i]).removeClass('active');
	            }
	        };
	
	        /**
	         * This method moves the cursor to the tag typehead in a particular index  of our event which holds the parent and set its class to be active
	         * @param event
	         * @param index
	         */
	        $scope.moveToTagTypeHead = function (event, index) {
	            var main_tag = angular.element(event.target.parentNode.parentNode.parentNode.parentNode).find('ul')[1]; //get the parent (div.main-tag ul)[1]
	            var lis = angular.element(main_tag).find('a');
	            var size = lis.length;
	            for (var i = 0; i < size; i++) {
	                if (i === index) {
	                    //check if it contains active before then toggle
	                    angular.element(lis[i]).addClass('active');
	                } else angular.element(lis[i]).removeClass('active');
	            }
	        };
	
	        /**
	         *  This method helps in going through our type head to get the active index and return the index of it or return -1 for not found
	         * @param event
	         * @return {number} -1 for not found >-1 for found index
	         */
	        $scope.getActiveTypeHead = function (event) {
	            var main_tag = angular.element(event.target.parentNode.parentNode.parentNode.parentNode).find('ul')[1]; //get the parent (div.main-tag ul)[1]
	            var lis = angular.element(main_tag).find('a');
	            var size = lis.length;
	            for (var i = 0; i < size - 1; i++) {
	                if (angular.element(lis[i]).hasClass('active')) return i;
	            } // is the active one
	
	            return -1; //no active
	        };
	
	        /**
	         * when the user type in the field it should call this function for checking
	         *
	         * which would check if the following instructions
	         *  1. allowOutsideDataSet
	         *  2. sameInput
	         *  3. hasError
	         */
	        $scope.processor = function (input) {
	
	            //lets check if it is inside our main data
	            var data_set_check = $scope.check_data($scope.data, input);
	
	            //lets check if it is inside our selected data set
	            var selected_set_check = $scope.check_data($scope.selected, input);
	
	            //scenarios: when allowed outside data set and same input should be allowed
	            if ($scope.allowOutsideDataSet && $scope.sameInput) {
	                $scope.update($scope.return_value(data_set_check, input));
	                return;
	            }
	
	            //scenarios: when allowed outside data set and same input is not set
	            if ($scope.allowOutsideDataSet && !$scope.sameInput) {
	
	                //then check for match in our selected data set
	                if (selected_set_check === undefined) $scope.update($scope.return_value(data_set_check, input));else $scope.hasError = true;
	
	                return;
	            }
	
	            //scenarios: when allowed outside data set is not set and not allowing same input
	            if (!$scope.allowOutsideDataSet && !$scope.sameInput) {
	                //then check for match in our selected data set and our main data set
	                if (data_set_check !== undefined && selected_set_check === undefined) $scope.update(data_set_check);else $scope.hasError = true;
	
	                return;
	            }
	
	            //scenarios: when allowed outside data set is not set and allowing same input
	            if (!$scope.allowOutsideDataSet && $scope.sameInput) {
	                //then check for match in our selected data set and our main data set
	                if (data_set_check !== undefined) $scope.update(data_set_check);else $scope.hasError = true;
	
	                return;
	            }
	
	            $scope.hasError = true;
	            $log.error("Error, Existing before in our output , or not among data set");
	        };
	    };
	
	    //inject into our controller required dependencies
	    controllerFunction.$inject = ['$scope', '$filter', '$log', '$timeout'];
	
	    var directive = function directive() {
	        return {
	            restrict: 'E',
	            require: '?^^form', //optoinal form incase the user wants required checking
	            scope: {
	                type: '@',
	                theme: '@', //help to get theme to use in manipulating tag via
	                data: '=?', //if set , is where we use in our data set to check if the entered item match any of the fields/items in it
	                selected: '=', //return the selected item(s)/tags here
	                sameInput: '=?', //to allow same input , that is a selected item can appear more than once in our tagging system
	                allowOutsideDataSet: '=?', //if the allowed input should be outside the data set specified
	                typehead: '=?', //used in turning type head to assist users when typing or not
	                displayField: '@', //field to display to the user in the data set to the tag view
	                placeholder: '@', //assist users so they can use their place holders , if not placed it wud use the default
	                delimiter: '=?', //delimiter to separate the text entered which is an array of delimiters
	                onTagAdded: '&', //event is passed via to the function to the directive to be called anytime u add a tag
	                onTagRemoved: '&', //event is passed via to the function to the directive to be called anytime we remove from the tag
	                onTagActive: '&', //event is passed via to the function to the directive to be called anytime a tag is active
	                max: '=?', //max tag that can be allowed
	                onTagMaximum: '&', //event called when the tag hits its maximum number of allowable input
	                required: '=?', //default false.if the input is required or not , and this is used when the input is empty and the selected is empty
	                name: '@', //is needed when the required is set true
	                minLength: '@', //minima longitud del contenido del tag
	                maxLength: '@', //maxima longitud del contenido del tag
	                validation: '<?' //validacion pattern para contenido de tags
	            },
	            templateUrl: function templateUrl(elem, attr) {
	                return 'angular-tag/templates/' + attr.type + '.html';
	            },
	            controller: controllerFunction, //Embed a custom controller in the directive
	            link: function link($scope, element, attrs, form) {
	                var our_input = angular.element(element.find("input")[0]);
	                $scope.form = data_init(form, undefined); //keep our parent form here if it is specified
	
	                our_input.bind('keyup', function ($event) {
	                    //check our input as they type for validity
	                    //here we bind form validity  if required is true
	                    if ($scope.required && $scope.selected.length === 0) //the form is invalid here
	                        if ($scope.form) {
	                            //if the form
	                            $scope.form[our_input.attr("name")].$setValidity('required', false);
	                        }
	                });
	            } //DOM manipulation
	        };
	    };
	
	    /**
	     * This directive helps to manipulate the text input to make it focusable
	     * @returns {{restrict: string, link: link}}
	     */
	    var directive_focus = function directive_focus() {
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                scope.$watch(attrs.focusMe, function (value) {
	                    if (value === true) element[0].focus();
	                });
	            } //DOM manipulation
	        };
	    };
	
	    var module = angular.module('angular-tag', ['angular-tag/templates']);
	    module.directive('tagMe', directive).directive('focusMe', directive_focus);
	})();
	
	angular.module('angular-tag/templates', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('angular-tag/templates/input.html', '<div id="main-tag">\n\n                                                                <div class="tag-container">\n\n                                                                  <ul ng-class="[\'tag\',{focus:isFocus},theme ]" ng-click="isFocus=true" ng-keydown="direction_keys($event)">\n\n                                                                    <li ng-repeat="select in selected" ng-click="(moveToTag($event,$index)) "  data-drop="true" data-drag="true" ng-model="selected" jqyoui-droppable="{index: {{$index}}}" jqyoui-draggable="{index: {{$index}}, insertInline: true, direction:\'jqyouiDirection\'}" data-jqyoui-options="{revert: \'invalid\'}" data-direction="{{item.jqyouiDirection}}">\n      {{select[displayField]}}\n                                                                      <a href="javascript:void(0)" ng-click="remove(select)">&times;</a>\n\n                                                                       </li>\n<li>\n\n                                                                         <input ng-pattern="validation" ng-minlength="{{minLength}}" ng-maxlength="{{maxLength}}" name="{{name}}" ng-model="input" ng-keyup="on_input_keyup($event)" ng-keydown="on_input_keydown($event)" ng-focus="isFocus=true" ng-blur="onblur();" focus-me="isFocus"\n type="input" placeholder="{{placeholder}}" ng-required="required && (!selected.length || selected.length==0)" >\n\n                                                                       </li>\n\n                                                                  </ul>\n\n                                                                </div>\n\n\n                                                                <ul class="tag-typehead" ng-show="(isFocus && input.length && typehead && results.length) || (typehead && typeheadOpened) " >\n\n                                                                  <li class="animate-repeat" ng-repeat="item in data | filter:input as results">\n\n                                                                    <a href="javascript:void(0)" ng-click="processor(item[displayField])">{{item[displayField]}}</a>\n\n                                                                  </li>\n\n                                                                  <!--<li class="animate-repeat" ng-if="results.length == 0">\n\n                                                                  <strong>No results found...</strong>\n\n                                                                  </li>-->\n\n                                                                </ul>\n\n                                                              </div>');
	}]);

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(596);
	__webpack_require__(179);
	var MODULE_NAME = 'angular-chips';
	
	angular.module(MODULE_NAME, ['angular-tag']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**!
	 * The MIT License
	 *
	 * Copyright (c) 2013 the angular-leaflet-directive Team, http://tombatossals.github.io/angular-leaflet-directive
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 *
	 * angular-leaflet-directive
	 * https://github.com/tombatossals/angular-leaflet-directive
	 *
	 * @authors https://github.com/tombatossals/angular-leaflet-directive/graphs/contributors
	 */
	
	/*!
	*  angular-leaflet-directive  2015-11-06
	*  angular-leaflet-directive - An AngularJS directive to easily interact with Leaflet maps
	*  git: https://github.com/tombatossals/angular-leaflet-directive
	*/
	(function (angular) {
	  'use strict';
	
	  angular.module('leaflet-directive', []).directive('leaflet', ["$q", "leafletData", "leafletMapDefaults", "leafletHelpers", "leafletMapEvents", function ($q, leafletData, leafletMapDefaults, leafletHelpers, leafletMapEvents) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      scope: {
	        center: '=',
	        lfCenter: '=',
	        defaults: '=',
	        maxbounds: '=',
	        bounds: '=',
	        markers: '=',
	        legend: '=',
	        geojson: '=',
	        paths: '=',
	        tiles: '=',
	        layers: '=',
	        controls: '=',
	        decorations: '=',
	        eventBroadcast: '=',
	        markersWatchOptions: '=',
	        geojsonWatchOptions: '='
	      },
	      transclude: true,
	      template: '<div class="angular-leaflet-map"><div ng-transclude></div></div>',
	      controller: ["$scope", function ($scope) {
	        this._leafletMap = $q.defer();
	        this.getMap = function () {
	          return this._leafletMap.promise;
	        };
	
	        this.getLeafletScope = function () {
	          return $scope;
	        };
	      }],
	
	      link: function link(scope, element, attrs, ctrl) {
	        var isDefined = leafletHelpers.isDefined;
	        var defaults = leafletMapDefaults.setDefaults(scope.defaults, attrs.id);
	        var mapEvents = leafletMapEvents.getAvailableMapEvents();
	        var addEvents = leafletMapEvents.addEvents;
	
	        scope.mapId = attrs.id;
	        leafletData.setDirectiveControls({}, attrs.id);
	
	        // Set width and height utility functions
	        function updateWidth() {
	          if (isNaN(attrs.width)) {
	            element.css('width', attrs.width);
	          } else {
	            element.css('width', attrs.width + 'px');
	          }
	        }
	
	        function updateHeight() {
	          if (isNaN(attrs.height)) {
	            element.css('height', attrs.height);
	          } else {
	            element.css('height', attrs.height + 'px');
	          }
	        }
	
	        // If the width attribute defined update css
	        // Then watch if bound property changes and update css
	        if (isDefined(attrs.width)) {
	          updateWidth();
	
	          scope.$watch(function () {
	            return element[0].getAttribute('width');
	          }, function () {
	            updateWidth();
	            setTimeout(function () {
	              map.invalidateSize();
	            }, 400);
	          });
	        }
	
	        // If the height attribute defined update css
	        // Then watch if bound property changes and update css
	        if (isDefined(attrs.height)) {
	          updateHeight();
	
	          scope.$watch(function () {
	            return element[0].getAttribute('height');
	          }, function () {
	            updateHeight();
	            setTimeout(function () {
	              map.invalidateSize();
	            }, 400);
	          });
	        }
	
	        // Create the Leaflet Map Object with the options
	        var map = new L.Map(element[0], leafletMapDefaults.getMapCreationDefaults(attrs.id));
	        ctrl._leafletMap.resolve(map);
	
	        if (!isDefined(attrs.center) && !isDefined(attrs.lfCenter)) {
	          map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	        }
	
	        // If no layers nor tiles defined, set the default tileLayer
	        if (!isDefined(attrs.tiles) && !isDefined(attrs.layers)) {
	          var tileLayerObj = L.tileLayer(defaults.tileLayer, defaults.tileLayerOptions);
	          tileLayerObj.addTo(map);
	          leafletData.setTiles(tileLayerObj, attrs.id);
	        }
	
	        // Set zoom control configuration
	        if (isDefined(map.zoomControl) && isDefined(defaults.zoomControlPosition)) {
	          map.zoomControl.setPosition(defaults.zoomControlPosition);
	        }
	
	        if (isDefined(map.zoomControl) && defaults.zoomControl === false) {
	          map.zoomControl.removeFrom(map);
	        }
	
	        if (isDefined(map.zoomsliderControl) && isDefined(defaults.zoomsliderControl) && defaults.zoomsliderControl === false) {
	          map.zoomsliderControl.removeFrom(map);
	        }
	
	        // if no event-broadcast attribute, all events are broadcasted
	        if (!isDefined(attrs.eventBroadcast)) {
	          var logic = 'broadcast';
	          addEvents(map, mapEvents, 'eventName', scope, logic);
	        }
	
	        // Resolve the map object to the promises
	        map.whenReady(function () {
	          leafletData.setMap(map, attrs.id);
	        });
	
	        scope.$on('$destroy', function () {
	          leafletMapDefaults.reset();
	          map.remove();
	          leafletData.unresolveMap(attrs.id);
	        });
	
	        //Handle request to invalidate the map size
	        //Up scope using $scope.$emit('invalidateSize')
	        //Down scope using $scope.$broadcast('invalidateSize')
	        scope.$on('invalidateSize', function () {
	          map.invalidateSize();
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletBoundsHelpers', ["$log", "leafletHelpers", function ($log, leafletHelpers) {
	
	    var isArray = leafletHelpers.isArray;
	    var isNumber = leafletHelpers.isNumber;
	    var isFunction = leafletHelpers.isFunction;
	    var isDefined = leafletHelpers.isDefined;
	
	    function _isValidBounds(bounds) {
	      return angular.isDefined(bounds) && angular.isDefined(bounds.southWest) && angular.isDefined(bounds.northEast) && angular.isNumber(bounds.southWest.lat) && angular.isNumber(bounds.southWest.lng) && angular.isNumber(bounds.northEast.lat) && angular.isNumber(bounds.northEast.lng);
	    }
	
	    return {
	      createLeafletBounds: function createLeafletBounds(bounds) {
	        if (_isValidBounds(bounds)) {
	          return L.latLngBounds([bounds.southWest.lat, bounds.southWest.lng], [bounds.northEast.lat, bounds.northEast.lng]);
	        }
	      },
	
	      isValidBounds: _isValidBounds,
	
	      createBoundsFromArray: function createBoundsFromArray(boundsArray) {
	        if (!(isArray(boundsArray) && boundsArray.length === 2 && isArray(boundsArray[0]) && isArray(boundsArray[1]) && boundsArray[0].length === 2 && boundsArray[1].length === 2 && isNumber(boundsArray[0][0]) && isNumber(boundsArray[0][1]) && isNumber(boundsArray[1][0]) && isNumber(boundsArray[1][1]))) {
	          $log.error('[AngularJS - Leaflet] The bounds array is not valid.');
	          return;
	        }
	
	        return {
	          northEast: {
	            lat: boundsArray[0][0],
	            lng: boundsArray[0][1]
	          },
	          southWest: {
	            lat: boundsArray[1][0],
	            lng: boundsArray[1][1]
	          }
	        };
	      },
	
	      createBoundsFromLeaflet: function createBoundsFromLeaflet(lfBounds) {
	        if (!(isDefined(lfBounds) && isFunction(lfBounds.getNorthEast) && isFunction(lfBounds.getSouthWest))) {
	          $log.error('[AngularJS - Leaflet] The leaflet bounds is not valid object.');
	          return;
	        }
	
	        var northEast = lfBounds.getNorthEast();
	        var southWest = lfBounds.getSouthWest();
	
	        return {
	          northEast: {
	            lat: northEast.lat,
	            lng: northEast.lng
	          },
	          southWest: {
	            lat: southWest.lat,
	            lng: southWest.lng
	          }
	        };
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletControlHelpers', ["$rootScope", "$log", "leafletHelpers", "leafletLayerHelpers", "leafletMapDefaults", function ($rootScope, $log, leafletHelpers, leafletLayerHelpers, leafletMapDefaults) {
	    var isDefined = leafletHelpers.isDefined;
	    var isObject = leafletHelpers.isObject;
	    var createLayer = leafletLayerHelpers.createLayer;
	    var _controls = {};
	    var errorHeader = leafletHelpers.errorHeader + ' [Controls] ';
	
	    var _controlLayersMustBeVisible = function _controlLayersMustBeVisible(baselayers, overlays, mapId) {
	      var defaults = leafletMapDefaults.getDefaults(mapId);
	      if (!defaults.controls.layers.visible) {
	        return false;
	      }
	
	      var atLeastOneControlItemMustBeShown = false;
	
	      if (isObject(baselayers)) {
	        Object.keys(baselayers).forEach(function (key) {
	          var layer = baselayers[key];
	          if (!isDefined(layer.layerOptions) || layer.layerOptions.showOnSelector !== false) {
	            atLeastOneControlItemMustBeShown = true;
	          }
	        });
	      }
	
	      if (isObject(overlays)) {
	        Object.keys(overlays).forEach(function (key) {
	          var layer = overlays[key];
	          if (!isDefined(layer.layerParams) || layer.layerParams.showOnSelector !== false) {
	            atLeastOneControlItemMustBeShown = true;
	          }
	        });
	      }
	
	      return atLeastOneControlItemMustBeShown;
	    };
	
	    var _createLayersControl = function _createLayersControl(mapId) {
	      var defaults = leafletMapDefaults.getDefaults(mapId);
	      var controlOptions = {
	        collapsed: defaults.controls.layers.collapsed,
	        position: defaults.controls.layers.position,
	        autoZIndex: false
	      };
	
	      angular.extend(controlOptions, defaults.controls.layers.options);
	
	      var control;
	      if (defaults.controls.layers && isDefined(defaults.controls.layers.control)) {
	        control = defaults.controls.layers.control.apply(this, [[], [], controlOptions]);
	      } else {
	        control = new L.control.layers([], [], controlOptions);
	      }
	
	      return control;
	    };
	
	    var controlTypes = {
	      draw: {
	        isPluginLoaded: function isPluginLoaded() {
	          if (!angular.isDefined(L.Control.Draw)) {
	            $log.error(errorHeader + ' Draw plugin is not loaded.');
	            return false;
	          }
	
	          return true;
	        },
	
	        checkValidParams: function checkValidParams() /* params */{
	          return true;
	        },
	
	        createControl: function createControl(params) {
	          return new L.Control.Draw(params);
	        }
	      },
	      scale: {
	        isPluginLoaded: function isPluginLoaded() {
	          return true;
	        },
	
	        checkValidParams: function checkValidParams() /* params */{
	          return true;
	        },
	
	        createControl: function createControl(params) {
	          return new L.control.scale(params);
	        }
	      },
	      fullscreen: {
	        isPluginLoaded: function isPluginLoaded() {
	          if (!angular.isDefined(L.Control.Fullscreen)) {
	            $log.error(errorHeader + ' Fullscreen plugin is not loaded.');
	            return false;
	          }
	
	          return true;
	        },
	
	        checkValidParams: function checkValidParams() /* params */{
	          return true;
	        },
	
	        createControl: function createControl(params) {
	          return new L.Control.Fullscreen(params);
	        }
	      },
	      search: {
	        isPluginLoaded: function isPluginLoaded() {
	          if (!angular.isDefined(L.Control.Search)) {
	            $log.error(errorHeader + ' Search plugin is not loaded.');
	            return false;
	          }
	
	          return true;
	        },
	
	        checkValidParams: function checkValidParams() /* params */{
	          return true;
	        },
	
	        createControl: function createControl(params) {
	          return new L.Control.Search(params);
	        }
	      },
	      custom: {},
	      minimap: {
	        isPluginLoaded: function isPluginLoaded() {
	          if (!angular.isDefined(L.Control.MiniMap)) {
	            $log.error(errorHeader + ' Minimap plugin is not loaded.');
	            return false;
	          }
	
	          return true;
	        },
	
	        checkValidParams: function checkValidParams(params) {
	          if (!isDefined(params.layer)) {
	            $log.warn(errorHeader + ' minimap "layer" option should be defined.');
	            return false;
	          }
	
	          return true;
	        },
	
	        createControl: function createControl(params) {
	          var layer = createLayer(params.layer);
	
	          if (!isDefined(layer)) {
	            $log.warn(errorHeader + ' minimap control "layer" could not be created.');
	            return;
	          }
	
	          return new L.Control.MiniMap(layer, params);
	        }
	      }
	    };
	
	    return {
	      layersControlMustBeVisible: _controlLayersMustBeVisible,
	
	      isValidControlType: function isValidControlType(type) {
	        return Object.keys(controlTypes).indexOf(type) !== -1;
	      },
	
	      createControl: function createControl(type, params) {
	        if (!controlTypes[type].checkValidParams(params)) {
	          return;
	        }
	
	        return controlTypes[type].createControl(params);
	      },
	
	      updateLayersControl: function updateLayersControl(map, mapId, loaded, baselayers, overlays, leafletLayers) {
	        var i;
	        var _layersControl = _controls[mapId];
	        var mustBeLoaded = _controlLayersMustBeVisible(baselayers, overlays, mapId);
	
	        if (isDefined(_layersControl) && loaded) {
	          for (i in leafletLayers.baselayers) {
	            _layersControl.removeLayer(leafletLayers.baselayers[i]);
	          }
	
	          for (i in leafletLayers.overlays) {
	            _layersControl.removeLayer(leafletLayers.overlays[i]);
	          }
	
	          map.removeControl(_layersControl);
	          delete _controls[mapId];
	        }
	
	        if (mustBeLoaded) {
	          _layersControl = _createLayersControl(mapId);
	          _controls[mapId] = _layersControl;
	          for (i in baselayers) {
	            var hideOnSelector = isDefined(baselayers[i].layerOptions) && baselayers[i].layerOptions.showOnSelector === false;
	            if (!hideOnSelector && isDefined(leafletLayers.baselayers[i])) {
	              _layersControl.addBaseLayer(leafletLayers.baselayers[i], baselayers[i].name);
	            }
	          }
	
	          for (i in overlays) {
	            var hideOverlayOnSelector = isDefined(overlays[i].layerParams) && overlays[i].layerParams.showOnSelector === false;
	            if (!hideOverlayOnSelector && isDefined(leafletLayers.overlays[i])) {
	              _layersControl.addOverlay(leafletLayers.overlays[i], overlays[i].name);
	            }
	          }
	
	          map.addControl(_layersControl);
	        }
	
	        return mustBeLoaded;
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletData', ["$log", "$q", "leafletHelpers", function ($log, $q, leafletHelpers) {
	    var getDefer = leafletHelpers.getDefer,
	        getUnresolvedDefer = leafletHelpers.getUnresolvedDefer,
	        setResolvedDefer = leafletHelpers.setResolvedDefer;
	
	    var _private = {};
	    var self = this;
	
	    var upperFirst = function upperFirst(string) {
	      return string.charAt(0).toUpperCase() + string.slice(1);
	    };
	
	    var _privateItems = ['map', 'tiles', 'layers', 'paths', 'markers', 'geoJSON', 'UTFGrid', //odd ball on naming convention keeping to not break
	    'decorations', 'directiveControls'];
	
	    //init
	    _privateItems.forEach(function (itemName) {
	      _private[itemName] = {};
	    });
	
	    this.unresolveMap = function (scopeId) {
	      var id = leafletHelpers.obtainEffectiveMapId(_private.map, scopeId);
	      _privateItems.forEach(function (itemName) {
	        _private[itemName][id] = undefined;
	      });
	    };
	
	    //int repetitive stuff (get and sets)
	    _privateItems.forEach(function (itemName) {
	      var name = upperFirst(itemName);
	      self['set' + name] = function (lObject, scopeId) {
	        var defer = getUnresolvedDefer(_private[itemName], scopeId);
	        defer.resolve(lObject);
	        setResolvedDefer(_private[itemName], scopeId);
	      };
	
	      self['get' + name] = function (scopeId) {
	        var defer = getDefer(_private[itemName], scopeId);
	        return defer.promise;
	      };
	    });
	  }]);
	
	  angular.module('leaflet-directive').service('leafletDirectiveControlsHelpers', ["$log", "leafletData", "leafletHelpers", function ($log, leafletData, leafletHelpers) {
	    var _isDefined = leafletHelpers.isDefined;
	    var _isString = leafletHelpers.isString;
	    var _isObject = leafletHelpers.isObject;
	    var _mainErrorHeader = leafletHelpers.errorHeader;
	
	    var _errorHeader = _mainErrorHeader + '[leafletDirectiveControlsHelpers';
	
	    var _extend = function _extend(id, thingToAddName, createFn, cleanFn) {
	      var _fnHeader = _errorHeader + '.extend] ';
	      var extender = {};
	      if (!_isDefined(thingToAddName)) {
	        $log.error(_fnHeader + 'thingToAddName cannot be undefined');
	        return;
	      }
	
	      if (_isString(thingToAddName) && _isDefined(createFn) && _isDefined(cleanFn)) {
	        extender[thingToAddName] = {
	          create: createFn,
	          clean: cleanFn
	        };
	      } else if (_isObject(thingToAddName) && !_isDefined(createFn) && !_isDefined(cleanFn)) {
	        extender = thingToAddName;
	      } else {
	        $log.error(_fnHeader + 'incorrect arguments');
	        return;
	      }
	
	      //add external control to create / destroy markers without a watch
	      leafletData.getDirectiveControls().then(function (controls) {
	        angular.extend(controls, extender);
	        leafletData.setDirectiveControls(controls, id);
	      });
	    };
	
	    return {
	      extend: _extend
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletGeoJsonHelpers', ["leafletHelpers", "leafletIterators", function (leafletHelpers, leafletIterators) {
	    var lHlp = leafletHelpers;
	    var lIt = leafletIterators;
	    var Point = function Point(lat, lng) {
	      this.lat = lat;
	      this.lng = lng;
	      return this;
	    };
	
	    var _getLat = function _getLat(value) {
	      if (Array.isArray(value) && value.length === 2) {
	        return value[1];
	      } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
	        return +value.coordinates[1];
	      } else {
	        return +value.lat;
	      }
	    };
	
	    var _getLng = function _getLng(value) {
	      if (Array.isArray(value) && value.length === 2) {
	        return value[0];
	      } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
	        return +value.coordinates[0];
	      } else {
	        return +value.lng;
	      }
	    };
	
	    var _validateCoords = function _validateCoords(coords) {
	      if (lHlp.isUndefined(coords)) {
	        return false;
	      }
	
	      if (lHlp.isArray(coords)) {
	        if (coords.length === 2 && lHlp.isNumber(coords[0]) && lHlp.isNumber(coords[1])) {
	          return true;
	        }
	      } else if (lHlp.isDefined(coords.type)) {
	        if (coords.type === 'Point' && lHlp.isArray(coords.coordinates) && coords.coordinates.length === 2 && lHlp.isNumber(coords.coordinates[0]) && lHlp.isNumber(coords.coordinates[1])) {
	          return true;
	        }
	      }
	
	      var ret = lIt.all(['lat', 'lng'], function (pos) {
	        return lHlp.isDefined(coords[pos]) && lHlp.isNumber(coords[pos]);
	      });
	
	      return ret;
	    };
	
	    var _getCoords = function _getCoords(value) {
	      if (!value || !_validateCoords(value)) {
	        return;
	      }
	
	      var p = null;
	      if (Array.isArray(value) && value.length === 2) {
	        p = new Point(value[1], value[0]);
	      } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
	        p = new Point(value.coordinates[1], value.coordinates[0]);
	      } else {
	        return value;
	      }
	
	      //note angular.merge is avail in angular 1.4.X we might want to fill it here
	      return angular.extend(value, p); //tap on lat, lng if it doesnt exist
	    };
	
	    return {
	      getLat: _getLat,
	      getLng: _getLng,
	      validateCoords: _validateCoords,
	      getCoords: _getCoords
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletHelpers', ["$q", "$log", function ($q, $log) {
	    var _errorHeader = '[AngularJS - Leaflet] ';
	    var _copy = angular.copy;
	    var _clone = _copy;
	    /*
	    For parsing paths to a field in an object
	     Example:
	    var obj = {
	        bike:{
	         1: 'hi'
	         2: 'foo'
	        }
	    };
	    _getObjectValue(obj,"bike.1") returns 'hi'
	    this is getPath in ui-gmap
	     */
	    var _getObjectValue = function _getObjectValue(object, pathStr) {
	      var obj;
	      if (!object || !angular.isObject(object)) return;
	
	      //if the key is not a sting then we already have the value
	      if (pathStr === null || !angular.isString(pathStr)) {
	        return pathStr;
	      }
	
	      obj = object;
	      pathStr.split('.').forEach(function (value) {
	        if (obj) {
	          obj = obj[value];
	        }
	      });
	
	      return obj;
	    };
	
	    /*
	     Object Array Notation
	     _getObjectArrayPath("bike.one.two")
	     returns:
	     'bike["one"]["two"]'
	     */
	    var _getObjectArrayPath = function _getObjectArrayPath(pathStr) {
	      return pathStr.split('.').reduce(function (previous, current) {
	        return previous + '["' + current + '"]';
	      });
	    };
	
	    /* Object Dot Notation
	     _getObjectPath(["bike","one","two"])
	     returns:
	     "bike.one.two"
	     */
	    var _getObjectDotPath = function _getObjectDotPath(arrayOfStrings) {
	      return arrayOfStrings.reduce(function (previous, current) {
	        return previous + '.' + current;
	      });
	    };
	
	    function _obtainEffectiveMapId(d, mapId) {
	      var id;
	      var i;
	      if (!angular.isDefined(mapId)) {
	        if (Object.keys(d).length === 0) {
	          id = 'main';
	        } else if (Object.keys(d).length >= 1) {
	          for (i in d) {
	            if (d.hasOwnProperty(i)) {
	              id = i;
	            }
	          }
	        } else {
	          $log.error(_errorHeader + '- You have more than 1 map on the DOM, you must provide the map ID to the leafletData.getXXX call');
	        }
	      } else {
	        id = mapId;
	      }
	
	      return id;
	    }
	
	    function _getUnresolvedDefer(d, mapId) {
	      var id = _obtainEffectiveMapId(d, mapId);
	      var defer;
	
	      if (!angular.isDefined(d[id]) || d[id].resolvedDefer === true) {
	        defer = $q.defer();
	        d[id] = {
	          defer: defer,
	          resolvedDefer: false
	        };
	      } else {
	        defer = d[id].defer;
	      }
	
	      return defer;
	    }
	
	    var _isDefined = function _isDefined(value) {
	      return angular.isDefined(value) && value !== null;
	    };
	
	    var _isUndefined = function _isUndefined(value) {
	      return !_isDefined(value);
	    };
	
	    // BEGIN DIRECT PORT FROM AngularJS code base
	
	    var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	
	    var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	
	    var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	
	    /**
	    Converts snake_case to camelCase.
	    Also there is special case for Moz prefix starting with upper case letter.
	    @param name Name to normalize
	     */
	
	    var camelCase = function camelCase(name) {
	      return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
	        if (offset) {
	          return letter.toUpperCase();
	        } else {
	          return letter;
	        }
	      }).replace(MOZ_HACK_REGEXP, 'Moz$1');
	    };
	
	    /**
	    Converts all accepted directives format into proper directive name.
	    @param name Name to normalize
	     */
	
	    var directiveNormalize = function directiveNormalize(name) {
	      return camelCase(name.replace(PREFIX_REGEXP, ''));
	    };
	
	    // END AngularJS port
	
	    return {
	      camelCase: camelCase,
	      directiveNormalize: directiveNormalize,
	      copy: _copy,
	      clone: _clone,
	      errorHeader: _errorHeader,
	      getObjectValue: _getObjectValue,
	      getObjectArrayPath: _getObjectArrayPath,
	      getObjectDotPath: _getObjectDotPath,
	      defaultTo: function defaultTo(val, _default) {
	        return _isDefined(val) ? val : _default;
	      },
	
	      //mainly for checking attributes of directives lets keep this minimal (on what we accept)
	      isTruthy: function isTruthy(val) {
	        return val === 'true' || val === true;
	      },
	
	      //Determine if a reference is {}
	      isEmpty: function isEmpty(value) {
	        return Object.keys(value).length === 0;
	      },
	
	      //Determine if a reference is undefined or {}
	      isUndefinedOrEmpty: function isUndefinedOrEmpty(value) {
	        return angular.isUndefined(value) || value === null || Object.keys(value).length === 0;
	      },
	
	      // Determine if a reference is defined
	      isDefined: _isDefined,
	      isUndefined: _isUndefined,
	      isNumber: angular.isNumber,
	      isString: angular.isString,
	      isArray: angular.isArray,
	      isObject: angular.isObject,
	      isFunction: angular.isFunction,
	      equals: angular.equals,
	
	      isValidCenter: function isValidCenter(center) {
	        return angular.isDefined(center) && angular.isNumber(center.lat) && angular.isNumber(center.lng) && angular.isNumber(center.zoom);
	      },
	
	      isValidPoint: function isValidPoint(point) {
	        if (!angular.isDefined(point)) {
	          return false;
	        }
	
	        if (angular.isArray(point)) {
	          return point.length === 2 && angular.isNumber(point[0]) && angular.isNumber(point[1]);
	        }
	
	        return angular.isNumber(point.lat) && angular.isNumber(point.lng);
	      },
	
	      isSameCenterOnMap: function isSameCenterOnMap(centerModel, map) {
	        var mapCenter = map.getCenter();
	        var zoom = map.getZoom();
	        if (centerModel.lat && centerModel.lng && mapCenter.lat.toFixed(4) === centerModel.lat.toFixed(4) && mapCenter.lng.toFixed(4) === centerModel.lng.toFixed(4) && zoom === centerModel.zoom) {
	          return true;
	        }
	
	        return false;
	      },
	
	      safeApply: function safeApply($scope, fn) {
	        var phase = $scope.$root.$$phase;
	        if (phase === '$apply' || phase === '$digest') {
	          $scope.$eval(fn);
	        } else {
	          $scope.$evalAsync(fn);
	        }
	      },
	
	      obtainEffectiveMapId: _obtainEffectiveMapId,
	
	      getDefer: function getDefer(d, mapId) {
	        var id = _obtainEffectiveMapId(d, mapId);
	        var defer;
	        if (!angular.isDefined(d[id]) || d[id].resolvedDefer === false) {
	          defer = _getUnresolvedDefer(d, mapId);
	        } else {
	          defer = d[id].defer;
	        }
	
	        return defer;
	      },
	
	      getUnresolvedDefer: _getUnresolvedDefer,
	
	      setResolvedDefer: function setResolvedDefer(d, mapId) {
	        var id = _obtainEffectiveMapId(d, mapId);
	        d[id].resolvedDefer = true;
	      },
	
	      rangeIsSupported: function rangeIsSupported() {
	        var testrange = document.createElement('input');
	        testrange.setAttribute('type', 'range');
	        return testrange.type === 'range';
	      },
	
	      FullScreenControlPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.Control.Fullscreen);
	        }
	      },
	
	      MiniMapControlPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.Control.MiniMap);
	        }
	      },
	
	      AwesomeMarkersPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.AwesomeMarkers) && angular.isDefined(L.AwesomeMarkers.Icon);
	        },
	
	        is: function is(icon) {
	          if (this.isLoaded()) {
	            return icon instanceof L.AwesomeMarkers.Icon;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(iconA, iconB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        }
	      },
	
	      VectorMarkersPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.VectorMarkers) && angular.isDefined(L.VectorMarkers.Icon);
	        },
	
	        is: function is(icon) {
	          if (this.isLoaded()) {
	            return icon instanceof L.VectorMarkers.Icon;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(iconA, iconB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        }
	      },
	
	      DomMarkersPlugin: {
	        isLoaded: function isLoaded() {
	          if (angular.isDefined(L.DomMarkers) && angular.isDefined(L.DomMarkers.Icon)) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	
	        is: function is(icon) {
	          if (this.isLoaded()) {
	            return icon instanceof L.DomMarkers.Icon;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(iconA, iconB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        }
	      },
	
	      PolylineDecoratorPlugin: {
	        isLoaded: function isLoaded() {
	          if (angular.isDefined(L.PolylineDecorator)) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	
	        is: function is(decoration) {
	          if (this.isLoaded()) {
	            return decoration instanceof L.PolylineDecorator;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(decorationA, decorationB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(decorationA)) {
	            return angular.equals(decorationA, decorationB);
	          } else {
	            return false;
	          }
	        }
	      },
	
	      MakiMarkersPlugin: {
	        isLoaded: function isLoaded() {
	          if (angular.isDefined(L.MakiMarkers) && angular.isDefined(L.MakiMarkers.Icon)) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	
	        is: function is(icon) {
	          if (this.isLoaded()) {
	            return icon instanceof L.MakiMarkers.Icon;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(iconA, iconB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        }
	      },
	      ExtraMarkersPlugin: {
	        isLoaded: function isLoaded() {
	          if (angular.isDefined(L.ExtraMarkers) && angular.isDefined(L.ExtraMarkers.Icon)) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	
	        is: function is(icon) {
	          if (this.isLoaded()) {
	            return icon instanceof L.ExtraMarkers.Icon;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(iconA, iconB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        }
	      },
	      LabelPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.Label);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.MarkerClusterGroup;
	          } else {
	            return false;
	          }
	        }
	      },
	      MarkerClusterPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.MarkerClusterGroup);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.MarkerClusterGroup;
	          } else {
	            return false;
	          }
	        }
	      },
	      GoogleLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.Google);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.Google;
	          } else {
	            return false;
	          }
	        }
	      },
	      LeafletProviderPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.TileLayer.Provider);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.TileLayer.Provider;
	          } else {
	            return false;
	          }
	        }
	      },
	      ChinaLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.tileLayer.chinaProvider);
	        }
	      },
	      HeatLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.heatLayer);
	        }
	      },
	      WebGLHeatMapLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.TileLayer.WebGLHeatMap);
	        }
	      },
	      BingLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.BingLayer);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.BingLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      WFSLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.GeoJSON.WFS !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.GeoJSON.WFS;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSBaseLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.basemapLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.basemapLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return lvector !== undefined && lvector.AGS !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof lvector.AGS;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSFeatureLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.featureLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.featureLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSTiledMapLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.tiledMapLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.tiledMapLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSDynamicMapLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.dynamicMapLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.dynamicMapLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSImageMapLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.imageMapLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.imageMapLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSClusteredLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.clusteredFeatureLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.clusteredFeatureLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSHeatmapLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.heatmapFeatureLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.heatmapFeatureLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      YandexLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.Yandex);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.Yandex;
	          } else {
	            return false;
	          }
	        }
	      },
	      GeoJSONPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.TileLayer.GeoJSON);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.TileLayer.GeoJSON;
	          } else {
	            return false;
	          }
	        }
	      },
	      UTFGridPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.UtfGrid);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.UtfGrid;
	          } else {
	            $log.error('[AngularJS - Leaflet] No UtfGrid plugin found.');
	            return false;
	          }
	        }
	      },
	      CartoDB: {
	        isLoaded: function isLoaded() {
	          return cartodb;
	        },
	
	        is: function is() /*layer*/{
	          return true;
	          /*
	          if (this.isLoaded()) {
	              return layer instanceof L.TileLayer.GeoJSON;
	          } else {
	              return false;
	          }*/
	        }
	      },
	      Leaflet: {
	        DivIcon: {
	          is: function is(icon) {
	            return icon instanceof L.DivIcon;
	          },
	
	          equal: function equal(iconA, iconB) {
	            if (this.is(iconA)) {
	              return angular.equals(iconA, iconB);
	            } else {
	              return false;
	            }
	          }
	        },
	        Icon: {
	          is: function is(icon) {
	            return icon instanceof L.Icon;
	          },
	
	          equal: function equal(iconA, iconB) {
	            if (this.is(iconA)) {
	              return angular.equals(iconA, iconB);
	            } else {
	              return false;
	            }
	          }
	        }
	      },
	      /*
	       watchOptions - object to set deep nested watches and turn off watches all together
	       (rely on control / functional updates)
	       watchOptions - Object
	           doWatch:boolean
	           isDeep:boolean (sets $watch(function,isDeep))
	           individual
	               doWatch:boolean
	               isDeep:boolean
	       */
	
	      //legacy defaults
	      watchOptions: {
	        doWatch: true,
	        isDeep: true,
	        individual: {
	          doWatch: true,
	          isDeep: true
	        }
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletIterators', ["$log", "leafletHelpers", function ($log, leafletHelpers) {
	
	    var lHlp = leafletHelpers;
	    var errorHeader = leafletHelpers.errorHeader + 'leafletIterators: ';
	
	    //BEGIN COPY from underscore
	    var _keys = Object.keys;
	    var _isFunction = lHlp.isFunction;
	    var _isObject = lHlp.isObject;
	
	    // Helper for collection methods to determine whether a collection
	    // should be iterated as an array or as an object
	    // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	    var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	    var _isArrayLike = function _isArrayLike(collection) {
	      var length = collection !== null && collection.length;
	      return lHlp.isNumber(length) && length >= 0 && length <= MAX_ARRAY_INDEX;
	    };
	
	    // Keep the identity function around for default iteratees.
	    var _identity = function _identity(value) {
	      return value;
	    };
	
	    var _property = function _property(key) {
	      return function (obj) {
	        return obj === null ? void 0 : obj[key];
	      };
	    };
	
	    // Internal function that returns an efficient (for current engines) version
	    // of the passed-in callback, to be repeatedly applied in other Underscore
	    // functions.
	    var optimizeCb = function optimizeCb(func, context, argCount) {
	      if (context === void 0) return func;
	      switch (argCount === null ? 3 : argCount) {
	        case 1:
	          return function (value) {
	            return func.call(context, value);
	          };
	
	        case 2:
	          return function (value, other) {
	            return func.call(context, value, other);
	          };
	
	        case 3:
	          return function (value, index, collection) {
	            return func.call(context, value, index, collection);
	          };
	
	        case 4:
	          return function (accumulator, value, index, collection) {
	            return func.call(context, accumulator, value, index, collection);
	          };
	      }
	      return function () {
	        return func.apply(context, arguments);
	      };
	    };
	
	    // An internal function for creating assigner functions.
	    var createAssigner = function createAssigner(keysFunc, undefinedOnly) {
	      return function (obj) {
	        var length = arguments.length;
	        if (length < 2 || obj === null) return obj;
	        for (var index = 1; index < length; index++) {
	          var source = arguments[index];
	          var keys = keysFunc(source);
	          var l = keys.length;
	
	          for (var i = 0; i < l; i++) {
	            var key = keys[i];
	            if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	          }
	        }
	
	        return obj;
	      };
	    };
	
	    // Assigns a given object with all the own properties in the passed-in object(s)
	    // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	    var _extendOwn;
	    var _assign = null;
	    _extendOwn = _assign = createAssigner(_keys);
	
	    // Returns whether an object has a given set of `key:value` pairs.
	    var _isMatch = function _isMatch(object, attrs) {
	      var keys = _keys(attrs);
	      var length = keys.length;
	      if (object === null) return !length;
	      var obj = Object(object);
	      for (var i = 0; i < length; i++) {
	        var key = keys[i];
	        if (attrs[key] !== obj[key] || !(key in obj)) return false;
	      }
	
	      return true;
	    };
	
	    // Returns a predicate for checking whether an object has a given set of
	    // `key:value` pairs.
	    var _matcher;
	    var _matches = null;
	    _matcher = _matches = function _matches(attrs) {
	      attrs = _extendOwn({}, attrs);
	      return function (obj) {
	        return _isMatch(obj, attrs);
	      };
	    };
	
	    // A mostly-internal function to generate callbacks that can be applied
	    // to each element in a collection, returning the desired result — either
	    // identity, an arbitrary callback, a property matcher, or a property accessor.
	    var cb = function cb(value, context, argCount) {
	      if (value === null) return _identity;
	      if (_isFunction(value)) return optimizeCb(value, context, argCount);
	      if (_isObject(value)) return _matcher(value);
	      return _property(value);
	    };
	
	    var _every;
	    var _all = null;
	    _every = _all = function _all(obj, predicate, context) {
	      predicate = cb(predicate, context);
	      var keys = !_isArrayLike(obj) && _keys(obj);
	      var length = (keys || obj).length;
	      for (var index = 0; index < length; index++) {
	        var currentKey = keys ? keys[index] : index;
	        if (!predicate(obj[currentKey], currentKey, obj)) return false;
	      }
	
	      return true;
	    };
	
	    //END COPY fron underscore
	
	    var _hasErrors = function _hasErrors(collection, cb, ignoreCollection, cbName) {
	      if (!ignoreCollection) {
	        if (!lHlp.isDefined(collection) || !lHlp.isDefined(cb)) {
	          return true;
	        }
	      }
	
	      if (!lHlp.isFunction(cb)) {
	        cbName = lHlp.defaultTo(cb, 'cb');
	        $log.error(errorHeader + cbName + ' is not a function');
	        return true;
	      }
	
	      return false;
	    };
	
	    var _iterate = function _iterate(collection, externalCb, internalCb) {
	      if (_hasErrors(undefined, internalCb, true, 'internalCb')) {
	        return;
	      }
	
	      if (!_hasErrors(collection, externalCb)) {
	        for (var key in collection) {
	          if (collection.hasOwnProperty(key)) {
	            internalCb(collection[key], key);
	          }
	        }
	      }
	    };
	
	    //see http://jsperf.com/iterators/3
	    //utilizing for in is way faster
	    var _each = function _each(collection, cb) {
	      _iterate(collection, cb, function (val, key) {
	        cb(val, key);
	      });
	    };
	
	    return {
	      each: _each,
	      forEach: _each,
	      every: _every,
	      all: _all
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletLayerHelpers', ["$rootScope", "$log", "$q", "leafletHelpers", "leafletIterators", function ($rootScope, $log, $q, leafletHelpers, leafletIterators) {
	    var Helpers = leafletHelpers;
	    var isString = leafletHelpers.isString;
	    var isObject = leafletHelpers.isObject;
	    var isArray = leafletHelpers.isArray;
	    var isDefined = leafletHelpers.isDefined;
	    var errorHeader = leafletHelpers.errorHeader;
	    var $it = leafletIterators;
	
	    var utfGridCreateLayer = function utfGridCreateLayer(params) {
	      if (!Helpers.UTFGridPlugin.isLoaded()) {
	        $log.error('[AngularJS - Leaflet] The UTFGrid plugin is not loaded.');
	        return;
	      }
	
	      var utfgrid = new L.UtfGrid(params.url, params.pluginOptions);
	
	      utfgrid.on('mouseover', function (e) {
	        $rootScope.$broadcast('leafletDirectiveMap.utfgridMouseover', e);
	      });
	
	      utfgrid.on('mouseout', function (e) {
	        $rootScope.$broadcast('leafletDirectiveMap.utfgridMouseout', e);
	      });
	
	      utfgrid.on('click', function (e) {
	        $rootScope.$broadcast('leafletDirectiveMap.utfgridClick', e);
	      });
	
	      utfgrid.on('mousemove', function (e) {
	        $rootScope.$broadcast('leafletDirectiveMap.utfgridMousemove', e);
	      });
	
	      return utfgrid;
	    };
	
	    var layerTypes = {
	      xyz: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          return L.tileLayer(params.url, params.options);
	        }
	      },
	      mapbox: {
	        mustHaveKey: true,
	        createLayer: function createLayer(params) {
	          var version = 3;
	          if (isDefined(params.options.version) && params.options.version === 4) {
	            version = params.options.version;
	          }
	
	          var url = version === 3 ? '//{s}.tiles.mapbox.com/v3/' + params.key + '/{z}/{x}/{y}.png' : '//api.tiles.mapbox.com/v4/' + params.key + '/{z}/{x}/{y}.png?access_token=' + params.apiKey;
	          return L.tileLayer(url, params.options);
	        }
	      },
	      geoJSON: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.GeoJSONPlugin.isLoaded()) {
	            return;
	          }
	
	          return new L.TileLayer.GeoJSON(params.url, params.pluginOptions, params.options);
	        }
	      },
	      geoJSONShape: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          return new L.GeoJSON(params.data, params.options);
	        }
	      },
	      geoJSONAwesomeMarker: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          return new L.geoJson(params.data, {
	            pointToLayer: function pointToLayer(feature, latlng) {
	              return L.marker(latlng, { icon: L.AwesomeMarkers.icon(params.icon) });
	            }
	          });
	        }
	      },
	      geoJSONVectorMarker: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          return new L.geoJson(params.data, {
	            pointToLayer: function pointToLayer(feature, latlng) {
	              return L.marker(latlng, { icon: L.VectorMarkers.icon(params.icon) });
	            }
	          });
	        }
	      },
	      utfGrid: {
	        mustHaveUrl: true,
	        createLayer: utfGridCreateLayer
	      },
	      cartodbTiles: {
	        mustHaveKey: true,
	        createLayer: function createLayer(params) {
	          var url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/{z}/{x}/{y}.png';
	          return L.tileLayer(url, params.options);
	        }
	      },
	      cartodbUTFGrid: {
	        mustHaveKey: true,
	        mustHaveLayer: true,
	        createLayer: function createLayer(params) {
	          params.url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/' + params.layer + '/{z}/{x}/{y}.grid.json';
	          return utfGridCreateLayer(params);
	        }
	      },
	      cartodbInteractive: {
	        mustHaveKey: true,
	        mustHaveLayer: true,
	        createLayer: function createLayer(params) {
	          var tilesURL = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/{z}/{x}/{y}.png';
	          var tileLayer = L.tileLayer(tilesURL, params.options);
	          params.url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/' + params.layer + '/{z}/{x}/{y}.grid.json';
	          var utfLayer = utfGridCreateLayer(params);
	          return L.layerGroup([tileLayer, utfLayer]);
	        }
	      },
	      wms: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          return L.tileLayer.wms(params.url, params.options);
	        }
	      },
	      wmts: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          return L.tileLayer.wmts(params.url, params.options);
	        }
	      },
	      wfs: {
	        mustHaveUrl: true,
	        mustHaveLayer: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.WFSLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          var options = angular.copy(params.options);
	          if (options.crs && typeof options.crs === 'string') {
	            /*jshint -W061 */
	            options.crs = eval(options.crs);
	          }
	
	          return new L.GeoJSON.WFS(params.url, params.layer, options);
	        }
	      },
	      group: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          var lyrs = [];
	          $it.each(params.options.layers, function (l) {
	            lyrs.push(_createLayer(l));
	          });
	
	          params.options.loadedDefer = function () {
	            var defers = [];
	            if (isDefined(params.options.layers)) {
	              for (var i = 0; i < params.options.layers.length; i++) {
	                var d = params.options.layers[i].layerOptions.loadedDefer;
	                if (isDefined(d)) {
	                  defers.push(d);
	                }
	              }
	            }
	
	            return defers;
	          };
	
	          return L.layerGroup(lyrs);
	        }
	      },
	      featureGroup: {
	        mustHaveUrl: false,
	        createLayer: function createLayer() {
	          return L.featureGroup();
	        }
	      },
	      google: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          var type = params.type || 'SATELLITE';
	          if (!Helpers.GoogleLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          return new L.Google(type, params.options);
	        }
	      },
	      here: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          var provider = params.provider || 'HERE.terrainDay';
	          if (!Helpers.LeafletProviderPlugin.isLoaded()) {
	            return;
	          }
	
	          return new L.TileLayer.Provider(provider, params.options);
	        }
	      },
	      china: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          var type = params.type || '';
	          if (!Helpers.ChinaLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          return L.tileLayer.chinaProvider(type, params.options);
	        }
	      },
	      agsBase: {
	        mustHaveLayer: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSBaseLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          return L.esri.basemapLayer(params.layer, params.options);
	        }
	      },
	      ags: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          var options = angular.copy(params.options);
	          angular.extend(options, {
	            url: params.url
	          });
	          var layer = new lvector.AGS(options);
	          layer.onAdd = function (map) {
	            this.setMap(map);
	          };
	
	          layer.onRemove = function () {
	            this.setMap(null);
	          };
	
	          return layer;
	        }
	      },
	      agsFeature: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSFeatureLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri plugin is not loaded.');
	            return;
	          }
	
	          params.options.url = params.url;
	
	          var layer = L.esri.featureLayer(params.options);
	          var load = function load() {
	            if (isDefined(params.options.loadedDefer)) {
	              params.options.loadedDefer.resolve();
	            }
	          };
	
	          layer.on('loading', function () {
	            params.options.loadedDefer = $q.defer();
	            layer.off('load', load);
	            layer.on('load', load);
	          });
	
	          return layer;
	        }
	      },
	      agsTiled: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSTiledMapLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri plugin is not loaded.');
	            return;
	          }
	
	          params.options.url = params.url;
	
	          return L.esri.tiledMapLayer(params.options);
	        }
	      },
	      agsDynamic: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSDynamicMapLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri plugin is not loaded.');
	            return;
	          }
	
	          params.options.url = params.url;
	
	          return L.esri.dynamicMapLayer(params.options);
	        }
	      },
	      agsImage: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSImageMapLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri plugin is not loaded.');
	            return;
	          }
	
	          params.options.url = params.url;
	
	          return L.esri.imageMapLayer(params.options);
	        }
	      },
	      agsClustered: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSClusteredLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri clustered layer plugin is not loaded.');
	            return;
	          }
	
	          if (!Helpers.MarkerClusterPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The markercluster plugin is not loaded.');
	            return;
	          }
	
	          return L.esri.clusteredFeatureLayer(params.url, params.options);
	        }
	      },
	      agsHeatmap: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSHeatmapLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri heatmap layer plugin is not loaded.');
	            return;
	          }
	
	          if (!Helpers.HeatLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The heatlayer plugin is not loaded.');
	            return;
	          }
	
	          return L.esri.heatmapFeatureLayer(params.url, params.options);
	        }
	      },
	      markercluster: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          if (!Helpers.MarkerClusterPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The markercluster plugin is not loaded.');
	            return;
	          }
	
	          return new L.MarkerClusterGroup(params.options);
	        }
	      },
	      bing: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          if (!Helpers.BingLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          return new L.BingLayer(params.key, params.options);
	        }
	      },
	      webGLHeatmap: {
	        mustHaveUrl: false,
	        mustHaveData: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.WebGLHeatMapLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          var layer = new L.TileLayer.WebGLHeatMap(params.options);
	          if (isDefined(params.data)) {
	            layer.setData(params.data);
	          }
	
	          return layer;
	        }
	      },
	      heat: {
	        mustHaveUrl: false,
	        mustHaveData: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.HeatLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          var layer = new L.heatLayer();
	
	          if (isArray(params.data)) {
	            layer.setLatLngs(params.data);
	          }
	
	          if (isObject(params.options)) {
	            layer.setOptions(params.options);
	          }
	
	          return layer;
	        }
	      },
	      yandex: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          var type = params.type || 'map';
	          if (!Helpers.YandexLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          return new L.Yandex(type, params.options);
	        }
	      },
	      imageOverlay: {
	        mustHaveUrl: true,
	        mustHaveBounds: true,
	        createLayer: function createLayer(params) {
	          return L.imageOverlay(params.url, params.bounds, params.options);
	        }
	      },
	      iip: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          return L.tileLayer.iip(params.url, params.options);
	        }
	      },
	
	      // This "custom" type is used to accept every layer that user want to define himself.
	      // We can wrap these custom layers like heatmap or yandex, but it means a lot of work/code to wrap the world,
	      // so we let user to define their own layer outside the directive,
	      // and pass it on "createLayer" result for next processes
	      custom: {
	        createLayer: function createLayer(params) {
	          if (params.layer instanceof L.Class) {
	            return angular.copy(params.layer);
	          } else {
	            $log.error('[AngularJS - Leaflet] A custom layer must be a leaflet Class');
	          }
	        }
	      },
	      cartodb: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          return cartodb.createLayer(params.map, params.url);
	        }
	      }
	    };
	
	    function isValidLayerType(layerDefinition) {
	      // Check if the baselayer has a valid type
	      if (!isString(layerDefinition.type)) {
	        $log.error('[AngularJS - Leaflet] A layer must have a valid type defined.');
	        return false;
	      }
	
	      if (Object.keys(layerTypes).indexOf(layerDefinition.type) === -1) {
	        $log.error('[AngularJS - Leaflet] A layer must have a valid type: ' + Object.keys(layerTypes));
	        return false;
	      }
	
	      // Check if the layer must have an URL
	      if (layerTypes[layerDefinition.type].mustHaveUrl && !isString(layerDefinition.url)) {
	        $log.error('[AngularJS - Leaflet] A base layer must have an url');
	        return false;
	      }
	
	      if (layerTypes[layerDefinition.type].mustHaveData && !isDefined(layerDefinition.data)) {
	        $log.error('[AngularJS - Leaflet] The base layer must have a "data" array attribute');
	        return false;
	      }
	
	      if (layerTypes[layerDefinition.type].mustHaveLayer && !isDefined(layerDefinition.layer)) {
	        $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have an layer defined');
	        return false;
	      }
	
	      if (layerTypes[layerDefinition.type].mustHaveBounds && !isDefined(layerDefinition.bounds)) {
	        $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have bounds defined');
	        return false;
	      }
	
	      if (layerTypes[layerDefinition.type].mustHaveKey && !isDefined(layerDefinition.key)) {
	        $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have key defined');
	        return false;
	      }
	
	      return true;
	    }
	
	    function _createLayer(layerDefinition) {
	      if (!isValidLayerType(layerDefinition)) {
	        return;
	      }
	
	      if (!isString(layerDefinition.name)) {
	        $log.error('[AngularJS - Leaflet] A base layer must have a name');
	        return;
	      }
	
	      if (!isObject(layerDefinition.layerParams)) {
	        layerDefinition.layerParams = {};
	      }
	
	      if (!isObject(layerDefinition.layerOptions)) {
	        layerDefinition.layerOptions = {};
	      }
	
	      // Mix the layer specific parameters with the general Leaflet options. Although this is an overhead
	      // the definition of a base layers is more 'clean' if the two types of parameters are differentiated
	      for (var attrname in layerDefinition.layerParams) {
	        layerDefinition.layerOptions[attrname] = layerDefinition.layerParams[attrname];
	      }
	
	      var params = {
	        url: layerDefinition.url,
	        data: layerDefinition.data,
	        options: layerDefinition.layerOptions,
	        layer: layerDefinition.layer,
	        icon: layerDefinition.icon,
	        type: layerDefinition.layerType,
	        bounds: layerDefinition.bounds,
	        key: layerDefinition.key,
	        apiKey: layerDefinition.apiKey,
	        pluginOptions: layerDefinition.pluginOptions,
	        user: layerDefinition.user
	      };
	
	      //TODO Add $watch to the layer properties
	      return layerTypes[layerDefinition.type].createLayer(params);
	    }
	
	    function safeAddLayer(map, layer) {
	      if (layer && typeof layer.addTo === 'function') {
	        layer.addTo(map);
	      } else {
	        map.addLayer(layer);
	      }
	    }
	
	    function safeRemoveLayer(map, layer, layerOptions) {
	      if (isDefined(layerOptions) && isDefined(layerOptions.loadedDefer)) {
	        if (angular.isFunction(layerOptions.loadedDefer)) {
	          var defers = layerOptions.loadedDefer();
	          $log.debug('Loaded Deferred', defers);
	          var count = defers.length;
	          if (count > 0) {
	            var resolve = function resolve() {
	              count--;
	              if (count === 0) {
	                map.removeLayer(layer);
	              }
	            };
	
	            for (var i = 0; i < defers.length; i++) {
	              defers[i].promise.then(resolve);
	            }
	          } else {
	            map.removeLayer(layer);
	          }
	        } else {
	          layerOptions.loadedDefer.promise.then(function () {
	            map.removeLayer(layer);
	          });
	        }
	      } else {
	        map.removeLayer(layer);
	      }
	    }
	
	    return {
	      createLayer: _createLayer,
	      safeAddLayer: safeAddLayer,
	      safeRemoveLayer: safeRemoveLayer
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletLegendHelpers', function () {
	    var _updateLegend = function _updateLegend(div, legendData, type, url) {
	      div.innerHTML = '';
	      if (legendData.error) {
	        div.innerHTML += '<div class="info-title alert alert-danger">' + legendData.error.message + '</div>';
	      } else {
	        if (type === 'arcgis') {
	          for (var i = 0; i < legendData.layers.length; i++) {
	            var layer = legendData.layers[i];
	            div.innerHTML += '<div class="info-title" data-layerid="' + layer.layerId + '">' + layer.layerName + '</div>';
	            for (var j = 0; j < layer.legend.length; j++) {
	              var leg = layer.legend[j];
	              div.innerHTML += '<div class="inline" data-layerid="' + layer.layerId + '"><img src="data:' + leg.contentType + ';base64,' + leg.imageData + '" /></div>' + '<div class="info-label" data-layerid="' + layer.layerId + '">' + leg.label + '</div>';
	            }
	          }
	        } else if (type === 'image') {
	          div.innerHTML = '<img src="' + url + '"/>';
	        }
	      }
	    };
	
	    var _getOnAddLegend = function _getOnAddLegend(legendData, legendClass, type, url) {
	      return function () /*map*/{
	        var div = L.DomUtil.create('div', legendClass);
	
	        if (!L.Browser.touch) {
	          L.DomEvent.disableClickPropagation(div);
	          L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
	        } else {
	          L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
	        }
	
	        _updateLegend(div, legendData, type, url);
	        return div;
	      };
	    };
	
	    var _getOnAddArrayLegend = function _getOnAddArrayLegend(legend, legendClass) {
	      return function () /*map*/{
	        var div = L.DomUtil.create('div', legendClass);
	        for (var i = 0; i < legend.colors.length; i++) {
	          div.innerHTML += '<div class="outline"><i style="background:' + legend.colors[i] + '"></i></div>' + '<div class="info-label">' + legend.labels[i] + '</div>';
	        }
	
	        if (!L.Browser.touch) {
	          L.DomEvent.disableClickPropagation(div);
	          L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
	        } else {
	          L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
	        }
	
	        return div;
	      };
	    };
	
	    return {
	      getOnAddLegend: _getOnAddLegend,
	      getOnAddArrayLegend: _getOnAddArrayLegend,
	      updateLegend: _updateLegend
	    };
	  });
	
	  angular.module('leaflet-directive').factory('leafletMapDefaults', ["$q", "leafletHelpers", function ($q, leafletHelpers) {
	    function _getDefaults() {
	      return {
	        keyboard: true,
	        dragging: true,
	        worldCopyJump: false,
	        doubleClickZoom: true,
	        scrollWheelZoom: true,
	        tap: true,
	        touchZoom: true,
	        zoomControl: true,
	        zoomsliderControl: false,
	        zoomControlPosition: 'topleft',
	        attributionControl: true,
	        controls: {
	          layers: {
	            visible: true,
	            position: 'topright',
	            collapsed: true
	          }
	        },
	        nominatim: {
	          server: ' http://nominatim.openstreetmap.org/search'
	        },
	        crs: L.CRS.EPSG3857,
	        tileLayer: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
	        tileLayerOptions: {
	          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	        },
	        path: {
	          weight: 10,
	          opacity: 1,
	          color: '#0000ff'
	        },
	        center: {
	          lat: 0,
	          lng: 0,
	          zoom: 1
	        }
	      };
	    }
	
	    var isDefined = leafletHelpers.isDefined;
	    var isObject = leafletHelpers.isObject;
	    var obtainEffectiveMapId = leafletHelpers.obtainEffectiveMapId;
	    var defaults = {};
	
	    // Get the _defaults dictionary, and override the properties defined by the user
	    return {
	      reset: function reset() {
	        defaults = {};
	      },
	
	      getDefaults: function getDefaults(scopeId) {
	        var mapId = obtainEffectiveMapId(defaults, scopeId);
	        return defaults[mapId];
	      },
	
	      getMapCreationDefaults: function getMapCreationDefaults(scopeId) {
	        var mapId = obtainEffectiveMapId(defaults, scopeId);
	        var d = defaults[mapId];
	
	        var mapDefaults = {
	          maxZoom: d.maxZoom,
	          keyboard: d.keyboard,
	          dragging: d.dragging,
	          zoomControl: d.zoomControl,
	          doubleClickZoom: d.doubleClickZoom,
	          scrollWheelZoom: d.scrollWheelZoom,
	          tap: d.tap,
	          touchZoom: d.touchZoom,
	          attributionControl: d.attributionControl,
	          worldCopyJump: d.worldCopyJump,
	          crs: d.crs
	        };
	
	        if (isDefined(d.minZoom)) {
	          mapDefaults.minZoom = d.minZoom;
	        }
	
	        if (isDefined(d.zoomAnimation)) {
	          mapDefaults.zoomAnimation = d.zoomAnimation;
	        }
	
	        if (isDefined(d.fadeAnimation)) {
	          mapDefaults.fadeAnimation = d.fadeAnimation;
	        }
	
	        if (isDefined(d.markerZoomAnimation)) {
	          mapDefaults.markerZoomAnimation = d.markerZoomAnimation;
	        }
	
	        if (d.map) {
	          for (var option in d.map) {
	            mapDefaults[option] = d.map[option];
	          }
	        }
	
	        return mapDefaults;
	      },
	
	      setDefaults: function setDefaults(userDefaults, scopeId) {
	        var newDefaults = _getDefaults();
	
	        if (isDefined(userDefaults)) {
	          newDefaults.doubleClickZoom = isDefined(userDefaults.doubleClickZoom) ? userDefaults.doubleClickZoom : newDefaults.doubleClickZoom;
	          newDefaults.scrollWheelZoom = isDefined(userDefaults.scrollWheelZoom) ? userDefaults.scrollWheelZoom : newDefaults.doubleClickZoom;
	          newDefaults.tap = isDefined(userDefaults.tap) ? userDefaults.tap : newDefaults.tap;
	          newDefaults.touchZoom = isDefined(userDefaults.touchZoom) ? userDefaults.touchZoom : newDefaults.doubleClickZoom;
	          newDefaults.zoomControl = isDefined(userDefaults.zoomControl) ? userDefaults.zoomControl : newDefaults.zoomControl;
	          newDefaults.zoomsliderControl = isDefined(userDefaults.zoomsliderControl) ? userDefaults.zoomsliderControl : newDefaults.zoomsliderControl;
	          newDefaults.attributionControl = isDefined(userDefaults.attributionControl) ? userDefaults.attributionControl : newDefaults.attributionControl;
	          newDefaults.tileLayer = isDefined(userDefaults.tileLayer) ? userDefaults.tileLayer : newDefaults.tileLayer;
	          newDefaults.zoomControlPosition = isDefined(userDefaults.zoomControlPosition) ? userDefaults.zoomControlPosition : newDefaults.zoomControlPosition;
	          newDefaults.keyboard = isDefined(userDefaults.keyboard) ? userDefaults.keyboard : newDefaults.keyboard;
	          newDefaults.dragging = isDefined(userDefaults.dragging) ? userDefaults.dragging : newDefaults.dragging;
	
	          if (isDefined(userDefaults.controls)) {
	            angular.extend(newDefaults.controls, userDefaults.controls);
	          }
	
	          if (isObject(userDefaults.crs)) {
	            newDefaults.crs = userDefaults.crs;
	          } else if (isDefined(L.CRS[userDefaults.crs])) {
	            newDefaults.crs = L.CRS[userDefaults.crs];
	          }
	
	          if (isDefined(userDefaults.center)) {
	            angular.copy(userDefaults.center, newDefaults.center);
	          }
	
	          if (isDefined(userDefaults.tileLayerOptions)) {
	            angular.copy(userDefaults.tileLayerOptions, newDefaults.tileLayerOptions);
	          }
	
	          if (isDefined(userDefaults.maxZoom)) {
	            newDefaults.maxZoom = userDefaults.maxZoom;
	          }
	
	          if (isDefined(userDefaults.minZoom)) {
	            newDefaults.minZoom = userDefaults.minZoom;
	          }
	
	          if (isDefined(userDefaults.zoomAnimation)) {
	            newDefaults.zoomAnimation = userDefaults.zoomAnimation;
	          }
	
	          if (isDefined(userDefaults.fadeAnimation)) {
	            newDefaults.fadeAnimation = userDefaults.fadeAnimation;
	          }
	
	          if (isDefined(userDefaults.markerZoomAnimation)) {
	            newDefaults.markerZoomAnimation = userDefaults.markerZoomAnimation;
	          }
	
	          if (isDefined(userDefaults.worldCopyJump)) {
	            newDefaults.worldCopyJump = userDefaults.worldCopyJump;
	          }
	
	          if (isDefined(userDefaults.map)) {
	            newDefaults.map = userDefaults.map;
	          }
	
	          if (isDefined(userDefaults.path)) {
	            newDefaults.path = userDefaults.path;
	          }
	        }
	
	        var mapId = obtainEffectiveMapId(defaults, scopeId);
	        defaults[mapId] = newDefaults;
	        return newDefaults;
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletMarkersHelpers', ["$rootScope", "$timeout", "leafletHelpers", "$log", "$compile", "leafletGeoJsonHelpers", function ($rootScope, $timeout, leafletHelpers, $log, $compile, leafletGeoJsonHelpers) {
	    var isDefined = leafletHelpers.isDefined;
	    var defaultTo = leafletHelpers.defaultTo;
	    var MarkerClusterPlugin = leafletHelpers.MarkerClusterPlugin;
	    var AwesomeMarkersPlugin = leafletHelpers.AwesomeMarkersPlugin;
	    var VectorMarkersPlugin = leafletHelpers.VectorMarkersPlugin;
	    var MakiMarkersPlugin = leafletHelpers.MakiMarkersPlugin;
	    var ExtraMarkersPlugin = leafletHelpers.ExtraMarkersPlugin;
	    var DomMarkersPlugin = leafletHelpers.DomMarkersPlugin;
	    var safeApply = leafletHelpers.safeApply;
	    var Helpers = leafletHelpers;
	    var isString = leafletHelpers.isString;
	    var isNumber = leafletHelpers.isNumber;
	    var isObject = leafletHelpers.isObject;
	    var groups = {};
	    var geoHlp = leafletGeoJsonHelpers;
	    var errorHeader = leafletHelpers.errorHeader;
	
	    var _string = function _string(marker) {
	      //this exists since JSON.stringify barfs on cyclic
	      var retStr = '';
	      ['_icon', '_latlng', '_leaflet_id', '_map', '_shadow'].forEach(function (prop) {
	        retStr += prop + ': ' + defaultTo(marker[prop], 'undefined') + ' \n';
	      });
	
	      return '[leafletMarker] : \n' + retStr;
	    };
	
	    var _log = function _log(marker, useConsole) {
	      var logger = useConsole ? console : $log;
	      logger.debug(_string(marker));
	    };
	
	    var createLeafletIcon = function createLeafletIcon(iconData) {
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'awesomeMarker') {
	        if (!AwesomeMarkersPlugin.isLoaded()) {
	          $log.error(errorHeader + ' The AwesomeMarkers Plugin is not loaded.');
	        }
	
	        return new L.AwesomeMarkers.icon(iconData);
	      }
	
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'vectorMarker') {
	        if (!VectorMarkersPlugin.isLoaded()) {
	          $log.error(errorHeader + ' The VectorMarkers Plugin is not loaded.');
	        }
	
	        return new L.VectorMarkers.icon(iconData);
	      }
	
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'makiMarker') {
	        if (!MakiMarkersPlugin.isLoaded()) {
	          $log.error(errorHeader + 'The MakiMarkers Plugin is not loaded.');
	        }
	
	        return new L.MakiMarkers.icon(iconData);
	      }
	
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'extraMarker') {
	        if (!ExtraMarkersPlugin.isLoaded()) {
	          $log.error(errorHeader + 'The ExtraMarkers Plugin is not loaded.');
	        }
	
	        return new L.ExtraMarkers.icon(iconData);
	      }
	
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'div') {
	        return new L.divIcon(iconData);
	      }
	
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'dom') {
	        if (!DomMarkersPlugin.isLoaded()) {
	          $log.error(errorHeader + 'The DomMarkers Plugin is not loaded.');
	        }
	
	        var markerScope = angular.isFunction(iconData.getMarkerScope) ? iconData.getMarkerScope() : $rootScope;
	        var template = $compile(iconData.template)(markerScope);
	        var iconDataCopy = angular.copy(iconData);
	        iconDataCopy.element = template[0];
	        return new L.DomMarkers.icon(iconDataCopy);
	      }
	
	      // allow for any custom icon to be used... assumes the icon has already been initialized
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'icon') {
	        return iconData.icon;
	      }
	
	      var base64icon = 'data:image/png;base64,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';
	      var base64shadow = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAC5ElEQVRYw+2YW4/TMBCF45S0S1luXZCABy5CgLQgwf//S4BYBLTdJLax0fFqmB07nnQfEGqkIydpVH85M+NLjPe++dcPc4Q8Qh4hj5D/AaQJx6H/4TMwB0PeBNwU7EGQAmAtsNfAzoZkgIa0ZgLMa4Aj6CxIAsjhjOCoL5z7Glg1JAOkaicgvQBXuncwJAWjksLtBTWZe04CnYRktUGdilALppZBOgHGZcBzL6OClABvMSVIzyBjazOgrvACf1ydC5mguqAVg6RhdkSWQFj2uxfaq/BrIZOLEWgZdALIDvcMcZLD8ZbLC9de4yR1sYMi4G20S4Q/PWeJYxTOZn5zJXANZHIxAd4JWhPIloTJZhzMQduM89WQ3MUVAE/RnhAXpTycqys3NZALOBbB7kFrgLesQl2h45Fcj8L1tTSohUwuxhy8H/Qg6K7gIs+3kkaigQCOcyEXCHN07wyQazhrmIulvKMQAwMcmLNqyCVyMAI+BuxSMeTk3OPikLY2J1uE+VHQk6ANrhds+tNARqBeaGc72cK550FP4WhXmFmcMGhTwAR1ifOe3EvPqIegFmF+C8gVy0OfAaWQPMR7gF1OQKqGoBjq90HPMP01BUjPOqGFksC4emE48tWQAH0YmvOgF3DST6xieJgHAWxPAHMuNhrImIdvoNOKNWIOcE+UXE0pYAnkX6uhWsgVXDxHdTfCmrEEmMB2zMFimLVOtiiajxiGWrbU52EeCdyOwPEQD8LqyPH9Ti2kgYMf4OhSKB7qYILbBv3CuVTJ11Y80oaseiMWOONc/Y7kJYe0xL2f0BaiFTxknHO5HaMGMublKwxFGzYdWsBF174H/QDknhTHmHHN39iWFnkZx8lPyM8WHfYELmlLKtgWNmFNzQcC1b47gJ4hL19i7o65dhH0Negbca8vONZoP7doIeOC9zXm8RjuL0Gf4d4OYaU5ljo3GYiqzrWQHfJxA6ALhDpVKv9qYeZA8eM3EhfPSCmpuD0AAAAASUVORK5CYII=';
	
	      if (!isDefined(iconData) || !isDefined(iconData.iconUrl)) {
	        return new L.Icon.Default({
	          iconUrl: base64icon,
	          shadowUrl: base64shadow,
	          iconSize: [25, 41],
	          iconAnchor: [12, 41],
	          popupAnchor: [1, -34],
	          shadowSize: [41, 41]
	        });
	      }
	
	      return new L.Icon(iconData);
	    };
	
	    var _resetMarkerGroup = function _resetMarkerGroup(groupName) {
	      if (isDefined(groups[groupName])) {
	        groups.splice(groupName, 1);
	      }
	    };
	
	    var _resetMarkerGroups = function _resetMarkerGroups() {
	      groups = {};
	    };
	
	    var _deleteMarker = function _deleteMarker(marker, map, layers) {
	      marker.closePopup();
	
	      // There is no easy way to know if a marker is added to a layer, so we search for it
	      // if there are overlays
	      if (isDefined(layers) && isDefined(layers.overlays)) {
	        for (var key in layers.overlays) {
	          if (layers.overlays[key] instanceof L.LayerGroup || layers.overlays[key] instanceof L.FeatureGroup) {
	            if (layers.overlays[key].hasLayer(marker)) {
	              layers.overlays[key].removeLayer(marker);
	              return;
	            }
	          }
	        }
	      }
	
	      if (isDefined(groups)) {
	        for (var groupKey in groups) {
	          if (groups[groupKey].hasLayer(marker)) {
	            groups[groupKey].removeLayer(marker);
	          }
	        }
	      }
	
	      if (map.hasLayer(marker)) {
	        map.removeLayer(marker);
	      }
	    };
	
	    var adjustPopupPan = function adjustPopupPan(marker, map) {
	      var containerHeight = marker._popup._container.offsetHeight;
	      var layerPos = new L.Point(marker._popup._containerLeft, -containerHeight - marker._popup._containerBottom);
	      var containerPos = map.layerPointToContainerPoint(layerPos);
	      if (containerPos !== null) {
	        marker._popup._adjustPan();
	      }
	    };
	
	    var compilePopup = function compilePopup(marker, markerScope) {
	      $compile(marker._popup._contentNode)(markerScope);
	    };
	
	    var updatePopup = function updatePopup(marker, markerScope, map) {
	      //The innerText should be more than 1 once angular has compiled.
	      //We need to keep trying until angular has compiled before we _updateLayout and _updatePosition
	      //This should take care of any scenario , eg ngincludes, whatever.
	      //Is there a better way to check for this?
	      var innerText = marker._popup._contentNode.innerText || marker._popup._contentNode.textContent;
	      if (innerText.length < 1) {
	        $timeout(function () {
	          updatePopup(marker, markerScope, map);
	        });
	      }
	
	      //cause a reflow - this is also very important - if we don't do this then the widths are from before $compile
	      var reflow = marker._popup._contentNode.offsetWidth;
	
	      marker._popup._updateLayout();
	      marker._popup._updatePosition();
	
	      if (marker._popup.options.autoPan) {
	        adjustPopupPan(marker, map);
	      }
	
	      //using / returning reflow so jshint doesn't moan
	      return reflow;
	    };
	
	    var _manageOpenPopup = function _manageOpenPopup(marker, markerData, map) {
	      // The marker may provide a scope returning function used to compile the message
	      // default to $rootScope otherwise
	      var markerScope = angular.isFunction(markerData.getMessageScope) ? markerData.getMessageScope() : $rootScope;
	      var compileMessage = isDefined(markerData.compileMessage) ? markerData.compileMessage : true;
	
	      if (compileMessage) {
	        if (!isDefined(marker._popup) || !isDefined(marker._popup._contentNode)) {
	          $log.error(errorHeader + 'Popup is invalid or does not have any content.');
	          return false;
	        }
	
	        compilePopup(marker, markerScope);
	        updatePopup(marker, markerData, map);
	      }
	    };
	
	    var _manageOpenLabel = function _manageOpenLabel(marker, markerData) {
	      var markerScope = angular.isFunction(markerData.getMessageScope) ? markerData.getMessageScope() : $rootScope;
	      var labelScope = angular.isFunction(markerData.getLabelScope) ? markerData.getLabelScope() : markerScope;
	      var compileMessage = isDefined(markerData.compileMessage) ? markerData.compileMessage : true;
	
	      if (Helpers.LabelPlugin.isLoaded() && isDefined(markerData.label)) {
	        if (isDefined(markerData.label.options) && markerData.label.options.noHide === true) {
	          marker.showLabel();
	        }
	
	        if (compileMessage && isDefined(marker.label)) {
	          $compile(marker.label._container)(labelScope);
	        }
	      }
	    };
	
	    var _updateMarker = function _updateMarker(markerData, oldMarkerData, marker, name, leafletScope, layers, map) {
	      if (!isDefined(oldMarkerData)) {
	        return;
	      }
	
	      // Update the lat-lng property (always present in marker properties)
	      if (!geoHlp.validateCoords(markerData)) {
	        $log.warn('There are problems with lat-lng data, please verify your marker model');
	        _deleteMarker(marker, map, layers);
	        return;
	      }
	
	      // watch is being initialized if old and new object is the same
	      var isInitializing = markerData === oldMarkerData;
	
	      // Update marker rotation
	      if (isDefined(markerData.iconAngle) && oldMarkerData.iconAngle !== markerData.iconAngle) {
	        marker.setIconAngle(markerData.iconAngle);
	      }
	
	      // It is possible that the layer has been removed or the layer marker does not exist
	      // Update the layer group if present or move it to the map if not
	      if (!isString(markerData.layer)) {
	        // There is no layer information, we move the marker to the map if it was in a layer group
	        if (isString(oldMarkerData.layer)) {
	          // Remove from the layer group that is supposed to be
	          if (isDefined(layers.overlays[oldMarkerData.layer]) && layers.overlays[oldMarkerData.layer].hasLayer(marker)) {
	            layers.overlays[oldMarkerData.layer].removeLayer(marker);
	            marker.closePopup();
	          }
	
	          // Test if it is not on the map and add it
	          if (!map.hasLayer(marker)) {
	            map.addLayer(marker);
	          }
	        }
	      }
	
	      if ((isNumber(markerData.opacity) || isNumber(parseFloat(markerData.opacity))) && markerData.opacity !== oldMarkerData.opacity) {
	        // There was a different opacity so we update it
	        marker.setOpacity(markerData.opacity);
	      }
	
	      if (isString(markerData.layer) && oldMarkerData.layer !== markerData.layer) {
	        // If it was on a layer group we have to remove it
	        if (isString(oldMarkerData.layer) && isDefined(layers.overlays[oldMarkerData.layer]) && layers.overlays[oldMarkerData.layer].hasLayer(marker)) {
	          layers.overlays[oldMarkerData.layer].removeLayer(marker);
	        }
	
	        marker.closePopup();
	
	        // Remove it from the map in case the new layer is hidden or there is an error in the new layer
	        if (map.hasLayer(marker)) {
	          map.removeLayer(marker);
	        }
	
	        // The markerData.layer is defined so we add the marker to the layer if it is different from the old data
	        if (!isDefined(layers.overlays[markerData.layer])) {
	          $log.error(errorHeader + 'You must use a name of an existing layer');
	          return;
	        }
	
	        // Is a group layer?
	        var layerGroup = layers.overlays[markerData.layer];
	        if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
	          $log.error(errorHeader + 'A marker can only be added to a layer of type "group" or "featureGroup"');
	          return;
	        }
	
	        // The marker goes to a correct layer group, so first of all we add it
	        layerGroup.addLayer(marker);
	
	        // The marker is automatically added to the map depending on the visibility
	        // of the layer, so we only have to open the popup if the marker is in the map
	        if (map.hasLayer(marker) && markerData.focus === true) {
	          marker.openPopup();
	        }
	      }
	
	      // Update the draggable property
	      if (markerData.draggable !== true && oldMarkerData.draggable === true && isDefined(marker.dragging)) {
	        marker.dragging.disable();
	      }
	
	      if (markerData.draggable === true && oldMarkerData.draggable !== true) {
	        // The markerData.draggable property must be true so we update if there wasn't a previous value or it wasn't true
	        if (marker.dragging) {
	          marker.dragging.enable();
	        } else {
	          if (L.Handler.MarkerDrag) {
	            marker.dragging = new L.Handler.MarkerDrag(marker);
	            marker.options.draggable = true;
	            marker.dragging.enable();
	          }
	        }
	      }
	
	      // Update the icon property
	      if (!isObject(markerData.icon)) {
	        // If there is no icon property or it's not an object
	        if (isObject(oldMarkerData.icon)) {
	          // If there was an icon before restore to the default
	          marker.setIcon(createLeafletIcon());
	          marker.closePopup();
	          marker.unbindPopup();
	          if (isString(markerData.message)) {
	            marker.bindPopup(markerData.message, markerData.popupOptions);
	          }
	        }
	      }
	
	      if (isObject(markerData.icon) && isObject(oldMarkerData.icon) && !angular.equals(markerData.icon, oldMarkerData.icon)) {
	        var dragG = false;
	        if (marker.dragging) {
	          dragG = marker.dragging.enabled();
	        }
	
	        marker.setIcon(createLeafletIcon(markerData.icon));
	        if (dragG) {
	          marker.dragging.enable();
	        }
	
	        marker.closePopup();
	        marker.unbindPopup();
	        if (isString(markerData.message)) {
	          marker.bindPopup(markerData.message, markerData.popupOptions);
	
	          // if marker has been already focused, reopen popup
	          if (map.hasLayer(marker) && markerData.focus === true) {
	            marker.openPopup();
	          }
	        }
	      }
	
	      // Update the Popup message property
	      if (!isString(markerData.message) && isString(oldMarkerData.message)) {
	        marker.closePopup();
	        marker.unbindPopup();
	      }
	
	      // Update the label content or bind a new label if the old one has been removed.
	      if (Helpers.LabelPlugin.isLoaded()) {
	        if (isDefined(markerData.label) && isDefined(markerData.label.message)) {
	          if ('label' in oldMarkerData && 'message' in oldMarkerData.label && !angular.equals(markerData.label.message, oldMarkerData.label.message)) {
	            marker.updateLabelContent(markerData.label.message);
	          } else if (!angular.isFunction(marker.getLabel) || angular.isFunction(marker.getLabel) && !isDefined(marker.getLabel())) {
	            marker.bindLabel(markerData.label.message, markerData.label.options);
	            _manageOpenLabel(marker, markerData);
	          } else {
	            _manageOpenLabel(marker, markerData);
	          }
	        } else if (!('label' in markerData && !('message' in markerData.label))) {
	          if (angular.isFunction(marker.unbindLabel)) {
	            marker.unbindLabel();
	          }
	        }
	      }
	
	      // There is some text in the popup, so we must show the text or update existing
	      if (isString(markerData.message) && !isString(oldMarkerData.message)) {
	        // There was no message before so we create it
	        marker.bindPopup(markerData.message, markerData.popupOptions);
	      }
	
	      if (isString(markerData.message) && isString(oldMarkerData.message) && markerData.message !== oldMarkerData.message) {
	        // There was a different previous message so we update it
	        marker.setPopupContent(markerData.message);
	      }
	
	      // Update the focus property
	      var updatedFocus = false;
	      if (markerData.focus !== true && oldMarkerData.focus === true) {
	        // If there was a focus property and was true we turn it off
	        marker.closePopup();
	        updatedFocus = true;
	      }
	
	      // The markerData.focus property must be true so we update if there wasn't a previous value or it wasn't true
	      if (markerData.focus === true && (!isDefined(oldMarkerData.focus) || oldMarkerData.focus === false) || isInitializing && markerData.focus === true) {
	        // Reopen the popup when focus is still true
	        marker.openPopup();
	        updatedFocus = true;
	      }
	
	      // zIndexOffset adjustment
	      if (oldMarkerData.zIndexOffset !== markerData.zIndexOffset) {
	        marker.setZIndexOffset(markerData.zIndexOffset);
	      }
	
	      var markerLatLng = marker.getLatLng();
	      var isCluster = isString(markerData.layer) && Helpers.MarkerClusterPlugin.is(layers.overlays[markerData.layer]);
	
	      // If the marker is in a cluster it has to be removed and added to the layer when the location is changed
	      if (isCluster) {
	        // The focus has changed even by a user click or programatically
	        if (updatedFocus) {
	          // We only have to update the location if it was changed programatically, because it was
	          // changed by a user drag the marker data has already been updated by the internal event
	          // listened by the directive
	          if (markerData.lat !== oldMarkerData.lat || markerData.lng !== oldMarkerData.lng) {
	            layers.overlays[markerData.layer].removeLayer(marker);
	            marker.setLatLng([markerData.lat, markerData.lng]);
	            layers.overlays[markerData.layer].addLayer(marker);
	          }
	        } else {
	          // The marker has possibly moved. It can be moved by a user drag (marker location and data are equal but old
	          // data is diferent) or programatically (marker location and data are diferent)
	          if (markerLatLng.lat !== markerData.lat || markerLatLng.lng !== markerData.lng) {
	            // The marker was moved by a user drag
	            layers.overlays[markerData.layer].removeLayer(marker);
	            marker.setLatLng([markerData.lat, markerData.lng]);
	            layers.overlays[markerData.layer].addLayer(marker);
	          } else if (markerData.lat !== oldMarkerData.lat || markerData.lng !== oldMarkerData.lng) {
	            // The marker was moved programatically
	            layers.overlays[markerData.layer].removeLayer(marker);
	            marker.setLatLng([markerData.lat, markerData.lng]);
	            layers.overlays[markerData.layer].addLayer(marker);
	          } else if (isObject(markerData.icon) && isObject(oldMarkerData.icon) && !angular.equals(markerData.icon, oldMarkerData.icon)) {
	            layers.overlays[markerData.layer].removeLayer(marker);
	            layers.overlays[markerData.layer].addLayer(marker);
	          }
	        }
	      } else if (markerLatLng.lat !== markerData.lat || markerLatLng.lng !== markerData.lng) {
	        marker.setLatLng([markerData.lat, markerData.lng]);
	      }
	    };
	
	    return {
	      resetMarkerGroup: _resetMarkerGroup,
	
	      resetMarkerGroups: _resetMarkerGroups,
	
	      deleteMarker: _deleteMarker,
	
	      manageOpenPopup: _manageOpenPopup,
	
	      manageOpenLabel: _manageOpenLabel,
	
	      createMarker: function createMarker(markerData) {
	        if (!isDefined(markerData) || !geoHlp.validateCoords(markerData)) {
	          $log.error(errorHeader + 'The marker definition is not valid.');
	          return;
	        }
	
	        var coords = geoHlp.getCoords(markerData);
	
	        if (!isDefined(coords)) {
	          $log.error(errorHeader + 'Unable to get coordinates from markerData.');
	          return;
	        }
	
	        var markerOptions = {
	          icon: createLeafletIcon(markerData.icon),
	          title: isDefined(markerData.title) ? markerData.title : '',
	          draggable: isDefined(markerData.draggable) ? markerData.draggable : false,
	          clickable: isDefined(markerData.clickable) ? markerData.clickable : true,
	          riseOnHover: isDefined(markerData.riseOnHover) ? markerData.riseOnHover : false,
	          zIndexOffset: isDefined(markerData.zIndexOffset) ? markerData.zIndexOffset : 0,
	          iconAngle: isDefined(markerData.iconAngle) ? markerData.iconAngle : 0
	        };
	
	        // Add any other options not added above to markerOptions
	        for (var markerDatum in markerData) {
	          if (markerData.hasOwnProperty(markerDatum) && !markerOptions.hasOwnProperty(markerDatum)) {
	            markerOptions[markerDatum] = markerData[markerDatum];
	          }
	        }
	
	        var marker = new L.marker(coords, markerOptions);
	
	        if (!isString(markerData.message)) {
	          marker.unbindPopup();
	        }
	
	        return marker;
	      },
	
	      addMarkerToGroup: function addMarkerToGroup(marker, groupName, groupOptions, map) {
	        if (!isString(groupName)) {
	          $log.error(errorHeader + 'The marker group you have specified is invalid.');
	          return;
	        }
	
	        if (!MarkerClusterPlugin.isLoaded()) {
	          $log.error(errorHeader + 'The MarkerCluster plugin is not loaded.');
	          return;
	        }
	
	        if (!isDefined(groups[groupName])) {
	          groups[groupName] = new L.MarkerClusterGroup(groupOptions);
	          map.addLayer(groups[groupName]);
	        }
	
	        groups[groupName].addLayer(marker);
	      },
	
	      listenMarkerEvents: function listenMarkerEvents(marker, markerData, leafletScope, doWatch, map) {
	        marker.on('popupopen', function () /* event */{
	          safeApply(leafletScope, function () {
	            if (isDefined(marker._popup) || isDefined(marker._popup._contentNode)) {
	              markerData.focus = true;
	              _manageOpenPopup(marker, markerData, map); //needed since markerData is now a copy
	            }
	          });
	        });
	
	        marker.on('popupclose', function () /* event */{
	          safeApply(leafletScope, function () {
	            markerData.focus = false;
	          });
	        });
	
	        marker.on('add', function () /* event */{
	          safeApply(leafletScope, function () {
	            if ('label' in markerData) _manageOpenLabel(marker, markerData);
	          });
	        });
	      },
	
	      updateMarker: _updateMarker,
	
	      addMarkerWatcher: function addMarkerWatcher(marker, name, leafletScope, layers, map, isDeepWatch) {
	        var markerWatchPath = Helpers.getObjectArrayPath('markers.' + name);
	        isDeepWatch = defaultTo(isDeepWatch, true);
	
	        var clearWatch = leafletScope.$watch(markerWatchPath, function (markerData, oldMarkerData) {
	          if (!isDefined(markerData)) {
	            _deleteMarker(marker, map, layers);
	            clearWatch();
	            return;
	          }
	
	          _updateMarker(markerData, oldMarkerData, marker, name, leafletScope, layers, map);
	        }, isDeepWatch);
	      },
	
	      string: _string,
	      log: _log
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletPathsHelpers', ["$rootScope", "$log", "leafletHelpers", function ($rootScope, $log, leafletHelpers) {
	    var isDefined = leafletHelpers.isDefined;
	    var isArray = leafletHelpers.isArray;
	    var isNumber = leafletHelpers.isNumber;
	    var isValidPoint = leafletHelpers.isValidPoint;
	
	    var availableOptions = [
	
	    // Path options
	    'stroke', 'weight', 'color', 'opacity', 'fill', 'fillColor', 'fillOpacity', 'dashArray', 'lineCap', 'lineJoin', 'clickable', 'pointerEvents', 'className',
	
	    // Polyline options
	    'smoothFactor', 'noClip'];
	    function _convertToLeafletLatLngs(latlngs) {
	      return latlngs.filter(function (latlng) {
	        return isValidPoint(latlng);
	      }).map(function (latlng) {
	        return _convertToLeafletLatLng(latlng);
	      });
	    }
	
	    function _convertToLeafletLatLng(latlng) {
	      if (isArray(latlng)) {
	        return new L.LatLng(latlng[0], latlng[1]);
	      } else {
	        return new L.LatLng(latlng.lat, latlng.lng);
	      }
	    }
	
	    function _convertToLeafletMultiLatLngs(paths) {
	      return paths.map(function (latlngs) {
	        return _convertToLeafletLatLngs(latlngs);
	      });
	    }
	
	    function _getOptions(path, defaults) {
	      var options = {};
	      for (var i = 0; i < availableOptions.length; i++) {
	        var optionName = availableOptions[i];
	
	        if (isDefined(path[optionName])) {
	          options[optionName] = path[optionName];
	        } else if (isDefined(defaults.path[optionName])) {
	          options[optionName] = defaults.path[optionName];
	        }
	      }
	
	      return options;
	    }
	
	    var _updatePathOptions = function _updatePathOptions(path, data) {
	      var updatedStyle = {};
	      for (var i = 0; i < availableOptions.length; i++) {
	        var optionName = availableOptions[i];
	        if (isDefined(data[optionName])) {
	          updatedStyle[optionName] = data[optionName];
	        }
	      }
	
	      path.setStyle(data);
	    };
	
	    var _isValidPolyline = function _isValidPolyline(latlngs) {
	      if (!isArray(latlngs)) {
	        return false;
	      }
	
	      for (var i = 0; i < latlngs.length; i++) {
	        var point = latlngs[i];
	        if (!isValidPoint(point)) {
	          return false;
	        }
	      }
	
	      return true;
	    };
	
	    var pathTypes = {
	      polyline: {
	        isValid: function isValid(pathData) {
	          var latlngs = pathData.latlngs;
	          return _isValidPolyline(latlngs);
	        },
	
	        createPath: function createPath(options) {
	          return new L.Polyline([], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLngs(_convertToLeafletLatLngs(data.latlngs));
	          _updatePathOptions(path, data);
	          return;
	        }
	      },
	      multiPolyline: {
	        isValid: function isValid(pathData) {
	          var latlngs = pathData.latlngs;
	          if (!isArray(latlngs)) {
	            return false;
	          }
	
	          for (var i in latlngs) {
	            var polyline = latlngs[i];
	            if (!_isValidPolyline(polyline)) {
	              return false;
	            }
	          }
	
	          return true;
	        },
	
	        createPath: function createPath(options) {
	          return new L.multiPolyline([[[0, 0], [1, 1]]], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLngs(_convertToLeafletMultiLatLngs(data.latlngs));
	          _updatePathOptions(path, data);
	          return;
	        }
	      },
	      polygon: {
	        isValid: function isValid(pathData) {
	          var latlngs = pathData.latlngs;
	          return _isValidPolyline(latlngs);
	        },
	
	        createPath: function createPath(options) {
	          return new L.Polygon([], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLngs(_convertToLeafletLatLngs(data.latlngs));
	          _updatePathOptions(path, data);
	          return;
	        }
	      },
	      multiPolygon: {
	        isValid: function isValid(pathData) {
	          var latlngs = pathData.latlngs;
	
	          if (!isArray(latlngs)) {
	            return false;
	          }
	
	          for (var i in latlngs) {
	            var polyline = latlngs[i];
	            if (!_isValidPolyline(polyline)) {
	              return false;
	            }
	          }
	
	          return true;
	        },
	
	        createPath: function createPath(options) {
	          return new L.MultiPolygon([[[0, 0], [1, 1], [0, 1]]], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLngs(_convertToLeafletMultiLatLngs(data.latlngs));
	          _updatePathOptions(path, data);
	          return;
	        }
	      },
	      rectangle: {
	        isValid: function isValid(pathData) {
	          var latlngs = pathData.latlngs;
	
	          if (!isArray(latlngs) || latlngs.length !== 2) {
	            return false;
	          }
	
	          for (var i in latlngs) {
	            var point = latlngs[i];
	            if (!isValidPoint(point)) {
	              return false;
	            }
	          }
	
	          return true;
	        },
	
	        createPath: function createPath(options) {
	          return new L.Rectangle([[0, 0], [1, 1]], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setBounds(new L.LatLngBounds(_convertToLeafletLatLngs(data.latlngs)));
	          _updatePathOptions(path, data);
	        }
	      },
	      circle: {
	        isValid: function isValid(pathData) {
	          var point = pathData.latlngs;
	          return isValidPoint(point) && isNumber(pathData.radius);
	        },
	
	        createPath: function createPath(options) {
	          return new L.Circle([0, 0], 1, options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLng(_convertToLeafletLatLng(data.latlngs));
	          if (isDefined(data.radius)) {
	            path.setRadius(data.radius);
	          }
	
	          _updatePathOptions(path, data);
	        }
	      },
	      circleMarker: {
	        isValid: function isValid(pathData) {
	          var point = pathData.latlngs;
	          return isValidPoint(point) && isNumber(pathData.radius);
	        },
	
	        createPath: function createPath(options) {
	          return new L.CircleMarker([0, 0], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLng(_convertToLeafletLatLng(data.latlngs));
	          if (isDefined(data.radius)) {
	            path.setRadius(data.radius);
	          }
	
	          _updatePathOptions(path, data);
	        }
	      }
	    };
	
	    var _getPathData = function _getPathData(path) {
	      var pathData = {};
	      if (path.latlngs) {
	        pathData.latlngs = path.latlngs;
	      }
	
	      if (path.radius) {
	        pathData.radius = path.radius;
	      }
	
	      return pathData;
	    };
	
	    return {
	      setPathOptions: function setPathOptions(leafletPath, pathType, data) {
	        if (!isDefined(pathType)) {
	          pathType = 'polyline';
	        }
	
	        pathTypes[pathType].setPath(leafletPath, data);
	      },
	
	      createPath: function createPath(name, path, defaults) {
	        if (!isDefined(path.type)) {
	          path.type = 'polyline';
	        }
	
	        var options = _getOptions(path, defaults);
	        var pathData = _getPathData(path);
	
	        if (!pathTypes[path.type].isValid(pathData)) {
	          $log.error('[AngularJS - Leaflet] Invalid data passed to the ' + path.type + ' path');
	          return;
	        }
	
	        return pathTypes[path.type].createPath(options);
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletWatchHelpers', function () {
	
	    var _maybe = function _maybe(scope, watchFunctionName, thingToWatchStr, watchOptions, initCb) {
	      //watchOptions.isDeep is/should be ignored in $watchCollection
	      var unWatch = scope[watchFunctionName](thingToWatchStr, function (newValue, oldValue) {
	        initCb(newValue, oldValue);
	        if (!watchOptions.doWatch) unWatch();
	      }, watchOptions.isDeep);
	
	      return unWatch;
	    };
	
	    /*
	    @name: maybeWatch
	    @description: Utility to watch something once or forever.
	    @returns unWatch function
	    @param watchOptions - see markersWatchOptions and or derrivatives. This object is used
	    to set watching to once and its watch depth.
	    */
	    var _maybeWatch = function _maybeWatch(scope, thingToWatchStr, watchOptions, initCb) {
	      return _maybe(scope, '$watch', thingToWatchStr, watchOptions, initCb);
	    };
	
	    /*
	    @name: _maybeWatchCollection
	    @description: Utility to watch something once or forever.
	    @returns unWatch function
	    @param watchOptions - see markersWatchOptions and or derrivatives. This object is used
	    to set watching to once and its watch depth.
	    */
	    var _maybeWatchCollection = function _maybeWatchCollection(scope, thingToWatchStr, watchOptions, initCb) {
	      return _maybe(scope, '$watchCollection', thingToWatchStr, watchOptions, initCb);
	    };
	
	    return {
	      maybeWatch: _maybeWatch,
	      maybeWatchCollection: _maybeWatchCollection
	    };
	  });
	
	  angular.module('leaflet-directive').factory('nominatimService', ["$q", "$http", "leafletHelpers", "leafletMapDefaults", function ($q, $http, leafletHelpers, leafletMapDefaults) {
	    var isDefined = leafletHelpers.isDefined;
	
	    return {
	      query: function query(address, mapId) {
	        var defaults = leafletMapDefaults.getDefaults(mapId);
	        var url = defaults.nominatim.server;
	        var df = $q.defer();
	
	        $http.get(url, { params: { format: 'json', limit: 1, q: address } }).success(function (data) {
	          if (data.length > 0 && isDefined(data[0].boundingbox)) {
	            df.resolve(data[0]);
	          } else {
	            df.reject('[Nominatim] Invalid address');
	          }
	        });
	
	        return df.promise;
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('bounds', ["$log", "$timeout", "$http", "leafletHelpers", "nominatimService", "leafletBoundsHelpers", function ($log, $timeout, $http, leafletHelpers, nominatimService, leafletBoundsHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: ['leaflet'],
	
	      link: function link(scope, element, attrs, controller) {
	        var isDefined = leafletHelpers.isDefined;
	        var createLeafletBounds = leafletBoundsHelpers.createLeafletBounds;
	        var leafletScope = controller[0].getLeafletScope();
	        var mapController = controller[0];
	        var errorHeader = leafletHelpers.errorHeader + ' [Bounds] ';
	
	        var emptyBounds = function emptyBounds(bounds) {
	          return bounds._southWest.lat === 0 && bounds._southWest.lng === 0 && bounds._northEast.lat === 0 && bounds._northEast.lng === 0;
	        };
	
	        mapController.getMap().then(function (map) {
	          leafletScope.$on('boundsChanged', function (event) {
	            var scope = event.currentScope;
	            var bounds = map.getBounds();
	
	            if (emptyBounds(bounds) || scope.settingBoundsFromScope) {
	              return;
	            }
	
	            scope.settingBoundsFromLeaflet = true;
	            var newScopeBounds = {
	              northEast: {
	                lat: bounds._northEast.lat,
	                lng: bounds._northEast.lng
	              },
	              southWest: {
	                lat: bounds._southWest.lat,
	                lng: bounds._southWest.lng
	              },
	              options: bounds.options
	            };
	            if (!angular.equals(scope.bounds, newScopeBounds)) {
	              scope.bounds = newScopeBounds;
	            }
	
	            $timeout(function () {
	              scope.settingBoundsFromLeaflet = false;
	            });
	          });
	
	          var lastNominatimQuery;
	          leafletScope.$watch('bounds', function (bounds) {
	            if (scope.settingBoundsFromLeaflet) return;
	            if (isDefined(bounds.address) && bounds.address !== lastNominatimQuery) {
	              scope.settingBoundsFromScope = true;
	              nominatimService.query(bounds.address, attrs.id).then(function (data) {
	                var b = data.boundingbox;
	                var newBounds = [[b[0], b[2]], [b[1], b[3]]];
	                map.fitBounds(newBounds);
	              }, function (errMsg) {
	
	                $log.error(errorHeader + ' ' + errMsg + '.');
	              });
	
	              lastNominatimQuery = bounds.address;
	              $timeout(function () {
	                scope.settingBoundsFromScope = false;
	              });
	
	              return;
	            }
	
	            var leafletBounds = createLeafletBounds(bounds);
	            if (leafletBounds && !map.getBounds().equals(leafletBounds)) {
	              scope.settingBoundsFromScope = true;
	              map.fitBounds(leafletBounds, bounds.options);
	              $timeout(function () {
	                scope.settingBoundsFromScope = false;
	              });
	            }
	          }, true);
	        });
	      }
	    };
	  }]);
	
	  var centerDirectiveTypes = ['center', 'lfCenter'];
	  var centerDirectives = {};
	
	  centerDirectiveTypes.forEach(function (directiveName) {
	    centerDirectives[directiveName] = ['$log', '$q', '$location', '$timeout', 'leafletMapDefaults', 'leafletHelpers', 'leafletBoundsHelpers', 'leafletMapEvents', function ($log, $q, $location, $timeout, leafletMapDefaults, leafletHelpers, leafletBoundsHelpers, leafletMapEvents) {
	
	      var isDefined = leafletHelpers.isDefined;
	      var isNumber = leafletHelpers.isNumber;
	      var isSameCenterOnMap = leafletHelpers.isSameCenterOnMap;
	      var safeApply = leafletHelpers.safeApply;
	      var isValidCenter = leafletHelpers.isValidCenter;
	      var isValidBounds = leafletBoundsHelpers.isValidBounds;
	      var isUndefinedOrEmpty = leafletHelpers.isUndefinedOrEmpty;
	      var errorHeader = leafletHelpers.errorHeader;
	
	      var shouldInitializeMapWithBounds = function shouldInitializeMapWithBounds(bounds, center) {
	        return isDefined(bounds) && isValidBounds(bounds) && isUndefinedOrEmpty(center);
	      };
	
	      var _leafletCenter;
	      return {
	        restrict: 'A',
	        scope: false,
	        replace: false,
	        require: 'leaflet',
	        controller: function controller() {
	          _leafletCenter = $q.defer();
	          this.getCenter = function () {
	            return _leafletCenter.promise;
	          };
	        },
	
	        link: function link(scope, element, attrs, controller) {
	          var leafletScope = controller.getLeafletScope();
	          var centerModel = leafletScope[directiveName];
	
	          controller.getMap().then(function (map) {
	            var defaults = leafletMapDefaults.getDefaults(attrs.id);
	
	            if (attrs[directiveName].search('-') !== -1) {
	              $log.error(errorHeader + ' The "center" variable can\'t use a "-" on its key name: "' + attrs[directiveName] + '".');
	              map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	              return;
	            } else if (shouldInitializeMapWithBounds(leafletScope.bounds, centerModel)) {
	              map.fitBounds(leafletBoundsHelpers.createLeafletBounds(leafletScope.bounds), leafletScope.bounds.options);
	              centerModel = map.getCenter();
	              safeApply(leafletScope, function (scope) {
	                angular.extend(scope[directiveName], {
	                  lat: map.getCenter().lat,
	                  lng: map.getCenter().lng,
	                  zoom: map.getZoom(),
	                  autoDiscover: false
	                });
	              });
	
	              safeApply(leafletScope, function (scope) {
	                var mapBounds = map.getBounds();
	                scope.bounds = {
	                  northEast: {
	                    lat: mapBounds._northEast.lat,
	                    lng: mapBounds._northEast.lng
	                  },
	                  southWest: {
	                    lat: mapBounds._southWest.lat,
	                    lng: mapBounds._southWest.lng
	                  }
	                };
	              });
	            } else if (!isDefined(centerModel)) {
	              $log.error(errorHeader + ' The "center" property is not defined in the main scope');
	              map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	              return;
	            } else if (!(isDefined(centerModel.lat) && isDefined(centerModel.lng)) && !isDefined(centerModel.autoDiscover)) {
	              angular.copy(defaults.center, centerModel);
	            }
	
	            var urlCenterHash;
	            var mapReady;
	            if (attrs.urlHashCenter === 'yes') {
	              var extractCenterFromUrl = function extractCenterFromUrl() {
	                var search = $location.search();
	                var centerParam;
	                if (isDefined(search.c)) {
	                  var cParam = search.c.split(':');
	                  if (cParam.length === 3) {
	                    centerParam = {
	                      lat: parseFloat(cParam[0]),
	                      lng: parseFloat(cParam[1]),
	                      zoom: parseInt(cParam[2], 10)
	                    };
	                  }
	                }
	
	                return centerParam;
	              };
	
	              urlCenterHash = extractCenterFromUrl();
	
	              leafletScope.$on('$locationChangeSuccess', function (event) {
	                var scope = event.currentScope;
	
	                //$log.debug("updated location...");
	                var urlCenter = extractCenterFromUrl();
	                if (isDefined(urlCenter) && !isSameCenterOnMap(urlCenter, map)) {
	                  //$log.debug("updating center model...", urlCenter);
	                  angular.extend(scope[directiveName], {
	                    lat: urlCenter.lat,
	                    lng: urlCenter.lng,
	                    zoom: urlCenter.zoom
	                  });
	                }
	              });
	            }
	
	            leafletScope.$watch(directiveName, function (center) {
	              if (leafletScope.settingCenterFromLeaflet) return;
	
	              //$log.debug("updated center model...");
	              // The center from the URL has priority
	              if (isDefined(urlCenterHash)) {
	                angular.copy(urlCenterHash, center);
	                urlCenterHash = undefined;
	              }
	
	              if (!isValidCenter(center) && center.autoDiscover !== true) {
	                $log.warn(errorHeader + ' invalid \'center\'');
	
	                //map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	                return;
	              }
	
	              if (center.autoDiscover === true) {
	                if (!isNumber(center.zoom)) {
	                  map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	                }
	
	                if (isNumber(center.zoom) && center.zoom > defaults.center.zoom) {
	                  map.locate({
	                    setView: true,
	                    maxZoom: center.zoom
	                  });
	                } else if (isDefined(defaults.maxZoom)) {
	                  map.locate({
	                    setView: true,
	                    maxZoom: defaults.maxZoom
	                  });
	                } else {
	                  map.locate({
	                    setView: true
	                  });
	                }
	
	                return;
	              }
	
	              if (mapReady && isSameCenterOnMap(center, map)) {
	                //$log.debug("no need to update map again.");
	                return;
	              }
	
	              //$log.debug("updating map center...", center);
	              leafletScope.settingCenterFromScope = true;
	              map.setView([center.lat, center.lng], center.zoom);
	              leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	              $timeout(function () {
	                leafletScope.settingCenterFromScope = false;
	
	                //$log.debug("allow center scope updates");
	              });
	            }, true);
	
	            map.whenReady(function () {
	              mapReady = true;
	            });
	
	            map.on('moveend', function () /* event */{
	              // Resolve the center after the first map position
	              _leafletCenter.resolve();
	              leafletMapEvents.notifyCenterUrlHashChanged(leafletScope, map, attrs, $location.search());
	
	              //$log.debug("updated center on map...");
	              if (isSameCenterOnMap(centerModel, map) || leafletScope.settingCenterFromScope) {
	                //$log.debug("same center in model, no need to update again.");
	                return;
	              }
	
	              leafletScope.settingCenterFromLeaflet = true;
	              safeApply(leafletScope, function (scope) {
	                if (!leafletScope.settingCenterFromScope) {
	                  //$log.debug("updating center model...", map.getCenter(), map.getZoom());
	                  angular.extend(scope[directiveName], {
	                    lat: map.getCenter().lat,
	                    lng: map.getCenter().lng,
	                    zoom: map.getZoom(),
	                    autoDiscover: false
	                  });
	                }
	
	                leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	                $timeout(function () {
	                  leafletScope.settingCenterFromLeaflet = false;
	                });
	              });
	            });
	
	            if (centerModel.autoDiscover === true) {
	              map.on('locationerror', function () {
	                $log.warn(errorHeader + ' The Geolocation API is unauthorized on this page.');
	                if (isValidCenter(centerModel)) {
	                  map.setView([centerModel.lat, centerModel.lng], centerModel.zoom);
	                  leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	                } else {
	                  map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	                  leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	                }
	              });
	            }
	          });
	        }
	      };
	    }];
	  });
	
	  centerDirectiveTypes.forEach(function (dirType) {
	    angular.module('leaflet-directive').directive(dirType, centerDirectives[dirType]);
	  });
	
	  angular.module('leaflet-directive').directive('controls', ["$log", "leafletHelpers", "leafletControlHelpers", function ($log, leafletHelpers, leafletControlHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: '?^leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        if (!controller) {
	          return;
	        }
	
	        var createControl = leafletControlHelpers.createControl;
	        var isValidControlType = leafletControlHelpers.isValidControlType;
	        var leafletScope = controller.getLeafletScope();
	        var isDefined = leafletHelpers.isDefined;
	        var isArray = leafletHelpers.isArray;
	        var leafletControls = {};
	        var errorHeader = leafletHelpers.errorHeader + ' [Controls] ';
	
	        controller.getMap().then(function (map) {
	
	          leafletScope.$watchCollection('controls', function (newControls) {
	
	            // Delete controls from the array
	            for (var name in leafletControls) {
	              if (!isDefined(newControls[name])) {
	                if (map.hasControl(leafletControls[name])) {
	                  map.removeControl(leafletControls[name]);
	                }
	
	                delete leafletControls[name];
	              }
	            }
	
	            for (var newName in newControls) {
	              var control;
	
	              var controlType = isDefined(newControls[newName].type) ? newControls[newName].type : newName;
	
	              if (!isValidControlType(controlType)) {
	                $log.error(errorHeader + ' Invalid control type: ' + controlType + '.');
	                return;
	              }
	
	              if (controlType !== 'custom') {
	                control = createControl(controlType, newControls[newName]);
	                map.addControl(control);
	                leafletControls[newName] = control;
	              } else {
	                var customControlValue = newControls[newName];
	                if (isArray(customControlValue)) {
	                  for (var i in customControlValue) {
	                    var customControl = customControlValue[i];
	                    map.addControl(customControl);
	                    leafletControls[newName] = !isDefined(leafletControls[newName]) ? [customControl] : leafletControls[newName].concat([customControl]);
	                  }
	                } else {
	                  map.addControl(customControlValue);
	                  leafletControls[newName] = customControlValue;
	                }
	              }
	            }
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('decorations', ["$log", "leafletHelpers", function ($log, leafletHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        var leafletScope = controller.getLeafletScope();
	        var PolylineDecoratorPlugin = leafletHelpers.PolylineDecoratorPlugin;
	        var isDefined = leafletHelpers.isDefined;
	        var leafletDecorations = {};
	
	        /* Creates an "empty" decoration with a set of coordinates, but no pattern. */
	        function createDecoration(options) {
	          if (isDefined(options) && isDefined(options.coordinates)) {
	            if (!PolylineDecoratorPlugin.isLoaded()) {
	              $log.error('[AngularJS - Leaflet] The PolylineDecorator Plugin is not loaded.');
	            }
	          }
	
	          return L.polylineDecorator(options.coordinates);
	        }
	
	        /* Updates the path and the patterns for the provided decoration, and returns the decoration. */
	        function setDecorationOptions(decoration, options) {
	          if (isDefined(decoration) && isDefined(options)) {
	            if (isDefined(options.coordinates) && isDefined(options.patterns)) {
	              decoration.setPaths(options.coordinates);
	              decoration.setPatterns(options.patterns);
	              return decoration;
	            }
	          }
	        }
	
	        controller.getMap().then(function (map) {
	          leafletScope.$watch('decorations', function (newDecorations) {
	            for (var name in leafletDecorations) {
	              if (!isDefined(newDecorations[name]) || !angular.equals(newDecorations[name], leafletDecorations)) {
	                map.removeLayer(leafletDecorations[name]);
	                delete leafletDecorations[name];
	              }
	            }
	
	            for (var newName in newDecorations) {
	              var decorationData = newDecorations[newName];
	              var newDecoration = createDecoration(decorationData);
	
	              if (isDefined(newDecoration)) {
	                leafletDecorations[newName] = newDecoration;
	                map.addLayer(newDecoration);
	                setDecorationOptions(newDecoration, decorationData);
	              }
	            }
	          }, true);
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('eventBroadcast', ["$log", "$rootScope", "leafletHelpers", "leafletMapEvents", "leafletIterators", function ($log, $rootScope, leafletHelpers, leafletMapEvents, leafletIterators) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        var isObject = leafletHelpers.isObject;
	        var isDefined = leafletHelpers.isDefined;
	        var leafletScope = controller.getLeafletScope();
	        var eventBroadcast = leafletScope.eventBroadcast;
	        var availableMapEvents = leafletMapEvents.getAvailableMapEvents();
	        var addEvents = leafletMapEvents.addEvents;
	
	        controller.getMap().then(function (map) {
	
	          var mapEvents = [];
	          var logic = 'broadcast';
	
	          // We have a possible valid object
	          if (!isDefined(eventBroadcast.map)) {
	            // We do not have events enable/disable do we do nothing (all enabled by default)
	            mapEvents = availableMapEvents;
	          } else if (!isObject(eventBroadcast.map)) {
	            // Not a valid object
	            $log.warn('[AngularJS - Leaflet] event-broadcast.map must be an object check your model.');
	          } else {
	            // We have a possible valid map object
	            // Event propadation logic
	            if (eventBroadcast.map.logic !== 'emit' && eventBroadcast.map.logic !== 'broadcast') {
	              // This is an error
	              $log.warn('[AngularJS - Leaflet] Available event propagation logic are: \'emit\' or \'broadcast\'.');
	            } else {
	              logic = eventBroadcast.map.logic;
	            }
	
	            if (!(isObject(eventBroadcast.map.enable) && eventBroadcast.map.enable.length >= 0)) {
	              $log.warn('[AngularJS - Leaflet] event-broadcast.map.enable must be an object check your model.');
	            } else {
	              // Enable events
	              leafletIterators.each(eventBroadcast.map.enable, function (eventName) {
	                // Do we have already the event enabled?
	                if (mapEvents.indexOf(eventName) === -1 && availableMapEvents.indexOf(eventName) !== -1) {
	                  mapEvents.push(eventName);
	                }
	              });
	            }
	          }
	
	          // as long as the map is removed in the root leaflet directive we
	          // do not need ot clean up the events as leaflet does it itself
	          addEvents(map, mapEvents, 'eventName', leafletScope, logic);
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('geojson', ["$log", "$rootScope", "leafletData", "leafletHelpers", "leafletWatchHelpers", "leafletDirectiveControlsHelpers", "leafletIterators", "leafletGeoJsonEvents", function ($log, $rootScope, leafletData, leafletHelpers, leafletWatchHelpers, leafletDirectiveControlsHelpers, leafletIterators, leafletGeoJsonEvents) {
	    var _maybeWatch = leafletWatchHelpers.maybeWatch;
	    var _watchOptions = leafletHelpers.watchOptions;
	    var _extendDirectiveControls = leafletDirectiveControlsHelpers.extend;
	    var hlp = leafletHelpers;
	    var $it = leafletIterators;
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        var isDefined = leafletHelpers.isDefined;
	        var leafletScope = controller.getLeafletScope();
	        var leafletGeoJSON = {};
	        var _hasSetLeafletData = false;
	
	        controller.getMap().then(function (map) {
	          var watchOptions = leafletScope.geojsonWatchOptions || _watchOptions;
	
	          var _hookUpEvents = function _hookUpEvents(geojson, maybeName) {
	            var onEachFeature;
	
	            if (angular.isFunction(geojson.onEachFeature)) {
	              onEachFeature = geojson.onEachFeature;
	            } else {
	              onEachFeature = function onEachFeature(feature, layer) {
	                if (leafletHelpers.LabelPlugin.isLoaded() && isDefined(feature.properties.description)) {
	                  layer.bindLabel(feature.properties.description);
	                }
	
	                leafletGeoJsonEvents.bindEvents(attrs.id, layer, null, feature, leafletScope, maybeName, { resetStyleOnMouseout: geojson.resetStyleOnMouseout,
	                  mapId: attrs.id });
	              };
	            }
	
	            return onEachFeature;
	          };
	
	          var isNested = hlp.isDefined(attrs.geojsonNested) && hlp.isTruthy(attrs.geojsonNested);
	
	          var _clean = function _clean() {
	            if (!leafletGeoJSON) return;
	            var _remove = function _remove(lObject) {
	              if (isDefined(lObject) && map.hasLayer(lObject)) {
	                map.removeLayer(lObject);
	              }
	            };
	
	            if (isNested) {
	              $it.each(leafletGeoJSON, function (lObject) {
	                _remove(lObject);
	              });
	
	              return;
	            }
	
	            _remove(leafletGeoJSON);
	          };
	
	          var _addGeojson = function _addGeojson(model, maybeName) {
	            var geojson = angular.copy(model);
	            if (!(isDefined(geojson) && isDefined(geojson.data))) {
	              return;
	            }
	
	            var onEachFeature = _hookUpEvents(geojson, maybeName);
	
	            if (!isDefined(geojson.options)) {
	              //right here is why we use a clone / copy (we modify and thus)
	              //would kick of a watcher.. we need to be more careful everywhere
	              //for stuff like this
	              geojson.options = {
	                style: geojson.style,
	                filter: geojson.filter,
	                onEachFeature: onEachFeature,
	                pointToLayer: geojson.pointToLayer
	              };
	            }
	
	            var lObject = L.geoJson(geojson.data, geojson.options);
	
	            if (maybeName && hlp.isString(maybeName)) {
	              leafletGeoJSON[maybeName] = lObject;
	            } else {
	              leafletGeoJSON = lObject;
	            }
	
	            lObject.addTo(map);
	
	            if (!_hasSetLeafletData) {
	              //only do this once and play with the same ref forever
	              _hasSetLeafletData = true;
	              leafletData.setGeoJSON(leafletGeoJSON, attrs.id);
	            }
	          };
	
	          var _create = function _create(model) {
	            _clean();
	            if (isNested) {
	              if (!model || !Object.keys(model).length) return;
	              $it.each(model, function (m, name) {
	                //name could be layerName and or groupName
	                //for now it is not tied to a layer
	                _addGeojson(m, name);
	              });
	
	              return;
	            }
	
	            _addGeojson(model);
	          };
	
	          _extendDirectiveControls(attrs.id, 'geojson', _create, _clean);
	
	          _maybeWatch(leafletScope, 'geojson', watchOptions, function (geojson) {
	            _create(geojson);
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('layercontrol', ["$filter", "$log", "leafletData", "leafletHelpers", function ($filter, $log, leafletData, leafletHelpers) {
	
	    return {
	      restrict: 'E',
	      scope: {
	        icons: '=?',
	        autoHideOpacity: '=?', // Hide other opacity controls when one is activated.
	        showGroups: '=?', // Hide other opacity controls when one is activated.
	        title: '@',
	        baseTitle: '@',
	        overlaysTitle: '@'
	      },
	      replace: true,
	      transclude: false,
	      require: '^leaflet',
	      controller: ["$scope", "$element", "$sce", function ($scope, $element, $sce) {
	        $log.debug('[Angular Directive - Layers] layers', $scope, $element);
	        var safeApply = leafletHelpers.safeApply;
	        var isDefined = leafletHelpers.isDefined;
	        angular.extend($scope, {
	          baselayer: '',
	          oldGroup: '',
	          layerProperties: {},
	          groupProperties: {},
	          rangeIsSupported: leafletHelpers.rangeIsSupported(),
	          changeBaseLayer: function changeBaseLayer(key, e) {
	            leafletHelpers.safeApply($scope, function (scp) {
	              scp.baselayer = key;
	              leafletData.getMap().then(function (map) {
	                leafletData.getLayers().then(function (leafletLayers) {
	                  if (map.hasLayer(leafletLayers.baselayers[key])) {
	                    return;
	                  }
	
	                  for (var i in scp.layers.baselayers) {
	                    scp.layers.baselayers[i].icon = scp.icons.unradio;
	                    if (map.hasLayer(leafletLayers.baselayers[i])) {
	                      map.removeLayer(leafletLayers.baselayers[i]);
	                    }
	                  }
	
	                  map.addLayer(leafletLayers.baselayers[key]);
	                  scp.layers.baselayers[key].icon = $scope.icons.radio;
	                });
	              });
	            });
	
	            e.preventDefault();
	          },
	
	          moveLayer: function moveLayer(ly, newIndex, e) {
	            var delta = Object.keys($scope.layers.baselayers).length;
	            if (newIndex >= 1 + delta && newIndex <= $scope.overlaysArray.length + delta) {
	              var oldLy;
	              for (var key in $scope.layers.overlays) {
	                if ($scope.layers.overlays[key].index === newIndex) {
	                  oldLy = $scope.layers.overlays[key];
	                  break;
	                }
	              }
	
	              if (oldLy) {
	                safeApply($scope, function () {
	                  oldLy.index = ly.index;
	                  ly.index = newIndex;
	                });
	              }
	            }
	
	            e.stopPropagation();
	            e.preventDefault();
	          },
	
	          initIndex: function initIndex(layer, idx) {
	            var delta = Object.keys($scope.layers.baselayers).length;
	            layer.index = isDefined(layer.index) ? layer.index : idx + delta + 1;
	          },
	
	          initGroup: function initGroup(groupName) {
	            $scope.groupProperties[groupName] = $scope.groupProperties[groupName] ? $scope.groupProperties[groupName] : {};
	          },
	
	          toggleOpacity: function toggleOpacity(e, layer) {
	            if (layer.visible) {
	              if ($scope.autoHideOpacity && !$scope.layerProperties[layer.name].opacityControl) {
	                for (var k in $scope.layerProperties) {
	                  $scope.layerProperties[k].opacityControl = false;
	                }
	              }
	
	              $scope.layerProperties[layer.name].opacityControl = !$scope.layerProperties[layer.name].opacityControl;
	            }
	
	            e.stopPropagation();
	            e.preventDefault();
	          },
	
	          toggleLegend: function toggleLegend(layer) {
	            $scope.layerProperties[layer.name].showLegend = !$scope.layerProperties[layer.name].showLegend;
	          },
	
	          showLegend: function showLegend(layer) {
	            return layer.legend && $scope.layerProperties[layer.name].showLegend;
	          },
	
	          unsafeHTML: function unsafeHTML(html) {
	            return $sce.trustAsHtml(html);
	          },
	
	          getOpacityIcon: function getOpacityIcon(layer) {
	            return layer.visible && $scope.layerProperties[layer.name].opacityControl ? $scope.icons.close : $scope.icons.open;
	          },
	
	          getGroupIcon: function getGroupIcon(group) {
	            return group.visible ? $scope.icons.check : $scope.icons.uncheck;
	          },
	
	          changeOpacity: function changeOpacity(layer) {
	            var op = $scope.layerProperties[layer.name].opacity;
	            leafletData.getMap().then(function (map) {
	              leafletData.getLayers().then(function (leafletLayers) {
	                var ly;
	                for (var k in $scope.layers.overlays) {
	                  if ($scope.layers.overlays[k] === layer) {
	                    ly = leafletLayers.overlays[k];
	                    break;
	                  }
	                }
	
	                if (map.hasLayer(ly)) {
	                  if (ly.setOpacity) {
	                    ly.setOpacity(op / 100);
	                  }
	
	                  if (ly.getLayers && ly.eachLayer) {
	                    ly.eachLayer(function (lay) {
	                      if (lay.setOpacity) {
	                        lay.setOpacity(op / 100);
	                      }
	                    });
	                  }
	                }
	              });
	            });
	          },
	
	          changeGroupVisibility: function changeGroupVisibility(groupName) {
	            if (!isDefined($scope.groupProperties[groupName])) {
	              return;
	            }
	
	            var visible = $scope.groupProperties[groupName].visible;
	            for (var k in $scope.layers.overlays) {
	              var layer = $scope.layers.overlays[k];
	              if (layer.group === groupName) {
	                layer.visible = visible;
	              }
	            }
	          }
	        });
	
	        var div = $element.get(0);
	        if (!L.Browser.touch) {
	          L.DomEvent.disableClickPropagation(div);
	          L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
	        } else {
	          L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
	        }
	      }],
	
	      template: '<div class="angular-leaflet-control-layers" ng-show="overlaysArray.length">' + '<h4 ng-if="title">{{ title }}</h4>' + '<div class="lf-baselayers">' + '<h5 class="lf-title" ng-if="baseTitle">{{ baseTitle }}</h5>' + '<div class="lf-row" ng-repeat="(key, layer) in baselayersArray">' + '<label class="lf-icon-bl" ng-click="changeBaseLayer(key, $event)">' + '<input class="leaflet-control-layers-selector" type="radio" name="lf-radio" ' + 'ng-show="false" ng-checked="baselayer === key" ng-value="key" /> ' + '<i class="lf-icon lf-icon-radio" ng-class="layer.icon"></i>' + '<div class="lf-text">{{layer.name}}</div>' + '</label>' + '</div>' + '</div>' + '<div class="lf-overlays">' + '<h5 class="lf-title" ng-if="overlaysTitle">{{ overlaysTitle }}</h5>' + '<div class="lf-container">' + '<div class="lf-row" ng-repeat="layer in (o = (overlaysArray | orderBy:\'index\':order))" ng-init="initIndex(layer, $index)">' + '<label class="lf-icon-ol-group" ng-if="showGroups &amp;&amp; layer.group &amp;&amp; layer.group != o[$index-1].group">' + '<input class="lf-control-layers-selector" type="checkbox" ng-show="false" ' + 'ng-change="changeGroupVisibility(layer.group)" ng-model="groupProperties[layer.group].visible"/> ' + '<i class="lf-icon lf-icon-check" ng-class="getGroupIcon(groupProperties[layer.group])"></i>' + '<div class="lf-text">{{ layer.group }}</div>' + '</label>' + '<label class="lf-icon-ol">' + '<input class="lf-control-layers-selector" type="checkbox" ng-show="false" ng-model="layer.visible"/> ' + '<i class="lf-icon lf-icon-check" ng-class="layer.icon"></i>' + '<div class="lf-text">{{layer.name}}</div>' + '</label>' + '<div class="lf-icons">' + '<i class="lf-icon lf-up" ng-class="icons.up" ng-click="moveLayer(layer, layer.index - orderNumber, $event)"></i> ' + '<i class="lf-icon lf-down" ng-class="icons.down" ng-click="moveLayer(layer, layer.index + orderNumber, $event)"></i> ' + '<i class="lf-icon lf-toggle-legend" ng-class="icons.toggleLegend" ng-if="layer.legend" ng-click="toggleLegend(layer)"></i> ' + '<i class="lf-icon lf-open" ng-class="getOpacityIcon(layer)" ng-click="toggleOpacity($event, layer)"></i>' + '</div>' + '<div class="lf-legend" ng-if="showLegend(layer)" ng-bind-html="unsafeHTML(layer.legend)"></div>' + '<div class="lf-opacity clearfix" ng-if="layer.visible &amp;&amp; layerProperties[layer.name].opacityControl">' + '<label ng-if="rangeIsSupported" class="pull-left" style="width: 50%">0</label>' + '<label ng-if="rangeIsSupported" class="pull-left text-right" style="width: 50%">100</label>' + '<input ng-if="rangeIsSupported" class="clearfix" type="range" min="0" max="100" class="lf-opacity-control" ' + 'ng-model="layerProperties[layer.name].opacity" ng-change="changeOpacity(layer)"/>' + '<h6 ng-if="!rangeIsSupported">Range is not supported in this browser</h6>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>',
	      link: function link(scope, element, attrs, controller) {
	        var isDefined = leafletHelpers.isDefined;
	        var leafletScope = controller.getLeafletScope();
	        var layers = leafletScope.layers;
	
	        scope.$watch('icons', function () {
	          var defaultIcons = {
	            uncheck: 'fa fa-square-o',
	            check: 'fa fa-check-square-o',
	            radio: 'fa fa-dot-circle-o',
	            unradio: 'fa fa-circle-o',
	            up: 'fa fa-angle-up',
	            down: 'fa fa-angle-down',
	            open: 'fa fa-angle-double-down',
	            close: 'fa fa-angle-double-up',
	            toggleLegend: 'fa fa-pencil-square-o'
	          };
	          if (isDefined(scope.icons)) {
	            angular.extend(defaultIcons, scope.icons);
	            angular.extend(scope.icons, defaultIcons);
	          } else {
	            scope.icons = defaultIcons;
	          }
	        });
	
	        // Setting layer stack order.
	        attrs.order = isDefined(attrs.order) && (attrs.order === 'normal' || attrs.order === 'reverse') ? attrs.order : 'normal';
	        scope.order = attrs.order === 'normal';
	        scope.orderNumber = attrs.order === 'normal' ? -1 : 1;
	
	        scope.layers = layers;
	        controller.getMap().then(function (map) {
	          leafletScope.$watch('layers.baselayers', function (newBaseLayers) {
	            var baselayersArray = {};
	            leafletData.getLayers().then(function (leafletLayers) {
	              var key;
	              for (key in newBaseLayers) {
	                var layer = newBaseLayers[key];
	                layer.icon = scope.icons[map.hasLayer(leafletLayers.baselayers[key]) ? 'radio' : 'unradio'];
	                baselayersArray[key] = layer;
	              }
	
	              scope.baselayersArray = baselayersArray;
	            });
	          });
	
	          leafletScope.$watch('layers.overlays', function (newOverlayLayers) {
	            var overlaysArray = [];
	            var groupVisibleCount = {};
	            leafletData.getLayers().then(function (leafletLayers) {
	              var key;
	              for (key in newOverlayLayers) {
	                var layer = newOverlayLayers[key];
	                layer.icon = scope.icons[layer.visible ? 'check' : 'uncheck'];
	                overlaysArray.push(layer);
	                if (!isDefined(scope.layerProperties[layer.name])) {
	                  scope.layerProperties[layer.name] = {
	                    opacity: isDefined(layer.layerOptions.opacity) ? layer.layerOptions.opacity * 100 : 100,
	                    opacityControl: false,
	                    showLegend: true
	                  };
	                }
	
	                if (isDefined(layer.group)) {
	                  if (!isDefined(scope.groupProperties[layer.group])) {
	                    scope.groupProperties[layer.group] = {
	                      visible: false
	                    };
	                  }
	
	                  groupVisibleCount[layer.group] = isDefined(groupVisibleCount[layer.group]) ? groupVisibleCount[layer.group] : {
	                    count: 0,
	                    visibles: 0
	                  };
	                  groupVisibleCount[layer.group].count++;
	                  if (layer.visible) {
	                    groupVisibleCount[layer.group].visibles++;
	                  }
	                }
	
	                if (isDefined(layer.index) && leafletLayers.overlays[key].setZIndex) {
	                  leafletLayers.overlays[key].setZIndex(newOverlayLayers[key].index);
	                }
	              }
	
	              for (key in groupVisibleCount) {
	                scope.groupProperties[key].visible = groupVisibleCount[key].visibles === groupVisibleCount[key].count;
	              }
	
	              scope.overlaysArray = overlaysArray;
	            });
	          }, true);
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('layers', ["$log", "$q", "leafletData", "leafletHelpers", "leafletLayerHelpers", "leafletControlHelpers", function ($log, $q, leafletData, leafletHelpers, leafletLayerHelpers, leafletControlHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	      controller: ["$scope", function ($scope) {
	        $scope._leafletLayers = $q.defer();
	        this.getLayers = function () {
	          return $scope._leafletLayers.promise;
	        };
	      }],
	
	      link: function link(scope, element, attrs, controller) {
	        var isDefined = leafletHelpers.isDefined;
	        var leafletLayers = {};
	        var leafletScope = controller.getLeafletScope();
	        var layers = leafletScope.layers;
	        var createLayer = leafletLayerHelpers.createLayer;
	        var safeAddLayer = leafletLayerHelpers.safeAddLayer;
	        var safeRemoveLayer = leafletLayerHelpers.safeRemoveLayer;
	        var updateLayersControl = leafletControlHelpers.updateLayersControl;
	        var isLayersControlVisible = false;
	
	        controller.getMap().then(function (map) {
	
	          // We have baselayers to add to the map
	          scope._leafletLayers.resolve(leafletLayers);
	          leafletData.setLayers(leafletLayers, attrs.id);
	
	          leafletLayers.baselayers = {};
	          leafletLayers.overlays = {};
	
	          var mapId = attrs.id;
	
	          // Setup all baselayers definitions
	          var oneVisibleLayer = false;
	          for (var layerName in layers.baselayers) {
	            var newBaseLayer = createLayer(layers.baselayers[layerName]);
	            if (!isDefined(newBaseLayer)) {
	              delete layers.baselayers[layerName];
	              continue;
	            }
	
	            leafletLayers.baselayers[layerName] = newBaseLayer;
	
	            // Only add the visible layer to the map, layer control manages the addition to the map
	            // of layers in its control
	            if (layers.baselayers[layerName].top === true) {
	              safeAddLayer(map, leafletLayers.baselayers[layerName]);
	              oneVisibleLayer = true;
	            }
	          }
	
	          // If there is no visible layer add first to the map
	          if (!oneVisibleLayer && Object.keys(leafletLayers.baselayers).length > 0) {
	            safeAddLayer(map, leafletLayers.baselayers[Object.keys(layers.baselayers)[0]]);
	          }
	
	          // Setup the Overlays
	          for (layerName in layers.overlays) {
	            //if (layers.overlays[layerName].type === 'cartodb') {
	            //
	            //}
	
	            var newOverlayLayer = createLayer(layers.overlays[layerName]);
	            if (!isDefined(newOverlayLayer)) {
	              delete layers.overlays[layerName];
	              continue;
	            }
	
	            leafletLayers.overlays[layerName] = newOverlayLayer;
	
	            // Only add the visible overlays to the map
	            if (layers.overlays[layerName].visible === true) {
	              safeAddLayer(map, leafletLayers.overlays[layerName]);
	            }
	          }
	
	          // Watch for the base layers
	          leafletScope.$watch('layers.baselayers', function (newBaseLayers, oldBaseLayers) {
	            if (angular.equals(newBaseLayers, oldBaseLayers)) {
	              isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, newBaseLayers, layers.overlays, leafletLayers);
	              return true;
	            }
	
	            // Delete layers from the array
	            for (var name in leafletLayers.baselayers) {
	              if (!isDefined(newBaseLayers[name]) || newBaseLayers[name].doRefresh) {
	                // Remove from the map if it's on it
	                if (map.hasLayer(leafletLayers.baselayers[name])) {
	                  map.removeLayer(leafletLayers.baselayers[name]);
	                }
	
	                delete leafletLayers.baselayers[name];
	
	                if (newBaseLayers[name] && newBaseLayers[name].doRefresh) {
	                  newBaseLayers[name].doRefresh = false;
	                }
	              }
	            }
	
	            // add new layers
	            for (var newName in newBaseLayers) {
	              if (!isDefined(leafletLayers.baselayers[newName])) {
	                var testBaseLayer = createLayer(newBaseLayers[newName]);
	                if (isDefined(testBaseLayer)) {
	                  leafletLayers.baselayers[newName] = testBaseLayer;
	
	                  // Only add the visible layer to the map
	                  if (newBaseLayers[newName].top === true) {
	                    safeAddLayer(map, leafletLayers.baselayers[newName]);
	                  }
	                }
	              } else {
	                if (newBaseLayers[newName].top === true && !map.hasLayer(leafletLayers.baselayers[newName])) {
	                  safeAddLayer(map, leafletLayers.baselayers[newName]);
	                } else if (newBaseLayers[newName].top === false && map.hasLayer(leafletLayers.baselayers[newName])) {
	                  map.removeLayer(leafletLayers.baselayers[newName]);
	                }
	              }
	            }
	
	            //we have layers, so we need to make, at least, one active
	            var found = false;
	
	            // search for an active layer
	            for (var key in leafletLayers.baselayers) {
	              if (map.hasLayer(leafletLayers.baselayers[key])) {
	                found = true;
	                break;
	              }
	            }
	
	            // If there is no active layer make one active
	            if (!found && Object.keys(leafletLayers.baselayers).length > 0) {
	              safeAddLayer(map, leafletLayers.baselayers[Object.keys(leafletLayers.baselayers)[0]]);
	            }
	
	            // Only show the layers switch selector control if we have more than one baselayer + overlay
	            isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, newBaseLayers, layers.overlays, leafletLayers);
	          }, true);
	
	          // Watch for the overlay layers
	          leafletScope.$watch('layers.overlays', function (newOverlayLayers, oldOverlayLayers) {
	            if (angular.equals(newOverlayLayers, oldOverlayLayers)) {
	              isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, layers.baselayers, newOverlayLayers, leafletLayers);
	              return true;
	            }
	
	            // Delete layers from the array
	            for (var name in leafletLayers.overlays) {
	              if (!isDefined(newOverlayLayers[name]) || newOverlayLayers[name].doRefresh) {
	                // Remove from the map if it's on it
	                if (map.hasLayer(leafletLayers.overlays[name])) {
	                  // Safe remove when ArcGIS layers is loading.
	                  var options = isDefined(newOverlayLayers[name]) ? newOverlayLayers[name].layerOptions : null;
	                  safeRemoveLayer(map, leafletLayers.overlays[name], options);
	                }
	
	                // TODO: Depending on the layer type we will have to delete what's included on it
	                delete leafletLayers.overlays[name];
	
	                if (newOverlayLayers[name] && newOverlayLayers[name].doRefresh) {
	                  newOverlayLayers[name].doRefresh = false;
	                }
	              }
	            }
	
	            // add new overlays
	            for (var newName in newOverlayLayers) {
	              if (!isDefined(leafletLayers.overlays[newName])) {
	                var testOverlayLayer = createLayer(newOverlayLayers[newName]);
	                if (!isDefined(testOverlayLayer)) {
	                  // If the layer creation fails, continue to the next overlay
	                  continue;
	                }
	
	                leafletLayers.overlays[newName] = testOverlayLayer;
	                if (newOverlayLayers[newName].visible === true) {
	                  safeAddLayer(map, leafletLayers.overlays[newName]);
	                }
	              } else {
	                // check for the .visible property to hide/show overLayers
	                if (newOverlayLayers[newName].visible && !map.hasLayer(leafletLayers.overlays[newName])) {
	                  safeAddLayer(map, leafletLayers.overlays[newName]);
	                } else if (newOverlayLayers[newName].visible === false && map.hasLayer(leafletLayers.overlays[newName])) {
	                  // Safe remove when ArcGIS layers is loading.
	                  safeRemoveLayer(map, leafletLayers.overlays[newName], newOverlayLayers[newName].layerOptions);
	                }
	              }
	
	              //refresh heatmap data if present
	              if (newOverlayLayers[newName].visible && map._loaded && newOverlayLayers[newName].data && newOverlayLayers[newName].type === 'heatmap') {
	                leafletLayers.overlays[newName].setData(newOverlayLayers[newName].data);
	                leafletLayers.overlays[newName].update();
	              }
	            }
	
	            // Only add the layers switch selector control if we have more than one baselayer + overlay
	            isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, layers.baselayers, newOverlayLayers, leafletLayers);
	          }, true);
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('legend', ["$log", "$http", "leafletHelpers", "leafletLegendHelpers", function ($log, $http, leafletHelpers, leafletLegendHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	
	        var isArray = leafletHelpers.isArray;
	        var isDefined = leafletHelpers.isDefined;
	        var isFunction = leafletHelpers.isFunction;
	        var leafletScope = controller.getLeafletScope();
	        var legend = leafletScope.legend;
	
	        var legendClass;
	        var position;
	        var leafletLegend;
	        var type;
	
	        leafletScope.$watch('legend', function (newLegend) {
	
	          if (isDefined(newLegend)) {
	
	            legendClass = newLegend.legendClass ? newLegend.legendClass : 'legend';
	
	            position = newLegend.position || 'bottomright';
	
	            // default to arcgis
	            type = newLegend.type || 'arcgis';
	          }
	        }, true);
	
	        controller.getMap().then(function (map) {
	
	          leafletScope.$watch('legend', function (newLegend) {
	
	            if (!isDefined(newLegend)) {
	
	              if (isDefined(leafletLegend)) {
	                leafletLegend.removeFrom(map);
	                leafletLegend = null;
	              }
	
	              return;
	            }
	
	            if (!isDefined(newLegend.url) && type === 'arcgis' && (!isArray(newLegend.colors) || !isArray(newLegend.labels) || newLegend.colors.length !== newLegend.labels.length)) {
	
	              $log.warn('[AngularJS - Leaflet] legend.colors and legend.labels must be set.');
	
	              return;
	            }
	
	            if (isDefined(newLegend.url)) {
	
	              $log.info('[AngularJS - Leaflet] loading legend service.');
	
	              return;
	            }
	
	            if (isDefined(leafletLegend)) {
	              leafletLegend.removeFrom(map);
	              leafletLegend = null;
	            }
	
	            leafletLegend = L.control({
	              position: position
	            });
	            if (type === 'arcgis') {
	              leafletLegend.onAdd = leafletLegendHelpers.getOnAddArrayLegend(newLegend, legendClass);
	            }
	
	            leafletLegend.addTo(map);
	          });
	
	          leafletScope.$watch('legend.url', function (newURL) {
	
	            if (!isDefined(newURL)) {
	              return;
	            }
	
	            $http.get(newURL).success(function (legendData) {
	
	              if (isDefined(leafletLegend)) {
	
	                leafletLegendHelpers.updateLegend(leafletLegend.getContainer(), legendData, type, newURL);
	              } else {
	
	                leafletLegend = L.control({
	                  position: position
	                });
	                leafletLegend.onAdd = leafletLegendHelpers.getOnAddLegend(legendData, legendClass, type, newURL);
	                leafletLegend.addTo(map);
	              }
	
	              if (isDefined(legend.loadedData) && isFunction(legend.loadedData)) {
	                legend.loadedData();
	              }
	            }).error(function () {
	              $log.warn('[AngularJS - Leaflet] legend.url not loaded.');
	            });
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('markers', ["$log", "$rootScope", "$q", "leafletData", "leafletHelpers", "leafletMapDefaults", "leafletMarkersHelpers", "leafletMarkerEvents", "leafletIterators", "leafletWatchHelpers", "leafletDirectiveControlsHelpers", function ($log, $rootScope, $q, leafletData, leafletHelpers, leafletMapDefaults, leafletMarkersHelpers, leafletMarkerEvents, leafletIterators, leafletWatchHelpers, leafletDirectiveControlsHelpers) {
	    //less terse vars to helpers
	    var isDefined = leafletHelpers.isDefined;
	    var errorHeader = leafletHelpers.errorHeader;
	    var Helpers = leafletHelpers;
	    var isString = leafletHelpers.isString;
	    var addMarkerWatcher = leafletMarkersHelpers.addMarkerWatcher;
	    var updateMarker = leafletMarkersHelpers.updateMarker;
	    var listenMarkerEvents = leafletMarkersHelpers.listenMarkerEvents;
	    var addMarkerToGroup = leafletMarkersHelpers.addMarkerToGroup;
	    var createMarker = leafletMarkersHelpers.createMarker;
	    var deleteMarker = leafletMarkersHelpers.deleteMarker;
	    var $it = leafletIterators;
	    var _markersWatchOptions = leafletHelpers.watchOptions;
	    var maybeWatch = leafletWatchHelpers.maybeWatch;
	    var extendDirectiveControls = leafletDirectiveControlsHelpers.extend;
	
	    var _getLMarker = function _getLMarker(leafletMarkers, name, maybeLayerName) {
	      if (!Object.keys(leafletMarkers).length) return;
	      if (maybeLayerName && isString(maybeLayerName)) {
	        if (!leafletMarkers[maybeLayerName] || !Object.keys(leafletMarkers[maybeLayerName]).length) return;
	        return leafletMarkers[maybeLayerName][name];
	      }
	
	      return leafletMarkers[name];
	    };
	
	    var _setLMarker = function _setLMarker(lObject, leafletMarkers, name, maybeLayerName) {
	      if (maybeLayerName && isString(maybeLayerName)) {
	        if (!isDefined(leafletMarkers[maybeLayerName])) leafletMarkers[maybeLayerName] = {};
	        leafletMarkers[maybeLayerName][name] = lObject;
	      } else leafletMarkers[name] = lObject;
	      return lObject;
	    };
	
	    var _maybeAddMarkerToLayer = function _maybeAddMarkerToLayer(layerName, layers, model, marker, doIndividualWatch, map) {
	
	      if (!isString(layerName)) {
	        $log.error(errorHeader + ' A layername must be a string');
	        return false;
	      }
	
	      if (!isDefined(layers)) {
	        $log.error(errorHeader + ' You must add layers to the directive if the markers are going to use this functionality.');
	        return false;
	      }
	
	      if (!isDefined(layers.overlays) || !isDefined(layers.overlays[layerName])) {
	        $log.error(errorHeader + ' A marker can only be added to a layer of type "group"');
	        return false;
	      }
	
	      var layerGroup = layers.overlays[layerName];
	      if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
	        $log.error(errorHeader + ' Adding a marker to an overlay needs a overlay of the type "group" or "featureGroup"');
	        return false;
	      }
	
	      // The marker goes to a correct layer group, so first of all we add it
	      layerGroup.addLayer(marker);
	
	      // The marker is automatically added to the map depending on the visibility
	      // of the layer, so we only have to open the popup if the marker is in the map
	      if (!doIndividualWatch && map.hasLayer(marker) && model.focus === true) {
	        marker.openPopup();
	      }
	
	      return true;
	    };
	
	    //TODO: move to leafletMarkersHelpers??? or make a new class/function file (leafletMarkersHelpers is large already)
	    var _addMarkers = function _addMarkers(mapId, markersToRender, oldModels, map, layers, leafletMarkers, leafletScope, watchOptions, maybeLayerName, skips) {
	      for (var newName in markersToRender) {
	        if (skips[newName]) continue;
	
	        if (newName.search('-') !== -1) {
	          $log.error('The marker can\'t use a "-" on his key name: "' + newName + '".');
	          continue;
	        }
	
	        var model = Helpers.copy(markersToRender[newName]);
	        var pathToMarker = Helpers.getObjectDotPath(maybeLayerName ? [maybeLayerName, newName] : [newName]);
	        var maybeLMarker = _getLMarker(leafletMarkers, newName, maybeLayerName);
	        if (!isDefined(maybeLMarker)) {
	          //(nmccready) very important to not have model changes when lObject is changed
	          //this might be desirable in some cases but it causes two-way binding to lObject which is not ideal
	          //if it is left as the reference then all changes from oldModel vs newModel are ignored
	          //see _destroy (where modelDiff becomes meaningless if we do not copy here)
	          var marker = createMarker(model);
	          var layerName = (model ? model.layer : undefined) || maybeLayerName; //original way takes pref
	          if (!isDefined(marker)) {
	            $log.error(errorHeader + ' Received invalid data on the marker ' + newName + '.');
	            continue;
	          }
	
	          _setLMarker(marker, leafletMarkers, newName, maybeLayerName);
	
	          // Bind message
	          if (isDefined(model.message)) {
	            marker.bindPopup(model.message, model.popupOptions);
	          }
	
	          // Add the marker to a cluster group if needed
	          if (isDefined(model.group)) {
	            var groupOptions = isDefined(model.groupOption) ? model.groupOption : null;
	            addMarkerToGroup(marker, model.group, groupOptions, map);
	          }
	
	          // Show label if defined
	          if (Helpers.LabelPlugin.isLoaded() && isDefined(model.label) && isDefined(model.label.message)) {
	            marker.bindLabel(model.label.message, model.label.options);
	          }
	
	          // Check if the marker should be added to a layer
	          if (isDefined(model) && (isDefined(model.layer) || isDefined(maybeLayerName))) {
	
	            var pass = _maybeAddMarkerToLayer(layerName, layers, model, marker, watchOptions.individual.doWatch, map);
	            if (!pass) continue; //something went wrong move on in the loop
	          } else if (!isDefined(model.group)) {
	            // We do not have a layer attr, so the marker goes to the map layer
	            map.addLayer(marker);
	            if (!watchOptions.individual.doWatch && model.focus === true) {
	              marker.openPopup();
	            }
	          }
	
	          if (watchOptions.individual.doWatch) {
	            addMarkerWatcher(marker, pathToMarker, leafletScope, layers, map, watchOptions.individual.isDeep);
	          }
	
	          listenMarkerEvents(marker, model, leafletScope, watchOptions.individual.doWatch, map);
	          leafletMarkerEvents.bindEvents(mapId, marker, pathToMarker, model, leafletScope, layerName);
	        } else {
	          var oldModel = isDefined(oldModel) ? oldModels[newName] : undefined;
	          updateMarker(model, oldModel, maybeLMarker, pathToMarker, leafletScope, layers, map);
	        }
	      }
	    };
	
	    var _seeWhatWeAlreadyHave = function _seeWhatWeAlreadyHave(markerModels, oldMarkerModels, lMarkers, isEqual, cb) {
	      var hasLogged = false;
	      var equals = false;
	      var oldMarker;
	      var newMarker;
	
	      var doCheckOldModel = isDefined(oldMarkerModels);
	      for (var name in lMarkers) {
	        if (!hasLogged) {
	          $log.debug(errorHeader + '[markers] destroy: ');
	          hasLogged = true;
	        }
	
	        if (doCheckOldModel) {
	          //might want to make the option (in watch options) to disable deep checking
	          //ie the options to only check !== (reference check) instead of angular.equals (slow)
	          newMarker = markerModels[name];
	          oldMarker = oldMarkerModels[name];
	          equals = angular.equals(newMarker, oldMarker) && isEqual;
	        }
	
	        if (!isDefined(markerModels) || !Object.keys(markerModels).length || !isDefined(markerModels[name]) || !Object.keys(markerModels[name]).length || equals) {
	          if (cb && Helpers.isFunction(cb)) cb(newMarker, oldMarker, name);
	        }
	      }
	    };
	
	    var _destroy = function _destroy(markerModels, oldMarkerModels, lMarkers, map, layers) {
	      _seeWhatWeAlreadyHave(markerModels, oldMarkerModels, lMarkers, false, function (newMarker, oldMarker, lMarkerName) {
	        $log.debug(errorHeader + '[marker] is deleting marker: ' + lMarkerName);
	        deleteMarker(lMarkers[lMarkerName], map, layers);
	        delete lMarkers[lMarkerName];
	      });
	    };
	
	    var _getNewModelsToSkipp = function _getNewModelsToSkipp(newModels, oldModels, lMarkers) {
	      var skips = {};
	      _seeWhatWeAlreadyHave(newModels, oldModels, lMarkers, true, function (newMarker, oldMarker, lMarkerName) {
	        $log.debug(errorHeader + '[marker] is already rendered, marker: ' + lMarkerName);
	        skips[lMarkerName] = newMarker;
	      });
	
	      return skips;
	    };
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: ['leaflet', '?layers'],
	
	      link: function link(scope, element, attrs, controller) {
	        var mapController = controller[0];
	        var leafletScope = mapController.getLeafletScope();
	
	        mapController.getMap().then(function (map) {
	          var leafletMarkers = {};
	          var getLayers;
	
	          // If the layers attribute is used, we must wait until the layers are created
	          if (isDefined(controller[1])) {
	            getLayers = controller[1].getLayers;
	          } else {
	            getLayers = function getLayers() {
	              var deferred = $q.defer();
	              deferred.resolve();
	              return deferred.promise;
	            };
	          }
	
	          var watchOptions = leafletScope.markersWatchOptions || _markersWatchOptions;
	
	          // backwards compat
	          if (isDefined(attrs.watchMarkers)) watchOptions.doWatch = watchOptions.individual.doWatch = !isDefined(attrs.watchMarkers) || Helpers.isTruthy(attrs.watchMarkers);
	
	          var isNested = isDefined(attrs.markersNested) && Helpers.isTruthy(attrs.markersNested);
	
	          getLayers().then(function (layers) {
	            var _clean = function _clean(models, oldModels) {
	              if (isNested) {
	                $it.each(models, function (markerToMaybeDel, layerName) {
	                  var oldModel = isDefined(oldModel) ? oldModels[layerName] : undefined;
	                  _destroy(markerToMaybeDel, oldModel, leafletMarkers[layerName], map, layers);
	                });
	
	                return;
	              }
	
	              _destroy(models, oldModels, leafletMarkers, map, layers);
	            };
	
	            var _create = function _create(models, oldModels) {
	              _clean(models, oldModels);
	              var skips = null;
	              if (isNested) {
	                $it.each(models, function (markersToAdd, layerName) {
	                  var oldModel = isDefined(oldModel) ? oldModels[layerName] : undefined;
	                  skips = _getNewModelsToSkipp(models[layerName], oldModel, leafletMarkers[layerName]);
	                  _addMarkers(attrs.id, markersToAdd, oldModels, map, layers, leafletMarkers, leafletScope, watchOptions, layerName, skips);
	                });
	
	                return;
	              }
	
	              skips = _getNewModelsToSkipp(models, oldModels, leafletMarkers);
	              _addMarkers(attrs.id, models, oldModels, map, layers, leafletMarkers, leafletScope, watchOptions, undefined, skips);
	            };
	
	            extendDirectiveControls(attrs.id, 'markers', _create, _clean);
	            leafletData.setMarkers(leafletMarkers, attrs.id);
	
	            maybeWatch(leafletScope, 'markers', watchOptions, function (newMarkers, oldMarkers) {
	              _create(newMarkers, oldMarkers);
	            });
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('maxbounds', ["$log", "leafletMapDefaults", "leafletBoundsHelpers", "leafletHelpers", function ($log, leafletMapDefaults, leafletBoundsHelpers, leafletHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        var leafletScope = controller.getLeafletScope();
	        var isValidBounds = leafletBoundsHelpers.isValidBounds;
	        var isNumber = leafletHelpers.isNumber;
	
	        controller.getMap().then(function (map) {
	          leafletScope.$watch('maxbounds', function (maxbounds) {
	            if (!isValidBounds(maxbounds)) {
	              // Unset any previous maxbounds
	              map.setMaxBounds();
	              return;
	            }
	
	            var leafletBounds = leafletBoundsHelpers.createLeafletBounds(maxbounds);
	            if (isNumber(maxbounds.pad)) {
	              leafletBounds = leafletBounds.pad(maxbounds.pad);
	            }
	
	            map.setMaxBounds(leafletBounds);
	            if (!attrs.center && !attrs.lfCenter) {
	              map.fitBounds(leafletBounds);
	            }
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('paths', ["$log", "$q", "leafletData", "leafletMapDefaults", "leafletHelpers", "leafletPathsHelpers", "leafletPathEvents", function ($log, $q, leafletData, leafletMapDefaults, leafletHelpers, leafletPathsHelpers, leafletPathEvents) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: ['leaflet', '?layers'],
	
	      link: function link(scope, element, attrs, controller) {
	        var mapController = controller[0];
	        var isDefined = leafletHelpers.isDefined;
	        var isString = leafletHelpers.isString;
	        var leafletScope = mapController.getLeafletScope();
	        var paths = leafletScope.paths;
	        var createPath = leafletPathsHelpers.createPath;
	        var bindPathEvents = leafletPathEvents.bindPathEvents;
	        var setPathOptions = leafletPathsHelpers.setPathOptions;
	
	        mapController.getMap().then(function (map) {
	          var defaults = leafletMapDefaults.getDefaults(attrs.id);
	          var getLayers;
	
	          // If the layers attribute is used, we must wait until the layers are created
	          if (isDefined(controller[1])) {
	            getLayers = controller[1].getLayers;
	          } else {
	            getLayers = function getLayers() {
	              var deferred = $q.defer();
	              deferred.resolve();
	              return deferred.promise;
	            };
	          }
	
	          if (!isDefined(paths)) {
	            return;
	          }
	
	          getLayers().then(function (layers) {
	
	            var leafletPaths = {};
	            leafletData.setPaths(leafletPaths, attrs.id);
	
	            // Should we watch for every specific marker on the map?
	            var shouldWatch = !isDefined(attrs.watchPaths) || attrs.watchPaths === 'true';
	
	            // Function for listening every single path once created
	            var watchPathFn = function watchPathFn(leafletPath, name) {
	              var clearWatch = leafletScope.$watch('paths["' + name + '"]', function (pathData, old) {
	                if (!isDefined(pathData)) {
	                  if (isDefined(old.layer)) {
	                    for (var i in layers.overlays) {
	                      var overlay = layers.overlays[i];
	                      overlay.removeLayer(leafletPath);
	                    }
	                  }
	
	                  map.removeLayer(leafletPath);
	                  clearWatch();
	                  return;
	                }
	
	                setPathOptions(leafletPath, pathData.type, pathData);
	              }, true);
	            };
	
	            leafletScope.$watchCollection('paths', function (newPaths) {
	
	              // Delete paths (by name) from the array
	              for (var name in leafletPaths) {
	                if (!isDefined(newPaths[name])) {
	                  map.removeLayer(leafletPaths[name]);
	                  delete leafletPaths[name];
	                }
	              }
	
	              // Create the new paths
	              for (var newName in newPaths) {
	                if (newName.search('\\$') === 0) {
	                  continue;
	                }
	
	                if (newName.search('-') !== -1) {
	                  $log.error('[AngularJS - Leaflet] The path name "' + newName + '" is not valid. It must not include "-" and a number.');
	                  continue;
	                }
	
	                if (!isDefined(leafletPaths[newName])) {
	                  var pathData = newPaths[newName];
	                  var newPath = createPath(newName, newPaths[newName], defaults);
	
	                  // bind popup if defined
	                  if (isDefined(newPath) && isDefined(pathData.message)) {
	                    newPath.bindPopup(pathData.message, pathData.popupOptions);
	                  }
	
	                  // Show label if defined
	                  if (leafletHelpers.LabelPlugin.isLoaded() && isDefined(pathData.label) && isDefined(pathData.label.message)) {
	                    newPath.bindLabel(pathData.label.message, pathData.label.options);
	                  }
	
	                  // Check if the marker should be added to a layer
	                  if (isDefined(pathData) && isDefined(pathData.layer)) {
	
	                    if (!isString(pathData.layer)) {
	                      $log.error('[AngularJS - Leaflet] A layername must be a string');
	                      continue;
	                    }
	
	                    if (!isDefined(layers)) {
	                      $log.error('[AngularJS - Leaflet] You must add layers to the directive if the markers are going to use this functionality.');
	                      continue;
	                    }
	
	                    if (!isDefined(layers.overlays) || !isDefined(layers.overlays[pathData.layer])) {
	                      $log.error('[AngularJS - Leaflet] A path can only be added to a layer of type "group"');
	                      continue;
	                    }
	
	                    var layerGroup = layers.overlays[pathData.layer];
	                    if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
	                      $log.error('[AngularJS - Leaflet] Adding a path to an overlay needs a overlay of the type "group" or "featureGroup"');
	                      continue;
	                    }
	
	                    // Listen for changes on the new path
	                    leafletPaths[newName] = newPath;
	
	                    // The path goes to a correct layer group, so first of all we add it
	                    layerGroup.addLayer(newPath);
	
	                    if (shouldWatch) {
	                      watchPathFn(newPath, newName);
	                    } else {
	                      setPathOptions(newPath, pathData.type, pathData);
	                    }
	                  } else if (isDefined(newPath)) {
	                    // Listen for changes on the new path
	                    leafletPaths[newName] = newPath;
	                    map.addLayer(newPath);
	
	                    if (shouldWatch) {
	                      watchPathFn(newPath, newName);
	                    } else {
	                      setPathOptions(newPath, pathData.type, pathData);
	                    }
	                  }
	
	                  bindPathEvents(attrs.id, newPath, newName, pathData, leafletScope);
	                }
	              }
	            });
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('tiles', ["$log", "leafletData", "leafletMapDefaults", "leafletHelpers", function ($log, leafletData, leafletMapDefaults, leafletHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        var isDefined = leafletHelpers.isDefined;
	        var leafletScope = controller.getLeafletScope();
	        var tiles = leafletScope.tiles;
	
	        if (!isDefined(tiles) || !isDefined(tiles.url)) {
	          $log.warn('[AngularJS - Leaflet] The \'tiles\' definition doesn\'t have the \'url\' property.');
	          return;
	        }
	
	        controller.getMap().then(function (map) {
	          var defaults = leafletMapDefaults.getDefaults(attrs.id);
	          var tileLayerObj;
	          leafletScope.$watch('tiles', function (tiles, oldtiles) {
	            var tileLayerOptions = defaults.tileLayerOptions;
	            var tileLayerUrl = defaults.tileLayer;
	
	            // If no valid tiles are in the scope, remove the last layer
	            if (!isDefined(tiles.url) && isDefined(tileLayerObj)) {
	              map.removeLayer(tileLayerObj);
	              return;
	            }
	
	            // No leafletTiles object defined yet
	            if (!isDefined(tileLayerObj)) {
	              if (isDefined(tiles.options)) {
	                angular.copy(tiles.options, tileLayerOptions);
	              }
	
	              if (isDefined(tiles.url)) {
	                tileLayerUrl = tiles.url;
	              }
	
	              if (tiles.type === 'wms') {
	                tileLayerObj = L.tileLayer.wms(tileLayerUrl, tileLayerOptions);
	              } else {
	                tileLayerObj = L.tileLayer(tileLayerUrl, tileLayerOptions);
	              }
	
	              tileLayerObj.addTo(map);
	              leafletData.setTiles(tileLayerObj, attrs.id);
	              return;
	            }
	
	            // If the options of the tilelayer is changed, we need to redraw the layer
	            if (isDefined(tiles.url) && isDefined(tiles.options) && (tiles.type !== oldtiles.type || !angular.equals(tiles.options, tileLayerOptions))) {
	              map.removeLayer(tileLayerObj);
	              tileLayerOptions = defaults.tileLayerOptions;
	              angular.copy(tiles.options, tileLayerOptions);
	              tileLayerUrl = tiles.url;
	
	              if (tiles.type === 'wms') {
	                tileLayerObj = L.tileLayer.wms(tileLayerUrl, tileLayerOptions);
	              } else {
	                tileLayerObj = L.tileLayer(tileLayerUrl, tileLayerOptions);
	              }
	
	              tileLayerObj.addTo(map);
	              leafletData.setTiles(tileLayerObj, attrs.id);
	              return;
	            }
	
	            // Only the URL of the layer is changed, update the tiles object
	            if (isDefined(tiles.url)) {
	              tileLayerObj.setUrl(tiles.url);
	            }
	          }, true);
	        });
	      }
	    };
	  }]);
	
	  /*
	      Create multiple similar directives for watchOptions to support directiveControl
	      instead. (when watches are disabled)
	      NgAnnotate does not work here due to the functional creation
	  */
	  ['markers', 'geojson'].forEach(function (name) {
	    angular.module('leaflet-directive').directive(name + 'WatchOptions', ['$log', '$rootScope', '$q', 'leafletData', 'leafletHelpers', function ($log, $rootScope, $q, leafletData, leafletHelpers) {
	
	      var isDefined = leafletHelpers.isDefined,
	          errorHeader = leafletHelpers.errorHeader,
	          isObject = leafletHelpers.isObject,
	          _watchOptions = leafletHelpers.watchOptions;
	
	      return {
	        restrict: 'A',
	        scope: false,
	        replace: false,
	        require: ['leaflet'],
	
	        link: function link(scope, element, attrs, controller) {
	          var mapController = controller[0],
	              leafletScope = mapController.getLeafletScope();
	
	          mapController.getMap().then(function () {
	            if (isDefined(scope[name + 'WatchOptions'])) {
	              if (isObject(scope[name + 'WatchOptions'])) angular.extend(_watchOptions, scope[name + 'WatchOptions']);else $log.error(errorHeader + '[' + name + 'WatchOptions] is not an object');
	              leafletScope[name + 'WatchOptions'] = _watchOptions;
	            }
	          });
	        }
	      };
	    }]);
	  });
	
	  angular.module('leaflet-directive').factory('LeafletEventsHelpersFactory', ["$rootScope", "$q", "$log", "leafletHelpers", function ($rootScope, $q, $log, leafletHelpers) {
	    var safeApply = leafletHelpers.safeApply;
	    var isDefined = leafletHelpers.isDefined;
	    var isObject = leafletHelpers.isObject;
	    var isArray = leafletHelpers.isArray;
	    var errorHeader = leafletHelpers.errorHeader;
	
	    var EventsHelper = function EventsHelper(rootBroadcastName, lObjectType) {
	      this.rootBroadcastName = rootBroadcastName;
	      $log.debug('LeafletEventsHelpersFactory: lObjectType: ' + lObjectType + 'rootBroadcastName: ' + rootBroadcastName);
	
	      //used to path/key out certain properties based on the type , "markers", "geojson"
	      this.lObjectType = lObjectType;
	    };
	
	    EventsHelper.prototype.getAvailableEvents = function () {
	      return [];
	    };
	
	    /*
	     argument: name: Note this can be a single string or dot notation
	     Example:
	     markerModel : {
	     m1: { lat:_, lon: _}
	     }
	     //would yield name of
	     name = "m1"
	      If nested:
	     markerModel : {
	     cars: {
	     m1: { lat:_, lon: _}
	     }
	     }
	     //would yield name of
	     name = "cars.m1"
	     */
	    EventsHelper.prototype.genDispatchEvent = function (maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra) {
	      var _this = this;
	
	      maybeMapId = maybeMapId || '';
	      if (maybeMapId) maybeMapId = '.' + maybeMapId;
	
	      return function (e) {
	        var broadcastName = _this.rootBroadcastName + maybeMapId + '.' + eventName;
	        $log.debug(broadcastName);
	        _this.fire(leafletScope, broadcastName, logic, e, e.target || lObject, model, name, layerName, extra);
	      };
	    };
	
	    EventsHelper.prototype.fire = function (scope, broadcastName, logic, event, lObject, model, modelName, layerName) {
	      // Safely broadcast the event
	      safeApply(scope, function () {
	        var toSend = {
	          leafletEvent: event,
	          leafletObject: lObject,
	          modelName: modelName,
	          model: model
	        };
	        if (isDefined(layerName)) angular.extend(toSend, { layerName: layerName });
	
	        if (logic === 'emit') {
	          scope.$emit(broadcastName, toSend);
	        } else {
	          $rootScope.$broadcast(broadcastName, toSend);
	        }
	      });
	    };
	
	    EventsHelper.prototype.bindEvents = function (maybeMapId, lObject, name, model, leafletScope, layerName, extra) {
	      var events = [];
	      var logic = 'emit';
	      var _this = this;
	
	      if (!isDefined(leafletScope.eventBroadcast)) {
	        // Backward compatibility, if no event-broadcast attribute, all events are broadcasted
	        events = this.getAvailableEvents();
	      } else if (!isObject(leafletScope.eventBroadcast)) {
	        // Not a valid object
	        $log.error(errorHeader + 'event-broadcast must be an object check your model.');
	      } else {
	        // We have a possible valid object
	        if (!isDefined(leafletScope.eventBroadcast[_this.lObjectType])) {
	          // We do not have events enable/disable do we do nothing (all enabled by default)
	          events = this.getAvailableEvents();
	        } else if (!isObject(leafletScope.eventBroadcast[_this.lObjectType])) {
	          // Not a valid object
	          $log.warn(errorHeader + 'event-broadcast.' + [_this.lObjectType] + ' must be an object check your model.');
	        } else {
	          // We have a possible valid map object
	          // Event propadation logic
	          if (isDefined(leafletScope.eventBroadcast[this.lObjectType].logic)) {
	            // We take care of possible propagation logic
	            if (leafletScope.eventBroadcast[_this.lObjectType].logic !== 'emit' && leafletScope.eventBroadcast[_this.lObjectType].logic !== 'broadcast') $log.warn(errorHeader + 'Available event propagation logic are: \'emit\' or \'broadcast\'.');
	          }
	
	          // Enable / Disable
	          var eventsEnable = false;
	          var eventsDisable = false;
	          if (isDefined(leafletScope.eventBroadcast[_this.lObjectType].enable) && isArray(leafletScope.eventBroadcast[_this.lObjectType].enable)) eventsEnable = true;
	          if (isDefined(leafletScope.eventBroadcast[_this.lObjectType].disable) && isArray(leafletScope.eventBroadcast[_this.lObjectType].disable)) eventsDisable = true;
	
	          if (eventsEnable && eventsDisable) {
	            // Both are active, this is an error
	            $log.warn(errorHeader + 'can not enable and disable events at the same time');
	          } else if (!eventsEnable && !eventsDisable) {
	            // Both are inactive, this is an error
	            $log.warn(errorHeader + 'must enable or disable events');
	          } else {
	            // At this point the object is OK, lets enable or disable events
	            if (eventsEnable) {
	              // Enable events
	              leafletScope.eventBroadcast[this.lObjectType].enable.forEach(function (eventName) {
	                // Do we have already the event enabled?
	                if (events.indexOf(eventName) !== -1) {
	                  // Repeated event, this is an error
	                  $log.warn(errorHeader + 'This event ' + eventName + ' is already enabled');
	                } else {
	                  // Does the event exists?
	                  if (_this.getAvailableEvents().indexOf(eventName) === -1) {
	                    // The event does not exists, this is an error
	                    $log.warn(errorHeader + 'This event ' + eventName + ' does not exist');
	                  } else {
	                    // All ok enable the event
	                    events.push(eventName);
	                  }
	                }
	              });
	            } else {
	              // Disable events
	              events = this.getAvailableEvents();
	              leafletScope.eventBroadcast[_this.lObjectType].disable.forEach(function (eventName) {
	                var index = events.indexOf(eventName);
	                if (index === -1) {
	                  // The event does not exist
	                  $log.warn(errorHeader + 'This event ' + eventName + ' does not exist or has been already disabled');
	                } else {
	                  events.splice(index, 1);
	                }
	              });
	            }
	          }
	        }
	      }
	
	      events.forEach(function (eventName) {
	        lObject.on(eventName, _this.genDispatchEvent(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra));
	      });
	
	      return logic;
	    };
	
	    return EventsHelper;
	  }]).service('leafletEventsHelpers', ["LeafletEventsHelpersFactory", function (LeafletEventsHelpersFactory) {
	    return new LeafletEventsHelpersFactory();
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletGeoJsonEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", "leafletData", function ($rootScope, $q, $log, leafletHelpers, LeafletEventsHelpersFactory, leafletData) {
	    var safeApply = leafletHelpers.safeApply;
	    var EventsHelper = LeafletEventsHelpersFactory;
	
	    var GeoJsonEvents = function GeoJsonEvents() {
	      EventsHelper.call(this, 'leafletDirectiveGeoJson', 'geojson');
	    };
	
	    GeoJsonEvents.prototype = new EventsHelper();
	
	    GeoJsonEvents.prototype.genDispatchEvent = function (maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra) {
	      var base = EventsHelper.prototype.genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName);
	      var _this = this;
	
	      return function (e) {
	        if (eventName === 'mouseout') {
	          if (extra.resetStyleOnMouseout) {
	            leafletData.getGeoJSON(extra.mapId).then(function (leafletGeoJSON) {
	              //this is broken on nested needs to traverse or user layerName (nested)
	              var lobj = layerName ? leafletGeoJSON[layerName] : leafletGeoJSON;
	              lobj.resetStyle(e.target);
	            });
	          }
	
	          safeApply(leafletScope, function () {
	            $rootScope.$broadcast(_this.rootBroadcastName + '.mouseout', e);
	          });
	        }
	
	        base(e); //common
	      };
	    };
	
	    GeoJsonEvents.prototype.getAvailableEvents = function () {
	      return ['click', 'dblclick', 'mouseover', 'mouseout'];
	    };
	
	    return new GeoJsonEvents();
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletLabelEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", function ($rootScope, $q, $log, leafletHelpers, LeafletEventsHelpersFactory) {
	    var Helpers = leafletHelpers;
	    var EventsHelper = LeafletEventsHelpersFactory;
	
	    var LabelEvents = function LabelEvents() {
	      EventsHelper.call(this, 'leafletDirectiveLabel', 'markers');
	    };
	
	    LabelEvents.prototype = new EventsHelper();
	
	    LabelEvents.prototype.genDispatchEvent = function (maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	      var markerName = name.replace('markers.', '');
	      return EventsHelper.prototype.genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, markerName, model, layerName);
	    };
	
	    LabelEvents.prototype.getAvailableEvents = function () {
	      return ['click', 'dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu'];
	    };
	
	    LabelEvents.prototype.genEvents = function (maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	      var _this = this;
	      var labelEvents = this.getAvailableEvents();
	      var scopeWatchName = Helpers.getObjectArrayPath('markers.' + name);
	      labelEvents.forEach(function (eventName) {
	        lObject.label.on(eventName, _this.genDispatchEvent(maybeMapId, eventName, logic, leafletScope, lObject.label, scopeWatchName, model, layerName));
	      });
	    };
	
	    LabelEvents.prototype.bindEvents = function () {};
	
	    return new LabelEvents();
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletMapEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "leafletEventsHelpers", "leafletIterators", function ($rootScope, $q, $log, leafletHelpers, leafletEventsHelpers, leafletIterators) {
	    var isDefined = leafletHelpers.isDefined;
	    var fire = leafletEventsHelpers.fire;
	
	    var _getAvailableMapEvents = function _getAvailableMapEvents() {
	      return ['click', 'dblclick', 'mousedown', 'mouseup', 'mouseover', 'mouseout', 'mousemove', 'contextmenu', 'focus', 'blur', 'preclick', 'load', 'unload', 'viewreset', 'movestart', 'move', 'moveend', 'dragstart', 'drag', 'dragend', 'zoomstart', 'zoomanim', 'zoomend', 'zoomlevelschange', 'resize', 'autopanstart', 'layeradd', 'layerremove', 'baselayerchange', 'overlayadd', 'overlayremove', 'locationfound', 'locationerror', 'popupopen', 'popupclose', 'draw:created', 'draw:edited', 'draw:deleted', 'draw:drawstart', 'draw:drawstop', 'draw:editstart', 'draw:editstop', 'draw:deletestart', 'draw:deletestop'];
	    };
	
	    var _genDispatchMapEvent = function _genDispatchMapEvent(scope, eventName, logic, maybeMapId) {
	      if (maybeMapId) maybeMapId = maybeMapId + '.';
	      return function (e) {
	        // Put together broadcast name
	        var broadcastName = 'leafletDirectiveMap.' + maybeMapId + eventName;
	        $log.debug(broadcastName);
	
	        // Safely broadcast the event
	        fire(scope, broadcastName, logic, e, e.target, scope);
	      };
	    };
	
	    var _notifyCenterChangedToBounds = function _notifyCenterChangedToBounds(scope) {
	      scope.$broadcast('boundsChanged');
	    };
	
	    var _notifyCenterUrlHashChanged = function _notifyCenterUrlHashChanged(scope, map, attrs, search) {
	      if (!isDefined(attrs.urlHashCenter)) {
	        return;
	      }
	
	      var center = map.getCenter();
	      var centerUrlHash = center.lat.toFixed(4) + ':' + center.lng.toFixed(4) + ':' + map.getZoom();
	      if (!isDefined(search.c) || search.c !== centerUrlHash) {
	        //$log.debug("notified new center...");
	        scope.$emit('centerUrlHash', centerUrlHash);
	      }
	    };
	
	    var _addEvents = function _addEvents(map, mapEvents, contextName, scope, logic) {
	      leafletIterators.each(mapEvents, function (eventName) {
	        var context = {};
	        context[contextName] = eventName;
	        map.on(eventName, _genDispatchMapEvent(scope, eventName, logic, map._container.id || ''), context);
	      });
	    };
	
	    return {
	      getAvailableMapEvents: _getAvailableMapEvents,
	      genDispatchMapEvent: _genDispatchMapEvent,
	      notifyCenterChangedToBounds: _notifyCenterChangedToBounds,
	      notifyCenterUrlHashChanged: _notifyCenterUrlHashChanged,
	      addEvents: _addEvents
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletMarkerEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", "leafletLabelEvents", function ($rootScope, $q, $log, leafletHelpers, LeafletEventsHelpersFactory, leafletLabelEvents) {
	    var safeApply = leafletHelpers.safeApply;
	    var isDefined = leafletHelpers.isDefined;
	    var Helpers = leafletHelpers;
	    var lblHelp = leafletLabelEvents;
	    var EventsHelper = LeafletEventsHelpersFactory;
	
	    var MarkerEvents = function MarkerEvents() {
	      EventsHelper.call(this, 'leafletDirectiveMarker', 'markers');
	    };
	
	    MarkerEvents.prototype = new EventsHelper();
	
	    MarkerEvents.prototype.genDispatchEvent = function (maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	      var handle = EventsHelper.prototype.genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName);
	      return function (e) {
	        // Broadcast old marker click name for backwards compatibility
	        if (eventName === 'click') {
	          safeApply(leafletScope, function () {
	            $rootScope.$broadcast('leafletDirectiveMarkersClick', name);
	          });
	        } else if (eventName === 'dragend') {
	          safeApply(leafletScope, function () {
	            model.lat = lObject.getLatLng().lat;
	            model.lng = lObject.getLatLng().lng;
	          });
	
	          if (model.message && model.focus === true) {
	            lObject.openPopup();
	          }
	        }
	
	        handle(e); //common
	      };
	    };
	
	    MarkerEvents.prototype.getAvailableEvents = function () {
	      return ['click', 'dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu', 'dragstart', 'drag', 'dragend', 'move', 'remove', 'popupopen', 'popupclose', 'touchend', 'touchstart', 'touchmove', 'touchcancel', 'touchleave'];
	    };
	
	    MarkerEvents.prototype.bindEvents = function (maybeMapId, lObject, name, model, leafletScope, layerName) {
	      var logic = EventsHelper.prototype.bindEvents.call(this, maybeMapId, lObject, name, model, leafletScope, layerName);
	
	      if (Helpers.LabelPlugin.isLoaded() && isDefined(lObject.label)) {
	        lblHelp.genEvents(maybeMapId, name, logic, leafletScope, lObject, model, layerName);
	      }
	    };
	
	    return new MarkerEvents();
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletPathEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "leafletLabelEvents", "leafletEventsHelpers", function ($rootScope, $q, $log, leafletHelpers, leafletLabelEvents, leafletEventsHelpers) {
	    var isDefined = leafletHelpers.isDefined;
	    var isObject = leafletHelpers.isObject;
	    var Helpers = leafletHelpers;
	    var errorHeader = leafletHelpers.errorHeader;
	    var lblHelp = leafletLabelEvents;
	    var fire = leafletEventsHelpers.fire;
	
	    /*
	    TODO (nmccready) This EventsHelper needs to be derrived from leafletEventsHelpers to elminate copy and paste code.
	    */
	
	    var _genDispatchPathEvent = function _genDispatchPathEvent(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	      maybeMapId = maybeMapId || '';
	
	      if (maybeMapId) maybeMapId = '.' + maybeMapId;
	
	      return function (e) {
	        var broadcastName = 'leafletDirectivePath' + maybeMapId + '.' + eventName;
	        $log.debug(broadcastName);
	        fire(leafletScope, broadcastName, logic, e, e.target || lObject, model, name, layerName);
	      };
	    };
	
	    var _bindPathEvents = function _bindPathEvents(maybeMapId, lObject, name, model, leafletScope) {
	      var pathEvents = [];
	      var i;
	      var eventName;
	      var logic = 'broadcast';
	
	      if (!isDefined(leafletScope.eventBroadcast)) {
	        // Backward compatibility, if no event-broadcast attribute, all events are broadcasted
	        pathEvents = _getAvailablePathEvents();
	      } else if (!isObject(leafletScope.eventBroadcast)) {
	        // Not a valid object
	        $log.error(errorHeader + 'event-broadcast must be an object check your model.');
	      } else {
	        // We have a possible valid object
	        if (!isDefined(leafletScope.eventBroadcast.path)) {
	          // We do not have events enable/disable do we do nothing (all enabled by default)
	          pathEvents = _getAvailablePathEvents();
	        } else if (isObject(leafletScope.eventBroadcast.paths)) {
	          // Not a valid object
	          $log.warn(errorHeader + 'event-broadcast.path must be an object check your model.');
	        } else {
	          // We have a possible valid map object
	          // Event propadation logic
	          if (leafletScope.eventBroadcast.path.logic !== undefined && leafletScope.eventBroadcast.path.logic !== null) {
	            // We take care of possible propagation logic
	            if (leafletScope.eventBroadcast.path.logic !== 'emit' && leafletScope.eventBroadcast.path.logic !== 'broadcast') {
	              // This is an error
	              $log.warn(errorHeader + 'Available event propagation logic are: \'emit\' or \'broadcast\'.');
	            } else if (leafletScope.eventBroadcast.path.logic === 'emit') {
	              logic = 'emit';
	            }
	          }
	
	          // Enable / Disable
	          var pathEventsEnable = false;
	          var pathEventsDisable = false;
	          if (leafletScope.eventBroadcast.path.enable !== undefined && leafletScope.eventBroadcast.path.enable !== null) {
	            if (_typeof(leafletScope.eventBroadcast.path.enable) === 'object') {
	              pathEventsEnable = true;
	            }
	          }
	
	          if (leafletScope.eventBroadcast.path.disable !== undefined && leafletScope.eventBroadcast.path.disable !== null) {
	            if (_typeof(leafletScope.eventBroadcast.path.disable) === 'object') {
	              pathEventsDisable = true;
	            }
	          }
	
	          if (pathEventsEnable && pathEventsDisable) {
	            // Both are active, this is an error
	            $log.warn(errorHeader + 'can not enable and disable events at the same time');
	          } else if (!pathEventsEnable && !pathEventsDisable) {
	            // Both are inactive, this is an error
	            $log.warn(errorHeader + 'must enable or disable events');
	          } else {
	            // At this point the path object is OK, lets enable or disable events
	            if (pathEventsEnable) {
	              // Enable events
	              for (i = 0; i < leafletScope.eventBroadcast.path.enable.length; i++) {
	                eventName = leafletScope.eventBroadcast.path.enable[i];
	
	                // Do we have already the event enabled?
	                if (pathEvents.indexOf(eventName) !== -1) {
	                  // Repeated event, this is an error
	                  $log.warn(errorHeader + 'This event ' + eventName + ' is already enabled');
	                } else {
	                  // Does the event exists?
	                  if (_getAvailablePathEvents().indexOf(eventName) === -1) {
	                    // The event does not exists, this is an error
	                    $log.warn(errorHeader + 'This event ' + eventName + ' does not exist');
	                  } else {
	                    // All ok enable the event
	                    pathEvents.push(eventName);
	                  }
	                }
	              }
	            } else {
	              // Disable events
	              pathEvents = _getAvailablePathEvents();
	              for (i = 0; i < leafletScope.eventBroadcast.path.disable.length; i++) {
	                eventName = leafletScope.eventBroadcast.path.disable[i];
	                var index = pathEvents.indexOf(eventName);
	                if (index === -1) {
	                  // The event does not exist
	                  $log.warn(errorHeader + 'This event ' + eventName + ' does not exist or has been already disabled');
	                } else {
	                  pathEvents.splice(index, 1);
	                }
	              }
	            }
	          }
	        }
	      }
	
	      for (i = 0; i < pathEvents.length; i++) {
	        eventName = pathEvents[i];
	        lObject.on(eventName, _genDispatchPathEvent(maybeMapId, eventName, logic, leafletScope, pathEvents, name));
	      }
	
	      if (Helpers.LabelPlugin.isLoaded() && isDefined(lObject.label)) {
	        lblHelp.genEvents(maybeMapId, name, logic, leafletScope, lObject, model);
	      }
	    };
	
	    var _getAvailablePathEvents = function _getAvailablePathEvents() {
	      return ['click', 'dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu', 'add', 'remove', 'popupopen', 'popupclose'];
	    };
	
	    return {
	      getAvailablePathEvents: _getAvailablePathEvents,
	      bindPathEvents: _bindPathEvents
	    };
	  }]);
	})(angular);

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//require('../../../../../../node_modules/leaflet/dist/leaflet');
	//require('../../../../../../node_modules/leaflet/dist/leaflet.css');
	//require('../../../../../../node_modules/leaflet-fullscreen/dist/Leaflet.fullscreen.min');
	//require('../../../../../../node_modules/leaflet-fullscreen/dist/leaflet.fullscreen.css');
	__webpack_require__(180);
	__webpack_require__(598);
	
	var MODULE_NAME = 'angular-leaflet';
	
	angular.module(MODULE_NAME, ['leaflet-directive']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Numeric directive.
	 * Version: 1.0.0
	 *
	 * Numeric only input. Limits input to:
	 * - max value: maximum input value. Default undefined (no max).
	 * - min value: minimum input value. Default undefined (no min).
	 * - decimals: number of decimals. Default 2.
	 * - formatting: apply thousand separator formatting. Default true.
	 */
	(function () {
	    'use strict';
	
	    if (true) {
	        module.exports = 'purplefox.numeric';
	    }
	
	    /* global angular */
	    angular.module('purplefox.numeric', []).directive('numerico', numeric);
	
	    numeric.$inject = ['$locale', 'Big', 'decimales'];
	
	    function numeric($locale, Big, decimales) {
	        // Usage:
	        //     <input type="text" decimals="3" min="-20" max="40" formatting="false" ></input>
	        // Creates:
	        //
	        var directive = {
	            link: link,
	            require: 'ngModel',
	            restrict: 'A'
	        };
	        return directive;
	
	        function link(scope, el, attrs, ngModelCtrl) {
	            var decimalSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
	            var groupSeparator = $locale.NUMBER_FORMATS.GROUP_SEP;
	
	            // Create new regular expression with current decimal separator.
	            var NUMBER_REGEXP = "^\\s*(\\-|\\+)?(\\d+|(\\d*(\\.\\d*)))\\s*$";
	            var regex = new RegExp(NUMBER_REGEXP);
	
	            var formatting = true;
	            var maxInputLength = 16; // Maximum input length. Default max ECMA script.
	            var max; // Maximum value. Default undefined.
	            var min; // Minimum value. Default undefined.
	            var limitMax = true; // Limit input to max value (value is capped). Default true.
	            var limitMin = true; // Limit input to min value (value is capped). Default true.
	            var decimals = 2; // Number of decimals. Default 2.
	            var lastValidValue; // Last valid value.
	            var decimalsDinamic = false; // If dinamics decimals
	            var maxdecimals = null; // Number to max decimals in case of decimals dinamic
	            var notNumber = null; // Exclude number
	            var numberDefault = 0; // Default number in case of excluding number
	
	            // Create parsers and formatters.
	            ngModelCtrl.$parsers.push(parseViewValue);
	            ngModelCtrl.$parsers.push(minValidator);
	            ngModelCtrl.$parsers.push(maxValidator);
	            ngModelCtrl.$formatters.push(formatViewValue);
	
	            el.bind('blur', onBlur); // Event handler for the leave event.
	            el.bind('focus', onFocus); // Event handler for the focus event.
	
	            // Put a watch on the min, max and decimal value changes in the attribute.
	            scope.$watch(attrs.min, onMinChanged);
	            scope.$watch(attrs.max, onMaxChanged);
	            scope.$watch(attrs.limitMax, onLimitMaxChanged);
	            scope.$watch(attrs.limitMin, onLimitMinChanged);
	            scope.$watch(attrs.decimals, onDecimalsChanged);
	            scope.$watch(attrs.formatting, onFormattingChanged);
	            scope.$watch(attrs.decimalsDinamic, onDecimalsDinamicChanged);
	            scope.$watch(attrs.maxdecimals, onMaxDecimalsChanged);
	            scope.$watch(attrs.notNumber, onNotNumberChanged);
	            scope.$watch(attrs.numberDefault, onNumberDefaultChanged);
	
	            // Setup decimal formatting.
	            init();
	
	            function init() {
	                if (decimals > -1) {
	                    ngModelCtrl.$parsers.push(function (value) {
	                        return value ? round(value) : value;
	                    });
	                    ngModelCtrl.$formatters.push(function (value) {
	                        return value ? formatPrecision(value) : value;
	                    });
	                }
	            }
	
	            function onMinChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    min = parseFloat(value);
	                    lastValidValue = minValidator(ngModelCtrl.$modelValue);
	                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
	                    ngModelCtrl.$render();
	                }
	            }
	
	            function onMaxChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    max = parseFloat(value);
	                    maxInputLength = calculateMaxLength(max);
	                    lastValidValue = maxValidator(ngModelCtrl.$modelValue);
	                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
	                    ngModelCtrl.$render();
	                }
	            }
	
	            function onDecimalsChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    decimals = parseFloat(value);
	                    lastValidValue = maxValidator(ngModelCtrl.$modelValue);
	                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
	                    ngModelCtrl.$render();
	                }
	            }
	            function onDecimalsDinamicChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    decimalsDinamic = value;
	                }
	            }
	
	            function onNotNumberChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    notNumber = value;
	                }
	            }
	            function onNumberDefaultChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    numberDefault = value;
	                }
	            }
	
	            function onMaxDecimalsChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    maxdecimals = value;
	                    lastValidValue = maxValidator(ngModelCtrl.$modelValue);
	                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
	                    ngModelCtrl.$render();
	                }
	            }
	
	            function onFormattingChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    formatting = value !== false;
	                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
	                    ngModelCtrl.$render();
	                }
	            }
	
	            function onLimitMinChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    limitMin = value == "true";
	                }
	            }
	
	            function onLimitMaxChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    limitMax = value == "true";
	                }
	            }
	
	            /**
	             * Round the value to the closest decimal.
	             */
	            function round2(value) {
	                if (typeof value !== 'number') {
	                    return;
	                }
	                var IS_NEGATIVE = value < 0;
	                value = IS_NEGATIVE ? value * -1 : value;
	                var CONVERSION_FACTOR = Math.pow(10, getDecimals(value));
	                value = parseFloat((value * CONVERSION_FACTOR).toFixed(11));
	                value = Math.round(value) / CONVERSION_FACTOR;
	                value = IS_NEGATIVE ? value * -1 : value;
	                return value;
	            }
	            // Round using Big.js library
	            function round(value) {
	                if (typeof value !== 'number') {
	                    return;
	                }
	                var numDecimals = parseInt(maxdecimals || decimales || 2);
	                return parseFloat(Big(value).toFixed(numDecimals));
	            }
	
	            function getDecimals(value) {
	                if (!decimalsDinamic) {
	                    return decimals;
	                }
	                value = value.toString();
	                if (!value.split('.')[1]) {
	                    return 2;
	                }
	                var N_DECIMALS = value.split('.')[1].length === 1 ? 2 : value.split('.')[1].length;
	                if (N_DECIMALS <= maxdecimals) {
	                    return N_DECIMALS;
	                }
	                return maxdecimals;
	            }
	
	            /**
	             * Format a number with the thousand group separator.
	             */
	            function numberWithCommas(value) {
	                if (formatting) {
	                    var parts = ("" + value).split(decimalSeparator);
	                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
	                    return parts.join(decimalSeparator);
	                } else {
	                    // No formatting applies.
	                    return value;
	                }
	            }
	
	            /**
	             * Format a value with thousand group separator and correct decimal char.
	             */
	            function formatPrecision(value) {
	                if (!(value || value === 0)) {
	                    return '';
	                }
	                var formattedValue = round(parseFloat(value)).toFixed(getDecimals(value));
	                formattedValue = formattedValue.replace('.', decimalSeparator);
	                return numberWithCommas(formattedValue);
	            }
	
	            function formatViewValue(value) {
	                return ngModelCtrl.$isEmpty(value) ? '' : '' + value;
	            }
	
	            /**
	             * Parse the view value.
	             */
	            function parseViewValue(value) {
	                if (angular.isUndefined(value)) {
	                    value = '';
	                }
	                if (decimals === 0) {
	                    value = ("" + value).split(groupSeparator).join('');
	                }
	                value = ("" + value).replace(decimalSeparator, '.');
	
	                // Handle leading decimal point, like ".5"
	                if (value.indexOf('.') === 0) {
	                    value = '0' + value;
	                }
	
	                // Allow "-" inputs only when min < 0
	                if (value.indexOf('-') === 0) {
	                    if (min >= 0) {
	                        value = null;
	                        ngModelCtrl.$setViewValue(formatViewValue(lastValidValue));
	                        ngModelCtrl.$render();
	                    } else if (value === '-') {
	                        value = '';
	                    }
	                }
	
	                var empty = ngModelCtrl.$isEmpty(value);
	                if (empty) {
	                    lastValidValue = '';
	                    //ngModelCtrl.$modelValue = undefined;
	                } else {
	                    if (regex.test(value) && value.length <= maxInputLength) {
	                        if (typeof notNumber === 'number' && parseFloat(value) === notNumber) {
	                            value = numberDefault ? numberDefault : 0;
	                        }
	                        if (value > max && limitMax) {
	                            lastValidValue = max;
	                        } else if (value < min && limitMin) {
	                            lastValidValue = min;
	                        } else {
	                            lastValidValue = value === '' ? null : parseFloat(value);
	                        }
	                    } else {
	                        // Render the last valid input in the field
	                        ngModelCtrl.$setViewValue(formatPrecision(formatViewValue(lastValidValue)));
	                        ngModelCtrl.$render();
	                    }
	                }
	
	                return lastValidValue;
	            }
	
	            /**
	             * Calculate the maximum input length in characters.
	             * If no maximum the input will be limited to 16; the maximum ECMA script int.
	             */
	            function calculateMaxLength(value) {
	                var length = 16;
	                if (!angular.isUndefined(value)) {
	                    length = Math.floor(value).toString().length;
	                }
	                if (decimals > 0) {
	                    // Add extra length for the decimals plus one for the decimal separator.
	                    length += decimals + 1;
	                }
	                if (min < 0) {
	                    // Add extra length for the - sign.
	                    length++;
	                }
	                return length;
	            }
	
	            /**
	             * Minimum value validator.
	             */
	            function minValidator(value) {
	                if (!angular.isUndefined(min) && limitMin) {
	                    if (!ngModelCtrl.$isEmpty(value) && value < min) {
	                        return min;
	                    } else {
	                        return value;
	                    }
	                } else {
	                    if (!limitMin) {
	                        ngModelCtrl.$setValidity('min', !(value < min));
	                    }
	                    return value;
	                }
	            }
	
	            /**
	             * Maximum value validator.
	             */
	            function maxValidator(value) {
	                if (!angular.isUndefined(max) && limitMax) {
	                    if (!ngModelCtrl.$isEmpty(value) && value > max) {
	                        return max;
	                    } else {
	                        return value;
	                    }
	                } else {
	                    if (!limitMax) {
	                        ngModelCtrl.$setValidity('max', !(value > max));
	                    }
	                    return value;
	                }
	            }
	
	            /**
	             * Function for handeling the blur (leave) event on the control.
	             */
	            function onBlur() {
	                var value = ngModelCtrl.$modelValue;
	                if (!angular.isUndefined(value)) {
	                    // Format the model value.
	                    ngModelCtrl.$viewValue = formatPrecision(value);
	                    ngModelCtrl.$render();
	                }
	            }
	
	            /**
	             * Function for handeling the focus (enter) event on the control.
	             * On focus show the value without the group separators.
	             */
	            function onFocus() {
	                var value = ngModelCtrl.$modelValue;
	                if (!angular.isUndefined(value)) {
	                    ngModelCtrl.$viewValue = ("" + value).replace(".", decimalSeparator);
	                    ngModelCtrl.$render();
	                }
	            }
	        }
	    }
	})();

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(600);
	
	var MODULE_NAME = 'numeric-directive';
	
	angular.module(MODULE_NAME, ['purplefox.numeric']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex']).constant('uibAccordionConfig', {
	  closeOthers: true
	}).controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function (openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function (group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function (groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function (event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function (group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion', function () {
	  return {
	    controller: 'UibAccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup', function () {
	  return {
	    require: '^uibAccordion', // We need this directive to be inside an accordion
	    transclude: true, // It transcludes the contents of the directive into the template
	    restrict: 'A',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@', // Interpolate the heading attribute onto this scope
	      panelClass: '@?', // Ditto with panelClass
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function controller() {
	      this.setHeading = function (element) {
	        this.heading = element;
	      };
	    },
	    link: function link(scope, element, attrs, accordionCtrl) {
	      element.addClass('panel');
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass || 'panel-default';
	      scope.$watch('isOpen', function (value) {
	        element.toggleClass(scope.openClass, !!value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function ($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	
	      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	      scope.headingId = id + '-tab';
	      scope.panelId = id + '-panel';
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading', function () {
	  return {
	    transclude: true, // Grab the contents to be used as the heading
	    template: '', // In effect remove this element!
	    replace: true,
	    require: '^uibAccordionGroup',
	    link: function link(scope, element, attrs, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude', function () {
	  return {
	    require: '^uibAccordionGroup',
	    link: function link(scope, element, attrs, controller) {
	      scope.$watch(function () {
	        return controller[attrs.uibAccordionTransclude];
	      }, function (heading) {
	        if (heading) {
	          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
	          elem.html('');
	          elem.append(heading);
	        }
	      });
	    }
	  };
	
	  function getHeaderSelectors() {
	    return 'uib-accordion-header,' + 'data-uib-accordion-header,' + 'x-uib-accordion-header,' + 'uib\\:accordion-header,' + '[uib-accordion-header],' + '[data-uib-accordion-header],' + '[x-uib-accordion-header]';
	  }
	});

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(609);
	__webpack_require__(633);
	__webpack_require__(642);
	__webpack_require__(643);
	__webpack_require__(602);
	
	var MODULE_NAME = 'ui.bootstrap.module.accordion';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.accordion', 'uib/template/accordion/accordion.html', 'uib/template/accordion/accordion-group.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.alert', []).controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function ($scope, $element, $attrs, $interpolate, $timeout) {
	  $scope.closeable = !!$attrs.close;
	  $element.addClass('alert');
	  $attrs.$set('role', 'alert');
	  if ($scope.closeable) {
	    $element.addClass('alert-dismissible');
	  }
	
	  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ? $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
	
	  if (dismissOnTimeout) {
	    $timeout(function () {
	      $scope.close();
	    }, parseInt(dismissOnTimeout, 10));
	  }
	}]).directive('uibAlert', function () {
	  return {
	    controller: 'UibAlertController',
	    controllerAs: 'alert',
	    restrict: 'A',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/alert/alert.html';
	    },
	    transclude: true,
	    scope: {
	      close: '&'
	    }
	  };
	});

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(644);
	__webpack_require__(604);
	
	var MODULE_NAME = 'ui.bootstrap.module.alert';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.alert', 'uib/template/alert/alert.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.buttons', []).constant('uibButtonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	}).controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}]).directive('uibBtnRadio', ['$parse', function ($parse) {
	  return {
	    require: ['uibBtnRadio', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'buttons',
	    link: function link(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	      var uncheckableExpr = $parse(attrs.uibUncheckable);
	
	      element.find('input').css({ display: 'none' });
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function () {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function () {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	
	      if (attrs.uibUncheckable) {
	        scope.$watch(uncheckableExpr, function (uncheckable) {
	          attrs.$set('uncheckable', uncheckable ? '' : undefined);
	        });
	      }
	    }
	  };
	}]).directive('uibBtnCheckbox', function () {
	  return {
	    require: ['uibBtnCheckbox', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'button',
	    link: function link(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      element.find('input').css({ display: 'none' });
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attribute, defaultValue) {
	        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function () {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function () {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(606);
	
	var MODULE_NAME = 'ui.bootstrap.module.buttons';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.buttons']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.collapse', []).directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
	  var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	  return {
	    link: function link(scope, element, attrs) {
	      var expandingExpr = $parse(attrs.expanding),
	          expandedExpr = $parse(attrs.expanded),
	          collapsingExpr = $parse(attrs.collapsing),
	          collapsedExpr = $parse(attrs.collapsed),
	          horizontal = false,
	          css = {},
	          cssTo = {};
	
	      init();
	
	      function init() {
	        horizontal = !!('horizontal' in attrs);
	        if (horizontal) {
	          css = {
	            width: ''
	          };
	          cssTo = { width: '0' };
	        } else {
	          css = {
	            height: ''
	          };
	          cssTo = { height: '0' };
	        }
	        if (!scope.$eval(attrs.uibCollapse)) {
	          element.addClass('in').addClass('collapse').attr('aria-expanded', true).attr('aria-hidden', false).css(css);
	        }
	      }
	
	      function getScrollFromElement(element) {
	        if (horizontal) {
	          return { width: element.scrollWidth + 'px' };
	        }
	        return { height: element.scrollHeight + 'px' };
	      }
	
	      function expand() {
	        if (element.hasClass('collapse') && element.hasClass('in')) {
	          return;
	        }
	
	        $q.resolve(expandingExpr(scope)).then(function () {
	          element.removeClass('collapse').addClass('collapsing').attr('aria-expanded', true).attr('aria-hidden', false);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              addClass: 'in',
	              easing: 'ease',
	              css: {
	                overflow: 'hidden'
	              },
	              to: getScrollFromElement(element[0])
	            }).start()['finally'](expandDone);
	          } else {
	            $animate.addClass(element, 'in', {
	              css: {
	                overflow: 'hidden'
	              },
	              to: getScrollFromElement(element[0])
	            }).then(expandDone);
	          }
	        }, angular.noop);
	      }
	
	      function expandDone() {
	        element.removeClass('collapsing').addClass('collapse').css(css);
	        expandedExpr(scope);
	      }
	
	      function collapse() {
	        if (!element.hasClass('collapse') && !element.hasClass('in')) {
	          return collapseDone();
	        }
	
	        $q.resolve(collapsingExpr(scope)).then(function () {
	          element
	          // IMPORTANT: The width must be set before adding "collapsing" class.
	          // Otherwise, the browser attempts to animate from width 0 (in
	          // collapsing class) to the given width here.
	          .css(getScrollFromElement(element[0]))
	          // initially all panel collapse have the collapse class, this removal
	          // prevents the animation from jumping to collapsed state
	          .removeClass('collapse').addClass('collapsing').attr('aria-expanded', false).attr('aria-hidden', true);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              removeClass: 'in',
	              to: cssTo
	            }).start()['finally'](collapseDone);
	          } else {
	            $animate.removeClass(element, 'in', {
	              to: cssTo
	            }).then(collapseDone);
	          }
	        }, angular.noop);
	      }
	
	      function collapseDone() {
	        element.css(cssTo); // Required so that collapse works when animation is disabled
	        element.removeClass('collapsing').addClass('collapse');
	        collapsedExpr(scope);
	      }
	
	      scope.$watch(attrs.uibCollapse, function (shouldCollapse) {
	        if (shouldCollapse) {
	          collapse();
	        } else {
	          expand();
	        }
	      });
	    }
	  };
	}]);

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(608);
	
	var MODULE_NAME = 'ui.bootstrap.module.collapse';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.collapse']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.dateparser', []).service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function ($log, $locale, dateFilter, orderByFilter, filterFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  var localeId;
	  var formatCodeToRegex;
	
	  this.init = function () {
	    localeId = $locale.id;
	
	    this.parsers = {};
	    this.formatters = {};
	
	    formatCodeToRegex = [{
	      key: 'yyyy',
	      regex: '\\d{4}',
	      apply: function apply(value) {
	        this.year = +value;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'yyyy');
	      }
	    }, {
	      key: 'yy',
	      regex: '\\d{2}',
	      apply: function apply(value) {
	        value = +value;this.year = value < 69 ? value + 2000 : value + 1900;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'yy');
	      }
	    }, {
	      key: 'y',
	      regex: '\\d{1,4}',
	      apply: function apply(value) {
	        this.year = +value;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'y');
	      }
	    }, {
	      key: 'M!',
	      regex: '0?[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        var value = date.getMonth();
	        if (/^[0-9]$/.test(value)) {
	          return dateFilter(date, 'MM');
	        }
	
	        return dateFilter(date, 'M');
	      }
	    }, {
	      key: 'MMMM',
	      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	      apply: function apply(value) {
	        this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MMMM');
	      }
	    }, {
	      key: 'MMM',
	      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	      apply: function apply(value) {
	        this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MMM');
	      }
	    }, {
	      key: 'MM',
	      regex: '0[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MM');
	      }
	    }, {
	      key: 'M',
	      regex: '[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'M');
	      }
	    }, {
	      key: 'd!',
	      regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        var value = date.getDate();
	        if (/^[1-9]$/.test(value)) {
	          return dateFilter(date, 'dd');
	        }
	
	        return dateFilter(date, 'd');
	      }
	    }, {
	      key: 'dd',
	      regex: '[0-2][0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'dd');
	      }
	    }, {
	      key: 'd',
	      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'd');
	      }
	    }, {
	      key: 'EEEE',
	      regex: $locale.DATETIME_FORMATS.DAY.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'EEEE');
	      }
	    }, {
	      key: 'EEE',
	      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'EEE');
	      }
	    }, {
	      key: 'HH',
	      regex: '(?:0|1)[0-9]|2[0-3]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'HH');
	      }
	    }, {
	      key: 'hh',
	      regex: '0[0-9]|1[0-2]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'hh');
	      }
	    }, {
	      key: 'H',
	      regex: '1?[0-9]|2[0-3]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'H');
	      }
	    }, {
	      key: 'h',
	      regex: '[0-9]|1[0-2]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'h');
	      }
	    }, {
	      key: 'mm',
	      regex: '[0-5][0-9]',
	      apply: function apply(value) {
	        this.minutes = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'mm');
	      }
	    }, {
	      key: 'm',
	      regex: '[0-9]|[1-5][0-9]',
	      apply: function apply(value) {
	        this.minutes = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'm');
	      }
	    }, {
	      key: 'sss',
	      regex: '[0-9][0-9][0-9]',
	      apply: function apply(value) {
	        this.milliseconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'sss');
	      }
	    }, {
	      key: 'ss',
	      regex: '[0-5][0-9]',
	      apply: function apply(value) {
	        this.seconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'ss');
	      }
	    }, {
	      key: 's',
	      regex: '[0-9]|[1-5][0-9]',
	      apply: function apply(value) {
	        this.seconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 's');
	      }
	    }, {
	      key: 'a',
	      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	      apply: function apply(value) {
	        if (this.hours === 12) {
	          this.hours = 0;
	        }
	
	        if (value === 'PM') {
	          this.hours += 12;
	        }
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'a');
	      }
	    }, {
	      key: 'Z',
	      regex: '[+-]\\d{4}',
	      apply: function apply(value) {
	        var matches = value.match(/([+-])(\d{2})(\d{2})/),
	            sign = matches[1],
	            hours = matches[2],
	            minutes = matches[3];
	        this.hours += toInt(sign + hours);
	        this.minutes += toInt(sign + minutes);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'Z');
	      }
	    }, {
	      key: 'ww',
	      regex: '[0-4][0-9]|5[0-3]',
	      formatter: function formatter(date) {
	        return dateFilter(date, 'ww');
	      }
	    }, {
	      key: 'w',
	      regex: '[0-9]|[1-4][0-9]|5[0-3]',
	      formatter: function formatter(date) {
	        return dateFilter(date, 'w');
	      }
	    }, {
	      key: 'GGGG',
	      regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GGGG');
	      }
	    }, {
	      key: 'GGG',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GGG');
	      }
	    }, {
	      key: 'GG',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GG');
	      }
	    }, {
	      key: 'G',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'G');
	      }
	    }];
	
	    if (angular.version.major >= 1 && angular.version.minor > 4) {
	      formatCodeToRegex.push({
	        key: 'LLLL',
	        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
	        apply: function apply(value) {
	          this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value);
	        },
	        formatter: function formatter(date) {
	          return dateFilter(date, 'LLLL');
	        }
	      });
	    }
	  };
	
	  this.init();
	
	  function getFormatCodeToRegex(key) {
	    return filterFilter(formatCodeToRegex, { key: key }, true)[0];
	  }
	
	  this.getParser = function (key) {
	    var f = getFormatCodeToRegex(key);
	    return f && f.apply || null;
	  };
	
	  this.overrideParser = function (key, parser) {
	    var f = getFormatCodeToRegex(key);
	    if (f && angular.isFunction(parser)) {
	      this.parsers = {};
	      f.apply = parser;
	    }
	  }.bind(this);
	
	  function createParser(format) {
	    var map = [],
	        regex = format.split('');
	
	    // check for literal values
	    var quoteIndex = format.indexOf('\'');
	    if (quoteIndex > -1) {
	      var inLiteral = false;
	      format = format.split('');
	      for (var i = quoteIndex; i < format.length; i++) {
	        if (inLiteral) {
	          if (format[i] === '\'') {
	            if (i + 1 < format.length && format[i + 1] === '\'') {
	              // escaped single quote
	              format[i + 1] = '$';
	              regex[i + 1] = '';
	            } else {
	              // end of literal
	              regex[i] = '';
	              inLiteral = false;
	            }
	          }
	          format[i] = '$';
	        } else {
	          if (format[i] === '\'') {
	            // start of literal
	            format[i] = '$';
	            regex[i] = '';
	            inLiteral = true;
	          }
	        }
	      }
	
	      format = format.join('');
	    }
	
	    angular.forEach(formatCodeToRegex, function (data) {
	      var index = format.indexOf(data.key);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({
	          index: index,
	          key: data.key,
	          apply: data.apply,
	          matcher: data.regex
	        });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  function createFormatter(format) {
	    var formatters = [];
	    var i = 0;
	    var formatter, literalIdx;
	    while (i < format.length) {
	      if (angular.isNumber(literalIdx)) {
	        if (format.charAt(i) === '\'') {
	          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
	            formatters.push(constructLiteralFormatter(format, literalIdx, i));
	            literalIdx = null;
	          }
	        } else if (i === format.length) {
	          while (literalIdx < format.length) {
	            formatter = constructFormatterFromIdx(format, literalIdx);
	            formatters.push(formatter);
	            literalIdx = formatter.endIdx;
	          }
	        }
	
	        i++;
	        continue;
	      }
	
	      if (format.charAt(i) === '\'') {
	        literalIdx = i;
	        i++;
	        continue;
	      }
	
	      formatter = constructFormatterFromIdx(format, i);
	
	      formatters.push(formatter.parser);
	      i = formatter.endIdx;
	    }
	
	    return formatters;
	  }
	
	  function constructLiteralFormatter(format, literalIdx, endIdx) {
	    return function () {
	      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
	    };
	  }
	
	  function constructFormatterFromIdx(format, i) {
	    var currentPosStr = format.substr(i);
	    for (var j = 0; j < formatCodeToRegex.length; j++) {
	      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
	        var data = formatCodeToRegex[j];
	        return {
	          endIdx: i + data.key.length,
	          parser: data.formatter
	        };
	      }
	    }
	
	    return {
	      endIdx: i + 1,
	      parser: function parser() {
	        return currentPosStr.charAt(0);
	      }
	    };
	  }
	
	  this.filter = function (date, format) {
	    if (!angular.isDate(date) || isNaN(date) || !format) {
	      return '';
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.formatters[format]) {
	      this.formatters[format] = createFormatter(format);
	    }
	
	    var formatters = this.formatters[format];
	
	    return formatters.reduce(function (str, formatter) {
	      return str + formatter(date);
	    }, '');
	  };
	
	  this.parse = function (input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format, 'apply');
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex),
	        tzOffset = false;
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i - 1];
	        if (mapper.matcher === 'Z') {
	          tzOffset = true;
	        }
	
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      var datesetter = tzOffset ? Date.prototype.setUTCFullYear : Date.prototype.setFullYear;
	      var timesetter = tzOffset ? Date.prototype.setUTCHours : Date.prototype.setHours;
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
	          dt = new Date(baseDate);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours, fields.minutes, fields.seconds, fields.milliseconds);
	        } else {
	          dt = new Date(0);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours || 0, fields.minutes || 0, fields.seconds || 0, fields.milliseconds || 0);
	        }
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	
	  function toInt(str) {
	    return parseInt(str, 10);
	  }
	
	  this.toTimezone = toTimezone;
	  this.fromTimezone = fromTimezone;
	  this.timezoneToOffset = timezoneToOffset;
	  this.addDateMinutes = addDateMinutes;
	  this.convertTimezoneToLocal = convertTimezoneToLocal;
	
	  function toTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
	  }
	
	  function fromTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
	  }
	
	  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
	  function timezoneToOffset(timezone, fallback) {
	    timezone = timezone.replace(/:/g, '');
	    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	  }
	
	  function addDateMinutes(date, minutes) {
	    date = new Date(date.getTime());
	    date.setMinutes(date.getMinutes() + minutes);
	    return date;
	  }
	
	  function convertTimezoneToLocal(date, timezone, reverse) {
	    reverse = reverse ? -1 : 1;
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	  }
	}]);

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(610);
	
	var MODULE_NAME = 'ui.bootstrap.module.dateparser';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.dateparser']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module("ngLocale", [], ["$provide", function ($provide) {
	  var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
	  $provide.value("$locale", {
	    "DATETIME_FORMATS": {
	      "AMPMS": ["a. m.", "p. m."],
	      "DAY": ["domingo", "lunes", "martes", "mi\xE9rcoles", "jueves", "viernes", "s\xE1bado"],
	      "ERANAMES": ["antes de Cristo", "despu\xE9s de Cristo"],
	      "ERAS": ["a. C.", "d. C."],
	      "FIRSTDAYOFWEEK": 0,
	      "MONTH": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
	      "SHORTDAY": ["dom.", "lun.", "mar.", "mi\xE9.", "jue.", "vie.", "s\xE1b."],
	      "SHORTMONTH": ["ene.", "feb.", "mar.", "abr.", "may.", "jun.", "jul.", "ago.", "sept.", "oct.", "nov.", "dic."],
	      "STANDALONEMONTH": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
	      "WEEKENDRANGE": [5, 6],
	      "fullDate": "EEEE, d 'de' MMMM 'de' y",
	      "longDate": "d 'de' MMMM 'de' y",
	      "medium": "d MMM y H:mm:ss",
	      "mediumDate": "d MMM y",
	      "mediumTime": "H:mm:ss",
	      "short": "d/M/yy H:mm",
	      "shortDate": "d/M/yy",
	      "shortTime": "H:mm"
	    },
	    "NUMBER_FORMATS": {
	      "CURRENCY_SYM": "\u20AC",
	      "DECIMAL_SEP": ",",
	      "GROUP_SEP": ".",
	      "PATTERNS": [{
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      }, {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "\xA0\xA4",
	        "posPre": "",
	        "posSuf": "\xA0\xA4"
	      }]
	    },
	    "id": "es-es",
	    "localeID": "es_ES",
	    "pluralCat": function pluralCat(n, opt_precision) {
	      if (n == 1) {
	        return PLURAL_CATEGORY.ONE;
	      }return PLURAL_CATEGORY.OTHER;
	    }
	  });
	}]);
	
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass']).value('$datepickerSuppressError', false).value('$datepickerLiteralWarning', true).constant('uibDatepickerConfig', {
	  datepickerMode: 'day',
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  maxDate: null,
	  maxMode: 'year',
	  minDate: null,
	  minMode: 'day',
	  monthColumns: 3,
	  ngModelOptions: {},
	  shortcutPropagation: false,
	  showWeeks: true,
	  yearColumns: 5,
	  yearRows: 4
	}).controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser', function ($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop },
	      // nullModelCtrl;
	  ngModelOptions = {},
	      watchListeners = [];
	
	  $element.addClass('uib-datepicker');
	  $attrs.$set('role', 'application');
	
	  if (!$scope.datepickerOptions) {
	    $scope.datepickerOptions = {};
	  }
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  ['customClass', 'dateDisabled', 'datepickerMode', 'formatDay', 'formatDayHeader', 'formatDayTitle', 'formatMonth', 'formatMonthTitle', 'formatYear', 'maxDate', 'maxMode', 'minDate', 'minMode', 'monthColumns', 'showWeeks', 'shortcutPropagation', 'startingDay', 'yearColumns', 'yearRows'].forEach(function (key) {
	    switch (key) {
	      case 'customClass':
	      case 'dateDisabled':
	        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
	        break;
	      case 'datepickerMode':
	        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ? $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
	        break;
	      case 'formatDay':
	      case 'formatDayHeader':
	      case 'formatDayTitle':
	      case 'formatMonth':
	      case 'formatMonthTitle':
	      case 'formatYear':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $interpolate($scope.datepickerOptions[key])($scope.$parent) : datepickerConfig[key];
	        break;
	      case 'monthColumns':
	      case 'showWeeks':
	      case 'shortcutPropagation':
	      case 'yearColumns':
	      case 'yearRows':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $scope.datepickerOptions[key] : datepickerConfig[key];
	        break;
	      case 'startingDay':
	        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
	          self.startingDay = $scope.datepickerOptions.startingDay;
	        } else if (angular.isNumber(datepickerConfig.startingDay)) {
	          self.startingDay = datepickerConfig.startingDay;
	        } else {
	          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	        }
	
	        break;
	      case 'maxDate':
	      case 'minDate':
	        $scope.$watch('datepickerOptions.' + key, function (value) {
	          if (value) {
	            if (angular.isDate(value)) {
	              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
	            } else {
	              if ($datepickerLiteralWarning) {
	                $log.warn('Literal date support has been deprecated, please switch to date object usage');
	              }
	
	              self[key] = new Date(dateFilter(value, 'medium'));
	            }
	          } else {
	            self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) : null;
	          }
	
	          self.refreshView();
	        });
	
	        break;
	      case 'maxMode':
	      case 'minMode':
	        if ($scope.datepickerOptions[key]) {
	          $scope.$watch(function () {
	            return $scope.datepickerOptions[key];
	          }, function (value) {
	            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
	            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) || key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
	              $scope.datepickerMode = self[key];
	              $scope.datepickerOptions.datepickerMode = self[key];
	            }
	          });
	        } else {
	          self[key] = $scope[key] = datepickerConfig[key] || null;
	        }
	
	        break;
	    }
	  });
	
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if (angular.isDefined($attrs.ngDisabled)) {
	    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
	      $scope.disabled = disabled;
	      self.refreshView();
	    }));
	  }
	
	  $scope.isActive = function (dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function (ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelOptions = extractOptions(ngModelCtrl);
	
	    if ($scope.datepickerOptions.initDate) {
	      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
	      $scope.$watch('datepickerOptions.initDate', function (initDate) {
	        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
	          self.refreshView();
	        }
	      });
	    } else {
	      self.activeDate = new Date();
	    }
	
	    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
	    this.activeDate = !isNaN(date) ? dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) : dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	
	    ngModelCtrl.$render = function () {
	      self.render();
	    };
	  };
	
	  this.render = function () {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function () {
	    if (this.element) {
	      $scope.selectedDt = null;
	      this._refreshView();
	      if ($scope.activeDt) {
	        $scope.activeDateId = $scope.activeDt.uid;
	      }
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setValidity('dateDisabled', !date || this.element && !this.isDisabled(date));
	    }
	  };
	
	  this.createDateObject = function (date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
	    var today = new Date();
	    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	    var time = this.compare(date, today);
	    var dt = {
	      date: date,
	      label: dateParser.filter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      past: time < 0,
	      current: time === 0,
	      future: time > 0,
	      customClass: this.customClass(date) || null
	    };
	
	    if (model && this.compare(date, model) === 0) {
	      $scope.selectedDt = dt;
	    }
	
	    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
	      $scope.activeDt = dt;
	    }
	
	    return dt;
	  };
	
	  this.isDisabled = function (date) {
	    return $scope.disabled || this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $scope.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode });
	  };
	
	  this.customClass = function (date) {
	    return $scope.customClass({ date: date, mode: $scope.datepickerMode });
	  };
	
	  // Split array into smaller arrays
	  this.split = function (arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function (date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);
	
	      $scope.$emit('uib:datepicker.mode');
	    }
	
	    $scope.$broadcast('uib:datepicker.focus');
	  };
	
	  $scope.move = function (direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function (direction) {
	    direction = direction || 1;
	
	    if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) {
	      return;
	    }
	
	    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);
	
	    $scope.$emit('uib:datepicker.mode');
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function focusElement() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function (evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	
	  $element.on('keydown', function (evt) {
	    $scope.$apply(function () {
	      $scope.keydown(evt);
	    });
	  });
	
	  $scope.$on('$destroy', function () {
	    //Clear all watch listeners on destroy
	    while (watchListeners.length) {
	      watchListeners.shift()();
	    }
	  });
	
	  function setMode(mode) {
	    $scope.datepickerMode = mode;
	    $scope.datepickerOptions.datepickerMode = mode;
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) {
	      // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = ngModelCtrl.$options || $scope.datepickerOptions.ngModelOptions || datepickerConfig.ngModelOptions || {};
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else {
	      // in angular >=1.6 $options is always present
	      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
	      var timezone = ngModelCtrl.$options.getOption('timezone') || ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) || (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);
	
	      // values passed to createChild override existing values
	      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
	      .createChild(datepickerConfig.ngModelOptions) // lowest precedence
	      .createChild($scope.datepickerOptions.ngModelOptions).createChild(ngModelCtrl.$options) // highest precedence
	      .createChild({ timezone: timezone }); // to keep from squashing a non-null value
	    }
	
	    return ngModelOptions;
	  }
	}]).controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	  this.step = { months: 1 };
	  this.element = $element;
	  function getDaysInMonth(year, month) {
	    return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
	  }
	
	  this.init = function (ctrl) {
	    angular.extend(ctrl, this);
	    scope.showWeeks = ctrl.showWeeks;
	    ctrl.refreshView();
	  };
	
	  this.getDates = function (startDate, n) {
	    var dates = new Array(n),
	        current = new Date(startDate),
	        i = 0,
	        date;
	    while (i < n) {
	      date = new Date(current);
	      dates[i++] = date;
	      current.setDate(current.getDate() + 1);
	    }
	    return dates;
	  };
	
	  this._refreshView = function () {
	    var year = this.activeDate.getFullYear(),
	        month = this.activeDate.getMonth(),
	        firstDayOfMonth = new Date(this.activeDate);
	
	    firstDayOfMonth.setFullYear(year, month, 1);
	
	    var difference = this.startingDay - firstDayOfMonth.getDay(),
	        numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference,
	        firstDate = new Date(firstDayOfMonth);
	
	    if (numDisplayedFromPreviousMonth > 0) {
	      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	    }
	
	    // 42 is the number of days on a six-week calendar
	    var days = this.getDates(firstDate, 42);
	    for (var i = 0; i < 42; i++) {
	      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	        secondary: days[i].getMonth() !== month,
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.labels = new Array(7);
	    for (var j = 0; j < 7; j++) {
	      scope.labels[j] = {
	        abbr: dateFilter(days[j].date, this.formatDayHeader),
	        full: dateFilter(days[j].date, 'EEEE')
	      };
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	    scope.rows = this.split(days, 7);
	
	    if (scope.showWeeks) {
	      scope.weekNumbers = [];
	      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	          numWeeks = scope.rows.length;
	      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	        scope.weekNumbers.push(getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	      }
	    }
	  };
	
	  this.compare = function (date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  function getISO8601WeekNumber(date) {
	    var checkDate = new Date(date);
	    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	    var time = checkDate.getTime();
	    checkDate.setMonth(0); // Compare with Jan 1
	    checkDate.setDate(1);
	    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	  }
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getDate();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - 7;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + 7;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
	      this.activeDate.setMonth(month, 1);
	      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	    } else if (key === 'home') {
	      date = 1;
	    } else if (key === 'end') {
	      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	    }
	    this.activeDate.setDate(date);
	  };
	}]).controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  this.step = { years: 1 };
	  this.element = $element;
	
	  this.init = function (ctrl) {
	    angular.extend(ctrl, this);
	    ctrl.refreshView();
	  };
	
	  this._refreshView = function () {
	    var months = new Array(12),
	        year = this.activeDate.getFullYear(),
	        date;
	
	    for (var i = 0; i < 12; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(year, i, 1);
	      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	    scope.rows = this.split(months, this.monthColumns);
	    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
	  };
	
	  this.compare = function (date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getMonth();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - this.monthColumns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + this.monthColumns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
	      this.activeDate.setFullYear(year);
	    } else if (key === 'home') {
	      date = 0;
	    } else if (key === 'end') {
	      date = 11;
	    }
	    this.activeDate.setMonth(date);
	  };
	}]).controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  var columns, range;
	  this.element = $element;
	
	  function getStartingYear(year) {
	    return parseInt((year - 1) / range, 10) * range + 1;
	  }
	
	  this.yearpickerInit = function () {
	    columns = this.yearColumns;
	    range = this.yearRows * columns;
	    this.step = { years: range };
	  };
	
	  this._refreshView = function () {
	    var years = new Array(range),
	        date;
	
	    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(start + i, 0, 1);
	      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	    scope.rows = this.split(years, columns);
	    scope.columns = columns;
	  };
	
	  this.compare = function (date1, date2) {
	    return date1.getFullYear() - date2.getFullYear();
	  };
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getFullYear();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - columns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + columns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      date += (key === 'pageup' ? -1 : 1) * range;
	    } else if (key === 'home') {
	      date = getStartingYear(this.activeDate.getFullYear());
	    } else if (key === 'end') {
	      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	    }
	    this.activeDate.setFullYear(date);
	  };
	}]).directive('uibDatepicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerOptions: '=?'
	    },
	    require: ['uibDatepicker', '^ngModel'],
	    restrict: 'A',
	    controller: 'UibDatepickerController',
	    controllerAs: 'datepicker',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	}).directive('uibDaypicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/day.html';
	    },
	    require: ['^uibDatepicker', 'uibDaypicker'],
	    restrict: 'A',
	    controller: 'UibDaypickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	}).directive('uibMonthpicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/month.html';
	    },
	    require: ['^uibDatepicker', 'uibMonthpicker'],
	    restrict: 'A',
	    controller: 'UibMonthpickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	}).directive('uibYearpicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/year.html';
	    },
	    require: ['^uibDatepicker', 'uibYearpicker'],
	    restrict: 'A',
	    controller: 'UibYearpickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var ctrl = ctrls[0];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	});

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(79);
	module.exports = __webpack_require__(87);

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(87);
	__webpack_require__(29);
	__webpack_require__(649);
	__webpack_require__(616);
	
	var MODULE_NAME = 'ui.bootstrap.module.datepickerPopup';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.datepickerPopup', 'uib/template/datepickerPopup/popup.html', 'ui.bootstrap.module.datepicker']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(79);
	__webpack_require__(26);
	__webpack_require__(181);
	module.exports = __webpack_require__(614);

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position']).value('$datepickerPopupLiteralWarning', true).constant('uibDatepickerPopupConfig', {
	  altInputFormats: [],
	  appendToBody: false,
	  clearText: 'Clear',
	  closeOnDateSelection: true,
	  closeText: 'Done',
	  currentText: 'Today',
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
	  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  onOpenFocus: true,
	  showButtonBar: true,
	  placement: 'auto bottom-left'
	}).controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning', function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
	  var cache = {},
	      isHtml5DateInput = false;
	  var dateFormat,
	      closeOnDateSelection,
	      appendToBody,
	      onOpenFocus,
	      datepickerPopupTemplateUrl,
	      datepickerTemplateUrl,
	      popupEl,
	      datepickerEl,
	      scrollParentEl,
	      ngModel,
	      ngModelOptions,
	      $popup,
	      altInputFormats,
	      watchListeners = [];
	
	  this.init = function (_ngModel_) {
	    ngModel = _ngModel_;
	    ngModelOptions = extractOptions(ngModel);
	    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ? $scope.$parent.$eval($attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;
	    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ? $scope.$parent.$eval($attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
	    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ? $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ? $attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl;
	    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ? $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	    altInputFormats = angular.isDefined($attrs.altInputFormats) ? $scope.$parent.$eval($attrs.altInputFormats) : datepickerPopupConfig.altInputFormats;
	
	    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ? $scope.$parent.$eval($attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
	
	    if (datepickerPopupConfig.html5Types[$attrs.type]) {
	      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
	      isHtml5DateInput = true;
	    } else {
	      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	      $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
	        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	        // Invalidate the $modelValue to ensure that formatters re-run
	        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	        if (newDateFormat !== dateFormat) {
	          dateFormat = newDateFormat;
	          ngModel.$modelValue = null;
	
	          if (!dateFormat) {
	            throw new Error('uibDatepickerPopup must have a date format specified.');
	          }
	        }
	      });
	    }
	
	    if (!dateFormat) {
	      throw new Error('uibDatepickerPopup must have a date format specified.');
	    }
	
	    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
	      throw new Error('HTML5 date input types do not support custom formats.');
	    }
	
	    // popup element used to display calendar
	    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	
	    popupEl.attr({
	      'ng-model': 'date',
	      'ng-change': 'dateSelection(date)',
	      'template-url': datepickerPopupTemplateUrl
	    });
	
	    // datepicker element
	    datepickerEl = angular.element(popupEl.children()[0]);
	    datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	    if (!$scope.datepickerOptions) {
	      $scope.datepickerOptions = {};
	    }
	
	    if (isHtml5DateInput) {
	      if ($attrs.type === 'month') {
	        $scope.datepickerOptions.datepickerMode = 'month';
	        $scope.datepickerOptions.minMode = 'month';
	      }
	    }
	
	    datepickerEl.attr('datepicker-options', 'datepickerOptions');
	
	    if (!isHtml5DateInput) {
	      // Internal API to maintain the correct ng-invalid-[key] class
	      ngModel.$$parserName = 'date';
	      ngModel.$validators.date = validator;
	      ngModel.$parsers.unshift(parseDate);
	      ngModel.$formatters.push(function (value) {
	        if (ngModel.$isEmpty(value)) {
	          $scope.date = value;
	          return value;
	        }
	
	        if (angular.isNumber(value)) {
	          value = new Date(value);
	        }
	
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	
	        return dateParser.filter($scope.date, dateFormat);
	      });
	    } else {
	      ngModel.$formatters.push(function (value) {
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	        return value;
	      });
	    }
	
	    // Detect changes in the view from the text box
	    ngModel.$viewChangeListeners.push(function () {
	      $scope.date = parseDateString(ngModel.$viewValue);
	    });
	
	    $element.on('keydown', inputKeydownBind);
	
	    $popup = $compile(popupEl)($scope);
	    // Prevent jQuery cache memory leak (template is now redundant after linking)
	    popupEl.remove();
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else {
	      $element.after($popup);
	    }
	
	    $scope.$on('$destroy', function () {
	      if ($scope.isOpen === true) {
	        if (!$rootScope.$$phase) {
	          $scope.$apply(function () {
	            $scope.isOpen = false;
	          });
	        }
	      }
	
	      $popup.remove();
	      $element.off('keydown', inputKeydownBind);
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	
	      //Clear all watch listeners on destroy
	      while (watchListeners.length) {
	        watchListeners.shift()();
	      }
	    });
	  };
	
	  $scope.getText = function (key) {
	    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	  };
	
	  $scope.isDisabled = function (date) {
	    if (date === 'today') {
	      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	    }
	
	    var dates = {};
	    angular.forEach(['minDate', 'maxDate'], function (key) {
	      if (!$scope.datepickerOptions[key]) {
	        dates[key] = null;
	      } else if (angular.isDate($scope.datepickerOptions[key])) {
	        dates[key] = new Date($scope.datepickerOptions[key]);
	      } else {
	        if ($datepickerPopupLiteralWarning) {
	          $log.warn('Literal date support has been deprecated, please switch to date object usage');
	        }
	
	        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
	      }
	    });
	
	    return $scope.datepickerOptions && dates.minDate && $scope.compare(date, dates.minDate) < 0 || dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
	  };
	
	  $scope.compare = function (date1, date2) {
	    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	  };
	
	  // Inner change
	  $scope.dateSelection = function (dt) {
	    $scope.date = dt;
	    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	    $element.val(date);
	    ngModel.$setViewValue(date);
	
	    if (closeOnDateSelection) {
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.keydown = function (evt) {
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.select = function (date, evt) {
	    evt.stopPropagation();
	
	    if (date === 'today') {
	      var today = new Date();
	      if (angular.isDate($scope.date)) {
	        date = new Date($scope.date);
	        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	      } else {
	        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	    $scope.dateSelection(date);
	  };
	
	  $scope.close = function (evt) {
	    evt.stopPropagation();
	
	    $scope.isOpen = false;
	    $element[0].focus();
	  };
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if ($attrs.ngDisabled) {
	    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {
	      $scope.disabled = disabled;
	    }));
	  }
	
	  $scope.$watch('isOpen', function (value) {
	    if (value) {
	      if (!$scope.disabled) {
	        $timeout(function () {
	          positionPopup();
	
	          if (onOpenFocus) {
	            $scope.$broadcast('uib:datepicker.focus');
	          }
	
	          $document.on('click', documentClickBind);
	
	          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	          if (appendToBody || $position.parsePlacement(placement)[2]) {
	            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
	            if (scrollParentEl) {
	              scrollParentEl.on('scroll', positionPopup);
	            }
	          } else {
	            scrollParentEl = null;
	          }
	
	          angular.element($window).on('resize', positionPopup);
	        }, 0, false);
	      } else {
	        $scope.isOpen = false;
	      }
	    } else {
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	    }
	  });
	
	  function cameltoDash(string) {
	    return string.replace(/([A-Z])/g, function ($1) {
	      return '-' + $1.toLowerCase();
	    });
	  }
	
	  function parseDateString(viewValue) {
	    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
	    if (isNaN(date)) {
	      for (var i = 0; i < altInputFormats.length; i++) {
	        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
	        if (!isNaN(date)) {
	          return date;
	        }
	      }
	    }
	    return date;
	  }
	
	  function parseDate(viewValue) {
	    if (angular.isNumber(viewValue)) {
	      // presumably timestamp to date object
	      viewValue = new Date(viewValue);
	    }
	
	    if (!viewValue) {
	      return null;
	    }
	
	    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	      return viewValue;
	    }
	
	    if (angular.isString(viewValue)) {
	      var date = parseDateString(viewValue);
	      if (!isNaN(date)) {
	        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
	      }
	    }
	
	    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
	  }
	
	  function validator(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	
	    if (!$attrs.ngRequired && !value) {
	      return true;
	    }
	
	    if (angular.isNumber(value)) {
	      value = new Date(value);
	    }
	
	    if (!value) {
	      return true;
	    }
	
	    if (angular.isDate(value) && !isNaN(value)) {
	      return true;
	    }
	
	    if (angular.isString(value)) {
	      return !isNaN(parseDateString(value));
	    }
	
	    return false;
	  }
	
	  function documentClickBind(event) {
	    if (!$scope.isOpen && $scope.disabled) {
	      return;
	    }
	
	    var popup = $popup[0];
	    var dpContainsTarget = $element[0].contains(event.target);
	    // The popup node may not be an element node
	    // In some browsers (IE) only element nodes have the 'contains' function
	    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	      $scope.$apply(function () {
	        $scope.isOpen = false;
	      });
	    }
	  }
	
	  function inputKeydownBind(evt) {
	    if (evt.which === 27 && $scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function () {
	        $scope.isOpen = false;
	      });
	      $element[0].focus();
	    } else if (evt.which === 40 && !$scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function () {
	        $scope.isOpen = true;
	      });
	    }
	  }
	
	  function positionPopup() {
	    if ($scope.isOpen) {
	      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
	      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	      var position = $position.positionElements($element, dpElement, placement, appendToBody);
	      dpElement.css({ top: position.top + 'px', left: position.left + 'px' });
	      if (dpElement.hasClass('uib-position-measure')) {
	        dpElement.removeClass('uib-position-measure');
	      }
	    }
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) {
	      // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = angular.isObject(ngModelCtrl.$options) ? ngModelCtrl.$options : {
	        timezone: null
	      };
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else {
	      // in angular >=1.6 $options is always present
	      ngModelOptions = ngModelCtrl.$options;
	    }
	
	    return ngModelOptions;
	  }
	
	  $scope.$on('uib:datepicker.mode', function () {
	    $timeout(positionPopup, 0, false);
	  });
	}]).directive('uibDatepickerPopup', function () {
	  return {
	    require: ['ngModel', 'uibDatepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      datepickerOptions: '=?',
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@'
	    },
	    link: function link(scope, element, attrs, ctrls) {
	      var ngModel = ctrls[0],
	          ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	}).directive('uibDatepickerPopupWrap', function () {
	  return {
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
	    }
	  };
	});

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position']).constant('uibDropdownConfig', {
	  appendToOpenClass: 'uib-dropdown-open',
	  openClass: 'open'
	}).service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function ($document, $rootScope, $$multiMap) {
	  var openScope = null;
	  var openedContainers = $$multiMap.createNew();
	
	  this.isOnlyOpen = function (dropdownScope, appendTo) {
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openDropdown = openedDropdowns.reduce(function (toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (openDropdown) {
	        return openedDropdowns.length === 1;
	      }
	    }
	
	    return false;
	  };
	
	  this.open = function (dropdownScope, element, appendTo) {
	    if (!openScope) {
	      $document.on('click', closeDropdown);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openedScopes = openedDropdowns.map(function (dropdown) {
	        return dropdown.scope;
	      });
	      if (openedScopes.indexOf(dropdownScope) === -1) {
	        openedContainers.put(appendTo, {
	          scope: dropdownScope
	        });
	      }
	    } else {
	      openedContainers.put(appendTo, {
	        scope: dropdownScope
	      });
	    }
	  };
	
	  this.close = function (dropdownScope, element, appendTo) {
	    if (openScope === dropdownScope) {
	      $document.off('click', closeDropdown);
	      $document.off('keydown', this.keybindFilter);
	      openScope = null;
	    }
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var dropdownToClose = openedDropdowns.reduce(function (toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (dropdownToClose) {
	        openedContainers.remove(appendTo, dropdownToClose);
	      }
	    }
	  };
	
	  var closeDropdown = function closeDropdown(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope || !openScope.isOpen) {
	      return;
	    }
	
	    if (evt && openScope.getAutoClose() === 'disabled') {
	      return;
	    }
	
	    if (evt && evt.which === 3) {
	      return;
	    }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.focusToggleElement();
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  this.keybindFilter = function (evt) {
	    if (!openScope) {
	      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    var toggleElement = openScope.getToggleElement();
	    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
	    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}]).controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	      scope = $scope.$new(),
	      // create a child scope so we are not polluting original one
	  templateScope,
	      appendToOpenClass = dropdownConfig.appendToOpenClass,
	      openClass = dropdownConfig.openClass,
	      getIsOpen,
	      setIsOpen = angular.noop,
	      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	      keynavEnabled = false,
	      selectedOption = null,
	      body = $document.find('body');
	
	  $element.addClass('dropdown');
	
	  this.init = function () {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function (value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    keynavEnabled = angular.isDefined($attrs.keyboardNav);
	  };
	
	  this.toggle = function (open) {
	    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen(scope, scope.isOpen);
	    }
	
	    return scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function () {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function () {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function () {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function () {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function () {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function (keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	    angular.element(self.dropdownMenu).find('a') : $element.find('ul').eq(0).find('a');
	
	    switch (keyCode) {
	      case 40:
	        {
	          if (!angular.isNumber(self.selectedOption)) {
	            self.selectedOption = 0;
	          } else {
	            self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;
	          }
	          break;
	        }
	      case 38:
	        {
	          if (!angular.isNumber(self.selectedOption)) {
	            self.selectedOption = elems.length - 1;
	          } else {
	            self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;
	          }
	          break;
	        }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function () {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function () {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  function removeDropdownMenu() {
	    $element.append(self.dropdownMenu);
	  }
	
	  scope.$watch('isOpen', function (isOpen, wasOpen) {
	    var appendTo = null,
	        appendToBody = false;
	
	    if (angular.isDefined($attrs.dropdownAppendTo)) {
	      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
	      if (appendToEl) {
	        appendTo = angular.element(appendToEl);
	      }
	    }
	
	    if (angular.isDefined($attrs.dropdownAppendToBody)) {
	      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
	      if (appendToBodyValue !== false) {
	        appendToBody = true;
	      }
	    }
	
	    if (appendToBody && !appendTo) {
	      appendTo = body;
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      if (isOpen) {
	        appendTo.append(self.dropdownMenu);
	        $element.on('$destroy', removeDropdownMenu);
	      } else {
	        $element.off('$destroy', removeDropdownMenu);
	        removeDropdownMenu();
	      }
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
	          css,
	          rightalign,
	          scrollbarPadding,
	          scrollbarWidth = 0;
	
	      css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        scrollbarPadding = $position.scrollbarPadding(appendTo);
	
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          scrollbarWidth = scrollbarPadding.scrollbarWidth;
	        }
	
	        css.right = window.innerWidth - scrollbarWidth - (pos.left + $element.prop('offsetWidth')) + 'px';
	      }
	
	      // Need to adjust our positioning to be relative to the appendTo container
	      // if it's not the body element
	      if (!appendToBody) {
	        var appendOffset = $position.offset(appendTo);
	
	        css.top = pos.top - appendOffset.top + 'px';
	
	        if (!rightalign) {
	          css.left = pos.left - appendOffset.left + 'px';
	        } else {
	          css.right = window.innerWidth - (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
	        }
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    var openContainer = appendTo ? appendTo : $element;
	    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
	    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
	    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);
	
	    if (hasOpenClass === !isOpen) {
	      var toggleClass;
	      if (appendTo) {
	        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
	      } else {
	        toggleClass = isOpen ? 'addClass' : 'removeClass';
	      }
	      $animate[toggleClass](openContainer, dropdownOpenClass).then(function () {
	        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	          toggleInvoker($scope, { open: !!isOpen });
	        }
	      });
	    }
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function (dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	            $document.on('keydown', uibDropdownService.keybindFilter);
	          });
	        });
	      } else {
	        $document.on('keydown', uibDropdownService.keybindFilter);
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope, $element, appendTo);
	    } else {
	      uibDropdownService.close(scope, $element, appendTo);
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	}]).directive('uibDropdown', function () {
	  return {
	    controller: 'UibDropdownController',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	}).directive('uibDropdownMenu', function () {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	}).directive('uibDropdownToggle', function () {
	  return {
	    require: '?^uibDropdown',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function toggleDropdown(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function () {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.on('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function () {
	        element.off('click', toggleDropdown);
	      });
	    }
	  };
	});

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(88);
	__webpack_require__(29);
	__webpack_require__(617);
	
	var MODULE_NAME = 'ui.bootstrap.module.dropdown';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.dropdown']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 619 */
[863, 618],
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(621);
	
	var MODULE_NAME = 'ui.bootstrap.module.isClass';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.isClass']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	'use strict';
	
	// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
	// at most one element.
	angular.module('ui.bootstrap.isClass', []).directive('uibIsClass', ['$animate', function ($animate) {
	  //                    11111111          22222222
	  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
	  //                    11111111           22222222
	  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
	
	  var dataPerTracked = {};
	
	  return {
	    restrict: 'A',
	    compile: function compile(tElement, tAttrs) {
	      var linkedScopes = [];
	      var instances = [];
	      var expToData = {};
	      var lastActivated = null;
	      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
	      var onExp = onExpMatches[2];
	      var expsStr = onExpMatches[1];
	      var exps = expsStr.split(',');
	
	      return linkFn;
	
	      function linkFn(scope, element, attrs) {
	        linkedScopes.push(scope);
	        instances.push({
	          scope: scope,
	          element: element
	        });
	
	        exps.forEach(function (exp, k) {
	          addForExp(exp, scope);
	        });
	
	        scope.$on('$destroy', removeScope);
	      }
	
	      function addForExp(exp, scope) {
	        var matches = exp.match(IS_REGEXP);
	        var clazz = scope.$eval(matches[1]);
	        var compareWithExp = matches[2];
	        var data = expToData[exp];
	        if (!data) {
	          var watchFn = function watchFn(compareWithVal) {
	            var newActivated = null;
	            instances.some(function (instance) {
	              var thisVal = instance.scope.$eval(onExp);
	              if (thisVal === compareWithVal) {
	                newActivated = instance;
	                return true;
	              }
	            });
	            if (data.lastActivated !== newActivated) {
	              if (data.lastActivated) {
	                $animate.removeClass(data.lastActivated.element, clazz);
	              }
	              if (newActivated) {
	                $animate.addClass(newActivated.element, clazz);
	              }
	              data.lastActivated = newActivated;
	            }
	          };
	          expToData[exp] = data = {
	            lastActivated: null,
	            scope: scope,
	            watchFn: watchFn,
	            compareWithExp: compareWithExp,
	            watcher: scope.$watch(compareWithExp, watchFn)
	          };
	        }
	        data.watchFn(scope.$eval(compareWithExp));
	      }
	
	      function removeScope(e) {
	        var removedScope = e.targetScope;
	        var index = linkedScopes.indexOf(removedScope);
	        linkedScopes.splice(index, 1);
	        instances.splice(index, 1);
	        if (linkedScopes.length) {
	          var newWatchScope = linkedScopes[0];
	          angular.forEach(expToData, function (data) {
	            if (data.scope === removedScope) {
	              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
	              data.scope = newWatchScope;
	            }
	          });
	        } else {
	          expToData = {};
	        }
	      }
	    }
	  };
	}]);

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(88);
	__webpack_require__(29);
	__webpack_require__(89);
	__webpack_require__(650);
	__webpack_require__(624);
	
	var MODULE_NAME = 'ui.bootstrap.module.modal';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.modal', 'uib/template/modal/window.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 623 */
[863, 622],
/* 624 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	.provider('$uibResolve', function () {
	  var resolve = this;
	  this.resolver = null;
	
	  this.setResolver = function (resolver) {
	    this.resolver = resolver;
	  };
	
	  this.$get = ['$injector', '$q', function ($injector, $q) {
	    var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	    return {
	      resolve: function resolve(invocables, locals, parent, self) {
	        if (resolver) {
	          return resolver.resolve(invocables, locals, parent, self);
	        }
	
	        var promises = [];
	
	        angular.forEach(invocables, function (value) {
	          if (angular.isFunction(value) || angular.isArray(value)) {
	            promises.push($q.resolve($injector.invoke(value)));
	          } else if (angular.isString(value)) {
	            promises.push($q.resolve($injector.get(value)));
	          } else {
	            promises.push($q.resolve(value));
	          }
	        });
	
	        return $q.all(promises).then(function (resolves) {
	          var resolveObj = {};
	          var resolveIter = 0;
	          angular.forEach(invocables, function (value, key) {
	            resolveObj[key] = resolves[resolveIter++];
	          });
	
	          return resolveObj;
	        });
	      }
	    };
	  }];
	})
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	.directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack', function ($animate, $injector, $modalStack) {
	  return {
	    restrict: 'A',
	    compile: function compile(tElement, tAttrs) {
	      tElement.addClass(tAttrs.backdropClass);
	      return linkFn;
	    }
	  };
	
	  function linkFn(scope, element, attrs) {
	    if (attrs.modalInClass) {
	      $animate.addClass(element, attrs.modalInClass);
	
	      scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
	        var done = setIsAsync();
	        if (scope.modalOptions.animation) {
	          $animate.removeClass(element, attrs.modalInClass).then(done);
	        } else {
	          done();
	        }
	      });
	    }
	  }
	}]).directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document', function ($modalStack, $q, $animateCss, $document) {
	  return {
	    scope: {
	      index: '@'
	    },
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function templateUrl(tElement, tAttrs) {
	      return tAttrs.templateUrl || 'uib/template/modal/window.html';
	    },
	    link: function link(scope, element, attrs) {
	      element.addClass(attrs.windowTopClass || '');
	      scope.size = attrs.size;
	
	      scope.close = function (evt) {
	        var modal = $modalStack.getTop();
	        if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && evt.target === evt.currentTarget) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          $modalStack.dismiss(modal.key, 'backdrop click');
	        }
	      };
	
	      // moved from template to fix issue #2280
	      element.on('click', scope.close);
	
	      // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	      // We can detect that by using this property in the template associated with this directive and then use
	      // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	      scope.$isRendered = true;
	
	      // Deferred object that will be resolved when this modal is rendered.
	      var modalRenderDeferObj = $q.defer();
	      // Resolve render promise post-digest
	      scope.$$postDigest(function () {
	        modalRenderDeferObj.resolve();
	      });
	
	      modalRenderDeferObj.promise.then(function () {
	        var animationPromise = null;
	
	        if (attrs.modalInClass) {
	          animationPromise = $animateCss(element, {
	            addClass: attrs.modalInClass
	          }).start();
	
	          scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
	            var done = setIsAsync();
	            $animateCss(element, {
	              removeClass: attrs.modalInClass
	            }).start().then(done);
	          });
	        }
	
	        $q.when(animationPromise).then(function () {
	          // Notify {@link $modalStack} that modal is rendered.
	          var modal = $modalStack.getTop();
	          if (modal) {
	            $modalStack.modalRendered(modal.key);
	          }
	
	          /**
	           * If something within the freshly-opened modal already has focus (perhaps via a
	           * directive that causes focus) then there's no need to try to focus anything.
	           */
	          if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	            var inputWithAutofocus = element[0].querySelector('[autofocus]');
	            /**
	             * Auto-focusing of a freshly-opened modal element causes any child elements
	             * with the autofocus attribute to lose focus. This is an issue on touch
	             * based devices which will show and then hide the onscreen keyboard.
	             * Attempts to refocus the autofocus element via JavaScript will not reopen
	             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	             * the modal element if the modal does not contain an autofocus element.
	             */
	            if (inputWithAutofocus) {
	              inputWithAutofocus.focus();
	            } else {
	              element[0].focus();
	            }
	          }
	        });
	      });
	    }
	  };
	}]).directive('uibModalAnimationClass', function () {
	  return {
	    compile: function compile(tElement, tAttrs) {
	      if (tAttrs.modalAnimation) {
	        tElement.addClass(tAttrs.uibModalAnimationClass);
	      }
	    }
	  };
	}).directive('uibModalTransclude', ['$animate', function ($animate) {
	  return {
	    link: function link(scope, element, attrs, controller, transclude) {
	      transclude(scope.$parent, function (clone) {
	        element.empty();
	        $animate.enter(clone, element);
	      });
	    }
	  };
	}]).factory('$uibModalStack', ['$animate', '$animateCss', '$document', '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition', function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
	  var OPENED_MODAL_CLASS = 'modal-open';
	
	  var backdropDomEl, backdropScope;
	  var openedWindows = $$stackedMap.createNew();
	  var openedClasses = $$multiMap.createNew();
	  var $modalStack = {
	    NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	  };
	  var topModalIndex = 0;
	  var previousTopOpenedModal = null;
	  var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';
	
	  //Modal focus behavior
	  var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' + 'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' + 'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
	  var scrollbarPadding;
	  var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	  // TODO: extract into common dependency with tooltip
	  function snake_case(name) {
	    var separator = '-';
	    return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  function isVisible(element) {
	    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
	  }
	
	  function backdropIndex() {
	    var topBackdropIndex = -1;
	    var opened = openedWindows.keys();
	    for (var i = 0; i < opened.length; i++) {
	      if (openedWindows.get(opened[i]).value.backdrop) {
	        topBackdropIndex = i;
	      }
	    }
	
	    // If any backdrop exist, ensure that it's index is always
	    // right below the top modal
	    if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
	      topBackdropIndex = topModalIndex;
	    }
	    return topBackdropIndex;
	  }
	
	  $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
	    if (backdropScope) {
	      backdropScope.index = newBackdropIndex;
	    }
	  });
	
	  function removeModalWindow(modalInstance, elementToReceiveFocus) {
	    var modalWindow = openedWindows.get(modalInstance).value;
	    var appendToElement = modalWindow.appendTo;
	
	    //clean up the stack
	    openedWindows.remove(modalInstance);
	    previousTopOpenedModal = openedWindows.top();
	    if (previousTopOpenedModal) {
	      topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
	    }
	
	    removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
	      var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	      openedClasses.remove(modalBodyClass, modalInstance);
	      var areAnyOpen = openedClasses.hasKey(modalBodyClass);
	      appendToElement.toggleClass(modalBodyClass, areAnyOpen);
	      if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	        if (scrollbarPadding.originalRight) {
	          appendToElement.css({ paddingRight: scrollbarPadding.originalRight + 'px' });
	        } else {
	          appendToElement.css({ paddingRight: '' });
	        }
	        scrollbarPadding = null;
	      }
	      toggleTopWindowClass(true);
	    }, modalWindow.closedDeferred);
	    checkRemoveBackdrop();
	
	    //move focus to specified element if available, or else to body
	    if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	      elementToReceiveFocus.focus();
	    } else if (appendToElement.focus) {
	      appendToElement.focus();
	    }
	  }
	
	  // Add or remove "windowTopClass" from the top window in the stack
	  function toggleTopWindowClass(toggleSwitch) {
	    var modalWindow;
	
	    if (openedWindows.length() > 0) {
	      modalWindow = openedWindows.top().value;
	      modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	    }
	  }
	
	  function checkRemoveBackdrop() {
	    //remove backdrop if no longer needed
	    if (backdropDomEl && backdropIndex() === -1) {
	      var backdropScopeRef = backdropScope;
	      removeAfterAnimate(backdropDomEl, backdropScope, function () {
	        backdropScopeRef = null;
	      });
	      backdropDomEl = undefined;
	      backdropScope = undefined;
	    }
	  }
	
	  function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	    var asyncDeferred;
	    var asyncPromise = null;
	    var setIsAsync = function setIsAsync() {
	      if (!asyncDeferred) {
	        asyncDeferred = $q.defer();
	        asyncPromise = asyncDeferred.promise;
	      }
	
	      return function asyncDone() {
	        asyncDeferred.resolve();
	      };
	    };
	    scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	    // Note that it's intentional that asyncPromise might be null.
	    // That's when setIsAsync has not been called during the
	    // NOW_CLOSING_EVENT broadcast.
	    return $q.when(asyncPromise).then(afterAnimating);
	
	    function afterAnimating() {
	      if (afterAnimating.done) {
	        return;
	      }
	      afterAnimating.done = true;
	
	      $animate.leave(domEl).then(function () {
	        if (done) {
	          done();
	        }
	
	        domEl.remove();
	        if (closedDeferred) {
	          closedDeferred.resolve();
	        }
	      });
	
	      scope.$destroy();
	    }
	  }
	
	  $document.on('keydown', keydownListener);
	
	  $rootScope.$on('$destroy', function () {
	    $document.off('keydown', keydownListener);
	  });
	
	  function keydownListener(evt) {
	    if (evt.isDefaultPrevented()) {
	      return evt;
	    }
	
	    var modal = openedWindows.top();
	    if (modal) {
	      switch (evt.which) {
	        case 27:
	          {
	            if (modal.value.keyboard) {
	              evt.preventDefault();
	              $rootScope.$apply(function () {
	                $modalStack.dismiss(modal.key, 'escape key press');
	              });
	            }
	            break;
	          }
	        case 9:
	          {
	            var list = $modalStack.loadFocusElementList(modal);
	            var focusChanged = false;
	            if (evt.shiftKey) {
	              if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                focusChanged = $modalStack.focusLastFocusableElement(list);
	              }
	            } else {
	              if ($modalStack.isFocusInLastItem(evt, list)) {
	                focusChanged = $modalStack.focusFirstFocusableElement(list);
	              }
	            }
	
	            if (focusChanged) {
	              evt.preventDefault();
	              evt.stopPropagation();
	            }
	
	            break;
	          }
	      }
	    }
	  }
	
	  $modalStack.open = function (modalInstance, modal) {
	    var modalOpener = $document[0].activeElement,
	        modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	    toggleTopWindowClass(false);
	
	    // Store the current top first, to determine what index we ought to use
	    // for the current top modal
	    previousTopOpenedModal = openedWindows.top();
	
	    openedWindows.add(modalInstance, {
	      deferred: modal.deferred,
	      renderDeferred: modal.renderDeferred,
	      closedDeferred: modal.closedDeferred,
	      modalScope: modal.scope,
	      backdrop: modal.backdrop,
	      keyboard: modal.keyboard,
	      openedClass: modal.openedClass,
	      windowTopClass: modal.windowTopClass,
	      animation: modal.animation,
	      appendTo: modal.appendTo
	    });
	
	    openedClasses.put(modalBodyClass, modalInstance);
	
	    var appendToElement = modal.appendTo,
	        currBackdropIndex = backdropIndex();
	
	    if (currBackdropIndex >= 0 && !backdropDomEl) {
	      backdropScope = $rootScope.$new(true);
	      backdropScope.modalOptions = modal;
	      backdropScope.index = currBackdropIndex;
	      backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	      backdropDomEl.attr({
	        'class': 'modal-backdrop',
	        'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
	        'uib-modal-animation-class': 'fade',
	        'modal-in-class': 'in'
	      });
	      if (modal.backdropClass) {
	        backdropDomEl.addClass(modal.backdropClass);
	      }
	
	      if (modal.animation) {
	        backdropDomEl.attr('modal-animation', 'true');
	      }
	      $compile(backdropDomEl)(backdropScope);
	      $animate.enter(backdropDomEl, appendToElement);
	      if ($uibPosition.isScrollable(appendToElement)) {
	        scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          appendToElement.css({ paddingRight: scrollbarPadding.right + 'px' });
	        }
	      }
	    }
	
	    var content;
	    if (modal.component) {
	      content = document.createElement(snake_case(modal.component.name));
	      content = angular.element(content);
	      content.attr({
	        resolve: '$resolve',
	        'modal-instance': '$uibModalInstance',
	        close: '$close($value)',
	        dismiss: '$dismiss($value)'
	      });
	    } else {
	      content = modal.content;
	    }
	
	    // Set the top modal index based on the index of the previous top modal
	    topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
	    var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	    angularDomEl.attr({
	      'class': 'modal',
	      'template-url': modal.windowTemplateUrl,
	      'window-top-class': modal.windowTopClass,
	      'role': 'dialog',
	      'aria-labelledby': modal.ariaLabelledBy,
	      'aria-describedby': modal.ariaDescribedBy,
	      'size': modal.size,
	      'index': topModalIndex,
	      'animate': 'animate',
	      'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
	      'tabindex': -1,
	      'uib-modal-animation-class': 'fade',
	      'modal-in-class': 'in'
	    }).append(content);
	    if (modal.windowClass) {
	      angularDomEl.addClass(modal.windowClass);
	    }
	
	    if (modal.animation) {
	      angularDomEl.attr('modal-animation', 'true');
	    }
	
	    appendToElement.addClass(modalBodyClass);
	    if (modal.scope) {
	      // we need to explicitly add the modal index to the modal scope
	      // because it is needed by ngStyle to compute the zIndex property.
	      modal.scope.$$topModalIndex = topModalIndex;
	    }
	    $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);
	
	    openedWindows.top().value.modalDomEl = angularDomEl;
	    openedWindows.top().value.modalOpener = modalOpener;
	
	    applyAriaHidden(angularDomEl);
	
	    function applyAriaHidden(el) {
	      if (!el || el[0].tagName === 'BODY') {
	        return;
	      }
	
	      getSiblings(el).forEach(function (sibling) {
	        var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
	            ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);
	
	        if (!ariaHiddenCount) {
	          ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
	        }
	
	        sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
	        sibling.setAttribute('aria-hidden', 'true');
	      });
	
	      return applyAriaHidden(el.parent());
	
	      function getSiblings(el) {
	        var children = el.parent() ? el.parent().children() : [];
	
	        return Array.prototype.filter.call(children, function (child) {
	          return child !== el[0];
	        });
	      }
	    }
	  };
	
	  function broadcastClosing(modalWindow, resultOrReason, closing) {
	    return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	  }
	
	  function unhideBackgroundElements() {
	    Array.prototype.forEach.call(document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'), function (hiddenEl) {
	      var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
	          newHiddenCount = ariaHiddenCount - 1;
	      hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);
	
	      if (!newHiddenCount) {
	        hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
	        hiddenEl.removeAttribute('aria-hidden');
	      }
	    });
	  }
	
	  $modalStack.close = function (modalInstance, result) {
	    var modalWindow = openedWindows.get(modalInstance);
	    unhideBackgroundElements();
	    if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	      modalWindow.value.deferred.resolve(result);
	      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	      return true;
	    }
	
	    return !modalWindow;
	  };
	
	  $modalStack.dismiss = function (modalInstance, reason) {
	    var modalWindow = openedWindows.get(modalInstance);
	    unhideBackgroundElements();
	    if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	      modalWindow.value.deferred.reject(reason);
	      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	      return true;
	    }
	    return !modalWindow;
	  };
	
	  $modalStack.dismissAll = function (reason) {
	    var topModal = this.getTop();
	    while (topModal && this.dismiss(topModal.key, reason)) {
	      topModal = this.getTop();
	    }
	  };
	
	  $modalStack.getTop = function () {
	    return openedWindows.top();
	  };
	
	  $modalStack.modalRendered = function (modalInstance) {
	    var modalWindow = openedWindows.get(modalInstance);
	    if (modalWindow) {
	      modalWindow.value.renderDeferred.resolve();
	    }
	  };
	
	  $modalStack.focusFirstFocusableElement = function (list) {
	    if (list.length > 0) {
	      list[0].focus();
	      return true;
	    }
	    return false;
	  };
	
	  $modalStack.focusLastFocusableElement = function (list) {
	    if (list.length > 0) {
	      list[list.length - 1].focus();
	      return true;
	    }
	    return false;
	  };
	
	  $modalStack.isModalFocused = function (evt, modalWindow) {
	    if (evt && modalWindow) {
	      var modalDomEl = modalWindow.value.modalDomEl;
	      if (modalDomEl && modalDomEl.length) {
	        return (evt.target || evt.srcElement) === modalDomEl[0];
	      }
	    }
	    return false;
	  };
	
	  $modalStack.isFocusInFirstItem = function (evt, list) {
	    if (list.length > 0) {
	      return (evt.target || evt.srcElement) === list[0];
	    }
	    return false;
	  };
	
	  $modalStack.isFocusInLastItem = function (evt, list) {
	    if (list.length > 0) {
	      return (evt.target || evt.srcElement) === list[list.length - 1];
	    }
	    return false;
	  };
	
	  $modalStack.loadFocusElementList = function (modalWindow) {
	    if (modalWindow) {
	      var modalDomE1 = modalWindow.value.modalDomEl;
	      if (modalDomE1 && modalDomE1.length) {
	        var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
	        return elements ? Array.prototype.filter.call(elements, function (element) {
	          return isVisible(element);
	        }) : elements;
	      }
	    }
	  };
	
	  return $modalStack;
	}]).provider('$uibModal', function () {
	  var $modalProvider = {
	    options: {
	      animation: true,
	      backdrop: true, //can also be false or 'static'
	      keyboard: true
	    },
	    $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack', function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	      var $modal = {};
	
	      function getTemplatePromise(options) {
	        return options.template ? $q.when(options.template) : $templateRequest(angular.isFunction(options.templateUrl) ? options.templateUrl() : options.templateUrl);
	      }
	
	      var promiseChain = null;
	      $modal.getPromiseChain = function () {
	        return promiseChain;
	      };
	
	      $modal.open = function (modalOptions) {
	        var modalResultDeferred = $q.defer();
	        var modalOpenedDeferred = $q.defer();
	        var modalClosedDeferred = $q.defer();
	        var modalRenderDeferred = $q.defer();
	
	        //prepare an instance of a modal to be injected into controllers and returned to a caller
	        var modalInstance = {
	          result: modalResultDeferred.promise,
	          opened: modalOpenedDeferred.promise,
	          closed: modalClosedDeferred.promise,
	          rendered: modalRenderDeferred.promise,
	          close: function close(result) {
	            return $modalStack.close(modalInstance, result);
	          },
	          dismiss: function dismiss(reason) {
	            return $modalStack.dismiss(modalInstance, reason);
	          }
	        };
	
	        //merge and clean up options
	        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	        modalOptions.resolve = modalOptions.resolve || {};
	        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	        if (!modalOptions.appendTo.length) {
	          throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	        }
	
	        //verify options
	        if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
	          throw new Error('One of component or template or templateUrl options is required.');
	        }
	
	        var templateAndResolvePromise;
	        if (modalOptions.component) {
	          templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
	        } else {
	          templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	        }
	
	        function resolveWithTemplate() {
	          return templateAndResolvePromise;
	        }
	
	        // Wait for the resolution of the existing promise chain.
	        // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	        // Then add to $modalStack and resolve opened.
	        // Finally clean up the chain variable if no subsequent modal has overwritten it.
	        var samePromise;
	        samePromise = promiseChain = $q.all([promiseChain]).then(resolveWithTemplate, resolveWithTemplate).then(function resolveSuccess(tplAndVars) {
	          var providedScope = modalOptions.scope || $rootScope;
	
	          var modalScope = providedScope.$new();
	          modalScope.$close = modalInstance.close;
	          modalScope.$dismiss = modalInstance.dismiss;
	
	          modalScope.$on('$destroy', function () {
	            if (!modalScope.$$uibDestructionScheduled) {
	              modalScope.$dismiss('$uibUnscheduledDestruction');
	            }
	          });
	
	          var modal = {
	            scope: modalScope,
	            deferred: modalResultDeferred,
	            renderDeferred: modalRenderDeferred,
	            closedDeferred: modalClosedDeferred,
	            animation: modalOptions.animation,
	            backdrop: modalOptions.backdrop,
	            keyboard: modalOptions.keyboard,
	            backdropClass: modalOptions.backdropClass,
	            windowTopClass: modalOptions.windowTopClass,
	            windowClass: modalOptions.windowClass,
	            windowTemplateUrl: modalOptions.windowTemplateUrl,
	            ariaLabelledBy: modalOptions.ariaLabelledBy,
	            ariaDescribedBy: modalOptions.ariaDescribedBy,
	            size: modalOptions.size,
	            openedClass: modalOptions.openedClass,
	            appendTo: modalOptions.appendTo
	          };
	
	          var component = {};
	          var ctrlInstance,
	              ctrlInstantiate,
	              ctrlLocals = {};
	
	          if (modalOptions.component) {
	            constructLocals(component, false, true, false);
	            component.name = modalOptions.component;
	            modal.component = component;
	          } else if (modalOptions.controller) {
	            constructLocals(ctrlLocals, true, false, true);
	
	            // the third param will make the controller instantiate later,private api
	            // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	            ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
	            if (modalOptions.controllerAs && modalOptions.bindToController) {
	              ctrlInstance = ctrlInstantiate.instance;
	              ctrlInstance.$close = modalScope.$close;
	              ctrlInstance.$dismiss = modalScope.$dismiss;
	              angular.extend(ctrlInstance, {
	                $resolve: ctrlLocals.$scope.$resolve
	              }, providedScope);
	            }
	
	            ctrlInstance = ctrlInstantiate();
	
	            if (angular.isFunction(ctrlInstance.$onInit)) {
	              ctrlInstance.$onInit();
	            }
	          }
	
	          if (!modalOptions.component) {
	            modal.content = tplAndVars[0];
	          }
	
	          $modalStack.open(modalInstance, modal);
	          modalOpenedDeferred.resolve(true);
	
	          function constructLocals(obj, template, instanceOnScope, injectable) {
	            obj.$scope = modalScope;
	            obj.$scope.$resolve = {};
	            if (instanceOnScope) {
	              obj.$scope.$uibModalInstance = modalInstance;
	            } else {
	              obj.$uibModalInstance = modalInstance;
	            }
	
	            var resolves = template ? tplAndVars[1] : tplAndVars;
	            angular.forEach(resolves, function (value, key) {
	              if (injectable) {
	                obj[key] = value;
	              }
	
	              obj.$scope.$resolve[key] = value;
	            });
	          }
	        }, function resolveError(reason) {
	          modalOpenedDeferred.reject(reason);
	          modalResultDeferred.reject(reason);
	        })['finally'](function () {
	          if (promiseChain === samePromise) {
	            promiseChain = null;
	          }
	        });
	
	        return modalInstance;
	      };
	
	      return $modal;
	    }]
	  };
	
	  return $modalProvider;
	});

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.multiMap', [])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	.factory('$$multiMap', function () {
	  return {
	    createNew: function createNew() {
	      var map = {};
	
	      return {
	        entries: function entries() {
	          return Object.keys(map).map(function (key) {
	            return {
	              key: key,
	              value: map[key]
	            };
	          });
	        },
	        get: function get(key) {
	          return map[key];
	        },
	        hasKey: function hasKey(key) {
	          return !!map[key];
	        },
	        keys: function keys() {
	          return Object.keys(map);
	        },
	        put: function put(key, value) {
	          if (!map[key]) {
	            map[key] = [];
	          }
	
	          map[key].push(value);
	        },
	        remove: function remove(key, value) {
	          var values = map[key];
	
	          if (!values) {
	            return;
	          }
	
	          var idx = values.indexOf(value);
	
	          if (idx !== -1) {
	            values.splice(idx, 1);
	          }
	
	          if (!values.length) {
	            delete map[key];
	          }
	        }
	      };
	    }
	  };
	});

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(90);
	__webpack_require__(653);
	__webpack_require__(651);
	__webpack_require__(652);
	__webpack_require__(628);
	
	var MODULE_NAME = 'ui.bootstrap.module.popover';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.popover', 'uib/template/popover/popover.html', 'uib/template/popover/popover-html.html', 'uib/template/popover/popover-template.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(80);
	module.exports = __webpack_require__(626);

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip']).directive('uibPopoverTemplatePopup', function () {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/popover/popover-template.html'
	  };
	}).directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}]).directive('uibPopoverHtmlPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', uibTitle: '@' },
	    templateUrl: 'uib/template/popover/popover-html.html'
	  };
	}).directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}]).directive('uibPopoverPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', content: '@' },
	    templateUrl: 'uib/template/popover/popover.html'
	  };
	}).directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopover', 'popover', 'click');
	}]);

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	.factory('$uibPosition', ['$document', '$window', function ($document, $window) {
	  /**
	   * Used by scrollbarWidth() function to cache scrollbar's width.
	   * Do not access this variable directly, use scrollbarWidth() instead.
	   */
	  var SCROLLBAR_WIDTH;
	  /**
	   * scrollbar on body and html element in IE and Edge overlay
	   * content and should be considered 0 width.
	   */
	  var BODY_SCROLLBAR_WIDTH;
	  var OVERFLOW_REGEX = {
	    normal: /(auto|scroll)/,
	    hidden: /(auto|scroll|hidden)/
	  };
	  var PLACEMENT_REGEX = {
	    auto: /\s?auto?\s?/i,
	    primary: /^(top|bottom|left|right)$/,
	    secondary: /^(top|bottom|left|right|center)$/,
	    vertical: /^(top|bottom)$/
	  };
	  var BODY_REGEX = /(HTML|BODY)/;
	
	  return {
	
	    /**
	     * Provides a raw DOM element from a jQuery/jQLite element.
	     *
	     * @param {element} elem - The element to convert.
	     *
	     * @returns {element} A HTML element.
	     */
	    getRawNode: function getRawNode(elem) {
	      return elem.nodeName ? elem : elem[0] || elem;
	    },
	
	    /**
	     * Provides a parsed number for a style property.  Strips
	     * units and casts invalid numbers to 0.
	     *
	     * @param {string} value - The style value to parse.
	     *
	     * @returns {number} A valid number.
	     */
	    parseStyle: function parseStyle(value) {
	      value = parseFloat(value);
	      return isFinite(value) ? value : 0;
	    },
	
	    /**
	     * Provides the closest positioned ancestor.
	     *
	     * @param {element} element - The element to get the offest parent for.
	     *
	     * @returns {element} The closest positioned ancestor.
	     */
	    offsetParent: function offsetParent(elem) {
	      elem = this.getRawNode(elem);
	
	      var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	      function isStaticPositioned(el) {
	        return ($window.getComputedStyle(el).position || 'static') === 'static';
	      }
	
	      while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	        offsetParent = offsetParent.offsetParent;
	      }
	
	      return offsetParent || $document[0].documentElement;
	    },
	
	    /**
	     * Provides the scrollbar width, concept from TWBS measureScrollbar()
	     * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	     * In IE and Edge, scollbar on body and html element overlay and should
	     * return a width of 0.
	     *
	     * @returns {number} The width of the browser scollbar.
	     */
	    scrollbarWidth: function scrollbarWidth(isBody) {
	      if (isBody) {
	        if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
	          var bodyElem = $document.find('body');
	          bodyElem.addClass('uib-position-body-scrollbar-measure');
	          BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
	          BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
	          bodyElem.removeClass('uib-position-body-scrollbar-measure');
	        }
	        return BODY_SCROLLBAR_WIDTH;
	      }
	
	      if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	        var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	        $document.find('body').append(scrollElem);
	        SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	        SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	        scrollElem.remove();
	      }
	
	      return SCROLLBAR_WIDTH;
	    },
	
	    /**
	     * Provides the padding required on an element to replace the scrollbar.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**scrollbarWidth**: the width of the scrollbar</li>
	     *     <li>**widthOverflow**: whether the the width is overflowing</li>
	     *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
	     *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
	     *     <li>**heightOverflow**: whether the the height is overflowing</li>
	     *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
	     *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
	     *   </ul>
	     */
	    scrollbarPadding: function scrollbarPadding(elem) {
	      elem = this.getRawNode(elem);
	
	      var elemStyle = $window.getComputedStyle(elem);
	      var paddingRight = this.parseStyle(elemStyle.paddingRight);
	      var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
	      var scrollParent = this.scrollParent(elem, false, true);
	      var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));
	
	      return {
	        scrollbarWidth: scrollbarWidth,
	        widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
	        right: paddingRight + scrollbarWidth,
	        originalRight: paddingRight,
	        heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
	        bottom: paddingBottom + scrollbarWidth,
	        originalBottom: paddingBottom
	      };
	    },
	
	    /**
	     * Checks to see if the element is scrollable.
	     *
	     * @param {element} elem - The element to check.
	     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	     *   default is false.
	     *
	     * @returns {boolean} Whether the element is scrollable.
	     */
	    isScrollable: function isScrollable(elem, includeHidden) {
	      elem = this.getRawNode(elem);
	
	      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	      var elemStyle = $window.getComputedStyle(elem);
	      return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	    },
	
	    /**
	     * Provides the closest scrollable ancestor.
	     * A port of the jQuery UI scrollParent method:
	     * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	     *
	     * @param {element} elem - The element to find the scroll parent of.
	     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	     *   default is false.
	     * @param {boolean=} [includeSelf=false] - Should the element being passed be
	     * included in the scrollable llokup.
	     *
	     * @returns {element} A HTML element.
	     */
	    scrollParent: function scrollParent(elem, includeHidden, includeSelf) {
	      elem = this.getRawNode(elem);
	
	      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	      var documentEl = $document[0].documentElement;
	      var elemStyle = $window.getComputedStyle(elem);
	      if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
	        return elem;
	      }
	      var excludeStatic = elemStyle.position === 'absolute';
	      var scrollParent = elem.parentElement || documentEl;
	
	      if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	        return documentEl;
	      }
	
	      while (scrollParent.parentElement && scrollParent !== documentEl) {
	        var spStyle = $window.getComputedStyle(scrollParent);
	        if (excludeStatic && spStyle.position !== 'static') {
	          excludeStatic = false;
	        }
	
	        if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	          break;
	        }
	        scrollParent = scrollParent.parentElement;
	      }
	
	      return scrollParent;
	    },
	
	    /**
	     * Provides read-only equivalent of jQuery's position function:
	     * http://api.jquery.com/position/ - distance to closest positioned
	     * ancestor.  Does not account for margins by default like jQuery position.
	     *
	     * @param {element} elem - The element to caclulate the position on.
	     * @param {boolean=} [includeMargins=false] - Should margins be accounted
	     * for, default is false.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**width**: the width of the element</li>
	     *     <li>**height**: the height of the element</li>
	     *     <li>**top**: distance to top edge of offset parent</li>
	     *     <li>**left**: distance to left edge of offset parent</li>
	     *   </ul>
	     */
	    position: function position(elem, includeMagins) {
	      elem = this.getRawNode(elem);
	
	      var elemOffset = this.offset(elem);
	      if (includeMagins) {
	        var elemStyle = $window.getComputedStyle(elem);
	        elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	        elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	      }
	      var parent = this.offsetParent(elem);
	      var parentOffset = { top: 0, left: 0 };
	
	      if (parent !== $document[0].documentElement) {
	        parentOffset = this.offset(parent);
	        parentOffset.top += parent.clientTop - parent.scrollTop;
	        parentOffset.left += parent.clientLeft - parent.scrollLeft;
	      }
	
	      return {
	        width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	        height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	        top: Math.round(elemOffset.top - parentOffset.top),
	        left: Math.round(elemOffset.left - parentOffset.left)
	      };
	    },
	
	    /**
	     * Provides read-only equivalent of jQuery's offset function:
	     * http://api.jquery.com/offset/ - distance to viewport.  Does
	     * not account for borders, margins, or padding on the body
	     * element.
	     *
	     * @param {element} elem - The element to calculate the offset on.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**width**: the width of the element</li>
	     *     <li>**height**: the height of the element</li>
	     *     <li>**top**: distance to top edge of viewport</li>
	     *     <li>**right**: distance to bottom edge of viewport</li>
	     *   </ul>
	     */
	    offset: function offset(elem) {
	      elem = this.getRawNode(elem);
	
	      var elemBCR = elem.getBoundingClientRect();
	      return {
	        width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	        height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	        top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	        left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	      };
	    },
	
	    /**
	     * Provides offset distance to the closest scrollable ancestor
	     * or viewport.  Accounts for border and scrollbar width.
	     *
	     * Right and bottom dimensions represent the distance to the
	     * respective edge of the viewport element.  If the element
	     * edge extends beyond the viewport, a negative value will be
	     * reported.
	     *
	     * @param {element} elem - The element to get the viewport offset for.
	     * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	     * of the first scrollable element, default is false.
	     * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	     * be accounted for, default is true.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**top**: distance to the top content edge of viewport element</li>
	     *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	     *     <li>**left**: distance to the left content edge of viewport element</li>
	     *     <li>**right**: distance to the right content edge of viewport element</li>
	     *   </ul>
	     */
	    viewportOffset: function viewportOffset(elem, useDocument, includePadding) {
	      elem = this.getRawNode(elem);
	      includePadding = includePadding !== false ? true : false;
	
	      var elemBCR = elem.getBoundingClientRect();
	      var offsetBCR = { top: 0, left: 0, bottom: 0, right: 0 };
	
	      var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	      var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	      offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	      offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	      if (offsetParent === $document[0].documentElement) {
	        offsetBCR.top += $window.pageYOffset;
	        offsetBCR.left += $window.pageXOffset;
	      }
	      offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	      offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	      if (includePadding) {
	        var offsetParentStyle = $window.getComputedStyle(offsetParent);
	        offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	        offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	        offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	        offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	      }
	
	      return {
	        top: Math.round(elemBCR.top - offsetBCR.top),
	        bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	        left: Math.round(elemBCR.left - offsetBCR.left),
	        right: Math.round(offsetBCR.right - elemBCR.right)
	      };
	    },
	
	    /**
	     * Provides an array of placement values parsed from a placement string.
	     * Along with the 'auto' indicator, supported placement strings are:
	     *   <ul>
	     *     <li>top: element on top, horizontally centered on host element.</li>
	     *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	     *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	     *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	     *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	     *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	     *     <li>left: element on left, vertically centered on host element.</li>
	     *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	     *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	     *     <li>right: element on right, vertically centered on host element.</li>
	     *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	     *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	     *   </ul>
	     * A placement string with an 'auto' indicator is expected to be
	     * space separated from the placement, i.e: 'auto bottom-left'  If
	     * the primary and secondary placement values do not match 'top,
	     * bottom, left, right' then 'top' will be the primary placement and
	     * 'center' will be the secondary placement.  If 'auto' is passed, true
	     * will be returned as the 3rd value of the array.
	     *
	     * @param {string} placement - The placement string to parse.
	     *
	     * @returns {array} An array with the following values
	     * <ul>
	     *   <li>**[0]**: The primary placement.</li>
	     *   <li>**[1]**: The secondary placement.</li>
	     *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	     * </ul>
	     */
	    parsePlacement: function parsePlacement(placement) {
	      var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	      if (autoPlace) {
	        placement = placement.replace(PLACEMENT_REGEX.auto, '');
	      }
	
	      placement = placement.split('-');
	
	      placement[0] = placement[0] || 'top';
	      if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	        placement[0] = 'top';
	      }
	
	      placement[1] = placement[1] || 'center';
	      if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	        placement[1] = 'center';
	      }
	
	      if (autoPlace) {
	        placement[2] = true;
	      } else {
	        placement[2] = false;
	      }
	
	      return placement;
	    },
	
	    /**
	     * Provides coordinates for an element to be positioned relative to
	     * another element.  Passing 'auto' as part of the placement parameter
	     * will enable smart placement - where the element fits. i.e:
	     * 'auto left-top' will check to see if there is enough space to the left
	     * of the hostElem to fit the targetElem, if not place right (same for secondary
	     * top placement).  Available space is calculated using the viewportOffset
	     * function.
	     *
	     * @param {element} hostElem - The element to position against.
	     * @param {element} targetElem - The element to position.
	     * @param {string=} [placement=top] - The placement for the targetElem,
	     *   default is 'top'. 'center' is assumed as secondary placement for
	     *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	     *   <ul>
	     *     <li>top</li>
	     *     <li>top-right</li>
	     *     <li>top-left</li>
	     *     <li>bottom</li>
	     *     <li>bottom-left</li>
	     *     <li>bottom-right</li>
	     *     <li>left</li>
	     *     <li>left-top</li>
	     *     <li>left-bottom</li>
	     *     <li>right</li>
	     *     <li>right-top</li>
	     *     <li>right-bottom</li>
	     *   </ul>
	     * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	     *   be calculated from the body element, default is false.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**top**: Value for targetElem top.</li>
	     *     <li>**left**: Value for targetElem left.</li>
	     *     <li>**placement**: The resolved placement.</li>
	     *   </ul>
	     */
	    positionElements: function positionElements(hostElem, targetElem, placement, appendToBody) {
	      hostElem = this.getRawNode(hostElem);
	      targetElem = this.getRawNode(targetElem);
	
	      // need to read from prop to support tests.
	      var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	      var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	      placement = this.parsePlacement(placement);
	
	      var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	      var targetElemPos = { top: 0, left: 0, placement: '' };
	
	      if (placement[2]) {
	        var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	        var targetElemStyle = $window.getComputedStyle(targetElem);
	        var adjustedSize = {
	          width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	          height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	        };
	
	        placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' : placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' : placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' : placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' : placement[0];
	
	        placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' : placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' : placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' : placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' : placement[1];
	
	        if (placement[1] === 'center') {
	          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	              placement[1] = 'left';
	            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	              placement[1] = 'right';
	            }
	          } else {
	            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	              placement[1] = 'top';
	            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	              placement[1] = 'bottom';
	            }
	          }
	        }
	      }
	
	      switch (placement[0]) {
	        case 'top':
	          targetElemPos.top = hostElemPos.top - targetHeight;
	          break;
	        case 'bottom':
	          targetElemPos.top = hostElemPos.top + hostElemPos.height;
	          break;
	        case 'left':
	          targetElemPos.left = hostElemPos.left - targetWidth;
	          break;
	        case 'right':
	          targetElemPos.left = hostElemPos.left + hostElemPos.width;
	          break;
	      }
	
	      switch (placement[1]) {
	        case 'top':
	          targetElemPos.top = hostElemPos.top;
	          break;
	        case 'bottom':
	          targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	          break;
	        case 'left':
	          targetElemPos.left = hostElemPos.left;
	          break;
	        case 'right':
	          targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	          break;
	        case 'center':
	          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	          } else {
	            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	          }
	          break;
	      }
	
	      targetElemPos.top = Math.round(targetElemPos.top);
	      targetElemPos.left = Math.round(targetElemPos.left);
	      targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	      return targetElemPos;
	    },
	
	    /**
	     * Provides a way to adjust the top positioning after first
	     * render to correctly align element to top after content
	     * rendering causes resized element height
	     *
	     * @param {array} placementClasses - The array of strings of classes
	     * element should have.
	     * @param {object} containerPosition - The object with container
	     * position information
	     * @param {number} initialHeight - The initial height for the elem.
	     * @param {number} currentHeight - The current height for the elem.
	     */
	    adjustTop: function adjustTop(placementClasses, containerPosition, initialHeight, currentHeight) {
	      if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
	        return {
	          top: containerPosition.top - currentHeight + 'px'
	        };
	      }
	    },
	
	    /**
	     * Provides a way for positioning tooltip & dropdown
	     * arrows when using placement options beyond the standard
	     * left, right, top, or bottom.
	     *
	     * @param {element} elem - The tooltip/dropdown element.
	     * @param {string} placement - The placement for the elem.
	     */
	    positionArrow: function positionArrow(elem, placement) {
	      elem = this.getRawNode(elem);
	
	      var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	      if (!innerElem) {
	        return;
	      }
	
	      var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	      var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	      if (!arrowElem) {
	        return;
	      }
	
	      var arrowCss = {
	        top: '',
	        bottom: '',
	        left: '',
	        right: ''
	      };
	
	      placement = this.parsePlacement(placement);
	      if (placement[1] === 'center') {
	        // no adjustment necessary - just reset styles
	        angular.element(arrowElem).css(arrowCss);
	        return;
	      }
	
	      var borderProp = 'border-' + placement[0] + '-width';
	      var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	      var borderRadiusProp = 'border-';
	      if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	        borderRadiusProp += placement[0] + '-' + placement[1];
	      } else {
	        borderRadiusProp += placement[1] + '-' + placement[0];
	      }
	      borderRadiusProp += '-radius';
	      var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	      switch (placement[0]) {
	        case 'top':
	          arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'bottom':
	          arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'left':
	          arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'right':
	          arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	          break;
	      }
	
	      arrowCss[placement[1]] = borderRadius;
	
	      angular.element(arrowElem).css(arrowCss);
	    }
	  };
	}]);

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(656);
	__webpack_require__(655);
	__webpack_require__(654);
	__webpack_require__(631);
	
	var MODULE_NAME = 'ui.bootstrap.module.progressbar';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.progressbar', 'uib/template/progressbar/progressbar.html', 'uib/template/progressbar/progress.html', 'uib/template/progressbar/bar.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.progressbar', []).constant('uibProgressConfig', {
	  animate: true,
	  max: 100
	}).controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function ($scope, $attrs, progressConfig) {
	  var self = this,
	      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = getMaxOrDefault();
	
	  this.addBar = function (bar, element, attrs) {
	    if (!animate) {
	      element.css({ 'transition': 'none' });
	    }
	
	    this.bars.push(bar);
	
	    bar.max = getMaxOrDefault();
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function (value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function () {
	      var totalPercentage = self.bars.reduce(function (total, bar) {
	        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function () {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function (bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	    this.bars.forEach(function (bar) {
	      bar.recalculatePercentage();
	    });
	  };
	
	  //$attrs.$observe('maxParam', function(maxParam) {
	  $scope.$watch('maxParam', function (maxParam) {
	    self.bars.forEach(function (bar) {
	      bar.max = getMaxOrDefault();
	      bar.recalculatePercentage();
	    });
	  });
	
	  function getMaxOrDefault() {
	    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
	  }
	}]).directive('uibProgress', function () {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    require: 'uibProgress',
	    scope: {
	      maxParam: '=?max'
	    },
	    templateUrl: 'uib/template/progressbar/progress.html'
	  };
	}).directive('uibBar', function () {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^uibProgress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/bar.html',
	    link: function link(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, element, attrs);
	    }
	  };
	}).directive('uibProgressbar', function () {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    scope: {
	      value: '=',
	      maxParam: '=?max',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/progressbar.html',
	    link: function link(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), { title: attrs.title });
	    }
	  };
	});

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	.factory('$$stackedMap', function () {
	  return {
	    createNew: function createNew() {
	      var stack = [];
	
	      return {
	        add: function add(key, value) {
	          stack.push({
	            key: key,
	            value: value
	          });
	        },
	        get: function get(key) {
	          for (var i = 0; i < stack.length; i++) {
	            if (key === stack[i].key) {
	              return stack[i];
	            }
	          }
	        },
	        keys: function keys() {
	          var keys = [];
	          for (var i = 0; i < stack.length; i++) {
	            keys.push(stack[i].key);
	          }
	          return keys;
	        },
	        top: function top() {
	          return stack[stack.length - 1];
	        },
	        remove: function remove(key) {
	          var idx = -1;
	          for (var i = 0; i < stack.length; i++) {
	            if (key === stack[i].key) {
	              idx = i;
	              break;
	            }
	          }
	          return stack.splice(idx, 1)[0];
	        },
	        removeTop: function removeTop() {
	          return stack.pop();
	        },
	        length: function length() {
	          return stack.length;
	        }
	      };
	    }
	  };
	});

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(634);
	
	var MODULE_NAME = 'ui.bootstrap.module.tabindex';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tabindex']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.tabindex', []).directive('uibTabindexToggle', function () {
	  return {
	    restrict: 'A',
	    link: function link(scope, elem, attrs) {
	      attrs.$observe('disabled', function (disabled) {
	        attrs.$set('tabindex', disabled ? -1 : null);
	      });
	    }
	  };
	});

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(657);
	__webpack_require__(658);
	__webpack_require__(636);
	
	var MODULE_NAME = 'ui.bootstrap.module.tabs';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tabs', 'uib/template/tabs/tab.html', 'uib/template/tabs/tabset.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.tabs', []).controller('UibTabsetController', ['$scope', function ($scope) {
	  var ctrl = this,
	      oldIndex;
	  ctrl.tabs = [];
	
	  ctrl.select = function (index, evt) {
	    if (!destroyed) {
	      var previousIndex = findTabIndex(oldIndex);
	      var previousSelected = ctrl.tabs[previousIndex];
	      if (previousSelected) {
	        previousSelected.tab.onDeselect({
	          $event: evt,
	          $selectedIndex: index
	        });
	        if (evt && evt.isDefaultPrevented()) {
	          return;
	        }
	        previousSelected.tab.active = false;
	      }
	
	      var selected = ctrl.tabs[index];
	      if (selected) {
	        selected.tab.onSelect({
	          $event: evt
	        });
	        selected.tab.active = true;
	        ctrl.active = selected.index;
	        oldIndex = selected.index;
	      } else if (!selected && angular.isDefined(oldIndex)) {
	        ctrl.active = null;
	        oldIndex = null;
	      }
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    ctrl.tabs.push({
	      tab: tab,
	      index: tab.index
	    });
	    ctrl.tabs.sort(function (t1, t2) {
	      if (t1.index > t2.index) {
	        return 1;
	      }
	
	      if (t1.index < t2.index) {
	        return -1;
	      }
	
	      return 0;
	    });
	
	    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
	      var newActiveIndex = findTabIndex(tab.index);
	      ctrl.select(newActiveIndex);
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index;
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].tab === tab) {
	        index = i;
	        break;
	      }
	    }
	
	    if (ctrl.tabs[index].index === ctrl.active) {
	      var newActiveTabIndex = index === ctrl.tabs.length - 1 ? index - 1 : index + 1 % ctrl.tabs.length;
	      ctrl.select(newActiveTabIndex);
	    }
	
	    ctrl.tabs.splice(index, 1);
	  };
	
	  $scope.$watch('tabset.active', function (val) {
	    if (angular.isDefined(val) && val !== oldIndex) {
	      ctrl.select(findTabIndex(val));
	    }
	  });
	
	  var destroyed;
	  $scope.$on('$destroy', function () {
	    destroyed = true;
	  });
	
	  function findTabIndex(index) {
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].index === index) {
	        return i;
	      }
	    }
	  }
	}]).directive('uibTabset', function () {
	  return {
	    transclude: true,
	    replace: true,
	    scope: {},
	    bindToController: {
	      active: '=?',
	      type: '@'
	    },
	    controller: 'UibTabsetController',
	    controllerAs: 'tabset',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
	    },
	    link: function link(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	}).directive('uibTab', ['$parse', function ($parse) {
	  return {
	    require: '^uibTabset',
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tab.html';
	    },
	    transclude: true,
	    scope: {
	      heading: '@',
	      index: '=?',
	      classes: '@?',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	      //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function controller() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    controllerAs: 'tab',
	    link: function link(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function (value) {
	          scope.disabled = !!value;
	        });
	      }
	
	      if (angular.isUndefined(attrs.index)) {
	        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
	          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) {
	            return t.index;
	          })) + 1;
	        } else {
	          scope.index = 0;
	        }
	      }
	
	      if (angular.isUndefined(attrs.classes)) {
	        scope.classes = '';
	      }
	
	      scope.select = function (evt) {
	        if (!scope.disabled) {
	          var index;
	          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
	            if (tabsetCtrl.tabs[i].tab === scope) {
	              index = i;
	              break;
	            }
	          }
	
	          tabsetCtrl.select(index, evt);
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function () {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}]).directive('uibTabHeadingTransclude', function () {
	  return {
	    restrict: 'A',
	    require: '^uibTab',
	    link: function link(scope, elm) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	}).directive('uibTabContentTransclude', function () {
	  return {
	    restrict: 'A',
	    require: '^uibTabset',
	    link: function link(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function (contents) {
	        angular.forEach(contents, function (node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (node.hasAttribute('uib-tab-heading') || node.hasAttribute('data-uib-tab-heading') || node.hasAttribute('x-uib-tab-heading') || node.tagName.toLowerCase() === 'uib-tab-heading' || node.tagName.toLowerCase() === 'data-uib-tab-heading' || node.tagName.toLowerCase() === 'x-uib-tab-heading' || node.tagName.toLowerCase() === 'uib:tab-heading');
	  }
	});

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(659);
	__webpack_require__(639);
	
	var MODULE_NAME = 'ui.bootstrap.module.timepicker';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.timepicker', 'uib/template/timepicker/timepicker.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(182);
	module.exports = __webpack_require__(637);

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.timepicker', []).constant('uibTimepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  secondStep: 1,
	  showMeridian: true,
	  showSeconds: false,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true,
	  templateUrl: 'uib/template/timepicker/timepicker.html'
	}).controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
	  var selected = new Date(),
	      watchers = [],
	      ngModelCtrl = { $setViewValue: angular.noop },
	      // nullModelCtrl
	  meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
	      padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;
	
	  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	  $element.removeAttr('tabindex');
	
	  this.init = function (ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function (modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1),
	        secondsInputEl = inputs.eq(2);
	
	    hoursModelCtrl = hoursInputEl.controller('ngModel');
	    minutesModelCtrl = minutesInputEl.controller('ngModel');
	    secondsModelCtrl = secondsInputEl.controller('ngModel');
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
	      hourStep = +value;
	    }));
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
	      minuteStep = +value;
	    }));
	  }
	
	  var min;
	  watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  }));
	
	  var max;
	  watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  }));
	
	  var disabled = false;
	  if ($attrs.ngDisabled) {
	    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
	      disabled = value;
	    }));
	  }
	
	  $scope.noIncrementHours = function () {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementHours = function () {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementMinutes = function () {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementMinutes = function () {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementSeconds = function () {
	    var incrementedSelected = addSeconds(selected, secondStep);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementSeconds = function () {
	    var decrementedSelected = addSeconds(selected, -secondStep);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noToggleMeridian = function () {
	    if (selected.getHours() < 12) {
	      return disabled || addMinutes(selected, 12 * 60) > max;
	    }
	
	    return disabled || addMinutes(selected, -12 * 60) < min;
	  };
	
	  var secondStep = timepickerConfig.secondStep;
	  if ($attrs.secondStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
	      secondStep = +value;
	    }));
	  }
	
	  $scope.showSeconds = timepickerConfig.showSeconds;
	  if ($attrs.showSeconds) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
	      $scope.showSeconds = !!value;
	    }));
	  }
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(),
	            minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    }));
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = +$scope.hours;
	    var valid = $scope.showMeridian ? hours > 0 && hours < 13 : hours >= 0 && hours < 24;
	    if (!valid || $scope.hours === '') {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = +$scope.minutes;
	    var valid = minutes >= 0 && minutes < 60;
	    if (!valid || $scope.minutes === '') {
	      return undefined;
	    }
	    return minutes;
	  }
	
	  function getSecondsFromTemplate() {
	    var seconds = +$scope.seconds;
	    return seconds >= 0 && seconds < 60 ? seconds : undefined;
	  }
	
	  function pad(value, noPad) {
	    if (value === null) {
	      return '';
	    }
	
	    return angular.isDefined(value) && value.toString().length < 2 && !noPad ? '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    var isScrollingUp = function isScrollingUp(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
	      return e.detail || delta > 0;
	    };
	
	    hoursInputEl.on('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      }
	      e.preventDefault();
	    });
	
	    minutesInputEl.on('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      }
	      e.preventDefault();
	    });
	
	    secondsInputEl.on('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
	      }
	      e.preventDefault();
	    });
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    hoursInputEl.on('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementHours();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementHours();
	          $scope.$apply();
	        }
	      }
	    });
	
	    minutesInputEl.on('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementMinutes();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementMinutes();
	          $scope.$apply();
	        }
	      }
	    });
	
	    secondsInputEl.on('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementSeconds();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementSeconds();
	          $scope.$apply();
	        }
	      }
	    });
	  };
	
	  this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      $scope.updateSeconds = angular.noop;
	      return;
	    }
	
	    var invalidate = function invalidate(invalidHours, invalidMinutes, invalidSeconds) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	        if (hoursModelCtrl) {
	          hoursModelCtrl.$setValidity('hours', false);
	        }
	      }
	
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	        if (minutesModelCtrl) {
	          minutesModelCtrl.$setValidity('minutes', false);
	        }
	      }
	
	      if (angular.isDefined(invalidSeconds)) {
	        $scope.invalidSeconds = invalidSeconds;
	        if (secondsModelCtrl) {
	          secondsModelCtrl.$setValidity('seconds', false);
	        }
	      }
	    };
	
	    $scope.updateHours = function () {
	      var hours = getHoursFromTemplate(),
	          minutes = getMinutesFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.on('blur', function (e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.hours === null || $scope.hours === '') {
	        invalidate(true);
	      } else if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function () {
	          $scope.hours = pad($scope.hours, !padHours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function () {
	      var minutes = getMinutesFromTemplate(),
	          hours = getHoursFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.on('blur', function (e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.minutes === null) {
	        invalidate(undefined, true);
	      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function () {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	    $scope.updateSeconds = function () {
	      var seconds = getSecondsFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(seconds)) {
	        selected.setSeconds(seconds);
	        refresh('s');
	      } else {
	        invalidate(undefined, undefined, true);
	      }
	    };
	
	    secondsInputEl.on('blur', function (e) {
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
	        $scope.$apply(function () {
	          $scope.seconds = pad($scope.seconds);
	        });
	      }
	    });
	  };
	
	  this.render = function () {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    if (hoursModelCtrl) {
	      hoursModelCtrl.$setValidity('hours', true);
	    }
	
	    if (minutesModelCtrl) {
	      minutesModelCtrl.$setValidity('minutes', true);
	    }
	
	    if (secondsModelCtrl) {
	      secondsModelCtrl.$setValidity('seconds', true);
	    }
	
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	    $scope.invalidSeconds = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    if (!ngModelCtrl.$modelValue) {
	      $scope.hours = null;
	      $scope.minutes = null;
	      $scope.seconds = null;
	      $scope.meridian = meridians[0];
	    } else {
	      var hours = selected.getHours(),
	          minutes = selected.getMinutes(),
	          seconds = selected.getSeconds();
	
	      if ($scope.showMeridian) {
	        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
	      }
	
	      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
	      if (keyboardChange !== 'm') {
	        $scope.minutes = pad(minutes);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	
	      if (keyboardChange !== 's') {
	        $scope.seconds = pad(seconds);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	    }
	  }
	
	  function addSecondsToSelected(seconds) {
	    selected = addSeconds(selected, seconds);
	    refresh();
	  }
	
	  function addMinutes(selected, minutes) {
	    return addSeconds(selected, minutes * 60);
	  }
	
	  function addSeconds(date, seconds) {
	    var dt = new Date(date.getTime() + seconds * 1000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
	    return newDate;
	  }
	
	  function modelIsEmpty() {
	    return ($scope.hours === null || $scope.hours === '') && ($scope.minutes === null || $scope.minutes === '') && (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ? $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function () {
	    if (!$scope.noIncrementHours()) {
	      addSecondsToSelected(hourStep * 60 * 60);
	    }
	  };
	
	  $scope.decrementHours = function () {
	    if (!$scope.noDecrementHours()) {
	      addSecondsToSelected(-hourStep * 60 * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function () {
	    if (!$scope.noIncrementMinutes()) {
	      addSecondsToSelected(minuteStep * 60);
	    }
	  };
	
	  $scope.decrementMinutes = function () {
	    if (!$scope.noDecrementMinutes()) {
	      addSecondsToSelected(-minuteStep * 60);
	    }
	  };
	
	  $scope.incrementSeconds = function () {
	    if (!$scope.noIncrementSeconds()) {
	      addSecondsToSelected(secondStep);
	    }
	  };
	
	  $scope.decrementSeconds = function () {
	    if (!$scope.noDecrementSeconds()) {
	      addSecondsToSelected(-secondStep);
	    }
	  };
	
	  $scope.toggleMeridian = function () {
	    var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	    if (!$scope.noToggleMeridian()) {
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
	      } else {
	        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
	      }
	    }
	  };
	
	  $scope.blur = function () {
	    ngModelCtrl.$setTouched();
	  };
	
	  $scope.$on('$destroy', function () {
	    while (watchers.length) {
	      watchers.shift()();
	    }
	  });
	}]).directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
	  return {
	    require: ['uibTimepicker', '?^ngModel'],
	    restrict: 'A',
	    controller: 'UibTimepickerController',
	    controllerAs: 'timepicker',
	    scope: {},
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
	    },
	    link: function link(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	}]);

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(26);
	__webpack_require__(80);
	module.exports = __webpack_require__(90);

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function () {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    placementClassPrefix: '',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'outsideClick': 'outsideClick',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
	  this.options = function (value) {
	    angular.extend(globalOptions, value);
	  };
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake_case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function (letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keyup', keypressListener);
	
	    $rootScope.$on('$destroy', function () {
	      $document.off('keyup', keypressListener);
	    });
	
	    function keypressListener(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          last = null;
	        }
	      }
	    }
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function (trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template = '<div ' + directiveName + '-popup ' + 'uib-title="' + startSym + 'title' + endSym + '" ' + (options.useContentExp ? 'content-exp="contentExp()" ' : 'content="' + startSym + 'content' + endSym + '" ') + 'origin-scope="origScope" ' + 'class="uib-position-measure ' + prefix + '" ' + 'tooltip-animation-class="fade"' + 'uib-tooltip-classes ' + 'ng-class="{ in: isOpen }" ' + '>' + '</div>';
	
	      return {
	        compile: function compile(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var adjustmentTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	            var lastPlacement;
	
	            var positionTooltip = function positionTooltip() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) {
	                return;
	              }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function () {
	                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
	                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
	                  var placementClasses = ttPosition.placement.split('-');
	
	                  if (!tooltip.hasClass(placementClasses[0])) {
	                    tooltip.removeClass(lastPlacement.split('-')[0]);
	                    tooltip.addClass(placementClasses[0]);
	                  }
	
	                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                  }
	
	                  adjustmentTimeout = $timeout(function () {
	                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
	                    if (adjustment) {
	                      tooltip.css(adjustment);
	                    }
	                    adjustmentTimeout = null;
	                  }, 0, false);
	
	                  // first time through tt element will have the
	                  // uib-position-measure class or if the placement
	                  // has changed we need to position the arrow.
	                  if (tooltip.hasClass('uib-position-measure')) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                    tooltip.removeClass('uib-position-measure');
	                  } else if (lastPlacement !== ttPosition.placement) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                  }
	                  lastPlacement = ttPosition.placement;
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function () {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function () {
	                if (ttScope) {
	                  ttScope.isOpen = false;
	                  assignIsOpen(false);
	                  // And now we remove it from the DOM. However, if we have animation, we
	                  // need to wait for it to expire beforehand.
	                  // FIXME: this is a placeholder for a port of the transitions library.
	                  // The fade transition in TWBS is 150ms.
	                  if (ttScope.animation) {
	                    if (!transitionTimeout) {
	                      transitionTimeout = $timeout(removeTooltip, 150, false);
	                    }
	                  } else {
	                    removeTooltip();
	                  }
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              openedTooltips.add(ttScope, {
	                close: hide
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterObservers();
	
	              if (tooltip) {
	                tooltip.remove();
	
	                tooltip = null;
	                if (adjustmentTimeout) {
	                  $timeout.cancel(adjustmentTimeout);
	                }
	              }
	
	              openedTooltips.remove(ttScope);
	
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	              var placement = $position.parsePlacement(ttScope.placement);
	              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function () {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function (val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function (val) {
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(scope.$watch(contentParse, function (val) {
	                  ttScope.content = val;
	                  if (!val && ttScope.isOpen) {
	                    hide();
	                  }
	                }));
	
	                observers.push(tooltipLinkedScope.$watch(function () {
	                  if (!repositionScheduled) {
	                    repositionScheduled = true;
	                    tooltipLinkedScope.$$postDigest(function () {
	                      repositionScheduled = false;
	                      if (ttScope && ttScope.isOpen) {
	                        positionTooltip();
	                      }
	                    });
	                  }
	                }));
	              } else {
	                observers.push(attrs.$observe(ttType, function (val) {
	                  ttScope.content = val;
	                  if (!val && ttScope.isOpen) {
	                    hide();
	                  } else {
	                    positionTooltip();
	                  }
	                }));
	              }
	
	              observers.push(attrs.$observe(prefix + 'Title', function (val) {
	                ttScope.title = val;
	                if (ttScope.isOpen) {
	                  positionTooltip();
	                }
	              }));
	
	              observers.push(attrs.$observe(prefix + 'Placement', function (val) {
	                ttScope.placement = val ? val : options.placement;
	                if (ttScope.isOpen) {
	                  positionTooltip();
	                }
	              }));
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function (observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            // hide tooltips/popovers for outsideClick trigger
	            function bodyHideTooltipBind(e) {
	              if (!ttScope || !ttScope.isOpen || !tooltip) {
	                return;
	              }
	              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                hideTooltipBind();
	              }
	            }
	
	            // KeyboardEvent handler to hide the tooltip on Escape key press
	            function hideOnEscapeKey(e) {
	              if (e.which === 27) {
	                hideTooltipBind();
	              }
	            }
	
	            var unregisterTriggers = function unregisterTriggers() {
	              triggers.show.forEach(function (trigger) {
	                if (trigger === 'outsideClick') {
	                  element.off('click', toggleTooltipBind);
	                } else {
	                  element.off(trigger, showTooltipBind);
	                  element.off(trigger, toggleTooltipBind);
	                }
	                element.off('keypress', hideOnEscapeKey);
	              });
	              triggers.hide.forEach(function (trigger) {
	                if (trigger === 'outsideClick') {
	                  $document.off('click', bodyHideTooltipBind);
	                } else {
	                  element.off(trigger, hideTooltipBind);
	                }
	              });
	            };
	
	            function prepTriggers() {
	              var showTriggers = [],
	                  hideTriggers = [];
	              var val = scope.$eval(attrs[prefix + 'Trigger']);
	              unregisterTriggers();
	
	              if (angular.isObject(val)) {
	                Object.keys(val).forEach(function (key) {
	                  showTriggers.push(key);
	                  hideTriggers.push(val[key]);
	                });
	                triggers = {
	                  show: showTriggers,
	                  hide: hideTriggers
	                };
	              } else {
	                triggers = getTriggers(val);
	              }
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function (trigger, idx) {
	                  if (trigger === 'outsideClick') {
	                    element.on('click', toggleTooltipBind);
	                    $document.on('click', bodyHideTooltipBind);
	                  } else if (trigger === triggers.hide[idx]) {
	                    element.on(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element.on(trigger, showTooltipBind);
	                    element.on(triggers.hide[idx], hideTooltipBind);
	                  }
	                  element.on('keypress', hideOnEscapeKey);
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal;
	            var appendKey = prefix + 'AppendToBody';
	            if (appendKey in attrs && attrs[appendKey] === undefined) {
	              appendToBodyVal = true;
	            } else {
	              appendToBodyVal = scope.$eval(attrs[appendKey]);
	            }
	
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', ['$animate', '$sce', '$compile', '$templateRequest', function ($animate, $sce, $compile, $templateRequest) {
	  return {
	    link: function link(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	          currentScope,
	          previousElement,
	          currentElement;
	
	      var cleanupLastIncludeContent = function cleanupLastIncludeContent() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function () {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function (response) {
	            if (thisChangeId !== changeCounter) {
	              return;
	            }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function (clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function () {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      // need to set the primary position so the
	      // arrow has space during position measure.
	      // tooltip.positionTooltip()
	      if (scope.placement) {
	        // // There are no top-left etc... classes
	        // // in TWBS, so we need the primary position.
	        var position = $uibPosition.parsePlacement(scope.placement);
	        element.addClass(position[0]);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}]).directive('uibTooltipPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { content: '@' },
	    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
	  };
	}).directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}]).directive('uibTooltipTemplatePopup', function () {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
	  };
	}).directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]).directive('uibTooltipHtmlPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
	  };
	}).directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion-group.html", "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" + "  <h4 class=\"panel-title\">\n" + "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" + "  </h4>\n" + "</div>\n" + "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" + "  <div class=\"panel-body\" ng-transclude></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion.html", "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
	}]);

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/alert/alert.html", "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" + "  <span aria-hidden=\"true\">&times;</span>\n" + "  <span class=\"sr-only\">Close</span>\n" + "</button>\n" + "<div ng-transclude></div>\n" + "");
	}]);

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/datepicker.html", "<div ng-switch=\"datepickerMode\">\n" + "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" + "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" + "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/day.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-right\"></i><span class=\"sr-only\">next</span></button></th>\n" + "    </tr>\n" + "    <tr>\n" + "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" + "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/month.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/year.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-right\"></i><span class=\"sr-only\">next</span></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepickerPopup/popup.html", "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" + "  <li ng-transclude></li>\n" + "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" + "    <span class=\"btn-group pull-left\">\n" + "      <button type=\"button\" md-effect class=\"btn btn-sm btn-primary uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" + "      <button type=\"button\" md-effect class=\"btn btn-sm btn-default uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" + "    </span>\n" + "    <button type=\"button\" md-effect class=\"btn btn-sm btn-default pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" + "  </li>\n" + "</ul>\n" + "");
	}]);

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/modal/window.html", "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" + "");
	}]);

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-html.html", "<div class=\"arrow\"></div>\n" + "\n" + "<div class=\"popover-inner\">\n" + "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" + "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-template.html", "<div class=\"arrow\"></div>\n" + "\n" + "<div class=\"popover-inner\">\n" + "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" + "    <div class=\"popover-content\"\n" + "      uib-tooltip-template-transclude=\"contentExp()\"\n" + "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover.html", "<div class=\"arrow\"></div>\n" + "\n" + "<div class=\"popover-inner\">\n" + "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" + "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/bar.html", "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" + "");
	}]);

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progress.html", "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
	}]);

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progressbar.html", "<div class=\"progress\">\n" + "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tab.html", "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" + "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" + "</li>\n" + "");
	}]);

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tabset.html", "<div>\n" + "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" + "  <div class=\"tab-content\">\n" + "    <div class=\"tab-pane\"\n" + "         ng-repeat=\"tab in tabset.tabs\"\n" + "         ng-class=\"{active: tabset.active === tab.index}\"\n" + "         uib-tab-content-transclude=\"tab\">\n" + "    </div>\n" + "  </div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/timepicker/timepicker.html", "<table class=\"uib-timepicker\">\n" + "  <tbody>\n" + "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" + "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"fa fa-angle-up\"></span></a></td>\n" + "      <td>&nbsp;</td>\n" + "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"fa fa-angle-up\"></span></a></td>\n" + "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"fa fa-angle-up\"></span></a></td>\n" + "      <td ng-show=\"showMeridian\"></td>\n" + "    </tr>\n" + "    <tr>\n" + "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" + "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td class=\"uib-separator\">:</td>\n" + "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" + "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" + "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" + "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" + "    </tr>\n" + "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" + "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"fa fa-angle-down\"></span></a></td>\n" + "      <td>&nbsp;</td>\n" + "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"fa fa-angle-down\"></span></a></td>\n" + "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"fa fa-angle-down\"></span></a></td>\n" + "      <td ng-show=\"showMeridian\"></td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html", "<div class=\"tooltip-arrow\"></div>\n" + "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" + "");
	}]);

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-popup.html", "<div class=\"tooltip-arrow\"></div>\n" + "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" + "");
	}]);

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html", "<div class=\"tooltip-arrow\"></div>\n" + "<div class=\"tooltip-inner\"\n" + "  uib-tooltip-template-transclude=\"contentExp()\"\n" + "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" + "");
	}]);

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Formly = angular.module('vendor.formly', []).run(["formlyConfig", "formlyValidationMessages", function (formlyConfig, formlyValidationMessages) {
	    'ngInject';
	    /* Datepicker */
	
	    var attributes = ['date-disabled', 'custom-class', 'show-weeks', 'starting-day', 'init-date', 'min-mode', 'max-mode', 'format-day', 'format-month', 'format-year', 'format-day-header', 'format-day-title', 'format-month-title', 'year-range', 'shortcut-propagation', 'datepicker-popup', 'show-button-bar', 'current-text', 'clear-text', 'close-text', 'close-on-date-selection', 'datepicker-append-to-body'];
	
	    var bindings = ['datepicker-mode', 'min-date', 'max-date'];
	
	    var ngModelAttrs = {};
	
	    angular.forEach(attributes, function (attr) {
	        ngModelAttrs[camelize(attr)] = { attribute: attr };
	    });
	
	    angular.forEach(bindings, function (binding) {
	        ngModelAttrs[camelize(binding)] = { bound: binding };
	    });
	
	    formlyConfig.setType({
	        name: 'datepicker',
	        template: '\n                <p class="input-group">\n                    <input  type="text"\n                            id="{{::id}}"\n                            name="{{::id}}"\n                            ng-model="model[options.key]"\n                            class="form-control"\n                            ng-click="datepicker.open($event)"\n                            uib-datepicker-popup="{{to.datepickerOptions.format}}"\n                            is-open="datepicker.opened"\n                            datepicker-options="to.datepickerOptions" />\n                    <span class="input-group-btn">\n                        <button type="button" class="btn btn-default" ng-click="datepicker.open($event)" ng-disabled="to.disabled"><i class="fa fa-calendar"></i></button>\n                    </span>\n                </p>\n            ',
	        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
	        defaultOptions: {
	            ngModelAttrs: ngModelAttrs,
	            templateOptions: {
	                datepickerOptions: {
	                    format: 'dd/MM/yyyy',
	                    initDate: new Date()
	                }
	            }
	        },
	        controller: ['$scope', function ($scope) {
	            $scope.datepicker = {};
	            $scope.datepicker.opened = false;
	
	            $scope.datepicker.open = function ($event) {
	                $scope.datepicker.opened = !$scope.datepicker.opened;
	            };
	        }]
	    });
	
	    /* timepicker */
	
	    ngModelAttrs = {};
	
	    angular.forEach(['meridians', 'readonly-input', 'mousewheel', 'arrowkeys'], function (attr) {
	        ngModelAttrs[camelize(attr)] = { attribute: attr };
	    });
	
	    angular.forEach(['hour-step', 'minute-step', 'show-meridian'], function (binding) {
	        ngModelAttrs[camelize(binding)] = { bound: binding };
	    });
	
	    formlyConfig.setType({
	        name: 'timepicker',
	        template: '<timepicker ng-model="model[options.key]"></timepicker>',
	        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
	        defaultOptions: {
	            ngModelAttrs: ngModelAttrs,
	            templateOptions: {
	                datepickerOptions: {}
	            }
	        }
	    });
	
	    function camelize(string) {
	        string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
	            return chr ? chr.toUpperCase() : '';
	        });
	
	        return string.replace(/^([A-Z])/, function (match, chr) {
	            return chr ? chr.toLowerCase() : '';
	        });
	    }
	
	    formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched || form.$submitted';
	
	    formlyValidationMessages.addStringMessage('required', 'El campo es obligatorio');
	}]).name;
	
	exports.default = Formly;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImageViewer = undefined;
	
	var _imageViewer = __webpack_require__(704);
	
	var _imageViewer2 = _interopRequireDefault(_imageViewer);
	
	__webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Marcelo Alejo Calle
	 */
	var ImageViewer = exports.ImageViewer = ["$window", "$document", "$timeout", "$compile", function ImageViewer($window, $document, $timeout, $compile) {
	  'ngInject';
	
	  /**
	   * b64toBlob - Convert base64 string to a Blob object
	   *
	   * @param  {string}  b64Data     Base64 string
	   * @param  {strig}   contentType Type of base64 file
	   * @param  {integer} sliceSize   Slice for performance
	   * @return {Blob}                Blob object
	   * @description https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
	   */
	
	  var b64toBlob = function b64toBlob(b64Data, contentType, sliceSize) {
	    contentType = contentType || '';
	    sliceSize = sliceSize || 512;
	
	    var byteCharacters = void 0;
	    if (b64Data.split(',')[0].indexOf('base64') >= 0) {
	      byteCharacters = atob(b64Data.split(',')[1]);
	    } else {
	      byteCharacters = atob(b64Data);
	    }
	    var byteArrays = [];
	
	    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	      var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	      var byteNumbers = new Array(slice.length);
	      for (var i = 0; i < slice.length; i++) {
	        byteNumbers[i] = slice.charCodeAt(i);
	      }
	
	      var byteArray = new window.Uint8Array(byteNumbers);
	
	      byteArrays.push(byteArray);
	    }
	
	    var blob = new Blob(byteArrays, { type: contentType });
	    return blob;
	  };
	
	  var imageSize = function imageSize(img) {
	    var image = {};
	    if (img && img.src) {
	      image.size = Math.round((img.src.length - 22) * 3 / 4);
	    } else {
	      image.size = img;
	    }
	    image.unit = 'B';
	    if (image.size >= 1000) {
	      image.size = image.size / 1000;
	      image.unit = 'KB';
	    }
	    if (image.size >= 1000) {
	      image.size = image.size / 1000;
	      image.unit = 'MB';
	    }
	    if (image.size.toFixed) {
	      image.size = image.size.toFixed(1);
	    }
	    return image;
	  };
	
	  return {
	    restrict: 'E',
	    template: _imageViewer2.default,
	    scope: {
	      base64: '=',
	      vm: '=?'
	    },
	
	    link: function link($scope, $element, $attrs) {
	      var image = $element.find('img')[0];
	      var canvas = $element.find('canvas')[0];
	      var ctx = canvas.getContext('2d');
	      var scale = 100;
	      var rotate = 0;
	      var objImage = new Image();
	
	      if ($scope.vm) {
	        $scope.vm = $scope;
	      }
	      if (!$scope.tipo) {
	        $scope.tipo = 'image/jpeg';
	      }
	      // Objeto para restaurar los cambios
	      // if($scope.base64.indexOf('base64')>0) {
	      //   image.src = $scope.base64;
	      // } else {
	      //   image.src = 'data:'+$scope.tipo+';base64,'+$scope.base64;
	      // }
	      if ($scope.base64.indexOf('base64') > 0) {
	        objImage.src = $scope.base64;
	      } else {
	        objImage.src = 'data:' + $scope.tipo + ';base64,' + $scope.base64;
	      }
	      objImage.id = 'image-viewer-print';
	      objImage.onload = function () {
	        canvas.width = objImage.width;
	        canvas.height = objImage.height;
	        ctx.drawImage(objImage, 0, 0);
	        $scope.imageDet = imageSize(objImage);
	        $scope.imageWidth = objImage.width;
	        $scope.imageHeight = objImage.height;
	      };
	
	      // funciones
	      $scope.imageZoom = function (zoom) {
	        if (zoom > 0) {
	          if (scale + zoom < 300) {
	            scale += zoom;
	            canvas.style.width = scale + '%';
	          }
	        } else if (zoom < 0) {
	          if (scale + zoom >= 10) {
	            scale += zoom;
	            canvas.style.width = scale + '%';
	          }
	        }
	      };
	
	      $scope.imageInvert = function () {
	        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	        var data = imageData.data;
	        for (var i = 0; i < data.length; i += 4) {
	          data[i] = 255 - data[i]; // red
	          data[i + 1] = 255 - data[i + 1]; // green
	          data[i + 2] = 255 - data[i + 2]; // blue
	        }
	        ctx.putImageData(imageData, 0, 0);
	        $scope.modificado = true;
	      };
	
	      $scope.imageGrayscale = function () {
	        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	        var data = imageData.data;
	        for (var i = 0; i < data.length; i += 4) {
	          var avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
	          data[i] = avg; // red
	          data[i + 1] = avg; // green
	          data[i + 2] = avg; // blue
	        }
	        ctx.putImageData(imageData, 0, 0);
	        $scope.modificado = true;
	      };
	
	      $scope.imageRotate = function () {
	        rotate += 90;
	        if (function (rotate) {
	          return 360;
	        }) {
	          rotate = rotate % 360;
	        }
	        if (rotate % 180 == 0) {
	          canvas.width = objImage.width;
	          canvas.height = objImage.height;
	        } else {
	          canvas.width = objImage.height;
	          canvas.height = objImage.width;
	        }
	        ctx.clearRect(0, 0, canvas.width, canvas.height);
	        ctx.save();
	        ctx.translate(canvas.width / 2, canvas.height / 2);
	        ctx.rotate(rotate * Math.PI / 180);
	        ctx.drawImage(objImage, -objImage.width / 2, -objImage.height / 2);
	        ctx.restore();
	        // image.src = canvas.toDataURL('image/png');
	        $scope.imageDet = imageSize(Math.round((canvas.toDataURL('image/jpeg', 1).length - 23) * 3 / 4));
	        $scope.modificado = true;
	      };
	
	      $scope.imageDownload1 = function () {
	        $window.location.href = canvas.toDataURL('image/jpeg', 1).replace('image/jpeg', 'image/octet-stream');
	      };
	
	      $scope.imageDownload = function () {
	        if (!$scope.descargando) {
	          $scope.descargando = true;
	          var image64 = canvas.toDataURL('image/jpeg', 1);
	          var file = void 0,
	              a = document.createElement('a');
	          a.innerHTML = '.';
	          document.body.appendChild(a);
	          // $compile(a)(scope);
	          file = b64toBlob(image64, 'image/jpeg');
	          $scope.imageDet = imageSize(file.size);
	          if (window.navigator.msSaveBlob) {
	            window.navigator.msSaveOrOpenBlob(file, $scope.nombre || 'documento.jpg');
	            $scope.descargando = false;
	          } else {
	            a.href = window.URL.createObjectURL(file);
	            a.download = $scope.nombre || 'documento.jpg';
	            //a.target = '_blank';
	            $timeout(function () {
	              a.click();
	              $scope.descargando = false;
	              angular.element(a).remove();
	            }, 250);
	          }
	        }
	      };
	
	      $scope.imagePrint = function () {
	        if (!$scope.imprimiendo) {
	          $scope.imprimiendo = true;
	          var imagePrint = new Image();
	          imagePrint.src = canvas.toDataURL('image/jpeg', 1);
	          imagePrint.onload = function () {
	            if (imagePrint.height / imagePrint.width < 1.294118) {
	              // Relacion de aspecto tamaño carta y/x => 11/8.5
	              imagePrint.style = "width:100%;";
	            } else {
	              imagePrint.style = "height:100%;";
	            }
	            document.body.appendChild(imagePrint);
	            $window.print();
	            imagePrint.parentNode.removeChild(imagePrint);
	            $scope.imprimiendo = false;
	          };
	        }
	      };
	
	      $scope.imageSave = function () {
	        if ($scope.modificado) {
	          $scope.modificado = false;
	          $scope.base64 = canvas.toDataURL('image/jpeg', 1);
	          $scope.imageDet = imageSize(Math.round((canvas.toDataURL('image/jpeg', 1).length - 23) * 3 / 4));
	        }
	      };
	    }
	  };
	}];

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _imageViewer = __webpack_require__(664);
	
	var ImageViewerModule = angular.module('app.image-viewer', []).directive('imageViewer', _imageViewer.ImageViewer).name;
	
	exports.default = ImageViewerModule;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function webpackUniversalModuleDefinition(root, factory) {
	    if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory(__webpack_require__(7));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["ng-table"] = factory(require("angular"));else root["ng-table"] = factory(root["angular"]);
	})(undefined, function (__WEBPACK_EXTERNAL_MODULE_0__) {
	    return (/******/function (modules) {
	            // webpackBootstrap
	            /******/ // The module cache
	            /******/var installedModules = {};
	            /******/
	            /******/ // The require function
	            /******/function __webpack_require__(moduleId) {
	                /******/
	                /******/ // Check if module is in cache
	                /******/if (installedModules[moduleId])
	                    /******/return installedModules[moduleId].exports;
	                /******/
	                /******/ // Create a new module (and put it into the cache)
	                /******/var module = installedModules[moduleId] = {
	                    /******/i: moduleId,
	                    /******/l: false,
	                    /******/exports: {}
	                    /******/ };
	                /******/
	                /******/ // Execute the module function
	                /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	                /******/
	                /******/ // Flag the module as loaded
	                /******/module.l = true;
	                /******/
	                /******/ // Return the exports of the module
	                /******/return module.exports;
	                /******/
	            }
	            /******/
	            /******/
	            /******/ // expose the modules object (__webpack_modules__)
	            /******/__webpack_require__.m = modules;
	            /******/
	            /******/ // expose the module cache
	            /******/__webpack_require__.c = installedModules;
	            /******/
	            /******/ // identity function for calling harmory imports with the correct context
	            /******/__webpack_require__.i = function (value) {
	                return value;
	            };
	            /******/
	            /******/ // define getter function for harmory exports
	            /******/__webpack_require__.d = function (exports, name, getter) {
	                /******/if (!__webpack_require__.o(exports, name)) {
	                    /******/Object.defineProperty(exports, name, {
	                        /******/configurable: false,
	                        /******/enumerable: true,
	                        /******/get: getter
	                        /******/ });
	                    /******/
	                }
	                /******/
	            };
	            /******/
	            /******/ // getDefaultExport function for compatibility with non-harmony modules
	            /******/__webpack_require__.n = function (module) {
	                /******/var getter = module && module.__esModule ?
	                /******/function getDefault() {
	                    return module['default'];
	                } :
	                /******/function getModuleExports() {
	                    return module;
	                };
	                /******/__webpack_require__.d(getter, 'a', getter);
	                /******/return getter;
	                /******/
	            };
	            /******/
	            /******/ // Object.prototype.hasOwnProperty.call
	            /******/__webpack_require__.o = function (object, property) {
	                return Object.prototype.hasOwnProperty.call(object, property);
	            };
	            /******/
	            /******/ // __webpack_public_path__
	            /******/__webpack_require__.p = "";
	            /******/
	            /******/ // Load entry module and return exports
	            /******/return __webpack_require__(__webpack_require__.s = 51);
	            /******/
	        }(
	        /************************************************************************/
	        /******/[
	        /* 0 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************!*\
	          !*** external "angular" ***!
	          \**************************/
	        /***/function (module, exports) {
	
	            module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	            /***/
	        },
	        /* 1 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************!*\
	          !*** ./src/core/index.ts ***!
	          \***************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            var angular = __webpack_require__( /*! angular */0);
	            var data_1 = __webpack_require__( /*! ./data */3);
	            var grouping_1 = __webpack_require__( /*! ./grouping */37);
	            var ngTableDefaults_1 = __webpack_require__( /*! ./ngTableDefaults */7);
	            var ngTableSettings_1 = __webpack_require__( /*! ./ngTableSettings */10);
	            var ngTableParams_1 = __webpack_require__( /*! ./ngTableParams */9);
	            var ngTableEventsChannel_1 = __webpack_require__( /*! ./ngTableEventsChannel */8);
	            var ngTableCoreModule = angular.module('ngTable-core', []).provider('ngTableDefaultGetData', data_1.NgTableDefaultGetDataProvider).factory('ngTableDefaultGetGroups', grouping_1.ngTableDefaultGetGroups).value('ngTableDefaults', ngTableDefaults_1.ngTableDefaults).service('ngTableEventsChannel', ngTableEventsChannel_1.NgTableEventsChannel).service('ngTableSettings', ngTableSettings_1.NgTableSettings).run(ngTableParams_1.NgTableParams.init);
	            exports.ngTableCoreModule = ngTableCoreModule;
	            // note: if you are using ES6 or typescript prefer:
	            // import { NgTableParams } from 'ng-table';
	            ngTableCoreModule.value('NgTableParams', ngTableParams_1.NgTableParams);
	            var ngTableDefaults_2 = __webpack_require__( /*! ./ngTableDefaults */7);
	            exports.IDefaults = ngTableDefaults_2.IDefaults;
	            __export(__webpack_require__( /*! ./ngTableEventsChannel */8));
	            var ngTableSettings_2 = __webpack_require__( /*! ./ngTableSettings */10);
	            exports.ISettings = ngTableSettings_2.ISettings;
	            __export(__webpack_require__( /*! ./ngTableParams */9));
	            __export(__webpack_require__( /*! ./data */3));
	            __export(__webpack_require__( /*! ./filtering */36));
	            __export(__webpack_require__( /*! ./grouping/publicExports */39));
	            __export(__webpack_require__( /*! ./paging */40));
	            __export(__webpack_require__( /*! ./sorting */41));
	
	            /***/
	        },
	        /* 2 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************!*\
	          !*** ./src/browser/index.ts ***!
	          \******************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            var angular = __webpack_require__( /*! angular */0);
	            var ngTable_directive_1 = __webpack_require__( /*! ./ngTable.directive */13);
	            var ngTableColumn_1 = __webpack_require__( /*! ./ngTableColumn */14);
	            var ngTableColumnsBinding_directive_1 = __webpack_require__( /*! ./ngTableColumnsBinding.directive */15);
	            var ngTableController_1 = __webpack_require__( /*! ./ngTableController */16);
	            exports.NgTableController = ngTableController_1.NgTableController;
	            var ngTableDynamic_directive_1 = __webpack_require__( /*! ./ngTableDynamic.directive */17);
	            var ngTableFilterConfig_1 = __webpack_require__( /*! ./ngTableFilterConfig */18);
	            exports.NgTableFilterConfigProvider = ngTableFilterConfig_1.NgTableFilterConfigProvider;
	            exports.NgTableFilterConfig = ngTableFilterConfig_1.NgTableFilterConfig;
	            var ngTableFilterRow_directive_1 = __webpack_require__( /*! ./ngTableFilterRow.directive */19);
	            var ngTableFilterRowController_1 = __webpack_require__( /*! ./ngTableFilterRowController */20);
	            var ngTableGroupRow_directive_1 = __webpack_require__( /*! ./ngTableGroupRow.directive */21);
	            var ngTableGroupRowController_1 = __webpack_require__( /*! ./ngTableGroupRowController */22);
	            var ngTablePagination_directive_1 = __webpack_require__( /*! ./ngTablePagination.directive */23);
	            var ngTableSelectFilterDs_directive_1 = __webpack_require__( /*! ./ngTableSelectFilterDs.directive */24);
	            var ngTableSorterRow_directive_1 = __webpack_require__( /*! ./ngTableSorterRow.directive */25);
	            var ngTableSorterRowController_1 = __webpack_require__( /*! ./ngTableSorterRowController */26);
	            __webpack_require__( /*! ./filters/number.html */43);
	            __webpack_require__( /*! ./filters/select.html */45);
	            __webpack_require__( /*! ./filters/select-multiple.html */44);
	            __webpack_require__( /*! ./filters/text.html */46);
	            __webpack_require__( /*! ./filters/hidden.html */52);
	            __webpack_require__( /*! ./pager.html */49);
	            __webpack_require__( /*! ./header.html */48);
	            var ngTableBrowserModule = angular.module('ngTable-browser', []).directive('ngTable', ngTable_directive_1.ngTable).service('ngTableColumn', ngTableColumn_1.NgTableColumn).directive('ngTableColumnsBinding', ngTableColumnsBinding_directive_1.ngTableColumnsBinding).controller('ngTableController', ngTableController_1.NgTableController).directive('ngTableDynamic', ngTableDynamic_directive_1.ngTableDynamic).provider('ngTableFilterConfig', ngTableFilterConfig_1.NgTableFilterConfigProvider).directive('ngTableFilterRow', ngTableFilterRow_directive_1.ngTableFilterRow).controller('ngTableFilterRowController', ngTableFilterRowController_1.NgTableFilterRowController).directive('ngTableGroupRow', ngTableGroupRow_directive_1.ngTableGroupRow).controller('ngTableGroupRowController', ngTableGroupRowController_1.NgTableGroupRowController).directive('ngTablePagination', ngTablePagination_directive_1.ngTablePagination).directive('ngTableSelectFilterDs', ngTableSelectFilterDs_directive_1.ngTableSelectFilterDs).directive('ngTableSorterRow', ngTableSorterRow_directive_1.ngTableSorterRow).controller('ngTableSorterRowController', ngTableSorterRowController_1.NgTableSorterRowController);
	            exports.ngTableBrowserModule = ngTableBrowserModule;
	            __export(__webpack_require__( /*! ./public-interfaces */27));
	
	            /***/
	        },
	        /* 3 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************!*\
	          !*** ./src/core/data/index.ts ***!
	          \********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./dataSettings */28));
	            __export(__webpack_require__( /*! ./getData */29));
	            __export(__webpack_require__( /*! ./interceptor */30));
	            __export(__webpack_require__( /*! ./ngTableDefaultGetData */31));
	            __export(__webpack_require__( /*! ./results */32));
	
	            /***/
	        },
	        /* 4 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/core/grouping/getGroup.ts ***!
	          \***************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 5 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************!*\
	          !*** ./src/core/grouping/groupSettings.ts ***!
	          \********************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 6 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*******************************************!*\
	          !*** ./src/core/grouping/groupingFunc.ts ***!
	          \*******************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 7 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************!*\
	          !*** ./src/core/ngTableDefaults.ts ***!
	          \*************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	            /**
	             * Default values for ngTable
	             */
	
	            exports.ngTableDefaults = {
	                params: {},
	                settings: {}
	            };
	
	            /***/
	        },
	        /* 8 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/core/ngTableEventsChannel.ts ***!
	          \******************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var NgTableEventsChannel = function () {
	                function NgTableEventsChannel($rootScope) {
	                    this.$rootScope = $rootScope;
	                    var events = this;
	                    events = this.addTableParamsEvent('afterCreated', events);
	                    events = this.addTableParamsEvent('afterReloadData', events);
	                    events = this.addTableParamsEvent('datasetChanged', events);
	                    events = this.addTableParamsEvent('pagesChanged', events);
	                    events = this.addTableParamsEvent('afterDataFiltered', events);
	                    events = this.addTableParamsEvent('afterDataSorted', events);
	                }
	                NgTableEventsChannel.prototype.addTableParamsEvent = function (eventName, target) {
	                    var fnName = eventName.charAt(0).toUpperCase() + eventName.substring(1);
	                    var event = (_a = {}, _a['on' + fnName] = this.createEventSubscriptionFn(eventName), _a['publish' + fnName] = this.createPublishEventFn(eventName), _a);
	                    return ng1.extend(target, event);
	                    var _a;
	                };
	                NgTableEventsChannel.prototype.createPublishEventFn = function (eventName) {
	                    var _this = this;
	                    return function () {
	                        var args = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            args[_i - 0] = arguments[_i];
	                        }
	                        (_a = _this.$rootScope).$broadcast.apply(_a, ['ngTable:' + eventName].concat(args));
	                        var _a;
	                    };
	                };
	                NgTableEventsChannel.prototype.createEventSubscriptionFn = function (eventName) {
	                    var _this = this;
	                    return function (handler, eventSelectorOrScope, eventSelector) {
	                        var actualEvtSelector;
	                        var scope = _this.$rootScope;
	                        if (isScopeLike(eventSelectorOrScope)) {
	                            scope = eventSelectorOrScope;
	                            actualEvtSelector = createEventSelectorFn(eventSelector);
	                        } else {
	                            actualEvtSelector = createEventSelectorFn(eventSelectorOrScope);
	                        }
	                        return scope.$on('ngTable:' + eventName, function (event, params) {
	                            var eventArgs = [];
	                            for (var _i = 2; _i < arguments.length; _i++) {
	                                eventArgs[_i - 2] = arguments[_i];
	                            }
	                            // don't send events published by the internal NgTableParams created by ngTableController
	                            if (params.isNullInstance) return;
	                            var fnArgs = [params].concat(eventArgs);
	                            if (actualEvtSelector.apply(this, fnArgs)) {
	                                handler.apply(this, fnArgs);
	                            }
	                        });
	                    };
	                    function createEventSelectorFn(eventSelector) {
	                        if (!eventSelector) {
	                            return function (publisher) {
	                                return true;
	                            };
	                        } else if (isEventSelectorFunc(eventSelector)) {
	                            return eventSelector;
	                        } else {
	                            // shorthand for subscriber to only receive events from a specific publisher instance
	                            return function (publisher) {
	                                return publisher === eventSelector;
	                            };
	                        }
	                    }
	                    function isEventSelectorFunc(val) {
	                        return typeof val === 'function';
	                    }
	                    function isScopeLike(val) {
	                        return val && typeof val.$new === 'function';
	                    }
	                };
	                NgTableEventsChannel.$inject = ['$rootScope'];
	                return NgTableEventsChannel;
	            }();
	            exports.NgTableEventsChannel = NgTableEventsChannel;
	
	            /***/
	        },
	        /* 9 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***********************************!*\
	          !*** ./src/core/ngTableParams.ts ***!
	          \***********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var util_1 = __webpack_require__( /*! ./util */11);
	            /**
	             * @private
	             */
	            function isNumber(n) {
	                return !isNaN(parseFloat(n)) && isFinite(n);
	            }
	            /**
	             * Parameters manager for an ngTable directive
	             */
	            var NgTableParams = function () {
	                function NgTableParams(baseParameters, baseSettings) {
	                    var _this = this;
	                    /**
	                     * The page of data rows currently being displayed in the table
	                     */
	                    this.data = [];
	                    this.defaultSettings = NgTableParams.ngTableSettings.createDefaults();
	                    this.isCommittedDataset = false;
	                    this.initialEvents = [];
	                    this._params = {
	                        page: 1,
	                        count: 10,
	                        filter: {},
	                        sorting: {},
	                        group: {}
	                    };
	                    this._settings = this.defaultSettings;
	                    // the ngTableController "needs" to create a dummy/null instance and it's important to know whether an instance
	                    // is one of these
	                    if (typeof baseParameters === "boolean") {
	                        this.isNullInstance = true;
	                    }
	                    this.reloadPages = function () {
	                        var currentPages;
	                        return function () {
	                            var oldPages = currentPages;
	                            var newPages = _this.generatePagesArray(_this.page(), _this.total(), _this.count());
	                            if (!ng1.equals(oldPages, newPages)) {
	                                currentPages = newPages;
	                                NgTableParams.ngTableEventsChannel.publishPagesChanged(_this, newPages, oldPages);
	                            }
	                        };
	                    }();
	                    ng1.extend(this._params, NgTableParams.ngTableDefaults.params);
	                    this.settings(baseSettings);
	                    this.parameters(baseParameters, true);
	                    NgTableParams.ngTableEventsChannel.publishAfterCreated(this);
	                    // run events during construction after the initial create event. That way a consumer
	                    // can subscribe to all events for a table without "dropping" an event
	                    ng1.forEach(this.initialEvents, function (event) {
	                        event();
	                    });
	                    this.initialEvents = null;
	                }
	                NgTableParams.prototype.count = function (count) {
	                    // reset to first page because can be blank page
	                    return count !== undefined ? this.parameters({
	                        'count': count,
	                        'page': 1
	                    }) : this._params.count;
	                };
	                NgTableParams.prototype.filter = function (filter) {
	                    if (filter != null && (typeof filter === 'undefined' ? 'undefined' : _typeof(filter)) === 'object') {
	                        return this.parameters({
	                            'filter': filter,
	                            'page': 1
	                        });
	                    } else if (filter === true) {
	                        var keys = Object.keys(this._params.filter);
	                        var significantFilter = {};
	                        for (var i = 0; i < keys.length; i++) {
	                            var filterValue = this._params.filter[keys[i]];
	                            if (filterValue != null && filterValue !== '') {
	                                significantFilter[keys[i]] = filterValue;
	                            }
	                        }
	                        return significantFilter;
	                    } else {
	                        return this._params.filter;
	                    }
	                };
	                /**
	                 * Generate array of pages.
	                 * When no arguments supplied, the current parameter state of this `NgTableParams` instance will be used
	                 * @param currentPage Which page must be active
	                 * @param totalItems  Total quantity of items
	                 * @param pageSize    Quantity of items on page
	                 * @param maxBlocks   Quantity of blocks for pagination
	                 * @returns Array of pages
	                 */
	                NgTableParams.prototype.generatePagesArray = function (currentPage, totalItems, pageSize, maxBlocks) {
	                    if (!arguments.length) {
	                        currentPage = this.page();
	                        totalItems = this.total();
	                        pageSize = this.count();
	                    }
	                    var maxPage, maxPivotPages, minPage, numPages;
	                    maxBlocks = maxBlocks && maxBlocks < 6 ? 6 : maxBlocks;
	                    var pages = [];
	                    numPages = Math.ceil(totalItems / pageSize);
	                    if (numPages > 1) {
	                        pages.push({
	                            type: 'prev',
	                            number: Math.max(1, currentPage - 1),
	                            active: currentPage > 1
	                        });
	                        pages.push({
	                            type: 'first',
	                            number: 1,
	                            active: currentPage > 1,
	                            current: currentPage === 1
	                        });
	                        maxPivotPages = Math.round((this._settings.paginationMaxBlocks - this._settings.paginationMinBlocks) / 2);
	                        minPage = Math.max(2, currentPage - maxPivotPages);
	                        maxPage = Math.min(numPages - 1, currentPage + maxPivotPages * 2 - (currentPage - minPage));
	                        minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));
	                        var i = minPage;
	                        while (i <= maxPage) {
	                            if (i === minPage && i !== 2 || i === maxPage && i !== numPages - 1) {
	                                pages.push({
	                                    type: 'more',
	                                    active: false
	                                });
	                            } else {
	                                pages.push({
	                                    type: 'page',
	                                    number: i,
	                                    active: currentPage !== i,
	                                    current: currentPage === i
	                                });
	                            }
	                            i++;
	                        }
	                        pages.push({
	                            type: 'last',
	                            number: numPages,
	                            active: currentPage !== numPages,
	                            current: currentPage === numPages
	                        });
	                        pages.push({
	                            type: 'next',
	                            number: Math.min(numPages, currentPage + 1),
	                            active: currentPage < numPages
	                        });
	                    }
	                    return pages;
	                };
	                NgTableParams.prototype.group = function (group, sortDirection) {
	                    if (group === undefined) {
	                        return this._params.group;
	                    }
	                    var newParameters = {
	                        page: 1
	                    };
	                    if (util_1.isGroupingFun(group) && sortDirection !== undefined) {
	                        group.sortDirection = sortDirection;
	                        newParameters.group = group;
	                    } else if (typeof group === 'string' && sortDirection !== undefined) {
	                        newParameters.group = (_a = {}, _a[group] = sortDirection, _a);
	                    } else {
	                        newParameters.group = group;
	                    }
	                    this.parameters(newParameters);
	                    return this;
	                    var _a;
	                };
	                /**
	                 * Returns true when an attempt to `reload` the current `parameter` values have resulted in a failure.
	                 * This method will continue to return true until the `reload` is successfully called or when the
	                 * `parameter` values have changed
	                 */
	                NgTableParams.prototype.hasErrorState = function () {
	                    return !!(this.errParamsMemento && ng1.equals(this.errParamsMemento, this.createComparableParams()));
	                };
	                /**
	                 * Returns true if `filter` has significant filter value(s) (any value except null, undefined, or empty string),
	                 * otherwise false
	                 */
	                NgTableParams.prototype.hasFilter = function () {
	                    return Object.keys(this.filter(true)).length > 0;
	                };
	                /**
	                 * Return true when a change to `filters` require the `reload` method
	                 * to be run so as to ensure the data presented to the user reflects these filters
	                 */
	                NgTableParams.prototype.hasFilterChanges = function () {
	                    var previousFilter = this.prevParamsMemento && this.prevParamsMemento.params.filter;
	                    return !ng1.equals(this._params.filter, previousFilter) || this.hasGlobalSearchFieldChanges();
	                };
	                NgTableParams.prototype.hasGroup = function (group, sortDirection) {
	                    if (group == null) {
	                        return util_1.isGroupingFun(this._params.group) || Object.keys(this._params.group).length > 0;
	                    }
	                    if (util_1.isGroupingFun(group)) {
	                        if (sortDirection == null) {
	                            return this._params.group === group;
	                        } else {
	                            return this._params.group === group && group.sortDirection === sortDirection;
	                        }
	                    } else {
	                        if (sortDirection == null) {
	                            return Object.keys(this._params.group).indexOf(group) !== -1;
	                        } else {
	                            return this._params.group[group] === sortDirection;
	                        }
	                    }
	                };
	                /**
	                 * Return true when a change to this instance should require the `reload` method
	                 * to be run so as to ensure the data rows presented to the user reflects the current state.
	                 *
	                 * Note that this method will return false when the `reload` method has run but fails. In this case
	                 * `hasErrorState` will return true.
	                 *
	                 * The built-in `ngTable` directives will watch for when this function returns true and will then call
	                 * the `reload` method to load its data rows
	                 */
	                NgTableParams.prototype.isDataReloadRequired = function () {
	                    // note: using != as want to treat null and undefined the same
	                    return !this.isCommittedDataset || !ng1.equals(this.createComparableParams(), this.prevParamsMemento) || this.hasGlobalSearchFieldChanges();
	                };
	                /**
	                 * Returns true if sorting by the field supplied. Where direction supplied
	                 * the field must also be sorted by that direction to return true
	                 */
	                NgTableParams.prototype.isSortBy = function (field, direction) {
	                    if (direction !== undefined) {
	                        return this._params.sorting[field] !== undefined && this._params.sorting[field] == direction;
	                    } else {
	                        return this._params.sorting[field] !== undefined;
	                    }
	                };
	                /**
	                 * Returns sorting values in a format that can be consumed by the angular `$orderBy` filter service
	                 */
	                NgTableParams.prototype.orderBy = function () {
	                    return util_1.convertSortToOrderBy(this._params.sorting);
	                };
	                NgTableParams.prototype.page = function (page) {
	                    return page !== undefined ? this.parameters({
	                        'page': page
	                    }) : this._params.page;
	                };
	                NgTableParams.prototype.parameters = function (newParameters, parseParamsFromUrl) {
	                    parseParamsFromUrl = parseParamsFromUrl || false;
	                    if ((typeof newParameters === 'undefined' ? 'undefined' : _typeof(newParameters)) !== undefined) {
	                        for (var key in newParameters) {
	                            var value = newParameters[key];
	                            if (parseParamsFromUrl && key.indexOf('[') >= 0) {
	                                var keys = key.split(/\[(.*)\]/).reverse();
	                                var lastKey = '';
	                                for (var i = 0, len = keys.length; i < len; i++) {
	                                    var name = keys[i];
	                                    if (name !== '') {
	                                        var v = value;
	                                        value = {};
	                                        value[lastKey = name] = isNumber(v) ? parseFloat(v) : v;
	                                    }
	                                }
	                                if (lastKey === 'sorting') {
	                                    this._params[lastKey] = {};
	                                }
	                                this._params[lastKey] = ng1.extend(this._params[lastKey] || {}, value[lastKey]);
	                            } else {
	                                if (key === 'group') {
	                                    this._params[key] = this.parseGroup(newParameters[key]);
	                                } else {
	                                    this._params[key] = isNumber(newParameters[key]) ? parseFloat(newParameters[key]) : newParameters[key];
	                                }
	                            }
	                        }
	                        this.log('ngTable: set parameters', this._params);
	                        return this;
	                    }
	                    return this._params;
	                };
	                /**
	                 * Trigger a reload of the data rows
	                 */
	                NgTableParams.prototype.reload = function () {
	                    var _this = this;
	                    var pData = null;
	                    this._settings.$loading = true;
	                    this.prevParamsMemento = ng1.copy(this.createComparableParams());
	                    this.isCommittedDataset = true;
	                    if (this.hasGroup()) {
	                        pData = this.runInterceptorPipeline(NgTableParams.$q.when(this._settings.getGroups(this)));
	                    } else {
	                        var fn = this._settings.getData;
	                        pData = this.runInterceptorPipeline(NgTableParams.$q.when(fn(this)));
	                    }
	                    this.log('ngTable: reload data');
	                    var oldData = this.data;
	                    return pData.then(function (data) {
	                        _this._settings.$loading = false;
	                        _this.errParamsMemento = null;
	                        _this.data = data;
	                        // note: I think it makes sense to publish this event even when data === oldData
	                        // subscribers can always set a filter to only receive the event when data !== oldData
	                        NgTableParams.ngTableEventsChannel.publishAfterReloadData(_this, data, oldData);
	                        _this.reloadPages();
	                        return data;
	                    }).catch(function (reason) {
	                        _this.errParamsMemento = _this.prevParamsMemento;
	                        // "rethrow"
	                        return NgTableParams.$q.reject(reason);
	                    });
	                };
	                NgTableParams.prototype.settings = function (newSettings) {
	                    var _this = this;
	                    if (ng1.isDefined(newSettings)) {
	                        var settings = NgTableParams.ngTableSettings.merge(this._settings, newSettings);
	                        var originalDataset_1 = this._settings.dataset;
	                        this._settings = settings;
	                        // note: using != as want null and undefined to be treated the same
	                        var hasDatasetChanged = newSettings.hasOwnProperty('dataset') && newSettings.dataset != originalDataset_1;
	                        if (hasDatasetChanged) {
	                            if (this.isCommittedDataset) {
	                                this.page(1); // reset page as a new dataset has been supplied
	                            }
	                            this.isCommittedDataset = false;
	                            var fireEvent = function fireEvent() {
	                                NgTableParams.ngTableEventsChannel.publishDatasetChanged(_this, newSettings.dataset, originalDataset_1);
	                            };
	                            if (this.initialEvents) {
	                                this.initialEvents.push(fireEvent);
	                            } else {
	                                fireEvent();
	                            }
	                        }
	                        this.log('ngTable: set settings', this._settings);
	                        return this;
	                    }
	                    return this._settings;
	                };
	                NgTableParams.prototype.sorting = function (sorting, direction) {
	                    if (typeof sorting === 'string') {
	                        this.parameters({
	                            'sorting': (_a = {}, _a[sorting] = direction, _a)
	                        });
	                        return this;
	                    }
	                    return sorting !== undefined ? this.parameters({
	                        'sorting': sorting
	                    }) : this._params.sorting;
	                    var _a;
	                };
	                NgTableParams.prototype.total = function (total) {
	                    return total !== undefined ? this.settings({
	                        'total': total
	                    }) : this._settings.total;
	                };
	                /**
	                 * Returns the current parameter values uri-encoded. Set `asString` to
	                 * true for the parameters to be returned as an array of strings of the form 'paramName=value'
	                 * otherwise parameters returned as a key-value object
	                 */
	                NgTableParams.prototype.url = function (asString) {
	                    // this function is an example of Typescript gone bad!!
	                    asString = asString || false;
	                    var pairs = asString ? [] : {};
	                    for (var key in this._params) {
	                        if (this._params.hasOwnProperty(key)) {
	                            var item = this._params[key],
	                                name = encodeURIComponent(key);
	                            if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === "object") {
	                                for (var subkey in item) {
	                                    if (isSignificantValue(item[subkey], key)) {
	                                        var pname = name + "[" + encodeURIComponent(subkey) + "]";
	                                        collectValue(item[subkey], pname);
	                                    }
	                                }
	                            } else if (!ng1.isFunction(item) && isSignificantValue(item, key)) {
	                                collectValue(item, name);
	                            }
	                        }
	                    }
	                    return pairs;
	                    function collectValue(value, key) {
	                        if (isArray(pairs)) {
	                            pairs.push(key + "=" + encodeURIComponent(value));
	                        } else {
	                            pairs[key] = encodeURIComponent(value);
	                        }
	                    }
	                    function isArray(pairs) {
	                        return asString;
	                    }
	                    function isSignificantValue(value, key) {
	                        return key === "group" ? true : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== undefined && value !== "";
	                    }
	                };
	                NgTableParams.prototype.createComparableParams = function () {
	                    var group = this._params.group;
	                    return {
	                        params: this._params,
	                        groupSortDirection: util_1.isGroupingFun(group) ? group.sortDirection : undefined
	                    };
	                };
	                NgTableParams.prototype.hasGlobalSearchFieldChanges = function () {
	                    var currentVal = this._params.filter && this._params.filter['$'];
	                    var previousVal = this.prevParamsMemento && this.prevParamsMemento.params.filter && this.prevParamsMemento.params.filter['$'];
	                    return !ng1.equals(currentVal, previousVal);
	                };
	                NgTableParams.prototype.log = function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i - 0] = arguments[_i];
	                    }
	                    if (this._settings.debugMode && NgTableParams.$log.debug) {
	                        (_a = NgTableParams.$log).debug.apply(_a, args);
	                    }
	                    var _a;
	                };
	                NgTableParams.prototype.parseGroup = function (group) {
	                    var defaultSort = this._settings.groupOptions && this._settings.groupOptions.defaultSort;
	                    if (!group) {
	                        return group;
	                    } else if (util_1.isGroupingFun(group)) {
	                        if (group.sortDirection == null) {
	                            group.sortDirection = defaultSort;
	                        }
	                        return group;
	                    } else if ((typeof group === 'undefined' ? 'undefined' : _typeof(group)) === 'object') {
	                        for (var key in group) {
	                            if (group[key] == null) {
	                                group[key] = defaultSort;
	                            }
	                        }
	                        return group;
	                    } else {
	                        return _a = {}, _a[group] = defaultSort, _a;
	                    }
	                    var _a;
	                };
	                NgTableParams.prototype.runInterceptorPipeline = function (fetchedData) {
	                    var _this = this;
	                    var interceptors = this._settings.interceptors || [];
	                    return interceptors.reduce(function (result, interceptor) {
	                        var thenFn = interceptor.response && interceptor.response.bind(interceptor) || NgTableParams.$q.when;
	                        var rejectFn = interceptor.responseError && interceptor.responseError.bind(interceptor) || NgTableParams.$q.reject;
	                        return result.then(function (data) {
	                            return thenFn(data, _this);
	                        }, function (reason) {
	                            return rejectFn(reason, _this);
	                        });
	                    }, fetchedData);
	                };
	                NgTableParams.init = function ($q, $log, ngTableDefaults, ngTableEventsChannel, ngTableSettings) {
	                    NgTableParams.$q = $q;
	                    NgTableParams.$log = $log;
	                    NgTableParams.ngTableDefaults = ngTableDefaults;
	                    NgTableParams.ngTableEventsChannel = ngTableEventsChannel;
	                    NgTableParams.ngTableSettings = ngTableSettings;
	                };
	                return NgTableParams;
	            }();
	            exports.NgTableParams = NgTableParams;
	            NgTableParams.init.$inject = ['$q', '$log', 'ngTableDefaults', 'ngTableEventsChannel', 'ngTableSettings'];
	
	            /***/
	        },
	        /* 10 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************!*\
	          !*** ./src/core/ngTableSettings.ts ***!
	          \*************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * @private
	             */
	            var NgTableSettings = function () {
	                function NgTableSettings(ngTableDefaults, ngTableDefaultGetData, ngTableDefaultGetGroups) {
	                    var _this = this;
	                    this.ngTableDefaults = ngTableDefaults;
	                    this.ngTableDefaultGetData = ngTableDefaultGetData;
	                    this.ngTableDefaultGetGroups = ngTableDefaultGetGroups;
	                    this.defaults = {
	                        $loading: false,
	                        dataset: null,
	                        total: 0,
	                        defaultSort: 'desc',
	                        counts: [10, 25, 50, 100],
	                        filterOptions: {
	                            filterComparator: undefined,
	                            filterDelay: 500,
	                            filterDelayThreshold: 10000,
	                            filterFilterName: undefined,
	                            filterFn: undefined,
	                            filterLayout: 'stack'
	                        },
	                        getData: function getData(params) {
	                            return _this.ngTableDefaultGetData(params.settings().dataset, params);
	                        },
	                        getGroups: this.ngTableDefaultGetGroups,
	                        groupOptions: {
	                            defaultSort: 'asc',
	                            isExpanded: true
	                        },
	                        interceptors: [],
	                        paginationMaxBlocks: 11,
	                        paginationMinBlocks: 5,
	                        sortingIndicator: 'span'
	                    };
	                }
	                NgTableSettings.prototype.createDefaults = function () {
	                    return this.merge(this.defaults, this.ngTableDefaults.settings);
	                };
	                NgTableSettings.prototype.merge = function (existing, newSettings) {
	                    newSettings = ng1.extend({}, newSettings);
	                    if (newSettings.filterOptions) {
	                        newSettings.filterOptions = ng1.extend({}, existing.filterOptions || {}, newSettings.filterOptions);
	                    }
	                    if (newSettings.groupOptions) {
	                        newSettings.groupOptions = ng1.extend({}, existing.groupOptions || {}, newSettings.groupOptions);
	                    }
	                    if (ng1.isArray(newSettings.dataset)) {
	                        //auto-set the total from passed in dataset
	                        newSettings.total = newSettings.dataset.length;
	                    }
	                    var results = ng1.extend({}, existing, newSettings);
	                    if (ng1.isArray(newSettings.dataset)) {
	                        this.optimizeFilterDelay(results);
	                    }
	                    return ng1.extend({}, existing, newSettings);
	                };
	                NgTableSettings.prototype.optimizeFilterDelay = function (settings) {
	                    // don't debounce by default filter input when working with small synchronous datasets
	                    if (settings.filterOptions.filterDelay === this.defaults.filterOptions.filterDelay && settings.total <= settings.filterOptions.filterDelayThreshold && settings.getData === this.defaults.getData) {
	                        settings.filterOptions.filterDelay = 0;
	                    }
	                };
	                NgTableSettings.$inject = ['ngTableDefaults', 'ngTableDefaultGetData', 'ngTableDefaultGetGroups'];
	                return NgTableSettings;
	            }();
	            exports.NgTableSettings = NgTableSettings;
	
	            /***/
	        },
	        /* 11 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************!*\
	          !*** ./src/core/util.ts ***!
	          \**************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	            /**
	             * @private
	             */
	
	            function convertSortToOrderBy(sorting) {
	                var result = [];
	                for (var column in sorting) {
	                    result.push((sorting[column] === "asc" ? "+" : "-") + column);
	                }
	                return result;
	            }
	            exports.convertSortToOrderBy = convertSortToOrderBy;
	            /**
	             * @private
	             */
	            function isGroupingFun(val) {
	                return typeof val === 'function';
	            }
	            exports.isGroupingFun = isGroupingFun;
	
	            /***/
	        },,
	        /* 12 */
	        /* 13 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/browser/ngTable.directive.ts ***!
	          \******************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            ngTable.$inject = ['$q', '$parse'];
	            /**
	             * Directive that instantiates {@link NgTableController NgTableController}.
	             * @ngdoc directive
	             * @name ngTable
	             * @example
	             *
	             * ```html
	             * <table ng-table="$ctrl.tableParams" show-filter="true" class="table table-bordered">
	             *  <tr ng-repeat="user in $data">
	             *      <td data-title="'Name'" sortable="'name'" filter="{ 'name': 'text' }">
	             *          {{user.name}}
	             *      </td>
	             *      <td data-title="'Age'" sortable="'age'" filter="{ 'age': 'text' }">
	             *          {{user.age}}
	             *      </td>
	             *  </tr>
	             * </table>
	             * ```
	             */
	            function ngTable($q, $parse) {
	                return {
	                    restrict: 'A',
	                    priority: 1001,
	                    scope: true,
	                    controller: 'ngTableController',
	                    compile: function compile(element) {
	                        var columns = [],
	                            i = 0,
	                            dataRow,
	                            groupRow;
	                        var rows = [];
	                        ng1.forEach(element.find('tr'), function (tr) {
	                            rows.push(ng1.element(tr));
	                        });
	                        dataRow = rows.filter(function (tr) {
	                            return !tr.hasClass('ng-table-group');
	                        })[0];
	                        groupRow = rows.filter(function (tr) {
	                            return tr.hasClass('ng-table-group');
	                        })[0];
	                        if (!dataRow) {
	                            return undefined;
	                        }
	                        ng1.forEach(dataRow.find('td'), function (item) {
	                            var el = ng1.element(item);
	                            if (el.attr('ignore-cell') && 'true' === el.attr('ignore-cell')) {
	                                return;
	                            }
	                            var getAttrValue = function getAttrValue(attr) {
	                                return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
	                            };
	                            var setAttrValue = function setAttrValue(attr, value) {
	                                if (el.attr('x-data-' + attr)) {
	                                    el.attr('x-data-' + attr, value);
	                                } else if (el.attr('data' + attr)) {
	                                    el.attr('data' + attr, value);
	                                } else {
	                                    el.attr(attr, value);
	                                }
	                            };
	                            var parsedAttribute = function parsedAttribute(attr) {
	                                var expr = getAttrValue(attr);
	                                if (!expr) {
	                                    return undefined;
	                                }
	                                var localValue;
	                                var getter = function getter(context) {
	                                    if (localValue !== undefined) {
	                                        return localValue;
	                                    }
	                                    return $parse(expr)(context);
	                                };
	                                getter.assign = function ($scope, value) {
	                                    var parsedExpr = $parse(expr);
	                                    if (parsedExpr.assign) {
	                                        // we should be writing back to the parent scope as this is where the expression
	                                        // came from
	                                        parsedExpr.assign($scope.$parent, value);
	                                    } else {
	                                        localValue = value;
	                                    }
	                                };
	                                return getter;
	                            };
	                            var titleExpr = getAttrValue('title-alt') || getAttrValue('title');
	                            if (titleExpr) {
	                                el.attr('data-title-text', '{{' + titleExpr + '}}'); // this used in responsive table
	                            }
	                            // NOTE TO MAINTAINERS: if you add extra fields to a $column be sure to extend ngTableColumn with
	                            // a corresponding "safe" default
	                            columns.push({
	                                id: i++,
	                                title: parsedAttribute('title'),
	                                titleAlt: parsedAttribute('title-alt'),
	                                headerTitle: parsedAttribute('header-title'),
	                                sortable: parsedAttribute('sortable'),
	                                'class': parsedAttribute('header-class'),
	                                filter: parsedAttribute('filter'),
	                                groupable: parsedAttribute('groupable'),
	                                headerTemplateURL: parsedAttribute('header'),
	                                filterData: parsedAttribute('filter-data'),
	                                show: el.attr("ng-if") ? parsedAttribute('ng-if') : undefined
	                            });
	                            if (groupRow || el.attr("ng-if")) {
	                                // change ng-if to bind to our column definition which we know will be writable
	                                // because this will potentially increase the $watch count, only do so if we already have an
	                                // ng-if or when we definitely need to change visibility of the columns.
	                                // currently only ngTableGroupRow directive needs to change visibility
	                                setAttrValue('ng-if', '$columns[' + (columns.length - 1) + '].show(this)');
	                            }
	                        });
	                        return function (scope, element, attrs, controller) {
	                            scope.$columns = columns = controller.buildColumns(columns);
	                            controller.setupBindingsToInternalScope(attrs.ngTable);
	                            controller.loadFilterData(columns);
	                            controller.compileDirectiveTemplates();
	                        };
	                    }
	                };
	            }
	            exports.ngTable = ngTable;
	
	            /***/
	        },
	        /* 14 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************!*\
	          !*** ./src/browser/ngTableColumn.ts ***!
	          \**************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * @private
	             */
	            function isScopeLike(object) {
	                return object != null && ng1.isFunction(object.$new);
	            }
	            /**
	             * @private
	             * Service to construct a $column definition used by {@link ngTable ngTable} directive
	             */
	            var NgTableColumn = function () {
	                function NgTableColumn() {}
	                /**
	                 * Creates a $column for use within a header template
	                 *
	                 * @param column the initial definition for $column to build
	                 * @param defaultScope the $scope to supply to the $column getter methods when not supplied by caller
	                 * @param columns a reference to the $columns array to make available on the context supplied to the
	                 * $column getter methods
	                 */
	                NgTableColumn.prototype.buildColumn = function (column, defaultScope, columns) {
	                    // note: we're not modifying the original column object. This helps to avoid unintended side affects
	                    var extendedCol = Object.create(column);
	                    var defaults = this.createDefaults();
	                    var _loop_1 = function _loop_1(prop) {
	                        if (extendedCol[prop] === undefined) {
	                            extendedCol[prop] = defaults[prop];
	                        }
	                        if (!ng1.isFunction(extendedCol[prop])) {
	                            // wrap raw field values with "getter" functions
	                            // - this is to ensure consistency with how ngTable.compile builds columns
	                            // - note that the original column object is being "proxied"; this is important
	                            //   as it ensure that any changes to the original object will be returned by the "getter"
	                            var getterSetter = function getterSetter() {
	                                if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                                    getterSetter.assign(null, arguments[0]);
	                                } else {
	                                    return column[prop];
	                                }
	                            };
	                            getterSetter.assign = function ($scope, value) {
	                                column[prop] = value;
	                            };
	                            extendedCol[prop] = getterSetter;
	                        }
	                        // satisfy the arguments expected by the function returned by parsedAttribute in the ngTable directive
	                        var getterFn = extendedCol[prop];
	                        extendedCol[prop] = function () {
	                            if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                                getterFn.assign(defaultScope, arguments[0]);
	                            } else {
	                                var scope = arguments[0] || defaultScope;
	                                var context = Object.create(scope);
	                                ng1.extend(context, {
	                                    $column: extendedCol,
	                                    $columns: columns
	                                });
	                                return getterFn.call(column, context);
	                            }
	                        };
	                        if (getterFn.assign) {
	                            extendedCol[prop].assign = getterFn.assign;
	                        } else {
	                            var wrappedGetterFn_1 = extendedCol[prop];
	                            var localValue_1;
	                            var getterSetter = function getterSetter() {
	                                if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                                    getterSetter.assign(null, arguments[0]);
	                                } else {
	                                    return localValue_1 != undefined ? localValue_1 : wrappedGetterFn_1.apply(extendedCol, arguments);
	                                }
	                            };
	                            getterSetter.assign = function ($scope, value) {
	                                localValue_1 = value;
	                            };
	                            extendedCol[prop] = getterSetter;
	                        }
	                    };
	                    for (var prop in defaults) {
	                        _loop_1(prop);
	                    }
	                    return extendedCol;
	                };
	                NgTableColumn.prototype.createDefaults = function () {
	                    return {
	                        'class': this.createGetterSetter(''),
	                        filter: this.createGetterSetter(false),
	                        groupable: this.createGetterSetter(false),
	                        filterData: ng1.noop,
	                        headerTemplateURL: this.createGetterSetter(false),
	                        headerTitle: this.createGetterSetter(''),
	                        sortable: this.createGetterSetter(false),
	                        show: this.createGetterSetter(true),
	                        title: this.createGetterSetter(''),
	                        titleAlt: this.createGetterSetter('')
	                    };
	                };
	                NgTableColumn.prototype.createGetterSetter = function (initialValue) {
	                    var value = initialValue;
	                    var getterSetter = function getterSetter() {
	                        if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                            getterSetter.assign(null, arguments[0]);
	                        } else {
	                            return value;
	                        }
	                    };
	                    getterSetter.assign = function ($scope, newValue) {
	                        value = newValue;
	                    };
	                    return getterSetter;
	                };
	                NgTableColumn.$inject = [];
	                return NgTableColumn;
	            }();
	            exports.NgTableColumn = NgTableColumn;
	
	            /***/
	        },
	        /* 15 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************************!*\
	          !*** ./src/browser/ngTableColumnsBinding.directive.ts ***!
	          \********************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            ngTableColumnsBinding.$inject = ["$parse"];
	            /**
	             * One-way data binds the $columns array generated by ngTable/ngTableDynamic to the specified
	             * expression.
	             * This allows the $columns array created for the table to be accessed outside of the html table
	             * markup.
	             *
	             * @ngdoc directive
	             *
	             * @example
	             * ```html
	             * <table ng-table="$ctrl.tableParams" class="table" ng-table-columns-binding="$ctlr.tableColumns">
	             * ```
	             */
	            function ngTableColumnsBinding($parse) {
	                var directive = {
	                    restrict: 'A',
	                    link: linkFn
	                };
	                return directive;
	                function linkFn($scope, $element, $attrs) {
	                    var setter = $parse($attrs.ngTableColumnsBinding).assign;
	                    if (setter) {
	                        $scope.$watch('$columns', function (newColumns) {
	                            var shallowClone = (newColumns || []).slice(0);
	                            setter($scope, shallowClone);
	                        });
	                    }
	                }
	            }
	            exports.ngTableColumnsBinding = ngTableColumnsBinding;
	
	            /***/
	        },
	        /* 16 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/browser/ngTableController.ts ***!
	          \******************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var core_1 = __webpack_require__( /*! ../core */1);
	            /**
	             * The controller for the {@link ngTable ngTable} and {@link ngTableDynamic ngTableDynamic} directives
	             */
	            var NgTableController = function () {
	                function NgTableController($scope, $timeout, $parse, $compile, $attrs, $element, $document, ngTableColumn, ngTableEventsChannel) {
	                    this.$scope = $scope;
	                    this.$parse = $parse;
	                    this.$compile = $compile;
	                    this.$attrs = $attrs;
	                    this.$element = $element;
	                    this.$document = $document;
	                    this.ngTableColumn = ngTableColumn;
	                    this.ngTableEventsChannel = ngTableEventsChannel;
	                    var isFirstTimeLoad = true;
	                    $scope.$filterRow = { disabled: false };
	                    $scope.$loading = false;
	                    // until such times as the directive uses an isolated scope, we need to ensure that the check for
	                    // the params field only consults the "own properties" of the $scope. This is to avoid seeing the params
	                    // field on a $scope higher up in the prototype chain
	                    if (!$scope.hasOwnProperty("params")) {
	                        $scope.params = new core_1.NgTableParams(true);
	                    }
	                    this.delayFilter = function () {
	                        var timer;
	                        return function (callback, ms) {
	                            $timeout.cancel(timer);
	                            timer = $timeout(callback, ms);
	                        };
	                    }();
	                    // watch for when a new NgTableParams is bound to the scope
	                    // CRITICAL: the watch must be for reference and NOT value equality; this is because NgTableParams maintains
	                    // the current data page as a field. Checking this for value equality would be terrible for performance
	                    // and potentially cause an error if the items in that array has circular references
	                    this.$scope.$watch('params', function (newParams, oldParams) {
	                        if (newParams === oldParams || !newParams) {
	                            return;
	                        }
	                        newParams.reload();
	                    }, false);
	                    this.subscribeToTableEvents();
	                }
	                Object.defineProperty(NgTableController.prototype, "hasVisibleFilterColumn", {
	                    get: function get() {
	                        var _this = this;
	                        if (!this.$scope.$columns) return false;
	                        return this.some(this.$scope.$columns, function ($column) {
	                            return $column.show(_this.$scope) && !!$column.filter(_this.$scope);
	                        });
	                    },
	                    enumerable: true,
	                    configurable: true
	                });
	                NgTableController.prototype.onDataReloadStatusChange = function (newStatus /*, oldStatus*/) {
	                    if (!newStatus || this.$scope.params.hasErrorState()) {
	                        return;
	                    }
	                    var currentParams = this.$scope.params;
	                    var filterOptions = currentParams.settings().filterOptions;
	                    if (currentParams.hasFilterChanges()) {
	                        var applyFilter = function applyFilter() {
	                            currentParams.page(1);
	                            currentParams.reload();
	                        };
	                        if (filterOptions.filterDelay) {
	                            this.delayFilter(applyFilter, filterOptions.filterDelay);
	                        } else {
	                            applyFilter();
	                        }
	                    } else {
	                        currentParams.reload();
	                    }
	                };
	                NgTableController.prototype.compileDirectiveTemplates = function () {
	                    if (!this.$element.hasClass('ng-table')) {
	                        this.$scope.templates = {
	                            header: this.$attrs.templateHeader ? this.$attrs.templateHeader : 'ng-table/header.html',
	                            pagination: this.$attrs.templatePagination ? this.$attrs.templatePagination : 'ng-table/pager.html'
	                        };
	                        this.$element.addClass('ng-table');
	                        var headerTemplate = null;
	                        // $element.find('> thead').length === 0 doesn't work on jqlite
	                        var theadFound_1 = false;
	                        ng1.forEach(this.$element.children(), function (e) {
	                            if (e.tagName === 'THEAD') {
	                                theadFound_1 = true;
	                            }
	                        });
	                        if (!theadFound_1) {
	                            headerTemplate = ng1.element('<thead ng-include="templates.header"></thead>', this.$document);
	                            if (this.$element.find('table').length) {
	                                this.$element.find('table').prepend(headerTemplate);
	                            } else {
	                                this.$element.prepend(headerTemplate);
	                            }
	                        }
	                        var paginationTemplate = ng1.element('<div ng-table-pagination="params" template-url="templates.pagination"></div>', this.$document);
	                        this.$element.after(paginationTemplate);
	                        if (headerTemplate) {
	                            this.$compile(headerTemplate)(this.$scope);
	                        }
	                        this.$compile(paginationTemplate)(this.$scope);
	                    }
	                };
	                NgTableController.prototype.loadFilterData = function ($columns) {
	                    var _this = this;
	                    ng1.forEach($columns, function ($column) {
	                        var result = $column.filterData(_this.$scope);
	                        if (!result) {
	                            delete $column.filterData;
	                            return undefined;
	                        }
	                        if (isPromiseLike(result)) {
	                            delete $column.filterData;
	                            return result.then(function (data) {
	                                // our deferred can eventually return arrays, functions and objects
	                                if (!ng1.isArray(data) && !ng1.isFunction(data) && !ng1.isObject(data)) {
	                                    // if none of the above was found - we just want an empty array
	                                    data = [];
	                                }
	                                $column.data = data;
	                            });
	                        } else {
	                            return $column.data = result;
	                        }
	                    });
	                    function isPromiseLike(val) {
	                        return val && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && typeof val.then === 'function';
	                    }
	                };
	                NgTableController.prototype.buildColumns = function (columns) {
	                    var _this = this;
	                    // todo: use strictNullChecks and remove guard clause
	                    var result = [];
	                    (columns || []).forEach(function (col) {
	                        result.push(_this.ngTableColumn.buildColumn(col, _this.$scope, result));
	                    });
	                    return result;
	                };
	                NgTableController.prototype.parseNgTableDynamicExpr = function (attr) {
	                    if (!attr || attr.indexOf(" with ") > -1) {
	                        var parts = attr.split(/\s+with\s+/);
	                        return {
	                            tableParams: parts[0],
	                            columns: parts[1]
	                        };
	                    } else {
	                        throw new Error('Parse error (expected example: ng-table-dynamic=\'tableParams with cols\')');
	                    }
	                };
	                NgTableController.prototype.setupBindingsToInternalScope = function (tableParamsExpr) {
	                    // note: this we're setting up watches to simulate angular's isolated scope bindings
	                    var _this = this;
	                    // note: is REALLY important to watch for a change to the ngTableParams *reference* rather than
	                    // $watch for value equivalence. This is because ngTableParams references the current page of data as
	                    // a field and it's important not to watch this
	                    this.$scope.$watch(tableParamsExpr, function (params) {
	                        if (params === undefined) {
	                            return;
	                        }
	                        _this.$scope.params = params;
	                    }, false);
	                    this.setupFilterRowBindingsToInternalScope();
	                    this.setupGroupRowBindingsToInternalScope();
	                };
	                NgTableController.prototype.setupFilterRowBindingsToInternalScope = function () {
	                    var _this = this;
	                    if (this.$attrs.showFilter) {
	                        this.$scope.$parent.$watch(this.$attrs.showFilter, function (value) {
	                            _this.$scope.show_filter = value;
	                        });
	                    } else {
	                        this.$scope.$watch(function () {
	                            return _this.hasVisibleFilterColumn;
	                        }, function (value) {
	                            _this.$scope.show_filter = value;
	                        });
	                    }
	                    if (this.$attrs.disableFilter) {
	                        this.$scope.$parent.$watch(this.$attrs.disableFilter, function (value) {
	                            _this.$scope.$filterRow.disabled = value;
	                        });
	                    }
	                };
	                NgTableController.prototype.setupGroupRowBindingsToInternalScope = function () {
	                    var _this = this;
	                    this.$scope.$groupRow = { show: false };
	                    if (this.$attrs.showGroup) {
	                        var showGroupGetter_1 = this.$parse(this.$attrs.showGroup);
	                        this.$scope.$parent.$watch(showGroupGetter_1, function (value) {
	                            _this.$scope.$groupRow.show = value;
	                        });
	                        if (showGroupGetter_1.assign) {
	                            // setup two-way databinding thus allowing ngTableGrowRow to assign to the showGroup expression
	                            this.$scope.$watch('$groupRow.show', function (value) {
	                                showGroupGetter_1.assign(_this.$scope.$parent, value);
	                            });
	                        }
	                    } else {
	                        this.$scope.$watch('params.hasGroup()', function (newValue) {
	                            _this.$scope.$groupRow.show = newValue;
	                        });
	                    }
	                };
	                NgTableController.prototype.getVisibleColumns = function () {
	                    var _this = this;
	                    return (this.$scope.$columns || []).filter(function (c) {
	                        return c.show(_this.$scope);
	                    });
	                };
	                NgTableController.prototype.subscribeToTableEvents = function () {
	                    var _this = this;
	                    this.$scope.$watch('params.isDataReloadRequired()', function (newStatus /*, oldStatus*/) {
	                        _this.onDataReloadStatusChange(newStatus);
	                    });
	                    this.ngTableEventsChannel.onAfterReloadData(function (params, newDatapage) {
	                        var visibleColumns = _this.getVisibleColumns();
	                        if (params.hasGroup()) {
	                            _this.$scope.$groups = newDatapage || [];
	                            _this.$scope.$groups.visibleColumnCount = visibleColumns.length;
	                        } else {
	                            _this.$scope.$data = newDatapage || [];
	                            _this.$scope.$data.visibleColumnCount = visibleColumns.length;
	                        }
	                    }, this.$scope, function (publisher) {
	                        return _this.$scope.params === publisher;
	                    });
	                    this.ngTableEventsChannel.onPagesChanged(function (params, newPages) {
	                        _this.$scope.pages = newPages;
	                    }, this.$scope, function (publisher) {
	                        return _this.$scope.params === publisher;
	                    });
	                };
	                NgTableController.prototype.some = function (array, predicate) {
	                    var found = false;
	                    for (var i = 0; i < array.length; i++) {
	                        var obj = array[i];
	                        if (predicate(obj)) {
	                            found = true;
	                            break;
	                        }
	                    }
	                    return found;
	                };
	                NgTableController.$inject = ['$scope', '$timeout', '$parse', '$compile', '$attrs', '$element', '$document', 'ngTableColumn', 'ngTableEventsChannel'];
	                return NgTableController;
	            }();
	            exports.NgTableController = NgTableController;
	
	            /***/
	        },
	        /* 17 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************************!*\
	          !*** ./src/browser/ngTableDynamic.directive.ts ***!
	          \*************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            ngTableDynamic.$inject = [];
	            /**
	             * A dynamic version of the {@link ngTable ngTable} directive that accepts a dynamic list of columns
	             * definitions to render
	             * @ngdoc directive
	             *
	             * @example
	             * ```html
	             * <table ng-table-dynamic="$ctrl.tableParams with $ctrl.cols" class="table">
	             *  <tr ng-repeat="row in $data">
	             *    <td ng-repeat="col in $columns">{{row[col.field]}}</td>
	             *  </tr>
	             * </table>
	             * ```
	             */
	            function ngTableDynamic() {
	                return {
	                    restrict: 'A',
	                    priority: 1001,
	                    scope: true,
	                    controller: 'ngTableController',
	                    compile: function compile(tElement) {
	                        var row;
	                        // IE 8 fix :not(.ng-table-group) selector
	                        ng1.forEach(tElement.find('tr'), function (tr) {
	                            tr = ng1.element(tr);
	                            if (!tr.hasClass('ng-table-group') && !row) {
	                                row = tr;
	                            }
	                        });
	                        if (!row) {
	                            return undefined;
	                        }
	                        ng1.forEach(row.find('td'), function (item) {
	                            var el = ng1.element(item);
	                            var getAttrValue = function getAttrValue(attr) {
	                                return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
	                            };
	                            // this used in responsive table
	                            var titleExpr = getAttrValue('title');
	                            if (!titleExpr) {
	                                el.attr('data-title-text', '{{$columns[$index].titleAlt(this) || $columns[$index].title(this)}}');
	                            }
	                            var showExpr = el.attr('ng-if');
	                            if (!showExpr) {
	                                el.attr('ng-if', '$columns[$index].show(this)');
	                            }
	                        });
	                        return function (scope, element, attrs, controller) {
	                            var expr = controller.parseNgTableDynamicExpr(attrs.ngTableDynamic);
	                            controller.setupBindingsToInternalScope(expr.tableParams);
	                            controller.compileDirectiveTemplates();
	                            scope.$watchCollection(expr.columns, function (newCols /*, oldCols*/) {
	                                scope.$columns = controller.buildColumns(newCols);
	                                controller.loadFilterData(scope.$columns);
	                            });
	                        };
	                    }
	                };
	            }
	            exports.ngTableDynamic = ngTableDynamic;
	
	            /***/
	        },
	        /* 18 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************!*\
	          !*** ./src/browser/ngTableFilterConfig.ts ***!
	          \********************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * The angular provider used to configure the behaviour of the `NgTableFilterConfig` service.
	             */
	            var NgTableFilterConfigProvider = function () {
	                function NgTableFilterConfigProvider($injector) {
	                    var _this = this;
	                    this.defaultConfig = {
	                        defaultBaseUrl: 'ng-table/filters/',
	                        defaultExt: '.html',
	                        aliasUrls: {}
	                    };
	                    this.$get = function () {
	                        return $injector.instantiate(NgTableFilterConfig, { config: ng1.copy(_this.config) });
	                    };
	                    this.$get.$inject = [];
	                    this.resetConfigs();
	                }
	                /**
	                 * Reset back to factory defaults the config values that `NgTableFilterConfig` service will use
	                 */
	                NgTableFilterConfigProvider.prototype.resetConfigs = function () {
	                    this.config = this.defaultConfig;
	                };
	                /**
	                 * Set the config values used by `NgTableFilterConfig` service
	                 */
	                NgTableFilterConfigProvider.prototype.setConfig = function (customConfig) {
	                    var mergeConfig = ng1.extend({}, this.config, customConfig);
	                    mergeConfig.aliasUrls = ng1.extend({}, this.config.aliasUrls, customConfig.aliasUrls);
	                    this.config = mergeConfig;
	                };
	                NgTableFilterConfigProvider.$inject = ['$injector'];
	                return NgTableFilterConfigProvider;
	            }();
	            exports.NgTableFilterConfigProvider = NgTableFilterConfigProvider;
	            /**
	             * Exposes configuration values and methods used to return the location of the html
	             * templates used to render the filter row of an ng-table directive
	             */
	            var NgTableFilterConfig = function () {
	                function NgTableFilterConfig(
	                /**
	                 * Readonly copy of the final values used to configure the service.
	                 */
	                config) {
	                    this.config = config;
	                }
	                /**
	                 * Return the url of the html filter template registered with the alias supplied
	                 */
	                NgTableFilterConfig.prototype.getUrlForAlias = function (aliasName, filterKey) {
	                    return this.config.aliasUrls[aliasName] || this.config.defaultBaseUrl + aliasName + this.config.defaultExt;
	                };
	                /**
	                 * Return the url of the html filter template for the supplied definition and key.
	                 * For more information see the documentation for {@link IFilterTemplateMap}
	                 */
	                NgTableFilterConfig.prototype.getTemplateUrl = function (filterDef, filterKey) {
	                    var filterName;
	                    if (typeof filterDef !== 'string') {
	                        filterName = filterDef.id;
	                    } else {
	                        filterName = filterDef;
	                    }
	                    if (filterName.indexOf('/') !== -1) {
	                        return filterName;
	                    }
	                    return this.getUrlForAlias(filterName, filterKey);
	                };
	                NgTableFilterConfig.$inject = ['config'];
	                return NgTableFilterConfig;
	            }();
	            exports.NgTableFilterConfig = NgTableFilterConfig;
	
	            /***/
	        },
	        /* 19 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableFilterRow.directive.ts ***!
	          \***************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var templateUrl = __webpack_require__( /*! ./filterRow.html */42);
	            ngTableFilterRow.$inject = [];
	            /**
	             * directive that renders the filter header row for a table
	             * @ngdoc directive
	             * @example
	             * ```html
	             * <ng-table-filter-row></ng-table-filter-row>
	             * ```
	             */
	            function ngTableFilterRow() {
	                var directive = {
	                    restrict: 'E',
	                    replace: true,
	                    templateUrl: templateUrl,
	                    scope: true,
	                    controller: 'ngTableFilterRowController',
	                    controllerAs: '$ctrl'
	                };
	                return directive;
	            }
	            exports.ngTableFilterRow = ngTableFilterRow;
	
	            /***/
	        },
	        /* 20 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableFilterRowController.ts ***!
	          \***************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	            /**
	             * Controller for the {@link ngTableFilterRow ngTableFilterRow} directive
	             */
	
	            var NgTableFilterRowController = function () {
	                function NgTableFilterRowController($scope, ngTableFilterConfig) {
	                    this.config = ngTableFilterConfig;
	                    // todo: stop doing this. Why?
	                    // * scope inheritance makes it hard to know how supplies functions
	                    // * scope is not a concept in angular 2
	                    // make function available to filter templates
	                    $scope.getFilterPlaceholderValue = this.getFilterPlaceholderValue.bind(this);
	                }
	                NgTableFilterRowController.prototype.getFilterCellCss = function (filter, layout) {
	                    if (layout !== 'horizontal') {
	                        return 's12';
	                    }
	                    var size = Object.keys(filter).length;
	                    var width = parseInt((12 / size).toString(), 10);
	                    return 's' + width;
	                };
	                NgTableFilterRowController.prototype.getFilterPlaceholderValue = function (filterDef, filterKey) {
	                    if (typeof filterDef === 'string') {
	                        return '';
	                    } else {
	                        return filterDef.placeholder;
	                    }
	                };
	                NgTableFilterRowController.$inject = ['$scope', 'ngTableFilterConfig'];
	                return NgTableFilterRowController;
	            }();
	            exports.NgTableFilterRowController = NgTableFilterRowController;
	
	            /***/
	        },
	        /* 21 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************************!*\
	          !*** ./src/browser/ngTableGroupRow.directive.ts ***!
	          \**************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var templateUrl = __webpack_require__( /*! ./groupRow.html */47);
	            ngTableGroupRow.$inject = [];
	            /**
	             * directive that renders the group header row for a table
	             * @ngdoc directive
	             * @example
	             * ```html
	             * <ng-table-group-row></ng-table-group-row>
	             * ```
	             */
	            function ngTableGroupRow() {
	                var directive = {
	                    restrict: 'E',
	                    replace: true,
	                    templateUrl: templateUrl,
	                    scope: true,
	                    controller: 'ngTableGroupRowController',
	                    controllerAs: '$ctrl'
	                };
	                return directive;
	            }
	            exports.ngTableGroupRow = ngTableGroupRow;
	
	            /***/
	        },
	        /* 22 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************************!*\
	          !*** ./src/browser/ngTableGroupRowController.ts ***!
	          \**************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	            /**
	             * Controller for the {@link ngTableGroupRow ngTableGroupRow} directive
	             */
	
	            var NgTableGroupRowController = function () {
	                function NgTableGroupRowController($scope) {
	                    var _this = this;
	                    this.$scope = $scope;
	                    this.groupFns = [];
	                    $scope.$watch('params.group()', function (newGrouping) {
	                        _this.setGroup(newGrouping);
	                    }, true);
	                }
	                NgTableGroupRowController.prototype.getGroupables = function () {
	                    var _this = this;
	                    var groupableCols = this.$scope.$columns.filter(function ($column) {
	                        return !!$column.groupable(_this.$scope);
	                    });
	                    return this.groupFns.concat(groupableCols);
	                };
	                NgTableGroupRowController.prototype.getGroupTitle = function (group) {
	                    return this.isGroupingFunc(group) ? group.title : group.title(this.$scope);
	                };
	                NgTableGroupRowController.prototype.getVisibleColumns = function () {
	                    var _this = this;
	                    return this.$scope.$columns.filter(function ($column) {
	                        return $column.show(_this.$scope);
	                    });
	                };
	                NgTableGroupRowController.prototype.groupBy = function (group) {
	                    if (this.isSelectedGroup(group)) {
	                        this.changeSortDirection();
	                    } else {
	                        if (this.isGroupingFunc(group)) {
	                            this.$scope.params.group(group);
	                        } else {
	                            // it's OK, we know that groupable will return a string
	                            // this is guaranteed by getGroupables returning only
	                            // columns that return (truthy) strings
	                            this.$scope.params.group(group.groupable(this.$scope));
	                        }
	                    }
	                };
	                NgTableGroupRowController.prototype.isSelectedGroup = function (group) {
	                    if (this.isGroupingFunc(group)) {
	                        return group === this.$scope.$selGroup;
	                    } else {
	                        return group.groupable(this.$scope) === this.$scope.$selGroup;
	                    }
	                };
	                NgTableGroupRowController.prototype.toggleDetail = function () {
	                    this.$scope.params.settings().groupOptions.isExpanded = !this.$scope.params.settings().groupOptions.isExpanded;
	                    return this.$scope.params.reload();
	                };
	                NgTableGroupRowController.prototype.changeSortDirection = function () {
	                    var newDirection;
	                    if (this.$scope.params.hasGroup(this.$scope.$selGroup, 'asc')) {
	                        newDirection = 'desc';
	                    } else if (this.$scope.params.hasGroup(this.$scope.$selGroup, 'desc')) {
	                        newDirection = '';
	                    } else {
	                        newDirection = 'asc';
	                    }
	                    this.$scope.params.group(this.$scope.$selGroup, newDirection);
	                };
	                NgTableGroupRowController.prototype.findGroupColumn = function (groupKey) {
	                    var _this = this;
	                    return this.$scope.$columns.filter(function ($column) {
	                        return $column.groupable(_this.$scope) === groupKey;
	                    })[0];
	                };
	                NgTableGroupRowController.prototype.isGroupingFunc = function (val) {
	                    return typeof val === 'function';
	                };
	                NgTableGroupRowController.prototype.setGroup = function (grouping) {
	                    var existingGroupCol = this.findGroupColumn(this.$scope.$selGroup);
	                    if (existingGroupCol && existingGroupCol.show.assign) {
	                        existingGroupCol.show.assign(this.$scope, true);
	                    }
	                    if (this.isGroupingFunc(grouping)) {
	                        this.groupFns = [grouping];
	                        this.$scope.$selGroup = grouping;
	                        this.$scope.$selGroupTitle = grouping.title;
	                    } else {
	                        // note: currently only one group is implemented
	                        var groupKey = Object.keys(grouping || {})[0];
	                        var groupedColumn = this.findGroupColumn(groupKey);
	                        if (groupedColumn) {
	                            this.$scope.$selGroupTitle = groupedColumn.title(this.$scope);
	                            this.$scope.$selGroup = groupKey;
	                            if (groupedColumn.show.assign) {
	                                groupedColumn.show.assign(this.$scope, false);
	                            }
	                        }
	                    }
	                };
	                NgTableGroupRowController.$inject = ['$scope'];
	                return NgTableGroupRowController;
	            }();
	            exports.NgTableGroupRowController = NgTableGroupRowController;
	
	            /***/
	        },
	        /* 23 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!****************************************************!*\
	          !*** ./src/browser/ngTablePagination.directive.ts ***!
	          \****************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            ngTablePagination.$inject = ['$compile', '$document', 'ngTableEventsChannel'];
	            /**
	             * Directive that renders the table pagination controls
	             * @ngdoc directive
	             */
	            function ngTablePagination($compile, $document, ngTableEventsChannel) {
	                return {
	                    restrict: 'A',
	                    scope: {
	                        'params': '=ngTablePagination',
	                        'templateUrl': '='
	                    },
	                    replace: false,
	                    link: function link(scope, element /*, attrs*/) {
	                        ngTableEventsChannel.onAfterReloadData(function (pubParams) {
	                            scope.pages = pubParams.generatePagesArray();
	                        }, scope, function (pubParams) {
	                            return pubParams === scope.params;
	                        });
	                        scope.$watch('templateUrl', function (templateUrl) {
	                            if (templateUrl === undefined) {
	                                return;
	                            }
	                            var template = ng1.element('<div ng-include="templateUrl"></div>', $document);
	                            element.append(template);
	                            $compile(template)(scope);
	                        });
	                    }
	                };
	            }
	            exports.ngTablePagination = ngTablePagination;
	
	            /***/
	        },
	        /* 24 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************************!*\
	          !*** ./src/browser/ngTableSelectFilterDs.directive.ts ***!
	          \********************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            ngTableSelectFilterDs.$inject = [];
	            /**
	             * Takes the array returned by $column.filterData and makes it available as `$selectData` on the `$scope`.
	             *
	             * The resulting `$selectData` array will contain an extra item that is suitable to represent the user
	             * "deselecting" an item from a `<select>` tag
	             *
	             * This directive is is focused on providing a datasource to an `ngOptions` directive
	             */
	            function ngTableSelectFilterDs() {
	                // note: not using isolated or child scope "by design"
	                // this is to allow this directive to be combined with other directives that do
	                var directive = {
	                    restrict: 'A',
	                    controller: NgTableSelectFilterDsController
	                };
	                return directive;
	            }
	            exports.ngTableSelectFilterDs = ngTableSelectFilterDs;
	            /**
	             * @private
	             */
	            var NgTableSelectFilterDsController = function () {
	                function NgTableSelectFilterDsController($scope, $parse, $attrs, $q) {
	                    var _this = this;
	                    this.$scope = $scope;
	                    this.$attrs = $attrs;
	                    this.$q = $q;
	                    this.$column = $parse($attrs.ngTableSelectFilterDs)($scope);
	                    $scope.$watch(function () {
	                        return _this.$column && _this.$column.data;
	                    }, function () {
	                        _this.bindDataSource();
	                    });
	                }
	                NgTableSelectFilterDsController.prototype.bindDataSource = function () {
	                    var _this = this;
	                    this.getSelectListData(this.$column).then(function (data) {
	                        if (data && !_this.hasEmptyOption(data)) {
	                            // data.unshift({ value: '', name: 'Seleccione' });
	                        }
	                        data = data || [];
	                        _this.$scope.$selectData = data;
	                    });
	                };
	                NgTableSelectFilterDsController.prototype.hasEmptyOption = function (data) {
	                    var isMatch;
	                    for (var i = 0; i < data.length; i++) {
	                        var item = data[i];
	                        if (item && item.id === '') {
	                            isMatch = true;
	                            break;
	                        }
	                    }
	                    return isMatch;
	                };
	                NgTableSelectFilterDsController.prototype.getSelectListData = function ($column) {
	                    var dataInput = $column.data;
	                    if (dataInput instanceof Array) {
	                        return this.$q.when(dataInput);
	                    } else {
	                        return this.$q.when(dataInput && dataInput());
	                    }
	                };
	                NgTableSelectFilterDsController.$inject = ['$scope', '$parse', '$attrs', '$q'];
	                return NgTableSelectFilterDsController;
	            }();
	            exports.NgTableSelectFilterDsController = NgTableSelectFilterDsController;
	
	            /***/
	        },
	        /* 25 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableSorterRow.directive.ts ***!
	          \***************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var templateUrl = __webpack_require__( /*! ./sorterRow.html */50);
	            ngTableSorterRow.$inject = [];
	            /**
	             * directive that renders the sorting header row for a table
	             * @ngdoc directive
	             * @example
	             * ```html
	             * <ng-table-sorter-row></ng-table-sorter-row>
	             * ```
	             */
	            function ngTableSorterRow() {
	                var directive = {
	                    restrict: 'E',
	                    replace: true,
	                    templateUrl: templateUrl,
	                    scope: true,
	                    controller: 'ngTableSorterRowController',
	                    controllerAs: '$ctrl'
	                };
	                return directive;
	            }
	            exports.ngTableSorterRow = ngTableSorterRow;
	
	            /***/
	        },
	        /* 26 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableSorterRowController.ts ***!
	          \***************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	            /**
	             * Controller for the {@link ngTableSorterRow ngTableSorterRow} directive
	             */
	
	            var NgTableSorterRowController = function () {
	                function NgTableSorterRowController($scope) {
	                    this.$scope = $scope;
	                }
	                NgTableSorterRowController.prototype.sortBy = function ($column, event) {
	                    var parsedSortable = $column.sortable && $column.sortable();
	                    if (!parsedSortable || typeof parsedSortable !== 'string') {
	                        return;
	                    } else {
	                        var defaultSort = this.$scope.params.settings().defaultSort;
	                        var inverseSort = defaultSort === 'asc' ? 'desc' : 'asc';
	                        var sorting = this.$scope.params.sorting() && this.$scope.params.sorting()[parsedSortable] && this.$scope.params.sorting()[parsedSortable] === defaultSort;
	                        var sortingParams = event.ctrlKey || event.metaKey ? this.$scope.params.sorting() : {};
	                        sortingParams[parsedSortable] = sorting ? inverseSort : defaultSort;
	                        this.$scope.params.parameters({
	                            sorting: sortingParams
	                        });
	                    }
	                };
	                NgTableSorterRowController.$inject = ['$scope'];
	                return NgTableSorterRowController;
	            }();
	            exports.NgTableSorterRowController = NgTableSorterRowController;
	
	            /***/
	        },
	        /* 27 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/browser/public-interfaces.ts ***!
	          \******************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 28 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/core/data/dataSettings.ts ***!
	          \***************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 29 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************!*\
	          !*** ./src/core/data/getData.ts ***!
	          \**********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 30 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************!*\
	          !*** ./src/core/data/interceptor.ts ***!
	          \**************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 31 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************************!*\
	          !*** ./src/core/data/ngTableDefaultGetData.ts ***!
	          \************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * Implementation of the {@link IDefaultGetDataProvider} interface
	             */
	            var NgTableDefaultGetDataProvider = function () {
	                function NgTableDefaultGetDataProvider() {
	                    /**
	                     * The name of a angular filter that knows how to apply the values returned by
	                     * `NgTableParams.filter()` to restrict an array of data.
	                     * (defaults to the angular `filter` filter service)
	                     */
	                    this.filterFilterName = 'filter';
	                    /**
	                     * The name of a angular filter that knows how to apply the values returned by
	                    * `NgTableParams.orderBy()` to sort an array of data.
	                    * (defaults to the angular `orderBy` filter service)
	                    */
	                    this.sortingFilterName = 'orderBy';
	                    var provider = this;
	                    this.$get = ngTableDefaultGetData;
	                    ngTableDefaultGetData.$inject = ['$filter', 'ngTableEventsChannel'];
	                    function ngTableDefaultGetData($filter, ngTableEventsChannel) {
	                        var defaultDataOptions = { applyFilter: true, applySort: true, applyPaging: true };
	                        getData.applyPaging = applyPaging;
	                        getData.getFilterFn = getFilterFn;
	                        getData.getOrderByFn = getOrderByFn;
	                        return getData;
	                        function getFilterFn(params) {
	                            var filterOptions = params.settings().filterOptions;
	                            if (ng1.isFunction(filterOptions.filterFn)) {
	                                return filterOptions.filterFn;
	                            } else {
	                                return $filter(filterOptions.filterFilterName || provider.filterFilterName);
	                            }
	                        }
	                        function getOrderByFn(params) {
	                            return $filter(provider.sortingFilterName);
	                        }
	                        function applyFilter(data, params) {
	                            if (!params.hasFilter()) {
	                                return data;
	                            }
	                            var filter = params.filter(true);
	                            var filterKeys = Object.keys(filter);
	                            var parsedFilter = filterKeys.reduce(function (result, key) {
	                                result = setPath(result, filter[key], key);
	                                return result;
	                            }, {});
	                            var filterFn = getFilterFn(params);
	                            return filterFn.call(params, data, parsedFilter, params.settings().filterOptions.filterComparator);
	                        }
	                        function applyPaging(data, params) {
	                            var pagedData = data.slice((params.page() - 1) * params.count(), params.page() * params.count());
	                            params.total(data.length); // set total for recalc pagination
	                            return pagedData;
	                        }
	                        function applySort(data, params) {
	                            var orderBy = params.orderBy();
	                            var orderByFn = getOrderByFn(params);
	                            return orderBy.length ? orderByFn(data, orderBy) : data;
	                        }
	                        function getData(data, params) {
	                            if (data == null) {
	                                return [];
	                            }
	                            var options = ng1.extend({}, defaultDataOptions, params.settings().dataOptions);
	                            var fData = options.applyFilter ? applyFilter(data, params) : data;
	                            ngTableEventsChannel.publishAfterDataFiltered(params, fData);
	                            var orderedData = options.applySort ? applySort(fData, params) : fData;
	                            ngTableEventsChannel.publishAfterDataSorted(params, orderedData);
	                            return options.applyPaging ? applyPaging(orderedData, params) : orderedData;
	                        }
	                        // Sets the value at any depth in a nested object based on the path
	                        // note: adapted from: underscore-contrib#setPath
	                        function setPath(obj, value, path) {
	                            var keys = path.split('.');
	                            var ret = obj;
	                            var lastKey = keys[keys.length - 1];
	                            var target = ret;
	                            var parentPathKeys = keys.slice(0, keys.length - 1);
	                            parentPathKeys.forEach(function (key) {
	                                if (!target.hasOwnProperty(key)) {
	                                    target[key] = {};
	                                }
	                                target = target[key];
	                            });
	                            target[lastKey] = value;
	                            return ret;
	                        }
	                    }
	                }
	                return NgTableDefaultGetDataProvider;
	            }();
	            exports.NgTableDefaultGetDataProvider = NgTableDefaultGetDataProvider;
	
	            /***/
	        },
	        /* 32 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************!*\
	          !*** ./src/core/data/results.ts ***!
	          \**********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 33 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************************!*\
	          !*** ./src/core/filtering/filterComparator.ts ***!
	          \************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 34 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/core/filtering/filterFunc.ts ***!
	          \******************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 35 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************************!*\
	          !*** ./src/core/filtering/filterSettings.ts ***!
	          \**********************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 36 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************!*\
	          !*** ./src/core/filtering/index.ts ***!
	          \*************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./filterComparator */33));
	            __export(__webpack_require__( /*! ./filterFunc */34));
	            __export(__webpack_require__( /*! ./filterSettings */35));
	
	            /***/
	        },
	        /* 37 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************!*\
	          !*** ./src/core/grouping/index.ts ***!
	          \************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./getGroup */4));
	            __export(__webpack_require__( /*! ./groupingFunc */6));
	            __export(__webpack_require__( /*! ./groupSettings */5));
	            __export(__webpack_require__( /*! ./ngTableDefaultGetGroups */38));
	
	            /***/
	        },
	        /* 38 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************************!*\
	          !*** ./src/core/grouping/ngTableDefaultGetGroups.ts ***!
	          \******************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var util_1 = __webpack_require__( /*! ../util */11);
	            ngTableDefaultGetGroups.$inject = ['$q', 'ngTableDefaultGetData'];
	            /**
	             * Implementation of the {@link IDefaultGetData IDefaultGetData} interface
	             *
	             * @ngdoc service
	             */
	            function ngTableDefaultGetGroups($q, ngTableDefaultGetData) {
	                return getGroups;
	                function getGroups(params) {
	                    var group = params.group();
	                    var groupFn;
	                    var sortDirection = undefined;
	                    if (util_1.isGroupingFun(group)) {
	                        groupFn = group;
	                        sortDirection = group.sortDirection;
	                    } else {
	                        // currently support for only one group implemented
	                        var groupField_1 = Object.keys(group)[0];
	                        sortDirection = group[groupField_1];
	                        groupFn = function groupFn(item) {
	                            return getPath(item, groupField_1);
	                        };
	                    }
	                    var settings = params.settings();
	                    var originalDataOptions = settings.dataOptions;
	                    settings.dataOptions = { applyPaging: false };
	                    var getData = settings.getData;
	                    var gotData = $q.when(getData(params));
	                    return gotData.then(function (data) {
	                        var groups = {};
	                        ng1.forEach(data, function (item) {
	                            var groupName = groupFn(item);
	                            groups[groupName] = groups[groupName] || {
	                                data: [],
	                                $hideRows: !settings.groupOptions.isExpanded,
	                                value: groupName
	                            };
	                            groups[groupName].data.push(item);
	                        });
	                        var result = [];
	                        for (var i in groups) {
	                            result.push(groups[i]);
	                        }
	                        if (sortDirection) {
	                            var orderByFn = ngTableDefaultGetData.getOrderByFn();
	                            var orderBy = util_1.convertSortToOrderBy({
	                                value: sortDirection
	                            });
	                            result = orderByFn(result, orderBy);
	                        }
	                        return ngTableDefaultGetData.applyPaging(result, params);
	                    }).finally(function () {
	                        // restore the real options
	                        settings.dataOptions = originalDataOptions;
	                    });
	                }
	            }
	            exports.ngTableDefaultGetGroups = ngTableDefaultGetGroups;
	            /**
	             * @private
	             */
	            function getPath(obj, ks) {
	                // origianl source https://github.com/documentcloud/underscore-contrib
	                var keys;
	                if (typeof ks === "string") {
	                    keys = ks.split(".");
	                } else {
	                    keys = ks;
	                }
	                // If we have reached an undefined property
	                // then stop executing and return undefined
	                if (obj === undefined) return void 0;
	                // If the path array has no more elements, we've reached
	                // the intended property and return its value
	                if (keys.length === 0) return obj;
	                // If we still have elements in the path array and the current
	                // value is null, stop executing and return undefined
	                if (obj === null) return void 0;
	                return getPath(obj[keys[0]], keys.slice(1));
	            }
	
	            /***/
	        },
	        /* 39 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************!*\
	          !*** ./src/core/grouping/publicExports.ts ***!
	          \********************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./getGroup */4));
	            __export(__webpack_require__( /*! ./groupingFunc */6));
	            __export(__webpack_require__( /*! ./groupSettings */5));
	
	            /***/
	        },
	        /* 40 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************!*\
	          !*** ./src/core/paging/index.ts ***!
	          \**********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 41 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***********************************!*\
	          !*** ./src/core/sorting/index.ts ***!
	          \***********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 42 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************!*\
	          !*** ./src/browser/filterRow.html ***!
	          \************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filterRow.html';
	            var html = "<tr ng-show=\"show_filter\" class=\"ng-table-filters\">\n    <th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=\"$column.show(this)\" class=\"filter {{$column.class(this)}}\"\n        ng-class=\"params.settings().filterOptions.filterLayout === 'horizontal' ? 'filter-horizontal' : ''\">\n        <div ng-repeat=\"(name, filter) in $column.filter(this)\" ng-include=\"$ctrl.config.getTemplateUrl(filter)\" class=\"filter-cell\"\n             ng-class=\"[$ctrl.getFilterCellCss($column.filter(this), params.settings().filterOptions.filterLayout), $last ? 'last' : '']\">\n        </div>\n    </th>\n</tr>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 43 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*****************************************!*\
	          !*** ./src/browser/filters/number.html ***!
	          \*****************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/number.html';
	            var html = "<input type=\"number\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"\n       placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 44 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************************!*\
	          !*** ./src/browser/filters/select-multiple.html ***!
	          \**************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/select-multiple.html';
	            var html = "<select ng-options=\"data.value as data.name for data in $column.data\"\n        ng-disabled=\"$filterRow.disabled\"\n        multiple ng-multiple=\"true\"\n        ng-model=\"params.filter()[name]\"\n        class=\"filter filter-select-multiple form-control\" name=\"{{name}}\">\n</select>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 45 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*****************************************!*\
	          !*** ./src/browser/filters/select.html ***!
	          \*****************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/select.html';
	            var html = "<select ng-options=\"data.value as data.name for data in $selectData\"\n        ng-table-select-filter-ds=\"$column\"\n        ng-disabled=\"$filterRow.disabled\"\n        ng-model=\"params.filter()[name]\"\n        class=\"filter filter-select form-control\" name=\"{{name}}\">\n    <option value=\"\">TODOS</option>\n</select>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 46 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/browser/filters/text.html ***!
	          \***************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/text.html';
	            var html = "<input type=\"text\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"\n       placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 47 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***********************************!*\
	          !*** ./src/browser/groupRow.html ***!
	          \***********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/groupRow.html';
	            var html = "<tr ng-if=\"params.hasGroup()\" ng-show=\"$groupRow.show\" class=\"ng-table-group-header\">\n    <th colspan=\"{{$ctrl.getVisibleColumns().length}}\" class=\"sortable\" ng-class=\"{\n                    'sort-asc': params.hasGroup($selGroup, 'asc'),\n                    'sort-desc':params.hasGroup($selGroup, 'desc')\n                  }\">\n        <a href=\"\" ng-click=\"isSelectorOpen = !isSelectorOpen\" class=\"ng-table-group-selector\">\n            <strong class=\"sort-indicator\">{{$selGroupTitle}}</strong>\n            <button class=\"btn btn-default btn-xs ng-table-group-close\"\n                    ng-click=\"$groupRow.show = false; $event.preventDefault(); $event.stopPropagation();\">\n                <span class=\"glyphicon glyphicon-remove\"></span>\n            </button>\n            <button class=\"btn btn-default btn-xs ng-table-group-toggle\"\n                    ng-click=\"$ctrl.toggleDetail(); $event.preventDefault(); $event.stopPropagation();\">\n                <span class=\"glyphicon\" ng-class=\"{\n                    'glyphicon-resize-small': params.settings().groupOptions.isExpanded,\n                    'glyphicon-resize-full': !params.settings().groupOptions.isExpanded\n                }\"></span>\n            </button>\n        </a>\n        <div class=\"list-group\" ng-if=\"isSelectorOpen\">\n            <a href=\"\" class=\"list-group-item\" ng-repeat=\"group in $ctrl.getGroupables()\" ng-click=\"$ctrl.groupBy(group)\">\n                <strong>{{ $ctrl.getGroupTitle(group)}}</strong>\n                <strong ng-class=\"$ctrl.isSelectedGroup(group) && 'sort-indicator'\"></strong>\n            </a>\n        </div>\n    </th>\n</tr>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 48 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*********************************!*\
	          !*** ./src/browser/header.html ***!
	          \*********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/header.html';
	            var html = "<ng-table-group-row></ng-table-group-row>\n<ng-table-sorter-row></ng-table-sorter-row>\n<ng-table-filter-row></ng-table-filter-row>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 49 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************!*\
	          !*** ./src/browser/pager.html ***!
	          \********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/pager.html';
	            var html = "<div class=\"ng-cloak ng-table-pager\" ng-if=\"params.data.length\">\n    <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n        <button ng-repeat=\"count in params.settings().counts\" type=\"button\"\n                ng-class=\"{'active':params.count() == count}\"\n                ng-click=\"params.count(count)\" class=\"btn btn-default\">\n            <span ng-bind=\"count\"></span>\n        </button>\n    </div>\n    <ul ng-if=\"pages.length\" class=\"pagination ng-table-pagination\">\n        <li class=\"page-item\" ng-class=\"{'disabled': !page.active && !page.current, 'active': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n            <a class=\"page-link\" ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">&laquo;</a>\n            <a class=\"page-link\" ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n            <a class=\"page-link\" ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">&raquo;</a>\n        </li>\n    </ul>\n</div>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 50 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************!*\
	          !*** ./src/browser/sorterRow.html ***!
	          \************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/sorterRow.html';
	            var html = "<tr class=\"ng-table-sort-header\">\n    <th title=\"{{$column.headerTitle(this)}}\"\n        ng-repeat=\"$column in $columns\"\n        ng-class=\"{\n                    'sortable': $column.sortable(this),\n                    'sort-asc': params.sorting()[$column.sortable(this)]=='asc',\n                    'sort-desc': params.sorting()[$column.sortable(this)]=='desc'\n                  }\"\n        ng-click=\"$ctrl.sortBy($column, $event)\"\n        ng-if=\"$column.show(this)\"\n        ng-init=\"template = $column.headerTemplateURL(this)\"\n        class=\"header {{$column.class(this)}}\">\n        <div ng-if=\"!template\" class=\"ng-table-header\" ng-class=\"{'sort-indicator': params.settings().sortingIndicator == 'div'}\">\n            <span ng-bind=\"$column.title(this)\" ng-class=\"{'sort-indicator': params.settings().sortingIndicator == 'span'}\"></span>\n        </div>\n        <div ng-if=\"template\" ng-include=\"template\"></div>\n    </th>\n</tr>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 51 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************!*\
	          !*** ./index.ts ***!
	          \******************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            var ng1 = __webpack_require__( /*! angular */0);
	            var core_1 = __webpack_require__( /*! ./src/core */1);
	            var browser_1 = __webpack_require__( /*! ./src/browser */2);
	            var ngTableModule = ng1.module('ngTable', [core_1.ngTableCoreModule.name, browser_1.ngTableBrowserModule.name]);
	            exports.ngTableModule = ngTableModule;
	            __export(__webpack_require__( /*! ./src/core */1));
	            __export(__webpack_require__( /*! ./src/browser */2));
	
	            /***/
	        },
	        /* 52 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/browser/filters/hidden.html ***!
	          \***************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/hidden.html';
	            var html = "<input type=\"hidden\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"/>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        }
	        /******/])
	    );
	});
	//# sourceMappingURL=ng-table.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)(module)))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pdfViewer = __webpack_require__(668);
	
	var _pdfViewer2 = _interopRequireDefault(_pdfViewer);
	
	var _pdfViewer3 = __webpack_require__(705);
	
	var _pdfViewer4 = _interopRequireDefault(_pdfViewer3);
	
	__webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PdfViewerComponent = {
	  bindings: {
	    scale: '@',
	    page: '@',
	    height: '@',
	    download: '@',
	    print: '@',
	    open: '@',
	    name: '@',
	    base64: '<',
	    data: '<',
	    url: '@'
	  },
	  controller: _pdfViewer2.default,
	  template: _pdfViewer4.default
	};
	
	exports.default = PdfViewerComponent;

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PdfViewerController = function () {
	  PdfViewerController.$inject = ["$q", "$scope", "$http", "Storage"];
	  function PdfViewerController($q, $scope, $http, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, PdfViewerController);
	
	    this.defer = $q.defer();
	    this.$scope = $scope;
	    this.$http = $http;
	    this.Storage = Storage;
	  }
	
	  _createClass(PdfViewerController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      // atob() is used to convert base64 encoded PDF to binary-like data.
	      // (See also https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/
	      // Base64_encoding_and_decoding.)}
	
	
	      this.base64Data = 'JVBERi0xLjcKCjEgMCBvYmogICUgZW50cnkgcG9pbnQKPDwKICAvVHlwZSAvQ2F0YWxvZwog' + 'IC9QYWdlcyAyIDAgUgo+PgplbmRvYmoKCjIgMCBvYmoKPDwKICAvVHlwZSAvUGFnZXMKICAv' + 'TWVkaWFCb3ggWyAwIDAgMjAwIDIwMCBdCiAgL0NvdW50IDEKICAvS2lkcyBbIDMgMCBSIF0K' + 'Pj4KZW5kb2JqCgozIDAgb2JqCjw8CiAgL1R5cGUgL1BhZ2UKICAvUGFyZW50IDIgMCBSCiAg' + 'L1Jlc291cmNlcyA8PAogICAgL0ZvbnQgPDwKICAgICAgL0YxIDQgMCBSIAogICAgPj4KICA+' + 'PgogIC9Db250ZW50cyA1IDAgUgo+PgplbmRvYmoKCjQgMCBvYmoKPDwKICAvVHlwZSAvRm9u' + 'dAogIC9TdWJ0eXBlIC9UeXBlMQogIC9CYXNlRm9udCAvVGltZXMtUm9tYW4KPj4KZW5kb2Jq' + 'Cgo1IDAgb2JqICAlIHBhZ2UgY29udGVudAo8PAogIC9MZW5ndGggNDQKPj4Kc3RyZWFtCkJU' + 'CjcwIDUwIFRECi9GMSAxMiBUZgooSGVsbG8sIHdvcmxkISkgVGoKRVQKZW5kc3RyZWFtCmVu' + 'ZG9iagoKeHJlZgowIDYKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDEwIDAwMDAwIG4g' + 'CjAwMDAwMDAwNzkgMDAwMDAgbiAKMDAwMDAwMDE3MyAwMDAwMCBuIAowMDAwMDAwMzAxIDAw' + 'MDAwIG4gCjAwMDAwMDAzODAgMDAwMDAgbiAKdHJhaWxlcgo8PAogIC9TaXplIDYKICAvUm9v' + 'dCAxIDAgUgo+PgpzdGFydHhyZWYKNDkyCiUlRU9G';
	
	      // For Base64 files
	      // this.pdfUrl = {
	      //   data: atob(this.base64Data)
	      // };
	
	      // TODO Falta implementar print y download
	      // Url files
	      // this.pdfUrl = '//cdn.mozilla.net/pdfjs/tracemonkey.pdf';
	
	      // TODO Opciones todavia no probadas. Falta implementar print y download
	      // withCredentials
	      // this.pdfUrl = {
	      //   'url': '//cdn.mozilla.net/pdfjs/tracemonkey.pdf',
	      //   'method': 'POST',
	      //   'withCredentials': false,
	      //   'httpHeaders': { 'Authorization': 'Bearer some-aleatory-token' }
	      // };
	      // this.base64 = this.base64Data;
	      // if(this.pdfUrl) {
	      //   this.pdfUrl = '//cdn.mozilla.net/pdfjs/tracemonkey.pdf';
	      // }
	      if (this.base64) {
	        this.pdfBase64 = this.base64;
	      }
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      // if(this.base64) {
	      //   this.pdfBase64 = this.base64;
	      // }
	      if (this.data) {
	        if (this.data.method == 'POST') {
	          var config = {
	            responseType: 'arraybuffer'
	          };
	          if (this.Storage.get('token')) {
	            config.headers = {
	              'Authorization': this.Storage.get('token')
	            };
	          }
	          this.data.urlDownload = this.data.url;
	          this.$http.post(this.data.urlDownload, {}, config).then(function (resp) {
	            if (resp && resp.data) {
	              var file = new window.Blob([resp.data], { type: 'application/pdf' });
	              _this.data.url = window.URL.createObjectURL(file);
	              _this.pdfUrl = _this.data;
	            }
	          }).catch(function (error) {});
	        } else {
	          this.pdfUrl = this.data;
	        }
	      }
	      this.$scope.$watch(function () {
	        _this.heightPdfContainer = parseInt(_this.height, 10) - 32 + 'px';
	        angular.element(document.querySelectorAll('.ng-pdf-container')).css('max-height', _this.heightPdfContainer);
	      });
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      var ngPrintFile = document.getElementById('print-ng-pdf-container');
	      ngPrintFile.parentNode.removeChild(ngPrintFile);
	    }
	  }]);
	
	  return PdfViewerController;
	}();
	
	exports.default = PdfViewerController;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _pdfViewer = __webpack_require__(667);
	
	var _pdfViewer2 = _interopRequireDefault(_pdfViewer);
	
	var _angularPdf = __webpack_require__(670);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PdfViewerModule = angular.module('app.pdf-viewer', []).component('pdfViewer', _pdfViewer2.default).directive('ngPdf', _angularPdf.NgPdf).name;
	
	exports.default = PdfViewerModule;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NgPdf = undefined;
	
	var _viewer = __webpack_require__(706);
	
	var _viewer2 = _interopRequireDefault(_viewer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NgPdf = exports.NgPdf = ["$window", "$document", "$http", "$log", "$sce", "$timeout", "$compile", function NgPdf($window, $document, $http, $log, $sce, $timeout, $compile) {
	  'ngInject';
	
	  var backingScale = function backingScale(canvas) {
	    var ctx = canvas.getContext('2d');
	    var dpr = $window.devicePixelRatio || 1;
	    var bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
	
	    return dpr / bsr;
	  };
	
	  var setCanvasDimensions = function setCanvasDimensions(canvas, w, h) {
	    var ratio = backingScale(canvas);
	    canvas.width = Math.floor(w * ratio);
	    canvas.height = Math.floor(h * ratio);
	    canvas.style.width = Math.floor(w) + 'px';
	    canvas.style.height = Math.floor(h) + 'px';
	    canvas.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0);
	    return canvas;
	  };
	
	  var initCanvas = function initCanvas(element, canvas, printCanvas) {
	    var divCanvas = $document[0].querySelector('.ng-pdf-container') ? $document[0].querySelector('.ng-pdf-container') : $document[0].createElement('div');
	    angular.element(divCanvas).addClass('ng-pdf-container');
	    angular.element(canvas).addClass('rotate0');
	    angular.element(divCanvas).append(canvas);
	    element.append(divCanvas);
	
	    var divCanvasPrint = document.querySelector('#print-ng-pdf-container') ? document.querySelector('#print-ng-pdf-container') : document.createElement('div');
	    divCanvasPrint.innerHTML = '';
	    angular.element(printCanvas).addClass('rotate0');
	    angular.element(divCanvasPrint).attr('id', 'print-ng-pdf-container').addClass('print-ng-pdf-container').append(printCanvas);
	    document.body.appendChild(divCanvasPrint);
	  };
	
	  return {
	    restrict: 'E',
	    template: _viewer2.default,
	    scope: {
	      data: '<',
	      data64: '<'
	    },
	    // templateUrl(element, attr) {
	    //   return attr.templateUrl ? attr.templateUrl : 'partials/viewer.html';
	    // },
	    link: function link(scope, element, attrs) {
	      var renderTask = null;
	      var pdfLoaderTask = null;
	      var debug = false;
	      var url = scope.pdfUrl;
	      var httpHeaders = scope.httpHeaders;
	      var pdfDoc = null;
	      var pageToDisplay = isFinite(attrs.page) ? parseInt(attrs.page) : 1;
	      var pageFit = attrs.scale === 'page-fit';
	      var limitHeight = attrs.limitcanvasheight === '1';
	      var scale = attrs.scale > 0 ? attrs.scale : 1;
	      var canvas = []; //$document[0].createElement('canvas');
	      var printCanvas = [];
	      var printCtx = [];
	      //let canvas = $document[0].createElement('canvas');
	      //initCanvas(element, canvas);
	      var creds = attrs.usecredentials;
	      debug = attrs.hasOwnProperty('debug') ? attrs.debug : false;
	
	      var ctx = [];
	      // let ctx = canvas.getContext('2d');
	      var windowEl = angular.element($window);
	
	      scope.download = attrs.download == 'true' ? true : false;
	      scope.print = attrs.print == 'true' ? true : false;
	      scope.name = attrs.name ? attrs.name : 'documento.pdf';
	      scope.pageLimit = 5; // Limite paginas para modo paginado.
	
	      element.css('display', 'block');
	
	      windowEl.on('scroll', function () {
	        scope.$apply(function () {
	          scope.scroll = windowEl[0].scrollY;
	        });
	      });
	
	      PDFJS.disableWorker = true;
	      scope.pageNum = pageToDisplay;
	
	      var printRenderPage = function printRenderPage(num) {
	        if (renderTask) {
	          renderTask._internalRenderTask.cancel();
	        }
	
	        pdfDoc.getPage(num).then(function (page) {
	          var pageWidthScale = void 0;
	          var printRenderContext = void 0;
	
	          //for print pages
	          var printViewport = page.getViewport(1);
	          printViewport = page.getViewport(2);
	          if (scope.pageLimit >= scope.pageCount) {
	            setCanvasDimensions(printCanvas[num - 1], printViewport.width, printViewport.height);
	            printRenderContext = {
	              canvasContext: printCtx[num - 1],
	              viewport: printViewport
	            };
	          } else {
	            setCanvasDimensions(printCanvas[0], printViewport.width, printViewport.height);
	            printRenderContext = {
	              canvasContext: printCtx[0],
	              viewport: printViewport
	            };
	          }
	          renderTask = page.render(printRenderContext);
	          renderTask.promise.then(function () {
	            if (angular.isFunction(scope.onPageRender)) {
	              scope.onPageRender();
	            }
	          }).catch(function (reason) {
	            $log.log(reason);
	          });
	        });
	      };
	
	      scope.renderPage = function (num) {
	        if (renderTask) {
	          renderTask._internalRenderTask.cancel();
	        }
	
	        pdfDoc.getPage(num).then(function (page) {
	          var viewport = void 0;
	          var pageWidthScale = void 0;
	          var renderContext = void 0;
	
	          if (pageFit) {
	            viewport = page.getViewport(1);
	            var clientRect = element[0].getBoundingClientRect();
	            pageWidthScale = clientRect.width / viewport.width - 0.1;
	            if (limitHeight) {
	              pageWidthScale = Math.min(pageWidthScale, clientRect.height / viewport.height);
	            }
	            scale = pageWidthScale;
	          }
	          viewport = page.getViewport(scale);
	
	          if (scope.pageLimit >= scope.pageCount) {
	            setCanvasDimensions(canvas[num - 1], viewport.width, viewport.height);
	            renderContext = {
	              canvasContext: ctx[num - 1],
	              viewport: viewport
	            };
	          } else {
	            setCanvasDimensions(canvas[0], viewport.width, viewport.height);
	            renderContext = {
	              canvasContext: ctx[0],
	              viewport: viewport
	            };
	          }
	
	          renderTask = page.render(renderContext);
	          renderTask.promise.then(function () {
	            if (angular.isFunction(scope.onPageRender)) {
	              scope.onPageRender();
	            }
	          }).catch(function (reason) {
	            $log.log(reason);
	          });
	        });
	      };
	
	      scope.goPrevious = function () {
	        if (scope.pageToDisplay <= 1) {
	          return;
	        }
	        scope.pageToDisplay = parseInt(scope.pageToDisplay) - 1;
	        scope.pageNum = scope.pageToDisplay;
	      };
	
	      scope.goNext = function () {
	        if (scope.pageToDisplay >= parseInt(pdfDoc.numPages)) {
	          return;
	        }
	        scope.pageToDisplay = parseInt(scope.pageToDisplay) + 1;
	        scope.pageNum = scope.pageToDisplay;
	      };
	
	      scope.zoomIn = function () {
	        pageFit = false;
	        if (parseFloat(scale) + 0.2 > 2.2) return scale;
	        scale = parseFloat(scale) + 0.2;
	        // scope.renderPage(scope.pageToDisplay);
	        var aux = void 0;
	        for (var i = 0; i < canvas.length; i++) {
	          scope.renderPage(i + 1);
	          if (canvas[i].getAttribute('class') === 'rotate90') {
	            aux = parseInt(canvas[i].style.width.replace('px', '')) - parseInt(canvas[i].style.height.replace('px', ''));
	            canvas[i].style.marginBottom = 48 + aux + 'px';
	          } else {
	            canvas[i].style.marginBottom = 8 + 'px';
	          }
	        }
	        return scale;
	      };
	
	      scope.zoomOut = function () {
	        pageFit = false;
	        if (parseFloat(scale) - 0.2 < 0.2) return scale;
	        scale = parseFloat(scale) - 0.2;
	        // scope.renderPage(scope.pageToDisplay);
	        var aux = void 0;
	        for (var i = 0; i < canvas.length; i++) {
	          scope.renderPage(i + 1);
	          if (canvas[i].getAttribute('class') === 'rotate90') {
	            aux = parseInt(canvas[i].style.width.replace('px', '')) - parseInt(canvas[i].style.height.replace('px', ''));
	            canvas[i].style.marginBottom = aux + 'px';
	          } else {
	            canvas[i].style.marginBottom = 16 + 'px';
	          }
	        }
	        return scale;
	      };
	
	      scope.fit = function () {
	        pageFit = true;
	        // scope.renderPage(scope.pageToDisplay);
	        for (var i = 0; i < canvas.length; i++) {
	          scope.renderPage(i + 1);
	        }
	      };
	
	      scope.changePage = function () {
	        scope.renderPage(scope.pageToDisplay);
	      };
	
	      scope.rotate = function () {
	        var aux = void 0;
	        for (var i = 0; i < canvas.length; i++) {
	          aux = parseInt(canvas[i].style.width.replace('px', '')) - parseInt(canvas[i].style.height.replace('px', ''));
	          if (canvas[i].getAttribute('class') === 'rotate0') {
	            canvas[i].setAttribute('class', 'rotate90');
	            canvas[i].style.marginBottom = 16 + aux + 'px';
	          } else if (canvas[i].getAttribute('class') === 'rotate90') {
	            canvas[i].setAttribute('class', 'rotate180');
	            canvas[i].style.marginBottom = 16 + 'px';
	          } else if (canvas[i].getAttribute('class') === 'rotate180') {
	            canvas[i].setAttribute('class', 'rotate270');
	            canvas[i].style.marginBottom = 16 + aux + 'px';
	          } else {
	            canvas[i].setAttribute('class', 'rotate0');
	            canvas[i].style.marginBottom = 16 + 'px';
	          }
	        }
	      };
	
	      scope.downloadFile = function () {
	        if (!scope.descargando) {
	          scope.descargando = true;
	          var a = document.createElement('a');
	          a.innerHTML = '.';
	          element.append(a);
	          $compile(a)(scope);
	          // Si se utiliza una dirección URL del archivo PDF
	          if (scope.data && scope.data.url) {
	            // a = document.getElementById('download_'+scope.name);
	            // Si es InternetExplorer PDF
	            if (window.navigator.msSaveBlob && scope.data.urlDownload) {
	              // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
	              $http.post(scope.data.urlDownload, {}, { responseType: 'arraybuffer' }).then(function (resp) {
	                if (resp.data) {
	                  var file = new window.Blob([resp.data], { type: 'application/pdf' });
	                  window.navigator.msSaveOrOpenBlob(file, scope.name || 'documento.pdf');
	                  scope.descargando = false;
	                }
	              }).catch(function (error) {
	                $log.log(error);
	              });
	              return;
	            }
	            if (scope.data.method != 'POST') {
	              // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
	              $http.get(scope.data.url, { responseType: 'arraybuffer' }).then(function (resp) {
	                if (resp) {
	                  var file = new window.Blob([new Uint8Array(resp.data)], { type: 'application/pdf' });
	                  if (window.navigator.msSaveBlob) {
	                    window.navigator.msSaveOrOpenBlob(file, scope.name || 'documento.pdf');
	                    scope.descargando = false;
	                  } else {
	                    // a.href = window.URL.createObjectURL(file);
	                    var base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(resp.data)));
	                    a.href = 'data:application/pdf;base64,' + base64String;
	                    a.download = scope.name || 'documento.pdf';
	                    a.target = '_blank';
	                    $timeout(function () {
	                      a.click();
	                      scope.descargando = false;
	                      angular.element(a).remove();
	                    }, 250);
	                  }
	                }
	              }).catch(function (error) {
	                $log.log(error);
	              });
	              return;
	            }
	            a.href = scope.data.url;
	            a.download = scope.name || 'documento.pdf';
	            a.target = '_blank';
	            $timeout(function () {
	              a.click();
	              scope.descargando = false;
	              angular.element(a).remove();
	            }, 250);
	            return;
	          }
	          // Para archivos en base 64.
	          var blob = b64toBlob(scope.data64.replace('data:application/pdf;base64,', ''), 'application/pdf');
	          if (window.navigator.msSaveBlob) {
	            // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
	            window.navigator.msSaveOrOpenBlob(blob, 'documento.pdf');
	            scope.descargando = false;
	          } else {
	            a.href = window.URL.createObjectURL(blob);
	            // a.href = 'data:application/pdf;base64,' + scope.data64;
	            a.download = scope.name || 'documento.pdf';
	            a.target = '_blank';
	            $timeout(function () {
	              a.click();
	              scope.descargando = false;
	            }, 250);
	          }
	        }
	      };
	
	      scope.printFile = function () {
	        window.print();
	      };
	
	      scope.printFileUrl = function () {
	        var documento = void 0;
	        // let blob = new Blob([scope.data.data], { type: 'application/pdf' });
	        // let objectURL = window.URL.createObjectURL(blob, { type: "application/pdf" });
	        if (scope.data && scope.data.url) {
	          documento = window.open(scope.data.url);
	          documento.onload = function () {
	            documento.print();
	          };
	        } else {
	          var blob = b64toBlob(scope.data64.replace('data:application/pdf;base64,', ''), 'application/pdf');
	          documento = $window.open(window.URL.createObjectURL(blob));
	          documento.onload = function () {
	            documento.print();
	          };
	        }
	        // var documento = $window.open( $sce.trustAsResourceUrl(objectURL) );
	      };
	
	      scope.detectIE = function () {
	        var ua = window.navigator.userAgent;
	        // Test values; Uncomment to check result …
	        // IE 10
	        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
	        // IE 11
	        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
	        // Edge 12 (Spartan)
	        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
	        // Edge 13
	        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
	        var msie = ua.indexOf('MSIE ');
	        if (msie > 0) {
	          // IE 10 or older => return version number
	          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	        }
	        var trident = ua.indexOf('Trident/');
	        if (trident > 0) {
	          // IE 11 => return version number
	          var rv = ua.indexOf('rv:');
	          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	        }
	        var edge = ua.indexOf('Edge/');
	        if (edge > 0) {
	          // Edge (IE 12+) => return version number
	          return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	        }
	        // other browser
	        return false;
	      };
	      /**
	       * Determine the mobile operating system.
	       * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
	       *
	       * @returns {String}
	       */
	      scope.getMobileOS = function () {
	        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	        // Windows Phone must come first because its UA also contains "Android"
	        if (/windows phone/i.test(userAgent)) {
	          return 'Windows Phone';
	        }
	        if (/android/i.test(userAgent)) {
	          return 'Android';
	        }
	        // iOS detection from: http://stackoverflow.com/a/9039885/177710
	        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	          return 'iOS';
	        }
	        return false;
	      };
	
	      /**
	       * b64toBlob - Convert base64 string to a Blob object
	       *
	       * @param  {string}  b64Data     Base64 string
	       * @param  {strig}   contentType Type of base64 file
	       * @param  {integer} sliceSize   Slice for performance
	       * @return {Blob}                Blob object
	       * @description https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
	       */
	      function b64toBlob(b64Data, contentType, sliceSize) {
	        contentType = contentType || '';
	        sliceSize = sliceSize || 512;
	
	        var byteCharacters = atob(b64Data);
	        var byteArrays = [];
	
	        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	          var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	          var byteNumbers = new Array(slice.length);
	          for (var i = 0; i < slice.length; i++) {
	            byteNumbers[i] = slice.charCodeAt(i);
	          }
	
	          var byteArray = new Uint8Array(byteNumbers);
	
	          byteArrays.push(byteArray);
	        }
	
	        var blob = new Blob(byteArrays, { type: contentType });
	        return blob;
	      }
	
	      function clearCanvas() {
	        for (var i = 0; i < ctx.length; i++) {
	          ctx[i].clearRect(0, 0, canvas[i].width, canvas[i].height);
	        }
	      }
	
	      function renderPDF() {
	        clearCanvas();
	
	        var params = void 0;
	        // let params = {
	        //   'url': url,
	        //   'withCredentials': creds
	        // };
	
	        if (httpHeaders) {
	          params.httpHeaders = httpHeaders;
	        }
	
	        if (scope.data) {
	          params = scope.data;
	        }
	
	        if (scope.data64) {
	          params = {
	            data: atob(scope.data64.replace('data:application/pdf;base64,', ''))
	          };
	        }
	
	        //if (url && url.length) {
	        if (params) {
	          $timeout(function () {
	            pdfLoaderTask = PDFJS.getDocument(params);
	            pdfLoaderTask.onProgress = scope.onProgress;
	            pdfLoaderTask.onPassword = scope.onPassword;
	            pdfLoaderTask.then(function (_pdfDoc) {
	              if (angular.isFunction(scope.onLoad)) {
	                scope.onLoad();
	              }
	
	              pdfDoc = _pdfDoc;
	              // scope.renderPage(scope.pageToDisplay);
	              //
	              var num = void 0,
	                  cant = void 0;
	              if (scope.pageLimit >= pdfDoc.numPages) {
	                num = 1;
	                cant = pdfDoc.numPages;
	              } else {
	                num = scope.pageToDisplay;
	                cant = parseInt(scope.pageToDisplay) || pdfDoc.numPages;
	              }
	              //for(var num = 1; num <= pdfDoc.numPages; num++) {
	              for (; num <= cant; num++) {
	                canvas.push($document[0].createElement('canvas'));
	                ctx[num - 1] = canvas[num - 1].getContext('2d');
	
	                printCanvas.push(document.createElement('canvas'));
	                printCtx[num - 1] = printCanvas[num - 1].getContext('2d');
	                initCanvas(element, canvas[num - 1], printCanvas);
	                scope.renderPage(num);
	                printRenderPage(num);
	              }
	
	              scope.$apply(function () {
	                scope.pageCount = _pdfDoc.numPages;
	              });
	            }, function (error) {
	              if (error) {
	                if (angular.isFunction(scope.onError)) {
	                  scope.onError(error);
	                }
	              }
	            });
	          }, 500);
	        }
	      }
	
	      scope.$watch('pageNum', function (newVal) {
	        if (pdfDoc && newVal > parseInt(pdfDoc.numPages)) {
	          newVal = pdfDoc.numPages;
	          scope.pageNum = pdfDoc.numPages;
	        }
	        if (newVal < 1) {
	          newVal = 1;
	          scope.pageNum = 1;
	        }
	        scope.pageToDisplay = parseInt(newVal);
	        if (pdfDoc !== null) {
	          scope.renderPage(scope.pageToDisplay);
	          printRenderPage(scope.pageToDisplay);
	        }
	      });
	
	      scope.$watch('data', function (newVal) {
	        if (newVal && newVal !== '') {
	          if (debug) {
	            $log.log('data change detected: ', scope.data);
	          }
	          url = newVal;
	          scope.pageNum = scope.pageToDisplay = pageToDisplay;
	          if (pdfLoaderTask) {
	            pdfLoaderTask.destroy().then(function () {
	              renderPDF();
	            });
	          } else {
	            renderPDF();
	          }
	        }
	      });
	
	      scope.$watch('data64', function (newVal) {
	        if (newVal && newVal !== '') {
	          if (debug) {
	            $log.log('data64 change detected: ', scope.data64);
	          }
	          url = newVal;
	          scope.pageNum = scope.pageToDisplay = pageToDisplay;
	          if (pdfLoaderTask) {
	            pdfLoaderTask.destroy().then(function () {
	              renderPDF();
	            });
	          } else {
	            renderPDF();
	          }
	        }
	      });
	
	      scope.$on('downloadFile', function () {
	        scope.downloadFile();
	      });
	
	      scope.$on('printFile', function () {
	        scope.printFile();
	      });
	    }
	  };
	}];
	/**
	 * Thanks to:
	 * https://github.com/sayanee/angularjs-pdf
	 */

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Cargando elementos de bootstrap que se usarán en el sistema
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _datepicker = __webpack_require__(613);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _datepickerPopup = __webpack_require__(615);
	
	var _datepickerPopup2 = _interopRequireDefault(_datepickerPopup);
	
	var _dropdown = __webpack_require__(619);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _accordion = __webpack_require__(603);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _alert = __webpack_require__(605);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _buttons = __webpack_require__(607);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	var _modal = __webpack_require__(623);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _popover = __webpack_require__(627);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _tabs = __webpack_require__(635);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _timepicker = __webpack_require__(638);
	
	var _timepicker2 = _interopRequireDefault(_timepicker);
	
	var _tooltip = __webpack_require__(640);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _pdfViewer = __webpack_require__(669);
	
	var _pdfViewer2 = _interopRequireDefault(_pdfViewer);
	
	var _imageViewer = __webpack_require__(665);
	
	var _imageViewer2 = _interopRequireDefault(_imageViewer);
	
	var _progressbar = __webpack_require__(630);
	
	var _progressbar2 = _interopRequireDefault(_progressbar);
	
	var _waves = __webpack_require__(674);
	
	var _waves2 = _interopRequireDefault(_waves);
	
	var _formly = __webpack_require__(663);
	
	var _formly2 = _interopRequireDefault(_formly);
	
	var _angularChips = __webpack_require__(597);
	
	var _angularChips2 = _interopRequireDefault(_angularChips);
	
	var _angularNumericDirective = __webpack_require__(601);
	
	var _angularNumericDirective2 = _interopRequireDefault(_angularNumericDirective);
	
	var _angularLeaflet = __webpack_require__(599);
	
	var _angularLeaflet2 = _interopRequireDefault(_angularLeaflet);
	
	__webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vendor = angular.module('app.vendor', [_datepicker2.default, _datepickerPopup2.default, _dropdown2.default, _accordion2.default, _alert2.default, _buttons2.default, _modal2.default, _popover2.default, _tabs2.default, _timepicker2.default, _tooltip2.default, _waves2.default, _formly2.default, _angularChips2.default, _angularNumericDirective2.default, _angularLeaflet2.default, _imageViewer2.default, _pdfViewer2.default, _progressbar2.default]).name;
	
	exports.default = Vendor;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _waves = __webpack_require__(673);
	
	var _waves2 = _interopRequireDefault(_waves);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdEffect = function () {
	    function MdEffect() {
	        _classCallCheck(this, MdEffect);
	
	        this.restrict = 'A';
	    }
	
	    _createClass(MdEffect, [{
	        key: 'link',
	        value: function link($scope, $elem, $attr) {
	            var className = ['waves-light'];
	            if ($attr.mdEffect.length) {
	                var array = $attr.mdEffect.split(' ');
	                if (array.length > 1) {
	                    className = array;
	                } else {
	                    className = [$attr.mdEffect];
	                }
	            }
	            if ($attr.class.indexOf('btn-secondary') != -1 || $attr.class.indexOf('btn-default') != -1) {
	                className = [];
	            }
	            _waves2.default.attach($elem, className);
	            _waves2.default.init();
	        }
	    }]);
	
	    return MdEffect;
	}();
	
	exports.default = MdEffect;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Waves v0.7.5
	 * http://fian.my.id/Waves
	 *
	 * Copyright 2014-2016 Alfiana E. Sibuea and other contributors
	 * Released under the MIT license
	 * https://github.com/fians/Waves/blob/master/LICENSE
	 */
	
	;(function (window, factory) {
	    'use strict';
	
	    // AMD. Register as an anonymous module.  Wrap in function so we have access
	    // to root via `this`.
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return factory.apply(window);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	
	    // Node. Does not work with strict CommonJS, but only CommonJS-like
	    // environments that support module.exports, like Node.
	    else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	            module.exports = factory.call(window);
	        }
	
	        // Browser globals.
	        else {
	                window.Waves = factory.call(window);
	            }
	})((typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' ? global : undefined, function () {
	    'use strict';
	
	    var Waves = Waves || {};
	    var $$ = document.querySelectorAll.bind(document);
	    var toString = Object.prototype.toString;
	    var isTouchAvailable = 'ontouchstart' in window;
	
	    // Find exact position of element
	    function isWindow(obj) {
	        return obj !== null && obj === obj.window;
	    }
	
	    function getWindow(elem) {
	        return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
	    }
	
	    function isObject(value) {
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	        return type === 'function' || type === 'object' && !!value;
	    }
	
	    function isDOMNode(obj) {
	        return isObject(obj) && obj.nodeType > 0;
	    }
	
	    function getWavesElements(nodes) {
	        var stringRepr = toString.call(nodes);
	
	        if (stringRepr === '[object String]') {
	            return $$(nodes);
	        } else if (isObject(nodes) && /^\[object (Array|HTMLCollection|NodeList|Object)\]$/.test(stringRepr) && nodes.hasOwnProperty('length')) {
	            return nodes;
	        } else if (isDOMNode(nodes)) {
	            return [nodes];
	        }
	
	        return [];
	    }
	
	    function offset(elem) {
	        var docElem,
	            win,
	            box = { top: 0, left: 0 },
	            doc = elem && elem.ownerDocument;
	
	        docElem = doc.documentElement;
	
	        if (_typeof(elem.getBoundingClientRect) !== ( true ? 'undefined' : _typeof(undefined))) {
	            box = elem.getBoundingClientRect();
	        }
	        win = getWindow(doc);
	        return {
	            top: box.top + win.pageYOffset - docElem.clientTop,
	            left: box.left + win.pageXOffset - docElem.clientLeft
	        };
	    }
	
	    function convertStyle(styleObj) {
	        var style = '';
	
	        for (var prop in styleObj) {
	            if (styleObj.hasOwnProperty(prop)) {
	                style += prop + ':' + styleObj[prop] + ';';
	            }
	        }
	
	        return style;
	    }
	
	    var Effect = {
	
	        // Effect duration
	        duration: 750,
	
	        // Effect delay (check for scroll before showing effect)
	        delay: 200,
	
	        show: function show(e, element, velocity) {
	
	            // Disable right click
	            if (e.button === 2) {
	                return false;
	            }
	
	            element = element || this;
	
	            // Create ripple
	            var ripple = document.createElement('div');
	            ripple.className = 'waves-ripple waves-rippling';
	            element.appendChild(ripple);
	
	            // Get click coordinate and element width
	            var pos = offset(element);
	            var relativeY = 0;
	            var relativeX = 0;
	            // Support for touch devices
	            if ('touches' in e && e.touches.length) {
	                relativeY = e.touches[0].pageY - pos.top;
	                relativeX = e.touches[0].pageX - pos.left;
	            }
	            //Normal case
	            else {
	                    relativeY = e.pageY - pos.top;
	                    relativeX = e.pageX - pos.left;
	                }
	            // Support for synthetic events
	            relativeX = relativeX >= 0 ? relativeX : 0;
	            relativeY = relativeY >= 0 ? relativeY : 0;
	
	            var scale = 'scale(' + element.clientWidth / 100 * 3 + ')';
	            var translate = 'translate(0,0)';
	
	            if (velocity) {
	                translate = 'translate(' + velocity.x + 'px, ' + velocity.y + 'px)';
	            }
	
	            // Attach data to element
	            ripple.setAttribute('data-hold', Date.now());
	            ripple.setAttribute('data-x', relativeX);
	            ripple.setAttribute('data-y', relativeY);
	            ripple.setAttribute('data-scale', scale);
	            ripple.setAttribute('data-translate', translate);
	
	            // Set ripple position
	            var rippleStyle = {
	                top: relativeY + 'px',
	                left: relativeX + 'px'
	            };
	
	            ripple.classList.add('waves-notransition');
	            ripple.setAttribute('style', convertStyle(rippleStyle));
	            ripple.classList.remove('waves-notransition');
	
	            // Scale the ripple
	            rippleStyle['-webkit-transform'] = scale + ' ' + translate;
	            rippleStyle['-moz-transform'] = scale + ' ' + translate;
	            rippleStyle['-ms-transform'] = scale + ' ' + translate;
	            rippleStyle['-o-transform'] = scale + ' ' + translate;
	            rippleStyle.transform = scale + ' ' + translate;
	            rippleStyle.opacity = '1';
	
	            var duration = e.type === 'mousemove' ? 2500 : Effect.duration;
	            rippleStyle['-webkit-transition-duration'] = duration + 'ms';
	            rippleStyle['-moz-transition-duration'] = duration + 'ms';
	            rippleStyle['-o-transition-duration'] = duration + 'ms';
	            rippleStyle['transition-duration'] = duration + 'ms';
	
	            ripple.setAttribute('style', convertStyle(rippleStyle));
	        },
	
	        hide: function hide(e, element) {
	            element = element || this;
	
	            var ripples = element.getElementsByClassName('waves-rippling');
	
	            for (var i = 0, len = ripples.length; i < len; i++) {
	                removeRipple(e, element, ripples[i]);
	            }
	        }
	    };
	
	    /**
	     * Collection of wrapper for HTML element that only have single tag
	     * like <input> and <img>
	     */
	    var TagWrapper = {
	
	        // Wrap <input> tag so it can perform the effect
	        input: function input(element) {
	
	            var parent = element.parentNode;
	
	            // If input already have parent just pass through
	            if (parent.tagName.toLowerCase() === 'i' && parent.classList.contains('waves-effect')) {
	                return;
	            }
	
	            // Put element class and style to the specified parent
	            var wrapper = document.createElement('i');
	            wrapper.className = element.className + ' waves-input-wrapper';
	            element.className = 'waves-button-input';
	
	            // Put element as child
	            parent.replaceChild(wrapper, element);
	            wrapper.appendChild(element);
	
	            // Apply element color and background color to wrapper
	            var elementStyle = window.getComputedStyle(element, null);
	            var color = elementStyle.color;
	            var backgroundColor = elementStyle.backgroundColor;
	
	            wrapper.setAttribute('style', 'color:' + color + ';background:' + backgroundColor);
	            element.setAttribute('style', 'background-color:rgba(0,0,0,0);');
	        },
	
	        // Wrap <img> tag so it can perform the effect
	        img: function img(element) {
	
	            var parent = element.parentNode;
	
	            // If input already have parent just pass through
	            if (parent.tagName.toLowerCase() === 'i' && parent.classList.contains('waves-effect')) {
	                return;
	            }
	
	            // Put element as child
	            var wrapper = document.createElement('i');
	            parent.replaceChild(wrapper, element);
	            wrapper.appendChild(element);
	        }
	    };
	
	    /**
	     * Hide the effect and remove the ripple. Must be
	     * a separate function to pass the JSLint...
	     */
	    function removeRipple(e, el, ripple) {
	
	        // Check if the ripple still exist
	        if (!ripple) {
	            return;
	        }
	
	        ripple.classList.remove('waves-rippling');
	
	        var relativeX = ripple.getAttribute('data-x');
	        var relativeY = ripple.getAttribute('data-y');
	        var scale = ripple.getAttribute('data-scale');
	        var translate = ripple.getAttribute('data-translate');
	
	        // Get delay beetween mousedown and mouse leave
	        var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
	        var delay = 350 - diff;
	
	        if (delay < 0) {
	            delay = 0;
	        }
	
	        if (e.type === 'mousemove') {
	            delay = 150;
	        }
	
	        // Fade out ripple after delay
	        var duration = e.type === 'mousemove' ? 2500 : Effect.duration;
	
	        setTimeout(function () {
	
	            var style = {
	                top: relativeY + 'px',
	                left: relativeX + 'px',
	                opacity: '0',
	
	                // Duration
	                '-webkit-transition-duration': duration + 'ms',
	                '-moz-transition-duration': duration + 'ms',
	                '-o-transition-duration': duration + 'ms',
	                'transition-duration': duration + 'ms',
	                '-webkit-transform': scale + ' ' + translate,
	                '-moz-transform': scale + ' ' + translate,
	                '-ms-transform': scale + ' ' + translate,
	                '-o-transform': scale + ' ' + translate,
	                'transform': scale + ' ' + translate
	            };
	
	            ripple.setAttribute('style', convertStyle(style));
	
	            setTimeout(function () {
	                try {
	                    el.removeChild(ripple);
	                } catch (e) {
	                    return false;
	                }
	            }, duration);
	        }, delay);
	    }
	
	    /**
	     * Disable mousedown event for 500ms during and after touch
	     */
	    var TouchHandler = {
	
	        /* uses an integer rather than bool so there's no issues with
	         * needing to clear timeouts if another touch event occurred
	         * within the 500ms. Cannot mouseup between touchstart and
	         * touchend, nor in the 500ms after touchend. */
	        touches: 0,
	
	        allowEvent: function allowEvent(e) {
	
	            var allow = true;
	
	            if (/^(mousedown|mousemove)$/.test(e.type) && TouchHandler.touches) {
	                allow = false;
	            }
	
	            return allow;
	        },
	        registerEvent: function registerEvent(e) {
	            var eType = e.type;
	
	            if (eType === 'touchstart') {
	
	                TouchHandler.touches += 1; // push
	            } else if (/^(touchend|touchcancel)$/.test(eType)) {
	
	                setTimeout(function () {
	                    if (TouchHandler.touches) {
	                        TouchHandler.touches -= 1; // pop after 500ms
	                    }
	                }, 500);
	            }
	        }
	    };
	
	    /**
	     * Delegated click handler for .waves-effect element.
	     * returns null when .waves-effect element not in "click tree"
	     */
	    function getWavesEffectElement(e) {
	
	        if (TouchHandler.allowEvent(e) === false) {
	            return null;
	        }
	
	        var element = null;
	        var target = e.target || e.srcElement;
	
	        while (target.parentElement) {
	            if (!(target instanceof SVGElement) && target.classList.contains('waves-effect')) {
	                element = target;
	                break;
	            }
	            target = target.parentElement;
	        }
	
	        return element;
	    }
	
	    /**
	     * Bubble the click and show effect if .waves-effect elem was found
	     */
	    function showEffect(e) {
	
	        // Disable effect if element has "disabled" property on it
	        // In some cases, the event is not triggered by the current element
	        // if (e.target.getAttribute('disabled') !== null) {
	        //     return;
	        // }
	
	        var element = getWavesEffectElement(e);
	
	        if (element !== null) {
	
	            // Make it sure the element has either disabled property, disabled attribute or 'disabled' class
	            if (element.disabled || element.getAttribute('disabled') || element.classList.contains('disabled')) {
	                return;
	            }
	
	            TouchHandler.registerEvent(e);
	
	            if (e.type === 'touchstart' && Effect.delay) {
	
	                var hidden = false;
	
	                var timer = setTimeout(function () {
	                    timer = null;
	                    Effect.show(e, element);
	                }, Effect.delay);
	
	                var hideEffect = function hideEffect(hideEvent) {
	
	                    // if touch hasn't moved, and effect not yet started: start effect now
	                    if (timer) {
	                        clearTimeout(timer);
	                        timer = null;
	                        Effect.show(e, element);
	                    }
	                    if (!hidden) {
	                        hidden = true;
	                        Effect.hide(hideEvent, element);
	                    }
	                };
	
	                var touchMove = function touchMove(moveEvent) {
	                    if (timer) {
	                        clearTimeout(timer);
	                        timer = null;
	                    }
	                    hideEffect(moveEvent);
	                };
	
	                element.addEventListener('touchmove', touchMove, false);
	                element.addEventListener('touchend', hideEffect, false);
	                element.addEventListener('touchcancel', hideEffect, false);
	            } else {
	
	                Effect.show(e, element);
	
	                if (isTouchAvailable) {
	                    element.addEventListener('touchend', Effect.hide, false);
	                    element.addEventListener('touchcancel', Effect.hide, false);
	                }
	
	                element.addEventListener('mouseup', Effect.hide, false);
	                element.addEventListener('mouseleave', Effect.hide, false);
	            }
	        }
	    }
	
	    Waves.init = function (options) {
	        var body = document.body;
	
	        options = options || {};
	
	        if ('duration' in options) {
	            Effect.duration = options.duration;
	        }
	
	        if ('delay' in options) {
	            Effect.delay = options.delay;
	        }
	
	        if (isTouchAvailable) {
	            body.addEventListener('touchstart', showEffect, false);
	            body.addEventListener('touchcancel', TouchHandler.registerEvent, false);
	            body.addEventListener('touchend', TouchHandler.registerEvent, false);
	        }
	
	        body.addEventListener('mousedown', showEffect, false);
	    };
	
	    /**
	     * Attach Waves to dynamically loaded inputs, or add .waves-effect and other
	     * waves classes to a set of elements. Set drag to true if the ripple mouseover
	     * or skimming effect should be applied to the elements.
	     */
	    Waves.attach = function (elements, classes) {
	
	        elements = getWavesElements(elements);
	
	        if (toString.call(classes) === '[object Array]') {
	            classes = classes.join(' ');
	        }
	
	        classes = classes ? ' ' + classes : '';
	
	        var element, tagName;
	
	        for (var i = 0, len = elements.length; i < len; i++) {
	
	            element = elements[i];
	            tagName = element.tagName.toLowerCase();
	
	            if (['input', 'img'].indexOf(tagName) !== -1) {
	                TagWrapper[tagName](element);
	                element = element.parentElement;
	            }
	
	            if (element.className.indexOf('waves-effect') === -1) {
	                element.className += ' waves-effect' + classes;
	            }
	        }
	    };
	
	    /**
	     * Cause a ripple to appear in an element via code.
	     */
	    Waves.ripple = function (elements, options) {
	        elements = getWavesElements(elements);
	        var elementsLen = elements.length;
	
	        options = options || {};
	        options.wait = options.wait || 0;
	        options.position = options.position || null; // default = centre of element
	
	
	        if (elementsLen) {
	            var element,
	                pos,
	                off,
	                centre = {},
	                i = 0;
	            var mousedown = {
	                type: 'mousedown',
	                button: 1
	            };
	            var hideRipple = function hideRipple(mouseup, element) {
	                return function () {
	                    Effect.hide(mouseup, element);
	                };
	            };
	
	            for (; i < elementsLen; i++) {
	                element = elements[i];
	                pos = options.position || {
	                    x: element.clientWidth / 2,
	                    y: element.clientHeight / 2
	                };
	
	                off = offset(element);
	                centre.x = off.left + pos.x;
	                centre.y = off.top + pos.y;
	
	                mousedown.pageX = centre.x;
	                mousedown.pageY = centre.y;
	
	                Effect.show(mousedown, element);
	
	                if (options.wait >= 0 && options.wait !== null) {
	                    var mouseup = {
	                        type: 'mouseup',
	                        button: 1
	                    };
	
	                    setTimeout(hideRipple(mouseup, element), options.wait);
	                }
	            }
	        }
	    };
	
	    /**
	     * Remove all ripples from an element.
	     */
	    Waves.calm = function (elements) {
	        elements = getWavesElements(elements);
	        var mouseup = {
	            type: 'mouseup',
	            button: 1
	        };
	
	        for (var i = 0, len = elements.length; i < len; i++) {
	            Effect.hide(mouseup, elements[i]);
	        }
	    };
	
	    /**
	     * Deprecated API fallback
	     */
	    Waves.displayEffect = function (options) {
	        console.error('Waves.displayEffect() has been deprecated and will be removed in future version. Please use Waves.init() to initialize Waves effect');
	        Waves.init(options);
	    };
	
	    return Waves;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _waves = __webpack_require__(672);
	
	var _waves2 = _interopRequireDefault(_waves);
	
	__webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Waves = angular.module('vendor.waves', []).directive('mdEffect', function () {
	    return new _waves2.default();
	}).name;
	
	exports.default = Waves;

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	/*! ng-csv 10-10-2015 */
	!function(a){angular.module("ngCsv.config",[]).value("ngCsv.config",{debug:!0}).config(["$compileProvider",function(a){angular.isDefined(a.urlSanitizationWhitelist)?a.urlSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|data):/):a.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|data):/)}]),angular.module("ngCsv.directives",["ngCsv.services"]),angular.module("ngCsv.services",[]),angular.module("ngCsv",["ngCsv.config","ngCsv.services","ngCsv.directives","ngSanitize"]),"undefined"!=typeof module&&"undefined"!=typeof exports&&module.exports===exports&&(module.exports="ngCsv"),angular.module("ngCsv.services").service("CSV",["$q",function(a){var b="\r\n",c="﻿",d={"\\t":"	","\\b":"\b","\\v":"","\\f":"\f","\\r":"\r"};this.stringifyField=function(a,b){return"locale"===b.decimalSep&&this.isFloat(a)?a.toLocaleString():"."!==b.decimalSep&&this.isFloat(a)?a.toString().replace(".",b.decimalSep):"string"==typeof a?(a=a.replace(/"/g,'""'),(b.quoteStrings||a.indexOf(",")>-1||a.indexOf("\n")>-1||a.indexOf("\r")>-1)&&(a=b.txtDelim+a+b.txtDelim),a):"boolean"==typeof a?a?"TRUE":"FALSE":a},this.isFloat=function(a){return+a===a&&(!isFinite(a)||Boolean(a%1))},this.stringify=function(d,e){var f=a.defer(),g=this,h="",i="",j=a.when(d).then(function(a){if(angular.isDefined(e.header)&&e.header){var d,j;d=[],angular.forEach(e.header,function(a){this.push(g.stringifyField(a,e))},d),j=d.join(e.fieldSep?e.fieldSep:","),i+=j+b}var k=[];if(angular.isArray(a)?k=a:angular.isFunction(a)&&(k=a()),angular.isDefined(e.label)&&e.label&&"boolean"==typeof e.label){var l,m;l=[],angular.forEach(k[0],function(a,b){this.push(g.stringifyField(b,e))},l),m=l.join(e.fieldSep?e.fieldSep:","),i+=m+b}angular.forEach(k,function(a,c){var d,f,h=angular.copy(k[c]);f=[];var j=e.columnOrder?e.columnOrder:h;angular.forEach(j,function(a){var b=e.columnOrder?h[a]:a;this.push(g.stringifyField(b,e))},f),d=f.join(e.fieldSep?e.fieldSep:","),i+=c<k.length?d+b:d}),e.addByteOrderMarker&&(h+=c),h+=i,f.resolve(h)});return"function"==typeof j["catch"]&&j["catch"](function(a){f.reject(a)}),f.promise},this.isSpecialChar=function(a){return void 0!==d[a]},this.getSpecialChar=function(a){return d[a]}}]),angular.module("ngCsv.directives").directive("ngCsv",["$parse","$q","CSV","$document","$timeout",function(b,c,d,e,f){return{restrict:"AC",scope:{data:"&ngCsv",filename:"@filename",header:"&csvHeader",columnOrder:"&csvColumnOrder",txtDelim:"@textDelimiter",decimalSep:"@decimalSeparator",quoteStrings:"@quoteStrings",fieldSep:"@fieldSeparator",lazyLoad:"@lazyLoad",addByteOrderMarker:"@addBom",ngClick:"&",charset:"@charset",label:"&csvLabel"},controller:["$scope","$element","$attrs","$transclude",function(a,b,e){function f(){var b={txtDelim:a.txtDelim?a.txtDelim:'"',decimalSep:a.decimalSep?a.decimalSep:".",quoteStrings:a.quoteStrings,addByteOrderMarker:a.addByteOrderMarker};return angular.isDefined(e.csvHeader)&&(b.header=a.$eval(a.header)),angular.isDefined(e.csvColumnOrder)&&(b.columnOrder=a.$eval(a.columnOrder)),angular.isDefined(e.csvLabel)&&(b.label=a.$eval(a.label)),b.fieldSep=a.fieldSep?a.fieldSep:",",b.fieldSep=d.isSpecialChar(b.fieldSep)?d.getSpecialChar(b.fieldSep):b.fieldSep,b}a.csv="",angular.isDefined(a.lazyLoad)&&"true"==a.lazyLoad||angular.isArray(a.data)&&a.$watch("data",function(){a.buildCSV()},!0),a.getFilename=function(){return a.filename||"download.csv"},a.buildCSV=function(){var g=c.defer();return b.addClass(e.ngCsvLoadingClass||"ng-csv-loading"),d.stringify(a.data(),f()).then(function(c){a.csv=c,b.removeClass(e.ngCsvLoadingClass||"ng-csv-loading"),g.resolve(c)}),a.$apply(),g.promise}}],link:function(b,c){function d(){var c=b.charset||"utf-8",d=new Blob([b.csv],{type:"text/csv;charset="+c+";"});if(a.navigator.msSaveOrOpenBlob)navigator.msSaveBlob(d,b.getFilename());else{var g=angular.element('<div data-tap-disabled="true"><a></a></div>'),h=angular.element(g.children()[0]);h.attr("href",a.URL.createObjectURL(d)),h.attr("download",b.getFilename()),h.attr("target","_blank"),e.find("body").append(g),f(function(){h[0].click(),h.remove()},null)}}c.bind("click",function(){b.buildCSV().then(function(){d()}),b.$apply()})}}}])}(window,document);

/***/ }),
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\" style=\"word-break:break-all;word-wrap:break-word;\"><i class=\"fa fa-paperclip\"></i>\n      {{$ctrl.title}}\n    </h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\" ng-if=\"true\">\n    <div class=\"col\">\n      <image-viewer id=\"1\" base64=\"$ctrl.image.base64\" height=\"300\" vm=\"$ctrl.$ivScope\"></image-viewer>\n      <!-- <hr>\n      <img id=\"preview_imagen\" ng-if=\"$ctrl.informe.tipo!='application/pdf'\" ng-src=\"{{$ctrl.getBase64Image()}}\" width=\"100%\" alt=\"Fotografía del informe\"/> -->\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.descargarImg()\">\n      <i class=\"fa fa-download\"></i> Descargar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.imprimirImg()\"\n    ng-if=\"!$ctrl.Util.isMobile.any() && !$ctrl.Util.isIEoEdge()\">\n      <i class=\"fa fa-print\"></i> Imprimir\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.save()\">\n        <i class=\"fa fa-check\"></i> Aceptar\n    </button>\n</div>\n"

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-{{ $ctrl.icon }}\" ng-if=\"$ctrl.icon\"></i> {{ $ctrl.title }}</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-if=\"$ctrl.btnClose\" ng-click=\"$ctrl.close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <div ng-bind-html=\"$ctrl.message\" ng-if=\"$ctrl.message\"></div>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.close()\" ng-if=\"$ctrl.cancel\">\n        <i class=\"fa fa-close\"></i> {{ $ctrl.labelCancel || 'Cancelar'}}\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n        <i class=\"fa fa-check\"></i> {{ $ctrl.labelOk || 'Aceptar' }}\n    </button>\n</div>"

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-file-pdf-o\"></i> {{$ctrl.item.title || 'PDF'}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n\n  <pdf-viewer ng-if=\"$ctrl.documento.tipo === 'application/pdf'\"\n  base64=\"$ctrl.documento.base64\"  scale=\"page-fit\" page=\"1\" download=\"true\" print=\"true\"></pdf-viewer>\n\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-secondary pull-left\" ng-click=\"$ctrl.fix()\" ng-if=\"$ctrl.item.reload\">\n    <i class=\"fa fa-refresh\"></i> Corregir\n  </button>\t\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-file-pdf-o\"></i> Declaración Jurada</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <iframe ng-src=\"{{$ctrl.urlPdf}}\" style=\"width:100%; height:550px;\" frameborder=\"0\">\n    <p>Su navegador no soporta iframe</p>\n  </iframe>\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>"

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-sm-12\">\n    <label for=\"{{$ctrl.name}}\" title=\"{{$ctrl.title}}\" class=\"title\" ng-class=\"{'requerido':$ctrl.ngRequired}\">{{$ctrl.label}}</label>\n    <input type=\"hidden\" name=\"{{$ctrl.name}}\" ng-required=\"$ctrl.ngRequired\" ng-model=\"$ctrl.model\">\n  </div>\n  <div class=\"col-sm-4\">\n    <div class=\"md-form-group md-select-group\">\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"dia\" ng-change=\"$ctrl.setDate()\" ng-model=\"$ctrl.day\" theme=\"bootstrap\" class=\"md-select\"\n      ng-required=\"$ctrl.ngRequired || ($ctrl.month || $ctrl.year)\" ng-disabled=\"$ctrl.ngDisabled\" maxlen=\"2\">\n        <ui-select-match placeholder=\"DÍA\" allow-clear=\"true\" allow-clear-class>{{$select.selected.text}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.days | filter: $select.search\"\n          refresh=\"$ctrl.inputDate($select.search, $ctrl.days | filter: $select.search, 'day')\" refresh-delay=\"0\" >\n          <span ng-bind-html=\"item.text | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> Seleccione un día válido. </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"dia\" ng-model=\"$ctrl.day\" ng-options=\"item.value for item in $ctrl.days\"\n      class=\"select-mobile\" ng-change=\"$ctrl.setDate()\" ng-required=\"$ctrl.ngRequired || ($ctrl.month || $ctrl.year)\"></select>\n\n      <label class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label no-float-label'}}\" ng-class=\"{'requerido':$ctrl.ngRequired, 'hasvalue': $ctrl.day}\">DÍA</label>\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.dia.$invalid && $ctrl.form.dia.$touched,'sin-error':!$ctrl.form.dia.$invalid}\"></i>\n      <div ng-messages=\"$ctrl.form.dia.$error\" class=\"error-select-date\" ng-if=\"$ctrl.form.dia.$touched || $ctrl.form.mes.$touched || $ctrl.form.anio.$touched\" role=\"alert\">\n        <div ng-message=\"required\"> El campo es requerido. </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-sm-4\">\n    <div class=\"md-form-group md-select-group\">\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"mes\" ng-change=\"$ctrl.setDate()\" ng-model=\"$ctrl.month\" theme=\"bootstrap\" class=\"md-select\"\n      ng-required=\"$ctrl.ngRequired || ($ctrl.day || $ctrl.year)\" ng-disabled=\"$ctrl.ngDisabled\" maxlen=\"10\">\n        <ui-select-match placeholder=\"MES\" allow-clear=\"true\" allow-clear-class>{{$select.selected.text}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.months | filter: $select.search\"\n          refresh=\"$ctrl.inputDate($select.search, $ctrl.months | filter: $select.search, 'month')\" refresh-delay=\"0\" >\n          <span ng-bind-html=\"item.text | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> Seleccione un mes válido. </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select class=\"select-mobile\" ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"mes\" ng-model=\"$ctrl.month\" ng-options=\"item.text for item in $ctrl.months\" ng-change=\"$ctrl.setDate()\" ng-required=\"$ctrl.ngRequired || ($ctrl.day || $ctrl.year)\"></select>\n\n      <label class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label no-float-label'}}\" ng-class=\"{'requerido':$ctrl.ngRequired, 'hasvalue': $ctrl.month}\">MES</label>\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.mes.$invalid && $ctrl.form.mes.$touched,'sin-error':!$ctrl.form.mes.$invalid}\"></i>\n      <div ng-messages=\"$ctrl.form.mes.$error\" class=\"error-select-date\" ng-if=\"$ctrl.form.mes.$touched || $ctrl.form.dia.$touched || $ctrl.form.anio.$touched\" role=\"alert\">\n        <div ng-message=\"required\"> El campo es requerido. </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-sm-4\">\n    <div class=\"md-form-group md-select-group\">\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"anio\" ng-change=\"$ctrl.setDate()\" ng-model=\"$ctrl.year\" theme=\"bootstrap\" class=\"md-select\"\n      ng-required=\"$ctrl.ngRequired || ($ctrl.day || $ctrl.month)\" ng-disabled=\"$ctrl.ngDisabled\" maxlen=\"4\">\n        <ui-select-match placeholder=\"AÑO\" allow-clear=\"true\" allow-clear-class>{{$select.selected.text}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.years | filter: $select.search\"\n          refresh=\"$ctrl.inputDate($select.search, $ctrl.years | filter: $select.search, 'year')\" refresh-delay=\"0\" >\n          <span ng-bind-html=\"item.text | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> Seleccione un año válido. </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select class=\"select-mobile\"  ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"anio\" ng-model=\"$ctrl.year\" ng-options=\"item.value for item in $ctrl.years\" ng-change=\"$ctrl.setDate()\" ng-required=\"$ctrl.ngRequired || ($ctrl.day || $ctrl.month)\"></select>\n\n      <label class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label no-float-label'}}\" ng-class=\"{'requerido':$ctrl.ngRequired, 'hasvalue': $ctrl.year}\">AÑO</label>\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.anio.$invalid && $ctrl.form.anio.$touched,'sin-error':!$ctrl.form.anio.$invalid}\"></i>\n      <div ng-messages=\"$ctrl.form.anio.$error\" class=\"error-select-date\" ng-if=\"$ctrl.form.anio.$touched || $ctrl.form.dia.$touched || $ctrl.form.mes.$touched\" role=\"alert\">\n        <div ng-message=\"required\"> El campo es requerido. </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div ng-class=\"$ctrl.horizontal? 'col-md-4' : 'col-md-12'\">\n    <div class=\"md-form-group md-select-group\" md-event-label>\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"departamento\" ng-model=\"$ctrl.ngModel.departamento\"\n                 theme=\"bootstrap\" class=\"md-select\" spinner-enabled=\"true\" ng-required=\"$ctrl.ngRequired\"\n                 ng-disabled=\"$ctrl.ngDisabled\" ng-change=\"$ctrl.getProvincias({{$select.selected}}, true)\" maxlen=\"10\">\n        <ui-select-match placeholder=\"Seleccione Departamento\" allow-clear=\"!$ctrl.ngRequired\" allow-clear-class>{{$select.selected.nombre}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.departamentos | orderBy : 'nombre' | filter: $select.search\">\n          <span ng-bind-html=\"item.nombre | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> Departamento no encontrado. </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"departamento\" ng-model=\"$ctrl.ngModel.departamento\" ng-options=\"item.nombre for item in $ctrl.departamentos\"\n      class=\"select-mobile\" ng-change=\"$ctrl.getProvincias($ctrl.ngModel.departamento, true)\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.disabledDepto\"></select>\n\n      <label for=\"departamento\" class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label'}}\"\n      ng-class=\"{'requerido':$ctrl.ngRequired, 'md-control-label': $ctrl.ngModel.departamento && !!$ctrl.Util.isMobile.any()}\">Departamento</label>\n\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.departamento.$invalid && $ctrl.form.departamento.$touched}\"></i>\n      <div ng-messages=\"$ctrl.form.departamento.$error\" ap-error ng-if=\"$ctrl.form.departamento.$touched\" role=\"alert\">\n        <div ng-message=\"required\" ng-if=\"$ctrl.ngRequired\"> El campo es requerido. </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-class=\"$ctrl.horizontal? 'col-md-4' : 'col-md-12'\">\n    <div class=\"md-form-group md-select-group\" md-event-label>\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"provincia\" ng-model=\"$ctrl.ngModel.provincia\" theme=\"bootstrap\" class=\"md-select\"\n      ng-disabled=\"$ctrl.ngDisabled || $ctrl.disableProvincia\" ng-change=\"$ctrl.getMunicipios({{$select.selected}}, true)\" maxlen=\"20\">\n        <ui-select-match placeholder=\"Seleccione Provincia\" allow-clear=\"!$ctrl.ngRequired\" allow-clear-class>{{$select.selected.nombre}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.provincias | orderBy : 'nombre' | filter: $select.search\">\n          <span ng-bind-html=\"item.nombre | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> {{!$ctrl.ngModel.departamento? 'Seleccione un departamento' : 'Provincia no encontrada'}} </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"provincia\" ng-model=\"$ctrl.ngModel.provincia\" ng-options=\"item.nombre for item in $ctrl.provincias\"\n      class=\"select-mobile\" ng-change=\"$ctrl.getMunicipios($ctrl.ngModel.provincia, true)\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.disableProvincia\"></select>\n\n      <label for=\"provincia\" class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label'}}\"\n      ng-class=\"{'md-control-label': $ctrl.ngModel.provincia && !!$ctrl.Util.isMobile.any()}\">Provincia</label>\n\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.provincia.$invalid && $ctrl.form.provincia.$touched}\"></i>\n      <div ng-messages=\"$ctrl.form.provincia.$error\" ap-error ng-if=\"$ctrl.form.provincia.$touched\" role=\"alert\">\n        <div ng-message=\"required\" ng-if=\"$ctrl.ngRequired && !$ctrl.ngModel.departamento\"> El campo es requerido. </div>\n        <div ng-if=\"$ctrl.ngModel.departamento && !$ctrl.ngModel.provincia\"> Debe seleccionar la Provincia. </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-class=\"$ctrl.horizontal? 'col-md-4' : 'col-md-12'\">\n    <div class=\"md-form-group md-select-group\" md-event-label>\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"municipio\" on-select=\"$ctrl.onSelectMunicipio({item:$item})\" ng-model=\"$ctrl.ngModel.municipio\" theme=\"bootstrap\" class=\"md-select\"\n      ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\" ng-change=\"$ctrl.setMunicipio($select.selected, true)\" maxlen=\"20\">\n        <ui-select-match placeholder=\"Seleccione Municipio\" allow-clear=\"!$ctrl.ngRequired\" allow-clear-class>{{$select.selected.nombre}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.municipios | orderBy : 'nombre' | filter: $select.search\">\n          <span ng-bind-html=\"item.nombre | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> {{!$ctrl.ngModel.provincia? 'Seleccione una provincia' : 'Provincia no encontrada'}} </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"municipio\" ng-model=\"$ctrl.ngModel.municipio\" ng-options=\"item.nombre for item in $ctrl.municipios\"\n      class=\"select-mobile\" ng-change=\"$ctrl.setMunicipio($ctrl.ngModel.municipio, true)\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\"></select>\n\n      <label for=\"municipio\" class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label'}}\"\n      ng-class=\"{'requerido':$ctrl.ngRequired, 'md-control-label': $ctrl.ngModel.municipio && !!$ctrl.Util.isMobile.any()}\">Municipio</label>\n\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.municipio.$invalid && $ctrl.form.municipio.$touched}\"></i>\n      <div ng-messages=\"$ctrl.form.municipio.$error\" ap-error ng-if=\"$ctrl.form.municipio.$touched\" role=\"alert\">\n        <div ng-message=\"required\" ng-if=\"$ctrl.ngRequired && !$ctrl.ngModel.provincia\"> El campo es requerido. </div>\n        <div ng-if=\"$ctrl.ngModel.provincia && !$ctrl.ngModel.municipio\"> Debe seleccionar el Municipio. </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"crud-table\">\n  <table ng-table-dynamic=\"$ctrl.tableParams with $ctrl.columns\" class=\"table table-striped table-hover table-responsive\">\n    <tr ng-repeat=\"row in $data\">\n      <td ng-repeat=\"col in $columns\">\n        <span class=\"{{(row[col.field] | typeof) == 'number' ? 'pull-right' : ''}}\">\n          {{ (row[col.field][col.subfield] || row[col.field]) | formatDecimal:2 | datetime:'convert' }}\n        </span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 695 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"crud-table\">\n    <div class=\"d-flex justify-content-between\" ng-if=\"!$ctrl.inline\">\n        <div class=\"btn-container p-2\">\n            <label class=\"custom-control custom-checkbox\" ng-if=\"$ctrl.checks\" uib-tooltip=\"Seleccionar todos\">\n                <input type=\"checkbox\" class=\"custom-control-input\" ng-change=\"$ctrl.selectAllChecks()\" ng-model=\"$ctrl.modelSelectAllCheks\">\n                <span class=\"custom-control-indicator\"></span>\n            </label>\n            <button class=\"btn btn-primary\" md-effect type=\"button\" ng-click=\"$ctrl.actionChecks()\" ng-if=\"$ctrl.checks\">\n                <i class=\"fa fa-{{$ctrl.checks.icon}}\" ng-if=\"$ctrl.checks.icon\"></i> {{$ctrl.checks.label || 'Checks.label'}}\n            </button>\n            <button class=\"btn btn-primary\" md-effect ng-click=\"$ctrl.add()\" type=\"button\" uib-tooltip=\"Agregar nuevo registro\" ng-if=\"$ctrl.permissions.create\">\n                <i class=\"fa fa-plus\"></i> {{ $ctrl.labels.create || 'Agregar' }}\n            </button>\n            <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\">\n                <i class=\"fa fa-refresh\"></i>\n            </button>\n            <button md-effect class=\"btn\" ng-class=\"button.class || 'btn-default'\" type=\"button\" ng-repeat=\"button in $ctrl.buttonsTop\" uib-tooltip=\"{{button.tooltip}}\" ng-click=\"button.onclick? button.onclick($event):true\" ng-if=\"button.if? button.if() : true\">\n                <i class=\"fa fa-{{button.icon}}\"></i> {{button.label}}\n            </button>\n        </div>\n        <form name=\"$ctrl.searchForm\" class=\"form-search p-2\" novalidate ng-submit=\"$ctrl.search()\" ng-if=\"$ctrl.permissions.filter\">\n            <div class=\"input-group\">\n                <span class=\"input-group-btn\" ng-if=\"$ctrl.searchTerm.length\">\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cleanSearch()\" uib-tooltip=\"Limpiar búsqueda\">\n                        <i class=\"fa fa-trash\"></i>\n                    </button>\n                </span>\n                <input type=\"text\" class=\"form-control\" placeholder=\"Escriba su búsqueda aquí\" name=\"searchTerm\" ng-model=\"$ctrl.searchTerm\" required />\n                <span class=\"input-group-btn\">\n                    <button class=\"btn btn-default\" type=\"submit\" ng-disabled=\"$ctrl.searchForm.$invalid\" uib-tooltip=\"Buscar en la tabla\">\n                        <i class=\"fa fa-search\"></i>\n                    </button>\n                </span>\n            </div>\n        </form>\n    </div>\n    <!-- <div ng-if=\"$ctrl.inlineOptions\" class=\"alert alert-info\">\n        <div ng-if=\"!$ctrl.editItem\">\n            <strong>Opciones: </strong> \n            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.edit()\" ng-if=\"$ctrl.permissions.update\" uib-tooltip=\"Editar la fila seleccionada\">\n                <i class=\"fa fa-edit\"></i> Editar\n            </button>\n            <button md-effect class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"$ctrl.delete()\" ng-if=\"$ctrl.permissions.delete\" uib-tooltip=\"Eliminar la fila seleccionada\">\n                <i class=\"fa fa-trash\"></i> Eliminar\n            </button>\n        </div>\n        <div ng-if=\"$ctrl.editItem\">\n            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.editCancel()\" ng-if=\"$ctrl.permissions.update\" uib-tooltip=\"Editar la fila seleccionada\">\n                <i class=\"fa fa-edit\"></i> Cancelar edición\n            </button>            \n        </div>\n    </div> -->\n    <form ng-if=\"$ctrl.inline\" name=\"$ctrl.formInline\" ng-submit=\"$ctrl.saveFormInline()\" novalidate class=\"crud-table-form-inline\" ng-class=\"{'alert-info' : $ctrl.editItem }\">\n        <formly-form model=\"$ctrl.modelInline\" fields=\"$ctrl.fieldsData\" options=\"$ctrl.options\" form=\"$ctrl.formInline\">            \n            <button md-effect type=\"submit\"  class=\"btn btn-primary submit-button\" uib-tooltip=\"Agregar a la lista\">\n                 <i class=\"fa fa-check\"></i> \n            </button>\n        </formly-form>\n    </form>\n    <div ng-class=\"{'edit-item-block' : $ctrl.editItem, 'crud-table-table-inline' : $ctrl.formInline }\" ng-hide=\"$ctrl.data.list && $ctrl.data.list.length == 0\">\n        <div ng-click=\"$ctrl.editCancel()\" class=\"edit-item-block-backdrop\"></div>\n        <div ng-table-dynamic=\"$ctrl.tableParams with $ctrl.headers\" show-filter=\"$ctrl.showFilter\" class=\"table-responsive\">\n            <table class=\"table table-striped table-hover ng-table\">\n                <tr ng-repeat=\"row in $data\" ng-class=\"{ 'edit-item' : row.edit }\" ng-click=\"$ctrl.selectRow(row, $data)\">\n                    <td ng-repeat=\"col in $columns\" ng-hide=\"\">\n                        <div ng-switch on=\"row[col.field]\" ng-if=\"col.dataType !== 'command'\">\n                            <div ng-switch-when=\"boolean_true\" class=\"text-center\">\n                                <i class=\"fa fa-check-circle text-success\"></i>\n                            </div>\n                            <div ng-switch-when=\"boolean_false\" class=\"text-center\">\n                                <!-- <i class=\"fa fa-check-circle text-success\"></i> -->\n                            </div>\n                            <div ng-switch-default ng-class=\"$ctrl.getFieldClass(row, col)\" ng-if=\"($ctrl.fieldsData[$index-1].type=='archive' && $ctrl.fieldsData[$index-1].templateOptions.type=='img')\">\n                                 <img ng-src=\"{{row[col.field]}}\" ng-if=\"row[col.field]\" width=\"100\" alt=\"{{col.field}}\" style:\"width: 100px; height: 90px; object-fit: contain;\"/> \n                                 <span ng-if=\"!row[col.field]\">Sin imagen</span>\n                            </div>\n                            <div ng-switch-default ng-class=\"$ctrl.getFieldClass(row, col)\" ng-if=\"!($ctrl.fieldsData[$index-1].type=='archive' && $ctrl.fieldsData[$index-1].templateOptions.type=='img')\">\n                                {{ row[col.field] | datetime: 'convert' }}\n                            </div>\n                        </div>\n\n                        <div ng-if=\"col.dataType === 'command'\" class=\"btn-actions\">\n                            <label class=\"custom-control custom-checkbox\" ng-if=\"$ctrl.checks && $ctrl.checkIf(row)\">\n                                <input type=\"checkbox\" class=\"custom-control-input\" ng-change=\"$ctrl.selectCheck(row)\" ng-model=\"row.checked\">\n                                <span class=\"custom-control-indicator\"></span>\n                            </label>\n                            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.edit(row)\" ng-if=\"($ctrl.permissions.update && $ctrl.update === undefined) || $ctrl.update.states[row[$ctrl.update.key]]\" uib-tooltip=\"Editar\">\n                                <i class=\"fa fa-edit\"></i>\n                            </button>\n                            <button md-effect class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"$ctrl.deleteRow(row)\" ng-if=\"($ctrl.permissions.delete && $ctrl.delete === undefined) || $ctrl.delete.states[row[$ctrl.delete.key]]\" uib-tooltip=\"Eliminar\">\n                                <i class=\"fa fa-trash\"></i>\n                            </button>\n                            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.print($event, row)\" ng-if=\"$ctrl.permissions.print\" uib-tooltip=\"Imprimir\">\n                                <i class=\"fa fa-trash\"></i>\n                            </button>\n                            <button md-effect class=\"btn btn-sm\" ng-class=\"button.class || ['btn-default']\" type=\"button\" ng-repeat=\"button in $ctrl.buttons\" uib-tooltip=\"{{button.tooltip}}\" ng-click=\"$ctrl.buttonEvent($event, row, button.onclick)\" ng-if=\"$ctrl.buttonIf($event, row, button.if)\">\n                                <i class=\"fa fa-{{button.icon}}\"></i>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n        <div ng-if=\"$ctrl.emptyTable\" class=\"alert alert-warning\">\n            <i class=\"fa fa-warning\"></i> {{ $ctrl.labels.emptyTable || 'No existen registros' }}\n        </div>\n    </div>\n</div>"

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i> Agregar/Editar {{ $ctrl.title }}</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <formly-form model=\"$ctrl.model\" fields=\"$ctrl.fields\" options=\"$ctrl.options\" form=\"$ctrl.form\"></formly-form>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n        <i class=\"fa fa-close\"></i> Cerrar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.form.$invalid\" ng-click=\"$ctrl.save()\">\n        <i class=\"fa fa-check\"></i> Guardar\n    </button>\n</div>"

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"documento\" ng-if=\"$ctrl.modoVista || ($ctrl.mostrarArchivo() && !$ctrl.cargarArchivo)\">\n  <div class=\"opciones\">\n    <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.vistaPrevia()\" ng-if=\"$ctrl.ver && $ctrl.ngModel\">\n      <i class=\"fa fa-eye\"></i>\n    </button>\n\n    <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n            download-file=\"{{$ctrl.urlDescargaDocumento}}\" file-name=\"{{$ctrl.label}}\" ng-if=\"$ctrl.descargar && $ctrl.ngModel\">\n      <i class=\"fa fa-download\"></i>\n    </button>\n\n    <button md-effect type=\"button\" class=\"btn btn-info btn-sm\" uib-tooltip=\"Cambiar\" ng-if=\"!$ctrl.modoVista\" ng-click=\"$ctrl.cargarArchivo = true\">\n      <i class=\"fa fa-exchange\"></i>\n    </button>\n  </div>\n  <img ng-if=\"$ctrl.ngModel\" src=\"./images/documento.jpg\" alt=\"Documento\">\n  <img ng-if=\"!$ctrl.ngModel\" src=\"./images/nodocumento.jpg\" alt=\"Documento\">\n  <div class=\"detalles\">\n    <div class=\"nombre\">{{$ctrl.label}}</div>\n  </div>\n</div>\n\n<ui-input-file name=\"{{$ctrl.name}}\" label=\"{{$ctrl.label}}\" file-base64=\"$ctrl.ngModel\"\n               types=\"{{$ctrl.types}}\" mime-types=\"{{$ctrl.mimeTypes}}\" maxfiles=\"1\" maxsize=\"{{$ctrl.maxsize}}\"\n               ng-if=\"!$ctrl.modoVista && (!$ctrl.mostrarArchivo() || $ctrl.cargarArchivo)\">\n</ui-input-file>\n"

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"documento-indentidad\">\r\n  <ng-form name=\"doc_identidad_form\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6\" ng-if=\"!$ctrl.onlyCi\">\r\n        <!-- <select-parametro name=\"tipo_documento\" label=\"Tipo de verificación\" ng-model=\"$ctrl.ngModel.tipo_documento\"\r\n        parametro=\"TIPO_DOCUMENTO\" ng-change=\"$ctrl.changeType()\"\r\n        ng-required=\"!$ctrl.modoVista && true\"\r\n        ng-disabled=\"$ctrl.ngDisabled || ($ctrl.ngModel.tipo_documento == 'TD_CI' && $ctrl.fill) || $ctrl.modoVista\"></select-parametro> -->\r\n        <c-input name=\"tipo_documento{{$ctrl.ngId}}\" label=\"Tipo de verificación\" ng-model=\"$ctrl.tipoDocumento\" ng-disabled=\"true\"></c-input>\r\n      </div>\r\n      <div class=\"col-md-6\" ng-if=\"!$ctrl.onlyCi\">\r\n        <c-select name=\"tipo_persona{{$ctrl.ngId}}\" label=\"Persona\" ng-model=\"$ctrl.ngModel.tipo_persona\"\r\n        options=\"$ctrl.tiposPersona\" key-value=\"valor\" ng-change=\"$ctrl.changePais()\"\r\n        ng-required=\"!$ctrl.modoVista && true\"\r\n        ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"></c-select>\r\n      </div>\r\n\r\n      <div class=\"col\" ng-if=\"!$ctrl.modoVista\">\r\n        <div class=\"alert alert-info\" ng-if=\"$ctrl.ngModel.tipo_documento == 'TD_CI' && !$ctrl.ngDisabled\">\r\n          <i class=\"fa fa-info-circle\"></i>\r\n          <span>Ingrese el número de documento y la fecha de nacimiento para realizar la búsqueda.</span>\r\n        </div>\r\n        <div class=\"alert alert-info\" ng-if=\"$ctrl.ngModel.tipo_documento == 'TD_PASS' && !$ctrl.ngDisabled\">\r\n          <i class=\"fa fa-info-circle\"></i>\r\n          <span>Ingrese el número de documento para realizar la búsqueda.</span>\r\n          <button type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.buscarPersona()\" ng-disabled=\"!$ctrl.ngModel.numero_documento\" >\r\n            <i class=\"fa fa-search\"></i>Buscar\r\n          </button>\r\n        </div>\r\n        <!-- <div class=\"alert alert-warning\" ng-if=\"$ctrl.ngModel.tipo_documento != 'TD_CI' && !$ctrl.ngDisabled\">\r\n          <i class=\"fa fa-info-circle\"></i>\r\n          <span>Ingrese el número de documento, fecha de nacimiento, primer apellido, segundo apellido y nombres para realizar la contrastación con segip.</span>\r\n        </div> -->\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"{{ !$ctrl.modoVista? 'col-md-4' : 'col-md-4' }}\">\r\n        <!-- Si se usa ng-blur en este input ejecuta la funcion 3 veces  -->\r\n        <c-input name=\"documento_identidad{{$ctrl.ngId}}\" label=\"Número de documento 1\" ng-model=\"$ctrl.ngModel.numero_documento\"\r\n        maxlength=\"10\" ng-directives=\"uppercase numeric\" ng-keyup = \"$ctrl.nombreDel()\"\r\n        \r\n        ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"\r\n        ng-if=\"$ctrl.ngModel.tipo_documento == 'TD_CI'\" ></c-input> <!--ng-required=\"!$ctrl.modoVista\"   2022-->\r\n\r\n        <c-input name=\"documento_identidad{{$ctrl.ngId}}\" label=\"Número de documento 2\" ng-model=\"$ctrl.ngModel.numero_documento\"\r\n        maxlength=\"15\" ng-directives=\"uppercase passport\" ng-keyup = \"$ctrl.nombreDel()\"\r\n        \r\n        ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"\r\n        ng-if=\"$ctrl.ngModel.tipo_documento == 'TD_PASS'\"></c-input><!--ng-required=\"!$ctrl.modoVista\"  2022-->\r\n      </div>\r\n      <div class=\"{{ !$ctrl.modoVista? 'col-md-4' : 'col-md-4' }}\">\r\n        <c-input name=\"complemento{{$ctrl.ngId}}\" label=\"Complemento\" ng-model=\"$ctrl.ngModel.complemento\"\r\n        maxlength=\"2\" ng-directives=\"uppercase passport\"\r\n        ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"></c-input>\r\n      </div>\r\n\r\n      <div class=\"{{ !$ctrl.modoVista? 'col-md-4' : 'col-md-4' }}\">\r\n        <c-date name=\"fecha_nacimiento{{$ctrl.ngId}}\" label=\"Fecha de nacimiento\" ng-model=\"$ctrl.ngModel.fecha_nacimiento\"\r\n        min-date=\"$ctrl.minDate\" max-date=\"$ctrl.maxDate\"\r\n        \r\n        ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"></c-date><!--ng-required=\"!$ctrl.modoVista\"   2022-->\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-4\">\r\n        <c-input name=\"primer_apellido{{$ctrl.ngId}}\" label=\"Primer Apellido\" ng-model=\"$ctrl.ngModel.primer_apellido\"\r\n        ng-directives=\"alpha uppercase\" maxlength=\"100\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"></c-input>\r\n      </div>\r\n\r\n      <div class=\"col-md-4\">\r\n        <c-input name=\"segundo_apellido{{$ctrl.ngId}}\" label=\"Segundo Apellido\" ng-model=\"$ctrl.ngModel.segundo_apellido\"\r\n        ng-directives=\"alpha uppercase\" maxlength=\"100\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"></c-input>\r\n      </div>\r\n\r\n      <div class=\"col-md-4\">\r\n        <c-input name=\"nombres{{$ctrl.ngId}}\" label=\"Nombre(s)\" ng-model=\"$ctrl.ngModel.nombres\" \r\n        ng-directives=\"alpha uppercase\" maxlength=\"100\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"></c-input><!--ng-required=\"!$ctrl.modoVista\"  2022-->\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\" ng-if=\"!$ctrl.modoVista\">\r\n<!--         <button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.contrastar()\" ng-disabled=\"$ctrl.isDisabled()\" ng-if=\"!$ctrl.ngDisabled && !$ctrl.ngModel.noVerificar && !$ctrl.isFill()\">\r\n          <i class=\"fa fa-search\"></i>Verificar\r\n        </button>\r\n        <span ng-if=\"!$ctrl.ngDisabled && !$ctrl.isFill()\"> &nbsp; <input type=\"checkbox\" name=\"no_verificar\" ng-model=\"$ctrl.ngModel.noVerificar\"></input> Verificar después</span>\r\n        <div class=\"alert alert-warning\" ng-if=\"$ctrl.ngModel.noVerificar\">\r\n          <i class=\"fa fa-info-circle\"></i>\r\n          <span>Al marcar la casilla Ud. asegura que los datos son correctos, ya que el número de documento es el respectivo usuario y este sera relacionado a los datos de la persona registrada.</span>\r\n        </div> -->\r\n       <!--  <button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.search()\" ng-disabled=\"$ctrl.isDisabled()\" ng-if=\"!$ctrl.isFill() && $ctrl.isCI()\">\r\n          <i class=\"fa fa-search\"></i>Buscar -->\r\n        <!-- <button md-effect type=\"button\" class=\"btn\" ng-click=\"$ctrl.nombreDel()\" ng-if=\"$ctrl.isFill()\">\r\n          <i class=\"fa fa-edit\"></i>Cambiar\r\n        </button> -->\r\n      </div>\r\n    </div>\r\n  </ng-form>\r\n</div>\r\n"

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-file-upload\">\n    <!-- 3. nv-file-over uploader=\"link\" over-class=\"className\" -->\n    <div ng-show=\"uploader.isHTML5\">\n        <!-- Example: ng-file-drop | ng-file-drop=\"options\" -->\n        <label for=\"{{ $ctrl.idFile }}\" nv-file-drop=\"\" nv-file-over=\"\" uploader=\"uploader\" over-class=\"other-over-zone\" class=\"other-drop-zone zone\">\n            <span ng-if=\"!$ctrl.textUpload\">Arrastre su{{ $ctrl.multiple ? 's' : ''}} archivo{{ $ctrl.multiple ? 's' : ''}} aquí <br> o <br> haga click aquí</span>\n            <span ng-if=\"$ctrl.textUpload\" ng-bind-html=\"$ctrl.textUpload\"></span>\n        </label>\n    </div>\n    <!-- Example: nv-file-select=\"\" uploader=\"{Object}\" options=\"{Object}\" filters=\"{String}\" -->\n    <!-- <label for=\"{{ $ctrl.idFile }}\" md-effect class=\"btn btn-outline-default\">\n        <i class=\"fa fa-paperclip\"></i> Seleccionar archivo{{ $ctrl.multiple ? 's' : ''}}\n    </label> -->\n    <input type=\"file\" nv-file-select=\"\" ng-if=\"$ctrl.multiple === undefined\" uploader=\"uploader\" id=\"{{ $ctrl.idFile }}\" class=\"ng-hide\"/>\n    <input type=\"file\" nv-file-select=\"\" ng-if=\"$ctrl.multiple\" uploader=\"uploader\" id=\"{{ $ctrl.idFile }}\" multiple class=\"ng-hide\"/>\n    <ul>\n        <li ng-repeat=\"item in uploader.queue\" class=\"ui-file-container\">\n            <div ng-show=\"uploader.isHTML5\">\n                <div class=\"progress\">\n                    <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ 'width': item.progress + '%' }\"></div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-4\" ng-if=\"$ctrl.isImage(item._file)\">\n                    <div class=\"ui-file-img\">\n                        <!-- Image preview -->\n                        <!--auto height-->\n                        <!--<div ng-thumb=\"{ file: item.file, width: 100 }\"></div>-->\n                        <!--auto width-->\n                        <div ng-thumb=\"{ file: item._file, height: 100 }\"></div>\n                        <!--fixed width and height -->\n                        <!--<div ng-thumb=\"{ file: item.file, width: 100, height: 100 }\"></div>-->\n                    </div>\n                </div>\n                <div class=\"col-md-{{ $ctrl.isImage(item._file) ? '8' : '12' }}\">\n                    <p><strong>Nombre del archivo:</strong> {{ item.file.name }}</p>\n                    <p><strong>Tamaño:</strong> {{ item.file.size/1024/1024|number:2 }} Mb</p>\n                    <div class=\"ui-file-buttons\">\n                        <button type=\"button\" class=\"btn btn-primary btn-sm\" md-effect ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" ng-hide=\"item.isUploading\">\n                            <i class=\"fa fa-upload\"></i> {{ $ctrl.label || 'Subir' }}\n                        </button>\n                        <button type=\"button\" class=\"btn btn-outline-default btn-sm\" md-effect ng-click=\"item.cancel()\" ng-disabled=\"!item.isUploading\" ng-hide=\"!item.isUploading\">\n                            <i class=\"fa fa-ban\"></i> Cancelar\n                        </button>\n                        <button type=\"button\" class=\"btn btn-danger btn-sm\" md-effect ng-click=\"item.remove()\" uib-tooltip=\"Eliminar archivo\">\n                            <i class=\"fa fa-trash\"></i>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </li>\n    </ul>\n    <div ng-if=\"$ctrl.multiple\">\n        <div>\n            <div class=\"progress\">\n                <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ 'width': uploader.progress + '%' }\"></div>\n            </div>\n        </div>\n        <button type=\"button\" class=\"btn btn-primary btn-sm\" md-effect ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\">\n            <i class=\"fa fa-upload\"></i> Subir todo\n        </button>\n        <button type=\"button\" class=\"btn btn-outline-default btn-sm\" md-effect ng-click=\"uploader.cancelAll()\" ng-disabled=\"!uploader.isUploading\">\n            <i class=\"fa fa-ban\"></i> Cancelar todo\n        </button>\n        <button type=\"button\" class=\"btn btn-danger btn-sm\" md-effect ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\">\n            <i class=\"fa fa-trash\"></i> Eliminar todo\n        </button>\n    </div>\n</div>"

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports = "<label class=\"label-form\">{{$ctrl.label}}</label>\n\n<div class=\"ui-file-upload\">\n  <input type=\"file\" nv-file-select=\"\" ng-if=\"$ctrl.multiple === undefined\" uploader=\"uploader\" id=\"{{ $ctrl.idFile }}\" class=\"ng-hide\" accept=\"{{$ctrl.mimeTypes}}\" />\n  <input type=\"file\" nv-file-select=\"\" ng-if=\"$ctrl.multiple\" uploader=\"uploader\" id=\"{{ $ctrl.idFile }}\" multiple class=\"ng-hide\" accept=\"{{$ctrl.mimeTypes}}\" />\n\n  <div ng-show=\"uploader.isHTML5\">\n    <label for=\"{{ $ctrl.idFile }}\" nv-file-drop=\"\" nv-file-over=\"\" uploader=\"uploader\" over-class=\"other-over-zone\" class=\"other-drop-zone zone noselect\" uuib-tooltip=\"Seleccione archivo\">\n      <span ng-if=\"!$ctrl.textUpload\">Seleccione {{ $ctrl.multiple ? 'los' : 'un' }} archivo {{ $ctrl.multiple ? 's' : '' }}</span><span ng-if=\"!$ctrl.Util.isMobile()\">o arrástrelo {{ $ctrl.multiple ? 's' : ''}} aquí</span>\n      <br><span ng-if=\"$ctrl.$$maxsize\">Debe pesar hasta <strong>{{$ctrl.maxsize}}</strong></span>\n      <br><span ng-if=\"$ctrl.$$maxsize\" ng-bind-html=\"$ctrl.getTypes().message\"></span>\n      <span ng-if=\"$ctrl.textUpload\" ng-bind-html=\"$ctrl.textUpload\"></span>\n    </label>\n  </div>\n\n  <ul>\n    <li ng-repeat=\"item in uploader.queue\" class=\"ui-file-container\">\n      <div ng-show=\"uploader.isHTML5\">\n        <div class=\"progress\">\n          <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ 'width': item.progress + '%' }\"></div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <p><strong>Nombre del archivo:</strong> {{ item.file.name }}</p>\n          <p><strong>Tamaño:</strong> {{ item.file.size/1024/1024|number:2 }} Mb</p>\n          <div class=\"ui-file-buttons\">\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" md-effect ng-click=\"$ctrl.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" ng-hide=\"item.isUploading\" ng-if=\"$ctrl.uploadCallback\">\n              <i class=\"fa fa-upload\"></i> {{ $ctrl.labelSubir || 'Subir' }}\n            </button>\n            <button type=\"button\" class=\"btn btn-outline-default btn-sm\" md-effect ng-click=\"item.cancel()\" ng-disabled=\"!item.isUploading\" ng-hide=\"!item.isUploading\">\n              <i class=\"fa fa-ban\"></i> Cancelar\n            </button>\n            <button type=\"button\" class=\"btn btn-danger btn-sm\" md-effect ng-click=\"$ctrl.remove(item)\" uib-tooltip=\"Eliminar archivo\">\n              <i class=\"fa fa-trash\"></i>\n            </button>\n          </div>\n        </div>\n      </div>\n    </li>\n  </ul>\n  <div ng-if=\"$ctrl.multiple\">\n    <div>\n      <div class=\"progress\">\n        <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ 'width': uploader.progress + '%' }\"></div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-6 col-sm-12 text-center\">\n        <button type=\"button\" class=\"btn btn-primary btn-md btn-width\" md-effect ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\" ng-if=\"false\">\n          <i class=\"fa fa-upload\"></i> Subir todo\n        </button>\n      </div>\n      <div class=\"col-md-6 col-sm-12 text-center\">\n        <button type=\"button\" class=\"btn btn-outline-default btn-md btn-width\" md-effect ng-click=\"uploader.cancelAll()\" ng-disabled=\"!uploader.isUploading\" ng-if=\"false\">\n          <i class=\"fa fa-ban\"></i> Cancelar todo\n        </button>\n      </div>\n      <div class=\"col-md-6 col-sm-12 text-center\">\n        <button type=\"button\" class=\"btn btn-danger btn-md btn-width\" md-effect ng-click=\"$ctrl.clearQueue(uploader)\" ng-disabled=\"!uploader.queue.length\">\n          <i class=\"fa fa-trash\"></i> Eliminar todo\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"select_date_form\">\r\n<div class=\"select-date form-group\">\r\n  <label ng-class=\"{'ap-req':$ctrl.ngRequired}\">{{$ctrl.label}}</label>\r\n  <div class=\"row mx-0\">\r\n    <input name=\"fecha\" numeric  maxlength=\"2\" minlength=\"1\" class=\"col-md-2 form-control day\" ng-model=\"$ctrl.day\" ng-change=\"$ctrl.changeDate('day')\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\" placeholder=\"Día\">\r\n    <select name=\"fecha\" class=\"col-md-5 form-control month\" ng-model=\"$ctrl.month\" ng-change=\"$ctrl.changeDate('month')\" size ng-required=\"$ctrl.ngRequired\"  ng-disabled=\"$ctrl.ngDisabled\">\r\n      <option selected value=\"\" ng-if=\"!$ctrl.month\">Mes</option>\r\n      <option ng-repeat=\"item in $ctrl.months\" ng-value=\"{{item.val}}\">{{item.name}}</option>\r\n    </select>\r\n    <input name=\"fecha\" numeric maxlength=\"4\" minlength=\"4\" class=\"col-md-2 form-control year\" ng-model=\"$ctrl.year\" ng-change=\"$ctrl.changeDate('year')\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\"  placeholder=\"Año\" >\r\n  </div>\r\n  <div ap-error ng-messages=\"select_date_form.fecha.$error\" role=\"alert\" ng-if=\"select_date_form.fecha.$touched\">\r\n    <div ng-message=\"required\">La fecha es requerida</div>\r\n    <div ng-message=\"minlength\">La fecha es requerida</div>\r\n    <div ng-message=\"maxlength\">La fecha es requerida</div>\r\n  </div>\r\n  <!-- <pre>{{select_date_form.fecha |json}}</pre> -->\r\n</div>\r\n</ng-form>\r\n"

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"dep_pro_mun_form\">\n  <div class=\"row\">\n    <div class=\"form-group col-md-4\">\n      <uib-select name=\"departamento\" label=\"Departamento:\" ng-model=\"$ctrl.departamento\" items=\"$ctrl.departamentos\" key-value=\"id\" key-text=\"descripcion\" placeholder=\"Seleccione...\" ng-required=\"$ctrl.conf.fid_departamento.requerido\" ng-disabled=\"$ctrl.conf.fid_departamento.disabled\"></uib-select>\n      <div ap-error ng-messages=\"dep_pro_mun_form.departamento.$error\" role=\"alert\" ng-if=\"dep_pro_mun_form.departamento.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n\n    <div class=\"form-group col-md-4\">\n      <uib-select name=\"provincia\" label=\"Provincia:\" ng-model=\"$ctrl.provincia\" items=\"$ctrl.provincias\" key-value=\"id\" key-text=\"nombre\" placeholder=\"Seleccione...\" ng-required=\"$ctrl.conf.fid_provincia.requerido\" ng-disabled=\"$ctrl.conf.fid_provincia.disabled\"></uib-select>\n      <div ap-error ng-messages=\"dep_pro_mun_form.provincia.$error\" role=\"alert\" ng-if=\"dep_pro_mun_form.provincia.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n\n    <div class=\"form-group col-md-4\">\n      <uib-select name=\"municipio\" label=\"Municipio:\" ng-model=\"$ctrl.municipio\" items=\"$ctrl.municipios\" key-value=\"id\" key-text=\"nombre\" placeholder=\"Seleccione...\" ng-required=\"$ctrl.conf.fid_municipio.requerido\" ng-disabled=\"$ctrl.conf.fid_municipio.disabled\"></uib-select>\n      <div ap-error ng-messages=\"dep_pro_mun_form.municipio.$error\" role=\"alert\" ng-if=\"dep_pro_mun_form.municipio.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n  </div>\n</ng-form>\n"

/***/ }),
/* 703 */
/***/ (function(module, exports) {

	module.exports = "<c-select name=\"{{$ctrl.name}}\"\n  label=\"{{$ctrl.label}}\"\n  ng-model=\"$ctrl.ngModel\"\n  options=\"$ctrl.items\"\n  key-value=\"{{ !$ctrl.selectModel? 'codigo' : $ctrl.selectModel }}\"\n  ng-disabled=\"$ctrl.ngDisabled\"\n  ng-required=\"$ctrl.ngRequired\">\n</c-select>\n"

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"image-viewer\" ng-attr-style=\"height:{{$ctrl.height?$ctrl.height+'px':'600px'}}\">\n  <div class=\"controls\">\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imageZoom(-20)\" title=\"Alejar\"><i class=\"fa fa-minus\"></i></button>\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imageZoom(20)\" title=\"Acercar\"><i class=\"fa fa-plus\"></i></button>\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imageRotate()\" title=\"Rotar\"><i class=\"fa fa-rotate-right\"></i></button>\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imageDownload()\" title=\"Descargar\"><i class=\"fa fa-download\"></i></button>\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imagePrint()\" title=\"Imprimir\"><i class=\"fa fa-print\"></i></button>\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imageInvert()\" title=\"Invertir color\"><i class=\"fa fa-exchange\"></i></button>\n    <!-- <button type=\"button\" class=\"btn-flat\" ng-click=\"imageSave()\" title=\"Guardar cambios\" ng-disabled=\"!modificado\"><i class=\"fa fa-save\"></i></button> -->\n    <span>{{imageDet.size}} {{imageDet.unit}}</span>\n    <span>{{imageWidth}}x{{imageHeight}}</span>\n  </div>\n  <div class=\"image-container\" ng-attr-style=\"height:{{$ctrl.height?($ctrl.height-550)+'px':'550px'}}\">\n    <canvas></canvas>\n    <img ng-attr-id=\"image-viewer{{$ctrl.id?('-'+$ctrl.id):''}}\" style=\"display:none;\"/>\n  </div>\n</div>\n"

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"document-area\" ng-if=\"!$ctrl.base64 && !$ctrl.pdfUrl\">\n  <div class=\"loading\">\n    <h3>Cargando documento, por favor espere ...</h3>\n  </div>\n</div>\n<div class=\"pdfviewer\" ng-if=\"$ctrl.base64 || $ctrl.pdfUrl\">\n  <ng-pdf class=\"ng-pdf\" data=\"$ctrl.pdfUrl\" data64=\"$ctrl.base64\" style=\"height:100%\"\n  name=\"{{$ctrl.name}}\" scale=\"{{$ctrl.scale}}\" page=\"{{$ctrl.page}}\"\n  download=\"{{$ctrl.download}}\" print=\"{{$ctrl.print}}\" open=\"{{$ctrl.open}}\"></ng-pdf>\n</div>\n"

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = "<nav ng-class=\"getNavStyle(scroll)\">\n  <div class=\"pdfviewer-control pageUp\" ng-if=\"pageLimit<pageCount\">\n    <button type=\"button\" ng-click=\"goPrevious()\"><span>&lt;</span></button>\n  </div>\n  <div class=\"pdfviewer-control pageDown\" ng-if=\"pageLimit<pageCount\">\n    <button type=\"button\" ng-click=\"goNext()\"><span>&gt;</span></button>\n  </div>\n  <div class=\"pdfviewer-control zoomOut\">\n    <button type=\"button\" ng-click=\"zoomOut()\"><span>-</span></button>\n  </div>\n  <div class=\"pdfviewer-button\">\n    <button type=\"button\" ng-click=\"fit()\"><span>100%</span></button>\n  </div>\n  <div class=\"pdfviewer-control zoomIn\">\n    <button type=\"button\" ng-click=\"zoomIn()\"><span>+</span></button>\n  </div>\n  <div class=\"pdfviewer-button\">\n    <!-- <button type=\"button\" ng-click=\"rotate()\"><span>Rotar</span></button> -->\n  </div>\n\n  <div class=\"pdfviewer-control page-num\" ng-hide=\"pageLimit>=pageCount\">\n    <span>Página:</span>\n    <input type=\"text\" min=1 ng-model=\"pageNum\" size=\"1\"> de\n    <span> {{pageCount}}</span>\n  </div>\n  <div class=\"pdfviewer-control page-num\" ng-hide=\"pageLimit<pageCount\">\n    <span>Páginas: </span>\n    <span> {{pageCount}}</span>\n  </div>\n\n  <!-- <div class=\"pdfviewer-control presentationMode\">\n    <button type=\"button\" ng-click=\"fullscreen()\"><span>-</span></button>\n  </div> -->\n  <div class=\"pdfviewer-control print\" ng-if=\"!detectIE() && getMobileOS()==false && print\">\n    <button type=\"button\" ng-click=\"printFile()\"><span>-</span></button>\n  </div>\n  <div class=\"pdfviewer-control download\" ng-if=\"download\">\n    <button type=\"button\" ng-click=\"downloadFile()\"><span>-</span></button>\n  </div>\n</nav>\n\n<hr class=\"separator\">\n\n{{loading}}"

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i> Cambiar contrase&ntilde;a</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n    <form name=\"form\">\n      <div class=\"row\">\n        <div class=\"col-12 alert alert-info\">\n          <i class=\"fa fa-info-circle\"></i> <strong>IMPORTANTE:</strong>\n          <ul class=\"btm-0\">\n            <li>Debe escribir su contraseña actual (se distingue entre mayúsculas y minúsculas).</li>\n            <!-- <li>Su contraseña nueva debe tener hasta 16 caracteres.</li> -->\n            <li>Luego de modificar su contraseña, se cerrará su sesión y se le redirigirá a la página de inicio automáticamente.</li>\n          </ul>\n        </div>\n        <div class=\"col-sm-12\">\n          <c-input type=\"password\" name=\"actual\" label=\"Contraseña actual\" ng-model=\"$ctrl.datos.actual\" ng-minlength=\"3\" ng-maxlength=\"16\" maxlength=\"16\" ng-required=\"true\" uib-tooltip=\"Escriba la contraseña actual.\"></c-input>\n        </div>\n        <!-- div class=\"col-sm-6\">\n          <c-input type=\"text\" name=\"nombre\" label=\"Usuario\" ng-model=\"$ctrl.datos.usuario\" ng-minlength=\"3\" ng-maxlength=\"32\" maxlength=\"32\" ng-required=\"true\" uib-tooltip=\"Escriba su nombre de usuario.\" ng-validation=\"alfa-numerico\"></c-input>\n        </div -->\n        <div class=\"col-sm-12\">\n          <c-input type=\"password\" name=\"nueva\" label=\"Nueva contraseña\" ng-model=\"$ctrl.datos.nueva\" ng-minlength=\"3\" ng-maxlength=\"16\" maxlength=\"16\" ng-required=\"true\" uib-tooltip=\"Escriba la nueva contraseña.\" ng-validation=\"alfa-numerico\" ></c-input>\n        </div>\n        <div class=\"col-sm-12\">\n          <c-input type=\"password\" name=\"confirmado\" label=\"Repita la nueva contraseña\" ng-model=\"$ctrl.datos.confirmado\" ng-minlength=\"3\" ng-maxlength=\"16\" maxlength=\"16\" ng-required=\"true\" uib-tooltip=\"Vuelva a escribir la nueva contraseña.\" c-ui-validate=\"{contrasena:'$ctrl.form.confirmado.$viewValue==$ctrl.form.nueva.$modelValue'}\" c-ui-validate-watch=\"'$ctrl.form.nueva.$modelValue'\" message-error-password=\"Las nuevas contraseñas no son iguales. Revise por favor.\"></c-input>\n        </div>\n      </div>\n    </form>\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n    <i class=\"fa fa-close\"></i> Cerrar\n  </button>\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"$ctrl.enviando || form.$invalid\">\n    <i class=\"fa fa-check\"></i> Modificar\n  </button>\n</div>\n"

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-expand\">\n    <div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\n        <ul class=\"navbar-nav mr-auto\">\n            <li class=\"nav-item\">\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.toggleSidenav()\">\n                    <i class=\"fa fa-bars\"></i>\n                </button>\n            </li>\n            <li class=\"nav-item\">\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.refresh()\">\n                    <i class=\"fa fa-refresh\"></i>\n                </button>\n            </li>\n            <li class=\"nav-item\">\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.fullscreen()\">\n                    <i class=\"fa fa-arrows-alt\"></i>\n                </button>\n            </li>\n            <!-- <li class=\"nav-item\">\n                <button type=\"button\" class=\"btn btn-link\">\n                    <i class=\"fa fa-bell-o\"></i>\n                </button>\n            </li> -->\n        </ul>\n        <div class=\"navbar-nav navbar-buttons my-2 my-lg-0\">\n            <div class=\"nav-item dropdown\" uib-dropdown is-open=\"status.isopen1\">\n                <a id=\"single-button\" href=\"\" class=\"nav-link\" uib-dropdown-toggle>\n                    {{$ctrl.user.rol.descripcion}}\n                </a>\n                <div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"navbarDropdownMenuLink\" style=\"margin-top: -40px;\" ng-if=\"$ctrl.user.roles.length>1\">\n                    <a class=\"dropdown-item\" href=\"\" ng-repeat=\"rol in $ctrl.user.roles\" ng-click=\"$ctrl.changeRol(rol)\"><i class=\"fa fa-user-circle-o\"></i> {{rol.nombre}}</a>\n                </div>\n            </div>\n        </div>\n        <div class=\"navbar-nav navbar-buttons my-2 my-lg-0\">\n            <div class=\"nav-item dropdown\" uib-dropdown is-open=\"status.isopen\">\n                <a id=\"single-button\" href=\"\" class=\"nav-link\" uib-dropdown-toggle>\n                    <i class=\"fa fa-ellipsis-v\"></i>\n                </a>\n                <div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"navbarDropdownMenuLink\" style=\"margin-top: -40px;\">\n                    <a class=\"dropdown-item\" href=\"\" ng-if=\"$ctrl.user.rol.nombre!='EMPRESA'\" ng-click=\"$ctrl.account()\"><i class=\"fa fa-user\"></i> Cambiar contraseña</a>\n                    <!-- <a class=\"dropdown-item\" href=\"\"><i class=\"fa fa-cog\"></i> Configuraciones</a> -->\n                    <hr>\n                    <a class=\"dropdown-item\" href=\"\" ng-click=\"$ctrl.logout()\"><i class=\"fa fa-sign-out\"></i> Cerrar sesión</a>\n                </div>\n            </div>\n        </div>\n    </div>\n</nav>\n"

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sidenav\">\n    <div class=\"sidenav-app\">\n        <div class=\"sidenav-logo text-primary\">\n            <span class=\"sidenav-logo-sistema\"></span>\n        </div>\n        <h1 class=\"sidenav-title\">{{ $ctrl.systemName }}</h1>\n    </div>\n    <div class=\"sidenav-user\" ng-if=\"$ctrl.getSidenav()\">\n        <figure class=\"sidenav-user-photo rounded-circle bg-{{ $ctrl.getColor() }}\">{{ $ctrl.getInitial() }}</figure>\n        <div class=\"sidenav-user-info\">\n            <label class=\"sidenav-user-name\" uib-tooltip=\"{{ $ctrl.getName() }}\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\">{{ $ctrl.getName() }}</label>\n            <label class=\"sidenav-user-mail\" uib-tooltip=\"{{ $ctrl.getEmail() }}\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-envelope-o\"></i> {{ $ctrl.getEmail() }}</label>\n        </div>\n    </div>\n    <div class=\"sidenav-container\" id=\"sidenav-menu\" ng-if=\"$ctrl.getVisible()\">\n        <ul class=\"sidenav-menu\">\n            <li ng-repeat=\"option in $ctrl.getMenu()\">\n                <a md-effect class=\"sidenav-item\" href=\"\" ng-click=\"$ctrl.send(option.url, option.submenu.length)\" toggle-menu data-url=\"{{option.url || option.label }}\">\n                    <span class=\"sidenav-icon rounded-circle bg-{{option.color}}\"><i class=\"fa fa-{{option.icon}}\"></i></span>\n                    <label class=\"sidenav-item-text\">{{ option.label }}</label>\n                    <span class=\"sidenav-item-arrow\" ng-if=\"option.submenu.length\"><i class=\"fa fa-angle-right\"></i></span>\n                </a>\n                <ul class=\"sidenav-submenu\" ng-if=\"option.submenu.length\">\n                    <li ng-repeat=\"sub in option.submenu\">\n                        <a md-effect class=\"sidenav-submenu-item btn-default\" href=\"\" data-url=\"{{sub.url}}\" ng-class=\"{ 'active' : $ctrl.url == sub.url }\" ng-click=\"$ctrl.send(sub.url)\">\n                          <span class=\"sidenav-icon bg-{{option.color}}\"><i class=\"fa fa-{{sub.icon}}\"></i></span>\n                          {{ sub.label }}\n                        </a>\n                    </li>\n                </ul>\n            </li>\n        </ul>\n    </div>\n</div>"

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n\t<h3 class=\"page-title\"><i class=\"fa fa-bars\"></i> Nueva Cartera</h3>\n\t<div class=\"card\">\n\t\t<div class=\"card-body\">\n\t\t\t<form name=\"FormEjemplo\" novalidate>\n\t\t\t\t<c-input-numeric name=\"input_nombre\" label=\"Num Cartera\" ng-model=\"$ctrl.cartera\" ng-required=\"true\"></c-input-numeric>\n\t\t\t\t<c-input name=\"input_nombre\" label=\"Descripcion\" ng-model=\"$ctrl.descripcion\" ng-required=\"true\"></c-input>\n\t\t\t\t<button uib-tooltip=\"Bot�n primary tooltip\" tooltip-placement=\"top\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.guardar()\">\n\t\t\t\t\t<i class=\"fa fa-check\"></i> Guardar\n\t\t\t\t</button>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n\t<div>\n\t\t<table class=\"table table-striped\">\n\t\t\t<tr class=\"thead-dark\">\n\t\t\t\t<th>id_cartera</th>\n\t\t\t\t<th>Cartera</th>\n\t\t\t\t<th>Descripci�n</th>\n\t\t\t</tr>\n\t\t\t<tr ng-repeat=\"(key,value) in $ctrl.carteras track by key\">\n\t\t\t\t<td>{{value.id_cartera}}</td>\n\t\t\t\t<td>{{value.num_cartera}}</td>\n\t\t\t\t<td>{{value.descripcion}}</td>\n\t\t\t</tr>\n\t\t</table>\n\t</div>\n\t\n</div>\n"

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n\n  <div class=\"card\">\n\t <h2 class=\"page-title\">\n\t\t  <i class=\"fa fa-bars\"></i> Proyecto : <small><strong>{{$ctrl.proyecto[0].nombre}}</strong></small>\n\t </h2>\n\t <div class=\"card-body\" >\n\t\t<ng-form name=\"formProyecto\">\n\t\t  <uib-tabset active=\"active\">\n\t\t\t <uib-tab index=\"0\" heading=\"Convenios\">\n\t\t\t\t<section ng-init=\"$ctrl.proyecto.convenio.$_plantilla=5; $ctrl.proyecto.convenio.$_nombre='convenio'\">\n\t\t\t\t\t<h6 class=\"title-section m-top\">\n\t\t\t\t\t\t <i class=\"fa fa-hand-o-right\"></i> Convenio {{$ctrl.proyecto[0].numero_convenio}}\n\t\t\t\t\t</h6>\n\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t<div class=\"col-md-12 col-lg-12\">\n\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"md-input-group col-md-12\">\n\t\t\t\t\t\t\t\t\t\t<c-input name=\"nro_convenio\" label=\"Numero de Convenio\" ng-model=\"$ctrl.proyecto[0].numero_convenio\" ng-minlength=\"3\" maxlength=\"100\" ng-disabled=\"true\">\n\t\t\t\t\t\t\t\t\t\t</c-input>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"md-input-group col-md-6\">\n\t\t\t\t\t\t\t\t\t\t<c-input name=\"nombre_proyecto\" label=\"Nombre de Proyecto :\" ng-model=\"$ctrl.proyecto[0].nombre\" ng-minlength=\"3\"  ng-disabled=\"true\"></c-input>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"md-input-group col-md-6\">\n\t\t\t\t\t\t\t\t\t<c-input name=\"Cartera\" label=\"Cartera\" ng-model=\"$ctrl.proyecto[0].cartera\"\n\t\t\t\t\t\t\t\t\tng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('doc_convenio')\"\n\t\t\t\t\t\t\t\t\tng-disabled=\"true\"\n\t\t\t\t\t\t\t\t\tng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('doc_convenio')\"></c-input>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"md-input-group col-md-6\" >\n\t\t\t\t\t\t\t\t\t<c-input name=\"departamento\" label=\"Departamento\" ng-model=\"$ctrl.proyecto[0].dep\" ng-minlength=\"3\" maxlength=\"100\" ng-disabled=\"true\"></c-input>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"md-input-group col-md-6\">\n\t\t\t\t\t\t\t\t\t<c-input name=\"municipio\" label=\"Municipio\" ng-model=\"$ctrl.proyecto[0].mun\" ng-minlength=\"3\" maxlength=\"100\" ng-disabled=\"true\"\t></c-input>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div ng-if=\"$ctrl.proyecto.convenio.fecha_suscripcion && $ctrl.proyecto.orden_proceder\">\n\t\t\t\t\t  <h6 class=\"title-section m-top\">\n\t\t\t\t\t\t <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 1\n\t\t\t\t\t  </h6>\n\t\t\t\t\t  <div class=\"row\">\n\t\t\t\t\t\t <div class=\"col-md-12 col-lg-6\">\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t  <div class=\"md-input-group col-md-6\">\n\t\t\t\t\t\t\t\t <c-select name=\"tipo_plazo\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado\"\n\t\t\t\t\t\t\t\t\t  options=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\t\t\t\t\t\t  ng-disabled=\"($ctrl.proyecto.convenio.plazo_convenio_ampliado2 > 0) || !$ctrl.Proyecto.esEditable('doc_convenio_extendido')\">\n\t\t\t\t\t\t\t\t </c-select>\n\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t  <div class=\"md-input-group col-md-6\">\n\t\t\t\t\t\t\t\t <c-input name=\"plazo_convenio_ampliado\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado\"\n\t\t\t\t\t\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio1()\"\n\t\t\t\t\t\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n\t\t\t\t\t\t\t\t\tng-disabled=\"($ctrl.proyecto.convenio.plazo_convenio_ampliado2 > 0) || !$ctrl.Proyecto.esEditable('doc_convenio_extendido')\">\n\t\t\t\t\t\t\t\t </c-input>\n\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t  <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado > 0\">\n\t\t\t\t\t\t\t\t <c-date name=\"fecha_ampliacion_con\" label=\"1ra fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio1\"\n\t\t\t\t\t\t\t\t\tng-required=\"true\"\n\t\t\t\t\t\t\t\t\tng-disabled=\"true\">\n\t\t\t\t\t\t\t\t </c-date>\n\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t </div>\n\n\t\t\t\t\t  </div>\n\t\t\t\t\t  <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado > 0\">\n\t\t\t\t\t\t <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 2\n\t\t\t\t\t  </h6>\n\t\t\t\t\t  <div class=\"row\" ng-if=\"($ctrl.proyecto.convenio.plazo_convenio_ampliado > 0)\">\n\t\t\t\t\t\t <div class=\"col-md-12 col-lg-6\">\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t  <div class=\"md-input-group col-md-6\">\n\t\t\t\t\t\t\t\t <c-select name=\"tipo_plazo2\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado2\"\n\t\t\t\t\t\t\t\t\t  options=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\t\t\t\t\t\t  ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido')\">\n\t\t\t\t\t\t\t\t </c-select>\n\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t  <div class=\"md-input-group col-md-6\">\n\t\t\t\t\t\t\t\t <c-input name=\"plazo_convenio_ampliado2\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado2\"\n\t\t\t\t\t\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio2()\"\n\t\t\t\t\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido')\">\n\t\t\t\t\t\t\t\t </c-input>\n\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t  <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado2 > 0\">\n\t\t\t\t\t\t\t\t <c-date name=\"fecha_ampliacion_con2\" label=\"2da fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio2\"\n\t\t\t\t\t\t\t\t ng-required=\"true\"\n\t\t\t\t\t\t\t\t ng-disabled=\"true\"></c-date>\n\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\n\t\t\t\t\t  </div>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t\t\t\t<div class=\"md-input-group col-md-6\">\n\t\t\t\t\t <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.verArchivo()\" tittle=\"ver Convenio\"> ver convenio</button>\n\t\t\t\t</div>\n\t\t\t\t<!-- <iframe src=\"{{$ctrl.urlIframe}}\"></iframe> -->\n\t\t\t </uib-tab>\n\t\t  </uib-tabset>\n\t\t</ng-form>\n\n\t </div>\n  </div>\n</div>\n"

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-{{ $ctrl.icon }}\" ng-if=\"$ctrl.icon\"></i> {{ $ctrl.title }}</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-if=\"$ctrl.btnClose\" ng-click=\"$ctrl.close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <!-- <iframe src=\"{{$ctrl.data}}\" style=\"width: 100%;height: 480px;\"></iframe> -->\n    <pdf-viewer base64=\"$ctrl.data\" height=\"400px\" scale=\"page-fit\" download=\"true\" print=\"false\" page=\"1\"></pdf-viewer>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.close()\" ng-if=\"$ctrl.cancel\">\n        <i class=\"fa fa-close\"></i> {{ $ctrl.labelCancel || 'Cancelar'}}\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n        <i class=\"fa fa-check\"></i> {{ $ctrl.labelOk || 'Aceptar' }}\n    </button>\n</div>"

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Cambiar C&oacute;digo\" ng-click=\"$ctrl.verRegistro()\">\n  <i class=\"fa fa-cog\"></i>\n</button>\n"

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	module.exports = "<form>\n<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Cambiar Nro Convenio</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"codigo\" label=\"Nro Convenio\" ng-model=\"$ctrl.proyecto.nro_convenio\"></c-input>\n  </div>\n  <div class=\"col-md-12 bg-warning\" ng-if=\"$ctrl.duplicados.length > 0\">\n    Proyectos con código {{$ctrl.proyecto.nro_convenio}}:\n    <ul ng-class=\"{'bg-warning':$ctrl.duplicados}\" style=\"font-size:10px\">\n      <li ng-repeat=\"nom in $ctrl.duplicados\">{{nom}}</li>\n    </ul>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-default\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.corregir()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n</form>"

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-cogs\"></i> Ejemplos de <strong>Componentes</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <h3>Botones</h3>\n      <div>\n        <button uib-tooltip=\"Botón default tooltip\" md-effect class=\"btn btn-default\">\n          <i class=\"fa fa-home\"></i> Botón default\n        </button>\n        <button uib-tooltip=\"Botón primary tooltip\" tooltip-placement=\"top\" md-effect class=\"btn btn-primary\">\n          <i class=\"fa fa-check\"></i> Botón primary\n        </button>\n        <button uib-tooltip=\"Botón success tooltip\" tooltip-placement=\"right\" md-effect class=\"btn btn-success\">\n          <i class=\"fa fa-book\"></i> Botón success\n        </button>\n        <button uib-tooltip=\"Botón info tooltip\" tooltip-placement=\"bottom\" md-effect class=\"btn btn-info\">\n          <i class=\"fa fa-cog\"></i> Botón info\n        </button>\n        <button uib-tooltip=\"Botón warning tooltip\" tooltip-placement=\"left\" md-effect class=\"btn btn-warning\">\n          <i class=\"fa fa-user-o\"></i> Botón warning\n        </button>\n        <button uib-tooltip=\"Botón danger tooltip\" md-effect class=\"btn btn-danger\">\n          <i class=\"fa fa-automobile\"></i> Botón danger\n        </button>\n      </div>\n      <hr>\n\n      <h3>Botones outline</h3>\n      <div>\n        <button md-effect class=\"btn btn-outline-default\"><i class=\"fa fa-home\"></i> Botón default</button>\n        <button md-effect class=\"btn btn-outline-primary\"><i class=\"fa fa-check\"></i> Botón primary</button>\n        <button md-effect class=\"btn btn-outline-success\"><i class=\"fa fa-book\"></i> Botón success</button>\n        <button md-effect class=\"btn btn-outline-info\"><i class=\"fa fa-cog\"></i> Botón info</button>\n        <button md-effect class=\"btn btn-outline-warning\"><i class=\"fa fa-user-o\"></i> Botón warning</button>\n        <button md-effect class=\"btn btn-outline-danger\"><i class=\"fa fa-automobile\"></i> Botón danger</button>\n      </div>\n      <hr>\n\n      <h3>Dropdown</h3>\n      <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen\">\n        <button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle>\n          Button dropdown <span class=\"caret\"></span>\n        </button>\n        <div class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\n          <h6 class=\"dropdown-header\">Dropdown header</h6>\n          <a class=\"dropdown-item\" href=\"\">Action</a>\n          <a class=\"dropdown-item\" href=\"\">Another action</a>\n          <a class=\"dropdown-item\" href=\"\">Something else here</a>\n          <div class=\"dropdown-divider\"></div>\n          <a class=\"dropdown-item\" href=\"\">Separated link</a>\n        </div>\n      </div>\n      <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen2\">\n        <button type=\"button\" class=\"btn btn-outline-success\" uib-dropdown-toggle>\n          Button dropdown <span class=\"caret\"></span>\n        </button>\n        <div class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\n          <h6 class=\"dropdown-header\">Dropdown header</h6>\n          <a class=\"dropdown-item\" href=\"\">Action</a>\n          <a class=\"dropdown-item\" href=\"\">Another action</a>\n          <a class=\"dropdown-item\" href=\"\">Something else here</a>\n          <div class=\"dropdown-divider\"></div>\n          <a class=\"dropdown-item\" href=\"\">Separated link</a>\n        </div>\n      </div>\n      <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen3\">\n        <button type=\"button\" class=\"btn btn-secondary\">Action</button>\n        <button type=\"button\" class=\"btn btn-secondary dropdown-toggle dropdown-toggle-split\" data-toggle=\"dropdown\" aria-haspopup=\"true\"\n          aria-expanded=\"false\" uib-dropdown-toggle>\n          <span class=\"sr-only\">Toggle Dropdown</span>\n        </button>\n        <div class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\n          <h6 class=\"dropdown-header\">Dropdown header</h6>\n          <a class=\"dropdown-item\" href=\"\">Action</a>\n          <a class=\"dropdown-item\" href=\"\">Another action</a>\n          <a class=\"dropdown-item\" href=\"\">Something else here</a>\n          <div class=\"dropdown-divider\"></div>\n          <a class=\"dropdown-item\" href=\"\">Separated link</a>\n        </div>\n      </div>\n      <hr>\n\n      <h3>Popup</h3>\n      <button uib-popover=\"Contenido del popover\" popover-title=\"Título del popover\" type=\"button\" class=\"btn btn-default\">Popover default</button>\n      <button uib-popover=\"Contenido del popover\" popover-title=\"Título del popover\" popover-placement=\"top\" type=\"button\" class=\"btn btn-primary\">Popover top</button>\n      <button uib-popover=\"Contenido del popover\" popover-title=\"Título del popover\" popover-placement=\"right\" type=\"button\" class=\"btn btn-success\">Popover right</button>\n      <button uib-popover=\"Contenido del popover\" popover-title=\"Título del popover\" popover-placement=\"bottom\" type=\"button\" class=\"btn btn-danger\">Popover bottom</button>\n      <button uib-popover=\"Contenido del popover\" popover-title=\"Título del popover\" popover-placement=\"left\" type=\"button\" class=\"btn btn-info\">Popover left</button>\n      <hr>\n\n      <h3>Tabs</h3>\n      <uib-tabset active=\"active\">\n        <uib-tab index=\"0\" heading=\"Static title\">Static content</uib-tab>\n        <uib-tab index=\"$index + 1\" ng-repeat=\"tab in $ctrl.tabs\" heading=\"{{tab.title}}\" disable=\"tab.disabled\">\n          {{tab.content}}\n        </uib-tab>\n        <uib-tab index=\"3\">\n          <uib-tab-heading>\n            <i class=\"fa fa-bell\"></i> Alert!\n          </uib-tab-heading>\n          I've got an HTML heading, and a select callback. Pretty cool!\n        </uib-tab>\n      </uib-tabset>\n      <hr>\n\n      <h3>Modal</h3>\n      <!-- Button trigger modal -->\n      <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.openModal()\">\n        <i class=\"fa fa-plus\"></i> Abrir modal\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.openModal('lg')\">\n        <i class=\"fa fa-plus\"></i> Abrir modal <strong>lg</strong>\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.openModal('sm')\">\n        <i class=\"fa fa-plus\"></i> Abrir modal <strong>sm</strong>\n      </button>\n      <hr>\n      <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.openAlert()\">\n        <i class=\"fa fa-bell\"></i> Abrir Alert\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.openConfirm()\">\n        <i class=\"fa fa-warning\"></i> Abrir Confirm\n      </button>\n      <hr>\n\n      <h3>Mensajes</h3>\n      <button md-effect type=\"button\" ng-click=\"$ctrl.openMessage('success')\" class=\"btn btn-secondary\">Abrir Success</button>\n      <button md-effect type=\"button\" ng-click=\"$ctrl.openMessage('info')\" class=\"btn btn-secondary\">Abrir Info</button>\n      <button md-effect type=\"button\" ng-click=\"$ctrl.openMessage('error')\" class=\"btn btn-secondary\">Abrir Error</button>\n      <button md-effect type=\"button\" ng-click=\"$ctrl.openMessage('warning')\" class=\"btn btn-secondary\">Abrir Warning</button>\n      <hr>\n\n      <h3>Alertas</h3>\n      <div class=\"alert alert-primary\" role=\"alert\">\n        <strong>Well done!</strong> You successfully read this important alert message.\n      </div>\n      <div class=\"alert alert-success\" role=\"alert\">\n        <strong>Well done!</strong> You successfully read this important alert message.\n      </div>\n      <div class=\"alert alert-info\" role=\"alert\">\n        <strong>Heads up!</strong> This alert needs your attention, but it's not super important.\n      </div>\n      <div class=\"alert alert-warning\" role=\"alert\">\n        <strong>Warning!</strong> Better check yourself, you're not looking too good.\n      </div>\n      <div class=\"alert alert-danger\" role=\"alert\">\n        <strong>Oh snap!</strong> Change a few things up and try submitting again.\n      </div>\n\n      <hr>\n      <h3>Badge</h3>\n      <span class=\"badge badge-default\">Default</span>\n      <span class=\"badge badge-primary\">Primary</span>\n      <span class=\"badge badge-success\">Success</span>\n      <span class=\"badge badge-info\">Info</span>\n      <span class=\"badge badge-warning\">Warning</span>\n      <span class=\"badge badge-danger\">Danger</span>\n      <hr>\n\n      <h3>Texto</h3>\n      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sapiente, modi, eaque adipisci quia quas accusantium beatae\n        quisquam laudantium ullam laboriosam fuga omnis nesciunt illum quasi maiores? Assumenda consectetur veritatis quod\n        veniam iure aliquid dolorem vitae dolores sit pariatur explicabo ut cumque a eveniet voluptatum reiciendis, fugit\n        ad neque, perspiciatis tempora.</p>\n      <p>Recusandae, est. Vitae asperiores labore ratione aut voluptatum! Recusandae quisquam velit dolorum itaque asperiores\n        eius amet possimus mollitia quos eum ipsum doloremque id explicabo temporibus nihil, commodi soluta sit aut fugit\n        labore voluptatum excepturi iure. Perspiciatis obcaecati minus dicta quod, fugiat illo eligendi sequi, nesciunt ullam,\n        accusantium veritatis praesentium fuga!</p>\n\n      <h3 class=\"card-title\">Formulario</h3>\n      <form>\n        <div class=\"form-group\">\n          <label for=\"exampleInputEmail1\">Email address</label>\n          <input type=\"email\" class=\"form-control\" id=\"exampleInputEmail1\" aria-describedby=\"emailHelp\" placeholder=\"Enter email\">\n          <small id=\"emailHelp\" class=\"form-text text-muted\">We'll never share your email with anyone else.</small>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"exampleInputPassword1\">Password</label>\n          <input type=\"password\" class=\"form-control\" id=\"exampleInputPassword1\" placeholder=\"Password\">\n        </div>\n        <div class=\"form-group\">\n          <label for=\"exampleSelect1\">Example select</label>\n          <select class=\"form-control\" id=\"exampleSelect1\">\n            <option ng-repeat=\"item in $ctrl.items\">{{ item.text }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"input\">Example ui-select</label>\n          <ui-select ng-model=\"$ctrl.item.selected\" theme=\"bootstrap\" ng-disabled=\"$ctrl.disabled\" title=\"Seleccione un item\">\n            <ui-select-match placeholder=\"Seleccione o busque un item de la lista...\">{{$select.selected.text}}</ui-select-match>\n            <ui-select-choices repeat=\"item in $ctrl.items | filter: $select.search\">\n              <span ng-bind-html=\"item.text | highlight: $select.search\"></span>\n              <small ng-bind-html=\"item.code | highlight: $select.search\"></small>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"exampleSelect2\">Example multiple select</label>\n          <select multiple class=\"form-control\" id=\"exampleSelect2\">\n            <option ng-repeat=\"item in $ctrl.items\">{{ item.text }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"exampleTextarea\">Example textarea</label>\n          <textarea class=\"form-control\" id=\"exampleTextarea\" rows=\"3\"></textarea>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"exampleInputFile\">File input</label>\n          <input type=\"file\" class=\"form-control-file\" id=\"exampleInputFile\" aria-describedby=\"fileHelp\">\n          <small id=\"fileHelp\" class=\"form-text text-muted\">This is some placeholder block-level help text for the above input. It's a bit lighter and easily wraps to a new line.</small>\n        </div>\n        <fieldset class=\"form-group\">\n          <legend>Radio buttons</legend>\n          <div class=\"form-check\">\n            <label class=\"form-check-label\">\n              <input type=\"radio\" class=\"form-check-input\" name=\"optionsRadios\" id=\"optionsRadios1\" value=\"option1\" checked>\n              Option one is this and that&mdash;be sure to include why it's great\n            </label>\n          </div>\n          <div class=\"form-check\">\n            <label class=\"form-check-label\">\n              <input type=\"radio\" class=\"form-check-input\" name=\"optionsRadios\" id=\"optionsRadios2\" value=\"option2\">\n              Option two can be something else and selecting it will deselect option one\n            </label>\n          </div>\n          <div class=\"form-check disabled\">\n            <label class=\"form-check-label\">\n              <input type=\"radio\" class=\"form-check-input\" name=\"optionsRadios\" id=\"optionsRadios3\" value=\"option3\" disabled>\n              Option three is disabled\n            </label>\n          </div>\n        </fieldset>\n        <div class=\"form-check\">\n          <label class=\"form-check-label\">\n            <input type=\"checkbox\" class=\"form-check-input\">\n            Check me out\n          </label>\n        </div>\n        <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\n      </form>\n      <hr>\n\n      <h3>Material Design Form</h3>\n      <form>\n        <md-input label=\"Nombre\" ng-model=\"$ctrl.field1\"></md-input>\n        <md-input label=\"Apellido\" ng-model=\"$ctrl.field2\" required></md-input>\n        <md-textarea label=\"Descripción\" ng-model=\"$ctrl.field3\"></md-textarea>\n\n        <div class=\"md-form-group md-select-group\" md-event-label>\n          <ui-select ng-model=\"$ctrl.item2.selected\" class=\"md-select\" theme=\"bootstrap\" ng-disabled=\"$ctrl.disabled\" title=\"Seleccione un item\">\n            <ui-select-match placeholder=\"Seleccione o busque un item de la lista...\">{{$select.selected.text}}</ui-select-match>\n            <ui-select-choices repeat=\"item in $ctrl.items | filter: $select.search\">\n              <span ng-bind-html=\"item.text | highlight: $select.search\"></span>\n              <small ng-bind-html=\"item.code | highlight: $select.search\"></small>\n            </ui-select-choices>\n          </ui-select>\n          <label class=\"md-control-label\" for=\"input\">Select material</label>\n          <i class=\"md-bar\"></i>\n        </div>\n        <!-- <md-select items=\"$ctrl.items\" ng-model=\"$ctrl.field4\" label=\"Lista\"></md-select> -->\n        <label class=\"custom-control custom-checkbox\">\n          <input type=\"checkbox\" class=\"custom-control-input\">\n          <span class=\"custom-control-indicator\"></span>\n          <span class=\"custom-control-description\">Check this custom checkbox</span>\n        </label>\n        <br>\n        <label class=\"custom-control custom-radio\">\n          <input id=\"radio1\" name=\"radio\" type=\"radio\" class=\"custom-control-input\">\n          <span class=\"custom-control-indicator\"></span>\n          <span class=\"custom-control-description\">Toggle this custom radio</span>\n        </label>\n        <label class=\"custom-control custom-radio\">\n          <input id=\"radio2\" name=\"radio\" type=\"radio\" class=\"custom-control-input\">\n          <span class=\"custom-control-indicator\"></span>\n          <span class=\"custom-control-description\">Or toggle this other custom radio</span>\n        </label>\n      </form>\n      <hr>\n\n      <h3>Datepicker</h3>\n      <div uib-datepicker ng-model=\"$ctrl.fecha\" datepicker-options=\"$ctrl.dateOptions\" class=\"well well-sm\"></div>\n      <hr>\n\n      <h3>Datepicker Popup</h3>\n      <div class=\"form-group\">\n        <label>Fecha</label>\n        <div class=\"input-group\">\n          <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.dt\" is-open=\"$ctrl.opened\" datepicker-options=\"$ctrl.dateOptions\"\n            ng-required=\"true\" />\n          <span class=\"input-group-btn\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.opened = true\"><i class=\"fa fa-calendar\"></i></button>\n          </span>\n        </div>\n      </div>\n      <hr>\n\n      <h3>Timepicker</h3>\n      <div uib-timepicker ng-model=\"$ctrl.mytime\"></div>\n      <hr>\n\n      <h3>Loading bar</h3>\n      <div>\n        <p><strong class=\"text-danger\">Nota.-</strong> Por defecto para cada petición se muestra el loading bar automáticamente, pero si se quiere un control manual usar estas opciones:</p>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.loadingInit()\">Iniciar loading</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.loadingInitText()\">Iniciar loading con texto</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.loadingInitLocked()\">Iniciar loading con texto en pantalla completa</button>\n        <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.loadingEnd()\">Terminar loading</button>\n      </div>\n      <hr>\n\n      <h3>Ayudas</h3>\n      <div>\n        <p>Debe pasar el puntero del mouse sobre el ícono <ui-help message=\"$ctrl.helpLang.ejemplo\"></ui-help></p>\n        <p>Texto de ayuda (top) <ui-help message=\"$ctrl.helpLang.ejemplo\" direction=\"top\"></ui-help></p>\n        <p>Texto de ayuda (right) <ui-help message=\"$ctrl.helpLang.ejemplo\" direction=\"right\"></ui-help></p>\n        <p>Texto de ayuda (bottom) <ui-help message=\"$ctrl.helpLang.ejemplo\" direction=\"bottom\"></ui-help></p>\n        <p>Texto de ayuda (left) <ui-help message=\"$ctrl.helpLang.ejemplo\" direction=\"left\"></ui-help></p>\n      </div>\n      <hr>\n\n      <h3>File upload</h3>\n      <div class=\"row\">\n        <div class=\"col\">\n          <label> File upload</label>\n          <ui-file-upload url=\"$ctrl.upload.url\"\n                          name=\"file\"></ui-file-upload>\n        </div>\n        <div class=\"col\">\n          <label> File upload (multiple)</label>\n          <ui-file-upload url=\"$ctrl.upload.url\"\n                          label=\"Subir al servidor\"\n                          textUpload=\"Subir archivos, arrastre acá\"\n                          multiple=\"true\"\n                          types=\"|png|jpg|pdf|xls|csv|\"\n                          name=\"file\"></ui-file-upload>\n        </div>\n      </div>\n      <hr>\n\n      <h3>Componentes Material</h3>\n      <form name=\"FormEjemplo\" novalidate>\n        <c-input name=\"input_nombre\" label=\"Input\" ng-model=\"$ctrl.inputNombre\" ng-required=\"true\"></c-input>\n        <c-input name=\"input_correo\" label=\"Input Correo\" ng-model=\"$ctrl.inputCorreo\" ng-required=\"true\" ng-disabled=\"false\" ng-validation=\"correo\"></c-input>\n        <c-input-money name=\"input_money\" label=\"Input Money\" ng-model=\"$ctrl.inputMoney\" ng-required=\"true\" ng-disabled=\"false\"></c-input-money>\n        <c-textarea name=\"textarea\" label=\"Textarea\" ng-model=\"$ctrl.textarea\" ng-required=\"true\" ng-disabled=\"false\"></c-textarea>\n        <c-select name=\"select\" label=\"Select\" placeholder=\"Seleccione Item\" ng-model=\"$ctrl.select\" ng-required=\"true\" ng-disabled=\"false\" options=\"$ctrl.items\" field=\"text\"></c-select>\n        <c-date name=\"date\" label=\"Date\" ng-model=\"$ctrl.date\" ng-required=\"true\" ng-disabled=\"false\"></c-date>\n        <c-checkbox name=\"checkbox\" label=\"Checkbox\" ng-model=\"$ctrl.checkbox\"></c-checkbox>\n        <c-radiobutton name=\"radiobutton\" label=\"RadioButton\" ng-model=\"$ctrl.radiobutton\" options=\"$ctrl.items\" field=\"text\"></c-radiobutton>\n        <c-input-chips name=\"inpuchips\" label=\"Input Chips\" placeholder=\"Adicionar Items\" ng-model=\"$ctrl.inputchips\" ng-required=\"true\" max-tags=\"3\"></c-input-chips>\n      </form>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i> Modal title</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <ul>\n        <li ng-repeat=\"item in $ctrl.items\">\n            <a href=\"#\" ng-click=\"$event.preventDefault(); $ctrl.selected.item = item\">{{ item.text }}</a>\n        </li>\n    </ul>\n    Selected: <strong>{{ $ctrl.selected.item.text }}</strong>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n        <i class=\"fa fa-close\"></i> Cerrar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n        <i class=\"fa fa-check\"></i> Guardar\n    </button>\n</div>"

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	module.exports = "<span class=\"btn btn-sm btn-warning\">{{$ctrl.proyecto.estado}}</span>\n<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"{{$ctrl.getTooltip()}}\" ng-if=\"$ctrl.puedeCambiarEstado()\" ng-click=\"$ctrl.cambiarEstado()\">\n  <i class=\"fa {{$ctrl.getIcon()}}\"></i>\n</button>\n"

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\" ui-sref=\"admin-estados\">\n    <i class=\"fa fa-reply\"></i>\n    <small>Volver</small>\n  </h2>\n  <div class=\"card\">\n    <ng-form name=\"estadoForm\">\n      <div class=\"card-body\">\n        <h4>Datos de estado</h4>\n        <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <c-input name=\"nombre\" label=\"Nombre\" ng-model=\"$ctrl.estado.nombre\"\n              ng-minlength=\"3\" maxlength=\"150\"\n              ng-required=\"true\"></c-input>\n          </div>\n        </div>\n        <br>        \n        <div class=\"row\">\n          <div class=\"col-sm-12 col-md-6 col-lg-4\">\n            <label>Áreas</label>\n            <div style=\"width: 100%; height: 400px;\">\n              <!--<angular-jsoneditor options=\"$ctrl.jsoneditorOptions\" json=\"$ctrl.estado.acciones\"></angular-jsoneditor>-->\n              <angular-jsoneditor ng-model=\"$ctrl.estado.areas\" options=\"$ctrl.jsoneditorOptions\"></angular-jsoneditor>\n            </div>\n          </div>\n          <div class=\"col-sm-12 col-md-6 col-lg-4\">\n            <label>Atributos</label>\n            <div style=\"width: 100%; height: 400px;\">\n              <angular-jsoneditor ng-model=\"$ctrl.estado.atributos\" options=\"$ctrl.jsoneditorOptions\"></angular-jsoneditor>\n            </div>\n          </div>\n          <div class=\"col-sm-12 col-md-6 col-lg-4\">\n            <label>Atributos detalle</label>\n            <div style=\"width: 100%; height: 400px;\">\n              <angular-jsoneditor ng-model=\"$ctrl.estado.atributos_detalle\" options=\"$ctrl.jsoneditorOptions\"></angular-jsoneditor>\n            </div>\n          </div>\n        </div>\n        \n      </div>\n    </ng-form>\n  </div>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row\">\n        <div class=\"col\">\n          <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.guardarDatos()\">\n            <i class=\"fa fa-save\"></i> Guardar datos\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Tabla de estados\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <crud-table url=\"$ctrl.estados.url\"\n                  data=\"$ctrl.estados.data\"\n                  fields=\"$ctrl.estados.fields\"\n                  permission=\"$ctrl.estados.permission\"\n                  event-create=\"$ctrl.estados.eventCreate\"\n                  event-edit=\"$ctrl.estados.eventEdit\"\n                  event-delete=\"$ctrl.estados.eventDelete\"\n                  buttons=\"$ctrl.estados.buttons\"\n                  labels=\"$ctrl.estados.labels\"\n                  fks=\"$ctrl.estados.fks\"\n                  update=\"$ctrl.estados.update\"\n                  clases=\"$ctrl.estados.clases\"\n                  ng-if=\"$ctrl.estados\" \n                  hidden-fields=\"$ctrl.estados.hiddenFields\">\n      </crud-table>\n    </div>\n  </div>\n  <!--\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row\">\n        <div class=\"col\">\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-warning\" ng-click=\"$ctrl.reestablecerValores()\">\n            Reestablecer valores iniciales\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n  -->\n</div>\n"

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login-container\">\n    <div class=\"login-logo\"> PROYECTOS </div>\n    <div class=\"login-header\">\n        {{ $ctrl.flip ? 'Recuperar contraseña' : 'Ingresar al sistema' }}\n    </div>\n    <div class=\"card-container\">\n        <div class=\"card-flip-container\" ng-class=\"{ 'recovery' : $ctrl.flip, 'empresa' : $ctrl.empresa }\">\n            <div class=\"card-flip\">\n                <div class=\"side front login-block\" ng-class=\"{'side':$ctrl.flip}\" ng-if=\"!$ctrl.flip\">\n                    <form name=\"form\" ng-submit=\"$ctrl.iniciarSesion()\">\n                        <div class=\"md-input-group icon\">\n                            <span class=\"md-input-group-addon\"><i class=\"fa fa-user\"></i></span>\n                            <md-input label=\"Usuario\" ng-model=\"$ctrl.username\" name=\"username\" required id=\"username\"></md-input>\n                            <div ng-messages=\"form.username.$error\" class=\"form-error\" ng-if=\"form.username.$touched\">\n                                <div ng-message=\"required\">El usuario es obligatorio</div>\n                            </div>\n                        </div>\n                        <div class=\"md-input-group icon\">\n                            <span class=\"md-input-group-addon\"><i class=\"fa fa-lock\"></i></span>\n                            <md-input label=\"Contraseña\" ng-model=\"$ctrl.password\" name=\"password\" type=\"password\" required id=\"password\"></md-input>\n                            <div ng-messages=\"form.password.$error\" class=\"form-error\" ng-if=\"form.password.$touched\">\n                                <div ng-message=\"required\">La contraseña es obligatoria</div>\n                            </div>\n                        </div>\n                        <div class=\"d-flex justify-content-between\">\n                            <div class=\"p-5\">\n                                <!--\n                                <label class=\"custom-control custom-checkbox\">\n                                    <input type=\"checkbox\" class=\"custom-control-input\">\n                                    <span class=\"custom-control-indicator\"></span>\n                                    <span class=\"custom-control-description\">Recordar sesión</span>\n                                </label>\n                                -->\n                                <br>\n                                <a href=\"\" ng-click=\"$ctrl.recovery()\" ng-if=\"!$ctrl.empresa\">¿Olvidó su contraseña?</a>\n                            </div>\n\t\t\t    <div>\n\t\t\t\t<a href=\"http://sipmi.fdi.gob.bo/seguimiento\" class=\"btn btn-outline-info\"> Seguimiento y Cierre</a>\n\t\t\t    </div>\n                            <div class=\"p-3 text-right\">\n                                <button md-effect class=\"btn btn-primary btn-lg\" type=\"submit\" validar-formulario-alerta=\"form\">\n                                    <i class=\"fa fa-sign-in\"></i> Iniciar sesión\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n                <div class=\"side back login-block\" ng-class=\"{'side':!$ctrl.flip}\" ng-if=\"$ctrl.flip\">\n                    <form ng-submit=\"$ctrl.recuperarContrasenia()\">\n                        <div class=\"md-input-group icon\">\n                            <span class=\"md-input-group-addon\"><i class=\"fa fa-user\"></i></span>\n                            <md-input label=\"Correo electrónico\" ng-model=\"$ctrl.correo\" name=\"correo\"></md-input>\n                        </div>\n                        <div class=\"d-flex justify-content-between\">\n                            <div class=\"p-5\">\n                                <br>\n                                <a href=\"\" ng-click=\"$ctrl.goLogin()\" class=\"login-link\">Iniciar sesión</a>\n                            </div>\n                            <div class=\"p-3 text-right\">\n                                <button md-effect class=\"btn btn-primary btn-lg\">\n                                    <i class=\"fa fa-repeat\"></i> Recuperar contraseña\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Configuración de Paramétricas\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <h4>INSTITUCION</h4>\n      <form name=\"institucion\">\n        <table class=\"table table-striped\">\n          <tr>\n            <th>Código</th>\n            <th>Nombre</th>\n            <th>Descripción (Valor)</th>\n            <th>Acciones</th>\n          </tr>\n          <tr ng-repeat=\"institucion in $ctrl.org_instituciones\">\n            <td>\n              <c-input name=\"codigo{{$index}}\" ng-model=\"institucion.codigo\" ng-disabled=\"institucion.codigo_ant\"></c-input>\n            </td>\n            <td>\n              <c-input name=\"nombre{{$index}}\" ng-model=\"institucion.nombre\"></c-input>\n            </td>\n            <td>\n              <c-input name=\"descripcion{{$index}}\" ng-model=\"institucion.descripcion\"></c-input>\n            </td>\n            <td>\n              <button type=\"button\" class=\"btn btn-sm\" ng-class=\"{'btn-success':(institucion.nombre!=institucion.nombre_ant||institucion.descripcion!=institucion.descripcion_ant)}\" ng-click=\"$ctrl.actualizar(institucion, 'ORG_INSTITUCION')\"><i class=\"fa fa-save\"></i></button>\n            </td>\n          </tr>\n        </table>\n        <!--div>\n          <button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.nuevo(institucion)\"><i class=\"fa fa-check\"></i> Nuevo parámetro</button>\n        </div-->\n      </form>\n    </div>\n  </div>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <h4>PARAMETROS GENERALES</h4>\n      <form name=\"param\">\n        <table class=\"table table-striped\">\n          <tr>\n            <th>Código</th>\n            <th>Nombre</th>\n            <th>Valor</th>\n            <th>Acciones</th>\n          </tr>\n          <tr ng-repeat=\"param in $ctrl.configParams\">\n            <td>\n              <c-input name=\"codigo{{$index}}\" ng-model=\"param.codigo\" ng-disabled=\"param.codigo_ant\"></c-input>\n            </td>\n            <td>\n              <c-input name=\"nombre{{$index}}\" ng-model=\"param.nombre\"></c-input>\n            </td>\n            <td>\n              <c-input name=\"descripcion{{$index}}\" ng-model=\"param.descripcion\"></c-input>\n            </td>\n            <td>\n              <button type=\"button\" class=\"btn btn-sm\" ng-class=\"{'btn-success':(param.nombre != param.nombre_ant || param.descripcion != param.descripcion_ant)}\" ng-click=\"$ctrl.actualizar(param, 'CONFIG')\"><i class=\"fa fa-save\"></i></button>\n            </td>\n          </tr>\n        </table>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Configuracion de Paramétricas\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <h4>UNIDAD</h4>\n      <form name=\"unidad\">\n        <table>\n          <tr>\n            <th>Código</th>\n            <th>Nombre</th>\n            <th>Descripción</th>\n          </tr>\n          <tr ng-repeat=\"unidad in $ctrl.unidades\">\n            <td>\n              <c-input name=\"codigo{{$index}}\" ng-model=\"unidad.codigo\" ng-maxlength=\"50\" ng-disabled=\"unidad.codigo_ant\"></c-input>\n            </td>\n            <td>\n              <c-input name=\"nombre{{$index}}\" ng-model=\"unidad.nombre\"></c-input>\n            </td>\n            <td>\n              <c-input name=\"descripcion{{$index}}\" ng-model=\"unidad.descripcion\"></c-input>\n            </td>\n            <td>\n              <button type=\"button\" class=\"btn btn-sm\" ng-class=\"{'btn-success':(unidad.nombre!=unidad.nombre_ant||unidad.descripcion!=unidad.descripcion_ant)}\" ng-click=\"$ctrl.actualizar(unidad)\"><i class=\"fa fa-save\"></i></button>\n            </td>\n          </tr>\n        </table>\n        <div>\n          <button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.nuevo(unidad)\"><i class=\"fa fa-check\"></i> Nuevo parámetro</button>\n        </div>\n      <form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Reasignación</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>\n    Usuario/a actual:\n  </p>\n  <div class=\"row\">\n    <div class=\"md-input-group col-12\">\n      {{$ctrl.transicion.usuario_asignado.persona.nombres}}\n      {{$ctrl.transicion.usuario_asignado.persona.primer_apellido}}\n      {{$ctrl.transicion.usuario_asignado.persona.segundo_apellido}}\n      <br><strong>{{$ctrl.transicion.usuario_asignado_rol.descripcion}}</strong>\n    </div>\n  </div>\n\n  <br><br>\n  <ng-form name=\"formUsuario\">\n    <div class=\"row\">\n      <div class=\"md-input-group col-md-12\">\n        <c-select name=\"nuevo_usuario_asignado\"\n        label=\"Nuevo usuario/a asignado\"\n        ng-model=\"$ctrl.datos.seleccionado\"\n        options=\"$ctrl.usuariosParaAsignar\"\n        field=\"nombre\"\n        ng-required=\"true\"></c-select>\n      </div>\n    </div>\n  </ng-form>\n  <div class=\"alert alert-info\">\n    <i class=\"fa fa-info-circle\"></i> Tome en cuenta que al reasignar al usuario ya no podrá acceder a los datos del proyecto. Transfiriendo todos los permisos y responsabilidades al nuevo usuario.\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.reasignarUsuario()\" validar-formulario=\"formUsuario\">\n    <i class=\"fa fa-send\"></i> Enviar cambio\n  </button>\n</div>\n"

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyecto\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-header\">\n      DATOS\n    </div>\n    <div class=\"card-body table-responsive\">\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <table class=\"table table-striped\">\n            <tr>\n              <th>Nombre:</th>\n              <td>{{$ctrl.proyecto.nombre}}</td>\n            </tr>\n            <tr>\n              <th>Nro Convenio:</th>\n              <td>{{$ctrl.proyecto.nro_convenio}} <button-cambiar-codigo proyecto=\"$ctrl.proyecto\"></button-cambiar-codigo></td>\n            </tr>\n            <tr>\n              <th>Departamento:</th>\n              <td>{{$ctrl.proyecto.municipio.provincia.departamento.nombre}}</td>\n            </tr>\n            <tr>\n              <th>Estado Proyecto:</th>\n              <td>{{$ctrl.proyecto.estado_proyecto}}</td>\n            </tr>\n            <tr>\n              <th>Estado:</th>\n              <td><button-estado proyecto=\"$ctrl.proyecto\"></button-estado></td>\n            </tr>\n            <tr>\n              <th>Registro de cambios</th>\n              <td><button-timeline proyecto=\"$ctrl.proyecto\"></button-timeline></td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"card\">\n    <div class=\"card-header\">\n      USUARIOS ASIGNADOS\n    </div>\n    <div class=\"card-body table-responsive\">\n      <table class=\"table table-striped\">\n        <tr>\n          <th>Observación</th>\n          <th>Usuario Asignado</th>\n          <th>Opciones</th>\n        </tr>\n        <tr ng-repeat=\"transicion in $ctrl.proyecto.transicion\">\n          <td ng-class =\"$ctrl.getColor(transicion.usuario_asignado_rol.nombre)\">{{transicion.tipo}}\n            <br>{{transicion.observacion}}\n          </td>\n          <td ng-class =\"$ctrl.getColor(transicion.usuario_asignado_rol.nombre)\">{{transicion.usuario_asignado.persona.nombres}}\n            {{transicion.usuario_asignado.persona.primer_apellido}}\n            {{transicion.usuario_asignado.persona.segundo_apellido}}\n            <br><strong>{{transicion.usuario_asignado_rol.descripcion}}</strong>\n          </td>\n          <td ng-class =\"$ctrl.getColor(transicion.usuario_asignado_rol.nombre)\">\n            <button type=\"button\" uib-tooltip=\"Reasignar usuario\" class=\"btn btn-sm\" ng-click=\"$ctrl.reasignarUsuario(transicion)\"><i class=\"fa fa-user\"></i></button>\n          </td>\n        </tr>\n        <tr ng-if=\"$ctrl.proyecto.usuario.persona && !$ctrl.usuarioEnTransiciones()\">\n          <td>proyecto</td>\n          <td>{{$ctrl.proyecto.usuario.persona.nombres}}\n            {{$ctrl.proyecto.usuario.persona.primer_apellido}}\n            {{$ctrl.proyecto.usuario.persona.segundo_apellido}}\n            <br><strong>{{$ctrl.proyecto.usuario_rol.descripcion}}\n          </td>\n          <td>\n            <button type=\"button\" uib-tooltip=\"Reasignar usuario\" class=\"btn btn-sm\" ng-click=\"$ctrl.reasignarUsuarioProy($ctrl.proyecto)\"><i class=\"fa fa-user\"></i></button>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyectos\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n\n      <crud-table url=\"$ctrl.proyectos.url\"\n                data=\"$ctrl.proyectos.data\"\n                fields=\"$ctrl.proyectos.fields\"\n                permission=\"$ctrl.proyectos.permission\"\n                event-create=\"$ctrl.proyectos.eventCreate\"\n                event-edit=\"$ctrl.proyectos.eventEdit\"\n                event-delete=\"$ctrl.proyectos.eventDelete\"\n                buttons=\"$ctrl.proyectos.buttons\"\n                labels=\"$ctrl.proyectos.labels\"\n                fks=\"$ctrl.proyectos.fks\"\n                update=\"$ctrl.proyectos.update\"\n                clases=\"$ctrl.proyectos.clases\"\n                ng-if=\"$ctrl.proyectos\"\n                hidden-fields=\"$ctrl.proyectos.hiddenFields\">\n      </crud-table>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login-container\">\n    <div class=\"login-logo\"> PROYECTOS </div>\n    <div class=\"login-header\">\n        {{ 'Cambiar contraseña' }}\n    </div>\n    <div class=\"card-container\">\n        <div class=\"card-flip-container\" ng-class=\"{ 'recovery' : $ctrl.flip, 'empresa' : $ctrl.empresa }\">\n            <div class=\"card-flip\">\n                <div class=\"side front login-block\" ng-class=\"{'side':$ctrl.flip}\" ng-if=\"!$ctrl.flip\">\n                    <form name=\"form\" ng-submit=\"$ctrl.cambiarContrasena()\">\n\n                        <div class=\"row\">\n                            <div class=\"col-12 alert alert-info\">\n                                <i class=\"fa fa-info-circle\"></i> <strong>IMPORTANTE:</strong>\n                                <ul class=\"btm-0\">\n                                    <li>Escriba una nueva contraseña (se distingue entre mayúsculas y minúsculas).</li>\n                                    <!-- <li>Su contraseña nueva debe tener hasta 16 caracteres.</li> -->\n                                    <li>Luego de modificar su contraseña, intente iniciar sesión nuevamente.</li>\n                                </ul>\n                            </div>\n                            \n                            <div class=\"col-sm-12\">\n                                <c-input type=\"password\" name=\"nueva\" label=\"Nueva contraseña\" ng-model=\"$ctrl.nueva\" ng-minlength=\"3\" ng-maxlength=\"16\" \n                                maxlength=\"16\" ng-required=\"true\" uib-tooltip=\"Escriba la nueva contraseña.\" ng-validation=\"alfa-numerico\" ></c-input>\n                            </div>\n\n                            <div class=\"col-sm-12\">\n                                <c-input type=\"password\" name=\"confirmada\" label=\"Repita la contraseña\" ng-model=\"$ctrl.confirmada\" ng-minlength=\"3\"\n                                ng-maxlength=\"16\" maxlength=\"16\" ng-required=\"true\" uib-tooltip=\"Vuelva a escribir la nueva contraseña.\" \n                                c-ui-validate=\"{contrasena:'$ctrl.form.confirmada.$viewValue==$ctrl.form.nueva.$modelValue'}\" \n                                c-ui-validate-watch=\"'$ctrl.form.nueva.$modelValue'\" \n                                message-error-password=\"Las nuevas contraseñas no son iguales. Revise por favor.\"></c-input>\n                            </div>\n                        </div>\n\n                        <div class=\"d-flex justify-content-between\">\n                            <div class=\"p-5\">\n                                <br>\n                                <a href=\"\" ng-click=\"$ctrl.inicioDeSesion()\">Ir a inicio de sesión</a>\n                            </div>\n                            <div class=\"p-3 text-right\">\n                                <button md-effect class=\"btn btn-primary btn-lg\" type=\"submit\" validar-formulario=\"form\" ng-disabled=\"false\">\n                                    <i class=\"fa fa-refresh\"></i> Cambiar contraseña\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\" ui-sref=\"admin-techos-presupuestarios\">\n    <i class=\"fa fa-reply\"></i>\n    <small>Volver</small>\n  </h2>\n  <div class=\"card\">\n    <ng-form name=\"techosPresupuestariosForm\">\n      <div class=\"card-body\">\n        <h4>Datos de techo presupuestario {{$ctrl.$stateParams.gestion}}</h4>\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <c-input name=\"nombre_municipio\" label=\"Municipio\" ng-model=\"$ctrl.techo_presupuestario.nombre_municipio\"\n            ng-minlength=\"3\" maxlength=\"255\"\n            ng-required=\"true\"></c-input>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-12 col-md-6\">\n            <c-input-numeric name=\"codigo\" label=\"Código\" ng-model=\"$ctrl.techo_presupuestario.codigo\"\n            ng-minvalue=\"00001\" ng-maxvalue=\"99999\" ng-formatting=\"false\" ng-decimals=\"0\" ng-required=\"true\" ng-disabled=\"true\"></c-input-numeric>\n          </div>\n          <div class=\"col-sm-12 col-md-6\">\n            <c-input-numeric name=\"codigo\" label=\"Número de concejales\" ng-model=\"$ctrl.techo_presupuestario.num_concejales\"\n            ng-minvalue=\"1\" ng-maxvalue=\"99\" ng-formatting=\"false\" ng-decimals=\"0\" ng-required=\"true\"></c-input-numeric>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-12 col-md-6 col-lg-4\">\n            <c-input-money name=\"techo_presupuestal\" label=\"Techo presupuestal\" ng-model=\"$ctrl.techo_presupuestario.techo_presupuestal\"\n            ng-required=\"true\" ng-blur=\"\"></c-input-money>\n          </div>\n          <div class=\"col-sm-12 col-md-6 col-lg-4\">\n            <c-input-money name=\"monto_usado\" label=\"Monto usado\" ng-model=\"$ctrl.techo_presupuestario.monto_usado\"\n            ng-required=\"true\" ng-disabled=\"true\" ng-blur=\"\"></c-input-money>\n          </div>\n          <div class=\"col-sm-12 col-md-6 col-lg-4\">\n            <c-input-money name=\"monto_disponible\" label=\"Monto disponible\" ng-model=\"$ctrl.techo_presupuestario.monto_disponible\"\n            ng-required=\"true\" ng-disabled=\"true\" ng-blur=\"\"></c-input-money>\n          </div>\n        </div>\n      </div>\n    </ng-form>\n  </div>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row\">\n        <div class=\"col\">\n          <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.guardarDatos(techosPresupuestariosForm)\">\n            <i class=\"fa fa-save\"></i> Guardar datos\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	module.exports = "<!--\n<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Configuracion de techos presupuestarios\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <h4>Techo presupuestario por municipio</h4>\n      <br>\n      <div>\n        <button type=\"button\" class=\"btn btn-sm btn-warning\" ng-click=\"$ctrl.reestablecerValores()\"><i class=\"fa fa-refresh\"></i> Reestablecer valores iniciales</button>\n      </div>\n      <br>\n      <form name=\"techo_presupuestario\">\n        <table>\n          <tr>\n            <th>Código</th>\n            <th>Nombre</th>\n            <th>Techo presupuestario</th>\n            <th>Monto usado</th>\n            <th>Monto disponible</th>\n          </tr>\n          <tr ng-repeat=\"techo in $ctrl.techos_presupuestarios\">\n            <td>\n              <c-input name=\"codigo{{$index}}\" ng-model=\"techo.codigo\" ng-disabled=\"techo.codigo_ant\"></c-input>\n            </td>\n            <td>\n              <c-input name=\"nombre_municipio{{$index}}\" ng-model=\"techo.nombre_municipio\"></c-input>\n            </td>\n            <td>\n              <c-input name=\"techo_presupuestal{{$index}}\" ng-model=\"techo.techo_presupuestal\"></c-input>\n            </td>\n            <td>\n              <c-input name=\"monto_usado{{$index}}\" ng-model=\"techo.monto_usado\" ng-disabled=\"true\"></c-input>\n            </td>\n            <td>\n              <c-input name=\"monto_disponible{{$index}}\" ng-model=\"techo.monto_disponible\" ng-disabled=\"true\"></c-input>\n            </td>\n            <td>\n              <button type=\"button\" class=\"btn btn-sm\" ng-class=\"{'btn-success':(techo.nombre_municipio != techo.nombre_municipio_ant || techo.techo_presupuestal != techo.techo_presupuestal_ant)}\" ng-click=\"$ctrl.actualizar(techo)\"><i class=\"fa fa-save\"></i></button>\n            </td>\n          </tr>\n        </table>\n        <!--\n        <div>\n          <button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.nuevo(techo)\"><i class=\"fa fa-check\"></i> Nuevo registro</button>\n        </div>\n\n      <form>\n    </div>\n  </div>\n</div>\n-->\n\n<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Tabla de techos presupuestarios\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <form name=\"form_gestion\">\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <c-select label=\"Gestión\" name=\"gestion\" ng-model=\"$ctrl.gestion\" options=\"$ctrl.gestiones\" keyValue=\"gestion\" on-select=\"$ctrl.cambiarGestion(item)\"></c-select>\n          </div>\n        </div>\n      </form>\n      <crud-table url=\"$ctrl.techos_presupuestarios.url\"\n                data=\"$ctrl.techos_presupuestarios.data\"\n                fields=\"$ctrl.techos_presupuestarios.fields\"\n                permission=\"$ctrl.techos_presupuestarios.permission\"\n                event-create=\"$ctrl.techos_presupuestarios.eventCreate\"\n                event-edit=\"$ctrl.techos_presupuestarios.eventEdit\"\n                event-delete=\"$ctrl.techos_presupuestarios.eventDelete\"\n                buttons=\"$ctrl.techos_presupuestarios.buttons\"\n                labels=\"$ctrl.techos_presupuestarios.labels\"\n                fks=\"$ctrl.techos_presupuestarios.fks\"\n                update=\"$ctrl.techos_presupuestarios.update\"\n                clases=\"$ctrl.techos_presupuestarios.clases\"\n                query-extra=\"$ctrl.techos_presupuestarios.queryExtra\"\n                ng-if=\"$ctrl.techos_presupuestarios\"\n                hidden-fields=\"$ctrl.techos_presupuestarios.hiddenFields\">\n      </crud-table>\n    </div>\n  </div>\n  <div class=\"card\">\n      <div class=\"card-body\">\n        <div class=\"row\">\n          <div class=\"col\">\n            <button md-effect type=\"button\" class=\"btn btn-sm btn-warning\" ng-click=\"$ctrl.reestablecerValores()\">\n              Reestablecer valores iniciales\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n</div>\n"

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Progreso del proyecto\" ng-click=\"$ctrl.verRegistro()\">\n  <i class=\"fa fa-stack-overflow\"></i>\n</button>\n"

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Linea de Tiempo</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>\n    <strong>Proyecto: </strong>{{$ctrl.proyecto.nombre}}\n  </p>\n  <div class=\"row\">\n    <div class=\"md-input-group col-12\">\n      {{$ctrl.transicion.usuario_asignado.persona.nombres}}\n      {{$ctrl.transicion.usuario_asignado.persona.primer_apellido}}\n      {{$ctrl.transicion.usuario_asignado.persona.segundo_apellido}}\n      <br><strong>{{$ctrl.transicion.usuario_asignado_rol.descripcion}}</strong>\n    </div>\n  </div>\n\n  <br><br>\n  <section style=\"max-height:400px;overflow:auto\">\n    <timeline>\n      <timeline-event ng-repeat=\"evento in $ctrl.eventos\" side=\"{{evento.side}}\">\n        <timeline-badge class=\"{{evento.badgeClass}}\">\n          <i class=\"fa fa-{{evento.badgeIconClass}}\"></i>\n        </timeline-badge>\n        <timeline-panel class=\"{{evento.badgeClass}}\">\n          <timeline-heading ng-if=\"evento.nombre\">\n            <h5>{{evento.nombre}}<br><small><strong>{{evento.rol}}</strong></small></h5>\n          </timeline-heading>\n          <p ng-if=\"evento.contenido\">{{evento.contenido}}</p>\n          <p style=\"margin:0\">\n            <small><strong>{{evento.estado}}</strong></p>\n            <small class=\"pull-right\"><i class=\"fa fa-clock\"></i>{{evento.fecha | date : 'dd/MM/yyyy HH:mm'}}</small></p>\n        </timeline-panel>\n      </timeline-event>\n    </timeline>\n  </section>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-sm btn-info\" uib-tooltip=\"Reenviar correo de confirmación\" \n  ng-click=\"$ctrl.reenviarCorreo()\">\n  <i class=\"fa fa-share-square-o\"></i>\n</button>\n"

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <!-- <i class=\"fa fa-bars\"></i> -->\n    <i class=\"fa fa-reply\" ui-sref=\"usuarios\"></i>\n    <!-- <small>Bandeja de planillas</small> -->\n  </h2>\n  <div class=\"card\">\n    <ng-form name=\"usuarioForm\">\n      <div class=\"card-body\">\n        <h4>Datos de Usuario</h4>\n        <documento-identidad ng-model=\"$ctrl.usuario.persona\"></documento-identidad>\n        <!-- <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <c-input name=\"usuario\" label=\"Usuario\" ng-model=\"$ctrl.usuario.usuario\"\n              ng-minlength=\"3\" maxlength=\"100\" ng-required=\"true\" ng-disabled=\"false\">\n            </c-input>\n          </div>\n          <div class=\"col-sm-6\">\n\n          </div>\n        </div> -->\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <c-input name=\"cargo\" label=\"Cargo\" ng-model=\"$ctrl.usuario.cargo\" maxlength=\"200\" ng-required=\"true\"></c-input>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-12 col-md-6\">\n            <c-input name=\"correo\" label=\"Correo electrónico\" ng-model=\"$ctrl.usuario.persona.correo\"\n              ng-minlength=\"3\" maxlength=\"100\" ng-required=\"true\" ng-disabled=\"false\">\n            </c-input>\n            <c-input name=\"telefono\" label=\"Celular/Teléfono\" ng-model=\"$ctrl.usuario.persona.telefono\"\n              ng-minlength=\"7\" maxlength=\"100\" ng-required=\"true\" ng-disabled=\"false\">\n            </c-input>\n            <h5>Roles</h5>\n            <c-checkbox name=\"{{'rol_'+rol.id_rol}}\" label=\"{{rol.nombre}}\" ng-model=\"rol.valor\" ng-repeat=\"rol in $ctrl.roles\"></c-checkbox>\n          </div>\n          <div class=\"col-sm-12 col-md-6\">\n            <c-select name=\"estado\" label=\"Estado\" placeholder=\"\" ng-model=\"$ctrl.usuario.estado\"  key-value=\"value\"\n              ng-required=\"true\" ng-disabled=\"false\" options=\"$ctrl.estados\" field=\"text\">\n            </c-select>\n            <c-input name=\"direccion\" label=\"Dirección\" ng-model=\"$ctrl.usuario.persona.direccion\"\n              ng-minlength=\"7\" maxlength=\"100\" ng-required=\"true\" ng-disabled=\"false\">\n            </c-input>\n            <!-- <c-select name=\"tipo_departamento\" label=\"Tipo de departamento\" placeholder=\"\" ng-model=\"$ctrl.usuario.tipo_departamento\"\n              ng-required=\"true\" ng-disabled=\"false\" options=\"$ctrl.tipos_departamento\" field=\"text\">\n            </c-select> -->\n            <h5>Departamento(s)</h5>\n            <div class=\"row\">\n              <div class=\"col-sm-12 col-lg-6\" ng-repeat=\"dep in $ctrl.departamentos\">\n                <c-checkbox name=\"{{'departamento_'+dep.nombre}}\" label=\"{{dep.nombre}}\" ng-model=\"dep.valor\"></c-checkbox>\n              </div>\n            </div>\n\n            <!-- <button md-effect type=\"button\" class=\"btn\" ng-click=\"$ctrl.nombreDel()\" ng-if=\"$ctrl.isFill()\">\n              <i class=\"fa fa-edit\"></i>Cambiar\n            </button> -->\n          </div>\n        </div>\n        <div class=\"row mx-0 mt-4\">\n          <div class=\"col\"></div>\n          <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.guardarDatos(usuarioForm)\">\n            <i class=\"fa fa-save\"></i> Guardar datos\n          </button>\n        </div>\n      </div>\n    </ng-form>\n  </div>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row\">\n        <div class=\"col\">\n          <button md-effect type=\"button\" class=\"btn btn-info\" uib-tooltip=\"Reenviar correo de confirmación\" ng-click=\"$ctrl.reenviarContrasenia()\">\n            <i class=\"fa fa-share-square-o\"></i> Regenerar y enviar contraseña\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Tabla de usuarios\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <crud-table url=\"$ctrl.usuarios.url\"\n                data=\"$ctrl.usuarios.data\"\n                fields=\"$ctrl.usuarios.fields\"\n                permission=\"$ctrl.usuarios.permission\"\n                event-create=\"$ctrl.usuarios.eventCreate\"\n                event-edit=\"$ctrl.usuarios.eventEdit\"\n                event-delete=\"$ctrl.usuarios.eventDelete\"\n                buttons=\"$ctrl.usuarios.buttons\"\n                labels=\"$ctrl.usuarios.labels\"\n                fks=\"$ctrl.usuarios.fks\"\n                update=\"$ctrl.usuarios.update\"\n                clases=\"$ctrl.usuarios.clases\"\n                ng-if=\"$ctrl.usuarios\" \n                hidden-fields=\"$ctrl.usuarios.hiddenFields\">\n      </crud-table>\n    </div>\n</div>\n"

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\"><i class=\"fa fa-hand-o-right\"></i> Datos Adicionales</h6>\n  <div class=\"row\">\n    <div class=\"col-md-12\" ng-if=\"!$ctrl.modoVista\">\n      <div class=\"alert alert-info\">\n        <i class=\"fa fa-info-circle\"></i> Introduzca el <strong>código del formulario</strong> registrado en el sistema de empresas a efectos de obtener su información.\n      </div>\n    </div>\n    <div class=\"col-md-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col\">\n          <c-input name=\"codigo_reporte\" label=\"Código de Formulario\" ng-model=\"$ctrl.proyecto.cod_documentacion_exp\"\n            ng-required=\"true\" ng-disabled=\"$ctrl.modoVista || $ctrl.tieneDocumentacion\">\n          </c-input>\n        </div>\n        <div class=\"col-md-4\" ng-if=\"!$ctrl.modoVista && $ctrl.proyecto.cod_documentacion_exp && $ctrl.proyecto.documentacion_exp\">\n          <button md-effect class=\"btn btn-{{$ctrl.tieneDocumentacion? 'primary':''}}\" ng-click=\"$ctrl.tieneDocumentacion? $ctrl.cambiarDocumentacion() : $ctrl.cancelarCambio()\">\n            <i class=\"fa fa-{{$ctrl.tieneDocumentacion? 'exchange' : 'close'}}\"></i>\n            {{$ctrl.tieneDocumentacion? 'Cambiar' : 'Cancelar'}}\n          </button>\n        </div>\n      </div>\n    </div>\n    <div class=\"md-input-group col-md-6\">\n      <c-input name=\"contrato\" label=\"Nro. de invitación directa\" ng-model=\"$ctrl.proyecto.nro_invitacion\"\n               ng-required=\"true\" ng-disabled=\"$ctrl.modoVista\">\n      </c-input>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"cronogramas\" class=\"row\">\n  <div class=\"col-md-6 col-lg-4\" ng-repeat=\"documento in $ctrl.documentos.lista\">\n    <ui-input-file name=\"{{documento.codigo}}\" label=\"{{documento.nombre}}\"\n      file-base64=\"$ctrl.empresa[documento.codigo]\"\n      upload-callback=\"$ctrl.documentos.uploadCallback\"\n      types=\"pdf\" mime-types=\".pdf\" maxfiles=\"1\" maxsize=\"3MB\"\n      ng-if=\"!documento.registrado\">\n    </ui-input-file>\n\n    <div id=\"documento\" ng-if=\"documento.registrado\">\n      <div class=\"opciones\">\n        <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.verDocumento(documento)\">\n          <i class=\"fa fa-eye\"></i>\n        </button>\n        <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n                download-file=\"{{documento.urlDescarga}}\" file-name=\"{{documento.nombre}}\">\n          <i class=\"fa fa-download\"></i>\n        </button>\n        <button md-effect type=\"button\" class=\"btn btn-info btn-sm\" uib-tooltip=\"Cambiar\" ng-click=\"$ctrl.cambiar(documento)\">\n          <i class=\"fa fa-exchange\"></i>\n        </button>\n      </div>\n      <img src=\"./images/formulario.jpg\" alt=\"Documento\">\n      <div class=\"detalles\">\n        <div class=\"nombre\">{{documento.nombre}}</div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\"><i class=\"fa fa-user-o\"></i> Datos de la Asociacion Accidental</h6>\n  </section>\n  <div class=\"col-md-12\">\n    <c-input label=\"Denominación de la Asociación Accidental\" name=\"nombre\" ng-model=\"$ctrl.asociacion.nombre_asociacion\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"col-md-12\">\n    <div class=\"row\">\n      <div class=\"col-md-3\">\n        Asociados\n      </div>\n      <div class=\"col-md-9\">\n        <table class=\"table table-striped\">\n          <tr>\n            <th>#</th>\n            <th>Nombre del Asociado</th>\n            <th>% de Participación</th>\n          </tr>\n          <tr ng-repeat=\"asociado in $ctrl.asociacion.asociados\">\n            <td>{{1+$index}}</td>\n            <td>{{asociado.razon_social}}</td>\n            <td>{{asociado.participacion}} %</td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-6 col-lg-4\">\n    <c-input label=\"N° de testimonio\" name=\"testimonio\" ng-model=\"$ctrl.asociacion.nro_testimonio\"\n             ng-required=\"true\" ng-disabled=\"true\">\n    </c-input>\n  </div>\n  <div class=\"col-md-6 col-lg-4\">\n    <c-input label=\"Lugar\" name=\"lugar\" ng-model=\"$ctrl.asociacion.lugar_testimonio\"\n             ng-required=\"true\" ng-disabled=\"true\">\n    </c-input>\n  </div>\n  <div class=\"col-md-6 col-lg-4\">\n    <c-date label=\"Fecha de Expedición\" id=\"fecha_expedicion\" name=\"fecha_expedicion\"\n            ng-model=\"$ctrl.asociacion.fecha_expedicion\"\n            ng-required=\"true\" ng-disabled=\"true\">\n    </c-date>\n  </div>\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"razon_social\" label=\"Nombre de la Empresa Líder\" ng-model=\"$ctrl.empresa.razon_social\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\"><i class=\"fa fa-user-o\"></i> Datos de Contacto de la Empresa Líder</h6>\n  </section>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"pais_empresa\" label=\"País\" ng-model=\"$ctrl.empresa.pais\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"ciudad_empresa\" label=\"Ciudad\" ng-model=\"$ctrl.empresa.ciudad\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"direccion_empresa\" label=\"Dirección\" ng-model=\"$ctrl.empresa.direccion\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"telefonos_empresa\" label=\"Teléfonos\" ng-model=\"$ctrl.empresa.telefono\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"fax_empresa\" label=\"Fax\" ng-model=\"$ctrl.empresa.fax\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"correo_empresa\" label=\"Correo electrónico\" ng-model=\"$ctrl.empresa.correo\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\"><i class=\"fa fa-user-o\"></i> Datos del Representante Legal de la Asociacion Accidental</h6>\n  </section>\n  <div class=\"md-input-group col-md-8\">\n    <c-input name=\"representante_legal\" label=\"Nombre\" ng-model=\"$ctrl.empresa.representante_legal.persona.nombre\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"ci_representante_legal\" label=\"Nro Cédula de Identidad\" ng-model=\"$ctrl.empresa.representante_legal.persona.documento_identidad\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"nro_testimonio\" label=\"Nro. de testimonio\" ng-model=\"$ctrl.empresa.representante_legal.poder.nro_testimonio\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"lugar_emision\" label=\"Lugar de emisión\" ng-model=\"$ctrl.empresa.representante_legal.poder.lugar_emision\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-date name=\"fecha_expedicion\" label=\"Fecha de expedición\" ng-model=\"$ctrl.empresa.representante_legal.poder.fecha_expedicion\"\n    ng-disabled=\"true\"></c-date>\n  </div>\n  <!-- <section class=\"col-md-12\">\n    <h6  class=\"title-section m-top\"><i class=\"fa fa-bell-o\"></i> Margen de preferencia</h6>\n  </section>\n  <div class=\"md-input-group col\"><br>\n    <c-checkbox name=\"margen_preferencia\" label=\"Asociación accidental de empresas constructoras cuyos asociados bolivianos tengan una participación igual o mayor al cincuenta y uno por ciento (51%)\"\n    ng-model=\"$ctrl.asociacion.margen_preferencia\"\n    ng-disabled=\"true\"></c-checkbox>\n  </div> -->\n\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\"><i class=\"fa fa-bell-o\"></i> Información para notificaciones</h6>\n  </section>\n  <div class=\"md-input-group col-md-1\"><br>\n    <c-checkbox name=\"correo_empresa_check\" label=\"a)\" ng-model=\"$ctrl.empresa.notificacion_correo_check\"\n    ng-disabled=\"true\"></c-checkbox>\n  </div>\n  <div class=\"md-input-group col-md-5\">\n    <c-input name=\"correo_empresa\" label=\"Correo electrónico\" ng-model=\"$ctrl.empresa.notificacion_correo\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-1\"><br>\n    <c-checkbox name=\"fax_empresa_check\" label=\"b)\" ng-model=\"$ctrl.empresa.notificacion_fax_check\"\n    ng-disabled=\"true\"></c-checkbox>\n  </div>\n  <div class=\"md-input-group col-md-5\">\n    <c-input name=\"fax_empresa\" label=\"Fax\" ng-model=\"$ctrl.empresa.notificacion_fax\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n</div>\n"

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"razon_social\" label=\"Nombre del proponente o razón social\" ng-model=\"$ctrl.empresa.razon_social\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"tipo_empresa\" label=\"Tipo\" ng-model=\"$ctrl.empresa.tipo\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"pais_empresa\" label=\"País\" ng-model=\"$ctrl.empresa.pais\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"ciudad_empresa\" label=\"Ciudad\" ng-model=\"$ctrl.empresa.ciudad\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"direccion_empresa\" label=\"Dirección\" ng-model=\"$ctrl.empresa.direccion\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"telefonos_empresa\" label=\"Teléfonos\" ng-model=\"$ctrl.empresa.telefono\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"nit\" label=\"NIT\" ng-model=\"$ctrl.empresa.nit\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"matricula_comercio\" label=\"Nro. Matrícula de Comercio\" ng-model=\"$ctrl.empresa.nro_matricula\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-date name=\"fecha_inscripcion_empresa\" label=\"Fecha de inscripción\" ng-model=\"$ctrl.empresa.fecha_inscripcion\"\n    ng-disabled=\"true\"></c-date>\n  </div>\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\"><i class=\"fa fa-user-o\"></i> Datos del Representante Legal</h6>\n  </section>\n  <div class=\"md-input-group col-md-8\">\n    <c-input name=\"representante_legal\" label=\"Nombre\" ng-model=\"$ctrl.empresa.representante_legal.persona.nombre\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"ci_representante_legal\" label=\"Nro Cédula de Identidad\" ng-model=\"$ctrl.empresa.representante_legal.persona.documento_identidad\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"nro_testimonio\" label=\"Nro. de testimonio\" ng-model=\"$ctrl.empresa.representante_legal.poder.nro_testimonio\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"lugar_emision\" label=\"Lugar de emisión\" ng-model=\"$ctrl.empresa.representante_legal.poder.lugar_emision\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-date name=\"fecha_expedicion\" label=\"Fecha de expedición\" ng-model=\"$ctrl.empresa.representante_legal.poder.fecha_expedicion\"\n    ng-disabled=\"true\"></c-date>\n  </div>\n\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\"><i class=\"fa fa-bell-o\"></i> Información para notificaciones</h6>\n  </section>\n\n  <div class=\"md-input-group col-md-1\"><br>\n    <c-checkbox name=\"correo_empresa_check\" label=\"a)\" ng-model=\"$ctrl.empresa.notificacion_correo_check\"\n    ng-disabled=\"true\"></c-checkbox>\n  </div>\n  <div class=\"md-input-group col-md-5\">\n    <c-input name=\"correo_empresa\" label=\"Correo electrónico\" ng-model=\"$ctrl.empresa.notificacion_correo\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-1\"><br>\n    <c-checkbox name=\"fax_empresa_check\" label=\"b)\" ng-model=\"$ctrl.empresa.notificacion_fax_check\"\n    ng-disabled=\"true\"></c-checkbox>\n  </div>\n  <div class=\"md-input-group col-md-5\">\n    <c-input name=\"fax_empresa\" label=\"Fax\" ng-model=\"$ctrl.empresa.notificacion_fax\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n</div>\n"

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports = "<div ng-repeat=\"asociado in $ctrl.integrantes.asociados\">\n  <div class=\"row\">\n    <section class=\"col-md-12\">\n      <h6 class=\"title-section m-top\"><i class=\"fa fa-user-o\"></i> Datos del Asociado #{{$index+1}}</h6>\n    </section>\n    <div class=\"md-input-group col-md-12\">\n      <c-input name=\"razon_social\" label=\"Nombre del proponente o razón social\" ng-model=\"asociado.razon_social\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"nit\" label=\"NIT\" ng-model=\"asociado.nit\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"matricula_comercio\" label=\"Nro. Matrícula de Comercio\" ng-model=\"asociado.nro_matricula\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-date name=\"fecha_inscripcion_empresa\" label=\"Fecha de inscripción\" ng-model=\"asociado.fecha_inscripcion\"\n      ng-disabled=\"true\"></c-date>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"!asociado.representante_legal || !asociado.representante_legal.persona\">\n    <div class=\"col-md-12\">\n      <div class=\"alert alert-info\">\n        <i class=\"fa fa-info-circle\"></i> El asociado es una <strong>Empresa Unipersonal</strong> y éste no acredita un Representante Legal.\n      </div>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"asociado.representante_legal && asociado.representante_legal.persona\">\n    <section class=\"col-md-12\">\n      <h6 class=\"m-top\"><i class=\"fa fa-user-o\"></i> Representante Legal</h6>\n    </section>\n    <div class=\"md-input-group col-md-8\">\n      <c-input name=\"representante_legal\" label=\"Nombre\" ng-model=\"asociado.representante_legal.persona.nombre\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"ci_representante_legal\" label=\"Nro Cédula de Identidad\" ng-model=\"asociado.representante_legal.persona.documento_identidad\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"nro_testimonio\" label=\"Nro. de testimonio\" ng-model=\"asociado.representante_legal.poder.nro_testimonio\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"lugar_emision\" label=\"Lugar de emisión\" ng-model=\"asociado.representante_legal.poder.lugar_emision\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-date name=\"fecha_expedicion\" label=\"Fecha de expedición\" ng-model=\"asociado.representante_legal.poder.fecha_expedicion\"\n      ng-disabled=\"true\"></c-date>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"crud-table table-responsive\" ng-table=\"$ctrl.tableParams\">\n  <table class=\"table table-striped table-hover ng-table\">\n    <tr ng-repeat=\"empleado in $data\">\n      <td data-title=\"'Acción'\">\n        <button md-effect type=\"button\" class=\"btn btn-success btn-noborder btn-sm\"\n                uib-tooltip=\"Ver experiencia\" ng-click=\"$ctrl.verExperiencia(empleado)\">\n          <i class=\"fa fa-eye\"></i>\n        </button>\n      </td>\n      <td data-title=\"'Cargo'\" filter=\"{cargo_actual: 'text'}\" sortable=\"'cargo_actual'\">{{empleado.cargo_actual}}</td>\n      <td data-title=\"'Nombre'\" filter=\"{nombre: 'text'}\" sortable=\"'nombre'\">{{empleado.nombre}}</td>\n      <td data-title=\"'Cédula de Identidad'\" filter=\"{documento_identidad: 'text'}\" sortable=\"'documento_identidad'\">{{empleado.documento_identidad}}</td>\n      <td data-title=\"'Nacionalidad'\" filter=\"{nacionalidad: 'text'}\" sortable=\"'nacionalidad'\">{{empleado.nacionalidad}}</td>\n      <td data-title=\"'Profesion'\" filter=\"{profesion: 'text'}\" sortable=\"'profesion'\">{{empleado.profesion}}</td>\n      <td data-title=\"'Nro. Registro Profesional'\" filter=\"{nro_registro_profesional: 'text'}\" sortable=\"'nro_registro_profesional'\">{{empleado.nro_registro_profesional}}</td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header pb-0\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i> {{$ctrl.empleado.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body pt-0\">\n  <uib-tabset active=\"active\">\n    <uib-tab index=\"0\" heading=\"Experiencia General\">\n      <c-table dataset=\"$ctrl.empleado.experiencias.generales\" columns=\"$ctrl.camposExperiencia\"></c-table>\n    </uib-tab>\n\n    <uib-tab index=\"1\" heading=\"Experiencia Específica\" disable=\"tab.disabled\">\n      <c-table dataset=\"$ctrl.empleado.experiencias.especificas\" columns=\"$ctrl.camposExperiencia\"></c-table>\n    </uib-tab>\n  </uib-tabset>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	module.exports = "<uib-tabset active=\"active\">\n  <uib-tab index=\"0\" heading=\"Permanente\">\n    <c-table columns=\"$ctrl.camposEquipo\" dataset=\"$ctrl.equipo.permanente\"></c-table>\n  </uib-tab>\n  <uib-tab index=\"1\" heading=\"A requerimiento\">\n    <c-table columns=\"$ctrl.camposEquipo\" dataset=\"$ctrl.equipo.requerido\"></c-table>\n  </uib-tab>\n</uib-tabset>\n"

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	module.exports = "<uib-tabset active=\"active\">\n  <uib-tab heading=\"General\">\n    <c-table columns=\"$ctrl.camposExperiencia\" dataset=\"$ctrl.experiencias.generales\"></c-table>\n  </uib-tab>\n  <uib-tab heading=\"Específica\">\n    <c-table columns=\"$ctrl.camposExperiencia\" dataset=\"$ctrl.experiencias.especificas\"></c-table>\n  </uib-tab>\n</uib-tabset>\n\n<div class=\"totales col-md-12\" style=\"clear:both;\">\n  <div class=\"row\">\n    <div class=\"col-md-6\">\n      TOTAL FACTURADO EN DÓLARES AMERICANOS (alternativo)\n    </div>\n    <div class=\"col-md-6\">\n      <strong>{{ active === 0 ? $ctrl.totalesExpGeneral.dolares : $ctrl.totalesExpEspecifica.dolares | formatDecimal }}</strong>\n    </div>\n    <div class=\"col-md-6\">\n      TOTAL FACTURADO EN BOLIVIANOS\n    </div>\n    <div class=\"col-md-6\">\n      <strong>{{ active === 0 ? $ctrl.totalesExpGeneral.bolivianos : $ctrl.totalesExpEspecifica.bolivianos | formatDecimal }}</strong>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"formularios\">\n  <div id=\"documento\" ng-repeat=\"formulario in $ctrl.proyecto.formularios\">\n    <div class=\"opciones\">\n      <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.ver(formulario)\">\n        <i class=\"fa fa-eye\"></i>\n      </button>\n\n        <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n                download-file=\"{{formulario.path}}\" file-name=\"{{formulario.nombre_archivo}}\">\n        <i class=\"fa fa-download\"></i>\n      </button>\n    </div>\n    <img src=\"./images/formulario.jpg\" alt=\"Documento\">\n    <div class=\"detalles\">\n      <div class=\"nombre\">{{formulario.nombre}}</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"alert alert-info\">\n  <i class=\"fa fa-info-circle\"></i>\n  <span ng-if=\"!$ctrl.proyecto.monto_total_ejecutado\">El monto total no debe sobrepasar al monto definido en el convenio <strong>{{$ctrl.proyecto.monto_total_convenio | formatDecimal}}</strong>\n  (<strong><em>{{$ctrl.proyecto.monto_total_convenio | numberToLiteral}}</em></strong>)</span>\n  <span ng-if=\"$ctrl.proyecto.monto_total_ejecutado\">El monto total no debe sobrepasar al monto total restante <strong>{{$ctrl.proyecto.monto_total_actual-$ctrl.proyecto.monto_total_ejecutado | formatDecimal}}</strong>\n  (<strong><em>{{$ctrl.proyecto.monto_total_actual-$ctrl.proyecto.monto_total_ejecutado | numberToLiteral}}</em></strong>)</span>\n</div>\n<div class=\"crud-table table-responsive\" id=\"presupuesto-items\">\n  <table class=\"table table-striped table-hover ng-table\">\n    <thead>\n      <tr>\n        <td>Nro</td>\n        <td>Desripción</td>\n        <td>Unidad</td>\n        <td>Cantidad</td>\n        <td>Precios Unitarios</td>\n        <td>Literal</td>\n        <td>Total</td>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in $ctrl.proyecto.items | orderBy : 'nro_item'\" ng-if=\"item.estado!='CERRADO'&&item.cantidad>0\" ng-class=\"{'observado':item.estado=='CERRADO'||item.cantidad==0}\">\n        <td>{{item.nro_item}}</td>\n        <td>{{item.nombre}}</td>\n        <td>{{item.unidad.nombre}}</td>\n        <td class=\"monto\">{{item.cantidad}}</td>\n        <td class=\"warning\">\n          <ng-form name=\"itemPrecio\">\n            <c-input-numeric name=\"precio\" ng-model=\"item.precio_unitario\" class=\"input-precio monto\"\n                             ng-minvalue=\"0.10\" ng-disabled=\"item.estado=='CERRADO'\"\n                             ng-blur=\"$ctrl.registrarPrecioItem(item)\">\n          </c-input-numeric>\n          <ng-form>\n        </td>\n        <td>{{item.precio_unitario | numberToLiteral}}</td>\n        <td class=\"monto\">{{item.precio_unitario? item.cantidad * item.precio_unitario : '' | formatDecimal}}</td>\n      </tr>\n    </tbody>\n  </table>\n\n  <div class=\"alert alert-danger\" ng-if=\"!$ctrl.esPresupuestoValido()\">\n    <i class=\"fa fa-times-circle\"></i>\n    <span ng-if=\"!$ctrl.proyecto.monto_total_ejecutado\">El precio total sobrepasa al monto total de convenio del proyecto (<strong>{{$ctrl.proyecto.monto_total_convenio | formatDecimal}}</strong>).</span>\n    <span ng-if=\"$ctrl.proyecto.monto_total_ejecutado\">El precio total sobrepasa al monto total restante del proyecto (<strong>{{$ctrl.proyecto.monto_total_actual-$ctrl.proyecto.monto_total_ejecutado | formatDecimal}}</strong>).</span>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      Precio Total de Convenio\n    </div>\n    <div class=\"col-md-9\">\n      <strong>{{$ctrl.proyecto.monto_total_convenio | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\" ng-if=\"$ctrl.proyecto.monto_total_actual && $ctrl.proyecto.monto_total_actual!=$ctrl.proyecto.monto_total_convenio\">\n      Precio Total Modificado\n    </div>\n    <div class=\"col-md-9\" ng-if=\"$ctrl.proyecto.monto_total_actual && $ctrl.proyecto.monto_total_actual!=$ctrl.proyecto.monto_total_convenio\">\n      <strong>{{$ctrl.proyecto.monto_total_actual | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\" ng-if=\"$ctrl.proyecto.monto_total_ejecutado\">\n      Precio Total Restante\n    </div>\n    <div class=\"col-md-9\" ng-if=\"$ctrl.proyecto.monto_total_ejecutado\">\n      <strong>{{$ctrl.proyecto.monto_total_actual-$ctrl.proyecto.monto_total_ejecutado | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\">\n      Precio Total (numeral)\n    </div>\n    <div class=\"col-md-9\">\n      <strong>{{$ctrl.precioTotal | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\">\n      Precio Total (literal)\n    </div>\n    <div class=\"col-md-9\">\n      <strong>{{$ctrl.precioTotal | numberToLiteral}}</strong>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"proyecto\" label=\"Poyecto\" ng-model=\"$ctrl.proyecto.nombre\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"codigo\" label=\"Código\" ng-model=\"$ctrl.proyecto.codigo\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"tipo\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.tipo\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"nro_convenio\" label=\"Número de Convenio\" ng-model=\"$ctrl.proyecto.nro_convenio\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-date name=\"fecha_convenio\" label=\"Fecha del Convenio\" ng-model=\"$ctrl.proyecto.fecha_suscripcion_convenio\" ng-disabled=\"true\"></c-date>\n  </div>\n  <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.estado_proyecto === 'REGISTRO_EMPRESA'\">\n    <c-input-numeric name=\"monto_total_convenio\" label=\"Monto total de convenio\" ng-model=\"$ctrl.proyecto.monto_total_convenio\" ng-disabled=\"true\"></c-input-numeric>\n  </div>\n  <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.estado_proyecto === 'REGISTRO_EMPRESA'\">\n    <c-input name=\"plazo_ejecucion_convenio\" label=\"Plazo de ejecución de convenio (días calendario)\" ng-model=\"$ctrl.proyecto.plazo_ejecucion_convenio\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.estado_proyecto !== 'REGISTRO_EMPRESA'\">\n    <c-input-money name=\"monto_total_contrato\" label=\"Monto total\" ng-model=\"$ctrl.proyecto.monto_total\"\n    ng-disabled=\"true\"></c-input-money>\n  </div>\n  <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.estado_proyecto !== 'REGISTRO_EMPRESA'\">\n    <c-input-numeric name=\"plazo_ejecucion_contrato\" label=\"Plazo de ejecución (días calendario)\" ng-model=\"$ctrl.proyecto.plazo_ejecucion\"\n    ng-disabled=\"true\"></c-input-numeric>\n  </div>\n\n</div>\n"

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-bell\"></i> Confirmación previa a la generación de formularios</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>¿Está seguro/a de proceder con la generación de los formularios?. Este procedimiento se realiza por única vez, sin opción a modificaciones posteriores.</p>\n\n  <p>\n    Se le recuerda que el monto total del proyecto (definido en su presupuesto) es <strong>{{$ctrl.proyecto.monto_total | formatDecimal}}</strong>\n    (<strong><em>{{$ctrl.proyecto.monto_total | numberToLiteral}}</em></strong>)\n  </p>\n\n  <div class=\"alert alert-info\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>Ingrese el <strong>número de días de la propuesta</strong>, tome en cuenta que <strong>no debe sobrepasar</strong> al plazo de ejecución definido en el convenio que son\n      <strong>{{$ctrl.proyecto.plazo_ejecucion_convenio}} días</strong>.</span>\n  </div>\n\n  <ng-form name=\"formPlazo\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <c-input-numeric name=\"plazo_ejecucion\" label=\"Plazo de validez (en días calendario)\"\n                         ng-model=\"$ctrl.proyecto.plazo_ejecucion\"\n                         ng-decimals=\"0\" ng-minvalue=\"1\" ng-maxvalue=\"{{$ctrl.proyecto.plazo_ejecucion_convenio}}\"\n                         ng-required=\"true\">\n        </c-input-numeric>\n      </div>\n    </div>\n  </ng-form>\n\n  <small><em>NOTA.- El plazo de ejecución define el tiempo de duración del proyecto.</em></small>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formPlazo\" ng-click=\"$ctrl.aceptar()\">\n    <i class=\"fa fa-check\"></i> Si, estoy seguro/a\n  </button>\n</div>\n"

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyecto Adjudicado\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.anterior()\"\n              ng-disabled=\"$ctrl.WizardHandler.wizard().currentStepNumber() === 1\">\n        <i class=\"fa fa-angle-double-left\" aria-hidden=\"true\"></i> Anterior\n      </button>\n\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.ejecutarAccionPaso()\"\n              ng-disabled=\"$ctrl.WizardHandler.wizard().currentStepNumber() === $ctrl.WizardHandler.wizard().totalStepCount()\"\n              validar-formulario=\"formDatosEmpresa\">\n        Siguiente <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i>\n      </button>\n\n      <ejecutar-transicion elemento=\"$ctrl.proyecto\"\n                           servicio=\"$ctrl.Proyecto\"\n                           atributo-estado=\"estado_proyecto\"\n                           metodo-previo=\"$ctrl.confirmacionGeneracion()\"\n                           metodo-posterior=\"refrescar-documentacion-proyecto\"\n                           url=\"$ctrl.urlProyectos\"\n                           ng-if=\"$ctrl.existeFormulario() && $ctrl.esModoEdicion\">\n      </ejecutar-transicion>\n      <ng-form name=\"formDatosEmpresa\">\n      <wizard indicators-position=\"top\" edit-mode=\"$ctrl.esDocumentacionCompleta()\" ng-if=\"$ctrl.proyecto\">\n        <wz-step wz-title=\"Proyecto\">\n            <proyecto-adjudicado proyecto=\"$ctrl.proyecto\"></proyecto-adjudicado>\n            <codigo-contrato proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.esModoEdicion\"\n                             tiene-documentacion=\"$ctrl.tieneDocumentacion\"\n                             codigo-documentacion=\"$ctrl.codigoDocumentoProy\">\n            </codigo-contrato>\n        </wz-step>\n\n        <wz-step wz-title=\"{{$ctrl.esEmpresa?'Empresa':'Asociación'}}\" ng-if=\"$ctrl.esModoEdicion\" wz-disabled=\"{{!$ctrl.esModoEdicion}}\">\n          <datos-empresa empresa=\"$ctrl.proyecto.documentacion_exp.datos_empresa\" ng-if=\"$ctrl.proyecto.documentacion_exp && $ctrl.esEmpresa\"></datos-empresa>\n          <datos-asociacion empresa=\"$ctrl.proyecto.documentacion_exp.datos_empresa\"\n                            asociacion=\"$ctrl.proyecto.documentacion_exp.datos_asociacion\"\n                            ng-if=\"$ctrl.proyecto.documentacion_exp && !$ctrl.esEmpresa\"></datos-asociacion>\n        </wz-step>\n\n        <wz-step wz-title=\"Integrantes\" wz-disabled=\"{{($ctrl.esEmpresa || !$ctrl.esModoEdicion)}}\">\n          <datos-integrantes integrantes=\"$ctrl.proyecto.documentacion_exp.datos_asociacion\"></datos-integrantes>\n        </wz-step>\n\n        <wz-step wz-title=\"Experiencia\" ng-if=\"$ctrl.esModoEdicion\" wz-disabled=\"{{!$ctrl.esModoEdicion}}\">\n          <experiencia-empresa experiencias=\"$ctrl.proyecto.documentacion_exp.experiencias\" ng-if=\"$ctrl.proyecto.documentacion_exp\"></experiencia-empresa>\n        </wz-step>\n\n        <wz-step wz-title=\"Empleados\" ng-if=\"$ctrl.esModoEdicion\" wz-disabled=\"{{!$ctrl.esModoEdicion}}\">\n          <empleados empleados=\"$ctrl.proyecto.documentacion_exp.empleados\" ng-if=\"$ctrl.proyecto.documentacion_exp\"></empleados>\n        </wz-step>\n\n        <wz-step wz-title=\"Equipo\" ng-if=\"$ctrl.esModoEdicion\" wz-disabled=\"{{!$ctrl.esModoEdicion}}\">\n          <equipo-minimo equipo=\"$ctrl.proyecto.documentacion_exp.equipos_trabajo\" ng-if=\"$ctrl.proyecto.documentacion_exp\"></equipo-minimo>\n        </wz-step>\n\n        <wz-step wz-title=\"Presupuesto\" ng-if=\"$ctrl.esModoEdicion\" wz-disabled=\"{{!$ctrl.esModoEdicion}}\">\n          <presupuesto-items proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.proyecto.documentacion_exp\"></presupuesto-items>\n        </wz-step>\n\n        <wz-step wz-title=\"Cronogramas\" ng-if=\"$ctrl.esModoEdicion\" wz-disabled=\"{{!$ctrl.esModoEdicion}}\">\n          <cronogramas proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.proyecto.documentacion_exp\"></cronogramas>\n        </wz-step>\n\n        <wz-step wz-title=\"Formularios\" ng-if=\"!$ctrl.esModoEdicion\" wz-disabled=\"{{$ctrl.esModoEdicion}}\">\n          <formularios-generados proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.proyecto.documentacion_exp\"></formularios-generados>\n        </wz-step>\n\n      </wizard>\n      </ng-form>\n\n      <div class=\"row both\">\n        <section ng-if=\"$ctrl.proyecto.observacion.mensaje\" class=\"col\">\n          <h6 class=\"title-section error m-top\">\n            <i class=\"fa fa-exclamation-triangle\"></i> Observación\n          </h6>\n          Mensaje: <strong>{{ $ctrl.proyecto.observacion.mensaje }}</strong><br>\n          Observado por: <strong>{{ $ctrl.proyecto.observacion.usuario.persona | nombreUnido }}</strong>\n        </section>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container matriculas\">\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row\">\n        <div class=\"card card-matricula\" ng-repeat=\"matricula in $ctrl.matriculas\">\n          <img src=\"./images/matricula.jpg\" class=\"card-image\" alt=\"Matrícula de comercio\">\n          <div class=\"card-body\">\n            <h4><strong>{{matricula.IdMatricula}}</strong></h4>\n            <span class=\"\">{{matricula.RazonSocial}}</span>\n          </div>\n          <div class=\"card-footer pull-rigth\">\n            <div class=\"text-center\">\n              <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.cargarDatosMatricula(matricula)\">\n                <i class=\"fa fa-check\"></i> Seleccionar\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-table\"></i> Cómputos Métricos - {{$ctrl.supervision.proyecto.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n\n  <computo-proyecto supervision=\"$ctrl.supervision\"\n                    item=\"$ctrl.item\"\n                    computos=\"$ctrl.computos\"\n                    modo-vista=\"$ctrl.modoVista\"\n                    existe-cambios=$ctrl.existeCambiosItem\n                    modificados=\"$ctrl.modificados\">\n  </computo-proyecto>\n\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\" ng-if=\"!$ctrl.modoVista\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formAdjudicacion\" ng-click=\"$ctrl.modoVista? $ctrl.cerrar() : $ctrl.guardar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"fs-sm\" ng-if=\"$ctrl.historialEmpresas\">\n  <h3 class=\"text-center\">\n    Historial de Empresas\n  </h3>\n  <div class=\"row\">\n    <div class=\"col-md-6 text-left\">\n      <table class=\"table mod-t mod-t-b mb-0\">\n        <tbody>\n          <tr ng-repeat=\"avance in $ctrl.historico.proyectos\">\n            <th ng-dblclick=\"$ctrl.verSupervision(avance)\" title=\"{{avance.empresa}}\">Avance Físico ({{$index+1}}° Empresa)</th>\n            <td>{{ avance.total_acumulado_fis/$ctrl.historico.monto_total_proyecto*100 | number:2 }}%</td>\n          </tr>\n          <tr>\n            <th>Total avance físico:</th>\n            <td>{{ $ctrl.historico.porcentaje_total_fis | number:2}}%</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n    <div class=\"col-md-6\">\n      <table class=\"table mod-t mod-t-b mb-0\">\n        <tbody>\n          <tr ng-repeat=\"avance in $ctrl.historico.proyectos\">\n            <th ng-dblclick=\"$ctrl.verSupervision(avance)\" title=\"{{avance.empresa}}\">Avance Financiero ({{$index+1}}° Empresa)</th>\n            <td>{{ avance.monto_avance/$ctrl.historico.monto_total_proyecto*100 | number:2 }}%</td>\n          </tr>\n          <tr>\n            <th>Total avance financiero:</th>\n            <td>{{ $ctrl.historico.porcentaje_total_fin | number:2 }}%</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</section>"

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Foto de la supervisión número {{$ctrl.foto.nro}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row mb-3\">\n    <div class=\"col\">\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.irAPosicion('anterior')\" ng-disabled=\"$ctrl.foto.nro <= 1\">\n        <i class=\"fa fa-angle-double-left\" aria-hidden=\"true\"></i> Anterior\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.irAPosicion('siguiente')\" ng-disabled=\"$ctrl.foto.nro >= $ctrl.fotos.length\">\n        Siguiente <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n  </div>\n\n  <figure class=\"text-center\" ng-repeat=\"foto in $ctrl.fotos\">    \n    <image-viewer id=\"fotosMovil\" base64=\"foto.base64\" height=\"300\" ng-if=\"$ctrl.foto.nro === ($index + 1)\"></image-viewer>\n  </figure>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-lg-4 col-md-6 col-sm-12\" ng-repeat=\"foto in $ctrl.fotos\">\n    <figure ng-dblclick=\"$ctrl.mostrarPopup(foto)\">\n      <span ng-if=\"!foto.mostrar\">Cargando ...</span>\n      <div ng-if=\"foto.mostrar\" class=\"foto\">\n        <img ng-src=\"data:image/jpg;base64, {{ foto.base64 }}\" alt=\"Foto {{foto.nro}}\" height=\"300\" width=\"100%\">\n        <div class=\"detalles\">\n          <span class=\"titulo\">Foto supervisión {{foto.nro}}</span>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"$ctrl.mostrarPopup(foto)\" uib-tooltip=\"Ver foto\">\n            <i class=\"fa fa-eye\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-primary pull-right\" ng-click=\"$ctrl.mostrarUbicacion(foto)\" uib-tooltip=\"Ver ubicación\">\n            <i class=\"fa fa-map-marker\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-danger pull-right\" ng-click=\"$ctrl.eliminarFoto(foto)\" uib-tooltip=\"Recargar datos de la fotografia\" ng-if=\"$ctrl.puedeEliminar\">\n            <i class=\"fa fa-trash\"></i>\n          </button>\n        </div>\n      </div>\n    </figure>\n  </div>\n</div>\n"

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-table\"></i> Confirmación previa a la aprobación de la planilla de avance</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>\n    El avance físico {{$ctrl.items.length > 1 ? 'de los items listados' : 'del item listado'}} a continuación está concluído, sin embargo el avance financiero aún no está cerrado.\n  </p>\n\n  <div class=\"crud-table\">\n    <table class=\"table table-hover table-striped table-responsive fs-sm\">\n      <thead>\n        <tr>\n          <th rowspan=\"2\" title=\"Nro de item\">Nro</th>\n          <th rowspan=\"2\" class=\"text-left\">Descripción</th>\n          <th rowspan=\"2\" title=\"Unidad\">Unid.</th>\n          <th rowspan=\"2\" title=\"Cantidad\">Cant.</th>\n          <th rowspan=\"2\" title=\"Precio Unitario\">P.U.</th>\n          <th rowspan=\"2\">Total(Bs)</th>\n          <th colspan=\"2\" class=\"text-center\">Volumenes de avance</th>\n          <th colspan=\"2\" class=\"text-center\">Avance financiero</th>\n        </tr>\n        <tr>\n          <th title=\"Total Acumulado\">T.A.</th>\n          <th title=\"Falta ejecutar\">F.E.</th>\n          <th title=\"Total Acumulado\">T.A.</th>\n          <th title=\"Falta ejecutar\">F.E.</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in $ctrl.items\">\n          <td>{{item.nro_item}}</td>\n          <td>{{item.nombre}}</td>\n          <td>{{item.unidad.nombre}}</td>\n          <td>{{item.cantidad | number:2}}</td>\n          <td>{{item.precio_unitario | number:2}}</td>\n          <td>{{item.total | number:2}}</td>\n          <td>{{item.total_acumulado_fis | number:2}}</td>\n          <td>{{item.falta_ejecutar_fis}}</td>\n          <td>{{item.total_acumulado_fin | number:2}}</td>\n          <td>{{item.falta_ejecutar_fin}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <p>\n    Al aprobar la planilla de avance se procederá a cerrar el avance financiero {{$ctrl.items.length > 1 ? 'de los items mencionados' : 'del item mencionado'}}.\n  </p>\n\n  <p class=\"resaltado\">\n    Si está seguro/a de aprobar la planilla de avance presione la opción \"<strong>APROBAR</strong>\" en caso contrario \"<strong>CANCELAR</strong>\".\n  </p>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\" ng-if=\"!$ctrl.modoVista\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.aprobar()\">\n    <i class=\"fa fa-check\"></i> Aprobar\n  </button>\n</div>\n"

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container px-3 planilla-proy\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyecto <small><strong>{{$ctrl.proyecto.nombre}}</strong></small>\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row mx-0\">\n        <div style=\"font-size: 20px;\" uib-tooltip=\"Volver atrás\" ng-click=\"$ctrl.irAtras()\">\n          <i class=\"fa fa-reply\"></i>\n        </div>\n      </div>\n      <h4 class=\"text-center\"><strong>{{$ctrl.proyecto.empresa.nombre}}</strong></h4>\n      <h3 class=\"text-center\">\n        Planilla de avance de obra Nro. {{$ctrl.supervision.nro_supervision}}\n      </h2>\n      <div class=\"texto\">\n        <p class=\"text-center\">Del {{$ctrl.supervision.fecha_inicio | date : 'dd/MM/yyyy'}} al {{!$ctrl.supervision.fecha_fin ? '-' : $ctrl.supervision.fecha_fin | date : 'dd/MM/yyyy'}} <br>\n          <span class=\"resaltado\" ng-if=\"$ctrl.supervision.monto_total_por_ejecutar === 0\">Planilla de cierre</span>\n        </p>\n        <section>\n          <a href=\"\">\n            <h6 class=\"title-section m-top\" ng-click=\"$ctrl.datosProyectoIsCollapsed = !$ctrl.datosProyectoIsCollapsed\">\n              <i class=\"fa fa-hand-o-right\"></i> Datos del proyecto\n            </h6>\n          </a>\n          <div uib-collapse=\"$ctrl.datosProyectoIsCollapsed\">\n            <div class=\"row\">\n              <div class=\"col-md-4 text-left\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr> <th class=\"text-right\">Nombre:</th> <td>{{$ctrl.proyecto.nombre}}</td> </tr>\n                    <tr> <th class=\"text-right\">Departamento:</th> <td>{{$ctrl.proyecto.dpa.departamento.nombre}}</td> </tr>\n                    <tr> <th class=\"text-right\">Provincia:</th> <td>{{$ctrl.proyecto.dpa.provincia.nombre}}</td> </tr>\n                    <tr> <th class=\"text-right\">Municipio:</th> <td>{{$ctrl.proyecto.dpa.municipio.nombre}}</td> </tr>\n                    <tr><th class=\"text-right\">Beneficiario:</th> <td>{{$ctrl.proyecto.entidad_beneficiaria}}</td> </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"col-md-4\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr> <th class=\"text-right\">Monto convenio:</th> <td class=\"text-right\">{{$ctrl.proyecto.monto_total_convenio | number:2}}</td> </tr>\n                    <tr> <th class=\"text-right\">Monto contrato:</th> <td class=\"text-right\">{{$ctrl.proyecto.monto_contractual | number:2}}</td> </tr>\n                    <tr ng-if=\"$ctrl.supervision.proyecto.monto_total!=$ctrl.proyecto.monto_contractual && $ctrl.proyecto.monto_contractual\">\n                      <th class=\"text-right\">Monto total con modificación:</th> <td class=\"text-right\">{{$ctrl.supervision.proyecto.monto_total | number:2}}</td>\n                    </tr>\n                    <tr> <th class=\"text-right\">Anticipo {{$ctrl.proyecto.porcentaje_anticipo | number:0}}%:</th> <td class=\"text-right\">{{$ctrl.proyecto.anticipo | number:2}}</td> </tr>\n                    <tr ng-repeat=\"supervision in $ctrl.supervision.supervisiones_anteriores\"> <th class=\"text-right\">Monto {{supervision.numero}} desembolso:</th> <td class=\"text-right\">{{supervision.desembolso | number:2}}</td> </tr>\n                    <tr> <th class=\"text-right\">TOTAL DESEMBOLSADO:</th> <td class=\"text-right\"><strong>{{$ctrl.supervision.monto_desembolso_total | number:2}}</strong></td> </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"col-md-4\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr> <th class=\"text-right\">Fecha inicio de obras/<br> Libro de ordenes:</th> <td>{{$ctrl.proyecto.orden_proceder | date : 'dd/MM/yyyy'}}</td> </tr>\n                    <tr> <th class=\"text-right\">Plazo de Ejecución</th> <td>{{$ctrl.proyecto.plazo_ejecucion}}</td> </tr>\n                    <tr> <th class=\"text-right\">Ampliación de Plazo</th> <td>{{$ctrl.proyecto.plazo_ampliacion.por_volumenes+$ctrl.proyecto.plazo_ampliacion.por_compensacion || 0}}</td> </tr>\n                    <tr> <th class=\"text-right\">Fecha prevista p/Recepción Provisional</th> <td>{{($ctrl.proyecto.fecha_recepcion_provisional) | date : 'dd/MM/yyyy'}}</td> </tr>\n                    <tr> <th class=\"text-right\">Fecha prevista p/Recepción definitiva </th> <td>{{($ctrl.proyecto.fecha_recepcion_definitiva) | date : 'dd/MM/yyyy'}}</td> </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n        </section>\n      </div>\n\n      <section>\n        <h6 class=\"title-section m-top\">\n          <i class=\"fa fa-list\"></i> Items del proyecto\n        </h6>\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <div class=\"alert alert-info text-white\">\n              <i class=\"fa fa-info-circle\"></i>\n              <span>Puede hacer doble click a un item para <strong>{{$ctrl.esEditable? 'realizar' : 'revisar'}} su cómputo métrico</strong>.</span>\n            </div>\n          </div>\n          <div class=\"col-md-6\" ng-if=\"$ctrl.proyecto.doc_especificaciones_tecnicas\">\n            <button md-effect type=\"button\" class=\"btn btn-info\" download-file=\"{{$ctrl.urlDescEspTecnicas}}\" file-name=\"Especificaciones técnicas\"\n            uib-tooltip=\"Especificaciones técnicas\" tooltip-placement=\"bottom\">\n              <i class=\"fa fa-file-text-o\"></i> E. Técnicas\n            </button>\n            <button md-effect type=\"button\" class=\"btn btn-info\" download-file=\"{{$ctrl.urlDescPlanilla}}\" file-name=\"Planilla de avance nro {{$ctrl.supervision.nro_supervision}}\"\n            uib-tooltip=\"Planilla de avance nro {{$ctrl.supervision.nro_supervision}}\" tooltip-placement=\"bottom\" ng-if=\"$ctrl.supervision.version_proyecto\">\n              <i class=\"fa fa-file-text-o\"></i> Planilla\n            </button>\n            <button md-effect type=\"button\" class=\"btn btn-info\" download-file=\"{{$ctrl.urlDescComputosResumen}}\" file-name=\"Resúmen de cómputos métricos de la planilla\"\n            uib-tooltip=\"Resúmen de cómputos métricos de la planilla\" tooltip-placement=\"bottom\" ng-if=\"$ctrl.supervision.version_proyecto\">\n              <i class=\"fa fa-table\"></i> Cómputos\n            </button>\n          </div>\n        </div>\n\n        <div class=\"row mt-2 mb-2\">\n          <div class=\"col-lg-6 col-md-12 mb-2\">\n            <div class=\"btn-group opciones\">\n              <label md-effect class=\"btn btn-primary\" btn-checkbox ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'TODOS'\">Todos</label>\n              <label md-effect class=\"btn btn-primary\" ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'COMPLETADOS'\">Completados</label>\n              <label md-effect class=\"btn btn-primary\" ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'INCOMPLETOS'\">Por completar</label>\n              <label md-effect class=\"btn btn-primary\" ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'PARA_ENVIAR'\">Planilla</label>\n            </div>\n          </div>\n          <div class=\"col-lg-6 col-md-12 mt-2\">\n\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator success\"></span><span>Completado</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator info\"></span><span>Con avance</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator primary\"></span><span>Sin avance</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator warning\"></span><span>Con avance en anterior(es) planilla(s)</span>\n            </label>\n          </div>\n        </div>\n\n        <div ng-repeat=\"modulo in $ctrl.supervision.modulos\" ng-show=\"modulo.show\" class=\"texto\">\n          <div class=\"my-1 mod-h\" ng-click=\"modulo.isCollapsed = !modulo.isCollapsed\">\n            <span uib-tooltip=\"Click para ocultar/mostrar sus items\" tooltip-placement=\"right\">\n              <strong>Módulo:</strong> {{modulo.nombre}}\n            </span>\n          </div>\n          <hr class=\"mt-2 mb-1\">\n          <div class=\"table-responsive\">\n            <div uib-collapse=\"modulo.isCollapsed\">\n              <table class=\"table table-striped mod-t text-right\" style=\"width:{{1820+$ctrl.supervision.proyecto.proyecto_historico.length*270}}px;max-width:none\">\n                <thead>\n                  <tr>\n                    <th rowspan=\"2\" title=\"Nro de item\" style=\"width:50px\">Nro</th>\n                    <th rowspan=\"2\" class=\"text-left\" style=\"width:350px\">Descripción</th>\n                    <th rowspan=\"2\" title=\"Unidad\" style=\"width:70px\">Unid.</th>\n                    <th colspan=\"3\" class=\"text-center\" style=\"width:270px\"\n                        ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<=$ctrl.supervision.version_proyecto\"\n                        ng-repeat=\"version in $ctrl.supervision.proyecto.proyecto_historico\">\n                        {{version.tipo_modificacion_proyecto.nombre}} {{version.tipo_modificacion_proyecto.numero}}\n                      </th>\n                    <th colspan=\"3\" class=\"text-center\" style=\"width:270px\"\n                        ng-if=\"$ctrl.supervision.version_proyecto===null || $ctrl.supervision.proyecto.version<=$ctrl.supervision.version_proyecto\">\n                        {{$ctrl.supervision.version_proyecto==1 || $ctrl.supervision.proyecto.version === 1 ? 'Contrato Original': $ctrl.proyecto.tipo_modificacion_proyecto.nombre+' '+$ctrl.proyecto.tipo_modificacion_proyecto.numero}}\n                      </th>\n                    <th colspan=\"4\" class=\"text-center\" style=\"width:360px\">Volumenes de avance</th>\n                    <th colspan=\"4\" class=\"text-center\" style=\"width:360px\">Avance financiero</th>\n                    <th rowspan=\"2\" title=\"% Ejecutado Físico\" style=\"width:90px\">% E.Fis.</th>\n                    <th rowspan=\"2\" title=\"% Ejecutar\" style=\"width:90px\">% E.</th>\n                    <th rowspan=\"2\" title=\"% Ejecutado Financiero\" style=\"width:90px\">% E.Fin.</th>\n                    <th rowspan=\"2\" title=\"% Ejecutar\" style=\"width:90px\">% E.</th>\n                  </tr>\n                  <tr>\n                    <th ng-repeat-start=\"version in modulo.items[0].item_historico\" style=\"width:90px\"\n                        ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\">Cant.</th>\n                    <th style=\"width:90px\"\n                        ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\">P.U.</th>\n                    <th ng-repeat-end style=\"width:90px\"\n                        ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\">Total</th>\n                    <th title=\"Cantidad\" style=\"width:90px\">Cant.</th>\n                    <th title=\"Precio Unitario\" style=\"width:90px\">P.U.</th>\n                    <th style=\"width:90px\">Total(Bs)</th>\n                    <th style=\"width:90px\">Anterior</th>\n                    <th style=\"width:90px\">Actual</th>\n                    <th title=\"Total Acumulado\" style=\"width:90px\">T.A.</th>\n                    <th title=\"Falta ejecutar\" style=\"width:90px\">F.E.</th>\n                    <th style=\"width:90px\">Anterior</th>\n                    <th style=\"width:90px\">Actual</th>\n                    <th title=\"Total Acumulado\" style=\"width:90px\">T.A.</th>\n                    <th title=\"Falta ejecutar\" style=\"width:90px\">F.E.</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-dblclick=\"$ctrl.mostrarComputo(item)\" ng-repeat=\"item in modulo.items\" ng-show=\"item.show\"\n                  ng-class=\"[{'observado': (item.falta_ejecutar_fis === 0 && item.falta_ejecutar_fin !== 0) || (item.ejecutar_porcentaje_fis === 0  && item.falta_ejecutar_fis > 0)}]\">\n                    <td ng-class=\"$ctrl.getMgColor(item)\" title=\"{{$ctrl.getTitle(item)}}\">{{item.nro_item}}</td>\n                    <td class=\"text-left\">\n                      {{item.nombre}}\n                      <button md-effect class=\"btn btn-info btn-sm right\" uib-tooltip=\"Reporte de Cómputos métricos\"\n                        ng-if=\"$ctrl.supervision.version_proyecto && item.cantidad_actual_fis > 0\"\n                        download-file=\"{{$ctrl.urlDescComputosItem + item.nro_item + '_' + $ctrl.supervision.nro_supervision + '/descargar'}}\"\n                        file-name=\"Computos metricos item nro {{item.nro_item}}\">\n                        <i class=\"fa fa-table\"></i>\n                      </button>\n                    </td>\n                    <td>{{$ctrl.unidades_obj[item.unidad_medida].nombre}}</td>\n                    <td ng-repeat-start=\"version in item.item_historico\"\n                        ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\"\n                        ng-class=\"[{'text-info font-weight-bold modificado':version.modificado}, $ctrl.getTipoClass(version.modificacion)]\">{{version.cantidad |number:2}}</td>\n                    <td ng-class=\"$ctrl.getTipoClass(version.modificacion)\"\n                        ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\">{{version.precio_unitario |number:2}}</td>\n                    <td ng-repeat-end ng-class=\"[{'text-info font-weight-bold':version.modificado}, $ctrl.getTipoClass(version.modificacion)]\"\n                        ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\">{{version.total |number:2}}</td>\n                    <td ng-class=\"[{'text-info font-weight-bold modificado':item.modificado},$ctrl.getTipoClass($ctrl.proyecto.tipo_modificacion)]\">{{item.cantidad | number:2}}</td>\n                    <td ng-class=\"$ctrl.getTipoClass($ctrl.proyecto.tipo_modificacion)\">{{item.precio_unitario | number:2}}</td>\n                    <td ng-class=\"[{'text-info font-weight-bold':item.modificado},$ctrl.getTipoClass($ctrl.proyecto.tipo_modificacion)]\">{{item.total | number:2}}</td>\n                    <td>{{item.cantidad_anterior_fis | number:2}}</td>\n                    <td>{{item.cantidad_actual_fis | number:2}}</td>\n                    <td>{{item.total_acumulado_fis | number:2}}</td>\n                    <td ng-class=\"{'danger' : item.falta_ejecutar_fis < 0}\">{{item.falta_ejecutar_fis | number:2}}</td>\n                    <td>{{item.cantidad_anterior_fin | number:2}}</td>\n                    <td>{{item.cantidad_actual_fin | number:2}}</td>\n                    <td>{{item.total_acumulado_fin | number:2}}</td>\n                    <td ng-class=\"{'danger' : item.falta_ejecutar_fin < 0}\">{{item.falta_ejecutar_fin | number:2}}</td>\n                    <td>{{item.ejecutado_porcentaje_fis | number:2}}</td>\n                    <td>{{item.ejecutar_porcentaje_fis | number:2}}</td>\n                    <td>{{item.ejecutado_porcentaje_fin | number:2}}</td>\n                    <td>{{item.ejecutar_porcentaje_fin | number:2}}</td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n      </section>\n      <div class=\"alert alert-warning\"ng-if=\"$ctrl.itemsNoCerrados.length > 0\">\n        <i class=\"fa fa-warning\"></i>\n        <span ng-if=\"$ctrl.itemsNoCerrados.length === 1\"><strong>El item resaltado</strong> tiene</span>\n        <span ng-if=\"$ctrl.itemsNoCerrados.length > 1\"><strong>Los items resaltados</strong> tienen</span>\n        <span>concluido el avance físico, sin embargo la parte financiera no ha cerrado o {{$ctrl.itemsNoCerrados.length > 1? 'tienen' : 'tiene'}}\n          concluído el porcentaje de avance físico sin embargo aún hay una cantidad faltante por ejecutar. Este detalle será revisado por personal de la UPRE.</span>\n      </div>\n\n      <div class=\"fs-sm\">\n        <div class=\"row\">\n          <div class=\"col-md-6 text-left\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th>Monto actual ejecutado:</th>\n                  <td>{{$ctrl.supervision.monto_total_actual_ejecutado | number:2}}</td>\n                </tr>\n                <tr>\n                  <th>Porcentaje total ejecutado:</th>\n                  <td>{{$ctrl.supervision.porcentaje_avance_fis | number:2}}%</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"col-md-6\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th>Monto actual acumulado a la fecha:</th>\n                  <td>{{$ctrl.supervision.monto_total_acumulado | number:2}}</td>\n                </tr>\n                <tr>\n                  <th>Monto total por ejecutar:</th>\n                  <td>{{$ctrl.supervision.monto_total_por_ejecutar | number:2}}</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"mt-4 texto\">\n        <div class=\"row\">\n          <div class=\"col-md-6 text-left\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th class=\"mot-t-sin-b\" colspan=\"3\">II. VERIFICACIÓN DE BOLETAS DE GARANTÍA </th>\n                </tr>\n                <tr>\n                  <th>Descripción</th>\n                  <th>Tipo</th>\n                  <th>Fecha de vencimiento</th>\n                </tr>\n                <tr ng-repeat=\"boleta in $ctrl.boletasAnticipo\">\n                  <td rowspan=\"{{$ctrl.boletasAnticipo.length}}\" ng-hide=\"$index>0\">Buena inversión del Anticipo</td>\n                  <td>{{ boleta.tipo_documento == 'POLIZA' ? 'Póliza' :'Boleta' }}</td>\n                  <td>{{ boleta.fecha_fin_validez | date : 'dd/MM/yyyy' }}</td>\n                </tr>\n                <tr ng-repeat=\"boleta in $ctrl.boletasCcontrato\">\n                  <td rowspan=\"{{$ctrl.boletasCcontrato.length}}\" ng-hide=\"$index>0\">Cumplimiento de Contrato</td>\n                  <td>{{ boleta.tipo_documento == 'POLIZA' ? 'Póliza' :'Boleta' }}</td>\n                  <td>{{ boleta.fecha_fin_validez | date : 'dd/MM/yyyy' }}</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"col-md-6\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th class=\"mot-t-sin-b\" colspan=\"3\">III.  INFORME TÉCNICO DE CONCLUSIONES </th>\n                </tr>\n                <tr>\n                  <th>Avance Físico</th>\n                  <td>{{$ctrl.supervision.porcentaje_avance_fis | number:2}}%</td>\n                </tr>\n                <tr>\n                  <th>Avance Financiero</th>\n                  <td>{{$ctrl.supervision.porcentaje_avance_fin | number:2}}%</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n\n        <section ng-if=\"$ctrl.Supervision.esAreaPermitida('DEUDA_ANTICIPO') && $ctrl.tieneDeudas\">\n          <h6 class=\"title-section m-top\"> <i class=\"fa fa-money\"></i> Descuento por anticipo </h6>\n          <p> La empresa solicitó un anticipo de <strong>{{$ctrl.proyecto.anticipo | number : 2}} Bs.</strong>\n            equivalente al {{$ctrl.proyecto.porcentaje_anticipo}}% del monto del contrato ({{$ctrl.proyecto.monto_total | number : 2}} Bs.).</p>\n\n          <p ng-if=\"$ctrl.supervision.supervisiones_anteriores.length > 0\"> A la fecha la empresa adeuda <strong>{{$ctrl.deudaAnticipo | number :2}} Bs.</strong> por concepto de anticipo pendiente. </p>\n\n          <p> La empresa solicitó el descuento <strong>{{$ctrl.supervision.tipo_descuento_anticipo}}</strong> por concepto de anticipo,\n            mismo que es equivalente a {{$ctrl.desembolso.descuento | number : 2}} Bs.\n            y el monto a desembolsar será <strong>{{$ctrl.desembolso.total | number : 2}} Bs.</strong> para la actual planilla. </p>\n        </section>\n\n        <section ng-if=\"$ctrl.Supervision.esAreaPermitida('FOTOGRAFIAS')\">\n          <h6 class=\"title-section m-top\"> <i class=\"fa fa-photo\"></i> Fotografías de la supervisión </h6>\n          <div class=\"alert alert-info\" ng-if=\"$ctrl.supervision.fotos_supervision.length === 0\">\n            <i class=\"fa fa-info-circle\"></i>\n            <span>Debe sacar fotografías a la obra con la aplicación móvil.</span>\n          </div>\n          <fotos-supervision fotos=\"$ctrl.supervision.fotos_supervision\" supervision=\"$ctrl.supervision\" ng-if=\"$ctrl.supervision.fotos_supervision.length > 0\"></fotos-supervision>\n          <div class=\"alert alert-info\" ng-if=\"$ctrl.supervision.nro_supervision===1\">\n            <i class=\"fa fa-exclamation-circle\"></i>\n            <strong>¡ADVERTENCIA!</strong><br>\n            <span>* Deberá tomar en cuenta que las primeras 3 fotos tomadas y aprobadas en la 1ra. planilla de avance establecerán la Georeferenciación del proyecto, siendo que para el envio de las siguientes planillas de avance la aplicación móvil no permitirá tomar las 3 fotos de una ubicación diferente o que no se encuentre dentro del radio permitido.</span>\n            <br><span>* Puede verificar la ubicación haciendo click en el botón <i class=\"fa fa-map-marker\"></i> de cada foto.</span>\n          </div>\n        </section>\n\n        <ng-form name=\"formSupervision\">\n          <section ng-if=\"$ctrl.Supervision.esAreaPermitida('INFORME')\">\n            <h6 class=\"title-section m-top\">\n              <i class=\"fa fa-file-text\"></i> Informe técnico de conclusiones\n            </h6>\n            <c-textarea label=\"Breve informe narrativo acerca de la situación del proyecto:\"\n                        name=\"observacion\" ng-model=\"$ctrl.supervision.informe\" rows=\"7\" ng-minlength=\"20\" maxlength=\"3000\"\n                        ng-required=\"true\"\n                        ng-if=\"$ctrl.Supervision.esEditable('informe')\">\n            </c-textarea>\n            <p ng-if=\"!$ctrl.Supervision.esEditable('informe')\" style=\"white-space:pre-wrap\" class=\"text-justify\">{{$ctrl.supervision.informe}}</p>\n          </section>\n        </ng-form>\n        <div class=\"mt-3\">\n          <small class=\"resaltado\"><strong><em>La presente planilla tiene valor de declaración Jurada, por lo que si se identifica cualquier falsedad, se realizarán las acciones legales respectivas en contra de la empresa constructora infractora.</em></strong></small>\n        </div>\n\n        <section ng-if=\"$ctrl.supervision.observacion_proceso.mensaje\">\n          <h6 class=\"title-section error m-top\">\n            <i class=\"fa fa-exclamation-triangle\"></i> Observación\n          </h6>\n          Mensaje: <strong>{{ $ctrl.supervision.observacion_proceso.mensaje }}</strong><br>\n          Observado por: <strong>{{ $ctrl.supervision.observacion_proceso.usuario.persona | nombreUnido }}</strong>\n        </section>\n\n        <div class=\"row my-3 pr-3 justify-content-end\">\n          <button md-effect type=\"button\" class=\"btn mr-3\" ng-click=\"$ctrl.filtroItems === 'PARA_ENVIAR' ? $ctrl.filtroItems = 'TODOS' : $ctrl.filtroItems = 'PARA_ENVIAR'\" ng-if=\"$ctrl.esEtapaEdicion\">\n            <i class=\"fa fa-eye\"></i> {{ $ctrl.filtroItems === 'PARA_ENVIAR' ? 'Ver todos' : 'Ver Planilla a enviar'}}\n          </button>\n          <ejecutar-transicion elemento=\"$ctrl.supervision\"\n                               servicio=\"$ctrl.Supervision\"\n                               form=\"formSupervision\"\n                               atributo-estado=\"estado_supervision\"\n                               url=\"$ctrl.url\"\n                               confirmar=\"true\"\n                               metodo-previo=\"$ctrl.verificarPlanilla()\">\n          </ejecutar-transicion>\n        </div>\n      </div>\n    </div>\n  </div>\n  <br>\n  <div class=\"card\" ng-if=\"$ctrl.supervision\">\n    <div class=\"card-body\">\n      <empresa-anterior supervision=\"$ctrl.supervision\"></empresa-anterior>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-search\"></i> Verificación de anticipo</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>Para este proyecto \"<strong>{{$ctrl.supervision.proyecto.nombre}}</strong>\", la empresa ha solicitado un\n    <strong>anticipo del {{$ctrl.supervision.proyecto.porcentaje_anticipo}}% equivalente a {{$ctrl.supervision.proyecto.anticipo | number}} Bs.</strong> del monto del contrato. </p>\n  <p>Para el pago de esta planilla requiere que se realice el descuento, elija el tipo de descuento que desea. </p>\n\n  <p ng-if=\"$ctrl.supervision.supervisiones_anteriores.length > 0\">\n    La empresa aún adeuda <strong>{{$ctrl.deudaAnticipo | number : 2}} Bs.</strong> por concepto de anticipo.\n  </p>\n\n  <div class=\"alert alert-warning\" ng-if=\"!$ctrl.puedeDescuentoTotal\">\n    <span>El monto total ejecutado es menor al monto del anticipo{{$ctrl.supervision.supervisiones_anteriores.length > 0 ? ' pendiente' : ''}}, por lo que el descuento será <strong>PROGRESIVO.</strong></span>\n  </div>\n\n  <div class=\"alert alert-warning\" ng-if=\"!$ctrl.puedeDescuentoProgresivo && !$ctrl.esPlanillaCierre\">\n    <span>El monto calculado para el descuento <strong>progresivo</strong> supera la cantidad que adeuda la empresa, por lo que el descuento será por el <strong>TOTAL</strong>.</span>\n  </div>\n\n  <div class=\"alert alert-warning\" ng-if=\"$ctrl.esPlanillaCierre\">\n    <span>La planilla actual corresponde a la <strong>planilla de cierre</strong>, por lo que el descuento debe ser por el <strong>TOTAL</strong>.</span>\n  </div>\n  <ng-form name=\"formDescuento\">\n    <c-radiobutton name=\"tipo_descuento\" label=\"Tipo de descuento\"\n                   ng-model=\"$ctrl.supervision.tipo_descuento_anticipo\"\n                   options=\"$ctrl.tiposDescuento\"\n                   field=\"nombre\"\n                   ng-change=\"$ctrl.calcularDescuento(data)\"\n                   ng-required=\"true\"\n                   ng-disabled=\"!$ctrl.puedeDescuentoTotal || !$ctrl.puedeDescuentoProgresivo\">\n    </c-radiobutton>\n  </ng-form>\n\n  <p> El monto actual ejecutado es <strong>{{$ctrl.supervision.monto_total_actual_ejecutado | number : 2}} Bs.</strong> <br>\n   <span ng-if=\"$ctrl.desembolso\">El monto a descontar es <strong>{{$ctrl.desembolso.descuento | number : 2}} Bs.</strong> y el monto a desembolsar será <strong>{{$ctrl.desembolso.total | number : 2}} Bs.</strong></span> </p>\n  <div class=\"alert alert-info\">\n    <span class=\"text-message\"><strong>*</strong>&nbspDescuento de la totalidad del anticipo {{$ctrl.supervision.supervisiones_anteriores.length > 0 ? 'pendiente' : '' }} al monto total ejecutado de la planilla de avance.</span><br>\n    <span class=\"text-message\"><strong>**</strong>Descuento del porcentaje del anticipo respecto al monto total ejecutado de la planilla de avance.</span>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formDescuento\" ng-click=\"$ctrl.registrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Ubicaciones</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row mb-3\">\n    <div class=\"col\">\n      <leaflet lf-center=\"$ctrl.mapa.centro\" controles=\"$ctrl.mapa.controls\" height=\"400px\" width=\"100%\" markers=\"$ctrl.mapa.marcadores\"></leaflet>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\"><i class=\"fa fa-user\"></i> Asignación de Responsable</h6>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <c-select name=\"usuario_asignado\"\n      label=\"Responsable de Proyecto\"\n      ng-model=\"$ctrl.usuario_asignado\"\n      on-select=\"$ctrl.seleccionado()\"\n      options=\"$ctrl.usuariosParaAsignar\"\n      field=\"nombre\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fid_usuario_asignado')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fid_usuario_asignado')\"></c-select>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	module.exports = "<documento-identidad ng-model=\"$ctrl.proyecto.autoridad_beneficiaria\" modo-vista=\"$ctrl.modoVista\"></documento-identidad>\n\n<div class=\"row\">\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"cargo\" label=\"Cargo\" ng-model=\"$ctrl.proyecto.cargo_autoridad_beneficiaria\"\n      maxlength=\"150\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('cargo_autoridad_beneficiaria')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('cargo_autoridad_beneficiaria')\">\n    </c-input>\n  </div>\n\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"celular\" label=\"Celular\" ng-model=\"$ctrl.proyecto.autoridad_beneficiaria.telefono\"\n      ng-validation=\"celular\" ng-directives=\"numeric\" maxlength=\"8\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('autoridad_beneficiaria')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\">\n    </c-input>\n  </div>\n\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"correo\" label=\"Correo Electrónico\" ng-model=\"$ctrl.proyecto.autoridad_beneficiaria.correo\"\n      maxlength=\"150\" ng-validation=\"correo\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\">\n    </c-input>\n  </div>\n\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"fax\" label=\"Fax\" ng-model=\"$ctrl.proyecto.fax_autoridad_beneficiaria\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fax_autoridad_beneficiaria')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fax_autoridad_beneficiaria')\">\n    </c-input>\n  </div>\n</div>\n"

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"md-input-group col-md-6\">\n    <c-input-numeric name=\"{{$ctrl.datos.nombrePorcentaje}}\" label=\"Porcentaje\"\n      ng-model=\"$ctrl.porcentaje\"\n      ng-minvalue=\"0\" ng-maxvalue=\"20\" ng-formatting=\"false\" ng-decimals=\"2\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('porcentaje_anticipo')\"\n      ng-disabled=\"$ctrl.modoVista || $ctrl.datos.porcentajeFijo\">\n    </c-input-numeric>\n  </div>\n\n  <div class=\"md-input-group col-md-6\">\n    <c-input-money name=\"{{$ctrl.datos.nombreMonto}}\" label=\"Monto\" ng-model=\"$ctrl.monto\"\n      ng-minvalue=\"0\"\n      ng-disabled=\"true\"></c-input-money>\n  </div>\n</div>\n\n<div class=\"row\">\n  <div class=\"col\" ng-if=\"$ctrl.mostrarBoletas && !$ctrl.completado && !$ctrl.modoVista\">\n    <button md-effect class=\"btn btn-success text-right\" type=\"submit\"\n      ng-click=\"$ctrl.adicionarBoleta()\">\n      <i class=\"fa fa-plus\"></i> Agregar boleta\n    </button>\n  </div>\n  <div class=\"col-md-9\" ng-if=\"$ctrl.mostrarBoletas && $ctrl.mensaje.mensaje\">\n    <div class=\"alert alert-{{$ctrl.mensaje.class}}\">\n      <i class=\"fa fa-{{$ctrl.mensaje.icono}}\"></i>\n      {{$ctrl.mensaje.mensaje}}, la suma de las boletas es <strong>{{$ctrl.sumaMontoBoletas | formatDecimal}}</strong>\n    </div>\n  </div>\n</div>\n\n<div class=\"row\">\n  <div class=\"col-md-6 warning\" ng-repeat=\"boleta in $ctrl.boletas\" ng-if=\"($ctrl.mostrarBoletas || $ctrl.modoVista) && boleta.estado=='ACTIVO'\">\n    <boleta model=\"$ctrl.boletas[$index]\" indice=\"$index\"\n            validaciones=\"$ctrl.validaciones\"\n            tipo-boleta=\"$ctrl.tipo\"\n            bid=\"1\"\n            modo-vista=\"$ctrl.modoVista\">\n    </boleta>\n    <button md-effect class=\"btn btn-danger float-right\" type=\"submit\"\n            ng-click=\"$ctrl.quitarBoleta($index)\"\n            ng-if=\"!$ctrl.modoVista\">\n      <i class=\"fa fa-trash-o\"></i> Quitar boleta\n    </button>\n    <button md-effect class=\"btn btn-warning float-right\" type=\"submit\"\n            ng-click=\"$ctrl.invalidarBoleta($index)\"\n            ng-if=\"$ctrl.modoVista && $ctrl.pModificar\">\n      <i class=\"fa fa-close\"></i> Renovar boleta\n    </button>\n  </div>\n</div>\n\n<div class=\"row\" ng-if=\"$ctrl.pModificar\">\n  <div class=\"col\">\n    <button md-effect class=\"btn btn-success text-right\" type=\"submit\"\n      ng-click=\"$ctrl.adicionarBoletaEx()\">\n      <i class=\"fa fa-plus\"></i> Agregar nueva boleta\n    </button>\n  </div>\n</div>\n\n<div class=\"row\" ng-if=\"$ctrl.pModificar\">\n  <div class=\"col-md-6\" ng-repeat=\"boleta in $ctrl.boletasEx\">\n    <boleta model=\"$ctrl.boletasEx[$index]\" indice=\"$index\"\n            validaciones=\"$ctrl.validacionesEx\"\n            bid=\"2\"\n            tipo-boleta=\"$ctrl.tipo\">\n    </boleta>\n    <button md-effect class=\"btn btn-danger float-right\" type=\"submit\"\n            ng-click=\"$ctrl.quitarBoletaEx($index)\">\n      <i class=\"fa fa-trash-o\"></i> Quitar boleta\n    </button>\n  </div>\n  <div class=\"col-12\" ng-if=\"$ctrl.boletasEx.length\">\n    <button md-effect class=\"btn btn-primary text-right\" type=\"submit\"\n      ng-click=\"$ctrl.enviarBoletaEx()\">\n      <i class=\"fa fa-plus\"></i> Guardar boletas agregadas\n    </button>\n  </div>\n</div>"

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-file-text-o\"></i> Boleta {{$ctrl.indice + 1}}\n  </h6>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <c-radiobutton name=\"tipo_documento_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\" label=\"Tipo\"\n                     ng-model=\"$ctrl.model.tipo_documento\"\n                     options=\"$ctrl.tiposDocumento\"\n                     field=\"nombre\"\n                     horizontal=\"true\"\n                     ng-required=\"true && !$ctrl.modoVista\"\n                     ng-disabled=\"$ctrl.modoVista\">\n      </c-radiobutton>\n    </div>\n    <div class=\"md-input-group col-md-6\">\n      <c-input name=\"numero_boleta_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\" label=\"Número\"\n               ng-model=\"$ctrl.model.numero\"\n               ng-required=\"true && !$ctrl.modoVista\"\n               ng-disabled=\"$ctrl.modoVista\">\n      </c-input>\n    </div>\n\n    <div class=\"md-input-group col-md-6\">\n      <c-input-numeric name=\"monto_boleta_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\" label=\"Monto en (Bs)\"\n                       ng-model=\"$ctrl.model.monto\"\n                       ng-minvalue=\"0\" ng-formatting=\"false\" ng-decimals=\"2\"\n                       ng-required=\"true && !$ctrl.modoVista\"\n                       ng-disabled=\"$ctrl.modoVista\">\n      </c-input-numeric>\n    </div>\n\n    <div class=\"md-input-group col-md-6\">\n      <c-date name=\"fecha_inicio_validez_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\" label=\"Fecha inicio de validez\"\n              ng-model=\"$ctrl.model.fecha_inicio_validez\"\n              ng-required=\"true && !$ctrl.modoVista\"\n              ng-disabled=\"$ctrl.modoVista\"\n              min-date=\"$ctrl.validaciones.fec_ini_minima\"\n              mensaje-min-date=\"{{$ctrl.validaciones.mensaje_fecminima}}\"\n              max-date-key=\"fecha_fin_validez_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\">\n      </c-date>\n    </div>\n\n    <div class=\"md-input-group col-md-6\">\n      <c-date name=\"fecha_fin_validez_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\" label=\"Fecha fin de validez\"\n              ng-model=\"$ctrl.model.fecha_fin_validez\"\n              ng-required=\"true && !$ctrl.modoVista\"\n              ng-disabled=\"$ctrl.modoVista\"\n              min-date-key=\"fecha_inicio_validez_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\">\n      </c-date>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Datos del Convenio\n  </h6>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"nro_convenio\" label=\"Número\" ng-model=\"$ctrl.proyecto.nro_convenio\"\n      ng-minlength=\"3\" maxlength=\"100\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('nro_convenio')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('nro_convenio')\"></c-input>\n    </div>\n\n    <div class=\"md-input-group col-md-4\">\n      <c-date name=\"fecha_suscripcion\" label=\"Fecha de suscripción\" ng-model=\"$ctrl.proyecto.fecha_suscripcion_convenio\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fecha_suscripcion_convenio')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_suscripcion_convenio')\"></c-date>\n    </div>\n\n    <div class=\"md-input-group col-md-4\">\n      <c-input-numeric name=\"plazo_ejecucion_convenio\" label=\"Plazo de ejecución (días calendario)\" ng-model=\"$ctrl.proyecto.plazo_ejecucion_convenio\"\n      ng-minvalue=\"0\" ng-maxvalue=\"999999\" ng-formatting=\"false\" ng-decimals=\"0\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('plazo_ejecucion_convenio')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('plazo_ejecucion_convenio')\"></c-input-numeric>\n    </div>\n\n    <div class=\"md-input-group col-md-4\">\n      <c-input-money name=\"monto_upre\" label=\"Monto financiado UPRE\" ng-model=\"$ctrl.proyecto.monto_upre\"\n      ng-minvalue=\"0\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('monto_upre')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('monto_upre')\"></c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input-money name=\"monto_contraparte\" label=\"Monto financiado contraparte\" ng-model=\"$ctrl.proyecto.monto_contraparte\"\n      ng-minvalue=\"0\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('monto_contraparte')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('monto_contraparte')\"></c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input-money name=\"monto_total_convenio\" label=\"Monto total de convenio\" ng-model=\"$ctrl.proyecto.monto_total_convenio\"\n      ng-minvalue=\"0\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('monto_total_convenio')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('monto_total_convenio')\"></c-input-money>\n    </div>\n\n    <div class=\"col-lg-6 col-md-12\" ng-if=\"$ctrl.proyecto.tipo == 'TP_CIFE'\">\n      <archivo name=\"doc_resmin_cife\" label=\"Resolución Ministerial\" ng-model=\"$ctrl.proyecto.doc_resmin_cife\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\"\n              url=\"{{$ctrl.archivos.urlDocResolucion}}\"\n              url-descarga=\"{{$ctrl.archivos.urlDocResolucionDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_resmin_cife')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_resmin_cife')\">\n      </archivo>\n    </div>\n\n    <div class=\"col-md-12 col-lg-6\">\n      <archivo name=\"doc_convenio\" label=\"Convenio\" ng-model=\"$ctrl.proyecto.doc_convenio\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\"\n              url=\"{{$ctrl.archivos.urlDocConvenio}}\"\n              url-descarga=\"{{$ctrl.archivos.urlDocConvenioDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio')\">\n      </archivo>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-file-text-o\"></i> Datos generales\n  </h6>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-6\">\n      <select-parametro name=\"tipo_proyecto\" label=\"Tipo de proyecto\" ng-model=\"$ctrl.proyecto.tipo\"\n      parametro=\"TIPO_PROYECTO\" ng-change=\"$ctrl.callbacks.tipoProyecto($ctrl.proyecto.tipo)\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('tipo')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('tipo')\"></select-parametro>\n    </div>\n\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.codigo\">\n      <c-input name=\"codigo\" label=\"Código\" ng-model=\"$ctrl.proyecto.codigo\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('codigo')\"></c-input>\n    </div>\n\n    <div class=\"md-input-group col-md-12\">\n      <c-input name=\"nombre_proyecto\" label=\"Nombre\" ng-model=\"$ctrl.proyecto.nombre\"\n      ng-directives=\"uppercase\" ng-minlength=\"3\" maxlength=\"255\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('nombre')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('nombre')\"></c-input>\n    </div>\n\n    <div class=\"md-input-group col-md-12\">\n      <c-input name=\"entidad_beneficiaria\" label=\"Entidad beneficiaria\" ng-model=\"$ctrl.proyecto.entidad_beneficiaria\"\n      ng-minlength=\"3\" maxlength=\"255\" ng-directives=\"uppercase\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('entidad_beneficiaria')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('entidad_beneficiaria')\"></c-input>\n    </div>\n\n    <div class=\"col-md-12\">\n      <c-select-dpa ng-model=\"$ctrl.proyecto.dpa\" horizontal=\"true\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fcod_municipio')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fcod_municipio')\"></c-select-dpa>\n    </div>\n\n    <div class=\"col-md-12\" ng-if=\"$ctrl.proyecto.sector || $ctrl.Proyecto.esEditable('sector')\">\n      <select-parametro name=\"sector\" label=\"Sector\" ng-model=\"$ctrl.proyecto.sector\" parametro=\"SECTOR\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('sector')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('sector')\"></select-parametro>\n    </div>\n\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.plazo_ejecucion\">\n      <c-input-numeric name=\"plazo_ejecucion_contrato\" label=\"Plazo de ejecución (días calendario)\" ng-model=\"$ctrl.proyecto.plazo_ejecucion\"\n      ng-disabled=\"true\"></c-input-numeric>\n    </div>\n\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.monto_total\">\n      <c-input-money name=\"monto_total_contrato\" label=\"Monto total\" ng-model=\"$ctrl.proyecto.monto_total\"\n      ng-disabled=\"true\"></c-input-money>\n    </div>\n\n  </div>\n</section>\n"

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-md-12 col-lg-6\">\n    <ui-input-file name=\"doc_convenio\" label=\"Documento base de contratación\"\n    file-base64=\"$ctrl.proyecto.doc_base_contratacion\"\n    types=\"pdf\" mime-types=\".pdf\" maxfiles=\"1\" maxsize=\"3MB\"\n    ng-if=\"!$ctrl.estaRegistrado() && $ctrl.Proyecto.esEditable('doc_base_contratacion')\"></ui-input-file>\n\n    <button md-effect class=\"btn btn-secondary\" type=\"submit\" ng-click=\"$ctrl.verDocumento()\"\n    ng-if=\"$ctrl.modoVista || $ctrl.estaRegistrado()\">\n      <i class=\"fa fa-file-pdf-o\"></i> Ver DBC\n    </button>\n\n  </div>\n</div>\n"

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> {{$ctrl.proyecto.tipo === 'TP_CIF'? 'Desembolso del 20%' : 'Certificación Presupuestaria'}}\n  </h6>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.tipo === 'TP_CIF'\">\n      <c-input-numeric name=\"porcentaje_desembolso\" label=\"Porcentaje Desembolso\"\n                       ng-model=\"$ctrl.proyecto.porcentaje_desembolso\"\n                       ng-minvalue=\"0\" ng-maxvalue=\"20\" ng-formatting=\"false\" ng-decimals=\"2\"\n                       ng-disabled=\"true\">\n      </c-input-numeric>\n    </div>\n\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.tipo === 'TP_CIF'\">\n      <c-input-money name=\"desembolso\" label=\"Desembolso\"\n                     ng-model=\"$ctrl.proyecto.desembolso\"\n                     ng-minvalue=\"0\"\n                     ng-disabled=\"true\">\n      </c-input-money>\n    </div>\n\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.fecha_desembolso || $ctrl.Proyecto.esEditable('fecha_desembolso')\">\n      <c-date name=\"fecha_desembolso\" label=\"Fecha del desembolso\"\n              ng-model=\"$ctrl.proyecto.fecha_desembolso\"\n              ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fecha_desembolso')\"\n              ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\"\n              min-date=\"$ctrl.validacion.fecha_minima\" mensaje-min-date=\"{{$ctrl.validacion.mensaje_fecminima}}\">\n      </c-date>\n    </div>\n\n    <div class=\"col-md-6\" ng-if=\"$ctrl.proyecto.doc_cert_presupuestaria || $ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\">\n      <archivo name=\"doc_cert_presupuestaria\" label=\"Certificado de Inscripción Presupuestaria\" ng-model=\"$ctrl.proyecto.doc_cert_presupuestaria\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\"\n              url=\"{{$ctrl.archivo.urlDocCertificacion}}\"\n              url-descarga=\"{{$ctrl.archivo.urlDocCertificacionDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\">\n      </archivo>\n    </div>\n\n  </div>\n\n</section>\n"

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	module.exports = "<uib-tabset active=\"active\">\n  <uib-tab heading=\"Cumplimiento de contrato\">\n    <div class=\"alert alert-info\" ng-if=\"!$ctrl.modoVista\">\n      <i class=\"fa fa-info-circle\"></i>\n      <span>El registro de las boletas por concepto de garantías de Cumplimiento de Contrato es obligatorio.\n        El monto es calculado de acuerdo al 7% del monto del contrato (<strong>{{$ctrl.proyecto.monto_total | formatDecimal}}</strong>)</span>\n    </div>\n    <boleta-garantia proyecto=\"$ctrl.proyecto\"\n              datos=\"$ctrl.cContrato\"\n              porcentaje=\"7\"\n              monto=\"$ctrl.monto_ccontrato\"\n              boletas=\"$ctrl.boletasCcontrato\"\n              tipo=\"TB_CUMPLIMIENTO_CONTRATO\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('boletas')\">\n    </boleta-garantia>\n  </uib-tab>\n  <uib-tab heading=\"Anticipo\">\n    <div class=\"alert alert-info\" ng-if=\"!$ctrl.modoVista\">\n      <i class=\"fa fa-info-circle\"></i>\n      <span>Si la empresa solicita anticipo registrar el porcentaje respecto al monto del contrato (<strong>{{$ctrl.proyecto.monto_total | formatDecimal}}</strong>),\n        en caso contrario registrar el porcentaje en cero \"0\".</span>\n    </div>\n    <boleta-garantia proyecto=\"$ctrl.proyecto\"\n              datos=\"$ctrl.anticipo\"\n              porcentaje=\"$ctrl.proyecto.porcentaje_anticipo\"\n              monto=\"$ctrl.proyecto.anticipo\"\n              boletas=\"$ctrl.boletasAnticipo\"\n              tipo=\"TB_CORRECTA_INVERSION\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('boletas')\">\n    </boleta-garantia>\n  </uib-tab>\n</uib-tabset>\n"

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"items\">\n<button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.adicionarModulo()\"\n        ng-if=\"!$ctrl.modoVista\">\n  <i class=\"fa fa-plus\"></i> Adicionar Módulo\n</button>\n<button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.importarItems()\"\n        ng-if=\"!$ctrl.modoVista\">\n  <i class=\"fa fa-upload\"></i> Importar Items\n</button>\n<button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.cargarEspecificacionesTecnicas()\"\n        ng-if=\"!$ctrl.modoVista\">\n  <i class=\"fa fa-upload\"></i> Cargar Especificaciones Técnicas\n</button>\n<button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.verEspecificacionesTecnicas()\"\n  ng-if=\"$ctrl.proyecto.doc_especificaciones_tecnicas\">\n  <i class=\"fa fa-file-text-o\"></i> Ver Especificaciones Técnicas\n</button>\n<br><br>\n<ng-form name=\"form_{{modulo.id_modulo}}\" ng-repeat=\"(keyModulo,modulo) in $ctrl.modulos | orderBy : 'id_modulo'\">\n  <span md-effect class=\" text-primary\" ng-click=\"modulo.show=!modulo.show\"><i class=\"fa fa-plus\" ng-if=\"!modulo.show\"></i><i class=\"fa fa-minus\" ng-if=\"modulo.show\"></i> {{modulo.nombre}}</span>\n  <div class=\"float-right\" ng-if=\"!$ctrl.modoVista\">\n    <button class=\"btn btn-link text-success ml-1  pl-1 pr-1\" ng-click=\"$ctrl.guardarDatosModulo(modulo)\"\n    uib-tooltip=\"Guardar datos módulo\" validar-formulario nombre-formulario=\"form_{{modulo.id_modulo}}\">\n      <i class=\"fa fa-save\"></i>\n    </button>\n    <button class=\"btn btn-link text-success ml-1  pl-1 pr-1\" ng-click=\"$ctrl.adicionarItem(modulo);modulo.show=true\" uib-tooltip=\"Nuevo Item\">\n      <i class=\"fa fa-plus-square-o\"></i>\n    </button>\n    <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"$ctrl.editarModulo(modulo)\" uib-tooltip=\"Editar\">\n      <i class=\"fa fa-edit\"></i>\n    </button>\n    <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1\" ng-click=\"$ctrl.eliminarModulo(modulo)\" uib-tooltip=\"Eliminar\">\n      <i class=\"fa fa-trash-o\"></i>\n    </button>\n  </div>\n  <hr>\n\n    <div class=\"items\" ng-repeat=\"(keyItem,item) in modulo.items | orderBy : 'nro_item' \" ng-if=\"modulo.show\">\n        <div class=\"row\">\n          <div class=\"col-md-1 nro-item text-info\">\n              <strong class=\"mt-3\"> {{item.nro_item}} </strong>\n          </div>\n          <div class=\"md-input-group col-md-4\">\n            <c-input name=\"item_nombre_{{keyItem}}\" label=\"Nombre\" ng-model=\"item.nombre\"\n            maxlength=\"150\"\n            ng-required=\"true\" ng-disabled=\"!item.edicion\">\n            </c-input>\n          </div>\n\n          <div class=\"md-input-group col-md-2\">\n            <c-select name=\"item_unidad_{{keyItem}}\" label=\"Unidad\" ng-model=\"item.unidad_medida\"\n              options=\"$ctrl.unidades\" key-value=\"codigo\" ng-required=\"true\" ng-disabled=\"!item.edicion\">\n            </c-select>\n          </div>\n\n          <div class=\"md-input-group col-md-3\">\n            <c-input-numeric name=\"item_cantidad_{{keyItem}}\" label=\"Cantidad\" ng-model=\"item.cantidad\"\n                             ng-minvalue=\"1\" ng-maxvalue=\"1\" ng-decimals=\"0\"\n                             ng-required=\"true\" ng-disabled=\"!item.edicion\" ng-if=\"item.unidad_medida === 'UN_GLOBAL'\">\n            </c-input-numeric>\n            <c-input-numeric name=\"item_cantidad_{{keyItem}}\" label=\"Cantidad\" ng-model=\"item.cantidad\"\n                             ng-minvalue=\"1\" ng-maxvalue=\"999999\" ng-decimals=\"0\"\n                             ng-required=\"true\" ng-disabled=\"!item.edicion\" ng-if=\"item.unidad_medida === 'UN_PIEZA' || item.unidad_medida === 'UN_PUNTO'\">\n            </c-input-numeric>\n            <c-input-numeric name=\"item_cantidad_{{keyItem}}\" label=\"Cantidad\" ng-model=\"item.cantidad\"\n                             ng-minvalue=\"0\" ng-maxvalue=\"999999\" ng-decimals=\"2\"\n                             ng-required=\"true\" ng-disabled=\"!item.edicion\" ng-if=\"item.unidad_medida !== 'UN_GLOBAL' && item.unidad_medida !== 'UN_PIEZA' && item.unidad_medida !== 'UN_PUNTO'\">\n            </c-input-numeric>\n          </div>\n\n          <div class=\"float-right\">\n            <button class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"!item.id_item? $ctrl.guardarItem(item, keyItem, keyModulo, modulo) : $ctrl.actualizarItem(item, keyItem, modulo)\"\n              ng-if=\"item.edicion && !$ctrl.modoVista\" uib-tooltip=\"Guardar\">\n              <i class=\"fa fa-save\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"item.edicion = true\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\" uib-tooltip=\"Editar\">\n              <i class=\"fa fa-edit\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"$ctrl.verEspecificacionesItem(item)\"\n              ng-if=\"!item.edicion && item.especificaciones\" uib-tooltip=\"Ver especificaciones\">\n              <i class=\"fa fa-file-text-o\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-info ml-1 pl-1 pr-1\" ng-click=\"$ctrl.cargarEspecificacionesItem(item)\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\" uib-tooltip=\"Cargar especificaciones\">\n              <i class=\"fa fa-upload\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1\" ng-click=\"$ctrl.eliminarItem(item, keyItem, modulo)\"\n              ng-if=\"!$ctrl.modoVista\" uib-tooltip=\"Eliminar\">\n              <i class=\"fa fa-trash-o\"></i>\n            </button>\n          </div>\n\n        </div>\n    </div>\n\n  </ng-form>\n</div>\n"

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa {{$ctrl.icon}}\"></i> {{$ctrl.title}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\" style=\"max-height:400px;overflow:auto;\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <ul ng-repeat=\"mensaje in $ctrl.mensajes\">\n        <li>{{mensaje.mensaje}}\n          <ul ng-repeat=\"item in mensaje.items\">\n            <li>Item: <strong>{{item.item}}</strong> debe verificar el valor <strong>{{item.texto}}</strong></li>\n          </ul>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa {{$ctrl.icon}}\"></i> {{$ctrl.title}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <ng-form name=\"formItem\">\n    <div class=\"row\">\n\n      <div class=\"md-input-group col-md-12\">\n        <c-input name=\"modulo_nombre\" label=\"Nombre\" ng-model=\"$ctrl.modulo.nombre\"\n          ng-directives=\"uppercase\"\n          ng-required=\"true\" maxlength=\"150\">\n        </c-input>\n      </div>\n\n    </div>\n  </ng-form>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"button\" md-effect class=\"btn btn-primary\" validar-formulario=\"formItem\"\n    ng-click=\"!$ctrl.modulo.id_modulo? $ctrl.guardar() : $ctrl.actualizar()\">\n    <i class=\"fa\" ng-class=\"!$ctrl.modulo.id_modulo? 'fa-check' : 'fa-save'\"></i>\n    {{!$ctrl.modulo.id_modulo? 'Adicionar' : 'Guardar'}}\n  </button>\n</div>\n"

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Orden de Proceder\n  </h6>\n\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.Proyecto.esEditable('orden_proceder')\">\n    <i class=\"fa fa-info-circle\"></i><span> Al introducir la fecha de orden de proceder se inicia el tiempo de ejecución del proyecto.</span>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-6\">\n      <c-date name=\"orden_proceder\" label=\"Fecha de orden de proceder\"\n              ng-model=\"$ctrl.proyecto.orden_proceder\"\n              ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('orden_proceder')\"\n              ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('orden_proceder')\"\n              min-date=\"$ctrl.validacion.fecha_minima\"\n              mensaje-min-date=\"{{$ctrl.validacion.mensaje_fecminima}}\">\n      </c-date>\n    </div>\n\n  </div>\n</section>\n"

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> {{$ctrl.proyecto.nombre}}<br>\n    <small>Bandeja de planillas</small>\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <crud-table url=\"$ctrl.planillas.url\"\n                query-extra=\"$ctrl.planillas.queryExtra\"\n                data=\"$ctrl.planillas.data\"\n                fields=\"$ctrl.planillas.fields\"\n                permission=\"$ctrl.planillas.permission\"\n                event-create=\"$ctrl.planillas.eventCreate\"\n                buttons=\"$ctrl.planillas.buttons\"\n                labels=\"$ctrl.planillas.labels\"\n                fks=\"$ctrl.planillas.fks\"\n                update=\"$ctrl.planillas.update\"\n                clases=\"$ctrl.planillas.clases\"\n                ng-if=\"$ctrl.planillas\" \n                hidden-fields=\"$ctrl.planillas.hiddenFields\">\n      </crud-table>\n\n\n    </div>\n</div>\n"

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container px-3 computo-proy\">\n\n  <div class=\"row\">\n    <div class=\"col\">\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.irItemPosicion('anterior')\" ng-disabled=\"$ctrl.esPrimerItem()\">\n        <i class=\"fa fa-angle-double-left\" aria-hidden=\"true\"></i> Anterior\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.irItemPosicion('siguiente')\" ng-disabled=\"$ctrl.esUltimoItem()\">\n        Siguiente <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n    <div class=\"col-md-3 seleccion-planilla mt-2 mb-2\">\n      <ng-form name=\"seleccion\">\n        <c-select name=\"supervisiones\" label=\"Histórico\"\n                  ng-model=\"$ctrl.supervisionHistorica\"\n                  options=\"$ctrl.supervisiones\"\n                  field=\"nombre\"\n                  placeholder=\"Seleccione\"\n                  on-select=\"$ctrl.mostrarDatosSupervision()\">\n        </c-select>\n      </ng-form>\n    </div>\n  </div>\n\n  <h5 class=\"text-center mt-2\">MOD: <strong>{{$ctrl.item.modulo.nombre.replace('|', ' | ')}}</strong></h5>\n  <h5 class=\"text-center\">Item {{$ctrl.item.nro_item}}: <strong>{{$ctrl.item.nombre}}</strong></h5>\n\n  <h6 class=\"text-right\"> Unidad de medida: <span class=\"unidad-medida\">{{$ctrl.item.unidad.descripcion}}</span></h6>\n\n  <resumen-computos item=\"$ctrl.item\" resumen=\"$ctrl.resumen\"></resumen-computos>\n\n  <computos-metricos item=\"$ctrl.item\"\n                     computos=\"$ctrl.computos\"\n                     copia-computos=\"$ctrl.copiaComputos\"\n                     supervision=\"$ctrl.supervision\"\n                     resumen=\"$ctrl.resumen\"\n                     fotos=\"$ctrl.fotos\"\n                     modo-vista=\"!$ctrl.esEditable\"\n                     ng-if=\"$ctrl.supervisionHistorica.id_supervision\"\n                     existe-cambios=\"$ctrl.existeCambios\"\n                     modificados=\"$ctrl.modificados\"\n                     ng-show=\"$ctrl.puedeVerComputos()\">\n  </computos-metricos>\n\n  <fotos-computos item=\"$ctrl.item\"\n                  supervision=\"$ctrl.supervision\"\n                  fotos=\"$ctrl.fotos\"\n                  modo-vista=\"!$ctrl.esEditable\"\n                  archivado=\"$ctrl.computoFinalizado\"\n                  ng-show=\"$ctrl.puedeVerComputos()\">\n  </fotos-computos>\n\n  <div ng-if=\"!$ctrl.puedeVerComputos()\" class=\"alert alert-warning\">\n    Usted no tiene permiso para ver esta pagina  \n  </div>\n  <!--El item no tiene avances para la presente planilla.-->\n\n  <div class=\"alert alert-success mt-3\" ng-if=\"$ctrl.resumen.cant_faltante == 0\">\n    <i class=\"fa fa-check\"></i>\n    <span>Item completado</span>\n  </div>\n</div>\n"

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"form_computo\">\n  <div class=\"form-computo\" style=\"font-size:0.9em;\">\n    <div class=\"table-responsive\">\n      <table class=\"table table-striped mod-t text-right\">\n        <thead>\n          <tr>\n            <th class=\"text-left bb-0\">\n              <button type=\"button\" md-effect class=\"btn btn-primary btn-sm\" ng-click=\"$ctrl.addRow()\" uib-tooltip=\"Agregar fila\" ng-if=\"!$ctrl.modoVista\">\n                <i class=\"fa fa-plus\"></i>\n              </button>\n              <button type=\"button\" md-effect class=\"btn btn-info btn-sm\" ng-click=\"$ctrl.addSubtitulo()\" uib-tooltip=\"Agregar subtítulo\" ng-if=\"!$ctrl.modoVista\">\n                <i class=\"fa fa-list\"></i>\n              </button>\n              <!-- ng-if=\"!$ctrl.modoVista && $ctrl.item.unidad_medida !== 'UN_GLOBAL'\" -->\n            </th>\n            <th rowspan=\"2\" ng-class=\"{'th-req':$ctrl.conf.cantidad.required}\">\n              {{ ($ctrl.item.unidad_medida=='UN_METRO_CUB' || $ctrl.item.unidad_medida=='UN_METRO_CUAD' || $ctrl.item.unidad_medida=='UN_METRO') ? 'Nro. de veces' : 'Cantidad' }}\n            </th>\n            <th rowspan=\"2\" ng-class=\"{'th-req':$ctrl.conf.factor_forma.required}\" title=\"Factor de forma\">Factor de Forma</th>\n            <th colspan=\"4\" class=\"text-center\">DIMENSIONES</th>\n            <th colspan=\"2\" class=\"bb-0\">\n              <button type=\"button\" md-effect class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.saveAllRow()\" uib-tooltip=\"Guardar todo\" ng-if=\"!$ctrl.modoVista\">\n                <i class=\"fa fa-save\"></i>\n              </button>\n              <button type=\"button\" md-effect class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.deleteAllRow()\" uib-tooltip=\"Eliminar todo\" ng-if=\"!$ctrl.modoVista\">\n                <i class=\"fa fa-trash\"></i>\n              </button>\n              <button type=\"button\" md-effect class=\"btn btn-info btn-sm\" uib-tooltip=\"Descargar especificaciones técnicas del item\"\n              download-file=\"{{$ctrl.descargaEsp.url}}\" file-name=\"{{$ctrl.descargaEsp.nombre}}\" ng-if=\"$ctrl.item.especificaciones\">\n                <i class=\"fa fa-download\"></i>\n              </button>\n            </th>\n          </tr>\n          <tr>\n            <th ng-class=\"{'th-req':$ctrl.conf.descripcion.required}\" class=\"text-left\">Descripción</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.largo.required}\">Largo [ml]</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.ancho.required}\">Ancho [ml]</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.alto.required}\">Alto [ml]</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.area.required}\">{{ $ctrl.item.unidad_medida=='UN_METRO_CUB' ? 'Volumen [m3]' : 'Área [m2]'}}</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.cantidad_parcial.required}\" title=\"Cantidad Parcial\">C.P.</th>\n            <th ng-if=\"!$ctrl.modoVista\"></th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"com in $ctrl.computos\" ng-click=\"$ctrl.setIndexSubtitulo($index)\">\n            <td class=\"subtitulo\" ng-if=\"com.isSubtitulo\" colspan=\"15\">\n              <div class=\"row mx-0\">\n                <div class=\"col subtitulo\">\n                  <c-input name=\"descripcion_{{$index}}\"\n                      ng-model=\"com.descripcion\"\n                      title=\"{{com.descripcion}}\"\n                      ng-disabled=\"!!$ctrl.modoVista\">\n                  </c-input>\n                </div>\n                <div class=\"actions\" ng-if=\"!$ctrl.modoVista\">\n                  <i class=\"fa fa-arrow-up\" ng-click=\"$ctrl.moveSubtitulo('up',$index)\" uib-tooltip=\"Mover fila arriba\"></i>\n                  <i class=\"fa fa-arrow-down\" ng-click=\"$ctrl.moveSubtitulo('down',$index)\" uib-tooltip=\"Mover fila abajo\"></i>\n                  <i class=\"fa fa-save text-success\" ng-click=\"$ctrl.saveSubtitulo(com, $index)\" uib-tooltip=\"Guardar subtítulo\"></i>\n                  <i class=\"fa fa-trash text-danger\" ng-click=\"$ctrl.deleteSubtitulo(com, $index)\" uib-tooltip=\"Eliminar subtítulo\"></i>\n                </div>\n              </div>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" class=\"text-left\">\n              <c-input name=\"descripcion_{{$index}}\"\n                  ng-model=\"com.descripcion\"\n                  ng-disabled=\"$ctrl.conf.descripcion.disabled || $ctrl.modoVista\"\n                  ng-required=\"$ctrl.conf.descripcion.required\"\n                  title=\"{{com.descripcion}}\"\n                  >\n              </c-input>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.cantidad.disabled\">\n              <div ng-if=\"$ctrl.conf.cantidad.decimals === 0\">\n                <c-input-numeric name=\"cantidad_{{$index}}\"\n                          ng-model=\"com.cantidad\"\n                          ng-disabled=\"$ctrl.conf.cantidad.disabled || $ctrl.modoVista\"\n                          ng-required=\"$ctrl.conf.cantidad.required\"\n                          ng-decimals=\"0\"\n                          ng-minvalue=\"0\"\n                          ng-maxvalue=\"999999999999\"\n                          ng-not-number=\"0\"\n                          ng-number-default=\"0\"\n                          ng-blur=\"$ctrl.changeComputo(com)\"\n                          >\n                </c-input-numeric>\n              </div>\n              <div ng-if=\"$ctrl.conf.cantidad.decimals > 0\">\n                <c-input-numeric name=\"cantidad_{{$index}}\"\n                          ng-model=\"com.cantidad\"\n                          ng-disabled=\"$ctrl.conf.cantidad.disabled || $ctrl.modoVista\"\n                          ng-required=\"$ctrl.conf.cantidad.required\"\n                          ng-decimals=\"6\"\n                          ng-minvalue=\"0\"\n                          ng-maxvalue=\"999999999999\"\n                          ng-not-number=\"0\"\n                          ng-number-default=\"0\"\n                          ng-blur=\"$ctrl.changeComputo(com)\"\n                          >\n                </c-input-numeric>\n              </div>\n              <!-- ng-maxvalue=\"{{$ctrl.item.unidad_medida == 'UN_GLOBAL'? '1' : '999999999999'}}\" -->\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.factor_forma.disabled\">\n              <c-input-numeric name=\"factor_forma_{{$index}}\"\n                        ng-model=\"com.factor_forma\"\n                        ng-disabled=\"$ctrl.conf.factor_forma.disabled || $ctrl.modoVista\"\n                        ng-required=\"$ctrl.conf.factor_forma.required\"\n                        ng-blur=\"$ctrl.changeComputo(com)\"\n                        ng-decimals-dinamic=\"true\"\n                        ng-max-decimals=\"6\"\n                        ng-not-number=\"0\"\n                        ng-number-default=\"1\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.largo.disabled\">\n              <c-input-numeric name=\"largo_{{$index}}\"\n                        ng-model=\"com.largo\"\n                        ng-disabled=\"$ctrl.conf.largo.disabled || $ctrl.modoVista\"\n                        ng-required=\"$ctrl.conf.largo.required\"\n                        ng-decimals=\"6\"\n                        ng-minvalue=\"0.01\"\n                        ng-not-number=\"0\"\n                        ng-number-default=\"1\"\n                        ng-blur=\"$ctrl.changeComputo(com)\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.ancho.disabled\">\n              <c-input-numeric name=\"ancho_{{$index}}\"\n                        ng-model=\"com.ancho\"\n                        ng-disabled=\"$ctrl.conf.ancho.disabled || $ctrl.modoVista\"\n                        ng-required=\"$ctrl.conf.ancho.required\"\n                        ng-decimals=\"6\"\n                        ng-minvalue=\"0.01\"\n                        ng-not-number=\"0\"\n                        ng-number-default=\"1\"\n                        ng-blur=\"$ctrl.uniformarArea('ancho',com);$ctrl.changeComputo(com)\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.alto.disabled\">\n              <c-input-numeric name=\"alto_{{$index}}\"\n                        ng-model=\"com.alto\"\n                        ng-disabled=\"$ctrl.conf.alto.disabled || $ctrl.modoVista\"\n                        ng-required=\"$ctrl.conf.alto.required\"\n                        ng-decimals=\"6\"\n                        ng-minvalue=\"0.01\"\n                        ng-not-number=\"0\"\n                        ng-number-default=\"1\"\n                        ng-blur=\"$ctrl.uniformarArea('alto',com);$ctrl.changeComputo(com)\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.area.disabled\" ng-class=\"$ctrl.conf.area.class\">\n              <c-input-numeric name=\"area_{{$index}}\"\n                        ng-model=\"com.area\"\n                        ng-disabled=\"$ctrl.conf.area.disabled\"\n                        ng-required=\"$ctrl.conf.area.required\"\n                        ng-decimals=\"6\"\n                        ng-class=\"$ctrl.conf.area.class\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.cantidad_parcial.disabled\" ng-class=\"$ctrl.conf.cantidad_parcial.class\">\n              <c-input-numeric name=\"cantidad_parcial_{{$index}}\"\n                        ng-model=\"com.cantidad_parcial\"\n                        ng-disabled=\"$ctrl.conf.cantidad_parcial.disabled\"\n                        ng-required=\"$ctrl.conf.cantidad_parcial.required\"\n                        ng-decimals=\"6\"\n                        ng-class=\"$ctrl.conf.cantidad_parcial.class\">\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo && !$ctrl.modoVista\" class=\"text-center\">\n              <div class=\"actions\">\n                <i class=\"fa fa-save text-success\" ng-click=\"$ctrl.saveRow(com, $index)\" uib-tooltip=\"Guardar fila\"></i>\n                <i class=\"fa fa-trash text-danger\" ng-click=\"$ctrl.deleteRow(com, $index)\" uib-tooltip=\"Eliminar fila\"></i>\n              </div>\n            </td>\n          </tr>\n        </tbody>\n        <tfoot>\n          <tr ng-class=\"{'error' : $ctrl.resumen.total_actual < 0 || $ctrl.resumen.total_actual > $ctrl.item.cantidad}\">\n            <th colspan=\"7\">Total</th>\n            <td class=\"align-middle\">{{$ctrl.resumen.total_actual | number:6}}</td>\n          </tr>\n        </tfoot>\n      </table>\n\n      <div class=\"alert alert-danger\" ng-if=\"$ctrl.resumen.total_actual < 0 || $ctrl.resumen.total_actual > $ctrl.item.cantidad\">\n        <i class=\"fa fa-times-circle\"></i>\n        <span ng-if=\"$ctrl.resumen.total_actual < 0\">La cantidad ejecutada no puede ser negativa.</span>\n        <span ng-if=\"$ctrl.resumen.total_actual > $ctrl.item.cantidad\">La cantidad ejecutada no puede ser mayor a la cantidad contractual.</span>\n      </div>\n    </div>\n  </div>\n\n</ng-form>\n"

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row images\">\n  <div class=\"col-md-4\">\n    <section class=\"image\">\n        <figure ng-if=\"$ctrl.fotos.foto1.show\">\n            <div class=\"row mx-0\">\n              <div class=\"col-md\">Foto 1: {{$ctrl.fotos.foto1.nombre}}</div>\n              <div class=\"actions\">\n                <i class=\"fa fa-eye text-success\" ng-click=\"$ctrl.showImage('foto1')\" uib-tooltip=\"Ver/Ocultar imagen\"></i>\n                <i class=\"fa fa-exchange\" ng-click=\"$ctrl.changeImage('foto1')\" uib-tooltip=\"Cambiar imagen\" ng-if=\"!$ctrl.modoVista\"></i>\n              </div>\n            </div>\n            <div ng-show=\"$ctrl.fotos.foto1.showImage\">\n              <img ng-src=\"data:image/jpg;base64, {{ $ctrl.fotos.foto1.base64 }}\" alt=\"Foto 1\" ng-click=\"$ctrl.vistaImagen($ctrl.fotos.foto1)\">\n            </div>\n        </figure>\n        <div ng-if=\"!$ctrl.fotos.foto1.show && !$ctrl.archivado && !$ctrl.modoVista\">\n            <ui-input-file name=\"foto1\" label=\"Foto 1\" file-base64=\"$ctrl.fotos.foto1\" upload-callback=\"$ctrl.fotos.uploadCallback\"\n                  types=\"jpg, png, jpeg\" mime-types=\"image/*\" maxfiles=\"1\" maxsize=\"3MB\"></ui-input-file>\n        </div>\n    </section>\n  </div>\n  <div class=\"col-md-4\">\n    <section class=\"image\">\n        <figure ng-if=\"$ctrl.fotos.foto2.show\">\n            <div class=\"row mx-0\">\n              <div class=\"col-md\">Foto 2: {{$ctrl.fotos.foto2.nombre}}</div>\n              <div class=\"actions\">\n                <i class=\"fa fa-eye text-success\" ng-click=\"$ctrl.showImage('foto2')\" uib-tooltip=\"Ver/Ocultar imagen\"></i>\n                <i class=\"fa fa-exchange\" ng-click=\"$ctrl.changeImage('foto2')\" uib-tooltip=\"Cambiar imagen\" ng-if=\"!$ctrl.modoVista\"></i>\n              </div>\n            </div>\n            <div ng-show=\"$ctrl.fotos.foto2.showImage\">\n              <img ng-src=\"data:image/jpg;base64, {{ $ctrl.fotos.foto2.base64 }}\" alt=\"Foto 2\" ng-click=\"$ctrl.vistaImagen($ctrl.fotos.foto2)\">\n            </div>\n        </figure>\n        <div ng-if=\"!$ctrl.fotos.foto2.show && !$ctrl.archivado && !$ctrl.modoVista\">\n            <ui-input-file name=\"foto2\" label=\"Foto 2\" file-base64=\"$ctrl.fotos.foto2\" upload-callback=\"$ctrl.fotos.uploadCallback\"\n                  types=\"jpg, png, jpeg\" mime-types=\"image/*\" maxfiles=\"1\" maxsize=\"3MB\"></ui-input-file>\n        </div>\n    </section>\n  </div>\n  <div class=\"col-md-4\">\n    <section class=\"image\">\n        <figure ng-if=\"$ctrl.fotos.foto3.show\">\n            <div class=\"row mx-0\">\n              <div class=\"col-md\">Foto 3: {{$ctrl.fotos.foto3.nombre}}</div>\n              <div class=\"actions\">\n                <i class=\"fa fa-eye text-success\" ng-click=\"$ctrl.showImage('foto3')\" uib-tooltip=\"Ver/Ocultar imagen\"></i>\n                <i class=\"fa fa-exchange\" ng-click=\"$ctrl.changeImage('foto3')\" uib-tooltip=\"Cambiar imagen\" ng-if=\"!$ctrl.modoVista\"></i>\n              </div>\n            </div>\n            <div ng-show=\"$ctrl.fotos.foto3.showImage\">\n              <img ng-src=\"data:image/jpg;base64, {{ $ctrl.fotos.foto3.base64 }}\" alt=\"Foto 3\" ng-click=\"$ctrl.vistaImagen($ctrl.fotos.foto3)\">\n            </div>\n        </figure>\n        <div ng-if=\"!$ctrl.fotos.foto3.show && !$ctrl.archivado && !$ctrl.modoVista\">\n            <ui-input-file name=\"foto3\" label=\"Foto 3\" file-base64=\"$ctrl.fotos.foto3\" upload-callback=\"$ctrl.fotos.uploadCallback\"\n                  types=\"jpg, png, jpeg\" mime-types=\"image/*\" maxfiles=\"1\" maxsize=\"3MB\"></ui-input-file>\n        </div>\n    </section>\n  </div>\n</div>\n<div class=\"row images\">\n  <div class=\"col\">\n    <section class=\"image\">\n        <figure ng-if=\"$ctrl.fotos.plano.show\">\n            <div class=\"row mx-0\">\n              <div class=\"col-md\">Plano/Factor de forma: {{$ctrl.fotos.plano.nombre}}</div>\n              <div class=\"actions\">\n                <i class=\"fa fa-eye text-success\" ng-click=\"$ctrl.showImage('plano')\" uib-tooltip=\"Ver/Ocultar imagen\"></i>\n                <i class=\"fa fa-exchange\" ng-click=\"$ctrl.changeImage('plano')\" uib-tooltip=\"Cambiar imagen\" ng-if=\"!$ctrl.modoVista\"></i>\n              </div>\n            </div>\n            <div ng-show=\"$ctrl.fotos.plano.showImage\">\n              <div id=\"documento\" ng-if=\"$ctrl.fotos.plano.showImage && $ctrl.fotos.plano.nombre.indexOf('.pdf')>0\">\n                <archivo name=\"plano\" label=\"Plano/Factor de Forma\" ng-model=\"$ctrl.fotos.plano\"\n                        types=\"pdf\" mime-types=\".pdf\" maxsize=\"20MB\"\n                        url=\"{{$ctrl.urlViewBase64}}\"\n                        url-descarga=\"{{$ctrl.urlDownloadBase64}}\"\n                        modo-vista=\"true\">\n                </archivo>\n                <!-- <div class=\"opciones\">\n                  <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.vistaPrevia()\" ng-if=\"true\">\n                    <i class=\"fa fa-eye\"></i>\n                  </button>\n                  <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n                          download-file=\"{{$ctrl.urlDownloadBase64}}\" file-name=\"{{$ctrl.fotos.plano.nombre}}\" ng-if=\"true\">\n                    <i class=\"fa fa-download\"></i>\n                  </button>\n                  <button md-effect type=\"button\" class=\"btn btn-info btn-sm\" uib-tooltip=\"Cambiar\" ng-if=\"false\" ng-click=\"$ctrl.cargarArchivo = true\">\n                    <i class=\"fa fa-exchange\"></i>\n                  </button>\n                </div>\n                <img src=\"./images/documento.jpg\" alt=\"Documento\">\n                <div class=\"detalles\">\n                  <div class=\"nombre\">Plano/Factor de forma: {{$ctrl.fotos.plano.nombre}}</div>\n                </div> -->\n              </div>\n              <img ng-if=\"$ctrl.fotos.plano.nombre.indexOf('.pdf')<0\" ng-src=\"data:image/jpg;base64, {{ $ctrl.fotos.plano.base64 }}\" alt=\"Plano\" ng-click=\"$ctrl.vistaImagen($ctrl.fotos.plano)\">\n            </div>\n        </figure>\n        <div ng-if=\"!$ctrl.fotos.plano.show && !$ctrl.archivado && !$ctrl.modoVista\">\n            <ui-input-file name=\"plano\" label=\"Plano/Factor de Forma\" file-base64=\"$ctrl.fotos.plano\" upload-callback=\"$ctrl.fotos.uploadCallback\"\n                  types=\"pdf, jpg, png, jpeg\" mime-types=\"image/*,.pdf\" maxfiles=\"1\" maxsize=\"3MB\"></ui-input-file>\n        </div>\n    </section>\n  </div>\n</div>\n"

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\" style=\"font-size:0.9em;\">\n  <div class=\"col-md-6\">\n    <div class=\"ayuda-form-computo\">\n      <ul class=\"pl-0\">\n        <li>Los campos con <span class=\"th-req\">(</span>) son requeridos</li>\n        <!-- div ng-show=\"$ctrl.item.unidad_medida=='UN_GLOBAL' || $ctrl.item.unidad_medida == 'UN_PIEZA' || $ctrl.item.unidad_medida == 'UN_PUNTO'\" -->\n        <!-- div ng-show=\"$ctrl.item.unidad_medida == 'UN_PIEZA' || $ctrl.item.unidad_medida == 'UN_PUNTO'\">\n          <li>La cantidad parcial para item <strong>{{$ctrl.item.unidad.nombre | uppercase}}</strong> será: <strong>C.P. =  Nro_de_veces </strong></li>\n        </div -->\n        <div ng-show=\"$ctrl.item.unidad_medida == 'UN_METRO'\">\n          <li>La cantidad parcial para item <strong>{{$ctrl.item.unidad.nombre | uppercase}}</strong> será: <strong>C.P. =  Nro_de_veces * largo </strong></li>\n        </div>\n        <div ng-show=\"$ctrl.item.unidad_medida == 'UN_METRO_CUAD'\">\n          <li>El área será:</li>\n          <li><strong>Area = factor_forma * largo * alto</strong></li>\n          <li>Ó: <strong>Area = factor_forma * largo * ancho</strong></li>\n          <li>La cantidad parcial para item <strong>{{$ctrl.item.unidad.nombre | uppercase}}</strong> será: <strong>C.P. =  Nro_de_veces * area </strong></li>\n        </div>\n        <div ng-show=\"$ctrl.item.unidad_medida == 'UN_METRO_CUB'\">\n          <li>El volumen será: <strong> Volumen = factor_forma * largo * ancho * alto</strong> </li>\n          <li>La cantidad parcial para item <strong>{{$ctrl.item.unidad.nombre | uppercase}}</strong> será: <strong>C.P. =  Nro_de_veces * volumen </strong></li>\n        </div>\n        <div ng-show=\"$ctrl.item.unidad_medida != 'UN_METRO' && $ctrl.item.unidad_medida != 'UN_METRO_CUAD' && $ctrl.item.unidad_medida != 'UN_METRO_CUB'\">\n          <li>La cantidad parcial para item <strong>{{$ctrl.item.unidad.nombre | uppercase}}</strong> será: <strong>C.P. =  Cantidad </strong></li>\n        </div>\n      </ul>\n    </div>\n  </div>\n  <div class=\"col-md-6\">\n    <table class=\"table table-striped mod-t table-responsive\">\n      <tbody>\n        <tr>\n          <th rowspan=\"2\" class=\"text-center\">RESUMEN</th>\n          <td class=\"text-right\">Cantidad Contractual</td>\n          <td class=\"text-right\">Cantidad Ejecutada</td>\n          <td class=\"text-right\">Cantidad Faltante</td>\n        </tr>\n        <tr>\n          <td class=\"text-right\">{{$ctrl.item.cantidad | number:6}}</td>\n          <td class=\"text-right\" ng-class=\"{'error' : $ctrl.resumen.cant_ejecutada < 0 || $ctrl.resumen.cant_ejecutada > $ctrl.item.cantidad}\">\n            <span uib-tooltip=\"{{$ctrl.resumen.cant_ejecutada < 0 ? 'La cantidad ejecutada no puede ser negativa' : $ctrl.resumen.cant_ejecutada > $ctrl.item.cantidad ? 'La cantidad ejecutada no puede ser mayor a la cantidad contractual.' : ''}}\"\n            tooltip-is-open=\"$ctrl.resumen.cant_ejecutada < 0 || $ctrl.resumen.cant_ejecutada > $ctrl.item.cantidad\"\n            tooltip-enable=\"$ctrl.resumen.cant_ejecutada < 0 || $ctrl.resumen.cant_ejecutada > $ctrl.item.cantidad\">\n            {{$ctrl.resumen.cant_ejecutada | number:6}}</span>\n          </td>\n          <td class=\"text-right\">{{$ctrl.resumen.cant_faltante | number:6}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-info-circle\"></i> Fecha de modificación</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>{{$ctrl.option.confirm_txt}}</p>\n\n  <p>\n    Se le informa que estas modificaciones, una vez aprobadas serán incorporadas a la planilla de avance.\n  </p>\n\n  <div class=\"alert alert-warning\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>{{$ctrl.option.action}} la <strong>fecha de la modificación</strong>.</span>\n  </div>\n\n  <ng-form name=\"formPlazo\">\n    <div class=\"row\">\n      <div class=\"offset-md-3 col-md-6\">\n        <c-date name=\"fecha_modificacion\" label=\"Fecha de modificación\"\n                ng-model=\"$ctrl.proyecto.fecha_modificacion\"\n                ng-required=\"true\"\n                min-date=\"$ctrl.validacion.fecha_minima\"\n                ng-disabled=\"$ctrl.option.disabled\"\n                mensaje-max-date=\"La fecha no puede ser mayor a la fecha actual\">\n        </c-date>\n      </div>\n    </div>\n  </ng-form>\n\n  <small>Nota.- La fecha de la modificación deberá ser la misma que se ha establecido en los documentos aprobados (libro de ordenes, informes técnicos, contrato modificatorio)</small>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formPlazo\" ng-click=\"$ctrl.aceptar()\">\n    <i class=\"fa fa-check\"></i> Si, estoy seguro/a\n  </button>\n</div>\n"

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container px-3 planilla-proy\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyecto <small><strong>{{$ctrl.proyecto.nombre}}</strong></small>\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row mx-0\">\n        <div style=\"font-size: 20px;\" uib-tooltip=\"Volver atrás\" ng-click=\"$ctrl.irAtras()\">\n          <i class=\"fa fa-reply\"></i>\n        </div>\n      </div>\n      <h4 class=\"text-center\"><strong>{{$ctrl.proyecto.empresa.nombre}}</strong></h4>\n      <h4 class=\"text-center\"><strong>{{$ctrl.proyecto.adjudicacion.referencia}}</strong></h4>\n      <h3 class=\"text-center\">\n        Modificación - {{$ctrl.proyecto.modificaciones.nombre}}<br>\n      </h3>\n      <div class=\"texto\">\n        <h4 class=\"text-center\">Fecha: <strong>{{$ctrl.proyecto.fecha_modificacion | date : 'dd/MM/yyyy'}}</strong></h4>\n        <section>\n          <a href=\"\">\n            <h6 class=\"title-section m-top\" ng-click=\"$ctrl.datosProyectoIsCollapsed = !$ctrl.datosProyectoIsCollapsed\">\n              <i class=\"fa fa-hand-o-right\"></i> Datos del proyecto\n            </h6>\n          </a>\n          <div uib-collapse=\"$ctrl.datosProyectoIsCollapsed\">\n            <div class=\"row\">\n              <div class=\"col-lg-4 text-left\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr> <th class=\"text-right\">Nombre:</th> <td>{{$ctrl.proyecto.nombre}}</td> </tr>\n                    <tr> <th class=\"text-right\">Departamento:</th> <td>{{$ctrl.proyecto.dpa.departamento.nombre}}</td> </tr>\n                    <tr> <th class=\"text-right\">Provincia:</th> <td>{{$ctrl.proyecto.dpa.provincia.nombre}}</td> </tr>\n                    <tr> <th class=\"text-right\">Municipio:</th> <td>{{$ctrl.proyecto.dpa.municipio.nombre}}</td> </tr>\n                    <tr><th class=\"text-right\">Beneficiario:</th> <td>{{$ctrl.proyecto.entidad_beneficiaria}}</td> </tr>\n                    <tr><th class=\"text-right\">Fecha de orden de proceder:<br>(Según convenio)</th> <td>{{$ctrl.proyecto.orden_proceder | date: 'dd/MM/yyyy'}}</td> </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"col-lg-4\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr> <th class=\"text-right\">Monto Adjudicación:</th> <td class=\"text-right\">{{($ctrl.proyecto.adjudicacion.monto_inicial) | number:$ctrl.decimales}}</td> </tr>\n                    <tr ng-repeat=\"modificacion in $ctrl.proyecto.adjudicacion.modificaciones\">\n                      <th class=\"text-right\">Modificación {{$index + 1}} ({{modificacion.tipo_modificacion_adjudicacion.nombre}}):</th> <td class=\"text-right\">{{modificacion.monto | number:$ctrl.decimales}}</td>\n                    </tr>\n                    <tr ng-if=\"$ctrl.proyecto.adjudicacion.version > 1\">\n                      <th class=\"text-right\">Modificación {{$ctrl.proyecto.adjudicacion.modificaciones.length + 1}} ({{$ctrl.proyecto.adjudicacion.tipo_modificacion_adjudicacion.nombre}}):</th> <td class=\"text-right\">{{$ctrl.proyecto.adjudicacion.monto | number:$ctrl.decimales}}</td>\n                    </tr>\n                    <tr ng-if=\"$ctrl.proyecto.adjudicacion.version > 1\"> <th class=\"text-right\">Monto Total con Modificaciones:</th> <td class=\"text-right\">{{$ctrl.proyecto.adjudicacion.monto | number:$ctrl.decimales}}</td> </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"col-lg-4\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr> <th class=\"text-right\">Fecha inicio de obras:</th> <td>{{$ctrl.proyecto.adjudicacion.orden_proceder | date : 'dd/MM/yyyy'}}</td> </tr>\n                    <tr> <th class=\"text-right\">Plazo de Ejecución <br>(Según convenio)</th> <td>{{$ctrl.proyecto.plazo_ejecucion}}</td> </tr>\n                    <tr> <th class=\"text-right\">Ampliación de Plazo</th> <td>{{$ctrl.proyecto.plazo_ampliacion_total+$ctrl.proyecto.plazo_ampliacion.por_volumenes+$ctrl.proyecto.plazo_ampliacion.por_compensacion || 0}}</td> </tr>\n                    <tr> <th class=\"text-right\">Fecha prevista p/Recepción Provisional</th> <td>{{($ctrl.proyecto.fecha_recepcion_provisional) | date : 'dd/MM/yyyy'}}</td> </tr>\n                    <tr> <th class=\"text-right\">Fecha prevista p/Recepción definitiva </th> <td>{{($ctrl.proyecto.fecha_recepcion_definitiva) | date : 'dd/MM/yyyy'}}</td> </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n        </section>\n      </div>\n\n      <section>\n        <h6 class=\"title-section m-top\">\n          <i class=\"fa fa-list\"></i> {{$ctrl.tabIndex == 1 ? 'Items' : 'Plazo'}} del proyecto\n        </h6>\n        <!--\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <div class=\"alert alert-info text-white\">\n              <i class=\"fa fa-info-circle\"></i>\n              <span>Puede hacer doble click a un item para <strong>{{$ctrl.esEditable? 'realizar' : 'revisar'}} su cómputo métrico</strong>.</span>\n            </div>\n          </div>\n          <div class=\"col-md-6\" ng-if=\"$ctrl.proyecto.doc_especificaciones_tecnicas\">\n            <button md-effect type=\"button\" class=\"btn btn-info\" download-file=\"{{$ctrl.urlDescEspTecnicas}}\" file-name=\"Especificaciones técnicas\">\n              <i class=\"fa fa-download\"></i> Especificaciones técnicas\n            </button>\n          </div>\n        </div>\n        -->\n\n        <div class=\"row mb-2\">\n          <div class=\"col-lg-6 col-md-12 mb-2\">\n            <div class=\"btn-group opciones\">\n              <label class=\"btn btn-success\" btn-checkbox ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'TODOS'\">Todos</label>\n              <label class=\"btn btn-success\" ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'COMPLETADOS'\">Completados</label>\n              <label class=\"btn btn-success\" ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'INCOMPLETOS'\">Por completar</label>\n            </div>\n          </div>\n          <div class=\"col-lg-6 col-md-12 mt-2\">\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator success\"></span><span>Completado</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator info\"></span><span>Con avance</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\" ng-if=\"$ctrl.esEtapaEdicion\">\n              <span class=\"custom-control-indicator primary\"></span><span>Sin avance</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\" ng-if=\"$ctrl.supervision.nro_supervision !== 1 && $ctrl.esEtapaEdicion\">\n              <span class=\"custom-control-indicator warning\"></span><span>Con avance en anterior(es) planilla(s)</span>\n            </label>\n          </div>\n        </div>\n        <form name=\"formModificacion\">\n          <uib-tabset active=\"$ctrl.tabIndex\">\n            <uib-tab index=\"1\" heading=\"ITEMS\">\n              <div class=\"row\">\n                <div class=\"col\">\n                  <button md-effect type=\"button\" class=\"btn mr-3 pull-right\" ng-class=\"{'btn-success':$ctrl.modificandoItems}\" ng-click=\"$ctrl.modificarItems()\" ng-if=\"!$ctrl.modoVista\">\n                    <i class=\"fa fa-edit\"></i> Modificar\n                  </button>\n                </div>\n              </div>\n              <div ng-repeat=\"modulo in $ctrl.proyecto.modulos\" class=\"texto\">\n                <div class=\"my-1 mod-h\" ng-click=\"modulo.isCollapsed = !modulo.isCollapsed\" style=\"background-color:rgba(0, 0, 0, 0.05);\">\n                  <span uib-tooltip=\"Click para ocultar/mostrar sus items\" tooltip-placement=\"right\">\n                    <strong>Módulo:</strong> {{modulo.nombre}}\n                  </span>\n                </div>\n                <hr class=\"mt-2 mb-1\">\n                <div class=\"table-responsive\" ng-class=\"{'col-md-6':!$ctrl.modificandoItems}\">\n                  <div uib-collapse=\"modulo.isCollapsed\">\n                    <table class=\"table table-striped mod-t text-right\" style=\"width:auto\" ng-init=\"version_ant=$ctrl.proyecto.version_anterior\">\n                      <thead>\n                        <tr>\n                          <th rowspan=\"2\" title=\"Nro de item\" style=\"width:50px\">Nro.</th>\n                          <th rowspan=\"2\" class=\"text-left\" style=\"width:350px\">Descripción</th>\n                          <th rowspan=\"2\" title=\"Unidad\" style=\"width:100px\">Unid.</th>\n                          <!-- <th rowspan=\"2\" title=\"Cantidad\" style=\"width:100px\">Cant.</th> -->\n                          <th rowspan=\"2\" title=\"Precio Unitario\" style=\"width:100px\">P.U.</th>\n                          <th rowspan=\"2\" title=\"Peso ponderado\" style=\"width:100px\">P.P.</th>\n                          <!-- <th rowspan=\"2\" style=\"width:100px\">Total (Bs)</th> -->\n                          <th colspan=\"2\" class=\"text-center\" style=\"width:200px\" ng-if=\"$ctrl.cabecera.version_inicial\">Contrato Original</th>\n                          <th colspan=\"2\" class=\"text-center\" style=\"width:200px\" ng-if=\"$ctrl.cabecera.version_anterior\">{{version_ant.tipo_modificacion_adjudicacion.nombre ? version_ant.tipo_modificacion_adjudicacion.nombre + ' N° ' + version_ant.tipo_modificacion_adjudicacion.numero : 'Contrato Original'}}</th>\n                          <th colspan=\"2\" class=\"text-center\" ng-if=\"$ctrl.modificandoItems\" style=\"width:200px\">{{$ctrl.proyecto.modificaciones.nombre}}</th>\n                          <th colspan=\"2\" class=\"text-center\" ng-if=\"$ctrl.modificandoItems\" style=\"width:200px\">Avance</th>\n                        </tr>\n                        <tr ng-if=\"$ctrl.modificandoItems\">\n                          <th title=\"Cantidad\" style=\"width:100px\" ng-if=\"$ctrl.cabecera.version_inicial\">Cant.</th>\n                          <th style=\"width:100px\" ng-if=\"$ctrl.cabecera.version_inicial\">Total (Bs)</th>\n                          <th title=\"Cantidad\" style=\"width:100px\" ng-if=\"$ctrl.cabecera.version_anterior\">Cant.</th>\n                          <th style=\"width:100px\" ng-if=\"$ctrl.cabecera.version_anterior\">Total (Bs)</th>\n                          <th title=\"Cantidad\" style=\"width:100px\">Cant.</th>\n                          <th style=\"width:100px\">Total (Bs)</th>\n                          <!-- <th style=\"width:100px\">Anterior</th> -->\n                          <th style=\"width:100px\">Actual</th>\n                          <th title=\"Falta ejecutar\" style=\"width:100px\">F.E.</th>\n                        </tr>\n                      </thead>\n                      <tbody>\n                        <tr ng-repeat=\"item in modulo.items\" ng-show=\"item.show\"\n                          ng-class=\"(item.cantidad == item.avance_actual || item.estado == 'CERRADO') ? 'completado' : ''\">\n                          <td ng-class=\"$ctrl.getMgColor(item)\" title=\"{{$ctrl.getTitle(item)}}\">{{item.nro_item}}</td>\n                          <td class=\"text-left\">{{item.nombre}}</td>\n                          <td title=\"{{item.unidad.descripcion}}\">{{item.unidad.nombre}}</td>\n                          <!-- <td>{{item.version_inicial.cantidad | number:$ctrl.decimales}}</td> -->\n                          <td>{{item.precio_unitario | number:$ctrl.decimales}}</td>\n                          <td class=\"modificacion-input\">\n                            <c-input-numeric name=\"peso_ponderado{{$index}}\" ng-model=\"item.peso_ponderado\"\n                              ng-minvalue=\"0\" ng-maxvalue=\"1\" ng-decimals=\"0\" ng-disabled=\"$ctrl.modoVista || item.estado =='CERRADO'\"\n                              ng-if=\"$ctrl.modificandoItems\" ng-blur=\"$ctrl.modificarPesoItem(item)\"></c-input-numeric>\n                            <span ng-if=\"!$ctrl.modificandoItems\">{{item.peso_ponderado | number:$ctrl.decimales}}</span>\n                          </td>\n                          <!-- <td>{{(item.version_inicial.cantidad*item.precio_unitario) | number:$ctrl.decimales}}</td> -->\n                          <td ng-if=\"$ctrl.cabecera.version_inicial\">{{item.version_inicial.cantidad | number:$ctrl.decimales}}</td>\n                          <td ng-if=\"$ctrl.cabecera.version_inicial\">{{$ctrl.Util.multiplicar([item.version_inicial.cantidad, item.precio_unitario]) | number:$ctrl.decimales}}</td>\n                          <td ng-class=\"{'text-info font-weight-bold':item.version_anterior.cantidad!=item.version_inicial.cantidad}\" ng-if=\"$ctrl.cabecera.version_anterior\">{{item.version_anterior.cantidad | number:$ctrl.decimales}}</td>\n                          <td ng-class=\"{'text-info font-weight-bold':item.version_anterior.cantidad!=item.version_inicial.cantidad}\" ng-if=\"$ctrl.cabecera.version_anterior\">{{(item.version_anterior.cantidad*item.precio_unitario) | number:$ctrl.decimales}}</td>\n                          <td class=\"modificacion-input\" ng-class=\"{'warning':(item.cantidad!=item.version_anterior.cantidad),'danger':item.error}\" ng-if=\"$ctrl.modificandoItems\">\n                            <c-input-numeric name=\"cantidad_{{$index}}\" ng-model=\"item.cantidad\"\n                             ng-minvalue=\"{{item.avance_actual}}\" ng-maxvalue=\"999999\" ng-decimals=\"0\" ng-blur=\"$ctrl.modificarCantidadItem(item)\"\n                             ng-disabled=\"$ctrl.modoVista || item.estado=='CERRADO'\" ng-if=\"item.unidad_medida === 'UN_GLOBAL' || item.unidad_medida === 'UN_PIEZA' || item.unidad_medida === 'UN_PUNTO'\">\n                            </c-input-numeric>\n                            <c-input-numeric name=\"cantidad{{$index}}\" ng-model=\"item.cantidad\" ng-blur=\"$ctrl.modificarCantidadItem(item)\" ng-disabled=\"$ctrl.modoVista || item.estado=='CERRADO'\"\n                                    ng-minvalue=\"{{item.avance_actual}}\" ng-maxvalue=\"9999999\" ng-decimals=\"{{$ctrl.decimales}}\"\n                                    ng-if=\"item.unidad_medida !== 'UN_GLOBAL' && item.unidad_medida !== 'UN_PIEZA' && item.unidad_medida !== 'UN_PUNTO'\"></c-input-numeric>\n                            <!--\n                            <c-input-numeric name=\"cantidad\" ng-model=\"item.cantidad\" ng-blur=\"$ctrl.modificarCantidadItem(item)\" ng-disabled=\"$ctrl.modoVista || item.estado=='CERRADO' || item.unidad.nombre=='glb'\"\n                                    ng-minvalue=\"{{item.avance_actual}}\" ng-maxvalue=\"999999\" ng-decimals=\"{{$ctrl.decimales}}\"></c-input-numeric>\n                             -->\n                          </td>\n                          <td ng-class=\"{'font-weight-bold warning':(item.cantidad!=item.version_anterior.cantidad),'danger':item.error}\" ng-if=\"$ctrl.modificandoItems\">{{(item.cantidad*item.precio_unitario) | number:$ctrl.decimales}}</td>\n                          <!-- <td ng-if=\"$ctrl.modificandoItems\">{{item.cantidad_anterior_fis | number:$ctrl.decimales}}</td> -->\n                          <td ng-if=\"$ctrl.modificandoItems\">{{item.avance_actual | number:$ctrl.decimales}}</td>\n                          <td ng-if=\"$ctrl.modificandoItems\">{{(item.cantidad-item.avance_actual) | number:$ctrl.decimales}}</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n              <section ng-repeat=\"nuevomodulo in $ctrl.nuevosmodulos\" ng-if=\"$ctrl.modificandoItems && $ctrl.tipoModificacion==3\">\n                <modulo modulo=\"nuevomodulo\" callback=\"$ctrl.recalcularMontos(data)\" options=\"{adicionar:true, idProyecto:$ctrl.proyecto.idProyecto, cabecera:$ctrl.cabecera}\" modo-vista=\"$ctrl.modoVista\"></modulo>\n              </section>\n              <button class=\"btn btn-link text-success\" ng-click=\"$ctrl.adicionarModulo()\" uib-tooltip=\"Adicionar nuevo módulo para los items nuevos\" ng-if=\"!$ctrl.modoVista && $ctrl.modificandoItems && $ctrl.tipoModificacion==3 && $ctrl.nuevosmodulos.length===0\">\n                <i class=\"fa fa-plus-square-o\"></i> Adicionar Items\n              </button>\n              <hr>\n              <br>\n              <div class=\"alert alert-danger\" ng-if=\"$ctrl.modificandoItems && $ctrl.porcentajeExcedido \">\n                <i class=\"fa fa-exclamation-circle\"></i>\n                <span>\n                  <span ng-if=\"$ctrl.tipoModificacion==1\">Se ha modificado el</span>\n                  <span ng-if=\"$ctrl.tipoModificacion!=1\">El monto total con modificación supera el {{$ctrl.porcentajeLimite*100}} % del</span>\n                  monto contractual en Bs. {{$ctrl.Util.restar($ctrl.Util.sumar([$ctrl.proyecto.monto_total_variacion_modificado, $ctrl.proyecto.modificaciones.total_variacion_h]), $ctrl.Util.multiplicar([$ctrl.proyecto.version_inicial.monto, $ctrl.porcentajeLimite])) | number:$ctrl.decimales}}. Usted debe revisar sus cantidades modificadas.</span>\n              </div>\n              <div class=\"alert alert-warning\" ng-if=\"$ctrl.itemsNoCerrados.length > 0\">\n                <i class=\"fa fa-warning\"></i>\n                <span ng-if=\"$ctrl.itemsNoCerrados.length === 1\"><strong>El item resaltado</strong> tiene</span>\n                <span ng-if=\"$ctrl.itemsNoCerrados.length > 1\"><strong>Los items resaltados</strong> tienen</span>\n                <span>concluido el avance físico, sin embargo la parte financiera no ha cerrado. Este detalle será revisado por personal del FDI.</span>\n              </div>\n\n              <div class=\"fs-sm\" ng-if=\"$ctrl.modificandoItems\">\n                <div class=\"row\">\n                  <div class=\"col-md-6 text-left\">\n                    <table class=\"table mod-t mod-t-b mb-0\">\n                      <tbody>\n                        <tr>\n                          <th>Monto total anterior:</th>\n                          <td>{{$ctrl.proyecto.version_anterior.monto | number:$ctrl.decimales}}</td>\n                        </tr>\n                        <!-- <tr>\n                          <th>Monto total de variación:</th>\n                          <td>{{$ctrl.proyecto.monto_total_variacion_modificado | number:$ctrl.decimales}}</td>\n                        </tr> -->\n                        <tr>\n                          <th>Monto total con modificación:</th>\n                          <td>{{$ctrl.Util.sumar([$ctrl.proyecto.version_anterior.monto, $ctrl.proyecto.monto_total_variacion_modificado]) | number:$ctrl.decimales}}</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                  <div class=\"col-md-6 text-left\">\n                    <table class=\"table mod-t mod-t-b mb-0\">\n                      <tbody>\n                        <tr>\n                          <th>Monto de contrato inicial:</th>\n                          <td>{{($ctrl.proyecto.adjudicacion.monto_inicial) | number:$ctrl.decimales}}</td>\n                        </tr>\n                        <tr>\n                          <th>Monto total de variación:</th>\n                          <td>{{$ctrl.proyecto.monto_total_variacion_modificado | number:$ctrl.decimales}}</td>\n                        </tr>\n                        <tr>\n                          <th>Porcentaje de variación:</th>\n                          <td>{{$ctrl.proyecto.porcentaje_variacion | number:$ctrl.decimales}}%</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n            </uib-tab>\n            <uib-tab index=\"2\" heading=\"PLAZOS\" ng-if=\"$ctrl.tipoModificacion>1\">\n              <div class=\"row\">\n                <div class=\"col\">\n                  <button md-effect type=\"button\" class=\"btn mr-3 pull-right\" ng-class=\"{'btn-success':$ctrl.modificandoPlazo}\" ng-click=\"$ctrl.modificarPlazo()\" ng-if=\"!$ctrl.modoVista\">\n                    <i class=\"fa fa-edit\"></i> Modificar\n                  </button>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-6 text-left\">\n                  <div style=\"overflow:auto\">\n                    <br>\n                    <h5>Fechas establecidas al inicio de obras:</h5>\n                    <table class=\"table mod-t mod-t-b mb-0\">\n                      <tbody>\n                        <tr>\n                          <th class=\"text-center\">Fecha de inicio de obras</th>\n                          <th class=\"text-center\">Plazo de ejecución (dias)</th>\n                          <th class=\"text-center\">Fecha de entrega provisional</th>\n                          <th class=\"text-center\">Fecha de recepción definitiva</th>\n                        </tr>\n                        <tr>\n                          <td class=\"text-center\">{{$ctrl.proyecto.orden_proceder | date : 'dd/MM/yyyy'}}</td>\n                          <td class=\"text-center\">{{$ctrl.proyecto.plazo_ejecucion}}</td>\n                          <td class=\"text-center\">{{$ctrl.fechaSumDias($ctrl.proyecto.orden_proceder,$ctrl.proyecto.plazo_ejecucion-1) | date : 'dd/MM/yyyy'}}</td>\n                          <td class=\"text-center\">{{$ctrl.fechaSumDias($ctrl.proyecto.orden_proceder,$ctrl.proyecto.plazo_ejecucion+89) | date : 'dd/MM/yyyy'}}</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n                <div class=\"col-lg-6 text-left\" ng-if=\"$ctrl.modificandoPlazo\">\n                  <div style=\"overflow:auto\">\n                    <br>\n                    <h5>Modificación Actual:</h5>\n                    <table class=\"table mod-t mod-t-b mb-0\">\n                      <tbody>\n                        <tr>\n                          <th class=\"text-center\">Ampliación de plazo por volúmenes (días)</th>\n                          <th class=\"text-center\">Ampliación de plazo por compensación (dias)</th>\n                          <th class=\"text-center\">Ampliación de plazo (días)</th>\n                        </tr>\n                        <tr>\n                          <td class=\"td-cinput-center\">\n                            <!-- <c-input name=\"cantidad\" ng-model=\"$ctrl.proyecto.plazo_ampliacion.por_volumenes\" ng-blur=\"$ctrl.modificarPlazoAmpliacion($ctrl.proyecto.plazo_ampliacion)\" ng-disabled=\"$ctrl.modoVista\"></c-input> -->\n                            <c-input-numeric name=\"por_volumenes\"\n                                      ng-model=\"$ctrl.proyecto.plazo_ampliacion.por_volumenes\"\n                                      ng-disabled=\"$ctrl.modoVista\" ng-required=\"false\"\n                                      ng-decimals=\"0\" ng-not-number=\"0\" ng-number-default=\"0\"\n                                      ng-minvalue=\"0\" ng-maxvalue=\"9999\"\n                                      ng-blur=\"$ctrl.modificarPlazoAmpliacion($ctrl.proyecto.plazo_ampliacion)\">\n                            </c-input-numeric>\n                          </td>\n                          <td class=\"td-cinput-center\">\n                            <!-- <c-input name=\"cantidad\" ng-model=\"$ctrl.proyecto.plazo_ampliacion.por_compensacion\" ng-blur=\"$ctrl.modificarPlazoAmpliacion($ctrl.proyecto.plazo_ampliacion)\" ng-disabled=\"$ctrl.modoVista\"></c-input> -->\n                            <c-input-numeric name=\"por_compensacion\"\n                                      ng-model=\"$ctrl.proyecto.plazo_ampliacion.por_compensacion\"\n                                      ng-disabled=\"$ctrl.modoVista\" ng-required=\"false\"\n                                      ng-decimals=\"0\" ng-not-number=\"0\" ng-number-default=\"0\"\n                                      ng-minvalue=\"0\" ng-maxvalue=\"9999\"\n                                      ng-blur=\"$ctrl.modificarPlazoAmpliacion($ctrl.proyecto.plazo_ampliacion)\">\n                            </c-input-numeric>\n                          </td>\n                          <td class=\"text-center\">{{ ($ctrl.proyecto.plazo_ampliacion.por_volumenes--$ctrl.proyecto.plazo_ampliacion.por_compensacion) }}</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-6 text-left\" ng-if=\"$ctrl.modificandoPlazo\">\n                  <div style=\"overflow:auto\">\n                    <br>\n                    <h5>Modificaciones de plazo:</h5>\n                    <table class=\"table mod-t mod-t-b mb-0\" ng-repeat=\"modificacion in $ctrl.proyecto.modificaciones.historial\">\n                      <tbody>\n                        <tr>\n                          <th class=\"text-center\" colspan=\"3\">{{modificacion.tipo_modificacion_adjudicacion.nombre}}</th>\n                        </tr>\n                        <tr>\n                          <th class=\"text-center\">Ampliación de plazo (días)</th>\n                          <th class=\"text-center\">Plazo de ejecución ampliada (dias)</th>\n                          <th class=\"text-center\">Fecha de entrega provisional ampliada</th>\n                        </tr>\n                        <tr ng-init=\"plazo = (modificacion.plazo_ampliacion.por_volumenes--modificacion.plazo_ampliacion.por_compensacion)\">\n                          <td class=\"text-center\">{{ (modificacion.plazo_ampliacion.por_volumenes--modificacion.plazo_ampliacion.por_compensacion) }}</td>\n                          <td class=\"text-center\">{{ modificacion.plazo_ampliacion_total+$ctrl.proyecto.plazo_ejecucion }}</td>\n                          <td class=\"text-center\">{{ modificacion.nueva_fecha_provisional | date : 'dd/MM/yyyy' }}</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n                <div class=\"col-lg-6 text-left\" ng-if=\"$ctrl.modificandoPlazo\">\n                  <div style=\"overflow:auto\">\n                    <br>\n                    <h5>Nuevas fechas modificadas:</h5>\n                    <table class=\"table mod-t mod-t-b mb-0\">\n                      <tbody>\n                        <tr>\n                          <th class=\"text-center\">Fecha de inicio de obras</th>\n                          <th class=\"text-center\">Plazo de ejecución ampliada (dias)</th>\n                          <th class=\"text-center\">Fecha de entrega provisional ampliada</th>\n                          <th class=\"text-center\">Fecha de recepción definitiva ampliada</th>\n                        </tr>\n                        <tr>\n                          <td class=\"text-center\">{{$ctrl.proyecto.orden_proceder | date : 'dd/MM/yyyy'}}</td>\n                          <td class=\"text-center\">{{$ctrl.proyecto.plazo_ejecucion+$ctrl.proyecto.plazo_ampliacion_total--$ctrl.proyecto.plazo_ampliacion.por_volumenes--$ctrl.proyecto.plazo_ampliacion.por_compensacion}}</td>\n                          <td class=\"text-center\">{{$ctrl.proyecto.nueva_fecha_provisional | date : 'dd/MM/yyyy'}}</td>\n                          <td class=\"text-center\">{{$ctrl.proyecto.nueva_fecha_definitiva | date : 'dd/MM/yyyy'}}</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n            </uib-tab>\n          </uib-tabset>\n        </form>\n      </section>\n\n      <section>\n        <h6 class=\"title-section m-top\">\n          <i class=\"fa fa-list\"></i> Resumen de la Modificación\n        </h6>\n\n        <div class=\"row\">\n          <div class=\"col-lg-6 text-left\">\n            <!-- <p>Monto contractual inicial <strong>{{$ctrl.proyecto.version_inicial.monto_total | number:$ctrl.decimales}}</strong></p> -->\n            <table class=\"table mod-t mod-t-b mb-0 table-responsive\">\n              <tbody>\n                <tr>\n                  <th colspan=\"6\" class=\"text-center\">Historial</th>\n                </tr>\n                <tr>\n                  <th>Modificación</th>\n                  <!-- <th>Monto total</th> -->\n                  <th>Variación</th>\n                  <th title=\"Orden de Cambio\">% O.C.</th>\n                  <th title=\"Contrato modificatorio\">% C.M.</th>\n                  <!-- <th>Estado</th> -->\n                  <th>Fecha</th>\n                </tr>\n                <tr ng-repeat=\"modificacion in $ctrl.proyecto.modificaciones.historial\" nng-if=\"$ctrl.proyecto.tipo_modificacion==modificacion.tipo_modificacion\">\n                  <td>{{modificacion.tipo_modificacion_adjudicacion.nombre}}</td>\n                  <!-- <td class=\"text-right\">{{modificacion.monto | number:$ctrl.decimales}}</td> -->\n                  <td class=\"text-right\">{{modificacion.variacion | number:$ctrl.decimales}}</td>\n                  <td>{{modificacion.variacion_porcentaje_oc | number:$ctrl.decimales}}</td>\n                  <td>{{modificacion.variacion_porcentaje_cm | number:$ctrl.decimales}}</td>\n                  <!-- <td>{{modificacion.estado_actual.nombre}}</td> -->\n                  <td>{{modificacion.fecha_modificacion | date : 'dd/MM/yyyy'}}</td>\n                </tr>\n                <tr>\n                  <td class=\"text-right\" colspan=\"1\"><strong>Total</strong></td>\n                  <td class=\"text-right\">{{$ctrl.proyecto.modificaciones.total_variacion | number:$ctrl.decimales}}</td>\n                  <td>{{$ctrl.proyecto.modificaciones.total_variacion_porcentaje_oc | number:$ctrl.decimales}}</td>\n                  <td>{{$ctrl.proyecto.modificaciones.total_variacion_porcentaje_cm | number:$ctrl.decimales}}</td>\n                  <td colspan=\"2\">&nbsp;</td>\n                </tr>\n              </tbody>\n            </table>\n            <div class=\"alert alert-danger\" ng-if=\"$ctrl.modificandoItems && $ctrl.porcentajeExcedido\">\n              <i class=\"fa fa-exclamation-circle\"></i>\n              <span>\n                <span ng-if=\"$ctrl.tipoModificacion==1\">{{ $ctrl.proyecto.modificaciones.total_variacion_h }} Se ha modificado el</span>\n                <span ng-if=\"$ctrl.tipoModificacion!=1\">El monto total con modificación supera el {{$ctrl.porcentajeLimite*100}} % del</span>\n                monto contractual en Bs. {{$ctrl.Util.restar($ctrl.Util.sumar([$ctrl.proyecto.monto_total_variacion_modificado, $ctrl.proyecto.modificaciones.total_variacion_h]), $ctrl.Util.multiplicar([$ctrl.proyecto.version_inicial.monto, $ctrl.porcentajeLimite])) | number:$ctrl.decimales}}. Usted debe revisar sus cantidades modificadas.</span>\n            </div>\n          </div>\n\n          <div class=\"col-lg-6 text-left\">\n            <ui-input-file name=\"doc_informe_tecnico\" label=\"Informe técnico o respaldo de la modificación\"\n              file-base64=\"$ctrl.informe_tecnico\"\n              upload-callback=\"$ctrl.uploadCallback\"\n              types=\"pdf\" mime-types=\".pdf\" maxfiles=\"1\" maxsize=\"3MB\"\n              ng-if=\"!$ctrl.informe_tecnico_registrado && !$ctrl.modoVista\">\n            </ui-input-file>\n            <div id=\"documento\" ng-if=\"$ctrl.informe_tecnico_registrado\">\n              <div class=\"opciones\">\n                <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.verInformeTecnico()\">\n                  <i class=\"fa fa-eye\"></i>\n                </button>\n                <!-- <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n                        download-file=\"{{documento.urlDescarga}}\" file-name=\"{{documento.nombre}}\">\n                  <i class=\"fa fa-download\"></i>\n                </button> -->\n                <button md-effect type=\"button\" class=\"btn btn-info btn-sm\" uib-tooltip=\"Cambiar\" ng-click=\"$ctrl.quitarInformeTecnico()\" ng-if=\"!$ctrl.modoVista\">\n                  <i class=\"fa fa-exchange\"></i>\n                </button>\n              </div>\n              <img src=\"./images/documento.jpg\" alt=\"Documento\">\n              <div class=\"detalles\">\n                <div class=\"nombre\">Documentos aprobados (libro de ordenes, informes técnicos, contrato modificatorio)</div>\n              </div>\n            </div>\n            <div class=\"alert alert-danger\" ng-if=\"!$ctrl.informe_tecnico_registrado && $ctrl.modoVista && $ctrl.proyecto.version>1\">\n              <i class=\"fa fa-danger\"></i><span>No existen los documentos aprobados (libro de ordenes, informes técnicos, contrato modificatorio)</span>\n            </div>\n          </div>\n\n        </div>\n      </section>\n\n      <section nng-if=\"$ctrl.proyecto.estado_actual.codigo=='NO_OBJECION_FDI' || $ctrl.respaldo_tecnico_registrado\">\n        <form name=\"documentos\">\n        <h6 class=\"title-section m-top\">\n          <i class=\"fa fa-list\"></i> Documentos de respaldo\n        </h6>\n        <div class=\"row\" ng-repeat=\"documento in $ctrl.proyecto.adjudicacion.documentos\">\n          <div class=\"col-lg-6 text-left\">\n            <div>\n              <c-input label=\"Título de Documento\" name=\"doc{{$index}}\" ng-model=\"documento.datos.name\" ng-disabled=\"!$ctrl.modoEdicionDoc(documento) || documento.datos.codigo\" maxlength=\"64\"></c-input>\n            </div>\n            <div>\n              <c-input label=\"Usuario\" name=\"autor{{$index}}\" ng-model=\"documento.datos.rol.descripcion\" ng-disabled=\"true\" maxlength=\"32\"></c-input>\n            </div>\n            <div>\n              <c-input label=\"Estado\" name=\"estado{{$index}}\" ng-model=\"documento.datos.estado.descripcion\" ng-disabled=\"true\" maxlength=\"32\"></c-input>\n            </div>\n          </div>\n          <div class=\"col-lg-6 text-left\">\n            <div>\n              <button md-effect type=\"button\" class=\"btn btn-danger btn-sm pull-right\" ng-if=\"$ctrl.modoEdicionDoc(documento)\" ng-click=\"$ctrl.eliminarRespaldoTecnico(documento)\"><span class=\"fa fa-minus\"></span></button>\n            </div>\n            <ui-input-file name=\"{{documento.datos.name}}\" label=\"Documento de respaldo\"\n              file-base64=\"documento.file\"\n              upload-callback=\"$ctrl.uploadRespaldo\"\n              types=\"pdf\" mime-types=\".pdf\" maxfiles=\"1\" maxsize=\"3MB\"\n              ng-if=\"!documento.datos.archivo\">\n            </ui-input-file>\n            <div id=\"documento\" ng-if=\"documento.datos.archivo\">\n              <div class=\"opciones\">\n                <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.verRespaldoTecnico(documento)\">\n                  <i class=\"fa fa-eye\"></i>\n                </button>\n                <button md-effect type=\"button\" class=\"btn btn-info btn-sm\" uib-tooltip=\"Cambiar\" ng-click=\"$ctrl.cambiarRespaldoTecnico(documento)\" ng-if=\"$ctrl.modoEdicionDoc(documento)\">\n                  <i class=\"fa fa-exchange\"></i>\n                </button>\n              </div>\n              <img src=\"./images/documento.jpg\" alt=\"Documento\">\n              <div class=\"detalles\">\n                <div class=\"nombre\">{{documento.datos.name}}</div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div>\n          <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.agregarRespaldoTecnico()\"><span class=\"fa fa-plus\"></span></button>\n        </div>\n        </form>\n      </section>\n\n      <div class=\"mt-4 texto\">\n        <!-- <div class=\"mt-3\">\n          <small class=\"resaltado\"><strong><em>La presente planilla tiene valor de declaración Jurada, por lo que si se identifica cualquier falsedad, se realizarán las acciones legales respectivas en contra de la empresa constructora infractora.</em></strong></small>\n        </div> -->\n\n        <div class=\"row my-3 pr-3 justify-content-end\">\n          <button md-effect type=\"button\" class=\"btn mr-3\" ng-click=\"$ctrl.filtroItems === 'PARA_ENVIAR' ? $ctrl.filtroItems = 'TODOS' : $ctrl.filtroItems = 'PARA_ENVIAR'\" ng-if=\"$ctrl.esEtapaEdicion\">\n            <i class=\"fa fa-eye\"></i> {{ $ctrl.filtroItems === 'PARA_ENVIAR' ? 'Ver todos' : 'Ver planilla a enviar'}}\n          </button>\n          <ejecutar-transicion elemento=\"$ctrl.proyecto\"\n                               servicio=\"$ctrl.Modificacion\"\n                               form=\"formModificacion\"\n                               atributo-estado=\"estado_proyecto\"\n                               url=\"$ctrl.url\"\n                               mensaje-button=\"$ctrl.mensajeConfirmacion\"\n                               confirmar=\"true\"\n                               metodo-previo=\"$ctrl.verificarModificacion(accion)\">\n          </ejecutar-transicion>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<style>\n.modificacion-input2 .md-form-group {\n  margin-top: 0rem;\n  margin-bottom: 0;\n}\n.modificacion-input .md-form-group {\n  margin-top: 0rem;\n  margin-bottom: 0;\n  width: 90px;\n  float: right;\n}\n.modificacion-input .md-form-group input {\n  text-align: right;\n}\n.td-cinput-center .md-form-group {\n  margin: 0 auto;\n  width: 90px;\n}\n.td-cinput-center .md-form-group input {\n  text-align: center;\n}\n</style>\n"

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"form_{{$ctrl.modulo.id_modulo}}\">\n  <span class=\" text-primary\"><strong>Módulo:</strong> {{$ctrl.modulo.nombre}}</span>\n  <button class=\"btn btn-link text-danger\" ng-click=\"$ctrl.eliminarModulo()\" uib-tooltip=\"Eliminar el módulo y los items adicionados\" ng-if=\"false\">\n    <i class=\"fa fa-trash-o\"></i> Eliminar Items\n  </button>\n  <div class=\"float-right\" ng-if=\"!$ctrl.modoVista\">\n    <button class=\"btn btn-link text-success ml-1  pl-1 pr-1\" ng-click=\"$ctrl.guardarDatosModulo($ctrl.modulo)\" ng-if=\"$ctrl.options.guardar===true\"\n    uib-tooltip=\"Guardar datos módulo\" validar-formulario nombre-formulario=\"form_{{$ctrl.modulo.id_modulo}}\">\n      <i class=\"fa fa-save\"></i>\n    </button>\n    <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"$ctrl.editarModulo($ctrl.modulo)\" ng-if=\"$ctrl.options.editar===true\" uib-tooltip=\"Editar\">\n      <i class=\"fa fa-edit\"></i>\n    </button>\n  </div>\n  <hr class=\"mt-2 mb-1\">\n\n  <div style=\"overflow:auto\">\n    <table class=\"table table-striped mod-t text-right\" style=\"width:auto;margin-bottom:170px;\">\n      <thead>\n        <tr>\n          <th rowspan=\"2\" title=\"Nro de item\" style=\"width:50px\">Nro.</th>\n          <th rowspan=\"2\" class=\"text-left\" style=\"width:350px\">Descripción</th>\n          <th rowspan=\"2\" title=\"Unidad\" style=\"width:100px\">Unid.</th>\n          <th rowspan=\"2\" title=\"Precio Unitario\" style=\"width:100px\">P.U.</th>\n          <th rowspan=\"2\" title=\"Peso ponderado\" style=\"width:100px\">P.P.</th>\n          <th rowspan=\"2\" style=\"width:100px\" ng-if=\"$ctrl.options.cabecera.version_inicial\">&nbsp;</th>\n          <th rowspan=\"2\" style=\"width:100px\" ng-if=\"$ctrl.options.cabecera.version_inicial\">&nbsp;</th>\n          <th rowspan=\"2\" style=\"width:100px\" ng-if=\"$ctrl.options.cabecera.version_anterior\">&nbsp;</th>\n          <th rowspan=\"2\" style=\"width:100px\" ng-if=\"$ctrl.options.cabecera.version_anterior\">&nbsp;</th>\n          <th colspan=\"2\" class=\"text-center\" style=\"width:200px\">Contrato Modificatorio</th>\n          <th rowspan=\"2\" class=\"text-center\" style=\"width:200px\">\n            <!-- <button class=\"btn btn-link text-success ml-1  pl-1 pr-1\" ng-click=\"$ctrl.adicionarItem($ctrl.modulo)\" ng-if=\"!$ctrl.modoVista && $ctrl.options.adicionar===true\" uib-tooltip=\"Nuevo Item\">\n              <i class=\"fa fa-plus-square-o\"></i> Adicionar Item\n            </button> -->\n            <br>Acciones\n          </th>\n        </tr>\n        <tr>\n          <th title=\"Cantidad\" style=\"width:100px\">Cant.</th>\n          <th style=\"width:100px\">Total (Bs)</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in $ctrl.modulo.items | orderBy:'nro_item'\"\n          ng-class=\"item.falta_ejecutar_fis === 0 && item.falta_ejecutar_fin !== 0 ? 'observado' : ''\">\n          <td ng-class=\"$ctrl.getMgColor(item)\" title=\"{{$ctrl.getTitle(item)}}\">{{item.nro_item}}</td>\n          <td class=\"modificacion-input2\">\n            <c-input name=\"item_nombre_{{$index}}\" ng-model=\"item.nombre\" maxlength=\"150\" ng-disabled=\"!item.edicion\"></c-input>\n          </td>\n          <td class=\"modificacion-input\"  title=\"{{item.unidad.descripcion}}\">\n            <c-select name=\"item_unidad_{{$index}}\" ng-model=\"item.unidad_medida\" options=\"$ctrl.unidades\" key-value=\"codigo\" ng-disabled=\"!item.edicion\"></c-select>\n          </td>\n          <td class=\"modificacion-input\">\n            <c-input-numeric name=\"item_precio_{{$index}}\" ng-model=\"item.precio_unitario\"\n                             ng-minvalue=\"0\" ng-maxvalue=\"999999\" ng-decimals=\"2\"\n                             ng-disabled=\"!item.edicion\">\n            </c-input-numeric>\n          </td>\n          <td class=\"modificacion-input\">\n            <c-input-numeric name=\"item_peso_{{$index}}\" ng-model=\"item.peso_ponderado\"\n                              ng-minvalue=\"0\" ng-maxvalue=\"1\" ng-decimals=\"0\"\n                              ng-disabled=\"!item.edicion\">\n            </c-input-numeric>\n          </td>\n          <td ng-if=\"$ctrl.options.cabecera.version_inicial\">&nbsp;</td>\n          <td ng-if=\"$ctrl.options.cabecera.version_inicial\">&nbsp;</td>\n          <td ng-if=\"$ctrl.options.cabecera.version_anterior\">&nbsp;</td>\n          <td ng-if=\"$ctrl.options.cabecera.version_anterior\">&nbsp;</td>\n          <td class=\"modificacion-input\" ng-class=\"{'warning':(item.cantidad!=item.version_anterior.cantidad),'danger':item.error}\">\n            <!-- <c-input-numeric name=\"item_cantidad_{{$index}}\" ng-model=\"item.cantidad\"\n                             ng-minvalue=\"1\" ng-maxvalue=\"1\" ng-decimals=\"2\"\n                             ng-disabled=\"!item.edicion\" ng-if=\"item.unidad_medida === 'UN_GLOBAL'\">\n            </c-input-numeric> -->\n            <c-input-numeric name=\"item_cantidad_{{$index}}\" ng-model=\"item.cantidad\"\n                             ng-minvalue=\"1\" ng-maxvalue=\"999999\" ng-decimals=\"0\"\n                             ng-disabled=\"!item.edicion\" ng-if=\"item.unidad_medida === 'UN_GLOBAL' || item.unidad_medida === 'UN_PIEZA' || item.unidad_medida === 'UN_PUNTO'\">\n            </c-input-numeric>\n            <c-input-numeric name=\"item_cantidad_{{$index}}\" ng-model=\"item.cantidad\"\n                             ng-minvalue=\"0\" ng-maxvalue=\"999999\" ng-decimals=\"2\"\n                             ng-disabled=\"!item.edicion\" ng-if=\"item.unidad_medida !== 'UN_GLOBAL' && item.unidad_medida !== 'UN_PIEZA' && item.unidad_medida !== 'UN_PUNTO'\">\n            </c-input-numeric>\n            <!-- <c-input name=\"cantidad\" ng-model=\"item.cantidad\" ng-blur=\"$ctrl.modificarCantidadItem(item)\"></c-input> -->\n          </td>\n          <td ng-class=\"{'warning':(item.cantidad!=item.version_anterior.cantidad),'danger':item.error}\"><strong>{{(item.cantidad*item.precio_unitario) | number:2}}</strong></td>\n          <td style=\"width:100px\">\n            <button class=\"btn btn-link text-success ml-1 pl-1 pr-1\" ng-click=\"$ctrl.verPdfItem(item,'APU')\" ng-disabled=\"!item.analisis_precios\"\n              ng-if=\"item.analisis_precios\" uib-tooltip=\"{{item.analisis_precios?'Ver analisis de precios unitarios':'Sin documento'}}\">\n              <i class=\"fa\" ng-class=\"item.analisis_precios?'fa-file-text':'fa-file-text-o'\"></i>\n            </button>\n            <button class=\"btn btn-link text-success ml-1 pl-1 pr-1\" ng-click=\"$ctrl.cargarPdfItem(item,'APU')\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\" uib-tooltip=\"Cargar analisis de precios unitarios\">\n              <i class=\"fa fa-arrow-circle-up\"></i>\n            </button>\n          <!-- </td>\n          <td style=\"width:100px\"> -->\n            <button class=\"btn btn-link text-info ml-1 pl-1 pr-1\" ng-click=\"$ctrl.verPdfItem(item,'ET')\" ng-disabled=\"!item.especificaciones\"\n              ng-if=\"item.especificaciones\" uib-tooltip=\"{{item.especificaciones?'Ver especificaciones técnicas':'Sin documento'}}\">\n              <i class=\"fa\" ng-class=\"item.especificaciones?'fa-file-text':'fa-file-text-o'\"></i>\n            </button>\n            <button class=\"btn btn-link text-info ml-1 pl-1 pr-1\" ng-click=\"$ctrl.cargarPdfItem(item,'ET')\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\" uib-tooltip=\"Cargar especificaciones\">\n              <i class=\"fa fa-upload\"></i>\n            </button>\n            <!-- <br> -->\n            <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"item.edicion = true\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\" uib-tooltip=\"Editar\">\n              <i class=\"fa fa-edit\"></i>\n            </button>\n            <button class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"!item.id_item? $ctrl.guardarItem(item, $index, $parent.$parent.$index, modulo) : $ctrl.actualizarItem(item, $index, modulo)\"\n              ng-if=\"item.edicion && !$ctrl.modoVista\" uib-tooltip=\"Guardar\">\n              <i class=\"fa fa-save\"></i>\n            </button>\n            <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1\" ng-click=\"$ctrl.eliminarItem(item, $index, modulo)\"\n              ng-if=\"!$ctrl.modoVista\" uib-tooltip=\"Eliminar\">\n              <i class=\"fa fa-trash-o\"></i>\n            </button>\n          </td>\n        </tr>\n        <tr ng-if=\"!$ctrl.modoVista && $ctrl.options.adicionar===true\">\n          <td colspan=\"12\">\n            <button class=\"btn btn-link text-success ml-1 pl-1 pr-1\" ng-click=\"$ctrl.adicionarItem($ctrl.modulo)\" uib-tooltip=\"Nuevo Item\">\n              <i class=\"fa fa-plus-square-o\"></i> Adicionar Item\n            </button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</ng-form>\n"

/***/ }),
/* 778 */
749,
/* 779 */
750,
/* 780 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Foto de la supervisión número {{$ctrl.foto.nro}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row mb-3\">\n    <div class=\"col\">\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.irAPosicion('anterior')\" ng-disabled=\"$ctrl.foto.nro <= 1\">\n        <i class=\"fa fa-angle-double-left\" aria-hidden=\"true\"></i> Anterior\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.irAPosicion('siguiente')\" ng-disabled=\"$ctrl.foto.nro >= $ctrl.fotos.length\">\n        Siguiente <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n  </div>\n\n  <figure class=\"text-center\" ng-repeat=\"foto in $ctrl.fotos\">    \n    \n    <image-viewer id=\"fotosMovil\" base64=\"foto.base64\" height=\"300\" ng-if=\"$ctrl.foto.nro === ($index + 1)\"></image-viewer>\n  </figure>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-lg-4 col-md-6 col-sm-12\" ng-repeat=\"foto in $ctrl.fotos\">\n    <figure ng-dblclick=\"$ctrl.mostrarPopup(foto)\"> \n      <div class=\"row mx-0\" ng-if=\"!foto.mostrar\">\n        <div class=\"col-md\">Foto supervisión {{foto.nro}}</div>\n          <div class=\"actions\">\n            <i class=\"fa fa-eye text-success\" ng-click=\"$ctrl.getFoto(foto)\" uib-tooltip=\"Ver/Ocultar imagen\"> Mostrar</i>\n          </div>\n      </div>\n      <div ng-if=\"foto.mostrar\" class=\"foto\">\n        <img ng-src=\"data:image/jpg;base64, {{ foto.base64 }}\" alt=\"Foto {{foto.nro}}\" height=\"300\" width=\"100%\">\n        <div class=\"detalles\">\n          <span class=\"titulo\">Foto supervisión {{foto.nro}}</span>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"$ctrl.mostrarPopup(foto)\" uib-tooltip=\"Ver foto\">\n            <i class=\"fa fa-eye\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-primary pull-right\" ng-click=\"$ctrl.mostrarUbicacion(foto)\" uib-tooltip=\"Ver ubicación\">\n            <i class=\"fa fa-map-marker\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-danger pull-right\" ng-click=\"$ctrl.eliminarFoto(foto)\" uib-tooltip=\"Recargar datos de la fotografia\" ng-if=\"$ctrl.puedeEliminar\">\n            <i class=\"fa fa-trash\"></i>\n          </button>\n        </div>\n      </div>\n    </figure>\n  </div>\n</div>\n"

/***/ }),
/* 782 */
753,
/* 783 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container px-3 planilla-proy\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyecto <small><strong>{{$ctrl.proyecto.nombre}}</strong></small>\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row mx-0\">\n        <div style=\"font-size: 20px;\" uib-tooltip=\"Volver atrás\" ng-click=\"$ctrl.irAtras()\">\n          <i class=\"fa fa-reply\"></i>\n        </div>\n      </div>\n      <h4 class=\"text-center\" ng-if=\"$ctrl.proyecto.empresa.nombre\"><strong>{{$ctrl.proyecto.empresa.nombre}}</strong></h4>\n      <h4 class=\"text-center\" ng-if=\"$ctrl.supervision.adjudicacion.referencia\"><strong>{{$ctrl.supervision.adjudicacion.referencia}}</strong></h4>\n      <h3 class=\"text-center\">\n        Planilla de avance de obra Nro. {{$ctrl.supervision.nro_supervision}}\n      </h3>\n      <div class=\"texto\">\n        <p class=\"text-center\">Del {{$ctrl.supervision.fecha_inicio | date : 'dd/MM/yyyy'}} al {{!$ctrl.supervision.fecha_fin ? '-' : $ctrl.supervision.fecha_fin | date : 'dd/MM/yyyy'}} <br>\n          <span class=\"resaltado\" ng-if=\"$ctrl.supervision.monto_total_por_ejecutar === 0\">Planilla de cierre</span>\n        </p>\n        <section>\n          <a href=\"\">\n            <h6 class=\"title-section m-top\" ng-click=\"$ctrl.datosProyectoIsCollapsed = !$ctrl.datosProyectoIsCollapsed\">\n              <i class=\"fa fa-hand-o-right\"></i> Datos del proyecto\n            </h6>\n          </a>\n          <div uib-collapse=\"$ctrl.datosProyectoIsCollapsed\">\n            <div class=\"row\">\n              <div class=\"col-md-4 text-left\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr> <th class=\"text-right\">Nombre:</th> <td>{{$ctrl.proyecto.nombre}}</td> </tr>\n                    <tr> <th class=\"text-right\">Departamento:</th> <td>{{$ctrl.proyecto.dpa.departamento.nombre}}</td> </tr>\n                    <tr> <th class=\"text-right\">Provincia:</th> <td>{{$ctrl.proyecto.dpa.provincia.nombre}}</td> </tr>\n                    <tr> <th class=\"text-right\">Municipio:</th> <td>{{$ctrl.proyecto.dpa.municipio.nombre}}</td> </tr>\n                    <tr><th class=\"text-right\">Beneficiario:</th> <td>{{$ctrl.proyecto.entidad_beneficiaria}}</td> </tr>\n                    <tr><th class=\"text-right\">Fecha de orden de proceder:<br>(Según convenio)</th> <td>{{$ctrl.proyecto.orden_proceder | date: 'dd/MM/yyyy'}}</td> </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"col-md-4\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr ng-if=\"$ctrl.supervision.adjudicacion.monto_inicial\"> <th class=\"text-right\">Monto Adjudicación:</th> <td class=\"text-right\">{{$ctrl.supervision.adjudicacion.monto_inicial| number:2}}</td> </tr>\n                    <tr ng-repeat=\"modificacion in $ctrl.supervision.modificaciones\">\n                      <th class=\"text-right\">Modificación {{$index + 1}} ({{modificacion.tipo_modificacion_adjudicacion.nombre}}):</th> <td class=\"text-right\">{{modificacion.monto | number:2}}</td>\n                    </tr>\n                    <tr ng-if=\"$ctrl.supervision.adjudicacion.monto != $ctrl.proyecto.monto_contractual && $ctrl.supervision.adjudicacion.version > 1\">\n                      <th class=\"text-right\">Modificación {{$ctrl.supervision.modificaciones.length + 1}} ({{$ctrl.supervision.adjudicacion.tipo_modificacion_adjudicacion.nombre}}):</th> <td class=\"text-right\">{{$ctrl.supervision.adjudicacion.monto | number:2}}</td>\n                    </tr>\n                    <tr ng-if=\"$ctrl.supervision.adjudicacion && $ctrl.supervision.adjudicacion.monto != $ctrl.proyecto.monto_contractual && $ctrl.supervision.adjudicacion.version > 1\"> <th class=\"text-right\">Monto Total con Modificaciones:</th> <td class=\"text-right\">{{$ctrl.supervision.adjudicacion.monto | number:2}}</td> </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"col-md-4\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr> <th class=\"text-right\">Fecha inicio de obras:</th> <td>{{$ctrl.supervision.adjudicacion.orden_proceder | date : 'dd/MM/yyyy'}}</td> </tr>\n                    <tr> <th class=\"text-right\">Plazo de Ejecución <br>(Según convenio)</th> <td>{{$ctrl.proyecto.plazo_ejecucion}}</td> </tr>\n                    <tr> <th class=\"text-right\">Ampliación de Plazo</th> <td>{{$ctrl.supervision.adjudicacion.plazo_ampliacion.por_volumenes+$ctrl.supervision.adjudicacion.plazo_ampliacion.por_compensacion || 0}}</td> </tr>\n                    <tr> <th class=\"text-right\">Fecha prevista p/Recepción Provisional</th> <td>{{($ctrl.proyecto.fecha_recepcion_provisional) | date : 'dd/MM/yyyy'}}</td> </tr>\n                    <tr> <th class=\"text-right\">Fecha prevista p/Recepción definitiva </th> <td>{{($ctrl.proyecto.fecha_recepcion_definitiva) | date : 'dd/MM/yyyy'}}</td> </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n        </section>\n      </div>\n\n      <section>\n        <h6 class=\"title-section m-top\">\n          <i class=\"fa fa-list\"></i> Items del proyecto\n        </h6>\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <div class=\"alert alert-info\">\n              <i class=\"fa fa-info-circle\"></i>\n              <span>Puede hacer doble click a un item para <strong>{{$ctrl.esEditable? 'realizar' : 'revisar'}} su cómputo métrico</strong>.</span>\n            </div>\n          </div>\n          <div class=\"col-md-6\" ng-if=\"$ctrl.proyecto.doc_especificaciones_tecnicas\">\n            <button md-effect type=\"button\" class=\"btn btn-info\" download-file=\"{{$ctrl.urlDescEspTecnicas}}\" file-name=\"Especificaciones técnicas\"\n              uib-tooltip=\"Especificaciones técnicas\" tooltip-placement=\"bottom\">\n              <i class=\"fa fa-file-text-o\"></i> E. Técnicas\n            </button>\n            <button md-effect type=\"button\" class=\"btn btn-info\" download-file=\"{{$ctrl.urlDescPlanilla}}\" file-name=\"Planilla de avance nro {{$ctrl.supervision.nro_supervision}}\"\n              uib-tooltip=\"Planilla de avance nro {{$ctrl.supervision.nro_supervision}}\" tooltip-placement=\"bottom\" ng-if=\"$ctrl.supervision.version_adjudicacion || $ctrl.esTecnico()\">\n              <i class=\"fa fa-file-text-o\"></i> Planilla\n            </button>\n            <button md-effect type=\"button\" class=\"btn btn-info\" download-file=\"{{$ctrl.urlDescComputosResumen}}\" file-name=\"Resúmen de cómputos métricos de la planilla\"\n              uib-tooltip=\"Resúmen de cómputos métricos de la planilla\" tooltip-placement=\"bottom\" ng-if=\"$ctrl.supervision.version_adjudicacion\">\n              <i class=\"fa fa-table\"></i> Cómputos\n            </button>\n          </div>\n        </div>\n\n        <div class=\"row mt-2 mb-2\">\n          <div class=\"col-lg-6 col-md-12 mb-2\">\n            <div class=\"btn-group opciones\">\n              <label class=\"btn btn-success\" btn-checkbox ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'TODOS'\">Todos</label>\n              <label class=\"btn btn-success\" ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'COMPLETADOS'\">Completados</label>\n              <label class=\"btn btn-success\" ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'INCOMPLETOS'\">Por completar</label>\n              <label class=\"btn btn-success\" ng-model=\"$ctrl.filtroItems\" uib-btn-radio=\"'PARA_ENVIAR'\">Planilla</label>\n            </div>\n          </div>\n          <div class=\"col-lg-6 col-md-12 mt-2\">\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator success\"></span><span>Completado</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator secondary\"></span><span>Con avance</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator danger\"></span><span>Sin avance</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator warning\"></span><span>Con avance en anterior(es) planilla(s)</span>\n            </label>\n          </div>\n        </div>\n\n        <div ng-repeat=\"modulo in $ctrl.supervision.modulos\" ng-show=\"modulo.show\" class=\"texto\">\n          <div class=\"my-1 mod-h\" ng-click=\"modulo.isCollapsed = !modulo.isCollapsed\">\n            <span uib-tooltip=\"Click para ocultar/mostrar sus items\" tooltip-placement=\"right\">\n              <strong>Módulo:</strong> {{modulo.nombre}}\n            </span>\n          </div>\n          <hr class=\"mt-2 mb-1\">\n          <div class=\"table-responsive\">\n            <div uib-collapse=\"modulo.isCollapsed\">\n              <table class=\"table table-striped mod-t text-right\" style=\"width:{{1820+$ctrl.supervision.adjudicacion.adjudicacion_historico.length*270}}px;max-width:none\">\n                <thead>\n                  <tr>\n                    <th rowspan=\"2\" title=\"Nro de item\" style=\"width:50px\">Nro</th>\n                    <th rowspan=\"2\" class=\"text-left\" style=\"width:350px\">Descripción</th>\n                    <th rowspan=\"2\" title=\"Unidad\" style=\"width:70px\">Unid.</th>\n                    <th colspan=\"4\" class=\"text-center\" style=\"width:270px\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion === null || version.version <= $ctrl.supervision.version_adjudicacion\"\n                        ng-repeat=\"version in $ctrl.supervision.adjudicacion.adjudicacion_historico\">\n                        {{version.version === 1 ? 'Contrato Original' : version.tipo_modificacion_adjudicacion.nombre+' '+version.tipo_modificacion_adjudicacion.numero}}\n                      </th>\n                    <th colspan=\"4\" class=\"text-center\" style=\"width:270px\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion === null || $ctrl.supervision.adjudicacion.version <= $ctrl.supervision.version_adjudicacion\">\n                        {{$ctrl.supervision.adjudicacion.version === 1 ? 'Contrato Original' : $ctrl.supervision.adjudicacion.tipo_modificacion_adjudicacion.nombre+' '+$ctrl.supervision.adjudicacion.tipo_modificacion_adjudicacion.numero}}\n                      </th>\n                    <th colspan=\"4\" class=\"text-center\" style=\"width:360px\">Volumenes de avance</th>\n                    <th colspan=\"4\" class=\"text-center\" style=\"width:360px\">Avance financiero</th>\n                    <th rowspan=\"2\" title=\"% Ejecutado Físico\" style=\"width:90px\">% E.Fis.</th>\n                    <th rowspan=\"2\" title=\"% Ejecutar\" style=\"width:90px\">% E.</th>\n                    <th rowspan=\"2\" title=\"% Ejecutado Financiero\" style=\"width:90px\">% E.Fin.</th>\n                    <th rowspan=\"2\" title=\"% Ejecutar\" style=\"width:90px\">% E.</th>\n                  </tr>\n                  <tr>\n                    <th ng-repeat-start=\"version in modulo.items[0].item_historico\" style=\"width:90px\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion === null || version.version < $ctrl.supervision.version_adjudicacion\">Cant.</th>\n                    <th style=\"width:90px\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion === null || version.version < $ctrl.supervision.version_adjudicacion\">P.U.</th>\n                    <th style=\"width:40px\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion === null || version.version < $ctrl.supervision.version_adjudicacion\">A.F.</th>\n                    <th ng-repeat-end style=\"width:90px\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion === null || version.version < $ctrl.supervision.version_adjudicacion\">Total</th>\n                    <th title=\"Cantidad\" style=\"width:90px\">Cant.</th>\n                    <th title=\"Precio Unitario\" style=\"width:90px\">P.U.</th>\n                    <th title=\"Con avance físico\" style=\"width:40px\">A.F.</th>\n                    <th style=\"width:90px\">Total(Bs)</th>\n                    <th style=\"width:90px\">Anterior</th>\n                    <th style=\"width:90px\">Actual</th>\n                    <th title=\"Total Acumulado\" style=\"width:90px\">T.A.</th>\n                    <th title=\"Falta ejecutar\" style=\"width:90px\">F.E.</th>\n                    <th style=\"width:90px\">Anterior</th>\n                    <th style=\"width:90px\">Actual</th>\n                    <th title=\"Total Acumulado\" style=\"width:90px\">T.A.</th>\n                    <th title=\"Falta ejecutar\" style=\"width:90px\">F.E.</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-dblclick=\"$ctrl.mostrarComputo(item)\" ng-repeat=\"item in modulo.items\" ng-show=\"item.show\"\n                  ng-class=\"[{'observado': (item.falta_ejecutar_fis === 0 && item.falta_ejecutar_fin !== 0) || (item.ejecutar_porcentaje_fis === 0  && item.falta_ejecutar_fis > 0) || item.regularizar}]\">\n                    <td ng-class=\"$ctrl.getMgColor(item)\" title=\"{{$ctrl.getTitle(item)}}\">{{item.nro_item}}</td>\n                    <td class=\"text-left\">\n                      {{item.nombre}}\n                      <button md-effect class=\"btn btn-info btn-sm right\" uib-tooltip=\"Reporte de Cómputos métricos\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion && item.cantidad_actual_fis > 0\"\n                        download-file=\"{{$ctrl.urlDescComputosItem + item.nro_item + '_' + $ctrl.supervision.nro_supervision + '/descargar'}}\"\n                        file-name=\"Computos metricos item nro {{item.nro_item}}\">\n                        <i class=\"fa fa-table\"></i>\n                      </button>\n                    </td>\n                    <td>{{$ctrl.unidades_obj[item.unidad_medida].nombre}}</td>\n                    <td ng-repeat-start=\"version in item.item_historico\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion === null || version.version < $ctrl.supervision.version_adjudicacion\"\n                        ng-class=\"[{'text-info font-weight-bold modificado':version.modificado}, $ctrl.getTipoClass(version.modificacion)]\">{{version.cantidad | number:6}}</td>\n                    <td ng-class=\"$ctrl.getTipoClass(version.modificacion)\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion === null || version.version < $ctrl.supervision.version_adjudicacion\">{{version.precio_unitario | number:2}}</td>\n                    <td ng-class=\"$ctrl.getTipoClass(version.modificacion)\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion === null || version.version < $ctrl.supervision.version_adjudicacion\">{{version.peso_ponderado | number:0}}</td>\n                    <td ng-repeat-end ng-class=\"[{'text-info font-weight-bold':version.modificado}, $ctrl.getTipoClass(version.modificacion)]\"\n                        ng-if=\"$ctrl.supervision.version_adjudicacion === null || version.version < $ctrl.supervision.version_adjudicacion\">{{version.total | number:2}}</td>\n                    <td ng-class=\"[{'text-info font-weight-bold modificado':item.modificado},$ctrl.getTipoClass($ctrl.proyecto.tipo_modificacion)]\">{{item.cantidad | number:6}}</td>\n                    <td ng-class=\"$ctrl.getTipoClass($ctrl.proyecto.tipo_modificacion)\">{{item.precio_unitario | number:2}}</td>\n                    <td ng-class=\"$ctrl.getTipoClass($ctrl.proyecto.tipo_modificacion)\">{{item.peso_ponderado | number:0}}</td>\n                    <td ng-class=\"[{'text-info font-weight-bold':item.modificado, 'warning': item.variacion},$ctrl.getTipoClass($ctrl.proyecto.tipo_modificacion)]\">{{item.total | number:2}}</td>\n                    <td>{{item.cantidad_anterior_fis | number:6}}</td>\n                    <td>{{item.cantidad_actual_fis | number:6}}</td>\n                    <td>{{item.total_acumulado_fis | number:6}}</td>\n                    <td ng-class=\"{'warning' : item.falta_ejecutar_fis < 0}\">{{item.falta_ejecutar_fis | number:6}}</td>\n                    <td ng-class=\"{'warning' : item.variacion}\">{{item.cantidad_anterior_fin | number:2}}</td>\n                    <td ng-class=\"{'warning' : item.variacion}\">{{item.cantidad_actual_fin | number:2}}</td>\n                    <td ng-class=\"{'warning' : item.variacion}\">{{item.total_acumulado_fin | number:2}}</td>\n                    <td ng-class=\"{'warning' : item.falta_ejecutar_fin < 0 || item.variacion}\">{{item.falta_ejecutar_fin | number:2}}</td>\n                    <td>{{item.ejecutado_porcentaje_fis | number:2}}</td>\n                    <td>{{item.ejecutar_porcentaje_fis | number:2}}</td>\n                    <td>{{item.ejecutado_porcentaje_fin | number:2}}</td>\n                    <td>{{item.ejecutar_porcentaje_fin | number:2}}</td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n      </section>\n      <div class=\"alert alert-warning\" ng-if=\"$ctrl.itemsNoCerrados.length > 0\">\n        <i class=\"fa fa-warning\"></i>\n        <span ng-if=\"$ctrl.itemsNoCerrados.length === 1\"><strong>El item resaltado</strong> tiene</span>\n        <span ng-if=\"$ctrl.itemsNoCerrados.length > 1\"><strong>Los items resaltados</strong> tienen</span>\n        <span>concluido el avance físico, sin embargo la parte financiera no ha cerrado o {{$ctrl.itemsNoCerrados.length > 1? 'tienen' : 'tiene'}}\n          concluído el porcentaje de avance físico sin embargo aún hay una cantidad faltante por ejecutar. Este detalle será revisado por personal del FDI.</span>\n      </div>\n      <!-- Mensaje de advertencia por variacion de decimales  -->\n      <div class=\"alert alert-warning\" ng-if=\"$ctrl.itemsVariacion.length > 0\">\n        <i class=\"fa fa-warning\"></i>\n        <span>Los items resaltados tienen variacion de decimales que fueron regularizados en la etapa de registro de los modulos e items mediante la opcion regularizar</span>\n      </div>\n      <br>\n      <div class=\"fs-sm\">\n        <div class=\"row\">\n          <div class=\"col-md-6 text-left\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th>Monto actual ejecutado (R):</th>\n                  <td>{{$ctrl.supervision.monto_total_actual_ejecutado | number:2}} Bs</td>\n                </tr>\n                <tr>\n                  <th>Porcentaje fisico total ejecutado (por avance items):</th>\n                  <!-- <td>{{$ctrl.supervision.porcentaje_avance_fis | number:2}}%</td>--> \n                  <td>{{$ctrl.supervision.avance_fisico_ponderado | number:2}}%</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"col-md-6\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th>Monto ejecutado acumulado a la fecha:</th>\n                  <td>{{$ctrl.supervision.monto_total_acumulado | number:2}} Bs</td>\n                </tr>\n                <tr>\n                  <th>Monto total por ejecutar:</th>\n                  <td>{{$ctrl.supervision.monto_total_por_ejecutar | number:2}} Bs</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"mt-4 texto\">\n        <div class=\"row\">\n          <div class=\"col-md-6 text-left\">\n            <!--\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th class=\"mot-t-sin-b\" colspan=\"3\">II. VERIFICACIÓN DE BOLETAS DE GARANTÍA </th>\n                </tr>\n                <tr>\n                  <th>Descripción</th>\n                  <th>Tipo</th>\n                  <th>Fecha de vencimiento</th>\n                </tr>\n                <tr ng-repeat=\"boleta in $ctrl.boletasAnticipo\">\n                  <td rowspan=\"{{$ctrl.boletasAnticipo.length}}\" ng-hide=\"$index>0\">Buena inversión del Anticipo</td>\n                  <td>{{ boleta.tipo_documento == 'POLIZA' ? 'Póliza' :'Boleta' }}</td>\n                  <td>{{ boleta.fecha_fin_validez | date : 'dd/MM/yyyy' }}</td>\n                </tr>\n                <tr ng-repeat=\"boleta in $ctrl.boletasCcontrato\">\n                  <td rowspan=\"{{$ctrl.boletasCcontrato.length}}\" ng-hide=\"$index>0\">Cumplimiento de Contrato</td>\n                  <td>{{ boleta.tipo_documento == 'POLIZA' ? 'Póliza' :'Boleta' }}</td>\n                  <td>{{ boleta.fecha_fin_validez | date : 'dd/MM/yyyy' }}</td>\n                </tr>\n              </tbody>\n            </table>\n            -->\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th>Monto total del componente adjudicado (P)</th>\n                  <td> {{$ctrl.supervision.adjudicacion.monto_inicial| number:2}}</td> \n                </tr>\n                \n                <tr>\n                  <th>Anticipo ( S = P * <input type=\"number\" ng-model=\"$ctrl.supervision.anticipo\" min= \"0\" max=\"20\"  ng-keyup=\"$ctrl.calcularAnticipos($ctrl.supervision.adjudicacion.monto_inicial,$ctrl.supervision.monto_total_actual_ejecutado);\"  ng-blur=\"$ctrl.mensajeGuardado()\" ng-disabled= \"$ctrl.esSupervisor() || $ctrl.supervision.estado_supervision != 'REGISTRO_PLANILLA_FDI'\">%  )</th>\n                  <td>{{$ctrl.anticipo20 | number:2}}</td>\n                </tr>\n                <tr>\n                  <th>Descuento Por Anticipo (T = S *  <input type=\"number\" ng-model=\"$ctrl.supervision.dpanticipo\" min= \"0\" max=\"100\"  ng-keyup=\"$ctrl.calcularAnticipos($ctrl.supervision.adjudicacion.monto_inicial,$ctrl.supervision.monto_total_actual_ejecutado);\"  ng-blur=\"$ctrl.mensajeGuardado()\" ng-disabled= \"$ctrl.esSupervisor() || $ctrl.supervision.estado_supervision != 'REGISTRO_PLANILLA_FDI'\"> %) </th>\n                  <td>{{$ctrl.descuentoAnticipo | number:2}}</td>\n                </tr>\n                <tr>\n                  <th>\n                    <input type=\"checkbox\" ng-model=\"$ctrl.supervision.retencion\" ng-change=\"$ctrl.calcularAnticipos($ctrl.supervision.adjudicacion.monto_inicial,$ctrl.supervision.monto_total_actual_ejecutado);\" ng-disabled= \"$ctrl.esSupervisor() || $ctrl.supervision.estado_supervision != 'REGISTRO_PLANILLA_FDI'\">\n                      Retencion del 7 % (Y = R *  7%)\n                    \n                    <input type=\"button\" name=\"guardarRetencion\" ng-click=\"$ctrl.mensajeGuardado();\" value=\"ok\">\n                  </th>\n                  <td>{{$ctrl.retension | number:2}}</td>\n                </tr>\n                <tr>\n                  <th>Liquido pagable actual (X = R - T - Y)</th>\n                  <td>{{$ctrl.liquidoPagable | number:2}}</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"col-md-6\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th class=\"mot-t-sin-b\" colspan=\"3\">II. INFORME TÉCNICO DE CONCLUSIONES </th>\n                </tr>\n                <tr>\n                  <th>Avance Físico (en base al monto total del componente adjudicado)</th>\n                  <td>{{$ctrl.supervision.porcentaje_avance_fis | number:2}}%</td>\n                </tr>\n                <tr>\n                  <th>Avance Financiero</th>\n                  <td>{{$ctrl.supervision.porcentaje_avance_fin | number:2}}%</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n\n        <section ng-if=\"$ctrl.Supervision.esAreaPermitida('DEUDA_ANTICIPO') && $ctrl.tieneDeudas\">\n          <h6 class=\"title-section m-top\"> <i class=\"fa fa-money\"></i> Descuento por anticipo </h6>\n          <p> La empresa solicitó un anticipo de <strong>{{$ctrl.proyecto.anticipo | number : 2}} Bs.</strong>\n            equivalente al {{$ctrl.proyecto.porcentaje_anticipo}}% del monto del contrato ({{$ctrl.proyecto.monto_total | number : 2}} Bs.).</p>\n\n          <p ng-if=\"$ctrl.supervision.supervisiones_anteriores.length > 0\"> A la fecha la empresa adeuda <strong>{{$ctrl.deudaAnticipo | number :2}} Bs.</strong> por concepto de anticipo pendiente. </p>\n\n          <p> La empresa solicitó el descuento <strong>{{$ctrl.supervision.tipo_descuento_anticipo}}</strong> por concepto de anticipo,\n            mismo que es equivalente a {{$ctrl.desembolso.descuento | number : 2}} Bs.\n            y el monto a desembolsar será <strong>{{$ctrl.desembolso.total | number : 2}} Bs.</strong> para la actual planilla. </p>\n        </section>\n\n        <section ng-if=\"$ctrl.Supervision.esAreaPermitida('FOTOGRAFIAS')\">\n          <h6 class=\"title-section m-top\"> <i class=\"fa fa-photo\"></i> Fotografías de la supervisión </h6>\n          <div class=\"alert alert-info\" ng-if=\"$ctrl.supervision.fotos_supervision.length === 0\">\n            <i class=\"fa fa-info-circle\"></i>\n            <span>Debe sacar fotografías al avance del proyecto con la aplicación móvil.</span>\n          </div>\n          <fotos-supervision fotos=\"$ctrl.supervision.fotos_supervision\" supervision=\"$ctrl.supervision\" ng-if=\"$ctrl.supervision.fotos_supervision.length > 0\"></fotos-supervision>\n          <div class=\"alert alert-info\" ng-if=\"$ctrl.supervision.nro_supervision === 1\">\n            <i class=\"fa fa-exclamation-circle\"></i>\n            <strong>¡ADVERTENCIA!</strong><br>\n            <span>* El usuario supervisor para el envío de las planillas de avance deberá tomar las fotos de supervisión utilizando la aplicación móvil, siendo que se validará la Georeferenciación de estas con respecto a la ubicación del centroide del Municipio, por lo que para esta y las siguientes planillas no le permitirá tomar fotos de una ubicación diferente.</span>\n            <br><span>* Puede verificar la ubicación haciendo click en el botón <i class=\"fa fa-map-marker\"></i> de cada foto.</span>\n          </div>\n        </section>\n\n        <ng-form name=\"formSupervision\">\n          <section ng-if=\"$ctrl.Supervision.esAreaPermitida('INFORME')\">\n            <h6 class=\"title-section m-top\">\n              <i class=\"fa fa-file-text\"></i> Informe técnico de conclusiones\n            </h6>\n            <c-textarea label=\"Breve informe narrativo acerca de la situación del proyecto:\"\n                        name=\"observacion\" ng-model=\"$ctrl.supervision.informe\" rows=\"7\" ng-minlength=\"20\" maxlength=\"3000\"\n                        ng-if=\"$ctrl.Supervision.esEditable('informe') || $ctrl.esTecnico()\" ng-disabled=\"$ctrl.esTecnico()\">\n            </c-textarea>\n            <!-- ng-required=\"true\" -->\n            <p ng-if=\"!$ctrl.Supervision.esEditable('informe')\" style=\"white-space:pre-wrap\" class=\"text-justify\">{{$ctrl.supervision.informe}}</p>\n          </section>\n\n          <section ng-if=\"$ctrl.Supervision.esAreaPermitida('INFORME')\">\n            <h6 class=\"title-section m-top\">\n              <i class=\"fa fa-user\"></i> Mano de obra\n            </h6>\n            <div class=\"col-sm-12 col-md-6\">\n              <c-input-numeric name=\"mano_obra_calificada\"\n                              label=\"Mano de obra calificada\"\n                              ng-model=\"$ctrl.supervision.mano_obra_calificada\"\n                              ng-disabled=\"!$ctrl.Supervision.esEditable('informe')\"\n                              ng-decimals=\"0\"\n                              ng-minvalue=\"0\"\n                              ng-maxvalue=\"999999999999\"\n                              ng-not-number=\"0\"\n                              ng-number-default=\"0\"\n                              >\n              </c-input-numeric>\n              <c-input-numeric name=\"mano_obra_no_calificada\"\n                              label=\"Mano de obra no calificada\"\n                              ng-model=\"$ctrl.supervision.mano_obra_no_calificada\"\n                              ng-disabled=\"!$ctrl.Supervision.esEditable('informe')\"\n                              ng-decimals=\"0\"\n                              ng-minvalue=\"0\"\n                              ng-maxvalue=\"999999999999\"\n                              ng-not-number=\"0\"\n                              ng-number-default=\"0\"\n                              >\n              </c-input-numeric>\n            </div>\n          </section>\n        </ng-form>\n        <div class=\"mt-3\">\n          <small class=\"resaltado\"><strong><em>La presente planilla tiene valor de declaración Jurada, por lo que si se identifica cualquier falsedad, se realizarán las acciones legales respectivas en contra de la empresa constructora infractora.</em></strong></small>\n        </div>\n\n        <ng-form name=\"formSupervision\">\n        <section ng-if=\"$ctrl.permitirVerAreaComprobante()\">\n          <h6 class=\"title-section m-top\"> <i class=\"fa fa-hand-o-right\"></i> Comprobante de Pago </h6>\n          <div class=\"row\">\n            <div class=\"col-md-12 col-lg-6\">\n              <div class=\"row\">\n                <div class=\"md-input-group col-md-6\">\n                  <c-date name=\"fecha_suscripcion_con\" label=\"Fecha de Pago\" ng-model=\"$ctrl.supervision.fecha_pago\"\n                  min-date-key=\"$ctrl.supervision.fecha_creacion\" mensaje-min-date=\"La fecha de pago no debe ser menor a la fecha de la planilla\"\n                  ng-required=\"true\"\n                  ng-disabled=\"$ctrl.supervision.estado_supervision != 'EN_FISCAL_FDI' \"></c-date>\n                </div>\n              </div>\n            </div>\n            <div class=\"col-md-12 col-lg-6\">\n              <archivo name=\"doc_comprobante\" label=\"Comprobante\" ng-model=\"$ctrl.supervision.path_comprobante\"\n                      types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\"\n                      url=\"{{$ctrl.archivos.urlDocComprobantePago}}\"\n                      url-descarga=\"{{$ctrl.archivos.urlDocComprobantePagoDescarga}}\"\n                      cambiar=\"$ctrl.supervision.estado_supervision == 'EN_FISCAL_FDI'\"\n                      modo-vista=\"$ctrl.supervision.estado_supervision != 'EN_FISCAL_FDI'\">\n              </archivo>\n            </div>\n          </div>\n        </section>\n        </ng-form>\n\n        <section ng-if=\"$ctrl.supervision.observacion_proceso.mensaje\">\n          <h6 class=\"title-section error m-top\">\n            <i class=\"fa fa-exclamation-triangle\"></i> Observación\n          </h6>\n          Mensaje: <strong>{{ $ctrl.supervision.observacion_proceso.mensaje }}</strong><br>\n          Observado por: <strong>{{ $ctrl.supervision.observacion_proceso.usuario.persona | nombreUnido }}</strong>\n        </section>\n\n        <div class=\"row my-3 pr-3 justify-content-end\">\n          <button md-effect type=\"button\" class=\"btn mr-3\" ng-click=\"$ctrl.filtroItems === 'PARA_ENVIAR' ? $ctrl.filtroItems = 'TODOS' : $ctrl.filtroItems = 'PARA_ENVIAR'\" ng-if=\"$ctrl.esEtapaEdicion\">\n            <i class=\"fa fa-eye\"></i> {{ $ctrl.filtroItems === 'PARA_ENVIAR' ? 'Ver todo' : 'Ver Planilla a enviar'}}\n          </button>\n          <ejecutar-transicion elemento=\"$ctrl.supervision\"\n                               servicio=\"$ctrl.Supervision\"\n                               form=\"formSupervision\"\n                               atributo-estado=\"estado_supervision\"\n                               url=\"$ctrl.url\"\n                               confirmar=\"true\"\n                               metodo-previo=\"$ctrl.verificarPlanilla()\">\n          </ejecutar-transicion>\n        </div>\n      </div>\n    </div>\n  </div>\n  <!--\n  <br>\n  <div class=\"card\" ng-if=\"$ctrl.supervision\">\n    <div class=\"card-body\">\n      <empresa-anterior supervision=\"$ctrl.supervision\"></empresa-anterior>\n    </div>\n  </div>\n  -->\n</div>\n"

/***/ }),
/* 784 */
755,
/* 785 */
756,
/* 786 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Reporte de Proyectos\n  </h2>\n\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <section>\n        <form name=\"resumen\">\n          <h6 class=\"title-section m-top\">\n            <i class=\"fa fa-file-text-o\"></i> Lista de Proyectos\n          </h6>\n          <div class=\"row\">\n            <div class=\"col-md-4\">\n              <c-select name=\"cartera\" label=\"Cartera\" ng-model=\"$ctrl.carteraSelected\" options=\"$ctrl.carteras\"  key-value=\"id_cartera\" field=\"descripcion\" on-select=\"$ctrl.cambiarGestion()\"></c-select>\n            </div>\n            <div class=\"col-md-4\">\n              <div class=\"alert alert-info\">\n                <i class=\"fa fa-info-circle\"></i>\n                <span>Solo debe seleccionar <strong>Departamento</strong> y <strong>Municipio</strong>.</span>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <c-select-dpa ng-model=\"$ctrl.dpa\" horizontal=\"true\" ></c-select-dpa>\n            </div>\n          </div>\n        </form>\n      </section>\n    </div>\n  </div>\n<!--   <div class=\"card\">\n    <div class=\"row\"> \n        <div class=\"col\"><h5 class=\"card-header\">En evaluación : {{$ctrl.datosEval.length}}</h5></div>\n        <div class=\"col\"><h5 class=\"card-header\">En convenio : {{$ctrl.datosConv.length}}</h5></div>\n        <div class=\"col\"><h5 class=\"card-header\">En desembolso : {{$ctrl.datosDesem.length}}</h5></div>\n        <div class=\"col\"><h5 class=\"card-header\">Aprobados : {{$ctrl.datos.length}}</h5></div>\n        <div class=\"col\"><h5 class=\"card-header\">En ejecución : {{$ctrl.datosEjec.length}}</h5></div>\n    </div>\n  </div> -->\n  <h6 class=\"title-section m-top\" ng-if=\"$ctrl.titulo\">{{$ctrl.titulo}}</h6>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <section ng-if=\"$ctrl.datoslista.length\">\n       <!--  <button class=\"btn btn-sm btn-danger\" ng-click=\"\" uib-tooltip=\"Descargar Reporte\"><i class=\"fa fa-file-pdf-o\"></i></button> -->\n        <button class=\"btn btn-sm btn-danger\" ng-click=\"$ctrl.generarPDF()\" uib-tooltip=\"Descargar Reporte\"><i class=\"fa fa-file-pdf-o\"></i></button>\n        <small>\n          <table id=\"tabla1\" class=\"table table-striped table-hover table-responsive\">\n            <thead>\n              <tr><th colspan=\"10\" class=\"encabezado\"><center><h4 class=\"titulocentral\">{{$ctrl.titulo}}</h4><center></th></tr>\n              <tr>\n                <th class=\"colorcabezera\">Nº</th>\n                <th class=\"colorcabezera\">ENTIDAD EJECUTORA</th>\n                <th class=\"colorcabezera\">NOMBRE DEL PROYECTO</th>\n                <th class=\"colorcabezera\">CARTERA</th>\n                <th class=\"colorcabezera\">CONVENIO</th>\n                <th class=\"colorcabezera\">TIPO</th>\n                <th class=\"colorcabezera\">TIPO FINANCIAMIENTO</th>\n                <!-- <th class=\"colorcabezera\">FAMILIAS BENEFICIADAS</th> -->\n                <th class=\"colorcabezera\">MONTO FDI (Bs.)</th>\n                <th class=\"colorcabezera\">MONTO GAM (Bs.)</th>\n                <th class=\"colorcabezera\">MONTO BENEFICIARIOS (Bs.)</th>\n                <th class=\"colorcabezera\">TOTAL PROYECTO (Bs.)</th>\n                <!-- \n                <th class=\"colorcabezera\">1ER DESEMBOLSO</th>\n                <th class=\"colorcabezera\">FECHA 1ER DESEMBOLSO</th>\n                <th class=\"colorcabezera\">2DO DESEMBOLSO</th>\n                <th class=\"colorcabezera\">FECHA 2DO DESEMBOLSO</th>\n                <th class=\"colorcabezera\">3ER DESEMBOLSO</th>\n                <th class=\"colorcabezera\">FECHA 3ER DESEMBOLSO</th> -->\n                <!-- <th class=\"colorcabezera\">TOTAL TRANSFERIDO FDI (Bs.)</th> -->\n                <!-- <th class=\"colorcabezera\">EJECUCIÓN PRESUPUESTARIA FDI (%)</th> -->\n                \n                <!-- <th class=\"colorcabezera\">AVANCE FÍSICO (%)</th> -->\n                \n                \n               \n\n\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"proy in $ctrl.datoslista\">\n                <td>{{$index + 1}}</td>\n                <td>{{proy.entidad_beneficiaria}}</td>\n                <td>{{proy.nombre}}</td>\n                <td>{{proy.cartera}}</td>\n                <td>{{proy.convenio.nro_convenio}}</td>\n                <td>{{proy.beneficiarios.tipo}}</td>\n                <td>{{proy.beneficiarios.tipo_financiamiento}}</td>\n                <!-- <td>{{proy.beneficiarios.nro_familias}}</td> -->\n                <td>{{proy.financiamiento.monto_fdi | number:2}}</td>\n                <td>{{proy.financiamiento.monto_contraparte | number:2}}</td>\n                <td>{{proy.financiamiento.monto_beneficiarios | number:2}}</td>\n                <td>{{proy.monto_total | number:2}}</td>\n                <!-- <td>{{proy.beneficiarios.tipo_financiamiento}}</td>\n                <td>{{proy.cronograma_desembolsos.monto_1 | number:2}}</td>\n                <td>{{proy.cronograma_desembolsos.fecha_1 | date }}</td>\n                <td>{{proy.cronograma_desembolsos.monto_2 | number:2}}</td>\n                <td>{{proy.cronograma_desembolsos.fecha_2 | date}}</td>\n                <td>{{proy.cronograma_desembolsos.monto_3 | number:2}}</td>\n                <td>{{proy.cronograma_desembolsos.fecha_3 | date}}</td> -->\n                <!-- <td>{{proy.totalTransferido | number:2}}</td> -->\n                <!-- <td>{{proy.ejecuPres | number:0}} %</td> -->\n                \n                <!-- <td>{{proy.avance_fisico}}</td> -->\n                \n                \n              </tr>\n            </tbody>\n            <tfoot>\n              <tr>\n                <td class=\"colorcabezera\"></td>\n                <th class=\"colorcabezera\">TOTAL GENERAL</th>\n                <th class=\"colorcabezera\">&nbsp;</th>\n                <th class=\"colorcabezera\">&nbsp;</th>\n                <th class=\"colorcabezera\">&nbsp;</th>\n                <th class=\"colorcabezera\">&nbsp;</th>\n                <th class=\"colorcabezera\">&nbsp;</th>\n                <!-- <th class=\"colorcabezera\">{{$ctrl.totalesEjec.totalFamilias}}</th> -->\n                <th class=\"colorcabezera\">{{$ctrl.totalesEjec.fdi | number:2}}</th>\n                <th class=\"colorcabezera\">{{$ctrl.totalesEjec.gam | number:2}}</th>\n                <th class=\"colorcabezera\">{{$ctrl.totalesEjec.beneficiarios | number:2}}</th>\n                <!-- <th class=\"colorcabezera\">{{$ctrl.totalesEjec.total | number:2}}</th> -->\n                <!-- <th>{{$ctrl.totalesEjec.ejecucion | number:0}}%</th> -->\n                <!-- <th>{{$ctrl.totalesEjec.avance_fisico | number:2}}%</th> -->\n                <!-- <th class=\"colorcabezera\">&nbsp;</th>\n                <th class=\"colorcabezera\">&nbsp;</th> -->\n                <!-- <th class=\"colorcabezera\">{{$ctrl.totalesEjec.primer_desembolso | number:2}}</th> -->\n                <!-- <th class=\"colorcabezera\">&nbsp;</th> -->\n                <!-- <th class=\"colorcabezera\">{{$ctrl.totalesEjec.segundo_desembolso | number:2}}</th> -->\n                <!-- <th class=\"colorcabezera\">&nbsp;</th> -->\n                <!-- <th class=\"colorcabezera\">{{$ctrl.totalesEjec.tercer_desembolso | number:2}}</th> -->\n                <!-- <th class=\"colorcabezera\">{{$ctrl.totalesEjec.transferidos | number:2}}</th> -->\n                <th class=\"colorcabezera\">&nbsp;</th>\n                <!-- <th class=\"colorcabezera\">&nbsp;</th> -->\n              </tr>\n              <tr><td colspan=\"2\" class=\"encabezado\">{{$ctrl.fechaRep}} - Fuente: SISPRO</td></tr>\n            </tfoot>\n          </table>\n        </small>\n      </section>\n    </div>\n  </div>\n<hr>\n\n\n</div>\n"

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n\t<h2 class=\"page-title\">\n\t\t<i class=\"fa fa-bars\"></i> Reporte convenios\n\t</h2>\n\t<div class=\"card\">\n\t\t<div class=\"card-body\">\n\t\t\t<h6 class=\"title-section m-top\">\n\t\t\t\t<i class=\"fa fa-filter\"></i> Filtrar\n\t\t\t</h6>\n\t\t\t<form name =\"resumen\">\n\t\t\t\t<div class=\"col-md-12\">\n\t\t\t\t\t<c-select-dpa ng-model=\"$ctrl.dpa\" horizontal=\"true\" ></c-select-dpa>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-3\">\n\t\t\t\t\t<c-select name=\"cartera\" label=\"Cartera\" ng-model=\"$ctrl.carteraSelected\" options=\"$ctrl.carteras\"  key-value=\"id_cartera\" field=\"descripcion\" ng-disabled=\"false\"></c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-3\">\n\t\t\t\t\t<button md-effect class=\"btn btn-outline-info\" ng-click=\"$ctrl.buscar($ctrl.dpa,$ctrl.carteraSelected)\"><i class=\"fa fa-search\"></i> Buscar</button>\n\t\t\t\t\t<hr ng-if=\"$ctrl.datos.length\">\n\t\t\t\t\t <div class=\"alert alert-info\" role=\"alert\" ng-if=\"$ctrl.datos.length > 1\">\n\t\t\t\t\t\t<i class=\"fa fa-info-circle\"></i> Se han encontrado {{$ctrl.datos.length}} registros.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t</form>\n\n\t\t</div>\n\t</div>\n\n\t<div class=\"card\" ng-if=\"$ctrl.datos.length\">\n\t\t<div class=\"card-body\">\n\t\t\t<section>\n\t\t\t\t<h6 class=\"title-section m-top\"><i class=\"fa fa-table\"></i></h6>\n\t\t\t\t<button class=\"btn btn-sm btn-danger\" ng-click=\"$ctrl.generarPDF()\" uib-tooltip=\"Descargar Reporte\"><i class=\"fa fa-file-pdf-o\"></i></button>\n\t\t\t<small>\n\n\t\t\t<table id=\"tabla1\" class=\"table table-striped table-hover table-responsive\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr><th colspan=\"12\" class=\"encabezado\"><center><h4 class=\"titulocentral\">{{$ctrl.titulo}}</h4><center></th>\n\t\t\t\t\t<th colspan=\"2\" class=\"encabezado\"><center><h4 class=\"titulocentral\" style=\"opacity:.2\">Fuente Sispro</h4><center></th></tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"colorcabezera\">Nº</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">Nº CONVENIO</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">NOMBRE DEL PROYECTO</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">FECHA SUSCRIPCION</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">FECHA INICIO</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">PLAZO CONV.</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 1</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 2</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 3</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 4</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 5</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 6</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 7</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 8</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 9</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 10</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 11</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 12</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 13</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">ADENDA 14</th>\n\t\t\t\t\t\t<th class=\"colorcabezera\">FECHA CONCLUSION</th>\n\t\t\t\t\t\t<!-- <th class=\"colorcabezera\">ESTADO</th> -->\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat=\"proy in $ctrl.datos\">\n\t\t\t\t\t\t<td>{{$index + 1}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.nro_convenio}}</td>\n\t\t\t\t\t\t<td>{{proy.nombre}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.fecha_suscripcion | date}}</td>\n\t\t\t\t\t\t<td>{{proy.orden_proceder | date}}</td>\n\t\t\t\t\t\t<td>{{proy.plazo_ejecucion}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado2}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado3}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado4}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado5}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado6}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado7}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado8}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado9}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado10}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado11}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado12}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado13}}</td>\n\t\t\t\t\t\t<td>{{proy.convenio.plazo_convenio_ampliado14}}</td>\n\t\t\t\t\t\t<td>{{proy.fconclusion | date}}</td>\n\t\t\t\t\t\t<!-- <td>{{proy.estado_proyecto}}</td> -->\n\t\t\t\t\t</tr>\n\t\t\t\t\t\n\t\t\t\t</tbody>\n\t\t\t\t<tfoot>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr><td class=\"encabezado\" colspan=\"2\">{{$ctrl.fechaRep}}</span>\n\t\t\t\t\t</td></tr>\n\t\t\t\t</tfoot>\n\n\t\t\t</table>\n\t\t\t</small>\n\t\t\t</section>\n\t\t</div>\n\t</div>\n</div>"

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyectos por Municipio\n  </h2>\n\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <section>\n        <form name=\"resumen\">\n          <h6 class=\"title-section m-top\">\n            <i class=\"fa fa-file-text-o\"></i> CARTERA {{$ctrl.carteraSelected}}\n          </h6>\n          <div class=\"row\">\n            <div class=\"col-md-4\">\n              <c-select name=\"cartera\" label=\"Cartera\" ng-model=\"$ctrl.carteraSelected\" options=\"$ctrl.carteras\"  key-value=\"id_cartera\" field=\"descripcion\" on-select=\"$ctrl.cambiarGestion()\"></c-select>\n            </div>\n            <div class=\"col-md-4\">\n              <div class=\"alert alert-info\">\n                <i class=\"fa fa-info-circle\"></i>\n                <span>Solo debe seleccionar <strong>Departamento</strong> y <strong>Municipio</strong>.</span>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <c-select-dpa ng-model=\"$ctrl.dpa\" horizontal=\"true\" ></c-select-dpa>\n            </div>\n          </div>\n        </form>\n      </section>\n    </div>\n  </div>\n  <div class=\"card\">\n    <div class=\"row\"> \n        <div class=\"col\"><h5 class=\"card-header\">En evaluación : {{$ctrl.datosEval.length}}</h5></div>\n        <div class=\"col\"><h5 class=\"card-header\">En convenio : {{$ctrl.datosConv.length}}</h5></div>\n        <div class=\"col\"><h5 class=\"card-header\">En desembolso : {{$ctrl.datosDesem.length}}</h5></div>\n        <div class=\"col\"><h5 class=\"card-header\">Aprobados : {{$ctrl.datos.length}}</h5></div>\n        <div class=\"col\"><h5 class=\"card-header\">En ejecución : {{$ctrl.datosEjec.length}}</h5></div>\n    </div>\n  </div>\n  <h6 class=\"title-section m-top\" ng-if=\"$ctrl.titulo\">{{$ctrl.titulo}}</h6>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <section ng-if=\"$ctrl.datosEval.length\">\n        <h6 class=\"title-section m-top\">PROYECTOS EN EVALUACIÓN : {{$ctrl.datosEval.length}}</h6>\n        <small>\n          <table class=\"table table-striped table-hover table-responsive\">\n            <thead>\n              <tr>\n                <th></th>\n                <th>NOMBRE DEL PROYECTO</th>\n                <th>TOTAL PROYECTO (Bs.)</th>\n                <th>MONTO FDI (Bs.)</th>\n                <th>MONTO GAM (Bs.)</th>\n                <th>MONTO BENEFICIARIOS (Bs.)</th>\n                <th>EJECUCIÓN PRESUPUESTARIA FDI (%)</th>\n                <th>AVANCE FÍSICO (%)</th>\n                <th>FECHA INICIO</th>\n                <th>PLAZO DE CONVENIO</th>\n                <th>FECHA DE CONCLUSIÓN</th>\n                <th>ESTADO</th>\n              </tr>\n            </thead>\n            <tbody ng-repeat=\"proy in $ctrl.datosEval\">\n              <tr>\n                <td><button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.verProyecto(proy)\"><i class=\"fa fa-eye\"></i></button></td>\n                <td>{{proy.nombre}}</td>\n                <td>{{proy.financiamiento.monto_total_proyecto | number:2}}</td>\n                <td>{{proy.financiamiento.monto_fdi | number:2}}</td>\n                <td>{{proy.financiamiento.monto_contraparte | number:2}}</td>\n                <td>{{proy.financiamiento.monto_beneficiarios | number:2}}</td>\n                <td>{{0 | number:0}} %</td>\n                <td>{{0}} %</td>\n                <td>{{''}}</td>\n                <td>{{proy.plazo_ejecucion | number}}</td>\n                <td>{{''}}</td>\n                <td>{{proy.estado_proyecto}}</td>\n              </tr>\n            </body>\n            <tfoot>\n              <tr>\n                <td></td>\n                <th>TOTAL GENERAL</th>\n                <th>{{$ctrl.totalesEval.total | number:2}}</th>\n                <th>{{$ctrl.totalesEval.fdi | number:2}}</th>\n                <th>{{$ctrl.totalesEval.gam | number:2}}</th>\n                <th>{{$ctrl.totalesEval.beneficiarios | number:2}}</th>\n                <th>{{$ctrl.totalesEval.ejecucion | number:2}}%</th>\n                <th>{{$ctrl.totalesEval.avance_fisico | number:2}}%</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n              </tr>\n            </tfoot>\n          </table>\n        </small>\n      </section>\n\n    </div>\n  </div>\n\n\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <section ng-if=\"$ctrl.datosConv.length\">\n        <h6 class=\"title-section m-top\">PROYECTOS EN REGISTRO CONVENIO : {{$ctrl.datosConv.length}}</h6>\n        <small>\n          <table class=\"table table-striped table-hover table-responsive\">\n            <thead>\n              <tr>\n                <th></th>\n                <th>NOMBRE DEL PROYECTO</th>\n                <th>TOTAL PROYECTO (Bs.)</th>\n                <th>MONTO FDI (Bs.)</th>\n                <th>MONTO GAM (Bs.)</th>\n                <th>MONTO BENEFICIARIOS (Bs.)</th>\n                <th>EJECUCIÓN PRESUPUESTARIA FDI (%)</th>\n                <th>AVANCE FÍSICO (%)</th>\n                <th>FECHA INICIO</th>\n                <th>PLAZO DE CONVENIO</th>\n                <th>FECHA DE CONCLUSIÓN</th>\n                <th>ESTADO</th>\n              </tr>\n            </thead>\n            <tbody ng-repeat=\"proy in $ctrl.datosConv\">\n              <tr>\n                <td><button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.verProyecto(proy)\"><i class=\"fa fa-eye\"></i></button><button class=\"btn btn-sm btn-primary\" ng-hide=\"true\" ng-click=\"$ctrl.fichaProyecto(proy)\" title=\"Ficha Tecnica\"><i class=\"fa fa-file-pdf-o\"></i></button></td>\n                <td>{{proy.nombre}}</td>\n                <td>{{proy.financiamiento.monto_total_proyecto | number:2}}</td>\n                <td>{{proy.financiamiento.monto_fdi | number:2}}</td>\n                <td>{{proy.financiamiento.monto_contraparte | number:2}}</td>\n                <td>{{proy.financiamiento.monto_beneficiarios | number:2}}</td>\n                <td>{{0 | number:0}} %</td>\n                <td>{{0}} %</td>\n                <td>{{''}}</td>\n                <td>{{proy.plazo_ejecucion | number}}</td>\n                <td>{{''}}</td>\n                <td>{{proy.estado_proyecto}}</td>\n              </tr>\n            </body>\n            <tfoot>\n              <tr>\n                <td></td>\n                <th>TOTAL GENERAL</th>\n                <th>{{$ctrl.totalesConv.total | number:2}}</th>\n                <th>{{$ctrl.totalesConv.fdi | number:2}}</th>\n                <th>{{$ctrl.totalesConv.gam | number:2}}</th>\n                <th>{{$ctrl.totalesConv.beneficiarios | number:2}}</th>\n                <th>{{$ctrl.totalesConv.ejecucion | number:2}}%</th>\n                <th>{{$ctrl.totalesConv.avance_fisico | number:2}}%</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n              </tr>\n            </tfoot>\n          </table>\n        </small>\n      </section>\n    </div>\n  </div>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <section ng-if=\"$ctrl.datosDesem.length\">\n        <h6 class=\"title-section m-top\">PROYECTOS EN REGISTRO DESEMBOLSO : {{$ctrl.datosDesem.length}}</h6>\n        <small>\n          <table class=\"table table-striped table-hover table-responsive\">\n            <thead>\n              <tr>\n                <th></th>\n                <th>NOMBRE DEL PROYECTO</th>\n                <th>TOTAL PROYECTO (Bs.)</th>\n                <th>MONTO FDI (Bs.)</th>\n                <th>MONTO GAM (Bs.)</th>\n                <th>MONTO BENEFICIARIOS (Bs.)</th>\n                <th>EJECUCIÓN PRESUPUESTARIA FDI (%)</th>\n                <th>AVANCE FÍSICO (%)</th>\n                <th>FECHA INICIO</th>\n                <th>PLAZO DE CONVENIO</th>\n                <th>FECHA DE CONCLUSIÓN</th>\n                <th>ESTADO</th>\n              </tr>\n            </thead>\n            <tbody ng-repeat=\"proy in $ctrl.datosDesem\">\n              <tr>\n                <td><button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.verProyecto(proy)\"><i class=\"fa fa-eye\"></i></button><button class=\"btn btn-sm btn-primary\" ng-hide=\"true\" ng-click=\"$ctrl.fichaProyecto(proy)\" title=\"Ficha Tecnica\"><i class=\"fa fa-file-pdf-o\"></i></button></td>\n                <td>{{proy.nombre}}</td>\n                <td>{{proy.financiamiento.monto_total_proyecto | number:2}}</td>\n                <td>{{proy.financiamiento.monto_fdi | number:2}}</td>\n                <td>{{proy.financiamiento.monto_contraparte | number:2}}</td>\n                <td>{{proy.financiamiento.monto_beneficiarios | number:2}}</td>\n                <td>{{0 | number:0}} %</td>\n                <td>{{0}} %</td>\n                <td>{{''}}</td>\n                <td>{{proy.plazo_ejecucion | number}}</td>\n                <td>{{''}}</td>\n                <td>{{proy.estado_proyecto}}</td>\n              </tr>\n            </body>\n            <tfoot>\n              <tr>\n                <td></td>\n                <th>TOTAL GENERAL</th>\n                <th>{{$ctrl.totalesDesem.total | number:2}}</th>\n                <th>{{$ctrl.totalesDesem.fdi | number:2}}</th>\n                <th>{{$ctrl.totalesDesem.gam | number:2}}</th>\n                <th>{{$ctrl.totalesDesem.beneficiarios | number:2}}</th>\n                <th>{{$ctrl.totalesDesem.ejecucion | number:2}}%</th>\n                <th>{{$ctrl.totalesDesem.avance_fisico | number:2}}%</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n              </tr>\n            </tfoot>\n          </table>\n        </small>\n      </section>\n    </div>\n  </div>\n\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <section ng-if=\"$ctrl.datos.length\">\n        <h6 class=\"title-section m-top\">PROYECTOS APROBADOS : {{$ctrl.datos.length}}</h6>\n        <small>\n          <table class=\"table table-striped table-hover table-responsive\">\n            <thead>\n              <tr>\n                <th></th>\n                <th>NOMBRE DEL PROYECTO</th>\n                <th>TOTAL PROYECTO (Bs.)</th>\n                <th>MONTO FDI (Bs.)</th>\n                <th>MONTO GAM (Bs.)</th>\n                <th>MONTO BENEFICIARIOS (Bs.)</th>\n                <th>EJECUCIÓN PRESUPUESTARIA FDI (%)</th>\n                <th>AVANCE FÍSICO (%)</th>\n                <th>FECHA INICIO</th>\n                <th>PLAZO DE CONVENIO</th>\n                <th>FECHA DE CONCLUSIÓN</th>\n                <th>ESTADO</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"proy in $ctrl.datos\">\n                <td>\n                  <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.verProyecto(proy)\"><i class=\"fa fa-eye\"></i></button>\n                  <button class=\"btn btn-sm btn-primary\" ng-hide=\"true\" ng-click=\"$ctrl.fichaProyecto(proy)\" title=\"Ficha Tecnica\"><i class=\"fa fa-file-pdf-o\"></i></button>\n                </td>\n                <td>{{proy.nombre}}</td>\n                <td>{{proy.financiamiento.monto_total_proyecto | number:2}}</td>\n                <td>{{proy.financiamiento.monto_fdi | number:2}}</td>\n                <td>{{proy.financiamiento.monto_contraparte | number:2}}</td>\n                <td>{{proy.financiamiento.monto_beneficiarios | number:2}}</td>\n                <td>{{0 | number:0}} %</td>\n                <td>{{0}} %</td>\n                <td>{{proy.orden_proceder | date}}</td>\n                <td>{{proy.plazo_ejecucion | number}}</td>\n                <td>{{''}}</td>\n                <td>{{proy.estado_proyecto}}</td>\n              </tr>\n            </body>\n            <tfoot>\n              <tr>\n                <th></th>\n                <th>TOTAL GENERAL</th>\n                <th>{{$ctrl.totales.total | number:2}}</th>\n                <th>{{$ctrl.totales.fdi | number:2}}</th>\n                <th>{{$ctrl.totales.gam | number:2}}</th>\n                <th>{{$ctrl.totales.beneficiarios | number:2}}</th>\n                <th>{{$ctrl.totales.ejecucion | number:2}}%</th>\n                <th>{{$ctrl.totales.avance_fisico | number:2}}%</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n              </tr>\n            </tfoot>\n          </table>\n        </small>\n      </section>\n    </div>\n  </div>\n\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <section ng-if=\"$ctrl.datosEjec.length\">\n        <h6 class=\"title-section m-top\">PROYECTOS EN EJECUCION : {{$ctrl.datosEjec.length}}</h6>\n        <small>\n          <table class=\"table table-striped table-hover table-responsive\">\n            <thead>\n              <tr>\n                <th></th>\n                <th>NOMBRE DEL PROYECTO</th>\n                <th>TOTAL PROYECTO (Bs.)</th>\n                <th>MONTO FDI (Bs.)</th>\n                <th>MONTO GAM (Bs.)</th>\n                <th>MONTO BENEFICIARIOS (Bs.)</th>\n                <th>EJECUCIÓN PRESUPUESTARIA FDI (%)</th>\n                <th>AVANCE FÍSICO (%)</th>\n                <th>FECHA INICIO</th>\n                <th>PLAZO DE CONVENIO</th>\n                <th>FECHA DE CONCLUSIÓN</th>\n                <th>ESTADO</th>\n              </tr>\n            </thead>\n            <tbody ng-repeat=\"proy in $ctrl.datosEjec\">\n              <tr>\n                <td><button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.verProyecto(proy)\"><i class=\"fa fa-eye\"></i></button><button class=\"btn btn-sm btn-primary\" ng-hide=\"true\"ng-click=\"$ctrl.fichaProyecto(proy)\" title=\"Ficha Tecnica\"><i class=\"fa fa-file-pdf-o\"></i></button></td>\n                <td>{{proy.nombre}}</td>\n                <td>{{proy.financiamiento.monto_total_proyecto | number:2}}</td>\n                <td>{{proy.financiamiento.monto_fdi | number:2}}</td>\n                <td>{{proy.financiamiento.monto_contraparte | number:2}}</td>\n                <td>{{proy.financiamiento.monto_beneficiarios | number:2}}</td>\n                <td>{{proy.ejecuPres | number:2}} %</td>\n                <td>{{proy.avance_fisico}}</td>\n                <td>{{proy.orden_proceder | date}}</td>\n                <td>{{proy.plazo_ejecucion | number}}</td>\n                <td>{{proy.fecha_conclusion | date}}</td>\n                <td>{{proy.estado_proyecto}}</td>\n              </tr>\n            </body>\n            <tfoot>\n              <tr>\n                <td></td>\n                <th>TOTAL GENERAL</th>\n                <th>{{$ctrl.totalesEjec.total | number:2}}</th>\n                <th>{{$ctrl.totalesEjec.fdi | number:2}}</th>\n                <th>{{$ctrl.totalesEjec.gam | number:2}}</th>\n                <th>{{$ctrl.totalesEjec.beneficiarios | number:2}}</th>\n                <th>{{$ctrl.totalesEjec.ejecucion | number:2}}%</th>\n                <th>{{$ctrl.totalesEjec.avance_fisico | number:2}}%</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n                <th>&nbsp;</th>\n              </tr>\n            </tfoot>\n          </table>\n        </small>\n      </section>\n    </div>\n  </div>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <section ng-if=\"$ctrl.datosRechazados.length\">\n        <h6 class=\"title-section m-top\">PROYECTOS RECHAZADOS</h6>\n        <small>\n          <table class=\"table table-striped table-hover table-responsive\">\n            <!-- <thead> -->\n              <tr>\n                <th></th>\n                <th>NOMBRE DEL PROYECTO</th>\n                <th>TOTAL PROYECTO (Bs.)</th>\n                <th>MONTO FDI (Bs.)</th>\n                <th>MONTO GAM (Bs.)</th>\n                <th>MONTO BENEFICIARIOS (Bs.)</th>\n                <th>EJECUCIÓN PRESUPUESTARIA FDI (%)</th>\n                <th>AVANCE FÍSICO (%)</th>\n                <th>FECHA INICIO</th>\n                <th>PLAZO DE CONVENIO</th>\n                <th>FECHA DE CONCLUSIÓN</th>\n                <th>ESTADO</th>\n              </tr>\n            <!-- </thead> -->\n            <!-- <tbody> -->\n              <tr ng-repeat=\"proy in $ctrl.datosRechazados\">\n                <th></th>\n                <td><button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.verProyecto(proy)\"><i class=\"fa fa-eye\"></i></button></td>\n                <td>{{proy.nombre}}</td>\n                <td>{{proy.financiamiento.monto_total_proyecto | number:2}}</td>\n                <td>{{proy.financiamiento.monto_fdi | number:2}}</td>\n                <td>{{proy.financiamiento.monto_contraparte | number:2}}</td>\n                <td>{{proy.financiamiento.monto_beneficiarios | number:2}}</td>\n                <td>{{0 | number:0}} %</td>\n                <td>{{0}} %</td>\n                <td>{{''}}</td>\n                <td>{{proy.plazo_ejecucion | number}}</td>\n                <td>{{''}}</td>\n                <td>{{proy.estado_proyecto}}</td>\n              </tr>\n            <!-- </body> -->\n          </table>\n        </small>\n      </section>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Mis proyectos\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n\n      <div class=\"btn-container d-flex flex-row\">\n        <button class=\"btn btn-{{boton.md}} boton-circular-mediano p-2\" md-effect type=\"button\"\n          ng-click=\"$ctrl.eventoOpcion($event, boton)\" uib-tooltip=\"{{boton.tooltip}}\"\n          ng-if=\"$ctrl.config.opciones\" ng-repeat=\"boton in $ctrl.config.opciones\">\n          <i class=\"fa fa-{{boton.icon}}\"></i>\n        </button>\n      </div>\n\n      <div class=\"crud-table\" ng-table=\"$ctrl.tableParams\">\n        <table class=\"table table-striped table-hover ng-table table-responsive\">\n          <tr ng-repeat=\"proyecto in $data track by proyecto.id_proyecto\">\n            <td data-title=\"''\" >\n              <button md-effect type=\"button\" class=\"btn btn-{{boton.md}} btn-sm mt-1\"\n                ng-click=\"$ctrl.eventoOpcion($event, boton, proyecto)\" uib-tooltip=\"{{boton.tooltip}}\"\n                ng-if=\"$ctrl.config.acciones\" ng-repeat=\"boton in $ctrl.config.acciones\">\n                <i class=\"fa fa-{{boton.icon}}\"></i>\n              </button>\n\n              <button md-effect type=\"button\" class=\"btn btn-primary btn-sm mt-1\"\n                ng-click=\"$ctrl.verUsuarios(proyecto)\" uib-tooltip=\"Usuarios\" ng-if=\"$ctrl.esJefeRevision()\">\n                <i class=\"fa fa-user\"></i>\n              </button>\n              <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\" ng-if=\"$ctrl.puedeVerConsolidado(proyecto)\" uib-tooltip=\"Planilla Consolidada\" download-file=\"{{$ctrl.urlPlanillaConsolidada(proyecto)}}\"  file-name=\"Planilla Consolidada\">\n                <i class=\"fa fa-list-alt\"></i>\n              </button>\n              <lista-supervisiones proyecto=\"proyecto\" ng-if=\"$ctrl.puedeVerSupervision(proyecto)\"></lista-supervisiones>\n\n              <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\"\n                ng-click=\"$ctrl.irAModificaciones(proyecto)\" uib-tooltip=\"Modificaciones\"\n                ng-if=\"$ctrl.puedeVerModificaciones(proyecto)\">\n                <i class=\"fa fa-medium\"></i>\n              </button>\n              <!--lista-modificaciones proyecto=\"proyecto\" ng-if=\"$ctrl.puedeVerModificacion(proyecto)\"></lista-modificaciones-->\n              <button-paralizar proyecto=\"proyecto\" ng-if=\"$ctrl.puedeParalizar(proyecto)\"></button-paralizar>\n              <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\"\n                ng-click=\"$ctrl.fdiCrearProyectoModificado(proyecto)\" uib-tooltip=\"Modificar Proyecto\"\n                ng-if=\"proyecto.estado_proyecto === 'RECHAZADO_FDI' && $ctrl.puedeReferenciarProyecto(proyecto)\">\n                <i class=\"fa fa-share-square\"></i>\n              </button>\n            </td>\n            <td data-title=\"'Códigoow'\" filter=\"{nro_convenio: 'text'}\" sortable=\"'nro_convenio'\">{{proyecto.nro_convenio}}</td>\n            <!-- <td data-title=\"'Referencia'\" filter=\"{'beneficiarios.referencia': 'text'}\" sortable=\"'beneficiarios.referencia'\">{{proyecto.beneficiarios.referencia}}</td> -->\n            <!-- <td data-title=\"'Referencia'\">{{proyecto.beneficiarios.referencia}}</td> -->\n            <td data-title=\"'Cartera'\" filter=\"{cartera: 'text'}\">{{proyecto.cartera}}</td>\n            <td data-title=\"'Nombre'\" filter=\"{nombre: 'text'}\" sortable=\"'nombre'\">{{proyecto.nombre}}</td>\n            <!-- <td data-title=\"'Tipo'\" filter=\"{tipo: 'text'}\" sortable=\"'tipo'\">{{proyecto.tipo_proyecto.nombre}}</td> -->\n            <td data-title=\"'Monto total'\" filter=\"{monto_total: 'text'}\" sortable=\"'monto_total'\">{{proyecto.monto_total | formatDecimal}}</td>\n            <!-- <td data-title=\"'Departamento'\" filter=\"{'departamento.nombre': 'text'}\">{{proyecto.municipio.provincia.departamento.nombre}}</td> -->\n            <td data-title=\"'Departamento'\" filter=\"{'departamento.nombre': 'filtro-departamento'}\">{{proyecto.municipio.provincia.departamento.nombre}}</td>\n            <td data-title=\"'Municipio'\" filter=\"{'municipio.nombre': 'text'}\">{{proyecto.municipio.nombre}}</td>\n            <td data-title=\"'Plazo ejecución'\" filter=\"{plazo_ejecucion: 'text'}\" sortable=\"'plazo_ejecucion'\">{{proyecto.plazo_ejecucion | formatDecimal}}</td>\n            <td data-title=\"'Vencimiento. Conv.'\" filter1=\"{'finPlazoC': 'text'} \"sortable=\"'monto_total'\">{{proyecto.finPlazoC}}</td>\n            <!-- <td data-title=\"'Código de acceso'\" filter=\"{codigo_acceso: 'text'}\" sortable=\"'codigo_acceso'\">{{proyecto.codigo_acceso}}</td> -->\n            <td data-title=\"'Estado Proyecto'\" filter=\"{estado_proyecto: 'text'}\" sortable=\"'estado_proyecto'\">{{proyecto.estado_actual.nombre}}</td>\n            <td data-title=\"'Estado Supervisión'\" filter=\"{'supervisiones.estado_actual.nombre': 'text'}\" sortable=\"'supervisiones.estado_actual.nombre'\">\n              <div ng-repeat=\"supervision in proyecto.supervisiones\">\n                <div ng-if=\"supervision.estado_actual.codigo!=='EN_ARCHIVO_FDI'\">\n                  <strong class=\"resaltado\">PLANILLA: {{supervision.nro_supervision}}</strong><br>\n                  {{supervision.estado_actual.nombre}} <br>\n                  <span ng-if=\"supervision.observacion_proceso.mensaje\" class=\"text-danger\"> {{ supervision.observacion_proceso.mensaje }} </span>\n                </div>\n              </div>\n            </td>\n            <td data-title=\"'Tecnico responsable FDI'\" filter1=\"{'usuario.persona.nombres': 'text'}\">{{proyecto.usuario.persona.nombres}} {{proyecto.usuario.persona.primer_apellido}} {{proyecto.usuario.persona.segundo_apellido}}</td>\n          </tr>\n        </table>\n      </div>\n\n    </div>\n  </div>\n</div>\n<!-- filtro departamento -->\n    <script type=\"text/ng-template\" id=\"ng-table/filters/filtro-departamento.html\">\n    <select ng-model=\"params.filter()[name]\">\n      <option value = \"\">todos</option>\n      <option value = \"chuquisaca\">Chuquisaca</option>\n      <option value = \"la paz\">La Paz</option>\n      <option value = \"cochabamba\">Cochabamba</option>\n      <option value = \"oruro\">Oruro</option>\n      <option value = \"potosi\">Potosi</option>\n      <option value = \"tarija\">Tarija</option>\n      <option value = \"santa cruz\">Santa Cruz</option>\n      <option value = \"beni\">Beni</option>\n      <option value = \"pando\">Pando</option>\n    </select>\n"

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Modificaciones\" ng-click=\"$ctrl.verModificaciones()\">\n  <i class=\"fa fa-medium\"></i>\n</button>\n"

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Paralizar Proyecto\" ng-click=\"$ctrl.verMensaje()\">\n  <i class=\"fa fa-ban\"></i>\n</button>\n"

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-ban\"></i> {{$ctrl.proyecto.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n\n<div class=\"modal-body\">\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.existeSupervisionesEnCurso\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>No puede realizar modificaciones mientras existan supervisiones en curso de aprobación.</span>\n  </div>\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.proyecto.estado_proyecto === 'CERRADO_FDI'\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>No puede realizar modificaciones en un proyecto concluído.</span>\n  </div>\n  <section ng-if=\"!$ctrl.existeSupervisionesEnCurso && $ctrl.proyecto.estado_proyecto !== 'CERRADO_FDI'\">\n    <div class=\"alert alert-primary\">\n      <div>\n        <i class=\"fa fa-exclamation-triangle\"></i>\n        <strong>¿Está seguro/a de paralizar el proyecto?</strong>\n        <ul>\n          <li>Se generará un nuevo código de acceso al proyecto, para la adjudicación de una nueva empresa.</li>\n          <li>Se le informa que una vez paralizado el proyecto, el mismo estará en estado de adjudicación hasta que se estipule una nueva fecha de Orden de Proceder del proyecto.</li>\n        </ul>\n      </div>\n    </div>\n  </section>\n</div>\n\n<div class=\"modal-footer\">\n  <div ng-if=\"!$ctrl.existeSupervisionesEnCurso && $ctrl.proyecto.estado_proyecto !== 'CERRADO_FDI'\">\n    <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n      <i class=\"fa fa-check\"></i> Cancelar\n    </button>\n    <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.paralizarProyecto()\">\n      <i class=\"fa fa-check\"></i> Si, estoy seguro/a\n    </button>\n  </div>\n  <div ng-if=\"$ctrl.existeSupervisionesEnCurso || $ctrl.proyecto.estado_proyecto === 'CERRADO_FDI'\">\n    <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n      <i class=\"fa fa-check\"></i> Cerrar\n    </button>\n  </div>\n</div>\n"

/***/ }),
/* 793 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyectos pendientes\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n\n      <div class=\"crud-table\" ng-table=\"$ctrl.tableParams\" ng-table-columns-binding=\"columnas\">\n        <table class=\"table table-striped table-hover ng-table table-responsive\">\n          <tr ng-repeat=\"proyecto in $data track by proyecto.id_proyecto\">\n            <td data-title=\"'Acciones'\">\n              <button md-effect type=\"button\" class=\"btn btn-{{acciones.md}} btn-sm\" ng-repeat=\"acciones in $ctrl.config.acciones\"\n                uib-tooltip=\"{{acciones.tooltip}}\" ng-click=\"acciones.metodo(proyecto)\" ng-if=\"$ctrl.puedeProcesarProyecto(proyecto)\">\n                <i class=\"fa fa-{{acciones.icon}}\"></i>\n              </button>\n\n              <button md-effect type=\"button\" class=\"btn btn-{{acciones.md}} btn-sm mt-1\" ng-repeat=\"acciones in $ctrl.configSupervisiones.acciones\"\n                uib-tooltip=\"{{acciones.tooltip}}\" ng-click=\"acciones.metodo(proyecto)\"\n                ng-if=\"proyecto.estado_proyecto === 'APROBADO_FDI' && proyecto.supervisiones && proyecto.supervisiones.length > 0 && (acciones.condicion ? acciones.condicion(proyecto) : true)\">\n                <i class=\"fa fa-{{acciones.icon}}\"></i>\n              </button>\n\n              <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\"\n                ng-click=\"$ctrl.nuevaPlanilla(proyecto)\" uib-tooltip=\"Crear Planilla\"\n                ng-if=\"(proyecto.estado_proyecto === 'APROBADO_FDI' || proyecto.estado_proyecto === 'EN_EJECUCION_FDI' || proyecto.estado_proyecto === 'REVISION_SEGUIMIENTO_FDI' || proyecto.estado_proyecto === 'ASIGNACION_TECNICO_CIERRE_FDI'  || proyecto.estado_proyecto === 'EN_CIERRE_FDI') && $ctrl.Usuarios.esSupervisor() && $ctrl.puedeCrearPlanilla(proyecto)\">\n                <i class=\"fa fa-plus\"></i>\n              </button>\n\n              <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\"\n                ng-click=\"$ctrl.irAModificaciones(proyecto)\" uib-tooltip=\"Modificaciones\"\n                ng-if=\"(proyecto.estado_proyecto === 'EN_EJECUCION_FDI' || proyecto.estado_proyecto === 'REVISION_SEGUIMIENTO_FDI' || proyecto.estado_proyecto === 'ASIGNACION_TECNICO_CIERRE_FDI'  || proyecto.estado_proyecto === 'EN_CIERRE_FDI') && $ctrl.puedeVerModificaciones(proyecto)\">\n                <i class=\"fa fa-medium\"></i>\n              </button>\n              <!-- ya no debe generar planilla consolidada -->\n              <!-- \n              <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\" ng-if=\"$ctrl.puedeVerConsolidado(proyecto)\" uib-tooltip=\"Planilla Consolidada\" download-file=\"{{$ctrl.urlPlanillaConsolidada(proyecto)}}\" file-name=\"Planilla Consolidada\">\n                <i class=\"fa fa-list-alt\"></i>\n              </button>\n              -->\n\n              <lista-supervisiones proyecto=\"proyecto\" ng-if=\"$ctrl.puedeVerSupervision(proyecto)\"></lista-supervisiones>\n\n              <!--lista-modificaciones proyecto=\"proyecto\" ng-if=\"$ctrl.puedeVerModificacion(proyecto)\"></lista-modificaciones-->\n            </td>\n            <td data-title=\"'Código'\" filter=\"{nro_convenio: 'text'}\" sortable=\"'nro_convenio'\">{{proyecto.nro_convenio}}</td>\n            <!-- <td data-title=\"'Referencia'\" filter=\"{'formulario.beneficiarios.form_model': 'text'}\" sortable=\"'formulario.beneficiarios.form_model'\">{{proyecto.beneficiarios.referencia}}</td> -->\n            <!-- <td data-title=\"'Referencia'\">{{proyecto.beneficiarios.referencia}}</td> -->\n            <td data-title=\"'Nombre'\" filter=\"{'nombre': 'text'}\" sortable=\"'nombre'\">{{proyecto.nombre}}</td>\n            <td data-title=\"'Cartera'\" filter=\"{cartera: 'text'}\">{{proyecto.cartera}}</td>\n            <!-- <td data-title=\"'Tipo'\" filter=\"{tipo: 'text'}\" sortable=\"'tipo'\">{{proyecto.tipo_proyecto.nombre}}</td> -->\n            <td data-title=\"'Monto total'\" filter=\"{monto_total: 'text'}\" sortable=\"'monto_total'\">{{proyecto.monto_total | formatDecimal}}</td>\n            <!-- <td data-title=\"'Municipio'\" filter=\"{'municipio.nombre': 'text'}\" sortable=\"'municipio.nombre'\">{{proyecto.dpa.municipio.nombre}}</td> -->\n            <td data-title=\"'Departamento'\" filter1=\"{'departamento.nombre': 'text'}\">{{proyecto.dpa.departamento.nombre}}</td>\n            <!-- <td data-title=\"'Departamento'\" filter=\"{'departamento.nombre': 'filtro-departamento'}\">{{proyecto.dpa.departamento.nombre}}</td> -->\n            <td data-title=\"'Municipio'\" filter=\"{'municipio.nombre': 'text'}\">{{proyecto.dpa.municipio.nombre}}</td>\n            <td data-title=\"'Plazo ejecución'\" filter=\"{plazo_ejecucion: 'text'}\" sortable=\"'plazo_ejecucion'\">{{proyecto.plazo_ejecucion | formatDecimal}}</td>\n            <td data-title=\"'Estado Proyecto'\" filter=\"{estado_proyecto: 'text'}\" sortable=\"'estado_proyecto'\">\n              {{proyecto.estado_actual.nombre}} <br>\n              <span ng-if=\"proyecto.observacion.mensaje\" class=\"text-danger\"> {{ proyecto.observacion.mensaje }} </span>\n            </td>\n            <td data-title=\"'Estado Supervisión'\" filter=\"{'supervisiones.estado_actual.nombre': 'text'}\" sortable=\"'supervisiones.estado_actual.nombre'\">\n              <div ng-repeat=\"supervision in proyecto.supervisiones\">\n                <div ng-if=\"supervision.estado_actual.codigo!=='EN_ARCHIVO_FDI'\">\n                  <strong class=\"resaltado\">PLANILLA: {{supervision.nro_supervision}}</strong><br>\n                  <strong>{{supervision.adjudicacion.referencia}}</strong><br>\n                  {{supervision.estado_actual.nombre}} <br>\n                  <span ng-if=\"supervision.observacion_proceso.mensaje\" class=\"text-danger\"> {{ supervision.observacion_proceso.mensaje }} </span>\n                </div>\n              </div>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n<!-- filtro departamento -->\n    <script type=\"text/ng-template\" id=\"ng-table/filters/filtro-departamento.html\">\n    <select ng-model=\"params.filter()[name]\">\n      <option value = \"\">todos</option>\n      <option value = \"chuquisaca\">Chuquisaca</option>\n      <option value = \"la paz\">La Paz</option>\n      <option value = \"cochabamba\">Cochabamba</option>\n      <option value = \"oruro\">Oruro</option>\n      <option value = \"potosi\">Potosi</option>\n      <option value = \"tarija\">Tarija</option>\n      <option value = \"santa cruz\">Santa Cruz</option>\n      <option value = \"beni\">Beni</option>\n      <option value = \"pando\">Pando</option>\n    </select>"

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Nueva Solicitud de Proyecto</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <ng-form name=\"formProyecto\">\n    <reg-datos-generales proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.conEstados\"></reg-datos-generales>\n    <reg-financiamiento proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.conEstados\"></reg-financiamiento>\n    <!-- <convenio proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.conEstados\"></convenio> -->\n  </ng-form>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario-alerta=\"formProyecto\" ng-click=\"$ctrl.guardarDatos()\">\n    <i class=\"fa fa-check\"></i> Guardar y enviar\n  </button>\n</div>\n"

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-info-circle\"></i> Gestión</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>\n    Ingrese la gestión del Proyecto.\n  </p>\n\n  <div class=\"alert alert-warning\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>Se usará el código generado para la gestión <strong>{{$ctrl.gestion.nombre}}</strong>.</span>\n  </div>\n\n  <ng-form name=\"formPlazo\">\n    <div class=\"row\">\n      <div class=\"offset-md-3 col-md-6\">\n        <c-select name=\"gestion\" label=\"Gestión\" ng-model=\"$ctrl.gestion\" options=\"$ctrl.gestiones\"></c-select>\n      </div>\n    </div>\n  </ng-form>\n\n</div>\n<div class=\"modal-footer\">\n  <!-- <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button> -->\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formPlazo\" ng-click=\"$ctrl.aceptar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Mis proyectos\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n\n      <div class=\"btn-container d-flex flex-row\">\n        <button class=\"btn btn-{{boton.md}} boton-circular-mediano p-2\" md-effect type=\"button\"\n          ng-click=\"$ctrl.eventoOpcion($event, boton)\" uib-tooltip=\"{{boton.tooltip}}\"\n          ng-if=\"$ctrl.config.opciones\" ng-repeat=\"boton in $ctrl.config.opciones\">\n          <i class=\"fa fa-{{boton.icon}}\"></i>\n        </button>\n      </div>\n\n      <div class=\"crud-table\" ng-table=\"$ctrl.tableParams\">\n        <table class=\"table table-striped table-hover ng-table table-responsive\">\n          <tr ng-repeat=\"proyecto in $data track by proyecto.id_proyecto\">\n            <td data-title=\"''\" >\n              <button md-effect type=\"button\" class=\"btn btn-{{boton.md}} btn-sm mt-1\"\n                ng-click=\"$ctrl.eventoOpcion($event, boton, proyecto)\" uib-tooltip=\"{{boton.tooltip}}\"\n                ng-if=\"$ctrl.config.acciones\" ng-repeat=\"boton in $ctrl.config.acciones\">\n                <i class=\"fa fa-{{boton.icon}}\"></i>\n              </button>\n\n              <button md-effect type=\"button\" class=\"btn btn-primary btn-sm mt-1\"\n                ng-click=\"$ctrl.verUsuarios(proyecto)\" uib-tooltip=\"Usuarios\" ng-if=\"$ctrl.Usuarios.esJefeRevision() || $ctrl.Usuarios.esJefeCierre()\">\n                <i class=\"fa fa-user\"></i>\n              </button>\n              <!--button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\"\n                ng-click=\"$ctrl.nuevaPlanilla(proyecto)\" uib-tooltip=\"Crear Planilla\"\n                ng-if=\"(proyecto.estado_proyecto === 'APROBADO_FDI' || proyecto.estado_proyecto === 'EN_EJECUCION_FDI') && $ctrl.esSupervisor && $ctrl.puedeCrearPlanilla(proyecto)\">\n                <i class=\"fa fa-plus\"></i>\n              </button-->\n              <!-- ya no debe generar planilla consolidada en procesados -->\n              <!--\n              <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\" ng-if=\"$ctrl.puedeVerConsolidado(proyecto)\" uib-tooltip=\"Planilla Consolidada\" download-file=\"{{$ctrl.urlPlanillaConsolidada(proyecto)}}\"  file-name=\"Planilla Consolidada\">\n                <i class=\"fa fa-list-alt\"></i>\n              </button> \n              -->\n              <lista-supervisiones proyecto=\"proyecto\" ng-if=\"$ctrl.puedeVerSupervision(proyecto)\"></lista-supervisiones>\n\n              <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\"\n                ng-click=\"$ctrl.irAModificaciones(proyecto)\" uib-tooltip=\"Ver Modificaciones\"\n                ng-if=\"$ctrl.puedeVerModificaciones(proyecto)\">\n                <i class=\"fa fa-medium\"></i>\n              </button>\n              <!--lista-modificaciones proyecto=\"proyecto\" ng-if=\"$ctrl.puedeVerModificacion(proyecto)\"></lista-modificaciones-->\n              <button-paralizar proyecto=\"proyecto\" ng-if=\"$ctrl.puedeParalizar(proyecto)\"></button-paralizar>\n              <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\"\n                ng-click=\"$ctrl.fdiCrearProyectoModificado(proyecto)\" uib-tooltip=\"Modificar Proyecto\"\n                ng-if=\"proyecto.estado_proyecto === 'RECHAZADO_FDI' && $ctrl.puedeReferenciarProyecto(proyecto)\">\n                <i class=\"fa fa-share-square\"></i>\n              </button>\n            </td>\n            <td data-title=\"'Código'\" filter=\"{nro_convenio: 'text'}\" sortable=\"'nro_convenio'\">{{proyecto.nro_convenio}}</td>\n            <!-- <td data-title=\"'Referencia'\" filter=\"{'beneficiarios.referencia': 'text'}\" sortable=\"'beneficiarios.referencia'\">{{proyecto.beneficiarios.referencia}}</td> -->\n            <!-- <td data-title=\"'Referencia'\">{{proyecto.beneficiarios.referencia}}</td> -->\n            <td data-title=\"'Cartera'\" filter=\"{cartera: 'text'}\">{{proyecto.cartera}}</td>\n            <td data-title=\"'Nombre'\" filter=\"{nombre: 'text'}\" sortable=\"'nombre'\">{{proyecto.nombre}}</td>\n            <!-- <td data-title=\"'Tipo'\" filter=\"{tipo: 'text'}\" sortable=\"'tipo'\">{{proyecto.tipo_proyecto.nombre}}</td> -->\n            <td data-title=\"'Monto total'\" filter=\"{monto_total: 'text'}\" sortable=\"'monto_total'\">{{proyecto.monto_total | formatDecimal}}</td>\n            <!-- <td data-title=\"'Departamento'\" filter=\"{'departamento.nombre': 'text'}\">{{proyecto.municipio.provincia.departamento.nombre}}</td> -->\n            <td data-title=\"'Departamento'\" filter=\"{'departamento.nombre': 'filtro-departamento'}\">{{proyecto.municipio.provincia.departamento.nombre}}</td>\n            <td data-title=\"'Municipio'\" filter=\"{'municipio.nombre': 'text'}\">{{proyecto.municipio.nombre}}</td>\n            <td data-title=\"'Plazo ejecución'\" filter=\"{plazo_ejecucion: 'text'}\" sortable=\"'plazo_ejecucion'\">{{proyecto.plazo_ejecucion | formatDecimal}}</td>\n            <!-- <td data-title=\"'Código de acceso'\" filter=\"{codigo_acceso: 'text'}\" sortable=\"'codigo_acceso'\">{{proyecto.codigo_acceso}}</td> -->\n            <td data-title=\"'Estado Proyecto'\" filter=\"{estado_proyecto: 'text'}\" sortable=\"'estado_proyecto'\">{{proyecto.estado_actual.nombre}}</td>\n            <td data-title=\"'Estado Supervisión'\" filter=\"{'supervisiones.estado_actual.nombre': 'text'}\" sortable=\"'supervisiones.estado_actual.nombre'\">\n              <div ng-repeat=\"supervision in proyecto.supervisiones\">\n                <div ng-if=\"supervision.estado_actual.codigo!=='EN_ARCHIVO_FDI'\">\n                  <strong class=\"resaltado\">PLANILLA: {{supervision.nro_supervision}}</strong><br>\n                  {{supervision.estado_actual.nombre}} <br>\n                  <span ng-if=\"supervision.observacion_proceso.mensaje\" class=\"text-danger\"> {{ supervision.observacion_proceso.mensaje }} </span>\n                </div>\n              </div>\n            </td>\n            <td data-title=\"'Tecnico responsable FDI'\" filter1=\"{'usuario.persona.nombres': 'text'}\">{{proyecto.usuario.persona.nombres}} {{proyecto.usuario.persona.primer_apellido}} {{proyecto.usuario.persona.segundo_apellido}}</td>\n          </tr>\n        </table>\n      </div>\n\n    </div>\n  </div>\n</div>\n<!-- filtro departamento -->\n    <script type=\"text/ng-template\" id=\"ng-table/filters/filtro-departamento.html\">\n    <select ng-model=\"params.filter()[name]\">\n      <option value = \"\">todos</option>\n      <option value = \"chuquisaca\">Chuquisaca</option>\n      <option value = \"la paz\">La Paz</option>\n      <option value = \"cochabamba\">Cochabamba</option>\n      <option value = \"oruro\">Oruro</option>\n      <option value = \"potosi\">Potosi</option>\n      <option value = \"tarija\">Tarija</option>\n      <option value = \"santa cruz\">Santa Cruz</option>\n      <option value = \"beni\">Beni</option>\n      <option value = \"pando\">Pando</option>\n    </select>\n\n  </script>"

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-list\"></i> {{$ctrl.proyecto.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\"><strong>COMPONENTES</strong></p>\n  <div class=\"crud-table mt-3\">\n    <table class=\"table table-striped table-hover ng-table\">\n      <tbody>\n        <tr ng-repeat=\"adjudicacion in $ctrl.proyecto.adjudicaciones\" ng-if=\"$ctrl.puedeCrearPlanilla(adjudicacion)\">\n          <td data-title=\"'Acción'\">\n            <button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\"\n                ng-click=\"$ctrl.nuevaPlanilla($ctrl.proyecto,adjudicacion.id_adjudicacion)\" uib-tooltip=\"Crear Planilla\"\n                ng-if=\"($ctrl.proyecto.estado_proyecto === 'APROBADO_FDI' || $ctrl.proyecto.estado_proyecto === 'EN_EJECUCION_FDI' || $ctrl.proyecto.estado_proyecto === 'REVISION_SEGUIMIENTO_FDI' || $ctrl.proyecto.estado_proyecto === 'ASIGNACION_TECNICO_CIERRE_FDI'  || $ctrl.proyecto.estado_proyecto === 'EN_CIERRE_FDI') && $ctrl.Usuarios.esSupervisor() && $ctrl.puedeCrearPlanilla(adjudicacion)\">\n                <i class=\"fa fa-plus\"></i>\n              </button>\n          </td>          \n          <td>{{adjudicacion.referencia}}</td>\n          <td>\n            <div ng-if=\"adjudicacion.supervision.length>0\">\n              <strong class=\"resaltado\">PLANILLA: {{adjudicacion.supervision[0].nro_supervision}}</strong><br>\n              {{adjudicacion.supervision[0].estado_actual.nombre}} <br>\n              <span ng-if=\"supervision.observacion_proceso.mensaje\" class=\"text-danger\"> {{ adjudicacion.supervision[0].observacion_proceso.mensaje }} </span>\n            </div>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Ver planillas\" ng-click=\"$ctrl.verSupervisiones()\">\n  <i class=\"fa fa-list\"></i>\n</button>\n"

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	module.exports = "<div >\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Ampliaciones al cierre\n  </h6>\n  <div class=\"row\" ng-repeat=\"(key, value) in $ctrl.proyecto.cierre.ampliacion.cierre\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-4\">\n          <c-select name=\"tipo_plazo\" label=\"Tipo\" ng-model=\"value.tipo_plazo\"\n              options=\"$ctrl.tipos_plazo_ampliado\" field=\"nombre\" key-value=\"codigo\"\n              >\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-4\">\n          <c-input name=\"plazo_cierre_{{key}}\" label=\"Ampliacion {{key+1}}\" ng-model=\"value.plazo\" ng-blur=\"$ctrl.calcularPlazos(key)\"\n            >\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-4\" ng-if=\"value.plazo >= 0\">\n          <c-date name=\"fecha_ampliacion_{{key+1}}\" label=\"{{key+1}}ra fecha ampliada\" ng-model=\"$ctrl.plazo_cierre[key]\"\n            ng-required=\"false\"\n            ng-disabled=\"true\">\n          </c-date>\n        </div>\n        <!-- <div class=\"float-right\">\n           <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT2')\"\n                  ng-if=\"value.doc\" uib-tooltip=\"Ver documento\">\n                  <i class=\"fa fa-file-text-o\"></i> Ver documento\n            </button>\n        </div> -->\n      </div>\n    </div>\n    <div class=\"float-right\">\n      <button class=\"btn btn-link text-success ml-1 pl-1 pr-1 pt-4\"\n         ng-click=\"$ctrl.guardar()\"\n         ng-if=\"value.edicion && !$ctrl.modoVista \" uib-tooltip=\"Guardar\">\n        <i class=\"fa fa-save\"></i>\n      </button>\n      <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.eliminar(value, key)\"\n        ng-if=\"!$ctrl.modoVista  \" uib-tooltip=\"Eliminar\">\n        <i class=\"fa fa-trash-o\"></i>\n      </button>\n    </div>\n  </div>\n\n  <div class=\"row\" >\n    <div class=\"col\">\n      <button class=\"btn btn-link btn-sm ml-1 pl-1 pr-1\" ng-click=\"$ctrl.adicionar($ctrl.proyecto.cierre.ampliacion.cierre)\" uib-tooltip=\"Agregar nuevo registro\">\n      <i class=\"fa fa-plus-square-o\"></i> Adicionar\n      </button>\n    </div>\n  </div>\n\n  \n</div>"

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	module.exports = "<section ng-repeat=\"archivo in $ctrl.proyecto.archivo_adjunto\">\n  <h6 class=\"title-section m-top\" ng-if=\"!archivo.datos.ruta\">\n    <i class=\"fa fa-hand-o-right\"></i> Adjuntar archivo\n  </h6>\n  <h6 class=\"title-section m-top\" ng-if=\"archivo.datos.ruta\">\n    <i class=\"fa fa-file\"></i> Adjunto: {{ archivo.datos.titulo }}\n  </h6>\n  <div class=\"row\">\n    <div class=\"col-lg-6 text-left\">\n      <div ng-if=\"!archivo.datos.ruta\">\n        <!-- esto lo cambie para que el rol tecnico legal pueda modificar el nombre del adjunto -->\n        <c-input label=\"Título de Documento\" name=\"doc{{$index}}\" ng-model=\"archivo.datos.titulo\" ng-disabled=\"!$ctrl.modoEdicionDoc(archivo) \" maxlength=\"64\" \n        ng-if=\"$ctrl.usuario.rol.id_rol != 13 && $ctrl.usuario.rol.id_rol != 15\"></c-input >\n        <c-select name=\"titulo documento\" label=\"Tipo Documento\" ng-model=\"archivo.datos.titulo\"\n              options=\"$ctrl.tipos_documentos\" key-value=\"nombre\" ng-if=\"$ctrl.usuario.rol.id_rol == 13 || $ctrl.usuario.rol.id_rol == 15\">\n        </c-select>\n      </div>\n      <div>\n        <!-- <c-input label=\"Título de Documento\" name=\"doc{{$index}}\" ng-model=\"archivo.datos.titulo\" ng-disabled=\"true\" maxlength=\"64\" ></c-input > -->\n        <!-- <c-input label=\"Usuario\" name=\"autor{{$index}}\" ng-model=\"archivo.datos.descripcion\" ng-disabled=\"true\" maxlength=\"32\"></c-input> -->\n      </div>\n      <div>\n        <!-- <c-input label=\"Estado\" name=\"codigo_estado{{$index}}\" ng-model=\"archivo.datos.codigo_estado\" ng-disabled=\"true\" maxlength=\"32\"></c-input> -->\n        <!-- </c-input > -->\n      </div>\n      <div class=\"row\">\n        <!-- <div class=\"col-lg-6 text-left\" ng-if=\"archivo.datos.fecha_inicio || !archivo.datos.ruta\">\n          <c-input label=\"Fecha inicio\" name=\"fecha_inicio{{$index}}\" ng-model=\"archivo.datos.fecha_inicio\" ng-disabled=\"!$ctrl.modoEdicionDoc(archivo) || archivo.datos.ruta\" maxlength=\"32\"></c-input>\n        </div>\n        <div class=\"col-lg-6 text-left\" ng-if=\"archivo.datos.fecha_inicio || !archivo.datos.ruta\">\n          <c-input label=\"Fecha fin\" name=\"fecha_fin{{$index}}\" ng-model=\"archivo.datos.fecha_fin\" ng-disabled=\"!$ctrl.modoEdicionDoc(archivo) || archivo.datos.ruta\" maxlength=\"32\"></c-input>\n        </div> -->\n      </div>\n    </div>\n    <div class=\"col-lg-6 text-left\">\n      <!-- lo aumente de 6Mb a 13Mb a pedido del area juridica porque el adjunto pesa mayor a 6Mb -->\n      <ui-input-file name=\"{{archivo.datos.titulo}}\" label=\"Documento de respaldo\"\n        file-base64=\"archivo.file\"\n        upload-callback=\"$ctrl.uploadArchivoAdjunto\"\n        types=\"pdf\" mime-types=\".pdf\" maxfiles=\"1\" maxsize=\"17MB\"\n        ng-if=\"!archivo.datos.ruta\">\n      </ui-input-file>\n      <div id=\"documento\" ng-if=\"archivo.datos.ruta\">\n        <div class=\"opciones\">\n          <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver archivo\" ng-click=\"$ctrl.verArchivoAdjunto(archivo)\">\n            <i class=\"fa fa-eye\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-info btn-sm\" uib-tooltip=\"Cambiar\" ng-click=\"$ctrl.cambiarArchivoAdjunto(archivo)\" ng-if=\"$ctrl.modoEdicionDoc(archivo)\">\n            <i class=\"fa fa-exchange\"></i>\n          </button>\n        </div>\n        <img src=\"./images/documento.jpg\" alt=\"Documento\">\n        <div class=\"detalles\">\n          <div class=\"nombre\" style=\"white-space:pre-wrap;word-break:break-word;\">{{archivo.datos.nombre_original}}</div>\n        </div>\n      </div>\n      <div>\n        <button md-effect type=\"button\" class=\"btn btn-danger btn-sm pull-right\" ng-if=\"$ctrl.inhabilitarBotonEliminar(archivo)\" ng-click=\"$ctrl.eliminarArchivoAdjunto(archivo,$index)\"><span class=\"fa fa-minus\"></span></button>\n      </div>\n    </div>\n  </div>\n</section>\n\n<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Adjuntar archivo\n    <span>\n      <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"$ctrl.agregarArchivoAdjunto()\"><span class=\"fa fa-plus\"></span></button>\n      <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"$ctrl.agregarTodosArchivos()\" ng-if=\"$ctrl.usuario.rol.id_rol == 13\"><span class=\"fa fa-list-ol\"></span></button>\n    </span>\n  </h6>\n</section>\n"

/***/ }),
/* 801 */
757,
/* 802 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <div ng-if=\"$ctrl.puedeReenviarConfirmacion()\">\n    <reconfirmacion-usuario usuario=\"$ctrl.usuarioGam\" api=\"{{$ctrl.urlReconfirmacion}}\"></reconfirmacion-usuario>\n    <button md-effect type=\"button\" class=\"btn btn-sm btn-danger\" uib-tooltip=\"Inhabilitar usuario\" ng-click=\"$ctrl.inactivarUsuarioResponsableGam($ctrl.usuarioGam)\"><i class=\"fa fa-ban\"></i></button>\n  </div>\n\n  <documento-identidad ng-model=\"$ctrl.proyecto.autoridad_beneficiaria\" modo-vista=\"$ctrl.modoVista\"></documento-identidad>\n\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-12\">\n      <c-input name=\"cargo\" label=\"Cargo\" ng-model=\"$ctrl.proyecto.cargo_autoridad_beneficiaria\"\n        maxlength=\"150\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('cargo_autoridad_beneficiaria')\"\n        ng-disabled=\"true\">\n      </c-input>\n    </div>\n\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"correo\" label=\"Correo Electrónico 1\" ng-model=\"$ctrl.proyecto.autoridad_beneficiaria.correo\"\n        maxlength=\"150\" ng-validation=\"correo\"\n        \n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\">\n      </c-input><!--ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('autoridad_beneficiaria')\"  2022-->\n    </div>\n\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"celular\" label=\"Celular\" ng-model=\"$ctrl.proyecto.autoridad_beneficiaria.telefono\"\n        ng-directives=\"numeric\" maxlength=\"8\"\n        \n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\">\n      </c-input><!--\n        ng-validation=\"celular\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('autoridad_beneficiaria')\"  2022-->\n    </div>\n\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"fax\" label=\"Teléfono/Fax\" ng-model=\"$ctrl.proyecto.fax_autoridad_beneficiaria\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fax_autoridad_beneficiaria')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fax_autoridad_beneficiaria')\">\n      </c-input>\n    </div>\n  </div>\n</section>\n\n<section ng-init=\"$ctrl.proyecto.contactos.$_plantilla=3; $ctrl.proyecto.contactos.$_nombre='contactos'\">\n  <div ng-repeat=\"contacto in $ctrl.proyecto.contactos.datos\">\n    <hr style=\"height:8px;margin-left:-19px;margin-right:-19px;background-color:#C9CDD0;\">\n    <documento-identidad ng-model=\"contacto.persona\" modo-vista=\"$ctrl.modoVista\" callback-search=\"$ctrl.verificar(data, $index)\" ng-id=\"{{$index}}\"></documento-identidad>\n\n    <div class=\"row\">\n      <div class=\"md-input-group col-md-12\">\n        <c-input name=\"cargo{{$index}}\" label=\"Cargo\" ng-model=\"contacto.cargo\"\n          maxlength=\"150\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('cargo_autoridad_beneficiaria')\"\n          ng-disabled=\"$index<1 || $ctrl.modoVista || !$ctrl.Proyecto.esEditable('cargo_autoridad_beneficiaria')\">\n        </c-input>\n      </div>\n\n      <div class=\"md-input-group col-md-4\">\n        <c-input name=\"correo{{$index}}\" label=\"Correo Electrónico 2\" ng-model=\"contacto.correo\"\n          maxlength=\"150\" ng-validation=\"correo\"\n          \n          ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\">\n        </c-input><!--ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('autoridad_beneficiaria')\"  2022-->\n      </div>\n\n      <div class=\"md-input-group col-md-4\">\n        <c-input name=\"celular{{$index}}\" label=\"Celular\" ng-model=\"contacto.telefono\"\n          ng-directives=\"numeric\" maxlength=\"8\"\n          \n          ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\">\n        </c-input><!--\n          ng-validation=\"celular\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('autoridad_beneficiaria')\"  2022-->\n      </div>\n\n      <div class=\"md-input-group col-md-4\">\n        <c-input name=\"fax{{$index}}\" label=\"Teléfono/Fax\" ng-model=\"contacto.fax\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fax_autoridad_beneficiaria')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fax_autoridad_beneficiaria')\">\n        </c-input>\n      </div>\n    </div>\n    <button type=\"button\" class=\"btn btn-md btn-danger\" ng-if=\"$index>0 && !$ctrl.modoVista && $ctrl.Proyecto.esEditable('autoridad_beneficiaria') && $ctrl.proyecto.contactos.datos.length>0\" ng-click=\"$ctrl.quitarContacto($index)\"><i class=\"fa fa-minus-circle\"></i></button>\n  </div>\n\n  <hr style=\"height:8px;margin-left:-19px;margin-right:-19px;background-color:#C9CDD0;\">\n  <button type=\"button\" class=\"btn btn-md btn-success\" ng-if=\"!$ctrl.modoVista && $ctrl.Proyecto.esEditable('autoridad_beneficiaria')\" ng-click=\"$ctrl.agregarContacto()\"><i class=\"fa fa-plus-circle\"></i></button>\n</section>"

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i>\n    {{ 'Registro de Responsable GAM/GAIOC' }}\n    <!-- {{$ctrl.miembro.tipo_equipo != 'TE_FDI' && !$ctrl.miembro.id_equipo_tecnico ? 'Registro' : $ctrl.modoEdicion ? 'Edición del' : ''}} Integrante del Equipo Técnico <span ng-if=\"$ctrl.referencia!=null\">para {{$ctrl.referencia}}</span> -->\n  </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <ng-form name=\"formMiembro\">\n    <documento-identidad ng-model=\"$ctrl.miembro\" modo-vista=\"!$ctrl.modoEdicion\"></documento-identidad>\n\n    <div class=\"row\">\n      <div class=\"md-input-group col-md-6\">\n        <c-input name=\"celular_miembro\" label=\"Celular\" ng-model=\"$ctrl.miembro.telefono\"\n        ng-validation=\"celular\" ng-directives=\"numeric\" maxlength=\"8\" ng-required=\"true\"></c-input>\n      </div>\n\n      <div class=\"md-input-group col-md-6\">\n        <c-input name=\"correo_miembro\" label=\"Correo Electrónico\" ng-model=\"$ctrl.miembro.correo\"\n        ng-validation=\"correo\" ng-required=\"true\"></c-input>\n      </div>\n    </div>\n  </ng-form>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.registrar()\" validar-formulario=\"formMiembro\">\n    <i class=\"fa fa-check\"></i> Actualizar\n  </button>\n</div>\n"

/***/ }),
/* 804 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\" style=\"font-size:12px;\">\n    <div class=\"col-md-auto\">\n\t\t<div class=\"form-group\">\n\t\t\t<label>Datos del proyecto</label>\n\t\t\t<p><b>Nombre : </b>{{$ctrl.proyecto.nombre}}<br>\n\t\t\t<b>Departamento : </b>{{$ctrl.proyecto.dpa.departamento.nombre}}\n\t\t\t<b>Provincia : </b>{{$ctrl.proyecto.dpa.provincia.nombre}}\n\t\t\t<b>Municipio : </b>{{$ctrl.proyecto.dpa.municipio.nombre}}<br>\n\t\t\t<b>Tipo del proyecto: </b>{{$ctrl.proyecto.tipo}}\n\t\t\t<b>Tipo de financiamiento : </b>{{$ctrl.proyecto.tipo_financiamiento}}\n\t\t\t<b>Tamaño del proyecto: </b>{{$ctrl.proyecto.tamanio_proyecto}}\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-auto\">\n\t\t<div class=\"form-group\">\n\t\t\t<label>Datos Convenio.</label>\n\t\t\t<p><b>Plazo Convenio: </b>{{$ctrl.proyecto.plazo_ejecucion}} (Diacalendario.)<br>\n\t\t\t<b>Nro Convenio: </b>{{$ctrl.proyecto.convenio.nro_convenio}} <br>\n\t\t\t<b>Fecha suscripcion : </b>{{$ctrl.proyecto.convenio.fecha_suscripcion | date}}</p>\n\t\t</div>\n\t</div>\n\t\t\t\n\t\t\t\n</div>\n<div class=\"row\" style=\"font-size:12px;\">\n\t<div class=\"col-md-auto\">\n\t\t<div class=\"form-group\">\n\t\t\t<label>Desembolsos (Bs.)</label>\n\t\t\t<p><b>1er Desembolso : </b>{{$ctrl.proyecto.cronograma_desembolsos.monto_1 | number:2}} <b>Fecha :</b> {{$ctrl.proyecto.cronograma_desembolsos.fecha_1 | date}} <br>\n\t\t\t<b>2do Desembolso : </b>{{$ctrl.proyecto.cronograma_desembolsos.monto_2 | number:2}} <b>Fecha :</b> {{$ctrl.proyecto.cronograma_desembolsos.fecha_2 | date}} <br>\n\t\t\t<b>3er Desembolso : </b>{{$ctrl.proyecto.cronograma_desembolsos.monto_3 | number:2}} <b>Fecha :</b> {{$ctrl.proyecto.cronograma_desembolsos.fecha_3 | date}} </p>\n\t\t</div>\n\t</div> \n\t<div class=\"col-md-auto\">\n\t\t<div class=\"form-group\">\n\t\t\t<label>Entrega provisional y definitiva</label>\n\t\t\t<p><b>Fecha del acta provisional : </b>{{$ctrl.proyecto.seguimiento.fecha_acta_provisional | date}}<br>\n\t\t\t<b>Fecha del acta definitiva : </b>{{$ctrl.proyecto.seguimiento.fecha_acta_definitiva | date}}\n\t\t</div>\n\t</div>\n</div>\n<h6 class=\"title-section m-top\">Cierre de Proyecto <ui-help message=\"$ctrl.helpLang.plazo_cierre\" direction=\"right\"></ui-help></h6>\n<div class=\"row\">\n\t<div class=\"col-md-auto\">\n\t\t<button md-effect type=\"button\"\n\t\t\tclass=\"btn btn-actions c-pointer btn-outline-success\"\n\t\t\tng-if=\"$ctrl.Proyecto.esEditable('plazo_cierre')\"\n\t\t\tng-click=\"$ctrl.guardarDatosCierre()\" uib-tooltip=\"Guardar\">\n\t\t\t<i class=\"fa fa-save\"></i> \n\t\t</button>\n\t</div>\n\t<div class=\"col-md-auto\">\n\t\t<c-input-numeric name=\"plazo_cierre\" label=\"Definir Plazo\" ng-model=\"$ctrl.proyecto.cierre.plazo_cierre\" ng-blur=\"$ctrl.calcularPlazos()\"\n\t\t      ng-minvalue=\"0\" ng-maxvalue=\"99999999\" ng-formatting=\"false\" ng-decimals=\"0\"></c-input-numeric>\n\t</div>\n\t<div class=\"col-md-auto\">\n\t\t<c-date name=\"fecha_inicio\" label=\"Fecha de inicio\" ng-model=\"$ctrl.proyecto.cierre.fecha_inicio\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('fecha_inicio')\" ng-change=\"$ctrl.calcularPlazos()\"  ng-required=\"true\"></c-date>\n\t</div>\t\n\t<div class=\"col-md-auto\">\n        <c-date name=\"fecha_finalizacion\" label=\"Finalización del plazo\" ng-model=\"$ctrl.plazo_cierre\"\n          ng-disabled=\"true\"></c-date>\n    </div>\n</div>\n<reg-ampliacion proyecto=\"$ctrl.proyecto\"></reg-ampliacion>\n<h6 class=\"title-section m-top\">Informe de transición</h6>\n<div class=\"row\">\n\n\t<div class=\"col-md-3\">\n\t\t\n\t\t<c-date name=\"fecha_informe_transicion\" label=\"Fecha Informe de transición\" ng-model=\"$ctrl.proyecto.seguimiento.fecha_informe\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\" ng-required=\"true\"></c-date>\n\t\t\t<!-- {{$ctrl.proyecto.seguimiento.fecha_informe}} -->\n\t\t\n\t</div>\n\t<div class=\"col-md-4\" >\n\t\t<archivo name=\"doc_inf_transicion\" label=\"Informe de transición\" ng-model=\"$ctrl.proyecto.seguimiento.doc_informe\" types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\" url=\"{{$ctrl.archivos.urlDocIT}}\" url-descarga=\"{{$ctrl.archivos.urlDocITDescarga}}\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\" ng-required=\"true\"></archivo>\n\t</div>\n\t<div class=\"col-md-4\" >\n\t\t\n\t</div>\n\n</div>\n\n<!-- ULTIMA INSPECCION DE CAMPO EN SEGUIMIENTO -->\n<section ng-if=\"!$ctrl.Usuarios.esFiscal()\">\n\t<h6 class=\"title-section m-top\">Inspeccion de campo al seguimiento</h6>\n\t<ng-form name=\"form_inspeccion_d\">\n\t\t<div class=\"\" ng-repeat=\"(key,value) in $ctrl.proyecto.seguimiento.inspeccion_campo\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-auto\">\n\t\t\t\t\t<c-date name=\"fecha_inspeccion_{{key}}\" label=\"Fecha inspeccion\" ng-model=\"value.fecha\" ng-disabled=\"!value.edicion\" ng-required=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\" ng-if=\"$ctrl.Usuarios.esTecnicoResponsable()\">\n\t\t\t\t\t<button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"value.edicion = true;$ctrl.fechant= value.fecha\" ng-if=\"!value.edicion && !$ctrl.modoVista && value.objeto_id\" uib-tooltip=\"Editar\">\n\t\t\t\t\t\t<i class=\"fa fa-edit\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-link text-success ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.actualizarInspeccion(value)\" ng-if=\"value.edicion && !$ctrl.modoVista && value.objeto_id\" uib-tooltip=\"Guardar\">\n\t\t\t\t\t\t<i class=\"fa fa-save\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-link text-danger ml-0 pl-0 pr-1 pt-4\" ng-click=\"value.edicion = false; value.fecha = $ctrl.fechant\" ng-if=\"value.edicion && !$ctrl.modoVista && value.objeto_id\" uib-tooltip=\"Cancelar\">\n\t\t\t\t\t\t<i class=\"fa fa-close\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-3\" ng-if=\"value.objeto_id\">\n\t\t\t\t\t<c-input name=\"tecnico_inspeccion_{{key}}\" label=\"Técnico responsable de la inspección\" ng-model=\"value.tecnico_inspeccion\"\n\t\t\t\t\tng-minlength=\"3\" maxlength=\"100\"\n\t\t\t\t\tng-disabled=\"true\"></c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-3\" ng-if=\"!value.objeto_id\">\n\t\t\t\t\t<c-select name=\"listaTecnico_{{key}}\" label=\"Técnico responsable de la inspección\"  ng-model=\"value.tecnico_inspeccion\" ng-required=\"true\" options=\"$ctrl.usuariosParaAsignar\" field=\"nombre\" ng-disabled=\"false\"></c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"value.objeto_id\">\n\t\t\t\t\t<c-input name=\"detallee_{{key}}\" label=\"Inspección\" ng-model=\"value.detalle\" ng-disabled=\"true\"></c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"!value.objeto_id\">\n\t\t\t\t\t<c-select name=\"detalle_inf_{{key}}\" label=\"Inspección\" placeholder=\"Seleccione tipo informe\" ng-model=\"value.detalle\" ng-required=\"true\" options=\"$ctrl.items\" field=\"text\" ng-disabled=\"false\"></c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"value.objeto_id\">\n\t\t\t\t\t<button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.obtenerInspeccion(value.doc_informe)\" ng-if=\"value.doc_informe\" uib-tooltip=\"Ver documento\">\n\t\t\t\t\t<i class=\"fa fa-file-pdf-o\"></i> Ver Informe\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"!value.objeto_id\">\n\t\t\t\t\t<archivo name=\"doc_inspeccion\" label=\"Informe de Inspeccion\" ng-model=\"value.doc_informe\" types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\" url=\"{{$ctrl.archivos.url}}\" url-descarga=\"{{$ctrl.archivos.url}}\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\"></archivo>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t<button class=\"btn btn-link text-success ml-1 pl-1 pr-1 pt-4\"\n\t\t\t\t\t\tng-click=\"$ctrl.guardarInspeccion(value,key)\"\n\t\t\t\t\t\tng-if=\"value.edicion && !$ctrl.modoVista && !value.objeto_id\" uib-tooltip=\"Guardar\">\n\t\t\t\t\t\t<i class=\"fa fa-save\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t\n\t\t\t\t\t<button class=\"btn btn-link text-danger ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.eliminarInspeccion(value, key)\"\n\t\t\t\t\t\tng-if=\"!$ctrl.modoVista && value.edicion && !value.objeto_id\" uib-tooltip=\"Eliminar\">\n\t\t\t\t\t\t<i class=\"fa fa-trash-o\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\t</ng-form>\n</section>\n\n<!-- INSPECCIONES DE CAMPO CIERRE-->\n\n<section ng-if=\"!$ctrl.Usuarios.esFiscal()\">\n\t<h6 class=\"title-section m-top\">Inspecciones de campo al cierre</h6>\n\t<div class=\"alert alert-info\" ng-if=\"$ctrl.Proyecto.esEditable('orden_proceder')\">\n    \t<i class=\"fa fa-info-circle\"></i><span><strong> Nota: </strong>Subir inspección/es de campo medio termino y final</span>\n  \t</div>\n\t<ng-form name=\"form_inspeccion_c\">\n\t\t<div class=\"\" ng-repeat=\"(key,value) in $ctrl.proyecto.cierre.inspeccion_campo\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-auto\">\n\t\t\t\t\t<c-date name=\"fecha_inspeccion_{{key}}\" label=\"Fecha inspeccion\" ng-model=\"value.fecha\" ng-disabled=\"!value.edicion\" ng-required=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\" ng-if=\"$ctrl.Usuarios.esTecnicoResponsable()\">\n\t\t\t\t\t<button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"value.edicion = true;$ctrl.fechant= value.fecha\" ng-if=\"!value.edicion && !$ctrl.modoVista && value.objeto_id\" uib-tooltip=\"Editar\">\n\t\t\t\t\t\t<i class=\"fa fa-edit\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-link text-success ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.actualizarInspeccion(value)\" ng-if=\"value.edicion && !$ctrl.modoVista && value.objeto_id\" uib-tooltip=\"Guardar\">\n\t\t\t\t\t\t<i class=\"fa fa-save\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-link text-danger ml-0 pl-0 pr-1 pt-4\" ng-click=\"value.edicion = false; value.fecha = $ctrl.fechant\" ng-if=\"value.edicion && !$ctrl.modoVista && value.objeto_id\" uib-tooltip=\"Cancelar\">\n\t\t\t\t\t\t<i class=\"fa fa-close\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-3\" ng-if=\"value.objeto_id\">\n\t\t\t\t\t<c-input name=\"tecnico_inspeccion_{{key}}\" label=\"Técnico responsable de la inspección\" ng-model=\"value.tecnico_inspeccion\"\n\t\t\t\t\tng-minlength=\"3\" maxlength=\"100\"\n\t\t\t\t\tng-disabled=\"true\"></c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-3\" ng-if=\"!value.objeto_id\">\n\t\t\t\t\t<c-select name=\"listaTecnico_{{key}}\" label=\"Técnico responsable de la inspección\"  ng-model=\"value.tecnico_inspeccion\" ng-required=\"true\" options=\"$ctrl.usuariosParaAsignar\" field=\"nombre\" ng-disabled=\"false\"></c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"value.objeto_id\">\n\t\t\t\t\t<c-input name=\"detallee_{{key}}\" label=\"Inspección\" ng-model=\"value.detalle\" ng-disabled=\"true\"></c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"!value.objeto_id\">\n\t\t\t\t\t<c-select name=\"detalle_inf_{{key}}\" label=\"Inspección\" placeholder=\"Seleccione tipo informe\" ng-model=\"value.detalle\" ng-required=\"true\" options=\"$ctrl.items\" field=\"text\" ng-disabled=\"false\"></c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"value.objeto_id\">\n\t\t\t\t\t<button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.obtenerInspeccion(value.doc_informe)\" ng-if=\"value.doc_informe\" uib-tooltip=\"Ver documento\">\n\t\t\t\t\t<i class=\"fa fa-file-pdf-o\"></i> Ver Informe\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"!value.objeto_id\">\n\t\t\t\t\t<archivo name=\"doc_inspeccion\" label=\"Informe de Inspeccion\" ng-model=\"value.doc_informe\" types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\" url=\"{{$ctrl.archivos.url}}\" url-descarga=\"{{$ctrl.archivos.url}}\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\"></archivo>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t<button class=\"btn btn-link text-success ml-1 pl-1 pr-1 pt-4\"\n\t\t\t\t\t\tng-click=\"$ctrl.guardarInspeccion(value,key)\"\n\t\t\t\t\t\tng-if=\"value.edicion && !$ctrl.modoVista && !value.objeto_id\" uib-tooltip=\"Guardar\">\n\t\t\t\t\t\t<i class=\"fa fa-save\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<!-- {{value.edicion }} && {{!$ctrl.modoVista}} && {{!value.objeto_id}} -->\n\t\t\t\t\t<button class=\"btn btn-link text-danger ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.eliminarInspeccion(value, key)\"\n\t\t\t\t\t\tng-if=\"!$ctrl.modoVista && value.edicion && !value.objeto_id\" uib-tooltip=\"Eliminar\">\n\t\t\t\t\t\t<i class=\"fa fa-trash-o\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\t</ng-form>\n\t\n\t<div class=\"row\" ng-if=\"$ctrl.Usuarios.esTecnicoCierre()\">\n\t\t<div class=\"col\">\n\t\t\t<button class=\"btn btn-link btn-sm ml-1 pl-1 pr-1\" ng-click=\"$ctrl.addIc($ctrl.proyecto.cierre.inspeccion_campo)\" uib-tooltip=\"Agregar nuevo registro\">\n\t\t\t<i class=\"fa fa-plus-square-o\"></i> Agregar inspeccion de campo\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</section>\n\n<h6 class=\"title-section m-top\">Datos del informe final de cierre</h6>\n\n<div class=\"row\">\n\t<div class=\"col-md-auto\">\n\t\t<button md-effect type=\"button\"\n\t\t\tclass=\"btn btn-actions c-pointer btn-outline-success\"\n\t\t\tng-if=\"$ctrl.Proyecto.esEditable('informe_cierre')\"\n\t\t\tng-click=\"$ctrl.guardarDatosCierre()\" uib-tooltip=\"Guardar\">\n\t\t\t<i class=\"fa fa-save\"></i> \n\t\t</button>\n\t</div>\n\t<div class=\"col-md-auto\">\n\t\t<c-date name=\"fecha_informe_cierre\" label=\"Fecha del informe \" ng-model=\"$ctrl.proyecto.cierre.fecha_informe\" ></c-date>\n\t</div>\n\t<div class=\"col-md-auto\" >\n\t\t<c-input name=\"hoja_ruta\" label=\"Hoja de ruta\" ng-model=\"$ctrl.proyecto.cierre.hoja_ruta_informe\"\n      ng-minlength=\"3\" maxlength=\"255\" ng-required=\"\" ng-disabled=\"\"></c-input>\n\t</div>\n\n\t<div class=\"col-auto\" >\n\t\t<c-input name=\"cite_informe\" label=\"CITE\" ng-model=\"$ctrl.proyecto.cierre.cite_informe\"\n      ng-minlength=\"3\" maxlength=\"255\" ng-required=\"\" ng-disabled=\"\"></c-input>\n\t</div>\n\n</div>\n\n\n<h6 class=\"title-section m-top\">Lista verificacion cierre proyecto</h6>{{ctrl.helpLang}}\n\t<reg-lista-cierre proyecto=\"$ctrl.proyecto\"></reg-lista-cierre>\n\n\n\n"

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	module.exports = "<section ng-init=\"$ctrl.proyecto.res_administrativa.$_plantilla=4; $ctrl.proyecto.res_administrativa.$_nombre='res_administrativa'\">\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Resolución de Aprobación\n  </h6>\n  <div class=\"row\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"nro_resmin_cife\" label=\"N° Resolución\" ng-model=\"$ctrl.proyecto.nro_resmin_cife\"\n          ng-minlength=\"3\" maxlength=\"100\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('doc_resmin_cife')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('doc_resmin_cife')\"></c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-date name=\"fecha_suscripcion_res\" label=\"Fecha emisión de la R.A.\" ng-model=\"$ctrl.proyecto.res_administrativa.fecha_emision\"\n          mensaje-min-date=\"La fecha no debe ser menor a la Fecha de la solicitud de financiamiento del proyecto\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('doc_resmin_cife')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('doc_resmin_cife')\"></c-date><!--min-date=\"$ctrl.proyecto.fecha_suscripcion_convenio\" 2022-->\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" > <!--se quito la condicion para ocultar el adjunto de doc_resolucion-->\n      <archivo name=\"doc_resmin_cife\" label=\"Resolución de Aprobación\" ng-model=\"$ctrl.proyecto.doc_resmin_cife\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"4MB\"\n              url=\"{{$ctrl.archivos.urlDocResolucion}}\"\n              url-descarga=\"{{$ctrl.archivos.urlDocResolucionDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_resmin_cife')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_resmin_cife')\">\n      </archivo>\n    </div>\n  </div>\n</section>\n<section ng-init=\"$ctrl.proyecto.convenio.$_plantilla=5; $ctrl.proyecto.convenio.$_nombre='convenio'\">\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio\n  </h6>\n  <div class=\"row\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"nro_convenio\" label=\"N° de Convenio\" ng-model=\"$ctrl.proyecto.convenio.nro_convenio\"\n          ng-minlength=\"3\" maxlength=\"100\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('doc_convenio')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('doc_convenio')\"></c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-date name=\"fecha_suscripcion_con\" label=\"Fecha de suscripción del convenio\" ng-model=\"$ctrl.proyecto.convenio.fecha_suscripcion\"\n          mensaje-min-date=\"La fecha de suscripción del convenio no debe ser menor a la Fecha de emisión R.A.\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('doc_convenio')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('doc_convenio')\"></c-date><!--min-date-key=\"fecha_suscripcion_res\"-->\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_tiempo_administrativo\" label=\"Plazo Administrativo\" ng-model=\"$ctrl.proyecto.convenio.plazo_tiempo_administrativo\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio\" label=\"Plazo de Convenio\" ng-model=\"$ctrl.proyecto.plazo_ejecucion\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('doc_convenio')\"\n          ng-disabled=\"true\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('doc_convenio')\"></c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.orden_proceder\">\n          <c-date name=\"fecha_orden_proceder\" label=\"Orden de proceder\" ng-model=\"$ctrl.proyecto.orden_proceder\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.orden_proceder\">\n          <c-date name=\"fecha_finalizacion_convenio\" label=\"Finalización del plazo\" ng-model=\"$ctrl.plazo_convenio0\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-3\">\n      <archivo name=\"doc_convenio\" label=\"Convenio\" ng-model=\"$ctrl.proyecto.doc_convenio\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{$ctrl.archivos.urlDocConvenio}}\"\n              url-descarga=\"{{$ctrl.archivos.urlDocConvenioDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio')\">\n      </archivo>\n    </div>\n    <div class=\"md-input-group col-md-3\">\n      <img src=\"{{$ctrl.qrimage}}\" alt='QR Code Image'>\n    </div>\n  </div>\n\n<div ng-if=\"$ctrl.proyecto.convenio.fecha_suscripcion || $ctrl.proyecto.orden_proceder\">\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 1\n  </h6>\n  <div class=\"row\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"($ctrl.proyecto.convenio.plazo_convenio_ampliado2 > 0) || !$ctrl.Proyecto.esEditable('doc_convenio_extendido')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio1()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"($ctrl.proyecto.convenio.plazo_convenio_ampliado2 > 0) || !$ctrl.Proyecto.esEditable('doc_convenio_extendido')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado >= 0\">\n          <c-date name=\"fecha_ampliacion_con\" label=\"1ra fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio1\"\n            ng-required=\"false\"\n            ng-disabled=\"true\">\n          </c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado >= 0\">\n      <archivo name=\"doc_convenio_extendido\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga }}\"\n              cambiar=\"!($ctrl.proyecto.convenio.plazo_convenio_ampliado2 > 0)\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido')\">\n       </archivo>  <!-- para cambiar documento adenda 1-->\n    </div>\n  </div>\n  <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 2\n  </h6>\n  <div class=\"row\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo2\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado2\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado2\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado2\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio2()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido\">\n          <c-date name=\"fecha_ampliacion_con2\" label=\"2da fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio2\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido\">\n      <archivo name=\"doc_convenio_extendido2\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido2\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido2 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga2 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido2')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido2')\">\n      </archivo>\n    </div>\n  </div>\n    <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido2\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 3\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido2)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo3\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado3\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido3')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado3\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado3\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio3()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido3')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido2\">\n          <c-date name=\"fecha_ampliacion_con3\" label=\"3ra fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio3\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido2\">\n      <archivo name=\"doc_convenio_extendido3\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido3\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido3 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga3 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido3')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido3')\">\n      </archivo>\n    </div>\n  </div>\n</div>\n\n    <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido3\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 4\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido3)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo4\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado4\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido4')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado4\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado4\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio4()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido4')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido3\">\n          <c-date name=\"fecha_ampliacion_con4\" label=\"4ta fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio4\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido3\">\n      <archivo name=\"doc_convenio_extendido4\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido4\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido4 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga4 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido4')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido4')\">\n      </archivo>\n    </div>\n  </div>\n</div>\n\n    <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 5\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido4)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo5\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado5\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido5')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado5\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado5\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio5()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido5')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n          <c-date name=\"fecha_ampliacion_con5\" label=\"5ta fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio5\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n      <archivo name=\"doc_convenio_extendido5\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido5\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido5 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga5 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido5')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido5')\">\n      </archivo>\n    </div>\n  </div>\n\n<!-- seccion adenda 6 -->\n    <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido5\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 6\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido5)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo6\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado6\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido6')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado6\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado6\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio6()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido6')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido5\">\n          <c-date name=\"fecha_ampliacion_con5\" label=\"6ta fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio6\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido5\">\n      <archivo name=\"doc_convenio_extendido6\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido6\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido6 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga6 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido6')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido6')\">\n      </archivo>\n    </div>\n  </div>\n  <!-- seccion adenda 7 -->\n    <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido6\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 7\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido6)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo7\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado7\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido7')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado7\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado7\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio7()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido7')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido6\">\n          <c-date name=\"fecha_ampliacion_con5\" label=\"7ma fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio7\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido6\">\n      <archivo name=\"doc_convenio_extendido7\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido7\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido7 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga7 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido7')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido7')\">\n      </archivo>\n    </div>\n  </div>\n  <!-- seccion adenda 8 -->\n    <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido7\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 8\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido7)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo8\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado8\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido8')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado8\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado8\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio8()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido8')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido7\">\n          <c-date name=\"fecha_ampliacion_con8\" label=\" fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio8\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido7\">\n      <archivo name=\"doc_convenio_extendido8\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido8\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido8 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga8 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido8')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido8')\">\n      </archivo>\n    </div>\n  </div>\n  <!-- seccion adenda 9 -->\n    <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido8\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 9\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido8)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo9\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado9\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido9')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado9\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado9\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio9()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido9')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido8\">\n          <c-date name=\"fecha_ampliacion_con9\" label=\" fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio9\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido8\">\n      <archivo name=\"doc_convenio_extendido9\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido9\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido9 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga9 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido9')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido9')\">\n      </archivo>\n    </div>\n  </div>\n\n  <!-- seccion adenda 10 -->\n  <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido9\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 10\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido9)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo10\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado10\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido10')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado10\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado10\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio10()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido10')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido8\">\n          <c-date name=\"fecha_ampliacion_con10\" label=\" fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio10\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido9\">\n      <archivo name=\"doc_convenio_extendido10\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido10\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido10 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga10 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido10')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido10')\">\n      </archivo>\n    </div>\n  </div>\n    <!-- seccion adenda 11 -->\n  <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido10\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 11\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido10)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo11\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado11\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido11')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado11\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado11\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio11()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido11')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido10\">\n          <c-date name=\"fecha_ampliacion_con11\" label=\" fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio11\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido10\">\n      <archivo name=\"doc_convenio_extendido11\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido11\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido11 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga11 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido11')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido11')\">\n      </archivo>\n    </div>\n  </div>\n    <!-- seccion adenda 12 -->\n  <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido11\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 12\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido11)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo12\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado12\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido12')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado12\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado12\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio12()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido12')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido11\">\n          <c-date name=\"fecha_ampliacion_con12\" label=\" fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio12\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido11\">\n      <archivo name=\"doc_convenio_extendido12\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido12\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido12 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga12 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido12')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido12')\">\n      </archivo>\n    </div>\n  </div>\n    <!-- seccion adenda 13 -->\n  <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido12\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 13\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido12)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo13\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado13\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido13')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado13\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado13\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio13()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido13')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido12\">\n          <c-date name=\"fecha_ampliacion_con13\" label=\" fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio13\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido12\">\n      <archivo name=\"doc_convenio_extendido13\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido13\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido13 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga13 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido13')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido13')\">\n      </archivo>\n    </div>\n  </div>\n    <!-- seccion adenda 14 -->\n  <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido13\">\n    <i class=\"fa fa-hand-o-right\"></i> Convenio modificatorio 14\n  </h6>\n  <div class=\"row\" ng-if=\"($ctrl.proyecto.doc_convenio_extendido13)\">\n    <div class=\"col-md-12 col-lg-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col-md-6\">\n          <c-select name=\"tipo_plazo9\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado14\"\n              options=\"$ctrl.tipos_plazo_ampliado\"\n              ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido14')\">\n          </c-select>\n        </div>\n        <div class=\"md-input-group col-md-6\">\n          <c-input name=\"plazo_convenio_ampliado14\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado14\"\n            ng-blur=\"$ctrl.recalcularPlazoConvenio14()\"\n            ng-required=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido')\"\n            ng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido14')\">\n          </c-input>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido13\">\n          <c-date name=\"fecha_ampliacion_con14\" label=\" fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio14\"\n          ng-required=\"false\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido13\">\n      <archivo name=\"doc_convenio_extendido14\" label=\"Documento de ampliación de convenio\" ng-model=\"$ctrl.proyecto.doc_convenio_extendido14\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"13MB\"\n              url=\"{{ $ctrl.archivos.urlDocConvenioExtendido14 }}\"\n              url-descarga=\"{{ $ctrl.archivos.urlDocConvenioExtendidoDescarga14 }}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio_extendido14')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido14')\">\n      </archivo>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	module.exports = "<section ng-init=\"$ctrl.proyecto.beneficiarios.$_plantilla=1; $ctrl.proyecto.beneficiarios.$_nombre='beneficiarios'\">\n  <h6 class=\"title-section m-top\"></h6>\n  <div class=\"row\">\n    <div class=\"col-lg-6\" ng-if=\"$ctrl.ver_comunidades\">\n      <div class=\"row\" ng-repeat=\"comunidad in $ctrl.proyecto.beneficiarios.comunidades\">\n        <div class=\"md-input-group col-md-2\">\n          <div class=\"md-form-group\" md-event-label=\"\">\n            <input name=\"nro0\" id=\"nro0\" disabled=\"true\" readonly=\"true\" value=\"{{$index+1}}\" maxlength=\"255\" class=\"ng-valid ng-valid-pattern ng-valid-minlength ng-valid-maxlength ng-valid-required ng-not-empty ng-dirty ng-valid-parse ng-touched\" type=\"text\">\n            <label for=\"nro0\" title=\"\" class=\"md-control-label ng-binding\" ng-class=\"{'requerido':$ctrl.ngRequired}\">Nro.</label>\n            <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form[$ctrl.name].$invalid &amp;&amp; $ctrl.form[$ctrl.name].$touched}\"></i>\n          </div>\n        </div>\n        <div class=\"md-input-group col-md-8\">\n          <c-input name=\"nombre{{$index}}\" label=\"Nombre\" ng-model=\"comunidad.nombre\"\n          maxlength=\"255\" ng-blur=\"$ctrl.renombrarComunidad($index,comunidad)\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\"></c-input>\n        </div>\n        <div class=\"md-input-group col-md-2\">\n          <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-if=\"!$ctrl.modoVista && $ctrl.editarBeneficiarios()\" ng-click=\"$ctrl.quitarComunidad($index)\"><i class=\"fa fa-trash\"></i></button>\n        </div>\n        <!--- UTM -->\n        <div ng-if=\"!$ctrl.noEditarCoordenadas()\" class=\"col-md-2\"></div>\n        <div ng-if=\"!$ctrl.noEditarCoordenadas()\" class=\"md-input-group col-md-2\">\n          <c-input-numeric name=\"coordenadas{{$index}}zona\" label=\"Zona\" ng-model=\"comunidad.coordenadas.zona\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\" ng-decimals=\"0\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input-numeric>\n        </div>\n        <div class=\"col-md-2\"></div>\n      </div>\n    </div>\n    <div class=\"col-lg-6\" style=\"z-index:1\">\n      <leaflet lf-center=\"$ctrl.mapa.centro\" defaults=\"$ctrl.mapa.defaults\" maxbounds=\"$ctrl.mapa.maxbounds\" ccontroles=\"$ctrl.mapa.controls\" layers=\"$ctrl.myLayers\" height=\"400px\" width=\"100%\" markers=\"$ctrl.mapa.marcadores\"></leaflet>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-6 col-lg-4\">\n      <c-input-numeric name=\"plazo_ejecucion\" label=\"Plazo de ejecución (días calendario)\" ng-model=\"$ctrl.proyecto.beneficiarios.plazo_ejecucion\"\n        ng-minvalue=\"0\" ng-maxvalue=\"999999\" ng-formatting=\"false\" ng-decimals=\"0\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"\n        ng-blur=\"$ctrl.plazoEjecucion()\"></c-input-numeric>\n    </div>\n    <div class=\"col-md-6 col-lg-4\" ng-if=\"$ctrl.proyecto.beneficiarios || $ctrl.editarBeneficiarios()\">\n      <select-parametro name=\"tamanio_proyecto\" label=\"Tamaño del proyecto\" ng-model=\"$ctrl.proyecto.beneficiarios.tamanio_proyecto\" parametro=\"OP_TAMANIO_PROYECTO\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"></select-parametro>\n    </div>\n    <div class=\"col-md-6 col-lg-4\" ng-if=\"$ctrl.proyecto.beneficiarios || $ctrl.editarBeneficiarios()\">\n      <select-parametro name=\"tipo_financiamiento\" label=\"Tipo de financiamiento\" ng-model=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento\" parametro=\"OP_TIPO_FINANCIAMIENTO\"\n        ng-change=\"$ctrl.selTipoFinanciamiento(item)\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"></select-parametro>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-6 col-lg-4\" ng-if=\"$ctrl.proyecto.beneficiarios || $ctrl.editarBeneficiarios()\">\n      <select-parametro name=\"tipo\" label=\"Tipo de proyecto\" ng-model=\"$ctrl.proyecto.beneficiarios.tipo\" parametro=\"OP_TIPO_PROYECTO\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"  ng-change=\"$ctrl.setIndicadores(); $ctrl.cambiarUnidades(); $ctrl.limpiarMatriz()\"></select-parametro>\n    </div>\n    <div class=\"col-md-6 col-lg-4\" ng-if=\"$ctrl.proyecto.beneficiarios.tipo == 'OP_TP_PRODUCTIVO'\">\n      <select-parametro name=\"tipo\" label=\"Subclasificación Proyecto Productivo\" ng-model=\"$ctrl.proyecto.beneficiarios.subtipo_productivo\" parametro=\"ST_PROY_PRODUCTIVO\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios') && $ctrl.proyecto.beneficiarios.tipo=='OP_TP_PRODUCTIVO'\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"></select-parametro>\n    </div>\n    <div class=\"col-md-6 col-lg-4\" ng-if=\"$ctrl.proyecto.beneficiarios.tipo == 'OP_TP_PRODUCTIVO' && $ctrl.editarIndicadores()\">\n      <button class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.adicionarIndicador()\" uib-tooltip=\"Agregar nuevo indicador\">\n        <i class=\"fa fa-plus\"></i>\n      </button>\n    </div>\n  </div>\n\n  <div ng-if=\"$ctrl.proyecto.beneficiarios.tipo !== 'OP_TP_PRODUCTIVO' && false\">\n    <div class=\"row\">\n      <div class=\"col-md-4 col-lg-4\">\n        <!-- c-input name=\"indicadores_impacto_numero\" label=\"Indicadores de Impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_numero\"\n        ng-directives=\"uppercase\" maxlength=\"10\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\" ng-blur=\"$ctrl.combinarIndicadoresImpacto(); $ctrl.actualizarIndicadoresImpacto()\"></c-input -->\n        <c-input-numeric name=\"indicadores_impacto_numero\" label=\"Indicadores de Impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_numero\"\n          ng-minvalue=\"0\" ng-maxvalue=\"999999999\" ng-formatting=\"false\" ng-decimals=\"2\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\"\n          ng-blur=\"$ctrl.combinarIndicadoresImpacto(); $ctrl.actualizarIndicadoresImpacto()\"></c-input-numeric>\n      </div>\n      <!-- Casos tipo Riego y Puentes -->\n      <div class=\"col-md-6 col-lg-4\" ng-if=\"($ctrl.proyecto.beneficiarios && $ctrl.proyecto.beneficiarios.tipo !== 'OP_TP_PRODUCTIVO')\">\n        <c-input name=\"indicadores_impacto_unidades\" label=\"Unidades de indicador de impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_unidades\"\n        ng-directives=\"uppercase\" maxlength=\"255\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\" ng-blur=\"$ctrl.combinarIndicadoresImpacto()\"></c-input>\n      </div>\n      <!-- Caso tipo Productivo -->\n      <div class=\"col-md-4 col-lg-4\" ng-if=\"($ctrl.proyecto.beneficiarios && $ctrl.proyecto.beneficiarios.tipo == 'OP_TP_PRODUCTIVO')\">\n        <!--select-parametro name=\"indicadores_impacto_unidades\" label=\"Unidades de indicador de impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_unidades\" parametro=\"UNIDAD\"\n        select-model=\"'nombre'\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\" ng-change=\"$ctrl.combinarIndicadoresImpacto()\"></select-parametro-->\n        <c-input ng-if=\"$ctrl.seleccion_unidades.length == 1\" name=\"indicadores_impacto_unidades\" label=\"Unidades de indicador de impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_unidades\" maxlength=\"255\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"true\" ng-blur=\"$ctrl.combinarIndicadoresImpacto()\"></c-input>\n\n        <c-select ng-if=\"$ctrl.seleccion_unidades.length > 1\" name=\"indicadores_impacto_unidades\" label=\"Unidades de indicador de impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_unidades\"\n            options=\"$ctrl.seleccion_unidades\"\n            ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n            ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\" ng-change=\"$ctrl.combinarIndicadoresImpacto()\">\n        </c-select>\n      </div>\n      <!-- Caso tipo Productivo \"Otro\" -->\n      <div class=\"col-md-4 col-lg-4\" ng-if=\"($ctrl.proyecto.beneficiarios.indicadores_impacto_unidades.codigo == 'Otro')\">\n        <c-input name=\"indicadores_impacto_otro\" label=\"Especifique las unidades del indicador de impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_otro\"\n        ng-directives=\"uppercase\" maxlength=\"255\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios') && $ctrl.proyecto.beneficiarios && $ctrl.proyecto.beneficiarios.indicadores_impacto_unidades == 'OTRO'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\" ng-blur=\"$ctrl.combinarIndicadoresImpacto()\"></c-input>\n      </div>\n    </div>\n  </div>\n\n  <div ng-repeat=\"(keyIndicador,indicador) in $ctrl.proyecto.beneficiarios.indicadores_impacto\">\n    <div class=\"row\">\n      <div class=\"col-md-1 col-lg-1\">\n        <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1\" ng-click=\"$ctrl.eliminarIndicador(keyIndicador)\"\n          ng-if=\"$ctrl.proyecto.beneficiarios.tipo == 'OP_TP_PRODUCTIVO' && $ctrl.editarIndicadores()\" uib-tooltip=\"Eliminar indicador\">\n          <i class=\"fa fa-trash-o\"></i>\n        </button>\n      </div>\n      <div class=\"col-md-3 col-lg-2\">\n        <c-input-numeric name=\"indicadores_impacto_numero_{{keyIndicador}}\" label=\"Indicador de impacto\" ng-model=\"indicador.numero\"\n          ng-minvalue=\"0\" ng-maxvalue=\"999999999\" ng-formatting=\"false\" ng-decimals=\"2\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"\n          ng-blur=\"$ctrl.combinarIndicadoresImpacto(keyIndicador); $ctrl.actualizarIndicadoresImpacto(keyIndicador)\"></c-input-numeric>\n      </div>\n      <!-- Casos tipo Riego y Puentes -->\n      <div class=\"col-md-3 col-lg-2\" ng-if=\"($ctrl.proyecto.beneficiarios && $ctrl.proyecto.beneficiarios.tipo !== 'OP_TP_PRODUCTIVO')\">\n        <c-input name=\"indicadores_impacto_unidades_{{keyIndicador}}\" label=\"Unidades de indicador de impacto\" ng-model=\"indicador.unidades\"\n        ng-directives=\"uppercase\" maxlength=\"255\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\" ng-blur=\"$ctrl.combinarIndicadoresImpacto(keyIndicador)\"></c-input>\n      </div>\n      <!-- Caso tipo Productivo -->\n      <div class=\"col-md-3 col-lg-2\" ng-if=\"($ctrl.proyecto.beneficiarios && $ctrl.proyecto.beneficiarios.tipo == 'OP_TP_PRODUCTIVO')\">\n        <c-input ng-if=\"$ctrl.seleccion_unidades.length == 1\" name=\"indicadores_impacto_unidades_{{keyIndicador}}\" label=\"Unidades de indicador de impacto\" ng-model=\"indicador.unidades\" maxlength=\"255\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"true\" ng-blur=\"$ctrl.combinarIndicadoresImpacto(keyIndicador)\"></c-input>\n\n        <c-select ng-if=\"$ctrl.seleccion_unidades.length > 1\" name=\"indicadores_impacto_unidades_{{keyIndicador}}\" label=\"Unidades de indicador de impacto\" ng-model=\"indicador.unidades\"\n            options=\"$ctrl.seleccion_unidades\"\n            ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n            ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\" ng-change=\"$ctrl.combinarIndicadoresImpacto(keyIndicador)\">\n        </c-select>\n      </div>\n      <!-- Caso tipo Productivo \"Otro\" -->\n      <div class=\"col-md-3 col-lg-2\" ng-if=\"(indicador.unidades.codigo == 'Otro')\">\n        <c-input name=\"indicadores_impacto_otro_{{keyIndicador}}\" label=\"Unidades de indicador de impacto (Otro)\" ng-model=\"indicador.otro\"\n        ng-directives=\"uppercase\" maxlength=\"255\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios') && $ctrl.proyecto.beneficiarios && $ctrl.proyecto.beneficiarios.indicadores_impacto_unidades[keyIndicador] == 'OTRO'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\" ng-blur=\"$ctrl.combinarIndicadoresImpacto(keyIndicador)\"></c-input>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\">\n    <div class=\"col-md-12\">\n      <c-input name=\"nombre-componente-publico\" label=\"Nombre Formal del Componente Público\" ng-model=\"$ctrl.proyecto.financiamiento.nombre_componente_publico\"\n        ng-minlength=\"3\" maxlength=\"255\"\n        ng-directives=\"uppercase\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\"></c-input>\n      </div>\n    </div>\n  </div>\n</section>\n<section ng-if=\"$ctrl.proyecto.beneficiarios.tipo == 'OP_TP_PRODUCTIVO' && $ctrl.sectorProductivo.length > 1\">\n  <h6 class=\"title-section m-top\">Productivo</h6>\n  <div class=\"row\">\n    <div class=\"col-12\">\n        <formly-form class=\"row\" model=\"$ctrl.proyecto.beneficiarios.productivo\" fields=\"$ctrl.sectorProductivo\"></formly-form>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	module.exports = "<section ng-init=\"$ctrl.proyecto.beneficiarios.$_plantilla=1; $ctrl.proyecto.beneficiarios.$_nombre='beneficiarios'\">\n  <h6 class=\"title-section m-top\"></h6>\n  <div class=\"row\">\n    <div class=\"md-input-group col-lg-1\">\n      <c-input name=\"nro_comunidades\" label=\"Cant.\" ng-model=\"$ctrl.proyecto.beneficiarios.nro_comunidades\" ng-disabled=\"true\"></c-input>\n      <button type=\"button\" class=\"btn btn-md btn-success\" ng-if=\"$ctrl.ver_comunidades && !$ctrl.modoVista && $ctrl.editarBeneficiarios()\" ng-click=\"$ctrl.agregarComunidad()\"><i class=\"fa fa-plus-circle\"></i></button>\n      <button type=\"button\" class=\"btn btn-md btn-success\" ng-if=\"!$ctrl.modoVista && $ctrl.editarBeneficiarios()\" ng-click=\"$ctrl.agregarComunidades()\"><i class=\"fa fa-list-alt\"></i></button>\n      <button type=\"button\" class=\"btn btn-secondary\" ng-if=\"!$ctrl.modoVista && $ctrl.editarBeneficiarios()\" style=\"background-color:orange;\" ng-click=\"$ctrl.extraerComunidades()\"><i class=\"fa fa-book\"></i></button>\n    </div>\n    <div class=\"col-lg-5\" ng-if=\"!$ctrl.ver_comunidades\">\n      <div class=\"alert alert-info\">\n        <i class=\"fa fa-info-circle\"></i>\n        <span>Añada una lista de comunidades por fila.<br>El formato es: COMUNIDAD|LAT|LNG y/o COMUNIDAD|ZONA|X|Y</span>\n      </div>\n      <c-textarea name=\"lista_comunidades\" ng-model=\"$ctrl.lista_comunidades\" label=\"Listado de Comunidades\" rows=\"10\"></c-textarea>\n      <button class=\"btn btn-sm btn-success pull-right\" ng-click=\"$ctrl.agregarComunidadesImportar()\"><i class=\"fa fa-plus\"></i> Agregar Comunidades</button>\n      <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"$ctrl.limpiarListaComunidades()\"><i class=\"fa fa-trash\"></i> Limpiar</button>\n    </div>\n    <div class=\"col-lg-5\" ng-if=\"$ctrl.ver_comunidades\">\n      <div class=\"row\" ng-repeat=\"comunidad in $ctrl.proyecto.beneficiarios.comunidades\">\n        <div class=\"md-input-group col-md-2\">\n          <div class=\"md-form-group\" md-event-label=\"\">\n            <input name=\"nro{{$index}}\" id=\"nro{{$index}}\" disabled=\"true\" readonly=\"true\" value=\"{{$index+1}}\" maxlength=\"255\" class=\"ng-valid ng-valid-pattern ng-valid-minlength ng-valid-maxlength ng-valid-required ng-not-empty ng-dirty ng-valid-parse ng-touched\" type=\"text\">\n            <label for=\"nro{{$index}}\" title=\"\" class=\"md-control-label ng-binding\" ng-class=\"{'requerido':$ctrl.ngRequired}\">Nro.</label>\n            <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form[$ctrl.name].$invalid &amp;&amp; $ctrl.form[$ctrl.name].$touched}\"></i>\n          </div>\n        </div>\n        <div class=\"md-input-group col-md-8\">\n          <c-input name=\"nombre{{$index}}\" label=\"Nombre\" ng-model=\"comunidad.nombre\"\n          maxlength=\"255\" ng-blur=\"$ctrl.renombrarComunidad($index,comunidad)\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\"></c-input>\n        </div>\n        <div class=\"md-input-group col-md-2\">\n          <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-if=\"!$ctrl.modoVista && $ctrl.editarBeneficiarios()\" ng-click=\"$ctrl.quitarComunidad($index)\"><i class=\"fa fa-trash\"></i></button>\n        </div>\n        <!--- UTM -->\n        <div ng-if=\"!$ctrl.noEditarCoordenadas()\" class=\"col-md-2\"></div>\n        <div ng-if=\"!$ctrl.noEditarCoordenadas()\" class=\"md-input-group col-md-2\">\n          <c-input-numeric name=\"coordenadas{{$index}}zona\" label=\"Zona\" ng-model=\"comunidad.coordenadas.zona\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\" ng-decimals=\"0\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input-numeric>\n        </div>\n        <div ng-if=\"!$ctrl.noEditarCoordenadas()\" class=\"md-input-group col-md-3\">\n          <c-input name=\"coordenadas{{$index}}este_x\" label=\"Este (X)\" ng-model=\"comunidad.coordenadas.este_x\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input>\n        </div>\n        <div ng-if=\"!$ctrl.noEditarCoordenadas()\" class=\"md-input-group col-md-3\">\n          <c-input name=\"coordenadas{{$index}}norte_y\" label=\"Norte (Y)\" ng-model=\"comunidad.coordenadas.norte_y\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input>\n        </div>\n        <div ng-if=\"!$ctrl.noEditarCoordenadas()\" class=\"col-md-2\"></div>\n        <!-- FIN UTM -->\n        <!-- DMS -->\n        <div class=\"md-input-group col-md-2\">\n          <c-input-numeric name=\"coordenadas{{$index}}degrees1\" label=\"°gra\" ng-model=\"comunidad.coordenadas.degrees1\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\" ng-decimals=\"0\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input-numeric>\n        </div>\n        <div class=\"md-input-group col-md-2\">\n          <c-input-numeric name=\"coordenadas{{$index}}minutes1\" label=\"' min\" ng-model=\"comunidad.coordenadas.minutes1\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\" ng-decimals=\"0\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input-numeric>\n        </div>\n        <div class=\"md-input-group col-md-3\">\n          <c-input name=\"coordenadas{{$index}}seconds1\" label=\"'' seg\" ng-model=\"comunidad.coordenadas.seconds1\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input>\n        </div>\n        <div class=\"md-input-group col-md-4\">\n          <c-input name=\"coordenadas{{$index}}direction1\" label=\"N, S, E, W\" ng-model=\"comunidad.coordenadas.direction1\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input>\n        </div>\n        <div class=\"md-input-group col-md-2\">\n          <c-input-numeric name=\"coordenadas{{$index}}degrees2\" label=\"°gra\" ng-model=\"comunidad.coordenadas.degrees2\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\" ng-decimals=\"0\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input-numeric>\n        </div>\n        <div class=\"md-input-group col-md-2\">\n          <c-input-numeric name=\"coordenadas{{$index}}minutes2\" label=\"' min\" ng-model=\"comunidad.coordenadas.minutes2\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\" ng-decimals=\"0\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input-numeric>\n        </div>\n        <div class=\"md-input-group col-md-3\">\n          <c-input name=\"coordenadas{{$index}}seconds2\" label=\"'' seg\" ng-model=\"comunidad.coordenadas.seconds2\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input>\n        </div>\n        <div class=\"md-input-group col-md-3\">\n          <c-input name=\"coordenadas{{$index}}direction2\" label=\"N, S, E, W\" ng-model=\"comunidad.coordenadas.direction2\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input>\n        </div>\n\n        <!-- FIN DMS -->\n        <div class=\"md-input-group col-md-4\">\n          <c-input name=\"coordenadas{{$index}}lat\" label=\"Latitud\" ng-model=\"comunidad.coordenadas.lat\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input>\n        </div>\n        <div class=\"md-input-group col-md-4\">\n          <c-input name=\"coordenadas{{$index}}lng\" label=\"Longitud\" ng-model=\"comunidad.coordenadas.lng\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"$ctrl.noEditarCoordenadas()\"\n          ng-blur=\"$ctrl.coordenadaManual($index,comunidad)\"></c-input>\n        </div>\n        <div class=\"col-md-2\"></div>\n        <!-- <div class=\"md-input-group col-md-16\">\n          <p><strong>Latitud:</strong> {{comunidad.coordenadas.lat}}</p>\n        </div>\n        <div class=\"md-input-group col-md-16\">\n          <p><strong>Longitud:</strong> {{comunidad.coordenadas.lng}}</p>\n        </div> -->\n      </div>\n    </div>\n    <div class=\"col-lg-6\" style=\"z-index:1\">\n      <leaflet lf-center=\"$ctrl.mapa.centro\" defaults=\"$ctrl.mapa.defaults\" maxbounds=\"$ctrl.mapa.maxbounds\" ccontroles=\"$ctrl.mapa.controls\" layers=\"$ctrl.myLayers\" height=\"400px\" width=\"100%\" markers=\"$ctrl.mapa.marcadores\"></leaflet>\n    </div>\n  </div>\n  <div class=\"row\">\n    <!-- <div class=\"col-md-4\">\n      <c-input-numeric name=\"nro_familias\" label=\"N° Familias Beneficiadas\" ng-model=\"$ctrl.proyecto.beneficiarios.nro_familias\"\n      ng-minvalue=\"0\" ng-maxvalue=\"999999\" ng-formatting=\"false\" ng-decimals=\"0\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\"></c-input-numeric>\n    </div> -->\n    <div class=\"col-md-6 col-lg-3\">\n      <c-input-numeric name=\"plazo_ejecucion\" label=\"Plazo de ejecución (días calendario)\" ng-model=\"$ctrl.proyecto.beneficiarios.plazo_ejecucion\"\n        ng-minvalue=\"0\" ng-maxvalue=\"999999\" ng-formatting=\"false\" ng-decimals=\"0\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"\n        ng-blur=\"$ctrl.plazoEjecucion()\"></c-input-numeric>\n    </div>\n    <div class=\"col-md-6 col-lg-1\" ng-if=\"$ctrl.proyecto.cartera == 4\">  <!--ng-if solo para cartera 4-->\n      <ui-help message=\"$ctrl.helpLang.nro_fam\" direction=\"top\"></ui-help>\n    <c-input-numeric name=\"cant_hombres\" label=\"N°Hombres\" ng-model=\"$ctrl.proyecto.beneficiarios.cant_hombres\"\n      ng-minvalue=\"0\" ng-maxvalue=\"99999999\" ng-formatting=\"false\" ng-decimals=\"0\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('beneficiarios')\"></c-input-numeric>\n      <c-input-numeric name=\"cant_mujeres\" label=\"N° Mujeres\" ng-model=\"$ctrl.proyecto.beneficiarios.cant_mujeres\"\n      ng-minvalue=\"0\" ng-maxvalue=\"99999999\" ng-formatting=\"false\" ng-decimals=\"0\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('beneficiarios')\"></c-input-numeric>\n    </div>\n    <div class=\"col-md-6 col-lg-4\" ng-if=\"$ctrl.proyecto.beneficiarios || $ctrl.editarBeneficiarios()\">\n      <select-parametro name=\"tamanio_proyecto\" label=\"Tamaño del proyecto\" ng-model=\"$ctrl.proyecto.beneficiarios.tamanio_proyecto\" parametro=\"OP_TAMANIO_PROYECTO\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"></select-parametro>\n    </div>\n    <div class=\"col-md-6 col-lg-4\" ng-if=\"$ctrl.proyecto.beneficiarios || $ctrl.editarBeneficiarios()\">\n      <select-parametro name=\"tipo_financiamiento\" label=\"Tipo de financiamiento\" ng-model=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento\" parametro=\"OP_TIPO_FINANCIAMIENTO\"\n        ng-change=\"$ctrl.selTipoFinanciamiento(item)\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"></select-parametro>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-6 col-lg-4\" ng-if=\"$ctrl.proyecto.beneficiarios || $ctrl.editarBeneficiarios()\">\n      <select-parametro name=\"tipo\" label=\"Tipo de proyecto\" ng-model=\"$ctrl.proyecto.beneficiarios.tipo\" parametro=\"OP_TIPO_PROYECTO\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"  ng-change=\"$ctrl.setIndicadores(); $ctrl.cambiarUnidades(); $ctrl.limpiarMatriz()\"></select-parametro>\n    </div>\n    <div class=\"col-md-6 col-lg-4\" ng-if=\"$ctrl.Proyecto.tratarComoProductivo($ctrl.proyecto)\">\n      <select-parametro name=\"tipo\" label=\"Subclasificación Proyecto Productivo\" ng-model=\"$ctrl.proyecto.beneficiarios.subtipo_productivo\" parametro=\"ST_PROY_PRODUCTIVO\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios') && $ctrl.Proyecto.tratarComoProductivo($ctrl.proyecto)\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"\n      ng-change=\"$ctrl.clearIndicadores();\"></select-parametro>\n    </div>\n    <div class=\"col-md-6 col-lg-4 d-flex align-items-center\" ng-if=\"$ctrl.Proyecto.tratarComoProductivo($ctrl.proyecto) && $ctrl.editarIndicadores()\">\n      <button class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.adicionarIndicador()\" uib-tooltip=\"Agregar nuevo indicador\">\n        <i class=\"fa fa-plus\" style=\"vertical-align: middle\"></i>\n      </button>\n    </div>\n  </div>\n\n  <div ng-if=\"$ctrl.proyecto.beneficiarios.tipo !== 'OP_TP_PRODUCTIVO' && false\">\n    <div class=\"row\">\n      <div class=\"col-md-4 col-lg-4\">\n        <!-- c-input name=\"indicadores_impacto_numero\" label=\"Indicadores de Impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_numero\"\n        ng-directives=\"uppercase\" maxlength=\"10\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\" ng-blur=\"$ctrl.combinarIndicadoresImpacto(); $ctrl.actualizarIndicadoresImpacto()\"></c-input -->\n        <c-input-numeric name=\"indicadores_impacto_numero\" label=\"Indicadores de Impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_numero\"\n          ng-minvalue=\"0\" ng-maxvalue=\"999999999\" ng-formatting=\"false\" ng-decimals=\"2\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\"\n          ng-blur=\"$ctrl.combinarIndicadoresImpacto(); $ctrl.actualizarIndicadoresImpacto()\"></c-input-numeric>\n      </div>\n      <!-- Casos tipo Riego y Puentes -->\n      <div class=\"col-md-6 col-lg-4\" ng-if=\"($ctrl.proyecto.beneficiarios && $ctrl.proyecto.beneficiarios.tipo !== 'OP_TP_PRODUCTIVO')\">\n        <c-input name=\"indicadores_impacto_unidades\" label=\"Unidades\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_unidades\"\n        ng-directives=\"uppercase\" maxlength=\"255\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\" ng-blur=\"$ctrl.combinarIndicadoresImpacto()\"></c-input>\n      </div>\n      <!-- Caso tipo Productivo -->\n      <div class=\"col-md-4 col-lg-4\" ng-if=\"($ctrl.proyecto.beneficiarios && $ctrl.proyecto.beneficiarios.tipo == 'OP_TP_PRODUCTIVO')\">\n        <!--select-parametro name=\"indicadores_impacto_unidades\" label=\"Unidades de indicador de impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_unidades\" parametro=\"UNIDAD\"\n        select-model=\"'nombre'\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\" ng-change=\"$ctrl.combinarIndicadoresImpacto()\"></select-parametro-->\n        <c-input ng-if=\"$ctrl.seleccion_unidades.length == 1\" name=\"indicadores_impacto_unidades\" label=\"Unidades\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_unidades\" maxlength=\"255\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"true\" ng-blur=\"$ctrl.combinarIndicadoresImpacto()\"></c-input>\n\n        <c-select ng-if=\"$ctrl.seleccion_unidades.length > 1\" name=\"indicadores_impacto_unidades\" label=\"Unidades\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_unidades\"\n            options=\"$ctrl.seleccion_unidades\"\n            ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n            ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\" ng-change=\"$ctrl.combinarIndicadoresImpacto()\">\n        </c-select>\n      </div>\n      <!-- Caso tipo Productivo \"Otro\" -->\n      <div class=\"col-md-4 col-lg-4\" ng-if=\"($ctrl.proyecto.beneficiarios.indicadores_impacto_unidades.codigo == 'Otro')\">\n        <c-input name=\"indicadores_impacto_otro\" label=\"Especifique las unidades del indicador de impacto\" ng-model=\"$ctrl.proyecto.beneficiarios.indicadores_impacto_otro\"\n        ng-directives=\"uppercase\" maxlength=\"255\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios') && $ctrl.proyecto.beneficiarios && $ctrl.proyecto.beneficiarios.indicadores_impacto_unidades == 'OTRO'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\" ng-blur=\"$ctrl.combinarIndicadoresImpacto()\"></c-input>\n      </div>\n    </div>\n  </div>\n\n  <div ng-repeat=\"(keyIndicador,indicador) in $ctrl.proyecto.beneficiarios.indicadores_impacto\">\n    <div class=\"row\">\n      <div class=\"col-md-1 col-lg-1 d-flex align-items-center justify-content-end\">\n        <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1\" ng-click=\"$ctrl.eliminarIndicador(keyIndicador)\"\n          ng-if=\"$ctrl.Proyecto.tratarComoProductivo($ctrl.proyecto) && $ctrl.editarIndicadores()\" uib-tooltip=\"Eliminar indicador\">\n          <i class=\"fa fa-trash-o\"></i>\n        </button>\n      </div>\n      <div class=\"col-md-3 col-lg-2\">\n        <c-input-numeric name=\"indicadores_impacto_numero_{{keyIndicador}}\" label=\"Indicador de impacto\" ng-model=\"indicador.numero\"\n          ng-minvalue=\"0\" ng-maxvalue=\"999999999\" ng-formatting=\"false\" ng-decimals=\"2\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"\n          ng-blur=\"$ctrl.combinarIndicadoresImpacto(keyIndicador); $ctrl.actualizarIndicadoresImpacto(keyIndicador)\"></c-input-numeric>\n      </div>\n      <!-- Casos tipo Riego y Puentes -->\n      <div class=\"col-md-3 col-lg-2\" ng-if=\"$ctrl.proyecto.beneficiarios && !$ctrl.Proyecto.tratarComoProductivo($ctrl.proyecto)\">\n        <c-input name=\"indicadores_impacto_unidades_{{keyIndicador}}\" label=\"Unidades\" ng-model=\"indicador.unidades\"\n        ng-directives=\"uppercase\" maxlength=\"255\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\" ng-blur=\"$ctrl.combinarIndicadoresImpacto(keyIndicador)\"></c-input>\n      </div>\n      <!-- Caso tipo Productivo -->\n      <div class=\"col-md-3 col-lg-2\" ng-if=\"$ctrl.proyecto.beneficiarios && $ctrl.Proyecto.tratarComoProductivo($ctrl.proyecto)\">\n        <c-input ng-if=\"$ctrl.seleccion_unidades.length == 1\" name=\"indicadores_impacto_unidades_{{keyIndicador}}\" label=\"Unidades\" ng-model=\"indicador.unidades\" maxlength=\"255\"\n          ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n          ng-disabled=\"true\" ng-blur=\"$ctrl.combinarIndicadoresImpacto(keyIndicador)\"></c-input>\n\n        <c-select ng-if=\"$ctrl.seleccion_unidades.length > 1\" name=\"indicadores_impacto_unidades_{{keyIndicador}}\" label=\"Unidades\" ng-model=\"indicador.unidades\"\n            options=\"$ctrl.seleccion_unidades\"\n            ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n            ng-change=\"$ctrl.combinarIndicadoresImpacto(keyIndicador)\"\n            ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"><!--ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\"-->\n        </c-select>\n      </div>\n      <!-- Caso tipo Productivo \"Otro\" -->\n      <div class=\"col-md-3 col-lg-2\" ng-if=\"(indicador.unidades.codigo == 'Otro')\">\n        <c-input name=\"indicadores_impacto_otro_{{keyIndicador}}\" label=\"Unidades (otro)\" ng-model=\"indicador.otro\"\n        ng-directives=\"uppercase\" maxlength=\"255\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios') && $ctrl.proyecto.beneficiarios && $ctrl.proyecto.beneficiarios.indicadores_impacto_unidades[keyIndicador] == 'OTRO'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarIndicadores()\" ng-blur=\"$ctrl.combinarIndicadoresImpacto(keyIndicador)\"></c-input>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\">\n    <div class=\"col-md-12\">\n      <c-input name=\"nombre-componente-publico\" label=\"Nombre Formal del Componente Público\" ng-model=\"$ctrl.proyecto.financiamiento.nombre_componente_publico\"\n        ng-minlength=\"3\" maxlength=\"255\"\n        ng-directives=\"uppercase\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.editarBeneficiarios()\"></c-input>\n      </div>\n    </div>\n  </div>\n</section>\n<!-- lo cambie > a >= en la condicion porque no mostraba esta seccion -->\n<section ng-if=\"$ctrl.Proyecto.tratarComoProductivo($ctrl.proyecto) && $ctrl.sectorProductivo.length >= 1\">\n  <h6 class=\"title-section m-top\">Productivo</h6>\n  <div class=\"row\">\n    <div class=\"col-12\">\n        <formly-form class=\"row\" model=\"$ctrl.proyecto.beneficiarios.productivo\" fields=\"$ctrl.sectorProductivo\"></formly-form>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Select Comunidad</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n\n  <div class=\"form-check\" ng-repeat=\"comun in $ctrl.data.datos\">\n    <input class=\"form-check-input\" type=\"checkbox\" ng-model=\"comun.seleccionado\" id=\"{{comun.fid}}\">\n    <label class=\"form-check-label\" for=\"{{comun.fid}}\">\n      {{comun.comunidad}}\n    </label>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\"  ng-click=\"$ctrl.aceptar()\">\n    <i class=\"fa fa-check\"></i> aceptar\n  </button>\n</div>\n"

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	module.exports = "<section ng-init=\"$ctrl.proyecto.beneficiarios.$_plantilla=1; $ctrl.proyecto.beneficiarios.$_nombre='beneficiarios'\">\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-file-text-o\"></i> Solicitud de Proyecto\n  </h6>\n  <div class=\"row\">\n    <div class=\"col-12\">\n      <div class=\"alert alert-info\" ng-if=\"$ctrl.proyecto.nro_convenio_referencia\">\n        <i class=\"fa fa-info-circle\"></i>\n        <span>El número de código del proyecto original es {{$ctrl.proyecto.nro_convenio_referencia}}.</span>\n      </div>\n      <div class=\"alert alert-info\" ng-if=\"!$ctrl.proyecto.estado && !$ctrl.proyecto.nro_convenio_referencia\">\n        <i class=\"fa fa-info-circle\"></i>\n        <span>El número de código {{$ctrl.proyecto.nro_convenio}} se confirma al momento de enviar este formulario, por lo que puede cambiar si otro usuario envia su solicitud antes que Usted.</span>\n      </div>\n      <div class=\"alert alert-warning\" ng-if=\"$ctrl.proyecto.motivo_rechazo\">\n        <i class=\"fa fa-info-circle\"></i>\n        <span><strong>Motivo de Rechazo:</strong> {{$ctrl.proyecto.motivo_rechazo}}</span><br><br>\n        <button md-effect type=\"button\" class=\"btn btn-danger\" uib-tooltip=\"Descargar Informe de Rechazo\"\n                download-file=\"{{ $ctrl.descarga.urlDescarga }}\" file-name=\"{{ $ctrl.descarga.nombreDescarga }}\">\n          <i class=\"fa fa-download\"></i> Informe de Rechazo\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-2\">\n      <c-input name=\"codigo1\" label=\"Código\" ng-model=\"$ctrl.proyecto.cite_codigo\" ng-disabled=\"true\"></c-input><!--ng-disabled=\"true\" 2022-->\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input name=\"codigo2\" label=\"Número\" ng-model=\"$ctrl.proyecto.cite_nro\" ng-disabled=\"!$ctrl.puedeModificarCodigo('nro_convenio')\"></c-input><!--ng-disabled=\"!$ctrl.puedeModificarCodigo('nro_convenio')\" 2022-->\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-date name=\"fecha_recepcion\" label=\"Fecha de recepción\" ng-model=\"$ctrl.proyecto.fecha_suscripcion_convenio\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fecha_suscripcion_convenio')\" ng-disabled=\"!$ctrl.puedeModificarCodigo('fecha_suscripcion_convenio')\"></c-date>\n    <!--ng-disabled=\"!$ctrl.puedeModificarCodigo('fecha_suscripcion_convenio')\"-->\n    </div>\n\n    <div class=\"md-input-group col-md-4 ng-hide\" ng-if=\"$ctrl.proyecto.codigo\">\n      <c-input name=\"codigo3\" label=\"Codigo\" ng-model=\"$ctrl.proyecto.codigo\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\" ng-if=\"$ctrl.puedeModificarCodigo()\">\n      <button md-effect type=\"button\" class=\"btn btn-warning\" uib-tooltip=\"Corregir código y fecha\"\n              ng-click=\"$ctrl.corregirDatosGenerales()\">\n        <i class=\"fa fa-download\"></i> Modificar\n      </button>\n    </div>\n    <div class=\"col-md-12\" ng-if=\"$ctrl.validarCite()\">\n      <div class=\"bg-danger\">\n        Error en el formato del número, debe ser de la forma 0001-2018.\n      </div>\n    </div>\n    <div class=\"col-md-12\" ng-if=\"$ctrl.proyecto.duplicados\">\n      Proyectos con código {{$ctrl.proyecto.nro_convenio}}:\n      <ul ng-class=\"{'bg-warning':$ctrl.proyecto.duplicados}\" style=\"font-size:10px\">\n        <li ng-repeat=\"nom in $ctrl.proyecto.duplicados\">{{nom}}</li>\n      </ul>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-6\">\n      <c-input name=\"procedencia\" label=\"Procedencia\" ng-model=\"$ctrl.proyecto.entidad_beneficiaria\"\n      ng-minlength=\"3\" maxlength=\"255\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('entidad_beneficiaria')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('entidad_beneficiaria')\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-6\" style=\"margin-top: 20px;\">\n        <!-- <input class=\"form-check-input\"  type=\"checkbox\" ng-model=\"$ctrl.proyecto.org_sociales\" id=\"flexCheckDefault\">\n        <label class=\"form-check-label\" for=\"flexCheckDefault\">Es organizacion social</label> -->\n        <c-checkbox name=\"org_sociales\" label=\"Es organizacion social\"\n        ng-model=\"$ctrl.proyecto.org_sociales\" ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('entidad_beneficiaria')\"></c-checkbox>\n    </div>\n\n    <div class=\"col-md-12\">\n      <c-select-dpa ng-model=\"$ctrl.proyecto.dpa\" horizontal=\"true\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fcod_municipio')\"\n      ng-disabled=\"$ctrl.modificarUbicacion()\"></c-select-dpa>\n    </div>\n\n    <div class=\"md-input-group col-md-12\">\n      <c-input name=\"referencia\" label=\"Referencia\" ng-model=\"$ctrl.proyecto.beneficiarios.referencia\"\n      ng-minlength=\"3\" maxlength=\"255\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('referencia')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('referencia')\"></c-input>\n    </div>\n\n    <div class=\"md-input-group col-md-12\">\n      <c-input name=\"nombre\" label=\"Nombre del Proyecto\" ng-model=\"$ctrl.proyecto.nombre\"\n      ng-minlength=\"3\" maxlength=\"255\"\n      ng-directives=\"uppercase\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('nombre')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('nombre')\"></c-input>\n    </div>\n\n    <div class=\"col-md-4\">\n      <c-input-numeric name=\"nro_familias\" label=\"N° Familias Beneficiadas\" ng-model=\"$ctrl.proyecto.beneficiarios.nro_familias\"\n      ng-minvalue=\"0\" ng-maxvalue=\"99999999\" ng-formatting=\"false\" ng-decimals=\"0\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('beneficiarios')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('beneficiarios')\"></c-input-numeric>\n    </div>\n    <div class=\"col-md-6\">\n      <c-select name=\"select\" label=\"Cartera\" placeholder=\"Seleccione Cartera\" ng-model=\"$ctrl.proyecto.cartera\" ng-required=\"true\" ng-disabled=\"!$ctrl.Proyecto.esEditable('cartera')\" options=\"$ctrl.carteras\" field=\"descripcion\" key-value=\"id_cartera\"></c-select>\n    </div>\n\n    <div class=\"col-md-12\" ng-if=\"$ctrl.proyecto.sector || $ctrl.Proyecto.esEditable('sector')\">\n      <select-parametro name=\"sector\" label=\"Sector\" ng-model=\"$ctrl.proyecto.sector\" parametro=\"SECTOR\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('sector')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('sector')\"></select-parametro>\n    </div>\n\n  </div>\n</section>\n"

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	module.exports = "<section ng-init=\"$ctrl.proyecto.cronograma_desembolsos.$_plantilla=6; $ctrl.proyecto.cronograma_desembolsos.$_nombre='cronograma_desembolsos'\">\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Registro de desembolsos / Cronograma {{$ctrl.proyecto.estado_proyecto}}\n  </h6>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"codigo_mefp\" label=\"Categoría Programática\" ng-model=\"$ctrl.proyecto.cronograma_desembolsos.categoria_programatica\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fecha_desembolso')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\" ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento != 'OP_TF_MIXTA'\">\n      </c-input>\n\n      <c-input name=\"codigo_mefp\" label=\"Categoría Programática Pública\" ng-model=\"$ctrl.proyecto.cronograma_desembolsos.categoria_programatica\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fecha_desembolso')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\" ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\">\n      </c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"codigo_sisin\" label=\"Código SISIN\" ng-model=\"$ctrl.proyecto.cronograma_desembolsos.codigo_sisin\"\n        ng-required=\"!$ctrl.modoVista && ($ctrl.proyecto.beneficiarios.tipo_financiamiento !== 'OP_TF_PRIVADA')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('cod_sisin')\">\n      </c-input>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\">\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"codigo_mefp2\" label=\"Categoría Programática Privada\" ng-model=\"$ctrl.proyecto.cronograma_desembolsos.categoria_programatica_2\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fecha_desembolso')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\">\n      </c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"codigo_sisin2\" label=\"SISIN TPP\" ng-model=\"$ctrl.proyecto.cronograma_desembolsos.codigo_tpp\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fecha_desembolso')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\">\n      </c-input>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-3\">\n      <c-date name=\"fecha_inscripcion\" label=\"Fecha de inscripción presupuestaria\"\n              ng-model=\"$ctrl.proyecto.cronograma_desembolsos.fecha_inscripcion\"\n              ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fecha_desembolso')\"\n              ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\"\n              ng-change=\"$ctrl.selFechaInscripcion()\"\n              min-date=\"$ctrl.validacion.fec_min_inscripcion\" mensaje-min-date=\"{{$ctrl.validacion.mensaje_fecminima}}\">\n      </c-date>\n    </div>\n    <div class=\"col-md-3\" ng-if=\"$ctrl.proyecto.doc_cert_presupuestaria || $ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\">\n      <archivo name=\"doc_cert_presupuestaria\" label=\"Certificado de Transferencia 1\" ng-model=\"$ctrl.proyecto.doc_cert_presupuestaria\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\"\n              url=\"{{$ctrl.archivo.urlDocCertificacion}}\"\n              url-descarga=\"{{$ctrl.archivo.urlDocCertificacionDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\">\n      </archivo>\n    </div>\n    <div class=\"col-md-3\" ng-if=\"$ctrl.proyecto.doc_cert_presupuestaria || $ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\">\n      <archivo name=\"doc_cert_presupuestaria2\" label=\"Certificado de Transferencia 2\" ng-model=\"$ctrl.proyecto.doc_cert_presupuestaria2\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\"\n              url=\"{{$ctrl.archivo.urlDocCertificacion2}}\"\n              url-descarga=\"{{$ctrl.archivo.urlDocCertificacionDescarga2}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_cert_presupuestaria2')\"\n              ng-if=\"$ctrl.proyecto.doc_cert_presupuestaria\">\n      </archivo>\n    </div>\n    <div class=\"col-md-3\" ng-if=\"$ctrl.proyecto.doc_cert_presupuestaria || $ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\">\n      <archivo name=\"doc_cert_presupuestaria3\" label=\"Certificado de Transferencia 3\" ng-model=\"$ctrl.proyecto.doc_cert_presupuestaria3\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\"\n              url=\"{{$ctrl.archivo.urlDocCertificacion3}}\"\n              url-descarga=\"{{$ctrl.archivo.urlDocCertificacionDescarga3}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_cert_presupuestaria3')\"\n              ng-if=\"$ctrl.proyecto.doc_cert_presupuestaria2\">\n      </archivo>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-2\">\n      \n    </div>\n    <div class=\"md-input-group col-md-2\">\n      \n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"monto-privado\" label=\"Monto-privado-disp.\"\n        ng-model=\"$ctrl.monto_privado\"\n        ng-minvalue=\"0\" ng-disabled=\"true\"\n        ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\">\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"monto-publico\" label=\"Monto-publico-disp\"\n        ng-model=\"$ctrl.monto_publico\"\n        ng-minvalue=\"0\" ng-disabled=\"true\"\n        ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\">\n      </c-input-money>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-2\">\n      <c-input-numeric name=\"porcentaje_1\" label=\"1er Desembolso %\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.porcentaje_1\"\n        ng-minvalue=\"0\" ng-maxvalue=\"100\" ng-formatting=\"false\" ng-decimals=\"2\" ng-keyup=\"$ctrl.recalcularPorcentaje()\" ng-disabled=\"true\" >\n      </c-input-numeric>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"monto_1\" label=\"Monto\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.monto_1\"\n        ng-minvalue=\"0\"  ng-keyup=\"$ctrl.recalcularPorcentaje()\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\">\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"priv_1\" label=\"Monto Priv.1\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.priv1\"\n        ng-keyup=\"$ctrl.sumaMontos(); $ctrl.recalcularPorcentaje()\"\n        ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\"\n        ng-minvalue=\"0\">\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"pub_1\" label=\"Monto Public.1\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.pub1\"\n        ng-keyup=\"$ctrl.sumaMontos(); $ctrl.recalcularPorcentaje()\"\n        ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\"\n        ng-minvalue=\"0\">\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-date name=\"fecha_1\" label=\"Fecha de desembolso\"\n              ng-model=\"$ctrl.proyecto.cronograma_desembolsos.fecha_1\"\n              ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('cronograma_desembolsos')\"\n              ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\"\n              ng-change=\"$ctrl.selFechaDesembolso()\"\n              min-date-key=\"fecha_inscripcion\" mensaje-min-date=\"{{$ctrl.validacion.mensaje_fecminima_desembolso1}}\">\n      </c-date>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-2\">\n      <c-input-numeric name=\"porcentaje_2\" label=\"2do Desembolso %\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.porcentaje_2\"\n        ng-minvalue=\"0\" ng-maxvalue=\"100\" ng-formatting=\"false\" ng-decimals=\"2\" ng-keyup=\"$ctrl.recalcularPorcentaje()\" ng-disabled=\"true\">\n      </c-input-numeric>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"monto_2\" label=\"Monto\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.monto_2\"\n        ng-minvalue=\"0\" ng-keyup=\"$ctrl.recalcularPorcentaje()\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso2')\">\n         <!-- ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso') || !$ctrl.proyecto.beneficiarios.productivo.maquinaria\"> -->\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"priv_2\" label=\"Monto Priv.2\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.priv2\"\n        ng-keyup=\"$ctrl.sumaMontos(); $ctrl.recalcularPorcentaje()\"\n        ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso2')\"\n        ng-minvalue=\"0\">\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"pub_2\" label=\"Monto Public.2\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.pub2\"\n        ng-keyup=\"$ctrl.sumaMontos(); $ctrl.recalcularPorcentaje()\"\n        ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso2')\"\n        ng-minvalue=\"0\">\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-2\" >\n      <c-date name=\"fecha_2\" label=\"Fecha de desembolso\"\n              ng-model=\"$ctrl.proyecto.cronograma_desembolsos.fecha_2\"\n              \n              ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso2')\"\n              min-date-key=\"fecha_1\" mensaje-min-date=\"{{$ctrl.validacion.mensaje_fecminima_desembolso2}}\">\n      </c-date>\n      <!-- ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('cronograma_desembolsos')\" -->\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-2\">\n      <c-input-numeric name=\"porcentaje_3\" label=\"3er Desembolso %\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.porcentaje_3\"\n        ng-minvalue=\"0\" ng-maxvalue=\"100\" ng-formatting=\"false\" ng-decimals=\"2\" ng-keyup=\"$ctrl.recalcularPorcentaje()\" ng-disabled=\"true\">\n      </c-input-numeric>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"monto_3\" label=\"Monto\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.monto_3\"\n        ng-minvalue=\"0\" ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso3')\"\n        ng-keyup=\"$ctrl.recalcularPorcentaje()\">\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"priv_3\" label=\"Monto Priv.3\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.priv3\"\n        ng-keyup=\"$ctrl.sumaMontos(); $ctrl.recalcularPorcentaje()\"\n        ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso3')\"\n        ng-minvalue=\"0\">\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-2\">\n      <c-input-money name=\"pub_3\" label=\"Monto Public.3\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.pub3\"\n        ng-keyup=\"$ctrl.sumaMontos(); $ctrl.recalcularPorcentaje()\"\n        ng-if=\"$ctrl.proyecto.beneficiarios.tipo_financiamiento == 'OP_TF_MIXTA'\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso3')\"\n        ng-minvalue=\"0\">\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-2\" >\n      <c-date name=\"fecha_3\" label=\"Fecha de desembolso\"\n              ng-model=\"$ctrl.proyecto.cronograma_desembolsos.fecha_3\"\n             \n              ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolos3')\"\n              min-date-key=\"fecha_2\" mensaje-min-date=\"{{$ctrl.validacion.mensaje_fecminima_desembolso2}}\">\n      </c-date>\n       <!-- ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('cronograma_desembolsos')\" -->\n    </div>\n  </div>\n\n  <div class=\"row\" ng-if=\"$ctrl.proyecto.cronograma_desembolsos.porcentaje_4\">\n    <div class=\"md-input-group col-md-4\">\n      <c-input-numeric name=\"porcentaje_4\" label=\"Saldo %\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.porcentaje_4\"\n        ng-minvalue=\"0\" ng-maxvalue=\"100\" ng-formatting=\"false\" ng-decimals=\"2\" ng-disabled=\"true\">\n      </c-input-numeric>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input-money name=\"monto_4\" label=\"Monto\"\n        ng-model=\"$ctrl.proyecto.cronograma_desembolsos.monto_4\"\n        ng-minvalue=\"0\" ng-disabled=\"true\">\n      </c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n    </div>\n  </div>\n\n</section>\n"

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	module.exports = "<span ng-if=\"$ctrl.puedeAcceder()\">\n  <button md-effect type=\"button\" class=\"btn btn-secondary btn-actions\" ng-click=\"$ctrl.cancelar()\" ng-if=\"$ctrl.opcionCancelar\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <span ng-repeat=\"accion in $ctrl.elemento.estado_actual.acciones\" ng-if=\"accion.tipo === 'boton'\">\n    <button md-effect type=\"button\"\n      class=\"btn btn-actions c-pointer {{accion.class}}\"\n      validar-formulario=\"(accion.observacion || accion.rechazar || accion.guardar) ? false : $ctrl.form\"\n      validacion-paralela=\"$ctrl.validacionParalela({accion})\"\n      ng-click=\"$ctrl.ejecutarAccion(accion)\">\n      <i class=\"fa {{accion.icon}}\"></i> {{accion.label}}\n    </button>\n  </span>\n</span>\n\n<button mf-effect type=\"button\"\n  class=\"btn btn-actions c-pointer btn-primary\"\n  ui-sref=\"proyectos-registrados\"\n  ng-if=\"!$ctrl.elemento.estado_actual.acciones || $ctrl.elemento.estado_actual.acciones.length === 0\">\n  <i class=\"fa fa-check\"></i> Aceptar\n</button>\n"

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-rotate-left\"></i> Rechazo del Proyecto</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>¿Usted desea rechazar el proyecto de manera definitiva o para su modificación?</p>\n\n  <ng-form name=\"formObservacion\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <c-textarea name=\"motivo_rechazo\" label=\"Motivo del Rechazo\"\n          ng-model=\"$ctrl.data.motivo_rechazo\"\n          ng-minlength=\"10\"\n          ng-required=\"true\"></c-textarea>\n      </div>\n    </div>\n  </ng-form>\n\n  <small><em>NOTA.- Debe registrar el motivo del rechazo.</em></small>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-danger\" validar-formulario=\"formObservacion\" ng-click=\"$ctrl.rechazar()\">\n    <i class=\"fa fa-trash\"></i> Rechazar\n  </button>\n</div>\n"

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.adicionar()\" ng-if=\"!$ctrl.tieneFiscal() && !$ctrl.modoVista\">\n  <i class=\"fa fa-plus\"></i> Agregar\n</button>\n<div class=\"crud-table\">\n  <table class=\"table table-striped table-hover table-responsive\">\n    <thead>\n      <tr>\n        <td>Acciones</td>\n        <td>Nombre</td>\n        <td>Cargo</td>\n        <td>Celular</td>\n        <td>Correo electrónico</td>\n        <td>Estado</td>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"miembro in $ctrl.listaEquipo\" ng-class=\"{'inactivo':miembro.estado!='ACTIVO'}\">\n        <td>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-primary\" uib-tooltip=\"Ver datos\" ng-click=\"$ctrl.verDatos(miembro)\"><i class=\"fa fa-eye\"></i></button>\n          <reconfirmacion-usuario usuario=\"miembro.usuario\" ng-if=\"$ctrl.esSupervisorOFiscal(miembro) && $ctrl.esResponsableProy\"\n            api=\"{{$ctrl.urlReconfirmacion + miembro.id_equipo_tecnico + '/notificar'}}\">\n          </reconfirmacion-usuario>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-danger\" uib-tooltip=\"Inhabilitar usuario\" ng-click=\"$ctrl.inactivarUsuario(miembro)\" ng-if=\"$ctrl.esSupervisorOFiscal(miembro) && $ctrl.esResponsableProy && !$ctrl.modoVista\"><i class=\"fa fa-ban\"></i></button>\n        </td>\n        <td>{{miembro.usuario.persona | nombreUnido}}</td>\n        <td>{{miembro.cargo_usuario.nombre}}</td>\n        <td>{{miembro.usuario.persona.telefono}}</td>\n        <td>{{miembro.usuario.persona.correo}}</td>\n        <td>{{miembro.estado}}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n<section ng-if=\"$ctrl.puedeVerAdjudicaciones()\">\n<h6 class=\"title-section m-top\">\n  <i class=\"fa fa-hand-o-right\"></i> Componentes\n</h6>\n<div class=\"row\">\n  <div class=\"md-input-group col-lg-1\">\n    <c-input name=\"nro_adjudicaciones\" label=\"Cant.\" ng-model=\"$ctrl.adjudicaciones.nro_adjudicaciones\" ng-disabled=\"true\"></c-input>\n    <button type=\"button\" class=\"btn btn-md btn-success\" ng-click=\"$ctrl.agregarAdjudicacion()\" ng-if=\"($ctrl.esResponsableGAM || $ctrl.esFiscal) && !$ctrl.modoVista\"><i class=\"fa fa-plus-circle\"></i></button>\n  </div>\n  <div class=\"col-lg-11\">\n    <div class=\"row\" ng-repeat=\"($adjindex,adjudicacion) in $ctrl.adjudicaciones.empresas\">\n      <div class=\"col-md-3\">         \n          <c-input name=\"referencia{{$adjindex}}\" label=\"Componente del Proyecto\" ng-model=\"adjudicacion.referencia\"        \n        ng-required=\"true\" ng-disabled=\"$ctrl.modoVista\"></c-input>  \n          <c-input-numeric name=\"monto{{$adjindex}}\" label=\"Monto Adjudicación\" ng-model=\"adjudicacion.monto\"        \n        ng-required=\"true\" ng-decimals=\"2\" ng-disabled=\"$ctrl.modoVista \"></c-input-numeric>\n        <c-input-numeric name=\"monto{{$adjindex}}\" label=\"Monto Adjudicación-Inicial\" ng-model=\"adjudicacion.montoHistorico\" ng-if=\"adjudicacion.montoHistorico\"     \n        ng-decimals=\"2\" ng-disabled=\"true\"></c-input-numeric>\n        <button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.guardarAdjudicacion($adjindex)\" ng-if=\"$ctrl.esFiscal || $ctrl.esResponsableGAM && !$ctrl.modoVista\"><i class=\"fa fa-save\"></i> Guardar</button>\n        <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"$ctrl.quitarAdjudicacion($adjindex)\" ng-if=\"($ctrl.esResponsableGAM || $ctrl.esFiscal) && !$ctrl.modoVista && !$ctrl.tieneSupervisiones($adjindex)\"><i class=\"fa fa-trash\"></i> Quitar</button>\n      </div>\n      <div class=\"col-md-3\">\n        <archivo name=\"doc_adjudicacion{{$adjindex}}\" label=\"Documento de Adjudicación\" ng-model=\"adjudicacion.doc_adjudicacion\"\n                types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\"\n                url=\"{{adjudicacion.archivo.url}}\"\n                url-descarga=\"{{adjudicacion.archivo.urlDescarga}}\"\n                cambiar=\"!$ctrl.modoVista\"\n                modo-vista=\"$ctrl.modoVista\">\n        </archivo>\n      </div>\n      <div class=\"col-md-6\" ng-if=\"adjudicacion.id_adjudicacion > 0\">\n        <div class=\"col-md-12\">\n          <h6 class=\"title-section m-top\">Designación de Supervisor(es)</h6>          \n          <button md-effect type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.adicionarSupervisorAdjudicacion($adjindex)\" ng-if=\"($ctrl.esResponsableGAM || $ctrl.esFiscal) && !$ctrl.modoVista && !$ctrl.tieneSupervisor(adjudicacion)\">\n            <i class=\"fa fa-plus\"></i> Agregar\n          </button>\n          <div class=\"crud-table\">            \n            <table class=\"table table-striped table-hover table-responsive\">\n              <thead>\n                <tr>\n                  <td>Acciones</td>\n                  <td>Nombre</td>\n                  <td>Celular</td>\n                  <td>Correo electrónico</td>\n                  <td>Estado</td>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"(key,miembro) in adjudicacion.equipo\" ng-class=\"{'inactivo':miembro.estado!='ACTIVO'}\">\n                  <td>\n                    <button md-effect type=\"button\" class=\"btn btn-sm btn-primary\" uib-tooltip=\"Ver datos\" ng-click=\"$ctrl.verDatos(miembro)\"><i class=\"fa fa-eye\"></i></button>\n                    <reconfirmacion-usuario usuario=\"miembro.usuario\" ng-if=\"($ctrl.esResponsableGAM || $ctrl.esFiscal) && miembro.estado === 'ACTIVO'\"\n                      api=\"{{$ctrl.urlReconfirmacion + miembro.id_equipo_tecnico + '/notificar'}}\">\n                    </reconfirmacion-usuario>\n                    <!-- {{$adjindex}}--{{key}} -->\n                    <button md-effect type=\"button\" class=\"btn btn-sm btn-danger\" uib-tooltip=\"Inhabilitar usuario\" ng-click=\"$ctrl.inactivarUsuarioAdjudicacion(key,$adjindex)\" ng-if=\"($ctrl.esResponsableGAM || $ctrl.esFiscal) && !$ctrl.modoVista && miembro.estado === 'ACTIVO'\"><i class=\"fa fa-ban\"></i></button>\n                  </td>\n                  <td>{{miembro.usuario.persona | nombreUnido}}</td>\n                  <td>{{miembro.usuario.persona.telefono}}</td>\n                  <td>{{miembro.usuario.persona.correo}}</td>\n                  <td>{{miembro.estado}}</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-12\">\n        <hr style=\"border-top: 1px dashed #8c8b8b;\">\n      </div>\n    </div>\n    <div class=\"row\">\n     <!--  <div class=\"col-md-3\">\n        <c-input-numeric name=\"monto_total\" label=\"Monto total del proyecto\" ng-model=\"$ctrl.monto_total\" \n          ng-decimals=\"2\" ng-disabled=\"true\" ></c-input-numeric>--> <!-- se elimino esta condicion para mostrar montos **** ng-if=\"$ctrl.esResponsableGAM && !$ctrl.modoVista\" -->\n      <!-- </div> -->\n      <div class=\"col-md-3\">\n        <c-input-numeric name=\"monto_fdi\" label=\"Monto total FDI\" ng-model=\"$ctrl.proyecto.monto_fdi\"\n          ng-decimals=\"2\" ng-disabled=\"true\" ></c-input-numeric>\n      </div>\n       <div class=\"col-md-3\">\n        <c-input-numeric name=\"monto_transferido\" label=\"Monto total transferido\" ng-model=\"$ctrl.proyecto.monto_transferido\"\n          ng-decimals=\"2\" ng-disabled=\"true\" ></c-input-numeric>\n      </div>\n      <div class=\"col-md-3\">\n        <c-input-numeric name=\"monto_total_adjudicado\" label=\"Monto total adjudicado\" ng-model=\"$ctrl.monto_total_adjudicado\"\n          ng-decimals=\"2\" ng-disabled=\"true\" ></c-input-numeric>\n      </div>\n      <div class=\"col-md-3\">\n        <c-input-numeric name=\"monto_restante\" label=\"Monto disponible para adjudicar\" ng-model=\"$ctrl.monto_restante\"\n          ng-decimals=\"2\" ng-disabled=\"true\" ></c-input-numeric>\n      </div>\n    </div>\n  </div>\n</div>\n</section>\n"

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i>\n    {{$ctrl.miembro.tipo_equipo != 'TE_FDI' && !$ctrl.miembro.id_equipo_tecnico ? 'Registro' : $ctrl.modoEdicion ? 'Edición del' : ''}} Integrante del Equipo Técnico <span ng-if=\"$ctrl.referencia!=null\">para {{$ctrl.referencia}}</span>\n  </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <ng-form name=\"formMiembro\">\n    <documento-identidad ng-model=\"$ctrl.miembro\" modo-vista=\"$ctrl.miembro.tipo_equipo == 'TE_FDI' || !$ctrl.modoEdicion\"></documento-identidad>\n\n    <div class=\"row\">\n      <div class=\"md-input-group col-md-6\">\n        <c-input name=\"celular_miembro\" label=\"Celular\" ng-model=\"$ctrl.miembro.telefono\"\n        ng-validation=\"celular\" ng-directives=\"numeric\" maxlength=\"8\"\n        ng-required=\"true\" ng-disabled=\"$ctrl.miembro.tipo_equipo == 'TE_FDI' || !$ctrl.modoEdicion\"></c-input>\n      </div>\n\n      <div class=\"md-input-group col-md-6\">\n        <c-input name=\"correo_miembro\" label=\"Correo Electrónico\" ng-model=\"$ctrl.miembro.correo\"\n        ng-validation=\"correo\" ng-required=\"true\" ng-disabled=\"$ctrl.miembro.tipo_equipo == 'TE_FDI' || !$ctrl.modoEdicion\"></c-input>\n      </div>\n\n      <div class=\"col-md-6\">\n        <c-select name=\"cargo\" label=\"Cargo\" ng-model=\"$ctrl.miembro.cargo\"\n        options=\"$ctrl.cargos\" key-value=\"codigo\" ng-required=\"true\"\n        on-select=\"$ctrl.verificarSiEsSupervisor()\" ng-disabled=\"$ctrl.miembro.tipo_equipo == 'TE_FDI' || !$ctrl.modoEdicion\"></c-select>\n      </div>\n\n      <div class=\"col-md-6\" ng-if=\"$ctrl.miembro.tipo_equipo != 'TE_FDI'\">\n        <archivo name=\"doc_designacion\" label=\"Documento de Designación\"\n                ng-model=\"$ctrl.miembro.doc_designacion\"\n                types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\"\n                url=\"{{$ctrl.archivo.url}}\"\n                url-descarga=\"{{$ctrl.archivo.urlDescarga}}\"\n                ver=\"false\"\n                modo-vista=\"!$ctrl.modoEdicion\">\n        </archivo>\n      </div>      \n    </div>\n  </ng-form>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\" ng-if=\"$ctrl.miembro.tipo_equipo == 'TE_FDI' || $ctrl.modoVista || $ctrl.estadoMiembro === 'INACTIVO'\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\" ng-if=\"$ctrl.miembro.tipo_equipo != 'TE_FDI' && !$ctrl.modoVista && $ctrl.estadoMiembro === 'ACTIVO'\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.registrar()\" validar-formulario=\"formMiembro\"\n  ng-if=\"$ctrl.modoEdicion && $ctrl.miembro.tipo_equipo != 'TE_FDI' && !$ctrl.modoVista\">\n    <i class=\"fa fa-check\"></i> {{$ctrl.miembro.id_equipo_tecnico ? 'Actualizar' : 'Registrar'}}\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.modoEdicion=true\"\n  ng-if=\"$ctrl.miembro.id_equipo_tecnico && !$ctrl.modoEdicion && $ctrl.miembro.tipo_equipo != 'TE_FDI' && !$ctrl.modoVista && $ctrl.estadoMiembro === 'ACTIVO'\">\n    <i class=\"fa fa-edit\"></i> Editar\n  </button>\n</div>\n"

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\" ng-if=\"!$ctrl.Proyecto.tratarComoProductivo($ctrl.proyecto) && !$ctrl.Proyecto.tratarComoRiego($ctrl.proyecto) && !$ctrl.Proyecto.tratarComoPuente($ctrl.proyecto)\">\n<section ng-init=\"$ctrl.initPlantilla()\" class=\"col-xl-8 offset-xl-2\">\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Documento de Evaluación Externa\n  </h6>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <archivo name=\"doc_ev_externa\" label=\"Documento de Evaluacion Externa\" ng-model=\"$ctrl.proyecto.doc_ev_externa\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\"\n              url=\"{{$ctrl.archivos.urlDocEvExterna}}\"\n              url-descarga=\"{{$ctrl.archivos.urlDocEvExternaDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_ev_externa')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_ev_externa')\">\n      </archivo>\n    </div>\n  </div>\n</section>\n</div>\n\n<div class=\"row\" ng-if=\"$ctrl.Proyecto.tratarComoProductivo($ctrl.proyecto) || $ctrl.Proyecto.tratarComoRiego($ctrl.proyecto) || $ctrl.Proyecto.tratarComoPuente($ctrl.proyecto) \">\n<section ng-init=\"$ctrl.initPlantilla()\" class=\"col-xl-10\" style=\"max-height:600px;overflow:auto\">\n  <div class=\"form-evaluacion table-responsive\">\n    <!-- <table>\n      <tr>\n        <td class=\"center\"><img alt=\"logo_mdryt\" src=\"../../../../../images/fdi-logo.png\"/ height=\"100px\"></td>\n        <th>\n          <h4>FORMULARIO DE EVALUACION DEL EDTP</h4>\n          <h6>I. DATOS GENERALES DEL PROYECTO</h6>\n        </th>\n        <td class=\"center\"><img alt=\"logo_fdi\" src=\"../../../../../images/mdryt-logo.png\"/ height=\"100px\"></td>\n      </tr>\n    </table>\n    <hr> -->\n    <table>\n      <tr>\n        <th>CODIGO</th>\n        <td colspan=\"5\">{{$ctrl.proyecto.nro_convenio}}</td>\n      </tr>\n      <tr>\n        <th class=\"w240\">DEPARTAMENTO</th>\n        <td style=\"width:25%\" colspan=\"2\">{{$ctrl.proyecto.evaluacion.departamento.nombre}}</td>\n        <th class=\"w240\">PROVINCIA</th>\n        <td colspan=\"2\">{{$ctrl.proyecto.evaluacion.provincia.nombre}}</td>\n      </tr>\n      <tr>\n        <th class=\"w240\">MUNICIPIO</th>\n        <td colspan=\"5\">{{$ctrl.proyecto.evaluacion.municipio.nombre}}</td>\n      </tr>\n      <tr>\n        <th class=\"w240\">NOMBRE DEL PROYECTO</th>\n        <td colspan=\"5\">{{$ctrl.proyecto.evaluacion.nombre}}</td>\n      </tr>\n    </table>\n    <hr>\n    <table>\n      <tr>\n        <th class=\"w240\" rowspan=\"2\">PLAZOS (días)</th>\n        <th class=\"w240\" style=\"width:25%\">Ejecución</th>\n        <td colspan=\"2\">{{$ctrl.proyecto.beneficiarios.plazo_ejecucion}}</td>\n      </tr>\n      <tr>\n        <th class=\"w240\">Convenio</th>\n        <td colspan=\"2\">{{$ctrl.plazo_convenio}}</td>\n      </tr>\n    </table>\n    <hr>\n    <table>\n      <tr>\n        <th class=\"w240\">N° COMUNIDADES</th>\n        <td style=\"width:25%\">{{$ctrl.proyecto.evaluacion.beneficiarios.nro_comunidades}}</td>\n        <th rowspan=\"2\" class=\"w240\">COMUNIDADES</th>\n        <td rowspan=\"2\">\n          <span ng-repeat=\"comunidad in $ctrl.proyecto.beneficiarios.comunidades\">\n            {{comunidad.nombre}}{{$last ? '' : ', '}}\n          </span>\n        </td>\n      </tr>\n      <tr>\n        <th class=\"w240\">N° Familias Beneficiarias directas</th>\n        <td>{{$ctrl.proyecto.evaluacion.beneficiarios.nro_familias}}</td>\n      </tr>\n    </table>\n    <hr>\n    <table>\n      <tr>\n        <th colspan=\"2\">MONTO FINANCIAMIENTO (Bs)</th>\n        <th colspan=\"2\">ELABORACIÓN DEL EDTP</th>\n      </tr>\n      <tr>\n        <th class=\"w240\">FDI</th>\n        <td class=\"right\" style=\"width:25%\">{{$ctrl.proyecto.evaluacion.financiamiento.monto_fdi | currency:'Bs':2}}</td>\n        <th rowspan=\"2\" class=\"w240\">Responsable GAM/GAIOC Aprobación proyectos / Correo / Teléfono</th>\n        <td rowspan=\"2\">\n          <!-- <textarea ng-disabled=\"true\" ng-model=\"$ctrl.proyecto.evaluacion.responsable_gam_gaioc\" style=\"width:100%;min-width:160px;\"></textarea> -->\n          <div ng-bind-html=\"$ctrl.proyecto.evaluacion.responsable_gam_gaioc\"></div>\n        </td>\n      </tr>\n      <tr>\n        <th class=\"w240\">GAM/GAIOC</th>\n        <td class=\"right\">{{$ctrl.proyecto.evaluacion.financiamiento.monto_contraparte | currency:'Bs':2}}</td>\n      </tr>\n      <tr>\n        <th class=\"w240\">BENEFICIARIOS</th>\n        <td class=\"right\">{{$ctrl.proyecto.evaluacion.financiamiento.monto_beneficiarios | currency:'Bs':2}}</td>\n        <th rowspan=\"2\" class=\"w240\">Tecnico encargado de la Elaboracion del EDTP / Correo / Teléfono</th>\n        <td rowspan=\"2\">\n          <!-- <textarea ng-disabled=\"true\" ng-model=\"$ctrl.proyecto.evaluacion.responsable_edtp\" style=\"width:100%;min-width:160px;\"></textarea> -->\n          <div ng-bind-html=\"$ctrl.proyecto.evaluacion.responsable_edtp\"></div>\n        </td>\n      </tr>\n      <tr>\n        <th class=\"w240\">OTROS</th>\n        <td class=\"right\">{{$ctrl.proyecto.evaluacion.financiamiento.monto_otros | currency:'Bs':2}}</td>\n      </tr>\n      <tr>\n        <th class=\"w240\">TOTAL</th>\n        <td class=\"titulo right\">{{$ctrl.proyecto.evaluacion.financiamiento.monto_total_proyecto | currency:'Bs':2}}</td>\n      </tr>\n    </table>\n    <hr>\n    <button type=\"button\" ng-if=\"!$ctrl.modoVista\" class=\"btn btn-xs btn-warning pull-right\" ng-click=\"$ctrl.regenerarFormulario()\">\n      <i class=\"fa fa-refresh\"></i> Regenerar\n    </button>\n    <table>\n      <tr>\n        <td colspan=\"2\" class=\"titulo\">DESCRIPCIÓN</td>\n        <td class=\"titulo\">PARAMETRO/CRITERIO DE EVALUACION</td>\n        <td class=\"titulo\">CUMPLE</td>\n        <td class=\"titulo\">NO CUMPLE</td>\n        <td class=\"titulo\">NO APLICA</td>\n        <td class=\"titulo\">OBSERVACIONES</td>\n      </tr>\n      <tr ng-repeat=\"(r,row) in $ctrl.proyecto.evaluacion.datos\">\n        <td ng-repeat=\"(c,col) in row.cols\" colspan=\"{{col.colspan}}\" rowspan=\"{{col.rowspan}}\" ng-class=\"col.class\">\n          <strong ng-bind-html=\"col.titulo\"></strong>\n          <div ng-if=\"col.contenido.type=='checkbox'\" ng-click=\"col.contenido.value=$ctrl.modoVista?col.contenido.value:!col.contenido.value\" class=\"btn\" ng-class=\"{'btn-success':col.contenido.value,'btn-secondary':!col.contenido.value}\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-square-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='radio'\" ng-click=\"$ctrl.radioChange(row.cols, c)\" class=\"btn\" ng-class=\"[$ctrl.radioColor(col.contenido)]\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-circle-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='textarea'\"><textarea ng-model=\"col.contenido.value\" cols=\"30\" rows=\"2\" ng-disabled=\"$ctrl.modoVista\"></textarea></div>\n          <div ng-if=\"!col.contenido.type\" ng-bind-html=\"$ctrl.limitarTexto(col.contenido)\" uib-tooltip-html='\"<br>{{$ctrl.parsearTexto(col.contenido)}}<br>&nbsp;\"' tooltip-append-to-body=\"true\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <hr>\n  <div class=\"form-evaluacion table-responsive\" ng-hide=\"$ctrl.proyecto.cartera == 4\">\n    <table>\n      <tr>\n        <td class=\"titulo\" colspan=\"4\">2. CRITERIOS GENERALES DE ELEGIBILIDAD</td>\n      </tr>\n      <tr>\n        <td class=\"titulo\" rowspan=\"2\">Criterio</td>\n        <td class=\"titulo\" rowspan=\"2\">Medios de verificación</td>\n        <td class=\"titulo\" colspan=\"2\">Valoracion</td>\n      </tr>\n      <tr>\n        <td class=\"titulo\">CUMPLE</td>\n        <td class=\"titulo\">NO CUMPLE</td>\n      </tr>\n      <tr ng-repeat=\"(r,row) in $ctrl.proyecto.evaluacion.datos2\">\n        <td ng-repeat=\"(c,col) in row.cols\" colspan=\"{{col.colspan}}\" rowspan=\"{{col.rowspan}}\" ng-class=\"col.class\">\n          <strong ng-bind-html=\"col.titulo\"></strong>\n          <div ng-if=\"col.contenido.type=='checkbox'\" ng-click=\"col.contenido.value=$ctrl.modoVista?col.contenido.value:!col.contenido.value\" class=\"btn\" ng-class=\"{'btn-success':col.contenido.value,'btn-secondary':!col.contenido.value}\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-square-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='radio'\" ng-click=\"$ctrl.radioChange(row.cols, c)\" class=\"btn\" ng-class=\"[$ctrl.radioColor(col.contenido)]\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-circle-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='textarea'\"><textarea ng-model=\"col.contenido.value\" cols=\"40\" rows=\"5\" ng-disabled=\"$ctrl.modoVista\"></textarea></div>\n          <div ng-if=\"!col.contenido.type\" ng-bind-html=\"col.contenido\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <hr>\n  <div class=\"form-evaluacion table-responsive\" ng-if=\"$ctrl.criteriosElegibilidad() && $ctrl.proyecto.cartera == 3\" >\n    <table>\n      <tr>\n        <td class=\"titulo\" colspan=\"3\">3. CRITERIOS ESPECIFICOS DE ELEGIBILIDAD</td>\n        <td class=\"titulo\" colspan=\"3\">Valoracion</td>\n      </tr>\n      <tr>\n        <td class=\"titulo\">Tipo de Proyecto</td>\n        <td class=\"titulo\">Criterio</td>\n        <td class=\"titulo\">Medios de Verificación</td>\n        <td class=\"titulo\">CUMPLE</td>\n        <td class=\"titulo\">NO CUMPLE</td>\n        <td class=\"titulo\">NO APLICA</td>\n      </tr>\n      <tr ng-repeat=\"(r,row) in $ctrl.proyecto.evaluacion.datos3\" ng-if=\"$ctrl.visibilidad(row.key)\" rel=\"{{row.key}}\">\n        <td ng-repeat=\"(c,col) in row.cols\" colspan=\"{{col.colspan}}\" rowspan=\"{{col.rowspan}}\" ng-class=\"col.class\">\n          <strong ng-bind-html=\"col.titulo\"></strong>\n          <div ng-if=\"col.contenido.type=='checkbox'\" ng-click=\"col.contenido.value=$ctrl.modoVista?col.contenido.value:!col.contenido.value\" class=\"btn\" ng-class=\"{'btn-success':col.contenido.value,'btn-secondary':!col.contenido.value}\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-square-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='radio'\" ng-click=\"$ctrl.radioChange(row.cols, c)\" class=\"btn\" ng-class=\"[$ctrl.radioColor(col.contenido)]\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-circle-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='textarea'\"><textarea ng-model=\"col.contenido.value\" cols=\"40\" rows=\"5\" ng-disabled=\"$ctrl.modoVista\"></textarea></div>\n          <div ng-if=\"!col.contenido.type\" ng-bind-html=\"col.contenido\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <hr>\n  <div class=\"form-evaluacion table-responsive\" ng-hide=\"true\">\n    <table>\n      <tr>\n        <td class=\"titulo\" colspan=\"3\">4. ANALISIS DE LA FACTIBILIDAD DEL PROYECTO</td>\n        <td class=\"titulo\" colspan=\"2\">Valoracion</td>\n      </tr>\n      <tr>\n        <td class=\"titulo\">Indicador</td>\n        <td class=\"titulo\">Parametro (Factor y/o dato)</td>\n        <td class=\"titulo\">Insumo / Instrumento</td>\n        <td class=\"titulo\">CUMPLE</td>\n        <td class=\"titulo\">NO CUMPLE</td>\n      </tr>\n      <tr ng-repeat=\"(r,row) in $ctrl.proyecto.evaluacion.datos4\" ng-if=\"$ctrl.visibilidadAnalisisFactibilidad(row.key)\" rel=\"{{row.key}}\">\n        <td ng-repeat=\"(c,col) in row.cols\" colspan=\"{{col.colspan}}\" rowspan=\"{{col.rowspan}}\" ng-class=\"col.class\">\n          <strong ng-bind-html=\"col.titulo\"></strong>\n          <div ng-if=\"col.contenido.type=='checkbox'\" ng-click=\"col.contenido.value=$ctrl.modoVista?col.contenido.value:!col.contenido.value\" class=\"btn\" ng-class=\"{'btn-success':col.contenido.value,'btn-secondary':!col.contenido.value}\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-square-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='radio'\" ng-click=\"$ctrl.radioChange(row.cols, c)\" class=\"btn\" ng-class=\"[$ctrl.radioColor(col.contenido)]\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-circle-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='textarea'\"><textarea ng-model=\"col.contenido.value\" cols=\"40\" rows=\"5\" ng-disabled=\"$ctrl.modoVista\"></textarea></div>\n          <div ng-if=\"!col.contenido.type\" ng-bind-html=\"col.contenido\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <hr>\n  <div class=\"form-evaluacion table-responsive\">\n    <table>\n      <tr>\n        <td class=\"titulo\"></td>\n        <td class=\"titulo\">APROBAR</td>\n        <td class=\"titulo\">AJUSTAR</td>\n        <td class=\"titulo\">RECHAZAR</td>\n      </tr>\n      <tr ng-repeat=\"(r,row) in $ctrl.proyecto.evaluacion.datos5\">\n        <td ng-repeat=\"(c,col) in row.cols\" colspan=\"{{col.colspan}}\" rowspan=\"{{col.rowspan}}\" ng-class=\"col.class\">\n          <strong ng-bind-html=\"col.titulo\"></strong>\n          <div ng-if=\"col.contenido.type=='checkbox'\" ng-click=\"col.contenido.value = $ctrl.modoVista ? col.contenido.value : !col.contenido.value\" class=\"btn\" ng-class=\"{'btn-success':col.contenido.value,'btn-secondary':!col.contenido.value}\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-square-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='radio'\" ng-click=\"$ctrl.radioChangeWithValidation(row.cols, c)\" class=\"btn\" ng-class=\"[$ctrl.radioColor(col.contenido)]\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-circle-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='textarea'\"><textarea ng-model=\"col.contenido.value\" cols=\"40\" rows=\"5\" ng-disabled=\"$ctrl.modoVista\"></textarea></div>\n          <div ng-if=\"!col.contenido.type\" ng-bind-html=\"col.contenido\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <hr>\n  <div class=\"form-evaluacion table-responsive\">\n    <table class=\"font-small\">\n      <tr>\n        <th class=\"backcolor\" width=\"33%\">TECNICO REVISOR</th>\n        <th class=\"backcolor\" width=\"33%\">CONFORMIDAD JEFE AREA REVISION TECNICA DE PROYECTOS</th>\n        <th class=\"backcolor\" width=\"33%\">V° B° JEFE DEPARTAMENTO TECNICO</th>\n      </tr>\n      <tr>\n        <td><br><br><br>FIRMA</td>\n        <td><br><br><br>FIRMA</td>\n        <td><br><br><br>FIRMA</td>\n      </tr>\n      <tr>\n        <td>Nombre:<input type=\"text\" ng-model=\"$ctrl.proyecto.evaluacion.revisor.nombre\" style=\"width:100%\" ng-disabled=\"true\"></td>\n        <td>Nombre:<input type=\"text\" ng-model=\"$ctrl.proyecto.evaluacion.jefe_area.nombre\" style=\"width:100%\" ng-disabled=\"true\"></td>\n        <td>Nombre:<input type=\"text\" ng-model=\"$ctrl.proyecto.evaluacion.jefe_depto.nombre\" style=\"width:100%\" ng-disabled=\"true\"></td>\n      </tr>\n      <tr>\n        <td>Cargo:<input type=\"text\" ng-model=\"$ctrl.proyecto.evaluacion.revisor.cargo\" style=\"width:100%\" ng-disabled=\"true\"></td>\n        <td>Cargo:<input type=\"text\" ng-model=\"$ctrl.proyecto.evaluacion.jefe_area.cargo\" style=\"width:100%\" ng-disabled=\"true\"></td>\n        <td>Cargo:<input type=\"text\" ng-model=\"$ctrl.proyecto.evaluacion.jefe_depto.cargo\" style=\"width:100%\" ng-disabled=\"true\"></td>\n      </tr>\n    </table>\n  </div>\n</section>\n<hr>\n<section class=\"col-xl-2\">\n  <button type=\"button\" ng-if=\"!$ctrl.modoVista || ($ctrl.esRechazado && $ctrl.esTecEval)\" class=\"btn btn-primary\" ng-click=\"$ctrl.generarEvaluacionPdf()\"><i class=\"fa fa-file-pdf-o\"></i> Generar<br>Formulario</button>\n  <hr>\n  <div class=\"row\">\n    <div class=\"col\">Formularios de evaluación generados</div>\n  </div>\n  <div class=\"row\">\n      <div class=\"col-md-6 col-xl-12\" ng-repeat=\"doc in $ctrl.documentos\" ng-if=\"doc.estado!=='INACTIVO' || $ctrl.esTecEval\">\n        <div class=\"btn btn-outline-tertiary\" style=\"width:100%;margin-top:2px;\">\n          <div ng-if=\"doc.estado!=='INACTIVO'\"><span ng-click=\"$ctrl.verEvaluacion(doc)\" >{{ doc.fecha_documento | date: 'dd/MM/yyyy' }}</span><span ng-click=\"$ctrl.corregirFecha(doc)\" ng-if=\"$ctrl.esTecEval\"> - <i class=\"fa fa-calendar-check-o text-warning\" uib-tooltip=\"Corregir fecha\"></i></span></div>\n          <div ng-if=\"$ctrl.esTecEval\" style=\"font-size:8px;color:#000;text-transform:none;\"><span ng-click=\"$ctrl.estado(doc)\"><i class=\"fa\" ng-class=\"{'fa-check-square-o': doc.estado!=='INACTIVO', 'fa-square-o': doc.estado==='INACTIVO'}\" uib-tooltip=\"Visible\" style=\"font-size:10px;\"></i> - </span>Creado: {{ doc._fecha_creacion | date: 'dd/MM/yyyy HH:mm' }}</div>\n        </div>\n      </div>\n  </div>\n</section>\n</div>\n<style>\n  .form-evaluacion .titulo {\n    text-align: center;\n    font-weight: bold;\n  }\n  .form-evaluacion .center {\n    text-align: center;\n  }\n  .form-evaluacion .right {\n    text-align: right;\n  }\n  .form-evaluacion .backcolor {\n    background-color: #BDD7EE;\n    border: 1px solid darkblue;\n  }\n  .form-evaluacion table {\n    width: 100%;\n  }\n  .form-evaluacion table th,\n  .form-evaluacion table th {\n    background-color: #BDD7EE;\n    text-align: center;\n  }\n  .form-evaluacion table td {\n    border: 1px solid #000;\n    padding-left: 4px;\n    padding-right: 4px;\n  }\n  .form-evaluacion table td .btn {\n    border: 1px solid #aaa;\n  }\n  .form-evaluacion table .w240 {\n    width: 240px;\n  }\n</style>\n"

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	module.exports = "<section ng-init=\"$ctrl.initPlantilla()\">\n  <h6 class=\"title-section m-top\"><i class=\"fa fa-file-text-o\"></i> Estructura de Financiamiento</h6>\n  <div class=\"row\">\n    <div class=\"col-md-6 col-lg-3\">\n      <c-input-money name=\"monto_fdi\" label=\"Monto FDI*\" ng-model=\"$ctrl.proyecto.financiamiento.monto_fdi\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('monto_total')\"\n      ng-disabled=\"$ctrl.modoVista || $ctrl.proyecto.financiamiento.cuadro || !$ctrl.Proyecto.esEditable('monto_total')\"\n      ng-blur=\"$ctrl.calcularFinanciamiento()\"></c-input-money>\n    </div>\n    <div class=\"col-md-6 col-lg-3\">\n      <c-input-money name=\"monto_contraparte\" label=\"Monto Contraparte (GAM/GAIOC)\" ng-model=\"$ctrl.proyecto.financiamiento.monto_contraparte\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('monto_total')\"\n      ng-disabled=\"$ctrl.modoVista || $ctrl.proyecto.financiamiento.cuadro || !$ctrl.Proyecto.esEditable('monto_total')\"\n      ng-blur=\"$ctrl.calcularFinanciamiento()\"></c-input-money>\n    </div>\n    <div class=\"col-md-6 col-lg-3\">\n      <c-input-money name=\"monto_beneficiarios\" label=\"Monto beneficiarios\" ng-model=\"$ctrl.proyecto.financiamiento.monto_beneficiarios\"\n      ng-disabled=\"$ctrl.modoVista || $ctrl.proyecto.financiamiento.cuadro || !$ctrl.Proyecto.esEditable('monto_total')\"\n      ng-blur=\"$ctrl.calcularFinanciamiento()\"></c-input-money>\n    </div>\n    <div class=\"col-md-6 col-lg-3\">\n      <c-input-money name=\"monto_otros\" label=\"Monto otros\" ng-model=\"$ctrl.proyecto.financiamiento.monto_otros\"\n      ng-disabled=\"$ctrl.modoVista || $ctrl.proyecto.financiamiento.cuadro || !$ctrl.Proyecto.esEditable('monto_total')\"\n      ng-blur=\"$ctrl.calcularFinanciamiento()\"></c-input-money>\n    </div>\n    <div class=\"col-md-6 col-lg-3\">\n      <c-input-money name=\"monto_total_proyecto\" label=\"Monto total proyecto\" ng-model=\"$ctrl.proyecto.financiamiento.monto_total_proyecto\"\n      ng-disabled=\"true\" ng-init=\"ctrl.func1(2)\"></c-input-money>\n    </div>\n    <div class=\"col-md-6 col-lg-3\">\n      <c-input-money name=\"monto_restante\" label=\"Monto disponible según techo presupuestario\" ng-model=\"$ctrl.techoPresupuestario.monto_restante\"\n      ng-if=\"$ctrl.techoPresupuestario\" ng-disabled=\"true\"></c-input-money>\n    </div>\n    <!-- ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('monto_total')\" -->\n  </div>\n</section>\n\n<!-- Tabla para tipo de financiamiento publico o privado -->\n<section ng-if=\"$ctrl.proyecto.financiamiento.cuadro.tipo == 1\">\n  <div class=\"financiamiento-cuadro1 table-responsive\">\n    <table>\n      <tr>\n        <td class=\"titulo\" rowspan=\"2\">Costos de inversión</td>\n        <td class=\"titulo\" rowspan=\"2\">Detalle de la inversión</td>\n        <td class=\"titulo\" rowspan=\"2\">COSTO TOTAL (en Bs)</td>\n        <td class=\"titulo\" colspan=\"4\">Estructura de financiamiento<br>(En Bolivianos)</td>\n      </tr>\n      <tr>\n        <td class=\"titulo\">FDI</td>\n        <td class=\"titulo\">GAM</td>\n        <td class=\"titulo\">BENEFICIARIOS</td>\n        <td class=\"titulo\">OTROS</td>\n      </tr>\n      <tr ng-repeat=\"(r,row) in $ctrl.proyecto.financiamiento.cuadro.datos\">\n        <td ng-repeat=\"(c,col) in row.cols\" colspan=\"{{col.colspan}}\" rowspan=\"{{col.rowspan}}\" ng-class=\"col.class\">\n          <strong ng-bind-html=\"col.titulo\"></strong>\n          <div ng-if=\"col.contenido.type=='inputMoney'\">\n            <c-input-money name=\"{{col.contenido.value}}{{r}}{{c}}\" ng-model=\"col.contenido.value\"\n              ng-disabled=\"$ctrl.modoVista || col.contenido.disabled || !$ctrl.Proyecto.esEditable('monto_total')\"\n              ng-click=\"$ctrl.limpiarCero(col, disabled=$ctrl.modoVista || col.contenido.disabled || !$ctrl.Proyecto.esEditable('monto_total'))\"\n              ng-blur=\"$ctrl.reemplazarVacio(col); $ctrl.calTotales()\"\n              ng-keyup=\"$ctrl.calTotales()\"\n              ng-decimals=\"2\" icon=\"false\">\n            </c-input-money>\n          </div>\n          <div ng-if=\"!col.contenido.type\" ng-bind-html=\"col.contenido\"></div>\n        </td>\n      </tr>\n      <tr>\n        <td class=\"titulo\" colspan=\"2\">PORCENTAJES</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.total_referencia |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_fdi |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_gam |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_beneficiarios |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_otros |number:2}}</td>\n      </tr>\n      <tr>\n        <td class=\"titulo\" colspan=\"2\">TOTAL</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.costo_total |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.fdi |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.gam |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.beneficiarios |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.otros |number:2}}</td>\n      </tr>\n    </table>\n  </div>\n  <br>\n  <div class=\"alert alert-info\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>NOTA: El aporte de la comunidad en especie se menciona en el convenio intergubernativo pero no se inscribe presupuestariamente</span>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <c-textarea name=\"observacion-cuadro-financiamiento\" label=\"Introducir el detalle del aporte del beneficiario\" ng-model=\"$ctrl.proyecto.financiamiento.cuadro.observacion\" ng-required=\"false\" ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('monto_total')\"></c-textarea>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-6\">\n      <c-select name=\"plazo_tiempo_administrativo\" label=\"Plazo Administrativo\" ng-model=\"$ctrl.proyecto.financiamiento.plazo_tiempo_administrativo\"\n      options=\"$ctrl.opciones_plazo_administrativo\"\n      ng-required=\"true\"\n      ng-disabled= \"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('plazo_tiempo_administrativo')\"\n      ></c-select>\n    </div>\n  </div>\n</section>\n\n<!-- Tabla para tipo de financiamiento mixto -->\n<section ng-if=\"$ctrl.proyecto.financiamiento.cuadro.tipo == 2\">\n  <div class=\"financiamiento-cuadro1 table-responsive\">\n    <table>\n      <tr>\n        <td class=\"titulo\" rowspan=\"3\">Costos de inversión</td>\n        <td class=\"titulo\" rowspan=\"3\">Detalle de la inversión</td>\n        <td ng-if=\"$ctrl.proyecto.cartera !== 1 && $ctrl.proyecto.cartera !== 2 && $ctrl.proyecto.cartera !== 3\" class=\"titulo\" rowspan=\"3\">COSTO TOTAL (en Bs)</td>\n        <td class=\"titulo\" colspan=\"8\" ng-if=\"$ctrl.proyecto.cartera >=4\">ESTRUCTURA DE FINANCIAMIENTO<br>(En Bolivianos)</td>\n        <td class=\"titulo\" colspan=\"6\" ng-if=\"$ctrl.proyecto.cartera < 4\">ESTRUCTURA DE FINANCIAMIENTO<br>(En Bolivianos)</td>\n      </tr>\n      <tr>\n        <td class=\"titulo\" rowspan=\"2\">FDI</td>\n        <td class=\"titulo\" rowspan=\"2\">GAM</td>\n        <td class=\"titulo\" rowspan=\"2\">BENEFICIARIOS</td>\n        <td class=\"titulo\" rowspan=\"2\">OTROS</td>\n        <td class=\"titulo\" colspan=\"2\">FDI</td>\n        <td class=\"titulo\" colspan=\"2\" ng-if=\"$ctrl.proyecto.cartera >=4\">GAM</td>\n      </tr>\n      <tr>\n        <td class=\"titulo\">PÚBLICO</td>\n        <td class=\"titulo\">PRIVADO</td>\n        <td class=\"titulo\" ng-if=\"$ctrl.proyecto.cartera >=4\">PÚBLICO</td>\n        <td class=\"titulo\" ng-if=\"$ctrl.proyecto.cartera >=4\">PRIVADO</td>\n      </tr>\n      <tr ng-repeat=\"(r,row) in $ctrl.proyecto.financiamiento.cuadro.datos\">\n        <td ng-repeat=\"(c,col) in row.cols\" colspan=\"{{col.colspan}}\" rowspan=\"{{col.rowspan}}\" ng-class=\"col.class\">\n          <strong ng-bind-html=\"col.titulo\"></strong>\n          <div ng-if=\"col.contenido.type=='inputMoney'\">\n            <c-input-money name=\"{{col.contenido.value}}\" ng-model=\"col.contenido.value\"\n              ng-disabled=\"$ctrl.modoVista || col.contenido.disabled || !$ctrl.Proyecto.esEditable('monto_total')\"\n              ng-click=\"$ctrl.limpiarCero(col, disabled=$ctrl.modoVista || col.contenido.disabled || !$ctrl.Proyecto.esEditable('monto_total'))\"\n              ng-blur=\"$ctrl.reemplazarVacio(col); $ctrl.calTotales()\"\n              ng-decimals=\"2\" icon=\"false\">\n            </c-input-money>\n          </div>\n          <div ng-if=\"!col.contenido.type\" ng-bind-html=\"col.contenido\"></div>\n        </td>\n      </tr>\n      <tr>\n        <td class=\"titulo\" colspan=\"2\">SUBTOTALES</td>\n        <td ng-if=\"$ctrl.proyecto.cartera !== 1 && $ctrl.proyecto.cartera !== 2 && $ctrl.proyecto.cartera !== 3\" class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.costo_total |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.fdi |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.gam |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.beneficiarios |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.otros |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.publico |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.privado |number:2}}</td>\n        <td class=\"titulo text-right\" ng-if=\"$ctrl.proyecto.cartera >=4\">{{$ctrl.proyecto.financiamiento.cuadro.totales.gampublico |number:2}}</td>\n        <td class=\"titulo text-right\" ng-if=\"$ctrl.proyecto.cartera >=4\">{{$ctrl.proyecto.financiamiento.cuadro.totales.gamprivado |number:2}}</td>\n      </tr>\n      <tr>\n        <td class=\"titulo\" colspan=\"2\">PORCENTAJES</td>\n        <td  ng-if=\"$ctrl.proyecto.cartera !== 1 && $ctrl.proyecto.cartera !== 2 && $ctrl.proyecto.cartera !== 3\" class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.total_referencia |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_fdi |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_gam |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_beneficiarios |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_otros |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_fdi_publico |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_fdi_privado |number:2}}</td>\n        <td class=\"titulo text-right\" ng-if=\"$ctrl.proyecto.cartera >=4\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_gam_publico |number:2}}</td>\n        <td class=\"titulo text-right\" ng-if=\"$ctrl.proyecto.cartera >=4\">{{$ctrl.proyecto.financiamiento.cuadro.porcentajes.porcentaje_gam_privado |number:2}}</td>\n      </tr>\n      <tr>\n        <td class=\"titulo\" colspan=\"2\">TOTALES</td>\n        <td class=\"titulo text-right\" colspan=\"5\" ng-if=\"$ctrl.proyecto.cartera >= 4\">{{$ctrl.proyecto.financiamiento.cuadro.totales.costo_total |number:2}}</td>\n        <td class=\"titulo text-right\" colspan=\"4\" ng-if=\"$ctrl.proyecto.cartera < 4\">{{$ctrl.proyecto.financiamiento.cuadro.totales.costo_total |number:2}}</td>\n        <td class=\"titulo text-right\" colspan=\"2\">{{$ctrl.proyecto.financiamiento.cuadro.totales.fdi_pp |number:2}}</td>\n        <td class=\"titulo text-right\" colspan=\"2\" ng-if=\"$ctrl.proyecto.cartera >=4\">{{$ctrl.proyecto.financiamiento.cuadro.totales.gam_pp |number:2}}</td>\n      </tr>\n      <!--<tr>\n        <td class=\"titulo\" colspan=\"2\">TOTALES</td>\n        <td class=\"titulo text-right\" colspan=\"2\">{{$ctrl.proyecto.financiamiento.cuadro.totales.fdi_gam |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.beneficiarios |number:2}}</td>\n        <td class=\"titulo text-right\">{{$ctrl.proyecto.financiamiento.cuadro.totales.otros |number:2}}</td>\n        <td class=\"titulo text-right\" colspan=\"2\">{{$ctrl.proyecto.financiamiento.cuadro.totales.fdi_pp |number:2}}</td>\n      </tr>-->\n    </table>\n  </div><br>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <c-textarea name=\"observacion-cuadro-financiamiento\" label=\"Introducir el detalle del aporte del beneficiario\" ng-model=\"$ctrl.proyecto.financiamiento.cuadro.observacion\" ng-required=\"false\" ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('monto_total')\"></c-textarea>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-6\">\n      <c-select name=\"plazo_tiempo_administrativo\" label=\"Plazo Administrativo\" ng-model=\"$ctrl.proyecto.financiamiento.plazo_tiempo_administrativo\"\n      options=\"$ctrl.opciones_plazo_administrativo\"\n      ng-required=\"true\"\n      ng-disabled= \"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('plazo_tiempo_administrativo')\"></c-select>\n    </div>\n  </div>\n</section>\n<style>\n.financiamiento-cuadro1 table {\n  width: 100%;\n}\n.financiamiento-cuadro1 table td {\n  border: 1px solid #000;\n  padding-left: 4px;\n  padding-right: 4px;\n}\n.financiamiento-cuadro1 table td.titulo {\n  font-weight: bold;\n  text-align: center;\n}\n\n.financiamiento-cuadro1 .input-group button{\n  margin-left: -22px !important;\n}\n.financiamiento-cuadro1 .md-form-group {\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n</style>\n"

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	module.exports = "\n<form name=\"form\">\n  <div class=\"row\">\n    <div class=\"col\">\n      <div class=\"alert alert-info\">\n        <i class=\"fa fa-info-circle\"></i> Para generar el informe debe llenar los siguientes datos.\n      </div>\n    </div>\n    <div class=\"col-md-12\">\n      <c-input name=\"director\" label=\"Director General Ejecutivo\" ng-model=\"$ctrl.proyecto.informe.director\" ng-required=\"true\" ng-disabled=\"$ctrl.modoVista\"></c-input>\n    </div>\n  </div>\n  <h5><b>OBJETIVOS</b></h5>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <c-textarea name=\"objetivos\" label=\"\" ng-model=\"$ctrl.proyecto.informe.objetivos\" ng-required=\"true\" ng-disabled=\"$ctrl.modoVista\"></c-textarea>\n    </div>\n  </div>\n  <h5><b>METAS Y RESULTADOS</b></h5>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <c-textarea name=\"metas_resultados\" label=\"\" ng-model=\"$ctrl.proyecto.informe.metas_resultados\" ng-required=\"true\" ng-disabled=\"$ctrl.modoVista\"></c-textarea>\n    </div>\n  </div>\n  <h5><b>INDICADORES DE PROYECTO</b></h5>\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <c-input name=\"descripcion\" label=\"Descripción\" ng-model=\"$ctrl.proyecto.informe.indicador.descripcion\" ng-required=\"true\" ng-disabled=\"$ctrl.modoVista\"></c-input>\n    </div>\n    <div class=\"col-md-3\">\n      <c-input-numeric name=\"linea_base\" label=\"Linea Base\" ng-model=\"$ctrl.proyecto.informe.indicador.linea_base\" ng-required=\"true\" ng-disabled=\"$ctrl.modoVista\" ng-minvalue=\"0\" ng-maxvalue=\"99999999\"></c-input-numeric>\n    </div>\n    <div class=\"col-md-3\">\n      <c-input name=\"proceso\" label=\"Indicador de Proceso\" ng-model=\"$ctrl.proyecto.informe.indicador.proceso\" ng-required=\"true\" ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"col-md-3\">\n      <c-input name=\"impacto\" label=\"Indicador de Impacto\" ng-model=\"$ctrl.proyecto.informe.indicador.impacto\" ng-required=\"true\" ng-disabled=\"true\"></c-input>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <c-input-numeric name=\"ge_directo\" label=\"Generación de Empleo Directo\" ng-model=\"$ctrl.proyecto.informe.indicador.ge_directo\" ng-minvalue=\"0\" ng-maxvalue=\"99999999\" ng-formatting=\"false\" ng-decimals=\"0\" ng-disabled=\"$ctrl.modoVista\"></c-input-numeric>\n    </div>\n    <div class=\"col-md-3\">\n      <c-input-numeric name=\"ge_indirecto\" label=\"Generación de Empleo Indirecto\" ng-model=\"$ctrl.proyecto.informe.indicador.ge_indirecto\" ng-minvalue=\"0\" ng-maxvalue=\"99999999\" ng-formatting=\"false\" ng-decimals=\"0\" ng-disabled=\"$ctrl.modoVista\"></c-input-numeric>\n    </div>\n  </div>\n</form>\n<div class=\"row\">\n<section ng-init=\"$ctrl.initPlantilla()\" class=\"col-xl-10\" style=\"max-height:600px;overflow:auto\">\n  <h5><b>EVALUACION TECNICA DEL PROYECTO</b></h5>\n  <!-- <h5><b>Cumplimiento de criterios generales de elegibilidad</b></h5>\n  <div class=\"form-evaluacion table-responsive\">\n    <table>\n      <tr>\n        <td class=\"titulo backcolor\">N°</td>\n        <td class=\"titulo backcolor\">Criterio</td>\n        <td class=\"titulo backcolor\">Medios de verificación</td>\n      </tr>\n      <tr ng-repeat=\"(r,row) in $ctrl.proyecto.informe.criterios\">\n        <td ng-repeat=\"(c,col) in row.cols\" colspan=\"{{col.colspan}}\" rowspan=\"{{col.rowspan}}\" ng-class=\"col.class\">\n          <strong ng-bind-html=\"col.titulo\"></strong>\n          <div ng-if=\"col.contenido.type=='textarea'\"><textarea ng-model=\"col.contenido.value\" cols=\"40\" rows=\"5\" ng-disabled=\"$ctrl.modoVista\"></textarea></div>\n          <div ng-if=\"!col.contenido.type\" ng-bind-html=\"col.contenido\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <hr> -->\n  <div class=\"form-evaluacion table-responsive\">\n\n  </div>\n  <h5><b>Valoración de la sostenibilidad técnica, económica, social, ambiental y organizativa institucional del programa o proyecto</b></h5>\n  <div class=\"form-evaluacion table-responsive\">\n    <table>\n      <tr>\n        <td class=\"titulo backcolor\" rowspan=\"2\">Indicador</td>\n        <td class=\"titulo backcolor\" rowspan=\"2\">Parámetro</td>\n        <td class=\"titulo backcolor\" colspan=\"2\">Valoración</td>\n      </tr>\n      <tr>\n        <td class=\"titulo backcolor\">CUMPLE</td>\n        <td class=\"titulo backcolor\">NO CUMPLE</td>\n      </tr>\n      <tr ng-repeat=\"(r,row) in $ctrl.proyecto.informe.valoracion\">\n        <td ng-repeat=\"(c,col) in row.cols\" colspan=\"{{col.colspan}}\" rowspan=\"{{col.rowspan}}\" class=\"{{col.class}}\" ng-class=\"{'center':col.contenido.type}\">\n          <strong ng-bind-html=\"col.titulo\"></strong>\n          <div ng-if=\"col.contenido.type=='inputMoney'\">\n            <c-input-money name=\"{{col.contenido.value}}{{r}}\" ng-model=\"col.contenido.value\"\n              ng-disabled=\"$ctrl.modoVista\"\n              ng-decimals=\"2\">\n            </c-input-money>\n          </div>\n          <div ng-if=\"col.contenido.type=='radio'\" ng-click=\"$ctrl.radioChange(row.cols, c)\" class=\"btn\" ng-class=\"[$ctrl.radioColor(col.contenido)]\" style=\"width:50px\"><i class=\"fa\" ng-class=\"{'fa-check-circle-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='textarea'\"><textarea ng-model=\"col.contenido.value\" cols=\"40\" rows=\"5\" ng-disabled=\"$ctrl.modoVista\"></textarea></div>\n          <div ng-if=\"col.contenido.type=='select'\" style=\"text-align: left;max-width: 300px;min-width: 300px;min-height: 180px;\">\n            <c-select ng-model=\"col.contenido.value\"\n            options=\"col.contenido.options\"\n            label=\"{{col.contenido.label}}\"\n            ng-disabled=\"$ctrl.modoVista\"></c-select>\n          </div>\n          <div ng-if=\"!col.contenido.type\" ng-bind-html=\"col.contenido\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n</section>\n<hr>\n<section class=\"col-xl-2\">\n  <button type=\"button\" ng-if=\"!$ctrl.modoVista\" class=\"btn btn-primary\" ng-click=\"$ctrl.generarInformePdf(form)\"><i class=\"fa fa-file-pdf-o\"></i> Generar<br>Informe</button>\n  <button md-effect type=\"button\" class=\"btn btn-primary\" uib-tooltip=\"Descargar resumen\" ng-if=\"$ctrl.documentos.length > 0 && $ctrl.Usuarios.esTecnicoResponsable()\"\n          download-file=\"{{ $ctrl.descarga.urlDescarga }}\" file-name=\"{{ $ctrl.descarga.nombreDescarga }}\">\n    <i class=\"fa fa-download\"></i> Informe<br>Resumen\n  </button>\n  <hr>\n  <div class=\"row\">\n    <div class=\"col\">Informe de evaluación</div>\n  </div>\n  <div class=\"row\">\n      <div class=\"col-md-6 col-xl-12\" ng-repeat=\"doc in $ctrl.documentos\" ng-if=\"doc.estado!=='INACTIVO' || $ctrl.esTecEval\">\n        <div class=\"btn btn-outline-tertiary\" style=\"width:100%;margin-top:2px;\">\n          <div ng-if=\"doc.estado!=='INACTIVO'\"><span ng-click=\"$ctrl.verInforme(doc)\">{{ doc.fecha_documento | date: 'dd/MM/yyyy' }}</span><span ng-click=\"$ctrl.corregirFecha(doc)\" ng-if=\"$ctrl.esTecEval\"> - <i class=\"fa fa-calendar-check-o text-warning\" uib-tooltip=\"Corregir fecha\"></i></span></div>\n          <div ng-if=\"$ctrl.esTecEval\" style=\"font-size:8px;color:#000;text-transform:none;\"><span ng-click=\"$ctrl.estado(doc)\" ng-if=\"$ctrl.esTecEval\"><i class=\"fa\" ng-class=\"{'fa-check-square-o': doc.estado!=='INACTIVO', 'fa-square-o': doc.estado==='INACTIVO'}\" uib-tooltip=\"Visible\" style=\"font-size:10px;\"></i> - </span>Creado: {{ doc._fecha_creacion | date: 'dd/MM/yyyy HH:mm' }}</div>\n        </div>\n      </div>\n  </div>\n</section>\n</div>\n<hr>\n<style>\n  .form-evaluacion .titulo {\n    text-align: center;\n    font-weight: bold;\n  }\n  .form-evaluacion .center {\n    text-align: center;\n  }\n  .form-evaluacion .right {\n    text-align: right;\n  }\n  .form-evaluacion .backcolor {\n    background-color: #BDD7EE;\n    border: 1px solid darkblue;\n  }\n  .form-evaluacion table {\n    width: 100%;\n  }\n  .form-evaluacion table th,\n  .form-evaluacion table th {\n    background-color: #BDD7EE;\n    text-align: center;\n  }\n  .form-evaluacion table td {\n    border: 1px solid #000;\n    padding-left: 4px;\n    padding-right: 4px;\n  }\n  .form-evaluacion table td .btn {\n    border: 1px solid #aaa;\n  }\n  .form-evaluacion table .w240 {\n    width: 240px;\n  }\n</style>\n"

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa {{$ctrl.icon}}\"></i> {{$ctrl.title}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.data.mensajeInformacion\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span ng-bind-html=\"$ctrl.data.mensajeInformacion\"></span>\n  </div>\n  <div ng-if=\"$ctrl.data.cargarItems\">\n\n    <button md-effect type=\"button\" class=\"btn btn-success btn-sm mr-1\" uib-tooltip=\"Descargar archivo modelo ods de items\"\n    download-file=\"{{$ctrl.descargas.modelo.ruta}}\" file-name=\"{{$ctrl.descargas.modelo.nombre}}\" download-type=\"ods\">\n    <i class=\"fa fa-download\"></i> Modelo ODS</button>\n\n    <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Descargar manual para crear un archivo ods de items\"\n    download-file=\"{{$ctrl.descargas.manual.ruta}}\" file-name=\"{{$ctrl.descargas.manual.nombre}}\">\n    <i class=\"fa fa-download\"></i> Manual ODS</button>\n  </div>\n\n  <ng-form name=\"formItem\">\n    <div class=\"row\">\n\n      <div class=\"md-input-group col-md-12\">\n        <ui-input-file name=\"doc_resmin_cife\"\n          file-base64=\"$ctrl.archivo\"\n          types=\"{{$ctrl.data.formatos}}\"\n          mime-types=\"{{$ctrl.data.tipos}}\"\n          maxfiles=\"1\" maxsize=\"3MB\"\n          ng-required=\"true\">\n        </ui-input-file>\n      </div>\n\n    </div>\n  </ng-form>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"button\" md-effect class=\"btn btn-primary\" validar-formulario=\"formItem\"\n    ng-click=\"$ctrl.registrar()\">\n    <i class=\"fa fa-upload\"></i> {{$ctrl.labelOk}}\n  </button>\n</div>\n"

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"items\">\n  <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.adicionarModulo()\"\n          ng-if=\"!$ctrl.modoVista && !$ctrl.tieneSupervisiones()\">\n    <i class=\"fa fa-plus\"></i> Adicionar Módulo\n  </button>\n  <button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.importarItems()\"\n          ng-if=\"!$ctrl.modoVista && !$ctrl.tieneSupervisiones()\">\n    <i class=\"fa fa-upload\"></i> Importar Items\n  </button>\n  <button md-effect type=\"button\" class=\"{{$ctrl.adjudicacion.doc_especificaciones_tecnicas ? 'btn btn-success' : 'btn btn-warning'}}\"\n          ng-click=\"$ctrl.cargarEspecificacionesTecnicas()\"\n          ng-if=\"!$ctrl.modoVista\">\n    <i class=\"fa fa-upload\"></i> Cargar Especificaciones Técnicas\n  </button>\n  <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.verEspecificacionesTecnicas()\"\n    ng-if=\"$ctrl.adjudicacion.doc_especificaciones_tecnicas\">\n    <i class=\"fa fa-file-text-o\"></i> Ver Especificaciones Técnicas\n  </button>\n  <div class=\"float-right col-md-4\">\n    <c-select name=\"adjudicacion\"\n      label=\"Seleccione una adjudicacion\"\n      ng-model=\"$ctrl.adjudicacionSeleccionada\"\n      options=\"$ctrl.opcionesAdjudicaciones\"\n      field=\"referencia\"\n      ng-required=\"true\"\n      ng-if=\"!$ctrl.Usuarios.esResponsableProyecto()\">\n    </c-select>\n    <div class=\"md-input-group\" ng-if=\"$ctrl.proyecto.adj\"> <!--se logro encontrar el problema por el cual no mostraba esta fecha de orden proceder de esta adjudicacion-->\n      <c-date name=\"orden_proceder\" label=\"Fecha de orden de proceder de esta adjudicación\"\n              ng-model=\"$ctrl.proyecto.adj.orden_proceder\"\n              ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('orden_proceder')\"\n              ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('orden_proceder') || $ctrl.tieneSupervisiones()\"\n              min-date=\"$ctrl.validacion.fecha_minima\"\n              mensaje-min-date=\"{{$ctrl.validacion.mensaje_fecminima}}\">\n      </c-date>\n    </div>\n  </div>\n\n  <br><br>\n  <br ng-if=\"!$ctrl.Usuarios.esResponsableProyecto()\">\n  <br ng-if=\"!$ctrl.Usuarios.esResponsableProyecto()\">\n  <br ng-if=\"$ctrl.proyecto.adj\">\n  <br ng-if=\"$ctrl.proyecto.adj\">\n\n  <ng-form name=\"form_{{modulo.id_modulo}}\" ng-repeat=\"(keyModulo,modulo) in $ctrl.modulos | orderBy : 'id_modulo'\">\n    <!--<span md-effect class=\" text-primary\" ng-click=\"modulo.show=!modulo.show\">-->\n    <span md-effect class=\" text-primary\" ng-click=\"$ctrl.getItems(modulo)\">\n      <strong>{{modulo.nombre.split('|')[0]}}</strong>\n      <p><i class=\"fa fa-plus\" ng-if=\"!modulo.show\"></i><i class=\"fa fa-minus\" ng-if=\"modulo.show\"></i> &nbsp; &nbsp; {{modulo.nombre.split('|')[1]}}</p>\n    </span>\n\n    <div class=\"float-right\">\n      <div style=\"display: inline-block;\">{{modulo.subtotal | formatDecimal}}&nbsp;&nbsp;</div>\n      <div ng-if=\"!$ctrl.modoVista && !$ctrl.tieneSupervisiones(modulo)\">\n        <button class=\"btn btn-link text-success ml-1  pl-1 pr-1\" ng-click=\"$ctrl.guardarDatosModulo(modulo)\"\n          uib-tooltip=\"Guardar datos del módulo\" validar-formulario nombre-formulario=\"form_{{modulo.id_modulo}}\">\n          <i class=\"fa fa-save\"></i>\n        </button>\n        <button class=\"btn btn-link text-success ml-1  pl-1 pr-1\" ng-click=\"$ctrl.adicionarItem(modulo);modulo.show=true\" uib-tooltip=\"Agregar nuevo item\">\n          <i class=\"fa fa-plus-square-o\"></i>\n        </button>\n        <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"$ctrl.editarModulo(modulo)\" uib-tooltip=\"Editar módulo\">\n          <i class=\"fa fa-edit\"></i>\n        </button>\n        <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1\" ng-click=\"$ctrl.eliminarModulo(modulo)\" uib-tooltip=\"Eliminar módulo\">\n          <i class=\"fa fa-trash-o\"></i>\n        </button>\n      </div>\n    </div>\n    <hr>\n\n      <div class=\"items\" ng-repeat=\"(keyItem,item) in modulo.items | orderBy : 'nro_item' \" ng-if=\"modulo.show\">\n        <div class=\"row\">\n          <div class=\"col-md-1 nro-item text-info\">\n              <strong class=\"mt-3\"> {{item.nro_item}} </strong>\n          </div>\n          <div class=\"md-input-group col-md-3\">\n            <c-input name=\"item_nombre_{{keyItem}}\" label=\"Nombre\" ng-model=\"item.nombre\"\n            maxlength=\"150\"\n            ng-required=\"true\" ng-disabled=\"!item.edicion\">\n            </c-input>\n          </div>\n\n          <div class=\"md-input-group col-md-1\">\n            <c-select name=\"item_unidad_{{keyItem}}\" label=\"Unidad\" ng-model=\"item.unidad_medida\"\n              options=\"$ctrl.unidades\" key-value=\"codigo\" field=\"descripcion\" ng-required=\"true\" ng-disabled=\"!item.edicion\">\n            </c-select>\n          </div>\n\n          <div class=\"md-input-group col-md-2\">\n            <!-- <c-input-numeric name=\"item_cantidad_{{keyItem}}\" label=\"Cantidad\" ng-model=\"item.cantidad\"\n                             ng-minvalue=\"1\" ng-maxvalue=\"1\" ng-decimals=\"0\"\n                             ng-required=\"true\" ng-disabled=\"!item.edicion\" ng-if=\"item.unidad_medida === 'UN_GLOBAL'\" ng-keyup=\"$ctrl.calcularItem(item, keyItem, keyModulo)\">\n            </c-input-numeric> -->\n            <c-input-numeric name=\"item_cantidad_{{keyItem}}\" label=\"Cantidad\" ng-model=\"item.cantidad\"\n                             ng-minvalue=\"1\" ng-maxvalue=\"999999\" ng-decimals=\"0\"\n                             ng-required=\"true\" ng-disabled=\"!item.edicion\" ng-if=\"item.unidad_medida === 'UN_GLOBAL' || item.unidad_medida === 'UN_PIEZA' || item.unidad_medida === 'UN_PUNTO'\" ng-keyup=\"$ctrl.calcularItem(item, keyItem, keyModulo)\">\n            </c-input-numeric>\n            <c-input-numeric name=\"item_cantidad_{{keyItem}}\" label=\"Cantidad\" ng-model=\"item.cantidad\"\n                             ng-minvalue=\"0\" ng-maxvalue=\"9999999\" ng-decimals=\"6\"\n                             ng-required=\"true\" ng-disabled=\"!item.edicion\" ng-if=\"item.unidad_medida !== 'UN_GLOBAL' && item.unidad_medida !== 'UN_PIEZA' && item.unidad_medida !== 'UN_PUNTO'\" ng-keyup=\"$ctrl.calcularItem(item, keyItem, keyModulo)\">\n            </c-input-numeric>\n          </div>\n\n          <div class=\"md-input-group col-md-2\">\n            <c-input-numeric name=\"item_precio_{{keyItem}}\" label=\"Precio\" ng-model=\"item.precio_unitario\"\n                             ng-minvalue=\"0\" ng-maxvalue=\"99999999\" ng-decimals=\"2\"\n                             ng-required=\"$ctrl.Proyecto.esRequerido('modulos')\"\n                             ng-if=\"$ctrl.Proyecto.esRequerido('modulos') || $ctrl.modoVista\"\n                             ng-disabled=\"!item.edicion\" ng-keyup=\"$ctrl.calcularItem(item, keyItem, keyModulo)\">\n            </c-input-numeric>\n            <!--\n              ng-blur=\"$ctrl.registrarPrecioItem(item)\"\n              ng-required=\"$ctrl.Proyecto.esRequerido('modulos.items.precio_unitario')\"\n              ng-disabled=\"$ctrl.modoVista && !$ctrl.Proyecto.esRequerido('modulos.items.precio_unitario')\"\n            -->\n          </div>\n<!-- ocultar peso ponderado porque ya no se utiliza -->\n<!--           <div class=\"md-input-group col-md-1\">\n            <c-input-numeric name=\"peso_ponderado_{{keyItem}}\" label=\"Peso ponderado\" ng-model=\"item.peso_ponderado\"\n                             ng-minvalue=\"0\" ng-maxvalue=\"1\" ng-decimals=\"1\"\n                             ng-required=\"$ctrl.Proyecto.esRequerido('modulos')\"\n                             ng-if=\"$ctrl.Proyecto.esRequerido('modulos') || $ctrl.modoVista\"\n                             ng-keyup=\"$ctrl.calcularItem(item_ponderado, keyItem, keyModulo)\"\n                             ng-blur=\"$ctrl.actualizarPesoItem(item)\">\n            </c-input-numeric>\n          </div> -->\n\n<!--           <div class=\"md-input-group col-md-1\">\n            <c-input-numeric name=\"variacion{{keyItem}}\" label=\"variacion decimal\" ng-model=\"item.variacion\"\n                             ng-minvalue=\"-1\" ng-maxvalue=\"1\" ng-decimals=\"3\"\n                             ng-if=\"item.regularizar\"\n                             ng-keyup=\"$ctrl.calcularItem(item, keyItem, keyModulo)\"\n                             ng-disabled=\"!item.edicion\"\n                             ng-blur=\"\">\n            </c-input-numeric>\n          </div> -->\n          <!-- ocultar regularizacion de decimales porque se ahora el sistema funcionara con 6 decimales en sus calculos -->\n<!--           <div class=\"md-input-group col-md-1 pt-4\">\n           <input type=\"checkbox\" name=\"regularizar{{keyItem}}\" ng-model=\"item.regularizar\" ng-change=\"$ctrl.checkboxRegularizar(item, keyItem, keyModulo);\" ng-if=\"$ctrl.Proyecto.esRequerido('modulos') || $ctrl.modoVista\" uib-tooltip=\"Regularizar variacion decimales\"ng-disabled=\"!item.edicion\">\n          </div> -->\n\n          <div class=\"md-input-group col-md-1\">\n            <c-input-numeric name=\"item_subtotal_{{keyItem}}\" label=\"Subtotal\" ng-model=\"item.subtotal\"\n                             ng-minvalue=\"0\" ng-maxvalue=\"99999999\" ng-decimals=\"2\"\n                             ng-required=\"false\"\n                             ng-if=\"$ctrl.Proyecto.esRequerido('modulos') || $ctrl.modoVista\"\n                             ng-disabled=\"true\">\n            </c-input-numeric>\n          </div>\n          <!-- <div class=\"md-input-group col-md-1\"> -->\n             <!-- <input type=\"checkbox\" name=\"regularizar{{keyItem}}\"  ng-model=\"item.regularizar\" ng-change=\"$\" ng-if=\"$ctrl.Proyecto.esRequerido('modulos') || $ctrl.modoVista\"> -->\n             <!-- <c-checkbox name=\"regularizar{{keyItem}}\" label=\"\" ng-model=\"item.regularizar\" ng-change=\"$\" ng-if=\"$ctrl.Proyecto.esRequerido('modulos') || $ctrl.modoVista\" uib-tooltip=\"Regularizar variacion decimales\"  ng-disabled=\"!item.edicion\" ></c-checkbox> -->\n          <!-- </div> -->\n\n          <div class=\"float-right\">\n            <button class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"!item.id_item? $ctrl.guardarItem(item, keyItem, keyModulo, modulo) : $ctrl.actualizarItem(item, keyItem, modulo)\"\n              ng-if=\"item.edicion && !$ctrl.modoVista && !$ctrl.tieneSupervisiones(modulo)\" uib-tooltip=\"Guardar\">\n              <i class=\"fa fa-save\"></i>\n            </button>\n           <!--  <button class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"\"\n              ng-if=\"item.edicion && !$ctrl.modoVista && !$ctrl.tieneSupervisiones(modulo)\" uib-tooltip=\"regularizar variacion decimales\">\n              <i class=\"fa fa-wrench\"></i>\n            </button> -->\n            <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"item.edicion = true\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista && !$ctrl.tieneSupervisiones(modulo)\" uib-tooltip=\"Editar\">\n              <i class=\"fa fa-edit\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"$ctrl.verEspecificacionesItem(item)\"\n              ng-if=\"!item.edicion && item.especificaciones\" uib-tooltip=\"Ver especificaciones\">\n              <i class=\"fa fa-file-text-o\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-info ml-1 pl-1 pr-1\" ng-click=\"$ctrl.cargarEspecificacionesItem(item)\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista && !$ctrl.tieneSupervisiones(modulo)\" uib-tooltip=\"Cargar especificaciones\">\n              <i class=\"fa fa-upload\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1\" ng-click=\"$ctrl.eliminarItem(item, keyItem, modulo)\"\n              ng-if=\"!$ctrl.modoVista && !$ctrl.tieneSupervisiones(modulo)\" uib-tooltip=\"Eliminar\">\n              <i class=\"fa fa-trash-o\"></i>\n            </button>\n          </div>\n\n        </div>\n    </div>\n\n  </ng-form>\n  <hr>\n  <!--\n    ng-if=\"$ctrl.Proyecto.esRequerido('modulos.items.precio_unitario') || $ctrl.modoVista\"\n  -->\n  <div class=\"alert alert-danger\" ng-if=\"$ctrl.Proyecto.esEditable('modulos') && $ctrl.diferencia != 0\">\n     <i class=\"fa fa-info-circle\"></i><strong> Nota: </strong><span>El <strong><em>precio total</em></strong> de los items debe ser igual al <strong><em>monto total adjudicado</em></strong></span>\n  </div>\n  <div class=\"row\" ng-if=\"$ctrl.Proyecto.esRequerido('modulos') || $ctrl.modoVista\">\n    <div class=\"col-md-3\" ng-if=\"!$ctrl.adjudicacion\">\n      Precio Total\n    </div>\n    <div class=\"col-md-9\" ng-if=\"!$ctrl.adjudicacion\">\n      <strong>{{$ctrl.proyecto.financiamiento.monto_total_proyecto | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\" ng-if=\"$ctrl.adjudicacion\">\n      Precio total de la adjudicación\n    </div>\n    <div class=\"col-md-9\" ng-if=\"$ctrl.adjudicacion\">\n      <strong>{{$ctrl.adjudicacion.monto | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\">\n      Precio Total (numeral)\n    </div>\n    <div class=\"col-md-9\">\n      <strong>{{$ctrl.precioTotal | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\">\n      Precio Total (literal)\n    </div>\n    <div class=\"col-md-9\">\n      <strong>{{$ctrl.precioTotal | numberToLiteral}}</strong>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 820 */
767,
/* 821 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa {{$ctrl.icon}}\"></i> {{$ctrl.title}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <ng-form name=\"formItem\">\n    <div class=\"row\">\n\n      <div class=\"md-input-group col-md-12\">\n        <!-- <c-select name=\"modulo_nombre\" label=\"Componente\" ng-model=\"$ctrl.modulo.componente\"\n          ng-required=\"true\" ng-disabled=\"false\" options=\"$ctrl.opcionesComponente\" field=\"nombre\">\n        </c-select> -->\n        <c-input name=\"modulo_nombre\" label=\"Componente\" ng-model=\"$ctrl.modulo.componente\"\n          ng-directives=\"uppercase\"\n          ng-required=\"true\" maxlength=\"150\"\n          ng-disabled=\"true\">\n        </c-input>\n      </div>\n      <div class=\"md-input-group col-md-12\">\n        <c-input name=\"modulo_nombre\" label=\"Módulo\" ng-model=\"$ctrl.modulo.modulo\"\n          ng-directives=\"uppercase\"\n          ng-required=\"true\" maxlength=\"150\">\n        </c-input>\n      </div>\n\n    </div>\n  </ng-form>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"button\" md-effect class=\"btn btn-primary\" validar-formulario=\"formItem\"\n    ng-click=\"!$ctrl.modulo.id_modulo ? $ctrl.guardar() : $ctrl.actualizar()\">\n    <i class=\"fa\" ng-class=\"!$ctrl.modulo.id_modulo ? 'fa-check' : 'fa-save'\"></i>\n    {{!$ctrl.modulo.id_modulo ? 'Adicionar' : 'Guardar'}}\n  </button>\n</div>\n"

/***/ }),
/* 822 */
818,
/* 823 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n\n  <div class=\"form-evaluacion table-responsive col-md-8\">\n    <!-- <table>\n      <tr>\n        <td class=\"center\"><img alt=\"logo_mdryt\" src=\"../../../../../images/fdi-logo.png\"/ height=\"100px\"></td>\n        <th>\n          <h4>FORMULARIO DE EVALUACION DEL EDTP</h4>\n          <h6>I. DATOS GENERALES DEL PROYECTO</h6>\n        </th>\n        <td class=\"center\"><img alt=\"logo_fdi\" src=\"../../../../../images/mdryt-logo.png\"/ height=\"100px\"></td>\n      </tr>\n    </table>\n    <hr> -->\n\n   <!--  <button type=\"button\" ng-if=\"!$ctrl.modoVista\" class=\"btn btn-xs btn-warning pull-right\" ng-click=\"$ctrl.regenerarFormulario()\">\n      <i class=\"fa fa-refresh\"></i> Regenerar\n    </button> -->\n    <!-- {{$ctrl.proyecto.cierre.lista_cierre}} -->\n    <button type=\"button\" ng-if=\"$ctrl.Proyecto.esEditable(lista_cierre)\" class=\"btn btn-sm btn-warning pull-right mt-1\" ng-click=\"$ctrl.regenerarFormulario()\" uib-tooltip=\"Regenerar lista\">\n      <i class=\"fa fa-refresh\"></i> \n    </button>\n    <table class=\"table table-sm table-borderless table-responsive\" style=\"font-size:12px;\">\n      <tr>\n        <td class=\"titulo\" colspan=\"2\">Requisitos</td>\n        <td class=\"titulo\">Cumple</td>\n        <td class=\"titulo\">No cumple</td>\n        <td class=\"titulo\">No aplica</td>\n        <td class=\"titulo\">Observaciones</td>\n        \n      </tr>\n      <tr ng-repeat=\"(r,row) in $ctrl.proyecto.cierre.lista_cierre\">\n        <td ng-repeat=\"(c,col) in row.cols\" colspan=\"{{col.colspan}}\" rowspan=\"{{col.rowspan}}\" ng-class=\"col.class\">\n\n          <strong ng-bind-html=\"col.titulo\"></strong>\n          <div ng-if=\"col.contenido.type=='checkbox'\" ng-click=\"col.contenido.value=$ctrl.modoVista?col.contenido.value:!col.contenido.value\" class=\"btn\" ng-class=\"{'btn-success':col.contenido.value,'btn-secondary':!col.contenido.value}\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-square-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='radio'\" ng-click=\"$ctrl.radioChange(row.cols, c,r)\" class=\"btn btn-sm\" ng-class=\"[$ctrl.radioColor(col.contenido)]\" style=\"width:100%\"><i class=\"fa\" ng-class=\"{'fa-check-circle-o':col.contenido.value}\"></i></div>\n          <div ng-if=\"col.contenido.type=='textarea'\"><textarea ng-model=\"col.contenido.value\" cols=\"25\" rows=\"1\" ng-disabled=\"$ctrl.modoVista\"></textarea></div>\n          <div ng-if=\"!col.contenido.type\" ng-bind-html=\"$ctrl.limitarTexto(col.contenido)\" uib-tooltip-html='\"<br>{{$ctrl.parsearTexto(col.contenido)}}<br>&nbsp;\"' tooltip-append-to-body=\"true\"></div>\n          <div ng-if=\"col.contenido.type=='button' && (r == 0 || r == 16 || r == 18)\" style=\"width:60px\"><button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-0 pb-0\" ng-click=\"$ctrl.verAdjunto(r,row.cols)\" \n              uib-tooltip=\"Ver documento\">\n              <i class=\"fa fa-file-text-o\"></i>\n            </button><button class=\"btn btn-link text-info ml-1 pl-1 pr-1 pt-0 pb-0\" ng-click=\"$ctrl.cargarAdjunto(row.cols)\"\n              uib-tooltip=\"Cargar documento\">\n              <i class=\"fa fa-upload\"></i>\n            </button></div>\n          <div ng-if=\"col.contenido.type=='button' && (r == 5 || r == 6 || r==7)\">\n            <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-0 pb-0\" ng-click=\"$ctrl.verAdjuntoSeguimiento(r)\" \n              uib-tooltip=\"Ver documento\">\n              <i class=\"fa fa-file-text-o\"></i>\n            </button>\n          </div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n<div class=\"col-md-4\">\n    <button type=\"button\" class=\"btn btn-actions c-pointer btn-outline-success\" ng-click=\"$ctrl.guardarChecklist()\" ng-if=\"$ctrl.Proyecto.esEditable('lista_cierre')\"><i class=\"fa fa-save\"></i>  Guardar Cambios</button>\n    <hr>\n    <div class=\"row\">\n      <div class=\"col\">\n        <div class=\"mt-3\">\n          <strong>\n            <em style=\"background-color: #fbb05e\">NOTA:</em>\n          </strong>\n          <ol>\n            <li>\n              Todos los informes de la entidad ejecutora deberan estar debidamente aprobados por todas las instancias y vías del informe.\n            </li>\n            <li>\n              Las fotocopias legalizadas deberan estar debidamente selladas y firmadas por la persona que legaliza los documentos.\n            </li>\n          </ol>\n          <strong>\n            <em style=\"background-color: #fbb05e\">ACLARACION:</em>\n          </strong>\n          <ol>\n            <li>El proyecto se cierra con el proceso cocluido de la auditoría, para entenderlo mejor se divide en dos partes el checklist, los requisitos del 1 al 6 (proceso de cierre) y del 7 al 9 (proceso de auditoría).</li>\n          </ol>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  \n</div>\n<div class=\"row\">\n  <div class=\"col-md-4\"></div>\n  <div class=\"col-md-4\"></div>\n  <div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-actions c-pointer btn-outline-success\" ng-click=\"$ctrl.guardarChecklist()\" ng-if=\"$ctrl.Proyecto.esEditable('lista_cierre')\"><i class=\"fa fa-save\"></i>  Guardar Cambios</button></div>\n  \n</div>\n\n<style>\n  .form-evaluacion .titulo {\n    text-align: center;\n    font-weight: bold;\n    font-size: 12px;\n  }\n  .form-evaluacion .center {\n    text-align: center;\n  }\n  .form-evaluacion .right {\n    text-align: right;\n  }\n  .form-evaluacion .backcolor {\n    background-color: #BDD7EE;\n    border: 1px solid darkblue;\n  }\n  .form-evaluacion table {\n    width: 100%;\n  }\n  .form-evaluacion table th,\n  .form-evaluacion table th {\n    background-color: #BDD7EE;\n    text-align: center;\n  }\n  .form-evaluacion table td {\n    border: 1px dashed #d3c0c0;\n    padding-left: 4px;\n    padding-right: 4px;\n  }\n  .form-evaluacion table td .btn {\n    border: 1px solid #aaa;\n  }\n  .form-evaluacion table .w240 {\n    width: 240px;\n  }\n</style>"

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Fecha Inicio del Proyecto\n  </h6>\n\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.Proyecto.esEditable('orden_proceder')\">\n    <i class=\"fa fa-info-circle\"></i><span> Al introducir la fecha de incio/orden proceder se inicia el tiempo de ejecución del proyecto.</span>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.Proyecto.esEditable('orden_proceder')\">\n      <button md-effect type=\"button\"\n        class=\"btn btn-actions c-pointer btn-outline-success\"\n        ng-if=\"$ctrl.Proyecto.esEditable('orden_proceder')\"\n        ng-click=\"$ctrl.guardarDatos()\" uib-tooltip=\"Guardar\">\n        <i class=\"fa fa-save\"></i> \n      </button>\n    </div>\n    <div class=\"md-input-group col-md-6\">\n      <c-date name=\"orden_proceder\" label=\"Fecha incio del proyecto\"\n              ng-model=\"$ctrl.proyecto.orden_proceder\"\n              ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('orden_proceder')\"\n              ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('orden_proceder')\"\n              min-date=\"$ctrl.validacion.fecha_minima\"\n              mensaje-min-date=\"{{$ctrl.validacion.mensaje_fecminima}}\">\n      </c-date>\n      <c-textarea name=\"observacion\" label=\"Observacion\" ng-model=\"$ctrl.proyecto.obs_orden_proceder\" ng-required=\"false\"  ng-if=\"$ctrl.Usuarios.esTecnicoResponsable() || $ctrl.Usuarios.esVisorReportes()\" ng-disabled=\"!$ctrl.Proyecto.esEditable('orden_proceder')\"></c-textarea>\n    </div>\n    <div class=\"md-input-group col-md-5\">\n      <archivo name=\"doc_ordenproceder\" label=\"Documento orden proceder\" ng-model=\"$ctrl.proyecto.doc_orden_proceder\" types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\" url=\"{{$ctrl.archivos.urlDocOrdenProceder}}\" url-descarga=\"{{$ctrl.archivos.urlDocOrdenProcederDescarga}}\" ></archivo>\n    </div>\n\n  </div>\n</section>\n"

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Plazo de recepción definitiva\n  </h6>\n\n  <!-- <div class=\"alert alert-info\" ng-if=\"$ctrl.Proyecto.esEditable('orden_proceder')\">\n    <i class=\"fa fa-info-circle\"></i><span> Al introducir la fecha de orden de proceder se inicia el tiempo de ejecución del proyecto.</span>\n  </div> -->\n\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-6\">\n      <c-input name=\"plazo_recepcion_definitiva\" label=\"Plazo de recepción definitiva [días]\" ng-model=\"$ctrl.proyecto.plazo_recepcion_definitiva\"\n        ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('plazo_recepcion_definitiva')\"\n        ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('plazo_recepcion_definitiva')\"\n        ng-blur=\"$ctrl.validarPlazo()\">\n      </c-input>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n<div class=\"col-xl-12\">\n\t<!-- <reg-convenio proyecto=\"$ctrl.proyecto\" ></reg-convenio> -->\n        <div class=\"row\">\n        \t<div class=\"col-md-auto\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>Datos del proyecto</label>\n\t\t\t\t\t<p><b>Nombre : </b>{{$ctrl.proyecto.nombre}}<br>\n\t\t\t\t\t<b>Departamento : </b>{{$ctrl.proyecto.dpa.departamento.nombre}}\n\t\t\t\t\t<b>Provincia : </b>{{$ctrl.proyecto.dpa.provincia.nombre}}\n\t\t\t\t\t<b>Municipio : </b>{{$ctrl.proyecto.dpa.municipio.nombre}}<br>\n\t\t\t\t\t<b>Tipo del proyecto: </b>{{$ctrl.proyecto.tipo}}\n\t\t\t\t\t<b>Tipo de financiamiento : </b>{{$ctrl.proyecto.tipo_financiamiento}}\n\t\t\t\t\t<b>Tamaño del proyecto: </b>{{$ctrl.proyecto.tamanio_proyecto}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-auto\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>Datos Convenio.</label>\n\t\t\t\t\t<p><b>Plazo Convenio: </b>{{$ctrl.proyecto.plazo_ejecucion}} (Dias calendario.)<br>\n\t\t\t\t\t<b>Nro Convenio: </b>{{$ctrl.proyecto.convenio.nro_convenio}} <br>\n\t\t\t\t\t<b>Fecha suscripcion : </b>{{$ctrl.proyecto.convenio.fecha_suscripcion | date}}</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\t\t\t<div class=\"col-md-auto\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>Desembolsos (Bs.)</label>\n\t\t\t\t\t<p><b>1er Desembolso : </b>{{$ctrl.proyecto.cronograma_desembolsos.monto_1 | number:2}} <b>Fecha :</b> {{$ctrl.proyecto.cronograma_desembolsos.fecha_1 | date}} <br>\n\t\t\t\t\t<b>2do Desembolso : </b>{{$ctrl.proyecto.cronograma_desembolsos.monto_2 | number:2}} <b>Fecha :</b> {{$ctrl.proyecto.cronograma_desembolsos.fecha_2 | date}} <br>\n\t\t\t\t\t<b>3er Desembolso : </b>{{$ctrl.proyecto.cronograma_desembolsos.monto_3 | number:2}} <b>Fecha :</b> {{$ctrl.proyecto.cronograma_desembolsos.fecha_3 | date}} </p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\n\n        </div>\t\n\t\t<reg-orden-proceder proyecto=\"$ctrl.proyecto\" ></reg-orden-proceder>\n\n\n\n<!-- \t<form name=\"form\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col\">\n\t\t\t\t<div class=\"alert alert-info\">\n\t\t\t\t\t<i class =\"fa fa-info-circle\"></i> Para generar el informe debe llenar los siguientes datos.\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div> -->\n\t\t\t\n<!-- \t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-12\">\n\t\t\t\t\t<c-textarea name=\"situacion_general\" label=\"Situacion general\" ng-model=\"$ctrl.proyecto.seguimiento.situacion_general\" ng-required=\"false\" ng-disabled=\"$ctrl.modoVista\"></c-textarea>\n\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-12\">\n\t\t\t\t\t<c-textarea name=\"objetivo_general\" label=\"Objetivo general\" ng-model=\"$ctrl.proyecto.seguimiento.objetivo_general\" ng-required=\"false\" ng-disabled=\"$ctrl.modoVista\"></c-textarea>\n\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-12\">\n\t\t\t\t\t<c-textarea name=\"resultados\" label=\"Resultados\" ng-model=\"$ctrl.proyecto.seguimiento.resultados\" ng-required=\"false\" ng-disabled=\"$ctrl.modoVista\"></c-textarea>\n\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t</div> -->\n\t\t<!-- <section ng-if=\"$ctrl.Proyecto.esEditable('impacto')\">\n\t\t\t<h6 class=\"title-section m-top\"> <i class=\"fa fa-hand-o-right\"></i> Impacto</h6>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-auto\">\n\t\t\t\t\t<button md-effect type=\"button\"\n\t\t\t\t\t\tclass=\"btn btn-actions c-pointer btn-outline-success\"\n\t\t\t\t\t\tng-if=\"$ctrl.usuario.rol.id_rol == 13 && $ctrl.Proyecto.esEditable('seguimiento')\"\n\t\t\t\t\t\tng-click=\"$ctrl.guardarDatos()\" uib-tooltip=\"Guardar\">\n\t\t\t\t\t\t<i class=\"fa fa-save\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-10\">\n\t\t\t\t\t<c-textarea name=\"impacto\" label=\"Impacto\" ng-model=\"$ctrl.proyecto.seguimiento.impacto\" ng-required=\"false\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\"></c-textarea>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n -->\n\n\n<!-- Adendas y convenios modificatorios-->\n<section ng-if=\"!$ctrl.Usuarios.esFiscal()\">\n\t<h6 class=\"title-section m-top\">\n\t\t<i class=\"fa fa-hand-o-right\"></i> Adendas y Convenio Modificatorio\n\t</h6>\n\t<!-- <div class=\"row\">\n\t\t<div class=\"col\"></div>\n\t\t<div class=\"col\"></div>\n\t\t<div class=\"col\"><button uib-popover-template=\"$ctrl.dynamicPopover2.templateUrl\" popover-placement=\"top\"  popover-trigger=\"'mouseenter'\"  type=\"button\" class=\"btn btn-outline-info btn-sm\">Ver desembolsos</button></div>\n\t\t<div class=\"col\"></div>\n\t\t<div class=\"col\">\n\t\t\t<button uib-popover-template=\"$ctrl.dynamicPopover.templateUrl\" popover-placement=\"top\"  popover-trigger=\"'mouseenter'\"  popover-is-open =\"true\" type=\"button\" class=\"btn btn-outline-info btn-sm\">Ver detalle</button>\n\t\t</div>\n\t</div> -->\n\t<div class=\"row\">\n\t\t<div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.orden_proceder\">\n          <c-date name=\"fecha_orden_proceder\" label=\"Fecha inicio del proyecto\" ng-model=\"$ctrl.proyecto.orden_proceder\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n        <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.orden_proceder\">\n          <c-date name=\"fecha_finalizacion_convenio\" label=\"Finalización del plazo\" ng-model=\"$ctrl.plazo_convenio0\"\n          ng-disabled=\"true\"></c-date>\n        </div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12 col-lg-12\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-select name=\"tipo_plazo\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado\"\n\t\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido') || $ctrl.proyecto.doc_convenio_extendido\">\n\t\t\t\t\t</c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-input name=\"plazo_convenio_ampliado\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado\"\n\t\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio1()\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido') || $ctrl.proyecto.doc_convenio_extendido\">\n\t\t\t\t\t</c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado >= 0\">\n\t\t\t\t\t<c-date name=\"fecha_ampliacion_con\" label=\"1ra fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio1\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\t\tng-disabled=\"true\">\n\t\t\t\t\t</c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT')\"\n\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido\" uib-tooltip=\"Ver documento\">\n\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t            </button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado\">\n\t\t<div class=\"col-md-12 col-lg-12\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-select name=\"tipo_plazo2\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado2\"\n\t\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido2') || $ctrl.proyecto.doc_convenio_extendido2\">\n\t\t\t\t\t</c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-input name=\"plazo_convenio_ampliado2\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado2\"\n\t\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio2()\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido2')  || $ctrl.proyecto.doc_convenio_extendido2\">\n\t\t\t\t\t</c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado2 >= 0\">\n\t\t\t\t\t<c-date name=\"fecha_ampliacion_con2\" label=\"2da fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio2\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT2')\"\n\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido2\" uib-tooltip=\"Ver documento\">\n\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t            </button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido\">\n\t\t</div>\n\t</div>\n\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado2\">\n\t<div class=\"col-md-12 col-lg-12\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-select name=\"tipo_plazo3\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado3\"\n\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido3') || $ctrl.proyecto.doc_convenio_extendido3\">\n\t\t\t\t</c-select>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-input name=\"plazo_convenio_ampliado3\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado3\"\n\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio3()\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido3') || $ctrl.proyecto.doc_convenio_extendido3\">\n\t\t\t\t</c-input>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado3 >= 0\">\n\t\t\t\t<c-date name=\"fecha_ampliacion_con3\" label=\"3ra fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio3\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t</div>\n\t\t\t<div class=\"float-right\">\n\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT3')\"\n\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido3\" uib-tooltip=\"Ver documento\">\n\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t            </button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido2\">\n\t</div>\n\t</div>\n\t<!-- adenda 4 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado3\">\n\t<div class=\"col-md-12 col-lg-12\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-select name=\"tipo_plazo4\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado4\"\n\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido4') || $ctrl.proyecto.doc_convenio_extendido4\">\n\t\t\t\t</c-select>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-input name=\"plazo_convenio_ampliado4\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado4\"\n\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio4()\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido4') || $ctrl.proyecto.doc_convenio_extendido4\">\n\t\t\t\t</c-input>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado4 >= 0\">\n\t\t\t\t<c-date name=\"fecha_ampliacion_con4\" label=\"4ta fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio4\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t</div>\n\t\t\t<div class=\"float-right\">\n\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT4')\"\n\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\" uib-tooltip=\"Ver documento\">\n\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t            </button>\n\t\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido3\">\n\t</div>\n\t</div>\n\t<!-- adenda 5 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado4\">\n\t<div class=\"col-md-12 col-lg-12\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-select name=\"tipo_plazo5\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado5\"\n\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido5') || $ctrl.proyecto.doc_convenio_extendido5\">\n\t\t\t\t</c-select>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-input name=\"plazo_convenio_ampliado5\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado5\"\n\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio5()\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido5') || $ctrl.proyecto.doc_convenio_extendido5\">\n\t\t\t\t</c-input>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado3 >= 0\">\n\t\t\t\t<c-date name=\"fecha_ampliacion_con5\" label=\"5ta fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio5\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t</div>\n\t\t\t<div class=\"float-right\">\n\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT5')\"\n\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido5\" uib-tooltip=\"Ver documento\">\n\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t            </button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n\t</div>\n\t</div>\n\t<!-- adenda 6 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado5\">\n\t<div class=\"col-md-12 col-lg-12\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-select name=\"tipo_plazo6\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado6\"\n\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido6') || $ctrl.proyecto.doc_convenio_extendido6\">\n\t\t\t\t</c-select>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-input name=\"plazo_convenio_ampliado6\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado6\"\n\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio6()\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido6') || $ctrl.proyecto.doc_convenio_extendido6\">\n\t\t\t\t</c-input>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado3 >= 0\">\n\t\t\t\t<c-date name=\"fecha_ampliacion_con6\" label=\"6ta fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio6\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t</div>\n\t\t\t<div class=\"float-right\">\n\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT6')\"\n\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido6\" uib-tooltip=\"Ver documento\">\n\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t            </button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido6\">\n\t</div>\n\t</div>\n\t<!-- adenda 7 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado6\">\n\t<div class=\"col-md-12 col-lg-12\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-select name=\"tipo_plazo7\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado7\"\n\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido7') || $ctrl.proyecto.doc_convenio_extendido7\">\n\t\t\t\t</c-select>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-input name=\"plazo_convenio_ampliado7\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado7\"\n\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio7()\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido7') || $ctrl.proyecto.doc_convenio_extendido7\">\n\t\t\t\t</c-input>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado3 >= 0\">\n\t\t\t\t<c-date name=\"fecha_ampliacion_con7\" label=\"7ma fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio7\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t</div>\n\t\t\t<div class=\"float-right\">\n\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT7')\"\n\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido7\" uib-tooltip=\"Ver documento\">\n\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t            </button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n\t</div>\n\t</div>\n\n\t\t<!-- adenda 8 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado7\">\n\t<div class=\"col-md-12 col-lg-12\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-select name=\"tipo_plazo8\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado8\"\n\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido8') || $ctrl.proyecto.doc_convenio_extendido8\">\n\t\t\t\t</c-select>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t<c-input name=\"plazo_convenio_ampliado8\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado8\"\n\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio8()\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido8') || $ctrl.proyecto.doc_convenio_extendido8\">\n\t\t\t\t</c-input>\n\t\t\t</div>\n\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado7 >= 0\">\n\t\t\t\t<c-date name=\"fecha_ampliacion_con8\" label=\"8 fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio8\"\n\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t</div>\n\t\t\t<div class=\"float-right\">\n\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT8')\"\n\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido8\" uib-tooltip=\"Ver documento\">\n\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t            </button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n\t</div>\n\t</div>\n\n\t\t<!-- adenda 9 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado8\">\n\t\t<div class=\"col-md-12 col-lg-12\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-select name=\"tipo_plazo9\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado9\"\n\t\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido7') || $ctrl.proyecto.doc_convenio_extendido9\">\n\t\t\t\t\t</c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-input name=\"plazo_convenio_ampliado9\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado9\"\n\t\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio9()\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido9') || $ctrl.proyecto.doc_convenio_extendido9\">\n\t\t\t\t\t</c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado8 >= 0\">\n\t\t\t\t\t<c-date name=\"fecha_ampliacion_con9\" label=\"9 fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio9\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT9')\"\n\t\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido9\" uib-tooltip=\"Ver documento\">\n\t\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t\t            </button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n\t\t</div>\n\t</div>\n\n\t<!-- adenda 10 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado9\">\n\t\t<div class=\"col-md-12 col-lg-12\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-select name=\"tipo_plazo10\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado10\"\n\t\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido10') || $ctrl.proyecto.doc_convenio_extendido10\">\n\t\t\t\t\t</c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-input name=\"plazo_convenio_ampliado10\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado10\"\n\t\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio10()\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido10') || $ctrl.proyecto.doc_convenio_extendido10\">\n\t\t\t\t\t</c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado9 >= 0\">\n\t\t\t\t\t<c-date name=\"fecha_ampliacion_con10\" label=\"fecha ampliada\" ng-model=\"$ctrl.plazo_convenio10\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT10')\"\n\t\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido10\" uib-tooltip=\"Ver documento\">\n\t\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t\t            </button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n\t\t</div>\n\t</div>\n\n\t<!-- adenda 11 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado10\">\n\t\t<div class=\"col-md-12 col-lg-12\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-select name=\"tipo_plazo11\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado11\"\n\t\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido11') || $ctrl.proyecto.doc_convenio_extendido11\">\n\t\t\t\t\t</c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-input name=\"plazo_convenio_ampliado11\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado11\"\n\t\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio11()\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido11') || $ctrl.proyecto.doc_convenio_extendido11\">\n\t\t\t\t\t</c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado10 >= 0\">\n\t\t\t\t\t<c-date name=\"fecha_ampliacion_con11\" label=\"fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio11\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT11')\"\n\t\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido11\" uib-tooltip=\"Ver documento\">\n\t\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t\t            </button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n\t\t</div>\n\t</div>\n\n\t<!-- adenda 12 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado11\">\n\t\t<div class=\"col-md-12 col-lg-12\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-select name=\"tipo_plazo12\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado12\"\n\t\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido12') || $ctrl.proyecto.doc_convenio_extendido12\">\n\t\t\t\t\t</c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-input name=\"plazo_convenio_ampliado12\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado12\"\n\t\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio12()\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido12') || $ctrl.proyecto.doc_convenio_extendido12\">\n\t\t\t\t\t</c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado11 >= 0\">\n\t\t\t\t\t<c-date name=\"fecha_ampliacion_con12\" label=\"fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio12\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT12')\"\n\t\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido12\" uib-tooltip=\"Ver documento\">\n\t\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t\t            </button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n\t\t</div>\n\t</div>\n\n\t<!-- adenda 13 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado12\">\n\t\t<div class=\"col-md-12 col-lg-12\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-select name=\"tipo_plazo13\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado13\"\n\t\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido13') || $ctrl.proyecto.doc_convenio_extendido13\">\n\t\t\t\t\t</c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-input name=\"plazo_convenio_ampliado13\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado13\"\n\t\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio13()\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido13') || $ctrl.proyecto.doc_convenio_extendido13\">\n\t\t\t\t\t</c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado12 >= 0\">\n\t\t\t\t\t<c-date name=\"fecha_ampliacion_con13\" label=\"fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio13\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT13')\"\n\t\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido13\" uib-tooltip=\"Ver documento\">\n\t\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t\t            </button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n\t\t</div>\n\t</div>\n\n\t<!-- adenda 14 -->\n\t<div class=\"row\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado13\">\n\t\t<div class=\"col-md-12 col-lg-12\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-select name=\"tipo_plazo14\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.convenio.tipo_plazo_convenio_ampliado14\"\n\t\t\t\t\toptions=\"$ctrl.tipos_plazo_ampliado\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido14') || $ctrl.proyecto.doc_convenio_extendido14\">\n\t\t\t\t\t</c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-input name=\"plazo_convenio_ampliado14\" label=\"Plazo ampliado de convenio\" ng-model=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado14\"\n\t\t\t\t\tng-blur=\"$ctrl.recalcularPlazoConvenio14()\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esRequerido('doc_convenio_extendido')\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('doc_convenio_extendido14') || $ctrl.proyecto.doc_convenio_extendido14\">\n\t\t\t\t\t</c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\" ng-if=\"$ctrl.proyecto.convenio.plazo_convenio_ampliado13 >= 0\">\n\t\t\t\t\t<c-date name=\"fecha_ampliacion_con14\" label=\"fecha ampliada convenio\" ng-model=\"$ctrl.plazo_convenio14\"\n\t\t\t\t\tng-required=\"$ctrl.Proyecto.esEditable('fecha_ampliada')\"\n\t\t\t\t\tng-disabled=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t\t <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.verAdenda('CXT14')\"\n\t\t\t              ng-if=\"$ctrl.proyecto.doc_convenio_extendido14\" uib-tooltip=\"Ver documento\">\n\t\t\t              <i class=\"fa fa-file-text-o\"></i> Ver documento\n\t\t\t            </button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-md-12 col-lg-6\" ng-if=\"$ctrl.proyecto.doc_convenio_extendido4\">\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col\">\n\t\t\t<button md-effect type=\"button\"\n\t\t\t\t\tclass=\"btn btn-actions c-pointer btn-outline-success\"\n\t\t\t\t\tng-if=\"$ctrl.Proyecto.esEditable('seguimiento')\"\n\t\t\t\t\tng-click=\"$ctrl.guardarAdendas()\" uib-tooltip=\"Guardar\"\n\t\t\t\t\tng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\">\n\t\t\t\t\t<i class=\"fa fa-save\"></i>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\n</div>\n</section>\n<hr>\n<div class=\"col-xl-2\" ng-if=\"false\">\n\t<button type=\"button\" ng-if=\"!$ctrl.modoVista\" class=\"btn btn-primary\" ng-click=\"$ctrl.generarInformePdf(form)\"><i class=\"fa fa-file-pdf-o\"></i> Generar<br>Informe</button>\n\t<hr>\n\t<div class=\"row\">\n\t \t<div class=\"col\">Informe tecnico final</div>\n\t</div>\n\t<div class=\"row\"></div>\n</div>\n</div >\n<!-- AVANCE FISICO -->\n<section ng-if=\"!$ctrl.Usuarios.esFiscal()\">\n\t<h6 class=\"title-section m-top\">Avance Fisico del Proyecto</h6>\n\t<div class=\"row\" ng-hide=\"!$ctrl.proyecto.seguimiento.avance_fis.length\">\n        <div class=\"col-md-6\">\n        \t<uib-progressbar value=\"$ctrl.proyecto.seguimiento.avance_fis[$ctrl.proyecto.seguimiento.avance_fis.length - 1].porcentaje\" type=\"\"class=\"progress-striped active\">{{$ctrl.proyecto.seguimiento.avance_fis[$ctrl.proyecto.seguimiento.avance_fis.length - 1].porcentaje}}%\n        \t</uib-progressbar>\n        \t<small><em><strong>Avance Fisico del proyecto</strong></em></small>\n\t\t</div>\n        <div class=\"col-md-12\">\n\t    \t<hr style=\"border-top: 1px dashed #8c8b8b; margin-top: 0rem;margin-bottom: 0rem;\">\n\t\t\t<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n\t\t\t\tuib-tooltip=\"Ver planillas\" ng-click=\"$ctrl.verSupervisiones()\">\n\t\t\t\t<i class=\"fa fa-list\"></i> Ver planillas y fotos \n\t\t\t</button> \n\n\t\t\t<button md-effect type=\"button\" class=\"btn btn-success btn-sm mt-1\"\n\t\t\t\tng-click=\"$ctrl.irAModificaciones($ctrl.proyecto)\" uib-tooltip=\"Modificaciones\"\n\t\t\t\tng-if=\"($ctrl.proyecto.estado_proyecto === 'EN_EJECUCION_FDI') && $ctrl.puedeVerModificaciones($ctrl.proyecto)\">\n\t\t\t\t\t<i class=\"fa fa-medium\"></i> Ver modificaciones\n\t\t\t</button>\n\t\t</div>\n\t</div>\n    \n\t<ng-form name=\"form_avance\">\n\t\t<div class=\"\" ng-repeat=\"(key,value) in $ctrl.proyecto.seguimiento.avance_fis\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-date name=\"fecha_{{key}}\" label=\"Fecha\" ng-model=\"value.fecha\"  ng-disabled=\"!value.edicion\" ng-required=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-auto\">\n\t\t\t\t\t<c-input-numeric name=\"porcentaje_{{key}}\" label=\"Porcentaje\" ng-model=\"value.porcentaje\"  ng-maxvalue=\"100\" ng-formatting=\"false\" ng-decimals=\"0\"ng-required=\"true\" ng-minvalue=\"{{$ctrl.proyecto.seguimiento.avance_fis[key -1].porcentaje}}\" ng-disabled=\"!value.edicion\"></c-input-numeric>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"md-input-group col-md-6\"><c-input name=\"situacion_actual_{{key}}\" label=\"Estado (Situacion actual)\" ng-model=\"value.situacion_actual\"  ng-required=\"true\" ng-disabled=\"!value.edicion\"></c-input></div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t<button class=\"btn btn-link text-success ml-1 pl-1 pr-1 pt-4\"\n\t\t              ng-click=\"$ctrl.guardarAvance(value,key)\"\n\t\t              ng-if=\"value.edicion && !$ctrl.modoVista \" uib-tooltip=\"Guardar\">\n\t\t              <i class=\"fa fa-save\"></i>\n\t\t            </button>\n\t\t            <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.eliminarAvance(value, key)\"\n\t\t              ng-if=\"!$ctrl.modoVista && value.edicion\" uib-tooltip=\"Eliminar\">\n\t\t              <i class=\"fa fa-trash-o\"></i>\n\t\t            </button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\" ng-if=\"$ctrl.Usuarios.esTecnicoResponsable()\">\n\t\t\t<div class=\"col\">\n\t\t\t\t<button class=\"btn btn-link btn-sm ml-1  pl-1 pr-1\" ng-click=\"$ctrl.addAf($ctrl.proyecto.seguimiento.avance_fis)\" uib-tooltip=\"Agregar nuevo registro\">\n\t\t\t\t<i class=\"fa fa-plus-square-o\"></i> registrar avance fisico\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</ng-form>\t\n\n</section>\n\n<!-- INSPECCIONES -->\n\n<section ng-if=\"!$ctrl.Usuarios.esFiscal()\">\n\t<h6 class=\"title-section m-top\">Inspecciones de campo</h6>\n\t<div class=\"alert alert-info\" ng-if=\"$ctrl.Proyecto.esEditable('orden_proceder')\">\n    \t<i class=\"fa fa-info-circle\"></i><span><strong> Nota: </strong>Subir inspección/es de campo medio termino y final</span>\n  \t</div>\n\t<ng-form name=\"form_inspeccion\">\n\t\t<div class=\"\" ng-repeat=\"(key,value) in $ctrl.proyecto.seguimiento.inspeccion_campo\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-auto\">\n\t\t\t\t\t<c-date name=\"fecha_inspeccion_{{key}}\" label=\"Fecha inspeccion\" ng-model=\"value.fecha\" ng-disabled=\"!value.edicion\" ng-required=\"true\"></c-date>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\" ng-if=\"$ctrl.Usuarios.esTecnicoResponsable()\">\n\t\t\t\t\t<button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"value.edicion = true;$ctrl.fechant= value.fecha\" ng-if=\"!value.edicion && !$ctrl.modoVista && value.id_inspeccion_campo\" uib-tooltip=\"Editar\">\n\t\t\t\t\t\t<i class=\"fa fa-edit\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-link text-success ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.actualizarInspeccion(value)\" ng-if=\"value.edicion && !$ctrl.modoVista && value.id_inspeccion_campo\" uib-tooltip=\"Guardar\">\n\t\t\t\t\t\t<i class=\"fa fa-save\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-link text-danger ml-0 pl-0 pr-1 pt-4\" ng-click=\"value.edicion = false; value.fecha = $ctrl.fechant\" ng-if=\"value.edicion && !$ctrl.modoVista && value.id_inspeccion_campo\" uib-tooltip=\"Cancelar\">\n\t\t\t\t\t\t<i class=\"fa fa-close\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-3\" ng-if=\"value.id_inspeccion_campo && !value.edicion\">\n\t\t\t\t\t<c-input name=\"tecnico_inspeccion_{{key}}\" label=\"Técnico responsable de la inspección\" ng-model=\"value.tecnico_inspeccion\"\n\t\t\t\t\tng-minlength=\"3\" maxlength=\"100\"\n\t\t\t\t\tng-disabled=\"true\"></c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-3\" ng-if=\"!value.id_inspeccion_campo || value.edicion\">\n\t\t\t\t\t<c-select name=\"listaTecnico_{{key}}\" label=\"Técnico responsable de la inspección\"  ng-model=\"value.tecnico_inspeccion\" ng-required=\"true\" options=\"$ctrl.usuariosParaAsignar\" field=\"nombre\" ng-disabled=\"false\"></c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"value.id_inspeccion_campo && !value.edicion\">\n\t\t\t\t\t<c-input name=\"detallee_{{key}}\" label=\"Inspección\" ng-model=\"value.detalle\" ng-disabled=\"true\"></c-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"!value.id_inspeccion_campo || value.edicion\">\n\t\t\t\t\t<c-select name=\"detalle_inf_{{key}}\" label=\"Inspección\" placeholder=\"Seleccione tipo informe\" ng-model=\"value.detalle\" ng-required=\"true\" options=\"$ctrl.items\" field=\"text\" ng-disabled=\"false\"></c-select>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"value.objeto_id\">\n\t\t\t\t\t<button class=\"btn btn-link text-primary ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.obtenerInspeccion(value.doc_informe)\" ng-if=\"value.doc_informe\" uib-tooltip=\"Ver documento\">\n\t\t\t\t\t<i class=\"fa fa-file-pdf-o\"></i> Ver Informe\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-auto\" ng-if=\"!value.objeto_id\">\n\t\t\t\t\t<archivo name=\"doc_inspeccion\" label=\"Informe de Inspeccion\" ng-model=\"value.doc_informe\" types=\"pdf\" mime-types=\".pdf\" maxsize=\"4MB\" url=\"{{$ctrl.archivos.url}}\" url-descarga=\"{{$ctrl.archivos.url}}\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\"></archivo>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"float-right\">\n\t\t\t\t\t<button class=\"btn btn-link text-success ml-1 pl-1 pr-1 pt-4\"\n\t\t\t\t\t\tng-click=\"$ctrl.guardarInspeccion(value,key)\"\n\t\t\t\t\t\tng-if=\"value.edicion && !$ctrl.modoVista && !value.id_inspeccion_campo\" uib-tooltip=\"Guardar\">\n\t\t\t\t\t\t<i class=\"fa fa-save\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-link text-danger ml-1 pl-1 pr-1 pt-4\" ng-click=\"$ctrl.eliminarInspeccion(value, key)\"\n\t\t\t\t\t\tng-if=\"!$ctrl.modoVista && value.edicion && !value.id_inspeccion_campo\" uib-tooltip=\"Eliminar\">\n\t\t\t\t\t\t<i class=\"fa fa-trash-o\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\t</ng-form>\n\t<div class=\"row\" ng-if=\"$ctrl.Usuarios.esTecnicoResponsable()\">\n\t\t<div class=\"col\">\n\t\t\t<button class=\"btn btn-link btn-sm ml-1 pl-1 pr-1\" ng-click=\"$ctrl.addIc($ctrl.proyecto.seguimiento.inspeccion_campo)\" uib-tooltip=\"Agregar nuevo registro\">\n\t\t\t<i class=\"fa fa-plus-square-o\"></i> Agregar inspeccion de campo\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</section>\n\n<h6 class=\"title-section m-top\">Acta provisional y Definitiva </h6>\n<div class=\"row\">\n\t<div class=\"col-md-auto\">\n\t\t<button md-effect type=\"button\"\n\t\t\tclass=\"btn btn-actions c-pointer btn-outline-success\"\n\t\t\tng-if=\"$ctrl.Proyecto.esEditable('seguimiento')\"\n\t\t\tng-click=\"$ctrl.guardarDatos()\" uib-tooltip=\"Guardar\">\n\t\t\t<i class=\"fa fa-save\"></i> \n\t\t</button>\n\t</div>\n\t<div class=\"col-md-3\">\n\t\t\t<c-date name=\"fecha_acta_provisional\" label=\"Fecha del acta provisional\" ng-model=\"$ctrl.proyecto.seguimiento.fecha_acta_provisional\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\" ng-required=\"true\"></c-date>\n\t\t\t<!-- {{$ctrl.proyecto.seguimiento.fecha_acta_provisional}} -->\n\t</div>\n\t<div class=\"col-md-4\" >\n\t\t<archivo name=\"doc_acta_provisional\" label=\"Acta provisional\" ng-model=\"$ctrl.proyecto.seguimiento.doc_acta_provisional\" types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\" url=\"{{$ctrl.archivos.urlDocActaProv}}\" url-descarga=\"{{$ctrl.archivos.urlDocActaProvDescarga}}\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\" ng-required=\"true\"\n\t\tmodo-vista=\"!$ctrl.Proyecto.esEditable('seguimiento')\"></archivo>\n\t</div>\n\t<div class=\"col-md-4\" >\n\t\t\n\t</div>\n\n</div>\n<hr>\n<div class=\"row\">\n\t<div class=\"col-md-auto\">\n\t\t<button md-effect type=\"button\"\n\t\t\tclass=\"btn btn-actions c-pointer btn-outline-success\"\n\t\t\tng-if=\"$ctrl.Proyecto.esEditable('seguimiento')\"\n\t\t\tng-click=\"$ctrl.guardarDatos()\" uib-tooltip=\"Guardar\">\n\t\t\t<i class=\"fa fa-save\"></i> \n\t\t</button>\n\t</div>\n\t<div class=\"col-md-3\">\n\t\t\t<c-date name=\"fecha_acta_definitiva\" label=\"Fecha del acta definitiva\" ng-model=\"$ctrl.proyecto.seguimiento.fecha_acta_definitiva\" ng-required=\"true\" ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\" ></c-date>\n\t\t\t<!-- {{$ctrl.proyecto.seguimiento.fecha_acta_definitiva}} -->\n\t</div>\n\t<div class=\"col-md-4\" >\n\t\t<archivo name=\"doc_acta_definitiva\" label=\"Acta definitiva\" ng-model=\"$ctrl.proyecto.seguimiento.doc_acta_definitiva\" types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\" url=\"{{$ctrl.archivos.urlDocActaDef}}\" url-descarga=\"{{$ctrl.archivos.urlDocActaDefDescarga}}\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\" ng-required=\"true\"></archivo>\n\t</div>\n\t<div class=\"col-md-4\" >\n\t\t\n\t</div>\n\n</div>\n</section>\n<section ng-if=\"!$ctrl.Usuarios.esFiscal()\">\n<h6 class=\"title-section m-top\">Informe de transición</h6>\n<div class=\"row\">\n\t<div class=\"col-md-auto\">\n\t\t<button md-effect type=\"button\"\n\t\t\tclass=\"btn btn-actions c-pointer btn-outline-success\"\n\t\t\tng-if=\"$ctrl.Proyecto.esEditable('seguimiento')\"\n\t\t\tng-click=\"$ctrl.guardarDatos()\" uib-tooltip=\"Guardar\">\n\t\t\t<i class=\"fa fa-save\"></i> \n\t\t</button>\n\t</div>\n\t<div class=\"col-md-3\">\n\t\t\t<c-date name=\"fecha_informe_transicion\" label=\"Fecha Informe de transición\" ng-model=\"$ctrl.proyecto.seguimiento.fecha_informe\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\" ng-required=\"true\"></c-date>\n\t\t\t<!-- {{$ctrl.proyecto.seguimiento.fecha_informe}} -->\n\t</div>\n\t<div class=\"col-md-4\" >\n\t\t<archivo name=\"doc_inf_transicion\" label=\"Informe de transición\" ng-model=\"$ctrl.proyecto.seguimiento.doc_informe\" types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\" url=\"{{$ctrl.archivos.urlDocIT}}\" url-descarga=\"{{$ctrl.archivos.urlDocITDescarga}}\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\" ng-required=\"true\"></archivo>\n\t</div>\n\t<div class=\"col-md-4\" >\n\t\t\n\t</div>\n\n</div>\n\n</section>\n\n<section>\n<h6 class=\"title-section m-top\">Ley Municipal de transferencia publico privada (si corresponde) </h6>\n<div class=\"row\">\n\t<div class=\"col-md-auto\">\n\t\t<button md-effect type=\"button\"\n\t\t\tclass=\"btn btn-actions c-pointer btn-outline-success\"\n\t\t\tng-if=\"$ctrl.Proyecto.esEditable('seguimiento')\"\n\t\t\tng-click=\"$ctrl.guardarDatos()\" uib-tooltip=\"Guardar\">\n\t\t\t<i class=\"fa fa-save\"></i> \n\t\t</button>\n\t</div>\n\t<div class=\"col-md-3\">\n\t\t<div class=\"md-input-group col-md-6\">\n\t\t\t<c-date name=\"fecha_ley_municipal\" label=\"Fecha\" ng-model=\"$ctrl.proyecto.seguimiento.fecha_ley_mun\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\"></c-date>\n\t\t\t<!-- {{$ctrl.proyecto.seguimiento.fecha_informe}} -->\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-4\" >\n\t\t<archivo name=\"doc_ley_municipal\" label=\"Ley municipal de transf.\" ng-model=\"$ctrl.proyecto.seguimiento.doc_ley_mun\" types=\"pdf\" mime-types=\".pdf\" maxsize=\"3MB\" url=\"{{$ctrl.archivos.urlDocLMT}}\" url-descarga=\"{{$ctrl.archivos.urlDocLMTDescarga}}\"  ng-disabled=\"!$ctrl.Proyecto.esEditable('seguimiento')\"></archivo>\n\t</div>\n\t<div class=\"col-md-4\" >\n\t\t\n\t</div>\n\n</div>\n\n</section>\n\n<!-- botones y acciones -->\n\n<!-- \n<button md-effect type=\"button\"\n      class=\"btn btn-actions c-pointer btn-info\"\n      ng-if=\"$ctrl.usuario.rol.id_rol == 13\"\n      ng-click=\"$ctrl.derivarProyecto()\">\n      <i class=\"fa fa-send\"></i> Enviar a responsable\n</button> \n\n<button md-effect type=\"button\"\n      class=\"btn btn-actions c-pointer btn-warning\"\n      ng-if=\"$ctrl.usuario.rol.id_rol == 12\"\n      ng-click=\"$ctrl.devolverProyecto()\">\n      <i class=\"fa fa-rotate-left\"></i> Observar\n</button>\n\n<button md-effect type=\"button\"\n      class=\"btn btn-actions c-pointer btn-success\"\n      ng-if=\"$ctrl.usuario.rol.id_rol == 12\"\n      ng-click=\"$ctrl.enviarACierre()\">\n      <i class=\"fa fa-send\"></i> Enviar a cierre\n</button>-->\n\n\n<script type=\"text/ng-template\" id=\"myPopoverTemplate.html\">\n        <!-- <div>{{dynamicPopover.content}}</div> -->\n        <div class=\"form-group\">\n          <!-- <label>Plazo Convenio:</label> -->\n          <!-- <input type=\"text\" ng-model=\"dynamicPopover.title\" class=\"form-control\"> -->\n          <p><b>Plazo Convenio: </b>{{$ctrl.proyecto.plazo_ejecucion}} d.c.<br>\n          <b>Nro Convenio: </b>{{$ctrl.proyecto.convenio.nro_convenio}} <br>\n          <b>Fecha suscripcion : </b>{{$ctrl.proyecto.convenio.fecha_suscripcion | date}}</p>\n        </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"myPopoverTemplate2.html\">\n        <!-- <div>{{dynamicPopover.content}}</div> -->\n        <div class=\"form-group\">\n          <label>Desembolsos (Bs.)</label>\n          <!-- <input type=\"text\" ng-model=\"dynamicPopover.title\" class=\"form-control\"> -->\n            <table class=\"table table-striped table-sm\">\n\t\t\t  <thead>\n\t\t\t    <tr>\n\t\t\t      <th scope=\"col\">#</th>\n\t\t\t      <th scope=\"col\">Monto</th>\n\t\t\t      <th scope=\"col\">Fecha</th>\n\t\t\t    </tr>\n\t\t\t  </thead>\n\t\t\t  <tbody>\n\t\t\t    <tr>\n\t\t\t      <th scope=\"row\">1</th>\n\t\t\t      <td>{{$ctrl.proyecto.cronograma_desembolsos.monto_1 | number:2}}</td>\n\t\t\t      <td>{{$ctrl.proyecto.cronograma_desembolsos.fecha_1 | date}}</td>\n\t\t\t    </tr>\n\t\t\t    <tr>\n\t\t\t      <th scope=\"row\">2</th>\n\t\t\t      <td>{{$ctrl.proyecto.cronograma_desembolsos.monto_2 | number:2}}</td>\n\t\t\t      <td>{{$ctrl.proyecto.cronograma_desembolsos.fecha_2 | date}}</td>\n\t\t\t    </tr>\n\t\t\t    <tr>\n\t\t\t      <th scope=\"row\">3</th>\n\t\t\t      <td>{{$ctrl.proyecto.cronograma_desembolsos.monto_3 | number:2}}</td>\n\t\t\t      <td>{{$ctrl.proyecto.cronograma_desembolsos.fecha_3 | date}}</td>\n\t\t\t    </tr>\n\t\t\t  </tbody>\n\t\t\t</table>\n        </div>\n</script>"

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyecto <small><strong>{{$ctrl.proyecto.nombre}}</strong></small>\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <ng-form name=\"formProyecto\">\n        <uib-tabset active=\"active\">\n          <uib-tab index=\"0\" heading=\"Datos Generales\">\n            <reg-datos-generales proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('DATOS_GENERALES')\"></reg-datos-generales>\n            <reg-datos-generales-extra proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('DATOS_GENERALES_EXTRA')\"></reg-datos-generales-extra>\n            <reg-financiamiento proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('DATOS_FINANCIAMIENTO')\"></reg-financiamiento>\n            <proyecto-adjudicado proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('PROYECTO_ADJUDICADO')\"></proyecto-adjudicado>\n            <codigo-contrato proyecto=\"$ctrl.proyecto\" modo-vista=\"true\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('PROYECTO_ADJUDICADO')\"></codigo-contrato>\n            <reg-convenio proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('CONVENIO')\"></reg-convenio>\n            <reg-asignacion-responsable proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('ASIGNACION_RESPONSABLE')\"></reg-asignacion-responsable>\n            <reg-desembolso proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('DESEMBOLSO')\"></reg-desembolso>\n            <reg-orden-proceder proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('ORDEN_PROCEDER')\"></reg-orden-proceder>\n            <reg-recepcion-definitiva proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('RECEPCION_DEFINITIVA')\"></reg-recepcion-definitiva>\n            \n          </uib-tab>\n\n          <uib-tab index=\"1\" heading=\"Contactos\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('AUTORIDAD_BENEFICIARIA')\">\n            <reg-autoridad-beneficiaria proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\" ng-if=\"active==1\"></reg-autoridad-beneficiaria>\n          </uib-tab>\n\n          <uib-tab index=\"2\" heading=\"Evaluación\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('AUTORIDAD_BENEFICIARIA') || $ctrl.Proyecto.esAreaPermitida('EVALUACION')\">\n            <reg-evaluacion proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\" ng-if=\"active==2\"></reg-evaluacion>\n          </uib-tab>\n\n          <uib-tab index=\"3\" heading=\"Informe de Evaluación\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('AUTORIDAD_BENEFICIARIA') || $ctrl.Proyecto.esAreaPermitida('INFORME_EVALUACION')\">\n            <reg-informe-eval proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\" ng-if=\"active==3\"></reg-informe-eval>\n          </uib-tab>\n\n          <uib-tab index=\"4\" heading=\"Actividades e ítems\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('MODULOS_ITEMS')\">\n            <reg-items proyecto=\"$ctrl.proyecto\" modulos=\"$ctrl.modulos\" modo-vista=\"!$ctrl.Proyecto.esEditable('modulos')\"></reg-items>\n          </uib-tab>\n\n          <!-- <uib-tab index=\"5\" heading=\"DBC\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('DOCUMENTO_BASE_CONTRATACION')\">\n            <dbc proyecto=\"$ctrl.proyecto\"></dbc>\n          </uib-tab> -->\n          <uib-tab index=\"5\" heading=\"Seguimiento\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('SEGUIMIENTO')\" >\n            <reg-seguimiento proyecto=\"$ctrl.proyecto\"></reg-seguimiento>\n          </uib-tab>\n\n          <!-- <uib-tab index=\"6\" heading=\"Formularios\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('FORMULARIOS')\">\n            <formularios-generados proyecto=\"$ctrl.proyecto\"></formularios-generados>\n          </uib-tab> -->\n          <uib-tab index=\"6\" heading=\"Cierre\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('CIERRE')\" >\n            <reg-cierre proyecto=\"$ctrl.proyecto\"></reg-cierre>\n          </uib-tab>\n          <uib-tab index=\"7\" heading=\"Garantías\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('GARANTIAS')\">\n            <garantia proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('boletas')\"></garantia>\n          </uib-tab>\n\n          <uib-tab index=\"8\" heading=\"Equipo Técnico\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('EQUIPO_TECNICO')\">\n            <equipo-tecnico proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('equipo_tecnico')\"></equipo-tecnico>\n          </uib-tab>\n          <uib-tab index=\"9\" heading=\"Adjuntos\" >\n            <reg-archivo-adjunto proyecto=\"$ctrl.proyecto\"></reg-archivo-adjunto>\n          </uib-tab>\n        </uib-tabset>\n      </ng-form>\n\n      <section ng-if=\"$ctrl.proyecto.observacion.mensaje\">\n        <h6 class=\"title-section error m-top\">\n          <i class=\"fa fa-exclamation-triangle\"></i> Observación\n        </h6>\n        Mensaje: <strong>{{ $ctrl.proyecto.observacion.mensaje }}</strong><br>\n        Observado por: <strong>{{ $ctrl.proyecto.observacion.usuario.persona | nombreUnido }}</strong>\n      </section>\n    </div>\n    <div class=\"card-footer text-right\">\n       <!-- <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.fichaProyecto($ctrl.idProyecto)\" title=\"Generar Ficha Tecnica\"><i class=\"fa fa-file-pdf-o\"></i>Generar Ficha Tecnica</button> -->\n      <ejecutar-transicion elemento=\"$ctrl.proyecto\"\n                           servicio=\"$ctrl.Proyecto\"\n                           form=\"formProyecto\"\n                           opcion-cancelar=\"true\"\n                           atributo-estado=\"estado_proyecto\"\n                           url=\"$ctrl.url\"\n                           confirmar=\"true\"\n                           metodo-previo=\"$ctrl.verificarSegunEstado()\"\n                           validacion-paralela=$ctrl.verificarEnParalelo(accion)>\n      </ejecutar-transicion>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-cogs\"></i> REPORTES <strong>CSV</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n\n      <h3 class=\"card-title\">Exportar CSV</h3>\n      <form>\n\n        <!-- <div class=\"row\">\n          <div class=\"col-6\">\n            <div class=\"form-group\">\n              <label>Fecha Inicial</label>\n              <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.dt1\" is-open=\"$ctrl.opened1\" datepicker-options=\"$ctrl.dateOptions\"\n                  ng-required=\"true\" />\n                <span class=\"input-group-btn\">\n                  <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.opened1 = true\"><i class=\"fa fa-calendar\"></i></button>\n                </span>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-6\">\n            <div class=\"form-group\">\n              <label>Fecha Final</label>\n              <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.dt2\" is-open=\"$ctrl.opened2\" datepicker-options=\"$ctrl.dateOptions\"\n                  ng-required=\"true\" />\n                <span class=\"input-group-btn\">\n                  <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.opened2 = true\"><i class=\"fa fa-calendar\"></i></button>\n                </span>\n              </div>\n            </div>\n          </div>\n        </div> -->\n        <hr>\n        <div class=\"alert alert-info\" role=\"alert\">\n          <i class=\"fa fa-info-circle\"></i> Seleccione el tipo de reporte y presione el botón para obtener los datos de todos los proyectos relacionados y pasarlos a formato CSV.\n        </div>\n\n        <section>\n          <form name=\"resumen\">\n            <div class=\"row\">\n              <div class=\"col-md-4\">\n                <c-select name=\"tipoReporte\" label=\"Tipo de reporte a generar\" ng-model=\"$ctrl.tipoReporte\" key-value=\"valor\" field=\"texto\" options=\"$ctrl.tiposReporte\" on-select=\"$ctrl.aplicarTipo()\"></c-select>\n              </div>\n            </div>\n            <!-- <div class=\"row\">\n              <div class=\"col-md-4\">\n                <c-select name=\"gestion\" label=\"Gestión\" ng-hide = \"$ctrl.tipoReporte == 'general'\" ng-model=\"$ctrl.gestion\" options=\"$ctrl.gestiones\" on-select=\"$ctrl.cambiarGestion(item)\"></c-select>\n              </div>\n            </div> -->\n            <div class=\"row\">\n              <div class=\"col-md-4\">\n                <c-select name=\"cartera\" label=\"Seleccione Cartera\" ng-model=\"$ctrl.carteraSelected\" options=\"$ctrl.carteras\"  key-value=\"id_cartera\" field=\"descripcion\" placeholder=\"Seleccione cartera\"></c-select>\n                \n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-md-12\" ng-if=\"$ctrl.showDpa\">\n                <c-select-dpa ng-model=\"$ctrl.dpa\" horizontal=\"true\" disable-provincia=\"true\"></c-select-dpa>\n              </div>\n              <!-- <div class=\"col-md-12\" ng-if=\"$ctrl.tipoReporte === 'porDepartamento'\">\n                <c-select-dpa ng-model=\"$ctrl.dpa\" horizontal=\"true\" disable-provincia=\"true\" disable-municipio=\"true\"></c-select-dpa>\n              </div> -->\n            </div>\n          </form>\n        </section>\n\n        <button type=\"button\" md-effect class=\"btn btn-outline-primary\" ng-click=\"$ctrl.descargarCSV()\"><i class=\"fa fa-check\"></i> Obtener datos csv</button>\n        <button type=\"button\" md-effect class=\"btn btn-outline-primary\" ng-click=\"$ctrl.descargarCSV('xlsx')\"><i class=\"fa fa-check\"></i> Descargar xlsx</button>\n        <!-- Opciones de descarga -->\n        <hr ng-if=\"$ctrl.cantidad\">\n        <div class=\"alert alert-info\" role=\"alert\" ng-if=\"$ctrl.cantidad == 1\">\n          <i class=\"fa fa-info-circle\"></i> Se ha encontrado 1 registro.\n        </div>\n        <div class=\"alert alert-info\" role=\"alert\" ng-if=\"$ctrl.cantidad > 1\">\n          <i class=\"fa fa-info-circle\"></i> Se han encontrado {{$ctrl.cantidad}} registros.\n        </div>\n        <button type=\"button\" md-effect class=\"btn btn-outline-primary\" lazy-load=\"false\"\n          csv-header=\"$ctrl.obtenerCabeceras()\" ng-csv=\"$ctrl.getArray\" filename=\"{{ $ctrl.filename }}\"\n          ng-if=\"$ctrl.cantidad\"><i class=\"fa fa-download\"></i> Descargar</button>\n      </form>\n      <hr>\n\n    </div>\n  </div>\n</div>"

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-cogs\"></i> REPORTES SEGUIMIENTO A LAS <strong>GAM</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n\n      <!-- <h3 class=\"card-title\">Reporte para seguimiento de avance a las GAM</h3> -->\n\n      <hr>\n\n\n      <button class=\"btn btn-sm btn-danger\" ng-click=\"$ctrl.generarPDF()\" uib-tooltip=\"Descargar Reporte\"><i class=\"fa fa-file-pdf-o\"></i></button>\n      <div class=\"crud-table\" ng-table=$ctrl.tableParams>\n       <table id=\"tabla1\" class=\"table table-striped table-hover ng-table table-responsive\">\n         <tr ng-repeat=\"proyecto in $data\">\n           <td data-title=\"'Código'\" filter=\"{codigo: 'text'}\" sortable=\"'codigo'\">{{proyecto.codigo}}</td>\n           <td data-title=\"'Nombre'\" filter=\"{nombre: 'text'}\" sortable=\"'nombre'\">{{proyecto.nombre}}</td>\n           <td data-title=\"'Cartera'\" filter=\"{cartera: 'text'}\">{{proyecto.cartera}}</td>\n           <td data-title=\"'Departamento'\" filter=\"{'departamento.nombre': 'filtro-departamento'}\">{{proyecto.municipio.provincia.departamento.nombre}}</td>\n           <td data-title=\"'Municipio'\" filter=\"{'municipio.nombre': 'text'}\">{{proyecto.municipio.nombre}}</td>\n           <td data-title=\"'Monto FDI'\"> {{proyecto.monto_fdi | number:2}}</td>\n           <td data-title=\"'Monto Total Ejecutado'\">{{proyecto.avance_ejecutado | number:2}}</td>\n           <td data-title=\"'% de avance general'\"><uib-progressbar value=\"proyecto.porcentaje_avance\" type=\"\">{{proyecto.porcentaje_avance}}%\n          </uib-progressbar></td>\n           <td data-title=\"'Componentes del Proyecto'\">\n              <table>\n                <tr ng-repeat=\"adj in proyecto.adjudicaciones\">\n                  <td style=\"text-align: center; vertical-align: middle;\"><strong>{{adj.referencia}}</strong></td>\n                  <td>\n                    <small>\n                    <table>\n                      <tr>\n                        <th>Planillas</th>\n                        <th>Monto Adjudicado</th>\n                        <th>Monto Ejecutado</th>\n                        <th>% de avance</th>\n                        <th>Fotos georefenciadas</th>\n                      </tr>\n                      <tr>\n                         <td>{{adj.nro_supervisiones.count}}</td>\n                         <td>{{adj.monto | number:2}}</td>\n                         <td>{{adj.monto_ejecutado | number:2}}</td>\n                         <td>{{(adj.monto_ejecutado / adj.monto) * 100 | number:2}} %</td>\n                         <td>{{adj.nro_fotos.length}}</td>\n                      </tr>\n                    </table>\n                    </small>\n                  </td>\n                </tr>\n              </table>\n           </td>\n         </tr>\n       </table>\n      </div>\n\n    </div>\n  </div>\n\n\n</div>\n\n\n\n\n\n\n\n<!-- filtro departamento -->\n    <script type=\"text/ng-template\" id=\"ng-table/filters/filtro-departamento.html\">\n    <select ng-model=\"params.filter()[name]\">\n      <option value = \"\">todos</option>\n      <option value = \"chuquisaca\">Chuquisaca</option>\n      <option value = \"la paz\">La Paz</option>\n      <option value = \"cochabamba\">Cochabamba</option>\n      <option value = \"oruro\">Oruro</option>\n      <option value = \"potosi\">Potosi</option>\n      <option value = \"tarija\">Tarija</option>\n      <option value = \"santa cruz\">Santa Cruz</option>\n      <option value = \"beni\">Beni</option>\n      <option value = \"pando\">Pando</option>\n    </select>\n\n  </script>\n<!-- <div class=\"container\">\n  <h6 class=\"title-section m-top\">Vizualizacion</h6>\n    <small>\n      <table id=\"tabla1\" class=\"table table-striped table-hover table-responsive\">\n        <thead>\n          <tr><th colspan=\"10\" class=\"encabezado\"><center><h4 class=\"titulocentral\">{{$ctrl.titulo}}</h4><center></th></tr>\n          <tr>\n            <th class=\"colorcabezera\">Nº</th>\n            <th class=\"colorcabezera\">Codigo</th>\n            <th class=\"colorcabezera\">NOMBRE DEL PROYECTO</th>\n            <th class=\"colorcabezera\">CARTERA</th>\n            <th class=\"colorcabezera\">MUNICIPIO</th>\n            <th class=\"colorcabezera\">COMPONENTES</th>\n            \n                  \n            \n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"proy in $ctrl.datosGam.rows\">\n            <td>{{$index + 1}}</td>\n            <td>{{proy.codigo}}</td>\n            <td>{{proy.nombre}}</td>\n            <td>{{proy.cartera}}</td>\n            <td>{{proy.municipio.nombre}}</td>\n            <td>\n              <table><tr ng-repeat=\"adj in proy.adjudicaciones\">\n              <td>{{adj.referencia}}</td>\n              <td>\n                <table>\n                  <tr ng-repeat=\"planillas in adj.supervision\">\n                    <td>Planilla Nro. {{planillas.nro_supervision}}</td>\n                    <td>{{planillas.estado_actual.nombre}}</td>\n                  </tr>\n                </table>\n              </td>\n            </tr></table>\n            </td>\n            \n                  \n          </tr>\n        </tbody>\n        <tfoot>\n          <tr>\n\n           \n          </tr>\n          <tr><td colspan=\"2\" class=\"encabezado\">{{$ctrl.fechaRep}} - Fuente: SISPRO</td></tr>\n        </tfoot>\n      </table>\n    </small>\n</div> -->"

/***/ }),
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Satellizer 0.15.5
	 * (c) 2016 Sahat Yalkabov 
	 * License: MIT 
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.satellizer = factory());
	}(this, function () { 'use strict';
	
	    var Config = (function () {
	        function Config() {
	            this.baseUrl = '/';
	            this.loginUrl = '/auth/login';
	            this.signupUrl = '/auth/signup';
	            this.unlinkUrl = '/auth/unlink/';
	            this.tokenName = 'token';
	            this.tokenPrefix = 'satellizer';
	            this.tokenHeader = 'Authorization';
	            this.tokenType = 'Bearer';
	            this.storageType = 'localStorage';
	            this.tokenRoot = null;
	            this.withCredentials = false;
	            this.providers = {
	                facebook: {
	                    name: 'facebook',
	                    url: '/auth/facebook',
	                    authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
	                    redirectUri: window.location.origin + '/',
	                    requiredUrlParams: ['display', 'scope'],
	                    scope: ['email'],
	                    scopeDelimiter: ',',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 580, height: 400 }
	                },
	                google: {
	                    name: 'google',
	                    url: '/auth/google',
	                    authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    optionalUrlParams: ['display', 'state'],
	                    scope: ['profile', 'email'],
	                    scopePrefix: 'openid',
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 452, height: 633 },
	                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
	                },
	                github: {
	                    name: 'github',
	                    url: '/auth/github',
	                    authorizationEndpoint: 'https://github.com/login/oauth/authorize',
	                    redirectUri: window.location.origin,
	                    optionalUrlParams: ['scope'],
	                    scope: ['user:email'],
	                    scopeDelimiter: ' ',
	                    oauthType: '2.0',
	                    popupOptions: { width: 1020, height: 618 }
	                },
	                instagram: {
	                    name: 'instagram',
	                    url: '/auth/instagram',
	                    authorizationEndpoint: 'https://api.instagram.com/oauth/authorize',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    scope: ['basic'],
	                    scopeDelimiter: '+',
	                    oauthType: '2.0'
	                },
	                linkedin: {
	                    name: 'linkedin',
	                    url: '/auth/linkedin',
	                    authorizationEndpoint: 'https://www.linkedin.com/uas/oauth2/authorization',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['state'],
	                    scope: ['r_emailaddress'],
	                    scopeDelimiter: ' ',
	                    state: 'STATE',
	                    oauthType: '2.0',
	                    popupOptions: { width: 527, height: 582 }
	                },
	                twitter: {
	                    name: 'twitter',
	                    url: '/auth/twitter',
	                    authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
	                    redirectUri: window.location.origin,
	                    oauthType: '1.0',
	                    popupOptions: { width: 495, height: 645 }
	                },
	                twitch: {
	                    name: 'twitch',
	                    url: '/auth/twitch',
	                    authorizationEndpoint: 'https://api.twitch.tv/kraken/oauth2/authorize',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    scope: ['user_read'],
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 560 }
	                },
	                live: {
	                    name: 'live',
	                    url: '/auth/live',
	                    authorizationEndpoint: 'https://login.live.com/oauth20_authorize.srf',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['display', 'scope'],
	                    scope: ['wl.emails'],
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 560 }
	                },
	                yahoo: {
	                    name: 'yahoo',
	                    url: '/auth/yahoo',
	                    authorizationEndpoint: 'https://api.login.yahoo.com/oauth2/request_auth',
	                    redirectUri: window.location.origin,
	                    scope: [],
	                    scopeDelimiter: ',',
	                    oauthType: '2.0',
	                    popupOptions: { width: 559, height: 519 }
	                },
	                bitbucket: {
	                    name: 'bitbucket',
	                    url: '/auth/bitbucket',
	                    authorizationEndpoint: 'https://bitbucket.org/site/oauth2/authorize',
	                    redirectUri: window.location.origin + '/',
	                    requiredUrlParams: ['scope'],
	                    scope: ['email'],
	                    scopeDelimiter: ' ',
	                    oauthType: '2.0',
	                    popupOptions: { width: 1028, height: 529 }
	                },
	                spotify: {
	                    name: 'spotify',
	                    url: '/auth/spotify',
	                    authorizationEndpoint: 'https://accounts.spotify.com/authorize',
	                    redirectUri: window.location.origin,
	                    optionalUrlParams: ['state'],
	                    requiredUrlParams: ['scope'],
	                    scope: ['user-read-email'],
	                    scopePrefix: '',
	                    scopeDelimiter: ',',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 530 },
	                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
	                }
	            };
	            this.httpInterceptor = function () { return true; };
	        }
	        Object.defineProperty(Config, "getConstant", {
	            get: function () {
	                return new Config();
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return Config;
	    }());
	    ;
	
	    var AuthProvider = (function () {
	        function AuthProvider(SatellizerConfig) {
	            this.SatellizerConfig = SatellizerConfig;
	        }
	        Object.defineProperty(AuthProvider.prototype, "baseUrl", {
	            get: function () { return this.SatellizerConfig.baseUrl; },
	            set: function (value) { this.SatellizerConfig.baseUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "loginUrl", {
	            get: function () { return this.SatellizerConfig.loginUrl; },
	            set: function (value) { this.SatellizerConfig.loginUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "signupUrl", {
	            get: function () { return this.SatellizerConfig.signupUrl; },
	            set: function (value) { this.SatellizerConfig.signupUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "unlinkUrl", {
	            get: function () { return this.SatellizerConfig.unlinkUrl; },
	            set: function (value) { this.SatellizerConfig.unlinkUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenRoot", {
	            get: function () { return this.SatellizerConfig.tokenRoot; },
	            set: function (value) { this.SatellizerConfig.tokenRoot = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenName", {
	            get: function () { return this.SatellizerConfig.tokenName; },
	            set: function (value) { this.SatellizerConfig.tokenName = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenPrefix", {
	            get: function () { return this.SatellizerConfig.tokenPrefix; },
	            set: function (value) { this.SatellizerConfig.tokenPrefix = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenHeader", {
	            get: function () { return this.SatellizerConfig.tokenHeader; },
	            set: function (value) { this.SatellizerConfig.tokenHeader = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenType", {
	            get: function () { return this.SatellizerConfig.tokenType; },
	            set: function (value) { this.SatellizerConfig.tokenType = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "withCredentials", {
	            get: function () { return this.SatellizerConfig.withCredentials; },
	            set: function (value) { this.SatellizerConfig.withCredentials = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "storageType", {
	            get: function () { return this.SatellizerConfig.storageType; },
	            set: function (value) { this.SatellizerConfig.storageType = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "httpInterceptor", {
	            get: function () { return this.SatellizerConfig.httpInterceptor; },
	            set: function (value) {
	                if (typeof value === 'function') {
	                    this.SatellizerConfig.httpInterceptor = value;
	                }
	                else {
	                    this.SatellizerConfig.httpInterceptor = function () { return value; };
	                }
	            },
	            enumerable: true,
	            configurable: true
	        });
	        AuthProvider.prototype.facebook = function (options) {
	            angular.extend(this.SatellizerConfig.providers.facebook, options);
	        };
	        AuthProvider.prototype.google = function (options) {
	            angular.extend(this.SatellizerConfig.providers.google, options);
	        };
	        AuthProvider.prototype.github = function (options) {
	            angular.extend(this.SatellizerConfig.providers.github, options);
	        };
	        AuthProvider.prototype.instagram = function (options) {
	            angular.extend(this.SatellizerConfig.providers.instagram, options);
	        };
	        AuthProvider.prototype.linkedin = function (options) {
	            angular.extend(this.SatellizerConfig.providers.linkedin, options);
	        };
	        AuthProvider.prototype.twitter = function (options) {
	            angular.extend(this.SatellizerConfig.providers.twitter, options);
	        };
	        AuthProvider.prototype.twitch = function (options) {
	            angular.extend(this.SatellizerConfig.providers.twitch, options);
	        };
	        AuthProvider.prototype.live = function (options) {
	            angular.extend(this.SatellizerConfig.providers.live, options);
	        };
	        AuthProvider.prototype.yahoo = function (options) {
	            angular.extend(this.SatellizerConfig.providers.yahoo, options);
	        };
	        AuthProvider.prototype.bitbucket = function (options) {
	            angular.extend(this.SatellizerConfig.providers.bitbucket, options);
	        };
	        AuthProvider.prototype.spotify = function (options) {
	            angular.extend(this.SatellizerConfig.providers.spotify, options);
	        };
	        AuthProvider.prototype.oauth1 = function (options) {
	            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
	                oauthType: '1.0'
	            });
	        };
	        AuthProvider.prototype.oauth2 = function (options) {
	            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
	                oauthType: '2.0'
	            });
	        };
	        AuthProvider.prototype.$get = function (SatellizerShared, SatellizerLocal, SatellizerOAuth) {
	            return {
	                login: function (user, options) { return SatellizerLocal.login(user, options); },
	                signup: function (user, options) { return SatellizerLocal.signup(user, options); },
	                logout: function () { return SatellizerShared.logout(); },
	                authenticate: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
	                link: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
	                unlink: function (name, options) { return SatellizerOAuth.unlink(name, options); },
	                isAuthenticated: function () { return SatellizerShared.isAuthenticated(); },
	                getPayload: function () { return SatellizerShared.getPayload(); },
	                getToken: function () { return SatellizerShared.getToken(); },
	                setToken: function (token) { return SatellizerShared.setToken({ access_token: token }); },
	                removeToken: function () { return SatellizerShared.removeToken(); },
	                setStorageType: function (type) { return SatellizerShared.setStorageType(type); }
	            };
	        };
	        AuthProvider.$inject = ['SatellizerConfig'];
	        return AuthProvider;
	    }());
	    AuthProvider.prototype.$get.$inject = ['SatellizerShared', 'SatellizerLocal', 'SatellizerOAuth'];
	
	    function joinUrl(baseUrl, url) {
	        if (/^(?:[a-z]+:)?\/\//i.test(url)) {
	            return url;
	        }
	        var joined = [baseUrl, url].join('/');
	        var normalize = function (str) {
	            return str
	                .replace(/[\/]+/g, '/')
	                .replace(/\/\?/g, '?')
	                .replace(/\/\#/g, '#')
	                .replace(/\:\//g, '://');
	        };
	        return normalize(joined);
	    }
	    function getFullUrlPath(location) {
	        var isHttps = location.protocol === 'https:';
	        return location.protocol + '//' + location.hostname +
	            ':' + (location.port || (isHttps ? '443' : '80')) +
	            (/^\//.test(location.pathname) ? location.pathname : '/' + location.pathname);
	    }
	    function parseQueryString(str) {
	        var obj = {};
	        var key;
	        var value;
	        angular.forEach((str || '').split('&'), function (keyValue) {
	            if (keyValue) {
	                value = keyValue.split('=');
	                key = decodeURIComponent(value[0]);
	                obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
	            }
	        });
	        return obj;
	    }
	    function decodeBase64(str) {
	        var buffer;
	        if (typeof module !== 'undefined' && module.exports) {
	            try {
	                buffer = __webpack_require__(10).Buffer;
	            }
	            catch (err) {
	            }
	        }
	        var fromCharCode = String.fromCharCode;
	        var re_btou = new RegExp([
	            '[\xC0-\xDF][\x80-\xBF]',
	            '[\xE0-\xEF][\x80-\xBF]{2}',
	            '[\xF0-\xF7][\x80-\xBF]{3}'
	        ].join('|'), 'g');
	        var cb_btou = function (cccc) {
	            switch (cccc.length) {
	                case 4:
	                    var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
	                        | ((0x3f & cccc.charCodeAt(1)) << 12)
	                        | ((0x3f & cccc.charCodeAt(2)) << 6)
	                        | (0x3f & cccc.charCodeAt(3));
	                    var offset = cp - 0x10000;
	                    return (fromCharCode((offset >>> 10) + 0xD800)
	                        + fromCharCode((offset & 0x3FF) + 0xDC00));
	                case 3:
	                    return fromCharCode(((0x0f & cccc.charCodeAt(0)) << 12)
	                        | ((0x3f & cccc.charCodeAt(1)) << 6)
	                        | (0x3f & cccc.charCodeAt(2)));
	                default:
	                    return fromCharCode(((0x1f & cccc.charCodeAt(0)) << 6)
	                        | (0x3f & cccc.charCodeAt(1)));
	            }
	        };
	        var btou = function (b) {
	            return b.replace(re_btou, cb_btou);
	        };
	        var _decode = buffer ? function (a) {
	            return (a.constructor === buffer.constructor
	                ? a : new buffer(a, 'base64')).toString();
	        }
	            : function (a) {
	                return btou(atob(a));
	            };
	        return _decode(String(str).replace(/[-_]/g, function (m0) {
	            return m0 === '-' ? '+' : '/';
	        })
	            .replace(/[^A-Za-z0-9\+\/]/g, ''));
	    }
	
	    var Shared = (function () {
	        function Shared($q, $window, SatellizerConfig, SatellizerStorage) {
	            this.$q = $q;
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerStorage = SatellizerStorage;
	            var _a = this.SatellizerConfig, tokenName = _a.tokenName, tokenPrefix = _a.tokenPrefix;
	            this.prefixedTokenName = tokenPrefix ? [tokenPrefix, tokenName].join('_') : tokenName;
	        }
	        Shared.prototype.getToken = function () {
	            return this.SatellizerStorage.get(this.prefixedTokenName);
	        };
	        Shared.prototype.getPayload = function () {
	            var token = this.SatellizerStorage.get(this.prefixedTokenName);
	            if (token && token.split('.').length === 3) {
	                try {
	                    var base64Url = token.split('.')[1];
	                    var base64 = base64Url.replace('-', '+').replace('_', '/');
	                    return JSON.parse(decodeBase64(base64));
	                }
	                catch (e) {
	                }
	            }
	        };
	        Shared.prototype.setToken = function (response) {
	            var tokenRoot = this.SatellizerConfig.tokenRoot;
	            var tokenName = this.SatellizerConfig.tokenName;
	            var accessToken = response && response.access_token;
	            var token;
	            if (accessToken) {
	                if (angular.isObject(accessToken) && angular.isObject(accessToken.data)) {
	                    response = accessToken;
	                }
	                else if (angular.isString(accessToken)) {
	                    token = accessToken;
	                }
	            }
	            if (!token && response) {
	                var tokenRootData = tokenRoot && tokenRoot.split('.').reduce(function (o, x) { return o[x]; }, response.data);
	                token = tokenRootData ? tokenRootData[tokenName] : response.data && response.data[tokenName];
	            }
	            if (token) {
	                this.SatellizerStorage.set(this.prefixedTokenName, token);
	            }
	        };
	        Shared.prototype.removeToken = function () {
	            this.SatellizerStorage.remove(this.prefixedTokenName);
	        };
	        Shared.prototype.isAuthenticated = function () {
	            var token = this.SatellizerStorage.get(this.prefixedTokenName);
	            if (token) {
	                if (token.split('.').length === 3) {
	                    try {
	                        var base64Url = token.split('.')[1];
	                        var base64 = base64Url.replace('-', '+').replace('_', '/');
	                        var exp = JSON.parse(this.$window.atob(base64)).exp;
	                        if (typeof exp === 'number') {
	                            return Math.round(new Date().getTime() / 1000) < exp;
	                        }
	                    }
	                    catch (e) {
	                        return true; // Pass: Non-JWT token that looks like JWT
	                    }
	                }
	                return true; // Pass: All other tokens
	            }
	            return false; // Fail: No token at all
	        };
	        Shared.prototype.logout = function () {
	            this.SatellizerStorage.remove(this.prefixedTokenName);
	            return this.$q.when();
	        };
	        Shared.prototype.setStorageType = function (type) {
	            this.SatellizerConfig.storageType = type;
	        };
	        Shared.$inject = ['$q', '$window', 'SatellizerConfig', 'SatellizerStorage'];
	        return Shared;
	    }());
	
	    var Local = (function () {
	        function Local($http, SatellizerConfig, SatellizerShared) {
	            this.$http = $http;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerShared = SatellizerShared;
	        }
	        Local.prototype.login = function (user, options) {
	            var _this = this;
	            if (options === void 0) { options = {}; }
	            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.loginUrl);
	            options.data = user || options.data;
	            options.method = options.method || 'POST';
	            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(options).then(function (response) {
	                _this.SatellizerShared.setToken(response);
	                return response;
	            });
	        };
	        Local.prototype.signup = function (user, options) {
	            if (options === void 0) { options = {}; }
	            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.signupUrl);
	            options.data = user || options.data;
	            options.method = options.method || 'POST';
	            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(options);
	        };
	        Local.$inject = ['$http', 'SatellizerConfig', 'SatellizerShared'];
	        return Local;
	    }());
	
	    var Popup = (function () {
	        function Popup($interval, $window, $q) {
	            this.$interval = $interval;
	            this.$window = $window;
	            this.$q = $q;
	            this.popup = null;
	            this.defaults = {
	                redirectUri: null
	            };
	        }
	        Popup.prototype.stringifyOptions = function (options) {
	            var parts = [];
	            angular.forEach(options, function (value, key) {
	                parts.push(key + '=' + value);
	            });
	            return parts.join(',');
	        };
	        Popup.prototype.open = function (url, name, popupOptions, redirectUri, dontPoll) {
	            var width = popupOptions.width || 500;
	            var height = popupOptions.height || 500;
	            var options = this.stringifyOptions({
	                width: width,
	                height: height,
	                top: this.$window.screenY + ((this.$window.outerHeight - height) / 2.5),
	                left: this.$window.screenX + ((this.$window.outerWidth - width) / 2)
	            });
	            var popupName = this.$window['cordova'] || this.$window.navigator.userAgent.indexOf('CriOS') > -1 ? '_blank' : name;
	            this.popup = this.$window.open(url, popupName, options);
	            if (this.popup && this.popup.focus) {
	                this.popup.focus();
	            }
	            if (dontPoll) {
	                return;
	            }
	            if (this.$window['cordova']) {
	                return this.eventListener(redirectUri);
	            }
	            else {
	                if (url === 'about:blank') {
	                    this.popup.location = url;
	                }
	                return this.polling(redirectUri);
	            }
	        };
	        Popup.prototype.polling = function (redirectUri) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                var redirectUriParser = document.createElement('a');
	                redirectUriParser.href = redirectUri;
	                var redirectUriPath = getFullUrlPath(redirectUriParser);
	                var polling = _this.$interval(function () {
	                    if (!_this.popup || _this.popup.closed || _this.popup.closed === undefined) {
	                        _this.$interval.cancel(polling);
	                        reject(new Error('The popup window was closed'));
	                    }
	                    try {
	                        var popupWindowPath = getFullUrlPath(_this.popup.location);
	                        if (popupWindowPath === redirectUriPath) {
	                            if (_this.popup.location.search || _this.popup.location.hash) {
	                                var query = parseQueryString(_this.popup.location.search.substring(1).replace(/\/$/, ''));
	                                var hash = parseQueryString(_this.popup.location.hash.substring(1).replace(/[\/$]/, ''));
	                                var params = angular.extend({}, query, hash);
	                                if (params.error) {
	                                    reject(new Error(params.error));
	                                }
	                                else {
	                                    resolve(params);
	                                }
	                            }
	                            else {
	                                reject(new Error('OAuth redirect has occurred but no query or hash parameters were found. ' +
	                                    'They were either not set during the redirect, or were removed—typically by a ' +
	                                    'routing library—before Satellizer could read it.'));
	                            }
	                            _this.$interval.cancel(polling);
	                            _this.popup.close();
	                        }
	                    }
	                    catch (error) {
	                    }
	                }, 500);
	            });
	        };
	        Popup.prototype.eventListener = function (redirectUri) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                _this.popup.addEventListener('loadstart', function (event) {
	                    if (event.url.indexOf(redirectUri) !== 0) {
	                        return;
	                    }
	                    var parser = document.createElement('a');
	                    parser.href = event.url;
	                    if (parser.search || parser.hash) {
	                        var query = parseQueryString(parser.search.substring(1).replace(/\/$/, ''));
	                        var hash = parseQueryString(parser.hash.substring(1).replace(/[\/$]/, ''));
	                        var params = angular.extend({}, query, hash);
	                        if (params.error) {
	                            reject(new Error(params.error));
	                        }
	                        else {
	                            resolve(params);
	                        }
	                        _this.popup.close();
	                    }
	                });
	                _this.popup.addEventListener('loaderror', function () {
	                    reject(new Error('Authorization failed'));
	                });
	                _this.popup.addEventListener('exit', function () {
	                    reject(new Error('The popup window was closed'));
	                });
	            });
	        };
	        Popup.$inject = ['$interval', '$window', '$q'];
	        return Popup;
	    }());
	
	    var OAuth1 = (function () {
	        function OAuth1($http, $window, SatellizerConfig, SatellizerPopup) {
	            this.$http = $http;
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.defaults = {
	                name: null,
	                url: null,
	                authorizationEndpoint: null,
	                scope: null,
	                scopePrefix: null,
	                scopeDelimiter: null,
	                redirectUri: null,
	                requiredUrlParams: null,
	                defaultUrlParams: null,
	                oauthType: '1.0',
	                popupOptions: { width: null, height: null }
	            };
	        }
	        ;
	        OAuth1.prototype.init = function (options, userData) {
	            var _this = this;
	            angular.extend(this.defaults, options);
	            var name = options.name, popupOptions = options.popupOptions;
	            var redirectUri = this.defaults.redirectUri;
	            // Should open an empty popup and wait until request token is received
	            if (!this.$window['cordova']) {
	                this.SatellizerPopup.open('about:blank', name, popupOptions, redirectUri, true);
	            }
	            return this.getRequestToken().then(function (response) {
	                return _this.openPopup(options, response).then(function (popupResponse) {
	                    return _this.exchangeForToken(popupResponse, userData);
	                });
	            });
	        };
	        OAuth1.prototype.openPopup = function (options, response) {
	            var url = [options.authorizationEndpoint, this.buildQueryString(response.data)].join('?');
	            var redirectUri = this.defaults.redirectUri;
	            if (this.$window['cordova']) {
	                return this.SatellizerPopup.open(url, options.name, options.popupOptions, redirectUri);
	            }
	            else {
	                this.SatellizerPopup.popup.location = url;
	                return this.SatellizerPopup.polling(redirectUri);
	            }
	        };
	        OAuth1.prototype.getRequestToken = function () {
	            var url = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
	            return this.$http.post(url, this.defaults);
	        };
	        OAuth1.prototype.exchangeForToken = function (oauthData, userData) {
	            var payload = angular.extend({}, userData, oauthData);
	            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
	            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
	        };
	        OAuth1.prototype.buildQueryString = function (obj) {
	            var str = [];
	            angular.forEach(obj, function (value, key) {
	                str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	            });
	            return str.join('&');
	        };
	        OAuth1.$inject = ['$http', '$window', 'SatellizerConfig', 'SatellizerPopup'];
	        return OAuth1;
	    }());
	
	    var OAuth2 = (function () {
	        function OAuth2($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage) {
	            this.$http = $http;
	            this.$window = $window;
	            this.$timeout = $timeout;
	            this.$q = $q;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.SatellizerStorage = SatellizerStorage;
	            this.defaults = {
	                name: null,
	                url: null,
	                clientId: null,
	                authorizationEndpoint: null,
	                redirectUri: null,
	                scope: null,
	                scopePrefix: null,
	                scopeDelimiter: null,
	                state: null,
	                requiredUrlParams: null,
	                defaultUrlParams: ['response_type', 'client_id', 'redirect_uri'],
	                responseType: 'code',
	                responseParams: {
	                    code: 'code',
	                    clientId: 'clientId',
	                    redirectUri: 'redirectUri'
	                },
	                oauthType: '2.0',
	                popupOptions: { width: null, height: null }
	            };
	        }
	        OAuth2.camelCase = function (name) {
	            return name.replace(/([\:\-\_]+(.))/g, function (_, separator, letter, offset) {
	                return offset ? letter.toUpperCase() : letter;
	            });
	        };
	        OAuth2.prototype.init = function (options, userData) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                angular.extend(_this.defaults, options);
	                var stateName = _this.defaults.name + '_state';
	                var _a = _this.defaults, name = _a.name, state = _a.state, popupOptions = _a.popupOptions, redirectUri = _a.redirectUri, responseType = _a.responseType;
	                if (typeof state === 'function') {
	                    _this.SatellizerStorage.set(stateName, state());
	                }
	                else if (typeof state === 'string') {
	                    _this.SatellizerStorage.set(stateName, state);
	                }
	                var url = [_this.defaults.authorizationEndpoint, _this.buildQueryString()].join('?');
	                _this.SatellizerPopup.open(url, name, popupOptions, redirectUri).then(function (oauth) {
	                    if (responseType === 'token' || !url) {
	                        return resolve(oauth);
	                    }
	                    if (oauth.state && oauth.state !== _this.SatellizerStorage.get(stateName)) {
	                        return reject(new Error('The value returned in the state parameter does not match the state value from your original ' +
	                            'authorization code request.'));
	                    }
	                    resolve(_this.exchangeForToken(oauth, userData));
	                }).catch(function (error) { return reject(error); });
	            });
	        };
	        OAuth2.prototype.exchangeForToken = function (oauthData, userData) {
	            var _this = this;
	            var payload = angular.extend({}, userData);
	            angular.forEach(this.defaults.responseParams, function (value, key) {
	                switch (key) {
	                    case 'code':
	                        payload[value] = oauthData.code;
	                        break;
	                    case 'clientId':
	                        payload[value] = _this.defaults.clientId;
	                        break;
	                    case 'redirectUri':
	                        payload[value] = _this.defaults.redirectUri;
	                        break;
	                    default:
	                        payload[value] = oauthData[key];
	                }
	            });
	            if (oauthData.state) {
	                payload.state = oauthData.state;
	            }
	            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ?
	                joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) :
	                this.defaults.url;
	            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
	        };
	        OAuth2.prototype.buildQueryString = function () {
	            var _this = this;
	            var keyValuePairs = [];
	            var urlParamsCategories = ['defaultUrlParams', 'requiredUrlParams', 'optionalUrlParams'];
	            angular.forEach(urlParamsCategories, function (paramsCategory) {
	                angular.forEach(_this.defaults[paramsCategory], function (paramName) {
	                    var camelizedName = OAuth2.camelCase(paramName);
	                    var paramValue = angular.isFunction(_this.defaults[paramName]) ? _this.defaults[paramName]() : _this.defaults[camelizedName];
	                    if (paramName === 'redirect_uri' && !paramValue) {
	                        return;
	                    }
	                    if (paramName === 'state') {
	                        var stateName = _this.defaults.name + '_state';
	                        paramValue = encodeURIComponent(_this.SatellizerStorage.get(stateName));
	                    }
	                    if (paramName === 'scope' && Array.isArray(paramValue)) {
	                        paramValue = paramValue.join(_this.defaults.scopeDelimiter);
	                        if (_this.defaults.scopePrefix) {
	                            paramValue = [_this.defaults.scopePrefix, paramValue].join(_this.defaults.scopeDelimiter);
	                        }
	                    }
	                    keyValuePairs.push([paramName, paramValue]);
	                });
	            });
	            return keyValuePairs.map(function (pair) { return pair.join('='); }).join('&');
	        };
	        OAuth2.$inject = ['$http', '$window', '$timeout', '$q', 'SatellizerConfig', 'SatellizerPopup', 'SatellizerStorage'];
	        return OAuth2;
	    }());
	
	    var OAuth = (function () {
	        function OAuth($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage, SatellizerShared, SatellizerOAuth1, SatellizerOAuth2) {
	            this.$http = $http;
	            this.$window = $window;
	            this.$timeout = $timeout;
	            this.$q = $q;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.SatellizerStorage = SatellizerStorage;
	            this.SatellizerShared = SatellizerShared;
	            this.SatellizerOAuth1 = SatellizerOAuth1;
	            this.SatellizerOAuth2 = SatellizerOAuth2;
	        }
	        OAuth.prototype.authenticate = function (name, userData) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                var provider = _this.SatellizerConfig.providers[name];
	                var oauth = null;
	                switch (provider.oauthType) {
	                    case '1.0':
	                        oauth = new OAuth1(_this.$http, _this.$window, _this.SatellizerConfig, _this.SatellizerPopup);
	                        break;
	                    case '2.0':
	                        oauth = new OAuth2(_this.$http, _this.$window, _this.$timeout, _this.$q, _this.SatellizerConfig, _this.SatellizerPopup, _this.SatellizerStorage);
	                        break;
	                    default:
	                        return reject(new Error('Invalid OAuth Type'));
	                }
	                return oauth.init(provider, userData).then(function (response) {
	                    if (provider.url) {
	                        _this.SatellizerShared.setToken(response);
	                    }
	                    resolve(response);
	                }).catch(function (error) {
	                    reject(error);
	                });
	            });
	        };
	        OAuth.prototype.unlink = function (provider, httpOptions) {
	            if (httpOptions === void 0) { httpOptions = {}; }
	            httpOptions.url = httpOptions.url ? httpOptions.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.unlinkUrl);
	            httpOptions.data = { provider: provider } || httpOptions.data;
	            httpOptions.method = httpOptions.method || 'POST';
	            httpOptions.withCredentials = httpOptions.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(httpOptions);
	        };
	        OAuth.$inject = [
	            '$http',
	            '$window',
	            '$timeout',
	            '$q',
	            'SatellizerConfig',
	            'SatellizerPopup',
	            'SatellizerStorage',
	            'SatellizerShared',
	            'SatellizerOAuth1',
	            'SatellizerOAuth2'
	        ];
	        return OAuth;
	    }());
	
	    var Storage = (function () {
	        function Storage($window, SatellizerConfig) {
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.memoryStore = {};
	        }
	        Storage.prototype.get = function (key) {
	            try {
	                return this.$window[this.SatellizerConfig.storageType].getItem(key);
	            }
	            catch (e) {
	                return this.memoryStore[key];
	            }
	        };
	        Storage.prototype.set = function (key, value) {
	            try {
	                this.$window[this.SatellizerConfig.storageType].setItem(key, value);
	            }
	            catch (e) {
	                this.memoryStore[key] = value;
	            }
	        };
	        Storage.prototype.remove = function (key) {
	            try {
	                this.$window[this.SatellizerConfig.storageType].removeItem(key);
	            }
	            catch (e) {
	                delete this.memoryStore[key];
	            }
	        };
	        Storage.$inject = ['$window', 'SatellizerConfig'];
	        return Storage;
	    }());
	
	    var Interceptor = (function () {
	        function Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage) {
	            var _this = this;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerShared = SatellizerShared;
	            this.SatellizerStorage = SatellizerStorage;
	            this.request = function (config) {
	                if (config['skipAuthorization']) {
	                    return config;
	                }
	                if (_this.SatellizerShared.isAuthenticated() && _this.SatellizerConfig.httpInterceptor()) {
	                    var tokenName = _this.SatellizerConfig.tokenPrefix ?
	                        [_this.SatellizerConfig.tokenPrefix, _this.SatellizerConfig.tokenName].join('_') : _this.SatellizerConfig.tokenName;
	                    var token = _this.SatellizerStorage.get(tokenName);
	                    if (_this.SatellizerConfig.tokenHeader && _this.SatellizerConfig.tokenType) {
	                        token = _this.SatellizerConfig.tokenType + ' ' + token;
	                    }
	                    config.headers[_this.SatellizerConfig.tokenHeader] = token;
	                }
	                return config;
	            };
	        }
	        Interceptor.Factory = function (SatellizerConfig, SatellizerShared, SatellizerStorage) {
	            return new Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage);
	        };
	        Interceptor.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];
	        return Interceptor;
	    }());
	    Interceptor.Factory.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];
	
	    var HttpProviderConfig = (function () {
	        function HttpProviderConfig($httpProvider) {
	            this.$httpProvider = $httpProvider;
	            $httpProvider.interceptors.push(Interceptor.Factory);
	        }
	        HttpProviderConfig.$inject = ['$httpProvider'];
	        return HttpProviderConfig;
	    }());
	
	    angular.module('satellizer', [])
	        .provider('$auth', ['SatellizerConfig', function (SatellizerConfig) { return new AuthProvider(SatellizerConfig); }])
	        .constant('SatellizerConfig', Config.getConstant)
	        .service('SatellizerShared', Shared)
	        .service('SatellizerLocal', Local)
	        .service('SatellizerPopup', Popup)
	        .service('SatellizerOAuth', OAuth)
	        .service('SatellizerOAuth2', OAuth2)
	        .service('SatellizerOAuth1', OAuth1)
	        .service('SatellizerStorage', Storage)
	        .service('SatellizerInterceptor', Interceptor)
	        .config(['$httpProvider', function ($httpProvider) { return new HttpProviderConfig($httpProvider); }]);
	    var ng1 = 'satellizer';
	
	    return ng1;
	
	}));
	//# sourceMappingURL=satellizer.js.map


/***/ }),
/* 835 */,
/* 836 */,
/* 837 */
/***/ (function(module, exports) {

	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.19.8 - 2017-04-18T05:43:43.673Z
	 * License: MIT
	 */
	
	
	(function () { 
	"use strict";
	var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
	    },
	
	    isControl: function (e) {
	        var k = e.which;
	        switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	            return true;
	        }
	
	        if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	        return false;
	    },
	    isFunctionKey: function (k) {
	        k = k.which ? k.which : k;
	        return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function (k){
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function (k){
	      return ~[KEY.LEFT,KEY.RIGHT,KEY.BACKSPACE,KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function (k) {
	      var sep = {ENTER:"\n",TAB:"\t",SPACE:" "}[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	function isNil(value) {
	  return angular.isUndefined(value) || value === null;
	}
	
	/**
	 * Add querySelectorAll() to jqLite.
	 *
	 * jqLite find() is limited to lookups by tag name.
	 * TODO This will change with future versions of AngularJS, to be removed when this happens
	 *
	 * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	 * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	 */
	if (angular.element.prototype.querySelectorAll === undefined) {
	  angular.element.prototype.querySelectorAll = function(selector) {
	    return angular.element(this[0].querySelectorAll(selector));
	  };
	}
	
	/**
	 * Add closest() to jqLite.
	 */
	if (angular.element.prototype.closest === undefined) {
	  angular.element.prototype.closest = function( selector) {
	    var elem = this[0];
	    var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	    while (elem) {
	      if (matchesSelector.bind(elem)(selector)) {
	        return elem;
	      } else {
	        elem = elem.parentElement;
	      }
	    }
	    return false;
	  };
	}
	
	var latestId = 0;
	
	var uis = angular.module('ui.select', [])
	
	.constant('uiSelectConfig', {
	  theme: 'bootstrap',
	  searchEnabled: true,
	  sortable: false,
	  placeholder: '', // Empty by default, like HTML tag <select>
	  refreshDelay: 1000, // In milliseconds
	  closeOnSelect: true,
	  skipFocusser: false,
	  dropdownPosition: 'auto',
	  removeSelected: true,
	  resetSearchInput: true,
	  generateId: function() {
	    return latestId++;
	  },
	  appendToBody: false,
	  spinnerEnabled: false,
	  spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
	  backspaceReset: true
	})
	
	// See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	.service('uiSelectMinErr', function() {
	  var minErr = angular.$$minErr('ui.select');
	  return function() {
	    var error = minErr.apply(this, arguments);
	    var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	    return new Error(message);
	  };
	})
	
	// Recreates old behavior of ng-transclude. Used internally.
	.directive('uisTranscludeAppend', function () {
	  return {
	    link: function (scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	})
	
	/**
	 * Highlights text that matches $select.search.
	 *
	 * Taken from AngularUI Bootstrap Typeahead
	 * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	 */
	.filter('highlight', function() {
	  function escapeRegexp(queryToEscape) {
	    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  }
	
	  return function(matchItem, query) {
	    return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	  };
	})
	
	/**
	 * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	 *
	 * Taken from AngularUI Bootstrap Position:
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	 */
	.factory('uisOffset',
	  ['$document', '$window',
	  function ($document, $window) {
	
	  return function(element) {
	    var boundingClientRect = element[0].getBoundingClientRect();
	    return {
	      width: boundingClientRect.width || element.prop('offsetWidth'),
	      height: boundingClientRect.height || element.prop('offsetHeight'),
	      top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	      left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	    };
	  };
	}]);
	
	uis.directive('uiSelectChoices',
	  ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
	  function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-choices');
	
	      // Gets theme attribute from parent (ui-select)
	      var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	      return theme + '/choices.tpl.html';
	    },
	
	    compile: function(tElement, tAttrs) {
	
	      if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	      // var repeat = RepeatParser.parse(attrs.repeat);
	      var groupByExp = tAttrs.groupBy;
	      var groupFilterExp = tAttrs.groupFilter;
	
	      if (groupByExp) {
	        var groups = tElement.querySelectorAll('.ui-select-choices-group');
	        if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	        groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	      }
	
	      var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	      var choices = tElement.querySelectorAll('.ui-select-choices-row');
	      if (choices.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
	             .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	
	      var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	      if (rowsInner.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	      }
	      rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	      // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
	      var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	      clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	      return function link(scope, element, attrs, $select) {
	
	
	        $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	        $select.disableChoiceExpression = attrs.uiDisableChoice;
	        $select.onHighlightCallback = attrs.onHighlight;
	        $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
	        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	        scope.$watch('$select.search', function(newValue) {
	          if(newValue && !$select.open && $select.multiple) $select.activate(false, true);
	          $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	          if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	            $select.refresh(attrs.refresh);
	          } else {
	            $select.items = [];
	          }
	        });
	
	        attrs.$observe('refreshDelay', function() {
	          // $eval() is needed otherwise we get a string instead of a number
	          var refreshDelay = scope.$eval(attrs.refreshDelay);
	          $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	        });
	
	        scope.$watch('$select.open', function(open) {
	          if (open) {
	            tElement.attr('role', 'listbox');
	            $select.refresh(attrs.refresh);
	          } else {
	            element.removeAttr('role');
	          }
	        });
	      };
	    }
	  };
	}]);
	
	/**
	 * Contains ui-select "intelligence".
	 *
	 * The goal is to limit dependency on the DOM whenever possible and
	 * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	 */
	uis.controller('uiSelectCtrl',
	  ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
	  function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	  var ctrl = this;
	
	  var EMPTY_SEARCH = '';
	
	  ctrl.placeholder = uiSelectConfig.placeholder;
	  ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	  ctrl.sortable = uiSelectConfig.sortable;
	  ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	  ctrl.paste = uiSelectConfig.paste;
	  ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
	  ctrl.refreshing = false;
	  ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
	  ctrl.spinnerClass = uiSelectConfig.spinnerClass;
	  ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	  ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	  ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	  ctrl.search = EMPTY_SEARCH;
	
	  ctrl.activeIndex = 0; //Dropdown of choices
	  ctrl.items = []; //All available choices
	
	  ctrl.open = false;
	  ctrl.focus = false;
	  ctrl.disabled = false;
	  ctrl.selected = undefined;
	
	  ctrl.dropdownPosition = 'auto';
	
	  ctrl.focusser = undefined; //Reference to input element used to handle focus events
	  ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	  ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	  ctrl.tagging = {isActivated: false, fct: undefined};
	  ctrl.taggingTokens = {isActivated: false, tokens: undefined};
	  ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	  ctrl.clickTriggeredSelect = false;
	  ctrl.$filter = $filter;
	  ctrl.$element = $element;
	
	  // Use $injector to check for $animate and store a reference to it
	  ctrl.$animate = (function () {
	    try {
	      return $injector.get('$animate');
	    } catch (err) {
	      // $animate does not exist
	      return null;
	    }
	  })();
	
	  ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	  if (ctrl.searchInput.length !== 1) {
	    throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	  }
	
	  ctrl.isEmpty = function() {
	    return isNil(ctrl.selected) || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
	  };
	
	  function _findIndex(collection, predicate, thisArg){
	    if (collection.findIndex){
	      return collection.findIndex(predicate, thisArg);
	    } else {
	      var list = Object(collection);
	      var length = list.length >>> 0;
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  }
	
	  // Most of the time the user does not want to empty the search input when in typeahead mode
	  function _resetSearchInput() {
	    if (ctrl.resetSearchInput) {
	      ctrl.search = EMPTY_SEARCH;
	      //reset activeIndex
	      if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	        ctrl.activeIndex = _findIndex(ctrl.items, function(item){
	          return angular.equals(this, item);
	        }, ctrl.selected);
	      }
	    }
	  }
	
	    function _groupsFilter(groups, groupNames) {
	      var i, j, result = [];
	      for(i = 0; i < groupNames.length ;i++){
	        for(j = 0; j < groups.length ;j++){
	          if(groups[j].name == [groupNames[i]]){
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	  // When the user clicks on ui-select, displays the dropdown list
	  ctrl.activate = function(initSearchValue, avoidReset) {
	    if (!ctrl.disabled  && !ctrl.open) {
	      if(!avoidReset) _resetSearchInput();
	
	      $scope.$broadcast('uis:activate');
	      ctrl.open = true;
	      ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	      // ensure that the index is set to zero for tagging variants
	      // that where first option is auto-selected
	      if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
	        ctrl.activeIndex = 0;
	      }
	
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var searchInput = $element.querySelectorAll('.ui-select-search');
	      if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	        var animateHandler = function(elem, phase) {
	          if (phase === 'start' && ctrl.items.length === 0) {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          } else if (phase === 'close') {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('enter', container[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          }
	        };
	
	        if (ctrl.items.length > 0) {
	          ctrl.$animate.on('enter', container[0], animateHandler);
	        } else {
	          ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	        }
	      } else {
	        $timeout(function () {
	          ctrl.focusSearchInput(initSearchValue);
	          if(!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	            _ensureHighlightVisible();
	          }
	        });
	      }
	    }
	    else if (ctrl.open && !ctrl.searchEnabled) {
	      // Close the selection if we don't have search enabled, and we click on the select again
	      ctrl.close();
	    }
	  };
	
	  ctrl.focusSearchInput = function (initSearchValue) {
	    ctrl.search = initSearchValue || ctrl.search;
	    ctrl.searchInput[0].focus();
	  };
	
	  ctrl.findGroupByName = function(name) {
	    return ctrl.groups && ctrl.groups.filter(function(group) {
	      return group.name === name;
	    })[0];
	  };
	
	  ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
	    function updateGroups(items) {
	      var groupFn = $scope.$eval(groupByExp);
	      ctrl.groups = [];
	      angular.forEach(items, function(item) {
	        var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	        var group = ctrl.findGroupByName(groupName);
	        if(group) {
	          group.items.push(item);
	        }
	        else {
	          ctrl.groups.push({name: groupName, items: [item]});
	        }
	      });
	      if(groupFilterExp){
	        var groupFilterFn = $scope.$eval(groupFilterExp);
	        if( angular.isFunction(groupFilterFn)){
	          ctrl.groups = groupFilterFn(ctrl.groups);
	        } else if(angular.isArray(groupFilterFn)){
	          ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	        }
	      }
	      ctrl.items = [];
	      ctrl.groups.forEach(function(group) {
	        ctrl.items = ctrl.items.concat(group.items);
	      });
	    }
	
	    function setPlainItems(items) {
	      ctrl.items = items || [];
	    }
	
	    ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	    ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	    ctrl.isGrouped = !!groupByExp;
	    ctrl.itemProperty = ctrl.parserResult.itemName;
	
	    //If collection is an Object, convert it to Array
	
	    var originalSource = ctrl.parserResult.source;
	
	    //When an object is used as source, we better create an array and use it as 'source'
	    var createArrayFromObject = function(){
	      var origSrc = originalSource($scope);
	      $scope.$uisSource = Object.keys(origSrc).map(function(v){
	        var result = {};
	        result[ctrl.parserResult.keyName] = v;
	        result.value = origSrc[v];
	        return result;
	      });
	    };
	
	    if (ctrl.parserResult.keyName){ // Check for (key,value) syntax
	      createArrayFromObject();
	      ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	      $scope.$watch(originalSource, function(newVal, oldVal){
	        if (newVal !== oldVal) createArrayFromObject();
	      }, true);
	    }
	
	    ctrl.refreshItems = function (data){
	      data = data || ctrl.parserResult.source($scope);
	      var selectedItems = ctrl.selected;
	      //TODO should implement for single mode removeSelected
	      if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.multiple || !ctrl.removeSelected) {
	        ctrl.setItemsFn(data);
	      }else{
	        if ( data !== undefined && data !== null ) {
	          var filteredItems = data.filter(function(i) {
	            return angular.isArray(selectedItems) ? selectedItems.every(function(selectedItem) {
	              return !angular.equals(i, selectedItem);
	            }) : !angular.equals(i, selectedItems);
	          });
	          ctrl.setItemsFn(filteredItems);
	        }
	      }
	      if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up'){
	        $scope.calculateDropdownPos();
	      }
	      $scope.$broadcast('uis:refresh');
	    };
	
	    // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	    $scope.$watchCollection(ctrl.parserResult.source, function(items) {
	      if (items === undefined || items === null) {
	        // If the user specifies undefined or null => reset the collection
	        // Special case: items can be undefined if the user did not initialized the collection on the scope
	        // i.e $scope.addresses = [] is missing
	        ctrl.items = [];
	      } else {
	        if (!angular.isArray(items)) {
	          throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	        } else {
	          //Remove already selected items (ex: while searching)
	          //TODO Should add a test
	          ctrl.refreshItems(items);
	
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ctrl.ngModel.$modelValue)) {
	            ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	        }
	      }
	    });
	
	  };
	
	  var _refreshDelayPromise;
	
	  /**
	   * Typeahead mode: lets the user refresh the collection using his own function.
	   *
	   * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	   */
	  ctrl.refresh = function(refreshAttr) {
	    if (refreshAttr !== undefined) {
	      // Debounce
	      // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	      // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	      if (_refreshDelayPromise) {
	        $timeout.cancel(_refreshDelayPromise);
	      }
	      _refreshDelayPromise = $timeout(function() {
	        if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
	          var refreshPromise = $scope.$eval(refreshAttr);
	          if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
	            ctrl.refreshing = true;
	            refreshPromise.finally(function() {
	              ctrl.refreshing = false;
	            });
	          }
	        }
	      }, ctrl.refreshDelay);
	    }
	  };
	
	  ctrl.isActive = function(itemScope) {
	    if ( !ctrl.open ) {
	      return false;
	    }
	    var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	    var isActive =  itemIndex == ctrl.activeIndex;
	
	    if ( !isActive || itemIndex < 0 ) {
	      return false;
	    }
	
	    if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	      itemScope.$eval(ctrl.onHighlightCallback);
	    }
	
	    return isActive;
	  };
	
	  var _isItemSelected = function (item) {
	    return (ctrl.selected && angular.isArray(ctrl.selected) &&
	        ctrl.selected.filter(function (selection) { return angular.equals(selection, item); }).length > 0);
	  };
	
	  var disabledItems = [];
	
	  function _updateItemDisabled(item, isDisabled) {
	    var disabledItemIndex = disabledItems.indexOf(item);
	    if (isDisabled && disabledItemIndex === -1) {
	      disabledItems.push(item);
	    }
	
	    if (!isDisabled && disabledItemIndex > -1) {
	      disabledItems.splice(disabledItemIndex, 1);
	    }
	  }
	
	  function _isItemDisabled(item) {
	    return disabledItems.indexOf(item) > -1;
	  }
	
	  ctrl.isDisabled = function(itemScope) {
	
	    if (!ctrl.open) return;
	
	    var item = itemScope[ctrl.itemProperty];
	    var itemIndex = ctrl.items.indexOf(item);
	    var isDisabled = false;
	
	    if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	
	      if (item.isTag) return false;
	
	      if (ctrl.multiple) {
	        isDisabled = _isItemSelected(item);
	      }
	
	      if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	        isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression));
	      }
	
	      _updateItemDisabled(item, isDisabled);
	    }
	
	    return isDisabled;
	  };
	
	
	  // When the user selects an item with ENTER or clicks the dropdown
	  ctrl.select = function(item, skipFocusser, $event) {
	    if (isNil(item) || !_isItemDisabled(item)) {
	
	      if ( ! ctrl.items && ! ctrl.search && ! ctrl.tagging.isActivated) return;
	
	      if (!item || !_isItemDisabled(item)) {
	        // if click is made on existing item, prevent from tagging, ctrl.search does not matter
	        ctrl.clickTriggeredSelect = false;
	        if($event && ($event.type === 'click' || $event.type === 'touchend') && item)
	          ctrl.clickTriggeredSelect = true;
	
	        if(ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
	          // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	          if ( ctrl.taggingLabel === false ) {
	            if ( ctrl.activeIndex < 0 ) {
	              if (item === undefined) {
	                item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	              }
	              if (!item || angular.equals( ctrl.items[0], item ) ) {
	                return;
	              }
	            } else {
	              // keyboard nav happened first, user selected from dropdown
	              item = ctrl.items[ctrl.activeIndex];
	            }
	          } else {
	            // tagging always operates at index zero, taggingLabel === false pushes
	            // the ctrl.search value without having it injected
	            if ( ctrl.activeIndex === 0 ) {
	              // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	              // for `item` if it is a detected duplicate
	              if ( item === undefined ) return;
	
	              // create new item on the fly if we don't already have one;
	              // use tagging function if we have one
	              if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
	                item = ctrl.tagging.fct(item);
	                if (!item) return;
	              // if item type is 'string', apply the tagging label
	              } else if ( typeof item === 'string' ) {
	                // trim the trailing space
	                item = item.replace(ctrl.taggingLabel,'').trim();
	              }
	            }
	          }
	          // search ctrl.selected for dupes potentially caused by tagging and return early if found
	          if (_isItemSelected(item)) {
	            ctrl.close(skipFocusser);
	            return;
	          }
	        }
	        _resetSearchInput();
	        $scope.$broadcast('uis:select', item);
	
	        if (ctrl.closeOnSelect) {
	          ctrl.close(skipFocusser);
	        }
	      }
	    }
	  };
	
	  // Closes the dropdown
	  ctrl.close = function(skipFocusser) {
	    if (!ctrl.open) return;
	    if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	    ctrl.open = false;
	    _resetSearchInput();
	    $scope.$broadcast('uis:close', skipFocusser);
	
	  };
	
	  ctrl.setFocus = function(){
	    if (!ctrl.focus) ctrl.focusInput[0].focus();
	  };
	
	  ctrl.clear = function($event) {
	    ctrl.select(null);
	    $event.stopPropagation();
	    $timeout(function() {
	      ctrl.focusser[0].focus();
	    }, 0, false);
	  };
	
	  // Toggle dropdown
	  ctrl.toggle = function(e) {
	    if (ctrl.open) {
	      ctrl.close();
	      e.preventDefault();
	      e.stopPropagation();
	    } else {
	      ctrl.activate();
	    }
	  };
	
	  // Set default function for locked choices - avoids unnecessary
	  // logic if functionality is not being used
	  ctrl.isLocked = function () {
	    return false;
	  };
	
	  $scope.$watch(function () {
	    return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
	  }, _initaliseLockedChoices);
	
	  function _initaliseLockedChoices(doInitalise) {
	    if(!doInitalise) return;
	
	    var lockedItems = [];
	
	    function _updateItemLocked(item, isLocked) {
	      var lockedItemIndex = lockedItems.indexOf(item);
	      if (isLocked && lockedItemIndex === -1) {
	        lockedItems.push(item);
	        }
	
	      if (!isLocked && lockedItemIndex > -1) {
	        lockedItems.splice(lockedItemIndex, 1);
	      }
	    }
	
	    function _isItemlocked(item) {
	      return lockedItems.indexOf(item) > -1;
	    }
	
	    ctrl.isLocked = function (itemScope, itemIndex) {
	      var isLocked = false,
	          item = ctrl.selected[itemIndex];
	
	      if(item) {
	        if (itemScope) {
	          isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression));
	          _updateItemLocked(item, isLocked);
	        } else {
	          isLocked = _isItemlocked(item);
	        }
	      }
	
	      return isLocked;
	    };
	  }
	
	
	  var sizeWatch = null;
	  var updaterScheduled = false;
	  ctrl.sizeSearchInput = function() {
	
	    var input = ctrl.searchInput[0],
	        container = ctrl.$element[0],
	        calculateContainerWidth = function() {
	          // Return the container width only if the search input is visible
	          return container.clientWidth * !!input.offsetParent;
	        },
	        updateIfVisible = function(containerWidth) {
	          if (containerWidth === 0) {
	            return false;
	          }
	          var inputWidth = containerWidth - input.offsetLeft;
	          if (inputWidth < 50) inputWidth = containerWidth;
	          ctrl.searchInput.css('width', inputWidth+'px');
	          return true;
	        };
	
	    ctrl.searchInput.css('width', '10px');
	    $timeout(function() { //Give tags time to render correctly
	      if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	        sizeWatch = $scope.$watch(function() {
	          if (!updaterScheduled) {
	            updaterScheduled = true;
	            $scope.$$postDigest(function() {
	              updaterScheduled = false;
	              if (updateIfVisible(calculateContainerWidth())) {
	                sizeWatch();
	                sizeWatch = null;
	              }
	            });
	          }
	        }, angular.noop);
	      }
	    });
	  };
	
	  function _handleDropDownSelection(key) {
	    var processed = true;
	    switch (key) {
	      case KEY.DOWN:
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex < ctrl.items.length - 1) {
	          var idx = ++ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
	            ctrl.activeIndex = ++idx;
	          }
	        }
	        break;
	      case KEY.UP:
	        var minActiveIndex = (ctrl.search.length === 0 && ctrl.tagging.isActivated) ? -1 : 0;
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex > minActiveIndex) {
	          var idxmin = --ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
	            ctrl.activeIndex = --idxmin;
	          }
	        }
	        break;
	      case KEY.TAB:
	        if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	        break;
	      case KEY.ENTER:
	        if(ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)){
	          ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	        } else {
	          ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        }
	        break;
	      case KEY.ESC:
	        ctrl.close();
	        break;
	      default:
	        processed = false;
	    }
	    return processed;
	  }
	
	  // Bind to keyboard shortcuts
	  ctrl.searchInput.on('keydown', function(e) {
	
	    var key = e.which;
	
	    if (~[KEY.ENTER,KEY.ESC].indexOf(key)){
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	    $scope.$apply(function() {
	
	      var tagged = false;
	
	      if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	        if(!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
	          e.preventDefault();
	          e.stopPropagation();
	        }
	        if ( ctrl.taggingTokens.isActivated ) {
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
	              // make sure there is a new value to push via tagging
	              if ( ctrl.search.length > 0 ) {
	                tagged = true;
	              }
	            }
	          }
	          if ( tagged ) {
	            $timeout(function() {
	              ctrl.searchInput.triggerHandler('tagged');
	              var newItem = ctrl.search.replace(KEY.MAP[e.keyCode],'').trim();
	              if ( ctrl.tagging.fct ) {
	                newItem = ctrl.tagging.fct( newItem );
	              }
	              if (newItem) ctrl.select(newItem, true);
	            });
	          }
	        }
	      }
	
	    });
	
	    if(KEY.isVerticalMovement(key) && ctrl.items.length > 0){
	      _ensureHighlightVisible();
	    }
	
	    if (key === KEY.ENTER || key === KEY.ESC) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	  });
	
	  ctrl.searchInput.on('paste', function (e) {
	    var data;
	
	    if (window.clipboardData && window.clipboardData.getData) { // IE
	      data = window.clipboardData.getData('Text');
	    } else {
	      data = (e.originalEvent || e).clipboardData.getData('text/plain');
	    }
	
	    // Prepend the current input field text to the paste buffer.
	    data = ctrl.search + data;
	
	    if (data && data.length > 0) {
	      // If tagging try to split by tokens and add items
	      if (ctrl.taggingTokens.isActivated) {
	        var items = [];
	        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {  // split by first token that is contained in data
	          var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	          if (data.indexOf(separator) > -1) {
	            items = data.split(separator);
	            break;  // only split by one token
	          }
	        }
	        if (items.length === 0) {
	          items = [data];
	        }
	        var oldsearch = ctrl.search;
	        angular.forEach(items, function (item) {
	          var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	          if (newItem) {
	            ctrl.select(newItem, true);
	          }
	        });
	        ctrl.search = oldsearch || EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      } else if (ctrl.paste) {
	        ctrl.paste(data);
	        ctrl.search = EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    }
	  });
	
	  ctrl.searchInput.on('tagged', function() {
	    $timeout(function() {
	      _resetSearchInput();
	    });
	  });
	
	  // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	  function _ensureHighlightVisible() {
	    var container = $element.querySelectorAll('.ui-select-choices-content');
	    var choices = container.querySelectorAll('.ui-select-choices-row');
	    if (choices.length < 1) {
	      throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	    }
	
	    if (ctrl.activeIndex < 0) {
	      return;
	    }
	
	    var highlighted = choices[ctrl.activeIndex];
	    var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	    var height = container[0].offsetHeight;
	
	    if (posY > height) {
	      container[0].scrollTop += posY - height;
	    } else if (posY < highlighted.clientHeight) {
	      if (ctrl.isGrouped && ctrl.activeIndex === 0)
	        container[0].scrollTop = 0; //To make group header visible when going all the way up
	      else
	        container[0].scrollTop -= highlighted.clientHeight - posY;
	    }
	  }
	
	  var onResize = $$uisDebounce(function() {
	    ctrl.sizeSearchInput();
	  }, 50);
	
	  angular.element($window).bind('resize', onResize);
	
	  $scope.$on('$destroy', function() {
	    ctrl.searchInput.off('keyup keydown tagged blur paste');
	    angular.element($window).off('resize', onResize);
	  });
	
	  $scope.$watch('$select.activeIndex', function(activeIndex) {
	    if (activeIndex)
	      $element.find('input').attr(
	        'aria-activedescendant',
	        'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
	  });
	
	  $scope.$watch('$select.open', function(open) {
	    if (!open)
	      $element.find('input').removeAttr('aria-activedescendant');
	  });
	}]);
	
	uis.directive('uiSelect',
	  ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
	  function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	  return {
	    restrict: 'EA',
	    templateUrl: function(tElement, tAttrs) {
	      var theme = tAttrs.theme || uiSelectConfig.theme;
	      return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	    },
	    replace: true,
	    transclude: true,
	    require: ['uiSelect', '^ngModel'],
	    scope: true,
	
	    controller: 'uiSelectCtrl',
	    controllerAs: '$select',
	    compile: function(tElement, tAttrs) {
	
	      // Allow setting ngClass on uiSelect
	      var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	      if(match) {
	        var combined = '{'+ match[1] +', '+ match[2] +'}';
	        tAttrs.ngClass = combined;
	        tElement.attr('ng-class', combined);
	      }
	
	      //Multiple or Single depending if multiple attribute presence
	      if (angular.isDefined(tAttrs.multiple))
	        tElement.append('<ui-select-multiple/>').removeAttr('multiple');
	      else
	        tElement.append('<ui-select-single/>');
	
	      if (tAttrs.inputId)
	        tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	      return function(scope, element, attrs, ctrls, transcludeFn) {
	
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        $select.generatedId = uiSelectConfig.generateId();
	        $select.baseTitle = attrs.title || 'Select box';
	        $select.focusserTitle = $select.baseTitle + ' focus';
	        $select.focusserId = 'focusser-' + $select.generatedId;
	
	        $select.closeOnSelect = function() {
	          if (angular.isDefined(attrs.closeOnSelect)) {
	            return $parse(attrs.closeOnSelect)();
	          } else {
	            return uiSelectConfig.closeOnSelect;
	          }
	        }();
	
	        scope.$watch('skipFocusser', function() {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	        });
	
	        $select.onSelectCallback = $parse(attrs.onSelect);
	        $select.onRemoveCallback = $parse(attrs.onRemove);
	
	        //Set reference to ngModel from uiSelectCtrl
	        $select.ngModel = ngModel;
	
	        $select.choiceGrouped = function(group){
	          return $select.isGrouped && group && group.name;
	        };
	
	        if(attrs.tabindex){
	          attrs.$observe('tabindex', function(value) {
	            $select.focusInput.attr('tabindex', value);
	            element.removeAttr('tabindex');
	          });
	        }
	
	        scope.$watch(function () { return scope.$eval(attrs.searchEnabled); }, function(newVal) {
	          $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	        });
	
	        scope.$watch('sortable', function() {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	        });
	
	        attrs.$observe('backspaceReset', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var backspaceReset = scope.$eval(attrs.backspaceReset);
	          $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
	        });
	
	        attrs.$observe('limit', function() {
	          //Limit the number of selections allowed
	          $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
	        });
	
	        scope.$watch('removeSelected', function() {
	            var removeSelected = scope.$eval(attrs.removeSelected);
	            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	        });
	
	        attrs.$observe('disabled', function() {
	          // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	          $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	        });
	
	        attrs.$observe('resetSearchInput', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	          $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	        });
	
	        attrs.$observe('paste', function() {
	          $select.paste = scope.$eval(attrs.paste);
	        });
	
	        attrs.$observe('tagging', function() {
	          if(attrs.tagging !== undefined)
	          {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var taggingEval = scope.$eval(attrs.tagging);
	            $select.tagging = {isActivated: true, fct: taggingEval !== true ? taggingEval : undefined};
	          }
	          else
	          {
	            $select.tagging = {isActivated: false, fct: undefined};
	          }
	        });
	
	        attrs.$observe('taggingLabel', function() {
	          if(attrs.tagging !== undefined )
	          {
	            // check eval for FALSE, in this case, we disable the labels
	            // associated with tagging
	            if ( attrs.taggingLabel === 'false' ) {
	              $select.taggingLabel = false;
	            }
	            else
	            {
	              $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	            }
	          }
	        });
	
	        attrs.$observe('taggingTokens', function() {
	          if (attrs.tagging !== undefined) {
	            var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',','ENTER'];
	            $select.taggingTokens = {isActivated: true, tokens: tokens };
	          }
	        });
	
	        attrs.$observe('spinnerEnabled', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
	          $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
	        });
	
	        attrs.$observe('spinnerClass', function() {
	          var spinnerClass = attrs.spinnerClass;
	          $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
	        });
	
	        //Automatically gets focus when loaded
	        if (angular.isDefined(attrs.autofocus)){
	          $timeout(function(){
	            $select.setFocus();
	          });
	        }
	
	        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	        if (angular.isDefined(attrs.focusOn)){
	          scope.$on(attrs.focusOn, function() {
	              $timeout(function(){
	                $select.setFocus();
	              });
	          });
	        }
	
	        function onDocumentClick(e) {
	          if (!$select.open) return; //Skip it if dropdown is close
	
	          var contains = false;
	
	          if (window.jQuery) {
	            // Firefox 3.6 does not support element.contains()
	            // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	            contains = window.jQuery.contains(element[0], e.target);
	          } else {
	            contains = element[0].contains(e.target);
	          }
	
	          if (!contains && !$select.clickTriggeredSelect) {
	            var skipFocusser;
	            if (!$select.skipFocusser) {
	              //Will lose focus only with certain targets
	              var focusableControls = ['input','button','textarea','select'];
	              var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	              skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	              if (!skipFocusser) skipFocusser =  ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	            } else {
	              skipFocusser = true;
	            }
	            $select.close(skipFocusser);
	            scope.$digest();
	          }
	          $select.clickTriggeredSelect = false;
	        }
	
	        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	        $document.on('click', onDocumentClick);
	
	        scope.$on('$destroy', function() {
	          $document.off('click', onDocumentClick);
	        });
	
	        // Move transcluded elements to their correct position in main template
	        transcludeFn(scope, function(clone) {
	          // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	          // One day jqLite will be replaced by jQuery and we will be able to write:
	          // var transcludedElement = clone.filter('.my-class')
	          // instead of creating a hackish DOM element:
	          var transcluded = angular.element('<div>').append(clone);
	
	          var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	          transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	          transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	          if (transcludedMatch.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	          }
	          element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	          var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	          transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	          transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	          if (transcludedChoices.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	          }
	          element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	          var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	          transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	          transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	          if (transcludedNoChoice.length == 1) {
	            element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	          }
	        });
	
	        // Support for appending the select field to the body when its open
	        var appendToBody = scope.$eval(attrs.appendToBody);
	        if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	          scope.$watch('$select.open', function(isOpen) {
	            if (isOpen) {
	              positionDropdown();
	            } else {
	              resetDropdown();
	            }
	          });
	
	          // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	          // it might stick around when the user routes away or the select field is otherwise removed
	          scope.$on('$destroy', function() {
	            resetDropdown();
	          });
	        }
	
	        // Hold on to a reference to the .ui-select-container element for appendToBody support
	        var placeholder = null,
	            originalWidth = '';
	
	        function positionDropdown() {
	          // Remember the absolute position of the element
	          var offset = uisOffset(element);
	
	          // Clone the element into a placeholder element to take its original place in the DOM
	          placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	          placeholder[0].style.width = offset.width + 'px';
	          placeholder[0].style.height = offset.height + 'px';
	          element.after(placeholder);
	
	          // Remember the original value of the element width inline style, so it can be restored
	          // when the dropdown is closed
	          originalWidth = element[0].style.width;
	
	          // Now move the actual dropdown element to the end of the body
	          $document.find('body').append(element);
	
	          element[0].style.position = 'absolute';
	          element[0].style.left = offset.left + 'px';
	          element[0].style.top = offset.top + 'px';
	          element[0].style.width = offset.width + 'px';
	        }
	
	        function resetDropdown() {
	          if (placeholder === null) {
	            // The dropdown has not actually been display yet, so there's nothing to reset
	            return;
	          }
	
	          // Move the dropdown element back to its original location in the DOM
	          placeholder.replaceWith(element);
	          placeholder = null;
	
	          element[0].style.position = '';
	          element[0].style.left = '';
	          element[0].style.top = '';
	          element[0].style.width = originalWidth;
	
	          // Set focus back on to the moved element
	          $select.setFocus();
	        }
	
	        // Hold on to a reference to the .ui-select-dropdown element for direction support.
	        var dropdown = null,
	            directionUpClassName = 'direction-up';
	
	        // Support changing the direction of the dropdown if there isn't enough space to render it.
	        scope.$watch('$select.open', function() {
	
	          if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up'){
	            scope.calculateDropdownPos();
	          }
	
	        });
	
	        var setDropdownPosUp = function(offset, offsetDropdown){
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = 'absolute';
	          dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
	          element.addClass(directionUpClassName);
	
	        };
	
	        var setDropdownPosDown = function(offset, offsetDropdown){
	
	          element.removeClass(directionUpClassName);
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = '';
	          dropdown[0].style.top = '';
	
	        };
	
	        var calculateDropdownPosAfterAnimation = function() {
	          // Delay positioning the dropdown until all choices have been added so its height is correct.
	          $timeout(function() {
	            if ($select.dropdownPosition === 'up') {
	              //Go UP
	              setDropdownPosUp();
	            } else {
	              //AUTO
	              element.removeClass(directionUpClassName);
	
	              var offset = uisOffset(element);
	              var offsetDropdown = uisOffset(dropdown);
	
	              //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	              var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	              // Determine if the direction of the dropdown needs to be changed.
	              if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                //Go UP
	                setDropdownPosUp(offset, offsetDropdown);
	              }else{
	                //Go DOWN
	                setDropdownPosDown(offset, offsetDropdown);
	              }
	            }
	
	            // Display the dropdown once it has been positioned.
	            dropdown[0].style.opacity = 1;
	          });
	        };
	
	        var opened = false;
	        
	        scope.calculateDropdownPos = function() {
	          if ($select.open) {
	            dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	            if (dropdown.length === 0) {
	              return;
	            }
	
	           // Hide the dropdown so there is no flicker until $timeout is done executing.
	           if ($select.search === '' && !opened) {
	              dropdown[0].style.opacity = 0;
	              opened = true;
	           }
	
	            if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	              var needsCalculated = true;
	
	              $select.$animate.on('enter', dropdown, function (elem, phase) {
	                if (phase === 'close' && needsCalculated) {
	                  calculateDropdownPosAfterAnimation();
	                  needsCalculated = false;
	                }
	              });
	            } else {
	              calculateDropdownPosAfterAnimation();
	            }
	          } else {
	            if (dropdown === null || dropdown.length === 0) {
	              return;
	            }
	
	            // Reset the position of the dropdown.
	            dropdown[0].style.opacity = 0;
	            dropdown[0].style.position = '';
	            dropdown[0].style.top = '';
	            element.removeClass(directionUpClassName);
	          }
	        };
	      };
	    }
	  };
	}]);
	
	uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-match');
	
	      var parent = tElement.parent();
	      // Gets theme attribute from parent (ui-select)
	      var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	      var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	      return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');      
	    },
	    link: function(scope, element, attrs, $select) {
	      $select.lockChoiceExpression = attrs.uiLockChoice;
	      attrs.$observe('placeholder', function(placeholder) {
	        $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	      });
	
	      function setAllowClear(allow) {
	        $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
	      }
	
	      attrs.$observe('allowClear', setAllowClear);
	      setAllowClear(attrs.allowClear);
	
	      if($select.multiple){
	        $select.sizeSearchInput();
	      }
	
	    }
	  };
	
	  function getAttribute(elem, attribute) {
	    if (elem[0].hasAttribute(attribute))
	      return elem.attr(attribute);
	
	    if (elem[0].hasAttribute('data-' + attribute))
	      return elem.attr('data-' + attribute);
	
	    if (elem[0].hasAttribute('x-' + attribute))
	      return elem.attr('x-' + attribute);
	  }
	}]);
	
	uis.directive('uiSelectMultiple', ['uiSelectMinErr','$timeout', function(uiSelectMinErr, $timeout) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	
	    controller: ['$scope','$timeout', function($scope, $timeout){
	
	      var ctrl = this,
	          $select = $scope.$select,
	          ngModel;
	
	      if (angular.isUndefined($select.selected))
	        $select.selected = [];
	
	      //Wait for link fn to inject it
	      $scope.$evalAsync(function(){ ngModel = $scope.ngModel; });
	
	      ctrl.activeMatchIndex = -1;
	
	      ctrl.updateModel = function(){
	        ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	        ctrl.refreshComponent();
	      };
	
	      ctrl.refreshComponent = function(){
	        //Remove already selected items
	        //e.g. When user clicks on a selection, the selected array changes and
	        //the dropdown should remove that item
	        if($select.refreshItems){
	          $select.refreshItems();
	        }
	        if($select.sizeSearchInput){
	          $select.sizeSearchInput();
	        }
	      };
	
	      // Remove item from multiple select
	      ctrl.removeChoice = function(index){
	
	        // if the choice is locked, don't remove it
	        if($select.isLocked(null, index)) return false;
	
	        var removedChoice = $select.selected[index];
	
	        var locals = {};
	        locals[$select.parserResult.itemName] = removedChoice;
	
	        $select.selected.splice(index, 1);
	        ctrl.activeMatchIndex = -1;
	        $select.sizeSearchInput();
	
	        // Give some time for scope propagation.
	        $timeout(function(){
	          $select.onRemoveCallback($scope, {
	            $item: removedChoice,
	            $model: $select.parserResult.modelMapper($scope, locals)
	          });
	        });
	
	        ctrl.updateModel();
	
	        return true;
	      };
	
	      ctrl.getPlaceholder = function(){
	        //Refactor single?
	        if($select.selected && $select.selected.length) return;
	        return $select.placeholder;
	      };
	
	
	    }],
	    controllerAs: '$selectMultiple',
	
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = scope.ngModel = ctrls[1];
	      var $selectMultiple = scope.$selectMultiple;
	
	      //$select.selected = raw selected objects (ignoring any property binding)
	
	      $select.multiple = true;
	
	      //Input that will handle focus
	      $select.focusInput = $select.searchInput;
	
	      //Properly check for empty if set to multiple
	      ngModel.$isEmpty = function(value) {
	        return !value || value.length === 0;
	      };
	
	      //From view --> model
	      ngModel.$parsers.unshift(function () {
	        var locals = {},
	            result,
	            resultMultiple = [];
	        for (var j = $select.selected.length - 1; j >= 0; j--) {
	          locals = {};
	          locals[$select.parserResult.itemName] = $select.selected[j];
	          result = $select.parserResult.modelMapper(scope, locals);
	          resultMultiple.unshift(result);
	        }
	        return resultMultiple;
	      });
	
	      // From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (!data) return inputValue;
	        var resultMultiple = [];
	        var checkFnMultiple = function(list, value){
	          if (!list || !list.length) return;
	          for (var p = list.length - 1; p >= 0; p--) {
	            locals[$select.parserResult.itemName] = list[p];
	            result = $select.parserResult.modelMapper(scope, locals);
	            if($select.parserResult.trackByExp){
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if(propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName){
	                  if(matches && matches.length>0 && result[matches[1]] == value[matches[1]]){
	                      resultMultiple.unshift(list[p]);
	                      return true;
	                  }
	                }
	            }
	            if (angular.equals(result,value)){
	              resultMultiple.unshift(list[p]);
	              return true;
	            }
	          }
	          return false;
	        };
	        if (!inputValue) return resultMultiple; //If ngModel was undefined
	        for (var k = inputValue.length - 1; k >= 0; k--) {
	          //Check model array of currently selected items
	          if (!checkFnMultiple($select.selected, inputValue[k])){
	            //Check model array of all items available
	            if (!checkFnMultiple(data, inputValue[k])){
	              //If not found on previous lists, just add it directly to resultMultiple
	              resultMultiple.unshift(inputValue[k]);
	            }
	          }
	        }
	        return resultMultiple;
	      });
	
	      //Watch for external model changes
	      scope.$watchCollection(function(){ return ngModel.$modelValue; }, function(newValue, oldValue) {
	        if (oldValue != newValue){
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ngModel.$modelValue)) {
	            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	          $selectMultiple.refreshComponent();
	        }
	      });
	
	      ngModel.$render = function() {
	        // Make sure that model value is array
	        if(!angular.isArray(ngModel.$viewValue)){
	          // Have tolerance for null or undefined values
	          if (isNil(ngModel.$viewValue)){
	            ngModel.$viewValue = [];
	          } else {
	            throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	          }
	        }
	        $select.selected = ngModel.$viewValue;
	        $selectMultiple.refreshComponent();
	        scope.$evalAsync(); //To force $digest
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        if($select.selected.length >= $select.limit) {
	          return;
	        }
	        $select.selected.push(item);
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function(){
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	        $selectMultiple.updateModel();
	      });
	
	      scope.$on('uis:activate', function () {
	        $selectMultiple.activeMatchIndex = -1;
	      });
	
	      scope.$watch('$select.disabled', function(newValue, oldValue) {
	        // As the search input field may now become visible, it may be necessary to recompute its size
	        if (oldValue && !newValue) $select.sizeSearchInput();
	      });
	
	      $select.searchInput.on('keydown', function(e) {
	        var key = e.which;
	        scope.$apply(function() {
	          var processed = false;
	          // var tagged = false; //Checkme
	          if(KEY.isHorizontalMovement(key)){
	            processed = _handleMatchSelection(key);
	          }
	          if (processed  && key != KEY.TAB) {
	            //TODO Check si el tab selecciona aun correctamente
	            //Crear test
	            e.preventDefault();
	            e.stopPropagation();
	          }
	        });
	      });
	      function _getCaretPosition(el) {
	        if(angular.isNumber(el.selectionStart)) return el.selectionStart;
	        // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	        else return el.value.length;
	      }
	      // Handles selected options in "multiple" mode
	      function _handleMatchSelection(key){
	        var caretPosition = _getCaretPosition($select.searchInput[0]),
	            length = $select.selected.length,
	            // none  = -1,
	            first = 0,
	            last  = length-1,
	            curr  = $selectMultiple.activeMatchIndex,
	            next  = $selectMultiple.activeMatchIndex+1,
	            prev  = $selectMultiple.activeMatchIndex-1,
	            newIndex = curr;
	
	        if(caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;
	
	        $select.close();
	
	        function getNewActiveMatchIndex(){
	          switch(key){
	            case KEY.LEFT:
	              // Select previous/first item
	              if(~$selectMultiple.activeMatchIndex) return prev;
	              // Select last item
	              else return last;
	              break;
	            case KEY.RIGHT:
	              // Open drop-down
	              if(!~$selectMultiple.activeMatchIndex || curr === last){
	                $select.activate();
	                return false;
	              }
	              // Select next/last item
	              else return next;
	              break;
	            case KEY.BACKSPACE:
	              // Remove selected item and select previous/first
	              if(~$selectMultiple.activeMatchIndex){
	                if($selectMultiple.removeChoice(curr)) {
	                  return prev;
	                } else {
	                  return curr;
	                }
	
	              } else {
	                // If nothing yet selected, select last item
	                return last;
	              }
	              break;
	            case KEY.DELETE:
	              // Remove selected item and select next item
	              if(~$selectMultiple.activeMatchIndex){
	                $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                return curr;
	              }
	              else return false;
	          }
	        }
	
	        newIndex = getNewActiveMatchIndex();
	
	        if(!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
	        else $selectMultiple.activeMatchIndex = Math.min(last,Math.max(first,newIndex));
	
	        return true;
	      }
	
	      $select.searchInput.on('keyup', function(e) {
	
	        if ( ! KEY.isVerticalMovement(e.which) ) {
	          scope.$evalAsync( function () {
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          });
	        }
	        // Push a "create new" item into array if there is a search string
	        if ( $select.tagging.isActivated && $select.search.length > 0 ) {
	
	          // return early with these keys
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
	            return;
	          }
	          // always reset the activeIndex to the first item when tagging
	          $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          // taggingLabel === false bypasses all of this
	          if ($select.taggingLabel === false) return;
	
	          var items = angular.copy( $select.items );
	          var stashArr = angular.copy( $select.items );
	          var newItem;
	          var item;
	          var hasTag = false;
	          var dupeIndex = -1;
	          var tagItems;
	          var tagItem;
	
	          // case for object tagging via transform `$select.tagging.fct` function
	          if ( $select.tagging.fct !== undefined) {
	            tagItems = $select.$filter('filter')(items,{'isTag': true});
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	            if ( items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.tagging.fct($select.search);
	            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	            if (
	              stashArr.some(function (origItem) {
	                 return angular.equals(origItem, newItem);
	              }) ||
	              $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })
	            ) {
	              scope.$evalAsync(function () {
	                $select.activeIndex = 0;
	                $select.items = items;
	              });
	              return;
	            }
	            if (newItem) newItem.isTag = true;
	          // handle newItem string and stripping dupes in tagging string context
	          } else {
	            // find any tagging items already in the $select.items array and store them
	            tagItems = $select.$filter('filter')(items,function (item) {
	              return item.match($select.taggingLabel);
	            });
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            item = items[0];
	            // remove existing tag item if found (should only ever be one tag item)
	            if ( item !== undefined && items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.search+' '+$select.taggingLabel;
	            if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
	              return;
	            }
	            // verify the the tag doesn't match the value of an existing item from
	            // the searched data set or the items already selected
	            if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
	              // if there is a tag from prev iteration, strip it / queue the change
	              // and return early
	              if ( hasTag ) {
	                items = stashArr;
	                scope.$evalAsync( function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	              }
	              return;
	            }
	            if ( _findCaseInsensitiveDupe(stashArr) ) {
	              // if there is a tag from prev iteration, strip it
	              if ( hasTag ) {
	                $select.items = stashArr.slice(1,stashArr.length);
	              }
	              return;
	            }
	          }
	          if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
	          // dupe found, shave the first item
	          if ( dupeIndex > -1 ) {
	            items = items.slice(dupeIndex+1,items.length-1);
	          } else {
	            items = [];
	            if (newItem) items.push(newItem);
	            items = items.concat(stashArr);
	          }
	          scope.$evalAsync( function () {
	            $select.activeIndex = 0;
	            $select.items = items;
	
	            if ($select.isGrouped) {
	              // update item references in groups, so that indexOf will work after angular.copy
	              var itemsWithoutTag = newItem ? items.slice(1) : items;
	              $select.setItemsFn(itemsWithoutTag);
	              if (newItem) {
	                // add tag item as a new group
	                $select.items.unshift(newItem);
	                $select.groups.unshift({name: '', items: [newItem], tagging: true});
	              }
	            }
	          });
	        }
	      });
	      function _findCaseInsensitiveDupe(arr) {
	        if ( arr === undefined || $select.search === undefined ) {
	          return false;
	        }
	        var hasDupe = arr.filter( function (origItem) {
	          if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
	            return false;
	          }
	          return origItem.toUpperCase() === $select.search.toUpperCase();
	        }).length > 0;
	
	        return hasDupe;
	      }
	      function _findApproxDupe(haystack, needle) {
	        var dupeIndex = -1;
	        if(angular.isArray(haystack)) {
	          var tempArr = angular.copy(haystack);
	          for (var i = 0; i <tempArr.length; i++) {
	            // handle the simple string version of tagging
	            if ( $select.tagging.fct === undefined ) {
	              // search the array for the match
	              if ( tempArr[i]+' '+$select.taggingLabel === needle ) {
	              dupeIndex = i;
	              }
	            // handle the object tagging implementation
	            } else {
	              var mockObj = tempArr[i];
	              if (angular.isObject(mockObj)) {
	                mockObj.isTag = true;
	              }
	              if ( angular.equals(mockObj, needle) ) {
	                dupeIndex = i;
	              }
	            }
	          }
	        }
	        return dupeIndex;
	      }
	
	      $select.searchInput.on('blur', function() {
	        $timeout(function() {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	      });
	
	    }
	  };
	}]);
	
	uis.directive('uiSelectNoChoice',
	    ['uiSelectConfig', function (uiSelectConfig) {
	        return {
	            restrict: 'EA',
	            require: '^uiSelect',
	            replace: true,
	            transclude: true,
	            templateUrl: function (tElement) {
	                // Needed so the uiSelect can detect the transcluded content
	                tElement.addClass('ui-select-no-choice');
	      
	                // Gets theme attribute from parent (ui-select)
	                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	                return theme + '/no-choice.tpl.html';
	            }
	        };
	    }]);
	
	uis.directive('uiSelectSingle', ['$timeout','$compile', function($timeout, $compile) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = ctrls[1];
	
	      //From view --> model
	      ngModel.$parsers.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var locals = {},
	            result;
	        locals[$select.parserResult.itemName] = inputValue;
	        result = $select.parserResult.modelMapper(scope, locals);
	        return result;
	      });
	
	      //From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (data){
	          var checkFnSingle = function(d){
	            locals[$select.parserResult.itemName] = d;
	            result = $select.parserResult.modelMapper(scope, locals);
	            return result === inputValue;
	          };
	          //If possible pass same object stored in $select.selected
	          if ($select.selected && checkFnSingle($select.selected)) {
	            return $select.selected;
	          }
	          for (var i = data.length - 1; i >= 0; i--) {
	            if (checkFnSingle(data[i])) return data[i];
	          }
	        }
	        return inputValue;
	      });
	
	      //Update viewValue if model change
	      scope.$watch('$select.selected', function(newValue) {
	        if (ngModel.$viewValue !== newValue) {
	          ngModel.$setViewValue(newValue);
	        }
	      });
	
	      ngModel.$render = function() {
	        $select.selected = ngModel.$viewValue;
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        $select.selected = item;
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function() {
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	      });
	
	      scope.$on('uis:close', function (event, skipFocusser) {
	        $timeout(function(){
	          $select.focusser.prop('disabled', false);
	          if (!skipFocusser) $select.focusser[0].focus();
	        },0,false);
	      });
	
	      scope.$on('uis:activate', function () {
	        focusser.prop('disabled', true); //Will reactivate it on .close()
	      });
	
	      //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	      var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	      $compile(focusser)(scope);
	      $select.focusser = focusser;
	
	      //Input that will handle focus
	      $select.focusInput = focusser;
	
	      element.parent().append(focusser);
	      focusser.bind("focus", function(){
	        scope.$evalAsync(function(){
	          $select.focus = true;
	        });
	      });
	      focusser.bind("blur", function(){
	        scope.$evalAsync(function(){
	          $select.focus = false;
	        });
	      });
	      focusser.bind("keydown", function(e){
	
	        if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
	          e.preventDefault();
	          e.stopPropagation();
	          $select.select(undefined);
	          scope.$apply();
	          return;
	        }
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	          return;
	        }
	
	        if (e.which == KEY.DOWN  || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE){
	          e.preventDefault();
	          e.stopPropagation();
	          $select.activate();
	        }
	
	        scope.$digest();
	      });
	
	      focusser.bind("keyup input", function(e){
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	          return;
	        }
	
	        $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	        focusser.val('');
	        scope.$digest();
	
	      });
	
	
	    }
	  };
	}]);
	
	// Make multiple matches sortable
	uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
	  return {
	    require: ['^^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	      if (scope[attrs.uiSelectSort] === null) {
	        throw uiSelectMinErr('sort', 'Expected a list to sort');
	      }
	
	      var $select = ctrls[0];
	      var $ngModel = ctrls[1];
	
	      var options = angular.extend({
	          axis: 'horizontal'
	        },
	        scope.$eval(attrs.uiSelectSortOptions));
	
	      var axis = options.axis;
	      var draggingClassName = 'dragging';
	      var droppingClassName = 'dropping';
	      var droppingBeforeClassName = 'dropping-before';
	      var droppingAfterClassName = 'dropping-after';
	
	      scope.$watch(function(){
	        return $select.sortable;
	      }, function(newValue){
	        if (newValue) {
	          element.attr('draggable', true);
	        } else {
	          element.removeAttr('draggable');
	        }
	      });
	
	      element.on('dragstart', function(event) {
	        element.addClass(draggingClassName);
	
	        (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	      });
	
	      element.on('dragend', function() {
	        removeClass(draggingClassName);
	      });
	
	      var move = function(from, to) {
	        /*jshint validthis: true */
	        this.splice(to, 0, this.splice(from, 1)[0]);
	      };
	
	      var removeClass = function(className) {
	        angular.forEach($select.$element.querySelectorAll('.' + className), function(el){
	          angular.element(el).removeClass(className);
	        });
	      };
	
	      var dragOverHandler = function(event) {
	        event.preventDefault();
	
	        var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	        if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
	          removeClass(droppingAfterClassName);
	          element.addClass(droppingBeforeClassName);
	
	        } else {
	          removeClass(droppingBeforeClassName);
	          element.addClass(droppingAfterClassName);
	        }
	      };
	
	      var dropTimeout;
	
	      var dropHandler = function(event) {
	        event.preventDefault();
	
	        var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	        // prevent event firing multiple times in firefox
	        $timeout.cancel(dropTimeout);
	        dropTimeout = $timeout(function() {
	          _dropHandler(droppedItemIndex);
	        }, 20);
	      };
	
	      var _dropHandler = function(droppedItemIndex) {
	        var theList = scope.$eval(attrs.uiSelectSort);
	        var itemToMove = theList[droppedItemIndex];
	        var newIndex = null;
	
	        if (element.hasClass(droppingBeforeClassName)) {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index - 1;
	          } else {
	            newIndex = scope.$index;
	          }
	        } else {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index;
	          } else {
	            newIndex = scope.$index + 1;
	          }
	        }
	
	        move.apply(theList, [droppedItemIndex, newIndex]);
	
	        $ngModel.$setViewValue(Date.now());
	
	        scope.$apply(function() {
	          scope.$emit('uiSelectSort:change', {
	            array: theList,
	            item: itemToMove,
	            from: droppedItemIndex,
	            to: newIndex
	          });
	        });
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('drop', dropHandler);
	      };
	
	      element.on('dragenter', function() {
	        if (element.hasClass(draggingClassName)) {
	          return;
	        }
	
	        element.addClass(droppingClassName);
	
	        element.on('dragover', dragOverHandler);
	        element.on('drop', dropHandler);
	      });
	
	      element.on('dragleave', function(event) {
	        if (event.target != element) {
	          return;
	        }
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('dragover', dragOverHandler);
	        element.off('drop', dropHandler);
	      });
	    }
	  };
	}]);
	
	/**
	 * Debounces functions
	 *
	 * Taken from UI Bootstrap $$debounce source code
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	 *
	 */
	uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
	  return function(callback, debounceTime) {
	    var timeoutPromise;
	
	    return function() {
	      var self = this;
	      var args = Array.prototype.slice.call(arguments);
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	
	      timeoutPromise = $timeout(function() {
	        callback.apply(self, args);
	      }, debounceTime);
	    };
	  };
	}]);
	
	uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
	  return {
	    restrict: 'A',
	    require: 'uiSelect',
	    link: function (scope, element, attrs, $select) {
	      $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
	
	      scope.$watch('$select.open', function (isOpen, previousState) {
	        if (isOpen !== previousState) {
	          $timeout(function () {
	            $select.onOpenCloseCallback(scope, {
	              isOpen: isOpen
	            });
	          });
	        }
	      });
	    }
	  };
	}]);
	
	/**
	 * Parses "repeat" attribute.
	 *
	 * Taken from AngularJS ngRepeat source code
	 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	 *
	 * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	 * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	 */
	
	uis.service('uisRepeatParser', ['uiSelectMinErr','$parse', function(uiSelectMinErr, $parse) {
	  var self = this;
	
	  /**
	   * Example:
	   * expression = "address in addresses | filter: {street: $select.search} track by $index"
	   * itemName = "address",
	   * source = "addresses | filter: {street: $select.search}",
	   * trackByExp = "$index",
	   */
	  self.parse = function(expression) {
	
	
	    var match;
	    //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	    // If an array is used as collection
	
	    // if (isObjectCollection){
	    // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	    match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	    // 1 Alias
	    // 2 Item
	    // 3 Key on (key,value)
	    // 4 Value on (key,value)
	    // 5 Source expression (including filters)
	    // 6 Track by
	
	    if (!match) {
	      throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	              expression);
	    }
	    
	    var source = match[5], 
	        filters = '';
	
	    // When using (key,value) ui-select requires filters to be extracted, since the object
	    // is converted to an array for $select.items 
	    // (in which case the filters need to be reapplied)
	    if (match[3]) {
	      // Remove any enclosing parenthesis
	      source = match[5].replace(/(^\()|(\)$)/g, '');
	      // match all after | but not after ||
	      var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	      if(filterMatch && filterMatch[1].trim()) {
	        filters = filterMatch[1];
	        source = source.replace(filters, '');
	      }      
	    }
	
	    return {
	      itemName: match[4] || match[2], // (lhs) Left-hand side,
	      keyName: match[3], //for (key, value) syntax
	      source: $parse(source),
	      filters: filters,
	      trackByExp: match[6],
	      modelMapper: $parse(match[1] || match[4] || match[2]),
	      repeatExpression: function (grouped) {
	        var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	        if (this.trackByExp) {
	          expression += ' track by ' + this.trackByExp;
	        }
	        return expression;
	      } 
	    };
	
	  };
	
	  self.getGroupNgRepeatExpression = function() {
	    return '$group in $select.groups track by $group.name';
	  };
	
	}]);
	
	}());
	angular.module("ui.select").run(["$templateCache", function($templateCache) {$templateCache.put("bootstrap/choices.tpl.html","<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
	$templateCache.put("bootstrap/match-multiple.tpl.html","<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	$templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	$templateCache.put("bootstrap/no-choice.tpl.html","<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	$templateCache.put("bootstrap/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("select2/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	$templateCache.put("select2/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	$templateCache.put("select2/match.tpl.html","<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	$templateCache.put("select2/no-choice.tpl.html","<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	$templateCache.put("select2/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
	$templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	$templateCache.put("selectize/match-multiple.tpl.html","<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
	$templateCache.put("selectize/match.tpl.html","<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
	$templateCache.put("selectize/no-choice.tpl.html","<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("selectize/select-multiple.tpl.html","<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("selectize/select.tpl.html","<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");}]);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(837);
	module.exports = 'ui.select';


/***/ }),
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _empresaAnterior = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _empresaAnterior2 = _interopRequireDefault(_empresaAnterior);
	
	var _empresaAnterior3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _empresaAnterior4 = _interopRequireDefault(_empresaAnterior3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmpresaAnteriorComponent = {
	  bindings: {
	    supervision: '<'
	  },
	  controller: _empresaAnterior2.default,
	  template: _empresaAnterior4.default
	};
	
	exports.default = EmpresaAnteriorComponent;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fotosSupervision = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _fotosSupervision2 = _interopRequireDefault(_fotosSupervision);
	
	var _fotosSupervision3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _fotosSupervision4 = _interopRequireDefault(_fotosSupervision3);
	
	__webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FotosSupervisionComponent = {
	  bindings: {
	    supervision: '=',
	    fotos: '<'
	  },
	  controller: _fotosSupervision2.default,
	  template: _fotosSupervision4.default
	};
	
	exports.default = FotosSupervisionComponent;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _planillaProyecto = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _planillaProyecto2 = _interopRequireDefault(_planillaProyecto);
	
	var _planillaProyecto3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _planillaProyecto4 = _interopRequireDefault(_planillaProyecto3);
	
	__webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlanillaProyectoComponent = {
	  bindings: {},
	  controller: _planillaProyecto2.default,
	  template: _planillaProyecto4.default
	};
	
	exports.default = PlanillaProyectoComponent;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _planillaProyecto = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _planillaProyecto2 = _interopRequireDefault(_planillaProyecto);
	
	var _fotosSupervision = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _fotosSupervision2 = _interopRequireDefault(_fotosSupervision);
	
	var _empresaAnterior = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _empresaAnterior2 = _interopRequireDefault(_empresaAnterior);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var planillaProyecto = angular.module('app.planillaProyecto', []).component('planillaProyecto', _planillaProyecto2.default).component('fotosSupervision', _fotosSupervision2.default).component('empresaAnterior', _empresaAnterior2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('planilla-proyecto', {
	        url: '/planilla-proyecto/:idSupervision',
	        component: 'planillaProyecto'
	    });
	}]).name;
	
	exports.default = planillaProyecto;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _asignacionResponsable = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _asignacionResponsable2 = _interopRequireDefault(_asignacionResponsable);
	
	var _asignacionResponsable3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _asignacionResponsable4 = _interopRequireDefault(_asignacionResponsable3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AsignacionResponsable = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _asignacionResponsable2.default,
	  template: _asignacionResponsable4.default
	};
	
	exports.default = AsignacionResponsable;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _autoridadBeneficiaria = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _autoridadBeneficiaria2 = _interopRequireDefault(_autoridadBeneficiaria);
	
	var _autoridadBeneficiaria3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _autoridadBeneficiaria4 = _interopRequireDefault(_autoridadBeneficiaria3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoridadBeneficiariaComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _autoridadBeneficiaria2.default,
	  template: _autoridadBeneficiaria4.default
	};
	
	exports.default = AutoridadBeneficiariaComponent;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _convenio = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _convenio2 = _interopRequireDefault(_convenio);
	
	var _convenio3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _convenio4 = _interopRequireDefault(_convenio3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConvenioComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _convenio2.default,
	  template: _convenio4.default
	};
	
	exports.default = ConvenioComponent;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datosGenerales = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _datosGenerales2 = _interopRequireDefault(_datosGenerales);
	
	var _datosGenerales3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _datosGenerales4 = _interopRequireDefault(_datosGenerales3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosGenerales = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _datosGenerales2.default,
	  template: _datosGenerales4.default
	};
	
	exports.default = DatosGenerales;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _desembolso = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _desembolso2 = _interopRequireDefault(_desembolso);
	
	var _desembolso3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _desembolso4 = _interopRequireDefault(_desembolso3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DesembolsoComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _desembolso2.default,
	  template: _desembolso4.default
	};
	
	exports.default = DesembolsoComponent;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _items3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _items4 = _interopRequireDefault(_items3);
	
	__webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ItemsComponent = {
	  bindings: {
	    proyecto: '=',
	    modulos: '=',
	    modoVista: '<'
	  },
	  controller: _items2.default,
	  template: _items4.default
	};
	
	exports.default = ItemsComponent;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordenProceder = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _ordenProceder2 = _interopRequireDefault(_ordenProceder);
	
	var _ordenProceder3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _ordenProceder4 = _interopRequireDefault(_ordenProceder3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrdenProcederComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _ordenProceder2.default,
	  template: _ordenProceder4.default
	};
	
	exports.default = OrdenProcederComponent;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	__webpack_require__(26);
	module.exports = __webpack_require__(__webpack_module_template_argument_0__);

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// app.d569fecc3ecc16c95411.js